export var cipToUcd = [{
  CIP7: '5909086',
  CIP13: '3400959090867',
  ucdLib: "18 FLT 222MBQ/ML INJ FL",
  UCD7: '9392349',
  UCD13: '3400893923498',
  ucdQtyMultiplicator: 1,
  cipLib: "18 FLT 222MBQ/ML INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5909092',
  CIP13: '3400959090928',
  ucdLib: "68 GA/68GE 1,1GBQ GENER RADIO",
  UCD7: '9392355',
  UCD13: '3400893923559',
  ucdQtyMultiplicator: 1,
  cipLib: "68 GA/68GE 1,1GBQ GENER RADIO BT 1",
  atcCode: ""
}, {
  CIP7: '5537354',
  CIP13: '3400955373544',
  ucdLib: "A 313 50000UI CAPS",
  UCD7: '9000059',
  UCD13: '3400890000598',
  ucdQtyMultiplicator: 60,
  cipLib: "A 313 50000UI CAPS BT 60",
  atcCode: "A11CA01"
}, {
  CIP7: '5909666',
  CIP13: '3400959096661',
  ucdLib: "ACIDE FOLIQUE EEB 5MG/2ML FL",
  UCD7: '9403113',
  UCD13: '3400894031130',
  ucdQtyMultiplicator: 1,
  cipLib: "ACIDE FOLIQUE EEB 5MG/2ML FL BT 1",
  atcCode: "B03BB01"
}, {
  CIP7: '5900665',
  CIP13: '3400959006653',
  ucdLib: "ADAGEN 250U/ML INJ AMP",
  UCD7: '9239493',
  UCD13: '3400892394930',
  ucdQtyMultiplicator: 4,
  cipLib: "ADAGEN 250U/ML INJ AMP BT 4",
  atcCode: "L03AX04"
}, {
  CIP7: '5901630',
  CIP13: '3400959016300',
  ucdLib: "ADALATE 5MG CAPS",
  UCD7: '9294440',
  UCD13: '3400892944401',
  ucdQtyMultiplicator: 100,
  cipLib: "ADALATE 5MG CAPS BT 100",
  atcCode: "C08CA05"
}, {
  CIP7: '5906722',
  CIP13: '3400959067227',
  ucdLib: "AGOMELATINE 5MG SRV CPR",
  UCD7: '9313232',
  UCD13: '3400893132326',
  ucdQtyMultiplicator: 40,
  cipLib: "AGOMELATINE 5MG SRV CPR BT 40",
  atcCode: "N06AX22"
}, {
  CIP7: '5900613',
  CIP13: '3400959006134',
  ucdLib: "AGRELIN 0,5MG GELU",
  UCD7: '9228325',
  UCD13: '3400892283258',
  ucdQtyMultiplicator: 100,
  cipLib: "AGRELIN 0,5MG GELU BT 100",
  atcCode: "L01XX35"
}, {
  CIP7: '5900820',
  CIP13: '3400959008206',
  ucdLib: "ALCOVER 24,5G/140ML BUV FL",
  UCD7: '9243804',
  UCD13: '3400892438047',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOVER 24,5G/140ML BUV FL BT 1",
  atcCode: "N07XX04"
}, {
  CIP7: '5905941',
  CIP13: '3400959059413',
  ucdLib: "ALINIA 100MG/5ML BUV FL60ML",
  UCD7: '9299242',
  UCD13: '3400892992426',
  ucdQtyMultiplicator: 1,
  cipLib: "ALINIA 100MG/5ML BUV FL60ML BT 1",
  atcCode: "P01AX11"
}, {
  CIP7: '5901676',
  CIP13: '3400959016768',
  ucdLib: "ALINIA 500MG CPR",
  UCD7: '9294463',
  UCD13: '3400892944630',
  ucdQtyMultiplicator: 60,
  cipLib: "ALINIA 500MG CPR BT 60",
  atcCode: "P01AX11"
}, {
  CIP7: '5906745',
  CIP13: '3400959067456',
  ucdLib: "ALPHAGAN P 0,15% COLLY FL10ML",
  UCD7: '9313321',
  UCD13: '3400893133217',
  ucdQtyMultiplicator: 1,
  cipLib: "ALPHAGAN P 0,15% COLLY FL10ML BT 1",
  atcCode: "S01EA05"
}, {
  CIP7: '5906739',
  CIP13: '3400959067395',
  ucdLib: "ALPHAGAN P 0,15% COLLY FL5ML",
  UCD7: '9313338',
  UCD13: '3400893133385',
  ucdQtyMultiplicator: 1,
  cipLib: "ALPHAGAN P 0,15% COLLY FL5ML BT 1",
  atcCode: "S01EA05"
}, {
  CIP7: '5906774',
  CIP13: '3400959067746',
  ucdLib: "AMG 531 250MCG PDR INJ FL",
  UCD7: '9313396',
  UCD13: '3400893133965',
  ucdQtyMultiplicator: 6,
  cipLib: "AMG 531 250MCG PDR INJ FL BT 6",
  atcCode: "B02BX04"
}, {
  CIP7: '5906797',
  CIP13: '3400959067975',
  ucdLib: "AMMONUL 10%/10% INJ FL+FL",
  UCD7: '9317023',
  UCD13: '3400893170236',
  ucdQtyMultiplicator: 1,
  cipLib: "AMMONUL 10%/10% INJ FL+FL BT 1",
  atcCode: "A16AX03"
}, {
  CIP7: '5906811',
  CIP13: '3400959068118',
  ucdLib: "ANADROL-50 50MG CPR",
  UCD7: '9318005',
  UCD13: '3400893180051',
  ucdQtyMultiplicator: 1,
  cipLib: "ANADROL-50 50MG CPR BT 1",
  atcCode: "A14AA05"
}, {
  CIP7: '5906171',
  CIP13: '3400959061713',
  ucdLib: "ANTAXONE 50MG/10ML BUV FL",
  UCD7: '9300005',
  UCD13: '3400893000052',
  ucdQtyMultiplicator: 14,
  cipLib: "ANTAXONE 50MG/10ML BUV FL BT 14",
  atcCode: "N07BB04"
}, {
  CIP7: '5900837',
  CIP13: '3400959008374',
  ucdLib: "ANTICHOLIUM 2MG/5ML INJ AMP",
  UCD7: '9243810',
  UCD13: '3400892438108',
  ucdQtyMultiplicator: 5,
  cipLib: "ANTICHOLIUM 2MG/5ML INJ AMP BT 5",
  atcCode: "V03AB19"
}, {
  CIP7: '5906857',
  CIP13: '3400959068576',
  ucdLib: "ANTIVYPMIN TRI SOL INJ FL",
  UCD7: '9318962',
  UCD13: '3400893189627',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTIVYPMIN TRI SOL INJ FL BT 1",
  atcCode: "J06BC"
}, {
  CIP7: '5909525',
  CIP13: '3400959095251',
  ucdLib: "ARGIPRESSIN 20UI/ML INJ FL",
  UCD7: '9399989',
  UCD13: '3400893999899',
  ucdQtyMultiplicator: 1,
  cipLib: "ARGIPRESSIN 20UI/ML INJ FL BT 1",
  atcCode: "H01BA01"
}, {
  CIP7: '5909531',
  CIP13: '3400959095312',
  ucdLib: "ARIKACE 70MG/ML INHAL NEB",
  UCD7: '9399995',
  UCD13: '3400893999950',
  ucdQtyMultiplicator: 1,
  cipLib: "ARIKACE 70MG/ML INHAL NEB BT 1",
  atcCode: "J01GB06"
}, {
  CIP7: '5908052',
  CIP13: '3400959080523',
  ucdLib: "ARINATE 100MG CPR",
  UCD7: '9373010',
  UCD13: '3400893730102',
  ucdQtyMultiplicator: 6,
  cipLib: "ARINATE 100MG CPR BT 6",
  atcCode: "P01BE03"
}, {
  CIP7: '5901943',
  CIP13: '3400959019431',
  ucdLib: "ARRANON 5MG/ML PERF FL50ML",
  UCD7: '9297964',
  UCD13: '3400892979649',
  ucdQtyMultiplicator: 6,
  cipLib: "ARRANON 5MG/ML PERF FL50ML BT 6",
  atcCode: "L01BB07"
}, {
  CIP7: '5908201',
  CIP13: '3400959082015',
  ucdLib: "ATGAM 50ML/ML INJ AMP5ML",
  UCD7: '9381564',
  UCD13: '3400893815649',
  ucdQtyMultiplicator: 5,
  cipLib: "ATGAM 50ML/ML INJ AMP5ML BT 5",
  atcCode: "L04AA04"
}, {
  CIP7: '5906188',
  CIP13: '3400959061881',
  ucdLib: "ATIVAN 4MG/ML INJ FL",
  UCD7: '9300011',
  UCD13: '3400893000113',
  ucdQtyMultiplicator: 1,
  cipLib: "ATIVAN 4MG/ML INJ FL BT 1",
  atcCode: "N05BA06"
}, {
  CIP7: '5901647',
  CIP13: '3400959016478',
  ucdLib: "AVELOX 400MG INJ POC250ML",
  UCD7: '9294457',
  UCD13: '3400892944579',
  ucdQtyMultiplicator: 1,
  cipLib: "AVELOX 400MG INJ POC250ML BT 1",
  atcCode: "J01MA14"
}, {
  CIP7: '5905958',
  CIP13: '3400959059581',
  ucdLib: "BABYBIG 100MG INJ FL",
  UCD7: '9299331',
  UCD13: '3400892993317',
  ucdQtyMultiplicator: 1,
  cipLib: "BABYBIG 100MG INJ FL BT 1",
  atcCode: "J06BB"
}, {
  CIP7: '5907779',
  CIP13: '3400959077790',
  ucdLib: "BELLAFIT 0,5MG/ML BUV GTT FL",
  UCD7: '9355532',
  UCD13: '3400893555323',
  ucdQtyMultiplicator: 1,
  cipLib: "BELLAFIT 0,5MG/ML BUV GTT FL BT 1",
  atcCode: "A03BA01"
}, {
  CIP7: '5908106',
  CIP13: '3400959081063',
  ucdLib: "BENZBROMARONE AL 100MG CPR",
  UCD7: '9373501',
  UCD13: '3400893735015',
  ucdQtyMultiplicator: 1,
  cipLib: "BENZBROMARONE AL 100MG CPR BT 1",
  atcCode: "M04AB03"
}, {
  CIP7: '5907756',
  CIP13: '3400959077561',
  ucdLib: "BENZNIDAZOL LFP 100MG CPR",
  UCD7: '9355549',
  UCD13: '3400893555491',
  ucdQtyMultiplicator: 100,
  cipLib: "BENZNIDAZOL LFP 100MG CPR BT 100",
  atcCode: "P01CA02"
}, {
  CIP7: '5908678',
  CIP13: '3400959086785',
  ucdLib: "BIOBAG 2,5*4CM PANS LARV SAC",
  UCD7: '9384255',
  UCD13: '3400893842553',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOBAG 2,5*4CM PANS LARV SAC BT 1",
  atcCode: ""
}, {
  CIP7: '5908684',
  CIP13: '3400959086846',
  ucdLib: "BIOBAG 4*5CM PANS LARV SAC",
  UCD7: '9384261',
  UCD13: '3400893842614',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOBAG 4*5CM PANS LARV SAC BT 1",
  atcCode: ""
}, {
  CIP7: '5908690',
  CIP13: '3400959086907',
  ucdLib: "BIOBAG 5*6CM PANS LARV SAC",
  UCD7: '9384278',
  UCD13: '3400893842782',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOBAG 5*6CM PANS LARV SAC BT 1",
  atcCode: ""
}, {
  CIP7: '5908709',
  CIP13: '3400959087096',
  ucdLib: "BIOBAG 6*12CM PANS LARV SAC",
  UCD7: '9384284',
  UCD13: '3400893842843',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOBAG 6*12CM PANS LARV SAC BT 1",
  atcCode: ""
}, {
  CIP7: '5909287',
  CIP13: '3400959092878',
  ucdLib: "BMS-650032 100MG GELU",
  UCD7: '9394779',
  UCD13: '3400893947791',
  ucdQtyMultiplicator: 66,
  cipLib: "BMS-650032 100MG GELU BT 66",
  atcCode: "J05AB"
}, {
  CIP7: '3061752',
  CIP13: '3400930617526',
  ucdLib: "BOIRON PATES PECT. MANDAR. 60G",
  UCD7: '9054109',
  UCD13: '3400890541091',
  ucdQtyMultiplicator: 1,
  cipLib: "BOIRON PATES PECT. MANDAR. 60G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5908193',
  CIP13: '3400959081933',
  ucdLib: "BOSATRIA 250MG INJ FL",
  UCD7: '9381297',
  UCD13: '3400893812976',
  ucdQtyMultiplicator: 1,
  cipLib: "BOSATRIA 250MG INJ FL BT 1",
  atcCode: "L04AC06"
}, {
  CIP7: '5905964',
  CIP13: '3400959059642',
  ucdLib: "BOTHROFAV SOL PERF FL10ML",
  UCD7: '9185366',
  UCD13: '3400891853667',
  ucdQtyMultiplicator: 1,
  cipLib: "BOTHROFAV SOL PERF FL10ML BT 1",
  atcCode: "J06BC"
}, {
  CIP7: '5906001',
  CIP13: '3400959060013',
  ucdLib: "BOTULISM ANTITOX. BEH FL250ML",
  UCD7: '9299495',
  UCD13: '3400892994956',
  ucdQtyMultiplicator: 1,
  cipLib: "BOTULISM ANTITOX. BEH FL250ML BT 1",
  atcCode: "J06AA04"
}, {
  CIP7: '5900903',
  CIP13: '3400959009036',
  ucdLib: "BREDININ 50MG GELU",
  UCD7: '9243916',
  UCD13: '3400892439167',
  ucdQtyMultiplicator: 100,
  cipLib: "BREDININ 50MG GELU BT 100",
  atcCode: "L04A"
}, {
  CIP7: '5906194',
  CIP13: '3400959061942',
  ucdLib: "BREVIMYTAL HIK 500MG INJ FL",
  UCD7: '9300028',
  UCD13: '3400893000281',
  ucdQtyMultiplicator: 1,
  cipLib: "BREVIMYTAL HIK 500MG INJ FL BT 1",
  atcCode: "N01AF01"
}, {
  CIP7: '5900843',
  CIP13: '3400959008435',
  ucdLib: "BROLENE 0,10% COLLY FL10ML",
  UCD7: '9243827',
  UCD13: '3400892438276',
  ucdQtyMultiplicator: 1,
  cipLib: "BROLENE 0,10% COLLY FL10ML BT 1",
  atcCode: "S01AX15"
}, {
  CIP7: '3453601',
  CIP13: '3400934536014',
  ucdLib: "CAFEINE CIT.CPF 25MG/ML A2ML",
  UCD7: '9204477',
  UCD13: '3400892044774',
  ucdQtyMultiplicator: 50,
  cipLib: "CAFEINE CIT.CPF 25MG/ML A2ML BT 50",
  atcCode: "N06BC01"
}, {
  CIP7: '3061700',
  CIP13: '3400930617007',
  ucdLib: "CALENDULA CREME BOIR POT20G",
  UCD7: '9015109',
  UCD13: '3400890151092',
  ucdQtyMultiplicator: 1,
  cipLib: "CALENDULA CREME BOIR POT20G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3061769',
  CIP13: '3400930617694',
  ucdLib: "CALENDULA LHF POM TB20G",
  UCD7: '9015121',
  UCD13: '3400890151214',
  ucdQtyMultiplicator: 1,
  cipLib: "CALENDULA LHF POM TB20G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '5907058',
  CIP13: '3400959070586',
  ucdLib: "CAMPATH 30MG/ML INJ FV",
  UCD7: '9386952',
  UCD13: '3400893869529',
  ucdQtyMultiplicator: 3,
  cipLib: "CAMPATH 30MG/ML INJ FV BT 3",
  atcCode: "L04AA34"
}, {
  CIP7: '5901417',
  CIP13: '3400959014177',
  ucdLib: "CAPASTAT 1G INJ FL",
  UCD7: '9289930',
  UCD13: '3400892899305',
  ucdQtyMultiplicator: 1,
  cipLib: "CAPASTAT 1G INJ FL BT 1",
  atcCode: "J04AB30"
}, {
  CIP7: '5901280',
  CIP13: '3400959012807',
  ucdLib: "CAPOTEN 5MG/ML BUV FL95ML",
  UCD7: '9288540',
  UCD13: '3400892885407',
  ucdQtyMultiplicator: 1,
  cipLib: "CAPOTEN 5MG/ML BUV FL95ML BT 1",
  atcCode: "C09AA01"
}, {
  CIP7: '5906202',
  CIP13: '3400959062024',
  ucdLib: "CAPTAGON 50MG CPR PELLIC",
  UCD7: '9016095',
  UCD13: '3400890160957',
  ucdQtyMultiplicator: 20,
  cipLib: "CAPTAGON 50MG CPR PELLIC BT 20",
  atcCode: "N06BA10"
}, {
  CIP7: '5901937',
  CIP13: '3400959019370',
  ucdLib: "CEFLATONIN 5MG PDR INJ FL",
  UCD7: '9297473',
  UCD13: '3400892974736',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFLATONIN 5MG PDR INJ FL BT 1",
  atcCode: "L01XX40"
}, {
  CIP7: '5906099',
  CIP13: '3400959060990',
  ucdLib: "CHENOFALK 250MG GELU",
  UCD7: '9299615',
  UCD13: '3400892996158',
  ucdQtyMultiplicator: 1,
  cipLib: "CHENOFALK 250MG GELU BT 1",
  atcCode: "A05AA01"
}, {
  CIP7: '5909382',
  CIP13: '3400959093820',
  ucdLib: "CICLOSPORINE NGP 0,01% CY FL",
  UCD7: '9396614',
  UCD13: '3400893966143',
  ucdQtyMultiplicator: 1,
  cipLib: "CICLOSPORINE NGP 0,01% CY FL BT 1",
  atcCode: "S01XA18"
}, {
  CIP7: '5909838',
  CIP13: '3400959098382',
  ucdLib: "CIDOFOVIR NXP 75MG/ML FL5ML",
  UCD7: '9404992',
  UCD13: '3400894049920',
  ucdQtyMultiplicator: 1,
  cipLib: "CIDOFOVIR NXP 75MG/ML FL5ML BT 1",
  atcCode: "J05AB12"
}, {
  CIP7: '5906863',
  CIP13: '3400959068637',
  ucdLib: "CILENGITIDE MERCK 15MG/ML FL",
  UCD7: '9318979',
  UCD13: '3400893189795',
  ucdQtyMultiplicator: 1,
  cipLib: "CILENGITIDE MERCK 15MG/ML FL BT 1",
  atcCode: "L01XX"
}, {
  CIP7: '5906840',
  CIP13: '3400959068408',
  ucdLib: "CIMAHER 5MG/ML INJ FL",
  UCD7: '9318229',
  UCD13: '3400893182291',
  ucdQtyMultiplicator: 1,
  cipLib: "CIMAHER 5MG/ML INJ FL BT 1",
  atcCode: "L01XC"
}, {
  CIP7: '5909910',
  CIP13: '3400959099105',
  ucdLib: "CMX 001 100MG CPR",
  UCD7: '9407364',
  UCD13: '3400894073642',
  ucdQtyMultiplicator: 1,
  cipLib: "CMX 001 100MG CPR BT 1",
  atcCode: "J05AB"
}, {
  CIP7: '5906107',
  CIP13: '3400959061072',
  ucdLib: "COLESTID 5G BUV SACH",
  UCD7: '9299621',
  UCD13: '3400892996219',
  ucdQtyMultiplicator: 1,
  cipLib: "COLESTID 5G BUV SACH BT 1",
  atcCode: "C10AC02"
}, {
  CIP7: '5909028',
  CIP13: '3400959090287',
  ucdLib: "CRIZOTINIB PFZ 25MG/ML 240ML",
  UCD7: '9390793',
  UCD13: '3400893907931',
  ucdQtyMultiplicator: 1,
  cipLib: "CRIZOTINIB PFZ 25MG/ML 240ML BT 1",
  atcCode: "L01XE16"
}, {
  CIP7: '5901400',
  CIP13: '3400959014009',
  ucdLib: "CYCLOSERINE 250MG GELU",
  UCD7: '9289947',
  UCD13: '3400892899473',
  ucdQtyMultiplicator: 100,
  cipLib: "CYCLOSERINE 250MG GELU BT 100",
  atcCode: "J04AB01"
}, {
  CIP7: '5901966',
  CIP13: '3400959019660',
  ucdLib: "CYTADREN 250MG CPR",
  UCD7: '9297970',
  UCD13: '3400892979700',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTADREN 250MG CPR BT 1",
  atcCode: "L02BG01"
}, {
  CIP7: '5909850',
  CIP13: '3400959098504',
  ucdLib: "CYTOTECT CP 100U/ML FL10ML",
  UCD7: '9406092',
  UCD13: '3400894060925',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTOTECT CP 100U/ML FL10ML BT 1",
  atcCode: "J06BB09"
}, {
  CIP7: '5909867',
  CIP13: '3400959098672',
  ucdLib: "CYTOTECT CP 100U/ML FL50ML",
  UCD7: '9406100',
  UCD13: '3400894061007',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTOTECT CP 100U/ML FL50ML BT 1",
  atcCode: "J06BB09"
}, {
  CIP7: '5906886',
  CIP13: '3400959068866',
  ucdLib: "DAPSONE 50MG CPR",
  UCD7: '9318985',
  UCD13: '3400893189856',
  ucdQtyMultiplicator: 100,
  cipLib: "DAPSONE 50MG CPR BT 100",
  atcCode: "J04BA02"
}, {
  CIP7: '5901009',
  CIP13: '3400959010094',
  ucdLib: "DECORENONE 50MG GELU",
  UCD7: '9246139',
  UCD13: '3400892461397',
  ucdQtyMultiplicator: 14,
  cipLib: "DECORENONE 50MG GELU BT 14",
  atcCode: "C01EB09"
}, {
  CIP7: '5901015',
  CIP13: '3400959010155',
  ucdLib: "DECORENONE 50MG/10ML BUV FL",
  UCD7: '9246145',
  UCD13: '3400892461458',
  ucdQtyMultiplicator: 10,
  cipLib: "DECORENONE 50MG/10ML BUV FL BT 10",
  atcCode: "C01EB09"
}, {
  CIP7: '5900814',
  CIP13: '3400959008145',
  ucdLib: "DEMSER 250MG CPR",
  UCD7: '9242880',
  UCD13: '3400892428802',
  ucdQtyMultiplicator: 100,
  cipLib: "DEMSER 250MG CPR BT 100",
  atcCode: "C02KB01"
}, {
  CIP7: '5906455',
  CIP13: '3400959064554',
  ucdLib: "DESURIC 100MG CPR",
  UCD7: '9025697',
  UCD13: '3400890256971',
  ucdQtyMultiplicator: 1,
  cipLib: "DESURIC 100MG CPR BT 1",
  atcCode: "M04AB03"
}, {
  CIP7: '5908715',
  CIP13: '3400959087157',
  ucdLib: "DEXAMFETAMINE AML 5MG CPR",
  UCD7: '9384315',
  UCD13: '3400893843154',
  ucdQtyMultiplicator: 28,
  cipLib: "DEXAMFETAMINE AML 5MG CPR BT 28",
  atcCode: "N06BA02"
}, {
  CIP7: '5900866',
  CIP13: '3400959008664',
  ucdLib: "DEXAMINE 5MG CPR",
  UCD7: '9243833',
  UCD13: '3400892438337',
  ucdQtyMultiplicator: 90,
  cipLib: "DEXAMINE 5MG CPR BT 90",
  atcCode: "N06BA02"
}, {
  CIP7: '5906219',
  CIP13: '3400959062192',
  ucdLib: "DEXEDRINE 5MG CPR",
  UCD7: '9300034',
  UCD13: '3400893000342',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXEDRINE 5MG CPR BT 1",
  atcCode: "N06BA02"
}, {
  CIP7: '5907650',
  CIP13: '3400959076502',
  ucdLib: "DEXSOL 2MG/5ML BUV FL150ML",
  UCD7: '9355041',
  UCD13: '3400893550410',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXSOL 2MG/5ML BUV FL150ML BT 1",
  atcCode: "H02AB02"
}, {
  CIP7: '5902693',
  CIP13: '3400959026934',
  ucdLib: "DHS PRICK 2GRAMIN INJ FL3ML",
  UCD7: '9252039',
  UCD13: '3400892520391',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK 2GRAMIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902687',
  CIP13: '3400959026873',
  ucdLib: "DHS PRICK 4CEREAL INJ FL3ML",
  UCD7: '9252045',
  UCD13: '3400892520452',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK 4CEREAL INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902701',
  CIP13: '3400959027016',
  ucdLib: "DHS PRICK 4GRAMIN INJ FL3ML",
  UCD7: '9252051',
  UCD13: '3400892520513',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK 4GRAMIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902724',
  CIP13: '3400959027245',
  ucdLib: "DHS PRICK 5GRAMIN INJ FL3ML",
  UCD7: '9252068',
  UCD13: '3400892520681',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK 5GRAMIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903385',
  CIP13: '3400959033857',
  ucdLib: "DHS PRICK 5POLLEN FLEUR INJ3ML",
  UCD7: '9252720',
  UCD13: '3400892527208',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK 5POLLEN FLEUR INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903043',
  CIP13: '3400959030436',
  ucdLib: "DHS PRICK ALTERNARIA INJ FL3ML",
  UCD7: '9252358',
  UCD13: '3400892523583',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK ALTERNARIA INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902807',
  CIP13: '3400959028075',
  ucdLib: "DHS PRICK AMBROISIE INJ FL3ML",
  UCD7: '9252111',
  UCD13: '3400892521114',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK AMBROISIE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903296',
  CIP13: '3400959032966',
  ucdLib: "DHS PRICK ARBRES CORYL INJ 3ML",
  UCD7: '9252631',
  UCD13: '3400892526317',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK ARBRES CORYL INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902813',
  CIP13: '3400959028136',
  ucdLib: "DHS PRICK ARMOISE INJ FL3ML",
  UCD7: '9252128',
  UCD13: '3400892521282',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK ARMOISE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903014',
  CIP13: '3400959030146',
  ucdLib: "DHS PRICK ASPERG.MIX INJ FL3ML",
  UCD7: '9252134',
  UCD13: '3400892521343',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK ASPERG.MIX INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902730',
  CIP13: '3400959027306',
  ucdLib: "DHS PRICK AULNE INJ FL3ML",
  UCD7: '9251910',
  UCD13: '3400892519104',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK AULNE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902664',
  CIP13: '3400959026644',
  ucdLib: "DHS PRICK AVOINE INJ FL3ML",
  UCD7: '9251927',
  UCD13: '3400892519272',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK AVOINE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902670',
  CIP13: '3400959026705',
  ucdLib: "DHS PRICK AVOINE/SEIGL INJ 3ML",
  UCD7: '9251933',
  UCD13: '3400892519333',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK AVOINE/SEIGL INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902799',
  CIP13: '3400959027993',
  ucdLib: "DHS PRICK BETULACEES INJ FL3ML",
  UCD7: '9252074',
  UCD13: '3400892520742',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK BETULACEES INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902954',
  CIP13: '3400959029546',
  ucdLib: "DHS PRICK BLATTE GERM INJ 3ML",
  UCD7: '9252140',
  UCD13: '3400892521404',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK BLATTE GERM INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902919',
  CIP13: '3400959029195',
  ucdLib: "DHS PRICK BLE INJ FL3ML",
  UCD7: '9252157',
  UCD13: '3400892521572',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK BLE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903066',
  CIP13: '3400959030665',
  ucdLib: "DHS PRICK BOTRYTIS CIN INJ 3ML",
  UCD7: '9252364',
  UCD13: '3400892523644',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK BOTRYTIS CIN INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902747',
  CIP13: '3400959027474',
  ucdLib: "DHS PRICK BOULEAU INJ FL3ML",
  UCD7: '9251956',
  UCD13: '3400892519562',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK BOULEAU INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903244',
  CIP13: '3400959032447',
  ucdLib: "DHS PRICK CHATAIGNIER INJ 3ML",
  UCD7: '9252370',
  UCD13: '3400892523705',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK CHATAIGNIER INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903132',
  CIP13: '3400959031327',
  ucdLib: "DHS PRICK CHENE INJ FL3ML",
  UCD7: '9252387',
  UCD13: '3400892523873',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK CHENE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903327',
  CIP13: '3400959033277',
  ucdLib: "DHS PRICK CHENOPODE INJ FL3ML",
  UCD7: '9252648',
  UCD13: '3400892526485',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK CHENOPODE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903008',
  CIP13: '3400959030085',
  ucdLib: "DHS PRICK CLADOSPORIUM INJ 3ML",
  UCD7: '9252163',
  UCD13: '3400892521633',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK CLADOSPORIUM INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903333',
  CIP13: '3400959033338',
  ucdLib: "DHS PRICK COLZA INJ FL3ML",
  UCD7: '9252654',
  UCD13: '3400892526546',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK COLZA INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903209',
  CIP13: '3400959032096',
  ucdLib: "DHS PRICK CYPRES ARIZ INJ 3ML",
  UCD7: '9252393',
  UCD13: '3400892523934',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK CYPRES ARIZ INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903190',
  CIP13: '3400959031907',
  ucdLib: "DHS PRICK CYPRES SEMP INJ 3ML",
  UCD7: '9252401',
  UCD13: '3400892524016',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK CYPRES SEMP INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902569',
  CIP13: '3400959025692',
  ucdLib: "DHS PRICK D.PTERONYS INJ FL3ML",
  UCD7: '9251525',
  UCD13: '3400892515250',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK D.PTERONYS INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902612',
  CIP13: '3400959026125',
  ucdLib: "DHS PRICK DACTYLE INJ FL3ML",
  UCD7: '9251962',
  UCD13: '3400892519623',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK DACTYLE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902575',
  CIP13: '3400959025753',
  ucdLib: "DHS PRICK DERM.FARIN INJ FL3ML",
  UCD7: '9251519',
  UCD13: '3400892515199',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK DERM.FARIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903250',
  CIP13: '3400959032508',
  ucdLib: "DHS PRICK FAGACEES INJ FL3ML",
  UCD7: '9252418',
  UCD13: '3400892524184',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK FAGACEES INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902871',
  CIP13: '3400959028716',
  ucdLib: "DHS PRICK FARINE BLE INJ FL3ML",
  UCD7: '9252186',
  UCD13: '3400892521862',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK FARINE BLE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902888',
  CIP13: '3400959028884',
  ucdLib: "DHS PRICK FARINE SEIGL INJ 3ML",
  UCD7: '9252192',
  UCD13: '3400892521923',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK FARINE SEIGL INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903184',
  CIP13: '3400959031846',
  ucdLib: "DHS PRICK FRENE INJ FL3ML",
  UCD7: '9252424',
  UCD13: '3400892524245',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK FRENE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902842',
  CIP13: '3400959028426',
  ucdLib: "DHS PRICK HERBACEES 1 INJ 3ML",
  UCD7: '9252200',
  UCD13: '3400892522005',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK HERBACEES 1 INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903362',
  CIP13: '3400959033628',
  ucdLib: "DHS PRICK HERBACEES 2 INJ 3ML",
  UCD7: '9252660',
  UCD13: '3400892526607',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK HERBACEES 2 INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903379',
  CIP13: '3400959033796',
  ucdLib: "DHS PRICK HERBACEES 3 INJ 3ML",
  UCD7: '9252677',
  UCD13: '3400892526775',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK HERBACEES 3 INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903126',
  CIP13: '3400959031266',
  ucdLib: "DHS PRICK HETRE INJ FL3ML",
  UCD7: '9252430',
  UCD13: '3400892524306',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK HETRE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902552',
  CIP13: '3400959025524',
  ucdLib: "DHS PRICK HISTAMINE INJ FL3ML",
  UCD7: '9251531',
  UCD13: '3400892515311',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK HISTAMINE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902902',
  CIP13: '3400959029027',
  ucdLib: "DHS PRICK HOULQ.LAIN INJ FL3ML",
  UCD7: '9252217',
  UCD13: '3400892522173',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK HOULQ.LAIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902629',
  CIP13: '3400959026293',
  ucdLib: "DHS PRICK IVRAIE INJ FL3ML",
  UCD7: '9251979',
  UCD13: '3400892519791',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK IVRAIE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902718',
  CIP13: '3400959027184',
  ucdLib: "DHS PRICK IVRAIE/PATUR INJ 3ML",
  UCD7: '9251985',
  UCD13: '3400892519852',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK IVRAIE/PATUR INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902776',
  CIP13: '3400959027764',
  ucdLib: "DHS PRICK JUNIP.ASHEI INJ 3ML",
  UCD7: '9252080',
  UCD13: '3400892520803',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK JUNIP.ASHEI INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902948',
  CIP13: '3400959029485',
  ucdLib: "DHS PRICK MAIS INJ FL3ML",
  UCD7: '9252223',
  UCD13: '3400892522234',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK MAIS INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903215',
  CIP13: '3400959032157',
  ucdLib: "DHS PRICK MARRONNIER INJ FL3ML",
  UCD7: '9252447',
  UCD13: '3400892524474',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK MARRONNIER INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902977',
  CIP13: '3400959029775',
  ucdLib: "DHS PRICK MELANG BLAT. INJ 3ML",
  UCD7: '9252246',
  UCD13: '3400892522463',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK MELANG BLAT. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903095',
  CIP13: '3400959030955',
  ucdLib: "DHS PRICK MOISISSUR.1 INJ 3ML",
  UCD7: '9252453',
  UCD13: '3400892524535',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK MOISISSUR.1 INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903103',
  CIP13: '3400959031037',
  ucdLib: "DHS PRICK MOISISSUR.2 INJ 3ML",
  UCD7: '9252476',
  UCD13: '3400892524764',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK MOISISSUR.2 INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903020',
  CIP13: '3400959030207',
  ucdLib: "DHS PRICK MUCOR RACEM. INJ 3ML",
  UCD7: '9252252',
  UCD13: '3400892522524',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK MUCOR RACEM. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902753',
  CIP13: '3400959027535',
  ucdLib: "DHS PRICK NOISETIER INJ FL3ML",
  UCD7: '9252097',
  UCD13: '3400892520971',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK NOISETIER INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903267',
  CIP13: '3400959032676',
  ucdLib: "DHS PRICK OLEACEES INJ FL3ML",
  UCD7: '9252482',
  UCD13: '3400892524825',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK OLEACEES INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902782',
  CIP13: '3400959027825',
  ucdLib: "DHS PRICK OLIVIER INJ FL3ML",
  UCD7: '9252105',
  UCD13: '3400892521053',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK OLIVIER INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902931',
  CIP13: '3400959029317',
  ucdLib: "DHS PRICK ORGE INJ FL3ML",
  UCD7: '9252269',
  UCD13: '3400892522692',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK ORGE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903149',
  CIP13: '3400959031495',
  ucdLib: "DHS PRICK ORME INJ FL3ML",
  UCD7: '9252499',
  UCD13: '3400892524993',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK ORME INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902836',
  CIP13: '3400959028365',
  ucdLib: "DHS PRICK PARIET.JUD INJ FL3ML",
  UCD7: '9252275',
  UCD13: '3400892522753',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PARIET.JUD INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902641',
  CIP13: '3400959026415',
  ucdLib: "DHS PRICK PATURIN INJ FL3ML",
  UCD7: '9251991',
  UCD13: '3400892519913',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PATURIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902983',
  CIP13: '3400959029836',
  ucdLib: "DHS PRICK PENICIL.MIX INJ 3ML",
  UCD7: '9252281',
  UCD13: '3400892522814',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PENICIL.MIX INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903178',
  CIP13: '3400959031785',
  ucdLib: "DHS PRICK PEUPLIER INJ FL3ML",
  UCD7: '9252507',
  UCD13: '3400892525075',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PEUPLIER INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902635',
  CIP13: '3400959026354',
  ucdLib: "DHS PRICK PHLEOLE PRES INJ 3ML",
  UCD7: '9252016',
  UCD13: '3400892520162',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PHLEOLE PRES INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903304',
  CIP13: '3400959033048',
  ucdLib: "DHS PRICK PISSENLIT INJ FL3ML",
  UCD7: '9252683',
  UCD13: '3400892526836',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PISSENLIT INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903310',
  CIP13: '3400959033109',
  ucdLib: "DHS PRICK PLANTAIN INJ FL3ML",
  UCD7: '9252708',
  UCD13: '3400892527086',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PLANTAIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903155',
  CIP13: '3400959031556',
  ucdLib: "DHS PRICK PLATANE INJ FL3ML",
  UCD7: '9252513',
  UCD13: '3400892525136',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PLATANE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902865',
  CIP13: '3400959028655',
  ucdLib: "DHS PRICK PLUME MELANG INJ 3ML",
  UCD7: '9252298',
  UCD13: '3400892522982',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PLUME MELANG INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902581',
  CIP13: '3400959025814',
  ucdLib: "DHS PRICK POIL CHAT INJ FL3ML",
  UCD7: '9251548',
  UCD13: '3400892515489',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK POIL CHAT INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902606',
  CIP13: '3400959026064',
  ucdLib: "DHS PRICK POIL CHEVAL INJ 3ML",
  UCD7: '9251554',
  UCD13: '3400892515540',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK POIL CHEVAL INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902598',
  CIP13: '3400959025982',
  ucdLib: "DHS PRICK POIL CHIEN INJ FL3ML",
  UCD7: '9251560',
  UCD13: '3400892515601',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK POIL CHIEN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902859',
  CIP13: '3400959028594',
  ucdLib: "DHS PRICK POIL LAPIN INJ FL3ML",
  UCD7: '9252306',
  UCD13: '3400892523064',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK POIL LAPIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902960',
  CIP13: '3400959029607',
  ucdLib: "DHS PRICK PUCE CHAT INJ FL3ML",
  UCD7: '9252312',
  UCD13: '3400892523125',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK PUCE CHAT INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903089',
  CIP13: '3400959030894',
  ucdLib: "DHS PRICK RHIZOPUS NIG INJ 3ML",
  UCD7: '9252536',
  UCD13: '3400892525365',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK RHIZOPUS NIG INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902894',
  CIP13: '3400959028945',
  ucdLib: "DHS PRICK ROSEAU INJ FL3ML",
  UCD7: '9252329',
  UCD13: '3400892523293',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK ROSEAU INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903273',
  CIP13: '3400959032737',
  ucdLib: "DHS PRICK SALICACEES INJ FL3ML",
  UCD7: '9252542',
  UCD13: '3400892525426',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK SALICACEES INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903161',
  CIP13: '3400959031617',
  ucdLib: "DHS PRICK SAULE INJ FL3ML",
  UCD7: '9252559',
  UCD13: '3400892525594',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK SAULE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902658',
  CIP13: '3400959026583',
  ucdLib: "DHS PRICK SEIGL.POL INJ FL3ML",
  UCD7: '9252022',
  UCD13: '3400892520223',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK SEIGL.POL INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903072',
  CIP13: '3400959030726',
  ucdLib: "DHS PRICK STEMPHILIUM INJ 3ML",
  UCD7: '9252565',
  UCD13: '3400892525655',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK STEMPHILIUM INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902546',
  CIP13: '3400959025463',
  ucdLib: "DHS PRICK TEMOIN NEG INJ 3ML",
  UCD7: '9251577',
  UCD13: '3400892515779',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK TEMOIN NEG INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903238',
  CIP13: '3400959032386',
  ucdLib: "DHS PRICK TILLEUL INJ FL3ML",
  UCD7: '9252571',
  UCD13: '3400892525716',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK TILLEUL INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903356',
  CIP13: '3400959033567',
  ucdLib: "DHS PRICK TREFLE INJ FL3ML",
  UCD7: '9252714',
  UCD13: '3400892527147',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK TREFLE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903221',
  CIP13: '3400959032218',
  ucdLib: "DHS PRICK TROENE INJ FL3ML",
  UCD7: '9252588',
  UCD13: '3400892525884',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK TROENE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902925',
  CIP13: '3400959029256',
  ucdLib: "DHS PRICK VULPIN INJ FL3ML",
  UCD7: '9252335',
  UCD13: '3400892523354',
  ucdQtyMultiplicator: 1,
  cipLib: "DHS PRICK VULPIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5909100',
  CIP13: '3400959091000',
  ucdLib: "DIAZEPAM DTI 10MG GEL RECT TB",
  UCD7: '9392361',
  UCD13: '3400893923610',
  ucdQtyMultiplicator: 1,
  cipLib: "DIAZEPAM DTI 10MG GEL RECT TB BT 1",
  atcCode: "N05BA01"
}, {
  CIP7: '5909933',
  CIP13: '3400959099334',
  ucdLib: "DIAZEPAM DTI 5MG GEL RECT",
  UCD7: '9407559',
  UCD13: '3400894075592',
  ucdQtyMultiplicator: 1,
  cipLib: "DIAZEPAM DTI 5MG GEL RECT BT 1",
  atcCode: "N05BA01"
}, {
  CIP7: '5908916',
  CIP13: '3400959089168',
  ucdLib: "DIAZEPAM RECT SDZ 5MG GEL TB",
  UCD7: '9386194',
  UCD13: '3400893861943',
  ucdQtyMultiplicator: 1,
  cipLib: "DIAZEPAM RECT SDZ 5MG GEL TB BT 1",
  atcCode: "N05BA01"
}, {
  CIP7: '5908744',
  CIP13: '3400959087447',
  ucdLib: "DIAZEPAM RECT SDZ10MG GEL TB",
  UCD7: '9384367',
  UCD13: '3400893843673',
  ucdQtyMultiplicator: 1,
  cipLib: "DIAZEPAM RECT SDZ10MG GEL TB BT 1",
  atcCode: "N05BA01"
}, {
  CIP7: '5909117',
  CIP13: '3400959091178',
  ucdLib: "DIBENYLINE 10MG GELU",
  UCD7: '9392378',
  UCD13: '3400893923788',
  ucdQtyMultiplicator: 1,
  cipLib: "DIBENYLINE 10MG GELU BT 1",
  atcCode: ""
}, {
  CIP7: '5906461',
  CIP13: '3400959064615',
  ucdLib: "DIBENZYRAN 10MG CPR",
  UCD7: '9300293',
  UCD13: '3400893002933',
  ucdQtyMultiplicator: 1,
  cipLib: "DIBENZYRAN 10MG CPR BT 1",
  atcCode: "G04"
}, {
  CIP7: '5906225',
  CIP13: '3400959062253',
  ucdLib: "DIBRO-BE MONO 850MG CPR",
  UCD7: '9300040',
  UCD13: '3400893000403',
  ucdQtyMultiplicator: 1,
  cipLib: "DIBRO-BE MONO 850MG CPR BT 1",
  atcCode: "N05CM11"
}, {
  CIP7: '5902049',
  CIP13: '3400959020499',
  ucdLib: "DI-DTPA-TL IBC 1,2MG/ML FL",
  UCD7: '9298751',
  UCD13: '3400892987514',
  ucdQtyMultiplicator: 1,
  cipLib: "DI-DTPA-TL IBC 1,2MG/ML FL BT 1",
  atcCode: "V10XX"
}, {
  CIP7: '5908000',
  CIP13: '3400959080004',
  ucdLib: "DIGIFAB 40MG LYOT INJ FL",
  UCD7: '9367989',
  UCD13: '3400893679890',
  ucdQtyMultiplicator: 1,
  cipLib: "DIGIFAB 40MG LYOT INJ FL BT 1",
  atcCode: "V03AB24"
}, {
  CIP7: '5909442',
  CIP13: '3400959094421',
  ucdLib: "DIGOXIN KERN 0,25MG/ML AMP2ML",
  UCD7: '9397826',
  UCD13: '3400893978269',
  ucdQtyMultiplicator: 5,
  cipLib: "DIGOXIN KERN 0,25MG/ML AMP2ML BT 5",
  atcCode: "C01AA05"
}, {
  CIP7: '5906018',
  CIP13: '3400959060181',
  ucdLib: "DILOXANIDE WAY 500MG CPR",
  UCD7: '9299532',
  UCD13: '3400892995328',
  ucdQtyMultiplicator: 1,
  cipLib: "DILOXANIDE WAY 500MG CPR BT 1",
  atcCode: "P01AC01"
}, {
  CIP7: '5908661',
  CIP13: '3400959086617',
  ucdLib: "DIMINEX 2MG CPR",
  UCD7: '9384195',
  UCD13: '3400893841952',
  ucdQtyMultiplicator: 60,
  cipLib: "DIMINEX 2MG CPR BT 60",
  atcCode: "A08AA05"
}, {
  CIP7: '5909123',
  CIP13: '3400959091239',
  ucdLib: "DIODOQIN 210MG CPR",
  UCD7: '9392390',
  UCD13: '3400893923900',
  ucdQtyMultiplicator: 1,
  cipLib: "DIODOQIN 210MG CPR BT 1",
  atcCode: ""
}, {
  CIP7: '5908508',
  CIP13: '3400959085085',
  ucdLib: "DIPHTHERIA A-TOX IBT1000UI FL",
  UCD7: '9382693',
  UCD13: '3400893826935',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPHTHERIA A-TOX IBT1000UI FL BT 1",
  atcCode: "J06BB10"
}, {
  CIP7: '5901512',
  CIP13: '3400959015129',
  ucdLib: "DODECAVIT 5MG/ML AMP2ML",
  UCD7: '9291111',
  UCD13: '3400892911113',
  ucdQtyMultiplicator: 6,
  cipLib: "DODECAVIT 5MG/ML AMP2ML BT 6",
  atcCode: "B03BA03"
}, {
  CIP7: '5909005',
  CIP13: '3400959090058',
  ucdLib: "DOPRAM 20MG/ML INJ AMP5ML",
  UCD7: '9387118',
  UCD13: '3400893871188',
  ucdQtyMultiplicator: 5,
  cipLib: "DOPRAM 20MG/ML INJ AMP5ML BT 5",
  atcCode: "R07AB01"
}, {
  CIP7: '5909695',
  CIP13: '3400959096951',
  ucdLib: "DOPS OD 100MG CPR DISP",
  UCD7: '9403159',
  UCD13: '3400894031598',
  ucdQtyMultiplicator: 1,
  cipLib: "DOPS OD 100MG CPR DISP BT 1",
  atcCode: "C01CA03"
}, {
  CIP7: '5909146',
  CIP13: '3400959091468',
  ucdLib: "DOTA-TOC 50MCG SOL INJ FL",
  UCD7: '9392409',
  UCD13: '3400893924099',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTA-TOC 50MCG SOL INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5909672',
  CIP13: '3400959096722',
  ucdLib: "EC-20 100MCG PDR INJ FL",
  UCD7: '9403136',
  UCD13: '3400894031369',
  ucdQtyMultiplicator: 1,
  cipLib: "EC-20 100MCG PDR INJ FL BT 1",
  atcCode: "V09IA08"
}, {
  CIP7: '5908750',
  CIP13: '3400959087508',
  ucdLib: "EDROPHONIUM BP 10MG/1ML FL",
  UCD7: '9384462',
  UCD13: '3400893844625',
  ucdQtyMultiplicator: 1,
  cipLib: "EDROPHONIUM BP 10MG/1ML FL BT 1",
  atcCode: ""
}, {
  CIP7: '5909689',
  CIP13: '3400959096890',
  ucdLib: "ELELYSO 200U PERF FL",
  UCD7: '9403142',
  UCD13: '3400894031420',
  ucdQtyMultiplicator: 1,
  cipLib: "ELELYSO 200U PERF FL BT 1",
  atcCode: "A16AB11"
}, {
  CIP7: '5901618',
  CIP13: '3400959016188',
  ucdLib: "ELMIRON GELU",
  UCD7: '9293529',
  UCD13: '3400892935294',
  ucdQtyMultiplicator: 100,
  cipLib: "ELMIRON GELU BT 100",
  atcCode: "G04BX15"
}, {
  CIP7: '5906892',
  CIP13: '3400959068927',
  ucdLib: "ELMISOL 10MG CPR",
  UCD7: '9319772',
  UCD13: '3400893197721',
  ucdQtyMultiplicator: 1,
  cipLib: "ELMISOL 10MG CPR BT 1",
  atcCode: "G04BX"
}, {
  CIP7: '5906900',
  CIP13: '3400959069009',
  ucdLib: "ELMISOL 25MG CPR",
  UCD7: '9319789',
  UCD13: '3400893197899',
  ucdQtyMultiplicator: 1,
  cipLib: "ELMISOL 25MG CPR BT 1",
  atcCode: "G04BX"
}, {
  CIP7: '5906923',
  CIP13: '3400959069238',
  ucdLib: "ELMISOL 50MG CPR",
  UCD7: '9319803',
  UCD13: '3400893198032',
  ucdQtyMultiplicator: 1,
  cipLib: "ELMISOL 50MG CPR BT 1",
  atcCode: "G04BX"
}, {
  CIP7: '5906917',
  CIP13: '3400959069177',
  ucdLib: "ELMISOL 5MG CPR",
  UCD7: '9319795',
  UCD13: '3400893197950',
  ucdQtyMultiplicator: 1,
  cipLib: "ELMISOL 5MG CPR BT 1",
  atcCode: "G04BX"
}, {
  CIP7: '3459489',
  CIP13: '3400934594892',
  ucdLib: "ELUSANES NATUDOR GELU",
  UCD7: '9201409',
  UCD13: '3400892014098',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES NATUDOR GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '5901274',
  CIP13: '3400959012746',
  ucdLib: "ENCADE 25MG GELU",
  UCD7: '9137485',
  UCD13: '3400891374858',
  ucdQtyMultiplicator: 100,
  cipLib: "ENCADE 25MG GELU BT 100",
  atcCode: "C01BC08"
}, {
  CIP7: '5906231',
  CIP13: '3400959062314',
  ucdLib: "ENLON 10MG/ML INJ FL15ML",
  UCD7: '9300063',
  UCD13: '3400893000632',
  ucdQtyMultiplicator: 1,
  cipLib: "ENLON 10MG/ML INJ FL15ML BT 1",
  atcCode: "N07AA"
}, {
  CIP7: '5906248',
  CIP13: '3400959062482',
  ucdLib: "EPANUTIN 30MG/5ML BUV FL",
  UCD7: '9300086',
  UCD13: '3400893000861',
  ucdQtyMultiplicator: 1,
  cipLib: "EPANUTIN 30MG/5ML BUV FL BT 1",
  atcCode: "N03AB02"
}, {
  CIP7: '5907785',
  CIP13: '3400959077851',
  ucdLib: "EPHEDRINE HYD WKT 15MG CPR",
  UCD7: '9355555',
  UCD13: '3400893555552',
  ucdQtyMultiplicator: 28,
  cipLib: "EPHEDRINE HYD WKT 15MG CPR BT 28",
  atcCode: "C01CA26"
}, {
  CIP7: '5902055',
  CIP13: '3400959020550',
  ucdLib: "EPRATUZUMAB 10MG/ML IMD FL",
  UCD7: '9299087',
  UCD13: '3400892990873',
  ucdQtyMultiplicator: 1,
  cipLib: "EPRATUZUMAB 10MG/ML IMD FL BT 1",
  atcCode: "L01XC"
}, {
  CIP7: '5905970',
  CIP13: '3400959059703',
  ucdLib: "ERGAMISOLE 50MG CPR",
  UCD7: '9299377',
  UCD13: '3400892993775',
  ucdQtyMultiplicator: 36,
  cipLib: "ERGAMISOLE 50MG CPR BT 36",
  atcCode: "P02CE01"
}, {
  CIP7: '5909206',
  CIP13: '3400959092069',
  ucdLib: "ESTREPTOMICINA SUL REI 1G F+F",
  UCD7: '9392473',
  UCD13: '3400893924730',
  ucdQtyMultiplicator: 1,
  cipLib: "ESTREPTOMICINA SUL REI 1G F+F BT 1",
  atcCode: "J01GA01"
}, {
  CIP7: '5908477',
  CIP13: '3400959084774',
  ucdLib: "FAV-AFRIQUE SOL INJ FL",
  UCD7: '9382687',
  UCD13: '3400893826874',
  ucdQtyMultiplicator: 1,
  cipLib: "FAV-AFRIQUE SOL INJ FL BT 1",
  atcCode: "J06AA03"
}, {
  CIP7: '5902061',
  CIP13: '3400959020611',
  ucdLib: "FERCAYL 100MG INJ AMP2ML",
  UCD7: '9298768',
  UCD13: '3400892987682',
  ucdQtyMultiplicator: 5,
  cipLib: "FERCAYL 100MG INJ AMP2ML BT 5",
  atcCode: "B03AC"
}, {
  CIP7: '5908655',
  CIP13: '3400959086556',
  ucdLib: "FLORINEF 100MCG CPR",
  UCD7: '9384203',
  UCD13: '3400893842034',
  ucdQtyMultiplicator: 100,
  cipLib: "FLORINEF 100MCG CPR BT 100",
  atcCode: "H02AA02"
}, {
  CIP7: '5906952',
  CIP13: '3400959069528',
  ucdLib: "FORODESINE 100MG MUN GELU",
  UCD7: '9320798',
  UCD13: '3400893207987',
  ucdQtyMultiplicator: 1,
  cipLib: "FORODESINE 100MG MUN GELU BT 1",
  atcCode: "L01XX"
}, {
  CIP7: '5907727',
  CIP13: '3400959077271',
  ucdLib: "FORODESINE 10MG/ML MUN INJ FL",
  UCD7: '9355130',
  UCD13: '3400893551301',
  ucdQtyMultiplicator: 1,
  cipLib: "FORODESINE 10MG/ML MUN INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5906969',
  CIP13: '3400959069696',
  ucdLib: "FORODESINE 5MG/ML MUN INJ FL",
  UCD7: '9320806',
  UCD13: '3400893208069',
  ucdQtyMultiplicator: 1,
  cipLib: "FORODESINE 5MG/ML MUN INJ FL BT 1",
  atcCode: "L01XX"
}, {
  CIP7: '5901535',
  CIP13: '3400959015358',
  ucdLib: "FOSFOCINA 4G INJ FL+AMP",
  UCD7: '9291134',
  UCD13: '3400892911342',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOCINA 4G INJ FL+AMP BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '5906975',
  CIP13: '3400959069757',
  ucdLib: "FURADANTIN 5MG/ML BUV FL",
  UCD7: '9320812',
  UCD13: '3400893208120',
  ucdQtyMultiplicator: 1,
  cipLib: "FURADANTIN 5MG/ML BUV FL BT 1",
  atcCode: "J01XE01"
}, {
  CIP7: '5907963',
  CIP13: '3400959079633',
  ucdLib: "GASTRODENOL 120MG CPR",
  UCD7: '9360421',
  UCD13: '3400893604212',
  ucdQtyMultiplicator: 1,
  cipLib: "GASTRODENOL 120MG CPR BT 1",
  atcCode: ""
}, {
  CIP7: '5909413',
  CIP13: '3400959094131',
  ucdLib: "GILURYTHMAL 50MG/10ML AMP",
  UCD7: '9397128',
  UCD13: '3400893971284',
  ucdQtyMultiplicator: 5,
  cipLib: "GILURYTHMAL 50MG/10ML AMP BT 5",
  atcCode: "C01BA05"
}, {
  CIP7: '3451312',
  CIP13: '3400934513121',
  ucdLib: "GLUCOSE 10% BSD INJ PPX1000ML",
  UCD7: '9234107',
  UCD13: '3400892341071',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% BSD INJ PPX1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5535444',
  CIP13: '3400955354444',
  ucdLib: "GLUCOSE 10% LAV INJ FV125ML",
  UCD7: '9114113',
  UCD13: '3400891141139',
  ucdQtyMultiplicator: 24,
  cipLib: "GLUCOSE 10% LAV INJ FV125ML BT 24",
  atcCode: "B05BA03"
}, {
  CIP7: '5535059',
  CIP13: '3400955350590',
  ucdLib: "GLUCOSE 30% LAV INJ FV250ML",
  UCD7: '9039535',
  UCD13: '3400890395359',
  ucdQtyMultiplicator: 12,
  cipLib: "GLUCOSE 30% LAV INJ FV250ML BT 12",
  atcCode: "B05BA03"
}, {
  CIP7: '5535042',
  CIP13: '3400955350422',
  ucdLib: "GLUCOSE 30% LAV INJ FV500ML",
  UCD7: '9116483',
  UCD13: '3400891164831',
  ucdQtyMultiplicator: 12,
  cipLib: "GLUCOSE 30% LAV INJ FV500ML BT 12",
  atcCode: "B05BA03"
}, {
  CIP7: '5908810',
  CIP13: '3400959088109',
  ucdLib: "GS 101 0,86MG/ML COLLY DOS",
  UCD7: '9385496',
  UCD13: '3400893854969',
  ucdQtyMultiplicator: 65,
  cipLib: "GS 101 0,86MG/ML COLLY DOS BT 65",
  atcCode: ""
}, {
  CIP7: '5902144',
  CIP13: '3400959021441',
  ucdLib: "HAEMATE P 1000UI INJ FL+FL",
  UCD7: '9299093',
  UCD13: '3400892990934',
  ucdQtyMultiplicator: 1,
  cipLib: "HAEMATE P 1000UI INJ FL+FL BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5909637',
  CIP13: '3400959096371',
  ucdLib: "HEPATECT CP 50UI/ML PERF FL",
  UCD7: '9402007',
  UCD13: '3400894020073',
  ucdQtyMultiplicator: 1,
  cipLib: "HEPATECT CP 50UI/ML PERF FL BT 1",
  atcCode: "J06BB04"
}, {
  CIP7: '5907733',
  CIP13: '3400959077332',
  ucdLib: "HEXALEN 50MG GELU",
  UCD7: '9355561',
  UCD13: '3400893555613',
  ucdQtyMultiplicator: 100,
  cipLib: "HEXALEN 50MG GELU BT 100",
  atcCode: "L01XX03"
}, {
  CIP7: '5902109',
  CIP13: '3400959021090',
  ucdLib: "HMN-14 IBC 5MG/3,8ML FL",
  UCD7: '9298811',
  UCD13: '3400892988115',
  ucdQtyMultiplicator: 1,
  cipLib: "HMN-14 IBC 5MG/3,8ML FL BT 1",
  atcCode: "L01"
}, {
  CIP7: '5906030',
  CIP13: '3400959060303',
  ucdLib: "HUMATIN 125MG SOL BUV FL",
  UCD7: '9299561',
  UCD13: '3400892995618',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMATIN 125MG SOL BUV FL BT 1",
  atcCode: "A07AA06"
}, {
  CIP7: '5905912',
  CIP13: '3400959059123',
  ucdLib: "HUMULIN REGULAR 500UI/ML FL",
  UCD7: '9299265',
  UCD13: '3400892992655',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMULIN REGULAR 500UI/ML FL BT 1",
  atcCode: "A10AB01"
}, {
  CIP7: '5908129',
  CIP13: '3400959081292',
  ucdLib: "IMMUSEVEN 600UI INJ FL+FL",
  UCD7: '9373665',
  UCD13: '3400893736654',
  ucdQtyMultiplicator: 1,
  cipLib: "IMMUSEVEN 600UI INJ FL+FL BT 1",
  atcCode: "B02BD05"
}, {
  CIP7: '5908483',
  CIP13: '3400959084835',
  ucdLib: "IMPAVIDO 10MG GELU",
  UCD7: '9382718',
  UCD13: '3400893827185',
  ucdQtyMultiplicator: 1,
  cipLib: "IMPAVIDO 10MG GELU BT 1",
  atcCode: ""
}, {
  CIP7: '5906047',
  CIP13: '3400959060471',
  ucdLib: "IMPAVIDO 50MG GELU",
  UCD7: '9299578',
  UCD13: '3400892995786',
  ucdQtyMultiplicator: 1,
  cipLib: "IMPAVIDO 50MG GELU BT 1",
  atcCode: ""
}, {
  CIP7: '5902032',
  CIP13: '3400959020321',
  ucdLib: "INDIUM 111+PENT1220MBQ MLK FL",
  UCD7: '9298780',
  UCD13: '3400892987804',
  ucdQtyMultiplicator: 1,
  cipLib: "INDIUM 111+PENT1220MBQ MLK FL BT 1",
  atcCode: "V09HB"
}, {
  CIP7: '5900139',
  CIP13: '3400959001399',
  ucdLib: "INDOCIN 1MG INJ AMP1ML",
  UCD7: '9162566',
  UCD13: '3400891625660',
  ucdQtyMultiplicator: 3,
  cipLib: "INDOCIN 1MG INJ AMP1ML BT 3",
  atcCode: "C01EB03"
}, {
  CIP7: '5906998',
  CIP13: '3400959069986',
  ucdLib: "INDOCIN 25MG/5ML BUV FL",
  UCD7: '9321007',
  UCD13: '3400893210079',
  ucdQtyMultiplicator: 1,
  cipLib: "INDOCIN 25MG/5ML BUV FL BT 1",
  atcCode: "C01EB03"
}, {
  CIP7: '5908879',
  CIP13: '3400959088796',
  ucdLib: "INDO-PAED 25MG/5ML BUV FL",
  UCD7: '9385987',
  UCD13: '3400893859872',
  ucdQtyMultiplicator: 1,
  cipLib: "INDO-PAED 25MG/5ML BUV FL BT 1",
  atcCode: ""
}, {
  CIP7: '5901736',
  CIP13: '3400959017369',
  ucdLib: "INFECTOFOS 2G INJ FL",
  UCD7: '9294598',
  UCD13: '3400892945989',
  ucdQtyMultiplicator: 10,
  cipLib: "INFECTOFOS 2G INJ FL BT 10",
  atcCode: "J01XX01"
}, {
  CIP7: '5902078',
  CIP13: '3400959020789',
  ucdLib: "IODE-131-S MDS PRECURS.RADIO",
  UCD7: '9298797',
  UCD13: '3400892987972',
  ucdQtyMultiplicator: 1,
  cipLib: "IODE-131-S MDS PRECURS.RADIO BT 1",
  atcCode: "V09FX03"
}, {
  CIP7: '5908968',
  CIP13: '3400959089687',
  ucdLib: "IRENAT 300MG/ML BUV GTT 40ML",
  UCD7: '9388419',
  UCD13: '3400893884195',
  ucdQtyMultiplicator: 1,
  cipLib: "IRENAT 300MG/ML BUV GTT 40ML BT 1",
  atcCode: "H03BC"
}, {
  CIP7: '5908135',
  CIP13: '3400959081353',
  ucdLib: "ISTODAX 10MG PERF FL",
  UCD7: '9374073',
  UCD13: '3400893740736',
  ucdQtyMultiplicator: 1,
  cipLib: "ISTODAX 10MG PERF FL BT 1",
  atcCode: "L01XX39"
}, {
  CIP7: '5909011',
  CIP13: '3400959090119',
  ucdLib: "IVEGAM-CMV 1G INJ AMP10ML",
  UCD7: '9373719',
  UCD13: '3400893737194',
  ucdQtyMultiplicator: 1,
  cipLib: "IVEGAM-CMV 1G INJ AMP10ML BT 1",
  atcCode: ""
}, {
  CIP7: '5907012',
  CIP13: '3400959070128',
  ucdLib: "IVEGAM-CMV 5G INJ FL50ML",
  UCD7: '9321059',
  UCD13: '3400893210598',
  ucdQtyMultiplicator: 1,
  cipLib: "IVEGAM-CMV 5G INJ FL50ML BT 1",
  atcCode: ""
}, {
  CIP7: '5907029',
  CIP13: '3400959070296',
  ucdLib: "IVOMEC PORCIN 1G INJ FL",
  UCD7: '9321065',
  UCD13: '3400893210659',
  ucdQtyMultiplicator: 1,
  cipLib: "IVOMEC PORCIN 1G INJ FL BT 1",
  atcCode: "P02CF01"
}, {
  CIP7: '5907041',
  CIP13: '3400959070418',
  ucdLib: "IXABEPILONE BMS 15MG FL+FL",
  UCD7: '9321390',
  UCD13: '3400893213902',
  ucdQtyMultiplicator: 1,
  cipLib: "IXABEPILONE BMS 15MG FL+FL BT 1",
  atcCode: "L01DC04"
}, {
  CIP7: '5906685',
  CIP13: '3400959066855',
  ucdLib: "JAPANESE ENCEPHAL. VAC FL1ML",
  UCD7: '9313060',
  UCD13: '3400893130605',
  ucdQtyMultiplicator: 1,
  cipLib: "JAPANESE ENCEPHAL. VAC FL1ML BT 1",
  atcCode: "J07BA02"
}, {
  CIP7: '5906254',
  CIP13: '3400959062543',
  ucdLib: "KEMADRINE CPR",
  UCD7: '9048787',
  UCD13: '3400890487870',
  ucdQtyMultiplicator: 1,
  cipLib: "KEMADRINE CPR BT 1",
  atcCode: "N04AA04"
}, {
  CIP7: '5532032',
  CIP13: '3400955320326',
  ucdLib: "KINUREA-H INJ AMP5ML",
  UCD7: '9049137',
  UCD13: '3400890491372',
  ucdQtyMultiplicator: 50,
  cipLib: "KINUREA-H INJ AMP5ML BT 50",
  atcCode: "C05BB"
}, {
  CIP7: '5908862',
  CIP13: '3400959088628',
  ucdLib: "KRYSTEXXA 8MG PERF FL1ML",
  UCD7: '9385935',
  UCD13: '3400893859353',
  ucdQtyMultiplicator: 1,
  cipLib: "KRYSTEXXA 8MG PERF FL1ML BT 1",
  atcCode: "M04AX02"
}, {
  CIP7: '5901699',
  CIP13: '3400959016997',
  ucdLib: "LABURIDE 200MG CPR",
  UCD7: '9294523',
  UCD13: '3400892945231',
  ucdQtyMultiplicator: 100,
  cipLib: "LABURIDE 200MG CPR BT 100",
  atcCode: "N03AX13"
}, {
  CIP7: '5908514',
  CIP13: '3400959085146',
  ucdLib: "LAMPIT 120MG CPR",
  UCD7: '9382782',
  UCD13: '3400893827826',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMPIT 120MG CPR BT 1",
  atcCode: "P01CC01"
}, {
  CIP7: '5906159',
  CIP13: '3400959061591',
  ucdLib: "L-ARGININE HYD.BAX 21% A20ML",
  UCD7: '9299822',
  UCD13: '3400892998220',
  ucdQtyMultiplicator: 10,
  cipLib: "L-ARGININE HYD.BAX 21% A20ML BT 10",
  atcCode: "B05XB01"
}, {
  CIP7: '5909152',
  CIP13: '3400959091529',
  ucdLib: "L-ARGININE HYD.BBM 21% A20ML",
  UCD7: '9392415',
  UCD13: '3400893924150',
  ucdQtyMultiplicator: 5,
  cipLib: "L-ARGININE HYD.BBM 21% A20ML BT 5",
  atcCode: "B05XB01"
}, {
  CIP7: '5909169',
  CIP13: '3400959091697',
  ucdLib: "L-ARGININE HYD.BBM 21% A20ML",
  UCD7: '9392415',
  UCD13: '3400893924150',
  ucdQtyMultiplicator: 10,
  cipLib: "L-ARGININE HYD.BBM 21% A20ML BT 10",
  atcCode: "B05XB01"
}, {
  CIP7: '5535266',
  CIP13: '3400955352662',
  ucdLib: "LAVOISIER PHYSIO PHEN. 9ML",
  UCD7: '9050123',
  UCD13: '3400890501231',
  ucdQtyMultiplicator: 50,
  cipLib: "LAVOISIER PHYSIO PHEN. 9ML BT 50",
  atcCode: "R07AX"
}, {
  CIP7: '5909376',
  CIP13: '3400959093769',
  ucdLib: "LDE 225 50MG GELU",
  UCD7: '9396301',
  UCD13: '3400893963012',
  ucdQtyMultiplicator: 1,
  cipLib: "LDE 225 50MG GELU BT 1",
  atcCode: ""
}, {
  CIP7: '5900889',
  CIP13: '3400959008893',
  ucdLib: "L-DOPS 100MG GELU",
  UCD7: '9243885',
  UCD13: '3400892438856',
  ucdQtyMultiplicator: 100,
  cipLib: "L-DOPS 100MG GELU BT 100",
  atcCode: "C01CA03"
}, {
  CIP7: '5901021',
  CIP13: '3400959010216',
  ucdLib: "L-DOPS 100MG GELU",
  UCD7: '9243885',
  UCD13: '3400892438856',
  ucdQtyMultiplicator: 500,
  cipLib: "L-DOPS 100MG GELU BT 500",
  atcCode: "C01CA03"
}, {
  CIP7: '5905875',
  CIP13: '3400959058751',
  ucdLib: "L-DOPS 200MG GELU",
  UCD7: '9299271',
  UCD13: '3400892992716',
  ucdQtyMultiplicator: 1,
  cipLib: "L-DOPS 200MG GELU BT 1",
  atcCode: "C01CA03"
}, {
  CIP7: '5901475',
  CIP13: '3400959014757',
  ucdLib: "LEGALON-SIL 350MG PDR INJ FL",
  UCD7: '9290548',
  UCD13: '3400892905488',
  ucdQtyMultiplicator: 4,
  cipLib: "LEGALON-SIL 350MG PDR INJ FL BT 4",
  atcCode: "A05BA03"
}, {
  CIP7: '3060296',
  CIP13: '3400930602966',
  ucdLib: "LEHNING GTT L.114 FL30ML",
  UCD7: '9051134',
  UCD13: '3400890511346',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT L.114 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3060304',
  CIP13: '3400930603048',
  ucdLib: "LEHNING GTT L.25 FL30ML",
  UCD7: '9051140',
  UCD13: '3400890511407',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT L.25 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3060310',
  CIP13: '3400930603109',
  ucdLib: "LEHNING GTT L.28 FL30ML",
  UCD7: '9051157',
  UCD13: '3400890511575',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT L.28 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3060327',
  CIP13: '3400930603277',
  ucdLib: "LEHNING GTT L.52 FL30ML",
  UCD7: '9051163',
  UCD13: '3400890511636',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT L.52 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3060333',
  CIP13: '3400930603338',
  ucdLib: "LEHNING GTT L.72 FL30ML",
  UCD7: '9051186',
  UCD13: '3400890511865',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT L.72 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3060356',
  CIP13: '3400930603567',
  ucdLib: "LEHNING GTT L.8 FL30ML",
  UCD7: '9051192',
  UCD13: '3400890511926',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT L.8 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5906716',
  CIP13: '3400959067166',
  ucdLib: "LEUKINE 250MCG/ML INJ FL",
  UCD7: '9313249',
  UCD13: '3400893132494',
  ucdQtyMultiplicator: 1,
  cipLib: "LEUKINE 250MCG/ML INJ FL BT 1",
  atcCode: "L03AA09"
}, {
  CIP7: '5906308',
  CIP13: '3400959063083',
  ucdLib: "LEUKINE 500MCG/ML INJ FL",
  UCD7: '9300123',
  UCD13: '3400893001233',
  ucdQtyMultiplicator: 1,
  cipLib: "LEUKINE 500MCG/ML INJ FL BT 1",
  atcCode: "L03AA09"
}, {
  CIP7: '5901481',
  CIP13: '3400959014818',
  ucdLib: "LEUKOTAC 1MG/ML INJ AMP5ML",
  UCD7: '9290643',
  UCD13: '3400892906430',
  ucdQtyMultiplicator: 5,
  cipLib: "LEUKOTAC 1MG/ML INJ AMP5ML BT 5",
  atcCode: "L04AA"
}, {
  CIP7: '5907064',
  CIP13: '3400959070647',
  ucdLib: "LIORESAL 5MG/5ML BUV FL",
  UCD7: '9321496',
  UCD13: '3400893214961',
  ucdQtyMultiplicator: 1,
  cipLib: "LIORESAL 5MG/5ML BUV FL BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '3062616',
  CIP13: '3400930626160',
  ucdLib: "LOBAMINE CYSTEINE GELU",
  UCD7: '9054747',
  UCD13: '3400890547475',
  ucdQtyMultiplicator: 60,
  cipLib: "LOBAMINE CYSTEINE GELU BT 60",
  atcCode: "D11AX"
}, {
  CIP7: '5907070',
  CIP13: '3400959070708',
  ucdLib: "LODOSYN 25MG CPR",
  UCD7: '9321757',
  UCD13: '3400893217573',
  ucdQtyMultiplicator: 1,
  cipLib: "LODOSYN 25MG CPR BT 1",
  atcCode: "N04BA"
}, {
  CIP7: '5908922',
  CIP13: '3400959089229',
  ucdLib: "LOMUSTINE MDC 40MG GELU",
  UCD7: '9386337',
  UCD13: '3400893863374',
  ucdQtyMultiplicator: 20,
  cipLib: "LOMUSTINE MDC 40MG GELU BT 20",
  atcCode: "L01AD02"
}, {
  CIP7: '5909330',
  CIP13: '3400959093301',
  ucdLib: "LORAZEPAM WWP 4MG/ML INJ FL",
  UCD7: '9395833',
  UCD13: '3400893958339',
  ucdQtyMultiplicator: 1,
  cipLib: "LORAZEPAM WWP 4MG/ML INJ FL BT 1",
  atcCode: "N05BA06"
}, {
  CIP7: '5909554',
  CIP13: '3400959095541',
  ucdLib: "LUTATHERA 7,4GBQ INJ FL",
  UCD7: '9400008',
  UCD13: '3400894000082',
  ucdQtyMultiplicator: 1,
  cipLib: "LUTATHERA 7,4GBQ INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '3064064',
  CIP13: '3400930640647',
  ucdLib: "MADECASSOL 10MG CPR",
  UCD7: '9055965',
  UCD13: '3400890559652',
  ucdQtyMultiplicator: 25,
  cipLib: "MADECASSOL 10MG CPR BT 25",
  atcCode: "C05CX"
}, {
  CIP7: '5908431',
  CIP13: '3400959084316',
  ucdLib: "MALACEF 60MG INJ FL+FL",
  UCD7: '9382598',
  UCD13: '3400893825983',
  ucdQtyMultiplicator: 1,
  cipLib: "MALACEF 60MG INJ FL+FL BT 1",
  atcCode: "P01BE03"
}, {
  CIP7: '5905881',
  CIP13: '3400959058812',
  ucdLib: "MARCOUMAR 3MG CPR SECAB",
  UCD7: '9299288',
  UCD13: '3400892992884',
  ucdQtyMultiplicator: 1,
  cipLib: "MARCOUMAR 3MG CPR SECAB BT 1",
  atcCode: "B01AA04"
}, {
  CIP7: '5908980',
  CIP13: '3400959089809',
  ucdLib: "MARIBAVIR VRP 100MG CPR",
  UCD7: '9389784',
  UCD13: '3400893897843',
  ucdQtyMultiplicator: 60,
  cipLib: "MARIBAVIR VRP 100MG CPR BT 60",
  atcCode: "J05AX10"
}, {
  CIP7: '5900895',
  CIP13: '3400959008954',
  ucdLib: "MARINOL 2,5MG CAPS",
  UCD7: '9243939',
  UCD13: '3400892439396',
  ucdQtyMultiplicator: 60,
  cipLib: "MARINOL 2,5MG CAPS BT 60",
  atcCode: "A04AD10"
}, {
  CIP7: '5902150',
  CIP13: '3400959021502',
  ucdLib: "MC 506/1 1,5MG/ML BUV FL",
  UCD7: '9299147',
  UCD13: '3400892991474',
  ucdQtyMultiplicator: 1,
  cipLib: "MC 506/1 1,5MG/ML BUV FL BT 1",
  atcCode: "L01XD04"
}, {
  CIP7: '5907093',
  CIP13: '3400959070937',
  ucdLib: "MENACTRA INJ FL",
  UCD7: '9321869',
  UCD13: '3400893218693',
  ucdQtyMultiplicator: 1,
  cipLib: "MENACTRA INJ FL BT 1",
  atcCode: "J07AH04"
}, {
  CIP7: '5908773',
  CIP13: '3400959087737',
  ucdLib: "MESTINON 60MG/5ML SIR FL",
  UCD7: '9384551',
  UCD13: '3400893845516',
  ucdQtyMultiplicator: 1,
  cipLib: "MESTINON 60MG/5ML SIR FL BT 1",
  atcCode: "N07AA02"
}, {
  CIP7: '3066933',
  CIP13: '3400930669334',
  ucdLib: "METEOXANE GELU",
  UCD7: '9058478',
  UCD13: '3400890584784',
  ucdQtyMultiplicator: 60,
  cipLib: "METEOXANE GELU BT 60",
  atcCode: "A03AX12"
}, {
  CIP7: '5907940',
  CIP13: '3400959079404',
  ucdLib: "METRELEPTIN 5MG/ML INJ FL",
  UCD7: '9360361',
  UCD13: '3400893603611',
  ucdQtyMultiplicator: 1,
  cipLib: "METRELEPTIN 5MG/ML INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5906449',
  CIP13: '3400959064493',
  ucdLib: "MIZORIBINE 50MG CPR",
  UCD7: '9300301',
  UCD13: '3400893003015',
  ucdQtyMultiplicator: 1,
  cipLib: "MIZORIBINE 50MG CPR BT 1",
  atcCode: "L04AX"
}, {
  CIP7: '5901222',
  CIP13: '3400959012227',
  ucdLib: "MNESIS 45MG CPR",
  UCD7: '9278375',
  UCD13: '3400892783758',
  ucdQtyMultiplicator: 30,
  cipLib: "MNESIS 45MG CPR BT 30",
  atcCode: "N06BX13"
}, {
  CIP7: '3069245',
  CIP13: '3400930692455',
  ucdLib: "MUTESA BUV SUSP FL200ML",
  UCD7: '9060328',
  UCD13: '3400890603287',
  ucdQtyMultiplicator: 1,
  cipLib: "MUTESA BUV SUSP FL200ML BT 1",
  atcCode: "A02AX"
}, {
  CIP7: '5906484',
  CIP13: '3400959064844',
  ucdLib: "MYOCHOLINE 10MG CPR",
  UCD7: '9300399',
  UCD13: '3400893003992',
  ucdQtyMultiplicator: 1,
  cipLib: "MYOCHOLINE 10MG CPR BT 1",
  atcCode: "N07AB02"
}, {
  CIP7: '5900926',
  CIP13: '3400959009265',
  ucdLib: "MYOCHOLINE 25MG CPR",
  UCD7: '9243891',
  UCD13: '3400892438917',
  ucdQtyMultiplicator: 50,
  cipLib: "MYOCHOLINE 25MG CPR BT 50",
  atcCode: "N07AB02"
}, {
  CIP7: '5906490',
  CIP13: '3400959064905',
  ucdLib: "MYOTONINE 25MG CPR",
  UCD7: '9300407',
  UCD13: '3400893004074',
  ucdQtyMultiplicator: 1,
  cipLib: "MYOTONINE 25MG CPR BT 1",
  atcCode: "N07AB02"
}, {
  CIP7: '5530754',
  CIP13: '3400955307549',
  ucdLib: "NALONE 0,4MG INJ AMP1ML",
  UCD7: '9171536',
  UCD13: '3400891715361',
  ucdQtyMultiplicator: 10,
  cipLib: "NALONE 0,4MG INJ AMP1ML BT 10",
  atcCode: "V03AB15"
}, {
  CIP7: '5907101',
  CIP13: '3400959071019',
  ucdLib: "NARDELZINE 15MG CPR",
  UCD7: '9321898',
  UCD13: '3400893218983',
  ucdQtyMultiplicator: 100,
  cipLib: "NARDELZINE 15MG CPR BT 100",
  atcCode: "N06AF03"
}, {
  CIP7: '5906314',
  CIP13: '3400959063144',
  ucdLib: "NARDIL 15MG CPR",
  UCD7: '9300146',
  UCD13: '3400893001462',
  ucdQtyMultiplicator: 60,
  cipLib: "NARDIL 15MG CPR BT 60",
  atcCode: "N06AF03"
}, {
  CIP7: '5901311',
  CIP13: '3400959013118',
  ucdLib: "NATACYN 5% COLLY FL15ML",
  UCD7: '9289812',
  UCD13: '3400892898124',
  ucdQtyMultiplicator: 1,
  cipLib: "NATACYN 5% COLLY FL15ML BT 1",
  atcCode: "S01AA10"
}, {
  CIP7: '5906432',
  CIP13: '3400959064325',
  ucdLib: "NATRIUMTHIOSULFAT 10% INJ FL",
  UCD7: '9300212',
  UCD13: '3400893002124',
  ucdQtyMultiplicator: 1,
  cipLib: "NATRIUMTHIOSULFAT 10% INJ FL BT 1",
  atcCode: "V03AB06"
}, {
  CIP7: '5906751',
  CIP13: '3400959067517',
  ucdLib: "NATRIUMTHIOSULFAT 25% INJ FL",
  UCD7: '9313344',
  UCD13: '3400893133446',
  ucdQtyMultiplicator: 1,
  cipLib: "NATRIUMTHIOSULFAT 25% INJ FL BT 1",
  atcCode: "V03AB06"
}, {
  CIP7: '5901570',
  CIP13: '3400959015709',
  ucdLib: "NEOSTIGMINE BROMID CBG CPR",
  UCD7: '9293535',
  UCD13: '3400892935355',
  ucdQtyMultiplicator: 140,
  cipLib: "NEOSTIGMINE BROMID CBG CPR BT 140",
  atcCode: "N07AA01"
}, {
  CIP7: '5900932',
  CIP13: '3400959009326',
  ucdLib: "NEOTON 1G PDR INJ FL60ML",
  UCD7: '9246062',
  UCD13: '3400892460628',
  ucdQtyMultiplicator: 1,
  cipLib: "NEOTON 1G PDR INJ FL60ML BT 1",
  atcCode: "C01EB06"
}, {
  CIP7: '5901860',
  CIP13: '3400959018601',
  ucdLib: "NERVIFENE 100MG/ML BUV FL125ML",
  UCD7: '9296255',
  UCD13: '3400892962559',
  ucdQtyMultiplicator: 1,
  cipLib: "NERVIFENE 100MG/ML BUV FL125ML BT 1",
  atcCode: "N05CC01"
}, {
  CIP7: '5901707',
  CIP13: '3400959017079',
  ucdLib: "NEURODOL 700MG DISP TRANS",
  UCD7: '9294575',
  UCD13: '3400892945750',
  ucdQtyMultiplicator: 5,
  cipLib: "NEURODOL 700MG DISP TRANS BT 5",
  atcCode: "N01BB02"
}, {
  CIP7: '5908164',
  CIP13: '3400959081643',
  ucdLib: "NEURONTIN 250MG/5ML FL470ML",
  UCD7: '9381050',
  UCD13: '3400893810507',
  ucdQtyMultiplicator: 1,
  cipLib: "NEURONTIN 250MG/5ML FL470ML BT 1",
  atcCode: "N03AX12"
}, {
  CIP7: '5909784',
  CIP13: '3400959097842',
  ucdLib: "NICOZID 500MG INJ FL5ML",
  UCD7: '9403998',
  UCD13: '3400894039983',
  ucdQtyMultiplicator: 5,
  cipLib: "NICOZID 500MG INJ FL5ML BT 5",
  atcCode: "J04AC01"
}, {
  CIP7: '5907905',
  CIP13: '3400959079053',
  ucdLib: "NIFEDIPINE RTP 20MG/ML FL30ML",
  UCD7: '9358789',
  UCD13: '3400893587898',
  ucdQtyMultiplicator: 1,
  cipLib: "NIFEDIPINE RTP 20MG/ML FL30ML BT 1",
  atcCode: "C08CA05"
}, {
  CIP7: '5907928',
  CIP13: '3400959079282',
  ucdLib: "NIMODIPIN HXL 30MG CPR PEL",
  UCD7: '9358795',
  UCD13: '3400893587959',
  ucdQtyMultiplicator: 1,
  cipLib: "NIMODIPIN HXL 30MG CPR PEL BT 1",
  atcCode: "C08CA06"
}, {
  CIP7: '5907118',
  CIP13: '3400959071187',
  ucdLib: "NIMOTOP 30MG GLE EFFV SACH",
  UCD7: '9321912',
  UCD13: '3400893219126',
  ucdQtyMultiplicator: 36,
  cipLib: "NIMOTOP 30MG GLE EFFV SACH BT 36",
  atcCode: "C08CA06"
}, {
  CIP7: '5908098',
  CIP13: '3400959080981',
  ucdLib: "NIZORAL 200MG CPR",
  UCD7: '9063226',
  UCD13: '3400890632263',
  ucdQtyMultiplicator: 10,
  cipLib: "NIZORAL 200MG CPR BT 10",
  atcCode: "J02AB02"
}, {
  CIP7: '5901624',
  CIP13: '3400959016249',
  ucdLib: "NOLOTIL 2G/5ML INJ AMP",
  UCD7: '9294115',
  UCD13: '3400892941158',
  ucdQtyMultiplicator: 10,
  cipLib: "NOLOTIL 2G/5ML INJ AMP BT 10",
  atcCode: "N02BB02"
}, {
  CIP7: '5530435',
  CIP13: '3400955304357',
  ucdLib: "NOOTROPYL 1G INJ AMP5ML",
  UCD7: '9063396',
  UCD13: '3400890633963',
  ucdQtyMultiplicator: 60,
  cipLib: "NOOTROPYL 1G INJ AMP5ML BT 60",
  atcCode: "N06BX03"
}, {
  CIP7: '5901831',
  CIP13: '3400959018311',
  ucdLib: "NORMIX 200MG CPR PELLIC",
  UCD7: '9295994',
  UCD13: '3400892959948',
  ucdQtyMultiplicator: 12,
  cipLib: "NORMIX 200MG CPR PELLIC BT 12",
  atcCode: "A07AA11"
}, {
  CIP7: '5909560',
  CIP13: '3400959095602',
  ucdLib: "NORMIX 2G/100ML GLE BUV FL",
  UCD7: '9400014',
  UCD13: '3400894000143',
  ucdQtyMultiplicator: 1,
  cipLib: "NORMIX 2G/100ML GLE BUV FL BT 1",
  atcCode: "A07AA11"
}, {
  CIP7: '5906320',
  CIP13: '3400959063205',
  ucdLib: "NORTRILEN 25MG CPR",
  UCD7: '9300229',
  UCD13: '3400893002292',
  ucdQtyMultiplicator: 50,
  cipLib: "NORTRILEN 25MG CPR BT 50",
  atcCode: "N06AA10"
}, {
  CIP7: '5901239',
  CIP13: '3400959012395',
  ucdLib: "NOVOTHYRAL 100 CPR",
  UCD7: '9285895',
  UCD13: '3400892858951',
  ucdQtyMultiplicator: 50,
  cipLib: "NOVOTHYRAL 100 CPR BT 50",
  atcCode: "H03AA01"
}, {
  CIP7: '5901245',
  CIP13: '3400959012456',
  ucdLib: "NOVOTHYRAL 100 CPR",
  UCD7: '9285895',
  UCD13: '3400892858951',
  ucdQtyMultiplicator: 100,
  cipLib: "NOVOTHYRAL 100 CPR BT 100",
  atcCode: "H03AA01"
}, {
  CIP7: '5909703',
  CIP13: '3400959097033',
  ucdLib: "OCTANATE 1000UI/5ML INJ F+FL",
  UCD7: '9403165',
  UCD13: '3400894031659',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTANATE 1000UI/5ML INJ F+FL BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5908974',
  CIP13: '3400959089748',
  ucdLib: "OMACETAXINE ATI 3,5MG INJ FL",
  UCD7: '9389212',
  UCD13: '3400893892121',
  ucdQtyMultiplicator: 1,
  cipLib: "OMACETAXINE ATI 3,5MG INJ FL BT 1",
  atcCode: "L01XX40"
}, {
  CIP7: '5908230',
  CIP13: '3400959082305',
  ucdLib: "OMACETAXINE ATI 5MG INJ FL",
  UCD7: '9382210',
  UCD13: '3400893822104',
  ucdQtyMultiplicator: 1,
  cipLib: "OMACETAXINE ATI 5MG INJ FL BT 1",
  atcCode: "L01XX40"
}, {
  CIP7: '5907124',
  CIP13: '3400959071248',
  ucdLib: "OMACETAXINE CRID 5MG INJ FL",
  UCD7: '9321935',
  UCD13: '3400893219355',
  ucdQtyMultiplicator: 1,
  cipLib: "OMACETAXINE CRID 5MG INJ FL BT 1",
  atcCode: "L01XX40"
}, {
  CIP7: '5902090',
  CIP13: '3400959020901',
  ucdLib: "ONTAK 300MCG/2ML PERF FL",
  UCD7: '9298834',
  UCD13: '3400892988344',
  ucdQtyMultiplicator: 1,
  cipLib: "ONTAK 300MCG/2ML PERF FL BT 1",
  atcCode: "L01XX29"
}, {
  CIP7: '5901038',
  CIP13: '3400959010384',
  ucdLib: "ONZAR 300MCG/2ML INJ FL",
  UCD7: '9244011',
  UCD13: '3400892440118',
  ucdQtyMultiplicator: 6,
  cipLib: "ONZAR 300MCG/2ML INJ FL BT 6",
  atcCode: "L01XX29"
}, {
  CIP7: '5907696',
  CIP13: '3400959076960',
  ucdLib: "OSELTAMIVIR RCH 100MG IV FL",
  UCD7: '9355147',
  UCD13: '3400893551479',
  ucdQtyMultiplicator: 1,
  cipLib: "OSELTAMIVIR RCH 100MG IV FL BT 1",
  atcCode: "J05AH02"
}, {
  CIP7: '5901593',
  CIP13: '3400959015938',
  ucdLib: "OSPOLOT 200MG CPR",
  UCD7: '9293558',
  UCD13: '3400892935584',
  ucdQtyMultiplicator: 50,
  cipLib: "OSPOLOT 200MG CPR BT 50",
  atcCode: "N03AX03"
}, {
  CIP7: '5901587',
  CIP13: '3400959015877',
  ucdLib: "OSPOLOT 50MG CPR",
  UCD7: '9293564',
  UCD13: '3400892935645',
  ucdQtyMultiplicator: 50,
  cipLib: "OSPOLOT 50MG CPR BT 50",
  atcCode: "N03AX03"
}, {
  CIP7: '5907153',
  CIP13: '3400959071538',
  ucdLib: "OXANDROLONE SPA 2,5MG CPR",
  UCD7: '9323667',
  UCD13: '3400893236673',
  ucdQtyMultiplicator: 1,
  cipLib: "OXANDROLONE SPA 2,5MG CPR BT 1",
  atcCode: "A14AA08"
}, {
  CIP7: '5909175',
  CIP13: '3400959091758',
  ucdLib: "OXANDROLONE USP 2,5MG CPR",
  UCD7: '9392421',
  UCD13: '3400893924211',
  ucdQtyMultiplicator: 1,
  cipLib: "OXANDROLONE USP 2,5MG CPR BT 1",
  atcCode: "A14AA08"
}, {
  CIP7: '5909985',
  CIP13: '3400959099853',
  ucdLib: "PALBOCICLIB PFZ 100MG GELU",
  UCD7: '9407654',
  UCD13: '3400894076544',
  ucdQtyMultiplicator: 21,
  cipLib: "PALBOCICLIB PFZ 100MG GELU BT 21",
  atcCode: "L01XE33"
}, {
  CIP7: '5909991',
  CIP13: '3400959099914',
  ucdLib: "PALBOCICLIB PFZ 125MG GELU",
  UCD7: '9407660',
  UCD13: '3400894076605',
  ucdQtyMultiplicator: 21,
  cipLib: "PALBOCICLIB PFZ 125MG GELU BT 21",
  atcCode: "L01XE33"
}, {
  CIP7: '5901848',
  CIP13: '3400959018489',
  ucdLib: "PALUTHER 80MG INJ AMP1ML",
  UCD7: '9296054',
  UCD13: '3400892960548',
  ucdQtyMultiplicator: 6,
  cipLib: "PALUTHER 80MG INJ AMP1ML BT 6",
  atcCode: "P01BE02"
}, {
  CIP7: '5902196',
  CIP13: '3400959021960',
  ucdLib: "PANITUMUMAB AMG 20MG/ML 10ML",
  UCD7: '9299182',
  UCD13: '3400892991825',
  ucdQtyMultiplicator: 1,
  cipLib: "PANITUMUMAB AMG 20MG/ML 10ML BT 1",
  atcCode: "L01XC08"
}, {
  CIP7: '5900949',
  CIP13: '3400959009494',
  ucdLib: "PARNATE 10MG CPR",
  UCD7: '9243945',
  UCD13: '3400892439457',
  ucdQtyMultiplicator: 28,
  cipLib: "PARNATE 10MG CPR BT 28",
  atcCode: "N06AF04"
}, {
  CIP7: '5909778',
  CIP13: '3400959097781',
  ucdLib: "PASIREOTIDE LAR 60MG INJ F+A",
  UCD7: '9403372',
  UCD13: '3400894033721',
  ucdQtyMultiplicator: 1,
  cipLib: "PASIREOTIDE LAR 60MG INJ F+A BT 1",
  atcCode: "H01CB05"
}, {
  CIP7: '5901216',
  CIP13: '3400959012166',
  ucdLib: "PENTAGASTRIN INJ AMP2ML",
  UCD7: '9275968',
  UCD13: '3400892759685',
  ucdQtyMultiplicator: 5,
  cipLib: "PENTAGASTRIN INJ AMP2ML BT 5",
  atcCode: "V04CG04"
}, {
  CIP7: '5907791',
  CIP13: '3400959077912',
  ucdLib: "PETINIMID 250MG GELU",
  UCD7: '9355584',
  UCD13: '3400893555842',
  ucdQtyMultiplicator: 100,
  cipLib: "PETINIMID 250MG GELU BT 100",
  atcCode: "N03AD01"
}, {
  CIP7: '5909181',
  CIP13: '3400959091819',
  ucdLib: "PETINUTIN 150MG CPR",
  UCD7: '9392438',
  UCD13: '3400893924389',
  ucdQtyMultiplicator: 1,
  cipLib: "PETINUTIN 150MG CPR BT 1",
  atcCode: ""
}, {
  CIP7: '5907176',
  CIP13: '3400959071767',
  ucdLib: "PICIBANIL 0,2KE PDR INJ FL",
  UCD7: '9323756',
  UCD13: '3400893237564',
  ucdQtyMultiplicator: 5,
  cipLib: "PICIBANIL 0,2KE PDR INJ FL BT 5",
  atcCode: "C05BB"
}, {
  CIP7: '5907911',
  CIP13: '3400959079114',
  ucdLib: "PICIBANIL 1KE PDR INJ FL",
  UCD7: '9358849',
  UCD13: '3400893588499',
  ucdQtyMultiplicator: 5,
  cipLib: "PICIBANIL 1KE PDR INJ FL BT 5",
  atcCode: ""
}, {
  CIP7: '5900079',
  CIP13: '3400959000798',
  ucdLib: "PITRESSIN 0,4MG INJ AMP1ML",
  UCD7: '9162046',
  UCD13: '3400891620467',
  ucdQtyMultiplicator: 10,
  cipLib: "PITRESSIN 0,4MG INJ AMP1ML BT 10",
  atcCode: "H01BA01"
}, {
  CIP7: '5908282',
  CIP13: '3400959082824',
  ucdLib: "PMS-ISONIAZID 10MG/ML BUV FL",
  UCD7: '9382291',
  UCD13: '3400893822913',
  ucdQtyMultiplicator: 1,
  cipLib: "PMS-ISONIAZID 10MG/ML BUV FL BT 1",
  atcCode: "J04AC01"
}, {
  CIP7: '5909436',
  CIP13: '3400959094360',
  ucdLib: "PMS-OXYBUTYNIN 1MG/ML SIR FL",
  UCD7: '9397513',
  UCD13: '3400893975138',
  ucdQtyMultiplicator: 1,
  cipLib: "PMS-OXYBUTYNIN 1MG/ML SIR FL BT 1",
  atcCode: "G04BD04"
}, {
  CIP7: '5908833',
  CIP13: '3400959088338',
  ucdLib: "PN 401 GRLS",
  UCD7: '9385823',
  UCD13: '3400893858233',
  ucdQtyMultiplicator: 1,
  cipLib: "PN 401 GRLS BT 1",
  atcCode: "V03AB"
}, {
  CIP7: '5900955',
  CIP13: '3400959009555',
  ucdLib: "POTABA 3G PDR BUV SACH",
  UCD7: '9245944',
  UCD13: '3400892459448',
  ucdQtyMultiplicator: 40,
  cipLib: "POTABA 3G PDR BUV SACH BT 40",
  atcCode: "V03"
}, {
  CIP7: '5908885',
  CIP13: '3400959088857',
  ucdLib: "POTABA 500MG GELU",
  UCD7: '9385993',
  UCD13: '3400893859933',
  ucdQtyMultiplicator: 1,
  cipLib: "POTABA 500MG GELU BT 1",
  atcCode: "V03"
}, {
  CIP7: '5536917',
  CIP13: '3400955369172',
  ucdLib: "PRAXILENE 100MG GELU",
  UCD7: '9074804',
  UCD13: '3400890748049',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAXILENE 100MG GELU BT 100",
  atcCode: "C04AX21"
}, {
  CIP7: '5907182',
  CIP13: '3400959071828',
  ucdLib: "PREDFORTE 1% COLLY SUSP FL",
  UCD7: '9323868',
  UCD13: '3400893238684',
  ucdQtyMultiplicator: 1,
  cipLib: "PREDFORTE 1% COLLY SUSP FL BT 1",
  atcCode: "S01BA04"
}, {
  CIP7: '5901713',
  CIP13: '3400959017130',
  ucdLib: "PREFOLIC 15MG CPR",
  UCD7: '9294629',
  UCD13: '3400892946290',
  ucdQtyMultiplicator: 30,
  cipLib: "PREFOLIC 15MG CPR BT 30",
  atcCode: "B03BB"
}, {
  CIP7: '5900961',
  CIP13: '3400959009616',
  ucdLib: "PRIMAQUINE 7,5MG CPR",
  UCD7: '9243968',
  UCD13: '3400892439686',
  ucdQtyMultiplicator: 100,
  cipLib: "PRIMAQUINE 7,5MG CPR BT 100",
  atcCode: "P01BA03"
}, {
  CIP7: '5901771',
  CIP13: '3400959017710',
  ucdLib: "PROGLYCEM 50MG/ML BUV FL30ML",
  UCD7: '9295528',
  UCD13: '3400892955285',
  ucdQtyMultiplicator: 1,
  cipLib: "PROGLYCEM 50MG/ML BUV FL30ML BT 1",
  atcCode: "C02DA01"
}, {
  CIP7: '5908425',
  CIP13: '3400959084255',
  ucdLib: "PROPYLTHIOURACILE NDC 50MG C",
  UCD7: '9382428',
  UCD13: '3400893824283',
  ucdQtyMultiplicator: 60,
  cipLib: "PROPYLTHIOURACILE NDC 50MG C BT 60",
  atcCode: "H03BA02"
}, {
  CIP7: '5908939',
  CIP13: '3400959089397',
  ucdLib: "PROSTIGMIN 15MG CPR",
  UCD7: '9386366',
  UCD13: '3400893863664',
  ucdQtyMultiplicator: 1,
  cipLib: "PROSTIGMIN 15MG CPR BT 1",
  atcCode: "N07AA01"
}, {
  CIP7: '5533296',
  CIP13: '3400955332961',
  ucdLib: "PROSTIGMINE 0,5MG INJ AMP1ML",
  UCD7: '9076246',
  UCD13: '3400890762465',
  ucdQtyMultiplicator: 60,
  cipLib: "PROSTIGMINE 0,5MG INJ AMP1ML BT 60",
  atcCode: "N07AA01"
}, {
  CIP7: '5901067',
  CIP13: '3400959010674',
  ucdLib: "QUINACRINE CPR 100MG",
  UCD7: '9246079',
  UCD13: '3400892460796',
  ucdQtyMultiplicator: 100,
  cipLib: "QUINACRINE CPR 100MG BT 100",
  atcCode: "P01AX05"
}, {
  CIP7: '5907839',
  CIP13: '3400959078391',
  ucdLib: "RADIOGARDASE 0,5G GELU",
  UCD7: '9355644',
  UCD13: '3400893556443',
  ucdQtyMultiplicator: 30,
  cipLib: "RADIOGARDASE 0,5G GELU BT 30",
  atcCode: ""
}, {
  CIP7: '5900292',
  CIP13: '3400959002921',
  ucdLib: "REGITINE 10MG/1ML INJ AMP",
  UCD7: '9166937',
  UCD13: '3400891669374',
  ucdQtyMultiplicator: 5,
  cipLib: "REGITINE 10MG/1ML INJ AMP BT 5",
  atcCode: "C04AB01"
}, {
  CIP7: '5900599',
  CIP13: '3400959005991',
  ucdLib: "RESCRIPTOR 200MG CPR",
  UCD7: '9219993',
  UCD13: '3400892199931',
  ucdQtyMultiplicator: 180,
  cipLib: "RESCRIPTOR 200MG CPR BT 180",
  atcCode: "J05AG02"
}, {
  CIP7: '5907265',
  CIP13: '3400959072658',
  ucdLib: "RESTASIS 0,05% COLLY DOS",
  UCD7: '9288528',
  UCD13: '3400892885285',
  ucdQtyMultiplicator: 30,
  cipLib: "RESTASIS 0,05% COLLY DOS BT 30",
  atcCode: "S01XA18"
}, {
  CIP7: '5908632',
  CIP13: '3400959086327',
  ucdLib: "RHIGF1 36MG/0,6ML INJ FL",
  UCD7: '9384031',
  UCD13: '3400893840313',
  ucdQtyMultiplicator: 1,
  cipLib: "RHIGF1 36MG/0,6ML INJ FL BT 1",
  atcCode: "H01AC05"
}, {
  CIP7: '5900978',
  CIP13: '3400959009784',
  ucdLib: "RIMSO 50 SOL INJ FL50ML",
  UCD7: '9246211',
  UCD13: '3400892462110',
  ucdQtyMultiplicator: 1,
  cipLib: "RIMSO 50 SOL INJ FL50ML BT 1",
  atcCode: "M02AX03"
}, {
  CIP7: '5535556',
  CIP13: '3400955355564',
  ucdLib: "RINGER LAC LAV FV1000ML",
  UCD7: '9114604',
  UCD13: '3400891146042',
  ucdQtyMultiplicator: 6,
  cipLib: "RINGER LAC LAV FV1000ML BT 6",
  atcCode: "B05BB01"
}, {
  CIP7: '5535579',
  CIP13: '3400955355793',
  ucdLib: "RINGER LAC LAV FV250ML",
  UCD7: '9080578',
  UCD13: '3400890805780',
  ucdQtyMultiplicator: 12,
  cipLib: "RINGER LAC LAV FV250ML BT 12",
  atcCode: "B05BB01"
}, {
  CIP7: '5535208',
  CIP13: '3400955352082',
  ucdLib: "RINGER LAV FL500ML",
  UCD7: '9114633',
  UCD13: '3400891146332',
  ucdQtyMultiplicator: 12,
  cipLib: "RINGER LAV FL500ML BT 12",
  atcCode: "B05BB01"
}, {
  CIP7: '5908856',
  CIP13: '3400959088567',
  ucdLib: "SB240563 250MG INJ FL",
  UCD7: '9385846',
  UCD13: '3400893858462',
  ucdQtyMultiplicator: 1,
  cipLib: "SB240563 250MG INJ FL BT 1",
  atcCode: "L04AC06"
}, {
  CIP7: '5901788',
  CIP13: '3400959017888',
  ucdLib: "SECRELUX 100U INJ AMP+AMP",
  UCD7: '9295557',
  UCD13: '3400892955575',
  ucdQtyMultiplicator: 1,
  cipLib: "SECRELUX 100U INJ AMP+AMP BT 1",
  atcCode: "V04CK01"
}, {
  CIP7: '5909198',
  CIP13: '3400959091987',
  ucdLib: "SEMPERA 10MG/ML INJ FL",
  UCD7: '9392444',
  UCD13: '3400893924440',
  ucdQtyMultiplicator: 1,
  cipLib: "SEMPERA 10MG/ML INJ FL BT 1",
  atcCode: "J02AC02"
}, {
  CIP7: '5909809',
  CIP13: '3400959098092',
  ucdLib: "SIGMACILLINA 1,2MUI/2,5ML SRG",
  UCD7: '9404093',
  UCD13: '3400894040934',
  ucdQtyMultiplicator: 1,
  cipLib: "SIGMACILLINA 1,2MUI/2,5ML SRG BT 1",
  atcCode: "J01CE08"
}, {
  CIP7: '5538081',
  CIP13: '3400955380818',
  ucdLib: "SODIUM 0,9% AGT FV125/50ML",
  UCD7: '9115101',
  UCD13: '3400891151015',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM 0,9% AGT FV125/50ML BT 24",
  atcCode: "B05XA03"
}, {
  CIP7: '5906509',
  CIP13: '3400959065094',
  ucdLib: "SODIUM THIOS. USP 25% INJ FL",
  UCD7: '9300442',
  UCD13: '3400893004425',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM THIOS. USP 25% INJ FL BT 1",
  atcCode: "V03AB06"
}, {
  CIP7: '5905697',
  CIP13: '3400959056979',
  ucdLib: "STALL DILUANT 4% INJ 1,8ML",
  UCD7: '9254883',
  UCD13: '3400892548838',
  ucdQtyMultiplicator: 50,
  cipLib: "STALL DILUANT 4% INJ 1,8ML BT 50",
  atcCode: ""
}, {
  CIP7: '5905705',
  CIP13: '3400959057051',
  ucdLib: "STALL GLYCERO SALIN BUV 9ML",
  UCD7: '9255411',
  UCD13: '3400892554112',
  ucdQtyMultiplicator: 5,
  cipLib: "STALL GLYCERO SALIN BUV 9ML BT 5",
  atcCode: ""
}, {
  CIP7: '5905823',
  CIP13: '3400959058232',
  ucdLib: "STALL IDR 5GRAMIN INJ FL+FL",
  UCD7: '9254989',
  UCD13: '3400892549897',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL IDR 5GRAMIN INJ FL+FL BT 1",
  atcCode: ""
}, {
  CIP7: '5905763',
  CIP13: '3400959057631',
  ucdLib: "STALL IDR ALTERNARIA INJ FL+FL",
  UCD7: '9254908',
  UCD13: '3400892549088',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL IDR ALTERNARIA INJ FL+FL BT 1",
  atcCode: ""
}, {
  CIP7: '5905800',
  CIP13: '3400959058003',
  ucdLib: "STALL IDR BOULEAU INJ FL+FL",
  UCD7: '9254914',
  UCD13: '3400892549149',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL IDR BOULEAU INJ FL+FL BT 1",
  atcCode: ""
}, {
  CIP7: '5905757',
  CIP13: '3400959057570',
  ucdLib: "STALL IDR D.PTERONYS INJ FL+FL",
  UCD7: '9254943',
  UCD13: '3400892549439',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL IDR D.PTERONYS INJ FL+FL BT 1",
  atcCode: ""
}, {
  CIP7: '5905817',
  CIP13: '3400959058171',
  ucdLib: "STALL IDR DACTYLE INJ FL+FL",
  UCD7: '9254920',
  UCD13: '3400892549200',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL IDR DACTYLE INJ FL+FL BT 1",
  atcCode: ""
}, {
  CIP7: '5905740',
  CIP13: '3400959057402',
  ucdLib: "STALL IDR DERM.FARIN INJ FL+FL",
  UCD7: '9254937',
  UCD13: '3400892549378',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL IDR DERM.FARIN INJ FL+FL BT 1",
  atcCode: ""
}, {
  CIP7: '5905786',
  CIP13: '3400959057860',
  ucdLib: "STALL IDR POIL CHAT INJ FL+FL",
  UCD7: '9254966',
  UCD13: '3400892549668',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL IDR POIL CHAT INJ FL+FL BT 1",
  atcCode: ""
}, {
  CIP7: '5905792',
  CIP13: '3400959057921',
  ucdLib: "STALL IDR POIL CHIEN INJ FL+FL",
  UCD7: '9254972',
  UCD13: '3400892549729',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL IDR POIL CHIEN INJ FL+FL BT 1",
  atcCode: ""
}, {
  CIP7: '5905674',
  CIP13: '3400959056740',
  ucdLib: "STALL PATCH 5GRAMIN POM SRG5ML",
  UCD7: '9255115',
  UCD13: '3400892551159',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH 5GRAMIN POM SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905585',
  CIP13: '3400959055859',
  ucdLib: "STALL PATCH ALTERNARIA POM 5ML",
  UCD7: '9254995',
  UCD13: '3400892549958',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH ALTERNARIA POM 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905622',
  CIP13: '3400959056221',
  ucdLib: "STALL PATCH AMBROSIA POM 5ML",
  UCD7: '9255428',
  UCD13: '3400892554280',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH AMBROSIA POM 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905639',
  CIP13: '3400959056399',
  ucdLib: "STALL PATCH ARMOISE POM SRG5ML",
  UCD7: '9255003',
  UCD13: '3400892550039',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH ARMOISE POM SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905680',
  CIP13: '3400959056801',
  ucdLib: "STALL PATCH BETULACEES POM 5ML",
  UCD7: '9255026',
  UCD13: '3400892550268',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH BETULACEES POM 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905556',
  CIP13: '3400959055569',
  ucdLib: "STALL PATCH BLATTE POM SRG5ML",
  UCD7: '9255032',
  UCD13: '3400892550329',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH BLATTE POM SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905562',
  CIP13: '3400959055620',
  ucdLib: "STALL PATCH D.FARINAE POM 5ML",
  UCD7: '9255055',
  UCD13: '3400892550558',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH D.FARINAE POM 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905579',
  CIP13: '3400959055798',
  ucdLib: "STALL PATCH D.PTERONYS POM 5ML",
  UCD7: '9255061',
  UCD13: '3400892550619',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH D.PTERONYS POM 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905645',
  CIP13: '3400959056450',
  ucdLib: "STALL PATCH DACTYLE POM SRG5ML",
  UCD7: '9255049',
  UCD13: '3400892550497',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH DACTYLE POM SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905651',
  CIP13: '3400959056511',
  ucdLib: "STALL PATCH PHLEOLE POM SRG5ML",
  UCD7: '9255078',
  UCD13: '3400892550787',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH PHLEOLE POM SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905668',
  CIP13: '3400959056689',
  ucdLib: "STALL PATCH PLANTAIN POM 5ML",
  UCD7: '9255084',
  UCD13: '3400892550848',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH PLANTAIN POM 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905591',
  CIP13: '3400959055910',
  ucdLib: "STALL PATCH POILS CHAT POM 5ML",
  UCD7: '9255090',
  UCD13: '3400892550909',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH POILS CHAT POM 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905616',
  CIP13: '3400959056160',
  ucdLib: "STALL PATCH POILS CHIEN POM5ML",
  UCD7: '9255109',
  UCD13: '3400892551098',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PATCH POILS CHIEN POM5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905390',
  CIP13: '3400959053909',
  ucdLib: "STALL POM ALCOOL LAINE SRG5ML",
  UCD7: '9255121',
  UCD13: '3400892551210',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM ALCOOL LAINE SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904462',
  CIP13: '3400959044624',
  ucdLib: "STALL POM BAUME PEROU SRG5ML",
  UCD7: '9253398',
  UCD13: '3400892533988',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM BAUME PEROU SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905467',
  CIP13: '3400959054678',
  ucdLib: "STALL POM BENZOCAINE SRG5ML",
  UCD7: '9255138',
  UCD13: '3400892551388',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM BENZOCAINE SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905496',
  CIP13: '3400959054968',
  ucdLib: "STALL POM C.M.ISOTHIAZ. SRG5ML",
  UCD7: '9255144',
  UCD13: '3400892551449',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM C.M.ISOTHIAZ. SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904479',
  CIP13: '3400959044792',
  ucdLib: "STALL POM CARBA-MIX SRG5ML",
  UCD7: '9253406',
  UCD13: '3400892534060',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM CARBA-MIX SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904433',
  CIP13: '3400959044334',
  ucdLib: "STALL POM CLIOQUINOL 5% SRG5ML",
  UCD7: '9253412',
  UCD13: '3400892534121',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM CLIOQUINOL 5% SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904485',
  CIP13: '3400959044853',
  ucdLib: "STALL POM COBALT CHLOR. SRG",
  UCD7: '9253429',
  UCD13: '3400892534299',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM COBALT CHLOR. SRG BT 1",
  atcCode: ""
}, {
  CIP7: '5904410',
  CIP13: '3400959044105',
  ucdLib: "STALL POM COLOPHANE SRG5ML",
  UCD7: '9253435',
  UCD13: '3400892534350',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM COLOPHANE SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905527',
  CIP13: '3400959055279',
  ucdLib: "STALL POM EUXYL K400 SRG5ML",
  UCD7: '9255150',
  UCD13: '3400892551500',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM EUXYL K400 SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905326',
  CIP13: '3400959053268',
  ucdLib: "STALL POM FORMALDEH AQ. SRG5ML",
  UCD7: '9255167',
  UCD13: '3400892551678',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM FORMALDEH AQ. SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905415',
  CIP13: '3400959054159',
  ucdLib: "STALL POM FRAGRANCE MIX SRG5ML",
  UCD7: '9255173',
  UCD13: '3400892551739',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM FRAGRANCE MIX SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905510',
  CIP13: '3400959055101',
  ucdLib: "STALL POM I.P.P.D. SRG5ML",
  UCD7: '9255440',
  UCD13: '3400892554402',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM I.P.P.D. SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904456',
  CIP13: '3400959044563',
  ucdLib: "STALL POM MERCAPTOBENZ. SRG5ML",
  UCD7: '9253441',
  UCD13: '3400892534411',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM MERCAPTOBENZ. SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905332',
  CIP13: '3400959053329',
  ucdLib: "STALL POM MERCAPTO-MIX SRG5ML",
  UCD7: '9255196',
  UCD13: '3400892551968',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM MERCAPTO-MIX SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905349',
  CIP13: '3400959053497',
  ucdLib: "STALL POM NEOMYCINE SUL SRG5ML",
  UCD7: '9255204',
  UCD13: '3400892552040',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM NEOMYCINE SUL SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905355',
  CIP13: '3400959053558',
  ucdLib: "STALL POM NICKEL SUL SRG5ML",
  UCD7: '9255210',
  UCD13: '3400892552101',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM NICKEL SUL SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905421',
  CIP13: '3400959054210',
  ucdLib: "STALL POM PARA-AMINODIP SRG5ML",
  UCD7: '9255227',
  UCD13: '3400892552279',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM PARA-AMINODIP SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904427',
  CIP13: '3400959044273',
  ucdLib: "STALL POM PARABENES-MIX SRG5ML",
  UCD7: '9253458',
  UCD13: '3400892534589',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM PARABENES-MIX SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905504',
  CIP13: '3400959055040',
  ucdLib: "STALL POM PARA-PHENYLEN SRG5ML",
  UCD7: '9255233',
  UCD13: '3400892552330',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM PARA-PHENYLEN SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905438',
  CIP13: '3400959054388',
  ucdLib: "STALL POM PARA-TOLUENE SRG5ML",
  UCD7: '9255256',
  UCD13: '3400892552569',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM PARA-TOLUENE SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905361',
  CIP13: '3400959053619',
  ucdLib: "STALL POM POTASSIUM DIC SRG5ML",
  UCD7: '9255262',
  UCD13: '3400892552620',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM POTASSIUM DIC SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905444',
  CIP13: '3400959054449',
  ucdLib: "STALL POM PROCAINE CHL SRG5ML",
  UCD7: '9255279',
  UCD13: '3400892552798',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM PROCAINE CHL SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905473',
  CIP13: '3400959054739',
  ucdLib: "STALL POM QUATERNIUM 15 SRG5ML",
  UCD7: '9255285',
  UCD13: '3400892552859',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM QUATERNIUM 15 SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905378',
  CIP13: '3400959053787',
  ucdLib: "STALL POM RESIN BUT.FOR SRG5ML",
  UCD7: '9255457',
  UCD13: '3400892554570',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM RESIN BUT.FOR SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904491',
  CIP13: '3400959044914',
  ucdLib: "STALL POM RESINE EPOXY SRG5ML",
  UCD7: '9253464',
  UCD13: '3400892534640',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM RESINE EPOXY SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905409',
  CIP13: '3400959054098',
  ucdLib: "STALL POM TEMOIN NEG SRG5ML",
  UCD7: '9255291',
  UCD13: '3400892552910',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM TEMOIN NEG SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905450',
  CIP13: '3400959054500',
  ucdLib: "STALL POM THIOMERSAL SRG5ML",
  UCD7: '9255316',
  UCD13: '3400892553160',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM THIOMERSAL SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905384',
  CIP13: '3400959053848',
  ucdLib: "STALL POM THIURAM MIX SRG5ML",
  UCD7: '9255322',
  UCD13: '3400892553221',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM THIURAM MIX SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905734',
  CIP13: '3400959057341',
  ucdLib: "STALL POM&SOL BATTERIE SRG5ML",
  UCD7: '9255434',
  UCD13: '3400892554341',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL POM&SOL BATTERIE SRG5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902440',
  CIP13: '3400959024404',
  ucdLib: "STALL PRICK 12GRAMIN INJ FL3ML",
  UCD7: '9251867',
  UCD13: '3400892518671',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK 12GRAMIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902457',
  CIP13: '3400959024572',
  ucdLib: "STALL PRICK 3GRAMIN INJ FL3ML",
  UCD7: '9251873',
  UCD13: '3400892518732',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK 3GRAMIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902428',
  CIP13: '3400959024282',
  ucdLib: "STALL PRICK 4CEREAL INJ FL3ML",
  UCD7: '9251896',
  UCD13: '3400892518961',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK 4CEREAL INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902434',
  CIP13: '3400959024343',
  ucdLib: "STALL PRICK 5GRAMIN INJ FL3ML",
  UCD7: '9251904',
  UCD13: '3400892519043',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK 5GRAMIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904172',
  CIP13: '3400959041722',
  ucdLib: "STALL PRICK 7CEREAL INJ FL3ML",
  UCD7: '9253688',
  UCD13: '3400892536880',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK 7CEREAL INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904031',
  CIP13: '3400959040312',
  ucdLib: "STALL PRICK ABRICOT INJ FL3ML",
  UCD7: '9253470',
  UCD13: '3400892534701',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ABRICOT INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904367',
  CIP13: '3400959043672',
  ucdLib: "STALL PRICK ACARIEN S.INJ 3ML",
  UCD7: '9253694',
  UCD13: '3400892536941',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ACARIEN S.INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904344',
  CIP13: '3400959043443',
  ucdLib: "STALL PRICK ACARUS SIRO INJ3ML",
  UCD7: '9253702',
  UCD13: '3400892537023',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ACARUS SIRO INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904775',
  CIP13: '3400959047755',
  ucdLib: "STALL PRICK AGROSTIDE INJ 3ML",
  UCD7: '9253889',
  UCD13: '3400892538891',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK AGROSTIDE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904048',
  CIP13: '3400959040480',
  ucdLib: "STALL PRICK AIL INJ FL3ML",
  UCD7: '9253487',
  UCD13: '3400892534879',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK AIL INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904255',
  CIP13: '3400959042552',
  ucdLib: "STALL PRICK ALPHA AMYL.INJ 3ML",
  UCD7: '9253837',
  UCD13: '3400892538372',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ALPHA AMYL.INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904396',
  CIP13: '3400959043962',
  ucdLib: "STALL PRICK ALTERNARIA INJ 3ML",
  UCD7: '9253719',
  UCD13: '3400892537191',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ALTERNARIA INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904054',
  CIP13: '3400959040541',
  ucdLib: "STALL PRICK AMANDE INJ FL3ML",
  UCD7: '9253493',
  UCD13: '3400892534930',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK AMANDE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904781',
  CIP13: '3400959047816',
  ucdLib: "STALL PRICK AMARANTE INJ FL3ML",
  UCD7: '9253895',
  UCD13: '3400892538952',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK AMARANTE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902279',
  CIP13: '3400959022790',
  ucdLib: "STALL PRICK AMBROISIE INJ 3ML",
  UCD7: '9251583',
  UCD13: '3400892515830',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK AMBROISIE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904060',
  CIP13: '3400959040602',
  ucdLib: "STALL PRICK ANIS INJ FL3ML",
  UCD7: '9253501',
  UCD13: '3400892535012',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ANIS INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902285',
  CIP13: '3400959022851',
  ucdLib: "STALL PRICK ARMOISE INJ FL3ML",
  UCD7: '9251608',
  UCD13: '3400892516080',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ARMOISE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903540',
  CIP13: '3400959035400',
  ucdLib: "STALL PRICK ARTICHAUT INJ 3ML",
  UCD7: '9252737',
  UCD13: '3400892527376',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ARTICHAUT INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904404',
  CIP13: '3400959044044',
  ucdLib: "STALL PRICK ASPERGILLUS INJ3ML",
  UCD7: '9253725',
  UCD13: '3400892537252',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ASPERGILLUS INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902291',
  CIP13: '3400959022912',
  ucdLib: "STALL PRICK AULNE INJ FL3ML",
  UCD7: '9251614',
  UCD13: '3400892516141',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK AULNE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904249',
  CIP13: '3400959042491',
  ucdLib: "STALL PRICK AVOCAT INJ FL3ML",
  UCD7: '9253843',
  UCD13: '3400892538433',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK AVOCAT INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904798',
  CIP13: '3400959047984',
  ucdLib: "STALL PRICK AVOINE POL. INJ3ML",
  UCD7: '9253903',
  UCD13: '3400892539034',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK AVOINE POL. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903557',
  CIP13: '3400959035578',
  ucdLib: "STALL PRICK BANANE INJ FL3ML",
  UCD7: '9252743',
  UCD13: '3400892527437',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BANANE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902463',
  CIP13: '3400959024633',
  ucdLib: "STALL PRICK BETULACEES INJ 3ML",
  UCD7: '9251620',
  UCD13: '3400892516202',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BETULACEES INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903824',
  CIP13: '3400959038241',
  ucdLib: "STALL PRICK BLANC OEUF INJ 3ML",
  UCD7: '9253062',
  UCD13: '3400892530628',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BLANC OEUF INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904278',
  CIP13: '3400959042781',
  ucdLib: "STALL PRICK BLATTE GERM INJ3ML",
  UCD7: '9253731',
  UCD13: '3400892537313',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BLATTE GERM INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903563',
  CIP13: '3400959035639',
  ucdLib: "STALL PRICK BLE ENTIER INJ 3ML",
  UCD7: '9252766',
  UCD13: '3400892527666',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BLE ENTIER INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903586',
  CIP13: '3400959035868',
  ucdLib: "STALL PRICK BLE FARINE INJ 3ML",
  UCD7: '9252772',
  UCD13: '3400892527727',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BLE FARINE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904806',
  CIP13: '3400959048066',
  ucdLib: "STALL PRICK BLE POLLEN INJ 3ML",
  UCD7: '9253926',
  UCD13: '3400892539263',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BLE POLLEN INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902233',
  CIP13: '3400959022332',
  ucdLib: "STALL PRICK BLOMIA INJ FL3ML",
  UCD7: '9251637',
  UCD13: '3400892516370',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BLOMIA INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904516',
  CIP13: '3400959045164',
  ucdLib: "STALL PRICK BOTRYT.CIN INJ 3ML",
  UCD7: '9253932',
  UCD13: '3400892539324',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BOTRYT.CIN INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902316',
  CIP13: '3400959023162',
  ucdLib: "STALL PRICK BOULEAU INJ FL3ML",
  UCD7: '9251643',
  UCD13: '3400892516431',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK BOULEAU INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903592',
  CIP13: '3400959035929',
  ucdLib: "STALL PRICK CACAHUETE INJ 3ML",
  UCD7: '9252789',
  UCD13: '3400892527895',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CACAHUETE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903600',
  CIP13: '3400959036001',
  ucdLib: "STALL PRICK CACAO INJ FL3ML",
  UCD7: '9252795',
  UCD13: '3400892527956',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CACAO INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903617',
  CIP13: '3400959036179',
  ucdLib: "STALL PRICK CAFE INJ FL3ML",
  UCD7: '9252803',
  UCD13: '3400892528038',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CAFE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904522',
  CIP13: '3400959045225',
  ucdLib: "STALL PRICK CANDID.ALB INJ 3ML",
  UCD7: '9253949',
  UCD13: '3400892539492',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CANDID.ALB INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903037',
  CIP13: '3400959030375',
  ucdLib: "STALL PRICK CANDIDA INJ FL3ML",
  UCD7: '9252341',
  UCD13: '3400892523415',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CANDIDA INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903623',
  CIP13: '3400959036230',
  ucdLib: "STALL PRICK CAROTTE INJ FL3ML",
  UCD7: '9252826',
  UCD13: '3400892528267',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CAROTTE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903646',
  CIP13: '3400959036469',
  ucdLib: "STALL PRICK CELERI RAV INJ 3ML",
  UCD7: '9252832',
  UCD13: '3400892528328',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CELERI RAV INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904545',
  CIP13: '3400959045454',
  ucdLib: "STALL PRICK CHAETOMIUM INJ 3ML",
  UCD7: '9253955',
  UCD13: '3400892539553',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CHAETOMIUM INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904686',
  CIP13: '3400959046864',
  ucdLib: "STALL PRICK CHARBON CER INJ3ML",
  UCD7: '9253961',
  UCD13: '3400892539614',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CHARBON CER INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902322',
  CIP13: '3400959023223',
  ucdLib: "STALL PRICK CHARME INJ FL3ML",
  UCD7: '9251666',
  UCD13: '3400892516660',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CHARME INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904812',
  CIP13: '3400959048127',
  ucdLib: "STALL PRICK CHATAIGNIER INJ3ML",
  UCD7: '9253978',
  UCD13: '3400892539782',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CHATAIGNIER INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904829',
  CIP13: '3400959048295',
  ucdLib: "STALL PRICK CHENE INJ FL3ML",
  UCD7: '9253984',
  UCD13: '3400892539843',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CHENE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904835',
  CIP13: '3400959048356',
  ucdLib: "STALL PRICK CHENOPODE INJ 3ML",
  UCD7: '9253990',
  UCD13: '3400892539904',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CHENOPODE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905266',
  CIP13: '3400959052667',
  ucdLib: "STALL PRICK CHENOPODIA. INJ3ML",
  UCD7: '9255339',
  UCD13: '3400892553399',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CHENOPODIA. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904841',
  CIP13: '3400959048417',
  ucdLib: "STALL PRICK CHIENDENT INJ 3ML",
  UCD7: '9254009',
  UCD13: '3400892540092',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CHIENDENT INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903652',
  CIP13: '3400959036520',
  ucdLib: "STALL PRICK CITRON INJ FL3ML",
  UCD7: '9252849',
  UCD13: '3400892528496',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CITRON INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904597',
  CIP13: '3400959045973',
  ucdLib: "STALL PRICK CLADOSPOR. INJ 3ML",
  UCD7: '9254015',
  UCD13: '3400892540153',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CLADOSPOR. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903669',
  CIP13: '3400959036698',
  ucdLib: "STALL PRICK COLIN INJ FL3ML",
  UCD7: '9252855',
  UCD13: '3400892528557',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK COLIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904858',
  CIP13: '3400959048585',
  ucdLib: "STALL PRICK COLZA INJ FL3ML",
  UCD7: '9254021',
  UCD13: '3400892540214',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK COLZA INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905303',
  CIP13: '3400959053039',
  ucdLib: "STALL PRICK COMPOSEES INJ 3ML",
  UCD7: '9255351',
  UCD13: '3400892553511',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK COMPOSEES INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903899',
  CIP13: '3400959038999',
  ucdLib: "STALL PRICK CR ORGE INJ FL3ML",
  UCD7: '9253211',
  UCD13: '3400892532110',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CR ORGE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903675',
  CIP13: '3400959036759',
  ucdLib: "STALL PRICK CRABE INJ FL3ML",
  UCD7: '9252861',
  UCD13: '3400892528618',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CRABE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903681',
  CIP13: '3400959036810',
  ucdLib: "STALL PRICK CREVETTE INJ FL3ML",
  UCD7: '9252878',
  UCD13: '3400892528786',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CREVETTE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904077',
  CIP13: '3400959040770',
  ucdLib: "STALL PRICK CUMIN INJ FL3ML",
  UCD7: '9253518',
  UCD13: '3400892535180',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CUMIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902517',
  CIP13: '3400959025173',
  ucdLib: "STALL PRICK CUPRESSACE INJ 3ML",
  UCD7: '9251672',
  UCD13: '3400892516721',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CUPRESSACE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904083',
  CIP13: '3400959040831',
  ucdLib: "STALL PRICK CURRY INJ FL3ML",
  UCD7: '9253524',
  UCD13: '3400892535241',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CURRY INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902486',
  CIP13: '3400959024862',
  ucdLib: "STALL PRICK CYNOD.DACT INJ 3ML",
  UCD7: '9251689',
  UCD13: '3400892516899',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CYNOD.DACT INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904864',
  CIP13: '3400959048646',
  ucdLib: "STALL PRICK CYPRES INJ FL3ML",
  UCD7: '9254038',
  UCD13: '3400892540382',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK CYPRES INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902227',
  CIP13: '3400959022271',
  ucdLib: "STALL PRICK D.PTERONYS INJ 3ML",
  UCD7: '9251726',
  UCD13: '3400892517261',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK D.PTERONYS INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902339',
  CIP13: '3400959023391',
  ucdLib: "STALL PRICK DACTYLE INJ FL3ML",
  UCD7: '9251695',
  UCD13: '3400892516950',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK DACTYLE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902210',
  CIP13: '3400959022103',
  ucdLib: "STALL PRICK DERM.FARIN INJ 3ML",
  UCD7: '9251703',
  UCD13: '3400892517032',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK DERM.FARIN INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904284',
  CIP13: '3400959042842',
  ucdLib: "STALL PRICK EPHESTIA INJ FL3ML",
  UCD7: '9253748',
  UCD13: '3400892537481',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK EPHESTIA INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904551',
  CIP13: '3400959045515',
  ucdLib: "STALL PRICK EPICOCCUM INJ 3ML",
  UCD7: '9254044',
  UCD13: '3400892540443',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK EPICOCCUM INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904568',
  CIP13: '3400959045683',
  ucdLib: "STALL PRICK EPIDERMOPH. INJ3ML",
  UCD7: '9254050',
  UCD13: '3400892540504',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK EPIDERMOPH. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903698',
  CIP13: '3400959036988',
  ucdLib: "STALL PRICK EPINARD INJ FL3ML",
  UCD7: '9252884',
  UCD13: '3400892528847',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK EPINARD INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904870',
  CIP13: '3400959048707',
  ucdLib: "STALL PRICK ERABLE INJ FL 3ML",
  UCD7: '9254506',
  UCD13: '3400892545066',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ERABLE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904350',
  CIP13: '3400959043504',
  ucdLib: "STALL PRICK EUROGLYPHUS INJ3ML",
  UCD7: '9253754',
  UCD13: '3400892537542',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK EUROGLYPHUS INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905237',
  CIP13: '3400959052377',
  ucdLib: "STALL PRICK FAGACEES INJ FL3ML",
  UCD7: '9254512',
  UCD13: '3400892545127',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK FAGACEES INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903988',
  CIP13: '3400959039880',
  ucdLib: "STALL PRICK FARIN.SEIGL INJ3ML",
  UCD7: '9253228',
  UCD13: '3400892532288',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK FARIN.SEIGL INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904887',
  CIP13: '3400959048875',
  ucdLib: "STALL PRICK FETUQUE INJ FL 3ML",
  UCD7: '9254529',
  UCD13: '3400892545295',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK FETUQUE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902345',
  CIP13: '3400959023452',
  ucdLib: "STALL PRICK FLOUVE INJ FL3ML",
  UCD7: '9251732',
  UCD13: '3400892517322',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK FLOUVE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903706',
  CIP13: '3400959037060',
  ucdLib: "STALL PRICK FRAISE INJ FL3ML",
  UCD7: '9252890',
  UCD13: '3400892528908',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK FRAISE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904893',
  CIP13: '3400959048936',
  ucdLib: "STALL PRICK FRENE INJ FL 3ML",
  UCD7: '9254535',
  UCD13: '3400892545356',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK FRENE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904189',
  CIP13: '3400959041890',
  ucdLib: "STALL PRICK FRUIT PASS INJ 3ML",
  UCD7: '9253530',
  UCD13: '3400892535302',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK FRUIT PASS INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904574',
  CIP13: '3400959045744',
  ucdLib: "STALL PRICK FUSARIUM INJ FL3ML",
  UCD7: '9254067',
  UCD13: '3400892540672',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK FUSARIUM INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904901',
  CIP13: '3400959049018',
  ucdLib: "STALL PRICK GENEVRIER INJ 3ML",
  UCD7: '9254541',
  UCD13: '3400892545417',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK GENEVRIER INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904338',
  CIP13: '3400959043382',
  ucdLib: "STALL PRICK GLYCIPHAG.INJ 3ML",
  UCD7: '9253760',
  UCD13: '3400892537603',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK GLYCIPHAG.INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903729',
  CIP13: '3400959037299',
  ucdLib: "STALL PRICK HARICOT V. INJ 3ML",
  UCD7: '9253079',
  UCD13: '3400892530796',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK HARICOT V. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905728',
  CIP13: '3400959057280',
  ucdLib: "STALL PRICK HCL HISTAM INJ 3ML",
  UCD7: '9255345',
  UCD13: '3400892553450',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK HCL HISTAM INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904580',
  CIP13: '3400959045805',
  ucdLib: "STALL PRICK HELMINTHOS. INJ3ML",
  UCD7: '9254073',
  UCD13: '3400892540733',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK HELMINTHOS. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904918',
  CIP13: '3400959049186',
  ucdLib: "STALL PRICK HETRE INJ FL 3ML",
  UCD7: '9254558',
  UCD13: '3400892545585',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK HETRE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904924',
  CIP13: '3400959049247',
  ucdLib: "STALL PRICK HOUBLON INJ FL 3ML",
  UCD7: '9254564',
  UCD13: '3400892545646',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK HOUBLON INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904930',
  CIP13: '3400959049308',
  ucdLib: "STALL PRICK HOULQ.LAIN. INJ3ML",
  UCD7: '9254570',
  UCD13: '3400892545707',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK HOULQ.LAIN. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903735',
  CIP13: '3400959037350',
  ucdLib: "STALL PRICK HUITRE INJ FL3ML",
  UCD7: '9253085',
  UCD13: '3400892530857',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK HUITRE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902351',
  CIP13: '3400959023513',
  ucdLib: "STALL PRICK IVRAIE INJ FL3ML",
  UCD7: '9251749',
  UCD13: '3400892517490',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK IVRAIE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903830',
  CIP13: '3400959038302',
  ucdLib: "STALL PRICK JAUNE OEUF INJ 3ML",
  UCD7: '9253091',
  UCD13: '3400892530918',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK JAUNE OEUF INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904203',
  CIP13: '3400959042033',
  ucdLib: "STALL PRICK KIWI INJ FL3ML",
  UCD7: '9253547',
  UCD13: '3400892535470',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK KIWI INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903741',
  CIP13: '3400959037411',
  ucdLib: "STALL PRICK LANGOUSTE INJ 3ML",
  UCD7: '9253116',
  UCD13: '3400892531168',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK LANGOUSTE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902523',
  CIP13: '3400959025234',
  ucdLib: "STALL PRICK LATEX INJ FL3ML",
  UCD7: '9251755',
  UCD13: '3400892517551',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK LATEX INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904108',
  CIP13: '3400959041081',
  ucdLib: "STALL PRICK LAURIER INJ FL3ML",
  UCD7: '9253553',
  UCD13: '3400892535531',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK LAURIER INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904315',
  CIP13: '3400959043153',
  ucdLib: "STALL PRICK LEPIDOG. INJ FL3ML",
  UCD7: '9253777',
  UCD13: '3400892537771',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK LEPIDOG. INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904663',
  CIP13: '3400959046635',
  ucdLib: "STALL PRICK LEVUR.MEL. INJ 3ML",
  UCD7: '9254096',
  UCD13: '3400892540962',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK LEVUR.MEL. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904947',
  CIP13: '3400959049476',
  ucdLib: "STALL PRICK LUZERNE INJ FL 3ML",
  UCD7: '9254587',
  UCD13: '3400892545875',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK LUZERNE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903758',
  CIP13: '3400959037589',
  ucdLib: "STALL PRICK MAIS GRAIN INJ 3ML",
  UCD7: '9253122',
  UCD13: '3400892531229',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MAIS GRAIN INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904953',
  CIP13: '3400959049537',
  ucdLib: "STALL PRICK MAIS POLLEN INJ3ML",
  UCD7: '9254593',
  UCD13: '3400892545936',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MAIS POLLEN INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904114',
  CIP13: '3400959041142',
  ucdLib: "STALL PRICK MALT INJ FL3ML",
  UCD7: '9253576',
  UCD13: '3400892535760',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MALT INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904195',
  CIP13: '3400959041951',
  ucdLib: "STALL PRICK MANGUE INJ FL3ML",
  UCD7: '9253582',
  UCD13: '3400892535821',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MANGUE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904976',
  CIP13: '3400959049766',
  ucdLib: "STALL PRICK MARGUERITE INJ 3ML",
  UCD7: '9254601',
  UCD13: '3400892546018',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MARGUERITE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904982',
  CIP13: '3400959049827',
  ucdLib: "STALL PRICK MARRONNIER INJ 3ML",
  UCD7: '9254618',
  UCD13: '3400892546186',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MARRONNIER INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905295',
  CIP13: '3400959052957',
  ucdLib: "STALL PRICK MEL.ARBRES INJ 3ML",
  UCD7: '9255368',
  UCD13: '3400892553689',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MEL.ARBRES INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905243',
  CIP13: '3400959052438',
  ucdLib: "STALL PRICK MEL.HERBA. INJ 3ML",
  UCD7: '9254624',
  UCD13: '3400892546247',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MEL.HERBA. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903764',
  CIP13: '3400959037640',
  ucdLib: "STALL PRICK MELON INJ FL3ML",
  UCD7: '9253139',
  UCD13: '3400892531397',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MELON INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903770',
  CIP13: '3400959037701',
  ucdLib: "STALL PRICK MERLAN INJ FL3ML",
  UCD7: '9253145',
  UCD13: '3400892531458',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MERLAN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904692',
  CIP13: '3400959046925',
  ucdLib: "STALL PRICK MERUL.LACR. INJ3ML",
  UCD7: '9254104',
  UCD13: '3400892541044',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MERUL.LACR. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904999',
  CIP13: '3400959049995',
  ucdLib: "STALL PRICK MIMOSA INJ FL 3ML",
  UCD7: '9254630',
  UCD13: '3400892546308',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MIMOSA INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904232',
  CIP13: '3400959042323',
  ucdLib: "STALL PRICK MORUE INJ FL3ML",
  UCD7: '9253599',
  UCD13: '3400892535999',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MORUE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903787',
  CIP13: '3400959037879',
  ucdLib: "STALL PRICK MOULE INJ FL3ML",
  UCD7: '9253151',
  UCD13: '3400892531519',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MOULE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904290',
  CIP13: '3400959042903',
  ucdLib: "STALL PRICK MOUSTIQUE INJ 3ML",
  UCD7: '9253783',
  UCD13: '3400892537832',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MOUSTIQUE INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905007',
  CIP13: '3400959050076',
  ucdLib: "STALL PRICK MOUT.POL. INJ 3ML",
  UCD7: '9254647',
  UCD13: '3400892546476',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MOUT.POL. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903793',
  CIP13: '3400959037930',
  ucdLib: "STALL PRICK MOUTARDE INJ FL3ML",
  UCD7: '9253168',
  UCD13: '3400892531687',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MOUTARDE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904605',
  CIP13: '3400959046055',
  ucdLib: "STALL PRICK MUCOR RACEM.INJ3ML",
  UCD7: '9254110',
  UCD13: '3400892541105',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MUCOR RACEM.INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905013',
  CIP13: '3400959050137',
  ucdLib: "STALL PRICK MUR.BLANC INJ 3ML",
  UCD7: '9254653',
  UCD13: '3400892546537',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK MUR.BLANC INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902368',
  CIP13: '3400959023681',
  ucdLib: "STALL PRICK NOISETIER INJ 3ML",
  UCD7: '9251761',
  UCD13: '3400892517612',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK NOISETIER INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903801',
  CIP13: '3400959038012',
  ucdLib: "STALL PRICK NOISETTE INJ FL3ML",
  UCD7: '9253174',
  UCD13: '3400892531748',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK NOISETTE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903818',
  CIP13: '3400959038180',
  ucdLib: "STALL PRICK NOIX INJ FL3ML",
  UCD7: '9253180',
  UCD13: '3400892531809',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK NOIX INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904120',
  CIP13: '3400959041203',
  ucdLib: "STALL PRICK NOIX MUSC. INJ 3ML",
  UCD7: '9253607',
  UCD13: '3400892536071',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK NOIX MUSC. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905036',
  CIP13: '3400959050366',
  ucdLib: "STALL PRICK NOYER INJ FL 3ML",
  UCD7: '9254676',
  UCD13: '3400892546766',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK NOYER INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903847',
  CIP13: '3400959038470',
  ucdLib: "STALL PRICK OEUF ENTIER INJ3ML",
  UCD7: '9253197',
  UCD13: '3400892531977',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK OEUF ENTIER INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903853',
  CIP13: '3400959038531',
  ucdLib: "STALL PRICK OIGNON INJ FL3ML",
  UCD7: '9253234',
  UCD13: '3400892532349',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK OIGNON INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905272',
  CIP13: '3400959052728',
  ucdLib: "STALL PRICK OLEACEES INJ FL3ML",
  UCD7: '9255374',
  UCD13: '3400892553740',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK OLEACEES INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903876',
  CIP13: '3400959038760',
  ucdLib: "STALL PRICK OLIVE INJ FL3ML",
  UCD7: '9253240',
  UCD13: '3400892532400',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK OLIVE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902374',
  CIP13: '3400959023742',
  ucdLib: "STALL PRICK OLIVIER INJ FL3ML",
  UCD7: '9251778',
  UCD13: '3400892517780',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK OLIVIER INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903882',
  CIP13: '3400959038821',
  ucdLib: "STALL PRICK ORANGE INJ FL3ML",
  UCD7: '9253257',
  UCD13: '3400892532578',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ORANGE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905042',
  CIP13: '3400959050427',
  ucdLib: "STALL PRICK ORGE POLLEN INJ3ML",
  UCD7: '9254682',
  UCD13: '3400892546827',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ORGE POLLEN INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905059',
  CIP13: '3400959050595',
  ucdLib: "STALL PRICK ORME INJ FL 3ML",
  UCD7: '9254699',
  UCD13: '3400892546995',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ORME INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905065',
  CIP13: '3400959050656',
  ucdLib: "STALL PRICK ORTIE INJ FL 3ML",
  UCD7: '9254707',
  UCD13: '3400892547077',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ORTIE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905071',
  CIP13: '3400959050717',
  ucdLib: "STALL PRICK OSEILLE INJ FL 3ML",
  UCD7: '9254713',
  UCD13: '3400892547138',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK OSEILLE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905148',
  CIP13: '3400959051486',
  ucdLib: "STALL PRICK PALM.DATT. INJ 3ML",
  UCD7: '9254736',
  UCD13: '3400892547367',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PALM.DATT. INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904137',
  CIP13: '3400959041371',
  ucdLib: "STALL PRICK PAPRIKA INJ FL3ML",
  UCD7: '9253613',
  UCD13: '3400892536132',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PAPRIKA INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902492',
  CIP13: '3400959024923',
  ucdLib: "STALL PRICK PARIET.JUD INJ 3ML",
  UCD7: '9251784',
  UCD13: '3400892517841',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PARIET.JUD INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902380',
  CIP13: '3400959023803',
  ucdLib: "STALL PRICK PARIET.OFF INJ 3ML",
  UCD7: '9251790',
  UCD13: '3400892517902',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PARIET.OFF INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902397',
  CIP13: '3400959023971',
  ucdLib: "STALL PRICK PATURIN INJ FL3ML",
  UCD7: '9251809',
  UCD13: '3400892518091',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PATURIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903907',
  CIP13: '3400959039071',
  ucdLib: "STALL PRICK PECHE INJ FL3ML",
  UCD7: '9253263',
  UCD13: '3400892532639',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PECHE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904611',
  CIP13: '3400959046116',
  ucdLib: "STALL PRICK PENICIL.MIX INJ3ML",
  UCD7: '9254127',
  UCD13: '3400892541273',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PENICIL.MIX INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905088',
  CIP13: '3400959050885',
  ucdLib: "STALL PRICK PEUPLIER INJ FL3ML",
  UCD7: '9254742',
  UCD13: '3400892547428',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PEUPLIER INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902405',
  CIP13: '3400959024053',
  ucdLib: "STALL PRICK PHLEOLE INJ FL3ML",
  UCD7: '9251815',
  UCD13: '3400892518152',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PHLEOLE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905711',
  CIP13: '3400959057112',
  ucdLib: "STALL PRICK PHOSPH COD INJ 3ML",
  UCD7: '9255380',
  UCD13: '3400892553801',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PHOSPH COD INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905094',
  CIP13: '3400959050946',
  ucdLib: "STALL PRICK PIN INJ FL 3ML",
  UCD7: '9254759',
  UCD13: '3400892547596',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PIN INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905102',
  CIP13: '3400959051028',
  ucdLib: "STALL PRICK PISSENLIT INJ 3ML",
  UCD7: '9254765',
  UCD13: '3400892547657',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PISSENLIT INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905119',
  CIP13: '3400959051196',
  ucdLib: "STALL PRICK PLANTAIN INJ FL3ML",
  UCD7: '9254771',
  UCD13: '3400892547718',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PLANTAIN INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905125',
  CIP13: '3400959051257',
  ucdLib: "STALL PRICK PLATANE INJ FL 3ML",
  UCD7: '9254788',
  UCD13: '3400892547886',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PLATANE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904700',
  CIP13: '3400959047007',
  ucdLib: "STALL PRICK PLUM.MELANG INJ3ML",
  UCD7: '9254133',
  UCD13: '3400892541334',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PLUM.MELANG INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902256',
  CIP13: '3400959022561',
  ucdLib: "STALL PRICK POIL CHAT INJ 3ML",
  UCD7: '9251821',
  UCD13: '3400892518213',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POIL CHAT INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904769',
  CIP13: '3400959047694',
  ucdLib: "STALL PRICK POIL CHEVAL INJ3ML",
  UCD7: '9254156',
  UCD13: '3400892541563',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POIL CHEVAL INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902262',
  CIP13: '3400959022622',
  ucdLib: "STALL PRICK POIL CHIEN INJ 3ML",
  UCD7: '9251838',
  UCD13: '3400892518381',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POIL CHIEN INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904717',
  CIP13: '3400959047175',
  ucdLib: "STALL PRICK POIL COBAYE INJ3ML",
  UCD7: '9254162',
  UCD13: '3400892541624',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POIL COBAYE INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904723',
  CIP13: '3400959047236',
  ucdLib: "STALL PRICK POIL HAMST. INJ3ML",
  UCD7: '9254179',
  UCD13: '3400892541792',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POIL HAMST. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904746',
  CIP13: '3400959047465',
  ucdLib: "STALL PRICK POIL LAPIN INJ 3ML",
  UCD7: '9254185',
  UCD13: '3400892541853',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POIL LAPIN INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904752',
  CIP13: '3400959047526',
  ucdLib: "STALL PRICK POIL RAT INJ FL3ML",
  UCD7: '9254191',
  UCD13: '3400892541914',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POIL RAT INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903712',
  CIP13: '3400959037121',
  ucdLib: "STALL PRICK POISSON E.D INJ3ML",
  UCD7: '9253205',
  UCD13: '3400892532059',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POISSON E.D INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904143',
  CIP13: '3400959041432',
  ucdLib: "STALL PRICK POIVRE INJ FL3ML",
  UCD7: '9253636',
  UCD13: '3400892536361',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POIVRE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903942',
  CIP13: '3400959039422',
  ucdLib: "STALL PRICK POM.TER INJ FL3ML",
  UCD7: '9253300',
  UCD13: '3400892533001',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POM.TER INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903936',
  CIP13: '3400959039361',
  ucdLib: "STALL PRICK POMME INJ FL3ML",
  UCD7: '9253292',
  UCD13: '3400892532929',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POMME INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903959',
  CIP13: '3400959039590',
  ucdLib: "STALL PRICK PORC INJ FL3ML",
  UCD7: '9253317',
  UCD13: '3400892533179',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PORC INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903965',
  CIP13: '3400959039651',
  ucdLib: "STALL PRICK POULET INJ FL3ML",
  UCD7: '9253323',
  UCD13: '3400892533230',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK POULET INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903913',
  CIP13: '3400959039132',
  ucdLib: "STALL PRICK PTS POIS INJ FL3ML",
  UCD7: '9253286',
  UCD13: '3400892532868',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PTS POIS INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904628',
  CIP13: '3400959046284',
  ucdLib: "STALL PRICK PULLUL.PUL. INJ3ML",
  UCD7: '9254216',
  UCD13: '3400892542164',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PULLUL.PUL. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904373',
  CIP13: '3400959043733',
  ucdLib: "STALL PRICK PYROGLYPHUS INJ3ML",
  UCD7: '9253808',
  UCD13: '3400892538082',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK PYROGLYPHUS INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904634',
  CIP13: '3400959046345',
  ucdLib: "STALL PRICK RHIZOPUS INJ FL3ML",
  UCD7: '9254222',
  UCD13: '3400892542225',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK RHIZOPUS INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903971',
  CIP13: '3400959039712',
  ucdLib: "STALL PRICK RIZ INJ FL3ML",
  UCD7: '9253346',
  UCD13: '3400892533469',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK RIZ INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905131',
  CIP13: '3400959051318',
  ucdLib: "STALL PRICK ROBINIER INJ 3ML",
  UCD7: '9254794',
  UCD13: '3400892547947',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK ROBINIER INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905289',
  CIP13: '3400959052896',
  ucdLib: "STALL PRICK SALICACEES INJ 3ML",
  UCD7: '9255397',
  UCD13: '3400892553979',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SALICACEES INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902500',
  CIP13: '3400959025005',
  ucdLib: "STALL PRICK SALSOL.KAL INJ 3ML",
  UCD7: '9251844',
  UCD13: '3400892518442',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SALSOL.KAL INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903994',
  CIP13: '3400959039941',
  ucdLib: "STALL PRICK SARDINE INJ FL3ML",
  UCD7: '9253352',
  UCD13: '3400892533520',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SARDINE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905154',
  CIP13: '3400959051547',
  ucdLib: "STALL PRICK SAULE INJ FL 3ML",
  UCD7: '9254802',
  UCD13: '3400892548029',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SAULE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5902411',
  CIP13: '3400959024114',
  ucdLib: "STALL PRICK SEIGL.POL INJ 3ML",
  UCD7: '9251850',
  UCD13: '3400892518503',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SEIGL.POL INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904261',
  CIP13: '3400959042613',
  ucdLib: "STALL PRICK SESAME INJ FL3ML",
  UCD7: '9253866',
  UCD13: '3400892538662',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SESAME INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904226',
  CIP13: '3400959042262',
  ucdLib: "STALL PRICK SOJA INJ FL3ML",
  UCD7: '9253642',
  UCD13: '3400892536422',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SOJA INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905160',
  CIP13: '3400959051608',
  ucdLib: "STALL PRICK SOLIDAGE INJ FL3ML",
  UCD7: '9254819',
  UCD13: '3400892548197',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SOLIDAGE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904640',
  CIP13: '3400959046406',
  ucdLib: "STALL PRICK STEMPH.BOT. INJ3ML",
  UCD7: '9254239',
  UCD13: '3400892542393',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK STEMPH.BOT. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905177',
  CIP13: '3400959051776',
  ucdLib: "STALL PRICK SUREAU INJ FL 3ML",
  UCD7: '9254825',
  UCD13: '3400892548258',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK SUREAU INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904309',
  CIP13: '3400959043092',
  ucdLib: "STALL PRICK TAON INJ FL3ML",
  UCD7: '9253814',
  UCD13: '3400892538143',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TAON INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905533',
  CIP13: '3400959055330',
  ucdLib: "STALL PRICK TEMOIN NEG INJ 3ML",
  UCD7: '9255405',
  UCD13: '3400892554051',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TEMOIN NEG INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904002',
  CIP13: '3400959040022',
  ucdLib: "STALL PRICK THE INJ FL3ML",
  UCD7: '9253369',
  UCD13: '3400892533698',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK THE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904019',
  CIP13: '3400959040190',
  ucdLib: "STALL PRICK THON INJ FL3ML",
  UCD7: '9253659',
  UCD13: '3400892536590',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK THON INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904166',
  CIP13: '3400959041661',
  ucdLib: "STALL PRICK THYM INJ FL3ML",
  UCD7: '9253665',
  UCD13: '3400892536651',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK THYM INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905183',
  CIP13: '3400959051837',
  ucdLib: "STALL PRICK TILLEUL INJ FL 3ML",
  UCD7: '9254831',
  UCD13: '3400892548319',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TILLEUL INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904025',
  CIP13: '3400959040251',
  ucdLib: "STALL PRICK TOMATE INJ FL3ML",
  UCD7: '9253671',
  UCD13: '3400892536712',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TOMATE INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905208',
  CIP13: '3400959052087',
  ucdLib: "STALL PRICK TOURNESOL INJ 3ML",
  UCD7: '9254848',
  UCD13: '3400892548487',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TOURNESOL INJ 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905214',
  CIP13: '3400959052148',
  ucdLib: "STALL PRICK TREFLE INJ FL 3ML",
  UCD7: '9254854',
  UCD13: '3400892548548',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TREFLE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904657',
  CIP13: '3400959046574',
  ucdLib: "STALL PRICK TRICHOPHYT. INJ3ML",
  UCD7: '9254245',
  UCD13: '3400892542454',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TRICHOPHYT. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904539',
  CIP13: '3400959045393',
  ucdLib: "STALL PRICK TRICHOTHEC. INJ3ML",
  UCD7: '9254251',
  UCD13: '3400892542515',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TRICHOTHEC. INJ3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5905220',
  CIP13: '3400959052209',
  ucdLib: "STALL PRICK TROENE INJ FL 3ML",
  UCD7: '9254860',
  UCD13: '3400892548609',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TROENE INJ FL 3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5904321',
  CIP13: '3400959043214',
  ucdLib: "STALL PRICK TYROPHAG.INJ FL3ML",
  UCD7: '9253820',
  UCD13: '3400892538204',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL PRICK TYROPHAG.INJ FL3ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903534',
  CIP13: '3400959035349',
  ucdLib: "STALL TEST BRON 5GRAMIN 5ML",
  UCD7: '9252967',
  UCD13: '3400892529677',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST BRON 5GRAMIN 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903511',
  CIP13: '3400959035110',
  ucdLib: "STALL TEST BRON BOULEAU 5ML",
  UCD7: '9252909',
  UCD13: '3400892529097',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST BRON BOULEAU 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903480',
  CIP13: '3400959034809',
  ucdLib: "STALL TEST BRON D.PTERONYS 5ML",
  UCD7: '9252938',
  UCD13: '3400892529387',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST BRON D.PTERONYS 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903528',
  CIP13: '3400959035288',
  ucdLib: "STALL TEST BRON DACTYLE 5ML",
  UCD7: '9252915',
  UCD13: '3400892529158',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST BRON DACTYLE 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903474',
  CIP13: '3400959034748',
  ucdLib: "STALL TEST BRON DERM.FARIN 5ML",
  UCD7: '9252921',
  UCD13: '3400892529219',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST BRON DERM.FARIN 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903497',
  CIP13: '3400959034977',
  ucdLib: "STALL TEST BRON POIL CHAT 5ML",
  UCD7: '9252944',
  UCD13: '3400892529448',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST BRON POIL CHAT 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903505',
  CIP13: '3400959035059',
  ucdLib: "STALL TEST BRON POIL CHIEN 5ML",
  UCD7: '9252950',
  UCD13: '3400892529509',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST BRON POIL CHIEN 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903468',
  CIP13: '3400959034687',
  ucdLib: "STALL TEST NAS 5GRAMIN 5ML",
  UCD7: '9253056',
  UCD13: '3400892530567',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST NAS 5GRAMIN 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903445',
  CIP13: '3400959034458',
  ucdLib: "STALL TEST NAS BOULEAU 5ML",
  UCD7: '9252973',
  UCD13: '3400892529738',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST NAS BOULEAU 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903416',
  CIP13: '3400959034168',
  ucdLib: "STALL TEST NAS D.PTERONYS 5ML",
  UCD7: '9253010',
  UCD13: '3400892530109',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST NAS D.PTERONYS 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903451',
  CIP13: '3400959034519',
  ucdLib: "STALL TEST NAS DACTYLE 5ML",
  UCD7: '9252996',
  UCD13: '3400892529967',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST NAS DACTYLE 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903391',
  CIP13: '3400959033918',
  ucdLib: "STALL TEST NAS DERM.FARIN 5ML",
  UCD7: '9253004',
  UCD13: '3400892530048',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST NAS DERM.FARIN 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903422',
  CIP13: '3400959034229',
  ucdLib: "STALL TEST NAS POIL CHAT 5ML",
  UCD7: '9253027',
  UCD13: '3400892530277',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST NAS POIL CHAT 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5903439',
  CIP13: '3400959034397',
  ucdLib: "STALL TEST NAS POIL CHIEN 5ML",
  UCD7: '9253033',
  UCD13: '3400892530338',
  ucdQtyMultiplicator: 1,
  cipLib: "STALL TEST NAS POIL CHIEN 5ML BT 1",
  atcCode: ""
}, {
  CIP7: '5906389',
  CIP13: '3400959063892',
  ucdLib: "STEMETIL 25MG CPR",
  UCD7: '9300270',
  UCD13: '3400893002704',
  ucdQtyMultiplicator: 1,
  cipLib: "STEMETIL 25MG CPR BT 1",
  atcCode: "N05AB04"
}, {
  CIP7: '5901305',
  CIP13: '3400959013057',
  ucdLib: "STEMGEN 1,5MG/ML INJ FL+FL",
  UCD7: '9289048',
  UCD13: '3400892890487',
  ucdQtyMultiplicator: 5,
  cipLib: "STEMGEN 1,5MG/ML INJ FL+FL BT 5",
  atcCode: "L03AA12"
}, {
  CIP7: '5900777',
  CIP13: '3400959007773',
  ucdLib: "STIRIPENTOL BDX 250MG BUV S.",
  UCD7: '9240674',
  UCD13: '3400892406749',
  ucdQtyMultiplicator: 50,
  cipLib: "STIRIPENTOL BDX 250MG BUV S. BT 50",
  atcCode: "N03AX17"
}, {
  CIP7: '5900754',
  CIP13: '3400959007544',
  ucdLib: "STIRIPENTOL BDX 250MG GELU",
  UCD7: '9240668',
  UCD13: '3400892406688',
  ucdQtyMultiplicator: 90,
  cipLib: "STIRIPENTOL BDX 250MG GELU BT 90",
  atcCode: "N03AX17"
}, {
  CIP7: '5900783',
  CIP13: '3400959007834',
  ucdLib: "STIRIPENTOL BDX 500MG BUV S.",
  UCD7: '9240697',
  UCD13: '3400892406978',
  ucdQtyMultiplicator: 50,
  cipLib: "STIRIPENTOL BDX 500MG BUV S. BT 50",
  atcCode: "N03AX17"
}, {
  CIP7: '5900760',
  CIP13: '3400959007605',
  ucdLib: "STIRIPENTOL BDX 500MG GELU",
  UCD7: '9240680',
  UCD13: '3400892406800',
  ucdQtyMultiplicator: 60,
  cipLib: "STIRIPENTOL BDX 500MG GELU BT 60",
  atcCode: "N03AX17"
}, {
  CIP7: '5901363',
  CIP13: '3400959013637',
  ucdLib: "STRATTERA 25MG GELU",
  UCD7: '9262457',
  UCD13: '3400892624570',
  ucdQtyMultiplicator: 28,
  cipLib: "STRATTERA 25MG GELU BT 28",
  atcCode: "N06BA09"
}, {
  CIP7: '5901386',
  CIP13: '3400959013866',
  ucdLib: "STRATTERA 40MG GELU",
  UCD7: '9262463',
  UCD13: '3400892624631',
  ucdQtyMultiplicator: 28,
  cipLib: "STRATTERA 40MG GELU BT 28",
  atcCode: "N06BA09"
}, {
  CIP7: '5901392',
  CIP13: '3400959013927',
  ucdLib: "STRATTERA 60MG GELU",
  UCD7: '9262486',
  UCD13: '3400892624860',
  ucdQtyMultiplicator: 28,
  cipLib: "STRATTERA 60MG GELU BT 28",
  atcCode: "N06BA09"
}, {
  CIP7: '5900671',
  CIP13: '3400959006714',
  ucdLib: "SUCRAID SOL BUV FL118ML",
  UCD7: '9239607',
  UCD13: '3400892396071',
  ucdQtyMultiplicator: 2,
  cipLib: "SUCRAID SOL BUV FL118ML BT 2",
  atcCode: "A16AB06"
}, {
  CIP7: '5906076',
  CIP13: '3400959060761',
  ucdLib: "SULFAMYLON 5% CUTA FL",
  UCD7: '9299590',
  UCD13: '3400892995908',
  ucdQtyMultiplicator: 1,
  cipLib: "SULFAMYLON 5% CUTA FL BT 1",
  atcCode: "D06BA03"
}, {
  CIP7: '5900984',
  CIP13: '3400959009845',
  ucdLib: "SULFAMYLON 85MG CR POT453,6G",
  UCD7: '9246091',
  UCD13: '3400892460918',
  ucdQtyMultiplicator: 1,
  cipLib: "SULFAMYLON 85MG CR POT453,6G BT 1",
  atcCode: "D06BA03"
}, {
  CIP7: '5909212',
  CIP13: '3400959092120',
  ucdLib: "SYMMETREL 50MG/5ML SIR FL",
  UCD7: '9392496',
  UCD13: '3400893924969',
  ucdQtyMultiplicator: 1,
  cipLib: "SYMMETREL 50MG/5ML SIR FL BT 1",
  atcCode: "N04BB01"
}, {
  CIP7: '5906780',
  CIP13: '3400959067807',
  ucdLib: "SYPROL 10MG/5ML BUV FL",
  UCD7: '9314088',
  UCD13: '3400893140888',
  ucdQtyMultiplicator: 1,
  cipLib: "SYPROL 10MG/5ML BUV FL BT 1",
  atcCode: "C07AA05"
}, {
  CIP7: '5909318',
  CIP13: '3400959093189',
  ucdLib: "SYPROL 50MG/5ML BUV FL",
  UCD7: '9395508',
  UCD13: '3400893955086',
  ucdQtyMultiplicator: 1,
  cipLib: "SYPROL 50MG/5ML BUV FL BT 1",
  atcCode: "C07AA05"
}, {
  CIP7: '5905898',
  CIP13: '3400959058980',
  ucdLib: "SYPROL 5MG/5ML BUV FL",
  UCD7: '9299302',
  UCD13: '3400892993027',
  ucdQtyMultiplicator: 1,
  cipLib: "SYPROL 5MG/5ML BUV FL BT 1",
  atcCode: "C07AA05"
}, {
  CIP7: '5901877',
  CIP13: '3400959018779',
  ucdLib: "TESLAC 50MG CPR",
  UCD7: '9296284',
  UCD13: '3400892962849',
  ucdQtyMultiplicator: 100,
  cipLib: "TESLAC 50MG CPR BT 100",
  atcCode: "L01"
}, {
  CIP7: '3450838',
  CIP13: '3400934508387',
  ucdLib: "TESLASCAN PERF FL50ML",
  UCD7: '9200700',
  UCD13: '3400892007007',
  ucdQtyMultiplicator: 1,
  cipLib: "TESLASCAN PERF FL50ML BT 1",
  atcCode: "V08CA05"
}, {
  CIP7: '5901073',
  CIP13: '3400959010735',
  ucdLib: "TETRAHYDROBIOP.INT 10MG CPR",
  UCD7: '9246228',
  UCD13: '3400892462288',
  ucdQtyMultiplicator: 10,
  cipLib: "TETRAHYDROBIOP.INT 10MG CPR BT 10",
  atcCode: "A16AX"
}, {
  CIP7: '5901096',
  CIP13: '3400959010964',
  ucdLib: "TETRAHYDROBIOP.INT 50MG CPR",
  UCD7: '9246234',
  UCD13: '3400892462349',
  ucdQtyMultiplicator: 10,
  cipLib: "TETRAHYDROBIOP.INT 50MG CPR BT 10",
  atcCode: "A16AX"
}, {
  CIP7: '5901794',
  CIP13: '3400959017949',
  ucdLib: "TETRAHYDROBIOP.SKS 10MG CPR",
  UCD7: '9295563',
  UCD13: '3400892955636',
  ucdQtyMultiplicator: 100,
  cipLib: "TETRAHYDROBIOP.SKS 10MG CPR BT 100",
  atcCode: "A16AX"
}, {
  CIP7: '5901802',
  CIP13: '3400959018021',
  ucdLib: "TETRAHYDROBIOP.SKS 50MG CPR",
  UCD7: '9295586',
  UCD13: '3400892955865',
  ucdQtyMultiplicator: 100,
  cipLib: "TETRAHYDROBIOP.SKS 50MG CPR BT 100",
  atcCode: "A16AX"
}, {
  CIP7: '5908141',
  CIP13: '3400959081414',
  ucdLib: "THIOPENTAL IRA 0,5G FL20ML",
  UCD7: '9376907',
  UCD13: '3400893769072',
  ucdQtyMultiplicator: 25,
  cipLib: "THIOPENTAL IRA 0,5G FL20ML BT 25",
  atcCode: "N01AF03"
}, {
  CIP7: '5908158',
  CIP13: '3400959081582',
  ucdLib: "THIOPENTAL IRA 1G FL20ML",
  UCD7: '9376913',
  UCD13: '3400893769133',
  ucdQtyMultiplicator: 25,
  cipLib: "THIOPENTAL IRA 1G FL20ML BT 25",
  atcCode: "N01AF03"
}, {
  CIP7: '5909235',
  CIP13: '3400959092359',
  ucdLib: "THIOPENTAL RTX 0,5G FL20ML",
  UCD7: '9392786',
  UCD13: '3400893927861',
  ucdQtyMultiplicator: 10,
  cipLib: "THIOPENTAL RTX 0,5G FL20ML BT 10",
  atcCode: "N01AF03"
}, {
  CIP7: '5909241',
  CIP13: '3400959092410',
  ucdLib: "THIOPENTAL RTX 1G FL20ML",
  UCD7: '9392792',
  UCD13: '3400893927922',
  ucdQtyMultiplicator: 10,
  cipLib: "THIOPENTAL RTX 1G FL20ML BT 10",
  atcCode: "N01AF03"
}, {
  CIP7: '5906515',
  CIP13: '3400959065155',
  ucdLib: "TISOPURINE ROSCH 100MG CPR",
  UCD7: '9300465',
  UCD13: '3400893004654',
  ucdQtyMultiplicator: 1,
  cipLib: "TISOPURINE ROSCH 100MG CPR BT 1",
  atcCode: "M04AA02"
}, {
  CIP7: '5909229',
  CIP13: '3400959092298',
  ucdLib: "TRANYLCYPROMINE GDP 10MG CPR",
  UCD7: '9392639',
  UCD13: '3400893926390',
  ucdQtyMultiplicator: 1,
  cipLib: "TRANYLCYPROMINE GDP 10MG CPR BT 1",
  atcCode: "N06AF04"
}, {
  CIP7: '5908827',
  CIP13: '3400959088277',
  ucdLib: "TRAVATAN Z 0,004% CY FL",
  UCD7: '9385786',
  UCD13: '3400893857861',
  ucdQtyMultiplicator: 1,
  cipLib: "TRAVATAN Z 0,004% CY FL BT 1",
  atcCode: "S01EE04"
}, {
  CIP7: '5906538',
  CIP13: '3400959065384',
  ucdLib: "TRAZOLAN 100MG CPR",
  UCD7: '9300471',
  UCD13: '3400893004715',
  ucdQtyMultiplicator: 90,
  cipLib: "TRAZOLAN 100MG CPR BT 90",
  atcCode: "N06AX05"
}, {
  CIP7: '5907957',
  CIP13: '3400959079572',
  ucdLib: "TRECATOR 250MG CPR",
  UCD7: '9094468',
  UCD13: '3400890944687',
  ucdQtyMultiplicator: 40,
  cipLib: "TRECATOR 250MG CPR BT 40",
  atcCode: "J04AD03"
}, {
  CIP7: '5907590',
  CIP13: '3400959075901',
  ucdLib: "TRH FERRING SOL INJ AMP1ML",
  UCD7: '9345404',
  UCD13: '3400893454046',
  ucdQtyMultiplicator: 1,
  cipLib: "TRH FERRING SOL INJ AMP1ML BT 1",
  atcCode: "V04CJ02"
}, {
  CIP7: '5901742',
  CIP13: '3400959017420',
  ucdLib: "TRIENTINE 300MG GELU",
  UCD7: '9295445',
  UCD13: '3400892954455',
  ucdQtyMultiplicator: 100,
  cipLib: "TRIENTINE 300MG GELU BT 100",
  atcCode: "V03"
}, {
  CIP7: '5907816',
  CIP13: '3400959078162',
  ucdLib: "TRITTICO RETARD 150MG CPR",
  UCD7: '9355590',
  UCD13: '3400893555903',
  ucdQtyMultiplicator: 60,
  cipLib: "TRITTICO RETARD 150MG CPR BT 60",
  atcCode: "N06AX05"
}, {
  CIP7: '5535639',
  CIP13: '3400955356394',
  ucdLib: "TRONOTHANE 1% GEL LOC TB30G",
  UCD7: '9095367',
  UCD13: '3400890953672',
  ucdQtyMultiplicator: 10,
  cipLib: "TRONOTHANE 1% GEL LOC TB30G BT 10",
  atcCode: "C05AD07"
}, {
  CIP7: '5908649',
  CIP13: '3400959086495',
  ucdLib: "UBICOR 50MG/10ML BUV FL+FL",
  UCD7: '9384060',
  UCD13: '3400893840603',
  ucdQtyMultiplicator: 1,
  cipLib: "UBICOR 50MG/10ML BUV FL+FL BT 1",
  atcCode: "C01EB09"
}, {
  CIP7: '5900990',
  CIP13: '3400959009906',
  ucdLib: "UBITEN 10MG CPR",
  UCD7: '9246240',
  UCD13: '3400892462400',
  ucdQtyMultiplicator: 100,
  cipLib: "UBITEN 10MG CPR BT 100",
  atcCode: "C01EB09"
}, {
  CIP7: '5908448',
  CIP13: '3400959084484',
  ucdLib: "UBITEN 50MG GELU",
  UCD7: '9382523',
  UCD13: '3400893825235',
  ucdQtyMultiplicator: 1,
  cipLib: "UBITEN 50MG GELU BT 1",
  atcCode: "C01EB09"
}, {
  CIP7: '5908454',
  CIP13: '3400959084545',
  ucdLib: "UBITEN 50MG/10ML BUV FL",
  UCD7: '9382546',
  UCD13: '3400893825464',
  ucdQtyMultiplicator: 1,
  cipLib: "UBITEN 50MG/10ML BUV FL BT 1",
  atcCode: "C01EB09"
}, {
  CIP7: '5908017',
  CIP13: '3400959080172',
  ucdLib: "UROCIT-K 10MEQ (1080MG) CPR",
  UCD7: '9371040',
  UCD13: '3400893710401',
  ucdQtyMultiplicator: 100,
  cipLib: "UROCIT-K 10MEQ (1080MG) CPR BT 100",
  atcCode: ""
}, {
  CIP7: '5908023',
  CIP13: '3400959080233',
  ucdLib: "UROCIT-K 5MEQ (540MG) CPR",
  UCD7: '9371057',
  UCD13: '3400893710579',
  ucdQtyMultiplicator: 100,
  cipLib: "UROCIT-K 5MEQ (540MG) CPR BT 100",
  atcCode: ""
}, {
  CIP7: '5905935',
  CIP13: '3400959059352',
  ucdLib: "URSOFALK 50MG/ML BUV FL",
  UCD7: '9299319',
  UCD13: '3400892993195',
  ucdQtyMultiplicator: 1,
  cipLib: "URSOFALK 50MG/ML BUV FL BT 1",
  atcCode: "A05AA02"
}, {
  CIP7: '5902138',
  CIP13: '3400959021380',
  ucdLib: "UVADEX 20MCG/ML SOL FL10ML",
  UCD7: '9298981',
  UCD13: '3400892989815',
  ucdQtyMultiplicator: 12,
  cipLib: "UVADEX 20MCG/ML SOL FL10ML BT 12",
  atcCode: "D05BA02"
}, {
  CIP7: '5909790',
  CIP13: '3400959097903',
  ucdLib: "VALCHLOR GEL CUTA TB60G",
  UCD7: '9404101',
  UCD13: '3400894041016',
  ucdQtyMultiplicator: 1,
  cipLib: "VALCHLOR GEL CUTA TB60G BT 1",
  atcCode: "L01AA05"
}, {
  CIP7: '5900659',
  CIP13: '3400959006592',
  ucdLib: "VALCYTE 450MG CPR",
  UCD7: '9231600',
  UCD13: '3400892316000',
  ucdQtyMultiplicator: 60,
  cipLib: "VALCYTE 450MG CPR BT 60",
  atcCode: "J05AB14"
}, {
  CIP7: '5906082',
  CIP13: '3400959060822',
  ucdLib: "VARITECT CP 25UI/ML INJ FL20ML",
  UCD7: '9299609',
  UCD13: '3400892996097',
  ucdQtyMultiplicator: 1,
  cipLib: "VARITECT CP 25UI/ML INJ FL20ML BT 1",
  atcCode: "J06BB03"
}, {
  CIP7: '5907851',
  CIP13: '3400959078513',
  ucdLib: "VARITECT CP 25UI/ML INJ FL50ML",
  UCD7: '9355667',
  UCD13: '3400893556672',
  ucdQtyMultiplicator: 1,
  cipLib: "VARITECT CP 25UI/ML INJ FL50ML BT 1",
  atcCode: "J06BB03"
}, {
  CIP7: '5907845',
  CIP13: '3400959078452',
  ucdLib: "VARITECT CP 25UI/ML INJ FL5ML",
  UCD7: '9355650',
  UCD13: '3400893556504',
  ucdQtyMultiplicator: 1,
  cipLib: "VARITECT CP 25UI/ML INJ FL5ML BT 1",
  atcCode: "J06BB03"
}, {
  CIP7: '3060988',
  CIP13: '3400930609880',
  ucdLib: "VEGETAL TONIQ.LEHN. ELIX 250ML",
  UCD7: '9097981',
  UCD13: '3400890979818',
  ucdQtyMultiplicator: 1,
  cipLib: "VEGETAL TONIQ.LEHN. ELIX 250ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5905987',
  CIP13: '3400959059871',
  ucdLib: "VERMOX 500MG CPR",
  UCD7: '9299437',
  UCD13: '3400892994376',
  ucdQtyMultiplicator: 1,
  cipLib: "VERMOX 500MG CPR BT 1",
  atcCode: "P02CA01"
}, {
  CIP7: '5901328',
  CIP13: '3400959013286',
  ucdLib: "VIGAMOX 0,5% COLLY FL5ML",
  UCD7: '9289829',
  UCD13: '3400892898292',
  ucdQtyMultiplicator: 1,
  cipLib: "VIGAMOX 0,5% COLLY FL5ML BT 1",
  atcCode: "S01AE07"
}, {
  CIP7: '5909761',
  CIP13: '3400959097613',
  ucdLib: "VINTAFOLIDE EEB 2,5MG INJ FL",
  UCD7: '9403202',
  UCD13: '3400894032021',
  ucdQtyMultiplicator: 1,
  cipLib: "VINTAFOLIDE EEB 2,5MG INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5900323',
  CIP13: '3400959003232',
  ucdLib: "VIRAZOLE 100MG/ML PERF FL12ML",
  UCD7: '9172470',
  UCD13: '3400891724707',
  ucdQtyMultiplicator: 5,
  cipLib: "VIRAZOLE 100MG/ML PERF FL12ML BT 5",
  atcCode: "J05AB04"
}, {
  CIP7: '5900317',
  CIP13: '3400959003171',
  ucdLib: "VIRAZOLE INHAL AERO 100ML",
  UCD7: '9172487',
  UCD13: '3400891724875',
  ucdQtyMultiplicator: 3,
  cipLib: "VIRAZOLE INHAL AERO 100ML BT 3",
  atcCode: "J05AB04"
}, {
  CIP7: '5901601',
  CIP13: '3400959016010',
  ucdLib: "VIT E CBG 100MG/ML BUV FL100ML",
  UCD7: '9293570',
  UCD13: '3400892935706',
  ucdQtyMultiplicator: 1,
  cipLib: "VIT E CBG 100MG/ML BUV FL100ML BT 1",
  atcCode: "A11HA03"
}, {
  CIP7: '5906165',
  CIP13: '3400959061652',
  ucdLib: "VITARUBIN DEPOT 1000MCG FL",
  UCD7: '9299940',
  UCD13: '3400892999401',
  ucdQtyMultiplicator: 1,
  cipLib: "VITARUBIN DEPOT 1000MCG FL BT 1",
  atcCode: "B03BA03"
}, {
  CIP7: '5905852',
  CIP13: '3400959058522',
  ucdLib: "VORAXAZE 1000UI PERF FL",
  UCD7: '9299213',
  UCD13: '3400892992136',
  ucdQtyMultiplicator: 1,
  cipLib: "VORAXAZE 1000UI PERF FL BT 1",
  atcCode: "V03AF09"
}, {
  CIP7: '5908891',
  CIP13: '3400959088918',
  ucdLib: "VYVANSE 30MG GELU",
  UCD7: '9386024',
  UCD13: '3400893860243',
  ucdQtyMultiplicator: 1,
  cipLib: "VYVANSE 30MG GELU BT 1",
  atcCode: "N06BA12"
}, {
  CIP7: '5909577',
  CIP13: '3400959095770',
  ucdLib: "WARFARIN SODIUM 1MG/ML BUV FL",
  UCD7: '9400072',
  UCD13: '3400894000723',
  ucdQtyMultiplicator: 1,
  cipLib: "WARFARIN SODIUM 1MG/ML BUV FL BT 1",
  atcCode: "B01AA03"
}, {
  CIP7: '5907762',
  CIP13: '3400959077622',
  ucdLib: "XENBILOX 250MG GELU",
  UCD7: '9355621',
  UCD13: '3400893556214',
  ucdQtyMultiplicator: 100,
  cipLib: "XENBILOX 250MG GELU BT 100",
  atcCode: "A05AA01"
}, {
  CIP7: '5907710',
  CIP13: '3400959077103',
  ucdLib: "ZANAMIVIR 10MG/ML GSK FL20ML",
  UCD7: '9355176',
  UCD13: '3400893551769',
  ucdQtyMultiplicator: 1,
  cipLib: "ZANAMIVIR 10MG/ML GSK FL20ML BT 1",
  atcCode: "J05AH01"
}, {
  CIP7: '5905869',
  CIP13: '3400959058690',
  ucdLib: "ZARNESTRA 100MG CPR",
  UCD7: '9299236',
  UCD13: '3400892992365',
  ucdQtyMultiplicator: 1,
  cipLib: "ZARNESTRA 100MG CPR BT 1",
  atcCode: "L01XX"
}, {
  CIP7: '5907868',
  CIP13: '3400959078681',
  ucdLib: "ZELDOX 20MG GELU",
  UCD7: '9355762',
  UCD13: '3400893557624',
  ucdQtyMultiplicator: 30,
  cipLib: "ZELDOX 20MG GELU BT 30",
  atcCode: "N05AE04"
}, {
  CIP7: '5907874',
  CIP13: '3400959078742',
  ucdLib: "ZELDOX 40MG GELU",
  UCD7: '9355779',
  UCD13: '3400893557792',
  ucdQtyMultiplicator: 30,
  cipLib: "ZELDOX 40MG GELU BT 30",
  atcCode: "N05AE04"
}, {
  CIP7: '5906395',
  CIP13: '3400959063953',
  ucdLib: "ZELDOX 60MG GELU",
  UCD7: '9300287',
  UCD13: '3400893002872',
  ucdQtyMultiplicator: 30,
  cipLib: "ZELDOX 60MG GELU BT 30",
  atcCode: "N05AE04"
}, {
  CIP7: '5908537',
  CIP13: '3400959085375',
  ucdLib: "ZITHROMAX 500MG PERF FL",
  UCD7: '9383480',
  UCD13: '3400893834800',
  ucdQtyMultiplicator: 1,
  cipLib: "ZITHROMAX 500MG PERF FL BT 1",
  atcCode: "J01FA10"
}, {
  CIP7: '5906550',
  CIP13: '3400959065506',
  ucdLib: "ZOLINZA 100MG GELU",
  UCD7: '9301246',
  UCD13: '3400893012468',
  ucdQtyMultiplicator: 120,
  cipLib: "ZOLINZA 100MG GELU BT 120",
  atcCode: "L01XX38"
}, {
  CIP7: '5901914',
  CIP13: '3400959019141',
  ucdLib: "ZOSTRIX 0,025% CR TB56,6G",
  UCD7: '9297013',
  UCD13: '3400892970134',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOSTRIX 0,025% CR TB56,6G BT 1",
  atcCode: "M02AB01"
}, {
  CIP7: '5901920',
  CIP13: '3400959019202',
  ucdLib: "ZOSTRIX HP 0,075% CR TB56,6G",
  UCD7: '9297007',
  UCD13: '3400892970073',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOSTRIX HP 0,075% CR TB56,6G BT 1",
  atcCode: "M02AB01"
}, {
  CIP7: '5905906',
  CIP13: '3400959059062',
  ucdLib: "ZYFLO 600MG CPR PELLIC",
  UCD7: '9299325',
  UCD13: '3400892993256',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYFLO 600MG CPR PELLIC BT 1",
  atcCode: ""
}, {
  CIP7: '5908359',
  CIP13: '3400959083593',
  ucdLib: "ZYFLO CR 600MG CPR LP",
  UCD7: '9382397',
  UCD13: '3400893823972',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYFLO CR 600MG CPR LP BT 1",
  atcCode: ""
}, {
  CIP7: '3830819',
  CIP13: '3400938308198',
  ucdLib: "ALKONATREM 150MG GELU",
  UCD7: '9316880',
  UCD13: '3400893168806',
  ucdQtyMultiplicator: 100,
  cipLib: "ALKONATREM 150MG GELU BT 100",
  atcCode: "J01AA01"
}, {
  CIP7: '3835716',
  CIP13: '3400938357165',
  ucdLib: "AMLODIPINE ALT 5MG GELU",
  UCD7: '9311701',
  UCD13: '3400893117019',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ALT 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3835722',
  CIP13: '3400938357226',
  ucdLib: "AMLODIPINE ALT 5MG GELU",
  UCD7: '9311701',
  UCD13: '3400893117019',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ALT 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '5546519',
  CIP13: '3400955465195',
  ucdLib: "COMPENSAL 11G10 INJ FL1000ML",
  UCD7: '9112166',
  UCD13: '3400891121667',
  ucdQtyMultiplicator: 6,
  cipLib: "COMPENSAL 11G10 INJ FL1000ML BT 6",
  atcCode: "B05BB02"
}, {
  CIP7: '3831552',
  CIP13: '3400938315523',
  ucdLib: "EAU P.P.I FRF.FP250ML",
  UCD7: '9308455',
  UCD13: '3400893084557',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I FRF.FP250ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3831598',
  CIP13: '3400938315981',
  ucdLib: "EAU P.P.I FRF.FP500ML",
  UCD7: '9308461',
  UCD13: '3400893084618',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I FRF.FP500ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3832161',
  CIP13: '3400938321616',
  ucdLib: "GLUCOSE 10% FKF INJ FP1000ML",
  UCD7: '9308283',
  UCD13: '3400893082836',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% FKF INJ FP1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3832089',
  CIP13: '3400938320893',
  ucdLib: "GLUCOSE 10% FKF INJ FP250ML",
  UCD7: '9308308',
  UCD13: '3400893083086',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% FKF INJ FP250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3832132',
  CIP13: '3400938321326',
  ucdLib: "GLUCOSE 10% FKF INJ FP500ML",
  UCD7: '9308314',
  UCD13: '3400893083147',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% FKF INJ FP500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3050346',
  CIP13: '3400930503461',
  ucdLib: "HOMEOGENE 9 CPR",
  UCD7: '9044329',
  UCD13: '3400890443296',
  ucdQtyMultiplicator: 60,
  cipLib: "HOMEOGENE 9 CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3050381',
  CIP13: '3400930503812',
  ucdLib: "HOMEOPLASMINE POM TB18G",
  UCD7: '9044341',
  UCD13: '3400890443418',
  ucdQtyMultiplicator: 1,
  cipLib: "HOMEOPLASMINE POM TB18G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3050375',
  CIP13: '3400930503751',
  ucdLib: "HOMEOPLASMINE POM TB40G",
  UCD7: '9112835',
  UCD13: '3400891128352',
  ucdQtyMultiplicator: 1,
  cipLib: "HOMEOPLASMINE POM TB40G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3050429',
  CIP13: '3400930504291',
  ucdLib: "HOMEOVOX CPR",
  UCD7: '9044370',
  UCD13: '3400890443708',
  ucdQtyMultiplicator: 60,
  cipLib: "HOMEOVOX CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3052658',
  CIP13: '3400930526583',
  ucdLib: "INFLUDO BUV GTT FL30ML",
  UCD7: '9046297',
  UCD13: '3400890462976',
  ucdQtyMultiplicator: 1,
  cipLib: "INFLUDO BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3054976',
  CIP13: '3400930549766',
  ucdLib: "JOUVENCE ABBE SOURY FV210ML",
  UCD7: '9048161',
  UCD13: '3400890481618',
  ucdQtyMultiplicator: 1,
  cipLib: "JOUVENCE ABBE SOURY FV210ML BT 1",
  atcCode: "C05CX"
}, {
  CIP7: '3056171',
  CIP13: '3400930561713',
  ucdLib: "KINUREA-H INJ AMP5ML",
  UCD7: '9049137',
  UCD13: '3400890491372',
  ucdQtyMultiplicator: 6,
  cipLib: "KINUREA-H INJ AMP5ML BT 6",
  atcCode: "C05BB"
}, {
  CIP7: '3059169',
  CIP13: '3400930591697',
  ucdLib: "LEHNING CPR N100",
  UCD7: '9051619',
  UCD13: '3400890516198',
  ucdQtyMultiplicator: 60,
  cipLib: "LEHNING CPR N100 BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3059181',
  CIP13: '3400930591819',
  ucdLib: "LEHNING CPR N11",
  UCD7: '9051720',
  UCD13: '3400890517201',
  ucdQtyMultiplicator: 60,
  cipLib: "LEHNING CPR N11 BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3059229',
  CIP13: '3400930592298',
  ucdLib: "LEHNING CPR N12",
  UCD7: '9051861',
  UCD13: '3400890518611',
  ucdQtyMultiplicator: 60,
  cipLib: "LEHNING CPR N12 BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3059235',
  CIP13: '3400930592359',
  ucdLib: "LEHNING CPR N20",
  UCD7: '9051950',
  UCD13: '3400890519502',
  ucdQtyMultiplicator: 60,
  cipLib: "LEHNING CPR N20 BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3059258',
  CIP13: '3400930592588',
  ucdLib: "LEHNING CPR N29",
  UCD7: '9052027',
  UCD13: '3400890520270',
  ucdQtyMultiplicator: 60,
  cipLib: "LEHNING CPR N29 BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3059270',
  CIP13: '3400930592700',
  ucdLib: "LEHNING CPR N39",
  UCD7: '9052151',
  UCD13: '3400890521512',
  ucdQtyMultiplicator: 60,
  cipLib: "LEHNING CPR N39 BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3059353',
  CIP13: '3400930593530',
  ucdLib: "LEHNING CPR N99",
  UCD7: '9052808',
  UCD13: '3400890528085',
  ucdQtyMultiplicator: 60,
  cipLib: "LEHNING CPR N99 BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3059560',
  CIP13: '3400930595602',
  ucdLib: "LEHNING CRATAEGUS N15 FV30ML",
  UCD7: '9051890',
  UCD13: '3400890518901',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING CRATAEGUS N15 FV30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5549564',
  CIP13: '3400955495642',
  ucdLib: "OSMOTAN G10% INJ FV1000ML",
  UCD7: '9129511',
  UCD13: '3400891295115',
  ucdQtyMultiplicator: 6,
  cipLib: "OSMOTAN G10% INJ FV1000ML BT 6",
  atcCode: "B05BB02"
}, {
  CIP7: '5549558',
  CIP13: '3400955495581',
  ucdLib: "OSMOTAN G10% INJ FV500ML",
  UCD7: '9129528',
  UCD13: '3400891295283',
  ucdQtyMultiplicator: 12,
  cipLib: "OSMOTAN G10% INJ FV500ML BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '5549825',
  CIP13: '3400955498254',
  ucdLib: "OSMOTAN G5% INJ FV1000ML",
  UCD7: '9129563',
  UCD13: '3400891295634',
  ucdQtyMultiplicator: 6,
  cipLib: "OSMOTAN G5% INJ FV1000ML BT 6",
  atcCode: "B05BB02"
}, {
  CIP7: '5549819',
  CIP13: '3400955498193',
  ucdLib: "OSMOTAN G5% INJ FV500ML",
  UCD7: '9129586',
  UCD13: '3400891295863',
  ucdQtyMultiplicator: 12,
  cipLib: "OSMOTAN G5% INJ FV500ML BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '3080117',
  CIP13: '3400930801178',
  ucdLib: "PASTISEROL PATE SUCER",
  UCD7: '9068689',
  UCD13: '3400890686891',
  ucdQtyMultiplicator: 60,
  cipLib: "PASTISEROL PATE SUCER BT 60",
  atcCode: "R02AA20"
}, {
  CIP7: '5545632',
  CIP13: '3400955456322',
  ucdLib: "PENTACIS TROUS FL",
  UCD7: '9208038',
  UCD13: '3400892080383',
  ucdQtyMultiplicator: 5,
  cipLib: "PENTACIS TROUS FL BT 5",
  atcCode: "V09CA01"
}, {
  CIP7: '3082524',
  CIP13: '3400930825242',
  ucdLib: "PHLEBOGENINE POM DERM TB40G",
  UCD7: '9071177',
  UCD13: '3400890711777',
  ucdQtyMultiplicator: 1,
  cipLib: "PHLEBOGENINE POM DERM TB40G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3082837',
  CIP13: '3400930828373',
  ucdLib: "PHOSOFORME BUV SOL FL90ML",
  UCD7: '9071450',
  UCD13: '3400890714501',
  ucdQtyMultiplicator: 1,
  cipLib: "PHOSOFORME BUV SOL FL90ML BT 1",
  atcCode: "G04BA"
}, {
  CIP7: '3083127',
  CIP13: '3400930831274',
  ucdLib: "PHYTAT D.B SIR FL250ML",
  UCD7: '9071651',
  UCD13: '3400890716512',
  ucdQtyMultiplicator: 1,
  cipLib: "PHYTAT D.B SIR FL250ML BT 1",
  atcCode: "G04BC"
}, {
  CIP7: '3083239',
  CIP13: '3400930832394',
  ucdLib: "PHYTOMELIS BUV GTT FV30ML",
  UCD7: '9168416',
  UCD13: '3400891684162',
  ucdQtyMultiplicator: 1,
  cipLib: "PHYTOMELIS BUV GTT FV30ML BT 1",
  atcCode: "C05CX"
}, {
  CIP7: '3083937',
  CIP13: '3400930839379',
  ucdLib: "PLASTENAN POM TB40G",
  UCD7: '9072604',
  UCD13: '3400890726047',
  ucdQtyMultiplicator: 1,
  cipLib: "PLASTENAN POM TB40G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3084078',
  CIP13: '3400930840788',
  ucdLib: "PLURIFACTOR CPR",
  UCD7: '9072751',
  UCD13: '3400890727518',
  ucdQtyMultiplicator: 30,
  cipLib: "PLURIFACTOR CPR BT 30",
  atcCode: "A11EX"
}, {
  CIP7: '3085646',
  CIP13: '3400930856468',
  ucdLib: "POVANYL 1% BUV FL35ML",
  UCD7: '9074690',
  UCD13: '3400890746908',
  ucdQtyMultiplicator: 1,
  cipLib: "POVANYL 1% BUV FL35ML BT 1",
  atcCode: "P02CX01"
}, {
  CIP7: '3087160',
  CIP13: '3400930871607',
  ucdLib: "PROTHYL PATE TB15G",
  UCD7: '9076430',
  UCD13: '3400890764308',
  ucdQtyMultiplicator: 1,
  cipLib: "PROTHYL PATE TB15G BT 1",
  atcCode: "N01BA05"
}, {
  CIP7: '3087906',
  CIP13: '3400930879061',
  ucdLib: "PULMONASE SIR FL200ML",
  UCD7: '9076950',
  UCD13: '3400890769501',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMONASE SIR FL200ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3088142',
  CIP13: '3400930881422',
  ucdLib: "PULVIPLASMINE NAS SOL FL15ML",
  UCD7: '9077263',
  UCD13: '3400890772631',
  ucdQtyMultiplicator: 1,
  cipLib: "PULVIPLASMINE NAS SOL FL15ML BT 1",
  atcCode: "R07AX"
}, {
  CIP7: '3088745',
  CIP13: '3400930887455',
  ucdLib: "QUININE VIT C GRAND CPR",
  UCD7: '9077820',
  UCD13: '3400890778206',
  ucdQtyMultiplicator: 24,
  cipLib: "QUININE VIT C GRAND CPR BT 24",
  atcCode: "M09AA"
}, {
  CIP7: '3089437',
  CIP13: '3400930894378',
  ucdLib: "RADIOSELECTAN UV 76% 20ML",
  UCD7: '9078274',
  UCD13: '3400890782746',
  ucdQtyMultiplicator: 1,
  cipLib: "RADIOSELECTAN UV 76% 20ML BT 1",
  atcCode: "V08AA01"
}, {
  CIP7: '3089874',
  CIP13: '3400930898741',
  ucdLib: "RECTOPANBILINE GEL UNIDOS",
  UCD7: '9078512',
  UCD13: '3400890785129',
  ucdQtyMultiplicator: 6,
  cipLib: "RECTOPANBILINE GEL UNIDOS BT 6",
  atcCode: "A06AG20"
}, {
  CIP7: '3089992',
  CIP13: '3400930899922',
  ucdLib: "RECTOQUOTANE CR RECT TB20G",
  UCD7: '9078593',
  UCD13: '3400890785938',
  ucdQtyMultiplicator: 1,
  cipLib: "RECTOQUOTANE CR RECT TB20G BT 1",
  atcCode: "C05AX03"
}, {
  CIP7: '5548369',
  CIP13: '3400955483694',
  ucdLib: "RINGER LAC G5% AGT DAT1000ML",
  UCD7: '9080495',
  UCD13: '3400890804950',
  ucdQtyMultiplicator: 10,
  cipLib: "RINGER LAC G5% AGT DAT1000ML BT 10",
  atcCode: "B05BB01"
}, {
  CIP7: '3613097',
  CIP13: '3400936130975',
  ucdLib: "ROXITHROMYCINE GGA 100MG CPR",
  UCD7: '9248575',
  UCD13: '3400892485751',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE GGA 100MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3831115',
  CIP13: '3400938311150',
  ucdLib: "SODIUM 0,9% FRF INJ FP100ML",
  UCD7: '9307846',
  UCD13: '3400893078464',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ FP100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3831144',
  CIP13: '3400938311440',
  ucdLib: "SODIUM 0,9% FRF INJ FP250ML",
  UCD7: '9307869',
  UCD13: '3400893078693',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ FP250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3831196',
  CIP13: '3400938311969',
  ucdLib: "SODIUM 0,9% FRF INJ FP500ML",
  UCD7: '9307875',
  UCD13: '3400893078754',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ FP500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5548524',
  CIP13: '3400955485247',
  ucdLib: "SODIUM 0,9% FRF INJ PBF3000ML",
  UCD7: '9118720',
  UCD13: '3400891187205',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ PBF3000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3838979',
  CIP13: '3400938389791',
  ucdLib: "SODIUM LEV.MDC 50MG/ML FL1ML",
  UCD7: '9315805',
  UCD13: '3400893158050',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM LEV.MDC 50MG/ML FL1ML BT 1",
  atcCode: "V03AF"
}, {
  CIP7: '3838991',
  CIP13: '3400938389913',
  ucdLib: "SODIUM LEV.MDC 50MG/ML FL4ML",
  UCD7: '9315811',
  UCD13: '3400893158111',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM LEV.MDC 50MG/ML FL4ML BT 1",
  atcCode: "V03AF"
}, {
  CIP7: '3839022',
  CIP13: '3400938390223',
  ucdLib: "SODIUM LEV.MDC 50MG/ML FL9ML",
  UCD7: '9315828',
  UCD13: '3400893158289',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM LEV.MDC 50MG/ML FL9ML BT 1",
  atcCode: "V03AF"
}, {
  CIP7: '3001613',
  CIP13: '3400930016138',
  ucdLib: "ACTIVOX PELARGON.RHUME BUV30ML",
  UCD7: '9413608',
  UCD13: '3400894136088',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTIVOX PELARGON.RHUME BUV30ML BT 1",
  atcCode: "R07A"
}, {
  CIP7: '3003995',
  CIP13: '3400930039953',
  ucdLib: "AMPHOSCA ORCHITYN CPR CROQ",
  UCD7: '9421080',
  UCD13: '3400894210801',
  ucdQtyMultiplicator: 60,
  cipLib: "AMPHOSCA ORCHITYN CPR CROQ BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3006285',
  CIP13: '3400930062852',
  ucdLib: "ARGININE VEYRON BUV AMP5ML",
  UCD7: '9006263',
  UCD13: '3400890062633',
  ucdQtyMultiplicator: 20,
  cipLib: "ARGININE VEYRON BUV AMP5ML BT 20",
  atcCode: "A05C"
}, {
  CIP7: '3006316',
  CIP13: '3400930063163',
  ucdLib: "ARGININE VEYRON BUV FL250ML",
  UCD7: '9006292',
  UCD13: '3400890062923',
  ucdQtyMultiplicator: 1,
  cipLib: "ARGININE VEYRON BUV FL250ML BT 1",
  atcCode: "A05C"
}, {
  CIP7: '3328149',
  CIP13: '3400933281496',
  ucdLib: "ARKOGELULES BARDANE",
  UCD7: '9144723',
  UCD13: '3400891447231',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES BARDANE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3322394',
  CIP13: '3400933223946',
  ucdLib: "ARKOGELULES MELISSE",
  UCD7: '9145059',
  UCD13: '3400891450590',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES MELISSE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3008887',
  CIP13: '3400930088876',
  ucdLib: "AVENOC POM RECT TB30G",
  UCD7: '9008635',
  UCD13: '3400890086356',
  ucdQtyMultiplicator: 1,
  cipLib: "AVENOC POM RECT TB30G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3003137',
  CIP13: '3400930031377',
  ucdLib: "BELIVAIR RHUME PELAR. CPR",
  UCD7: '9419752',
  UCD13: '3400894197522',
  ucdQtyMultiplicator: 15,
  cipLib: "BELIVAIR RHUME PELAR. CPR BT 15",
  atcCode: "R07A"
}, {
  CIP7: '3003665',
  CIP13: '3400930036655',
  ucdLib: "BOLDOFLORINE TIS SACH1,63G",
  UCD7: '9215647',
  UCD13: '3400892156477',
  ucdQtyMultiplicator: 24,
  cipLib: "BOLDOFLORINE TIS SACH1,63G BT 24",
  atcCode: "A06AB56"
}, {
  CIP7: '3003666',
  CIP13: '3400930036662',
  ucdLib: "BOLDOFLORINE TIS SACH1,63G",
  UCD7: '9215647',
  UCD13: '3400892156477',
  ucdQtyMultiplicator: 48,
  cipLib: "BOLDOFLORINE TIS SACH1,63G BT 48",
  atcCode: "A06AB56"
}, {
  CIP7: '3009071',
  CIP13: '3400930090718',
  ucdLib: "BOP CPR",
  UCD7: '9012080',
  UCD13: '3400890120807',
  ucdQtyMultiplicator: 60,
  cipLib: "BOP CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3322158',
  CIP13: '3400933221584',
  ucdLib: "CANTALENE CPR SUCER",
  UCD7: '9140151',
  UCD13: '3400891401516',
  ucdQtyMultiplicator: 24,
  cipLib: "CANTALENE CPR SUCER BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3003324',
  CIP13: '3400930033241',
  ucdLib: "CAROMINTHE BUV GTT FL90ML",
  UCD7: '9419195',
  UCD13: '3400894191957',
  ucdQtyMultiplicator: 1,
  cipLib: "CAROMINTHE BUV GTT FL90ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3284966',
  CIP13: '3400932849666',
  ucdLib: "CYCLO 3 CR TB100G",
  UCD7: '9117873',
  UCD13: '3400891178739',
  ucdQtyMultiplicator: 1,
  cipLib: "CYCLO 3 CR TB100G BT 1",
  atcCode: "C05CX"
}, {
  CIP7: '3005354',
  CIP13: '3400930053546',
  ucdLib: "DIABENE BUV GTT FL30ML",
  UCD7: '9026024',
  UCD13: '3400890260244',
  ucdQtyMultiplicator: 1,
  cipLib: "DIABENE BUV GTT FL30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '3280170',
  CIP13: '3400932801701',
  ucdLib: "DIANEAL PD1 G.1,36% PS3L+LU",
  UCD7: '9126458',
  UCD13: '3400891264586',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% PS3L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3280187',
  CIP13: '3400932801879',
  ucdLib: "DIANEAL PD1 G.1,36% PS5L+LU",
  UCD7: '9126464',
  UCD13: '3400891264647',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% PS5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3280158',
  CIP13: '3400932801589',
  ucdLib: "DIANEAL PD1 G.3,86% PS3L+LU",
  UCD7: '9150669',
  UCD13: '3400891506693',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% PS3L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3280164',
  CIP13: '3400932801640',
  ucdLib: "DIANEAL PD1 G.3,86% PS5L+LU",
  UCD7: '9150675',
  UCD13: '3400891506754',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% PS5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3004376',
  CIP13: '3400930043769',
  ucdLib: "DOXYLAMINE AWC 15MG CPR",
  UCD7: '9417144',
  UCD13: '3400894171447',
  ucdQtyMultiplicator: 10,
  cipLib: "DOXYLAMINE AWC 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '3004377',
  CIP13: '3400930043776',
  ucdLib: "DOXYLAMINE EGC 15MG CPR",
  UCD7: '9417411',
  UCD13: '3400894174110',
  ucdQtyMultiplicator: 10,
  cipLib: "DOXYLAMINE EGC 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '3004331',
  CIP13: '3400930043318',
  ucdLib: "DROSETUX SIR FL150ML",
  UCD7: '9029005',
  UCD13: '3400890290050',
  ucdQtyMultiplicator: 1,
  cipLib: "DROSETUX SIR FL150ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3002111',
  CIP13: '3400930021118',
  ucdLib: "FERTISTARTKIT 150UI FL+SRG",
  UCD7: '9417612',
  UCD13: '3400894176121',
  ucdQtyMultiplicator: 1,
  cipLib: "FERTISTARTKIT 150UI FL+SRG BT 1",
  atcCode: "G03GA02"
}, {
  CIP7: '3002108',
  CIP13: '3400930021088',
  ucdLib: "FERTISTARTKIT 75UI FL+SRG",
  UCD7: '9417629',
  UCD13: '3400894176299',
  ucdQtyMultiplicator: 1,
  cipLib: "FERTISTARTKIT 75UI FL+SRG BT 1",
  atcCode: "G03GA02"
}, {
  CIP7: '3285049',
  CIP13: '3400932850495',
  ucdLib: "ISOBAR CPR",
  UCD7: '9129008',
  UCD13: '3400891290080',
  ucdQtyMultiplicator: 30,
  cipLib: "ISOBAR CPR BT 30",
  atcCode: "C03EA"
}, {
  CIP7: '3000763',
  CIP13: '3400930007631',
  ucdLib: "KETOCONAZOLE HRA 200MG CPR",
  UCD7: '9406979',
  UCD13: '3400894069799',
  ucdQtyMultiplicator: 60,
  cipLib: "KETOCONAZOLE HRA 200MG CPR BT 60",
  atcCode: "G01AF11"
}, {
  CIP7: '3281169',
  CIP13: '3400932811694',
  ucdLib: "LYSO-6 CPR SUBLING",
  UCD7: '9055764',
  UCD13: '3400890557641',
  ucdQtyMultiplicator: 30,
  cipLib: "LYSO-6 CPR SUBLING BT 30",
  atcCode: "A01AD11"
}, {
  CIP7: '3288651',
  CIP13: '3400932886517',
  ucdLib: "MULTIRINSE SOL OCUL DOS10ML",
  UCD7: '9178107',
  UCD13: '3400891781076',
  ucdQtyMultiplicator: 30,
  cipLib: "MULTIRINSE SOL OCUL DOS10ML BT 30",
  atcCode: ""
}, {
  CIP7: '3000246',
  CIP13: '3400930002469',
  ucdLib: "NIRVA 100MG GELU",
  UCD7: '9422234',
  UCD13: '3400894222347',
  ucdQtyMultiplicator: 50,
  cipLib: "NIRVA 100MG GELU BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3320633',
  CIP13: '3400933206338',
  ucdLib: "OPO-VEINOGENE BUV FL150ML",
  UCD7: '9148307',
  UCD13: '3400891483079',
  ucdQtyMultiplicator: 1,
  cipLib: "OPO-VEINOGENE BUV FL150ML BT 1",
  atcCode: "C05CX"
}, {
  CIP7: '3281100',
  CIP13: '3400932811007',
  ucdLib: "OSCILLOCOCCINUM GM GLB DOS",
  UCD7: '9065969',
  UCD13: '3400890659697',
  ucdQtyMultiplicator: 6,
  cipLib: "OSCILLOCOCCINUM GM GLB DOS BT 6",
  atcCode: "V03AX"
}, {
  CIP7: '3322170',
  CIP13: '3400933221706',
  ucdLib: "PANOXYL 10% PAIN100G",
  UCD7: '9143126',
  UCD13: '3400891431261',
  ucdQtyMultiplicator: 1,
  cipLib: "PANOXYL 10% PAIN100G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '3322980',
  CIP13: '3400933229801',
  ucdLib: "PERCUTAFEINE GEL DERM TB144G",
  UCD7: '9141558',
  UCD13: '3400891415582',
  ucdQtyMultiplicator: 1,
  cipLib: "PERCUTAFEINE GEL DERM TB144G BT 1",
  atcCode: "D11AX"
}, {
  CIP7: '3320656',
  CIP13: '3400933206567',
  ucdLib: "PHOSPHALUGEL CPR",
  UCD7: '9144858',
  UCD13: '3400891448580',
  ucdQtyMultiplicator: 36,
  cipLib: "PHOSPHALUGEL CPR BT 36",
  atcCode: "A02AB03"
}, {
  CIP7: '3000148',
  CIP13: '3400930001486',
  ucdLib: "SINUSPAX CPR CROQ",
  UCD7: '9084091',
  UCD13: '3400890840910',
  ucdQtyMultiplicator: 60,
  cipLib: "SINUSPAX CPR CROQ BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3321851',
  CIP13: '3400933218515',
  ucdLib: "SPREGAL EXT SOL FL PRESS 200ML",
  UCD7: '9143020',
  UCD13: '3400891430202',
  ucdQtyMultiplicator: 1,
  cipLib: "SPREGAL EXT SOL FL PRESS 200ML BT 1",
  atcCode: "P03AC"
}, {
  CIP7: '3280023',
  CIP13: '3400932800230',
  ucdLib: "STERILLIUM LOC SOL FP100ML",
  UCD7: '9128569',
  UCD13: '3400891285697',
  ucdQtyMultiplicator: 1,
  cipLib: "STERILLIUM LOC SOL FP100ML BT 1",
  atcCode: "D08AX53"
}, {
  CIP7: '3280046',
  CIP13: '3400932800469',
  ucdLib: "STERILLIUM LOC SOL FP500ML",
  UCD7: '9122650',
  UCD13: '3400891226508',
  ucdQtyMultiplicator: 1,
  cipLib: "STERILLIUM LOC SOL FP500ML BT 1",
  atcCode: "D08AX53"
}, {
  CIP7: '3289679',
  CIP13: '3400932896790',
  ucdLib: "UVIMAG B6 BUV AMP10ML",
  UCD7: '9125192',
  UCD13: '3400891251920',
  ucdQtyMultiplicator: 20,
  cipLib: "UVIMAG B6 BUV AMP10ML BT 20",
  atcCode: "A11EC"
}, {
  CIP7: '3001866',
  CIP13: '3400930018668',
  ucdLib: "VENLAFAXINE BLF LP37,5 GELU",
  UCD7: '9353473',
  UCD13: '3400893534731',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BLF LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3001867',
  CIP13: '3400930018675',
  ucdLib: "VENLAFAXINE BLF LP75MG GELU",
  UCD7: '9353496',
  UCD13: '3400893534960',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BLF LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3292807',
  CIP13: '3400932928071',
  ucdLib: "ARKOGELULES FRAGON GELU",
  UCD7: '9117962',
  UCD13: '3400891179620',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES FRAGON GELU BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3296892',
  CIP13: '3400932968923',
  ucdLib: "ARKOGELULES PRELE CHAMPS",
  UCD7: '9128776',
  UCD13: '3400891287769',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES PRELE CHAMPS BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3278983',
  CIP13: '3400932789832',
  ucdLib: "COOPER POLYION.GL.N3 500ML",
  UCD7: '9214292',
  UCD13: '3400892142920',
  ucdQtyMultiplicator: 1,
  cipLib: "COOPER POLYION.GL.N3 500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3031171',
  CIP13: '3400930311714',
  ucdLib: "DIFRAREL 100MG CPR",
  UCD7: '9026805',
  UCD13: '3400890268059',
  ucdQtyMultiplicator: 20,
  cipLib: "DIFRAREL 100MG CPR BT 20",
  atcCode: "C05CX"
}, {
  CIP7: '3031159',
  CIP13: '3400930311592',
  ucdLib: "DIFRAREL E CPR",
  UCD7: '9026780',
  UCD13: '3400890267809',
  ucdQtyMultiplicator: 24,
  cipLib: "DIFRAREL E CPR BT 24",
  atcCode: "S01X"
}, {
  CIP7: '3031254',
  CIP13: '3400930312544',
  ucdLib: "DIGESTODORON BUV GTT FL30ML",
  UCD7: '9026923',
  UCD13: '3400890269230',
  ucdQtyMultiplicator: 1,
  cipLib: "DIGESTODORON BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3291015',
  CIP13: '3400932910151',
  ucdLib: "ELUSANES ARTICHAUT GELU",
  UCD7: '9121159',
  UCD13: '3400891211597',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES ARTICHAUT GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3291050',
  CIP13: '3400932910502',
  ucdLib: "ELUSANES AUBEPINE GELU",
  UCD7: '9121165',
  UCD13: '3400891211658',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES AUBEPINE GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3296834',
  CIP13: '3400932968343',
  ucdLib: "ELUSANES BOLDO GELU",
  UCD7: '9121805',
  UCD13: '3400891218053',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES BOLDO GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3296840',
  CIP13: '3400932968404',
  ucdLib: "ELUSANES FUMETERRE GELU",
  UCD7: '9121171',
  UCD13: '3400891211719',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES FUMETERRE GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3291044',
  CIP13: '3400932910441',
  ucdLib: "ELUSANES PASSIF.200MG GELU",
  UCD7: '9120355',
  UCD13: '3400891203554',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES PASSIF.200MG GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3296716',
  CIP13: '3400932967162',
  ucdLib: "ELUSANES PRELE 185MG GELU",
  UCD7: '9121231',
  UCD13: '3400891212310',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES PRELE 185MG GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3291021',
  CIP13: '3400932910212',
  ucdLib: "ELUSANES REINE DES PRES GELU",
  UCD7: '9121248',
  UCD13: '3400891212488',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES REINE DES PRES GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3296857',
  CIP13: '3400932968572',
  ucdLib: "ELUSANES VIGNE ROUGE GELU",
  UCD7: '9127280',
  UCD13: '3400891272802',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES VIGNE ROUGE GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3035654',
  CIP13: '3400930356548',
  ucdLib: "ENDHOMETROL OV",
  UCD7: '9030965',
  UCD13: '3400890309653',
  ucdQtyMultiplicator: 6,
  cipLib: "ENDHOMETROL OV BT 6",
  atcCode: "V03AX"
}, {
  CIP7: '3037481',
  CIP13: '3400930374818',
  ucdLib: "ESSENCE ALGERIENNE FL20ML",
  UCD7: '9110316',
  UCD13: '3400891103168',
  ucdQtyMultiplicator: 1,
  cipLib: "ESSENCE ALGERIENNE FL20ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3575037',
  CIP13: '3400935750372',
  ucdLib: "ETHER GIFRER LOC SOL FF110ML",
  UCD7: '9250069',
  UCD13: '3400892500690',
  ucdQtyMultiplicator: 1,
  cipLib: "ETHER GIFRER LOC SOL FF110ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3038500',
  CIP13: '3400930385005',
  ucdLib: "EUPHON PAST",
  UCD7: '9033633',
  UCD13: '3400890336338',
  ucdQtyMultiplicator: 70,
  cipLib: "EUPHON PAST BT 70",
  atcCode: "R02AA20"
}, {
  CIP7: '3039149',
  CIP13: '3400930391495',
  ucdLib: "EXTRANASE CPR",
  UCD7: '9034236',
  UCD13: '3400890342360',
  ucdQtyMultiplicator: 40,
  cipLib: "EXTRANASE CPR BT 40",
  atcCode: "D03BA03"
}, {
  CIP7: '3039155',
  CIP13: '3400930391556',
  ucdLib: "EXTRANASE CPR",
  UCD7: '9034236',
  UCD13: '3400890342360',
  ucdQtyMultiplicator: 80,
  cipLib: "EXTRANASE CPR BT 80",
  atcCode: "D03BA03"
}, {
  CIP7: '5557931',
  CIP13: '3400955579311',
  ucdLib: "FORTRANS BUV PDR SACH 74G",
  UCD7: '9125708',
  UCD13: '3400891257083',
  ucdQtyMultiplicator: 50,
  cipLib: "FORTRANS BUV PDR SACH 74G BT 50",
  atcCode: "A06AD65"
}, {
  CIP7: '5551822',
  CIP13: '3400955518228',
  ucdLib: "HALCION 0,125MG CPR",
  UCD7: '9131229',
  UCD13: '3400891312294',
  ucdQtyMultiplicator: 100,
  cipLib: "HALCION 0,125MG CPR BT 100",
  atcCode: "N05CD05"
}, {
  CIP7: '3299270',
  CIP13: '3400932992706',
  ucdLib: "HEMORROGEL GELU",
  UCD7: '9122696',
  UCD13: '3400891226966',
  ucdQtyMultiplicator: 45,
  cipLib: "HEMORROGEL GELU BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3299287',
  CIP13: '3400932992874',
  ucdLib: "HEMORROGEL GELU",
  UCD7: '9122696',
  UCD13: '3400891226966',
  ucdQtyMultiplicator: 150,
  cipLib: "HEMORROGEL GELU BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3574753',
  CIP13: '3400935747532',
  ucdLib: "HOMEOMUNYL GLE UNIDOS",
  UCD7: '9233616',
  UCD13: '3400892336169',
  ucdQtyMultiplicator: 4,
  cipLib: "HOMEOMUNYL GLE UNIDOS BT 4",
  atcCode: "V03AX"
}, {
  CIP7: '3578225',
  CIP13: '3400935782250',
  ucdLib: "KABIVEN INJ POC2566ML",
  UCD7: '9217020',
  UCD13: '3400892170206',
  ucdQtyMultiplicator: 2,
  cipLib: "KABIVEN INJ POC2566ML BT 2",
  atcCode: "B05BA10"
}, {
  CIP7: '5556268',
  CIP13: '3400955562689',
  ucdLib: "LEVOCARNIL 100MG/ML BUV FL10ML",
  UCD7: '9128049',
  UCD13: '3400891280494',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVOCARNIL 100MG/ML BUV FL10ML BT 10",
  atcCode: "A16AA01"
}, {
  CIP7: '3290576',
  CIP13: '3400932905768',
  ucdLib: "MEPACYL SOL FL14ML",
  UCD7: '9188146',
  UCD13: '3400891881462',
  ucdQtyMultiplicator: 1,
  cipLib: "MEPACYL SOL FL14ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3276056',
  CIP13: '3400932760565',
  ucdLib: "NAUSICALM SIR FV150ML",
  UCD7: '9106036',
  UCD13: '3400891060362',
  ucdQtyMultiplicator: 1,
  cipLib: "NAUSICALM SIR FV150ML BT 1",
  atcCode: "A04AD"
}, {
  CIP7: '5553169',
  CIP13: '3400955531692',
  ucdLib: "OMNIPAQUE 180 INJ FV15ML",
  UCD7: '9113154',
  UCD13: '3400891131543',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 180 INJ FV15ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '3293770',
  CIP13: '3400932937707',
  ucdLib: "PABASUN 500MG CPR",
  UCD7: '9119642',
  UCD13: '3400891196429',
  ucdQtyMultiplicator: 60,
  cipLib: "PABASUN 500MG CPR BT 60",
  atcCode: "D02BA01"
}, {
  CIP7: '3276501',
  CIP13: '3400932765010',
  ucdLib: "PHYTOTUX SIR FL250ML",
  UCD7: '9071734',
  UCD13: '3400890717342',
  ucdQtyMultiplicator: 1,
  cipLib: "PHYTOTUX SIR FL250ML BT 1",
  atcCode: "R05CA10"
}, {
  CIP7: '3276464',
  CIP13: '3400932764648',
  ucdLib: "PNEUMASEPTIC AD. SIR FL150ML",
  UCD7: '9158777',
  UCD13: '3400891587777',
  ucdQtyMultiplicator: 1,
  cipLib: "PNEUMASEPTIC AD. SIR FL150ML BT 1",
  atcCode: "R05CA10"
}, {
  CIP7: '3295473',
  CIP13: '3400932954735',
  ucdLib: "POLYCLEAN SOL LENTIL FP12ML",
  UCD7: '9121283',
  UCD13: '3400891212839',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYCLEAN SOL LENTIL FP12ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3295496',
  CIP13: '3400932954964',
  ucdLib: "POLYCLEAN SOL LENTIL FP24ML",
  UCD7: '9121308',
  UCD13: '3400891213089',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYCLEAN SOL LENTIL FP24ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3291676',
  CIP13: '3400932916764',
  ucdLib: "PRESSICAINE FLUID SOL FL40ML",
  UCD7: '9140576',
  UCD13: '3400891405767',
  ucdQtyMultiplicator: 1,
  cipLib: "PRESSICAINE FLUID SOL FL40ML BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '3273218',
  CIP13: '3400932732180',
  ucdLib: "PYRAX BB. SUP",
  UCD7: '9103500',
  UCD13: '3400891035001',
  ucdQtyMultiplicator: 8,
  cipLib: "PYRAX BB. SUP BT 8",
  atcCode: "N02BA51"
}, {
  CIP7: '3273224',
  CIP13: '3400932732241',
  ucdLib: "PYRAX ENF SUP",
  UCD7: '9103517',
  UCD13: '3400891035179',
  ucdQtyMultiplicator: 8,
  cipLib: "PYRAX ENF SUP BT 8",
  atcCode: "N02BA51"
}, {
  CIP7: '3276694',
  CIP13: '3400932766949',
  ucdLib: "REXORUBIA GLE ORAL BT350G",
  UCD7: '9103606',
  UCD13: '3400891036060',
  ucdQtyMultiplicator: 1,
  cipLib: "REXORUBIA GLE ORAL BT350G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3294367',
  CIP13: '3400932943678',
  ucdLib: "RHINASPIR NAS FL PULV 15ML",
  UCD7: '9125499',
  UCD13: '3400891254990',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINASPIR NAS FL PULV 15ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3299324',
  CIP13: '3400932993246',
  ucdLib: "SALBUMOL 0,5MG INJ AMP1ML",
  UCD7: '9126145',
  UCD13: '3400891261455',
  ucdQtyMultiplicator: 6,
  cipLib: "SALBUMOL 0,5MG INJ AMP1ML BT 6",
  atcCode: "G02CA"
}, {
  CIP7: '5555990',
  CIP13: '3400955559900',
  ucdLib: "SODIUM BIC 4,2% AGT FV500ML",
  UCD7: '9127802',
  UCD13: '3400891278026',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM BIC 4,2% AGT FV500ML BT 12",
  atcCode: "B05XA02"
}, {
  CIP7: '3233006',
  CIP13: '3400932330065',
  ucdLib: "ALPAGELLE CR TB80G",
  UCD7: '9003336',
  UCD13: '3400890033367',
  ucdQtyMultiplicator: 1,
  cipLib: "ALPAGELLE CR TB80G BT 1",
  atcCode: "G02BB"
}, {
  CIP7: '3010022',
  CIP13: '3400930100226',
  ucdLib: "BAUDRY PATES PECTORALES BT70G",
  UCD7: '9009557',
  UCD13: '3400890095570',
  ucdQtyMultiplicator: 1,
  cipLib: "BAUDRY PATES PECTORALES BT70G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3011524',
  CIP13: '3400930115244',
  ucdLib: "BILLEROL LEHNING CPR",
  UCD7: '9010885',
  UCD13: '3400890108850',
  ucdQtyMultiplicator: 45,
  cipLib: "BILLEROL LEHNING CPR BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3011659',
  CIP13: '3400930116593',
  ucdLib: "BIOCARDE BUV GTT FL30ML",
  UCD7: '9010968',
  UCD13: '3400890109680',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOCARDE BUV GTT FL30ML BT 1",
  atcCode: "C01EX"
}, {
  CIP7: '3016591',
  CIP13: '3400930165911',
  ucdLib: "CALCIBRONAT 2G CPR EFFV",
  UCD7: '9014417',
  UCD13: '3400890144179',
  ucdQtyMultiplicator: 20,
  cipLib: "CALCIBRONAT 2G CPR EFFV BT 20",
  atcCode: "N05CM11"
}, {
  CIP7: '3018779',
  CIP13: '3400930187791',
  ucdLib: "CARDIOCALM CPR",
  UCD7: '9016439',
  UCD13: '3400890164399',
  ucdQtyMultiplicator: 40,
  cipLib: "CARDIOCALM CPR BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '3019661',
  CIP13: '3400930196618',
  ucdLib: "CEMAFLAVONE BUV AMP10ML",
  UCD7: '9017539',
  UCD13: '3400890175395',
  ucdQtyMultiplicator: 20,
  cipLib: "CEMAFLAVONE BUV AMP10ML BT 20",
  atcCode: "C05CX"
}, {
  CIP7: '3022634',
  CIP13: '3400930226346',
  ucdLib: "CHOLEODORON BUV GTT FL30ML",
  UCD7: '9019260',
  UCD13: '3400890192606',
  ucdQtyMultiplicator: 1,
  cipLib: "CHOLEODORON BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3022798',
  CIP13: '3400930227985',
  ucdLib: "CHOPHYTOL 20% BUV FL120ML",
  UCD7: '9109017',
  UCD13: '3400891090178',
  ucdQtyMultiplicator: 1,
  cipLib: "CHOPHYTOL 20% BUV FL120ML BT 1",
  atcCode: "A05C"
}, {
  CIP7: '3025265',
  CIP13: '3400930252659',
  ucdLib: "CONTRE-COUPS PERDRIGEON FL60ML",
  UCD7: '9070172',
  UCD13: '3400890701723',
  ucdQtyMultiplicator: 1,
  cipLib: "CONTRE-COUPS PERDRIGEON FL60ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3027465',
  CIP13: '3400930274651',
  ucdLib: "CUTISAN 1% PDR DERM BT80G",
  UCD7: '9023439',
  UCD13: '3400890234399',
  ucdQtyMultiplicator: 1,
  cipLib: "CUTISAN 1% PDR DERM BT80G BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3029607',
  CIP13: '3400930296073',
  ucdLib: "DERMO-6 LOC SOL FL200ML",
  UCD7: '9025332',
  UCD13: '3400890253321',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMO-6 LOC SOL FL200ML BT 1",
  atcCode: "D11AX"
}, {
  CIP7: '3029843',
  CIP13: '3400930298435',
  ucdLib: "DESINTEX BUV AMP5ML",
  UCD7: '9025585',
  UCD13: '3400890255851',
  ucdQtyMultiplicator: 14,
  cipLib: "DESINTEX BUV AMP5ML BT 14",
  atcCode: "A16AX"
}, {
  CIP7: '3029872',
  CIP13: '3400930298725',
  ucdLib: "DESINTEX CPR",
  UCD7: '9025616',
  UCD13: '3400890256162',
  ucdQtyMultiplicator: 60,
  cipLib: "DESINTEX CPR BT 60",
  atcCode: "A16AX"
}, {
  CIP7: '3232544',
  CIP13: '3400932325443',
  ucdLib: "DIACURE GELU",
  UCD7: '9026113',
  UCD13: '3400890261135',
  ucdQtyMultiplicator: 60,
  cipLib: "DIACURE GELU BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3234856',
  CIP13: '3400932348565',
  ucdLib: "DIANEAL PD1 G.1,36% PS1,5L+P.",
  UCD7: '9150563',
  UCD13: '3400891505634',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% PS1,5L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3234862',
  CIP13: '3400932348626',
  ucdLib: "DIANEAL PD1 G.1,36% PS2L+P.",
  UCD7: '9150586',
  UCD13: '3400891505863',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% PS2L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3234891',
  CIP13: '3400932348916',
  ucdLib: "DIANEAL PD1 G.3,86% PS1,5L+P.",
  UCD7: '9150706',
  UCD13: '3400891507065',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% PS1,5L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3234922',
  CIP13: '3400932349227',
  ucdLib: "DIANEAL PD1 G.3,86% PS3L/2L+P.",
  UCD7: '9150735',
  UCD13: '3400891507355',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% PS3L/2L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3117866',
  CIP13: '3400931178668',
  ucdLib: "DULCIPHAK COLLY FP10ML",
  UCD7: '9029206',
  UCD13: '3400890292061',
  ucdQtyMultiplicator: 1,
  cipLib: "DULCIPHAK COLLY FP10ML BT 1",
  atcCode: "S01XA"
}, {
  CIP7: '3232691',
  CIP13: '3400932326914',
  ucdLib: "EUPHON SANS SUCRE PAST",
  UCD7: '9033662',
  UCD13: '3400890336628',
  ucdQtyMultiplicator: 70,
  cipLib: "EUPHON SANS SUCRE PAST BT 70",
  atcCode: "R02AA20"
}, {
  CIP7: '3040980',
  CIP13: '3400930409800',
  ucdLib: "FONGERYL 1% CR TB30G",
  UCD7: '9035997',
  UCD13: '3400890359979',
  ucdQtyMultiplicator: 1,
  cipLib: "FONGERYL 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3043056',
  CIP13: '3400930430569',
  ucdLib: "GASTROCYNESINE CPR",
  UCD7: '9037507',
  UCD13: '3400890375078',
  ucdQtyMultiplicator: 60,
  cipLib: "GASTROCYNESINE CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3043085',
  CIP13: '3400930430859',
  ucdLib: "GASTROPAX PDR BT100G",
  UCD7: '9037588',
  UCD13: '3400890375887',
  ucdQtyMultiplicator: 1,
  cipLib: "GASTROPAX PDR BT100G BT 1",
  atcCode: "A02AH"
}, {
  CIP7: '3231214',
  CIP13: '3400932312146',
  ucdLib: "GELUCYSTINE 500MG GELU",
  UCD7: '9037861',
  UCD13: '3400890378611',
  ucdQtyMultiplicator: 60,
  cipLib: "GELUCYSTINE 500MG GELU BT 60",
  atcCode: "D11AX"
}, {
  CIP7: '3119262',
  CIP13: '3400931192626',
  ucdLib: "GENCYDO NAS SOL FL15ML",
  UCD7: '9037967',
  UCD13: '3400890379670',
  ucdQtyMultiplicator: 1,
  cipLib: "GENCYDO NAS SOL FL15ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3236370',
  CIP13: '3400932363704',
  ucdLib: "GLUCOSE 15% BSD INJ FV500ML",
  UCD7: '9039363',
  UCD13: '3400890393638',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 15% BSD INJ FV500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3045730',
  CIP13: '3400930457306',
  ucdLib: "GOMENOLEO 5% LOC AMP5ML",
  UCD7: '9040550',
  UCD13: '3400890405508',
  ucdQtyMultiplicator: 10,
  cipLib: "GOMENOLEO 5% LOC AMP5ML BT 10",
  atcCode: "G04BX"
}, {
  CIP7: '3048295',
  CIP13: '3400930482957',
  ucdLib: "HEPANEPHROL BUV AMP10ML",
  UCD7: '9042508',
  UCD13: '3400890425087',
  ucdQtyMultiplicator: 20,
  cipLib: "HEPANEPHROL BUV AMP10ML BT 20",
  atcCode: "A05C"
}, {
  CIP7: '3048384',
  CIP13: '3400930483848',
  ucdLib: "HEPARGITOL PDR SACH",
  UCD7: '9042520',
  UCD13: '3400890425209',
  ucdQtyMultiplicator: 20,
  cipLib: "HEPARGITOL PDR SACH BT 20",
  atcCode: "A05C"
}, {
  CIP7: '3233762',
  CIP13: '3400932337620',
  ucdLib: "HEPATOUM BUV SOL FV550ML",
  UCD7: '9043034',
  UCD13: '3400890430340',
  ucdQtyMultiplicator: 1,
  cipLib: "HEPATOUM BUV SOL FV550ML BT 1",
  atcCode: "A05AX"
}, {
  CIP7: '3049478',
  CIP13: '3400930494783',
  ucdLib: "HEXAQUINE CPR",
  UCD7: '9043471',
  UCD13: '3400890434713',
  ucdQtyMultiplicator: 18,
  cipLib: "HEXAQUINE CPR BT 18",
  atcCode: "M09AA"
}, {
  CIP7: '3013109',
  CIP13: '3400930131091',
  ucdLib: "OXYDE MERCUR.1% CHAUVIN POM 5G",
  UCD7: '9011732',
  UCD13: '3400890117326',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYDE MERCUR.1% CHAUVIN POM 5G BT 1",
  atcCode: "S01AX01"
}, {
  CIP7: '3119782',
  CIP13: '3400931197829',
  ucdLib: "PERTUDORON BUV GTT FL30ML",
  UCD7: '9070597',
  UCD13: '3400890705974',
  ucdQtyMultiplicator: 1,
  cipLib: "PERTUDORON BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3237317',
  CIP13: '3400932373178',
  ucdLib: "RADIOSELECTAN UV 76% 60ML +NEC",
  UCD7: '9078311',
  UCD13: '3400890783118',
  ucdQtyMultiplicator: 1,
  cipLib: "RADIOSELECTAN UV 76% 60ML +NEC BT 1",
  atcCode: "V08AA01"
}, {
  CIP7: '3231183',
  CIP13: '3400932311835',
  ucdLib: "STAGO BUV SOL FL550ML",
  UCD7: '9087385',
  UCD13: '3400890873857',
  ucdQtyMultiplicator: 1,
  cipLib: "STAGO BUV SOL FL550ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3110309',
  CIP13: '3400931103097',
  ucdLib: "URARTHONE BUV SOL FL250ML",
  UCD7: '9096527',
  UCD13: '3400890965279',
  ucdQtyMultiplicator: 1,
  cipLib: "URARTHONE BUV SOL FL250ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3112596',
  CIP13: '3400931125969',
  ucdLib: "VIBTIL 250MG CPR",
  UCD7: '9098578',
  UCD13: '3400890985789',
  ucdQtyMultiplicator: 40,
  cipLib: "VIBTIL 250MG CPR BT 40",
  atcCode: "A05AX"
}, {
  CIP7: '3265006',
  CIP13: '3400932650064',
  ucdLib: "ALPAGELLE CR DOS30G",
  UCD7: '9003342',
  UCD13: '3400890033428',
  ucdQtyMultiplicator: 6,
  cipLib: "ALPAGELLE CR DOS30G BT 6",
  atcCode: "G02BB"
}, {
  CIP7: '3314064',
  CIP13: '3400933140649',
  ucdLib: "ARKOGELULES ARTICHAUT",
  UCD7: '9134506',
  UCD13: '3400891345063',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES ARTICHAUT BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3314070',
  CIP13: '3400933140700',
  ucdLib: "ARKOGELULES ARTICHAUT",
  UCD7: '9134506',
  UCD13: '3400891345063',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES ARTICHAUT BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3317499',
  CIP13: '3400933174996',
  ucdLib: "ARKOGELULES FUMETERRE",
  UCD7: '9139722',
  UCD13: '3400891397222',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES FUMETERRE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3316554',
  CIP13: '3400933165543',
  ucdLib: "ARKOGELULES HAMAMELISGELU",
  UCD7: '9136729',
  UCD13: '3400891367294',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES HAMAMELISGELU BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3314153',
  CIP13: '3400933141530',
  ucdLib: "ARKOGELULES PASSIFLORE",
  UCD7: '9134529',
  UCD13: '3400891345292',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES PASSIFLORE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3317453',
  CIP13: '3400933174538',
  ucdLib: "ARKOGELULES PILOSELLE",
  UCD7: '9145680',
  UCD13: '3400891456806',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES PILOSELLE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3314006',
  CIP13: '3400933140069',
  ucdLib: "ARKOGELULES PRELE CHAMPS",
  UCD7: '9128776',
  UCD13: '3400891287769',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES PRELE CHAMPS BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3313780',
  CIP13: '3400933137809',
  ucdLib: "BACTOX 1G IM IV FL+AMP",
  UCD7: '9146449',
  UCD13: '3400891464498',
  ucdQtyMultiplicator: 1,
  cipLib: "BACTOX 1G IM IV FL+AMP BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3260397',
  CIP13: '3400932603978',
  ucdLib: "BACTOX 500MG GELU",
  UCD7: '9146478',
  UCD13: '3400891464788',
  ucdQtyMultiplicator: 12,
  cipLib: "BACTOX 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3313797',
  CIP13: '3400933137977',
  ucdLib: "BACTOX 500MG IM FL+AMP",
  UCD7: '9146484',
  UCD13: '3400891464849',
  ucdQtyMultiplicator: 1,
  cipLib: "BACTOX 500MG IM FL+AMP BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3191182',
  CIP13: '3400931911821',
  ucdLib: "BORIBEL N9 TIS SACH DOS",
  UCD7: '9012861',
  UCD13: '3400890128612',
  ucdQtyMultiplicator: 50,
  cipLib: "BORIBEL N9 TIS SACH DOS BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3316560',
  CIP13: '3400933165604',
  ucdLib: "CAMILINE GELU",
  UCD7: '9140777',
  UCD13: '3400891407778',
  ucdQtyMultiplicator: 45,
  cipLib: "CAMILINE GELU BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3253948',
  CIP13: '3400932539482',
  ucdLib: "COLLUDOL COLLU FL30ML",
  UCD7: '9021274',
  UCD13: '3400890212748',
  ucdQtyMultiplicator: 1,
  cipLib: "COLLUDOL COLLU FL30ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3254592',
  CIP13: '3400932545926',
  ucdLib: "ENDOTINE SOL DENT FL45ML",
  UCD7: '9355791',
  UCD13: '3400893557914',
  ucdQtyMultiplicator: 1,
  cipLib: "ENDOTINE SOL DENT FL45ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3269903',
  CIP13: '3400932699032',
  ucdLib: "FLUORESCEINE 0,5% FAURE CY",
  UCD7: '9105433',
  UCD13: '3400891054330',
  ucdQtyMultiplicator: 20,
  cipLib: "FLUORESCEINE 0,5% FAURE CY BT 20",
  atcCode: "S01JA01"
}, {
  CIP7: '3259738',
  CIP13: '3400932597383',
  ucdLib: "LEHNING GTT N57 FL30ML",
  UCD7: '9052352',
  UCD13: '3400890523523',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N57 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3268619',
  CIP13: '3400932686193',
  ucdLib: "NOOTROPYL 800MG CPR",
  UCD7: '9123141',
  UCD13: '3400891231410',
  ucdQtyMultiplicator: 90,
  cipLib: "NOOTROPYL 800MG CPR BT 90",
  atcCode: "N06BX03"
}, {
  CIP7: '3250269',
  CIP13: '3400932502691',
  ucdLib: "PANOXYL 10% GEL LOC TB40G",
  UCD7: '9067299',
  UCD13: '3400890672993',
  ucdQtyMultiplicator: 1,
  cipLib: "PANOXYL 10% GEL LOC TB40G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '3190277',
  CIP13: '3400931902775',
  ucdLib: "PARAMINAN 500MG CPR",
  UCD7: '9067543',
  UCD13: '3400890675437',
  ucdQtyMultiplicator: 120,
  cipLib: "PARAMINAN 500MG CPR BT 120",
  atcCode: "D02BA01"
}, {
  CIP7: '3250200',
  CIP13: '3400932502004',
  ucdLib: "PEPTAVLON INJ AMP2ML",
  UCD7: '9069996',
  UCD13: '3400890699969',
  ucdQtyMultiplicator: 5,
  cipLib: "PEPTAVLON INJ AMP2ML BT 5",
  atcCode: "V04CG04"
}, {
  CIP7: '3257277',
  CIP13: '3400932572779',
  ucdLib: "PHARMACILLINE COLLU FL35ML",
  UCD7: '9070829',
  UCD13: '3400890708296',
  ucdQtyMultiplicator: 1,
  cipLib: "PHARMACILLINE COLLU FL35ML BT 1",
  atcCode: "R02AB30"
}, {
  CIP7: '3313900',
  CIP13: '3400933139001',
  ucdLib: "POLYRINSE SOL LENTIL FL15ML",
  UCD7: '9107834',
  UCD13: '3400891078343',
  ucdQtyMultiplicator: 30,
  cipLib: "POLYRINSE SOL LENTIL FL15ML BT 30",
  atcCode: "S01XA20"
}, {
  CIP7: '3253747',
  CIP13: '3400932537471',
  ucdLib: "PSORADERM-5 20MG CPR SECAB",
  UCD7: '9076625',
  UCD13: '3400890766258',
  ucdQtyMultiplicator: 50,
  cipLib: "PSORADERM-5 20MG CPR SECAB BT 50",
  atcCode: "D05BA03"
}, {
  CIP7: '3191791',
  CIP13: '3400931917915',
  ucdLib: "PULMO-DRAINOL GTT FL30ML",
  UCD7: '9076772',
  UCD13: '3400890767729',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMO-DRAINOL GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3263094',
  CIP13: '3400932630943',
  ucdLib: "RINGER BSD P.500ML",
  UCD7: '9152361',
  UCD13: '3400891523614',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER BSD P.500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3263154',
  CIP13: '3400932631544',
  ucdLib: "RINGER LAC BSD P.500ML",
  UCD7: '9132884',
  UCD13: '3400891328844',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC BSD P.500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3310994',
  CIP13: '3400933109943',
  ucdLib: "SOLACY PEDIA CPR BUV",
  UCD7: '9149703',
  UCD13: '3400891497038',
  ucdQtyMultiplicator: 90,
  cipLib: "SOLACY PEDIA CPR BUV BT 90",
  atcCode: "R05X"
}, {
  CIP7: '3100067',
  CIP13: '3400931000679',
  ucdLib: "STODAL SIR FL200ML",
  UCD7: '9088031',
  UCD13: '3400890880312',
  ucdQtyMultiplicator: 1,
  cipLib: "STODAL SIR FL200ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3101546',
  CIP13: '3400931015468',
  ucdLib: "SULFURYL 200MG CPR CROQ",
  UCD7: '9089036',
  UCD13: '3400890890366',
  ucdQtyMultiplicator: 30,
  cipLib: "SULFURYL 200MG CPR CROQ BT 30",
  atcCode: "R07AX"
}, {
  CIP7: '3102801',
  CIP13: '3400931028017',
  ucdLib: "SYNERGON INJ AMP1ML",
  UCD7: '9090022',
  UCD13: '3400890900225',
  ucdQtyMultiplicator: 3,
  cipLib: "SYNERGON INJ AMP1ML BT 3",
  atcCode: "G03FA04"
}, {
  CIP7: '3106420',
  CIP13: '3400931064206',
  ucdLib: "TIBER SEDATIF SIR FL150ML",
  UCD7: '9093049',
  UCD13: '3400890930499',
  ucdQtyMultiplicator: 1,
  cipLib: "TIBER SEDATIF SIR FL150ML BT 1",
  atcCode: "N05CM11"
}, {
  CIP7: '3247008',
  CIP13: '3400932470082',
  ucdLib: "ALMA 2MG PATE",
  UCD7: '9003218',
  UCD13: '3400890032186',
  ucdQtyMultiplicator: 1,
  cipLib: "ALMA 2MG PATE BT 1",
  atcCode: "R05CA"
}, {
  CIP7: '3240408',
  CIP13: '3400932404087',
  ucdLib: "ALPAGELLE CR TB80G",
  UCD7: '9003336',
  UCD13: '3400890033367',
  ucdQtyMultiplicator: 1,
  cipLib: "ALPAGELLE CR TB80G BT 1",
  atcCode: "G02BB"
}, {
  CIP7: '3337361',
  CIP13: '3400933373610',
  ucdLib: "AMPICILLINE PAN 2G FL",
  UCD7: '9164938',
  UCD13: '3400891649383',
  ucdQtyMultiplicator: 25,
  cipLib: "AMPICILLINE PAN 2G FL BT 25",
  atcCode: "J01CA01"
}, {
  CIP7: '3337355',
  CIP13: '3400933373559',
  ucdLib: "AMPICILLINE PAN 500MG FL",
  UCD7: '9164944',
  UCD13: '3400891649444',
  ucdQtyMultiplicator: 25,
  cipLib: "AMPICILLINE PAN 500MG FL BT 25",
  atcCode: "J01CA01"
}, {
  CIP7: '3335729',
  CIP13: '3400933357290',
  ucdLib: "ARKOGELULES BUSSEROLE",
  UCD7: '9155098',
  UCD13: '3400891550986',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES BUSSEROLE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3309666',
  CIP13: '3400933096663',
  ucdLib: "ARKOGELULES CASSIS GELU",
  UCD7: '9136712',
  UCD13: '3400891367126',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES CASSIS GELU BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3335675',
  CIP13: '3400933356750',
  ucdLib: "ARKOGELULES CHARDON MARIE",
  UCD7: '9155112',
  UCD13: '3400891551129',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES CHARDON MARIE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3335764',
  CIP13: '3400933357641',
  ucdLib: "ARKOGELULES CUPALINE",
  UCD7: '9155135',
  UCD13: '3400891551358',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES CUPALINE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3335770',
  CIP13: '3400933357702',
  ucdLib: "ARKOGELULES CUPALINE",
  UCD7: '9155135',
  UCD13: '3400891551358',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES CUPALINE BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3303385',
  CIP13: '3400933033859',
  ucdLib: "ARKOGELULES HOUBLON GELU",
  UCD7: '9125588',
  UCD13: '3400891255881',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES HOUBLON GELU BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3331855',
  CIP13: '3400933318550',
  ucdLib: "ARKOGELULES PASSIFLORE",
  UCD7: '9134529',
  UCD13: '3400891345292',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES PASSIFLORE BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3303445',
  CIP13: '3400933034450',
  ucdLib: "ARKOGELULES REINE PRES",
  UCD7: '9129480',
  UCD13: '3400891294804',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES REINE PRES BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3303451',
  CIP13: '3400933034511',
  ucdLib: "ARKOGELULES REINE PRES",
  UCD7: '9129480',
  UCD13: '3400891294804',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES REINE PRES BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3307495',
  CIP13: '3400933074951',
  ucdLib: "ARTHRODONT 1% PATE GGVL TB5G",
  UCD7: '9249853',
  UCD13: '3400892498539',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTHRODONT 1% PATE GGVL TB5G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3335882',
  CIP13: '3400933358822',
  ucdLib: "BACTOX 125MG/5ML BUV FL60ML",
  UCD7: '9149910',
  UCD13: '3400891499100',
  ucdQtyMultiplicator: 1,
  cipLib: "BACTOX 125MG/5ML BUV FL60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3335876',
  CIP13: '3400933358761',
  ucdLib: "BACTOX 250MG/5ML BUV FL60ML",
  UCD7: '9149927',
  UCD13: '3400891499278',
  ucdQtyMultiplicator: 1,
  cipLib: "BACTOX 250MG/5ML BUV FL60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3337852',
  CIP13: '3400933378523',
  ucdLib: "CAMILINE GELU",
  UCD7: '9140777',
  UCD13: '3400891407778',
  ucdQtyMultiplicator: 150,
  cipLib: "CAMILINE GELU BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3337349',
  CIP13: '3400933373498',
  ucdLib: "CEFALOTINE PAN 1G INJ FL",
  UCD7: '9164950',
  UCD13: '3400891649505',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFALOTINE PAN 1G INJ FL BT 25",
  atcCode: "J01DB03"
}, {
  CIP7: '5561387',
  CIP13: '3400955613879',
  ucdLib: "CEFAZOLINE PAN 0,5G/5ML FL",
  UCD7: '9134630',
  UCD13: '3400891346305',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFAZOLINE PAN 0,5G/5ML FL BT 25",
  atcCode: "J01DB04"
}, {
  CIP7: '3303830',
  CIP13: '3400933038304',
  ucdLib: "CYCLO 3 FORT GELU",
  UCD7: '9119116',
  UCD13: '3400891191165',
  ucdQtyMultiplicator: 30,
  cipLib: "CYCLO 3 FORT GELU BT 30",
  atcCode: "C05CX"
}, {
  CIP7: '3303847',
  CIP13: '3400933038472',
  ucdLib: "CYCLO 3 FORT GELU",
  UCD7: '9119116',
  UCD13: '3400891191165',
  ucdQtyMultiplicator: 30,
  cipLib: "CYCLO 3 FORT GELU BT 30",
  atcCode: "C05CX"
}, {
  CIP7: '3303876',
  CIP13: '3400933038762',
  ucdLib: "CYCLO 3 FORT GELU",
  UCD7: '9119116',
  UCD13: '3400891191165',
  ucdQtyMultiplicator: 60,
  cipLib: "CYCLO 3 FORT GELU BT 60",
  atcCode: "C05CX"
}, {
  CIP7: '5560689',
  CIP13: '3400955606895',
  ucdLib: "CYTARABINE EBW 50MG/ML FL20ML",
  UCD7: '9305764',
  UCD13: '3400893057643',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE EBW 50MG/ML FL20ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5561269',
  CIP13: '3400955612698',
  ucdLib: "DAFALGAN CODEINE CPR EFFV",
  UCD7: '9128871',
  UCD13: '3400891288711',
  ucdQtyMultiplicator: 100,
  cipLib: "DAFALGAN CODEINE CPR EFFV BT 100",
  atcCode: "N02BE51"
}, {
  CIP7: '5569012',
  CIP13: '3400955690122',
  ucdLib: "DIPRIVAN 500MG IV FL50ML",
  UCD7: '9145881',
  UCD13: '3400891458817',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPRIVAN 500MG IV FL50ML BT 1",
  atcCode: "N01AX10"
}, {
  CIP7: '5563133',
  CIP13: '3400955631330',
  ucdLib: "DPCA2 DIA.PER. P.1000ML",
  UCD7: '9134699',
  UCD13: '3400891346992',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA2 DIA.PER. P.1000ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563156',
  CIP13: '3400955631569',
  ucdLib: "DPCA2 DIA.PER. P.1500ML",
  UCD7: '9135109',
  UCD13: '3400891351095',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA2 DIA.PER. P.1500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563179',
  CIP13: '3400955631798',
  ucdLib: "DPCA2 DIA.PER. P.2500ML",
  UCD7: '9135121',
  UCD13: '3400891351217',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA2 DIA.PER. P.2500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563127',
  CIP13: '3400955631279',
  ucdLib: "DPCA2 DIA.PER. P.500ML",
  UCD7: '9135138',
  UCD13: '3400891351385',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA2 DIA.PER. P.500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563297',
  CIP13: '3400955632979',
  ucdLib: "DPCA3 DIA.PER. P.1000ML",
  UCD7: '9135256',
  UCD13: '3400891352566',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA3 DIA.PER. P.1000ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563305',
  CIP13: '3400955633051',
  ucdLib: "DPCA3 DIA.PER. P.1500ML",
  UCD7: '9135262',
  UCD13: '3400891352627',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA3 DIA.PER. P.1500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563328',
  CIP13: '3400955633280',
  ucdLib: "DPCA3 DIA.PER. P.2500ML",
  UCD7: '9135285',
  UCD13: '3400891352856',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA3 DIA.PER. P.2500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563274',
  CIP13: '3400955632740',
  ucdLib: "DPCA3 DIA.PER. P.500ML",
  UCD7: '9135291',
  UCD13: '3400891352917',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA3 DIA.PER. P.500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563222',
  CIP13: '3400955632221',
  ucdLib: "DPCA4 DIA.PER. P.1000ML",
  UCD7: '9135397',
  UCD13: '3400891353976',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA4 DIA.PER. P.1000ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563239',
  CIP13: '3400955632399',
  ucdLib: "DPCA4 DIA.PER. P.1500ML",
  UCD7: '9135405',
  UCD13: '3400891354058',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA4 DIA.PER. P.1500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563245',
  CIP13: '3400955632450',
  ucdLib: "DPCA4 DIA.PER. P.2000ML",
  UCD7: '9135411',
  UCD13: '3400891354119',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA4 DIA.PER. P.2000ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563251',
  CIP13: '3400955632511',
  ucdLib: "DPCA4 DIA.PER. P.2500ML",
  UCD7: '9136126',
  UCD13: '3400891361261',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA4 DIA.PER. P.2500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '5563191',
  CIP13: '3400955631910',
  ucdLib: "DPCA4 DIA.PER. P.500ML",
  UCD7: '9135428',
  UCD13: '3400891354287',
  ucdQtyMultiplicator: 1,
  cipLib: "DPCA4 DIA.PER. P.500ML BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3330413',
  CIP13: '3400933304133',
  ucdLib: "ECHOVIST 3G IV FL+FL",
  UCD7: '9165889',
  UCD13: '3400891658897',
  ucdQtyMultiplicator: 1,
  cipLib: "ECHOVIST 3G IV FL+FL BT 1",
  atcCode: "V08DA02"
}, {
  CIP7: '5560809',
  CIP13: '3400955608097',
  ucdLib: "HF 02 FRESENIUS INJ P.5000ML",
  UCD7: '9133961',
  UCD13: '3400891339611',
  ucdQtyMultiplicator: 2,
  cipLib: "HF 02 FRESENIUS INJ P.5000ML BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '5560778',
  CIP13: '3400955607786',
  ucdLib: "HF 11 FRESENIUS INJ P.4500ML",
  UCD7: '9133978',
  UCD13: '3400891339789',
  ucdQtyMultiplicator: 2,
  cipLib: "HF 11 FRESENIUS INJ P.4500ML BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '5560784',
  CIP13: '3400955607847',
  ucdLib: "HF 23 FRESENIUS INJ P.4500ML",
  UCD7: '9133984',
  UCD13: '3400891339840',
  ucdQtyMultiplicator: 2,
  cipLib: "HF 23 FRESENIUS INJ P.4500ML BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '5560790',
  CIP13: '3400955607908',
  ucdLib: "HF 25 FRESENIUS INJ P.4500ML",
  UCD7: '9133990',
  UCD13: '3400891339901',
  ucdQtyMultiplicator: 2,
  cipLib: "HF 25 FRESENIUS INJ P.4500ML BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '5563707',
  CIP13: '3400955637073',
  ucdLib: "HYPNOVEL 5MG/ML INJ AMP1ML",
  UCD7: '9120562',
  UCD13: '3400891205626',
  ucdQtyMultiplicator: 6,
  cipLib: "HYPNOVEL 5MG/ML INJ AMP1ML BT 6",
  atcCode: "N05CD08"
}, {
  CIP7: '5562636',
  CIP13: '3400955626367',
  ucdLib: "LEVOCARNIL 1G/5ML INJ AMP",
  UCD7: '9126085',
  UCD13: '3400891260854',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOCARNIL 1G/5ML INJ AMP BT 5",
  atcCode: "A16AA01"
}, {
  CIP7: '3070308',
  CIP13: '3400930703083',
  ucdLib: "NAUTAMINE CPR",
  UCD7: '9061210',
  UCD13: '3400890612104',
  ucdQtyMultiplicator: 20,
  cipLib: "NAUTAMINE CPR BT 20",
  atcCode: "R06AA02"
}, {
  CIP7: '3071934',
  CIP13: '3400930719343',
  ucdLib: "NEUROSTHENOL BUV AMP5ML",
  UCD7: '9062600',
  UCD13: '3400890626002',
  ucdQtyMultiplicator: 20,
  cipLib: "NEUROSTHENOL BUV AMP5ML BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3247422',
  CIP13: '3400932474226',
  ucdLib: "NOVOPTINE COLLY FL10ML",
  UCD7: '9064059',
  UCD13: '3400890640596',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOPTINE COLLY FL10ML BT 1",
  atcCode: "S01AX"
}, {
  CIP7: '3074743',
  CIP13: '3400930747438',
  ucdLib: "ODDIBIL 250MG CPR ENROB",
  UCD7: '9064533',
  UCD13: '3400890645331',
  ucdQtyMultiplicator: 40,
  cipLib: "ODDIBIL 250MG CPR ENROB BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '3075145',
  CIP13: '3400930751459',
  ucdLib: "OLIGOSOL FLUOR BUV A.2ML",
  UCD7: '9064852',
  UCD13: '3400890648523',
  ucdQtyMultiplicator: 14,
  cipLib: "OLIGOSOL FLUOR BUV A.2ML BT 14",
  atcCode: "V03AX"
}, {
  CIP7: '3075240',
  CIP13: '3400930752401',
  ucdLib: "OLIGOSOL ZINC BUV A.2ML",
  UCD7: '9064987',
  UCD13: '3400890649872',
  ucdQtyMultiplicator: 14,
  cipLib: "OLIGOSOL ZINC BUV A.2ML BT 14",
  atcCode: "V03AX"
}, {
  CIP7: '3075257',
  CIP13: '3400930752579',
  ucdLib: "OLIGOSOL ZN-CU BUV A.2ML",
  UCD7: '9064993',
  UCD13: '3400890649933',
  ucdQtyMultiplicator: 14,
  cipLib: "OLIGOSOL ZN-CU BUV A.2ML BT 14",
  atcCode: "V03AX"
}, {
  CIP7: '3339816',
  CIP13: '3400933398163',
  ucdLib: "OPTI-FREE SOL LENTIL 15ML",
  UCD7: '9150103',
  UCD13: '3400891501032',
  ucdQtyMultiplicator: 6,
  cipLib: "OPTI-FREE SOL LENTIL 15ML BT 6",
  atcCode: "S01XA20"
}, {
  CIP7: '3076392',
  CIP13: '3400930763926',
  ucdLib: "OSCILLOCOCCINUM GM GLB DOS",
  UCD7: '9065969',
  UCD13: '3400890659697',
  ucdQtyMultiplicator: 1,
  cipLib: "OSCILLOCOCCINUM GM GLB DOS BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3076512',
  CIP13: '3400930765128',
  ucdLib: "OSTEOCYNESINE CPR",
  UCD7: '9066124',
  UCD13: '3400890661249',
  ucdQtyMultiplicator: 60,
  cipLib: "OSTEOCYNESINE CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3076699',
  CIP13: '3400930766996',
  ucdLib: "OTYLOL GTT AURIC FL10ML",
  UCD7: '9066325',
  UCD13: '3400890663250',
  ucdQtyMultiplicator: 1,
  cipLib: "OTYLOL GTT AURIC FL10ML BT 1",
  atcCode: "S02DC"
}, {
  CIP7: '3077776',
  CIP13: '3400930777763',
  ucdLib: "PALIURYL 25% BUV GTT FL30ML",
  UCD7: '9067000',
  UCD13: '3400890670005',
  ucdQtyMultiplicator: 1,
  cipLib: "PALIURYL 25% BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3078385',
  CIP13: '3400930783856',
  ucdLib: "PARAGRIPPE CPR",
  UCD7: '9067508',
  UCD13: '3400890675086',
  ucdQtyMultiplicator: 60,
  cipLib: "PARAGRIPPE CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3078592',
  CIP13: '3400930785928',
  ucdLib: "PAREGORIQUE LAFRAN CPR",
  UCD7: '9067661',
  UCD13: '3400890676618',
  ucdQtyMultiplicator: 20,
  cipLib: "PAREGORIQUE LAFRAN CPR BT 20",
  atcCode: "A07DA02"
}, {
  CIP7: '3078712',
  CIP13: '3400930787120',
  ucdLib: "PARNEL DEPURATIF SIR FL150ML",
  UCD7: '9067810',
  UCD13: '3400890678100',
  ucdQtyMultiplicator: 1,
  cipLib: "PARNEL DEPURATIF SIR FL150ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3078818',
  CIP13: '3400930788189',
  ucdLib: "PASSIFLORINE BUV FV125ML",
  UCD7: '9067968',
  UCD13: '3400890679688',
  ucdQtyMultiplicator: 1,
  cipLib: "PASSIFLORINE BUV FV125ML BT 1",
  atcCode: "V03A"
}, {
  CIP7: '3302167',
  CIP13: '3400933021672',
  ucdLib: "PEDIAZOLE GLE SIR FV100ML",
  UCD7: '9131301',
  UCD13: '3400891313017',
  ucdQtyMultiplicator: 1,
  cipLib: "PEDIAZOLE GLE SIR FV100ML BT 1",
  atcCode: "J01RA02"
}, {
  CIP7: '3336338',
  CIP13: '3400933363383',
  ucdLib: "PHAPAX BUV GTT FL30ML",
  UCD7: '9154839',
  UCD13: '3400891548396',
  ucdQtyMultiplicator: 1,
  cipLib: "PHAPAX BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3300553',
  CIP13: '3400933005535',
  ucdLib: "PHARMATEX 18,9MG MINI OVULE",
  UCD7: '9127021',
  UCD13: '3400891270211',
  ucdQtyMultiplicator: 10,
  cipLib: "PHARMATEX 18,9MG MINI OVULE BT 10",
  atcCode: "G02BB"
}, {
  CIP7: '3300576',
  CIP13: '3400933005764',
  ucdLib: "PHARMATEX 18,9MG MINI OVULE",
  UCD7: '9127021',
  UCD13: '3400891270211',
  ucdQtyMultiplicator: 20,
  cipLib: "PHARMATEX 18,9MG MINI OVULE BT 20",
  atcCode: "G02BB"
}, {
  CIP7: '5562843',
  CIP13: '3400955628439',
  ucdLib: "PROZAC 20MG GELU",
  UCD7: '9137686',
  UCD13: '3400891376869',
  ucdQtyMultiplicator: 70,
  cipLib: "PROZAC 20MG GELU BT 70",
  atcCode: "N06AB03"
}, {
  CIP7: '3336189',
  CIP13: '3400933361891',
  ucdLib: "SEDATIF PC GRLS",
  UCD7: '9066868',
  UCD13: '3400890668682',
  ucdQtyMultiplicator: 160,
  cipLib: "SEDATIF PC GRLS BT 160",
  atcCode: "V03AX"
}, {
  CIP7: '4911158',
  CIP13: '3400949111589',
  ucdLib: "SIMVASTATINE PFZ 40MG CPR",
  UCD7: '9367529',
  UCD13: '3400893675298',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE PFZ 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '4911193',
  CIP13: '3400949111930',
  ucdLib: "SIMVASTATINE PFZ 40MG CPR",
  UCD7: '9367529',
  UCD13: '3400893675298',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE PFZ 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '5560169',
  CIP13: '3400955601692',
  ucdLib: "SODIUM 0,9% BLZ INJ P.250ML",
  UCD7: '9129221',
  UCD13: '3400891292213',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BLZ INJ P.250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3337148',
  CIP13: '3400933371487',
  ucdLib: "SOLACY PEDIA CPR BUV",
  UCD7: '9149703',
  UCD13: '3400891497038',
  ucdQtyMultiplicator: 30,
  cipLib: "SOLACY PEDIA CPR BUV BT 30",
  atcCode: "R05X"
}, {
  CIP7: '3242287',
  CIP13: '3400932422876',
  ucdLib: "SPANOR 100MG CPR",
  UCD7: '9086612',
  UCD13: '3400890866125',
  ucdQtyMultiplicator: 5,
  cipLib: "SPANOR 100MG CPR BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '3336195',
  CIP13: '3400933361952',
  ucdLib: "STODAL GRLS",
  UCD7: '9104818',
  UCD13: '3400891048186',
  ucdQtyMultiplicator: 160,
  cipLib: "STODAL GRLS BT 160",
  atcCode: "V03AX"
}, {
  CIP7: '5567817',
  CIP13: '3400955678175',
  ucdLib: "TIAPRIDE PAN 100MG INJ A.2ML",
  UCD7: '9131459',
  UCD13: '3400891314595',
  ucdQtyMultiplicator: 100,
  cipLib: "TIAPRIDE PAN 100MG INJ A.2ML BT 100",
  atcCode: "N05AL03"
}, {
  CIP7: '3241112',
  CIP13: '3400932411122',
  ucdLib: "VAMINE GLUCOSE IV FV100ML",
  UCD7: '9117117',
  UCD13: '3400891171174',
  ucdQtyMultiplicator: 1,
  cipLib: "VAMINE GLUCOSE IV FV100ML BT 1",
  atcCode: "B05BA10"
}, {
  CIP7: '3241129',
  CIP13: '3400932411290',
  ucdLib: "VAMINE GLUCOSE IV FV500ML",
  UCD7: '9117146',
  UCD13: '3400891171464',
  ucdQtyMultiplicator: 1,
  cipLib: "VAMINE GLUCOSE IV FV500ML BT 1",
  atcCode: "B05BA10"
}, {
  CIP7: '3307615',
  CIP13: '3400933076153',
  ucdLib: "VOXPAX CPR",
  UCD7: '9132909',
  UCD13: '3400891329094',
  ucdQtyMultiplicator: 60,
  cipLib: "VOXPAX CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3091919',
  CIP13: '3400930919194',
  ucdLib: "ARUM TRIPHYL COMP ROCAL CPR",
  UCD7: '9006932',
  UCD13: '3400890069328',
  ucdQtyMultiplicator: 1,
  cipLib: "ARUM TRIPHYL COMP ROCAL CPR BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5577431',
  CIP13: '3400955774310',
  ucdLib: "BETADINE 5% IRR OCUL FL50ML",
  UCD7: '9156270',
  UCD13: '3400891562705',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 5% IRR OCUL FL50ML BT 1",
  atcCode: "S01AX18"
}, {
  CIP7: '5576242',
  CIP13: '3400955762423',
  ucdLib: "BUCANEST ADR.1/100M CART.",
  UCD7: '9161696',
  UCD13: '3400891616965',
  ucdQtyMultiplicator: 50,
  cipLib: "BUCANEST ADR.1/100M CART. BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5576213',
  CIP13: '3400955762133',
  ucdLib: "BUCANEST ADR.1/200M CART.",
  UCD7: '9161704',
  UCD13: '3400891617047',
  ucdQtyMultiplicator: 50,
  cipLib: "BUCANEST ADR.1/200M CART. BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '3222876',
  CIP13: '3400932228768',
  ucdLib: "CALCIBRONAT 2G CPR EFFV",
  UCD7: '9014417',
  UCD13: '3400890144179',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIBRONAT 2G CPR EFFV BT 60",
  atcCode: "N05CM11"
}, {
  CIP7: '3609629',
  CIP13: '3400936096295',
  ucdLib: "CAMILIA BUV UNIDOS1ML",
  UCD7: '9249698',
  UCD13: '3400892496986',
  ucdQtyMultiplicator: 10,
  cipLib: "CAMILIA BUV UNIDOS1ML BT 10",
  atcCode: "V03AX"
}, {
  CIP7: '5570908',
  CIP13: '3400955709084',
  ucdLib: "CHLORHEXIDINE GIF AV/COL 500ML",
  UCD7: '9275017',
  UCD13: '3400892750170',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIF AV/COL 500ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '5575159',
  CIP13: '3400955751595',
  ucdLib: "CITICOLINE PAN 250MG INJ AMP",
  UCD7: '9154153',
  UCD13: '3400891541533',
  ucdQtyMultiplicator: 10,
  cipLib: "CITICOLINE PAN 250MG INJ AMP BT 10",
  atcCode: "N06BX06"
}, {
  CIP7: '5575165',
  CIP13: '3400955751656',
  ucdLib: "CITICOLINE PAN 500MG INJ AMP",
  UCD7: '9154176',
  UCD13: '3400891541762',
  ucdQtyMultiplicator: 10,
  cipLib: "CITICOLINE PAN 500MG INJ AMP BT 10",
  atcCode: "N06BX06"
}, {
  CIP7: '5571569',
  CIP13: '3400955715696',
  ucdLib: "DAFALGAN CODEINE CPR",
  UCD7: '9147928',
  UCD13: '3400891479287',
  ucdQtyMultiplicator: 100,
  cipLib: "DAFALGAN CODEINE CPR BT 100",
  atcCode: "N02BE51"
}, {
  CIP7: '3609664',
  CIP13: '3400936096646',
  ucdLib: "DIARALIA CPR",
  UCD7: '9263250',
  UCD13: '3400892632506',
  ucdQtyMultiplicator: 40,
  cipLib: "DIARALIA CPR BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '3600812',
  CIP13: '3400936008120',
  ucdLib: "DPCA3 DIA.PER. STS2500ML",
  UCD7: '9243046',
  UCD13: '3400892430461',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA3 DIA.PER. STS2500ML BT 4",
  atcCode: ""
}, {
  CIP7: '5570423',
  CIP13: '3400955704232',
  ucdLib: "EAU P.P.I AGT FV1000ML",
  UCD7: '9110003',
  UCD13: '3400891100037',
  ucdQtyMultiplicator: 6,
  cipLib: "EAU P.P.I AGT FV1000ML BT 6",
  atcCode: "V07AB"
}, {
  CIP7: '5570452',
  CIP13: '3400955704522',
  ucdLib: "EAU P.P.I AGT FV250ML",
  UCD7: '9176120',
  UCD13: '3400891761207',
  ucdQtyMultiplicator: 12,
  cipLib: "EAU P.P.I AGT FV250ML BT 12",
  atcCode: "V07AB"
}, {
  CIP7: '5570446',
  CIP13: '3400955704461',
  ucdLib: "EAU P.P.I AGT FV500ML",
  UCD7: '9110032',
  UCD13: '3400891100327',
  ucdQtyMultiplicator: 12,
  cipLib: "EAU P.P.I AGT FV500ML BT 12",
  atcCode: "V07AB"
}, {
  CIP7: '3376214',
  CIP13: '3400933762148',
  ucdLib: "ELUSANES GDE CAMOMIL GELU",
  UCD7: '9173452',
  UCD13: '3400891734522',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES GDE CAMOMIL GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3604247',
  CIP13: '3400936042476',
  ucdLib: "ELUSANES HARPAGOPHYTON GELU",
  UCD7: '9257396',
  UCD13: '3400892573960',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES HARPAGOPHYTON GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3604253',
  CIP13: '3400936042537',
  ucdLib: "ELUSANES HARPAGOPHYTON GELU",
  UCD7: '9257396',
  UCD13: '3400892573960',
  ucdQtyMultiplicator: 60,
  cipLib: "ELUSANES HARPAGOPHYTON GELU BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3376361',
  CIP13: '3400933763619',
  ucdLib: "ELUSANES MARRON INDE GELU",
  UCD7: '9176812',
  UCD13: '3400891768121',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES MARRON INDE GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '5578838',
  CIP13: '3400955788386',
  ucdLib: "ETOPOSIDE PFM100MG INJ FL5ML",
  UCD7: '9157246',
  UCD13: '3400891572469',
  ucdQtyMultiplicator: 5,
  cipLib: "ETOPOSIDE PFM100MG INJ FL5ML BT 5",
  atcCode: "L01CB01"
}, {
  CIP7: '3604655',
  CIP13: '3400936046559',
  ucdLib: "GLUCOSE 10% MAC INJ P.50ML+NEC",
  UCD7: '9199411',
  UCD13: '3400891994117',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P.50ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604709',
  CIP13: '3400936047099',
  ucdLib: "GLUCOSE 10% MAC INJ P1000ML+N.",
  UCD7: '9199380',
  UCD13: '3400891993806',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P1000ML+N. BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604661',
  CIP13: '3400936046610',
  ucdLib: "GLUCOSE 10% MAC INJ P100ML+NEC",
  UCD7: '9199374',
  UCD13: '3400891993745',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P100ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604678',
  CIP13: '3400936046788',
  ucdLib: "GLUCOSE 10% MAC INJ P150ML+NEC",
  UCD7: '9199397',
  UCD13: '3400891993974',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P150ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604684',
  CIP13: '3400936046849',
  ucdLib: "GLUCOSE 10% MAC INJ P250ML+NEC",
  UCD7: '9199405',
  UCD13: '3400891994056',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P250ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604690',
  CIP13: '3400936046900',
  ucdLib: "GLUCOSE 10% MAC INJ P500ML+NEC",
  UCD7: '9199428',
  UCD13: '3400891994285',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P500ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3378727',
  CIP13: '3400933787271',
  ucdLib: "HIBIDIL SOL LOC UNIDOS15ML",
  UCD7: '9169083',
  UCD13: '3400891690835',
  ucdQtyMultiplicator: 1,
  cipLib: "HIBIDIL SOL LOC UNIDOS15ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3609718',
  CIP13: '3400936097186',
  ucdLib: "HOMEOTONYL GLE TB",
  UCD7: '9299880',
  UCD13: '3400892998800',
  ucdQtyMultiplicator: 3,
  cipLib: "HOMEOTONYL GLE TB BT 3",
  atcCode: "V03AX"
}, {
  CIP7: '5575509',
  CIP13: '3400955755098',
  ucdLib: "HYPNOVEL 1MG/ML INJ AMP5ML",
  UCD7: '9153774',
  UCD13: '3400891537741',
  ucdQtyMultiplicator: 6,
  cipLib: "HYPNOVEL 1MG/ML INJ AMP5ML BT 6",
  atcCode: "N05CD08"
}, {
  CIP7: '3370128',
  CIP13: '3400933701284',
  ucdLib: "LEHNING GTT N1 FL30ML",
  UCD7: '9174492',
  UCD13: '3400891744927',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N1 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370223',
  CIP13: '3400933702236',
  ucdLib: "LEHNING GTT N18 FL30ML",
  UCD7: '9174664',
  UCD13: '3400891746648',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N18 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370269',
  CIP13: '3400933702694',
  ucdLib: "LEHNING GTT N26 FL30ML",
  UCD7: '9174701',
  UCD13: '3400891747010',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N26 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370140',
  CIP13: '3400933701406',
  ucdLib: "LEHNING GTT N3 FL30ML",
  UCD7: '9174718',
  UCD13: '3400891747188',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N3 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370312',
  CIP13: '3400933703127',
  ucdLib: "LEHNING GTT N37 FL30ML",
  UCD7: '9174776',
  UCD13: '3400891747768',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N37 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370329',
  CIP13: '3400933703295',
  ucdLib: "LEHNING GTT N40 FL30ML",
  UCD7: '9174782',
  UCD13: '3400891747829',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N40 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370387',
  CIP13: '3400933703875',
  ucdLib: "LEHNING GTT N49 FL30ML",
  UCD7: '9174859',
  UCD13: '3400891748598',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N49 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370157',
  CIP13: '3400933701574',
  ucdLib: "LEHNING GTT N5 FL30ML",
  UCD7: '9174865',
  UCD13: '3400891748659',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N5 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370163',
  CIP13: '3400933701635',
  ucdLib: "LEHNING GTT N6 FL30ML",
  UCD7: '9174894',
  UCD13: '3400891748949',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N6 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370424',
  CIP13: '3400933704247',
  ucdLib: "LEHNING GTT N61 FL30ML",
  UCD7: '9174919',
  UCD13: '3400891749199',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N61 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370430',
  CIP13: '3400933704308',
  ucdLib: "LEHNING GTT N62 FL30ML",
  UCD7: '9174925',
  UCD13: '3400891749250',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N62 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370453',
  CIP13: '3400933704537',
  ucdLib: "LEHNING GTT N64 FL30ML",
  UCD7: '9174948',
  UCD13: '3400891749489',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N64 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370476',
  CIP13: '3400933704766',
  ucdLib: "LEHNING GTT N65 FL30ML",
  UCD7: '9174954',
  UCD13: '3400891749540',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N65 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370482',
  CIP13: '3400933704827',
  ucdLib: "LEHNING GTT N70 FL30ML",
  UCD7: '9174977',
  UCD13: '3400891749779',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N70 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370499',
  CIP13: '3400933704995',
  ucdLib: "LEHNING GTT N71 FL30ML",
  UCD7: '9174983',
  UCD13: '3400891749830',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N71 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370507',
  CIP13: '3400933705077',
  ucdLib: "LEHNING GTT N73 FL30ML",
  UCD7: '9175008',
  UCD13: '3400891750089',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N73 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370536',
  CIP13: '3400933705367',
  ucdLib: "LEHNING GTT N75 FL30ML",
  UCD7: '9175020',
  UCD13: '3400891750201',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N75 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370542',
  CIP13: '3400933705428',
  ucdLib: "LEHNING GTT N78 FL30ML",
  UCD7: '9175037',
  UCD13: '3400891750379',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N78 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370559',
  CIP13: '3400933705596',
  ucdLib: "LEHNING GTT N79 FL30ML",
  UCD7: '9175043',
  UCD13: '3400891750430',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N79 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370565',
  CIP13: '3400933705657',
  ucdLib: "LEHNING GTT N80 FL30ML",
  UCD7: '9175066',
  UCD13: '3400891750669',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N80 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370571',
  CIP13: '3400933705718',
  ucdLib: "LEHNING GTT N81 FL30ML",
  UCD7: '9175072',
  UCD13: '3400891750720',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N81 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370625',
  CIP13: '3400933706258',
  ucdLib: "LEHNING GTT N87 FL30ML",
  UCD7: '9175132',
  UCD13: '3400891751321',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N87 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370631',
  CIP13: '3400933706319',
  ucdLib: "LEHNING GTT N88 FL30ML",
  UCD7: '9175149',
  UCD13: '3400891751499',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N88 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370648',
  CIP13: '3400933706487',
  ucdLib: "LEHNING GTT N89 FL30ML",
  UCD7: '9175155',
  UCD13: '3400891751550',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N89 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3370192',
  CIP13: '3400933701925',
  ucdLib: "LEHNING GTT N9 FL30ML",
  UCD7: '9175161',
  UCD13: '3400891751611',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N9 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5572563',
  CIP13: '3400955725633',
  ucdLib: "OCUCOAT 2% SOL OCUL SERING",
  UCD7: '9153231',
  UCD13: '3400891532319',
  ucdQtyMultiplicator: 1,
  cipLib: "OCUCOAT 2% SOL OCUL SERING BT 1",
  atcCode: "S01KA02"
}, {
  CIP7: '3092037',
  CIP13: '3400930920374',
  ucdLib: "PAREIRA BRAV COMP ROCAL CPR",
  UCD7: '9067709',
  UCD13: '3400890677097',
  ucdQtyMultiplicator: 1,
  cipLib: "PAREIRA BRAV COMP ROCAL CPR BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3092043',
  CIP13: '3400930920435',
  ucdLib: "PASSIFLORA COMPOSE ROCAL CPR",
  UCD7: '9067951',
  UCD13: '3400890679510',
  ucdQtyMultiplicator: 1,
  cipLib: "PASSIFLORA COMPOSE ROCAL CPR BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3225395',
  CIP13: '3400932253951',
  ucdLib: "PENTICORT CR TB 30G",
  UCD7: '9069890',
  UCD13: '3400890698900',
  ucdQtyMultiplicator: 1,
  cipLib: "PENTICORT CR TB 30G BT 1",
  atcCode: "D07AC11"
}, {
  CIP7: '3224912',
  CIP13: '3400932249121',
  ucdLib: "PHARMATEX 18,9MG OV",
  UCD7: '9070924',
  UCD13: '3400890709248',
  ucdQtyMultiplicator: 10,
  cipLib: "PHARMATEX 18,9MG OV BT 10",
  atcCode: "G02BB"
}, {
  CIP7: '3377840',
  CIP13: '3400933778408',
  ucdLib: "PHYSIOTENS 0,2MG CPR",
  UCD7: '9184817',
  UCD13: '3400891848175',
  ucdQtyMultiplicator: 100,
  cipLib: "PHYSIOTENS 0,2MG CPR BT 100",
  atcCode: "C02AC05"
}, {
  CIP7: '3377917',
  CIP13: '3400933779177',
  ucdLib: "PHYSIOTENS 0,4MG CPR",
  UCD7: '9184823',
  UCD13: '3400891848236',
  ucdQtyMultiplicator: 100,
  cipLib: "PHYSIOTENS 0,4MG CPR BT 100",
  atcCode: "C02AC05"
}, {
  CIP7: '3602544',
  CIP13: '3400936025448',
  ucdLib: "PIRACETAM MYL 20% BUV FL125ML",
  UCD7: '9242756',
  UCD13: '3400892427560',
  ucdQtyMultiplicator: 1,
  cipLib: "PIRACETAM MYL 20% BUV FL125ML BT 1",
  atcCode: "N06BX03"
}, {
  CIP7: '3227046',
  CIP13: '3400932270460',
  ucdLib: "POLY-KARAYA GLE SACH10G",
  UCD7: '9073779',
  UCD13: '3400890737791',
  ucdQtyMultiplicator: 30,
  cipLib: "POLY-KARAYA GLE SACH10G BT 30",
  atcCode: "A02X"
}, {
  CIP7: '3372334',
  CIP13: '3400933723347',
  ucdLib: "POLYRINSE SOL LENTIL FL15ML",
  UCD7: '9107834',
  UCD13: '3400891078343',
  ucdQtyMultiplicator: 10,
  cipLib: "POLYRINSE SOL LENTIL FL15ML BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3379595',
  CIP13: '3400933795955',
  ucdLib: "REFRESH COLLY UNIDOS",
  UCD7: '9200077',
  UCD13: '3400892000770',
  ucdQtyMultiplicator: 10,
  cipLib: "REFRESH COLLY UNIDOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3090713',
  CIP13: '3400930907139',
  ucdLib: "REX DRAGEES CPR",
  UCD7: '9079345',
  UCD13: '3400890793452',
  ucdQtyMultiplicator: 40,
  cipLib: "REX DRAGEES CPR BT 40",
  atcCode: "A06AB20"
}, {
  CIP7: '3091279',
  CIP13: '3400930912799',
  ucdLib: "RHUBARBE LAFRAN 250MG CPR",
  UCD7: '9079948',
  UCD13: '3400890799485',
  ucdQtyMultiplicator: 30,
  cipLib: "RHUBARBE LAFRAN 250MG CPR BT 30",
  atcCode: "A06AB"
}, {
  CIP7: '3226555',
  CIP13: '3400932265558',
  ucdLib: "RIABAL ENF BUV SOL FV50ML",
  UCD7: '9117695',
  UCD13: '3400891176957',
  ucdQtyMultiplicator: 1,
  cipLib: "RIABAL ENF BUV SOL FV50ML BT 1",
  atcCode: "A03AB18"
}, {
  CIP7: '3371719',
  CIP13: '3400933717193',
  ucdLib: "SANOGYL FLUO 2 DENT TB115G",
  UCD7: '9172257',
  UCD13: '3400891722574',
  ucdQtyMultiplicator: 1,
  cipLib: "SANOGYL FLUO 2 DENT TB115G BT 1",
  atcCode: "A01AA30"
}, {
  CIP7: '3094289',
  CIP13: '3400930942895',
  ucdLib: "SANTAHERBA LEHNING GTT FL30ML",
  UCD7: '9082264',
  UCD13: '3400890822640',
  ucdQtyMultiplicator: 1,
  cipLib: "SANTAHERBA LEHNING GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3600284',
  CIP13: '3400936002845',
  ucdLib: "SANTANE O1 TIS SACH DOS",
  UCD7: '9227024',
  UCD13: '3400892270241',
  ucdQtyMultiplicator: 24,
  cipLib: "SANTANE O1 TIS SACH DOS BT 24",
  atcCode: "V03AX"
}, {
  CIP7: '3092126',
  CIP13: '3400930921265',
  ucdLib: "SAPONARIA COMPOSE ROCAL CPR",
  UCD7: '9082525',
  UCD13: '3400890825252',
  ucdQtyMultiplicator: 1,
  cipLib: "SAPONARIA COMPOSE ROCAL CPR BT 1",
  atcCode: "Z05"
}, {
  CIP7: '3094740',
  CIP13: '3400930947401',
  ucdLib: "SCHOUM SOL BUV FL540ML",
  UCD7: '9082815',
  UCD13: '3400890828154',
  ucdQtyMultiplicator: 1,
  cipLib: "SCHOUM SOL BUV FL540ML BT 1",
  atcCode: "A05AX"
}, {
  CIP7: '3608452',
  CIP13: '3400936084520',
  ucdLib: "SICCAFLUID 2,5MG/G GEL DOS",
  UCD7: '9276005',
  UCD13: '3400892760056',
  ucdQtyMultiplicator: 10,
  cipLib: "SICCAFLUID 2,5MG/G GEL DOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3096762',
  CIP13: '3400930967621',
  ucdLib: "SLIPEOL BUV GTT FL15ML",
  UCD7: '9084180',
  UCD13: '3400890841801',
  ucdQtyMultiplicator: 1,
  cipLib: "SLIPEOL BUV GTT FL15ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5570498',
  CIP13: '3400955704980',
  ucdLib: "SODIUM 0,9% AGT INJ FV1000ML",
  UCD7: '9115070',
  UCD13: '3400891150704',
  ucdQtyMultiplicator: 6,
  cipLib: "SODIUM 0,9% AGT INJ FV1000ML BT 6",
  atcCode: "B05XA03"
}, {
  CIP7: '5570363',
  CIP13: '3400955703631',
  ucdLib: "SODIUM 0,9% AGT INJ L.A100ML",
  UCD7: '9176083',
  UCD13: '3400891760835',
  ucdQtyMultiplicator: 40,
  cipLib: "SODIUM 0,9% AGT INJ L.A100ML BT 40",
  atcCode: "B05XA03"
}, {
  CIP7: '5570386',
  CIP13: '3400955703860',
  ucdLib: "SODIUM 0,9% AGT INJ L.A250ML",
  UCD7: '9175965',
  UCD13: '3400891759655',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% AGT INJ L.A250ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5570392',
  CIP13: '3400955703921',
  ucdLib: "SODIUM 0,9% AGT INJ L.A500ML",
  UCD7: '9175988',
  UCD13: '3400891759884',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% AGT INJ L.A500ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5570400',
  CIP13: '3400955704003',
  ucdLib: "SODIUM 0,9% AGT INJ LA1000ML",
  UCD7: '9175942',
  UCD13: '3400891759426',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% AGT INJ LA1000ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3097448',
  CIP13: '3400930974483',
  ucdLib: "SOLUDOR BUV GTT FL90ML",
  UCD7: '9085908',
  UCD13: '3400890859080',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLUDOR BUV GTT FL90ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3686618',
  CIP13: '3400936866188',
  ucdLib: "SOLUTRICINE M.G TETRA0,2MG C",
  UCD7: '9278010',
  UCD13: '3400892780108',
  ucdQtyMultiplicator: 24,
  cipLib: "SOLUTRICINE M.G TETRA0,2MG C BT 24",
  atcCode: "R02AD"
}, {
  CIP7: '3609701',
  CIP13: '3400936097018',
  ucdLib: "SOMNIDORON BUV GTT FL30ML",
  UCD7: '9281584',
  UCD13: '3400892815848',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMNIDORON BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3098270',
  CIP13: '3400930982709',
  ucdLib: "SOREAL BUV GTT FL15ML",
  UCD7: '9086440',
  UCD13: '3400890864404',
  ucdQtyMultiplicator: 1,
  cipLib: "SOREAL BUV GTT FL15ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3098749',
  CIP13: '3400930987490',
  ucdLib: "SPASMINE CPR",
  UCD7: '9086948',
  UCD13: '3400890869485',
  ucdQtyMultiplicator: 30,
  cipLib: "SPASMINE CPR BT 30",
  atcCode: "N05CM09"
}, {
  CIP7: '3609687',
  CIP13: '3400936096875',
  ucdLib: "SPORTENINE CPR CROQ",
  UCD7: '9271433',
  UCD13: '3400892714332',
  ucdQtyMultiplicator: 22,
  cipLib: "SPORTENINE CPR CROQ BT 22",
  atcCode: "V03AX"
}, {
  CIP7: '3099789',
  CIP13: '3400930997895',
  ucdLib: "STERLANE LOC SOL FP125ML",
  UCD7: '9115561',
  UCD13: '3400891155617',
  ucdQtyMultiplicator: 1,
  cipLib: "STERLANE LOC SOL FP125ML BT 1",
  atcCode: "D08AJ"
}, {
  CIP7: '3099795',
  CIP13: '3400930997956',
  ucdLib: "STERLANE LOC SOL FP350ML",
  UCD7: '9087818',
  UCD13: '3400890878180',
  ucdQtyMultiplicator: 1,
  cipLib: "STERLANE LOC SOL FP350ML BT 1",
  atcCode: "D08AJ"
}, {
  CIP7: '5574935',
  CIP13: '3400955749356',
  ucdLib: "TANAKAN 40MG CPR",
  UCD7: '9151315',
  UCD13: '3400891513158',
  ucdQtyMultiplicator: 500,
  cipLib: "TANAKAN 40MG CPR BT 500",
  atcCode: "N06DX02"
}, {
  CIP7: '3376527',
  CIP13: '3400933765279',
  ucdLib: "UTEPLEX 2MG BUV AMP2ML",
  UCD7: '9096958',
  UCD13: '3400890969581',
  ucdQtyMultiplicator: 45,
  cipLib: "UTEPLEX 2MG BUV AMP2ML BT 45",
  atcCode: "M09AX"
}, {
  CIP7: '3220512',
  CIP13: '3400932205127',
  ucdLib: "VASTAREL 20MG CPR PELLIC",
  UCD7: '9097797',
  UCD13: '3400890977975',
  ucdQtyMultiplicator: 100,
  cipLib: "VASTAREL 20MG CPR PELLIC BT 100",
  atcCode: "C01EB15"
}, {
  CIP7: '3609641',
  CIP13: '3400936096417',
  ucdLib: "VERRULIA CPR SUCER",
  UCD7: '9253872',
  UCD13: '3400892538723',
  ucdQtyMultiplicator: 60,
  cipLib: "VERRULIA CPR SUCER BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3609670',
  CIP13: '3400936096707',
  ucdLib: "ZENALIA CPR SUBLING",
  UCD7: '9272639',
  UCD13: '3400892726397',
  ucdQtyMultiplicator: 30,
  cipLib: "ZENALIA CPR SUBLING BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3348838',
  CIP13: '3400933488383',
  ucdLib: "AGYRAX CPR SECAB",
  UCD7: '9155000',
  UCD13: '3400891550009',
  ucdQtyMultiplicator: 15,
  cipLib: "AGYRAX CPR SECAB BT 15",
  atcCode: "R06AE05"
}, {
  CIP7: '5580083',
  CIP13: '3400955800835',
  ucdLib: "ANSATIPINE 150MG GELU",
  UCD7: '9159216',
  UCD13: '3400891592160',
  ucdQtyMultiplicator: 90,
  cipLib: "ANSATIPINE 150MG GELU BT 90",
  atcCode: "J04AB04"
}, {
  CIP7: '3343700',
  CIP13: '3400933437008',
  ucdLib: "ARKOGELULES ESCHOLTZIA",
  UCD7: '9155158',
  UCD13: '3400891551587',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES ESCHOLTZIA BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3408931',
  CIP13: '3400934089312',
  ucdLib: "BACTOX 1G PDR BUV SACH",
  UCD7: '9188028',
  UCD13: '3400891880281',
  ucdQtyMultiplicator: 6,
  cipLib: "BACTOX 1G PDR BUV SACH BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3408925',
  CIP13: '3400934089251',
  ucdLib: "BACTOX 500MG/5ML BUV FL60ML",
  UCD7: '9188034',
  UCD13: '3400891880342',
  ucdQtyMultiplicator: 1,
  cipLib: "BACTOX 500MG/5ML BUV FL60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3348399',
  CIP13: '3400933483999',
  ucdLib: "BI-CITROL GLE SACH10G",
  UCD7: '9153018',
  UCD13: '3400891530186',
  ucdQtyMultiplicator: 10,
  cipLib: "BI-CITROL GLE SACH10G BT 10",
  atcCode: "A02AX"
}, {
  CIP7: '3402561',
  CIP13: '3400934025617',
  ucdLib: "BILINUM CPLEXE N113 CPR",
  UCD7: '9236537',
  UCD13: '3400892365374',
  ucdQtyMultiplicator: 60,
  cipLib: "BILINUM CPLEXE N113 CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3402578',
  CIP13: '3400934025785',
  ucdLib: "BIOMAG AGRUMES CPR CROQ",
  UCD7: '9010922',
  UCD13: '3400890109222',
  ucdQtyMultiplicator: 90,
  cipLib: "BIOMAG AGRUMES CPR CROQ BT 90",
  atcCode: "V03AX"
}, {
  CIP7: '5582917',
  CIP13: '3400955829171',
  ucdLib: "BSS COMPOSE IRR 240ML+10ML",
  UCD7: '9165085',
  UCD13: '3400891650853',
  ucdQtyMultiplicator: 6,
  cipLib: "BSS COMPOSE IRR 240ML+10ML BT 6",
  atcCode: "S01KX"
}, {
  CIP7: '5582892',
  CIP13: '3400955828921',
  ucdLib: "BSS COMPOSE IRR 480ML+20ML",
  UCD7: '9165091',
  UCD13: '3400891650914',
  ucdQtyMultiplicator: 6,
  cipLib: "BSS COMPOSE IRR 480ML+20ML BT 6",
  atcCode: "S01KX"
}, {
  CIP7: '5589090',
  CIP13: '3400955890904',
  ucdLib: "CHELATRAN 1000MG INJ A.10ML",
  UCD7: '9178685',
  UCD13: '3400891786859',
  ucdQtyMultiplicator: 10,
  cipLib: "CHELATRAN 1000MG INJ A.10ML BT 10",
  atcCode: "V03AB03"
}, {
  CIP7: '3432622',
  CIP13: '3400934326226',
  ucdLib: "CREON 25000U GELU",
  UCD7: '9164967',
  UCD13: '3400891649673',
  ucdQtyMultiplicator: 100,
  cipLib: "CREON 25000U GELU BT 100",
  atcCode: "A09AA02"
}, {
  CIP7: '3523804',
  CIP13: '3400935238047',
  ucdLib: "DECAN PERF FL210ML",
  UCD7: '9218019',
  UCD13: '3400892180199',
  ucdQtyMultiplicator: 12,
  cipLib: "DECAN PERF FL210ML BT 12",
  atcCode: "B05XA30"
}, {
  CIP7: '5583319',
  CIP13: '3400955833192',
  ucdLib: "DETENSIEL 10MG CPR",
  UCD7: '9119317',
  UCD13: '3400891193176',
  ucdQtyMultiplicator: 50,
  cipLib: "DETENSIEL 10MG CPR BT 50",
  atcCode: "C07AB07"
}, {
  CIP7: '3434673',
  CIP13: '3400934346736',
  ucdLib: "EAU P.P.I FRF.FV250ML",
  UCD7: '9029991',
  UCD13: '3400890299916',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I FRF.FV250ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3404927',
  CIP13: '3400934049279',
  ucdLib: "ELUSANES ESCHSCHOLT. GELU",
  UCD7: '9186035',
  UCD13: '3400891860351',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES ESCHSCHOLT. GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3527297',
  CIP13: '3400935272973',
  ucdLib: "ELUSANES FRAGON 200MG GELU",
  UCD7: '9225120',
  UCD13: '3400892251202',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES FRAGON 200MG GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3342244',
  CIP13: '3400933422448',
  ucdLib: "ELUSANES ORTHOSIPHON GELU",
  UCD7: '9150445',
  UCD13: '3400891504453',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES ORTHOSIPHON GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3527133',
  CIP13: '3400935271334',
  ucdLib: "EUPHON MENTHOL PAST",
  UCD7: '9232462',
  UCD13: '3400892324623',
  ucdQtyMultiplicator: 70,
  cipLib: "EUPHON MENTHOL PAST BT 70",
  atcCode: "R02AA20"
}, {
  CIP7: '5585488',
  CIP13: '3400955854883',
  ucdLib: "FLOXYFRAL 100MG CPR",
  UCD7: '9158576',
  UCD13: '3400891585766',
  ucdQtyMultiplicator: 100,
  cipLib: "FLOXYFRAL 100MG CPR BT 100",
  atcCode: "N06AB08"
}, {
  CIP7: '3430617',
  CIP13: '3400934306174',
  ucdLib: "GLUCALCIUM INJ AMP10ML",
  UCD7: '9192231',
  UCD13: '3400891922318',
  ucdQtyMultiplicator: 100,
  cipLib: "GLUCALCIUM INJ AMP10ML BT 100",
  atcCode: "A12AA20"
}, {
  CIP7: '5587033',
  CIP13: '3400955870333',
  ucdLib: "GLUCOSE 10% SLD PERF POC 100ML",
  UCD7: '9172748',
  UCD13: '3400891727487',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SLD PERF POC 100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5587056',
  CIP13: '3400955870562',
  ucdLib: "GLUCOSE 10% SLD PERF POC 250ML",
  UCD7: '9172777',
  UCD13: '3400891727777',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SLD PERF POC 250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5587062',
  CIP13: '3400955870623',
  ucdLib: "GLUCOSE 10% SLD PERF POC 500ML",
  UCD7: '9172783',
  UCD13: '3400891727838',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SLD PERF POC 500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5587079',
  CIP13: '3400955870791',
  ucdLib: "GLUCOSE 10% SLD PERF POC1000ML",
  UCD7: '9172754',
  UCD13: '3400891727548',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SLD PERF POC1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5587085',
  CIP13: '3400955870852',
  ucdLib: "GLUCOSE 10% SLD PERF POC2000ML",
  UCD7: '9172760',
  UCD13: '3400891727609',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SLD PERF POC2000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3522609',
  CIP13: '3400935226099',
  ucdLib: "GLUCOSE 20% MAC INJ P.250ML",
  UCD7: '9135687',
  UCD13: '3400891356878',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 20% MAC INJ P.250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5586973',
  CIP13: '3400955869733',
  ucdLib: "GLUCOSE 5% SLD PERF POC 100ML",
  UCD7: '9172808',
  UCD13: '3400891728088',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% SLD PERF POC 100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5586996',
  CIP13: '3400955869962',
  ucdLib: "GLUCOSE 5% SLD PERF POC 250ML",
  UCD7: '9172837',
  UCD13: '3400891728378',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% SLD PERF POC 250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5587004',
  CIP13: '3400955870043',
  ucdLib: "GLUCOSE 5% SLD PERF POC 500ML",
  UCD7: '9172843',
  UCD13: '3400891728439',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% SLD PERF POC 500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5587010',
  CIP13: '3400955870104',
  ucdLib: "GLUCOSE 5% SLD PERF POC1000ML",
  UCD7: '9172814',
  UCD13: '3400891728149',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% SLD PERF POC1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5587027',
  CIP13: '3400955870272',
  ucdLib: "GLUCOSE 5% SLD PERF POC2000ML",
  UCD7: '9172820',
  UCD13: '3400891728200',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% SLD PERF POC2000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3342698',
  CIP13: '3400933426989',
  ucdLib: "INTERCYTON 200MG GELU",
  UCD7: '9158381',
  UCD13: '3400891583816',
  ucdQtyMultiplicator: 30,
  cipLib: "INTERCYTON 200MG GELU BT 30",
  atcCode: "C05CX"
}, {
  CIP7: '3401573',
  CIP13: '3400934015731',
  ucdLib: "LEHNING GTT N110 FL30ML",
  UCD7: '9174581',
  UCD13: '3400891745818',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N110 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3401604',
  CIP13: '3400934016042',
  ucdLib: "LEHNING GTT N115 FL30ML",
  UCD7: '9174606',
  UCD13: '3400891746068',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N115 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3401610',
  CIP13: '3400934016103',
  ucdLib: "LEHNING GTT N118 FL30ML",
  UCD7: '9174612',
  UCD13: '3400891746129',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N118 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3401656',
  CIP13: '3400934016561',
  ucdLib: "LEHNING GTT N122 FL30ML",
  UCD7: '9174641',
  UCD13: '3400891746419',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N122 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3401490',
  CIP13: '3400934014901',
  ucdLib: "LEHNING GTT N96 FL30ML",
  UCD7: '9175190',
  UCD13: '3400891751901',
  ucdQtyMultiplicator: 1,
  cipLib: "LEHNING GTT N96 FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5580640',
  CIP13: '3400955806400',
  ucdLib: "LUMIREM 175MG/L BUV FL300ML",
  UCD7: '9159676',
  UCD13: '3400891596762',
  ucdQtyMultiplicator: 3,
  cipLib: "LUMIREM 175MG/L BUV FL300ML BT 3",
  atcCode: "V08CB03"
}, {
  CIP7: '3125009',
  CIP13: '3400931250098',
  ucdLib: "MAGNE-B6 48MG/5MG CPR",
  UCD7: '9056054',
  UCD13: '3400890560542',
  ucdQtyMultiplicator: 50,
  cipLib: "MAGNE-B6 48MG/5MG CPR BT 50",
  atcCode: "A12CC30"
}, {
  CIP7: '5589115',
  CIP13: '3400955891154',
  ucdLib: "METHADONE AP-HP 10MG/7,5ML D.",
  UCD7: '9171559',
  UCD13: '3400891715590',
  ucdQtyMultiplicator: 70,
  cipLib: "METHADONE AP-HP 10MG/7,5ML D. BT 70",
  atcCode: "N07BC02"
}, {
  CIP7: '5589121',
  CIP13: '3400955891215',
  ucdLib: "METHADONE AP-HP 20MG/15ML DOS",
  UCD7: '9171565',
  UCD13: '3400891715651',
  ucdQtyMultiplicator: 70,
  cipLib: "METHADONE AP-HP 20MG/15ML DOS BT 70",
  atcCode: "N07BC02"
}, {
  CIP7: '5589109',
  CIP13: '3400955891093',
  ucdLib: "METHADONE AP-HP 5MG/3,75ML D.",
  UCD7: '9171571',
  UCD13: '3400891715712',
  ucdQtyMultiplicator: 70,
  cipLib: "METHADONE AP-HP 5MG/3,75ML D. BT 70",
  atcCode: "N07BC02"
}, {
  CIP7: '3435135',
  CIP13: '3400934351358',
  ucdLib: "OMEZELIS CPR",
  UCD7: '9097165',
  UCD13: '3400890971652',
  ucdQtyMultiplicator: 120,
  cipLib: "OMEZELIS CPR BT 120",
  atcCode: "N05CM"
}, {
  CIP7: '3522294',
  CIP13: '3400935222947',
  ucdLib: "OXYGENE MED APM B.AC15L+CBSTAR",
  UCD7: '9221412',
  UCD13: '3400892214122',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.AC15L+CBSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435678',
  CIP13: '3400934356780',
  ucdLib: "OXYGENE MED APM CRYO.FIX 100L",
  UCD7: '9193609',
  UCD13: '3400891936094',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM CRYO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435655',
  CIP13: '3400934356551',
  ucdLib: "OXYGENE MED APM CRYO.MOB 180L",
  UCD7: '9193288',
  UCD13: '3400891932881',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM CRYO.MOB 180L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435773',
  CIP13: '3400934357732',
  ucdLib: "OXYGENE MED SAG BOUT 15L",
  UCD7: '9193532',
  UCD13: '3400891935325',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG BOUT 15L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435796',
  CIP13: '3400934357961',
  ucdLib: "OXYGENE MED SAG BOUT 15L+MAN.",
  UCD7: '9193437',
  UCD13: '3400891934373',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG BOUT 15L+MAN. BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435804',
  CIP13: '3400934358043',
  ucdLib: "OXYGENE MED SAG BOUT 20L",
  UCD7: '9193555',
  UCD13: '3400891935554',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG BOUT 20L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435709',
  CIP13: '3400934357091',
  ucdLib: "OXYGENE MED SAG BOUT 2L",
  UCD7: '9193549',
  UCD13: '3400891935493',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG BOUT 2L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435715',
  CIP13: '3400934357152',
  ucdLib: "OXYGENE MED SAG BOUT 2L+MAN.",
  UCD7: '9193443',
  UCD13: '3400891934434',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG BOUT 2L+MAN. BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435750',
  CIP13: '3400934357503',
  ucdLib: "OXYGENE MED SAG BOUT 5L",
  UCD7: '9193584',
  UCD13: '3400891935844',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG BOUT 5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435767',
  CIP13: '3400934357671',
  ucdLib: "OXYGENE MED SAG BOUT 5L+MAN.",
  UCD7: '9193472',
  UCD13: '3400891934724',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG BOUT 5L+MAN. BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435827',
  CIP13: '3400934358272',
  ucdLib: "OXYGENE MED SAG BOUT AC50L",
  UCD7: '9193495',
  UCD13: '3400891934953',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG BOUT AC50L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435916',
  CIP13: '3400934359163',
  ucdLib: "OXYGENE MED SAG CRYO.FIX 100L",
  UCD7: '9193615',
  UCD13: '3400891936155',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG CRYO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435856',
  CIP13: '3400934358562',
  ucdLib: "OXYGENE MED SAG CRYO.MOB 180L",
  UCD7: '9193638',
  UCD13: '3400891936384',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG CRYO.MOB 180L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435862',
  CIP13: '3400934358623',
  ucdLib: "OXYGENE MED SAG CRYO.MOB 200L",
  UCD7: '9193644',
  UCD13: '3400891936445',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG CRYO.MOB 200L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3129036',
  CIP13: '3400931290360',
  ucdLib: "PAREGORIQUE LIPHA 50% FL45ML",
  UCD7: '9067632',
  UCD13: '3400890676328',
  ucdQtyMultiplicator: 1,
  cipLib: "PAREGORIQUE LIPHA 50% FL45ML BT 1",
  atcCode: "A07DA02"
}, {
  CIP7: '3129763',
  CIP13: '3400931297635',
  ucdLib: "PHARMATEX 1,2% CR TB72G",
  UCD7: '9070901',
  UCD13: '3400890709019',
  ucdQtyMultiplicator: 1,
  cipLib: "PHARMATEX 1,2% CR TB72G BT 1",
  atcCode: "G02BB"
}, {
  CIP7: '3129757',
  CIP13: '3400931297574',
  ucdLib: "PHARMATEX 1,2% CR TB72G + APPL",
  UCD7: '9113496',
  UCD13: '3400891134964',
  ucdQtyMultiplicator: 1,
  cipLib: "PHARMATEX 1,2% CR TB72G + APPL BT 1",
  atcCode: "G02BB"
}, {
  CIP7: '5583615',
  CIP13: '3400955836155',
  ucdLib: "PLASMION INJ POC500ML",
  UCD7: '9183404',
  UCD13: '3400891834048',
  ucdQtyMultiplicator: 1,
  cipLib: "PLASMION INJ POC500ML BT 1",
  atcCode: "B05AA06"
}, {
  CIP7: '3527251',
  CIP13: '3400935272515',
  ucdLib: "QUIETUDE SIR FL200ML",
  UCD7: '9220482',
  UCD13: '3400892204826',
  ucdQtyMultiplicator: 1,
  cipLib: "QUIETUDE SIR FL200ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3125972',
  CIP13: '3400931259725',
  ucdLib: "QUITAXON 10MG BUV GTT FL30ML",
  UCD7: '9078096',
  UCD13: '3400890780964',
  ucdQtyMultiplicator: 1,
  cipLib: "QUITAXON 10MG BUV GTT FL30ML BT 1",
  atcCode: "N06AA12"
}, {
  CIP7: '3123387',
  CIP13: '3400931233879',
  ucdLib: "SEDATIF PC CPR",
  UCD7: '9066845',
  UCD13: '3400890668453',
  ucdQtyMultiplicator: 40,
  cipLib: "SEDATIF PC CPR BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '3348471',
  CIP13: '3400933484712',
  ucdLib: "SEDOPAL GELU",
  UCD7: '9168422',
  UCD13: '3400891684223',
  ucdQtyMultiplicator: 40,
  cipLib: "SEDOPAL GELU BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '5586967',
  CIP13: '3400955869672',
  ucdLib: "SODIUM 0,9% SLD IRR POC 3000ML",
  UCD7: '9172961',
  UCD13: '3400891729610',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% SLD IRR POC 3000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5586915',
  CIP13: '3400955869153',
  ucdLib: "SODIUM 0,9% SLD PERF POC 100ML",
  UCD7: '9172903',
  UCD13: '3400891729030',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% SLD PERF POC 100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5586921',
  CIP13: '3400955869214',
  ucdLib: "SODIUM 0,9% SLD PERF POC 250ML",
  UCD7: '9172949',
  UCD13: '3400891729498',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% SLD PERF POC 250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5586938',
  CIP13: '3400955869382',
  ucdLib: "SODIUM 0,9% SLD PERF POC 500ML",
  UCD7: '9172955',
  UCD13: '3400891729559',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% SLD PERF POC 500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5586944',
  CIP13: '3400955869443',
  ucdLib: "SODIUM 0,9% SLD PERF POC1000ML",
  UCD7: '9172926',
  UCD13: '3400891729269',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% SLD PERF POC1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5586950',
  CIP13: '3400955869504',
  ucdLib: "SODIUM 0,9% SLD PERF POC2000ML",
  UCD7: '9172932',
  UCD13: '3400891729320',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% SLD PERF POC2000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3123973',
  CIP13: '3400931239734',
  ucdLib: "SODIUM BIC GIFRER PDR BT250G",
  UCD7: '9115489',
  UCD13: '3400891154894',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC GIFRER PDR BT250G BT 1",
  atcCode: "A02AH"
}, {
  CIP7: '5582596',
  CIP13: '3400955825968',
  ucdLib: "SULTOPRIDE PAN 200MG/2ML AMP",
  UCD7: '9165524',
  UCD13: '3400891655247',
  ucdQtyMultiplicator: 6,
  cipLib: "SULTOPRIDE PAN 200MG/2ML AMP BT 6",
  atcCode: "N05AL02"
}, {
  CIP7: '3524123',
  CIP13: '3400935241238',
  ucdLib: "TIAPRIDE PAN 100MG INJ A.2ML",
  UCD7: '9131459',
  UCD13: '3400891314595',
  ucdQtyMultiplicator: 10,
  cipLib: "TIAPRIDE PAN 100MG INJ A.2ML BT 10",
  atcCode: "N05AL03"
}, {
  CIP7: '3409735',
  CIP13: '3400934097355',
  ucdLib: "TRANQUITAL CPR",
  UCD7: '9181090',
  UCD13: '3400891810905',
  ucdQtyMultiplicator: 100,
  cipLib: "TRANQUITAL CPR BT 100",
  atcCode: "N05CM09"
}, {
  CIP7: '3520361',
  CIP13: '3400935203618',
  ucdLib: "VISIPAQUE 270MG INJ FP150ML",
  UCD7: '9293297',
  UCD13: '3400892932972',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 270MG INJ FP150ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3520243',
  CIP13: '3400935202437',
  ucdLib: "VISIPAQUE 270MG INJ FP20ML",
  UCD7: '9242029',
  UCD13: '3400892420295',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 270MG INJ FP20ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3520154',
  CIP13: '3400935201546',
  ucdLib: "VISIPAQUE 320MG INJ FP150ML",
  UCD7: '9293305',
  UCD13: '3400892933054',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 320MG INJ FP150ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3520059',
  CIP13: '3400935200594',
  ucdLib: "VISIPAQUE 320MG INJ FP20ML",
  UCD7: '9242064',
  UCD13: '3400892420646',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 320MG INJ FP20ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3145673',
  CIP13: '3400931456735',
  ucdLib: "ACIDUM PHOSP COMP BOIR CPR",
  UCD7: '9000450',
  UCD13: '3400890004503',
  ucdQtyMultiplicator: 50,
  cipLib: "ACIDUM PHOSP COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3145667',
  CIP13: '3400931456674',
  ucdLib: "ACIDUM PHOSP COMP BOIR GRLS",
  UCD7: '9000467',
  UCD13: '3400890004671',
  ucdQtyMultiplicator: 80,
  cipLib: "ACIDUM PHOSP COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3145650',
  CIP13: '3400931456506',
  ucdLib: "ACIDUM PHOSP COMP BOIR GTT30ML",
  UCD7: '9107188',
  UCD13: '3400891071887',
  ucdQtyMultiplicator: 1,
  cipLib: "ACIDUM PHOSP COMP BOIR GTT30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3145733',
  CIP13: '3400931457336',
  ucdLib: "ACONITUM COMP BOIR CPR",
  UCD7: '9000533',
  UCD13: '3400890005333',
  ucdQtyMultiplicator: 50,
  cipLib: "ACONITUM COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3145727',
  CIP13: '3400931457275',
  ucdLib: "ACONITUM COMP BOIR GRLS",
  UCD7: '9000556',
  UCD13: '3400890005562',
  ucdQtyMultiplicator: 80,
  cipLib: "ACONITUM COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3145710',
  CIP13: '3400931457107',
  ucdLib: "ACONITUM COMP BOIR GTT FL30ML",
  UCD7: '9000562',
  UCD13: '3400890005623',
  ucdQtyMultiplicator: 1,
  cipLib: "ACONITUM COMP BOIR GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146767',
  CIP13: '3400931467670',
  ucdLib: "AESCULUS BOIR POM TB20G",
  UCD7: '9001633',
  UCD13: '3400890016339',
  ucdQtyMultiplicator: 1,
  cipLib: "AESCULUS BOIR POM TB20G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3145963',
  CIP13: '3400931459637',
  ucdLib: "AESCULUS COMP BOIR CPR",
  UCD7: '9001521',
  UCD13: '3400890015219',
  ucdQtyMultiplicator: 50,
  cipLib: "AESCULUS COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3145957',
  CIP13: '3400931459576',
  ucdLib: "AESCULUS COMP BOIR GRLS",
  UCD7: '9001538',
  UCD13: '3400890015387',
  ucdQtyMultiplicator: 80,
  cipLib: "AESCULUS COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3145940',
  CIP13: '3400931459408',
  ucdLib: "AESCULUS COMP BOIR GTT FL30ML",
  UCD7: '9107202',
  UCD13: '3400891072020',
  ucdQtyMultiplicator: 1,
  cipLib: "AESCULUS COMP BOIR GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3145992',
  CIP13: '3400931459927',
  ucdLib: "AESCULUS COMP BOIR SUP",
  UCD7: '9001550',
  UCD13: '3400890015509',
  ucdQtyMultiplicator: 12,
  cipLib: "AESCULUS COMP BOIR SUP BT 12",
  atcCode: "V03AX"
}, {
  CIP7: '3146796',
  CIP13: '3400931467960',
  ucdLib: "AESCULUS PAEONIA BOIR POM 20G",
  UCD7: '9001627',
  UCD13: '3400890016278',
  ucdQtyMultiplicator: 1,
  cipLib: "AESCULUS PAEONIA BOIR POM 20G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146804',
  CIP13: '3400931468042',
  ucdLib: "AGARICUS BOIR POM TB20G",
  UCD7: '9001805',
  UCD13: '3400890018050',
  ucdQtyMultiplicator: 1,
  cipLib: "AGARICUS BOIR POM TB20G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3145791',
  CIP13: '3400931457916',
  ucdLib: "ALLIUM CEPA COMP BOIR CPR",
  UCD7: '9003023',
  UCD13: '3400890030236',
  ucdQtyMultiplicator: 50,
  cipLib: "ALLIUM CEPA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3145785',
  CIP13: '3400931457855',
  ucdLib: "ALLIUM CEPA COMP BOIR GRLS",
  UCD7: '9003046',
  UCD13: '3400890030465',
  ucdQtyMultiplicator: 80,
  cipLib: "ALLIUM CEPA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3145779',
  CIP13: '3400931457794',
  ucdLib: "ALLIUM CEPA COMP BOIR GTT 30ML",
  UCD7: '9107248',
  UCD13: '3400891072488',
  ucdQtyMultiplicator: 1,
  cipLib: "ALLIUM CEPA COMP BOIR GTT 30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3145851',
  CIP13: '3400931458517',
  ucdLib: "ALOE COMP BOIR CPR",
  UCD7: '9003230',
  UCD13: '3400890032308',
  ucdQtyMultiplicator: 50,
  cipLib: "ALOE COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3145845',
  CIP13: '3400931458456',
  ucdLib: "ALOE COMP BOIR GRLS",
  UCD7: '9003247',
  UCD13: '3400890032476',
  ucdQtyMultiplicator: 80,
  cipLib: "ALOE COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3145839',
  CIP13: '3400931458395',
  ucdLib: "ALOE COMP BOIR GTT FL30ML",
  UCD7: '9107254',
  UCD13: '3400891072549',
  ucdQtyMultiplicator: 1,
  cipLib: "ALOE COMP BOIR GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3675394',
  CIP13: '3400936753945',
  ucdLib: "AMISULPRIDE ZYD 200MG CPR",
  UCD7: '9271143',
  UCD13: '3400892711430',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE ZYD 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3202098',
  CIP13: '3400932020980',
  ucdLib: "AMPHOSCA OVARINE CPR",
  UCD7: '9004181',
  UCD13: '3400890041812',
  ucdQtyMultiplicator: 60,
  cipLib: "AMPHOSCA OVARINE CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3358392',
  CIP13: '3400933583927',
  ucdLib: "ARKOGELULES ORTIE",
  UCD7: '9160722',
  UCD13: '3400891607222',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES ORTIE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3358400',
  CIP13: '3400933584009',
  ucdLib: "ARKOGELULES ORTIE RACINE",
  UCD7: '9168764',
  UCD13: '3400891687644',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES ORTIE RACINE BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3145874',
  CIP13: '3400931458746',
  ucdLib: "ARNICA BOIR POM TB20G",
  UCD7: '9006464',
  UCD13: '3400890064644',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNICA BOIR POM TB20G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3145911',
  CIP13: '3400931459118',
  ucdLib: "ARUM TRIPHYL COMP BOIR CPR",
  UCD7: '9006895',
  UCD13: '3400890068956',
  ucdQtyMultiplicator: 50,
  cipLib: "ARUM TRIPHYL COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3145905',
  CIP13: '3400931459057',
  ucdLib: "ARUM TRIPHYL COMP BOIR GRLS",
  UCD7: '9006903',
  UCD13: '3400890069038',
  ucdQtyMultiplicator: 80,
  cipLib: "ARUM TRIPHYL COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3145897',
  CIP13: '3400931458975',
  ucdLib: "ARUM TRIPHYL COMP BOIR GTT30ML",
  UCD7: '9108118',
  UCD13: '3400891081183',
  ucdQtyMultiplicator: 1,
  cipLib: "ARUM TRIPHYL COMP BOIR GTT30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146738',
  CIP13: '3400931467380',
  ucdLib: "BOIRON PATES PECT. SAMBUC. 70G",
  UCD7: '9011927',
  UCD13: '3400890119276',
  ucdQtyMultiplicator: 1,
  cipLib: "BOIRON PATES PECT. SAMBUC. 70G BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3146000',
  CIP13: '3400931460008',
  ucdLib: "BRYONIA OPOD. BOIRON LIN.125ML",
  UCD7: '9013932',
  UCD13: '3400890139328',
  ucdQtyMultiplicator: 1,
  cipLib: "BRYONIA OPOD. BOIRON LIN.125ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146052',
  CIP13: '3400931460527',
  ucdLib: "CALCAREA COMP BOIR CPR",
  UCD7: '9014297',
  UCD13: '3400890142977',
  ucdQtyMultiplicator: 50,
  cipLib: "CALCAREA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146046',
  CIP13: '3400931460466',
  ucdLib: "CALCAREA COMP BOIR GRLS",
  UCD7: '9014305',
  UCD13: '3400890143059',
  ucdQtyMultiplicator: 80,
  cipLib: "CALCAREA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146017',
  CIP13: '3400931460176',
  ucdLib: "CALCAREA COMP BOIR PDR BT15G",
  UCD7: '9108638',
  UCD13: '3400891086386',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCAREA COMP BOIR PDR BT15G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146023',
  CIP13: '3400931460237',
  ucdLib: "CALCAREA COMP BOIR PDR BT30G",
  UCD7: '9014311',
  UCD13: '3400890143110',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCAREA COMP BOIR PDR BT30G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146810',
  CIP13: '3400931468103',
  ucdLib: "CASTOR EQUI BOIR POM TB20G",
  UCD7: '9016741',
  UCD13: '3400890167413',
  ucdQtyMultiplicator: 1,
  cipLib: "CASTOR EQUI BOIR POM TB20G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3146106',
  CIP13: '3400931461067',
  ucdLib: "CEREALES GERMEES BOIR CPR",
  UCD7: '9017947',
  UCD13: '3400890179478',
  ucdQtyMultiplicator: 50,
  cipLib: "CEREALES GERMEES BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146098',
  CIP13: '3400931460985',
  ucdLib: "CEREALES GERMEES BOIR GRLS",
  UCD7: '9017953',
  UCD13: '3400890179539',
  ucdQtyMultiplicator: 80,
  cipLib: "CEREALES GERMEES BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146158',
  CIP13: '3400931461586',
  ucdLib: "CHELIDONIUM COMP BOIR CPR",
  UCD7: '9018800',
  UCD13: '3400890188005',
  ucdQtyMultiplicator: 50,
  cipLib: "CHELIDONIUM COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146141',
  CIP13: '3400931461418',
  ucdLib: "CHELIDONIUM COMP BOIR GRLS",
  UCD7: '9018817',
  UCD13: '3400890188173',
  ucdQtyMultiplicator: 80,
  cipLib: "CHELIDONIUM COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146135',
  CIP13: '3400931461357',
  ucdLib: "CHELIDONIUM COMP BOIR GTT 30ML",
  UCD7: '9018823',
  UCD13: '3400890188234',
  ucdQtyMultiplicator: 1,
  cipLib: "CHELIDONIUM COMP BOIR GTT 30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146201',
  CIP13: '3400931462019',
  ucdLib: "CINA COMP BOIR CPR",
  UCD7: '9019716',
  UCD13: '3400890197168',
  ucdQtyMultiplicator: 50,
  cipLib: "CINA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146193',
  CIP13: '3400931461937',
  ucdLib: "CINA COMP BOIR GRLS",
  UCD7: '9019722',
  UCD13: '3400890197229',
  ucdQtyMultiplicator: 80,
  cipLib: "CINA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146827',
  CIP13: '3400931468271',
  ucdLib: "CLEMATIS VIT BOIR POM TB20G",
  UCD7: '9020323',
  UCD13: '3400890203234',
  ucdQtyMultiplicator: 1,
  cipLib: "CLEMATIS VIT BOIR POM TB20G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3675193',
  CIP13: '3400936751934',
  ucdLib: "DONORMYL 15MG CPR",
  UCD7: '9136965',
  UCD13: '3400891369656',
  ucdQtyMultiplicator: 10,
  cipLib: "DONORMYL 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '3675201',
  CIP13: '3400936752016',
  ucdLib: "DONORMYL 15MG CPR EFFV",
  UCD7: '9028603',
  UCD13: '3400890286039',
  ucdQtyMultiplicator: 10,
  cipLib: "DONORMYL 15MG CPR EFFV BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '3146253',
  CIP13: '3400931462538',
  ucdLib: "DROSERA COMP BOIR CPR",
  UCD7: '9028968',
  UCD13: '3400890289689',
  ucdQtyMultiplicator: 50,
  cipLib: "DROSERA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146247',
  CIP13: '3400931462477',
  ucdLib: "DROSERA COMP BOIR GRLS",
  UCD7: '9028974',
  UCD13: '3400890289740',
  ucdQtyMultiplicator: 80,
  cipLib: "DROSERA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146230',
  CIP13: '3400931462309',
  ucdLib: "DROSERA COMP BOIR GTT FL30ML",
  UCD7: '9112261',
  UCD13: '3400891122619',
  ucdQtyMultiplicator: 1,
  cipLib: "DROSERA COMP BOIR GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3148418',
  CIP13: '3400931484189',
  ucdLib: "DROSERA COMP DOLI GRLS",
  UCD7: '9145591',
  UCD13: '3400891455915',
  ucdQtyMultiplicator: 80,
  cipLib: "DROSERA COMP DOLI GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3358423',
  CIP13: '3400933584238',
  ucdLib: "ELUSANES BUSSEROLE GELU",
  UCD7: '9165932',
  UCD13: '3400891659320',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES BUSSEROLE GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3671829',
  CIP13: '3400936718296',
  ucdLib: "FLUCONAZOLE SDZ2MG/ML FL100ML",
  UCD7: '9274489',
  UCD13: '3400892744896',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE SDZ2MG/ML FL100ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3671835',
  CIP13: '3400936718357',
  ucdLib: "FLUCONAZOLE SDZ2MG/ML FL200ML",
  UCD7: '9274495',
  UCD13: '3400892744957',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE SDZ2MG/ML FL200ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3671812',
  CIP13: '3400936718128',
  ucdLib: "FLUCONAZOLE SDZ2MG/ML FL50ML",
  UCD7: '9274503',
  UCD13: '3400892745039',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE SDZ2MG/ML FL50ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3144395',
  CIP13: '3400931443957',
  ucdLib: "FLUDEX 2,5MG CPR",
  UCD7: '9035448',
  UCD13: '3400890354486',
  ucdQtyMultiplicator: 100,
  cipLib: "FLUDEX 2,5MG CPR BT 100",
  atcCode: "C03BA11"
}, {
  CIP7: '3146336',
  CIP13: '3400931463368',
  ucdLib: "FORMICA RUFA COMP BOIR CPR",
  UCD7: '9036057',
  UCD13: '3400890360579',
  ucdQtyMultiplicator: 50,
  cipLib: "FORMICA RUFA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146313',
  CIP13: '3400931463139',
  ucdLib: "FORMICA RUFA COMP BOIR GRLS",
  UCD7: '9036063',
  UCD13: '3400890360630',
  ucdQtyMultiplicator: 80,
  cipLib: "FORMICA RUFA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146307',
  CIP13: '3400931463078',
  ucdLib: "FORMICA RUFA COMP BOIR GTT30ML",
  UCD7: '9110569',
  UCD13: '3400891105698',
  ucdQtyMultiplicator: 1,
  cipLib: "FORMICA RUFA COMP BOIR GTT30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146833',
  CIP13: '3400931468332',
  ucdLib: "GRAPHITES BOIR POM TB20G",
  UCD7: '9040892',
  UCD13: '3400890408929',
  ucdQtyMultiplicator: 1,
  cipLib: "GRAPHITES BOIR POM TB20G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3202537',
  CIP13: '3400932025374',
  ucdLib: "GUETHURAL 300MG CPR",
  UCD7: '9041087',
  UCD13: '3400890410878',
  ucdQtyMultiplicator: 40,
  cipLib: "GUETHURAL 300MG CPR BT 40",
  atcCode: "R05CB"
}, {
  CIP7: '3146856',
  CIP13: '3400931468561',
  ucdLib: "HAMAMELIS BOIR POM TB20G",
  UCD7: '9041704',
  UCD13: '3400890417044',
  ucdQtyMultiplicator: 1,
  cipLib: "HAMAMELIS BOIR POM TB20G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146388',
  CIP13: '3400931463887',
  ucdLib: "HAMAMELIS COMP BOIR CPR",
  UCD7: '9041650',
  UCD13: '3400890416504',
  ucdQtyMultiplicator: 50,
  cipLib: "HAMAMELIS COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146371',
  CIP13: '3400931463719',
  ucdLib: "HAMAMELIS COMP BOIR GRLS",
  UCD7: '9041667',
  UCD13: '3400890416672',
  ucdQtyMultiplicator: 80,
  cipLib: "HAMAMELIS COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146365',
  CIP13: '3400931463658',
  ucdLib: "HAMAMELIS COMP BOIR GTT FL30ML",
  UCD7: '9041673',
  UCD13: '3400890416733',
  ucdQtyMultiplicator: 1,
  cipLib: "HAMAMELIS COMP BOIR GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146431',
  CIP13: '3400931464310',
  ucdLib: "HELONIAS COMP BOIR CPR",
  UCD7: '9042106',
  UCD13: '3400890421065',
  ucdQtyMultiplicator: 50,
  cipLib: "HELONIAS COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146425',
  CIP13: '3400931464259',
  ucdLib: "HELONIAS COMP BOIR GRLS",
  UCD7: '9042112',
  UCD13: '3400890421126',
  ucdQtyMultiplicator: 80,
  cipLib: "HELONIAS COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3352975',
  CIP13: '3400933529758',
  ucdLib: "HISTOFLUINE P BUV GTT FL50ML",
  UCD7: '9156956',
  UCD13: '3400891569568',
  ucdQtyMultiplicator: 1,
  cipLib: "HISTOFLUINE P BUV GTT FL50ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146460',
  CIP13: '3400931464600',
  ucdLib: "HYDRASTIS COMP BOIR CPR",
  UCD7: '9044950',
  UCD13: '3400890449502',
  ucdQtyMultiplicator: 50,
  cipLib: "HYDRASTIS COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146454',
  CIP13: '3400931464549',
  ucdLib: "HYDRASTIS COMP BOIR GRLS",
  UCD7: '9044967',
  UCD13: '3400890449670',
  ucdQtyMultiplicator: 80,
  cipLib: "HYDRASTIS COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3148217',
  CIP13: '3400931482178',
  ucdLib: "HYDRASTIS COMP DOLI CPR",
  UCD7: '9209546',
  UCD13: '3400892095462',
  ucdQtyMultiplicator: 50,
  cipLib: "HYDRASTIS COMP DOLI CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146537',
  CIP13: '3400931465379',
  ucdLib: "IPECA COMP BOIR CPR",
  UCD7: '9047345',
  UCD13: '3400890473453',
  ucdQtyMultiplicator: 50,
  cipLib: "IPECA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146520',
  CIP13: '3400931465201',
  ucdLib: "IPECA COMP BOIR GRLS",
  UCD7: '9047351',
  UCD13: '3400890473514',
  ucdQtyMultiplicator: 80,
  cipLib: "IPECA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146514',
  CIP13: '3400931465140',
  ucdLib: "IPECA COMP BOIR GTT FL30ML",
  UCD7: '9111089',
  UCD13: '3400891110890',
  ucdQtyMultiplicator: 1,
  cipLib: "IPECA COMP BOIR GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3356683',
  CIP13: '3400933566838',
  ucdLib: "IVELIP 20% PERF FV100ML",
  UCD7: '9160343',
  UCD13: '3400891603439',
  ucdQtyMultiplicator: 1,
  cipLib: "IVELIP 20% PERF FV100ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3356708',
  CIP13: '3400933567088',
  ucdLib: "IVELIP 20% PERF FV250ML",
  UCD7: '9160372',
  UCD13: '3400891603729',
  ucdQtyMultiplicator: 1,
  cipLib: "IVELIP 20% PERF FV250ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3356714',
  CIP13: '3400933567149',
  ucdLib: "IVELIP 20% PERF FV500ML",
  UCD7: '9160389',
  UCD13: '3400891603897',
  ucdQtyMultiplicator: 1,
  cipLib: "IVELIP 20% PERF FV500ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '4989054',
  CIP13: '3400949890545',
  ucdLib: "MAGNEVIE B6 100MG/10MG CPR",
  UCD7: '9341027',
  UCD13: '3400893410271',
  ucdQtyMultiplicator: 120,
  cipLib: "MAGNEVIE B6 100MG/10MG CPR BT 120",
  atcCode: "A12CC30"
}, {
  CIP7: '3132819',
  CIP13: '3400931328193',
  ucdLib: "MEDIFLOR N1 MINCEUR TIS DOS",
  UCD7: '9057289',
  UCD13: '3400890572897',
  ucdQtyMultiplicator: 24,
  cipLib: "MEDIFLOR N1 MINCEUR TIS DOS BT 24",
  atcCode: "V03AX"
}, {
  CIP7: '5514761',
  CIP13: '3400955147619',
  ucdLib: "METHERGIN 0,2MG INJ AMP1ML",
  UCD7: '9058484',
  UCD13: '3400890584845',
  ucdQtyMultiplicator: 50,
  cipLib: "METHERGIN 0,2MG INJ AMP1ML BT 50",
  atcCode: "G02AB01"
}, {
  CIP7: '3146862',
  CIP13: '3400931468622',
  ucdLib: "MEZEREUM BOIR POM TB20G",
  UCD7: '9058716',
  UCD13: '3400890587167',
  ucdQtyMultiplicator: 1,
  cipLib: "MEZEREUM BOIR POM TB20G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3145325',
  CIP13: '3400931453253',
  ucdLib: "MICROTRAST PATE ORAL TB800G",
  UCD7: '9058828',
  UCD13: '3400890588287',
  ucdQtyMultiplicator: 1,
  cipLib: "MICROTRAST PATE ORAL TB800G BT 1",
  atcCode: "V08BA01"
}, {
  CIP7: '3359492',
  CIP13: '3400933594923',
  ucdLib: "NAUSICALM 50MG GELU",
  UCD7: '9106042',
  UCD13: '3400891060423',
  ucdQtyMultiplicator: 14,
  cipLib: "NAUSICALM 50MG GELU BT 14",
  atcCode: "A04AD"
}, {
  CIP7: '3202069',
  CIP13: '3400932020690',
  ucdLib: "NERVOPAX CPR",
  UCD7: '9062221',
  UCD13: '3400890622219',
  ucdQtyMultiplicator: 60,
  cipLib: "NERVOPAX CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3131731',
  CIP13: '3400931317319',
  ucdLib: "NICOPRIVE CPR ENROB",
  UCD7: '9062959',
  UCD13: '3400890629591',
  ucdQtyMultiplicator: 60,
  cipLib: "NICOPRIVE CPR ENROB BT 60",
  atcCode: "N07BA"
}, {
  CIP7: '5519528',
  CIP13: '3400955195283',
  ucdLib: "NOOTROPYL 3G INJ AMP15ML",
  UCD7: '9063373',
  UCD13: '3400890633734',
  ucdQtyMultiplicator: 20,
  cipLib: "NOOTROPYL 3G INJ AMP15ML BT 20",
  atcCode: "N06BX03"
}, {
  CIP7: '3141586',
  CIP13: '3400931415862',
  ucdLib: "NOPRON ENF15MG/5ML SIR FL150ML",
  UCD7: '9063456',
  UCD13: '3400890634564',
  ucdQtyMultiplicator: 1,
  cipLib: "NOPRON ENF15MG/5ML SIR FL150ML BT 1",
  atcCode: "N05CM16"
}, {
  CIP7: '3146595',
  CIP13: '3400931465959',
  ucdLib: "NUX VOMICA COMP BOIR CPR",
  UCD7: '9064289',
  UCD13: '3400890642897',
  ucdQtyMultiplicator: 50,
  cipLib: "NUX VOMICA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146589',
  CIP13: '3400931465898',
  ucdLib: "NUX VOMICA COMP BOIR GRLS",
  UCD7: '9064295',
  UCD13: '3400890642958',
  ucdQtyMultiplicator: 80,
  cipLib: "NUX VOMICA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146572',
  CIP13: '3400931465720',
  ucdLib: "NUX VOMICA COMP BOIR GTT 30ML",
  UCD7: '9064303',
  UCD13: '3400890643030',
  ucdQtyMultiplicator: 1,
  cipLib: "NUX VOMICA COMP BOIR GTT 30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3358357',
  CIP13: '3400933583576',
  ucdLib: "OPTI-FREE SOL LENTIL 15ML",
  UCD7: '9150103',
  UCD13: '3400891501032',
  ucdQtyMultiplicator: 90,
  cipLib: "OPTI-FREE SOL LENTIL 15ML BT 90",
  atcCode: "S01XA20"
}, {
  CIP7: '3146879',
  CIP13: '3400931468790',
  ucdLib: "PAEONIA BOIR POM TB20G",
  UCD7: '9066957',
  UCD13: '3400890669573',
  ucdQtyMultiplicator: 1,
  cipLib: "PAEONIA BOIR POM TB20G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146655',
  CIP13: '3400931466550',
  ucdLib: "PAREIRA BRAV COMP BOIR CPR",
  UCD7: '9067678',
  UCD13: '3400890676786',
  ucdQtyMultiplicator: 50,
  cipLib: "PAREIRA BRAV COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146649',
  CIP13: '3400931466499',
  ucdLib: "PAREIRA BRAV COMP BOIR GRLS",
  UCD7: '9067684',
  UCD13: '3400890676847',
  ucdQtyMultiplicator: 80,
  cipLib: "PAREIRA BRAV COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146632',
  CIP13: '3400931466321',
  ucdLib: "PAREIRA BRAV COMP BOIR GTT30ML",
  UCD7: '9067690',
  UCD13: '3400890676908',
  ucdQtyMultiplicator: 1,
  cipLib: "PAREIRA BRAV COMP BOIR GTT30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146709',
  CIP13: '3400931467090',
  ucdLib: "PASSIFLORA COMP BOIR CPR",
  UCD7: '9067922',
  UCD13: '3400890679220',
  ucdQtyMultiplicator: 50,
  cipLib: "PASSIFLORA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3146690',
  CIP13: '3400931466901',
  ucdLib: "PASSIFLORA COMP BOIR GRLS",
  UCD7: '9067939',
  UCD13: '3400890679398',
  ucdQtyMultiplicator: 80,
  cipLib: "PASSIFLORA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3146684',
  CIP13: '3400931466840',
  ucdLib: "PASSIFLORA COMP BOIR GTT 30ML",
  UCD7: '9067945',
  UCD13: '3400890679459',
  ucdQtyMultiplicator: 1,
  cipLib: "PASSIFLORA COMP BOIR GTT 30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3205501',
  CIP13: '3400932055012',
  ucdLib: "PHARMATEX 18,9MG OV",
  UCD7: '9070924',
  UCD13: '3400890709248',
  ucdQtyMultiplicator: 20,
  cipLib: "PHARMATEX 18,9MG OV BT 20",
  atcCode: "G02BB"
}, {
  CIP7: '3146750',
  CIP13: '3400931467502',
  ucdLib: "PHYTOLACCA CAL. BOIR COLLU15ML",
  UCD7: '9071705',
  UCD13: '3400890717052',
  ucdQtyMultiplicator: 1,
  cipLib: "PHYTOLACCA CAL. BOIR COLLU15ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146744',
  CIP13: '3400931467441',
  ucdLib: "PHYTOLACCA CAL. BOIR GTT 15ML",
  UCD7: '9071711',
  UCD13: '3400890717113',
  ucdQtyMultiplicator: 1,
  cipLib: "PHYTOLACCA CAL. BOIR GTT 15ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146891',
  CIP13: '3400931468912',
  ucdLib: "PULVIS NIGER BOIRON TRITUR 15G",
  UCD7: '9077286',
  UCD13: '3400890772860',
  ucdQtyMultiplicator: 1,
  cipLib: "PULVIS NIGER BOIRON TRITUR 15G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3146885',
  CIP13: '3400931468851',
  ucdLib: "RATANHIA BOIR POM TB20G",
  UCD7: '9078423',
  UCD13: '3400890784238',
  ucdQtyMultiplicator: 1,
  cipLib: "RATANHIA BOIR POM TB20G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3352082',
  CIP13: '3400933520823',
  ucdLib: "RECTOPANBILINE AD. NF SUP",
  UCD7: '9156910',
  UCD13: '3400891569100',
  ucdQtyMultiplicator: 10,
  cipLib: "RECTOPANBILINE AD. NF SUP BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3146951',
  CIP13: '3400931469513',
  ucdLib: "RHUS TOX COMP BOIR CPR",
  UCD7: '9080029',
  UCD13: '3400890800297',
  ucdQtyMultiplicator: 50,
  cipLib: "RHUS TOX COMP BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3146945',
  CIP13: '3400931469452',
  ucdLib: "RHUS TOX COMP BOIR GRLS",
  UCD7: '9080035',
  UCD13: '3400890800358',
  ucdQtyMultiplicator: 80,
  cipLib: "RHUS TOX COMP BOIR GRLS BT 80",
  atcCode: "Z01"
}, {
  CIP7: '3146939',
  CIP13: '3400931469391',
  ucdLib: "RHUS TOX COMP BOIR GTT FL30ML",
  UCD7: '9080041',
  UCD13: '3400890800419',
  ucdQtyMultiplicator: 1,
  cipLib: "RHUS TOX COMP BOIR GTT FL30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '3147011',
  CIP13: '3400931470113',
  ucdLib: "RICINUS COMP BOIR CPR",
  UCD7: '9080213',
  UCD13: '3400890802130',
  ucdQtyMultiplicator: 50,
  cipLib: "RICINUS COMP BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3147005',
  CIP13: '3400931470052',
  ucdLib: "RICINUS COMP BOIR GRLS",
  UCD7: '9080236',
  UCD13: '3400890802369',
  ucdQtyMultiplicator: 80,
  cipLib: "RICINUS COMP BOIR GRLS BT 80",
  atcCode: "Z01"
}, {
  CIP7: '3146997',
  CIP13: '3400931469971',
  ucdLib: "RICINUS COMP BOIR GTT FL30ML",
  UCD7: '9080242',
  UCD13: '3400890802420',
  ucdQtyMultiplicator: 1,
  cipLib: "RICINUS COMP BOIR GTT FL30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '3209114',
  CIP13: '3400932091140',
  ucdLib: "RUTOVINCINE CPR",
  UCD7: '9081477',
  UCD13: '3400890814775',
  ucdQtyMultiplicator: 60,
  cipLib: "RUTOVINCINE CPR BT 60",
  atcCode: "C04AX07"
}, {
  CIP7: '3147063',
  CIP13: '3400931470632',
  ucdLib: "SABAL SERRUL COMP BOIR CPR",
  UCD7: '9081589',
  UCD13: '3400890815895',
  ucdQtyMultiplicator: 50,
  cipLib: "SABAL SERRUL COMP BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3147057',
  CIP13: '3400931470571',
  ucdLib: "SABAL SERRUL COMP BOIR GRLS",
  UCD7: '9081595',
  UCD13: '3400890815956',
  ucdQtyMultiplicator: 80,
  cipLib: "SABAL SERRUL COMP BOIR GRLS BT 80",
  atcCode: "Z01"
}, {
  CIP7: '3147040',
  CIP13: '3400931470403',
  ucdLib: "SABAL SERRUL COMP BOIR GTT30ML",
  UCD7: '9114691',
  UCD13: '3400891146912',
  ucdQtyMultiplicator: 1,
  cipLib: "SABAL SERRUL COMP BOIR GTT30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '3144981',
  CIP13: '3400931449812',
  ucdLib: "SACOLENE 2G GLE SACH",
  UCD7: '9081661',
  UCD13: '3400890816618',
  ucdQtyMultiplicator: 12,
  cipLib: "SACOLENE 2G GLE SACH BT 12",
  atcCode: "A07BC30"
}, {
  CIP7: '3144975',
  CIP13: '3400931449751',
  ucdLib: "SACOLENE PEDIA 500 GLE SACH",
  UCD7: '9081678',
  UCD13: '3400890816786',
  ucdQtyMultiplicator: 12,
  cipLib: "SACOLENE PEDIA 500 GLE SACH BT 12",
  atcCode: "A07BC30"
}, {
  CIP7: '3147123',
  CIP13: '3400931471233',
  ucdLib: "SAPONARIA COMP BOIR CPR",
  UCD7: '9082494',
  UCD13: '3400890824941',
  ucdQtyMultiplicator: 50,
  cipLib: "SAPONARIA COMP BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3147117',
  CIP13: '3400931471172',
  ucdLib: "SAPONARIA COMP BOIR GRLS",
  UCD7: '9082502',
  UCD13: '3400890825023',
  ucdQtyMultiplicator: 80,
  cipLib: "SAPONARIA COMP BOIR GRLS BT 80",
  atcCode: "Z01"
}, {
  CIP7: '3147100',
  CIP13: '3400931471004',
  ucdLib: "SAPONARIA COMP BOIR GTT FL30ML",
  UCD7: '9082519',
  UCD13: '3400890825191',
  ucdQtyMultiplicator: 1,
  cipLib: "SAPONARIA COMP BOIR GTT FL30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '3202052',
  CIP13: '3400932020522',
  ucdLib: "SCLEROCALCINE CPR",
  UCD7: '9082850',
  UCD13: '3400890828505',
  ucdQtyMultiplicator: 60,
  cipLib: "SCLEROCALCINE CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3147181',
  CIP13: '3400931471813',
  ucdLib: "SCROFULARIA COMP BOIR CPR",
  UCD7: '9082910',
  UCD13: '3400890829106',
  ucdQtyMultiplicator: 50,
  cipLib: "SCROFULARIA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3147175',
  CIP13: '3400931471752',
  ucdLib: "SCROFULARIA COMP BOIR GRLS",
  UCD7: '9082927',
  UCD13: '3400890829274',
  ucdQtyMultiplicator: 80,
  cipLib: "SCROFULARIA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3147169',
  CIP13: '3400931471691',
  ucdLib: "SCROFULARIA COMP BOIR GTT 30ML",
  UCD7: '9114892',
  UCD13: '3400891148923',
  ucdQtyMultiplicator: 1,
  cipLib: "SCROFULARIA COMP BOIR GTT 30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3147270',
  CIP13: '3400931472704',
  ucdLib: "SEPIA COMP BOIR CPR",
  UCD7: '9083542',
  UCD13: '3400890835428',
  ucdQtyMultiplicator: 50,
  cipLib: "SEPIA COMP BOIR CPR BT 50",
  atcCode: "V03AX"
}, {
  CIP7: '3147264',
  CIP13: '3400931472643',
  ucdLib: "SEPIA COMP BOIR GRLS",
  UCD7: '9083559',
  UCD13: '3400890835596',
  ucdQtyMultiplicator: 80,
  cipLib: "SEPIA COMP BOIR GRLS BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3147258',
  CIP13: '3400931472582',
  ucdLib: "SEPIA COMP BOIR GTT FL30ML",
  UCD7: '9083565',
  UCD13: '3400890835657',
  ucdQtyMultiplicator: 1,
  cipLib: "SEPIA COMP BOIR GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5510970',
  CIP13: '3400955109709',
  ucdLib: "SODIUM 0,9% FRF INJ PPX1000ML",
  UCD7: '9115124',
  UCD13: '3400891151244',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ PPX1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5510964',
  CIP13: '3400955109648',
  ucdLib: "SODIUM 0,9% FRF INJ PPX500ML",
  UCD7: '9115153',
  UCD13: '3400891151534',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ PPX500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3147324',
  CIP13: '3400931473244',
  ucdLib: "STRONTIUM COMP BOIR CPR",
  UCD7: '9088350',
  UCD13: '3400890883504',
  ucdQtyMultiplicator: 50,
  cipLib: "STRONTIUM COMP BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3147318',
  CIP13: '3400931473183',
  ucdLib: "STRONTIUM COMP BOIR GRLS",
  UCD7: '9088367',
  UCD13: '3400890883672',
  ucdQtyMultiplicator: 80,
  cipLib: "STRONTIUM COMP BOIR GRLS BT 80",
  atcCode: "Z01"
}, {
  CIP7: '3147301',
  CIP13: '3400931473015',
  ucdLib: "STRONTIUM COMP BOIR GTT FL30ML",
  UCD7: '9115590',
  UCD13: '3400891155907',
  ucdQtyMultiplicator: 1,
  cipLib: "STRONTIUM COMP BOIR GTT FL30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '3147382',
  CIP13: '3400931473824',
  ucdLib: "STROPHANTUS COMP BOIR CPR",
  UCD7: '9088396',
  UCD13: '3400890883962',
  ucdQtyMultiplicator: 50,
  cipLib: "STROPHANTUS COMP BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3147376',
  CIP13: '3400931473763',
  ucdLib: "STROPHANTUS COMP BOIR GRLS",
  UCD7: '9088404',
  UCD13: '3400890884044',
  ucdQtyMultiplicator: 80,
  cipLib: "STROPHANTUS COMP BOIR GRLS BT 80",
  atcCode: "Z01"
}, {
  CIP7: '3147353',
  CIP13: '3400931473534',
  ucdLib: "STROPHANTUS COMP BOIR GTT 30ML",
  UCD7: '9088410',
  UCD13: '3400890884105',
  ucdQtyMultiplicator: 1,
  cipLib: "STROPHANTUS COMP BOIR GTT 30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '5514910',
  CIP13: '3400955149101',
  ucdLib: "SYNTOCINON 5UI INJ AMP1ML",
  UCD7: '9090068',
  UCD13: '3400890900683',
  ucdQtyMultiplicator: 50,
  cipLib: "SYNTOCINON 5UI INJ AMP1ML BT 50",
  atcCode: "H01BB02"
}, {
  CIP7: '3147442',
  CIP13: '3400931474425',
  ucdLib: "TABACUM COMP BOIR CPR",
  UCD7: '9090200',
  UCD13: '3400890902007',
  ucdQtyMultiplicator: 50,
  cipLib: "TABACUM COMP BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3147436',
  CIP13: '3400931474364',
  ucdLib: "TABACUM COMP BOIR GRLS",
  UCD7: '9090217',
  UCD13: '3400890902175',
  ucdQtyMultiplicator: 80,
  cipLib: "TABACUM COMP BOIR GRLS BT 80",
  atcCode: "Z01"
}, {
  CIP7: '3147413',
  CIP13: '3400931474135',
  ucdLib: "TABACUM COMP BOIR GTT FL30ML",
  UCD7: '9090223',
  UCD13: '3400890902236',
  ucdQtyMultiplicator: 1,
  cipLib: "TABACUM COMP BOIR GTT FL30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '5510378',
  CIP13: '3400955103783',
  ucdLib: "TELEBRIX 12 SODIUM FV250ML",
  UCD7: '9090772',
  UCD13: '3400890907729',
  ucdQtyMultiplicator: 10,
  cipLib: "TELEBRIX 12 SODIUM FV250ML BT 10",
  atcCode: "V08AA05"
}, {
  CIP7: '3147502',
  CIP13: '3400931475026',
  ucdLib: "TRIPHOSPHATES BOIR CPR",
  UCD7: '9095077',
  UCD13: '3400890950770',
  ucdQtyMultiplicator: 50,
  cipLib: "TRIPHOSPHATES BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3147494',
  CIP13: '3400931474944',
  ucdLib: "TRIPHOSPHATES BOIR PDR BT15G",
  UCD7: '9095083',
  UCD13: '3400890950831',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIPHOSPHATES BOIR PDR BT15G BT 1",
  atcCode: "Z05"
}, {
  CIP7: '3147554',
  CIP13: '3400931475545',
  ucdLib: "URANIUM COMP BOIR CPR",
  UCD7: '9096473',
  UCD13: '3400890964739',
  ucdQtyMultiplicator: 50,
  cipLib: "URANIUM COMP BOIR CPR BT 50",
  atcCode: "Z05"
}, {
  CIP7: '3147548',
  CIP13: '3400931475484',
  ucdLib: "URANIUM COMP BOIR GRLS",
  UCD7: '9096496',
  UCD13: '3400890964968',
  ucdQtyMultiplicator: 80,
  cipLib: "URANIUM COMP BOIR GRLS BT 80",
  atcCode: "Z01"
}, {
  CIP7: '3147531',
  CIP13: '3400931475316',
  ucdLib: "URANIUM COMP BOIR GTT FL30ML",
  UCD7: '9115897',
  UCD13: '3400891158977',
  ucdQtyMultiplicator: 1,
  cipLib: "URANIUM COMP BOIR GTT FL30ML BT 1",
  atcCode: "Z03"
}, {
  CIP7: '4987813',
  CIP13: '3400949878130',
  ucdLib: "VALACICLOVIR PFZ 500MG CPR",
  UCD7: '9368948',
  UCD13: '3400893689486',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR PFZ 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '4987859',
  CIP13: '3400949878598',
  ucdLib: "VALACICLOVIR PFZ 500MG CPR",
  UCD7: '9368948',
  UCD13: '3400893689486',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR PFZ 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '5516458',
  CIP13: '3400955164586',
  ucdLib: "XYLOCAINE VISQ.2% GEL TB100G",
  UCD7: '9101671',
  UCD13: '3400891016710',
  ucdQtyMultiplicator: 10,
  cipLib: "XYLOCAINE VISQ.2% GEL TB100G BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '3390289',
  CIP13: '3400933902896',
  ucdLib: "ALODONT BAIN BCHE FV30ML",
  UCD7: '9196275',
  UCD13: '3400891962758',
  ucdQtyMultiplicator: 1,
  cipLib: "ALODONT BAIN BCHE FV30ML BT 1",
  atcCode: "A01AB11"
}, {
  CIP7: '5599697',
  CIP13: '3400955996972',
  ucdLib: "AMCY KRYPTOGAS GENER",
  UCD7: '9194879',
  UCD13: '3400891948790',
  ucdQtyMultiplicator: 1,
  cipLib: "AMCY KRYPTOGAS GENER BT 1",
  atcCode: "V09EX01"
}, {
  CIP7: '5591170',
  CIP13: '3400955911708',
  ucdLib: "AMINOMIX 3 PERF POC1000ML",
  UCD7: '9177303',
  UCD13: '3400891773033',
  ucdQtyMultiplicator: 1,
  cipLib: "AMINOMIX 3 PERF POC1000ML BT 1",
  atcCode: "B05BA10"
}, {
  CIP7: '5591187',
  CIP13: '3400955911876',
  ucdLib: "AMINOMIX 3 PERF POC1500ML",
  UCD7: '9177326',
  UCD13: '3400891773262',
  ucdQtyMultiplicator: 1,
  cipLib: "AMINOMIX 3 PERF POC1500ML BT 1",
  atcCode: "B05BA10"
}, {
  CIP7: '5591193',
  CIP13: '3400955911937',
  ucdLib: "AMINOMIX 3 PERF POC2000ML",
  UCD7: '9177332',
  UCD13: '3400891773323',
  ucdQtyMultiplicator: 1,
  cipLib: "AMINOMIX 3 PERF POC2000ML BT 1",
  atcCode: "B05BA10"
}, {
  CIP7: '3568008',
  CIP13: '3400935680082',
  ucdLib: "ARANESP 100MCG INJ SRG0,5ML",
  UCD7: '9233243',
  UCD13: '3400892332437',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 100MCG INJ SRG0,5ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3567836',
  CIP13: '3400935678362',
  ucdLib: "ARANESP 10MCG INJ SRG0,4ML",
  UCD7: '9233237',
  UCD13: '3400892332376',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 10MCG INJ SRG0,4ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3568020',
  CIP13: '3400935680204',
  ucdLib: "ARANESP 150MCG INJ SRG0,3ML",
  UCD7: '9233289',
  UCD13: '3400892332895',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 150MCG INJ SRG0,3ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3567871',
  CIP13: '3400935678713',
  ucdLib: "ARANESP 20MCG INJ SRG0,5ML",
  UCD7: '9233295',
  UCD13: '3400892332956',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 20MCG INJ SRG0,5ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3567894',
  CIP13: '3400935678942',
  ucdLib: "ARANESP 30MCG INJ SRG0,3ML",
  UCD7: '9233326',
  UCD13: '3400892333267',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 30MCG INJ SRG0,3ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3567919',
  CIP13: '3400935679192',
  ucdLib: "ARANESP 40MCG INJ SRG0,4ML",
  UCD7: '9233355',
  UCD13: '3400892333557',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 40MCG INJ SRG0,4ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3567931',
  CIP13: '3400935679314',
  ucdLib: "ARANESP 50MCG INJ SRG0,5ML",
  UCD7: '9233361',
  UCD13: '3400892333618',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 50MCG INJ SRG0,5ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3567954',
  CIP13: '3400935679543',
  ucdLib: "ARANESP 60MCG INJ SRG0,3ML",
  UCD7: '9233384',
  UCD13: '3400892333847',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 60MCG INJ SRG0,3ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3567977',
  CIP13: '3400935679772',
  ucdLib: "ARANESP 80MCG INJ SRG0,4ML",
  UCD7: '9233390',
  UCD13: '3400892333908',
  ucdQtyMultiplicator: 4,
  cipLib: "ARANESP 80MCG INJ SRG0,4ML BT 4",
  atcCode: "B03XA02"
}, {
  CIP7: '3398463',
  CIP13: '3400933984632',
  ucdLib: "ARKOGELULES BARDANE",
  UCD7: '9144723',
  UCD13: '3400891447231',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES BARDANE BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3398457',
  CIP13: '3400933984571',
  ucdLib: "ARKOGELULES CASSIS GELU",
  UCD7: '9136712',
  UCD13: '3400891367126',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES CASSIS GELU BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3398440',
  CIP13: '3400933984403',
  ucdLib: "ARKOGELULES HAMAMELISGELU",
  UCD7: '9136729',
  UCD13: '3400891367294',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES HAMAMELISGELU BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '5594458',
  CIP13: '3400955944584',
  ucdLib: "BIBAG 650G PDR POC",
  UCD7: '9183143',
  UCD13: '3400891831436',
  ucdQtyMultiplicator: 10,
  cipLib: "BIBAG 650G PDR POC BT 10",
  atcCode: "B05ZA"
}, {
  CIP7: '3369929',
  CIP13: '3400933699291',
  ucdLib: "COCCULINE GLB DOS",
  UCD7: '9020599',
  UCD13: '3400890205993',
  ucdQtyMultiplicator: 6,
  cipLib: "COCCULINE GLB DOS BT 6",
  atcCode: "V03AX"
}, {
  CIP7: '3215327',
  CIP13: '3400932153275',
  ucdLib: "DEPURATUM GELU",
  UCD7: '9025154',
  UCD13: '3400890251549',
  ucdQtyMultiplicator: 60,
  cipLib: "DEPURATUM GELU BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '5594665',
  CIP13: '3400955946656',
  ucdLib: "DEXTRION G10 LAV INJ FL250ML",
  UCD7: '9183829',
  UCD13: '3400891838299',
  ucdQtyMultiplicator: 12,
  cipLib: "DEXTRION G10 LAV INJ FL250ML BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '5594642',
  CIP13: '3400955946427',
  ucdLib: "DEXTRION G5 LAV INJ FL250ML",
  UCD7: '9183841',
  UCD13: '3400891838411',
  ucdQtyMultiplicator: 12,
  cipLib: "DEXTRION G5 LAV INJ FL250ML BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '5594659',
  CIP13: '3400955946595',
  ucdLib: "DEXTRION G5 LAV INJ FL500ML",
  UCD7: '9183858',
  UCD13: '3400891838589',
  ucdQtyMultiplicator: 12,
  cipLib: "DEXTRION G5 LAV INJ FL500ML BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '5598930',
  CIP13: '3400955989301',
  ucdLib: "DOBUTAMINE AGT 250MG INJ FL",
  UCD7: '9192366',
  UCD13: '3400891923667',
  ucdQtyMultiplicator: 10,
  cipLib: "DOBUTAMINE AGT 250MG INJ FL BT 10",
  atcCode: "C01CA07"
}, {
  CIP7: '3213512',
  CIP13: '3400932135127',
  ucdLib: "ELGYDIUM PATE DENT TB8G",
  UCD7: '9234337',
  UCD13: '3400892343372',
  ucdQtyMultiplicator: 1,
  cipLib: "ELGYDIUM PATE DENT TB8G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3362560',
  CIP13: '3400933625603',
  ucdLib: "ELUSANES BARDANE 200MG GELU",
  UCD7: '9170815',
  UCD13: '3400891708158',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES BARDANE 200MG GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3555951',
  CIP13: '3400935559517',
  ucdLib: "GENESERINE 4,5MG CPR",
  UCD7: '9230960',
  UCD13: '3400892309606',
  ucdQtyMultiplicator: 30,
  cipLib: "GENESERINE 4,5MG CPR BT 30",
  atcCode: "A03FA"
}, {
  CIP7: '5598717',
  CIP13: '3400955987178',
  ucdLib: "GLUCOSE 10% SOLUPERF POC 100ML",
  UCD7: '9227337',
  UCD13: '3400892273372',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SOLUPERF POC 100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5598723',
  CIP13: '3400955987239',
  ucdLib: "GLUCOSE 10% SOLUPERF POC 250ML",
  UCD7: '9227395',
  UCD13: '3400892273952',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SOLUPERF POC 250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5598746',
  CIP13: '3400955987468',
  ucdLib: "GLUCOSE 10% SOLUPERF POC 500ML",
  UCD7: '9227403',
  UCD13: '3400892274034',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SOLUPERF POC 500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5598752',
  CIP13: '3400955987529',
  ucdLib: "GLUCOSE 10% SOLUPERF POC1000ML",
  UCD7: '9227372',
  UCD13: '3400892273723',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SOLUPERF POC1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5598769',
  CIP13: '3400955987697',
  ucdLib: "GLUCOSE 10% SOLUPERF POC2000ML",
  UCD7: '9227389',
  UCD13: '3400892273891',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% SOLUPERF POC2000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5592904',
  CIP13: '3400955929048',
  ucdLib: "GLUCOSE 20% REN INJ AMP10ML",
  UCD7: '9187454',
  UCD13: '3400891874549',
  ucdQtyMultiplicator: 100,
  cipLib: "GLUCOSE 20% REN INJ AMP10ML BT 100",
  atcCode: "B05BA03"
}, {
  CIP7: '3561360',
  CIP13: '3400935613608',
  ucdLib: "GLUCOSE 5% MAC INJ PML50ML",
  UCD7: '9230121',
  UCD13: '3400892301211',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ PML50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5598657',
  CIP13: '3400955986577',
  ucdLib: "GLUCOSE 5% SOLUPERF POC 100ML",
  UCD7: '9227426',
  UCD13: '3400892274263',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% SOLUPERF POC 100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5598663',
  CIP13: '3400955986638',
  ucdLib: "GLUCOSE 5% SOLUPERF POC 250ML",
  UCD7: '9227449',
  UCD13: '3400892274492',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% SOLUPERF POC 250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5598700',
  CIP13: '3400955987000',
  ucdLib: "GLUCOSE 5% SOLUPERF POC2000ML",
  UCD7: '9227432',
  UCD13: '3400892274324',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% SOLUPERF POC2000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5593789',
  CIP13: '3400955937890',
  ucdLib: "HEPTAMINOL RCA 187,8MG CPR",
  UCD7: '9176545',
  UCD13: '3400891765458',
  ucdQtyMultiplicator: 1000,
  cipLib: "HEPTAMINOL RCA 187,8MG CPR BT 1000",
  atcCode: "C01DX08"
}, {
  CIP7: '3217823',
  CIP13: '3400932178230',
  ucdLib: "IONITAN INJ FL500ML",
  UCD7: '9110888',
  UCD13: '3400891108880',
  ucdQtyMultiplicator: 1,
  cipLib: "IONITAN INJ FL500ML BT 1",
  atcCode: "B05XA30"
}, {
  CIP7: '3390071',
  CIP13: '3400933900717',
  ucdLib: "JOUVENCE ABBE SOURY CPR",
  UCD7: '9048155',
  UCD13: '3400890481557',
  ucdQtyMultiplicator: 180,
  cipLib: "JOUVENCE ABBE SOURY CPR BT 180",
  atcCode: "C05CX"
}, {
  CIP7: '3854719',
  CIP13: '3400938547191',
  ucdLib: "LOSARTAN/HYD.ALT 100/25MG C.",
  UCD7: '9333513',
  UCD13: '3400893335130',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN/HYD.ALT 100/25MG C. BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3854257',
  CIP13: '3400938542578',
  ucdLib: "LOSARTAN/HYD.ALT 50/12,5 CPR",
  UCD7: '9320640',
  UCD13: '3400893206409',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN/HYD.ALT 50/12,5 CPR BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3551657',
  CIP13: '3400935516572',
  ucdLib: "MANNITOL 20% MAC INJ POC1000ML",
  UCD7: '9169427',
  UCD13: '3400891694277',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 20% MAC INJ POC1000ML BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '5595423',
  CIP13: '3400955954231',
  ucdLib: "MEDIAM ETAIN STAN. INJ FL",
  UCD7: '9194454',
  UCD13: '3400891944549',
  ucdQtyMultiplicator: 5,
  cipLib: "MEDIAM ETAIN STAN. INJ FL BT 5",
  atcCode: "V09GX"
}, {
  CIP7: '5594719',
  CIP13: '3400955947196',
  ucdLib: "METHADONE AP-HP 40MG/15ML DOS",
  UCD7: '9178455',
  UCD13: '3400891784558',
  ucdQtyMultiplicator: 70,
  cipLib: "METHADONE AP-HP 40MG/15ML DOS BT 70",
  atcCode: "N07BC02"
}, {
  CIP7: '5594731',
  CIP13: '3400955947318',
  ucdLib: "METHADONE AP-HP 60MG/15ML DOS",
  UCD7: '9178461',
  UCD13: '3400891784619',
  ucdQtyMultiplicator: 70,
  cipLib: "METHADONE AP-HP 60MG/15ML DOS BT 70",
  atcCode: "N07BC02"
}, {
  CIP7: '5595498',
  CIP13: '3400955954989',
  ucdLib: "MEXILETINE AP-HP 200MG GELU",
  UCD7: '9058685',
  UCD13: '3400890586856',
  ucdQtyMultiplicator: 50,
  cipLib: "MEXILETINE AP-HP 200MG GELU BT 50",
  atcCode: "M09AX"
}, {
  CIP7: '3853588',
  CIP13: '3400938535884',
  ucdLib: "MG/B6 BGA 48MG/5MG CPR",
  UCD7: '9319080',
  UCD13: '3400893190807',
  ucdQtyMultiplicator: 50,
  cipLib: "MG/B6 BGA 48MG/5MG CPR BT 50",
  atcCode: "A12CC30"
}, {
  CIP7: '3853370',
  CIP13: '3400938533705',
  ucdLib: "MG/B6 BGC 48MG/5MG CPR",
  UCD7: '9332117',
  UCD13: '3400893321171',
  ucdQtyMultiplicator: 50,
  cipLib: "MG/B6 BGC 48MG/5MG CPR BT 50",
  atcCode: "A12CC30"
}, {
  CIP7: '5597706',
  CIP13: '3400955977063',
  ucdLib: "MONONINE 500UI INJ FL+FL+NEC",
  UCD7: '9181687',
  UCD13: '3400891816877',
  ucdQtyMultiplicator: 1,
  cipLib: "MONONINE 500UI INJ FL+FL+NEC BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5597238',
  CIP13: '3400955972389',
  ucdLib: "NIFLURIL 250MG GELU",
  UCD7: '9063002',
  UCD13: '3400890630023',
  ucdQtyMultiplicator: 100,
  cipLib: "NIFLURIL 250MG GELU BT 100",
  atcCode: "M01AX02"
}, {
  CIP7: '3564861',
  CIP13: '3400935648617',
  ucdLib: "NOCTIUM SIR FP125ML",
  UCD7: '9232232',
  UCD13: '3400892322322',
  ucdQtyMultiplicator: 1,
  cipLib: "NOCTIUM SIR FP125ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3560490',
  CIP13: '3400935604903',
  ucdLib: "OLICLINOMEL N6-900 P.T2L",
  UCD7: '9228176',
  UCD13: '3400892281766',
  ucdQtyMultiplicator: 4,
  cipLib: "OLICLINOMEL N6-900 P.T2L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '5595156',
  CIP13: '3400955951568',
  ucdLib: "ORNIDAZOLE MRM 1000MG A.5ML",
  UCD7: '9192372',
  UCD13: '3400891923728',
  ucdQtyMultiplicator: 100,
  cipLib: "ORNIDAZOLE MRM 1000MG A.5ML BT 100",
  atcCode: "J01XD03"
}, {
  CIP7: '5595110',
  CIP13: '3400955951100',
  ucdLib: "ORNIDAZOLE SRB 1000MG A.5ML",
  UCD7: '9249037',
  UCD13: '3400892490373',
  ucdQtyMultiplicator: 10,
  cipLib: "ORNIDAZOLE SRB 1000MG A.5ML BT 10",
  atcCode: "J01XD03"
}, {
  CIP7: '5595067',
  CIP13: '3400955950677',
  ucdLib: "ORNIDAZOLE SRB 500MG A.2,5ML",
  UCD7: '9192389',
  UCD13: '3400891923896',
  ucdQtyMultiplicator: 10,
  cipLib: "ORNIDAZOLE SRB 500MG A.2,5ML BT 10",
  atcCode: "J01XD03"
}, {
  CIP7: '3855512',
  CIP13: '3400938555127',
  ucdLib: "PARACETAMOL ALT 1G G.EFFV SAC",
  UCD7: '9328423',
  UCD13: '3400893284230',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ALT 1G G.EFFV SAC BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3390444',
  CIP13: '3400933904449',
  ucdLib: "PRESSICAINE FLUID SOL FL15ML",
  UCD7: '9245967',
  UCD13: '3400892459677',
  ucdQtyMultiplicator: 1,
  cipLib: "PRESSICAINE FLUID SOL FL15ML BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '5592117',
  CIP13: '3400955921172',
  ucdLib: "RADIOSELECTAN U. 30% FL250ML",
  UCD7: '9078251',
  UCD13: '3400890782517',
  ucdQtyMultiplicator: 10,
  cipLib: "RADIOSELECTAN U. 30% FL250ML BT 10",
  atcCode: "V08AA01"
}, {
  CIP7: '5592241',
  CIP13: '3400955922414',
  ucdLib: "RADIOSELECTAN UV 76% 60ML",
  UCD7: '9186302',
  UCD13: '3400891863024',
  ucdQtyMultiplicator: 10,
  cipLib: "RADIOSELECTAN UV 76% 60ML BT 10",
  atcCode: "V08AA01"
}, {
  CIP7: '3365736',
  CIP13: '3400933657369',
  ucdLib: "RAMET DALIBOUR LOC SOL FP250ML",
  UCD7: '9165866',
  UCD13: '3400891658668',
  ucdQtyMultiplicator: 1,
  cipLib: "RAMET DALIBOUR LOC SOL FP250ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3365742',
  CIP13: '3400933657420',
  ucdLib: "RAMET DALIBOUR LOC SOL FP500ML",
  UCD7: '9165872',
  UCD13: '3400891658729',
  ucdQtyMultiplicator: 1,
  cipLib: "RAMET DALIBOUR LOC SOL FP500ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3393158',
  CIP13: '3400933931582',
  ucdLib: "SALICAIRINE BUV GTT FL60ML",
  UCD7: '9114739',
  UCD13: '3400891147391',
  ucdQtyMultiplicator: 1,
  cipLib: "SALICAIRINE BUV GTT FL60ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3563212',
  CIP13: '3400935632128',
  ucdLib: "SODIUM 0,9% MAC INJ PML50ML",
  UCD7: '9230368',
  UCD13: '3400892303680',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PML50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5598605',
  CIP13: '3400955986058',
  ucdLib: "SODIUM 0,9% SOLUPERF POC 100ML",
  UCD7: '9227455',
  UCD13: '3400892274553',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% SOLUPERF POC 100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5598611',
  CIP13: '3400955986119',
  ucdLib: "SODIUM 0,9% SOLUPERF POC 250ML",
  UCD7: '9227461',
  UCD13: '3400892274614',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% SOLUPERF POC 250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5595009',
  CIP13: '3400955950097',
  ucdLib: "SODIUM 20% REN INJ AMP10ML",
  UCD7: '9183574',
  UCD13: '3400891835748',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 20% REN INJ AMP10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5595050',
  CIP13: '3400955950509',
  ucdLib: "SODIUM 20% REN INJ AMP20ML",
  UCD7: '9183427',
  UCD13: '3400891834277',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 20% REN INJ AMP20ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3364518',
  CIP13: '3400933645182',
  ucdLib: "STREPSILS MIEL-CITR. PAST",
  UCD7: '9143037',
  UCD13: '3400891430370',
  ucdQtyMultiplicator: 12,
  cipLib: "STREPSILS MIEL-CITR. PAST BT 12",
  atcCode: "R02AA20"
}, {
  CIP7: '5591810',
  CIP13: '3400955918103',
  ucdLib: "ZESTRIL 20MG CPR",
  UCD7: '9128061',
  UCD13: '3400891280616',
  ucdQtyMultiplicator: 100,
  cipLib: "ZESTRIL 20MG CPR BT 100",
  atcCode: "C09AA03"
}, {
  CIP7: '3510486',
  CIP13: '3400935104861',
  ucdLib: "ALDYZINE SOL DENT FL13ML",
  UCD7: '9390936',
  UCD13: '3400893909362',
  ucdQtyMultiplicator: 1,
  cipLib: "ALDYZINE SOL DENT FL13ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3510492',
  CIP13: '3400935104922',
  ucdLib: "ALDYZINE SOL DENT FL45ML",
  UCD7: '9390942',
  UCD13: '3400893909423',
  ucdQtyMultiplicator: 1,
  cipLib: "ALDYZINE SOL DENT FL45ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3518140',
  CIP13: '3400935181404',
  ucdLib: "AMINOVEN 10% PERF FL500ML",
  UCD7: '9291973',
  UCD13: '3400892919737',
  ucdQtyMultiplicator: 1,
  cipLib: "AMINOVEN 10% PERF FL500ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '3518105',
  CIP13: '3400935181053',
  ucdLib: "AMINOVEN 5% PERF FL500ML",
  UCD7: '9291996',
  UCD13: '3400892919966',
  ucdQtyMultiplicator: 1,
  cipLib: "AMINOVEN 5% PERF FL500ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '3517583',
  CIP13: '3400935175830',
  ucdLib: "ARKOGELULES FUCUS",
  UCD7: '9221085',
  UCD13: '3400892210858',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES FUCUS BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3626119',
  CIP13: '3400936261198',
  ucdLib: "ARKOGELULES MATE",
  UCD7: '9144924',
  UCD13: '3400891449242',
  ucdQtyMultiplicator: 60,
  cipLib: "ARKOGELULES MATE BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3626125',
  CIP13: '3400936261259',
  ucdLib: "ARKOGELULES MATE",
  UCD7: '9144924',
  UCD13: '3400891449242',
  ucdQtyMultiplicator: 180,
  cipLib: "ARKOGELULES MATE BT 180",
  atcCode: "V03AX"
}, {
  CIP7: '3417249',
  CIP13: '3400934172496',
  ucdLib: "ARKOGELULES OLIVIER",
  UCD7: '9184639',
  UCD13: '3400891846393',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES OLIVIER BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3653151',
  CIP13: '3400936531512',
  ucdLib: "CANOL CPR",
  UCD7: '9015954',
  UCD13: '3400890159548',
  ucdQtyMultiplicator: 60,
  cipLib: "CANOL CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3597843',
  CIP13: '3400935978431',
  ucdLib: "CORTEXAN FRAMYCETINE PATE 7,5G",
  UCD7: '9391060',
  UCD13: '3400893910603',
  ucdQtyMultiplicator: 1,
  cipLib: "CORTEXAN FRAMYCETINE PATE 7,5G BT 1",
  atcCode: "A01AC"
}, {
  CIP7: '3653903',
  CIP13: '3400936539037',
  ucdLib: "DIANEAL PD1 G.1,36% 3L+1,5L+LU",
  UCD7: '9291329',
  UCD13: '3400892913292',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% 3L+1,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3653978',
  CIP13: '3400936539785',
  ucdLib: "DIANEAL PD1 G.1,36% 3L+2,5L+LU",
  UCD7: '9291826',
  UCD13: '3400892918266',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% 3L+2,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3653949',
  CIP13: '3400936539495',
  ucdLib: "DIANEAL PD1 G.1,36% 3L+2L+LU",
  UCD7: '9291803',
  UCD13: '3400892918037',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% 3L+2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3653613',
  CIP13: '3400936536135',
  ucdLib: "DIANEAL PD1 G.1,36% PS2,5L+P.",
  UCD7: '9287730',
  UCD13: '3400892877303',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% PS2,5L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3653599',
  CIP13: '3400936535992',
  ucdLib: "DIANEAL PD1 G.1,36% PS2L+LU",
  UCD7: '9287641',
  UCD13: '3400892876412',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.1,36% PS2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3625249',
  CIP13: '3400936252493',
  ucdLib: "EAU P.P.I MAC P.FDEHP1000ML",
  UCD7: '9260808',
  UCD13: '3400892608082',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FDEHP1000ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3620358',
  CIP13: '3400936203587',
  ucdLib: "EAU P.P.I MAC P.FDEHP100ML",
  UCD7: '9260783',
  UCD13: '3400892607832',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FDEHP100ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3625226',
  CIP13: '3400936252264',
  ucdLib: "EAU P.P.I MAC P.FDEHP250ML",
  UCD7: '9260843',
  UCD13: '3400892608433',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FDEHP250ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3625232',
  CIP13: '3400936252325',
  ucdLib: "EAU P.P.I MAC P.FDEHP500ML",
  UCD7: '9260889',
  UCD13: '3400892608891',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FDEHP500ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3620341',
  CIP13: '3400936203419',
  ucdLib: "EAU P.P.I MAC P.FDEHP50ML",
  UCD7: '9260872',
  UCD13: '3400892608723',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FDEHP50ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3652795',
  CIP13: '3400936527959',
  ucdLib: "ELUSANES GATTIL.4,7MG GELU",
  UCD7: '9271516',
  UCD13: '3400892715162',
  ucdQtyMultiplicator: 60,
  cipLib: "ELUSANES GATTIL.4,7MG GELU BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3517175',
  CIP13: '3400935171757',
  ucdLib: "ETHER GIFRER LOC SOL FF200ML",
  UCD7: '9215334',
  UCD13: '3400892153346',
  ucdQtyMultiplicator: 1,
  cipLib: "ETHER GIFRER LOC SOL FF200ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3517181',
  CIP13: '3400935171818',
  ucdLib: "ETHER GIFRER LOC SOL FF400ML",
  UCD7: '9217936',
  UCD13: '3400892179360',
  ucdQtyMultiplicator: 1,
  cipLib: "ETHER GIFRER LOC SOL FF400ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3517198',
  CIP13: '3400935171986',
  ucdLib: "ETHER GIFRER LOC SOL FF800ML",
  UCD7: '9217942',
  UCD13: '3400892179421',
  ucdQtyMultiplicator: 1,
  cipLib: "ETHER GIFRER LOC SOL FF800ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3652772',
  CIP13: '3400936527720',
  ucdLib: "GELDOLOR GEL TB100G",
  UCD7: '9275520',
  UCD13: '3400892755205',
  ucdQtyMultiplicator: 1,
  cipLib: "GELDOLOR GEL TB100G BT 1",
  atcCode: "M02AB01"
}, {
  CIP7: '3598707',
  CIP13: '3400935987075',
  ucdLib: "GLUCOSE 10% PCA INJ DAT1000ML6",
  UCD7: '9312379',
  UCD13: '3400893123799',
  ucdQtyMultiplicator: 6,
  cipLib: "GLUCOSE 10% PCA INJ DAT1000ML6 BT 6",
  atcCode: "B05BA03"
}, {
  CIP7: '3598593',
  CIP13: '3400935985934',
  ucdLib: "GLUCOSE 10% PCA INJ DAT100ML40",
  UCD7: '9312362',
  UCD13: '3400893123621',
  ucdQtyMultiplicator: 40,
  cipLib: "GLUCOSE 10% PCA INJ DAT100ML40 BT 40",
  atcCode: "B05BA03"
}, {
  CIP7: '3598630',
  CIP13: '3400935986306',
  ucdLib: "GLUCOSE 10% PCA INJ DAT250ML20",
  UCD7: '9312385',
  UCD13: '3400893123850',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 10% PCA INJ DAT250ML20 BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3598676',
  CIP13: '3400935986764',
  ucdLib: "GLUCOSE 10% PCA INJ DAT500ML12",
  UCD7: '9312391',
  UCD13: '3400893123911',
  ucdQtyMultiplicator: 12,
  cipLib: "GLUCOSE 10% PCA INJ DAT500ML12 BT 12",
  atcCode: "B05BA03"
}, {
  CIP7: '3654475',
  CIP13: '3400936544758',
  ucdLib: "GLUCOSE 5% MAC PPDS100+100",
  UCD7: '9281319',
  UCD13: '3400892813196',
  ucdQtyMultiplicator: 2,
  cipLib: "GLUCOSE 5% MAC PPDS100+100 BT 2",
  atcCode: "B05BA03"
}, {
  CIP7: '3654481',
  CIP13: '3400936544819',
  ucdLib: "GLUCOSE 5% MAC PPDS250+100",
  UCD7: '9281325',
  UCD13: '3400892813257',
  ucdQtyMultiplicator: 2,
  cipLib: "GLUCOSE 5% MAC PPDS250+100 BT 2",
  atcCode: "B05BA03"
}, {
  CIP7: '3654469',
  CIP13: '3400936544697',
  ucdLib: "GLUCOSE 5% MAC PPDS50+100",
  UCD7: '9281331',
  UCD13: '3400892813318',
  ucdQtyMultiplicator: 2,
  cipLib: "GLUCOSE 5% MAC PPDS50+100 BT 2",
  atcCode: "B05BA03"
}, {
  CIP7: '3590686',
  CIP13: '3400935906861',
  ucdLib: "GLUCOSE 5% PCA INJ DAT100ML",
  UCD7: '9312215',
  UCD13: '3400893122150',
  ucdQtyMultiplicator: 40,
  cipLib: "GLUCOSE 5% PCA INJ DAT100ML BT 40",
  atcCode: "B05BA03"
}, {
  CIP7: '3590723',
  CIP13: '3400935907233',
  ucdLib: "GLUCOSE 5% PCA INJ DAT250ML",
  UCD7: '9312221',
  UCD13: '3400893122211',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 5% PCA INJ DAT250ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3590640',
  CIP13: '3400935906403',
  ucdLib: "GLUCOSE 5% PCA INJ DAT50ML",
  UCD7: '9312238',
  UCD13: '3400893122389',
  ucdQtyMultiplicator: 40,
  cipLib: "GLUCOSE 5% PCA INJ DAT50ML BT 40",
  atcCode: "B05BA03"
}, {
  CIP7: '3625278',
  CIP13: '3400936252783',
  ucdLib: "GLUCOSE 50% MAC P.DEHP100ML",
  UCD7: '9260961',
  UCD13: '3400892609614',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 50% MAC P.DEHP100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3625284',
  CIP13: '3400936252844',
  ucdLib: "GLUCOSE 50% MAC P.DEHP250ML",
  UCD7: '9260984',
  UCD13: '3400892609843',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 50% MAC P.DEHP250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3595241',
  CIP13: '3400935952417',
  ucdLib: "LITHIODERM 8% GEL TB30G",
  UCD7: '9251488',
  UCD13: '3400892514888',
  ucdQtyMultiplicator: 1,
  cipLib: "LITHIODERM 8% GEL TB30G BT 1",
  atcCode: "D11AX"
}, {
  CIP7: '3622021',
  CIP13: '3400936220218',
  ucdLib: "MINIRIN 0,1MG CPR",
  UCD7: '9172518',
  UCD13: '3400891725186',
  ucdQtyMultiplicator: 30,
  cipLib: "MINIRIN 0,1MG CPR BT 30",
  atcCode: "H01BA02"
}, {
  CIP7: '3417367',
  CIP13: '3400934173677',
  ucdLib: "MOPRAL 40MG INJ FL",
  UCD7: '9192142',
  UCD13: '3400891921427',
  ucdQtyMultiplicator: 5,
  cipLib: "MOPRAL 40MG INJ FL BT 5",
  atcCode: "A02BC01"
}, {
  CIP7: '3487155',
  CIP13: '3400934871559',
  ucdLib: "MULTIVITAMINES MYL CPR",
  UCD7: '9214808',
  UCD13: '3400892148083',
  ucdQtyMultiplicator: 20,
  cipLib: "MULTIVITAMINES MYL CPR BT 20",
  atcCode: "A11AA04"
}, {
  CIP7: '3539544',
  CIP13: '3400935395443',
  ucdLib: "NEUPOGEN 30 MU INJ SRG0,5ML",
  UCD7: '9259739',
  UCD13: '3400892597393',
  ucdQtyMultiplicator: 5,
  cipLib: "NEUPOGEN 30 MU INJ SRG0,5ML BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '3539521',
  CIP13: '3400935395214',
  ucdLib: "NEUPOGEN 48 MU INJ SRG0,5ML",
  UCD7: '9259745',
  UCD13: '3400892597454',
  ucdQtyMultiplicator: 5,
  cipLib: "NEUPOGEN 48 MU INJ SRG0,5ML BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '3483909',
  CIP13: '3400934839092',
  ucdLib: "NICORETTE INHAL 10MG C.+ETUI",
  UCD7: '9218456',
  UCD13: '3400892184562',
  ucdQtyMultiplicator: 42,
  cipLib: "NICORETTE INHAL 10MG C.+ETUI BT 42",
  atcCode: "N07BA01"
}, {
  CIP7: '3489355',
  CIP13: '3400934893551',
  ucdLib: "NOCTYL 15MG CPR",
  UCD7: '9210503',
  UCD13: '3400892105031',
  ucdQtyMultiplicator: 10,
  cipLib: "NOCTYL 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '3413464',
  CIP13: '3400934134647',
  ucdLib: "OSMOTOL SOL AURIC FL10ML",
  UCD7: '9190367',
  UCD13: '3400891903676',
  ucdQtyMultiplicator: 1,
  cipLib: "OSMOTOL SOL AURIC FL10ML BT 1",
  atcCode: "S02DC"
}, {
  CIP7: '3413197',
  CIP13: '3400934131974',
  ucdLib: "OTOMIDE SOL AURIC FL20ML",
  UCD7: '9066265',
  UCD13: '3400890662659',
  ucdQtyMultiplicator: 1,
  cipLib: "OTOMIDE SOL AURIC FL20ML BT 1",
  atcCode: "S02AA30"
}, {
  CIP7: '3622452',
  CIP13: '3400936224520',
  ucdLib: "OVITRELLE 250MCG INJ SRG0,5ML",
  UCD7: '9261469',
  UCD13: '3400892614694',
  ucdQtyMultiplicator: 1,
  cipLib: "OVITRELLE 250MCG INJ SRG0,5ML BT 1",
  atcCode: "G03GA08"
}, {
  CIP7: '3539509',
  CIP13: '3400935395092',
  ucdLib: "OXYGENE MED APM B.AL15L+CBSTA0",
  UCD7: '9236276',
  UCD13: '3400892362762',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.AL15L+CBSTA0 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3539484',
  CIP13: '3400935394842',
  ucdLib: "OXYGENE MED APM B.ALU2L+RM200",
  UCD7: '9236282',
  UCD13: '3400892362823',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ALU2L+RM200 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3539490',
  CIP13: '3400935394903',
  ucdLib: "OXYGENE MED APM B.ALU5L+CBSTA0",
  UCD7: '9236299',
  UCD13: '3400892362991',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ALU5L+CBSTA0 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3627633',
  CIP13: '3400936276338',
  ucdLib: "OXYGENE MED LDH CRYO.MOB 230L",
  UCD7: '9259515',
  UCD13: '3400892595153',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH CRYO.MOB 230L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3627656',
  CIP13: '3400936276567',
  ucdLib: "OXYGENE MED LDH CRYO.MOB 660L",
  UCD7: '9259521',
  UCD13: '3400892595214',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH CRYO.MOB 660L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3413429',
  CIP13: '3400934134296',
  ucdLib: "PEGA 1000MG CPR CROQ",
  UCD7: '9222618',
  UCD13: '3400892226187',
  ucdQtyMultiplicator: 30,
  cipLib: "PEGA 1000MG CPR CROQ BT 30",
  atcCode: "A13A"
}, {
  CIP7: '3413470',
  CIP13: '3400934134708',
  ucdLib: "PEGA 500MG CPR CROQ",
  UCD7: '9222624',
  UCD13: '3400892226248',
  ucdQtyMultiplicator: 20,
  cipLib: "PEGA 500MG CPR CROQ BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3410371',
  CIP13: '3400934103711',
  ucdLib: "PERICAL 1000MG CPR SUCER",
  UCD7: '9186093',
  UCD13: '3400891860931',
  ucdQtyMultiplicator: 30,
  cipLib: "PERICAL 1000MG CPR SUCER BT 30",
  atcCode: "A12AA04"
}, {
  CIP7: '3598937',
  CIP13: '3400935989376',
  ucdLib: "POLYIONIQUE G10 PCA DAT2000ML4",
  UCD7: '9312445',
  UCD13: '3400893124451',
  ucdQtyMultiplicator: 4,
  cipLib: "POLYIONIQUE G10 PCA DAT2000ML4 BT 4",
  atcCode: "B05BB02"
}, {
  CIP7: '3598854',
  CIP13: '3400935988546',
  ucdLib: "POLYIONIQUE G10 PCA DAT250ML20",
  UCD7: '9312451',
  UCD13: '3400893124512',
  ucdQtyMultiplicator: 20,
  cipLib: "POLYIONIQUE G10 PCA DAT250ML20 BT 20",
  atcCode: "B05BB02"
}, {
  CIP7: '3598877',
  CIP13: '3400935988775',
  ucdLib: "POLYIONIQUE G10 PCA DAT500ML12",
  UCD7: '9312468',
  UCD13: '3400893124680',
  ucdQtyMultiplicator: 12,
  cipLib: "POLYIONIQUE G10 PCA DAT500ML12 BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '3591450',
  CIP13: '3400935914507',
  ucdLib: "POLYIONIQUE G5 PCA DAT2000ML 4",
  UCD7: '9312474',
  UCD13: '3400893124741',
  ucdQtyMultiplicator: 4,
  cipLib: "POLYIONIQUE G5 PCA DAT2000ML 4 BT 4",
  atcCode: "B05BB02"
}, {
  CIP7: '3591384',
  CIP13: '3400935913845',
  ucdLib: "POLYIONIQUE G5 PCA DAT250ML 20",
  UCD7: '9312480',
  UCD13: '3400893124802',
  ucdQtyMultiplicator: 20,
  cipLib: "POLYIONIQUE G5 PCA DAT250ML 20 BT 20",
  atcCode: "B05BB02"
}, {
  CIP7: '3416238',
  CIP13: '3400934162381',
  ucdLib: "POLYTONYL ENF BUV SACH",
  UCD7: '9194141',
  UCD13: '3400891941418',
  ucdQtyMultiplicator: 18,
  cipLib: "POLYTONYL ENF BUV SACH BT 18",
  atcCode: "A11AA03"
}, {
  CIP7: '3417999',
  CIP13: '3400934179990',
  ucdLib: "PULMADOL BB. SIR FL125ML",
  UCD7: '9124815',
  UCD13: '3400891248159',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMADOL BB. SIR FL125ML BT 1",
  atcCode: "R05CA10"
}, {
  CIP7: '3652022',
  CIP13: '3400936520226',
  ucdLib: "RAMIPRIL TVC 1,25MG GELU",
  UCD7: '9267035',
  UCD13: '3400892670355',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVC 1,25MG GELU BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3652045',
  CIP13: '3400936520455',
  ucdLib: "RAMIPRIL TVC 2,5MG GELU",
  UCD7: '9267041',
  UCD13: '3400892670416',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVC 2,5MG GELU BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3652074',
  CIP13: '3400936520745',
  ucdLib: "RAMIPRIL TVC 5MG GELU",
  UCD7: '9267058',
  UCD13: '3400892670584',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVC 5MG GELU BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3517910',
  CIP13: '3400935179104',
  ucdLib: "RESCUEFLOW PERF POC250ML",
  UCD7: '9227260',
  UCD13: '3400892272603',
  ucdQtyMultiplicator: 6,
  cipLib: "RESCUEFLOW PERF POC250ML BT 6",
  atcCode: "B05AA05"
}, {
  CIP7: '3657083',
  CIP13: '3400936570832',
  ucdLib: "REVASC 15MG/0,5ML INJ FL+A.",
  UCD7: '9206453',
  UCD13: '3400892064536',
  ucdQtyMultiplicator: 10,
  cipLib: "REVASC 15MG/0,5ML INJ FL+A. BT 10",
  atcCode: "B01AE01"
}, {
  CIP7: '3591473',
  CIP13: '3400935914736',
  ucdLib: "RINGER LAC PCA DAT250ML",
  UCD7: '9312250',
  UCD13: '3400893122501',
  ucdQtyMultiplicator: 20,
  cipLib: "RINGER LAC PCA DAT250ML BT 20",
  atcCode: "B05BB01"
}, {
  CIP7: '3627975',
  CIP13: '3400936279759',
  ucdLib: "SANTANE N9 TIS SACH DOS",
  UCD7: '9082347',
  UCD13: '3400890823470',
  ucdQtyMultiplicator: 24,
  cipLib: "SANTANE N9 TIS SACH DOS BT 24",
  atcCode: "V03AX"
}, {
  CIP7: '3654914',
  CIP13: '3400936549142',
  ucdLib: "SODIUM 0,9% MAC PPDS 50+100",
  UCD7: '9281420',
  UCD13: '3400892814209',
  ucdQtyMultiplicator: 2,
  cipLib: "SODIUM 0,9% MAC PPDS 50+100 BT 2",
  atcCode: "B05XA03"
}, {
  CIP7: '3654920',
  CIP13: '3400936549203',
  ucdLib: "SODIUM 0,9% MAC PPDS100+100",
  UCD7: '9281408',
  UCD13: '3400892814087',
  ucdQtyMultiplicator: 2,
  cipLib: "SODIUM 0,9% MAC PPDS100+100 BT 2",
  atcCode: "B05XA03"
}, {
  CIP7: '3654937',
  CIP13: '3400936549371',
  ucdLib: "SODIUM 0,9% MAC PPDS250+100",
  UCD7: '9281414',
  UCD13: '3400892814148',
  ucdQtyMultiplicator: 2,
  cipLib: "SODIUM 0,9% MAC PPDS250+100 BT 2",
  atcCode: "B05XA03"
}, {
  CIP7: '3591007',
  CIP13: '3400935910073',
  ucdLib: "SODIUM 0,9% PCA INJ DAT100ML",
  UCD7: '9312273',
  UCD13: '3400893122730',
  ucdQtyMultiplicator: 40,
  cipLib: "SODIUM 0,9% PCA INJ DAT100ML BT 40",
  atcCode: "B05XA03"
}, {
  CIP7: '3591059',
  CIP13: '3400935910592',
  ucdLib: "SODIUM 0,9% PCA INJ DAT250ML",
  UCD7: '9312310',
  UCD13: '3400893123102',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% PCA INJ DAT250ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3590976',
  CIP13: '3400935909763',
  ucdLib: "SODIUM 0,9% PCA INJ DAT50ML",
  UCD7: '9312333',
  UCD13: '3400893123331',
  ucdQtyMultiplicator: 40,
  cipLib: "SODIUM 0,9% PCA INJ DAT50ML BT 40",
  atcCode: "B05XA03"
}, {
  CIP7: '3591119',
  CIP13: '3400935911193',
  ucdLib: "SODIUM 0,9% PCA INJ DT1000ML",
  UCD7: '9312296',
  UCD13: '3400893122969',
  ucdQtyMultiplicator: 6,
  cipLib: "SODIUM 0,9% PCA INJ DT1000ML BT 6",
  atcCode: "B05XA03"
}, {
  CIP7: '3591131',
  CIP13: '3400935911315',
  ucdLib: "SODIUM 0,9% PCA INJ DT2000ML",
  UCD7: '9312304',
  UCD13: '3400893123041',
  ucdQtyMultiplicator: 5,
  cipLib: "SODIUM 0,9% PCA INJ DT2000ML BT 5",
  atcCode: "B05XA03"
}, {
  CIP7: '3591160',
  CIP13: '3400935911605',
  ucdLib: "SODIUM 0,9% PCA INJ DT3000ML",
  UCD7: '9312327',
  UCD13: '3400893123270',
  ucdQtyMultiplicator: 3,
  cipLib: "SODIUM 0,9% PCA INJ DT3000ML BT 3",
  atcCode: "B05XA03"
}, {
  CIP7: '3511876',
  CIP13: '3400935118769',
  ucdLib: "SODIUM BIC 8,4% CPF A.10ML",
  UCD7: '9216457',
  UCD13: '3400892164571',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 8,4% CPF A.10ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '3657108',
  CIP13: '3400936571082',
  ucdLib: "SUCCICAPTAL 200MG GELU",
  UCD7: '9187402',
  UCD13: '3400891874020',
  ucdQtyMultiplicator: 15,
  cipLib: "SUCCICAPTAL 200MG GELU BT 15",
  atcCode: "V03AB"
}, {
  CIP7: '3486210',
  CIP13: '3400934862106',
  ucdLib: "SYMPATHYL CPR PELLIC",
  UCD7: '9213068',
  UCD13: '3400892130682',
  ucdQtyMultiplicator: 40,
  cipLib: "SYMPATHYL CPR PELLIC BT 40",
  atcCode: "N05CX"
}, {
  CIP7: '3532051',
  CIP13: '3400935320513',
  ucdLib: "VENTOLINE 2,5MG INHAL UNIDOS",
  UCD7: '9221010',
  UCD13: '3400892210100',
  ucdQtyMultiplicator: 20,
  cipLib: "VENTOLINE 2,5MG INHAL UNIDOS BT 20",
  atcCode: "R03AC02"
}, {
  CIP7: '3532097',
  CIP13: '3400935320971',
  ucdLib: "VENTOLINE 5MG INHAL UNIDOS",
  UCD7: '9221027',
  UCD13: '3400892210278',
  ucdQtyMultiplicator: 20,
  cipLib: "VENTOLINE 5MG INHAL UNIDOS BT 20",
  atcCode: "R03AC02"
}, {
  CIP7: '3488700',
  CIP13: '3400934887000',
  ucdLib: "ZOPICLONE MYL 7,5MG CPR",
  UCD7: '9210816',
  UCD13: '3400892108162',
  ucdQtyMultiplicator: 5,
  cipLib: "ZOPICLONE MYL 7,5MG CPR BT 5",
  atcCode: "N05CF01"
}, {
  CIP7: '5600696',
  CIP13: '3400956006960',
  ucdLib: "ACUITEL 20MG CPR",
  UCD7: '9140932',
  UCD13: '3400891409321',
  ucdQtyMultiplicator: 50,
  cipLib: "ACUITEL 20MG CPR BT 50",
  atcCode: "C09AA06"
}, {
  CIP7: '5600710',
  CIP13: '3400956007103',
  ucdLib: "ACUITEL 5MG CPR",
  UCD7: '9140949',
  UCD13: '3400891409499',
  ucdQtyMultiplicator: 50,
  cipLib: "ACUITEL 5MG CPR BT 50",
  atcCode: "C09AA06"
}, {
  CIP7: '3463491',
  CIP13: '3400934634918',
  ucdLib: "AUBELINE AUBEPINE GELU",
  UCD7: '9212991',
  UCD13: '3400892129914',
  ucdQtyMultiplicator: 45,
  cipLib: "AUBELINE AUBEPINE GELU BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3463539',
  CIP13: '3400934635397',
  ucdLib: "AUBELINE AUBEPINE GELU",
  UCD7: '9212991',
  UCD13: '3400892129914',
  ucdQtyMultiplicator: 150,
  cipLib: "AUBELINE AUBEPINE GELU BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3468057',
  CIP13: '3400934680571',
  ucdLib: "BUCCOSOIN BAIN BCHE FL500ML",
  UCD7: '9348874',
  UCD13: '3400893488744',
  ucdQtyMultiplicator: 1,
  cipLib: "BUCCOSOIN BAIN BCHE FL500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3188926',
  CIP13: '3400931889267',
  ucdLib: "CATARSTAT COLLY FL10ML",
  UCD7: '9016853',
  UCD13: '3400890168533',
  ucdQtyMultiplicator: 1,
  cipLib: "CATARSTAT COLLY FL10ML BT 1",
  atcCode: "S01XA"
}, {
  CIP7: '3157239',
  CIP13: '3400931572398',
  ucdLib: "DIALYSE PER. BSD \"1\" FP10L",
  UCD7: '9026225',
  UCD13: '3400890262255',
  ucdQtyMultiplicator: 1,
  cipLib: "DIALYSE PER. BSD \"1\" FP10L BT 1",
  atcCode: "B05DA"
}, {
  CIP7: '3154666',
  CIP13: '3400931546665',
  ucdLib: "DIGEDRYL CPR EFFV",
  UCD7: '9026811',
  UCD13: '3400890268110',
  ucdQtyMultiplicator: 30,
  cipLib: "DIGEDRYL CPR EFFV BT 30",
  atcCode: "A02X"
}, {
  CIP7: '3541788',
  CIP13: '3400935417886',
  ucdLib: "DURAPHAT 50MG/ML SUSP TB1,6ML",
  UCD7: '9284631',
  UCD13: '3400892846316',
  ucdQtyMultiplicator: 5,
  cipLib: "DURAPHAT 50MG/ML SUSP TB1,6ML BT 5",
  atcCode: "A01AA01"
}, {
  CIP7: '5600408',
  CIP13: '3400956004089',
  ucdLib: "EAU P.P.I GILB UNIDOS20ML",
  UCD7: '9206565',
  UCD13: '3400892065656',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I GILB UNIDOS20ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5604702',
  CIP13: '3400956047024',
  ucdLib: "EFFERALGANMED 500MG CPR",
  UCD7: '9148388',
  UCD13: '3400891483888',
  ucdQtyMultiplicator: 100,
  cipLib: "EFFERALGANMED 500MG CPR BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '3549100',
  CIP13: '3400935491008',
  ucdLib: "ETHER CPF LOC SOL FL125ML",
  UCD7: '9228791',
  UCD13: '3400892287911',
  ucdQtyMultiplicator: 1,
  cipLib: "ETHER CPF LOC SOL FL125ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '5604292',
  CIP13: '3400956042920',
  ucdLib: "FLUOROURACILE TVC 250MG FL5ML",
  UCD7: '9196186',
  UCD13: '3400891961867',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE TVC 250MG FL5ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5609875',
  CIP13: '3400956098750',
  ucdLib: "GALLIUM 67 AMH 74-370MBQ FL",
  UCD7: '9205488',
  UCD13: '3400892054889',
  ucdQtyMultiplicator: 1,
  cipLib: "GALLIUM 67 AMH 74-370MBQ FL BT 1",
  atcCode: "V09HX01"
}, {
  CIP7: '5603134',
  CIP13: '3400956031344',
  ucdLib: "GAMMAGARD 50MG/ML FL+FL50ML",
  UCD7: '9199061',
  UCD13: '3400891990614',
  ucdQtyMultiplicator: 1,
  cipLib: "GAMMAGARD 50MG/ML FL+FL50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5601069',
  CIP13: '3400956010691',
  ucdLib: "GLUCOSE 2,5% AGT INJ FV1000ML",
  UCD7: '9176516',
  UCD13: '3400891765168',
  ucdQtyMultiplicator: 6,
  cipLib: "GLUCOSE 2,5% AGT INJ FV1000ML BT 6",
  atcCode: "B05BA03"
}, {
  CIP7: '3589275',
  CIP13: '3400935892751',
  ucdLib: "GLUCOSE 5% MAC POC.S100ML+NEC",
  UCD7: '9241188',
  UCD13: '3400892411880',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC POC.S100ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3589482',
  CIP13: '3400935894823',
  ucdLib: "GLUCOSE 5% MAC POC.S250ML+NEC",
  UCD7: '9241219',
  UCD13: '3400892412191',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC POC.S250ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3589499',
  CIP13: '3400935894991',
  ucdLib: "GLUCOSE 5% MAC POC.S500ML+NEC",
  UCD7: '9241231',
  UCD13: '3400892412313',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC POC.S500ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3589269',
  CIP13: '3400935892690',
  ucdLib: "GLUCOSE 5% MAC POC.S50ML+NEC",
  UCD7: '9241225',
  UCD13: '3400892412252',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC POC.S50ML+NEC BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5608841',
  CIP13: '3400956088416',
  ucdLib: "GRAFALON 20MG/ML INJ FL2ML",
  UCD7: '9194891',
  UCD13: '3400891948912',
  ucdQtyMultiplicator: 1,
  cipLib: "GRAFALON 20MG/ML INJ FL2ML BT 1",
  atcCode: "L04AA03"
}, {
  CIP7: '5608858',
  CIP13: '3400956088584',
  ucdLib: "GRAFALON 20MG/ML INJ FL2ML",
  UCD7: '9194891',
  UCD13: '3400891948912',
  ucdQtyMultiplicator: 10,
  cipLib: "GRAFALON 20MG/ML INJ FL2ML BT 10",
  atcCode: "L04AA03"
}, {
  CIP7: '5608864',
  CIP13: '3400956088645',
  ucdLib: "GRAFALON 20MG/ML INJ FL5ML",
  UCD7: '9194885',
  UCD13: '3400891948851',
  ucdQtyMultiplicator: 1,
  cipLib: "GRAFALON 20MG/ML INJ FL5ML BT 1",
  atcCode: "L04AA03"
}, {
  CIP7: '3463516',
  CIP13: '3400934635168',
  ucdLib: "HARPADOL HARPAGO GELU",
  UCD7: '9213022',
  UCD13: '3400892130224',
  ucdQtyMultiplicator: 45,
  cipLib: "HARPADOL HARPAGO GELU BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '3463522',
  CIP13: '3400934635229',
  ucdLib: "HARPADOL HARPAGO GELU",
  UCD7: '9213022',
  UCD13: '3400892130224',
  ucdQtyMultiplicator: 150,
  cipLib: "HARPADOL HARPAGO GELU BT 150",
  atcCode: "V03AX"
}, {
  CIP7: '3587508',
  CIP13: '3400935875082',
  ucdLib: "HOMEOAFTYL CPR SUCER",
  UCD7: '9237991',
  UCD13: '3400892379913',
  ucdQtyMultiplicator: 60,
  cipLib: "HOMEOAFTYL CPR SUCER BT 60",
  atcCode: "A01AD11"
}, {
  CIP7: '5609964',
  CIP13: '3400956099641',
  ucdLib: "INDIUM 111 MLK 370MBQ FL10ML",
  UCD7: '9209977',
  UCD13: '3400892099774',
  ucdQtyMultiplicator: 1,
  cipLib: "INDIUM 111 MLK 370MBQ FL10ML BT 1",
  atcCode: "V09HB"
}, {
  CIP7: '3183461',
  CIP13: '3400931834618',
  ucdLib: "INTRAIT MARRON INDE P BUV 60ML",
  UCD7: '9046943',
  UCD13: '3400890469432',
  ucdQtyMultiplicator: 1,
  cipLib: "INTRAIT MARRON INDE P BUV 60ML BT 1",
  atcCode: "C05CX"
}, {
  CIP7: '3544485',
  CIP13: '3400935444851',
  ucdLib: "LANSOYL FRAMB. GEL UNIDOS",
  UCD7: '9224379',
  UCD13: '3400892243795',
  ucdQtyMultiplicator: 10,
  cipLib: "LANSOYL FRAMB. GEL UNIDOS BT 10",
  atcCode: "A06AA01"
}, {
  CIP7: '3460877',
  CIP13: '3400934608773',
  ucdLib: "MAG 2 100MG CPR",
  UCD7: '9207151',
  UCD13: '3400892071510',
  ucdQtyMultiplicator: 60,
  cipLib: "MAG 2 100MG CPR BT 60",
  atcCode: "A12CC08"
}, {
  CIP7: '3460908',
  CIP13: '3400934609084',
  ucdLib: "MAG 2 100MG CPR",
  UCD7: '9207151',
  UCD13: '3400892071510',
  ucdQtyMultiplicator: 120,
  cipLib: "MAG 2 100MG CPR BT 120",
  atcCode: "A12CC08"
}, {
  CIP7: '3464237',
  CIP13: '3400934642371',
  ucdLib: "NARAMIG 2,5MG CPR",
  UCD7: '9202544',
  UCD13: '3400892025445',
  ucdQtyMultiplicator: 18,
  cipLib: "NARAMIG 2,5MG CPR BT 18",
  atcCode: "N02CC02"
}, {
  CIP7: '5607356',
  CIP13: '3400956073566',
  ucdLib: "NARCOZEP 1MG INJ AMP+AMP",
  UCD7: '9107113',
  UCD13: '3400891071139',
  ucdQtyMultiplicator: 3,
  cipLib: "NARCOZEP 1MG INJ AMP+AMP BT 3",
  atcCode: "N05CD03"
}, {
  CIP7: '3159072',
  CIP13: '3400931590729',
  ucdLib: "NICOPRIVE CPR ENROB",
  UCD7: '9062959',
  UCD13: '3400890629591',
  ucdQtyMultiplicator: 120,
  cipLib: "NICOPRIVE CPR ENROB BT 120",
  atcCode: "N07BA"
}, {
  CIP7: '3159089',
  CIP13: '3400931590897',
  ucdLib: "NICOPRIVE CPR ENROB",
  UCD7: '9062959',
  UCD13: '3400890629591',
  ucdQtyMultiplicator: 240,
  cipLib: "NICOPRIVE CPR ENROB BT 240",
  atcCode: "N07BA"
}, {
  CIP7: '5609361',
  CIP13: '3400956093618',
  ucdLib: "NORADRENALINE AGT 2MG/ML 4ML",
  UCD7: '9195761',
  UCD13: '3400891957617',
  ucdQtyMultiplicator: 50,
  cipLib: "NORADRENALINE AGT 2MG/ML 4ML BT 50",
  atcCode: "C01CA03"
}, {
  CIP7: '3545473',
  CIP13: '3400935454737',
  ucdLib: "NUROFENFLASH 200MG CPR",
  UCD7: '9271108',
  UCD13: '3400892711089',
  ucdQtyMultiplicator: 20,
  cipLib: "NUROFENFLASH 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '5601626',
  CIP13: '3400956016266',
  ucdLib: "OPTIRAY 300 INJ FV50ML",
  UCD7: '9147466',
  UCD13: '3400891474664',
  ucdQtyMultiplicator: 25,
  cipLib: "OPTIRAY 300 INJ FV50ML BT 25",
  atcCode: "V08AB07"
}, {
  CIP7: '5605877',
  CIP13: '3400956058778',
  ucdLib: "OXYGENE MED APM VAPO.FIX 100L",
  UCD7: '9193271',
  UCD13: '3400891932713',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM VAPO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605860',
  CIP13: '3400956058600',
  ucdLib: "OXYGENE MED APM VAPO.MOB 180L",
  UCD7: '9193294',
  UCD13: '3400891932942',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM VAPO.MOB 180L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605883',
  CIP13: '3400956058839',
  ucdLib: "OXYGENE MED SAG BOUT 50L",
  UCD7: '9193590',
  UCD13: '3400891935905',
  ucdQtyMultiplicator: 9,
  cipLib: "OXYGENE MED SAG BOUT 50L BT 9",
  atcCode: "V03AN01"
}, {
  CIP7: '5605908',
  CIP13: '3400956059089',
  ucdLib: "OXYGENE MED SAG BOUT 50L",
  UCD7: '9193590',
  UCD13: '3400891935905',
  ucdQtyMultiplicator: 16,
  cipLib: "OXYGENE MED SAG BOUT 50L BT 16",
  atcCode: "V03AN01"
}, {
  CIP7: '5605989',
  CIP13: '3400956059898',
  ucdLib: "OXYGENE MED SAG VAPO.FIX 100L",
  UCD7: '9193354',
  UCD13: '3400891933543',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG VAPO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605920',
  CIP13: '3400956059201',
  ucdLib: "OXYGENE MED SAG VAPO.MOB 180L",
  UCD7: '9193377',
  UCD13: '3400891933772',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG VAPO.MOB 180L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605937',
  CIP13: '3400956059379',
  ucdLib: "OXYGENE MED SAG VAPO.MOB 200L",
  UCD7: '9193383',
  UCD13: '3400891933833',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SAG VAPO.MOB 200L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3462882',
  CIP13: '3400934628825',
  ucdLib: "PERCUTAFEINE GEL DERM TB192G",
  UCD7: '9228354',
  UCD13: '3400892283548',
  ucdQtyMultiplicator: 1,
  cipLib: "PERCUTAFEINE GEL DERM TB192G BT 1",
  atcCode: "D11AX"
}, {
  CIP7: '3543818',
  CIP13: '3400935438188',
  ucdLib: "PHARMATEX 18,9MG CAPS VAG",
  UCD7: '9232172',
  UCD13: '3400892321721',
  ucdQtyMultiplicator: 6,
  cipLib: "PHARMATEX 18,9MG CAPS VAG BT 6",
  atcCode: "G02BB"
}, {
  CIP7: '5607008',
  CIP13: '3400956070084',
  ucdLib: "PRETERIAN 4MG/1,25MG CPR",
  UCD7: '9205790',
  UCD13: '3400892057903',
  ucdQtyMultiplicator: 100,
  cipLib: "PRETERIAN 4MG/1,25MG CPR BT 100",
  atcCode: "C09BA04"
}, {
  CIP7: '5601508',
  CIP13: '3400956015085',
  ucdLib: "QUADRASA 2G PDR RECT FL4,2G",
  UCD7: '9197984',
  UCD13: '3400891979848',
  ucdQtyMultiplicator: 1,
  cipLib: "QUADRASA 2G PDR RECT FL4,2G BT 1",
  atcCode: "A07EC"
}, {
  CIP7: '3178661',
  CIP13: '3400931786610',
  ucdLib: "RADIOSELECTAN UV 76% 100ML+NEC",
  UCD7: '9078297',
  UCD13: '3400890782975',
  ucdQtyMultiplicator: 1,
  cipLib: "RADIOSELECTAN UV 76% 100ML+NEC BT 1",
  atcCode: "V08AA01"
}, {
  CIP7: '3178690',
  CIP13: '3400931786900',
  ucdLib: "RADIOSELECTAN UV 76% 200ML",
  UCD7: '9078280',
  UCD13: '3400890782807',
  ucdQtyMultiplicator: 1,
  cipLib: "RADIOSELECTAN UV 76% 200ML BT 1",
  atcCode: "V08AA01"
}, {
  CIP7: '3178678',
  CIP13: '3400931786788',
  ucdLib: "RADIOSELECTAN UV 76% 50ML +NEC",
  UCD7: '9078305',
  UCD13: '3400890783057',
  ucdQtyMultiplicator: 1,
  cipLib: "RADIOSELECTAN UV 76% 50ML +NEC BT 1",
  atcCode: "V08AA01"
}, {
  CIP7: '3702406',
  CIP13: '3400937024068',
  ucdLib: "REVATIO 20MG CPR",
  UCD7: '9279972',
  UCD13: '3400892799728',
  ucdQtyMultiplicator: 90,
  cipLib: "REVATIO 20MG CPR BT 90",
  atcCode: "G04BE03"
}, {
  CIP7: '5602198',
  CIP13: '3400956021987',
  ucdLib: "RINGER AGT DAT500ML",
  UCD7: '9199753',
  UCD13: '3400891997538',
  ucdQtyMultiplicator: 20,
  cipLib: "RINGER AGT DAT500ML BT 20",
  atcCode: "B05BB01"
}, {
  CIP7: '5602146',
  CIP13: '3400956021468',
  ucdLib: "RINGER AGT FV500ML",
  UCD7: '9199724',
  UCD13: '3400891997248',
  ucdQtyMultiplicator: 12,
  cipLib: "RINGER AGT FV500ML BT 12",
  atcCode: "B05BB01"
}, {
  CIP7: '5607735',
  CIP13: '3400956077359',
  ucdLib: "RINGER LAC AGT FV1000ML",
  UCD7: '9114544',
  UCD13: '3400891145441',
  ucdQtyMultiplicator: 6,
  cipLib: "RINGER LAC AGT FV1000ML BT 6",
  atcCode: "B05BB01"
}, {
  CIP7: '5607712',
  CIP13: '3400956077120',
  ucdLib: "RINGER LAC AGT FV250ML",
  UCD7: '9080532',
  UCD13: '3400890805322',
  ucdQtyMultiplicator: 12,
  cipLib: "RINGER LAC AGT FV250ML BT 12",
  atcCode: "B05BB01"
}, {
  CIP7: '5607729',
  CIP13: '3400956077298',
  ucdLib: "RINGER LAC AGT FV500ML",
  UCD7: '9114550',
  UCD13: '3400891145502',
  ucdQtyMultiplicator: 12,
  cipLib: "RINGER LAC AGT FV500ML BT 12",
  atcCode: "B05BB01"
}, {
  CIP7: '3188205',
  CIP13: '3400931882053',
  ucdLib: "SANTANE N9 TIS FV90G",
  UCD7: '9082330',
  UCD13: '3400890823302',
  ucdQtyMultiplicator: 1,
  cipLib: "SANTANE N9 TIS FV90G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3188091',
  CIP13: '3400931880912',
  ucdLib: "SANTANE O1 TIS FV90G",
  UCD7: '9082353',
  UCD13: '3400890823531',
  ucdQtyMultiplicator: 1,
  cipLib: "SANTANE O1 TIS FV90G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3178922',
  CIP13: '3400931789222',
  ucdLib: "SEBRANE M.GORG COLLU FL30ML",
  UCD7: '9010997',
  UCD13: '3400890109970',
  ucdQtyMultiplicator: 1,
  cipLib: "SEBRANE M.GORG COLLU FL30ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '5603275',
  CIP13: '3400956032754',
  ucdLib: "SODIUM 0,9% FRF INJ PBF2000ML",
  UCD7: '9234188',
  UCD13: '3400892341880',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ PBF2000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3174545',
  CIP13: '3400931745457',
  ucdLib: "SORIN VERMIFUGE BUV FL200ML",
  UCD7: '9086457',
  UCD13: '3400890864572',
  ucdQtyMultiplicator: 1,
  cipLib: "SORIN VERMIFUGE BUV FL200ML BT 1",
  atcCode: "P02CB01"
}, {
  CIP7: '3187594',
  CIP13: '3400931875949',
  ucdLib: "TOTAPEN 500MG GELU",
  UCD7: '9094043',
  UCD13: '3400890940436',
  ucdQtyMultiplicator: 12,
  cipLib: "TOTAPEN 500MG GELU BT 12",
  atcCode: "J01CA01"
}, {
  CIP7: '3186264',
  CIP13: '3400931862642',
  ucdLib: "TRH FERRING 125Y/ML INJ AV2ML",
  UCD7: '9087959',
  UCD13: '3400890879590',
  ucdQtyMultiplicator: 2,
  cipLib: "TRH FERRING 125Y/ML INJ AV2ML BT 2",
  atcCode: "V04CJ02"
}, {
  CIP7: '3187565',
  CIP13: '3400931875659',
  ucdLib: "VEINOBIASE CPR EFFV",
  UCD7: '9098064',
  UCD13: '3400890980647',
  ucdQtyMultiplicator: 30,
  cipLib: "VEINOBIASE CPR EFFV BT 30",
  atcCode: "C05CA51"
}, {
  CIP7: '5600650',
  CIP13: '3400956006502',
  ucdLib: "XYLOCAINE 5MG/ML S/C FL20ML",
  UCD7: '9185231',
  UCD13: '3400891852318',
  ucdQtyMultiplicator: 10,
  cipLib: "XYLOCAINE 5MG/ML S/C FL20ML BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '3767328',
  CIP13: '3400937673280',
  ucdLib: "ALCOOL MODIFIE EVL LOC FP500ML",
  UCD7: '9312020',
  UCD13: '3400893120200',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE EVL LOC FP500ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3813962',
  CIP13: '3400938139624',
  ucdLib: "AMLODIPINE ALT 10MG GELU",
  UCD7: '9309006',
  UCD13: '3400893090060',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ALT 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3813979',
  CIP13: '3400938139792',
  ucdLib: "AMLODIPINE ALT 10MG GELU",
  UCD7: '9309006',
  UCD13: '3400893090060',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ALT 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3630960',
  CIP13: '3400936309609',
  ucdLib: "BICIRKAN CPR",
  UCD7: '9307734',
  UCD13: '3400893077344',
  ucdQtyMultiplicator: 30,
  cipLib: "BICIRKAN CPR BT 30",
  atcCode: "C05CX"
}, {
  CIP7: '3741470',
  CIP13: '3400937414708',
  ucdLib: "BUCCOBET 0,1MG CPR SUCER",
  UCD7: '9288623',
  UCD13: '3400892886237',
  ucdQtyMultiplicator: 50,
  cipLib: "BUCCOBET 0,1MG CPR SUCER BT 50",
  atcCode: "A01AC"
}, {
  CIP7: '3664611',
  CIP13: '3400936646117',
  ucdLib: "CAPTOPRIL/HYD.PKI 50/25MG C.",
  UCD7: '9267408',
  UCD13: '3400892674087',
  ucdQtyMultiplicator: 28,
  cipLib: "CAPTOPRIL/HYD.PKI 50/25MG C. BT 28",
  atcCode: "C09BA01"
}, {
  CIP7: '3741518',
  CIP13: '3400937415187',
  ucdLib: "CARDIOCALM CPR",
  UCD7: '9016439',
  UCD13: '3400890164399',
  ucdQtyMultiplicator: 80,
  cipLib: "CARDIOCALM CPR BT 80",
  atcCode: "V03AX"
}, {
  CIP7: '3662842',
  CIP13: '3400936628427',
  ucdLib: "DIANEAL PD1 G.3,86% 3L+1,5L+LU",
  UCD7: '9300927',
  UCD13: '3400893009277',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% 3L+1,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3662902',
  CIP13: '3400936629028',
  ucdLib: "DIANEAL PD1 G.3,86% 3L+2,5L+LU",
  UCD7: '9293185',
  UCD13: '3400892931852',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% 3L+2,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3662871',
  CIP13: '3400936628717',
  ucdLib: "DIANEAL PD1 G.3,86% 3L+2L+LU",
  UCD7: '9291849',
  UCD13: '3400892918495',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% 3L+2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3662569',
  CIP13: '3400936625693',
  ucdLib: "DIANEAL PD1 G.3,86% PS2,5L+P.",
  UCD7: '9287701',
  UCD13: '3400892877013',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% PS2,5L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3662546',
  CIP13: '3400936625464',
  ucdLib: "DIANEAL PD1 G.3,86% PS3L/2L+LU",
  UCD7: '9287664',
  UCD13: '3400892876641',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD1 G.3,86% PS3L/2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663020',
  CIP13: '3400936630208',
  ucdLib: "DIANEAL PD4 G.1,36% 3L/2,5L+P.",
  UCD7: '9287948',
  UCD13: '3400892879482',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% 3L/2,5L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663161',
  CIP13: '3400936631618',
  ucdLib: "DIANEAL PD4 G.1,36% PD2L+P.",
  UCD7: '9287925',
  UCD13: '3400892879253',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% PD2L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663327',
  CIP13: '3400936633278',
  ucdLib: "DIANEAL PD4 G.2,27% 3L/2,5L+P.",
  UCD7: '9287983',
  UCD13: '3400892879833',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% 3L/2,5L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663505',
  CIP13: '3400936635050',
  ucdLib: "DIANEAL PD4 G.2,27% PD2,5L+LU",
  UCD7: '9287871',
  UCD13: '3400892878713',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% PD2,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663304',
  CIP13: '3400936633049',
  ucdLib: "DIANEAL PD4 G.2,27% PS2L+LU",
  UCD7: '9287954',
  UCD13: '3400892879543',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% PS2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663758',
  CIP13: '3400936637580',
  ucdLib: "DIANEAL PD4 G.3,86% PD2L+P.",
  UCD7: '9288020',
  UCD13: '3400892880204',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.3,86% PD2L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663600',
  CIP13: '3400936636002',
  ucdLib: "DIANEAL PD4 G.3,86% PS2L+LU",
  UCD7: '9288008',
  UCD13: '3400892880082',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.3,86% PS2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3815091',
  CIP13: '3400938150919',
  ucdLib: "DOMPERIDONE ALT 10MG CPR",
  UCD7: '9305942',
  UCD13: '3400893059425',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE ALT 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3381497',
  CIP13: '3400933814977',
  ucdLib: "ELUSANES ORTIE GELU",
  UCD7: '9176829',
  UCD13: '3400891768299',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES ORTIE GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3636709',
  CIP13: '3400936367098',
  ucdLib: "ENDOTELON 150MG CPR",
  UCD7: '9136971',
  UCD13: '3400891369717',
  ucdQtyMultiplicator: 60,
  cipLib: "ENDOTELON 150MG CPR BT 60",
  atcCode: "C05CX"
}, {
  CIP7: '3769534',
  CIP13: '3400937695343',
  ucdLib: "EXJADE 250MG CPR DISP",
  UCD7: '9290933',
  UCD13: '3400892909332',
  ucdQtyMultiplicator: 28,
  cipLib: "EXJADE 250MG CPR DISP BT 28",
  atcCode: "V03AC03"
}, {
  CIP7: '3383473',
  CIP13: '3400933834739',
  ucdLib: "FLUDITEC AD. 5% SIR FL125ML",
  UCD7: '9183315',
  UCD13: '3400891833157',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUDITEC AD. 5% SIR FL125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3387028',
  CIP13: '3400933870287',
  ucdLib: "GLYCERINE SGP SUP AD. SACH",
  UCD7: '9172180',
  UCD13: '3400891721805',
  ucdQtyMultiplicator: 25,
  cipLib: "GLYCERINE SGP SUP AD. SACH BT 25",
  atcCode: "A06AX01"
}, {
  CIP7: '3387034',
  CIP13: '3400933870348',
  ucdLib: "GLYCERINE SGP SUP AD. SACH",
  UCD7: '9172180',
  UCD13: '3400891721805',
  ucdQtyMultiplicator: 50,
  cipLib: "GLYCERINE SGP SUP AD. SACH BT 50",
  atcCode: "A06AX01"
}, {
  CIP7: '3387040',
  CIP13: '3400933870409',
  ucdLib: "GLYCERINE SGP SUP AD. SACH",
  UCD7: '9172180',
  UCD13: '3400891721805',
  ucdQtyMultiplicator: 100,
  cipLib: "GLYCERINE SGP SUP AD. SACH BT 100",
  atcCode: "A06AX01"
}, {
  CIP7: '3666739',
  CIP13: '3400936667396',
  ucdLib: "GRANIONS SELENIUM BUV AMP2ML",
  UCD7: '9040857',
  UCD13: '3400890408578',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS SELENIUM BUV AMP2ML BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3638499',
  CIP13: '3400936384996',
  ucdLib: "HEXALYSE CPR SUCER",
  UCD7: '9043382',
  UCD13: '3400890433822',
  ucdQtyMultiplicator: 24,
  cipLib: "HEXALYSE CPR SUCER BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3637531',
  CIP13: '3400936375314',
  ucdLib: "HOMEOGENE 46 CPR DISP",
  UCD7: '9374133',
  UCD13: '3400893741337',
  ucdQtyMultiplicator: 60,
  cipLib: "HOMEOGENE 46 CPR DISP BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3668431',
  CIP13: '3400936684317',
  ucdLib: "IPERTEN 10MG CPR",
  UCD7: '9250537',
  UCD13: '3400892505374',
  ucdQtyMultiplicator: 56,
  cipLib: "IPERTEN 10MG CPR BT 56",
  atcCode: "C08CA11"
}, {
  CIP7: '3668402',
  CIP13: '3400936684027',
  ucdLib: "IPERTEN 20MG CPR",
  UCD7: '9258585',
  UCD13: '3400892585857',
  ucdQtyMultiplicator: 56,
  cipLib: "IPERTEN 20MG CPR BT 56",
  atcCode: "C08CA11"
}, {
  CIP7: '3382692',
  CIP13: '3400933826925',
  ucdLib: "LACTEOL 170MG GELU",
  UCD7: '9049479',
  UCD13: '3400890494793',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTEOL 170MG GELU BT 20",
  atcCode: "A07FA01"
}, {
  CIP7: '3767216',
  CIP13: '3400937672160',
  ucdLib: "LIPOFEINE 5% GEL TB190G",
  UCD7: '9296723',
  UCD13: '3400892967233',
  ucdQtyMultiplicator: 1,
  cipLib: "LIPOFEINE 5% GEL TB190G BT 1",
  atcCode: "D11AX"
}, {
  CIP7: '3632686',
  CIP13: '3400936326866',
  ucdLib: "MAGNEVIE B6 100MG/10MG CPR",
  UCD7: '9341027',
  UCD13: '3400893410271',
  ucdQtyMultiplicator: 60,
  cipLib: "MAGNEVIE B6 100MG/10MG CPR BT 60",
  atcCode: "A12CC30"
}, {
  CIP7: '3816251',
  CIP13: '3400938162516',
  ucdLib: "MANNITOL 20% MAC P.FNS1000ML 1",
  UCD7: '9304865',
  UCD13: '3400893048658',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 20% MAC P.FNS1000ML 1 BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3636661',
  CIP13: '3400936366619',
  ucdLib: "OKIMUS CPR",
  UCD7: '9307639',
  UCD13: '3400893076392',
  ucdQtyMultiplicator: 40,
  cipLib: "OKIMUS CPR BT 40",
  atcCode: "M09AA72"
}, {
  CIP7: '3743003',
  CIP13: '3400937430036',
  ucdLib: "OSELTAMIVIR PG 30MG CPR",
  UCD7: '9343807',
  UCD13: '3400893438077',
  ucdQtyMultiplicator: 5,
  cipLib: "OSELTAMIVIR PG 30MG CPR BT 5",
  atcCode: "J05AH02"
}, {
  CIP7: '3727369',
  CIP13: '3400937273695',
  ucdLib: "RAMIPRIL ALT 1,25MG CPR",
  UCD7: '9289491',
  UCD13: '3400892894911',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ALT 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3698343',
  CIP13: '3400936983434',
  ucdLib: "RINGER LAC MAC P.PS1000ML +MAT",
  UCD7: '9311894',
  UCD13: '3400893118948',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.PS1000ML +MAT BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3698320',
  CIP13: '3400936983205',
  ucdLib: "RINGER LAC MAC P.PS250ML +MAT",
  UCD7: '9311902',
  UCD13: '3400893119020',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.PS250ML +MAT BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3698337',
  CIP13: '3400936983373',
  ucdLib: "RINGER LAC MAC P.PS500ML +MAT",
  UCD7: '9311919',
  UCD13: '3400893119198',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.PS500ML +MAT BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3639932',
  CIP13: '3400936399327',
  ucdLib: "SCLEREMO INJ AMP2ML",
  UCD7: '9265355',
  UCD13: '3400892653556',
  ucdQtyMultiplicator: 5,
  cipLib: "SCLEREMO INJ AMP2ML BT 5",
  atcCode: "C05BB"
}, {
  CIP7: '3767050',
  CIP13: '3400937670500',
  ucdLib: "SMOFLIPID 200MG/ML IV F100ML",
  UCD7: '9312712',
  UCD13: '3400893127124',
  ucdQtyMultiplicator: 1,
  cipLib: "SMOFLIPID 200MG/ML IV F100ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3767067',
  CIP13: '3400937670678',
  ucdLib: "SMOFLIPID 200MG/ML IV F250ML",
  UCD7: '9308975',
  UCD13: '3400893089750',
  ucdQtyMultiplicator: 1,
  cipLib: "SMOFLIPID 200MG/ML IV F250ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3767073',
  CIP13: '3400937670739',
  ucdLib: "SMOFLIPID 200MG/ML IV F500ML",
  UCD7: '9312729',
  UCD13: '3400893127292',
  ucdQtyMultiplicator: 1,
  cipLib: "SMOFLIPID 200MG/ML IV F500ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3745781',
  CIP13: '3400937457811',
  ucdLib: "SPASMINE CPR",
  UCD7: '9086948',
  UCD13: '3400890869485',
  ucdQtyMultiplicator: 60,
  cipLib: "SPASMINE CPR BT 60",
  atcCode: "N05CM09"
}, {
  CIP7: '3637761',
  CIP13: '3400936377615',
  ucdLib: "STREPSILS MIEL-CITR. PAST",
  UCD7: '9143037',
  UCD13: '3400891430370',
  ucdQtyMultiplicator: 8,
  cipLib: "STREPSILS MIEL-CITR. PAST BT 8",
  atcCode: "R02AA20"
}, {
  CIP7: '3634018',
  CIP13: '3400936340183',
  ucdLib: "STRUCTOKABIVEN INJ POC1477ML",
  UCD7: '9261972',
  UCD13: '3400892619729',
  ucdQtyMultiplicator: 4,
  cipLib: "STRUCTOKABIVEN INJ POC1477ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3634923',
  CIP13: '3400936349230',
  ucdLib: "STRUCTOKABIVEN INJ POC1970ML",
  UCD7: '9261989',
  UCD13: '3400892619897',
  ucdQtyMultiplicator: 2,
  cipLib: "STRUCTOKABIVEN INJ POC1970ML BT 2",
  atcCode: "B05BA10"
}, {
  CIP7: '3696048',
  CIP13: '3400936960480',
  ucdLib: "STRUCTOKABIVEN INJ POC986ML",
  UCD7: '9284648',
  UCD13: '3400892846484',
  ucdQtyMultiplicator: 4,
  cipLib: "STRUCTOKABIVEN INJ POC986ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3762561',
  CIP13: '3400937625616',
  ucdLib: "ZOXAN LP 4MG CPR",
  UCD7: '9216730',
  UCD13: '3400892167305',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOXAN LP 4MG CPR BT 28",
  atcCode: "G04CA05"
}, {
  CIP7: '3762578',
  CIP13: '3400937625784',
  ucdLib: "ZOXAN LP 8MG CPR",
  UCD7: '9216747',
  UCD13: '3400892167473',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOXAN LP 8MG CPR BT 28",
  atcCode: "G04CA05"
}, {
  CIP7: '3471527',
  CIP13: '3400934715273',
  ucdLib: "ADCIRCA 20MG CPR",
  UCD7: '9348615',
  UCD13: '3400893486153',
  ucdQtyMultiplicator: 28,
  cipLib: "ADCIRCA 20MG CPR BT 28",
  atcCode: "G04BE08"
}, {
  CIP7: '3471533',
  CIP13: '3400934715334',
  ucdLib: "ADCIRCA 20MG CPR",
  UCD7: '9348615',
  UCD13: '3400893486153',
  ucdQtyMultiplicator: 56,
  cipLib: "ADCIRCA 20MG CPR BT 56",
  atcCode: "G04BE08"
}, {
  CIP7: '5621468',
  CIP13: '3400956214686',
  ucdLib: "AZOTE PROTOXYDE APM BOUT 5L",
  UCD7: '9239257',
  UCD13: '3400892392578',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE APM BOUT 5L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625532',
  CIP13: '3400956255320',
  ucdLib: "AZOTE PROTOXYDE SLF BOUT 40L",
  UCD7: '9239300',
  UCD13: '3400892393001',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE SLF BOUT 40L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625503',
  CIP13: '3400956255030',
  ucdLib: "AZOTE PROTOXYDE SLF BOUT 5L",
  UCD7: '9239317',
  UCD13: '3400892393179',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE SLF BOUT 5L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '3821453',
  CIP13: '3400938214536',
  ucdLib: "BINOCRIT 1000UI INJ SRG0,5ML",
  UCD7: '9311204',
  UCD13: '3400893112045',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 1000UI INJ SRG0,5ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3821482',
  CIP13: '3400938214826',
  ucdLib: "BINOCRIT 2000UI INJ SRG1ML",
  UCD7: '9311227',
  UCD13: '3400893112274',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 2000UI INJ SRG1ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3821507',
  CIP13: '3400938215076',
  ucdLib: "BINOCRIT 3000UI INJ SRG0,3ML",
  UCD7: '9311233',
  UCD13: '3400893112335',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 3000UI INJ SRG0,3ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3821536',
  CIP13: '3400938215366',
  ucdLib: "BINOCRIT 4000UI INJ SRG0,4ML",
  UCD7: '9311256',
  UCD13: '3400893112564',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 4000UI INJ SRG0,4ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3821559',
  CIP13: '3400938215595',
  ucdLib: "BINOCRIT 5000UI INJ SRG0,5ML",
  UCD7: '9311262',
  UCD13: '3400893112625',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 5000UI INJ SRG0,5ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3821571',
  CIP13: '3400938215717',
  ucdLib: "BINOCRIT 6000UI INJ SRG0,6ML",
  UCD7: '9311279',
  UCD13: '3400893112793',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 6000UI INJ SRG0,6ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3640964',
  CIP13: '3400936409644',
  ucdLib: "BOIRON CHARBON VEG. GELU",
  UCD7: '9263238',
  UCD13: '3400892632384',
  ucdQtyMultiplicator: 50,
  cipLib: "BOIRON CHARBON VEG. GELU BT 50",
  atcCode: "A07BA01"
}, {
  CIP7: '5623792',
  CIP13: '3400956237920',
  ucdLib: "CARBOPLATINE AGT 10MG/ML 15ML",
  UCD7: '9227544',
  UCD13: '3400892275444',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE AGT 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5623800',
  CIP13: '3400956238002',
  ucdLib: "CARBOPLATINE AGT 10MG/ML 45ML",
  UCD7: '9227550',
  UCD13: '3400892275505',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE AGT 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5623786',
  CIP13: '3400956237869',
  ucdLib: "CARBOPLATINE AGT 10MG/ML 5ML",
  UCD7: '9227567',
  UCD13: '3400892275673',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE AGT 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '3820465',
  CIP13: '3400938204650',
  ucdLib: "CLIMAXOL BUV GTT FL60ML",
  UCD7: '9308159',
  UCD13: '3400893081594',
  ucdQtyMultiplicator: 1,
  cipLib: "CLIMAXOL BUV GTT FL60ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5623208',
  CIP13: '3400956232086',
  ucdLib: "CYANOCOBALAMINE AMH CAPS",
  UCD7: '9234202',
  UCD13: '3400892342023',
  ucdQtyMultiplicator: 6,
  cipLib: "CYANOCOBALAMINE AMH CAPS BT 6",
  atcCode: "V09XX01"
}, {
  CIP7: '3770106',
  CIP13: '3400937701068',
  ucdLib: "DIFRAREL E CPR",
  UCD7: '9026780',
  UCD13: '3400890267809',
  ucdQtyMultiplicator: 60,
  cipLib: "DIFRAREL E CPR BT 60",
  atcCode: "S01X"
}, {
  CIP7: '3471591',
  CIP13: '3400934715914',
  ucdLib: "DOCETAXEL TVC 20MG INJ FL+FL",
  UCD7: '9348383',
  UCD13: '3400893483831',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL TVC 20MG INJ FL+FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '3471616',
  CIP13: '3400934716164',
  ucdLib: "DOCETAXEL TVC 80MG INJ FL+FL",
  UCD7: '9348408',
  UCD13: '3400893484081',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL TVC 80MG INJ FL+FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '3782641',
  CIP13: '3400937826419',
  ucdLib: "ELUSANES SALICAIR.200MG GELU",
  UCD7: '9301252',
  UCD13: '3400893012529',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES SALICAIR.200MG GELU BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3783505',
  CIP13: '3400937835053',
  ucdLib: "ENALAPRIL NOR 20MG CPR",
  UCD7: '9301022',
  UCD13: '3400893010228',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL NOR 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3495640',
  CIP13: '3400934956409',
  ucdLib: "ENZYMICINE BAT DENT",
  UCD7: '9301720',
  UCD13: '3400893017203',
  ucdQtyMultiplicator: 50,
  cipLib: "ENZYMICINE BAT DENT BT 50",
  atcCode: "A01A"
}, {
  CIP7: '3495657',
  CIP13: '3400934956577',
  ucdLib: "ENZYMICINE BAT DENT",
  UCD7: '9301720',
  UCD13: '3400893017203',
  ucdQtyMultiplicator: 200,
  cipLib: "ENZYMICINE BAT DENT BT 200",
  atcCode: "A01A"
}, {
  CIP7: '5699507',
  CIP13: '3400956995073',
  ucdLib: "EPIRUBICINE EBW 2MG/ML FL100ML",
  UCD7: '9293357',
  UCD13: '3400892933573',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE EBW 2MG/ML FL100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5699482',
  CIP13: '3400956994823',
  ucdLib: "EPIRUBICINE EBW 2MG/ML FL25ML",
  UCD7: '9293363',
  UCD13: '3400892933634',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE EBW 2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5699499',
  CIP13: '3400956994991',
  ucdLib: "EPIRUBICINE EBW 2MG/ML FL50ML",
  UCD7: '9293392',
  UCD13: '3400892933924',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE EBW 2MG/ML FL50ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5699476',
  CIP13: '3400956994762',
  ucdLib: "EPIRUBICINE EBW 2MG/ML FL5ML",
  UCD7: '9293386',
  UCD13: '3400892933863',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE EBW 2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '3798754',
  CIP13: '3400937987547',
  ucdLib: "HOMEODIGEO GLE TB",
  UCD7: '9319654',
  UCD13: '3400893196540',
  ucdQtyMultiplicator: 3,
  cipLib: "HOMEODIGEO GLE TB BT 3",
  atcCode: "V03AX"
}, {
  CIP7: '3827562',
  CIP13: '3400938275629',
  ucdLib: "JOUVENCE ABBE SOURY CPR",
  UCD7: '9048155',
  UCD13: '3400890481557',
  ucdQtyMultiplicator: 180,
  cipLib: "JOUVENCE ABBE SOURY CPR BT 180",
  atcCode: "C05CX"
}, {
  CIP7: '5621066',
  CIP13: '3400956210664',
  ucdLib: "KASKADIL INJ FV+FV10ML",
  UCD7: '9170442',
  UCD13: '3400891704426',
  ucdQtyMultiplicator: 1,
  cipLib: "KASKADIL INJ FV+FV10ML BT 1",
  atcCode: "B02BD01"
}, {
  CIP7: '5621072',
  CIP13: '3400956210725',
  ucdLib: "KASKADIL INJ FV+FV20ML",
  UCD7: '9170459',
  UCD13: '3400891704594',
  ucdQtyMultiplicator: 1,
  cipLib: "KASKADIL INJ FV+FV20ML BT 1",
  atcCode: "B02BD01"
}, {
  CIP7: '3646240',
  CIP13: '3400936462403',
  ucdLib: "LOBAMINE CYSTEINE GELU",
  UCD7: '9054747',
  UCD13: '3400890547475',
  ucdQtyMultiplicator: 120,
  cipLib: "LOBAMINE CYSTEINE GELU BT 120",
  atcCode: "D11AX"
}, {
  CIP7: '3774506',
  CIP13: '3400937745062',
  ucdLib: "LUMINITY INJ FL1,5ML",
  UCD7: '9304948',
  UCD13: '3400893049488',
  ucdQtyMultiplicator: 4,
  cipLib: "LUMINITY INJ FL1,5ML BT 4",
  atcCode: "V08DA04"
}, {
  CIP7: '5625153',
  CIP13: '3400956251537',
  ucdLib: "NIDREL 10MG CPR",
  UCD7: '9133659',
  UCD13: '3400891336597',
  ucdQtyMultiplicator: 50,
  cipLib: "NIDREL 10MG CPR BT 50",
  atcCode: "C08CA08"
}, {
  CIP7: '5621965',
  CIP13: '3400956219650',
  ucdLib: "NIDREL 20MG CPR",
  UCD7: '9133665',
  UCD13: '3400891336658',
  ucdQtyMultiplicator: 50,
  cipLib: "NIDREL 20MG CPR BT 50",
  atcCode: "C08CA08"
}, {
  CIP7: '3790712',
  CIP13: '3400937907125',
  ucdLib: "NISIS 160MG CPR",
  UCD7: '9236023',
  UCD13: '3400892360232',
  ucdQtyMultiplicator: 56,
  cipLib: "NISIS 160MG CPR BT 56",
  atcCode: "C09CA03"
}, {
  CIP7: '3790586',
  CIP13: '3400937905862',
  ucdLib: "NISIS 40MG CPR SECAB",
  UCD7: '9285091',
  UCD13: '3400892850917',
  ucdQtyMultiplicator: 56,
  cipLib: "NISIS 40MG CPR SECAB BT 56",
  atcCode: "C09CA03"
}, {
  CIP7: '3790652',
  CIP13: '3400937906524',
  ucdLib: "NISIS 80MG CPR",
  UCD7: '9236052',
  UCD13: '3400892360522',
  ucdQtyMultiplicator: 56,
  cipLib: "NISIS 80MG CPR BT 56",
  atcCode: "C09CA03"
}, {
  CIP7: '3790439',
  CIP13: '3400937904391',
  ucdLib: "NISISCO 160MG/12,5MG CPR",
  UCD7: '9259834',
  UCD13: '3400892598345',
  ucdQtyMultiplicator: 56,
  cipLib: "NISISCO 160MG/12,5MG CPR BT 56",
  atcCode: "C09DA03"
}, {
  CIP7: '3790505',
  CIP13: '3400937905053',
  ucdLib: "NISISCO 160MG/25MG CPR",
  UCD7: '9242992',
  UCD13: '3400892429922',
  ucdQtyMultiplicator: 56,
  cipLib: "NISISCO 160MG/25MG CPR BT 56",
  atcCode: "C09DA03"
}, {
  CIP7: '3790356',
  CIP13: '3400937903561',
  ucdLib: "NISISCO 80MG/12,5MG CPR",
  UCD7: '9198593',
  UCD13: '3400891985931',
  ucdQtyMultiplicator: 56,
  cipLib: "NISISCO 80MG/12,5MG CPR BT 56",
  atcCode: "C09DA03"
}, {
  CIP7: '5625383',
  CIP13: '3400956253838',
  ucdLib: "OXYGENE MED SOL VAPO.FIX 100L",
  UCD7: '9224534',
  UCD13: '3400892245348',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SOL VAPO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3826858',
  CIP13: '3400938268584',
  ucdLib: "PANTOPRAZOLE ALT 40MG CPR",
  UCD7: '9310989',
  UCD13: '3400893109892',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ALT 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3496757',
  CIP13: '3400934967573',
  ucdLib: "PASSIFLORINE GELU",
  UCD7: '9229589',
  UCD13: '3400892295893',
  ucdQtyMultiplicator: 40,
  cipLib: "PASSIFLORINE GELU BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '3473153',
  CIP13: '3400934731532',
  ucdLib: "PIROXICAM MKG 20MG INJ A.1ML",
  UCD7: '9205620',
  UCD13: '3400892056203',
  ucdQtyMultiplicator: 2,
  cipLib: "PIROXICAM MKG 20MG INJ A.1ML BT 2",
  atcCode: "M01AC01"
}, {
  CIP7: '3644146',
  CIP13: '3400936441460',
  ucdLib: "PLAQUENIL 200MG CPR PEL",
  UCD7: '9264077',
  UCD13: '3400892640778',
  ucdQtyMultiplicator: 30,
  cipLib: "PLAQUENIL 200MG CPR PEL BT 30",
  atcCode: "D11AX"
}, {
  CIP7: '3780317',
  CIP13: '3400937803175',
  ucdLib: "PLENESIA NERVOSITE CPR",
  UCD7: '9280604',
  UCD13: '3400892806044',
  ucdQtyMultiplicator: 60,
  cipLib: "PLENESIA NERVOSITE CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '5621592',
  CIP13: '3400956215928',
  ucdLib: "PROLEUKIN 18M UI INJ FL",
  UCD7: '9233214',
  UCD13: '3400892332147',
  ucdQtyMultiplicator: 10,
  cipLib: "PROLEUKIN 18M UI INJ FL BT 10",
  atcCode: "L03AC01"
}, {
  CIP7: '5621563',
  CIP13: '3400956215638',
  ucdLib: "PROLEUKIN 18M UI PERF FL",
  UCD7: '9233220',
  UCD13: '3400892332208',
  ucdQtyMultiplicator: 10,
  cipLib: "PROLEUKIN 18M UI PERF FL BT 10",
  atcCode: "L03AC01"
}, {
  CIP7: '3716549',
  CIP13: '3400937165495',
  ucdLib: "VASOVIST 0,25MMOL INJ FV10ML",
  UCD7: '9307786',
  UCD13: '3400893077863',
  ucdQtyMultiplicator: 1,
  cipLib: "VASOVIST 0,25MMOL INJ FV10ML BT 1",
  atcCode: "V08CA11"
}, {
  CIP7: '3887009',
  CIP13: '3400938870091',
  ucdLib: "ARNICA MONTANA TM BOIR LO125ML",
  UCD7: '9383899',
  UCD13: '3400893838990',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNICA MONTANA TM BOIR LO125ML BT 1",
  atcCode: "Z10"
}, {
  CIP7: '3886990',
  CIP13: '3400938869903',
  ucdLib: "ARNICA MONTANA TM BOIR LOC60ML",
  UCD7: '9383907',
  UCD13: '3400893839072',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNICA MONTANA TM BOIR LOC60ML BT 1",
  atcCode: "Z10"
}, {
  CIP7: '5614942',
  CIP13: '3400956149421',
  ucdLib: "BENEFIX 1000UI INJ FL+FL",
  UCD7: '9200982',
  UCD13: '3400892009827',
  ucdQtyMultiplicator: 1,
  cipLib: "BENEFIX 1000UI INJ FL+FL BT 1",
  atcCode: "B02BD09"
}, {
  CIP7: '5614913',
  CIP13: '3400956149131',
  ucdLib: "BENEFIX 250UI INJ FL+FL",
  UCD7: '9200999',
  UCD13: '3400892009995',
  ucdQtyMultiplicator: 1,
  cipLib: "BENEFIX 250UI INJ FL+FL BT 1",
  atcCode: "B02BD09"
}, {
  CIP7: '5614936',
  CIP13: '3400956149360',
  ucdLib: "BENEFIX 500UI INJ FL+FL",
  UCD7: '9201007',
  UCD13: '3400892010076',
  ucdQtyMultiplicator: 1,
  cipLib: "BENEFIX 500UI INJ FL+FL BT 1",
  atcCode: "B02BD09"
}, {
  CIP7: '3757703',
  CIP13: '3400937577038',
  ucdLib: "BICALUTAMIDE KBI 50MG CPR",
  UCD7: '9351735',
  UCD13: '3400893517352',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE KBI 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3876299',
  CIP13: '3400938762990',
  ucdLib: "BISOPROLOL ACT 10MG CPR",
  UCD7: '9256801',
  UCD13: '3400892568010',
  ucdQtyMultiplicator: 84,
  cipLib: "BISOPROLOL ACT 10MG CPR BT 84",
  atcCode: "C07AB07"
}, {
  CIP7: '5616852',
  CIP13: '3400956168521',
  ucdLib: "CALCIUM CH.10% CPF INJ 10ML",
  UCD7: '9216262',
  UCD13: '3400892162621',
  ucdQtyMultiplicator: 100,
  cipLib: "CALCIUM CH.10% CPF INJ 10ML BT 100",
  atcCode: "A12AA07"
}, {
  CIP7: '3738568',
  CIP13: '3400937385688',
  ucdLib: "CAPTOPRIL/HYD.PKI 50/25MG C.",
  UCD7: '9267408',
  UCD13: '3400892674087',
  ucdQtyMultiplicator: 84,
  cipLib: "CAPTOPRIL/HYD.PKI 50/25MG C. BT 84",
  atcCode: "C09BA01"
}, {
  CIP7: '5612676',
  CIP13: '3400956126767',
  ucdLib: "CHLORHEXIDINE GIL ALC COL125ML",
  UCD7: '9207671',
  UCD13: '3400892076713',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIL ALC COL125ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '5612682',
  CIP13: '3400956126828',
  ucdLib: "CHLORHEXIDINE GIL ALC COL250ML",
  UCD7: '9215794',
  UCD13: '3400892157948',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIL ALC COL250ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '5612699',
  CIP13: '3400956126996',
  ucdLib: "CHLORHEXIDINE GIL ALC COL500ML",
  UCD7: '9274325',
  UCD13: '3400892743257',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIL ALC COL500ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3756081',
  CIP13: '3400937560818',
  ucdLib: "DOLOSOFT 450MG CPR",
  UCD7: '9383586',
  UCD13: '3400893835869',
  ucdQtyMultiplicator: 90,
  cipLib: "DOLOSOFT 450MG CPR BT 90",
  atcCode: "V03AX"
}, {
  CIP7: '3756106',
  CIP13: '3400937561068',
  ucdLib: "DRILL ENROUEMENT 15MG S/S",
  UCD7: '9318442',
  UCD13: '3400893184424',
  ucdQtyMultiplicator: 24,
  cipLib: "DRILL ENROUEMENT 15MG S/S BT 24",
  atcCode: "V03AX"
}, {
  CIP7: '5611228',
  CIP13: '3400956112289',
  ucdLib: "DROLEPTAN 2,5MG INJ AMP1ML",
  UCD7: '9211158',
  UCD13: '3400892111582',
  ucdQtyMultiplicator: 10,
  cipLib: "DROLEPTAN 2,5MG INJ AMP1ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '5500389',
  CIP13: '3400955003892',
  ucdLib: "DROPERIDOL PAN 0,5MG A.2,5ML",
  UCD7: '9409854',
  UCD13: '3400894098546',
  ucdQtyMultiplicator: 10,
  cipLib: "DROPERIDOL PAN 0,5MG A.2,5ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '3441609',
  CIP13: '3400934416095',
  ucdLib: "EUPHRASIA 3DH WLD COLLY DOS",
  UCD7: '9390362',
  UCD13: '3400893903629',
  ucdQtyMultiplicator: 10,
  cipLib: "EUPHRASIA 3DH WLD COLLY DOS BT 10",
  atcCode: "Z03"
}, {
  CIP7: '3164179',
  CIP13: '3400931641797',
  ucdLib: "GENESERINE 3 BUV GTT FL30ML",
  UCD7: '9038004',
  UCD13: '3400890380041',
  ucdQtyMultiplicator: 1,
  cipLib: "GENESERINE 3 BUV GTT FL30ML BT 1",
  atcCode: "A03FA"
}, {
  CIP7: '3758074',
  CIP13: '3400937580748',
  ucdLib: "GLUCOSE 2,5% MAC P.FS250ML",
  UCD7: '9298053',
  UCD13: '3400892980539',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5% MAC P.FS250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3446328',
  CIP13: '3400934463280',
  ucdLib: "GLUCOSE 30% AGT INJ DAT500ML",
  UCD7: '9207300',
  UCD13: '3400892073002',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 30% AGT INJ DAT500ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '5611317',
  CIP13: '3400956113170',
  ucdLib: "HEMOLEVEN 1000UI INJ FV+FV",
  UCD7: '9170175',
  UCD13: '3400891701753',
  ucdQtyMultiplicator: 1,
  cipLib: "HEMOLEVEN 1000UI INJ FV+FV BT 1",
  atcCode: "B02BD"
}, {
  CIP7: '3165316',
  CIP13: '3400931653165',
  ucdLib: "HEPARINE SLD 666U/ML FL100ML",
  UCD7: '9042773',
  UCD13: '3400890427739',
  ucdQtyMultiplicator: 1,
  cipLib: "HEPARINE SLD 666U/ML FL100ML BT 1",
  atcCode: "B01AB01"
}, {
  CIP7: '3805425',
  CIP13: '3400938054255',
  ucdLib: "HOMEOREGUL GLE TB",
  UCD7: '9313114',
  UCD13: '3400893131145',
  ucdQtyMultiplicator: 3,
  cipLib: "HOMEOREGUL GLE TB BT 3",
  atcCode: "V03AX"
}, {
  CIP7: '3880757',
  CIP13: '3400938807578',
  ucdLib: "IMIPEN/CIL.RBX 500/500 100ML",
  UCD7: '9324750',
  UCD13: '3400893247501',
  ucdQtyMultiplicator: 1,
  cipLib: "IMIPEN/CIL.RBX 500/500 100ML BT 1",
  atcCode: "J01DH51"
}, {
  CIP7: '3442359',
  CIP13: '3400934423598',
  ucdLib: "KINTUXIL 0,25% SIR FL150ML",
  UCD7: '9214056',
  UCD13: '3400892140568',
  ucdQtyMultiplicator: 1,
  cipLib: "KINTUXIL 0,25% SIR FL150ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3924012',
  CIP13: '3400939240121',
  ucdLib: "METEOXANE GELU",
  UCD7: '9058478',
  UCD13: '3400890584784',
  ucdQtyMultiplicator: 30,
  cipLib: "METEOXANE GELU BT 30",
  atcCode: "A03AX12"
}, {
  CIP7: '3867484',
  CIP13: '3400938674842',
  ucdLib: "MG/B6 MYL 48MG/5MG CPR",
  UCD7: '9326737',
  UCD13: '3400893267370',
  ucdQtyMultiplicator: 50,
  cipLib: "MG/B6 MYL 48MG/5MG CPR BT 50",
  atcCode: "A12CC30"
}, {
  CIP7: '3754662',
  CIP13: '3400937546621',
  ucdLib: "OLIGOSOL LITHIUM BUV A.2ML",
  UCD7: '9064875',
  UCD13: '3400890648752',
  ucdQtyMultiplicator: 28,
  cipLib: "OLIGOSOL LITHIUM BUV A.2ML BT 28",
  atcCode: "V03AX"
}, {
  CIP7: '3754685',
  CIP13: '3400937546850',
  ucdLib: "OLIGOSOL MAGNESIUM BUV A.2ML",
  UCD7: '9064881',
  UCD13: '3400890648813',
  ucdQtyMultiplicator: 28,
  cipLib: "OLIGOSOL MAGNESIUM BUV A.2ML BT 28",
  atcCode: "V03AX"
}, {
  CIP7: '3754739',
  CIP13: '3400937547390',
  ucdLib: "OLIGOSOL MN-CO BUV A.2ML",
  UCD7: '9182273',
  UCD13: '3400891822731',
  ucdQtyMultiplicator: 28,
  cipLib: "OLIGOSOL MN-CO BUV A.2ML BT 28",
  atcCode: "V03AX"
}, {
  CIP7: '3754780',
  CIP13: '3400937547802',
  ucdLib: "OLIGOSOL ZN-NI-CO BUV A.2ML",
  UCD7: '9065001',
  UCD13: '3400890650014',
  ucdQtyMultiplicator: 28,
  cipLib: "OLIGOSOL ZN-NI-CO BUV A.2ML BT 28",
  atcCode: "V03AX"
}, {
  CIP7: '5614770',
  CIP13: '3400956147700',
  ucdLib: "OMNIPAQUE 180 INJ FP15ML",
  UCD7: '9222363',
  UCD13: '3400892223636',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 180 INJ FP15ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5614712',
  CIP13: '3400956147120',
  ucdLib: "OMNIPAQUE 240 INJ FP15ML",
  UCD7: '9222392',
  UCD13: '3400892223926',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 240 INJ FP15ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5614735',
  CIP13: '3400956147359',
  ucdLib: "OMNIPAQUE 300 INJ FP10ML",
  UCD7: '9222423',
  UCD13: '3400892224237',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 300 INJ FP10ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5614758',
  CIP13: '3400956147588',
  ucdLib: "OMNIPAQUE 350 INJ FP20ML",
  UCD7: '9222481',
  UCD13: '3400892224817',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 350 INJ FP20ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '3757755',
  CIP13: '3400937577557',
  ucdLib: "OXYGENE MED ALS BOUT 13,5L",
  UCD7: '9293481',
  UCD13: '3400892934815',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 13,5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3757749',
  CIP13: '3400937577496',
  ucdLib: "OXYGENE MED ALS BOUT 4L",
  UCD7: '9293498',
  UCD13: '3400892934983',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 4L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3757732',
  CIP13: '3400937577328',
  ucdLib: "OXYGENE MED ALS BOUT ALU3L+MAN",
  UCD7: '9293475',
  UCD13: '3400892934754',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT ALU3L+MAN BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3865485',
  CIP13: '3400938654851',
  ucdLib: "PANDEMRIX INJ FL+FL",
  UCD7: '9341286',
  UCD13: '3400893412862',
  ucdQtyMultiplicator: 50,
  cipLib: "PANDEMRIX INJ FL+FL BT 50",
  atcCode: "J07BB02"
}, {
  CIP7: '3446400',
  CIP13: '3400934464003',
  ucdLib: "PAROEX 0,12% BAIN BCHE FL50ML",
  UCD7: '9242779',
  UCD13: '3400892427799',
  ucdQtyMultiplicator: 1,
  cipLib: "PAROEX 0,12% BAIN BCHE FL50ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '5619891',
  CIP13: '3400956198917',
  ucdLib: "POTASSIUM 10% REN A.20ML",
  UCD7: '9208535',
  UCD13: '3400892085357',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 10% REN A.20ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '3804130',
  CIP13: '3400938041309',
  ucdLib: "PRAVASTATINE ALT 40MG CPR",
  UCD7: '9292949',
  UCD13: '3400892929491',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ALT 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3169283',
  CIP13: '3400931692836',
  ucdLib: "SEDACOLLYRE COLLY FL10ML",
  UCD7: '9083016',
  UCD13: '3400890830164',
  ucdQtyMultiplicator: 1,
  cipLib: "SEDACOLLYRE COLLY FL10ML BT 1",
  atcCode: "S01GA55"
}, {
  CIP7: '3928151',
  CIP13: '3400939281513',
  ucdLib: "SMOFKABIVEN E PERF PTB2463ML",
  UCD7: '9331299',
  UCD13: '3400893312995',
  ucdQtyMultiplicator: 3,
  cipLib: "SMOFKABIVEN E PERF PTB2463ML BT 3",
  atcCode: "B05BA10"
}, {
  CIP7: '3802929',
  CIP13: '3400938029291',
  ucdLib: "TERBINAFINE ALT 250MG CPR",
  UCD7: '9304687',
  UCD13: '3400893046876',
  ucdQtyMultiplicator: 14,
  cipLib: "TERBINAFINE ALT 250MG CPR BT 14",
  atcCode: "D01BA02"
}, {
  CIP7: '5504768',
  CIP13: '3400955047681',
  ucdLib: "TROBICINE 2G IM FL+A.3,2ML",
  UCD7: '9095232',
  UCD13: '3400890952323',
  ucdQtyMultiplicator: 10,
  cipLib: "TROBICINE 2G IM FL+A.3,2ML BT 10",
  atcCode: "J01XX04"
}, {
  CIP7: '5612417',
  CIP13: '3400956124176',
  ucdLib: "VIT K1 ROCHE 10MG B/I A.1ML+P",
  UCD7: '9209948',
  UCD13: '3400892099484',
  ucdQtyMultiplicator: 6,
  cipLib: "VIT K1 ROCHE 10MG B/I A.1ML+P BT 6",
  atcCode: "B02BA01"
}, {
  CIP7: '3886429',
  CIP13: '3400938864298',
  ucdLib: "WELEDA CALENDULA OFF TM FL60ML",
  UCD7: '9410900',
  UCD13: '3400894109006',
  ucdQtyMultiplicator: 1,
  cipLib: "WELEDA CALENDULA OFF TM FL60ML BT 1",
  atcCode: "Z10"
}, {
  CIP7: '2214490',
  CIP13: '3400922144900',
  ucdLib: "AESCULUS COMP 103 GTT FV30ML",
  UCD7: '9388425',
  UCD13: '3400893884256',
  ucdQtyMultiplicator: 1,
  cipLib: "AESCULUS COMP 103 GTT FV30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3979496',
  CIP13: '3400939794969',
  ucdLib: "ANGIPAX CPR ORODISP",
  UCD7: '9339349',
  UCD13: '3400893393499',
  ucdQtyMultiplicator: 40,
  cipLib: "ANGIPAX CPR ORODISP BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '3952304',
  CIP13: '3400939523040',
  ucdLib: "ARGENTUM COMPLEXE N98 CPR",
  UCD7: '9348532',
  UCD13: '3400893485323',
  ucdQtyMultiplicator: 60,
  cipLib: "ARGENTUM COMPLEXE N98 CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3956472',
  CIP13: '3400939564722',
  ucdLib: "ARNICA MONTANA TM WLD LOC 60ML",
  UCD7: '9410857',
  UCD13: '3400894108573',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNICA MONTANA TM WLD LOC 60ML BT 1",
  atcCode: "Z10"
}, {
  CIP7: '3956041',
  CIP13: '3400939560410',
  ucdLib: "AVENA SATIVA TM WLD BUV FL60ML",
  UCD7: '9410863',
  UCD13: '3400894108634',
  ucdQtyMultiplicator: 1,
  cipLib: "AVENA SATIVA TM WLD BUV FL60ML BT 1",
  atcCode: "Z10"
}, {
  CIP7: '3954214',
  CIP13: '3400939542140',
  ucdLib: "BERBERIS CPLEX N83 GTT FL30ML",
  UCD7: '9346579',
  UCD13: '3400893465790',
  ucdQtyMultiplicator: 1,
  cipLib: "BERBERIS CPLEX N83 GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3916722',
  CIP13: '3400939167220',
  ucdLib: "BICIRKAN CPR",
  UCD7: '9307734',
  UCD13: '3400893077344',
  ucdQtyMultiplicator: 60,
  cipLib: "BICIRKAN CPR BT 60",
  atcCode: "C05CX"
}, {
  CIP7: '5639296',
  CIP13: '3400956392964',
  ucdLib: "BUCANEST ADR.1/200M CART.",
  UCD7: '9161704',
  UCD13: '3400891617047',
  ucdQtyMultiplicator: 10,
  cipLib: "BUCANEST ADR.1/200M CART. BT 10",
  atcCode: "N01BB58"
}, {
  CIP7: '5641028',
  CIP13: '3400956410286',
  ucdLib: "CARBAGLU 200MG CPR DISP",
  UCD7: '9234053',
  UCD13: '3400892340531',
  ucdQtyMultiplicator: 15,
  cipLib: "CARBAGLU 200MG CPR DISP BT 15",
  atcCode: "A16AA05"
}, {
  CIP7: '5641353',
  CIP13: '3400956413539',
  ucdLib: "CARBOPLATINE SDZ 10MG/ML 15ML",
  UCD7: '9256818',
  UCD13: '3400892568188',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE SDZ 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5641376',
  CIP13: '3400956413768',
  ucdLib: "CARBOPLATINE SDZ 10MG/ML 45ML",
  UCD7: '9256824',
  UCD13: '3400892568249',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE SDZ 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5641347',
  CIP13: '3400956413478',
  ucdLib: "CARBOPLATINE SDZ 10MG/ML 5ML",
  UCD7: '9256830',
  UCD13: '3400892568300',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE SDZ 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '3847843',
  CIP13: '3400938478433',
  ucdLib: "CARYOLYSINE 10MG INJ FL+AMP",
  UCD7: '9321444',
  UCD13: '3400893214442',
  ucdQtyMultiplicator: 1,
  cipLib: "CARYOLYSINE 10MG INJ FL+AMP BT 1",
  atcCode: "L01AA05"
}, {
  CIP7: '3899797',
  CIP13: '3400938997972',
  ucdLib: "CIPROFLOX.KBI200MG/100ML P.S",
  UCD7: '9325005',
  UCD13: '3400893250051',
  ucdQtyMultiplicator: 1,
  cipLib: "CIPROFLOX.KBI200MG/100ML P.S BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '3956012',
  CIP13: '3400939560120',
  ucdLib: "COCCULINE CPR ORODISP",
  UCD7: '9345485',
  UCD13: '3400893454855',
  ucdQtyMultiplicator: 40,
  cipLib: "COCCULINE CPR ORODISP BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '3900342',
  CIP13: '3400939003429',
  ucdLib: "DIFRAREL 100MG CPR",
  UCD7: '9026805',
  UCD13: '3400890268059',
  ucdQtyMultiplicator: 60,
  cipLib: "DIFRAREL 100MG CPR BT 60",
  atcCode: "C05CX"
}, {
  CIP7: '5642720',
  CIP13: '3400956427208',
  ucdLib: "DIVARIUS 20MG CPR",
  UCD7: '9246027',
  UCD13: '3400892460277',
  ucdQtyMultiplicator: 56,
  cipLib: "DIVARIUS 20MG CPR BT 56",
  atcCode: "N06AB05"
}, {
  CIP7: '5645032',
  CIP13: '3400956450329',
  ucdLib: "DOPAMINE REN 10MG/ML AMP5ML",
  UCD7: '9246263',
  UCD13: '3400892462639',
  ucdQtyMultiplicator: 100,
  cipLib: "DOPAMINE REN 10MG/ML AMP5ML BT 100",
  atcCode: "C01CA04"
}, {
  CIP7: '3844282',
  CIP13: '3400938442823',
  ucdLib: "DOSISEPTINE COL 0,05% D.45ML",
  UCD7: '9319418',
  UCD13: '3400893194188',
  ucdQtyMultiplicator: 30,
  cipLib: "DOSISEPTINE COL 0,05% D.45ML BT 30",
  atcCode: "D08AC02"
}, {
  CIP7: '3844307',
  CIP13: '3400938443073',
  ucdLib: "DOSISEPTINE COL 0,05% D100ML",
  UCD7: '9319401',
  UCD13: '3400893194010',
  ucdQtyMultiplicator: 30,
  cipLib: "DOSISEPTINE COL 0,05% D100ML BT 30",
  atcCode: "D08AC02"
}, {
  CIP7: '5640537',
  CIP13: '3400956405374',
  ucdLib: "FLUOROURACILE MDC 50MG FL100ML",
  UCD7: '9247216',
  UCD13: '3400892472164',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE MDC 50MG FL100ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5640460',
  CIP13: '3400956404605',
  ucdLib: "FLUOROURACILE MDC 50MG FL10ML",
  UCD7: '9247191',
  UCD13: '3400892471914',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE MDC 50MG FL10ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5640508',
  CIP13: '3400956405084',
  ucdLib: "FLUOROURACILE MDC 50MG FL20ML",
  UCD7: '9247222',
  UCD13: '3400892472225',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE MDC 50MG FL20ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5640431',
  CIP13: '3400956404315',
  ucdLib: "FLUOROURACILE MDC 50MG FL5ML",
  UCD7: '9247239',
  UCD13: '3400892472393',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE MDC 50MG FL5ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '3909739',
  CIP13: '3400939097398',
  ucdLib: "GLUCOSE 5% LAV INJ FP100ML",
  UCD7: '9326571',
  UCD13: '3400893265710',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ FP100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3959766',
  CIP13: '3400939597669',
  ucdLib: "HOMEOCYST GLE TB",
  UCD7: '9345692',
  UCD13: '3400893456927',
  ucdQtyMultiplicator: 2,
  cipLib: "HOMEOCYST GLE TB BT 2",
  atcCode: "V03AX"
}, {
  CIP7: '3841651',
  CIP13: '3400938416510',
  ucdLib: "HOMEODRAIN GLE TB",
  UCD7: '9321585',
  UCD13: '3400893215852',
  ucdQtyMultiplicator: 3,
  cipLib: "HOMEODRAIN GLE TB BT 3",
  atcCode: "V03AX"
}, {
  CIP7: '3841639',
  CIP13: '3400938416398',
  ucdLib: "HOMEONORMYL GLE TB",
  UCD7: '9321579',
  UCD13: '3400893215791',
  ucdQtyMultiplicator: 3,
  cipLib: "HOMEONORMYL GLE TB BT 3",
  atcCode: "V03AX"
}, {
  CIP7: '3959588',
  CIP13: '3400939595887',
  ucdLib: "HOMEORUB GLE TB",
  UCD7: '9345479',
  UCD13: '3400893454794',
  ucdQtyMultiplicator: 1,
  cipLib: "HOMEORUB GLE TB BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3965896',
  CIP13: '3400939658964',
  ucdLib: "HOMEORYL GLE TB",
  UCD7: '9345700',
  UCD13: '3400893457009',
  ucdQtyMultiplicator: 2,
  cipLib: "HOMEORYL GLE TB BT 2",
  atcCode: "V03AX"
}, {
  CIP7: '5644251',
  CIP13: '3400956442515',
  ucdLib: "KINOX 225 M/MOL BOUT ACIER 20L",
  UCD7: '9184846',
  UCD13: '3400891848465',
  ucdQtyMultiplicator: 1,
  cipLib: "KINOX 225 M/MOL BOUT ACIER 20L BT 1",
  atcCode: "R07AX"
}, {
  CIP7: '5644245',
  CIP13: '3400956442454',
  ucdLib: "KINOX 225 M/MOL BOUT ACIER 5L",
  UCD7: '9236649',
  UCD13: '3400892366494',
  ucdQtyMultiplicator: 1,
  cipLib: "KINOX 225 M/MOL BOUT ACIER 5L BT 1",
  atcCode: "R07AX"
}, {
  CIP7: '5644274',
  CIP13: '3400956442744',
  ucdLib: "KINOX 450 M/MOL BOUT ACIER 20L",
  UCD7: '9184852',
  UCD13: '3400891848526',
  ucdQtyMultiplicator: 1,
  cipLib: "KINOX 450 M/MOL BOUT ACIER 20L BT 1",
  atcCode: "R07AX"
}, {
  CIP7: '5644268',
  CIP13: '3400956442683',
  ucdLib: "KINOX 450 M/MOL BOUT ACIER 5L",
  UCD7: '9236744',
  UCD13: '3400892367446',
  ucdQtyMultiplicator: 1,
  cipLib: "KINOX 450 M/MOL BOUT ACIER 5L BT 1",
  atcCode: "R07AX"
}, {
  CIP7: '3953568',
  CIP13: '3400939535685',
  ucdLib: "LIDENE 15MG CPR",
  UCD7: '9219421',
  UCD13: '3400892194219',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDENE 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '5642393',
  CIP13: '3400956423934',
  ucdLib: "METHOTREX.MYL 25MG/ML 200ML",
  UCD7: '9233504',
  UCD13: '3400892335049',
  ucdQtyMultiplicator: 1,
  cipLib: "METHOTREX.MYL 25MG/ML 200ML BT 1",
  atcCode: "L01BA01"
}, {
  CIP7: '5644506',
  CIP13: '3400956445066',
  ucdLib: "MIBG (123I) 74MBQ/ML INJ FL",
  UCD7: '9246429',
  UCD13: '3400892464299',
  ucdQtyMultiplicator: 1,
  cipLib: "MIBG (123I) 74MBQ/ML INJ FL BT 1",
  atcCode: "V09IX01"
}, {
  CIP7: '5648728',
  CIP13: '3400956487288',
  ucdLib: "MIDAZOLAM AGT 1MG/ML AMP5ML",
  UCD7: '9249497',
  UCD13: '3400892494975',
  ucdQtyMultiplicator: 50,
  cipLib: "MIDAZOLAM AGT 1MG/ML AMP5ML BT 50",
  atcCode: "N05CD08"
}, {
  CIP7: '5648792',
  CIP13: '3400956487929',
  ucdLib: "MIDAZOLAM AGT 5MG/ML AMP10ML",
  UCD7: '9249511',
  UCD13: '3400892495118',
  ucdQtyMultiplicator: 50,
  cipLib: "MIDAZOLAM AGT 5MG/ML AMP10ML BT 50",
  atcCode: "N05CD08"
}, {
  CIP7: '5648757',
  CIP13: '3400956487578',
  ucdLib: "MIDAZOLAM AGT 5MG/ML AMP3ML",
  UCD7: '9249528',
  UCD13: '3400892495286',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM AGT 5MG/ML AMP3ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5635708',
  CIP13: '3400956357086',
  ucdLib: "MORPHINE 50MG AP-HP S/C 5ML",
  UCD7: '9237407',
  UCD13: '3400892374079',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 50MG AP-HP S/C 5ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '5644481',
  CIP13: '3400956444816',
  ucdLib: "MYOVIEW 230MCG TROUS FL",
  UCD7: '9169290',
  UCD13: '3400891692907',
  ucdQtyMultiplicator: 2,
  cipLib: "MYOVIEW 230MCG TROUS FL BT 2",
  atcCode: "V09GA02"
}, {
  CIP7: '5632822',
  CIP13: '3400956328222',
  ucdLib: "NEOSPECT 47MCG TROUS FL",
  UCD7: '9234610',
  UCD13: '3400892346106',
  ucdQtyMultiplicator: 1,
  cipLib: "NEOSPECT 47MCG TROUS FL BT 1",
  atcCode: "V09IA05"
}, {
  CIP7: '5632839',
  CIP13: '3400956328390',
  ucdLib: "NEOSPECT 47MCG TROUS FL",
  UCD7: '9234610',
  UCD13: '3400892346106',
  ucdQtyMultiplicator: 5,
  cipLib: "NEOSPECT 47MCG TROUS FL BT 5",
  atcCode: "V09IA05"
}, {
  CIP7: '3841349',
  CIP13: '3400938413496',
  ucdLib: "OXYGENE MED BTG 5L +MAN.V2D15",
  UCD7: '9330940',
  UCD13: '3400893309407',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED BTG 5L +MAN.V2D15 BT 1",
  atcCode: ""
}, {
  CIP7: '5645173',
  CIP13: '3400956451739',
  ucdLib: "OXYGENE MED LDH VAPO.MOB 230L",
  UCD7: '9259751',
  UCD13: '3400892597515',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH VAPO.MOB 230L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5645204',
  CIP13: '3400956452040',
  ucdLib: "OXYGENE MED LDH VAPO.MOB 660L",
  UCD7: '9259768',
  UCD13: '3400892597683',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH VAPO.MOB 660L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3505999',
  CIP13: '3400935059994',
  ucdLib: "OXYGENE MED SLF BOUT ALU2L+MAN",
  UCD7: '9239375',
  UCD13: '3400892393759',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT ALU2L+MAN BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5641488',
  CIP13: '3400956414888',
  ucdLib: "PIPERACILLINE GGA 1G INJ FL",
  UCD7: '9255753',
  UCD13: '3400892557533',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACILLINE GGA 1G INJ FL BT 10",
  atcCode: "J01CA12"
}, {
  CIP7: '5641525',
  CIP13: '3400956415250',
  ucdLib: "PIPERACILLINE GGA 2G INJ FL",
  UCD7: '9256161',
  UCD13: '3400892561615',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACILLINE GGA 2G INJ FL BT 10",
  atcCode: "J01CA12"
}, {
  CIP7: '5641560',
  CIP13: '3400956415601',
  ucdLib: "PIPERACILLINE GGA 4G INJ FL",
  UCD7: '9256178',
  UCD13: '3400892561783',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACILLINE GGA 4G INJ FL BT 10",
  atcCode: "J01CA12"
}, {
  CIP7: '3508673',
  CIP13: '3400935086730',
  ucdLib: "PROMINCIL GEL FL140G",
  UCD7: '9217830',
  UCD13: '3400892178301',
  ucdQtyMultiplicator: 1,
  cipLib: "PROMINCIL GEL FL140G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5631142',
  CIP13: '3400956311422',
  ucdLib: "PROZAC 20MG CPR DISP",
  UCD7: '9221978',
  UCD13: '3400892219783',
  ucdQtyMultiplicator: 70,
  cipLib: "PROZAC 20MG CPR DISP BT 70",
  atcCode: "N06AB03"
}, {
  CIP7: '3917213',
  CIP13: '3400939172132',
  ucdLib: "RHINALLERGY CPR SUCER",
  UCD7: '9228621',
  UCD13: '3400892286211',
  ucdQtyMultiplicator: 40,
  cipLib: "RHINALLERGY CPR SUCER BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '3930188',
  CIP13: '3400939301884',
  ucdLib: "ROPINIROLE ARG 5MG CPR",
  UCD7: '9337675',
  UCD13: '3400893376751',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE ARG 5MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3907700',
  CIP13: '3400939077000',
  ucdLib: "SODIUM 0,9% LAV INJ FP100ML",
  UCD7: '9323503',
  UCD13: '3400893235034',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ FP100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3507113',
  CIP13: '3400935071132',
  ucdLib: "SODIUM 0,9% PFX INJ P.100ML",
  UCD7: '9211595',
  UCD13: '3400892115955',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% PFX INJ P.100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3507107',
  CIP13: '3400935071071',
  ucdLib: "SODIUM 0,9% PFX INJ P.50ML",
  UCD7: '9211626',
  UCD13: '3400892116266',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% PFX INJ P.50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3930780',
  CIP13: '3400939307800',
  ucdLib: "STRESSDORON BUV GTT FL30ML",
  UCD7: '9355006',
  UCD13: '3400893550069',
  ucdQtyMultiplicator: 1,
  cipLib: "STRESSDORON BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3506556',
  CIP13: '3400935065568',
  ucdLib: "STRUCTOLIPIDE 20% PERF 500ML",
  UCD7: '9215848',
  UCD13: '3400892158488',
  ucdQtyMultiplicator: 1,
  cipLib: "STRUCTOLIPIDE 20% PERF 500ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3847234',
  CIP13: '3400938472349',
  ucdLib: "TRANDOLAPRIL MYL 0,5MG GELU",
  UCD7: '9315975',
  UCD13: '3400893159750',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL MYL 0,5MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3960433',
  CIP13: '3400939604336',
  ucdLib: "VALACICLOVIR BCR 500MG CPR",
  UCD7: '9341636',
  UCD13: '3400893416365',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR BCR 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3960462',
  CIP13: '3400939604626',
  ucdLib: "VALACICLOVIR BCR 500MG CPR",
  UCD7: '9341636',
  UCD13: '3400893416365',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR BCR 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3960491',
  CIP13: '3400939604916',
  ucdLib: "VALACICLOVIR BCR 500MG CPR",
  UCD7: '9341636',
  UCD13: '3400893416365',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR BCR 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3506473',
  CIP13: '3400935064738',
  ucdLib: "VENTOLINE 0,5% INHAL GTT10ML",
  UCD7: '9210845',
  UCD13: '3400892108452',
  ucdQtyMultiplicator: 1,
  cipLib: "VENTOLINE 0,5% INHAL GTT10ML BT 1",
  atcCode: "R03CC02"
}, {
  CIP7: '5630042',
  CIP13: '3400956300426',
  ucdLib: "VENTOLINE 1,25MG INH. UNIDOS",
  UCD7: '9232060',
  UCD13: '3400892320601',
  ucdQtyMultiplicator: 20,
  cipLib: "VENTOLINE 1,25MG INH. UNIDOS BT 20",
  atcCode: "R03AC02"
}, {
  CIP7: '5647597',
  CIP13: '3400956475971',
  ucdLib: "VIT B6 AGT 250MG INJ A.B5ML",
  UCD7: '9253375',
  UCD13: '3400892533759',
  ucdQtyMultiplicator: 10,
  cipLib: "VIT B6 AGT 250MG INJ A.B5ML BT 10",
  atcCode: "A11HA02"
}, {
  CIP7: '5649159',
  CIP13: '3400956491599',
  ucdLib: "YTRACIS SOL FL2ML",
  UCD7: '9251235',
  UCD13: '3400892512358',
  ucdQtyMultiplicator: 1,
  cipLib: "YTRACIS SOL FL2ML BT 1",
  atcCode: "V09XX"
}, {
  CIP7: '2191814',
  CIP13: '3400921918144',
  ucdLib: "ARNICALME CPR DISP",
  UCD7: '9382948',
  UCD13: '3400893829486',
  ucdQtyMultiplicator: 40,
  cipLib: "ARNICALME CPR DISP BT 40",
  atcCode: "Z05"
}, {
  CIP7: '3986786',
  CIP13: '3400939867861',
  ucdLib: "BORIPHARM N41 GRLS TB7G",
  UCD7: '9198676',
  UCD13: '3400891986761',
  ucdQtyMultiplicator: 1,
  cipLib: "BORIPHARM N41 GRLS TB7G BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '3947289',
  CIP13: '3400939472898',
  ucdLib: "CAMILIA BUV UNIDOS1ML",
  UCD7: '9249698',
  UCD13: '3400892496986',
  ucdQtyMultiplicator: 30,
  cipLib: "CAMILIA BUV UNIDOS1ML BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '3946864',
  CIP13: '3400939468648',
  ucdLib: "CELVAPAN INJ FL5ML",
  UCD7: '9343718',
  UCD13: '3400893437186',
  ucdQtyMultiplicator: 20,
  cipLib: "CELVAPAN INJ FL5ML BT 20",
  atcCode: "J07BB01"
}, {
  CIP7: '2192400',
  CIP13: '3400921924008',
  ucdLib: "CHAMOMILLA VULG BOIR SUP",
  UCD7: '9399788',
  UCD13: '3400893997888',
  ucdQtyMultiplicator: 12,
  cipLib: "CHAMOMILLA VULG BOIR SUP BT 12",
  atcCode: "V03AX"
}, {
  CIP7: '4155840',
  CIP13: '3400941558405',
  ucdLib: "CICADERMA POM DERM TB ALU30G",
  UCD7: '9373553',
  UCD13: '3400893735534',
  ucdQtyMultiplicator: 1,
  cipLib: "CICADERMA POM DERM TB ALU30G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '4900108',
  CIP13: '3400949001088',
  ucdLib: "DIAMICRON 30MG CLM AIPPLA IT",
  UCD7: '9305913',
  UCD13: '3400893059135',
  ucdQtyMultiplicator: 60,
  cipLib: "DIAMICRON 30MG CLM AIPPLA IT BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '2668989',
  CIP13: '3400926689896',
  ucdLib: "DOXYLAMINE BGC 15MG CPR",
  UCD7: '9394526',
  UCD13: '3400893945261',
  ucdQtyMultiplicator: 10,
  cipLib: "DOXYLAMINE BGC 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '2668995',
  CIP13: '3400926689957',
  ucdLib: "DOXYLAMINE MYC 15MG CPR",
  UCD7: '9397051',
  UCD13: '3400893970515',
  ucdQtyMultiplicator: 10,
  cipLib: "DOXYLAMINE MYC 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '2668972',
  CIP13: '3400926689728',
  ucdLib: "DOXYLAMINE SDC 15MG CPR",
  UCD7: '9388750',
  UCD13: '3400893887509',
  ucdQtyMultiplicator: 10,
  cipLib: "DOXYLAMINE SDC 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '2663070',
  CIP13: '3400926630706',
  ucdLib: "DOXYLAMINE TCO 15MG CPR",
  UCD7: '9393308',
  UCD13: '3400893933084',
  ucdQtyMultiplicator: 10,
  cipLib: "DOXYLAMINE TCO 15MG CPR BT 10",
  atcCode: "R06AA09"
}, {
  CIP7: '2757049',
  CIP13: '3400927570490',
  ucdLib: "DROPERIDOL PAN 2,5MG INJ 1ML",
  UCD7: '9399423',
  UCD13: '3400893994238',
  ucdQtyMultiplicator: 10,
  cipLib: "DROPERIDOL PAN 2,5MG INJ 1ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '2661711',
  CIP13: '3400926617110',
  ucdLib: "FAMENPAX CPR ORODISP",
  UCD7: '9407335',
  UCD13: '3400894073352',
  ucdQtyMultiplicator: 40,
  cipLib: "FAMENPAX CPR ORODISP BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '4190894',
  CIP13: '3400941908941',
  ucdLib: "FUCUS CPLEXE N111 CPR",
  UCD7: '9386981',
  UCD13: '3400893869819',
  ucdQtyMultiplicator: 60,
  cipLib: "FUCUS CPLEXE N111 CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3943860',
  CIP13: '3400939438603',
  ucdLib: "GRANIONS OR BUV AMP2ML",
  UCD7: '9040834',
  UCD13: '3400890408349',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS OR BUV AMP2ML BT 30",
  atcCode: "A12CX"
}, {
  CIP7: '3943877',
  CIP13: '3400939438771',
  ucdLib: "GRANIONS SOUFRE BUV A.2ML",
  UCD7: '9040863',
  UCD13: '3400890408639',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS SOUFRE BUV A.2ML BT 30",
  atcCode: "A12CX"
}, {
  CIP7: '3949124',
  CIP13: '3400939491240',
  ucdLib: "ISOFEBRIL VIT C CPR EFFV",
  UCD7: '9146745',
  UCD13: '3400891467451',
  ucdQtyMultiplicator: 16,
  cipLib: "ISOFEBRIL VIT C CPR EFFV BT 16",
  atcCode: "N02BA51"
}, {
  CIP7: '4902165',
  CIP13: '3400949021659',
  ucdLib: "OSCILLOCOCCINUM GLB AIPMWI LT",
  UCD7: '9399417',
  UCD13: '3400893994177',
  ucdQtyMultiplicator: 6,
  cipLib: "OSCILLOCOCCINUM GLB AIPMWI LT BT 6",
  atcCode: "V03AX"
}, {
  CIP7: '4931706',
  CIP13: '3400949317066',
  ucdLib: "PERUBORE INHAL. CAPS",
  UCD7: '9372140',
  UCD13: '3400893721407',
  ucdQtyMultiplicator: 15,
  cipLib: "PERUBORE INHAL. CAPS BT 15",
  atcCode: "R07AX"
}, {
  CIP7: '4995712',
  CIP13: '3400949957125',
  ucdLib: "REPAGLINIDE ZYD 2MG CPR",
  UCD7: '9366174',
  UCD13: '3400893661741',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ZYD 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '2759516',
  CIP13: '3400927595165',
  ucdLib: "SPEDRA 50MG CPR",
  UCD7: '9400215',
  UCD13: '3400894002154',
  ucdQtyMultiplicator: 12,
  cipLib: "SPEDRA 50MG CPR BT 12",
  atcCode: "G04BE10"
}, {
  CIP7: '4941314',
  CIP13: '3400949413140',
  ucdLib: "TOPOTECAN HPI 4MG INJ FL4ML",
  UCD7: '9355029',
  UCD13: '3400893550298',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPOTECAN HPI 4MG INJ FL4ML BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '4900539',
  CIP13: '3400949005390',
  ucdLib: "ZOXAN LP 4MG CPR AIP MWI UK",
  UCD7: '9353697',
  UCD13: '3400893536971',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOXAN LP 4MG CPR AIP MWI UK BT 28",
  atcCode: "G04CA05"
}, {
  CIP7: '4900924',
  CIP13: '3400949009244',
  ucdLib: "ZOXAN LP 8MG CPR AIP MWI UK",
  UCD7: '9380079',
  UCD13: '3400893800799',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOXAN LP 8MG CPR AIP MWI UK BT 28",
  atcCode: "G04CA05"
}, {
  CIP7: '5910735',
  CIP13: '3400959107350',
  ucdLib: "AMANTADINE AUD 50MG/5ML SIR FL",
  UCD7: '9419999',
  UCD13: '3400894199991',
  ucdQtyMultiplicator: 1,
  cipLib: "AMANTADINE AUD 50MG/5ML SIR FL BT 1",
  atcCode: "N04BB01"
}, {
  CIP7: '5910468',
  CIP13: '3400959104687',
  ucdLib: "AMANTADINE BMS 100MG GELU",
  UCD7: '9416854',
  UCD13: '3400894168546',
  ucdQtyMultiplicator: 50,
  cipLib: "AMANTADINE BMS 100MG GELU BT 50",
  atcCode: "N04BB01"
}, {
  CIP7: '5910132',
  CIP13: '3400959101327',
  ucdLib: "AMENAMEVIR MRO 200MG CPR",
  UCD7: '9410716',
  UCD13: '3400894107163',
  ucdQtyMultiplicator: 1,
  cipLib: "AMENAMEVIR MRO 200MG CPR BT 1",
  atcCode: ""
}, {
  CIP7: '5910876',
  CIP13: '3400959108760',
  ucdLib: "ATTENTIN 5MG CPR",
  UCD7: '9422493',
  UCD13: '3400894224938',
  ucdQtyMultiplicator: 20,
  cipLib: "ATTENTIN 5MG CPR BT 20",
  atcCode: "N06BA02"
}, {
  CIP7: '5910907',
  CIP13: '3400959109071',
  ucdLib: "ATTENTIN 5MG CPR",
  UCD7: '9422493',
  UCD13: '3400894224938',
  ucdQtyMultiplicator: 50,
  cipLib: "ATTENTIN 5MG CPR BT 50",
  atcCode: "N06BA02"
}, {
  CIP7: '5910913',
  CIP13: '3400959109132',
  ucdLib: "AVELUMAB 20MG/ML PERF FL",
  UCD7: '9422518',
  UCD13: '3400894225188',
  ucdQtyMultiplicator: 1,
  cipLib: "AVELUMAB 20MG/ML PERF FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910149',
  CIP13: '3400959101495',
  ucdLib: "AZD4547 20MG CPR",
  UCD7: '9410722',
  UCD13: '3400894107224',
  ucdQtyMultiplicator: 20,
  cipLib: "AZD4547 20MG CPR BT 20",
  atcCode: ""
}, {
  CIP7: '5910787',
  CIP13: '3400959107879',
  ucdLib: "BENZNIDAZOL LFP 12,5MG DISP",
  UCD7: '9420206',
  UCD13: '3400894202066',
  ucdQtyMultiplicator: 1,
  cipLib: "BENZNIDAZOL LFP 12,5MG DISP BT 1",
  atcCode: "P01CA02"
}, {
  CIP7: '5910534',
  CIP13: '3400959105349',
  ucdLib: "BINIMETINIB SCU 15MG CPR",
  UCD7: '9417026',
  UCD13: '3400894170266',
  ucdQtyMultiplicator: 1,
  cipLib: "BINIMETINIB SCU 15MG CPR BT 1",
  atcCode: ""
}, {
  CIP7: '5910540',
  CIP13: '3400959105400',
  ucdLib: "BYL719 200MG CPR PELLIC",
  UCD7: '9417032',
  UCD13: '3400894170327',
  ucdQtyMultiplicator: 35,
  cipLib: "BYL719 200MG CPR PELLIC BT 35",
  atcCode: ""
}, {
  CIP7: '5910557',
  CIP13: '3400959105578',
  ucdLib: "BYL719 50MG CPR PELLIC",
  UCD7: '9417049',
  UCD13: '3400894170495',
  ucdQtyMultiplicator: 35,
  cipLib: "BYL719 50MG CPR PELLIC BT 35",
  atcCode: ""
}, {
  CIP7: '5910451',
  CIP13: '3400959104519',
  ucdLib: "CEFTAZIDIME AVIB ASZ 2/0,5G F",
  UCD7: '9416788',
  UCD13: '3400894167884',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTAZIDIME AVIB ASZ 2/0,5G F BT 1",
  atcCode: "J01DD52"
}, {
  CIP7: '5910563',
  CIP13: '3400959105639',
  ucdLib: "CERENDAY 100MG GELU",
  UCD7: '9417084',
  UCD13: '3400894170846',
  ucdQtyMultiplicator: 1,
  cipLib: "CERENDAY 100MG GELU BT 1",
  atcCode: "A11HA05"
}, {
  CIP7: '5910474',
  CIP13: '3400959104748',
  ucdLib: "CMX 001 10MG/ML BUV FL",
  UCD7: '9416860',
  UCD13: '3400894168607',
  ucdQtyMultiplicator: 1,
  cipLib: "CMX 001 10MG/ML BUV FL BT 1",
  atcCode: "J05AB"
}, {
  CIP7: '5910741',
  CIP13: '3400959107411',
  ucdLib: "CYT 107 2MG/ML SOL INJ FL",
  UCD7: '9420034',
  UCD13: '3400894200345',
  ucdQtyMultiplicator: 1,
  cipLib: "CYT 107 2MG/ML SOL INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910155',
  CIP13: '3400959101556',
  ucdLib: "CYT 107 4MG/ML SOL INJ FL",
  UCD7: '9410840',
  UCD13: '3400894108405',
  ucdQtyMultiplicator: 1,
  cipLib: "CYT 107 4MG/ML SOL INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910758',
  CIP13: '3400959107589',
  ucdLib: "DEMSER 250MG GELU",
  UCD7: '9420040',
  UCD13: '3400894200406',
  ucdQtyMultiplicator: 1,
  cipLib: "DEMSER 250MG GELU BT 1",
  atcCode: "C02KB01"
}, {
  CIP7: '5910310',
  CIP13: '3400959103109',
  ucdLib: "DIPHANTOINE 100MG CPR",
  UCD7: '9412224',
  UCD13: '3400894122241',
  ucdQtyMultiplicator: 100,
  cipLib: "DIPHANTOINE 100MG CPR BT 100",
  atcCode: "N03AB02"
}, {
  CIP7: '5910586',
  CIP13: '3400959105868',
  ucdLib: "DIPHTERIA ANITOX 1000UI/ML FL",
  UCD7: '9417210',
  UCD13: '3400894172109',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPHTERIA ANITOX 1000UI/ML FL BT 1",
  atcCode: "J06BB10"
}, {
  CIP7: '5910592',
  CIP13: '3400959105929',
  ucdLib: "DORIBAX 500MG PERF FL",
  UCD7: '9316868',
  UCD13: '3400893168684',
  ucdQtyMultiplicator: 1,
  cipLib: "DORIBAX 500MG PERF FL BT 1",
  atcCode: "J01DH04"
}, {
  CIP7: '5910385',
  CIP13: '3400959103857',
  ucdLib: "DOTA-NOC 50MCG SOL INJ FL 1",
  UCD7: '9414832',
  UCD13: '3400894148326',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTA-NOC 50MCG SOL INJ FL 1 BT 1",
  atcCode: ""
}, {
  CIP7: '5910480',
  CIP13: '3400959104809',
  ucdLib: "EMSAM 12MG/24H DISP TRANS",
  UCD7: '9416877',
  UCD13: '3400894168775',
  ucdQtyMultiplicator: 1,
  cipLib: "EMSAM 12MG/24H DISP TRANS BT 1",
  atcCode: "N04BD01"
}, {
  CIP7: '5910161',
  CIP13: '3400959101617',
  ucdLib: "EMSAM 6MG/24H DISP TRANS",
  UCD7: '9410886',
  UCD13: '3400894108863',
  ucdQtyMultiplicator: 1,
  cipLib: "EMSAM 6MG/24H DISP TRANS BT 1",
  atcCode: "N04BD01"
}, {
  CIP7: '5910764',
  CIP13: '3400959107640',
  ucdLib: "EMSAM 9MG/24H DISP TRANS",
  UCD7: '9420086',
  UCD13: '3400894200864',
  ucdQtyMultiplicator: 1,
  cipLib: "EMSAM 9MG/24H DISP TRANS BT 1",
  atcCode: "N04BD01"
}, {
  CIP7: '5002469',
  CIP13: '3400950024694',
  ucdLib: "EUCARYL SOL DENT FL13ML",
  UCD7: '9419574',
  UCD13: '3400894195740',
  ucdQtyMultiplicator: 1,
  cipLib: "EUCARYL SOL DENT FL13ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '5002475',
  CIP13: '3400950024755',
  ucdLib: "EUCARYL SOL DENT FL45ML",
  UCD7: '9419580',
  UCD13: '3400894195801',
  ucdQtyMultiplicator: 1,
  cipLib: "EUCARYL SOL DENT FL45ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '5910936',
  CIP13: '3400959109361',
  ucdLib: "GLECAPRE/PIB ABV 100/40MG CP",
  UCD7: '9422777',
  UCD13: '3400894227779',
  ucdQtyMultiplicator: 30,
  cipLib: "GLECAPRE/PIB ABV 100/40MG CP BT 30",
  atcCode: ""
}, {
  CIP7: '5910528',
  CIP13: '3400959105288',
  ucdLib: "GLIBENTEK 0,6MG/ML BUV FL30ML",
  UCD7: '9416989',
  UCD13: '3400894169895',
  ucdQtyMultiplicator: 1,
  cipLib: "GLIBENTEK 0,6MG/ML BUV FL30ML BT 1",
  atcCode: "A10BB01"
}, {
  CIP7: '5910770',
  CIP13: '3400959107701',
  ucdLib: "GLIBENTEK 6MG/ML BUV FL",
  UCD7: '9420092',
  UCD13: '3400894200925',
  ucdQtyMultiplicator: 1,
  cipLib: "GLIBENTEK 6MG/ML BUV FL BT 1",
  atcCode: "A10BB01"
}, {
  CIP7: '5910273',
  CIP13: '3400959102737',
  ucdLib: "GRAZOPREV/ELB MSD100/50MG C.",
  UCD7: '9411414',
  UCD13: '3400894114147',
  ucdQtyMultiplicator: 18,
  cipLib: "GRAZOPREV/ELB MSD100/50MG C. BT 18",
  atcCode: ""
}, {
  CIP7: '5910445',
  CIP13: '3400959104458',
  ucdLib: "INOTUZUMAB OZOG PFZ 4MG F+F",
  UCD7: '9416765',
  UCD13: '3400894167655',
  ucdQtyMultiplicator: 1,
  cipLib: "INOTUZUMAB OZOG PFZ 4MG F+F BT 1",
  atcCode: "L01XC26"
}, {
  CIP7: '5910178',
  CIP13: '3400959101785',
  ucdLib: "KEDRION HUM PLAS 1MG/ML CY FL",
  UCD7: '9410892',
  UCD13: '3400894108924',
  ucdQtyMultiplicator: 1,
  cipLib: "KEDRION HUM PLAS 1MG/ML CY FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910505',
  CIP13: '3400959105059',
  ucdLib: "LORLATINIB PFZ 100MG CPR",
  UCD7: '9416908',
  UCD13: '3400894169086',
  ucdQtyMultiplicator: 1,
  cipLib: "LORLATINIB PFZ 100MG CPR BT 1",
  atcCode: "L01XE"
}, {
  CIP7: '5910511',
  CIP13: '3400959105110',
  ucdLib: "LORLATINIB PFZ 25MG CPR",
  UCD7: '9416914',
  UCD13: '3400894169147',
  ucdQtyMultiplicator: 1,
  cipLib: "LORLATINIB PFZ 25MG CPR BT 1",
  atcCode: "L01XE"
}, {
  CIP7: '5910623',
  CIP13: '3400959106230',
  ucdLib: "LUMACAF/IVA VTX 200/125MG CPR",
  UCD7: '9413614',
  UCD13: '3400894136149',
  ucdQtyMultiplicator: 28,
  cipLib: "LUMACAF/IVA VTX 200/125MG CPR BT 28",
  atcCode: "R07AX30"
}, {
  CIP7: '5910882',
  CIP13: '3400959108821',
  ucdLib: "METRELEPTINE 11,3MG INJ FL",
  UCD7: '9422286',
  UCD13: '3400894222866',
  ucdQtyMultiplicator: 1,
  cipLib: "METRELEPTINE 11,3MG INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910793',
  CIP13: '3400959107930',
  ucdLib: "NIMOTOP 30MG/0,75ML GTT FL",
  UCD7: '9420212',
  UCD13: '3400894202127',
  ucdQtyMultiplicator: 1,
  cipLib: "NIMOTOP 30MG/0,75ML GTT FL BT 1",
  atcCode: "C08CA06"
}, {
  CIP7: '5910652',
  CIP13: '3400959106520',
  ucdLib: "P.AERUGINOSA PHAGE PP1131 CUT",
  UCD7: '9417434',
  UCD13: '3400894174349',
  ucdQtyMultiplicator: 1,
  cipLib: "P.AERUGINOSA PHAGE PP1131 CUT BT 1",
  atcCode: ""
}, {
  CIP7: '5910008',
  CIP13: '3400959100085',
  ucdLib: "PALBOCICLIB PFZ 75MG GELU",
  UCD7: '9407677',
  UCD13: '3400894076773',
  ucdQtyMultiplicator: 21,
  cipLib: "PALBOCICLIB PFZ 75MG GELU BT 21",
  atcCode: "L01XE33"
}, {
  CIP7: '5910669',
  CIP13: '3400959106698',
  ucdLib: "PANOBINOSTAT NPH 20MG GELU",
  UCD7: '9411101',
  UCD13: '3400894111016',
  ucdQtyMultiplicator: 15,
  cipLib: "PANOBINOSTAT NPH 20MG GELU BT 15",
  atcCode: "L01XX42"
}, {
  CIP7: '5001694',
  CIP13: '3400950016941',
  ucdLib: "PARACAMF SOL DENT FV45ML",
  UCD7: '9419539',
  UCD13: '3400894195399',
  ucdQtyMultiplicator: 1,
  cipLib: "PARACAMF SOL DENT FV45ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '5910014',
  CIP13: '3400959100146',
  ucdLib: "PAS-FATOL 11,82G PERF FL",
  UCD7: '9407737',
  UCD13: '3400894077374',
  ucdQtyMultiplicator: 1,
  cipLib: "PAS-FATOL 11,82G PERF FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910184',
  CIP13: '3400959101846',
  ucdLib: "PDP-ISONIAZID 10MG/ML BUV FL",
  UCD7: '9410917',
  UCD13: '3400894109174',
  ucdQtyMultiplicator: 1,
  cipLib: "PDP-ISONIAZID 10MG/ML BUV FL BT 1",
  atcCode: "J04AC01"
}, {
  CIP7: '5910020',
  CIP13: '3400959100207',
  ucdLib: "PHENTOLAMINE MES. BDD 5MG FL",
  UCD7: '9407743',
  UCD13: '3400894077435',
  ucdQtyMultiplicator: 1,
  cipLib: "PHENTOLAMINE MES. BDD 5MG FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910801',
  CIP13: '3400959108012',
  ucdLib: "PHENTOLAMINE MES. SDZ 5MG FL",
  UCD7: '9420241',
  UCD13: '3400894202417',
  ucdQtyMultiplicator: 1,
  cipLib: "PHENTOLAMINE MES. SDZ 5MG FL BT 1",
  atcCode: "C04AB01"
}, {
  CIP7: '5910818',
  CIP13: '3400959108180',
  ucdLib: "PHOSPHATE SDZ 500MG CPR EFFV",
  UCD7: '9420258',
  UCD13: '3400894202585',
  ucdQtyMultiplicator: 1,
  cipLib: "PHOSPHATE SDZ 500MG CPR EFFV BT 1",
  atcCode: ""
}, {
  CIP7: '5910824',
  CIP13: '3400959108241',
  ucdLib: "PICIBANIL 0,5KE PDR INJ FL",
  UCD7: '9420264',
  UCD13: '3400894202646',
  ucdQtyMultiplicator: 1,
  cipLib: "PICIBANIL 0,5KE PDR INJ FL BT 1",
  atcCode: "C05BB"
}, {
  CIP7: '5910190',
  CIP13: '3400959101907',
  ucdLib: "PRIDOPIDINE NSH 45MG CPR",
  UCD7: '9410923',
  UCD13: '3400894109235',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIDOPIDINE NSH 45MG CPR BT 1",
  atcCode: ""
}, {
  CIP7: '5911083',
  CIP13: '3400959110831',
  ucdLib: "PROBENECID BKN 500MG CPR",
  UCD7: '9422978',
  UCD13: '3400894229780',
  ucdQtyMultiplicator: 100,
  cipLib: "PROBENECID BKN 500MG CPR BT 100",
  atcCode: ""
}, {
  CIP7: '5910698',
  CIP13: '3400959106988',
  ucdLib: "PROPRANOLOL RMT 10MG/5ML FL",
  UCD7: '9419769',
  UCD13: '3400894197690',
  ucdQtyMultiplicator: 1,
  cipLib: "PROPRANOLOL RMT 10MG/5ML FL BT 1",
  atcCode: "C07AA05"
}, {
  CIP7: '5910706',
  CIP13: '3400959107060',
  ucdLib: "PROPRANOLOL RMT 50MG/5ML FL",
  UCD7: '9419775',
  UCD13: '3400894197751',
  ucdQtyMultiplicator: 1,
  cipLib: "PROPRANOLOL RMT 50MG/5ML FL BT 1",
  atcCode: "C07AA05"
}, {
  CIP7: '5910712',
  CIP13: '3400959107121',
  ucdLib: "PROPRANOLOL RMT 5MG/5ML FL",
  UCD7: '9419781',
  UCD13: '3400894197812',
  ucdQtyMultiplicator: 1,
  cipLib: "PROPRANOLOL RMT 5MG/5ML FL BT 1",
  atcCode: "C07AA05"
}, {
  CIP7: '5910830',
  CIP13: '3400959108302',
  ucdLib: "PSMA-11 PDR INJ FL",
  UCD7: '9420270',
  UCD13: '3400894202707',
  ucdQtyMultiplicator: 1,
  cipLib: "PSMA-11 PDR INJ FL BT 1",
  atcCode: ""
}, {
  CIP7: '5000921',
  CIP13: '3400950009219',
  ucdLib: "ROCKLES SOL DENT FL13ML",
  UCD7: '9419605',
  UCD13: '3400894196051',
  ucdQtyMultiplicator: 1,
  cipLib: "ROCKLES SOL DENT FL13ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '5910209',
  CIP13: '3400959102096',
  ucdLib: "ROGITINE SOL INJ AMP",
  UCD7: '9410946',
  UCD13: '3400894109464',
  ucdQtyMultiplicator: 1,
  cipLib: "ROGITINE SOL INJ AMP BT 1",
  atcCode: "C04AB01"
}, {
  CIP7: '5910853',
  CIP13: '3400959108531',
  ucdLib: "SALBUMOL 2MG CPR",
  UCD7: '9127096',
  UCD13: '3400891270969',
  ucdQtyMultiplicator: 40,
  cipLib: "SALBUMOL 2MG CPR BT 40",
  atcCode: "G02CA"
}, {
  CIP7: '5910215',
  CIP13: '3400959102157',
  ucdLib: "SCORPIFAV 1ML PERF FL",
  UCD7: '9410952',
  UCD13: '3400894109525',
  ucdQtyMultiplicator: 1,
  cipLib: "SCORPIFAV 1ML PERF FL BT 1",
  atcCode: "J06BB"
}, {
  CIP7: '5001056',
  CIP13: '3400950010567',
  ucdLib: "SEPTOMIXINE PATE DENT TB7,5G",
  UCD7: '9419551',
  UCD13: '3400894195511',
  ucdQtyMultiplicator: 1,
  cipLib: "SEPTOMIXINE PATE DENT TB7,5G BT 1",
  atcCode: "A01AC"
}, {
  CIP7: '5910847',
  CIP13: '3400959108470',
  ucdLib: "SOFOSB/VELP GLD 400/100MG CP",
  UCD7: '9420287',
  UCD13: '3400894202875',
  ucdQtyMultiplicator: 28,
  cipLib: "SOFOSB/VELP GLD 400/100MG CP BT 28",
  atcCode: ""
}, {
  CIP7: '5910221',
  CIP13: '3400959102218',
  ucdLib: "SONIDEGIB NPH 50MG/ML BUV F+F",
  UCD7: '9410969',
  UCD13: '3400894109693',
  ucdQtyMultiplicator: 1,
  cipLib: "SONIDEGIB NPH 50MG/ML BUV F+F BT 1",
  atcCode: "L01XX48"
}, {
  CIP7: '5910422',
  CIP13: '3400959104229',
  ucdLib: "STRATTERA 10MG GELU",
  UCD7: '9262434',
  UCD13: '3400892624341',
  ucdQtyMultiplicator: 7,
  cipLib: "STRATTERA 10MG GELU BT 7",
  atcCode: "N06BA09"
}, {
  CIP7: '5910439',
  CIP13: '3400959104397',
  ucdLib: "STRATTERA 18MG GELU",
  UCD7: '9262440',
  UCD13: '3400892624402',
  ucdQtyMultiplicator: 7,
  cipLib: "STRATTERA 18MG GELU BT 7",
  atcCode: "N06BA09"
}, {
  CIP7: '5910681',
  CIP13: '3400959106810',
  ucdLib: "TENOFOVIR ALAF GLD 25MG CPR",
  UCD7: '9418089',
  UCD13: '3400894180890',
  ucdQtyMultiplicator: 30,
  cipLib: "TENOFOVIR ALAF GLD 25MG CPR BT 30",
  atcCode: "J05AF13"
}, {
  CIP7: '5910675',
  CIP13: '3400959106759',
  ucdLib: "TENORMINE 5MG/ML BUV FL300ML",
  UCD7: '9417581',
  UCD13: '3400894175810',
  ucdQtyMultiplicator: 1,
  cipLib: "TENORMINE 5MG/ML BUV FL300ML BT 1",
  atcCode: "C07AB03"
}, {
  CIP7: '5910899',
  CIP13: '3400959108999',
  ucdLib: "TETAGAM P 250UI/ML INJ SRG1ML",
  UCD7: '9422470',
  UCD13: '3400894224709',
  ucdQtyMultiplicator: 1,
  cipLib: "TETAGAM P 250UI/ML INJ SRG1ML BT 1",
  atcCode: "J06BB02"
}, {
  CIP7: '5910238',
  CIP13: '3400959102386',
  ucdLib: "TMC 278 300MG/ML SUSP INJ FL",
  UCD7: '9410981',
  UCD13: '3400894109815',
  ucdQtyMultiplicator: 1,
  cipLib: "TMC 278 300MG/ML SUSP INJ FL BT 1",
  atcCode: "J05AG05"
}, {
  CIP7: '5910379',
  CIP13: '3400959103796',
  ucdLib: "UBITEN 10MG CPR",
  UCD7: '9246240',
  UCD13: '3400892462400',
  ucdQtyMultiplicator: 112,
  cipLib: "UBITEN 10MG CPR BT 112",
  atcCode: "C01EB09"
}, {
  CIP7: '5910362',
  CIP13: '3400959103628',
  ucdLib: "UX003 2MG/ML PERF FL",
  UCD7: '9413637',
  UCD13: '3400894136378',
  ucdQtyMultiplicator: 1,
  cipLib: "UX003 2MG/ML PERF FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910244',
  CIP13: '3400959102447',
  ucdLib: "UX007 SOL BUV FL",
  UCD7: '9410998',
  UCD13: '3400894109983',
  ucdQtyMultiplicator: 1,
  cipLib: "UX007 SOL BUV FL BT 1",
  atcCode: ""
}, {
  CIP7: '5910729',
  CIP13: '3400959107299',
  ucdLib: "VENETOCLAX ABV 100MG CPR",
  UCD7: '9419278',
  UCD13: '3400894192787',
  ucdQtyMultiplicator: 124,
  cipLib: "VENETOCLAX ABV 100MG CPR BT 124",
  atcCode: "L01XX52"
}, {
  CIP7: '5910497',
  CIP13: '3400959104977',
  ucdLib: "VERMOX 100MG CPR",
  UCD7: '9416883',
  UCD13: '3400894168836',
  ucdQtyMultiplicator: 1,
  cipLib: "VERMOX 100MG CPR BT 1",
  atcCode: "P02CA01"
}, {
  CIP7: '5910250',
  CIP13: '3400959102508',
  ucdLib: "VITARUBINE SUPERC 1000MCG FL",
  UCD7: '9411006',
  UCD13: '3400894110064',
  ucdQtyMultiplicator: 1,
  cipLib: "VITARUBINE SUPERC 1000MCG FL BT 1",
  atcCode: "B03BA01"
}, {
  CIP7: '5910037',
  CIP13: '3400959100375',
  ucdLib: "XEPIN 5% CR TB",
  UCD7: '9407766',
  UCD13: '3400894077664',
  ucdQtyMultiplicator: 1,
  cipLib: "XEPIN 5% CR TB BT 1",
  atcCode: ""
}, {
  CIP7: '2676463',
  CIP13: '3400926764630',
  ucdLib: "ACTHEANE CPR",
  UCD7: '9302317',
  UCD13: '3400893023174',
  ucdQtyMultiplicator: 120,
  cipLib: "ACTHEANE CPR BT 120",
  atcCode: "V03AX"
}, {
  CIP7: '2203150',
  CIP13: '3400922031507',
  ucdLib: "ATEPADENE 30MG GELU",
  UCD7: '9155017',
  UCD13: '3400891550177',
  ucdQtyMultiplicator: 30,
  cipLib: "ATEPADENE 30MG GELU BT 30",
  atcCode: "M03AX"
}, {
  CIP7: '2673996',
  CIP13: '3400926739966',
  ucdLib: "BADIAGA COMPLEXE N47 CPR",
  UCD7: '9403544',
  UCD13: '3400894035442',
  ucdQtyMultiplicator: 60,
  cipLib: "BADIAGA COMPLEXE N47 CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '4929566',
  CIP13: '3400949295661',
  ucdLib: "CALENDULA OFF TM BOIR LOC 60ML",
  UCD7: '9386975',
  UCD13: '3400893869758',
  ucdQtyMultiplicator: 1,
  cipLib: "CALENDULA OFF TM BOIR LOC 60ML BT 1",
  atcCode: "Z10"
}, {
  CIP7: '4929572',
  CIP13: '3400949295722',
  ucdLib: "CALENDULA OFF TM BOIR LOC125ML",
  UCD7: '9386969',
  UCD13: '3400893869697',
  ucdQtyMultiplicator: 1,
  cipLib: "CALENDULA OFF TM BOIR LOC125ML BT 1",
  atcCode: "Z10"
}, {
  CIP7: '3990397',
  CIP13: '3400939903972',
  ucdLib: "CHOPHYTOL CPR",
  UCD7: '9019337',
  UCD13: '3400890193375',
  ucdQtyMultiplicator: 60,
  cipLib: "CHOPHYTOL CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3990405',
  CIP13: '3400939904054',
  ucdLib: "CHOPHYTOL CPR",
  UCD7: '9019337',
  UCD13: '3400890193375',
  ucdQtyMultiplicator: 180,
  cipLib: "CHOPHYTOL CPR BT 180",
  atcCode: "V03AX"
}, {
  CIP7: '5755298',
  CIP13: '3400957552985',
  ucdLib: "CIPROFLOXACINE QVR 750MG CPR",
  UCD7: '9338887',
  UCD13: '3400893388877',
  ucdQtyMultiplicator: 80,
  cipLib: "CIPROFLOXACINE QVR 750MG CPR BT 80",
  atcCode: "J01MA02"
}, {
  CIP7: '2246886',
  CIP13: '3400922468860',
  ucdLib: "CORYZALIA CPR DISP",
  UCD7: '9388402',
  UCD13: '3400893884027',
  ucdQtyMultiplicator: 40,
  cipLib: "CORYZALIA CPR DISP BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '2203173',
  CIP13: '3400922031736',
  ucdLib: "DOLOSOFT 450MG CPR",
  UCD7: '9383586',
  UCD13: '3400893835869',
  ucdQtyMultiplicator: 45,
  cipLib: "DOLOSOFT 450MG CPR BT 45",
  atcCode: "V03AX"
}, {
  CIP7: '2244746',
  CIP13: '3400922447469',
  ucdLib: "DORMICALM CPR ENROB",
  UCD7: '9390540',
  UCD13: '3400893905401',
  ucdQtyMultiplicator: 30,
  cipLib: "DORMICALM CPR ENROB BT 30",
  atcCode: "N05CM09"
}, {
  CIP7: '2165366',
  CIP13: '3400921653663',
  ucdLib: "DOXAZOSINE MYL LP 4MG CPR",
  UCD7: '9397884',
  UCD13: '3400893978849',
  ucdQtyMultiplicator: 28,
  cipLib: "DOXAZOSINE MYL LP 4MG CPR BT 28",
  atcCode: "C02CA04"
}, {
  CIP7: '2181017',
  CIP13: '3400921810172',
  ucdLib: "DROLEPTAN 1,25MG INJ A.2,5ML",
  UCD7: '9387673',
  UCD13: '3400893876732',
  ucdQtyMultiplicator: 10,
  cipLib: "DROLEPTAN 1,25MG INJ A.2,5ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '5715005',
  CIP13: '3400957150051',
  ucdLib: "GEMCITABINE HPI 1G INJ FL",
  UCD7: '9309779',
  UCD13: '3400893097793',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE HPI 1G INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5714980',
  CIP13: '3400957149802',
  ucdLib: "GEMCITABINE HPI 200MG INJ FL",
  UCD7: '9309791',
  UCD13: '3400893097915',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE HPI 200MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5715028',
  CIP13: '3400957150280',
  ucdLib: "GEMCITABINE HPI 2G INJ FL",
  UCD7: '9309785',
  UCD13: '3400893097854',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE HPI 2G INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '2238556',
  CIP13: '3400922385563',
  ucdLib: "HELICIDINE 10% S/S SIR FP125ML",
  UCD7: '9389809',
  UCD13: '3400893898093',
  ucdQtyMultiplicator: 1,
  cipLib: "HELICIDINE 10% S/S SIR FP125ML BT 1",
  atcCode: "R05DB"
}, {
  CIP7: '2238562',
  CIP13: '3400922385624',
  ucdLib: "HELICIDINE 10% S/S SIR FP250ML",
  UCD7: '9389815',
  UCD13: '3400893898154',
  ucdQtyMultiplicator: 1,
  cipLib: "HELICIDINE 10% S/S SIR FP250ML BT 1",
  atcCode: "R05DB"
}, {
  CIP7: '2166667',
  CIP13: '3400921666670',
  ucdLib: "HOMEOQUINTYL GLE TB",
  UCD7: '9384054',
  UCD13: '3400893840542',
  ucdQtyMultiplicator: 2,
  cipLib: "HOMEOQUINTYL GLE TB BT 2",
  atcCode: "V03AX"
}, {
  CIP7: '2189800',
  CIP13: '3400921898002',
  ucdLib: "LERGYPAX CPR DISP",
  UCD7: '9391019',
  UCD13: '3400893910191',
  ucdQtyMultiplicator: 40,
  cipLib: "LERGYPAX CPR DISP BT 40",
  atcCode: "V03AX"
}, {
  CIP7: '5756524',
  CIP13: '3400957565244',
  ucdLib: "LEVOFLOX.MYL 5MG/ML POC50ML",
  UCD7: '9341889',
  UCD13: '3400893418895',
  ucdQtyMultiplicator: 50,
  cipLib: "LEVOFLOX.MYL 5MG/ML POC50ML BT 50",
  atcCode: "J01MA12"
}, {
  CIP7: '4166200',
  CIP13: '3400941662003',
  ucdLib: "OSCILLOCOCCINUM GM GLB DOS",
  UCD7: '9065969',
  UCD13: '3400890659697',
  ucdQtyMultiplicator: 30,
  cipLib: "OSCILLOCOCCINUM GM GLB DOS BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '5709447',
  CIP13: '3400957094478',
  ucdLib: "OXALIPLATIN.EBW 5MG/ML 100MG",
  UCD7: '9301393',
  UCD13: '3400893013939',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.EBW 5MG/ML 100MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5728315',
  CIP13: '3400957283155',
  ucdLib: "OXALIPLATIN.EBW 5MG/ML 150MG",
  UCD7: '9314415',
  UCD13: '3400893144152',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.EBW 5MG/ML 150MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5709430',
  CIP13: '3400957094300',
  ucdLib: "OXALIPLATIN.EBW 5MG/ML 50MG",
  UCD7: '9301401',
  UCD13: '3400893014011',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.EBW 5MG/ML 50MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5704800',
  CIP13: '3400957048006',
  ucdLib: "OXALIPLATIN.MYL 5MG/ML 100MG",
  UCD7: '9297349',
  UCD13: '3400892973494',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.MYL 5MG/ML 100MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5704734',
  CIP13: '3400957047344',
  ucdLib: "OXALIPLATIN.MYL 5MG/ML 50MG",
  UCD7: '9297355',
  UCD13: '3400892973555',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.MYL 5MG/ML 50MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '3992574',
  CIP13: '3400939925745',
  ucdLib: "PANENZA INJ FL5ML",
  UCD7: '9343291',
  UCD13: '3400893432914',
  ucdQtyMultiplicator: 10,
  cipLib: "PANENZA INJ FL5ML BT 10",
  atcCode: "J07BB02"
}, {
  CIP7: '3992580',
  CIP13: '3400939925806',
  ucdLib: "PANENZA INJ SRG0,5ML A/AIG",
  UCD7: '9343285',
  UCD13: '3400893432853',
  ucdQtyMultiplicator: 1,
  cipLib: "PANENZA INJ SRG0,5ML A/AIG BT 1",
  atcCode: "J07BB02"
}, {
  CIP7: '2227765',
  CIP13: '3400922277653',
  ucdLib: "REVATIO 10MG/ML BUV FL",
  UCD7: '9385013',
  UCD13: '3400893850138',
  ucdQtyMultiplicator: 1,
  cipLib: "REVATIO 10MG/ML BUV FL BT 1",
  atcCode: "G04BE03"
}, {
  CIP7: '2169588',
  CIP13: '3400921695885',
  ucdLib: "RIBAVIRINE MYL 400MG CPR",
  UCD7: '9373398',
  UCD13: '3400893733981',
  ucdQtyMultiplicator: 14,
  cipLib: "RIBAVIRINE MYL 400MG CPR BT 14",
  atcCode: "J05AB04"
}, {
  CIP7: '2189651',
  CIP13: '3400921896510',
  ucdLib: "SEDATIF PC CPR",
  UCD7: '9066845',
  UCD13: '3400890668453',
  ucdQtyMultiplicator: 90,
  cipLib: "SEDATIF PC CPR BT 90",
  atcCode: "V03AX"
}, {
  CIP7: '2688383',
  CIP13: '3400926883836',
  ucdLib: "SUCCICAPTAL 100MG GELU",
  UCD7: '9391031',
  UCD13: '3400893910313',
  ucdQtyMultiplicator: 15,
  cipLib: "SUCCICAPTAL 100MG GELU BT 15",
  atcCode: "V03AB"
}, {
  CIP7: '2671997',
  CIP13: '3400926719975',
  ucdLib: "TRAMADOL/PAR.KRK 75/650 CPR",
  UCD7: '9418729',
  UCD13: '3400894187295',
  ucdQtyMultiplicator: 10,
  cipLib: "TRAMADOL/PAR.KRK 75/650 CPR BT 10",
  atcCode: "N02AX52"
}, {
  CIP7: '2771569',
  CIP13: '3400927715693',
  ucdLib: "ANTISTAX 360MG CPR",
  UCD7: '9406933',
  UCD13: '3400894069331',
  ucdQtyMultiplicator: 30,
  cipLib: "ANTISTAX 360MG CPR BT 30",
  atcCode: "V03AX"
}, {
  CIP7: '2771581',
  CIP13: '3400927715815',
  ucdLib: "ANTISTAX 360MG CPR",
  UCD7: '9406933',
  UCD13: '3400894069331',
  ucdQtyMultiplicator: 60,
  cipLib: "ANTISTAX 360MG CPR BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '2795653',
  CIP13: '3400927956539',
  ucdLib: "ANXEMIL 200MG CPR",
  UCD7: '9405655',
  UCD13: '3400894056553',
  ucdQtyMultiplicator: 42,
  cipLib: "ANXEMIL 200MG CPR BT 42",
  atcCode: "V03AX"
}, {
  CIP7: '2773841',
  CIP13: '3400927738418',
  ucdLib: "CALENDORON CR TB25G",
  UCD7: '9418155',
  UCD13: '3400894181552',
  ucdQtyMultiplicator: 1,
  cipLib: "CALENDORON CR TB25G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '5661396',
  CIP13: '3400956613960',
  ucdLib: "CHOLEDIAM TROUS FL",
  UCD7: '9275543',
  UCD13: '3400892755434',
  ucdQtyMultiplicator: 5,
  cipLib: "CHOLEDIAM TROUS FL BT 5",
  atcCode: "V09DA04"
}, {
  CIP7: '5739796',
  CIP13: '3400957397968',
  ucdLib: "CIPROFLOX.KBI400MG/200ML P.S",
  UCD7: '9325011',
  UCD13: '3400893250112',
  ucdQtyMultiplicator: 1,
  cipLib: "CIPROFLOX.KBI400MG/200ML P.S BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '5842904',
  CIP13: '3400958429040',
  ucdLib: "DROPERIDOL AGT 1,25MG INJ1ML",
  UCD7: '9391373',
  UCD13: '3400893913734',
  ucdQtyMultiplicator: 10,
  cipLib: "DROPERIDOL AGT 1,25MG INJ1ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '5840495',
  CIP13: '3400958404955',
  ucdLib: "DROPERIDOL AGT 2,5MG INJ 1ML",
  UCD7: '9390505',
  UCD13: '3400893905050',
  ucdQtyMultiplicator: 10,
  cipLib: "DROPERIDOL AGT 2,5MG INJ 1ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '5833070',
  CIP13: '3400958330704',
  ucdLib: "DROPERIDOL ARW 2,5MG INJ 1ML",
  UCD7: '9385898',
  UCD13: '3400893858981',
  ucdQtyMultiplicator: 10,
  cipLib: "DROPERIDOL ARW 2,5MG INJ 1ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '5669736',
  CIP13: '3400956697366',
  ucdLib: "EAU P.P.I REN A.B5ML",
  UCD7: '9277358',
  UCD13: '3400892773582',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I REN A.B5ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5682429',
  CIP13: '3400956824298',
  ucdLib: "EPIRUBICINE INT 2MG/ML FL100ML",
  UCD7: '9284358',
  UCD13: '3400892843582',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE INT 2MG/ML FL100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5682406',
  CIP13: '3400956824069',
  ucdLib: "EPIRUBICINE INT 2MG/ML FL25ML",
  UCD7: '9284364',
  UCD13: '3400892843643',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE INT 2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5682412',
  CIP13: '3400956824120',
  ucdLib: "EPIRUBICINE INT 2MG/ML FL50ML",
  UCD7: '9284387',
  UCD13: '3400892843872',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE INT 2MG/ML FL50ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5682381',
  CIP13: '3400956823819',
  ucdLib: "EPIRUBICINE INT 2MG/ML FL5ML",
  UCD7: '9284370',
  UCD13: '3400892843704',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE INT 2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5779229',
  CIP13: '3400957792299',
  ucdLib: "EPOPROSTENOL INT 0,5MG FL+FL",
  UCD7: '9356201',
  UCD13: '3400893562017',
  ucdQtyMultiplicator: 1,
  cipLib: "EPOPROSTENOL INT 0,5MG FL+FL BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5779241',
  CIP13: '3400957792411',
  ucdLib: "EPOPROSTENOL INT 1,5MG FL+FL",
  UCD7: '9356218',
  UCD13: '3400893562185',
  ucdQtyMultiplicator: 1,
  cipLib: "EPOPROSTENOL INT 1,5MG FL+FL BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5776047',
  CIP13: '3400957760472',
  ucdLib: "EPOPROSTENOL SDZ 0,5MG FL+FL",
  UCD7: '9355816',
  UCD13: '3400893558164',
  ucdQtyMultiplicator: 1,
  cipLib: "EPOPROSTENOL SDZ 0,5MG FL+FL BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5783573',
  CIP13: '3400957835736',
  ucdLib: "EPOPROSTENOL SDZ 1,5MG FL+FL",
  UCD7: '9355822',
  UCD13: '3400893558225',
  ucdQtyMultiplicator: 1,
  cipLib: "EPOPROSTENOL SDZ 1,5MG FL+FL BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5680519',
  CIP13: '3400956805198',
  ucdLib: "GLUCOSE 10% REN INJ A.B10ML",
  UCD7: '9280834',
  UCD13: '3400892808345',
  ucdQtyMultiplicator: 100,
  cipLib: "GLUCOSE 10% REN INJ A.B10ML BT 100",
  atcCode: "B05BA03"
}, {
  CIP7: '5671940',
  CIP13: '3400956719402',
  ucdLib: "GLUCOSE 5% REN INJ A.B20ML",
  UCD7: '9280751',
  UCD13: '3400892807515',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 5% REN INJ A.B20ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '5785342',
  CIP13: '3400957853426',
  ucdLib: "IDARUBICINE SDZ 1MG/ML FL10ML",
  UCD7: '9360898',
  UCD13: '3400893608982',
  ucdQtyMultiplicator: 1,
  cipLib: "IDARUBICINE SDZ 1MG/ML FL10ML BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5785371',
  CIP13: '3400957853716',
  ucdLib: "IDARUBICINE SDZ 1MG/ML FL20ML",
  UCD7: '9360906',
  UCD13: '3400893609064',
  ucdQtyMultiplicator: 1,
  cipLib: "IDARUBICINE SDZ 1MG/ML FL20ML BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5785307',
  CIP13: '3400957853075',
  ucdLib: "IDARUBICINE SDZ 1MG/ML FL5ML",
  UCD7: '9360912',
  UCD13: '3400893609125',
  ucdQtyMultiplicator: 1,
  cipLib: "IDARUBICINE SDZ 1MG/ML FL5ML BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5735798',
  CIP13: '3400957357986',
  ucdLib: "IMIPEN/CIL.RBX 500/500 22ML+S",
  UCD7: '9324767',
  UCD13: '3400893247679',
  ucdQtyMultiplicator: 10,
  cipLib: "IMIPEN/CIL.RBX 500/500 22ML+S BT 10",
  atcCode: "J01DH51"
}, {
  CIP7: '5662088',
  CIP13: '3400956620883',
  ucdLib: "IONSYS 40MCG/DOS DISP TRANS",
  UCD7: '9295729',
  UCD13: '3400892957296',
  ucdQtyMultiplicator: 1,
  cipLib: "IONSYS 40MCG/DOS DISP TRANS BT 1",
  atcCode: "N02AB03"
}, {
  CIP7: '5779519',
  CIP13: '3400957795191',
  ucdLib: "IRINOTECAN EBW 20MG/ML 7,5ML",
  UCD7: '9354952',
  UCD13: '3400893549520',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN EBW 20MG/ML 7,5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5779488',
  CIP13: '3400957794880',
  ucdLib: "IRINOTECAN EBW 20MG/ML FL5ML",
  UCD7: '9354946',
  UCD13: '3400893549469',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN EBW 20MG/ML FL5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '2792620',
  CIP13: '3400927926204',
  ucdLib: "L107 BUV GTT FL30ML",
  UCD7: '9255500',
  UCD13: '3400892555003',
  ucdQtyMultiplicator: 1,
  cipLib: "L107 BUV GTT FL30ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '4965527',
  CIP13: '3400949655274',
  ucdLib: "METFORMINE PFZ 1000MG CPR",
  UCD7: '9365967',
  UCD13: '3400893659670',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE PFZ 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '4965591',
  CIP13: '3400949655915',
  ucdLib: "METFORMINE PFZ 1000MG CPR",
  UCD7: '9365967',
  UCD13: '3400893659670',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE PFZ 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '5667111',
  CIP13: '3400956671113',
  ucdLib: "MITOXANTRONE MYL2MG/ML 10ML",
  UCD7: '9277186',
  UCD13: '3400892771861',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE MYL2MG/ML 10ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5680867',
  CIP13: '3400956808670',
  ucdLib: "MITOXANTRONE MYL2MG/ML 12ML5",
  UCD7: '9284803',
  UCD13: '3400892848037',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE MYL2MG/ML 12ML5 BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5667097',
  CIP13: '3400956670970',
  ucdLib: "MITOXANTRONE MYL2MG/ML 5ML",
  UCD7: '9277192',
  UCD13: '3400892771922',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE MYL2MG/ML 5ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5669446',
  CIP13: '3400956694464',
  ucdLib: "MORPHINE 10MG/ML CPF A.10ML",
  UCD7: '9274791',
  UCD13: '3400892747910',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 10MG/ML CPF A.10ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5663662',
  CIP13: '3400956636624',
  ucdLib: "MORPHINE 10MG/ML CPF A.1ML",
  UCD7: '9274785',
  UCD13: '3400892747859',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 10MG/ML CPF A.1ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5669392',
  CIP13: '3400956693924',
  ucdLib: "MORPHINE 10MG/ML CPF A.2ML",
  UCD7: '9274816',
  UCD13: '3400892748160',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 10MG/ML CPF A.2ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5669417',
  CIP13: '3400956694174',
  ucdLib: "MORPHINE 10MG/ML CPF A.5ML",
  UCD7: '9274822',
  UCD13: '3400892748221',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 10MG/ML CPF A.5ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5667766',
  CIP13: '3400956677665',
  ucdLib: "OFLOXACINE MAC200MG/40ML P+MAT",
  UCD7: '9277720',
  UCD13: '3400892777207',
  ucdQtyMultiplicator: 1,
  cipLib: "OFLOXACINE MAC200MG/40ML P+MAT BT 1",
  atcCode: "J01MA01"
}, {
  CIP7: '5661025',
  CIP13: '3400956610259',
  ucdLib: "OXYNOX 135 BOUT 5L",
  UCD7: '9280165',
  UCD13: '3400892801650',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYNOX 135 BOUT 5L BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '2794346',
  CIP13: '3400927943461',
  ucdLib: "PERINDOPRIL TOSI.TVC 5MG C",
  UCD7: '9404319',
  UCD13: '3400894043195',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL TOSI.TVC 5MG C BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2794375',
  CIP13: '3400927943751',
  ucdLib: "PERINDOPRIL TOSI.TVC 5MG C",
  UCD7: '9404319',
  UCD13: '3400894043195',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL TOSI.TVC 5MG C BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '5671609',
  CIP13: '3400956716098',
  ucdLib: "SEPTANEST ADR.1/100 CART1ML",
  UCD7: '9405046',
  UCD13: '3400894050469',
  ucdQtyMultiplicator: 50,
  cipLib: "SEPTANEST ADR.1/100 CART1ML BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5671615',
  CIP13: '3400956716159',
  ucdLib: "SEPTANEST ADR.1/200 CART1ML",
  UCD7: '9405052',
  UCD13: '3400894050520',
  ucdQtyMultiplicator: 50,
  cipLib: "SEPTANEST ADR.1/200 CART1ML BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5670099',
  CIP13: '3400956700998',
  ucdLib: "SODIUM 0,9% REN INJ A.B10ML",
  UCD7: '9277223',
  UCD13: '3400892772233',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% REN INJ A.B10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5670024',
  CIP13: '3400956700240',
  ucdLib: "SODIUM 0,9% REN INJ A.B20ML",
  UCD7: '9277246',
  UCD13: '3400892772462',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 0,9% REN INJ A.B20ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '5670165',
  CIP13: '3400956701650',
  ucdLib: "SODIUM 0,9% REN INJ A.B5ML",
  UCD7: '9277252',
  UCD13: '3400892772523',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% REN INJ A.B5ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5669995',
  CIP13: '3400956699957',
  ucdLib: "SODIUM 10% REN INJ A.B20ML",
  UCD7: '9277275',
  UCD13: '3400892772752',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 10% REN INJ A.B20ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '2799941',
  CIP13: '3400927999413',
  ucdLib: "STODALINE S/SUC SIR FL200ML",
  UCD7: '9411420',
  UCD13: '3400894114208',
  ucdQtyMultiplicator: 1,
  cipLib: "STODALINE S/SUC SIR FL200ML BT 1",
  atcCode: "V03AX"
}, {
  CIP7: '5660391',
  CIP13: '3400956603916',
  ucdLib: "SUFENTANIL EPT 50MCG/ML 1ML",
  UCD7: '9266001',
  UCD13: '3400892660011',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTANIL EPT 50MCG/ML 1ML BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5657963',
  CIP13: '3400956579631',
  ucdLib: "ABILIFY 10MG CPR",
  UCD7: '9261274',
  UCD13: '3400892612744',
  ucdQtyMultiplicator: 98,
  cipLib: "ABILIFY 10MG CPR BT 98",
  atcCode: "N05AX12"
}, {
  CIP7: '5657986',
  CIP13: '3400956579860',
  ucdLib: "ABILIFY 15MG CPR",
  UCD7: '9261280',
  UCD13: '3400892612805',
  ucdQtyMultiplicator: 98,
  cipLib: "ABILIFY 15MG CPR BT 98",
  atcCode: "N05AX12"
}, {
  CIP7: '5651191',
  CIP13: '3400956511914',
  ucdLib: "ACIDE FOLIQUE CCD 5MG CPR",
  UCD7: '9235207',
  UCD13: '3400892352077',
  ucdQtyMultiplicator: 500,
  cipLib: "ACIDE FOLIQUE CCD 5MG CPR BT 500",
  atcCode: "B03BB01"
}, {
  CIP7: '5654516',
  CIP13: '3400956545162',
  ucdLib: "ADRENALINE 1MG/ML REN AB5ML",
  UCD7: '9262026',
  UCD13: '3400892620268',
  ucdQtyMultiplicator: 100,
  cipLib: "ADRENALINE 1MG/ML REN AB5ML BT 100",
  atcCode: "C01CA24"
}, {
  CIP7: '5523926',
  CIP13: '3400955239260',
  ucdLib: "BETADINE 10% SOL LOC FL500ML",
  UCD7: '9108242',
  UCD13: '3400891082425',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 10% SOL LOC FL500ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '5527025',
  CIP13: '3400955270256',
  ucdLib: "BETNEVAL 0,1% POM TB100G",
  UCD7: '9108319',
  UCD13: '3400891083194',
  ucdQtyMultiplicator: 1,
  cipLib: "BETNEVAL 0,1% POM TB100G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '5653267',
  CIP13: '3400956532674',
  ucdLib: "CALCIUM GL.10% AGT A.B10ML",
  UCD7: '9257031',
  UCD13: '3400892570310',
  ucdQtyMultiplicator: 50,
  cipLib: "CALCIUM GL.10% AGT A.B10ML BT 50",
  atcCode: "A12AA03"
}, {
  CIP7: '5523688',
  CIP13: '3400955236887',
  ucdLib: "DERMACIDE SOL MOUSST FP2000ML",
  UCD7: '9109460',
  UCD13: '3400891094602',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMACIDE SOL MOUSST FP2000ML BT 1",
  atcCode: "D08AX"
}, {
  CIP7: '3422552',
  CIP13: '3400934225529',
  ucdLib: "ELUSANES MARRON INDE GELU",
  UCD7: '9176812',
  UCD13: '3400891768121',
  ucdQtyMultiplicator: 60,
  cipLib: "ELUSANES MARRON INDE GELU BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3422575',
  CIP13: '3400934225758',
  ucdLib: "ELUSANES ORTHOSIPHON GELU",
  UCD7: '9150445',
  UCD13: '3400891504453',
  ucdQtyMultiplicator: 60,
  cipLib: "ELUSANES ORTHOSIPHON GELU BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3422569',
  CIP13: '3400934225697',
  ucdLib: "ELUSANES PASSIF.200MG GELU",
  UCD7: '9120355',
  UCD13: '3400891203554',
  ucdQtyMultiplicator: 60,
  cipLib: "ELUSANES PASSIF.200MG GELU BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '3424628',
  CIP13: '3400934246289',
  ucdLib: "ELUSANES VIGNE ROUGE GELU",
  UCD7: '9127280',
  UCD13: '3400891272802',
  ucdQtyMultiplicator: 60,
  cipLib: "ELUSANES VIGNE ROUGE GELU BT 60",
  atcCode: "V03AX"
}, {
  CIP7: '5761488',
  CIP13: '3400957614881',
  ucdLib: "FLUOROURACILE EBW 50MG FL10ML",
  UCD7: '9340950',
  UCD13: '3400893409503',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUOROURACILE EBW 50MG FL10ML BT 5",
  atcCode: "L01BC02"
}, {
  CIP7: '5761465',
  CIP13: '3400957614652',
  ucdLib: "FLUOROURACILE EBW 50MG FL5ML",
  UCD7: '9340967',
  UCD13: '3400893409671',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUOROURACILE EBW 50MG FL5ML BT 5",
  atcCode: "L01BC02"
}, {
  CIP7: '5761519',
  CIP13: '3400957615192',
  ucdLib: "FLUOROURACILE EBW 50MG OS50ML",
  UCD7: '9341004',
  UCD13: '3400893410042',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE EBW 50MG OS50ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '3421179',
  CIP13: '3400934211799',
  ucdLib: "JOUVENCE ABBE SOURY GEL TB100G",
  UCD7: '9187632',
  UCD13: '3400891876321',
  ucdQtyMultiplicator: 1,
  cipLib: "JOUVENCE ABBE SOURY GEL TB100G BT 1",
  atcCode: "C05CX"
}, {
  CIP7: '5890024',
  CIP13: '3400958900242',
  ucdLib: "LUTATHERA 370MBQ/ML FL30ML",
  UCD7: '9408211',
  UCD13: '3400894082118',
  ucdQtyMultiplicator: 1,
  cipLib: "LUTATHERA 370MBQ/ML FL30ML BT 1",
  atcCode: "V10X"
}, {
  CIP7: '3421481',
  CIP13: '3400934214813',
  ucdLib: "MERCALM CPR PELLIC",
  UCD7: '9104971',
  UCD13: '3400891049718',
  ucdQtyMultiplicator: 15,
  cipLib: "MERCALM CPR PELLIC BT 15",
  atcCode: "A04AD"
}, {
  CIP7: '5651653',
  CIP13: '3400956516537',
  ucdLib: "MIDAZOLAM HAM 5MG/ML AMP10ML",
  UCD7: '9258622',
  UCD13: '3400892586229',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM HAM 5MG/ML AMP10ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5651618',
  CIP13: '3400956516186',
  ucdLib: "MIDAZOLAM HAM 5MG/ML AMP1ML",
  UCD7: '9258616',
  UCD13: '3400892586168',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM HAM 5MG/ML AMP1ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5653787',
  CIP13: '3400956537877',
  ucdLib: "MORPHINE 50MG AP-HP S/C 20ML",
  UCD7: '9260174',
  UCD13: '3400892601748',
  ucdQtyMultiplicator: 5,
  cipLib: "MORPHINE 50MG AP-HP S/C 20ML BT 5",
  atcCode: "N02AA01"
}, {
  CIP7: '3424338',
  CIP13: '3400934243387',
  ucdLib: "OMEZELIS CPR",
  UCD7: '9097165',
  UCD13: '3400890971652',
  ucdQtyMultiplicator: 40,
  cipLib: "OMEZELIS CPR BT 40",
  atcCode: "N05CM"
}, {
  CIP7: '5890017',
  CIP13: '3400958900174',
  ucdLib: "OSPOLOT 200MG CPR",
  UCD7: '9293558',
  UCD13: '3400892935584',
  ucdQtyMultiplicator: 50,
  cipLib: "OSPOLOT 200MG CPR BT 50",
  atcCode: "N03AX03"
}, {
  CIP7: '5653379',
  CIP13: '3400956533794',
  ucdLib: "POTASSIUM 10% LAV AB20ML",
  UCD7: '9261481',
  UCD13: '3400892614816',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 10% LAV AB20ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '5653391',
  CIP13: '3400956533916',
  ucdLib: "POTASSIUM 15% LAV AB20ML",
  UCD7: '9275448',
  UCD13: '3400892754482',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 15% LAV AB20ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '5658572',
  CIP13: '3400956585724',
  ucdLib: "POTASSIUM 7,46% REN AB10ML",
  UCD7: '9277217',
  UCD13: '3400892772172',
  ucdQtyMultiplicator: 100,
  cipLib: "POTASSIUM 7,46% REN AB10ML BT 100",
  atcCode: "B05XA01"
}, {
  CIP7: '5526818',
  CIP13: '3400955268185',
  ucdLib: "PRIMALAN 5MG CPR SECAB",
  UCD7: '9075175',
  UCD13: '3400890751759',
  ucdQtyMultiplicator: 100,
  cipLib: "PRIMALAN 5MG CPR SECAB BT 100",
  atcCode: "R06AD07"
}, {
  CIP7: '5890074',
  CIP13: '3400958900747',
  ucdLib: "QIZENDAY 100MG GELU",
  UCD7: '9418741',
  UCD13: '3400894187417',
  ucdQtyMultiplicator: 90,
  cipLib: "QIZENDAY 100MG GELU BT 90",
  atcCode: "A11HA05"
}, {
  CIP7: '3425409',
  CIP13: '3400934254093',
  ucdLib: "QUADRASA 2G PDR RECT FL4,2G",
  UCD7: '9197984',
  UCD13: '3400891979848',
  ucdQtyMultiplicator: 7,
  cipLib: "QUADRASA 2G PDR RECT FL4,2G BT 7",
  atcCode: "A07EC"
}, {
  CIP7: '3427265',
  CIP13: '3400934272653',
  ucdLib: "QUINIMAX 500MG INJ AMP4ML",
  UCD7: '9198015',
  UCD13: '3400891980158',
  ucdQtyMultiplicator: 3,
  cipLib: "QUINIMAX 500MG INJ AMP4ML BT 3",
  atcCode: "P01BC01"
}, {
  CIP7: '5650932',
  CIP13: '3400956509324',
  ucdLib: "QUIXIL 2ML FL+FL +NEC",
  UCD7: '9262167',
  UCD13: '3400892621678',
  ucdQtyMultiplicator: 1,
  cipLib: "QUIXIL 2ML FL+FL +NEC BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5650949',
  CIP13: '3400956509492',
  ucdLib: "QUIXIL 5ML FL+FL +NEC",
  UCD7: '9262173',
  UCD13: '3400892621739',
  ucdQtyMultiplicator: 1,
  cipLib: "QUIXIL 5ML FL+FL +NEC BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5659815',
  CIP13: '3400956598151',
  ucdLib: "SCOPOLAMINE REN 0,025% A1ML",
  UCD7: '9284602',
  UCD13: '3400892846026',
  ucdQtyMultiplicator: 100,
  cipLib: "SCOPOLAMINE REN 0,025% A1ML BT 100",
  atcCode: "R07A"
}, {
  CIP7: '5654746',
  CIP13: '3400956547463',
  ucdLib: "SODIUM 0,9% CPF INJ AB5ML",
  UCD7: '9281851',
  UCD13: '3400892818511',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% CPF INJ AB5ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5653497',
  CIP13: '3400956534975',
  ucdLib: "SODIUM 10% LAV INJ AB20ML",
  UCD7: '9261564',
  UCD13: '3400892615646',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 10% LAV INJ AB20ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '5525641',
  CIP13: '3400955256410',
  ucdLib: "SODIUM BIC 4,2% AGT AV10ML",
  UCD7: '9016356',
  UCD13: '3400890163569',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM BIC 4,2% AGT AV10ML BT 100",
  atcCode: "B05XA02"
}, {
  CIP7: '5657199',
  CIP13: '3400956571994',
  ucdLib: "SPORANOX 10MG/ML INJ AMP+POC",
  UCD7: '9263267',
  UCD13: '3400892632674',
  ucdQtyMultiplicator: 1,
  cipLib: "SPORANOX 10MG/ML INJ AMP+POC BT 1",
  atcCode: "J02AC02"
}, {
  CIP7: '5528674',
  CIP13: '3400955286745',
  ucdLib: "THALLIUM 201 MLK 63-370MBQ FL",
  UCD7: '9118200',
  UCD13: '3400891182002',
  ucdQtyMultiplicator: 1,
  cipLib: "THALLIUM 201 MLK 63-370MBQ FL BT 1",
  atcCode: "V09GX01"
}, {
  CIP7: '5654628',
  CIP13: '3400956546282',
  ucdLib: "VIT C AGT 10% INJ A.B5ML",
  UCD7: '9260607',
  UCD13: '3400892606071',
  ucdQtyMultiplicator: 10,
  cipLib: "VIT C AGT 10% INJ A.B5ML BT 10",
  atcCode: "A11GA01"
}, {
  CIP7: '3007146',
  CIP13: '3400930071465',
  ucdLib: "MYSILDECARD 20MG CPR",
  UCD7: '9420399',
  UCD13: '3400894203995',
  ucdQtyMultiplicator: 90,
  cipLib: "MYSILDECARD 20 mg Cpr pell Plq/90x1",
  atcCode: ""
}, {
  CIP7: '5857627',
  CIP13: '3400958576270',
  ucdLib: "XOFIGO 1100KBQ/ML INJ FL6ML",
  UCD7: '9397542',
  UCD13: '3400893975428',
  ucdQtyMultiplicator: 1,
  cipLib: "XOFIGO 1100KBQ/ML INJ FL6ML BT 1",
  atcCode: "V10XX03"
}, {
  CIP7: '5649320',
  CIP13: '3400956493203',
  ucdLib: "ZEVALIN 1,6MG/ML TROUS",
  UCD7: '9258504',
  UCD13: '3400892585048',
  ucdQtyMultiplicator: 1,
  cipLib: "ZEVALIN 1,6MG/ML TROUS BT 1",
  atcCode: "V10XX02"
}, {
  CIP7: '5559864',
  CIP13: '3400955598640',
  ucdLib: "IOBENGUANE CIS 9,25MBQ/ML FL",
  UCD7: '9165435',
  UCD13: '3400891654356',
  ucdQtyMultiplicator: 1,
  cipLib: "IOBENGUANE CIS 9,25MBQ/ML FL BT 1",
  atcCode: "V10XA02"
}, {
  CIP7: '5599881',
  CIP13: '3400955998815',
  ucdLib: "IOBENGUANE CIS MIBG-131-T FL",
  UCD7: '9317046',
  UCD13: '3400893170465',
  ucdQtyMultiplicator: 1,
  cipLib: "IOBENGUANE CIS MIBG-131-T FL BT 1",
  atcCode: "V10XA02"
}, {
  CIP7: '5609987',
  CIP13: '3400956099870',
  ucdLib: "CAPSION GELU",
  UCD7: '9209262',
  UCD13: '3400892092621',
  ucdQtyMultiplicator: 1,
  cipLib: "CAPSION GELU BT 1",
  atcCode: "V10XA01"
}, {
  CIP7: '5612280',
  CIP13: '3400956122806',
  ucdLib: "SODIUM IODURE MLK GELU",
  UCD7: '9220358',
  UCD13: '3400892203584',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IODURE MLK GELU BT 1",
  atcCode: "V10XA01"
}, {
  CIP7: '5714951',
  CIP13: '3400957149512',
  ucdLib: "THERACAP 131 GELU",
  UCD7: '9350210',
  UCD13: '3400893502105',
  ucdQtyMultiplicator: 1,
  cipLib: "THERACAP 131 GELU BT 1",
  atcCode: "V10XA01"
}, {
  CIP7: '5609869',
  CIP13: '3400956098699',
  ucdLib: "QUADRAMET 1,3GBQ/ML FL",
  UCD7: '9202018',
  UCD13: '3400892020181',
  ucdQtyMultiplicator: 1,
  cipLib: "QUADRAMET 1,3GBQ/ML FL BT 1",
  atcCode: "V10BX02"
}, {
  CIP7: '5580120',
  CIP13: '3400955801207',
  ucdLib: "METASTRON INJ FL4ML",
  UCD7: '9160490',
  UCD13: '3400891604900',
  ucdQtyMultiplicator: 1,
  cipLib: "METASTRON INJ FL4ML BT 1",
  atcCode: "V10BX01"
}, {
  CIP7: '5545974',
  CIP13: '3400955459743',
  ucdLib: "RHENIUM 186RE CIS INJ FL",
  UCD7: '9165493',
  UCD13: '3400891654936',
  ucdQtyMultiplicator: 1,
  cipLib: "RHENIUM 186RE CIS INJ FL BT 1",
  atcCode: "V10AX05"
}, {
  CIP7: '5612191',
  CIP13: '3400956121915',
  ucdLib: "ERBIUM CIS 111MBQ/ML INJ FL",
  UCD7: '9209747',
  UCD13: '3400892097473',
  ucdQtyMultiplicator: 1,
  cipLib: "ERBIUM CIS 111MBQ/ML INJ FL BT 1",
  atcCode: "V10AX04"
}, {
  CIP7: '5599674',
  CIP13: '3400955996743',
  ucdLib: "YTTRIUM CIS INJ LOC FL",
  UCD7: '9200114',
  UCD13: '3400892001142',
  ucdQtyMultiplicator: 1,
  cipLib: "YTTRIUM CIS INJ LOC FL BT 1",
  atcCode: "V10AA01"
}, {
  CIP7: '5644529',
  CIP13: '3400956445295',
  ucdLib: "NORCHOLEST.CIS NORCHOL-131 FL",
  UCD7: '9317052',
  UCD13: '3400893170526',
  ucdQtyMultiplicator: 1,
  cipLib: "NORCHOLEST.CIS NORCHOL-131 FL BT 1",
  atcCode: "V09XA01"
}, {
  CIP7: '5782533',
  CIP13: '3400957825331',
  ucdLib: "IASOCHOLINE 1GBQ/ML INJ FL15ML",
  UCD7: '9375411',
  UCD13: '3400893754115',
  ucdQtyMultiplicator: 1,
  cipLib: "IASOCHOLINE 1GBQ/ML INJ FL15ML BT 1",
  atcCode: "V09IX07"
}, {
  CIP7: '5769461',
  CIP13: '3400957694616',
  ucdLib: "IASOCHOLINE 1GBQ/ML INJ FL25ML",
  UCD7: '9352203',
  UCD13: '3400893522035',
  ucdQtyMultiplicator: 1,
  cipLib: "IASOCHOLINE 1GBQ/ML INJ FL25ML BT 1",
  atcCode: "V09IX07"
}, {
  CIP7: '5773184',
  CIP13: '3400957731847',
  ucdLib: "CISNAF 100MBQ/ML INJ FL",
  UCD7: '9360160',
  UCD13: '3400893601600',
  ucdQtyMultiplicator: 1,
  cipLib: "CISNAF 100MBQ/ML INJ FL BT 1",
  atcCode: "V09IX06"
}, {
  CIP7: '5784265',
  CIP13: '3400957842659',
  ucdLib: "IASOFLU 2GBQ/ML INJ FL15ML",
  UCD7: '9375434',
  UCD13: '3400893754344',
  ucdQtyMultiplicator: 1,
  cipLib: "IASOFLU 2GBQ/ML INJ FL15ML BT 1",
  atcCode: "V09IX06"
}, {
  CIP7: '5732280',
  CIP13: '3400957322809',
  ucdLib: "IASOFLU 2GBQ/ML INJ FL25ML",
  UCD7: '9320924',
  UCD13: '3400893209240',
  ucdQtyMultiplicator: 1,
  cipLib: "IASOFLU 2GBQ/ML INJ FL25ML BT 1",
  atcCode: "V09IX06"
}, {
  CIP7: '5501036',
  CIP13: '3400955010364',
  ucdLib: "DOPAVIEW 222MBQ/ML INJ FL15ML",
  UCD7: '9416185',
  UCD13: '3400894161851',
  ucdQtyMultiplicator: 1,
  cipLib: "DOPAVIEW 222MBQ/ML INJ FL15ML BT 1",
  atcCode: "V09IX05"
}, {
  CIP7: '5782562',
  CIP13: '3400957825621',
  ucdLib: "IASODOPA 0,3GBQ/ML INJ FL15ML",
  UCD7: '9375428',
  UCD13: '3400893754283',
  ucdQtyMultiplicator: 1,
  cipLib: "IASODOPA 0,3GBQ/ML INJ FL15ML BT 1",
  atcCode: "V09IX05"
}, {
  CIP7: '5668978',
  CIP13: '3400956689781',
  ucdLib: "IASODOPA 0,3GBQ/ML INJ FL25ML",
  UCD7: '9297496',
  UCD13: '3400892974965',
  ucdQtyMultiplicator: 1,
  cipLib: "IASODOPA 0,3GBQ/ML INJ FL25ML BT 1",
  atcCode: "V09IX05"
}, {
  CIP7: '5768763',
  CIP13: '3400957687632',
  ucdLib: "DOPACIS 90MBQ/ML INJ FL10ML",
  UCD7: '9354314',
  UCD13: '3400893543146',
  ucdQtyMultiplicator: 1,
  cipLib: "DOPACIS 90MBQ/ML INJ FL10ML BT 1",
  atcCode: "V09IX05"
}, {
  CIP7: '5644423',
  CIP13: '3400956444236',
  ucdLib: "FLUDESOXYGLUCOSE-IBA INJ FL",
  UCD7: '9251212',
  UCD13: '3400892512129',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUDESOXYGLUCOSE-IBA INJ FL BT 1",
  atcCode: "V09IX04"
}, {
  CIP7: '5644618',
  CIP13: '3400956446186',
  ucdLib: "GLUSCAN 600MBQ/ML INJ FL",
  UCD7: '9280076',
  UCD13: '3400892800769',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUSCAN 600MBQ/ML INJ FL BT 1",
  atcCode: "V09IX04"
}, {
  CIP7: '5749613',
  CIP13: '3400957496135',
  ucdLib: "FLUCIS 250MBQ/ML INJ FL M-DOS",
  UCD7: '9345077',
  UCD13: '3400893450772',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCIS 250MBQ/ML INJ FL M-DOS BT 1",
  atcCode: "V09IX04"
}, {
  CIP7: '5752437',
  CIP13: '3400957524371',
  ucdLib: "GLUCOTEP INJ FL.MULTI",
  UCD7: '9343144',
  UCD13: '3400893431443',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOTEP INJ FL.MULTI BT 1",
  atcCode: "V09IX04"
}, {
  CIP7: '5644593',
  CIP13: '3400956445936',
  ucdLib: "ADREVIEW 74MBQ/ML INJ FL",
  UCD7: '9279989',
  UCD13: '3400892799896',
  ucdQtyMultiplicator: 1,
  cipLib: "ADREVIEW 74MBQ/ML INJ FL BT 1",
  atcCode: "V09IX01"
}, {
  CIP7: '5586772',
  CIP13: '3400955867722',
  ucdLib: "OCTREOSCAN INJ FL+FL",
  UCD7: '9177183',
  UCD13: '3400891771831',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTREOSCAN INJ FL+FL BT 1",
  atcCode: "V09IB01"
}, {
  CIP7: '5546028',
  CIP13: '3400955460282',
  ucdLib: "GALLIUM 67 CIS 74MBQ INJ FL",
  UCD7: '9165234',
  UCD13: '3400891652345',
  ucdQtyMultiplicator: 1,
  cipLib: "GALLIUM 67 CIS 74MBQ INJ FL BT 1",
  atcCode: "V09HX01"
}, {
  CIP7: '5609906',
  CIP13: '3400956099061',
  ucdLib: "GALLIUM 67 CITR MLK INJ FL",
  UCD7: '9209960',
  UCD13: '3400892099606',
  ucdQtyMultiplicator: 1,
  cipLib: "GALLIUM 67 CITR MLK INJ FL BT 1",
  atcCode: "V09HX01"
}, {
  CIP7: '5548429',
  CIP13: '3400955484295',
  ucdLib: "INDIUM OXIN.MLK 37MBQ FL+TAMP",
  UCD7: '9123112',
  UCD13: '3400891231120',
  ucdQtyMultiplicator: 1,
  cipLib: "INDIUM OXIN.MLK 37MBQ FL+TAMP BT 1",
  atcCode: "V09HB01"
}, {
  CIP7: '5769136',
  CIP13: '3400957691363',
  ucdLib: "SCINTIMUN 1MG TROUSS FL+FL",
  UCD7: '9354030',
  UCD13: '3400893540305',
  ucdQtyMultiplicator: 1,
  cipLib: "SCINTIMUN 1MG TROUSS FL+FL BT 1",
  atcCode: "V09HA03"
}, {
  CIP7: '5769142',
  CIP13: '3400957691424',
  ucdLib: "SCINTIMUN 1MG TROUSS FL+FL",
  UCD7: '9354030',
  UCD13: '3400893540305',
  ucdQtyMultiplicator: 2,
  cipLib: "SCINTIMUN 1MG TROUSS FL+FL BT 2",
  atcCode: "V09HA03"
}, {
  CIP7: '5561795',
  CIP13: '3400955617952',
  ucdLib: "CERETEC 500MCG INJ FL",
  UCD7: '9141044',
  UCD13: '3400891410440',
  ucdQtyMultiplicator: 5,
  cipLib: "CERETEC 500MCG INJ FL BT 5",
  atcCode: "V09HA02"
}, {
  CIP7: '5599728',
  CIP13: '3400955997283',
  ucdLib: "CHROMATE AMH 37-185MBQ FL",
  UCD7: '9198044',
  UCD13: '3400891980448',
  ucdQtyMultiplicator: 1,
  cipLib: "CHROMATE AMH 37-185MBQ FL BT 1",
  atcCode: "V09GX03"
}, {
  CIP7: '5565497',
  CIP13: '3400955654971',
  ucdLib: "THALLIUM 201 CIS TL201S1 FL",
  UCD7: '9165547',
  UCD13: '3400891655476',
  ucdQtyMultiplicator: 1,
  cipLib: "THALLIUM 201 CIS TL201S1 FL BT 1",
  atcCode: "V09GX01"
}, {
  CIP7: '5644452',
  CIP13: '3400956444526',
  ucdLib: "ALBUMINE H. IOD CIS INJ FL",
  UCD7: '9317017',
  UCD13: '3400893170175',
  ucdQtyMultiplicator: 4,
  cipLib: "ALBUMINE H. IOD CIS INJ FL BT 4",
  atcCode: "V09GB02"
}, {
  CIP7: '5612245',
  CIP13: '3400956122455',
  ucdLib: "ANGIOCIS TROUS FL",
  UCD7: '9279995',
  UCD13: '3400892799957',
  ucdQtyMultiplicator: 5,
  cipLib: "ANGIOCIS TROUS FL BT 5",
  atcCode: "V09GA06"
}, {
  CIP7: '5609881',
  CIP13: '3400956098811',
  ucdLib: "VASCULOCIS 10MG TROUS FL",
  UCD7: '9257893',
  UCD13: '3400892578934',
  ucdQtyMultiplicator: 5,
  cipLib: "VASCULOCIS 10MG TROUS FL BT 5",
  atcCode: "V09GA04"
}, {
  CIP7: '5644498',
  CIP13: '3400956444984',
  ucdLib: "MYOVIEW 230MCG TROUS FL",
  UCD7: '9169290',
  UCD13: '3400891692907',
  ucdQtyMultiplicator: 5,
  cipLib: "MYOVIEW 230MCG TROUS FL BT 5",
  atcCode: "V09GA02"
}, {
  CIP7: '5571026',
  CIP13: '3400955710264',
  ucdLib: "CARDIOLITE TROUS FV5ML",
  UCD7: '9148678',
  UCD13: '3400891486780',
  ucdQtyMultiplicator: 5,
  cipLib: "CARDIOLITE TROUS FV5ML BT 5",
  atcCode: "V09GA01"
}, {
  CIP7: '5752466',
  CIP13: '3400957524661',
  ucdLib: "CARDIOMIBI 1MG TROUS FL",
  UCD7: '9343345',
  UCD13: '3400893433454',
  ucdQtyMultiplicator: 6,
  cipLib: "CARDIOMIBI 1MG TROUS FL BT 6",
  atcCode: "V09GA01"
}, {
  CIP7: '5755430',
  CIP13: '3400957554309',
  ucdLib: "MIBITEC TROUS INJ FL",
  UCD7: '9348992',
  UCD13: '3400893489925',
  ucdQtyMultiplicator: 2,
  cipLib: "MIBITEC TROUS INJ FL BT 2",
  atcCode: "V09GA01"
}, {
  CIP7: '5755447',
  CIP13: '3400957554477',
  ucdLib: "MIBITEC TROUS INJ FL",
  UCD7: '9348992',
  UCD13: '3400893489925',
  ucdQtyMultiplicator: 5,
  cipLib: "MIBITEC TROUS INJ FL BT 5",
  atcCode: "V09GA01"
}, {
  CIP7: '5727712',
  CIP13: '3400957277123',
  ucdLib: "STAMICIS 1MG TROUS FL",
  UCD7: '9318844',
  UCD13: '3400893188446',
  ucdQtyMultiplicator: 5,
  cipLib: "STAMICIS 1MG TROUS FL BT 5",
  atcCode: "V09GA01"
}, {
  CIP7: '5545879',
  CIP13: '3400955458791',
  ucdLib: "SODIUM IOD.CIS 1110MBQ/ML FL",
  UCD7: '9165375',
  UCD13: '3400891653755',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.CIS 1110MBQ/ML FL BT 1",
  atcCode: "V09FX03"
}, {
  CIP7: '5545891',
  CIP13: '3400955458913',
  ucdLib: "SODIUM IOD.CIS I131S2 INJ FL",
  UCD7: '9165381',
  UCD13: '3400891653816',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.CIS I131S2 INJ FL BT 1",
  atcCode: "V09FX03"
}, {
  CIP7: '5736059',
  CIP13: '3400957360597',
  ucdLib: "SODIUM IOD.MLK 131I 185MBQ FL",
  UCD7: '9326163',
  UCD13: '3400893261637',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.MLK 131I 185MBQ FL BT 1",
  atcCode: "V09FX03"
}, {
  CIP7: '5736065',
  CIP13: '3400957360658',
  ucdLib: "SODIUM IOD.MLK 131I 370MBQ FL",
  UCD7: '9326192',
  UCD13: '3400893261927',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.MLK 131I 370MBQ FL BT 1",
  atcCode: "V09FX03"
}, {
  CIP7: '5732788',
  CIP13: '3400957327880',
  ucdLib: "SODIUM IOD.MLK 131I 37MBQ FL",
  UCD7: '9326186',
  UCD13: '3400893261866',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.MLK 131I 37MBQ FL BT 1",
  atcCode: "V09FX03"
}, {
  CIP7: '5545750',
  CIP13: '3400955457503',
  ucdLib: "SODIUM IOD.CIS I123S1 INJ FL",
  UCD7: '9165300',
  UCD13: '3400891653007',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.CIS I123S1 INJ FL BT 1",
  atcCode: "V09FX02"
}, {
  CIP7: '5545744',
  CIP13: '3400955457442',
  ucdLib: "SODIUM IOD.CIS I123S2 INJ FL 1",
  UCD7: '9165317',
  UCD13: '3400891653175',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.CIS I123S2 INJ FL 1 BT 1",
  atcCode: "V09FX02"
}, {
  CIP7: '5565511',
  CIP13: '3400955655114',
  ucdLib: "SODIUM IOD.MLK 123I 37MBQ FL",
  UCD7: '9140820',
  UCD13: '3400891408201',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.MLK 123I 37MBQ FL BT 1",
  atcCode: "V09FX02"
}, {
  CIP7: '5742864',
  CIP13: '3400957428648',
  ucdLib: "SODIUM IOD.GEH 123I 37MBQ FL",
  UCD7: '9360869',
  UCD13: '3400893608692',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM IOD.GEH 123I 37MBQ FL BT 1",
  atcCode: "V09FX02"
}, {
  CIP7: '5541769',
  CIP13: '3400955417699',
  ucdLib: "ULTRA TECHNEKOW FM GENER",
  UCD7: '9123158',
  UCD13: '3400891231588',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRA TECHNEKOW FM GENER BT 1",
  atcCode: "V09FX01"
}, {
  CIP7: '5609800',
  CIP13: '3400956098002',
  ucdLib: "TECEOS TROUS FL",
  UCD7: '9208050',
  UCD13: '3400892080505',
  ucdQtyMultiplicator: 5,
  cipLib: "TECEOS TROUS FL BT 5",
  atcCode: "V09FX01"
}, {
  CIP7: '5525948',
  CIP13: '3400955259480',
  ucdLib: "ELUMATIC III 2-20 GBQ GENER",
  UCD7: '9165151',
  UCD13: '3400891651515',
  ucdQtyMultiplicator: 1,
  cipLib: "ELUMATIC III 2-20 GBQ GENER BT 1",
  atcCode: "V09FX01"
}, {
  CIP7: '5599680',
  CIP13: '3400955996804',
  ucdLib: "KRYPTOSCAN GENER",
  UCD7: '9186940',
  UCD13: '3400891869408',
  ucdQtyMultiplicator: 1,
  cipLib: "KRYPTOSCAN GENER BT 1",
  atcCode: "V09EX01"
}, {
  CIP7: '5599792',
  CIP13: '3400955997924',
  ucdLib: "PULMOCIS 2MG TROUS FL",
  UCD7: '9200887',
  UCD13: '3400892008875',
  ucdQtyMultiplicator: 5,
  cipLib: "PULMOCIS 2MG TROUS FL BT 5",
  atcCode: "V09EB01"
}, {
  CIP7: '5623591',
  CIP13: '3400956235919',
  ucdLib: "TECHNESCAN LYOMAA INJ FL",
  UCD7: '9224617',
  UCD13: '3400892246178',
  ucdQtyMultiplicator: 5,
  cipLib: "TECHNESCAN LYOMAA INJ FL BT 5",
  atcCode: "V09EB01"
}, {
  CIP7: '5599734',
  CIP13: '3400955997344',
  ucdLib: "PULMOTEC CREUSET GRAPHITE",
  UCD7: '9214607',
  UCD13: '3400892146072',
  ucdQtyMultiplicator: 50,
  cipLib: "PULMOTEC CREUSET GRAPHITE BT 50",
  atcCode: "V09EA02"
}, {
  CIP7: '5609929',
  CIP13: '3400956099290',
  ucdLib: "TECHNESCAN DTPA INJ FL",
  UCD7: '9209983',
  UCD13: '3400892099835',
  ucdQtyMultiplicator: 5,
  cipLib: "TECHNESCAN DTPA INJ FL BT 5",
  atcCode: "V09EA01"
}, {
  CIP7: '5530429',
  CIP13: '3400955304296',
  ucdLib: "PHYTACIS TROUS FL",
  UCD7: '9165487',
  UCD13: '3400891654875',
  ucdQtyMultiplicator: 5,
  cipLib: "PHYTACIS TROUS FL BT 5",
  atcCode: "V09DB07"
}, {
  CIP7: '5530808',
  CIP13: '3400955308089',
  ucdLib: "NANOCIS TROUS FL+FL",
  UCD7: '9165139',
  UCD13: '3400891651393',
  ucdQtyMultiplicator: 5,
  cipLib: "NANOCIS TROUS FL+FL BT 5",
  atcCode: "V09DB06"
}, {
  CIP7: '5623214',
  CIP13: '3400956232147',
  ucdLib: "HEPATATE TROUS INJ FL",
  UCD7: '9256623',
  UCD13: '3400892566238',
  ucdQtyMultiplicator: 5,
  cipLib: "HEPATATE TROUS INJ FL BT 5",
  atcCode: "V09DB04"
}, {
  CIP7: '5591282',
  CIP13: '3400955912828',
  ucdLib: "NANOCOLL INJ FL",
  UCD7: '9185975',
  UCD13: '3400891859751',
  ucdQtyMultiplicator: 5,
  cipLib: "NANOCOLL INJ FL BT 5",
  atcCode: "V09DB01"
}, {
  CIP7: '5599800',
  CIP13: '3400955998006',
  ucdLib: "CHROME-51 EDTA AMH INJ FL",
  UCD7: '9199664',
  UCD13: '3400891996647',
  ucdQtyMultiplicator: 1,
  cipLib: "CHROME-51 EDTA AMH INJ FL BT 1",
  atcCode: "V09CX04"
}, {
  CIP7: '5781769',
  CIP13: '3400957817695',
  ucdLib: "EDICIS 2MG TROUS FL",
  UCD7: '9371695',
  UCD13: '3400893716953',
  ucdQtyMultiplicator: 4,
  cipLib: "EDICIS 2MG TROUS FL BT 4",
  atcCode: "V09CA06"
}, {
  CIP7: '5569331',
  CIP13: '3400955693314',
  ucdLib: "TECHNESCAN MAG 3 FL10ML",
  UCD7: '9147153',
  UCD13: '3400891471533',
  ucdQtyMultiplicator: 5,
  cipLib: "TECHNESCAN MAG 3 FL10ML BT 5",
  atcCode: "V09CA03"
}, {
  CIP7: '5668961',
  CIP13: '3400956689613',
  ucdLib: "NEPHROMAG 0,2MG TROUS FL10ML",
  UCD7: '9307473',
  UCD13: '3400893074732',
  ucdQtyMultiplicator: 5,
  cipLib: "NEPHROMAG 0,2MG TROUS FL10ML BT 5",
  atcCode: "V09CA03"
}, {
  CIP7: '5623556',
  CIP13: '3400956235568',
  ucdLib: "RENOCIS TROUS FL",
  UCD7: '9303914',
  UCD13: '3400893039144',
  ucdQtyMultiplicator: 5,
  cipLib: "RENOCIS TROUS FL BT 5",
  atcCode: "V09CA02"
}, {
  CIP7: '5644587',
  CIP13: '3400956445875',
  ucdLib: "TECHNESCAN DMSA INJ FL",
  UCD7: '9293334',
  UCD13: '3400892933344',
  ucdQtyMultiplicator: 5,
  cipLib: "TECHNESCAN DMSA INJ FL BT 5",
  atcCode: "V09CA02"
}, {
  CIP7: '5565468',
  CIP13: '3400955654681',
  ucdLib: "TECHNESCAN PYP INJ FL",
  UCD7: '9136592',
  UCD13: '3400891365924',
  ucdQtyMultiplicator: 5,
  cipLib: "TECHNESCAN PYP INJ FL BT 5",
  atcCode: "V09BA03"
}, {
  CIP7: '5542125',
  CIP13: '3400955421252',
  ucdLib: "OSTEOCIS 3MG TROUS FL",
  UCD7: '9165263',
  UCD13: '3400891652635',
  ucdQtyMultiplicator: 5,
  cipLib: "OSTEOCIS 3MG TROUS FL BT 5",
  atcCode: "V09BA01"
}, {
  CIP7: '5589747',
  CIP13: '3400955897477',
  ucdLib: "TECHNESCAN HDP INJ FL10ML",
  UCD7: '9172990',
  UCD13: '3400891729900',
  ucdQtyMultiplicator: 5,
  cipLib: "TECHNESCAN HDP INJ FL10ML BT 5",
  atcCode: "V09BA01"
}, {
  CIP7: '5868252',
  CIP13: '3400958682520',
  ucdLib: "NEURACEQ 300MBQ/ML INJ FL",
  UCD7: '9405520',
  UCD13: '3400894055204',
  ucdQtyMultiplicator: 1,
  cipLib: "NEURACEQ 300MBQ/ML INJ FL BT 1",
  atcCode: "V09AX06"
}, {
  CIP7: '5623421',
  CIP13: '3400956234219',
  ucdLib: "INDIUM PENT.MLK INJ FL10ML",
  UCD7: '9329150',
  UCD13: '3400893291504',
  ucdQtyMultiplicator: 1,
  cipLib: "INDIUM PENT.MLK INJ FL10ML BT 1",
  atcCode: "V09AX01"
}, {
  CIP7: '5623622',
  CIP13: '3400956236220',
  ucdLib: "DATSCAN 74MBQ/ML INJ FL2,5ML",
  UCD7: '9227805',
  UCD13: '3400892278056',
  ucdQtyMultiplicator: 1,
  cipLib: "DATSCAN 74MBQ/ML INJ FL2,5ML BT 1",
  atcCode: "V09AB03"
}, {
  CIP7: '5583756',
  CIP13: '3400955837565',
  ucdLib: "NEUROLITE TROUS FL+FL",
  UCD7: '9168043',
  UCD13: '3400891680430',
  ucdQtyMultiplicator: 1,
  cipLib: "NEUROLITE TROUS FL+FL BT 1",
  atcCode: "V09AA02"
}, {
  CIP7: '5623579',
  CIP13: '3400956235797',
  ucdLib: "CERESTAB 500MCG INJ FL",
  UCD7: '9224416',
  UCD13: '3400892244167',
  ucdQtyMultiplicator: 2,
  cipLib: "CERESTAB 500MCG INJ FL BT 2",
  atcCode: "V09AA01"
}, {
  CIP7: '3575646',
  CIP13: '3400935756466',
  ucdLib: "SONOVUE 8MCL/ML INJ FL+SRG+SYS",
  UCD7: '9243000',
  UCD13: '3400892430003',
  ucdQtyMultiplicator: 1,
  cipLib: "SONOVUE 8MCL/ML INJ FL+SRG+SYS BT 1",
  atcCode: "V08DA05"
}, {
  CIP7: '3608038',
  CIP13: '3400936080386',
  ucdLib: "GADOVIST 1MMOL INJ SRG15ML",
  UCD7: '9299124',
  UCD13: '3400892991245',
  ucdQtyMultiplicator: 1,
  cipLib: "GADOVIST 1MMOL INJ SRG15ML BT 1",
  atcCode: "V08CA09"
}, {
  CIP7: '3701424',
  CIP13: '3400937014243',
  ucdLib: "GADOVIST 1MMOL INJ SRG7,5ML",
  UCD7: '9299130',
  UCD13: '3400892991306',
  ucdQtyMultiplicator: 1,
  cipLib: "GADOVIST 1MMOL INJ SRG7,5ML BT 1",
  atcCode: "V08CA09"
}, {
  CIP7: '5645718',
  CIP13: '3400956457182',
  ucdLib: "GADOVIST 1MMOL INJ SRG15ML",
  UCD7: '9299124',
  UCD13: '3400892991245',
  ucdQtyMultiplicator: 5,
  cipLib: "GADOVIST 1MMOL INJ SRG15ML BT 5",
  atcCode: "V08CA09"
}, {
  CIP7: '2790816',
  CIP13: '3400927908163',
  ucdLib: "GADOVIST 1MMOL INJ FV2ML",
  UCD7: '9412170',
  UCD13: '3400894121701',
  ucdQtyMultiplicator: 1,
  cipLib: "GADOVIST 1MMOL INJ FV2ML BT 1",
  atcCode: "V08CA09"
}, {
  CIP7: '5671762',
  CIP13: '3400956717620',
  ucdLib: "GADOVIST 1MMOL INJ SRG7,5ML",
  UCD7: '9299130',
  UCD13: '3400892991306',
  ucdQtyMultiplicator: 5,
  cipLib: "GADOVIST 1MMOL INJ SRG7,5ML BT 5",
  atcCode: "V08CA09"
}, {
  CIP7: '3474129',
  CIP13: '3400934741296',
  ucdLib: "MULTIHANCE 0,5MMOL INJ FV10ML1",
  UCD7: '9208682',
  UCD13: '3400892086828',
  ucdQtyMultiplicator: 1,
  cipLib: "MULTIHANCE 0,5MMOL INJ FV10ML1 BT 1",
  atcCode: "V08CA08"
}, {
  CIP7: '3474135',
  CIP13: '3400934741357',
  ucdLib: "MULTIHANCE 0,5MMOL INJ FV15ML1",
  UCD7: '9208699',
  UCD13: '3400892086996',
  ucdQtyMultiplicator: 1,
  cipLib: "MULTIHANCE 0,5MMOL INJ FV15ML1 BT 1",
  atcCode: "V08CA08"
}, {
  CIP7: '3474141',
  CIP13: '3400934741418',
  ucdLib: "MULTIHANCE 0,5MMOL INJ FV20ML",
  UCD7: '9234314',
  UCD13: '3400892343143',
  ucdQtyMultiplicator: 1,
  cipLib: "MULTIHANCE 0,5MMOL INJ FV20ML BT 1",
  atcCode: "V08CA08"
}, {
  CIP7: '3474112',
  CIP13: '3400934741128',
  ucdLib: "MULTIHANCE 0,5MMOL INJ FV5ML 1",
  UCD7: '9208707',
  UCD13: '3400892087078',
  ucdQtyMultiplicator: 1,
  cipLib: "MULTIHANCE 0,5MMOL INJ FV5ML 1 BT 1",
  atcCode: "V08CA08"
}, {
  CIP7: '3887966',
  CIP13: '3400938879667',
  ucdLib: "MULTIHANCE 0,5MMOL INJ S.10ML",
  UCD7: '9322521',
  UCD13: '3400893225219',
  ucdQtyMultiplicator: 1,
  cipLib: "MULTIHANCE 0,5MMOL INJ S.10ML BT 1",
  atcCode: "V08CA08"
}, {
  CIP7: '3887972',
  CIP13: '3400938879728',
  ucdLib: "MULTIHANCE 0,5MMOL INJ S.15ML",
  UCD7: '9322538',
  UCD13: '3400893225387',
  ucdQtyMultiplicator: 1,
  cipLib: "MULTIHANCE 0,5MMOL INJ S.15ML BT 1",
  atcCode: "V08CA08"
}, {
  CIP7: '3887989',
  CIP13: '3400938879896',
  ucdLib: "MULTIHANCE 0,5MMOL INJ S.20ML",
  UCD7: '9322544',
  UCD13: '3400893225448',
  ucdQtyMultiplicator: 1,
  cipLib: "MULTIHANCE 0,5MMOL INJ S.20ML BT 1",
  atcCode: "V08CA08"
}, {
  CIP7: '3001186',
  CIP13: '3400930011867',
  ucdLib: "PROHANCE 4748,1MG/17ML S.+NEC",
  UCD7: '9411153',
  UCD13: '3400894111535',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 4748,1MG/17ML S.+NEC BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '3001188',
  CIP13: '3400930011881',
  ucdLib: "PROHANCE 4748,1MG/17ML S.+NIA",
  UCD7: '9411147',
  UCD13: '3400894111474',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 4748,1MG/17ML S.+NIA BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '3378503',
  CIP13: '3400933785031',
  ucdLib: "PROHANCE 1396,5MG/5ML INJ FL",
  UCD7: '9190640',
  UCD13: '3400891906400',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 1396,5MG/5ML INJ FL BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '3378526',
  CIP13: '3400933785260',
  ucdLib: "PROHANCE 2793MG/10ML INJ FL",
  UCD7: '9190657',
  UCD13: '3400891906578',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 2793MG/10ML INJ FL BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '3378532',
  CIP13: '3400933785321',
  ucdLib: "PROHANCE 4189,5MG/15ML INJ FL",
  UCD7: '9190663',
  UCD13: '3400891906639',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 4189,5MG/15ML INJ FL BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '3378549',
  CIP13: '3400933785499',
  ucdLib: "PROHANCE 5586MG/20ML INJ FL",
  UCD7: '9190686',
  UCD13: '3400891906868',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 5586MG/20ML INJ FL BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '3508271',
  CIP13: '3400935082718',
  ucdLib: "PROHANCE 2793MG/10ML INJ SRG",
  UCD7: '9216701',
  UCD13: '3400892167015',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 2793MG/10ML INJ SRG BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '3508288',
  CIP13: '3400935082886',
  ucdLib: "PROHANCE 4189,5MG/15ML INJ S.",
  UCD7: '9216718',
  UCD13: '3400892167183',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 4189,5MG/15ML INJ S. BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '3508294',
  CIP13: '3400935082947',
  ucdLib: "PROHANCE 4748,1MG/17ML INJ S.",
  UCD7: '9216724',
  UCD13: '3400892167244',
  ucdQtyMultiplicator: 1,
  cipLib: "PROHANCE 4748,1MG/17ML INJ S. BT 1",
  atcCode: "V08CA04"
}, {
  CIP7: '2769414',
  CIP13: '3400927694141',
  ucdLib: "OMNISCAN 0,5MMOL PCO15ML +N",
  UCD7: '9398228',
  UCD13: '3400893982280',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNISCAN 0,5MMOL PCO15ML +N BT 1",
  atcCode: "V08CA03"
}, {
  CIP7: '2769420',
  CIP13: '3400927694202',
  ucdLib: "OMNISCAN 0,5MMOL PCO20ML +N",
  UCD7: '9398234',
  UCD13: '3400893982341',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNISCAN 0,5MMOL PCO20ML +N BT 1",
  atcCode: "V08CA03"
}, {
  CIP7: '3373032',
  CIP13: '3400933730321',
  ucdLib: "OMNISCAN 0,5MMOL INJ FV10ML",
  UCD7: '9168451',
  UCD13: '3400891684513',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNISCAN 0,5MMOL INJ FV10ML BT 1",
  atcCode: "V08CA03"
}, {
  CIP7: '3373049',
  CIP13: '3400933730499',
  ucdLib: "OMNISCAN 0,5MMOL INJ FV15ML",
  UCD7: '9168468',
  UCD13: '3400891684681',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNISCAN 0,5MMOL INJ FV15ML BT 1",
  atcCode: "V08CA03"
}, {
  CIP7: '3373055',
  CIP13: '3400933730550',
  ucdLib: "OMNISCAN 0,5MMOL INJ FV20ML",
  UCD7: '9168474',
  UCD13: '3400891684742',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNISCAN 0,5MMOL INJ FV20ML BT 1",
  atcCode: "V08CA03"
}, {
  CIP7: '5584885',
  CIP13: '3400955848851',
  ucdLib: "OMNISCAN 0,5MMOL INJ FV15ML",
  UCD7: '9168468',
  UCD13: '3400891684681',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNISCAN 0,5MMOL INJ FV15ML BT 10",
  atcCode: "V08CA03"
}, {
  CIP7: '5584891',
  CIP13: '3400955848912',
  ucdLib: "OMNISCAN 0,5MMOL INJ FV20ML",
  UCD7: '9168474',
  UCD13: '3400891684742',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNISCAN 0,5MMOL INJ FV20ML BT 10",
  atcCode: "V08CA03"
}, {
  CIP7: '3874053',
  CIP13: '3400938740530',
  ucdLib: "OMNISCAN 0,5MMOL INJ PCO10ML",
  UCD7: '9354685',
  UCD13: '3400893546857',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNISCAN 0,5MMOL INJ PCO10ML BT 1",
  atcCode: "V08CA03"
}, {
  CIP7: '3874076',
  CIP13: '3400938740769',
  ucdLib: "OMNISCAN 0,5MMOL INJ PCO10ML",
  UCD7: '9354685',
  UCD13: '3400893546857',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNISCAN 0,5MMOL INJ PCO10ML BT 10",
  atcCode: "V08CA03"
}, {
  CIP7: '3874099',
  CIP13: '3400938740998',
  ucdLib: "OMNISCAN 0,5MMOL INJ PCO15ML",
  UCD7: '9354691',
  UCD13: '3400893546918',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNISCAN 0,5MMOL INJ PCO15ML BT 10",
  atcCode: "V08CA03"
}, {
  CIP7: '3874113',
  CIP13: '3400938741131',
  ucdLib: "OMNISCAN 0,5MMOL INJ PCO20ML",
  UCD7: '9354716',
  UCD13: '3400893547168',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNISCAN 0,5MMOL INJ PCO20ML BT 10",
  atcCode: "V08CA03"
}, {
  CIP7: '3000450',
  CIP13: '3400930004500',
  ucdLib: "DOTAREM 0,5MMOL/ML SRG15ML+N.A",
  UCD7: '9409831',
  UCD13: '3400894098317',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML SRG15ML+N.A BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3000451',
  CIP13: '3400930004517',
  ucdLib: "DOTAREM 0,5MMOL/ML SRG20ML+N.A",
  UCD7: '9409848',
  UCD13: '3400894098485',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML SRG20ML+N.A BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3317134',
  CIP13: '3400933171346',
  ucdLib: "DOTAREM 0,5MMOL/ML INJ FV10ML",
  UCD7: '9137054',
  UCD13: '3400891370546',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML INJ FV10ML BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3317140',
  CIP13: '3400933171407',
  ucdLib: "DOTAREM 0,5MMOL/ML INJ FV15ML",
  UCD7: '9140783',
  UCD13: '3400891407839',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML INJ FV15ML BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3317157',
  CIP13: '3400933171575',
  ucdLib: "DOTAREM 0,5MMOL/ML INJ FV20ML",
  UCD7: '9137002',
  UCD13: '3400891370027',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML INJ FV20ML BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3599138',
  CIP13: '3400935991386',
  ucdLib: "ARTIREM INJ SRG20ML",
  UCD7: '9246582',
  UCD13: '3400892465821',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTIREM INJ SRG20ML BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3589542',
  CIP13: '3400935895424',
  ucdLib: "DOTAREM 0,5MMOL/ML INJ FV5ML",
  UCD7: '9240579',
  UCD13: '3400892405797',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML INJ FV5ML BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3589536',
  CIP13: '3400935895363',
  ucdLib: "DOTAREM 0,5MMOL/ML INJ S.10ML",
  UCD7: '9269241',
  UCD13: '3400892692418',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML INJ S.10ML BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3384030',
  CIP13: '3400933840303',
  ucdLib: "DOTAREM 0,5MMOL/ML INJ S.15ML",
  UCD7: '9177154',
  UCD13: '3400891771541',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML INJ S.15ML BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3384047',
  CIP13: '3400933840471',
  ucdLib: "DOTAREM 0,5MMOL/ML INJ S.20ML",
  UCD7: '9177160',
  UCD13: '3400891771602',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML INJ S.20ML BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '2794694',
  CIP13: '3400927946943',
  ucdLib: "DOTAREM 0,5MMOL/ML SRG15ML+NEC",
  UCD7: '9406011',
  UCD13: '3400894060116',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML SRG15ML+NEC BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '2794702',
  CIP13: '3400927947025',
  ucdLib: "DOTAREM 0,5MMOL/ML SRG20ML+NEC",
  UCD7: '9406028',
  UCD13: '3400894060284',
  ucdQtyMultiplicator: 1,
  cipLib: "DOTAREM 0,5MMOL/ML SRG20ML+NEC BT 1",
  atcCode: "V08CA02"
}, {
  CIP7: '3317631',
  CIP13: '3400933176310',
  ucdLib: "MAGNEVIST INJ FV10ML",
  UCD7: '9137373',
  UCD13: '3400891373738',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNEVIST INJ FV10ML BT 1",
  atcCode: "V08CA01"
}, {
  CIP7: '3317648',
  CIP13: '3400933176488',
  ucdLib: "MAGNEVIST INJ FV15ML",
  UCD7: '9137396',
  UCD13: '3400891373967',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNEVIST INJ FV15ML BT 1",
  atcCode: "V08CA01"
}, {
  CIP7: '3311433',
  CIP13: '3400933114336',
  ucdLib: "MAGNEVIST INJ FV20ML",
  UCD7: '9131057',
  UCD13: '3400891310573',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNEVIST INJ FV20ML BT 1",
  atcCode: "V08CA01"
}, {
  CIP7: '3430209',
  CIP13: '3400934302091',
  ucdLib: "MAGNEVIST INJ SRG V10ML",
  UCD7: '9198558',
  UCD13: '3400891985580',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNEVIST INJ SRG V10ML BT 1",
  atcCode: "V08CA01"
}, {
  CIP7: '3430215',
  CIP13: '3400934302152',
  ucdLib: "MAGNEVIST INJ SRG V15ML",
  UCD7: '9198564',
  UCD13: '3400891985641',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNEVIST INJ SRG V15ML BT 1",
  atcCode: "V08CA01"
}, {
  CIP7: '3430221',
  CIP13: '3400934302213',
  ucdLib: "MAGNEVIST INJ SRG V20ML",
  UCD7: '9198570',
  UCD13: '3400891985702',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNEVIST INJ SRG V20ML BT 1",
  atcCode: "V08CA01"
}, {
  CIP7: '3360822',
  CIP13: '3400933608224',
  ucdLib: "MAGNEVIST INJ FV5ML",
  UCD7: '9161673',
  UCD13: '3400891616736',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNEVIST INJ FV5ML BT 1",
  atcCode: "V08CA01"
}, {
  CIP7: '3478133',
  CIP13: '3400934781339',
  ucdLib: "MAGNEVIST INJ FV30ML",
  UCD7: '9212301',
  UCD13: '3400892123011',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNEVIST INJ FV30ML BT 1",
  atcCode: "V08CA01"
}, {
  CIP7: '3143645',
  CIP13: '3400931436454',
  ucdLib: "MICROTRAST PATE ORAL TB150G",
  UCD7: '9111899',
  UCD13: '3400891118995',
  ucdQtyMultiplicator: 1,
  cipLib: "MICROTRAST PATE ORAL TB150G BT 1",
  atcCode: "V08BA02"
}, {
  CIP7: '3067499',
  CIP13: '3400930674994',
  ucdLib: "MICROPAQUE SUSP FL150ML",
  UCD7: '9058797',
  UCD13: '3400890587976',
  ucdQtyMultiplicator: 1,
  cipLib: "MICROPAQUE SUSP FL150ML BT 1",
  atcCode: "V08BA01"
}, {
  CIP7: '3067507',
  CIP13: '3400930675076',
  ucdLib: "MICROPAQUE SUSP FL500ML",
  UCD7: '9111876',
  UCD13: '3400891118766',
  ucdQtyMultiplicator: 1,
  cipLib: "MICROPAQUE SUSP FL500ML BT 1",
  atcCode: "V08BA01"
}, {
  CIP7: '3305390',
  CIP13: '3400933053901',
  ucdLib: "MICROPAQUE SCAN.BV 150ML/500ML",
  UCD7: '9126949',
  UCD13: '3400891269499',
  ucdQtyMultiplicator: 1,
  cipLib: "MICROPAQUE SCAN.BV 150ML/500ML BT 1",
  atcCode: "V08BA01"
}, {
  CIP7: '5500210',
  CIP13: '3400955002109',
  ucdLib: "MICROPAQUE SUSP FL2000ML",
  UCD7: '9111853',
  UCD13: '3400891118537',
  ucdQtyMultiplicator: 1,
  cipLib: "MICROPAQUE SUSP FL2000ML BT 1",
  atcCode: "V08BA01"
}, {
  CIP7: '3062160',
  CIP13: '3400930621608',
  ucdLib: "LIPIODOL ULTRAFLUIDE A.10ML",
  UCD7: '9054405',
  UCD13: '3400890544054',
  ucdQtyMultiplicator: 1,
  cipLib: "LIPIODOL ULTRAFLUIDE A.10ML BT 1",
  atcCode: "V08AD01"
}, {
  CIP7: '3377627',
  CIP13: '3400933776275',
  ucdLib: "XENETIX 250 INJ FV125/100ML",
  UCD7: '9168126',
  UCD13: '3400891681260',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 250 INJ FV125/100ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377716',
  CIP13: '3400933777166',
  ucdLib: "XENETIX 300 INJ FV125/100ML",
  UCD7: '9168178',
  UCD13: '3400891681789',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ FV125/100ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377722',
  CIP13: '3400933777227',
  ucdLib: "XENETIX 300 INJ FV150ML",
  UCD7: '9168675',
  UCD13: '3400891686753',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ FV150ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377053',
  CIP13: '3400933770532',
  ucdLib: "XENETIX 300 INJ FV200ML",
  UCD7: '9168184',
  UCD13: '3400891681840',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ FV200ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377679',
  CIP13: '3400933776794',
  ucdLib: "XENETIX 300 INJ FV30/20ML",
  UCD7: '9168149',
  UCD13: '3400891681499',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ FV30/20ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377685',
  CIP13: '3400933776855',
  ucdLib: "XENETIX 300 INJ FV50ML",
  UCD7: '9168155',
  UCD13: '3400891681550',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ FV50ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377691',
  CIP13: '3400933776916',
  ucdLib: "XENETIX 300 INJ FV60ML",
  UCD7: '9168681',
  UCD13: '3400891686814',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ FV60ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377099',
  CIP13: '3400933770990',
  ucdLib: "XENETIX 300 INJ FV60ML + NEC",
  UCD7: '9168706',
  UCD13: '3400891687064',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ FV60ML + NEC BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377136',
  CIP13: '3400933771362',
  ucdLib: "XENETIX 350 INJ FV125/100ML",
  UCD7: '9168221',
  UCD13: '3400891682212',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ FV125/100ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377142',
  CIP13: '3400933771423',
  ucdLib: "XENETIX 350 INJ FV150ML",
  UCD7: '9168712',
  UCD13: '3400891687125',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ FV150ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377159',
  CIP13: '3400933771591',
  ucdLib: "XENETIX 350 INJ FV200ML",
  UCD7: '9168238',
  UCD13: '3400891682380',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ FV200ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377107',
  CIP13: '3400933771072',
  ucdLib: "XENETIX 350 INJ FV30/20ML",
  UCD7: '9168190',
  UCD13: '3400891681901',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ FV30/20ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377113',
  CIP13: '3400933771133',
  ucdLib: "XENETIX 350 INJ FV50ML",
  UCD7: '9168209',
  UCD13: '3400891682090',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ FV50ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3379106',
  CIP13: '3400933791063',
  ucdLib: "XENETIX 350 INJ FV60ML",
  UCD7: '9168729',
  UCD13: '3400891687293',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ FV60ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3377188',
  CIP13: '3400933771881',
  ucdLib: "XENETIX 350 INJ FV60ML + NEC",
  UCD7: '9168741',
  UCD13: '3400891687415',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ FV60ML + NEC BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '5601603',
  CIP13: '3400956016037',
  ucdLib: "XENETIX 250 INJ FV125/100ML",
  UCD7: '9168126',
  UCD13: '3400891681260',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 250 INJ FV125/100ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '5601589',
  CIP13: '3400956015894',
  ucdLib: "XENETIX 300 INJ FV125/100ML",
  UCD7: '9168178',
  UCD13: '3400891681789',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 300 INJ FV125/100ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '5601572',
  CIP13: '3400956015726',
  ucdLib: "XENETIX 300 INJ FV50ML",
  UCD7: '9168155',
  UCD13: '3400891681550',
  ucdQtyMultiplicator: 25,
  cipLib: "XENETIX 300 INJ FV50ML BT 25",
  atcCode: "V08AB11"
}, {
  CIP7: '5601566',
  CIP13: '3400956015665',
  ucdLib: "XENETIX 350 INJ FV125/100ML",
  UCD7: '9168221',
  UCD13: '3400891682212',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 350 INJ FV125/100ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '5601543',
  CIP13: '3400956015436',
  ucdLib: "XENETIX 350 INJ FV50ML",
  UCD7: '9168209',
  UCD13: '3400891682090',
  ucdQtyMultiplicator: 25,
  cipLib: "XENETIX 350 INJ FV50ML BT 25",
  atcCode: "V08AB11"
}, {
  CIP7: '3691447',
  CIP13: '3400936914476',
  ucdLib: "XENETIX 300 INJ POC100ML",
  UCD7: '9299897',
  UCD13: '3400892998978',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ POC100ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3691476',
  CIP13: '3400936914766',
  ucdLib: "XENETIX 300 INJ POC150ML",
  UCD7: '9299905',
  UCD13: '3400892999050',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ POC150ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3691542',
  CIP13: '3400936915428',
  ucdLib: "XENETIX 350 INJ POC100ML",
  UCD7: '9299911',
  UCD13: '3400892999111',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ POC100ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '3691565',
  CIP13: '3400936915657',
  ucdLib: "XENETIX 350 INJ POC150ML",
  UCD7: '9299928',
  UCD13: '3400892999289',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ POC150ML BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '5708206',
  CIP13: '3400957082062',
  ucdLib: "XENETIX 300 INJ POC100ML",
  UCD7: '9299897',
  UCD13: '3400892998978',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 300 INJ POC100ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '5708212',
  CIP13: '3400957082123',
  ucdLib: "XENETIX 300 INJ POC150ML",
  UCD7: '9299905',
  UCD13: '3400892999050',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 300 INJ POC150ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '2737176',
  CIP13: '3400927371769',
  ucdLib: "XENETIX 300 INJ POC150ML T.MED",
  UCD7: '9396809',
  UCD13: '3400893968093',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 300 INJ POC150ML T.MED BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '5708229',
  CIP13: '3400957082291',
  ucdLib: "XENETIX 300 INJ POC200ML",
  UCD7: '9299957',
  UCD13: '3400892999579',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 300 INJ POC200ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '5708169',
  CIP13: '3400957081690',
  ucdLib: "XENETIX 350 INJ POC100ML",
  UCD7: '9299911',
  UCD13: '3400892999111',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 350 INJ POC100ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '5708175',
  CIP13: '3400957081751',
  ucdLib: "XENETIX 350 INJ POC150ML",
  UCD7: '9299928',
  UCD13: '3400892999289',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 350 INJ POC150ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '2737242',
  CIP13: '3400927372421',
  ucdLib: "XENETIX 350 INJ POC150ML T.MED",
  UCD7: '9396821',
  UCD13: '3400893968215',
  ucdQtyMultiplicator: 1,
  cipLib: "XENETIX 350 INJ POC150ML T.MED BT 1",
  atcCode: "V08AB11"
}, {
  CIP7: '5708181',
  CIP13: '3400957081812',
  ucdLib: "XENETIX 350 INJ POC200ML",
  UCD7: '9299963',
  UCD13: '3400892999630',
  ucdQtyMultiplicator: 10,
  cipLib: "XENETIX 350 INJ POC200ML BT 10",
  atcCode: "V08AB11"
}, {
  CIP7: '3619800',
  CIP13: '3400936198005',
  ucdLib: "IOMERON 400 FV100ML TR.AN",
  UCD7: '9369184',
  UCD13: '3400893691847',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV100ML TR.AN BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3619817',
  CIP13: '3400936198173',
  ucdLib: "IOMERON 400 FV100ML TR.ME",
  UCD7: '9369190',
  UCD13: '3400893691908',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV100ML TR.ME BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3616173',
  CIP13: '3400936161733',
  ucdLib: "IOMERON 400 FV150ML TR.AN",
  UCD7: '9257195',
  UCD13: '3400892571959',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV150ML TR.AN BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3616196',
  CIP13: '3400936161962',
  ucdLib: "IOMERON 400 FV150ML TR.ME",
  UCD7: '9257203',
  UCD13: '3400892572031',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV150ML TR.ME BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379135',
  CIP13: '3400933791353',
  ucdLib: "IOMERON 150MG INJ FV100ML",
  UCD7: '9171826',
  UCD13: '3400891718263',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 150MG INJ FV100ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379164',
  CIP13: '3400933791643',
  ucdLib: "IOMERON 150MG INJ FV250ML",
  UCD7: '9374280',
  UCD13: '3400893742808',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 150MG INJ FV250ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379193',
  CIP13: '3400933791933',
  ucdLib: "IOMERON 200MG INJ FV100ML",
  UCD7: '9171849',
  UCD13: '3400891718492',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 200MG INJ FV100ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379170',
  CIP13: '3400933791704',
  ucdLib: "IOMERON 200MG INJ FV50ML",
  UCD7: '9171861',
  UCD13: '3400891718614',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 200MG INJ FV50ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379276',
  CIP13: '3400933792763',
  ucdLib: "IOMERON 250MG INJ FV100ML",
  UCD7: '9171878',
  UCD13: '3400891718782',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 250MG INJ FV100ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379299',
  CIP13: '3400933792992',
  ucdLib: "IOMERON 250MG INJ FV200ML",
  UCD7: '9171884',
  UCD13: '3400891718843',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 250MG INJ FV200ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379247',
  CIP13: '3400933792473',
  ucdLib: "IOMERON 250MG INJ FV50ML",
  UCD7: '9171890',
  UCD13: '3400891718904',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 250MG INJ FV50ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379371',
  CIP13: '3400933793715',
  ucdLib: "IOMERON 300MG INJ FV100ML",
  UCD7: '9171915',
  UCD13: '3400891719154',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 300MG INJ FV100ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379394',
  CIP13: '3400933793944',
  ucdLib: "IOMERON 300MG INJ FV200ML",
  UCD7: '9171921',
  UCD13: '3400891719215',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 300MG INJ FV200ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379359',
  CIP13: '3400933793593',
  ucdLib: "IOMERON 300MG INJ FV50ML",
  UCD7: '9171938',
  UCD13: '3400891719383',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 300MG INJ FV50ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379454',
  CIP13: '3400933794545',
  ucdLib: "IOMERON 350MG INJ FV100ML",
  UCD7: '9171950',
  UCD13: '3400891719505',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350MG INJ FV100ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379460',
  CIP13: '3400933794606',
  ucdLib: "IOMERON 350MG INJ FV150ML",
  UCD7: '9171967',
  UCD13: '3400891719673',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350MG INJ FV150ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379477',
  CIP13: '3400933794774',
  ucdLib: "IOMERON 350MG INJ FV200ML",
  UCD7: '9171973',
  UCD13: '3400891719734',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350MG INJ FV200ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379431',
  CIP13: '3400933794316',
  ucdLib: "IOMERON 350MG INJ FV50ML",
  UCD7: '9171996',
  UCD13: '3400891719963',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350MG INJ FV50ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379448',
  CIP13: '3400933794484',
  ucdLib: "IOMERON 350MG INJ FV75ML",
  UCD7: '9353591',
  UCD13: '3400893535912',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350MG INJ FV75ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379537',
  CIP13: '3400933795375',
  ucdLib: "IOMERON 400MG INJ FV100ML",
  UCD7: '9172004',
  UCD13: '3400891720044',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400MG INJ FV100ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379543',
  CIP13: '3400933795436',
  ucdLib: "IOMERON 400MG INJ FV150ML",
  UCD7: '9172010',
  UCD13: '3400891720105',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400MG INJ FV150ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379566',
  CIP13: '3400933795665',
  ucdLib: "IOMERON 400MG INJ FV200ML",
  UCD7: '9172027',
  UCD13: '3400891720273',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400MG INJ FV200ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379514',
  CIP13: '3400933795146',
  ucdLib: "IOMERON 400MG INJ FV50ML",
  UCD7: '9172033',
  UCD13: '3400891720334',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400MG INJ FV50ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3379520',
  CIP13: '3400933795207',
  ucdLib: "IOMERON 400MG INJ FV75ML",
  UCD7: '9353616',
  UCD13: '3400893536162',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400MG INJ FV75ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3551114',
  CIP13: '3400935511140',
  ucdLib: "IOMERON 300 FV150ML TR.ME",
  UCD7: '9231238',
  UCD13: '3400892312385',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 300 FV150ML TR.ME BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3399132',
  CIP13: '3400933991326',
  ucdLib: "IOMERON 300MG INJ FV50ML +NEC",
  UCD7: '9187477',
  UCD13: '3400891874778',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 300MG INJ FV50ML +NEC BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3551120',
  CIP13: '3400935511201',
  ucdLib: "IOMERON 350 FV150ML TR.ME",
  UCD7: '9231250',
  UCD13: '3400892312507',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350 FV150ML TR.ME BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3399126',
  CIP13: '3400933991265',
  ucdLib: "IOMERON 350MG INJ FV50ML +NEC",
  UCD7: '9187483',
  UCD13: '3400891874839',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350MG INJ FV50ML +NEC BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3399103',
  CIP13: '3400933991036',
  ucdLib: "IOMERON 400MG INJ FV50ML +NEC",
  UCD7: '9187508',
  UCD13: '3400891875089',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400MG INJ FV50ML +NEC BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3546946',
  CIP13: '3400935469465',
  ucdLib: "IOMERON 300 FV150ML TR.AN",
  UCD7: '9231221',
  UCD13: '3400892312217',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 300 FV150ML TR.AN BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3546923',
  CIP13: '3400935469236',
  ucdLib: "IOMERON 300MG INJ FV20ML",
  UCD7: '9228638',
  UCD13: '3400892286389',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 300MG INJ FV20ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3546969',
  CIP13: '3400935469694',
  ucdLib: "IOMERON 350 FV150ML TR.AN",
  UCD7: '9231244',
  UCD13: '3400892312446',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350 FV150ML TR.AN BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3546952',
  CIP13: '3400935469526',
  ucdLib: "IOMERON 350MG INJ FV20ML",
  UCD7: '9227515',
  UCD13: '3400892275154',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350MG INJ FV20ML BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2699493',
  CIP13: '3400926994938',
  ucdLib: "IOMERON 350 FV100ML TR.CT-EXPR",
  UCD7: '9396703',
  UCD13: '3400893967034',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350 FV100ML TR.CT-EXPR BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2699470',
  CIP13: '3400926994709',
  ucdLib: "IOMERON 350 FV100ML TR.EMPOWER",
  UCD7: '9396689',
  UCD13: '3400893966891',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350 FV100ML TR.EMPOWER BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2699501',
  CIP13: '3400926995010',
  ucdLib: "IOMERON 350 FV150ML TR.CT-EXPR",
  UCD7: '9396726',
  UCD13: '3400893967263',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350 FV150ML TR.CT-EXPR BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2699487',
  CIP13: '3400926994877',
  ucdLib: "IOMERON 350 FV150ML TR.EMPOWER",
  UCD7: '9396695',
  UCD13: '3400893966952',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350 FV150ML TR.EMPOWER BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2699412',
  CIP13: '3400926994129',
  ucdLib: "IOMERON 400 FV100ML TR.CT-EXPR",
  UCD7: '9396755',
  UCD13: '3400893967553',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV100ML TR.CT-EXPR BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2699398',
  CIP13: '3400926993986',
  ucdLib: "IOMERON 400 FV100ML TR.EMPOWER",
  UCD7: '9396732',
  UCD13: '3400893967324',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV100ML TR.EMPOWER BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2699429',
  CIP13: '3400926994297',
  ucdLib: "IOMERON 400 FV150ML TR.CT-EXPR",
  UCD7: '9396761',
  UCD13: '3400893967614',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV150ML TR.CT-EXPR BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2699406',
  CIP13: '3400926994068',
  ucdLib: "IOMERON 400 FV150ML TR.EMPOWER",
  UCD7: '9396749',
  UCD13: '3400893967492',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV150ML TR.EMPOWER BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2770682',
  CIP13: '3400927706820',
  ucdLib: "IOMERON 350 FV100ML TR.NEMOTO",
  UCD7: '9402941',
  UCD13: '3400894029410',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350 FV100ML TR.NEMOTO BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2770699',
  CIP13: '3400927706998',
  ucdLib: "IOMERON 350 FV150ML TR.NEMOTO",
  UCD7: '9402958',
  UCD13: '3400894029588',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 350 FV150ML TR.NEMOTO BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2770713',
  CIP13: '3400927707131',
  ucdLib: "IOMERON 400 FV100ML TR.NEMOTO",
  UCD7: '9402964',
  UCD13: '3400894029649',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV100ML TR.NEMOTO BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '2770736',
  CIP13: '3400927707360',
  ucdLib: "IOMERON 400 FV150ML TR.NEMOTO",
  UCD7: '9402970',
  UCD13: '3400894029700',
  ucdQtyMultiplicator: 1,
  cipLib: "IOMERON 400 FV150ML TR.NEMOTO BT 1",
  atcCode: "V08AB10"
}, {
  CIP7: '3520332',
  CIP13: '3400935203328',
  ucdLib: "VISIPAQUE 270MG INJ FP100ML",
  UCD7: '9242012',
  UCD13: '3400892420127',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 270MG INJ FP100ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3520349',
  CIP13: '3400935203496',
  ucdLib: "VISIPAQUE 270MG INJ FP100ML",
  UCD7: '9242012',
  UCD13: '3400892420127',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 270MG INJ FP100ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3520390',
  CIP13: '3400935203908',
  ucdLib: "VISIPAQUE 270MG INJ FP200ML",
  UCD7: '9242035',
  UCD13: '3400892420356',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 270MG INJ FP200ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3520409',
  CIP13: '3400935204097',
  ucdLib: "VISIPAQUE 270MG INJ FP200ML",
  UCD7: '9242035',
  UCD13: '3400892420356',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 270MG INJ FP200ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3520289',
  CIP13: '3400935202895',
  ucdLib: "VISIPAQUE 270MG INJ FP50ML",
  UCD7: '9242041',
  UCD13: '3400892420417',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 270MG INJ FP50ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3520295',
  CIP13: '3400935202956',
  ucdLib: "VISIPAQUE 270MG INJ FP50ML",
  UCD7: '9242041',
  UCD13: '3400892420417',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 270MG INJ FP50ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3520125',
  CIP13: '3400935201256',
  ucdLib: "VISIPAQUE 320MG INJ FP100ML",
  UCD7: '9242058',
  UCD13: '3400892420585',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320MG INJ FP100ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3520131',
  CIP13: '3400935201317',
  ucdLib: "VISIPAQUE 320MG INJ FP100ML",
  UCD7: '9242058',
  UCD13: '3400892420585',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 320MG INJ FP100ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3520148',
  CIP13: '3400935201485',
  ucdLib: "VISIPAQUE 320MG INJ FP150ML",
  UCD7: '9293305',
  UCD13: '3400892933054',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320MG INJ FP150ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3520183',
  CIP13: '3400935201836',
  ucdLib: "VISIPAQUE 320MG INJ FP200ML",
  UCD7: '9242070',
  UCD13: '3400892420707',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320MG INJ FP200ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3520208',
  CIP13: '3400935202086',
  ucdLib: "VISIPAQUE 320MG INJ FP200ML",
  UCD7: '9242070',
  UCD13: '3400892420707',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 320MG INJ FP200ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3520088',
  CIP13: '3400935200884',
  ucdLib: "VISIPAQUE 320MG INJ FP50ML",
  UCD7: '9242087',
  UCD13: '3400892420875',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320MG INJ FP50ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3520094',
  CIP13: '3400935200945',
  ucdLib: "VISIPAQUE 320MG INJ FP50ML",
  UCD7: '9242087',
  UCD13: '3400892420875',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIPAQUE 320MG INJ FP50ML BT 10",
  atcCode: "V08AB09"
}, {
  CIP7: '3384633',
  CIP13: '3400933846336',
  ucdLib: "VISIPAQUE 270MG INJ FV20ML",
  UCD7: '9179288',
  UCD13: '3400891792881',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 270MG INJ FV20ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3384685',
  CIP13: '3400933846855',
  ucdLib: "VISIPAQUE 320MG INJ FV20ML",
  UCD7: '9179325',
  UCD13: '3400891793253',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320MG INJ FV20ML BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '2667731',
  CIP13: '3400926677312',
  ucdLib: "VISIPAQUE 270 INJ FP100ML NEM",
  UCD7: '9387271',
  UCD13: '3400893872710',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 270 INJ FP100ML NEM BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '2667760',
  CIP13: '3400926677602',
  ucdLib: "VISIPAQUE 270 INJ FP150ML MED",
  UCD7: '9387265',
  UCD13: '3400893872659',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 270 INJ FP150ML MED BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '2667783',
  CIP13: '3400926677831',
  ucdLib: "VISIPAQUE 320 INJ FP100ML MED",
  UCD7: '9387294',
  UCD13: '3400893872949',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320 INJ FP100ML MED BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '2667777',
  CIP13: '3400926677770',
  ucdLib: "VISIPAQUE 320 INJ FP100ML NEM",
  UCD7: '9387319',
  UCD13: '3400893873199',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320 INJ FP100ML NEM BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '2667814',
  CIP13: '3400926678142',
  ucdLib: "VISIPAQUE 320 INJ FP150ML MED",
  UCD7: '9387302',
  UCD13: '3400893873021',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320 INJ FP150ML MED BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '2667808',
  CIP13: '3400926678081',
  ucdLib: "VISIPAQUE 320 INJ FP150ML NEM",
  UCD7: '9387325',
  UCD13: '3400893873250',
  ucdQtyMultiplicator: 1,
  cipLib: "VISIPAQUE 320 INJ FP150ML NEM BT 1",
  atcCode: "V08AB09"
}, {
  CIP7: '3327629',
  CIP13: '3400933276294',
  ucdLib: "OPTIRAY 300 INJ FV100ML",
  UCD7: '9147420',
  UCD13: '3400891474206',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIRAY 300 INJ FV100ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3327635',
  CIP13: '3400933276355',
  ucdLib: "OPTIRAY 300 INJ FV200ML",
  UCD7: '9147443',
  UCD13: '3400891474435',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIRAY 300 INJ FV200ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3327687',
  CIP13: '3400933276874',
  ucdLib: "OPTIRAY 350 INJ FV100ML",
  UCD7: '9147495',
  UCD13: '3400891474954',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIRAY 350 INJ FV100ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3327693',
  CIP13: '3400933276935',
  ucdLib: "OPTIRAY 350 INJ FV200ML",
  UCD7: '9147526',
  UCD13: '3400891475265',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIRAY 350 INJ FV200ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3327664',
  CIP13: '3400933276645',
  ucdLib: "OPTIRAY 350 INJ FV50ML",
  UCD7: '9147532',
  UCD13: '3400891475326',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIRAY 350 INJ FV50ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3407914',
  CIP13: '3400934079146',
  ucdLib: "OPTIJECT 240MG INJ S.P125ML",
  UCD7: '9190887',
  UCD13: '3400891908879',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIJECT 240MG INJ S.P125ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3407883',
  CIP13: '3400934078835',
  ucdLib: "OPTIJECT 240MG INJ SRG50ML",
  UCD7: '9190870',
  UCD13: '3400891908701',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIJECT 240MG INJ SRG50ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3408368',
  CIP13: '3400934083686',
  ucdLib: "OPTIJECT 300MG INJ S.P100ML",
  UCD7: '9190918',
  UCD13: '3400891909180',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIJECT 300MG INJ S.P100ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3408380',
  CIP13: '3400934083808',
  ucdLib: "OPTIJECT 300MG INJ S.P125ML",
  UCD7: '9190924',
  UCD13: '3400891909241',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIJECT 300MG INJ S.P125ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3408322',
  CIP13: '3400934083228',
  ucdLib: "OPTIJECT 300MG INJ SRG50ML",
  UCD7: '9190901',
  UCD13: '3400891909012',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIJECT 300MG INJ SRG50ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3408664',
  CIP13: '3400934086649',
  ucdLib: "OPTIJECT 350MG INJ S.P100ML",
  UCD7: '9191013',
  UCD13: '3400891910131',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIJECT 350MG INJ S.P100ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3408687',
  CIP13: '3400934086878',
  ucdLib: "OPTIJECT 350MG INJ S.P125ML",
  UCD7: '9191036',
  UCD13: '3400891910360',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIJECT 350MG INJ S.P125ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '3408629',
  CIP13: '3400934086298',
  ucdLib: "OPTIJECT 350MG INJ SRG50ML",
  UCD7: '9191007',
  UCD13: '3400891910070',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTIJECT 350MG INJ SRG50ML BT 1",
  atcCode: "V08AB07"
}, {
  CIP7: '5601632',
  CIP13: '3400956016327',
  ucdLib: "OPTIRAY 300 INJ FV100ML",
  UCD7: '9147420',
  UCD13: '3400891474206',
  ucdQtyMultiplicator: 10,
  cipLib: "OPTIRAY 300 INJ FV100ML BT 10",
  atcCode: "V08AB07"
}, {
  CIP7: '5603424',
  CIP13: '3400956034246',
  ucdLib: "OPTIRAY 350 INJ FV100ML",
  UCD7: '9147495',
  UCD13: '3400891474954',
  ucdQtyMultiplicator: 10,
  cipLib: "OPTIRAY 350 INJ FV100ML BT 10",
  atcCode: "V08AB07"
}, {
  CIP7: '5603418',
  CIP13: '3400956034185',
  ucdLib: "OPTIRAY 350 INJ FV50ML",
  UCD7: '9147532',
  UCD13: '3400891475326',
  ucdQtyMultiplicator: 25,
  cipLib: "OPTIRAY 350 INJ FV50ML BT 25",
  atcCode: "V08AB07"
}, {
  CIP7: '2763624',
  CIP13: '3400927636240',
  ucdLib: "ULTRAVIST 300 INJ SRG150ML AIL",
  UCD7: '9401580',
  UCD13: '3400894015802',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 300 INJ SRG150ML AIL BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '2763713',
  CIP13: '3400927637131',
  ucdLib: "ULTRAVIST 370 INJ SRG150ML AIL",
  UCD7: '9401605',
  UCD13: '3400894016052',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 370 INJ SRG150ML AIL BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3309040',
  CIP13: '3400933090401',
  ucdLib: "ULTRAVIST 300 INJ FV100ML",
  UCD7: '9134021',
  UCD13: '3400891340211',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 300 INJ FV100ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3309057',
  CIP13: '3400933090579',
  ucdLib: "ULTRAVIST 300 INJ FV200ML",
  UCD7: '9134044',
  UCD13: '3400891340440',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 300 INJ FV200ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3309028',
  CIP13: '3400933090289',
  ucdLib: "ULTRAVIST 300 INJ FV20ML",
  UCD7: '9134038',
  UCD13: '3400891340389',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 300 INJ FV20ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3309034',
  CIP13: '3400933090340',
  ucdLib: "ULTRAVIST 300 INJ FV50ML",
  UCD7: '9134050',
  UCD13: '3400891340501',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 300 INJ FV50ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3309100',
  CIP13: '3400933091002',
  ucdLib: "ULTRAVIST 370 INJ FV100ML",
  UCD7: '9134067',
  UCD13: '3400891340679',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 370 INJ FV100ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3309117',
  CIP13: '3400933091170',
  ucdLib: "ULTRAVIST 370 INJ FV200ML",
  UCD7: '9134096',
  UCD13: '3400891340969',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 370 INJ FV200ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3309063',
  CIP13: '3400933090630',
  ucdLib: "ULTRAVIST 370 INJ FV20ML",
  UCD7: '9134073',
  UCD13: '3400891340730',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 370 INJ FV20ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3309086',
  CIP13: '3400933090869',
  ucdLib: "ULTRAVIST 370 INJ FV50ML",
  UCD7: '9134104',
  UCD13: '3400891341041',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 370 INJ FV50ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '5595593',
  CIP13: '3400955955931',
  ucdLib: "ULTRAVIST 300 INJ FV100ML",
  UCD7: '9134021',
  UCD13: '3400891340211',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 300 INJ FV100ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '5592123',
  CIP13: '3400955921233',
  ucdLib: "ULTRAVIST 300 INJ FV200ML",
  UCD7: '9134044',
  UCD13: '3400891340440',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 300 INJ FV200ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '5595570',
  CIP13: '3400955955702',
  ucdLib: "ULTRAVIST 300 INJ FV20ML",
  UCD7: '9134038',
  UCD13: '3400891340389',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 300 INJ FV20ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '5595587',
  CIP13: '3400955955870',
  ucdLib: "ULTRAVIST 300 INJ FV50ML",
  UCD7: '9134050',
  UCD13: '3400891340501',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 300 INJ FV50ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '5592063',
  CIP13: '3400955920632',
  ucdLib: "ULTRAVIST 370 INJ FV100ML",
  UCD7: '9134067',
  UCD13: '3400891340679',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 370 INJ FV100ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '5592086',
  CIP13: '3400955920861',
  ucdLib: "ULTRAVIST 370 INJ FV200ML",
  UCD7: '9134096',
  UCD13: '3400891340969',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 370 INJ FV200ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '5592040',
  CIP13: '3400955920403',
  ucdLib: "ULTRAVIST 370 INJ FV20ML",
  UCD7: '9134073',
  UCD13: '3400891340730',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 370 INJ FV20ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '5592057',
  CIP13: '3400955920571',
  ucdLib: "ULTRAVIST 370 INJ FV50ML",
  UCD7: '9134104',
  UCD13: '3400891341041',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 370 INJ FV50ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '3760378',
  CIP13: '3400937603782',
  ucdLib: "ULTRAVIST 300 INJ FV150ML",
  UCD7: '9237100',
  UCD13: '3400892371009',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 300 INJ FV150ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3760384',
  CIP13: '3400937603843',
  ucdLib: "ULTRAVIST 370 INJ FV150ML",
  UCD7: '9237117',
  UCD13: '3400892371177',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 370 INJ FV150ML BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '5638517',
  CIP13: '3400956385171',
  ucdLib: "ULTRAVIST 300 INJ FV150ML",
  UCD7: '9237100',
  UCD13: '3400892371009',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 300 INJ FV150ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '5638492',
  CIP13: '3400956384921',
  ucdLib: "ULTRAVIST 370 INJ FV150ML",
  UCD7: '9237117',
  UCD13: '3400892371177',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAVIST 370 INJ FV150ML BT 10",
  atcCode: "V08AB05"
}, {
  CIP7: '2779714',
  CIP13: '3400927797149',
  ucdLib: "ULTRAVIST 300 INJ FV100ML+MED",
  UCD7: '9405425',
  UCD13: '3400894054252',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 300 INJ FV100ML+MED BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '2779720',
  CIP13: '3400927797200',
  ucdLib: "ULTRAVIST 300 INJ FV150ML+MED",
  UCD7: '9405431',
  UCD13: '3400894054313',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 300 INJ FV150ML+MED BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '2779921',
  CIP13: '3400927799211',
  ucdLib: "ULTRAVIST 370 INJ FV100ML+MED",
  UCD7: '9405448',
  UCD13: '3400894054481',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 370 INJ FV100ML+MED BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '2779938',
  CIP13: '3400927799389',
  ucdLib: "ULTRAVIST 370 INJ FV150ML+MED",
  UCD7: '9405454',
  UCD13: '3400894054542',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAVIST 370 INJ FV150ML+MED BT 1",
  atcCode: "V08AB05"
}, {
  CIP7: '3255522',
  CIP13: '3400932555222',
  ucdLib: "IOPAMIRON 200 INJ FL15ML",
  UCD7: '9047233',
  UCD13: '3400890472333',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 200 INJ FL15ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245877',
  CIP13: '3400932458776',
  ucdLib: "IOPAMIRON 200 INJ FL10ML",
  UCD7: '9111008',
  UCD13: '3400891110081',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 200 INJ FL10ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245914',
  CIP13: '3400932459148',
  ucdLib: "IOPAMIRON 300 INJ FL100ML",
  UCD7: '9047256',
  UCD13: '3400890472562',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 300 INJ FL100ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245883',
  CIP13: '3400932458837',
  ucdLib: "IOPAMIRON 300 INJ FL10ML",
  UCD7: '9111014',
  UCD13: '3400891110142',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 300 INJ FL10ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245920',
  CIP13: '3400932459209',
  ucdLib: "IOPAMIRON 300 INJ FL200ML",
  UCD7: '9111020',
  UCD13: '3400891110203',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 300 INJ FL200ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245908',
  CIP13: '3400932459087',
  ucdLib: "IOPAMIRON 300 INJ FL50ML",
  UCD7: '9111037',
  UCD13: '3400891110371',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 300 INJ FL50ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245966',
  CIP13: '3400932459667',
  ucdLib: "IOPAMIRON 370 INJ FL100ML",
  UCD7: '9111043',
  UCD13: '3400891110432',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 370 INJ FL100ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245972',
  CIP13: '3400932459728',
  ucdLib: "IOPAMIRON 370 INJ FL200ML",
  UCD7: '9111066',
  UCD13: '3400891110661',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 370 INJ FL200ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245937',
  CIP13: '3400932459377',
  ucdLib: "IOPAMIRON 370 INJ FL20ML",
  UCD7: '9047262',
  UCD13: '3400890472623',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 370 INJ FL20ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3245943',
  CIP13: '3400932459438',
  ucdLib: "IOPAMIRON 370 INJ FL50ML",
  UCD7: '9111072',
  UCD13: '3400891110722',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 370 INJ FL50ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3335296',
  CIP13: '3400933352967',
  ucdLib: "IOPAMIRON 370 INJ FL50ML+NEC",
  UCD7: '9149790',
  UCD13: '3400891497908',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 370 INJ FL50ML+NEC BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '5591997',
  CIP13: '3400955919971',
  ucdLib: "IOPAMIRON 300 INJ FL100ML",
  UCD7: '9047256',
  UCD13: '3400890472562',
  ucdQtyMultiplicator: 10,
  cipLib: "IOPAMIRON 300 INJ FL100ML BT 10",
  atcCode: "V08AB04"
}, {
  CIP7: '3398351',
  CIP13: '3400933983512',
  ucdLib: "IOPAMIRON 300 INJ FL100ML+NEC",
  UCD7: '9190031',
  UCD13: '3400891900316',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 300 INJ FL100ML+NEC BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '5592005',
  CIP13: '3400955920052',
  ucdLib: "IOPAMIRON 300 INJ FL200ML",
  UCD7: '9111020',
  UCD13: '3400891110203',
  ucdQtyMultiplicator: 10,
  cipLib: "IOPAMIRON 300 INJ FL200ML BT 10",
  atcCode: "V08AB04"
}, {
  CIP7: '5591980',
  CIP13: '3400955919803',
  ucdLib: "IOPAMIRON 300 INJ FL50ML",
  UCD7: '9111037',
  UCD13: '3400891110371',
  ucdQtyMultiplicator: 10,
  cipLib: "IOPAMIRON 300 INJ FL50ML BT 10",
  atcCode: "V08AB04"
}, {
  CIP7: '5591951',
  CIP13: '3400955919513',
  ucdLib: "IOPAMIRON 370 INJ FL100ML",
  UCD7: '9111043',
  UCD13: '3400891110432',
  ucdQtyMultiplicator: 10,
  cipLib: "IOPAMIRON 370 INJ FL100ML BT 10",
  atcCode: "V08AB04"
}, {
  CIP7: '3398368',
  CIP13: '3400933983680',
  ucdLib: "IOPAMIRON 370 INJ FL100ML+NEC",
  UCD7: '9190048',
  UCD13: '3400891900484',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIRON 370 INJ FL100ML+NEC BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '5591968',
  CIP13: '3400955919681',
  ucdLib: "IOPAMIRON 370 INJ FL200ML",
  UCD7: '9111066',
  UCD13: '3400891110661',
  ucdQtyMultiplicator: 10,
  cipLib: "IOPAMIRON 370 INJ FL200ML BT 10",
  atcCode: "V08AB04"
}, {
  CIP7: '5591939',
  CIP13: '3400955919391',
  ucdLib: "IOPAMIRON 370 INJ FL20ML",
  UCD7: '9047262',
  UCD13: '3400890472623',
  ucdQtyMultiplicator: 10,
  cipLib: "IOPAMIRON 370 INJ FL20ML BT 10",
  atcCode: "V08AB04"
}, {
  CIP7: '5591945',
  CIP13: '3400955919452',
  ucdLib: "IOPAMIRON 370 INJ FL50ML",
  UCD7: '9111072',
  UCD13: '3400891110722',
  ucdQtyMultiplicator: 10,
  cipLib: "IOPAMIRON 370 INJ FL50ML BT 10",
  atcCode: "V08AB04"
}, {
  CIP7: '4931296',
  CIP13: '3400949312962',
  ucdLib: "IOPAMIGITA 300MG INJ FL100ML",
  UCD7: '9366004',
  UCD13: '3400893660041',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIGITA 300MG INJ FL100ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '4931304',
  CIP13: '3400949313044',
  ucdLib: "IOPAMIGITA 300MG INJ FL200ML",
  UCD7: '9366010',
  UCD13: '3400893660102',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIGITA 300MG INJ FL200ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '4931356',
  CIP13: '3400949313563',
  ucdLib: "IOPAMIGITA 370MG INJ FL100ML",
  UCD7: '9366033',
  UCD13: '3400893660331',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIGITA 370MG INJ FL100ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '4931362',
  CIP13: '3400949313624',
  ucdLib: "IOPAMIGITA 370MG INJ FL200ML",
  UCD7: '9366062',
  UCD13: '3400893660621',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPAMIGITA 370MG INJ FL200ML BT 1",
  atcCode: "V08AB04"
}, {
  CIP7: '3230479',
  CIP13: '3400932304790',
  ucdLib: "HEXABRIX 320 INJ FV125/100ML",
  UCD7: '9112568',
  UCD13: '3400891125689',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXABRIX 320 INJ FV125/100ML BT 1",
  atcCode: "V08AB03"
}, {
  CIP7: '3230485',
  CIP13: '3400932304851',
  ucdLib: "HEXABRIX 320 INJ FV200ML",
  UCD7: '9112580',
  UCD13: '3400891125801',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXABRIX 320 INJ FV200ML BT 1",
  atcCode: "V08AB03"
}, {
  CIP7: '3239138',
  CIP13: '3400932391387',
  ucdLib: "HEXABRIX 320 INJ FV30ML/20ML",
  UCD7: '9112574',
  UCD13: '3400891125740',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXABRIX 320 INJ FV30ML/20ML BT 1",
  atcCode: "V08AB03"
}, {
  CIP7: '3230433',
  CIP13: '3400932304332',
  ucdLib: "HEXABRIX 320 INJ FV50ML +NEC",
  UCD7: '9043287',
  UCD13: '3400890432870',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXABRIX 320 INJ FV50ML +NEC BT 1",
  atcCode: "V08AB03"
}, {
  CIP7: '3607530',
  CIP13: '3400936075306',
  ucdLib: "HEXABRIX 320 INJ FV10ML",
  UCD7: '9247676',
  UCD13: '3400892476766',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXABRIX 320 INJ FV10ML BT 1",
  atcCode: "V08AB03"
}, {
  CIP7: '5604642',
  CIP13: '3400956046423',
  ucdLib: "HEXABRIX 320 INJ FV125/100ML",
  UCD7: '9112568',
  UCD13: '3400891125689',
  ucdQtyMultiplicator: 10,
  cipLib: "HEXABRIX 320 INJ FV125/100ML BT 10",
  atcCode: "V08AB03"
}, {
  CIP7: '5604636',
  CIP13: '3400956046362',
  ucdLib: "HEXABRIX 320 INJ FV50ML +NEC",
  UCD7: '9043287',
  UCD13: '3400890432870',
  ucdQtyMultiplicator: 25,
  cipLib: "HEXABRIX 320 INJ FV50ML +NEC BT 25",
  atcCode: "V08AB03"
}, {
  CIP7: '5639103',
  CIP13: '3400956391035',
  ucdLib: "HEXABRIX 320 INJ FV10ML",
  UCD7: '9247676',
  UCD13: '3400892476766',
  ucdQtyMultiplicator: 25,
  cipLib: "HEXABRIX 320 INJ FV10ML BT 25",
  atcCode: "V08AB03"
}, {
  CIP7: '3268105',
  CIP13: '3400932681051',
  ucdLib: "OMNIPAQUE 180 INJ FV10ML",
  UCD7: '9105806',
  UCD13: '3400891058062',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 180 INJ FV10ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3268157',
  CIP13: '3400932681570',
  ucdLib: "OMNIPAQUE 300 INJ FV10ML",
  UCD7: '9105829',
  UCD13: '3400891058291',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FV10ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3268192',
  CIP13: '3400932681921',
  ucdLib: "OMNIPAQUE 350 INJ FV20ML",
  UCD7: '9105835',
  UCD13: '3400891058352',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FV20ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3334983',
  CIP13: '3400933349837',
  ucdLib: "OMNIPAQUE 300 INJ FP50ML+NEC",
  UCD7: '9150014',
  UCD13: '3400891500141',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP50ML+NEC BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3334977',
  CIP13: '3400933349776',
  ucdLib: "OMNIPAQUE 350 INJ FP50ML+NEC",
  UCD7: '9150020',
  UCD13: '3400891500202',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP50ML+NEC BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3531850',
  CIP13: '3400935318503',
  ucdLib: "OMNIPAQUE 300 INJ FP100ML",
  UCD7: '9222446',
  UCD13: '3400892224466',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP100ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3531867',
  CIP13: '3400935318671',
  ucdLib: "OMNIPAQUE 300 INJ FP150ML",
  UCD7: '9229514',
  UCD13: '3400892295145',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP150ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3531896',
  CIP13: '3400935318961',
  ucdLib: "OMNIPAQUE 300 INJ FP200ML",
  UCD7: '9222452',
  UCD13: '3400892224527',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP200ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3531809',
  CIP13: '3400935318091',
  ucdLib: "OMNIPAQUE 350 INJ FP100ML",
  UCD7: '9222475',
  UCD13: '3400892224756',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP100ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3531815',
  CIP13: '3400935318152',
  ucdLib: "OMNIPAQUE 350 INJ FP150ML",
  UCD7: '9229543',
  UCD13: '3400892295435',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP150ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3531838',
  CIP13: '3400935318381',
  ucdLib: "OMNIPAQUE 350 INJ FP200ML",
  UCD7: '9222498',
  UCD13: '3400892224985',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP200ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3460050',
  CIP13: '3400934600500',
  ucdLib: "OMNIPAQUE 240 INJ FP50ML",
  UCD7: '9222417',
  UCD13: '3400892224176',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 240 INJ FP50ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3460073',
  CIP13: '3400934600739',
  ucdLib: "OMNIPAQUE 300 INJ FP50ML",
  UCD7: '9222469',
  UCD13: '3400892224695',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP50ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '3460110',
  CIP13: '3400934601101',
  ucdLib: "OMNIPAQUE 350 INJ FP50ML",
  UCD7: '9222506',
  UCD13: '3400892225067',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP50ML BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '5622686',
  CIP13: '3400956226863',
  ucdLib: "OMNIPAQUE 240 INJ FP100ML",
  UCD7: '9222386',
  UCD13: '3400892223865',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 240 INJ FP100ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5622692',
  CIP13: '3400956226924',
  ucdLib: "OMNIPAQUE 240 INJ FP200ML",
  UCD7: '9222400',
  UCD13: '3400892224008',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 240 INJ FP200ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5623935',
  CIP13: '3400956239351',
  ucdLib: "OMNIPAQUE 300 INJ FP100ML",
  UCD7: '9222446',
  UCD13: '3400892224466',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 300 INJ FP100ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5623941',
  CIP13: '3400956239412',
  ucdLib: "OMNIPAQUE 300 INJ FP150ML",
  UCD7: '9229514',
  UCD13: '3400892295145',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 300 INJ FP150ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5623964',
  CIP13: '3400956239641',
  ucdLib: "OMNIPAQUE 300 INJ FP200ML",
  UCD7: '9222452',
  UCD13: '3400892224527',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 300 INJ FP200ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5623881',
  CIP13: '3400956238811',
  ucdLib: "OMNIPAQUE 350 INJ FP100ML",
  UCD7: '9222475',
  UCD13: '3400892224756',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 350 INJ FP100ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5623898',
  CIP13: '3400956238989',
  ucdLib: "OMNIPAQUE 350 INJ FP150ML",
  UCD7: '9229543',
  UCD13: '3400892295435',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 350 INJ FP150ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5623912',
  CIP13: '3400956239122',
  ucdLib: "OMNIPAQUE 350 INJ FP200ML",
  UCD7: '9222498',
  UCD13: '3400892224985',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 350 INJ FP200ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5614729',
  CIP13: '3400956147298',
  ucdLib: "OMNIPAQUE 240 INJ FP50ML",
  UCD7: '9222417',
  UCD13: '3400892224176',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 240 INJ FP50ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5614741',
  CIP13: '3400956147410',
  ucdLib: "OMNIPAQUE 300 INJ FP50ML",
  UCD7: '9222469',
  UCD13: '3400892224695',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 300 INJ FP50ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '5614764',
  CIP13: '3400956147649',
  ucdLib: "OMNIPAQUE 350 INJ FP50ML",
  UCD7: '9222506',
  UCD13: '3400892225067',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 350 INJ FP50ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '2667576',
  CIP13: '3400926675769',
  ucdLib: "OMNIPAQUE 300 INJ FP100ML MED",
  UCD7: '9387153',
  UCD13: '3400893871539',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP100ML MED BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '2667553',
  CIP13: '3400926675530',
  ucdLib: "OMNIPAQUE 300 INJ FP100ML NEM",
  UCD7: '9387182',
  UCD13: '3400893871829',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP100ML NEM BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '2667599',
  CIP13: '3400926675998',
  ucdLib: "OMNIPAQUE 300 INJ FP150ML MED",
  UCD7: '9387176',
  UCD13: '3400893871768',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP150ML MED BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '2667582',
  CIP13: '3400926675820',
  ucdLib: "OMNIPAQUE 300 INJ FP150ML NEM",
  UCD7: '9387199',
  UCD13: '3400893871997',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 300 INJ FP150ML NEM BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '2667665',
  CIP13: '3400926676650',
  ucdLib: "OMNIPAQUE 350 INJ FP100ML MED",
  UCD7: '9387207',
  UCD13: '3400893872079',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP100ML MED BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '2667659',
  CIP13: '3400926676599',
  ucdLib: "OMNIPAQUE 350 INJ FP100ML NEM",
  UCD7: '9387236',
  UCD13: '3400893872369',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP100ML NEM BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '2667688',
  CIP13: '3400926676889',
  ucdLib: "OMNIPAQUE 350 INJ FP150ML MED",
  UCD7: '9387213',
  UCD13: '3400893872130',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP150ML MED BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '2667671',
  CIP13: '3400926676711',
  ucdLib: "OMNIPAQUE 350 INJ FP150ML NEM",
  UCD7: '9387242',
  UCD13: '3400893872420',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNIPAQUE 350 INJ FP150ML NEM BT 1",
  atcCode: "V08AB02"
}, {
  CIP7: '5721069',
  CIP13: '3400957210694',
  ucdLib: "OMNIPAQUE 180 INJ FV10ML",
  UCD7: '9105806',
  UCD13: '3400891058062',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNIPAQUE 180 INJ FV10ML BT 10",
  atcCode: "V08AB02"
}, {
  CIP7: '3280773',
  CIP13: '3400932807734',
  ucdLib: "TELEBRIX 35 INJ FV125/100ML",
  UCD7: '9169522',
  UCD13: '3400891695229',
  ucdQtyMultiplicator: 1,
  cipLib: "TELEBRIX 35 INJ FV125/100ML BT 1",
  atcCode: "V08AA05"
}, {
  CIP7: '3280796',
  CIP13: '3400932807963',
  ucdLib: "TELEBRIX 35 INJ FV200ML",
  UCD7: '9169539',
  UCD13: '3400891695397',
  ucdQtyMultiplicator: 1,
  cipLib: "TELEBRIX 35 INJ FV200ML BT 1",
  atcCode: "V08AA05"
}, {
  CIP7: '3274815',
  CIP13: '3400932748150',
  ucdLib: "TELEBRIX GASTRO FV100ML",
  UCD7: '9113384',
  UCD13: '3400891133844',
  ucdQtyMultiplicator: 1,
  cipLib: "TELEBRIX GASTRO FV100ML BT 1",
  atcCode: "V08AA05"
}, {
  CIP7: '3274809',
  CIP13: '3400932748099',
  ucdLib: "TELEBRIX GASTRO FV50ML",
  UCD7: '9113390',
  UCD13: '3400891133905',
  ucdQtyMultiplicator: 1,
  cipLib: "TELEBRIX GASTRO FV50ML BT 1",
  atcCode: "V08AA05"
}, {
  CIP7: '3135545',
  CIP13: '3400931355458',
  ucdLib: "TELEBRIX 30 MEGL. FV30ML",
  UCD7: '9115673',
  UCD13: '3400891156737',
  ucdQtyMultiplicator: 1,
  cipLib: "TELEBRIX 30 MEGL. FV30ML BT 1",
  atcCode: "V08AA05"
}, {
  CIP7: '3201070',
  CIP13: '3400932010707',
  ucdLib: "TELEBRIX HYSTERO FV20ML",
  UCD7: '9090766',
  UCD13: '3400890907668',
  ucdQtyMultiplicator: 1,
  cipLib: "TELEBRIX HYSTERO FV20ML BT 1",
  atcCode: "V08AA05"
}, {
  CIP7: '3171601',
  CIP13: '3400931716013',
  ucdLib: "TELEBRIX 12 SODIUM FV250ML",
  UCD7: '9090772',
  UCD13: '3400890907729',
  ucdQtyMultiplicator: 1,
  cipLib: "TELEBRIX 12 SODIUM FV250ML BT 1",
  atcCode: "V08AA05"
}, {
  CIP7: '5603453',
  CIP13: '3400956034536',
  ucdLib: "TELEBRIX 30 MEGL. 125/100ML",
  UCD7: '9090789',
  UCD13: '3400890907897',
  ucdQtyMultiplicator: 10,
  cipLib: "TELEBRIX 30 MEGL. 125/100ML BT 10",
  atcCode: "V08AA05"
}, {
  CIP7: '5603476',
  CIP13: '3400956034765',
  ucdLib: "TELEBRIX 30 MEGL. FV30ML",
  UCD7: '9115673',
  UCD13: '3400891156737',
  ucdQtyMultiplicator: 25,
  cipLib: "TELEBRIX 30 MEGL. FV30ML BT 25",
  atcCode: "V08AA05"
}, {
  CIP7: '5603482',
  CIP13: '3400956034826',
  ucdLib: "TELEBRIX 30 MEGL. FV50ML",
  UCD7: '9169516',
  UCD13: '3400891695168',
  ucdQtyMultiplicator: 25,
  cipLib: "TELEBRIX 30 MEGL. FV50ML BT 25",
  atcCode: "V08AA05"
}, {
  CIP7: '5603447',
  CIP13: '3400956034475',
  ucdLib: "TELEBRIX 35 INJ FV125/100ML",
  UCD7: '9169522',
  UCD13: '3400891695229',
  ucdQtyMultiplicator: 10,
  cipLib: "TELEBRIX 35 INJ FV125/100ML BT 10",
  atcCode: "V08AA05"
}, {
  CIP7: '5603430',
  CIP13: '3400956034307',
  ucdLib: "TELEBRIX 35 INJ FV50ML",
  UCD7: '9169545',
  UCD13: '3400891695458',
  ucdQtyMultiplicator: 25,
  cipLib: "TELEBRIX 35 INJ FV50ML BT 25",
  atcCode: "V08AA05"
}, {
  CIP7: '3386098',
  CIP13: '3400933860981',
  ucdLib: "TELEBRIX 35 INJ FV50ML + NEC",
  UCD7: '9171743',
  UCD13: '3400891717433',
  ucdQtyMultiplicator: 1,
  cipLib: "TELEBRIX 35 INJ FV50ML + NEC BT 1",
  atcCode: "V08AA05"
}, {
  CIP7: '3089466',
  CIP13: '3400930894668',
  ucdLib: "RADIOSELECTAN U. 30% FL250ML",
  UCD7: '9078251',
  UCD13: '3400890782517',
  ucdQtyMultiplicator: 1,
  cipLib: "RADIOSELECTAN U. 30% FL250ML BT 1",
  atcCode: "V08AA01"
}, {
  CIP7: '3008083',
  CIP13: '3400930080832',
  ucdLib: "GASTROGRAFINE BUV/RECT 100ML",
  UCD7: '9037513',
  UCD13: '3400890375139',
  ucdQtyMultiplicator: 1,
  cipLib: "GASTROGRAFINE BUV/RECT 100ML BT 1",
  atcCode: "V08AA01"
}, {
  CIP7: '5570618',
  CIP13: '3400955706182',
  ucdLib: "RADIOSELECTAN UV 76% 20ML",
  UCD7: '9078274',
  UCD13: '3400890782746',
  ucdQtyMultiplicator: 10,
  cipLib: "RADIOSELECTAN UV 76% 20ML BT 10",
  atcCode: "V08AA01"
}, {
  CIP7: '5512791',
  CIP13: '3400955127918',
  ucdLib: "RADIOSELECTAN UV 76% 100ML",
  UCD7: '9119151',
  UCD13: '3400891191516',
  ucdQtyMultiplicator: 10,
  cipLib: "RADIOSELECTAN UV 76% 100ML BT 10",
  atcCode: "V08AA01"
}, {
  CIP7: '5512816',
  CIP13: '3400955128168',
  ucdLib: "RADIOSELECTAN UV 76% 50ML",
  UCD7: '9191941',
  UCD13: '3400891919417',
  ucdQtyMultiplicator: 10,
  cipLib: "RADIOSELECTAN UV 76% 50ML BT 10",
  atcCode: "V08AA01"
}, {
  CIP7: '5592011',
  CIP13: '3400955920113',
  ucdLib: "RADIOSELECTAN UV 76% 200ML",
  UCD7: '9078280',
  UCD13: '3400890782807',
  ucdQtyMultiplicator: 10,
  cipLib: "RADIOSELECTAN UV 76% 200ML BT 10",
  atcCode: "V08AA01"
}, {
  CIP7: '3608417',
  CIP13: '3400936084179',
  ucdLib: "INFRACYANINE 25MG INJ FL+AMP",
  UCD7: '9208848',
  UCD13: '3400892088488',
  ucdQtyMultiplicator: 1,
  cipLib: "INFRACYANINE 25MG INJ FL+AMP BT 1",
  atcCode: "V07AY"
}, {
  CIP7: '3066376',
  CIP13: '3400930663769',
  ucdLib: "DILUANT PHYSIO STAL. 4,5ML",
  UCD7: '9087416',
  UCD13: '3400890874168',
  ucdQtyMultiplicator: 5,
  cipLib: "DILUANT PHYSIO STAL. 4,5ML BT 5",
  atcCode: "V07AB"
}, {
  CIP7: '5534930',
  CIP13: '3400955349303',
  ucdLib: "EAU P.P.I LAV FV1000ML",
  UCD7: '9109951',
  UCD13: '3400891099515',
  ucdQtyMultiplicator: 6,
  cipLib: "EAU P.P.I LAV FV1000ML BT 6",
  atcCode: "V07AB"
}, {
  CIP7: '5534953',
  CIP13: '3400955349532',
  ucdLib: "EAU P.P.I LAV FV250ML",
  UCD7: '9029873',
  UCD13: '3400890298735',
  ucdQtyMultiplicator: 12,
  cipLib: "EAU P.P.I LAV FV250ML BT 12",
  atcCode: "V07AB"
}, {
  CIP7: '5534947',
  CIP13: '3400955349471',
  ucdLib: "EAU P.P.I LAV FV500ML",
  UCD7: '9109974',
  UCD13: '3400891099744',
  ucdQtyMultiplicator: 12,
  cipLib: "EAU P.P.I LAV FV500ML BT 12",
  atcCode: "V07AB"
}, {
  CIP7: '3831575',
  CIP13: '3400938315752',
  ucdLib: "EAU P.P.I FRF.FP250ML",
  UCD7: '9308455',
  UCD13: '3400893084557',
  ucdQtyMultiplicator: 20,
  cipLib: "EAU P.P.I FRF.FP250ML BT 20",
  atcCode: "V07AB"
}, {
  CIP7: '3831606',
  CIP13: '3400938316063',
  ucdLib: "EAU P.P.I FRF.FP500ML",
  UCD7: '9308461',
  UCD13: '3400893084618',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I FRF.FP500ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3611141',
  CIP13: '3400936111417',
  ucdLib: "EAU P.P.I LAV AB10ML",
  UCD7: '9263178',
  UCD13: '3400892631783',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I LAV AB10ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3616210',
  CIP13: '3400936162105',
  ucdLib: "EAU P.P.I LAV AB20ML",
  UCD7: '9263184',
  UCD13: '3400892631844',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I LAV AB20ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3611129',
  CIP13: '3400936111295',
  ucdLib: "EAU P.P.I LAV AB2ML",
  UCD7: '9275394',
  UCD13: '3400892753942',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I LAV AB2ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3611135',
  CIP13: '3400936111356',
  ucdLib: "EAU P.P.I LAV AB5ML",
  UCD7: '9263190',
  UCD13: '3400892631905',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I LAV AB5ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3058804',
  CIP13: '3400930588048',
  ucdLib: "LAVOISIER PHYSIO PHEN. 9ML",
  UCD7: '9050123',
  UCD13: '3400890501231',
  ucdQtyMultiplicator: 1,
  cipLib: "LAVOISIER PHYSIO PHEN. 9ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3230189',
  CIP13: '3400932301898',
  ucdLib: "EAU P.P.I LAV FV1000ML",
  UCD7: '9109951',
  UCD13: '3400891099515',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I LAV FV1000ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3607197',
  CIP13: '3400936071971',
  ucdLib: "EAU P.P.I BBM P.E1000ML",
  UCD7: '9177906',
  UCD13: '3400891779066',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I BBM P.E1000ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3607168',
  CIP13: '3400936071681',
  ucdLib: "EAU P.P.I BBM P.E100ML",
  UCD7: '9189275',
  UCD13: '3400891892758',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I BBM P.E100ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3607174',
  CIP13: '3400936071742',
  ucdLib: "EAU P.P.I BBM P.E250ML",
  UCD7: '9177912',
  UCD13: '3400891779127',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I BBM P.E250ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3607180',
  CIP13: '3400936071803',
  ucdLib: "EAU P.P.I BBM P.E500ML",
  UCD7: '9177929',
  UCD13: '3400891779295',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I BBM P.E500ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3683092',
  CIP13: '3400936830929',
  ucdLib: "EAU P.P.I PROAMP AMP5ML",
  UCD7: '9280343',
  UCD13: '3400892803432',
  ucdQtyMultiplicator: 50,
  cipLib: "EAU P.P.I PROAMP AMP5ML BT 50",
  atcCode: "V07AB"
}, {
  CIP7: '3409534',
  CIP13: '3400934095344',
  ucdLib: "EAU P.P.I CPF FV1000ML",
  UCD7: '9210319',
  UCD13: '3400892103198',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I CPF FV1000ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3409511',
  CIP13: '3400934095115',
  ucdLib: "EAU P.P.I CPF FV250ML",
  UCD7: '9210325',
  UCD13: '3400892103259',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I CPF FV250ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3409528',
  CIP13: '3400934095283',
  ucdLib: "EAU P.P.I CPF FV500ML",
  UCD7: '9210331',
  UCD13: '3400892103310',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I CPF FV500ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3120495',
  CIP13: '3400931204954',
  ucdLib: "EAU P.P.I LAV FV250ML",
  UCD7: '9029873',
  UCD13: '3400890298735',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I LAV FV250ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3120503',
  CIP13: '3400931205036',
  ucdLib: "EAU P.P.I LAV FV500ML",
  UCD7: '9109974',
  UCD13: '3400891099744',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I LAV FV500ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '5596368',
  CIP13: '3400955963684',
  ucdLib: "EAU P.P.I LAV FV125ML/100ML",
  UCD7: '9195689',
  UCD13: '3400891956894',
  ucdQtyMultiplicator: 24,
  cipLib: "EAU P.P.I LAV FV125ML/100ML BT 24",
  atcCode: "V07AB"
}, {
  CIP7: '5596351',
  CIP13: '3400955963516',
  ucdLib: "EAU P.P.I LAV FV125ML/50ML",
  UCD7: '9195695',
  UCD13: '3400891956955',
  ucdQtyMultiplicator: 24,
  cipLib: "EAU P.P.I LAV FV125ML/50ML BT 24",
  atcCode: "V07AB"
}, {
  CIP7: '5596374',
  CIP13: '3400955963745',
  ucdLib: "EAU P.P.I LAV FV250ML/200ML",
  UCD7: '9195703',
  UCD13: '3400891957037',
  ucdQtyMultiplicator: 12,
  cipLib: "EAU P.P.I LAV FV250ML/200ML BT 12",
  atcCode: "V07AB"
}, {
  CIP7: '3653470',
  CIP13: '3400936534704',
  ucdLib: "EAU P.P.I CPF A.B10ML",
  UCD7: '9281762',
  UCD13: '3400892817620',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I CPF A.B10ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3653487',
  CIP13: '3400936534872',
  ucdLib: "EAU P.P.I CPF A.B20ML",
  UCD7: '9281785',
  UCD13: '3400892817859',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I CPF A.B20ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3653464',
  CIP13: '3400936534643',
  ucdLib: "EAU P.P.I CPF A.B5ML",
  UCD7: '9281791',
  UCD13: '3400892817910',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I CPF A.B5ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3159356',
  CIP13: '3400931593560',
  ucdLib: "DILUANT PHYSIO STAL. 4,5ML",
  UCD7: '9087416',
  UCD13: '3400890874168',
  ucdQtyMultiplicator: 50,
  cipLib: "DILUANT PHYSIO STAL. 4,5ML BT 50",
  atcCode: "V07AB"
}, {
  CIP7: '3159362',
  CIP13: '3400931593621',
  ucdLib: "DILUANT PHYSIO STAL. 9ML",
  UCD7: '9087422',
  UCD13: '3400890874229',
  ucdQtyMultiplicator: 50,
  cipLib: "DILUANT PHYSIO STAL. 9ML BT 50",
  atcCode: "V07AB"
}, {
  CIP7: '5601744',
  CIP13: '3400956017447',
  ucdLib: "EAU P.P.I BBM APE10ML",
  UCD7: '9189200',
  UCD13: '3400891892000',
  ucdQtyMultiplicator: 20,
  cipLib: "EAU P.P.I BBM APE10ML BT 20",
  atcCode: "V07AB"
}, {
  CIP7: '5601750',
  CIP13: '3400956017508',
  ucdLib: "EAU P.P.I BBM APE20ML",
  UCD7: '9189217',
  UCD13: '3400891892178',
  ucdQtyMultiplicator: 20,
  cipLib: "EAU P.P.I BBM APE20ML BT 20",
  atcCode: "V07AB"
}, {
  CIP7: '5600377',
  CIP13: '3400956003778',
  ucdLib: "EAU P.P.I GILB UNIDOS5ML",
  UCD7: '9187767',
  UCD13: '3400891877670',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I GILB UNIDOS5ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '3706410',
  CIP13: '3400937064101',
  ucdLib: "EAU P.P.I PROAMP AMP10ML",
  UCD7: '9280320',
  UCD13: '3400892803203',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I PROAMP AMP10ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3706479',
  CIP13: '3400937064798',
  ucdLib: "EAU P.P.I PROAMP AMP20ML",
  UCD7: '9280337',
  UCD13: '3400892803371',
  ucdQtyMultiplicator: 20,
  cipLib: "EAU P.P.I PROAMP AMP20ML BT 20",
  atcCode: "V07AB"
}, {
  CIP7: '3585515',
  CIP13: '3400935855152',
  ucdLib: "EAU P.P.I VIAFLO POC1000ML",
  UCD7: '9260300',
  UCD13: '3400892603001',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I VIAFLO POC1000ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3585509',
  CIP13: '3400935855091',
  ucdLib: "EAU P.P.I VIAFLO POC500ML",
  UCD7: '9260352',
  UCD13: '3400892603520',
  ucdQtyMultiplicator: 20,
  cipLib: "EAU P.P.I VIAFLO POC500ML BT 20",
  atcCode: "V07AB"
}, {
  CIP7: '3695994',
  CIP13: '3400936959941',
  ucdLib: "EAU P.P.I FRF.AP10ML",
  UCD7: '9281880',
  UCD13: '3400892818801',
  ucdQtyMultiplicator: 20,
  cipLib: "EAU P.P.I FRF.AP10ML BT 20",
  atcCode: "V07AB"
}, {
  CIP7: '3696019',
  CIP13: '3400936960190',
  ucdLib: "EAU P.P.I FRF.AP20ML",
  UCD7: '9281897',
  UCD13: '3400892818979',
  ucdQtyMultiplicator: 20,
  cipLib: "EAU P.P.I FRF.AP20ML BT 20",
  atcCode: "V07AB"
}, {
  CIP7: '3637034',
  CIP13: '3400936370340',
  ucdLib: "EAU P.P.I MAC P.FNS1000ML",
  UCD7: '9258740',
  UCD13: '3400892587400',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FNS1000ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3636997',
  CIP13: '3400936369979',
  ucdLib: "EAU P.P.I MAC P.FNS100ML",
  UCD7: '9258734',
  UCD13: '3400892587349',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FNS100ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3637011',
  CIP13: '3400936370111',
  ucdLib: "EAU P.P.I MAC P.FNS250ML",
  UCD7: '9258786',
  UCD13: '3400892587868',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FNS250ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3637028',
  CIP13: '3400936370289',
  ucdLib: "EAU P.P.I MAC P.FNS500ML",
  UCD7: '9258800',
  UCD13: '3400892588001',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FNS500ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3636980',
  CIP13: '3400936369801',
  ucdLib: "EAU P.P.I MAC P.FNS50ML",
  UCD7: '9258792',
  UCD13: '3400892587929',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.FNS50ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3691418',
  CIP13: '3400936914186',
  ucdLib: "EAU P.P.I REN A.B20ML",
  UCD7: '9277341',
  UCD13: '3400892773414',
  ucdQtyMultiplicator: 50,
  cipLib: "EAU P.P.I REN A.B20ML BT 50",
  atcCode: "V07AB"
}, {
  CIP7: '5646296',
  CIP13: '3400956462964',
  ucdLib: "EAU P.P.I LAV AB10ML",
  UCD7: '9263178',
  UCD13: '3400892631783',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I LAV AB10ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5647344',
  CIP13: '3400956473441',
  ucdLib: "EAU P.P.I LAV AB20ML",
  UCD7: '9263184',
  UCD13: '3400892631844',
  ucdQtyMultiplicator: 50,
  cipLib: "EAU P.P.I LAV AB20ML BT 50",
  atcCode: "V07AB"
}, {
  CIP7: '3909716',
  CIP13: '3400939097169',
  ucdLib: "EAU P.P.I LAV FP1000ML",
  UCD7: '9324603',
  UCD13: '3400893246030',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I LAV FP1000ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3909722',
  CIP13: '3400939097220',
  ucdLib: "EAU P.P.I LAV FP1000ML",
  UCD7: '9324603',
  UCD13: '3400893246030',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I LAV FP1000ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3909685',
  CIP13: '3400939096858',
  ucdLib: "EAU P.P.I LAV FP500ML",
  UCD7: '9324626',
  UCD13: '3400893246269',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I LAV FP500ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '3909691',
  CIP13: '3400939096919',
  ucdLib: "EAU P.P.I LAV FP500ML",
  UCD7: '9324626',
  UCD13: '3400893246269',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I LAV FP500ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3948260',
  CIP13: '3400939482606',
  ucdLib: "EAU P.P.I LAV APP10ML",
  UCD7: '9333134',
  UCD13: '3400893331347',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I LAV APP10ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '3948277',
  CIP13: '3400939482774',
  ucdLib: "EAU P.P.I LAV APP20ML",
  UCD7: '9333140',
  UCD13: '3400893331408',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU P.P.I LAV APP20ML BT 10",
  atcCode: "V07AB"
}, {
  CIP7: '2195829',
  CIP13: '3400921958294',
  ucdLib: "EAU P.P.I MAC P.EASY+1000ML",
  UCD7: '9383356',
  UCD13: '3400893833568',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.EASY+1000ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '2195806',
  CIP13: '3400921958065',
  ucdLib: "EAU P.P.I MAC P.EASY+250ML",
  UCD7: '9383362',
  UCD13: '3400893833629',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.EASY+250ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '2195812',
  CIP13: '3400921958126',
  ucdLib: "EAU P.P.I MAC P.EASY+500ML",
  UCD7: '9383385',
  UCD13: '3400893833858',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU P.P.I MAC P.EASY+500ML BT 1",
  atcCode: "V07AB"
}, {
  CIP7: '5753359',
  CIP13: '3400957533595',
  ucdLib: "EAU P.P.I LAV APP10ML",
  UCD7: '9333134',
  UCD13: '3400893331347',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I LAV APP10ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5753365',
  CIP13: '3400957533656',
  ucdLib: "EAU P.P.I LAV APP20ML",
  UCD7: '9333140',
  UCD13: '3400893331408',
  ucdQtyMultiplicator: 50,
  cipLib: "EAU P.P.I LAV APP20ML BT 50",
  atcCode: "V07AB"
}, {
  CIP7: '5753342',
  CIP13: '3400957533427',
  ucdLib: "EAU P.P.I LAV APP5ML",
  UCD7: '9333157',
  UCD13: '3400893331576',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I LAV APP5ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5807138',
  CIP13: '3400958071386',
  ucdLib: "EAU P.P.I BBM APP10ML",
  UCD7: '9377628',
  UCD13: '3400893776285',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I BBM APP10ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5807144',
  CIP13: '3400958071447',
  ucdLib: "EAU P.P.I BBM APP20ML",
  UCD7: '9377634',
  UCD13: '3400893776346',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I BBM APP20ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5669742',
  CIP13: '3400956697427',
  ucdLib: "EAU P.P.I REN A.B10ML",
  UCD7: '9277335',
  UCD13: '3400892773353',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I REN A.B10ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5658448',
  CIP13: '3400956584482',
  ucdLib: "EAU P.P.I CPF A.B10ML",
  UCD7: '9281762',
  UCD13: '3400892817620',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I CPF A.B10ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5658431',
  CIP13: '3400956584314',
  ucdLib: "EAU P.P.I CPF A.B5ML",
  UCD7: '9281791',
  UCD13: '3400892817910',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU P.P.I CPF A.B5ML BT 100",
  atcCode: "V07AB"
}, {
  CIP7: '5556216',
  CIP13: '3400955562160',
  ucdLib: "CETORNAN 10G BUV SACH",
  UCD7: '9124732',
  UCD13: '3400891247329',
  ucdQtyMultiplicator: 50,
  cipLib: "CETORNAN 10G BUV SACH BT 50",
  atcCode: "V06DD"
}, {
  CIP7: '3302782',
  CIP13: '3400933027827',
  ucdLib: "CETORNAN 5G BUV SACH",
  UCD7: '9187164',
  UCD13: '3400891871647',
  ucdQtyMultiplicator: 10,
  cipLib: "CETORNAN 5G BUV SACH BT 10",
  atcCode: "V06DD"
}, {
  CIP7: '3360874',
  CIP13: '3400933608743',
  ucdLib: "KETOSTERIL CPR",
  UCD7: '9166819',
  UCD13: '3400891668193',
  ucdQtyMultiplicator: 100,
  cipLib: "KETOSTERIL CPR BT 100",
  atcCode: "V06DD"
}, {
  CIP7: '3741122',
  CIP13: '3400937411226',
  ucdLib: "ORNITHINE OXOGL.CHI 5G SACH",
  UCD7: '9339912',
  UCD13: '3400893399125',
  ucdQtyMultiplicator: 10,
  cipLib: "ORNITHINE OXOGL.CHI 5G SACH BT 10",
  atcCode: "V06DD"
}, {
  CIP7: '3750888',
  CIP13: '3400937508889',
  ucdLib: "ORNITHINE OXOGL.MYL 10G SACH",
  UCD7: '9290488',
  UCD13: '3400892904887',
  ucdQtyMultiplicator: 10,
  cipLib: "ORNITHINE OXOGL.MYL 10G SACH BT 10",
  atcCode: "V06DD"
}, {
  CIP7: '3750753',
  CIP13: '3400937507530',
  ucdLib: "ORNITHINE OXOGL.MYL 5G SACH",
  UCD7: '9290494',
  UCD13: '3400892904948',
  ucdQtyMultiplicator: 10,
  cipLib: "ORNITHINE OXOGL.MYL 5G SACH BT 10",
  atcCode: "V06DD"
}, {
  CIP7: '3830860',
  CIP13: '3400938308600',
  ucdLib: "HELICOBACTER TEST 45MG BUV K.",
  UCD7: '9315797',
  UCD13: '3400893157978',
  ucdQtyMultiplicator: 1,
  cipLib: "HELICOBACTER TEST 45MG BUV K. BT 1",
  atcCode: "V04CX"
}, {
  CIP7: '3123803',
  CIP13: '3400931238034',
  ucdLib: "BLEU PATENTE GUERBET INJ A.2ML",
  UCD7: '9011844',
  UCD13: '3400890118446',
  ucdQtyMultiplicator: 5,
  cipLib: "BLEU PATENTE GUERBET INJ A.2ML BT 5",
  atcCode: "V04CX"
}, {
  CIP7: '3431321',
  CIP13: '3400934313219',
  ucdLib: "HELIKIT 75MG BUV FL+SACH+KIT",
  UCD7: '9220654',
  UCD13: '3400892206547',
  ucdQtyMultiplicator: 1,
  cipLib: "HELIKIT 75MG BUV FL+SACH+KIT BT 1",
  atcCode: "V04CX"
}, {
  CIP7: '3483950',
  CIP13: '3400934839504',
  ucdLib: "HELICOBACTER TEST 75MG BUV KIT",
  UCD7: '9214961',
  UCD13: '3400892149615',
  ucdQtyMultiplicator: 1,
  cipLib: "HELICOBACTER TEST 75MG BUV KIT BT 1",
  atcCode: "V04CX"
}, {
  CIP7: '3694977',
  CIP13: '3400936949775',
  ucdLib: "HEXVIX 85MG VESIC FV+FP",
  UCD7: '9297332',
  UCD13: '3400892973326',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXVIX 85MG VESIC FV+FP BT 1",
  atcCode: "V04CX"
}, {
  CIP7: '5731866',
  CIP13: '3400957318666',
  ucdLib: "ARIDOL GELU +INHAL",
  UCD7: '9354283',
  UCD13: '3400893542835',
  ucdQtyMultiplicator: 19,
  cipLib: "ARIDOL GELU +INHAL BT 19",
  atcCode: "V04CX"
}, {
  CIP7: '2161279',
  CIP13: '3400921612790',
  ucdLib: "LHRH FERRING 100MCG INJ A.1ML",
  UCD7: '9391953',
  UCD13: '3400893919538',
  ucdQtyMultiplicator: 1,
  cipLib: "LHRH FERRING 100MCG INJ A.1ML BT 1",
  atcCode: "V04CM01"
}, {
  CIP7: '3577705',
  CIP13: '3400935777058',
  ucdLib: "THYROGEN 0,9MG INJ FL",
  UCD7: '9206921',
  UCD13: '3400892069210',
  ucdQtyMultiplicator: 2,
  cipLib: "THYROGEN 0,9MG INJ FL BT 2",
  atcCode: "V04CJ01"
}, {
  CIP7: '2751673',
  CIP13: '3400927516733',
  ucdLib: "CARMYNE 40MG/5ML INJ AMP5ML",
  UCD7: '9395431',
  UCD13: '3400893954317',
  ucdQtyMultiplicator: 10,
  cipLib: "CARMYNE 40MG/5ML INJ AMP5ML BT 10",
  atcCode: "V04CH02"
}, {
  CIP7: '4155337',
  CIP13: '3400941553370',
  ucdLib: "PROINULINE SERB 25% AMP20ML",
  UCD7: '9394868',
  UCD13: '3400893948682',
  ucdQtyMultiplicator: 25,
  cipLib: "PROINULINE SERB 25% AMP20ML BT 25",
  atcCode: "V04CH01"
}, {
  CIP7: '3539550',
  CIP13: '3400935395504',
  ucdLib: "TUBERTEST INJ FL10DOS",
  UCD7: '9237229',
  UCD13: '3400892372297',
  ucdQtyMultiplicator: 1,
  cipLib: "TUBERTEST INJ FL10DOS BT 1",
  atcCode: "V04CF01"
}, {
  CIP7: '5572190',
  CIP13: '3400955721901',
  ucdLib: "STIMU-GH 50MCG INJ A.+A.",
  UCD7: '9172501',
  UCD13: '3400891725018',
  ucdQtyMultiplicator: 1,
  cipLib: "STIMU-GH 50MCG INJ A.+A. BT 1",
  atcCode: "V04CD05"
}, {
  CIP7: '3566311',
  CIP13: '3400935663115',
  ucdLib: "STIMU-ACTH 100MCG INJ A.+A.",
  UCD7: '9232114',
  UCD13: '3400892321141',
  ucdQtyMultiplicator: 1,
  cipLib: "STIMU-ACTH 100MCG INJ A.+A. BT 1",
  atcCode: "V04CD04"
}, {
  CIP7: '5600348',
  CIP13: '3400956003488',
  ucdLib: "METOPIRONE 250MG CAPS",
  UCD7: '9166914',
  UCD13: '3400891669145',
  ucdQtyMultiplicator: 50,
  cipLib: "METOPIRONE 250MG CAPS BT 50",
  atcCode: "V04CD01"
}, {
  CIP7: '3458509',
  CIP13: '3400934585098',
  ucdLib: "OXYGENE MED SLF BOUT 15L",
  UCD7: '9207961',
  UCD13: '3400892079615',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT 15L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3458515',
  CIP13: '3400934585159',
  ucdLib: "OXYGENE MED SLF BOUT 15L+MAN.",
  UCD7: '9207949',
  UCD13: '3400892079493',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT 15L+MAN. BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3458478',
  CIP13: '3400934584787',
  ucdLib: "OXYGENE MED SLF BOUT 2L",
  UCD7: '9207978',
  UCD13: '3400892079783',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT 2L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3458521',
  CIP13: '3400934585210',
  ucdLib: "OXYGENE MED SLF BOUT 50L",
  UCD7: '9207990',
  UCD13: '3400892079905',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT 50L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3458484',
  CIP13: '3400934584848',
  ucdLib: "OXYGENE MED SLF BOUT 5L",
  UCD7: '9207984',
  UCD13: '3400892079844',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT 5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3458490',
  CIP13: '3400934584909',
  ucdLib: "OXYGENE MED SLF BOUT 5L+MAN.",
  UCD7: '9207955',
  UCD13: '3400892079554',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT 5L+MAN. BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3687687',
  CIP13: '3400936876873',
  ucdLib: "OXYGENE MED LDH B15L DEB0-6L",
  UCD7: '9285777',
  UCD13: '3400892857770',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B15L DEB0-6L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3687664',
  CIP13: '3400936876644',
  ucdLib: "OXYGENE MED LDH B2L DEB0-6L",
  UCD7: '9285783',
  UCD13: '3400892857831',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B2L DEB0-6L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3687670',
  CIP13: '3400936876705',
  ucdLib: "OXYGENE MED LDH B5L DEB0-6L",
  UCD7: '9285808',
  UCD13: '3400892858081',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B5L DEB0-6L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435218',
  CIP13: '3400934352188',
  ucdLib: "OXYGENE MED ALS BOUT 15L",
  UCD7: '9192900',
  UCD13: '3400891929003',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 15L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435230',
  CIP13: '3400934352300',
  ucdLib: "OXYGENE MED ALS BOUT 20L",
  UCD7: '9192923',
  UCD13: '3400891929232',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 20L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435158',
  CIP13: '3400934351587',
  ucdLib: "OXYGENE MED ALS BOUT 2L",
  UCD7: '9192917',
  UCD13: '3400891929171',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 2L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435170',
  CIP13: '3400934351709',
  ucdLib: "OXYGENE MED ALS BOUT 3,5L",
  UCD7: '9192946',
  UCD13: '3400891929461',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 3,5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435247',
  CIP13: '3400934352478',
  ucdLib: "OXYGENE MED ALS BOUT 50L",
  UCD7: '9192969',
  UCD13: '3400891929690',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 50L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435187',
  CIP13: '3400934351877',
  ucdLib: "OXYGENE MED ALS BOUT 5L",
  UCD7: '9192952',
  UCD13: '3400891929522',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435224',
  CIP13: '3400934352249',
  ucdLib: "OXYGENE MED ALS BOUT AL15L+MAN",
  UCD7: '9192863',
  UCD13: '3400891928631',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT AL15L+MAN BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435164',
  CIP13: '3400934351648',
  ucdLib: "OXYGENE MED ALS BOUT ALU2L+MAN",
  UCD7: '9192886',
  UCD13: '3400891928860',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT ALU2L+MAN BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435193',
  CIP13: '3400934351938',
  ucdLib: "OXYGENE MED ALS BOUT ALU5L+MAN",
  UCD7: '9192892',
  UCD13: '3400891928921',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT ALU5L+MAN BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3522302',
  CIP13: '3400935223029',
  ucdLib: "OXYGENE MED APM B.AC20L+CBSTAR",
  UCD7: '9221435',
  UCD13: '3400892214351',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.AC20L+CBSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3522271',
  CIP13: '3400935222718',
  ucdLib: "OXYGENE MED APM B.ACI2L+RM200",
  UCD7: '9221429',
  UCD13: '3400892214290',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ACI2L+RM200 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3522288',
  CIP13: '3400935222886',
  ucdLib: "OXYGENE MED APM B.ACI5L+CBSTAR",
  UCD7: '9221441',
  UCD13: '3400892214412',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ACI5L+CBSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435595',
  CIP13: '3400934355950',
  ucdLib: "OXYGENE MED APM B.AL15L+CBSTA1",
  UCD7: '9192975',
  UCD13: '3400891929751',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.AL15L+CBSTA1 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435626',
  CIP13: '3400934356261',
  ucdLib: "OXYGENE MED APM B.AL20L+CBSTAR",
  UCD7: '9192998',
  UCD13: '3400891929980',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.AL20L+CBSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435520',
  CIP13: '3400934355202',
  ucdLib: "OXYGENE MED APM B.ALU2L+CBSTAR",
  UCD7: '9192981',
  UCD13: '3400891929812',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ALU2L+CBSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435566',
  CIP13: '3400934355660',
  ucdLib: "OXYGENE MED APM B.ALU5L+CBSTA1",
  UCD7: '9193006',
  UCD13: '3400891930061',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ALU5L+CBSTA1 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435589',
  CIP13: '3400934355899',
  ucdLib: "OXYGENE MED APM BOUT 15L",
  UCD7: '9193029',
  UCD13: '3400891930290',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 15L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435603',
  CIP13: '3400934356032',
  ucdLib: "OXYGENE MED APM BOUT 20L",
  UCD7: '9193041',
  UCD13: '3400891930412',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 20L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435514',
  CIP13: '3400934355141',
  ucdLib: "OXYGENE MED APM BOUT 2L",
  UCD7: '9193035',
  UCD13: '3400891930351',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 2L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435537',
  CIP13: '3400934355370',
  ucdLib: "OXYGENE MED APM BOUT 3,5L",
  UCD7: '9193058',
  UCD13: '3400891930580',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 3,5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435543',
  CIP13: '3400934355431',
  ucdLib: "OXYGENE MED APM BOUT 30L",
  UCD7: '9193070',
  UCD13: '3400891930702',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 30L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435649',
  CIP13: '3400934356490',
  ucdLib: "OXYGENE MED APM BOUT 30L",
  UCD7: '9193087',
  UCD13: '3400891930870',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 30L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435460',
  CIP13: '3400934354601',
  ucdLib: "OXYGENE MED LDH B15L DEB0-15L",
  UCD7: '9192679',
  UCD13: '3400891926798',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B15L DEB0-15L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435454',
  CIP13: '3400934354540',
  ucdLib: "OXYGENE MED LDH B15L DEB0-5L",
  UCD7: '9192716',
  UCD13: '3400891927160',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B15L DEB0-5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435365',
  CIP13: '3400934353659',
  ucdLib: "OXYGENE MED LDH B2L DEB0-15L",
  UCD7: '9192685',
  UCD13: '3400891926859',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B2L DEB0-15L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435359',
  CIP13: '3400934353598',
  ucdLib: "OXYGENE MED LDH B2L DEB0-5L",
  UCD7: '9192722',
  UCD13: '3400891927221',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B2L DEB0-5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435425',
  CIP13: '3400934354250',
  ucdLib: "OXYGENE MED LDH B5L DEB0-15L",
  UCD7: '9192691',
  UCD13: '3400891926910',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B5L DEB0-15L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435419',
  CIP13: '3400934354199',
  ucdLib: "OXYGENE MED LDH B5L DEB0-5L",
  UCD7: '9192739',
  UCD13: '3400891927399',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH B5L DEB0-5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435448',
  CIP13: '3400934354489',
  ucdLib: "OXYGENE MED LDH BOUT 15L",
  UCD7: '9192745',
  UCD13: '3400891927450',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH BOUT 15L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435342',
  CIP13: '3400934353420',
  ucdLib: "OXYGENE MED LDH BOUT 2L",
  UCD7: '9192751',
  UCD13: '3400891927511',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH BOUT 2L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435508',
  CIP13: '3400934355080',
  ucdLib: "OXYGENE MED LDH BOUT 50L",
  UCD7: '9192828',
  UCD13: '3400891928280',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH BOUT 50L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3435402',
  CIP13: '3400934354021',
  ucdLib: "OXYGENE MED LDH BOUT 5L",
  UCD7: '9192811',
  UCD13: '3400891928112',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH BOUT 5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3627774',
  CIP13: '3400936277748',
  ucdLib: "OXYGENE MED ALR BOUT ALU2L+MAN",
  UCD7: '9275218',
  UCD13: '3400892752181',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALR BOUT ALU2L+MAN BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3539432',
  CIP13: '3400935394323',
  ucdLib: "OXYGENE MED LDH CRYO.FIX 100L",
  UCD7: '9225456',
  UCD13: '3400892254562',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH CRYO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3539449',
  CIP13: '3400935394491',
  ucdLib: "OXYGENE MED LDH CRYO.MOB 155L",
  UCD7: '9225462',
  UCD13: '3400892254623',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH CRYO.MOB 155L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3539455',
  CIP13: '3400935394552',
  ucdLib: "OXYGENE MED LDH CRYO.MOB 200L",
  UCD7: '9225479',
  UCD13: '3400892254791',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH CRYO.MOB 200L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3539478',
  CIP13: '3400935394781',
  ucdLib: "OXYGENE MED LDH CRYO.MOB 600L",
  UCD7: '9225491',
  UCD13: '3400892254913',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH CRYO.MOB 600L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605593',
  CIP13: '3400956055937',
  ucdLib: "OXYGENE MED ALS BOUT 50L C9",
  UCD7: '9356193',
  UCD13: '3400893561935',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 50L C9 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605647',
  CIP13: '3400956056477',
  ucdLib: "OXYGENE MED ALS VAPO.FIX 100L",
  UCD7: '9193236',
  UCD13: '3400891932362',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS VAPO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605618',
  CIP13: '3400956056187',
  ucdLib: "OXYGENE MED ALS VAPO.MOB 180L",
  UCD7: '9193242',
  UCD13: '3400891932423',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS VAPO.MOB 180L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605624',
  CIP13: '3400956056248',
  ucdLib: "OXYGENE MED ALS VAPO.MOB 450L",
  UCD7: '9193259',
  UCD13: '3400891932591',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS VAPO.MOB 450L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605630',
  CIP13: '3400956056309',
  ucdLib: "OXYGENE MED ALS VAPO.MOB 630L",
  UCD7: '9193265',
  UCD13: '3400891932652',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS VAPO.MOB 630L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605848',
  CIP13: '3400956058488',
  ucdLib: "OXYGENE MED APM BOUT 50L C11",
  UCD7: '9347455',
  UCD13: '3400893474556',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 50L C11 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605854',
  CIP13: '3400956058549',
  ucdLib: "OXYGENE MED APM BOUT 50L C12",
  UCD7: '9347449',
  UCD13: '3400893474495',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 50L C12 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605771',
  CIP13: '3400956057719',
  ucdLib: "OXYGENE MED LDH BOUT 50L C16",
  UCD7: '9356135',
  UCD13: '3400893561355',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH BOUT 50L C16 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605788',
  CIP13: '3400956057887',
  ucdLib: "OXYGENE MED LDH BOUT 50L C28",
  UCD7: '9356112',
  UCD13: '3400893561126',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH BOUT 50L C28 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605742',
  CIP13: '3400956057429',
  ucdLib: "OXYGENE MED LDH BOUT 50L C8",
  UCD7: '9356129',
  UCD13: '3400893561294',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH BOUT 50L C8 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605831',
  CIP13: '3400956058310',
  ucdLib: "OXYGENE MED LDH VAPO.FIX 100L",
  UCD7: '9193182',
  UCD13: '3400891931822',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH VAPO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605802',
  CIP13: '3400956058020',
  ucdLib: "OXYGENE MED LDH VAPO.MOB 155L",
  UCD7: '9193199',
  UCD13: '3400891931990',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH VAPO.MOB 155L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5605819',
  CIP13: '3400956058198',
  ucdLib: "OXYGENE MED LDH VAPO.MOB 200L",
  UCD7: '9193207',
  UCD13: '3400891932072',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH VAPO.MOB 200L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3814588',
  CIP13: '3400938145885',
  ucdLib: "OXYGENE MED APM B.AC15L+MNSTAR",
  UCD7: '9311322',
  UCD13: '3400893113226',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.AC15L+MNSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3814565',
  CIP13: '3400938145656',
  ucdLib: "OXYGENE MED APM B.ACI5L+MNSTAR",
  UCD7: '9311339',
  UCD13: '3400893113394',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ACI5L+MNSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3814571',
  CIP13: '3400938145717',
  ucdLib: "OXYGENE MED APM B.AL15L+MNSTAR",
  UCD7: '9311345',
  UCD13: '3400893113455',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.AL15L+MNSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3814542',
  CIP13: '3400938145427',
  ucdLib: "OXYGENE MED APM B.ALU2L+MNSTAR",
  UCD7: '9311351',
  UCD13: '3400893113516',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ALU2L+MNSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3814559',
  CIP13: '3400938145595',
  ucdLib: "OXYGENE MED APM B.ALU5L+MNSTAR",
  UCD7: '9311368',
  UCD13: '3400893113684',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM B.ALU5L+MNSTAR BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3494327',
  CIP13: '3400934943270',
  ucdLib: "OXYGENE MED BTG BOUT 2L",
  UCD7: '9212324',
  UCD13: '3400892123240',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED BTG BOUT 2L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3494333',
  CIP13: '3400934943331',
  ucdLib: "OXYGENE MED BTG BOUT 5L",
  UCD7: '9212347',
  UCD13: '3400892123479',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED BTG BOUT 5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3494356',
  CIP13: '3400934943560',
  ucdLib: "OXYGENE MED BTG BOUT 5L+MAN.",
  UCD7: '9212376',
  UCD13: '3400892123769',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED BTG BOUT 5L+MAN. BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3494362',
  CIP13: '3400934943621',
  ucdLib: "OXYGENE MED BTG BOUT AC10L",
  UCD7: '9330957',
  UCD13: '3400893309575',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED BTG BOUT AC10L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3494385',
  CIP13: '3400934943850',
  ucdLib: "OXYGENE MED BTG BOUT AC20L",
  UCD7: '9212330',
  UCD13: '3400892123301',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED BTG BOUT AC20L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3494416',
  CIP13: '3400934944161',
  ucdLib: "OXYGENE MED BTG BOUT AC50L",
  UCD7: '9212353',
  UCD13: '3400892123530',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED BTG BOUT AC50L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5625408',
  CIP13: '3400956254088',
  ucdLib: "OXYGENE MED LDH VAPO.MOB 600L",
  UCD7: '9225516',
  UCD13: '3400892255163',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED LDH VAPO.MOB 600L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5625414',
  CIP13: '3400956254149',
  ucdLib: "OXYGENE MED SLF BOUT 50L",
  UCD7: '9207990',
  UCD13: '3400892079905',
  ucdQtyMultiplicator: 9,
  cipLib: "OXYGENE MED SLF BOUT 50L BT 9",
  atcCode: "V03AN01"
}, {
  CIP7: '3442879',
  CIP13: '3400934428791',
  ucdLib: "OXYGENE MED ALS BOUT 2,5L",
  UCD7: '9196080',
  UCD13: '3400891960808',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT 2,5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5614391',
  CIP13: '3400956143917',
  ucdLib: "OXYGENE MED SLF BOUT 50L",
  UCD7: '9207990',
  UCD13: '3400892079905',
  ucdQtyMultiplicator: 16,
  cipLib: "OXYGENE MED SLF BOUT 50L BT 16",
  atcCode: "V03AN01"
}, {
  CIP7: '5614416',
  CIP13: '3400956144167',
  ucdLib: "OXYGENE MED SLF BOUT 50L",
  UCD7: '9207990',
  UCD13: '3400892079905',
  ucdQtyMultiplicator: 20,
  cipLib: "OXYGENE MED SLF BOUT 50L BT 20",
  atcCode: "V03AN01"
}, {
  CIP7: '5614474',
  CIP13: '3400956144747',
  ucdLib: "OXYGENE MED SLF VAPO.FIX 100L",
  UCD7: '9208009',
  UCD13: '3400892080093',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF VAPO.FIX 100L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5614422',
  CIP13: '3400956144228',
  ucdLib: "OXYGENE MED SLF VAPO.MOB 200L",
  UCD7: '9208015',
  UCD13: '3400892080154',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF VAPO.MOB 200L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5614445',
  CIP13: '3400956144457',
  ucdLib: "OXYGENE MED SLF VAPO.MOB 600L",
  UCD7: '9208021',
  UCD13: '3400892080215',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF VAPO.MOB 600L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '2215087',
  CIP13: '3400922150871',
  ucdLib: "OXYGENE MED ALS BOU11L+MAN.TIP",
  UCD7: '9395402',
  UCD13: '3400893954027',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOU11L+MAN.TIP BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '2215058',
  CIP13: '3400922150581',
  ucdLib: "OXYGENE MED ALS BOUT2L+MAN.TIP",
  UCD7: '9395419',
  UCD13: '3400893954195',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT2L+MAN.TIP BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '2215070',
  CIP13: '3400922150703',
  ucdLib: "OXYGENE MED ALS BOUT5L+MAN.TIP",
  UCD7: '9389821',
  UCD13: '3400893898215',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT5L+MAN.TIP BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3505982',
  CIP13: '3400935059826',
  ucdLib: "OXYGENE MED SLF BOUT 0,4L",
  UCD7: '9303860',
  UCD13: '3400893038604',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT 0,4L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '3506007',
  CIP13: '3400935060075',
  ucdLib: "OXYGENE MED SLF BOUT 3,5L",
  UCD7: '9229773',
  UCD13: '3400892297736',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED SLF BOUT 3,5L BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '4920973',
  CIP13: '3400949209736',
  ucdLib: "OXYGENE MED ALS BOUT AL11L+MAN",
  UCD7: '9374400',
  UCD13: '3400893744000',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED ALS BOUT AL11L+MAN BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5741936',
  CIP13: '3400957419363',
  ucdLib: "OXYGENE MED APM BOUT 50L C",
  UCD7: '9374185',
  UCD13: '3400893741856',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 50L C BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5741913',
  CIP13: '3400957419134',
  ucdLib: "OXYGENE MED APM BOUT 50L C12",
  UCD7: '9374191',
  UCD13: '3400893741917',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYGENE MED APM BOUT 50L C12 BT 1",
  atcCode: "V03AN01"
}, {
  CIP7: '5856757',
  CIP13: '3400958567575',
  ucdLib: "PROGLICEM 100MG GELU",
  UCD7: '9118996',
  UCD13: '3400891189964',
  ucdQtyMultiplicator: 100,
  cipLib: "PROGLICEM 100MG GELU BT 100",
  atcCode: "V03AH01"
}, {
  CIP7: '5788547',
  CIP13: '3400957885472',
  ucdLib: "PROGLICEM 25MG GELU",
  UCD7: '9076080',
  UCD13: '3400890760805',
  ucdQtyMultiplicator: 100,
  cipLib: "PROGLICEM 25MG GELU BT 100",
  atcCode: "V03AH01"
}, {
  CIP7: '3702263',
  CIP13: '3400937022637',
  ucdLib: "KEPIVANCE 6,25MG INJ FL",
  UCD7: '9279038',
  UCD13: '3400892790381',
  ucdQtyMultiplicator: 6,
  cipLib: "KEPIVANCE 6,25MG INJ FL BT 6",
  atcCode: "V03AF08"
}, {
  CIP7: '5621391',
  CIP13: '3400956213917',
  ucdLib: "FASTURTEC 1,5MG/ML FL+A.1ML",
  UCD7: '9239116',
  UCD13: '3400892391168',
  ucdQtyMultiplicator: 3,
  cipLib: "FASTURTEC 1,5MG/ML FL+A.1ML BT 3",
  atcCode: "V03AF07"
}, {
  CIP7: '5634123',
  CIP13: '3400956341238',
  ucdLib: "FASTURTEC 1,5MG/ML FL+A.5ML",
  UCD7: '9239381',
  UCD13: '3400892393810',
  ucdQtyMultiplicator: 1,
  cipLib: "FASTURTEC 1,5MG/ML FL+A.5ML BT 1",
  atcCode: "V03AF07"
}, {
  CIP7: '5584508',
  CIP13: '3400955845089',
  ucdLib: "ETHYOL 50MG/ML INJ FL500MG",
  UCD7: '9172607',
  UCD13: '3400891726077',
  ucdQtyMultiplicator: 3,
  cipLib: "ETHYOL 50MG/ML INJ FL500MG BT 3",
  atcCode: "V03AF05"
}, {
  CIP7: '3489906',
  CIP13: '3400934899065',
  ucdLib: "ELVORINE 100MG INJ FL10ML",
  UCD7: '9201935',
  UCD13: '3400892019352',
  ucdQtyMultiplicator: 1,
  cipLib: "ELVORINE 100MG INJ FL10ML BT 1",
  atcCode: "V03AF04"
}, {
  CIP7: '3489912',
  CIP13: '3400934899126',
  ucdLib: "ELVORINE 175MG INJ FL17,5ML",
  UCD7: '9201941',
  UCD13: '3400892019413',
  ucdQtyMultiplicator: 1,
  cipLib: "ELVORINE 175MG INJ FL17,5ML BT 1",
  atcCode: "V03AF04"
}, {
  CIP7: '3489881',
  CIP13: '3400934898815',
  ucdLib: "ELVORINE 25MG INJ FL2,5ML",
  UCD7: '9201958',
  UCD13: '3400892019581',
  ucdQtyMultiplicator: 1,
  cipLib: "ELVORINE 25MG INJ FL2,5ML BT 1",
  atcCode: "V03AF04"
}, {
  CIP7: '3489898',
  CIP13: '3400934898983',
  ucdLib: "ELVORINE 50MG INJ FL5ML",
  UCD7: '9201964',
  UCD13: '3400892019642',
  ucdQtyMultiplicator: 1,
  cipLib: "ELVORINE 50MG INJ FL5ML BT 1",
  atcCode: "V03AF04"
}, {
  CIP7: '3844098',
  CIP13: '3400938440980',
  ucdLib: "CALCIUM LEV.ZEN 25MG/2,5ML FL",
  UCD7: '9314941',
  UCD13: '3400893149416',
  ucdQtyMultiplicator: 5,
  cipLib: "CALCIUM LEV.ZEN 25MG/2,5ML FL BT 5",
  atcCode: "V03AF04"
}, {
  CIP7: '3844129',
  CIP13: '3400938441291',
  ucdLib: "CALCIUM LEV.ZEN10MG FL17,5ML",
  UCD7: '9314929',
  UCD13: '3400893149294',
  ucdQtyMultiplicator: 5,
  cipLib: "CALCIUM LEV.ZEN10MG FL17,5ML BT 5",
  atcCode: "V03AF04"
}, {
  CIP7: '3844112',
  CIP13: '3400938441123',
  ucdLib: "CALCIUM LEV.ZEN10MG/ML F10ML",
  UCD7: '9314912',
  UCD13: '3400893149126',
  ucdQtyMultiplicator: 5,
  cipLib: "CALCIUM LEV.ZEN10MG/ML F10ML BT 5",
  atcCode: "V03AF04"
}, {
  CIP7: '3844106',
  CIP13: '3400938441062',
  ucdLib: "CALCIUM LEV.ZEN10MG/ML FL5ML",
  UCD7: '9314935',
  UCD13: '3400893149355',
  ucdQtyMultiplicator: 5,
  cipLib: "CALCIUM LEV.ZEN10MG/ML FL5ML BT 5",
  atcCode: "V03AF04"
}, {
  CIP7: '3835946',
  CIP13: '3400938359466',
  ucdLib: "CALCIUM FOL.ZEN 100MG INJ FL",
  UCD7: '9313255',
  UCD13: '3400893132555',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCIUM FOL.ZEN 100MG INJ FL BT 1",
  atcCode: "V03AF03"
}, {
  CIP7: '3835952',
  CIP13: '3400938359527',
  ucdLib: "CALCIUM FOL.ZEN 200MG INJ FL",
  UCD7: '9313261',
  UCD13: '3400893132616',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCIUM FOL.ZEN 200MG INJ FL BT 1",
  atcCode: "V03AF03"
}, {
  CIP7: '3835969',
  CIP13: '3400938359695',
  ucdLib: "CALCIUM FOL.ZEN 350MG INJ FL",
  UCD7: '9313278',
  UCD13: '3400893132784',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCIUM FOL.ZEN 350MG INJ FL BT 1",
  atcCode: "V03AF03"
}, {
  CIP7: '3325702',
  CIP13: '3400933257026',
  ucdLib: "LEDERFOLINE 15MG CPR",
  UCD7: '9134245',
  UCD13: '3400891342451',
  ucdQtyMultiplicator: 30,
  cipLib: "LEDERFOLINE 15MG CPR BT 30",
  atcCode: "V03AF03"
}, {
  CIP7: '3307377',
  CIP13: '3400933073770',
  ucdLib: "FOLINORAL 5MG GELU",
  UCD7: '9138898',
  UCD13: '3400891388985',
  ucdQtyMultiplicator: 28,
  cipLib: "FOLINORAL 5MG GELU BT 28",
  atcCode: "V03AF03"
}, {
  CIP7: '3367296',
  CIP13: '3400933672966',
  ucdLib: "FOLINORAL 25MG GELU",
  UCD7: '9166707',
  UCD13: '3400891667073',
  ucdQtyMultiplicator: 14,
  cipLib: "FOLINORAL 25MG GELU BT 14",
  atcCode: "V03AF03"
}, {
  CIP7: '3747633',
  CIP13: '3400937476331',
  ucdLib: "CALCIUM FOL.SDZ 10MG/ML 10ML",
  UCD7: '9298001',
  UCD13: '3400892980010',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCIUM FOL.SDZ 10MG/ML 10ML BT 1",
  atcCode: "V03AF03"
}, {
  CIP7: '3747656',
  CIP13: '3400937476560',
  ucdLib: "CALCIUM FOL.SDZ 10MG/ML 20ML",
  UCD7: '9298018',
  UCD13: '3400892980188',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCIUM FOL.SDZ 10MG/ML 20ML BT 1",
  atcCode: "V03AF03"
}, {
  CIP7: '3747662',
  CIP13: '3400937476621',
  ucdLib: "CALCIUM FOL.SDZ 10MG/ML 30ML",
  UCD7: '9298024',
  UCD13: '3400892980249',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCIUM FOL.SDZ 10MG/ML 30ML BT 1",
  atcCode: "V03AF03"
}, {
  CIP7: '3479718',
  CIP13: '3400934797187',
  ucdLib: "LEDERFOLINE 25MG CPR",
  UCD7: '9146308',
  UCD13: '3400891463088',
  ucdQtyMultiplicator: 30,
  cipLib: "LEDERFOLINE 25MG CPR BT 30",
  atcCode: "V03AF03"
}, {
  CIP7: '3475494',
  CIP13: '3400934754944',
  ucdLib: "LEDERFOLINE 5MG CPR",
  UCD7: '9124198',
  UCD13: '3400891241983',
  ucdQtyMultiplicator: 30,
  cipLib: "LEDERFOLINE 5MG CPR BT 30",
  atcCode: "V03AF03"
}, {
  CIP7: '5590839',
  CIP13: '3400955908395',
  ucdLib: "CARDIOXANE 500MG PERF FL",
  UCD7: '9179029',
  UCD13: '3400891790290',
  ucdQtyMultiplicator: 1,
  cipLib: "CARDIOXANE 500MG PERF FL BT 1",
  atcCode: "V03AF02"
}, {
  CIP7: '3771761',
  CIP13: '3400937717618',
  ucdLib: "SAVENE 20MG/ML IV FL+POC(3)",
  UCD7: '9291602',
  UCD13: '3400892916026',
  ucdQtyMultiplicator: 10,
  cipLib: "SAVENE 20MG/ML IV FL+POC(3) BT 10",
  atcCode: "V03AF02"
}, {
  CIP7: '5787163',
  CIP13: '3400957871635',
  ucdLib: "CYRDANAX 20MG/ML INJ FL500MG",
  UCD7: '9365625',
  UCD13: '3400893656259',
  ucdQtyMultiplicator: 1,
  cipLib: "CYRDANAX 20MG/ML INJ FL500MG BT 1",
  atcCode: "V03AF02"
}, {
  CIP7: '3000446',
  CIP13: '3400930004463',
  ucdLib: "UROMITEXAN 400MG CPR",
  UCD7: '9194796',
  UCD13: '3400891947960',
  ucdQtyMultiplicator: 10,
  cipLib: "UROMITEXAN 400MG CPR BT 10",
  atcCode: "V03AF01"
}, {
  CIP7: '3000442',
  CIP13: '3400930004425',
  ucdLib: "UROMITEXAN 600MG CPR",
  UCD7: '9194804',
  UCD13: '3400891948042',
  ucdQtyMultiplicator: 10,
  cipLib: "UROMITEXAN 600MG CPR BT 10",
  atcCode: "V03AF01"
}, {
  CIP7: '5584767',
  CIP13: '3400955847670',
  ucdLib: "UROMITEXAN 1G INJ FL10ML",
  UCD7: '9173104',
  UCD13: '3400891731040',
  ucdQtyMultiplicator: 1,
  cipLib: "UROMITEXAN 1G INJ FL10ML BT 1",
  atcCode: "V03AF01"
}, {
  CIP7: '5584773',
  CIP13: '3400955847731',
  ucdLib: "UROMITEXAN 5G INJ FL50ML",
  UCD7: '9173110',
  UCD13: '3400891731101',
  ucdQtyMultiplicator: 1,
  cipLib: "UROMITEXAN 5G INJ FL50ML BT 1",
  atcCode: "V03AF01"
}, {
  CIP7: '5620032',
  CIP13: '3400956200320',
  ucdLib: "UROMITEXAN 400MG INJ AMP4ML",
  UCD7: '9106763',
  UCD13: '3400891067637',
  ucdQtyMultiplicator: 15,
  cipLib: "UROMITEXAN 400MG INJ AMP4ML BT 15",
  atcCode: "V03AF01"
}, {
  CIP7: '5714566',
  CIP13: '3400957145668',
  ucdLib: "MESNA EG 100MG/ML INJ FL10ML",
  UCD7: '9395709',
  UCD13: '3400893957097',
  ucdQtyMultiplicator: 1,
  cipLib: "MESNA EG 100MG/ML INJ FL10ML BT 1",
  atcCode: "V03AF01"
}, {
  CIP7: '5857082',
  CIP13: '3400958570827',
  ucdLib: "MESNA EG 100MG/ML INJ AMP4ML",
  UCD7: '9402622',
  UCD13: '3400894026228',
  ucdQtyMultiplicator: 10,
  cipLib: "MESNA EG 100MG/ML INJ AMP4ML BT 10",
  atcCode: "V03AF01"
}, {
  CIP7: '3814660',
  CIP13: '3400938146608',
  ucdLib: "PHOSPHOSORB 660MG CPR",
  UCD7: '9352835',
  UCD13: '3400893528358',
  ucdQtyMultiplicator: 200,
  cipLib: "PHOSPHOSORB 660MG CPR BT 200",
  atcCode: "V03AE07"
}, {
  CIP7: '2802264',
  CIP13: '3400928022646',
  ucdLib: "VELPHORO 500MG CPR CROQ",
  UCD7: '9411288',
  UCD13: '3400894112884',
  ucdQtyMultiplicator: 30,
  cipLib: "VELPHORO 500MG CPR CROQ BT 30",
  atcCode: "V03AE05"
}, {
  CIP7: '2802270',
  CIP13: '3400928022707',
  ucdLib: "VELPHORO 500MG CPR CROQ",
  UCD7: '9411288',
  UCD13: '3400894112884',
  ucdQtyMultiplicator: 90,
  cipLib: "VELPHORO 500MG CPR CROQ BT 90",
  atcCode: "V03AE05"
}, {
  CIP7: '3692903',
  CIP13: '3400936929036',
  ucdLib: "FOSRENOL 1000MG CPR CROQ",
  UCD7: '9293423',
  UCD13: '3400892934235',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSRENOL 1000MG CPR CROQ BT 90",
  atcCode: "V03AE03"
}, {
  CIP7: '3692754',
  CIP13: '3400936927544',
  ucdLib: "FOSRENOL 500MG CPR CROQ",
  UCD7: '9293452',
  UCD13: '3400892934525',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSRENOL 500MG CPR CROQ BT 90",
  atcCode: "V03AE03"
}, {
  CIP7: '3692837',
  CIP13: '3400936928374',
  ucdLib: "FOSRENOL 750MG CPR CROQ",
  UCD7: '9293469',
  UCD13: '3400892934693',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSRENOL 750MG CPR CROQ BT 90",
  atcCode: "V03AE03"
}, {
  CIP7: '2236209',
  CIP13: '3400922362090',
  ucdLib: "FOSRENOL 1000MG PDR SACH",
  UCD7: '9393254',
  UCD13: '3400893932544',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSRENOL 1000MG PDR SACH BT 90",
  atcCode: "V03AE03"
}, {
  CIP7: '2236190',
  CIP13: '3400922361901',
  ucdLib: "FOSRENOL 750MG PDR SACH",
  UCD7: '9393260',
  UCD13: '3400893932605',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSRENOL 750MG PDR SACH BT 90",
  atcCode: "V03AE03"
}, {
  CIP7: '3000238',
  CIP13: '3400930002384',
  ucdLib: "SEVELAMER CARB.MYP 800MG CP",
  UCD7: '9410047',
  UCD13: '3400894100478',
  ucdQtyMultiplicator: 180,
  cipLib: "SEVELAMER CARB.MYP 800MG CP BT 180",
  atcCode: "V03AE02"
}, {
  CIP7: '3002343',
  CIP13: '3400930023433',
  ucdLib: "SEVELAMER CARB.SDZ 800MG CP",
  UCD7: '9412632',
  UCD13: '3400894126324',
  ucdQtyMultiplicator: 180,
  cipLib: "SEVELAMER CARB.SDZ 800MG CP BT 180",
  atcCode: "V03AE02"
}, {
  CIP7: '3572659',
  CIP13: '3400935726599',
  ucdLib: "RENAGEL 800MG CPR",
  UCD7: '9248167',
  UCD13: '3400892481678',
  ucdQtyMultiplicator: 180,
  cipLib: "RENAGEL 800MG CPR BT 180",
  atcCode: "V03AE02"
}, {
  CIP7: '3967079',
  CIP13: '3400939670799',
  ucdLib: "RENVELA 2,4G BUV PDR SACH",
  UCD7: '9347544',
  UCD13: '3400893475447',
  ucdQtyMultiplicator: 90,
  cipLib: "RENVELA 2,4G BUV PDR SACH BT 90",
  atcCode: "V03AE02"
}, {
  CIP7: '3967027',
  CIP13: '3400939670270',
  ucdLib: "RENVELA 800MG CPR",
  UCD7: '9347550',
  UCD13: '3400893475508',
  ucdQtyMultiplicator: 180,
  cipLib: "RENVELA 800MG CPR BT 180",
  atcCode: "V03AE02"
}, {
  CIP7: '2794978',
  CIP13: '3400927949784',
  ucdLib: "SEVELAMER CARB.TVC 800MG CP",
  UCD7: '9409788',
  UCD13: '3400894097884',
  ucdQtyMultiplicator: 180,
  cipLib: "SEVELAMER CARB.TVC 800MG CP BT 180",
  atcCode: "V03AE02"
}, {
  CIP7: '3235086',
  CIP13: '3400932350865',
  ucdLib: "KAYEXALATE PDR BT454G",
  UCD7: '9048669',
  UCD13: '3400890486699',
  ucdQtyMultiplicator: 1,
  cipLib: "KAYEXALATE PDR BT454G BT 1",
  atcCode: "V03AE01"
}, {
  CIP7: '3804986',
  CIP13: '3400938049862',
  ucdLib: "RESIKALI PDR BUV&RECT FL500G",
  UCD7: '9326134',
  UCD13: '3400893261347',
  ucdQtyMultiplicator: 1,
  cipLib: "RESIKALI PDR BUV&RECT FL500G BT 1",
  atcCode: "V03AE01"
}, {
  CIP7: '3769511',
  CIP13: '3400937695114',
  ucdLib: "EXJADE 125MG CPR DISP",
  UCD7: '9290927',
  UCD13: '3400892909271',
  ucdQtyMultiplicator: 28,
  cipLib: "EXJADE 125MG CPR DISP BT 28",
  atcCode: "V03AC03"
}, {
  CIP7: '3769557',
  CIP13: '3400937695572',
  ucdLib: "EXJADE 500MG CPR DISP",
  UCD7: '9290956',
  UCD13: '3400892909561',
  ucdQtyMultiplicator: 28,
  cipLib: "EXJADE 500MG CPR DISP BT 28",
  atcCode: "V03AC03"
}, {
  CIP7: '3657628',
  CIP13: '3400936576285',
  ucdLib: "FERRIPROX 500MG CPR",
  UCD7: '9220306',
  UCD13: '3400892203065',
  ucdQtyMultiplicator: 100,
  cipLib: "FERRIPROX 500MG CPR BT 100",
  atcCode: "V03AC02"
}, {
  CIP7: '3943854',
  CIP13: '3400939438542',
  ucdLib: "FERRIPROX 100MG/ML BUV FL500ML",
  UCD7: '9331170',
  UCD13: '3400893311707',
  ucdQtyMultiplicator: 1,
  cipLib: "FERRIPROX 100MG/ML BUV FL500ML BT 1",
  atcCode: "V03AC02"
}, {
  CIP7: '4962776',
  CIP13: '3400949627769',
  ucdLib: "FERRIPROX 1000MG CPR",
  UCD7: '9355905',
  UCD13: '3400893559055',
  ucdQtyMultiplicator: 50,
  cipLib: "FERRIPROX 1000MG CPR BT 50",
  atcCode: "V03AC02"
}, {
  CIP7: '3029837',
  CIP13: '3400930298374',
  ucdLib: "DESFERAL 100MG/ML INJ F+A5ML",
  UCD7: '9025579',
  UCD13: '3400890255790',
  ucdQtyMultiplicator: 1,
  cipLib: "DESFERAL 100MG/ML INJ F+A5ML BT 1",
  atcCode: "V03AC01"
}, {
  CIP7: '5501369',
  CIP13: '3400955013693',
  ucdLib: "PRAXBIND 2,5G/50ML INJ FL",
  UCD7: '9413873',
  UCD13: '3400894138730',
  ucdQtyMultiplicator: 2,
  cipLib: "PRAXBIND 2,5G/50ML INJ FL BT 2",
  atcCode: "V03AB37"
}, {
  CIP7: '5735539',
  CIP13: '3400957355395',
  ucdLib: "BRIDION 100MG/ML INJ FL2ML",
  UCD7: '9323101',
  UCD13: '3400893231012',
  ucdQtyMultiplicator: 10,
  cipLib: "BRIDION 100MG/ML INJ FL2ML BT 10",
  atcCode: "V03AB35"
}, {
  CIP7: '5735545',
  CIP13: '3400957355456',
  ucdLib: "BRIDION 100MG/ML INJ FL5ML",
  UCD7: '9323118',
  UCD13: '3400893231180',
  ucdQtyMultiplicator: 10,
  cipLib: "BRIDION 100MG/ML INJ FL5ML BT 10",
  atcCode: "V03AB35"
}, {
  CIP7: '5620233',
  CIP13: '3400956202331',
  ucdLib: "FOMEPIZOLE AP-HP 5MG INJ 20ML",
  UCD7: '9214033',
  UCD13: '3400892140339',
  ucdQtyMultiplicator: 5,
  cipLib: "FOMEPIZOLE AP-HP 5MG INJ 20ML BT 5",
  atcCode: "V03AB34"
}, {
  CIP7: '4991223',
  CIP13: '3400949912230',
  ucdLib: "CYANOKIT 5G PERF FL +NEC",
  UCD7: '9366398',
  UCD13: '3400893663981',
  ucdQtyMultiplicator: 1,
  cipLib: "CYANOKIT 5G PERF FL +NEC BT 1",
  atcCode: "V03AB33"
}, {
  CIP7: '3709532',
  CIP13: '3400937095327',
  ucdLib: "FLUMAZENIL KBI 0,1MG/ML 10ML",
  UCD7: '9283382',
  UCD13: '3400892833828',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUMAZENIL KBI 0,1MG/ML 10ML BT 5",
  atcCode: "V03AB25"
}, {
  CIP7: '3708053',
  CIP13: '3400937080538',
  ucdLib: "FLUMAZENIL MYL 0,1MG/ML 10ML",
  UCD7: '9280521',
  UCD13: '3400892805214',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUMAZENIL MYL 0,1MG/ML 10ML BT 5",
  atcCode: "V03AB25"
}, {
  CIP7: '3707993',
  CIP13: '3400937079938',
  ucdLib: "FLUMAZENIL MYL 0,1MG/ML 5ML",
  UCD7: '9280538',
  UCD13: '3400892805382',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUMAZENIL MYL 0,1MG/ML 5ML BT 5",
  atcCode: "V03AB25"
}, {
  CIP7: '3795307',
  CIP13: '3400937953078',
  ucdLib: "FLUMAZENIL AGT 0,1MG/ML 10ML",
  UCD7: '9300330',
  UCD13: '3400893003305',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUMAZENIL AGT 0,1MG/ML 10ML BT 10",
  atcCode: "V03AB25"
}, {
  CIP7: '3795299',
  CIP13: '3400937952996',
  ucdLib: "FLUMAZENIL AGT 0,1MG/ML 5ML",
  UCD7: '9300347',
  UCD13: '3400893003473',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUMAZENIL AGT 0,1MG/ML 5ML BT 10",
  atcCode: "V03AB25"
}, {
  CIP7: '3978574',
  CIP13: '3400939785745',
  ucdLib: "FLUMAZENIL PAN 0,1MG/ML 10ML",
  UCD7: '9341240',
  UCD13: '3400893412404',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUMAZENIL PAN 0,1MG/ML 10ML BT 10",
  atcCode: "V03AB25"
}, {
  CIP7: '3978516',
  CIP13: '3400939785165',
  ucdLib: "FLUMAZENIL PAN 0,1MG/ML 5ML",
  UCD7: '9341257',
  UCD13: '3400893412572',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUMAZENIL PAN 0,1MG/ML 5ML BT 10",
  atcCode: "V03AB25"
}, {
  CIP7: '3945712',
  CIP13: '3400939457123',
  ucdLib: "FLUMAZENIL TVC 0,1MG/ML 10ML",
  UCD7: '9338893',
  UCD13: '3400893388938',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUMAZENIL TVC 0,1MG/ML 10ML BT 5",
  atcCode: "V03AB25"
}, {
  CIP7: '3945681',
  CIP13: '3400939456812',
  ucdLib: "FLUMAZENIL TVC 0,1MG/ML 5ML",
  UCD7: '9338901',
  UCD13: '3400893389010',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUMAZENIL TVC 0,1MG/ML 5ML BT 5",
  atcCode: "V03AB25"
}, {
  CIP7: '5558391',
  CIP13: '3400955583912',
  ucdLib: "HIDONAC 5G INJ FV25ML",
  UCD7: '9126719',
  UCD13: '3400891267198',
  ucdQtyMultiplicator: 1,
  cipLib: "HIDONAC 5G INJ FV25ML BT 1",
  atcCode: "V03AB23"
}, {
  CIP7: '3430095',
  CIP13: '3400934300950',
  ucdLib: "POTASSIUM IOD PCA 130MG CPR",
  UCD7: '9200769',
  UCD13: '3400892007694',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM IOD PCA 130MG CPR BT 10",
  atcCode: "V03AB21"
}, {
  CIP7: '3922065',
  CIP13: '3400939220659',
  ucdLib: "POTASSIUM IOD PCA 65MG CPR",
  UCD7: '9345982',
  UCD13: '3400893459829',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM IOD PCA 65MG CPR BT 10",
  atcCode: "V03AB21"
}, {
  CIP7: '5800834',
  CIP13: '3400958008344',
  ucdLib: "METHYLTHIONIN.PVB 5MG/ML 10ML",
  UCD7: '9360705',
  UCD13: '3400893607053',
  ucdQtyMultiplicator: 5,
  cipLib: "METHYLTHIONIN.PVB 5MG/ML 10ML BT 5",
  atcCode: "V03AB17"
}, {
  CIP7: '3816417',
  CIP13: '3400938164176',
  ucdLib: "CURETHYL 26% INJ AMP20ML",
  UCD7: '9304316',
  UCD13: '3400893043165',
  ucdQtyMultiplicator: 10,
  cipLib: "CURETHYL 26% INJ AMP20ML BT 10",
  atcCode: "V03AB16"
}, {
  CIP7: '3291469',
  CIP13: '3400932914692',
  ucdLib: "NARCAN 0,4MG/1ML INJ AMP",
  UCD7: '9061026',
  UCD13: '3400890610261',
  ucdQtyMultiplicator: 10,
  cipLib: "NARCAN 0,4MG/1ML INJ AMP BT 10",
  atcCode: "V03AB15"
}, {
  CIP7: '3686386',
  CIP13: '3400936863866',
  ucdLib: "NALOXONE AGT 0,4MG/ML AMP",
  UCD7: '9274986',
  UCD13: '3400892749860',
  ucdQtyMultiplicator: 10,
  cipLib: "NALOXONE AGT 0,4MG/ML AMP BT 10",
  atcCode: "V03AB15"
}, {
  CIP7: '5630711',
  CIP13: '3400956307111',
  ucdLib: "NALOXONE MYL 0,4MG/1ML AMP",
  UCD7: '9223109',
  UCD13: '3400892231099',
  ucdQtyMultiplicator: 10,
  cipLib: "NALOXONE MYL 0,4MG/1ML AMP BT 10",
  atcCode: "V03AB15"
}, {
  CIP7: '5890044',
  CIP13: '3400958900440',
  ucdLib: "NALSCUE 0,9MG/0,1ML NAS DOS",
  UCD7: '9418712',
  UCD13: '3400894187127',
  ucdQtyMultiplicator: 4,
  cipLib: "NALSCUE 0,9MG/0,1ML NAS DOS BT 4",
  atcCode: "V03AB15"
}, {
  CIP7: '3101173',
  CIP13: '3400931011736',
  ucdLib: "PROTAMINE CHOAY INJ FL10ML",
  UCD7: '9076269',
  UCD13: '3400890762694',
  ucdQtyMultiplicator: 1,
  cipLib: "PROTAMINE CHOAY INJ FL10ML BT 1",
  atcCode: "V03AB14"
}, {
  CIP7: '3009065',
  CIP13: '3400930090657',
  ucdLib: "BAL INJ AMP2ML",
  UCD7: '9008842',
  UCD13: '3400890088428',
  ucdQtyMultiplicator: 12,
  cipLib: "BAL INJ AMP2ML BT 12",
  atcCode: "V03AB09"
}, {
  CIP7: '3025259',
  CIP13: '3400930252598',
  ucdLib: "CONTRATHION INJ 2% FL+AMP",
  UCD7: '9021819',
  UCD13: '3400890218191',
  ucdQtyMultiplicator: 10,
  cipLib: "CONTRATHION INJ 2% FL+AMP BT 10",
  atcCode: "V03AB04"
}, {
  CIP7: '3055792',
  CIP13: '3400930557921',
  ucdLib: "KELOCYANOR INJ AMP20ML",
  UCD7: '9048770',
  UCD13: '3400890487702',
  ucdQtyMultiplicator: 6,
  cipLib: "KELOCYANOR INJ AMP20ML BT 6",
  atcCode: "V03AB03"
}, {
  CIP7: '3016792',
  CIP13: '3400930167922',
  ucdLib: "CALCIUM EDTA SRB 5% AMP10ML",
  UCD7: '9014647',
  UCD13: '3400890146470',
  ucdQtyMultiplicator: 10,
  cipLib: "CALCIUM EDTA SRB 5% AMP10ML BT 10",
  atcCode: "V03AB03"
}, {
  CIP7: '3285575',
  CIP13: '3400932855759',
  ucdLib: "ALBEY ABEILLE 120MCG FL+FL",
  UCD7: '9155365',
  UCD13: '3400891553659',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBEY ABEILLE 120MCG FL+FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3285598',
  CIP13: '3400932855988',
  ucdLib: "ALBEY GUEPE 120MCG FL+FL",
  UCD7: '9155371',
  UCD13: '3400891553710',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBEY GUEPE 120MCG FL+FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3328267',
  CIP13: '3400933282677',
  ucdLib: "ALYOSTAL ABEILLE 110MCG FL",
  UCD7: '9149844',
  UCD13: '3400891498448',
  ucdQtyMultiplicator: 1,
  cipLib: "ALYOSTAL ABEILLE 110MCG FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3328296',
  CIP13: '3400933282967',
  ucdLib: "ALYOSTAL ABEILLE 550MCG FL",
  UCD7: '9149850',
  UCD13: '3400891498509',
  ucdQtyMultiplicator: 1,
  cipLib: "ALYOSTAL ABEILLE 550MCG FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3328304',
  CIP13: '3400933283049',
  ucdLib: "ALYOSTAL GUEPE POL 110MCG FL",
  UCD7: '9149867',
  UCD13: '3400891498677',
  ucdQtyMultiplicator: 1,
  cipLib: "ALYOSTAL GUEPE POL 110MCG FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3328310',
  CIP13: '3400933283100',
  ucdLib: "ALYOSTAL GUEPE POL 550MCG FL",
  UCD7: '9149873',
  UCD13: '3400891498738',
  ucdQtyMultiplicator: 1,
  cipLib: "ALYOSTAL GUEPE POL 550MCG FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3328250',
  CIP13: '3400933282509',
  ucdLib: "ALYOSTAL GUEPE VES 110MCG FL",
  UCD7: '9149896',
  UCD13: '3400891498967',
  ucdQtyMultiplicator: 1,
  cipLib: "ALYOSTAL GUEPE VES 110MCG FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3328273',
  CIP13: '3400933282738',
  ucdLib: "ALYOSTAL GUEPE VES 550MCG FL",
  UCD7: '9149904',
  UCD13: '3400891499049',
  ucdQtyMultiplicator: 1,
  cipLib: "ALYOSTAL GUEPE VES 550MCG FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3270705',
  CIP13: '3400932707058',
  ucdLib: "ALBEY ABEILLE 550MCG FL+FL",
  UCD7: '9127417',
  UCD13: '3400891274172',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBEY ABEILLE 550MCG FL+FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3270740',
  CIP13: '3400932707409',
  ucdLib: "ALBEY GUEPE 550MCG FL+FL",
  UCD7: '9127423',
  UCD13: '3400891274233',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBEY GUEPE 550MCG FL+FL BT 1",
  atcCode: "V01AA07"
}, {
  CIP7: '3689516',
  CIP13: '3400936895164',
  ucdLib: "ORALAIR 100IR&300IR CPR",
  UCD7: '9389293',
  UCD13: '3400893892930',
  ucdQtyMultiplicator: 31,
  cipLib: "ORALAIR 100IR&300IR CPR BT 31",
  atcCode: "V01AA02"
}, {
  CIP7: '3689522',
  CIP13: '3400936895225',
  ucdLib: "ORALAIR 300IR CPR SUBLING",
  UCD7: '9389301',
  UCD13: '3400893893012',
  ucdQtyMultiplicator: 30,
  cipLib: "ORALAIR 300IR CPR SUBLING BT 30",
  atcCode: "V01AA02"
}, {
  CIP7: '3780116',
  CIP13: '3400937801164',
  ucdLib: "GRAZAX 75000 LYOT ORAL",
  UCD7: '9311799',
  UCD13: '3400893117996',
  ucdQtyMultiplicator: 30,
  cipLib: "GRAZAX 75000 LYOT ORAL BT 30",
  atcCode: "V01AA02"
}, {
  CIP7: '3020049',
  CIP13: '3400930200490',
  ucdLib: "CERULYSE SOL AURIC FL10ML",
  UCD7: '9018059',
  UCD13: '3400890180597',
  ucdQtyMultiplicator: 1,
  cipLib: "CERULYSE SOL AURIC FL10ML BT 1",
  atcCode: "S02DC"
}, {
  CIP7: '3279066',
  CIP13: '3400932790661',
  ucdLib: "OTIPAX SOL INSTIL AUR FV16G+CG",
  UCD7: '9113295',
  UCD13: '3400891132953',
  ucdQtyMultiplicator: 1,
  cipLib: "OTIPAX SOL INSTIL AUR FV16G+CG BT 1",
  atcCode: "S02DA30"
}, {
  CIP7: '3192253',
  CIP13: '3400931922537',
  ucdLib: "PANOTILE GTT AURIC FL8ML",
  UCD7: '9067282',
  UCD13: '3400890672825',
  ucdQtyMultiplicator: 1,
  cipLib: "PANOTILE GTT AURIC FL8ML BT 1",
  atcCode: "S02CA07"
}, {
  CIP7: '3415144',
  CIP13: '3400934151446',
  ucdLib: "FRAMYXONE SOL AURIC FL10ML",
  UCD7: '9194626',
  UCD13: '3400891946260',
  ucdQtyMultiplicator: 1,
  cipLib: "FRAMYXONE SOL AURIC FL10ML BT 1",
  atcCode: "S02CA06"
}, {
  CIP7: '3153342',
  CIP13: '3400931533429',
  ucdLib: "POLYDEXA SOL AURIC FL10,5ML",
  UCD7: '9073791',
  UCD13: '3400890737913',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYDEXA SOL AURIC FL10,5ML BT 1",
  atcCode: "S02CA06"
}, {
  CIP7: '3640148',
  CIP13: '3400936401488',
  ucdLib: "AURICULARUM AURIC FL+AMP",
  UCD7: '9285151',
  UCD13: '3400892851518',
  ucdQtyMultiplicator: 1,
  cipLib: "AURICULARUM AURIC FL+AMP BT 1",
  atcCode: "S02CA06"
}, {
  CIP7: '2243971',
  CIP13: '3400922439716',
  ucdLib: "CILOXADEX 3MG/1MG/ML AURIC 5ML",
  UCD7: '9401611',
  UCD13: '3400894016113',
  ucdQtyMultiplicator: 1,
  cipLib: "CILOXADEX 3MG/1MG/ML AURIC 5ML BT 1",
  atcCode: "S02CA06"
}, {
  CIP7: '3005328',
  CIP13: '3400930053287',
  ucdLib: "ANTIBIO-SYNALAR AURIC SOL 10ML",
  UCD7: '9005329',
  UCD13: '3400890053297',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTIBIO-SYNALAR AURIC SOL 10ML BT 1",
  atcCode: "S02CA05"
}, {
  CIP7: '3229683',
  CIP13: '3400932296835',
  ucdLib: "AURIGOUTTE GTT AURIC FL15ML",
  UCD7: '9008463',
  UCD13: '3400890084635',
  ucdQtyMultiplicator: 1,
  cipLib: "AURIGOUTTE GTT AURIC FL15ML BT 1",
  atcCode: "S02AA30"
}, {
  CIP7: '3398635',
  CIP13: '3400933986353',
  ucdLib: "OFLOCET 1,5MG AURIC UNIDOS",
  UCD7: '9183605',
  UCD13: '3400891836059',
  ucdQtyMultiplicator: 20,
  cipLib: "OFLOCET 1,5MG AURIC UNIDOS BT 20",
  atcCode: "S02AA16"
}, {
  CIP7: '4964255',
  CIP13: '3400949642557',
  ucdLib: "OFLOXACINE BGA 1,5MG/0,5ML D20",
  UCD7: '9365720',
  UCD13: '3400893657201',
  ucdQtyMultiplicator: 20,
  cipLib: "OFLOXACINE BGA 1,5MG/0,5ML D20 BT 20",
  atcCode: "S02AA16"
}, {
  CIP7: '3601303',
  CIP13: '3400936013032',
  ucdLib: "CILOXAN 3MG/ML SOL AURIC FL5ML",
  UCD7: '9391858',
  UCD13: '3400893918586',
  ucdQtyMultiplicator: 1,
  cipLib: "CILOXAN 3MG/ML SOL AURIC FL5ML BT 1",
  atcCode: "S02AA15"
}, {
  CIP7: '3280520',
  CIP13: '3400932805204',
  ucdLib: "OTOFA SOL AURIC FL C-GTT 10ML",
  UCD7: '9109856',
  UCD13: '3400891098563',
  ucdQtyMultiplicator: 1,
  cipLib: "OTOFA SOL AURIC FL C-GTT 10ML BT 1",
  atcCode: "S02AA12"
}, {
  CIP7: '5847971',
  CIP13: '3400958479717',
  ucdLib: "JETREA 0,5MG/0,2ML INJ FL",
  UCD7: '9402579',
  UCD13: '3400894025795',
  ucdQtyMultiplicator: 1,
  cipLib: "JETREA 0,5MG/0,2ML INJ FL BT 1",
  atcCode: "S01XA22"
}, {
  CIP7: '5893327',
  CIP13: '3400958933271',
  ucdLib: "CYSTADROPS 0,55% CY FL5ML",
  UCD7: '9396235',
  UCD13: '3400893962350',
  ucdQtyMultiplicator: 1,
  cipLib: "CYSTADROPS 0,55% CY FL5ML BT 1",
  atcCode: "S01XA21"
}, {
  CIP7: '3458716',
  CIP13: '3400934587160',
  ucdLib: "SENSIVISION PLANTAIN CY DOS",
  UCD7: '9190769',
  UCD13: '3400891907698',
  ucdQtyMultiplicator: 10,
  cipLib: "SENSIVISION PLANTAIN CY DOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3574747',
  CIP13: '3400935747471',
  ucdLib: "SEDACOLLYRE CETHEXON.CY FL10ML",
  UCD7: '9231853',
  UCD13: '3400892318530',
  ucdQtyMultiplicator: 1,
  cipLib: "SEDACOLLYRE CETHEXON.CY FL10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3570666',
  CIP13: '3400935706669',
  ucdLib: "UNIFLUID COLLY UNIDOS",
  UCD7: '9231617',
  UCD13: '3400892316178',
  ucdQtyMultiplicator: 36,
  cipLib: "UNIFLUID COLLY UNIDOS BT 36",
  atcCode: "S01XA20"
}, {
  CIP7: '3011694',
  CIP13: '3400930116944',
  ucdLib: "BIOCIDAN COLLY FL10ML",
  UCD7: '9011005',
  UCD13: '3400890110051',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOCIDAN COLLY FL10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3231639',
  CIP13: '3400932316397',
  ucdLib: "DULCILARMES SOL OPHT FL10ML",
  UCD7: '9029175',
  UCD13: '3400890291750',
  ucdQtyMultiplicator: 1,
  cipLib: "DULCILARMES SOL OPHT FL10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3113437',
  CIP13: '3400931134374',
  ucdLib: "VIT B12 HOR COLLY FP5ML",
  UCD7: '9100306',
  UCD13: '3400891003062',
  ucdQtyMultiplicator: 1,
  cipLib: "VIT B12 HOR COLLY FP5ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3319481',
  CIP13: '3400933194819',
  ucdLib: "GEL-LARMES GEL OPHT TB10G",
  UCD7: '9154414',
  UCD13: '3400891544145',
  ucdQtyMultiplicator: 1,
  cipLib: "GEL-LARMES GEL OPHT TB10G BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3075599',
  CIP13: '3400930755990',
  ucdLib: "OPHTASILOXANE COLLY FL 10ML",
  UCD7: '9065260',
  UCD13: '3400890652605',
  ucdQtyMultiplicator: 1,
  cipLib: "OPHTASILOXANE COLLY FL 10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3330749',
  CIP13: '3400933307493',
  ucdLib: "UNILARM COLLY UNIDOS",
  UCD7: '9145102',
  UCD13: '3400891451023',
  ucdQtyMultiplicator: 20,
  cipLib: "UNILARM COLLY UNIDOS BT 20",
  atcCode: "S01XA20"
}, {
  CIP7: '3379744',
  CIP13: '3400933797447',
  ucdLib: "CELLUVISC 4MG COLLY UNIDOS",
  UCD7: '9181747',
  UCD13: '3400891817478',
  ucdQtyMultiplicator: 30,
  cipLib: "CELLUVISC 4MG COLLY UNIDOS BT 30",
  atcCode: "S01XA20"
}, {
  CIP7: '3379750',
  CIP13: '3400933797508',
  ucdLib: "CELLUVISC 4MG COLLY UNIDOS",
  UCD7: '9181747',
  UCD13: '3400891817478',
  ucdQtyMultiplicator: 90,
  cipLib: "CELLUVISC 4MG COLLY UNIDOS BT 90",
  atcCode: "S01XA20"
}, {
  CIP7: '3602320',
  CIP13: '3400936023208',
  ucdLib: "FLUIDABAK 1,5% COLLY FL10ML",
  UCD7: '9248173',
  UCD13: '3400892481739',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUIDABAK 1,5% COLLY FL10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3376562',
  CIP13: '3400933765620',
  ucdLib: "LACRYVISC GEL OPHT TB15G",
  UCD7: '9172317',
  UCD13: '3400891723175',
  ucdQtyMultiplicator: 1,
  cipLib: "LACRYVISC GEL OPHT TB15G BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3379603',
  CIP13: '3400933796037',
  ucdLib: "REFRESH COLLY UNIDOS",
  UCD7: '9200077',
  UCD13: '3400892000770',
  ucdQtyMultiplicator: 30,
  cipLib: "REFRESH COLLY UNIDOS BT 30",
  atcCode: "S01XA20"
}, {
  CIP7: '3379626',
  CIP13: '3400933796266',
  ucdLib: "REFRESH COLLY UNIDOS",
  UCD7: '9200077',
  UCD13: '3400892000770',
  ucdQtyMultiplicator: 90,
  cipLib: "REFRESH COLLY UNIDOS BT 90",
  atcCode: "S01XA20"
}, {
  CIP7: '3403589',
  CIP13: '3400934035890',
  ucdLib: "ARTELAC 1,6MG/0,5ML CY DOS",
  UCD7: '9249209',
  UCD13: '3400892492094',
  ucdQtyMultiplicator: 60,
  cipLib: "ARTELAC 1,6MG/0,5ML CY DOS BT 60",
  atcCode: "S01XA20"
}, {
  CIP7: '3352113',
  CIP13: '3400933521134',
  ucdLib: "LACRIGEL GEL OPHT TB10G",
  UCD7: '9158613',
  UCD13: '3400891586138',
  ucdQtyMultiplicator: 1,
  cipLib: "LACRIGEL GEL OPHT TB10G BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3673018',
  CIP13: '3400936730182',
  ucdLib: "VIT B12 CHV COLLY UNIDOS",
  UCD7: '9271841',
  UCD13: '3400892718415',
  ucdQtyMultiplicator: 10,
  cipLib: "VIT B12 CHV COLLY UNIDOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3672987',
  CIP13: '3400936729872',
  ucdLib: "VIT B12 HOR CY UNIDOS0,4ML",
  UCD7: '9273314',
  UCD13: '3400892733142',
  ucdQtyMultiplicator: 20,
  cipLib: "VIT B12 HOR CY UNIDOS0,4ML BT 20",
  atcCode: "S01XA20"
}, {
  CIP7: '3351941',
  CIP13: '3400933519414',
  ucdLib: "VITARUTINE COLLY FL10ML",
  UCD7: '9164200',
  UCD13: '3400891642001',
  ucdQtyMultiplicator: 1,
  cipLib: "VITARUTINE COLLY FL10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3565062',
  CIP13: '3400935650627',
  ucdLib: "GEL-LARMES GEL OPHT UNIDOS",
  UCD7: '9172659',
  UCD13: '3400891726596',
  ucdQtyMultiplicator: 30,
  cipLib: "GEL-LARMES GEL OPHT UNIDOS BT 30",
  atcCode: "S01XA20"
}, {
  CIP7: '3366664',
  CIP13: '3400933666644',
  ucdLib: "LACRINORM 0,2% GEL OPHT TB10G",
  UCD7: '9170577',
  UCD13: '3400891705775',
  ucdQtyMultiplicator: 1,
  cipLib: "LACRINORM 0,2% GEL OPHT TB10G BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3369651',
  CIP13: '3400933696511',
  ucdLib: "LARMES ARTIF. MARTINET CY 10ML",
  UCD7: '9160840',
  UCD13: '3400891608403',
  ucdQtyMultiplicator: 1,
  cipLib: "LARMES ARTIF. MARTINET CY 10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3593101',
  CIP13: '3400935931016',
  ucdLib: "LIPOSIC GEL OPHT TB10G",
  UCD7: '9249215',
  UCD13: '3400892492155',
  ucdQtyMultiplicator: 1,
  cipLib: "LIPOSIC GEL OPHT TB10G BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3412826',
  CIP13: '3400934128264',
  ucdLib: "MONOSEPT COLLY DOS",
  UCD7: '9280449',
  UCD13: '3400892804491',
  ucdQtyMultiplicator: 10,
  cipLib: "MONOSEPT COLLY DOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3514745',
  CIP13: '3400935147455',
  ucdLib: "NOVOPTINE COLLY UNIDOS",
  UCD7: '9213571',
  UCD13: '3400892135717',
  ucdQtyMultiplicator: 10,
  cipLib: "NOVOPTINE COLLY UNIDOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3417522',
  CIP13: '3400934175220',
  ucdLib: "SICCAFLUID 2,5MG/G GEL OPHT10G",
  UCD7: '9198038',
  UCD13: '3400891980387',
  ucdQtyMultiplicator: 1,
  cipLib: "SICCAFLUID 2,5MG/G GEL OPHT10G BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3485506',
  CIP13: '3400934855061',
  ucdLib: "VIT B12 THEA 0,05% CY DOS",
  UCD7: '9231089',
  UCD13: '3400892310893',
  ucdQtyMultiplicator: 20,
  cipLib: "VIT B12 THEA 0,05% CY DOS BT 20",
  atcCode: "S01XA20"
}, {
  CIP7: '3587514',
  CIP13: '3400935875143',
  ucdLib: "HOMEOPTIC COLLY UNIDOS",
  UCD7: '9238016',
  UCD13: '3400892380162',
  ucdQtyMultiplicator: 10,
  cipLib: "HOMEOPTIC COLLY UNIDOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3383496',
  CIP13: '3400933834968',
  ucdLib: "BIOCIDAN 0,1MG COLLY UNIDOS",
  UCD7: '9172406',
  UCD13: '3400891724066',
  ucdQtyMultiplicator: 10,
  cipLib: "BIOCIDAN 0,1MG COLLY UNIDOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3768902',
  CIP13: '3400937689021',
  ucdLib: "LACRIFLUID 0,13% CY UNIDOS",
  UCD7: '9306255',
  UCD13: '3400893062555',
  ucdQtyMultiplicator: 60,
  cipLib: "LACRIFLUID 0,13% CY UNIDOS BT 60",
  atcCode: "S01XA20"
}, {
  CIP7: '3381793',
  CIP13: '3400933817930',
  ucdLib: "LARMABAK 0,9% COLLY FL10ML",
  UCD7: '9181569',
  UCD13: '3400891815696',
  ucdQtyMultiplicator: 1,
  cipLib: "LARMABAK 0,9% COLLY FL10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3690815',
  CIP13: '3400936908154',
  ucdLib: "LARMES ARTIF. MARTINET CY D.",
  UCD7: '9277430',
  UCD13: '3400892774305',
  ucdQtyMultiplicator: 20,
  cipLib: "LARMES ARTIF. MARTINET CY D. BT 20",
  atcCode: "S01XA20"
}, {
  CIP7: '3636684',
  CIP13: '3400936366848',
  ucdLib: "MONOSEPT COLLY DOS",
  UCD7: '9280449',
  UCD13: '3400892804491',
  ucdQtyMultiplicator: 30,
  cipLib: "MONOSEPT COLLY DOS BT 30",
  atcCode: "S01XA20"
}, {
  CIP7: '3449982',
  CIP13: '3400934499821',
  ucdLib: "NUTRIVISC 5% COLLY FL10ML",
  UCD7: '9239487',
  UCD13: '3400892394879',
  ucdQtyMultiplicator: 1,
  cipLib: "NUTRIVISC 5% COLLY FL10ML BT 1",
  atcCode: "S01XA20"
}, {
  CIP7: '3915668',
  CIP13: '3400939156682',
  ucdLib: "AQUAREST 0,2% GEL OPHT DOS",
  UCD7: '9329405',
  UCD13: '3400893294055',
  ucdQtyMultiplicator: 60,
  cipLib: "AQUAREST 0,2% GEL OPHT DOS BT 60",
  atcCode: "S01XA20"
}, {
  CIP7: '2795647',
  CIP13: '3400927956478',
  ucdLib: "DULCILARMES 1,5% COLLY DOS",
  UCD7: '9408926',
  UCD13: '3400894089261',
  ucdQtyMultiplicator: 60,
  cipLib: "DULCILARMES 1,5% COLLY DOS BT 60",
  atcCode: "S01XA20"
}, {
  CIP7: '3425289',
  CIP13: '3400934252891',
  ucdLib: "LACRYVISC GEL OPHT UNIDOS",
  UCD7: '9172346',
  UCD13: '3400891723465',
  ucdQtyMultiplicator: 30,
  cipLib: "LACRYVISC GEL OPHT UNIDOS BT 30",
  atcCode: "S01XA20"
}, {
  CIP7: '3423907',
  CIP13: '3400934239076',
  ucdLib: "NUTRIVISC 5% COLLY UNIDOS",
  UCD7: '9233651',
  UCD13: '3400892336510',
  ucdQtyMultiplicator: 30,
  cipLib: "NUTRIVISC 5% COLLY UNIDOS BT 30",
  atcCode: "S01XA20"
}, {
  CIP7: '3421937',
  CIP13: '3400934219375',
  ucdLib: "SEDACOLLYRE CETYLPYR.CY DOS",
  UCD7: '9194247',
  UCD13: '3400891942477',
  ucdQtyMultiplicator: 10,
  cipLib: "SEDACOLLYRE CETYLPYR.CY DOS BT 10",
  atcCode: "S01XA20"
}, {
  CIP7: '3001064',
  CIP13: '3400930010648',
  ucdLib: "IKERVIS 1MG/ML CY DOS0,3ML",
  UCD7: '9397217',
  UCD13: '3400893972175',
  ucdQtyMultiplicator: 30,
  cipLib: "IKERVIS 1MG/ML CY DOS0,3ML BT 30",
  atcCode: "S01XA18"
}, {
  CIP7: '3194631',
  CIP13: '3400931946311',
  ucdLib: "CORRECTOL 0,1% COLLY FL10ML",
  UCD7: '9022204',
  UCD13: '3400890222044',
  ucdQtyMultiplicator: 1,
  cipLib: "CORRECTOL 0,1% COLLY FL10ML BT 1",
  atcCode: "S01XA10"
}, {
  CIP7: '3130594',
  CIP13: '3400931305941',
  ucdLib: "CATACOL 0,1% COLLY FL10ML",
  UCD7: '9016764',
  UCD13: '3400890167642',
  ucdQtyMultiplicator: 1,
  cipLib: "CATACOL 0,1% COLLY FL10ML BT 1",
  atcCode: "S01XA10"
}, {
  CIP7: '3364777',
  CIP13: '3400933647773',
  ucdLib: "EURONAC 5% COLLY FL5ML",
  UCD7: '9162431',
  UCD13: '3400891624311',
  ucdQtyMultiplicator: 1,
  cipLib: "EURONAC 5% COLLY FL5ML BT 1",
  atcCode: "S01XA08"
}, {
  CIP7: '3113443',
  CIP13: '3400931134435',
  ucdLib: "VIT A DULCIS POM OPHT TB10G",
  UCD7: '9100111',
  UCD13: '3400891001112',
  ucdQtyMultiplicator: 1,
  cipLib: "VIT A DULCIS POM OPHT TB10G BT 1",
  atcCode: "S01XA02"
}, {
  CIP7: '3386187',
  CIP13: '3400933861872',
  ucdLib: "VIT A FAURE 150000UI CY FL10ML",
  UCD7: '9177148',
  UCD13: '3400891771480',
  ucdQtyMultiplicator: 1,
  cipLib: "VIT A FAURE 150000UI CY FL10ML BT 1",
  atcCode: "S01XA02"
}, {
  CIP7: '2678367',
  CIP13: '3400926783679',
  ucdLib: "EYLEA 40MG/ML INJ FL",
  UCD7: '9395394',
  UCD13: '3400893953945',
  ucdQtyMultiplicator: 1,
  cipLib: "EYLEA 40MG/ML INJ FL BT 1",
  atcCode: "S01LA05"
}, {
  CIP7: '2767119',
  CIP13: '3400927671197',
  ucdLib: "LUCENTIS 10MG/ML INJ SRG",
  UCD7: '9400994',
  UCD13: '3400894009948',
  ucdQtyMultiplicator: 1,
  cipLib: "LUCENTIS 10MG/ML INJ SRG BT 1",
  atcCode: "S01LA04"
}, {
  CIP7: '3781015',
  CIP13: '3400937810159',
  ucdLib: "LUCENTIS 10MG/ML INJ FL+NEC",
  UCD7: '9295540',
  UCD13: '3400892955407',
  ucdQtyMultiplicator: 1,
  cipLib: "LUCENTIS 10MG/ML INJ FL+NEC BT 1",
  atcCode: "S01LA04"
}, {
  CIP7: '3553076',
  CIP13: '3400935530769',
  ucdLib: "VISUDYNE 15MG PERF FL10ML 1",
  UCD7: '9221725',
  UCD13: '3400892217253',
  ucdQtyMultiplicator: 1,
  cipLib: "VISUDYNE 15MG PERF FL10ML 1 BT 1",
  atcCode: "S01LA01"
}, {
  CIP7: '3257544',
  CIP13: '3400932575442',
  ucdLib: "FLUORESCEINE 0,5% FAURE CY",
  UCD7: '9105433',
  UCD13: '3400891054330',
  ucdQtyMultiplicator: 100,
  cipLib: "FLUORESCEINE 0,5% FAURE CY BT 100",
  atcCode: "S01JA01"
}, {
  CIP7: '3190283',
  CIP13: '3400931902836',
  ucdLib: "FLUORESCEINE 10% FAURE A.5ML",
  UCD7: '9035738',
  UCD13: '3400890357388',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUORESCEINE 10% FAURE A.5ML BT 1",
  atcCode: "S01JA01"
}, {
  CIP7: '3203376',
  CIP13: '3400932033768',
  ucdLib: "FLUORESCEINE 10% FAURE A.5ML",
  UCD7: '9035738',
  UCD13: '3400890357388',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUORESCEINE 10% FAURE A.5ML BT 10",
  atcCode: "S01JA01"
}, {
  CIP7: '3656698',
  CIP13: '3400936566989',
  ucdLib: "FLUOCYNE 10% INJ AMP5ML",
  UCD7: '9265711',
  UCD13: '3400892657110',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUOCYNE 10% INJ AMP5ML BT 10",
  atcCode: "S01JA01"
}, {
  CIP7: '3695422',
  CIP13: '3400936954229',
  ucdLib: "FLUOCYNE 10% INJ AMP5ML",
  UCD7: '9265711',
  UCD13: '3400892657110',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOCYNE 10% INJ AMP5ML BT 1",
  atcCode: "S01JA01"
}, {
  CIP7: '3762696',
  CIP13: '3400937626965',
  ucdLib: "FLUORESCEINE 0,5% FAURE CY",
  UCD7: '9105433',
  UCD13: '3400891054330',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUORESCEINE 0,5% FAURE CY BT 5",
  atcCode: "S01JA01"
}, {
  CIP7: '3216137',
  CIP13: '3400932161379',
  ucdLib: "TETRACAINE 1% THEA COLLY DOS",
  UCD7: '9105539',
  UCD13: '3400891055399',
  ucdQtyMultiplicator: 100,
  cipLib: "TETRACAINE 1% THEA COLLY DOS BT 100",
  atcCode: "S01HA03"
}, {
  CIP7: '3192342',
  CIP13: '3400931923428',
  ucdLib: "CEBESINE 0,4% COLLY FL10ML",
  UCD7: '9017019',
  UCD13: '3400890170192',
  ucdQtyMultiplicator: 1,
  cipLib: "CEBESINE 0,4% COLLY FL10ML BT 1",
  atcCode: "S01HA02"
}, {
  CIP7: '3657686',
  CIP13: '3400936576865',
  ucdLib: "OXYBUPROCAINE THEA COLLY DOS",
  UCD7: '9160521',
  UCD13: '3400891605211',
  ucdQtyMultiplicator: 20,
  cipLib: "OXYBUPROCAINE THEA COLLY DOS BT 20",
  atcCode: "S01HA02"
}, {
  CIP7: '3657692',
  CIP13: '3400936576926',
  ucdLib: "OXYBUPROCAINE THEA COLLY DOS",
  UCD7: '9160521',
  UCD13: '3400891605211',
  ucdQtyMultiplicator: 100,
  cipLib: "OXYBUPROCAINE THEA COLLY DOS BT 100",
  atcCode: "S01HA02"
}, {
  CIP7: '3622653',
  CIP13: '3400936226531',
  ucdLib: "PURIVIST 0,5MG/ML COLLY FL5ML",
  UCD7: '9257410',
  UCD13: '3400892574103',
  ucdQtyMultiplicator: 1,
  cipLib: "PURIVIST 0,5MG/ML COLLY FL5ML BT 1",
  atcCode: "S01GX10"
}, {
  CIP7: '3598972',
  CIP13: '3400935989727',
  ucdLib: "OPATANOL 1MG/ML COLLY FL5ML",
  UCD7: '9248440',
  UCD13: '3400892484402',
  ucdQtyMultiplicator: 1,
  cipLib: "OPATANOL 1MG/ML COLLY FL5ML BT 1",
  atcCode: "S01GX09"
}, {
  CIP7: '3560774',
  CIP13: '3400935607744',
  ucdLib: "ZALERG 0,25MG/ML COLLY DOS",
  UCD7: '9236885',
  UCD13: '3400892368856',
  ucdQtyMultiplicator: 30,
  cipLib: "ZALERG 0,25MG/ML COLLY DOS BT 30",
  atcCode: "S01GX08"
}, {
  CIP7: '3560745',
  CIP13: '3400935607454',
  ucdLib: "ZALERGONIUM 0,25MG/ML COLLY5ML",
  UCD7: '9236879',
  UCD13: '3400892368795',
  ucdQtyMultiplicator: 1,
  cipLib: "ZALERGONIUM 0,25MG/ML COLLY5ML BT 1",
  atcCode: "S01GX08"
}, {
  CIP7: '2221461',
  CIP13: '3400922214610',
  ucdLib: "MONOKETO 0,25MG/ML COLLY DOS",
  UCD7: '9390617',
  UCD13: '3400893906170',
  ucdQtyMultiplicator: 60,
  cipLib: "MONOKETO 0,25MG/ML COLLY DOS BT 60",
  atcCode: "S01GX08"
}, {
  CIP7: '4925031',
  CIP13: '3400949250318',
  ucdLib: "ZALERG 0,25MG/ML COLLY FL5ML",
  UCD7: '9363098',
  UCD13: '3400893630983',
  ucdQtyMultiplicator: 1,
  cipLib: "ZALERG 0,25MG/ML COLLY FL5ML BT 1",
  atcCode: "S01GX08"
}, {
  CIP7: '3476720',
  CIP13: '3400934767203',
  ucdLib: "ALLERGODIL 0,05% COLLY FP6ML",
  UCD7: '9217273',
  UCD13: '3400892172736',
  ucdQtyMultiplicator: 1,
  cipLib: "ALLERGODIL 0,05% COLLY FP6ML BT 1",
  atcCode: "S01GX07"
}, {
  CIP7: '3362525',
  CIP13: '3400933625252',
  ucdLib: "TILAVIST 2% COLLY FL5ML",
  UCD7: '9262635',
  UCD13: '3400892626352',
  ucdQtyMultiplicator: 1,
  cipLib: "TILAVIST 2% COLLY FL5ML BT 1",
  atcCode: "S01GX04"
}, {
  CIP7: '3267034',
  CIP13: '3400932670345',
  ucdLib: "NAAXIA COLLY FP10ML",
  UCD7: '9205755',
  UCD13: '3400892057552',
  ucdQtyMultiplicator: 1,
  cipLib: "NAAXIA COLLY FP10ML BT 1",
  atcCode: "S01GX03"
}, {
  CIP7: '3267028',
  CIP13: '3400932670284',
  ucdLib: "NAAXIA COLLY FP5ML",
  UCD7: '9060794',
  UCD13: '3400890607940',
  ucdQtyMultiplicator: 1,
  cipLib: "NAAXIA COLLY FP5ML BT 1",
  atcCode: "S01GX03"
}, {
  CIP7: '3356358',
  CIP13: '3400933563585',
  ucdLib: "NAABAK 4,9% COLLY FL10ML",
  UCD7: '9220625',
  UCD13: '3400892206257',
  ucdQtyMultiplicator: 1,
  cipLib: "NAABAK 4,9% COLLY FL10ML BT 1",
  atcCode: "S01GX03"
}, {
  CIP7: '3565151',
  CIP13: '3400935651518',
  ucdLib: "NAABAK COLLY UNIDOS",
  UCD7: '9152869',
  UCD13: '3400891528695',
  ucdQtyMultiplicator: 36,
  cipLib: "NAABAK COLLY UNIDOS BT 36",
  atcCode: "S01GX03"
}, {
  CIP7: '3442678',
  CIP13: '3400934426780',
  ucdLib: "NAABAK COLLY UNIDOS",
  UCD7: '9152869',
  UCD13: '3400891528695',
  ucdQtyMultiplicator: 10,
  cipLib: "NAABAK COLLY UNIDOS BT 10",
  atcCode: "S01GX03"
}, {
  CIP7: '3469163',
  CIP13: '3400934691638',
  ucdLib: "ALLERGIFLASH 0,05% COLLY DOS",
  UCD7: '9350701',
  UCD13: '3400893507018',
  ucdQtyMultiplicator: 10,
  cipLib: "ALLERGIFLASH 0,05% COLLY DOS BT 10",
  atcCode: "S01GX02"
}, {
  CIP7: '3473986',
  CIP13: '3400934739866',
  ucdLib: "LEVOPHTA 0,05% COLLY FL5ML",
  UCD7: '9218054',
  UCD13: '3400892180540',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVOPHTA 0,05% COLLY FL5ML BT 1",
  atcCode: "S01GX02"
}, {
  CIP7: '3913132',
  CIP13: '3400939131320',
  ucdLib: "LEVOFREE 0,05% COLLY UNIDOS",
  UCD7: '9354811',
  UCD13: '3400893548110',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOFREE 0,05% COLLY UNIDOS BT 30",
  atcCode: "S01GX02"
}, {
  CIP7: '3459176',
  CIP13: '3400934591761',
  ucdLib: "CROMOPTIC COLLY FL10ML",
  UCD7: '9218048',
  UCD13: '3400892180489',
  ucdQtyMultiplicator: 1,
  cipLib: "CROMOPTIC COLLY FL10ML BT 1",
  atcCode: "S01GX01"
}, {
  CIP7: '3313550',
  CIP13: '3400933135508',
  ucdLib: "OPTICRON COLLY UNIDOS",
  UCD7: '9136764',
  UCD13: '3400891367645',
  ucdQtyMultiplicator: 10,
  cipLib: "OPTICRON COLLY UNIDOS BT 10",
  atcCode: "S01GX01"
}, {
  CIP7: '3689404',
  CIP13: '3400936894044',
  ucdLib: "OPTICRON COLLY UNIDOS",
  UCD7: '9136764',
  UCD13: '3400891367645',
  ucdQtyMultiplicator: 24,
  cipLib: "OPTICRON COLLY UNIDOS BT 24",
  atcCode: "S01GX01"
}, {
  CIP7: '3405306',
  CIP13: '3400934053061',
  ucdLib: "CROMABAK 20MG/ML COLLY FL10ML",
  UCD7: '9186905',
  UCD13: '3400891869057',
  ucdQtyMultiplicator: 1,
  cipLib: "CROMABAK 20MG/ML COLLY FL10ML BT 1",
  atcCode: "S01GX01"
}, {
  CIP7: '3405329',
  CIP13: '3400934053290',
  ucdLib: "MULTICROM 2% COLLY FL10ML",
  UCD7: '9226160',
  UCD13: '3400892261607',
  ucdQtyMultiplicator: 1,
  cipLib: "MULTICROM 2% COLLY FL10ML BT 1",
  atcCode: "S01GX01"
}, {
  CIP7: '3202980',
  CIP13: '3400932029808',
  ucdLib: "OPTICRON 2% COLLY FL5ML",
  UCD7: '9065455',
  UCD13: '3400890654555',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTICRON 2% COLLY FL5ML BT 1",
  atcCode: "S01GX01"
}, {
  CIP7: '3561578',
  CIP13: '3400935615787',
  ucdLib: "CROMEDIL 2% COLLY UNIDOS",
  UCD7: '9228696',
  UCD13: '3400892286969',
  ucdQtyMultiplicator: 30,
  cipLib: "CROMEDIL 2% COLLY UNIDOS BT 30",
  atcCode: "S01GX01"
}, {
  CIP7: '3567339',
  CIP13: '3400935673398',
  ucdLib: "HUMEX CONJ.ALL.2% COLLY DOS",
  UCD7: '9330101',
  UCD13: '3400893301012',
  ucdQtyMultiplicator: 10,
  cipLib: "HUMEX CONJ.ALL.2% COLLY DOS BT 10",
  atcCode: "S01GX01"
}, {
  CIP7: '3488462',
  CIP13: '3400934884627',
  ucdLib: "CROMADOSES 2% COLLY UNIDOS",
  UCD7: '9230954',
  UCD13: '3400892309545',
  ucdQtyMultiplicator: 30,
  cipLib: "CROMADOSES 2% COLLY UNIDOS BT 30",
  atcCode: "S01GX01"
}, {
  CIP7: '3535664',
  CIP13: '3400935356642',
  ucdLib: "CROMOPTIC 2% COLLY UNIDOS",
  UCD7: '9225982',
  UCD13: '3400892259826',
  ucdQtyMultiplicator: 30,
  cipLib: "CROMOPTIC 2% COLLY UNIDOS BT 30",
  atcCode: "S01GX01"
}, {
  CIP7: '3535670',
  CIP13: '3400935356703',
  ucdLib: "OPHTACALM 2% COLLY UNIDOS",
  UCD7: '9227113',
  UCD13: '3400892271132',
  ucdQtyMultiplicator: 10,
  cipLib: "OPHTACALM 2% COLLY UNIDOS BT 10",
  atcCode: "S01GX01"
}, {
  CIP7: '3542931',
  CIP13: '3400935429315',
  ucdLib: "ALLERGOCOMOD COLLY FL10ML+POMP",
  UCD7: '9237761',
  UCD13: '3400892377612',
  ucdQtyMultiplicator: 1,
  cipLib: "ALLERGOCOMOD COLLY FL10ML+POMP BT 1",
  atcCode: "S01GX01"
}, {
  CIP7: '3469223',
  CIP13: '3400934692239',
  ucdLib: "CROMOFREE 2% COLLY FP10ML",
  UCD7: '9389034',
  UCD13: '3400893890349',
  ucdQtyMultiplicator: 1,
  cipLib: "CROMOFREE 2% COLLY FP10ML BT 1",
  atcCode: "S01GX01"
}, {
  CIP7: '3469217',
  CIP13: '3400934692178',
  ucdLib: "OPHTACALMFREE 2% COLLY FP10ML",
  UCD7: '9355578',
  UCD13: '3400893555781',
  ucdQtyMultiplicator: 1,
  cipLib: "OPHTACALMFREE 2% COLLY FP10ML BT 1",
  atcCode: "S01GX01"
}, {
  CIP7: '4921576',
  CIP13: '3400949215768',
  ucdLib: "CROMOGLICATE BGA 2% CY FL5ML",
  UCD7: '9356862',
  UCD13: '3400893568620',
  ucdQtyMultiplicator: 1,
  cipLib: "CROMOGLICATE BGA 2% CY FL5ML BT 1",
  atcCode: "S01GX01"
}, {
  CIP7: '2789977',
  CIP13: '3400927899775',
  ucdLib: "CROMOGLICATE SDC 2% CY DOS",
  UCD7: '9402071',
  UCD13: '3400894020714',
  ucdQtyMultiplicator: 10,
  cipLib: "CROMOGLICATE SDC 2% CY DOS BT 10",
  atcCode: "S01GX01"
}, {
  CIP7: '3378377',
  CIP13: '3400933783778',
  ucdLib: "VISIODOSE COLLY UNIDOS",
  UCD7: '9172493',
  UCD13: '3400891724936',
  ucdQtyMultiplicator: 10,
  cipLib: "VISIODOSE COLLY UNIDOS BT 10",
  atcCode: "S01GA55"
}, {
  CIP7: '3013285',
  CIP13: '3400930132852',
  ucdLib: "LAITER BLEU COLLY FL10ML",
  UCD7: '9011815',
  UCD13: '3400890118156',
  ucdQtyMultiplicator: 1,
  cipLib: "LAITER BLEU COLLY FL10ML BT 1",
  atcCode: "S01GA51"
}, {
  CIP7: '3231438',
  CIP13: '3400932314386',
  ucdLib: "NEOSYNEPHRINE 10% FAURE CY DOS",
  UCD7: '9105479',
  UCD13: '3400891054798',
  ucdQtyMultiplicator: 100,
  cipLib: "NEOSYNEPHRINE 10% FAURE CY DOS BT 100",
  atcCode: "S01FB01"
}, {
  CIP7: '3217214',
  CIP13: '3400932172146',
  ucdLib: "NEOSYNEPHRINE 10% FAURE CY 5ML",
  UCD7: '9061954',
  UCD13: '3400890619547',
  ucdQtyMultiplicator: 1,
  cipLib: "NEOSYNEPHRINE 10% FAURE CY 5ML BT 1",
  atcCode: "S01FB01"
}, {
  CIP7: '3217208',
  CIP13: '3400932172085',
  ucdLib: "NEOSYNEPHRINE 5% FAURE CY 5ML",
  UCD7: '9061977',
  UCD13: '3400890619776',
  ucdQtyMultiplicator: 1,
  cipLib: "NEOSYNEPHRINE 5% FAURE CY 5ML BT 1",
  atcCode: "S01FB01"
}, {
  CIP7: '2789316',
  CIP13: '3400927893162',
  ucdLib: "NEOSYNEPHRINE 2,5% FAURE CY",
  UCD7: '9406755',
  UCD13: '3400894067559',
  ucdQtyMultiplicator: 20,
  cipLib: "NEOSYNEPHRINE 2,5% FAURE CY BT 20",
  atcCode: "S01FB01"
}, {
  CIP7: '2790928',
  CIP13: '3400927909283',
  ucdLib: "NEOSYNEPHRINE 2,5% FAURE CY",
  UCD7: '9406755',
  UCD13: '3400894067559',
  ucdQtyMultiplicator: 1,
  cipLib: "NEOSYNEPHRINE 2,5% FAURE CY BT 1",
  atcCode: "S01FB01"
}, {
  CIP7: '3537284',
  CIP13: '3400935372840',
  ucdLib: "MYDRIASERT INSERT OPHT",
  UCD7: '9221487',
  UCD13: '3400892214870',
  ucdQtyMultiplicator: 1,
  cipLib: "MYDRIASERT INSERT OPHT BT 1",
  atcCode: "S01FA56"
}, {
  CIP7: '3537290',
  CIP13: '3400935372901',
  ucdLib: "MYDRIASERT INSERT OPHT",
  UCD7: '9221487',
  UCD13: '3400892214870',
  ucdQtyMultiplicator: 20,
  cipLib: "MYDRIASERT INSERT OPHT BT 20",
  atcCode: "S01FA56"
}, {
  CIP7: '5501539',
  CIP13: '3400955015390',
  ucdLib: "MYDRANE INJ AMP0,6ML",
  UCD7: '9415837',
  UCD13: '3400894158370',
  ucdQtyMultiplicator: 20,
  cipLib: "MYDRANE INJ AMP0,6ML BT 20",
  atcCode: "S01FA56"
}, {
  CIP7: '3069498',
  CIP13: '3400930694985',
  ucdLib: "MYDRIATICUM 0,5% COLLY FP10ML",
  UCD7: '9060564',
  UCD13: '3400890605649',
  ucdQtyMultiplicator: 1,
  cipLib: "MYDRIATICUM 0,5% COLLY FP10ML BT 1",
  atcCode: "S01FA06"
}, {
  CIP7: '3432616',
  CIP13: '3400934326165',
  ucdLib: "MYDRIATICUM 2MG/0,4ML CY DOS",
  UCD7: '9177533',
  UCD13: '3400891775334',
  ucdQtyMultiplicator: 1,
  cipLib: "MYDRIATICUM 2MG/0,4ML CY DOS BT 1",
  atcCode: "S01FA06"
}, {
  CIP7: '3397908',
  CIP13: '3400933979089',
  ucdLib: "MYDRIATICUM 2MG/0,4ML CY DOS",
  UCD7: '9177533',
  UCD13: '3400891775334',
  ucdQtyMultiplicator: 100,
  cipLib: "MYDRIATICUM 2MG/0,4ML CY DOS BT 100",
  atcCode: "S01FA06"
}, {
  CIP7: '3216290',
  CIP13: '3400932162901',
  ucdLib: "SKIACOL 0,5% COLLY FL0,5ML",
  UCD7: '9084168',
  UCD13: '3400890841689',
  ucdQtyMultiplicator: 1,
  cipLib: "SKIACOL 0,5% COLLY FL0,5ML BT 1",
  atcCode: "S01FA04"
}, {
  CIP7: '3085379',
  CIP13: '3400930853795',
  ucdLib: "ATROPINE ALC 0,3% COLLY FP10ML",
  UCD7: '9008144',
  UCD13: '3400890081443',
  ucdQtyMultiplicator: 1,
  cipLib: "ATROPINE ALC 0,3% COLLY FP10ML BT 1",
  atcCode: "S01FA01"
}, {
  CIP7: '3085385',
  CIP13: '3400930853856',
  ucdLib: "ATROPINE ALC 0,5% COLLY FP10ML",
  UCD7: '9008167',
  UCD13: '3400890081672',
  ucdQtyMultiplicator: 1,
  cipLib: "ATROPINE ALC 0,5% COLLY FP10ML BT 1",
  atcCode: "S01FA01"
}, {
  CIP7: '3085362',
  CIP13: '3400930853627',
  ucdLib: "ATROPINE ALC 1% COLLY FP10ML",
  UCD7: '9008196',
  UCD13: '3400890081962',
  ucdQtyMultiplicator: 1,
  cipLib: "ATROPINE ALC 1% COLLY FP10ML BT 1",
  atcCode: "S01FA01"
}, {
  CIP7: '3227632',
  CIP13: '3400932276325',
  ucdLib: "ATROPINE 1% FAURE CY DOS",
  UCD7: '9105404',
  UCD13: '3400891054040',
  ucdQtyMultiplicator: 100,
  cipLib: "ATROPINE 1% FAURE CY DOS BT 100",
  atcCode: "S01FA01"
}, {
  CIP7: '3584763',
  CIP13: '3400935847638',
  ucdLib: "TRAVATAN 40MCG/ML CY FL2,5ML",
  UCD7: '9235874',
  UCD13: '3400892358741',
  ucdQtyMultiplicator: 1,
  cipLib: "TRAVATAN 40MCG/ML CY FL2,5ML BT 1",
  atcCode: "S01EE04"
}, {
  CIP7: '4950282',
  CIP13: '3400949502820',
  ucdLib: "TRAVATAN 40Y/ML CY2,5ML ADPMWI",
  UCD7: '9365045',
  UCD13: '3400893650455',
  ucdQtyMultiplicator: 1,
  cipLib: "TRAVATAN 40Y/ML CY2,5ML ADPMWI BT 1",
  atcCode: "S01EE04"
}, {
  CIP7: '3598529',
  CIP13: '3400935985293',
  ucdLib: "LUMIGAN 0,1MG/ML COLLY FL3ML",
  UCD7: '9350724',
  UCD13: '3400893507247',
  ucdQtyMultiplicator: 1,
  cipLib: "LUMIGAN 0,1MG/ML COLLY FL3ML BT 1",
  atcCode: "S01EE03"
}, {
  CIP7: '3592202',
  CIP13: '3400935922021',
  ucdLib: "LUMIGAN 0,3MG/ML COLLY FL3ML",
  UCD7: '9237749',
  UCD13: '3400892377490',
  ucdQtyMultiplicator: 1,
  cipLib: "LUMIGAN 0,3MG/ML COLLY FL3ML BT 1",
  atcCode: "S01EE03"
}, {
  CIP7: '4950008',
  CIP13: '3400949500086',
  ucdLib: "LUMIGAN 0,3MG/ML CY3ML ADP PLA",
  UCD7: '9413353',
  UCD13: '3400894133537',
  ucdQtyMultiplicator: 1,
  cipLib: "LUMIGAN 0,3MG/ML CY3ML ADP PLA BT 1",
  atcCode: "S01EE03"
}, {
  CIP7: '3438406',
  CIP13: '3400934384066',
  ucdLib: "XALATAN 50MCG/ML COLLY F2,5ML",
  UCD7: '9194069',
  UCD13: '3400891940695',
  ucdQtyMultiplicator: 1,
  cipLib: "XALATAN 50MCG/ML COLLY F2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '3438412',
  CIP13: '3400934384127',
  ucdLib: "XALATAN 50MCG/ML COLLY F2,5ML",
  UCD7: '9194069',
  UCD13: '3400891940695',
  ucdQtyMultiplicator: 3,
  cipLib: "XALATAN 50MCG/ML COLLY F2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '3933318',
  CIP13: '3400939333182',
  ucdLib: "LATANOPROST ARW COLLY FL2,5ML",
  UCD7: '9335736',
  UCD13: '3400893357361',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST ARW COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '3933324',
  CIP13: '3400939333243',
  ucdLib: "LATANOPROST ARW COLLY FL2,5ML",
  UCD7: '9335736',
  UCD13: '3400893357361',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST ARW COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '2215302',
  CIP13: '3400922153025',
  ucdLib: "LATANOPROST MYP COLLY FL2,5ML",
  UCD7: '9382931',
  UCD13: '3400893829318',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST MYP COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '2215319',
  CIP13: '3400922153193',
  ucdLib: "LATANOPROST MYP COLLY FL2,5ML",
  UCD7: '9382931',
  UCD13: '3400893829318',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST MYP COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '2213958',
  CIP13: '3400922139586',
  ucdLib: "LATANOPROST ZYD COLLY FL2,5ML",
  UCD7: '9383706',
  UCD13: '3400893837061',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST ZYD COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '4198884',
  CIP13: '3400941988844',
  ucdLib: "LATANOPROST ACT COLLY FL2,5ML",
  UCD7: '9380234',
  UCD13: '3400893802342',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST ACT COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '2193753',
  CIP13: '3400921937534',
  ucdLib: "LATANOPROST SDZ COLLY FL2,5ML",
  UCD7: '9378208',
  UCD13: '3400893782088',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST SDZ COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '2193776',
  CIP13: '3400921937763',
  ucdLib: "LATANOPROST SDZ COLLY FL2,5ML",
  UCD7: '9378208',
  UCD13: '3400893782088',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST SDZ COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '4194596',
  CIP13: '3400941945960',
  ucdLib: "LATANOPROST TVC COLLY FL2,5ML",
  UCD7: '9379834',
  UCD13: '3400893798348',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST TVC COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '4194604',
  CIP13: '3400941946042',
  ucdLib: "LATANOPROST TVC COLLY FL2,5ML",
  UCD7: '9379834',
  UCD13: '3400893798348',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST TVC COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '2181603',
  CIP13: '3400921816037',
  ucdLib: "LATANOPROST ACT COLLY FL2,5ML",
  UCD7: '9380234',
  UCD13: '3400893802342',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST ACT COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '2172231',
  CIP13: '3400921722314',
  ucdLib: "LATANOPROST BGA COLLY FL2,5ML",
  UCD7: '9380174',
  UCD13: '3400893801741',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST BGA COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '2181589',
  CIP13: '3400921815894',
  ucdLib: "LATANOPROST BGA COLLY FL2,5ML",
  UCD7: '9380174',
  UCD13: '3400893801741',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST BGA COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '4161941',
  CIP13: '3400941619410',
  ucdLib: "LATANOPROST EG COLLY FL2,5ML",
  UCD7: '9378869',
  UCD13: '3400893788691',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST EG COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '4161958',
  CIP13: '3400941619588',
  ucdLib: "LATANOPROST EG COLLY FL2,5ML",
  UCD7: '9378869',
  UCD13: '3400893788691',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST EG COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '2237611',
  CIP13: '3400922376110',
  ucdLib: "LATANOPROST PFZ COLLY FL2,5ML",
  UCD7: '9386892',
  UCD13: '3400893868928',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST PFZ COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '2237628',
  CIP13: '3400922376288',
  ucdLib: "LATANOPROST PFZ COLLY FL2,5ML",
  UCD7: '9386892',
  UCD13: '3400893868928',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST PFZ COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '2183944',
  CIP13: '3400921839449',
  ucdLib: "LATANOPROST RBX COLLY FL2,5ML",
  UCD7: '9380205',
  UCD13: '3400893802052',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST RBX COLLY FL2,5ML BT 1",
  atcCode: "S01EE01"
}, {
  CIP7: '2183950',
  CIP13: '3400921839500',
  ucdLib: "LATANOPROST RBX COLLY FL2,5ML",
  UCD7: '9380205',
  UCD13: '3400893802052',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST RBX COLLY FL2,5ML BT 3",
  atcCode: "S01EE01"
}, {
  CIP7: '2673826',
  CIP13: '3400926738266',
  ucdLib: "MONOPROST 50MCG/ML COLLY DOS",
  UCD7: '9392585',
  UCD13: '3400893925850',
  ucdQtyMultiplicator: 30,
  cipLib: "MONOPROST 50MCG/ML COLLY DOS BT 30",
  atcCode: "S01EE01"
}, {
  CIP7: '3002625',
  CIP13: '3400930026250',
  ucdLib: "DORZOLAMIDE/TIM.CRT COLLY 5ML",
  UCD7: '9412916',
  UCD13: '3400894129165',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE/TIM.CRT COLLY 5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3003834',
  CIP13: '3400930038345',
  ucdLib: "DUALKOPT 20+5MG/ML CY FL10ML",
  UCD7: '9408228',
  UCD13: '3400894082286',
  ucdQtyMultiplicator: 1,
  cipLib: "DUALKOPT 20+5MG/ML CY FL10ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3576025',
  CIP13: '3400935760258',
  ucdLib: "XALACOM COLLY FL2,5ML",
  UCD7: '9237028',
  UCD13: '3400892370286',
  ucdQtyMultiplicator: 1,
  cipLib: "XALACOM COLLY FL2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3576031',
  CIP13: '3400935760319',
  ucdLib: "XALACOM COLLY FL2,5ML",
  UCD7: '9237028',
  UCD13: '3400892370286',
  ucdQtyMultiplicator: 3,
  cipLib: "XALACOM COLLY FL2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '4913890',
  CIP13: '3400949138906',
  ucdLib: "DORZOLAMIDE/TIM.TVC COLLY 5ML",
  UCD7: '9356342',
  UCD13: '3400893563427',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE/TIM.TVC COLLY 5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3480638',
  CIP13: '3400934806384',
  ucdLib: "COSOPT COLLY FP5ML",
  UCD7: '9205867',
  UCD13: '3400892058672',
  ucdQtyMultiplicator: 1,
  cipLib: "COSOPT COLLY FP5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '4950009',
  CIP13: '3400949500093',
  ucdLib: "AZARGA COLLY FP5ML ADP MWI",
  UCD7: '9415783',
  UCD13: '3400894157830',
  ucdQtyMultiplicator: 1,
  cipLib: "AZARGA COLLY FP5ML ADP MWI BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '4950313',
  CIP13: '3400949503131',
  ucdLib: "GANFORT COLLY FL3ML ADP MWI",
  UCD7: '9372660',
  UCD13: '3400893726600',
  ucdQtyMultiplicator: 1,
  cipLib: "GANFORT COLLY FL3ML ADP MWI BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3717224',
  CIP13: '3400937172240',
  ucdLib: "COMBIGAN COLLY FL5ML",
  UCD7: '9281472',
  UCD13: '3400892814728',
  ucdQtyMultiplicator: 1,
  cipLib: "COMBIGAN COLLY FL5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3770572',
  CIP13: '3400937705721',
  ucdLib: "COSOPT COLLY UNIDOS0,2ML",
  UCD7: '9317299',
  UCD13: '3400893172995',
  ucdQtyMultiplicator: 60,
  cipLib: "COSOPT COLLY UNIDOS0,2ML BT 60",
  atcCode: "S01ED51"
}, {
  CIP7: '3757494',
  CIP13: '3400937574945',
  ucdLib: "DUOTRAV COLLY FL2,5ML",
  UCD7: '9290749',
  UCD13: '3400892907499',
  ucdQtyMultiplicator: 1,
  cipLib: "DUOTRAV COLLY FL2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3757413',
  CIP13: '3400937574136',
  ucdLib: "GANFORT 0,3MG+5MG/ML CY FL3ML",
  UCD7: '9287210',
  UCD13: '3400892872100',
  ucdQtyMultiplicator: 1,
  cipLib: "GANFORT 0,3MG+5MG/ML CY FL3ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3912664',
  CIP13: '3400939126647',
  ucdLib: "AZARGA COLLY FP5ML",
  UCD7: '9331201',
  UCD13: '3400893312018',
  ucdQtyMultiplicator: 1,
  cipLib: "AZARGA COLLY FP5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '3964359',
  CIP13: '3400939643595',
  ucdLib: "DORZOLAMIDE/TIM.SDZ COLLY 5ML",
  UCD7: '9343641',
  UCD13: '3400893436417',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE/TIM.SDZ COLLY 5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2217471',
  CIP13: '3400922174716',
  ucdLib: "LATANOPROST/TIM.SDZ CY 2,5ML",
  UCD7: '9385266',
  UCD13: '3400893852668',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.SDZ CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '4901208',
  CIP13: '3400949012084',
  ucdLib: "COSOPT COLLY FP5ML AIP PLA IT",
  UCD7: '9391870',
  UCD13: '3400893918708',
  ucdQtyMultiplicator: 1,
  cipLib: "COSOPT COLLY FP5ML AIP PLA IT BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2195953',
  CIP13: '3400921959536',
  ucdLib: "DORZOLAMIDE/TIM.EG COLLY 5ML",
  UCD7: '9382109',
  UCD13: '3400893821091',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE/TIM.EG COLLY 5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '4196069',
  CIP13: '3400941960697',
  ucdLib: "DORZOLAMIDE/TIM.MYL COLLY 5ML",
  UCD7: '9382115',
  UCD13: '3400893821152',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE/TIM.MYL COLLY 5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2756162',
  CIP13: '3400927561627',
  ucdLib: "GANFORT 0,3MG+5MG/ML CY DOS",
  UCD7: '9411839',
  UCD13: '3400894118398',
  ucdQtyMultiplicator: 30,
  cipLib: "GANFORT 0,3MG+5MG/ML CY DOS BT 30",
  atcCode: "S01ED51"
}, {
  CIP7: '2759309',
  CIP13: '3400927593093',
  ucdLib: "LATANOPROST/TIM.BGA CY 2,5ML",
  UCD7: '9402266',
  UCD13: '3400894022664',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.BGA CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2759315',
  CIP13: '3400927593154',
  ucdLib: "LATANOPROST/TIM.BGA CY 2,5ML",
  UCD7: '9402266',
  UCD13: '3400894022664',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.BGA CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '2748085',
  CIP13: '3400927480850',
  ucdLib: "LATANOPROST/TIM.PFZ CY 2,5ML",
  UCD7: '9409305',
  UCD13: '3400894093053',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.PFZ CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2748091',
  CIP13: '3400927480911',
  ucdLib: "LATANOPROST/TIM.PFZ CY 2,5ML",
  UCD7: '9409305',
  UCD13: '3400894093053',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.PFZ CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '2665577',
  CIP13: '3400926655778',
  ucdLib: "LATANOPROST/TIM.ZYD CY 2,5ML",
  UCD7: '9390592',
  UCD13: '3400893905920',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.ZYD CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2665583',
  CIP13: '3400926655839',
  ucdLib: "LATANOPROST/TIM.ZYD CY 2,5ML",
  UCD7: '9390592',
  UCD13: '3400893905920',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.ZYD CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '2732397',
  CIP13: '3400927323973',
  ucdLib: "DORZOLAMIDE/TIM.ARW COLLY 5ML",
  UCD7: '9394064',
  UCD13: '3400893940648',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE/TIM.ARW COLLY 5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2209129',
  CIP13: '3400922091297',
  ucdLib: "DORZOLAMIDE/TIM.BGA COLLY 5ML",
  UCD7: '9384918',
  UCD13: '3400893849187',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE/TIM.BGA COLLY 5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2180963',
  CIP13: '3400921809633',
  ucdLib: "DORZOLAMIDE/TIM.ZEN COLLY 5ML",
  UCD7: '9380398',
  UCD13: '3400893803981',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE/TIM.ZEN COLLY 5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2675216',
  CIP13: '3400926752163',
  ucdLib: "LATANOPROST/TIM.ARW CY 2,5ML",
  UCD7: '9390729',
  UCD13: '3400893907290',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.ARW CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2675222',
  CIP13: '3400926752224',
  ucdLib: "LATANOPROST/TIM.ARW CY 2,5ML",
  UCD7: '9390729',
  UCD13: '3400893907290',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.ARW CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '2231672',
  CIP13: '3400922316727',
  ucdLib: "LATANOPROST/TIM.EG CY 2,5ML",
  UCD7: '9386900',
  UCD13: '3400893869000',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.EG CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2231689',
  CIP13: '3400922316895',
  ucdLib: "LATANOPROST/TIM.EG CY 2,5ML",
  UCD7: '9386900',
  UCD13: '3400893869000',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.EG CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '2231620',
  CIP13: '3400922316208',
  ucdLib: "LATANOPROST/TIM.MYP CY 2,5ML",
  UCD7: '9385941',
  UCD13: '3400893859414',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.MYP CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2231637',
  CIP13: '3400922316376',
  ucdLib: "LATANOPROST/TIM.MYP CY 2,5ML",
  UCD7: '9385941',
  UCD13: '3400893859414',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.MYP CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '2227647',
  CIP13: '3400922276472',
  ucdLib: "LATANOPROST/TIM.SDZ CY 2,5ML",
  UCD7: '9385266',
  UCD13: '3400893852668',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.SDZ CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '2231643',
  CIP13: '3400922316437',
  ucdLib: "LATANOPROST/TIM.TVC CY 2,5ML",
  UCD7: '9388170',
  UCD13: '3400893881705',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.TVC CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2231666',
  CIP13: '3400922316666',
  ucdLib: "LATANOPROST/TIM.TVC CY 2,5ML",
  UCD7: '9388170',
  UCD13: '3400893881705',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.TVC CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '2682676',
  CIP13: '3400926826765',
  ucdLib: "LATANOPROST/TIM.ZEN CY 2,5ML",
  UCD7: '9397950',
  UCD13: '3400893979501',
  ucdQtyMultiplicator: 1,
  cipLib: "LATANOPROST/TIM.ZEN CY 2,5ML BT 1",
  atcCode: "S01ED51"
}, {
  CIP7: '2682682',
  CIP13: '3400926826826',
  ucdLib: "LATANOPROST/TIM.ZEN CY 2,5ML",
  UCD7: '9397950',
  UCD13: '3400893979501',
  ucdQtyMultiplicator: 3,
  cipLib: "LATANOPROST/TIM.ZEN CY 2,5ML BT 3",
  atcCode: "S01ED51"
}, {
  CIP7: '3578892',
  CIP13: '3400935788924',
  ucdLib: "CARTEOL LP 1% COLLY FP3ML",
  UCD7: '9238909',
  UCD13: '3400892389097',
  ucdQtyMultiplicator: 1,
  cipLib: "CARTEOL LP 1% COLLY FP3ML BT 1",
  atcCode: "S01ED05"
}, {
  CIP7: '3578952',
  CIP13: '3400935789525',
  ucdLib: "CARTEOL LP 2% COLLY FP3ML",
  UCD7: '9239412',
  UCD13: '3400892394121',
  ucdQtyMultiplicator: 1,
  cipLib: "CARTEOL LP 2% COLLY FP3ML BT 1",
  atcCode: "S01ED05"
}, {
  CIP7: '3600663',
  CIP13: '3400936006638',
  ucdLib: "CARTEOL LP 1% COLLY UNIDOS",
  UCD7: '9247038',
  UCD13: '3400892470382',
  ucdQtyMultiplicator: 30,
  cipLib: "CARTEOL LP 1% COLLY UNIDOS BT 30",
  atcCode: "S01ED05"
}, {
  CIP7: '3600901',
  CIP13: '3400936009011',
  ucdLib: "CARTEOL LP 2% COLLY UNIDOS",
  UCD7: '9247044',
  UCD13: '3400892470443',
  ucdQtyMultiplicator: 30,
  cipLib: "CARTEOL LP 2% COLLY UNIDOS BT 30",
  atcCode: "S01ED05"
}, {
  CIP7: '3438079',
  CIP13: '3400934380792',
  ucdLib: "CARTEOL 1% COLLY FL3ML",
  UCD7: '9197903',
  UCD13: '3400891979039',
  ucdQtyMultiplicator: 1,
  cipLib: "CARTEOL 1% COLLY FL3ML BT 1",
  atcCode: "S01ED05"
}, {
  CIP7: '3438091',
  CIP13: '3400934380914',
  ucdLib: "CARTEOL 2% COLLY FL3ML",
  UCD7: '9197926',
  UCD13: '3400891979268',
  ucdQtyMultiplicator: 1,
  cipLib: "CARTEOL 2% COLLY FL3ML BT 1",
  atcCode: "S01ED05"
}, {
  CIP7: '3458610',
  CIP13: '3400934586101',
  ucdLib: "BETAGAN 0,5% COLLY UNIDOS",
  UCD7: '9205548',
  UCD13: '3400892055480',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAGAN 0,5% COLLY UNIDOS BT 60",
  atcCode: "S01ED03"
}, {
  CIP7: '3281531',
  CIP13: '3400932815319',
  ucdLib: "BETAGAN 0,5% COLLY FL5ML",
  UCD7: '9392088',
  UCD13: '3400893920886',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAGAN 0,5% COLLY FL5ML BT 1",
  atcCode: "S01ED03"
}, {
  CIP7: '3290458',
  CIP13: '3400932904587',
  ucdLib: "BETOPTIC 0,5% COLLY FP3ML",
  UCD7: '9119895',
  UCD13: '3400891198959',
  ucdQtyMultiplicator: 1,
  cipLib: "BETOPTIC 0,5% COLLY FP3ML BT 1",
  atcCode: "S01ED02"
}, {
  CIP7: '3351295',
  CIP13: '3400933512958',
  ucdLib: "BETOPTIC 0,25% OPHT FL3ML",
  UCD7: '9164275',
  UCD13: '3400891642759',
  ucdQtyMultiplicator: 1,
  cipLib: "BETOPTIC 0,25% OPHT FL3ML BT 1",
  atcCode: "S01ED02"
}, {
  CIP7: '3224326',
  CIP13: '3400932243266',
  ucdLib: "TIMOPTOL 0,25% COLLY FP3ML",
  UCD7: '9093351',
  UCD13: '3400890933513',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOPTOL 0,25% COLLY FP3ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '3224295',
  CIP13: '3400932242955',
  ucdLib: "TIMOPTOL 0,50% COLLY FP3ML",
  UCD7: '9093368',
  UCD13: '3400890933681',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOPTOL 0,50% COLLY FP3ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '3373397',
  CIP13: '3400933733971',
  ucdLib: "TIMOPTOL LP 0,25% COLLY 2,5ML",
  UCD7: '9172702',
  UCD13: '3400891727029',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOPTOL LP 0,25% COLLY 2,5ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '3373405',
  CIP13: '3400933734053',
  ucdLib: "TIMOPTOL LP 0,50% COLLY 2,5ML",
  UCD7: '9172719',
  UCD13: '3400891727197',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOPTOL LP 0,50% COLLY 2,5ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '3404301',
  CIP13: '3400934043017',
  ucdLib: "TIMABAK 0,25% COLLY FL5ML",
  UCD7: '9187000',
  UCD13: '3400891870008',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMABAK 0,25% COLLY FL5ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '3404318',
  CIP13: '3400934043185',
  ucdLib: "TIMABAK 0,50% COLLY FL5ML",
  UCD7: '9187017',
  UCD13: '3400891870176',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMABAK 0,50% COLLY FL5ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '3354632',
  CIP13: '3400933546328',
  ucdLib: "OPHTIM 0,25% COLLY UNIDOS",
  UCD7: '9181581',
  UCD13: '3400891815818',
  ucdQtyMultiplicator: 60,
  cipLib: "OPHTIM 0,25% COLLY UNIDOS BT 60",
  atcCode: "S01ED01"
}, {
  CIP7: '3354649',
  CIP13: '3400933546496',
  ucdLib: "OPHTIM 0,50% COLLY UNIDOS",
  UCD7: '9181598',
  UCD13: '3400891815986',
  ucdQtyMultiplicator: 60,
  cipLib: "OPHTIM 0,50% COLLY UNIDOS BT 60",
  atcCode: "S01ED01"
}, {
  CIP7: '3412737',
  CIP13: '3400934127373',
  ucdLib: "TIMOLOL ALCON 0,50% CY FL5ML",
  UCD7: '9191875',
  UCD13: '3400891918755',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOLOL ALCON 0,50% CY FL5ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '3706829',
  CIP13: '3400937068291',
  ucdLib: "GELTIM LP 1MG/G GEL OPHT DOS",
  UCD7: '9304026',
  UCD13: '3400893040263',
  ucdQtyMultiplicator: 30,
  cipLib: "GELTIM LP 1MG/G GEL OPHT DOS BT 30",
  atcCode: "S01ED01"
}, {
  CIP7: '3546981',
  CIP13: '3400935469816',
  ucdLib: "TIMOCOMOD 0,25% CY FL5ML+POMP",
  UCD7: '9226384',
  UCD13: '3400892263847',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOCOMOD 0,25% CY FL5ML+POMP BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '3546998',
  CIP13: '3400935469984',
  ucdLib: "TIMOCOMOD 0,50% CY FL5ML+POMP",
  UCD7: '9226390',
  UCD13: '3400892263908',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOCOMOD 0,50% CY FL5ML+POMP BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '2243876',
  CIP13: '3400922438764',
  ucdLib: "TIMOLOL SDZ 0,25% COLLY FL5ML",
  UCD7: '9385651',
  UCD13: '3400893856512',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOLOL SDZ 0,25% COLLY FL5ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '2243882',
  CIP13: '3400922438825',
  ucdLib: "TIMOLOL SDZ 0,50% COLLY FL5ML",
  UCD7: '9385668',
  UCD13: '3400893856680',
  ucdQtyMultiplicator: 1,
  cipLib: "TIMOLOL SDZ 0,50% COLLY FL5ML BT 1",
  atcCode: "S01ED01"
}, {
  CIP7: '2792962',
  CIP13: '3400927929625',
  ucdLib: "SIMBRINZA COLLY FL5ML",
  UCD7: '9409877',
  UCD13: '3400894098775',
  ucdQtyMultiplicator: 1,
  cipLib: "SIMBRINZA COLLY FL5ML BT 1",
  atcCode: "S01EC54"
}, {
  CIP7: '3004311',
  CIP13: '3400930043110',
  ucdLib: "BRINZOLAMIDE BGA COLLY FL5ML",
  UCD7: '9422033',
  UCD13: '3400894220336',
  ucdQtyMultiplicator: 1,
  cipLib: "BRINZOLAMIDE BGA COLLY FL5ML BT 1",
  atcCode: "S01EC04"
}, {
  CIP7: '3004632',
  CIP13: '3400930046326',
  ucdLib: "BRINZOLAMIDE CRT COLLY FL5ML",
  UCD7: '9417374',
  UCD13: '3400894173748',
  ucdQtyMultiplicator: 1,
  cipLib: "BRINZOLAMIDE CRT COLLY FL5ML BT 1",
  atcCode: "S01EC04"
}, {
  CIP7: '3004330',
  CIP13: '3400930043301',
  ucdLib: "BRINZOLAMIDE EG COLLY FL5ML",
  UCD7: '9418468',
  UCD13: '3400894184683',
  ucdQtyMultiplicator: 1,
  cipLib: "BRINZOLAMIDE EG COLLY FL5ML BT 1",
  atcCode: "S01EC04"
}, {
  CIP7: '3003288',
  CIP13: '3400930032886',
  ucdLib: "BRINZOLAMIDE MYL COLLY FL5ML",
  UCD7: '9413666',
  UCD13: '3400894136668',
  ucdQtyMultiplicator: 1,
  cipLib: "BRINZOLAMIDE MYL COLLY FL5ML BT 1",
  atcCode: "S01EC04"
}, {
  CIP7: '3543497',
  CIP13: '3400935434975',
  ucdLib: "AZOPT COLLY FL5ML",
  UCD7: '9220571',
  UCD13: '3400892205717',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOPT COLLY FL5ML BT 1",
  atcCode: "S01EC04"
}, {
  CIP7: '4950164',
  CIP13: '3400949501649',
  ucdLib: "AZOPT COLLY FL5ML ADP MWI",
  UCD7: '9341814',
  UCD13: '3400893418147',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOPT COLLY FL5ML ADP MWI BT 1",
  atcCode: "S01EC04"
}, {
  CIP7: '4950098',
  CIP13: '3400949500987',
  ucdLib: "AZOPT COLLY FL5ML ADP PLA",
  UCD7: '9330294',
  UCD13: '3400893302941',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOPT COLLY FL5ML ADP PLA BT 1",
  atcCode: "S01EC04"
}, {
  CIP7: '4987753',
  CIP13: '3400949877539',
  ucdLib: "DORZOLAMIDE EG 2% COLLY 5ML",
  UCD7: '9368871',
  UCD13: '3400893688717',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE EG 2% COLLY 5ML BT 1",
  atcCode: "S01EC03"
}, {
  CIP7: '3385130',
  CIP13: '3400933851309',
  ucdLib: "TRUSOPT 20MG/ML COLLY FL5ML",
  UCD7: '9177846',
  UCD13: '3400891778465',
  ucdQtyMultiplicator: 1,
  cipLib: "TRUSOPT 20MG/ML COLLY FL5ML BT 1",
  atcCode: "S01EC03"
}, {
  CIP7: '3894216',
  CIP13: '3400938942163',
  ucdLib: "DORZOLAMIDE BGA 2% COLLY FL5ML",
  UCD7: '9329411',
  UCD13: '3400893294116',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE BGA 2% COLLY FL5ML BT 1",
  atcCode: "S01EC03"
}, {
  CIP7: '3914893',
  CIP13: '3400939148939',
  ucdLib: "DORZOLAMIDE TVC 2% COLLY 5ML",
  UCD7: '9329428',
  UCD13: '3400893294284',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE TVC 2% COLLY 5ML BT 1",
  atcCode: "S01EC03"
}, {
  CIP7: '4153781',
  CIP13: '3400941537813',
  ucdLib: "DORZOLAMIDE ACT 2% COLLY 5ML",
  UCD7: '9371301',
  UCD13: '3400893713013',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE ACT 2% COLLY 5ML BT 1",
  atcCode: "S01EC03"
}, {
  CIP7: '4960613',
  CIP13: '3400949606139',
  ucdLib: "DORZOLAMIDE MYL 2% COLLY 5ML",
  UCD7: '9363106',
  UCD13: '3400893631065',
  ucdQtyMultiplicator: 1,
  cipLib: "DORZOLAMIDE MYL 2% COLLY 5ML BT 1",
  atcCode: "S01EC03"
}, {
  CIP7: '5533735',
  CIP13: '3400955337355',
  ucdLib: "DIAMOX 500MG INJ FL",
  UCD7: '9026366',
  UCD13: '3400890263665',
  ucdQtyMultiplicator: 25,
  cipLib: "DIAMOX 500MG INJ FL BT 25",
  atcCode: "S01EC01"
}, {
  CIP7: '3030527',
  CIP13: '3400930305270',
  ucdLib: "DIAMOX 250MG CPR SECAB",
  UCD7: '9026343',
  UCD13: '3400890263436',
  ucdQtyMultiplicator: 24,
  cipLib: "DIAMOX 250MG CPR SECAB BT 24",
  atcCode: "S01EC01"
}, {
  CIP7: '3030533',
  CIP13: '3400930305331',
  ucdLib: "DIAMOX 500MG INJ FL+AMP",
  UCD7: '9026372',
  UCD13: '3400890263726',
  ucdQtyMultiplicator: 1,
  cipLib: "DIAMOX 500MG INJ FL+AMP BT 1",
  atcCode: "S01EC01"
}, {
  CIP7: '5676825',
  CIP13: '3400956768257',
  ucdLib: "MIOCHOLE 20MG SOL OCUL FL+A.",
  UCD7: '9290554',
  UCD13: '3400892905549',
  ucdQtyMultiplicator: 1,
  cipLib: "MIOCHOLE 20MG SOL OCUL FL+A. BT 1",
  atcCode: "S01EB09"
}, {
  CIP7: '5668122',
  CIP13: '3400956681228',
  ucdLib: "MIOSTAT 100Y/ML INJ FL1,5ML",
  UCD7: '9284909',
  UCD13: '3400892849096',
  ucdQtyMultiplicator: 12,
  cipLib: "MIOSTAT 100Y/ML INJ FL1,5ML BT 12",
  atcCode: "S01EB02"
}, {
  CIP7: '3325760',
  CIP13: '3400933257606',
  ucdLib: "ISOPTO-PILOCARPINE 2% CY 10ML",
  UCD7: '9161124',
  UCD13: '3400891611243',
  ucdQtyMultiplicator: 1,
  cipLib: "ISOPTO-PILOCARPINE 2% CY 10ML BT 1",
  atcCode: "S01EB01"
}, {
  CIP7: '3241945',
  CIP13: '3400932419456',
  ucdLib: "PILOCARPINE 1% FAURE COLLY",
  UCD7: '9105491',
  UCD13: '3400891054910',
  ucdQtyMultiplicator: 100,
  cipLib: "PILOCARPINE 1% FAURE COLLY BT 100",
  atcCode: "S01EB01"
}, {
  CIP7: '3241968',
  CIP13: '3400932419685',
  ucdLib: "PILOCARPINE 2% FAURE COLLY",
  UCD7: '9105516',
  UCD13: '3400891055160',
  ucdQtyMultiplicator: 100,
  cipLib: "PILOCARPINE 2% FAURE COLLY BT 100",
  atcCode: "S01EB01"
}, {
  CIP7: '3454730',
  CIP13: '3400934547300',
  ucdLib: "ALPHAGAN 0,2% COLLY FL5ML",
  UCD7: '9201504',
  UCD13: '3400892015040',
  ucdQtyMultiplicator: 1,
  cipLib: "ALPHAGAN 0,2% COLLY FL5ML BT 1",
  atcCode: "S01EA05"
}, {
  CIP7: '3952089',
  CIP13: '3400939520896',
  ucdLib: "BRIMONIDINE CHV0,2% CY FL5ML",
  UCD7: '9340909',
  UCD13: '3400893409091',
  ucdQtyMultiplicator: 1,
  cipLib: "BRIMONIDINE CHV0,2% CY FL5ML BT 1",
  atcCode: "S01EA05"
}, {
  CIP7: '3895948',
  CIP13: '3400938959482',
  ucdLib: "BRIMONIDINE EG 0,2% CY FL5ML",
  UCD7: '9327010',
  UCD13: '3400893270103',
  ucdQtyMultiplicator: 1,
  cipLib: "BRIMONIDINE EG 0,2% CY FL5ML BT 1",
  atcCode: "S01EA05"
}, {
  CIP7: '3895842',
  CIP13: '3400938958423',
  ucdLib: "BRIMONIDINE MYL0,2% CY FL5ML",
  UCD7: '9328564',
  UCD13: '3400893285640',
  ucdQtyMultiplicator: 1,
  cipLib: "BRIMONIDINE MYL0,2% CY FL5ML BT 1",
  atcCode: "S01EA05"
}, {
  CIP7: '3930886',
  CIP13: '3400939308869',
  ucdLib: "BRIMONIDINE SDZ0,2% CY FL5ML",
  UCD7: '9332614',
  UCD13: '3400893326145',
  ucdQtyMultiplicator: 1,
  cipLib: "BRIMONIDINE SDZ0,2% CY FL5ML BT 1",
  atcCode: "S01EA05"
}, {
  CIP7: '3914947',
  CIP13: '3400939149479',
  ucdLib: "BRIMONIDINE TVC0,2% CY FL5ML",
  UCD7: '9328587',
  UCD13: '3400893285879',
  ucdQtyMultiplicator: 1,
  cipLib: "BRIMONIDINE TVC0,2% CY FL5ML BT 1",
  atcCode: "S01EA05"
}, {
  CIP7: '3410543',
  CIP13: '3400934105432',
  ucdLib: "IOPIDINE 1% COLLY UNIDOS",
  UCD7: '9196542',
  UCD13: '3400891965421',
  ucdQtyMultiplicator: 2,
  cipLib: "IOPIDINE 1% COLLY UNIDOS BT 2",
  atcCode: "S01EA03"
}, {
  CIP7: '3383898',
  CIP13: '3400933838980',
  ucdLib: "IOPIDINE 0,5% COLLY FL5ML",
  UCD7: '9176976',
  UCD13: '3400891769760',
  ucdQtyMultiplicator: 1,
  cipLib: "IOPIDINE 0,5% COLLY FL5ML BT 1",
  atcCode: "S01EA03"
}, {
  CIP7: '3545906',
  CIP13: '3400935459060',
  ucdLib: "INDOBIOTIC COLLY UNIDOS",
  UCD7: '9232692',
  UCD13: '3400892326924',
  ucdQtyMultiplicator: 20,
  cipLib: "INDOBIOTIC COLLY UNIDOS BT 20",
  atcCode: "S01CC02"
}, {
  CIP7: '3065253',
  CIP13: '3400930652534',
  ucdLib: "MAXIDROL COLLY FL3ML",
  UCD7: '9057177',
  UCD13: '3400890571777',
  ucdQtyMultiplicator: 1,
  cipLib: "MAXIDROL COLLY FL3ML BT 1",
  atcCode: "S01CA01"
}, {
  CIP7: '3021741',
  CIP13: '3400930217412',
  ucdLib: "CHIBRO-CADRON COLLY FL5ML",
  UCD7: '9018906',
  UCD13: '3400890189064',
  ucdQtyMultiplicator: 1,
  cipLib: "CHIBRO-CADRON COLLY FL5ML BT 1",
  atcCode: "S01CA01"
}, {
  CIP7: '3264521',
  CIP13: '3400932645213',
  ucdLib: "FRAKIDEX POM OPHT TB5G",
  UCD7: '9036258',
  UCD13: '3400890362580',
  ucdQtyMultiplicator: 1,
  cipLib: "FRAKIDEX POM OPHT TB5G BT 1",
  atcCode: "S01CA01"
}, {
  CIP7: '3198356',
  CIP13: '3400931983569',
  ucdLib: "MAXIDROL POM OPHT TB3,5G",
  UCD7: '9057183',
  UCD13: '3400890571838',
  ucdQtyMultiplicator: 1,
  cipLib: "MAXIDROL POM OPHT TB3,5G BT 1",
  atcCode: "S01CA01"
}, {
  CIP7: '3138414',
  CIP13: '3400931384144',
  ucdLib: "STERDEX POM OPHT UNIDOS",
  UCD7: '9087735',
  UCD13: '3400890877350',
  ucdQtyMultiplicator: 12,
  cipLib: "STERDEX POM OPHT UNIDOS BT 12",
  atcCode: "S01CA01"
}, {
  CIP7: '3473495',
  CIP13: '3400934734953',
  ucdLib: "FRAKIDEX COLLY FP5ML",
  UCD7: '9202892',
  UCD13: '3400892028927',
  ucdQtyMultiplicator: 1,
  cipLib: "FRAKIDEX COLLY FP5ML BT 1",
  atcCode: "S01CA01"
}, {
  CIP7: '3442997',
  CIP13: '3400934429972',
  ucdLib: "TOBRADEX COLLY FL5ML",
  UCD7: '9201361',
  UCD13: '3400892013619',
  ucdQtyMultiplicator: 1,
  cipLib: "TOBRADEX COLLY FL5ML BT 1",
  atcCode: "S01CA01"
}, {
  CIP7: '2160469',
  CIP13: '3400921604696',
  ucdLib: "YELLOX 0,9MG/ML COLLY FL5ML",
  UCD7: '9377812',
  UCD13: '3400893778128',
  ucdQtyMultiplicator: 1,
  cipLib: "YELLOX 0,9MG/ML COLLY FL5ML BT 1",
  atcCode: "S01BC11"
}, {
  CIP7: '3098040',
  CIP13: '3400930980408',
  ucdLib: "SOPHTAL 0,1% COLLY FL10ML",
  UCD7: '9086144',
  UCD13: '3400890861441',
  ucdQtyMultiplicator: 1,
  cipLib: "SOPHTAL 0,1% COLLY FL10ML BT 1",
  atcCode: "S01BC08"
}, {
  CIP7: '3650856',
  CIP13: '3400936508569',
  ucdLib: "CIELLA 0,1% LAV OPHT UNIDOS",
  UCD7: '9267489',
  UCD13: '3400892674896',
  ucdQtyMultiplicator: 20,
  cipLib: "CIELLA 0,1% LAV OPHT UNIDOS BT 20",
  atcCode: "S01BC08"
}, {
  CIP7: '3641745',
  CIP13: '3400936417458',
  ucdLib: "ANTALYRE COLLY DOS0,4ML",
  UCD7: '9261297',
  UCD13: '3400892612973',
  ucdQtyMultiplicator: 10,
  cipLib: "ANTALYRE COLLY DOS0,4ML BT 10",
  atcCode: "S01BC08"
}, {
  CIP7: '3342959',
  CIP13: '3400933429591',
  ucdLib: "ACULAR 0,5% COLLY FL5ML",
  UCD7: '9210124',
  UCD13: '3400892101248',
  ucdQtyMultiplicator: 1,
  cipLib: "ACULAR 0,5% COLLY FL5ML BT 1",
  atcCode: "S01BC05"
}, {
  CIP7: '3344349',
  CIP13: '3400933443498',
  ucdLib: "OCUFEN 0,12MG/0,4ML CY DOS",
  UCD7: '9154360',
  UCD13: '3400891543605',
  ucdQtyMultiplicator: 20,
  cipLib: "OCUFEN 0,12MG/0,4ML CY DOS BT 20",
  atcCode: "S01BC04"
}, {
  CIP7: '3350261',
  CIP13: '3400933502614',
  ucdLib: "OCUFEN 0,12MG/0,4ML CY DOS",
  UCD7: '9154360',
  UCD13: '3400891543605',
  ucdQtyMultiplicator: 50,
  cipLib: "OCUFEN 0,12MG/0,4ML CY DOS BT 50",
  atcCode: "S01BC04"
}, {
  CIP7: '3386862',
  CIP13: '3400933868628',
  ucdLib: "VOLTARENOPHTA 0,1% CY DOS",
  UCD7: '9177355',
  UCD13: '3400891773552',
  ucdQtyMultiplicator: 20,
  cipLib: "VOLTARENOPHTA 0,1% CY DOS BT 20",
  atcCode: "S01BC03"
}, {
  CIP7: '3386879',
  CIP13: '3400933868796',
  ucdLib: "VOLTARENOPHTA 0,1% CY DOS",
  UCD7: '9177355',
  UCD13: '3400891773552',
  ucdQtyMultiplicator: 100,
  cipLib: "VOLTARENOPHTA 0,1% CY DOS BT 100",
  atcCode: "S01BC03"
}, {
  CIP7: '3668224',
  CIP13: '3400936682245',
  ucdLib: "VOLTARENOPHTABAK COLLY FL10ML",
  UCD7: '9298248',
  UCD13: '3400892982489',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLTARENOPHTABAK COLLY FL10ML BT 1",
  atcCode: "S01BC03"
}, {
  CIP7: '3419538',
  CIP13: '3400934195389',
  ucdLib: "INDOCOLLYRE 0,1% COLLY FL5ML",
  UCD7: '9194359',
  UCD13: '3400891943597',
  ucdQtyMultiplicator: 1,
  cipLib: "INDOCOLLYRE 0,1% COLLY FL5ML BT 1",
  atcCode: "S01BC01"
}, {
  CIP7: '3464668',
  CIP13: '3400934646683',
  ucdLib: "INDOCOLLYRE 0,1% COLLY DOS",
  UCD7: '9196252',
  UCD13: '3400891962529',
  ucdQtyMultiplicator: 20,
  cipLib: "INDOCOLLYRE 0,1% COLLY DOS BT 20",
  atcCode: "S01BC01"
}, {
  CIP7: '5606730',
  CIP13: '3400956067305',
  ucdLib: "INDOCOLLYRE 0,1% COLLY DOS",
  UCD7: '9196252',
  UCD13: '3400891962529',
  ucdQtyMultiplicator: 50,
  cipLib: "INDOCOLLYRE 0,1% COLLY DOS BT 50",
  atcCode: "S01BC01"
}, {
  CIP7: '3242028',
  CIP13: '3400932420285',
  ucdLib: "FLUCON COLLY FL3ML",
  UCD7: '9035425',
  UCD13: '3400890354257',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCON COLLY FL3ML BT 1",
  atcCode: "S01BA07"
}, {
  CIP7: '3065247',
  CIP13: '3400930652473',
  ucdLib: "MAXIDEX 0,1% COLLY FL3ML",
  UCD7: '9057160',
  UCD13: '3400890571609',
  ucdQtyMultiplicator: 1,
  cipLib: "MAXIDEX 0,1% COLLY FL3ML BT 1",
  atcCode: "S01BA01"
}, {
  CIP7: '3747768',
  CIP13: '3400937477680',
  ucdLib: "DEXAFREE 1MG/ML COLLY DOS",
  UCD7: '9300815',
  UCD13: '3400893008157',
  ucdQtyMultiplicator: 30,
  cipLib: "DEXAFREE 1MG/ML COLLY DOS BT 30",
  atcCode: "S01BA01"
}, {
  CIP7: '4940711',
  CIP13: '3400949407118',
  ucdLib: "OZURDEX 700MCG IMPL SACH 1",
  UCD7: '9355064',
  UCD13: '3400893550649',
  ucdQtyMultiplicator: 1,
  cipLib: "OZURDEX 700MCG IMPL SACH 1 BT 1",
  atcCode: "S01BA01"
}, {
  CIP7: '5623094',
  CIP13: '3400956230945',
  ucdLib: "BETADINE 5% IRR OCUL FL20ML",
  UCD7: '9220039',
  UCD13: '3400892200392',
  ucdQtyMultiplicator: 20,
  cipLib: "BETADINE 5% IRR OCUL FL20ML BT 20",
  atcCode: "S01AX18"
}, {
  CIP7: '3227980',
  CIP13: '3400932279807',
  ucdLib: "VITABACT 0,05% COLLY FL10ML",
  UCD7: '9099201',
  UCD13: '3400890992015',
  ucdQtyMultiplicator: 1,
  cipLib: "VITABACT 0,05% COLLY FL10ML BT 1",
  atcCode: "S01AX16"
}, {
  CIP7: '3371487',
  CIP13: '3400933714871',
  ucdLib: "VITABACT COLLY UNIDOS",
  UCD7: '9182379',
  UCD13: '3400891823790',
  ucdQtyMultiplicator: 10,
  cipLib: "VITABACT COLLY UNIDOS BT 10",
  atcCode: "S01AX16"
}, {
  CIP7: '3371493',
  CIP13: '3400933714932',
  ucdLib: "VITABACT COLLY UNIDOS",
  UCD7: '9182379',
  UCD13: '3400891823790',
  ucdQtyMultiplicator: 100,
  cipLib: "VITABACT COLLY UNIDOS BT 100",
  atcCode: "S01AX16"
}, {
  CIP7: '3029955',
  CIP13: '3400930299555',
  ucdLib: "DESOMEDINE OPHT ORL FL10ML",
  UCD7: '9025674',
  UCD13: '3400890256742',
  ucdQtyMultiplicator: 1,
  cipLib: "DESOMEDINE OPHT ORL FL10ML BT 1",
  atcCode: "S01AX08"
}, {
  CIP7: '3486799',
  CIP13: '3400934867996',
  ucdLib: "DESOMEDINE 0,1% COLLY 0,6ML",
  UCD7: '9214079',
  UCD13: '3400892140797',
  ucdQtyMultiplicator: 10,
  cipLib: "DESOMEDINE 0,1% COLLY 0,6ML BT 10",
  atcCode: "S01AX08"
}, {
  CIP7: '3610992',
  CIP13: '3400936109926',
  ucdLib: "DACRYUM SOL OPHT UNIDOS5ML",
  UCD7: '9247587',
  UCD13: '3400892475875',
  ucdQtyMultiplicator: 30,
  cipLib: "DACRYUM SOL OPHT UNIDOS5ML BT 30",
  atcCode: "S01AX07"
}, {
  CIP7: '3028039',
  CIP13: '3400930280393',
  ucdLib: "DACRYOSERUM SOL OPHT FL150ML",
  UCD7: '9023793',
  UCD13: '3400890237932',
  ucdQtyMultiplicator: 1,
  cipLib: "DACRYOSERUM SOL OPHT FL150ML BT 1",
  atcCode: "S01AX07"
}, {
  CIP7: '3601898',
  CIP13: '3400936018983',
  ucdLib: "DACRYUM SOL OPHT UNIDOS5ML",
  UCD7: '9247587',
  UCD13: '3400892475875',
  ucdQtyMultiplicator: 15,
  cipLib: "DACRYUM SOL OPHT UNIDOS5ML BT 15",
  atcCode: "S01AX07"
}, {
  CIP7: '3816736',
  CIP13: '3400938167368',
  ucdLib: "BORAX/BORIQ.BGA12/18MG 5ML",
  UCD7: '9310050',
  UCD13: '3400893100509',
  ucdQtyMultiplicator: 20,
  cipLib: "BORAX/BORIQ.BGA12/18MG 5ML BT 20",
  atcCode: "S01AX07"
}, {
  CIP7: '3742274',
  CIP13: '3400937422741',
  ucdLib: "STERIDOSE SOL OPHT DOS10ML",
  UCD7: '9294084',
  UCD13: '3400892940847',
  ucdQtyMultiplicator: 10,
  cipLib: "STERIDOSE SOL OPHT DOS10ML BT 10",
  atcCode: "S01AX07"
}, {
  CIP7: '3742297',
  CIP13: '3400937422970',
  ucdLib: "STERIDOSE SOL OPHT DOS10ML",
  UCD7: '9294084',
  UCD13: '3400892940847',
  ucdQtyMultiplicator: 20,
  cipLib: "STERIDOSE SOL OPHT DOS10ML BT 20",
  atcCode: "S01AX07"
}, {
  CIP7: '3473265',
  CIP13: '3400934732652',
  ucdLib: "DACRYOSERUM SOL OPHT DOS5ML",
  UCD7: '9210130',
  UCD13: '3400892101309',
  ucdQtyMultiplicator: 20,
  cipLib: "DACRYOSERUM SOL OPHT DOS5ML BT 20",
  atcCode: "S01AX07"
}, {
  CIP7: '3479670',
  CIP13: '3400934796708',
  ucdLib: "DACUDOSES OPHT UNIDOS10ML",
  UCD7: '9198179',
  UCD13: '3400891981797',
  ucdQtyMultiplicator: 24,
  cipLib: "DACUDOSES OPHT UNIDOS10ML BT 24",
  atcCode: "S01AX07"
}, {
  CIP7: '3442744',
  CIP13: '3400934427442',
  ucdLib: "DACUDOSES OPHT UNIDOS10ML",
  UCD7: '9198179',
  UCD13: '3400891981797',
  ucdQtyMultiplicator: 16,
  cipLib: "DACUDOSES OPHT UNIDOS10ML BT 16",
  atcCode: "S01AX07"
}, {
  CIP7: '3973594',
  CIP13: '3400939735948',
  ucdLib: "BORAX/BORIQ.BGC12/18MG 5ML",
  UCD7: '9344215',
  UCD13: '3400893442159',
  ucdQtyMultiplicator: 15,
  cipLib: "BORAX/BORIQ.BGC12/18MG 5ML BT 15",
  atcCode: "S01AX07"
}, {
  CIP7: '4178048',
  CIP13: '3400941780486',
  ucdLib: "BORAX/BORIQ.ZEN12/18MG 5ML",
  UCD7: '9375210',
  UCD13: '3400893752104',
  ucdQtyMultiplicator: 20,
  cipLib: "BORAX/BORIQ.ZEN12/18MG 5ML BT 20",
  atcCode: "S01AX07"
}, {
  CIP7: '4198708',
  CIP13: '3400941987083',
  ucdLib: "NETDOSE 12MG/18MG/ML D.10ML",
  UCD7: '9413258',
  UCD13: '3400894132585',
  ucdQtyMultiplicator: 20,
  cipLib: "NETDOSE 12MG/18MG/ML D.10ML BT 20",
  atcCode: "S01AX07"
}, {
  CIP7: '3373753',
  CIP13: '3400933737535',
  ucdLib: "CILOXAN 0,3% COLLY FL5ML",
  UCD7: '9194253',
  UCD13: '3400891942538',
  ucdQtyMultiplicator: 1,
  cipLib: "CILOXAN 0,3% COLLY FL5ML BT 1",
  atcCode: "S01AE03"
}, {
  CIP7: '3592277',
  CIP13: '3400935922779',
  ucdLib: "CILOXAN 0,3% POM OPHT TB3,5G",
  UCD7: '9247529',
  UCD13: '3400892475295',
  ucdQtyMultiplicator: 1,
  cipLib: "CILOXAN 0,3% POM OPHT TB3,5G BT 1",
  atcCode: "S01AE03"
}, {
  CIP7: '3313225',
  CIP13: '3400933132255',
  ucdLib: "CHIBROXINE 0,3% COLLY FP5ML",
  UCD7: '9143296',
  UCD13: '3400891432961',
  ucdQtyMultiplicator: 1,
  cipLib: "CHIBROXINE 0,3% COLLY FP5ML BT 1",
  atcCode: "S01AE02"
}, {
  CIP7: '3317080',
  CIP13: '3400933170806',
  ucdLib: "EXOCINE 0,3% COLLY FP5ML",
  UCD7: '9143474',
  UCD13: '3400891434743',
  ucdQtyMultiplicator: 1,
  cipLib: "EXOCINE 0,3% COLLY FP5ML BT 1",
  atcCode: "S01AE01"
}, {
  CIP7: '2661912',
  CIP13: '3400926619121',
  ucdLib: "MONOOX 1,5MG COLLY UNIDOS",
  UCD7: '9390043',
  UCD13: '3400893900437',
  ucdQtyMultiplicator: 20,
  cipLib: "MONOOX 1,5MG COLLY UNIDOS BT 20",
  atcCode: "S01AE01"
}, {
  CIP7: '4995267',
  CIP13: '3400949952670',
  ucdLib: "QUINOFREE 1,5MG/0,5 ML CY D.20",
  UCD7: '9386395',
  UCD13: '3400893863954',
  ucdQtyMultiplicator: 20,
  cipLib: "QUINOFREE 1,5MG/0,5 ML CY D.20 BT 20",
  atcCode: "S01AE01"
}, {
  CIP7: '3395128',
  CIP13: '3400933951283',
  ucdLib: "VIRGAN 1,5MG/G GEL OPHT TB5G",
  UCD7: '9181629',
  UCD13: '3400891816297',
  ucdQtyMultiplicator: 1,
  cipLib: "VIRGAN 1,5MG/G GEL OPHT TB5G BT 1",
  atcCode: "S01AD09"
}, {
  CIP7: '3253954',
  CIP13: '3400932539543',
  ucdLib: "ZOVIRAX 3% POM OPHT TB4,5G",
  UCD7: '9102127',
  UCD13: '3400891021271',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOVIRAX 3% POM OPHT TB4,5G BT 1",
  atcCode: "S01AD03"
}, {
  CIP7: '3266968',
  CIP13: '3400932669684',
  ucdLib: "VIROPHTA COLLY FL+FL",
  UCD7: '9098957',
  UCD13: '3400890989572',
  ucdQtyMultiplicator: 1,
  cipLib: "VIROPHTA COLLY FL+FL BT 1",
  atcCode: "S01AD02"
}, {
  CIP7: '3432438',
  CIP13: '3400934324383',
  ucdLib: "ATEBEMYXINE COLLY FP10ML",
  UCD7: '9199339',
  UCD13: '3400891993394',
  ucdQtyMultiplicator: 1,
  cipLib: "ATEBEMYXINE COLLY FP10ML BT 1",
  atcCode: "S01AA30"
}, {
  CIP7: '3405660',
  CIP13: '3400934056604',
  ucdLib: "ATEBEMYXINE POM OPHT TB5G",
  UCD7: '9190752',
  UCD13: '3400891907520',
  ucdQtyMultiplicator: 1,
  cipLib: "ATEBEMYXINE POM OPHT TB5G BT 1",
  atcCode: "S01AA30"
}, {
  CIP7: '3432421',
  CIP13: '3400934324215',
  ucdLib: "CEBEMYXINE COLLY FP10ML",
  UCD7: '9200841',
  UCD13: '3400892008417',
  ucdQtyMultiplicator: 1,
  cipLib: "CEBEMYXINE COLLY FP10ML BT 1",
  atcCode: "S01AA30"
}, {
  CIP7: '3145041',
  CIP13: '3400931450412',
  ucdLib: "CEBEMYXINE POM OPHT TB5G",
  UCD7: '9016965',
  UCD13: '3400890169653',
  ucdQtyMultiplicator: 1,
  cipLib: "CEBEMYXINE POM OPHT TB5G BT 1",
  atcCode: "S01AA30"
}, {
  CIP7: '2241044',
  CIP13: '3400922410449',
  ucdLib: "APROKAM 50MG PDR INJ FL",
  UCD7: '9385852',
  UCD13: '3400893858523',
  ucdQtyMultiplicator: 1,
  cipLib: "APROKAM 50MG PDR INJ FL BT 1",
  atcCode: "S01AA27"
}, {
  CIP7: '5829565',
  CIP13: '3400958295652',
  ucdLib: "APROKAM 50MG PDR INJ FL",
  UCD7: '9385852',
  UCD13: '3400893858523',
  ucdQtyMultiplicator: 10,
  cipLib: "APROKAM 50MG PDR INJ FL BT 10",
  atcCode: "S01AA27"
}, {
  CIP7: '3820382',
  CIP13: '3400938203820',
  ucdLib: "AZYTER COLLY UNIDOS",
  UCD7: '9314208',
  UCD13: '3400893142080',
  ucdQtyMultiplicator: 6,
  cipLib: "AZYTER COLLY UNIDOS BT 6",
  atcCode: "S01AA26"
}, {
  CIP7: '3091523',
  CIP13: '3400930915233',
  ucdLib: "RIFAMYCINE CHIBR COLLY FL10ML",
  UCD7: '9080302',
  UCD13: '3400890803021',
  ucdQtyMultiplicator: 1,
  cipLib: "RIFAMYCINE CHIBR COLLY FL10ML BT 1",
  atcCode: "S01AA16"
}, {
  CIP7: '3091546',
  CIP13: '3400930915462',
  ucdLib: "RIFAMYCINE CHIBR POM OPHT TB5G",
  UCD7: '9080319',
  UCD13: '3400890803199',
  ucdQtyMultiplicator: 1,
  cipLib: "RIFAMYCINE CHIBR POM OPHT TB5G BT 1",
  atcCode: "S01AA16"
}, {
  CIP7: '3319133',
  CIP13: '3400933191337',
  ucdLib: "FUCITHALMIC 1% GEL OPHT TB3G",
  UCD7: '9140062',
  UCD13: '3400891400625',
  ucdQtyMultiplicator: 1,
  cipLib: "FUCITHALMIC 1% GEL OPHT TB3G BT 1",
  atcCode: "S01AA13"
}, {
  CIP7: '3280543',
  CIP13: '3400932805433',
  ucdLib: "TOBREX 0,3% COLLY FL5ML",
  UCD7: '9125536',
  UCD13: '3400891255362',
  ucdQtyMultiplicator: 1,
  cipLib: "TOBREX 0,3% COLLY FL5ML BT 1",
  atcCode: "S01AA12"
}, {
  CIP7: '3280537',
  CIP13: '3400932805372',
  ucdLib: "TOBREX 0,3% POM OPHT TB5G",
  UCD7: '9125542',
  UCD13: '3400891255423',
  ucdQtyMultiplicator: 1,
  cipLib: "TOBREX 0,3% POM OPHT TB5G BT 1",
  atcCode: "S01AA12"
}, {
  CIP7: '3533406',
  CIP13: '3400935334060',
  ucdLib: "TOBRABACT 0,3% COLLY FL5ML",
  UCD7: '9301849',
  UCD13: '3400893018491',
  ucdQtyMultiplicator: 1,
  cipLib: "TOBRABACT 0,3% COLLY FL5ML BT 1",
  atcCode: "S01AA12"
}, {
  CIP7: '3421334',
  CIP13: '3400934213342',
  ucdLib: "AUREOMYCINE EVM 1% OPHT 5G",
  UCD7: '9200717',
  UCD13: '3400892007175',
  ucdQtyMultiplicator: 1,
  cipLib: "AUREOMYCINE EVM 1% OPHT 5G BT 1",
  atcCode: "S01AA02"
}, {
  CIP7: '3004101',
  CIP13: '3400930041017',
  ucdLib: "ORKAMBI 200MG/125MG CPR",
  UCD7: '9415903',
  UCD13: '3400894159032',
  ucdQtyMultiplicator: 112,
  cipLib: "ORKAMBI 200MG/125MG CPR BT 112",
  atcCode: "R07AX30"
}, {
  CIP7: '2660611',
  CIP13: '3400926606114',
  ucdLib: "KALYDECO 150MG CPR PELLIC",
  UCD7: '9385929',
  UCD13: '3400893859292',
  ucdQtyMultiplicator: 56,
  cipLib: "KALYDECO 150MG CPR PELLIC BT 56",
  atcCode: "R07AX02"
}, {
  CIP7: '5634028',
  CIP13: '3400956340286',
  ucdLib: "INOMAX 400PPM M/MOL BOUT 10L",
  UCD7: '9235905',
  UCD13: '3400892359052',
  ucdQtyMultiplicator: 1,
  cipLib: "INOMAX 400PPM M/MOL BOUT 10L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5722146',
  CIP13: '3400957221461',
  ucdLib: "KINOX 225 M/MOL BOUT ALU 20L",
  UCD7: '9310630',
  UCD13: '3400893106303',
  ucdQtyMultiplicator: 1,
  cipLib: "KINOX 225 M/MOL BOUT ALU 20L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5722123',
  CIP13: '3400957221232',
  ucdLib: "KINOX 225 M/MOL BOUT ALU 5L",
  UCD7: '9310647',
  UCD13: '3400893106471',
  ucdQtyMultiplicator: 1,
  cipLib: "KINOX 225 M/MOL BOUT ALU 5L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5722241',
  CIP13: '3400957222413',
  ucdLib: "KINOX 450 M/MOL BOUT ALU 20L",
  UCD7: '9310653',
  UCD13: '3400893106532',
  ucdQtyMultiplicator: 1,
  cipLib: "KINOX 450 M/MOL BOUT ALU 20L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5722235',
  CIP13: '3400957222352',
  ucdLib: "KINOX 450 M/MOL BOUT ALU 5L",
  UCD7: '9310676',
  UCD13: '3400893106761',
  ucdQtyMultiplicator: 1,
  cipLib: "KINOX 450 M/MOL BOUT ALU 5L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5775941',
  CIP13: '3400957759414',
  ucdLib: "NOXAP 200M/M GAZ CPR BOUT 10L",
  UCD7: '9368411',
  UCD13: '3400893684115',
  ucdQtyMultiplicator: 1,
  cipLib: "NOXAP 200M/M GAZ CPR BOUT 10L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5775958',
  CIP13: '3400957759582',
  ucdLib: "NOXAP 200M/M GAZ CPR BOUT 20L",
  UCD7: '9368428',
  UCD13: '3400893684283',
  ucdQtyMultiplicator: 1,
  cipLib: "NOXAP 200M/M GAZ CPR BOUT 20L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5775935',
  CIP13: '3400957759353',
  ucdLib: "NOXAP 200M/M GAZ CPR BOUT 5L",
  UCD7: '9368440',
  UCD13: '3400893684405',
  ucdQtyMultiplicator: 1,
  cipLib: "NOXAP 200M/M GAZ CPR BOUT 5L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5775906',
  CIP13: '3400957759063',
  ucdLib: "NOXAP 800M/M GAZ CPR BOUT 10L",
  UCD7: '9368457',
  UCD13: '3400893684573',
  ucdQtyMultiplicator: 1,
  cipLib: "NOXAP 800M/M GAZ CPR BOUT 10L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5775912',
  CIP13: '3400957759124',
  ucdLib: "NOXAP 800M/M GAZ CPR BOUT 20L",
  UCD7: '9368463',
  UCD13: '3400893684634',
  ucdQtyMultiplicator: 1,
  cipLib: "NOXAP 800M/M GAZ CPR BOUT 20L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5775898',
  CIP13: '3400957758981',
  ucdLib: "NOXAP 800M/M GAZ CPR BOUT 5L",
  UCD7: '9368492',
  UCD13: '3400893684924',
  ucdQtyMultiplicator: 1,
  cipLib: "NOXAP 800M/M GAZ CPR BOUT 5L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '5658023',
  CIP13: '3400956580231',
  ucdLib: "INOMAX 400PPM M/MOL BOUT 2L",
  UCD7: '9305178',
  UCD13: '3400893051788',
  ucdQtyMultiplicator: 1,
  cipLib: "INOMAX 400PPM M/MOL BOUT 2L BT 1",
  atcCode: "R07AX01"
}, {
  CIP7: '3214279',
  CIP13: '3400932142798',
  ucdLib: "VECTARION 15MG INJ FL+AMP",
  UCD7: '9097863',
  UCD13: '3400890978637',
  ucdQtyMultiplicator: 12,
  cipLib: "VECTARION 15MG INJ FL+AMP BT 12",
  atcCode: "R07AB07"
}, {
  CIP7: '5509524',
  CIP13: '3400955095248',
  ucdLib: "DOPRAM 2% INJ AMP3ML",
  UCD7: '9028655',
  UCD13: '3400890286558',
  ucdQtyMultiplicator: 50,
  cipLib: "DOPRAM 2% INJ AMP3ML BT 50",
  atcCode: "R07AB01"
}, {
  CIP7: '5577520',
  CIP13: '3400955775201',
  ucdLib: "CUROSURF 120MG FL1,5ML",
  UCD7: '9157022',
  UCD13: '3400891570229',
  ucdQtyMultiplicator: 1,
  cipLib: "CUROSURF 120MG FL1,5ML BT 1",
  atcCode: "R07AA02"
}, {
  CIP7: '5577537',
  CIP13: '3400955775379',
  ucdLib: "CUROSURF 240MG FL3ML",
  UCD7: '9157039',
  UCD13: '3400891570397',
  ucdQtyMultiplicator: 1,
  cipLib: "CUROSURF 240MG FL3ML BT 1",
  atcCode: "R07AA02"
}, {
  CIP7: '4991358',
  CIP13: '3400949913589',
  ucdLib: "BILASKA 20MG CPR",
  UCD7: '9374222',
  UCD13: '3400893742228',
  ucdQtyMultiplicator: 10,
  cipLib: "BILASKA 20MG CPR BT 10",
  atcCode: "R06AX29"
}, {
  CIP7: '4991370',
  CIP13: '3400949913701',
  ucdLib: "BILASKA 20MG CPR",
  UCD7: '9374222',
  UCD13: '3400893742228',
  ucdQtyMultiplicator: 30,
  cipLib: "BILASKA 20MG CPR BT 30",
  atcCode: "R06AX29"
}, {
  CIP7: '4991387',
  CIP13: '3400949913879',
  ucdLib: "INORIAL 20MG CPR",
  UCD7: '9372625',
  UCD13: '3400893726259',
  ucdQtyMultiplicator: 10,
  cipLib: "INORIAL 20MG CPR BT 10",
  atcCode: "R06AX29"
}, {
  CIP7: '4991401',
  CIP13: '3400949914012',
  ucdLib: "INORIAL 20MG CPR",
  UCD7: '9372625',
  UCD13: '3400893726259',
  ucdQtyMultiplicator: 30,
  cipLib: "INORIAL 20MG CPR BT 30",
  atcCode: "R06AX29"
}, {
  CIP7: '3828840',
  CIP13: '3400938288407',
  ucdLib: "WYSTAMM 10MG CPR",
  UCD7: '9314384',
  UCD13: '3400893143841',
  ucdQtyMultiplicator: 15,
  cipLib: "WYSTAMM 10MG CPR BT 15",
  atcCode: "R06AX28"
}, {
  CIP7: '3841622',
  CIP13: '3400938416220',
  ucdLib: "WYSTAMM 10MG CPR",
  UCD7: '9314384',
  UCD13: '3400893143841',
  ucdQtyMultiplicator: 30,
  cipLib: "WYSTAMM 10MG CPR BT 30",
  atcCode: "R06AX28"
}, {
  CIP7: '3002114',
  CIP13: '3400930021149',
  ucdLib: "DESLORATADINE BGA 5MG CPR",
  UCD7: '9377858',
  UCD13: '3400893778586',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE BGA 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '3565576',
  CIP13: '3400935655769',
  ucdLib: "AERIUS 5MG CPR",
  UCD7: '9236603',
  UCD13: '3400892366036',
  ucdQtyMultiplicator: 15,
  cipLib: "AERIUS 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '3565607',
  CIP13: '3400935656070',
  ucdLib: "AERIUS 5MG CPR",
  UCD7: '9236603',
  UCD13: '3400892366036',
  ucdQtyMultiplicator: 30,
  cipLib: "AERIUS 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '4950022',
  CIP13: '3400949500222',
  ucdLib: "AERIUS 5MG CPR ADP BBA",
  UCD7: '9422151',
  UCD13: '3400894221517',
  ucdQtyMultiplicator: 30,
  cipLib: "AERIUS 5MG CPR ADP BBA BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '4950013',
  CIP13: '3400949500130',
  ucdLib: "AERIUS 5MG CPR ADP MWI",
  UCD7: '9416297',
  UCD13: '3400894162971',
  ucdQtyMultiplicator: 30,
  cipLib: "AERIUS 5MG CPR ADP MWI BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '3809848',
  CIP13: '3400938098488',
  ucdLib: "AERIUS 0,5MG/ML BUV 150ML+SRG",
  UCD7: '9304322',
  UCD13: '3400893043226',
  ucdQtyMultiplicator: 1,
  cipLib: "AERIUS 0,5MG/ML BUV 150ML+SRG BT 1",
  atcCode: "R06AX27"
}, {
  CIP7: '2694113',
  CIP13: '3400926941130',
  ucdLib: "DESLORATADINE ALM 5MG CPR",
  UCD7: '9397938',
  UCD13: '3400893979389',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE ALM 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2694142',
  CIP13: '3400926941420',
  ucdLib: "DESLORATADINE ALM 5MG CPR",
  UCD7: '9397938',
  UCD13: '3400893979389',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE ALM 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '4194142',
  CIP13: '3400941941429',
  ucdLib: "DESLORATADINE ARW 5MG CPR",
  UCD7: '9373524',
  UCD13: '3400893735244',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE ARW 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '4194171',
  CIP13: '3400941941719',
  ucdLib: "DESLORATADINE ARW 5MG CPR",
  UCD7: '9373524',
  UCD13: '3400893735244',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE ARW 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '4199903',
  CIP13: '3400941999031',
  ucdLib: "DESLORATADINE BGA 5MG CPR",
  UCD7: '9377858',
  UCD13: '3400893778586',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE BGA 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '4199949',
  CIP13: '3400941999499',
  ucdLib: "DESLORATADINE BGA 5MG CPR",
  UCD7: '9377858',
  UCD13: '3400893778586',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE BGA 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '4196394',
  CIP13: '3400941963940',
  ucdLib: "DESLORATADINE BGA0,5MG/ML150ML",
  UCD7: '9377841',
  UCD13: '3400893778418',
  ucdQtyMultiplicator: 1,
  cipLib: "DESLORATADINE BGA0,5MG/ML150ML BT 1",
  atcCode: "R06AX27"
}, {
  CIP7: '4196690',
  CIP13: '3400941966903',
  ucdLib: "DESLORATADINE CRT 5MG CPR",
  UCD7: '9377290',
  UCD13: '3400893772904',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE CRT 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '4196744',
  CIP13: '3400941967443',
  ucdLib: "DESLORATADINE CRT 5MG CPR",
  UCD7: '9377290',
  UCD13: '3400893772904',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE CRT 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '4196572',
  CIP13: '3400941965722',
  ucdLib: "DESLORATADINE MYL0,5MG/ML150ML",
  UCD7: '9377315',
  UCD13: '3400893773154',
  ucdQtyMultiplicator: 1,
  cipLib: "DESLORATADINE MYL0,5MG/ML150ML BT 1",
  atcCode: "R06AX27"
}, {
  CIP7: '2758971',
  CIP13: '3400927589713',
  ucdLib: "DESLORATADINE SDZ 5MG CPR",
  UCD7: '9409044',
  UCD13: '3400894090441',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE SDZ 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2758988',
  CIP13: '3400927589881',
  ucdLib: "DESLORATADINE SDZ 5MG CPR",
  UCD7: '9409044',
  UCD13: '3400894090441',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE SDZ 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '2241446',
  CIP13: '3400922414461',
  ucdLib: "DASSELTA 5MG CPR",
  UCD7: '9386188',
  UCD13: '3400893861882',
  ucdQtyMultiplicator: 30,
  cipLib: "DASSELTA 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '2176364',
  CIP13: '3400921763645',
  ucdLib: "DESLORATADINE ARW0,5MG/ML150ML",
  UCD7: '9377605',
  UCD13: '3400893776056',
  ucdQtyMultiplicator: 1,
  cipLib: "DESLORATADINE ARW0,5MG/ML150ML BT 1",
  atcCode: "R06AX27"
}, {
  CIP7: '2176140',
  CIP13: '3400921761405',
  ucdLib: "DESLORATADINE EG 0,5MG/ML150ML",
  UCD7: '9378674',
  UCD13: '3400893786741',
  ucdQtyMultiplicator: 1,
  cipLib: "DESLORATADINE EG 0,5MG/ML150ML BT 1",
  atcCode: "R06AX27"
}, {
  CIP7: '2209715',
  CIP13: '3400922097152',
  ucdLib: "DESLORATADINE EG 5MG CPR",
  UCD7: '9385473',
  UCD13: '3400893854730',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE EG 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2209738',
  CIP13: '3400922097381',
  ucdLib: "DESLORATADINE EG 5MG CPR",
  UCD7: '9385473',
  UCD13: '3400893854730',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE EG 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '2176045',
  CIP13: '3400921760453',
  ucdLib: "DESLORATADINE GNR0,5MG/ML150ML",
  UCD7: '9376988',
  UCD13: '3400893769881',
  ucdQtyMultiplicator: 1,
  cipLib: "DESLORATADINE GNR0,5MG/ML150ML BT 1",
  atcCode: "R06AX27"
}, {
  CIP7: '2682587',
  CIP13: '3400926825874',
  ucdLib: "DESLORATADINE MYL 5MG CPR",
  UCD7: '9406318',
  UCD13: '3400894063186',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE MYL 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2682601',
  CIP13: '3400926826017',
  ucdLib: "DESLORATADINE MYL 5MG CPR",
  UCD7: '9406318',
  UCD13: '3400894063186',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE MYL 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '2209922',
  CIP13: '3400922099224',
  ucdLib: "DESLORATADINE RBX 5MG CPR",
  UCD7: '9385272',
  UCD13: '3400893852729',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE RBX 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2209968',
  CIP13: '3400922099682',
  ucdLib: "DESLORATADINE RBX 5MG CPR",
  UCD7: '9385272',
  UCD13: '3400893852729',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE RBX 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '2175382',
  CIP13: '3400921753820',
  ucdLib: "DESLORATADINE TVS 5MG CPR",
  UCD7: '9378680',
  UCD13: '3400893786802',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE TVS 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2175413',
  CIP13: '3400921754131',
  ucdLib: "DESLORATADINE TVS 5MG CPR",
  UCD7: '9378680',
  UCD13: '3400893786802',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE TVS 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '2174885',
  CIP13: '3400921748857',
  ucdLib: "DESLORATADINE ZEN 5MG CPR",
  UCD7: '9378036',
  UCD13: '3400893780367',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE ZEN 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2174922',
  CIP13: '3400921749229',
  ucdLib: "DESLORATADINE ZEN 5MG CPR",
  UCD7: '9378036',
  UCD13: '3400893780367',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE ZEN 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '2176269',
  CIP13: '3400921762693',
  ucdLib: "DESLORATADINE ZEN0,5MG/ML150ML",
  UCD7: '9378013',
  UCD13: '3400893780138',
  ucdQtyMultiplicator: 1,
  cipLib: "DESLORATADINE ZEN0,5MG/ML150ML BT 1",
  atcCode: "R06AX27"
}, {
  CIP7: '2686102',
  CIP13: '3400926861025',
  ucdLib: "DESLORATADINE ZYD 5MG CPR",
  UCD7: '9391692',
  UCD13: '3400893916926',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE ZYD 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2686119',
  CIP13: '3400926861193',
  ucdLib: "DESLORATADINE ZYD 5MG CPR",
  UCD7: '9391692',
  UCD13: '3400893916926',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE ZYD 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '2791052',
  CIP13: '3400927910524',
  ucdLib: "DESLORATADINE EVO 5MG CPR",
  UCD7: '9404242',
  UCD13: '3400894042426',
  ucdQtyMultiplicator: 15,
  cipLib: "DESLORATADINE EVO 5MG CPR BT 15",
  atcCode: "R06AX27"
}, {
  CIP7: '2791098',
  CIP13: '3400927910982',
  ucdLib: "DESLORATADINE EVO 5MG CPR",
  UCD7: '9404242',
  UCD13: '3400894042426',
  ucdQtyMultiplicator: 30,
  cipLib: "DESLORATADINE EVO 5MG CPR BT 30",
  atcCode: "R06AX27"
}, {
  CIP7: '3454581',
  CIP13: '3400934545818',
  ucdLib: "FEXOFENADINE ZEN 120MG CPR",
  UCD7: '9298426',
  UCD13: '3400892984261',
  ucdQtyMultiplicator: 15,
  cipLib: "FEXOFENADINE ZEN 120MG CPR BT 15",
  atcCode: "R06AX26"
}, {
  CIP7: '3454629',
  CIP13: '3400934546297',
  ucdLib: "FEXOFENADINE ZEN 180MG CPR",
  UCD7: '9298432',
  UCD13: '3400892984322',
  ucdQtyMultiplicator: 15,
  cipLib: "FEXOFENADINE ZEN 180MG CPR BT 15",
  atcCode: "R06AX26"
}, {
  CIP7: '3454492',
  CIP13: '3400934544927',
  ucdLib: "TELFAST 120MG CPR P-ET",
  UCD7: '9198280',
  UCD13: '3400891982800',
  ucdQtyMultiplicator: 15,
  cipLib: "TELFAST 120MG CPR P-ET BT 15",
  atcCode: "R06AX26"
}, {
  CIP7: '3454546',
  CIP13: '3400934545467',
  ucdLib: "TELFAST 180MG CPR P-ET",
  UCD7: '9198297',
  UCD13: '3400891982978',
  ucdQtyMultiplicator: 15,
  cipLib: "TELFAST 180MG CPR P-ET BT 15",
  atcCode: "R06AX26"
}, {
  CIP7: '3828923',
  CIP13: '3400938289237',
  ucdLib: "FEXOFENADINE BGA 120MG CPR",
  UCD7: '9312534',
  UCD13: '3400893125342',
  ucdQtyMultiplicator: 15,
  cipLib: "FEXOFENADINE BGA 120MG CPR BT 15",
  atcCode: "R06AX26"
}, {
  CIP7: '3828998',
  CIP13: '3400938289985',
  ucdLib: "FEXOFENADINE BGA 180MG CPR",
  UCD7: '9312540',
  UCD13: '3400893125403',
  ucdQtyMultiplicator: 15,
  cipLib: "FEXOFENADINE BGA 180MG CPR BT 15",
  atcCode: "R06AX26"
}, {
  CIP7: '3829124',
  CIP13: '3400938291247',
  ucdLib: "FEXOFENADINE MYL 120MG CPR",
  UCD7: '9313605',
  UCD13: '3400893136058',
  ucdQtyMultiplicator: 15,
  cipLib: "FEXOFENADINE MYL 120MG CPR BT 15",
  atcCode: "R06AX26"
}, {
  CIP7: '3829182',
  CIP13: '3400938291827',
  ucdLib: "FEXOFENADINE MYL 180MG CPR",
  UCD7: '9313611',
  UCD13: '3400893136119',
  ucdQtyMultiplicator: 15,
  cipLib: "FEXOFENADINE MYL 180MG CPR BT 15",
  atcCode: "R06AX26"
}, {
  CIP7: '3639777',
  CIP13: '3400936397774',
  ucdLib: "MIZOLLEN 10MG CPR LM",
  UCD7: '9206542',
  UCD13: '3400892065427',
  ucdQtyMultiplicator: 15,
  cipLib: "MIZOLLEN 10MG CPR LM BT 15",
  atcCode: "R06AX25"
}, {
  CIP7: '3639808',
  CIP13: '3400936398085',
  ucdLib: "MIZOLLEN 10MG CPR LM",
  UCD7: '9206542',
  UCD13: '3400892065427',
  ucdQtyMultiplicator: 30,
  cipLib: "MIZOLLEN 10MG CPR LM BT 30",
  atcCode: "R06AX25"
}, {
  CIP7: '4928644',
  CIP13: '3400949286447',
  ucdLib: "MIZOCLER 10MG CPR LM",
  UCD7: '9370164',
  UCD13: '3400893701645',
  ucdQtyMultiplicator: 30,
  cipLib: "MIZOCLER 10MG CPR LM BT 30",
  atcCode: "R06AX25"
}, {
  CIP7: '3137900',
  CIP13: '3400931379003',
  ucdLib: "CALMIXENE SIR FL150ML",
  UCD7: '9015210',
  UCD13: '3400890152105',
  ucdQtyMultiplicator: 1,
  cipLib: "CALMIXENE SIR FL150ML BT 1",
  atcCode: "R06AX23"
}, {
  CIP7: '3403537',
  CIP13: '3400934035371',
  ucdLib: "KESTIN 10MG CPR",
  UCD7: '9182675',
  UCD13: '3400891826753',
  ucdQtyMultiplicator: 15,
  cipLib: "KESTIN 10MG CPR BT 15",
  atcCode: "R06AX22"
}, {
  CIP7: '3403566',
  CIP13: '3400934035661',
  ucdLib: "KESTIN 10MG CPR",
  UCD7: '9182675',
  UCD13: '3400891826753',
  ucdQtyMultiplicator: 30,
  cipLib: "KESTIN 10MG CPR BT 30",
  atcCode: "R06AX22"
}, {
  CIP7: '3675916',
  CIP13: '3400936759169',
  ucdLib: "KESTINLYO 10MG LYOT ORAL",
  UCD7: '9282939',
  UCD13: '3400892829395',
  ucdQtyMultiplicator: 30,
  cipLib: "KESTINLYO 10MG LYOT ORAL BT 30",
  atcCode: "R06AX22"
}, {
  CIP7: '2168991',
  CIP13: '3400921689914',
  ucdLib: "EBASTINE TVC 10MG CPR DISP",
  UCD7: '9379797',
  UCD13: '3400893797976',
  ucdQtyMultiplicator: 30,
  cipLib: "EBASTINE TVC 10MG CPR DISP BT 30",
  atcCode: "R06AX22"
}, {
  CIP7: '2781289',
  CIP13: '3400927812897',
  ucdLib: "EBASTINE ZEN 10MG CPR",
  UCD7: '9401717',
  UCD13: '3400894017172',
  ucdQtyMultiplicator: 30,
  cipLib: "EBASTINE ZEN 10MG CPR BT 30",
  atcCode: "R06AX22"
}, {
  CIP7: '2770191',
  CIP13: '3400927701917',
  ucdLib: "EBASTINE MYL 10MG CPR DISP",
  UCD7: '9400468',
  UCD13: '3400894004684',
  ucdQtyMultiplicator: 30,
  cipLib: "EBASTINE MYL 10MG CPR DISP BT 30",
  atcCode: "R06AX22"
}, {
  CIP7: '2770268',
  CIP13: '3400927702686',
  ucdLib: "EBASTINE ZEN 10MG CPR DISP",
  UCD7: '9400824',
  UCD13: '3400894008248',
  ucdQtyMultiplicator: 30,
  cipLib: "EBASTINE ZEN 10MG CPR DISP BT 30",
  atcCode: "R06AX22"
}, {
  CIP7: '3230350',
  CIP13: '3400932303502',
  ucdLib: "ZADITEN 1MG GELU",
  UCD7: '9101961',
  UCD13: '3400891019612',
  ucdQtyMultiplicator: 60,
  cipLib: "ZADITEN 1MG GELU BT 60",
  atcCode: "R06AX17"
}, {
  CIP7: '3244895',
  CIP13: '3400932448951',
  ucdLib: "ZADITEN 1MG/5ML BUV FV150ML",
  UCD7: '9101978',
  UCD13: '3400891019780',
  ucdQtyMultiplicator: 1,
  cipLib: "ZADITEN 1MG/5ML BUV FV150ML BT 1",
  atcCode: "R06AX17"
}, {
  CIP7: '3369214',
  CIP13: '3400933692148',
  ucdLib: "ZADITEN LP 2MG CPR",
  UCD7: '9172725',
  UCD13: '3400891727258',
  ucdQtyMultiplicator: 30,
  cipLib: "ZADITEN LP 2MG CPR BT 30",
  atcCode: "R06AX17"
}, {
  CIP7: '3515851',
  CIP13: '3400935158512',
  ucdLib: "ZADITEN 1MG GELU",
  UCD7: '9101961',
  UCD13: '3400891019612',
  ucdQtyMultiplicator: 60,
  cipLib: "ZADITEN 1MG GELU BT 60",
  atcCode: "R06AX17"
}, {
  CIP7: '3613364',
  CIP13: '3400936133648',
  ucdLib: "LORATADINE EG 10MG CPR",
  UCD7: '9309118',
  UCD13: '3400893091180',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE EG 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3298916',
  CIP13: '3400932989164',
  ucdLib: "CLARITYNE 10MG CPR",
  UCD7: '9129741',
  UCD13: '3400891297416',
  ucdQtyMultiplicator: 15,
  cipLib: "CLARITYNE 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '2762205',
  CIP13: '3400927622052',
  ucdLib: "LORATADINE SDC 10MG CPR",
  UCD7: '9397619',
  UCD13: '3400893976197',
  ucdQtyMultiplicator: 7,
  cipLib: "LORATADINE SDC 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '3605867',
  CIP13: '3400936058675',
  ucdLib: "LORATADINE ARW 10MG CPR",
  UCD7: '9313108',
  UCD13: '3400893131084',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE ARW 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3608854',
  CIP13: '3400936088542',
  ucdLib: "LORATADINE MYL 10MG CPR",
  UCD7: '9275856',
  UCD13: '3400892758565',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE MYL 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3356051',
  CIP13: '3400933560515',
  ucdLib: "CLARITYNE 1MG/ML SIR FL120ML",
  UCD7: '9181902',
  UCD13: '3400891819021',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITYNE 1MG/ML SIR FL120ML BT 1",
  atcCode: "R06AX13"
}, {
  CIP7: '3356045',
  CIP13: '3400933560454',
  ucdLib: "CLARITYNE 1MG/ML SIR FL60ML",
  UCD7: '9158145',
  UCD13: '3400891581454',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITYNE 1MG/ML SIR FL60ML BT 1",
  atcCode: "R06AX13"
}, {
  CIP7: '4981905',
  CIP13: '3400949819058',
  ucdLib: "DOLIALLERGIE LORAT.10MG CPR",
  UCD7: '9365482',
  UCD13: '3400893654828',
  ucdQtyMultiplicator: 7,
  cipLib: "DOLIALLERGIE LORAT.10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '4989433',
  CIP13: '3400949894338',
  ucdLib: "HUMEX ALLERGIE LOR.10MG CPR",
  UCD7: '9367995',
  UCD13: '3400893679951',
  ucdQtyMultiplicator: 7,
  cipLib: "HUMEX ALLERGIE LOR.10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '3675371',
  CIP13: '3400936753716',
  ucdLib: "LORATADINE CRT 10MG CPR",
  UCD7: '9348638',
  UCD13: '3400893486382',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE CRT 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '4989545',
  CIP13: '3400949895458',
  ucdLib: "LORATADINE NEP 10MG CPR",
  UCD7: '9370098',
  UCD13: '3400893700983',
  ucdQtyMultiplicator: 7,
  cipLib: "LORATADINE NEP 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '3859697',
  CIP13: '3400938596977',
  ucdLib: "LORATADINE AWC 10MG CPR",
  UCD7: '9318264',
  UCD13: '3400893182642',
  ucdQtyMultiplicator: 7,
  cipLib: "LORATADINE AWC 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '3859734',
  CIP13: '3400938597349',
  ucdLib: "LORATADINE RTC 10MG CPR",
  UCD7: '9320255',
  UCD13: '3400893202555',
  ucdQtyMultiplicator: 7,
  cipLib: "LORATADINE RTC 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '3632108',
  CIP13: '3400936321083',
  ucdLib: "LORATADINE TVC 10MG CPR",
  UCD7: '9311552',
  UCD13: '3400893115527',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE TVC 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3828337',
  CIP13: '3400938283372',
  ucdLib: "LORATADINE TCO 10MG CPR",
  UCD7: '9353852',
  UCD13: '3400893538524',
  ucdQtyMultiplicator: 7,
  cipLib: "LORATADINE TCO 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '3645306',
  CIP13: '3400936453067',
  ucdLib: "LORATADINE ZEN 10MG CPR",
  UCD7: '9265378',
  UCD13: '3400892653785',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE ZEN 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3860921',
  CIP13: '3400938609219',
  ucdLib: "LORATADINE RBX 10MG CPR",
  UCD7: '9310914',
  UCD13: '3400893109144',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE RBX 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3906623',
  CIP13: '3400939066233',
  ucdLib: "LORATADINE ALM 10MG CPR",
  UCD7: '9326364',
  UCD13: '3400893263648',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE ALM 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3841177',
  CIP13: '3400938411775',
  ucdLib: "LORATADINE BGA 10MG CPR",
  UCD7: '9312586',
  UCD13: '3400893125861',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE BGA 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3934743',
  CIP13: '3400939347431',
  ucdLib: "LORATADINE ZYD 10MG CPR",
  UCD7: '9332790',
  UCD13: '3400893327906',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE ZYD 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '3946077',
  CIP13: '3400939460772',
  ucdLib: "LORATADINE BGC 10MG CPR",
  UCD7: '9335825',
  UCD13: '3400893358252',
  ucdQtyMultiplicator: 7,
  cipLib: "LORATADINE BGC 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '3944776',
  CIP13: '3400939447766',
  ucdLib: "ZAPRILIS 10MG CPR",
  UCD7: '9339102',
  UCD13: '3400893391020',
  ucdQtyMultiplicator: 7,
  cipLib: "ZAPRILIS 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '2780019',
  CIP13: '3400927800191',
  ucdLib: "LORATADINE MYC 10MG CPR",
  UCD7: '9314131',
  UCD13: '3400893141311',
  ucdQtyMultiplicator: 7,
  cipLib: "LORATADINE MYC 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '2226990',
  CIP13: '3400922269900',
  ucdLib: "LORATADINE SDZ 10MG CPR",
  UCD7: '9267845',
  UCD13: '3400892678450',
  ucdQtyMultiplicator: 15,
  cipLib: "LORATADINE SDZ 10MG CPR BT 15",
  atcCode: "R06AX13"
}, {
  CIP7: '4925491',
  CIP13: '3400949254910',
  ucdLib: "LORATADINE ZF 10MG CPR",
  UCD7: '9359412',
  UCD13: '3400893594124',
  ucdQtyMultiplicator: 7,
  cipLib: "LORATADINE ZF 10MG CPR BT 7",
  atcCode: "R06AX13"
}, {
  CIP7: '3081789',
  CIP13: '3400930817896',
  ucdLib: "PERIACTINE 4MG CPR",
  UCD7: '9070255',
  UCD13: '3400890702553',
  ucdQtyMultiplicator: 30,
  cipLib: "PERIACTINE 4MG CPR BT 30",
  atcCode: "R06AX02"
}, {
  CIP7: '3003575',
  CIP13: '3400930035757',
  ucdLib: "LEVOCETIRIZINE CRT 5MG CPR",
  UCD7: '9414424',
  UCD13: '3400894144243',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE CRT 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3001138',
  CIP13: '3400930011386',
  ucdLib: "LEVOCETIRIZINE RBX 5MG CPR",
  UCD7: '9409713',
  UCD13: '3400894097136',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE RBX 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3001140',
  CIP13: '3400930011409',
  ucdLib: "LEVOCETIRIZINE RBX 5MG CPR",
  UCD7: '9409713',
  UCD13: '3400894097136',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE RBX 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3585024',
  CIP13: '3400935850249',
  ucdLib: "XYZALL 5MG CPR",
  UCD7: '9244028',
  UCD13: '3400892440286',
  ucdQtyMultiplicator: 14,
  cipLib: "XYZALL 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3585053',
  CIP13: '3400935850539',
  ucdLib: "XYZALL 5MG CPR",
  UCD7: '9244028',
  UCD13: '3400892440286',
  ucdQtyMultiplicator: 28,
  cipLib: "XYZALL 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3927536',
  CIP13: '3400939275369',
  ucdLib: "LEVOCETIRIZINE TVC 5MG CPR",
  UCD7: '9338775',
  UCD13: '3400893387757',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE TVC 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3927571',
  CIP13: '3400939275710',
  ucdLib: "LEVOCETIRIZINE TVC 5MG CPR",
  UCD7: '9338775',
  UCD13: '3400893387757',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE TVC 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '2217933',
  CIP13: '3400922179339',
  ucdLib: "LEVOCETIRIZINE KRK 5MG CPR",
  UCD7: '9385622',
  UCD13: '3400893856222',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE KRK 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '2217962',
  CIP13: '3400922179629',
  ucdLib: "LEVOCETIRIZINE KRK 5MG CPR",
  UCD7: '9385622',
  UCD13: '3400893856222',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE KRK 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3968570',
  CIP13: '3400939685700',
  ucdLib: "LEVOCETIRIZINE RTP 5MG CPR",
  UCD7: '9352522',
  UCD13: '3400893525227',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE RTP 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3968920',
  CIP13: '3400939689203',
  ucdLib: "LEVOCETIRIZINE SDZ 5MG CPR",
  UCD7: '9379053',
  UCD13: '3400893790533',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE SDZ 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3968943',
  CIP13: '3400939689432',
  ucdLib: "LEVOCETIRIZINE SDZ 5MG CPR",
  UCD7: '9379053',
  UCD13: '3400893790533',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE SDZ 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '2213421',
  CIP13: '3400922134215',
  ucdLib: "LEVOCETIRIZINE ZEN 5MG CPR",
  UCD7: '9384700',
  UCD13: '3400893847008',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE ZEN 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '2219435',
  CIP13: '3400922194356',
  ucdLib: "LEVOCETIRIZINE ZEN 5MG CPR",
  UCD7: '9384700',
  UCD13: '3400893847008',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE ZEN 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3985864',
  CIP13: '3400939858647',
  ucdLib: "LEVOCETIRIZINE ARW 5MG CPR",
  UCD7: '9354142',
  UCD13: '3400893541425',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE ARW 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3985887',
  CIP13: '3400939858876',
  ucdLib: "LEVOCETIRIZINE ARW 5MG CPR",
  UCD7: '9354142',
  UCD13: '3400893541425',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE ARW 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3985781',
  CIP13: '3400939857817',
  ucdLib: "LEVOCETIRIZINE BGA 5MG CPR",
  UCD7: '9364844',
  UCD13: '3400893648445',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE BGA 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3985806',
  CIP13: '3400939858067',
  ucdLib: "LEVOCETIRIZINE BGA 5MG CPR",
  UCD7: '9364844',
  UCD13: '3400893648445',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE BGA 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3985539',
  CIP13: '3400939855394',
  ucdLib: "LEVOCETIRIZINE EG 5MG CPR",
  UCD7: '9372097',
  UCD13: '3400893720974',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE EG 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3985551',
  CIP13: '3400939855516',
  ucdLib: "LEVOCETIRIZINE EG 5MG CPR",
  UCD7: '9372097',
  UCD13: '3400893720974',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE EG 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3985663',
  CIP13: '3400939856636',
  ucdLib: "LEVOCETIRIZINE MYL 5MG CPR",
  UCD7: '9360757',
  UCD13: '3400893607572',
  ucdQtyMultiplicator: 14,
  cipLib: "LEVOCETIRIZINE MYL 5MG CPR BT 14",
  atcCode: "R06AE09"
}, {
  CIP7: '3985692',
  CIP13: '3400939856926',
  ucdLib: "LEVOCETIRIZINE MYL 5MG CPR",
  UCD7: '9360757',
  UCD13: '3400893607572',
  ucdQtyMultiplicator: 28,
  cipLib: "LEVOCETIRIZINE MYL 5MG CPR BT 28",
  atcCode: "R06AE09"
}, {
  CIP7: '3000524',
  CIP13: '3400930005248',
  ucdLib: "CETIRIZINE BGA 10MG CPR",
  UCD7: '9265102',
  UCD13: '3400892651026',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE BGA 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3302345',
  CIP13: '3400933023454',
  ucdLib: "VIRLIX 10MG CPR",
  UCD7: '9127185',
  UCD13: '3400891271850',
  ucdQtyMultiplicator: 15,
  cipLib: "VIRLIX 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3688758',
  CIP13: '3400936887589',
  ucdLib: "CETIRIZINE BGC 10MG CPR",
  UCD7: '9277387',
  UCD13: '3400892773872',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE BGC 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3603472',
  CIP13: '3400936034723',
  ucdLib: "CETIRIZINE MYL 10MG CPR",
  UCD7: '9251040',
  UCD13: '3400892510408',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE MYL 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3670758',
  CIP13: '3400936707580',
  ucdLib: "ALAIRGIX ALL.CETI.10MG CPR",
  UCD7: '9281466',
  UCD13: '3400892814667',
  ucdQtyMultiplicator: 7,
  cipLib: "ALAIRGIX ALL.CETI.10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3674466',
  CIP13: '3400936744660',
  ucdLib: "CETIRIZINE ZEN 10MG CPR",
  UCD7: '9269904',
  UCD13: '3400892699042',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE ZEN 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3656445',
  CIP13: '3400936564459',
  ucdLib: "CETIRIZINE BGA 10MG/ML BUV15ML",
  UCD7: '9266685',
  UCD13: '3400892666853',
  ucdQtyMultiplicator: 1,
  cipLib: "CETIRIZINE BGA 10MG/ML BUV15ML BT 1",
  atcCode: "R06AE07"
}, {
  CIP7: '3626616',
  CIP13: '3400936266162',
  ucdLib: "CETIRIZINE EG 10MG CPR",
  UCD7: '9258929',
  UCD13: '3400892589299',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE EG 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3417700',
  CIP13: '3400934177002',
  ucdLib: "ZYRTEC 10MG/ML BUV FV15ML",
  UCD7: '9204336',
  UCD13: '3400892043364',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYRTEC 10MG/ML BUV FV15ML BT 1",
  atcCode: "R06AE07"
}, {
  CIP7: '3543907',
  CIP13: '3400935439079',
  ucdLib: "CETIRIZINE CRT 10MG CPR",
  UCD7: '9351882',
  UCD13: '3400893518823',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE CRT 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3708107',
  CIP13: '3400937081078',
  ucdLib: "CETIRIZINE EG 10MG CPR SUC",
  UCD7: '9354768',
  UCD13: '3400893547687',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE EG 10MG CPR SUC BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3588442',
  CIP13: '3400935884428',
  ucdLib: "CETIRIZINE SDZ 10MG CPR",
  UCD7: '9259283',
  UCD13: '3400892592831',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE SDZ 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3635992',
  CIP13: '3400936359925',
  ucdLib: "CETIRIZINE ARW 10MG CPR",
  UCD7: '9259277',
  UCD13: '3400892592770',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE ARW 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3746289',
  CIP13: '3400937462891',
  ucdLib: "CETIRIZINE AWC 10MG CPR",
  UCD7: '9288853',
  UCD13: '3400892888538',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE AWC 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3669985',
  CIP13: '3400936699854',
  ucdLib: "CETIRIZINE MYP 10MG CPR",
  UCD7: '9271321',
  UCD13: '3400892713212',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE MYP 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3749879',
  CIP13: '3400937498791',
  ucdLib: "CETIRIZINE RTC 10MG CPR",
  UCD7: '9290198',
  UCD13: '3400892901985',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE RTC 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3815352',
  CIP13: '3400938153521',
  ucdLib: "DRILL ALLERGIE CETI.10MG CPR",
  UCD7: '9388359',
  UCD13: '3400893883594',
  ucdQtyMultiplicator: 7,
  cipLib: "DRILL ALLERGIE CETI.10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3768836',
  CIP13: '3400937688369',
  ucdLib: "HUMEX ALLERGIE CET.10MG CPR",
  UCD7: '9292228',
  UCD13: '3400892922287',
  ucdQtyMultiplicator: 7,
  cipLib: "HUMEX ALLERGIE CET.10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3790149',
  CIP13: '3400937901499',
  ucdLib: "CETIRIZINE ARW 10MG/ML BUV15ML",
  UCD7: '9301476',
  UCD13: '3400893014769',
  ucdQtyMultiplicator: 1,
  cipLib: "CETIRIZINE ARW 10MG/ML BUV15ML BT 1",
  atcCode: "R06AE07"
}, {
  CIP7: '3648629',
  CIP13: '3400936486294',
  ucdLib: "CETIRIZINE BGA 10MG CPR",
  UCD7: '9265102',
  UCD13: '3400892651026',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE BGA 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3775368',
  CIP13: '3400937753685',
  ucdLib: "CETIRIZINE SDC 10MG CPR",
  UCD7: '9296462',
  UCD13: '3400892964621',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE SDC 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3792065',
  CIP13: '3400937920650',
  ucdLib: "CETIRIZINE TCO 10MG CPR",
  UCD7: '9303274',
  UCD13: '3400893032749',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE TCO 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3645789',
  CIP13: '3400936457898',
  ucdLib: "CETIRIZINE TVC 10MG CPR",
  UCD7: '9262109',
  UCD13: '3400892621098',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE TVC 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3646168',
  CIP13: '3400936461680',
  ucdLib: "ZYRTECSET 10MG CPR",
  UCD7: '9267673',
  UCD13: '3400892676739',
  ucdQtyMultiplicator: 7,
  cipLib: "ZYRTECSET 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3802131',
  CIP13: '3400938021318',
  ucdLib: "ACTIFED ALL.CETI.10MG CPR",
  UCD7: '9305557',
  UCD13: '3400893055571',
  ucdQtyMultiplicator: 7,
  cipLib: "ACTIFED ALL.CETI.10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3759872',
  CIP13: '3400937598729',
  ucdLib: "CETIRIZINE CRC 10MG CPR",
  UCD7: '9292151',
  UCD13: '3400892921518',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE CRC 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3921396',
  CIP13: '3400939213965',
  ucdLib: "CETIRIZINE ZYD 10MG CPR",
  UCD7: '9336569',
  UCD13: '3400893365694',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE ZYD 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3844218',
  CIP13: '3400938442182',
  ucdLib: "CETIRIZINE EVO 10MG CPR",
  UCD7: '9313054',
  UCD13: '3400893130544',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE EVO 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '2216052',
  CIP13: '3400922160528',
  ucdLib: "CETIRIZINE ISD 10MG CPR",
  UCD7: '9384605',
  UCD13: '3400893846056',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE ISD 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '2216106',
  CIP13: '3400922161068',
  ucdLib: "CETIRIZINE PHR 10MG CPR",
  UCD7: '9384611',
  UCD13: '3400893846117',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE PHR 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3896238',
  CIP13: '3400938962383',
  ucdLib: "CETIRIZINE RPG 10MG CPR",
  UCD7: '9271574',
  UCD13: '3400892715742',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE RPG 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '3900313',
  CIP13: '3400939003139',
  ucdLib: "CETIRIZINE ZYF 10MG CPR",
  UCD7: '9326996',
  UCD13: '3400893269961',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE ZYF 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '4194656',
  CIP13: '3400941946561',
  ucdLib: "CETIRIZINE ALM 10MG CPR",
  UCD7: '9377255',
  UCD13: '3400893772553',
  ucdQtyMultiplicator: 15,
  cipLib: "CETIRIZINE ALM 10MG CPR BT 15",
  atcCode: "R06AE07"
}, {
  CIP7: '4922245',
  CIP13: '3400949222452',
  ucdLib: "CETIRIZINE NEP 10MG CPR",
  UCD7: '9356738',
  UCD13: '3400893567388',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE NEP 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '3991089',
  CIP13: '3400939910895',
  ucdLib: "CETIRIZINE RMO 10MG CPR",
  UCD7: '9348058',
  UCD13: '3400893480588',
  ucdQtyMultiplicator: 7,
  cipLib: "CETIRIZINE RMO 10MG CPR BT 7",
  atcCode: "R06AE07"
}, {
  CIP7: '5767812',
  CIP13: '3400957678128',
  ucdLib: "CETIRIZINE ARW 10MG CPR",
  UCD7: '9259277',
  UCD13: '3400892592770',
  ucdQtyMultiplicator: 60,
  cipLib: "CETIRIZINE ARW 10MG CPR BT 60",
  atcCode: "R06AE07"
}, {
  CIP7: '3636885',
  CIP13: '3400936368859',
  ucdLib: "RHINATHIOL PROMETH. SIR 200ML",
  UCD7: '9283488',
  UCD13: '3400892834887',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINATHIOL PROMETH. SIR 200ML BT 1",
  atcCode: "R06AD52"
}, {
  CIP7: '3000996',
  CIP13: '3400930009963',
  ucdLib: "OXOMEMAZINE SDC S/SUC BUV150ML",
  UCD7: '9412023',
  UCD13: '3400894120230',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE SDC S/SUC BUV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4919148',
  CIP13: '3400949191482',
  ucdLib: "OXOMEMAZINE BGA S/SUC BUV150ML",
  UCD7: '9355325',
  UCD13: '3400893553251',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE BGA S/SUC BUV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4916463',
  CIP13: '3400949164639',
  ucdLib: "OXOMEMAZINE PHR SIR FL150ML",
  UCD7: '9355408',
  UCD13: '3400893554081',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE PHR SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '3689545',
  CIP13: '3400936895454',
  ucdLib: "OXOMEMAZINE BGA SIR FL150ML",
  UCD7: '9353007',
  UCD13: '3400893530078',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE BGA SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '3595784',
  CIP13: '3400935957849',
  ucdLib: "TOPLEXIL 0,33MG/ML SIR FL150ML",
  UCD7: '9249540',
  UCD13: '3400892495408',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPLEXIL 0,33MG/ML SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '3730762',
  CIP13: '3400937307628',
  ucdLib: "TOPLEXIL 0,33MG/ML S/S FV150ML",
  UCD7: '9296077',
  UCD13: '3400892960777',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPLEXIL 0,33MG/ML S/S FV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4924652',
  CIP13: '3400949246526',
  ucdLib: "HUMEX T.SEC OXOM. SIR FL150ML",
  UCD7: '9359582',
  UCD13: '3400893595824',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMEX T.SEC OXOM. SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4921524',
  CIP13: '3400949215249',
  ucdLib: "HUMEX T.SEC OXOM.S/S BUV 150ML",
  UCD7: '9359599',
  UCD13: '3400893595992',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMEX T.SEC OXOM.S/S BUV 150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4921530',
  CIP13: '3400949215300',
  ucdLib: "OXOMEMAZINE ARW S/SUC BUV150ML",
  UCD7: '9355360',
  UCD13: '3400893553602',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE ARW S/SUC BUV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4924675',
  CIP13: '3400949246755',
  ucdLib: "OXOMEMAZINE ARW SIR FL150ML",
  UCD7: '9355354',
  UCD13: '3400893553541',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE ARW SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '2241110',
  CIP13: '3400922411101',
  ucdLib: "OXOMEMAZINE BGC S/SUC BUV150ML",
  UCD7: '9389494',
  UCD13: '3400893894941',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE BGC S/SUC BUV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4924445',
  CIP13: '3400949244454',
  ucdLib: "OXOMEMAZINE EG S/SUC BUV 150ML",
  UCD7: '9355348',
  UCD13: '3400893553480',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE EG S/SUC BUV 150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4924623',
  CIP13: '3400949246236',
  ucdLib: "OXOMEMAZINE EG SIR FL150ML",
  UCD7: '9355331',
  UCD13: '3400893553312',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE EG SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4921553',
  CIP13: '3400949215539',
  ucdLib: "OXOMEMAZINE MYL S/SUC BUV150ML",
  UCD7: '9355319',
  UCD13: '3400893553190',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE MYL S/SUC BUV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4924669',
  CIP13: '3400949246694',
  ucdLib: "OXOMEMAZINE MYL SIR FL150ML",
  UCD7: '9355302',
  UCD13: '3400893553022',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE MYL SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4921547',
  CIP13: '3400949215478',
  ucdLib: "OXOMEMAZINE PHR S/SUC BUV150ML",
  UCD7: '9355414',
  UCD13: '3400893554142',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE PHR S/SUC BUV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '2240085',
  CIP13: '3400922400853',
  ucdLib: "OXOMEMAZINE SDZ S/SUC BUV150ML",
  UCD7: '9385970',
  UCD13: '3400893859704',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE SDZ S/SUC BUV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '2240079',
  CIP13: '3400922400792',
  ucdLib: "OXOMEMAZINE SDZ SIR FL150ML",
  UCD7: '9385964',
  UCD13: '3400893859643',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE SDZ SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4926912',
  CIP13: '3400949269129',
  ucdLib: "OXOMEMAZINE TVC SIR FL150ML",
  UCD7: '9355420',
  UCD13: '3400893554203',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE TVC SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4922127',
  CIP13: '3400949221271',
  ucdLib: "OXOMEMAZINE ZEN S/SUC BUV150ML",
  UCD7: '9355466',
  UCD13: '3400893554661',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE ZEN S/SUC BUV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '4924681',
  CIP13: '3400949246816',
  ucdLib: "OXOMEMAZINE ZEN SIR FL150ML",
  UCD7: '9355443',
  UCD13: '3400893554432',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE ZEN SIR FL150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '2176424',
  CIP13: '3400921764246',
  ucdLib: "OXOMEMAZINE ZTL S/SUC FV150ML",
  UCD7: '9404845',
  UCD13: '3400894048459',
  ucdQtyMultiplicator: 1,
  cipLib: "OXOMEMAZINE ZTL S/SUC FV150ML BT 1",
  atcCode: "R06AD08"
}, {
  CIP7: '3263680',
  CIP13: '3400932636808',
  ucdLib: "PRIMALAN SIR FL60ML",
  UCD7: '9075181',
  UCD13: '3400890751810',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIMALAN SIR FL60ML BT 1",
  atcCode: "R06AD07"
}, {
  CIP7: '3395832',
  CIP13: '3400933958329',
  ucdLib: "PRIMALAN 10MG CPR SECAB",
  UCD7: '9186265',
  UCD13: '3400891862652',
  ucdQtyMultiplicator: 14,
  cipLib: "PRIMALAN 10MG CPR SECAB BT 14",
  atcCode: "R06AD07"
}, {
  CIP7: '3627308',
  CIP13: '3400936273085',
  ucdLib: "PRIMALAN SIR FL125ML",
  UCD7: '9261239',
  UCD13: '3400892612393',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIMALAN SIR FL125ML BT 1",
  atcCode: "R06AD07"
}, {
  CIP7: '3181568',
  CIP13: '3400931815686',
  ucdLib: "PRIMALAN 5MG CPR SECAB",
  UCD7: '9075175',
  UCD13: '3400890751759',
  ucdQtyMultiplicator: 14,
  cipLib: "PRIMALAN 5MG CPR SECAB BT 14",
  atcCode: "R06AD07"
}, {
  CIP7: '3082240',
  CIP13: '3400930822401',
  ucdLib: "PHENERGAN 2,5% INJ AMP2ML",
  UCD7: '9070999',
  UCD13: '3400890709996',
  ucdQtyMultiplicator: 5,
  cipLib: "PHENERGAN 2,5% INJ AMP2ML BT 5",
  atcCode: "R06AD02"
}, {
  CIP7: '3082286',
  CIP13: '3400930822869',
  ucdLib: "PHENERGAN 25MG CPR",
  UCD7: '9071007',
  UCD13: '3400890710077',
  ucdQtyMultiplicator: 20,
  cipLib: "PHENERGAN 25MG CPR BT 20",
  atcCode: "R06AD02"
}, {
  CIP7: '3253523',
  CIP13: '3400932535231',
  ucdLib: "PHENERGAN 0,1% SIR FL150ML",
  UCD7: '9071036',
  UCD13: '3400890710367',
  ucdQtyMultiplicator: 1,
  cipLib: "PHENERGAN 0,1% SIR FL150ML BT 1",
  atcCode: "R06AD02"
}, {
  CIP7: '5547401',
  CIP13: '3400955474012',
  ucdLib: "THERALENE 4% BUV GTT FL100ML",
  UCD7: '9115762',
  UCD13: '3400891157628',
  ucdQtyMultiplicator: 1,
  cipLib: "THERALENE 4% BUV GTT FL100ML BT 1",
  atcCode: "R06AD01"
}, {
  CIP7: '3105337',
  CIP13: '3400931053378',
  ucdLib: "THERALENE 0,05% SIR FL150ML",
  UCD7: '9092268',
  UCD13: '3400890922685',
  ucdQtyMultiplicator: 1,
  cipLib: "THERALENE 0,05% SIR FL150ML BT 1",
  atcCode: "R06AD01"
}, {
  CIP7: '3105308',
  CIP13: '3400931053088',
  ucdLib: "THERALENE 4% BUV GTT FL30ML",
  UCD7: '9092251',
  UCD13: '3400890922517',
  ucdQtyMultiplicator: 1,
  cipLib: "THERALENE 4% BUV GTT FL30ML BT 1",
  atcCode: "R06AD01"
}, {
  CIP7: '3105283',
  CIP13: '3400931052838',
  ucdLib: "THERALENE 5MG CPR PELLIC",
  UCD7: '9092245',
  UCD13: '3400890922456',
  ucdQtyMultiplicator: 50,
  cipLib: "THERALENE 5MG CPR PELLIC BT 50",
  atcCode: "R06AD01"
}, {
  CIP7: '3335988',
  CIP13: '3400933359881',
  ucdLib: "HUMEXLIB PARA/CHLO GELU",
  UCD7: '9169002',
  UCD13: '3400891690026',
  ucdQtyMultiplicator: 16,
  cipLib: "HUMEXLIB PARA/CHLO GELU BT 16",
  atcCode: "R06AB54"
}, {
  CIP7: '2243942',
  CIP13: '3400922439426',
  ucdLib: "DRILL RHUME CPR",
  UCD7: '9389778',
  UCD13: '3400893897782',
  ucdQtyMultiplicator: 16,
  cipLib: "DRILL RHUME CPR BT 16",
  atcCode: "R06AB54"
}, {
  CIP7: '4977559',
  CIP13: '3400949775590',
  ucdLib: "CELESTAMINE CPR",
  UCD7: '9017315',
  UCD13: '3400890173155',
  ucdQtyMultiplicator: 30,
  cipLib: "CELESTAMINE CPR BT 30",
  atcCode: "R06AB52"
}, {
  CIP7: '3084894',
  CIP13: '3400930848944',
  ucdLib: "POLARAMINE 2MG CPR SECAB",
  UCD7: '9073650',
  UCD13: '3400890736503',
  ucdQtyMultiplicator: 30,
  cipLib: "POLARAMINE 2MG CPR SECAB BT 30",
  atcCode: "R06AB02"
}, {
  CIP7: '3084925',
  CIP13: '3400930849255',
  ucdLib: "POLARAMINE 5MG INJ AMP1ML",
  UCD7: '9073644',
  UCD13: '3400890736442',
  ucdQtyMultiplicator: 5,
  cipLib: "POLARAMINE 5MG INJ AMP1ML BT 5",
  atcCode: "R06AB02"
}, {
  CIP7: '3422730',
  CIP13: '3400934227301',
  ucdLib: "POLARAMINE 2MG CPR SECAB",
  UCD7: '9073650',
  UCD13: '3400890736503',
  ucdQtyMultiplicator: 20,
  cipLib: "POLARAMINE 2MG CPR SECAB BT 20",
  atcCode: "R06AB02"
}, {
  CIP7: '3031900',
  CIP13: '3400930319000',
  ucdLib: "DIMEGAN 12MG GELU",
  UCD7: '9027348',
  UCD13: '3400890273480',
  ucdQtyMultiplicator: 10,
  cipLib: "DIMEGAN 12MG GELU BT 10",
  atcCode: "R06AB01"
}, {
  CIP7: '5531742',
  CIP13: '3400955317425',
  ucdLib: "GOMENOL SOLUBLE NEB AMP5ML",
  UCD7: '9040455',
  UCD13: '3400890404556',
  ucdQtyMultiplicator: 100,
  cipLib: "GOMENOL SOLUBLE NEB AMP5ML BT 100",
  atcCode: "R05X"
}, {
  CIP7: '3065299',
  CIP13: '3400930652992',
  ucdLib: "MAXILASE M.GORGE SIR FL125ML",
  UCD7: '9057208',
  UCD13: '3400890572088',
  ucdQtyMultiplicator: 1,
  cipLib: "MAXILASE M.GORGE SIR FL125ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3006575',
  CIP13: '3400930065754',
  ucdLib: "AROMASOL SOL PR AERO FL45ML",
  UCD7: '9006547',
  UCD13: '3400890065474',
  ucdQtyMultiplicator: 1,
  cipLib: "AROMASOL SOL PR AERO FL45ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3004061',
  CIP13: '3400930040614',
  ucdLib: "HUMEXLIB ETAT GRIP S/SUC SACH",
  UCD7: '9420502',
  UCD13: '3400894205029',
  ucdQtyMultiplicator: 8,
  cipLib: "HUMEXLIB ETAT GRIP S/SUC SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '3575327',
  CIP13: '3400935753274',
  ucdLib: "ACTIFED RHUME JOUR&NUIT CPR",
  UCD7: '9176137',
  UCD13: '3400891761375',
  ucdQtyMultiplicator: 16,
  cipLib: "ACTIFED RHUME JOUR&NUIT CPR BT 16",
  atcCode: "R05X"
}, {
  CIP7: '3037512',
  CIP13: '3400930375129',
  ucdLib: "ESSENCES GOUTTES BUV FL45ML",
  UCD7: '9032852',
  UCD13: '3400890328524',
  ucdQtyMultiplicator: 1,
  cipLib: "ESSENCES GOUTTES BUV FL45ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3037506',
  CIP13: '3400930375068',
  ucdLib: "ESSENCES GOUTTES BUV FL90ML",
  UCD7: '9110339',
  UCD13: '3400891103397',
  ucdQtyMultiplicator: 1,
  cipLib: "ESSENCES GOUTTES BUV FL90ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3270591',
  CIP13: '3400932705917',
  ucdLib: "FERVEX GRIP AD. GLE BUV SACH",
  UCD7: '9034779',
  UCD13: '3400890347792',
  ucdQtyMultiplicator: 8,
  cipLib: "FERVEX GRIP AD. GLE BUV SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '3017455',
  CIP13: '3400930174555',
  ucdLib: "CALYPTOL INHALANT AMP5ML",
  UCD7: '9015411',
  UCD13: '3400890154116',
  ucdQtyMultiplicator: 10,
  cipLib: "CALYPTOL INHALANT AMP5ML BT 10",
  atcCode: "R05X"
}, {
  CIP7: '3045687',
  CIP13: '3400930456873',
  ucdLib: "GOMENOL SOLUBLE NEB AMP5ML",
  UCD7: '9040455',
  UCD13: '3400890404556',
  ucdQtyMultiplicator: 5,
  cipLib: "GOMENOL SOLUBLE NEB AMP5ML BT 5",
  atcCode: "R05X"
}, {
  CIP7: '3112662',
  CIP13: '3400931126621',
  ucdLib: "VICKS INHALER TAMP",
  UCD7: '9098615',
  UCD13: '3400890986151',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS INHALER TAMP BT 1",
  atcCode: "R05X"
}, {
  CIP7: '2769294',
  CIP13: '3400927692949',
  ucdLib: "CLARIX ETAT GRIP. BUV SACH",
  UCD7: '9416682',
  UCD13: '3400894166825',
  ucdQtyMultiplicator: 8,
  cipLib: "CLARIX ETAT GRIP. BUV SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '3335959',
  CIP13: '3400933359591',
  ucdLib: "FERVEX GRIP AD.S/SUC GLE SACH",
  UCD7: '9150741',
  UCD13: '3400891507416',
  ucdQtyMultiplicator: 8,
  cipLib: "FERVEX GRIP AD.S/SUC GLE SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '3337154',
  CIP13: '3400933371548',
  ucdLib: "SOLACY PEDIA CPR BUV",
  UCD7: '9149703',
  UCD13: '3400891497038',
  ucdQtyMultiplicator: 60,
  cipLib: "SOLACY PEDIA CPR BUV BT 60",
  atcCode: "R05X"
}, {
  CIP7: '3434868',
  CIP13: '3400934348686',
  ucdLib: "MAXILASE M.GORGE SIR FL200ML",
  UCD7: '9249008',
  UCD13: '3400892490083',
  ucdQtyMultiplicator: 1,
  cipLib: "MAXILASE M.GORGE SIR FL200ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3528196',
  CIP13: '3400935281968',
  ucdLib: "VICKS VAPORUB POM POT100G",
  UCD7: '9220683',
  UCD13: '3400892206837',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS VAPORUB POM POT100G BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3528173',
  CIP13: '3400935281739',
  ucdLib: "VICKS VAPORUB POM POT50G",
  UCD7: '9220708',
  UCD13: '3400892207087',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS VAPORUB POM POT50G BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3677424',
  CIP13: '3400936774247',
  ucdLib: "ALFA-AMYLASE BGC 200U SIR200ML",
  UCD7: '9295468',
  UCD13: '3400892954684',
  ucdQtyMultiplicator: 1,
  cipLib: "ALFA-AMYLASE BGC 200U SIR200ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '4989835',
  CIP13: '3400949898350',
  ucdLib: "FERVEX GRIP AD.FRAMB GLE SACH",
  UCD7: '9374676',
  UCD13: '3400893746769',
  ucdQtyMultiplicator: 8,
  cipLib: "FERVEX GRIP AD.FRAMB GLE SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '3351579',
  CIP13: '3400933515799',
  ucdLib: "FERVEX RHUME ENF S/S BUV SACH",
  UCD7: '9156028',
  UCD13: '3400891560282',
  ucdQtyMultiplicator: 8,
  cipLib: "FERVEX RHUME ENF S/S BUV SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '3565292',
  CIP13: '3400935652928',
  ucdLib: "ACTIFED ETAT.GRIP BUV SACH",
  UCD7: '9231801',
  UCD13: '3400892318011',
  ucdQtyMultiplicator: 10,
  cipLib: "ACTIFED ETAT.GRIP BUV SACH BT 10",
  atcCode: "R05X"
}, {
  CIP7: '3557223',
  CIP13: '3400935572233',
  ucdLib: "SOLACY AD. GELU",
  UCD7: '9085529',
  UCD13: '3400890855297',
  ucdQtyMultiplicator: 90,
  cipLib: "SOLACY AD. GELU BT 90",
  atcCode: "R05X"
}, {
  CIP7: '3553998',
  CIP13: '3400935539984',
  ucdLib: "TERPINE GONNON0,5% BUV FV200ML",
  UCD7: '9231273',
  UCD13: '3400892312736',
  ucdQtyMultiplicator: 1,
  cipLib: "TERPINE GONNON0,5% BUV FV200ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3516715',
  CIP13: '3400935167156',
  ucdLib: "ACTISOUFRE NAS BUC FL100ML",
  UCD7: '9255523',
  UCD13: '3400892555232',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTISOUFRE NAS BUC FL100ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3546455',
  CIP13: '3400935464552',
  ucdLib: "ALFA-AMYLASE BGC 200U SIR125ML",
  UCD7: '9295451',
  UCD13: '3400892954516',
  ucdQtyMultiplicator: 1,
  cipLib: "ALFA-AMYLASE BGC 200U SIR125ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3173959',
  CIP13: '3400931739593',
  ucdLib: "SOLACY AD. GELU",
  UCD7: '9085529',
  UCD13: '3400890855297',
  ucdQtyMultiplicator: 45,
  cipLib: "SOLACY AD. GELU BT 45",
  atcCode: "R05X"
}, {
  CIP7: '3761053',
  CIP13: '3400937610537',
  ucdLib: "ACTIFEDSIGN GELU",
  UCD7: '9079747',
  UCD13: '3400890797474',
  ucdQtyMultiplicator: 20,
  cipLib: "ACTIFEDSIGN GELU BT 20",
  atcCode: "R05X"
}, {
  CIP7: '3698604',
  CIP13: '3400936986046',
  ucdLib: "DOLIRHUMEPRO P/P/D CPR",
  UCD7: '9290620',
  UCD13: '3400892906201',
  ucdQtyMultiplicator: 16,
  cipLib: "DOLIRHUMEPRO P/P/D CPR BT 16",
  atcCode: "R05X"
}, {
  CIP7: '3477889',
  CIP13: '3400934778896',
  ucdLib: "MAXILASE M.GORGE 3000U CPR",
  UCD7: '9057220',
  UCD13: '3400890572200',
  ucdQtyMultiplicator: 30,
  cipLib: "MAXILASE M.GORGE 3000U CPR BT 30",
  atcCode: "R05X"
}, {
  CIP7: '3897025',
  CIP13: '3400938970258',
  ucdLib: "BALSOLENE SOL INHAL FL100ML",
  UCD7: '9326387',
  UCD13: '3400893263877',
  ucdQtyMultiplicator: 1,
  cipLib: "BALSOLENE SOL INHAL FL100ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3933258',
  CIP13: '3400939332581',
  ucdLib: "GOMENOL LIQ INHAL FUM FL15ML",
  UCD7: '9342742',
  UCD13: '3400893427422',
  ucdQtyMultiplicator: 1,
  cipLib: "GOMENOL LIQ INHAL FUM FL15ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3500387',
  CIP13: '3400935003874',
  ucdLib: "MEGAMYLASE 200U/ML SIR FL125ML",
  UCD7: '9213111',
  UCD13: '3400892131115',
  ucdQtyMultiplicator: 1,
  cipLib: "MEGAMYLASE 200U/ML SIR FL125ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3500393',
  CIP13: '3400935003935',
  ucdLib: "MEGAMYLASE 200U/ML SIR FL250ML",
  UCD7: '9213128',
  UCD13: '3400892131283',
  ucdQtyMultiplicator: 1,
  cipLib: "MEGAMYLASE 200U/ML SIR FL250ML BT 1",
  atcCode: "R05X"
}, {
  CIP7: '3500370',
  CIP13: '3400935003706',
  ucdLib: "MEGAMYLASE 3000U CPR",
  UCD7: '9213105',
  UCD13: '3400892131054',
  ucdQtyMultiplicator: 24,
  cipLib: "MEGAMYLASE 3000U CPR BT 24",
  atcCode: "R05X"
}, {
  CIP7: '2742556',
  CIP13: '3400927425561',
  ucdLib: "FERVEX RHUME J/N CPR",
  UCD7: '9411779',
  UCD13: '3400894117797',
  ucdQtyMultiplicator: 16,
  cipLib: "FERVEX RHUME J/N CPR BT 16",
  atcCode: "R05X"
}, {
  CIP7: '2746815',
  CIP13: '3400927468155',
  ucdLib: "FLUSTIMEX PDR BUV SACH",
  UCD7: '9396620',
  UCD13: '3400893966204',
  ucdQtyMultiplicator: 8,
  cipLib: "FLUSTIMEX PDR BUV SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '2782739',
  CIP13: '3400927827396',
  ucdLib: "HUMEXLIB ETAT GRIP BUV SACH",
  UCD7: '9403573',
  UCD13: '3400894035732',
  ucdQtyMultiplicator: 8,
  cipLib: "HUMEXLIB ETAT GRIP BUV SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '3993384',
  CIP13: '3400939933849',
  ucdLib: "MAXILASE M.GORGE 3000U CPR",
  UCD7: '9057220',
  UCD13: '3400890572200',
  ucdQtyMultiplicator: 15,
  cipLib: "MAXILASE M.GORGE 3000U CPR BT 15",
  atcCode: "R05X"
}, {
  CIP7: '4964404',
  CIP13: '3400949644049',
  ucdLib: "ALFA-AMYLASE BGC 3000U CPR",
  UCD7: '9295474',
  UCD13: '3400892954745',
  ucdQtyMultiplicator: 18,
  cipLib: "ALFA-AMYLASE BGC 3000U CPR BT 18",
  atcCode: "R05X"
}, {
  CIP7: '2773290',
  CIP13: '3400927732904',
  ucdLib: "DOLI E.GRIP PARAC/C/PHEN.SACH",
  UCD7: '9402272',
  UCD13: '3400894022725',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLI E.GRIP PARAC/C/PHEN.SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '2773249',
  CIP13: '3400927732492',
  ucdLib: "PARACET/VIT C/PHENIR.MYC SACH",
  UCD7: '9410426',
  UCD13: '3400894104261',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACET/VIT C/PHENIR.MYC SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '2779565',
  CIP13: '3400927795657',
  ucdLib: "PARACET/VIT C/PHENIR.SDC SACH",
  UCD7: '9399311',
  UCD13: '3400893993118',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACET/VIT C/PHENIR.SDC SACH BT 8",
  atcCode: "R05X"
}, {
  CIP7: '3312438',
  CIP13: '3400933124380',
  ucdLib: "TERPONE SIR FL180ML",
  UCD7: '9145421',
  UCD13: '3400891454215',
  ucdQtyMultiplicator: 1,
  cipLib: "TERPONE SIR FL180ML BT 1",
  atcCode: "R05FB02"
}, {
  CIP7: '3850495',
  CIP13: '3400938504958',
  ucdLib: "EUPHONYLL EXPEC.AD SIR FL180ML",
  UCD7: '9368753',
  UCD13: '3400893687536',
  ucdQtyMultiplicator: 1,
  cipLib: "EUPHONYLL EXPEC.AD SIR FL180ML BT 1",
  atcCode: "R05FB02"
}, {
  CIP7: '3411040',
  CIP13: '3400934110405',
  ucdLib: "PASSEDYL ENF/BB. SIR FL125ML",
  UCD7: '9202768',
  UCD13: '3400892027685',
  ucdQtyMultiplicator: 1,
  cipLib: "PASSEDYL ENF/BB. SIR FL125ML BT 1",
  atcCode: "R05FB02"
}, {
  CIP7: '3288993',
  CIP13: '3400932889938',
  ucdLib: "PULMOSERUM BUV FV200ML",
  UCD7: '9132192',
  UCD13: '3400891321920',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMOSERUM BUV FV200ML BT 1",
  atcCode: "R05FA02"
}, {
  CIP7: '3032029',
  CIP13: '3400930320297',
  ucdLib: "DINACODE AD. SIR FL180ML",
  UCD7: '9027408',
  UCD13: '3400890274081',
  ucdQtyMultiplicator: 1,
  cipLib: "DINACODE AD. SIR FL180ML BT 1",
  atcCode: "R05FA02"
}, {
  CIP7: '3276576',
  CIP13: '3400932765768',
  ucdLib: "NEO-CODION CPR ENROB",
  UCD7: '9061606',
  UCD13: '3400890616065',
  ucdQtyMultiplicator: 20,
  cipLib: "NEO-CODION CPR ENROB BT 20",
  atcCode: "R05FA02"
}, {
  CIP7: '3111869',
  CIP13: '3400931118695',
  ucdLib: "VEGETOSERUM AD. SIR FL150ML",
  UCD7: '9097998',
  UCD13: '3400890979986',
  ucdQtyMultiplicator: 1,
  cipLib: "VEGETOSERUM AD. SIR FL150ML BT 1",
  atcCode: "R05FA02"
}, {
  CIP7: '3071012',
  CIP13: '3400930710128',
  ucdLib: "NEO-CODION ENF SIR FL125ML",
  UCD7: '9061664',
  UCD13: '3400890616645',
  ucdQtyMultiplicator: 1,
  cipLib: "NEO-CODION ENF SIR FL125ML BT 1",
  atcCode: "R05FA02"
}, {
  CIP7: '3437016',
  CIP13: '3400934370168',
  ucdLib: "PULMOBAILLY BUV FL125ML",
  UCD7: '9207010',
  UCD13: '3400892070100',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMOBAILLY BUV FL125ML BT 1",
  atcCode: "R05FA02"
}, {
  CIP7: '3418036',
  CIP13: '3400934180361',
  ucdLib: "THIOPECTOL AD. SIR FL150ML",
  UCD7: '9197228',
  UCD13: '3400891972283',
  ucdQtyMultiplicator: 1,
  cipLib: "THIOPECTOL AD. SIR FL150ML BT 1",
  atcCode: "R05FA02"
}, {
  CIP7: '3063107',
  CIP13: '3400930631072',
  ucdLib: "FLUISEDAL SIR FL125ML",
  UCD7: '9035537',
  UCD13: '3400890355377',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUISEDAL SIR FL125ML BT 1",
  atcCode: "R05DB20"
}, {
  CIP7: '3277877',
  CIP13: '3400932778775',
  ucdLib: "FLUISEDAL SIR FL250ML",
  UCD7: '9117933',
  UCD13: '3400891179330',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUISEDAL SIR FL250ML BT 1",
  atcCode: "R05DB20"
}, {
  CIP7: '3288970',
  CIP13: '3400932889709',
  ucdLib: "PAXELADINE 0,2% SIR FL125ML",
  UCD7: '9114194',
  UCD13: '3400891141948',
  ucdQtyMultiplicator: 1,
  cipLib: "PAXELADINE 0,2% SIR FL125ML BT 1",
  atcCode: "R05DB09"
}, {
  CIP7: '3535776',
  CIP13: '3400935357762',
  ucdLib: "VICKS SIROP PECTORAL FL150ML",
  UCD7: '9220677',
  UCD13: '3400892206776',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS SIROP PECTORAL FL150ML BT 1",
  atcCode: "R05DB05"
}, {
  CIP7: '3826700',
  CIP13: '3400938267006',
  ucdLib: "CLARIX T.SEC PENTO.ENF FL150ML",
  UCD7: '9319424',
  UCD13: '3400893194249',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARIX T.SEC PENTO.ENF FL150ML BT 1",
  atcCode: "R05DB05"
}, {
  CIP7: '3084931',
  CIP13: '3400930849316',
  ucdLib: "POLERY AD. SIR FL200ML",
  UCD7: '9073704',
  UCD13: '3400890737043',
  ucdQtyMultiplicator: 1,
  cipLib: "POLERY AD. SIR FL200ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3281057',
  CIP13: '3400932810574',
  ucdLib: "TUSSIPAX CPR",
  UCD7: '9095858',
  UCD13: '3400890958585',
  ucdQtyMultiplicator: 15,
  cipLib: "TUSSIPAX CPR BT 15",
  atcCode: "R05DA20"
}, {
  CIP7: '3038144',
  CIP13: '3400930381441',
  ucdLib: "EUCALYPTINE SIR FL200ML",
  UCD7: '9033254',
  UCD13: '3400890332545',
  ucdQtyMultiplicator: 1,
  cipLib: "EUCALYPTINE SIR FL200ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3272615',
  CIP13: '3400932726158',
  ucdLib: "HEXAPNEUMINE AD. SIR FL200ML",
  UCD7: '9043399',
  UCD13: '3400890433990',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXAPNEUMINE AD. SIR FL200ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3272621',
  CIP13: '3400932726219',
  ucdLib: "HEXAPNEUMINE ENF SIR FL200ML",
  UCD7: '9043407',
  UCD13: '3400890434072',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXAPNEUMINE ENF SIR FL200ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3109654',
  CIP13: '3400931096542',
  ucdLib: "TUSSIPAX BUV GTT FL24ML",
  UCD7: '9095864',
  UCD13: '3400890958646',
  ucdQtyMultiplicator: 1,
  cipLib: "TUSSIPAX BUV GTT FL24ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3109660',
  CIP13: '3400931096603',
  ucdLib: "TUSSIPAX SIR FL200ML",
  UCD7: '9095870',
  UCD13: '3400890958707',
  ucdQtyMultiplicator: 1,
  cipLib: "TUSSIPAX SIR FL200ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3073844',
  CIP13: '3400930738443',
  ucdLib: "CLARIX T.SEC DEXT.MEP.AD.125ML",
  UCD7: '9063717',
  UCD13: '3400890637176',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARIX T.SEC DEXT.MEP.AD.125ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3748331',
  CIP13: '3400937483315',
  ucdLib: "EUPHON SIR FL300ML",
  UCD7: '9300979',
  UCD13: '3400893009796',
  ucdQtyMultiplicator: 1,
  cipLib: "EUPHON SIR FL300ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3160508',
  CIP13: '3400931605089',
  ucdLib: "TUSSISEDAL SIR FL125ML",
  UCD7: '9095901',
  UCD13: '3400890959018',
  ucdQtyMultiplicator: 1,
  cipLib: "TUSSISEDAL SIR FL125ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3506616',
  CIP13: '3400935066169',
  ucdLib: "POLERY ENF SIR FL125ML+SRG",
  UCD7: '9212086',
  UCD13: '3400892120867',
  ucdQtyMultiplicator: 1,
  cipLib: "POLERY ENF SIR FL125ML+SRG BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3984586',
  CIP13: '3400939845869',
  ucdLib: "POLERY AD. S/SUC SIR FL200ML",
  UCD7: '9362325',
  UCD13: '3400893623251',
  ucdQtyMultiplicator: 1,
  cipLib: "POLERY AD. S/SUC SIR FL200ML BT 1",
  atcCode: "R05DA20"
}, {
  CIP7: '3285256',
  CIP13: '3400932852567',
  ucdLib: "ERGIX TOUX SECHE AD. SIR 150ML",
  UCD7: '9106846',
  UCD13: '3400891068467',
  ucdQtyMultiplicator: 1,
  cipLib: "ERGIX TOUX SECHE AD. SIR 150ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3311692',
  CIP13: '3400933116927',
  ucdLib: "TUXIUM 30MG CAPS",
  UCD7: '9135084',
  UCD13: '3400891350845',
  ucdQtyMultiplicator: 12,
  cipLib: "TUXIUM 30MG CAPS BT 12",
  atcCode: "R05DA09"
}, {
  CIP7: '3433432',
  CIP13: '3400934334320',
  ucdLib: "DRILL T.SEC AD. SIR FV125ML",
  UCD7: '9196111',
  UCD13: '3400891961119',
  ucdQtyMultiplicator: 1,
  cipLib: "DRILL T.SEC AD. SIR FV125ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3433449',
  CIP13: '3400934334498',
  ucdLib: "DRILL T.SEC ENF SIR FV125ML",
  UCD7: '9196128',
  UCD13: '3400891961287',
  ucdQtyMultiplicator: 1,
  cipLib: "DRILL T.SEC ENF SIR FV125ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3353348',
  CIP13: '3400933533489',
  ucdLib: "EUPHONYLL T.SEC AD.S/S FL125ML",
  UCD7: '9368776',
  UCD13: '3400893687765',
  ucdQtyMultiplicator: 1,
  cipLib: "EUPHONYLL T.SEC AD.S/S FL125ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3366227',
  CIP13: '3400933662271',
  ucdLib: "ATUXANE SIR FL125ML",
  UCD7: '9171772',
  UCD13: '3400891717723',
  ucdQtyMultiplicator: 1,
  cipLib: "ATUXANE SIR FL125ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3563057',
  CIP13: '3400935630575',
  ucdLib: "HUMEX AD. T.SEC DEXT. SIR200ML",
  UCD7: '9241099',
  UCD13: '3400892410999',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMEX AD. T.SEC DEXT. SIR200ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3567405',
  CIP13: '3400935674050',
  ucdLib: "HUMEX ENF T.SEC DEXT. SIR125ML",
  UCD7: '9241107',
  UCD13: '3400892411071',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMEX ENF T.SEC DEXT. SIR125ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3550913',
  CIP13: '3400935509130',
  ucdLib: "PULMODEXANE S/SUC BUV FL150ML",
  UCD7: '9230581',
  UCD13: '3400892305813',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMODEXANE S/SUC BUV FL150ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3485133',
  CIP13: '3400934851339',
  ucdLib: "BIOCADEXTRO ENF S/SUC SIR100ML",
  UCD7: '9391841',
  UCD13: '3400893918418',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOCADEXTRO ENF S/SUC SIR100ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3418556',
  CIP13: '3400934185564',
  ucdLib: "DEXTROCIDINE 0,3% SIR FL150ML",
  UCD7: '9198162',
  UCD13: '3400891981629',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXTROCIDINE 0,3% SIR FL150ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3485156',
  CIP13: '3400934851568',
  ucdLib: "FLUIMUCIL T.SEC AD.SS SIR200ML",
  UCD7: '9403610',
  UCD13: '3400894036104',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUIMUCIL T.SEC AD.SS SIR200ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3622676',
  CIP13: '3400936226760',
  ucdLib: "TUSSIDANE 1,5MG/ML SIR FL125ML",
  UCD7: '9250715',
  UCD13: '3400892507156',
  ucdQtyMultiplicator: 1,
  cipLib: "TUSSIDANE 1,5MG/ML SIR FL125ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3622682',
  CIP13: '3400936226821',
  ucdLib: "TUSSIDANE 1,5MG/ML SIR FL250ML",
  UCD7: '9250721',
  UCD13: '3400892507217',
  ucdQtyMultiplicator: 1,
  cipLib: "TUSSIDANE 1,5MG/ML SIR FL250ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3479581',
  CIP13: '3400934795817',
  ucdLib: "ERGIX TOUX SECHE GELU",
  UCD7: '9211253',
  UCD13: '3400892112534',
  ucdQtyMultiplicator: 20,
  cipLib: "ERGIX TOUX SECHE GELU BT 20",
  atcCode: "R05DA09"
}, {
  CIP7: '3782888',
  CIP13: '3400937828888',
  ucdLib: "PULMODEXANE 30MG CPR",
  UCD7: '9314071',
  UCD13: '3400893140710',
  ucdQtyMultiplicator: 12,
  cipLib: "PULMODEXANE 30MG CPR BT 12",
  atcCode: "R05DA09"
}, {
  CIP7: '3798553',
  CIP13: '3400937985536',
  ucdLib: "TUSSIDANE 1,5MG/ML SS BUV125ML",
  UCD7: '9310311',
  UCD13: '3400893103111',
  ucdQtyMultiplicator: 1,
  cipLib: "TUSSIDANE 1,5MG/ML SS BUV125ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3798599',
  CIP13: '3400937985994',
  ucdLib: "TUSSIDANE 1,5MG/ML SS BUV250ML",
  UCD7: '9310328',
  UCD13: '3400893103289',
  ucdQtyMultiplicator: 1,
  cipLib: "TUSSIDANE 1,5MG/ML SS BUV250ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3785289',
  CIP13: '3400937852890',
  ucdLib: "VICKS AD. T.SEC MIEL SIR 120ML",
  UCD7: '9305416',
  UCD13: '3400893054161',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS AD. T.SEC MIEL SIR 120ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '3785295',
  CIP13: '3400937852951',
  ucdLib: "VICKS AD. T.SEC MIEL SIR 180ML",
  UCD7: '9387012',
  UCD13: '3400893870129',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS AD. T.SEC MIEL SIR 180ML BT 1",
  atcCode: "R05DA09"
}, {
  CIP7: '4973053',
  CIP13: '3400949730537',
  ucdLib: "NODEX AD. SIR SACH10ML",
  UCD7: '9371525',
  UCD13: '3400893715253',
  ucdQtyMultiplicator: 10,
  cipLib: "NODEX AD. SIR SACH10ML BT 10",
  atcCode: "R05DA09"
}, {
  CIP7: '4155805',
  CIP13: '3400941558054',
  ucdLib: "TUSSIDANE 30MG CPR",
  UCD7: '9377019',
  UCD13: '3400893770191',
  ucdQtyMultiplicator: 12,
  cipLib: "TUSSIDANE 30MG CPR BT 12",
  atcCode: "R05DA09"
}, {
  CIP7: '4151322',
  CIP13: '3400941513220',
  ucdLib: "VICKS T.SEC AD. MIEL PAST",
  UCD7: '9368730',
  UCD13: '3400893687307',
  ucdQtyMultiplicator: 12,
  cipLib: "VICKS T.SEC AD. MIEL PAST BT 12",
  atcCode: "R05DA09"
}, {
  CIP7: '2670791',
  CIP13: '3400926707910',
  ucdLib: "CLARIX T.SEC DEXT.AD S/S SAC",
  UCD7: '9390190',
  UCD13: '3400893901908',
  ucdQtyMultiplicator: 15,
  cipLib: "CLARIX T.SEC DEXT.AD S/S SAC BT 15",
  atcCode: "R05DA09"
}, {
  CIP7: '2670615',
  CIP13: '3400926706159',
  ucdLib: "FLUIMUCIL T.SEC AD.SS SACH",
  UCD7: '9411650',
  UCD13: '3400894116509',
  ucdQtyMultiplicator: 15,
  cipLib: "FLUIMUCIL T.SEC AD.SS SACH BT 15",
  atcCode: "R05DA09"
}, {
  CIP7: '2670762',
  CIP13: '3400926707620',
  ucdLib: "HUMEX AD. T.SEC DEXT. SS SAC",
  UCD7: '9390557',
  UCD13: '3400893905579',
  ucdQtyMultiplicator: 15,
  cipLib: "HUMEX AD. T.SEC DEXT. SS SAC BT 15",
  atcCode: "R05DA09"
}, {
  CIP7: '2670561',
  CIP13: '3400926705619',
  ucdLib: "SURBRONC T.SEC.DEXT. SS SACH",
  UCD7: '9403538',
  UCD13: '3400894035381',
  ucdQtyMultiplicator: 15,
  cipLib: "SURBRONC T.SEC.DEXT. SS SACH BT 15",
  atcCode: "R05DA09"
}, {
  CIP7: '3572151',
  CIP13: '3400935721518',
  ucdLib: "BIOCALYPTOL SIR FV200ML",
  UCD7: '9237034',
  UCD13: '3400892370347',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOCALYPTOL SIR FV200ML BT 1",
  atcCode: "R05DA08"
}, {
  CIP7: '3626651',
  CIP13: '3400936266513',
  ucdLib: "DIMETANE SS SUCRE SIR FL200ML",
  UCD7: '9256942',
  UCD13: '3400892569420',
  ucdQtyMultiplicator: 1,
  cipLib: "DIMETANE SS SUCRE SIR FL200ML BT 1",
  atcCode: "R05DA08"
}, {
  CIP7: '3584527',
  CIP13: '3400935845276',
  ucdLib: "BIOCALYPTOL S/SUC SIR FV200ML",
  UCD7: '9314059',
  UCD13: '3400893140598',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOCALYPTOL S/SUC SIR FV200ML BT 1",
  atcCode: "R05DA08"
}, {
  CIP7: '3071006',
  CIP13: '3400930710067',
  ucdLib: "NEO-CODION AD. SIR FL180ML",
  UCD7: '9061658',
  UCD13: '3400890616584',
  ucdQtyMultiplicator: 1,
  cipLib: "NEO-CODION AD. SIR FL180ML BT 1",
  atcCode: "R05DA04"
}, {
  CIP7: '3077606',
  CIP13: '3400930776063',
  ucdLib: "PADERYL 0,1% SIR FL150ML",
  UCD7: '9066934',
  UCD13: '3400890669344',
  ucdQtyMultiplicator: 1,
  cipLib: "PADERYL 0,1% SIR FL150ML BT 1",
  atcCode: "R05DA04"
}, {
  CIP7: '3077598',
  CIP13: '3400930775981',
  ucdLib: "PADERYL 19,5MG CPR",
  UCD7: '9066928',
  UCD13: '3400890669283',
  ucdQtyMultiplicator: 20,
  cipLib: "PADERYL 19,5MG CPR BT 20",
  atcCode: "R05DA04"
}, {
  CIP7: '3544338',
  CIP13: '3400935443380',
  ucdLib: "CODEDRILL S/SUC 0,1% BUV 200ML",
  UCD7: '9222564',
  UCD13: '3400892225647',
  ucdQtyMultiplicator: 1,
  cipLib: "CODEDRILL S/SUC 0,1% BUV 200ML BT 1",
  atcCode: "R05DA04"
}, {
  CIP7: '3496823',
  CIP13: '3400934968235',
  ucdLib: "PETER'S SIR FL250ML",
  UCD7: '9218462',
  UCD13: '3400892184623',
  ucdQtyMultiplicator: 1,
  cipLib: "PETER'S SIR FL250ML BT 1",
  atcCode: "R05DA01"
}, {
  CIP7: '2742852',
  CIP13: '3400927428524',
  ucdLib: "CLARIX T.SEC CODETHY. S/S250ML",
  UCD7: '9396293',
  UCD13: '3400893962930',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARIX T.SEC CODETHY. S/S250ML BT 1",
  atcCode: "R05DA01"
}, {
  CIP7: '3371524',
  CIP13: '3400933715243',
  ucdLib: "VECTRINE 300MG BUV PDR SACH",
  UCD7: '9174397',
  UCD13: '3400891743975',
  ucdQtyMultiplicator: 20,
  cipLib: "VECTRINE 300MG BUV PDR SACH BT 20",
  atcCode: "R05CB15"
}, {
  CIP7: '3364837',
  CIP13: '3400933648374',
  ucdLib: "VECTRINE 300MG GELU",
  UCD7: '9172085',
  UCD13: '3400891720853',
  ucdQtyMultiplicator: 20,
  cipLib: "VECTRINE 300MG GELU BT 20",
  atcCode: "R05CB15"
}, {
  CIP7: '3646748',
  CIP13: '3400936467484',
  ucdLib: "PULMOZYME 2500U INHAL AMP",
  UCD7: '9164832',
  UCD13: '3400891648324',
  ucdQtyMultiplicator: 6,
  cipLib: "PULMOZYME 2500U INHAL AMP BT 6",
  atcCode: "R05CB13"
}, {
  CIP7: '3646754',
  CIP13: '3400936467545',
  ucdLib: "PULMOZYME 2500U INHAL AMP",
  UCD7: '9164832',
  UCD13: '3400891648324',
  ucdQtyMultiplicator: 30,
  cipLib: "PULMOZYME 2500U INHAL AMP BT 30",
  atcCode: "R05CB13"
}, {
  CIP7: '3314779',
  CIP13: '3400933147792',
  ucdLib: "FLUISEDAL S.PROMET.SIR FV250ML",
  UCD7: '9140056',
  UCD13: '3400891400564',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUISEDAL S.PROMET.SIR FV250ML BT 1",
  atcCode: "R05CB10"
}, {
  CIP7: '3206096',
  CIP13: '3400932060962',
  ucdLib: "FLUISEDAL S.PROMET.SIR FV125ML",
  UCD7: '9140033',
  UCD13: '3400891400335',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUISEDAL S.PROMET.SIR FV125ML BT 1",
  atcCode: "R05CB10"
}, {
  CIP7: '3619510',
  CIP13: '3400936195103',
  ucdLib: "AMBROXOL EGC 0,6% BUV 150ML+CM",
  UCD7: '9250253',
  UCD13: '3400892502533',
  ucdQtyMultiplicator: 1,
  cipLib: "AMBROXOL EGC 0,6% BUV 150ML+CM BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3617698',
  CIP13: '3400936176980',
  ucdLib: "AMBROXOL MYL 0,6% BUV 150ML+GD",
  UCD7: '9250336',
  UCD13: '3400892503363',
  ucdQtyMultiplicator: 1,
  cipLib: "AMBROXOL MYL 0,6% BUV 150ML+GD BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3611655',
  CIP13: '3400936116559',
  ucdLib: "AMBROXOL TCO 0,3% BUV FL180ML",
  UCD7: '9244413',
  UCD13: '3400892444130',
  ucdQtyMultiplicator: 1,
  cipLib: "AMBROXOL TCO 0,3% BUV FL180ML BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3619177',
  CIP13: '3400936191778',
  ucdLib: "AMBROXOL TCO 0,6% BUV 150ML+CM",
  UCD7: '9254280',
  UCD13: '3400892542805',
  ucdQtyMultiplicator: 1,
  cipLib: "AMBROXOL TCO 0,6% BUV 150ML+CM BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3611661',
  CIP13: '3400936116610',
  ucdLib: "AMBROXOL TCO 30MG CPR",
  UCD7: '9244436',
  UCD13: '3400892444369',
  ucdQtyMultiplicator: 30,
  cipLib: "AMBROXOL TCO 30MG CPR BT 30",
  atcCode: "R05CB06"
}, {
  CIP7: '3617882',
  CIP13: '3400936178823',
  ucdLib: "VICKS EXPEC AMBR.0,6% 150ML+GD",
  UCD7: '9394963',
  UCD13: '3400893949634',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS EXPEC AMBR.0,6% 150ML+GD BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3322922',
  CIP13: '3400933229221',
  ucdLib: "MUXOL 30MG CPR",
  UCD7: '9144077',
  UCD13: '3400891440775',
  ucdQtyMultiplicator: 30,
  cipLib: "MUXOL 30MG CPR BT 30",
  atcCode: "R05CB06"
}, {
  CIP7: '3274063',
  CIP13: '3400932740635',
  ucdLib: "SURBRONC EXPEC.AMBR. S/S 100ML",
  UCD7: '9284016',
  UCD13: '3400892840161',
  ucdQtyMultiplicator: 1,
  cipLib: "SURBRONC EXPEC.AMBR. S/S 100ML BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3274040',
  CIP13: '3400932740406',
  ucdLib: "SURBRONC EXPEC.AMBR.30MG CPR",
  UCD7: '9119174',
  UCD13: '3400891191745',
  ucdQtyMultiplicator: 30,
  cipLib: "SURBRONC EXPEC.AMBR.30MG CPR BT 30",
  atcCode: "R05CB06"
}, {
  CIP7: '3302434',
  CIP13: '3400933024345',
  ucdLib: "MUXOL BUV SOL FV180ML",
  UCD7: '9136480',
  UCD13: '3400891364804',
  ucdQtyMultiplicator: 1,
  cipLib: "MUXOL BUV SOL FV180ML BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3596134',
  CIP13: '3400935961341',
  ucdLib: "AMBROXOL ARW 30MG CPR",
  UCD7: '9242236',
  UCD13: '3400892422367',
  ucdQtyMultiplicator: 30,
  cipLib: "AMBROXOL ARW 30MG CPR BT 30",
  atcCode: "R05CB06"
}, {
  CIP7: '3488781',
  CIP13: '3400934887819',
  ucdLib: "AMBROXOL EGC 0,3% S/SUC 180ML",
  UCD7: '9215618',
  UCD13: '3400892156187',
  ucdQtyMultiplicator: 1,
  cipLib: "AMBROXOL EGC 0,3% S/SUC 180ML BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3488686',
  CIP13: '3400934886867',
  ucdLib: "AMBROXOL EGC 30MG CPR",
  UCD7: '9215624',
  UCD13: '3400892156248',
  ucdQtyMultiplicator: 30,
  cipLib: "AMBROXOL EGC 30MG CPR BT 30",
  atcCode: "R05CB06"
}, {
  CIP7: '3588548',
  CIP13: '3400935885487',
  ucdLib: "AMBROXOL ARW 0,6% BUV 150ML+GD",
  UCD7: '9240616',
  UCD13: '3400892406169',
  ucdQtyMultiplicator: 1,
  cipLib: "AMBROXOL ARW 0,6% BUV 150ML+GD BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3705511',
  CIP13: '3400937055116',
  ucdLib: "AMBROXOL MYL 30MG CPR",
  UCD7: '9192604',
  UCD13: '3400891926040',
  ucdQtyMultiplicator: 20,
  cipLib: "AMBROXOL MYL 30MG CPR BT 20",
  atcCode: "R05CB06"
}, {
  CIP7: '3814157',
  CIP13: '3400938141573',
  ucdLib: "AMBROXOL BGC 0,6% S/S 100ML+GD",
  UCD7: '9308739',
  UCD13: '3400893087398',
  ucdQtyMultiplicator: 1,
  cipLib: "AMBROXOL BGC 0,6% S/S 100ML+GD BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3813548',
  CIP13: '3400938135480',
  ucdLib: "AMBROXOL BGC 30MG CPR",
  UCD7: '9202395',
  UCD13: '3400892023953',
  ucdQtyMultiplicator: 20,
  cipLib: "AMBROXOL BGC 30MG CPR BT 20",
  atcCode: "R05CB06"
}, {
  CIP7: '3771152',
  CIP13: '3400937711524',
  ucdLib: "AMBROXOL SDC 0,6% BUV 150ML+GD",
  UCD7: '9291476',
  UCD13: '3400892914763',
  ucdQtyMultiplicator: 1,
  cipLib: "AMBROXOL SDC 0,6% BUV 150ML+GD BT 1",
  atcCode: "R05CB06"
}, {
  CIP7: '3475063',
  CIP13: '3400934750632',
  ucdLib: "VICKS EXPEC AMBROX.30MG CPR",
  UCD7: '9205838',
  UCD13: '3400892058382',
  ucdQtyMultiplicator: 30,
  cipLib: "VICKS EXPEC AMBROX.30MG CPR BT 30",
  atcCode: "R05CB06"
}, {
  CIP7: '3611690',
  CIP13: '3400936116900',
  ucdLib: "CARBOCISTEINE TCO ENF SIR125ML",
  UCD7: '9244749',
  UCD13: '3400892447490',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE TCO ENF SIR125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3610578',
  CIP13: '3400936105782',
  ucdLib: "ERGIX EXPEC. AD. S/SUC FL250ML",
  UCD7: '9255948',
  UCD13: '3400892559483',
  ucdQtyMultiplicator: 1,
  cipLib: "ERGIX EXPEC. AD. S/SUC FL250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3271521',
  CIP13: '3400932715213',
  ucdLib: "BRONCHOKOD S/SUC ENF BUV 125ML",
  UCD7: '9102469',
  UCD13: '3400891024692',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCHOKOD S/SUC ENF BUV 125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3252127',
  CIP13: '3400932521272',
  ucdLib: "BRONCATHIOL ENF BUV FV125ML",
  UCD7: '9202604',
  UCD13: '3400892026046',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCATHIOL ENF BUV FV125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3241862',
  CIP13: '3400932418626',
  ucdLib: "BRONCHOKOD ENF 2% SIR FV125ML",
  UCD7: '9013553',
  UCD13: '3400890135535',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCHOKOD ENF 2% SIR FV125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3332808',
  CIP13: '3400933328085',
  ucdLib: "BRONCOCLAR 5% AD. SIR FL250ML",
  UCD7: '9171648',
  UCD13: '3400891716481',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCOCLAR 5% AD. SIR FL250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3606128',
  CIP13: '3400936061286',
  ucdLib: "CLARIX EXP.CARB.5% S/S FL250ML",
  UCD7: '9242928',
  UCD13: '3400892429281',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARIX EXP.CARB.5% S/S FL250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3090937',
  CIP13: '3400930909379',
  ucdLib: "RHINATHIOL CARBO.2% SIR 125ML",
  UCD7: '9079552',
  UCD13: '3400890795524',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINATHIOL CARBO.2% SIR 125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3430327',
  CIP13: '3400934303272',
  ucdLib: "DRILL EXPEC AD. SIR FV200ML",
  UCD7: '9195465',
  UCD13: '3400891954654',
  ucdQtyMultiplicator: 1,
  cipLib: "DRILL EXPEC AD. SIR FV200ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3341658',
  CIP13: '3400933416584',
  ucdLib: "MEDIBRONC ENF SIR FL150ML",
  UCD7: '9155069',
  UCD13: '3400891550696',
  ucdQtyMultiplicator: 1,
  cipLib: "MEDIBRONC ENF SIR FL150ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3430965',
  CIP13: '3400934309656',
  ucdLib: "RHINATHIOL CARBO.2% S/SUC125ML",
  UCD7: '9198498',
  UCD13: '3400891984989',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINATHIOL CARBO.2% S/SUC125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3674377',
  CIP13: '3400936743779',
  ucdLib: "CARBOCISTEINE ZTC S/S ENF125ML",
  UCD7: '9269838',
  UCD13: '3400892698380',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE ZTC S/S ENF125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3396033',
  CIP13: '3400933960339',
  ucdLib: "BRONCATHIOL EXPEC.AD FV150ML",
  UCD7: '9199345',
  UCD13: '3400891993455',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCATHIOL EXPEC.AD FV150ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3550250',
  CIP13: '3400935502506',
  ucdLib: "CARBOCISTEINE EGC ENF SIR125ML",
  UCD7: '9224155',
  UCD13: '3400892241555',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE EGC ENF SIR125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3418591',
  CIP13: '3400934185915',
  ucdLib: "CARBOCISTEINE RTC ENF SIR125ML",
  UCD7: '9206045',
  UCD13: '3400892060453',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE RTC ENF SIR125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3581799',
  CIP13: '3400935817990',
  ucdLib: "CARBOCISTEINE BGA S/S ENF125ML",
  UCD7: '9250939',
  UCD13: '3400892509396',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE BGA S/S ENF125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3466696',
  CIP13: '3400934666964',
  ucdLib: "MEDIBRONC AD. BUV FL250ML",
  UCD7: '9246300',
  UCD13: '3400892463001',
  ucdQtyMultiplicator: 1,
  cipLib: "MEDIBRONC AD. BUV FL250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3741234',
  CIP13: '3400937412346',
  ucdLib: "CARBOCIST.MYL AD. SIR200ML +GD",
  UCD7: '9284832',
  UCD13: '3400892848327',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCIST.MYL AD. SIR200ML +GD BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3741168',
  CIP13: '3400937411684',
  ucdLib: "CARBOCIST.MYL ENF SIR125ML+SRG",
  UCD7: '9284849',
  UCD13: '3400892848495',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCIST.MYL ENF SIR125ML+SRG BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3749514',
  CIP13: '3400937495141',
  ucdLib: "CARBOCIST.MYL S/S AD.200ML +GD",
  UCD7: '9284855',
  UCD13: '3400892848556',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCIST.MYL S/S AD.200ML +GD BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3813442',
  CIP13: '3400938134421',
  ucdLib: "CARBOCISTEINE BGC S/S 5% 200ML",
  UCD7: '9308745',
  UCD13: '3400893087459',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE BGC S/S 5% 200ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3638482',
  CIP13: '3400936384828',
  ucdLib: "CLARIX EXP.CARB.2% SIR FL150ML",
  UCD7: '9263103',
  UCD13: '3400892631035',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARIX EXP.CARB.2% SIR FL150ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3383467',
  CIP13: '3400933834678',
  ucdLib: "FLUDITEC ENF 2% SIR FL125ML",
  UCD7: '9183321',
  UCD13: '3400891833218',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUDITEC ENF 2% SIR FL125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3718933',
  CIP13: '3400937189330',
  ucdLib: "CARBOCIST.MYL S/S ENF125ML+SRG",
  UCD7: '9284861',
  UCD13: '3400892848617',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCIST.MYL S/S ENF125ML+SRG BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3771181',
  CIP13: '3400937711814',
  ucdLib: "CARBOCISTEINE SDC ENF SIR125ML",
  UCD7: '9291708',
  UCD13: '3400892917085',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE SDC ENF SIR125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3771198',
  CIP13: '3400937711982',
  ucdLib: "CARBOCISTEINE SDC S/S AD.200ML",
  UCD7: '9291714',
  UCD13: '3400892917146',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE SDC S/S AD.200ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3771212',
  CIP13: '3400937712125',
  ucdLib: "CARBOCISTEINE SDC S/S ENF125ML",
  UCD7: '9291720',
  UCD13: '3400892917207',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE SDC S/S ENF125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3792059',
  CIP13: '3400937920599',
  ucdLib: "CARBOCISTEINE TCO S/S ENF125ML",
  UCD7: '9303127',
  UCD13: '3400893031278',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE TCO S/S ENF125ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3923194',
  CIP13: '3400939231945',
  ucdLib: "CARBOCISTEINE EG S/S AD.200ML",
  UCD7: '9341702',
  UCD13: '3400893417027',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE EG S/S AD.200ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3751617',
  CIP13: '3400937516174',
  ucdLib: "CARBOCISTEINE TCO AD. SIR200ML",
  UCD7: '9376646',
  UCD13: '3400893766460',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE TCO AD. SIR200ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3751623',
  CIP13: '3400937516235',
  ucdLib: "CARBOCISTEINE TCO S/S AD.200ML",
  UCD7: '9368546',
  UCD13: '3400893685464',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE TCO S/S AD.200ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3939321',
  CIP13: '3400939393216',
  ucdLib: "HUMEX 5% AD.EXP.S/SUC BUV250ML",
  UCD7: '9339237',
  UCD13: '3400893392379',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMEX 5% AD.EXP.S/SUC BUV250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '4152037',
  CIP13: '3400941520372',
  ucdLib: "BRONCHOKOD AD. SIR FV250ML",
  UCD7: '9379892',
  UCD13: '3400893798928',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCHOKOD AD. SIR FV250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '4152043',
  CIP13: '3400941520433',
  ucdLib: "BRONCHOKOD S/SUC AD. BUV 250ML",
  UCD7: '9379900',
  UCD13: '3400893799000',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCHOKOD S/SUC AD. BUV 250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '2751058',
  CIP13: '3400927510588',
  ucdLib: "CARBOCISTEINE ZTC S/S AD.250ML",
  UCD7: '9398872',
  UCD13: '3400893988725',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE ZTC S/S AD.250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3999085',
  CIP13: '3400939990859',
  ucdLib: "BRONCHOKOD 750MG S/S C.VAN S",
  UCD7: '9374104',
  UCD13: '3400893741047',
  ucdQtyMultiplicator: 15,
  cipLib: "BRONCHOKOD 750MG S/S C.VAN S BT 15",
  atcCode: "R05CB03"
}, {
  CIP7: '3999151',
  CIP13: '3400939991511',
  ucdLib: "CLARIX EXP.CARB.750MG BUV S.",
  UCD7: '9355124',
  UCD13: '3400893551240',
  ucdQtyMultiplicator: 15,
  cipLib: "CLARIX EXP.CARB.750MG BUV S. BT 15",
  atcCode: "R05CB03"
}, {
  CIP7: '3999122',
  CIP13: '3400939991221',
  ucdLib: "HUMEX EXP.CARB.AD.S/SUC SACH",
  UCD7: '9358772',
  UCD13: '3400893587720',
  ucdQtyMultiplicator: 15,
  cipLib: "HUMEX EXP.CARB.AD.S/SUC SACH BT 15",
  atcCode: "R05CB03"
}, {
  CIP7: '2177665',
  CIP13: '3400921776652',
  ucdLib: "RHINATHIOL CARBO.5% SIR 250ML",
  UCD7: '9388388',
  UCD13: '3400893883884',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINATHIOL CARBO.5% SIR 250ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '4962871',
  CIP13: '3400949628711',
  ucdLib: "CARBOCISTEINE ARW S/S AD.200ML",
  UCD7: '9374044',
  UCD13: '3400893740446',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOCISTEINE ARW S/S AD.200ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3425421',
  CIP13: '3400934254215',
  ucdLib: "DRILL EXPEC S/S AD.BUV FV200ML",
  UCD7: '9195471',
  UCD13: '3400891954715',
  ucdQtyMultiplicator: 1,
  cipLib: "DRILL EXPEC S/S AD.BUV FV200ML BT 1",
  atcCode: "R05CB03"
}, {
  CIP7: '3736061',
  CIP13: '3400937360616',
  ucdLib: "BISOLVON 8MG CPR",
  UCD7: '9011703',
  UCD13: '3400890117036',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOLVON 8MG CPR BT 30",
  atcCode: "R05CB02"
}, {
  CIP7: '3237369',
  CIP13: '3400932373697',
  ucdLib: "FLUIMUCIL EXPEC 200MG S/S S.",
  UCD7: '9035514',
  UCD13: '3400890355148',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUIMUCIL EXPEC 200MG S/S S. BT 30",
  atcCode: "R05CB01"
}, {
  CIP7: '3406518',
  CIP13: '3400934065187',
  ucdLib: "MUCOMYST 200MG PDR SACH",
  UCD7: '9060110',
  UCD13: '3400890601108',
  ucdQtyMultiplicator: 18,
  cipLib: "MUCOMYST 200MG PDR SACH BT 18",
  atcCode: "R05CB01"
}, {
  CIP7: '3656391',
  CIP13: '3400936563919',
  ucdLib: "ACETYLCYSTEINE ARW 200 CPR",
  UCD7: '9267331',
  UCD13: '3400892673318',
  ucdQtyMultiplicator: 20,
  cipLib: "ACETYLCYSTEINE ARW 200 CPR BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '3539283',
  CIP13: '3400935392831',
  ucdLib: "FLUIMUCIL EXPEC AD.SS BUV200ML",
  UCD7: '9231103',
  UCD13: '3400892311036',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUIMUCIL EXPEC AD.SS BUV200ML BT 1",
  atcCode: "R05CB01"
}, {
  CIP7: '3531956',
  CIP13: '3400935319562',
  ucdLib: "FLUIMUCIL EXPEC EN.SS BUV100ML",
  UCD7: '9240622',
  UCD13: '3400892406220',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUIMUCIL EXPEC EN.SS BUV100ML BT 1",
  atcCode: "R05CB01"
}, {
  CIP7: '3691648',
  CIP13: '3400936916487',
  ucdLib: "ACETYLCYSTEINE TCO 200 SACH",
  UCD7: '9277884',
  UCD13: '3400892778846',
  ucdQtyMultiplicator: 20,
  cipLib: "ACETYLCYSTEINE TCO 200 SACH BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '3638513',
  CIP13: '3400936385139',
  ucdLib: "EXOMUC 200MG GLE BUV SACH",
  UCD7: '9034124',
  UCD13: '3400890341240',
  ucdQtyMultiplicator: 24,
  cipLib: "EXOMUC 200MG GLE BUV SACH BT 24",
  atcCode: "R05CB01"
}, {
  CIP7: '3821364',
  CIP13: '3400938213645',
  ucdLib: "ACETYLCYSTEINE BGC 200 CPR",
  UCD7: '9204046',
  UCD13: '3400892040462',
  ucdQtyMultiplicator: 20,
  cipLib: "ACETYLCYSTEINE BGC 200 CPR BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '3646323',
  CIP13: '3400936463233',
  ucdLib: "ACETYLCYSTEINE MYL 200 SACH",
  UCD7: '9266053',
  UCD13: '3400892660530',
  ucdQtyMultiplicator: 20,
  cipLib: "ACETYLCYSTEINE MYL 200 SACH BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '3785645',
  CIP13: '3400937856454',
  ucdLib: "ACETYLCYSTEINE SDC 200 SACH",
  UCD7: '9305020',
  UCD13: '3400893050200',
  ucdQtyMultiplicator: 20,
  cipLib: "ACETYLCYSTEINE SDC 200 SACH BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '3771643',
  CIP13: '3400937716437',
  ucdLib: "SOLMUCOL 200MG BUV GLE SACH",
  UCD7: '9136304',
  UCD13: '3400891363043',
  ucdQtyMultiplicator: 20,
  cipLib: "SOLMUCOL 200MG BUV GLE SACH BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '3756098',
  CIP13: '3400937560986',
  ucdLib: "ACETYLCYSTEINE EG 200 SACH",
  UCD7: '9294291',
  UCD13: '3400892942919',
  ucdQtyMultiplicator: 20,
  cipLib: "ACETYLCYSTEINE EG 200 SACH BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '3802639',
  CIP13: '3400938026399',
  ucdLib: "MUCOMYSTENDO INSTIL TRAC 5ML",
  UCD7: '9305907',
  UCD13: '3400893059074',
  ucdQtyMultiplicator: 6,
  cipLib: "MUCOMYSTENDO INSTIL TRAC 5ML BT 6",
  atcCode: "R05CB01"
}, {
  CIP7: '3506869',
  CIP13: '3400935068699',
  ucdLib: "FLUIMUCIL EXPEC 200MG AD. SS",
  UCD7: '9331158',
  UCD13: '3400893311585',
  ucdQtyMultiplicator: 18,
  cipLib: "FLUIMUCIL EXPEC 200MG AD. SS BT 18",
  atcCode: "R05CB01"
}, {
  CIP7: '4939429',
  CIP13: '3400949394296',
  ucdLib: "ACETYLCYSTEINE EGC 200 S/SUC",
  UCD7: '9360935',
  UCD13: '3400893609354',
  ucdQtyMultiplicator: 18,
  cipLib: "ACETYLCYSTEINE EGC 200 S/SUC BT 18",
  atcCode: "R05CB01"
}, {
  CIP7: '2669138',
  CIP13: '3400926691387',
  ucdLib: "ACETYLCYSTEINE TCO 200 S/S S",
  UCD7: '9391232',
  UCD13: '3400893912324',
  ucdQtyMultiplicator: 18,
  cipLib: "ACETYLCYSTEINE TCO 200 S/S S BT 18",
  atcCode: "R05CB01"
}, {
  CIP7: '4154094',
  CIP13: '3400941540943',
  ucdLib: "MUCOTHIOL 200MG CPR",
  UCD7: '9186242',
  UCD13: '3400891862423',
  ucdQtyMultiplicator: 20,
  cipLib: "MUCOTHIOL 200MG CPR BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '2782633',
  CIP13: '3400927826337',
  ucdLib: "MUCODRILL 600MG S/SUC C.EFFV",
  UCD7: '9420117',
  UCD13: '3400894201175',
  ucdQtyMultiplicator: 10,
  cipLib: "MUCODRILL 600MG S/SUC C.EFFV BT 10",
  atcCode: "R05CB01"
}, {
  CIP7: '3429790',
  CIP13: '3400934297908',
  ucdLib: "ACETYLCYSTEINE BGC 200 SACH",
  UCD7: '9196996',
  UCD13: '3400891969962',
  ucdQtyMultiplicator: 20,
  cipLib: "ACETYLCYSTEINE BGC 200 SACH BT 20",
  atcCode: "R05CB01"
}, {
  CIP7: '3421274',
  CIP13: '3400934212741',
  ucdLib: "PROSPAN S/SUC SIR FL100ML",
  UCD7: '9213602',
  UCD13: '3400892136028',
  ucdQtyMultiplicator: 1,
  cipLib: "PROSPAN S/SUC SIR FL100ML BT 1",
  atcCode: "R05CA12"
}, {
  CIP7: '3839654',
  CIP13: '3400938396546',
  ucdLib: "COQUELUSEDAL AD. SUP",
  UCD7: '9021877',
  UCD13: '3400890218771',
  ucdQtyMultiplicator: 10,
  cipLib: "COQUELUSEDAL AD. SUP BT 10",
  atcCode: "R05CA10"
}, {
  CIP7: '3839737',
  CIP13: '3400938397376',
  ucdLib: "COQUELUSEDAL ENF SUP",
  UCD7: '9021908',
  UCD13: '3400890219082',
  ucdQtyMultiplicator: 10,
  cipLib: "COQUELUSEDAL ENF SUP BT 10",
  atcCode: "R05CA10"
}, {
  CIP7: '3087852',
  CIP13: '3400930878521',
  ucdLib: "PULMOFLUIDE SIMP.BUV FL180ML",
  UCD7: '9076890',
  UCD13: '3400890768900',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMOFLUIDE SIMP.BUV FL180ML BT 1",
  atcCode: "R05CA10"
}, {
  CIP7: '3015806',
  CIP13: '3400930158067',
  ucdLib: "BRONCHODERMINE AD. SUP",
  UCD7: '9013518',
  UCD13: '3400890135184',
  ucdQtyMultiplicator: 10,
  cipLib: "BRONCHODERMINE AD. SUP BT 10",
  atcCode: "R05CA10"
}, {
  CIP7: '3015812',
  CIP13: '3400930158128',
  ucdLib: "BRONCHODERMINE ENF SUP",
  UCD7: '9013530',
  UCD13: '3400890135306',
  ucdQtyMultiplicator: 10,
  cipLib: "BRONCHODERMINE ENF SUP BT 10",
  atcCode: "R05CA10"
}, {
  CIP7: '3015798',
  CIP13: '3400930157985',
  ucdLib: "BRONCHODERMINE POM TB60G",
  UCD7: '9013501',
  UCD13: '3400890135016',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCHODERMINE POM TB60G BT 1",
  atcCode: "R05CA10"
}, {
  CIP7: '3015640',
  CIP13: '3400930156407',
  ucdLib: "BRONCHORECTINE AD. SUP",
  UCD7: '9013659',
  UCD13: '3400890136594',
  ucdQtyMultiplicator: 10,
  cipLib: "BRONCHORECTINE AD. SUP BT 10",
  atcCode: "R05CA10"
}, {
  CIP7: '3015657',
  CIP13: '3400930156575',
  ucdLib: "BRONCHORECTINE ENF SUP",
  UCD7: '9013665',
  UCD13: '3400890136655',
  ucdQtyMultiplicator: 10,
  cipLib: "BRONCHORECTINE ENF SUP BT 10",
  atcCode: "R05CA10"
}, {
  CIP7: '3259543',
  CIP13: '3400932595433',
  ucdLib: "NEO-CODION BB. SIR FL125ML",
  UCD7: '9061629',
  UCD13: '3400890616294',
  ucdQtyMultiplicator: 1,
  cipLib: "NEO-CODION BB. SIR FL125ML BT 1",
  atcCode: "R05CA10"
}, {
  CIP7: '3108809',
  CIP13: '3400931088097',
  ucdLib: "TROPHIRES ENF SUP",
  UCD7: '9095479',
  UCD13: '3400890954792',
  ucdQtyMultiplicator: 8,
  cipLib: "TROPHIRES ENF SUP BT 8",
  atcCode: "R05CA10"
}, {
  CIP7: '3756046',
  CIP13: '3400937560467',
  ucdLib: "COQUELUSEDAL BB. SUP",
  UCD7: '9021883',
  UCD13: '3400890218832',
  ucdQtyMultiplicator: 10,
  cipLib: "COQUELUSEDAL BB. SUP BT 10",
  atcCode: "R05CA10"
}, {
  CIP7: '3495663',
  CIP13: '3400934956638',
  ucdLib: "VICKS EXPEC AD. MIEL SIR 120ML",
  UCD7: '9214257',
  UCD13: '3400892142579',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS EXPEC AD. MIEL SIR 120ML BT 1",
  atcCode: "R05CA03"
}, {
  CIP7: '3495686',
  CIP13: '3400934956867',
  ucdLib: "VICKS EXPEC AD. MIEL SIR 180ML",
  UCD7: '9387029',
  UCD13: '3400893870297',
  ucdQtyMultiplicator: 1,
  cipLib: "VICKS EXPEC AD. MIEL SIR 180ML BT 1",
  atcCode: "R05CA03"
}, {
  CIP7: '3003835',
  CIP13: '3400930038352',
  ucdLib: "NUCALA 100MG INJ FL",
  UCD7: '9413850',
  UCD13: '3400894138501',
  ucdQtyMultiplicator: 1,
  cipLib: "NUCALA 100MG INJ FL BT 1",
  atcCode: "R03DX09"
}, {
  CIP7: '3921249',
  CIP13: '3400939212494',
  ucdLib: "XOLAIR 150MG INJ SRG1ML",
  UCD7: '9345456',
  UCD13: '3400893454565',
  ucdQtyMultiplicator: 1,
  cipLib: "XOLAIR 150MG INJ SRG1ML BT 1",
  atcCode: "R03DX05"
}, {
  CIP7: '3921226',
  CIP13: '3400939212265',
  ucdLib: "XOLAIR 75MG INJ SRG0,5ML",
  UCD7: '9345462',
  UCD13: '3400893454626',
  ucdQtyMultiplicator: 1,
  cipLib: "XOLAIR 75MG INJ SRG0,5ML BT 1",
  atcCode: "R03DX05"
}, {
  CIP7: '3192974',
  CIP13: '3400931929741',
  ucdLib: "PNEUMOREL 80MG CPR",
  UCD7: '9072952',
  UCD13: '3400890729529',
  ucdQtyMultiplicator: 30,
  cipLib: "PNEUMOREL 80MG CPR BT 30",
  atcCode: "R03DX03"
}, {
  CIP7: '3193011',
  CIP13: '3400931930112',
  ucdLib: "PNEUMOREL 80MG CPR",
  UCD7: '9072952',
  UCD13: '3400890729529',
  ucdQtyMultiplicator: 100,
  cipLib: "PNEUMOREL 80MG CPR BT 100",
  atcCode: "R03DX03"
}, {
  CIP7: '3137981',
  CIP13: '3400931379812',
  ucdLib: "PNEUMOREL 0,2% SIR FL150ML",
  UCD7: '9072900',
  UCD13: '3400890729000',
  ucdQtyMultiplicator: 1,
  cipLib: "PNEUMOREL 0,2% SIR FL150ML BT 1",
  atcCode: "R03DX03"
}, {
  CIP7: '3002244',
  CIP13: '3400930022443',
  ucdLib: "MONTELUKAST ARW 5MG CPR CROQ",
  UCD7: '9410656',
  UCD13: '3400894106562',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ARW 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3002232',
  CIP13: '3400930022320',
  ucdLib: "MONTELUKAST EVO 5MG CPR CROQ",
  UCD7: '9415056',
  UCD13: '3400894150565',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST EVO 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4988445',
  CIP13: '3400949884452',
  ucdLib: "MONTELUKAST KRK 4MG CPR CROQ",
  UCD7: '9370187',
  UCD13: '3400893701874',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST KRK 4MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4988623',
  CIP13: '3400949886234',
  ucdLib: "MONTELUKAST KRK 5MG CPR CROQ",
  UCD7: '9370193',
  UCD13: '3400893701935',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST KRK 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3554704',
  CIP13: '3400935547040',
  ucdLib: "MONTELUKAST BGA 10MG CPR",
  UCD7: '9352249',
  UCD13: '3400893522493',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST BGA 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3554584',
  CIP13: '3400935545848',
  ucdLib: "MONTELUKAST BGA 5MG CPR CROQ",
  UCD7: '9352255',
  UCD13: '3400893522554',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST BGA 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3461411',
  CIP13: '3400934614118',
  ucdLib: "SINGULAIR 10MG CPR PELL",
  UCD7: '9200775',
  UCD13: '3400892007755',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 10MG CPR PELL BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3461285',
  CIP13: '3400934612855',
  ucdLib: "SINGULAIR 5MG CPR CROQ",
  UCD7: '9200781',
  UCD13: '3400892007816',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '5611665',
  CIP13: '3400956116652',
  ucdLib: "SINGULAIR 10MG CPR PELL",
  UCD7: '9200775',
  UCD13: '3400892007755',
  ucdQtyMultiplicator: 50,
  cipLib: "SINGULAIR 10MG CPR PELL BT 50",
  atcCode: "R03DC03"
}, {
  CIP7: '5611659',
  CIP13: '3400956116591',
  ucdLib: "SINGULAIR 5MG CPR CROQ",
  UCD7: '9200781',
  UCD13: '3400892007816',
  ucdQtyMultiplicator: 50,
  cipLib: "SINGULAIR 5MG CPR CROQ BT 50",
  atcCode: "R03DC03"
}, {
  CIP7: '3893145',
  CIP13: '3400938931457',
  ucdLib: "MONTELUKAST SDZ 5MG CPR CROQ",
  UCD7: '9370218',
  UCD13: '3400893702185',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST SDZ 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3896209',
  CIP13: '3400938962093',
  ucdLib: "MONTELUKAST TVC 10MG CPR",
  UCD7: '9335883',
  UCD13: '3400893358832',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST TVC 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3896304',
  CIP13: '3400938963045',
  ucdLib: "MONTELUKAST TVC 5MG CPR CROQ",
  UCD7: '9335908',
  UCD13: '3400893359082',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST TVC 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3931124',
  CIP13: '3400939311241',
  ucdLib: "SINGULAIR 4MG CPR CROQ",
  UCD7: '9345918',
  UCD13: '3400893459188',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 4MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '3931236',
  CIP13: '3400939312361',
  ucdLib: "SINGULAIR 4MG GLE SACH DOS",
  UCD7: '9345924',
  UCD13: '3400893459249',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 4MG GLE SACH DOS BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2699725',
  CIP13: '3400926997250',
  ucdLib: "MONTELUKAST AHL 10MG CPR",
  UCD7: '9394710',
  UCD13: '3400893947104',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST AHL 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4999868',
  CIP13: '3400949998685',
  ucdLib: "MONTELUKAST EG 10MG CPR",
  UCD7: '9389100',
  UCD13: '3400893891001',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST EG 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4999182',
  CIP13: '3400949991822',
  ucdLib: "MONTELUKAST EG 5MG CPR CROQ",
  UCD7: '9389117',
  UCD13: '3400893891179',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST EG 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4947920',
  CIP13: '3400949479207',
  ucdLib: "MONTELUKAST KRK 10MG CPR",
  UCD7: '9370170',
  UCD13: '3400893701706',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST KRK 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2662260',
  CIP13: '3400926622602',
  ucdLib: "MONTELUKAST ZTL 10MG CPR",
  UCD7: '9389459',
  UCD13: '3400893894590',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ZTL 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2662024',
  CIP13: '3400926620240',
  ucdLib: "MONTELUKAST ZTL 4MG GLE SACH",
  UCD7: '9389465',
  UCD13: '3400893894651',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ZTL 4MG GLE SACH BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2662107',
  CIP13: '3400926621070',
  ucdLib: "MONTELUKAST ZTL 5MG CPR CROQ",
  UCD7: '9389471',
  UCD13: '3400893894712',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ZTL 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4997869',
  CIP13: '3400949978694',
  ucdLib: "MONTELUKAST ZYD 10MG CPR",
  UCD7: '9370224',
  UCD13: '3400893702246',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ZYD 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4150736',
  CIP13: '3400941507366',
  ucdLib: "MONTELUKAST ZYD 5MG CPR CROQ",
  UCD7: '9370247',
  UCD13: '3400893702475',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ZYD 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4902834',
  CIP13: '3400949028344',
  ucdLib: "SINGULAIR 10MG CPR AIPBBA PL",
  UCD7: '9406502',
  UCD13: '3400894065029',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 10MG CPR AIPBBA PL BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4902716',
  CIP13: '3400949027163',
  ucdLib: "SINGULAIR 10MG CPR AIPITT PL",
  UCD7: '9406057',
  UCD13: '3400894060574',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 10MG CPR AIPITT PL BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4900034',
  CIP13: '3400949000340',
  ucdLib: "SINGULAIR 10MG CPR AIPMWI PL",
  UCD7: '9411880',
  UCD13: '3400894118800',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 10MG CPR AIPMWI PL BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4902840',
  CIP13: '3400949028405',
  ucdLib: "SINGULAIR 4MG CPR AIP BBA PL",
  UCD7: '9409883',
  UCD13: '3400894098836',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 4MG CPR AIP BBA PL BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4902811',
  CIP13: '3400949028115',
  ucdLib: "SINGULAIR 5MG CPR AIP BBA PL",
  UCD7: '9406519',
  UCD13: '3400894065197',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 5MG CPR AIP BBA PL BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4902544',
  CIP13: '3400949025442',
  ucdLib: "SINGULAIR 5MG CPR AIP ITT PL",
  UCD7: '9403047',
  UCD13: '3400894030478',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 5MG CPR AIP ITT PL BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4900033',
  CIP13: '3400949000333',
  ucdLib: "SINGULAIR 5MG CPR AIP MWI PL",
  UCD7: '9411897',
  UCD13: '3400894118978',
  ucdQtyMultiplicator: 28,
  cipLib: "SINGULAIR 5MG CPR AIP MWI PL BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2241802',
  CIP13: '3400922418025',
  ucdLib: "MONTELUKAST ACT 10MG CPR",
  UCD7: '9389413',
  UCD13: '3400893894132',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ACT 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2240949',
  CIP13: '3400922409498',
  ucdLib: "MONTELUKAST ALM 10MG CPR",
  UCD7: '9405388',
  UCD13: '3400894053880',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ALM 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2178908',
  CIP13: '3400921789089',
  ucdLib: "MONTELUKAST ALT 10MG CPR",
  UCD7: '9389092',
  UCD13: '3400893890929',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ALT 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2179500',
  CIP13: '3400921795004',
  ucdLib: "MONTELUKAST ARW 10MG CPR",
  UCD7: '9390735',
  UCD13: '3400893907351',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ARW 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2783650',
  CIP13: '3400927836503',
  ucdLib: "MONTELUKAST ARW 4MG GLE SACH",
  UCD7: '9415033',
  UCD13: '3400894150336',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST ARW 4MG GLE SACH BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4163650',
  CIP13: '3400941636509',
  ucdLib: "MONTELUKAST CRT 10MG CPR",
  UCD7: '9376095',
  UCD13: '3400893760956',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST CRT 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4163532',
  CIP13: '3400941635328',
  ucdLib: "MONTELUKAST CRT 5MG CPR CROQ",
  UCD7: '9373228',
  UCD13: '3400893732281',
  ucdQtyMultiplicator: 30,
  cipLib: "MONTELUKAST CRT 5MG CPR CROQ BT 30",
  atcCode: "R03DC03"
}, {
  CIP7: '2241920',
  CIP13: '3400922419206',
  ucdLib: "MONTELUKAST EVO 10MG CPR",
  UCD7: '9388187',
  UCD13: '3400893881873',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST EVO 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4161527',
  CIP13: '3400941615276',
  ucdLib: "MONTELUKAST MYL 5MG CPR CROQ",
  UCD7: '9373240',
  UCD13: '3400893732403',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST MYL 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2160050',
  CIP13: '3400921600506',
  ucdLib: "MONTELUKAST PHR 5MG CPR CROQ",
  UCD7: '9390830',
  UCD13: '3400893908303',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST PHR 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2206094',
  CIP13: '3400922060941',
  ucdLib: "MONTELUKAST RBX 10MG CPR",
  UCD7: '9389436',
  UCD13: '3400893894361',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST RBX 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2206131',
  CIP13: '3400922061313',
  ucdLib: "MONTELUKAST RBX 5MG CPR CROQ",
  UCD7: '9389442',
  UCD13: '3400893894422',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST RBX 5MG CPR CROQ BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4925568',
  CIP13: '3400949255689',
  ucdLib: "MONTELUKAST SDZ 10MG CPR",
  UCD7: '9359493',
  UCD13: '3400893594933',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST SDZ 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '2186109',
  CIP13: '3400921861099',
  ucdLib: "MONTELUKAST TVC 4MG GLE SACH",
  UCD7: '9390623',
  UCD13: '3400893906231',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST TVC 4MG GLE SACH BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '4966923',
  CIP13: '3400949669233',
  ucdLib: "MONTELUKAST MYL 10MG CPR",
  UCD7: '9367096',
  UCD13: '3400893670965',
  ucdQtyMultiplicator: 28,
  cipLib: "MONTELUKAST MYL 10MG CPR BT 28",
  atcCode: "R03DC03"
}, {
  CIP7: '5653913',
  CIP13: '3400956539130',
  ucdLib: "AMINOPHYLLINE REN 250MG A.B",
  UCD7: '9262032',
  UCD13: '3400892620329',
  ucdQtyMultiplicator: 100,
  cipLib: "AMINOPHYLLINE REN 250MG A.B BT 100",
  atcCode: "R03DA05"
}, {
  CIP7: '3280141',
  CIP13: '3400932801411',
  ucdLib: "EUPHYLLINE L.A 200MG GELU",
  UCD7: '9116810',
  UCD13: '3400891168105',
  ucdQtyMultiplicator: 30,
  cipLib: "EUPHYLLINE L.A 200MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3282186',
  CIP13: '3400932821860',
  ucdLib: "EUPHYLLINE L.A 400MG GELU",
  UCD7: '9134216',
  UCD13: '3400891342161',
  ucdQtyMultiplicator: 30,
  cipLib: "EUPHYLLINE L.A 400MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3031780',
  CIP13: '3400930317808',
  ucdLib: "DILATRANE 1% SIR FP200ML",
  UCD7: '9027236',
  UCD13: '3400890272360',
  ucdQtyMultiplicator: 1,
  cipLib: "DILATRANE 1% SIR FP200ML BT 1",
  atcCode: "R03DA04"
}, {
  CIP7: '3031774',
  CIP13: '3400930317747',
  ucdLib: "DILATRANE 100MG GELU",
  UCD7: '9027259',
  UCD13: '3400890272599',
  ucdQtyMultiplicator: 30,
  cipLib: "DILATRANE 100MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3031768',
  CIP13: '3400930317686',
  ucdLib: "DILATRANE 200MG GELU",
  UCD7: '9027265',
  UCD13: '3400890272650',
  ucdQtyMultiplicator: 30,
  cipLib: "DILATRANE 200MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3278799',
  CIP13: '3400932787999',
  ucdLib: "DILATRANE 300MG GELU",
  UCD7: '9104468',
  UCD13: '3400891044683',
  ucdQtyMultiplicator: 30,
  cipLib: "DILATRANE 300MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3278782',
  CIP13: '3400932787821',
  ucdLib: "DILATRANE 50MG GELU",
  UCD7: '9104474',
  UCD13: '3400891044744',
  ucdQtyMultiplicator: 30,
  cipLib: "DILATRANE 50MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3278753',
  CIP13: '3400932787531',
  ucdLib: "THEOSTAT LP 200MG CPR",
  UCD7: '9143623',
  UCD13: '3400891436235',
  ucdQtyMultiplicator: 30,
  cipLib: "THEOSTAT LP 200MG CPR BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3273141',
  CIP13: '3400932731411',
  ucdLib: "THEOSTAT LP 300MG CPR",
  UCD7: '9103782',
  UCD13: '3400891037821',
  ucdQtyMultiplicator: 30,
  cipLib: "THEOSTAT LP 300MG CPR BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3250163',
  CIP13: '3400932501632',
  ucdLib: "EUPHYLLINE L.A 100MG GELU",
  UCD7: '9033691',
  UCD13: '3400890336918',
  ucdQtyMultiplicator: 30,
  cipLib: "EUPHYLLINE L.A 100MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3250186',
  CIP13: '3400932501861',
  ucdLib: "EUPHYLLINE L.A 300MG GELU",
  UCD7: '9033716',
  UCD13: '3400890337168',
  ucdQtyMultiplicator: 30,
  cipLib: "EUPHYLLINE L.A 300MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3103539',
  CIP13: '3400931035398',
  ucdLib: "TEDRALAN 200MG GELU",
  UCD7: '9090683',
  UCD13: '3400890906838',
  ucdQtyMultiplicator: 30,
  cipLib: "TEDRALAN 200MG GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3269151',
  CIP13: '3400932691517',
  ucdLib: "THEOSTAT LP 100MG CPR",
  UCD7: '9103776',
  UCD13: '3400891037760',
  ucdQtyMultiplicator: 30,
  cipLib: "THEOSTAT LP 100MG CPR BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3315359',
  CIP13: '3400933153595',
  ucdLib: "XANTHIUM 200MG LP GELU",
  UCD7: '9143586',
  UCD13: '3400891435863',
  ucdQtyMultiplicator: 30,
  cipLib: "XANTHIUM 200MG LP GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3315371',
  CIP13: '3400933153717',
  ucdLib: "XANTHIUM 400MG LP GELU",
  UCD7: '9143592',
  UCD13: '3400891435924',
  ucdQtyMultiplicator: 30,
  cipLib: "XANTHIUM 400MG LP GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3362844',
  CIP13: '3400933628444',
  ucdLib: "XANTHIUM 300MG LP GELU",
  UCD7: '9177757',
  UCD13: '3400891777574',
  ucdQtyMultiplicator: 30,
  cipLib: "XANTHIUM 300MG LP GELU BT 30",
  atcCode: "R03DA04"
}, {
  CIP7: '3371375',
  CIP13: '3400933713751',
  ucdLib: "OXEOL 10MG CPR",
  UCD7: '9171482',
  UCD13: '3400891714821',
  ucdQtyMultiplicator: 30,
  cipLib: "OXEOL 10MG CPR BT 30",
  atcCode: "R03CC12"
}, {
  CIP7: '3371369',
  CIP13: '3400933713690',
  ucdLib: "OXEOL 20MG CPR",
  UCD7: '9208564',
  UCD13: '3400892085647',
  ucdQtyMultiplicator: 30,
  cipLib: "OXEOL 20MG CPR BT 30",
  atcCode: "R03CC12"
}, {
  CIP7: '3921574',
  CIP13: '3400939215747',
  ucdLib: "BRICANYL 0,5MG INJ AMP1ML",
  UCD7: '9013091',
  UCD13: '3400890130912',
  ucdQtyMultiplicator: 10,
  cipLib: "BRICANYL 0,5MG INJ AMP1ML BT 10",
  atcCode: "R03CC03"
}, {
  CIP7: '2662892',
  CIP13: '3400926628925',
  ucdLib: "BRICANYL LP 5MG CPR",
  UCD7: '9141268',
  UCD13: '3400891412680',
  ucdQtyMultiplicator: 60,
  cipLib: "BRICANYL LP 5MG CPR BT 60",
  atcCode: "R03CC03"
}, {
  CIP7: '3299293',
  CIP13: '3400932992935',
  ucdLib: "VENTOLINE 0,5MG/1ML INJ AMP",
  UCD7: '9124117',
  UCD13: '3400891241174',
  ucdQtyMultiplicator: 6,
  cipLib: "VENTOLINE 0,5MG/1ML INJ AMP BT 6",
  atcCode: "R03CC02"
}, {
  CIP7: '3809239',
  CIP13: '3400938092394',
  ucdLib: "SALBUMOL FORT 5MG INJ A.5ML",
  UCD7: '9130477',
  UCD13: '3400891304770',
  ucdQtyMultiplicator: 5,
  cipLib: "SALBUMOL FORT 5MG INJ A.5ML BT 5",
  atcCode: "R03CC02"
}, {
  CIP7: '5638345',
  CIP13: '3400956383450',
  ucdLib: "SALBUTAMOL MYL 5MG/5ML INJ A",
  UCD7: '9239429',
  UCD13: '3400892394299',
  ucdQtyMultiplicator: 10,
  cipLib: "SALBUTAMOL MYL 5MG/5ML INJ A BT 10",
  atcCode: "R03CC02"
}, {
  CIP7: '5702646',
  CIP13: '3400957026462',
  ucdLib: "SALBUTAMOL REN 5MG/5ML INJ A",
  UCD7: '9298952',
  UCD13: '3400892989525',
  ucdQtyMultiplicator: 10,
  cipLib: "SALBUTAMOL REN 5MG/5ML INJ A BT 10",
  atcCode: "R03CC02"
}, {
  CIP7: '3241193',
  CIP13: '3400932411931',
  ucdLib: "LOMUDAL NEBUL SOL AMP2ML",
  UCD7: '9055008',
  UCD13: '3400890550086',
  ucdQtyMultiplicator: 48,
  cipLib: "LOMUDAL NEBUL SOL AMP2ML BT 48",
  atcCode: "R03BC01"
}, {
  CIP7: '3000464',
  CIP13: '3400930004647',
  ucdLib: "INCRUSE 55MCG INHAL UNIDOS",
  UCD7: '9415895',
  UCD13: '3400894158950',
  ucdQtyMultiplicator: 30,
  cipLib: "INCRUSE 55MCG INHAL UNIDOS BT 30",
  atcCode: "R03BB07"
}, {
  CIP7: '3002102',
  CIP13: '3400930021026',
  ucdLib: "SEEBRI BREEZ.44MCG GELU +INH",
  UCD7: '9399854',
  UCD13: '3400893998540',
  ucdQtyMultiplicator: 10,
  cipLib: "SEEBRI BREEZ.44MCG GELU +INH BT 10",
  atcCode: "R03BB06"
}, {
  CIP7: '2675498',
  CIP13: '3400926754983',
  ucdLib: "SEEBRI BREEZ.44MCG GELU +INH",
  UCD7: '9399854',
  UCD13: '3400893998540',
  ucdQtyMultiplicator: 30,
  cipLib: "SEEBRI BREEZ.44MCG GELU +INH BT 30",
  atcCode: "R03BB06"
}, {
  CIP7: '3686920',
  CIP13: '3400936869202',
  ucdLib: "SPIRIVA 18MCG GELU INH +DISP",
  UCD7: '9278027',
  UCD13: '3400892780276',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRIVA 18MCG GELU INH +DISP BT 30",
  atcCode: "R03BB04"
}, {
  CIP7: '3819203',
  CIP13: '3400938192032',
  ucdLib: "SPIRIVA RESPIMAT 2,5Y CART+I.",
  UCD7: '9348294',
  UCD13: '3400893482940',
  ucdQtyMultiplicator: 1,
  cipLib: "SPIRIVA RESPIMAT 2,5Y CART+I. BT 1",
  atcCode: "R03BB04"
}, {
  CIP7: '5707626',
  CIP13: '3400957076269',
  ucdLib: "SPIRIVA 18MCG GELU INH +DISP",
  UCD7: '9278027',
  UCD13: '3400892780276',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRIVA 18MCG GELU INH +DISP BT 10",
  atcCode: "R03BB04"
}, {
  CIP7: '3001763',
  CIP13: '3400930017630',
  ucdLib: "IPRATROPIUM CRT 0,50MG/2ML D",
  UCD7: '9410231',
  UCD13: '3400894102311',
  ucdQtyMultiplicator: 10,
  cipLib: "IPRATROPIUM CRT 0,50MG/2ML D BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '4912956',
  CIP13: '3400949129560',
  ucdLib: "IPRATROPIUM ALM 0,5MG/2ML D.",
  UCD7: '9354343',
  UCD13: '3400893543436',
  ucdQtyMultiplicator: 10,
  cipLib: "IPRATROPIUM ALM 0,5MG/2ML D. BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '3607978',
  CIP13: '3400936079786',
  ucdLib: "ATROVENT 20MCG INHAL FL200DOS",
  UCD7: '9307208',
  UCD13: '3400893072080',
  ucdQtyMultiplicator: 1,
  cipLib: "ATROVENT 20MCG INHAL FL200DOS BT 1",
  atcCode: "R03BB01"
}, {
  CIP7: '3671539',
  CIP13: '3400936715394',
  ucdLib: "IPRATROPIUM ARW 0,25MG/ML D.",
  UCD7: '9281489',
  UCD13: '3400892814896',
  ucdQtyMultiplicator: 30,
  cipLib: "IPRATROPIUM ARW 0,25MG/ML D. BT 30",
  atcCode: "R03BB01"
}, {
  CIP7: '3658094',
  CIP13: '3400936580947',
  ucdLib: "ATROVENT AD. 0,50MG/1ML DOS",
  UCD7: '9244117',
  UCD13: '3400892441177',
  ucdQtyMultiplicator: 30,
  cipLib: "ATROVENT AD. 0,50MG/1ML DOS BT 30",
  atcCode: "R03BB01"
}, {
  CIP7: '3657309',
  CIP13: '3400936573093',
  ucdLib: "ATROVENT AD. 0,50MG/2ML DOS",
  UCD7: '9158079',
  UCD13: '3400891580792',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROVENT AD. 0,50MG/2ML DOS BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '3658131',
  CIP13: '3400936581319',
  ucdLib: "ATROVENT ENF 0,25MG/1ML DOS",
  UCD7: '9244100',
  UCD13: '3400892441009',
  ucdQtyMultiplicator: 30,
  cipLib: "ATROVENT ENF 0,25MG/1ML DOS BT 30",
  atcCode: "R03BB01"
}, {
  CIP7: '3657315',
  CIP13: '3400936573154',
  ucdLib: "ATROVENT ENF 0,25MG/2ML DOS",
  UCD7: '9158085',
  UCD13: '3400891580853',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROVENT ENF 0,25MG/2ML DOS BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '3658177',
  CIP13: '3400936581777',
  ucdLib: "IPRATROPIUM AGT 0,5MG/2ML D.",
  UCD7: '9242874',
  UCD13: '3400892428741',
  ucdQtyMultiplicator: 10,
  cipLib: "IPRATROPIUM AGT 0,5MG/2ML D. BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '3657841',
  CIP13: '3400936578418',
  ucdLib: "IPRATROPIUM ARW 0,5MG/2ML D.",
  UCD7: '9248428',
  UCD13: '3400892484280',
  ucdQtyMultiplicator: 10,
  cipLib: "IPRATROPIUM ARW 0,5MG/2ML D. BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '3658059',
  CIP13: '3400936580596',
  ucdLib: "IPRATROPIUM MYL 0,25MG/ML D.",
  UCD7: '9262339',
  UCD13: '3400892623399',
  ucdQtyMultiplicator: 10,
  cipLib: "IPRATROPIUM MYL 0,25MG/ML D. BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '3658036',
  CIP13: '3400936580367',
  ucdLib: "IPRATROPIUM MYL 0,5MG/2ML D.",
  UCD7: '9247788',
  UCD13: '3400892477886',
  ucdQtyMultiplicator: 10,
  cipLib: "IPRATROPIUM MYL 0,5MG/2ML D. BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '3894009',
  CIP13: '3400938940091',
  ucdLib: "IPRATROPIUM TVC 0,25MG/1ML D",
  UCD7: '9315857',
  UCD13: '3400893158579',
  ucdQtyMultiplicator: 30,
  cipLib: "IPRATROPIUM TVC 0,25MG/1ML D BT 30",
  atcCode: "R03BB01"
}, {
  CIP7: '3894067',
  CIP13: '3400938940671',
  ucdLib: "IPRATROPIUM TVC 0,5MG/2ML D.",
  UCD7: '9315863',
  UCD13: '3400893158630',
  ucdQtyMultiplicator: 10,
  cipLib: "IPRATROPIUM TVC 0,5MG/2ML D. BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '2791448',
  CIP13: '3400927914485',
  ucdLib: "IPRATROPIUM SDZ 0,25MG/1ML D",
  UCD7: '9404495',
  UCD13: '3400894044956',
  ucdQtyMultiplicator: 30,
  cipLib: "IPRATROPIUM SDZ 0,25MG/1ML D BT 30",
  atcCode: "R03BB01"
}, {
  CIP7: '2791371',
  CIP13: '3400927913716',
  ucdLib: "IPRATROPIUM SDZ 0,50MG/2ML D",
  UCD7: '9404503',
  UCD13: '3400894045038',
  ucdQtyMultiplicator: 10,
  cipLib: "IPRATROPIUM SDZ 0,50MG/2ML D BT 10",
  atcCode: "R03BB01"
}, {
  CIP7: '3900299',
  CIP13: '3400939002996',
  ucdLib: "ALVESCO 160MCG/DOS INH FL60DOS",
  UCD7: '9387437',
  UCD13: '3400893874370',
  ucdQtyMultiplicator: 1,
  cipLib: "ALVESCO 160MCG/DOS INH FL60DOS BT 1",
  atcCode: "R03BA08"
}, {
  CIP7: '3900253',
  CIP13: '3400939002538',
  ucdLib: "ALVESCO 80MCG/DOS INH FL60DOS",
  UCD7: '9387443',
  UCD13: '3400893874431',
  ucdQtyMultiplicator: 1,
  cipLib: "ALVESCO 80MCG/DOS INH FL60DOS BT 1",
  atcCode: "R03BA08"
}, {
  CIP7: '3592432',
  CIP13: '3400935924322',
  ucdLib: "ASMANEX TWISTHALER 200Y 30DOS",
  UCD7: '9383534',
  UCD13: '3400893835340',
  ucdQtyMultiplicator: 1,
  cipLib: "ASMANEX TWISTHALER 200Y 30DOS BT 1",
  atcCode: "R03BA07"
}, {
  CIP7: '3592449',
  CIP13: '3400935924490',
  ucdLib: "ASMANEX TWISTHALER 200Y 60DOS",
  UCD7: '9383540',
  UCD13: '3400893835401',
  ucdQtyMultiplicator: 1,
  cipLib: "ASMANEX TWISTHALER 200Y 60DOS BT 1",
  atcCode: "R03BA07"
}, {
  CIP7: '3592455',
  CIP13: '3400935924551',
  ucdLib: "ASMANEX TWISTHALER 400Y 30DOS",
  UCD7: '9383557',
  UCD13: '3400893835579',
  ucdQtyMultiplicator: 1,
  cipLib: "ASMANEX TWISTHALER 400Y 30DOS BT 1",
  atcCode: "R03BA07"
}, {
  CIP7: '3592461',
  CIP13: '3400935924612',
  ucdLib: "ASMANEX TWISTHALER 400Y 60DOS",
  UCD7: '9383563',
  UCD13: '3400893835630',
  ucdQtyMultiplicator: 1,
  cipLib: "ASMANEX TWISTHALER 400Y 60DOS BT 1",
  atcCode: "R03BA07"
}, {
  CIP7: '3367066',
  CIP13: '3400933670665',
  ucdLib: "FLIXOTIDE 125MCG BUC FL120DOS",
  UCD7: '9211661',
  UCD13: '3400892116617',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXOTIDE 125MCG BUC FL120DOS BT 1",
  atcCode: "R03BA05"
}, {
  CIP7: '3367089',
  CIP13: '3400933670894',
  ucdLib: "FLIXOTIDE 250MCG BUC FL120DOS",
  UCD7: '9192426',
  UCD13: '3400891924268',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXOTIDE 250MCG BUC FL120DOS BT 1",
  atcCode: "R03BA05"
}, {
  CIP7: '3367037',
  CIP13: '3400933670375',
  ucdLib: "FLIXOTIDE 50MCG BUC FL120DOS",
  UCD7: '9229431',
  UCD13: '3400892294315',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXOTIDE 50MCG BUC FL120DOS BT 1",
  atcCode: "R03BA05"
}, {
  CIP7: '3393307',
  CIP13: '3400933933074',
  ucdLib: "FLIXOTIDE DISKUS 100MCG PDR60D",
  UCD7: '9229425',
  UCD13: '3400892294254',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXOTIDE DISKUS 100MCG PDR60D BT 1",
  atcCode: "R03BA05"
}, {
  CIP7: '3393336',
  CIP13: '3400933933364',
  ucdLib: "FLIXOTIDE DISKUS 250MCG PDR60D",
  UCD7: '9211655',
  UCD13: '3400892116556',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXOTIDE DISKUS 250MCG PDR60D BT 1",
  atcCode: "R03BA05"
}, {
  CIP7: '3393632',
  CIP13: '3400933936327',
  ucdLib: "FLIXOTIDE DISKUS 500MCG PDR60D",
  UCD7: '9192403',
  UCD13: '3400891924039',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXOTIDE DISKUS 500MCG PDR60D BT 1",
  atcCode: "R03BA05"
}, {
  CIP7: '3332754',
  CIP13: '3400933327545',
  ucdLib: "PULMICORT TURB 200Y FL200DOS",
  UCD7: '9152421',
  UCD13: '3400891524215',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMICORT TURB 200Y FL200DOS BT 1",
  atcCode: "R03BA02"
}, {
  CIP7: '3372713',
  CIP13: '3400933727130',
  ucdLib: "PULMICORT 0,50MG INH DOS2ML",
  UCD7: '9172062',
  UCD13: '3400891720624',
  ucdQtyMultiplicator: 20,
  cipLib: "PULMICORT 0,50MG INH DOS2ML BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3373569',
  CIP13: '3400933735692',
  ucdLib: "PULMICORT 1MG INH DOS2ML",
  UCD7: '9172079',
  UCD13: '3400891720792',
  ucdQtyMultiplicator: 20,
  cipLib: "PULMICORT 1MG INH DOS2ML BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3374787',
  CIP13: '3400933747879',
  ucdLib: "PULMICORT TURB 400Y FL100DOS",
  UCD7: '9173357',
  UCD13: '3400891733570',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMICORT TURB 400Y FL100DOS BT 1",
  atcCode: "R03BA02"
}, {
  CIP7: '3672266',
  CIP13: '3400936722668',
  ucdLib: "BUDESONIDE BGA 0,5MG/2ML DOS",
  UCD7: '9270959',
  UCD13: '3400892709598',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE BGA 0,5MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3672326',
  CIP13: '3400936723269',
  ucdLib: "BUDESONIDE BGA 1MG/2ML DOS",
  UCD7: '9270965',
  UCD13: '3400892709659',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE BGA 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3672378',
  CIP13: '3400936723788',
  ucdLib: "BUDESONIDE EG 0,5MG/2ML DOS",
  UCD7: '9319967',
  UCD13: '3400893199671',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE EG 0,5MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3672421',
  CIP13: '3400936724211',
  ucdLib: "BUDESONIDE EG 1MG/2ML DOS",
  UCD7: '9319973',
  UCD13: '3400893199732',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE EG 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '4989203',
  CIP13: '3400949892037',
  ucdLib: "BUDESONIDE ISD 1MG/2ML DOS",
  UCD7: '9365393',
  UCD13: '3400893653937',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE ISD 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3672148',
  CIP13: '3400936721487',
  ucdLib: "BUDESONIDE SDZ 0,5MG/2ML DOS",
  UCD7: '9271172',
  UCD13: '3400892711720',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE SDZ 0,5MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3672208',
  CIP13: '3400936722088',
  ucdLib: "BUDESONIDE SDZ 1MG/2ML DOS",
  UCD7: '9270971',
  UCD13: '3400892709710',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE SDZ 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3364961',
  CIP13: '3400933649616',
  ucdLib: "PULMICORT TURB 100Y FL200DOS",
  UCD7: '9173340',
  UCD13: '3400891733402',
  ucdQtyMultiplicator: 1,
  cipLib: "PULMICORT TURB 100Y FL200DOS BT 1",
  atcCode: "R03BA02"
}, {
  CIP7: '3624066',
  CIP13: '3400936240667',
  ucdLib: "BUDESONIDE ARW 0,5MG/2ML DOS",
  UCD7: '9256712',
  UCD13: '3400892567129',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE ARW 0,5MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3626326',
  CIP13: '3400936263260',
  ucdLib: "BUDESONIDE ARW 1MG/2ML DOS",
  UCD7: '9256729',
  UCD13: '3400892567297',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE ARW 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3629388',
  CIP13: '3400936293885',
  ucdLib: "NOVOPULMON NOVOL.200Y 200D.+I",
  UCD7: '9262368',
  UCD13: '3400892623689',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOPULMON NOVOL.200Y 200D.+I BT 1",
  atcCode: "R03BA02"
}, {
  CIP7: '3629402',
  CIP13: '3400936294028',
  ucdLib: "NOVOPULMON NOVOLIZ.200Y 200D.",
  UCD7: '9262351',
  UCD13: '3400892623511',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOPULMON NOVOLIZ.200Y 200D. BT 1",
  atcCode: "R03BA02"
}, {
  CIP7: '3585604',
  CIP13: '3400935856043',
  ucdLib: "MIFLONIL 200MCG GELU +INH.",
  UCD7: '9258266',
  UCD13: '3400892582665',
  ucdQtyMultiplicator: 60,
  cipLib: "MIFLONIL 200MCG GELU +INH. BT 60",
  atcCode: "R03BA02"
}, {
  CIP7: '3585633',
  CIP13: '3400935856333',
  ucdLib: "MIFLONIL 400MCG GELU +INH.",
  UCD7: '9258272',
  UCD13: '3400892582726',
  ucdQtyMultiplicator: 60,
  cipLib: "MIFLONIL 400MCG GELU +INH. BT 60",
  atcCode: "R03BA02"
}, {
  CIP7: '3698449',
  CIP13: '3400936984493',
  ucdLib: "ACORSPRAY 200MCG/DOS FL200DOS",
  UCD7: '9414720',
  UCD13: '3400894147206',
  ucdQtyMultiplicator: 1,
  cipLib: "ACORSPRAY 200MCG/DOS FL200DOS BT 1",
  atcCode: "R03BA02"
}, {
  CIP7: '3698461',
  CIP13: '3400936984615',
  ucdLib: "NOVOPULMON NOVOL.400Y 100D. +I",
  UCD7: '9286386',
  UCD13: '3400892863863',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOPULMON NOVOL.400Y 100D. +I BT 1",
  atcCode: "R03BA02"
}, {
  CIP7: '3698478',
  CIP13: '3400936984783',
  ucdLib: "NOVOPULMON NOVOL.400Y 100D. +I",
  UCD7: '9286386',
  UCD13: '3400892863863',
  ucdQtyMultiplicator: 2,
  cipLib: "NOVOPULMON NOVOL.400Y 100D. +I BT 2",
  atcCode: "R03BA02"
}, {
  CIP7: '3698490',
  CIP13: '3400936984905',
  ucdLib: "NOVOPULMON NOVOLIZ.400Y 100D.",
  UCD7: '9286363',
  UCD13: '3400892863634',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOPULMON NOVOLIZ.400Y 100D. BT 1",
  atcCode: "R03BA02"
}, {
  CIP7: '3865700',
  CIP13: '3400938657005',
  ucdLib: "BUDESONIDE TVC 0,5MG/2ML DOS",
  UCD7: '9270988',
  UCD13: '3400892709888',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE TVC 0,5MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3865829',
  CIP13: '3400938658293',
  ucdLib: "BUDESONIDE TVC 1MG/2ML DOS",
  UCD7: '9270994',
  UCD13: '3400892709949',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE TVC 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '4949971',
  CIP13: '3400949499717',
  ucdLib: "BUDESONIDE CRT 0,5MG/2ML DOS",
  UCD7: '9362791',
  UCD13: '3400893627914',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE CRT 0,5MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '2225832',
  CIP13: '3400922258324',
  ucdLib: "BUDESONIDE EVO 0,5MG/2ML DOS",
  UCD7: '9398903',
  UCD13: '3400893989036',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE EVO 0,5MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '2225849',
  CIP13: '3400922258492',
  ucdLib: "BUDESONIDE EVO 1MG/2ML DOS",
  UCD7: '9398926',
  UCD13: '3400893989265',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE EVO 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '2209282',
  CIP13: '3400922092829',
  ucdLib: "BUDESONIDE MYL 0,5MG/2ML DOS",
  UCD7: '9385154',
  UCD13: '3400893851548',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE MYL 0,5MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '2209299',
  CIP13: '3400922092997',
  ucdLib: "BUDESONIDE MYL 1MG/2ML DOS",
  UCD7: '9385160',
  UCD13: '3400893851609',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE MYL 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '4960091',
  CIP13: '3400949600915',
  ucdLib: "BUDESONIDE CRT 1MG/2ML DOS",
  UCD7: '9362816',
  UCD13: '3400893628164',
  ucdQtyMultiplicator: 20,
  cipLib: "BUDESONIDE CRT 1MG/2ML DOS BT 20",
  atcCode: "R03BA02"
}, {
  CIP7: '3290286',
  CIP13: '3400932902866',
  ucdLib: "BECOTIDE 250Y BUC FL200DOS",
  UCD7: '9210153',
  UCD13: '3400892101538',
  ucdQtyMultiplicator: 1,
  cipLib: "BECOTIDE 250Y BUC FL200DOS BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '2760347',
  CIP13: '3400927603471',
  ucdLib: "ECOBEC 250MCG INHAL 200DOS S/P",
  UCD7: '9400451',
  UCD13: '3400894004516',
  ucdQtyMultiplicator: 1,
  cipLib: "ECOBEC 250MCG INHAL 200DOS S/P BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3377320',
  CIP13: '3400933773205',
  ucdLib: "BECLOJET 250MCG BUC FL200DOS",
  UCD7: '9177875',
  UCD13: '3400891778755',
  ucdQtyMultiplicator: 1,
  cipLib: "BECLOJET 250MCG BUC FL200DOS BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3565955',
  CIP13: '3400935659552',
  ucdLib: "MIFLASONE 400MCG GELU +INH.",
  UCD7: '9234567',
  UCD13: '3400892345673',
  ucdQtyMultiplicator: 60,
  cipLib: "MIFLASONE 400MCG GELU +INH. BT 60",
  atcCode: "R03BA01"
}, {
  CIP7: '3484553',
  CIP13: '3400934845536',
  ucdLib: "MIFLASONE 100MCG GELU +INH.",
  UCD7: '9211968',
  UCD13: '3400892119687',
  ucdQtyMultiplicator: 60,
  cipLib: "MIFLASONE 100MCG GELU +INH. BT 60",
  atcCode: "R03BA01"
}, {
  CIP7: '3484582',
  CIP13: '3400934845826',
  ucdLib: "MIFLASONE 200MCG GELU +INH.",
  UCD7: '9211974',
  UCD13: '3400892119748',
  ucdQtyMultiplicator: 60,
  cipLib: "MIFLASONE 200MCG GELU +INH. BT 60",
  atcCode: "R03BA01"
}, {
  CIP7: '3516069',
  CIP13: '3400935160690',
  ucdLib: "QVAR AUTOHALER 100MCG FL200DOS",
  UCD7: '9220832',
  UCD13: '3400892208329',
  ucdQtyMultiplicator: 1,
  cipLib: "QVAR AUTOHALER 100MCG FL200DOS BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3516023',
  CIP13: '3400935160232',
  ucdLib: "QVARSPRAY 100Y INHAL FL100DOS",
  UCD7: '9220849',
  UCD13: '3400892208497',
  ucdQtyMultiplicator: 1,
  cipLib: "QVARSPRAY 100Y INHAL FL100DOS BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3701631',
  CIP13: '3400937016315',
  ucdLib: "BECLOSPRAY 250MCG/DOS FL200DOS",
  UCD7: '9300525',
  UCD13: '3400893005255',
  ucdQtyMultiplicator: 1,
  cipLib: "BECLOSPRAY 250MCG/DOS FL200DOS BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3460972',
  CIP13: '3400934609725',
  ucdLib: "BEMEDREX EASYHAL.200Y 200D.+BT",
  UCD7: '9217586',
  UCD13: '3400892175867',
  ucdQtyMultiplicator: 1,
  cipLib: "BEMEDREX EASYHAL.200Y 200D.+BT BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3696344',
  CIP13: '3400936963443',
  ucdLib: "BECLOSPIN 400Y/1ML INH DOS",
  UCD7: '9293400',
  UCD13: '3400892934006',
  ucdQtyMultiplicator: 20,
  cipLib: "BECLOSPIN 400Y/1ML INH DOS BT 20",
  atcCode: "R03BA01"
}, {
  CIP7: '3696350',
  CIP13: '3400936963504',
  ucdLib: "BECLOSPIN 800Y/2ML INH DOS",
  UCD7: '9293417',
  UCD13: '3400892934174',
  ucdQtyMultiplicator: 20,
  cipLib: "BECLOSPIN 800Y/2ML INH DOS BT 20",
  atcCode: "R03BA01"
}, {
  CIP7: '3698567',
  CIP13: '3400936985674',
  ucdLib: "BECLOSPRAY 50MCG/DOS FL200DOS",
  UCD7: '9300531',
  UCD13: '3400893005316',
  ucdQtyMultiplicator: 1,
  cipLib: "BECLOSPRAY 50MCG/DOS FL200DOS BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3771637',
  CIP13: '3400937716376',
  ucdLib: "BECLOMETAS.TVC 250MCG FL200DOS",
  UCD7: '9293966',
  UCD13: '3400892939667',
  ucdQtyMultiplicator: 1,
  cipLib: "BECLOMETAS.TVC 250MCG FL200DOS BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3771620',
  CIP13: '3400937716208',
  ucdLib: "BECLOMETAS.TVC 50MCG FL200DOS",
  UCD7: '9293972',
  UCD13: '3400892939728',
  ucdQtyMultiplicator: 1,
  cipLib: "BECLOMETAS.TVC 50MCG FL200DOS BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '4900042',
  CIP13: '3400949000425',
  ucdLib: "QVAR A-HAL.100Y 200D.AIPMWI D2",
  UCD7: '9411874',
  UCD13: '3400894118749',
  ucdQtyMultiplicator: 1,
  cipLib: "QVAR A-HAL.100Y 200D.AIPMWI D2 BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '4901964',
  CIP13: '3400949019649',
  ucdLib: "QVAR A-HAL.100Y 200D.AIPPLA D2",
  UCD7: '9399707',
  UCD13: '3400893997079',
  ucdQtyMultiplicator: 1,
  cipLib: "QVAR A-HAL.100Y 200D.AIPPLA D2 BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '4900806',
  CIP13: '3400949008063',
  ucdLib: "QVAR A-HAL.100Y 200D.AIPPLA EL",
  UCD7: '9374334',
  UCD13: '3400893743348',
  ucdQtyMultiplicator: 1,
  cipLib: "QVAR A-HAL.100Y 200D.AIPPLA EL BT 1",
  atcCode: "R03BA01"
}, {
  CIP7: '3003880',
  CIP13: '3400930038802',
  ucdLib: "ULTIBRO BREEZ.85MCG GELU+INH",
  UCD7: '9396436',
  UCD13: '3400893964361',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTIBRO BREEZ.85MCG GELU+INH BT 10",
  atcCode: "R03AL04"
}, {
  CIP7: '2756624',
  CIP13: '3400927566240',
  ucdLib: "ULTIBRO BREEZ.85MCG GELU+INH",
  UCD7: '9396436',
  UCD13: '3400893964361',
  ucdQtyMultiplicator: 6,
  cipLib: "ULTIBRO BREEZ.85MCG GELU+INH BT 6",
  atcCode: "R03AL04"
}, {
  CIP7: '2756647',
  CIP13: '3400927566479',
  ucdLib: "ULTIBRO BREEZ.85MCG GELU+INH",
  UCD7: '9396436',
  UCD13: '3400893964361',
  ucdQtyMultiplicator: 30,
  cipLib: "ULTIBRO BREEZ.85MCG GELU+INH BT 30",
  atcCode: "R03AL04"
}, {
  CIP7: '3608699',
  CIP13: '3400936086999',
  ucdLib: "BRONCHODUAL SOL INHAL FL200DOS",
  UCD7: '9374392',
  UCD13: '3400893743928',
  ucdQtyMultiplicator: 1,
  cipLib: "BRONCHODUAL SOL INHAL FL200DOS BT 1",
  atcCode: "R03AL01"
}, {
  CIP7: '2664885',
  CIP13: '3400926648855',
  ucdLib: "FLUTIFORM 125/5MCG INH 120DOS",
  UCD7: '9395135',
  UCD13: '3400893951354',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUTIFORM 125/5MCG INH 120DOS BT 1",
  atcCode: "R03AK11"
}, {
  CIP7: '2664879',
  CIP13: '3400926648794',
  ucdLib: "FLUTIFORM 50/5MCG INH 120DOS",
  UCD7: '9395158',
  UCD13: '3400893951583',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUTIFORM 50/5MCG INH 120DOS BT 1",
  atcCode: "R03AK11"
}, {
  CIP7: '2761996',
  CIP13: '3400927619960',
  ucdLib: "RELVAR ELLIPTA 92/22Y 30DOS",
  UCD7: '9408553',
  UCD13: '3400894085539',
  ucdQtyMultiplicator: 1,
  cipLib: "RELVAR ELLIPTA 92/22Y 30DOS BT 1",
  atcCode: "R03AK10"
}, {
  CIP7: '3004003',
  CIP13: '3400930040034',
  ucdLib: "INNOVAIR 200/6Y/DOS FL120DOS",
  UCD7: '9419137',
  UCD13: '3400894191377',
  ucdQtyMultiplicator: 1,
  cipLib: "INNOVAIR 200/6Y/DOS FL120DOS BT 1",
  atcCode: "R03AK08"
}, {
  CIP7: '3003994',
  CIP13: '3400930039946',
  ucdLib: "INNOVAIR NEXT.200/6Y 120DOS",
  UCD7: '9419143',
  UCD13: '3400894191438',
  ucdQtyMultiplicator: 1,
  cipLib: "INNOVAIR NEXT.200/6Y 120DOS BT 1",
  atcCode: "R03AK08"
}, {
  CIP7: '3812112',
  CIP13: '3400938121124',
  ucdLib: "FORMODUAL 100/6Y/DOS FL120DOS",
  UCD7: '9309093',
  UCD13: '3400893090930',
  ucdQtyMultiplicator: 1,
  cipLib: "FORMODUAL 100/6Y/DOS FL120DOS BT 1",
  atcCode: "R03AK08"
}, {
  CIP7: '3814128',
  CIP13: '3400938141283',
  ucdLib: "INNOVAIR 100/6Y/DOS FL120DOS",
  UCD7: '9304517',
  UCD13: '3400893045176',
  ucdQtyMultiplicator: 1,
  cipLib: "INNOVAIR 100/6Y/DOS FL120DOS BT 1",
  atcCode: "R03AK08"
}, {
  CIP7: '2663288',
  CIP13: '3400926632885',
  ucdLib: "FORMODUAL NEXT.100/6Y 120DOS",
  UCD7: '9399392',
  UCD13: '3400893993927',
  ucdQtyMultiplicator: 1,
  cipLib: "FORMODUAL NEXT.100/6Y 120DOS BT 1",
  atcCode: "R03AK08"
}, {
  CIP7: '2663621',
  CIP13: '3400926636210',
  ucdLib: "INNOVAIR NEXT.100/6Y 120DOS",
  UCD7: '9399400',
  UCD13: '3400893994009',
  ucdQtyMultiplicator: 1,
  cipLib: "INNOVAIR NEXT.100/6Y 120DOS BT 1",
  atcCode: "R03AK08"
}, {
  CIP7: '3565820',
  CIP13: '3400935658203',
  ucdLib: "SYMBICORT TURB 100/6Y 120DOS",
  UCD7: '9232284',
  UCD13: '3400892322841',
  ucdQtyMultiplicator: 1,
  cipLib: "SYMBICORT TURB 100/6Y 120DOS BT 1",
  atcCode: "R03AK07"
}, {
  CIP7: '3565843',
  CIP13: '3400935658432',
  ucdLib: "SYMBICORT TURB 200/6Y 120DOS",
  UCD7: '9232290',
  UCD13: '3400892322902',
  ucdQtyMultiplicator: 1,
  cipLib: "SYMBICORT TURB 200/6Y 120DOS BT 1",
  atcCode: "R03AK07"
}, {
  CIP7: '3599730',
  CIP13: '3400935997302',
  ucdLib: "SYMBICORT TURB 400/12Y 60DOS",
  UCD7: '9245364',
  UCD13: '3400892453644',
  ucdQtyMultiplicator: 1,
  cipLib: "SYMBICORT TURB 400/12Y 60DOS BT 1",
  atcCode: "R03AK07"
}, {
  CIP7: '4900999',
  CIP13: '3400949009992',
  ucdLib: "SYMBICORT TURB 400/12Y 60D.AIP",
  UCD7: '9384812',
  UCD13: '3400893848128',
  ucdQtyMultiplicator: 1,
  cipLib: "SYMBICORT TURB 400/12Y 60D.AIP BT 1",
  atcCode: "R03AK07"
}, {
  CIP7: '2787547',
  CIP13: '3400927875472',
  ucdLib: "DUORESP SPIROMAX 160MCG 120D.",
  UCD7: '9411704',
  UCD13: '3400894117049',
  ucdQtyMultiplicator: 1,
  cipLib: "DUORESP SPIROMAX 160MCG 120D. BT 1",
  atcCode: "R03AK07"
}, {
  CIP7: '2787553',
  CIP13: '3400927875533',
  ucdLib: "DUORESP SPIROMAX 320MCG 60DOS",
  UCD7: '9411710',
  UCD13: '3400894117100',
  ucdQtyMultiplicator: 1,
  cipLib: "DUORESP SPIROMAX 320MCG 60DOS BT 1",
  atcCode: "R03AK07"
}, {
  CIP7: '3565872',
  CIP13: '3400935658722',
  ucdLib: "SERETIDE 125/25Y/DOS FL120DOS",
  UCD7: '9232522',
  UCD13: '3400892325224',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE 125/25Y/DOS FL120DOS BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '3565889',
  CIP13: '3400935658890',
  ucdLib: "SERETIDE 250/25Y/DOS FL120DOS",
  UCD7: '9232539',
  UCD13: '3400892325392',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE 250/25Y/DOS FL120DOS BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '3565866',
  CIP13: '3400935658661',
  ucdLib: "SERETIDE 50/25Y/DOS FL120DOS",
  UCD7: '9232545',
  UCD13: '3400892325453',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE 50/25Y/DOS FL120DOS BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '3545929',
  CIP13: '3400935459299',
  ucdLib: "SERETIDE DISK100/50Y 28DOS +D",
  UCD7: '9225338',
  UCD13: '3400892253381',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE DISK100/50Y 28DOS +D BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '3545935',
  CIP13: '3400935459350',
  ucdLib: "SERETIDE DISK100/50Y 60DOS +D",
  UCD7: '9221932',
  UCD13: '3400892219325',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE DISK100/50Y 60DOS +D BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '3545964',
  CIP13: '3400935459640',
  ucdLib: "SERETIDE DISK250/50Y 28DOS +D",
  UCD7: '9225344',
  UCD13: '3400892253442',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE DISK250/50Y 28DOS +D BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '3545970',
  CIP13: '3400935459701',
  ucdLib: "SERETIDE DISK250/50Y 60DOS +D",
  UCD7: '9221949',
  UCD13: '3400892219493',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE DISK250/50Y 60DOS +D BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '3547348',
  CIP13: '3400935473486',
  ucdLib: "SERETIDE DISK500/50Y 28DOS +D",
  UCD7: '9225350',
  UCD13: '3400892253503',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE DISK500/50Y 28DOS +D BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '3547354',
  CIP13: '3400935473547',
  ucdLib: "SERETIDE DISK500/50Y 60DOS +D",
  UCD7: '9221955',
  UCD13: '3400892219554',
  ucdQtyMultiplicator: 1,
  cipLib: "SERETIDE DISK500/50Y 60DOS +D BT 1",
  atcCode: "R03AK06"
}, {
  CIP7: '2772327',
  CIP13: '3400927723278',
  ucdLib: "STRIVERDI RESPIMAT 2,5Y 60DOS",
  UCD7: '9411271',
  UCD13: '3400894112716',
  ucdQtyMultiplicator: 1,
  cipLib: "STRIVERDI RESPIMAT 2,5Y 60DOS BT 1",
  atcCode: "R03AC19"
}, {
  CIP7: '4941136',
  CIP13: '3400949411368',
  ucdLib: "OSLIF BREEZ.150MCG GELU +INH",
  UCD7: '9365602',
  UCD13: '3400893656020',
  ucdQtyMultiplicator: 10,
  cipLib: "OSLIF BREEZ.150MCG GELU +INH BT 10",
  atcCode: "R03AC18"
}, {
  CIP7: '4941159',
  CIP13: '3400949411597',
  ucdLib: "OSLIF BREEZ.300MCG GELU +INH",
  UCD7: '9365619',
  UCD13: '3400893656198',
  ucdQtyMultiplicator: 10,
  cipLib: "OSLIF BREEZ.300MCG GELU +INH BT 10",
  atcCode: "R03AC18"
}, {
  CIP7: '3998217',
  CIP13: '3400939982175',
  ucdLib: "ONBREZ BREEZ.150MCG GELU +INH",
  UCD7: '9360444',
  UCD13: '3400893604441',
  ucdQtyMultiplicator: 10,
  cipLib: "ONBREZ BREEZ.150MCG GELU +INH BT 10",
  atcCode: "R03AC18"
}, {
  CIP7: '3998223',
  CIP13: '3400939982236',
  ucdLib: "ONBREZ BREEZ.150MCG GELU +INH",
  UCD7: '9360444',
  UCD13: '3400893604441',
  ucdQtyMultiplicator: 30,
  cipLib: "ONBREZ BREEZ.150MCG GELU +INH BT 30",
  atcCode: "R03AC18"
}, {
  CIP7: '3998246',
  CIP13: '3400939982465',
  ucdLib: "ONBREZ BREEZ.300MCG GELU +INH",
  UCD7: '9360450',
  UCD13: '3400893604502',
  ucdQtyMultiplicator: 10,
  cipLib: "ONBREZ BREEZ.300MCG GELU +INH BT 10",
  atcCode: "R03AC18"
}, {
  CIP7: '3998252',
  CIP13: '3400939982526',
  ucdLib: "ONBREZ BREEZ.300MCG GELU +INH",
  UCD7: '9360450',
  UCD13: '3400893604502',
  ucdQtyMultiplicator: 30,
  cipLib: "ONBREZ BREEZ.300MCG GELU +INH BT 30",
  atcCode: "R03AC18"
}, {
  CIP7: '3001109',
  CIP13: '3400930011096',
  ucdLib: "FORMOTEROL BGA 12MCG GELU",
  UCD7: '9415553',
  UCD13: '3400894155539',
  ucdQtyMultiplicator: 30,
  cipLib: "FORMOTEROL BGA 12MCG GELU BT 30",
  atcCode: "R03AC13"
}, {
  CIP7: '3001110',
  CIP13: '3400930011102',
  ucdLib: "FORMOTEROL BGA 12MCG GELU",
  UCD7: '9415553',
  UCD13: '3400894155539',
  ucdQtyMultiplicator: 60,
  cipLib: "FORMOTEROL BGA 12MCG GELU BT 60",
  atcCode: "R03AC13"
}, {
  CIP7: '3377337',
  CIP13: '3400933773373',
  ucdLib: "FORADIL 12MCG BUC GELU",
  UCD7: '9173825',
  UCD13: '3400891738254',
  ucdQtyMultiplicator: 30,
  cipLib: "FORADIL 12MCG BUC GELU BT 30",
  atcCode: "R03AC13"
}, {
  CIP7: '3377343',
  CIP13: '3400933773434',
  ucdLib: "FORADIL 12MCG BUC GELU",
  UCD7: '9173825',
  UCD13: '3400891738254',
  ucdQtyMultiplicator: 60,
  cipLib: "FORADIL 12MCG BUC GELU BT 60",
  atcCode: "R03AC13"
}, {
  CIP7: '3767268',
  CIP13: '3400937672689',
  ucdLib: "ASMELOR NOVOLIZ.12Y/DOS C +INH",
  UCD7: '9298099',
  UCD13: '3400892980997',
  ucdQtyMultiplicator: 1,
  cipLib: "ASMELOR NOVOLIZ.12Y/DOS C +INH BT 1",
  atcCode: "R03AC13"
}, {
  CIP7: '3767274',
  CIP13: '3400937672740',
  ucdLib: "ASMELOR NOVOLIZ.12Y/DOS CART.",
  UCD7: '9298082',
  UCD13: '3400892980829',
  ucdQtyMultiplicator: 1,
  cipLib: "ASMELOR NOVOLIZ.12Y/DOS CART. BT 1",
  atcCode: "R03AC13"
}, {
  CIP7: '3695126',
  CIP13: '3400936951266',
  ucdLib: "FORMOAIR 12MCG/DOS INH 100DOS",
  UCD7: '9288215',
  UCD13: '3400892882154',
  ucdQtyMultiplicator: 1,
  cipLib: "FORMOAIR 12MCG/DOS INH 100DOS BT 1",
  atcCode: "R03AC13"
}, {
  CIP7: '2802844',
  CIP13: '3400928028440',
  ucdLib: "FORMOTEROL MYL 12MCG GELU",
  UCD7: '9411319',
  UCD13: '3400894113195',
  ucdQtyMultiplicator: 60,
  cipLib: "FORMOTEROL MYL 12MCG GELU BT 60",
  atcCode: "R03AC13"
}, {
  CIP7: '2802838',
  CIP13: '3400928028389',
  ucdLib: "FORMOTEROL MYL 12MCG GELU",
  UCD7: '9411319',
  UCD13: '3400894113195',
  ucdQtyMultiplicator: 30,
  cipLib: "FORMOTEROL MYL 12MCG GELU BT 30",
  atcCode: "R03AC13"
}, {
  CIP7: '5706779',
  CIP13: '3400957067793',
  ucdLib: "FORADIL 12MCG BUC GELU",
  UCD7: '9173825',
  UCD13: '3400891738254',
  ucdQtyMultiplicator: 10,
  cipLib: "FORADIL 12MCG BUC GELU BT 10",
  atcCode: "R03AC13"
}, {
  CIP7: '3345780',
  CIP13: '3400933457808',
  ucdLib: "SEREVENT 25MCG PDR FL120DOS",
  UCD7: '9167569',
  UCD13: '3400891675696',
  ucdQtyMultiplicator: 1,
  cipLib: "SEREVENT 25MCG PDR FL120DOS BT 1",
  atcCode: "R03AC12"
}, {
  CIP7: '3391946',
  CIP13: '3400933919467',
  ucdLib: "SEREVENT DISKUS 50Y PDR60DOS+D",
  UCD7: '9192449',
  UCD13: '3400891924497',
  ucdQtyMultiplicator: 1,
  cipLib: "SEREVENT DISKUS 50Y PDR60DOS+D BT 1",
  atcCode: "R03AC12"
}, {
  CIP7: '3657338',
  CIP13: '3400936573383',
  ucdLib: "BRICANYL 5MG/2ML INHAL DOS",
  UCD7: '9159908',
  UCD13: '3400891599084',
  ucdQtyMultiplicator: 50,
  cipLib: "BRICANYL 5MG/2ML INHAL DOS BT 50",
  atcCode: "R03AC03"
}, {
  CIP7: '3657901',
  CIP13: '3400936579019',
  ucdLib: "TERBUTALINE ARW 5MG/2ML DOS",
  UCD7: '9250589',
  UCD13: '3400892505893',
  ucdQtyMultiplicator: 50,
  cipLib: "TERBUTALINE ARW 5MG/2ML DOS BT 50",
  atcCode: "R03AC03"
}, {
  CIP7: '4198772',
  CIP13: '3400941987724',
  ucdLib: "TERBUTALINE BGA 5MG/2ML DOS",
  UCD7: '9379490',
  UCD13: '3400893794906',
  ucdQtyMultiplicator: 50,
  cipLib: "TERBUTALINE BGA 5MG/2ML DOS BT 50",
  atcCode: "R03AC03"
}, {
  CIP7: '2226352',
  CIP13: '3400922263526',
  ucdLib: "BRICANYL TURBUHAL 500Y 100DOS",
  UCD7: '9385792',
  UCD13: '3400893857922',
  ucdQtyMultiplicator: 1,
  cipLib: "BRICANYL TURBUHAL 500Y 100DOS BT 1",
  atcCode: "R03AC03"
}, {
  CIP7: '2738193',
  CIP13: '3400927381935',
  ucdLib: "TERBUTALINE SDZ 5MG/2ML DOS",
  UCD7: '9393981',
  UCD13: '3400893939819',
  ucdQtyMultiplicator: 50,
  cipLib: "TERBUTALINE SDZ 5MG/2ML DOS BT 50",
  atcCode: "R03AC03"
}, {
  CIP7: '3406033',
  CIP13: '3400934060335',
  ucdLib: "AIROMIR A-H 100MCG INHAL200DOS",
  UCD7: '9214398',
  UCD13: '3400892143989',
  ucdQtyMultiplicator: 1,
  cipLib: "AIROMIR A-H 100MCG INHAL200DOS BT 1",
  atcCode: "R03AC02"
}, {
  CIP7: '3657953',
  CIP13: '3400936579538',
  ucdLib: "SALBUTAMOL ARW 2,5MG/2,5ML D.",
  UCD7: '9269560',
  UCD13: '3400892695600',
  ucdQtyMultiplicator: 60,
  cipLib: "SALBUTAMOL ARW 2,5MG/2,5ML D. BT 60",
  atcCode: "R03AC02"
}, {
  CIP7: '3658013',
  CIP13: '3400936580138',
  ucdLib: "SALBUTAMOL ARW 5MG/2,5ML DOS",
  UCD7: '9269577',
  UCD13: '3400892695778',
  ucdQtyMultiplicator: 60,
  cipLib: "SALBUTAMOL ARW 5MG/2,5ML DOS BT 60",
  atcCode: "R03AC02"
}, {
  CIP7: '3658438',
  CIP13: '3400936584389',
  ucdLib: "SALBUTAMOL MYL 2,5MG/2,5ML D",
  UCD7: '9274578',
  UCD13: '3400892745787',
  ucdQtyMultiplicator: 60,
  cipLib: "SALBUTAMOL MYL 2,5MG/2,5ML D BT 60",
  atcCode: "R03AC02"
}, {
  CIP7: '3656646',
  CIP13: '3400936566460',
  ucdLib: "SALBUTAMOL MYL 5MG/2,5ML DOS",
  UCD7: '9274584',
  UCD13: '3400892745848',
  ucdQtyMultiplicator: 60,
  cipLib: "SALBUTAMOL MYL 5MG/2,5ML DOS BT 60",
  atcCode: "R03AC02"
}, {
  CIP7: '3657806',
  CIP13: '3400936578067',
  ucdLib: "VENTOLINE 1,25MG INH. UNIDOS",
  UCD7: '9232060',
  UCD13: '3400892320601',
  ucdQtyMultiplicator: 20,
  cipLib: "VENTOLINE 1,25MG INH. UNIDOS BT 20",
  atcCode: "R03AC02"
}, {
  CIP7: '3532074',
  CIP13: '3400935320742',
  ucdLib: "VENTOLINE 2,5MG INHAL UNIDOS",
  UCD7: '9221010',
  UCD13: '3400892210100',
  ucdQtyMultiplicator: 60,
  cipLib: "VENTOLINE 2,5MG INHAL UNIDOS BT 60",
  atcCode: "R03AC02"
}, {
  CIP7: '3532111',
  CIP13: '3400935321114',
  ucdLib: "VENTOLINE 5MG INHAL UNIDOS",
  UCD7: '9221027',
  UCD13: '3400892210278',
  ucdQtyMultiplicator: 60,
  cipLib: "VENTOLINE 5MG INHAL UNIDOS BT 60",
  atcCode: "R03AC02"
}, {
  CIP7: '3584266',
  CIP13: '3400935842664',
  ucdLib: "SALBUTAMOL TVC100MCG INH200DOS",
  UCD7: '9245683',
  UCD13: '3400892456836',
  ucdQtyMultiplicator: 1,
  cipLib: "SALBUTAMOL TVC100MCG INH200DOS BT 1",
  atcCode: "R03AC02"
}, {
  CIP7: '3641202',
  CIP13: '3400936412026',
  ucdLib: "VENTILASTIN NOV.100Y 200D.+I.",
  UCD7: '9267325',
  UCD13: '3400892673257',
  ucdQtyMultiplicator: 1,
  cipLib: "VENTILASTIN NOV.100Y 200D.+I. BT 1",
  atcCode: "R03AC02"
}, {
  CIP7: '3641219',
  CIP13: '3400936412194',
  ucdLib: "VENTILASTIN NOV.100Y 200DOS",
  UCD7: '9267319',
  UCD13: '3400892673196',
  ucdQtyMultiplicator: 1,
  cipLib: "VENTILASTIN NOV.100Y 200DOS BT 1",
  atcCode: "R03AC02"
}, {
  CIP7: '3443873',
  CIP13: '3400934438738',
  ucdLib: "VENTOLINE 100Y INH FL200DOS",
  UCD7: '9201705',
  UCD13: '3400892017051',
  ucdQtyMultiplicator: 1,
  cipLib: "VENTOLINE 100Y INH FL200DOS BT 1",
  atcCode: "R03AC02"
}, {
  CIP7: '3895368',
  CIP13: '3400938953688',
  ucdLib: "SALBUTAMOL TVC 2,5MG/2,5ML D",
  UCD7: '9337681',
  UCD13: '3400893376812',
  ucdQtyMultiplicator: 60,
  cipLib: "SALBUTAMOL TVC 2,5MG/2,5ML D BT 60",
  atcCode: "R03AC02"
}, {
  CIP7: '3895411',
  CIP13: '3400938954111',
  ucdLib: "SALBUTAMOL TVC 5MG/2,5ML DOS",
  UCD7: '9337698',
  UCD13: '3400893376980',
  ucdQtyMultiplicator: 60,
  cipLib: "SALBUTAMOL TVC 5MG/2,5ML DOS BT 60",
  atcCode: "R03AC02"
}, {
  CIP7: '3000241',
  CIP13: '3400930002414',
  ucdLib: "STREFEN 8,75MG ORAN S/S PAST",
  UCD7: '9411331',
  UCD13: '3400894113317',
  ucdQtyMultiplicator: 16,
  cipLib: "STREFEN 8,75MG ORAN S/S PAST BT 16",
  atcCode: "R02AX01"
}, {
  CIP7: '3543600',
  CIP13: '3400935436009',
  ucdLib: "STREFEN 8,75MG PAST",
  UCD7: '9295801',
  UCD13: '3400892958019',
  ucdQtyMultiplicator: 16,
  cipLib: "STREFEN 8,75MG PAST BT 16",
  atcCode: "R02AX01"
}, {
  CIP7: '3062912',
  CIP13: '3400930629123',
  ucdLib: "GLOSSITHIASE CPR SUBLING",
  UCD7: '9038642',
  UCD13: '3400890386425',
  ucdQtyMultiplicator: 30,
  cipLib: "GLOSSITHIASE CPR SUBLING BT 30",
  atcCode: "R02AA20"
}, {
  CIP7: '3082607',
  CIP13: '3400930826072',
  ucdLib: "PHOLCONES BISMUTH AD. SUP",
  UCD7: '9071332',
  UCD13: '3400890713320',
  ucdQtyMultiplicator: 8,
  cipLib: "PHOLCONES BISMUTH AD. SUP BT 8",
  atcCode: "R02AA20"
}, {
  CIP7: '3002996',
  CIP13: '3400930029961',
  ucdLib: "DRILL MAUX GORGE CPR",
  UCD7: '9419864',
  UCD13: '3400894198642',
  ucdQtyMultiplicator: 18,
  cipLib: "DRILL MAUX GORGE CPR BT 18",
  atcCode: "R02AA20"
}, {
  CIP7: '3002992',
  CIP13: '3400930029923',
  ucdLib: "DRILL MAUX GORGE SIR FV200ML",
  UCD7: '9419858',
  UCD13: '3400894198581',
  ucdQtyMultiplicator: 1,
  cipLib: "DRILL MAUX GORGE SIR FV200ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3003966',
  CIP13: '3400930039663',
  ucdLib: "HUMEX M.GORG LAA M.CITR PAST",
  UCD7: '9419717',
  UCD13: '3400894197171',
  ucdQtyMultiplicator: 24,
  cipLib: "HUMEX M.GORG LAA M.CITR PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3003976',
  CIP13: '3400930039762',
  ucdLib: "HUMEX M.GORG LAA M.CITR S/S",
  UCD7: '9419700',
  UCD13: '3400894197003',
  ucdQtyMultiplicator: 24,
  cipLib: "HUMEX M.GORG LAA M.CITR S/S BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3003971',
  CIP13: '3400930039717',
  ucdLib: "HUMEX M.GORG LAA MENT.GL S/S",
  UCD7: '9419692',
  UCD13: '3400894196921',
  ucdQtyMultiplicator: 24,
  cipLib: "HUMEX M.GORG LAA MENT.GL S/S BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3003962',
  CIP13: '3400930039625',
  ucdLib: "HUMEX M.GORG LAA MENTHE PAST",
  UCD7: '9419798',
  UCD13: '3400894197980',
  ucdQtyMultiplicator: 24,
  cipLib: "HUMEX M.GORG LAA MENTHE PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3001108',
  CIP13: '3400930011089',
  ucdLib: "LYSOPAINE M.GORG AMBR.MENT20ML",
  UCD7: '9419870',
  UCD13: '3400894198703',
  ucdQtyMultiplicator: 1,
  cipLib: "LYSOPAINE M.GORG AMBR.MENT20ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3322661',
  CIP13: '3400933226619',
  ucdLib: "STREPSILS MIEL-CITR. PAST",
  UCD7: '9143037',
  UCD13: '3400891430370',
  ucdQtyMultiplicator: 24,
  cipLib: "STREPSILS MIEL-CITR. PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3579667',
  CIP13: '3400935796677',
  ucdLib: "DRILL MAUX GORGE COLLU FA40ML",
  UCD7: '9242785',
  UCD13: '3400892427850',
  ucdQtyMultiplicator: 1,
  cipLib: "DRILL MAUX GORGE COLLU FA40ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3570264',
  CIP13: '3400935702647',
  ucdLib: "ELUDRIL COLLU FL PRESS A 55ML",
  UCD7: '9237040',
  UCD13: '3400892370408',
  ucdQtyMultiplicator: 1,
  cipLib: "ELUDRIL COLLU FL PRESS A 55ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3042565',
  CIP13: '3400930425657',
  ucdLib: "ANGI-SPRAY M.GORG CHLO/LID40ML",
  UCD7: '9088746',
  UCD13: '3400890887465',
  ucdQtyMultiplicator: 1,
  cipLib: "ANGI-SPRAY M.GORG CHLO/LID40ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3231094',
  CIP13: '3400932310944',
  ucdLib: "PHOLCONES BISMUTH ENF SUP",
  UCD7: '9071349',
  UCD13: '3400890713498',
  ucdQtyMultiplicator: 8,
  cipLib: "PHOLCONES BISMUTH ENF SUP BT 8",
  atcCode: "R02AA20"
}, {
  CIP7: '3112679',
  CIP13: '3400931126799',
  ucdLib: "VICKS PAST MENT-EUC.",
  UCD7: '9098621',
  UCD13: '3400890986212',
  ucdQtyMultiplicator: 18,
  cipLib: "VICKS PAST MENT-EUC. BT 18",
  atcCode: "R02AA20"
}, {
  CIP7: '3268447',
  CIP13: '3400932684472',
  ucdLib: "VOCADYS PATE SUCER",
  UCD7: '9101027',
  UCD13: '3400891010275',
  ucdQtyMultiplicator: 30,
  cipLib: "VOCADYS PATE SUCER BT 30",
  atcCode: "R02AA20"
}, {
  CIP7: '3307727',
  CIP13: '3400933077273',
  ucdLib: "BIQUINOL AD. SUP",
  UCD7: '9011465',
  UCD13: '3400890114653',
  ucdQtyMultiplicator: 10,
  cipLib: "BIQUINOL AD. SUP BT 10",
  atcCode: "R02AA20"
}, {
  CIP7: '3307733',
  CIP13: '3400933077334',
  ucdLib: "BIQUINOL ENF SUP",
  UCD7: '9011471',
  UCD13: '3400890114714',
  ucdQtyMultiplicator: 10,
  cipLib: "BIQUINOL ENF SUP BT 10",
  atcCode: "R02AA20"
}, {
  CIP7: '3337817',
  CIP13: '3400933378172',
  ucdLib: "DRILL SANS SUCRE PAST",
  UCD7: '9150770',
  UCD13: '3400891507706',
  ucdQtyMultiplicator: 24,
  cipLib: "DRILL SANS SUCRE PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3308655',
  CIP13: '3400933086558',
  ucdLib: "VICKS PAST MENT-EUC.",
  UCD7: '9098621',
  UCD13: '3400890986212',
  ucdQtyMultiplicator: 30,
  cipLib: "VICKS PAST MENT-EUC. BT 30",
  atcCode: "R02AA20"
}, {
  CIP7: '3529511',
  CIP13: '3400935295118',
  ucdLib: "STREPSILS LIDOC PAST",
  UCD7: '9222512',
  UCD13: '3400892225128',
  ucdQtyMultiplicator: 24,
  cipLib: "STREPSILS LIDOC PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3400088',
  CIP13: '3400934000881',
  ucdLib: "STREPSILS LIDOC SPRAY 20ML",
  UCD7: '9183054',
  UCD13: '3400891830545',
  ucdQtyMultiplicator: 1,
  cipLib: "STREPSILS LIDOC SPRAY 20ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3358825',
  CIP13: '3400933588250',
  ucdLib: "DRILL CITR MENTH PAST",
  UCD7: '9221688',
  UCD13: '3400892216881',
  ucdQtyMultiplicator: 24,
  cipLib: "DRILL CITR MENTH PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3350060',
  CIP13: '3400933500603',
  ucdLib: "DRILL MIEL ROSAT PAST",
  UCD7: '9155342',
  UCD13: '3400891553420',
  ucdQtyMultiplicator: 24,
  cipLib: "DRILL MIEL ROSAT PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3132570',
  CIP13: '3400931325703',
  ucdLib: "DRILL PAST",
  UCD7: '9028916',
  UCD13: '3400890289160',
  ucdQtyMultiplicator: 24,
  cipLib: "DRILL PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3203778',
  CIP13: '3400932037780',
  ucdLib: "STREPSILS MENT GLAC PAST",
  UCD7: '9088232',
  UCD13: '3400890882323',
  ucdQtyMultiplicator: 24,
  cipLib: "STREPSILS MENT GLAC PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3850319',
  CIP13: '3400938503197',
  ucdLib: "DRILL S/SUC ANIS MENTH PAST",
  UCD7: '9320918',
  UCD13: '3400893209189',
  ucdQtyMultiplicator: 24,
  cipLib: "DRILL S/SUC ANIS MENTH PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3850331',
  CIP13: '3400938503319',
  ucdLib: "DRILL S/SUC PAMPLEMOUS PAST",
  UCD7: '9342682',
  UCD13: '3400893426821',
  ucdQtyMultiplicator: 24,
  cipLib: "DRILL S/SUC PAMPLEMOUS PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3851218',
  CIP13: '3400938512182',
  ucdLib: "STREPSILS MIEL-CITR. PAST",
  UCD7: '9143037',
  UCD13: '3400891430370',
  ucdQtyMultiplicator: 36,
  cipLib: "STREPSILS MIEL-CITR. PAST BT 36",
  atcCode: "R02AA20"
}, {
  CIP7: '3511511',
  CIP13: '3400935115119',
  ucdLib: "HUMEX GORG.IRRIT LIDOC. GOM",
  UCD7: '9339734',
  UCD13: '3400893397343',
  ucdQtyMultiplicator: 30,
  cipLib: "HUMEX GORG.IRRIT LIDOC. GOM BT 30",
  atcCode: "R02AA20"
}, {
  CIP7: '3534966',
  CIP13: '3400935349668',
  ucdLib: "RHINADVIL M.GORGE PULV 12ML",
  UCD7: '9388744',
  UCD13: '3400893887448',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINADVIL M.GORGE PULV 12ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3465366',
  CIP13: '3400934653667',
  ucdLib: "THIOVALONE BUC FL PULV 12ML",
  UCD7: '9213921',
  UCD13: '3400892139210',
  ucdQtyMultiplicator: 1,
  cipLib: "THIOVALONE BUC FL PULV 12ML BT 1",
  atcCode: "R02AA20"
}, {
  CIP7: '3741346',
  CIP13: '3400937413466',
  ucdLib: "STREPSILS CITRON S/S PAST",
  UCD7: '9287635',
  UCD13: '3400892876351',
  ucdQtyMultiplicator: 24,
  cipLib: "STREPSILS CITRON S/S PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3741211',
  CIP13: '3400937412117',
  ucdLib: "STREPSILS FRAISE S/S PAST",
  UCD7: '9285613',
  UCD13: '3400892856131',
  ucdQtyMultiplicator: 24,
  cipLib: "STREPSILS FRAISE S/S PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3695474',
  CIP13: '3400936954748',
  ucdLib: "STREPSILS ORAN.VIT C PAST",
  UCD7: '9285518',
  UCD13: '3400892855189',
  ucdQtyMultiplicator: 24,
  cipLib: "STREPSILS ORAN.VIT C PAST BT 24",
  atcCode: "R02AA20"
}, {
  CIP7: '3925916',
  CIP13: '3400939259161',
  ucdLib: "LYSOPAINE CASS 20MG S/S PAST",
  UCD7: '9355696',
  UCD13: '3400893556962',
  ucdQtyMultiplicator: 18,
  cipLib: "LYSOPAINE CASS 20MG S/S PAST BT 18",
  atcCode: "R02AA20"
}, {
  CIP7: '3903576',
  CIP13: '3400939035765',
  ucdLib: "LYSOPAINE M.GORG S/SUC CPR",
  UCD7: '9055824',
  UCD13: '3400890558242',
  ucdQtyMultiplicator: 36,
  cipLib: "LYSOPAINE M.GORG S/SUC CPR BT 36",
  atcCode: "R02AA20"
}, {
  CIP7: '4998372',
  CIP13: '3400949983728',
  ucdLib: "LYSOPAINE MENT 20MG S/S PAST",
  UCD7: '9312623',
  UCD13: '3400893126233',
  ucdQtyMultiplicator: 18,
  cipLib: "LYSOPAINE MENT 20MG S/S PAST BT 18",
  atcCode: "R02AA20"
}, {
  CIP7: '2802643',
  CIP13: '3400928026439',
  ucdLib: "LYSOPAINE M.GORG FRA S/S C",
  UCD7: '9411294',
  UCD13: '3400894112945',
  ucdQtyMultiplicator: 36,
  cipLib: "LYSOPAINE M.GORG FRA S/S C BT 36",
  atcCode: "R02AA20"
}, {
  CIP7: '2802672',
  CIP13: '3400928026729',
  ucdLib: "LYSOPAINE M.GORG MIE S/S C",
  UCD7: '9411302',
  UCD13: '3400894113027',
  ucdQtyMultiplicator: 36,
  cipLib: "LYSOPAINE M.GORG MIE S/S C BT 36",
  atcCode: "R02AA20"
}, {
  CIP7: '2228635',
  CIP13: '3400922286358',
  ucdLib: "LYSOPAINE CITR 20MG S/S PAST",
  UCD7: '9397861',
  UCD13: '3400893978610',
  ucdQtyMultiplicator: 18,
  cipLib: "LYSOPAINE CITR 20MG S/S PAST BT 18",
  atcCode: "R02AA20"
}, {
  CIP7: '3003624',
  CIP13: '3400930036242',
  ucdLib: "HEXASPRAY FR.EXO COLLU FL30G",
  UCD7: '9413488',
  UCD13: '3400894134886',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXASPRAY FR.EXO COLLU FL30G BT 1",
  atcCode: "R02AA19"
}, {
  CIP7: '3277972',
  CIP13: '3400932779727',
  ucdLib: "HEXASPRAY COLLU FL PRESS 30G",
  UCD7: '9102908',
  UCD13: '3400891029086',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXASPRAY COLLU FL PRESS 30G BT 1",
  atcCode: "R02AA19"
}, {
  CIP7: '3392911',
  CIP13: '3400933929114',
  ucdLib: "HUMEX M.GORG BIC ORANGE PAST",
  UCD7: '9222601',
  UCD13: '3400892226019',
  ucdQtyMultiplicator: 24,
  cipLib: "HUMEX M.GORG BIC ORANGE PAST BT 24",
  atcCode: "R02AA19"
}, {
  CIP7: '3635265',
  CIP13: '3400936352650',
  ucdLib: "HUMEX M.GORG BIC FR.RGE S/S",
  UCD7: '9290689',
  UCD13: '3400892906898',
  ucdQtyMultiplicator: 24,
  cipLib: "HUMEX M.GORG BIC FR.RGE S/S BT 24",
  atcCode: "R02AA19"
}, {
  CIP7: '3812017',
  CIP13: '3400938120172',
  ucdLib: "HUMEX M.GORG BIC M.CITR PAST",
  UCD7: '9304925',
  UCD13: '3400893049259',
  ucdQtyMultiplicator: 24,
  cipLib: "HUMEX M.GORG BIC M.CITR PAST BT 24",
  atcCode: "R02AA19"
}, {
  CIP7: '3635302',
  CIP13: '3400936353022',
  ucdLib: "HUMEX M.GORG BIC MENTHE S/S",
  UCD7: '9290695',
  UCD13: '3400892906959',
  ucdQtyMultiplicator: 24,
  cipLib: "HUMEX M.GORG BIC MENTHE S/S BT 24",
  atcCode: "R02AA19"
}, {
  CIP7: '2790147',
  CIP13: '3400927901478',
  ucdLib: "EUPHONYLL M.GORG CPR SUCER",
  UCD7: '9404532',
  UCD13: '3400894045328',
  ucdQtyMultiplicator: 24,
  cipLib: "EUPHONYLL M.GORG CPR SUCER BT 24",
  atcCode: "R02AA06"
}, {
  CIP7: '3024892',
  CIP13: '3400930248928',
  ucdLib: "COLLUNOVAR 0,11% FL PRESS 40ML",
  UCD7: '9021311',
  UCD13: '3400890213110',
  ucdQtyMultiplicator: 1,
  cipLib: "COLLUNOVAR 0,11% FL PRESS 40ML BT 1",
  atcCode: "R02AA05"
}, {
  CIP7: '3436258',
  CIP13: '3400934362583',
  ucdLib: "NUROFEN RHUME CPR",
  UCD7: '9204247',
  UCD13: '3400892042473',
  ucdQtyMultiplicator: 20,
  cipLib: "NUROFEN RHUME CPR BT 20",
  atcCode: "R01BA52"
}, {
  CIP7: '3340848',
  CIP13: '3400933408480',
  ucdLib: "RHINADVIL RHUME CPR",
  UCD7: '9154495',
  UCD13: '3400891544954',
  ucdQtyMultiplicator: 20,
  cipLib: "RHINADVIL RHUME CPR BT 20",
  atcCode: "R01BA52"
}, {
  CIP7: '3556293',
  CIP13: '3400935562937',
  ucdLib: "ACTIFED RHUME CPR",
  UCD7: '9232166',
  UCD13: '3400892321660',
  ucdQtyMultiplicator: 15,
  cipLib: "ACTIFED RHUME CPR BT 15",
  atcCode: "R01BA52"
}, {
  CIP7: '3412559',
  CIP13: '3400934125591',
  ucdLib: "DOLIRHUME 500MG/30MG CPR",
  UCD7: '9201533',
  UCD13: '3400892015330',
  ucdQtyMultiplicator: 16,
  cipLib: "DOLIRHUME 500MG/30MG CPR BT 16",
  atcCode: "R01BA52"
}, {
  CIP7: '3762070',
  CIP13: '3400937620703',
  ucdLib: "ACTIFED LP RHINIT.ALLERG CPR",
  UCD7: '9297295',
  UCD13: '3400892972954',
  ucdQtyMultiplicator: 10,
  cipLib: "ACTIFED LP RHINIT.ALLERG CPR BT 10",
  atcCode: "R01BA52"
}, {
  CIP7: '3388565',
  CIP13: '3400933885656',
  ucdLib: "RHINUREFLEX CPR",
  UCD7: '9178627',
  UCD13: '3400891786279',
  ucdQtyMultiplicator: 20,
  cipLib: "RHINUREFLEX CPR BT 20",
  atcCode: "R01BA52"
}, {
  CIP7: '3447463',
  CIP13: '3400934474637',
  ucdLib: "HUMEX RHUME CPR+GELU",
  UCD7: '9199919',
  UCD13: '3400891999198',
  ucdQtyMultiplicator: 16,
  cipLib: "HUMEX RHUME CPR+GELU BT 16",
  atcCode: "R01BA52"
}, {
  CIP7: '3443790',
  CIP13: '3400934437908',
  ucdLib: "RHUMAGRIP CPR",
  UCD7: '9197085',
  UCD13: '3400891970852',
  ucdQtyMultiplicator: 16,
  cipLib: "RHUMAGRIP CPR BT 16",
  atcCode: "R01BA52"
}, {
  CIP7: '3047031',
  CIP13: '3400930470312',
  ucdLib: "H.E.C POM DERM NAS TB25G",
  UCD7: '9041383',
  UCD13: '3400890413831',
  ucdQtyMultiplicator: 1,
  cipLib: "H.E.C POM DERM NAS TB25G BT 1",
  atcCode: "R01AX30"
}, {
  CIP7: '3181350',
  CIP13: '3400931813507',
  ucdLib: "EUVANOL SPRAY NAS FL15ML",
  UCD7: '9034006',
  UCD13: '3400890340069',
  ucdQtyMultiplicator: 1,
  cipLib: "EUVANOL SPRAY NAS FL15ML BT 1",
  atcCode: "R01AX30"
}, {
  CIP7: '3496763',
  CIP13: '3400934967634',
  ucdLib: "PRORHINEL RHUME NAS AP5ML",
  UCD7: '9158783',
  UCD13: '3400891587838',
  ucdQtyMultiplicator: 20,
  cipLib: "PRORHINEL RHUME NAS AP5ML BT 20",
  atcCode: "R01AX30"
}, {
  CIP7: '3050814',
  CIP13: '3400930508145',
  ucdLib: "HUILE GOMENOLEE 2% NAS FL22ML",
  UCD7: '9044619',
  UCD13: '3400890446198',
  ucdQtyMultiplicator: 1,
  cipLib: "HUILE GOMENOLEE 2% NAS FL22ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3050820',
  CIP13: '3400930508206',
  ucdLib: "HUILE GOMENOLEE 5% NAS FL22ML",
  UCD7: '9044625',
  UCD13: '3400890446259',
  ucdQtyMultiplicator: 1,
  cipLib: "HUILE GOMENOLEE 5% NAS FL22ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3050984',
  CIP13: '3400930509845',
  ucdLib: "HUMEX INHALER TAMP",
  UCD7: '9044708',
  UCD13: '3400890447089',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMEX INHALER TAMP BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3281643',
  CIP13: '3400932816439',
  ucdLib: "ACTISOUFRE NAS BUV AMP10ML",
  UCD7: '9000935',
  UCD13: '3400890009355',
  ucdQtyMultiplicator: 30,
  cipLib: "ACTISOUFRE NAS BUV AMP10ML BT 30",
  atcCode: "R01AX10"
}, {
  CIP7: '3232389',
  CIP13: '3400932323890',
  ucdLib: "BIOCIDAN NAS SOL FL PULV 15ML",
  UCD7: '9102423',
  UCD13: '3400891024234',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOCIDAN NAS SOL FL PULV 15ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3045701',
  CIP13: '3400930457016',
  ucdLib: "GOMENOLEO 2% LOC AMP5ML",
  UCD7: '9040538',
  UCD13: '3400890405386',
  ucdQtyMultiplicator: 10,
  cipLib: "GOMENOLEO 2% LOC AMP5ML BT 10",
  atcCode: "R01AX10"
}, {
  CIP7: '3111579',
  CIP13: '3400931115793',
  ucdLib: "VASELINE GOMENOLEE 5% TB15G",
  UCD7: '9097610',
  UCD13: '3400890976107',
  ucdQtyMultiplicator: 1,
  cipLib: "VASELINE GOMENOLEE 5% TB15G BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3070372',
  CIP13: '3400930703724',
  ucdLib: "NAZINETTE POM TB12G",
  UCD7: '9061285',
  UCD13: '3400890612852',
  ucdQtyMultiplicator: 1,
  cipLib: "NAZINETTE POM TB12G BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3098318',
  CIP13: '3400930983188',
  ucdLib: "DOLIRHUME 2% NAS FL PULV 15ML",
  UCD7: '9086523',
  UCD13: '3400890865234',
  ucdQtyMultiplicator: 1,
  cipLib: "DOLIRHUME 2% NAS FL PULV 15ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3091026',
  CIP13: '3400930910269',
  ucdLib: "RHINOTROPHYL NAS FL PULV20ML",
  UCD7: '9079859',
  UCD13: '3400890798594',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINOTROPHYL NAS FL PULV20ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3402070',
  CIP13: '3400934020704',
  ucdLib: "RHINAMIDE NAS SOL FL PULV 20ML",
  UCD7: '9177562',
  UCD13: '3400891775624',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINAMIDE NAS SOL FL PULV 20ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3360093',
  CIP13: '3400933600938',
  ucdLib: "GELUTROPHYL 200MG GELU",
  UCD7: '9383422',
  UCD13: '3400893834220',
  ucdQtyMultiplicator: 30,
  cipLib: "GELUTROPHYL 200MG GELU BT 30",
  atcCode: "R01AX10"
}, {
  CIP7: '3413180',
  CIP13: '3400934131806',
  ucdLib: "BALSAMORHINOL NAS SOL FL20ML",
  UCD7: '9243483',
  UCD13: '3400892434834',
  ucdQtyMultiplicator: 1,
  cipLib: "BALSAMORHINOL NAS SOL FL20ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3415888',
  CIP13: '3400934158889',
  ucdLib: "HUMEX 0,04% NAS FL PULV 15ML",
  UCD7: '9204804',
  UCD13: '3400892048048',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMEX 0,04% NAS FL PULV 15ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3413168',
  CIP13: '3400934131684',
  ucdLib: "RHINEDRINE NAS SOL FP13ML",
  UCD7: '9183634',
  UCD13: '3400891836349',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINEDRINE NAS SOL FP13ML BT 1",
  atcCode: "R01AX10"
}, {
  CIP7: '3344562',
  CIP13: '3400933445621',
  ucdLib: "DESOMEDINE 0,1% NAS FL10ML",
  UCD7: '9190344',
  UCD13: '3400891903447',
  ucdQtyMultiplicator: 1,
  cipLib: "DESOMEDINE 0,1% NAS FL10ML BT 1",
  atcCode: "R01AX07"
}, {
  CIP7: '3634165',
  CIP13: '3400936341654',
  ucdLib: "BACTROBAN 2% POM NAS TB3G",
  UCD7: '9154147',
  UCD13: '3400891541472',
  ucdQtyMultiplicator: 1,
  cipLib: "BACTROBAN 2% POM NAS TB3G BT 1",
  atcCode: "R01AX06"
}, {
  CIP7: '3070515',
  CIP13: '3400930705155',
  ucdLib: "NECYRANE NAS FL PRESS 10ML",
  UCD7: '9061368',
  UCD13: '3400890613682',
  ucdQtyMultiplicator: 1,
  cipLib: "NECYRANE NAS FL PRESS 10ML BT 1",
  atcCode: "R01AX05"
}, {
  CIP7: '3392756',
  CIP13: '3400933927561',
  ucdLib: "ATROVENT NAS 0,03% PULV 15ML",
  UCD7: '9182385',
  UCD13: '3400891823851',
  ucdQtyMultiplicator: 1,
  cipLib: "ATROVENT NAS 0,03% PULV 15ML BT 1",
  atcCode: "R01AX03"
}, {
  CIP7: '2756311',
  CIP13: '3400927563119',
  ucdLib: "DYMISTA PULV NAS FL23G",
  UCD7: '9418020',
  UCD13: '3400894180203',
  ucdQtyMultiplicator: 1,
  cipLib: "DYMISTA PULV NAS FL23G BT 1",
  atcCode: "R01AD58"
}, {
  CIP7: '3209686',
  CIP13: '3400932096862',
  ucdLib: "DETURGYLONE NAS FL NEB 10ML",
  UCD7: '9025763',
  UCD13: '3400890257633',
  ucdQtyMultiplicator: 1,
  cipLib: "DETURGYLONE NAS FL NEB 10ML BT 1",
  atcCode: "R01AD52"
}, {
  CIP7: '3535606',
  CIP13: '3400935356062',
  ucdLib: "DERINOX SOL NAS FL15ML +POMP",
  UCD7: '9219898',
  UCD13: '3400892198989',
  ucdQtyMultiplicator: 1,
  cipLib: "DERINOX SOL NAS FL15ML +POMP BT 1",
  atcCode: "R01AD52"
}, {
  CIP7: '3832244',
  CIP13: '3400938322446',
  ucdLib: "AVAMYS 27,5MCG/PULV NAS 120DOS",
  UCD7: '9314183',
  UCD13: '3400893141830',
  ucdQtyMultiplicator: 1,
  cipLib: "AVAMYS 27,5MCG/PULV NAS 120DOS BT 1",
  atcCode: "R01AD12"
}, {
  CIP7: '3429229',
  CIP13: '3400934292293',
  ucdLib: "NASACORT 55MCG/DOS NAS FL15ML",
  UCD7: '9194833',
  UCD13: '3400891948332',
  ucdQtyMultiplicator: 1,
  cipLib: "NASACORT 55MCG/DOS NAS FL15ML BT 1",
  atcCode: "R01AD11"
}, {
  CIP7: '3430126',
  CIP13: '3400934301261',
  ucdLib: "NASONEX 50MCG NAS FL120DOS",
  UCD7: '9213915',
  UCD13: '3400892139159',
  ucdQtyMultiplicator: 1,
  cipLib: "NASONEX 50MCG NAS FL120DOS BT 1",
  atcCode: "R01AD09"
}, {
  CIP7: '2750567',
  CIP13: '3400927505676',
  ucdLib: "MOMETASONE SDZ 50Y NAS 120DOS",
  UCD7: '9399044',
  UCD13: '3400893990445',
  ucdQtyMultiplicator: 1,
  cipLib: "MOMETASONE SDZ 50Y NAS 120DOS BT 1",
  atcCode: "R01AD09"
}, {
  CIP7: '2793950',
  CIP13: '3400927939501',
  ucdLib: "MOMETASONE TVC 50Y NAS 120DOS",
  UCD7: '9404288',
  UCD13: '3400894042884',
  ucdQtyMultiplicator: 1,
  cipLib: "MOMETASONE TVC 50Y NAS 120DOS BT 1",
  atcCode: "R01AD09"
}, {
  CIP7: '3741286',
  CIP13: '3400937412865',
  ucdLib: "FLIXONASE 50Y NAS PULV FP120D.",
  UCD7: '9293995',
  UCD13: '3400892939957',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXONASE 50Y NAS PULV FP120D. BT 1",
  atcCode: "R01AD08"
}, {
  CIP7: '3975831',
  CIP13: '3400939758312',
  ucdLib: "FIXORINOX 50Y/DOS NAS FL120DOS",
  UCD7: '9386840',
  UCD13: '3400893868409',
  ucdQtyMultiplicator: 1,
  cipLib: "FIXORINOX 50Y/DOS NAS FL120DOS BT 1",
  atcCode: "R01AD08"
}, {
  CIP7: '3206110',
  CIP13: '3400932061105',
  ucdLib: "PIVALONE 1% NAS FL PULV 10ML",
  UCD7: '9072320',
  UCD13: '3400890723206',
  ucdQtyMultiplicator: 1,
  cipLib: "PIVALONE 1% NAS FL PULV 10ML BT 1",
  atcCode: "R01AD07"
}, {
  CIP7: '3515822',
  CIP13: '3400935158222',
  ucdLib: "RHINOCORT 64Y NAS FL120DOS",
  UCD7: '9214702',
  UCD13: '3400892147024',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINOCORT 64Y NAS FL120DOS BT 1",
  atcCode: "R01AD05"
}, {
  CIP7: '3988874',
  CIP13: '3400939888743',
  ucdLib: "BUDESONIDE SDZ 64Y/DOS 120DOS",
  UCD7: '9413117',
  UCD13: '3400894131175',
  ucdQtyMultiplicator: 1,
  cipLib: "BUDESONIDE SDZ 64Y/DOS 120DOS BT 1",
  atcCode: "R01AD05"
}, {
  CIP7: '3292925',
  CIP13: '3400932929252',
  ucdLib: "BECONASE 50Y PULV NAS FL200DOS",
  UCD7: '9201160',
  UCD13: '3400892011608',
  ucdQtyMultiplicator: 1,
  cipLib: "BECONASE 50Y PULV NAS FL200DOS BT 1",
  atcCode: "R01AD01"
}, {
  CIP7: '3432131',
  CIP13: '3400934321313',
  ucdLib: "HUMEX RHUME FOIN 50 NAS 100D.",
  UCD7: '9281868',
  UCD13: '3400892818689',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMEX RHUME FOIN 50 NAS 100D. BT 1",
  atcCode: "R01AD01"
}, {
  CIP7: '3417812',
  CIP13: '3400934178122',
  ucdLib: "BECLO-RHINO 50MCG NAS FL100DOS",
  UCD7: '9200597',
  UCD13: '3400892005973',
  ucdQtyMultiplicator: 1,
  cipLib: "BECLO-RHINO 50MCG NAS FL100DOS BT 1",
  atcCode: "R01AD01"
}, {
  CIP7: '3417829',
  CIP13: '3400934178290',
  ucdLib: "BECLO-RHINO 50MCG NAS FL200DOS",
  UCD7: '9200605',
  UCD13: '3400892006055',
  ucdQtyMultiplicator: 1,
  cipLib: "BECLO-RHINO 50MCG NAS FL200DOS BT 1",
  atcCode: "R01AD01"
}, {
  CIP7: '3707125',
  CIP13: '3400937071253',
  ucdLib: "RHINOMAXIL 100Y NAS PULV120DOS",
  UCD7: '9326482',
  UCD13: '3400893264829',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINOMAXIL 100Y NAS PULV120DOS BT 1",
  atcCode: "R01AD01"
}, {
  CIP7: '3707102',
  CIP13: '3400937071024',
  ucdLib: "RINOCLENIL 100Y NAS PULV120DOS",
  UCD7: '9326565',
  UCD13: '3400893265659',
  ucdQtyMultiplicator: 1,
  cipLib: "RINOCLENIL 100Y NAS PULV120DOS BT 1",
  atcCode: "R01AD01"
}, {
  CIP7: '3455066',
  CIP13: '3400934550669',
  ucdLib: "PROALLERGODIL PULV NAS FV10ML",
  UCD7: '9299414',
  UCD13: '3400892994147',
  ucdQtyMultiplicator: 1,
  cipLib: "PROALLERGODIL PULV NAS FV10ML BT 1",
  atcCode: "R01AC03"
}, {
  CIP7: '3383059',
  CIP13: '3400933830595',
  ucdLib: "ALLERGODIL NAS PULV FV17ML",
  UCD7: '9198535',
  UCD13: '3400891985351',
  ucdQtyMultiplicator: 1,
  cipLib: "ALLERGODIL NAS PULV FV17ML BT 1",
  atcCode: "R01AC03"
}, {
  CIP7: '3375373',
  CIP13: '3400933753733',
  ucdLib: "LOMUSOL 4% PULV NAS FL15ML",
  UCD7: '9173707',
  UCD13: '3400891737073',
  ucdQtyMultiplicator: 1,
  cipLib: "LOMUSOL 4% PULV NAS FL15ML BT 1",
  atcCode: "R01AC01"
}, {
  CIP7: '3399830',
  CIP13: '3400933998301',
  ucdLib: "CROMORHINOL 2% NAS FL15ML",
  UCD7: '9186578',
  UCD13: '3400891865783',
  ucdQtyMultiplicator: 1,
  cipLib: "CROMORHINOL 2% NAS FL15ML BT 1",
  atcCode: "R01AC01"
}, {
  CIP7: '2211965',
  CIP13: '3400922119656',
  ucdLib: "ALAIRGIX RHIN.ALL NAS FL15ML",
  UCD7: '9387147',
  UCD13: '3400893871478',
  ucdQtyMultiplicator: 1,
  cipLib: "ALAIRGIX RHIN.ALL NAS FL15ML BT 1",
  atcCode: "R01AC01"
}, {
  CIP7: '3263711',
  CIP13: '3400932637119',
  ucdLib: "RHINOFLUIMUCIL NAS FL NEB 10ML",
  UCD7: '9104758',
  UCD13: '3400891047585',
  ucdQtyMultiplicator: 1,
  cipLib: "RHINOFLUIMUCIL NAS FL NEB 10ML BT 1",
  atcCode: "R01AB08"
}, {
  CIP7: '3237903',
  CIP13: '3400932379033',
  ucdLib: "HUMOXAL NAS SOL FV15ML",
  UCD7: '9044803',
  UCD13: '3400890448031',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMOXAL NAS SOL FV15ML BT 1",
  atcCode: "R01AB01"
}, {
  CIP7: '3081996',
  CIP13: '3400930819968',
  ucdLib: "PERNAZENE 0,05% NAS FP12ML",
  UCD7: '9070410',
  UCD13: '3400890704106',
  ucdQtyMultiplicator: 1,
  cipLib: "PERNAZENE 0,05% NAS FP12ML BT 1",
  atcCode: "R01AA05"
}, {
  CIP7: '3008456',
  CIP13: '3400930084564',
  ucdLib: "ATURGYL 0,05% NAS FL15ML",
  UCD7: '9008256',
  UCD13: '3400890082563',
  ucdQtyMultiplicator: 1,
  cipLib: "ATURGYL 0,05% NAS FL15ML BT 1",
  atcCode: "R01AA05"
}, {
  CIP7: '3410388',
  CIP13: '3400934103889',
  ucdLib: "PRIODERM 0,5% CUTA SOL FL100ML",
  UCD7: '9184562',
  UCD13: '3400891845624',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIODERM 0,5% CUTA SOL FL100ML BT 1",
  atcCode: "P03AX03"
}, {
  CIP7: '2793602',
  CIP13: '3400927936029',
  ucdLib: "PRIODERM LOT FV100ML",
  UCD7: '9408286',
  UCD13: '3400894082866',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIODERM LOT FV100ML BT 1",
  atcCode: "P03AX03"
}, {
  CIP7: '3002001',
  CIP13: '3400930020012',
  ucdLib: "ASCABIOL 10% EMUL LOC FL125ML",
  UCD7: '9411733',
  UCD13: '3400894117339',
  ucdQtyMultiplicator: 1,
  cipLib: "ASCABIOL 10% EMUL LOC FL125ML BT 1",
  atcCode: "P03AX01"
}, {
  CIP7: '3493836',
  CIP13: '3400934938368',
  ucdLib: "PARA-PLUS LOT FL PRESS 116G",
  UCD7: '9211282',
  UCD13: '3400892112824',
  ucdQtyMultiplicator: 1,
  cipLib: "PARA-PLUS LOT FL PRESS 116G BT 1",
  atcCode: "P03AC54"
}, {
  CIP7: '3322106',
  CIP13: '3400933221065',
  ucdLib: "PARA SPEC. POUX SHAMP FP125ML",
  UCD7: '9143072',
  UCD13: '3400891430721',
  ucdQtyMultiplicator: 1,
  cipLib: "PARA SPEC. POUX SHAMP FP125ML BT 1",
  atcCode: "P03AC52"
}, {
  CIP7: '3373322',
  CIP13: '3400933733223',
  ucdLib: "PARA SPEC. POUX SHAMP FP250ML",
  UCD7: '9173386',
  UCD13: '3400891733860',
  ucdQtyMultiplicator: 1,
  cipLib: "PARA SPEC. POUX SHAMP FP250ML BT 1",
  atcCode: "P03AC52"
}, {
  CIP7: '3493842',
  CIP13: '3400934938429',
  ucdLib: "PARA SPEC. POUX FL PRESS 116G",
  UCD7: '9211276',
  UCD13: '3400892112763',
  ucdQtyMultiplicator: 1,
  cipLib: "PARA SPEC. POUX FL PRESS 116G BT 1",
  atcCode: "P03AC52"
}, {
  CIP7: '3536735',
  CIP13: '3400935367358',
  ucdLib: "SPRAY-PAX LOC SOL FL PULV 8G",
  UCD7: '9224126',
  UCD13: '3400892241265',
  ucdQtyMultiplicator: 1,
  cipLib: "SPRAY-PAX LOC SOL FL PULV 8G BT 1",
  atcCode: "P03AC51"
}, {
  CIP7: '3000223',
  CIP13: '3400930002230',
  ucdLib: "TOPISCAB 5% CR TB30G",
  UCD7: '9409009',
  UCD13: '3400894090090',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPISCAB 5% CR TB30G BT 1",
  atcCode: "P03AC04"
}, {
  CIP7: '3316100',
  CIP13: '3400933161002',
  ucdLib: "ITEM ANTI-POUX SHAMP FP150ML",
  UCD7: '9138444',
  UCD13: '3400891384444',
  ucdQtyMultiplicator: 1,
  cipLib: "ITEM ANTI-POUX SHAMP FP150ML BT 1",
  atcCode: "P03AC03"
}, {
  CIP7: '3245707',
  CIP13: '3400932457076',
  ucdLib: "HEGOR POUX SHAMP FL150ML",
  UCD7: '9042046',
  UCD13: '3400890420464',
  ucdQtyMultiplicator: 1,
  cipLib: "HEGOR POUX SHAMP FL150ML BT 1",
  atcCode: "P03AC03"
}, {
  CIP7: '3332412',
  CIP13: '3400933324124',
  ucdLib: "ITAX SHA FL150ML",
  UCD7: '9148945',
  UCD13: '3400891489453',
  ucdQtyMultiplicator: 1,
  cipLib: "ITAX SHA FL150ML BT 1",
  atcCode: "P03AC03"
}, {
  CIP7: '3304700',
  CIP13: '3400933047009',
  ucdLib: "PARASIDOSE SHA FP200ML",
  UCD7: '9127699',
  UCD13: '3400891276992',
  ucdQtyMultiplicator: 1,
  cipLib: "PARASIDOSE SHA FP200ML BT 1",
  atcCode: "P03AC03"
}, {
  CIP7: '3364429',
  CIP13: '3400933644291',
  ucdLib: "ITAX SHA FL300ML",
  UCD7: '9165843',
  UCD13: '3400891658439',
  ucdQtyMultiplicator: 1,
  cipLib: "ITAX SHA FL300ML BT 1",
  atcCode: "P03AC03"
}, {
  CIP7: '3107750',
  CIP13: '3400931077503',
  ucdLib: "TREDEMINE 500MG CPR CROQ",
  UCD7: '9094497',
  UCD13: '3400890944977',
  ucdQtyMultiplicator: 4,
  cipLib: "TREDEMINE 500MG CPR CROQ BT 4",
  atcCode: "P02DA01"
}, {
  CIP7: '3523885',
  CIP13: '3400935238856',
  ucdLib: "STROMECTOL 3MG CPR",
  UCD7: '9220430',
  UCD13: '3400892204307',
  ucdQtyMultiplicator: 4,
  cipLib: "STROMECTOL 3MG CPR BT 4",
  atcCode: "P02CF01"
}, {
  CIP7: '3523891',
  CIP13: '3400935238917',
  ucdLib: "STROMECTOL 3MG CPR",
  UCD7: '9220430',
  UCD13: '3400892204307',
  ucdQtyMultiplicator: 20,
  cipLib: "STROMECTOL 3MG CPR BT 20",
  atcCode: "P02CF01"
}, {
  CIP7: '3305645',
  CIP13: '3400933056452',
  ucdLib: "HELMINTOX 125MG CPR PELLIC",
  UCD7: '9133257',
  UCD13: '3400891332575',
  ucdQtyMultiplicator: 6,
  cipLib: "HELMINTOX 125MG CPR PELLIC BT 6",
  atcCode: "P02CC01"
}, {
  CIP7: '3305622',
  CIP13: '3400933056223',
  ucdLib: "HELMINTOX 125MG/2,5ML BUV 15ML",
  UCD7: '9133240',
  UCD13: '3400891332407',
  ucdQtyMultiplicator: 1,
  cipLib: "HELMINTOX 125MG/2,5ML BUV 15ML BT 1",
  atcCode: "P02CC01"
}, {
  CIP7: '3305639',
  CIP13: '3400933056391',
  ucdLib: "HELMINTOX 250MG CPR PELLIC",
  UCD7: '9133263',
  UCD13: '3400891332636',
  ucdQtyMultiplicator: 3,
  cipLib: "HELMINTOX 250MG CPR PELLIC BT 3",
  atcCode: "P02CC01"
}, {
  CIP7: '3140629',
  CIP13: '3400931406297',
  ucdLib: "COMBANTRIN 125MG CPR SECAB",
  UCD7: '9021529',
  UCD13: '3400890215299',
  ucdQtyMultiplicator: 6,
  cipLib: "COMBANTRIN 125MG CPR SECAB BT 6",
  atcCode: "P02CC01"
}, {
  CIP7: '3140718',
  CIP13: '3400931407188',
  ucdLib: "COMBANTRIN BUV FL15ML",
  UCD7: '9021535',
  UCD13: '3400890215350',
  ucdQtyMultiplicator: 1,
  cipLib: "COMBANTRIN BUV FL15ML BT 1",
  atcCode: "P02CC01"
}, {
  CIP7: '3073910',
  CIP13: '3400930739105',
  ucdLib: "NOTEZINE 100MG CPR",
  UCD7: '9063781',
  UCD13: '3400890637817',
  ucdQtyMultiplicator: 20,
  cipLib: "NOTEZINE 100MG CPR BT 20",
  atcCode: "P02CB02"
}, {
  CIP7: '3234017',
  CIP13: '3400932340170',
  ucdLib: "FLUVERMAL CPR",
  UCD7: '9035856',
  UCD13: '3400890358569',
  ucdQtyMultiplicator: 6,
  cipLib: "FLUVERMAL CPR BT 6",
  atcCode: "P02CA05"
}, {
  CIP7: '3244079',
  CIP13: '3400932440795',
  ucdLib: "FLUVERMAL 2% BUV FL30ML",
  UCD7: '9035862',
  UCD13: '3400890358620',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUVERMAL 2% BUV FL30ML BT 1",
  atcCode: "P02CA05"
}, {
  CIP7: '3297041',
  CIP13: '3400932970414',
  ucdLib: "ZENTEL 4G/100ML BUV FP10ML",
  UCD7: '9127222',
  UCD13: '3400891272222',
  ucdQtyMultiplicator: 1,
  cipLib: "ZENTEL 4G/100ML BUV FP10ML BT 1",
  atcCode: "P02CA03"
}, {
  CIP7: '3686682',
  CIP13: '3400936866829',
  ucdLib: "ESKAZOLE 400MG CPR",
  UCD7: '9278582',
  UCD13: '3400892785820',
  ucdQtyMultiplicator: 56,
  cipLib: "ESKAZOLE 400MG CPR BT 56",
  atcCode: "P02CA03"
}, {
  CIP7: '3684826',
  CIP13: '3400936848269',
  ucdLib: "ZENTEL 400MG CPR",
  UCD7: '9280455',
  UCD13: '3400892804552',
  ucdQtyMultiplicator: 1,
  cipLib: "ZENTEL 400MG CPR BT 1",
  atcCode: "P02CA03"
}, {
  CIP7: '3585774',
  CIP13: '3400935857743',
  ucdLib: "EGATEN 250MG CPR",
  UCD7: '9244637',
  UCD13: '3400892446370',
  ucdQtyMultiplicator: 4,
  cipLib: "EGATEN 250MG CPR BT 4",
  atcCode: "P02BX04"
}, {
  CIP7: '3251381',
  CIP13: '3400932513819',
  ucdLib: "BILTRICIDE 600MG CPR",
  UCD7: '9129675',
  UCD13: '3400891296754',
  ucdQtyMultiplicator: 6,
  cipLib: "BILTRICIDE 600MG CPR BT 6",
  atcCode: "P02BA01"
}, {
  CIP7: '3322891',
  CIP13: '3400933228910',
  ucdLib: "PENTACARINAT 300MG INJ FV",
  UCD7: '9137249',
  UCD13: '3400891372496',
  ucdQtyMultiplicator: 1,
  cipLib: "PENTACARINAT 300MG INJ FV BT 1",
  atcCode: "P01CX01"
}, {
  CIP7: '3272667',
  CIP13: '3400932726677',
  ucdLib: "GLUCANTIME 1,5G INJ AMP5ML",
  UCD7: '9038719',
  UCD13: '3400890387194',
  ucdQtyMultiplicator: 5,
  cipLib: "GLUCANTIME 1,5G INJ AMP5ML BT 5",
  atcCode: "P01CB01"
}, {
  CIP7: '2175198',
  CIP13: '3400921751987',
  ucdLib: "EURARTESIM 320MG/40MG CPR",
  UCD7: '9382753',
  UCD13: '3400893827536',
  ucdQtyMultiplicator: 12,
  cipLib: "EURARTESIM 320MG/40MG CPR BT 12",
  atcCode: "P01BF05"
}, {
  CIP7: '2760330',
  CIP13: '3400927603303',
  ucdLib: "RIAMET 20MG/120MG CPR",
  UCD7: '9300749',
  UCD13: '3400893007495',
  ucdQtyMultiplicator: 24,
  cipLib: "RIAMET 20MG/120MG CPR BT 24",
  atcCode: "P01BF01"
}, {
  CIP7: '3004889',
  CIP13: '3400930048894',
  ucdLib: "FANSIDAR CPR",
  UCD7: '9034325',
  UCD13: '3400890343251',
  ucdQtyMultiplicator: 3,
  cipLib: "FANSIDAR CPR BT 3",
  atcCode: "P01BD51"
}, {
  CIP7: '3064578',
  CIP13: '3400930645789',
  ucdLib: "MALOCIDE 50MG CPR",
  UCD7: '9124353',
  UCD13: '3400891243536',
  ucdQtyMultiplicator: 20,
  cipLib: "MALOCIDE 50MG CPR BT 20",
  atcCode: "P01BD01"
}, {
  CIP7: '3396168',
  CIP13: '3400933961688',
  ucdLib: "LARIAM 250MG CPR",
  UCD7: '9106935',
  UCD13: '3400891069358',
  ucdQtyMultiplicator: 8,
  cipLib: "LARIAM 250MG CPR BT 8",
  atcCode: "P01BC02"
}, {
  CIP7: '3088751',
  CIP13: '3400930887516',
  ucdLib: "QUININE C.LFR 224,75MG CPR",
  UCD7: '9077754',
  UCD13: '3400890777544',
  ucdQtyMultiplicator: 20,
  cipLib: "QUININE C.LFR 224,75MG CPR BT 20",
  atcCode: "P01BC01"
}, {
  CIP7: '3088774',
  CIP13: '3400930887745',
  ucdLib: "QUININE C.LFR 449,5MG CPR",
  UCD7: '9077760',
  UCD13: '3400890777605',
  ucdQtyMultiplicator: 20,
  cipLib: "QUININE C.LFR 449,5MG CPR BT 20",
  atcCode: "P01BC01"
}, {
  CIP7: '3436488',
  CIP13: '3400934364884',
  ucdLib: "QUINIMAX 125MG CPR",
  UCD7: '9212815',
  UCD13: '3400892128153',
  ucdQtyMultiplicator: 18,
  cipLib: "QUINIMAX 125MG CPR BT 18",
  atcCode: "P01BC01"
}, {
  CIP7: '3413501',
  CIP13: '3400934135019',
  ucdLib: "QUINIMAX 500MG CPR",
  UCD7: '9194508',
  UCD13: '3400891945089',
  ucdQtyMultiplicator: 9,
  cipLib: "QUINIMAX 500MG CPR BT 9",
  atcCode: "P01BC01"
}, {
  CIP7: '2670911',
  CIP13: '3400926709112',
  ucdLib: "QUINIMAX 500MG INJ AMP4ML",
  UCD7: '9198015',
  UCD13: '3400891980158',
  ucdQtyMultiplicator: 6,
  cipLib: "QUINIMAX 500MG INJ AMP4ML BT 6",
  atcCode: "P01BC01"
}, {
  CIP7: '3427213',
  CIP13: '3400934272134',
  ucdLib: "QUINIMAX 125MG INJ AMP1ML",
  UCD7: '9197990',
  UCD13: '3400891979909',
  ucdQtyMultiplicator: 3,
  cipLib: "QUINIMAX 125MG INJ AMP1ML BT 3",
  atcCode: "P01BC01"
}, {
  CIP7: '3427242',
  CIP13: '3400934272424',
  ucdLib: "QUINIMAX 250MG INJ AMP2ML",
  UCD7: '9198009',
  UCD13: '3400891980097',
  ucdQtyMultiplicator: 3,
  cipLib: "QUINIMAX 250MG INJ AMP2ML BT 3",
  atcCode: "P01BC01"
}, {
  CIP7: '3622647',
  CIP13: '3400936226470',
  ucdLib: "MALARONE 62,5/25MG ENF CPR",
  UCD7: '9249675',
  UCD13: '3400892496757',
  ucdQtyMultiplicator: 12,
  cipLib: "MALARONE 62,5/25MG ENF CPR BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '3412795',
  CIP13: '3400934127953',
  ucdLib: "SAVARINE CPR",
  UCD7: '9182250',
  UCD13: '3400891822502',
  ucdQtyMultiplicator: 28,
  cipLib: "SAVARINE CPR BT 28",
  atcCode: "P01BB51"
}, {
  CIP7: '3442980',
  CIP13: '3400934429804',
  ucdLib: "MALARONE 250MG/100MG CPR",
  UCD7: '9199115',
  UCD13: '3400891991154',
  ucdQtyMultiplicator: 12,
  cipLib: "MALARONE 250MG/100MG CPR BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '2749009',
  CIP13: '3400927490095',
  ucdLib: "ATOVAQ/PROGUAN.BGA 250/100 C",
  UCD7: '9397571',
  UCD13: '3400893975718',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.BGA 250/100 C BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '2748990',
  CIP13: '3400927489907',
  ucdLib: "ATOVAQ/PROGUAN.BGA 62,5/25 C",
  UCD7: '9397588',
  UCD13: '3400893975886',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.BGA 62,5/25 C BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '2750047',
  CIP13: '3400927500473',
  ucdLib: "ATOVAQ/PROGUAN.TVC 250/100 C",
  UCD7: '9406287',
  UCD13: '3400894062875',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.TVC 250/100 C BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '2750030',
  CIP13: '3400927500305',
  ucdLib: "ATOVAQ/PROGUAN.TVC 62,5/25 C",
  UCD7: '9406293',
  UCD13: '3400894062936',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.TVC 62,5/25 C BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '2748984',
  CIP13: '3400927489846',
  ucdLib: "ATOVAQ/PROGUAN.ZEN 250/100 C",
  UCD7: '9397594',
  UCD13: '3400893975947',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.ZEN 250/100 C BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '2748978',
  CIP13: '3400927489785',
  ucdLib: "ATOVAQ/PROGUAN.ZEN 62,5/25 C",
  UCD7: '9397602',
  UCD13: '3400893976029',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.ZEN 62,5/25 C BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '2247319',
  CIP13: '3400922473192',
  ucdLib: "ATOVAQ/PROGUAN.EG 250/100 CP",
  UCD7: '9397803',
  UCD13: '3400893978030',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.EG 250/100 CP BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '2674429',
  CIP13: '3400926744298',
  ucdLib: "ATOVAQ/PROGUAN.MYL 250/100",
  UCD7: '9395595',
  UCD13: '3400893955956',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.MYL 250/100 BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '4966886',
  CIP13: '3400949668861',
  ucdLib: "ATOVAQ/PROGUAN.SGT 250/100 C",
  UCD7: '9369586',
  UCD13: '3400893695869',
  ucdQtyMultiplicator: 12,
  cipLib: "ATOVAQ/PROGUAN.SGT 250/100 C BT 12",
  atcCode: "P01BB51"
}, {
  CIP7: '3320981',
  CIP13: '3400933209810',
  ucdLib: "PALUDRINE 100MG CPR",
  UCD7: '9140493',
  UCD13: '3400891404937',
  ucdQtyMultiplicator: 56,
  cipLib: "PALUDRINE 100MG CPR BT 56",
  atcCode: "P01BB01"
}, {
  CIP7: '3254445',
  CIP13: '3400932544455',
  ucdLib: "NIVAQUINE SIR FL150ML",
  UCD7: '9063195',
  UCD13: '3400890631952',
  ucdQtyMultiplicator: 1,
  cipLib: "NIVAQUINE SIR FL150ML BT 1",
  atcCode: "P01BA01"
}, {
  CIP7: '3073100',
  CIP13: '3400930731000',
  ucdLib: "NIVAQUINE 100MG CPR",
  UCD7: '9063189',
  UCD13: '3400890631891',
  ucdQtyMultiplicator: 100,
  cipLib: "NIVAQUINE 100MG CPR BT 100",
  atcCode: "P01BA01"
}, {
  CIP7: '3073117',
  CIP13: '3400930731178',
  ucdLib: "NIVAQUINE 100MG CPR",
  UCD7: '9063189',
  UCD13: '3400890631891',
  ucdQtyMultiplicator: 20,
  cipLib: "NIVAQUINE 100MG CPR BT 20",
  atcCode: "P01BA01"
}, {
  CIP7: '5676653',
  CIP13: '3400956766536',
  ucdLib: "FLISINT 20MG GELU",
  UCD7: '9287256',
  UCD13: '3400892872568',
  ucdQtyMultiplicator: 42,
  cipLib: "FLISINT 20MG GELU BT 42",
  atcCode: "P01AX10"
}, {
  CIP7: '3418970',
  CIP13: '3400934189708',
  ucdLib: "ATRICAN 250MG CAPS",
  UCD7: '9196708',
  UCD13: '3400891967081',
  ucdQtyMultiplicator: 8,
  cipLib: "ATRICAN 250MG CAPS BT 8",
  atcCode: "P01AX08"
}, {
  CIP7: '3657278',
  CIP13: '3400936572782',
  ucdLib: "WELLVONE 750MG/5ML BUV FL226ML",
  UCD7: '9186348',
  UCD13: '3400891863482',
  ucdQtyMultiplicator: 1,
  cipLib: "WELLVONE 750MG/5ML BUV FL226ML BT 1",
  atcCode: "P01AX06"
}, {
  CIP7: '3337071',
  CIP13: '3400933370718',
  ucdLib: "SECNOL 2G GLE SACH DOS",
  UCD7: '9157660',
  UCD13: '3400891576603',
  ucdQtyMultiplicator: 1,
  cipLib: "SECNOL 2G GLE SACH DOS BT 1",
  atcCode: "P01AB07"
}, {
  CIP7: '3053534',
  CIP13: '3400930535349',
  ucdLib: "INTETRIX GELU",
  UCD7: '9046920',
  UCD13: '3400890469203',
  ucdQtyMultiplicator: 20,
  cipLib: "INTETRIX GELU BT 20",
  atcCode: "P01AA05"
}, {
  CIP7: '3004329',
  CIP13: '3400930043295',
  ucdLib: "WAKIX 18MG CPR PELLIC",
  UCD7: '9416699',
  UCD13: '3400894166993',
  ucdQtyMultiplicator: 30,
  cipLib: "WAKIX 18MG CPR PELLIC BT 30",
  atcCode: "N07XX11"
}, {
  CIP7: '3004328',
  CIP13: '3400930043288',
  ucdLib: "WAKIX 4,5MG CPR PELLIC",
  UCD7: '9416707',
  UCD13: '3400894167075',
  ucdQtyMultiplicator: 30,
  cipLib: "WAKIX 4,5MG CPR PELLIC BT 30",
  atcCode: "N07XX11"
}, {
  CIP7: '2749788',
  CIP13: '3400927497889',
  ucdLib: "TECFIDERA 120MG GELU",
  UCD7: '9399357',
  UCD13: '3400893993576',
  ucdQtyMultiplicator: 14,
  cipLib: "TECFIDERA 120MG GELU BT 14",
  atcCode: "N07XX09"
}, {
  CIP7: '2749794',
  CIP13: '3400927497940',
  ucdLib: "TECFIDERA 240MG GELU",
  UCD7: '9399363',
  UCD13: '3400893993637',
  ucdQtyMultiplicator: 56,
  cipLib: "TECFIDERA 240MG GELU BT 56",
  atcCode: "N07XX09"
}, {
  CIP7: '2182459',
  CIP13: '3400921824599',
  ucdLib: "VYNDAQEL 20MG CAPS MOL",
  UCD7: '9380837',
  UCD13: '3400893808375',
  ucdQtyMultiplicator: 30,
  cipLib: "VYNDAQEL 20MG CAPS MOL BT 30",
  atcCode: "N07XX08"
}, {
  CIP7: '2193954',
  CIP13: '3400921939545',
  ucdLib: "FAMPYRA 10MG CPR LP",
  UCD7: '9391924',
  UCD13: '3400893919248',
  ucdQtyMultiplicator: 28,
  cipLib: "FAMPYRA 10MG CPR LP BT 28",
  atcCode: "N07XX07"
}, {
  CIP7: '2193960',
  CIP13: '3400921939606',
  ucdLib: "FAMPYRA 10MG CPR LP",
  UCD7: '9391924',
  UCD13: '3400893919248',
  ucdQtyMultiplicator: 56,
  cipLib: "FAMPYRA 10MG CPR LP BT 56",
  atcCode: "N07XX07"
}, {
  CIP7: '3693191',
  CIP13: '3400936931916',
  ucdLib: "XENAZINE 25MG CPR",
  UCD7: '9278234',
  UCD13: '3400892782348',
  ucdQtyMultiplicator: 112,
  cipLib: "XENAZINE 25MG CPR BT 112",
  atcCode: "N07XX06"
}, {
  CIP7: '4993127',
  CIP13: '3400949931279',
  ucdLib: "TETMODIS 25MG CPR",
  UCD7: '9375629',
  UCD13: '3400893756294',
  ucdQtyMultiplicator: 112,
  cipLib: "TETMODIS 25MG CPR BT 112",
  atcCode: "N07XX06"
}, {
  CIP7: '3471556',
  CIP13: '3400934715563',
  ucdLib: "FIRDAPSE 10MG CPR",
  UCD7: '9350569',
  UCD13: '3400893505694',
  ucdQtyMultiplicator: 100,
  cipLib: "FIRDAPSE 10MG CPR BT 100",
  atcCode: "N07XX05"
}, {
  CIP7: '3702352',
  CIP13: '3400937023528',
  ucdLib: "XYREM 500MG/ML BUV FP180ML",
  UCD7: '9281199',
  UCD13: '3400892811994',
  ucdQtyMultiplicator: 1,
  cipLib: "XYREM 500MG/ML BUV FP180ML BT 1",
  atcCode: "N07XX04"
}, {
  CIP7: '3416468',
  CIP13: '3400934164682',
  ucdLib: "RILUTEK 50MG CPR",
  UCD7: '9186294',
  UCD13: '3400891862942',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUTEK 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '3462758',
  CIP13: '3400934627583',
  ucdLib: "RILUZOLE BGA 50MG CPR",
  UCD7: '9349773',
  UCD13: '3400893497739',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUZOLE BGA 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '4950005',
  CIP13: '3400949500055',
  ucdLib: "RILUTEK 50MG CPR ADP BBA",
  UCD7: '9408808',
  UCD13: '3400894088080',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUTEK 50MG CPR ADP BBA BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '3934938',
  CIP13: '3400939349381',
  ucdLib: "RILUZOLE ARW 50MG CPR",
  UCD7: '9339935',
  UCD13: '3400893399354',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUZOLE ARW 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '4991335',
  CIP13: '3400949913350',
  ucdLib: "RILUZOLE EG 50MG CPR",
  UCD7: '9376391',
  UCD13: '3400893763919',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUZOLE EG 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '4991246',
  CIP13: '3400949912469',
  ucdLib: "RILUZOLE TVC 50MG CPR",
  UCD7: '9388632',
  UCD13: '3400893886328',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUZOLE TVC 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '2756601',
  CIP13: '3400927566011',
  ucdLib: "TEGLUTIK 5MG/ML BUV FL300ML",
  UCD7: '9416593',
  UCD13: '3400894165934',
  ucdQtyMultiplicator: 1,
  cipLib: "TEGLUTIK 5MG/ML BUV FL300ML BT 1",
  atcCode: "N07XX02"
}, {
  CIP7: '2200884',
  CIP13: '3400922008844',
  ucdLib: "RILUZOLE MYL 50MG CPR",
  UCD7: '9383824',
  UCD13: '3400893838242',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUZOLE MYL 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '2183921',
  CIP13: '3400921839210',
  ucdLib: "RILUZOLE PMCS 50MG CPR",
  UCD7: '9398576',
  UCD13: '3400893985762',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUZOLE PMCS 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '2177702',
  CIP13: '3400921777024',
  ucdLib: "RILUZOLE SDZ 50MG CPR",
  UCD7: '9385510',
  UCD13: '3400893855102',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUZOLE SDZ 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '2242500',
  CIP13: '3400922425009',
  ucdLib: "RILUZOLE ZEN 50MG CPR",
  UCD7: '9388649',
  UCD13: '3400893886496',
  ucdQtyMultiplicator: 56,
  cipLib: "RILUZOLE ZEN 50MG CPR BT 56",
  atcCode: "N07XX02"
}, {
  CIP7: '3272259',
  CIP13: '3400932722594',
  ucdLib: "TANGANIL 500MG INJ AMP5ML",
  UCD7: '9090476',
  UCD13: '3400890904766',
  ucdQtyMultiplicator: 5,
  cipLib: "TANGANIL 500MG INJ AMP5ML BT 5",
  atcCode: "N07CA04"
}, {
  CIP7: '3384573',
  CIP13: '3400933845735',
  ucdLib: "TANGANILPRO 500MG CPR",
  UCD7: '9090482',
  UCD13: '3400890904827',
  ucdQtyMultiplicator: 30,
  cipLib: "TANGANILPRO 500MG CPR BT 30",
  atcCode: "N07CA04"
}, {
  CIP7: '3384604',
  CIP13: '3400933846046',
  ucdLib: "TANGANILPRO 500MG CPR",
  UCD7: '9090482',
  UCD13: '3400890904827',
  ucdQtyMultiplicator: 60,
  cipLib: "TANGANILPRO 500MG CPR BT 60",
  atcCode: "N07CA04"
}, {
  CIP7: '4199286',
  CIP13: '3400941992865',
  ucdLib: "ACETYLLEUCINE MYL 500MG CPR",
  UCD7: '9380352',
  UCD13: '3400893803523',
  ucdQtyMultiplicator: 30,
  cipLib: "ACETYLLEUCINE MYL 500MG CPR BT 30",
  atcCode: "N07CA04"
}, {
  CIP7: '2740020',
  CIP13: '3400927400209',
  ucdLib: "TANGANIL 500MG CPR",
  UCD7: '9394897',
  UCD13: '3400893948972',
  ucdQtyMultiplicator: 30,
  cipLib: "TANGANIL 500MG CPR BT 30",
  atcCode: "N07CA04"
}, {
  CIP7: '2740103',
  CIP13: '3400927401039',
  ucdLib: "TANGANIL 500MG CPR",
  UCD7: '9394897',
  UCD13: '3400893948972',
  ucdQtyMultiplicator: 60,
  cipLib: "TANGANIL 500MG CPR BT 60",
  atcCode: "N07CA04"
}, {
  CIP7: '4182558',
  CIP13: '3400941825583',
  ucdLib: "ACETYLLEUCINE BGA 500MG CPR",
  UCD7: '9377829',
  UCD13: '3400893778296',
  ucdQtyMultiplicator: 30,
  cipLib: "ACETYLLEUCINE BGA 500MG CPR BT 30",
  atcCode: "N07CA04"
}, {
  CIP7: '2208673',
  CIP13: '3400922086736',
  ucdLib: "ACETYLLEUCINE TVC 500MG CPR",
  UCD7: '9383600',
  UCD13: '3400893836002',
  ucdQtyMultiplicator: 30,
  cipLib: "ACETYLLEUCINE TVC 500MG CPR BT 30",
  atcCode: "N07CA04"
}, {
  CIP7: '4182564',
  CIP13: '3400941825644',
  ucdLib: "ACETYLLEUCINE ZEN 500MG CPR",
  UCD7: '9380228',
  UCD13: '3400893802281',
  ucdQtyMultiplicator: 30,
  cipLib: "ACETYLLEUCINE ZEN 500MG CPR BT 30",
  atcCode: "N07CA04"
}, {
  CIP7: '3282944',
  CIP13: '3400932829446',
  ucdLib: "SIBELIUM 10MG CPR SECAB",
  UCD7: '9105924',
  UCD13: '3400891059243',
  ucdQtyMultiplicator: 30,
  cipLib: "SIBELIUM 10MG CPR SECAB BT 30",
  atcCode: "N07CA03"
}, {
  CIP7: '3833999',
  CIP13: '3400938339994',
  ucdLib: "BETAHISTINE ARW 24MG CPR",
  UCD7: '9311718',
  UCD13: '3400893117187',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE ARW 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3834065',
  CIP13: '3400938340655',
  ucdLib: "BETAHISTINE BGA 24MG CPR",
  UCD7: '9313410',
  UCD13: '3400893134108',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE BGA 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3834102',
  CIP13: '3400938341027',
  ucdLib: "BETAHISTINE EG 24MG CPR",
  UCD7: '9313427',
  UCD13: '3400893134276',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE EG 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3834148',
  CIP13: '3400938341485',
  ucdLib: "BETAHISTINE RBX 24MG CPR",
  UCD7: '9311724',
  UCD13: '3400893117248',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE RBX 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3833901',
  CIP13: '3400938339017',
  ucdLib: "BETAHISTINE SDZ 24MG CPR",
  UCD7: '9313479',
  UCD13: '3400893134795',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE SDZ 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3833829',
  CIP13: '3400938338294',
  ucdLib: "BETAHISTINE TVC 24MG CPR",
  UCD7: '9311405',
  UCD13: '3400893114056',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE TVC 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3833947',
  CIP13: '3400938339475',
  ucdLib: "BETAHISTINE ZEN 24MG CPR",
  UCD7: '9313404',
  UCD13: '3400893134047',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE ZEN 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3610199',
  CIP13: '3400936101999',
  ucdLib: "LECTIL 24MG CPR",
  UCD7: '9260642',
  UCD13: '3400892606422',
  ucdQtyMultiplicator: 60,
  cipLib: "LECTIL 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3225099',
  CIP13: '3400932250998',
  ucdLib: "EXTOVYL GELU",
  UCD7: '9034213',
  UCD13: '3400890342131',
  ucdQtyMultiplicator: 60,
  cipLib: "EXTOVYL GELU BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3528463',
  CIP13: '3400935284631',
  ucdLib: "BETAHISTINE ZYD 8MG CPR",
  UCD7: '9222771',
  UCD13: '3400892227719',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE ZYD 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3520823',
  CIP13: '3400935208231',
  ucdLib: "LECTIL 16MG CPR",
  UCD7: '9213393',
  UCD13: '3400892133935',
  ucdQtyMultiplicator: 45,
  cipLib: "LECTIL 16MG CPR BT 45",
  atcCode: "N07CA01"
}, {
  CIP7: '3674331',
  CIP13: '3400936743311',
  ucdLib: "BETAHISTINE ZEN 8MG CPR",
  UCD7: '9269784',
  UCD13: '3400892697840',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE ZEN 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3556471',
  CIP13: '3400935564719',
  ucdLib: "BETASERC 24MG CPR",
  UCD7: '9233071',
  UCD13: '3400892330716',
  ucdQtyMultiplicator: 60,
  cipLib: "BETASERC 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '3553975',
  CIP13: '3400935539755',
  ucdLib: "SERC 8MG CPR",
  UCD7: '9083683',
  UCD13: '3400890836838',
  ucdQtyMultiplicator: 90,
  cipLib: "SERC 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3514886',
  CIP13: '3400935148865',
  ucdLib: "BETAHISTINE BCR 8MG CPR",
  UCD7: '9363218',
  UCD13: '3400893632185',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAHISTINE BCR 8MG CPR BT 30",
  atcCode: "N07CA01"
}, {
  CIP7: '3514900',
  CIP13: '3400935149008',
  ucdLib: "BETAHISTINE BCR 8MG CPR",
  UCD7: '9363218',
  UCD13: '3400893632185',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE BCR 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3488947',
  CIP13: '3400934889479',
  ucdLib: "BETAHISTINE BIP 8MG CPR",
  UCD7: '9211069',
  UCD13: '3400892110691',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE BIP 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3477292',
  CIP13: '3400934772924',
  ucdLib: "BETAHISTINE MYL 8MG CPR",
  UCD7: '9206329',
  UCD13: '3400892063294',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE MYL 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3865628',
  CIP13: '3400938656282',
  ucdLib: "BETAHISTINE EG 8MG CPR",
  UCD7: '9356678',
  UCD13: '3400893566787',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAHISTINE EG 8MG CPR BT 30",
  atcCode: "N07CA01"
}, {
  CIP7: '3865953',
  CIP13: '3400938659535',
  ucdLib: "BETAHISTINE EG 8MG CPR",
  UCD7: '9356678',
  UCD13: '3400893566787',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE EG 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3506705',
  CIP13: '3400935067050',
  ucdLib: "BETAHISTINE BGA 8MG CPR",
  UCD7: '9213370',
  UCD13: '3400892133706',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAHISTINE BGA 8MG CPR BT 30",
  atcCode: "N07CA01"
}, {
  CIP7: '3506711',
  CIP13: '3400935067111',
  ucdLib: "BETAHISTINE BGA 8MG CPR",
  UCD7: '9213370',
  UCD13: '3400892133706',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE BGA 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3848831',
  CIP13: '3400938488319',
  ucdLib: "BETAHISTINE MYL 24MG CPR",
  UCD7: '9313433',
  UCD13: '3400893134337',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE MYL 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '4175021',
  CIP13: '3400941750212',
  ucdLib: "BETAHISTINE ARW 8MG CPR",
  UCD7: '9373518',
  UCD13: '3400893735183',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAHISTINE ARW 8MG CPR BT 30",
  atcCode: "N07CA01"
}, {
  CIP7: '4175044',
  CIP13: '3400941750441',
  ucdLib: "BETAHISTINE ARW 8MG CPR",
  UCD7: '9373518',
  UCD13: '3400893735183',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE ARW 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '2203285',
  CIP13: '3400922032856',
  ucdLib: "BETAHISTINE ACC 8MG CPR",
  UCD7: '9380978',
  UCD13: '3400893809785',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAHISTINE ACC 8MG CPR BT 30",
  atcCode: "N07CA01"
}, {
  CIP7: '4189856',
  CIP13: '3400941898563',
  ucdLib: "BETAHISTINE BIP 24MG CPR",
  UCD7: '9240332',
  UCD13: '3400892403328',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE BIP 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '2780189',
  CIP13: '3400927801891',
  ucdLib: "BETAHISTINE ZYF 24MG CPR",
  UCD7: '9401887',
  UCD13: '3400894018872',
  ucdQtyMultiplicator: 60,
  cipLib: "BETAHISTINE ZYF 24MG CPR BT 60",
  atcCode: "N07CA01"
}, {
  CIP7: '2780166',
  CIP13: '3400927801662',
  ucdLib: "BETAHISTINE ZYF 8MG CPR",
  UCD7: '9401893',
  UCD13: '3400894018933',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAHISTINE ZYF 8MG CPR BT 90",
  atcCode: "N07CA01"
}, {
  CIP7: '3776132',
  CIP13: '3400937761321',
  ucdLib: "SUBOXONE 2MG/0,5MG CPR",
  UCD7: '9317483',
  UCD13: '3400893174838',
  ucdQtyMultiplicator: 7,
  cipLib: "SUBOXONE 2MG/0,5MG CPR BT 7",
  atcCode: "N07BC51"
}, {
  CIP7: '3776149',
  CIP13: '3400937761499',
  ucdLib: "SUBOXONE 2MG/0,5MG CPR",
  UCD7: '9317483',
  UCD13: '3400893174838',
  ucdQtyMultiplicator: 28,
  cipLib: "SUBOXONE 2MG/0,5MG CPR BT 28",
  atcCode: "N07BC51"
}, {
  CIP7: '3776155',
  CIP13: '3400937761550',
  ucdLib: "SUBOXONE 8MG/2MG CPR",
  UCD7: '9317508',
  UCD13: '3400893175088',
  ucdQtyMultiplicator: 7,
  cipLib: "SUBOXONE 8MG/2MG CPR BT 7",
  atcCode: "N07BC51"
}, {
  CIP7: '3776161',
  CIP13: '3400937761611',
  ucdLib: "SUBOXONE 8MG/2MG CPR",
  UCD7: '9317508',
  UCD13: '3400893175088',
  ucdQtyMultiplicator: 28,
  cipLib: "SUBOXONE 8MG/2MG CPR BT 28",
  atcCode: "N07BC51"
}, {
  CIP7: '3400415',
  CIP13: '3400934004155',
  ucdLib: "METHADONE AP-HP 40MG/15ML DOS",
  UCD7: '9178455',
  UCD13: '3400891784558',
  ucdQtyMultiplicator: 1,
  cipLib: "METHADONE AP-HP 40MG/15ML DOS BT 1",
  atcCode: "N07BC02"
}, {
  CIP7: '3400421',
  CIP13: '3400934004216',
  ucdLib: "METHADONE AP-HP 60MG/15ML DOS",
  UCD7: '9178461',
  UCD13: '3400891784619',
  ucdQtyMultiplicator: 1,
  cipLib: "METHADONE AP-HP 60MG/15ML DOS BT 1",
  atcCode: "N07BC02"
}, {
  CIP7: '3531979',
  CIP13: '3400935319791',
  ucdLib: "METHADONE AP-HP SIR FUT 5L",
  UCD7: '9231652',
  UCD13: '3400892316529',
  ucdQtyMultiplicator: 1,
  cipLib: "METHADONE AP-HP SIR FUT 5L BT 1",
  atcCode: "N07BC02"
}, {
  CIP7: '3389435',
  CIP13: '3400933894351',
  ucdLib: "METHADONE AP-HP 10MG/7,5ML D.",
  UCD7: '9171559',
  UCD13: '3400891715590',
  ucdQtyMultiplicator: 1,
  cipLib: "METHADONE AP-HP 10MG/7,5ML D. BT 1",
  atcCode: "N07BC02"
}, {
  CIP7: '3389441',
  CIP13: '3400933894412',
  ucdLib: "METHADONE AP-HP 20MG/15ML DOS",
  UCD7: '9171565',
  UCD13: '3400891715651',
  ucdQtyMultiplicator: 1,
  cipLib: "METHADONE AP-HP 20MG/15ML DOS BT 1",
  atcCode: "N07BC02"
}, {
  CIP7: '3389458',
  CIP13: '3400933894580',
  ucdLib: "METHADONE AP-HP 5MG/3,75ML D.",
  UCD7: '9171571',
  UCD13: '3400891715712',
  ucdQtyMultiplicator: 1,
  cipLib: "METHADONE AP-HP 5MG/3,75ML D. BT 1",
  atcCode: "N07BC02"
}, {
  CIP7: '3791485',
  CIP13: '3400937914857',
  ucdLib: "METHADONE AP-HP 10MG GELU",
  UCD7: '9310156',
  UCD13: '3400893101568',
  ucdQtyMultiplicator: 7,
  cipLib: "METHADONE AP-HP 10MG GELU BT 7",
  atcCode: "N07BC02"
}, {
  CIP7: '3791462',
  CIP13: '3400937914628',
  ucdLib: "METHADONE AP-HP 1MG GELU",
  UCD7: '9310133',
  UCD13: '3400893101339',
  ucdQtyMultiplicator: 7,
  cipLib: "METHADONE AP-HP 1MG GELU BT 7",
  atcCode: "N07BC02"
}, {
  CIP7: '3791491',
  CIP13: '3400937914918',
  ucdLib: "METHADONE AP-HP 20MG GELU",
  UCD7: '9310162',
  UCD13: '3400893101629',
  ucdQtyMultiplicator: 7,
  cipLib: "METHADONE AP-HP 20MG GELU BT 7",
  atcCode: "N07BC02"
}, {
  CIP7: '3791479',
  CIP13: '3400937914796',
  ucdLib: "METHADONE AP-HP 5MG GELU",
  UCD7: '9310185',
  UCD13: '3400893101858',
  ucdQtyMultiplicator: 7,
  cipLib: "METHADONE AP-HP 5MG GELU BT 7",
  atcCode: "N07BC02"
}, {
  CIP7: '3805081',
  CIP13: '3400938050813',
  ucdLib: "METHADONE AP-HP 40MG GELU",
  UCD7: '9310179',
  UCD13: '3400893101797',
  ucdQtyMultiplicator: 7,
  cipLib: "METHADONE AP-HP 40MG GELU BT 7",
  atcCode: "N07BC02"
}, {
  CIP7: '3394442',
  CIP13: '3400933944421',
  ucdLib: "SUBUTEX 0,4MG CPR SUBLING",
  UCD7: '9178515',
  UCD13: '3400891785159',
  ucdQtyMultiplicator: 7,
  cipLib: "SUBUTEX 0,4MG CPR SUBLING BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3395140',
  CIP13: '3400933951405',
  ucdLib: "SUBUTEX 2MG CPR SUBLING",
  UCD7: '9178521',
  UCD13: '3400891785210',
  ucdQtyMultiplicator: 7,
  cipLib: "SUBUTEX 2MG CPR SUBLING BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3394399',
  CIP13: '3400933943998',
  ucdLib: "SUBUTEX 8MG CPR SUBLING",
  UCD7: '9178538',
  UCD13: '3400891785388',
  ucdQtyMultiplicator: 7,
  cipLib: "SUBUTEX 8MG CPR SUBLING BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3705043',
  CIP13: '3400937050432',
  ucdLib: "BUPRENORPHINE MYL 0,4MG CPR",
  UCD7: '9290117',
  UCD13: '3400892901176',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE MYL 0,4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3704977',
  CIP13: '3400937049771',
  ucdLib: "BUPRENORPHINE MYL 8MG CPR",
  UCD7: '9290169',
  UCD13: '3400892901695',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE MYL 8MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3819746',
  CIP13: '3400938197464',
  ucdLib: "BUPRENORPHINE ARW 1MG CPR",
  UCD7: '9318927',
  UCD13: '3400893189276',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE ARW 1MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3819769',
  CIP13: '3400938197693',
  ucdLib: "BUPRENORPHINE ARW 4MG CPR",
  UCD7: '9318933',
  UCD13: '3400893189337',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE ARW 4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3819781',
  CIP13: '3400938197815',
  ucdLib: "BUPRENORPHINE ARW 6MG CPR",
  UCD7: '9318956',
  UCD13: '3400893189566',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE ARW 6MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3746421',
  CIP13: '3400937464215',
  ucdLib: "BUPRENORPHINE MYL 2MG CPR",
  UCD7: '9290152',
  UCD13: '3400892901527',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE MYL 2MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3715691',
  CIP13: '3400937156912',
  ucdLib: "BUPRENORPHINE ARW 0,4MG CPR",
  UCD7: '9282833',
  UCD13: '3400892828336',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE ARW 0,4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3716271',
  CIP13: '3400937162715',
  ucdLib: "BUPRENORPHINE ARW 2MG CPR",
  UCD7: '9282856',
  UCD13: '3400892828565',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE ARW 2MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3715722',
  CIP13: '3400937157223',
  ucdLib: "BUPRENORPHINE ARW 8MG CPR",
  UCD7: '9282862',
  UCD13: '3400892828626',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE ARW 8MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3820086',
  CIP13: '3400938200867',
  ucdLib: "BUPRENORPHINE MYL 1MG CPR",
  UCD7: '9323578',
  UCD13: '3400893235782',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE MYL 1MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3820100',
  CIP13: '3400938201000',
  ucdLib: "BUPRENORPHINE MYL 4MG CPR",
  UCD7: '9323584',
  UCD13: '3400893235843',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE MYL 4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3820123',
  CIP13: '3400938201239',
  ucdLib: "BUPRENORPHINE MYL 6MG CPR",
  UCD7: '9323590',
  UCD13: '3400893235904',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE MYL 6MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887015',
  CIP13: '3400938870152',
  ucdLib: "BUPRENORPHINE BGA 0,4MG CPR",
  UCD7: '9329842',
  UCD13: '3400893298428',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE BGA 0,4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887127',
  CIP13: '3400938871272',
  ucdLib: "BUPRENORPHINE BGA 2MG CPR",
  UCD7: '9329859',
  UCD13: '3400893298596',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE BGA 2MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887357',
  CIP13: '3400938873573',
  ucdLib: "BUPRENORPHINE BGA 8MG CPR",
  UCD7: '9329865',
  UCD13: '3400893298657',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE BGA 8MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887050',
  CIP13: '3400938870503',
  ucdLib: "BUPRENORPHINE SDZ 0,4MG CPR",
  UCD7: '9329807',
  UCD13: '3400893298077',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE SDZ 0,4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887156',
  CIP13: '3400938871562',
  ucdLib: "BUPRENORPHINE SDZ 2MG CPR",
  UCD7: '9329813',
  UCD13: '3400893298138',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE SDZ 2MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887423',
  CIP13: '3400938874235',
  ucdLib: "BUPRENORPHINE SDZ 8MG CPR",
  UCD7: '9329836',
  UCD13: '3400893298367',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE SDZ 8MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887038',
  CIP13: '3400938870381',
  ucdLib: "BUPRENORPHINE TVC 0,4MG CPR",
  UCD7: '9331514',
  UCD13: '3400893315149',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE TVC 0,4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887104',
  CIP13: '3400938871043',
  ucdLib: "BUPRENORPHINE TVC 2MG CPR",
  UCD7: '9329902',
  UCD13: '3400893299029',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE TVC 2MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3887386',
  CIP13: '3400938873863',
  ucdLib: "BUPRENORPHINE TVC 8MG CPR",
  UCD7: '9329919',
  UCD13: '3400893299197',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE TVC 8MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3897031',
  CIP13: '3400938970319',
  ucdLib: "BUPRENORPHINE SDZ 1MG CPR",
  UCD7: '9338462',
  UCD13: '3400893384626',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE SDZ 1MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3897077',
  CIP13: '3400938970777',
  ucdLib: "BUPRENORPHINE SDZ 4MG CPR",
  UCD7: '9338479',
  UCD13: '3400893384794',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE SDZ 4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3897120',
  CIP13: '3400938971200',
  ucdLib: "BUPRENORPHINE SDZ 6MG CPR",
  UCD7: '9338485',
  UCD13: '3400893384855',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE SDZ 6MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '4993587',
  CIP13: '3400949935871',
  ucdLib: "BUPRENORPHINE EG 2MG CPR",
  UCD7: '9370477',
  UCD13: '3400893704776',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE EG 2MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '4993742',
  CIP13: '3400949937424',
  ucdLib: "BUPRENORPHINE EG 8MG CPR",
  UCD7: '9370483',
  UCD13: '3400893704837',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE EG 8MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '2241593',
  CIP13: '3400922415932',
  ucdLib: "BUPRENORPHINE EG 0,4MG CPR",
  UCD7: '9396034',
  UCD13: '3400893960349',
  ucdQtyMultiplicator: 7,
  cipLib: "BUPRENORPHINE EG 0,4MG CPR BT 7",
  atcCode: "N07BC01"
}, {
  CIP7: '3000826',
  CIP13: '3400930008263',
  ucdLib: "SELINCRO 18MG CPR ETUI",
  UCD7: '9411615',
  UCD13: '3400894116158',
  ucdQtyMultiplicator: 14,
  cipLib: "SELINCRO 18MG CPR ETUI BT 14",
  atcCode: "N07BB05"
}, {
  CIP7: '3675721',
  CIP13: '3400936757219',
  ucdLib: "NALTREXONE MYL 50MG CPR",
  UCD7: '9271189',
  UCD13: '3400892711898',
  ucdQtyMultiplicator: 28,
  cipLib: "NALTREXONE MYL 50MG CPR BT 28",
  atcCode: "N07BB04"
}, {
  CIP7: '3886197',
  CIP13: '3400938861976',
  ucdLib: "NALTREXONE ACC 50MG CPR",
  UCD7: '9355271',
  UCD13: '3400893552711',
  ucdQtyMultiplicator: 28,
  cipLib: "NALTREXONE ACC 50MG CPR BT 28",
  atcCode: "N07BB04"
}, {
  CIP7: '3989721',
  CIP13: '3400939897219',
  ucdLib: "REVIA 50MG CPR",
  UCD7: '9190396',
  UCD13: '3400891903966',
  ucdQtyMultiplicator: 28,
  cipLib: "REVIA 50MG CPR BT 28",
  atcCode: "N07BB04"
}, {
  CIP7: '3297615',
  CIP13: '3400932976157',
  ucdLib: "AOTAL 333MG CPR",
  UCD7: '9132915',
  UCD13: '3400891329155',
  ucdQtyMultiplicator: 60,
  cipLib: "AOTAL 333MG CPR BT 60",
  atcCode: "N07BB03"
}, {
  CIP7: '2760778',
  CIP13: '3400927607783',
  ucdLib: "ACAMPROSATE BGA 333MG CPR",
  UCD7: '9401373',
  UCD13: '3400894013730',
  ucdQtyMultiplicator: 60,
  cipLib: "ACAMPROSATE BGA 333MG CPR BT 60",
  atcCode: "N07BB03"
}, {
  CIP7: '2760790',
  CIP13: '3400927607905',
  ucdLib: "ACAMPROSATE BGA 333MG CPR",
  UCD7: '9401373',
  UCD13: '3400894013730',
  ucdQtyMultiplicator: 180,
  cipLib: "ACAMPROSATE BGA 333MG CPR BT 180",
  atcCode: "N07BB03"
}, {
  CIP7: '3751706',
  CIP13: '3400937517065',
  ucdLib: "AOTAL 333MG CPR",
  UCD7: '9132915',
  UCD13: '3400891329155',
  ucdQtyMultiplicator: 180,
  cipLib: "AOTAL 333MG CPR BT 180",
  atcCode: "N07BB03"
}, {
  CIP7: '3037469',
  CIP13: '3400930374696',
  ucdLib: "ESPERAL 500MG CPR",
  UCD7: '9032510',
  UCD13: '3400890325103',
  ucdQtyMultiplicator: 20,
  cipLib: "ESPERAL 500MG CPR BT 20",
  atcCode: "N07BB01"
}, {
  CIP7: '3771844',
  CIP13: '3400937718448',
  ucdLib: "CHAMPIX 0,5MG CPR",
  UCD7: '9295103',
  UCD13: '3400892951034',
  ucdQtyMultiplicator: 56,
  cipLib: "CHAMPIX 0,5MG CPR BT 56",
  atcCode: "N07BA03"
}, {
  CIP7: '2733209',
  CIP13: '3400927332098',
  ucdLib: "CHAMPIX 0,5MG/1MG CPR",
  UCD7: '9297119',
  UCD13: '3400892971193',
  ucdQtyMultiplicator: 25,
  cipLib: "CHAMPIX 0,5MG/1MG CPR BT 25",
  atcCode: "N07BA03"
}, {
  CIP7: '2733161',
  CIP13: '3400927331619',
  ucdLib: "CHAMPIX 1MG CPR",
  UCD7: '9297125',
  UCD13: '3400892971254',
  ucdQtyMultiplicator: 28,
  cipLib: "CHAMPIX 1MG CPR BT 28",
  atcCode: "N07BA03"
}, {
  CIP7: '2733178',
  CIP13: '3400927331787',
  ucdLib: "CHAMPIX 1MG CPR",
  UCD7: '9297125',
  UCD13: '3400892971254',
  ucdQtyMultiplicator: 56,
  cipLib: "CHAMPIX 1MG CPR BT 56",
  atcCode: "N07BA03"
}, {
  CIP7: '3838028',
  CIP13: '3400938380286',
  ucdLib: "NICOPATCH 14MG/24H DISP SACH",
  UCD7: '9331164',
  UCD13: '3400893311646',
  ucdQtyMultiplicator: 7,
  cipLib: "NICOPATCH 14MG/24H DISP SACH BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3838057',
  CIP13: '3400938380576',
  ucdLib: "NICOPATCH 14MG/24H DISP SACH",
  UCD7: '9331164',
  UCD13: '3400893311646',
  ucdQtyMultiplicator: 28,
  cipLib: "NICOPATCH 14MG/24H DISP SACH BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3838063',
  CIP13: '3400938380637',
  ucdLib: "NICOPATCH 21MG/24H DISP SACH",
  UCD7: '9331141',
  UCD13: '3400893311417',
  ucdQtyMultiplicator: 7,
  cipLib: "NICOPATCH 21MG/24H DISP SACH BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3838100',
  CIP13: '3400938381009',
  ucdLib: "NICOPATCH 21MG/24H DISP SACH",
  UCD7: '9331141',
  UCD13: '3400893311417',
  ucdQtyMultiplicator: 28,
  cipLib: "NICOPATCH 21MG/24H DISP SACH BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3837980',
  CIP13: '3400938379808',
  ucdLib: "NICOPATCH 7MG/24H DISP SACH",
  UCD7: '9329256',
  UCD13: '3400893292563',
  ucdQtyMultiplicator: 7,
  cipLib: "NICOPATCH 7MG/24H DISP SACH BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3838011',
  CIP13: '3400938380118',
  ucdLib: "NICOPATCH 7MG/24H DISP SACH",
  UCD7: '9329256',
  UCD13: '3400893292563',
  ucdQtyMultiplicator: 28,
  cipLib: "NICOPATCH 7MG/24H DISP SACH BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3001040',
  CIP13: '3400930010402',
  ucdLib: "NICOPASS 1,5MG S/S MENT PAST",
  UCD7: '9262204',
  UCD13: '3400892622040',
  ucdQtyMultiplicator: 12,
  cipLib: "NICOPASS 1,5MG S/S MENT PAST BT 12",
  atcCode: "N07BA01"
}, {
  CIP7: '3571967',
  CIP13: '3400935719676',
  ucdLib: "NIQUITIN 7MG/24H DISP",
  UCD7: '9213200',
  UCD13: '3400892132006',
  ucdQtyMultiplicator: 28,
  cipLib: "NIQUITIN 7MG/24H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3575238',
  CIP13: '3400935752383',
  ucdLib: "NIQUITIN MENT.DC.2MG S/S CPR",
  UCD7: '9231787',
  UCD13: '3400892317878',
  ucdQtyMultiplicator: 36,
  cipLib: "NIQUITIN MENT.DC.2MG S/S CPR BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '2760979',
  CIP13: '3400927609794',
  ucdLib: "NICORETTE 2MG CPR SUCER",
  UCD7: '9403981',
  UCD13: '3400894039815',
  ucdQtyMultiplicator: 20,
  cipLib: "NICORETTE 2MG CPR SUCER BT 20",
  atcCode: "N07BA01"
}, {
  CIP7: '2760985',
  CIP13: '3400927609855',
  ucdLib: "NICORETTE 2MG CPR SUCER",
  UCD7: '9403981',
  UCD13: '3400894039815',
  ucdQtyMultiplicator: 80,
  cipLib: "NICORETTE 2MG CPR SUCER BT 80",
  atcCode: "N07BA01"
}, {
  CIP7: '3686848',
  CIP13: '3400936868489',
  ucdLib: "NICOTINELL MENT 2MG CPR",
  UCD7: '9294279',
  UCD13: '3400892942797',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINELL MENT 2MG CPR BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3686854',
  CIP13: '3400936868540',
  ucdLib: "NICOTINELL MENT 2MG CPR",
  UCD7: '9294279',
  UCD13: '3400892942797',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOTINELL MENT 2MG CPR BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3346791',
  CIP13: '3400933467913',
  ucdLib: "NICOTINELL TTS 14MG/24H DISP",
  UCD7: '9152579',
  UCD13: '3400891525793',
  ucdQtyMultiplicator: 7,
  cipLib: "NICOTINELL TTS 14MG/24H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3346839',
  CIP13: '3400933468392',
  ucdLib: "NICOTINELL TTS 14MG/24H DISP",
  UCD7: '9152579',
  UCD13: '3400891525793',
  ucdQtyMultiplicator: 28,
  cipLib: "NICOTINELL TTS 14MG/24H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3346845',
  CIP13: '3400933468453',
  ucdLib: "NICOTINELL TTS 21MG/24H DISP",
  UCD7: '9152585',
  UCD13: '3400891525854',
  ucdQtyMultiplicator: 7,
  cipLib: "NICOTINELL TTS 21MG/24H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3346874',
  CIP13: '3400933468743',
  ucdLib: "NICOTINELL TTS 21MG/24H DISP",
  UCD7: '9152585',
  UCD13: '3400891525854',
  ucdQtyMultiplicator: 28,
  cipLib: "NICOTINELL TTS 21MG/24H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3346756',
  CIP13: '3400933467562',
  ucdLib: "NICOTINELL TTS 7MG/24H DISP",
  UCD7: '9152562',
  UCD13: '3400891525625',
  ucdQtyMultiplicator: 7,
  cipLib: "NICOTINELL TTS 7MG/24H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3346785',
  CIP13: '3400933467852',
  ucdLib: "NICOTINELL TTS 7MG/24H DISP",
  UCD7: '9152562',
  UCD13: '3400891525625',
  ucdQtyMultiplicator: 28,
  cipLib: "NICOTINELL TTS 7MG/24H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3483890',
  CIP13: '3400934838903',
  ucdLib: "NICORETTE INHAL 10MG C.+ETUI",
  UCD7: '9218456',
  UCD13: '3400892184562',
  ucdQtyMultiplicator: 6,
  cipLib: "NICORETTE INHAL 10MG C.+ETUI BT 6",
  atcCode: "N07BA01"
}, {
  CIP7: '3483921',
  CIP13: '3400934839214',
  ucdLib: "NICORETTE INHAL 10MG CARTCHE",
  UCD7: '9218433',
  UCD13: '3400892184333',
  ucdQtyMultiplicator: 42,
  cipLib: "NICORETTE INHAL 10MG CARTCHE BT 42",
  atcCode: "N07BA01"
}, {
  CIP7: '3654966',
  CIP13: '3400936549661',
  ucdLib: "NICORETTE MENT F.2MG S/S GOM",
  UCD7: '9267615',
  UCD13: '3400892676159',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORETTE MENT F.2MG S/S GOM BT 30",
  atcCode: "N07BA01"
}, {
  CIP7: '3655049',
  CIP13: '3400936550490',
  ucdLib: "NICORETTE MENT F.4MG S/S GOM",
  UCD7: '9267621',
  UCD13: '3400892676210',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORETTE MENT F.4MG S/S GOM BT 30",
  atcCode: "N07BA01"
}, {
  CIP7: '3596045',
  CIP13: '3400935960450',
  ucdLib: "NIQUITIN MENT.FR.2MG S/S GOM",
  UCD7: '9246375',
  UCD13: '3400892463759',
  ucdQtyMultiplicator: 24,
  cipLib: "NIQUITIN MENT.FR.2MG S/S GOM BT 24",
  atcCode: "N07BA01"
}, {
  CIP7: '3596068',
  CIP13: '3400935960689',
  ucdLib: "NIQUITIN MENT.FR.2MG S/S GOM",
  UCD7: '9246375',
  UCD13: '3400892463759',
  ucdQtyMultiplicator: 96,
  cipLib: "NIQUITIN MENT.FR.2MG S/S GOM BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3596080',
  CIP13: '3400935960801',
  ucdLib: "NIQUITIN MENT.FR.4MG S/S GOM",
  UCD7: '9246381',
  UCD13: '3400892463810',
  ucdQtyMultiplicator: 24,
  cipLib: "NIQUITIN MENT.FR.4MG S/S GOM BT 24",
  atcCode: "N07BA01"
}, {
  CIP7: '3596105',
  CIP13: '3400935961051',
  ucdLib: "NIQUITIN MENT.FR.4MG S/S GOM",
  UCD7: '9246381',
  UCD13: '3400892463810',
  ucdQtyMultiplicator: 96,
  cipLib: "NIQUITIN MENT.FR.4MG S/S GOM BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3709897',
  CIP13: '3400937098977',
  ucdLib: "NICORETTE FRUIT 2MG S/S GM",
  UCD7: '9293222',
  UCD13: '3400892932224',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORETTE FRUIT 2MG S/S GM BT 30",
  atcCode: "N07BA01"
}, {
  CIP7: '3709957',
  CIP13: '3400937099578',
  ucdLib: "NICORETTE FRUIT 2MG S/S GM",
  UCD7: '9293222',
  UCD13: '3400892932224',
  ucdQtyMultiplicator: 105,
  cipLib: "NICORETTE FRUIT 2MG S/S GM BT 105",
  atcCode: "N07BA01"
}, {
  CIP7: '3709621',
  CIP13: '3400937096218',
  ucdLib: "NICORETTE MENT G.2MG S/S GOM",
  UCD7: '9335417',
  UCD13: '3400893354179',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORETTE MENT G.2MG S/S GOM BT 30",
  atcCode: "N07BA01"
}, {
  CIP7: '3709696',
  CIP13: '3400937096966',
  ucdLib: "NICORETTE MENT G.2MG S/S GOM",
  UCD7: '9335417',
  UCD13: '3400893354179',
  ucdQtyMultiplicator: 105,
  cipLib: "NICORETTE MENT G.2MG S/S GOM BT 105",
  atcCode: "N07BA01"
}, {
  CIP7: '3709762',
  CIP13: '3400937097628',
  ucdLib: "NICORETTE MENT G.4MG S/S GOM",
  UCD7: '9335423',
  UCD13: '3400893354230',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORETTE MENT G.4MG S/S GOM BT 30",
  atcCode: "N07BA01"
}, {
  CIP7: '3709839',
  CIP13: '3400937098397',
  ucdLib: "NICORETTE MENT G.4MG S/S GOM",
  UCD7: '9335423',
  UCD13: '3400893354230',
  ucdQtyMultiplicator: 105,
  cipLib: "NICORETTE MENT G.4MG S/S GOM BT 105",
  atcCode: "N07BA01"
}, {
  CIP7: '3701306',
  CIP13: '3400937013062',
  ucdLib: "NIQUITIN MENT.FR.2MG CPR",
  UCD7: '9290560',
  UCD13: '3400892905600',
  ucdQtyMultiplicator: 24,
  cipLib: "NIQUITIN MENT.FR.2MG CPR BT 24",
  atcCode: "N07BA01"
}, {
  CIP7: '3701329',
  CIP13: '3400937013291',
  ucdLib: "NIQUITIN MENT.FR.2MG CPR",
  UCD7: '9290560',
  UCD13: '3400892905600',
  ucdQtyMultiplicator: 96,
  cipLib: "NIQUITIN MENT.FR.2MG CPR BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3701335',
  CIP13: '3400937013352',
  ucdLib: "NIQUITIN MENT.FR.4MG CPR",
  UCD7: '9290577',
  UCD13: '3400892905778',
  ucdQtyMultiplicator: 96,
  cipLib: "NIQUITIN MENT.FR.4MG CPR BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3767972',
  CIP13: '3400937679725',
  ucdLib: "NICOPASS 1,5MG S/S EUCA PAST",
  UCD7: '9353912',
  UCD13: '3400893539125',
  ucdQtyMultiplicator: 12,
  cipLib: "NICOPASS 1,5MG S/S EUCA PAST BT 12",
  atcCode: "N07BA01"
}, {
  CIP7: '3767995',
  CIP13: '3400937679954',
  ucdLib: "NICOPASS 1,5MG S/S EUCA PAST",
  UCD7: '9353912',
  UCD13: '3400893539125',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOPASS 1,5MG S/S EUCA PAST BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3768055',
  CIP13: '3400937680554',
  ucdLib: "NICOPASS 1,5MG S/S EUCA PAST",
  UCD7: '9353912',
  UCD13: '3400893539125',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOPASS 1,5MG S/S EUCA PAST BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3763098',
  CIP13: '3400937630986',
  ucdLib: "NICORETTE 2MG S/SUC GOM",
  UCD7: '9216026',
  UCD13: '3400892160269',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORETTE 2MG S/SUC GOM BT 30",
  atcCode: "N07BA01"
}, {
  CIP7: '3763112',
  CIP13: '3400937631129',
  ucdLib: "NICORETTE 2MG S/SUC GOM",
  UCD7: '9216026',
  UCD13: '3400892160269',
  ucdQtyMultiplicator: 105,
  cipLib: "NICORETTE 2MG S/SUC GOM BT 105",
  atcCode: "N07BA01"
}, {
  CIP7: '3763129',
  CIP13: '3400937631297',
  ucdLib: "NICORETTE 2MG S/SUC GOM",
  UCD7: '9216026',
  UCD13: '3400892160269',
  ucdQtyMultiplicator: 210,
  cipLib: "NICORETTE 2MG S/SUC GOM BT 210",
  atcCode: "N07BA01"
}, {
  CIP7: '3763075',
  CIP13: '3400937630757',
  ucdLib: "NICORETTE 4MG S/SUC GOM",
  UCD7: '9211419',
  UCD13: '3400892114194',
  ucdQtyMultiplicator: 105,
  cipLib: "NICORETTE 4MG S/SUC GOM BT 105",
  atcCode: "N07BA01"
}, {
  CIP7: '3763135',
  CIP13: '3400937631358',
  ucdLib: "NICORETTE MENT F.2MG S/S GOM",
  UCD7: '9267615',
  UCD13: '3400892676159',
  ucdQtyMultiplicator: 105,
  cipLib: "NICORETTE MENT F.2MG S/S GOM BT 105",
  atcCode: "N07BA01"
}, {
  CIP7: '3763141',
  CIP13: '3400937631419',
  ucdLib: "NICORETTE MENT F.2MG S/S GOM",
  UCD7: '9267615',
  UCD13: '3400892676159',
  ucdQtyMultiplicator: 210,
  cipLib: "NICORETTE MENT F.2MG S/S GOM BT 210",
  atcCode: "N07BA01"
}, {
  CIP7: '3763158',
  CIP13: '3400937631587',
  ucdLib: "NICORETTE MENT F.4MG S/S GOM",
  UCD7: '9267621',
  UCD13: '3400892676210',
  ucdQtyMultiplicator: 105,
  cipLib: "NICORETTE MENT F.4MG S/S GOM BT 105",
  atcCode: "N07BA01"
}, {
  CIP7: '3631675',
  CIP13: '3400936316751',
  ucdLib: "NICOTINELL FR.2MG S/SUC GOM",
  UCD7: '9231439',
  UCD13: '3400892314396',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINELL FR.2MG S/SUC GOM BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3631712',
  CIP13: '3400936317123',
  ucdLib: "NICOTINELL FR.2MG S/SUC GOM",
  UCD7: '9231439',
  UCD13: '3400892314396',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOTINELL FR.2MG S/SUC GOM BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3631497',
  CIP13: '3400936314979',
  ucdLib: "NICOTINELL MEN F.2MG S/S GOM",
  UCD7: '9231445',
  UCD13: '3400892314457',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINELL MEN F.2MG S/S GOM BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3631534',
  CIP13: '3400936315341',
  ucdLib: "NICOTINELL MEN F.2MG S/S GOM",
  UCD7: '9231445',
  UCD13: '3400892314457',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOTINELL MEN F.2MG S/S GOM BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3631586',
  CIP13: '3400936315860',
  ucdLib: "NICOTINELL MEN F.4MG S/S GOM",
  UCD7: '9231451',
  UCD13: '3400892314518',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINELL MEN F.4MG S/S GOM BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3631623',
  CIP13: '3400936316232',
  ucdLib: "NICOTINELL MEN F.4MG S/S GOM",
  UCD7: '9231451',
  UCD13: '3400892314518',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOTINELL MEN F.4MG S/S GOM BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3644761',
  CIP13: '3400936447615',
  ucdLib: "NICOPASS 1,5MG S/S MENT PAST",
  UCD7: '9262204',
  UCD13: '3400892622040',
  ucdQtyMultiplicator: 12,
  cipLib: "NICOPASS 1,5MG S/S MENT PAST BT 12",
  atcCode: "N07BA01"
}, {
  CIP7: '3644784',
  CIP13: '3400936447844',
  ucdLib: "NICOPASS 1,5MG S/S MENT PAST",
  UCD7: '9262204',
  UCD13: '3400892622040',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOPASS 1,5MG S/S MENT PAST BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3649899',
  CIP13: '3400936498990',
  ucdLib: "NICOPASS 1,5MG S/S MENT PAST",
  UCD7: '9262204',
  UCD13: '3400892622040',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOPASS 1,5MG S/S MENT PAST BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3649907',
  CIP13: '3400936499072',
  ucdLib: "NICOPASS 1,5MG S/S REGL PAST",
  UCD7: '9262210',
  UCD13: '3400892622101',
  ucdQtyMultiplicator: 12,
  cipLib: "NICOPASS 1,5MG S/S REGL PAST BT 12",
  atcCode: "N07BA01"
}, {
  CIP7: '3649936',
  CIP13: '3400936499362',
  ucdLib: "NICOPASS 1,5MG S/S REGL PAST",
  UCD7: '9262210',
  UCD13: '3400892622101',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOPASS 1,5MG S/S REGL PAST BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3649988',
  CIP13: '3400936499881',
  ucdLib: "NICOPASS 1,5MG S/S REGL PAST",
  UCD7: '9262210',
  UCD13: '3400892622101',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOPASS 1,5MG S/S REGL PAST BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3710073',
  CIP13: '3400937100731',
  ucdLib: "NICORETTE FRUIT 4MG S/S GOM",
  UCD7: '9293239',
  UCD13: '3400892932392',
  ucdQtyMultiplicator: 105,
  cipLib: "NICORETTE FRUIT 4MG S/S GOM BT 105",
  atcCode: "N07BA01"
}, {
  CIP7: '3799239',
  CIP13: '3400937992398',
  ucdLib: "NICORETTE MICROTAB 2MG CPR +E",
  UCD7: '9305362',
  UCD13: '3400893053621',
  ucdQtyMultiplicator: 100,
  cipLib: "NICORETTE MICROTAB 2MG CPR +E BT 100",
  atcCode: "N07BA01"
}, {
  CIP7: '3798671',
  CIP13: '3400937986717',
  ucdLib: "NICORETTE MICROTAB CIT2MG C.",
  UCD7: '9305356',
  UCD13: '3400893053560',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORETTE MICROTAB CIT2MG C. BT 30",
  atcCode: "N07BA01"
}, {
  CIP7: '3798694',
  CIP13: '3400937986946',
  ucdLib: "NICORETTE MICROTAB CIT2MG C.",
  UCD7: '9305356',
  UCD13: '3400893053560',
  ucdQtyMultiplicator: 100,
  cipLib: "NICORETTE MICROTAB CIT2MG C. BT 100",
  atcCode: "N07BA01"
}, {
  CIP7: '3640898',
  CIP13: '3400936408982',
  ucdLib: "NICOTINELL MENT 1MG CPR",
  UCD7: '9267851',
  UCD13: '3400892678511',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINELL MENT 1MG CPR BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3640906',
  CIP13: '3400936409064',
  ucdLib: "NICOTINELL MENT 1MG CPR",
  UCD7: '9267851',
  UCD13: '3400892678511',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOTINELL MENT 1MG CPR BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3795603',
  CIP13: '3400937956031',
  ucdLib: "NIQUITIN 14MG/24H DISP",
  UCD7: '9213186',
  UCD13: '3400892131863',
  ucdQtyMultiplicator: 7,
  cipLib: "NIQUITIN 14MG/24H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3795632',
  CIP13: '3400937956321',
  ucdLib: "NIQUITIN 14MG/24H DISP",
  UCD7: '9213186',
  UCD13: '3400892131863',
  ucdQtyMultiplicator: 28,
  cipLib: "NIQUITIN 14MG/24H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3795572',
  CIP13: '3400937955720',
  ucdLib: "NIQUITIN 21MG/24H DISP",
  UCD7: '9213192',
  UCD13: '3400892131924',
  ucdQtyMultiplicator: 7,
  cipLib: "NIQUITIN 21MG/24H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3795595',
  CIP13: '3400937955959',
  ucdLib: "NIQUITIN 21MG/24H DISP",
  UCD7: '9213192',
  UCD13: '3400892131924',
  ucdQtyMultiplicator: 28,
  cipLib: "NIQUITIN 21MG/24H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3795649',
  CIP13: '3400937956499',
  ucdLib: "NIQUITIN 7MG/24H DISP",
  UCD7: '9213200',
  UCD13: '3400892132006',
  ucdQtyMultiplicator: 7,
  cipLib: "NIQUITIN 7MG/24H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3470284',
  CIP13: '3400934702846',
  ucdLib: "NIQUITIN MENT.DC.2MG S/S CPR",
  UCD7: '9231787',
  UCD13: '3400892317878',
  ucdQtyMultiplicator: 96,
  cipLib: "NIQUITIN MENT.DC.2MG S/S CPR BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3470278',
  CIP13: '3400934702785',
  ucdLib: "NIQUITIN MENT.DC.4MG S/S CPR",
  UCD7: '9231793',
  UCD13: '3400892317939',
  ucdQtyMultiplicator: 96,
  cipLib: "NIQUITIN MENT.DC.4MG S/S CPR BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3872999',
  CIP13: '3400938729993',
  ucdLib: "NICOPASS 2,5MG S/S MENT PAST",
  UCD7: '9326418',
  UCD13: '3400893264188',
  ucdQtyMultiplicator: 12,
  cipLib: "NICOPASS 2,5MG S/S MENT PAST BT 12",
  atcCode: "N07BA01"
}, {
  CIP7: '3873013',
  CIP13: '3400938730135',
  ucdLib: "NICOPASS 2,5MG S/S MENT PAST",
  UCD7: '9326418',
  UCD13: '3400893264188',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOPASS 2,5MG S/S MENT PAST BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3873071',
  CIP13: '3400938730715',
  ucdLib: "NICOPASS 2,5MG S/S MENT PAST",
  UCD7: '9326418',
  UCD13: '3400893264188',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOPASS 2,5MG S/S MENT PAST BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3872887',
  CIP13: '3400938728873',
  ucdLib: "NICOPASS 2,5MG S/S REGL PAST",
  UCD7: '9333298',
  UCD13: '3400893332986',
  ucdQtyMultiplicator: 12,
  cipLib: "NICOPASS 2,5MG S/S REGL PAST BT 12",
  atcCode: "N07BA01"
}, {
  CIP7: '3872901',
  CIP13: '3400938729016',
  ucdLib: "NICOPASS 2,5MG S/S REGL PAST",
  UCD7: '9333298',
  UCD13: '3400893332986',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOPASS 2,5MG S/S REGL PAST BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '3872953',
  CIP13: '3400938729535',
  ucdLib: "NICOPASS 2,5MG S/S REGL PAST",
  UCD7: '9333298',
  UCD13: '3400893332986',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOPASS 2,5MG S/S REGL PAST BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '3867219',
  CIP13: '3400938672190',
  ucdLib: "NIQUITINMINIS MEN.1,5MG S/S",
  UCD7: '9323041',
  UCD13: '3400893230411',
  ucdQtyMultiplicator: 20,
  cipLib: "NIQUITINMINIS MEN.1,5MG S/S BT 20",
  atcCode: "N07BA01"
}, {
  CIP7: '3867231',
  CIP13: '3400938672312',
  ucdLib: "NIQUITINMINIS MEN.1,5MG S/S",
  UCD7: '9323041',
  UCD13: '3400893230411',
  ucdQtyMultiplicator: 60,
  cipLib: "NIQUITINMINIS MEN.1,5MG S/S BT 60",
  atcCode: "N07BA01"
}, {
  CIP7: '3867254',
  CIP13: '3400938672541',
  ucdLib: "NIQUITINMINIS MEN.4MG S/SUC",
  UCD7: '9323058',
  UCD13: '3400893230589',
  ucdQtyMultiplicator: 20,
  cipLib: "NIQUITINMINIS MEN.4MG S/SUC BT 20",
  atcCode: "N07BA01"
}, {
  CIP7: '3867277',
  CIP13: '3400938672770',
  ucdLib: "NIQUITINMINIS MEN.4MG S/SUC",
  UCD7: '9323058',
  UCD13: '3400893230589',
  ucdQtyMultiplicator: 60,
  cipLib: "NIQUITINMINIS MEN.4MG S/SUC BT 60",
  atcCode: "N07BA01"
}, {
  CIP7: '3900336',
  CIP13: '3400939003368',
  ucdLib: "NICORETTE MENT G.2MG S/S GOM",
  UCD7: '9335417',
  UCD13: '3400893354179',
  ucdQtyMultiplicator: 210,
  cipLib: "NICORETTE MENT G.2MG S/S GOM BT 210",
  atcCode: "N07BA01"
}, {
  CIP7: '3965034',
  CIP13: '3400939650340',
  ucdLib: "NICORETTESKIN 10MG/16H DISP",
  UCD7: '9353929',
  UCD13: '3400893539293',
  ucdQtyMultiplicator: 7,
  cipLib: "NICORETTESKIN 10MG/16H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3965057',
  CIP13: '3400939650579',
  ucdLib: "NICORETTESKIN 10MG/16H DISP",
  UCD7: '9353929',
  UCD13: '3400893539293',
  ucdQtyMultiplicator: 28,
  cipLib: "NICORETTESKIN 10MG/16H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3965063',
  CIP13: '3400939650630',
  ucdLib: "NICORETTESKIN 15MG/16H DISP",
  UCD7: '9353935',
  UCD13: '3400893539354',
  ucdQtyMultiplicator: 7,
  cipLib: "NICORETTESKIN 15MG/16H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3965092',
  CIP13: '3400939650920',
  ucdLib: "NICORETTESKIN 15MG/16H DISP",
  UCD7: '9353935',
  UCD13: '3400893539354',
  ucdQtyMultiplicator: 28,
  cipLib: "NICORETTESKIN 15MG/16H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3965100',
  CIP13: '3400939651002',
  ucdLib: "NICORETTESKIN 25MG/16H DISP",
  UCD7: '9353941',
  UCD13: '3400893539415',
  ucdQtyMultiplicator: 7,
  cipLib: "NICORETTESKIN 25MG/16H DISP BT 7",
  atcCode: "N07BA01"
}, {
  CIP7: '3965123',
  CIP13: '3400939651231',
  ucdLib: "NICORETTESKIN 25MG/16H DISP",
  UCD7: '9353941',
  UCD13: '3400893539415',
  ucdQtyMultiplicator: 28,
  cipLib: "NICORETTESKIN 25MG/16H DISP BT 28",
  atcCode: "N07BA01"
}, {
  CIP7: '3939522',
  CIP13: '3400939395227',
  ucdLib: "NICOTINELL FR.2MG S/SUC GOM",
  UCD7: '9231439',
  UCD13: '3400892314396',
  ucdQtyMultiplicator: 204,
  cipLib: "NICOTINELL FR.2MG S/SUC GOM BT 204",
  atcCode: "N07BA01"
}, {
  CIP7: '3939545',
  CIP13: '3400939395456',
  ucdLib: "NICOTINELL MEN F.2MG S/S GOM",
  UCD7: '9231445',
  UCD13: '3400892314457',
  ucdQtyMultiplicator: 204,
  cipLib: "NICOTINELL MEN F.2MG S/S GOM BT 204",
  atcCode: "N07BA01"
}, {
  CIP7: '3891991',
  CIP13: '3400938919912',
  ucdLib: "NICOTINELL MENT 1MG CPR",
  UCD7: '9267851',
  UCD13: '3400892678511',
  ucdQtyMultiplicator: 144,
  cipLib: "NICOTINELL MENT 1MG CPR BT 144",
  atcCode: "N07BA01"
}, {
  CIP7: '3892447',
  CIP13: '3400938924473',
  ucdLib: "NICOTINELL MENT 2MG CPR",
  UCD7: '9294279',
  UCD13: '3400892942797',
  ucdQtyMultiplicator: 144,
  cipLib: "NICOTINELL MENT 2MG CPR BT 144",
  atcCode: "N07BA01"
}, {
  CIP7: '2690049',
  CIP13: '3400926900496',
  ucdLib: "NICOTINE EG ME.2MG S/S GOM",
  UCD7: '9396531',
  UCD13: '3400893965313',
  ucdQtyMultiplicator: 204,
  cipLib: "NICOTINE EG ME.2MG S/S GOM BT 204",
  atcCode: "N07BA01"
}, {
  CIP7: '2690167',
  CIP13: '3400926901677',
  ucdLib: "NICOTINE EG ME.4MG S/S GOM",
  UCD7: '9396548',
  UCD13: '3400893965481',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINE EG ME.4MG S/S GOM BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '2690316',
  CIP13: '3400926903169',
  ucdLib: "NICOTINE EG ME.4MG S/S GOM",
  UCD7: '9396548',
  UCD13: '3400893965481',
  ucdQtyMultiplicator: 108,
  cipLib: "NICOTINE EG ME.4MG S/S GOM BT 108",
  atcCode: "N07BA01"
}, {
  CIP7: '2203196',
  CIP13: '3400922031965',
  ucdLib: "NICOPASS 1,5MG S/S MENT PAST",
  UCD7: '9262204',
  UCD13: '3400892622040',
  ucdQtyMultiplicator: 144,
  cipLib: "NICOPASS 1,5MG S/S MENT PAST BT 144",
  atcCode: "N07BA01"
}, {
  CIP7: '2241050',
  CIP13: '3400922410500',
  ucdLib: "NICORETTESPRAY 1MG/DOS BUC FL",
  UCD7: '9393403',
  UCD13: '3400893934036',
  ucdQtyMultiplicator: 1,
  cipLib: "NICORETTESPRAY 1MG/DOS BUC FL BT 1",
  atcCode: "N07BA01"
}, {
  CIP7: '2241067',
  CIP13: '3400922410678',
  ucdLib: "NICORETTESPRAY 1MG/DOS BUC FL",
  UCD7: '9393403',
  UCD13: '3400893934036',
  ucdQtyMultiplicator: 2,
  cipLib: "NICORETTESPRAY 1MG/DOS BUC FL BT 2",
  atcCode: "N07BA01"
}, {
  CIP7: '2689170',
  CIP13: '3400926891701',
  ucdLib: "NICOTINE EG FR.2MG S/S GOM",
  UCD7: '9416512',
  UCD13: '3400894165125',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINE EG FR.2MG S/S GOM BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '2689307',
  CIP13: '3400926893071',
  ucdLib: "NICOTINE EG FR.2MG S/S GOM",
  UCD7: '9416512',
  UCD13: '3400894165125',
  ucdQtyMultiplicator: 108,
  cipLib: "NICOTINE EG FR.2MG S/S GOM BT 108",
  atcCode: "N07BA01"
}, {
  CIP7: '2689371',
  CIP13: '3400926893712',
  ucdLib: "NICOTINE EG FR.2MG S/S GOM",
  UCD7: '9416512',
  UCD13: '3400894165125',
  ucdQtyMultiplicator: 204,
  cipLib: "NICOTINE EG FR.2MG S/S GOM BT 204",
  atcCode: "N07BA01"
}, {
  CIP7: '2689508',
  CIP13: '3400926895082',
  ucdLib: "NICOTINE EG FR.4MG S/S GOM",
  UCD7: '9416529',
  UCD13: '3400894165293',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINE EG FR.4MG S/S GOM BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '2689649',
  CIP13: '3400926896492',
  ucdLib: "NICOTINE EG FR.4MG S/S GOM",
  UCD7: '9416529',
  UCD13: '3400894165293',
  ucdQtyMultiplicator: 108,
  cipLib: "NICOTINE EG FR.4MG S/S GOM BT 108",
  atcCode: "N07BA01"
}, {
  CIP7: '2689833',
  CIP13: '3400926898335',
  ucdLib: "NICOTINE EG ME.2MG S/S GOM",
  UCD7: '9396531',
  UCD13: '3400893965313',
  ucdQtyMultiplicator: 36,
  cipLib: "NICOTINE EG ME.2MG S/S GOM BT 36",
  atcCode: "N07BA01"
}, {
  CIP7: '2689974',
  CIP13: '3400926899745',
  ucdLib: "NICOTINE EG ME.2MG S/S GOM",
  UCD7: '9396531',
  UCD13: '3400893965313',
  ucdQtyMultiplicator: 108,
  cipLib: "NICOTINE EG ME.2MG S/S GOM BT 108",
  atcCode: "N07BA01"
}, {
  CIP7: '2179606',
  CIP13: '3400921796063',
  ucdLib: "NICOTINELL FRU EXO2MG GOM",
  UCD7: '9403716',
  UCD13: '3400894037163',
  ucdQtyMultiplicator: 96,
  cipLib: "NICOTINELL FRU EXO2MG GOM BT 96",
  atcCode: "N07BA01"
}, {
  CIP7: '2179612',
  CIP13: '3400921796124',
  ucdLib: "NICOTINELL FRU EXO2MG GOM",
  UCD7: '9403716',
  UCD13: '3400894037163',
  ucdQtyMultiplicator: 204,
  cipLib: "NICOTINELL FRU EXO2MG GOM BT 204",
  atcCode: "N07BA01"
}, {
  CIP7: '3399178',
  CIP13: '3400933991784',
  ucdLib: "SALAGEN 5MG CPR",
  UCD7: '9179928',
  UCD13: '3400891799286',
  ucdQtyMultiplicator: 84,
  cipLib: "SALAGEN 5MG CPR BT 84",
  atcCode: "N07AX01"
}, {
  CIP7: '3069848',
  CIP13: '3400930698488',
  ucdLib: "MYTELASE 10MG CPR",
  UCD7: '9060765',
  UCD13: '3400890607650',
  ucdQtyMultiplicator: 50,
  cipLib: "MYTELASE 10MG CPR BT 50",
  atcCode: "N07AA30"
}, {
  CIP7: '3616279',
  CIP13: '3400936162792',
  ucdLib: "MESTINON 60MG CPR",
  UCD7: '9058389',
  UCD13: '3400890583893',
  ucdQtyMultiplicator: 20,
  cipLib: "MESTINON 60MG CPR BT 20",
  atcCode: "N07AA02"
}, {
  CIP7: '3001758',
  CIP13: '3400930017586',
  ucdLib: "MESTINON LP 180MG CPR",
  UCD7: '9413643',
  UCD13: '3400894136439',
  ucdQtyMultiplicator: 50,
  cipLib: "MESTINON LP 180MG CPR BT 50",
  atcCode: "N07AA02"
}, {
  CIP7: '3087036',
  CIP13: '3400930870365',
  ucdLib: "PROSTIGMINE 0,5MG INJ AMP1ML",
  UCD7: '9076246',
  UCD13: '3400890762465',
  ucdQtyMultiplicator: 6,
  cipLib: "PROSTIGMINE 0,5MG INJ AMP1ML BT 6",
  atcCode: "N07AA01"
}, {
  CIP7: '2693958',
  CIP13: '3400926939588',
  ucdLib: "NEOSTIGMINE REN 5MG/5ML AMP",
  UCD7: '9393490',
  UCD13: '3400893934906',
  ucdQtyMultiplicator: 10,
  cipLib: "NEOSTIGMINE REN 5MG/5ML AMP BT 10",
  atcCode: "N07AA01"
}, {
  CIP7: '3284570',
  CIP13: '3400932845705',
  ucdLib: "GINKOGINK BUV SOL FV30ML",
  UCD7: '9110836',
  UCD13: '3400891108361',
  ucdQtyMultiplicator: 1,
  cipLib: "GINKOGINK BUV SOL FV30ML BT 1",
  atcCode: "N06DX02"
}, {
  CIP7: '3299040',
  CIP13: '3400932990405',
  ucdLib: "TANAKAN 40MG CPR",
  UCD7: '9151315',
  UCD13: '3400891513158',
  ucdQtyMultiplicator: 30,
  cipLib: "TANAKAN 40MG CPR BT 30",
  atcCode: "N06DX02"
}, {
  CIP7: '3299063',
  CIP13: '3400932990634',
  ucdLib: "TANAKAN 40MG CPR",
  UCD7: '9151315',
  UCD13: '3400891513158',
  ucdQtyMultiplicator: 90,
  cipLib: "TANAKAN 40MG CPR BT 90",
  atcCode: "N06DX02"
}, {
  CIP7: '3302799',
  CIP13: '3400933027995',
  ucdLib: "TANAKAN 40MG/ML BUV FL90ML",
  UCD7: '9171329',
  UCD13: '3400891713299',
  ucdQtyMultiplicator: 1,
  cipLib: "TANAKAN 40MG/ML BUV FL90ML BT 1",
  atcCode: "N06DX02"
}, {
  CIP7: '4982135',
  CIP13: '3400949821358',
  ucdLib: "GINKGO BGA 40MG CPR",
  UCD7: '9391396',
  UCD13: '3400893913963',
  ucdQtyMultiplicator: 30,
  cipLib: "GINKGO BGA 40MG CPR BT 30",
  atcCode: "N06DX02"
}, {
  CIP7: '4982141',
  CIP13: '3400949821419',
  ucdLib: "GINKGO BGA 40MG CPR",
  UCD7: '9391396',
  UCD13: '3400893913963',
  ucdQtyMultiplicator: 90,
  cipLib: "GINKGO BGA 40MG CPR BT 90",
  atcCode: "N06DX02"
}, {
  CIP7: '3653122',
  CIP13: '3400936531222',
  ucdLib: "VITALOGINK 40MG/ML BUV FL90ML",
  UCD7: '9301016',
  UCD13: '3400893010167',
  ucdQtyMultiplicator: 1,
  cipLib: "VITALOGINK 40MG/ML BUV FL90ML BT 1",
  atcCode: "N06DX02"
}, {
  CIP7: '3769273',
  CIP13: '3400937692731',
  ucdLib: "VITALOGINK 40MG CPR",
  UCD7: '9301364',
  UCD13: '3400893013649',
  ucdQtyMultiplicator: 30,
  cipLib: "VITALOGINK 40MG CPR BT 30",
  atcCode: "N06DX02"
}, {
  CIP7: '3769296',
  CIP13: '3400937692960',
  ucdLib: "VITALOGINK 40MG CPR",
  UCD7: '9301364',
  UCD13: '3400893013649',
  ucdQtyMultiplicator: 90,
  cipLib: "VITALOGINK 40MG CPR BT 90",
  atcCode: "N06DX02"
}, {
  CIP7: '3163240',
  CIP13: '3400931632405',
  ucdLib: "TANAKAN 40MG/ML BUV FL30ML",
  UCD7: '9090424',
  UCD13: '3400890904247',
  ucdQtyMultiplicator: 1,
  cipLib: "TANAKAN 40MG/ML BUV FL30ML BT 1",
  atcCode: "N06DX02"
}, {
  CIP7: '3003751',
  CIP13: '3400930037515',
  ucdLib: "MEMANTINE BGA 20MG CPR",
  UCD7: '9393188',
  UCD13: '3400893931882',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE BGA 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2767527',
  CIP13: '3400927675270',
  ucdLib: "MEMANTINE EG 10MG CPR",
  UCD7: '9400971',
  UCD13: '3400894009719',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE EG 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2767533',
  CIP13: '3400927675331',
  ucdLib: "MEMANTINE EG 20MG CPR",
  UCD7: '9400988',
  UCD13: '3400894009887',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE EG 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2764167',
  CIP13: '3400927641671',
  ucdLib: "MEMANTINE EVO 10MG CPR",
  UCD7: '9400770',
  UCD13: '3400894007708',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE EVO 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2764210',
  CIP13: '3400927642104',
  ucdLib: "MEMANTINE EVO 20MG CPR",
  UCD7: '9400787',
  UCD13: '3400894007876',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE EVO 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2764084',
  CIP13: '3400927640841',
  ucdLib: "MEMANTINE RBX 10MG CPR",
  UCD7: '9399587',
  UCD13: '3400893995877',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE RBX 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2764121',
  CIP13: '3400927641213',
  ucdLib: "MEMANTINE RBX 20MG CPR",
  UCD7: '9399593',
  UCD13: '3400893995938',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE RBX 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2764865',
  CIP13: '3400927648656',
  ucdLib: "MEMANTINE ZEN 10MG CPR",
  UCD7: '9402711',
  UCD13: '3400894027119',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE ZEN 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2764859',
  CIP13: '3400927648595',
  ucdLib: "MEMANTINE ZEN 20MG CPR",
  UCD7: '9402728',
  UCD13: '3400894027287',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE ZEN 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2764629',
  CIP13: '3400927646294',
  ucdLib: "MEMANTINE ZYF 10MG CPR",
  UCD7: '9399601',
  UCD13: '3400893996010',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE ZYF 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2764635',
  CIP13: '3400927646355',
  ucdLib: "MEMANTINE ZYF 20MG CPR",
  UCD7: '9399618',
  UCD13: '3400893996188',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE ZYF 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '3595531',
  CIP13: '3400935955319',
  ucdLib: "EBIXA 10MG CPR",
  UCD7: '9238619',
  UCD13: '3400892386195',
  ucdQtyMultiplicator: 56,
  cipLib: "EBIXA 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '3595560',
  CIP13: '3400935955609',
  ucdLib: "EBIXA 5MG/PRES BUV FL50ML",
  UCD7: '9238648',
  UCD13: '3400892386485',
  ucdQtyMultiplicator: 1,
  cipLib: "EBIXA 5MG/PRES BUV FL50ML BT 1",
  atcCode: "N06DX01"
}, {
  CIP7: '3874030',
  CIP13: '3400938740301',
  ucdLib: "EBIXA 20MG CPR",
  UCD7: '9327174',
  UCD13: '3400893271742',
  ucdQtyMultiplicator: 28,
  cipLib: "EBIXA 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2690730',
  CIP13: '3400926907303',
  ucdLib: "MEMANTINE ALM 10MG CPR",
  UCD7: '9395922',
  UCD13: '3400893959220',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE ALM 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2690747',
  CIP13: '3400926907471',
  ucdLib: "MEMANTINE ALM 20MG CPR",
  UCD7: '9395939',
  UCD13: '3400893959398',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE ALM 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2759427',
  CIP13: '3400927594274',
  ucdLib: "MEMANTINE ARW 10MG CPR",
  UCD7: '9397068',
  UCD13: '3400893970683',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE ARW 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2759433',
  CIP13: '3400927594335',
  ucdLib: "MEMANTINE ARW 20MG CPR",
  UCD7: '9397074',
  UCD13: '3400893970744',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE ARW 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2750484',
  CIP13: '3400927504846',
  ucdLib: "MEMANTINE CRT 10MG CPR",
  UCD7: '9396100',
  UCD13: '3400893961001',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE CRT 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2750627',
  CIP13: '3400927506277',
  ucdLib: "MEMANTINE CRT 20MG CPR",
  UCD7: '9396117',
  UCD13: '3400893961179',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE CRT 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2692338',
  CIP13: '3400926923389',
  ucdLib: "MEMANTINE HCS 10MG CPR",
  UCD7: '9392289',
  UCD13: '3400893922897',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE HCS 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2692367',
  CIP13: '3400926923679',
  ucdLib: "MEMANTINE HCS 20MG CPR",
  UCD7: '9392295',
  UCD13: '3400893922958',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE HCS 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2742697',
  CIP13: '3400927426971',
  ucdLib: "MEMANTINE LEK 10MG CPR",
  UCD7: '9393521',
  UCD13: '3400893935217',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE LEK 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2742705',
  CIP13: '3400927427053',
  ucdLib: "MEMANTINE LEK 20MG CPR",
  UCD7: '9393538',
  UCD13: '3400893935385',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE LEK 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2744727',
  CIP13: '3400927447273',
  ucdLib: "MEMANTINE MYL 10MG CPR",
  UCD7: '9393811',
  UCD13: '3400893938119',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE MYL 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2744756',
  CIP13: '3400927447563',
  ucdLib: "MEMANTINE MYL 20MG CPR",
  UCD7: '9393828',
  UCD13: '3400893938287',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE MYL 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '2690687',
  CIP13: '3400926906870',
  ucdLib: "MEMANTINE TVS 10MG CPR",
  UCD7: '9395247',
  UCD13: '3400893952474',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE TVS 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2690693',
  CIP13: '3400926906931',
  ucdLib: "MEMANTINE TVS 20MG CPR",
  UCD7: '9395253',
  UCD13: '3400893952535',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE TVS 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '5707796',
  CIP13: '3400957077969',
  ucdLib: "EBIXA 10MG CPR",
  UCD7: '9238619',
  UCD13: '3400892386195',
  ucdQtyMultiplicator: 98,
  cipLib: "EBIXA 10MG CPR BT 98",
  atcCode: "N06DX01"
}, {
  CIP7: '2688118',
  CIP13: '3400926881184',
  ucdLib: "MEMANTINE BGA 10MG CPR",
  UCD7: '9393194',
  UCD13: '3400893931943',
  ucdQtyMultiplicator: 56,
  cipLib: "MEMANTINE BGA 10MG CPR BT 56",
  atcCode: "N06DX01"
}, {
  CIP7: '2688124',
  CIP13: '3400926881245',
  ucdLib: "MEMANTINE BGA 20MG CPR",
  UCD7: '9393188',
  UCD13: '3400893931882',
  ucdQtyMultiplicator: 28,
  cipLib: "MEMANTINE BGA 20MG CPR BT 28",
  atcCode: "N06DX01"
}, {
  CIP7: '5737053',
  CIP13: '3400957370534',
  ucdLib: "EBIXA 20MG CPR",
  UCD7: '9327174',
  UCD13: '3400893271742',
  ucdQtyMultiplicator: 98,
  cipLib: "EBIXA 20MG CPR BT 98",
  atcCode: "N06DX01"
}, {
  CIP7: '3570175',
  CIP13: '3400935701756',
  ucdLib: "REMINYL 4MG CPR",
  UCD7: '9228851',
  UCD13: '3400892288512',
  ucdQtyMultiplicator: 56,
  cipLib: "REMINYL 4MG CPR BT 56",
  atcCode: "N06DA04"
}, {
  CIP7: '3675951',
  CIP13: '3400936759510',
  ucdLib: "REMINYL LP 16MG GELU",
  UCD7: '9268721',
  UCD13: '3400892687216',
  ucdQtyMultiplicator: 28,
  cipLib: "REMINYL LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '3675968',
  CIP13: '3400936759688',
  ucdLib: "REMINYL LP 24MG GELU",
  UCD7: '9268738',
  UCD13: '3400892687384',
  ucdQtyMultiplicator: 28,
  cipLib: "REMINYL LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '3675939',
  CIP13: '3400936759398',
  ucdLib: "REMINYL LP 8MG GELU",
  UCD7: '9268744',
  UCD13: '3400892687445',
  ucdQtyMultiplicator: 28,
  cipLib: "REMINYL LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '3553691',
  CIP13: '3400935536914',
  ucdLib: "REMINYL 12MG CPR",
  UCD7: '9228845',
  UCD13: '3400892288451',
  ucdQtyMultiplicator: 56,
  cipLib: "REMINYL 12MG CPR BT 56",
  atcCode: "N06DA04"
}, {
  CIP7: '3553722',
  CIP13: '3400935537225',
  ucdLib: "REMINYL 4MG/ML BUV FL100ML",
  UCD7: '9228868',
  UCD13: '3400892288680',
  ucdQtyMultiplicator: 1,
  cipLib: "REMINYL 4MG/ML BUV FL100ML BT 1",
  atcCode: "N06DA04"
}, {
  CIP7: '3553685',
  CIP13: '3400935536853',
  ucdLib: "REMINYL 8MG CPR",
  UCD7: '9228874',
  UCD13: '3400892288741',
  ucdQtyMultiplicator: 56,
  cipLib: "REMINYL 8MG CPR BT 56",
  atcCode: "N06DA04"
}, {
  CIP7: '2211037',
  CIP13: '3400922110370',
  ucdLib: "GALANTAMINE MYL LP 16MG GELU",
  UCD7: '9384404',
  UCD13: '3400893844045',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE MYL LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2211184',
  CIP13: '3400922111841',
  ucdLib: "GALANTAMINE MYL LP 24MG GELU",
  UCD7: '9384410',
  UCD13: '3400893844106',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE MYL LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2210948',
  CIP13: '3400922109480',
  ucdLib: "GALANTAMINE MYL LP 8MG GELU",
  UCD7: '9384427',
  UCD13: '3400893844274',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE MYL LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2748903',
  CIP13: '3400927489037',
  ucdLib: "GALANTAMINE EG LP 16MG GELU",
  UCD7: '9396867',
  UCD13: '3400893968673',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE EG LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2748955',
  CIP13: '3400927489556',
  ucdLib: "GALANTAMINE EG LP 24MG GELU",
  UCD7: '9396873',
  UCD13: '3400893968734',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE EG LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2748843',
  CIP13: '3400927488436',
  ucdLib: "GALANTAMINE EG LP 8MG GELU",
  UCD7: '9396896',
  UCD13: '3400893968963',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE EG LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2749386',
  CIP13: '3400927493867',
  ucdLib: "GALANTAMINE TVS LP 16MG GELU",
  UCD7: '9406324',
  UCD13: '3400894063247',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE TVS LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2749469',
  CIP13: '3400927494697',
  ucdLib: "GALANTAMINE TVS LP 24MG GELU",
  UCD7: '9406330',
  UCD13: '3400894063308',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE TVS LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2749280',
  CIP13: '3400927492808',
  ucdLib: "GALANTAMINE TVS LP 8MG GELU",
  UCD7: '9406347',
  UCD13: '3400894063476',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE TVS LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2197159',
  CIP13: '3400921971590',
  ucdLib: "GALANTAMINE ZTL LP 16MG GELU",
  UCD7: '9383215',
  UCD13: '3400893832158',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ZTL LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2197136',
  CIP13: '3400921971361',
  ucdLib: "GALANTAMINE ZTL LP 24MG GELU",
  UCD7: '9383221',
  UCD13: '3400893832219',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ZTL LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2197188',
  CIP13: '3400921971880',
  ucdLib: "GALANTAMINE ZTL LP 8MG GELU",
  UCD7: '9383238',
  UCD13: '3400893832387',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ZTL LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201180',
  CIP13: '3400922011806',
  ucdLib: "GALANTAMINE ARW LP 16MG GELU",
  UCD7: '9380814',
  UCD13: '3400893808146',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ARW LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201010',
  CIP13: '3400922010106',
  ucdLib: "GALANTAMINE ARW LP 24MG GELU",
  UCD7: '9380808',
  UCD13: '3400893808085',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ARW LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201286',
  CIP13: '3400922012865',
  ucdLib: "GALANTAMINE ARW LP 8MG GELU",
  UCD7: '9380820',
  UCD13: '3400893808207',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ARW LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201116',
  CIP13: '3400922011165',
  ucdLib: "GALANTAMINE BGA LP 16MG GELU",
  UCD7: '9383184',
  UCD13: '3400893831847',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE BGA LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2200996',
  CIP13: '3400922009964',
  ucdLib: "GALANTAMINE BGA LP 24MG GELU",
  UCD7: '9383190',
  UCD13: '3400893831908',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE BGA LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201398',
  CIP13: '3400922013985',
  ucdLib: "GALANTAMINE BGA LP 8MG GELU",
  UCD7: '9383209',
  UCD13: '3400893832097',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE BGA LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201033',
  CIP13: '3400922010335',
  ucdLib: "GALANTAMINE CRT LP 16MG GELU",
  UCD7: '9398978',
  UCD13: '3400893989784',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE CRT LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201257',
  CIP13: '3400922012575',
  ucdLib: "GALANTAMINE CRT LP 24MG GELU",
  UCD7: '9398984',
  UCD13: '3400893989845',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE CRT LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201145',
  CIP13: '3400922011455',
  ucdLib: "GALANTAMINE CRT LP 8MG GELU",
  UCD7: '9398990',
  UCD13: '3400893989906',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE CRT LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '4187165',
  CIP13: '3400941871658',
  ucdLib: "GALANTAMINE KRK LP 16MG GELU",
  UCD7: '9378390',
  UCD13: '3400893783900',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE KRK LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '4187202',
  CIP13: '3400941872020',
  ucdLib: "GALANTAMINE KRK LP 24MG GELU",
  UCD7: '9378409',
  UCD13: '3400893784099',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE KRK LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '4187024',
  CIP13: '3400941870248',
  ucdLib: "GALANTAMINE KRK LP 8MG GELU",
  UCD7: '9378415',
  UCD13: '3400893784150',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE KRK LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '4186639',
  CIP13: '3400941866395',
  ucdLib: "GALANTAMINE SDZ LP 16MG GELU",
  UCD7: '9378361',
  UCD13: '3400893783610',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE SDZ LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '4186674',
  CIP13: '3400941866746',
  ucdLib: "GALANTAMINE SDZ LP 24MG GELU",
  UCD7: '9378378',
  UCD13: '3400893783788',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE SDZ LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '4186438',
  CIP13: '3400941864384',
  ucdLib: "GALANTAMINE SDZ LP 8MG GELU",
  UCD7: '9378384',
  UCD13: '3400893783849',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE SDZ LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201168',
  CIP13: '3400922011684',
  ucdLib: "GALANTAMINE ZYD LP 16MG GELU",
  UCD7: '9381966',
  UCD13: '3400893819661',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ZYD LP 16MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201062',
  CIP13: '3400922010625',
  ucdLib: "GALANTAMINE ZYD LP 24MG GELU",
  UCD7: '9381972',
  UCD13: '3400893819722',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ZYD LP 24MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2201352',
  CIP13: '3400922013527',
  ucdLib: "GALANTAMINE ZYD LP 8MG GELU",
  UCD7: '9381989',
  UCD13: '3400893819890',
  ucdQtyMultiplicator: 28,
  cipLib: "GALANTAMINE ZYD LP 8MG GELU BT 28",
  atcCode: "N06DA04"
}, {
  CIP7: '2792169',
  CIP13: '3400927921698',
  ucdLib: "GALANTAMINE BGA LP 16MG GELU",
  UCD7: '9383184',
  UCD13: '3400893831847',
  ucdQtyMultiplicator: 30,
  cipLib: "GALANTAMINE BGA LP 16MG GELU BT 30",
  atcCode: "N06DA04"
}, {
  CIP7: '2769472',
  CIP13: '3400927694721',
  ucdLib: "RIVASTIGMINE MYP 4,6MG/24H D",
  UCD7: '9404041',
  UCD13: '3400894040415',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE MYP 4,6MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2769495',
  CIP13: '3400927694950',
  ucdLib: "RIVASTIGMINE MYP 9,5MG/24H D",
  UCD7: '9404058',
  UCD13: '3400894040583',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE MYP 9,5MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2769408',
  CIP13: '3400927694080',
  ucdLib: "RIVASTIGMINE ZEN 4,6MG/24H D",
  UCD7: '9410277',
  UCD13: '3400894102779',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE ZEN 4,6MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2769443',
  CIP13: '3400927694431',
  ucdLib: "RIVASTIGMINE ZEN 9,5MG/24H D",
  UCD7: '9410283',
  UCD13: '3400894102830',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE ZEN 9,5MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '4919450',
  CIP13: '3400949194506',
  ucdLib: "RIVASTIGMINE MYL 1,5MG GELU",
  UCD7: '9364382',
  UCD13: '3400893643822',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE MYL 1,5MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '4919473',
  CIP13: '3400949194735',
  ucdLib: "RIVASTIGMINE MYL 1,5MG GELU",
  UCD7: '9364382',
  UCD13: '3400893643822',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE MYL 1,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '4919639',
  CIP13: '3400949196395',
  ucdLib: "RIVASTIGMINE MYL 3MG GELU",
  UCD7: '9364399',
  UCD13: '3400893643990',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE MYL 3MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '4919651',
  CIP13: '3400949196517',
  ucdLib: "RIVASTIGMINE MYL 3MG GELU",
  UCD7: '9364399',
  UCD13: '3400893643990',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE MYL 3MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '4919786',
  CIP13: '3400949197866',
  ucdLib: "RIVASTIGMINE MYL 4,5MG GELU",
  UCD7: '9364407',
  UCD13: '3400893644072',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE MYL 4,5MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '4919800',
  CIP13: '3400949198009',
  ucdLib: "RIVASTIGMINE MYL 4,5MG GELU",
  UCD7: '9364407',
  UCD13: '3400893644072',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE MYL 4,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '4919898',
  CIP13: '3400949198986',
  ucdLib: "RIVASTIGMINE MYL 6MG GELU",
  UCD7: '9364413',
  UCD13: '3400893644133',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE MYL 6MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '4919912',
  CIP13: '3400949199129',
  ucdLib: "RIVASTIGMINE MYL 6MG GELU",
  UCD7: '9364413',
  UCD13: '3400893644133',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE MYL 6MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3634892',
  CIP13: '3400936348929',
  ucdLib: "EXELON 2MG/ML BUV FL50ML",
  UCD7: '9270505',
  UCD13: '3400892705057',
  ucdQtyMultiplicator: 1,
  cipLib: "EXELON 2MG/ML BUV FL50ML BT 1",
  atcCode: "N06DA03"
}, {
  CIP7: '3819479',
  CIP13: '3400938194791',
  ucdLib: "EXELON 4,6MG/24H DISP TRANS",
  UCD7: '9310771',
  UCD13: '3400893107713',
  ucdQtyMultiplicator: 30,
  cipLib: "EXELON 4,6MG/24H DISP TRANS BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '3819491',
  CIP13: '3400938194913',
  ucdLib: "EXELON 9,5MG/24H DISP TRANS",
  UCD7: '9310788',
  UCD13: '3400893107881',
  ucdQtyMultiplicator: 30,
  cipLib: "EXELON 9,5MG/24H DISP TRANS BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '3818379',
  CIP13: '3400938183795',
  ucdLib: "RIVASTIGMINE ZYD 1,5MG GELU",
  UCD7: '9358370',
  UCD13: '3400893583708',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE ZYD 1,5MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '3818391',
  CIP13: '3400938183917',
  ucdLib: "RIVASTIGMINE ZYD 1,5MG GELU",
  UCD7: '9358370',
  UCD13: '3400893583708',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE ZYD 1,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3474690',
  CIP13: '3400934746901',
  ucdLib: "EXELON 1,5MG GELU",
  UCD7: '9202691',
  UCD13: '3400892026916',
  ucdQtyMultiplicator: 56,
  cipLib: "EXELON 1,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3474721',
  CIP13: '3400934747212',
  ucdLib: "EXELON 3MG GELU",
  UCD7: '9202716',
  UCD13: '3400892027166',
  ucdQtyMultiplicator: 56,
  cipLib: "EXELON 3MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3475850',
  CIP13: '3400934758508',
  ucdLib: "EXELON 4,5MG GELU",
  UCD7: '9202722',
  UCD13: '3400892027227',
  ucdQtyMultiplicator: 56,
  cipLib: "EXELON 4,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3475896',
  CIP13: '3400934758966',
  ucdLib: "EXELON 6MG GELU",
  UCD7: '9202739',
  UCD13: '3400892027395',
  ucdQtyMultiplicator: 56,
  cipLib: "EXELON 6MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3471763',
  CIP13: '3400934717635',
  ucdLib: "RIVASTIGMINE SDZ 1,5MG GELU",
  UCD7: '9367618',
  UCD13: '3400893676189',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE SDZ 1,5MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '3471786',
  CIP13: '3400934717864',
  ucdLib: "RIVASTIGMINE SDZ 1,5MG GELU",
  UCD7: '9367618',
  UCD13: '3400893676189',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE SDZ 1,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3471792',
  CIP13: '3400934717925',
  ucdLib: "RIVASTIGMINE SDZ 3MG GELU",
  UCD7: '9367630',
  UCD13: '3400893676301',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE SDZ 3MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '3471817',
  CIP13: '3400934718175',
  ucdLib: "RIVASTIGMINE SDZ 3MG GELU",
  UCD7: '9367630',
  UCD13: '3400893676301',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE SDZ 3MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3471823',
  CIP13: '3400934718236',
  ucdLib: "RIVASTIGMINE SDZ 4,5MG GELU",
  UCD7: '9367647',
  UCD13: '3400893676479',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE SDZ 4,5MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '3471846',
  CIP13: '3400934718465',
  ucdLib: "RIVASTIGMINE SDZ 4,5MG GELU",
  UCD7: '9367647',
  UCD13: '3400893676479',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE SDZ 4,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3471852',
  CIP13: '3400934718526',
  ucdLib: "RIVASTIGMINE SDZ 6MG GELU",
  UCD7: '9367653',
  UCD13: '3400893676530',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE SDZ 6MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '3471869',
  CIP13: '3400934718694',
  ucdLib: "RIVASTIGMINE SDZ 6MG GELU",
  UCD7: '9367653',
  UCD13: '3400893676530',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE SDZ 6MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3821111',
  CIP13: '3400938211115',
  ucdLib: "RIVASTIGMINE ZYD 3MG GELU",
  UCD7: '9358387',
  UCD13: '3400893583876',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE ZYD 3MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '3821192',
  CIP13: '3400938211924',
  ucdLib: "RIVASTIGMINE ZYD 3MG GELU",
  UCD7: '9358387',
  UCD13: '3400893583876',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE ZYD 3MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3823570',
  CIP13: '3400938235708',
  ucdLib: "RIVASTIGMINE ZYD 4,5MG GELU",
  UCD7: '9358393',
  UCD13: '3400893583937',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE ZYD 4,5MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '3823802',
  CIP13: '3400938238020',
  ucdLib: "RIVASTIGMINE ZYD 4,5MG GELU",
  UCD7: '9358393',
  UCD13: '3400893583937',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE ZYD 4,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3825103',
  CIP13: '3400938251036',
  ucdLib: "RIVASTIGMINE ZYD 6MG GELU",
  UCD7: '9358401',
  UCD13: '3400893584019',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE ZYD 6MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '3825209',
  CIP13: '3400938252095',
  ucdLib: "RIVASTIGMINE ZYD 6MG GELU",
  UCD7: '9358401',
  UCD13: '3400893584019',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE ZYD 6MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3978723',
  CIP13: '3400939787237',
  ucdLib: "RIVASTIGMINE EG 1,5MG GELU",
  UCD7: '9346929',
  UCD13: '3400893469293',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE EG 1,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3978901',
  CIP13: '3400939789019',
  ucdLib: "RIVASTIGMINE EG 3MG GELU",
  UCD7: '9346935',
  UCD13: '3400893469354',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE EG 3MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3979059',
  CIP13: '3400939790596',
  ucdLib: "RIVASTIGMINE EG 4,5MG GELU",
  UCD7: '9346941',
  UCD13: '3400893469415',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE EG 4,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '3979154',
  CIP13: '3400939791548',
  ucdLib: "RIVASTIGMINE EG 6MG GELU",
  UCD7: '9346958',
  UCD13: '3400893469583',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE EG 6MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '2194445',
  CIP13: '3400921944457',
  ucdLib: "RIVASTIGMINE BGA 1,5MG GELU",
  UCD7: '9384775',
  UCD13: '3400893847756',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE BGA 1,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '2194474',
  CIP13: '3400921944747',
  ucdLib: "RIVASTIGMINE BGA 3MG GELU",
  UCD7: '9384781',
  UCD13: '3400893847817',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE BGA 3MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '2194505',
  CIP13: '3400921945058',
  ucdLib: "RIVASTIGMINE BGA 4,5MG GELU",
  UCD7: '9384798',
  UCD13: '3400893847985',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE BGA 4,5MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '2194540',
  CIP13: '3400921945409',
  ucdLib: "RIVASTIGMINE BGA 6MG GELU",
  UCD7: '9384806',
  UCD13: '3400893848067',
  ucdQtyMultiplicator: 56,
  cipLib: "RIVASTIGMINE BGA 6MG GELU BT 56",
  atcCode: "N06DA03"
}, {
  CIP7: '2696649',
  CIP13: '3400926966492',
  ucdLib: "RIVASTIGMINE EG 4,6MG/24H DT",
  UCD7: '9409475',
  UCD13: '3400894094753',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE EG 4,6MG/24H DT BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2696678',
  CIP13: '3400926966782',
  ucdLib: "RIVASTIGMINE EG 9,5MG/24H DT",
  UCD7: '9409481',
  UCD13: '3400894094814',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE EG 9,5MG/24H DT BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2696709',
  CIP13: '3400926967093',
  ucdLib: "RIVASTIGMINE TVC 4,6MG/24H D",
  UCD7: '9411383',
  UCD13: '3400894113836',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE TVC 4,6MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2696738',
  CIP13: '3400926967383',
  ucdLib: "RIVASTIGMINE TVC 9,5MG/24H D",
  UCD7: '9411408',
  UCD13: '3400894114086',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE TVC 9,5MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2800213',
  CIP13: '3400928002136',
  ucdLib: "RIVASTIGMINE BGA 4,6MG/24H D",
  UCD7: '9407275',
  UCD13: '3400894072751',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE BGA 4,6MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2800242',
  CIP13: '3400928002426',
  ucdLib: "RIVASTIGMINE BGA 9,5MG/24H D",
  UCD7: '9407281',
  UCD13: '3400894072812',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE BGA 9,5MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2684741',
  CIP13: '3400926847418',
  ucdLib: "RIVASTIGMINE ARW 1,5MG GELU",
  UCD7: '9408470',
  UCD13: '3400894084709',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE ARW 1,5MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '2684882',
  CIP13: '3400926848828',
  ucdLib: "RIVASTIGMINE ARW 3MG GELU",
  UCD7: '9408487',
  UCD13: '3400894084877',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE ARW 3MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '2685025',
  CIP13: '3400926850258',
  ucdLib: "RIVASTIGMINE ARW 4,5MG GELU",
  UCD7: '9408493',
  UCD13: '3400894084938',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE ARW 4,5MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '2685120',
  CIP13: '3400926851200',
  ucdLib: "RIVASTIGMINE ARW 6MG GELU",
  UCD7: '9408501',
  UCD13: '3400894085010',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVASTIGMINE ARW 6MG GELU BT 28",
  atcCode: "N06DA03"
}, {
  CIP7: '2781906',
  CIP13: '3400927819063',
  ucdLib: "RIVASTIGMINE SDZ 4,6MG/24H D",
  UCD7: '9403449',
  UCD13: '3400894034490',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE SDZ 4,6MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '2781929',
  CIP13: '3400927819292',
  ucdLib: "RIVASTIGMINE SDZ 9,5MG/24H D",
  UCD7: '9403455',
  UCD13: '3400894034551',
  ucdQtyMultiplicator: 30,
  cipLib: "RIVASTIGMINE SDZ 9,5MG/24H D BT 30",
  atcCode: "N06DA03"
}, {
  CIP7: '3004133',
  CIP13: '3400930041338',
  ucdLib: "DONEPEZIL BGA 10MG CPR",
  UCD7: '9378705',
  UCD13: '3400893787052',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL BGA 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3818617',
  CIP13: '3400938186178',
  ucdLib: "DONEPEZIL TVC 10MG CPR DISP",
  UCD7: '9356968',
  UCD13: '3400893569689',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL TVC 10MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3814401',
  CIP13: '3400938144017',
  ucdLib: "DONEPEZIL TVC 5MG CPR DISP",
  UCD7: '9356974',
  UCD13: '3400893569740',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL TVC 5MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3444950',
  CIP13: '3400934449505',
  ucdLib: "ARICEPT 10MG CPR",
  UCD7: '9196039',
  UCD13: '3400891960396',
  ucdQtyMultiplicator: 28,
  cipLib: "ARICEPT 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3730644',
  CIP13: '3400937306447',
  ucdLib: "ARICEPT 10MG CPR ORODISP",
  UCD7: '9291140',
  UCD13: '3400892911403',
  ucdQtyMultiplicator: 28,
  cipLib: "ARICEPT 10MG CPR ORODISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3808369',
  CIP13: '3400938083699',
  ucdLib: "ARICEPT 10MG CPR ORODISP",
  UCD7: '9291140',
  UCD13: '3400892911403',
  ucdQtyMultiplicator: 50,
  cipLib: "ARICEPT 10MG CPR ORODISP BT 50",
  atcCode: "N06DA02"
}, {
  CIP7: '3444909',
  CIP13: '3400934449093',
  ucdLib: "ARICEPT 5MG CPR",
  UCD7: '9196045',
  UCD13: '3400891960457',
  ucdQtyMultiplicator: 28,
  cipLib: "ARICEPT 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3730609',
  CIP13: '3400937306096',
  ucdLib: "ARICEPT 5MG CPR ORODISP",
  UCD7: '9291157',
  UCD13: '3400892911571',
  ucdQtyMultiplicator: 28,
  cipLib: "ARICEPT 5MG CPR ORODISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3808352',
  CIP13: '3400938083521',
  ucdLib: "ARICEPT 5MG CPR ORODISP",
  UCD7: '9291157',
  UCD13: '3400892911571',
  ucdQtyMultiplicator: 50,
  cipLib: "ARICEPT 5MG CPR ORODISP BT 50",
  atcCode: "N06DA02"
}, {
  CIP7: '3870612',
  CIP13: '3400938706123',
  ucdLib: "DONEPEZIL RBX 10MG CPR",
  UCD7: '9322159',
  UCD13: '3400893221594',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL RBX 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3870517',
  CIP13: '3400938705171',
  ucdLib: "DONEPEZIL RBX 5MG CPR",
  UCD7: '9322165',
  UCD13: '3400893221655',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL RBX 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3899946',
  CIP13: '3400938999464',
  ucdLib: "DONEPEZIL ARG 10MG CPR",
  UCD7: '9332235',
  UCD13: '3400893322352',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ARG 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3899863',
  CIP13: '3400938998634',
  ucdLib: "DONEPEZIL ARG 5MG CPR",
  UCD7: '9332241',
  UCD13: '3400893322413',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ARG 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3893234',
  CIP13: '3400938932348',
  ucdLib: "DONEPEZIL MYL 10MG CPR +SEM",
  UCD7: '9382167',
  UCD13: '3400893821671',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL MYL 10MG CPR +SEM BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3893056',
  CIP13: '3400938930566',
  ucdLib: "DONEPEZIL MYL 5MG CPR +SEM",
  UCD7: '9382150',
  UCD13: '3400893821503',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL MYL 5MG CPR +SEM BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3890218',
  CIP13: '3400938902181',
  ucdLib: "DONEPEZIL SDZ 10MG CPR",
  UCD7: '9325057',
  UCD13: '3400893250570',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL SDZ 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3890164',
  CIP13: '3400938901641',
  ucdLib: "DONEPEZIL SDZ 5MG CPR",
  UCD7: '9325063',
  UCD13: '3400893250631',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL SDZ 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3899917',
  CIP13: '3400938999174',
  ucdLib: "DONEPEZIL TVS 10MG CPR",
  UCD7: '9332212',
  UCD13: '3400893322123',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL TVS 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3899780',
  CIP13: '3400938997804',
  ucdLib: "DONEPEZIL TVS 5MG CPR",
  UCD7: '9332229',
  UCD13: '3400893322291',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL TVS 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2662627',
  CIP13: '3400926626273',
  ucdLib: "DONEPEZIL ACC 10MG CPR",
  UCD7: '9389637',
  UCD13: '3400893896372',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ACC 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2662596',
  CIP13: '3400926625962',
  ucdLib: "DONEPEZIL ACC 5MG CPR",
  UCD7: '9389643',
  UCD13: '3400893896433',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ACC 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '4993937',
  CIP13: '3400949939374',
  ucdLib: "DONEPEZIL ALT 10MG CPR",
  UCD7: '9371287',
  UCD13: '3400893712870',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ALT 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2667493',
  CIP13: '3400926674939',
  ucdLib: "DONEPEZIL ARG 10MG CPR DISP",
  UCD7: '9386202',
  UCD13: '3400893862025',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ARG 10MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2667441',
  CIP13: '3400926674410',
  ucdLib: "DONEPEZIL ARG 5MG CPR DISP",
  UCD7: '9386219',
  UCD13: '3400893862193',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ARG 5MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2660700',
  CIP13: '3400926607005',
  ucdLib: "DONEPEZIL CRT 10MG CPR",
  UCD7: '9394667',
  UCD13: '3400893946671',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL CRT 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2660634',
  CIP13: '3400926606343',
  ucdLib: "DONEPEZIL CRT 5MG CPR",
  UCD7: '9394673',
  UCD13: '3400893946732',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL CRT 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '4936247',
  CIP13: '3400949362479',
  ucdLib: "DONEPEZIL EG 10MG CPR",
  UCD7: '9361113',
  UCD13: '3400893611135',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL EG 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '4936164',
  CIP13: '3400949361649',
  ucdLib: "DONEPEZIL EG 5MG CPR",
  UCD7: '9361136',
  UCD13: '3400893611364',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL EG 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2196450',
  CIP13: '3400921964509',
  ucdLib: "DONEPEZIL EVO 10MG CPR",
  UCD7: '9388141',
  UCD13: '3400893881415',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL EVO 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2196390',
  CIP13: '3400921963908',
  ucdLib: "DONEPEZIL EVO 5MG CPR",
  UCD7: '9388158',
  UCD13: '3400893881583',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL EVO 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '4935012',
  CIP13: '3400949350124',
  ucdLib: "DONEPEZIL MYL 10MG CPR DISP",
  UCD7: '9361142',
  UCD13: '3400893611425',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL MYL 10MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '4934863',
  CIP13: '3400949348633',
  ucdLib: "DONEPEZIL MYL 5MG CPR DISP",
  UCD7: '9361159',
  UCD13: '3400893611593',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL MYL 5MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '4199056',
  CIP13: '3400941990564',
  ucdLib: "DONEPEZIL ZEN 10MG CPR",
  UCD7: '9378757',
  UCD13: '3400893787571',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ZEN 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '4198996',
  CIP13: '3400941989964',
  ucdLib: "DONEPEZIL ZEN 5MG CPR",
  UCD7: '9378786',
  UCD13: '3400893787861',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ZEN 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3985769',
  CIP13: '3400939857695',
  ucdLib: "DONEPEZIL ZYD 10MG CPR",
  UCD7: '9346415',
  UCD13: '3400893464151',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ZYD 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '3985611',
  CIP13: '3400939856117',
  ucdLib: "DONEPEZIL ZYD 5MG CPR",
  UCD7: '9346421',
  UCD13: '3400893464212',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ZYD 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2209187',
  CIP13: '3400922091877',
  ucdLib: "DONEPEZIL ACT 10MG CPR DISP",
  UCD7: '9383652',
  UCD13: '3400893836521',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ACT 10MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2209218',
  CIP13: '3400922092188',
  ucdLib: "DONEPEZIL ACT 5MG CPR DISP",
  UCD7: '9383669',
  UCD13: '3400893836699',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL ACT 5MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2165998',
  CIP13: '3400921659986',
  ucdLib: "DONEPEZIL BGA 10MG CPR",
  UCD7: '9378705',
  UCD13: '3400893787052',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL BGA 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2165969',
  CIP13: '3400921659696',
  ucdLib: "DONEPEZIL BGA 5MG CPR",
  UCD7: '9378711',
  UCD13: '3400893787113',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL BGA 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2236244',
  CIP13: '3400922362441',
  ucdLib: "DONEPEZIL BLF 10MG CPR",
  UCD7: '9411756',
  UCD13: '3400894117568',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL BLF 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2236221',
  CIP13: '3400922362212',
  ucdLib: "DONEPEZIL BLF 5MG CPR",
  UCD7: '9411762',
  UCD13: '3400894117629',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL BLF 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2170924',
  CIP13: '3400921709247',
  ucdLib: "DONEPEZIL KRK 10MG CPR",
  UCD7: '9386231',
  UCD13: '3400893862315',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL KRK 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2170870',
  CIP13: '3400921708707',
  ucdLib: "DONEPEZIL KRK 5MG CPR",
  UCD7: '9386254',
  UCD13: '3400893862544',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL KRK 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2182519',
  CIP13: '3400921825190',
  ucdLib: "DONEPEZIL PFZ 10MG CPR",
  UCD7: '9380694',
  UCD13: '3400893806944',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL PFZ 10MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2182488',
  CIP13: '3400921824889',
  ucdLib: "DONEPEZIL PFZ 5MG CPR",
  UCD7: '9380688',
  UCD13: '3400893806883',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL PFZ 5MG CPR BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2204327',
  CIP13: '3400922043272',
  ucdLib: "DONEPEZIL SDZ 10MG CPR DISP",
  UCD7: '9381340',
  UCD13: '3400893813409',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL SDZ 10MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '2204238',
  CIP13: '3400922042381',
  ucdLib: "DONEPEZIL SDZ 5MG CPR DISP",
  UCD7: '9381334',
  UCD13: '3400893813348',
  ucdQtyMultiplicator: 28,
  cipLib: "DONEPEZIL SDZ 5MG CPR DISP BT 28",
  atcCode: "N06DA02"
}, {
  CIP7: '5683914',
  CIP13: '3400956839148',
  ucdLib: "ARICEPT 10MG CPR",
  UCD7: '9196039',
  UCD13: '3400891960396',
  ucdQtyMultiplicator: 50,
  cipLib: "ARICEPT 10MG CPR BT 50",
  atcCode: "N06DA02"
}, {
  CIP7: '5683908',
  CIP13: '3400956839087',
  ucdLib: "ARICEPT 5MG CPR",
  UCD7: '9196045',
  UCD13: '3400891960457',
  ucdQtyMultiplicator: 50,
  cipLib: "ARICEPT 5MG CPR BT 50",
  atcCode: "N06DA02"
}, {
  CIP7: '3002456',
  CIP13: '3400930024560',
  ucdLib: "RAXONE 150MG CPR PELLIC",
  UCD7: '9399216',
  UCD13: '3400893992166',
  ucdQtyMultiplicator: 180,
  cipLib: "RAXONE 150MG CPR PELLIC BT 180",
  atcCode: "N06BX13"
}, {
  CIP7: '3577042',
  CIP13: '3400935770424',
  ucdLib: "PIRACETAM ARW 20% BUV FL125ML",
  UCD7: '9235609',
  UCD13: '3400892356099',
  ucdQtyMultiplicator: 1,
  cipLib: "PIRACETAM ARW 20% BUV FL125ML BT 1",
  atcCode: "N06BX03"
}, {
  CIP7: '3314414',
  CIP13: '3400933144142',
  ucdLib: "NOOTROPYL 1200MG BUV A.6ML",
  UCD7: '9132186',
  UCD13: '3400891321869',
  ucdQtyMultiplicator: 30,
  cipLib: "NOOTROPYL 1200MG BUV A.6ML BT 30",
  atcCode: "N06BX03"
}, {
  CIP7: '3266371',
  CIP13: '3400932663712',
  ucdLib: "NOOTROPYL 800MG CPR",
  UCD7: '9123141',
  UCD13: '3400891231410',
  ucdQtyMultiplicator: 45,
  cipLib: "NOOTROPYL 800MG CPR BT 45",
  atcCode: "N06BX03"
}, {
  CIP7: '3225716',
  CIP13: '3400932257164',
  ucdLib: "GABACET 400MG GELU",
  UCD7: '9036910',
  UCD13: '3400890369107',
  ucdQtyMultiplicator: 60,
  cipLib: "GABACET 400MG GELU BT 60",
  atcCode: "N06BX03"
}, {
  CIP7: '3220185',
  CIP13: '3400932201853',
  ucdLib: "GABACET BUV AMP10ML",
  UCD7: '9036896',
  UCD13: '3400890368964',
  ucdQtyMultiplicator: 20,
  cipLib: "GABACET BUV AMP10ML BT 20",
  atcCode: "N06BX03"
}, {
  CIP7: '3209551',
  CIP13: '3400932095513',
  ucdLib: "NOOTROPYL 20% BUV FL125ML",
  UCD7: '9063404',
  UCD13: '3400890634045',
  ucdQtyMultiplicator: 1,
  cipLib: "NOOTROPYL 20% BUV FL125ML BT 1",
  atcCode: "N06BX03"
}, {
  CIP7: '3596223',
  CIP13: '3400935962232',
  ucdLib: "PIRACETAM ARW 800MG CPR",
  UCD7: '9243655',
  UCD13: '3400892436555',
  ucdQtyMultiplicator: 45,
  cipLib: "PIRACETAM ARW 800MG CPR BT 45",
  atcCode: "N06BX03"
}, {
  CIP7: '3595169',
  CIP13: '3400935951694',
  ucdLib: "PIRACETAM MYL 800MG CPR",
  UCD7: '9240444',
  UCD13: '3400892404448',
  ucdQtyMultiplicator: 45,
  cipLib: "PIRACETAM MYL 800MG CPR BT 45",
  atcCode: "N06BX03"
}, {
  CIP7: '3596737',
  CIP13: '3400935967374',
  ucdLib: "PIRACETAM TVC 800MG CPR",
  UCD7: '9248552',
  UCD13: '3400892485522',
  ucdQtyMultiplicator: 45,
  cipLib: "PIRACETAM TVC 800MG CPR BT 45",
  atcCode: "N06BX03"
}, {
  CIP7: '3464792',
  CIP13: '3400934647925',
  ucdLib: "NOOTROPYL 3G INJ AMP15ML",
  UCD7: '9063373',
  UCD13: '3400890633734',
  ucdQtyMultiplicator: 4,
  cipLib: "NOOTROPYL 3G INJ AMP15ML BT 4",
  atcCode: "N06BX03"
}, {
  CIP7: '3541570',
  CIP13: '3400935415707',
  ucdLib: "PIRACETAM ZYD 800MG CPR",
  UCD7: '9222883',
  UCD13: '3400892228839',
  ucdQtyMultiplicator: 45,
  cipLib: "PIRACETAM ZYD 800MG CPR BT 45",
  atcCode: "N06BX03"
}, {
  CIP7: '3497277',
  CIP13: '3400934972775',
  ucdLib: "PIRACETAM BGA 400MG CPR",
  UCD7: '9211000',
  UCD13: '3400892110004',
  ucdQtyMultiplicator: 90,
  cipLib: "PIRACETAM BGA 400MG CPR BT 90",
  atcCode: "N06BX03"
}, {
  CIP7: '3497320',
  CIP13: '3400934973208',
  ucdLib: "PIRACETAM BGA 800MG CPR",
  UCD7: '9211017',
  UCD13: '3400892110172',
  ucdQtyMultiplicator: 45,
  cipLib: "PIRACETAM BGA 800MG CPR BT 45",
  atcCode: "N06BX03"
}, {
  CIP7: '3497194',
  CIP13: '3400934971945',
  ucdLib: "PIRACETAM EG 800MG CPR",
  UCD7: '9216339',
  UCD13: '3400892163390',
  ucdQtyMultiplicator: 45,
  cipLib: "PIRACETAM EG 800MG CPR BT 45",
  atcCode: "N06BX03"
}, {
  CIP7: '2762642',
  CIP13: '3400927626425',
  ucdLib: "MODAFINIL ARW 100MG CPR",
  UCD7: '9410018',
  UCD13: '3400894100188',
  ucdQtyMultiplicator: 30,
  cipLib: "MODAFINIL ARW 100MG CPR BT 30",
  atcCode: "N06BA07"
}, {
  CIP7: '3346466',
  CIP13: '3400933464660',
  ucdLib: "MODIODAL 100MG CPR",
  UCD7: '9167061',
  UCD13: '3400891670615',
  ucdQtyMultiplicator: 30,
  cipLib: "MODIODAL 100MG CPR BT 30",
  atcCode: "N06BA07"
}, {
  CIP7: '4926740',
  CIP13: '3400949267408',
  ucdLib: "MODAFINIL BGA 100MG CPR",
  UCD7: '9361567',
  UCD13: '3400893615676',
  ucdQtyMultiplicator: 30,
  cipLib: "MODAFINIL BGA 100MG CPR BT 30",
  atcCode: "N06BA07"
}, {
  CIP7: '2683003',
  CIP13: '3400926830038',
  ucdLib: "MODAFINIL EG 100MG CPR",
  UCD7: '9392668',
  UCD13: '3400893926680',
  ucdQtyMultiplicator: 30,
  cipLib: "MODAFINIL EG 100MG CPR BT 30",
  atcCode: "N06BA07"
}, {
  CIP7: '4926941',
  CIP13: '3400949269419',
  ucdLib: "MODAFINIL MYL 100MG CPR",
  UCD7: '9359458',
  UCD13: '3400893594582',
  ucdQtyMultiplicator: 30,
  cipLib: "MODAFINIL MYL 100MG CPR BT 30",
  atcCode: "N06BA07"
}, {
  CIP7: '3615541',
  CIP13: '3400936155411',
  ucdLib: "CONCERTA LP 18MG CPR",
  UCD7: '9256652',
  UCD13: '3400892566528',
  ucdQtyMultiplicator: 28,
  cipLib: "CONCERTA LP 18MG CPR BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '3615558',
  CIP13: '3400936155589',
  ucdLib: "CONCERTA LP 36MG CPR",
  UCD7: '9256669',
  UCD13: '3400892566696',
  ucdQtyMultiplicator: 28,
  cipLib: "CONCERTA LP 36MG CPR BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '3615564',
  CIP13: '3400936155640',
  ucdLib: "CONCERTA LP 54MG CPR",
  UCD7: '9256675',
  UCD13: '3400892566757',
  ucdQtyMultiplicator: 28,
  cipLib: "CONCERTA LP 54MG CPR BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '3392940',
  CIP13: '3400933929404',
  ucdLib: "RITALINE 10MG CPR",
  UCD7: '9166943',
  UCD13: '3400891669435',
  ucdQtyMultiplicator: 30,
  cipLib: "RITALINE 10MG CPR BT 30",
  atcCode: "N06BA04"
}, {
  CIP7: '3653493',
  CIP13: '3400936534933',
  ucdLib: "RITALINE LP 20MG GELU",
  UCD7: '9258303',
  UCD13: '3400892583037',
  ucdQtyMultiplicator: 28,
  cipLib: "RITALINE LP 20MG GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '3653501',
  CIP13: '3400936535015',
  ucdLib: "RITALINE LP 30MG GELU",
  UCD7: '9258326',
  UCD13: '3400892583266',
  ucdQtyMultiplicator: 28,
  cipLib: "RITALINE LP 30MG GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '3653518',
  CIP13: '3400936535183',
  ucdLib: "RITALINE LP 40MG GELU",
  UCD7: '9258332',
  UCD13: '3400892583327',
  ucdQtyMultiplicator: 28,
  cipLib: "RITALINE LP 40MG GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4972616',
  CIP13: '3400949726165',
  ucdLib: "QUASYM LP 10MG GELU",
  UCD7: '9350842',
  UCD13: '3400893508428',
  ucdQtyMultiplicator: 28,
  cipLib: "QUASYM LP 10MG GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4972622',
  CIP13: '3400949726226',
  ucdLib: "QUASYM LP 20MG GELU",
  UCD7: '9350859',
  UCD13: '3400893508596',
  ucdQtyMultiplicator: 28,
  cipLib: "QUASYM LP 20MG GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4972674',
  CIP13: '3400949726745',
  ucdLib: "QUASYM LP 30MG GELU",
  UCD7: '9350865',
  UCD13: '3400893508657',
  ucdQtyMultiplicator: 28,
  cipLib: "QUASYM LP 30MG GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4948138',
  CIP13: '3400949481385',
  ucdLib: "MEDIKINET 10MG LM GELU",
  UCD7: '9398470',
  UCD13: '3400893984703',
  ucdQtyMultiplicator: 28,
  cipLib: "MEDIKINET 10MG LM GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4948150',
  CIP13: '3400949481507',
  ucdLib: "MEDIKINET 20MG LM GELU",
  UCD7: '9398487',
  UCD13: '3400893984871',
  ucdQtyMultiplicator: 28,
  cipLib: "MEDIKINET 20MG LM GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4948173',
  CIP13: '3400949481736',
  ucdLib: "MEDIKINET 30MG LM GELU",
  UCD7: '9398493',
  UCD13: '3400893984932',
  ucdQtyMultiplicator: 28,
  cipLib: "MEDIKINET 30MG LM GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4948210',
  CIP13: '3400949482108',
  ucdLib: "MEDIKINET 40MG LM GELU",
  UCD7: '9398501',
  UCD13: '3400893985014',
  ucdQtyMultiplicator: 28,
  cipLib: "MEDIKINET 40MG LM GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4947854',
  CIP13: '3400949478545',
  ucdLib: "MEDIKINET 5MG LM GELU",
  UCD7: '9398518',
  UCD13: '3400893985182',
  ucdQtyMultiplicator: 28,
  cipLib: "MEDIKINET 5MG LM GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '4168653',
  CIP13: '3400941686535',
  ucdLib: "RITALINE LP 10MG GELU",
  UCD7: '9383876',
  UCD13: '3400893838761',
  ucdQtyMultiplicator: 28,
  cipLib: "RITALINE LP 10MG GELU BT 28",
  atcCode: "N06BA04"
}, {
  CIP7: '2770819',
  CIP13: '3400927708190',
  ucdLib: "BRINTELLIX 10MG CPR",
  UCD7: '9413784',
  UCD13: '3400894137849',
  ucdQtyMultiplicator: 28,
  cipLib: "BRINTELLIX 10MG CPR BT 28",
  atcCode: "N06AX26"
}, {
  CIP7: '2770825',
  CIP13: '3400927708251',
  ucdLib: "BRINTELLIX 15MG CPR",
  UCD7: '9413790',
  UCD13: '3400894137900',
  ucdQtyMultiplicator: 28,
  cipLib: "BRINTELLIX 15MG CPR BT 28",
  atcCode: "N06AX26"
}, {
  CIP7: '2770831',
  CIP13: '3400927708312',
  ucdLib: "BRINTELLIX 20MG CPR",
  UCD7: '9413809',
  UCD13: '3400894138099',
  ucdQtyMultiplicator: 28,
  cipLib: "BRINTELLIX 20MG CPR BT 28",
  atcCode: "N06AX26"
}, {
  CIP7: '2770802',
  CIP13: '3400927708022',
  ucdLib: "BRINTELLIX 5MG CPR",
  UCD7: '9413815',
  UCD13: '3400894138150',
  ucdQtyMultiplicator: 28,
  cipLib: "BRINTELLIX 5MG CPR BT 28",
  atcCode: "N06AX26"
}, {
  CIP7: '3627892',
  CIP13: '3400936278929',
  ucdLib: "ELUSANES MILLEPERTUIS GELU",
  UCD7: '9251330',
  UCD13: '3400892513300',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES MILLEPERTUIS GELU BT 30",
  atcCode: "N06AX25"
}, {
  CIP7: '3626177',
  CIP13: '3400936261778',
  ucdLib: "MILDAC 300MG CPR",
  UCD7: '9272119',
  UCD13: '3400892721194',
  ucdQtyMultiplicator: 40,
  cipLib: "MILDAC 300MG CPR BT 40",
  atcCode: "N06AX25"
}, {
  CIP7: '3653056',
  CIP13: '3400936530560',
  ucdLib: "MILLEPERTUIS PIJ CPR",
  UCD7: '9418793',
  UCD13: '3400894187936',
  ucdQtyMultiplicator: 45,
  cipLib: "MILLEPERTUIS PIJ CPR BT 45",
  atcCode: "N06AX25"
}, {
  CIP7: '3653027',
  CIP13: '3400936530270',
  ucdLib: "PROSOFT CPR",
  UCD7: '9295847',
  UCD13: '3400892958477',
  ucdQtyMultiplicator: 45,
  cipLib: "PROSOFT CPR BT 45",
  atcCode: "N06AX25"
}, {
  CIP7: '3587419',
  CIP13: '3400935874191',
  ucdLib: "ARKOGELULES MILLEPERTUIS",
  UCD7: '9241320',
  UCD13: '3400892413204',
  ucdQtyMultiplicator: 42,
  cipLib: "ARKOGELULES MILLEPERTUIS BT 42",
  atcCode: "N06AX25"
}, {
  CIP7: '3872433',
  CIP13: '3400938724332',
  ucdLib: "MILDAC 600MG CPR",
  UCD7: '9325778',
  UCD13: '3400893257784',
  ucdQtyMultiplicator: 15,
  cipLib: "MILDAC 600MG CPR BT 15",
  atcCode: "N06AX25"
}, {
  CIP7: '3943305',
  CIP13: '3400939433059',
  ucdLib: "VALDOXAN 25MG CPR",
  UCD7: '9341429',
  UCD13: '3400893414293',
  ucdQtyMultiplicator: 28,
  cipLib: "VALDOXAN 25MG CPR BT 28",
  atcCode: "N06AX22"
}, {
  CIP7: '5751455',
  CIP13: '3400957514556',
  ucdLib: "VALDOXAN 25MG CPR",
  UCD7: '9341429',
  UCD13: '3400893414293',
  ucdQtyMultiplicator: 100,
  cipLib: "VALDOXAN 25MG CPR BT 100",
  atcCode: "N06AX22"
}, {
  CIP7: '3002060',
  CIP13: '3400930020609',
  ucdLib: "DULOXETINE BGA 30MG GELU",
  UCD7: '9412135',
  UCD13: '3400894121350',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE BGA 30MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3002064',
  CIP13: '3400930020647',
  ucdLib: "DULOXETINE BGA 60MG GELU",
  UCD7: '9412141',
  UCD13: '3400894121411',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE BGA 60MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3002073',
  CIP13: '3400930020739',
  ucdLib: "DULOXETINE KRK 30MG GELU",
  UCD7: '9411963',
  UCD13: '3400894119630',
  ucdQtyMultiplicator: 7,
  cipLib: "DULOXETINE KRK 30MG GELU BT 7",
  atcCode: "N06AX21"
}, {
  CIP7: '3002074',
  CIP13: '3400930020746',
  ucdLib: "DULOXETINE KRK 30MG GELU",
  UCD7: '9411963',
  UCD13: '3400894119630',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE KRK 30MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3002076',
  CIP13: '3400930020760',
  ucdLib: "DULOXETINE KRK 60MG GELU",
  UCD7: '9411986',
  UCD13: '3400894119869',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE KRK 60MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3002657',
  CIP13: '3400930026571',
  ucdLib: "DULOXETINE MYP 30MG GELU",
  UCD7: '9418043',
  UCD13: '3400894180432',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE MYP 30MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3002679',
  CIP13: '3400930026793',
  ucdLib: "DULOXETINE MYP 60MG GELU",
  UCD7: '9418066',
  UCD13: '3400894180661',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE MYP 60MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3003452',
  CIP13: '3400930034521',
  ucdLib: "DULOXETINE TVS 30MG GELU",
  UCD7: '9414890',
  UCD13: '3400894148906',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE TVS 30MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3003457',
  CIP13: '3400930034576',
  ucdLib: "DULOXETINE TVS 60MG GELU",
  UCD7: '9414909',
  UCD13: '3400894149095',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE TVS 60MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3003169',
  CIP13: '3400930031698',
  ucdLib: "DULOXETINE ZEN 30MG GELU",
  UCD7: '9414387',
  UCD13: '3400894143871',
  ucdQtyMultiplicator: 7,
  cipLib: "DULOXETINE ZEN 30MG GELU BT 7",
  atcCode: "N06AX21"
}, {
  CIP7: '3003170',
  CIP13: '3400930031704',
  ucdLib: "DULOXETINE ZEN 30MG GELU",
  UCD7: '9414387',
  UCD13: '3400894143871',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE ZEN 30MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3003171',
  CIP13: '3400930031711',
  ucdLib: "DULOXETINE ZEN 60MG GELU",
  UCD7: '9414393',
  UCD13: '3400894143932',
  ucdQtyMultiplicator: 28,
  cipLib: "DULOXETINE ZEN 60MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3658645',
  CIP13: '3400936586451',
  ucdLib: "CYMBALTA 30MG GELU",
  UCD7: '9300873',
  UCD13: '3400893008737',
  ucdQtyMultiplicator: 28,
  cipLib: "CYMBALTA 30MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3658651',
  CIP13: '3400936586512',
  ucdLib: "CYMBALTA 60MG GELU",
  UCD7: '9300896',
  UCD13: '3400893008966',
  ucdQtyMultiplicator: 28,
  cipLib: "CYMBALTA 60MG GELU BT 28",
  atcCode: "N06AX21"
}, {
  CIP7: '3702375',
  CIP13: '3400937023757',
  ucdLib: "CYMBALTA 30MG GELU",
  UCD7: '9300873',
  UCD13: '3400893008737',
  ucdQtyMultiplicator: 7,
  cipLib: "CYMBALTA 30MG GELU BT 7",
  atcCode: "N06AX21"
}, {
  CIP7: '5707773',
  CIP13: '3400957077730',
  ucdLib: "CYMBALTA 60MG GELU",
  UCD7: '9300896',
  UCD13: '3400893008966',
  ucdQtyMultiplicator: 100,
  cipLib: "CYMBALTA 60MG GELU BT 100",
  atcCode: "N06AX21"
}, {
  CIP7: '3419774',
  CIP13: '3400934197741',
  ucdLib: "IXEL 25MG GELU",
  UCD7: '9187371',
  UCD13: '3400891873719',
  ucdQtyMultiplicator: 56,
  cipLib: "IXEL 25MG GELU BT 56",
  atcCode: "N06AX17"
}, {
  CIP7: '3419857',
  CIP13: '3400934198571',
  ucdLib: "IXEL 50MG GELU",
  UCD7: '9187388',
  UCD13: '3400891873887',
  ucdQtyMultiplicator: 56,
  cipLib: "IXEL 50MG GELU BT 56",
  atcCode: "N06AX17"
}, {
  CIP7: '4171460',
  CIP13: '3400941714603',
  ucdLib: "MILNACIPRAN ARW 25MG GELU",
  UCD7: '9373027',
  UCD13: '3400893730270',
  ucdQtyMultiplicator: 56,
  cipLib: "MILNACIPRAN ARW 25MG GELU BT 56",
  atcCode: "N06AX17"
}, {
  CIP7: '4171431',
  CIP13: '3400941714313',
  ucdLib: "MILNACIPRAN ARW 50MG GELU",
  UCD7: '9373033',
  UCD13: '3400893730331',
  ucdQtyMultiplicator: 56,
  cipLib: "MILNACIPRAN ARW 50MG GELU BT 56",
  atcCode: "N06AX17"
}, {
  CIP7: '4193881',
  CIP13: '3400941938818',
  ucdLib: "MILNACIPRAN BGA 25MG GELU",
  UCD7: '9379165',
  UCD13: '3400893791653',
  ucdQtyMultiplicator: 56,
  cipLib: "MILNACIPRAN BGA 25MG GELU BT 56",
  atcCode: "N06AX17"
}, {
  CIP7: '2208638',
  CIP13: '3400922086385',
  ucdLib: "MILNACIPRAN BGA 50MG GELU",
  UCD7: '9404271',
  UCD13: '3400894042716',
  ucdQtyMultiplicator: 56,
  cipLib: "MILNACIPRAN BGA 50MG GELU BT 56",
  atcCode: "N06AX17"
}, {
  CIP7: '3002203',
  CIP13: '3400930022030',
  ucdLib: "VENLAFAXINE BGA LP37,5 GELU",
  UCD7: '9323319',
  UCD13: '3400893233191',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BGA LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3002204',
  CIP13: '3400930022047',
  ucdLib: "VENLAFAXINE BGA LP75MG GELU",
  UCD7: '9323325',
  UCD13: '3400893233252',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BGA LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3853536',
  CIP13: '3400938535365',
  ucdLib: "VENLAFAXINE MYL 50MG CPR",
  UCD7: '9318755',
  UCD13: '3400893187555',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE MYL 50MG CPR BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3465633',
  CIP13: '3400934656330',
  ucdLib: "EFFEXOR LP 37,5MG GELU",
  UCD7: '9203986',
  UCD13: '3400892039862',
  ucdQtyMultiplicator: 30,
  cipLib: "EFFEXOR LP 37,5MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3465567',
  CIP13: '3400934655678',
  ucdLib: "EFFEXOR LP 75MG GELU",
  UCD7: '9260180',
  UCD13: '3400892601809',
  ucdQtyMultiplicator: 30,
  cipLib: "EFFEXOR LP 75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3466182',
  CIP13: '3400934661822',
  ucdLib: "VENLAFAXINE PFZ LP37,5 GELU",
  UCD7: '9314622',
  UCD13: '3400893146224',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE PFZ LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3465679',
  CIP13: '3400934656798',
  ucdLib: "VENLAFAXINE PFZ LP75MG GELU",
  UCD7: '9314639',
  UCD13: '3400893146392',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE PFZ LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3742937',
  CIP13: '3400937429375',
  ucdLib: "VENLAFAXINE BCR LP37,5 GELU",
  UCD7: '9353674',
  UCD13: '3400893536742',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BCR LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3742995',
  CIP13: '3400937429955',
  ucdLib: "VENLAFAXINE BCR LP75MG GELU",
  UCD7: '9353680',
  UCD13: '3400893536803',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BCR LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3819901',
  CIP13: '3400938199017',
  ucdLib: "VENLAFAXINE ZEN LP37,5 GELU",
  UCD7: '9312095',
  UCD13: '3400893120958',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ZEN LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3819953',
  CIP13: '3400938199536',
  ucdLib: "VENLAFAXINE ZEN LP75MG GELU",
  UCD7: '9312103',
  UCD13: '3400893121030',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ZEN LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3875762',
  CIP13: '3400938757620',
  ucdLib: "VENLAFAXINE ALM LP37,5 GELU",
  UCD7: '9322946',
  UCD13: '3400893229460',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ALM LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3876230',
  CIP13: '3400938762303',
  ucdLib: "VENLAFAXINE ALM LP75MG GELU",
  UCD7: '9322952',
  UCD13: '3400893229521',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ALM LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3881194',
  CIP13: '3400938811940',
  ucdLib: "VENLAFAXINE ALT LP37,5 GELU",
  UCD7: '9323302',
  UCD13: '3400893233023',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ALT LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3876187',
  CIP13: '3400938761870',
  ucdLib: "VENLAFAXINE ALT LP75MG GELU",
  UCD7: '9322969',
  UCD13: '3400893229699',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ALT LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3882348',
  CIP13: '3400938823486',
  ucdLib: "VENLAFAXINE ARW LP37,5 GELU",
  UCD7: '9323710',
  UCD13: '3400893237106',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ARW LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3882354',
  CIP13: '3400938823547',
  ucdLib: "VENLAFAXINE ARW LP37,5 GELU",
  UCD7: '9323710',
  UCD13: '3400893237106',
  ucdQtyMultiplicator: 50,
  cipLib: "VENLAFAXINE ARW LP37,5 GELU BT 50",
  atcCode: "N06AX16"
}, {
  CIP7: '3872249',
  CIP13: '3400938722499',
  ucdLib: "VENLAFAXINE ARW LP75MG GELU",
  UCD7: '9322685',
  UCD13: '3400893226858',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ARW LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3872255',
  CIP13: '3400938722550',
  ucdLib: "VENLAFAXINE ARW LP75MG GELU",
  UCD7: '9322685',
  UCD13: '3400893226858',
  ucdQtyMultiplicator: 50,
  cipLib: "VENLAFAXINE ARW LP75MG GELU BT 50",
  atcCode: "N06AX16"
}, {
  CIP7: '3872189',
  CIP13: '3400938721898',
  ucdLib: "VENLAFAXINE BGA LP37,5 GELU",
  UCD7: '9323319',
  UCD13: '3400893233191',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BGA LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3872858',
  CIP13: '3400938728583',
  ucdLib: "VENLAFAXINE BGA LP75MG GELU",
  UCD7: '9323325',
  UCD13: '3400893233252',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BGA LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3881248',
  CIP13: '3400938812480',
  ucdLib: "VENLAFAXINE CRT LP37,5 GELU",
  UCD7: '9324135',
  UCD13: '3400893241356',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE CRT LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3875644',
  CIP13: '3400938756449',
  ucdLib: "VENLAFAXINE CRT LP75MG GELU",
  UCD7: '9322981',
  UCD13: '3400893229811',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE CRT LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3884152',
  CIP13: '3400938841527',
  ucdLib: "VENLAFAXINE MYL LP37,5 GELU",
  UCD7: '9323377',
  UCD13: '3400893233771',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE MYL LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3884258',
  CIP13: '3400938842586',
  ucdLib: "VENLAFAXINE MYL LP75MG GELU",
  UCD7: '9323383',
  UCD13: '3400893233832',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE MYL LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3872781',
  CIP13: '3400938727814',
  ucdLib: "VENLAFAXINE RTP LP37,5 GELU",
  UCD7: '9322998',
  UCD13: '3400893229989',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE RTP LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3872580',
  CIP13: '3400938725803',
  ucdLib: "VENLAFAXINE RTP LP75MG GELU",
  UCD7: '9323006',
  UCD13: '3400893230060',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE RTP LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3881308',
  CIP13: '3400938813081',
  ucdLib: "VENLAFAXINE SDZ LP37,5 GELU",
  UCD7: '9321763',
  UCD13: '3400893217634',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE SDZ LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3875710',
  CIP13: '3400938757101',
  ucdLib: "VENLAFAXINE SDZ LP75MG GELU",
  UCD7: '9321786',
  UCD13: '3400893217863',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE SDZ LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3878341',
  CIP13: '3400938783414',
  ucdLib: "VENLAFAXINE ZYF LP37,5 GELU",
  UCD7: '9325844',
  UCD13: '3400893258446',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ZYF LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3877519',
  CIP13: '3400938775198',
  ucdLib: "VENLAFAXINE ZYF LP75MG GELU",
  UCD7: '9325850',
  UCD13: '3400893258507',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ZYF LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3844879',
  CIP13: '3400938448795',
  ucdLib: "VENLAFAXINE BIP LP150MG CPR",
  UCD7: '9404644',
  UCD13: '3400894046448',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BIP LP150MG CPR BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3845063',
  CIP13: '3400938450637',
  ucdLib: "VENLAFAXINE BIP LP225MG CPR",
  UCD7: '9404650',
  UCD13: '3400894046509',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BIP LP225MG CPR BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3913178',
  CIP13: '3400939131788',
  ucdLib: "VENLAFAXINE EG LP37,5 GELU",
  UCD7: '9331017',
  UCD13: '3400893310175',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE EG LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3913250',
  CIP13: '3400939132501',
  ucdLib: "VENLAFAXINE EG LP75MG GELU",
  UCD7: '9331023',
  UCD13: '3400893310236',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE EG LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3908119',
  CIP13: '3400939081199',
  ucdLib: "VENLAFAXINE ISD LP37,5 GELU",
  UCD7: '9329049',
  UCD13: '3400893290491',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ISD LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3906445',
  CIP13: '3400939064451',
  ucdLib: "VENLAFAXINE ISD LP75MG GELU",
  UCD7: '9328363',
  UCD13: '3400893283639',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE ISD LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '4168541',
  CIP13: '3400941685415',
  ucdLib: "VENLAFAXINE EVO LP37,5 GELU",
  UCD7: '9376793',
  UCD13: '3400893767931',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE EVO LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '4168742',
  CIP13: '3400941687426',
  ucdLib: "VENLAFAXINE EVO LP75MG GELU",
  UCD7: '9376801',
  UCD13: '3400893768013',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE EVO LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '2736716',
  CIP13: '3400927367168',
  ucdLib: "VENLAFAXINE MYL LP75MG GELU",
  UCD7: '9323383',
  UCD13: '3400893233832',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE MYL LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '2248112',
  CIP13: '3400922481128',
  ucdLib: "VENLAFAXINE RBX LP37,5 GELU",
  UCD7: '9329109',
  UCD13: '3400893291092',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE RBX LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '2248023',
  CIP13: '3400922480237',
  ucdLib: "VENLAFAXINE RBX LP75MG GELU",
  UCD7: '9329115',
  UCD13: '3400893291153',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE RBX LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '4961096',
  CIP13: '3400949610969',
  ucdLib: "VENLAFAXINE KRK LP 37,5 GELU",
  UCD7: '9372298',
  UCD13: '3400893722985',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE KRK LP 37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '4961535',
  CIP13: '3400949615353',
  ucdLib: "VENLAFAXINE KRK LP 75MG GELU",
  UCD7: '9372306',
  UCD13: '3400893723067',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE KRK LP 75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '4969608',
  CIP13: '3400949696086',
  ucdLib: "VENLAFAXINE TVS LP37,5 GELU",
  UCD7: '9372559',
  UCD13: '3400893725597',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE TVS LP37,5 GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '4969761',
  CIP13: '3400949697618',
  ucdLib: "VENLAFAXINE TVS LP75MG GELU",
  UCD7: '9372565',
  UCD13: '3400893725658',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE TVS LP75MG GELU BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3844460',
  CIP13: '3400938444605',
  ucdLib: "VENLAFAXINE BIP LP37,5MG CPR",
  UCD7: '9403840',
  UCD13: '3400894038405',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BIP LP37,5MG CPR BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3844678',
  CIP13: '3400938446784',
  ucdLib: "VENLAFAXINE BIP LP75MG CPR",
  UCD7: '9403857',
  UCD13: '3400894038573',
  ucdQtyMultiplicator: 30,
  cipLib: "VENLAFAXINE BIP LP75MG CPR BT 30",
  atcCode: "N06AX16"
}, {
  CIP7: '3001420',
  CIP13: '3400930014202',
  ucdLib: "TIANEPTINE MYP 12,5MG CPR",
  UCD7: '9408317',
  UCD13: '3400894083177',
  ucdQtyMultiplicator: 28,
  cipLib: "TIANEPTINE MYP 12,5MG CPR BT 28",
  atcCode: "N06AX14"
}, {
  CIP7: '5583360',
  CIP13: '3400955833604',
  ucdLib: "STABLON 12,5MG CPR",
  UCD7: '9125513',
  UCD13: '3400891255133',
  ucdQtyMultiplicator: 100,
  cipLib: "STABLON 12,5MG CPR BT 100",
  atcCode: "N06AX14"
}, {
  CIP7: '5500558',
  CIP13: '3400955005582',
  ucdLib: "TIANEPTINE MYP 12,5MG CPR",
  UCD7: '9408317',
  UCD13: '3400894083177',
  ucdQtyMultiplicator: 100,
  cipLib: "TIANEPTINE MYP 12,5MG CPR BT 100",
  atcCode: "N06AX14"
}, {
  CIP7: '2672235',
  CIP13: '3400926722357',
  ucdLib: "STABLON 12,5MG CPR",
  UCD7: '9125513',
  UCD13: '3400891255133',
  ucdQtyMultiplicator: 28,
  cipLib: "STABLON 12,5MG CPR BT 28",
  atcCode: "N06AX14"
}, {
  CIP7: '2675239',
  CIP13: '3400926752392',
  ucdLib: "TIANEPTINE BGA 12,5MG CPR",
  UCD7: '9204017',
  UCD13: '3400892040172',
  ucdQtyMultiplicator: 28,
  cipLib: "TIANEPTINE BGA 12,5MG CPR BT 28",
  atcCode: "N06AX14"
}, {
  CIP7: '3575149',
  CIP13: '3400935751492',
  ucdLib: "ZYBAN LP 150MG CPR",
  UCD7: '9233065',
  UCD13: '3400892330655',
  ucdQtyMultiplicator: 60,
  cipLib: "ZYBAN LP 150MG CPR BT 60",
  atcCode: "N06AX12"
}, {
  CIP7: '3003671',
  CIP13: '3400930036716',
  ucdLib: "MIRTAZAPINE CRT 15MG CPR",
  UCD7: '9415636',
  UCD13: '3400894156369',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE CRT 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3599523',
  CIP13: '3400935995230',
  ucdLib: "NORSET 15MG/ML BUV FL66ML",
  UCD7: '9246599',
  UCD13: '3400892465999',
  ucdQtyMultiplicator: 1,
  cipLib: "NORSET 15MG/ML BUV FL66ML BT 1",
  atcCode: "N06AX11"
}, {
  CIP7: '3761449',
  CIP13: '3400937614498',
  ucdLib: "MIRTAZAPINE ARG 15MG C.DISP",
  UCD7: '9292866',
  UCD13: '3400892928661',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE ARG 15MG C.DISP BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3767386',
  CIP13: '3400937673860',
  ucdLib: "MIRTAZAPINE BGA 15MG C.DISP",
  UCD7: '9294090',
  UCD13: '3400892940908',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE BGA 15MG C.DISP BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3694658',
  CIP13: '3400936946583',
  ucdLib: "MIRTAZAPINE TVC 15MG CPR",
  UCD7: '9278725',
  UCD13: '3400892787251',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE TVC 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3772631',
  CIP13: '3400937726313',
  ucdLib: "MIRTAZAPINE MYL 15MG CPR",
  UCD7: '9296769',
  UCD13: '3400892967691',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE MYL 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3784657',
  CIP13: '3400937846578',
  ucdLib: "MIRTAZAPINE SDZ 15MG CPR",
  UCD7: '9297556',
  UCD13: '3400892975566',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE SDZ 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3772648',
  CIP13: '3400937726481',
  ucdLib: "MIRTAZAPINE ZEN 15MG CPR",
  UCD7: '9296806',
  UCD13: '3400892968063',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE ZEN 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3875911',
  CIP13: '3400938759112',
  ucdLib: "MIRTAZAPINE ARW 15MG C.DISP",
  UCD7: '9325399',
  UCD13: '3400893253991',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE ARW 15MG C.DISP BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3876017',
  CIP13: '3400938760170',
  ucdLib: "MIRTAZAPINE BLF 15MG C.DISP",
  UCD7: '9322314',
  UCD13: '3400893223147',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE BLF 15MG C.DISP BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3445412',
  CIP13: '3400934454127',
  ucdLib: "NORSET 15MG CPR",
  UCD7: '9211477',
  UCD13: '3400892114774',
  ucdQtyMultiplicator: 30,
  cipLib: "NORSET 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3902341',
  CIP13: '3400939023410',
  ucdLib: "MIRTAZAPINE ALM 15MG C.DISP",
  UCD7: '9330503',
  UCD13: '3400893305034',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE ALM 15MG C.DISP BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3846111',
  CIP13: '3400938461114',
  ucdLib: "MIRTAZAPINE EG 15MG CPR",
  UCD7: '9313781',
  UCD13: '3400893137819',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE EG 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '3902223',
  CIP13: '3400939022239',
  ucdLib: "MIRTAZAPINE RBX 15MG C.DISP",
  UCD7: '9326401',
  UCD13: '3400893264010',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE RBX 15MG C.DISP BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '2184375',
  CIP13: '3400921843750',
  ucdLib: "MIRTAZAPINE ARG 15MG CPR",
  UCD7: '9408777',
  UCD13: '3400894087779',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE ARG 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '2208584',
  CIP13: '3400922085845',
  ucdLib: "MIRTAZAPINE ZYD 15MG CPR",
  UCD7: '9383729',
  UCD13: '3400893837290',
  ucdQtyMultiplicator: 30,
  cipLib: "MIRTAZAPINE ZYD 15MG CPR BT 30",
  atcCode: "N06AX11"
}, {
  CIP7: '5733138',
  CIP13: '3400957331382',
  ucdLib: "MIRTAZAPINE BLF 15MG C.DISP",
  UCD7: '9322314',
  UCD13: '3400893223147',
  ucdQtyMultiplicator: 90,
  cipLib: "MIRTAZAPINE BLF 15MG C.DISP BT 90",
  atcCode: "N06AX11"
}, {
  CIP7: '3613281',
  CIP13: '3400936132818',
  ucdLib: "MIANSERINE RPG 10MG CPR",
  UCD7: '9248888',
  UCD13: '3400892488882',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE RPG 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3613217',
  CIP13: '3400936132177',
  ucdLib: "MIANSERINE RPG 30MG CPR",
  UCD7: '9248894',
  UCD13: '3400892488943',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE RPG 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3614458',
  CIP13: '3400936144583',
  ucdLib: "MIANSERINE TVC 10MG CPR",
  UCD7: '9245163',
  UCD13: '3400892451633',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE TVC 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3614464',
  CIP13: '3400936144644',
  ucdLib: "MIANSERINE TVC 30MG CPR",
  UCD7: '9245186',
  UCD13: '3400892451862',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE TVC 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3614470',
  CIP13: '3400936144705',
  ucdLib: "MIANSERINE TVC 60MG CPR",
  UCD7: '9245192',
  UCD13: '3400892451923',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE TVC 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3004374',
  CIP13: '3400930043745',
  ucdLib: "MIANSERINE MYL 30MG CPR",
  UCD7: '9159759',
  UCD13: '3400891597592',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE MYL 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3573699',
  CIP13: '3400935736994',
  ucdLib: "MIANSERINE CRT 10MG CPR",
  UCD7: '9232775',
  UCD13: '3400892327754',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE CRT 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3573713',
  CIP13: '3400935737137',
  ucdLib: "MIANSERINE CRT 30MG CPR",
  UCD7: '9232781',
  UCD13: '3400892327815',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE CRT 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3573736',
  CIP13: '3400935737366',
  ucdLib: "MIANSERINE CRT 60MG CPR",
  UCD7: '9232798',
  UCD13: '3400892327983',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE CRT 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3573788',
  CIP13: '3400935737885',
  ucdLib: "MIANSERINE EG 10MG CPR",
  UCD7: '9232746',
  UCD13: '3400892327464',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE EG 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3573802',
  CIP13: '3400935738028',
  ucdLib: "MIANSERINE EG 30MG CPR",
  UCD7: '9232752',
  UCD13: '3400892327525',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE EG 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3573819',
  CIP13: '3400935738196',
  ucdLib: "MIANSERINE EG 60MG CPR",
  UCD7: '9232769',
  UCD13: '3400892327693',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE EG 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3573630',
  CIP13: '3400935736307',
  ucdLib: "MIANSERINE RTP 60MG CPR",
  UCD7: '9232858',
  UCD13: '3400892328584',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE RTP 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3342379',
  CIP13: '3400933423797',
  ucdLib: "MIANSERINE MYL 10MG CPR",
  UCD7: '9159742',
  UCD13: '3400891597424',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE MYL 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3342385',
  CIP13: '3400933423858',
  ucdLib: "MIANSERINE MYL 30MG CPR",
  UCD7: '9159759',
  UCD13: '3400891597592',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE MYL 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3674621',
  CIP13: '3400936746213',
  ucdLib: "MIANSERINE ZEN 10MG CPR",
  UCD7: '9270066',
  UCD13: '3400892700663',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE ZEN 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3674638',
  CIP13: '3400936746381',
  ucdLib: "MIANSERINE ZEN 30MG CPR",
  UCD7: '9270072',
  UCD13: '3400892700724',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE ZEN 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3674644',
  CIP13: '3400936746442',
  ucdLib: "MIANSERINE ZEN 60MG CPR",
  UCD7: '9270089',
  UCD13: '3400892700892',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE ZEN 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3483329',
  CIP13: '3400934833298',
  ucdLib: "MIANSERINE MYL 60MG CPR",
  UCD7: '9208512',
  UCD13: '3400892085128',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE MYL 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3483335',
  CIP13: '3400934833359',
  ucdLib: "MIANSERINE MYL 60MG CPR",
  UCD7: '9208512',
  UCD13: '3400892085128',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE MYL 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3583479',
  CIP13: '3400935834799',
  ucdLib: "MIANSERINE ARW 10MG CPR",
  UCD7: '9237519',
  UCD13: '3400892375199',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE ARW 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3583491',
  CIP13: '3400935834911',
  ucdLib: "MIANSERINE ARW 30MG CPR",
  UCD7: '9237525',
  UCD13: '3400892375250',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE ARW 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3583516',
  CIP13: '3400935835161',
  ucdLib: "MIANSERINE ARW 60MG CPR",
  UCD7: '9237531',
  UCD13: '3400892375311',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE ARW 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3583545',
  CIP13: '3400935835451',
  ucdLib: "MIANSERINE ARW 60MG CPR",
  UCD7: '9237531',
  UCD13: '3400892375311',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE ARW 60MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3586673',
  CIP13: '3400935866738',
  ucdLib: "MIANSERINE BGA 10MG CPR",
  UCD7: '9237548',
  UCD13: '3400892375489',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE BGA 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3586704',
  CIP13: '3400935867049',
  ucdLib: "MIANSERINE BGA 30MG CPR",
  UCD7: '9237554',
  UCD13: '3400892375540',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE BGA 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3586319',
  CIP13: '3400935863195',
  ucdLib: "MIANSERINE BGA 60MG CPR",
  UCD7: '9237560',
  UCD13: '3400892375601',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE BGA 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3661825',
  CIP13: '3400936618251',
  ucdLib: "MIANSERINE SDZ 10MG CPR",
  UCD7: '9265823',
  UCD13: '3400892658230',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE SDZ 10MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3661854',
  CIP13: '3400936618541',
  ucdLib: "MIANSERINE SDZ 30MG CPR",
  UCD7: '9265846',
  UCD13: '3400892658469',
  ucdQtyMultiplicator: 30,
  cipLib: "MIANSERINE SDZ 30MG CPR BT 30",
  atcCode: "N06AX03"
}, {
  CIP7: '3661848',
  CIP13: '3400936618480',
  ucdLib: "MIANSERINE SDZ 60MG CPR",
  UCD7: '9265852',
  UCD13: '3400892658520',
  ucdQtyMultiplicator: 14,
  cipLib: "MIANSERINE SDZ 60MG CPR BT 14",
  atcCode: "N06AX03"
}, {
  CIP7: '3333802',
  CIP13: '3400933338022',
  ucdLib: "LEVOTONINE GELU",
  UCD7: '9103032',
  UCD13: '3400891030327',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOTONINE GELU BT 100",
  atcCode: "N06AX01"
}, {
  CIP7: '3332493',
  CIP13: '3400933324933',
  ucdLib: "MOCLAMINE 150MG CPR",
  UCD7: '9166653',
  UCD13: '3400891666533',
  ucdQtyMultiplicator: 30,
  cipLib: "MOCLAMINE 150MG CPR BT 30",
  atcCode: "N06AG02"
}, {
  CIP7: '3688250',
  CIP13: '3400936882508',
  ucdLib: "MARSILID 50MG CPR",
  UCD7: '9278228',
  UCD13: '3400892782287',
  ucdQtyMultiplicator: 30,
  cipLib: "MARSILID 50MG CPR BT 30",
  atcCode: "N06AF05"
}, {
  CIP7: '3599374',
  CIP13: '3400935993748',
  ucdLib: "SEROPLEX 10MG CPR",
  UCD7: '9240846',
  UCD13: '3400892408460',
  ucdQtyMultiplicator: 28,
  cipLib: "SEROPLEX 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '3599397',
  CIP13: '3400935993977',
  ucdLib: "SEROPLEX 15MG CPR",
  UCD7: '9321438',
  UCD13: '3400893214381',
  ucdQtyMultiplicator: 28,
  cipLib: "SEROPLEX 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '3599411',
  CIP13: '3400935994110',
  ucdLib: "SEROPLEX 20MG CPR",
  UCD7: '9273018',
  UCD13: '3400892730189',
  ucdQtyMultiplicator: 28,
  cipLib: "SEROPLEX 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '3599351',
  CIP13: '3400935993519',
  ucdLib: "SEROPLEX 5MG CPR",
  UCD7: '9273024',
  UCD13: '3400892730240',
  ucdQtyMultiplicator: 28,
  cipLib: "SEROPLEX 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '3820459',
  CIP13: '3400938204599',
  ucdLib: "SEROPLEX 20MG/ML BUV GTT15ML",
  UCD7: '9338746',
  UCD13: '3400893387467',
  ucdQtyMultiplicator: 1,
  cipLib: "SEROPLEX 20MG/ML BUV GTT15ML BT 1",
  atcCode: "N06AB10"
}, {
  CIP7: '3642897',
  CIP13: '3400936428973',
  ucdLib: "SEROPLEX 5MG CPR",
  UCD7: '9273024',
  UCD13: '3400892730240',
  ucdQtyMultiplicator: 14,
  cipLib: "SEROPLEX 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2698720',
  CIP13: '3400926987206',
  ucdLib: "ESCITALOPRAM BGA 10MG CPR",
  UCD7: '9399541',
  UCD13: '3400893995419',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM BGA 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2698737',
  CIP13: '3400926987374',
  ucdLib: "ESCITALOPRAM BGA 15MG CPR",
  UCD7: '9399558',
  UCD13: '3400893995587',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM BGA 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2698743',
  CIP13: '3400926987435',
  ucdLib: "ESCITALOPRAM BGA 20MG CPR",
  UCD7: '9399564',
  UCD13: '3400893995648',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM BGA 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2698708',
  CIP13: '3400926987084',
  ucdLib: "ESCITALOPRAM BGA 5MG CPR",
  UCD7: '9399570',
  UCD13: '3400893995709',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM BGA 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2698714',
  CIP13: '3400926987145',
  ucdLib: "ESCITALOPRAM BGA 5MG CPR",
  UCD7: '9399570',
  UCD13: '3400893995709',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM BGA 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2755783',
  CIP13: '3400927557835',
  ucdLib: "ESCITALOPRAM EG 10MG CPR",
  UCD7: '9400876',
  UCD13: '3400894008767',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM EG 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2755872',
  CIP13: '3400927558726',
  ucdLib: "ESCITALOPRAM EG 15MG CPR",
  UCD7: '9400882',
  UCD13: '3400894008828',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM EG 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2755926',
  CIP13: '3400927559266',
  ucdLib: "ESCITALOPRAM EG 20MG CPR",
  UCD7: '9400899',
  UCD13: '3400894008996',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM EG 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2755688',
  CIP13: '3400927556883',
  ucdLib: "ESCITALOPRAM EG 5MG CPR",
  UCD7: '9400907',
  UCD13: '3400894009078',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM EG 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2755694',
  CIP13: '3400927556944',
  ucdLib: "ESCITALOPRAM EG 5MG CPR",
  UCD7: '9400907',
  UCD13: '3400894009078',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM EG 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2742800',
  CIP13: '3400927428005',
  ucdLib: "ESCITALOPRAM EVO 10MG CPR",
  UCD7: '9398932',
  UCD13: '3400893989326',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM EVO 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2742786',
  CIP13: '3400927427862',
  ucdLib: "ESCITALOPRAM EVO 15MG CPR",
  UCD7: '9398949',
  UCD13: '3400893989494',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM EVO 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2742823',
  CIP13: '3400927428234',
  ucdLib: "ESCITALOPRAM EVO 20MG CPR",
  UCD7: '9398955',
  UCD13: '3400893989555',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM EVO 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2742728',
  CIP13: '3400927427282',
  ucdLib: "ESCITALOPRAM EVO 5MG CPR",
  UCD7: '9398961',
  UCD13: '3400893989616',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM EVO 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2742734',
  CIP13: '3400927427343',
  ucdLib: "ESCITALOPRAM EVO 5MG CPR",
  UCD7: '9398961',
  UCD13: '3400893989616',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM EVO 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2740787',
  CIP13: '3400927407871',
  ucdLib: "ESCITALOPRAM RBX 10MG CPR",
  UCD7: '9401516',
  UCD13: '3400894015161',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM RBX 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2740847',
  CIP13: '3400927408472',
  ucdLib: "ESCITALOPRAM RBX 20MG CPR",
  UCD7: '9401539',
  UCD13: '3400894015390',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM RBX 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '4900084',
  CIP13: '3400949000845',
  ucdLib: "SEROPLEX 10MG CPR AIP BBA CZ",
  UCD7: '9421418',
  UCD13: '3400894214182',
  ucdQtyMultiplicator: 28,
  cipLib: "SEROPLEX 10MG CPR AIP BBA CZ BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '4900065',
  CIP13: '3400949000654',
  ucdLib: "SEROPLEX 10MG CPR AIP MWI CZ",
  UCD7: '9416570',
  UCD13: '3400894165705',
  ucdQtyMultiplicator: 28,
  cipLib: "SEROPLEX 10MG CPR AIP MWI CZ BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2784773',
  CIP13: '3400927847738',
  ucdLib: "ESCITALOPRAM ALM 10MG CPR",
  UCD7: '9402438',
  UCD13: '3400894024385',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ALM 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2784750',
  CIP13: '3400927847509',
  ucdLib: "ESCITALOPRAM ALM 15MG CPR",
  UCD7: '9402444',
  UCD13: '3400894024446',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ALM 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2784804',
  CIP13: '3400927848049',
  ucdLib: "ESCITALOPRAM ALM 20MG CPR",
  UCD7: '9402450',
  UCD13: '3400894024507',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ALM 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2784715',
  CIP13: '3400927847158',
  ucdLib: "ESCITALOPRAM ALM 5MG CPR",
  UCD7: '9402467',
  UCD13: '3400894024675',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ALM 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2783006',
  CIP13: '3400927830068',
  ucdLib: "ESCITALOPRAM CRT 10MG CPR",
  UCD7: '9401410',
  UCD13: '3400894014102',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM CRT 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2783199',
  CIP13: '3400927831997',
  ucdLib: "ESCITALOPRAM CRT 15MG CPR",
  UCD7: '9401427',
  UCD13: '3400894014270',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM CRT 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2783271',
  CIP13: '3400927832710',
  ucdLib: "ESCITALOPRAM CRT 20MG CPR",
  UCD7: '9401433',
  UCD13: '3400894014331',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM CRT 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2782751',
  CIP13: '3400927827518',
  ucdLib: "ESCITALOPRAM CRT 5MG CPR",
  UCD7: '9401456',
  UCD13: '3400894014560',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM CRT 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2782774',
  CIP13: '3400927827747',
  ucdLib: "ESCITALOPRAM CRT 5MG CPR",
  UCD7: '9401456',
  UCD13: '3400894014560',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM CRT 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2780918',
  CIP13: '3400927809187',
  ucdLib: "ESCITALOPRAM KRK 10MG CPR",
  UCD7: '9401462',
  UCD13: '3400894014621',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM KRK 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2780870',
  CIP13: '3400927808708',
  ucdLib: "ESCITALOPRAM KRK 15MG CPR",
  UCD7: '9401479',
  UCD13: '3400894014799',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM KRK 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2780829',
  CIP13: '3400927808296',
  ucdLib: "ESCITALOPRAM KRK 20MG CPR",
  UCD7: '9401485',
  UCD13: '3400894014850',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM KRK 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2780930',
  CIP13: '3400927809309',
  ucdLib: "ESCITALOPRAM KRK 5MG CPR",
  UCD7: '9401491',
  UCD13: '3400894014911',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM KRK 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2780953',
  CIP13: '3400927809538',
  ucdLib: "ESCITALOPRAM KRK 5MG CPR",
  UCD7: '9401491',
  UCD13: '3400894014911',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM KRK 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2688288',
  CIP13: '3400926882884',
  ucdLib: "ESCITALOPRAM RBX 15MG CPR",
  UCD7: '9401522',
  UCD13: '3400894015222',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM RBX 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2688153',
  CIP13: '3400926881535',
  ucdLib: "ESCITALOPRAM RBX 5MG CPR",
  UCD7: '9401545',
  UCD13: '3400894015451',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM RBX 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2688176',
  CIP13: '3400926881764',
  ucdLib: "ESCITALOPRAM RBX 5MG CPR",
  UCD7: '9401545',
  UCD13: '3400894015451',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM RBX 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2239745',
  CIP13: '3400922397450',
  ucdLib: "ESCITALOPRAM SDZ 10MG CPR",
  UCD7: '9389560',
  UCD13: '3400893895603',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM SDZ 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2239900',
  CIP13: '3400922399003',
  ucdLib: "ESCITALOPRAM SDZ 15MG CPR",
  UCD7: '9389577',
  UCD13: '3400893895771',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM SDZ 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2239998',
  CIP13: '3400922399980',
  ucdLib: "ESCITALOPRAM SDZ 20MG CPR",
  UCD7: '9389583',
  UCD13: '3400893895832',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM SDZ 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2239478',
  CIP13: '3400922394787',
  ucdLib: "ESCITALOPRAM SDZ 5MG CPR",
  UCD7: '9389608',
  UCD13: '3400893896082',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM SDZ 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2239490',
  CIP13: '3400922394909',
  ucdLib: "ESCITALOPRAM SDZ 5MG CPR",
  UCD7: '9389608',
  UCD13: '3400893896082',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM SDZ 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '5709513',
  CIP13: '3400957095130',
  ucdLib: "SEROPLEX 10MG CPR",
  UCD7: '9240846',
  UCD13: '3400892408460',
  ucdQtyMultiplicator: 98,
  cipLib: "SEROPLEX 10MG CPR BT 98",
  atcCode: "N06AB10"
}, {
  CIP7: '5709536',
  CIP13: '3400957095369',
  ucdLib: "SEROPLEX 15MG CPR",
  UCD7: '9321438',
  UCD13: '3400893214381',
  ucdQtyMultiplicator: 98,
  cipLib: "SEROPLEX 15MG CPR BT 98",
  atcCode: "N06AB10"
}, {
  CIP7: '5709542',
  CIP13: '3400957095420',
  ucdLib: "SEROPLEX 20MG CPR",
  UCD7: '9273018',
  UCD13: '3400892730189',
  ucdQtyMultiplicator: 98,
  cipLib: "SEROPLEX 20MG CPR BT 98",
  atcCode: "N06AB10"
}, {
  CIP7: '5709507',
  CIP13: '3400957095079',
  ucdLib: "SEROPLEX 5MG CPR",
  UCD7: '9273024',
  UCD13: '3400892730240',
  ucdQtyMultiplicator: 98,
  cipLib: "SEROPLEX 5MG CPR BT 98",
  atcCode: "N06AB10"
}, {
  CIP7: '2771664',
  CIP13: '3400927716645',
  ucdLib: "ESCITALOPRAM ARW 10MG CPR",
  UCD7: '9400310',
  UCD13: '3400894003106',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ARW 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2771724',
  CIP13: '3400927717246',
  ucdLib: "ESCITALOPRAM ARW 15MG CPR",
  UCD7: '9400327',
  UCD13: '3400894003274',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ARW 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2771799',
  CIP13: '3400927717994',
  ucdLib: "ESCITALOPRAM ARW 20MG CPR",
  UCD7: '9400333',
  UCD13: '3400894003335',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ARW 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2771598',
  CIP13: '3400927715983',
  ucdLib: "ESCITALOPRAM ARW 5MG CPR",
  UCD7: '9400356',
  UCD13: '3400894003564',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM ARW 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2771606',
  CIP13: '3400927716065',
  ucdLib: "ESCITALOPRAM ARW 5MG CPR",
  UCD7: '9400356',
  UCD13: '3400894003564',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ARW 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2771925',
  CIP13: '3400927719257',
  ucdLib: "ESCITALOPRAM MYG 10MG CPR",
  UCD7: '9400474',
  UCD13: '3400894004745',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM MYG 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2791112',
  CIP13: '3400927911125',
  ucdLib: "ESCITALOPRAM MYG 10MG CPR",
  UCD7: '9400474',
  UCD13: '3400894004745',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM MYG 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2771983',
  CIP13: '3400927719837',
  ucdLib: "ESCITALOPRAM MYG 15MG CPR",
  UCD7: '9400480',
  UCD13: '3400894004806',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM MYG 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2791129',
  CIP13: '3400927911293',
  ucdLib: "ESCITALOPRAM MYG 15MG CPR",
  UCD7: '9400480',
  UCD13: '3400894004806',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM MYG 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2772066',
  CIP13: '3400927720666',
  ucdLib: "ESCITALOPRAM MYG 20MG CPR",
  UCD7: '9400497',
  UCD13: '3400894004974',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM MYG 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2791135',
  CIP13: '3400927911354',
  ucdLib: "ESCITALOPRAM MYG 20MG CPR",
  UCD7: '9400497',
  UCD13: '3400894004974',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM MYG 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2771859',
  CIP13: '3400927718595',
  ucdLib: "ESCITALOPRAM MYG 5MG CPR",
  UCD7: '9400505',
  UCD13: '3400894005056',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM MYG 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2771865',
  CIP13: '3400927718656',
  ucdLib: "ESCITALOPRAM MYG 5MG CPR",
  UCD7: '9400505',
  UCD13: '3400894005056',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM MYG 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2791106',
  CIP13: '3400927911064',
  ucdLib: "ESCITALOPRAM MYG 5MG CPR",
  UCD7: '9400505',
  UCD13: '3400894005056',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM MYG 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2773870',
  CIP13: '3400927738708',
  ucdLib: "ESCITALOPRAM TVC 10MG CPR",
  UCD7: '9401775',
  UCD13: '3400894017752',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM TVC 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2773887',
  CIP13: '3400927738876',
  ucdLib: "ESCITALOPRAM TVC 15MG CPR",
  UCD7: '9401781',
  UCD13: '3400894017813',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM TVC 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2773893',
  CIP13: '3400927738937',
  ucdLib: "ESCITALOPRAM TVC 20MG CPR",
  UCD7: '9401798',
  UCD13: '3400894017981',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM TVC 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2773858',
  CIP13: '3400927738586',
  ucdLib: "ESCITALOPRAM TVC 5MG CPR",
  UCD7: '9401806',
  UCD13: '3400894018063',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM TVC 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2773864',
  CIP13: '3400927738647',
  ucdLib: "ESCITALOPRAM TVC 5MG CPR",
  UCD7: '9401806',
  UCD13: '3400894018063',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM TVC 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2773410',
  CIP13: '3400927734106',
  ucdLib: "ESCITALOPRAM ZTL 10MG CPR",
  UCD7: '9401812',
  UCD13: '3400894018124',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ZTL 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2773456',
  CIP13: '3400927734564',
  ucdLib: "ESCITALOPRAM ZTL 15MG CPR",
  UCD7: '9401829',
  UCD13: '3400894018292',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ZTL 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2773485',
  CIP13: '3400927734854',
  ucdLib: "ESCITALOPRAM ZTL 20MG CPR",
  UCD7: '9401835',
  UCD13: '3400894018353',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ZTL 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2773338',
  CIP13: '3400927733383',
  ucdLib: "ESCITALOPRAM ZTL 20MG/ML F15ML",
  UCD7: '9401841',
  UCD13: '3400894018414',
  ucdQtyMultiplicator: 1,
  cipLib: "ESCITALOPRAM ZTL 20MG/ML F15ML BT 1",
  atcCode: "N06AB10"
}, {
  CIP7: '2773367',
  CIP13: '3400927733673',
  ucdLib: "ESCITALOPRAM ZTL 5MG CPR",
  UCD7: '9401858',
  UCD13: '3400894018582',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM ZTL 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2773373',
  CIP13: '3400927733734',
  ucdLib: "ESCITALOPRAM ZTL 5MG CPR",
  UCD7: '9401858',
  UCD13: '3400894018582',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ZTL 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2774065',
  CIP13: '3400927740657',
  ucdLib: "ESCITALOPRAM ZYD 10MG CPR",
  UCD7: '9401278',
  UCD13: '3400894012788',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ZYD 10MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2774154',
  CIP13: '3400927741548',
  ucdLib: "ESCITALOPRAM ZYD 15MG CPR",
  UCD7: '9401284',
  UCD13: '3400894012849',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ZYD 15MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2774987',
  CIP13: '3400927749872',
  ucdLib: "ESCITALOPRAM ZYD 20MG CPR",
  UCD7: '9401290',
  UCD13: '3400894012900',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ZYD 20MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '2774042',
  CIP13: '3400927740428',
  ucdLib: "ESCITALOPRAM ZYD 5MG CPR",
  UCD7: '9401309',
  UCD13: '3400894013099',
  ucdQtyMultiplicator: 14,
  cipLib: "ESCITALOPRAM ZYD 5MG CPR BT 14",
  atcCode: "N06AB10"
}, {
  CIP7: '2774059',
  CIP13: '3400927740596',
  ucdLib: "ESCITALOPRAM ZYD 5MG CPR",
  UCD7: '9401309',
  UCD13: '3400894013099',
  ucdQtyMultiplicator: 28,
  cipLib: "ESCITALOPRAM ZYD 5MG CPR BT 28",
  atcCode: "N06AB10"
}, {
  CIP7: '3272911',
  CIP13: '3400932729111',
  ucdLib: "FLOXYFRAL 50MG CPR",
  UCD7: '9106881',
  UCD13: '3400891068818',
  ucdQtyMultiplicator: 30,
  cipLib: "FLOXYFRAL 50MG CPR BT 30",
  atcCode: "N06AB08"
}, {
  CIP7: '3319831',
  CIP13: '3400933198312',
  ucdLib: "FLOXYFRAL 100MG CPR",
  UCD7: '9158576',
  UCD13: '3400891585766',
  ucdQtyMultiplicator: 15,
  cipLib: "FLOXYFRAL 100MG CPR BT 15",
  atcCode: "N06AB08"
}, {
  CIP7: '3602449',
  CIP13: '3400936024496',
  ucdLib: "FLUVOXAMINE ARW 100MG CPR",
  UCD7: '9317543',
  UCD13: '3400893175439',
  ucdQtyMultiplicator: 15,
  cipLib: "FLUVOXAMINE ARW 100MG CPR BT 15",
  atcCode: "N06AB08"
}, {
  CIP7: '3602426',
  CIP13: '3400936024267',
  ucdLib: "FLUVOXAMINE ARW 50MG CPR",
  UCD7: '9317566',
  UCD13: '3400893175668',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVOXAMINE ARW 50MG CPR BT 30",
  atcCode: "N06AB08"
}, {
  CIP7: '3564708',
  CIP13: '3400935647085',
  ucdLib: "FLUVOXAMINE MYL 100MG CPR",
  UCD7: '9241509',
  UCD13: '3400892415093',
  ucdQtyMultiplicator: 15,
  cipLib: "FLUVOXAMINE MYL 100MG CPR BT 15",
  atcCode: "N06AB08"
}, {
  CIP7: '3564683',
  CIP13: '3400935646835',
  ucdLib: "FLUVOXAMINE MYL 50MG CPR",
  UCD7: '9241515',
  UCD13: '3400892415154',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVOXAMINE MYL 50MG CPR BT 30",
  atcCode: "N06AB08"
}, {
  CIP7: '3590516',
  CIP13: '3400935905161',
  ucdLib: "FLUVOXAMINE EG 100MG CPR",
  UCD7: '9243750',
  UCD13: '3400892437507',
  ucdQtyMultiplicator: 15,
  cipLib: "FLUVOXAMINE EG 100MG CPR BT 15",
  atcCode: "N06AB08"
}, {
  CIP7: '3590427',
  CIP13: '3400935904270',
  ucdLib: "FLUVOXAMINE EG 50MG CPR",
  UCD7: '9243767',
  UCD13: '3400892437675',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVOXAMINE EG 50MG CPR BT 30",
  atcCode: "N06AB08"
}, {
  CIP7: '3403419',
  CIP13: '3400934034190',
  ucdLib: "ZOLOFT 50MG GELU",
  UCD7: '9181718',
  UCD13: '3400891817188',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOLOFT 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3403425',
  CIP13: '3400934034251',
  ucdLib: "ZOLOFT 50MG GELU",
  UCD7: '9181718',
  UCD13: '3400891817188',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOLOFT 50MG GELU BT 30",
  atcCode: "N06AB06"
}, {
  CIP7: '3556181',
  CIP13: '3400935561817',
  ucdLib: "SERTRALINE PFZ 25MG GELU",
  UCD7: '9329718',
  UCD13: '3400893297186',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE PFZ 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3556206',
  CIP13: '3400935562067',
  ucdLib: "ZOLOFT 25MG GELU",
  UCD7: '9229230',
  UCD13: '3400892292304',
  ucdQtyMultiplicator: 7,
  cipLib: "ZOLOFT 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3701660',
  CIP13: '3400937016605',
  ucdLib: "SERTRALINE ALM 50MG GELU",
  UCD7: '9282365',
  UCD13: '3400892823652',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE ALM 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3697556',
  CIP13: '3400936975569',
  ucdLib: "SERTRALINE ARW 50MG GELU",
  UCD7: '9278292',
  UCD13: '3400892782928',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE ARW 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3697562',
  CIP13: '3400936975620',
  ucdLib: "SERTRALINE ARW 50MG GELU",
  UCD7: '9278292',
  UCD13: '3400892782928',
  ucdQtyMultiplicator: 30,
  cipLib: "SERTRALINE ARW 50MG GELU BT 30",
  atcCode: "N06AB06"
}, {
  CIP7: '3745634',
  CIP13: '3400937456340',
  ucdLib: "SERTRALINE BGA 25MG GELU",
  UCD7: '9289551',
  UCD13: '3400892895512',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE BGA 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3694552',
  CIP13: '3400936945524',
  ucdLib: "SERTRALINE BGA 50MG GELU",
  UCD7: '9276519',
  UCD13: '3400892765198',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE BGA 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3698053',
  CIP13: '3400936980532',
  ucdLib: "SERTRALINE EG 50MG GELU",
  UCD7: '9278300',
  UCD13: '3400892783000',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE EG 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3698225',
  CIP13: '3400936982253',
  ucdLib: "SERTRALINE EVO 50MG GELU",
  UCD7: '9279280',
  UCD13: '3400892792804',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE EVO 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3699532',
  CIP13: '3400936995321',
  ucdLib: "SERTRALINE MYL 50MG GELU",
  UCD7: '9278323',
  UCD13: '3400892783239',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE MYL 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3698018',
  CIP13: '3400936980181',
  ucdLib: "SERTRALINE RBX 50MG GELU",
  UCD7: '9278346',
  UCD13: '3400892783468',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE RBX 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3697929',
  CIP13: '3400936979291',
  ucdLib: "SERTRALINE RTP 50MG CPR",
  UCD7: '9278352',
  UCD13: '3400892783529',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE RTP 50MG CPR BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3766748',
  CIP13: '3400937667487',
  ucdLib: "SERTRALINE SDZ 50MG GELU",
  UCD7: '9278197',
  UCD13: '3400892781976',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE SDZ 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3698194',
  CIP13: '3400936981942',
  ucdLib: "SERTRALINE TVC 50MG GELU",
  UCD7: '9279104',
  UCD13: '3400892791043',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE TVC 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3698165',
  CIP13: '3400936981652',
  ucdLib: "SERTRALINE ZEN 50MG GELU",
  UCD7: '9278369',
  UCD13: '3400892783697',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE ZEN 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3715751',
  CIP13: '3400937157513',
  ucdLib: "SERTRALINE ZEN 25MG GELU",
  UCD7: '9284967',
  UCD13: '3400892849676',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE ZEN 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3712103',
  CIP13: '3400937121033',
  ucdLib: "SERTRALINE ZYF 25MG GELU",
  UCD7: '9283790',
  UCD13: '3400892837901',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE ZYF 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3712037',
  CIP13: '3400937120371',
  ucdLib: "SERTRALINE ZYF 50MG GELU",
  UCD7: '9283910',
  UCD13: '3400892839103',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE ZYF 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3802705',
  CIP13: '3400938027051',
  ucdLib: "SERTRALINE ARW 25MG GELU",
  UCD7: '9306284',
  UCD13: '3400893062845',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE ARW 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3731974',
  CIP13: '3400937319744',
  ucdLib: "SERTRALINE EG 25MG GELU",
  UCD7: '9285984',
  UCD13: '3400892859842',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE EG 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3732465',
  CIP13: '3400937324656',
  ucdLib: "SERTRALINE MYL 25MG GELU",
  UCD7: '9285990',
  UCD13: '3400892859903',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE MYL 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3731939',
  CIP13: '3400937319393',
  ucdLib: "SERTRALINE RBX 25MG GELU",
  UCD7: '9286541',
  UCD13: '3400892865416',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE RBX 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3732057',
  CIP13: '3400937320573',
  ucdLib: "SERTRALINE SDZ 25MG GELU",
  UCD7: '9287569',
  UCD13: '3400892875699',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE SDZ 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3732436',
  CIP13: '3400937324366',
  ucdLib: "SERTRALINE TVC 25MG GELU",
  UCD7: '9287061',
  UCD13: '3400892870618',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE TVC 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3975297',
  CIP13: '3400939752976',
  ucdLib: "SERTRALINE CRT 25MG GELU",
  UCD7: '9344037',
  UCD13: '3400893440377',
  ucdQtyMultiplicator: 7,
  cipLib: "SERTRALINE CRT 25MG GELU BT 7",
  atcCode: "N06AB06"
}, {
  CIP7: '3975400',
  CIP13: '3400939754000',
  ucdLib: "SERTRALINE CRT 50MG GELU",
  UCD7: '9344043',
  UCD13: '3400893440438',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE CRT 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '5631188',
  CIP13: '3400956311880',
  ucdLib: "ZOLOFT 25MG GELU",
  UCD7: '9229230',
  UCD13: '3400892292304',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOLOFT 25MG GELU BT 30",
  atcCode: "N06AB06"
}, {
  CIP7: '3998513',
  CIP13: '3400939985138',
  ucdLib: "SERTRALINE ALT 50MG GELU",
  UCD7: '9282603',
  UCD13: '3400892826035',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE ALT 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3422322',
  CIP13: '3400934223228',
  ucdLib: "SERTRALINE PFZ 50MG GELU",
  UCD7: '9329724',
  UCD13: '3400893297247',
  ucdQtyMultiplicator: 28,
  cipLib: "SERTRALINE PFZ 50MG GELU BT 28",
  atcCode: "N06AB06"
}, {
  CIP7: '3601125',
  CIP13: '3400936011250',
  ucdLib: "DIVARIUS 20MG CPR",
  UCD7: '9246027',
  UCD13: '3400892460277',
  ucdQtyMultiplicator: 14,
  cipLib: "DIVARIUS 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3601131',
  CIP13: '3400936011311',
  ucdLib: "DIVARIUS 20MG CPR",
  UCD7: '9246027',
  UCD13: '3400892460277',
  ucdQtyMultiplicator: 28,
  cipLib: "DIVARIUS 20MG CPR BT 28",
  atcCode: "N06AB05"
}, {
  CIP7: '3685470',
  CIP13: '3400936854703',
  ucdLib: "PAROXETINE ARW 20MG CPR",
  UCD7: '9272585',
  UCD13: '3400892725857',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE ARW 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3352538',
  CIP13: '3400933525385',
  ucdLib: "DEROXAT 20MG CPR",
  UCD7: '9170005',
  UCD13: '3400891700053',
  ucdQtyMultiplicator: 14,
  cipLib: "DEROXAT 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3677246',
  CIP13: '3400936772465',
  ucdLib: "PAROXETINE BGA 20MG CPR",
  UCD7: '9272964',
  UCD13: '3400892729640',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE BGA 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3599871',
  CIP13: '3400935998712',
  ucdLib: "PAROXETINE MYL 20MG CPR",
  UCD7: '9246955',
  UCD13: '3400892469553',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE MYL 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '5608189',
  CIP13: '3400956081899',
  ucdLib: "DEROXAT 20MG CPR",
  UCD7: '9170005',
  UCD13: '3400891700053',
  ucdQtyMultiplicator: 50,
  cipLib: "DEROXAT 20MG CPR BT 50",
  atcCode: "N06AB05"
}, {
  CIP7: '3742647',
  CIP13: '3400937426473',
  ucdLib: "PAROXETINE ALM 20MG CPR",
  UCD7: '9289404',
  UCD13: '3400892894041',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE ALM 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3742742',
  CIP13: '3400937427425',
  ucdLib: "PAROXETINE ALT 20MG CPR",
  UCD7: '9289396',
  UCD13: '3400892893969',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE ALT 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3697444',
  CIP13: '3400936974449',
  ucdLib: "PAROXETINE EG 20MG CPR",
  UCD7: '9278777',
  UCD13: '3400892787770',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE EG 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3742699',
  CIP13: '3400937426992',
  ucdLib: "PAROXETINE EVO 20MG CPR",
  UCD7: '9289373',
  UCD13: '3400892893730',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE EVO 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3741731',
  CIP13: '3400937417310',
  ucdLib: "PAROXETINE MYL 20MG CPR",
  UCD7: '9246955',
  UCD13: '3400892469553',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE MYL 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3695385',
  CIP13: '3400936953857',
  ucdLib: "PAROXETINE SDZ 20MG CPR PELL",
  UCD7: '9279334',
  UCD13: '3400892793344',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE SDZ 20MG CPR PELL BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3668750',
  CIP13: '3400936687509',
  ucdLib: "PAROXETINE ZEN 20MG CPR",
  UCD7: '9274526',
  UCD13: '3400892745268',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE ZEN 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3492860',
  CIP13: '3400934928604',
  ucdLib: "DEROXAT 20MG/10ML BUV FL150ML",
  UCD7: '9215073',
  UCD13: '3400892150734',
  ucdQtyMultiplicator: 1,
  cipLib: "DEROXAT 20MG/10ML BUV FL150ML BT 1",
  atcCode: "N06AB05"
}, {
  CIP7: '3779544',
  CIP13: '3400937795449',
  ucdLib: "PAROXETINE RTP 20MG CPR",
  UCD7: '9247050',
  UCD13: '3400892470504',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE RTP 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3797424',
  CIP13: '3400937974240',
  ucdLib: "PAROXETINE ZYD 20MG CPR",
  UCD7: '9301938',
  UCD13: '3400893019382',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE ZYD 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3867047',
  CIP13: '3400938670479',
  ucdLib: "PAROXETINE TVC 20MG CPR",
  UCD7: '9347828',
  UCD13: '3400893478288',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE TVC 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3934045',
  CIP13: '3400939340456',
  ucdLib: "PAROXETINE CRT 20MG CPR",
  UCD7: '9335179',
  UCD13: '3400893351796',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE CRT 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '2800503',
  CIP13: '3400928005038',
  ucdLib: "PAROXETINE RBX 20MG CPR",
  UCD7: '9408783',
  UCD13: '3400894087830',
  ucdQtyMultiplicator: 14,
  cipLib: "PAROXETINE RBX 20MG CPR BT 14",
  atcCode: "N06AB05"
}, {
  CIP7: '3616776',
  CIP13: '3400936167766',
  ucdLib: "CITALOPRAM MYL 20MG CPR",
  UCD7: '9256758',
  UCD13: '3400892567587',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM MYL 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3003135',
  CIP13: '3400930031353',
  ucdLib: "CITALOPRAM BGA 20MG CPR",
  UCD7: '9356796',
  UCD13: '3400893567968',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM BGA 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3000235',
  CIP13: '3400930002353',
  ucdLib: "CITALOPRAM MYL 20MG CPR",
  UCD7: '9256758',
  UCD13: '3400892567587',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM MYL 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '4917988',
  CIP13: '3400949179886',
  ucdLib: "CITALOPRAM EVO 20MG CPR",
  UCD7: '9356773',
  UCD13: '3400893567739',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM EVO 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3674325',
  CIP13: '3400936743250',
  ucdLib: "CITALOPRAM ZEN 20MG CPR",
  UCD7: '9269956',
  UCD13: '3400892699561',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM ZEN 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3465372',
  CIP13: '3400934653728',
  ucdLib: "SEROPRAM 40MG/ML BUV 12ML+SRG",
  UCD7: '9206418',
  UCD13: '3400892064185',
  ucdQtyMultiplicator: 1,
  cipLib: "SEROPRAM 40MG/ML BUV 12ML+SRG BT 1",
  atcCode: "N06AB04"
}, {
  CIP7: '3667727',
  CIP13: '3400936677272',
  ucdLib: "CITALOPRAM ARW 20MG CPR",
  UCD7: '9272579',
  UCD13: '3400892725796',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM ARW 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3667733',
  CIP13: '3400936677333',
  ucdLib: "CITALOPRAM ARW 20MG CPR",
  UCD7: '9272579',
  UCD13: '3400892725796',
  ucdQtyMultiplicator: 30,
  cipLib: "CITALOPRAM ARW 20MG CPR BT 30",
  atcCode: "N06AB04"
}, {
  CIP7: '3665088',
  CIP13: '3400936650886',
  ucdLib: "CITALOPRAM CRT 20MG CPR",
  UCD7: '9267420',
  UCD13: '3400892674209',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM CRT 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3667762',
  CIP13: '3400936677623',
  ucdLib: "CITALOPRAM EG 20MG CPR",
  UCD7: '9273509',
  UCD13: '3400892735092',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM EG 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3639406',
  CIP13: '3400936394063',
  ucdLib: "CITALOPRAM ISD 20MG CPR",
  UCD7: '9337988',
  UCD13: '3400893379882',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM ISD 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3639464',
  CIP13: '3400936394643',
  ucdLib: "CITALOPRAM SDZ 20MG CPR",
  UCD7: '9259627',
  UCD13: '3400892596273',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM SDZ 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3639352',
  CIP13: '3400936393523',
  ucdLib: "CITALOPRAM TVS 20MG CPR",
  UCD7: '9259900',
  UCD13: '3400892599007',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM TVS 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3383361',
  CIP13: '3400933833619',
  ucdLib: "SEROPRAM 20MG CPR",
  UCD7: '9176485',
  UCD13: '3400891764857',
  ucdQtyMultiplicator: 28,
  cipLib: "SEROPRAM 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3647713',
  CIP13: '3400936477131',
  ucdLib: "CITALOPRAM ALM 20MG CPR",
  UCD7: '9265757',
  UCD13: '3400892657578',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM ALM 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3737534',
  CIP13: '3400937375344',
  ucdLib: "CITALOPRAM ACT 20MG CPR",
  UCD7: '9356767',
  UCD13: '3400893567678',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM ACT 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3881716',
  CIP13: '3400938817164',
  ucdLib: "CITALOPRAM ZYD 20MG CPR",
  UCD7: '9321792',
  UCD13: '3400893217924',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM ZYD 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '5615580',
  CIP13: '3400956155804',
  ucdLib: "SEROPRAM 20MG PERF A.0,5ML",
  UCD7: '9202521',
  UCD13: '3400892025216',
  ucdQtyMultiplicator: 10,
  cipLib: "SEROPRAM 20MG PERF A.0,5ML BT 10",
  atcCode: "N06AB04"
}, {
  CIP7: '5615597',
  CIP13: '3400956155972',
  ucdLib: "SEROPRAM 40MG PERF AMP1ML",
  UCD7: '9202538',
  UCD13: '3400892025384',
  ucdQtyMultiplicator: 10,
  cipLib: "SEROPRAM 40MG PERF AMP1ML BT 10",
  atcCode: "N06AB04"
}, {
  CIP7: '3899768',
  CIP13: '3400938997682',
  ucdLib: "CITALOPRAM ALT 20MG CPR",
  UCD7: '9327027',
  UCD13: '3400893270271',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM ALT 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '3846163',
  CIP13: '3400938461633',
  ucdLib: "CITALOPRAM RBX 20MG CPR",
  UCD7: '9316360',
  UCD13: '3400893163603',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM RBX 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '2203316',
  CIP13: '3400922033167',
  ucdLib: "CITALOPRAM BGA 20MG CPR",
  UCD7: '9356796',
  UCD13: '3400893567968',
  ucdQtyMultiplicator: 28,
  cipLib: "CITALOPRAM BGA 20MG CPR BT 28",
  atcCode: "N06AB04"
}, {
  CIP7: '2172194',
  CIP13: '3400921721942',
  ucdLib: "CITALOPRAM BLF 20MG CPR",
  UCD7: '9383095',
  UCD13: '3400893830956',
  ucdQtyMultiplicator: 30,
  cipLib: "CITALOPRAM BLF 20MG CPR BT 30",
  atcCode: "N06AB04"
}, {
  CIP7: '5705107',
  CIP13: '3400957051075',
  ucdLib: "SEROPRAM 20MG CPR",
  UCD7: '9176485',
  UCD13: '3400891764857',
  ucdQtyMultiplicator: 98,
  cipLib: "SEROPRAM 20MG CPR BT 98",
  atcCode: "N06AB04"
}, {
  CIP7: '3450531',
  CIP13: '3400934505317',
  ucdLib: "PROZAC 20MG CPR DISP",
  UCD7: '9221978',
  UCD13: '3400892219783',
  ucdQtyMultiplicator: 28,
  cipLib: "PROZAC 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3838554',
  CIP13: '3400938385540',
  ucdLib: "FLUOXETINE BGA 20MG CPR DISP",
  UCD7: '9311782',
  UCD13: '3400893117828',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE BGA 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3838494',
  CIP13: '3400938384949',
  ucdLib: "FLUOXETINE EG 20MG CPR DISP",
  UCD7: '9312557',
  UCD13: '3400893125571',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE EG 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3832729',
  CIP13: '3400938327298',
  ucdLib: "FLUOXETINE LBR 20MG GELU",
  UCD7: '9313634',
  UCD13: '3400893136348',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE LBR 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3611804',
  CIP13: '3400936118041',
  ucdLib: "FLUOXETINE TVC 20MG GELU",
  UCD7: '9245051',
  UCD13: '3400892450513',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE TVC 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3310095',
  CIP13: '3400933100957',
  ucdLib: "PROZAC 20MG GELU",
  UCD7: '9137686',
  UCD13: '3400891376869',
  ucdQtyMultiplicator: 14,
  cipLib: "PROZAC 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '4914688',
  CIP13: '3400949146888',
  ucdLib: "FLUOXETINE ACT 20MG CPR DISP",
  UCD7: '9355207',
  UCD13: '3400893552070',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE ACT 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3688965',
  CIP13: '3400936889651',
  ucdLib: "FLUOXETINE ALM 20MG GELU",
  UCD7: '9277418',
  UCD13: '3400892774183',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE ALM 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3674561',
  CIP13: '3400936745612',
  ucdLib: "FLUOXETINE ZEN 20MG GELU",
  UCD7: '9270014',
  UCD13: '3400892700144',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE ZEN 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3360420',
  CIP13: '3400933604202',
  ucdLib: "PROZAC 20MG/5ML BUV FL70ML",
  UCD7: '9162371',
  UCD13: '3400891623710',
  ucdQtyMultiplicator: 1,
  cipLib: "PROZAC 20MG/5ML BUV FL70ML BT 1",
  atcCode: "N06AB03"
}, {
  CIP7: '3590597',
  CIP13: '3400935905970',
  ucdLib: "FLUOXETINE ARW 20MG GELU",
  UCD7: '9240639',
  UCD13: '3400892406398',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE ARW 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3510291',
  CIP13: '3400935102911',
  ucdLib: "FLUOXETINE MYL 20MG GELU",
  UCD7: '9233415',
  UCD13: '3400892334158',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE MYL 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3485535',
  CIP13: '3400934855351',
  ucdLib: "FLUOXETINE PHR 20MG GELU",
  UCD7: '9352195',
  UCD13: '3400893521953',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE PHR 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3658421',
  CIP13: '3400936584211',
  ucdLib: "FLUOXETINE SDZ 20MG GELU",
  UCD7: '9263936',
  UCD13: '3400892639369',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE SDZ 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3581718',
  CIP13: '3400935817181',
  ucdLib: "FLUOXETINE ARW 20MG/5ML FL70ML",
  UCD7: '9238157',
  UCD13: '3400892381572',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOXETINE ARW 20MG/5ML FL70ML BT 1",
  atcCode: "N06AB03"
}, {
  CIP7: '3548572',
  CIP13: '3400935485724',
  ucdLib: "FLUOXETINE BGA 20MG GELU",
  UCD7: '9227053',
  UCD13: '3400892270531',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE BGA 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3588376',
  CIP13: '3400935883766',
  ucdLib: "FLUOXETINE EG 20MG GELU",
  UCD7: '9236980',
  UCD13: '3400892369808',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE EG 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3540665',
  CIP13: '3400935406651',
  ucdLib: "FLUOXETINE EVO 20MG GELU",
  UCD7: '9312563',
  UCD13: '3400893125632',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE EVO 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3582511',
  CIP13: '3400935825117',
  ucdLib: "FLUOXETINE ZYD 20MG GELU",
  UCD7: '9257924',
  UCD13: '3400892579245',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE ZYD 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3631250',
  CIP13: '3400936312500',
  ucdLib: "FLUOXETINE CRT 20MG GELU",
  UCD7: '9257522',
  UCD13: '3400892575223',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE CRT 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3632048',
  CIP13: '3400936320482',
  ucdLib: "FLUOXETINE MYL 20MG CPR DISP",
  UCD7: '9259917',
  UCD13: '3400892599175',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE MYL 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3765660',
  CIP13: '3400937656603',
  ucdLib: "FLUOXETINE RBX 20MG GELU",
  UCD7: '9292323',
  UCD13: '3400892923239',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE RBX 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3645335',
  CIP13: '3400936453357',
  ucdLib: "FLUOXETINE BGA 20MG/5ML FL70ML",
  UCD7: '9261831',
  UCD13: '3400892618319',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOXETINE BGA 20MG/5ML FL70ML BT 1",
  atcCode: "N06AB03"
}, {
  CIP7: '3771531',
  CIP13: '3400937715317',
  ucdLib: "FLUOXETINE SDZ 20MG CPR DISP",
  UCD7: '9296605',
  UCD13: '3400892966052',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE SDZ 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3645364',
  CIP13: '3400936453647',
  ucdLib: "FLUOXETINE TVS 20MG CPR DISP",
  UCD7: '9270818',
  UCD13: '3400892708188',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE TVS 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3793886',
  CIP13: '3400937938860',
  ucdLib: "FLUOXETINE ZEN 20MG CPR DISP",
  UCD7: '9301884',
  UCD13: '3400893018842',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE ZEN 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3870428',
  CIP13: '3400938704280',
  ucdLib: "FLUOXETINE ALT 20MG GELU",
  UCD7: '9320953',
  UCD13: '3400893209530',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE ALT 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3806904',
  CIP13: '3400938069044',
  ucdLib: "FLUOXETINE ARW 20MG CPR DISP",
  UCD7: '9304894',
  UCD13: '3400893048948',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE ARW 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3804420',
  CIP13: '3400938044201',
  ucdLib: "FLUOXETINE ZYD 20MG CPR DISP",
  UCD7: '9304084',
  UCD13: '3400893040843',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE ZYD 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '3913356',
  CIP13: '3400939133560',
  ucdLib: "FLUOXETINE CRT 20MG CPR DISP",
  UCD7: '9328759',
  UCD13: '3400893287590',
  ucdQtyMultiplicator: 28,
  cipLib: "FLUOXETINE CRT 20MG CPR DISP BT 28",
  atcCode: "N06AB03"
}, {
  CIP7: '4940467',
  CIP13: '3400949404674',
  ucdLib: "FLUOXETINE ACC 20MG GELU",
  UCD7: '9361202',
  UCD13: '3400893612026',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE ACC 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '3986651',
  CIP13: '3400939866512',
  ucdLib: "FLUOXETINE ISD 20MG GELU",
  UCD7: '9343902',
  UCD13: '3400893439029',
  ucdQtyMultiplicator: 14,
  cipLib: "FLUOXETINE ISD 20MG GELU BT 14",
  atcCode: "N06AB03"
}, {
  CIP7: '5710953',
  CIP13: '3400957109530',
  ucdLib: "FLUOXETINE ARW 20MG CPR DISP",
  UCD7: '9304894',
  UCD13: '3400893048948',
  ucdQtyMultiplicator: 70,
  cipLib: "FLUOXETINE ARW 20MG CPR DISP BT 70",
  atcCode: "N06AB03"
}, {
  CIP7: '3222913',
  CIP13: '3400932229130',
  ucdLib: "LUDIOMIL 75MG CPR",
  UCD7: '9055273',
  UCD13: '3400890552738',
  ucdQtyMultiplicator: 28,
  cipLib: "LUDIOMIL 75MG CPR BT 28",
  atcCode: "N06AA21"
}, {
  CIP7: '3140233',
  CIP13: '3400931402336',
  ucdLib: "LUDIOMIL 25MG CPR",
  UCD7: '9055267',
  UCD13: '3400890552677',
  ucdQtyMultiplicator: 50,
  cipLib: "LUDIOMIL 25MG CPR BT 50",
  atcCode: "N06AA21"
}, {
  CIP7: '3333860',
  CIP13: '3400933338602',
  ucdLib: "DEFANYL 100MG CPR SECAB",
  UCD7: '9125648',
  UCD13: '3400891256482',
  ucdQtyMultiplicator: 30,
  cipLib: "DEFANYL 100MG CPR SECAB BT 30",
  atcCode: "N06AA17"
}, {
  CIP7: '3308603',
  CIP13: '3400933086039',
  ucdLib: "DEFANYL 50MG CPR",
  UCD7: '9130307',
  UCD13: '3400891303070',
  ucdQtyMultiplicator: 25,
  cipLib: "DEFANYL 50MG CPR BT 25",
  atcCode: "N06AA17"
}, {
  CIP7: '3250097',
  CIP13: '3400932500970',
  ucdLib: "PROTHIADEN 75MG CPR ENROB",
  UCD7: '9076424',
  UCD13: '3400890764247',
  ucdQtyMultiplicator: 20,
  cipLib: "PROTHIADEN 75MG CPR ENROB BT 20",
  atcCode: "N06AA16"
}, {
  CIP7: '3640154',
  CIP13: '3400936401549',
  ucdLib: "PROTHIADEN 25MG GELU",
  UCD7: '9076418',
  UCD13: '3400890764186',
  ucdQtyMultiplicator: 50,
  cipLib: "PROTHIADEN 25MG GELU BT 50",
  atcCode: "N06AA16"
}, {
  CIP7: '3332926',
  CIP13: '3400933329266',
  ucdLib: "QUITAXON 10MG CPR SECAB",
  UCD7: '9147041',
  UCD13: '3400891470413',
  ucdQtyMultiplicator: 40,
  cipLib: "QUITAXON 10MG CPR SECAB BT 40",
  atcCode: "N06AA12"
}, {
  CIP7: '3332932',
  CIP13: '3400933329327',
  ucdLib: "QUITAXON 50MG CPR SECAB",
  UCD7: '9147058',
  UCD13: '3400891470581',
  ucdQtyMultiplicator: 20,
  cipLib: "QUITAXON 50MG CPR SECAB BT 20",
  atcCode: "N06AA12"
}, {
  CIP7: '3126026',
  CIP13: '3400931260264',
  ucdLib: "QUITAXON 25MG INJ AMP2ML",
  UCD7: '9078044',
  UCD13: '3400890780445',
  ucdQtyMultiplicator: 10,
  cipLib: "QUITAXON 25MG INJ AMP2ML BT 10",
  atcCode: "N06AA12"
}, {
  CIP7: '3057302',
  CIP13: '3400930573020',
  ucdLib: "LAROXYL 25MG CPR",
  UCD7: '9049864',
  UCD13: '3400890498647',
  ucdQtyMultiplicator: 60,
  cipLib: "LAROXYL 25MG CPR BT 60",
  atcCode: "N06AA09"
}, {
  CIP7: '3057325',
  CIP13: '3400930573259',
  ucdLib: "LAROXYL 40MG/ML BUV FL20ML",
  UCD7: '9049887',
  UCD13: '3400890498876',
  ucdQtyMultiplicator: 1,
  cipLib: "LAROXYL 40MG/ML BUV FL20ML BT 1",
  atcCode: "N06AA09"
}, {
  CIP7: '3057319',
  CIP13: '3400930573198',
  ucdLib: "LAROXYL 50MG CPR",
  UCD7: '9049870',
  UCD13: '3400890498708',
  ucdQtyMultiplicator: 20,
  cipLib: "LAROXYL 50MG CPR BT 20",
  atcCode: "N06AA09"
}, {
  CIP7: '3057294',
  CIP13: '3400930572948',
  ucdLib: "LAROXYL 50MG INJ AMP2ML",
  UCD7: '9049858',
  UCD13: '3400890498586',
  ucdQtyMultiplicator: 12,
  cipLib: "LAROXYL 50MG INJ AMP2ML BT 12",
  atcCode: "N06AA09"
}, {
  CIP7: '3035163',
  CIP13: '3400930351635',
  ucdLib: "ELAVIL 25MG CPR",
  UCD7: '9030652',
  UCD13: '3400890306522',
  ucdQtyMultiplicator: 60,
  cipLib: "ELAVIL 25MG CPR BT 60",
  atcCode: "N06AA09"
}, {
  CIP7: '5553100',
  CIP13: '3400955531005',
  ucdLib: "LAROXYL 25MG CPR",
  UCD7: '9049864',
  UCD13: '3400890498647',
  ucdQtyMultiplicator: 100,
  cipLib: "LAROXYL 25MG CPR BT 100",
  atcCode: "N06AA09"
}, {
  CIP7: '3102267',
  CIP13: '3400931022671',
  ucdLib: "SURMONTIL 100MG CPR",
  UCD7: '9089616',
  UCD13: '3400890896160',
  ucdQtyMultiplicator: 20,
  cipLib: "SURMONTIL 100MG CPR BT 20",
  atcCode: "N06AA06"
}, {
  CIP7: '3102296',
  CIP13: '3400931022961',
  ucdLib: "SURMONTIL 25MG CPR",
  UCD7: '9089622',
  UCD13: '3400890896221',
  ucdQtyMultiplicator: 50,
  cipLib: "SURMONTIL 25MG CPR BT 50",
  atcCode: "N06AA06"
}, {
  CIP7: '3102250',
  CIP13: '3400931022503',
  ucdLib: "SURMONTIL 4% BUV FL30ML",
  UCD7: '9089639',
  UCD13: '3400890896399',
  ucdQtyMultiplicator: 1,
  cipLib: "SURMONTIL 4% BUV FL30ML BT 1",
  atcCode: "N06AA06"
}, {
  CIP7: '3004352',
  CIP13: '3400930043523',
  ucdLib: "ANAFRANIL 25MG CPR",
  UCD7: '9004614',
  UCD13: '3400890046145',
  ucdQtyMultiplicator: 50,
  cipLib: "ANAFRANIL 25MG CPR BT 50",
  atcCode: "N06AA04"
}, {
  CIP7: '3004346',
  CIP13: '3400930043462',
  ucdLib: "ANAFRANIL 25MG INJ AMP2ML",
  UCD7: '9004608',
  UCD13: '3400890046084',
  ucdQtyMultiplicator: 5,
  cipLib: "ANAFRANIL 25MG INJ AMP2ML BT 5",
  atcCode: "N06AA04"
}, {
  CIP7: '3037015',
  CIP13: '3400930370155',
  ucdLib: "ANAFRANIL 10MG CPR",
  UCD7: '9004583',
  UCD13: '3400890045834',
  ucdQtyMultiplicator: 60,
  cipLib: "ANAFRANIL 10MG CPR BT 60",
  atcCode: "N06AA04"
}, {
  CIP7: '3244843',
  CIP13: '3400932448432',
  ucdLib: "ANAFRANIL 75MG CPR PELLIC",
  UCD7: '9004577',
  UCD13: '3400890045773',
  ucdQtyMultiplicator: 20,
  cipLib: "ANAFRANIL 75MG CPR PELLIC BT 20",
  atcCode: "N06AA04"
}, {
  CIP7: '3689261',
  CIP13: '3400936892613',
  ucdLib: "CLOMIPRAMINE SDZ 10MG CPR",
  UCD7: '9273171',
  UCD13: '3400892731711',
  ucdQtyMultiplicator: 60,
  cipLib: "CLOMIPRAMINE SDZ 10MG CPR BT 60",
  atcCode: "N06AA04"
}, {
  CIP7: '3688362',
  CIP13: '3400936883628',
  ucdLib: "CLOMIPRAMINE SDZ 25MG CPR",
  UCD7: '9273188',
  UCD13: '3400892731889',
  ucdQtyMultiplicator: 50,
  cipLib: "CLOMIPRAMINE SDZ 25MG CPR BT 50",
  atcCode: "N06AA04"
}, {
  CIP7: '3680691',
  CIP13: '3400936806917',
  ucdLib: "CLOMIPRAMINE SDZ 75MG CPR",
  UCD7: '9268856',
  UCD13: '3400892688565',
  ucdQtyMultiplicator: 20,
  cipLib: "CLOMIPRAMINE SDZ 75MG CPR BT 20",
  atcCode: "N06AA04"
}, {
  CIP7: '3530141',
  CIP13: '3400935301413',
  ucdLib: "CLOMIPRAMINE MYL 75MG CPR",
  UCD7: '9221240',
  UCD13: '3400892212401',
  ucdQtyMultiplicator: 20,
  cipLib: "CLOMIPRAMINE MYL 75MG CPR BT 20",
  atcCode: "N06AA04"
}, {
  CIP7: '3420725',
  CIP13: '3400934207259',
  ucdLib: "CLOMIPRAMINE MYL 10MG CPR",
  UCD7: '9190261',
  UCD13: '3400891902617',
  ucdQtyMultiplicator: 60,
  cipLib: "CLOMIPRAMINE MYL 10MG CPR BT 60",
  atcCode: "N06AA04"
}, {
  CIP7: '3420783',
  CIP13: '3400934207839',
  ucdLib: "CLOMIPRAMINE MYL 25MG CPR",
  UCD7: '9190278',
  UCD13: '3400891902785',
  ucdQtyMultiplicator: 50,
  cipLib: "CLOMIPRAMINE MYL 25MG CPR BT 50",
  atcCode: "N06AA04"
}, {
  CIP7: '3106762',
  CIP13: '3400931067627',
  ucdLib: "TOFRANIL 10MG CPR",
  UCD7: '9093457',
  UCD13: '3400890934572',
  ucdQtyMultiplicator: 60,
  cipLib: "TOFRANIL 10MG CPR BT 60",
  atcCode: "N06AA02"
}, {
  CIP7: '3106779',
  CIP13: '3400931067795',
  ucdLib: "TOFRANIL 25MG CPR",
  UCD7: '9093486',
  UCD13: '3400890934862',
  ucdQtyMultiplicator: 100,
  cipLib: "TOFRANIL 25MG CPR BT 100",
  atcCode: "N06AA02"
}, {
  CIP7: '5825426',
  CIP13: '3400958254260',
  ucdLib: "DEXDOR 100MCG/ML AMP2ML",
  UCD7: '9385088',
  UCD13: '3400893850886',
  ucdQtyMultiplicator: 25,
  cipLib: "DEXDOR 100MCG/ML AMP2ML BT 25",
  atcCode: "N05CM18"
}, {
  CIP7: '3289716',
  CIP13: '3400932897162',
  ucdLib: "EUPHYTOSE CPR",
  UCD7: '9033739',
  UCD13: '3400890337397',
  ucdQtyMultiplicator: 120,
  cipLib: "EUPHYTOSE CPR BT 120",
  atcCode: "N05CM09"
}, {
  CIP7: '3311999',
  CIP13: '3400933119997',
  ucdLib: "ARKOGELULES VALERIANE",
  UCD7: '9134541',
  UCD13: '3400891345414',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES VALERIANE BT 45",
  atcCode: "N05CM09"
}, {
  CIP7: '3364398',
  CIP13: '3400933643980',
  ucdLib: "ARKOGELULES VALERIANE",
  UCD7: '9134541',
  UCD13: '3400891345414',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES VALERIANE BT 150",
  atcCode: "N05CM09"
}, {
  CIP7: '3362577',
  CIP13: '3400933625771',
  ucdLib: "ELUSANES VALER.200MG GELU",
  UCD7: '9170821',
  UCD13: '3400891708219',
  ucdQtyMultiplicator: 30,
  cipLib: "ELUSANES VALER.200MG GELU BT 30",
  atcCode: "N05CM09"
}, {
  CIP7: '3422598',
  CIP13: '3400934225987',
  ucdLib: "ELUSANES VALER.200MG GELU",
  UCD7: '9170821',
  UCD13: '3400891708219',
  ucdQtyMultiplicator: 60,
  cipLib: "ELUSANES VALER.200MG GELU BT 60",
  atcCode: "N05CM09"
}, {
  CIP7: '2249985',
  CIP13: '3400922499857',
  ucdLib: "CIRCADIN LP 2MG CPR",
  UCD7: '9294581',
  UCD13: '3400892945811',
  ucdQtyMultiplicator: 30,
  cipLib: "CIRCADIN LP 2MG CPR BT 30",
  atcCode: "N05CH01"
}, {
  CIP7: '3610302',
  CIP13: '3400936103023',
  ucdLib: "ZOLPIDEM BGA 10MG CPR",
  UCD7: '9259389',
  UCD13: '3400892593890',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM BGA 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3619125',
  CIP13: '3400936191259',
  ucdLib: "ZOLPIDEM SDZ 10MG CPR",
  UCD7: '9259395',
  UCD13: '3400892593951',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM SDZ 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3602596',
  CIP13: '3400936025967',
  ucdLib: "ZOLPIDEM EG 10MG CPR",
  UCD7: '9251181',
  UCD13: '3400892511818',
  ucdQtyMultiplicator: 7,
  cipLib: "ZOLPIDEM EG 10MG CPR BT 7",
  atcCode: "N05CF02"
}, {
  CIP7: '3602604',
  CIP13: '3400936026049',
  ucdLib: "ZOLPIDEM EG 10MG CPR",
  UCD7: '9251181',
  UCD13: '3400892511818',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM EG 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3609977',
  CIP13: '3400936099777',
  ucdLib: "ZOLPIDEM TVC 10MG CPR",
  UCD7: '9257166',
  UCD13: '3400892571669',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM TVC 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3671284',
  CIP13: '3400936712843',
  ucdLib: "ZOLPIDEM RPG 10MG CPR",
  UCD7: '9273946',
  UCD13: '3400892739465',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM RPG 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3674928',
  CIP13: '3400936749283',
  ucdLib: "ZOLPIDEM ZEN 10MG CPR",
  UCD7: '9270304',
  UCD13: '3400892703046',
  ucdQtyMultiplicator: 7,
  cipLib: "ZOLPIDEM ZEN 10MG CPR BT 7",
  atcCode: "N05CF02"
}, {
  CIP7: '3674934',
  CIP13: '3400936749344',
  ucdLib: "ZOLPIDEM ZEN 10MG CPR",
  UCD7: '9270304',
  UCD13: '3400892703046',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM ZEN 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3671309',
  CIP13: '3400936713093',
  ucdLib: "ZOLPIDEM ZYD 10MG CPR",
  UCD7: '9273691',
  UCD13: '3400892736914',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM ZYD 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3390361',
  CIP13: '3400933903619',
  ucdLib: "STILNOX 10MG CPR PELLIC",
  UCD7: '9123520',
  UCD13: '3400891235203',
  ucdQtyMultiplicator: 7,
  cipLib: "STILNOX 10MG CPR PELLIC BT 7",
  atcCode: "N05CF02"
}, {
  CIP7: '3621599',
  CIP13: '3400936215993',
  ucdLib: "ZOLPIDEM TVS 10MG CPR",
  UCD7: '9254877',
  UCD13: '3400892548777',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM TVS 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3465857',
  CIP13: '3400934658570',
  ucdLib: "STILNOX 10MG CPR PELLIC",
  UCD7: '9123520',
  UCD13: '3400891235203',
  ucdQtyMultiplicator: 14,
  cipLib: "STILNOX 10MG CPR PELLIC BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3638890',
  CIP13: '3400936388901',
  ucdLib: "ZOLPIDEM ARW 10MG CPR",
  UCD7: '9260033',
  UCD13: '3400892600338',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM ARW 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3645447',
  CIP13: '3400936454477',
  ucdLib: "ZOLPIDEM ACT 10MG CPR",
  UCD7: '9271114',
  UCD13: '3400892711140',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM ACT 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3645683',
  CIP13: '3400936456839',
  ucdLib: "ZOLPIDEM ALM 10MG CPR",
  UCD7: '9271120',
  UCD13: '3400892711201',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM ALM 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3645542',
  CIP13: '3400936455429',
  ucdLib: "ZOLPIDEM CRT 10MG CPR",
  UCD7: '9262196',
  UCD13: '3400892621968',
  ucdQtyMultiplicator: 7,
  cipLib: "ZOLPIDEM CRT 10MG CPR BT 7",
  atcCode: "N05CF02"
}, {
  CIP7: '3645571',
  CIP13: '3400936455719',
  ucdLib: "ZOLPIDEM CRT 10MG CPR",
  UCD7: '9262196',
  UCD13: '3400892621968',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM CRT 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3645045',
  CIP13: '3400936450455',
  ucdLib: "ZOLPIDEM MYL 10MG CPR",
  UCD7: '9260688',
  UCD13: '3400892606880',
  ucdQtyMultiplicator: 7,
  cipLib: "ZOLPIDEM MYL 10MG CPR BT 7",
  atcCode: "N05CF02"
}, {
  CIP7: '3645051',
  CIP13: '3400936450516',
  ucdLib: "ZOLPIDEM MYL 10MG CPR",
  UCD7: '9260688',
  UCD13: '3400892606880',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM MYL 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '3645097',
  CIP13: '3400936450974',
  ucdLib: "ZOLPIDEM MYL 10MG CPR",
  UCD7: '9260688',
  UCD13: '3400892606880',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM MYL 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '5631320',
  CIP13: '3400956313204',
  ucdLib: "STILNOX 10MG CPR PELLIC",
  UCD7: '9123520',
  UCD13: '3400891235203',
  ucdQtyMultiplicator: 150,
  cipLib: "STILNOX 10MG CPR PELLIC BT 150",
  atcCode: "N05CF02"
}, {
  CIP7: '3939019',
  CIP13: '3400939390192',
  ucdLib: "ZOLPIDEM ALT 10MG CPR",
  UCD7: '9335216',
  UCD13: '3400893352168',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOLPIDEM ALT 10MG CPR BT 14",
  atcCode: "N05CF02"
}, {
  CIP7: '5766161',
  CIP13: '3400957661618',
  ucdLib: "ZOLPIDEM ARW 10MG CPR",
  UCD7: '9260033',
  UCD13: '3400892600338',
  ucdQtyMultiplicator: 60,
  cipLib: "ZOLPIDEM ARW 10MG CPR BT 60",
  atcCode: "N05CF02"
}, {
  CIP7: '3614518',
  CIP13: '3400936145184',
  ucdLib: "ZOPICLONE TVC 7,5MG CPR",
  UCD7: '9245803',
  UCD13: '3400892458038',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE TVC 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3284989',
  CIP13: '3400932849895',
  ucdLib: "IMOVANE 7,5MG CPR",
  UCD7: '9119122',
  UCD13: '3400891191226',
  ucdQtyMultiplicator: 5,
  cipLib: "IMOVANE 7,5MG CPR BT 5",
  atcCode: "N05CF01"
}, {
  CIP7: '3001861',
  CIP13: '3400930018613',
  ucdLib: "ZOPICLONE BGA 7,5MG CPR",
  UCD7: '9219220',
  UCD13: '3400892192208',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE BGA 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3000367',
  CIP13: '3400930003671',
  ucdLib: "ZOPICLONE MYL 7,5MG CPR",
  UCD7: '9210816',
  UCD13: '3400892108162',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE MYL 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3274206',
  CIP13: '3400932742066',
  ucdLib: "IMOVANE 7,5MG CPR",
  UCD7: '9119122',
  UCD13: '3400891191226',
  ucdQtyMultiplicator: 20,
  cipLib: "IMOVANE 7,5MG CPR BT 20",
  atcCode: "N05CF01"
}, {
  CIP7: '3605241',
  CIP13: '3400936052413',
  ucdLib: "IMOVANE 3,75MG CPR",
  UCD7: '9249132',
  UCD13: '3400892491325',
  ucdQtyMultiplicator: 5,
  cipLib: "IMOVANE 3,75MG CPR BT 5",
  atcCode: "N05CF01"
}, {
  CIP7: '3605258',
  CIP13: '3400936052581',
  ucdLib: "IMOVANE 3,75MG CPR",
  UCD7: '9249132',
  UCD13: '3400892491325',
  ucdQtyMultiplicator: 14,
  cipLib: "IMOVANE 3,75MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3528629',
  CIP13: '3400935286291',
  ucdLib: "ZOPICLONE BGA 7,5MG CPR",
  UCD7: '9219220',
  UCD13: '3400892192208',
  ucdQtyMultiplicator: 5,
  cipLib: "ZOPICLONE BGA 7,5MG CPR BT 5",
  atcCode: "N05CF01"
}, {
  CIP7: '3528635',
  CIP13: '3400935286352',
  ucdLib: "ZOPICLONE BGA 7,5MG CPR",
  UCD7: '9219220',
  UCD13: '3400892192208',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE BGA 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3528575',
  CIP13: '3400935285751',
  ucdLib: "ZOPICLONE CRT 7,5MG CPR",
  UCD7: '9260702',
  UCD13: '3400892607023',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE CRT 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3524749',
  CIP13: '3400935247490',
  ucdLib: "ZOPICLONE EG 7,5MG CPR",
  UCD7: '9219237',
  UCD13: '3400892192376',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE EG 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3529853',
  CIP13: '3400935298539',
  ucdLib: "ZOPICLONE TVS 7,5MG CPR",
  UCD7: '9239961',
  UCD13: '3400892399614',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE TVS 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3558926',
  CIP13: '3400935589262',
  ucdLib: "ZOPICLONE ZYD 7,5MG CPR",
  UCD7: '9228957',
  UCD13: '3400892289571',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE ZYD 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3488746',
  CIP13: '3400934887468',
  ucdLib: "ZOPICLONE MYL 7,5MG CPR",
  UCD7: '9210816',
  UCD13: '3400892108162',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE MYL 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3658384',
  CIP13: '3400936583849',
  ucdLib: "ZOPICLONE SDZ 7,5MG CPR",
  UCD7: '9264108',
  UCD13: '3400892641089',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE SDZ 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3548247',
  CIP13: '3400935482471',
  ucdLib: "ZOPICLONE ARW 7,5MG CPR",
  UCD7: '9227320',
  UCD13: '3400892273204',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE ARW 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3812276',
  CIP13: '3400938122763',
  ucdLib: "ZOPICLONE ALT 7,5MG CPR",
  UCD7: '9303937',
  UCD13: '3400893039373',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE ALT 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3474856',
  CIP13: '3400934748561',
  ucdLib: "IMOVANE 7,5MG CPR",
  UCD7: '9119122',
  UCD13: '3400891191226',
  ucdQtyMultiplicator: 14,
  cipLib: "IMOVANE 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '5611949',
  CIP13: '3400956119493',
  ucdLib: "ZOPICLONE MYL 7,5MG CPR",
  UCD7: '9210816',
  UCD13: '3400892108162',
  ucdQtyMultiplicator: 100,
  cipLib: "ZOPICLONE MYL 7,5MG CPR BT 100",
  atcCode: "N05CF01"
}, {
  CIP7: '3802094',
  CIP13: '3400938020946',
  ucdLib: "ZOPICLONE RBX 7,5MG CPR",
  UCD7: '9317974',
  UCD13: '3400893179741',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE RBX 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '3897999',
  CIP13: '3400938979992',
  ucdLib: "ZOPICLONE ZEN 7,5MG CPR",
  UCD7: '9328400',
  UCD13: '3400893284001',
  ucdQtyMultiplicator: 5,
  cipLib: "ZOPICLONE ZEN 7,5MG CPR BT 5",
  atcCode: "N05CF01"
}, {
  CIP7: '3898007',
  CIP13: '3400938980073',
  ucdLib: "ZOPICLONE ZEN 7,5MG CPR",
  UCD7: '9328400',
  UCD13: '3400893284001',
  ucdQtyMultiplicator: 14,
  cipLib: "ZOPICLONE ZEN 7,5MG CPR BT 14",
  atcCode: "N05CF01"
}, {
  CIP7: '5747726',
  CIP13: '3400957477264',
  ucdLib: "IMOVANE 3,75MG CPR",
  UCD7: '9249132',
  UCD13: '3400892491325',
  ucdQtyMultiplicator: 30,
  cipLib: "IMOVANE 3,75MG CPR BT 30",
  atcCode: "N05CF01"
}, {
  CIP7: '5765954',
  CIP13: '3400957659547',
  ucdLib: "ZOPICLONE ARW 7,5MG CPR",
  UCD7: '9227320',
  UCD13: '3400892273204',
  ucdQtyMultiplicator: 60,
  cipLib: "ZOPICLONE ARW 7,5MG CPR BT 60",
  atcCode: "N05CF01"
}, {
  CIP7: '3248781',
  CIP13: '3400932487813',
  ucdLib: "HAVLANE CPR",
  UCD7: '9041986',
  UCD13: '3400890419864',
  ucdQtyMultiplicator: 20,
  cipLib: "HAVLANE CPR BT 20",
  atcCode: "N05CD11"
}, {
  CIP7: '5627264',
  CIP13: '3400956272648',
  ucdLib: "MIDAZOLAM MYL 1MG/ML AMP5ML",
  UCD7: '9235911',
  UCD13: '3400892359113',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM MYL 1MG/ML AMP5ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5627258',
  CIP13: '3400956272587',
  ucdLib: "MIDAZOLAM MYL 5MG/ML AMP10ML",
  UCD7: '9235928',
  UCD13: '3400892359281',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM MYL 5MG/ML AMP10ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5627241',
  CIP13: '3400956272419',
  ucdLib: "MIDAZOLAM MYL 5MG/ML AMP1ML",
  UCD7: '9237695',
  UCD13: '3400892376950',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM MYL 5MG/ML AMP1ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '2210871',
  CIP13: '3400922108711',
  ucdLib: "BUCCOLAM 10MG BUC SRG2ML",
  UCD7: '9382345',
  UCD13: '3400893823453',
  ucdQtyMultiplicator: 4,
  cipLib: "BUCCOLAM 10MG BUC SRG2ML BT 4",
  atcCode: "N05CD08"
}, {
  CIP7: '2210842',
  CIP13: '3400922108421',
  ucdLib: "BUCCOLAM 2,5MG BUC SRG0,5ML",
  UCD7: '9382316',
  UCD13: '3400893823163',
  ucdQtyMultiplicator: 4,
  cipLib: "BUCCOLAM 2,5MG BUC SRG0,5ML BT 4",
  atcCode: "N05CD08"
}, {
  CIP7: '2210859',
  CIP13: '3400922108599',
  ucdLib: "BUCCOLAM 5MG BUC SRG1ML",
  UCD7: '9382322',
  UCD13: '3400893823224',
  ucdQtyMultiplicator: 4,
  cipLib: "BUCCOLAM 5MG BUC SRG1ML BT 4",
  atcCode: "N05CD08"
}, {
  CIP7: '2210865',
  CIP13: '3400922108650',
  ucdLib: "BUCCOLAM 7,5MG BUC SRG1,5ML",
  UCD7: '9382339',
  UCD13: '3400893823392',
  ucdQtyMultiplicator: 4,
  cipLib: "BUCCOLAM 7,5MG BUC SRG1,5ML BT 4",
  atcCode: "N05CD08"
}, {
  CIP7: '5648711',
  CIP13: '3400956487110',
  ucdLib: "MIDAZOLAM AGT 1MG/ML AMP5ML",
  UCD7: '9249497',
  UCD13: '3400892494975',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM AGT 1MG/ML AMP5ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5648786',
  CIP13: '3400956487868',
  ucdLib: "MIDAZOLAM AGT 5MG/ML AMP10ML",
  UCD7: '9249511',
  UCD13: '3400892495118',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM AGT 5MG/ML AMP10ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5648734',
  CIP13: '3400956487349',
  ucdLib: "MIDAZOLAM AGT 5MG/ML AMP1ML",
  UCD7: '9249505',
  UCD13: '3400892495057',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM AGT 5MG/ML AMP1ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5648740',
  CIP13: '3400956487400',
  ucdLib: "MIDAZOLAM AGT 5MG/ML AMP1ML",
  UCD7: '9249505',
  UCD13: '3400892495057',
  ucdQtyMultiplicator: 50,
  cipLib: "MIDAZOLAM AGT 5MG/ML AMP1ML BT 50",
  atcCode: "N05CD08"
}, {
  CIP7: '5648763',
  CIP13: '3400956487639',
  ucdLib: "MIDAZOLAM AGT 5MG/ML AMP3ML",
  UCD7: '9249528',
  UCD13: '3400892495286',
  ucdQtyMultiplicator: 50,
  cipLib: "MIDAZOLAM AGT 5MG/ML AMP3ML BT 50",
  atcCode: "N05CD08"
}, {
  CIP7: '5736645',
  CIP13: '3400957366452',
  ucdLib: "MIDAZOLAM ACC 1MG/ML AMP5ML",
  UCD7: '9330489',
  UCD13: '3400893304891',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM ACC 1MG/ML AMP5ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5736674',
  CIP13: '3400957366742',
  ucdLib: "MIDAZOLAM ACC 5MG/ML AMP10ML",
  UCD7: '9334903',
  UCD13: '3400893349038',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM ACC 5MG/ML AMP10ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5736651',
  CIP13: '3400957366513',
  ucdLib: "MIDAZOLAM ACC 5MG/ML AMP1ML",
  UCD7: '9330495',
  UCD13: '3400893304952',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM ACC 5MG/ML AMP1ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5652167',
  CIP13: '3400956521678',
  ucdLib: "MIDAZOLAM PAN 1MG/ML AMP5ML",
  UCD7: '9256416',
  UCD13: '3400892564166',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM PAN 1MG/ML AMP5ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5652196',
  CIP13: '3400956521968',
  ucdLib: "MIDAZOLAM PAN 5MG/ML AMP1ML",
  UCD7: '9256422',
  UCD13: '3400892564227',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM PAN 5MG/ML AMP1ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '5652144',
  CIP13: '3400956521449',
  ucdLib: "MIDAZOLAM PAN 5MG/ML FL10ML",
  UCD7: '9256439',
  UCD13: '3400892564395',
  ucdQtyMultiplicator: 10,
  cipLib: "MIDAZOLAM PAN 5MG/ML FL10ML BT 10",
  atcCode: "N05CD08"
}, {
  CIP7: '3608570',
  CIP13: '3400936085701',
  ucdLib: "NORMISON 10MG CPR",
  UCD7: '9256445',
  UCD13: '3400892564456',
  ucdQtyMultiplicator: 14,
  cipLib: "NORMISON 10MG CPR BT 14",
  atcCode: "N05CD07"
}, {
  CIP7: '3608587',
  CIP13: '3400936085879',
  ucdLib: "NORMISON 20MG CPR",
  UCD7: '9256451',
  UCD13: '3400892564517',
  ucdQtyMultiplicator: 7,
  cipLib: "NORMISON 20MG CPR BT 7",
  atcCode: "N05CD07"
}, {
  CIP7: '3544700',
  CIP13: '3400935447005',
  ucdLib: "NOCTAMIDE 2MG CPR",
  UCD7: '9136557',
  UCD13: '3400891365573',
  ucdQtyMultiplicator: 14,
  cipLib: "NOCTAMIDE 2MG CPR BT 14",
  atcCode: "N05CD06"
}, {
  CIP7: '3496674',
  CIP13: '3400934966743',
  ucdLib: "NOCTAMIDE 1MG CPR",
  UCD7: '9136540',
  UCD13: '3400891365405',
  ucdQtyMultiplicator: 14,
  cipLib: "NOCTAMIDE 1MG CPR BT 14",
  atcCode: "N05CD06"
}, {
  CIP7: '2756707',
  CIP13: '3400927567070',
  ucdLib: "LORMETAZEPAM ARW 1MG CPR",
  UCD7: '9397967',
  UCD13: '3400893979679',
  ucdQtyMultiplicator: 14,
  cipLib: "LORMETAZEPAM ARW 1MG CPR BT 14",
  atcCode: "N05CD06"
}, {
  CIP7: '2756713',
  CIP13: '3400927567131',
  ucdLib: "LORMETAZEPAM ARW 2MG CPR",
  UCD7: '9397973',
  UCD13: '3400893979730',
  ucdQtyMultiplicator: 14,
  cipLib: "LORMETAZEPAM ARW 2MG CPR BT 14",
  atcCode: "N05CD06"
}, {
  CIP7: '3217906',
  CIP13: '3400932179060',
  ucdLib: "NUCTALON CPR",
  UCD7: '9064154',
  UCD13: '3400890641548',
  ucdQtyMultiplicator: 20,
  cipLib: "NUCTALON CPR BT 20",
  atcCode: "N05CD04"
}, {
  CIP7: '3553969',
  CIP13: '3400935539694',
  ucdLib: "MOGADON 5MG CPR",
  UCD7: '9228667',
  UCD13: '3400892286679',
  ucdQtyMultiplicator: 20,
  cipLib: "MOGADON 5MG CPR BT 20",
  atcCode: "N05CD02"
}, {
  CIP7: '5622031',
  CIP13: '3400956220311',
  ucdLib: "MOGADON 5MG CPR",
  UCD7: '9228667',
  UCD13: '3400892286679',
  ucdQtyMultiplicator: 100,
  cipLib: "MOGADON 5MG CPR BT 100",
  atcCode: "N05CD02"
}, {
  CIP7: '3228577',
  CIP13: '3400932285778',
  ucdLib: "STRESAM GELU",
  UCD7: '9088290',
  UCD13: '3400890882903',
  ucdQtyMultiplicator: 60,
  cipLib: "STRESAM GELU BT 60",
  atcCode: "N05BX03"
}, {
  CIP7: '3480259',
  CIP13: '3400934802591',
  ucdLib: "BUSPIRONE MYL 10MG CPR",
  UCD7: '9207493',
  UCD13: '3400892074931',
  ucdQtyMultiplicator: 20,
  cipLib: "BUSPIRONE MYL 10MG CPR BT 20",
  atcCode: "N05BE01"
}, {
  CIP7: '3766553',
  CIP13: '3400937665537',
  ucdLib: "BUSPIRONE SDZ 10MG CPR",
  UCD7: '9291536',
  UCD13: '3400892915364',
  ucdQtyMultiplicator: 20,
  cipLib: "BUSPIRONE SDZ 10MG CPR BT 20",
  atcCode: "N05BE01"
}, {
  CIP7: '3372251',
  CIP13: '3400933722517',
  ucdLib: "COVATINE 50MG CPR",
  UCD7: '9022635',
  UCD13: '3400890226356',
  ucdQtyMultiplicator: 45,
  cipLib: "COVATINE 50MG CPR BT 45",
  atcCode: "N05BB02"
}, {
  CIP7: '3613565',
  CIP13: '3400936135659',
  ucdLib: "HYDROXYZINE REN100MG INJ 2ML",
  UCD7: '9249706',
  UCD13: '3400892497068',
  ucdQtyMultiplicator: 10,
  cipLib: "HYDROXYZINE REN100MG INJ 2ML BT 10",
  atcCode: "N05BB01"
}, {
  CIP7: '3008137',
  CIP13: '3400930081372',
  ucdLib: "ATARAX 25MG CPR PELLIC",
  UCD7: '9007819',
  UCD13: '3400890078191',
  ucdQtyMultiplicator: 30,
  cipLib: "ATARAX 25MG CPR PELLIC BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '3008143',
  CIP13: '3400930081433',
  ucdLib: "ATARAX SIR FV200ML +SRG",
  UCD7: '9007794',
  UCD13: '3400890077941',
  ucdQtyMultiplicator: 1,
  cipLib: "ATARAX SIR FV200ML +SRG BT 1",
  atcCode: "N05BB01"
}, {
  CIP7: '3000623',
  CIP13: '3400930006238',
  ucdLib: "HYDROXYZINE CRT 25MG CPR",
  UCD7: '9407217',
  UCD13: '3400894072171',
  ucdQtyMultiplicator: 30,
  cipLib: "HYDROXYZINE CRT 25MG CPR BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '3000634',
  CIP13: '3400930006344',
  ucdLib: "HYDROXYZINE EG 25MG CPR",
  UCD7: '9407571',
  UCD13: '3400894075714',
  ucdQtyMultiplicator: 30,
  cipLib: "HYDROXYZINE EG 25MG CPR BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '3000646',
  CIP13: '3400930006467',
  ucdLib: "HYDROXYZINE TVC 25MG CPR",
  UCD7: '9408748',
  UCD13: '3400894087489',
  ucdQtyMultiplicator: 30,
  cipLib: "HYDROXYZINE TVC 25MG CPR BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '2789919',
  CIP13: '3400927899195',
  ucdLib: "HYDROXYZINE ARW 25MG CPR",
  UCD7: '9404489',
  UCD13: '3400894044895',
  ucdQtyMultiplicator: 30,
  cipLib: "HYDROXYZINE ARW 25MG CPR BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '2789807',
  CIP13: '3400927898075',
  ucdLib: "HYDROXYZINE BGA 25MG CPR",
  UCD7: '9406123',
  UCD13: '3400894061236',
  ucdQtyMultiplicator: 30,
  cipLib: "HYDROXYZINE BGA 25MG CPR BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '2789581',
  CIP13: '3400927895814',
  ucdLib: "HYDROXYZINE MYL 25MG CPR",
  UCD7: '9405201',
  UCD13: '3400894052012',
  ucdQtyMultiplicator: 30,
  cipLib: "HYDROXYZINE MYL 25MG CPR BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '2789687',
  CIP13: '3400927896873',
  ucdLib: "HYDROXYZINE SDZ 25MG CPR",
  UCD7: '9404928',
  UCD13: '3400894049289',
  ucdQtyMultiplicator: 30,
  cipLib: "HYDROXYZINE SDZ 25MG CPR BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '2789463',
  CIP13: '3400927894633',
  ucdLib: "HYDROXYZINE ZEN 25MG CPR",
  UCD7: '9408754',
  UCD13: '3400894087540',
  ucdQtyMultiplicator: 30,
  cipLib: "HYDROXYZINE ZEN 25MG CPR BT 30",
  atcCode: "N05BB01"
}, {
  CIP7: '3260670',
  CIP13: '3400932606702',
  ucdLib: "VERATRAN 10MG CPR",
  UCD7: '9098182',
  UCD13: '3400890981828',
  ucdQtyMultiplicator: 30,
  cipLib: "VERATRAN 10MG CPR BT 30",
  atcCode: "N05BA21"
}, {
  CIP7: '3260664',
  CIP13: '3400932606641',
  ucdLib: "VERATRAN 5MG CPR",
  UCD7: '9106786',
  UCD13: '3400891067866',
  ucdQtyMultiplicator: 30,
  cipLib: "VERATRAN 5MG CPR BT 30",
  atcCode: "N05BA21"
}, {
  CIP7: '3240302',
  CIP13: '3400932403028',
  ucdLib: "VICTAN 2MG CPR",
  UCD7: '9098667',
  UCD13: '3400890986670',
  ucdQtyMultiplicator: 30,
  cipLib: "VICTAN 2MG CPR BT 30",
  atcCode: "N05BA18"
}, {
  CIP7: '3272957',
  CIP13: '3400932729579',
  ucdLib: "NORDAZ 15MG CPR",
  UCD7: '9103227',
  UCD13: '3400891032277',
  ucdQtyMultiplicator: 30,
  cipLib: "NORDAZ 15MG CPR BT 30",
  atcCode: "N05BA16"
}, {
  CIP7: '3272963',
  CIP13: '3400932729630',
  ucdLib: "NORDAZ 7,5MG CPR",
  UCD7: '9103233',
  UCD13: '3400891032338',
  ucdQtyMultiplicator: 30,
  cipLib: "NORDAZ 7,5MG CPR BT 30",
  atcCode: "N05BA16"
}, {
  CIP7: '3456315',
  CIP13: '3400934563157',
  ucdLib: "ALPRAZOLAM ARW 0,25MG CPR",
  UCD7: '9273716',
  UCD13: '3400892737164',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ARW 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3456321',
  CIP13: '3400934563218',
  ucdLib: "ALPRAZOLAM ARW 0,50MG CPR",
  UCD7: '9273722',
  UCD13: '3400892737225',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ARW 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '5542183',
  CIP13: '3400955421832',
  ucdLib: "XANAX 0,25MG CPR",
  UCD7: '9101464',
  UCD13: '3400891014648',
  ucdQtyMultiplicator: 100,
  cipLib: "XANAX 0,25MG CPR BT 100",
  atcCode: "N05BA12"
}, {
  CIP7: '5542208',
  CIP13: '3400955422082',
  ucdLib: "XANAX 0,50MG CPR",
  UCD7: '9101470',
  UCD13: '3400891014709',
  ucdQtyMultiplicator: 100,
  cipLib: "XANAX 0,50MG CPR BT 100",
  atcCode: "N05BA12"
}, {
  CIP7: '5542214',
  CIP13: '3400955422143',
  ucdLib: "XANAX 1MG CPR",
  UCD7: '9125217',
  UCD13: '3400891252170',
  ucdQtyMultiplicator: 100,
  cipLib: "XANAX 1MG CPR BT 100",
  atcCode: "N05BA12"
}, {
  CIP7: '3264449',
  CIP13: '3400932644490',
  ucdLib: "XANAX 0,25MG CPR",
  UCD7: '9101464',
  UCD13: '3400891014648',
  ucdQtyMultiplicator: 30,
  cipLib: "XANAX 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3264455',
  CIP13: '3400932644551',
  ucdLib: "XANAX 0,50MG CPR",
  UCD7: '9101470',
  UCD13: '3400891014709',
  ucdQtyMultiplicator: 30,
  cipLib: "XANAX 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3620996',
  CIP13: '3400936209961',
  ucdLib: "ALPRAZOLAM CRT 0,25MG CPR",
  UCD7: '9329291',
  UCD13: '3400893292914',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM CRT 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3620967',
  CIP13: '3400936209671',
  ucdLib: "ALPRAZOLAM CRT 0,50MG CPR",
  UCD7: '9329316',
  UCD13: '3400893293164',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM CRT 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3485742',
  CIP13: '3400934857423',
  ucdLib: "ALPRAZOLAM EG 0,25MG CPR",
  UCD7: '9208469',
  UCD13: '3400892084695',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM EG 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3485759',
  CIP13: '3400934857591',
  ucdLib: "ALPRAZOLAM EG 0,50MG CPR",
  UCD7: '9208475',
  UCD13: '3400892084756',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM EG 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3620973',
  CIP13: '3400936209732',
  ucdLib: "ALPRAZOLAM ISD 0,25MG CPR",
  UCD7: '9351008',
  UCD13: '3400893510087',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ISD 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3620944',
  CIP13: '3400936209442',
  ucdLib: "ALPRAZOLAM ISD 0,50MG CPR",
  UCD7: '9351014',
  UCD13: '3400893510148',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ISD 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3483743',
  CIP13: '3400934837432',
  ucdLib: "ALPRAZOLAM MYL 0,25MG CPR",
  UCD7: '9207553',
  UCD13: '3400892075532',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM MYL 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3483766',
  CIP13: '3400934837661',
  ucdLib: "ALPRAZOLAM MYL 0,25MG CPR",
  UCD7: '9207553',
  UCD13: '3400892075532',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM MYL 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3483246',
  CIP13: '3400934832468',
  ucdLib: "ALPRAZOLAM MYL 0,50MG CPR",
  UCD7: '9207576',
  UCD13: '3400892075761',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM MYL 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3483252',
  CIP13: '3400934832529',
  ucdLib: "ALPRAZOLAM MYL 0,50MG CPR",
  UCD7: '9207576',
  UCD13: '3400892075761',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM MYL 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3483275',
  CIP13: '3400934832758',
  ucdLib: "ALPRAZOLAM MYL 1MG CPR",
  UCD7: '9207582',
  UCD13: '3400892075822',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM MYL 1MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3658289',
  CIP13: '3400936582897',
  ucdLib: "ALPRAZOLAM SDZ 0,25MG CPR",
  UCD7: '9263741',
  UCD13: '3400892637419',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM SDZ 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3658415',
  CIP13: '3400936584150',
  ucdLib: "ALPRAZOLAM SDZ 0,50MG CPR",
  UCD7: '9263758',
  UCD13: '3400892637587',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM SDZ 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3621004',
  CIP13: '3400936210042',
  ucdLib: "ALPRAZOLAM TVC 0,25MG CPR",
  UCD7: '9254268',
  UCD13: '3400892542683',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM TVC 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3620950',
  CIP13: '3400936209503',
  ucdLib: "ALPRAZOLAM TVC 0,50MG CPR",
  UCD7: '9254274',
  UCD13: '3400892542744',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM TVC 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3581782',
  CIP13: '3400935817822',
  ucdLib: "ALPRAZOLAM ALT 0,25MG CPR",
  UCD7: '9280811',
  UCD13: '3400892808116',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ALT 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3581776',
  CIP13: '3400935817761',
  ucdLib: "ALPRAZOLAM ALT 0,50MG CPR",
  UCD7: '9280828',
  UCD13: '3400892808284',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ALT 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3642911',
  CIP13: '3400936429116',
  ucdLib: "ALPRAZOLAM BGA 0,25MG CPR",
  UCD7: '9209492',
  UCD13: '3400892094922',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM BGA 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3642905',
  CIP13: '3400936429055',
  ucdLib: "ALPRAZOLAM BGA 0,50MG CPR",
  UCD7: '9209500',
  UCD13: '3400892095004',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM BGA 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3780091',
  CIP13: '3400937800914',
  ucdLib: "ALPRAZOLAM ZYD 0,25MG CPR",
  UCD7: '9222742',
  UCD13: '3400892227429',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ZYD 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '3780085',
  CIP13: '3400937800853',
  ucdLib: "ALPRAZOLAM ZYD 0,50MG CPR",
  UCD7: '9222759',
  UCD13: '3400892227597',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ZYD 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '5618199',
  CIP13: '3400956181995',
  ucdLib: "ALPRAZOLAM MYL 0,25MG CPR",
  UCD7: '9207553',
  UCD13: '3400892075532',
  ucdQtyMultiplicator: 100,
  cipLib: "ALPRAZOLAM MYL 0,25MG CPR BT 100",
  atcCode: "N05BA12"
}, {
  CIP7: '5618213',
  CIP13: '3400956182138',
  ucdLib: "ALPRAZOLAM MYL 0,50MG CPR",
  UCD7: '9207576',
  UCD13: '3400892075761',
  ucdQtyMultiplicator: 100,
  cipLib: "ALPRAZOLAM MYL 0,50MG CPR BT 100",
  atcCode: "N05BA12"
}, {
  CIP7: '4969525',
  CIP13: '3400949695256',
  ucdLib: "ALPRAZOLAM ZEN 0,25MG CPR",
  UCD7: '9269689',
  UCD13: '3400892696898',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ZEN 0,25MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '4969531',
  CIP13: '3400949695317',
  ucdLib: "ALPRAZOLAM ZEN 0,50MG CPR",
  UCD7: '9269695',
  UCD13: '3400892696959',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRAZOLAM ZEN 0,50MG CPR BT 30",
  atcCode: "N05BA12"
}, {
  CIP7: '5766698',
  CIP13: '3400957666989',
  ucdLib: "ALPRAZOLAM ARW 0,25MG CPR",
  UCD7: '9273716',
  UCD13: '3400892737164',
  ucdQtyMultiplicator: 60,
  cipLib: "ALPRAZOLAM ARW 0,25MG CPR BT 60",
  atcCode: "N05BA12"
}, {
  CIP7: '5766706',
  CIP13: '3400957667061',
  ucdLib: "ALPRAZOLAM ARW 0,50MG CPR",
  UCD7: '9273722',
  UCD13: '3400892737225',
  ucdQtyMultiplicator: 60,
  cipLib: "ALPRAZOLAM ARW 0,50MG CPR BT 60",
  atcCode: "N05BA12"
}, {
  CIP7: '3311686',
  CIP13: '3400933116866',
  ucdLib: "LYSANXIA 15MG/ML BUV GTT 20ML",
  UCD7: '9133642',
  UCD13: '3400891336429',
  ucdQtyMultiplicator: 1,
  cipLib: "LYSANXIA 15MG/ML BUV GTT 20ML BT 1",
  atcCode: "N05BA11"
}, {
  CIP7: '3261072',
  CIP13: '3400932610723',
  ucdLib: "LYSANXIA 40MG CPR",
  UCD7: '9055675',
  UCD13: '3400890556750',
  ucdQtyMultiplicator: 20,
  cipLib: "LYSANXIA 40MG CPR BT 20",
  atcCode: "N05BA11"
}, {
  CIP7: '3533984',
  CIP13: '3400935339843',
  ucdLib: "PRAZEPAM ARW 10MG CPR",
  UCD7: '9353289',
  UCD13: '3400893532898',
  ucdQtyMultiplicator: 40,
  cipLib: "PRAZEPAM ARW 10MG CPR BT 40",
  atcCode: "N05BA11"
}, {
  CIP7: '3533949',
  CIP13: '3400935339492',
  ucdLib: "PRAZEPAM BGA 10MG CPR",
  UCD7: '9353272',
  UCD13: '3400893532720',
  ucdQtyMultiplicator: 40,
  cipLib: "PRAZEPAM BGA 10MG CPR BT 40",
  atcCode: "N05BA11"
}, {
  CIP7: '3183662',
  CIP13: '3400931836629',
  ucdLib: "LYSANXIA 10MG CPR",
  UCD7: '9055669',
  UCD13: '3400890556699',
  ucdQtyMultiplicator: 40,
  cipLib: "LYSANXIA 10MG CPR BT 40",
  atcCode: "N05BA11"
}, {
  CIP7: '3975512',
  CIP13: '3400939755120',
  ucdLib: "PRAZEPAM EG 10MG CPR",
  UCD7: '9343687',
  UCD13: '3400893436875',
  ucdQtyMultiplicator: 40,
  cipLib: "PRAZEPAM EG 10MG CPR BT 40",
  atcCode: "N05BA11"
}, {
  CIP7: '3001628',
  CIP13: '3400930016282',
  ucdLib: "LIKOZAM 1MG/ML BUV FL150ML+S.",
  UCD7: '9400391',
  UCD13: '3400894003915',
  ucdQtyMultiplicator: 1,
  cipLib: "LIKOZAM 1MG/ML BUV FL150ML+S. BT 1",
  atcCode: "N05BA09"
}, {
  CIP7: '3252073',
  CIP13: '3400932520732',
  ucdLib: "URBANYL 20MG CPR",
  UCD7: '9096579',
  UCD13: '3400890965798',
  ucdQtyMultiplicator: 30,
  cipLib: "URBANYL 20MG CPR BT 30",
  atcCode: "N05BA09"
}, {
  CIP7: '3181373',
  CIP13: '3400931813736',
  ucdLib: "URBANYL 10MG CPR",
  UCD7: '9096562',
  UCD13: '3400890965620',
  ucdQtyMultiplicator: 30,
  cipLib: "URBANYL 10MG CPR BT 30",
  atcCode: "N05BA09"
}, {
  CIP7: '3172380',
  CIP13: '3400931723806',
  ucdLib: "URBANYL 5MG GELU",
  UCD7: '9096585',
  UCD13: '3400890965859',
  ucdQtyMultiplicator: 30,
  cipLib: "URBANYL 5MG GELU BT 30",
  atcCode: "N05BA09"
}, {
  CIP7: '3610673',
  CIP13: '3400936106734',
  ucdLib: "BROMAZEPAM ARW 6MG CPR",
  UCD7: '9247713',
  UCD13: '3400892477138',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM ARW 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3000810',
  CIP13: '3400930008102',
  ucdLib: "BROMAZEPAM ARW 6MG CPR",
  UCD7: '9247713',
  UCD13: '3400892477138',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM ARW 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3674348',
  CIP13: '3400936743489',
  ucdLib: "BROMAZEPAM ZEN 6MG CPR",
  UCD7: '9269790',
  UCD13: '3400892697901',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM ZEN 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3855446',
  CIP13: '3400938554465',
  ucdLib: "BROMAZEPAM CRT 6MG CPR",
  UCD7: '9316130',
  UCD13: '3400893161302',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM CRT 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3488427',
  CIP13: '3400934884276',
  ucdLib: "BROMAZEPAM EG 6MG CPR",
  UCD7: '9209575',
  UCD13: '3400892095752',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM EG 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3488350',
  CIP13: '3400934883507',
  ucdLib: "BROMAZEPAM MYL 6MG CPR",
  UCD7: '9209581',
  UCD13: '3400892095813',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM MYL 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3658332',
  CIP13: '3400936583320',
  ucdLib: "BROMAZEPAM SDZ 6MG CPR",
  UCD7: '9263818',
  UCD13: '3400892638188',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM SDZ 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3488367',
  CIP13: '3400934883675',
  ucdLib: "BROMAZEPAM ZYD 6MG CPR",
  UCD7: '9222794',
  UCD13: '3400892227948',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM ZYD 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3174284',
  CIP13: '3400931742845',
  ucdLib: "LEXOMIL 6MG CPR",
  UCD7: '9054061',
  UCD13: '3400890540612',
  ucdQtyMultiplicator: 30,
  cipLib: "LEXOMIL 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3477228',
  CIP13: '3400934772283',
  ucdLib: "BROMAZEPAM BGA 6MG CPR",
  UCD7: '9206335',
  UCD13: '3400892063355',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM BGA 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3792036',
  CIP13: '3400937920360',
  ucdLib: "BROMAZEPAM TVC 6MG CPR",
  UCD7: '9244531',
  UCD13: '3400892445311',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM TVC 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '3802585',
  CIP13: '3400938025859',
  ucdLib: "BROMAZEPAM ISD 6MG CPR",
  UCD7: '9305652',
  UCD13: '3400893056523',
  ucdQtyMultiplicator: 30,
  cipLib: "BROMAZEPAM ISD 6MG CPR BT 30",
  atcCode: "N05BA08"
}, {
  CIP7: '5619537',
  CIP13: '3400956195374',
  ucdLib: "LEXOMIL 6MG CPR",
  UCD7: '9054061',
  UCD13: '3400890540612',
  ucdQtyMultiplicator: 100,
  cipLib: "LEXOMIL 6MG CPR BT 100",
  atcCode: "N05BA08"
}, {
  CIP7: '2771397',
  CIP13: '3400927713972',
  ucdLib: "BROMAZEPAM ARW 1,5MG CPR",
  UCD7: '9399469',
  UCD13: '3400893994696',
  ucdQtyMultiplicator: 120,
  cipLib: "BROMAZEPAM ARW 1,5MG CPR BT 120",
  atcCode: "N05BA08"
}, {
  CIP7: '3574693',
  CIP13: '3400935746931',
  ucdLib: "TEMESTA 1MG CPR",
  UCD7: '9090884',
  UCD13: '3400890908849',
  ucdQtyMultiplicator: 30,
  cipLib: "TEMESTA 1MG CPR BT 30",
  atcCode: "N05BA06"
}, {
  CIP7: '3404382',
  CIP13: '3400934043826',
  ucdLib: "LORAZEPAM MYL 1MG CPR",
  UCD7: '9179816',
  UCD13: '3400891798166',
  ucdQtyMultiplicator: 30,
  cipLib: "LORAZEPAM MYL 1MG CPR BT 30",
  atcCode: "N05BA06"
}, {
  CIP7: '3148996',
  CIP13: '3400931489962',
  ucdLib: "TEMESTA 2,5MG CPR",
  UCD7: '9090890',
  UCD13: '3400890908900',
  ucdQtyMultiplicator: 30,
  cipLib: "TEMESTA 2,5MG CPR BT 30",
  atcCode: "N05BA06"
}, {
  CIP7: '3365156',
  CIP13: '3400933651565',
  ucdLib: "LORAZEPAM MYL 2,5MG CPR",
  UCD7: '9179822',
  UCD13: '3400891798227',
  ucdQtyMultiplicator: 30,
  cipLib: "LORAZEPAM MYL 2,5MG CPR BT 30",
  atcCode: "N05BA06"
}, {
  CIP7: '5540936',
  CIP13: '3400955409366',
  ucdLib: "TRANXENE 20MG INJ FL+AMP",
  UCD7: '9094362',
  UCD13: '3400890943628',
  ucdQtyMultiplicator: 20,
  cipLib: "TRANXENE 20MG INJ FL+AMP BT 20",
  atcCode: "N05BA05"
}, {
  CIP7: '3243016',
  CIP13: '3400932430161',
  ucdLib: "TRANXENE 20MG INJ FL+AMP",
  UCD7: '9094362',
  UCD13: '3400890943628',
  ucdQtyMultiplicator: 5,
  cipLib: "TRANXENE 20MG INJ FL+AMP BT 5",
  atcCode: "N05BA05"
}, {
  CIP7: '5590035',
  CIP13: '3400955900351',
  ucdLib: "TRANXENE 10MG GELU",
  UCD7: '9094333',
  UCD13: '3400890943338',
  ucdQtyMultiplicator: 50,
  cipLib: "TRANXENE 10MG GELU BT 50",
  atcCode: "N05BA05"
}, {
  CIP7: '5590029',
  CIP13: '3400955900290',
  ucdLib: "TRANXENE 5MG GELU",
  UCD7: '9094379',
  UCD13: '3400890943796',
  ucdQtyMultiplicator: 50,
  cipLib: "TRANXENE 5MG GELU BT 50",
  atcCode: "N05BA05"
}, {
  CIP7: '3629885',
  CIP13: '3400936298859',
  ucdLib: "TRANXENE 20MG GELU",
  UCD7: '9268572',
  UCD13: '3400892685724',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANXENE 20MG GELU BT 28",
  atcCode: "N05BA05"
}, {
  CIP7: '3770135',
  CIP13: '3400937701358',
  ucdLib: "TRANXENE 10MG GELU",
  UCD7: '9094333',
  UCD13: '3400890943338',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANXENE 10MG GELU BT 30",
  atcCode: "N05BA05"
}, {
  CIP7: '3770129',
  CIP13: '3400937701297',
  ucdLib: "TRANXENE 5MG GELU",
  UCD7: '9094379',
  UCD13: '3400890943796',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANXENE 5MG GELU BT 30",
  atcCode: "N05BA05"
}, {
  CIP7: '5653623',
  CIP13: '3400956536238',
  ucdLib: "TRANXENE 20MG GELU",
  UCD7: '9268572',
  UCD13: '3400892685724',
  ucdQtyMultiplicator: 50,
  cipLib: "TRANXENE 20MG GELU BT 50",
  atcCode: "N05BA05"
}, {
  CIP7: '5533706',
  CIP13: '3400955337065',
  ucdLib: "SERESTA 50MG CPR SECAB",
  UCD7: '9083720',
  UCD13: '3400890837200',
  ucdQtyMultiplicator: 100,
  cipLib: "SERESTA 50MG CPR SECAB BT 100",
  atcCode: "N05BA04"
}, {
  CIP7: '3095969',
  CIP13: '3400930959695',
  ucdLib: "SERESTA 50MG CPR SECAB",
  UCD7: '9083720',
  UCD13: '3400890837200',
  ucdQtyMultiplicator: 20,
  cipLib: "SERESTA 50MG CPR SECAB BT 20",
  atcCode: "N05BA04"
}, {
  CIP7: '3588755',
  CIP13: '3400935887559',
  ucdLib: "SERESTA 10MG CPR",
  UCD7: '9083714',
  UCD13: '3400890837149',
  ucdQtyMultiplicator: 30,
  cipLib: "SERESTA 10MG CPR BT 30",
  atcCode: "N05BA04"
}, {
  CIP7: '5789618',
  CIP13: '3400957896188',
  ucdLib: "SERESTA 10MG CPR",
  UCD7: '9083714',
  UCD13: '3400890837149',
  ucdQtyMultiplicator: 100,
  cipLib: "SERESTA 10MG CPR BT 100",
  atcCode: "N05BA04"
}, {
  CIP7: '5544383',
  CIP13: '3400955443834',
  ucdLib: "VALIUM 10MG CPR",
  UCD7: '9097260',
  UCD13: '3400890972604',
  ucdQtyMultiplicator: 100,
  cipLib: "VALIUM 10MG CPR BT 100",
  atcCode: "N05BA01"
}, {
  CIP7: '5544360',
  CIP13: '3400955443605',
  ucdLib: "VALIUM 2MG CPR",
  UCD7: '9097283',
  UCD13: '3400890972833',
  ucdQtyMultiplicator: 100,
  cipLib: "VALIUM 2MG CPR BT 100",
  atcCode: "N05BA01"
}, {
  CIP7: '5544377',
  CIP13: '3400955443773',
  ucdLib: "VALIUM 5MG CPR",
  UCD7: '9097314',
  UCD13: '3400890973144',
  ucdQtyMultiplicator: 100,
  cipLib: "VALIUM 5MG CPR BT 100",
  atcCode: "N05BA01"
}, {
  CIP7: '3111303',
  CIP13: '3400931113034',
  ucdLib: "VALIUM 1% BUV GTT FV20ML",
  UCD7: '9097248',
  UCD13: '3400890972482',
  ucdQtyMultiplicator: 1,
  cipLib: "VALIUM 1% BUV GTT FV20ML BT 1",
  atcCode: "N05BA01"
}, {
  CIP7: '3111272',
  CIP13: '3400931112723',
  ucdLib: "VALIUM 10MG CPR",
  UCD7: '9097260',
  UCD13: '3400890972604',
  ucdQtyMultiplicator: 30,
  cipLib: "VALIUM 10MG CPR BT 30",
  atcCode: "N05BA01"
}, {
  CIP7: '3111243',
  CIP13: '3400931112433',
  ucdLib: "VALIUM 10MG INJ AMP2ML",
  UCD7: '9097254',
  UCD13: '3400890972543',
  ucdQtyMultiplicator: 6,
  cipLib: "VALIUM 10MG INJ AMP2ML BT 6",
  atcCode: "N05BA01"
}, {
  CIP7: '3111266',
  CIP13: '3400931112662',
  ucdLib: "VALIUM 2MG CPR",
  UCD7: '9097283',
  UCD13: '3400890972833',
  ucdQtyMultiplicator: 40,
  cipLib: "VALIUM 2MG CPR BT 40",
  atcCode: "N05BA01"
}, {
  CIP7: '3111289',
  CIP13: '3400931112891',
  ucdLib: "VALIUM 5MG CPR",
  UCD7: '9097314',
  UCD13: '3400890973144',
  ucdQtyMultiplicator: 40,
  cipLib: "VALIUM 5MG CPR BT 40",
  atcCode: "N05BA01"
}, {
  CIP7: '3253115',
  CIP13: '3400932531158',
  ucdLib: "DIAZEPAM TVC 10MG CPR",
  UCD7: '9147101',
  UCD13: '3400891471014',
  ucdQtyMultiplicator: 30,
  cipLib: "DIAZEPAM TVC 10MG CPR BT 30",
  atcCode: "N05BA01"
}, {
  CIP7: '3253109',
  CIP13: '3400932531097',
  ucdLib: "DIAZEPAM TVC 2MG CPR",
  UCD7: '9147118',
  UCD13: '3400891471182',
  ucdQtyMultiplicator: 40,
  cipLib: "DIAZEPAM TVC 2MG CPR BT 40",
  atcCode: "N05BA01"
}, {
  CIP7: '3253090',
  CIP13: '3400932530908',
  ucdLib: "DIAZEPAM TVC 5MG CPR",
  UCD7: '9147124',
  UCD13: '3400891471243',
  ucdQtyMultiplicator: 40,
  cipLib: "DIAZEPAM TVC 5MG CPR BT 40",
  atcCode: "N05BA01"
}, {
  CIP7: '5637676',
  CIP13: '3400956376766',
  ucdLib: "DIAZEPAM REN 10MG INJ A.2ML",
  UCD7: '9238677',
  UCD13: '3400892386775',
  ucdQtyMultiplicator: 100,
  cipLib: "DIAZEPAM REN 10MG INJ A.2ML BT 100",
  atcCode: "N05BA01"
}, {
  CIP7: '4176687',
  CIP13: '3400941766879',
  ucdLib: "XEPLION 100MG INJ LP SRG",
  UCD7: '9387377',
  UCD13: '3400893873779',
  ucdQtyMultiplicator: 1,
  cipLib: "XEPLION 100MG INJ LP SRG BT 1",
  atcCode: "N05AX13"
}, {
  CIP7: '4176693',
  CIP13: '3400941766930',
  ucdLib: "XEPLION 150MG INJ LP SRG",
  UCD7: '9387383',
  UCD13: '3400893873830',
  ucdQtyMultiplicator: 1,
  cipLib: "XEPLION 150MG INJ LP SRG BT 1",
  atcCode: "N05AX13"
}, {
  CIP7: '4176658',
  CIP13: '3400941766589',
  ucdLib: "XEPLION 25MG INJ LP SRG",
  UCD7: '9387408',
  UCD13: '3400893874080',
  ucdQtyMultiplicator: 1,
  cipLib: "XEPLION 25MG INJ LP SRG BT 1",
  atcCode: "N05AX13"
}, {
  CIP7: '4176664',
  CIP13: '3400941766640',
  ucdLib: "XEPLION 50MG INJ LP SRG",
  UCD7: '9387414',
  UCD13: '3400893874141',
  ucdQtyMultiplicator: 1,
  cipLib: "XEPLION 50MG INJ LP SRG BT 1",
  atcCode: "N05AX13"
}, {
  CIP7: '4176670',
  CIP13: '3400941766701',
  ucdLib: "XEPLION 75MG INJ LP SRG",
  UCD7: '9387420',
  UCD13: '3400893874202',
  ucdQtyMultiplicator: 1,
  cipLib: "XEPLION 75MG INJ LP SRG BT 1",
  atcCode: "N05AX13"
}, {
  CIP7: '3001897',
  CIP13: '3400930018972',
  ucdLib: "ABILIFY MAINTENA 400MG SRG+3A",
  UCD7: '9412431',
  UCD13: '3400894124313',
  ucdQtyMultiplicator: 1,
  cipLib: "ABILIFY MAINTENA 400MG SRG+3A BT 1",
  atcCode: "N05AX12"
}, {
  CIP7: '3002615',
  CIP13: '3400930026151',
  ucdLib: "ARIPIPRAZOLE BGR 10MG C.DISP",
  UCD7: '9416334',
  UCD13: '3400894163343',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE BGR 10MG C.DISP BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002610',
  CIP13: '3400930026106',
  ucdLib: "ARIPIPRAZOLE BGR 10MG CPR",
  UCD7: '9416328',
  UCD13: '3400894163282',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE BGR 10MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002617',
  CIP13: '3400930026175',
  ucdLib: "ARIPIPRAZOLE BGR 15MG C.DISP",
  UCD7: '9416357',
  UCD13: '3400894163572',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE BGR 15MG C.DISP BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002612',
  CIP13: '3400930026120',
  ucdLib: "ARIPIPRAZOLE BGR 15MG CPR",
  UCD7: '9416340',
  UCD13: '3400894163404',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE BGR 15MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002607',
  CIP13: '3400930026076',
  ucdLib: "ARIPIPRAZOLE BGR 5MG CPR",
  UCD7: '9416363',
  UCD13: '3400894163633',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE BGR 5MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3003174',
  CIP13: '3400930031742',
  ucdLib: "ARIPIPRAZOLE EG 10MG C.DISP",
  UCD7: '9418379',
  UCD13: '3400894183792',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE EG 10MG C.DISP BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3003148',
  CIP13: '3400930031483',
  ucdLib: "ARIPIPRAZOLE EG 10MG CPR",
  UCD7: '9421996',
  UCD13: '3400894219965',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE EG 10MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3003181',
  CIP13: '3400930031810',
  ucdLib: "ARIPIPRAZOLE EG 15MG C.DISP",
  UCD7: '9418385',
  UCD13: '3400894183853',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE EG 15MG C.DISP BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3003156',
  CIP13: '3400930031568',
  ucdLib: "ARIPIPRAZOLE EG 15MG CPR",
  UCD7: '9422004',
  UCD13: '3400894220046',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE EG 15MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3003142',
  CIP13: '3400930031421',
  ucdLib: "ARIPIPRAZOLE EG 5MG CPR",
  UCD7: '9422010',
  UCD13: '3400894220107',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE EG 5MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3003412',
  CIP13: '3400930034125',
  ucdLib: "ARIPIPRAZOLE FOC 10MG CPR",
  UCD7: '9414944',
  UCD13: '3400894149446',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE FOC 10MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3003421',
  CIP13: '3400930034217',
  ucdLib: "ARIPIPRAZOLE FOC 15MG CPR",
  UCD7: '9414950',
  UCD13: '3400894149507',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE FOC 15MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3003404',
  CIP13: '3400930034040',
  ucdLib: "ARIPIPRAZOLE FOC 5MG CPR",
  UCD7: '9414967',
  UCD13: '3400894149675',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE FOC 5MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3005969',
  CIP13: '3400930059692',
  ucdLib: "ARIPIPRAZOLE MYP 10MG CPR",
  UCD7: '9418758',
  UCD13: '3400894187585',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE MYP 10MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3005970',
  CIP13: '3400930059708',
  ucdLib: "ARIPIPRAZOLE MYP 15MG CPR",
  UCD7: '9418764',
  UCD13: '3400894187646',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE MYP 15MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3005968',
  CIP13: '3400930059685',
  ucdLib: "ARIPIPRAZOLE MYP 5MG CPR",
  UCD7: '9418770',
  UCD13: '3400894187707',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE MYP 5MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002364',
  CIP13: '3400930023648',
  ucdLib: "ARIPIPRAZOLE SDZ 10MG CPR",
  UCD7: '9410478',
  UCD13: '3400894104780',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE SDZ 10MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3004343',
  CIP13: '3400930043431',
  ucdLib: "ARIPIPRAZOLE SDZ 10MG DISP",
  UCD7: '9415990',
  UCD13: '3400894159902',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE SDZ 10MG DISP BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002365',
  CIP13: '3400930023655',
  ucdLib: "ARIPIPRAZOLE SDZ 15MG CPR",
  UCD7: '9410484',
  UCD13: '3400894104841',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE SDZ 15MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3004357',
  CIP13: '3400930043578',
  ucdLib: "ARIPIPRAZOLE SDZ 15MG DISP",
  UCD7: '9416009',
  UCD13: '3400894160090',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE SDZ 15MG DISP BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002363',
  CIP13: '3400930023631',
  ucdLib: "ARIPIPRAZOLE SDZ 5MG CPR",
  UCD7: '9410490',
  UCD13: '3400894104902',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE SDZ 5MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3001725',
  CIP13: '3400930017258',
  ucdLib: "ARIPIPRAZOLE TVC 10MG CPR",
  UCD7: '9410337',
  UCD13: '3400894103370',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE TVC 10MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3001745',
  CIP13: '3400930017456',
  ucdLib: "ARIPIPRAZOLE TVC 15MG CPR",
  UCD7: '9410343',
  UCD13: '3400894103431',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE TVC 15MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3001735',
  CIP13: '3400930017357',
  ucdLib: "ARIPIPRAZOLE TVC 5MG CPR",
  UCD7: '9410366',
  UCD13: '3400894103660',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE TVC 5MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002389',
  CIP13: '3400930023891',
  ucdLib: "ARIPIPRAZOLE ZEN 10MG CPR",
  UCD7: '9414306',
  UCD13: '3400894143062',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE ZEN 10MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002390',
  CIP13: '3400930023907',
  ucdLib: "ARIPIPRAZOLE ZEN 15MG CPR",
  UCD7: '9414329',
  UCD13: '3400894143291',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE ZEN 15MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3002388',
  CIP13: '3400930023884',
  ucdLib: "ARIPIPRAZOLE ZEN 5MG CPR",
  UCD7: '9414341',
  UCD13: '3400894143413',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIPIPRAZOLE ZEN 5MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '4950020',
  CIP13: '3400949500208',
  ucdLib: "ABILIFY 10MG CPR ADP BBA",
  UCD7: '9421861',
  UCD13: '3400894218616',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 10MG CPR ADP BBA BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '4950011',
  CIP13: '3400949500116',
  ucdLib: "ABILIFY 10MG CPR ADP MWI",
  UCD7: '9416268',
  UCD13: '3400894162681',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 10MG CPR ADP MWI BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3692145',
  CIP13: '3400936921450',
  ucdLib: "ABILIFY 10MG CPR DISP",
  UCD7: '9290726',
  UCD13: '3400892907260',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 10MG CPR DISP BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '4950021',
  CIP13: '3400949500215',
  ucdLib: "ABILIFY 15MG CPR ADP BBA",
  UCD7: '9421878',
  UCD13: '3400894218784',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 15MG CPR ADP BBA BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '4950012',
  CIP13: '3400949500123',
  ucdLib: "ABILIFY 15MG CPR ADP MWI",
  UCD7: '9416274',
  UCD13: '3400894162742',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 15MG CPR ADP MWI BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3692174',
  CIP13: '3400936921740',
  ucdLib: "ABILIFY 15MG CPR DISP",
  UCD7: '9290732',
  UCD13: '3400892907321',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 15MG CPR DISP BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '4950010',
  CIP13: '3400949500109',
  ucdLib: "ABILIFY 5MG CPR ADP MWI",
  UCD7: '9416280',
  UCD13: '3400894162803',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 5MG CPR ADP MWI BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3640734',
  CIP13: '3400936407343',
  ucdLib: "ABILIFY 10MG CPR",
  UCD7: '9261274',
  UCD13: '3400892612744',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 10MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3640786',
  CIP13: '3400936407862',
  ucdLib: "ABILIFY 15MG CPR",
  UCD7: '9261280',
  UCD13: '3400892612805',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 15MG CPR BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3640697',
  CIP13: '3400936406971',
  ucdLib: "ABILIFY 5MG CPR D.U",
  UCD7: '9297059',
  UCD13: '3400892970592',
  ucdQtyMultiplicator: 28,
  cipLib: "ABILIFY 5MG CPR D.U BT 28",
  atcCode: "N05AX12"
}, {
  CIP7: '3777769',
  CIP13: '3400937777698',
  ucdLib: "ABILIFY 7,5MG/ML INJ FV1,3ML",
  UCD7: '9310535',
  UCD13: '3400893105351',
  ucdQtyMultiplicator: 1,
  cipLib: "ABILIFY 7,5MG/ML INJ FV1,3ML BT 1",
  atcCode: "N05AX12"
}, {
  CIP7: '3732979',
  CIP13: '3400937329798',
  ucdLib: "ABILIFY 1MG/ML BUV FP150ML",
  UCD7: '9353102',
  UCD13: '3400893531020',
  ucdQtyMultiplicator: 1,
  cipLib: "ABILIFY 1MG/ML BUV FP150ML BT 1",
  atcCode: "N05AX12"
}, {
  CIP7: '2772184',
  CIP13: '3400927721847',
  ucdLib: "ABILIFY MAINTENA 300MG FL+FL",
  UCD7: '9402088',
  UCD13: '3400894020882',
  ucdQtyMultiplicator: 1,
  cipLib: "ABILIFY MAINTENA 300MG FL+FL BT 1",
  atcCode: "N05AX12"
}, {
  CIP7: '2772190',
  CIP13: '3400927721908',
  ucdLib: "ABILIFY MAINTENA 400MG FL+FL",
  UCD7: '9402094',
  UCD13: '3400894020943',
  ucdQtyMultiplicator: 1,
  cipLib: "ABILIFY MAINTENA 400MG FL+FL BT 1",
  atcCode: "N05AX12"
}, {
  CIP7: '3833491',
  CIP13: '3400938334913',
  ucdLib: "RISPERIDONE SDZ 0,5MG C.DISP",
  UCD7: '9319200',
  UCD13: '3400893192009',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE SDZ 0,5MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3833522',
  CIP13: '3400938335224',
  ucdLib: "RISPERIDONE SDZ 1MG C.DISP",
  UCD7: '9319217',
  UCD13: '3400893192177',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE SDZ 1MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3833545',
  CIP13: '3400938335453',
  ucdLib: "RISPERIDONE SDZ 2MG C.DISP",
  UCD7: '9319223',
  UCD13: '3400893192238',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE SDZ 2MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3834616',
  CIP13: '3400938346169',
  ucdLib: "RISPERIDONE TVS 1MG CPR",
  UCD7: '9313982',
  UCD13: '3400893139820',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE TVS 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3834651',
  CIP13: '3400938346510',
  ucdLib: "RISPERIDONE TVS 2MG CPR",
  UCD7: '9313999',
  UCD13: '3400893139998',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE TVS 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3835490',
  CIP13: '3400938354904',
  ucdLib: "RISPERIDONE TVS 4MG CPR",
  UCD7: '9314007',
  UCD13: '3400893140079',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE TVS 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3004442',
  CIP13: '3400930044421',
  ucdLib: "RISPERIDONE BGA 1MG CPR",
  UCD7: '9307119',
  UCD13: '3400893071199',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE BGA 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3004444',
  CIP13: '3400930044445',
  ucdLib: "RISPERIDONE BGA 2MG CPR",
  UCD7: '9307125',
  UCD13: '3400893071250',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE BGA 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3004445',
  CIP13: '3400930044452',
  ucdLib: "RISPERIDONE BGA 4MG CPR",
  UCD7: '9307349',
  UCD13: '3400893073490',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE BGA 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '4917600',
  CIP13: '3400949176007',
  ucdLib: "RISPERIDONE SDZ 3MG C.DISP",
  UCD7: '9356023',
  UCD13: '3400893560235',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE SDZ 3MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '4917534',
  CIP13: '3400949175345',
  ucdLib: "RISPERIDONE SDZ 4MG C.DISP",
  UCD7: '9356046',
  UCD13: '3400893560464',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE SDZ 4MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3439848',
  CIP13: '3400934398483',
  ucdLib: "RISPERDAL 1MG/ML BUV FL120ML",
  UCD7: '9201728',
  UCD13: '3400892017280',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERDAL 1MG/ML BUV FL120ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3439802',
  CIP13: '3400934398025',
  ucdLib: "RISPERDAL 1MG/ML BUV FL30ML",
  UCD7: '9265912',
  UCD13: '3400892659121',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERDAL 1MG/ML BUV FL30ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3439819',
  CIP13: '3400934398193',
  ucdLib: "RISPERDAL 1MG/ML BUV FL60ML",
  UCD7: '9201438',
  UCD13: '3400892014388',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERDAL 1MG/ML BUV FL60ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3855771',
  CIP13: '3400938557718',
  ucdLib: "RISPERIDONE SDZ1MG/ML BUV 30ML",
  UCD7: '9320597',
  UCD13: '3400893205976',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE SDZ1MG/ML BUV 30ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3855788',
  CIP13: '3400938557886',
  ucdLib: "RISPERIDONE SDZ1MG/ML BUV 60ML",
  UCD7: '9320605',
  UCD13: '3400893206058',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE SDZ1MG/ML BUV 60ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3855819',
  CIP13: '3400938558197',
  ucdLib: "RISPERIDONE SDZ1MG/ML BUV120ML",
  UCD7: '9320580',
  UCD13: '3400893205808',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE SDZ1MG/ML BUV120ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3624913',
  CIP13: '3400936249134',
  ucdLib: "RISPERDALCONSTA LP 25MG F+SRG",
  UCD7: '9257551',
  UCD13: '3400892575513',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERDALCONSTA LP 25MG F+SRG BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3624936',
  CIP13: '3400936249363',
  ucdLib: "RISPERDALCONSTA LP 37,5MG F+S",
  UCD7: '9257568',
  UCD13: '3400892575681',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERDALCONSTA LP 37,5MG F+S BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3624942',
  CIP13: '3400936249424',
  ucdLib: "RISPERDALCONSTA LP 50MG F+SRG",
  UCD7: '9257574',
  UCD13: '3400892575742',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERDALCONSTA LP 50MG F+SRG BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3389487',
  CIP13: '3400933894870',
  ucdLib: "RISPERDAL 1MG CPR",
  UCD7: '9177007',
  UCD13: '3400891770070',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERDAL 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3389501',
  CIP13: '3400933895013',
  ucdLib: "RISPERDAL 2MG CPR",
  UCD7: '9177013',
  UCD13: '3400891770131',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERDAL 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3816073',
  CIP13: '3400938160734',
  ucdLib: "RISPERIDONE ALM 1MG CPR",
  UCD7: '9307088',
  UCD13: '3400893070888',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ALM 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3816127',
  CIP13: '3400938161274',
  ucdLib: "RISPERIDONE ALM 2MG CPR",
  UCD7: '9307094',
  UCD13: '3400893070949',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ALM 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3816156',
  CIP13: '3400938161564',
  ucdLib: "RISPERIDONE ALM 4MG CPR",
  UCD7: '9307102',
  UCD13: '3400893071021',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE ALM 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3817842',
  CIP13: '3400938178425',
  ucdLib: "RISPERIDONE ARL 1MG CPR",
  UCD7: '9308515',
  UCD13: '3400893085158',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ARL 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3817859',
  CIP13: '3400938178593',
  ucdLib: "RISPERIDONE ARL 1MG CPR",
  UCD7: '9308515',
  UCD13: '3400893085158',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ARL 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3817865',
  CIP13: '3400938178654',
  ucdLib: "RISPERIDONE ARL 2MG CPR",
  UCD7: '9308521',
  UCD13: '3400893085219',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ARL 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3817871',
  CIP13: '3400938178715',
  ucdLib: "RISPERIDONE ARL 2MG CPR",
  UCD7: '9308521',
  UCD13: '3400893085219',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ARL 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3817888',
  CIP13: '3400938178883',
  ucdLib: "RISPERIDONE ARL 4MG CPR",
  UCD7: '9308538',
  UCD13: '3400893085387',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE ARL 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3817894',
  CIP13: '3400938178944',
  ucdLib: "RISPERIDONE ARL 4MG CPR",
  UCD7: '9308538',
  UCD13: '3400893085387',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE ARL 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3815978',
  CIP13: '3400938159783',
  ucdLib: "RISPERIDONE BGA 1MG CPR",
  UCD7: '9307119',
  UCD13: '3400893071199',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE BGA 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3816015',
  CIP13: '3400938160154',
  ucdLib: "RISPERIDONE BGA 2MG CPR",
  UCD7: '9307125',
  UCD13: '3400893071250',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE BGA 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3816038',
  CIP13: '3400938160383',
  ucdLib: "RISPERIDONE BGA 4MG CPR",
  UCD7: '9307349',
  UCD13: '3400893073490',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE BGA 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3817753',
  CIP13: '3400938177534',
  ucdLib: "RISPERIDONE EVO 1MG CPR",
  UCD7: '9308484',
  UCD13: '3400893084847',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE EVO 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3817782',
  CIP13: '3400938177824',
  ucdLib: "RISPERIDONE EVO 2MG CPR",
  UCD7: '9308490',
  UCD13: '3400893084908',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE EVO 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3817807',
  CIP13: '3400938178074',
  ucdLib: "RISPERIDONE EVO 4MG CPR",
  UCD7: '9308509',
  UCD13: '3400893085097',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE EVO 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3819539',
  CIP13: '3400938195392',
  ucdLib: "RISPERIDONE TVC 1MG CPR",
  UCD7: '9307705',
  UCD13: '3400893077054',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE TVC 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3819545',
  CIP13: '3400938195453',
  ucdLib: "RISPERIDONE TVC 2MG CPR",
  UCD7: '9307711',
  UCD13: '3400893077115',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE TVC 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3819551',
  CIP13: '3400938195514',
  ucdLib: "RISPERIDONE TVC 4MG CPR",
  UCD7: '9307728',
  UCD13: '3400893077283',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE TVC 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3820666',
  CIP13: '3400938206661',
  ucdLib: "RISPERIDONE CRT 1MG CPR",
  UCD7: '9309897',
  UCD13: '3400893098974',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE CRT 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3820726',
  CIP13: '3400938207262',
  ucdLib: "RISPERIDONE CRT 2MG CPR",
  UCD7: '9309905',
  UCD13: '3400893099056',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE CRT 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3820732',
  CIP13: '3400938207323',
  ucdLib: "RISPERIDONE CRT 4MG CPR",
  UCD7: '9309911',
  UCD13: '3400893099117',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE CRT 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3774765',
  CIP13: '3400937747653',
  ucdLib: "RISPERIDONE EG 1MG CPR",
  UCD7: '9298917',
  UCD13: '3400892989174',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE EG 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3828165',
  CIP13: '3400938281651',
  ucdLib: "RISPERIDONE EG 1MG/ML BUV 60ML",
  UCD7: '9311931',
  UCD13: '3400893119310',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE EG 1MG/ML BUV 60ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3828188',
  CIP13: '3400938281880',
  ucdLib: "RISPERIDONE EG 1MG/ML BUV120ML",
  UCD7: '9311925',
  UCD13: '3400893119259',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE EG 1MG/ML BUV120ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3775078',
  CIP13: '3400937750783',
  ucdLib: "RISPERIDONE EG 2MG CPR",
  UCD7: '9298923',
  UCD13: '3400892989235',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE EG 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3775150',
  CIP13: '3400937751506',
  ucdLib: "RISPERIDONE EG 4MG CPR",
  UCD7: '9298946',
  UCD13: '3400892989464',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE EG 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3827970',
  CIP13: '3400938279702',
  ucdLib: "RISPERIDONE MYL1MG/ML BUV 30ML",
  UCD7: '9307757',
  UCD13: '3400893077573',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE MYL1MG/ML BUV 30ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3827987',
  CIP13: '3400938279870',
  ucdLib: "RISPERIDONE MYL1MG/ML BUV 60ML",
  UCD7: '9307763',
  UCD13: '3400893077634',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE MYL1MG/ML BUV 60ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3828018',
  CIP13: '3400938280180',
  ucdLib: "RISPERIDONE MYL1MG/ML BUV120ML",
  UCD7: '9307740',
  UCD13: '3400893077405',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE MYL1MG/ML BUV120ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3820689',
  CIP13: '3400938206890',
  ucdLib: "RISPERIDONE RBX 1MG CPR",
  UCD7: '9307674',
  UCD13: '3400893076743',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE RBX 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3820749',
  CIP13: '3400938207491',
  ucdLib: "RISPERIDONE RBX 2MG CPR",
  UCD7: '9307680',
  UCD13: '3400893076804',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE RBX 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3820755',
  CIP13: '3400938207552',
  ucdLib: "RISPERIDONE RBX 4MG CPR",
  UCD7: '9307697',
  UCD13: '3400893076972',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE RBX 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3790184',
  CIP13: '3400937901840',
  ucdLib: "RISPERIDONE SDZ 1MG CPR",
  UCD7: '9301803',
  UCD13: '3400893018033',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE SDZ 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3790215',
  CIP13: '3400937902151',
  ucdLib: "RISPERIDONE SDZ 2MG CPR",
  UCD7: '9301826',
  UCD13: '3400893018262',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE SDZ 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3790238',
  CIP13: '3400937902380',
  ucdLib: "RISPERIDONE SDZ 4MG CPR",
  UCD7: '9301832',
  UCD13: '3400893018323',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE SDZ 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3775842',
  CIP13: '3400937758420',
  ucdLib: "RISPERIDONE ZEN 1MG CPR",
  UCD7: '9307355',
  UCD13: '3400893073551',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ZEN 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3775954',
  CIP13: '3400937759540',
  ucdLib: "RISPERIDONE ZEN 2MG CPR",
  UCD7: '9307361',
  UCD13: '3400893073612',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ZEN 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3776043',
  CIP13: '3400937760430',
  ucdLib: "RISPERIDONE ZEN 4MG CPR",
  UCD7: '9307378',
  UCD13: '3400893073780',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE ZEN 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3828202',
  CIP13: '3400938282023',
  ucdLib: "RISPERIDONE ZEN1MG/ML BUV 30ML",
  UCD7: '9310481',
  UCD13: '3400893104811',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE ZEN1MG/ML BUV 30ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3828219',
  CIP13: '3400938282191',
  ucdLib: "RISPERIDONE ZEN1MG/ML BUV 60ML",
  UCD7: '9310498',
  UCD13: '3400893104989',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE ZEN1MG/ML BUV 60ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3828231',
  CIP13: '3400938282313',
  ucdLib: "RISPERIDONE ZEN1MG/ML BUV120ML",
  UCD7: '9310475',
  UCD13: '3400893104750',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE ZEN1MG/ML BUV120ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3442738',
  CIP13: '3400934427381',
  ucdLib: "RISPERDAL 4MG CPR",
  UCD7: '9196223',
  UCD13: '3400891962239',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERDAL 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3914717',
  CIP13: '3400939147178',
  ucdLib: "RISPERIDONE ALT 1MG CPR",
  UCD7: '9331767',
  UCD13: '3400893317679',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ALT 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3914769',
  CIP13: '3400939147697',
  ucdLib: "RISPERIDONE ALT 2MG CPR",
  UCD7: '9331773',
  UCD13: '3400893317730',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ALT 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3914812',
  CIP13: '3400939148120',
  ucdLib: "RISPERIDONE ALT 4MG CPR",
  UCD7: '9331796',
  UCD13: '3400893317969',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE ALT 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3918023',
  CIP13: '3400939180236',
  ucdLib: "RISPERIDONE MYL 0,5MG C.DISP",
  UCD7: '9334501',
  UCD13: '3400893345016',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE MYL 0,5MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3918052',
  CIP13: '3400939180526',
  ucdLib: "RISPERIDONE MYL 1MG C.DISP",
  UCD7: '9334518',
  UCD13: '3400893345184',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE MYL 1MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3918075',
  CIP13: '3400939180755',
  ucdLib: "RISPERIDONE MYL 2MG C.DISP",
  UCD7: '9334524',
  UCD13: '3400893345245',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE MYL 2MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3904742',
  CIP13: '3400939047423',
  ucdLib: "RISPERIDONE MYP 1MG CPR",
  UCD7: '9330779',
  UCD13: '3400893307793',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE MYP 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3904788',
  CIP13: '3400939047881',
  ucdLib: "RISPERIDONE MYP 2MG CPR",
  UCD7: '9330785',
  UCD13: '3400893307854',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE MYP 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3904854',
  CIP13: '3400939048543',
  ucdLib: "RISPERIDONE MYP 4MG CPR",
  UCD7: '9330791',
  UCD13: '3400893307915',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE MYP 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '3933904',
  CIP13: '3400939339047',
  ucdLib: "RISPERIDONE TVC 0,5MG C.DISP",
  UCD7: '9334719',
  UCD13: '3400893347195',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE TVC 0,5MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3933985',
  CIP13: '3400939339856',
  ucdLib: "RISPERIDONE TVC 1MG C.DISP",
  UCD7: '9334725',
  UCD13: '3400893347256',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE TVC 1MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3910286',
  CIP13: '3400939102863',
  ucdLib: "RISPERIDONE TVS1MG/ML BUV 30ML",
  UCD7: '9326915',
  UCD13: '3400893269152',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE TVS1MG/ML BUV 30ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3910292',
  CIP13: '3400939102924',
  ucdLib: "RISPERIDONE TVS1MG/ML BUV 60ML",
  UCD7: '9326921',
  UCD13: '3400893269213',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE TVS1MG/ML BUV 60ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '3910323',
  CIP13: '3400939103235',
  ucdLib: "RISPERIDONE TVS1MG/ML BUV120ML",
  UCD7: '9326909',
  UCD13: '3400893269091',
  ucdQtyMultiplicator: 1,
  cipLib: "RISPERIDONE TVS1MG/ML BUV120ML BT 1",
  atcCode: "N05AX08"
}, {
  CIP7: '4151500',
  CIP13: '3400941515002',
  ucdLib: "RISPERIDONE MYL 3MG C.DISP",
  UCD7: '9368078',
  UCD13: '3400893680780',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE MYL 3MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '4151428',
  CIP13: '3400941514289',
  ucdLib: "RISPERIDONE MYL 4MG C.DISP",
  UCD7: '9368084',
  UCD13: '3400893680841',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE MYL 4MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3945741',
  CIP13: '3400939457413',
  ucdLib: "RISPERIDONE ZYD 1MG CPR",
  UCD7: '9334731',
  UCD13: '3400893347317',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ZYD 1MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3945770',
  CIP13: '3400939457703',
  ucdLib: "RISPERIDONE ZYD 2MG CPR",
  UCD7: '9334748',
  UCD13: '3400893347485',
  ucdQtyMultiplicator: 60,
  cipLib: "RISPERIDONE ZYD 2MG CPR BT 60",
  atcCode: "N05AX08"
}, {
  CIP7: '3945847',
  CIP13: '3400939458472',
  ucdLib: "RISPERIDONE ZYD 4MG CPR",
  UCD7: '9334754',
  UCD13: '3400893347546',
  ucdQtyMultiplicator: 30,
  cipLib: "RISPERIDONE ZYD 4MG CPR BT 30",
  atcCode: "N05AX08"
}, {
  CIP7: '4928934',
  CIP13: '3400949289349',
  ucdLib: "RISPERIDONE EG 0,5MG C.DISP",
  UCD7: '9356477',
  UCD13: '3400893564776',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE EG 0,5MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '4929046',
  CIP13: '3400949290468',
  ucdLib: "RISPERIDONE EG 1MG C.DISP",
  UCD7: '9356483',
  UCD13: '3400893564837',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE EG 1MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '4929106',
  CIP13: '3400949291069',
  ucdLib: "RISPERIDONE EG 2MG C.DISP",
  UCD7: '9356508',
  UCD13: '3400893565087',
  ucdQtyMultiplicator: 28,
  cipLib: "RISPERIDONE EG 2MG C.DISP BT 28",
  atcCode: "N05AX08"
}, {
  CIP7: '3372736',
  CIP13: '3400933727369',
  ucdLib: "TERALITHE LP 400MG CPR",
  UCD7: '9169315',
  UCD13: '3400891693157',
  ucdQtyMultiplicator: 60,
  cipLib: "TERALITHE LP 400MG CPR BT 60",
  atcCode: "N05AN01"
}, {
  CIP7: '3137633',
  CIP13: '3400931376330',
  ucdLib: "TERALITHE 250MG CPR",
  UCD7: '9091122',
  UCD13: '3400890911221',
  ucdQtyMultiplicator: 100,
  cipLib: "TERALITHE 250MG CPR BT 100",
  atcCode: "N05AN01"
}, {
  CIP7: '3322081',
  CIP13: '3400933220815',
  ucdLib: "SOLIAN 200MG INJ AMP4ML",
  UCD7: '9140122',
  UCD13: '3400891401226',
  ucdQtyMultiplicator: 6,
  cipLib: "SOLIAN 200MG INJ AMP4ML BT 6",
  atcCode: "N05AL05"
}, {
  CIP7: '5566545',
  CIP13: '3400955665458',
  ucdLib: "SOLIAN 200MG CPR",
  UCD7: '9128457',
  UCD13: '3400891284577',
  ucdQtyMultiplicator: 150,
  cipLib: "SOLIAN 200MG CPR BT 150",
  atcCode: "N05AL05"
}, {
  CIP7: '3680610',
  CIP13: '3400936806108',
  ucdLib: "AMISULPRIDE MYL 400MG CPR",
  UCD7: '9272154',
  UCD13: '3400892721545',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE MYL 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3680685',
  CIP13: '3400936806856',
  ucdLib: "AMISULPRIDE SDZ 200MG CPR",
  UCD7: '9268796',
  UCD13: '3400892687964',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE SDZ 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3685671',
  CIP13: '3400936856714',
  ucdLib: "AMISULPRIDE SDZ 400MG CPR",
  UCD7: '9275744',
  UCD13: '3400892757445',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE SDZ 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3685719',
  CIP13: '3400936857193',
  ucdLib: "AMISULPRIDE TVC 400MG CPR",
  UCD7: '9275342',
  UCD13: '3400892753423',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE TVC 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3528701',
  CIP13: '3400935287014',
  ucdLib: "SOLIAN 100MG/ML BUV FL60ML",
  UCD7: '9221062',
  UCD13: '3400892210629',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLIAN 100MG/ML BUV FL60ML BT 1",
  atcCode: "N05AL05"
}, {
  CIP7: '3672817',
  CIP13: '3400936728172',
  ucdLib: "AMISULPRIDE BGA 400MG CPR",
  UCD7: '9269258',
  UCD13: '3400892692586',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE BGA 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3672792',
  CIP13: '3400936727922',
  ucdLib: "AMISULPRIDE EG 400MG CPR",
  UCD7: '9269264',
  UCD13: '3400892692647',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE EG 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3672881',
  CIP13: '3400936728813',
  ucdLib: "AMISULPRIDE TVC 100MG CPR",
  UCD7: '9269287',
  UCD13: '3400892692876',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE TVC 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3674242',
  CIP13: '3400936742420',
  ucdLib: "AMISULPRIDE ZEN 100MG CPR",
  UCD7: '9269726',
  UCD13: '3400892697260',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE ZEN 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3674259',
  CIP13: '3400936742598',
  ucdLib: "AMISULPRIDE ZEN 200MG CPR",
  UCD7: '9269732',
  UCD13: '3400892697321',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE ZEN 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3675402',
  CIP13: '3400936754027',
  ucdLib: "AMISULPRIDE ZYD 400MG CPR",
  UCD7: '9271166',
  UCD13: '3400892711669',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE ZYD 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3628644',
  CIP13: '3400936286443',
  ucdLib: "AMISULPRIDE ARW 200MG CPR",
  UCD7: '9257456',
  UCD13: '3400892574561',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE ARW 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3621702',
  CIP13: '3400936217027',
  ucdLib: "AMISULPRIDE BGA 200MG CPR",
  UCD7: '9255776',
  UCD13: '3400892557762',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE BGA 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3655807',
  CIP13: '3400936558076',
  ucdLib: "AMISULPRIDE ZEN 400MG CPR",
  UCD7: '9271901',
  UCD13: '3400892719016',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE ZEN 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3487474',
  CIP13: '3400934874741',
  ucdLib: "SOLIAN 100MG CPR",
  UCD7: '9210147',
  UCD13: '3400892101477',
  ucdQtyMultiplicator: 30,
  cipLib: "SOLIAN 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3487480',
  CIP13: '3400934874802',
  ucdLib: "SOLIAN 400MG CPR",
  UCD7: '9210199',
  UCD13: '3400892101996',
  ucdQtyMultiplicator: 30,
  cipLib: "SOLIAN 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3512077',
  CIP13: '3400935120779',
  ucdLib: "SOLIAN 400MG CPR",
  UCD7: '9210199',
  UCD13: '3400892101996',
  ucdQtyMultiplicator: 80,
  cipLib: "SOLIAN 400MG CPR BT 80",
  atcCode: "N05AL05"
}, {
  CIP7: '3638105',
  CIP13: '3400936381056',
  ucdLib: "AMISULPRIDE ARW 100MG CPR",
  UCD7: '9264953',
  UCD13: '3400892649535',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE ARW 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3693386',
  CIP13: '3400936933866',
  ucdLib: "AMISULPRIDE ARW 400MG CPR",
  UCD7: '9277364',
  UCD13: '3400892773643',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE ARW 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3693446',
  CIP13: '3400936934467',
  ucdLib: "AMISULPRIDE CRT 400MG CPR",
  UCD7: '9280484',
  UCD13: '3400892804842',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE CRT 400MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3632611',
  CIP13: '3400936326118',
  ucdLib: "AMISULPRIDE EG 200MG CPR",
  UCD7: '9260197',
  UCD13: '3400892601977',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE EG 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3639317',
  CIP13: '3400936393172',
  ucdLib: "AMISULPRIDE MYL 200MG CPR",
  UCD7: '9264195',
  UCD13: '3400892641959',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE MYL 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3665450',
  CIP13: '3400936654501',
  ucdLib: "AMISULPRIDE TVC 200MG CPR",
  UCD7: '9267704',
  UCD13: '3400892677040',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE TVC 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3644695',
  CIP13: '3400936446953',
  ucdLib: "AMISULPRIDE BGA 100MG CPR",
  UCD7: '9264976',
  UCD13: '3400892649764',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE BGA 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3649994',
  CIP13: '3400936499942',
  ucdLib: "AMISULPRIDE EG 100MG CPR",
  UCD7: '9264982',
  UCD13: '3400892649825',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE EG 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3644347',
  CIP13: '3400936443471',
  ucdLib: "AMISULPRIDE MYL 100MG CPR",
  UCD7: '9265007',
  UCD13: '3400892650074',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE MYL 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3644241',
  CIP13: '3400936442412',
  ucdLib: "AMISULPRIDE SDZ 100MG CPR",
  UCD7: '9265042',
  UCD13: '3400892650425',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE SDZ 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '3473621',
  CIP13: '3400934736216',
  ucdLib: "SOLIAN 200MG CPR",
  UCD7: '9128457',
  UCD13: '3400891284577',
  ucdQtyMultiplicator: 60,
  cipLib: "SOLIAN 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3864534',
  CIP13: '3400938645347',
  ucdLib: "AMISULPRIDE ACT 200MG CPR",
  UCD7: '9324307',
  UCD13: '3400893243077',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE ACT 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '5613121',
  CIP13: '3400956131211',
  ucdLib: "SOLIAN 100MG CPR",
  UCD7: '9210147',
  UCD13: '3400892101477',
  ucdQtyMultiplicator: 150,
  cipLib: "SOLIAN 100MG CPR BT 150",
  atcCode: "N05AL05"
}, {
  CIP7: '4935667',
  CIP13: '3400949356676',
  ucdLib: "AMISULPRIDE CRT 100MG CPR",
  UCD7: '9358878',
  UCD13: '3400893588789',
  ucdQtyMultiplicator: 30,
  cipLib: "AMISULPRIDE CRT 100MG CPR BT 30",
  atcCode: "N05AL05"
}, {
  CIP7: '4935727',
  CIP13: '3400949357277',
  ucdLib: "AMISULPRIDE CRT 200MG CPR",
  UCD7: '9358884',
  UCD13: '3400893588840',
  ucdQtyMultiplicator: 60,
  cipLib: "AMISULPRIDE CRT 200MG CPR BT 60",
  atcCode: "N05AL05"
}, {
  CIP7: '3006785',
  CIP13: '3400930067857',
  ucdLib: "TIAPRIDE MYL 100MG CPR",
  UCD7: '9153917',
  UCD13: '3400891539172',
  ucdQtyMultiplicator: 20,
  cipLib: "TIAPRIDE MYL 100MG CPR BT 20",
  atcCode: "N05AL03"
}, {
  CIP7: '5566580',
  CIP13: '3400955665809',
  ucdLib: "TIAPRIDAL 100MG CPR SECAB",
  UCD7: '9093032',
  UCD13: '3400890930321',
  ucdQtyMultiplicator: 150,
  cipLib: "TIAPRIDAL 100MG CPR SECAB BT 150",
  atcCode: "N05AL03"
}, {
  CIP7: '3331890',
  CIP13: '3400933318901',
  ucdLib: "TIAPRIDE MYL 100MG CPR",
  UCD7: '9153917',
  UCD13: '3400891539172',
  ucdQtyMultiplicator: 20,
  cipLib: "TIAPRIDE MYL 100MG CPR BT 20",
  atcCode: "N05AL03"
}, {
  CIP7: '3659662',
  CIP13: '3400936596627',
  ucdLib: "TIAPRIDE SDZ 100MG CPR",
  UCD7: '9264083',
  UCD13: '3400892640839',
  ucdQtyMultiplicator: 20,
  cipLib: "TIAPRIDE SDZ 100MG CPR BT 20",
  atcCode: "N05AL03"
}, {
  CIP7: '3174249',
  CIP13: '3400931742494',
  ucdLib: "TIAPRIDAL 100MG CPR SECAB",
  UCD7: '9093032',
  UCD13: '3400890930321',
  ucdQtyMultiplicator: 20,
  cipLib: "TIAPRIDAL 100MG CPR SECAB BT 20",
  atcCode: "N05AL03"
}, {
  CIP7: '3174255',
  CIP13: '3400931742555',
  ucdLib: "TIAPRIDAL 100MG INJ AMP2ML",
  UCD7: '9093026',
  UCD13: '3400890930260',
  ucdQtyMultiplicator: 12,
  cipLib: "TIAPRIDAL 100MG INJ AMP2ML BT 12",
  atcCode: "N05AL03"
}, {
  CIP7: '3461109',
  CIP13: '3400934611094',
  ucdLib: "TIAPRIDAL GTT BUV FL30ML",
  UCD7: '9210822',
  UCD13: '3400892108223',
  ucdQtyMultiplicator: 1,
  cipLib: "TIAPRIDAL GTT BUV FL30ML BT 1",
  atcCode: "N05AL03"
}, {
  CIP7: '3614323',
  CIP13: '3400936143234',
  ucdLib: "SULPIRIDE TVC 200MG CPR",
  UCD7: '9245430',
  UCD13: '3400892454306',
  ucdQtyMultiplicator: 12,
  cipLib: "SULPIRIDE TVC 200MG CPR BT 12",
  atcCode: "N05AL01"
}, {
  CIP7: '3614317',
  CIP13: '3400936143173',
  ucdLib: "SULPIRIDE TVC 50MG GELU",
  UCD7: '9245447',
  UCD13: '3400892454474',
  ucdQtyMultiplicator: 30,
  cipLib: "SULPIRIDE TVC 50MG GELU BT 30",
  atcCode: "N05AL01"
}, {
  CIP7: '3032905',
  CIP13: '3400930329054',
  ucdLib: "DOGMATIL 0,5% S/S BUV FL200ML",
  UCD7: '9028158',
  UCD13: '3400890281584',
  ucdQtyMultiplicator: 1,
  cipLib: "DOGMATIL 0,5% S/S BUV FL200ML BT 1",
  atcCode: "N05AL01"
}, {
  CIP7: '3032880',
  CIP13: '3400930328804',
  ucdLib: "DOGMATIL 200MG CPR",
  UCD7: '9028164',
  UCD13: '3400890281645',
  ucdQtyMultiplicator: 12,
  cipLib: "DOGMATIL 200MG CPR BT 12",
  atcCode: "N05AL01"
}, {
  CIP7: '3032897',
  CIP13: '3400930328972',
  ucdLib: "DOGMATIL 50MG GELU",
  UCD7: '9028141',
  UCD13: '3400890281416',
  ucdQtyMultiplicator: 30,
  cipLib: "DOGMATIL 50MG GELU BT 30",
  atcCode: "N05AL01"
}, {
  CIP7: '3254468',
  CIP13: '3400932544684',
  ucdLib: "SYNEDIL FORT 200MG CPR",
  UCD7: '9089987',
  UCD13: '3400890899871',
  ucdQtyMultiplicator: 12,
  cipLib: "SYNEDIL FORT 200MG CPR BT 12",
  atcCode: "N05AL01"
}, {
  CIP7: '3241810',
  CIP13: '3400932418107',
  ucdLib: "SYNEDIL 0,5% BUV FL200ML",
  UCD7: '9089970',
  UCD13: '3400890899703',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNEDIL 0,5% BUV FL200ML BT 1",
  atcCode: "N05AL01"
}, {
  CIP7: '3241767',
  CIP13: '3400932417674',
  ucdLib: "SYNEDIL 50MG GELU",
  UCD7: '9089993',
  UCD13: '3400890899932',
  ucdQtyMultiplicator: 30,
  cipLib: "SYNEDIL 50MG GELU BT 30",
  atcCode: "N05AL01"
}, {
  CIP7: '3562632',
  CIP13: '3400935626325',
  ucdLib: "SULPIRIDE MYL 200MG CPR",
  UCD7: '9230612',
  UCD13: '3400892306124',
  ucdQtyMultiplicator: 12,
  cipLib: "SULPIRIDE MYL 200MG CPR BT 12",
  atcCode: "N05AL01"
}, {
  CIP7: '3515360',
  CIP13: '3400935153609',
  ucdLib: "SULPIRIDE MYL 50MG GELU",
  UCD7: '9218137',
  UCD13: '3400892181370',
  ucdQtyMultiplicator: 30,
  cipLib: "SULPIRIDE MYL 50MG GELU BT 30",
  atcCode: "N05AL01"
}, {
  CIP7: '3661788',
  CIP13: '3400936617889',
  ucdLib: "SULPIRIDE SDZ 50MG GELU",
  UCD7: '9265875',
  UCD13: '3400892658759',
  ucdQtyMultiplicator: 30,
  cipLib: "SULPIRIDE SDZ 50MG GELU BT 30",
  atcCode: "N05AL01"
}, {
  CIP7: '3797602',
  CIP13: '3400937976022',
  ucdLib: "SULPIRIDE ZEN 200MG CPR",
  UCD7: '9303050',
  UCD13: '3400893030509',
  ucdQtyMultiplicator: 12,
  cipLib: "SULPIRIDE ZEN 200MG CPR BT 12",
  atcCode: "N05AL01"
}, {
  CIP7: '3797588',
  CIP13: '3400937975889',
  ucdLib: "SULPIRIDE ZEN 50MG GELU",
  UCD7: '9303067',
  UCD13: '3400893030677',
  ucdQtyMultiplicator: 30,
  cipLib: "SULPIRIDE ZEN 50MG GELU BT 30",
  atcCode: "N05AL01"
}, {
  CIP7: '3004558',
  CIP13: '3400930045589',
  ucdLib: "QUETIAPINE BGA LP300MG CPR",
  UCD7: '9418511',
  UCD13: '3400894185116',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE BGA LP300MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3004560',
  CIP13: '3400930045602',
  ucdLib: "QUETIAPINE BGA LP300MG CPR",
  UCD7: '9418511',
  UCD13: '3400894185116',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE BGA LP300MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3004562',
  CIP13: '3400930045626',
  ucdLib: "QUETIAPINE BGA LP400MG CPR",
  UCD7: '9418528',
  UCD13: '3400894185284',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE BGA LP400MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3004564',
  CIP13: '3400930045640',
  ucdLib: "QUETIAPINE BGA LP400MG CPR",
  UCD7: '9418528',
  UCD13: '3400894185284',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE BGA LP400MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3004540',
  CIP13: '3400930045404',
  ucdLib: "QUETIAPINE BGA LP50MG CPR",
  UCD7: '9418534',
  UCD13: '3400894185345',
  ucdQtyMultiplicator: 10,
  cipLib: "QUETIAPINE BGA LP50MG CPR BT 10",
  atcCode: "N05AH04"
}, {
  CIP7: '3004541',
  CIP13: '3400930045411',
  ucdLib: "QUETIAPINE BGA LP50MG CPR",
  UCD7: '9418534',
  UCD13: '3400894185345',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE BGA LP50MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3002849',
  CIP13: '3400930028490',
  ucdLib: "QUETIAPINE EG LP300MG CPR",
  UCD7: '9416541',
  UCD13: '3400894165415',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE EG LP300MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3002851',
  CIP13: '3400930028513',
  ucdLib: "QUETIAPINE EG LP300MG CPR",
  UCD7: '9416541',
  UCD13: '3400894165415',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE EG LP300MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3002852',
  CIP13: '3400930028520',
  ucdLib: "QUETIAPINE EG LP400MG CPR",
  UCD7: '9416558',
  UCD13: '3400894165583',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE EG LP400MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3002853',
  CIP13: '3400930028537',
  ucdLib: "QUETIAPINE EG LP400MG CPR",
  UCD7: '9416558',
  UCD13: '3400894165583',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE EG LP400MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3002843',
  CIP13: '3400930028438',
  ucdLib: "QUETIAPINE EG LP50MG CPR",
  UCD7: '9416564',
  UCD13: '3400894165644',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE EG LP50MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3001031',
  CIP13: '3400930010310',
  ucdLib: "QUETIAPINE MYP LP300MG CP",
  UCD7: '9408234',
  UCD13: '3400894082347',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE MYP LP300MG CP BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3001033',
  CIP13: '3400930010334',
  ucdLib: "QUETIAPINE MYP LP300MG CP",
  UCD7: '9408234',
  UCD13: '3400894082347',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE MYP LP300MG CP BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3001036',
  CIP13: '3400930010365',
  ucdLib: "QUETIAPINE MYP LP400MG CP",
  UCD7: '9408240',
  UCD13: '3400894082408',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE MYP LP400MG CP BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3001038',
  CIP13: '3400930010389',
  ucdLib: "QUETIAPINE MYP LP400MG CP",
  UCD7: '9408240',
  UCD13: '3400894082408',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE MYP LP400MG CP BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3001024',
  CIP13: '3400930010242',
  ucdLib: "QUETIAPINE MYP LP50MG CPR",
  UCD7: '9408257',
  UCD13: '3400894082576',
  ucdQtyMultiplicator: 10,
  cipLib: "QUETIAPINE MYP LP50MG CPR BT 10",
  atcCode: "N05AH04"
}, {
  CIP7: '3001026',
  CIP13: '3400930010266',
  ucdLib: "QUETIAPINE MYP LP50MG CPR",
  UCD7: '9408257',
  UCD13: '3400894082576',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE MYP LP50MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3004567',
  CIP13: '3400930045671',
  ucdLib: "QUETIAPINE RBX LP300MG CPR",
  UCD7: '9418563',
  UCD13: '3400894185635',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE RBX LP300MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3004568',
  CIP13: '3400930045688',
  ucdLib: "QUETIAPINE RBX LP300MG CPR",
  UCD7: '9418563',
  UCD13: '3400894185635',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE RBX LP300MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3004569',
  CIP13: '3400930045695',
  ucdLib: "QUETIAPINE RBX LP400MG CPR",
  UCD7: '9418586',
  UCD13: '3400894185864',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE RBX LP400MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3004570',
  CIP13: '3400930045701',
  ucdLib: "QUETIAPINE RBX LP400MG CPR",
  UCD7: '9418586',
  UCD13: '3400894185864',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE RBX LP400MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3004565',
  CIP13: '3400930045657',
  ucdLib: "QUETIAPINE RBX LP50MG CPR",
  UCD7: '9418592',
  UCD13: '3400894185925',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE RBX LP50MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3005520',
  CIP13: '3400930055205',
  ucdLib: "QUETIAPINE RBX LP50MG CPR",
  UCD7: '9418592',
  UCD13: '3400894185925',
  ucdQtyMultiplicator: 10,
  cipLib: "QUETIAPINE RBX LP50MG CPR BT 10",
  atcCode: "N05AH04"
}, {
  CIP7: '3002837',
  CIP13: '3400930028377',
  ucdLib: "QUETIAPINE SDZ LP300MG CP",
  UCD7: '9413755',
  UCD13: '3400894137559',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE SDZ LP300MG CP BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3002839',
  CIP13: '3400930028391',
  ucdLib: "QUETIAPINE SDZ LP300MG CP",
  UCD7: '9413755',
  UCD13: '3400894137559',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE SDZ LP300MG CP BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3002840',
  CIP13: '3400930028407',
  ucdLib: "QUETIAPINE SDZ LP400MG CP",
  UCD7: '9413761',
  UCD13: '3400894137610',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE SDZ LP400MG CP BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '3002841',
  CIP13: '3400930028414',
  ucdLib: "QUETIAPINE SDZ LP400MG CP",
  UCD7: '9413761',
  UCD13: '3400894137610',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE SDZ LP400MG CP BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '3002832',
  CIP13: '3400930028322',
  ucdLib: "QUETIAPINE SDZ LP50MG CPR",
  UCD7: '9413778',
  UCD13: '3400894137788',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE SDZ LP50MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '4974029',
  CIP13: '3400949740291',
  ucdLib: "XEROQUEL LP 300MG CPR",
  UCD7: '9371867',
  UCD13: '3400893718674',
  ucdQtyMultiplicator: 30,
  cipLib: "XEROQUEL LP 300MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '4974035',
  CIP13: '3400949740352',
  ucdLib: "XEROQUEL LP 300MG CPR",
  UCD7: '9371867',
  UCD13: '3400893718674',
  ucdQtyMultiplicator: 60,
  cipLib: "XEROQUEL LP 300MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '4974041',
  CIP13: '3400949740413',
  ucdLib: "XEROQUEL LP 400MG CPR",
  UCD7: '9371873',
  UCD13: '3400893718735',
  ucdQtyMultiplicator: 30,
  cipLib: "XEROQUEL LP 400MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '4974058',
  CIP13: '3400949740581',
  ucdLib: "XEROQUEL LP 400MG CPR",
  UCD7: '9371873',
  UCD13: '3400893718735',
  ucdQtyMultiplicator: 60,
  cipLib: "XEROQUEL LP 400MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '4973952',
  CIP13: '3400949739523',
  ucdLib: "XEROQUEL LP 50MG CPR",
  UCD7: '9371896',
  UCD13: '3400893718964',
  ucdQtyMultiplicator: 10,
  cipLib: "XEROQUEL LP 50MG CPR BT 10",
  atcCode: "N05AH04"
}, {
  CIP7: '4973969',
  CIP13: '3400949739691',
  ucdLib: "XEROQUEL LP 50MG CPR",
  UCD7: '9371896',
  UCD13: '3400893718964',
  ucdQtyMultiplicator: 30,
  cipLib: "XEROQUEL LP 50MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '2696520',
  CIP13: '3400926965204',
  ucdLib: "QUETIAPINE ARW LP300MG CPR",
  UCD7: '9418540',
  UCD13: '3400894185406',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE ARW LP300MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '2696543',
  CIP13: '3400926965433',
  ucdLib: "QUETIAPINE ARW LP300MG CPR",
  UCD7: '9418540',
  UCD13: '3400894185406',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE ARW LP300MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '2696572',
  CIP13: '3400926965723',
  ucdLib: "QUETIAPINE ARW LP400MG CPR",
  UCD7: '9418557',
  UCD13: '3400894185574',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE ARW LP400MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '2696595',
  CIP13: '3400926965952',
  ucdLib: "QUETIAPINE ARW LP400MG CPR",
  UCD7: '9418557',
  UCD13: '3400894185574',
  ucdQtyMultiplicator: 60,
  cipLib: "QUETIAPINE ARW LP400MG CPR BT 60",
  atcCode: "N05AH04"
}, {
  CIP7: '2750372',
  CIP13: '3400927503726',
  ucdLib: "QUETIAPINE ARW LP50MG CPR",
  UCD7: '9407507',
  UCD13: '3400894075073',
  ucdQtyMultiplicator: 30,
  cipLib: "QUETIAPINE ARW LP50MG CPR BT 30",
  atcCode: "N05AH04"
}, {
  CIP7: '5787660',
  CIP13: '3400957876609',
  ucdLib: "XEROQUEL LP 300MG CPR",
  UCD7: '9371867',
  UCD13: '3400893718674',
  ucdQtyMultiplicator: 100,
  cipLib: "XEROQUEL LP 300MG CPR BT 100",
  atcCode: "N05AH04"
}, {
  CIP7: '5787677',
  CIP13: '3400957876777',
  ucdLib: "XEROQUEL LP 400MG CPR",
  UCD7: '9371873',
  UCD13: '3400893718735',
  ucdQtyMultiplicator: 100,
  cipLib: "XEROQUEL LP 400MG CPR BT 100",
  atcCode: "N05AH04"
}, {
  CIP7: '5787631',
  CIP13: '3400957876319',
  ucdLib: "XEROQUEL LP 50MG CPR",
  UCD7: '9371896',
  UCD13: '3400893718964',
  ucdQtyMultiplicator: 100,
  cipLib: "XEROQUEL LP 50MG CPR BT 100",
  atcCode: "N05AH04"
}, {
  CIP7: '3834740',
  CIP13: '3400938347401',
  ucdLib: "OLANZAPINE TVC 10MG CPR",
  UCD7: '9336380',
  UCD13: '3400893363805',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE TVC 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3834846',
  CIP13: '3400938348460',
  ucdLib: "OLANZAPINE TVC 10MG CPR DISP",
  UCD7: '9336374',
  UCD13: '3400893363744',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE TVC 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3834697',
  CIP13: '3400938346978',
  ucdLib: "OLANZAPINE TVC 5MG CPR",
  UCD7: '9336440',
  UCD13: '3400893364406',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE TVC 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3834817',
  CIP13: '3400938348170',
  ucdLib: "OLANZAPINE TVC 5MG CPR DISP",
  UCD7: '9336434',
  UCD13: '3400893364345',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE TVC 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3834711',
  CIP13: '3400938347111',
  ucdLib: "OLANZAPINE TVC 7,5MG CPR",
  UCD7: '9336457',
  UCD13: '3400893364574',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE TVC 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3001674',
  CIP13: '3400930016749',
  ucdLib: "OLANZAPINE BGA 10MG CPR",
  UCD7: '9361722',
  UCD13: '3400893617229',
  ucdQtyMultiplicator: 30,
  cipLib: "OLANZAPINE BGA 10MG CPR BT 30",
  atcCode: "N05AH03"
}, {
  CIP7: '3001673',
  CIP13: '3400930016732',
  ucdLib: "OLANZAPINE BGA 5MG CPR",
  UCD7: '9361739',
  UCD13: '3400893617397',
  ucdQtyMultiplicator: 30,
  cipLib: "OLANZAPINE BGA 5MG CPR BT 30",
  atcCode: "N05AH03"
}, {
  CIP7: '3575497',
  CIP13: '3400935754974',
  ucdLib: "ZYPREXA 10MG INJ FL",
  UCD7: '9236359',
  UCD13: '3400892363592',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYPREXA 10MG INJ FL BT 1",
  atcCode: "N05AH03"
}, {
  CIP7: '2760436',
  CIP13: '3400927604362',
  ucdLib: "OLANZAPINE MYL 10MG C.DISP",
  UCD7: '9409742',
  UCD13: '3400894097426',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE MYL 10MG C.DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2760471',
  CIP13: '3400927604713',
  ucdLib: "OLANZAPINE MYL 15MG C.DISP",
  UCD7: '9409759',
  UCD13: '3400894097594',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE MYL 15MG C.DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2760519',
  CIP13: '3400927605192',
  ucdLib: "OLANZAPINE MYL 20MG C.DISP",
  UCD7: '9409765',
  UCD13: '3400894097655',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE MYL 20MG C.DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2760382',
  CIP13: '3400927603822',
  ucdLib: "OLANZAPINE MYL 5MG C.DISP",
  UCD7: '9409771',
  UCD13: '3400894097716',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE MYL 5MG C.DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3553716',
  CIP13: '3400935537164',
  ucdLib: "ZYPREXA 7,5MG CPR",
  UCD7: '9193839',
  UCD13: '3400891938395',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3545438',
  CIP13: '3400935454386',
  ucdLib: "ZYPREXA VELOTAB 10MG CPR",
  UCD7: '9236307',
  UCD13: '3400892363073',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELOTAB 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3545444',
  CIP13: '3400935454447',
  ucdLib: "ZYPREXA VELOTAB 15MG CPR",
  UCD7: '9236313',
  UCD13: '3400892363134',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELOTAB 15MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3545450',
  CIP13: '3400935454508',
  ucdLib: "ZYPREXA VELOTAB 20MG CPR",
  UCD7: '9236336',
  UCD13: '3400892363363',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELOTAB 20MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3545421',
  CIP13: '3400935454218',
  ucdLib: "ZYPREXA VELOTAB 5MG CPR",
  UCD7: '9236342',
  UCD13: '3400892363424',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELOTAB 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950520',
  CIP13: '3400949505203',
  ucdLib: "ZYPREXA 10MG CPR ADP BBA",
  UCD7: '9389324',
  UCD13: '3400893893241',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 10MG CPR ADP BBA BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950951',
  CIP13: '3400949509515',
  ucdLib: "ZYPREXA 10MG CPR ADP ITT",
  UCD7: '9398381',
  UCD13: '3400893983812',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 10MG CPR ADP ITT BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950655',
  CIP13: '3400949506552',
  ucdLib: "ZYPREXA 10MG CPR ADP MWI",
  UCD7: '9389169',
  UCD13: '3400893891698',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 10MG CPR ADP MWI BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950709',
  CIP13: '3400949507092',
  ucdLib: "ZYPREXA 10MG CPR ADP PLA",
  UCD7: '9392237',
  UCD13: '3400893922378',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 10MG CPR ADP PLA BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950514',
  CIP13: '3400949505142',
  ucdLib: "ZYPREXA 5MG CPR ADP BBA",
  UCD7: '9389330',
  UCD13: '3400893893302',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 5MG CPR ADP BBA BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950974',
  CIP13: '3400949509744',
  ucdLib: "ZYPREXA 5MG CPR ADP ITT",
  UCD7: '9398398',
  UCD13: '3400893983980',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 5MG CPR ADP ITT BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950394',
  CIP13: '3400949503940',
  ucdLib: "ZYPREXA 5MG CPR ADP MWI",
  UCD7: '9384858',
  UCD13: '3400893848586',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 5MG CPR ADP MWI BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950715',
  CIP13: '3400949507153',
  ucdLib: "ZYPREXA 5MG CPR ADP PLA",
  UCD7: '9392243',
  UCD13: '3400893922439',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 5MG CPR ADP PLA BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950402',
  CIP13: '3400949504022',
  ucdLib: "ZYPREXA 7,5MG CPR ADP MWI",
  UCD7: '9384864',
  UCD13: '3400893848647',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 7,5MG CPR ADP MWI BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950543',
  CIP13: '3400949505432',
  ucdLib: "ZYPREXA VELO.10MG CP ADP BBA",
  UCD7: '9389347',
  UCD13: '3400893893470',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELO.10MG CP ADP BBA BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4951034',
  CIP13: '3400949510344',
  ucdLib: "ZYPREXA VELO.10MG CP ADP ITT",
  UCD7: '9401143',
  UCD13: '3400894011439',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELO.10MG CP ADP ITT BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950425',
  CIP13: '3400949504251',
  ucdLib: "ZYPREXA VELO.10MG CP ADP MWI",
  UCD7: '9384870',
  UCD13: '3400893848708',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELO.10MG CP ADP MWI BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950744',
  CIP13: '3400949507443',
  ucdLib: "ZYPREXA VELO.10MG CP ADP PLA",
  UCD7: '9396838',
  UCD13: '3400893968383',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELO.10MG CP ADP PLA BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950537',
  CIP13: '3400949505371',
  ucdLib: "ZYPREXA VELO.5MG CPR ADP BBA",
  UCD7: '9389175',
  UCD13: '3400893891759',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELO.5MG CPR ADP BBA BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4951028',
  CIP13: '3400949510283',
  ucdLib: "ZYPREXA VELO.5MG CPR ADP ITT",
  UCD7: '9401166',
  UCD13: '3400894011668',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELO.5MG CPR ADP ITT BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950419',
  CIP13: '3400949504190',
  ucdLib: "ZYPREXA VELO.5MG CPR ADP MWI",
  UCD7: '9384887',
  UCD13: '3400893848876',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELO.5MG CPR ADP MWI BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4950738',
  CIP13: '3400949507382',
  ucdLib: "ZYPREXA VELO.5MG CPR ADP PLA",
  UCD7: '9396844',
  UCD13: '3400893968444',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA VELO.5MG CPR ADP PLA BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3471272',
  CIP13: '3400934712722',
  ucdLib: "OLANZAPINE ZYD 5MG CPR",
  UCD7: '9358097',
  UCD13: '3400893580974',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZYD 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3863807',
  CIP13: '3400938638073',
  ucdLib: "OLANZAPINE RTP 10MG CPR",
  UCD7: '9336233',
  UCD13: '3400893362334',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RTP 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3880898',
  CIP13: '3400938808988',
  ucdLib: "OLANZAPINE RTP 10MG CPR DISP",
  UCD7: '9336256',
  UCD13: '3400893362563',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RTP 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3863641',
  CIP13: '3400938636413',
  ucdLib: "OLANZAPINE RTP 5MG CPR",
  UCD7: '9336262',
  UCD13: '3400893362624',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RTP 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3863724',
  CIP13: '3400938637243',
  ucdLib: "OLANZAPINE RTP 7,5MG CPR",
  UCD7: '9336285',
  UCD13: '3400893362853',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RTP 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3864190',
  CIP13: '3400938641905',
  ucdLib: "OLANZAPINE SDZ 10MG CPR",
  UCD7: '9336291',
  UCD13: '3400893362914',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE SDZ 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3863902',
  CIP13: '3400938639025',
  ucdLib: "OLANZAPINE SDZ 5MG CPR",
  UCD7: '9336316',
  UCD13: '3400893363164',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE SDZ 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3864089',
  CIP13: '3400938640892',
  ucdLib: "OLANZAPINE SDZ 7,5MG CPR",
  UCD7: '9336322',
  UCD13: '3400893363225',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE SDZ 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3882006',
  CIP13: '3400938820065',
  ucdLib: "OLANZAPINE ZYD 10MG CPR",
  UCD7: '9358080',
  UCD13: '3400893580806',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZYD 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3754573',
  CIP13: '3400937545730',
  ucdLib: "OLANZAPINE ZYD 7,5MG CPR",
  UCD7: '9358105',
  UCD13: '3400893581056',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZYD 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3917532',
  CIP13: '3400939175324',
  ucdLib: "OLANZAPINE ALT 10MG CPR",
  UCD7: '9336167',
  UCD13: '3400893361672',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ALT 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3917472',
  CIP13: '3400939174723',
  ucdLib: "OLANZAPINE ALT 5MG CPR",
  UCD7: '9336196',
  UCD13: '3400893361962',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ALT 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3917495',
  CIP13: '3400939174952',
  ucdLib: "OLANZAPINE ALT 7,5MG CPR",
  UCD7: '9336204',
  UCD13: '3400893362044',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ALT 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3952830',
  CIP13: '3400939528304',
  ucdLib: "OLANZAPINE ARG 10MG CPR DISP",
  UCD7: '9340097',
  UCD13: '3400893400975',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3952876',
  CIP13: '3400939528762',
  ucdLib: "OLANZAPINE ARG 10MG CPR DISP",
  UCD7: '9340097',
  UCD13: '3400893400975',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3953060',
  CIP13: '3400939530604',
  ucdLib: "OLANZAPINE ARG 15MG CPR DISP",
  UCD7: '9340105',
  UCD13: '3400893401057',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 15MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3953189',
  CIP13: '3400939531892',
  ucdLib: "OLANZAPINE ARG 20MG CPR DISP",
  UCD7: '9340111',
  UCD13: '3400893401118',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 20MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3952942',
  CIP13: '3400939529424',
  ucdLib: "OLANZAPINE ARG 5MG CPR DISP",
  UCD7: '9340128',
  UCD13: '3400893401286',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3952988',
  CIP13: '3400939529882',
  ucdLib: "OLANZAPINE ARG 5MG CPR DISP",
  UCD7: '9340128',
  UCD13: '3400893401286',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2214455',
  CIP13: '3400922144559',
  ucdLib: "OLANZAPINE CRT 10MG CPR",
  UCD7: '9387791',
  UCD13: '3400893877913',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE CRT 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2214449',
  CIP13: '3400922144498',
  ucdLib: "OLANZAPINE CRT 5MG CPR",
  UCD7: '9387816',
  UCD13: '3400893878163',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE CRT 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2214432',
  CIP13: '3400922144320',
  ucdLib: "OLANZAPINE CRT 7,5MG CPR",
  UCD7: '9387822',
  UCD13: '3400893878224',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE CRT 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3937121',
  CIP13: '3400939371214',
  ucdLib: "OLANZAPINE EG 10MG CPR",
  UCD7: '9340298',
  UCD13: '3400893402986',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE EG 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3936920',
  CIP13: '3400939369204',
  ucdLib: "OLANZAPINE EG 5MG CPR",
  UCD7: '9340358',
  UCD13: '3400893403587',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE EG 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3937061',
  CIP13: '3400939370613',
  ucdLib: "OLANZAPINE EG 7,5MG CPR",
  UCD7: '9340364',
  UCD13: '3400893403648',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE EG 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2210049',
  CIP13: '3400922100494',
  ucdLib: "OLANZAPINE EVO 10MG C.DISP",
  UCD7: '9387839',
  UCD13: '3400893878392',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE EVO 10MG C.DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3966890',
  CIP13: '3400939668901',
  ucdLib: "OLANZAPINE RBX 10MG CPR",
  UCD7: '9346964',
  UCD13: '3400893469644',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RBX 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3967286',
  CIP13: '3400939672861',
  ucdLib: "OLANZAPINE RBX 10MG CPR DISP",
  UCD7: '9346970',
  UCD13: '3400893469705',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RBX 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3966625',
  CIP13: '3400939666259',
  ucdLib: "OLANZAPINE RBX 5MG CPR",
  UCD7: '9347030',
  UCD13: '3400893470305',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RBX 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3967174',
  CIP13: '3400939671741',
  ucdLib: "OLANZAPINE RBX 5MG CPR DISP",
  UCD7: '9347047',
  UCD13: '3400893470473',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RBX 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3966803',
  CIP13: '3400939668031',
  ucdLib: "OLANZAPINE RBX 7,5MG CPR",
  UCD7: '9347053',
  UCD13: '3400893470534',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE RBX 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4993096',
  CIP13: '3400949930968',
  ucdLib: "OLANZAPINE ALT 10MG CPR DISP",
  UCD7: '9370282',
  UCD13: '3400893702826',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ALT 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939872',
  CIP13: '3400949398720',
  ucdLib: "OLANZAPINE ARG 10MG CPR",
  UCD7: '9361751',
  UCD13: '3400893617519',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939837',
  CIP13: '3400949398379',
  ucdLib: "OLANZAPINE ARG 5MG CPR",
  UCD7: '9361768',
  UCD13: '3400893617687',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939843',
  CIP13: '3400949398430',
  ucdLib: "OLANZAPINE ARG 7,5MG CPR",
  UCD7: '9361774',
  UCD13: '3400893617748',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ARG 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939926',
  CIP13: '3400949399260',
  ucdLib: "OLANZAPINE BGA 10MG CPR",
  UCD7: '9361722',
  UCD13: '3400893617229',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE BGA 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3989804',
  CIP13: '3400939898049',
  ucdLib: "OLANZAPINE BGA 10MG CPR DISP",
  UCD7: '9347076',
  UCD13: '3400893470763',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE BGA 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939895',
  CIP13: '3400949398959',
  ucdLib: "OLANZAPINE BGA 5MG CPR",
  UCD7: '9361739',
  UCD13: '3400893617397',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE BGA 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3989773',
  CIP13: '3400939897738',
  ucdLib: "OLANZAPINE BGA 5MG CPR DISP",
  UCD7: '9347099',
  UCD13: '3400893470992',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE BGA 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939903',
  CIP13: '3400949399031',
  ucdLib: "OLANZAPINE BGA 7,5MG CPR",
  UCD7: '9361745',
  UCD13: '3400893617458',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE BGA 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3948024',
  CIP13: '3400939480244',
  ucdLib: "OLANZAPINE EG 10MG CPR DISP",
  UCD7: '9340281',
  UCD13: '3400893402818',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE EG 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3947987',
  CIP13: '3400939479873',
  ucdLib: "OLANZAPINE EG 5MG CPR DISP",
  UCD7: '9340341',
  UCD13: '3400893403419',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE EG 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4998969',
  CIP13: '3400949989690',
  ucdLib: "OLANZAPINE ISD 10MG CPR",
  UCD7: '9370336',
  UCD13: '3400893703366',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ISD 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4151285',
  CIP13: '3400941512858',
  ucdLib: "OLANZAPINE ISD 10MG CPR DISP",
  UCD7: '9370342',
  UCD13: '3400893703427',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ISD 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4998863',
  CIP13: '3400949988631',
  ucdLib: "OLANZAPINE ISD 5MG CPR",
  UCD7: '9370359',
  UCD13: '3400893703595',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ISD 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3945505',
  CIP13: '3400939455051',
  ucdLib: "OLANZAPINE MYL 10MG CPR",
  UCD7: '9342417',
  UCD13: '3400893424179',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE MYL 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3945439',
  CIP13: '3400939454399',
  ucdLib: "OLANZAPINE MYL 5MG CPR",
  UCD7: '9342452',
  UCD13: '3400893424520',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE MYL 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3945468',
  CIP13: '3400939454689',
  ucdLib: "OLANZAPINE MYL 7,5MG CPR",
  UCD7: '9336227',
  UCD13: '3400893362273',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE MYL 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4943419',
  CIP13: '3400949434190',
  ucdLib: "OLANZAPINE ZEN 10MG CPR DISP",
  UCD7: '9367133',
  UCD13: '3400893671337',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZEN 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4943359',
  CIP13: '3400949433599',
  ucdLib: "OLANZAPINE ZEN 5MG CPR DISP",
  UCD7: '9367222',
  UCD13: '3400893672228',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZEN 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939955',
  CIP13: '3400949399550',
  ucdLib: "OLANZAPINE ZTL 10MG CPR",
  UCD7: '9361685',
  UCD13: '3400893616857',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZTL 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939932',
  CIP13: '3400949399321',
  ucdLib: "OLANZAPINE ZTL 5MG CPR",
  UCD7: '9361691',
  UCD13: '3400893616918',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZTL 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4939949',
  CIP13: '3400949399499',
  ucdLib: "OLANZAPINE ZTL 7,5MG CPR",
  UCD7: '9361716',
  UCD13: '3400893617168',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZTL 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2682794',
  CIP13: '3400926827946',
  ucdLib: "OLANZAPINE ACC 10MG CPR",
  UCD7: '9390391',
  UCD13: '3400893903919',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ACC 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2682713',
  CIP13: '3400926827137',
  ucdLib: "OLANZAPINE ACC 5MG CPR",
  UCD7: '9390416',
  UCD13: '3400893904169',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ACC 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2682742',
  CIP13: '3400926827427',
  ucdLib: "OLANZAPINE ACC 7,5MG CPR",
  UCD7: '9390422',
  UCD13: '3400893904220',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ACC 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2169341',
  CIP13: '3400921693416',
  ucdLib: "OLANZAPINE BLF 10MG CPR DISP",
  UCD7: '9377953',
  UCD13: '3400893779538',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE BLF 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2169111',
  CIP13: '3400921691115',
  ucdLib: "OLANZAPINE BLF 5MG CPR DISP",
  UCD7: '9377976',
  UCD13: '3400893779767',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE BLF 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2209997',
  CIP13: '3400922099972',
  ucdLib: "OLANZAPINE EVO 5MG C.DISP",
  UCD7: '9387845',
  UCD13: '3400893878453',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE EVO 5MG C.DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4187975',
  CIP13: '3400941879753',
  ucdLib: "OLANZAPINE SDZ 10MG CPR DISP",
  UCD7: '9374305',
  UCD13: '3400893743058',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE SDZ 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4188012',
  CIP13: '3400941880124',
  ucdLib: "OLANZAPINE SDZ 15MG CPR DISP",
  UCD7: '9379389',
  UCD13: '3400893793893',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE SDZ 15MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4188041',
  CIP13: '3400941880414',
  ucdLib: "OLANZAPINE SDZ 20MG CPR DISP",
  UCD7: '9379395',
  UCD13: '3400893793954',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE SDZ 20MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4187917',
  CIP13: '3400941879173',
  ucdLib: "OLANZAPINE SDZ 5MG CPR DISP",
  UCD7: '9374311',
  UCD13: '3400893743119',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE SDZ 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2243793',
  CIP13: '3400922437934',
  ucdLib: "OLANZAPINE ZYD 10MG CPR DISP",
  UCD7: '9405862',
  UCD13: '3400894058625',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZYD 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2243706',
  CIP13: '3400922437064',
  ucdLib: "OLANZAPINE ZYD 5MG CPR DISP",
  UCD7: '9405879',
  UCD13: '3400894058793',
  ucdQtyMultiplicator: 28,
  cipLib: "OLANZAPINE ZYD 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4187716',
  CIP13: '3400941877162',
  ucdLib: "ONEZYP 10MG CPR ORODISP",
  UCD7: '9393857',
  UCD13: '3400893938577',
  ucdQtyMultiplicator: 28,
  cipLib: "ONEZYP 10MG CPR ORODISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4187857',
  CIP13: '3400941878572',
  ucdLib: "ONEZYP 15MG CPR ORODISP",
  UCD7: '9393863',
  UCD13: '3400893938638',
  ucdQtyMultiplicator: 28,
  cipLib: "ONEZYP 15MG CPR ORODISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4187892',
  CIP13: '3400941878923',
  ucdLib: "ONEZYP 20MG CPR ORODISP",
  UCD7: '9393886',
  UCD13: '3400893938867',
  ucdQtyMultiplicator: 28,
  cipLib: "ONEZYP 20MG CPR ORODISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '4187633',
  CIP13: '3400941876332',
  ucdLib: "ONEZYP 5MG CPR ORODISP",
  UCD7: '9393892',
  UCD13: '3400893938928',
  ucdQtyMultiplicator: 28,
  cipLib: "ONEZYP 5MG CPR ORODISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2241498',
  CIP13: '3400922414980',
  ucdLib: "ZALASTA 10MG CPR",
  UCD7: '9386515',
  UCD13: '3400893865156',
  ucdQtyMultiplicator: 28,
  cipLib: "ZALASTA 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2241541',
  CIP13: '3400922415413',
  ucdLib: "ZALASTA 10MG CPR DISP",
  UCD7: '9386521',
  UCD13: '3400893865217',
  ucdQtyMultiplicator: 28,
  cipLib: "ZALASTA 10MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2241469',
  CIP13: '3400922414690',
  ucdLib: "ZALASTA 5MG CPR",
  UCD7: '9386538',
  UCD13: '3400893865385',
  ucdQtyMultiplicator: 28,
  cipLib: "ZALASTA 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2241529',
  CIP13: '3400922415291',
  ucdLib: "ZALASTA 5MG CPR DISP",
  UCD7: '9386544',
  UCD13: '3400893865446',
  ucdQtyMultiplicator: 28,
  cipLib: "ZALASTA 5MG CPR DISP BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '2241475',
  CIP13: '3400922414751',
  ucdLib: "ZALASTA 7,5MG CPR",
  UCD7: '9386550',
  UCD13: '3400893865507',
  ucdQtyMultiplicator: 28,
  cipLib: "ZALASTA 7,5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '5746916',
  CIP13: '3400957469160',
  ucdLib: "ZYPADHERA 210MG INJ FL+FL",
  UCD7: '9328446',
  UCD13: '3400893284469',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYPADHERA 210MG INJ FL+FL BT 1",
  atcCode: "N05AH03"
}, {
  CIP7: '5746922',
  CIP13: '3400957469221',
  ucdLib: "ZYPADHERA 300MG INJ FL+FL",
  UCD7: '9328452',
  UCD13: '3400893284520',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYPADHERA 300MG INJ FL+FL BT 1",
  atcCode: "N05AH03"
}, {
  CIP7: '5746939',
  CIP13: '3400957469399',
  ucdLib: "ZYPADHERA 405MG INJ FL+FL",
  UCD7: '9328469',
  UCD13: '3400893284698',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYPADHERA 405MG INJ FL+FL BT 1",
  atcCode: "N05AH03"
}, {
  CIP7: '3423801',
  CIP13: '3400934238017',
  ucdLib: "ZYPREXA 10MG CPR",
  UCD7: '9193816',
  UCD13: '3400891938166',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 10MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3423818',
  CIP13: '3400934238185',
  ucdLib: "ZYPREXA 10MG CPR",
  UCD7: '9193816',
  UCD13: '3400891938166',
  ucdQtyMultiplicator: 56,
  cipLib: "ZYPREXA 10MG CPR BT 56",
  atcCode: "N05AH03"
}, {
  CIP7: '3423770',
  CIP13: '3400934237706',
  ucdLib: "ZYPREXA 5MG CPR",
  UCD7: '9193822',
  UCD13: '3400891938227',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYPREXA 5MG CPR BT 28",
  atcCode: "N05AH03"
}, {
  CIP7: '3423787',
  CIP13: '3400934237874',
  ucdLib: "ZYPREXA 7,5MG CPR",
  UCD7: '9193839',
  UCD13: '3400891938395',
  ucdQtyMultiplicator: 56,
  cipLib: "ZYPREXA 7,5MG CPR BT 56",
  atcCode: "N05AH03"
}, {
  CIP7: '3005696',
  CIP13: '3400930056967',
  ucdLib: "CLOZAPINE PAN 25MG CPR",
  UCD7: '9202113',
  UCD13: '3400892021133',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOZAPINE PAN 25MG CPR BT 30",
  atcCode: "N05AH02"
}, {
  CIP7: '3570465',
  CIP13: '3400935704658',
  ucdLib: "CLOZAPINE MYL 100MG CPR",
  UCD7: '9222699',
  UCD13: '3400892226996',
  ucdQtyMultiplicator: 14,
  cipLib: "CLOZAPINE MYL 100MG CPR BT 14",
  atcCode: "N05AH02"
}, {
  CIP7: '3570471',
  CIP13: '3400935704719',
  ucdLib: "CLOZAPINE MYL 100MG CPR",
  UCD7: '9222699',
  UCD13: '3400892226996',
  ucdQtyMultiplicator: 28,
  cipLib: "CLOZAPINE MYL 100MG CPR BT 28",
  atcCode: "N05AH02"
}, {
  CIP7: '3570382',
  CIP13: '3400935703828',
  ucdLib: "CLOZAPINE MYL 25MG CPR",
  UCD7: '9222707',
  UCD13: '3400892227078',
  ucdQtyMultiplicator: 7,
  cipLib: "CLOZAPINE MYL 25MG CPR BT 7",
  atcCode: "N05AH02"
}, {
  CIP7: '3570407',
  CIP13: '3400935704078',
  ucdLib: "CLOZAPINE MYL 25MG CPR",
  UCD7: '9222707',
  UCD13: '3400892227078',
  ucdQtyMultiplicator: 28,
  cipLib: "CLOZAPINE MYL 25MG CPR BT 28",
  atcCode: "N05AH02"
}, {
  CIP7: '5610080',
  CIP13: '3400956100804',
  ucdLib: "CLOZAPINE PAN 100MG CPR",
  UCD7: '9202107',
  UCD13: '3400892021072',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOZAPINE PAN 100MG CPR BT 30",
  atcCode: "N05AH02"
}, {
  CIP7: '2737199',
  CIP13: '3400927371998',
  ucdLib: "LEPONEX 100MG CPR",
  UCD7: '9151166',
  UCD13: '3400891511666',
  ucdQtyMultiplicator: 14,
  cipLib: "LEPONEX 100MG CPR BT 14",
  atcCode: "N05AH02"
}, {
  CIP7: '2737207',
  CIP13: '3400927372070',
  ucdLib: "LEPONEX 100MG CPR",
  UCD7: '9151166',
  UCD13: '3400891511666',
  ucdQtyMultiplicator: 28,
  cipLib: "LEPONEX 100MG CPR BT 28",
  atcCode: "N05AH02"
}, {
  CIP7: '2737118',
  CIP13: '3400927371189',
  ucdLib: "LEPONEX 25MG CPR",
  UCD7: '9151172',
  UCD13: '3400891511727',
  ucdQtyMultiplicator: 7,
  cipLib: "LEPONEX 25MG CPR BT 7",
  atcCode: "N05AH02"
}, {
  CIP7: '2737124',
  CIP13: '3400927371240',
  ucdLib: "LEPONEX 25MG CPR",
  UCD7: '9151172',
  UCD13: '3400891511727',
  ucdQtyMultiplicator: 14,
  cipLib: "LEPONEX 25MG CPR BT 14",
  atcCode: "N05AH02"
}, {
  CIP7: '2737130',
  CIP13: '3400927371301',
  ucdLib: "LEPONEX 25MG CPR",
  UCD7: '9151172',
  UCD13: '3400891511727',
  ucdQtyMultiplicator: 28,
  cipLib: "LEPONEX 25MG CPR BT 28",
  atcCode: "N05AH02"
}, {
  CIP7: '3233420',
  CIP13: '3400932334209',
  ucdLib: "LOXAPAC 25MG/ML BUV FV30ML",
  UCD7: '9055184',
  UCD13: '3400890551847',
  ucdQtyMultiplicator: 1,
  cipLib: "LOXAPAC 25MG/ML BUV FV30ML BT 1",
  atcCode: "N05AH01"
}, {
  CIP7: '3222770',
  CIP13: '3400932227709',
  ucdLib: "LOXAPAC 25MG CPR",
  UCD7: '9055161',
  UCD13: '3400890551618',
  ucdQtyMultiplicator: 30,
  cipLib: "LOXAPAC 25MG CPR BT 30",
  atcCode: "N05AH01"
}, {
  CIP7: '3343574',
  CIP13: '3400933435745',
  ucdLib: "LOXAPAC 50MG CPR",
  UCD7: '9055178',
  UCD13: '3400890551786',
  ucdQtyMultiplicator: 30,
  cipLib: "LOXAPAC 50MG CPR BT 30",
  atcCode: "N05AH01"
}, {
  CIP7: '3398428',
  CIP13: '3400933984281',
  ucdLib: "LOXAPAC 100MG CPR",
  UCD7: '9190597',
  UCD13: '3400891905977',
  ucdQtyMultiplicator: 30,
  cipLib: "LOXAPAC 100MG CPR BT 30",
  atcCode: "N05AH01"
}, {
  CIP7: '3695391',
  CIP13: '3400936953918',
  ucdLib: "LOXAPAC 25MG/ML BUV FV60ML",
  UCD7: '9287285',
  UCD13: '3400892872858',
  ucdQtyMultiplicator: 1,
  cipLib: "LOXAPAC 25MG/ML BUV FV60ML BT 1",
  atcCode: "N05AH01"
}, {
  CIP7: '5633098',
  CIP13: '3400956330980',
  ucdLib: "LOXAPAC 50MG INJ AMP2ML",
  UCD7: '9136899',
  UCD13: '3400891368994',
  ucdQtyMultiplicator: 10,
  cipLib: "LOXAPAC 50MG INJ AMP2ML BT 10",
  atcCode: "N05AH01"
}, {
  CIP7: '5859767',
  CIP13: '3400958597671',
  ucdLib: "ADASUVE 9,1MG INHAL UNIDOS",
  UCD7: '9403604',
  UCD13: '3400894036043',
  ucdQtyMultiplicator: 1,
  cipLib: "ADASUVE 9,1MG INHAL UNIDOS BT 1",
  atcCode: "N05AH01"
}, {
  CIP7: '5848611',
  CIP13: '3400958486111',
  ucdLib: "LOXAPAC 100MG CPR",
  UCD7: '9190597',
  UCD13: '3400891905977',
  ucdQtyMultiplicator: 30,
  cipLib: "LOXAPAC 100MG CPR BT 30",
  atcCode: "N05AH01"
}, {
  CIP7: '5849119',
  CIP13: '3400958491191',
  ucdLib: "LOXAPAC 25MG CPR",
  UCD7: '9055161',
  UCD13: '3400890551618',
  ucdQtyMultiplicator: 30,
  cipLib: "LOXAPAC 25MG CPR BT 30",
  atcCode: "N05AH01"
}, {
  CIP7: '5849160',
  CIP13: '3400958491603',
  ucdLib: "LOXAPAC 50MG CPR",
  UCD7: '9055178',
  UCD13: '3400890551786',
  ucdQtyMultiplicator: 30,
  cipLib: "LOXAPAC 50MG CPR BT 30",
  atcCode: "N05AH01"
}, {
  CIP7: '3130714',
  CIP13: '3400931307143',
  ucdLib: "ORAP 1MG CPR",
  UCD7: '9065633',
  UCD13: '3400890656337',
  ucdQtyMultiplicator: 30,
  cipLib: "ORAP 1MG CPR BT 30",
  atcCode: "N05AG02"
}, {
  CIP7: '3130720',
  CIP13: '3400931307204',
  ucdLib: "ORAP 4MG CPR",
  UCD7: '9065656',
  UCD13: '3400890656566',
  ucdQtyMultiplicator: 30,
  cipLib: "ORAP 4MG CPR BT 30",
  atcCode: "N05AG02"
}, {
  CIP7: '3294798',
  CIP13: '3400932947980',
  ucdLib: "CLOPIXOL 2% BUV GTT FV20ML",
  UCD7: '9126027',
  UCD13: '3400891260274',
  ucdQtyMultiplicator: 1,
  cipLib: "CLOPIXOL 2% BUV GTT FV20ML BT 1",
  atcCode: "N05AF05"
}, {
  CIP7: '3294806',
  CIP13: '3400932948062',
  ucdLib: "CLOPIXOL A.P 200MG/ML IM AMP",
  UCD7: '9125996',
  UCD13: '3400891259964',
  ucdQtyMultiplicator: 1,
  cipLib: "CLOPIXOL A.P 200MG/ML IM AMP BT 1",
  atcCode: "N05AF05"
}, {
  CIP7: '3294812',
  CIP13: '3400932948123',
  ucdLib: "CLOPIXOL A.P 200MG/ML IM AMP",
  UCD7: '9125996',
  UCD13: '3400891259964',
  ucdQtyMultiplicator: 10,
  cipLib: "CLOPIXOL A.P 200MG/ML IM AMP BT 10",
  atcCode: "N05AF05"
}, {
  CIP7: '5562599',
  CIP13: '3400955625995',
  ucdLib: "CLOPIXOL A.S.P 50MG/1ML IM",
  UCD7: '9126004',
  UCD13: '3400891260045',
  ucdQtyMultiplicator: 5,
  cipLib: "CLOPIXOL A.S.P 50MG/1ML IM BT 5",
  atcCode: "N05AF05"
}, {
  CIP7: '3695416',
  CIP13: '3400936954168',
  ucdLib: "CLOPIXOL 10MG CPR PELLIC",
  UCD7: '9126010',
  UCD13: '3400891260106',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIXOL 10MG CPR PELLIC BT 30",
  atcCode: "N05AF05"
}, {
  CIP7: '3695439',
  CIP13: '3400936954397',
  ucdLib: "CLOPIXOL 25MG CPR PELLIC",
  UCD7: '9126033',
  UCD13: '3400891260335',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIXOL 25MG CPR PELLIC BT 30",
  atcCode: "N05AF05"
}, {
  CIP7: '5671696',
  CIP13: '3400956716968',
  ucdLib: "CLOPIXOL 25MG CPR PELLIC",
  UCD7: '9126033',
  UCD13: '3400891260335',
  ucdQtyMultiplicator: 98,
  cipLib: "CLOPIXOL 25MG CPR PELLIC BT 98",
  atcCode: "N05AF05"
}, {
  CIP7: '3263496',
  CIP13: '3400932634965',
  ucdLib: "FLUANXOL LP 100MG/ML INJ A1ML",
  UCD7: '9102794',
  UCD13: '3400891027945',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUANXOL LP 100MG/ML INJ A1ML BT 1",
  atcCode: "N05AF01"
}, {
  CIP7: '3165552',
  CIP13: '3400931655527',
  ucdLib: "FLUANXOL 4% BUV GTT FV10ML",
  UCD7: '9035371',
  UCD13: '3400890353717',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUANXOL 4% BUV GTT FV10ML BT 1",
  atcCode: "N05AF01"
}, {
  CIP7: '5867264',
  CIP13: '3400958672644',
  ucdLib: "DROPERIDOL PAN 5MG INJ A.2ML",
  UCD7: '9403567',
  UCD13: '3400894035671',
  ucdQtyMultiplicator: 10,
  cipLib: "DROPERIDOL PAN 5MG INJ A.2ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '5605297',
  CIP13: '3400956052974',
  ucdLib: "DROLEPTAN 5MG INJ AMP2ML",
  UCD7: '9195057',
  UCD13: '3400891950571',
  ucdQtyMultiplicator: 10,
  cipLib: "DROLEPTAN 5MG INJ AMP2ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '5840532',
  CIP13: '3400958405327',
  ucdLib: "DROPERIDOL AGT 5MG INJ A.2ML",
  UCD7: '9390511',
  UCD13: '3400893905111',
  ucdQtyMultiplicator: 10,
  cipLib: "DROPERIDOL AGT 5MG INJ A.2ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '5833093',
  CIP13: '3400958330933',
  ucdLib: "DROPERIDOL ARW 5MG INJ A.2ML",
  UCD7: '9385906',
  UCD13: '3400893859063',
  ucdQtyMultiplicator: 10,
  cipLib: "DROPERIDOL ARW 5MG INJ A.2ML BT 10",
  atcCode: "N05AD08"
}, {
  CIP7: '3032319',
  CIP13: '3400930323199',
  ucdLib: "DIPIPERON 40MG CPR",
  UCD7: '9027650',
  UCD13: '3400890276504',
  ucdQtyMultiplicator: 20,
  cipLib: "DIPIPERON 40MG CPR BT 20",
  atcCode: "N05AD05"
}, {
  CIP7: '3130045',
  CIP13: '3400931300458',
  ucdLib: "DIPIPERON 40MG/ML BUV FL30ML",
  UCD7: '9027644',
  UCD13: '3400890276443',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPIPERON 40MG/ML BUV FL30ML BT 1",
  atcCode: "N05AD05"
}, {
  CIP7: '5605995',
  CIP13: '3400956059959',
  ucdLib: "DIPIPERON 40MG/ML BUV FL195ML",
  UCD7: '9109626',
  UCD13: '3400891096262',
  ucdQtyMultiplicator: 4,
  cipLib: "DIPIPERON 40MG/ML BUV FL195ML BT 4",
  atcCode: "N05AD05"
}, {
  CIP7: '5533008',
  CIP13: '3400955330080',
  ucdLib: "HALDOL 2MG/ML BUV GTT FP195ML",
  UCD7: '9112485',
  UCD13: '3400891124859',
  ucdQtyMultiplicator: 4,
  cipLib: "HALDOL 2MG/ML BUV GTT FP195ML BT 4",
  atcCode: "N05AD01"
}, {
  CIP7: '3047143',
  CIP13: '3400930471432',
  ucdLib: "HALDOL 1MG CPR",
  UCD7: '9041489',
  UCD13: '3400890414890',
  ucdQtyMultiplicator: 40,
  cipLib: "HALDOL 1MG CPR BT 40",
  atcCode: "N05AD01"
}, {
  CIP7: '3047189',
  CIP13: '3400930471890',
  ucdLib: "HALDOL 5MG INJ AMP1ML",
  UCD7: '9041472',
  UCD13: '3400890414722',
  ucdQtyMultiplicator: 5,
  cipLib: "HALDOL 5MG INJ AMP1ML BT 5",
  atcCode: "N05AD01"
}, {
  CIP7: '3263510',
  CIP13: '3400932635108',
  ucdLib: "HALDOL DECANOAS INJ AMP1ML",
  UCD7: '9041532',
  UCD13: '3400890415323',
  ucdQtyMultiplicator: 5,
  cipLib: "HALDOL DECANOAS INJ AMP1ML BT 5",
  atcCode: "N05AD01"
}, {
  CIP7: '3269932',
  CIP13: '3400932699322',
  ucdLib: "HALDOL DECANOAS INJ AMP1ML",
  UCD7: '9041532',
  UCD13: '3400890415323',
  ucdQtyMultiplicator: 1,
  cipLib: "HALDOL DECANOAS INJ AMP1ML BT 1",
  atcCode: "N05AD01"
}, {
  CIP7: '3208250',
  CIP13: '3400932082506',
  ucdLib: "HALDOL 5MG CPR",
  UCD7: '9041503',
  UCD13: '3400890415033',
  ucdQtyMultiplicator: 30,
  cipLib: "HALDOL 5MG CPR BT 30",
  atcCode: "N05AD01"
}, {
  CIP7: '2692114',
  CIP13: '3400926921149',
  ucdLib: "HALDOL 2MG/ML BUV GTT FP30ML",
  UCD7: '9395193',
  UCD13: '3400893951934',
  ucdQtyMultiplicator: 1,
  cipLib: "HALDOL 2MG/ML BUV GTT FP30ML BT 1",
  atcCode: "N05AD01"
}, {
  CIP7: '3141913',
  CIP13: '3400931419136',
  ucdLib: "PIPORTIL 10MG CPR",
  UCD7: '9072171',
  UCD13: '3400890721714',
  ucdQtyMultiplicator: 20,
  cipLib: "PIPORTIL 10MG CPR BT 20",
  atcCode: "N05AC04"
}, {
  CIP7: '3141971',
  CIP13: '3400931419716',
  ucdLib: "PIPORTIL 4% BUV GTT FL10ML",
  UCD7: '9072188',
  UCD13: '3400890721882',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPORTIL 4% BUV GTT FL10ML BT 1",
  atcCode: "N05AC04"
}, {
  CIP7: '3140486',
  CIP13: '3400931404866',
  ucdLib: "PIPORTIL L4 100MG INJ AMP4ML",
  UCD7: '9072202',
  UCD13: '3400890722025',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPORTIL L4 100MG INJ AMP4ML BT 1",
  atcCode: "N05AC04"
}, {
  CIP7: '3272584',
  CIP13: '3400932725847',
  ucdLib: "NEULEPTIL 4% BUV GTT FL30ML",
  UCD7: '9062385',
  UCD13: '3400890623858',
  ucdQtyMultiplicator: 1,
  cipLib: "NEULEPTIL 4% BUV GTT FL30ML BT 1",
  atcCode: "N05AC01"
}, {
  CIP7: '3071696',
  CIP13: '3400930716960',
  ucdLib: "NEULEPTIL 1% BUV GTT FL30ML",
  UCD7: '9062379',
  UCD13: '3400890623797',
  ucdQtyMultiplicator: 1,
  cipLib: "NEULEPTIL 1% BUV GTT FL30ML BT 1",
  atcCode: "N05AC01"
}, {
  CIP7: '3542718',
  CIP13: '3400935427182',
  ucdLib: "NEULEPTIL 10MG GELU",
  UCD7: '9062362',
  UCD13: '3400890623629',
  ucdQtyMultiplicator: 50,
  cipLib: "NEULEPTIL 10MG GELU BT 50",
  atcCode: "N05AC01"
}, {
  CIP7: '3186962',
  CIP13: '3400931869627',
  ucdLib: "NEULEPTIL 25MG CPR",
  UCD7: '9062356',
  UCD13: '3400890623568',
  ucdQtyMultiplicator: 50,
  cipLib: "NEULEPTIL 25MG CPR BT 50",
  atcCode: "N05AC01"
}, {
  CIP7: '5503450',
  CIP13: '3400955034506',
  ucdLib: "NEULEPTIL 4% BUV FL125ML+SRG",
  UCD7: '9120214',
  UCD13: '3400891202144',
  ucdQtyMultiplicator: 1,
  cipLib: "NEULEPTIL 4% BUV FL125ML+SRG BT 1",
  atcCode: "N05AC01"
}, {
  CIP7: '3121454',
  CIP13: '3400931214540',
  ucdLib: "MODECATE 125MG INJ FL5ML",
  UCD7: '9059325',
  UCD13: '3400890593250',
  ucdQtyMultiplicator: 1,
  cipLib: "MODECATE 125MG INJ FL5ML BT 1",
  atcCode: "N05AB02"
}, {
  CIP7: '3121460',
  CIP13: '3400931214601',
  ucdLib: "MODECATE 25MG INJ AMP1ML",
  UCD7: '9059319',
  UCD13: '3400890593199',
  ucdQtyMultiplicator: 3,
  cipLib: "MODECATE 25MG INJ AMP1ML BT 3",
  atcCode: "N05AB02"
}, {
  CIP7: '5547387',
  CIP13: '3400955473879',
  ucdLib: "TERCIAN 4% BUV GTT FV100ML",
  UCD7: '9115710',
  UCD13: '3400891157109',
  ucdQtyMultiplicator: 1,
  cipLib: "TERCIAN 4% BUV GTT FV100ML BT 1",
  atcCode: "N05AA06"
}, {
  CIP7: '3296389',
  CIP13: '3400932963898',
  ucdLib: "TERCIAN 25MG CPR",
  UCD7: '9125849',
  UCD13: '3400891258493',
  ucdQtyMultiplicator: 30,
  cipLib: "TERCIAN 25MG CPR BT 30",
  atcCode: "N05AA06"
}, {
  CIP7: '3191992',
  CIP13: '3400931919926',
  ucdLib: "TERCIAN 100MG CPR",
  UCD7: '9091145',
  UCD13: '3400890911450',
  ucdQtyMultiplicator: 25,
  cipLib: "TERCIAN 100MG CPR BT 25",
  atcCode: "N05AA06"
}, {
  CIP7: '3130329',
  CIP13: '3400931303299',
  ucdLib: "TERCIAN 4% BUV GTT FV30ML",
  UCD7: '9091168',
  UCD13: '3400890911689',
  ucdQtyMultiplicator: 1,
  cipLib: "TERCIAN 4% BUV GTT FV30ML BT 1",
  atcCode: "N05AA06"
}, {
  CIP7: '3162335',
  CIP13: '3400931623359',
  ucdLib: "TERCIAN 50MG INJ AMP5ML",
  UCD7: '9091139',
  UCD13: '3400890911399',
  ucdQtyMultiplicator: 5,
  cipLib: "TERCIAN 50MG INJ AMP5ML BT 5",
  atcCode: "N05AA06"
}, {
  CIP7: '5746425',
  CIP13: '3400957464257',
  ucdLib: "TERCIAN 100MG CPR",
  UCD7: '9091145',
  UCD13: '3400890911450',
  ucdQtyMultiplicator: 50,
  cipLib: "TERCIAN 100MG CPR BT 50",
  atcCode: "N05AA06"
}, {
  CIP7: '5748938',
  CIP13: '3400957489380',
  ucdLib: "TERCIAN 25MG CPR",
  UCD7: '9125849',
  UCD13: '3400891258493',
  ucdQtyMultiplicator: 100,
  cipLib: "TERCIAN 25MG CPR BT 100",
  atcCode: "N05AA06"
}, {
  CIP7: '3272578',
  CIP13: '3400932725786',
  ucdLib: "NOZINAN 25MG INJ AMP1ML",
  UCD7: '9064071',
  UCD13: '3400890640718',
  ucdQtyMultiplicator: 5,
  cipLib: "NOZINAN 25MG INJ AMP1ML BT 5",
  atcCode: "N05AA02"
}, {
  CIP7: '3074298',
  CIP13: '3400930742983',
  ucdLib: "NOZINAN 100MG CPR",
  UCD7: '9064119',
  UCD13: '3400890641197',
  ucdQtyMultiplicator: 20,
  cipLib: "NOZINAN 100MG CPR BT 20",
  atcCode: "N05AA02"
}, {
  CIP7: '3074281',
  CIP13: '3400930742815',
  ucdLib: "NOZINAN 25MG CPR",
  UCD7: '9064125',
  UCD13: '3400890641258',
  ucdQtyMultiplicator: 20,
  cipLib: "NOZINAN 25MG CPR BT 20",
  atcCode: "N05AA02"
}, {
  CIP7: '3074312',
  CIP13: '3400930743126',
  ucdLib: "NOZINAN 4% BUV GTT FL30ML",
  UCD7: '9064088',
  UCD13: '3400890640886',
  ucdQtyMultiplicator: 1,
  cipLib: "NOZINAN 4% BUV GTT FL30ML BT 1",
  atcCode: "N05AA02"
}, {
  CIP7: '5504461',
  CIP13: '3400955044611',
  ucdLib: "NOZINAN 4% BUV FL125ML+SRG",
  UCD7: '9120237',
  UCD13: '3400891202373',
  ucdQtyMultiplicator: 1,
  cipLib: "NOZINAN 4% BUV FL125ML+SRG BT 1",
  atcCode: "N05AA02"
}, {
  CIP7: '3057124',
  CIP13: '3400930571248',
  ucdLib: "LARGACTIL 100MG CPR",
  UCD7: '9049717',
  UCD13: '3400890497176',
  ucdQtyMultiplicator: 30,
  cipLib: "LARGACTIL 100MG CPR BT 30",
  atcCode: "N05AA01"
}, {
  CIP7: '3057118',
  CIP13: '3400930571187',
  ucdLib: "LARGACTIL 25MG CPR",
  UCD7: '9049723',
  UCD13: '3400890497237',
  ucdQtyMultiplicator: 50,
  cipLib: "LARGACTIL 25MG CPR BT 50",
  atcCode: "N05AA01"
}, {
  CIP7: '3057147',
  CIP13: '3400930571477',
  ucdLib: "LARGACTIL 4% BUV GTT FL30ML",
  UCD7: '9049746',
  UCD13: '3400890497466',
  ucdQtyMultiplicator: 1,
  cipLib: "LARGACTIL 4% BUV GTT FL30ML BT 1",
  atcCode: "N05AA01"
}, {
  CIP7: '3272242',
  CIP13: '3400932722426',
  ucdLib: "LARGACTIL 25MG INJ AMP5ML",
  UCD7: '9049700',
  UCD13: '3400890497008',
  ucdQtyMultiplicator: 5,
  cipLib: "LARGACTIL 25MG INJ AMP5ML BT 5",
  atcCode: "N05AA01"
}, {
  CIP7: '5500569',
  CIP13: '3400955005698',
  ucdLib: "LARGACTIL 4% BUV GTT FL125ML",
  UCD7: '9120148',
  UCD13: '3400891201482',
  ucdQtyMultiplicator: 1,
  cipLib: "LARGACTIL 4% BUV GTT FL125ML BT 1",
  atcCode: "N05AA01"
}, {
  CIP7: '3486517',
  CIP13: '3400934865176',
  ucdLib: "COMTAN 200MG CPR",
  UCD7: '9204916',
  UCD13: '3400892049168',
  ucdQtyMultiplicator: 60,
  cipLib: "COMTAN 200MG CPR BT 60",
  atcCode: "N04BX02"
}, {
  CIP7: '3486523',
  CIP13: '3400934865237',
  ucdLib: "COMTAN 200MG CPR",
  UCD7: '9204916',
  UCD13: '3400892049168',
  ucdQtyMultiplicator: 100,
  cipLib: "COMTAN 200MG CPR BT 100",
  atcCode: "N04BX02"
}, {
  CIP7: '2227676',
  CIP13: '3400922276762',
  ucdLib: "ENTACAPONE MYL 200MG CPR",
  UCD7: '9386834',
  UCD13: '3400893868348',
  ucdQtyMultiplicator: 60,
  cipLib: "ENTACAPONE MYL 200MG CPR BT 60",
  atcCode: "N04BX02"
}, {
  CIP7: '2227682',
  CIP13: '3400922276823',
  ucdLib: "ENTACAPONE MYL 200MG CPR",
  UCD7: '9386834',
  UCD13: '3400893868348',
  ucdQtyMultiplicator: 100,
  cipLib: "ENTACAPONE MYL 200MG CPR BT 100",
  atcCode: "N04BX02"
}, {
  CIP7: '3454664',
  CIP13: '3400934546648',
  ucdLib: "TASMAR 100MG CPR",
  UCD7: '9202202',
  UCD13: '3400892022024',
  ucdQtyMultiplicator: 100,
  cipLib: "TASMAR 100MG CPR BT 100",
  atcCode: "N04BX01"
}, {
  CIP7: '3006783',
  CIP13: '3400930067833',
  ucdLib: "RASAGILINE BGA 1MG CPR",
  UCD7: '9421720',
  UCD13: '3400894217206',
  ucdQtyMultiplicator: 30,
  cipLib: "RASAGILINE BGA 1MG CPR BT 30",
  atcCode: "N04BD02"
}, {
  CIP7: '3004825',
  CIP13: '3400930048252',
  ucdLib: "RASAGILINE HCS 1MG CPR",
  UCD7: '9422719',
  UCD13: '3400894227199',
  ucdQtyMultiplicator: 30,
  cipLib: "RASAGILINE HCS 1MG CPR BT 30",
  atcCode: "N04BD02"
}, {
  CIP7: '3006006',
  CIP13: '3400930060063',
  ucdLib: "RASAGILINE MYL 1MG CPR",
  UCD7: '9418600',
  UCD13: '3400894186007',
  ucdQtyMultiplicator: 30,
  cipLib: "RASAGILINE MYL 1MG CPR BT 30",
  atcCode: "N04BD02"
}, {
  CIP7: '3002055',
  CIP13: '3400930020555',
  ucdLib: "RASAGILINE RTP 1MG CPR",
  UCD7: '9413896',
  UCD13: '3400894138969',
  ucdQtyMultiplicator: 30,
  cipLib: "RASAGILINE RTP 1MG CPR BT 30",
  atcCode: "N04BD02"
}, {
  CIP7: '3657835',
  CIP13: '3400936578357',
  ucdLib: "AZILECT 1MG CPR",
  UCD7: '9284789',
  UCD13: '3400892847894',
  ucdQtyMultiplicator: 30,
  cipLib: "AZILECT 1MG CPR BT 30",
  atcCode: "N04BD02"
}, {
  CIP7: '3507573',
  CIP13: '3400935075734',
  ucdLib: "SELEGILINE MYL 5MG CPR",
  UCD7: '9198021',
  UCD13: '3400891980219',
  ucdQtyMultiplicator: 30,
  cipLib: "SELEGILINE MYL 5MG CPR BT 30",
  atcCode: "N04BD01"
}, {
  CIP7: '3983581',
  CIP13: '3400939835815',
  ucdLib: "DEPRENYL 5MG CPR",
  UCD7: '9140725',
  UCD13: '3400891407259',
  ucdQtyMultiplicator: 100,
  cipLib: "DEPRENYL 5MG CPR BT 100",
  atcCode: "N04BD01"
}, {
  CIP7: '3983598',
  CIP13: '3400939835983',
  ucdLib: "DEPRENYL 5MG CPR",
  UCD7: '9140725',
  UCD13: '3400891407259',
  ucdQtyMultiplicator: 30,
  cipLib: "DEPRENYL 5MG CPR BT 30",
  atcCode: "N04BD01"
}, {
  CIP7: '3772097',
  CIP13: '3400937720977',
  ucdLib: "NEUPRO 2MG/24H DISP TRANS",
  UCD7: '9317342',
  UCD13: '3400893173428',
  ucdQtyMultiplicator: 30,
  cipLib: "NEUPRO 2MG/24H DISP TRANS BT 30",
  atcCode: "N04BC09"
}, {
  CIP7: '3772111',
  CIP13: '3400937721110',
  ucdLib: "NEUPRO 4MG/24H DISP TRANS",
  UCD7: '9317365',
  UCD13: '3400893173657',
  ucdQtyMultiplicator: 30,
  cipLib: "NEUPRO 4MG/24H DISP TRANS BT 30",
  atcCode: "N04BC09"
}, {
  CIP7: '3772134',
  CIP13: '3400937721349',
  ucdLib: "NEUPRO 6MG/24H DISP TRANS",
  UCD7: '9317371',
  UCD13: '3400893173718',
  ucdQtyMultiplicator: 30,
  cipLib: "NEUPRO 6MG/24H DISP TRANS BT 30",
  atcCode: "N04BC09"
}, {
  CIP7: '3772157',
  CIP13: '3400937721578',
  ucdLib: "NEUPRO 8MG/24H DISP TRANS",
  UCD7: '9317388',
  UCD13: '3400893173886',
  ucdQtyMultiplicator: 30,
  cipLib: "NEUPRO 8MG/24H DISP TRANS BT 30",
  atcCode: "N04BC09"
}, {
  CIP7: '3732850',
  CIP13: '3400937328500',
  ucdLib: "NEUPRO 2MG/24H DISP TRANS",
  UCD7: '9317342',
  UCD13: '3400893173428',
  ucdQtyMultiplicator: 7,
  cipLib: "NEUPRO 2MG/24H DISP TRANS BT 7",
  atcCode: "N04BC09"
}, {
  CIP7: '3732873',
  CIP13: '3400937328739',
  ucdLib: "NEUPRO 4MG/24H DISP TRANS",
  UCD7: '9317365',
  UCD13: '3400893173657',
  ucdQtyMultiplicator: 7,
  cipLib: "NEUPRO 4MG/24H DISP TRANS BT 7",
  atcCode: "N04BC09"
}, {
  CIP7: '3108608',
  CIP13: '3400931086086',
  ucdLib: "TRIVASTAL 20MG CPR ENROB",
  UCD7: '9095195',
  UCD13: '3400890951951',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIVASTAL 20MG CPR ENROB BT 30",
  atcCode: "N04BC08"
}, {
  CIP7: '3189067',
  CIP13: '3400931890676',
  ucdLib: "TRIVASTAL 50MG LP CPR",
  UCD7: '9095203',
  UCD13: '3400890952033',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIVASTAL 50MG LP CPR BT 30",
  atcCode: "N04BC08"
}, {
  CIP7: '3189110',
  CIP13: '3400931891109',
  ucdLib: "TRIVASTAL 50MG LP CPR",
  UCD7: '9095203',
  UCD13: '3400890952033',
  ucdQtyMultiplicator: 100,
  cipLib: "TRIVASTAL 50MG LP CPR BT 100",
  atcCode: "N04BC08"
}, {
  CIP7: '3169900',
  CIP13: '3400931699002',
  ucdLib: "TRIVASTAL 3MG INJ AMP1ML",
  UCD7: '9095189',
  UCD13: '3400890951890',
  ucdQtyMultiplicator: 12,
  cipLib: "TRIVASTAL 3MG INJ AMP1ML BT 12",
  atcCode: "N04BC08"
}, {
  CIP7: '3387057',
  CIP13: '3400933870577',
  ucdLib: "APOKINON 30MG/3ML INJ CARTCH",
  UCD7: '9177208',
  UCD13: '3400891772081',
  ucdQtyMultiplicator: 1,
  cipLib: "APOKINON 30MG/3ML INJ CARTCH BT 1",
  atcCode: "N04BC07"
}, {
  CIP7: '3387063',
  CIP13: '3400933870638',
  ucdLib: "APOKINON 30MG/3ML INJ CARTCH",
  UCD7: '9177208',
  UCD13: '3400891772081',
  ucdQtyMultiplicator: 5,
  cipLib: "APOKINON 30MG/3ML INJ CARTCH BT 5",
  atcCode: "N04BC07"
}, {
  CIP7: '4974064',
  CIP13: '3400949740642',
  ucdLib: "APOKINON 5MG/ML INJ AMP10ML",
  UCD7: '9362704',
  UCD13: '3400893627044',
  ucdQtyMultiplicator: 10,
  cipLib: "APOKINON 5MG/ML INJ AMP10ML BT 10",
  atcCode: "N04BC07"
}, {
  CIP7: '3001204',
  CIP13: '3400930012048',
  ucdLib: "PRAMIPEXOLE SDZ LP0,26MG CPR",
  UCD7: '9414542',
  UCD13: '3400894145424',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE SDZ LP0,26MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3001231',
  CIP13: '3400930012314',
  ucdLib: "PRAMIPEXOLE SDZ LP0,52MG CPR",
  UCD7: '9414559',
  UCD13: '3400894145592',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE SDZ LP0,52MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3001233',
  CIP13: '3400930012338',
  ucdLib: "PRAMIPEXOLE SDZ LP1,05MG CPR",
  UCD7: '9414565',
  UCD13: '3400894145653',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE SDZ LP1,05MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3001237',
  CIP13: '3400930012376',
  ucdLib: "PRAMIPEXOLE SDZ LP2,1MG CPR",
  UCD7: '9414571',
  UCD13: '3400894145714',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE SDZ LP2,1MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2762228',
  CIP13: '3400927622281',
  ucdLib: "OPRYMEA 0,26MG CPR LP",
  UCD7: '9398524',
  UCD13: '3400893985243',
  ucdQtyMultiplicator: 30,
  cipLib: "OPRYMEA 0,26MG CPR LP BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2762240',
  CIP13: '3400927622403',
  ucdLib: "OPRYMEA 0,52MG CPR LP",
  UCD7: '9398530',
  UCD13: '3400893985304',
  ucdQtyMultiplicator: 30,
  cipLib: "OPRYMEA 0,52MG CPR LP BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2762263',
  CIP13: '3400927622632',
  ucdLib: "OPRYMEA 1,05MG CPR LP",
  UCD7: '9398547',
  UCD13: '3400893985472',
  ucdQtyMultiplicator: 30,
  cipLib: "OPRYMEA 1,05MG CPR LP BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2762292',
  CIP13: '3400927622922',
  ucdLib: "OPRYMEA 2,1MG CPR LP",
  UCD7: '9398553',
  UCD13: '3400893985533',
  ucdQtyMultiplicator: 30,
  cipLib: "OPRYMEA 2,1MG CPR LP BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3634691',
  CIP13: '3400936346918',
  ucdLib: "SIFROL 0,18MG CPR",
  UCD7: '9259567',
  UCD13: '3400892595672',
  ucdQtyMultiplicator: 30,
  cipLib: "SIFROL 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3634716',
  CIP13: '3400936347168',
  ucdLib: "SIFROL 0,18MG CPR",
  UCD7: '9259567',
  UCD13: '3400892595672',
  ucdQtyMultiplicator: 100,
  cipLib: "SIFROL 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3634745',
  CIP13: '3400936347458',
  ucdLib: "SIFROL 0,7MG CPR",
  UCD7: '9259596',
  UCD13: '3400892595962',
  ucdQtyMultiplicator: 30,
  cipLib: "SIFROL 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3634751',
  CIP13: '3400936347519',
  ucdLib: "SIFROL 0,7MG CPR",
  UCD7: '9259596',
  UCD13: '3400892595962',
  ucdQtyMultiplicator: 100,
  cipLib: "SIFROL 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3793900',
  CIP13: '3400937939003',
  ucdLib: "PRAMIPEXOLE BGA 0,18MG CPR",
  UCD7: '9357991',
  UCD13: '3400893579916',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE BGA 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3793952',
  CIP13: '3400937939522',
  ucdLib: "PRAMIPEXOLE BGA 0,18MG CPR",
  UCD7: '9357991',
  UCD13: '3400893579916',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE BGA 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3793969',
  CIP13: '3400937939690',
  ucdLib: "PRAMIPEXOLE BGA 0,7MG CPR",
  UCD7: '9358016',
  UCD13: '3400893580165',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE BGA 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3793975',
  CIP13: '3400937939751',
  ucdLib: "PRAMIPEXOLE BGA 0,7MG CPR",
  UCD7: '9358016',
  UCD13: '3400893580165',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE BGA 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3934312',
  CIP13: '3400939343129',
  ucdLib: "PRAMIPEXOLE EG 0,18MG CPR",
  UCD7: '9336486',
  UCD13: '3400893364864',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE EG 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3934335',
  CIP13: '3400939343358',
  ucdLib: "PRAMIPEXOLE EG 0,18MG CPR",
  UCD7: '9336486',
  UCD13: '3400893364864',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE EG 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3934358',
  CIP13: '3400939343587',
  ucdLib: "PRAMIPEXOLE EG 0,7MG CPR",
  UCD7: '9336492',
  UCD13: '3400893364925',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE EG 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3934370',
  CIP13: '3400939343709',
  ucdLib: "PRAMIPEXOLE EG 0,7MG CPR",
  UCD7: '9336492',
  UCD13: '3400893364925',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE EG 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3979266',
  CIP13: '3400939792668',
  ucdLib: "PRAMIPEXOLE SDZ 0,18MG CPR",
  UCD7: '9347225',
  UCD13: '3400893472255',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE SDZ 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3979295',
  CIP13: '3400939792958',
  ucdLib: "PRAMIPEXOLE SDZ 0,18MG CPR",
  UCD7: '9347225',
  UCD13: '3400893472255',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE SDZ 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3979527',
  CIP13: '3400939795270',
  ucdLib: "PRAMIPEXOLE SDZ 0,7MG CPR",
  UCD7: '9347231',
  UCD13: '3400893472316',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE SDZ 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3979562',
  CIP13: '3400939795621',
  ucdLib: "PRAMIPEXOLE SDZ 0,7MG CPR",
  UCD7: '9347231',
  UCD13: '3400893472316',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE SDZ 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3953605',
  CIP13: '3400939536057',
  ucdLib: "PRAMIPEXOLE TVC 0,18MG CPR",
  UCD7: '9342498',
  UCD13: '3400893424988',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE TVC 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3953663',
  CIP13: '3400939536637',
  ucdLib: "PRAMIPEXOLE TVC 0,7MG CPR",
  UCD7: '9342506',
  UCD13: '3400893425060',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE TVC 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3968245',
  CIP13: '3400939682457',
  ucdLib: "PRAMIPEXOLE ZEN 0,18MG CPR",
  UCD7: '9347188',
  UCD13: '3400893471883',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE ZEN 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3968251',
  CIP13: '3400939682518',
  ucdLib: "PRAMIPEXOLE ZEN 0,18MG CPR",
  UCD7: '9347188',
  UCD13: '3400893471883',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE ZEN 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3968222',
  CIP13: '3400939682228',
  ucdLib: "PRAMIPEXOLE ZEN 0,7MG CPR",
  UCD7: '9347194',
  UCD13: '3400893471944',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE ZEN 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3968239',
  CIP13: '3400939682396',
  ucdLib: "PRAMIPEXOLE ZEN 0,7MG CPR",
  UCD7: '9347194',
  UCD13: '3400893471944',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE ZEN 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3911340',
  CIP13: '3400939113401',
  ucdLib: "PRAMIPEXOLE ZYD 0,18MG CPR",
  UCD7: '9356448',
  UCD13: '3400893564486',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE ZYD 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3912368',
  CIP13: '3400939123684',
  ucdLib: "PRAMIPEXOLE ZYD 0,18MG CPR",
  UCD7: '9356448',
  UCD13: '3400893564486',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE ZYD 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3907976',
  CIP13: '3400939079769',
  ucdLib: "PRAMIPEXOLE ZYD 0,7MG CPR",
  UCD7: '9356460',
  UCD13: '3400893564608',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE ZYD 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3909544',
  CIP13: '3400939095448',
  ucdLib: "PRAMIPEXOLE ZYD 0,7MG CPR",
  UCD7: '9356460',
  UCD13: '3400893564608',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE ZYD 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3974903',
  CIP13: '3400939749037',
  ucdLib: "SIFROL 0,26MG CPR LP",
  UCD7: '9346013',
  UCD13: '3400893460139',
  ucdQtyMultiplicator: 10,
  cipLib: "SIFROL 0,26MG CPR LP BT 10",
  atcCode: "N04BC05"
}, {
  CIP7: '3974926',
  CIP13: '3400939749266',
  ucdLib: "SIFROL 0,26MG CPR LP",
  UCD7: '9346013',
  UCD13: '3400893460139',
  ucdQtyMultiplicator: 30,
  cipLib: "SIFROL 0,26MG CPR LP BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3974949',
  CIP13: '3400939749495',
  ucdLib: "SIFROL 0,52MG CPR LP",
  UCD7: '9346036',
  UCD13: '3400893460368',
  ucdQtyMultiplicator: 10,
  cipLib: "SIFROL 0,52MG CPR LP BT 10",
  atcCode: "N04BC05"
}, {
  CIP7: '3974955',
  CIP13: '3400939749556',
  ucdLib: "SIFROL 0,52MG CPR LP",
  UCD7: '9346036',
  UCD13: '3400893460368',
  ucdQtyMultiplicator: 30,
  cipLib: "SIFROL 0,52MG CPR LP BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3974961',
  CIP13: '3400939749617',
  ucdLib: "SIFROL 1,05MG CPR LP",
  UCD7: '9346042',
  UCD13: '3400893460429',
  ucdQtyMultiplicator: 10,
  cipLib: "SIFROL 1,05MG CPR LP BT 10",
  atcCode: "N04BC05"
}, {
  CIP7: '3974978',
  CIP13: '3400939749785',
  ucdLib: "SIFROL 1,05MG CPR LP",
  UCD7: '9346042',
  UCD13: '3400893460429',
  ucdQtyMultiplicator: 30,
  cipLib: "SIFROL 1,05MG CPR LP BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '3974990',
  CIP13: '3400939749907',
  ucdLib: "SIFROL 2,1MG CPR LP",
  UCD7: '9346059',
  UCD13: '3400893460597',
  ucdQtyMultiplicator: 30,
  cipLib: "SIFROL 2,1MG CPR LP BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2199715',
  CIP13: '3400921997156',
  ucdLib: "PRAMIPEXOLE ACC 0,18MG CPR",
  UCD7: '9378266',
  UCD13: '3400893782668',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE ACC 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2199738',
  CIP13: '3400921997385',
  ucdLib: "PRAMIPEXOLE ACC 0,7MG CPR",
  UCD7: '9378272',
  UCD13: '3400893782729',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE ACC 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2241268',
  CIP13: '3400922412689',
  ucdLib: "OPRYMEA 0,18MG CPR",
  UCD7: '9386372',
  UCD13: '3400893863725',
  ucdQtyMultiplicator: 30,
  cipLib: "OPRYMEA 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2241305',
  CIP13: '3400922413051',
  ucdLib: "OPRYMEA 0,7MG CPR",
  UCD7: '9386389',
  UCD13: '3400893863893',
  ucdQtyMultiplicator: 30,
  cipLib: "OPRYMEA 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '2222673',
  CIP13: '3400922226736',
  ucdLib: "PRAMIPEXOLE ACC 0,18MG CPR",
  UCD7: '9378266',
  UCD13: '3400893782668',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE ACC 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '2222704',
  CIP13: '3400922227047',
  ucdLib: "PRAMIPEXOLE ACC 0,7MG CPR",
  UCD7: '9378272',
  UCD13: '3400893782729',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE ACC 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '4924592',
  CIP13: '3400949245925',
  ucdLib: "PRAMIPEXOLE TVC 0,18MG CPR",
  UCD7: '9342498',
  UCD13: '3400893424988',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE TVC 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '4924617',
  CIP13: '3400949246175',
  ucdLib: "PRAMIPEXOLE TVC 0,7MG CPR",
  UCD7: '9342506',
  UCD13: '3400893425060',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE TVC 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '4963681',
  CIP13: '3400949636815',
  ucdLib: "PRAMIPEXOLE MYL 0,18MG CPR",
  UCD7: '9363112',
  UCD13: '3400893631126',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE MYL 0,18MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '4963729',
  CIP13: '3400949637294',
  ucdLib: "PRAMIPEXOLE MYL 0,18MG CPR",
  UCD7: '9363112',
  UCD13: '3400893631126',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE MYL 0,18MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '4963907',
  CIP13: '3400949639076',
  ucdLib: "PRAMIPEXOLE MYL 0,7MG CPR",
  UCD7: '9363129',
  UCD13: '3400893631294',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAMIPEXOLE MYL 0,7MG CPR BT 30",
  atcCode: "N04BC05"
}, {
  CIP7: '4963959',
  CIP13: '3400949639595',
  ucdLib: "PRAMIPEXOLE MYL 0,7MG CPR",
  UCD7: '9363129',
  UCD13: '3400893631294',
  ucdQtyMultiplicator: 100,
  cipLib: "PRAMIPEXOLE MYL 0,7MG CPR BT 100",
  atcCode: "N04BC05"
}, {
  CIP7: '3792154',
  CIP13: '3400937921541',
  ucdLib: "REQUIP LP 2MG CPR",
  UCD7: '9304977',
  UCD13: '3400893049778',
  ucdQtyMultiplicator: 28,
  cipLib: "REQUIP LP 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '3792214',
  CIP13: '3400937922142',
  ucdLib: "REQUIP LP 4MG CPR",
  UCD7: '9304983',
  UCD13: '3400893049839',
  ucdQtyMultiplicator: 28,
  cipLib: "REQUIP LP 4MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '3792237',
  CIP13: '3400937922371',
  ucdLib: "REQUIP LP 8MG CPR",
  UCD7: '9305008',
  UCD13: '3400893050088',
  ucdQtyMultiplicator: 28,
  cipLib: "REQUIP LP 8MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '3879990',
  CIP13: '3400938799903',
  ucdLib: "REQUIP 0,25MG CPR",
  UCD7: '9189559',
  UCD13: '3400891895599',
  ucdQtyMultiplicator: 21,
  cipLib: "REQUIP 0,25MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3880177',
  CIP13: '3400938801774',
  ucdLib: "REQUIP 0,50MG CPR",
  UCD7: '9189565',
  UCD13: '3400891895650',
  ucdQtyMultiplicator: 21,
  cipLib: "REQUIP 0,50MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3880183',
  CIP13: '3400938801835',
  ucdLib: "REQUIP 1MG CPR",
  UCD7: '9189571',
  UCD13: '3400891895711',
  ucdQtyMultiplicator: 21,
  cipLib: "REQUIP 1MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3880214',
  CIP13: '3400938802146',
  ucdLib: "REQUIP 2MG CPR",
  UCD7: '9189588',
  UCD13: '3400891895889',
  ucdQtyMultiplicator: 21,
  cipLib: "REQUIP 2MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3880237',
  CIP13: '3400938802375',
  ucdLib: "REQUIP 5MG CPR",
  UCD7: '9189594',
  UCD13: '3400891895940',
  ucdQtyMultiplicator: 21,
  cipLib: "REQUIP 5MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3928530',
  CIP13: '3400939285306',
  ucdLib: "ROPINIROLE ARG 0,25MG CPR",
  UCD7: '9337623',
  UCD13: '3400893376232',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE ARG 0,25MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3928694',
  CIP13: '3400939286945',
  ucdLib: "ROPINIROLE ARG 0,50MG CPR",
  UCD7: '9337646',
  UCD13: '3400893376461',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE ARG 0,50MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3929937',
  CIP13: '3400939299372',
  ucdLib: "ROPINIROLE ARG 1MG CPR",
  UCD7: '9337652',
  UCD13: '3400893376522',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE ARG 1MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3889296',
  CIP13: '3400938892963',
  ucdLib: "ROPINIROLE EG 0,25MG CPR",
  UCD7: '9328104',
  UCD13: '3400893281048',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE EG 0,25MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3889505',
  CIP13: '3400938895056',
  ucdLib: "ROPINIROLE EG 0,5MG CPR",
  UCD7: '9328110',
  UCD13: '3400893281109',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE EG 0,5MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3889793',
  CIP13: '3400938897937',
  ucdLib: "ROPINIROLE EG 5MG CPR",
  UCD7: '9334530',
  UCD13: '3400893345306',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE EG 5MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3872367',
  CIP13: '3400938723670',
  ucdLib: "ROPINIROLE MYL 0,25MG CPR",
  UCD7: '9318577',
  UCD13: '3400893185773',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE MYL 0,25MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3872373',
  CIP13: '3400938723731',
  ucdLib: "ROPINIROLE MYL 0,50MG CPR",
  UCD7: '9318583',
  UCD13: '3400893185834',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE MYL 0,50MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3872396',
  CIP13: '3400938723960',
  ucdLib: "ROPINIROLE MYL 1MG CPR",
  UCD7: '9318608',
  UCD13: '3400893186084',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE MYL 1MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3872404',
  CIP13: '3400938724042',
  ucdLib: "ROPINIROLE MYL 2MG CPR",
  UCD7: '9318614',
  UCD13: '3400893186145',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE MYL 2MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3872410',
  CIP13: '3400938724103',
  ucdLib: "ROPINIROLE MYL 5MG CPR",
  UCD7: '9318620',
  UCD13: '3400893186206',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE MYL 5MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3918394',
  CIP13: '3400939183947',
  ucdLib: "ADARTREL 0,25MG CPR",
  UCD7: '9273320',
  UCD13: '3400892733203',
  ucdQtyMultiplicator: 12,
  cipLib: "ADARTREL 0,25MG CPR BT 12",
  atcCode: "N04BC04"
}, {
  CIP7: '3918402',
  CIP13: '3400939184029',
  ucdLib: "ADARTREL 0,50MG CPR",
  UCD7: '9273337',
  UCD13: '3400892733371',
  ucdQtyMultiplicator: 28,
  cipLib: "ADARTREL 0,50MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '3918448',
  CIP13: '3400939184487',
  ucdLib: "ADARTREL 2MG CPR",
  UCD7: '9273366',
  UCD13: '3400892733661',
  ucdQtyMultiplicator: 28,
  cipLib: "ADARTREL 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '3930076',
  CIP13: '3400939300764',
  ucdLib: "ROPINIROLE ARG 2MG CPR",
  UCD7: '9337669',
  UCD13: '3400893376690',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE ARG 2MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '2213728',
  CIP13: '3400922137285',
  ucdLib: "ROPINIROLE EG LP 2MG CPR",
  UCD7: '9390646',
  UCD13: '3400893906460',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE EG LP 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '3930248',
  CIP13: '3400939302485',
  ucdLib: "ROPINIROLE TVC 0,25MG CPR",
  UCD7: '9332838',
  UCD13: '3400893328385',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE TVC 0,25MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3930389',
  CIP13: '3400939303895',
  ucdLib: "ROPINIROLE TVC 0,50MG CPR",
  UCD7: '9332844',
  UCD13: '3400893328446',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE TVC 0,50MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3930395',
  CIP13: '3400939303956',
  ucdLib: "ROPINIROLE TVC 0,50MG CPR",
  UCD7: '9332844',
  UCD13: '3400893328446',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE TVC 0,50MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '3930484',
  CIP13: '3400939304847',
  ucdLib: "ROPINIROLE TVC 1MG CPR",
  UCD7: '9332850',
  UCD13: '3400893328507',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE TVC 1MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3930550',
  CIP13: '3400939305509',
  ucdLib: "ROPINIROLE TVC 2MG CPR",
  UCD7: '9332867',
  UCD13: '3400893328675',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE TVC 2MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '3930567',
  CIP13: '3400939305677',
  ucdLib: "ROPINIROLE TVC 2MG CPR",
  UCD7: '9332867',
  UCD13: '3400893328675',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE TVC 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2213792',
  CIP13: '3400922137926',
  ucdLib: "ROPINIROLE ZEN LP 2MG CPR",
  UCD7: '9390675',
  UCD13: '3400893906750',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE ZEN LP 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2213846',
  CIP13: '3400922138466',
  ucdLib: "ROPINIROLE ZEN LP 4MG CPR",
  UCD7: '9390681',
  UCD13: '3400893906811',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE ZEN LP 4MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2213912',
  CIP13: '3400922139128',
  ucdLib: "ROPINIROLE ZEN LP 8MG CPR",
  UCD7: '9390698',
  UCD13: '3400893906989',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE ZEN LP 8MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2745856',
  CIP13: '3400927458569',
  ucdLib: "ROPINIROLE BGA LP 2MG CPR",
  UCD7: '9396933',
  UCD13: '3400893969335',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE BGA LP 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2745916',
  CIP13: '3400927459160',
  ucdLib: "ROPINIROLE BGA LP 4MG CPR",
  UCD7: '9396956',
  UCD13: '3400893969564',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE BGA LP 4MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2745968',
  CIP13: '3400927459689',
  ucdLib: "ROPINIROLE BGA LP 8MG CPR",
  UCD7: '9396962',
  UCD13: '3400893969625',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE BGA LP 8MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4177273',
  CIP13: '3400941772733',
  ucdLib: "ROPINIROLE EG 1MG CPR",
  UCD7: '9328127',
  UCD13: '3400893281277',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE EG 1MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '4177149',
  CIP13: '3400941771491',
  ucdLib: "ROPINIROLE EG 2MG CPR",
  UCD7: '9328133',
  UCD13: '3400893281338',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE EG 2MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '2801951',
  CIP13: '3400928019516',
  ucdLib: "ROPINIROLE ARW LP 2MG CPR",
  UCD7: '9411584',
  UCD13: '3400894115847',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE ARW LP 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2802011',
  CIP13: '3400928020116',
  ucdLib: "ROPINIROLE ARW LP 4MG CPR",
  UCD7: '9411590',
  UCD13: '3400894115908',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE ARW LP 4MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2802063',
  CIP13: '3400928020635',
  ucdLib: "ROPINIROLE ARW LP 8MG CPR",
  UCD7: '9411609',
  UCD13: '3400894116097',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE ARW LP 8MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2235782',
  CIP13: '3400922357829',
  ucdLib: "ROPINIROLE EG LP 4MG CPR",
  UCD7: '9390652',
  UCD13: '3400893906521',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE EG LP 4MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '2235859',
  CIP13: '3400922358598',
  ucdLib: "ROPINIROLE EG LP 8MG CPR",
  UCD7: '9390669',
  UCD13: '3400893906699',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE EG LP 8MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4163839',
  CIP13: '3400941638398',
  ucdLib: "ROPINIROLE KRK LP 2MG CPR",
  UCD7: '9379432',
  UCD13: '3400893794326',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE KRK LP 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4163957',
  CIP13: '3400941639579',
  ucdLib: "ROPINIROLE KRK LP 4MG CPR",
  UCD7: '9379449',
  UCD13: '3400893794494',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE KRK LP 4MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4164052',
  CIP13: '3400941640520',
  ucdLib: "ROPINIROLE KRK LP 8MG CPR",
  UCD7: '9379455',
  UCD13: '3400893794555',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE KRK LP 8MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4163779',
  CIP13: '3400941637797',
  ucdLib: "ROPINIROLE SDZ LP 2MG CPR",
  UCD7: '9374618',
  UCD13: '3400893746189',
  ucdQtyMultiplicator: 21,
  cipLib: "ROPINIROLE SDZ LP 2MG CPR BT 21",
  atcCode: "N04BC04"
}, {
  CIP7: '4163785',
  CIP13: '3400941637858',
  ucdLib: "ROPINIROLE SDZ LP 2MG CPR",
  UCD7: '9374618',
  UCD13: '3400893746189',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE SDZ LP 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4163911',
  CIP13: '3400941639111',
  ucdLib: "ROPINIROLE SDZ LP 4MG CPR",
  UCD7: '9374624',
  UCD13: '3400893746240',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE SDZ LP 4MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4164000',
  CIP13: '3400941640001',
  ucdLib: "ROPINIROLE SDZ LP 8MG CPR",
  UCD7: '9374630',
  UCD13: '3400893746301',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE SDZ LP 8MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4166051',
  CIP13: '3400941660511',
  ucdLib: "ROPINIROLE TVC LP 2MG CPR",
  UCD7: '9374452',
  UCD13: '3400893744529',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE TVC LP 2MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4166097',
  CIP13: '3400941660979',
  ucdLib: "ROPINIROLE TVC LP 4MG CPR",
  UCD7: '9374469',
  UCD13: '3400893744697',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE TVC LP 4MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '4166134',
  CIP13: '3400941661341',
  ucdLib: "ROPINIROLE TVC LP 8MG CPR",
  UCD7: '9374475',
  UCD13: '3400893744758',
  ucdQtyMultiplicator: 28,
  cipLib: "ROPINIROLE TVC LP 8MG CPR BT 28",
  atcCode: "N04BC04"
}, {
  CIP7: '3474230',
  CIP13: '3400934742309',
  ucdLib: "PARLODEL 10MG GELU",
  UCD7: '9067804',
  UCD13: '3400890678049',
  ucdQtyMultiplicator: 30,
  cipLib: "PARLODEL 10MG GELU BT 30",
  atcCode: "N04BC01"
}, {
  CIP7: '3474282',
  CIP13: '3400934742828',
  ucdLib: "PARLODEL 5MG GELU",
  UCD7: '9154472',
  UCD13: '3400891544725',
  ucdQtyMultiplicator: 30,
  cipLib: "PARLODEL 5MG GELU BT 30",
  atcCode: "N04BC01"
}, {
  CIP7: '3153371',
  CIP13: '3400931533719',
  ucdLib: "MANTADIX 100MG CAPS",
  UCD7: '9056806',
  UCD13: '3400890568067',
  ucdQtyMultiplicator: 50,
  cipLib: "MANTADIX 100MG CAPS BT 50",
  atcCode: "N04BB01"
}, {
  CIP7: '3003924',
  CIP13: '3400930039243',
  ucdLib: "LEVOD/C/E.ARW 100/25/200 CP",
  UCD7: '9413672',
  UCD13: '3400894136729',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.ARW 100/25/200 CP BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3003936',
  CIP13: '3400930039366',
  ucdLib: "LEVOD/C/E.ARW 150/37,5/200",
  UCD7: '9413695',
  UCD13: '3400894136958',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.ARW 150/37,5/200 BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3003951',
  CIP13: '3400930039519',
  ucdLib: "LEVOD/C/E.ARW 200/50/200 CP",
  UCD7: '9413726',
  UCD13: '3400894137269',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.ARW 200/50/200 CP BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3003910',
  CIP13: '3400930039106',
  ucdLib: "LEVOD/C/E.ARW 50/12,5/200 C",
  UCD7: '9413732',
  UCD13: '3400894137320',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.ARW 50/12,5/200 C BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3003917',
  CIP13: '3400930039175',
  ucdLib: "LEVOD/C/E.ARW 75/18,75/200",
  UCD7: '9413749',
  UCD13: '3400894137498',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.ARW 75/18,75/200 BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3003930',
  CIP13: '3400930039304',
  ucdLib: "LEVOD/C/E.ARW125/31,25/200",
  UCD7: '9413689',
  UCD13: '3400894136897',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.ARW125/31,25/200 BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3003943',
  CIP13: '3400930039434',
  ucdLib: "LEVOD/C/E.ARW175/43,75/200",
  UCD7: '9413703',
  UCD13: '3400894137030',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.ARW175/43,75/200 BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3000330',
  CIP13: '3400930003305',
  ucdLib: "LEVOD/C/E.EG 100/25/200 CPR",
  UCD7: '9412661',
  UCD13: '3400894126614',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.EG 100/25/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3000365',
  CIP13: '3400930003657',
  ucdLib: "LEVOD/C/E.EG 125/31,25/200",
  UCD7: '9412678',
  UCD13: '3400894126782',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.EG 125/31,25/200 BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3000338',
  CIP13: '3400930003381',
  ucdLib: "LEVOD/C/E.EG 150/37,5/200 C",
  UCD7: '9412684',
  UCD13: '3400894126843',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.EG 150/37,5/200 C BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3000345',
  CIP13: '3400930003459',
  ucdLib: "LEVOD/C/E.EG 175/43,75/200",
  UCD7: '9412690',
  UCD13: '3400894126904',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.EG 175/43,75/200 BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3000353',
  CIP13: '3400930003534',
  ucdLib: "LEVOD/C/E.EG 200/50/200 CPR",
  UCD7: '9412709',
  UCD13: '3400894127093',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.EG 200/50/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3000322',
  CIP13: '3400930003220',
  ucdLib: "LEVOD/C/E.EG 50/12,5/200 CP",
  UCD7: '9412715',
  UCD13: '3400894127154',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.EG 50/12,5/200 CP BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3000362',
  CIP13: '3400930003626',
  ucdLib: "LEVOD/C/E.EG 75/18,75/200 C",
  UCD7: '9412721',
  UCD13: '3400894127215',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.EG 75/18,75/200 C BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3853884',
  CIP13: '3400938538847',
  ucdLib: "STALEVO 200/50/200MG CPR",
  UCD7: '9321958',
  UCD13: '3400893219584',
  ucdQtyMultiplicator: 100,
  cipLib: "STALEVO 200/50/200MG CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3634573',
  CIP13: '3400936345737',
  ucdLib: "STALEVO 100/25/200MG CPR",
  UCD7: '9259797',
  UCD13: '3400892597973',
  ucdQtyMultiplicator: 100,
  cipLib: "STALEVO 100/25/200MG CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3634627',
  CIP13: '3400936346277',
  ucdLib: "STALEVO 150/37,5/200MG CPR",
  UCD7: '9259805',
  UCD13: '3400892598055',
  ucdQtyMultiplicator: 100,
  cipLib: "STALEVO 150/37,5/200MG CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3634538',
  CIP13: '3400936345386',
  ucdLib: "STALEVO 50/12,5/200MG CPR",
  UCD7: '9259811',
  UCD13: '3400892598116',
  ucdQtyMultiplicator: 100,
  cipLib: "STALEVO 50/12,5/200MG CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3944256',
  CIP13: '3400939442563',
  ucdLib: "STALEVO 125/31,25/200MG CPR",
  UCD7: '9338338',
  UCD13: '3400893383384',
  ucdQtyMultiplicator: 100,
  cipLib: "STALEVO 125/31,25/200MG CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3944196',
  CIP13: '3400939441962',
  ucdLib: "STALEVO 75/18,75/200MG CPR",
  UCD7: '9338344',
  UCD13: '3400893383445',
  ucdQtyMultiplicator: 100,
  cipLib: "STALEVO 75/18,75/200MG CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2800957',
  CIP13: '3400928009579',
  ucdLib: "LEVOD/C/E.BGA 100/25/200 CP",
  UCD7: '9409340',
  UCD13: '3400894093404',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.BGA 100/25/200 CP BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2801075',
  CIP13: '3400928010759',
  ucdLib: "LEVOD/C/E.BGA 150/37,5/200 CP",
  UCD7: '9409363',
  UCD13: '3400894093633',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.BGA 150/37,5/200 CP BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2801170',
  CIP13: '3400928011701',
  ucdLib: "LEVOD/C/E.BGA 200/50/200 CP",
  UCD7: '9409392',
  UCD13: '3400894093923',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.BGA 200/50/200 CP BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2800851',
  CIP13: '3400928008510',
  ucdLib: "LEVOD/C/E.BGA 50/12,5/200 C",
  UCD7: '9409400',
  UCD13: '3400894094005',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.BGA 50/12,5/200 C BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2800905',
  CIP13: '3400928009050',
  ucdLib: "LEVOD/C/E.BGA 75/18,75/200 C",
  UCD7: '9409417',
  UCD13: '3400894094173',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.BGA 75/18,75/200 C BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2801017',
  CIP13: '3400928010179',
  ucdLib: "LEVOD/C/E.BGA125/31,25/200 C",
  UCD7: '9409357',
  UCD13: '3400894093572',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.BGA125/31,25/200 C BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2801129',
  CIP13: '3400928011299',
  ucdLib: "LEVOD/C/E.BGA175/43,75/200 C",
  UCD7: '9409386',
  UCD13: '3400894093862',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOD/C/E.BGA175/43,75/200 C BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2670420',
  CIP13: '3400926704209',
  ucdLib: "STALEVO 175/43,75/200MG CPR",
  UCD7: '9387348',
  UCD13: '3400893873489',
  ucdQtyMultiplicator: 100,
  cipLib: "STALEVO 175/43,75/200MG CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2770860',
  CIP13: '3400927708602',
  ucdLib: "CORBILTA 100/25/200 CPR",
  UCD7: '9414140',
  UCD13: '3400894141402',
  ucdQtyMultiplicator: 100,
  cipLib: "CORBILTA 100/25/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2770877',
  CIP13: '3400927708770',
  ucdLib: "CORBILTA 125/31,25/200 CPR",
  UCD7: '9414157',
  UCD13: '3400894141570',
  ucdQtyMultiplicator: 100,
  cipLib: "CORBILTA 125/31,25/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2770883',
  CIP13: '3400927708831',
  ucdLib: "CORBILTA 150/37,5/200 CPR",
  UCD7: '9414163',
  UCD13: '3400894141631',
  ucdQtyMultiplicator: 100,
  cipLib: "CORBILTA 150/37,5/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2770908',
  CIP13: '3400927709081',
  ucdLib: "CORBILTA 175/43,75/200 CPR",
  UCD7: '9414186',
  UCD13: '3400894141860',
  ucdQtyMultiplicator: 100,
  cipLib: "CORBILTA 175/43,75/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2770914',
  CIP13: '3400927709142',
  ucdLib: "CORBILTA 200/50/200 CPR",
  UCD7: '9414192',
  UCD13: '3400894141921',
  ucdQtyMultiplicator: 100,
  cipLib: "CORBILTA 200/50/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2770848',
  CIP13: '3400927708480',
  ucdLib: "CORBILTA 50/12,5/200 CPR",
  UCD7: '9414200',
  UCD13: '3400894142003',
  ucdQtyMultiplicator: 100,
  cipLib: "CORBILTA 50/12,5/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '2770854',
  CIP13: '3400927708541',
  ucdLib: "CORBILTA 75/18,75/200 CPR",
  UCD7: '9414217',
  UCD13: '3400894142171',
  ucdQtyMultiplicator: 100,
  cipLib: "CORBILTA 75/18,75/200 CPR BT 100",
  atcCode: "N04BA03"
}, {
  CIP7: '3832899',
  CIP13: '3400938328998',
  ucdLib: "LEVODOPA BEN.TVC 100/25 GELU",
  UCD7: '9311434',
  UCD13: '3400893114346',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVODOPA BEN.TVC 100/25 GELU BT 60",
  atcCode: "N04BA02"
}, {
  CIP7: '3832959',
  CIP13: '3400938329599',
  ucdLib: "LEVODOPA BEN.TVC 200/50 GELU",
  UCD7: '9311440',
  UCD13: '3400893114407',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVODOPA BEN.TVC 200/50 GELU BT 60",
  atcCode: "N04BA02"
}, {
  CIP7: '3832830',
  CIP13: '3400938328301',
  ucdLib: "LEVODOPA BEN.TVC 50/12,5GELU",
  UCD7: '9311457',
  UCD13: '3400893114575',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVODOPA BEN.TVC 50/12,5GELU BT 60",
  atcCode: "N04BA02"
}, {
  CIP7: '3298537',
  CIP13: '3400932985371',
  ucdLib: "MODOPAR LP 125 GELU",
  UCD7: '9134268',
  UCD13: '3400891342680',
  ucdQtyMultiplicator: 60,
  cipLib: "MODOPAR LP 125 GELU BT 60",
  atcCode: "N04BA02"
}, {
  CIP7: '2764486',
  CIP13: '3400927644863',
  ucdLib: "LEVODOPA/CAR.ACC LP200/50 CP",
  UCD7: '9398300',
  UCD13: '3400893983003',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVODOPA/CAR.ACC LP200/50 CP BT 30",
  atcCode: "N04BA02"
}, {
  CIP7: '3331312',
  CIP13: '3400933313128',
  ucdLib: "MODOPAR 125 DISP CPR",
  UCD7: '9151663',
  UCD13: '3400891516630',
  ucdQtyMultiplicator: 60,
  cipLib: "MODOPAR 125 DISP CPR BT 60",
  atcCode: "N04BA02"
}, {
  CIP7: '3240762',
  CIP13: '3400932407620',
  ucdLib: "MODOPAR 62,5 GELU",
  UCD7: '9059420',
  UCD13: '3400890594202',
  ucdQtyMultiplicator: 60,
  cipLib: "MODOPAR 62,5 GELU BT 60",
  atcCode: "N04BA02"
}, {
  CIP7: '3436850',
  CIP13: '3400934368509',
  ucdLib: "LEVODOPA CAR.TVC 100/10 CPR",
  UCD7: '9201266',
  UCD13: '3400892012667',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVODOPA CAR.TVC 100/10 CPR BT 100",
  atcCode: "N04BA02"
}, {
  CIP7: '3436821',
  CIP13: '3400934368219',
  ucdLib: "LEVODOPA CAR.TVC 250/25 CPR",
  UCD7: '9201272',
  UCD13: '3400892012728',
  ucdQtyMultiplicator: 50,
  cipLib: "LEVODOPA CAR.TVC 250/25 CPR BT 50",
  atcCode: "N04BA02"
}, {
  CIP7: '3200805',
  CIP13: '3400932008056',
  ucdLib: "SINEMET 100MG/10MG CPR",
  UCD7: '9084010',
  UCD13: '3400890840101',
  ucdQtyMultiplicator: 100,
  cipLib: "SINEMET 100MG/10MG CPR BT 100",
  atcCode: "N04BA02"
}, {
  CIP7: '3356654',
  CIP13: '3400933566548',
  ucdLib: "SINEMET LP 100MG/25MG CPR",
  UCD7: '9190404',
  UCD13: '3400891904048',
  ucdQtyMultiplicator: 30,
  cipLib: "SINEMET LP 100MG/25MG CPR BT 30",
  atcCode: "N04BA02"
}, {
  CIP7: '3356938',
  CIP13: '3400933569389',
  ucdLib: "SINEMET LP 200MG/50MG CPR",
  UCD7: '9158702',
  UCD13: '3400891587029',
  ucdQtyMultiplicator: 30,
  cipLib: "SINEMET LP 200MG/50MG CPR BT 30",
  atcCode: "N04BA02"
}, {
  CIP7: '3651100',
  CIP13: '3400936511002',
  ucdLib: "DUODOPA GEL INTEST SACH100ML",
  UCD7: '9268000',
  UCD13: '3400892680002',
  ucdQtyMultiplicator: 7,
  cipLib: "DUODOPA GEL INTEST SACH100ML BT 7",
  atcCode: "N04BA02"
}, {
  CIP7: '3170429',
  CIP13: '3400931704294',
  ucdLib: "MODOPAR 125 GELU",
  UCD7: '9059437',
  UCD13: '3400890594370',
  ucdQtyMultiplicator: 60,
  cipLib: "MODOPAR 125 GELU BT 60",
  atcCode: "N04BA02"
}, {
  CIP7: '3170487',
  CIP13: '3400931704874',
  ucdLib: "MODOPAR 250 GELU",
  UCD7: '9059443',
  UCD13: '3400890594431',
  ucdQtyMultiplicator: 60,
  cipLib: "MODOPAR 250 GELU BT 60",
  atcCode: "N04BA02"
}, {
  CIP7: '3172463',
  CIP13: '3400931724636',
  ucdLib: "SINEMET 250MG/25MG CPR",
  UCD7: '9084027',
  UCD13: '3400890840279',
  ucdQtyMultiplicator: 50,
  cipLib: "SINEMET 250MG/25MG CPR BT 50",
  atcCode: "N04BA02"
}, {
  CIP7: '3762093',
  CIP13: '3400937620932',
  ucdLib: "CARBI.LEVOD.TVC LP25/100 CPR",
  UCD7: '9296427',
  UCD13: '3400892964270',
  ucdQtyMultiplicator: 30,
  cipLib: "CARBI.LEVOD.TVC LP25/100 CPR BT 30",
  atcCode: "N04BA02"
}, {
  CIP7: '3762130',
  CIP13: '3400937621304',
  ucdLib: "CARBI.LEVOD.TVC LP50/200 CPR",
  UCD7: '9296433',
  UCD13: '3400892964331',
  ucdQtyMultiplicator: 30,
  cipLib: "CARBI.LEVOD.TVC LP50/200 CPR BT 30",
  atcCode: "N04BA02"
}, {
  CIP7: '3140500',
  CIP13: '3400931405009',
  ucdLib: "LEPTICUR 10MG",
  UCD7: '9053699',
  UCD13: '3400890536998',
  ucdQtyMultiplicator: 30,
  cipLib: "LEPTICUR 10MG BT 30",
  atcCode: "N04AA12"
}, {
  CIP7: '3175616',
  CIP13: '3400931756163',
  ucdLib: "LEPTICUR 10MG INJ AMP2ML",
  UCD7: '9109796',
  UCD13: '3400891097962',
  ucdQtyMultiplicator: 1,
  cipLib: "LEPTICUR 10MG INJ AMP2ML BT 1",
  atcCode: "N04AA12"
}, {
  CIP7: '5748967',
  CIP13: '3400957489670',
  ucdLib: "LEPTICUR 10MG",
  UCD7: '9053699',
  UCD13: '3400890536998',
  ucdQtyMultiplicator: 50,
  cipLib: "LEPTICUR 10MG BT 50",
  atcCode: "N04AA12"
}, {
  CIP7: '3149889',
  CIP13: '3400931498896',
  ucdLib: "AKINETON LP 4MG CPR",
  UCD7: '9001917',
  UCD13: '3400890019170',
  ucdQtyMultiplicator: 30,
  cipLib: "AKINETON LP 4MG CPR BT 30",
  atcCode: "N04AA02"
}, {
  CIP7: '3006687',
  CIP13: '3400930066874',
  ucdLib: "ARTANE 2MG CPR",
  UCD7: '9006719',
  UCD13: '3400890067195',
  ucdQtyMultiplicator: 50,
  cipLib: "ARTANE 2MG CPR BT 50",
  atcCode: "N04AA01"
}, {
  CIP7: '3006693',
  CIP13: '3400930066935',
  ucdLib: "ARTANE 5MG CPR",
  UCD7: '9006725',
  UCD13: '3400890067256',
  ucdQtyMultiplicator: 20,
  cipLib: "ARTANE 5MG CPR BT 20",
  atcCode: "N04AA01"
}, {
  CIP7: '5559516',
  CIP13: '3400955595168',
  ucdLib: "TRIHEXY 2MG RICHARD CPR",
  UCD7: '9159506',
  UCD13: '3400891595062',
  ucdQtyMultiplicator: 1000,
  cipLib: "TRIHEXY 2MG RICHARD CPR BT 1000",
  atcCode: "N04AA01"
}, {
  CIP7: '5559522',
  CIP13: '3400955595229',
  ucdLib: "TRIHEXY 5MG RICHARD CPR",
  UCD7: '9130224',
  UCD13: '3400891302240',
  ucdQtyMultiplicator: 500,
  cipLib: "TRIHEXY 5MG RICHARD CPR BT 500",
  atcCode: "N04AA01"
}, {
  CIP7: '3243074',
  CIP13: '3400932430741',
  ucdLib: "ARTANE 10MG INJ AMP5ML",
  UCD7: '9006688',
  UCD13: '3400890066884',
  ucdQtyMultiplicator: 5,
  cipLib: "ARTANE 10MG INJ AMP5ML BT 5",
  atcCode: "N04AA01"
}, {
  CIP7: '3189593',
  CIP13: '3400931895930',
  ucdLib: "ARTANE 0,4% BUV GTT FL30ML",
  UCD7: '9006694',
  UCD13: '3400890066945',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTANE 0,4% BUV GTT FL30ML BT 1",
  atcCode: "N04AA01"
}, {
  CIP7: '3174717',
  CIP13: '3400931747178',
  ucdLib: "PARKINANE LP 2MG GELU",
  UCD7: '9067744',
  UCD13: '3400890677448',
  ucdQtyMultiplicator: 50,
  cipLib: "PARKINANE LP 2MG GELU BT 50",
  atcCode: "N04AA01"
}, {
  CIP7: '3174723',
  CIP13: '3400931747239',
  ucdLib: "PARKINANE LP 5MG GELU",
  UCD7: '9067750',
  UCD13: '3400890677509',
  ucdQtyMultiplicator: 20,
  cipLib: "PARKINANE LP 5MG GELU BT 20",
  atcCode: "N04AA01"
}, {
  CIP7: '2677698',
  CIP13: '3400926776985',
  ucdLib: "FYCOMPA 10MG CPR",
  UCD7: '9400244',
  UCD13: '3400894002444',
  ucdQtyMultiplicator: 28,
  cipLib: "FYCOMPA 10MG CPR BT 28",
  atcCode: "N03AX22"
}, {
  CIP7: '2677712',
  CIP13: '3400926777128',
  ucdLib: "FYCOMPA 12MG CPR",
  UCD7: '9400250',
  UCD13: '3400894002505',
  ucdQtyMultiplicator: 28,
  cipLib: "FYCOMPA 12MG CPR BT 28",
  atcCode: "N03AX22"
}, {
  CIP7: '2677600',
  CIP13: '3400926776008',
  ucdLib: "FYCOMPA 2MG CPR",
  UCD7: '9400267',
  UCD13: '3400894002673',
  ucdQtyMultiplicator: 7,
  cipLib: "FYCOMPA 2MG CPR BT 7",
  atcCode: "N03AX22"
}, {
  CIP7: '2677623',
  CIP13: '3400926776237',
  ucdLib: "FYCOMPA 4MG CPR",
  UCD7: '9400273',
  UCD13: '3400894002734',
  ucdQtyMultiplicator: 28,
  cipLib: "FYCOMPA 4MG CPR BT 28",
  atcCode: "N03AX22"
}, {
  CIP7: '2677652',
  CIP13: '3400926776527',
  ucdLib: "FYCOMPA 6MG CPR",
  UCD7: '9400296',
  UCD13: '3400894002963',
  ucdQtyMultiplicator: 28,
  cipLib: "FYCOMPA 6MG CPR BT 28",
  atcCode: "N03AX22"
}, {
  CIP7: '2677675',
  CIP13: '3400926776756',
  ucdLib: "FYCOMPA 8MG CPR",
  UCD7: '9400304',
  UCD13: '3400894003045',
  ucdQtyMultiplicator: 28,
  cipLib: "FYCOMPA 8MG CPR BT 28",
  atcCode: "N03AX22"
}, {
  CIP7: '4171655',
  CIP13: '3400941716553',
  ucdLib: "TROBALT 100MG CPR",
  UCD7: '9374481',
  UCD13: '3400893744819',
  ucdQtyMultiplicator: 21,
  cipLib: "TROBALT 100MG CPR BT 21",
  atcCode: "N03AX21"
}, {
  CIP7: '4171661',
  CIP13: '3400941716614',
  ucdLib: "TROBALT 100MG CPR",
  UCD7: '9374481',
  UCD13: '3400893744819',
  ucdQtyMultiplicator: 84,
  cipLib: "TROBALT 100MG CPR BT 84",
  atcCode: "N03AX21"
}, {
  CIP7: '4171678',
  CIP13: '3400941716782',
  ucdLib: "TROBALT 200MG CPR",
  UCD7: '9374498',
  UCD13: '3400893744987',
  ucdQtyMultiplicator: 84,
  cipLib: "TROBALT 200MG CPR BT 84",
  atcCode: "N03AX21"
}, {
  CIP7: '4171684',
  CIP13: '3400941716843',
  ucdLib: "TROBALT 300MG CPR",
  UCD7: '9374506',
  UCD13: '3400893745069',
  ucdQtyMultiplicator: 84,
  cipLib: "TROBALT 300MG CPR BT 84",
  atcCode: "N03AX21"
}, {
  CIP7: '4171690',
  CIP13: '3400941716904',
  ucdLib: "TROBALT 400MG CPR",
  UCD7: '9374512',
  UCD13: '3400893745120',
  ucdQtyMultiplicator: 84,
  cipLib: "TROBALT 400MG CPR BT 84",
  atcCode: "N03AX21"
}, {
  CIP7: '4171632',
  CIP13: '3400941716324',
  ucdLib: "TROBALT 50MG CPR",
  UCD7: '9374529',
  UCD13: '3400893745298',
  ucdQtyMultiplicator: 21,
  cipLib: "TROBALT 50MG CPR BT 21",
  atcCode: "N03AX21"
}, {
  CIP7: '4171649',
  CIP13: '3400941716492',
  ucdLib: "TROBALT 50MG CPR",
  UCD7: '9374529',
  UCD13: '3400893745298',
  ucdQtyMultiplicator: 84,
  cipLib: "TROBALT 50MG CPR BT 84",
  atcCode: "N03AX21"
}, {
  CIP7: '3882992',
  CIP13: '3400938829921',
  ucdLib: "VIMPAT 100MG CPR PELLIC",
  UCD7: '9319364',
  UCD13: '3400893193648',
  ucdQtyMultiplicator: 56,
  cipLib: "VIMPAT 100MG CPR PELLIC BT 56",
  atcCode: "N03AX18"
}, {
  CIP7: '3883098',
  CIP13: '3400938830989',
  ucdLib: "VIMPAT 10MG/ML PERF FL20ML",
  UCD7: '9328386',
  UCD13: '3400893283868',
  ucdQtyMultiplicator: 1,
  cipLib: "VIMPAT 10MG/ML PERF FL20ML BT 1",
  atcCode: "N03AX18"
}, {
  CIP7: '3883017',
  CIP13: '3400938830170',
  ucdLib: "VIMPAT 150MG CPR PELLIC",
  UCD7: '9321591',
  UCD13: '3400893215913',
  ucdQtyMultiplicator: 56,
  cipLib: "VIMPAT 150MG CPR PELLIC BT 56",
  atcCode: "N03AX18"
}, {
  CIP7: '3883046',
  CIP13: '3400938830460',
  ucdLib: "VIMPAT 200MG CPR PELLIC",
  UCD7: '9319370',
  UCD13: '3400893193709',
  ucdQtyMultiplicator: 56,
  cipLib: "VIMPAT 200MG CPR PELLIC BT 56",
  atcCode: "N03AX18"
}, {
  CIP7: '3882957',
  CIP13: '3400938829570',
  ucdLib: "VIMPAT 50MG CPR PELLIC",
  UCD7: '9319387',
  UCD13: '3400893193877',
  ucdQtyMultiplicator: 14,
  cipLib: "VIMPAT 50MG CPR PELLIC BT 14",
  atcCode: "N03AX18"
}, {
  CIP7: '3882963',
  CIP13: '3400938829631',
  ucdLib: "VIMPAT 50MG CPR PELLIC",
  UCD7: '9319387',
  UCD13: '3400893193877',
  ucdQtyMultiplicator: 56,
  cipLib: "VIMPAT 50MG CPR PELLIC BT 56",
  atcCode: "N03AX18"
}, {
  CIP7: '2219814',
  CIP13: '3400922198149',
  ucdLib: "VIMPAT 10MG/ML SIR FL200ML",
  UCD7: '9383439',
  UCD13: '3400893834398',
  ucdQtyMultiplicator: 1,
  cipLib: "VIMPAT 10MG/ML SIR FL200ML BT 1",
  atcCode: "N03AX18"
}, {
  CIP7: '2247348',
  CIP13: '3400922473482',
  ucdLib: "VIMPAT 100MG CPR PELLIC",
  UCD7: '9319364',
  UCD13: '3400893193648',
  ucdQtyMultiplicator: 56,
  cipLib: "VIMPAT 100MG CPR PELLIC BT 56",
  atcCode: "N03AX18"
}, {
  CIP7: '2247354',
  CIP13: '3400922473543',
  ucdLib: "VIMPAT 150MG CPR PELLIC",
  UCD7: '9321591',
  UCD13: '3400893215913',
  ucdQtyMultiplicator: 56,
  cipLib: "VIMPAT 150MG CPR PELLIC BT 56",
  atcCode: "N03AX18"
}, {
  CIP7: '2247360',
  CIP13: '3400922473604',
  ucdLib: "VIMPAT 200MG CPR PELLIC",
  UCD7: '9319370',
  UCD13: '3400893193709',
  ucdQtyMultiplicator: 56,
  cipLib: "VIMPAT 200MG CPR PELLIC BT 56",
  atcCode: "N03AX18"
}, {
  CIP7: '2247331',
  CIP13: '3400922473314',
  ucdLib: "VIMPAT 50MG CPR PELLIC",
  UCD7: '9319387',
  UCD13: '3400893193877',
  ucdQtyMultiplicator: 56,
  cipLib: "VIMPAT 50MG CPR PELLIC BT 56",
  atcCode: "N03AX18"
}, {
  CIP7: '3783221',
  CIP13: '3400937832212',
  ucdLib: "DIACOMIT 250MG GELU",
  UCD7: '9193845',
  UCD13: '3400891938456',
  ucdQtyMultiplicator: 60,
  cipLib: "DIACOMIT 250MG GELU BT 60",
  atcCode: "N03AX17"
}, {
  CIP7: '3783296',
  CIP13: '3400937832960',
  ucdLib: "DIACOMIT 250MG PDR BUV SACH",
  UCD7: '9297243',
  UCD13: '3400892972435',
  ucdQtyMultiplicator: 60,
  cipLib: "DIACOMIT 250MG PDR BUV SACH BT 60",
  atcCode: "N03AX17"
}, {
  CIP7: '3783250',
  CIP13: '3400937832502',
  ucdLib: "DIACOMIT 500MG GELU",
  UCD7: '9193868',
  UCD13: '3400891938685',
  ucdQtyMultiplicator: 60,
  cipLib: "DIACOMIT 500MG GELU BT 60",
  atcCode: "N03AX17"
}, {
  CIP7: '3783327',
  CIP13: '3400937833271',
  ucdLib: "DIACOMIT 500MG PDR BUV SACH",
  UCD7: '9297266',
  UCD13: '3400892972664',
  ucdQtyMultiplicator: 60,
  cipLib: "DIACOMIT 500MG PDR BUV SACH BT 60",
  atcCode: "N03AX17"
}, {
  CIP7: '3004046',
  CIP13: '3400930040461',
  ucdLib: "PREGABALINE ARL 100MG GELU",
  UCD7: '9414737',
  UCD13: '3400894147374',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE ARL 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3004049',
  CIP13: '3400930040492',
  ucdLib: "PREGABALINE ARL 150MG GELU",
  UCD7: '9414743',
  UCD13: '3400894147435',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE ARL 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3004054',
  CIP13: '3400930040546',
  ucdLib: "PREGABALINE ARL 200MG GELU",
  UCD7: '9414766',
  UCD13: '3400894147664',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE ARL 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3004029',
  CIP13: '3400930040294',
  ucdLib: "PREGABALINE ARL 25MG GELU",
  UCD7: '9414772',
  UCD13: '3400894147725',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE ARL 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3004030',
  CIP13: '3400930040300',
  ucdLib: "PREGABALINE ARL 25MG GELU",
  UCD7: '9414772',
  UCD13: '3400894147725',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE ARL 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3004058',
  CIP13: '3400930040584',
  ucdLib: "PREGABALINE ARL 300MG GELU",
  UCD7: '9414789',
  UCD13: '3400894147893',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE ARL 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3004038',
  CIP13: '3400930040386',
  ucdLib: "PREGABALINE ARL 50MG GELU",
  UCD7: '9414795',
  UCD13: '3400894147954',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE ARL 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3004041',
  CIP13: '3400930040416',
  ucdLib: "PREGABALINE ARL 75MG GELU",
  UCD7: '9414803',
  UCD13: '3400894148036',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE ARL 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3003295',
  CIP13: '3400930032954',
  ucdLib: "PREGABALINE BGA 100MG GELU",
  UCD7: '9414588',
  UCD13: '3400894145882',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE BGA 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3003307',
  CIP13: '3400930033074',
  ucdLib: "PREGABALINE BGA 150MG GELU",
  UCD7: '9414594',
  UCD13: '3400894145943',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE BGA 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3003311',
  CIP13: '3400930033111',
  ucdLib: "PREGABALINE BGA 200MG GELU",
  UCD7: '9414602',
  UCD13: '3400894146025',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE BGA 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3003266',
  CIP13: '3400930032664',
  ucdLib: "PREGABALINE BGA 25MG GELU",
  UCD7: '9414619',
  UCD13: '3400894146193',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE BGA 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3003267',
  CIP13: '3400930032671',
  ucdLib: "PREGABALINE BGA 25MG GELU",
  UCD7: '9414619',
  UCD13: '3400894146193',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE BGA 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3003323',
  CIP13: '3400930033234',
  ucdLib: "PREGABALINE BGA 300MG GELU",
  UCD7: '9414625',
  UCD13: '3400894146254',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE BGA 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3003274',
  CIP13: '3400930032749',
  ucdLib: "PREGABALINE BGA 50MG GELU",
  UCD7: '9414631',
  UCD13: '3400894146315',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE BGA 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3003291',
  CIP13: '3400930032916',
  ucdLib: "PREGABALINE BGA 75MG GELU",
  UCD7: '9414648',
  UCD13: '3400894146483',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE BGA 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3006034',
  CIP13: '3400930060346',
  ucdLib: "PREGABALINE CRT 150MG GELU",
  UCD7: '9421045',
  UCD13: '3400894210450',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE CRT 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3005688',
  CIP13: '3400930056882',
  ucdLib: "PREGABALINE CRT 25MG GELU",
  UCD7: '9421051',
  UCD13: '3400894210511',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE CRT 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3005689',
  CIP13: '3400930056899',
  ucdLib: "PREGABALINE CRT 25MG GELU",
  UCD7: '9421051',
  UCD13: '3400894210511',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE CRT 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3006039',
  CIP13: '3400930060391',
  ucdLib: "PREGABALINE CRT 300MG GELU",
  UCD7: '9421068',
  UCD13: '3400894210689',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE CRT 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3006030',
  CIP13: '3400930060308',
  ucdLib: "PREGABALINE CRT 75MG GELU",
  UCD7: '9421074',
  UCD13: '3400894210740',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE CRT 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002899',
  CIP13: '3400930028995',
  ucdLib: "PREGABALINE EG 100MG GELU",
  UCD7: '9415079',
  UCD13: '3400894150794',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE EG 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002901',
  CIP13: '3400930029015',
  ucdLib: "PREGABALINE EG 150MG GELU",
  UCD7: '9415085',
  UCD13: '3400894150855',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE EG 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002903',
  CIP13: '3400930029039',
  ucdLib: "PREGABALINE EG 200MG GELU",
  UCD7: '9415091',
  UCD13: '3400894150916',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE EG 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002890',
  CIP13: '3400930028902',
  ucdLib: "PREGABALINE EG 25MG GELU",
  UCD7: '9415116',
  UCD13: '3400894151166',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE EG 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002891',
  CIP13: '3400930028919',
  ucdLib: "PREGABALINE EG 25MG GELU",
  UCD7: '9415116',
  UCD13: '3400894151166',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE EG 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002907',
  CIP13: '3400930029077',
  ucdLib: "PREGABALINE EG 300MG GELU",
  UCD7: '9415122',
  UCD13: '3400894151227',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE EG 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002894',
  CIP13: '3400930028940',
  ucdLib: "PREGABALINE EG 50MG GELU",
  UCD7: '9415139',
  UCD13: '3400894151395',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE EG 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002897',
  CIP13: '3400930028971',
  ucdLib: "PREGABALINE EG 75MG GELU",
  UCD7: '9415145',
  UCD13: '3400894151456',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE EG 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3004147',
  CIP13: '3400930041475',
  ucdLib: "PREGABALINE HCS 100MG GELU",
  UCD7: '9417486',
  UCD13: '3400894174868',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE HCS 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3004149',
  CIP13: '3400930041499',
  ucdLib: "PREGABALINE HCS 150MG GELU",
  UCD7: '9417492',
  UCD13: '3400894174929',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE HCS 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3004155',
  CIP13: '3400930041550',
  ucdLib: "PREGABALINE HCS 200MG GELU",
  UCD7: '9417500',
  UCD13: '3400894175001',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE HCS 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3004135',
  CIP13: '3400930041352',
  ucdLib: "PREGABALINE HCS 25MG GELU",
  UCD7: '9417517',
  UCD13: '3400894175179',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE HCS 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3004136',
  CIP13: '3400930041369',
  ucdLib: "PREGABALINE HCS 25MG GELU",
  UCD7: '9417517',
  UCD13: '3400894175179',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE HCS 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3004160',
  CIP13: '3400930041604',
  ucdLib: "PREGABALINE HCS 300MG GELU",
  UCD7: '9417523',
  UCD13: '3400894175230',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE HCS 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3004140',
  CIP13: '3400930041406',
  ucdLib: "PREGABALINE HCS 50MG GELU",
  UCD7: '9417546',
  UCD13: '3400894175469',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE HCS 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3004142',
  CIP13: '3400930041420',
  ucdLib: "PREGABALINE HCS 75MG GELU",
  UCD7: '9417552',
  UCD13: '3400894175520',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE HCS 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3001818',
  CIP13: '3400930018187',
  ucdLib: "PREGABALINE MYL 100MG GELU",
  UCD7: '9410076',
  UCD13: '3400894100768',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE MYL 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3001820',
  CIP13: '3400930018200',
  ucdLib: "PREGABALINE MYL 150MG GELU",
  UCD7: '9410082',
  UCD13: '3400894100829',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE MYL 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3001822',
  CIP13: '3400930018224',
  ucdLib: "PREGABALINE MYL 200MG GELU",
  UCD7: '9410099',
  UCD13: '3400894100997',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE MYL 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3001811',
  CIP13: '3400930018118',
  ucdLib: "PREGABALINE MYL 25MG GELU",
  UCD7: '9410107',
  UCD13: '3400894101079',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE MYL 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3001812',
  CIP13: '3400930018125',
  ucdLib: "PREGABALINE MYL 25MG GELU",
  UCD7: '9410107',
  UCD13: '3400894101079',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE MYL 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3001824',
  CIP13: '3400930018248',
  ucdLib: "PREGABALINE MYL 300MG GELU",
  UCD7: '9410113',
  UCD13: '3400894101130',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE MYL 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3001814',
  CIP13: '3400930018149',
  ucdLib: "PREGABALINE MYL 50MG GELU",
  UCD7: '9410136',
  UCD13: '3400894101369',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE MYL 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3001816',
  CIP13: '3400930018163',
  ucdLib: "PREGABALINE MYL 75MG GELU",
  UCD7: '9410142',
  UCD13: '3400894101420',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE MYL 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002785',
  CIP13: '3400930027851',
  ucdLib: "PREGABALINE RBX 100MG GELU",
  UCD7: '9413028',
  UCD13: '3400894130284',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE RBX 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002798',
  CIP13: '3400930027981',
  ucdLib: "PREGABALINE RBX 150MG GELU",
  UCD7: '9413034',
  UCD13: '3400894130345',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE RBX 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002811',
  CIP13: '3400930028117',
  ucdLib: "PREGABALINE RBX 200MG GELU",
  UCD7: '9413040',
  UCD13: '3400894130406',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE RBX 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002735',
  CIP13: '3400930027356',
  ucdLib: "PREGABALINE RBX 25MG GELU",
  UCD7: '9413057',
  UCD13: '3400894130574',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE RBX 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002736',
  CIP13: '3400930027363',
  ucdLib: "PREGABALINE RBX 25MG GELU",
  UCD7: '9413057',
  UCD13: '3400894130574',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE RBX 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002825',
  CIP13: '3400930028254',
  ucdLib: "PREGABALINE RBX 300MG GELU",
  UCD7: '9413063',
  UCD13: '3400894130635',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE RBX 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002754',
  CIP13: '3400930027547',
  ucdLib: "PREGABALINE RBX 50MG GELU",
  UCD7: '9413086',
  UCD13: '3400894130864',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE RBX 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002769',
  CIP13: '3400930027691',
  ucdLib: "PREGABALINE RBX 75MG GELU",
  UCD7: '9413092',
  UCD13: '3400894130925',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE RBX 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3001929',
  CIP13: '3400930019290',
  ucdLib: "PREGABALINE SDG 100MG GELU",
  UCD7: '9410521',
  UCD13: '3400894105213',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE SDG 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3001930',
  CIP13: '3400930019306',
  ucdLib: "PREGABALINE SDG 150MG GELU",
  UCD7: '9410538',
  UCD13: '3400894105381',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE SDG 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3001931',
  CIP13: '3400930019313',
  ucdLib: "PREGABALINE SDG 200MG GELU",
  UCD7: '9410544',
  UCD13: '3400894105442',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE SDG 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3001925',
  CIP13: '3400930019252',
  ucdLib: "PREGABALINE SDG 25MG GELU",
  UCD7: '9410550',
  UCD13: '3400894105503',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE SDG 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3001926',
  CIP13: '3400930019269',
  ucdLib: "PREGABALINE SDG 25MG GELU",
  UCD7: '9410550',
  UCD13: '3400894105503',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE SDG 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3001932',
  CIP13: '3400930019320',
  ucdLib: "PREGABALINE SDG 300MG GELU",
  UCD7: '9410567',
  UCD13: '3400894105671',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE SDG 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3001927',
  CIP13: '3400930019276',
  ucdLib: "PREGABALINE SDG 50MG GELU",
  UCD7: '9410573',
  UCD13: '3400894105732',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE SDG 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3001928',
  CIP13: '3400930019283',
  ucdLib: "PREGABALINE SDG 75MG GELU",
  UCD7: '9410596',
  UCD13: '3400894105961',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE SDG 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002277',
  CIP13: '3400930022771',
  ucdLib: "PREGABALINE TVS 100MG GELU",
  UCD7: '9412543',
  UCD13: '3400894125433',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE TVS 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002281',
  CIP13: '3400930022818',
  ucdLib: "PREGABALINE TVS 150MG GELU",
  UCD7: '9412566',
  UCD13: '3400894125662',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE TVS 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002284',
  CIP13: '3400930022849',
  ucdLib: "PREGABALINE TVS 200MG GELU",
  UCD7: '9412572',
  UCD13: '3400894125723',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE TVS 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002262',
  CIP13: '3400930022627',
  ucdLib: "PREGABALINE TVS 25MG GELU",
  UCD7: '9412589',
  UCD13: '3400894125891',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE TVS 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002263',
  CIP13: '3400930022634',
  ucdLib: "PREGABALINE TVS 25MG GELU",
  UCD7: '9412589',
  UCD13: '3400894125891',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE TVS 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002286',
  CIP13: '3400930022863',
  ucdLib: "PREGABALINE TVS 300MG GELU",
  UCD7: '9412595',
  UCD13: '3400894125952',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE TVS 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002268',
  CIP13: '3400930022689',
  ucdLib: "PREGABALINE TVS 50MG GELU",
  UCD7: '9412603',
  UCD13: '3400894126034',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE TVS 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002273',
  CIP13: '3400930022733',
  ucdLib: "PREGABALINE TVS 75MG GELU",
  UCD7: '9412626',
  UCD13: '3400894126263',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE TVS 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002381',
  CIP13: '3400930023815',
  ucdLib: "PREGABALINE ZEN 100MG GELU",
  UCD7: '9415151',
  UCD13: '3400894151517',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE ZEN 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002383',
  CIP13: '3400930023839',
  ucdLib: "PREGABALINE ZEN 150MG GELU",
  UCD7: '9415168',
  UCD13: '3400894151685',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE ZEN 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002384',
  CIP13: '3400930023846',
  ucdLib: "PREGABALINE ZEN 200MG GELU",
  UCD7: '9415174',
  UCD13: '3400894151746',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE ZEN 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002377',
  CIP13: '3400930023778',
  ucdLib: "PREGABALINE ZEN 25MG GELU",
  UCD7: '9415180',
  UCD13: '3400894151807',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE ZEN 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002378',
  CIP13: '3400930023785',
  ucdLib: "PREGABALINE ZEN 25MG GELU",
  UCD7: '9415180',
  UCD13: '3400894151807',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE ZEN 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002385',
  CIP13: '3400930023853',
  ucdLib: "PREGABALINE ZEN 300MG GELU",
  UCD7: '9415197',
  UCD13: '3400894151975',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE ZEN 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3002379',
  CIP13: '3400930023792',
  ucdLib: "PREGABALINE ZEN 50MG GELU",
  UCD7: '9415205',
  UCD13: '3400894152057',
  ucdQtyMultiplicator: 84,
  cipLib: "PREGABALINE ZEN 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3002380',
  CIP13: '3400930023808',
  ucdLib: "PREGABALINE ZEN 75MG GELU",
  UCD7: '9415211',
  UCD13: '3400894152118',
  ucdQtyMultiplicator: 56,
  cipLib: "PREGABALINE ZEN 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3651301',
  CIP13: '3400936513013',
  ucdLib: "LYRICA 100MG GELU",
  UCD7: '9263965',
  UCD13: '3400892639659',
  ucdQtyMultiplicator: 84,
  cipLib: "LYRICA 100MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3651318',
  CIP13: '3400936513181',
  ucdLib: "LYRICA 150MG GELU",
  UCD7: '9263971',
  UCD13: '3400892639710',
  ucdQtyMultiplicator: 56,
  cipLib: "LYRICA 150MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3651324',
  CIP13: '3400936513242',
  ucdLib: "LYRICA 200MG GELU",
  UCD7: '9263988',
  UCD13: '3400892639888',
  ucdQtyMultiplicator: 84,
  cipLib: "LYRICA 200MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3651270',
  CIP13: '3400936512702',
  ucdLib: "LYRICA 25MG GELU",
  UCD7: '9263994',
  UCD13: '3400892639949',
  ucdQtyMultiplicator: 56,
  cipLib: "LYRICA 25MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3651353',
  CIP13: '3400936513532',
  ucdLib: "LYRICA 25MG GELU",
  UCD7: '9263994',
  UCD13: '3400892639949',
  ucdQtyMultiplicator: 84,
  cipLib: "LYRICA 25MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3651330',
  CIP13: '3400936513303',
  ucdLib: "LYRICA 300MG GELU",
  UCD7: '9264002',
  UCD13: '3400892640020',
  ucdQtyMultiplicator: 56,
  cipLib: "LYRICA 300MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '3651287',
  CIP13: '3400936512870',
  ucdLib: "LYRICA 50MG GELU",
  UCD7: '9264019',
  UCD13: '3400892640198',
  ucdQtyMultiplicator: 84,
  cipLib: "LYRICA 50MG GELU BT 84",
  atcCode: "N03AX16"
}, {
  CIP7: '3651293',
  CIP13: '3400936512931',
  ucdLib: "LYRICA 75MG GELU",
  UCD7: '9264025',
  UCD13: '3400892640259',
  ucdQtyMultiplicator: 56,
  cipLib: "LYRICA 75MG GELU BT 56",
  atcCode: "N03AX16"
}, {
  CIP7: '4170147',
  CIP13: '3400941701474',
  ucdLib: "LYRICA 20MG/ML BUV FL473ML",
  UCD7: '9395201',
  UCD13: '3400893952016',
  ucdQtyMultiplicator: 1,
  cipLib: "LYRICA 20MG/ML BUV FL473ML BT 1",
  atcCode: "N03AX16"
}, {
  CIP7: '5658170',
  CIP13: '3400956581702',
  ucdLib: "LYRICA 100MG GELU",
  UCD7: '9263965',
  UCD13: '3400892639659',
  ucdQtyMultiplicator: 100,
  cipLib: "LYRICA 100MG GELU BT 100",
  atcCode: "N03AX16"
}, {
  CIP7: '5658187',
  CIP13: '3400956581870',
  ucdLib: "LYRICA 150MG GELU",
  UCD7: '9263971',
  UCD13: '3400892639710',
  ucdQtyMultiplicator: 100,
  cipLib: "LYRICA 150MG GELU BT 100",
  atcCode: "N03AX16"
}, {
  CIP7: '5658193',
  CIP13: '3400956581931',
  ucdLib: "LYRICA 200MG GELU",
  UCD7: '9263988',
  UCD13: '3400892639888',
  ucdQtyMultiplicator: 100,
  cipLib: "LYRICA 200MG GELU BT 100",
  atcCode: "N03AX16"
}, {
  CIP7: '5658141',
  CIP13: '3400956581412',
  ucdLib: "LYRICA 25MG GELU",
  UCD7: '9263994',
  UCD13: '3400892639949',
  ucdQtyMultiplicator: 100,
  cipLib: "LYRICA 25MG GELU BT 100",
  atcCode: "N03AX16"
}, {
  CIP7: '5658201',
  CIP13: '3400956582013',
  ucdLib: "LYRICA 300MG GELU",
  UCD7: '9264002',
  UCD13: '3400892640020',
  ucdQtyMultiplicator: 100,
  cipLib: "LYRICA 300MG GELU BT 100",
  atcCode: "N03AX16"
}, {
  CIP7: '5658158',
  CIP13: '3400956581580',
  ucdLib: "LYRICA 50MG GELU",
  UCD7: '9264019',
  UCD13: '3400892640198',
  ucdQtyMultiplicator: 100,
  cipLib: "LYRICA 50MG GELU BT 100",
  atcCode: "N03AX16"
}, {
  CIP7: '5658164',
  CIP13: '3400956581641',
  ucdLib: "LYRICA 75MG GELU",
  UCD7: '9264025',
  UCD13: '3400892640259',
  ucdQtyMultiplicator: 100,
  cipLib: "LYRICA 75MG GELU BT 100",
  atcCode: "N03AX16"
}, {
  CIP7: '3005888',
  CIP13: '3400930058886',
  ucdLib: "ZONISAMIDE MYL 100MG GELU",
  UCD7: '9418273',
  UCD13: '3400894182733',
  ucdQtyMultiplicator: 56,
  cipLib: "ZONISAMIDE MYL 100MG GELU BT 56",
  atcCode: "N03AX15"
}, {
  CIP7: '3005879',
  CIP13: '3400930058794',
  ucdLib: "ZONISAMIDE MYL 25MG GELU",
  UCD7: '9418296',
  UCD13: '3400894182962',
  ucdQtyMultiplicator: 14,
  cipLib: "ZONISAMIDE MYL 25MG GELU BT 14",
  atcCode: "N03AX15"
}, {
  CIP7: '3005882',
  CIP13: '3400930058824',
  ucdLib: "ZONISAMIDE MYL 50MG GELU",
  UCD7: '9418304',
  UCD13: '3400894183044',
  ucdQtyMultiplicator: 14,
  cipLib: "ZONISAMIDE MYL 50MG GELU BT 14",
  atcCode: "N03AX15"
}, {
  CIP7: '3659455',
  CIP13: '3400936594555',
  ucdLib: "ZONEGRAN 100MG GELU",
  UCD7: '9244034',
  UCD13: '3400892440347',
  ucdQtyMultiplicator: 56,
  cipLib: "ZONEGRAN 100MG GELU BT 56",
  atcCode: "N03AX15"
}, {
  CIP7: '3659426',
  CIP13: '3400936594265',
  ucdLib: "ZONEGRAN 25MG GELU",
  UCD7: '9281549',
  UCD13: '3400892815497',
  ucdQtyMultiplicator: 14,
  cipLib: "ZONEGRAN 25MG GELU BT 14",
  atcCode: "N03AX15"
}, {
  CIP7: '3692033',
  CIP13: '3400936920330',
  ucdLib: "ZONEGRAN 50MG GELU",
  UCD7: '9281555',
  UCD13: '3400892815558',
  ucdQtyMultiplicator: 14,
  cipLib: "ZONEGRAN 50MG GELU BT 14",
  atcCode: "N03AX15"
}, {
  CIP7: '3001785',
  CIP13: '3400930017852',
  ucdLib: "LEVETIRACETAM EVO 500MG CPR",
  UCD7: '9413235',
  UCD13: '3400894132356',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM EVO 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '3000422',
  CIP13: '3400930004227',
  ucdLib: "LEVETIRACETAM KRK 1000MG CPR",
  UCD7: '9416475',
  UCD13: '3400894164753',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM KRK 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '3000403',
  CIP13: '3400930004036',
  ucdLib: "LEVETIRACETAM KRK 250MG CPR",
  UCD7: '9416481',
  UCD13: '3400894164814',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM KRK 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '3000410',
  CIP13: '3400930004104',
  ucdLib: "LEVETIRACETAM KRK 500MG CPR",
  UCD7: '9416498',
  UCD13: '3400894164982',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM KRK 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2764687',
  CIP13: '3400927646874',
  ucdLib: "LEVETIRACETAM ACT 1000MG CPR",
  UCD7: '9381179',
  UCD13: '3400893811795',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ACT 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '3560225',
  CIP13: '3400935602251',
  ucdLib: "KEPPRA 1000MG CPR",
  UCD7: '9227521',
  UCD13: '3400892275215',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '3560136',
  CIP13: '3400935601360',
  ucdLib: "KEPPRA 250MG CPR",
  UCD7: '9227538',
  UCD13: '3400892275383',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '3560165',
  CIP13: '3400935601650',
  ucdLib: "KEPPRA 500MG CPR",
  UCD7: '9225976',
  UCD13: '3400892259765',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '3702381',
  CIP13: '3400937023818',
  ucdLib: "KEPPRA 100MG/ML BUV FL300ML",
  UCD7: '9290838',
  UCD13: '3400892908380',
  ucdQtyMultiplicator: 1,
  cipLib: "KEPPRA 100MG/ML BUV FL300ML BT 1",
  atcCode: "N03AX14"
}, {
  CIP7: '4951057',
  CIP13: '3400949510573',
  ucdLib: "KEPPRA 1000MG CPR ADP ITT",
  UCD7: '9401077',
  UCD13: '3400894010777',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 1000MG CPR ADP ITT BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4950483',
  CIP13: '3400949504831',
  ucdLib: "KEPPRA 1000MG CPR ADP MWI",
  UCD7: '9389040',
  UCD13: '3400893890400',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 1000MG CPR ADP MWI BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4951086',
  CIP13: '3400949510863',
  ucdLib: "KEPPRA 1000MG CPR ADP PLA",
  UCD7: '9401628',
  UCD13: '3400894016281',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 1000MG CPR ADP PLA BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4950006',
  CIP13: '3400949500062',
  ucdLib: "KEPPRA 250MG CPR ADP MWI",
  UCD7: '9410780',
  UCD13: '3400894107804',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 250MG CPR ADP MWI BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4951229',
  CIP13: '3400949512294',
  ucdLib: "KEPPRA 250MG CPR ADP PLA",
  UCD7: '9402987',
  UCD13: '3400894029878',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 250MG CPR ADP PLA BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4950891',
  CIP13: '3400949508914',
  ucdLib: "KEPPRA 500MG CPR ADP BBA",
  UCD7: '9398369',
  UCD13: '3400893983690',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 500MG CPR ADP BBA BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4951040',
  CIP13: '3400949510405',
  ucdLib: "KEPPRA 500MG CPR ADP ITT",
  UCD7: '9401083',
  UCD13: '3400894010838',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 500MG CPR ADP ITT BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4950508',
  CIP13: '3400949505081',
  ucdLib: "KEPPRA 500MG CPR ADP MWI",
  UCD7: '9389057',
  UCD13: '3400893890578',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 500MG CPR ADP MWI BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4951063',
  CIP13: '3400949510634',
  ucdLib: "KEPPRA 500MG CPR ADP PLA",
  UCD7: '9401634',
  UCD13: '3400894016342',
  ucdQtyMultiplicator: 60,
  cipLib: "KEPPRA 500MG CPR ADP PLA BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '5500535',
  CIP13: '3400955005353',
  ucdLib: "KEPPRA 1000MG CPR",
  UCD7: '9227521',
  UCD13: '3400892275215',
  ucdQtyMultiplicator: 100,
  cipLib: "KEPPRA 1000MG CPR BT 100",
  atcCode: "N03AX14"
}, {
  CIP7: '5500533',
  CIP13: '3400955005339',
  ucdLib: "KEPPRA 250MG CPR",
  UCD7: '9227538',
  UCD13: '3400892275383',
  ucdQtyMultiplicator: 100,
  cipLib: "KEPPRA 250MG CPR BT 100",
  atcCode: "N03AX14"
}, {
  CIP7: '5500534',
  CIP13: '3400955005346',
  ucdLib: "KEPPRA 500MG CPR",
  UCD7: '9225976',
  UCD13: '3400892259765',
  ucdQtyMultiplicator: 100,
  cipLib: "KEPPRA 500MG CPR BT 100",
  atcCode: "N03AX14"
}, {
  CIP7: '2218921',
  CIP13: '3400922189215',
  ucdLib: "LEVETIRACETAM AGT 100MG/ML FL",
  UCD7: '9383592',
  UCD13: '3400893835920',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVETIRACETAM AGT 100MG/ML FL BT 10",
  atcCode: "N03AX14"
}, {
  CIP7: '3982765',
  CIP13: '3400939827650',
  ucdLib: "KEPPRA 100MG/ML BUV 150ML+S1ML",
  UCD7: '9340045',
  UCD13: '3400893400456',
  ucdQtyMultiplicator: 1,
  cipLib: "KEPPRA 100MG/ML BUV 150ML+S1ML BT 1",
  atcCode: "N03AX14"
}, {
  CIP7: '3982759',
  CIP13: '3400939827599',
  ucdLib: "KEPPRA 100MG/ML BUV 150ML+S3ML",
  UCD7: '9340051',
  UCD13: '3400893400517',
  ucdQtyMultiplicator: 1,
  cipLib: "KEPPRA 100MG/ML BUV 150ML+S3ML BT 1",
  atcCode: "N03AX14"
}, {
  CIP7: '2198986',
  CIP13: '3400921989861',
  ucdLib: "LEVETIRACETAM ACC 1000MG CPR",
  UCD7: '9378214',
  UCD13: '3400893782149',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ACC 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2198822',
  CIP13: '3400921988222',
  ucdLib: "LEVETIRACETAM ACC 250MG CPR",
  UCD7: '9378220',
  UCD13: '3400893782200',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ACC 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2198874',
  CIP13: '3400921988741',
  ucdLib: "LEVETIRACETAM ACC 500MG CPR",
  UCD7: '9378237',
  UCD13: '3400893782378',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ACC 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2666097',
  CIP13: '3400926660970',
  ucdLib: "LEVETIRACETAM ARW 100MG/ML FL",
  UCD7: '9387934',
  UCD13: '3400893879344',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVETIRACETAM ARW 100MG/ML FL BT 10",
  atcCode: "N03AX14"
}, {
  CIP7: '2744957',
  CIP13: '3400927449574',
  ucdLib: "LEVETIRACETAM EG 1000MG CPR",
  UCD7: '9396063',
  UCD13: '3400893960639',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM EG 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2744791',
  CIP13: '3400927447914',
  ucdLib: "LEVETIRACETAM EG 250MG CPR",
  UCD7: '9396086',
  UCD13: '3400893960868',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM EG 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2744839',
  CIP13: '3400927448393',
  ucdLib: "LEVETIRACETAM EG 500MG CPR",
  UCD7: '9396092',
  UCD13: '3400893960929',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM EG 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2192771',
  CIP13: '3400921927719',
  ucdLib: "LEVETIRACETAM SDZ 1000MG CPR",
  UCD7: '9380547',
  UCD13: '3400893805473',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM SDZ 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2196094',
  CIP13: '3400921960945',
  ucdLib: "LEVETIRACETAM SDZ 100MG/ML F",
  UCD7: '9380576',
  UCD13: '3400893805763',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVETIRACETAM SDZ 100MG/ML F BT 10",
  atcCode: "N03AX14"
}, {
  CIP7: '2192564',
  CIP13: '3400921925647',
  ucdLib: "LEVETIRACETAM SDZ 250MG CPR",
  UCD7: '9380524',
  UCD13: '3400893805244',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM SDZ 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2192676',
  CIP13: '3400921926767',
  ucdLib: "LEVETIRACETAM SDZ 500MG CPR",
  UCD7: '9380530',
  UCD13: '3400893805305',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM SDZ 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2193925',
  CIP13: '3400921939255',
  ucdLib: "LEVETIRACETAM SDZ100MG/ML300ML",
  UCD7: '9380553',
  UCD13: '3400893805534',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVETIRACETAM SDZ100MG/ML300ML BT 1",
  atcCode: "N03AX14"
}, {
  CIP7: '2196119',
  CIP13: '3400921961195',
  ucdLib: "LEVETIRACETAM TVC 100MG/ML F",
  UCD7: '9386627',
  UCD13: '3400893866276',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVETIRACETAM TVC 100MG/ML F BT 10",
  atcCode: "N03AX14"
}, {
  CIP7: '2661208',
  CIP13: '3400926612085',
  ucdLib: "LEVETIRACETAM ZTL 1000MG CPR",
  UCD7: '9415582',
  UCD13: '3400894155829',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ZTL 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2661036',
  CIP13: '3400926610364',
  ucdLib: "LEVETIRACETAM ZTL 250MG CPR",
  UCD7: '9415599',
  UCD13: '3400894155997',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ZTL 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2661088',
  CIP13: '3400926610883',
  ucdLib: "LEVETIRACETAM ZTL 500MG CPR",
  UCD7: '9415607',
  UCD13: '3400894156079',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ZTL 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2749943',
  CIP13: '3400927499432',
  ucdLib: "LEVETIRACETAM ZYD 1000MG CPR",
  UCD7: '9400741',
  UCD13: '3400894007418',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ZYD 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2749819',
  CIP13: '3400927498190',
  ucdLib: "LEVETIRACETAM ZYD 250MG CPR",
  UCD7: '9400758',
  UCD13: '3400894007586',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ZYD 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2749854',
  CIP13: '3400927498541',
  ucdLib: "LEVETIRACETAM ZYD 500MG CPR",
  UCD7: '9400764',
  UCD13: '3400894007647',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ZYD 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2684468',
  CIP13: '3400926844684',
  ucdLib: "KEPPRA 100MG/ML INJ FL5ML NU",
  UCD7: '9393969',
  UCD13: '3400893939697',
  ucdQtyMultiplicator: 10,
  cipLib: "KEPPRA 100MG/ML INJ FL5ML NU BT 10",
  atcCode: "N03AX14"
}, {
  CIP7: '2238214',
  CIP13: '3400922382142',
  ucdLib: "LEVETIRACETAM ACC 1000MG CPR",
  UCD7: '9378214',
  UCD13: '3400893782149',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ACC 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2238148',
  CIP13: '3400922381480',
  ucdLib: "LEVETIRACETAM ACC 250MG CPR",
  UCD7: '9378220',
  UCD13: '3400893782200',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ACC 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2238160',
  CIP13: '3400922381602',
  ucdLib: "LEVETIRACETAM ACC 500MG CPR",
  UCD7: '9378237',
  UCD13: '3400893782378',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ACC 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2685255',
  CIP13: '3400926852559',
  ucdLib: "LEVETIRACETAM ACG300ML+SRG10ML",
  UCD7: '9391114',
  UCD13: '3400893911143',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVETIRACETAM ACG300ML+SRG10ML BT 1",
  atcCode: "N03AX14"
}, {
  CIP7: '2685261',
  CIP13: '3400926852610',
  ucdLib: "LEVETIRACETAM ACG300ML+SRG1ML",
  UCD7: '9391120',
  UCD13: '3400893911204',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVETIRACETAM ACG300ML+SRG1ML BT 1",
  atcCode: "N03AX14"
}, {
  CIP7: '2685278',
  CIP13: '3400926852788',
  ucdLib: "LEVETIRACETAM ACG300ML+SRG3ML",
  UCD7: '9391137',
  UCD13: '3400893911372',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVETIRACETAM ACG300ML+SRG3ML BT 1",
  atcCode: "N03AX14"
}, {
  CIP7: '2227512',
  CIP13: '3400922275123',
  ucdLib: "LEVETIRACETAM ALT 500MG CPR",
  UCD7: '9386320',
  UCD13: '3400893863206',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ALT 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2680536',
  CIP13: '3400926805364',
  ucdLib: "LEVETIRACETAM ARL 1000MG CPR",
  UCD7: '9408079',
  UCD13: '3400894080794',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ARL 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2680393',
  CIP13: '3400926803933',
  ucdLib: "LEVETIRACETAM ARL 250MG CPR",
  UCD7: '9408085',
  UCD13: '3400894080855',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ARL 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2680430',
  CIP13: '3400926804305',
  ucdLib: "LEVETIRACETAM ARL 500MG CPR",
  UCD7: '9408091',
  UCD13: '3400894080916',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM ARL 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2680789',
  CIP13: '3400926807894',
  ucdLib: "LEVETIRACETAM ARL 500MG CPR",
  UCD7: '9408091',
  UCD13: '3400894080916',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVETIRACETAM ARL 500MG CPR BT 30",
  atcCode: "N03AX14"
}, {
  CIP7: '4165672',
  CIP13: '3400941656729',
  ucdLib: "LEVETIRACETAM BGA 1000MG CPR",
  UCD7: '9373990',
  UCD13: '3400893739907',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM BGA 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4165695',
  CIP13: '3400941656958',
  ucdLib: "LEVETIRACETAM BGA 250MG CPR",
  UCD7: '9374009',
  UCD13: '3400893740095',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM BGA 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4165637',
  CIP13: '3400941656378',
  ucdLib: "LEVETIRACETAM BGA 500MG CPR",
  UCD7: '9374015',
  UCD13: '3400893740156',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM BGA 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2780545',
  CIP13: '3400927805455',
  ucdLib: "LEVETIRACETAM CRT 1000MG CPR",
  UCD7: '9401924',
  UCD13: '3400894019244',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM CRT 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2780249',
  CIP13: '3400927802492',
  ucdLib: "LEVETIRACETAM CRT 250MG CPR",
  UCD7: '9401930',
  UCD13: '3400894019305',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM CRT 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2780321',
  CIP13: '3400927803215',
  ucdLib: "LEVETIRACETAM CRT 500MG CPR",
  UCD7: '9401947',
  UCD13: '3400894019473',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM CRT 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2781881',
  CIP13: '3400927818813',
  ucdLib: "LEVETIRACETAM HPI 100MG/ML F",
  UCD7: '9399765',
  UCD13: '3400893997659',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVETIRACETAM HPI 100MG/ML F BT 10",
  atcCode: "N03AX14"
}, {
  CIP7: '2173029',
  CIP13: '3400921730296',
  ucdLib: "LEVETIRACETAM MYL 100MG/ML A.",
  UCD7: '9376971',
  UCD13: '3400893769713',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVETIRACETAM MYL 100MG/ML A. BT 10",
  atcCode: "N03AX14"
}, {
  CIP7: '4162722',
  CIP13: '3400941627224',
  ucdLib: "LEVETIRACETAM MYP 1000MG CPR",
  UCD7: '9372631',
  UCD13: '3400893726310',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM MYP 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4162610',
  CIP13: '3400941626104',
  ucdLib: "LEVETIRACETAM MYP 250MG CPR",
  UCD7: '9372648',
  UCD13: '3400893726488',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM MYP 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '4162691',
  CIP13: '3400941626913',
  ucdLib: "LEVETIRACETAM MYP 500MG CPR",
  UCD7: '9372654',
  UCD13: '3400893726549',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM MYP 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2685189',
  CIP13: '3400926851897',
  ucdLib: "LEVETIRACETAM MYP100MG/ML300ML",
  UCD7: '9405661',
  UCD13: '3400894056614',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVETIRACETAM MYP100MG/ML300ML BT 1",
  atcCode: "N03AX14"
}, {
  CIP7: '2232660',
  CIP13: '3400922326603',
  ucdLib: "LEVETIRACETAM RBX 1000MG CPR",
  UCD7: '9387762',
  UCD13: '3400893877623',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM RBX 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2232542',
  CIP13: '3400922325422',
  ucdLib: "LEVETIRACETAM RBX 250MG CPR",
  UCD7: '9387779',
  UCD13: '3400893877791',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM RBX 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2232594',
  CIP13: '3400922325941',
  ucdLib: "LEVETIRACETAM RBX 500MG CPR",
  UCD7: '9387785',
  UCD13: '3400893877852',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM RBX 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2209365',
  CIP13: '3400922093659',
  ucdLib: "LEVETIRACETAM SUN 100MG/ML A",
  UCD7: '9380346',
  UCD13: '3400893803462',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVETIRACETAM SUN 100MG/ML A BT 10",
  atcCode: "N03AX14"
}, {
  CIP7: '2162617',
  CIP13: '3400921626179',
  ucdLib: "LEVETIRACETAM TVC 1000MG CPR",
  UCD7: '9377893',
  UCD13: '3400893778937',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM TVC 1000MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2162592',
  CIP13: '3400921625929',
  ucdLib: "LEVETIRACETAM TVC 250MG CPR",
  UCD7: '9377901',
  UCD13: '3400893779019',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM TVC 250MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2162600',
  CIP13: '3400921626001',
  ucdLib: "LEVETIRACETAM TVC 500MG CPR",
  UCD7: '9377918',
  UCD13: '3400893779187',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVETIRACETAM TVC 500MG CPR BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2799898',
  CIP13: '3400927998980',
  ucdLib: "LEVIDCEN 1000MG GLE SACH",
  UCD7: '9406778',
  UCD13: '3400894067788',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVIDCEN 1000MG GLE SACH BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2799697',
  CIP13: '3400927996979',
  ucdLib: "LEVIDCEN 250MG GLE SACH",
  UCD7: '9406784',
  UCD13: '3400894067849',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVIDCEN 250MG GLE SACH BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2799757',
  CIP13: '3400927997570',
  ucdLib: "LEVIDCEN 500MG GLE SACH",
  UCD7: '9406790',
  UCD13: '3400894067900',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVIDCEN 500MG GLE SACH BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '2799823',
  CIP13: '3400927998232',
  ucdLib: "LEVIDCEN 750MG GLE SACH",
  UCD7: '9406809',
  UCD13: '3400894068099',
  ucdQtyMultiplicator: 60,
  cipLib: "LEVIDCEN 750MG GLE SACH BT 60",
  atcCode: "N03AX14"
}, {
  CIP7: '3688942',
  CIP13: '3400936889422',
  ucdLib: "GABAPENTINE EVO 400MG GELU",
  UCD7: '9276471',
  UCD13: '3400892764719',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE EVO 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3686305',
  CIP13: '3400936863057',
  ucdLib: "GABAPENTINE ZYD 400MG GELU",
  UCD7: '9276488',
  UCD13: '3400892764887',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ZYD 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3378986',
  CIP13: '3400933789862',
  ucdLib: "NEURONTIN 100MG GELU",
  UCD7: '9170755',
  UCD13: '3400891707557',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3379017',
  CIP13: '3400933790172',
  ucdLib: "NEURONTIN 300MG GELU",
  UCD7: '9170761',
  UCD13: '3400891707618',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3590025',
  CIP13: '3400935900258',
  ucdLib: "NEURONTIN 600MG CPR",
  UCD7: '9217712',
  UCD13: '3400892177120',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3590048',
  CIP13: '3400935900487',
  ucdLib: "NEURONTIN 800MG CPR",
  UCD7: '9217729',
  UCD13: '3400892177298',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3744304',
  CIP13: '3400937443043',
  ucdLib: "GABAPENTINE BGA 100MG GELU",
  UCD7: '9287262',
  UCD13: '3400892872629',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE BGA 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3744244',
  CIP13: '3400937442442',
  ucdLib: "GABAPENTINE BGA 300MG GELU",
  UCD7: '9287279',
  UCD13: '3400892872797',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE BGA 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3668046',
  CIP13: '3400936680463',
  ucdLib: "GABAPENTINE BGA 400MG GELU",
  UCD7: '9273521',
  UCD13: '3400892735214',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE BGA 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3744497',
  CIP13: '3400937444972',
  ucdLib: "GABAPENTINE CRT 400MG GELU",
  UCD7: '9288965',
  UCD13: '3400892889658',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE CRT 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3816179',
  CIP13: '3400938161793',
  ucdLib: "GABAPENTINE EGL 400MG GELU",
  UCD7: '9305899',
  UCD13: '3400893058992',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE EGL 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3744669',
  CIP13: '3400937446693',
  ucdLib: "GABAPENTINE EVO 100MG GELU",
  UCD7: '9288959',
  UCD13: '3400892889597',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE EVO 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3744190',
  CIP13: '3400937441902',
  ucdLib: "GABAPENTINE EVO 300MG GELU",
  UCD7: '9288244',
  UCD13: '3400892882444',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE EVO 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3668129',
  CIP13: '3400936681293',
  ucdLib: "GABAPENTINE MYL 400MG GELU",
  UCD7: '9275402',
  UCD13: '3400892754024',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE MYL 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3667868',
  CIP13: '3400936678682',
  ucdLib: "GABAPENTINE RPG 300MG GELU",
  UCD7: '9273544',
  UCD13: '3400892735443',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE RPG 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3741145',
  CIP13: '3400937411455',
  ucdLib: "GABAPENTINE SDZ 100MG GELU",
  UCD7: '9286073',
  UCD13: '3400892860732',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE SDZ 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3741139',
  CIP13: '3400937411394',
  ucdLib: "GABAPENTINE SDZ 300MG GELU",
  UCD7: '9286096',
  UCD13: '3400892860961',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE SDZ 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3766642',
  CIP13: '3400937666428',
  ucdLib: "GABAPENTINE SDZ 400MG GELU",
  UCD7: '9290985',
  UCD13: '3400892909851',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE SDZ 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3667785',
  CIP13: '3400936677852',
  ucdLib: "GABAPENTINE TVC 100MG GELU",
  UCD7: '9272711',
  UCD13: '3400892727110',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE TVC 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3667851',
  CIP13: '3400936678514',
  ucdLib: "GABAPENTINE TVC 300MG GELU",
  UCD7: '9272728',
  UCD13: '3400892727288',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE TVC 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3667874',
  CIP13: '3400936678743',
  ucdLib: "GABAPENTINE TVC 400MG GELU",
  UCD7: '9272734',
  UCD13: '3400892727349',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE TVC 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3661357',
  CIP13: '3400936613577',
  ucdLib: "GABAPENTINE TVC 600MG CPR",
  UCD7: '9272740',
  UCD13: '3400892727400',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE TVC 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3767475',
  CIP13: '3400937674751',
  ucdLib: "GABAPENTINE TVC 800MG CPR",
  UCD7: '9294003',
  UCD13: '3400892940038',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE TVC 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3744379',
  CIP13: '3400937443791',
  ucdLib: "GABAPENTINE ZEN 100MG GELU",
  UCD7: '9288988',
  UCD13: '3400892889887',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ZEN 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3744445',
  CIP13: '3400937444453',
  ucdLib: "GABAPENTINE ZEN 300MG GELU",
  UCD7: '9288994',
  UCD13: '3400892889948',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ZEN 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3694210',
  CIP13: '3400936942103',
  ucdLib: "GABAPENTINE ZEN 400MG GELU",
  UCD7: '9277909',
  UCD13: '3400892779096',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ZEN 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3380144',
  CIP13: '3400933801441',
  ucdLib: "NEURONTIN 400MG GELU",
  UCD7: '9170778',
  UCD13: '3400891707786',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3797074',
  CIP13: '3400937970747',
  ucdLib: "GABAPENTINE ARW 600MG CPR",
  UCD7: '9302872',
  UCD13: '3400893028728',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ARW 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3797051',
  CIP13: '3400937970518',
  ucdLib: "GABAPENTINE ARW 800MG CPR",
  UCD7: '9302889',
  UCD13: '3400893028896',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ARW 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3778823',
  CIP13: '3400937788236',
  ucdLib: "GABAPENTINE BGA 600MG CPR",
  UCD7: '9297875',
  UCD13: '3400892978758',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE BGA 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3778898',
  CIP13: '3400937788984',
  ucdLib: "GABAPENTINE BGA 800MG CPR",
  UCD7: '9297881',
  UCD13: '3400892978819',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE BGA 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3778987',
  CIP13: '3400937789875',
  ucdLib: "GABAPENTINE MYL 100MG GELU",
  UCD7: '9297898',
  UCD13: '3400892978987',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE MYL 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3779113',
  CIP13: '3400937791137',
  ucdLib: "GABAPENTINE MYL 300MG GELU",
  UCD7: '9297906',
  UCD13: '3400892979069',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE MYL 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3773406',
  CIP13: '3400937734066',
  ucdLib: "GABAPENTINE MYL 600MG CPR",
  UCD7: '9296611',
  UCD13: '3400892966113',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE MYL 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3772950',
  CIP13: '3400937729505',
  ucdLib: "GABAPENTINE MYL 800MG CPR",
  UCD7: '9296628',
  UCD13: '3400892966281',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE MYL 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3826491',
  CIP13: '3400938264913',
  ucdLib: "GABAPENTINE RBX 400MG GELU",
  UCD7: '9310423',
  UCD13: '3400893104231',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE RBX 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3779248',
  CIP13: '3400937792486',
  ucdLib: "GABAPENTINE ZEN 600MG CPR",
  UCD7: '9298722',
  UCD13: '3400892987224',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ZEN 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3779320',
  CIP13: '3400937793209',
  ucdLib: "GABAPENTINE ZEN 800MG CPR",
  UCD7: '9298739',
  UCD13: '3400892987392',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ZEN 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3800215',
  CIP13: '3400938002157',
  ucdLib: "GABAPENTINE EGL 100MG GELU",
  UCD7: '9305876',
  UCD13: '3400893058763',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE EGL 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3800681',
  CIP13: '3400938006810',
  ucdLib: "GABAPENTINE EGL 300MG GELU",
  UCD7: '9305882',
  UCD13: '3400893058824',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE EGL 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3920379',
  CIP13: '3400939203799',
  ucdLib: "GABAPENTINE EGL 600MG CPR",
  UCD7: '9334240',
  UCD13: '3400893342404',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE EGL 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3920474',
  CIP13: '3400939204741',
  ucdLib: "GABAPENTINE EGL 800MG CPR",
  UCD7: '9334257',
  UCD13: '3400893342572',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE EGL 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '4992174',
  CIP13: '3400949921744',
  ucdLib: "GABAPENTINE ARG 100MG GELU",
  UCD7: '9375836',
  UCD13: '3400893758366',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ARG 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '4992257',
  CIP13: '3400949922574',
  ucdLib: "GABAPENTINE ARG 300MG GELU",
  UCD7: '9375842',
  UCD13: '3400893758427',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ARG 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '4992458',
  CIP13: '3400949924585',
  ucdLib: "GABAPENTINE ARG 400MG GELU",
  UCD7: '9375859',
  UCD13: '3400893758595',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE ARG 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '2748197',
  CIP13: '3400927481970',
  ucdLib: "GABAPENTINE PFZ 100MG GELU",
  UCD7: '9400913',
  UCD13: '3400894009139',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE PFZ 100MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '2748205',
  CIP13: '3400927482052',
  ucdLib: "GABAPENTINE PFZ 300MG GELU",
  UCD7: '9400936',
  UCD13: '3400894009368',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE PFZ 300MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '2748211',
  CIP13: '3400927482113',
  ucdLib: "GABAPENTINE PFZ 400MG GELU",
  UCD7: '9400942',
  UCD13: '3400894009429',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE PFZ 400MG GELU BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '2748234',
  CIP13: '3400927482342',
  ucdLib: "GABAPENTINE PFZ 600MG CPR",
  UCD7: '9400959',
  UCD13: '3400894009597',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE PFZ 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '2748257',
  CIP13: '3400927482571',
  ucdLib: "GABAPENTINE PFZ 800MG CPR",
  UCD7: '9400965',
  UCD13: '3400894009658',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE PFZ 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '3984913',
  CIP13: '3400939849133',
  ucdLib: "GABAPENTINE RBX 600MG CPR",
  UCD7: '9346651',
  UCD13: '3400893466513',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE RBX 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '4901409',
  CIP13: '3400949014095',
  ucdLib: "NEURONTIN 300MG GEL.AIPBBAES",
  UCD7: '9394472',
  UCD13: '3400893944721',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 300MG GEL.AIPBBAES BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '4901390',
  CIP13: '3400949013906',
  ucdLib: "NEURONTIN 400MG GEL.AIPBBAES",
  UCD7: '9394489',
  UCD13: '3400893944899',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 400MG GEL.AIPBBAES BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '4900037',
  CIP13: '3400949000371',
  ucdLib: "NEURONTIN 600MG CPR AIPBBAES",
  UCD7: '9411845',
  UCD13: '3400894118459',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 600MG CPR AIPBBAES BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '4900038',
  CIP13: '3400949000388',
  ucdLib: "NEURONTIN 800MG CPR AIPBBAES",
  UCD7: '9411851',
  UCD13: '3400894118510',
  ucdQtyMultiplicator: 90,
  cipLib: "NEURONTIN 800MG CPR AIPBBAES BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '2203210',
  CIP13: '3400922032108',
  ucdLib: "GABAPENTINE SDZ 600MG CPR",
  UCD7: '9373151',
  UCD13: '3400893731512',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE SDZ 600MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '2203233',
  CIP13: '3400922032337',
  ucdLib: "GABAPENTINE SDZ 800MG CPR",
  UCD7: '9373168',
  UCD13: '3400893731680',
  ucdQtyMultiplicator: 90,
  cipLib: "GABAPENTINE SDZ 800MG CPR BT 90",
  atcCode: "N03AX12"
}, {
  CIP7: '5665193',
  CIP13: '3400956651931',
  ucdLib: "GABAPENTINE ARW 400MG GELU",
  UCD7: '9273834',
  UCD13: '3400892738345',
  ucdQtyMultiplicator: 100,
  cipLib: "GABAPENTINE ARW 400MG GELU BT 100",
  atcCode: "N03AX12"
}, {
  CIP7: '3563442',
  CIP13: '3400935634429',
  ucdLib: "EPITOMAX 100MG CPR",
  UCD7: '9198417',
  UCD13: '3400891984170',
  ucdQtyMultiplicator: 28,
  cipLib: "EPITOMAX 100MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3563465',
  CIP13: '3400935634658',
  ucdLib: "EPITOMAX 200MG CPR",
  UCD7: '9198423',
  UCD13: '3400891984231',
  ucdQtyMultiplicator: 28,
  cipLib: "EPITOMAX 200MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3563413',
  CIP13: '3400935634139',
  ucdLib: "EPITOMAX 50MG CPR",
  UCD7: '9198452',
  UCD13: '3400891984521',
  ucdQtyMultiplicator: 28,
  cipLib: "EPITOMAX 50MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3483051',
  CIP13: '3400934830518',
  ucdLib: "EPITOMAX 15MG GELU",
  UCD7: '9212235',
  UCD13: '3400892122359',
  ucdQtyMultiplicator: 28,
  cipLib: "EPITOMAX 15MG GELU BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3483068',
  CIP13: '3400934830686',
  ucdLib: "EPITOMAX 25MG GELU",
  UCD7: '9212241',
  UCD13: '3400892122410',
  ucdQtyMultiplicator: 28,
  cipLib: "EPITOMAX 25MG GELU BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3483074',
  CIP13: '3400934830747',
  ucdLib: "EPITOMAX 50MG GELU",
  UCD7: '9212258',
  UCD13: '3400892122588',
  ucdQtyMultiplicator: 28,
  cipLib: "EPITOMAX 50MG GELU BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3827088',
  CIP13: '3400938270884',
  ucdLib: "TOPIRAMATE MYL 100MG CPR",
  UCD7: '9311121',
  UCD13: '3400893111215',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE MYL 100MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3827125',
  CIP13: '3400938271256',
  ucdLib: "TOPIRAMATE MYL 200MG CPR",
  UCD7: '9311138',
  UCD13: '3400893111383',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE MYL 200MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3827042',
  CIP13: '3400938270426',
  ucdLib: "TOPIRAMATE MYL 50MG CPR",
  UCD7: '9311144',
  UCD13: '3400893111444',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE MYL 50MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3805632',
  CIP13: '3400938056327',
  ucdLib: "TOPIRAMATE BGA 100MG CPR",
  UCD7: '9306404',
  UCD13: '3400893064047',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE BGA 100MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3805738',
  CIP13: '3400938057386',
  ucdLib: "TOPIRAMATE BGA 200MG CPR",
  UCD7: '9306410',
  UCD13: '3400893064108',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE BGA 200MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3805218',
  CIP13: '3400938052183',
  ucdLib: "TOPIRAMATE BGA 50MG CPR",
  UCD7: '9306427',
  UCD13: '3400893064276',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE BGA 50MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3805939',
  CIP13: '3400938059397',
  ucdLib: "TOPIRAMATE EG 100MG CPR",
  UCD7: '9315366',
  UCD13: '3400893153666',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE EG 100MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3806034',
  CIP13: '3400938060348',
  ucdLib: "TOPIRAMATE EG 200MG CPR",
  UCD7: '9315372',
  UCD13: '3400893153727',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE EG 200MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3805810',
  CIP13: '3400938058109',
  ucdLib: "TOPIRAMATE EG 50MG CPR",
  UCD7: '9315389',
  UCD13: '3400893153895',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE EG 50MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3897870',
  CIP13: '3400938978704',
  ucdLib: "TOPIRAMATE ARG 100MG CPR",
  UCD7: '9328162',
  UCD13: '3400893281628',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ARG 100MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3897930',
  CIP13: '3400938979305',
  ucdLib: "TOPIRAMATE ARG 100MG CPR",
  UCD7: '9328162',
  UCD13: '3400893281628',
  ucdQtyMultiplicator: 30,
  cipLib: "TOPIRAMATE ARG 100MG CPR BT 30",
  atcCode: "N03AX11"
}, {
  CIP7: '3898148',
  CIP13: '3400938981483',
  ucdLib: "TOPIRAMATE ARG 200MG CPR",
  UCD7: '9328179',
  UCD13: '3400893281796',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ARG 200MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3900069',
  CIP13: '3400939000695',
  ucdLib: "TOPIRAMATE ARG 50MG CPR",
  UCD7: '9328185',
  UCD13: '3400893281857',
  ucdQtyMultiplicator: 30,
  cipLib: "TOPIRAMATE ARG 50MG CPR BT 30",
  atcCode: "N03AX11"
}, {
  CIP7: '3901695',
  CIP13: '3400939016955',
  ucdLib: "TOPIRAMATE SDZ 100MG CPR",
  UCD7: '9328239',
  UCD13: '3400893282397',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE SDZ 100MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3901821',
  CIP13: '3400939018218',
  ucdLib: "TOPIRAMATE SDZ 200MG CPR",
  UCD7: '9328245',
  UCD13: '3400893282458',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE SDZ 200MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3913847',
  CIP13: '3400939138473',
  ucdLib: "TOPIRAMATE ZYD 100MG CPR",
  UCD7: '9333358',
  UCD13: '3400893333587',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ZYD 100MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3913913',
  CIP13: '3400939139135',
  ucdLib: "TOPIRAMATE ZYD 200MG CPR",
  UCD7: '9333364',
  UCD13: '3400893333648',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ZYD 200MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3917130',
  CIP13: '3400939171302',
  ucdLib: "TOPIRAMATE ZYD 25MG GELU",
  UCD7: '9333370',
  UCD13: '3400893333709',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ZYD 25MG GELU BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3913801',
  CIP13: '3400939138015',
  ucdLib: "TOPIRAMATE ZYD 50MG CPR",
  UCD7: '9333387',
  UCD13: '3400893333877',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ZYD 50MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '2745566',
  CIP13: '3400927455667',
  ucdLib: "TOPIRAMATE ACC 100MG CPR",
  UCD7: '9395537',
  UCD13: '3400893955376',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ACC 100MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '2745508',
  CIP13: '3400927455087',
  ucdLib: "TOPIRAMATE ACC 200MG CPR",
  UCD7: '9395543',
  UCD13: '3400893955437',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ACC 200MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '2745715',
  CIP13: '3400927457159',
  ucdLib: "TOPIRAMATE ACC 25MG CPR",
  UCD7: '9395566',
  UCD13: '3400893955666',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ACC 25MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '2745649',
  CIP13: '3400927456497',
  ucdLib: "TOPIRAMATE ACC 50MG CPR",
  UCD7: '9395572',
  UCD13: '3400893955727',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ACC 50MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3986390',
  CIP13: '3400939863900',
  ucdLib: "TOPIRAMATE ARW 25MG GELU",
  UCD7: '9344066',
  UCD13: '3400893440667',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE ARW 25MG GELU BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '3943469',
  CIP13: '3400939434698',
  ucdLib: "TOPIRAMATE SDZ 50MG CPR",
  UCD7: '9328251',
  UCD13: '3400893282519',
  ucdQtyMultiplicator: 28,
  cipLib: "TOPIRAMATE SDZ 50MG CPR BT 28",
  atcCode: "N03AX11"
}, {
  CIP7: '5592459',
  CIP13: '3400955924593',
  ucdLib: "TALOXA 600MG CPR",
  UCD7: '9180096',
  UCD13: '3400891800968',
  ucdQtyMultiplicator: 60,
  cipLib: "TALOXA 600MG CPR BT 60",
  atcCode: "N03AX10"
}, {
  CIP7: '5591589',
  CIP13: '3400955915898',
  ucdLib: "TALOXA 600MG/5ML BUV FV230ML",
  UCD7: '9180104',
  UCD13: '3400891801040',
  ucdQtyMultiplicator: 1,
  cipLib: "TALOXA 600MG/5ML BUV FV230ML BT 1",
  atcCode: "N03AX10"
}, {
  CIP7: '3414736',
  CIP13: '3400934147364',
  ucdLib: "LAMICTAL 200MG CPR DISP",
  UCD7: '9214412',
  UCD13: '3400892144122',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMICTAL 200MG CPR DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3414713',
  CIP13: '3400934147135',
  ucdLib: "LAMICTAL 50MG CPR DISP",
  UCD7: '9214429',
  UCD13: '3400892144290',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMICTAL 50MG CPR DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3545817',
  CIP13: '3400935458179',
  ucdLib: "LAMICTAL 2MG CPR DISP",
  UCD7: '9224043',
  UCD13: '3400892240435',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMICTAL 2MG CPR DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3389866',
  CIP13: '3400933898663',
  ucdLib: "LAMICTAL 100MG CPR DISP",
  UCD7: '9178432',
  UCD13: '3400891784329',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMICTAL 100MG CPR DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3389843',
  CIP13: '3400933898434',
  ucdLib: "LAMICTAL 25MG CPR DISP",
  UCD7: '9178449',
  UCD13: '3400891784497',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMICTAL 25MG CPR DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3762779',
  CIP13: '3400937627795',
  ucdLib: "LAMOTRIGINE BGA 100MG C.DISP",
  UCD7: '9292719',
  UCD13: '3400892927190',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE BGA 100MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3762822',
  CIP13: '3400937628228',
  ucdLib: "LAMOTRIGINE BGA 200MG C.DISP",
  UCD7: '9292725',
  UCD13: '3400892927251',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE BGA 200MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3762621',
  CIP13: '3400937626217',
  ucdLib: "LAMOTRIGINE BGA 25MG C.DISP",
  UCD7: '9292731',
  UCD13: '3400892927312',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE BGA 25MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3762727',
  CIP13: '3400937627276',
  ucdLib: "LAMOTRIGINE BGA 50MG C.DISP",
  UCD7: '9292748',
  UCD13: '3400892927480',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE BGA 50MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3696781',
  CIP13: '3400936967816',
  ucdLib: "LAMOTRIGINE SDZ 100MG C.DISP",
  UCD7: '9278145',
  UCD13: '3400892781457',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE SDZ 100MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3696841',
  CIP13: '3400936968417',
  ucdLib: "LAMOTRIGINE SDZ 200MG C.DISP",
  UCD7: '9278151',
  UCD13: '3400892781518',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE SDZ 200MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3696717',
  CIP13: '3400936967175',
  ucdLib: "LAMOTRIGINE SDZ 25MG C.DISP",
  UCD7: '9278168',
  UCD13: '3400892781686',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE SDZ 25MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3727889',
  CIP13: '3400937278898',
  ucdLib: "LAMOTRIGINE SDZ 50MG C.DISP",
  UCD7: '9285085',
  UCD13: '3400892850856',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE SDZ 50MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3787029',
  CIP13: '3400937870290',
  ucdLib: "LAMOTRIGINE EG 100MG C.DISP",
  UCD7: '9303535',
  UCD13: '3400893035351',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE EG 100MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3786797',
  CIP13: '3400937867979',
  ucdLib: "LAMOTRIGINE EG 200MG C.DISP",
  UCD7: '9303541',
  UCD13: '3400893035412',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE EG 200MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3787176',
  CIP13: '3400937871761',
  ucdLib: "LAMOTRIGINE EG 25MG C.DISP",
  UCD7: '9303558',
  UCD13: '3400893035580',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE EG 25MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3448356',
  CIP13: '3400934483561',
  ucdLib: "LAMICTAL 5MG CPR DISP",
  UCD7: '9203992',
  UCD13: '3400892039923',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMICTAL 5MG CPR DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3808493',
  CIP13: '3400938084931',
  ucdLib: "LAMOTRIGINE MYL 100MG C.DISP",
  UCD7: '9304569',
  UCD13: '3400893045695',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE MYL 100MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3808607',
  CIP13: '3400938086072',
  ucdLib: "LAMOTRIGINE MYL 200MG C.DISP",
  UCD7: '9304575',
  UCD13: '3400893045756',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE MYL 200MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3808033',
  CIP13: '3400938080339',
  ucdLib: "LAMOTRIGINE MYL 25MG C.DISP",
  UCD7: '9304581',
  UCD13: '3400893045817',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE MYL 25MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3808398',
  CIP13: '3400938083989',
  ucdLib: "LAMOTRIGINE MYL 50MG C.DISP",
  UCD7: '9304598',
  UCD13: '3400893045985',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE MYL 50MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3928300',
  CIP13: '3400939283005',
  ucdLib: "LAMOTRIGINE TVC 100MG C.DISP",
  UCD7: '9335110',
  UCD13: '3400893351109',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE TVC 100MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3928352',
  CIP13: '3400939283524',
  ucdLib: "LAMOTRIGINE TVC 200MG C.DISP",
  UCD7: '9335127',
  UCD13: '3400893351277',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE TVC 200MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3928211',
  CIP13: '3400939282114',
  ucdLib: "LAMOTRIGINE TVC 25MG C.DISP",
  UCD7: '9335133',
  UCD13: '3400893351338',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE TVC 25MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3928257',
  CIP13: '3400939282572',
  ucdLib: "LAMOTRIGINE TVC 50MG C.DISP",
  UCD7: '9335162',
  UCD13: '3400893351628',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE TVC 50MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '3928174',
  CIP13: '3400939281742',
  ucdLib: "LAMOTRIGINE TVC 5MG CPR DISP",
  UCD7: '9335156',
  UCD13: '3400893351567',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE TVC 5MG CPR DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '2196728',
  CIP13: '3400921967289',
  ucdLib: "LAMOTRIGINE ARL 100MG C.DISP",
  UCD7: '9407068',
  UCD13: '3400894070689',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE ARL 100MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '2196792',
  CIP13: '3400921967920',
  ucdLib: "LAMOTRIGINE ARL 200MG C.DISP",
  UCD7: '9407074',
  UCD13: '3400894070740',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE ARL 200MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '2196591',
  CIP13: '3400921965919',
  ucdLib: "LAMOTRIGINE ARL 25MG C.DISP",
  UCD7: '9407080',
  UCD13: '3400894070801',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE ARL 25MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '2196668',
  CIP13: '3400921966688',
  ucdLib: "LAMOTRIGINE ARL 50MG C.DISP",
  UCD7: '9407097',
  UCD13: '3400894070979',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMOTRIGINE ARL 50MG C.DISP BT 30",
  atcCode: "N03AX09"
}, {
  CIP7: '5890015',
  CIP13: '3400958900150',
  ucdLib: "OSPOLOT 50MG CPR",
  UCD7: '9293564',
  UCD13: '3400892935645',
  ucdQtyMultiplicator: 50,
  cipLib: "OSPOLOT 50MG CPR BT 50",
  atcCode: "N03AX03"
}, {
  CIP7: '3412625',
  CIP13: '3400934126253',
  ucdLib: "GABITRIL 10MG CPR",
  UCD7: '9181925',
  UCD13: '3400891819250',
  ucdQtyMultiplicator: 50,
  cipLib: "GABITRIL 10MG CPR BT 50",
  atcCode: "N03AG06"
}, {
  CIP7: '3412648',
  CIP13: '3400934126482',
  ucdLib: "GABITRIL 15MG CPR",
  UCD7: '9181931',
  UCD13: '3400891819311',
  ucdQtyMultiplicator: 50,
  cipLib: "GABITRIL 15MG CPR BT 50",
  atcCode: "N03AG06"
}, {
  CIP7: '3412602',
  CIP13: '3400934126024',
  ucdLib: "GABITRIL 5MG CPR",
  UCD7: '9181948',
  UCD13: '3400891819489',
  ucdQtyMultiplicator: 50,
  cipLib: "GABITRIL 5MG CPR BT 50",
  atcCode: "N03AG06"
}, {
  CIP7: '3378064',
  CIP13: '3400933780647',
  ucdLib: "SABRIL 0,5G GLE BUV SACH",
  UCD7: '9163330',
  UCD13: '3400891633306',
  ucdQtyMultiplicator: 60,
  cipLib: "SABRIL 0,5G GLE BUV SACH BT 60",
  atcCode: "N03AG04"
}, {
  CIP7: '3378041',
  CIP13: '3400933780418',
  ucdLib: "SABRIL 500MG CPR",
  UCD7: '9144290',
  UCD13: '3400891442908',
  ucdQtyMultiplicator: 60,
  cipLib: "SABRIL 500MG CPR BT 60",
  atcCode: "N03AG04"
}, {
  CIP7: '3207061',
  CIP13: '3400932070619',
  ucdLib: "DEPAMIDE 300MG CPR DRG",
  UCD7: '9025036',
  UCD13: '3400890250368',
  ucdQtyMultiplicator: 30,
  cipLib: "DEPAMIDE 300MG CPR DRG BT 30",
  atcCode: "N03AG02"
}, {
  CIP7: '5590006',
  CIP13: '3400955900061',
  ucdLib: "DEPAMIDE 300MG CPR DRG",
  UCD7: '9025036',
  UCD13: '3400890250368',
  ucdQtyMultiplicator: 50,
  cipLib: "DEPAMIDE 300MG CPR DRG BT 50",
  atcCode: "N03AG02"
}, {
  CIP7: '3029292',
  CIP13: '3400930292921',
  ucdLib: "DEPAKINE 200MG CPR",
  UCD7: '9024982',
  UCD13: '3400890249829',
  ucdQtyMultiplicator: 40,
  cipLib: "DEPAKINE 200MG CPR BT 40",
  atcCode: "N03AG01"
}, {
  CIP7: '3029300',
  CIP13: '3400930293003',
  ucdLib: "DEPAKINE BUV SOL FL40ML",
  UCD7: '9025007',
  UCD13: '3400890250078',
  ucdQtyMultiplicator: 1,
  cipLib: "DEPAKINE BUV SOL FL40ML BT 1",
  atcCode: "N03AG01"
}, {
  CIP7: '3255769',
  CIP13: '3400932557691',
  ucdLib: "DEPAKINE 400MG INJ FL+AMP",
  UCD7: '9153946',
  UCD13: '3400891539462',
  ucdQtyMultiplicator: 4,
  cipLib: "DEPAKINE 400MG INJ FL+AMP BT 4",
  atcCode: "N03AG01"
}, {
  CIP7: '3192276',
  CIP13: '3400931922766',
  ucdLib: "DEPAKINE 500MG CPR",
  UCD7: '9025013',
  UCD13: '3400890250139',
  ucdQtyMultiplicator: 40,
  cipLib: "DEPAKINE 500MG CPR BT 40",
  atcCode: "N03AG01"
}, {
  CIP7: '3263450',
  CIP13: '3400932634507',
  ucdLib: "DEPAKINE 57,6MG/ML SIR FV150ML",
  UCD7: '9024999',
  UCD13: '3400890249997',
  ucdQtyMultiplicator: 1,
  cipLib: "DEPAKINE 57,6MG/ML SIR FV150ML BT 1",
  atcCode: "N03AG01"
}, {
  CIP7: '3301802',
  CIP13: '3400933018023',
  ucdLib: "DEPAKINE CHRONO 500MG CPR",
  UCD7: '9126056',
  UCD13: '3400891260564',
  ucdQtyMultiplicator: 30,
  cipLib: "DEPAKINE CHRONO 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3673886',
  CIP13: '3400936738867',
  ucdLib: "VALPROATE ZEN 20% BUV FL40ML",
  UCD7: '9270563',
  UCD13: '3400892705637',
  ucdQtyMultiplicator: 1,
  cipLib: "VALPROATE ZEN 20% BUV FL40ML BT 1",
  atcCode: "N03AG01"
}, {
  CIP7: '3673857',
  CIP13: '3400936738577',
  ucdLib: "VALPROATE ZEN 200MG CPR",
  UCD7: '9270557',
  UCD13: '3400892705576',
  ucdQtyMultiplicator: 40,
  cipLib: "VALPROATE ZEN 200MG CPR BT 40",
  atcCode: "N03AG01"
}, {
  CIP7: '3673863',
  CIP13: '3400936738638',
  ucdLib: "VALPROATE ZEN 500MG CPR",
  UCD7: '9270586',
  UCD13: '3400892705866',
  ucdQtyMultiplicator: 40,
  cipLib: "VALPROATE ZEN 500MG CPR BT 40",
  atcCode: "N03AG01"
}, {
  CIP7: '3487623',
  CIP13: '3400934876233',
  ucdLib: "DEPAKOTE 250MG CPR",
  UCD7: '9218835',
  UCD13: '3400892188355',
  ucdQtyMultiplicator: 30,
  cipLib: "DEPAKOTE 250MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3655173',
  CIP13: '3400936551732',
  ucdLib: "MICROPAKINE LP 1000MG GLE S.",
  UCD7: '9262954',
  UCD13: '3400892629544',
  ucdQtyMultiplicator: 30,
  cipLib: "MICROPAKINE LP 1000MG GLE S. BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3655115',
  CIP13: '3400936551152',
  ucdLib: "MICROPAKINE LP 100MG GLE S.",
  UCD7: '9262948',
  UCD13: '3400892629483',
  ucdQtyMultiplicator: 30,
  cipLib: "MICROPAKINE LP 100MG GLE S. BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3655121',
  CIP13: '3400936551213',
  ucdLib: "MICROPAKINE LP 250MG GLE S.",
  UCD7: '9262960',
  UCD13: '3400892629605',
  ucdQtyMultiplicator: 30,
  cipLib: "MICROPAKINE LP 250MG GLE S. BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3655138',
  CIP13: '3400936551381',
  ucdLib: "MICROPAKINE LP 500MG GLE S.",
  UCD7: '9262977',
  UCD13: '3400892629773',
  ucdQtyMultiplicator: 30,
  cipLib: "MICROPAKINE LP 500MG GLE S. BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3655144',
  CIP13: '3400936551442',
  ucdLib: "MICROPAKINE LP 750MG GLE S.",
  UCD7: '9262983',
  UCD13: '3400892629834',
  ucdQtyMultiplicator: 30,
  cipLib: "MICROPAKINE LP 750MG GLE S. BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3544427',
  CIP13: '3400935444271',
  ucdLib: "DEPAKOTE 500MG CPR",
  UCD7: '9218841',
  UCD13: '3400892188416',
  ucdQtyMultiplicator: 90,
  cipLib: "DEPAKOTE 500MG CPR BT 90",
  atcCode: "N03AG01"
}, {
  CIP7: '3696692',
  CIP13: '3400936966925',
  ucdLib: "VALPROATE BGA LP 500MG CPR",
  UCD7: '9278895',
  UCD13: '3400892788951',
  ucdQtyMultiplicator: 30,
  cipLib: "VALPROATE BGA LP 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3696597',
  CIP13: '3400936965973',
  ucdLib: "VALPROATE EG LP 500MG CPR",
  UCD7: '9278903',
  UCD13: '3400892789033',
  ucdQtyMultiplicator: 30,
  cipLib: "VALPROATE EG LP 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3696700',
  CIP13: '3400936967007',
  ucdLib: "VALPROATE MYL LP 500MG CPR",
  UCD7: '9278926',
  UCD13: '3400892789262',
  ucdQtyMultiplicator: 30,
  cipLib: "VALPROATE MYL LP 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3696640',
  CIP13: '3400936966406',
  ucdLib: "VALPROATE TVC LP 500MG CPR",
  UCD7: '9278961',
  UCD13: '3400892789613',
  ucdQtyMultiplicator: 30,
  cipLib: "VALPROATE TVC LP 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3696628',
  CIP13: '3400936966284',
  ucdLib: "VALPROATE TVS LP 500MG CPR",
  UCD7: '9278949',
  UCD13: '3400892789491',
  ucdQtyMultiplicator: 30,
  cipLib: "VALPROATE TVS LP 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3693469',
  CIP13: '3400936934696',
  ucdLib: "VALPROATE ZEN LP 500MG CPR",
  UCD7: '9277594',
  UCD13: '3400892775944',
  ucdQtyMultiplicator: 30,
  cipLib: "VALPROATE ZEN LP 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '3785757',
  CIP13: '3400937857574',
  ucdLib: "VALPROATE AGT 400MG INJ A.4ML",
  UCD7: '9298320',
  UCD13: '3400892983202',
  ucdQtyMultiplicator: 10,
  cipLib: "VALPROATE AGT 400MG INJ A.4ML BT 10",
  atcCode: "N03AG01"
}, {
  CIP7: '3715745',
  CIP13: '3400937157452',
  ucdLib: "VALPROATE ARW LP 500MG CPR",
  UCD7: '9282916',
  UCD13: '3400892829166',
  ucdQtyMultiplicator: 30,
  cipLib: "VALPROATE ARW LP 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '5618934',
  CIP13: '3400956189342',
  ucdLib: "DEPAKOTE 250MG CPR",
  UCD7: '9218835',
  UCD13: '3400892188355',
  ucdQtyMultiplicator: 90,
  cipLib: "DEPAKOTE 250MG CPR BT 90",
  atcCode: "N03AG01"
}, {
  CIP7: '4998024',
  CIP13: '3400949980246',
  ucdLib: "VALPROATE ARW 200MG/ML BUV40ML",
  UCD7: '9371063',
  UCD13: '3400893710630',
  ucdQtyMultiplicator: 1,
  cipLib: "VALPROATE ARW 200MG/ML BUV40ML BT 1",
  atcCode: "N03AG01"
}, {
  CIP7: '3984853',
  CIP13: '3400939848532',
  ucdLib: "VALPROATE SDZ LP 500MG CPR",
  UCD7: '9347484',
  UCD13: '3400893474846',
  ucdQtyMultiplicator: 30,
  cipLib: "VALPROATE SDZ LP 500MG CPR BT 30",
  atcCode: "N03AG01"
}, {
  CIP7: '5848947',
  CIP13: '3400958489471',
  ucdLib: "DEPAKINE CHRONO 500MG CPR",
  UCD7: '9126056',
  UCD13: '3400891260564',
  ucdQtyMultiplicator: 100,
  cipLib: "DEPAKINE CHRONO 500MG CPR BT 100",
  atcCode: "N03AG01"
}, {
  CIP7: '5678988',
  CIP13: '3400956789887',
  ucdLib: "VALPROATE ARW LP 500MG CPR",
  UCD7: '9282916',
  UCD13: '3400892829166',
  ucdQtyMultiplicator: 40,
  cipLib: "VALPROATE ARW LP 500MG CPR BT 40",
  atcCode: "N03AG01"
}, {
  CIP7: '3973499',
  CIP13: '3400939734996',
  ucdLib: "ZEBINIX 800MG CPR",
  UCD7: '9381096',
  UCD13: '3400893810965',
  ucdQtyMultiplicator: 30,
  cipLib: "ZEBINIX 800MG CPR BT 30",
  atcCode: "N03AF04"
}, {
  CIP7: '3817612',
  CIP13: '3400938176124',
  ucdLib: "INOVELON 200MG CPR",
  UCD7: '9332755',
  UCD13: '3400893327555',
  ucdQtyMultiplicator: 60,
  cipLib: "INOVELON 200MG CPR BT 60",
  atcCode: "N03AF03"
}, {
  CIP7: '3817629',
  CIP13: '3400938176292',
  ucdLib: "INOVELON 400MG CPR",
  UCD7: '9332761',
  UCD13: '3400893327616',
  ucdQtyMultiplicator: 60,
  cipLib: "INOVELON 400MG CPR BT 60",
  atcCode: "N03AF03"
}, {
  CIP7: '3828461',
  CIP13: '3400938284614',
  ucdLib: "INOVELON 100MG CPR",
  UCD7: '9332749',
  UCD13: '3400893327494',
  ucdQtyMultiplicator: 10,
  cipLib: "INOVELON 100MG CPR BT 10",
  atcCode: "N03AF03"
}, {
  CIP7: '2206912',
  CIP13: '3400922069128',
  ucdLib: "INOVELON 40MG/ML BUV BOUT460ML",
  UCD7: '9391255',
  UCD13: '3400893912553',
  ucdQtyMultiplicator: 1,
  cipLib: "INOVELON 40MG/ML BUV BOUT460ML BT 1",
  atcCode: "N03AF03"
}, {
  CIP7: '3579012',
  CIP13: '3400935790125',
  ucdLib: "TRILEPTAL 60MG/ML BUV FL250ML",
  UCD7: '9249586',
  UCD13: '3400892495866',
  ucdQtyMultiplicator: 1,
  cipLib: "TRILEPTAL 60MG/ML BUV FL250ML BT 1",
  atcCode: "N03AF02"
}, {
  CIP7: '3535701',
  CIP13: '3400935357014',
  ucdLib: "TRILEPTAL 150MG CPR",
  UCD7: '9226958',
  UCD13: '3400892269580',
  ucdQtyMultiplicator: 50,
  cipLib: "TRILEPTAL 150MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3535724',
  CIP13: '3400935357243',
  ucdLib: "TRILEPTAL 300MG CPR",
  UCD7: '9220648',
  UCD13: '3400892206486',
  ucdQtyMultiplicator: 50,
  cipLib: "TRILEPTAL 300MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3535747',
  CIP13: '3400935357472',
  ucdLib: "TRILEPTAL 600MG CPR",
  UCD7: '9226964',
  UCD13: '3400892269641',
  ucdQtyMultiplicator: 50,
  cipLib: "TRILEPTAL 600MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3797878',
  CIP13: '3400937978781',
  ucdLib: "OXCARBAZEPINE MYL 150MG CPR",
  UCD7: '9304090',
  UCD13: '3400893040904',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE MYL 150MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3798286',
  CIP13: '3400937982863',
  ucdLib: "OXCARBAZEPINE MYL 300MG CPR",
  UCD7: '9304109',
  UCD13: '3400893041093',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE MYL 300MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3798346',
  CIP13: '3400937983464',
  ucdLib: "OXCARBAZEPINE MYL 600MG CPR",
  UCD7: '9304115',
  UCD13: '3400893041154',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE MYL 600MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3967576',
  CIP13: '3400939675763',
  ucdLib: "OXCARBAZEPINE TVC 150MG CPR",
  UCD7: '9343960',
  UCD13: '3400893439609',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE TVC 150MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3986757',
  CIP13: '3400939867571',
  ucdLib: "OXCARBAZEPINE TVC 300MG CPR",
  UCD7: '9343977',
  UCD13: '3400893439777',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE TVC 300MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3986740',
  CIP13: '3400939867403',
  ucdLib: "OXCARBAZEPINE TVC 600MG CPR",
  UCD7: '9343983',
  UCD13: '3400893439838',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE TVC 600MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '2236600',
  CIP13: '3400922366005',
  ucdLib: "OXCARBAZEPINE SDZ 150MG CPR",
  UCD7: '9388282',
  UCD13: '3400893882825',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE SDZ 150MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '2236801',
  CIP13: '3400922368016',
  ucdLib: "OXCARBAZEPINE SDZ 300MG CPR",
  UCD7: '9388299',
  UCD13: '3400893882993',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE SDZ 300MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '2236899',
  CIP13: '3400922368993',
  ucdLib: "OXCARBAZEPINE SDZ 600MG CPR",
  UCD7: '9388307',
  UCD13: '3400893883075',
  ucdQtyMultiplicator: 50,
  cipLib: "OXCARBAZEPINE SDZ 600MG CPR BT 50",
  atcCode: "N03AF02"
}, {
  CIP7: '3295639',
  CIP13: '3400932956395',
  ucdLib: "TEGRETOL 20MG/ML BUV FL150ML",
  UCD7: '9152349',
  UCD13: '3400891523492',
  ucdQtyMultiplicator: 1,
  cipLib: "TEGRETOL 20MG/ML BUV FL150ML BT 1",
  atcCode: "N03AF01"
}, {
  CIP7: '3298431',
  CIP13: '3400932984312',
  ucdLib: "TEGRETOL LP 400MG CPR",
  UCD7: '9134937',
  UCD13: '3400891349375',
  ucdQtyMultiplicator: 30,
  cipLib: "TEGRETOL LP 400MG CPR BT 30",
  atcCode: "N03AF01"
}, {
  CIP7: '3103545',
  CIP13: '3400931035459',
  ucdLib: "TEGRETOL 200MG CPR",
  UCD7: '9090714',
  UCD13: '3400890907149',
  ucdQtyMultiplicator: 50,
  cipLib: "TEGRETOL 200MG CPR BT 50",
  atcCode: "N03AF01"
}, {
  CIP7: '3314874',
  CIP13: '3400933148744',
  ucdLib: "TEGRETOL LP 200MG CPR",
  UCD7: '9134920',
  UCD13: '3400891349207',
  ucdQtyMultiplicator: 30,
  cipLib: "TEGRETOL LP 200MG CPR BT 30",
  atcCode: "N03AF01"
}, {
  CIP7: '3530632',
  CIP13: '3400935306326',
  ucdLib: "CARBAMAZEPINE MYL LP200MG C.",
  UCD7: '9220588',
  UCD13: '3400892205885',
  ucdQtyMultiplicator: 30,
  cipLib: "CARBAMAZEPINE MYL LP200MG C. BT 30",
  atcCode: "N03AF01"
}, {
  CIP7: '3530514',
  CIP13: '3400935305145',
  ucdLib: "CARBAMAZEPINE MYL LP400MG C.",
  UCD7: '9220594',
  UCD13: '3400892205946',
  ucdQtyMultiplicator: 30,
  cipLib: "CARBAMAZEPINE MYL LP400MG C. BT 30",
  atcCode: "N03AF01"
}, {
  CIP7: '3443637',
  CIP13: '3400934436376',
  ucdLib: "CARBAMAZEPINE SDZ LP200MG C.",
  UCD7: '9329374',
  UCD13: '3400893293744',
  ucdQtyMultiplicator: 30,
  cipLib: "CARBAMAZEPINE SDZ LP200MG C. BT 30",
  atcCode: "N03AF01"
}, {
  CIP7: '3443689',
  CIP13: '3400934436895',
  ucdLib: "CARBAMAZEPINE SDZ LP400MG C.",
  UCD7: '9329380',
  UCD13: '3400893293805',
  ucdQtyMultiplicator: 30,
  cipLib: "CARBAMAZEPINE SDZ LP400MG C. BT 30",
  atcCode: "N03AF01"
}, {
  CIP7: '3170524',
  CIP13: '3400931705246',
  ucdLib: "RIVOTRIL 2,5MG/ML BUV GTT 20ML",
  UCD7: '9080727',
  UCD13: '3400890807272',
  ucdQtyMultiplicator: 1,
  cipLib: "RIVOTRIL 2,5MG/ML BUV GTT 20ML BT 1",
  atcCode: "N03AE01"
}, {
  CIP7: '3816498',
  CIP13: '3400938164985',
  ucdLib: "RIVOTRIL 2MG CPR",
  UCD7: '9080710',
  UCD13: '3400890807104',
  ucdQtyMultiplicator: 28,
  cipLib: "RIVOTRIL 2MG CPR BT 28",
  atcCode: "N03AE01"
}, {
  CIP7: '3442827',
  CIP13: '3400934428272',
  ucdLib: "RIVOTRIL 1MG INJ AMP+AMP",
  UCD7: '9199658',
  UCD13: '3400891996586',
  ucdQtyMultiplicator: 6,
  cipLib: "RIVOTRIL 1MG INJ AMP+AMP BT 6",
  atcCode: "N03AE01"
}, {
  CIP7: '3250795',
  CIP13: '3400932507955',
  ucdLib: "ZARONTIN 5% SIR FV200ML",
  UCD7: '9102021',
  UCD13: '3400891020212',
  ucdQtyMultiplicator: 1,
  cipLib: "ZARONTIN 5% SIR FV200ML BT 1",
  atcCode: "N03AD01"
}, {
  CIP7: '5610950',
  CIP13: '3400956109500',
  ucdLib: "PRODILANTIN 75MG INJ FL10ML",
  UCD7: '9205005',
  UCD13: '3400892050058',
  ucdQtyMultiplicator: 10,
  cipLib: "PRODILANTIN 75MG INJ FL10ML BT 10",
  atcCode: "N03AB05"
}, {
  CIP7: '3030303',
  CIP13: '3400930303030',
  ucdLib: "DI-HYDAN 100MG CPR",
  UCD7: '9026018',
  UCD13: '3400890260183',
  ucdQtyMultiplicator: 60,
  cipLib: "DI-HYDAN 100MG CPR BT 60",
  atcCode: "N03AB02"
}, {
  CIP7: '5605535',
  CIP13: '3400956055357',
  ucdLib: "DILANTIN 250MG/5ML INJ FL",
  UCD7: '9162023',
  UCD13: '3400891620238',
  ucdQtyMultiplicator: 10,
  cipLib: "DILANTIN 250MG/5ML INJ FL BT 10",
  atcCode: "N03AB02"
}, {
  CIP7: '3069825',
  CIP13: '3400930698259',
  ucdLib: "MYSOLINE 250MG CPR",
  UCD7: '9060742',
  UCD13: '3400890607421',
  ucdQtyMultiplicator: 50,
  cipLib: "MYSOLINE 250MG CPR BT 50",
  atcCode: "N03AA03"
}, {
  CIP7: '3055496',
  CIP13: '3400930554968',
  ucdLib: "KANEURON BUV GTT FL30ML",
  UCD7: '9048528',
  UCD13: '3400890485289',
  ucdQtyMultiplicator: 1,
  cipLib: "KANEURON BUV GTT FL30ML BT 1",
  atcCode: "N03AA02"
}, {
  CIP7: '3289610',
  CIP13: '3400932896103',
  ucdLib: "ALEPSAL 100MG CPR",
  UCD7: '9002242',
  UCD13: '3400890022422',
  ucdQtyMultiplicator: 30,
  cipLib: "ALEPSAL 100MG CPR BT 30",
  atcCode: "N03AA02"
}, {
  CIP7: '3289627',
  CIP13: '3400932896271',
  ucdLib: "ALEPSAL 15MG CPR",
  UCD7: '9002213',
  UCD13: '3400890022132',
  ucdQtyMultiplicator: 30,
  cipLib: "ALEPSAL 15MG CPR BT 30",
  atcCode: "N03AA02"
}, {
  CIP7: '3002229',
  CIP13: '3400930022290',
  ucdLib: "ALEPSAL 50MG CPR",
  UCD7: '9002265',
  UCD13: '3400890022651',
  ucdQtyMultiplicator: 30,
  cipLib: "ALEPSAL 50MG CPR BT 30",
  atcCode: "N03AA02"
}, {
  CIP7: '3286209',
  CIP13: '3400932862092',
  ucdLib: "GARDENAL 40MG INJ FV+AMP",
  UCD7: '9118364',
  UCD13: '3400891183641',
  ucdQtyMultiplicator: 1,
  cipLib: "GARDENAL 40MG INJ FV+AMP BT 1",
  atcCode: "N03AA02"
}, {
  CIP7: '3042536',
  CIP13: '3400930425367',
  ucdLib: "GARDENAL 100MG CPR",
  UCD7: '9037298',
  UCD13: '3400890372985',
  ucdQtyMultiplicator: 20,
  cipLib: "GARDENAL 100MG CPR BT 20",
  atcCode: "N03AA02"
}, {
  CIP7: '3042507',
  CIP13: '3400930425077',
  ucdLib: "GARDENAL 10MG CPR",
  UCD7: '9037281',
  UCD13: '3400890372817',
  ucdQtyMultiplicator: 80,
  cipLib: "GARDENAL 10MG CPR BT 80",
  atcCode: "N03AA02"
}, {
  CIP7: '3042513',
  CIP13: '3400930425138',
  ucdLib: "GARDENAL 50MG CPR",
  UCD7: '9037306',
  UCD13: '3400890373067',
  ucdQtyMultiplicator: 30,
  cipLib: "GARDENAL 50MG CPR BT 30",
  atcCode: "N03AA02"
}, {
  CIP7: '3313308',
  CIP13: '3400933133085',
  ucdLib: "ALEPSAL 150MG CPR",
  UCD7: '9136072',
  UCD13: '3400891360721',
  ucdQtyMultiplicator: 30,
  cipLib: "ALEPSAL 150MG CPR BT 30",
  atcCode: "N03AA02"
}, {
  CIP7: '3399698',
  CIP13: '3400933996987',
  ucdLib: "GARDENAL 200MG INJ FV+AMP",
  UCD7: '9120094',
  UCD13: '3400891200942',
  ucdQtyMultiplicator: 1,
  cipLib: "GARDENAL 200MG INJ FV+AMP BT 1",
  atcCode: "N03AA02"
}, {
  CIP7: '5601336',
  CIP13: '3400956013364',
  ucdLib: "PHENOBARBITAL RCA100MG CPR",
  UCD7: '9381216',
  UCD13: '3400893812167',
  ucdQtyMultiplicator: 1000,
  cipLib: "PHENOBARBITAL RCA100MG CPR BT 1000",
  atcCode: "N03AA02"
}, {
  CIP7: '3180853',
  CIP13: '3400931808534',
  ucdLib: "NOCERTONE 60MG CPR",
  UCD7: '9063309',
  UCD13: '3400890633093',
  ucdQtyMultiplicator: 30,
  cipLib: "NOCERTONE 60MG CPR BT 30",
  atcCode: "N02CX06"
}, {
  CIP7: '3137538',
  CIP13: '3400931375388',
  ucdLib: "SANMIGRAN 0,5MG CPR",
  UCD7: '9082198',
  UCD13: '3400890821988',
  ucdQtyMultiplicator: 50,
  cipLib: "SANMIGRAN 0,5MG CPR BT 50",
  atcCode: "N02CX01"
}, {
  CIP7: '3137544',
  CIP13: '3400931375449',
  ucdLib: "SANMIGRAN 0,5MG CPR",
  UCD7: '9082198',
  UCD13: '3400890821988',
  ucdQtyMultiplicator: 100,
  cipLib: "SANMIGRAN 0,5MG CPR BT 100",
  atcCode: "N02CX01"
}, {
  CIP7: '3615647',
  CIP13: '3400936156470',
  ucdLib: "TIGREAT 2,5MG CPR",
  UCD7: '9299851',
  UCD13: '3400892998510',
  ucdQtyMultiplicator: 12,
  cipLib: "TIGREAT 2,5MG CPR BT 12",
  atcCode: "N02CC07"
}, {
  CIP7: '3575534',
  CIP13: '3400935755346',
  ucdLib: "TIGREAT 2,5MG CPR",
  UCD7: '9299851',
  UCD13: '3400892998510',
  ucdQtyMultiplicator: 2,
  cipLib: "TIGREAT 2,5MG CPR BT 2",
  atcCode: "N02CC07"
}, {
  CIP7: '3575540',
  CIP13: '3400935755407',
  ucdLib: "TIGREAT 2,5MG CPR",
  UCD7: '9299851',
  UCD13: '3400892998510',
  ucdQtyMultiplicator: 6,
  cipLib: "TIGREAT 2,5MG CPR BT 6",
  atcCode: "N02CC07"
}, {
  CIP7: '3556169',
  CIP13: '3400935561695',
  ucdLib: "ISIMIG 2,5MG CPR",
  UCD7: '9299839',
  UCD13: '3400892998398',
  ucdQtyMultiplicator: 2,
  cipLib: "ISIMIG 2,5MG CPR BT 2",
  atcCode: "N02CC07"
}, {
  CIP7: '3556175',
  CIP13: '3400935561756',
  ucdLib: "ISIMIG 2,5MG CPR",
  UCD7: '9299839',
  UCD13: '3400892998398',
  ucdQtyMultiplicator: 6,
  cipLib: "ISIMIG 2,5MG CPR BT 6",
  atcCode: "N02CC07"
}, {
  CIP7: '3778295',
  CIP13: '3400937782951',
  ucdLib: "ISIMIG 2,5MG CPR",
  UCD7: '9299839',
  UCD13: '3400892998398',
  ucdQtyMultiplicator: 12,
  cipLib: "ISIMIG 2,5MG CPR BT 12",
  atcCode: "N02CC07"
}, {
  CIP7: '2694320',
  CIP13: '3400926943202',
  ucdLib: "FROVATRIPTAN MYL 2,5MG CPR",
  UCD7: '9415576',
  UCD13: '3400894155768',
  ucdQtyMultiplicator: 2,
  cipLib: "FROVATRIPTAN MYL 2,5MG CPR BT 2",
  atcCode: "N02CC07"
}, {
  CIP7: '2694337',
  CIP13: '3400926943370',
  ucdLib: "FROVATRIPTAN MYL 2,5MG CPR",
  UCD7: '9415576',
  UCD13: '3400894155768',
  ucdQtyMultiplicator: 6,
  cipLib: "FROVATRIPTAN MYL 2,5MG CPR BT 6",
  atcCode: "N02CC07"
}, {
  CIP7: '2694343',
  CIP13: '3400926943431',
  ucdLib: "FROVATRIPTAN MYL 2,5MG CPR",
  UCD7: '9415576',
  UCD13: '3400894155768',
  ucdQtyMultiplicator: 12,
  cipLib: "FROVATRIPTAN MYL 2,5MG CPR BT 12",
  atcCode: "N02CC07"
}, {
  CIP7: '3002954',
  CIP13: '3400930029541',
  ucdLib: "ELETRIPTAN BGR 20MG CPR",
  UCD7: '9412922',
  UCD13: '3400894129226',
  ucdQtyMultiplicator: 6,
  cipLib: "ELETRIPTAN BGR 20MG CPR BT 6",
  atcCode: "N02CC06"
}, {
  CIP7: '3002958',
  CIP13: '3400930029589',
  ucdLib: "ELETRIPTAN BGR 40MG CPR",
  UCD7: '9412939',
  UCD13: '3400894129394',
  ucdQtyMultiplicator: 6,
  cipLib: "ELETRIPTAN BGR 40MG CPR BT 6",
  atcCode: "N02CC06"
}, {
  CIP7: '3002959',
  CIP13: '3400930029596',
  ucdLib: "ELETRIPTAN BGR 40MG CPR",
  UCD7: '9412939',
  UCD13: '3400894129394',
  ucdQtyMultiplicator: 10,
  cipLib: "ELETRIPTAN BGR 40MG CPR BT 10",
  atcCode: "N02CC06"
}, {
  CIP7: '3002943',
  CIP13: '3400930029435',
  ucdLib: "ELETRIPTAN PFZ 40MG CPR",
  UCD7: '9413229',
  UCD13: '3400894132295',
  ucdQtyMultiplicator: 6,
  cipLib: "ELETRIPTAN PFZ 40MG CPR BT 6",
  atcCode: "N02CC06"
}, {
  CIP7: '3002944',
  CIP13: '3400930029442',
  ucdLib: "ELETRIPTAN PFZ 40MG CPR",
  UCD7: '9413229',
  UCD13: '3400894132295',
  ucdQtyMultiplicator: 10,
  cipLib: "ELETRIPTAN PFZ 40MG CPR BT 10",
  atcCode: "N02CC06"
}, {
  CIP7: '3578610',
  CIP13: '3400935786104',
  ucdLib: "RELPAX 20MG CPR",
  UCD7: '9238051',
  UCD13: '3400892380513',
  ucdQtyMultiplicator: 6,
  cipLib: "RELPAX 20MG CPR BT 6",
  atcCode: "N02CC06"
}, {
  CIP7: '3578685',
  CIP13: '3400935786852',
  ucdLib: "RELPAX 40MG CPR",
  UCD7: '9238068',
  UCD13: '3400892380681',
  ucdQtyMultiplicator: 6,
  cipLib: "RELPAX 40MG CPR BT 6",
  atcCode: "N02CC06"
}, {
  CIP7: '3578691',
  CIP13: '3400935786913',
  ucdLib: "RELPAX 40MG CPR",
  UCD7: '9238068',
  UCD13: '3400892380681',
  ucdQtyMultiplicator: 10,
  cipLib: "RELPAX 40MG CPR BT 10",
  atcCode: "N02CC06"
}, {
  CIP7: '2773108',
  CIP13: '3400927731082',
  ucdLib: "ELETRIPTAN MYL 20MG CPR",
  UCD7: '9412945',
  UCD13: '3400894129455',
  ucdQtyMultiplicator: 6,
  cipLib: "ELETRIPTAN MYL 20MG CPR BT 6",
  atcCode: "N02CC06"
}, {
  CIP7: '2773120',
  CIP13: '3400927731204',
  ucdLib: "ELETRIPTAN MYL 40MG CPR",
  UCD7: '9412951',
  UCD13: '3400894129516',
  ucdQtyMultiplicator: 6,
  cipLib: "ELETRIPTAN MYL 40MG CPR BT 6",
  atcCode: "N02CC06"
}, {
  CIP7: '2773143',
  CIP13: '3400927731433',
  ucdLib: "ELETRIPTAN MYL 40MG CPR",
  UCD7: '9412951',
  UCD13: '3400894129516',
  ucdQtyMultiplicator: 10,
  cipLib: "ELETRIPTAN MYL 40MG CPR BT 10",
  atcCode: "N02CC06"
}, {
  CIP7: '3002128',
  CIP13: '3400930021286',
  ucdLib: "ALMOTRIPTAN ARW 12,5MG CPR",
  UCD7: '9412856',
  UCD13: '3400894128564',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOTRIPTAN ARW 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '3002130',
  CIP13: '3400930021309',
  ucdLib: "ALMOTRIPTAN ARW 12,5MG CPR",
  UCD7: '9412856',
  UCD13: '3400894128564',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOTRIPTAN ARW 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '3002135',
  CIP13: '3400930021354',
  ucdLib: "ALMOTRIPTAN EG 12,5MG CPR",
  UCD7: '9412112',
  UCD13: '3400894121121',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOTRIPTAN EG 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '3002137',
  CIP13: '3400930021378',
  ucdLib: "ALMOTRIPTAN EG 12,5MG CPR",
  UCD7: '9412112',
  UCD13: '3400894121121',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOTRIPTAN EG 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '3002864',
  CIP13: '3400930028643',
  ucdLib: "ALMOTRIPTAN ZEN 12,5MG CPR",
  UCD7: '9415369',
  UCD13: '3400894153696',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOTRIPTAN ZEN 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '3002866',
  CIP13: '3400930028667',
  ucdLib: "ALMOTRIPTAN ZEN 12,5MG CPR",
  UCD7: '9415369',
  UCD13: '3400894153696',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOTRIPTAN ZEN 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '3000528',
  CIP13: '3400930005286',
  ucdLib: "ALMOTRIPTAN ZYD 12,5MG CPR",
  UCD7: '9407513',
  UCD13: '3400894075134',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOTRIPTAN ZYD 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '3000529',
  CIP13: '3400930005293',
  ucdLib: "ALMOTRIPTAN ZYD 12,5MG CPR",
  UCD7: '9407513',
  UCD13: '3400894075134',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOTRIPTAN ZYD 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '2760258',
  CIP13: '3400927602580',
  ucdLib: "ALMOTRIPTAN SDZ 12,5MG CPR",
  UCD7: '9404934',
  UCD13: '3400894049340',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOTRIPTAN SDZ 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '2760293',
  CIP13: '3400927602931',
  ucdLib: "ALMOTRIPTAN SDZ 12,5MG CPR",
  UCD7: '9404934',
  UCD13: '3400894049340',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOTRIPTAN SDZ 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '3556146',
  CIP13: '3400935561466',
  ucdLib: "ALMOGRAN 12,5MG CPR",
  UCD7: '9246659',
  UCD13: '3400892466590',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOGRAN 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '3586070',
  CIP13: '3400935860705',
  ucdLib: "ALMOGRAN 12,5MG CPR",
  UCD7: '9246659',
  UCD13: '3400892466590',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOGRAN 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '2802258',
  CIP13: '3400928022585',
  ucdLib: "ALMOTRIPTAN TVC 12,5MG CPR",
  UCD7: '9406301',
  UCD13: '3400894063018',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOTRIPTAN TVC 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '2802241',
  CIP13: '3400928022417',
  ucdLib: "ALMOTRIPTAN TVC 12,5MG CPR",
  UCD7: '9406301',
  UCD13: '3400894063018',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOTRIPTAN TVC 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '2681889',
  CIP13: '3400926818890',
  ucdLib: "ALMOTRIPTAN MYL 12,5MG CPR",
  UCD7: '9405224',
  UCD13: '3400894052241',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOTRIPTAN MYL 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '2681903',
  CIP13: '3400926819033',
  ucdLib: "ALMOTRIPTAN MYL 12,5MG CPR",
  UCD7: '9405224',
  UCD13: '3400894052241',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOTRIPTAN MYL 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '2791879',
  CIP13: '3400927918797',
  ucdLib: "ALMOTRIPTAN BGA 12,5MG CPR",
  UCD7: '9405767',
  UCD13: '3400894057673',
  ucdQtyMultiplicator: 6,
  cipLib: "ALMOTRIPTAN BGA 12,5MG CPR BT 6",
  atcCode: "N02CC05"
}, {
  CIP7: '2791885',
  CIP13: '3400927918858',
  ucdLib: "ALMOTRIPTAN BGA 12,5MG CPR",
  UCD7: '9405767',
  UCD13: '3400894057673',
  ucdQtyMultiplicator: 12,
  cipLib: "ALMOTRIPTAN BGA 12,5MG CPR BT 12",
  atcCode: "N02CC05"
}, {
  CIP7: '3479351',
  CIP13: '3400934793516',
  ucdLib: "MAXALT 10MG CPR",
  UCD7: '9205703',
  UCD13: '3400892057033',
  ucdQtyMultiplicator: 6,
  cipLib: "MAXALT 10MG CPR BT 6",
  atcCode: "N02CC04"
}, {
  CIP7: '3479368',
  CIP13: '3400934793684',
  ucdLib: "MAXALT 10MG CPR",
  UCD7: '9205703',
  UCD13: '3400892057033',
  ucdQtyMultiplicator: 12,
  cipLib: "MAXALT 10MG CPR BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '3479322',
  CIP13: '3400934793226',
  ucdLib: "MAXALT 5MG CPR",
  UCD7: '9205732',
  UCD13: '3400892057323',
  ucdQtyMultiplicator: 12,
  cipLib: "MAXALT 5MG CPR BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '3479434',
  CIP13: '3400934794346',
  ucdLib: "MAXALTLYO 10MG LYOT ORAL",
  UCD7: '9205726',
  UCD13: '3400892057262',
  ucdQtyMultiplicator: 6,
  cipLib: "MAXALTLYO 10MG LYOT ORAL BT 6",
  atcCode: "N02CC04"
}, {
  CIP7: '3479440',
  CIP13: '3400934794407',
  ucdLib: "MAXALTLYO 10MG LYOT ORAL",
  UCD7: '9205726',
  UCD13: '3400892057262',
  ucdQtyMultiplicator: 12,
  cipLib: "MAXALTLYO 10MG LYOT ORAL BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '3479374',
  CIP13: '3400934793745',
  ucdLib: "MAXALTLYO 5MG LYOT ORAL",
  UCD7: '9205749',
  UCD13: '3400892057491',
  ucdQtyMultiplicator: 2,
  cipLib: "MAXALTLYO 5MG LYOT ORAL BT 2",
  atcCode: "N02CC04"
}, {
  CIP7: '3503658',
  CIP13: '3400935036582',
  ucdLib: "RIZATRIPTAN TVC 10MG C.DISP",
  UCD7: '9352396',
  UCD13: '3400893523964',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN TVC 10MG C.DISP BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '2698950',
  CIP13: '3400926989507',
  ucdLib: "RIZATRIPTAN ARL 10MG CPR",
  UCD7: '9394101',
  UCD13: '3400893941010',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN ARL 10MG CPR BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '2742415',
  CIP13: '3400927424151',
  ucdLib: "RIZATRIPTAN BGA 10MG CPR DISP",
  UCD7: '9401321',
  UCD13: '3400894013211',
  ucdQtyMultiplicator: 6,
  cipLib: "RIZATRIPTAN BGA 10MG CPR DISP BT 6",
  atcCode: "N02CC04"
}, {
  CIP7: '2742421',
  CIP13: '3400927424212',
  ucdLib: "RIZATRIPTAN BGA 10MG CPR DISP",
  UCD7: '9401321',
  UCD13: '3400894013211',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN BGA 10MG CPR DISP BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '2197254',
  CIP13: '3400921972542',
  ucdLib: "RIZATRIPTAN MYL 10MG C.DISP",
  UCD7: '9392912',
  UCD13: '3400893929124',
  ucdQtyMultiplicator: 6,
  cipLib: "RIZATRIPTAN MYL 10MG C.DISP BT 6",
  atcCode: "N02CC04"
}, {
  CIP7: '2197260',
  CIP13: '3400921972603',
  ucdLib: "RIZATRIPTAN MYL 10MG C.DISP",
  UCD7: '9392912',
  UCD13: '3400893929124',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN MYL 10MG C.DISP BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '2742295',
  CIP13: '3400927422959',
  ucdLib: "RIZATRIPTAN SDZ 10MG CPR DISP",
  UCD7: '9409015',
  UCD13: '3400894090151',
  ucdQtyMultiplicator: 6,
  cipLib: "RIZATRIPTAN SDZ 10MG CPR DISP BT 6",
  atcCode: "N02CC04"
}, {
  CIP7: '2742303',
  CIP13: '3400927423031',
  ucdLib: "RIZATRIPTAN SDZ 10MG CPR DISP",
  UCD7: '9409015',
  UCD13: '3400894090151',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN SDZ 10MG CPR DISP BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '2238496',
  CIP13: '3400922384962',
  ucdLib: "RIZATRIPTAN ARL 10MG CPR DISP",
  UCD7: '9392591',
  UCD13: '3400893925911',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN ARL 10MG CPR DISP BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '2169306',
  CIP13: '3400921693065',
  ucdLib: "RIZATRIPTAN EG 10MG C.DISP",
  UCD7: '9379426',
  UCD13: '3400893794265',
  ucdQtyMultiplicator: 6,
  cipLib: "RIZATRIPTAN EG 10MG C.DISP BT 6",
  atcCode: "N02CC04"
}, {
  CIP7: '2169312',
  CIP13: '3400921693126',
  ucdLib: "RIZATRIPTAN EG 10MG C.DISP",
  UCD7: '9379426',
  UCD13: '3400893794265',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN EG 10MG C.DISP BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '2169252',
  CIP13: '3400921692525',
  ucdLib: "RIZATRIPTAN EG 10MG CPR",
  UCD7: '9378510',
  UCD13: '3400893785102',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN EG 10MG CPR BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '2169192',
  CIP13: '3400921691924',
  ucdLib: "RIZATRIPTAN EG 5MG CPR",
  UCD7: '9378527',
  UCD13: '3400893785270',
  ucdQtyMultiplicator: 12,
  cipLib: "RIZATRIPTAN EG 5MG CPR BT 12",
  atcCode: "N02CC04"
}, {
  CIP7: '3533642',
  CIP13: '3400935336422',
  ucdLib: "ZOMIGORO 2,5MG CPR DISP",
  UCD7: '9221033',
  UCD13: '3400892210339',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOMIGORO 2,5MG CPR DISP BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '3533665',
  CIP13: '3400935336651',
  ucdLib: "ZOMIGORO 2,5MG CPR DISP",
  UCD7: '9221033',
  UCD13: '3400892210339',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOMIGORO 2,5MG CPR DISP BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '3544309',
  CIP13: '3400935443090',
  ucdLib: "ZOMIG 2,5MG CPR + POCHT",
  UCD7: '9201912',
  UCD13: '3400892019123',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOMIG 2,5MG CPR + POCHT BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '3753326',
  CIP13: '3400937533263',
  ucdLib: "ZOLMITRIPTAN EVO 2,5MG CPR",
  UCD7: '9362578',
  UCD13: '3400893625781',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN EVO 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '3753332',
  CIP13: '3400937533324',
  ucdLib: "ZOLMITRIPTAN EVO 2,5MG CPR",
  UCD7: '9362578',
  UCD13: '3400893625781',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN EVO 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '3753987',
  CIP13: '3400937539876',
  ucdLib: "ZOLMITRIPTAN ZYF 2,5MG CPR",
  UCD7: '9360088',
  UCD13: '3400893600887',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN ZYF 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '3753993',
  CIP13: '3400937539937',
  ucdLib: "ZOLMITRIPTAN ZYF 2,5MG CPR",
  UCD7: '9360088',
  UCD13: '3400893600887',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN ZYF 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '3445398',
  CIP13: '3400934453984',
  ucdLib: "ZOMIG 2,5MG CPR + POCHT",
  UCD7: '9201912',
  UCD13: '3400892019123',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOMIG 2,5MG CPR + POCHT BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4975342',
  CIP13: '3400949753420',
  ucdLib: "ZOLMITRIPTAN ARG 2,5MG C.DISP",
  UCD7: '9367908',
  UCD13: '3400893679081',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN ARG 2,5MG C.DISP BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4975365',
  CIP13: '3400949753659',
  ucdLib: "ZOLMITRIPTAN ARG 2,5MG C.DISP",
  UCD7: '9367908',
  UCD13: '3400893679081',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN ARG 2,5MG C.DISP BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '4975187',
  CIP13: '3400949751877',
  ucdLib: "ZOLMITRIPTAN ARG 2,5MG CPR",
  UCD7: '9367914',
  UCD13: '3400893679142',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN ARG 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4975193',
  CIP13: '3400949751938',
  ucdLib: "ZOLMITRIPTAN ARG 2,5MG CPR",
  UCD7: '9367914',
  UCD13: '3400893679142',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN ARG 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '4975081',
  CIP13: '3400949750818',
  ucdLib: "ZOLMITRIPTAN BGA 2,5MG CPR",
  UCD7: '9367883',
  UCD13: '3400893678831',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN BGA 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4975098',
  CIP13: '3400949750986',
  ucdLib: "ZOLMITRIPTAN BGA 2,5MG CPR",
  UCD7: '9367883',
  UCD13: '3400893678831',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN BGA 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '3919212',
  CIP13: '3400939192123',
  ucdLib: "ZOLMITRIPTAN EVO 2,5MG C.DISP",
  UCD7: '9362561',
  UCD13: '3400893625613',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN EVO 2,5MG C.DISP BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '3919330',
  CIP13: '3400939193304',
  ucdLib: "ZOLMITRIPTAN EVO 2,5MG C.DISP",
  UCD7: '9362561',
  UCD13: '3400893625613',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN EVO 2,5MG C.DISP BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '4975017',
  CIP13: '3400949750177',
  ucdLib: "ZOLMITRIPTAN RBX 2,5MG C.DISP",
  UCD7: '9367877',
  UCD13: '3400893678770',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN RBX 2,5MG C.DISP BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4975046',
  CIP13: '3400949750467',
  ucdLib: "ZOLMITRIPTAN RBX 2,5MG C.DISP",
  UCD7: '9367877',
  UCD13: '3400893678770',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN RBX 2,5MG C.DISP BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '2219872',
  CIP13: '3400922198729',
  ucdLib: "ZOLMITRIPTAN SDZ 2,5MG C.DIS",
  UCD7: '9385036',
  UCD13: '3400893850367',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN SDZ 2,5MG C.DIS BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '2219889',
  CIP13: '3400922198897',
  ucdLib: "ZOLMITRIPTAN SDZ 2,5MG C.DIS",
  UCD7: '9385036',
  UCD13: '3400893850367',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN SDZ 2,5MG C.DIS BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '2218335',
  CIP13: '3400922183350',
  ucdLib: "ZOLMITRIPTAN SDZ 2,5MG CPR",
  UCD7: '9385042',
  UCD13: '3400893850428',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN SDZ 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '2218341',
  CIP13: '3400922183411',
  ucdLib: "ZOLMITRIPTAN SDZ 2,5MG CPR",
  UCD7: '9385042',
  UCD13: '3400893850428',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN SDZ 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '4975282',
  CIP13: '3400949752829',
  ucdLib: "ZOLMITRIPTAN TVS 2,5MG C.DISP",
  UCD7: '9367920',
  UCD13: '3400893679203',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN TVS 2,5MG C.DISP BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4975307',
  CIP13: '3400949753079',
  ucdLib: "ZOLMITRIPTAN TVS 2,5MG C.DISP",
  UCD7: '9367920',
  UCD13: '3400893679203',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN TVS 2,5MG C.DISP BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '4975230',
  CIP13: '3400949752300',
  ucdLib: "ZOLMITRIPTAN TVS 2,5MG CPR",
  UCD7: '9367937',
  UCD13: '3400893679371',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN TVS 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4975247',
  CIP13: '3400949752478',
  ucdLib: "ZOLMITRIPTAN TVS 2,5MG CPR",
  UCD7: '9367937',
  UCD13: '3400893679371',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN TVS 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '3919169',
  CIP13: '3400939191690',
  ucdLib: "ZOLMITRIPTAN ZYF 2,5MG C.DISP",
  UCD7: '9360071',
  UCD13: '3400893600719',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN ZYF 2,5MG C.DISP BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '3919181',
  CIP13: '3400939191812',
  ucdLib: "ZOLMITRIPTAN ZYF 2,5MG C.DISP",
  UCD7: '9360071',
  UCD13: '3400893600719',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN ZYF 2,5MG C.DISP BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '2197449',
  CIP13: '3400921974492',
  ucdLib: "ZOLMITRIPTAN MYL 2,5MG C.DIS",
  UCD7: '9382138',
  UCD13: '3400893821381',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN MYL 2,5MG C.DIS BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '2197478',
  CIP13: '3400921974782',
  ucdLib: "ZOLMITRIPTAN MYL 2,5MG C.DIS",
  UCD7: '9382138',
  UCD13: '3400893821381',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN MYL 2,5MG C.DIS BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '2198259',
  CIP13: '3400921982596',
  ucdLib: "ZOLMITRIPTAN MYL 2,5MG CPR",
  UCD7: '9382144',
  UCD13: '3400893821442',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN MYL 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '2198265',
  CIP13: '3400921982657',
  ucdLib: "ZOLMITRIPTAN MYL 2,5MG CPR",
  UCD7: '9382144',
  UCD13: '3400893821442',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN MYL 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '4172005',
  CIP13: '3400941720055',
  ucdLib: "ZOLMITRIPTAN ZEN 2,5MG C.DIS",
  UCD7: '9376818',
  UCD13: '3400893768181',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN ZEN 2,5MG C.DIS BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4172034',
  CIP13: '3400941720345',
  ucdLib: "ZOLMITRIPTAN ZEN 2,5MG C.DIS",
  UCD7: '9376818',
  UCD13: '3400893768181',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN ZEN 2,5MG C.DIS BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '4172092',
  CIP13: '3400941720925',
  ucdLib: "ZOLMITRIPTAN ZEN 2,5MG CPR",
  UCD7: '9376824',
  UCD13: '3400893768242',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN ZEN 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4172117',
  CIP13: '3400941721175',
  ucdLib: "ZOLMITRIPTAN ZEN 2,5MG CPR",
  UCD7: '9376824',
  UCD13: '3400893768242',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN ZEN 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '4924712',
  CIP13: '3400949247127',
  ucdLib: "ZOLMITRIPTAN BGA 2,5MG C.DISP",
  UCD7: '9358766',
  UCD13: '3400893587669',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN BGA 2,5MG C.DISP BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '4924729',
  CIP13: '3400949247295',
  ucdLib: "ZOLMITRIPTAN BGA 2,5MG C.DISP",
  UCD7: '9358766',
  UCD13: '3400893587669',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN BGA 2,5MG C.DISP BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '2245384',
  CIP13: '3400922453842',
  ucdLib: "ZOLMITRIPTAN CRT 2,5MG C.DIS",
  UCD7: '9388690',
  UCD13: '3400893886908',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN CRT 2,5MG C.DIS BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '2179078',
  CIP13: '3400921790788',
  ucdLib: "ZOLMITRIPTAN EG 2,5MG C.DISP",
  UCD7: '9380197',
  UCD13: '3400893801970',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN EG 2,5MG C.DISP BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '2179090',
  CIP13: '3400921790900',
  ucdLib: "ZOLMITRIPTAN EG 2,5MG C.DISP",
  UCD7: '9380197',
  UCD13: '3400893801970',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN EG 2,5MG C.DISP BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '2179003',
  CIP13: '3400921790030',
  ucdLib: "ZOLMITRIPTAN EG 2,5MG CPR",
  UCD7: '9380180',
  UCD13: '3400893801802',
  ucdQtyMultiplicator: 6,
  cipLib: "ZOLMITRIPTAN EG 2,5MG CPR BT 6",
  atcCode: "N02CC03"
}, {
  CIP7: '2179026',
  CIP13: '3400921790269',
  ucdLib: "ZOLMITRIPTAN EG 2,5MG CPR",
  UCD7: '9380180',
  UCD13: '3400893801802',
  ucdQtyMultiplicator: 12,
  cipLib: "ZOLMITRIPTAN EG 2,5MG CPR BT 12",
  atcCode: "N02CC03"
}, {
  CIP7: '3439423',
  CIP13: '3400934394232',
  ucdLib: "NARAMIG 2,5MG CPR",
  UCD7: '9202544',
  UCD13: '3400892025445',
  ucdQtyMultiplicator: 6,
  cipLib: "NARAMIG 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '3554673',
  CIP13: '3400935546739',
  ucdLib: "NARATRIPTAN SDZ 2,5MG CPR",
  UCD7: '9352278',
  UCD13: '3400893522783',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN SDZ 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '3554696',
  CIP13: '3400935546968',
  ucdLib: "NARATRIPTAN SDZ 2,5MG CPR",
  UCD7: '9352278',
  UCD13: '3400893522783',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN SDZ 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '3464220',
  CIP13: '3400934642203',
  ucdLib: "NARAMIG 2,5MG CPR",
  UCD7: '9202544',
  UCD13: '3400892025445',
  ucdQtyMultiplicator: 12,
  cipLib: "NARAMIG 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '3861398',
  CIP13: '3400938613988',
  ucdLib: "NARATRIPTAN TVC 2,5MG CPR",
  UCD7: '9320315',
  UCD13: '3400893203156',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN TVC 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '3861406',
  CIP13: '3400938614060',
  ucdLib: "NARATRIPTAN TVC 2,5MG CPR",
  UCD7: '9320315',
  UCD13: '3400893203156',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN TVC 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '4939323',
  CIP13: '3400949393237',
  ucdLib: "NARATRIPTAN ARW 2,5MG CPR",
  UCD7: '9361627',
  UCD13: '3400893616277',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN ARW 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '4939352',
  CIP13: '3400949393527',
  ucdLib: "NARATRIPTAN ARW 2,5MG CPR",
  UCD7: '9361627',
  UCD13: '3400893616277',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN ARW 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '4939197',
  CIP13: '3400949391974',
  ucdLib: "NARATRIPTAN BGA 2,5MG CPR",
  UCD7: '9361604',
  UCD13: '3400893616048',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN BGA 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '4939211',
  CIP13: '3400949392117',
  ucdLib: "NARATRIPTAN BGA 2,5MG CPR",
  UCD7: '9361604',
  UCD13: '3400893616048',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN BGA 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '4936299',
  CIP13: '3400949362998',
  ucdLib: "NARATRIPTAN EG 2,5MG CPR",
  UCD7: '9361610',
  UCD13: '3400893616109',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN EG 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '4936313',
  CIP13: '3400949363131',
  ucdLib: "NARATRIPTAN EG 2,5MG CPR",
  UCD7: '9361610',
  UCD13: '3400893616109',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN EG 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '4182239',
  CIP13: '3400941822391',
  ucdLib: "NARATRIPTAN MYL 2,5MG CPR",
  UCD7: '9379219',
  UCD13: '3400893792193',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN MYL 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '4182245',
  CIP13: '3400941822452',
  ucdLib: "NARATRIPTAN MYL 2,5MG CPR",
  UCD7: '9379219',
  UCD13: '3400893792193',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN MYL 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '4188087',
  CIP13: '3400941880872',
  ucdLib: "NARATRIPTAN RBX 2,5MG CPR",
  UCD7: '9380412',
  UCD13: '3400893804124',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN RBX 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '4188093',
  CIP13: '3400941880933',
  ucdLib: "NARATRIPTAN RBX 2,5MG CPR",
  UCD7: '9380412',
  UCD13: '3400893804124',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN RBX 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '2181508',
  CIP13: '3400921815085',
  ucdLib: "NARATRIPTAN ZEN 2,5MG CPR",
  UCD7: '9380406',
  UCD13: '3400893804063',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN ZEN 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '2181514',
  CIP13: '3400921815146',
  ucdLib: "NARATRIPTAN ZEN 2,5MG CPR",
  UCD7: '9380406',
  UCD13: '3400893804063',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN ZEN 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '4188213',
  CIP13: '3400941882135',
  ucdLib: "NARATRIPTAN ZYD 2,5MG CPR",
  UCD7: '9383741',
  UCD13: '3400893837412',
  ucdQtyMultiplicator: 6,
  cipLib: "NARATRIPTAN ZYD 2,5MG CPR BT 6",
  atcCode: "N02CC02"
}, {
  CIP7: '4188236',
  CIP13: '3400941882364',
  ucdLib: "NARATRIPTAN ZYD 2,5MG CPR",
  UCD7: '9383741',
  UCD13: '3400893837412',
  ucdQtyMultiplicator: 12,
  cipLib: "NARATRIPTAN ZYD 2,5MG CPR BT 12",
  atcCode: "N02CC02"
}, {
  CIP7: '3338774',
  CIP13: '3400933387747',
  ucdLib: "IMIGRANE 6MG/0,5ML SER+A-INJ",
  UCD7: '9164370',
  UCD13: '3400891643701',
  ucdQtyMultiplicator: 2,
  cipLib: "IMIGRANE 6MG/0,5ML SER+A-INJ BT 2",
  atcCode: "N02CC01"
}, {
  CIP7: '3338745',
  CIP13: '3400933387457',
  ucdLib: "IMIGRANE 6MG/0,5ML SERING",
  UCD7: '9164364',
  UCD13: '3400891643640',
  ucdQtyMultiplicator: 2,
  cipLib: "IMIGRANE 6MG/0,5ML SERING BT 2",
  atcCode: "N02CC01"
}, {
  CIP7: '3378288',
  CIP13: '3400933782887',
  ucdLib: "IMIJECT 6MG/0,5ML SER+A-INJ",
  UCD7: '9169976',
  UCD13: '3400891699760',
  ucdQtyMultiplicator: 2,
  cipLib: "IMIJECT 6MG/0,5ML SER+A-INJ BT 2",
  atcCode: "N02CC01"
}, {
  CIP7: '3378259',
  CIP13: '3400933782597',
  ucdLib: "IMIJECT 6MG/0,5ML SERING",
  UCD7: '9169953',
  UCD13: '3400891699531',
  ucdQtyMultiplicator: 2,
  cipLib: "IMIJECT 6MG/0,5ML SERING BT 2",
  atcCode: "N02CC01"
}, {
  CIP7: '3433834',
  CIP13: '3400934338342',
  ucdLib: "IMIGRANE 10MG PULV NAS AMP",
  UCD7: '9212270',
  UCD13: '3400892122700',
  ucdQtyMultiplicator: 2,
  cipLib: "IMIGRANE 10MG PULV NAS AMP BT 2",
  atcCode: "N02CC01"
}, {
  CIP7: '3433811',
  CIP13: '3400934338113',
  ucdLib: "IMIGRANE 20MG PULV NAS AMP",
  UCD7: '9212287',
  UCD13: '3400892122878',
  ucdQtyMultiplicator: 6,
  cipLib: "IMIGRANE 20MG PULV NAS AMP BT 6",
  atcCode: "N02CC01"
}, {
  CIP7: '3473704',
  CIP13: '3400934737046',
  ucdLib: "IMIGRANE 50MG CPR",
  UCD7: '9210992',
  UCD13: '3400892109923',
  ucdQtyMultiplicator: 6,
  cipLib: "IMIGRANE 50MG CPR BT 6",
  atcCode: "N02CC01"
}, {
  CIP7: '3797996',
  CIP13: '3400937979962',
  ucdLib: "SUMATRIPTAN TVC 50MG CPR",
  UCD7: '9306373',
  UCD13: '3400893063736',
  ucdQtyMultiplicator: 6,
  cipLib: "SUMATRIPTAN TVC 50MG CPR BT 6",
  atcCode: "N02CC01"
}, {
  CIP7: '4926906',
  CIP13: '3400949269068',
  ucdLib: "SUMATRIPTAN SUN 6MG/0,5ML SRG",
  UCD7: '9359837',
  UCD13: '3400893598375',
  ucdQtyMultiplicator: 2,
  cipLib: "SUMATRIPTAN SUN 6MG/0,5ML SRG BT 2",
  atcCode: "N02CC01"
}, {
  CIP7: '3046787',
  CIP13: '3400930467879',
  ucdLib: "GYNERGENE CAFEINE CPR",
  UCD7: '9041176',
  UCD13: '3400890411769',
  ucdQtyMultiplicator: 20,
  cipLib: "GYNERGENE CAFEINE CPR BT 20",
  atcCode: "N02CA52"
}, {
  CIP7: '3643833',
  CIP13: '3400936438330',
  ucdLib: "DHE AMD 1MG/ML INJ AMP1ML",
  UCD7: '9270474',
  UCD13: '3400892704746',
  ucdQtyMultiplicator: 2,
  cipLib: "DHE AMD 1MG/ML INJ AMP1ML BT 2",
  atcCode: "N02CA01"
}, {
  CIP7: '3473822',
  CIP13: '3400934738227',
  ucdLib: "DIERGOSPRAY 4MG/ML NAS FL1ML",
  UCD7: '9216658',
  UCD13: '3400892166582',
  ucdQtyMultiplicator: 1,
  cipLib: "DIERGOSPRAY 4MG/ML NAS FL1ML BT 1",
  atcCode: "N02CA01"
}, {
  CIP7: '5697276',
  CIP13: '3400956972760',
  ucdLib: "PRIALT 100MCG/ML PERF FL1ML",
  UCD7: '9306870',
  UCD13: '3400893068700',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIALT 100MCG/ML PERF FL1ML BT 1",
  atcCode: "N02BG08"
}, {
  CIP7: '5697299',
  CIP13: '3400956972999',
  ucdLib: "PRIALT 100MCG/ML PERF FL5ML",
  UCD7: '9306887',
  UCD13: '3400893068878',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIALT 100MCG/ML PERF FL5ML BT 1",
  atcCode: "N02BG08"
}, {
  CIP7: '3001195',
  CIP13: '3400930011959',
  ucdLib: "NEFOPAM MSO 20MG/2ML INJ AMP",
  UCD7: '9407163',
  UCD13: '3400894071631',
  ucdQtyMultiplicator: 10,
  cipLib: "NEFOPAM MSO 20MG/2ML INJ AMP BT 10",
  atcCode: "N02BG06"
}, {
  CIP7: '3242175',
  CIP13: '3400932421756',
  ucdLib: "ACUPAN 20MG INJ AMP2ML",
  UCD7: '9001047',
  UCD13: '3400890010474',
  ucdQtyMultiplicator: 5,
  cipLib: "ACUPAN 20MG INJ AMP2ML BT 5",
  atcCode: "N02BG06"
}, {
  CIP7: '3587661',
  CIP13: '3400935876614',
  ucdLib: "NEFOPAM MYL 20MG/2ML INJ AMP",
  UCD7: '9348555',
  UCD13: '3400893485552',
  ucdQtyMultiplicator: 10,
  cipLib: "NEFOPAM MYL 20MG/2ML INJ AMP BT 10",
  atcCode: "N02BG06"
}, {
  CIP7: '4942087',
  CIP13: '3400949420872',
  ucdLib: "ACUPAN 20MG INJ AMP2ML",
  UCD7: '9001047',
  UCD13: '3400890010474',
  ucdQtyMultiplicator: 20,
  cipLib: "ACUPAN 20MG INJ AMP2ML BT 20",
  atcCode: "N02BG06"
}, {
  CIP7: '3458366',
  CIP13: '3400934583667',
  ucdLib: "ALGOTROPYL SUP",
  UCD7: '9208937',
  UCD13: '3400892089379',
  ucdQtyMultiplicator: 10,
  cipLib: "ALGOTROPYL SUP BT 10",
  atcCode: "N02BE51"
}, {
  CIP7: '3617149',
  CIP13: '3400936171497',
  ucdLib: "PRONTALGINE CPR",
  UCD7: '9076134',
  UCD13: '3400890761345',
  ucdQtyMultiplicator: 18,
  cipLib: "PRONTALGINE CPR BT 18",
  atcCode: "N02BE51"
}, {
  CIP7: '3320797',
  CIP13: '3400933207977',
  ucdLib: "CLARADOL 500MG CAFEINE EFFV",
  UCD7: '9170519',
  UCD13: '3400891705195',
  ucdQtyMultiplicator: 16,
  cipLib: "CLARADOL 500MG CAFEINE EFFV BT 16",
  atcCode: "N02BE51"
}, {
  CIP7: '3293534',
  CIP13: '3400932935345',
  ucdLib: "CLARADOL 500MG CAFEINE CPR",
  UCD7: '9123425',
  UCD13: '3400891234251',
  ucdQtyMultiplicator: 16,
  cipLib: "CLARADOL 500MG CAFEINE CPR BT 16",
  atcCode: "N02BE51"
}, {
  CIP7: '3105030',
  CIP13: '3400931050308',
  ucdLib: "THEINOL BUV SOL FV125ML",
  UCD7: '9091984',
  UCD13: '3400890919845',
  ucdQtyMultiplicator: 1,
  cipLib: "THEINOL BUV SOL FV125ML BT 1",
  atcCode: "N02BE51"
}, {
  CIP7: '3246658',
  CIP13: '3400932466580',
  ucdLib: "CEFALINE HTH PDR SACH",
  UCD7: '9017172',
  UCD13: '3400890171724',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFALINE HTH PDR SACH BT 10",
  atcCode: "N02BE51"
}, {
  CIP7: '3378236',
  CIP13: '3400933782368',
  ucdLib: "CEFALINE HTH 500/50MG CPR",
  UCD7: '9195459',
  UCD13: '3400891954593',
  ucdQtyMultiplicator: 16,
  cipLib: "CEFALINE HTH 500/50MG CPR BT 16",
  atcCode: "N02BE51"
}, {
  CIP7: '3430072',
  CIP13: '3400934300721',
  ucdLib: "ALGODOL CAFEINE CPR",
  UCD7: '9226622',
  UCD13: '3400892266220',
  ucdQtyMultiplicator: 16,
  cipLib: "ALGODOL CAFEINE CPR BT 16",
  atcCode: "N02BE51"
}, {
  CIP7: '3434874',
  CIP13: '3400934348747',
  ucdLib: "MIGRALGINE GELU",
  UCD7: '9059006',
  UCD13: '3400890590068',
  ucdQtyMultiplicator: 12,
  cipLib: "MIGRALGINE GELU BT 12",
  atcCode: "N02BE51"
}, {
  CIP7: '3434880',
  CIP13: '3400934348808',
  ucdLib: "MIGRALGINE GELU",
  UCD7: '9059006',
  UCD13: '3400890590068',
  ucdQtyMultiplicator: 18,
  cipLib: "MIGRALGINE GELU BT 18",
  atcCode: "N02BE51"
}, {
  CIP7: '3515495',
  CIP13: '3400935154958',
  ucdLib: "LAMALINE GELU",
  UCD7: '9102995',
  UCD13: '3400891029956',
  ucdQtyMultiplicator: 16,
  cipLib: "LAMALINE GELU BT 16",
  atcCode: "N02BE51"
}, {
  CIP7: '3517301',
  CIP13: '3400935173010',
  ucdLib: "LAMALINE SUP",
  UCD7: '9103003',
  UCD13: '3400891030037',
  ucdQtyMultiplicator: 10,
  cipLib: "LAMALINE SUP BT 10",
  atcCode: "N02BE51"
}, {
  CIP7: '3766501',
  CIP13: '3400937665018',
  ucdLib: "DOLIPRANEVITAMINEC CPR EFFV",
  UCD7: '9331460',
  UCD13: '3400893314609',
  ucdQtyMultiplicator: 16,
  cipLib: "DOLIPRANEVITAMINEC CPR EFFV BT 16",
  atcCode: "N02BE51"
}, {
  CIP7: '3637324',
  CIP13: '3400936373242',
  ucdLib: "EFFERALGAN VIT C 500/200 EFFV",
  UCD7: '9296083',
  UCD13: '3400892960838',
  ucdQtyMultiplicator: 16,
  cipLib: "EFFERALGAN VIT C 500/200 EFFV BT 16",
  atcCode: "N02BE51"
}, {
  CIP7: '3771034',
  CIP13: '3400937710343',
  ucdLib: "COQUELUSEDAL PARACET.100 SUP",
  UCD7: '9122443',
  UCD13: '3400891224436',
  ucdQtyMultiplicator: 10,
  cipLib: "COQUELUSEDAL PARACET.100 SUP BT 10",
  atcCode: "N02BE51"
}, {
  CIP7: '3921172',
  CIP13: '3400939211725',
  ucdLib: "COQUELUSEDAL PARACET.250 SUP",
  UCD7: '9338568',
  UCD13: '3400893385685',
  ucdQtyMultiplicator: 10,
  cipLib: "COQUELUSEDAL PARACET.250 SUP BT 10",
  atcCode: "N02BE51"
}, {
  CIP7: '5500318',
  CIP13: '3400955003182',
  ucdLib: "IZALGI 500MG/25MG GELU",
  UCD7: '9391261',
  UCD13: '3400893912614',
  ucdQtyMultiplicator: 100,
  cipLib: "IZALGI 500MG/25MG GELU BT 100",
  atcCode: "N02BE51"
}, {
  CIP7: '3953870',
  CIP13: '3400939538709',
  ucdLib: "COQUELUSEDAL PARACET.500 SUP",
  UCD7: '9122420',
  UCD13: '3400891224207',
  ucdQtyMultiplicator: 10,
  cipLib: "COQUELUSEDAL PARACET.500 SUP BT 10",
  atcCode: "N02BE51"
}, {
  CIP7: '4960553',
  CIP13: '3400949605538',
  ucdLib: "IZALGI 500MG/25MG GELU",
  UCD7: '9391261',
  UCD13: '3400893912614',
  ucdQtyMultiplicator: 16,
  cipLib: "IZALGI 500MG/25MG GELU BT 16",
  atcCode: "N02BE51"
}, {
  CIP7: '3450778',
  CIP13: '3400934507786',
  ucdLib: "DOLIPRANE 500MG GELU",
  UCD7: '9199612',
  UCD13: '3400891996128',
  ucdQtyMultiplicator: 16,
  cipLib: "DOLIPRANE 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3615883',
  CIP13: '3400936158832',
  ucdLib: "DAFALGAN 1G CPR PELLIC",
  UCD7: '9248807',
  UCD13: '3400892488073',
  ucdQtyMultiplicator: 8,
  cipLib: "DAFALGAN 1G CPR PELLIC BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '5547335',
  CIP13: '3400955473350',
  ucdLib: "DOLIPRANE 500MG CPR",
  UCD7: '9028218',
  UCD13: '3400890282185',
  ucdQtyMultiplicator: 100,
  cipLib: "DOLIPRANE 500MG CPR BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '3613335',
  CIP13: '3400936133358',
  ucdLib: "PARACETAMOL BGA 500MG C.EFFV",
  UCD7: '9249787',
  UCD13: '3400892497877',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL BGA 500MG C.EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3610124',
  CIP13: '3400936101241',
  ucdLib: "PARACETAMOL MYL 1000MG C.EFFV",
  UCD7: '9258450',
  UCD13: '3400892584508',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL MYL 1000MG C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3611508',
  CIP13: '3400936115088',
  ucdLib: "PARACETAMOL TVC 500MG CPR",
  UCD7: '9245298',
  UCD13: '3400892452982',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL TVC 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3000617',
  CIP13: '3400930006177',
  ucdLib: "EFFERALGAN 1000MG GLE SACH",
  UCD7: '9409127',
  UCD13: '3400894091271',
  ucdQtyMultiplicator: 8,
  cipLib: "EFFERALGAN 1000MG GLE SACH BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3000606',
  CIP13: '3400930006061',
  ucdLib: "EFFERALGAN 250MG GLE SACH",
  UCD7: '9409133',
  UCD13: '3400894091332',
  ucdQtyMultiplicator: 10,
  cipLib: "EFFERALGAN 250MG GLE SACH BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3000612',
  CIP13: '3400930006122',
  ucdLib: "EFFERALGAN 500MG GLE SACH",
  UCD7: '9409156',
  UCD13: '3400894091561',
  ucdQtyMultiplicator: 16,
  cipLib: "EFFERALGAN 500MG GLE SACH BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3003622',
  CIP13: '3400930036228',
  ucdLib: "PARACETAMOL BGA 1G CPR",
  UCD7: '9262374',
  UCD13: '3400892623740',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL BGA 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3004322',
  CIP13: '3400930043226',
  ucdLib: "PARACETAMOL BGA 500MG CPR",
  UCD7: '9195790',
  UCD13: '3400891957907',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL BGA 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3004066',
  CIP13: '3400930040669',
  ucdLib: "PARACETAMOL MYL 1G CPR",
  UCD7: '9310995',
  UCD13: '3400893109953',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL MYL 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3002078',
  CIP13: '3400930020784',
  ucdLib: "PARACETAMOL MYL 500MG CPR",
  UCD7: '9206401',
  UCD13: '3400892064017',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL MYL 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3000799',
  CIP13: '3400930007990',
  ucdLib: "PARACETAMOL MYL 500MG GELU",
  UCD7: '9258467',
  UCD13: '3400892584676',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL MYL 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3273649',
  CIP13: '3400932736492',
  ucdLib: "CLARADOL 500MG CPR EFFV",
  UCD7: '9102529',
  UCD13: '3400891025293',
  ucdQtyMultiplicator: 16,
  cipLib: "CLARADOL 500MG CPR EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '5553063',
  CIP13: '3400955530633',
  ucdLib: "DAFALGAN 500MG GELU",
  UCD7: '9023824',
  UCD13: '3400890238243',
  ucdQtyMultiplicator: 100,
  cipLib: "DAFALGAN 500MG GELU BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '3273655',
  CIP13: '3400932736553',
  ucdLib: "DAFALGAN 600MG ADULTE SUP",
  UCD7: '9104422',
  UCD13: '3400891044225',
  ucdQtyMultiplicator: 10,
  cipLib: "DAFALGAN 600MG ADULTE SUP BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3574256',
  CIP13: '3400935742568',
  ucdLib: "PARACETAMOL ALM 500MG CPR",
  UCD7: '9272444',
  UCD13: '3400892724447',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ALM 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3292227',
  CIP13: '3400932922277',
  ucdLib: "PARACETAMOL BGA 500MG GELU",
  UCD7: '9195809',
  UCD13: '3400891958096',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL BGA 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3571393',
  CIP13: '3400935713933',
  ucdLib: "PARACETAMOL ISD 500MG CPR",
  UCD7: '9319105',
  UCD13: '3400893191057',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ISD 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3571387',
  CIP13: '3400935713872',
  ucdLib: "PARACETAMOL RTP 500MG CPR",
  UCD7: '9234627',
  UCD13: '3400892346274',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL RTP 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3290205',
  CIP13: '3400932902057',
  ucdLib: "PARALYOC 500MG LYOT ORAL",
  UCD7: '9130359',
  UCD13: '3400891303599',
  ucdQtyMultiplicator: 16,
  cipLib: "PARALYOC 500MG LYOT ORAL BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3232018',
  CIP13: '3400932320189',
  ucdLib: "DOLIPRANE 500MG CPR",
  UCD7: '9028218',
  UCD13: '3400890282185',
  ucdQtyMultiplicator: 16,
  cipLib: "DOLIPRANE 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3233153',
  CIP13: '3400932331536',
  ucdLib: "DOLIPRANE 500MG PDR SACH",
  UCD7: '9028247',
  UCD13: '3400890282475',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLIPRANE 500MG PDR SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '5866885',
  CIP13: '3400958668852',
  ucdLib: "PARACET.MAC10MG/ML P10ML PREL",
  UCD7: '9404118',
  UCD13: '3400894041184',
  ucdQtyMultiplicator: 20,
  cipLib: "PARACET.MAC10MG/ML P10ML PREL BT 20",
  atcCode: "N02BE01"
}, {
  CIP7: '3267904',
  CIP13: '3400932679041',
  ucdLib: "DAFALGAN 500MG GELU",
  UCD7: '9023824',
  UCD13: '3400890238243',
  ucdQtyMultiplicator: 16,
  cipLib: "DAFALGAN 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3256757',
  CIP13: '3400932567577',
  ucdLib: "EFFERALGANMED 500MG CPR",
  UCD7: '9148388',
  UCD13: '3400891483888',
  ucdQtyMultiplicator: 16,
  cipLib: "EFFERALGANMED 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3257001',
  CIP13: '3400932570010',
  ucdLib: "EFFERALGANMED 500MG CPR EFFV",
  UCD7: '9030474',
  UCD13: '3400890304740',
  ucdQtyMultiplicator: 16,
  cipLib: "EFFERALGANMED 500MG CPR EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3258615',
  CIP13: '3400932586158',
  ucdLib: "GELUPRANE 500MG GELU",
  UCD7: '9169947',
  UCD13: '3400891699470',
  ucdQtyMultiplicator: 16,
  cipLib: "GELUPRANE 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3312941',
  CIP13: '3400933129415',
  ucdLib: "PARALYOC 250MG LYOT ORAL",
  UCD7: '9137634',
  UCD13: '3400891376340',
  ucdQtyMultiplicator: 10,
  cipLib: "PARALYOC 250MG LYOT ORAL BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3333251',
  CIP13: '3400933332518',
  ucdLib: "CLARADOL 500MG CPR",
  UCD7: '9170525',
  UCD13: '3400891705256',
  ucdQtyMultiplicator: 16,
  cipLib: "CLARADOL 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3307199',
  CIP13: '3400933071998',
  ucdLib: "DOLIPRANE 500MG CPR EFFV",
  UCD7: '9125660',
  UCD13: '3400891256604',
  ucdQtyMultiplicator: 16,
  cipLib: "DOLIPRANE 500MG CPR EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3304746',
  CIP13: '3400933047467',
  ucdLib: "DOLIPRANE AD. SUP",
  UCD7: '9129770',
  UCD13: '3400891297706',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLIPRANE AD. SUP BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3338811',
  CIP13: '3400933388119',
  ucdLib: "DOLKO 500MG CPR",
  UCD7: '9150238',
  UCD13: '3400891502381',
  ucdQtyMultiplicator: 16,
  cipLib: "DOLKO 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3338194',
  CIP13: '3400933381943',
  ucdLib: "DOLKO 60MG/2ML BUV FL90ML",
  UCD7: '9154242',
  UCD13: '3400891542424',
  ucdQtyMultiplicator: 1,
  cipLib: "DOLKO 60MG/2ML BUV FL90ML BT 1",
  atcCode: "N02BE01"
}, {
  CIP7: '3308483',
  CIP13: '3400933084837',
  ucdLib: "DOLKO AD 500MG BUV PDR SACH",
  UCD7: '9149554',
  UCD13: '3400891495546',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLKO AD 500MG BUV PDR SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '4911543',
  CIP13: '3400949115433',
  ucdLib: "PARACETAMOL ARW 500MG C.EFFV",
  UCD7: '9356419',
  UCD13: '3400893564196',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ARW 500MG C.EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '4917391',
  CIP13: '3400949173914',
  ucdLib: "PARATABS 500MG CPR DISP",
  UCD7: '9374096',
  UCD13: '3400893740965',
  ucdQtyMultiplicator: 12,
  cipLib: "PARATABS 500MG CPR DISP BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3376668',
  CIP13: '3400933766689',
  ucdLib: "PARACETAMOL EG 500MG GELU",
  UCD7: '9266797',
  UCD13: '3400892667973',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL EG 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3529103',
  CIP13: '3400935291035',
  ucdLib: "DAFALGAN 1G CPR EFFV",
  UCD7: '9354573',
  UCD13: '3400893545737',
  ucdQtyMultiplicator: 8,
  cipLib: "DAFALGAN 1G CPR EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3400390',
  CIP13: '3400934003905',
  ucdLib: "DAFALGAN 250MG PDR EFFV SACH",
  UCD7: '9187649',
  UCD13: '3400891876499',
  ucdQtyMultiplicator: 12,
  cipLib: "DAFALGAN 250MG PDR EFFV SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3529422',
  CIP13: '3400935294227',
  ucdLib: "DOLIPRANE 1000MG CPR EFFV",
  UCD7: '9216902',
  UCD13: '3400892169026',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLIPRANE 1000MG CPR EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3521202',
  CIP13: '3400935212023',
  ucdLib: "DOLIPRANEORODOZ 500MG C.DISP",
  UCD7: '9217824',
  UCD13: '3400892178240',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLIPRANEORODOZ 500MG C.DISP BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3529178',
  CIP13: '3400935291783',
  ucdLib: "EFFERALGANMED 1G CPR EFFV",
  UCD7: '9215819',
  UCD13: '3400892158198',
  ucdQtyMultiplicator: 8,
  cipLib: "EFFERALGANMED 1G CPR EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3403307',
  CIP13: '3400934033070',
  ucdLib: "PANADOL 500MG CPR PELLIC",
  UCD7: '9184556',
  UCD13: '3400891845563',
  ucdQtyMultiplicator: 16,
  cipLib: "PANADOL 500MG CPR PELLIC BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3673047',
  CIP13: '3400936730472',
  ucdLib: "DAFALGAN 500MG CPR",
  UCD7: '9356106',
  UCD13: '3400893561065',
  ucdQtyMultiplicator: 16,
  cipLib: "DAFALGAN 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3351639',
  CIP13: '3400933516390',
  ucdLib: "PARACETAMOL MYL 500MG CPR",
  UCD7: '9206401',
  UCD13: '3400892064017',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL MYL 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3673751',
  CIP13: '3400936737518',
  ucdLib: "PARACETAMOL ZTL 500MG CPR",
  UCD7: '9266811',
  UCD13: '3400892668116',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ZTL 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3559914',
  CIP13: '3400935599148',
  ucdLib: "ALGODOL 500MG CPR",
  UCD7: '9226639',
  UCD13: '3400892266398',
  ucdQtyMultiplicator: 16,
  cipLib: "ALGODOL 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3390562',
  CIP13: '3400933905620',
  ucdLib: "DAFALGAN 150MG PDR EFFV SACH",
  UCD7: '9175451',
  UCD13: '3400891754513',
  ucdQtyMultiplicator: 12,
  cipLib: "DAFALGAN 150MG PDR EFFV SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3390579',
  CIP13: '3400933905798',
  ucdLib: "DAFALGAN 150MG SUP",
  UCD7: '9175468',
  UCD13: '3400891754681',
  ucdQtyMultiplicator: 10,
  cipLib: "DAFALGAN 150MG SUP BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3390585',
  CIP13: '3400933905859',
  ucdLib: "DAFALGAN 300MG SUP",
  UCD7: '9175445',
  UCD13: '3400891754452',
  ucdQtyMultiplicator: 10,
  cipLib: "DAFALGAN 300MG SUP BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3390533',
  CIP13: '3400933905330',
  ucdLib: "DAFALGAN 80MG PDR EFFV SACH",
  UCD7: '9175474',
  UCD13: '3400891754742',
  ucdQtyMultiplicator: 12,
  cipLib: "DAFALGAN 80MG PDR EFFV SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3390556',
  CIP13: '3400933905569',
  ucdLib: "DAFALGAN 80MG SUP",
  UCD7: '9175480',
  UCD13: '3400891754803',
  ucdQtyMultiplicator: 10,
  cipLib: "DAFALGAN 80MG SUP BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3852531',
  CIP13: '3400938525311',
  ucdLib: "PARACETAMOL RBX 500MG GELU",
  UCD7: '9317968',
  UCD13: '3400893179680',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL RBX 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3558978',
  CIP13: '3400935589781',
  ucdLib: "PARACETAMOL ZYD 500MG CPR",
  UCD7: '9259538',
  UCD13: '3400892595382',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ZYD 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3625657',
  CIP13: '3400936256576',
  ucdLib: "DAFALGAN 500MG CPR EFFV",
  UCD7: '9354596',
  UCD13: '3400893545966',
  ucdQtyMultiplicator: 16,
  cipLib: "DAFALGAN 500MG CPR EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3519702',
  CIP13: '3400935197023',
  ucdLib: "DAFALGAN PEDIA.3% BUV FL90ML",
  UCD7: '9215185',
  UCD13: '3400892151854',
  ucdQtyMultiplicator: 1,
  cipLib: "DAFALGAN PEDIA.3% BUV FL90ML BT 1",
  atcCode: "N02BE01"
}, {
  CIP7: '3624698',
  CIP13: '3400936246980',
  ucdLib: "DOLIPRANE 1000MG BUV SACH",
  UCD7: '9262569',
  UCD13: '3400892625690',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLIPRANE 1000MG BUV SACH BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3595583',
  CIP13: '3400935955838',
  ucdLib: "DOLIPRANE 1000MG CPR",
  UCD7: '9239091',
  UCD13: '3400892390918',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLIPRANE 1000MG CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3480911',
  CIP13: '3400934809118',
  ucdLib: "DOLIPRANE 100MG SUP",
  UCD7: '9209693',
  UCD13: '3400892096933',
  ucdQtyMultiplicator: 10,
  cipLib: "DOLIPRANE 100MG SUP BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3480940',
  CIP13: '3400934809408',
  ucdLib: "DOLIPRANE 150MG SUP",
  UCD7: '9209701',
  UCD13: '3400892097015',
  ucdQtyMultiplicator: 10,
  cipLib: "DOLIPRANE 150MG SUP BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3480986',
  CIP13: '3400934809866',
  ucdLib: "DOLIPRANE 200MG SUP",
  UCD7: '9209718',
  UCD13: '3400892097183',
  ucdQtyMultiplicator: 10,
  cipLib: "DOLIPRANE 200MG SUP BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3481017',
  CIP13: '3400934810176',
  ucdLib: "DOLIPRANE 300MG SUP",
  UCD7: '9209724',
  UCD13: '3400892097244',
  ucdQtyMultiplicator: 10,
  cipLib: "DOLIPRANE 300MG SUP BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '3624669',
  CIP13: '3400936246690',
  ucdLib: "DOLKO 1G CPR",
  UCD7: '9258361',
  UCD13: '3400892583617',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLKO 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3482152',
  CIP13: '3400934821523',
  ucdLib: "EFFERALGAN 500MG CPR DISP",
  UCD7: '9205100',
  UCD13: '3400892051000',
  ucdQtyMultiplicator: 16,
  cipLib: "EFFERALGAN 500MG CPR DISP BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3599753',
  CIP13: '3400935997531',
  ucdLib: "PARACETAMOL BGA 1G C.EFFV",
  UCD7: '9246470',
  UCD13: '3400892464701',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL BGA 1G C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3655718',
  CIP13: '3400936557185',
  ucdLib: "PARACETAMOL EG 1000MG C.EFFV",
  UCD7: '9270899',
  UCD13: '3400892708997',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL EG 1000MG C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3627550',
  CIP13: '3400936275508',
  ucdLib: "PARACETAMOL MYL 500MG GELU",
  UCD7: '9258467',
  UCD13: '3400892584676',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL MYL 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3656847',
  CIP13: '3400936568471',
  ucdLib: "PARACETAMOL SDZ 500MG CPR",
  UCD7: '9264060',
  UCD13: '3400892640600',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL SDZ 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3461546',
  CIP13: '3400934615467',
  ucdLib: "DOLIPRANE 2,4% S/SUC BUV 100ML",
  UCD7: '9202805',
  UCD13: '3400892028057',
  ucdQtyMultiplicator: 1,
  cipLib: "DOLIPRANE 2,4% S/SUC BUV 100ML BT 1",
  atcCode: "N02BE01"
}, {
  CIP7: '5608261',
  CIP13: '3400956082612',
  ucdLib: "DOLIPRANE 500MG GELU",
  UCD7: '9199612',
  UCD13: '3400891996128',
  ucdQtyMultiplicator: 100,
  cipLib: "DOLIPRANE 500MG GELU BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '3705238',
  CIP13: '3400937052382',
  ucdLib: "PARACETAMOL ALM 1G CPR",
  UCD7: '9290761',
  UCD13: '3400892907611',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ALM 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3581753',
  CIP13: '3400935817532',
  ucdLib: "PARACETAMOL ARW 500MG CPR",
  UCD7: '9237815',
  UCD13: '3400892378152',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ARW 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3584817',
  CIP13: '3400935848178',
  ucdLib: "PARACETAMOL EG 500MG C.EFFV",
  UCD7: '9265668',
  UCD13: '3400892656687',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL EG 500MG C.EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3549910',
  CIP13: '3400935499103',
  ucdLib: "PARACETAMOL MYL 500MG C.EFFV",
  UCD7: '9251494',
  UCD13: '3400892514949',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL MYL 500MG C.EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3818037',
  CIP13: '3400938180374',
  ucdLib: "PARACETAMOL ALT 1G CPR",
  UCD7: '9314065',
  UCD13: '3400893140659',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ALT 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3633668',
  CIP13: '3400936336681',
  ucdLib: "PARACETAMOL ARW 1G C.EFFV",
  UCD7: '9260056',
  UCD13: '3400892600567',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ARW 1G C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3638157',
  CIP13: '3400936381575',
  ucdLib: "PARACETAMOL ARW 1G CPR",
  UCD7: '9262138',
  UCD13: '3400892621388',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ARW 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3638186',
  CIP13: '3400936381865',
  ucdLib: "PARACETAMOL BGA 1G CPR",
  UCD7: '9262374',
  UCD13: '3400892623740',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL BGA 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3819806',
  CIP13: '3400938198065',
  ucdLib: "PARACETAMOL CRT 1G CPR",
  UCD7: '9323271',
  UCD13: '3400893232712',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL CRT 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3819686',
  CIP13: '3400938196863',
  ucdLib: "PARACETAMOL CRT 500MG CPR",
  UCD7: '9323288',
  UCD13: '3400893232880',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL CRT 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3638192',
  CIP13: '3400936381926',
  ucdLib: "PARACETAMOL EG 1G CPR",
  UCD7: '9262807',
  UCD13: '3400892628073',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL EG 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3819723',
  CIP13: '3400938197235',
  ucdLib: "PARACETAMOL EVO 1G CPR",
  UCD7: '9384479',
  UCD13: '3400893844793',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL EVO 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3819829',
  CIP13: '3400938198294',
  ucdLib: "PARACETAMOL MYL 1G CPR",
  UCD7: '9310995',
  UCD13: '3400893109953',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL MYL 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3696479',
  CIP13: '3400936964792',
  ucdLib: "PARACETAMOL RTP 1000MG C.EFFV",
  UCD7: '9282678',
  UCD13: '3400892826783',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL RTP 1000MG C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3638200',
  CIP13: '3400936382008',
  ucdLib: "PARACETAMOL RTP 1G CPR",
  UCD7: '9262629',
  UCD13: '3400892626291',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL RTP 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3696462',
  CIP13: '3400936964624',
  ucdLib: "PARACETAMOL RTP 500MG C.EFFV",
  UCD7: '9282684',
  UCD13: '3400892826844',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL RTP 500MG C.EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3694612',
  CIP13: '3400936946125',
  ucdLib: "PARACETAMOL SDZ 1G CPR",
  UCD7: '9278174',
  UCD13: '3400892781747',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL SDZ 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3631830',
  CIP13: '3400936318304',
  ucdLib: "PARACETAMOL SDZ 500MG GELU",
  UCD7: '9261883',
  UCD13: '3400892618838',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL SDZ 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3638163',
  CIP13: '3400936381636',
  ucdLib: "PARACETAMOL TVC 1G CPR",
  UCD7: '9262144',
  UCD13: '3400892621449',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL TVC 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3740677',
  CIP13: '3400937406772',
  ucdLib: "PARACETAMOL ZYD 1G CPR",
  UCD7: '9290608',
  UCD13: '3400892906089',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ZYD 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3499833',
  CIP13: '3400934998331',
  ucdLib: "DOLIPRANE 100MG PDR SACH",
  UCD7: '9210928',
  UCD13: '3400892109282',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLIPRANE 100MG PDR SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3499879',
  CIP13: '3400934998799',
  ucdLib: "DOLIPRANE 150MG PDR SACH",
  UCD7: '9210934',
  UCD13: '3400892109343',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLIPRANE 150MG PDR SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3499916',
  CIP13: '3400934999161',
  ucdLib: "DOLIPRANE 200MG PDR SACH",
  UCD7: '9210940',
  UCD13: '3400892109404',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLIPRANE 200MG PDR SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3499945',
  CIP13: '3400934999451',
  ucdLib: "DOLIPRANE 300MG PDR SACH",
  UCD7: '9210957',
  UCD13: '3400892109572',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLIPRANE 300MG PDR SACH BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3648546',
  CIP13: '3400936485464',
  ucdLib: "EFFERALGAN 1G CPR",
  UCD7: '9376652',
  UCD13: '3400893766521',
  ucdQtyMultiplicator: 8,
  cipLib: "EFFERALGAN 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3820057',
  CIP13: '3400938200577',
  ucdLib: "PARACETAMOL BGA 500MG CPR",
  UCD7: '9356425',
  UCD13: '3400893564257',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL BGA 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3473058',
  CIP13: '3400934730580',
  ucdLib: "PARACETAMOL EGL 500MG CPR",
  UCD7: '9215742',
  UCD13: '3400892157429',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL EGL 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3826723',
  CIP13: '3400938267235',
  ucdLib: "PARACETAMOL RPG 1G CPR",
  UCD7: '9318318',
  UCD13: '3400893183182',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL RPG 1G CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3782871',
  CIP13: '3400937828710',
  ucdLib: "PARACETAMOL RTP 500MG GELU",
  UCD7: '9301565',
  UCD13: '3400893015650',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL RTP 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3771117',
  CIP13: '3400937711173',
  ucdLib: "PARACETAMOL SDC 500MG CPR",
  UCD7: '9298455',
  UCD13: '3400892984551',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL SDC 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3792094',
  CIP13: '3400937920940',
  ucdLib: "PARACETAMOL TCO 500MG CPR",
  UCD7: '9316578',
  UCD13: '3400893165782',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL TCO 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3886369',
  CIP13: '3400938863697',
  ucdLib: "PARACETAMOL ARW 1000MG BUV S.",
  UCD7: '9323762',
  UCD13: '3400893237625',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ARW 1000MG BUV S. BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3886346',
  CIP13: '3400938863468',
  ucdLib: "PARACETAMOL ARW 300MG BUV S.",
  UCD7: '9323779',
  UCD13: '3400893237793',
  ucdQtyMultiplicator: 12,
  cipLib: "PARACETAMOL ARW 300MG BUV S. BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3886352',
  CIP13: '3400938863529',
  ucdLib: "PARACETAMOL ARW 500MG BUV S.",
  UCD7: '9323785',
  UCD13: '3400893237854',
  ucdQtyMultiplicator: 12,
  cipLib: "PARACETAMOL ARW 500MG BUV S. BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3871043',
  CIP13: '3400938710434',
  ucdLib: "PARACETAMOL AWC 500MG CPR",
  UCD7: '9360467',
  UCD13: '3400893604670',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL AWC 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '5500095',
  CIP13: '3400955000952',
  ucdLib: "PARACETAMOL BBM10MG/ML 10ML",
  UCD7: '9407909',
  UCD13: '3400894079095',
  ucdQtyMultiplicator: 20,
  cipLib: "PARACETAMOL BBM10MG/ML 10ML BT 20",
  atcCode: "N02BE01"
}, {
  CIP7: '3884962',
  CIP13: '3400938849622',
  ucdLib: "PARACETAMOL BGA 300MG BUV S.",
  UCD7: '9348271',
  UCD13: '3400893482711',
  ucdQtyMultiplicator: 12,
  cipLib: "PARACETAMOL BGA 300MG BUV S. BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '5501475',
  CIP13: '3400955014751',
  ucdLib: "PARACETAMOL MYL 1G CPR",
  UCD7: '9310995',
  UCD13: '3400893109953',
  ucdQtyMultiplicator: 80,
  cipLib: "PARACETAMOL MYL 1G CPR BT 80",
  atcCode: "N02BE01"
}, {
  CIP7: '5500774',
  CIP13: '3400955007746',
  ucdLib: "PARACETAMOL MYL 500MG CPR",
  UCD7: '9206401',
  UCD13: '3400892064017',
  ucdQtyMultiplicator: 100,
  cipLib: "PARACETAMOL MYL 500MG CPR BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5500314',
  CIP13: '3400955003144',
  ucdLib: "PARACETAMOL MYL 500MG GELU",
  UCD7: '9258467',
  UCD13: '3400892584676',
  ucdQtyMultiplicator: 100,
  cipLib: "PARACETAMOL MYL 500MG GELU BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5641152',
  CIP13: '3400956411528',
  ucdLib: "DAFALGAN 1G CPR PELLIC",
  UCD7: '9248807',
  UCD13: '3400892488073',
  ucdQtyMultiplicator: 100,
  cipLib: "DAFALGAN 1G CPR PELLIC BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5636955',
  CIP13: '3400956369553',
  ucdLib: "DOLIPRANE 1000MG CPR",
  UCD7: '9239091',
  UCD13: '3400892390918',
  ucdQtyMultiplicator: 100,
  cipLib: "DOLIPRANE 1000MG CPR BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5632992',
  CIP13: '3400956329922',
  ucdLib: "DOLIPRANE 1000MG CPR EFFV",
  UCD7: '9216902',
  UCD13: '3400892169026',
  ucdQtyMultiplicator: 100,
  cipLib: "DOLIPRANE 1000MG CPR EFFV BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '3840982',
  CIP13: '3400938409826',
  ucdLib: "PARACETAMOL ARW 500MG GELU",
  UCD7: '9355851',
  UCD13: '3400893558515',
  ucdQtyMultiplicator: 12,
  cipLib: "PARACETAMOL ARW 500MG GELU BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3841007',
  CIP13: '3400938410075',
  ucdLib: "PARACETAMOL ARW 500MG GELU",
  UCD7: '9355851',
  UCD13: '3400893558515',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ARW 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3841295',
  CIP13: '3400938412956',
  ucdLib: "PARACETAMOL ARW 500MG GELU",
  UCD7: '9355851',
  UCD13: '3400893558515',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ARW 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3906971',
  CIP13: '3400939069715',
  ucdLib: "PARACETAMOL BGA 1000MG BUV S.",
  UCD7: '9348265',
  UCD13: '3400893482650',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL BGA 1000MG BUV S. BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3906959',
  CIP13: '3400939069593',
  ucdLib: "PARACETAMOL BGA 500MG BUV S.",
  UCD7: '9348288',
  UCD13: '3400893482889',
  ucdQtyMultiplicator: 12,
  cipLib: "PARACETAMOL BGA 500MG BUV S. BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '3934861',
  CIP13: '3400939348612',
  ucdLib: "PARACETAMOL ISD 1000MG C.EFFV",
  UCD7: '9338798',
  UCD13: '3400893387986',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ISD 1000MG C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '3915935',
  CIP13: '3400939159355',
  ucdLib: "PARACETAMOL ISD 500MG C.EFFV",
  UCD7: '9332169',
  UCD13: '3400893321690',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ISD 500MG C.EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '3931354',
  CIP13: '3400939313542',
  ucdLib: "PARACETAMOL ISD 500MG CPR",
  UCD7: '9319105',
  UCD13: '3400893191057',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL ISD 500MG CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '5631834',
  CIP13: '3400956318346',
  ucdLib: "PARACETAMOL ZEN 1000MG C.EFFV",
  UCD7: '9384108',
  UCD13: '3400893841082',
  ucdQtyMultiplicator: 100,
  cipLib: "PARACETAMOL ZEN 1000MG C.EFFV BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5649627',
  CIP13: '3400956496273',
  ucdLib: "PARACETAMOL ZEN 1000MG CPR",
  UCD7: '9384083',
  UCD13: '3400893840832',
  ucdQtyMultiplicator: 100,
  cipLib: "PARACETAMOL ZEN 1000MG CPR BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5647870',
  CIP13: '3400956478705',
  ucdLib: "PARACETAMOL ZEN 500MG CPR",
  UCD7: '9384114',
  UCD13: '3400893841143',
  ucdQtyMultiplicator: 100,
  cipLib: "PARACETAMOL ZEN 500MG CPR BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5630591',
  CIP13: '3400956305919',
  ucdLib: "PERFALGAN 10MG/ML INJ 100ML",
  UCD7: '9231267',
  UCD13: '3400892312675',
  ucdQtyMultiplicator: 12,
  cipLib: "PERFALGAN 10MG/ML INJ 100ML BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '5636240',
  CIP13: '3400956362400',
  ucdLib: "PERFALGAN 10MG/ML INJ 50ML",
  UCD7: '9239642',
  UCD13: '3400892396422',
  ucdQtyMultiplicator: 12,
  cipLib: "PERFALGAN 10MG/ML INJ 50ML BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '4153396',
  CIP13: '3400941533969',
  ucdLib: "DOLIPRANE 1000MG GELU",
  UCD7: '9373984',
  UCD13: '3400893739846',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLIPRANE 1000MG GELU BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '4153404',
  CIP13: '3400941534041',
  ucdLib: "DOLIPRANECAPS 1000MG GELU",
  UCD7: '9411644',
  UCD13: '3400894116448',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLIPRANECAPS 1000MG GELU BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '4150908',
  CIP13: '3400941509087',
  ucdLib: "PARACETAMOL AHCL1G C.EFFV",
  UCD7: '9384025',
  UCD13: '3400893840252',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL AHCL1G C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '2194215',
  CIP13: '3400921942156',
  ucdLib: "PARACETAMOL CRT 500MG GELU",
  UCD7: '9384752',
  UCD13: '3400893847527',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL CRT 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '2194178',
  CIP13: '3400921941784',
  ucdLib: "PARACETAMOL TVC 500MG GELU",
  UCD7: '9389152',
  UCD13: '3400893891520',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL TVC 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '4151150',
  CIP13: '3400941511509',
  ucdLib: "PARACETAMOL ZYD 500MG GELU",
  UCD7: '9369209',
  UCD13: '3400893692097',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL ZYD 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '5871691',
  CIP13: '3400958716911',
  ucdLib: "PARACETAMOL ARW 500MG GELU",
  UCD7: '9355851',
  UCD13: '3400893558515',
  ucdQtyMultiplicator: 100,
  cipLib: "PARACETAMOL ARW 500MG GELU BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '2802488',
  CIP13: '3400928024886',
  ucdLib: "PARACETAMOL EVO 500MG GELU",
  UCD7: '9414447',
  UCD13: '3400894144472',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL EVO 500MG GELU BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '2789411',
  CIP13: '3400927894114',
  ucdLib: "DOLIPRANELIQUIZ 200MG S/S S.",
  UCD7: '9411472',
  UCD13: '3400894114727',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLIPRANELIQUIZ 200MG S/S S. BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '2789747',
  CIP13: '3400927897474',
  ucdLib: "DOLIPRANELIQUIZ 300MG S/S S.",
  UCD7: '9411489',
  UCD13: '3400894114895',
  ucdQtyMultiplicator: 12,
  cipLib: "DOLIPRANELIQUIZ 300MG S/S S. BT 12",
  atcCode: "N02BE01"
}, {
  CIP7: '4163124',
  CIP13: '3400941631245',
  ucdLib: "DOLIPRANETABS 1000MG CPR",
  UCD7: '9380056',
  UCD13: '3400893800560',
  ucdQtyMultiplicator: 8,
  cipLib: "DOLIPRANETABS 1000MG CPR BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '4163182',
  CIP13: '3400941631825',
  ucdLib: "DOLIPRANETABS 500MG CPR",
  UCD7: '9380062',
  UCD13: '3400893800621',
  ucdQtyMultiplicator: 16,
  cipLib: "DOLIPRANETABS 500MG CPR BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '5729970',
  CIP13: '3400957299705',
  ucdLib: "PARACET.PAN10MG/ML P100ML",
  UCD7: '9308685',
  UCD13: '3400893086858',
  ucdQtyMultiplicator: 50,
  cipLib: "PARACET.PAN10MG/ML P100ML BT 50",
  atcCode: "N02BE01"
}, {
  CIP7: '5718601',
  CIP13: '3400957186012',
  ucdLib: "PARACET.PAN10MG/ML P50ML",
  UCD7: '9308691',
  UCD13: '3400893086919',
  ucdQtyMultiplicator: 10,
  cipLib: "PARACET.PAN10MG/ML P50ML BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '2688644',
  CIP13: '3400926886448',
  ucdLib: "PARACETAMOL GNR 1G C.EFFV",
  UCD7: '9396318',
  UCD13: '3400893963180',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL GNR 1G C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '2688615',
  CIP13: '3400926886158',
  ucdLib: "PARACETAMOL GNR 500MG C.EFFV",
  UCD7: '9256362',
  UCD13: '3400892563626',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL GNR 500MG C.EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '2688532',
  CIP13: '3400926885328',
  ucdLib: "PARACETAMOL TVS 1000MG C.EFFV",
  UCD7: '9396778',
  UCD13: '3400893967782',
  ucdQtyMultiplicator: 8,
  cipLib: "PARACETAMOL TVS 1000MG C.EFFV BT 8",
  atcCode: "N02BE01"
}, {
  CIP7: '2688503',
  CIP13: '3400926885038',
  ucdLib: "PARACETAMOL TVS 500MG C.EFFV",
  UCD7: '9396784',
  UCD13: '3400893967843',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACETAMOL TVS 500MG C.EFFV BT 16",
  atcCode: "N02BE01"
}, {
  CIP7: '5755708',
  CIP13: '3400957557089',
  ucdLib: "PERFALGAN 10MG/ML POC100ML",
  UCD7: '9343799',
  UCD13: '3400893437995',
  ucdQtyMultiplicator: 50,
  cipLib: "PERFALGAN 10MG/ML POC100ML BT 50",
  atcCode: "N02BE01"
}, {
  CIP7: '5834106',
  CIP13: '3400958341069',
  ucdLib: "DAFALGAN 1G CPR PELLIC",
  UCD7: '9248807',
  UCD13: '3400892488073',
  ucdQtyMultiplicator: 40,
  cipLib: "DAFALGAN 1G CPR PELLIC BT 40",
  atcCode: "N02BE01"
}, {
  CIP7: '5662510',
  CIP13: '3400956625109',
  ucdLib: "DAFALGAN 500MG CPR",
  UCD7: '9356106',
  UCD13: '3400893561065',
  ucdQtyMultiplicator: 100,
  cipLib: "DAFALGAN 500MG CPR BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5777727',
  CIP13: '3400957777272',
  ucdLib: "DAFALGANHOP 1G CPR EFFV",
  UCD7: '9355638',
  UCD13: '3400893556382',
  ucdQtyMultiplicator: 100,
  cipLib: "DAFALGANHOP 1G CPR EFFV BT 100",
  atcCode: "N02BE01"
}, {
  CIP7: '5834112',
  CIP13: '3400958341120',
  ucdLib: "DAFALGANHOP 1G CPR EFFV",
  UCD7: '9355638',
  UCD13: '3400893556382',
  ucdQtyMultiplicator: 40,
  cipLib: "DAFALGANHOP 1G CPR EFFV BT 40",
  atcCode: "N02BE01"
}, {
  CIP7: '5800780',
  CIP13: '3400958007804',
  ucdLib: "PARACET.KBI10MG/ML FL100ML",
  UCD7: '9379857',
  UCD13: '3400893798577',
  ucdQtyMultiplicator: 10,
  cipLib: "PARACET.KBI10MG/ML FL100ML BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '5800745',
  CIP13: '3400958007453',
  ucdLib: "PARACET.KBI10MG/ML FL50ML",
  UCD7: '9379840',
  UCD13: '3400893798409',
  ucdQtyMultiplicator: 10,
  cipLib: "PARACET.KBI10MG/ML FL50ML BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '5824929',
  CIP13: '3400958249297',
  ucdLib: "PARACET.KBI10MG/ML PFS100ML",
  UCD7: '9392467',
  UCD13: '3400893924679',
  ucdQtyMultiplicator: 20,
  cipLib: "PARACET.KBI10MG/ML PFS100ML BT 20",
  atcCode: "N02BE01"
}, {
  CIP7: '5856409',
  CIP13: '3400958564093',
  ucdLib: "PARACET.PAN10MG/ML FV10ML",
  UCD7: '9399794',
  UCD13: '3400893997949',
  ucdQtyMultiplicator: 10,
  cipLib: "PARACET.PAN10MG/ML FV10ML BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '5812205',
  CIP13: '3400958122057',
  ucdLib: "PARACETAMOL ARW10MG/ML 100ML",
  UCD7: '9382227',
  UCD13: '3400893822272',
  ucdQtyMultiplicator: 10,
  cipLib: "PARACETAMOL ARW10MG/ML 100ML BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '5830752',
  CIP13: '3400958307522',
  ucdLib: "PARACETAMOL BBM10MG/ML 50ML",
  UCD7: '9387532',
  UCD13: '3400893875322',
  ucdQtyMultiplicator: 10,
  cipLib: "PARACETAMOL BBM10MG/ML 50ML BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '5830812',
  CIP13: '3400958308123',
  ucdLib: "PARACETAMOL BBM10MG/ML100ML",
  UCD7: '9387549',
  UCD13: '3400893875490',
  ucdQtyMultiplicator: 10,
  cipLib: "PARACETAMOL BBM10MG/ML100ML BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '5768958',
  CIP13: '3400957689582',
  ucdLib: "PARACET.MAC10MG/ML 100ML PERF",
  UCD7: '9350658',
  UCD13: '3400893506585',
  ucdQtyMultiplicator: 50,
  cipLib: "PARACET.MAC10MG/ML 100ML PERF BT 50",
  atcCode: "N02BE01"
}, {
  CIP7: '5769024',
  CIP13: '3400957690243',
  ucdLib: "PARACET.MAC10MG/ML 50ML 2SIT",
  UCD7: '9350670',
  UCD13: '3400893506707',
  ucdQtyMultiplicator: 50,
  cipLib: "PARACET.MAC10MG/ML 50ML 2SIT BT 50",
  atcCode: "N02BE01"
}, {
  CIP7: '5769076',
  CIP13: '3400957690762',
  ucdLib: "PARACET.MAC10MG/ML100ML 2SIT",
  UCD7: '9350664',
  UCD13: '3400893506646',
  ucdQtyMultiplicator: 10,
  cipLib: "PARACET.MAC10MG/ML100ML 2SIT BT 10",
  atcCode: "N02BE01"
}, {
  CIP7: '5769107',
  CIP13: '3400957691073',
  ucdLib: "PARACET.MAC10MG/ML100ML 2SIT",
  UCD7: '9350664',
  UCD13: '3400893506646',
  ucdQtyMultiplicator: 50,
  cipLib: "PARACET.MAC10MG/ML100ML 2SIT BT 50",
  atcCode: "N02BE01"
}, {
  CIP7: '3288875',
  CIP13: '3400932888757',
  ucdLib: "ASPIRINE 500MG C OB. C.EFFV",
  UCD7: '9109891',
  UCD13: '3400891098914',
  ucdQtyMultiplicator: 30,
  cipLib: "ASPIRINE 500MG C OB. C.EFFV BT 30",
  atcCode: "N02BA51"
}, {
  CIP7: '3007681',
  CIP13: '3400930076811',
  ucdLib: "ASPIRINE UPSA VIT C C.EFFV",
  UCD7: '9007570',
  UCD13: '3400890075701',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPIRINE UPSA VIT C C.EFFV BT 20",
  atcCode: "N02BA51"
}, {
  CIP7: '3325085',
  CIP13: '3400933250850',
  ucdLib: "ASPRO 500 VIT C EFFV CPR",
  UCD7: '9144628',
  UCD13: '3400891446289',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPRO 500 VIT C EFFV CPR BT 20",
  atcCode: "N02BA51"
}, {
  CIP7: '3289142',
  CIP13: '3400932891429',
  ucdLib: "METASPIRINE CPR",
  UCD7: '9058449',
  UCD13: '3400890584494',
  ucdQtyMultiplicator: 30,
  cipLib: "METASPIRINE CPR BT 30",
  atcCode: "N02BA51"
}, {
  CIP7: '3118340',
  CIP13: '3400931183402',
  ucdLib: "ACTRON CPR EFFV",
  UCD7: '9001030',
  UCD13: '3400890010306',
  ucdQtyMultiplicator: 20,
  cipLib: "ACTRON CPR EFFV BT 20",
  atcCode: "N02BA51"
}, {
  CIP7: '3221380',
  CIP13: '3400932213801',
  ucdLib: "ACTRON CPR EFFV",
  UCD7: '9001030',
  UCD13: '3400890010306',
  ucdQtyMultiplicator: 30,
  cipLib: "ACTRON CPR EFFV BT 30",
  atcCode: "N02BA51"
}, {
  CIP7: '3404695',
  CIP13: '3400934046957',
  ucdLib: "NOVACETOL CPR",
  UCD7: '9063806',
  UCD13: '3400890638067',
  ucdQtyMultiplicator: 24,
  cipLib: "NOVACETOL CPR BT 24",
  atcCode: "N02BA51"
}, {
  CIP7: '3368781',
  CIP13: '3400933687816',
  ucdLib: "ANTIGRIPPINE ASPIR CPR",
  UCD7: '9167049',
  UCD13: '3400891670493',
  ucdQtyMultiplicator: 20,
  cipLib: "ANTIGRIPPINE ASPIR CPR BT 20",
  atcCode: "N02BA51"
}, {
  CIP7: '3397340',
  CIP13: '3400933973407',
  ucdLib: "ASPRO CAFEI.500/50MG C.EFFV",
  UCD7: '9188005',
  UCD13: '3400891880052',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPRO CAFEI.500/50MG C.EFFV BT 20",
  atcCode: "N02BA51"
}, {
  CIP7: '3368976',
  CIP13: '3400933689766',
  ucdLib: "MIGPRIV BUV PDR SACH",
  UCD7: '9163531',
  UCD13: '3400891635317',
  ucdQtyMultiplicator: 6,
  cipLib: "MIGPRIV BUV PDR SACH BT 6",
  atcCode: "N02BA51"
}, {
  CIP7: '3415635',
  CIP13: '3400934156359',
  ucdLib: "ASPRO CAFEI.500/50MG CPR",
  UCD7: '9188011',
  UCD13: '3400891880113',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPRO CAFEI.500/50MG CPR BT 20",
  atcCode: "N02BA51"
}, {
  CIP7: '3483097',
  CIP13: '3400934830976',
  ucdLib: "SEDASPIR CPR",
  UCD7: '9083128',
  UCD13: '3400890831284',
  ucdQtyMultiplicator: 20,
  cipLib: "SEDASPIR CPR BT 20",
  atcCode: "N02BA51"
}, {
  CIP7: '3187559',
  CIP13: '3400931875598',
  ucdLib: "CEPHYL CPR",
  UCD7: '9017798',
  UCD13: '3400890177986',
  ucdQtyMultiplicator: 20,
  cipLib: "CEPHYL CPR BT 20",
  atcCode: "N02BA51"
}, {
  CIP7: '3187884',
  CIP13: '3400931878841',
  ucdLib: "CEPHYL CPR",
  UCD7: '9017798',
  UCD13: '3400890177986',
  ucdQtyMultiplicator: 60,
  cipLib: "CEPHYL CPR BT 60",
  atcCode: "N02BA51"
}, {
  CIP7: '3467773',
  CIP13: '3400934677731',
  ucdLib: "EXCEDRINIL 250/250/65MG CPR",
  UCD7: '9410403',
  UCD13: '3400894104032',
  ucdQtyMultiplicator: 10,
  cipLib: "EXCEDRINIL 250/250/65MG CPR BT 10",
  atcCode: "N02BA51"
}, {
  CIP7: '5531498',
  CIP13: '3400955314981',
  ucdLib: "ASPEGIC 500MG INJ FL",
  UCD7: '9007239',
  UCD13: '3400890072397',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPEGIC 500MG INJ FL BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3007468',
  CIP13: '3400930074688',
  ucdLib: "ASPIRINE PH8 500MG CPR",
  UCD7: '9007535',
  UCD13: '3400890075350',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPIRINE PH8 500MG CPR BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3007474',
  CIP13: '3400930074749',
  ucdLib: "ASPIRINE PH8 500MG CPR",
  UCD7: '9007535',
  UCD13: '3400890075350',
  ucdQtyMultiplicator: 50,
  cipLib: "ASPIRINE PH8 500MG CPR BT 50",
  atcCode: "N02BA01"
}, {
  CIP7: '3007818',
  CIP13: '3400930078181',
  ucdLib: "ASPRO 320 CPR",
  UCD7: '9007647',
  UCD13: '3400890076470',
  ucdQtyMultiplicator: 60,
  cipLib: "ASPRO 320 CPR BT 60",
  atcCode: "N02BA01"
}, {
  CIP7: '3291104',
  CIP13: '3400932911042',
  ucdLib: "ALKA-SELTZER CPR EFFV",
  UCD7: '9002928',
  UCD13: '3400890029285',
  ucdQtyMultiplicator: 40,
  cipLib: "ALKA-SELTZER CPR EFFV BT 40",
  atcCode: "N02BA01"
}, {
  CIP7: '3292687',
  CIP13: '3400932926879',
  ucdLib: "ALKA-SELTZER CPR EFFV",
  UCD7: '9002928',
  UCD13: '3400890029285',
  ucdQtyMultiplicator: 20,
  cipLib: "ALKA-SELTZER CPR EFFV BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3270361',
  CIP13: '3400932703616',
  ucdLib: "ASPEGIC 250MG PDR SACH",
  UCD7: '9007280',
  UCD13: '3400890072809',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPEGIC 250MG PDR SACH BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3570672',
  CIP13: '3400935706720',
  ucdLib: "ASPEGIC AD. 1000MG BUV SACH",
  UCD7: '9007274',
  UCD13: '3400890072748',
  ucdQtyMultiplicator: 30,
  cipLib: "ASPEGIC AD. 1000MG BUV SACH BT 30",
  atcCode: "N02BA01"
}, {
  CIP7: '3261020',
  CIP13: '3400932610204',
  ucdLib: "ASPEGIC 1G INJ FL+AMP",
  UCD7: '9007268',
  UCD13: '3400890072687',
  ucdQtyMultiplicator: 6,
  cipLib: "ASPEGIC 1G INJ FL+AMP BT 6",
  atcCode: "N02BA01"
}, {
  CIP7: '3122689',
  CIP13: '3400931226895',
  ucdLib: "ASPEGIC 500MG BUV SACH",
  UCD7: '9007297',
  UCD13: '3400890072977',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPEGIC 500MG BUV SACH BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3342480',
  CIP13: '3400933424800',
  ucdLib: "ASPIRINE DU RHONE 0,5G CROQ",
  UCD7: '9157281',
  UCD13: '3400891572810',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPIRINE DU RHONE 0,5G CROQ BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '5516990',
  CIP13: '3400955169901',
  ucdLib: "ASPIRINE RICHARD 500MG CPR",
  UCD7: '9159481',
  UCD13: '3400891594812',
  ucdQtyMultiplicator: 1000,
  cipLib: "ASPIRINE RICHARD 500MG CPR BT 1000",
  atcCode: "N02BA01"
}, {
  CIP7: '3353153',
  CIP13: '3400933531539',
  ucdLib: "ASPIRINE UPSA 1000MG C.EFFV",
  UCD7: '9156933',
  UCD13: '3400891569339',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPIRINE UPSA 1000MG C.EFFV BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3351510',
  CIP13: '3400933515102',
  ucdLib: "ASPIRINE UPSA 500MG C.EFFV",
  UCD7: '9156896',
  UCD13: '3400891568967',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPIRINE UPSA 500MG C.EFFV BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3206245',
  CIP13: '3400932062454',
  ucdLib: "ASPRO 500 EFFV CPR",
  UCD7: '9007676',
  UCD13: '3400890076760',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPRO 500 EFFV CPR BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3206251',
  CIP13: '3400932062515',
  ucdLib: "ASPRO 500 EFFV CPR",
  UCD7: '9007676',
  UCD13: '3400890076760',
  ucdQtyMultiplicator: 36,
  cipLib: "ASPRO 500 EFFV CPR BT 36",
  atcCode: "N02BA01"
}, {
  CIP7: '3514679',
  CIP13: '3400935146793',
  ucdLib: "ASPIRINE DU RHONE 0,5G CPR",
  UCD7: '9007587',
  UCD13: '3400890075879',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPIRINE DU RHONE 0,5G CPR BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3514685',
  CIP13: '3400935146854',
  ucdLib: "ASPIRINE DU RHONE 0,5G CPR",
  UCD7: '9007587',
  UCD13: '3400890075879',
  ucdQtyMultiplicator: 50,
  cipLib: "ASPIRINE DU RHONE 0,5G CPR BT 50",
  atcCode: "N02BA01"
}, {
  CIP7: '3189819',
  CIP13: '3400931898191',
  ucdLib: "ASPEGIC AD. 1000MG BUV SACH",
  UCD7: '9007274',
  UCD13: '3400890072748',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPEGIC AD. 1000MG BUV SACH BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3189363',
  CIP13: '3400931893639',
  ucdLib: "ASPEGIC BB. 100MG BUV SACH",
  UCD7: '9007222',
  UCD13: '3400890072229',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPEGIC BB. 100MG BUV SACH BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '3473615',
  CIP13: '3400934736155',
  ucdLib: "ASPEGIC 500MG BUV SACH",
  UCD7: '9007297',
  UCD13: '3400890072977',
  ucdQtyMultiplicator: 30,
  cipLib: "ASPEGIC 500MG BUV SACH BT 30",
  atcCode: "N02BA01"
}, {
  CIP7: '3473590',
  CIP13: '3400934735905',
  ucdLib: "ASPEGIC AD. 1000MG BUV SACH",
  UCD7: '9007274',
  UCD13: '3400890072748',
  ucdQtyMultiplicator: 15,
  cipLib: "ASPEGIC AD. 1000MG BUV SACH BT 15",
  atcCode: "N02BA01"
}, {
  CIP7: '3509224',
  CIP13: '3400935092243',
  ucdLib: "HUVANOF 250MG ENF BUV SACH",
  UCD7: '9384120',
  UCD13: '3400893841204',
  ucdQtyMultiplicator: 100,
  cipLib: "HUVANOF 250MG ENF BUV SACH BT 100",
  atcCode: "N02BA01"
}, {
  CIP7: '2790710',
  CIP13: '3400927907104',
  ucdLib: "ASPROFLASH 500MG CPR",
  UCD7: '9408323',
  UCD13: '3400894083238',
  ucdQtyMultiplicator: 20,
  cipLib: "ASPROFLASH 500MG CPR BT 20",
  atcCode: "N02BA01"
}, {
  CIP7: '5826590',
  CIP13: '3400958265907',
  ucdLib: "HUVANOF 1000MG AD. BUV SACH",
  UCD7: '9387696',
  UCD13: '3400893876961',
  ucdQtyMultiplicator: 100,
  cipLib: "HUVANOF 1000MG AD. BUV SACH BT 100",
  atcCode: "N02BA01"
}, {
  CIP7: '5826578',
  CIP13: '3400958265785',
  ucdLib: "HUVANOF 100MG BB. BUV SACH",
  UCD7: '9387704',
  UCD13: '3400893877043',
  ucdQtyMultiplicator: 100,
  cipLib: "HUVANOF 100MG BB. BUV SACH BT 100",
  atcCode: "N02BA01"
}, {
  CIP7: '5826584',
  CIP13: '3400958265846',
  ucdLib: "HUVANOF 500MG BUV SACH DOS",
  UCD7: '9387710',
  UCD13: '3400893877104',
  ucdQtyMultiplicator: 100,
  cipLib: "HUVANOF 500MG BUV SACH DOS BT 100",
  atcCode: "N02BA01"
}, {
  CIP7: '3839861',
  CIP13: '3400938398618',
  ucdLib: "TRAMADOL SDZ LP 100MG CPR",
  UCD7: '9317684',
  UCD13: '3400893176849',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL SDZ LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3839909',
  CIP13: '3400938399097',
  ucdLib: "TRAMADOL SDZ LP 200MG CPR",
  UCD7: '9317709',
  UCD13: '3400893177099',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL SDZ LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3611454',
  CIP13: '3400936114548',
  ucdLib: "TRAMADOL TVC 50MG GELU",
  UCD7: '9245737',
  UCD13: '3400892457376',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL TVC 50MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3001410',
  CIP13: '3400930014103',
  ucdLib: "TRAMADOL BGA LP 100MG CPR",
  UCD7: '9322840',
  UCD13: '3400893228401',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL BGA LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3571306',
  CIP13: '3400935713063',
  ucdLib: "TRAMADOL ZYD 50MG GELU",
  UCD7: '9234685',
  UCD13: '3400892346854',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZYD 50MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3680917',
  CIP13: '3400936809178',
  ucdLib: "MONOALGIC LP 300MG CPR",
  UCD7: '9294569',
  UCD13: '3400892945699',
  ucdQtyMultiplicator: 15,
  cipLib: "MONOALGIC LP 300MG CPR BT 15",
  atcCode: "N02AX02"
}, {
  CIP7: '3681934',
  CIP13: '3400936819344',
  ucdLib: "TRAMADOL SDZ 50MG CPR",
  UCD7: '9269117',
  UCD13: '3400892691176',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL SDZ 50MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '5588819',
  CIP13: '3400955888192',
  ucdLib: "TOPALGIC 100MG INJ AMP2ML",
  UCD7: '9186621',
  UCD13: '3400891866216',
  ucdQtyMultiplicator: 5,
  cipLib: "TOPALGIC 100MG INJ AMP2ML BT 5",
  atcCode: "N02AX02"
}, {
  CIP7: '5588788',
  CIP13: '3400955887881',
  ucdLib: "TOPALGIC 50MG GELU",
  UCD7: '9186377',
  UCD13: '3400891863772',
  ucdQtyMultiplicator: 100,
  cipLib: "TOPALGIC 50MG GELU BT 100",
  atcCode: "N02AX02"
}, {
  CIP7: '3431427',
  CIP13: '3400934314278',
  ucdLib: "TOPALGIC LP 100MG CPR",
  UCD7: '9204862',
  UCD13: '3400892048628',
  ucdQtyMultiplicator: 30,
  cipLib: "TOPALGIC LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3431456',
  CIP13: '3400934314568',
  ucdLib: "TOPALGIC LP 150MG CPR",
  UCD7: '9204879',
  UCD13: '3400892048796',
  ucdQtyMultiplicator: 30,
  cipLib: "TOPALGIC LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3431479',
  CIP13: '3400934314797',
  ucdLib: "TOPALGIC LP 200MG CPR",
  UCD7: '9204885',
  UCD13: '3400892048857',
  ucdQtyMultiplicator: 30,
  cipLib: "TOPALGIC LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3524844',
  CIP13: '3400935248442',
  ucdLib: "TRAMADOL BGA 50MG GELU",
  UCD7: '9216977',
  UCD13: '3400892169774',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL BGA 50MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3523603',
  CIP13: '3400935236036',
  ucdLib: "ZUMALGIC 100MG CPR EFFV",
  UCD7: '9240504',
  UCD13: '3400892405049',
  ucdQtyMultiplicator: 20,
  cipLib: "ZUMALGIC 100MG CPR EFFV BT 20",
  atcCode: "N02AX02"
}, {
  CIP7: '3678719',
  CIP13: '3400936787193',
  ucdLib: "MONOALGIC LP 100MG CPR",
  UCD7: '9294546',
  UCD13: '3400892945460',
  ucdQtyMultiplicator: 15,
  cipLib: "MONOALGIC LP 100MG CPR BT 15",
  atcCode: "N02AX02"
}, {
  CIP7: '3679423',
  CIP13: '3400936794238',
  ucdLib: "MONOALGIC LP 200MG CPR",
  UCD7: '9294552',
  UCD13: '3400892945521',
  ucdQtyMultiplicator: 15,
  cipLib: "MONOALGIC LP 200MG CPR BT 15",
  atcCode: "N02AX02"
}, {
  CIP7: '3674880',
  CIP13: '3400936748804',
  ucdLib: "TRAMADOL ZEN 50MG CPR EFFV",
  UCD7: '9270250',
  UCD13: '3400892702506',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZEN 50MG CPR EFFV BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3553165',
  CIP13: '3400935531650',
  ucdLib: "TAKADOL 100MG CPR EFFV",
  UCD7: '9231557',
  UCD13: '3400892315577',
  ucdQtyMultiplicator: 30,
  cipLib: "TAKADOL 100MG CPR EFFV BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3391188',
  CIP13: '3400933911881',
  ucdLib: "TOPALGIC 50MG GELU",
  UCD7: '9186377',
  UCD13: '3400891863772',
  ucdQtyMultiplicator: 30,
  cipLib: "TOPALGIC 50MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3855245',
  CIP13: '3400938552454',
  ucdLib: "TRAMADOL SDZ LP 150MG CPR",
  UCD7: '9317690',
  UCD13: '3400893176900',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL SDZ LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3620683',
  CIP13: '3400936206830',
  ucdLib: "CONTRAMAL 100MG/ML BUV FL10ML",
  UCD7: '9262492',
  UCD13: '3400892624921',
  ucdQtyMultiplicator: 1,
  cipLib: "CONTRAMAL 100MG/ML BUV FL10ML BT 1",
  atcCode: "N02AX02"
}, {
  CIP7: '3480816',
  CIP13: '3400934808166',
  ucdLib: "CONTRAMAL 50MG GELU",
  UCD7: '9206157',
  UCD13: '3400892061573',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTRAMAL 50MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3482761',
  CIP13: '3400934827617',
  ucdLib: "CONTRAMAL LP 100MG CPR",
  UCD7: '9206128',
  UCD13: '3400892061283',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTRAMAL LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3482784',
  CIP13: '3400934827846',
  ucdLib: "CONTRAMAL LP 150MG CPR",
  UCD7: '9206134',
  UCD13: '3400892061344',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTRAMAL LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3482809',
  CIP13: '3400934828096',
  ucdLib: "CONTRAMAL LP 200MG CPR",
  UCD7: '9206140',
  UCD13: '3400892061405',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTRAMAL LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3624712',
  CIP13: '3400936247123',
  ucdLib: "MONOCRIXO LP 100MG GELU",
  UCD7: '9262581',
  UCD13: '3400892625812',
  ucdQtyMultiplicator: 15,
  cipLib: "MONOCRIXO LP 100MG GELU BT 15",
  atcCode: "N02AX02"
}, {
  CIP7: '3624764',
  CIP13: '3400936247642',
  ucdLib: "MONOCRIXO LP 150MG GELU",
  UCD7: '9262598',
  UCD13: '3400892625980',
  ucdQtyMultiplicator: 15,
  cipLib: "MONOCRIXO LP 150MG GELU BT 15",
  atcCode: "N02AX02"
}, {
  CIP7: '3624818',
  CIP13: '3400936248182',
  ucdLib: "MONOCRIXO LP 200MG GELU",
  UCD7: '9262606',
  UCD13: '3400892626062',
  ucdQtyMultiplicator: 15,
  cipLib: "MONOCRIXO LP 200MG GELU BT 15",
  atcCode: "N02AX02"
}, {
  CIP7: '3620677',
  CIP13: '3400936206779',
  ucdLib: "TOPALGIC 100MG/ML BUV FL10ML",
  UCD7: '9257798',
  UCD13: '3400892577982',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPALGIC 100MG/ML BUV FL10ML BT 1",
  atcCode: "N02AX02"
}, {
  CIP7: '3513059',
  CIP13: '3400935130594',
  ucdLib: "TRAMADOL EG 50MG CPR",
  UCD7: '9219852',
  UCD13: '3400892198521',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL EG 50MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3532298',
  CIP13: '3400935322982',
  ucdLib: "TRAMADOL TVC 50MG CPR",
  UCD7: '9230641',
  UCD13: '3400892306414',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL TVC 50MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3480236',
  CIP13: '3400934802362',
  ucdLib: "ZUMALGIC 50MG CPR EFFV",
  UCD7: '9207174',
  UCD13: '3400892071749',
  ucdQtyMultiplicator: 30,
  cipLib: "ZUMALGIC 50MG CPR EFFV BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '5604228',
  CIP13: '3400956042289',
  ucdLib: "TOPALGIC LP 100MG CPR",
  UCD7: '9204862',
  UCD13: '3400892048628',
  ucdQtyMultiplicator: 100,
  cipLib: "TOPALGIC LP 100MG CPR BT 100",
  atcCode: "N02AX02"
}, {
  CIP7: '5604240',
  CIP13: '3400956042401',
  ucdLib: "TOPALGIC LP 150MG CPR",
  UCD7: '9204879',
  UCD13: '3400892048796',
  ucdQtyMultiplicator: 100,
  cipLib: "TOPALGIC LP 150MG CPR BT 100",
  atcCode: "N02AX02"
}, {
  CIP7: '5604263',
  CIP13: '3400956042630',
  ucdLib: "TOPALGIC LP 200MG CPR",
  UCD7: '9204885',
  UCD13: '3400892048857',
  ucdQtyMultiplicator: 100,
  cipLib: "TOPALGIC LP 200MG CPR BT 100",
  atcCode: "N02AX02"
}, {
  CIP7: '3587715',
  CIP13: '3400935877154',
  ucdLib: "TRAMADOL ARW 50MG CPR",
  UCD7: '9259372',
  UCD13: '3400892593722',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ARW 50MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3465432',
  CIP13: '3400934654329',
  ucdLib: "ZAMUDOL LP 100MG GELU",
  UCD7: '9205212',
  UCD13: '3400892052120',
  ucdQtyMultiplicator: 30,
  cipLib: "ZAMUDOL LP 100MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3465455',
  CIP13: '3400934654558',
  ucdLib: "ZAMUDOL LP 150MG GELU",
  UCD7: '9205229',
  UCD13: '3400892052298',
  ucdQtyMultiplicator: 30,
  cipLib: "ZAMUDOL LP 150MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3465478',
  CIP13: '3400934654787',
  ucdLib: "ZAMUDOL LP 200MG GELU",
  UCD7: '9205235',
  UCD13: '3400892052359',
  ucdQtyMultiplicator: 30,
  cipLib: "ZAMUDOL LP 200MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3465403',
  CIP13: '3400934654039',
  ucdLib: "ZAMUDOL LP 50MG GELU",
  UCD7: '9205241',
  UCD13: '3400892052410',
  ucdQtyMultiplicator: 30,
  cipLib: "ZAMUDOL LP 50MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3747946',
  CIP13: '3400937479462',
  ucdLib: "TRAMADOL TVC LP 150MG CPR",
  UCD7: '9358571',
  UCD13: '3400893585719',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL TVC LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3748414',
  CIP13: '3400937484145',
  ucdLib: "TRAMADOL TVC LP 200MG CPR",
  UCD7: '9353450',
  UCD13: '3400893534502',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL TVC LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3748992',
  CIP13: '3400937489928',
  ucdLib: "TRAMADOL ZYD LP 100MG CPR",
  UCD7: '9353639',
  UCD13: '3400893536391',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZYD LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3821298',
  CIP13: '3400938212983',
  ucdLib: "TRAMADOL BGA LP 100MG CPR",
  UCD7: '9322840',
  UCD13: '3400893228401',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL BGA LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3822292',
  CIP13: '3400938222920',
  ucdLib: "TRAMADOL BGA LP 150MG CPR",
  UCD7: '9322857',
  UCD13: '3400893228579',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL BGA LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3822553',
  CIP13: '3400938225532',
  ucdLib: "TRAMADOL BGA LP 200MG CPR",
  UCD7: '9322863',
  UCD13: '3400893228630',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL BGA LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3497627',
  CIP13: '3400934976278',
  ucdLib: "TRAMADOL MYL 50MG CPR EFFV",
  UCD7: '9210561',
  UCD13: '3400892105611',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL MYL 50MG CPR EFFV BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3497633',
  CIP13: '3400934976339',
  ucdLib: "TRAMADOL MYL 50MG GELU",
  UCD7: '9210578',
  UCD13: '3400892105789',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL MYL 50MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3822837',
  CIP13: '3400938228373',
  ucdLib: "TRAMADOL ZEN LP 100MG CPR",
  UCD7: '9322811',
  UCD13: '3400893228111',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZEN LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3822978',
  CIP13: '3400938229783',
  ucdLib: "TRAMADOL ZEN LP 150MG CPR",
  UCD7: '9322828',
  UCD13: '3400893228289',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZEN LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3823104',
  CIP13: '3400938231045',
  ucdLib: "TRAMADOL ZEN LP 200MG CPR",
  UCD7: '9322834',
  UCD13: '3400893228340',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZEN LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3822702',
  CIP13: '3400938227024',
  ucdLib: "TRAMADOL ZEN LP 50MG CPR",
  UCD7: '9322461',
  UCD13: '3400893224618',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZEN LP 50MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '5611139',
  CIP13: '3400956111398',
  ucdLib: "CONTRAMAL 100MG INJ AMP2ML",
  UCD7: '9206476',
  UCD13: '3400892064765',
  ucdQtyMultiplicator: 5,
  cipLib: "CONTRAMAL 100MG INJ AMP2ML BT 5",
  atcCode: "N02AX02"
}, {
  CIP7: '5611122',
  CIP13: '3400956111220',
  ucdLib: "CONTRAMAL 50MG GELU",
  UCD7: '9206157',
  UCD13: '3400892061573',
  ucdQtyMultiplicator: 100,
  cipLib: "CONTRAMAL 50MG GELU BT 100",
  atcCode: "N02AX02"
}, {
  CIP7: '5611412',
  CIP13: '3400956114122',
  ucdLib: "CONTRAMAL LP 100MG CPR",
  UCD7: '9206128',
  UCD13: '3400892061283',
  ucdQtyMultiplicator: 100,
  cipLib: "CONTRAMAL LP 100MG CPR BT 100",
  atcCode: "N02AX02"
}, {
  CIP7: '5611435',
  CIP13: '3400956114351',
  ucdLib: "CONTRAMAL LP 150MG CPR",
  UCD7: '9206134',
  UCD13: '3400892061344',
  ucdQtyMultiplicator: 100,
  cipLib: "CONTRAMAL LP 150MG CPR BT 100",
  atcCode: "N02AX02"
}, {
  CIP7: '5611458',
  CIP13: '3400956114580',
  ucdLib: "CONTRAMAL LP 200MG CPR",
  UCD7: '9206140',
  UCD13: '3400892061405',
  ucdQtyMultiplicator: 100,
  cipLib: "CONTRAMAL LP 200MG CPR BT 100",
  atcCode: "N02AX02"
}, {
  CIP7: '3737451',
  CIP13: '3400937374514',
  ucdLib: "TRAMADOL TVC LP 100MG CPR",
  UCD7: '9358565',
  UCD13: '3400893585658',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL TVC LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3506734',
  CIP13: '3400935067340',
  ucdLib: "BIODALGIC 50MG CPR EFFV",
  UCD7: '9215630',
  UCD13: '3400892156309',
  ucdQtyMultiplicator: 30,
  cipLib: "BIODALGIC 50MG CPR EFFV BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '4936359',
  CIP13: '3400949363599',
  ucdLib: "TRAMADOL CRT LP 100MG CPR",
  UCD7: '9362472',
  UCD13: '3400893624722',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL CRT LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '4936394',
  CIP13: '3400949363940',
  ucdLib: "TRAMADOL CRT LP 150MG CPR",
  UCD7: '9362489',
  UCD13: '3400893624890',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL CRT LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '4937867',
  CIP13: '3400949378678',
  ucdLib: "TRAMADOL CRT LP 200MG CPR",
  UCD7: '9362495',
  UCD13: '3400893624951',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL CRT LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '2669090',
  CIP13: '3400926690908',
  ucdLib: "TRAMADOL EVO 50MG GELU",
  UCD7: '9389554',
  UCD13: '3400893895542',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL EVO 50MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3941737',
  CIP13: '3400939417370',
  ucdLib: "TRAMADOL ZYD LP 150MG CPR",
  UCD7: '9337729',
  UCD13: '3400893377291',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZYD LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3941789',
  CIP13: '3400939417899',
  ucdLib: "TRAMADOL ZYD LP 200MG CPR",
  UCD7: '9337735',
  UCD13: '3400893377352',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ZYD LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '5748602',
  CIP13: '3400957486020',
  ucdLib: "TRAMADOL LAV 50MG/ML AMP2ML",
  UCD7: '9332293',
  UCD13: '3400893322932',
  ucdQtyMultiplicator: 5,
  cipLib: "TRAMADOL LAV 50MG/ML AMP2ML BT 5",
  atcCode: "N02AX02"
}, {
  CIP7: '3812425',
  CIP13: '3400938124255',
  ucdLib: "TRAMADOL MYG LP 100MG CPR",
  UCD7: '9402378',
  UCD13: '3400894023784',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL MYG LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3812595',
  CIP13: '3400938125955',
  ucdLib: "TRAMADOL MYG LP 150MG CPR",
  UCD7: '9402384',
  UCD13: '3400894023845',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL MYG LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3812767',
  CIP13: '3400938127676',
  ucdLib: "TRAMADOL MYG LP 200MG CPR",
  UCD7: '9402390',
  UCD13: '3400894023906',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL MYG LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3867521',
  CIP13: '3400938675214',
  ucdLib: "TRAMADOL RBX LP 100MG CPR",
  UCD7: '9384829',
  UCD13: '3400893848296',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL RBX LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3874739',
  CIP13: '3400938747393',
  ucdLib: "TRAMADOL RBX LP 150MG CPR",
  UCD7: '9384835',
  UCD13: '3400893848357',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL RBX LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3867544',
  CIP13: '3400938675443',
  ucdLib: "TRAMADOL RBX LP 200MG CPR",
  UCD7: '9384841',
  UCD13: '3400893848418',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL RBX LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3918566',
  CIP13: '3400939185668',
  ucdLib: "TRAMADOL ARW LP 100MG GELU",
  UCD7: '9379509',
  UCD13: '3400893795095',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ARW LP 100MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3918678',
  CIP13: '3400939186788',
  ucdLib: "TRAMADOL ARW LP 150MG GELU",
  UCD7: '9379515',
  UCD13: '3400893795156',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ARW LP 150MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3918589',
  CIP13: '3400939185897',
  ucdLib: "TRAMADOL ARW LP 200MG GELU",
  UCD7: '9379521',
  UCD13: '3400893795217',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ARW LP 200MG GELU BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3972347',
  CIP13: '3400939723471',
  ucdLib: "TRAMADOL EG LP 100MG CPR",
  UCD7: '9376936',
  UCD13: '3400893769362',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL EG LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3972620',
  CIP13: '3400939726205',
  ucdLib: "TRAMADOL EG LP 150MG CPR",
  UCD7: '9376942',
  UCD13: '3400893769423',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL EG LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3972519',
  CIP13: '3400939725192',
  ucdLib: "TRAMADOL EG LP 200MG CPR",
  UCD7: '9376959',
  UCD13: '3400893769591',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL EG LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3947881',
  CIP13: '3400939478814',
  ucdLib: "TRAMADOL ARW LP 100MG CPR",
  UCD7: '9385390',
  UCD13: '3400893853900',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ARW LP 100MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3982624',
  CIP13: '3400939826240',
  ucdLib: "TRAMADOL ARW LP 150MG CPR",
  UCD7: '9347403',
  UCD13: '3400893474037',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ARW LP 150MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3947680',
  CIP13: '3400939476803',
  ucdLib: "TRAMADOL ARW LP 200MG CPR",
  UCD7: '9385409',
  UCD13: '3400893854099',
  ucdQtyMultiplicator: 30,
  cipLib: "TRAMADOL ARW LP 200MG CPR BT 30",
  atcCode: "N02AX02"
}, {
  CIP7: '3004535',
  CIP13: '3400930045350',
  ucdLib: "TRAMADOL/PAR.BGA 37,5/325 CP",
  UCD7: '9391226',
  UCD13: '3400893912263',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.BGA 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2760703',
  CIP13: '3400927607035',
  ucdLib: "TRAMADOL/PAR.ARW 37,5/325 EF",
  UCD7: '9397565',
  UCD13: '3400893975657',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.ARW 37,5/325 EF BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '3585739',
  CIP13: '3400935857392',
  ucdLib: "IXPRIM 37,5MG/325MG CPR",
  UCD7: '9247245',
  UCD13: '3400892472454',
  ucdQtyMultiplicator: 20,
  cipLib: "IXPRIM 37,5MG/325MG CPR BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '3585691',
  CIP13: '3400935856913',
  ucdLib: "ZALDIAR 37,5MG/325MG CPR",
  UCD7: '9239406',
  UCD13: '3400892394060',
  ucdQtyMultiplicator: 20,
  cipLib: "ZALDIAR 37,5MG/325MG CPR BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '3919005',
  CIP13: '3400939190051',
  ucdLib: "IXPRIM 37,5MG/325MG C.EFFV",
  UCD7: '9331454',
  UCD13: '3400893314548',
  ucdQtyMultiplicator: 20,
  cipLib: "IXPRIM 37,5MG/325MG C.EFFV BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '5636062',
  CIP13: '3400956360628',
  ucdLib: "IXPRIM 37,5MG/325MG CPR",
  UCD7: '9247245',
  UCD13: '3400892472454',
  ucdQtyMultiplicator: 60,
  cipLib: "IXPRIM 37,5MG/325MG CPR BT 60",
  atcCode: "N02AJ13"
}, {
  CIP7: '5636033',
  CIP13: '3400956360338',
  ucdLib: "ZALDIAR 37,5MG/325MG CPR",
  UCD7: '9239406',
  UCD13: '3400892394060',
  ucdQtyMultiplicator: 60,
  cipLib: "ZALDIAR 37,5MG/325MG CPR BT 60",
  atcCode: "N02AJ13"
}, {
  CIP7: '2696112',
  CIP13: '3400926961121',
  ucdLib: "TRAMADOL/PAR.ARG 37,5/325 CP",
  UCD7: '9392384',
  UCD13: '3400893923849',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.ARG 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2696342',
  CIP13: '3400926963422',
  ucdLib: "TRAMADOL/PAR.CRT 37,5/325 CP",
  UCD7: '9392616',
  UCD13: '3400893926161',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.CRT 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2694248',
  CIP13: '3400926942489',
  ucdLib: "TRAMADOL/PAR.EGL 37,5/325 CP",
  UCD7: '9398197',
  UCD13: '3400893981979',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.EGL 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2694314',
  CIP13: '3400926943141',
  ucdLib: "TRAMADOL/PAR.RPG.37,5/325 CP",
  UCD7: '9392622',
  UCD13: '3400893926222',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.RPG.37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2751354',
  CIP13: '3400927513541',
  ucdLib: "TRAMADOL/PAR.ZYD 37,5/325 CP20",
  UCD7: '9403395',
  UCD13: '3400894033950',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.ZYD 37,5/325 CP20 BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2209603',
  CIP13: '3400922096032',
  ucdLib: "TRAMADOL/PAR.BGA 37,5/325 CP",
  UCD7: '9391226',
  UCD13: '3400893912263',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.BGA 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2732121',
  CIP13: '3400927321214',
  ucdLib: "TRAMADOL/PAR.EVO 37,5/325 CP",
  UCD7: '9394696',
  UCD13: '3400893946961',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.EVO 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2672146',
  CIP13: '3400926721466',
  ucdLib: "TRAMADOL/PAR.KRK 37,5/325 CP",
  UCD7: '9393840',
  UCD13: '3400893938409',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.KRK 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2209595',
  CIP13: '3400922095950',
  ucdLib: "TRAMADOL/PAR.MYG 37,5/325 CP",
  UCD7: '9386490',
  UCD13: '3400893864906',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.MYG 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2684592',
  CIP13: '3400926845926',
  ucdLib: "TRAMADOL/PAR.PHR 37,5/325 CP",
  UCD7: '9392935',
  UCD13: '3400893929353',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.PHR 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2209626',
  CIP13: '3400922096261',
  ucdLib: "TRAMADOL/PAR.SDZ 37,5/325 CP",
  UCD7: '9388796',
  UCD13: '3400893887967',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.SDZ 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2683807',
  CIP13: '3400926838072',
  ucdLib: "TRAMADOL/PAR.TVC 37,5/325 CP",
  UCD7: '9391686',
  UCD13: '3400893916865',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.TVC 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '2209632',
  CIP13: '3400922096322',
  ucdLib: "TRAMADOL/PAR.ZEN 37,5/325 CP",
  UCD7: '9386509',
  UCD13: '3400893865095',
  ucdQtyMultiplicator: 20,
  cipLib: "TRAMADOL/PAR.ZEN 37,5/325 CP BT 20",
  atcCode: "N02AJ13"
}, {
  CIP7: '5819957',
  CIP13: '3400958199578',
  ucdLib: "TRAMADOL/PAR.MYG 37,5/325 CP",
  UCD7: '9386490',
  UCD13: '3400893864906',
  ucdQtyMultiplicator: 60,
  cipLib: "TRAMADOL/PAR.MYG 37,5/325 CP BT 60",
  atcCode: "N02AJ13"
}, {
  CIP7: '3975558',
  CIP13: '3400939755588',
  ucdLib: "ANTARENE COD.200/30MG CPR",
  UCD7: '9367481',
  UCD13: '3400893674819',
  ucdQtyMultiplicator: 20,
  cipLib: "ANTARENE COD.200/30MG CPR BT 20",
  atcCode: "N02AJ08"
}, {
  CIP7: '3975587',
  CIP13: '3400939755878',
  ucdLib: "ANTARENE COD.400/60MG CPR",
  UCD7: '9367498',
  UCD13: '3400893674987',
  ucdQtyMultiplicator: 10,
  cipLib: "ANTARENE COD.400/60MG CPR BT 10",
  atcCode: "N02AJ08"
}, {
  CIP7: '3610503',
  CIP13: '3400936105034',
  ucdLib: "PARACET.COD BGA500/30MG C.EF",
  UCD7: '9259225',
  UCD13: '3400892592251',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACET.COD BGA500/30MG C.EF BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3610265',
  CIP13: '3400936102651',
  ucdLib: "PARACET.COD MYL500/30MG C.EF",
  UCD7: '9258674',
  UCD13: '3400892586748',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACET.COD MYL500/30MG C.EF BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3322075',
  CIP13: '3400933220754',
  ucdLib: "CODOLIPRANE AD. 400/20MG CPR",
  UCD7: '9129787',
  UCD13: '3400891297874',
  ucdQtyMultiplicator: 16,
  cipLib: "CODOLIPRANE AD. 400/20MG CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3327581',
  CIP13: '3400933275815',
  ucdLib: "DAFALGAN CODEINE CPR",
  UCD7: '9147928',
  UCD13: '3400891479287',
  ucdQtyMultiplicator: 16,
  cipLib: "DAFALGAN CODEINE CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3328379',
  CIP13: '3400933283797',
  ucdLib: "GAOSEDAL CODEINE CPR",
  UCD7: '9152823',
  UCD13: '3400891528237',
  ucdQtyMultiplicator: 12,
  cipLib: "GAOSEDAL CODEINE CPR BT 12",
  atcCode: "N02AJ06"
}, {
  CIP7: '3574865',
  CIP13: '3400935748652',
  ucdLib: "KLIPAL CODEI.300MG/25MG CPR",
  UCD7: '9234260',
  UCD13: '3400892342603',
  ucdQtyMultiplicator: 16,
  cipLib: "KLIPAL CODEI.300MG/25MG CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3574871',
  CIP13: '3400935748713',
  ucdLib: "KLIPAL CODEI.600MG/50MG CPR",
  UCD7: '9234277',
  UCD13: '3400892342771',
  ucdQtyMultiplicator: 12,
  cipLib: "KLIPAL CODEI.600MG/50MG CPR BT 12",
  atcCode: "N02AJ06"
}, {
  CIP7: '3577007',
  CIP13: '3400935770073',
  ucdLib: "PARACET.COD ARW400/20MG CPR",
  UCD7: '9237821',
  UCD13: '3400892378213',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACET.COD ARW400/20MG CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3318085',
  CIP13: '3400933180850',
  ucdLib: "LINDILANE 400MG/25MG CPR",
  UCD7: '9136184',
  UCD13: '3400891361841',
  ucdQtyMultiplicator: 16,
  cipLib: "LINDILANE 400MG/25MG CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3331909',
  CIP13: '3400933319090',
  ucdLib: "ALGISEDAL CPR",
  UCD7: '9002621',
  UCD13: '3400890026215',
  ucdQtyMultiplicator: 16,
  cipLib: "ALGISEDAL CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3330465',
  CIP13: '3400933304652',
  ucdLib: "CLARADOL 500MG CODEINE CPR",
  UCD7: '9149979',
  UCD13: '3400891499797',
  ucdQtyMultiplicator: 16,
  cipLib: "CLARADOL 500MG CODEINE CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3331677',
  CIP13: '3400933316778',
  ucdLib: "DAFALGAN CODEINE CPR EFFV",
  UCD7: '9128871',
  UCD13: '3400891288711',
  ucdQtyMultiplicator: 16,
  cipLib: "DAFALGAN CODEINE CPR EFFV BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '5569549',
  CIP13: '3400955695493',
  ucdLib: "KLIPAL CODEI.600MG/50MG CPR",
  UCD7: '9234277',
  UCD13: '3400892342771',
  ucdQtyMultiplicator: 100,
  cipLib: "KLIPAL CODEI.600MG/50MG CPR BT 100",
  atcCode: "N02AJ06"
}, {
  CIP7: '3689456',
  CIP13: '3400936894563',
  ucdLib: "PARACET.COD SDZ500/30MG C.EF",
  UCD7: '9273277',
  UCD13: '3400892732770',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACET.COD SDZ500/30MG C.EF BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3486606',
  CIP13: '3400934866067',
  ucdLib: "CODOLIPRANE ENF 400/20MG CPR",
  UCD7: '9205784',
  UCD13: '3400892057842',
  ucdQtyMultiplicator: 16,
  cipLib: "CODOLIPRANE ENF 400/20MG CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3488338',
  CIP13: '3400934883385',
  ucdLib: "COMPRALGYL 400MG/20MG CPR",
  UCD7: '9263161',
  UCD13: '3400892631615',
  ucdQtyMultiplicator: 16,
  cipLib: "COMPRALGYL 400MG/20MG CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3628940',
  CIP13: '3400936289406',
  ucdLib: "PARACET.COD ARW500/30MG C.EF",
  UCD7: '9260062',
  UCD13: '3400892600628',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACET.COD ARW500/30MG C.EF BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3628928',
  CIP13: '3400936289284',
  ucdLib: "PARACET.COD EG 500/30MG C.EF",
  UCD7: '9261216',
  UCD13: '3400892612164',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACET.COD EG 500/30MG C.EF BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '5609289',
  CIP13: '3400956092895',
  ucdLib: "CODOLIPRANE AD. 400/20MG CPR",
  UCD7: '9129787',
  UCD13: '3400891297874',
  ucdQtyMultiplicator: 100,
  cipLib: "CODOLIPRANE AD. 400/20MG CPR BT 100",
  atcCode: "N02AJ06"
}, {
  CIP7: '3902447',
  CIP13: '3400939024479',
  ucdLib: "CODOLIPRANE 500/30MG C.EFF",
  UCD7: '9385800',
  UCD13: '3400893858004',
  ucdQtyMultiplicator: 16,
  cipLib: "CODOLIPRANE 500/30MG C.EFF BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '3902364',
  CIP13: '3400939023649',
  ucdLib: "PARACET.COD CRT500/30MG C.EFFV",
  UCD7: '9328601',
  UCD13: '3400893286012',
  ucdQtyMultiplicator: 16,
  cipLib: "PARACET.COD CRT500/30MG C.EFFV BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '2756239',
  CIP13: '3400927562396',
  ucdLib: "CODOLIPRANE 500/30MG CPR",
  UCD7: '9393604',
  UCD13: '3400893936047',
  ucdQtyMultiplicator: 16,
  cipLib: "CODOLIPRANE 500/30MG CPR BT 16",
  atcCode: "N02AJ06"
}, {
  CIP7: '5846291',
  CIP13: '3400958462917',
  ucdLib: "CODOLIPRANE 500/30MG CPR",
  UCD7: '9393604',
  UCD13: '3400893936047',
  ucdQtyMultiplicator: 100,
  cipLib: "CODOLIPRANE 500/30MG CPR BT 100",
  atcCode: "N02AJ06"
}, {
  CIP7: '3689410',
  CIP13: '3400936894105',
  ucdLib: "NALBUPHINE SRB 20MG INJ A2ML",
  UCD7: '9243106',
  UCD13: '3400892431062',
  ucdQtyMultiplicator: 10,
  cipLib: "NALBUPHINE SRB 20MG INJ A2ML BT 10",
  atcCode: "N02AF02"
}, {
  CIP7: '3553946',
  CIP13: '3400935539465',
  ucdLib: "NALBUPHINE MYL 20MG INJ A2ML",
  UCD7: '9226852',
  UCD13: '3400892268521',
  ucdQtyMultiplicator: 10,
  cipLib: "NALBUPHINE MYL 20MG INJ A2ML BT 10",
  atcCode: "N02AF02"
}, {
  CIP7: '3583166',
  CIP13: '3400935831668',
  ucdLib: "NALBUPHINE REN 20MG INJ A2ML",
  UCD7: '9237985',
  UCD13: '3400892379852',
  ucdQtyMultiplicator: 10,
  cipLib: "NALBUPHINE REN 20MG INJ A2ML BT 10",
  atcCode: "N02AF02"
}, {
  CIP7: '3295272',
  CIP13: '3400932952724',
  ucdLib: "TEMGESIC 0,2MG CPR",
  UCD7: '9136008',
  UCD13: '3400891360080',
  ucdQtyMultiplicator: 20,
  cipLib: "TEMGESIC 0,2MG CPR BT 20",
  atcCode: "N02AE01"
}, {
  CIP7: '3295295',
  CIP13: '3400932952953',
  ucdLib: "TEMGESIC 0,2MG CPR",
  UCD7: '9136008',
  UCD13: '3400891360080',
  ucdQtyMultiplicator: 50,
  cipLib: "TEMGESIC 0,2MG CPR BT 50",
  atcCode: "N02AE01"
}, {
  CIP7: '3273106',
  CIP13: '3400932731060',
  ucdLib: "TEMGESIC 0,3MG INJ AMP1ML",
  UCD7: '9121662',
  UCD13: '3400891216622',
  ucdQtyMultiplicator: 10,
  cipLib: "TEMGESIC 0,3MG INJ AMP1ML BT 10",
  atcCode: "N02AE01"
}, {
  CIP7: '2765675',
  CIP13: '3400927656750',
  ucdLib: "RECIVIT 133MCG CPR SUBLING",
  UCD7: '9399073',
  UCD13: '3400893990735',
  ucdQtyMultiplicator: 15,
  cipLib: "RECIVIT 133MCG CPR SUBLING BT 15",
  atcCode: "N02AB03"
}, {
  CIP7: '2765698',
  CIP13: '3400927656989',
  ucdLib: "RECIVIT 133MCG CPR SUBLING",
  UCD7: '9399073',
  UCD13: '3400893990735',
  ucdQtyMultiplicator: 30,
  cipLib: "RECIVIT 133MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '2765770',
  CIP13: '3400927657702',
  ucdLib: "RECIVIT 267MCG CPR SUBLING",
  UCD7: '9399096',
  UCD13: '3400893990964',
  ucdQtyMultiplicator: 30,
  cipLib: "RECIVIT 267MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '2765853',
  CIP13: '3400927658532',
  ucdLib: "RECIVIT 400MCG CPR SUBLING",
  UCD7: '9399104',
  UCD13: '3400893991046',
  ucdQtyMultiplicator: 30,
  cipLib: "RECIVIT 400MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '2765959',
  CIP13: '3400927659591',
  ucdLib: "RECIVIT 533MCG CPR SUBLING",
  UCD7: '9399110',
  UCD13: '3400893991107',
  ucdQtyMultiplicator: 30,
  cipLib: "RECIVIT 533MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '2765586',
  CIP13: '3400927655869',
  ucdLib: "RECIVIT 67MCG CPR SUBLING",
  UCD7: '9399127',
  UCD13: '3400893991275',
  ucdQtyMultiplicator: 15,
  cipLib: "RECIVIT 67MCG CPR SUBLING BT 15",
  atcCode: "N02AB03"
}, {
  CIP7: '2766031',
  CIP13: '3400927660313',
  ucdLib: "RECIVIT 800MCG CPR SUBLING",
  UCD7: '9399133',
  UCD13: '3400893991336',
  ucdQtyMultiplicator: 30,
  cipLib: "RECIVIT 800MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '3379922',
  CIP13: '3400933799229',
  ucdLib: "FENTANYL ZEN 12MCG/H DISP SAC",
  UCD7: '9350492',
  UCD13: '3400893504925',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ZEN 12MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '4981213',
  CIP13: '3400949812134',
  ucdLib: "BREAKYL 200MCG FILM DISP",
  UCD7: '9390296',
  UCD13: '3400893902967',
  ucdQtyMultiplicator: 10,
  cipLib: "BREAKYL 200MCG FILM DISP BT 10",
  atcCode: "N02AB03"
}, {
  CIP7: '3851023',
  CIP13: '3400938510232',
  ucdLib: "FENTANYL ZEN 100MCG/H DISP S.",
  UCD7: '9323911',
  UCD13: '3400893239117',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ZEN 100MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3850934',
  CIP13: '3400938509342',
  ucdLib: "FENTANYL ZEN 25MCG/H DISP SAC",
  UCD7: '9323928',
  UCD13: '3400893239285',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ZEN 25MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3850957',
  CIP13: '3400938509571',
  ucdLib: "FENTANYL ZEN 50MCG/H DISP SAC",
  UCD7: '9323934',
  UCD13: '3400893239346',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ZEN 50MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3850986',
  CIP13: '3400938509861',
  ucdLib: "FENTANYL ZEN 75MCG/H DISP SAC",
  UCD7: '9323940',
  UCD13: '3400893239407',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ZEN 75MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3584384',
  CIP13: '3400935843845',
  ucdLib: "ACTIQ 1200MCG CPR BUC",
  UCD7: '9233740',
  UCD13: '3400892337401',
  ucdQtyMultiplicator: 3,
  cipLib: "ACTIQ 1200MCG CPR BUC BT 3",
  atcCode: "N02AB03"
}, {
  CIP7: '3584421',
  CIP13: '3400935844217',
  ucdLib: "ACTIQ 1600MCG CPR BUC",
  UCD7: '9233757',
  UCD13: '3400892337579',
  ucdQtyMultiplicator: 3,
  cipLib: "ACTIQ 1600MCG CPR BUC BT 3",
  atcCode: "N02AB03"
}, {
  CIP7: '3580630',
  CIP13: '3400935806307',
  ucdLib: "ACTIQ 200MCG CPR BUC",
  UCD7: '9233763',
  UCD13: '3400892337630',
  ucdQtyMultiplicator: 3,
  cipLib: "ACTIQ 200MCG CPR BUC BT 3",
  atcCode: "N02AB03"
}, {
  CIP7: '3580682',
  CIP13: '3400935806826',
  ucdLib: "ACTIQ 400MCG CPR BUC",
  UCD7: '9233786',
  UCD13: '3400892337869',
  ucdQtyMultiplicator: 3,
  cipLib: "ACTIQ 400MCG CPR BUC BT 3",
  atcCode: "N02AB03"
}, {
  CIP7: '3580736',
  CIP13: '3400935807366',
  ucdLib: "ACTIQ 600MCG CPR BUC",
  UCD7: '9233792',
  UCD13: '3400892337920',
  ucdQtyMultiplicator: 3,
  cipLib: "ACTIQ 600MCG CPR BUC BT 3",
  atcCode: "N02AB03"
}, {
  CIP7: '3584349',
  CIP13: '3400935843494',
  ucdLib: "ACTIQ 800MCG CPR BUC",
  UCD7: '9233800',
  UCD13: '3400892338002',
  ucdQtyMultiplicator: 3,
  cipLib: "ACTIQ 800MCG CPR BUC BT 3",
  atcCode: "N02AB03"
}, {
  CIP7: '3698515',
  CIP13: '3400936985155',
  ucdLib: "DUROGESIC 12MCG/H DISP TRANS",
  UCD7: '9284453',
  UCD13: '3400892844534',
  ucdQtyMultiplicator: 5,
  cipLib: "DUROGESIC 12MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3814950',
  CIP13: '3400938149500',
  ucdLib: "FENTANYL SDZ 12MCG/H DISP SAC",
  UCD7: '9333401',
  UCD13: '3400893334010',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL SDZ 12MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3922071',
  CIP13: '3400939220710',
  ucdLib: "EFFENTORA 100MCG CPR GGVL",
  UCD7: '9341300',
  UCD13: '3400893413005',
  ucdQtyMultiplicator: 4,
  cipLib: "EFFENTORA 100MCG CPR GGVL BT 4",
  atcCode: "N02AB03"
}, {
  CIP7: '3922088',
  CIP13: '3400939220888',
  ucdLib: "EFFENTORA 100MCG CPR GGVL",
  UCD7: '9341300',
  UCD13: '3400893413005',
  ucdQtyMultiplicator: 28,
  cipLib: "EFFENTORA 100MCG CPR GGVL BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '3922094',
  CIP13: '3400939220949',
  ucdLib: "EFFENTORA 200MCG CPR GGVL",
  UCD7: '9341317',
  UCD13: '3400893413173',
  ucdQtyMultiplicator: 4,
  cipLib: "EFFENTORA 200MCG CPR GGVL BT 4",
  atcCode: "N02AB03"
}, {
  CIP7: '3922102',
  CIP13: '3400939221021',
  ucdLib: "EFFENTORA 200MCG CPR GGVL",
  UCD7: '9341317',
  UCD13: '3400893413173',
  ucdQtyMultiplicator: 28,
  cipLib: "EFFENTORA 200MCG CPR GGVL BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '3922125',
  CIP13: '3400939221250',
  ucdLib: "EFFENTORA 400MCG CPR GGVL",
  UCD7: '9341323',
  UCD13: '3400893413234',
  ucdQtyMultiplicator: 28,
  cipLib: "EFFENTORA 400MCG CPR GGVL BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '3922148',
  CIP13: '3400939221489',
  ucdLib: "EFFENTORA 600MCG CPR GGVL",
  UCD7: '9341346',
  UCD13: '3400893413463',
  ucdQtyMultiplicator: 28,
  cipLib: "EFFENTORA 600MCG CPR GGVL BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '3922160',
  CIP13: '3400939221601',
  ucdLib: "EFFENTORA 800MCG CPR GGVL",
  UCD7: '9341352',
  UCD13: '3400893413524',
  ucdQtyMultiplicator: 28,
  cipLib: "EFFENTORA 800MCG CPR GGVL BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '3920209',
  CIP13: '3400939202099',
  ucdLib: "FENTANYL BGA 100MCG/H DISP S.",
  UCD7: '9331359',
  UCD13: '3400893313596',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL BGA 100MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3920043',
  CIP13: '3400939200439',
  ucdLib: "FENTANYL BGA 25MCG/H DISP SAC",
  UCD7: '9331365',
  UCD13: '3400893313657',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL BGA 25MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3920066',
  CIP13: '3400939200668',
  ucdLib: "FENTANYL BGA 50MCG/H DISP SAC",
  UCD7: '9331371',
  UCD13: '3400893313718',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL BGA 50MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3920072',
  CIP13: '3400939200729',
  ucdLib: "FENTANYL BGA 75MCG/H DISP SAC",
  UCD7: '9331388',
  UCD13: '3400893313886',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL BGA 75MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3921344',
  CIP13: '3400939213446',
  ucdLib: "FENTANYL TVC 25MCG/H DISP",
  UCD7: '9334211',
  UCD13: '3400893342114',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL TVC 25MCG/H DISP BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3865284',
  CIP13: '3400938652840',
  ucdLib: "MATRIFEN 100MCG/H DISP TRANS",
  UCD7: '9318270',
  UCD13: '3400893182703',
  ucdQtyMultiplicator: 5,
  cipLib: "MATRIFEN 100MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3865048',
  CIP13: '3400938650488',
  ucdLib: "MATRIFEN 12MCG/H DISP TRANS",
  UCD7: '9316897',
  UCD13: '3400893168974',
  ucdQtyMultiplicator: 5,
  cipLib: "MATRIFEN 12MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3865108',
  CIP13: '3400938651089',
  ucdLib: "MATRIFEN 25MCG/H DISP TRANS",
  UCD7: '9318287',
  UCD13: '3400893182871',
  ucdQtyMultiplicator: 5,
  cipLib: "MATRIFEN 25MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3865172',
  CIP13: '3400938651720',
  ucdLib: "MATRIFEN 50MCG/H DISP TRANS",
  UCD7: '9318293',
  UCD13: '3400893182932',
  ucdQtyMultiplicator: 5,
  cipLib: "MATRIFEN 50MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3865232',
  CIP13: '3400938652321',
  ucdLib: "MATRIFEN 75MCG/H DISP TRANS",
  UCD7: '9318301',
  UCD13: '3400893183014',
  ucdQtyMultiplicator: 5,
  cipLib: "MATRIFEN 75MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3910429',
  CIP13: '3400939104294',
  ucdLib: "ABSTRAL 100MCG CPR SUBLING",
  UCD7: '9328498',
  UCD13: '3400893284988',
  ucdQtyMultiplicator: 10,
  cipLib: "ABSTRAL 100MCG CPR SUBLING BT 10",
  atcCode: "N02AB03"
}, {
  CIP7: '3910435',
  CIP13: '3400939104355',
  ucdLib: "ABSTRAL 100MCG CPR SUBLING",
  UCD7: '9328498',
  UCD13: '3400893284988',
  ucdQtyMultiplicator: 30,
  cipLib: "ABSTRAL 100MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '3910441',
  CIP13: '3400939104416',
  ucdLib: "ABSTRAL 200MCG CPR SUBLING",
  UCD7: '9328506',
  UCD13: '3400893285060',
  ucdQtyMultiplicator: 10,
  cipLib: "ABSTRAL 200MCG CPR SUBLING BT 10",
  atcCode: "N02AB03"
}, {
  CIP7: '3910458',
  CIP13: '3400939104584',
  ucdLib: "ABSTRAL 200MCG CPR SUBLING",
  UCD7: '9328506',
  UCD13: '3400893285060',
  ucdQtyMultiplicator: 30,
  cipLib: "ABSTRAL 200MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '3910464',
  CIP13: '3400939104645',
  ucdLib: "ABSTRAL 300MCG CPR SUBLING",
  UCD7: '9328512',
  UCD13: '3400893285121',
  ucdQtyMultiplicator: 10,
  cipLib: "ABSTRAL 300MCG CPR SUBLING BT 10",
  atcCode: "N02AB03"
}, {
  CIP7: '3910470',
  CIP13: '3400939104706',
  ucdLib: "ABSTRAL 300MCG CPR SUBLING",
  UCD7: '9328512',
  UCD13: '3400893285121',
  ucdQtyMultiplicator: 30,
  cipLib: "ABSTRAL 300MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '3910487',
  CIP13: '3400939104874',
  ucdLib: "ABSTRAL 400MCG CPR SUBLING",
  UCD7: '9328529',
  UCD13: '3400893285299',
  ucdQtyMultiplicator: 10,
  cipLib: "ABSTRAL 400MCG CPR SUBLING BT 10",
  atcCode: "N02AB03"
}, {
  CIP7: '3910493',
  CIP13: '3400939104935',
  ucdLib: "ABSTRAL 400MCG CPR SUBLING",
  UCD7: '9328529',
  UCD13: '3400893285299',
  ucdQtyMultiplicator: 30,
  cipLib: "ABSTRAL 400MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '3910518',
  CIP13: '3400939105185',
  ucdLib: "ABSTRAL 600MCG CPR SUBLING",
  UCD7: '9328541',
  UCD13: '3400893285411',
  ucdQtyMultiplicator: 30,
  cipLib: "ABSTRAL 600MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '3910576',
  CIP13: '3400939105765',
  ucdLib: "ABSTRAL 800MCG CPR SUBLING",
  UCD7: '9328558',
  UCD13: '3400893285589',
  ucdQtyMultiplicator: 30,
  cipLib: "ABSTRAL 800MCG CPR SUBLING BT 30",
  atcCode: "N02AB03"
}, {
  CIP7: '3964135',
  CIP13: '3400939641355',
  ucdLib: "FENTANYL ARW 100MCG/H DISP S.",
  UCD7: '9341470',
  UCD13: '3400893414705',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ARW 100MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3964098',
  CIP13: '3400939640983',
  ucdLib: "FENTANYL ARW 25MCG/H DISP SAC",
  UCD7: '9341487',
  UCD13: '3400893414873',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ARW 25MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3964170',
  CIP13: '3400939641706',
  ucdLib: "FENTANYL ARW 50MCG/H DISP SAC",
  UCD7: '9341493',
  UCD13: '3400893414934',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ARW 50MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3969925',
  CIP13: '3400939699257',
  ucdLib: "FENTANYL ARW 75MCG/H DISP SAC",
  UCD7: '9341501',
  UCD13: '3400893415016',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL ARW 75MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3939232',
  CIP13: '3400939392325',
  ucdLib: "FENTANYL SDZ 100MCG/H DISP S.",
  UCD7: '9333393',
  UCD13: '3400893333938',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL SDZ 100MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3939054',
  CIP13: '3400939390543',
  ucdLib: "FENTANYL SDZ 25MCG/H DISP SAC",
  UCD7: '9333418',
  UCD13: '3400893334188',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL SDZ 25MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3939114',
  CIP13: '3400939391144',
  ucdLib: "FENTANYL SDZ 50MCG/H DISP SAC",
  UCD7: '9333424',
  UCD13: '3400893334249',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL SDZ 50MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3939189',
  CIP13: '3400939391892',
  ucdLib: "FENTANYL SDZ 75MCG/H DISP SAC",
  UCD7: '9333430',
  UCD13: '3400893334300',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL SDZ 75MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3931495',
  CIP13: '3400939314952',
  ucdLib: "FENTANYL TVC 100MCG/H DISP",
  UCD7: '9334205',
  UCD13: '3400893342053',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL TVC 100MCG/H DISP BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3971193',
  CIP13: '3400939711935',
  ucdLib: "INSTANYL 100Y/DOS NAS FL1,8ML",
  UCD7: '9339148',
  UCD13: '3400893391488',
  ucdQtyMultiplicator: 1,
  cipLib: "INSTANYL 100Y/DOS NAS FL1,8ML BT 1",
  atcCode: "N02AB03"
}, {
  CIP7: '3971201',
  CIP13: '3400939712017',
  ucdLib: "INSTANYL 200Y/DOS NAS FL1,8ML",
  UCD7: '9339154',
  UCD13: '3400893391549',
  ucdQtyMultiplicator: 1,
  cipLib: "INSTANYL 200Y/DOS NAS FL1,8ML BT 1",
  atcCode: "N02AB03"
}, {
  CIP7: '3971187',
  CIP13: '3400939711874',
  ucdLib: "INSTANYL 50Y/DOS NAS FL1,8ML",
  UCD7: '9339160',
  UCD13: '3400893391600',
  ucdQtyMultiplicator: 1,
  cipLib: "INSTANYL 50Y/DOS NAS FL1,8ML BT 1",
  atcCode: "N02AB03"
}, {
  CIP7: '3984362',
  CIP13: '3400939843629',
  ucdLib: "FENTANYL EG 12Y/H DISP S.ENF",
  UCD7: '9343859',
  UCD13: '3400893438596',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL EG 12Y/H DISP S.ENF BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3984451',
  CIP13: '3400939844510',
  ucdLib: "FENTANYL EG 25Y/H DISP S.ENF",
  UCD7: '9343865',
  UCD13: '3400893438657',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL EG 25Y/H DISP S.ENF BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3984534',
  CIP13: '3400939845340',
  ucdLib: "FENTANYL EG 50Y/H DISP S.ENF",
  UCD7: '9343871',
  UCD13: '3400893438718',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL EG 50Y/H DISP S.ENF BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3984646',
  CIP13: '3400939846460',
  ucdLib: "FENTANYL EG 75Y/H DISP S.ENF",
  UCD7: '9343888',
  UCD13: '3400893438886',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL EG 75Y/H DISP S.ENF BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2756133',
  CIP13: '3400927561337',
  ucdLib: "FENTANYL TVS 100MCG/H DISP S.",
  UCD7: '9317773',
  UCD13: '3400893177730',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL TVS 100MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2756044',
  CIP13: '3400927560446',
  ucdLib: "FENTANYL TVS 12MCG/H DISP SAC",
  UCD7: '9317796',
  UCD13: '3400893177969',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL TVS 12MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2756067',
  CIP13: '3400927560675',
  ucdLib: "FENTANYL TVS 25MCG/H DISP SAC",
  UCD7: '9317804',
  UCD13: '3400893178041',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL TVS 25MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2756096',
  CIP13: '3400927560965',
  ucdLib: "FENTANYL TVS 50MCG/H DISP SAC",
  UCD7: '9317810',
  UCD13: '3400893178102',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL TVS 50MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2756110',
  CIP13: '3400927561108',
  ucdLib: "FENTANYL TVS 75MCG/H DISP SAC",
  UCD7: '9317827',
  UCD13: '3400893178270',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL TVS 75MCG/H DISP SAC BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2185794',
  CIP13: '3400921857948',
  ucdLib: "BREAKYL 1200MCG FILM DISP",
  UCD7: '9390273',
  UCD13: '3400893902738',
  ucdQtyMultiplicator: 28,
  cipLib: "BREAKYL 1200MCG FILM DISP BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '2185647',
  CIP13: '3400921856477',
  ucdLib: "BREAKYL 200MCG FILM DISP",
  UCD7: '9390296',
  UCD13: '3400893902967',
  ucdQtyMultiplicator: 4,
  cipLib: "BREAKYL 200MCG FILM DISP BT 4",
  atcCode: "N02AB03"
}, {
  CIP7: '2185653',
  CIP13: '3400921856538',
  ucdLib: "BREAKYL 200MCG FILM DISP",
  UCD7: '9390296',
  UCD13: '3400893902967',
  ucdQtyMultiplicator: 28,
  cipLib: "BREAKYL 200MCG FILM DISP BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '2185676',
  CIP13: '3400921856767',
  ucdLib: "BREAKYL 400MCG FILM DISP",
  UCD7: '9390304',
  UCD13: '3400893903049',
  ucdQtyMultiplicator: 4,
  cipLib: "BREAKYL 400MCG FILM DISP BT 4",
  atcCode: "N02AB03"
}, {
  CIP7: '2185682',
  CIP13: '3400921856828',
  ucdLib: "BREAKYL 400MCG FILM DISP",
  UCD7: '9390304',
  UCD13: '3400893903049',
  ucdQtyMultiplicator: 10,
  cipLib: "BREAKYL 400MCG FILM DISP BT 10",
  atcCode: "N02AB03"
}, {
  CIP7: '2185699',
  CIP13: '3400921856996',
  ucdLib: "BREAKYL 400MCG FILM DISP",
  UCD7: '9390304',
  UCD13: '3400893903049',
  ucdQtyMultiplicator: 28,
  cipLib: "BREAKYL 400MCG FILM DISP BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '2185707',
  CIP13: '3400921857078',
  ucdLib: "BREAKYL 600MCG FILM DISP",
  UCD7: '9390310',
  UCD13: '3400893903100',
  ucdQtyMultiplicator: 4,
  cipLib: "BREAKYL 600MCG FILM DISP BT 4",
  atcCode: "N02AB03"
}, {
  CIP7: '2185713',
  CIP13: '3400921857139',
  ucdLib: "BREAKYL 600MCG FILM DISP",
  UCD7: '9390310',
  UCD13: '3400893903100',
  ucdQtyMultiplicator: 10,
  cipLib: "BREAKYL 600MCG FILM DISP BT 10",
  atcCode: "N02AB03"
}, {
  CIP7: '2185736',
  CIP13: '3400921857368',
  ucdLib: "BREAKYL 600MCG FILM DISP",
  UCD7: '9390310',
  UCD13: '3400893903100',
  ucdQtyMultiplicator: 28,
  cipLib: "BREAKYL 600MCG FILM DISP BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '2185765',
  CIP13: '3400921857658',
  ucdLib: "BREAKYL 800MCG FILM DISP",
  UCD7: '9390327',
  UCD13: '3400893903278',
  ucdQtyMultiplicator: 28,
  cipLib: "BREAKYL 800MCG FILM DISP BT 28",
  atcCode: "N02AB03"
}, {
  CIP7: '3990339',
  CIP13: '3400939903392',
  ucdLib: "FENTANYL EG 100Y/H DISP S.ENF",
  UCD7: '9343842',
  UCD13: '3400893438428',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL EG 100Y/H DISP S.ENF BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2230342',
  CIP13: '3400922303420',
  ucdLib: "FENTANYL MYL 100MCG/H DISP S.",
  UCD7: '9393082',
  UCD13: '3400893930823',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL MYL 100MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2230193',
  CIP13: '3400922301938',
  ucdLib: "FENTANYL MYL 12MCG/H DISP S.",
  UCD7: '9393099',
  UCD13: '3400893930991',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL MYL 12MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2230230',
  CIP13: '3400922302300',
  ucdLib: "FENTANYL MYL 25MCG/H DISP S.",
  UCD7: '9393107',
  UCD13: '3400893931073',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL MYL 25MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2230276',
  CIP13: '3400922302768',
  ucdLib: "FENTANYL MYL 50MCG/H DISP S.",
  UCD7: '9393113',
  UCD13: '3400893931134',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL MYL 50MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2230307',
  CIP13: '3400922303079',
  ucdLib: "FENTANYL MYL 75MCG/H DISP S.",
  UCD7: '9393136',
  UCD13: '3400893931363',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL MYL 75MCG/H DISP S. BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '2162511',
  CIP13: '3400921625110',
  ucdLib: "INSTANYL 100MCG NAS UNIDOS",
  UCD7: '9372588',
  UCD13: '3400893725887',
  ucdQtyMultiplicator: 6,
  cipLib: "INSTANYL 100MCG NAS UNIDOS BT 6",
  atcCode: "N02AB03"
}, {
  CIP7: '2162557',
  CIP13: '3400921625578',
  ucdLib: "INSTANYL 200MCG NAS UNIDOS",
  UCD7: '9372594',
  UCD13: '3400893725948',
  ucdQtyMultiplicator: 6,
  cipLib: "INSTANYL 200MCG NAS UNIDOS BT 6",
  atcCode: "N02AB03"
}, {
  CIP7: '2162474',
  CIP13: '3400921624748',
  ucdLib: "INSTANYL 50MCG NAS UNIDOS",
  UCD7: '9372602',
  UCD13: '3400893726020',
  ucdQtyMultiplicator: 6,
  cipLib: "INSTANYL 50MCG NAS UNIDOS BT 6",
  atcCode: "N02AB03"
}, {
  CIP7: '4966633',
  CIP13: '3400949666331',
  ucdLib: "PECFENT 100MCG/PULV NAS1,55ML",
  UCD7: '9372683',
  UCD13: '3400893726839',
  ucdQtyMultiplicator: 1,
  cipLib: "PECFENT 100MCG/PULV NAS1,55ML BT 1",
  atcCode: "N02AB03"
}, {
  CIP7: '4966662',
  CIP13: '3400949666621',
  ucdLib: "PECFENT 400MCG/PULV NAS1,55ML",
  UCD7: '9372708',
  UCD13: '3400893727089',
  ucdQtyMultiplicator: 1,
  cipLib: "PECFENT 400MCG/PULV NAS1,55ML BT 1",
  atcCode: "N02AB03"
}, {
  CIP7: '3423876',
  CIP13: '3400934238765',
  ucdLib: "DUROGESIC 100MCG/H DISP TRANS",
  UCD7: '9193756',
  UCD13: '3400891937565',
  ucdQtyMultiplicator: 5,
  cipLib: "DUROGESIC 100MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3423830',
  CIP13: '3400934238307',
  ucdLib: "DUROGESIC 25MCG/H DISP TRANS",
  UCD7: '9193762',
  UCD13: '3400891937626',
  ucdQtyMultiplicator: 5,
  cipLib: "DUROGESIC 25MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3423847',
  CIP13: '3400934238475',
  ucdLib: "DUROGESIC 50MCG/H DISP TRANS",
  UCD7: '9193779',
  UCD13: '3400891937794',
  ucdQtyMultiplicator: 5,
  cipLib: "DUROGESIC 50MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3423853',
  CIP13: '3400934238536',
  ucdLib: "DUROGESIC 75MCG/H DISP TRANS",
  UCD7: '9193785',
  UCD13: '3400891937855',
  ucdQtyMultiplicator: 5,
  cipLib: "DUROGESIC 75MCG/H DISP TRANS BT 5",
  atcCode: "N02AB03"
}, {
  CIP7: '3620306',
  CIP13: '3400936203068',
  ucdLib: "PETHIDINE REN 50MG/ML AB2ML",
  UCD7: '9251206',
  UCD13: '3400892512068',
  ucdQtyMultiplicator: 10,
  cipLib: "PETHIDINE REN 50MG/ML AB2ML BT 10",
  atcCode: "N02AB02"
}, {
  CIP7: '3368479',
  CIP13: '3400933684792',
  ucdLib: "DICODIN LP 60MG CPR",
  UCD7: '9151143',
  UCD13: '3400891511437',
  ucdQtyMultiplicator: 20,
  cipLib: "DICODIN LP 60MG CPR BT 20",
  atcCode: "N02AA08"
}, {
  CIP7: '3003903',
  CIP13: '3400930039038',
  ucdLib: "OXYCODONE AGT 10MG/ML AMP1ML",
  UCD7: '9415234',
  UCD13: '3400894152347',
  ucdQtyMultiplicator: 5,
  cipLib: "OXYCODONE AGT 10MG/ML AMP1ML BT 5",
  atcCode: "N02AA05"
}, {
  CIP7: '3003905',
  CIP13: '3400930039052',
  ucdLib: "OXYCODONE AGT 10MG/ML AMP20ML",
  UCD7: '9415240',
  UCD13: '3400894152408',
  ucdQtyMultiplicator: 5,
  cipLib: "OXYCODONE AGT 10MG/ML AMP20ML BT 5",
  atcCode: "N02AA05"
}, {
  CIP7: '3003904',
  CIP13: '3400930039045',
  ucdLib: "OXYCODONE AGT 10MG/ML AMP2ML",
  UCD7: '9415754',
  UCD13: '3400894157540',
  ucdQtyMultiplicator: 5,
  cipLib: "OXYCODONE AGT 10MG/ML AMP2ML BT 5",
  atcCode: "N02AA05"
}, {
  CIP7: '3003900',
  CIP13: '3400930039007',
  ucdLib: "OXYCODONE AGT 50MG/ML AMP1ML",
  UCD7: '9415760',
  UCD13: '3400894157601',
  ucdQtyMultiplicator: 5,
  cipLib: "OXYCODONE AGT 50MG/ML AMP1ML BT 5",
  atcCode: "N02AA05"
}, {
  CIP7: '3624215',
  CIP13: '3400936242159',
  ucdLib: "OXYNORM 10MG GELU",
  UCD7: '9250365',
  UCD13: '3400892503653',
  ucdQtyMultiplicator: 14,
  cipLib: "OXYNORM 10MG GELU BT 14",
  atcCode: "N02AA05"
}, {
  CIP7: '3624238',
  CIP13: '3400936242388',
  ucdLib: "OXYNORM 20MG GELU",
  UCD7: '9250371',
  UCD13: '3400892503714',
  ucdQtyMultiplicator: 14,
  cipLib: "OXYNORM 20MG GELU BT 14",
  atcCode: "N02AA05"
}, {
  CIP7: '3624190',
  CIP13: '3400936241909',
  ucdLib: "OXYNORM 5MG GELU",
  UCD7: '9250388',
  UCD13: '3400892503882',
  ucdQtyMultiplicator: 14,
  cipLib: "OXYNORM 5MG GELU BT 14",
  atcCode: "N02AA05"
}, {
  CIP7: '3542090',
  CIP13: '3400935420909',
  ucdLib: "OXYCONTIN LP 10MG CPR",
  UCD7: '9235101',
  UCD13: '3400892351018',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 10MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3542150',
  CIP13: '3400935421500',
  ucdLib: "OXYCONTIN LP 20MG CPR",
  UCD7: '9235118',
  UCD13: '3400892351186',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 20MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3542227',
  CIP13: '3400935422279',
  ucdLib: "OXYCONTIN LP 40MG CPR",
  UCD7: '9235124',
  UCD13: '3400892351247',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 40MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3542948',
  CIP13: '3400935429483',
  ucdLib: "OXYCONTIN LP 80MG CPR",
  UCD7: '9235130',
  UCD13: '3400892351308',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 80MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3669034',
  CIP13: '3400936690349',
  ucdLib: "OXYCONTIN LP 5MG CPR",
  UCD7: '9276399',
  UCD13: '3400892763996',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 5MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3669123',
  CIP13: '3400936691230',
  ucdLib: "OXYNORM 10MG/ML BUV FL30ML",
  UCD7: '9276407',
  UCD13: '3400892764078',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYNORM 10MG/ML BUV FL30ML BT 1",
  atcCode: "N02AA05"
}, {
  CIP7: '3669146',
  CIP13: '3400936691469',
  ucdLib: "OXYNORM 10MG/ML INJ AMP1ML",
  UCD7: '9276413',
  UCD13: '3400892764139',
  ucdQtyMultiplicator: 5,
  cipLib: "OXYNORM 10MG/ML INJ AMP1ML BT 5",
  atcCode: "N02AA05"
}, {
  CIP7: '3669152',
  CIP13: '3400936691520',
  ucdLib: "OXYNORM 10MG/ML INJ AMP2ML",
  UCD7: '9276436',
  UCD13: '3400892764368',
  ucdQtyMultiplicator: 5,
  cipLib: "OXYNORM 10MG/ML INJ AMP2ML BT 5",
  atcCode: "N02AA05"
}, {
  CIP7: '3923171',
  CIP13: '3400939231716',
  ucdLib: "OXYNORM 10MG/ML INJ AMP20ML",
  UCD7: '9331477',
  UCD13: '3400893314777',
  ucdQtyMultiplicator: 4,
  cipLib: "OXYNORM 10MG/ML INJ AMP20ML BT 4",
  atcCode: "N02AA05"
}, {
  CIP7: '3876253',
  CIP13: '3400938762532',
  ucdLib: "OXYNORM 50MG/ML INJ AMP1ML",
  UCD7: '9319016',
  UCD13: '3400893190166',
  ucdQtyMultiplicator: 5,
  cipLib: "OXYNORM 50MG/ML INJ AMP1ML BT 5",
  atcCode: "N02AA05"
}, {
  CIP7: '3804259',
  CIP13: '3400938042597',
  ucdLib: "OXYNORMORO 10MG CPR ORODISP",
  UCD7: '9311374',
  UCD13: '3400893113745',
  ucdQtyMultiplicator: 14,
  cipLib: "OXYNORMORO 10MG CPR ORODISP BT 14",
  atcCode: "N02AA05"
}, {
  CIP7: '3804288',
  CIP13: '3400938042887',
  ucdLib: "OXYNORMORO 20MG CPR ORODISP",
  UCD7: '9311380',
  UCD13: '3400893113806',
  ucdQtyMultiplicator: 14,
  cipLib: "OXYNORMORO 20MG CPR ORODISP BT 14",
  atcCode: "N02AA05"
}, {
  CIP7: '3804213',
  CIP13: '3400938042139',
  ucdLib: "OXYNORMORO 5MG CPR ORODISP",
  UCD7: '9311397',
  UCD13: '3400893113974',
  ucdQtyMultiplicator: 14,
  cipLib: "OXYNORMORO 5MG CPR ORODISP BT 14",
  atcCode: "N02AA05"
}, {
  CIP7: '3846022',
  CIP13: '3400938460223',
  ucdLib: "OXYCONTIN LP 120MG CPR",
  UCD7: '9311606',
  UCD13: '3400893116067',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 120MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3845844',
  CIP13: '3400938458442',
  ucdLib: "OXYCONTIN LP 15MG CPR",
  UCD7: '9311612',
  UCD13: '3400893116128',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 15MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3845873',
  CIP13: '3400938458732',
  ucdLib: "OXYCONTIN LP 30MG CPR",
  UCD7: '9311635',
  UCD13: '3400893116357',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 30MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3845985',
  CIP13: '3400938459852',
  ucdLib: "OXYCONTIN LP 60MG CPR",
  UCD7: '9311641',
  UCD13: '3400893116418',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCONTIN LP 60MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2788937',
  CIP13: '3400927889370',
  ucdLib: "OXYCODONE MYL LP 10MG CPR",
  UCD7: '9403863',
  UCD13: '3400894038634',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE MYL LP 10MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2788972',
  CIP13: '3400927889721',
  ucdLib: "OXYCODONE MYL LP 20MG CPR",
  UCD7: '9403886',
  UCD13: '3400894038863',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE MYL LP 20MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2789003',
  CIP13: '3400927890031',
  ucdLib: "OXYCODONE MYL LP 40MG CPR",
  UCD7: '9403892',
  UCD13: '3400894038924',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE MYL LP 40MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2788908',
  CIP13: '3400927889080',
  ucdLib: "OXYCODONE MYL LP 5MG CPR",
  UCD7: '9403900',
  UCD13: '3400894039006',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE MYL LP 5MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2788860',
  CIP13: '3400927888601',
  ucdLib: "OXYCODONE MYL LP 80MG CPR",
  UCD7: '9403917',
  UCD13: '3400894039174',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE MYL LP 80MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2775165',
  CIP13: '3400927751653',
  ucdLib: "OXYCODONE EG LP 10MG CPR",
  UCD7: '9405885',
  UCD13: '3400894058854',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE EG LP 10MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2775372',
  CIP13: '3400927753725',
  ucdLib: "OXYCODONE EG LP 15MG CPR",
  UCD7: '9405891',
  UCD13: '3400894058915',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE EG LP 15MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2775509',
  CIP13: '3400927755095',
  ucdLib: "OXYCODONE EG LP 20MG CPR",
  UCD7: '9405916',
  UCD13: '3400894059165',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE EG LP 20MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2775633',
  CIP13: '3400927756337',
  ucdLib: "OXYCODONE EG LP 30MG CPR",
  UCD7: '9405922',
  UCD13: '3400894059226',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE EG LP 30MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2775797',
  CIP13: '3400927757976',
  ucdLib: "OXYCODONE EG LP 40MG CPR",
  UCD7: '9405939',
  UCD13: '3400894059394',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE EG LP 40MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2774875',
  CIP13: '3400927748752',
  ucdLib: "OXYCODONE EG LP 5MG CPR",
  UCD7: '9405945',
  UCD13: '3400894059455',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE EG LP 5MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2775923',
  CIP13: '3400927759239',
  ucdLib: "OXYCODONE EG LP 60MG CPR",
  UCD7: '9405951',
  UCD13: '3400894059516',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE EG LP 60MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '2776058',
  CIP13: '3400927760587',
  ucdLib: "OXYCODONE EG LP 80MG CPR",
  UCD7: '9405968',
  UCD13: '3400894059684',
  ucdQtyMultiplicator: 28,
  cipLib: "OXYCODONE EG LP 80MG CPR BT 28",
  atcCode: "N02AA05"
}, {
  CIP7: '3489065',
  CIP13: '3400934890659',
  ucdLib: "SOPHIDONE LP 16MG GELU",
  UCD7: '9206281',
  UCD13: '3400892062815',
  ucdQtyMultiplicator: 14,
  cipLib: "SOPHIDONE LP 16MG GELU BT 14",
  atcCode: "N02AA03"
}, {
  CIP7: '3489088',
  CIP13: '3400934890888',
  ucdLib: "SOPHIDONE LP 24MG GELU",
  UCD7: '9206298',
  UCD13: '3400892062983',
  ucdQtyMultiplicator: 14,
  cipLib: "SOPHIDONE LP 24MG GELU BT 14",
  atcCode: "N02AA03"
}, {
  CIP7: '3489013',
  CIP13: '3400934890130',
  ucdLib: "SOPHIDONE LP 4MG GELU",
  UCD7: '9206306',
  UCD13: '3400892063065',
  ucdQtyMultiplicator: 14,
  cipLib: "SOPHIDONE LP 4MG GELU BT 14",
  atcCode: "N02AA03"
}, {
  CIP7: '3489042',
  CIP13: '3400934890420',
  ucdLib: "SOPHIDONE LP 8MG GELU",
  UCD7: '9206312',
  UCD13: '3400892063126',
  ucdQtyMultiplicator: 14,
  cipLib: "SOPHIDONE LP 8MG GELU BT 14",
  atcCode: "N02AA03"
}, {
  CIP7: '5535326',
  CIP13: '3400955353263',
  ucdLib: "MORPHINE 10MG LAV S/C 1ML",
  UCD7: '9059816',
  UCD13: '3400890598163',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 10MG LAV S/C 1ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5535332',
  CIP13: '3400955353324',
  ucdLib: "MORPHINE 20MG/ML LAV AV1ML",
  UCD7: '9059822',
  UCD13: '3400890598224',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 20MG/ML LAV AV1ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '3287002',
  CIP13: '3400932870028',
  ucdLib: "MOSCONTIN LP 100MG CPR",
  UCD7: '9117471',
  UCD13: '3400891174717',
  ucdQtyMultiplicator: 14,
  cipLib: "MOSCONTIN LP 100MG CPR BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3286971',
  CIP13: '3400932869718',
  ucdLib: "MOSCONTIN LP 10MG CPR",
  UCD7: '9117465',
  UCD13: '3400891174656',
  ucdQtyMultiplicator: 14,
  cipLib: "MOSCONTIN LP 10MG CPR BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3286988',
  CIP13: '3400932869886',
  ucdLib: "MOSCONTIN LP 30MG CPR",
  UCD7: '9117488',
  UCD13: '3400891174885',
  ucdQtyMultiplicator: 14,
  cipLib: "MOSCONTIN LP 30MG CPR BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3286994',
  CIP13: '3400932869947',
  ucdLib: "MOSCONTIN LP 60MG CPR",
  UCD7: '9117494',
  UCD13: '3400891174946',
  ucdQtyMultiplicator: 14,
  cipLib: "MOSCONTIN LP 60MG CPR BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3332381',
  CIP13: '3400933323813',
  ucdLib: "SKENAN LP 100MG GELU",
  UCD7: '9151048',
  UCD13: '3400891510485',
  ucdQtyMultiplicator: 14,
  cipLib: "SKENAN LP 100MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3332352',
  CIP13: '3400933323523',
  ucdLib: "SKENAN LP 10MG GELU",
  UCD7: '9151031',
  UCD13: '3400891510317',
  ucdQtyMultiplicator: 14,
  cipLib: "SKENAN LP 10MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3332369',
  CIP13: '3400933323691',
  ucdLib: "SKENAN LP 30MG GELU",
  UCD7: '9151054',
  UCD13: '3400891510546',
  ucdQtyMultiplicator: 14,
  cipLib: "SKENAN LP 30MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3332375',
  CIP13: '3400933323752',
  ucdLib: "SKENAN LP 60MG GELU",
  UCD7: '9151060',
  UCD13: '3400891510607',
  ucdQtyMultiplicator: 14,
  cipLib: "SKENAN LP 60MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3689835',
  CIP13: '3400936898356',
  ucdLib: "MORPHINE 40MG/ML REN A.10ML",
  UCD7: '9274880',
  UCD13: '3400892748801',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 40MG/ML REN A.10ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3402130',
  CIP13: '3400934021305',
  ucdLib: "MORPHINE 10MG LAV S/C 1ML",
  UCD7: '9059816',
  UCD13: '3400890598163',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 10MG LAV S/C 1ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3430066',
  CIP13: '3400934300660',
  ucdLib: "MOSCONTIN LP 200MG CPR",
  UCD7: '9169284',
  UCD13: '3400891692846',
  ucdQtyMultiplicator: 14,
  cipLib: "MOSCONTIN LP 200MG CPR BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3438760',
  CIP13: '3400934387609',
  ucdLib: "ORAMORPH 100MG/5ML BUV DOS",
  UCD7: '9283146',
  UCD13: '3400892831466',
  ucdQtyMultiplicator: 10,
  cipLib: "ORAMORPH 100MG/5ML BUV DOS BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3438725',
  CIP13: '3400934387258',
  ucdLib: "ORAMORPH 10MG/5ML BUV DOS",
  UCD7: '9283117',
  UCD13: '3400892831176',
  ucdQtyMultiplicator: 10,
  cipLib: "ORAMORPH 10MG/5ML BUV DOS BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3438748',
  CIP13: '3400934387487',
  ucdLib: "ORAMORPH 30MG/5ML BUV DOS",
  UCD7: '9283169',
  UCD13: '3400892831695',
  ucdQtyMultiplicator: 10,
  cipLib: "ORAMORPH 30MG/5ML BUV DOS BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3347997',
  CIP13: '3400933479978',
  ucdLib: "SEVREDOL 10MG CPR",
  UCD7: '9204394',
  UCD13: '3400892043944',
  ucdQtyMultiplicator: 14,
  cipLib: "SEVREDOL 10MG CPR BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3348005',
  CIP13: '3400933480059',
  ucdLib: "SEVREDOL 20MG CPR",
  UCD7: '9204402',
  UCD13: '3400892044026',
  ucdQtyMultiplicator: 14,
  cipLib: "SEVREDOL 20MG CPR BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3405370',
  CIP13: '3400934053702',
  ucdLib: "SKENAN LP 200MG GELU",
  UCD7: '9184125',
  UCD13: '3400891841251',
  ucdQtyMultiplicator: 14,
  cipLib: "SKENAN LP 200MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3562069',
  CIP13: '3400935620699',
  ucdLib: "MORPHINE SUL 1MG LAV 1ML",
  UCD7: '9229201',
  UCD13: '3400892292014',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE SUL 1MG LAV 1ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3561992',
  CIP13: '3400935619921',
  ucdLib: "MORPHINE SUL 50MG LAV 10ML",
  UCD7: '9229218',
  UCD13: '3400892292182',
  ucdQtyMultiplicator: 1,
  cipLib: "MORPHINE SUL 50MG LAV 10ML BT 1",
  atcCode: "N02AA01"
}, {
  CIP7: '3562017',
  CIP13: '3400935620170',
  ucdLib: "MORPHINE SUL 50MG LAV 10ML",
  UCD7: '9229218',
  UCD13: '3400892292182',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE SUL 50MG LAV 10ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3658728',
  CIP13: '3400936587281',
  ucdLib: "ORAMORPH 20MG/1ML BUV FL20ML",
  UCD7: '9283152',
  UCD13: '3400892831527',
  ucdQtyMultiplicator: 1,
  cipLib: "ORAMORPH 20MG/1ML BUV FL20ML BT 1",
  atcCode: "N02AA01"
}, {
  CIP7: '5602761',
  CIP13: '3400956027613',
  ucdLib: "MORPHINE 10MG LAV S/C 5ML",
  UCD7: '9187342',
  UCD13: '3400891873429',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 10MG LAV S/C 5ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5602784',
  CIP13: '3400956027842',
  ucdLib: "MORPHINE 20MG/ML LAV AV5ML",
  UCD7: '9187359',
  UCD13: '3400891873597',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 20MG/ML LAV AV5ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '3690614',
  CIP13: '3400936906143',
  ucdLib: "MORPHINE 0,1MG/ML AGT A.5ML",
  UCD7: '9274064',
  UCD13: '3400892740645',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 0,1MG/ML AGT A.5ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3691163',
  CIP13: '3400936911635',
  ucdLib: "MORPHINE 10MG/ML AGT A.10ML",
  UCD7: '9274093',
  UCD13: '3400892740935',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 10MG/ML AGT A.10ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3691068',
  CIP13: '3400936910683',
  ucdLib: "MORPHINE 10MG/ML AGT A.1ML",
  UCD7: '9274087',
  UCD13: '3400892740874',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 10MG/ML AGT A.1ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3691105',
  CIP13: '3400936911055',
  ucdLib: "MORPHINE 10MG/ML AGT A.5ML",
  UCD7: '9274101',
  UCD13: '3400892741017',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 10MG/ML AGT A.5ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3690040',
  CIP13: '3400936900400',
  ucdLib: "MORPHINE 10MG/ML REN A.1ML",
  UCD7: '9274874',
  UCD13: '3400892748740',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 10MG/ML REN A.1ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3690577',
  CIP13: '3400936905771',
  ucdLib: "MORPHINE 40MG/ML AGT A.10ML",
  UCD7: '9274130',
  UCD13: '3400892741307',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 40MG/ML AGT A.10ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3499000',
  CIP13: '3400934990007',
  ucdLib: "ACTISKENAN 10MG GELU",
  UCD7: '9208392',
  UCD13: '3400892083926',
  ucdQtyMultiplicator: 14,
  cipLib: "ACTISKENAN 10MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3499129',
  CIP13: '3400934991295',
  ucdLib: "ACTISKENAN 20MG GELU",
  UCD7: '9208400',
  UCD13: '3400892084008',
  ucdQtyMultiplicator: 14,
  cipLib: "ACTISKENAN 20MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3499230',
  CIP13: '3400934992308',
  ucdLib: "ACTISKENAN 30MG GELU",
  UCD7: '9208417',
  UCD13: '3400892084176',
  ucdQtyMultiplicator: 14,
  cipLib: "ACTISKENAN 30MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3495137',
  CIP13: '3400934951374',
  ucdLib: "ACTISKENAN 5MG GELU",
  UCD7: '9208423',
  UCD13: '3400892084237',
  ucdQtyMultiplicator: 14,
  cipLib: "ACTISKENAN 5MG GELU BT 14",
  atcCode: "N02AA01"
}, {
  CIP7: '3441093',
  CIP13: '3400934410932',
  ucdLib: "MORPHINE 20MG/ML LAV AV1ML",
  UCD7: '9059822',
  UCD13: '3400890598224',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 20MG/ML LAV AV1ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3953427',
  CIP13: '3400939534275',
  ucdLib: "MORPHINE 1MG/ML REN A.10ML",
  UCD7: '9342699',
  UCD13: '3400893426999',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 1MG/ML REN A.10ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '2187959',
  CIP13: '3400921879599',
  ucdLib: "MORPHINE 10MG/ML REN P100ML+S",
  UCD7: '9379194',
  UCD13: '3400893791943',
  ucdQtyMultiplicator: 1,
  cipLib: "MORPHINE 10MG/ML REN P100ML+S BT 1",
  atcCode: "N02AA01"
}, {
  CIP7: '2187971',
  CIP13: '3400921879711',
  ucdLib: "MORPHINE 20MG/ML REN P100ML+S",
  UCD7: '9379202',
  UCD13: '3400893792025',
  ucdQtyMultiplicator: 1,
  cipLib: "MORPHINE 20MG/ML REN P100ML+S BT 1",
  atcCode: "N02AA01"
}, {
  CIP7: '5669647',
  CIP13: '3400956696475',
  ucdLib: "MORPHINE 10MG/ML REN A.1ML",
  UCD7: '9274874',
  UCD13: '3400892748740',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 10MG/ML REN A.1ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5669682',
  CIP13: '3400956696826',
  ucdLib: "MORPHINE 10MG/ML REN A.5ML",
  UCD7: '9274940',
  UCD13: '3400892749402',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 10MG/ML REN A.5ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5669699',
  CIP13: '3400956696994',
  ucdLib: "MORPHINE 1MG/ML REN A.1ML",
  UCD7: '9274934',
  UCD13: '3400892749341',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 1MG/ML REN A.1ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5781901',
  CIP13: '3400957819019',
  ucdLib: "MORPHINE 1MG/ML REN FL50ML",
  UCD7: '9359122',
  UCD13: '3400893591222',
  ucdQtyMultiplicator: 12,
  cipLib: "MORPHINE 1MG/ML REN FL50ML BT 12",
  atcCode: "N02AA01"
}, {
  CIP7: '5812843',
  CIP13: '3400958128431',
  ucdLib: "MORPHINE 1MG/ML REN P100ML+S",
  UCD7: '9379188',
  UCD13: '3400893791882',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 1MG/ML REN P100ML+S BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '5669587',
  CIP13: '3400956695874',
  ucdLib: "MORPHINE 20MG/ML REN A.1ML",
  UCD7: '9274957',
  UCD13: '3400892749570',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 20MG/ML REN A.1ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '5669618',
  CIP13: '3400956696185',
  ucdLib: "MORPHINE 20MG/ML REN A.5ML",
  UCD7: '9274963',
  UCD13: '3400892749631',
  ucdQtyMultiplicator: 100,
  cipLib: "MORPHINE 20MG/ML REN A.5ML BT 100",
  atcCode: "N02AA01"
}, {
  CIP7: '3429123',
  CIP13: '3400934291234',
  ucdLib: "MORPHINE 10MG LAV S/C 5ML",
  UCD7: '9187342',
  UCD13: '3400891873429',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 10MG LAV S/C 5ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '3429146',
  CIP13: '3400934291463',
  ucdLib: "MORPHINE 20MG/ML LAV AV5ML",
  UCD7: '9187359',
  UCD13: '3400891873597',
  ucdQtyMultiplicator: 10,
  cipLib: "MORPHINE 20MG/ML LAV AV5ML BT 10",
  atcCode: "N02AA01"
}, {
  CIP7: '5768384',
  CIP13: '3400957683849',
  ucdLib: "QUTENZA 179MG PATCH CUTA",
  UCD7: '9355868',
  UCD13: '3400893558683',
  ucdQtyMultiplicator: 1,
  cipLib: "QUTENZA 179MG PATCH CUTA BT 1",
  atcCode: "N01BX04"
}, {
  CIP7: '5768390',
  CIP13: '3400957683900',
  ucdLib: "QUTENZA 179MG PATCH CUTA",
  UCD7: '9355868',
  UCD13: '3400893558683',
  ucdQtyMultiplicator: 2,
  cipLib: "QUTENZA 179MG PATCH CUTA BT 2",
  atcCode: "N01BX04"
}, {
  CIP7: '3255077',
  CIP13: '3400932550777',
  ucdLib: "ALPHACAINE SP INJ CARTCHE",
  UCD7: '9127469',
  UCD13: '3400891274691',
  ucdQtyMultiplicator: 100,
  cipLib: "ALPHACAINE SP INJ CARTCHE BT 100",
  atcCode: "N01BB58"
}, {
  CIP7: '3241201',
  CIP13: '3400932412013',
  ucdLib: "ALPHACAINE N INJ CARTCHE",
  UCD7: '9127452',
  UCD13: '3400891274523',
  ucdQtyMultiplicator: 100,
  cipLib: "ALPHACAINE N INJ CARTCHE BT 100",
  atcCode: "N01BB58"
}, {
  CIP7: '5576199',
  CIP13: '3400955761990',
  ucdLib: "DELTAZINE ADR.1/100 C.1,7ML",
  UCD7: '9161727',
  UCD13: '3400891617276',
  ucdQtyMultiplicator: 50,
  cipLib: "DELTAZINE ADR.1/100 C.1,7ML BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5576182',
  CIP13: '3400955761822',
  ucdLib: "DELTAZINE ADR.1/200 C.1,7ML",
  UCD7: '9161733',
  UCD13: '3400891617337',
  ucdQtyMultiplicator: 50,
  cipLib: "DELTAZINE ADR.1/200 C.1,7ML BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5576288',
  CIP13: '3400955762881',
  ucdLib: "SEPTANEST ADR.1/100 C.1,7ML",
  UCD7: '9158240',
  UCD13: '3400891582406',
  ucdQtyMultiplicator: 50,
  cipLib: "SEPTANEST ADR.1/100 C.1,7ML BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5576271',
  CIP13: '3400955762713',
  ucdLib: "SEPTANEST ADR.1/200 C.1,7ML",
  UCD7: '9158257',
  UCD13: '3400891582574',
  ucdQtyMultiplicator: 50,
  cipLib: "SEPTANEST ADR.1/200 C.1,7ML BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5593660',
  CIP13: '3400955936602',
  ucdLib: "UBISTESIN ADR.1/100000 C. AC",
  UCD7: '9201378',
  UCD13: '3400892013787',
  ucdQtyMultiplicator: 50,
  cipLib: "UBISTESIN ADR.1/100000 C. AC BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5593677',
  CIP13: '3400955936770',
  ucdLib: "UBISTESIN ADR.1/200000 C. AC",
  UCD7: '9201384',
  UCD13: '3400892013848',
  ucdQtyMultiplicator: 50,
  cipLib: "UBISTESIN ADR.1/200000 C. AC BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5620138',
  CIP13: '3400956201389',
  ucdLib: "ARTICADENT 1/100 INJ CART.",
  UCD7: '9245878',
  UCD13: '3400892458786',
  ucdQtyMultiplicator: 100,
  cipLib: "ARTICADENT 1/100 INJ CART. BT 100",
  atcCode: "N01BB58"
}, {
  CIP7: '5620144',
  CIP13: '3400956201440',
  ucdLib: "ARTICADENT 1/200 INJ CART.",
  UCD7: '9245884',
  UCD13: '3400892458847',
  ucdQtyMultiplicator: 100,
  cipLib: "ARTICADENT 1/200 INJ CART. BT 100",
  atcCode: "N01BB58"
}, {
  CIP7: '3494853',
  CIP13: '3400934948534',
  ucdLib: "PREDESIC ADR.1/100000 INJ C.",
  UCD7: '9212904',
  UCD13: '3400892129044',
  ucdQtyMultiplicator: 50,
  cipLib: "PREDESIC ADR.1/100000 INJ C. BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '3494876',
  CIP13: '3400934948763',
  ucdLib: "PREDESIC ADR.1/200000 INJ C.",
  UCD7: '9212910',
  UCD13: '3400892129105',
  ucdQtyMultiplicator: 50,
  cipLib: "PREDESIC ADR.1/200000 INJ C. BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '3848044',
  CIP13: '3400938480443',
  ucdLib: "ARTINIBSA ADR.1/100 INJ CART",
  UCD7: '9360131',
  UCD13: '3400893601310',
  ucdQtyMultiplicator: 50,
  cipLib: "ARTINIBSA ADR.1/100 INJ CART BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '3848050',
  CIP13: '3400938480504',
  ucdLib: "ARTINIBSA ADR.1/200 INJ CART",
  UCD7: '9360148',
  UCD13: '3400893601488',
  ucdQtyMultiplicator: 50,
  cipLib: "ARTINIBSA ADR.1/200 INJ CART BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5646965',
  CIP13: '3400956469659',
  ucdLib: "PRIMACAINE ADR.1/100000 C. +B",
  UCD7: '9248977',
  UCD13: '3400892489773',
  ucdQtyMultiplicator: 50,
  cipLib: "PRIMACAINE ADR.1/100000 C. +B BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5646971',
  CIP13: '3400956469710',
  ucdLib: "PRIMACAINE ADR.1/200000 C. +B",
  UCD7: '9248983',
  UCD13: '3400892489834',
  ucdQtyMultiplicator: 50,
  cipLib: "PRIMACAINE ADR.1/200000 C. +B BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5670231',
  CIP13: '3400956702312',
  ucdLib: "DELTAZINE ADR.1/100 CART1ML",
  UCD7: '9378326',
  UCD13: '3400893783269',
  ucdQtyMultiplicator: 50,
  cipLib: "DELTAZINE ADR.1/100 CART1ML BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '5670248',
  CIP13: '3400956702480',
  ucdLib: "DELTAZINE ADR.1/200 CART1ML",
  UCD7: '9378332',
  UCD13: '3400893783320',
  ucdQtyMultiplicator: 50,
  cipLib: "DELTAZINE ADR.1/200 CART1ML BT 50",
  atcCode: "N01BB58"
}, {
  CIP7: '3336516',
  CIP13: '3400933365165',
  ucdLib: "SCANDONEST 20MG NOR.1/100 C",
  UCD7: '9158211',
  UCD13: '3400891582116',
  ucdQtyMultiplicator: 50,
  cipLib: "SCANDONEST 20MG NOR.1/100 C BT 50",
  atcCode: "N01BB53"
}, {
  CIP7: '5593625',
  CIP13: '3400955936251',
  ucdLib: "SCANDONEST 20MG ADR.1/100 C",
  UCD7: '9205962',
  UCD13: '3400892059624',
  ucdQtyMultiplicator: 50,
  cipLib: "SCANDONEST 20MG ADR.1/100 C BT 50",
  atcCode: "N01BB53"
}, {
  CIP7: '3572665',
  CIP13: '3400935726650',
  ucdLib: "ZIACAINE CPRESS+SOL(45ML)",
  UCD7: '9397097',
  UCD13: '3400893970973',
  ucdQtyMultiplicator: 200,
  cipLib: "ZIACAINE CPRESS+SOL(45ML) BT 200",
  atcCode: "N01BB52"
}, {
  CIP7: '3115212',
  CIP13: '3400931152125',
  ucdLib: "XYLOCAINE 10MG/ML ADR FL20ML",
  UCD7: '9101524',
  UCD13: '3400891015249',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE 10MG/ML ADR FL20ML BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '3115241',
  CIP13: '3400931152415',
  ucdLib: "XYLOCAINE 20MG/ML ADR FL20ML",
  UCD7: '9101576',
  UCD13: '3400891015768',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE 20MG/ML ADR FL20ML BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '3115270',
  CIP13: '3400931152705',
  ucdLib: "XYLOCAINE 5% NAPHAZ. FL24ML",
  UCD7: '9101613',
  UCD13: '3400891016130',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE 5% NAPHAZ. FL24ML BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '3194542',
  CIP13: '3400931945420',
  ucdLib: "ZIACAINE SOL FL PULV 36G",
  UCD7: '9166848',
  UCD13: '3400891668483',
  ucdQtyMultiplicator: 1,
  cipLib: "ZIACAINE SOL FL PULV 36G BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '3376964',
  CIP13: '3400933769642',
  ucdLib: "XOGEL AD. GEL GGVL FL50G",
  UCD7: '9320870',
  UCD13: '3400893208700',
  ucdQtyMultiplicator: 1,
  cipLib: "XOGEL AD. GEL GGVL FL50G BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '3376987',
  CIP13: '3400933769871',
  ucdLib: "XOGEL ENF GEL GGVL FL50G",
  UCD7: '9320887',
  UCD13: '3400893208878',
  ucdQtyMultiplicator: 1,
  cipLib: "XOGEL ENF GEL GGVL FL50G BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '5576294',
  CIP13: '3400955762942',
  ucdLib: "XYLONOR 20MG/ML ADR.1/80 C",
  UCD7: '9365111',
  UCD13: '3400893651117',
  ucdQtyMultiplicator: 50,
  cipLib: "XYLONOR 20MG/ML ADR.1/80 C BT 50",
  atcCode: "N01BB52"
}, {
  CIP7: '5576302',
  CIP13: '3400955763024',
  ucdLib: "XYLONOR 20MG/ML NOR.1/25 CBC",
  UCD7: '9161822',
  UCD13: '3400891618228',
  ucdQtyMultiplicator: 50,
  cipLib: "XYLONOR 20MG/ML NOR.1/25 CBC BT 50",
  atcCode: "N01BB52"
}, {
  CIP7: '5576319',
  CIP13: '3400955763192',
  ucdLib: "XYLONOR 30MG/ML NOR.1/25 CBC",
  UCD7: '9161839',
  UCD13: '3400891618396',
  ucdQtyMultiplicator: 50,
  cipLib: "XYLONOR 30MG/ML NOR.1/25 CBC BT 50",
  atcCode: "N01BB52"
}, {
  CIP7: '5576377',
  CIP13: '3400955763772',
  ucdLib: "ZIACAINE 20MG/ML ADR.1/80 C.",
  UCD7: '9304233',
  UCD13: '3400893042335',
  ucdQtyMultiplicator: 50,
  cipLib: "ZIACAINE 20MG/ML ADR.1/80 C. BT 50",
  atcCode: "N01BB52"
}, {
  CIP7: '5576331',
  CIP13: '3400955763314',
  ucdLib: "ZIACAINE 20MG/ML NOR.1/25 C.",
  UCD7: '9161845',
  UCD13: '3400891618457',
  ucdQtyMultiplicator: 50,
  cipLib: "ZIACAINE 20MG/ML NOR.1/25 C. BT 50",
  atcCode: "N01BB52"
}, {
  CIP7: '5576437',
  CIP13: '3400955764373',
  ucdLib: "ZIACAINE 30MG/ML NOR.1/25 CC",
  UCD7: '9161851',
  UCD13: '3400891618518',
  ucdQtyMultiplicator: 50,
  cipLib: "ZIACAINE 30MG/ML NOR.1/25 CC BT 50",
  atcCode: "N01BB52"
}, {
  CIP7: '3376958',
  CIP13: '3400933769581',
  ucdLib: "ZIAGEL AD. GEL GGVL FL50G",
  UCD7: '9399825',
  UCD13: '3400893998250',
  ucdQtyMultiplicator: 1,
  cipLib: "ZIAGEL AD. GEL GGVL FL50G BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '3376993',
  CIP13: '3400933769932',
  ucdLib: "ZIAGEL ENF GEL GGVL FL50G",
  UCD7: '9399831',
  UCD13: '3400893998311',
  ucdQtyMultiplicator: 1,
  cipLib: "ZIAGEL ENF GEL GGVL FL50G BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '5516599',
  CIP13: '3400955165996',
  ucdLib: "XYLOCAINE 10MG/ML ADR FL20ML",
  UCD7: '9101524',
  UCD13: '3400891015249',
  ucdQtyMultiplicator: 10,
  cipLib: "XYLOCAINE 10MG/ML ADR FL20ML BT 10",
  atcCode: "N01BB52"
}, {
  CIP7: '5516576',
  CIP13: '3400955165767',
  ucdLib: "XYLOCAINE 20MG/ML ADR FL20ML",
  UCD7: '9101576',
  UCD13: '3400891015768',
  ucdQtyMultiplicator: 10,
  cipLib: "XYLOCAINE 20MG/ML ADR FL20ML BT 10",
  atcCode: "N01BB52"
}, {
  CIP7: '5516435',
  CIP13: '3400955164357',
  ucdLib: "XYLOCAINE 5% NAPHAZ. FL24ML",
  UCD7: '9101613',
  UCD13: '3400891016130',
  ucdQtyMultiplicator: 10,
  cipLib: "XYLOCAINE 5% NAPHAZ. FL24ML BT 10",
  atcCode: "N01BB52"
}, {
  CIP7: '5605564',
  CIP13: '3400956055647',
  ucdLib: "INSTILLAGEL GEL SRG11ML",
  UCD7: '9197458',
  UCD13: '3400891974584',
  ucdQtyMultiplicator: 10,
  cipLib: "INSTILLAGEL GEL SRG11ML BT 10",
  atcCode: "N01BB52"
}, {
  CIP7: '3175326',
  CIP13: '3400931753261',
  ucdLib: "XYLONOR SOL FL PULV 90ML",
  UCD7: '9166831',
  UCD13: '3400891668315',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLONOR SOL FL PULV 90ML BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '5002110',
  CIP13: '3400950021105',
  ucdLib: "XYLOROLLAND ADR. C.1,8ML",
  UCD7: '9418971',
  UCD13: '3400894189718',
  ucdQtyMultiplicator: 50,
  cipLib: "XYLOROLLAND ADR. C.1,8ML BT 50",
  atcCode: "N01BB52"
}, {
  CIP7: '5002127',
  CIP13: '3400950021273',
  ucdLib: "XYLOROLLAND ADR. C.1,8ML",
  UCD7: '9418971',
  UCD13: '3400894189718',
  ucdQtyMultiplicator: 100,
  cipLib: "XYLOROLLAND ADR. C.1,8ML BT 100",
  atcCode: "N01BB52"
}, {
  CIP7: '5001234',
  CIP13: '3400950012349',
  ucdLib: "ZIACAINE SOL DENT FV45ML",
  UCD7: '9419568',
  UCD13: '3400894195689',
  ucdQtyMultiplicator: 1,
  cipLib: "ZIACAINE SOL DENT FV45ML BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '2241127',
  CIP13: '3400922411279',
  ucdLib: "PLIAGLIS CR TB15G",
  UCD7: '9392823',
  UCD13: '3400893928233',
  ucdQtyMultiplicator: 1,
  cipLib: "PLIAGLIS CR TB15G BT 1",
  atcCode: "N01BB52"
}, {
  CIP7: '5843393',
  CIP13: '3400958433931',
  ucdLib: "LIDOC.AGT 10MG/ML ADR.A.10ML",
  UCD7: '9391640',
  UCD13: '3400893916407',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDOC.AGT 10MG/ML ADR.A.10ML BT 10",
  atcCode: "N01BB52"
}, {
  CIP7: '5843447',
  CIP13: '3400958434471',
  ucdLib: "LIDOC.AGT 20MG/ML ADR.A.10ML",
  UCD7: '9391657',
  UCD13: '3400893916575',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDOC.AGT 20MG/ML ADR.A.10ML BT 10",
  atcCode: "N01BB52"
}, {
  CIP7: '3329232',
  CIP13: '3400933292324',
  ucdLib: "EMLA 5% CR TB5G + PANS",
  UCD7: '9159446',
  UCD13: '3400891594461',
  ucdQtyMultiplicator: 1,
  cipLib: "EMLA 5% CR TB5G + PANS BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '2761097',
  CIP13: '3400927610974',
  ucdLib: "LIDOCAIN/PRIL.BGA 5% PANS",
  UCD7: '9403314',
  UCD13: '3400894033141',
  ucdQtyMultiplicator: 1,
  cipLib: "LIDOCAIN/PRIL.BGA 5% PANS BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '2766551',
  CIP13: '3400927665516',
  ucdLib: "LIDOCAIN/PRIL.ZEN 5% PANS",
  UCD7: '9404822',
  UCD13: '3400894048220',
  ucdQtyMultiplicator: 1,
  cipLib: "LIDOCAIN/PRIL.ZEN 5% PANS BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '5569360',
  CIP13: '3400955693604',
  ucdLib: "EMLA 5% CR TB5G + PANS",
  UCD7: '9159446',
  UCD13: '3400891594461',
  ucdQtyMultiplicator: 5,
  cipLib: "EMLA 5% CR TB5G + PANS BT 5",
  atcCode: "N01BB20"
}, {
  CIP7: '3686363',
  CIP13: '3400936863637',
  ucdLib: "ANESDERM 5% CR TB5G + PANS",
  UCD7: '9277743',
  UCD13: '3400892777436',
  ucdQtyMultiplicator: 1,
  cipLib: "ANESDERM 5% CR TB5G + PANS BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '3400071',
  CIP13: '3400934000713',
  ucdLib: "EMLAPATCH 5% PANS ADH",
  UCD7: '9188198',
  UCD13: '3400891881981',
  ucdQtyMultiplicator: 1,
  cipLib: "EMLAPATCH 5% PANS ADH BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '5588759',
  CIP13: '3400955887591',
  ucdLib: "EMLAPATCH 5% PANS ADH",
  UCD7: '9188198',
  UCD13: '3400891881981',
  ucdQtyMultiplicator: 20,
  cipLib: "EMLAPATCH 5% PANS ADH BT 20",
  atcCode: "N01BB20"
}, {
  CIP7: '3678814',
  CIP13: '3400936788145',
  ucdLib: "ORAQIX GEL CARTCHE1,7G",
  UCD7: '9289870',
  UCD13: '3400892898704',
  ucdQtyMultiplicator: 20,
  cipLib: "ORAQIX GEL CARTCHE1,7G BT 20",
  atcCode: "N01BB20"
}, {
  CIP7: '5591454',
  CIP13: '3400955914549',
  ucdLib: "EMLA 5% CR TB30G",
  UCD7: '9181635',
  UCD13: '3400891816358',
  ucdQtyMultiplicator: 1,
  cipLib: "EMLA 5% CR TB30G BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '3699578',
  CIP13: '3400936995789',
  ucdLib: "LIDOCAIN/PRIL.ZEN 5% CR 5G +P",
  UCD7: '9280550',
  UCD13: '3400892805504',
  ucdQtyMultiplicator: 1,
  cipLib: "LIDOCAIN/PRIL.ZEN 5% CR 5G +P BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '3771347',
  CIP13: '3400937713474',
  ucdLib: "LIDOCAIN/PRIL.BGA 5% CR 5G +P",
  UCD7: '9294061',
  UCD13: '3400892940618',
  ucdQtyMultiplicator: 1,
  cipLib: "LIDOCAIN/PRIL.BGA 5% CR 5G +P BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '5664006',
  CIP13: '3400956640065',
  ucdLib: "ANESDERM 5% CR TB5G + PANS",
  UCD7: '9277743',
  UCD13: '3400892777436',
  ucdQtyMultiplicator: 5,
  cipLib: "ANESDERM 5% CR TB5G + PANS BT 5",
  atcCode: "N01BB20"
}, {
  CIP7: '5675122',
  CIP13: '3400956751228',
  ucdLib: "LIDOCAIN/PRIL.AGT 5% CR 30G",
  UCD7: '9277789',
  UCD13: '3400892777894',
  ucdQtyMultiplicator: 1,
  cipLib: "LIDOCAIN/PRIL.AGT 5% CR 30G BT 1",
  atcCode: "N01BB20"
}, {
  CIP7: '5672916',
  CIP13: '3400956729166',
  ucdLib: "LIDOCAIN/PRIL.AGT 5% CR 5G +P",
  UCD7: '9277795',
  UCD13: '3400892777955',
  ucdQtyMultiplicator: 5,
  cipLib: "LIDOCAIN/PRIL.AGT 5% CR 5G +P BT 5",
  atcCode: "N01BB20"
}, {
  CIP7: '5857389',
  CIP13: '3400958573897',
  ucdLib: "LIDOCAIN/PRIL.AGT 5% PANS",
  UCD7: '9397329',
  UCD13: '3400893973295',
  ucdQtyMultiplicator: 20,
  cipLib: "LIDOCAIN/PRIL.AGT 5% PANS BT 20",
  atcCode: "N01BB20"
}, {
  CIP7: '5869346',
  CIP13: '3400958693465',
  ucdLib: "LEVOBUPIVA.KBI 2,5MG/ML A10ML",
  UCD7: '9408412',
  UCD13: '3400894084129',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOBUPIVA.KBI 2,5MG/ML A10ML BT 5",
  atcCode: "N01BB10"
}, {
  CIP7: '5869375',
  CIP13: '3400958693755',
  ucdLib: "LEVOBUPIVA.KBI 5MG/ML A10ML",
  UCD7: '9408429',
  UCD13: '3400894084297',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOBUPIVA.KBI 5MG/ML A10ML BT 5",
  atcCode: "N01BB10"
}, {
  CIP7: '5869263',
  CIP13: '3400958692635',
  ucdLib: "LEVOBUPIVA.KBI1,25MG/ML100ML",
  UCD7: '9408406',
  UCD13: '3400894084068',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOBUPIVA.KBI1,25MG/ML100ML BT 5",
  atcCode: "N01BB10"
}, {
  CIP7: '5668240',
  CIP13: '3400956682409',
  ucdLib: "CHIROCAINE 0,625MG/ML P100ML",
  UCD7: '9279050',
  UCD13: '3400892790503',
  ucdQtyMultiplicator: 24,
  cipLib: "CHIROCAINE 0,625MG/ML P100ML BT 24",
  atcCode: "N01BB10"
}, {
  CIP7: '5668286',
  CIP13: '3400956682867',
  ucdLib: "CHIROCAINE 0,625MG/ML P200ML",
  UCD7: '9279067',
  UCD13: '3400892790671',
  ucdQtyMultiplicator: 12,
  cipLib: "CHIROCAINE 0,625MG/ML P200ML BT 12",
  atcCode: "N01BB10"
}, {
  CIP7: '5668317',
  CIP13: '3400956683178',
  ucdLib: "CHIROCAINE 1,25MG/ML P.100ML",
  UCD7: '9279073',
  UCD13: '3400892790732',
  ucdQtyMultiplicator: 24,
  cipLib: "CHIROCAINE 1,25MG/ML P.100ML BT 24",
  atcCode: "N01BB10"
}, {
  CIP7: '5668352',
  CIP13: '3400956683529',
  ucdLib: "CHIROCAINE 1,25MG/ML P.200ML",
  UCD7: '9279096',
  UCD13: '3400892790961',
  ucdQtyMultiplicator: 12,
  cipLib: "CHIROCAINE 1,25MG/ML P.200ML BT 12",
  atcCode: "N01BB10"
}, {
  CIP7: '5657012',
  CIP13: '3400956570126',
  ucdLib: "CHIROCAINE 2,5MG/ML AP10ML",
  UCD7: '9263126',
  UCD13: '3400892631264',
  ucdQtyMultiplicator: 20,
  cipLib: "CHIROCAINE 2,5MG/ML AP10ML BT 20",
  atcCode: "N01BB10"
}, {
  CIP7: '5657041',
  CIP13: '3400956570416',
  ucdLib: "CHIROCAINE 2,5MG/ML AP10ML P",
  UCD7: '9263132',
  UCD13: '3400892631325',
  ucdQtyMultiplicator: 20,
  cipLib: "CHIROCAINE 2,5MG/ML AP10ML P BT 20",
  atcCode: "N01BB10"
}, {
  CIP7: '5657147',
  CIP13: '3400956571475',
  ucdLib: "CHIROCAINE 5MG/ML AP10ML",
  UCD7: '9263149',
  UCD13: '3400892631493',
  ucdQtyMultiplicator: 20,
  cipLib: "CHIROCAINE 5MG/ML AP10ML BT 20",
  atcCode: "N01BB10"
}, {
  CIP7: '5657182',
  CIP13: '3400956571826',
  ucdLib: "CHIROCAINE 5MG/ML AP10ML P",
  UCD7: '9263155',
  UCD13: '3400892631554',
  ucdQtyMultiplicator: 20,
  cipLib: "CHIROCAINE 5MG/ML AP10ML P BT 20",
  atcCode: "N01BB10"
}, {
  CIP7: '5599361',
  CIP13: '3400955993612',
  ucdLib: "NAROPEINE 10MG/ML INJ A.10ML",
  UCD7: '9187885',
  UCD13: '3400891878851',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 10MG/ML INJ A.10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5599409',
  CIP13: '3400955994091',
  ucdLib: "NAROPEINE 10MG/ML INJ A.20ML",
  UCD7: '9187891',
  UCD13: '3400891878912',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 10MG/ML INJ A.20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5599177',
  CIP13: '3400955991779',
  ucdLib: "NAROPEINE 2MG/ML INJ A.10ML",
  UCD7: '9187916',
  UCD13: '3400891879162',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 2MG/ML INJ A.10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5599220',
  CIP13: '3400955992202',
  ucdLib: "NAROPEINE 2MG/ML INJ A.20ML",
  UCD7: '9187922',
  UCD13: '3400891879223',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 2MG/ML INJ A.20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5599438',
  CIP13: '3400955994381',
  ucdLib: "NAROPEINE 2MG/ML INJ POC100ML",
  UCD7: '9187939',
  UCD13: '3400891879391',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 2MG/ML INJ POC100ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5599272',
  CIP13: '3400955992721',
  ucdLib: "NAROPEINE 7,5MG/ML INJ A10ML",
  UCD7: '9187951',
  UCD13: '3400891879513',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 7,5MG/ML INJ A10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5599326',
  CIP13: '3400955993261',
  ucdLib: "NAROPEINE 7,5MG/ML INJ A20ML",
  UCD7: '9187968',
  UCD13: '3400891879681',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 7,5MG/ML INJ A20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5600093',
  CIP13: '3400956000937',
  ucdLib: "NAROPEINE 2MG/ML INJ POC200ML",
  UCD7: '9187945',
  UCD13: '3400891879452',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 2MG/ML INJ POC200ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5745242',
  CIP13: '3400957452421',
  ucdLib: "ROPIVACAINE MYL 10MG/ML 10ML",
  UCD7: '9333944',
  UCD13: '3400893339442',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE MYL 10MG/ML 10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5745271',
  CIP13: '3400957452711',
  ucdLib: "ROPIVACAINE MYL 10MG/ML 20ML",
  UCD7: '9333950',
  UCD13: '3400893339503',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE MYL 10MG/ML 20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5745124',
  CIP13: '3400957451240',
  ucdLib: "ROPIVACAINE MYL 2MG/ML 100ML",
  UCD7: '9333996',
  UCD13: '3400893339961',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE MYL 2MG/ML 100ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5745064',
  CIP13: '3400957450649',
  ucdLib: "ROPIVACAINE MYL 2MG/ML 10ML",
  UCD7: '9333967',
  UCD13: '3400893339671',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE MYL 2MG/ML 10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5745147',
  CIP13: '3400957451479',
  ucdLib: "ROPIVACAINE MYL 2MG/ML 200ML",
  UCD7: '9334004',
  UCD13: '3400893340042',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE MYL 2MG/ML 200ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5745093',
  CIP13: '3400957450939',
  ucdLib: "ROPIVACAINE MYL 2MG/ML 20ML",
  UCD7: '9333973',
  UCD13: '3400893339732',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE MYL 2MG/ML 20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5745176',
  CIP13: '3400957451769',
  ucdLib: "ROPIVACAINE MYL 7,5MG/ML 10ML",
  UCD7: '9334010',
  UCD13: '3400893340103',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE MYL 7,5MG/ML 10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5745207',
  CIP13: '3400957452070',
  ucdLib: "ROPIVACAINE MYL 7,5MG/ML 20ML",
  UCD7: '9334027',
  UCD13: '3400893340271',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE MYL 7,5MG/ML 20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5795843',
  CIP13: '3400957958435',
  ucdLib: "ROPIVACAINE BBM 10MG/ML 20ML",
  UCD7: '9386923',
  UCD13: '3400893869239',
  ucdQtyMultiplicator: 20,
  cipLib: "ROPIVACAINE BBM 10MG/ML 20ML BT 20",
  atcCode: "N01BB09"
}, {
  CIP7: '5795814',
  CIP13: '3400957958145',
  ucdLib: "ROPIVACAINE BBM 7,5MG/ML10ML",
  UCD7: '9376592',
  UCD13: '3400893765920',
  ucdQtyMultiplicator: 20,
  cipLib: "ROPIVACAINE BBM 7,5MG/ML10ML BT 20",
  atcCode: "N01BB09"
}, {
  CIP7: '5774166',
  CIP13: '3400957741662',
  ucdLib: "ROPIVACAINE KBI 10MG/ML 10ML",
  UCD7: '9361366',
  UCD13: '3400893613665',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 10MG/ML 10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5774232',
  CIP13: '3400957742324',
  ucdLib: "ROPIVACAINE KBI 10MG/ML 20ML",
  UCD7: '9361372',
  UCD13: '3400893613726',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 10MG/ML 20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5774338',
  CIP13: '3400957743383',
  ucdLib: "ROPIVACAINE KBI 2MG/ML 100ML",
  UCD7: '9361389',
  UCD13: '3400893613894',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 2MG/ML 100ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5773899',
  CIP13: '3400957738990',
  ucdLib: "ROPIVACAINE KBI 2MG/ML 10ML",
  UCD7: '9361403',
  UCD13: '3400893614037',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 2MG/ML 10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5774367',
  CIP13: '3400957743673',
  ucdLib: "ROPIVACAINE KBI 2MG/ML 200ML",
  UCD7: '9361395',
  UCD13: '3400893613955',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 2MG/ML 200ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5773965',
  CIP13: '3400957739652',
  ucdLib: "ROPIVACAINE KBI 2MG/ML 20ML",
  UCD7: '9361426',
  UCD13: '3400893614266',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 2MG/ML 20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5774290',
  CIP13: '3400957742904',
  ucdLib: "ROPIVACAINE KBI 5MG/ML 10ML",
  UCD7: '9361432',
  UCD13: '3400893614327',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 5MG/ML 10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5774025',
  CIP13: '3400957740252',
  ucdLib: "ROPIVACAINE KBI 7,5MG/ML 10ML",
  UCD7: '9361449',
  UCD13: '3400893614495',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 7,5MG/ML 10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5774083',
  CIP13: '3400957740832',
  ucdLib: "ROPIVACAINE KBI 7,5MG/ML 20ML",
  UCD7: '9361455',
  UCD13: '3400893614556',
  ucdQtyMultiplicator: 5,
  cipLib: "ROPIVACAINE KBI 7,5MG/ML 20ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5784420',
  CIP13: '3400957844202',
  ucdLib: "ROPIVACAINE REN 2MG/ML 100ML",
  UCD7: '9360846',
  UCD13: '3400893608463',
  ucdQtyMultiplicator: 10,
  cipLib: "ROPIVACAINE REN 2MG/ML 100ML BT 10",
  atcCode: "N01BB09"
}, {
  CIP7: '5784472',
  CIP13: '3400957844721',
  ucdLib: "ROPIVACAINE REN 2MG/ML 200ML",
  UCD7: '9360852',
  UCD13: '3400893608524',
  ucdQtyMultiplicator: 10,
  cipLib: "ROPIVACAINE REN 2MG/ML 200ML BT 10",
  atcCode: "N01BB09"
}, {
  CIP7: '5654982',
  CIP13: '3400956549825',
  ucdLib: "NAROPEINE 5MG/ML INJ A.10ML",
  UCD7: '9277683',
  UCD13: '3400892776835',
  ucdQtyMultiplicator: 5,
  cipLib: "NAROPEINE 5MG/ML INJ A.10ML BT 5",
  atcCode: "N01BB09"
}, {
  CIP7: '5727681',
  CIP13: '3400957276812',
  ucdLib: "DELTAZINE 40MG/ML INJ C1,7ML",
  UCD7: '9342765',
  UCD13: '3400893427651',
  ucdQtyMultiplicator: 50,
  cipLib: "DELTAZINE 40MG/ML INJ C1,7ML BT 50",
  atcCode: "N01BB08"
}, {
  CIP7: '5727669',
  CIP13: '3400957276690',
  ucdLib: "SEPTANEST 40MG/ML INJ C1,7ML",
  UCD7: '9342825',
  UCD13: '3400893428252',
  ucdQtyMultiplicator: 50,
  cipLib: "SEPTANEST 40MG/ML INJ C1,7ML BT 50",
  atcCode: "N01BB08"
}, {
  CIP7: '5858963',
  CIP13: '3400958589638',
  ucdLib: "BARITEKAL 20MG/ML INJ AV5ML",
  UCD7: '9399328',
  UCD13: '3400893993286',
  ucdQtyMultiplicator: 10,
  cipLib: "BARITEKAL 20MG/ML INJ AV5ML BT 10",
  atcCode: "N01BB04"
}, {
  CIP7: '3524287',
  CIP13: '3400935242877',
  ucdLib: "CARBOCAINE 10MG/ML INJ A20ML",
  UCD7: '9184964',
  UCD13: '3400891849646',
  ucdQtyMultiplicator: 5,
  cipLib: "CARBOCAINE 10MG/ML INJ A20ML BT 5",
  atcCode: "N01BB03"
}, {
  CIP7: '3524293',
  CIP13: '3400935242938',
  ucdLib: "CARBOCAINE 20MG/ML INJ A20ML",
  UCD7: '9184970',
  UCD13: '3400891849707',
  ucdQtyMultiplicator: 5,
  cipLib: "CARBOCAINE 20MG/ML INJ A20ML BT 5",
  atcCode: "N01BB03"
}, {
  CIP7: '5593648',
  CIP13: '3400955936480',
  ucdLib: "SCANDONEST 30MG/ML C.1,8ML",
  UCD7: '9203928',
  UCD13: '3400892039282',
  ucdQtyMultiplicator: 50,
  cipLib: "SCANDONEST 30MG/ML C.1,8ML BT 50",
  atcCode: "N01BB03"
}, {
  CIP7: '3800132',
  CIP13: '3400938001327',
  ucdLib: "MEPIVACAIN.BBM10MG/ML AP20ML",
  UCD7: '9310682',
  UCD13: '3400893106822',
  ucdQtyMultiplicator: 20,
  cipLib: "MEPIVACAIN.BBM10MG/ML AP20ML BT 20",
  atcCode: "N01BB03"
}, {
  CIP7: '3800103',
  CIP13: '3400938001037',
  ucdLib: "MEPIVACAIN.BBM20MG/ML AP20ML",
  UCD7: '9310699',
  UCD13: '3400893106990',
  ucdQtyMultiplicator: 20,
  cipLib: "MEPIVACAIN.BBM20MG/ML AP20ML BT 20",
  atcCode: "N01BB03"
}, {
  CIP7: '5557606',
  CIP13: '3400955576068',
  ucdLib: "XYLOCAINE 5% NEB. C/C FL20G",
  UCD7: '9131117',
  UCD13: '3400891311174',
  ucdQtyMultiplicator: 5,
  cipLib: "XYLOCAINE 5% NEB. C/C FL20G BT 5",
  atcCode: "N01BB02"
}, {
  CIP7: '5557888',
  CIP13: '3400955578888',
  ucdLib: "XYLOCAINE 5% NEB. C/L FL20G",
  UCD7: '9131123',
  UCD13: '3400891311235',
  ucdQtyMultiplicator: 5,
  cipLib: "XYLOCAINE 5% NEB. C/L FL20G BT 5",
  atcCode: "N01BB02"
}, {
  CIP7: '3115376',
  CIP13: '3400931153764',
  ucdLib: "XYLOCAINE VISQ.2% GEL TB100G",
  UCD7: '9101671',
  UCD13: '3400891016710',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE VISQ.2% GEL TB100G BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '3310770',
  CIP13: '3400933107703',
  ucdLib: "MESOCAINE 25MG INJ A.B5ML",
  UCD7: '9134765',
  UCD13: '3400891347654',
  ucdQtyMultiplicator: 1,
  cipLib: "MESOCAINE 25MG INJ A.B5ML BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '3310801',
  CIP13: '3400933108014',
  ucdLib: "MESOCAINE 50MG INJ A.B5ML",
  UCD7: '9134771',
  UCD13: '3400891347715',
  ucdQtyMultiplicator: 1,
  cipLib: "MESOCAINE 50MG INJ A.B5ML BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '3267258',
  CIP13: '3400932672585',
  ucdLib: "PRESSICAINE A SVC CARTCHE",
  UCD7: '9245950',
  UCD13: '3400892459509',
  ucdQtyMultiplicator: 50,
  cipLib: "PRESSICAINE A SVC CARTCHE BT 50",
  atcCode: "N01BB02"
}, {
  CIP7: '3229938',
  CIP13: '3400932299386',
  ucdLib: "XYLOCAINE 5% NEB. C/C FL20G",
  UCD7: '9131117',
  UCD13: '3400891311174',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE 5% NEB. C/C FL20G BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '3527989',
  CIP13: '3400935279897',
  ucdLib: "DYNEXAN 2% PATE GGVL TB10G",
  UCD7: '9219562',
  UCD13: '3400892195629',
  ucdQtyMultiplicator: 1,
  cipLib: "DYNEXAN 2% PATE GGVL TB10G BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '4987552',
  CIP13: '3400949875528',
  ucdLib: "DYNEXANGIVAL 1% CR BUC TB10G",
  UCD7: '9372045',
  UCD13: '3400893720455',
  ucdQtyMultiplicator: 1,
  cipLib: "DYNEXANGIVAL 1% CR BUC TB10G BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '3398144',
  CIP13: '3400933981440',
  ucdLib: "LIDOCAINE AGT 10MG/ML AB5ML",
  UCD7: '9266573',
  UCD13: '3400892665733',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDOCAINE AGT 10MG/ML AB5ML BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '3627254',
  CIP13: '3400936272545',
  ucdLib: "LIDOC.AGT 10MG/ML S/C FV20ML",
  UCD7: '9250425',
  UCD13: '3400892504254',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDOC.AGT 10MG/ML S/C FV20ML BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '3627260',
  CIP13: '3400936272606',
  ucdLib: "LIDOC.AGT 20MG/ML S/C FV20ML",
  UCD7: '9250431',
  UCD13: '3400892504315',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDOC.AGT 20MG/ML S/C FV20ML BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '3511706',
  CIP13: '3400935117069',
  ucdLib: "LIDOCAINE 5% AGT FV20G +CAN",
  UCD7: '9215825',
  UCD13: '3400892158259',
  ucdQtyMultiplicator: 5,
  cipLib: "LIDOCAINE 5% AGT FV20G +CAN BT 5",
  atcCode: "N01BB02"
}, {
  CIP7: '3636721',
  CIP13: '3400936367210',
  ucdLib: "LIDOC.AGT 5MG/ML S/C FV20ML",
  UCD7: '9257226',
  UCD13: '3400892572260',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDOC.AGT 5MG/ML S/C FV20ML BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '3634461',
  CIP13: '3400936344617',
  ucdLib: "XYLOCAINE 2% GEL SRG10G",
  UCD7: '9260027',
  UCD13: '3400892600277',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE 2% GEL SRG10G BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '3828567',
  CIP13: '3400938285673',
  ucdLib: "VERSATIS 5% EMPL MEDIC",
  UCD7: '9298107',
  UCD13: '3400892981079',
  ucdQtyMultiplicator: 30,
  cipLib: "VERSATIS 5% EMPL MEDIC BT 30",
  atcCode: "N01BB02"
}, {
  CIP7: '5611754',
  CIP13: '3400956117543',
  ucdLib: "LIDOCAINE 10MG/ML REN AV5ML",
  UCD7: '9208854',
  UCD13: '3400892088549',
  ucdQtyMultiplicator: 100,
  cipLib: "LIDOCAINE 10MG/ML REN AV5ML BT 100",
  atcCode: "N01BB02"
}, {
  CIP7: '5002989',
  CIP13: '3400950029897',
  ucdLib: "XYLOCONTACT CR DENT TB15G",
  UCD7: '9418988',
  UCD13: '3400894189886',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCONTACT CR DENT TB15G BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '5002191',
  CIP13: '3400950021914',
  ucdLib: "XYLOROLLAND C.1,8ML",
  UCD7: '9418965',
  UCD13: '3400894189657',
  ucdQtyMultiplicator: 50,
  cipLib: "XYLOROLLAND C.1,8ML BT 50",
  atcCode: "N01BB02"
}, {
  CIP7: '2772250',
  CIP13: '3400927722509',
  ucdLib: "LIDOC.AGT 10MG/ML S/C AP10ML",
  UCD7: '9398642',
  UCD13: '3400893986424',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDOC.AGT 10MG/ML S/C AP10ML BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '2772304',
  CIP13: '3400927723049',
  ucdLib: "LIDOC.AGT 20MG/ML S/C AP10ML",
  UCD7: '9398659',
  UCD13: '3400893986592',
  ucdQtyMultiplicator: 10,
  cipLib: "LIDOC.AGT 20MG/ML S/C AP10ML BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '3422397',
  CIP13: '3400934223976',
  ucdLib: "XYLOCAINE 10MG/ML S/C FL20ML",
  UCD7: '9185248',
  UCD13: '3400891852486',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE 10MG/ML S/C FL20ML BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '5653244',
  CIP13: '3400956532445',
  ucdLib: "XYLOCAINE 2% GEL SRG10G",
  UCD7: '9260027',
  UCD13: '3400892600277',
  ucdQtyMultiplicator: 10,
  cipLib: "XYLOCAINE 2% GEL SRG10G BT 10",
  atcCode: "N01BB02"
}, {
  CIP7: '3422405',
  CIP13: '3400934224058',
  ucdLib: "XYLOCAINE 20MG/ML S/C FL20ML",
  UCD7: '9185254',
  UCD13: '3400891852547',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE 20MG/ML S/C FL20ML BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '3421506',
  CIP13: '3400934215063',
  ucdLib: "XYLOCAINE 5MG/ML S/C FL20ML",
  UCD7: '9185231',
  UCD13: '3400891852318',
  ucdQtyMultiplicator: 1,
  cipLib: "XYLOCAINE 5MG/ML S/C FL20ML BT 1",
  atcCode: "N01BB02"
}, {
  CIP7: '5606902',
  CIP13: '3400956069026',
  ucdLib: "BUPIVAC.RACH.5MG/ML AGT 4ML",
  UCD7: '9199351',
  UCD13: '3400891993516',
  ucdQtyMultiplicator: 20,
  cipLib: "BUPIVAC.RACH.5MG/ML AGT 4ML BT 20",
  atcCode: "N01BB01"
}, {
  CIP7: '5626046',
  CIP13: '3400956260461',
  ucdLib: "BUPIVACAINE MYL 2,5MG/ML 20ML",
  UCD7: '9223055',
  UCD13: '3400892230559',
  ucdQtyMultiplicator: 10,
  cipLib: "BUPIVACAINE MYL 2,5MG/ML 20ML BT 10",
  atcCode: "N01BB01"
}, {
  CIP7: '5626052',
  CIP13: '3400956260522',
  ucdLib: "BUPIVACAINE MYL 5MG/ML 20ML",
  UCD7: '9223049',
  UCD13: '3400892230498',
  ucdQtyMultiplicator: 10,
  cipLib: "BUPIVACAINE MYL 5MG/ML 20ML BT 10",
  atcCode: "N01BB01"
}, {
  CIP7: '5631165',
  CIP13: '3400956311651',
  ucdLib: "BUPIVACAINE MYL 20MG IR 4ML",
  UCD7: '9226467',
  UCD13: '3400892264677',
  ucdQtyMultiplicator: 20,
  cipLib: "BUPIVACAINE MYL 20MG IR 4ML BT 20",
  atcCode: "N01BB01"
}, {
  CIP7: '5651280',
  CIP13: '3400956512805',
  ucdLib: "BUPIVAC.2,5MG/ML AGT FL20ML",
  UCD7: '9256244',
  UCD13: '3400892562445',
  ucdQtyMultiplicator: 10,
  cipLib: "BUPIVAC.2,5MG/ML AGT FL20ML BT 10",
  atcCode: "N01BB01"
}, {
  CIP7: '5651311',
  CIP13: '3400956513116',
  ucdLib: "BUPIVAC.5MG/ML AGT FL20ML",
  UCD7: '9256267',
  UCD13: '3400892562674',
  ucdQtyMultiplicator: 10,
  cipLib: "BUPIVAC.5MG/ML AGT FL20ML BT 10",
  atcCode: "N01BB01"
}, {
  CIP7: '2229586',
  CIP13: '3400922295862',
  ucdLib: "CLOROTEKAL 10MG/ML INJ 5ML",
  UCD7: '9390238',
  UCD13: '3400893902387',
  ucdQtyMultiplicator: 10,
  cipLib: "CLOROTEKAL 10MG/ML INJ 5ML BT 10",
  atcCode: "N01BA04"
}, {
  CIP7: '3086350',
  CIP13: '3400930863503',
  ucdLib: "PROCAINE 2% BIOSTA. INJ AMP5ML",
  UCD7: '9075726',
  UCD13: '3400890757263',
  ucdQtyMultiplicator: 6,
  cipLib: "PROCAINE 2% BIOSTA. INJ AMP5ML BT 6",
  atcCode: "N01BA02"
}, {
  CIP7: '3625373',
  CIP13: '3400936253735',
  ucdLib: "PROCAINE 1% LAV A.B2ML",
  UCD7: '9271462',
  UCD13: '3400892714622',
  ucdQtyMultiplicator: 10,
  cipLib: "PROCAINE 1% LAV A.B2ML BT 10",
  atcCode: "N01BA02"
}, {
  CIP7: '3625396',
  CIP13: '3400936253964',
  ucdLib: "PROCAINE 1% LAV A.B5ML",
  UCD7: '9271479',
  UCD13: '3400892714790',
  ucdQtyMultiplicator: 10,
  cipLib: "PROCAINE 1% LAV A.B5ML BT 10",
  atcCode: "N01BA02"
}, {
  CIP7: '3625404',
  CIP13: '3400936254046',
  ucdLib: "PROCAINE 2% LAV A.B2ML",
  UCD7: '9271485',
  UCD13: '3400892714851',
  ucdQtyMultiplicator: 10,
  cipLib: "PROCAINE 2% LAV A.B2ML BT 10",
  atcCode: "N01BA02"
}, {
  CIP7: '3625410',
  CIP13: '3400936254107',
  ucdLib: "PROCAINE 2% LAV A.B5ML",
  UCD7: '9271491',
  UCD13: '3400892714912',
  ucdQtyMultiplicator: 10,
  cipLib: "PROCAINE 2% LAV A.B5ML BT 10",
  atcCode: "N01BA02"
}, {
  CIP7: '5621652',
  CIP13: '3400956216529',
  ucdLib: "ANTASOL 135 GAZ INHAL 5L",
  UCD7: '9239369',
  UCD13: '3400892393698',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTASOL 135 GAZ INHAL 5L BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5621646',
  CIP13: '3400956216468',
  ucdLib: "KALINOX 50%/50% BOUT20L +RAC.",
  UCD7: '9236626',
  UCD13: '3400892366265',
  ucdQtyMultiplicator: 1,
  cipLib: "KALINOX 50%/50% BOUT20L +RAC. BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5621623',
  CIP13: '3400956216239',
  ucdLib: "KALINOX 50%/50% BOUT5L +RAC.",
  UCD7: '9236632',
  UCD13: '3400892366326',
  ucdQtyMultiplicator: 1,
  cipLib: "KALINOX 50%/50% BOUT5L +RAC. BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5633879',
  CIP13: '3400956338795',
  ucdLib: "ANTASOL 135 GAZ INHAL 15L",
  UCD7: '9239352',
  UCD13: '3400892393520',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTASOL 135 GAZ INHAL 15L BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5644239',
  CIP13: '3400956442393',
  ucdLib: "ANTASOL 135 GAZ INHAL 15L+MAN",
  UCD7: '9249913',
  UCD13: '3400892499130',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTASOL 135 GAZ INHAL 15L+MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '3964247',
  CIP13: '3400939642475',
  ucdLib: "ANTASOL 135 GAZ INHAL 5L+MAN",
  UCD7: '9249936',
  UCD13: '3400892499369',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTASOL 135 GAZ INHAL 5L+MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5644392',
  CIP13: '3400956443925',
  ucdLib: "ANTASOL 135 GAZ INHAL D15L+MAN",
  UCD7: '9285665',
  UCD13: '3400892856650',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTASOL 135 GAZ INHAL D15L+MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '3964253',
  CIP13: '3400939642536',
  ucdLib: "ANTASOL 135 GAZ INHAL D5L+MAN",
  UCD7: '9285671',
  UCD13: '3400892856711',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTASOL 135 GAZ INHAL D5L+MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5645256',
  CIP13: '3400956452569',
  ucdLib: "KALINOX 50%/50% BOUT15L +MAN.",
  UCD7: '9256474',
  UCD13: '3400892564746',
  ucdQtyMultiplicator: 1,
  cipLib: "KALINOX 50%/50% BOUT15L +MAN. BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '3964230',
  CIP13: '3400939642307',
  ucdLib: "KALINOX 50%/50% BOUT5L +MAN.",
  UCD7: '9396413',
  UCD13: '3400893964132',
  ucdQtyMultiplicator: 1,
  cipLib: "KALINOX 50%/50% BOUT5L +MAN. BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '4177971',
  CIP13: '3400941779718',
  ucdLib: "ANTASOL 180 GAZ INHAL D2L+MAN",
  UCD7: '9377686',
  UCD13: '3400893776865',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTASOL 180 GAZ INHAL D2L+MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '4177988',
  CIP13: '3400941779886',
  ucdLib: "ANTASOL 180 GAZ INHAL D5L+MAN",
  UCD7: '9377692',
  UCD13: '3400893776926',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTASOL 180 GAZ INHAL D5L+MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '2241073',
  CIP13: '3400922410739',
  ucdLib: "ENTONOX 170BAR BOUT 2L +MAN",
  UCD7: '9389235',
  UCD13: '3400893892350',
  ucdQtyMultiplicator: 1,
  cipLib: "ENTONOX 170BAR BOUT 2L +MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '2241096',
  CIP13: '3400922410968',
  ucdLib: "ENTONOX 170BAR BOUT 5L +MAN",
  UCD7: '9389241',
  UCD13: '3400893892411',
  ucdQtyMultiplicator: 1,
  cipLib: "ENTONOX 170BAR BOUT 5L +MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5829588',
  CIP13: '3400958295881',
  ucdLib: "ENTONOX 170BAR BOUT 15L +MAN",
  UCD7: '9389229',
  UCD13: '3400893892299',
  ucdQtyMultiplicator: 1,
  cipLib: "ENTONOX 170BAR BOUT 15L +MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5661054',
  CIP13: '3400956610549',
  ucdLib: "OXYNOX 135 BOUT 15L +MAN",
  UCD7: '9280136',
  UCD13: '3400892801360',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYNOX 135 BOUT 15L +MAN BT 1",
  atcCode: "N01AX63"
}, {
  CIP7: '5714678',
  CIP13: '3400957146788',
  ucdLib: "LENOXE 100% GAZ INHAL BOUT10L",
  UCD7: '9321906',
  UCD13: '3400893219065',
  ucdQtyMultiplicator: 1,
  cipLib: "LENOXE 100% GAZ INHAL BOUT10L BT 1",
  atcCode: "N01AX15"
}, {
  CIP7: '5625584',
  CIP13: '3400956255849',
  ucdLib: "AZOTE PROTOXYDE ALS BOUT 15L",
  UCD7: '9234076',
  UCD13: '3400892340760',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE ALS BOUT 15L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625590',
  CIP13: '3400956255900',
  ucdLib: "AZOTE PROTOXYDE ALS BOUT 47L",
  UCD7: '9234082',
  UCD13: '3400892340821',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE ALS BOUT 47L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625578',
  CIP13: '3400956255788',
  ucdLib: "AZOTE PROTOXYDE ALS BOUT 5L",
  UCD7: '9237666',
  UCD13: '3400892376660',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE ALS BOUT 5L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625609',
  CIP13: '3400956256099',
  ucdLib: "AZOTE PROTOXYDE ALS BOUT47L C9",
  UCD7: '9374386',
  UCD13: '3400893743867',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE ALS BOUT47L C9 BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5621439',
  CIP13: '3400956214396',
  ucdLib: "AZOTE PROTOXYDE ALS EVAPO.FIX",
  UCD7: '9235710',
  UCD13: '3400892357102',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE ALS EVAPO.FIX BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5621528',
  CIP13: '3400956215287',
  ucdLib: "AZOTE PROTOXYDE APM 50L +TB",
  UCD7: '9239263',
  UCD13: '3400892392639',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE APM 50L +TB BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5621497',
  CIP13: '3400956214976',
  ucdLib: "AZOTE PROTOXYDE APM BOUT 20L",
  UCD7: '9239234',
  UCD13: '3400892392349',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE APM BOUT 20L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5621505',
  CIP13: '3400956215058',
  ucdLib: "AZOTE PROTOXYDE APM BOUT 50L",
  UCD7: '9239731',
  UCD13: '3400892397313',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE APM BOUT 50L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5621534',
  CIP13: '3400956215348',
  ucdLib: "AZOTE PROTOXYDE APM EVAPO.FIX",
  UCD7: '9239286',
  UCD13: '3400892392868',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE APM EVAPO.FIX BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625443',
  CIP13: '3400956254439',
  ucdLib: "AZOTE PROTOXYDE LDH BOUT 15L",
  UCD7: '9237608',
  UCD13: '3400892376080',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE LDH BOUT 15L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625420',
  CIP13: '3400956254200',
  ucdLib: "AZOTE PROTOXYDE LDH BOUT 2L",
  UCD7: '9237614',
  UCD13: '3400892376141',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE LDH BOUT 2L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625472',
  CIP13: '3400956254729',
  ucdLib: "AZOTE PROTOXYDE LDH BOUT 450L",
  UCD7: '9237620',
  UCD13: '3400892376202',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE LDH BOUT 450L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625466',
  CIP13: '3400956254668',
  ucdLib: "AZOTE PROTOXYDE LDH BOUT 47L",
  UCD7: '9237637',
  UCD13: '3400892376370',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE LDH BOUT 47L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625437',
  CIP13: '3400956254378',
  ucdLib: "AZOTE PROTOXYDE LDH BOUT 5L",
  UCD7: '9237643',
  UCD13: '3400892376431',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE LDH BOUT 5L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625489',
  CIP13: '3400956254897',
  ucdLib: "AZOTE PROTOXYDE LDH BOUT47L C8",
  UCD7: '9356141',
  UCD13: '3400893561416',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE LDH BOUT47L C8 BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625549',
  CIP13: '3400956255498',
  ucdLib: "AZOTE PROTOXYDE SLF BOUT 50L",
  UCD7: '9239323',
  UCD13: '3400892393230',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE SLF BOUT 50L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5625555',
  CIP13: '3400956255559',
  ucdLib: "AZOTE PROTOXYDE SLF BOUT 50L",
  UCD7: '9239323',
  UCD13: '3400892393230',
  ucdQtyMultiplicator: 9,
  cipLib: "AZOTE PROTOXYDE SLF BOUT 50L BT 9",
  atcCode: "N01AX13"
}, {
  CIP7: '5625561',
  CIP13: '3400956255610',
  ucdLib: "AZOTE PROTOXYDE SOL EVAPO.FIX",
  UCD7: '9239346',
  UCD13: '3400892393469',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE SOL EVAPO.FIX BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5634092',
  CIP13: '3400956340927',
  ucdLib: "AZOTE PROTOXYDE SLF BOUT 15L",
  UCD7: '9239292',
  UCD13: '3400892392929',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE SLF BOUT 15L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5650978',
  CIP13: '3400956509782',
  ucdLib: "AZOTE PROTOXYDE LDH BOUT 50L",
  UCD7: '9278990',
  UCD13: '3400892789903',
  ucdQtyMultiplicator: 1,
  cipLib: "AZOTE PROTOXYDE LDH BOUT 50L BT 1",
  atcCode: "N01AX13"
}, {
  CIP7: '5607391',
  CIP13: '3400956073917',
  ucdLib: "GAMMA-OH 200MG/ML INJ AMP10ML",
  UCD7: '9037045',
  UCD13: '3400890370455',
  ucdQtyMultiplicator: 6,
  cipLib: "GAMMA-OH 200MG/ML INJ AMP10ML BT 6",
  atcCode: "N01AX11"
}, {
  CIP7: '5597770',
  CIP13: '3400955977704',
  ucdLib: "DIPRIVAN 10MG/ML INJ SRG50ML",
  UCD7: '9184585',
  UCD13: '3400891845853',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPRIVAN 10MG/ML INJ SRG50ML BT 1",
  atcCode: "N01AX10"
}, {
  CIP7: '5609993',
  CIP13: '3400956099931',
  ucdLib: "PROPOFOL FRF 10MG/ML A.20ML",
  UCD7: '9237258',
  UCD13: '3400892372587',
  ucdQtyMultiplicator: 5,
  cipLib: "PROPOFOL FRF 10MG/ML A.20ML BT 5",
  atcCode: "N01AX10"
}, {
  CIP7: '5610045',
  CIP13: '3400956100453',
  ucdLib: "PROPOFOL FRF 10MG/ML FL100ML",
  UCD7: '9237264',
  UCD13: '3400892372648',
  ucdQtyMultiplicator: 10,
  cipLib: "PROPOFOL FRF 10MG/ML FL100ML BT 10",
  atcCode: "N01AX10"
}, {
  CIP7: '5610016',
  CIP13: '3400956100163',
  ucdLib: "PROPOFOL FRF 10MG/ML FL50ML",
  UCD7: '9237270',
  UCD13: '3400892372709',
  ucdQtyMultiplicator: 10,
  cipLib: "PROPOFOL FRF 10MG/ML FL50ML BT 10",
  atcCode: "N01AX10"
}, {
  CIP7: '5636116',
  CIP13: '3400956361168',
  ucdLib: "DIPRIVAN 20MG/ML INJ SRG50ML",
  UCD7: '9239636',
  UCD13: '3400892396361',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPRIVAN 20MG/ML INJ SRG50ML BT 1",
  atcCode: "N01AX10"
}, {
  CIP7: '5636079',
  CIP13: '3400956360796',
  ucdLib: "PROPOFOL LIPURO 1% INJ A20ML",
  UCD7: '9238074',
  UCD13: '3400892380742',
  ucdQtyMultiplicator: 5,
  cipLib: "PROPOFOL LIPURO 1% INJ A20ML BT 5",
  atcCode: "N01AX10"
}, {
  CIP7: '5641063',
  CIP13: '3400956410637',
  ucdLib: "PROPOFOL MYL 20MG/ML FL50ML",
  UCD7: '9250661',
  UCD13: '3400892506616',
  ucdQtyMultiplicator: 1,
  cipLib: "PROPOFOL MYL 20MG/ML FL50ML BT 1",
  atcCode: "N01AX10"
}, {
  CIP7: '5717369',
  CIP13: '3400957173692',
  ucdLib: "PROPOFOL LIPURO 1% INJ F100ML",
  UCD7: '9239837',
  UCD13: '3400892398372',
  ucdQtyMultiplicator: 10,
  cipLib: "PROPOFOL LIPURO 1% INJ F100ML BT 10",
  atcCode: "N01AX10"
}, {
  CIP7: '5717352',
  CIP13: '3400957173524',
  ucdLib: "PROPOFOL LIPURO 1% INJ F50ML",
  UCD7: '9239843',
  UCD13: '3400892398433',
  ucdQtyMultiplicator: 10,
  cipLib: "PROPOFOL LIPURO 1% INJ F50ML BT 10",
  atcCode: "N01AX10"
}, {
  CIP7: '5705283',
  CIP13: '3400957052836',
  ucdLib: "PROPOFOL LIPURO 2% INJ F50ML",
  UCD7: '9312681',
  UCD13: '3400893126813',
  ucdQtyMultiplicator: 10,
  cipLib: "PROPOFOL LIPURO 2% INJ F50ML BT 10",
  atcCode: "N01AX10"
}, {
  CIP7: '5729421',
  CIP13: '3400957294212',
  ucdLib: "PROPOFOL PAN 10MG/ML FL100ML",
  UCD7: '9320568',
  UCD13: '3400893205686',
  ucdQtyMultiplicator: 1,
  cipLib: "PROPOFOL PAN 10MG/ML FL100ML BT 1",
  atcCode: "N01AX10"
}, {
  CIP7: '5729415',
  CIP13: '3400957294151',
  ucdLib: "PROPOFOL PAN 10MG/ML FL50ML",
  UCD7: '9393656',
  UCD13: '3400893936566',
  ucdQtyMultiplicator: 1,
  cipLib: "PROPOFOL PAN 10MG/ML FL50ML BT 1",
  atcCode: "N01AX10"
}, {
  CIP7: '5738621',
  CIP13: '3400957386214',
  ucdLib: "PROPOFOL LIPURO 5MG/ML A20ML",
  UCD7: '9331402',
  UCD13: '3400893314029',
  ucdQtyMultiplicator: 5,
  cipLib: "PROPOFOL LIPURO 5MG/ML A20ML BT 5",
  atcCode: "N01AX10"
}, {
  CIP7: '5849473',
  CIP13: '3400958494734',
  ucdLib: "PROPOFOL PAN 10MG/ML FL20ML",
  UCD7: '9382233',
  UCD13: '3400893822333',
  ucdQtyMultiplicator: 5,
  cipLib: "PROPOFOL PAN 10MG/ML FL20ML BT 5",
  atcCode: "N01AX10"
}, {
  CIP7: '5606919',
  CIP13: '3400956069194',
  ucdLib: "HYPNOMIDATE 2MG/ML INJ 10ML",
  UCD7: '9120378',
  UCD13: '3400891203783',
  ucdQtyMultiplicator: 5,
  cipLib: "HYPNOMIDATE 2MG/ML INJ 10ML BT 5",
  atcCode: "N01AX07"
}, {
  CIP7: '5614379',
  CIP13: '3400956143795',
  ucdLib: "ETOMIDATE LIPURO 20MG A.10ML",
  UCD7: '9201467',
  UCD13: '3400892014678',
  ucdQtyMultiplicator: 10,
  cipLib: "ETOMIDATE LIPURO 20MG A.10ML BT 10",
  atcCode: "N01AX07"
}, {
  CIP7: '5839807',
  CIP13: '3400958398070',
  ucdLib: "KETAMINE PAN 250MG AMP5ML",
  UCD7: '9126903',
  UCD13: '3400891269031',
  ucdQtyMultiplicator: 5,
  cipLib: "KETAMINE PAN 250MG AMP5ML BT 5",
  atcCode: "N01AX03"
}, {
  CIP7: '5839799',
  CIP13: '3400958397998',
  ucdLib: "KETAMINE PAN 50MG AMP5ML",
  UCD7: '9126926',
  UCD13: '3400891269260',
  ucdQtyMultiplicator: 5,
  cipLib: "KETAMINE PAN 50MG AMP5ML BT 5",
  atcCode: "N01AX03"
}, {
  CIP7: '5785299',
  CIP13: '3400957852993',
  ucdLib: "KETAMINE REN10MG/ML INJ 5ML",
  UCD7: '9362928',
  UCD13: '3400893629284',
  ucdQtyMultiplicator: 10,
  cipLib: "KETAMINE REN10MG/ML INJ 5ML BT 10",
  atcCode: "N01AX03"
}, {
  CIP7: '5785419',
  CIP13: '3400957854195',
  ucdLib: "KETAMINE REN50MG/ML INJ 5ML",
  UCD7: '9362934',
  UCD13: '3400893629345',
  ucdQtyMultiplicator: 10,
  cipLib: "KETAMINE REN50MG/ML INJ 5ML BT 10",
  atcCode: "N01AX03"
}, {
  CIP7: '5601394',
  CIP13: '3400956013944',
  ucdLib: "ULTIVA 1MG INJ FL",
  UCD7: '9190516',
  UCD13: '3400891905168',
  ucdQtyMultiplicator: 5,
  cipLib: "ULTIVA 1MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5601402',
  CIP13: '3400956014026',
  ucdLib: "ULTIVA 2MG INJ FL",
  UCD7: '9190522',
  UCD13: '3400891905229',
  ucdQtyMultiplicator: 5,
  cipLib: "ULTIVA 2MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5601649',
  CIP13: '3400956016495',
  ucdLib: "ULTIVA 5MG INJ FL",
  UCD7: '9190539',
  UCD13: '3400891905397',
  ucdQtyMultiplicator: 5,
  cipLib: "ULTIVA 5MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5795317',
  CIP13: '3400957953171',
  ucdLib: "REMIFENTANIL ARW 1MG INJ FL",
  UCD7: '9373760',
  UCD13: '3400893737606',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL ARW 1MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5795323',
  CIP13: '3400957953232',
  ucdLib: "REMIFENTANIL ARW 2MG INJ FL",
  UCD7: '9373777',
  UCD13: '3400893737774',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL ARW 2MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5795346',
  CIP13: '3400957953461',
  ucdLib: "REMIFENTANIL ARW 5MG INJ FL",
  UCD7: '9373783',
  UCD13: '3400893737835',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL ARW 5MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5791963',
  CIP13: '3400957919634',
  ucdLib: "REMIFENTANIL HPI 1MG INJ FL",
  UCD7: '9377166',
  UCD13: '3400893771662',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL HPI 1MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5791986',
  CIP13: '3400957919863',
  ucdLib: "REMIFENTANIL HPI 2MG INJ FL",
  UCD7: '9377172',
  UCD13: '3400893771723',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL HPI 2MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5791992',
  CIP13: '3400957919924',
  ucdLib: "REMIFENTANIL HPI 5MG INJ FL",
  UCD7: '9377189',
  UCD13: '3400893771891',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL HPI 5MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5772836',
  CIP13: '3400957728366',
  ucdLib: "REMIFENTANIL MYL 1MG INJ FL",
  UCD7: '9355070',
  UCD13: '3400893550700',
  ucdQtyMultiplicator: 10,
  cipLib: "REMIFENTANIL MYL 1MG INJ FL BT 10",
  atcCode: "N01AH06"
}, {
  CIP7: '5772894',
  CIP13: '3400957728946',
  ucdLib: "REMIFENTANIL MYL 2MG INJ FL",
  UCD7: '9355087',
  UCD13: '3400893550878',
  ucdQtyMultiplicator: 10,
  cipLib: "REMIFENTANIL MYL 2MG INJ FL BT 10",
  atcCode: "N01AH06"
}, {
  CIP7: '5772954',
  CIP13: '3400957729547',
  ucdLib: "REMIFENTANIL MYL 5MG INJ FL",
  UCD7: '9355093',
  UCD13: '3400893550939',
  ucdQtyMultiplicator: 10,
  cipLib: "REMIFENTANIL MYL 5MG INJ FL BT 10",
  atcCode: "N01AH06"
}, {
  CIP7: '5779169',
  CIP13: '3400957791698',
  ucdLib: "REMIFENTANIL TVC 1MG INJ FL",
  UCD7: '9364347',
  UCD13: '3400893643471',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL TVC 1MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5779181',
  CIP13: '3400957791810',
  ucdLib: "REMIFENTANIL TVC 2MG INJ FL",
  UCD7: '9364353',
  UCD13: '3400893643532',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL TVC 2MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5779206',
  CIP13: '3400957792060',
  ucdLib: "REMIFENTANIL TVC 5MG INJ FL",
  UCD7: '9364376',
  UCD13: '3400893643761',
  ucdQtyMultiplicator: 5,
  cipLib: "REMIFENTANIL TVC 5MG INJ FL BT 5",
  atcCode: "N01AH06"
}, {
  CIP7: '5572468',
  CIP13: '3400955724681',
  ucdLib: "SUFENTA 250MCG/5ML INJ AMP",
  UCD7: '9153662',
  UCD13: '3400891536621',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTA 250MCG/5ML INJ AMP BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5611464',
  CIP13: '3400956114641',
  ucdLib: "SUFENTA 10MCG/2ML INJ AMP",
  UCD7: '9211201',
  UCD13: '3400892112015',
  ucdQtyMultiplicator: 5,
  cipLib: "SUFENTA 10MCG/2ML INJ AMP BT 5",
  atcCode: "N01AH03"
}, {
  CIP7: '5611470',
  CIP13: '3400956114702',
  ucdLib: "SUFENTA 50MCG/10ML INJ AMP",
  UCD7: '9211218',
  UCD13: '3400892112183',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTA 50MCG/10ML INJ AMP BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5501478',
  CIP13: '3400955014782',
  ucdLib: "ZALVISO 15MCG CPR SUB CAR40",
  UCD7: '9415866',
  UCD13: '3400894158660',
  ucdQtyMultiplicator: 20,
  cipLib: "ZALVISO 15MCG CPR SUB CAR40 BT 20",
  atcCode: "N01AH03"
}, {
  CIP7: '5648970',
  CIP13: '3400956489701',
  ucdLib: "SUFENTANIL MYL 50MCG/ML 5ML",
  UCD7: '9250247',
  UCD13: '3400892502472',
  ucdQtyMultiplicator: 20,
  cipLib: "SUFENTANIL MYL 50MCG/ML 5ML BT 20",
  atcCode: "N01AH03"
}, {
  CIP7: '5649053',
  CIP13: '3400956490530',
  ucdLib: "SUFENTANIL MYL 5MCG/ML 10ML",
  UCD7: '9250224',
  UCD13: '3400892502243',
  ucdQtyMultiplicator: 20,
  cipLib: "SUFENTANIL MYL 5MCG/ML 10ML BT 20",
  atcCode: "N01AH03"
}, {
  CIP7: '5649018',
  CIP13: '3400956490189',
  ucdLib: "SUFENTANIL MYL 5MCG/ML 2ML",
  UCD7: '9250230',
  UCD13: '3400892502304',
  ucdQtyMultiplicator: 20,
  cipLib: "SUFENTANIL MYL 5MCG/ML 2ML BT 20",
  atcCode: "N01AH03"
}, {
  CIP7: '5660445',
  CIP13: '3400956604456',
  ucdLib: "SUFENTANIL EPT 50MCG/ML 5ML",
  UCD7: '9266018',
  UCD13: '3400892660189',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTANIL EPT 50MCG/ML 5ML BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5660563',
  CIP13: '3400956605637',
  ucdLib: "SUFENTANIL EPT 5MCG/ML 10ML",
  UCD7: '9265987',
  UCD13: '3400892659879',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTANIL EPT 5MCG/ML 10ML BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5660528',
  CIP13: '3400956605286',
  ucdLib: "SUFENTANIL EPT 5MCG/ML 2ML",
  UCD7: '9265993',
  UCD13: '3400892659930',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTANIL EPT 5MCG/ML 2ML BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5674714',
  CIP13: '3400956747146',
  ucdLib: "SUFENTANIL REN 50MCG/ML 5ML",
  UCD7: '9282425',
  UCD13: '3400892824253',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTANIL REN 50MCG/ML 5ML BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5675323',
  CIP13: '3400956753239',
  ucdLib: "SUFENTANIL REN 5MCG/ML 10ML",
  UCD7: '9282402',
  UCD13: '3400892824024',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTANIL REN 5MCG/ML 10ML BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5675257',
  CIP13: '3400956752577',
  ucdLib: "SUFENTANIL REN 5MCG/ML 2ML",
  UCD7: '9282419',
  UCD13: '3400892824192',
  ucdQtyMultiplicator: 10,
  cipLib: "SUFENTANIL REN 5MCG/ML 2ML BT 10",
  atcCode: "N01AH03"
}, {
  CIP7: '5546057',
  CIP13: '3400955460572',
  ucdLib: "RAPIFEN 1MG INJ AMP2ML",
  UCD7: '9109879',
  UCD13: '3400891098792',
  ucdQtyMultiplicator: 5,
  cipLib: "RAPIFEN 1MG INJ AMP2ML BT 5",
  atcCode: "N01AH02"
}, {
  CIP7: '5546086',
  CIP13: '3400955460862',
  ucdLib: "RAPIFEN 5MG INJ AMP10ML",
  UCD7: '9109885',
  UCD13: '3400891098853',
  ucdQtyMultiplicator: 10,
  cipLib: "RAPIFEN 5MG INJ AMP10ML BT 10",
  atcCode: "N01AH02"
}, {
  CIP7: '5561370',
  CIP13: '3400955613701',
  ucdLib: "FENTANYL JAN 500MCG AMP10ML",
  UCD7: '9034644',
  UCD13: '3400890346443',
  ucdQtyMultiplicator: 10,
  cipLib: "FENTANYL JAN 500MCG AMP10ML BT 10",
  atcCode: "N01AH01"
}, {
  CIP7: '5587837',
  CIP13: '3400955878377',
  ucdLib: "FENTANYL JAN 100MCG AMP2ML",
  UCD7: '9034650',
  UCD13: '3400890346504',
  ucdQtyMultiplicator: 5,
  cipLib: "FENTANYL JAN 100MCG AMP2ML BT 5",
  atcCode: "N01AH01"
}, {
  CIP7: '5622025',
  CIP13: '3400956220250',
  ucdLib: "FENTANYL MYL 100MCG AMP2ML",
  UCD7: '9226680',
  UCD13: '3400892266800',
  ucdQtyMultiplicator: 10,
  cipLib: "FENTANYL MYL 100MCG AMP2ML BT 10",
  atcCode: "N01AH01"
}, {
  CIP7: '5622002',
  CIP13: '3400956220021',
  ucdLib: "FENTANYL MYL 500MCG AMP10ML",
  UCD7: '9226697',
  UCD13: '3400892266978',
  ucdQtyMultiplicator: 10,
  cipLib: "FENTANYL MYL 500MCG AMP10ML BT 10",
  atcCode: "N01AH01"
}, {
  CIP7: '5626276',
  CIP13: '3400956262762',
  ucdLib: "FENTANYL REN 0,05MG/ML 10ML",
  UCD7: '9222179',
  UCD13: '3400892221793',
  ucdQtyMultiplicator: 10,
  cipLib: "FENTANYL REN 0,05MG/ML 10ML BT 10",
  atcCode: "N01AH01"
}, {
  CIP7: '5626218',
  CIP13: '3400956262182',
  ucdLib: "FENTANYL REN 0,05MG/ML 2ML",
  UCD7: '9222185',
  UCD13: '3400892221854',
  ucdQtyMultiplicator: 10,
  cipLib: "FENTANYL REN 0,05MG/ML 2ML BT 10",
  atcCode: "N01AH01"
}, {
  CIP7: '5631627',
  CIP13: '3400956316274',
  ucdLib: "SEVORANE LIQ INHAL FP250ML+SYS",
  UCD7: '9237092',
  UCD13: '3400892370927',
  ucdQtyMultiplicator: 1,
  cipLib: "SEVORANE LIQ INHAL FP250ML+SYS BT 1",
  atcCode: "N01AB08"
}, {
  CIP7: '5674789',
  CIP13: '3400956747894',
  ucdLib: "SEVOFLURANE BAX 1ML/ML 250ML",
  UCD7: '9282477',
  UCD13: '3400892824772',
  ucdQtyMultiplicator: 6,
  cipLib: "SEVOFLURANE BAX 1ML/ML 250ML BT 6",
  atcCode: "N01AB08"
}, {
  CIP7: '5756263',
  CIP13: '3400957562632',
  ucdLib: "SUPRANE INHAL VAP FA240ML",
  UCD7: '9350204',
  UCD13: '3400893502044',
  ucdQtyMultiplicator: 1,
  cipLib: "SUPRANE INHAL VAP FA240ML BT 1",
  atcCode: "N01AB07"
}, {
  CIP7: '5546695',
  CIP13: '3400955466956',
  ucdLib: "FORENE LIQ INHAL VAP FV100ML",
  UCD7: '9105261',
  UCD13: '3400891052619',
  ucdQtyMultiplicator: 1,
  cipLib: "FORENE LIQ INHAL VAP FV100ML BT 1",
  atcCode: "N01AB06"
}, {
  CIP7: '5545862',
  CIP13: '3400955458623',
  ucdLib: "FORENE LIQ INHAL VAP FV250ML",
  UCD7: '9154348',
  UCD13: '3400891543483',
  ucdQtyMultiplicator: 1,
  cipLib: "FORENE LIQ INHAL VAP FV250ML BT 1",
  atcCode: "N01AB06"
}, {
  CIP7: '5574295',
  CIP13: '3400955742951',
  ucdLib: "AERRANE SOL ANESTH FL100ML",
  UCD7: '9162141',
  UCD13: '3400891621419',
  ucdQtyMultiplicator: 6,
  cipLib: "AERRANE SOL ANESTH FL100ML BT 6",
  atcCode: "N01AB06"
}, {
  CIP7: '5573901',
  CIP13: '3400955739012',
  ucdLib: "ISOFLURANE BELAMONT FL100ML",
  UCD7: '9156778',
  UCD13: '3400891567786',
  ucdQtyMultiplicator: 1,
  cipLib: "ISOFLURANE BELAMONT FL100ML BT 1",
  atcCode: "N01AB06"
}, {
  CIP7: '5596575',
  CIP13: '3400955965756',
  ucdLib: "AERRANE SOL ANESTH FL250ML",
  UCD7: '9194715',
  UCD13: '3400891947151',
  ucdQtyMultiplicator: 6,
  cipLib: "AERRANE SOL ANESTH FL250ML BT 6",
  atcCode: "N01AB06"
}, {
  CIP7: '2795937',
  CIP13: '3400927959370',
  ucdLib: "TRANSLARNA 1000MG GLE BUV SA",
  UCD7: '9402757',
  UCD13: '3400894027577',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANSLARNA 1000MG GLE BUV SA BT 30",
  atcCode: "M09AX03"
}, {
  CIP7: '2795914',
  CIP13: '3400927959141',
  ucdLib: "TRANSLARNA 125MG GLE BUV SAC",
  UCD7: '9402763',
  UCD13: '3400894027638',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANSLARNA 125MG GLE BUV SAC BT 30",
  atcCode: "M09AX03"
}, {
  CIP7: '2795920',
  CIP13: '3400927959202',
  ucdLib: "TRANSLARNA 250MG GLE BUV SAC",
  UCD7: '9402786',
  UCD13: '3400894027867',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANSLARNA 250MG GLE BUV SAC BT 30",
  atcCode: "M09AX03"
}, {
  CIP7: '3356571',
  CIP13: '3400933565718',
  ucdLib: "HYALGAN 20MG/2ML INJ SRG",
  UCD7: '9170376',
  UCD13: '3400891703764',
  ucdQtyMultiplicator: 1,
  cipLib: "HYALGAN 20MG/2ML INJ SRG BT 1",
  atcCode: "M09AX01"
}, {
  CIP7: '4928578',
  CIP13: '3400949285785',
  ucdLib: "PROLIA 60MG INJ SRG1ML P/A",
  UCD7: '9354739',
  UCD13: '3400893547397',
  ucdQtyMultiplicator: 1,
  cipLib: "PROLIA 60MG INJ SRG1ML P/A BT 1",
  atcCode: "M05BX04"
}, {
  CIP7: '2172538',
  CIP13: '3400921725384',
  ucdLib: "XGEVA 120MG INJ FL1,7ML",
  UCD7: '9384143',
  UCD13: '3400893841433',
  ucdQtyMultiplicator: 1,
  cipLib: "XGEVA 120MG INJ FL1,7ML BT 1",
  atcCode: "M05BX04"
}, {
  CIP7: '3651703',
  CIP13: '3400936517035',
  ucdLib: "PROTELOS 2G BUV GLE SACH",
  UCD7: '9270540',
  UCD13: '3400892705408',
  ucdQtyMultiplicator: 28,
  cipLib: "PROTELOS 2G BUV GLE SACH BT 28",
  atcCode: "M05BX03"
}, {
  CIP7: '5649277',
  CIP13: '3400956492770',
  ucdLib: "OSIGRAFT 3,3MG INJ FL",
  UCD7: '9283904',
  UCD13: '3400892839042',
  ucdQtyMultiplicator: 1,
  cipLib: "OSIGRAFT 3,3MG INJ FL BT 1",
  atcCode: "M05BC02"
}, {
  CIP7: '3813057',
  CIP13: '3400938130577',
  ucdLib: "ACTONELCOMBI CPR+GLE SACH",
  UCD7: '9307881',
  UCD13: '3400893078815',
  ucdQtyMultiplicator: 4,
  cipLib: "ACTONELCOMBI CPR+GLE SACH BT 4",
  atcCode: "M05BB04"
}, {
  CIP7: '3828455',
  CIP13: '3400938284553',
  ucdLib: "ACTONELCOMBI CPR+GLE SACH",
  UCD7: '9307881',
  UCD13: '3400893078815',
  ucdQtyMultiplicator: 12,
  cipLib: "ACTONELCOMBI CPR+GLE SACH BT 12",
  atcCode: "M05BB04"
}, {
  CIP7: '3702234',
  CIP13: '3400937022347',
  ucdLib: "FOSAVANCE 70MG/2800UI CPR",
  UCD7: '9278607',
  UCD13: '3400892786070',
  ucdQtyMultiplicator: 12,
  cipLib: "FOSAVANCE 70MG/2800UI CPR BT 12",
  atcCode: "M05BB03"
}, {
  CIP7: '4950046',
  CIP13: '3400949500468',
  ucdLib: "FOSAVANCE 70/2800 CP ADP MWI",
  UCD7: '9317833',
  UCD13: '3400893178331',
  ucdQtyMultiplicator: 4,
  cipLib: "FOSAVANCE 70/2800 CP ADP MWI BT 4",
  atcCode: "M05BB03"
}, {
  CIP7: '4950141',
  CIP13: '3400949501410',
  ucdLib: "FOSAVANCE 70/2800 CP ADP MWI",
  UCD7: '9317833',
  UCD13: '3400893178331',
  ucdQtyMultiplicator: 12,
  cipLib: "FOSAVANCE 70/2800 CP ADP MWI BT 12",
  atcCode: "M05BB03"
}, {
  CIP7: '4950052',
  CIP13: '3400949500529',
  ucdLib: "FOSAVANCE 70/2800 CP ADP PLA",
  UCD7: '9318258',
  UCD13: '3400893182581',
  ucdQtyMultiplicator: 4,
  cipLib: "FOSAVANCE 70/2800 CP ADP PLA BT 4",
  atcCode: "M05BB03"
}, {
  CIP7: '4950187',
  CIP13: '3400949501878',
  ucdLib: "FOSAVANCE 70/2800 CP ADP PLA",
  UCD7: '9318258',
  UCD13: '3400893182581',
  ucdQtyMultiplicator: 12,
  cipLib: "FOSAVANCE 70/2800 CP ADP PLA BT 12",
  atcCode: "M05BB03"
}, {
  CIP7: '4950112',
  CIP13: '3400949501120',
  ucdLib: "FOSAVANCE 70/5600 CP ADP MWI",
  UCD7: '9335096',
  UCD13: '3400893350966',
  ucdQtyMultiplicator: 4,
  cipLib: "FOSAVANCE 70/5600 CP ADP MWI BT 4",
  atcCode: "M05BB03"
}, {
  CIP7: '4950158',
  CIP13: '3400949501588',
  ucdLib: "FOSAVANCE 70/5600 CP ADP MWI",
  UCD7: '9335096',
  UCD13: '3400893350966',
  ucdQtyMultiplicator: 12,
  cipLib: "FOSAVANCE 70/5600 CP ADP MWI BT 12",
  atcCode: "M05BB03"
}, {
  CIP7: '3692518',
  CIP13: '3400936925182',
  ucdLib: "FOSAVANCE 70MG/2800UI CPR",
  UCD7: '9278607',
  UCD13: '3400892786070',
  ucdQtyMultiplicator: 4,
  cipLib: "FOSAVANCE 70MG/2800UI CPR BT 4",
  atcCode: "M05BB03"
}, {
  CIP7: '3780872',
  CIP13: '3400937808729',
  ucdLib: "ADROVANCE 70MG/2800UI CPR",
  UCD7: '9300809',
  UCD13: '3400893008096',
  ucdQtyMultiplicator: 4,
  cipLib: "ADROVANCE 70MG/2800UI CPR BT 4",
  atcCode: "M05BB03"
}, {
  CIP7: '3780895',
  CIP13: '3400937808958',
  ucdLib: "ADROVANCE 70MG/2800UI CPR",
  UCD7: '9300809',
  UCD13: '3400893008096',
  ucdQtyMultiplicator: 12,
  cipLib: "ADROVANCE 70MG/2800UI CPR BT 12",
  atcCode: "M05BB03"
}, {
  CIP7: '3820212',
  CIP13: '3400938202120',
  ucdLib: "ADROVANCE 70MG/5600UI CPR",
  UCD7: '9308573',
  UCD13: '3400893085738',
  ucdQtyMultiplicator: 4,
  cipLib: "ADROVANCE 70MG/5600UI CPR BT 4",
  atcCode: "M05BB03"
}, {
  CIP7: '3820229',
  CIP13: '3400938202298',
  ucdLib: "ADROVANCE 70MG/5600UI CPR",
  UCD7: '9308573',
  UCD13: '3400893085738',
  ucdQtyMultiplicator: 12,
  cipLib: "ADROVANCE 70MG/5600UI CPR BT 12",
  atcCode: "M05BB03"
}, {
  CIP7: '3820181',
  CIP13: '3400938201819',
  ucdLib: "FOSAVANCE 70MG/5600UI CPR",
  UCD7: '9308277',
  UCD13: '3400893082775',
  ucdQtyMultiplicator: 4,
  cipLib: "FOSAVANCE 70MG/5600UI CPR BT 4",
  atcCode: "M05BB03"
}, {
  CIP7: '3820198',
  CIP13: '3400938201987',
  ucdLib: "FOSAVANCE 70MG/5600UI CPR",
  UCD7: '9308277',
  UCD13: '3400893082775',
  ucdQtyMultiplicator: 12,
  cipLib: "FOSAVANCE 70MG/5600UI CPR BT 12",
  atcCode: "M05BB03"
}, {
  CIP7: '3658711',
  CIP13: '3400936587113',
  ucdLib: "ACLASTA 5MG PERF FL100ML",
  UCD7: '9279179',
  UCD13: '3400892791791',
  ucdQtyMultiplicator: 1,
  cipLib: "ACLASTA 5MG PERF FL100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2757664',
  CIP13: '3400927576645',
  ucdLib: "ACID.ZOLEDRONIQ.BGA 5MG/100ML",
  UCD7: '9398694',
  UCD13: '3400893986943',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.BGA 5MG/100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2696425',
  CIP13: '3400926964252',
  ucdLib: "ACID.ZOLEDRONIQ.MDC 4MG/100ML",
  UCD7: '9391812',
  UCD13: '3400893918128',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.MDC 4MG/100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2687834',
  CIP13: '3400926878344',
  ucdLib: "ACID.ZOLEDRONIQ.HPI 4MG/100ML",
  UCD7: '9390103',
  UCD13: '3400893901038',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.HPI 4MG/100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2675601',
  CIP13: '3400926756017',
  ucdLib: "ACID.ZOLEDRONIQ.MYL 4MG/5ML",
  UCD7: '9389270',
  UCD13: '3400893892701',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.MYL 4MG/5ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2240889',
  CIP13: '3400922408897',
  ucdLib: "ACID.ZOLEDRONIQ.SDZ 4MG/100ML",
  UCD7: '9391427',
  UCD13: '3400893914274',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.SDZ 4MG/100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2247236',
  CIP13: '3400922472362',
  ucdLib: "ACID.ZOLEDRONIQ.SDZ 5MG/100ML",
  UCD7: '9404408',
  UCD13: '3400894044086',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.SDZ 5MG/100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2688377',
  CIP13: '3400926883775',
  ucdLib: "ACID.ZOLEDRONIQ.TVP 5MG/100ML",
  UCD7: '9397890',
  UCD13: '3400893978900',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.TVP 5MG/100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2175264',
  CIP13: '3400921752649',
  ucdLib: "ZOMETA 4MG/100ML PERF FL",
  UCD7: '9382606',
  UCD13: '3400893826065',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOMETA 4MG/100ML PERF FL BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2776130',
  CIP13: '3400927761300',
  ucdLib: "ACID.ZOLEDRONIQ.BGA 4MG/100ML",
  UCD7: '9402409',
  UCD13: '3400894024095',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.BGA 4MG/100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '2779513',
  CIP13: '3400927795138',
  ucdLib: "ACID.ZOLEDRONIQ.ZTL 4MG/100ML",
  UCD7: '9402415',
  UCD13: '3400894024156',
  ucdQtyMultiplicator: 1,
  cipLib: "ACID.ZOLEDRONIQ.ZTL 4MG/100ML BT 1",
  atcCode: "M05BA08"
}, {
  CIP7: '3615771',
  CIP13: '3400936157712',
  ucdLib: "ACTONEL 35MG CPR",
  UCD7: '9247009',
  UCD13: '3400892470092',
  ucdQtyMultiplicator: 4,
  cipLib: "ACTONEL 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4911313',
  CIP13: '3400949113132',
  ucdLib: "RISEDRONATE RBX 35MG CPR",
  UCD7: '9356017',
  UCD13: '3400893560174',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE RBX 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '3543669',
  CIP13: '3400935436696',
  ucdLib: "ACTONEL 30MG CPR",
  UCD7: '9227478',
  UCD13: '3400892274782',
  ucdQtyMultiplicator: 28,
  cipLib: "ACTONEL 30MG CPR BT 28",
  atcCode: "M05BA07"
}, {
  CIP7: '3543623',
  CIP13: '3400935436238',
  ucdLib: "ACTONEL 5MG CPR",
  UCD7: '9227484',
  UCD13: '3400892274843',
  ucdQtyMultiplicator: 28,
  cipLib: "ACTONEL 5MG CPR BT 28",
  atcCode: "M05BA07"
}, {
  CIP7: '3666685',
  CIP13: '3400936666856',
  ucdLib: "ACTONEL 35MG CPR",
  UCD7: '9247009',
  UCD13: '3400892470092',
  ucdQtyMultiplicator: 12,
  cipLib: "ACTONEL 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '3845689',
  CIP13: '3400938456899',
  ucdLib: "ACTONEL 75MG CPR",
  UCD7: '9317218',
  UCD13: '3400893172186',
  ucdQtyMultiplicator: 2,
  cipLib: "ACTONEL 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '3845703',
  CIP13: '3400938457032',
  ucdLib: "ACTONEL 75MG CPR",
  UCD7: '9317218',
  UCD13: '3400893172186',
  ucdQtyMultiplicator: 6,
  cipLib: "ACTONEL 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '4973461',
  CIP13: '3400949734610',
  ucdLib: "RISEDRONATE ARG 35MG CPR",
  UCD7: '9362785',
  UCD13: '3400893627853',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE ARG 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4972504',
  CIP13: '3400949725045',
  ucdLib: "RISEDRONATE CRT 35MG CPR",
  UCD7: '9362851',
  UCD13: '3400893628515',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE CRT 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4972527',
  CIP13: '3400949725274',
  ucdLib: "RISEDRONATE CRT 35MG CPR",
  UCD7: '9362851',
  UCD13: '3400893628515',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE CRT 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4972958',
  CIP13: '3400949729586',
  ucdLib: "RISEDRONATE EG 35MG CPR",
  UCD7: '9363069',
  UCD13: '3400893630693',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE EG 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4972964',
  CIP13: '3400949729647',
  ucdLib: "RISEDRONATE EG 35MG CPR",
  UCD7: '9363069',
  UCD13: '3400893630693',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE EG 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4972898',
  CIP13: '3400949728985',
  ucdLib: "RISEDRONATE EG 5MG CPR",
  UCD7: '9363075',
  UCD13: '3400893630754',
  ucdQtyMultiplicator: 28,
  cipLib: "RISEDRONATE EG 5MG CPR BT 28",
  atcCode: "M05BA07"
}, {
  CIP7: '4978814',
  CIP13: '3400949788149',
  ucdLib: "RISEDRONATE EVO 35MG CPR",
  UCD7: '9365476',
  UCD13: '3400893654767',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE EVO 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4978837',
  CIP13: '3400949788378',
  ucdLib: "RISEDRONATE EVO 35MG CPR",
  UCD7: '9365476',
  UCD13: '3400893654767',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE EVO 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4973490',
  CIP13: '3400949734900',
  ucdLib: "RISEDRONATE ISD 35MG CPR",
  UCD7: '9362868',
  UCD13: '3400893628683',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE ISD 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4973509',
  CIP13: '3400949735099',
  ucdLib: "RISEDRONATE ISD 35MG CPR",
  UCD7: '9362868',
  UCD13: '3400893628683',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE ISD 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4974897',
  CIP13: '3400949748976',
  ucdLib: "RISEDRONATE ZYD 35MG CPR",
  UCD7: '9363081',
  UCD13: '3400893630815',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE ZYD 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4974911',
  CIP13: '3400949749119',
  ucdLib: "RISEDRONATE ZYD 35MG CPR",
  UCD7: '9363081',
  UCD13: '3400893630815',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE ZYD 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4902053',
  CIP13: '3400949020539',
  ucdLib: "ACTONEL 35MG CPR AIP BBA IT",
  UCD7: '9399021',
  UCD13: '3400893990216',
  ucdQtyMultiplicator: 12,
  cipLib: "ACTONEL 35MG CPR AIP BBA IT BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4900017',
  CIP13: '3400949000173',
  ucdLib: "ACTONEL 35MG CPR AIP PLA IT",
  UCD7: '9410662',
  UCD13: '3400894106623',
  ucdQtyMultiplicator: 4,
  cipLib: "ACTONEL 35MG CPR AIP PLA IT BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4902142',
  CIP13: '3400949021420',
  ucdLib: "ACTONEL 75MG CPR AIP BBA IT",
  UCD7: '9399038',
  UCD13: '3400893990384',
  ucdQtyMultiplicator: 6,
  cipLib: "ACTONEL 75MG CPR AIP BBA IT BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '4900020',
  CIP13: '3400949000203',
  ucdLib: "ACTONEL 75MG CPR AIP PLA IT",
  UCD7: '9410679',
  UCD13: '3400894106791',
  ucdQtyMultiplicator: 2,
  cipLib: "ACTONEL 75MG CPR AIP PLA IT BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '2194020',
  CIP13: '3400921940206',
  ucdLib: "RISEDRONATE ALT 35MG CPR",
  UCD7: '9380783',
  UCD13: '3400893807835',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE ALT 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '2194043',
  CIP13: '3400921940435',
  ucdLib: "RISEDRONATE ALT 35MG CPR",
  UCD7: '9380783',
  UCD13: '3400893807835',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE ALT 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4157307',
  CIP13: '3400941573071',
  ucdLib: "RISEDRONATE ARW 75MG CPR",
  UCD7: '9372192',
  UCD13: '3400893721926',
  ucdQtyMultiplicator: 2,
  cipLib: "RISEDRONATE ARW 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '4171945',
  CIP13: '3400941719455',
  ucdLib: "RISEDRONATE ARW 75MG CPR",
  UCD7: '9372192',
  UCD13: '3400893721926',
  ucdQtyMultiplicator: 6,
  cipLib: "RISEDRONATE ARW 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '4157282',
  CIP13: '3400941572821',
  ucdLib: "RISEDRONATE BGA 75MG CPR",
  UCD7: '9368902',
  UCD13: '3400893689028',
  ucdQtyMultiplicator: 2,
  cipLib: "RISEDRONATE BGA 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '4170383',
  CIP13: '3400941703836',
  ucdLib: "RISEDRONATE BGA 75MG CPR",
  UCD7: '9368902',
  UCD13: '3400893689028',
  ucdQtyMultiplicator: 6,
  cipLib: "RISEDRONATE BGA 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '4991849',
  CIP13: '3400949918492',
  ucdLib: "RISEDRONATE BLF 35MG CPR",
  UCD7: '9372424',
  UCD13: '3400893724248',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE BLF 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4991855',
  CIP13: '3400949918553',
  ucdLib: "RISEDRONATE BLF 35MG CPR",
  UCD7: '9372424',
  UCD13: '3400893724248',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE BLF 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4157313',
  CIP13: '3400941573132',
  ucdLib: "RISEDRONATE EG 75MG CPR",
  UCD7: '9372186',
  UCD13: '3400893721865',
  ucdQtyMultiplicator: 2,
  cipLib: "RISEDRONATE EG 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '4171916',
  CIP13: '3400941719165',
  ucdLib: "RISEDRONATE EG 75MG CPR",
  UCD7: '9372186',
  UCD13: '3400893721865',
  ucdQtyMultiplicator: 6,
  cipLib: "RISEDRONATE EG 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '2740712',
  CIP13: '3400927407123',
  ucdLib: "RISEDRONATE MYL 75MG CPR",
  UCD7: '9401025',
  UCD13: '3400894010258',
  ucdQtyMultiplicator: 2,
  cipLib: "RISEDRONATE MYL 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '2740735',
  CIP13: '3400927407352',
  ucdLib: "RISEDRONATE MYL 75MG CPR",
  UCD7: '9401025',
  UCD13: '3400894010258',
  ucdQtyMultiplicator: 6,
  cipLib: "RISEDRONATE MYL 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '2193888',
  CIP13: '3400921938883',
  ucdLib: "RISEDRONATE PHR 35MG CPR",
  UCD7: '9383758',
  UCD13: '3400893837580',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE PHR 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '2193894',
  CIP13: '3400921938944',
  ucdLib: "RISEDRONATE PHR 35MG CPR",
  UCD7: '9383758',
  UCD13: '3400893837580',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE PHR 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4945708',
  CIP13: '3400949457083',
  ucdLib: "RISEDRONATE SDZ 35MG CPR",
  UCD7: '9360711',
  UCD13: '3400893607114',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE SDZ 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4945720',
  CIP13: '3400949457205',
  ucdLib: "RISEDRONATE SDZ 35MG CPR",
  UCD7: '9360711',
  UCD13: '3400893607114',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE SDZ 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '2171763',
  CIP13: '3400921717631',
  ucdLib: "RISEDRONATE ARW 35MG C.PEL",
  UCD7: '9407105',
  UCD13: '3400894071051',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE ARW 35MG C.PEL BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '2171792',
  CIP13: '3400921717921',
  ucdLib: "RISEDRONATE ARW 35MG C.PEL",
  UCD7: '9407105',
  UCD13: '3400894071051',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE ARW 35MG C.PEL BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4924540',
  CIP13: '3400949245406',
  ucdLib: "RISEDRONATE BGR 35MG CPR",
  UCD7: '9356000',
  UCD13: '3400893560006',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE BGR 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4924563',
  CIP13: '3400949245635',
  ucdLib: "RISEDRONATE BGR 35MG CPR",
  UCD7: '9356000',
  UCD13: '3400893560006',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE BGR 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '2229103',
  CIP13: '3400922291031',
  ucdLib: "RISEDRONATE MYP 35MG CPR",
  UCD7: '9400793',
  UCD13: '3400894007937',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE MYP 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '2229132',
  CIP13: '3400922291321',
  ucdLib: "RISEDRONATE MYP 35MG CPR",
  UCD7: '9400793',
  UCD13: '3400894007937',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE MYP 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '2221047',
  CIP13: '3400922210476',
  ucdLib: "RISEDRONATE PHR 75MG CPR",
  UCD7: '9385527',
  UCD13: '3400893855270',
  ucdQtyMultiplicator: 2,
  cipLib: "RISEDRONATE PHR 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '2221053',
  CIP13: '3400922210537',
  ucdLib: "RISEDRONATE PHR 75MG CPR",
  UCD7: '9385527',
  UCD13: '3400893855270',
  ucdQtyMultiplicator: 6,
  cipLib: "RISEDRONATE PHR 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '4927797',
  CIP13: '3400949277971',
  ucdLib: "RISEDRONATE RBX 35MG CPR",
  UCD7: '9356017',
  UCD13: '3400893560174',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE RBX 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '2208236',
  CIP13: '3400922082363',
  ucdLib: "RISEDRONATE RTP 75MG CPR",
  UCD7: '9388968',
  UCD13: '3400893889688',
  ucdQtyMultiplicator: 2,
  cipLib: "RISEDRONATE RTP 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '2208259',
  CIP13: '3400922082592',
  ucdLib: "RISEDRONATE RTP 75MG CPR",
  UCD7: '9388968',
  UCD13: '3400893889688',
  ucdQtyMultiplicator: 6,
  cipLib: "RISEDRONATE RTP 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '2176370',
  CIP13: '3400921763706',
  ucdLib: "RISEDRONATE SDZ 75MG CPR",
  UCD7: '9388951',
  UCD13: '3400893889510',
  ucdQtyMultiplicator: 2,
  cipLib: "RISEDRONATE SDZ 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '2176393',
  CIP13: '3400921763935',
  ucdLib: "RISEDRONATE SDZ 75MG CPR",
  UCD7: '9388951',
  UCD13: '3400893889510',
  ucdQtyMultiplicator: 6,
  cipLib: "RISEDRONATE SDZ 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '4169351',
  CIP13: '3400941693519',
  ucdLib: "RISEDRONATE TVC 75MG CPR",
  UCD7: '9383764',
  UCD13: '3400893837641',
  ucdQtyMultiplicator: 2,
  cipLib: "RISEDRONATE TVC 75MG CPR BT 2",
  atcCode: "M05BA07"
}, {
  CIP7: '4169405',
  CIP13: '3400941694059',
  ucdLib: "RISEDRONATE TVC 75MG CPR",
  UCD7: '9383764',
  UCD13: '3400893837641',
  ucdQtyMultiplicator: 6,
  cipLib: "RISEDRONATE TVC 75MG CPR BT 6",
  atcCode: "M05BA07"
}, {
  CIP7: '4969488',
  CIP13: '3400949694884',
  ucdLib: "RISEDRONATE RTP 35MG CPR",
  UCD7: '9362897',
  UCD13: '3400893628973',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE RTP 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4961883',
  CIP13: '3400949618835',
  ucdLib: "RISEDRONATE TVC 35MG CPR",
  UCD7: '9362905',
  UCD13: '3400893629055',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE TVC 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4961937',
  CIP13: '3400949619375',
  ucdLib: "RISEDRONATE TVC 35MG CPR",
  UCD7: '9362905',
  UCD13: '3400893629055',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE TVC 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '4964433',
  CIP13: '3400949644339',
  ucdLib: "RISEDRONATE ZTL 35MG CPR",
  UCD7: '9408814',
  UCD13: '3400894088141',
  ucdQtyMultiplicator: 4,
  cipLib: "RISEDRONATE ZTL 35MG CPR BT 4",
  atcCode: "M05BA07"
}, {
  CIP7: '4964456',
  CIP13: '3400949644568',
  ucdLib: "RISEDRONATE ZTL 35MG CPR",
  UCD7: '9408814',
  UCD13: '3400894088141',
  ucdQtyMultiplicator: 12,
  cipLib: "RISEDRONATE ZTL 35MG CPR BT 12",
  atcCode: "M05BA07"
}, {
  CIP7: '3656586',
  CIP13: '3400936565869',
  ucdLib: "BONDRONAT 2MG PERF FL2ML",
  UCD7: '9273484',
  UCD13: '3400892734842',
  ucdQtyMultiplicator: 1,
  cipLib: "BONDRONAT 2MG PERF FL2ML BT 1",
  atcCode: "M05BA06"
}, {
  CIP7: '3634857',
  CIP13: '3400936348578',
  ucdLib: "BONDRONAT 6MG PERF FL6ML",
  UCD7: '9261127',
  UCD13: '3400892611273',
  ucdQtyMultiplicator: 1,
  cipLib: "BONDRONAT 6MG PERF FL6ML BT 1",
  atcCode: "M05BA06"
}, {
  CIP7: '3768718',
  CIP13: '3400937687188',
  ucdLib: "BONVIVA 3MG INJ SRG3ML",
  UCD7: '9303989',
  UCD13: '3400893039892',
  ucdQtyMultiplicator: 1,
  cipLib: "BONVIVA 3MG INJ SRG3ML BT 1",
  atcCode: "M05BA06"
}, {
  CIP7: '3716578',
  CIP13: '3400937165785',
  ucdLib: "BONVIVA 150MG CPR",
  UCD7: '9294434',
  UCD13: '3400892944340',
  ucdQtyMultiplicator: 1,
  cipLib: "BONVIVA 150MG CPR BT 1",
  atcCode: "M05BA06"
}, {
  CIP7: '3716584',
  CIP13: '3400937165846',
  ucdLib: "BONVIVA 150MG CPR",
  UCD7: '9294434',
  UCD13: '3400892944340',
  ucdQtyMultiplicator: 3,
  cipLib: "BONVIVA 150MG CPR BT 3",
  atcCode: "M05BA06"
}, {
  CIP7: '3385532',
  CIP13: '3400933855321',
  ucdLib: "SKELID 200MG CPR",
  UCD7: '9180216',
  UCD13: '3400891802160',
  ucdQtyMultiplicator: 28,
  cipLib: "SKELID 200MG CPR BT 28",
  atcCode: "M05BA05"
}, {
  CIP7: '3837052',
  CIP13: '3400938370522',
  ucdLib: "ACID.ALENDRONIQ.RBX 70MG CPR",
  UCD7: '9312511',
  UCD13: '3400893125113',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.RBX 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3837075',
  CIP13: '3400938370751',
  ucdLib: "ACID.ALENDRONIQ.RBX 70MG CPR",
  UCD7: '9312511',
  UCD13: '3400893125113',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.RBX 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3406731',
  CIP13: '3400934067310',
  ucdLib: "FOSAMAX 10MG CPR",
  UCD7: '9182072',
  UCD13: '3400891820720',
  ucdQtyMultiplicator: 28,
  cipLib: "FOSAMAX 10MG CPR BT 28",
  atcCode: "M05BA04"
}, {
  CIP7: '3595637',
  CIP13: '3400935956378',
  ucdLib: "FOSAMAX 70MG CPR",
  UCD7: '9240711',
  UCD13: '3400892407111',
  ucdQtyMultiplicator: 4,
  cipLib: "FOSAMAX 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3595666',
  CIP13: '3400935956668',
  ucdLib: "FOSAMAX 70MG CPR",
  UCD7: '9240711',
  UCD13: '3400892407111',
  ucdQtyMultiplicator: 12,
  cipLib: "FOSAMAX 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3708716',
  CIP13: '3400937087162',
  ucdLib: "ACID.ALENDRONIQ.ARW 10MG CPR",
  UCD7: '9286558',
  UCD13: '3400892865584',
  ucdQtyMultiplicator: 28,
  cipLib: "ACID.ALENDRONIQ.ARW 10MG CPR BT 28",
  atcCode: "M05BA04"
}, {
  CIP7: '3708656',
  CIP13: '3400937086561',
  ucdLib: "ACID.ALENDRONIQ.ARW 70MG CPR",
  UCD7: '9286021',
  UCD13: '3400892860213',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.ARW 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3708679',
  CIP13: '3400937086790',
  ucdLib: "ACID.ALENDRONIQ.ARW 70MG CPR",
  UCD7: '9286021',
  UCD13: '3400892860213',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.ARW 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3708768',
  CIP13: '3400937087681',
  ucdLib: "ACID.ALENDRONIQ.BGA 70MG CPR",
  UCD7: '9285659',
  UCD13: '3400892856599',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.BGA 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3708780',
  CIP13: '3400937087803',
  ucdLib: "ACID.ALENDRONIQ.BGA 70MG CPR",
  UCD7: '9285659',
  UCD13: '3400892856599',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.BGA 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3702168',
  CIP13: '3400937021685',
  ucdLib: "ACID.ALENDRONIQ.EG 70MG CPR",
  UCD7: '9284192',
  UCD13: '3400892841922',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.EG 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3702180',
  CIP13: '3400937021807',
  ucdLib: "ACID.ALENDRONIQ.EG 70MG CPR",
  UCD7: '9284192',
  UCD13: '3400892841922',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.EG 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3743606',
  CIP13: '3400937436069',
  ucdLib: "ACID.ALENDRONIQ.MYL 70MG CPR",
  UCD7: '9286452',
  UCD13: '3400892864525',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.MYL 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3743629',
  CIP13: '3400937436298',
  ucdLib: "ACID.ALENDRONIQ.MYL 70MG CPR",
  UCD7: '9286452',
  UCD13: '3400892864525',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.MYL 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3665036',
  CIP13: '3400936650367',
  ucdLib: "ALENDRONATE TVC 10MG CPR",
  UCD7: '9269413',
  UCD13: '3400892694139',
  ucdQtyMultiplicator: 28,
  cipLib: "ALENDRONATE TVC 10MG CPR BT 28",
  atcCode: "M05BA04"
}, {
  CIP7: '3824983',
  CIP13: '3400938249835',
  ucdLib: "ACID.ALENDRONIQ.ALT 70MG CPR",
  UCD7: '9312126',
  UCD13: '3400893121269',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.ALT 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3825008',
  CIP13: '3400938250084',
  ucdLib: "ACID.ALENDRONIQ.ALT 70MG CPR",
  UCD7: '9312126',
  UCD13: '3400893121269',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.ALT 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3770141',
  CIP13: '3400937701419',
  ucdLib: "ACID.ALENDRONIQ.SDZ 70MG CPR",
  UCD7: '9296315',
  UCD13: '3400892963150',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.SDZ 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3770164',
  CIP13: '3400937701648',
  ucdLib: "ACID.ALENDRONIQ.SDZ 70MG CPR",
  UCD7: '9296315',
  UCD13: '3400892963150',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.SDZ 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3914278',
  CIP13: '3400939142784',
  ucdLib: "ACID.ALENDRONIQ.CRT 70MG CPR",
  UCD7: '9350411',
  UCD13: '3400893504116',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.CRT 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3914290',
  CIP13: '3400939142906',
  ucdLib: "ACID.ALENDRONIQ.CRT 70MG CPR",
  UCD7: '9350411',
  UCD13: '3400893504116',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.CRT 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3914108',
  CIP13: '3400939141084',
  ucdLib: "ACID.ALENDRONIQ.PHR 70MG CPR",
  UCD7: '9350405',
  UCD13: '3400893504055',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.PHR 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3914120',
  CIP13: '3400939141206',
  ucdLib: "ACID.ALENDRONIQ.PHR 70MG CPR",
  UCD7: '9350405',
  UCD13: '3400893504055',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.PHR 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3914433',
  CIP13: '3400939144337',
  ucdLib: "ACID.ALENDRONIQ.TVS 70MG CPR",
  UCD7: '9350434',
  UCD13: '3400893504345',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.TVS 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3914462',
  CIP13: '3400939144627',
  ucdLib: "ACID.ALENDRONIQ.TVS 70MG CPR",
  UCD7: '9350434',
  UCD13: '3400893504345',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.TVS 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3914551',
  CIP13: '3400939145518',
  ucdLib: "ACID.ALENDRONIQ.ZYD 70MG CPR",
  UCD7: '9328624',
  UCD13: '3400893286241',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.ZYD 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '3914574',
  CIP13: '3400939145747',
  ucdLib: "ACID.ALENDRONIQ.ZYD 70MG CPR",
  UCD7: '9328624',
  UCD13: '3400893286241',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.ZYD 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '4192060',
  CIP13: '3400941920608',
  ucdLib: "ACID.ALENDRONIQ.EVO 70MG CPR",
  UCD7: '9378533',
  UCD13: '3400893785331',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.EVO 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '4192083',
  CIP13: '3400941920837',
  ucdLib: "ACID.ALENDRONIQ.EVO 70MG CPR",
  UCD7: '9378533',
  UCD13: '3400893785331',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.EVO 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '2668311',
  CIP13: '3400926683115',
  ucdLib: "STEOVESS 70MG CPR EFFV",
  UCD7: '9415820',
  UCD13: '3400894158202',
  ucdQtyMultiplicator: 4,
  cipLib: "STEOVESS 70MG CPR EFFV BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '2668328',
  CIP13: '3400926683283',
  ucdLib: "STEOVESS 70MG CPR EFFV",
  UCD7: '9415820',
  UCD13: '3400894158202',
  ucdQtyMultiplicator: 12,
  cipLib: "STEOVESS 70MG CPR EFFV BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '4928667',
  CIP13: '3400949286676',
  ucdLib: "ACID.ALENDRONIQ.ACT 70MG CPR",
  UCD7: '9363187',
  UCD13: '3400893631874',
  ucdQtyMultiplicator: 4,
  cipLib: "ACID.ALENDRONIQ.ACT 70MG CPR BT 4",
  atcCode: "M05BA04"
}, {
  CIP7: '4928696',
  CIP13: '3400949286966',
  ucdLib: "ACID.ALENDRONIQ.ACT 70MG CPR",
  UCD7: '9363187',
  UCD13: '3400893631874',
  ucdQtyMultiplicator: 12,
  cipLib: "ACID.ALENDRONIQ.ACT 70MG CPR BT 12",
  atcCode: "M05BA04"
}, {
  CIP7: '3687977',
  CIP13: '3400936879775',
  ucdLib: "OSTEPAM 15MG/ML PERF FP2ML",
  UCD7: '9281667',
  UCD13: '3400892816678',
  ucdQtyMultiplicator: 1,
  cipLib: "OSTEPAM 15MG/ML PERF FP2ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3688008',
  CIP13: '3400936880085',
  ucdLib: "OSTEPAM 15MG/ML PERF FP4ML",
  UCD7: '9281673',
  UCD13: '3400892816739',
  ucdQtyMultiplicator: 1,
  cipLib: "OSTEPAM 15MG/ML PERF FP4ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3650514',
  CIP13: '3400936505148',
  ucdLib: "PAMIDRONATE MYL 3MG/ML FL20ML",
  UCD7: '9309963',
  UCD13: '3400893099636',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE MYL 3MG/ML FL20ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3650543',
  CIP13: '3400936505438',
  ucdLib: "PAMIDRONATE MYL 3MG/ML FL30ML",
  UCD7: '9309986',
  UCD13: '3400893099865',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE MYL 3MG/ML FL30ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3650448',
  CIP13: '3400936504486',
  ucdLib: "PAMIDRONATE MYL 3MG/ML FL5ML",
  UCD7: '9309992',
  UCD13: '3400893099926',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE MYL 3MG/ML FL5ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3816972',
  CIP13: '3400938169720',
  ucdLib: "PAMIDRONATE HPI 3MG/ML FL10ML",
  UCD7: '9304411',
  UCD13: '3400893044117',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE HPI 3MG/ML FL10ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3816966',
  CIP13: '3400938169669',
  ucdLib: "PAMIDRONATE HPI 3MG/ML FL5ML",
  UCD7: '9304428',
  UCD13: '3400893044285',
  ucdQtyMultiplicator: 5,
  cipLib: "PAMIDRONATE HPI 3MG/ML FL5ML BT 5",
  atcCode: "M05BA03"
}, {
  CIP7: '3816989',
  CIP13: '3400938169898',
  ucdLib: "PAMIDRONATE HPI 6MG/ML FL10ML",
  UCD7: '9304397',
  UCD13: '3400893043974',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE HPI 6MG/ML FL10ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3816995',
  CIP13: '3400938169959',
  ucdLib: "PAMIDRONATE HPI 9MG/ML FL10ML",
  UCD7: '9304405',
  UCD13: '3400893044056',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE HPI 9MG/ML FL10ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3712681',
  CIP13: '3400937126816',
  ucdLib: "PAMIDRONATE RTP 3MG/ML FL10ML",
  UCD7: '9281710',
  UCD13: '3400892817101',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE RTP 3MG/ML FL10ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3712712',
  CIP13: '3400937127127',
  ucdLib: "PAMIDRONATE RTP 3MG/ML FL20ML",
  UCD7: '9281727',
  UCD13: '3400892817279',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE RTP 3MG/ML FL20ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3712652',
  CIP13: '3400937126526',
  ucdLib: "PAMIDRONATE RTP 3MG/ML FL5ML",
  UCD7: '9281756',
  UCD13: '3400892817569',
  ucdQtyMultiplicator: 1,
  cipLib: "PAMIDRONATE RTP 3MG/ML FL5ML BT 1",
  atcCode: "M05BA03"
}, {
  CIP7: '3404241',
  CIP13: '3400934042416',
  ucdLib: "LYTOS 520MG CPR",
  UCD7: '9185610',
  UCD13: '3400891856101',
  ucdQtyMultiplicator: 30,
  cipLib: "LYTOS 520MG CPR BT 30",
  atcCode: "M05BA02"
}, {
  CIP7: '3620660',
  CIP13: '3400936206601',
  ucdLib: "CLASTOBAN 800MG CPR",
  UCD7: '9258243',
  UCD13: '3400892582436',
  ucdQtyMultiplicator: 60,
  cipLib: "CLASTOBAN 800MG CPR BT 60",
  atcCode: "M05BA02"
}, {
  CIP7: '3542322',
  CIP13: '3400935423221',
  ucdLib: "CLASTOBAN 300MG INJ AMP5ML",
  UCD7: '9140352',
  UCD13: '3400891403527',
  ucdQtyMultiplicator: 5,
  cipLib: "CLASTOBAN 300MG INJ AMP5ML BT 5",
  atcCode: "M05BA02"
}, {
  CIP7: '3024490',
  CIP13: '3400930244906',
  ucdLib: "COLCHIMAX CPR",
  UCD7: '9020895',
  UCD13: '3400890208956',
  ucdQtyMultiplicator: 20,
  cipLib: "COLCHIMAX CPR BT 20",
  atcCode: "M04AC01"
}, {
  CIP7: '3627509',
  CIP13: '3400936275096',
  ucdLib: "COLCHICINE OPC 1MG CPR",
  UCD7: '9256540',
  UCD13: '3400892565408',
  ucdQtyMultiplicator: 20,
  cipLib: "COLCHICINE OPC 1MG CPR BT 20",
  atcCode: "M04AC01"
}, {
  CIP7: '3857250',
  CIP13: '3400938572506',
  ucdLib: "ADENURIC 120MG CPR",
  UCD7: '9342707',
  UCD13: '3400893427071',
  ucdQtyMultiplicator: 28,
  cipLib: "ADENURIC 120MG CPR BT 28",
  atcCode: "M04AA03"
}, {
  CIP7: '3857244',
  CIP13: '3400938572445',
  ucdLib: "ADENURIC 80MG CPR",
  UCD7: '9342713',
  UCD13: '3400893427132',
  ucdQtyMultiplicator: 28,
  cipLib: "ADENURIC 80MG CPR BT 28",
  atcCode: "M04AA03"
}, {
  CIP7: '3454380',
  CIP13: '3400934543807',
  ucdLib: "ALLOPURINOL MYL 100MG CPR",
  UCD7: '9201183',
  UCD13: '3400892011837',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL MYL 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3454397',
  CIP13: '3400934543975',
  ucdLib: "ALLOPURINOL MYL 200MG CPR",
  UCD7: '9201208',
  UCD13: '3400892012087',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL MYL 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3454405',
  CIP13: '3400934544057',
  ucdLib: "ALLOPURINOL MYL 300MG CPR",
  UCD7: '9201214',
  UCD13: '3400892012148',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL MYL 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3004188',
  CIP13: '3400930041888',
  ucdLib: "ALLOPURINOL BGA 100MG CPR",
  UCD7: '9256511',
  UCD13: '3400892565118',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL BGA 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3004196',
  CIP13: '3400930041963',
  ucdLib: "ALLOPURINOL BGA 200MG CPR",
  UCD7: '9256528',
  UCD13: '3400892565286',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL BGA 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3574598',
  CIP13: '3400935745989',
  ucdLib: "ALLOPURINOL ARW 100MG CPR",
  UCD7: '9234857',
  UCD13: '3400892348575',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ARW 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3574606',
  CIP13: '3400935746061',
  ucdLib: "ALLOPURINOL ARW 100MG CPR",
  UCD7: '9234857',
  UCD13: '3400892348575',
  ucdQtyMultiplicator: 30,
  cipLib: "ALLOPURINOL ARW 100MG CPR BT 30",
  atcCode: "M04AA01"
}, {
  CIP7: '3574664',
  CIP13: '3400935746641',
  ucdLib: "ALLOPURINOL ARW 200MG CPR",
  UCD7: '9234863',
  UCD13: '3400892348636',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ARW 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3574641',
  CIP13: '3400935746412',
  ucdLib: "ALLOPURINOL ARW 300MG CPR",
  UCD7: '9234886',
  UCD13: '3400892348865',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ARW 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3272727',
  CIP13: '3400932727278',
  ucdLib: "ZYLORIC 200MG CPR SECAB",
  UCD7: '9103948',
  UCD13: '3400891039481',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYLORIC 200MG CPR SECAB BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3115554',
  CIP13: '3400931155546',
  ucdLib: "ZYLORIC 100MG CPR",
  UCD7: '9102133',
  UCD13: '3400891021332',
  ucdQtyMultiplicator: 100,
  cipLib: "ZYLORIC 100MG CPR BT 100",
  atcCode: "M04AA01"
}, {
  CIP7: '3262982',
  CIP13: '3400932629824',
  ucdLib: "ALLOPURINOL ZYD 300MG CPR",
  UCD7: '9225663',
  UCD13: '3400892256634',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ZYD 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3259833',
  CIP13: '3400932598335',
  ucdLib: "ZYLORIC 100MG CPR",
  UCD7: '9102133',
  UCD13: '3400891021332',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYLORIC 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3222959',
  CIP13: '3400932229598',
  ucdLib: "ZYLORIC 300MG CPR SECAB",
  UCD7: '9102156',
  UCD13: '3400891021561',
  ucdQtyMultiplicator: 28,
  cipLib: "ZYLORIC 300MG CPR SECAB BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3222971',
  CIP13: '3400932229710',
  ucdLib: "ZYLORIC 300MG CPR SECAB",
  UCD7: '9102156',
  UCD13: '3400891021561',
  ucdQtyMultiplicator: 100,
  cipLib: "ZYLORIC 300MG CPR SECAB BT 100",
  atcCode: "M04AA01"
}, {
  CIP7: '4985599',
  CIP13: '3400949855995',
  ucdLib: "ALLOPURINOL PHR 100MG CPR",
  UCD7: '9365246',
  UCD13: '3400893652466',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL PHR 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '4985754',
  CIP13: '3400949857548',
  ucdLib: "ALLOPURINOL PHR 300MG CPR",
  UCD7: '9365269',
  UCD13: '3400893652695',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL PHR 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3623977',
  CIP13: '3400936239777',
  ucdLib: "ALLOPURINOL BGA 100MG CPR",
  UCD7: '9256511',
  UCD13: '3400892565118',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL BGA 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3624008',
  CIP13: '3400936240087',
  ucdLib: "ALLOPURINOL BGA 200MG CPR",
  UCD7: '9256528',
  UCD13: '3400892565286',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL BGA 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3537858',
  CIP13: '3400935378583',
  ucdLib: "ALLOPURINOL EG 100MG CPR",
  UCD7: '9220542',
  UCD13: '3400892205427',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL EG 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3537870',
  CIP13: '3400935378705',
  ucdLib: "ALLOPURINOL EG 200MG CPR",
  UCD7: '9220559',
  UCD13: '3400892205595',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL EG 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3537864',
  CIP13: '3400935378644',
  ucdLib: "ALLOPURINOL EG 300MG CPR",
  UCD7: '9220565',
  UCD13: '3400892205656',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL EG 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3656853',
  CIP13: '3400936568532',
  ucdLib: "ALLOPURINOL SDZ 100MG CPR",
  UCD7: '9263712',
  UCD13: '3400892637129',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL SDZ 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3658295',
  CIP13: '3400936582958',
  ucdLib: "ALLOPURINOL SDZ 200MG CPR",
  UCD7: '9263729',
  UCD13: '3400892637297',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL SDZ 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3659716',
  CIP13: '3400936597167',
  ucdLib: "ALLOPURINOL SDZ 300MG CPR",
  UCD7: '9263735',
  UCD13: '3400892637358',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL SDZ 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3534311',
  CIP13: '3400935343116',
  ucdLib: "ALLOPURINOL ZYD 200MG CPR",
  UCD7: '9225657',
  UCD13: '3400892256573',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ZYD 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3466532',
  CIP13: '3400934665325',
  ucdLib: "ALLOPURINOL BGA 300MG CPR",
  UCD7: '9256534',
  UCD13: '3400892565347',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL BGA 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3548000',
  CIP13: '3400935480002',
  ucdLib: "ALLOPURINOL ZYD 100MG CPR",
  UCD7: '9225640',
  UCD13: '3400892256405',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ZYD 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '5600733',
  CIP13: '3400956007332',
  ucdLib: "ZYLORIC 200MG CPR SECAB",
  UCD7: '9103948',
  UCD13: '3400891039481',
  ucdQtyMultiplicator: 100,
  cipLib: "ZYLORIC 200MG CPR SECAB BT 100",
  atcCode: "M04AA01"
}, {
  CIP7: '3790942',
  CIP13: '3400937909426',
  ucdLib: "ALLOPURINOL RBX 100MG CPR",
  UCD7: '9317715',
  UCD13: '3400893177150',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL RBX 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3790959',
  CIP13: '3400937909594',
  ucdLib: "ALLOPURINOL RBX 200MG CPR",
  UCD7: '9317721',
  UCD13: '3400893177211',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL RBX 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '3790965',
  CIP13: '3400937909655',
  ucdLib: "ALLOPURINOL RBX 300MG CPR",
  UCD7: '9317738',
  UCD13: '3400893177389',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL RBX 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '2196013',
  CIP13: '3400921960136',
  ucdLib: "ALLOPURINOL ISD 100MG CPR",
  UCD7: '9384568',
  UCD13: '3400893845684',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ISD 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '2167744',
  CIP13: '3400921677447',
  ucdLib: "ALLOPURINOL CRT 100MG CPR",
  UCD7: '9381305',
  UCD13: '3400893813058',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL CRT 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '2167891',
  CIP13: '3400921678918',
  ucdLib: "ALLOPURINOL CRT 200MG CPR",
  UCD7: '9381311',
  UCD13: '3400893813119',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL CRT 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '2168005',
  CIP13: '3400921680058',
  ucdLib: "ALLOPURINOL CRT 300MG CPR",
  UCD7: '9381328',
  UCD13: '3400893813287',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL CRT 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '2167307',
  CIP13: '3400921673074',
  ucdLib: "ALLOPURINOL ZEN 100MG CPR",
  UCD7: '9379768',
  UCD13: '3400893797686',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ZEN 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '2167589',
  CIP13: '3400921675894',
  ucdLib: "ALLOPURINOL ZEN 200MG CPR",
  UCD7: '9379774',
  UCD13: '3400893797747',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ZEN 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '2167626',
  CIP13: '3400921676266',
  ucdLib: "ALLOPURINOL ZEN 300MG CPR",
  UCD7: '9379780',
  UCD13: '3400893797808',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL ZEN 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '4961794',
  CIP13: '3400949617944',
  ucdLib: "ALLOPURINOL TVC 100MG CPR",
  UCD7: '9365275',
  UCD13: '3400893652756',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL TVC 100MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '4962003',
  CIP13: '3400949620036',
  ucdLib: "ALLOPURINOL TVC 200MG CPR",
  UCD7: '9365281',
  UCD13: '3400893652817',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL TVC 200MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '4962368',
  CIP13: '3400949623686',
  ucdLib: "ALLOPURINOL TVC 300MG CPR",
  UCD7: '9365298',
  UCD13: '3400893652985',
  ucdQtyMultiplicator: 28,
  cipLib: "ALLOPURINOL TVC 300MG CPR BT 28",
  atcCode: "M04AA01"
}, {
  CIP7: '5548731',
  CIP13: '3400955487319',
  ucdLib: "DANTRIUM INJ FL",
  UCD7: '9135090',
  UCD13: '3400891350906',
  ucdQtyMultiplicator: 1,
  cipLib: "DANTRIUM INJ FL BT 1",
  atcCode: "M03CA01"
}, {
  CIP7: '3215617',
  CIP13: '3400932156177',
  ucdLib: "DANTRIUM 100MG GELU",
  UCD7: '9023971',
  UCD13: '3400890239714',
  ucdQtyMultiplicator: 30,
  cipLib: "DANTRIUM 100MG GELU BT 30",
  atcCode: "M03CA01"
}, {
  CIP7: '3215623',
  CIP13: '3400932156238',
  ucdLib: "DANTRIUM 100MG GELU",
  UCD7: '9023971',
  UCD13: '3400890239714',
  ucdQtyMultiplicator: 50,
  cipLib: "DANTRIUM 100MG GELU BT 50",
  atcCode: "M03CA01"
}, {
  CIP7: '3215600',
  CIP13: '3400932156009',
  ucdLib: "DANTRIUM 25MG GELU",
  UCD7: '9023988',
  UCD13: '3400890239882',
  ucdQtyMultiplicator: 50,
  cipLib: "DANTRIUM 25MG GELU BT 50",
  atcCode: "M03CA01"
}, {
  CIP7: '3512060',
  CIP13: '3400935120601',
  ucdLib: "DECONTRACTYL 500MG CPR",
  UCD7: '9221211',
  UCD13: '3400892212111',
  ucdQtyMultiplicator: 24,
  cipLib: "DECONTRACTYL 500MG CPR BT 24",
  atcCode: "M03BX06"
}, {
  CIP7: '3616463',
  CIP13: '3400936164635',
  ucdLib: "THIOCOLCHICOSIDE ALM 4MG CPR",
  UCD7: '9295764',
  UCD13: '3400892957647',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE ALM 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3616486',
  CIP13: '3400936164864',
  ucdLib: "THIOCOLCHICOSIDE ALM 4MG CPR",
  UCD7: '9295764',
  UCD13: '3400892957647',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE ALM 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3613973',
  CIP13: '3400936139732',
  ucdLib: "THIOCOLCHICOSIDE CRT 4MG CPR",
  UCD7: '9248606',
  UCD13: '3400892486062',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE CRT 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3613996',
  CIP13: '3400936139961',
  ucdLib: "THIOCOLCHICOSIDE CRT 4MG CPR",
  UCD7: '9248606',
  UCD13: '3400892486062',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE CRT 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3617161',
  CIP13: '3400936171619',
  ucdLib: "THIOCOLCHICOSIDE EG 4MG CPR",
  UCD7: '9242532',
  UCD13: '3400892425320',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE EG 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3339874',
  CIP13: '3400933398743',
  ucdLib: "MIOREL 4MG GELU",
  UCD7: '9154644',
  UCD13: '3400891546446',
  ucdQtyMultiplicator: 12,
  cipLib: "MIOREL 4MG GELU BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3339880',
  CIP13: '3400933398804',
  ucdLib: "MIOREL 4MG GELU",
  UCD7: '9154644',
  UCD13: '3400891546446',
  ucdQtyMultiplicator: 24,
  cipLib: "MIOREL 4MG GELU BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3688853',
  CIP13: '3400936888531',
  ucdLib: "COLTHIOZID 4MG/2ML INJ AMP",
  UCD7: '9277588',
  UCD13: '3400892775883',
  ucdQtyMultiplicator: 5,
  cipLib: "COLTHIOZID 4MG/2ML INJ AMP BT 5",
  atcCode: "M03BX05"
}, {
  CIP7: '3602567',
  CIP13: '3400936025677',
  ucdLib: "THIOCOLCHICOSIDE EG 4MG CPR",
  UCD7: '9242532',
  UCD13: '3400892425320',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE EG 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3673834',
  CIP13: '3400936738348',
  ucdLib: "THIOCOLCHICOSIDE ZEN 4MG CPR",
  UCD7: '9266886',
  UCD13: '3400892668864',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE ZEN 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3673840',
  CIP13: '3400936738409',
  ucdLib: "THIOCOLCHICOSIDE ZEN 4MG CPR",
  UCD7: '9266886',
  UCD13: '3400892668864',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE ZEN 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3560610',
  CIP13: '3400935606105',
  ucdLib: "THIOCOLCHICOSIDE MYL 4MG CPR",
  UCD7: '9228940',
  UCD13: '3400892289403',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE MYL 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3597197',
  CIP13: '3400935971975',
  ucdLib: "THIOCOLCHICOSIDE ARW 4MG CPR",
  UCD7: '9241745',
  UCD13: '3400892417455',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE ARW 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3597205',
  CIP13: '3400935972057',
  ucdLib: "THIOCOLCHICOSIDE ARW 4MG CPR",
  UCD7: '9241745',
  UCD13: '3400892417455',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE ARW 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3597211',
  CIP13: '3400935972118',
  ucdLib: "THIOCOLCHICOSIDE ARW 4MG CPR",
  UCD7: '9241745',
  UCD13: '3400892417455',
  ucdQtyMultiplicator: 30,
  cipLib: "THIOCOLCHICOSIDE ARW 4MG CPR BT 30",
  atcCode: "M03BX05"
}, {
  CIP7: '3597091',
  CIP13: '3400935970916',
  ucdLib: "THIOCOLCHICOSIDE BGA 4MG CPR",
  UCD7: '9241538',
  UCD13: '3400892415383',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE BGA 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3597116',
  CIP13: '3400935971166',
  ucdLib: "THIOCOLCHICOSIDE BGA 4MG CPR",
  UCD7: '9241538',
  UCD13: '3400892415383',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE BGA 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3588264',
  CIP13: '3400935882646',
  ucdLib: "THIOCOLCHICOSIDE MYL 4MG CPR",
  UCD7: '9228940',
  UCD13: '3400892289403',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE MYL 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3690956',
  CIP13: '3400936909564',
  ucdLib: "MIOREL 4MG/2ML INJ AMP",
  UCD7: '9154650',
  UCD13: '3400891546507',
  ucdQtyMultiplicator: 5,
  cipLib: "MIOREL 4MG/2ML INJ AMP BT 5",
  atcCode: "M03BX05"
}, {
  CIP7: '3815116',
  CIP13: '3400938151169',
  ucdLib: "THIOCOLCHICOSIDE ALT 4MG CPR",
  UCD7: '9306143',
  UCD13: '3400893061435',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE ALT 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3815122',
  CIP13: '3400938151220',
  ucdLib: "THIOCOLCHICOSIDE ALT 4MG CPR",
  UCD7: '9306143',
  UCD13: '3400893061435',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE ALT 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '3661765',
  CIP13: '3400936617650',
  ucdLib: "THIOCOLCHICOSIDE SDZ 4MG CPR",
  UCD7: '9265881',
  UCD13: '3400892658810',
  ucdQtyMultiplicator: 12,
  cipLib: "THIOCOLCHICOSIDE SDZ 4MG CPR BT 12",
  atcCode: "M03BX05"
}, {
  CIP7: '3661771',
  CIP13: '3400936617711',
  ucdLib: "THIOCOLCHICOSIDE SDZ 4MG CPR",
  UCD7: '9265881',
  UCD13: '3400892658810',
  ucdQtyMultiplicator: 24,
  cipLib: "THIOCOLCHICOSIDE SDZ 4MG CPR BT 24",
  atcCode: "M03BX05"
}, {
  CIP7: '5893333',
  CIP13: '3400958933332',
  ucdLib: "SIRDALUD 4MG CPR",
  UCD7: '9300175',
  UCD13: '3400893001752',
  ucdQtyMultiplicator: 30,
  cipLib: "SIRDALUD 4MG CPR BT 30",
  atcCode: "M03BX02"
}, {
  CIP7: '5585376',
  CIP13: '3400955853763',
  ucdLib: "LIORESAL 0,05MG INJ AMP1ML",
  UCD7: '9170583',
  UCD13: '3400891705836',
  ucdQtyMultiplicator: 1,
  cipLib: "LIORESAL 0,05MG INJ AMP1ML BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '5585399',
  CIP13: '3400955853992',
  ucdLib: "LIORESAL 10MG INJ AMP20ML",
  UCD7: '9170608',
  UCD13: '3400891706086',
  ucdQtyMultiplicator: 1,
  cipLib: "LIORESAL 10MG INJ AMP20ML BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '5585382',
  CIP13: '3400955853824',
  ucdLib: "LIORESAL 10MG INJ AMP5ML",
  UCD7: '9170614',
  UCD13: '3400891706147',
  ucdQtyMultiplicator: 1,
  cipLib: "LIORESAL 10MG INJ AMP5ML BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '3674319',
  CIP13: '3400936743199',
  ucdLib: "BACLOFENE ZEN 10MG CPR",
  UCD7: '9269778',
  UCD13: '3400892697789',
  ucdQtyMultiplicator: 30,
  cipLib: "BACLOFENE ZEN 10MG CPR BT 30",
  atcCode: "M03BX01"
}, {
  CIP7: '3171618',
  CIP13: '3400931716181',
  ucdLib: "LIORESAL CPR",
  UCD7: '9054322',
  UCD13: '3400890543224',
  ucdQtyMultiplicator: 50,
  cipLib: "LIORESAL CPR BT 50",
  atcCode: "M03BX01"
}, {
  CIP7: '5786755',
  CIP13: '3400957867553',
  ucdLib: "BACLOFENE AGT 0,05MG/ML A1ML",
  UCD7: '9366300',
  UCD13: '3400893663004',
  ucdQtyMultiplicator: 10,
  cipLib: "BACLOFENE AGT 0,05MG/ML A1ML BT 10",
  atcCode: "M03BX01"
}, {
  CIP7: '5786749',
  CIP13: '3400957867492',
  ucdLib: "BACLOFENE AGT 0,5MG/ML A.20ML",
  UCD7: '9366317',
  UCD13: '3400893663172',
  ucdQtyMultiplicator: 1,
  cipLib: "BACLOFENE AGT 0,5MG/ML A.20ML BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '5786732',
  CIP13: '3400957867324',
  ucdLib: "BACLOFENE AGT 2MG/ML AMP20ML",
  UCD7: '9382090',
  UCD13: '3400893820902',
  ucdQtyMultiplicator: 1,
  cipLib: "BACLOFENE AGT 2MG/ML AMP20ML BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '5786726',
  CIP13: '3400957867263',
  ucdLib: "BACLOFENE AGT 2MG/ML AMP5ML",
  UCD7: '9366323',
  UCD13: '3400893663233',
  ucdQtyMultiplicator: 10,
  cipLib: "BACLOFENE AGT 2MG/ML AMP5ML BT 10",
  atcCode: "M03BX01"
}, {
  CIP7: '5768059',
  CIP13: '3400957680596',
  ucdLib: "BACLOFENE SUN 0,05MG/ML AMP",
  UCD7: '9348578',
  UCD13: '3400893485781',
  ucdQtyMultiplicator: 1,
  cipLib: "BACLOFENE SUN 0,05MG/ML AMP BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '5768071',
  CIP13: '3400957680718',
  ucdLib: "BACLOFENE SUN 10MG/20ML AMP",
  UCD7: '9348584',
  UCD13: '3400893485842',
  ucdQtyMultiplicator: 1,
  cipLib: "BACLOFENE SUN 10MG/20ML AMP BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '5768094',
  CIP13: '3400957680947',
  ucdLib: "BACLOFENE SUN 10MG/5ML AMP",
  UCD7: '9348590',
  UCD13: '3400893485903',
  ucdQtyMultiplicator: 1,
  cipLib: "BACLOFENE SUN 10MG/5ML AMP BT 1",
  atcCode: "M03BX01"
}, {
  CIP7: '3063219',
  CIP13: '3400930632192',
  ucdLib: "LUMIRELAX 500MG CPR",
  UCD7: '9055356',
  UCD13: '3400890553568',
  ucdQtyMultiplicator: 20,
  cipLib: "LUMIRELAX 500MG CPR BT 20",
  atcCode: "M03BA03"
}, {
  CIP7: '5581059',
  CIP13: '3400955810599',
  ucdLib: "DYSPORT 500U INJ FL",
  UCD7: '9166966',
  UCD13: '3400891669664',
  ucdQtyMultiplicator: 1,
  cipLib: "DYSPORT 500U INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '3708320',
  CIP13: '3400937083201',
  ucdLib: "BOTOX 200U ALLERGAN INJ FL",
  UCD7: '9294486',
  UCD13: '3400892944869',
  ucdQtyMultiplicator: 1,
  cipLib: "BOTOX 200U ALLERGAN INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '3708314',
  CIP13: '3400937083140',
  ucdLib: "BOTOX 50U ALLERGAN INJ FL",
  UCD7: '9289746',
  UCD13: '3400892897462',
  ucdQtyMultiplicator: 1,
  cipLib: "BOTOX 50U ALLERGAN INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5620888',
  CIP13: '3400956208883',
  ucdLib: "BOTOX 100U ALLERGAN INJ FL",
  UCD7: '9222788',
  UCD13: '3400892227887',
  ucdQtyMultiplicator: 1,
  cipLib: "BOTOX 100U ALLERGAN INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5621250',
  CIP13: '3400956212507',
  ucdLib: "NEUROBLOC 5000U/ML INJ FL0,5ML",
  UCD7: '9230670',
  UCD13: '3400892306704',
  ucdQtyMultiplicator: 1,
  cipLib: "NEUROBLOC 5000U/ML INJ FL0,5ML BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5621267',
  CIP13: '3400956212675',
  ucdLib: "NEUROBLOC 5000U/ML INJ FL1ML",
  UCD7: '9230687',
  UCD13: '3400892306872',
  ucdQtyMultiplicator: 1,
  cipLib: "NEUROBLOC 5000U/ML INJ FL1ML BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5621273',
  CIP13: '3400956212736',
  ucdLib: "NEUROBLOC 5000U/ML INJ FL2ML",
  UCD7: '9230693',
  UCD13: '3400892306933',
  ucdQtyMultiplicator: 1,
  cipLib: "NEUROBLOC 5000U/ML INJ FL2ML BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '3646961',
  CIP13: '3400936469617',
  ucdLib: "VISTABEL 4U ALLERGAN INJ1,25ML",
  UCD7: '9266283',
  UCD13: '3400892662831',
  ucdQtyMultiplicator: 1,
  cipLib: "VISTABEL 4U ALLERGAN INJ1,25ML BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5502215',
  CIP13: '3400955022152',
  ucdLib: "XEOMIN 200U INJ FL",
  UCD7: '9419203',
  UCD13: '3400894192039',
  ucdQtyMultiplicator: 1,
  cipLib: "XEOMIN 200U INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '3934192',
  CIP13: '3400939341927',
  ucdLib: "AZZALURE 10U/0,05ML INJ FL",
  UCD7: '9418037',
  UCD13: '3400894180371',
  ucdQtyMultiplicator: 1,
  cipLib: "AZZALURE 10U/0,05ML INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '3934200',
  CIP13: '3400939342009',
  ucdLib: "AZZALURE 10U/0,05ML INJ FL",
  UCD7: '9418037',
  UCD13: '3400894180371',
  ucdQtyMultiplicator: 2,
  cipLib: "AZZALURE 10U/0,05ML INJ FL BT 2",
  atcCode: "M03AX01"
}, {
  CIP7: '4949304',
  CIP13: '3400949493043',
  ucdLib: "BOCOUTURE 50U INJ FL",
  UCD7: '9357494',
  UCD13: '3400893574942',
  ucdQtyMultiplicator: 1,
  cipLib: "BOCOUTURE 50U INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5718860',
  CIP13: '3400957188603',
  ucdLib: "XEOMIN 100U INJ FL",
  UCD7: '9310506',
  UCD13: '3400893105061',
  ucdQtyMultiplicator: 1,
  cipLib: "XEOMIN 100U INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5776490',
  CIP13: '3400957764906',
  ucdLib: "DYSPORT 300U INJ FL",
  UCD7: '9360208',
  UCD13: '3400893602089',
  ucdQtyMultiplicator: 1,
  cipLib: "DYSPORT 300U INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5808847',
  CIP13: '3400958088476',
  ucdLib: "XEOMIN 50U INJ FL",
  UCD7: '9377663',
  UCD13: '3400893776636',
  ucdQtyMultiplicator: 1,
  cipLib: "XEOMIN 50U INJ FL BT 1",
  atcCode: "M03AX01"
}, {
  CIP7: '5595363',
  CIP13: '3400955953630',
  ucdLib: "NIMBEX 2MG/ML INJ AMP10ML",
  UCD7: '9184786',
  UCD13: '3400891847864',
  ucdQtyMultiplicator: 5,
  cipLib: "NIMBEX 2MG/ML INJ AMP10ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5595340',
  CIP13: '3400955953401',
  ucdLib: "NIMBEX 2MG/ML INJ AMP2,5ML",
  UCD7: '9184792',
  UCD13: '3400891847925',
  ucdQtyMultiplicator: 5,
  cipLib: "NIMBEX 2MG/ML INJ AMP2,5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5595357',
  CIP13: '3400955953579',
  ucdLib: "NIMBEX 2MG/ML INJ AMP5ML",
  UCD7: '9184757',
  UCD13: '3400891847574',
  ucdQtyMultiplicator: 5,
  cipLib: "NIMBEX 2MG/ML INJ AMP5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5595392',
  CIP13: '3400955953920',
  ucdLib: "NIMBEX 5MG/ML INJ FL30ML",
  UCD7: '9184763',
  UCD13: '3400891847635',
  ucdQtyMultiplicator: 1,
  cipLib: "NIMBEX 5MG/ML INJ FL30ML BT 1",
  atcCode: "M03AC11"
}, {
  CIP7: '5501421',
  CIP13: '3400955014218',
  ucdLib: "CISATRACURIUM ACC2MG/ML 10ML",
  UCD7: '9415458',
  UCD13: '3400894154587',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM ACC2MG/ML 10ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5501417',
  CIP13: '3400955014171',
  ucdLib: "CISATRACURIUM ACC2MG/ML 2,5ML",
  UCD7: '9415464',
  UCD13: '3400894154648',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM ACC2MG/ML 2,5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5501419',
  CIP13: '3400955014195',
  ucdLib: "CISATRACURIUM ACC2MG/ML 5ML",
  UCD7: '9415470',
  UCD13: '3400894154709',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM ACC2MG/ML 5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5501425',
  CIP13: '3400955014256',
  ucdLib: "CISATRACURIUM ACC5MG/ML 30ML",
  UCD7: '9415487',
  UCD13: '3400894154877',
  ucdQtyMultiplicator: 1,
  cipLib: "CISATRACURIUM ACC5MG/ML 30ML BT 1",
  atcCode: "M03AC11"
}, {
  CIP7: '5813446',
  CIP13: '3400958134463',
  ucdLib: "CISATRACURIUM HPI2MG/ML 10ML",
  UCD7: '9380139',
  UCD13: '3400893801390',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM HPI2MG/ML 10ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5813392',
  CIP13: '3400958133923',
  ucdLib: "CISATRACURIUM HPI2MG/ML 2,5ML",
  UCD7: '9380116',
  UCD13: '3400893801161',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM HPI2MG/ML 2,5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5813417',
  CIP13: '3400958134173',
  ucdLib: "CISATRACURIUM HPI2MG/ML 5ML",
  UCD7: '9380122',
  UCD13: '3400893801222',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM HPI2MG/ML 5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5813452',
  CIP13: '3400958134524',
  ucdLib: "CISATRACURIUM HPI5MG/ML 30ML",
  UCD7: '9380145',
  UCD13: '3400893801451',
  ucdQtyMultiplicator: 1,
  cipLib: "CISATRACURIUM HPI5MG/ML 30ML BT 1",
  atcCode: "M03AC11"
}, {
  CIP7: '5806914',
  CIP13: '3400958069147',
  ucdLib: "CISATRACURIUM KBI2MG/ML 10ML",
  UCD7: '9377568',
  UCD13: '3400893775684',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM KBI2MG/ML 10ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5806825',
  CIP13: '3400958068256',
  ucdLib: "CISATRACURIUM KBI2MG/ML 2,5ML",
  UCD7: '9377574',
  UCD13: '3400893775745',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM KBI2MG/ML 2,5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5806877',
  CIP13: '3400958068775',
  ucdLib: "CISATRACURIUM KBI2MG/ML 5ML",
  UCD7: '9377580',
  UCD13: '3400893775806',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM KBI2MG/ML 5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5848060',
  CIP13: '3400958480607',
  ucdLib: "CISATRACURIUM KBI5MG/ML 30ML",
  UCD7: '9394874',
  UCD13: '3400893948743',
  ucdQtyMultiplicator: 1,
  cipLib: "CISATRACURIUM KBI5MG/ML 30ML BT 1",
  atcCode: "M03AC11"
}, {
  CIP7: '5854675',
  CIP13: '3400958546754',
  ucdLib: "CISATRACURIUM MYL2MG/ML 10ML",
  UCD7: '9395069',
  UCD13: '3400893950692',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM MYL2MG/ML 10ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5854623',
  CIP13: '3400958546235',
  ucdLib: "CISATRACURIUM MYL2MG/ML 2,5ML",
  UCD7: '9395075',
  UCD13: '3400893950753',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM MYL2MG/ML 2,5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5854652',
  CIP13: '3400958546525',
  ucdLib: "CISATRACURIUM MYL2MG/ML 5ML",
  UCD7: '9395081',
  UCD13: '3400893950814',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM MYL2MG/ML 5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5854681',
  CIP13: '3400958546815',
  ucdLib: "CISATRACURIUM MYL5MG/ML 30ML",
  UCD7: '9395098',
  UCD13: '3400893950982',
  ucdQtyMultiplicator: 1,
  cipLib: "CISATRACURIUM MYL5MG/ML 30ML BT 1",
  atcCode: "M03AC11"
}, {
  CIP7: '5806972',
  CIP13: '3400958069727',
  ucdLib: "CISATRACURIUM SDZ2MG/ML 10ML",
  UCD7: '9377261',
  UCD13: '3400893772614',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM SDZ2MG/ML 10ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5807061',
  CIP13: '3400958070617',
  ucdLib: "CISATRACURIUM SDZ2MG/ML A5ML",
  UCD7: '9377284',
  UCD13: '3400893772843',
  ucdQtyMultiplicator: 5,
  cipLib: "CISATRACURIUM SDZ2MG/ML A5ML BT 5",
  atcCode: "M03AC11"
}, {
  CIP7: '5772351',
  CIP13: '3400957723514',
  ucdLib: "MIVACRON 20MG INJ AMP10ML",
  UCD7: '9167233',
  UCD13: '3400891672336',
  ucdQtyMultiplicator: 5,
  cipLib: "MIVACRON 20MG INJ AMP10ML BT 5",
  atcCode: "M03AC10"
}, {
  CIP7: '5651162',
  CIP13: '3400956511624',
  ucdLib: "MIVACRON 10MG INJ AMP5ML",
  UCD7: '9167227',
  UCD13: '3400891672275',
  ucdQtyMultiplicator: 5,
  cipLib: "MIVACRON 10MG INJ AMP5ML BT 5",
  atcCode: "M03AC10"
}, {
  CIP7: '5500417',
  CIP13: '3400955004172',
  ucdLib: "ROCURONIUM HPI10MG/ML FL5ML",
  UCD7: '9409506',
  UCD13: '3400894095064',
  ucdQtyMultiplicator: 10,
  cipLib: "ROCURONIUM HPI10MG/ML FL5ML BT 10",
  atcCode: "M03AC09"
}, {
  CIP7: '5715212',
  CIP13: '3400957152123',
  ucdLib: "ESMERON 10MG/ML INJ FL5ML",
  UCD7: '9195092',
  UCD13: '3400891950922',
  ucdQtyMultiplicator: 10,
  cipLib: "ESMERON 10MG/ML INJ FL5ML BT 10",
  atcCode: "M03AC09"
}, {
  CIP7: '5795760',
  CIP13: '3400957957605',
  ucdLib: "ROCURONIUM BBM10MG/ML FL5ML",
  UCD7: '9406962',
  UCD13: '3400894069621',
  ucdQtyMultiplicator: 10,
  cipLib: "ROCURONIUM BBM10MG/ML FL5ML BT 10",
  atcCode: "M03AC09"
}, {
  CIP7: '5584336',
  CIP13: '3400955843368',
  ucdLib: "TRACRIUM 250MG/25ML INJ AMP",
  UCD7: '9167256',
  UCD13: '3400891672565',
  ucdQtyMultiplicator: 1,
  cipLib: "TRACRIUM 250MG/25ML INJ AMP BT 1",
  atcCode: "M03AC04"
}, {
  CIP7: '5713874',
  CIP13: '3400957138745',
  ucdLib: "ATRACURIUM HPI 10MG/ML 2,5ML",
  UCD7: '9304351',
  UCD13: '3400893043516',
  ucdQtyMultiplicator: 5,
  cipLib: "ATRACURIUM HPI 10MG/ML 2,5ML BT 5",
  atcCode: "M03AC04"
}, {
  CIP7: '5713880',
  CIP13: '3400957138806',
  ucdLib: "ATRACURIUM HPI 10MG/ML A.5ML",
  UCD7: '9304368',
  UCD13: '3400893043684',
  ucdQtyMultiplicator: 5,
  cipLib: "ATRACURIUM HPI 10MG/ML A.5ML BT 5",
  atcCode: "M03AC04"
}, {
  CIP7: '5713897',
  CIP13: '3400957138974',
  ucdLib: "ATRACURIUM HPI 10MG/ML FL25ML",
  UCD7: '9304374',
  UCD13: '3400893043745',
  ucdQtyMultiplicator: 1,
  cipLib: "ATRACURIUM HPI 10MG/ML FL25ML BT 1",
  atcCode: "M03AC04"
}, {
  CIP7: '5651179',
  CIP13: '3400956511792',
  ucdLib: "TRACRIUM 25MG/2,5ML INJ AMP",
  UCD7: '9121478',
  UCD13: '3400891214789',
  ucdQtyMultiplicator: 5,
  cipLib: "TRACRIUM 25MG/2,5ML INJ AMP BT 5",
  atcCode: "M03AC04"
}, {
  CIP7: '5651185',
  CIP13: '3400956511853',
  ucdLib: "TRACRIUM 50MG/5ML INJ AMP",
  UCD7: '9122609',
  UCD13: '3400891226096',
  ucdQtyMultiplicator: 5,
  cipLib: "TRACRIUM 50MG/5ML INJ AMP BT 5",
  atcCode: "M03AC04"
}, {
  CIP7: '5572706',
  CIP13: '3400955727064',
  ucdLib: "NORCURON 10MG INJ FL",
  UCD7: '9153343',
  UCD13: '3400891533439',
  ucdQtyMultiplicator: 10,
  cipLib: "NORCURON 10MG INJ FL BT 10",
  atcCode: "M03AC03"
}, {
  CIP7: '5630444',
  CIP13: '3400956304448',
  ucdLib: "CELOCURINE 50MG/ML INJ A.2ML",
  UCD7: '9230871',
  UCD13: '3400892308715',
  ucdQtyMultiplicator: 10,
  cipLib: "CELOCURINE 50MG/ML INJ A.2ML BT 10",
  atcCode: "M03AB01"
}, {
  CIP7: '5768450',
  CIP13: '3400957684501',
  ucdLib: "SUXAMETHONIUM AGT 50MG/ML A.",
  UCD7: '9349916',
  UCD13: '3400893499160',
  ucdQtyMultiplicator: 10,
  cipLib: "SUXAMETHONIUM AGT 50MG/ML A. BT 10",
  atcCode: "M03AB01"
}, {
  CIP7: '5769455',
  CIP13: '3400957694555',
  ucdLib: "SUXAMETHONIUM BDX 50MG/ML A.",
  UCD7: '9353094',
  UCD13: '3400893530948',
  ucdQtyMultiplicator: 10,
  cipLib: "SUXAMETHONIUM BDX 50MG/ML A. BT 10",
  atcCode: "M03AB01"
}, {
  CIP7: '3066910',
  CIP13: '3400930669105',
  ucdLib: "DEFILTRAN 10% CR TB100G",
  UCD7: '9109431',
  UCD13: '3400891094312',
  ucdQtyMultiplicator: 1,
  cipLib: "DEFILTRAN 10% CR TB100G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3002077',
  CIP13: '3400930020777',
  ucdLib: "ARNIGEL GEL TB120G",
  UCD7: '9413100',
  UCD13: '3400894131007',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNIGEL GEL TB120G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3102882',
  CIP13: '3400931028826',
  ucdLib: "SYNTHOL LOC SOL FP225ML",
  UCD7: '9090045',
  UCD13: '3400890900454',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNTHOL LOC SOL FP225ML BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3102959',
  CIP13: '3400931029595',
  ucdLib: "SYNTHOL LOC SOL FP450ML",
  UCD7: '9115644',
  UCD13: '3400891156447',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNTHOL LOC SOL FP450ML BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3076417',
  CIP13: '3400930764176',
  ucdLib: "OSMOGEL LOC GEL TB90G",
  UCD7: '9065975',
  UCD13: '3400890659758',
  ucdQtyMultiplicator: 1,
  cipLib: "OSMOGEL LOC GEL TB90G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3565027',
  CIP13: '3400935650276',
  ucdLib: "ARNIGEL GEL TB45G",
  UCD7: '9237442',
  UCD13: '3400892374420',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNIGEL GEL TB45G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3416008',
  CIP13: '3400934160080',
  ucdLib: "ALGESAL SURACTIVE CR TB100G",
  UCD7: '9400379',
  UCD13: '3400894003793',
  ucdQtyMultiplicator: 1,
  cipLib: "ALGESAL SURACTIVE CR TB100G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3415977',
  CIP13: '3400934159770',
  ucdLib: "ALGESAL SURACTIVE CR TB40G",
  UCD7: '9187431',
  UCD13: '3400891874310',
  ucdQtyMultiplicator: 1,
  cipLib: "ALGESAL SURACTIVE CR TB40G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3416391',
  CIP13: '3400934163913',
  ucdLib: "ARNICAN 4% CR TB50G",
  UCD7: '9190835',
  UCD13: '3400891908350',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNICAN 4% CR TB50G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3416161',
  CIP13: '3400934161612',
  ucdLib: "LUMIRELAX 10% CR TB80G",
  UCD7: '9199925',
  UCD13: '3400891999259',
  ucdQtyMultiplicator: 1,
  cipLib: "LUMIRELAX 10% CR TB80G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3186531',
  CIP13: '3400931865315',
  ucdLib: "ARNICA TEINTURE GIL CPRESS",
  UCD7: '9070887',
  UCD13: '3400890708876',
  ucdQtyMultiplicator: 12,
  cipLib: "ARNICA TEINTURE GIL CPRESS BT 12",
  atcCode: "M02AX10"
}, {
  CIP7: '3762207',
  CIP13: '3400937622073',
  ucdLib: "ARNICA ST BERNARD GEL TB50G",
  UCD7: '9303825',
  UCD13: '3400893038253',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNICA ST BERNARD GEL TB50G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3775405',
  CIP13: '3400937754057',
  ucdLib: "ARNICAGEL GEL TB25G",
  UCD7: '9297065',
  UCD13: '3400892970653',
  ucdQtyMultiplicator: 1,
  cipLib: "ARNICAGEL GEL TB25G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3164245',
  CIP13: '3400931642459',
  ucdLib: "DECONTRACTYL BAUM TB80G",
  UCD7: '9024278',
  UCD13: '3400890242783',
  ucdQtyMultiplicator: 1,
  cipLib: "DECONTRACTYL BAUM TB80G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3802214',
  CIP13: '3400938022148',
  ucdLib: "SYNTHOL GEL TB75G",
  UCD7: '9303920',
  UCD13: '3400893039205',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNTHOL GEL TB75G BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3735972',
  CIP13: '3400937359726',
  ucdLib: "SYNTHOL LOC SOL FL PULV 75ML",
  UCD7: '9286268',
  UCD13: '3400892862682',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNTHOL LOC SOL FL PULV 75ML BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3735966',
  CIP13: '3400937359665',
  ucdLib: "SYNTHOL LOC SOL FP75ML",
  UCD7: '9286251',
  UCD13: '3400892862514',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNTHOL LOC SOL FP75ML BT 1",
  atcCode: "M02AX10"
}, {
  CIP7: '3186620',
  CIP13: '3400931866206',
  ucdLib: "SRILANE 5% CR TB60G",
  UCD7: '9087333',
  UCD13: '3400890873338',
  ucdQtyMultiplicator: 1,
  cipLib: "SRILANE 5% CR TB60G BT 1",
  atcCode: "M02AX05"
}, {
  CIP7: '3081720',
  CIP13: '3400930817209',
  ucdLib: "PERCUTALGINE EXT AMP2ML",
  UCD7: '9070137',
  UCD13: '3400890701372',
  ucdQtyMultiplicator: 10,
  cipLib: "PERCUTALGINE EXT AMP2ML BT 10",
  atcCode: "M02AC"
}, {
  CIP7: '3006517',
  CIP13: '3400930065174',
  ucdLib: "AROMA BAUME CR TB50G",
  UCD7: '9006518',
  UCD13: '3400890065184',
  ucdQtyMultiplicator: 1,
  cipLib: "AROMA BAUME CR TB50G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3117783',
  CIP13: '3400931177838',
  ucdLib: "PERCUTALGINE GEL TB30G",
  UCD7: '9070143',
  UCD13: '3400890701433',
  ucdQtyMultiplicator: 1,
  cipLib: "PERCUTALGINE GEL TB30G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3221397',
  CIP13: '3400932213979',
  ucdLib: "CORTISAL CR TB30G",
  UCD7: '9022440',
  UCD13: '3400890224406',
  ucdQtyMultiplicator: 1,
  cipLib: "CORTISAL CR TB30G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3415931',
  CIP13: '3400934159312',
  ucdLib: "ALGESAL CR TB40G",
  UCD7: '9186176',
  UCD13: '3400891861761',
  ucdQtyMultiplicator: 1,
  cipLib: "ALGESAL CR TB40G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3415894',
  CIP13: '3400934158940',
  ucdLib: "INONGAN CR TB55G",
  UCD7: '9186360',
  UCD13: '3400891863604',
  ucdQtyMultiplicator: 1,
  cipLib: "INONGAN CR TB55G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3415813',
  CIP13: '3400934158131',
  ucdLib: "LUMBALGINE CR TB90G",
  UCD7: '9196660',
  UCD13: '3400891966602',
  ucdQtyMultiplicator: 1,
  cipLib: "LUMBALGINE CR TB90G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3415517',
  CIP13: '3400934155178',
  ucdLib: "SAINT-BERNARD BAUME CR TB100G",
  UCD7: '9200663',
  UCD13: '3400892006635',
  ucdQtyMultiplicator: 1,
  cipLib: "SAINT-BERNARD BAUME CR TB100G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3415500',
  CIP13: '3400934155000',
  ucdLib: "SAINT-BERNARD BAUME CR TB42G",
  UCD7: '9200686',
  UCD13: '3400892006864',
  ucdQtyMultiplicator: 1,
  cipLib: "SAINT-BERNARD BAUME CR TB42G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3588867',
  CIP13: '3400935888679',
  ucdLib: "PERCUTALGINE GEL TB60G",
  UCD7: '9259969',
  UCD13: '3400892599694',
  ucdQtyMultiplicator: 1,
  cipLib: "PERCUTALGINE GEL TB60G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3841438',
  CIP13: '3400938414387',
  ucdLib: "AROMA BAUME CR TB100G",
  UCD7: '9324336',
  UCD13: '3400893243367',
  ucdQtyMultiplicator: 1,
  cipLib: "AROMA BAUME CR TB100G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3916254',
  CIP13: '3400939162546',
  ucdLib: "REPARIL GEL TB40G",
  UCD7: '9332005',
  UCD13: '3400893320051',
  ucdQtyMultiplicator: 1,
  cipLib: "REPARIL GEL TB40G BT 1",
  atcCode: "M02AC"
}, {
  CIP7: '3318665',
  CIP13: '3400933186654',
  ucdLib: "NIFLUGEL 2,5% GEL PERCUT TB60G",
  UCD7: '9138496',
  UCD13: '3400891384963',
  ucdQtyMultiplicator: 1,
  cipLib: "NIFLUGEL 2,5% GEL PERCUT TB60G BT 1",
  atcCode: "M02AA17"
}, {
  CIP7: '3833746',
  CIP13: '3400938337464',
  ucdLib: "DICLOFENAC MYL 1% GEL TB50G",
  UCD7: '9311747',
  UCD13: '3400893117477',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC MYL 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3833752',
  CIP13: '3400938337525',
  ucdLib: "DICLOFENAC MYP 1% GEL TB100G",
  UCD7: '9311730',
  UCD13: '3400893117309',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC MYP 1% GEL TB100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3288697',
  CIP13: '3400932886975',
  ucdLib: "VOLTARENE EMULGEL 1% TAV50G",
  UCD7: '9125200',
  UCD13: '3400891252002',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLTARENE EMULGEL 1% TAV50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2762062',
  CIP13: '3400927620621',
  ucdLib: "ANTALCALM 140MG EMPL MEDIC",
  UCD7: '9408524',
  UCD13: '3400894085249',
  ucdQtyMultiplicator: 5,
  cipLib: "ANTALCALM 140MG EMPL MEDIC BT 5",
  atcCode: "M02AA15"
}, {
  CIP7: '2769609',
  CIP13: '3400927696091',
  ucdLib: "DICLOFENAC CRT 1% GEL TB100G",
  UCD7: '9417397',
  UCD13: '3400894173977',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC CRT 1% GEL TB100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '4913401',
  CIP13: '3400949134014',
  ucdLib: "DICLOFENAC EG 1% GEL FL100ML",
  UCD7: '9356922',
  UCD13: '3400893569221',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC EG 1% GEL FL100ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '4913393',
  CIP13: '3400949133932',
  ucdLib: "DICLOFENAC TVC 1% GEL FL100ML",
  UCD7: '9356945',
  UCD13: '3400893569450',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC TVC 1% GEL FL100ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '4913387',
  CIP13: '3400949133871',
  ucdLib: "DICLOFENAC UGO 1% GEL FL100ML",
  UCD7: '9356891',
  UCD13: '3400893568910',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC UGO 1% GEL FL100ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3338461',
  CIP13: '3400933384616',
  ucdLib: "FLECTOR 1% GEL TB60G",
  UCD7: '9156063',
  UCD13: '3400891560633',
  ucdQtyMultiplicator: 1,
  cipLib: "FLECTOR 1% GEL TB60G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3529215',
  CIP13: '3400935292155',
  ucdLib: "DICLOFENAC RTC 1% EMPL",
  UCD7: '9360881',
  UCD13: '3400893608814',
  ucdQtyMultiplicator: 5,
  cipLib: "DICLOFENAC RTC 1% EMPL BT 5",
  atcCode: "M02AA15"
}, {
  CIP7: '3593147',
  CIP13: '3400935931474',
  ucdLib: "VOLTARENACTIGO 1% GEL FL50ML",
  UCD7: '9343196',
  UCD13: '3400893431962',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLTARENACTIGO 1% GEL FL50ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3469186',
  CIP13: '3400934691867',
  ucdLib: "DICLOFENAC RMO 1% GEL TB50G",
  UCD7: '9357436',
  UCD13: '3400893574362',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC RMO 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3172664',
  CIP13: '3400931726647',
  ucdLib: "TENDOL 1% GEL TB50G",
  UCD7: '9357442',
  UCD13: '3400893574423',
  ucdQtyMultiplicator: 1,
  cipLib: "TENDOL 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3589513',
  CIP13: '3400935895134',
  ucdLib: "VOLTARENE EMULGEL 1% FL100ML",
  UCD7: '9249623',
  UCD13: '3400892496238',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLTARENE EMULGEL 1% FL100ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3635408',
  CIP13: '3400936354081',
  ucdLib: "VOLTARENACTIGO 1% GEL TAV60G",
  UCD7: '9277625',
  UCD13: '3400892776255',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLTARENACTIGO 1% GEL TAV60G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3723012',
  CIP13: '3400937230124',
  ucdLib: "VOLTARENSPE 1% GEL TLA100G",
  UCD7: '9399972',
  UCD13: '3400893999721',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLTARENSPE 1% GEL TLA100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3826835',
  CIP13: '3400938268355',
  ucdLib: "DICLOFENAC BGA 1% GEL TB100G",
  UCD7: '9310400',
  UCD13: '3400893104002',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC BGA 1% GEL TB100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3826901',
  CIP13: '3400938269017',
  ucdLib: "DICLOFENAC EG 1% GEL TB100G",
  UCD7: '9309590',
  UCD13: '3400893095904',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC EG 1% GEL TB100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3826918',
  CIP13: '3400938269185',
  ucdLib: "DICLOFENAC EGL 1% GEL TB50G",
  UCD7: '9309584',
  UCD13: '3400893095843',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC EGL 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3470657',
  CIP13: '3400934706578',
  ucdLib: "DICLOFENAC SDC 1% GEL TB50G",
  UCD7: '9356916',
  UCD13: '3400893569160',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC SDC 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3778421',
  CIP13: '3400937784214',
  ucdLib: "FLECTOR 1% GEL FL100G",
  UCD7: '9304003',
  UCD13: '3400893040034',
  ucdQtyMultiplicator: 1,
  cipLib: "FLECTOR 1% GEL FL100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3782233',
  CIP13: '3400937822336',
  ucdLib: "FLECTORTISSUGELEP 1% EMPL",
  UCD7: '9308478',
  UCD13: '3400893084786',
  ucdQtyMultiplicator: 5,
  cipLib: "FLECTORTISSUGELEP 1% EMPL BT 5",
  atcCode: "M02AA15"
}, {
  CIP7: '3782256',
  CIP13: '3400937822565',
  ucdLib: "FLECTORTISSUGELEP 1% EMPL",
  UCD7: '9308478',
  UCD13: '3400893084786',
  ucdQtyMultiplicator: 10,
  cipLib: "FLECTORTISSUGELEP 1% EMPL BT 10",
  atcCode: "M02AA15"
}, {
  CIP7: '3440596',
  CIP13: '3400934405969',
  ucdLib: "DICLOFENAC ARW 1% GEL TB50G",
  UCD7: '9347633',
  UCD13: '3400893476338',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC ARW 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3806910',
  CIP13: '3400938069105',
  ucdLib: "DICLOFENAC BGR 1% GEL TB50G",
  UCD7: '9310392',
  UCD13: '3400893103920',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC BGR 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3882549',
  CIP13: '3400938825497',
  ucdLib: "DICLOFENAC RTC 1% GEL TB50G",
  UCD7: '9325040',
  UCD13: '3400893250402',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC RTC 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3882472',
  CIP13: '3400938824728',
  ucdLib: "DICLOFENAC TVC 1% GEL TB50G",
  UCD7: '9321823',
  UCD13: '3400893218235',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC TVC 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3882555',
  CIP13: '3400938825558',
  ucdLib: "DICLOFENAC TVC.1% GEL TB100G",
  UCD7: '9321817',
  UCD13: '3400893218174',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC TVC.1% GEL TB100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3440834',
  CIP13: '3400934408342',
  ucdLib: "DISPADOL 1% GEL TB50G",
  UCD7: '9356951',
  UCD13: '3400893569511',
  ucdQtyMultiplicator: 1,
  cipLib: "DISPADOL 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3898119',
  CIP13: '3400938981193',
  ucdLib: "DICLOFENAC REF 1% GEL FL100ML",
  UCD7: '9327033',
  UCD13: '3400893270332',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC REF 1% GEL FL100ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3898792',
  CIP13: '3400938987928',
  ucdLib: "DICLOFENAC TCO 1% GEL TB50G",
  UCD7: '9327062',
  UCD13: '3400893270622',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC TCO 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3898036',
  CIP13: '3400938980363',
  ucdLib: "DICLOFENAC ZEN 1% GEL TB50G",
  UCD7: '9327056',
  UCD13: '3400893270561',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC ZEN 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2742125',
  CIP13: '3400927421259',
  ucdLib: "DICLOFENAC CRT 1% GEL TB50G",
  UCD7: '9417405',
  UCD13: '3400894174059',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC CRT 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2741893',
  CIP13: '3400927418938',
  ucdLib: "DICLOFENAC MYL 1% GEL FL100ML",
  UCD7: '9402800',
  UCD13: '3400894028000',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC MYL 1% GEL FL100ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3988532',
  CIP13: '3400939885322',
  ucdLib: "DICLOFENAC NEP 1% GEL TB50G",
  UCD7: '9346409',
  UCD13: '3400893464090',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC NEP 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2698341',
  CIP13: '3400926983413',
  ucdLib: "DICLOFENAC SDZ 1% GEL TB100G",
  UCD7: '9392450',
  UCD13: '3400893924501',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC SDZ 1% GEL TB100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2698329',
  CIP13: '3400926983291',
  ucdLib: "DICLOFENAC SDZ 1% GEL TB50G",
  UCD7: '9392036',
  UCD13: '3400893920367',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC SDZ 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2697181',
  CIP13: '3400926971816',
  ucdLib: "DICLOFENAC UGO 1% GEL TB50G",
  UCD7: '9399966',
  UCD13: '3400893999660',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC UGO 1% GEL TB50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3988526',
  CIP13: '3400939885261',
  ucdLib: "DICLOFENAC ZEN 1% GEL FL100ML",
  UCD7: '9346390',
  UCD13: '3400893463901',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC ZEN 1% GEL FL100ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2759321',
  CIP13: '3400927593215',
  ucdLib: "DICLOFENAC ZEN 1% GEL TB100G",
  UCD7: '9397944',
  UCD13: '3400893979440',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC ZEN 1% GEL TB100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '4939889',
  CIP13: '3400949398898',
  ucdLib: "FLECTOR TISSUGEL HEPARIN.EMPL",
  UCD7: '9363980',
  UCD13: '3400893639801',
  ucdQtyMultiplicator: 3,
  cipLib: "FLECTOR TISSUGEL HEPARIN.EMPL BT 3",
  atcCode: "M02AA15"
}, {
  CIP7: '2740758',
  CIP13: '3400927407581',
  ucdLib: "VOLTARENACTIGO 2% GEL TLA30G",
  UCD7: '9393314',
  UCD13: '3400893933145',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLTARENACTIGO 2% GEL TLA30G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3942234',
  CIP13: '3400939422343',
  ucdLib: "VOLTARENPLAST 1% EMPL SACH",
  UCD7: '9352108',
  UCD13: '3400893521083',
  ucdQtyMultiplicator: 5,
  cipLib: "VOLTARENPLAST 1% EMPL SACH BT 5",
  atcCode: "M02AA15"
}, {
  CIP7: '2800779',
  CIP13: '3400928007797',
  ucdLib: "VOLTARENACTIGO 1% GEL TLA100G",
  UCD7: '9420927',
  UCD13: '3400894209270',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLTARENACTIGO 1% GEL TLA100G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2682788',
  CIP13: '3400926827885',
  ucdLib: "DICLOFENAC SDZ 1% GEL FL100ML",
  UCD7: '9390333',
  UCD13: '3400893903339',
  ucdQtyMultiplicator: 1,
  cipLib: "DICLOFENAC SDZ 1% GEL FL100ML BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2772155',
  CIP13: '3400927721557',
  ucdLib: "FLECTOREFFIGEL 1% GEL FL50G",
  UCD7: '9402148',
  UCD13: '3400894021483',
  ucdQtyMultiplicator: 1,
  cipLib: "FLECTOREFFIGEL 1% GEL FL50G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '2772132',
  CIP13: '3400927721328',
  ucdLib: "FLECTOREFFIGEL 1% GEL TB60G",
  UCD7: '9402119',
  UCD13: '3400894021193',
  ucdQtyMultiplicator: 1,
  cipLib: "FLECTOREFFIGEL 1% GEL TB60G BT 1",
  atcCode: "M02AA15"
}, {
  CIP7: '3572955',
  CIP13: '3400935729552',
  ucdLib: "NUROFEN 5% GEL TB50G",
  UCD7: '9243951',
  UCD13: '3400892439518',
  ucdQtyMultiplicator: 1,
  cipLib: "NUROFEN 5% GEL TB50G BT 1",
  atcCode: "M02AA13"
}, {
  CIP7: '3609440',
  CIP13: '3400936094406',
  ucdLib: "ADVILMED 5% GEL TB100G",
  UCD7: '9249712',
  UCD13: '3400892497129',
  ucdQtyMultiplicator: 1,
  cipLib: "ADVILMED 5% GEL TB100G BT 1",
  atcCode: "M02AA13"
}, {
  CIP7: '3436666',
  CIP13: '3400934366666',
  ucdLib: "IBUPROFENE URGO 5% GEL TB60G",
  UCD7: '9201421',
  UCD13: '3400892014210',
  ucdQtyMultiplicator: 1,
  cipLib: "IBUPROFENE URGO 5% GEL TB60G BT 1",
  atcCode: "M02AA13"
}, {
  CIP7: '3556270',
  CIP13: '3400935562708',
  ucdLib: "ANTARENE 5% GEL TB50G",
  UCD7: '9228986',
  UCD13: '3400892289861',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTARENE 5% GEL TB50G BT 1",
  atcCode: "M02AA13"
}, {
  CIP7: '3552898',
  CIP13: '3400935528988',
  ucdLib: "IBUFETUM 5% GEL TB60G",
  UCD7: '9383244',
  UCD13: '3400893832448',
  ucdQtyMultiplicator: 1,
  cipLib: "IBUFETUM 5% GEL TB60G BT 1",
  atcCode: "M02AA13"
}, {
  CIP7: '3484524',
  CIP13: '3400934845246',
  ucdLib: "CLIPTOL GEL TB50G",
  UCD7: '9210590',
  UCD13: '3400892105901',
  ucdQtyMultiplicator: 1,
  cipLib: "CLIPTOL GEL TB50G BT 1",
  atcCode: "M02AA13"
}, {
  CIP7: '3762265',
  CIP13: '3400937622653',
  ucdLib: "IBUPROFENE ARW 5% GEL TB60G",
  UCD7: '9307622',
  UCD13: '3400893076224',
  ucdQtyMultiplicator: 1,
  cipLib: "IBUPROFENE ARW 5% GEL TB60G BT 1",
  atcCode: "M02AA13"
}, {
  CIP7: '3643804',
  CIP13: '3400936438040',
  ucdLib: "ANTARENE 5% GEL TB100G",
  UCD7: '9262724',
  UCD13: '3400892627243',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTARENE 5% GEL TB100G BT 1",
  atcCode: "M02AA13"
}, {
  CIP7: '3616724',
  CIP13: '3400936167247',
  ucdLib: "KETOPROFENE EG 2,5% GEL TA60G",
  UCD7: '9248279',
  UCD13: '3400892482798',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOPROFENE EG 2,5% GEL TA60G BT 1",
  atcCode: "M02AA10"
}, {
  CIP7: '3335497',
  CIP13: '3400933354978',
  ucdLib: "KETUM 2,5% GEL LOC TB60G",
  UCD7: '9157625',
  UCD13: '3400891576252',
  ucdQtyMultiplicator: 1,
  cipLib: "KETUM 2,5% GEL LOC TB60G BT 1",
  atcCode: "M02AA10"
}, {
  CIP7: '3676413',
  CIP13: '3400936764132',
  ucdLib: "KETOPROFENE SDZ 2,5% GEL D120G",
  UCD7: '9271002',
  UCD13: '3400892710020',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOPROFENE SDZ 2,5% GEL D120G BT 1",
  atcCode: "M02AA10"
}, {
  CIP7: '3530201',
  CIP13: '3400935302014',
  ucdLib: "KETOPROFENE BGA 2,5% GEL TB60G",
  UCD7: '9218120',
  UCD13: '3400892181202',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOPROFENE BGA 2,5% GEL TB60G BT 1",
  atcCode: "M02AA10"
}, {
  CIP7: '3799297',
  CIP13: '3400937992978',
  ucdLib: "KETOPROFENE BGR 2,5% GEL D120G",
  UCD7: '9310446',
  UCD13: '3400893104460',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOPROFENE BGR 2,5% GEL D120G BT 1",
  atcCode: "M02AA10"
}, {
  CIP7: '3869000',
  CIP13: '3400938690002',
  ucdLib: "KETOPROFENE TVS 2,5% GEL TB60G",
  UCD7: '9330259',
  UCD13: '3400893302590',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOPROFENE TVS 2,5% GEL TB60G BT 1",
  atcCode: "M02AA10"
}, {
  CIP7: '3444476',
  CIP13: '3400934444760',
  ucdLib: "KETUM 2,5% GEL LOC TB DISP120G",
  UCD7: '9200746',
  UCD13: '3400892007465',
  ucdQtyMultiplicator: 1,
  cipLib: "KETUM 2,5% GEL LOC TB DISP120G BT 1",
  atcCode: "M02AA10"
}, {
  CIP7: '3316703',
  CIP13: '3400933167035',
  ucdLib: "GELDENE 0,5% GEL LOC TB50G",
  UCD7: '9140926',
  UCD13: '3400891409260',
  ucdQtyMultiplicator: 1,
  cipLib: "GELDENE 0,5% GEL LOC TB50G BT 1",
  atcCode: "M02AA07"
}, {
  CIP7: '3293907',
  CIP13: '3400932939077',
  ucdLib: "ACADIONE 250MG CPR",
  UCD7: '9131175',
  UCD13: '3400891311754',
  ucdQtyMultiplicator: 120,
  cipLib: "ACADIONE 250MG CPR BT 120",
  atcCode: "M01CX"
}, {
  CIP7: '3203169',
  CIP13: '3400932031696',
  ucdLib: "TROLOVOL 300MG CPR",
  UCD7: '9095321',
  UCD13: '3400890953214',
  ucdQtyMultiplicator: 30,
  cipLib: "TROLOVOL 300MG CPR BT 30",
  atcCode: "M01CC01"
}, {
  CIP7: '3214954',
  CIP13: '3400932149544',
  ucdLib: "PIASCLEDINE 300MG GELU",
  UCD7: '9071757',
  UCD13: '3400890717571',
  ucdQtyMultiplicator: 15,
  cipLib: "PIASCLEDINE 300MG GELU BT 15",
  atcCode: "M01AX26"
}, {
  CIP7: '3594135',
  CIP13: '3400935941350',
  ucdLib: "PIASCLEDINE 300MG GELU",
  UCD7: '9071757',
  UCD13: '3400890717571',
  ucdQtyMultiplicator: 30,
  cipLib: "PIASCLEDINE 300MG GELU BT 30",
  atcCode: "M01AX26"
}, {
  CIP7: '3359173',
  CIP13: '3400933591731',
  ucdLib: "CHONDROSULF 400MG GELU",
  UCD7: '9162247',
  UCD13: '3400891622478',
  ucdQtyMultiplicator: 84,
  cipLib: "CHONDROSULF 400MG GELU BT 84",
  atcCode: "M01AX25"
}, {
  CIP7: '3359150',
  CIP13: '3400933591502',
  ucdLib: "CHONDROSULF 400MG GLE SACH",
  UCD7: '9163927',
  UCD13: '3400891639278',
  ucdQtyMultiplicator: 84,
  cipLib: "CHONDROSULF 400MG GLE SACH BT 84",
  atcCode: "M01AX25"
}, {
  CIP7: '3546432',
  CIP13: '3400935464323',
  ucdLib: "STRUCTUM 500MG GELU",
  UCD7: '9232019',
  UCD13: '3400892320199',
  ucdQtyMultiplicator: 60,
  cipLib: "STRUCTUM 500MG GELU BT 60",
  atcCode: "M01AX25"
}, {
  CIP7: '3132133',
  CIP13: '3400931321330',
  ucdLib: "NIFLURIL 700MG SUP AD",
  UCD7: '9063031',
  UCD13: '3400890630313',
  ucdQtyMultiplicator: 8,
  cipLib: "NIFLURIL 700MG SUP AD BT 8",
  atcCode: "M01AX22"
}, {
  CIP7: '3188636',
  CIP13: '3400931886365',
  ucdLib: "NIFLURIL 400MG SUP ENF",
  UCD7: '9063025',
  UCD13: '3400890630252',
  ucdQtyMultiplicator: 8,
  cipLib: "NIFLURIL 400MG SUP ENF BT 8",
  atcCode: "M01AX22"
}, {
  CIP7: '3355293',
  CIP13: '3400933552930',
  ucdLib: "ART 50MG GELU",
  UCD7: '9167552',
  UCD13: '3400891675528',
  ucdQtyMultiplicator: 30,
  cipLib: "ART 50MG GELU BT 30",
  atcCode: "M01AX21"
}, {
  CIP7: '3355301',
  CIP13: '3400933553012',
  ucdLib: "ZONDAR 50MG GELU",
  UCD7: '9167948',
  UCD13: '3400891679489',
  ucdQtyMultiplicator: 30,
  cipLib: "ZONDAR 50MG GELU BT 30",
  atcCode: "M01AX21"
}, {
  CIP7: '3865999',
  CIP13: '3400938659993',
  ucdLib: "DIACEREINE BGA 50MG GELU",
  UCD7: '9324595',
  UCD13: '3400893245958',
  ucdQtyMultiplicator: 30,
  cipLib: "DIACEREINE BGA 50MG GELU BT 30",
  atcCode: "M01AX21"
}, {
  CIP7: '3865864',
  CIP13: '3400938658644',
  ucdLib: "DIACEREINE MYL 50MG GELU",
  UCD7: '9324684',
  UCD13: '3400893246849',
  ucdQtyMultiplicator: 30,
  cipLib: "DIACEREINE MYL 50MG GELU BT 30",
  atcCode: "M01AX21"
}, {
  CIP7: '3965643',
  CIP13: '3400939656434',
  ucdLib: "DIACEREINE CRT 50MG GELU",
  UCD7: '9344327',
  UCD13: '3400893443279',
  ucdQtyMultiplicator: 30,
  cipLib: "DIACEREINE CRT 50MG GELU BT 30",
  atcCode: "M01AX21"
}, {
  CIP7: '3934507',
  CIP13: '3400939345079',
  ucdLib: "DIACEREINE EG 50MG GELU",
  UCD7: '9336782',
  UCD13: '3400893367827',
  ucdQtyMultiplicator: 30,
  cipLib: "DIACEREINE EG 50MG GELU BT 30",
  atcCode: "M01AX21"
}, {
  CIP7: '3965376',
  CIP13: '3400939653761',
  ucdLib: "DIACEREINE ZEN 50MG GELU",
  UCD7: '9344296',
  UCD13: '3400893442968',
  ucdQtyMultiplicator: 30,
  cipLib: "DIACEREINE ZEN 50MG GELU BT 30",
  atcCode: "M01AX21"
}, {
  CIP7: '2166532',
  CIP13: '3400921665321',
  ucdLib: "DIACEREINE ZYD 50MG GELU",
  UCD7: '9377143',
  UCD13: '3400893771433',
  ucdQtyMultiplicator: 30,
  cipLib: "DIACEREINE ZYD 50MG GELU BT 30",
  atcCode: "M01AX21"
}, {
  CIP7: '3469192',
  CIP13: '3400934691928',
  ucdLib: "STRUCTOFLEX 625MG GELU",
  UCD7: '9360473',
  UCD13: '3400893604731',
  ucdQtyMultiplicator: 60,
  cipLib: "STRUCTOFLEX 625MG GELU BT 60",
  atcCode: "M01AX05"
}, {
  CIP7: '3805342',
  CIP13: '3400938053425',
  ucdLib: "FLEXEA 625MG CPR",
  UCD7: '9350871',
  UCD13: '3400893508718',
  ucdQtyMultiplicator: 60,
  cipLib: "FLEXEA 625MG CPR BT 60",
  atcCode: "M01AX05"
}, {
  CIP7: '3931331',
  CIP13: '3400939313313',
  ucdLib: "DOLENIO 1178MG CPR",
  UCD7: '9348070',
  UCD13: '3400893480700',
  ucdQtyMultiplicator: 30,
  cipLib: "DOLENIO 1178MG CPR BT 30",
  atcCode: "M01AX05"
}, {
  CIP7: '3970182',
  CIP13: '3400939701820',
  ucdLib: "OSAFLEXAN 1178MG BUV SACH",
  UCD7: '9350836',
  UCD13: '3400893508367',
  ucdQtyMultiplicator: 30,
  cipLib: "OSAFLEXAN 1178MG BUV SACH BT 30",
  atcCode: "M01AX05"
}, {
  CIP7: '3845732',
  CIP13: '3400938457322',
  ucdLib: "VOLTAFLEX 625MG CPR",
  UCD7: '9319447',
  UCD13: '3400893194478',
  ucdQtyMultiplicator: 60,
  cipLib: "VOLTAFLEX 625MG CPR BT 60",
  atcCode: "M01AX05"
}, {
  CIP7: '3072879',
  CIP13: '3400930728796',
  ucdLib: "NIFLURIL 250MG GELU",
  UCD7: '9063002',
  UCD13: '3400890630023',
  ucdQtyMultiplicator: 30,
  cipLib: "NIFLURIL 250MG GELU BT 30",
  atcCode: "M01AX02"
}, {
  CIP7: '3327173',
  CIP13: '3400933271732',
  ucdLib: "NABUCOX 1G CPR DISP",
  UCD7: '9209049',
  UCD13: '3400892090498',
  ucdQtyMultiplicator: 28,
  cipLib: "NABUCOX 1G CPR DISP BT 28",
  atcCode: "M01AX01"
}, {
  CIP7: '3327115',
  CIP13: '3400933271152',
  ucdLib: "NABUCOX 500MG CPR PELLIC",
  UCD7: '9281526',
  UCD13: '3400892815268',
  ucdQtyMultiplicator: 28,
  cipLib: "NABUCOX 500MG CPR PELLIC BT 28",
  atcCode: "M01AX01"
}, {
  CIP7: '3465018',
  CIP13: '3400934650185',
  ucdLib: "NABUCOX 1G CPR DISP",
  UCD7: '9209049',
  UCD13: '3400892090498',
  ucdQtyMultiplicator: 14,
  cipLib: "NABUCOX 1G CPR DISP BT 14",
  atcCode: "M01AX01"
}, {
  CIP7: '3879808',
  CIP13: '3400938798081',
  ucdLib: "ARCOXIA 30MG CPR",
  UCD7: '9325465',
  UCD13: '3400893254653',
  ucdQtyMultiplicator: 28,
  cipLib: "ARCOXIA 30MG CPR BT 28",
  atcCode: "M01AH05"
}, {
  CIP7: '3879257',
  CIP13: '3400938792577',
  ucdLib: "ARCOXIA 60MG CPR",
  UCD7: '9325471',
  UCD13: '3400893254714',
  ucdQtyMultiplicator: 28,
  cipLib: "ARCOXIA 60MG CPR BT 28",
  atcCode: "M01AH05"
}, {
  CIP7: '3592165',
  CIP13: '3400935921659',
  ucdLib: "DYNASTAT 40MG INJ FL",
  UCD7: '9242905',
  UCD13: '3400892429052',
  ucdQtyMultiplicator: 10,
  cipLib: "DYNASTAT 40MG INJ FL BT 10",
  atcCode: "M01AH04"
}, {
  CIP7: '3000133',
  CIP13: '3400930001332',
  ucdLib: "CELECOXIB BGA 100MG GELU",
  UCD7: '9407536',
  UCD13: '3400894075363',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB BGA 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '3000137',
  CIP13: '3400930001370',
  ucdLib: "CELECOXIB BGA 200MG GELU",
  UCD7: '9407542',
  UCD13: '3400894075424',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB BGA 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2760577',
  CIP13: '3400927605772',
  ucdLib: "CELECOXIB ZEN 100MG GELU",
  UCD7: '9404779',
  UCD13: '3400894047797',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB ZEN 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2760956',
  CIP13: '3400927609565',
  ucdLib: "CELECOXIB ZEN 200MG GELU",
  UCD7: '9404785',
  UCD13: '3400894047858',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB ZEN 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '3543681',
  CIP13: '3400935436818',
  ucdLib: "CELEBREX 100MG GELU",
  UCD7: '9223457',
  UCD13: '3400892234571',
  ucdQtyMultiplicator: 30,
  cipLib: "CELEBREX 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '3543706',
  CIP13: '3400935437068',
  ucdLib: "CELEBREX 200MG GELU",
  UCD7: '9223463',
  UCD13: '3400892234632',
  ucdQtyMultiplicator: 30,
  cipLib: "CELEBREX 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '5627152',
  CIP13: '3400956271528',
  ucdLib: "CELEBREX 100MG GELU",
  UCD7: '9223457',
  UCD13: '3400892234571',
  ucdQtyMultiplicator: 100,
  cipLib: "CELEBREX 100MG GELU BT 100",
  atcCode: "M01AH01"
}, {
  CIP7: '5628051',
  CIP13: '3400956280513',
  ucdLib: "CELEBREX 200MG GELU",
  UCD7: '9223463',
  UCD13: '3400892234632',
  ucdQtyMultiplicator: 100,
  cipLib: "CELEBREX 200MG GELU BT 100",
  atcCode: "M01AH01"
}, {
  CIP7: '2802399',
  CIP13: '3400928023995',
  ucdLib: "CELECOXIB CRT 200MG GELU",
  UCD7: '9408702',
  UCD13: '3400894087021',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB CRT 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2785844',
  CIP13: '3400927858444',
  ucdLib: "CELECOXIB ARW 100MG GELU",
  UCD7: '9404466',
  UCD13: '3400894044666',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB ARW 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2785927',
  CIP13: '3400927859274',
  ucdLib: "CELECOXIB ARW 200MG GELU",
  UCD7: '9404472',
  UCD13: '3400894044727',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB ARW 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2784253',
  CIP13: '3400927842535',
  ucdLib: "CELECOXIB EG 100MG GELU",
  UCD7: '9403739',
  UCD13: '3400894037392',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB EG 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2784282',
  CIP13: '3400927842825',
  ucdLib: "CELECOXIB EG 200MG GELU",
  UCD7: '9403745',
  UCD13: '3400894037453',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB EG 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2789138',
  CIP13: '3400927891380',
  ucdLib: "CELECOXIB MYP 100MG GELU",
  UCD7: '9404704',
  UCD13: '3400894047049',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB MYP 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2789196',
  CIP13: '3400927891960',
  ucdLib: "CELECOXIB MYP 200MG GELU",
  UCD7: '9404710',
  UCD13: '3400894047100',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB MYP 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2786105',
  CIP13: '3400927861055',
  ucdLib: "CELECOXIB PFZ 100MG GELU",
  UCD7: '9403751',
  UCD13: '3400894037514',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB PFZ 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2786128',
  CIP13: '3400927861284',
  ucdLib: "CELECOXIB PFZ 200MG GELU",
  UCD7: '9403768',
  UCD13: '3400894037682',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB PFZ 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2781094',
  CIP13: '3400927810947',
  ucdLib: "CELECOXIB SDZ 100MG GELU",
  UCD7: '9405000',
  UCD13: '3400894050001',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB SDZ 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2781160',
  CIP13: '3400927811609',
  ucdLib: "CELECOXIB SDZ 200MG GELU",
  UCD7: '9405017',
  UCD13: '3400894050179',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB SDZ 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2249519',
  CIP13: '3400922495194',
  ucdLib: "CELECOXIB TVC 100MG GELU",
  UCD7: '9404199',
  UCD13: '3400894041993',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB TVC 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2249755',
  CIP13: '3400922497556',
  ucdLib: "CELECOXIB TVC 200MG GELU",
  UCD7: '9404207',
  UCD13: '3400894042075',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB TVC 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2773835',
  CIP13: '3400927738357',
  ucdLib: "CELECOXIB HCS 100MG GELU",
  UCD7: '9404756',
  UCD13: '3400894047568',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB HCS 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2773806',
  CIP13: '3400927738067',
  ucdLib: "CELECOXIB HCS 200MG GELU",
  UCD7: '9404762',
  UCD13: '3400894047629',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB HCS 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2795883',
  CIP13: '3400927958830',
  ucdLib: "CELECOXIB RBX 200MG GELU",
  UCD7: '9410159',
  UCD13: '3400894101598',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB RBX 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2795216',
  CIP13: '3400927952166',
  ucdLib: "CELECOXIB ZYD 100MG GELU",
  UCD7: '9404213',
  UCD13: '3400894042136',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB ZYD 100MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '2795245',
  CIP13: '3400927952456',
  ucdLib: "CELECOXIB ZYD 200MG GELU",
  UCD7: '9404236',
  UCD13: '3400894042365',
  ucdQtyMultiplicator: 30,
  cipLib: "CELECOXIB ZYD 200MG GELU BT 30",
  atcCode: "M01AH01"
}, {
  CIP7: '3085244',
  CIP13: '3400930852446',
  ucdLib: "PONSTYL 250MG CAPS",
  UCD7: '9074075',
  UCD13: '3400890740753',
  ucdQtyMultiplicator: 20,
  cipLib: "PONSTYL 250MG CAPS BT 20",
  atcCode: "M01AG01"
}, {
  CIP7: '3618864',
  CIP13: '3400936188648',
  ucdLib: "KETESSE 50MG/2ML INJ AMP",
  UCD7: '9380955',
  UCD13: '3400893809556',
  ucdQtyMultiplicator: 6,
  cipLib: "KETESSE 50MG/2ML INJ AMP BT 6",
  atcCode: "M01AE17"
}, {
  CIP7: '3461753',
  CIP13: '3400934617539',
  ucdLib: "KETESSE 12,5MG CPR",
  UCD7: '9381015',
  UCD13: '3400893810156',
  ucdQtyMultiplicator: 20,
  cipLib: "KETESSE 12,5MG CPR BT 20",
  atcCode: "M01AE17"
}, {
  CIP7: '3461782',
  CIP13: '3400934617829',
  ucdLib: "KETESSE 25MG CPR",
  UCD7: '9373582',
  UCD13: '3400893735824',
  ucdQtyMultiplicator: 20,
  cipLib: "KETESSE 25MG CPR BT 20",
  atcCode: "M01AE17"
}, {
  CIP7: '3342468',
  CIP13: '3400933424688',
  ucdLib: "MINALFENE 300MG CPR",
  UCD7: '9156092',
  UCD13: '3400891560923',
  ucdQtyMultiplicator: 15,
  cipLib: "MINALFENE 300MG CPR BT 15",
  atcCode: "M01AE16"
}, {
  CIP7: '3830771',
  CIP13: '3400938307719',
  ucdLib: "ACIDE TIAPROF.ARW 100MG CPR",
  UCD7: '9309408',
  UCD13: '3400893094082',
  ucdQtyMultiplicator: 30,
  cipLib: "ACIDE TIAPROF.ARW 100MG CPR BT 30",
  atcCode: "M01AE11"
}, {
  CIP7: '3239948',
  CIP13: '3400932399482',
  ucdLib: "SURGAM 200MG CPR",
  UCD7: '9187589',
  UCD13: '3400891875898',
  ucdQtyMultiplicator: 15,
  cipLib: "SURGAM 200MG CPR BT 15",
  atcCode: "M01AE11"
}, {
  CIP7: '3673596',
  CIP13: '3400936735965',
  ucdLib: "ACIDE TIAPROF.ZEN 100MG CPR",
  UCD7: '9266596',
  UCD13: '3400892665962',
  ucdQtyMultiplicator: 30,
  cipLib: "ACIDE TIAPROF.ZEN 100MG CPR BT 30",
  atcCode: "M01AE11"
}, {
  CIP7: '3517459',
  CIP13: '3400935174598',
  ucdLib: "ACIDE TIAPROF.EG 100MG CPR",
  UCD7: '9213298',
  UCD13: '3400892132983',
  ucdQtyMultiplicator: 30,
  cipLib: "ACIDE TIAPROF.EG 100MG CPR BT 30",
  atcCode: "M01AE11"
}, {
  CIP7: '3530709',
  CIP13: '3400935307095',
  ucdLib: "FLANID 100MG CPR",
  UCD7: '9219042',
  UCD13: '3400892190426',
  ucdQtyMultiplicator: 30,
  cipLib: "FLANID 100MG CPR BT 30",
  atcCode: "M01AE11"
}, {
  CIP7: '3530690',
  CIP13: '3400935306906',
  ucdLib: "FLANID 200MG CPR",
  UCD7: '9219059',
  UCD13: '3400892190594',
  ucdQtyMultiplicator: 15,
  cipLib: "FLANID 200MG CPR BT 15",
  atcCode: "M01AE11"
}, {
  CIP7: '3177928',
  CIP13: '3400931779285',
  ucdLib: "SURGAM 100MG CPR",
  UCD7: '9089473',
  UCD13: '3400890894739',
  ucdQtyMultiplicator: 30,
  cipLib: "SURGAM 100MG CPR BT 30",
  atcCode: "M01AE11"
}, {
  CIP7: '3267672',
  CIP13: '3400932676729',
  ucdLib: "ANTADYS 100MG CPR",
  UCD7: '9144812',
  UCD13: '3400891448122',
  ucdQtyMultiplicator: 15,
  cipLib: "ANTADYS 100MG CPR BT 15",
  atcCode: "M01AE09"
}, {
  CIP7: '3197109',
  CIP13: '3400931971092',
  ucdLib: "CEBUTID 50MG CPR",
  UCD7: '9017077',
  UCD13: '3400890170772',
  ucdQtyMultiplicator: 30,
  cipLib: "CEBUTID 50MG CPR BT 30",
  atcCode: "M01AE09"
}, {
  CIP7: '3319908',
  CIP13: '3400933199081',
  ucdLib: "CEBUTID LP 200MG GELU",
  UCD7: '9143468',
  UCD13: '3400891434682',
  ucdQtyMultiplicator: 16,
  cipLib: "CEBUTID LP 200MG GELU BT 16",
  atcCode: "M01AE09"
}, {
  CIP7: '3222675',
  CIP13: '3400932226757',
  ucdLib: "CEBUTID 100MG CPR",
  UCD7: '9017054',
  UCD13: '3400890170543',
  ucdQtyMultiplicator: 15,
  cipLib: "CEBUTID 100MG CPR BT 15",
  atcCode: "M01AE09"
}, {
  CIP7: '3198190',
  CIP13: '3400931981909',
  ucdLib: "NALGESIC 300MG CPR",
  UCD7: '9060877',
  UCD13: '3400890608770',
  ucdQtyMultiplicator: 16,
  cipLib: "NALGESIC 300MG CPR BT 16",
  atcCode: "M01AE04"
}, {
  CIP7: '3611170',
  CIP13: '3400936111707',
  ucdLib: "KETOPROFENE TVC LP200MG GELU",
  UCD7: '9245128',
  UCD13: '3400892451282',
  ucdQtyMultiplicator: 14,
  cipLib: "KETOPROFENE TVC LP200MG GELU BT 14",
  atcCode: "M01AE03"
}, {
  CIP7: '3282594',
  CIP13: '3400932825943',
  ucdLib: "PROFENID LP 200MG CPR",
  UCD7: '9106059',
  UCD13: '3400891060591',
  ucdQtyMultiplicator: 14,
  cipLib: "PROFENID LP 200MG CPR BT 14",
  atcCode: "M01AE03"
}, {
  CIP7: '3315833',
  CIP13: '3400933158330',
  ucdLib: "PROFENID LP 200MG GELU",
  UCD7: '9143617',
  UCD13: '3400891436174',
  ucdQtyMultiplicator: 14,
  cipLib: "PROFENID LP 200MG GELU BT 14",
  atcCode: "M01AE03"
}, {
  CIP7: '3330206',
  CIP13: '3400933302061',
  ucdLib: "PROFENID 100MG CPR",
  UCD7: '9149809',
  UCD13: '3400891498097',
  ucdQtyMultiplicator: 30,
  cipLib: "PROFENID 100MG CPR BT 30",
  atcCode: "M01AE03"
}, {
  CIP7: '3308106',
  CIP13: '3400933081065',
  ucdLib: "TOPREC 25MG CPR",
  UCD7: '9138303',
  UCD13: '3400891383034',
  ucdQtyMultiplicator: 20,
  cipLib: "TOPREC 25MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '5573456',
  CIP13: '3400955734567',
  ucdLib: "PROFENID 100MG CPR",
  UCD7: '9149809',
  UCD13: '3400891498097',
  ucdQtyMultiplicator: 100,
  cipLib: "PROFENID 100MG CPR BT 100",
  atcCode: "M01AE03"
}, {
  CIP7: '5574668',
  CIP13: '3400955746683',
  ucdLib: "PROFENID 100MG IV FL",
  UCD7: '9075962',
  UCD13: '3400890759625',
  ucdQtyMultiplicator: 50,
  cipLib: "PROFENID 100MG IV FL BT 50",
  atcCode: "M01AE03"
}, {
  CIP7: '5589807',
  CIP13: '3400955898078',
  ucdLib: "PROFEMIGR 150MG CPR",
  UCD7: '9010684',
  UCD13: '3400890106849',
  ucdQtyMultiplicator: 100,
  cipLib: "PROFEMIGR 150MG CPR BT 100",
  atcCode: "M01AE03"
}, {
  CIP7: '3852465',
  CIP13: '3400938524659',
  ucdLib: "KETOPROFENE RBX 50MG GELU",
  UCD7: '9317922',
  UCD13: '3400893179222',
  ucdQtyMultiplicator: 24,
  cipLib: "KETOPROFENE RBX 50MG GELU BT 24",
  atcCode: "M01AE03"
}, {
  CIP7: '3392791',
  CIP13: '3400933927912',
  ucdLib: "KETUM 100MG CPR",
  UCD7: '9178716',
  UCD13: '3400891787160',
  ucdQtyMultiplicator: 30,
  cipLib: "KETUM 100MG CPR BT 30",
  atcCode: "M01AE03"
}, {
  CIP7: '3392816',
  CIP13: '3400933928162',
  ucdLib: "KETUM LP 200MG GELU",
  UCD7: '9178691',
  UCD13: '3400891786910',
  ucdQtyMultiplicator: 14,
  cipLib: "KETUM LP 200MG GELU BT 14",
  atcCode: "M01AE03"
}, {
  CIP7: '3533091',
  CIP13: '3400935330918',
  ucdLib: "KETOPROFENE MYL LP200MG GELU",
  UCD7: '9223368',
  UCD13: '3400892233680',
  ucdQtyMultiplicator: 14,
  cipLib: "KETOPROFENE MYL LP200MG GELU BT 14",
  atcCode: "M01AE03"
}, {
  CIP7: '3515733',
  CIP13: '3400935157331',
  ucdLib: "TOPREC 1MG/ML SIR FL150ML",
  UCD7: '9215587',
  UCD13: '3400892155876',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPREC 1MG/ML SIR FL150ML BT 1",
  atcCode: "M01AE03"
}, {
  CIP7: '3179293',
  CIP13: '3400931792932',
  ucdLib: "PROFENID 100MG SUP",
  UCD7: '9075956',
  UCD13: '3400890759564',
  ucdQtyMultiplicator: 12,
  cipLib: "PROFENID 100MG SUP BT 12",
  atcCode: "M01AE03"
}, {
  CIP7: '3746674',
  CIP13: '3400937466745',
  ucdLib: "KETOPROFENE PMY 100MG/2ML AMP",
  UCD7: '9290235',
  UCD13: '3400892902357',
  ucdQtyMultiplicator: 6,
  cipLib: "KETOPROFENE PMY 100MG/2ML AMP BT 6",
  atcCode: "M01AE03"
}, {
  CIP7: '3784829',
  CIP13: '3400937848299',
  ucdLib: "KETOPROFENE RBX 100MG CPR",
  UCD7: '9317649',
  UCD13: '3400893176498',
  ucdQtyMultiplicator: 30,
  cipLib: "KETOPROFENE RBX 100MG CPR BT 30",
  atcCode: "M01AE03"
}, {
  CIP7: '3783451',
  CIP13: '3400937834513',
  ucdLib: "KETOPROFENE RBX LP 200MG CPR",
  UCD7: '9317916',
  UCD13: '3400893179161',
  ucdQtyMultiplicator: 14,
  cipLib: "KETOPROFENE RBX LP 200MG CPR BT 14",
  atcCode: "M01AE03"
}, {
  CIP7: '3471898',
  CIP13: '3400934718984',
  ucdLib: "KETOPROFENE ZEN LP 100MG CPR",
  UCD7: '9372080',
  UCD13: '3400893720806',
  ucdQtyMultiplicator: 20,
  cipLib: "KETOPROFENE ZEN LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '3752249',
  CIP13: '3400937522496',
  ucdLib: "PROFEMIGR 150MG CPR",
  UCD7: '9010684',
  UCD13: '3400890106849',
  ucdQtyMultiplicator: 10,
  cipLib: "PROFEMIGR 150MG CPR BT 10",
  atcCode: "M01AE03"
}, {
  CIP7: '2214314',
  CIP13: '3400922143149',
  ucdLib: "KETOPROFENE ARW LP 100MG CPR",
  UCD7: '9394561',
  UCD13: '3400893945612',
  ucdQtyMultiplicator: 20,
  cipLib: "KETOPROFENE ARW LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '2214337',
  CIP13: '3400922143378',
  ucdLib: "KETOPROFENE BGA LP 100MG CPR",
  UCD7: '9389005',
  UCD13: '3400893890059',
  ucdQtyMultiplicator: 20,
  cipLib: "KETOPROFENE BGA LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '2214260',
  CIP13: '3400922142609',
  ucdLib: "KETOPROFENE EG LP 100MG CPR",
  UCD7: '9394851',
  UCD13: '3400893948514',
  ucdQtyMultiplicator: 20,
  cipLib: "KETOPROFENE EG LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '2214283',
  CIP13: '3400922142838',
  ucdLib: "KETOPROFENE TVC LP 100MG CPR",
  UCD7: '9393171',
  UCD13: '3400893931714',
  ucdQtyMultiplicator: 20,
  cipLib: "KETOPROFENE TVC LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '2661869',
  CIP13: '3400926618698',
  ucdLib: "KETOPROFENE MYL LP 100MG CPR",
  UCD7: '9389376',
  UCD13: '3400893893760',
  ucdQtyMultiplicator: 20,
  cipLib: "KETOPROFENE MYL LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '2662900',
  CIP13: '3400926629007',
  ucdLib: "KETOPROFENE RBX LP 100MG CPR",
  UCD7: '9389382',
  UCD13: '3400893893821',
  ucdQtyMultiplicator: 20,
  cipLib: "KETOPROFENE RBX LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '2662952',
  CIP13: '3400926629526',
  ucdLib: "KETOPROFENE SDZ LP 100MG CPR",
  UCD7: '9389399',
  UCD13: '3400893893999',
  ucdQtyMultiplicator: 20,
  cipLib: "KETOPROFENE SDZ LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '4993920',
  CIP13: '3400949939206',
  ucdLib: "PROFENID 50MG GELU",
  UCD7: '9075933',
  UCD13: '3400890759335',
  ucdQtyMultiplicator: 20,
  cipLib: "PROFENID 50MG GELU BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '3998022',
  CIP13: '3400939980225',
  ucdLib: "BIPROFENID LP 100MG CPR",
  UCD7: '9343701',
  UCD13: '3400893437018',
  ucdQtyMultiplicator: 20,
  cipLib: "BIPROFENID LP 100MG CPR BT 20",
  atcCode: "M01AE03"
}, {
  CIP7: '3998045',
  CIP13: '3400939980454',
  ucdLib: "BIPROFENID LP 100MG CPR",
  UCD7: '9343701',
  UCD13: '3400893437018',
  ucdQtyMultiplicator: 100,
  cipLib: "BIPROFENID LP 100MG CPR BT 100",
  atcCode: "M01AE03"
}, {
  CIP7: '2688851',
  CIP13: '3400926888510',
  ucdLib: "KETOPROFENE MDC 100MG/4ML A.",
  UCD7: '9390215',
  UCD13: '3400893902158',
  ucdQtyMultiplicator: 10,
  cipLib: "KETOPROFENE MDC 100MG/4ML A. BT 10",
  atcCode: "M01AE03"
}, {
  CIP7: '5803784',
  CIP13: '3400958037849',
  ucdLib: "KETOPROFENE MAC100MG 100ML+S",
  UCD7: '9401640',
  UCD13: '3400894016403',
  ucdQtyMultiplicator: 10,
  cipLib: "KETOPROFENE MAC100MG 100ML+S BT 10",
  atcCode: "M01AE03"
}, {
  CIP7: '5803761',
  CIP13: '3400958037610',
  ucdLib: "KETOPROFENE MAC100MG P100ML",
  UCD7: '9377083',
  UCD13: '3400893770832',
  ucdQtyMultiplicator: 10,
  cipLib: "KETOPROFENE MAC100MG P100ML BT 10",
  atcCode: "M01AE03"
}, {
  CIP7: '5803821',
  CIP13: '3400958038211',
  ucdLib: "KETOPROFENE MCL100MG 100ML +S",
  UCD7: '9404383',
  UCD13: '3400894043836',
  ucdQtyMultiplicator: 10,
  cipLib: "KETOPROFENE MCL100MG 100ML +S BT 10",
  atcCode: "M01AE03"
}, {
  CIP7: '5833118',
  CIP13: '3400958331183',
  ucdLib: "KETOPROFENE MYL LP 100MG CPR",
  UCD7: '9389376',
  UCD13: '3400893893760',
  ucdQtyMultiplicator: 100,
  cipLib: "KETOPROFENE MYL LP 100MG CPR BT 100",
  atcCode: "M01AE03"
}, {
  CIP7: '3429212',
  CIP13: '3400934292125',
  ucdLib: "PROFENID 100MG IM AMP2ML",
  UCD7: '9204974',
  UCD13: '3400892049748',
  ucdQtyMultiplicator: 6,
  cipLib: "PROFENID 100MG IM AMP2ML BT 6",
  atcCode: "M01AE03"
}, {
  CIP7: '3250039',
  CIP13: '3400932500390',
  ucdLib: "APRANAX 275MG CPR",
  UCD7: '9005973',
  UCD13: '3400890059732',
  ucdQtyMultiplicator: 30,
  cipLib: "APRANAX 275MG CPR BT 30",
  atcCode: "M01AE02"
}, {
  CIP7: '3266135',
  CIP13: '3400932661350',
  ucdLib: "APRANAX 550MG CPR",
  UCD7: '9005996',
  UCD13: '3400890059961',
  ucdQtyMultiplicator: 16,
  cipLib: "APRANAX 550MG CPR BT 16",
  atcCode: "M01AE02"
}, {
  CIP7: '3344993',
  CIP13: '3400933449933',
  ucdLib: "NAPROSYNE 1000MG CPR",
  UCD7: '9156100',
  UCD13: '3400891561005',
  ucdQtyMultiplicator: 8,
  cipLib: "NAPROSYNE 1000MG CPR BT 8",
  atcCode: "M01AE02"
}, {
  CIP7: '3353644',
  CIP13: '3400933536442',
  ucdLib: "APRANAX 750MG CPR",
  UCD7: '9157306',
  UCD13: '3400891573060',
  ucdQtyMultiplicator: 15,
  cipLib: "APRANAX 750MG CPR BT 15",
  atcCode: "M01AE02"
}, {
  CIP7: '3205056',
  CIP13: '3400932050567',
  ucdLib: "NAPROSYNE 500MG SUP",
  UCD7: '9061003',
  UCD13: '3400890610032',
  ucdQtyMultiplicator: 12,
  cipLib: "NAPROSYNE 500MG SUP BT 12",
  atcCode: "M01AE02"
}, {
  CIP7: '3467224',
  CIP13: '3400934672248',
  ucdLib: "NAPROXENE S.TVC 550MG CPR",
  UCD7: '9206513',
  UCD13: '3400892065137',
  ucdQtyMultiplicator: 16,
  cipLib: "NAPROXENE S.TVC 550MG CPR BT 16",
  atcCode: "M01AE02"
}, {
  CIP7: '3168438',
  CIP13: '3400931684381',
  ucdLib: "NAPROSYNE 250MG CPR",
  UCD7: '9060972',
  UCD13: '3400890609722',
  ucdQtyMultiplicator: 10,
  cipLib: "NAPROSYNE 250MG CPR BT 10",
  atcCode: "M01AE02"
}, {
  CIP7: '3502417',
  CIP13: '3400935024176',
  ucdLib: "NAPROSYNE 500MG CPR",
  UCD7: '9060989',
  UCD13: '3400890609890',
  ucdQtyMultiplicator: 10,
  cipLib: "NAPROSYNE 500MG CPR BT 10",
  atcCode: "M01AE02"
}, {
  CIP7: '2742869',
  CIP13: '3400927428692',
  ucdLib: "ALEVETABS 220MG CPR",
  UCD7: '9368598',
  UCD13: '3400893685983',
  ucdQtyMultiplicator: 24,
  cipLib: "ALEVETABS 220MG CPR BT 24",
  atcCode: "M01AE02"
}, {
  CIP7: '4997415',
  CIP13: '3400949974153',
  ucdLib: "NAPROXENE S.EG 550MG CPR",
  UCD7: '9366091',
  UCD13: '3400893660911',
  ucdQtyMultiplicator: 16,
  cipLib: "NAPROXENE S.EG 550MG CPR BT 16",
  atcCode: "M01AE02"
}, {
  CIP7: '4162811',
  CIP13: '3400941628115',
  ucdLib: "ANTALNOX 550MG CPR",
  UCD7: '9373263',
  UCD13: '3400893732632',
  ucdQtyMultiplicator: 16,
  cipLib: "ANTALNOX 550MG CPR BT 16",
  atcCode: "M01AE02"
}, {
  CIP7: '3619295',
  CIP13: '3400936192959',
  ucdLib: "ANTARENE BB./ENF BUV 150ML+SRG",
  UCD7: '9250276',
  UCD13: '3400892502762',
  ucdQtyMultiplicator: 1,
  cipLib: "ANTARENE BB./ENF BUV 150ML+SRG BT 1",
  atcCode: "M01AE01"
}, {
  CIP7: '3835892',
  CIP13: '3400938358926',
  ucdLib: "IBUPROFENE BGC 400MG CPR",
  UCD7: '9316667',
  UCD13: '3400893166673',
  ucdQtyMultiplicator: 10,
  cipLib: "IBUPROFENE BGC 400MG CPR BT 10",
  atcCode: "M01AE01"
}, {
  CIP7: '3830707',
  CIP13: '3400938307078',
  ucdLib: "IBUPROFENE CRT 200MG C.PELL",
  UCD7: '9309526',
  UCD13: '3400893095263',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE CRT 200MG C.PELL BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3832706',
  CIP13: '3400938327069',
  ucdLib: "IBUPROFENE SDC 400MG CPR",
  UCD7: '9318040',
  UCD13: '3400893180402',
  ucdQtyMultiplicator: 15,
  cipLib: "IBUPROFENE SDC 400MG CPR BT 15",
  atcCode: "M01AE01"
}, {
  CIP7: '3323152',
  CIP13: '3400933231521',
  ucdLib: "ADVIL 200MG CPR",
  UCD7: '9121691',
  UCD13: '3400891216912',
  ucdQtyMultiplicator: 30,
  cipLib: "ADVIL 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3006533',
  CIP13: '3400930065334',
  ucdLib: "IBUPRADOLL 200MG CPR",
  UCD7: '9419321',
  UCD13: '3400894193210',
  ucdQtyMultiplicator: 24,
  cipLib: "IBUPRADOLL 200MG CPR BT 24",
  atcCode: "M01AE01"
}, {
  CIP7: '3006536',
  CIP13: '3400930065365',
  ucdLib: "IBUPRADOLL 400MG CPR",
  UCD7: '9419338',
  UCD13: '3400894193388',
  ucdQtyMultiplicator: 12,
  cipLib: "IBUPRADOLL 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '3006522',
  CIP13: '3400930065228',
  ucdLib: "IBUPROFENE ZTC 200MG CPR",
  UCD7: '9421200',
  UCD13: '3400894212003',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE ZTC 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3006526',
  CIP13: '3400930065266',
  ucdLib: "IBUPROFENE ZTC 400MG CPR",
  UCD7: '9421217',
  UCD13: '3400894212171',
  ucdQtyMultiplicator: 10,
  cipLib: "IBUPROFENE ZTC 400MG CPR BT 10",
  atcCode: "M01AE01"
}, {
  CIP7: '3002103',
  CIP13: '3400930021033',
  ucdLib: "SPEDIFEN 400MG CPR",
  UCD7: '9308656',
  UCD13: '3400893086568',
  ucdQtyMultiplicator: 3,
  cipLib: "SPEDIFEN 400MG CPR BT 3",
  atcCode: "M01AE01"
}, {
  CIP7: '3321590',
  CIP13: '3400933215903',
  ucdLib: "UPFEN 200MG CPR",
  UCD7: '9143480',
  UCD13: '3400891434804',
  ucdQtyMultiplicator: 20,
  cipLib: "UPFEN 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3295935',
  CIP13: '3400932959358',
  ucdLib: "ADVIL 200MG CPR",
  UCD7: '9121691',
  UCD13: '3400891216912',
  ucdQtyMultiplicator: 20,
  cipLib: "ADVIL 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3295941',
  CIP13: '3400932959419',
  ucdLib: "ADVILMED 400MG CPR",
  UCD7: '9219697',
  UCD13: '3400892196978',
  ucdQtyMultiplicator: 20,
  cipLib: "ADVILMED 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3571507',
  CIP13: '3400935715074',
  ucdLib: "IBUPROFENE ARW 200MG CPR",
  UCD7: '9234521',
  UCD13: '3400892345215',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE ARW 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3571513',
  CIP13: '3400935715135',
  ucdLib: "IBUPROFENE ARW 200MG CPR",
  UCD7: '9234521',
  UCD13: '3400892345215',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE ARW 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3606074',
  CIP13: '3400936060746',
  ucdLib: "IBUPROFENE ISD 200MG CPR",
  UCD7: '9331537',
  UCD13: '3400893315378',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE ISD 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3602828',
  CIP13: '3400936028289',
  ucdLib: "IBUPROFENE RTC 200MG CPR",
  UCD7: '9341010',
  UCD13: '3400893410103',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE RTC 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3606016',
  CIP13: '3400936060166',
  ucdLib: "IBUPROFENE TCO 200MG CPR",
  UCD7: '9246949',
  UCD13: '3400892469492',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE TCO 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3606045',
  CIP13: '3400936060456',
  ucdLib: "IBUPROFENE TVC 200MG CPR ENR",
  UCD7: '9261179',
  UCD13: '3400892611792',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE TVC 200MG CPR ENR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3605399',
  CIP13: '3400936053991',
  ucdLib: "NUROFEN 200MG CPR DISP",
  UCD7: '9414476',
  UCD13: '3400894144762',
  ucdQtyMultiplicator: 12,
  cipLib: "NUROFEN 200MG CPR DISP BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '3686498',
  CIP13: '3400936864986',
  ucdLib: "NUROFEN 400MG CPR",
  UCD7: '9311693',
  UCD13: '3400893116937',
  ucdQtyMultiplicator: 12,
  cipLib: "NUROFEN 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '3681420',
  CIP13: '3400936814202',
  ucdLib: "NUROFENFEM 400MG CPR",
  UCD7: '9350397',
  UCD13: '3400893503973',
  ucdQtyMultiplicator: 12,
  cipLib: "NUROFENFEM 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '3605301',
  CIP13: '3400936053014',
  ucdLib: "NUROFENTABS 200MG CPR DISP",
  UCD7: '9268023',
  UCD13: '3400892680231',
  ucdQtyMultiplicator: 12,
  cipLib: "NUROFENTABS 200MG CPR DISP BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '3608133',
  CIP13: '3400936081338',
  ucdLib: "SPEDIFEN 200MG CPR",
  UCD7: '9250833',
  UCD13: '3400892508337',
  ucdQtyMultiplicator: 20,
  cipLib: "SPEDIFEN 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3608191',
  CIP13: '3400936081918',
  ucdLib: "SPIFEN 200MG CPR",
  UCD7: '9319602',
  UCD13: '3400893196021',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIFEN 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3432510',
  CIP13: '3400934325106',
  ucdLib: "INTRALGIS 200MG CPR",
  UCD7: '9192018',
  UCD13: '3400891920185',
  ucdQtyMultiplicator: 30,
  cipLib: "INTRALGIS 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3525105',
  CIP13: '3400935251053',
  ucdLib: "SPEDIFEN 400MG BUV GLE SACH",
  UCD7: '9383474',
  UCD13: '3400893834749',
  ucdQtyMultiplicator: 12,
  cipLib: "SPEDIFEN 400MG BUV GLE SACH BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '4989717',
  CIP13: '3400949897179',
  ucdLib: "IBUTABS 400MG CPR",
  UCD7: '9371459',
  UCD13: '3400893714591',
  ucdQtyMultiplicator: 10,
  cipLib: "IBUTABS 400MG CPR BT 10",
  atcCode: "M01AE01"
}, {
  CIP7: '3356594',
  CIP13: '3400933565947',
  ucdLib: "INTRALGIS 200MG CPR",
  UCD7: '9192018',
  UCD13: '3400891920185',
  ucdQtyMultiplicator: 20,
  cipLib: "INTRALGIS 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3675247',
  CIP13: '3400936752474',
  ucdLib: "NUROFENFLASH 200MG CPR",
  UCD7: '9271108',
  UCD13: '3400892711089',
  ucdQtyMultiplicator: 12,
  cipLib: "NUROFENFLASH 200MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '3676057',
  CIP13: '3400936760578',
  ucdLib: "NUROFENFLASH 400MG CPR",
  UCD7: '9339125',
  UCD13: '3400893391259',
  ucdQtyMultiplicator: 12,
  cipLib: "NUROFENFLASH 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '3364062',
  CIP13: '3400933640620',
  ucdLib: "ADVILMED 20MG/1ML BUV FL200ML",
  UCD7: '9167500',
  UCD13: '3400891675009',
  ucdQtyMultiplicator: 1,
  cipLib: "ADVILMED 20MG/1ML BUV FL200ML BT 1",
  atcCode: "M01AE01"
}, {
  CIP7: '3366581',
  CIP13: '3400933665814',
  ucdLib: "ANTARENE 200MG CPR",
  UCD7: '9179785',
  UCD13: '3400891797855',
  ucdQtyMultiplicator: 30,
  cipLib: "ANTARENE 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3399273',
  CIP13: '3400933992736',
  ucdLib: "HEMAGENE TAILLEUR 200MG CPR",
  UCD7: '9187081',
  UCD13: '3400891870817',
  ucdQtyMultiplicator: 24,
  cipLib: "HEMAGENE TAILLEUR 200MG CPR BT 24",
  atcCode: "M01AE01"
}, {
  CIP7: '3368195',
  CIP13: '3400933681951',
  ucdLib: "IBUPROFENE EG 400MG CPR",
  UCD7: '9265220',
  UCD13: '3400892652207',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE EG 400MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3550652',
  CIP13: '3400935506528',
  ucdLib: "IBUPROFENE ZYD 200MG CPR",
  UCD7: '9225002',
  UCD13: '3400892250021',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE ZYD 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3398612',
  CIP13: '3400933986124',
  ucdLib: "NUREFLEX 200MG CPR",
  UCD7: '9178403',
  UCD13: '3400891784039',
  ucdQtyMultiplicator: 30,
  cipLib: "NUREFLEX 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3368634',
  CIP13: '3400933686345',
  ucdLib: "NUREFLEX LP 300MG GELU",
  UCD7: '9203791',
  UCD13: '3400892037912',
  ucdQtyMultiplicator: 30,
  cipLib: "NUREFLEX LP 300MG GELU BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3396435',
  CIP13: '3400933964351',
  ucdLib: "NUROFEN 200MG CPR",
  UCD7: '9125447',
  UCD13: '3400891254471',
  ucdQtyMultiplicator: 20,
  cipLib: "NUROFEN 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3519990',
  CIP13: '3400935199904',
  ucdLib: "ANTARENE 100MG CPR",
  UCD7: '9217669',
  UCD13: '3400892176697',
  ucdQtyMultiplicator: 40,
  cipLib: "ANTARENE 100MG CPR BT 40",
  atcCode: "M01AE01"
}, {
  CIP7: '3519375',
  CIP13: '3400935193759',
  ucdLib: "ANTARENE 400MG CPR",
  UCD7: '9216776',
  UCD13: '3400892167763',
  ucdQtyMultiplicator: 30,
  cipLib: "ANTARENE 400MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3622570',
  CIP13: '3400936225701',
  ucdLib: "BRUFEN 400MG CPR PELLIC",
  UCD7: '9258993',
  UCD13: '3400892589930',
  ucdQtyMultiplicator: 30,
  cipLib: "BRUFEN 400MG CPR PELLIC BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3484168',
  CIP13: '3400934841682',
  ucdLib: "IBUPROFENE BGA 200MG CPR",
  UCD7: '9206588',
  UCD13: '3400892065885',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE BGA 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3593041',
  CIP13: '3400935930415',
  ucdLib: "IBUPROFENE RTP 200MG CPR",
  UCD7: '9239903',
  UCD13: '3400892399034',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE RTP 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3658303',
  CIP13: '3400936583030',
  ucdLib: "IBUPROFENE SDZ 200MG C.ENROB",
  UCD7: '9263942',
  UCD13: '3400892639420',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE SDZ 200MG C.ENROB BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3659573',
  CIP13: '3400936595736',
  ucdLib: "IBUPROFENE SDZ 400MG CPR",
  UCD7: '9263959',
  UCD13: '3400892639598',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE SDZ 400MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3416847',
  CIP13: '3400934168475',
  ucdLib: "NUREFLEX 400MG CPR",
  UCD7: '9192596',
  UCD13: '3400891925968',
  ucdQtyMultiplicator: 20,
  cipLib: "NUREFLEX 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3625189',
  CIP13: '3400936251892',
  ucdLib: "SPEDIFEN 400MG CPR",
  UCD7: '9308656',
  UCD13: '3400893086568',
  ucdQtyMultiplicator: 12,
  cipLib: "SPEDIFEN 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '3625137',
  CIP13: '3400936251373',
  ucdLib: "SPIFEN 400MG CPR",
  UCD7: '9261914',
  UCD13: '3400892619149',
  ucdQtyMultiplicator: 20,
  cipLib: "SPIFEN 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3584591',
  CIP13: '3400935845917',
  ucdLib: "ADVILMED 100MG CPR",
  UCD7: '9240295',
  UCD13: '3400892402956',
  ucdQtyMultiplicator: 30,
  cipLib: "ADVILMED 100MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3582327',
  CIP13: '3400935823274',
  ucdLib: "IBUPROFENE MYL 200MG CPR",
  UCD7: '9237181',
  UCD13: '3400892371818',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE MYL 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3583137',
  CIP13: '3400935831378',
  ucdLib: "IBUPROFENE MYL 200MG CPR",
  UCD7: '9237181',
  UCD13: '3400892371818',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE MYL 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3817115',
  CIP13: '3400938171150',
  ucdLib: "ADVIL 400MG CPR",
  UCD7: '9318809',
  UCD13: '3400893188095',
  ucdQtyMultiplicator: 14,
  cipLib: "ADVIL 400MG CPR BT 14",
  atcCode: "M01AE01"
}, {
  CIP7: '3816297',
  CIP13: '3400938162974',
  ucdLib: "ADVILCAPS 200MG CAPS MOL",
  UCD7: '9319252',
  UCD13: '3400893192528',
  ucdQtyMultiplicator: 16,
  cipLib: "ADVILCAPS 200MG CAPS MOL BT 16",
  atcCode: "M01AE01"
}, {
  CIP7: '3769333',
  CIP13: '3400937693332',
  ucdLib: "IBUPROFENE ALM 200MG CPR",
  UCD7: '9295178',
  UCD13: '3400892951782',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE ALM 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3766398',
  CIP13: '3400937663984',
  ucdLib: "IBUPROFENE ALM 400MG CPR",
  UCD7: '9292547',
  UCD13: '3400892925479',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE ALM 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3665616',
  CIP13: '3400936656161',
  ucdLib: "IBUPROFENE ARW 400MG CPR",
  UCD7: '9269399',
  UCD13: '3400892693996',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE ARW 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3665622',
  CIP13: '3400936656222',
  ucdLib: "IBUPROFENE ARW 400MG CPR",
  UCD7: '9269399',
  UCD13: '3400892693996',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE ARW 400MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3765631',
  CIP13: '3400937656313',
  ucdLib: "IBUPROFENE BGA 400MG CPR",
  UCD7: '9292553',
  UCD13: '3400892925530',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE BGA 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3769304',
  CIP13: '3400937693042',
  ucdLib: "IBUPROFENE BGC 200MG CPR",
  UCD7: '9295184',
  UCD13: '3400892951843',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE BGC 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3749916',
  CIP13: '3400937499163',
  ucdLib: "IBUPROFENE MYL 400MG CPR",
  UCD7: '9289841',
  UCD13: '3400892898414',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE MYL 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3749922',
  CIP13: '3400937499224',
  ucdLib: "IBUPROFENE MYL 400MG CPR",
  UCD7: '9289841',
  UCD13: '3400892898414',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE MYL 400MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3766530',
  CIP13: '3400937665308',
  ucdLib: "IBUPROFENE SDC 200MG CPR",
  UCD7: '9292576',
  UCD13: '3400892925769',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE SDC 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3665579',
  CIP13: '3400936655799',
  ucdLib: "IBUPROFENE SDZ 400MG C.PELL",
  UCD7: '9269494',
  UCD13: '3400892694948',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE SDZ 400MG C.PELL BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3828662',
  CIP13: '3400938286625',
  ucdLib: "ADVILCAPS 400MG CAPS MOL",
  UCD7: '9339214',
  UCD13: '3400893392140',
  ucdQtyMultiplicator: 14,
  cipLib: "ADVILCAPS 400MG CAPS MOL BT 14",
  atcCode: "M01AE01"
}, {
  CIP7: '3647593',
  CIP13: '3400936475939',
  ucdLib: "IBUPROFENE EG 200MG CPR",
  UCD7: '9263563',
  UCD13: '3400892635637',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE EG 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '3791841',
  CIP13: '3400937918411',
  ucdLib: "NUROFENPRO 20MG/ML S/S BU150ML",
  UCD7: '9302984',
  UCD13: '3400893029848',
  ucdQtyMultiplicator: 1,
  cipLib: "NUROFENPRO 20MG/ML S/S BU150ML BT 1",
  atcCode: "M01AE01"
}, {
  CIP7: '3475092',
  CIP13: '3400934750922',
  ucdLib: "SPIFEN 400MG BUV SACH3G",
  UCD7: '9246487',
  UCD13: '3400892464879',
  ucdQtyMultiplicator: 20,
  cipLib: "SPIFEN 400MG BUV SACH3G BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3866183',
  CIP13: '3400938661835',
  ucdLib: "IBUPROFENE MYL ENF/BB.BUV200ML",
  UCD7: '9324425',
  UCD13: '3400893244258',
  ucdQtyMultiplicator: 1,
  cipLib: "IBUPROFENE MYL ENF/BB.BUV200ML BT 1",
  atcCode: "M01AE01"
}, {
  CIP7: '3847837',
  CIP13: '3400938478372',
  ucdLib: "IBUPROFENE TVS 400MG CPR",
  UCD7: '9313692',
  UCD13: '3400893136928',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE TVS 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '3841421',
  CIP13: '3400938414219',
  ucdLib: "NUROFEN 200MG CPR",
  UCD7: '9125447',
  UCD13: '3400891254471',
  ucdQtyMultiplicator: 30,
  cipLib: "NUROFEN 200MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '2213384',
  CIP13: '3400922133843',
  ucdLib: "NUROFENCAPS 400MG CAPS BT10",
  UCD7: '9398725',
  UCD13: '3400893987254',
  ucdQtyMultiplicator: 10,
  cipLib: "NUROFENCAPS 400MG CAPS BT10 BT 10",
  atcCode: "M01AE01"
}, {
  CIP7: '4170420',
  CIP13: '3400941704208',
  ucdLib: "IBUPROFENE CRT 400MG CPR",
  UCD7: '9385504',
  UCD13: '3400893855041',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE CRT 400MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '4990100',
  CIP13: '3400949901005',
  ucdLib: "IBUPROFENE NEP 200MG CPR",
  UCD7: '9384321',
  UCD13: '3400893843215',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE NEP 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '4997645',
  CIP13: '3400949976454',
  ucdLib: "IBUPROFENE NEP 400MG CPR",
  UCD7: '9371413',
  UCD13: '3400893714133',
  ucdQtyMultiplicator: 12,
  cipLib: "IBUPROFENE NEP 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '2667518',
  CIP13: '3400926675189',
  ucdLib: "IBUPROFENE TCO 400MG CPR",
  UCD7: '9393900',
  UCD13: '3400893939000',
  ucdQtyMultiplicator: 12,
  cipLib: "IBUPROFENE TCO 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '4992613',
  CIP13: '3400949926138',
  ucdLib: "IBUPROFENE TVC 400MG CPR",
  UCD7: '9371382',
  UCD13: '3400893713822',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE TVC 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '4992636',
  CIP13: '3400949926367',
  ucdLib: "IBUPROFENE TVC 400MG CPR",
  UCD7: '9371382',
  UCD13: '3400893713822',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE TVC 400MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '4175920',
  CIP13: '3400941759208',
  ucdLib: "IBUPROFENE ZF 400MG CPR",
  UCD7: '9383103',
  UCD13: '3400893831038',
  ucdQtyMultiplicator: 12,
  cipLib: "IBUPROFENE ZF 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '4176032',
  CIP13: '3400941760327',
  ucdLib: "NUROFENFLASH 400MG BUV SACH",
  UCD7: '9387940',
  UCD13: '3400893879405',
  ucdQtyMultiplicator: 10,
  cipLib: "NUROFENFLASH 400MG BUV SACH BT 10",
  atcCode: "M01AE01"
}, {
  CIP7: '2802790',
  CIP13: '3400928027900',
  ucdLib: "IBUPRADOLL 200MG CAPS MOL",
  UCD7: '9419634',
  UCD13: '3400894196341',
  ucdQtyMultiplicator: 24,
  cipLib: "IBUPRADOLL 200MG CAPS MOL BT 24",
  atcCode: "M01AE01"
}, {
  CIP7: '2802815',
  CIP13: '3400928028150',
  ucdLib: "IBUPRADOLL 400MG CAPS MOL",
  UCD7: '9419640',
  UCD13: '3400894196402',
  ucdQtyMultiplicator: 10,
  cipLib: "IBUPRADOLL 400MG CAPS MOL BT 10",
  atcCode: "M01AE01"
}, {
  CIP7: '5751780',
  CIP13: '3400957517809',
  ucdLib: "IBUPROFENE ARW 200MG CPR",
  UCD7: '9234521',
  UCD13: '3400892345215',
  ucdQtyMultiplicator: 50,
  cipLib: "IBUPROFENE ARW 200MG CPR BT 50",
  atcCode: "M01AE01"
}, {
  CIP7: '3993266',
  CIP13: '3400939932668',
  ucdLib: "IBUPROFENE AWC 400MG CPR",
  UCD7: '9349365',
  UCD13: '3400893493656',
  ucdQtyMultiplicator: 15,
  cipLib: "IBUPROFENE AWC 400MG CPR BT 15",
  atcCode: "M01AE01"
}, {
  CIP7: '2782018',
  CIP13: '3400927820182',
  ucdLib: "IBUPROFENE MYC 400MG CPR",
  UCD7: '9400422',
  UCD13: '3400894004226',
  ucdQtyMultiplicator: 12,
  cipLib: "IBUPROFENE MYC 400MG CPR BT 12",
  atcCode: "M01AE01"
}, {
  CIP7: '2184547',
  CIP13: '3400921845471',
  ucdLib: "IBUPROFENE ZYF 200MG CPR",
  UCD7: '9385817',
  UCD13: '3400893858172',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE ZYF 200MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '4925367',
  CIP13: '3400949253678',
  ucdLib: "IBUPROFENE ZYF 400MG CPR",
  UCD7: '9355928',
  UCD13: '3400893559284',
  ucdQtyMultiplicator: 20,
  cipLib: "IBUPROFENE ZYF 400MG CPR BT 20",
  atcCode: "M01AE01"
}, {
  CIP7: '4925373',
  CIP13: '3400949253739',
  ucdLib: "IBUPROFENE ZYF 400MG CPR",
  UCD7: '9355928',
  UCD13: '3400893559284',
  ucdQtyMultiplicator: 30,
  cipLib: "IBUPROFENE ZYF 400MG CPR BT 30",
  atcCode: "M01AE01"
}, {
  CIP7: '5660362',
  CIP13: '3400956603626',
  ucdLib: "IBUPROFENE ARW 400MG CPR",
  UCD7: '9269399',
  UCD13: '3400892693996',
  ucdQtyMultiplicator: 50,
  cipLib: "IBUPROFENE ARW 400MG CPR BT 50",
  atcCode: "M01AE01"
}, {
  CIP7: '3396085',
  CIP13: '3400933960858',
  ucdLib: "MOBIC 7,5MG CPR",
  UCD7: '9182244',
  UCD13: '3400891822441',
  ucdQtyMultiplicator: 14,
  cipLib: "MOBIC 7,5MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3539745',
  CIP13: '3400935397454',
  ucdLib: "MOBIC 15MG/1,5ML INJ AMP",
  UCD7: '9221493',
  UCD13: '3400892214931',
  ucdQtyMultiplicator: 3,
  cipLib: "MOBIC 15MG/1,5ML INJ AMP BT 3",
  atcCode: "M01AC06"
}, {
  CIP7: '3709472',
  CIP13: '3400937094726',
  ucdLib: "MELOXICAM TVC 15MG CPR",
  UCD7: '9286854',
  UCD13: '3400892868547',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM TVC 15MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3709408',
  CIP13: '3400937094085',
  ucdLib: "MELOXICAM TVC 7,5MG CPR",
  UCD7: '9286860',
  UCD13: '3400892868608',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM TVC 7,5MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3765507',
  CIP13: '3400937655071',
  ucdLib: "MELOXICAM SDZ 15MG CPR",
  UCD7: '9291200',
  UCD13: '3400892912004',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM SDZ 15MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3389062',
  CIP13: '3400933890629',
  ucdLib: "MOBIC 15MG CPR",
  UCD7: '9182238',
  UCD13: '3400891822380',
  ucdQtyMultiplicator: 14,
  cipLib: "MOBIC 15MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3718264',
  CIP13: '3400937182645',
  ucdLib: "MELOXICAM ZEN 15MG CPR",
  UCD7: '9286877',
  UCD13: '3400892868776',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM ZEN 15MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3718169',
  CIP13: '3400937181693',
  ucdLib: "MELOXICAM ZEN 7,5MG CPR",
  UCD7: '9286883',
  UCD13: '3400892868837',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM ZEN 7,5MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3966358',
  CIP13: '3400939663586',
  ucdLib: "MELOXICAM BGA 15MG CPR",
  UCD7: '9343664',
  UCD13: '3400893436646',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM BGA 15MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3966097',
  CIP13: '3400939660974',
  ucdLib: "MELOXICAM BGA 7,5MG CPR",
  UCD7: '9343670',
  UCD13: '3400893436707',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM BGA 7,5MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3989715',
  CIP13: '3400939897158',
  ucdLib: "MELOXICAM EG 15MG CPR",
  UCD7: '9340134',
  UCD13: '3400893401347',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM EG 15MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3983606',
  CIP13: '3400939836065',
  ucdLib: "MELOXICAM EG 7,5MG CPR",
  UCD7: '9340140',
  UCD13: '3400893401408',
  ucdQtyMultiplicator: 14,
  cipLib: "MELOXICAM EG 7,5MG CPR BT 14",
  atcCode: "M01AC06"
}, {
  CIP7: '3445613',
  CIP13: '3400934456138',
  ucdLib: "TILCOTIL 20MG CPR",
  UCD7: '9124152',
  UCD13: '3400891241525',
  ucdQtyMultiplicator: 15,
  cipLib: "TILCOTIL 20MG CPR BT 15",
  atcCode: "M01AC02"
}, {
  CIP7: '3456918',
  CIP13: '3400934569180',
  ucdLib: "PIROXICAM EG 20MG GELU",
  UCD7: '9215535',
  UCD13: '3400892155357',
  ucdQtyMultiplicator: 15,
  cipLib: "PIROXICAM EG 20MG GELU BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3611566',
  CIP13: '3400936115668',
  ucdLib: "PIROXICAM TVC 20MG GELU",
  UCD7: '9245393',
  UCD13: '3400892453934',
  ucdQtyMultiplicator: 15,
  cipLib: "PIROXICAM TVC 20MG GELU BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3611537',
  CIP13: '3400936115378',
  ucdLib: "PIROXICAM TVC 20MG INJ A.1ML",
  UCD7: '9246636',
  UCD13: '3400892466361',
  ucdQtyMultiplicator: 2,
  cipLib: "PIROXICAM TVC 20MG INJ A.1ML BT 2",
  atcCode: "M01AC01"
}, {
  CIP7: '3286103',
  CIP13: '3400932861033',
  ucdLib: "FELDENE 20MG IM AMP1ML",
  UCD7: '9119926',
  UCD13: '3400891199260',
  ucdQtyMultiplicator: 2,
  cipLib: "FELDENE 20MG IM AMP1ML BT 2",
  atcCode: "M01AC01"
}, {
  CIP7: '3319392',
  CIP13: '3400933193928',
  ucdLib: "FELDENE 20MG DISP. CPR",
  UCD7: '9144002',
  UCD13: '3400891440027',
  ucdQtyMultiplicator: 15,
  cipLib: "FELDENE 20MG DISP. CPR BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3263697',
  CIP13: '3400932636976',
  ucdLib: "FELDENE 20MG GELU",
  UCD7: '9034578',
  UCD13: '3400890345781',
  ucdQtyMultiplicator: 15,
  cipLib: "FELDENE 20MG GELU BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3263823',
  CIP13: '3400932638239',
  ucdLib: "FELDENE 20MG SUP",
  UCD7: '9034584',
  UCD13: '3400890345842',
  ucdQtyMultiplicator: 15,
  cipLib: "FELDENE 20MG SUP BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3242212',
  CIP13: '3400932422128',
  ucdLib: "FELDENE 10MG GELU",
  UCD7: '9034561',
  UCD13: '3400890345613',
  ucdQtyMultiplicator: 30,
  cipLib: "FELDENE 10MG GELU BT 30",
  atcCode: "M01AC01"
}, {
  CIP7: '3607613',
  CIP13: '3400936076136',
  ucdLib: "PIROXICAM MYL 20MG GELU",
  UCD7: '9181380',
  UCD13: '3400891813807',
  ucdQtyMultiplicator: 15,
  cipLib: "PIROXICAM MYL 20MG GELU BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3430132',
  CIP13: '3400934301322',
  ucdLib: "PIROXICAM BGA 10MG GELU",
  UCD7: '9203199',
  UCD13: '3400892031996',
  ucdQtyMultiplicator: 30,
  cipLib: "PIROXICAM BGA 10MG GELU BT 30",
  atcCode: "M01AC01"
}, {
  CIP7: '3430149',
  CIP13: '3400934301490',
  ucdLib: "PIROXICAM BGA 20MG GELU",
  UCD7: '9203006',
  UCD13: '3400892030067',
  ucdQtyMultiplicator: 15,
  cipLib: "PIROXICAM BGA 20MG GELU BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3359598',
  CIP13: '3400933595982',
  ucdLib: "BREXIN 20MG CPR",
  UCD7: '9158441',
  UCD13: '3400891584417',
  ucdQtyMultiplicator: 14,
  cipLib: "BREXIN 20MG CPR BT 14",
  atcCode: "M01AC01"
}, {
  CIP7: '3360957',
  CIP13: '3400933609573',
  ucdLib: "CYCLADOL 20MG CPR",
  UCD7: '9162402',
  UCD13: '3400891624021',
  ucdQtyMultiplicator: 14,
  cipLib: "CYCLADOL 20MG CPR BT 14",
  atcCode: "M01AC01"
}, {
  CIP7: '3396895',
  CIP13: '3400933968953',
  ucdLib: "PIROXICAM PFZ 10MG GELU",
  UCD7: '9328883',
  UCD13: '3400893288832',
  ucdQtyMultiplicator: 30,
  cipLib: "PIROXICAM PFZ 10MG GELU BT 30",
  atcCode: "M01AC01"
}, {
  CIP7: '3396889',
  CIP13: '3400933968892',
  ucdLib: "PIROXICAM PFZ 20MG CPR DISP",
  UCD7: '9328877',
  UCD13: '3400893288771',
  ucdQtyMultiplicator: 15,
  cipLib: "PIROXICAM PFZ 20MG CPR DISP BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3396754',
  CIP13: '3400933967543',
  ucdLib: "PIROXICAM PFZ 20MG INJ A.1ML",
  UCD7: '9328908',
  UCD13: '3400893289082',
  ucdQtyMultiplicator: 2,
  cipLib: "PIROXICAM PFZ 20MG INJ A.1ML BT 2",
  atcCode: "M01AC01"
}, {
  CIP7: '3487770',
  CIP13: '3400934877704',
  ucdLib: "BREXIN 20MG CPR EFFV",
  UCD7: '9212896',
  UCD13: '3400892128962',
  ucdQtyMultiplicator: 14,
  cipLib: "BREXIN 20MG CPR EFFV BT 14",
  atcCode: "M01AC01"
}, {
  CIP7: '3487735',
  CIP13: '3400934877353',
  ucdLib: "CYCLADOL 20MG CPR EFFV",
  UCD7: '9211649',
  UCD13: '3400892116495',
  ucdQtyMultiplicator: 14,
  cipLib: "CYCLADOL 20MG CPR EFFV BT 14",
  atcCode: "M01AC01"
}, {
  CIP7: '3498934',
  CIP13: '3400934989346',
  ucdLib: "PIROXICAM MYL 20MG CPR DISP",
  UCD7: '9213418',
  UCD13: '3400892134185',
  ucdQtyMultiplicator: 15,
  cipLib: "PIROXICAM MYL 20MG CPR DISP BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3643106',
  CIP13: '3400936431065',
  ucdLib: "PIROXICAM ZYD 20MG GELU",
  UCD7: '9262397',
  UCD13: '3400892623979',
  ucdQtyMultiplicator: 15,
  cipLib: "PIROXICAM ZYD 20MG GELU BT 15",
  atcCode: "M01AC01"
}, {
  CIP7: '3424048',
  CIP13: '3400934240485',
  ucdLib: "ZOFORA 20MG/1ML INJ AMP",
  UCD7: '9195672',
  UCD13: '3400891956726',
  ucdQtyMultiplicator: 2,
  cipLib: "ZOFORA 20MG/1ML INJ AMP BT 2",
  atcCode: "M01AC01"
}, {
  CIP7: '3526547',
  CIP13: '3400935265470',
  ucdLib: "ARTOTEC 75MG/0,2MG CPR",
  UCD7: '9220393',
  UCD13: '3400892203935',
  ucdQtyMultiplicator: 20,
  cipLib: "ARTOTEC 75MG/0,2MG CPR BT 20",
  atcCode: "M01AB55"
}, {
  CIP7: '3364926',
  CIP13: '3400933649265',
  ucdLib: "ARTOTEC 50MG/0,2MG CPR",
  UCD7: '9194218',
  UCD13: '3400891942187',
  ucdQtyMultiplicator: 30,
  cipLib: "ARTOTEC 50MG/0,2MG CPR BT 30",
  atcCode: "M01AB55"
}, {
  CIP7: '3456657',
  CIP13: '3400934566578',
  ucdLib: "CARTREX 100MG CPR",
  UCD7: '9249669',
  UCD13: '3400892496696',
  ucdQtyMultiplicator: 30,
  cipLib: "CARTREX 100MG CPR BT 30",
  atcCode: "M01AB16"
}, {
  CIP7: '3002948',
  CIP13: '3400930029480',
  ucdLib: "ACECLOFENAC BGA 100MG CPR",
  UCD7: '9414938',
  UCD13: '3400894149385',
  ucdQtyMultiplicator: 30,
  cipLib: "ACECLOFENAC BGA 100MG CPR BT 30",
  atcCode: "M01AB16"
}, {
  CIP7: '3727984',
  CIP13: '3400937279840',
  ucdLib: "ACECLOFENAC MYL 100MG CPR",
  UCD7: '9288600',
  UCD13: '3400892886008',
  ucdQtyMultiplicator: 30,
  cipLib: "ACECLOFENAC MYL 100MG CPR BT 30",
  atcCode: "M01AB16"
}, {
  CIP7: '3898711',
  CIP13: '3400938987119',
  ucdLib: "ACECLOFENAC EG 100MG CPR",
  UCD7: '9324069',
  UCD13: '3400893240694',
  ucdQtyMultiplicator: 30,
  cipLib: "ACECLOFENAC EG 100MG CPR BT 30",
  atcCode: "M01AB16"
}, {
  CIP7: '4997421',
  CIP13: '3400949974214',
  ucdLib: "ACECLOFENAC ACC 100MG CPR",
  UCD7: '9365944',
  UCD13: '3400893659441',
  ucdQtyMultiplicator: 30,
  cipLib: "ACECLOFENAC ACC 100MG CPR BT 30",
  atcCode: "M01AB16"
}, {
  CIP7: '3285204',
  CIP13: '3400932852048',
  ucdLib: "LODINE 200MG CPR",
  UCD7: '9129505',
  UCD13: '3400891295054',
  ucdQtyMultiplicator: 30,
  cipLib: "LODINE 200MG CPR BT 30",
  atcCode: "M01AB08"
}, {
  CIP7: '3348040',
  CIP13: '3400933480400',
  ucdLib: "LODINE 300MG CPR",
  UCD7: '9154466',
  UCD13: '3400891544664',
  ucdQtyMultiplicator: 20,
  cipLib: "LODINE 300MG CPR BT 20",
  atcCode: "M01AB08"
}, {
  CIP7: '3574115',
  CIP13: '3400935741158',
  ucdLib: "DICLOFENAC ARW 50MG CPR",
  UCD7: '9235555',
  UCD13: '3400892355559',
  ucdQtyMultiplicator: 30,
  cipLib: "DICLOFENAC ARW 50MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3291073',
  CIP13: '3400932910731',
  ucdLib: "DICLOFENAC SDZ 50MG CPR",
  UCD7: '9120912',
  UCD13: '3400891209129',
  ucdQtyMultiplicator: 30,
  cipLib: "DICLOFENAC SDZ 50MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3235117',
  CIP13: '3400932351176',
  ucdLib: "VOLTARENE 50MG CPR",
  UCD7: '9101151',
  UCD13: '3400891011517',
  ucdQtyMultiplicator: 30,
  cipLib: "VOLTARENE 50MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3245222',
  CIP13: '3400932452224',
  ucdLib: "VOLTARENE 75MG INJ AMP3ML",
  UCD7: '9101168',
  UCD13: '3400891011685',
  ucdQtyMultiplicator: 2,
  cipLib: "VOLTARENE 75MG INJ AMP3ML BT 2",
  atcCode: "M01AB05"
}, {
  CIP7: '3246049',
  CIP13: '3400932460496',
  ucdLib: "VOLTARENE LP 100MG CPR",
  UCD7: '9101122',
  UCD13: '3400891011227',
  ucdQtyMultiplicator: 15,
  cipLib: "VOLTARENE LP 100MG CPR BT 15",
  atcCode: "M01AB05"
}, {
  CIP7: '3221434',
  CIP13: '3400932214341',
  ucdLib: "VOLTARENE 100MG SUP",
  UCD7: '9101139',
  UCD13: '3400891011395',
  ucdQtyMultiplicator: 10,
  cipLib: "VOLTARENE 100MG SUP BT 10",
  atcCode: "M01AB05"
}, {
  CIP7: '3436241',
  CIP13: '3400934362415',
  ucdLib: "DICLOFENAC EG 50MG CPR",
  UCD7: '9197671',
  UCD13: '3400891976717',
  ucdQtyMultiplicator: 30,
  cipLib: "DICLOFENAC EG 50MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3526429',
  CIP13: '3400935264299',
  ucdLib: "FLECTOR 50MG BUV GLE SACH",
  UCD7: '9222966',
  UCD13: '3400892229669',
  ucdQtyMultiplicator: 21,
  cipLib: "FLECTOR 50MG BUV GLE SACH BT 21",
  atcCode: "M01AB05"
}, {
  CIP7: '3359204',
  CIP13: '3400933592042',
  ucdLib: "VOLTARENE LP 75MG CPR PVC",
  UCD7: '9168988',
  UCD13: '3400891689884',
  ucdQtyMultiplicator: 30,
  cipLib: "VOLTARENE LP 75MG CPR PVC BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3538869',
  CIP13: '3400935388698',
  ucdLib: "DICLOFENAC CRT 50MG CPR",
  UCD7: '9249273',
  UCD13: '3400892492735',
  ucdQtyMultiplicator: 30,
  cipLib: "DICLOFENAC CRT 50MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3482910',
  CIP13: '3400934829109',
  ucdLib: "DICLOFENAC MYL 50MG CPR",
  UCD7: '9181285',
  UCD13: '3400891812855',
  ucdQtyMultiplicator: 30,
  cipLib: "DICLOFENAC MYL 50MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3513674',
  CIP13: '3400935136749',
  ucdLib: "DICLOFENAC TVC 25MG CPR",
  UCD7: '9249296',
  UCD13: '3400892492964',
  ucdQtyMultiplicator: 30,
  cipLib: "DICLOFENAC TVC 25MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3513680',
  CIP13: '3400935136800',
  ucdLib: "DICLOFENAC TVC 50MG CPR",
  UCD7: '9249304',
  UCD13: '3400892493046',
  ucdQtyMultiplicator: 30,
  cipLib: "DICLOFENAC TVC 50MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3594112',
  CIP13: '3400935941121',
  ucdLib: "VOLTARENDOLO 12,5MG CPR",
  UCD7: '9270712',
  UCD13: '3400892707129',
  ucdQtyMultiplicator: 30,
  cipLib: "VOLTARENDOLO 12,5MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3381445',
  CIP13: '3400933814458',
  ucdLib: "VOLTARENE 25MG CPR",
  UCD7: '9101145',
  UCD13: '3400891011456',
  ucdQtyMultiplicator: 30,
  cipLib: "VOLTARENE 25MG CPR BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '4902768',
  CIP13: '3400949027682',
  ucdLib: "VOLTARENE LP 75 CPR AIPBBAES",
  UCD7: '9405508',
  UCD13: '3400894055082',
  ucdQtyMultiplicator: 30,
  cipLib: "VOLTARENE LP 75 CPR AIPBBAES BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '4900053',
  CIP13: '3400949000531',
  ucdLib: "VOLTARENE LP 75 CPR AIPMWIES",
  UCD7: '9414453',
  UCD13: '3400894144533',
  ucdQtyMultiplicator: 30,
  cipLib: "VOLTARENE LP 75 CPR AIPMWIES BT 30",
  atcCode: "M01AB05"
}, {
  CIP7: '3190633',
  CIP13: '3400931906339',
  ucdLib: "ARTHROCINE 100MG CPR",
  UCD7: '9006808',
  UCD13: '3400890068086',
  ucdQtyMultiplicator: 40,
  cipLib: "ARTHROCINE 100MG CPR BT 40",
  atcCode: "M01AB02"
}, {
  CIP7: '3190656',
  CIP13: '3400931906568',
  ucdLib: "ARTHROCINE 200MG CPR",
  UCD7: '9006814',
  UCD13: '3400890068147',
  ucdQtyMultiplicator: 30,
  cipLib: "ARTHROCINE 200MG CPR BT 30",
  atcCode: "M01AB02"
}, {
  CIP7: '3052575',
  CIP13: '3400930525753',
  ucdLib: "INDOCID 100MG SUP",
  UCD7: '9046133',
  UCD13: '3400890461337',
  ucdQtyMultiplicator: 10,
  cipLib: "INDOCID 100MG SUP BT 10",
  atcCode: "M01AB01"
}, {
  CIP7: '3052569',
  CIP13: '3400930525692',
  ucdLib: "INDOCID 25MG GELU",
  UCD7: '9046156',
  UCD13: '3400890461566',
  ucdQtyMultiplicator: 30,
  cipLib: "INDOCID 25MG GELU BT 30",
  atcCode: "M01AB01"
}, {
  CIP7: '3231013',
  CIP13: '3400932310135',
  ucdLib: "CHRONO-INDOCID 75MG GELU",
  UCD7: '9019461',
  UCD13: '3400890194617',
  ucdQtyMultiplicator: 20,
  cipLib: "CHRONO-INDOCID 75MG GELU BT 20",
  atcCode: "M01AB01"
}, {
  CIP7: '2745796',
  CIP13: '3400927457968',
  ucdLib: "IMNOVID 1MG GELU",
  UCD7: '9395796',
  UCD13: '3400893957967',
  ucdQtyMultiplicator: 21,
  cipLib: "IMNOVID 1MG GELU BT 21",
  atcCode: "L04AX06"
}, {
  CIP7: '2745804',
  CIP13: '3400927458040',
  ucdLib: "IMNOVID 2MG GELU",
  UCD7: '9395804',
  UCD13: '3400893958049',
  ucdQtyMultiplicator: 21,
  cipLib: "IMNOVID 2MG GELU BT 21",
  atcCode: "L04AX06"
}, {
  CIP7: '2745810',
  CIP13: '3400927458101',
  ucdLib: "IMNOVID 3MG GELU",
  UCD7: '9395810',
  UCD13: '3400893958100',
  ucdQtyMultiplicator: 21,
  cipLib: "IMNOVID 3MG GELU BT 21",
  atcCode: "L04AX06"
}, {
  CIP7: '2745827',
  CIP13: '3400927458279',
  ucdLib: "IMNOVID 4MG GELU",
  UCD7: '9395827',
  UCD13: '3400893958278',
  ucdQtyMultiplicator: 21,
  cipLib: "IMNOVID 4MG GELU BT 21",
  atcCode: "L04AX06"
}, {
  CIP7: '4168831',
  CIP13: '3400941688317',
  ucdLib: "ESBRIET 267MG GELU",
  UCD7: '9388365',
  UCD13: '3400893883655',
  ucdQtyMultiplicator: 63,
  cipLib: "ESBRIET 267MG GELU BT 63",
  atcCode: "L04AX05"
}, {
  CIP7: '4168848',
  CIP13: '3400941688485',
  ucdLib: "ESBRIET 267MG GELU",
  UCD7: '9388365',
  UCD13: '3400893883655',
  ucdQtyMultiplicator: 252,
  cipLib: "ESBRIET 267MG GELU BT 252",
  atcCode: "L04AX05"
}, {
  CIP7: '3810231',
  CIP13: '3400938102314',
  ucdLib: "REVLIMID 10MG GELU",
  UCD7: '9298113',
  UCD13: '3400892981130',
  ucdQtyMultiplicator: 21,
  cipLib: "REVLIMID 10MG GELU BT 21",
  atcCode: "L04AX04"
}, {
  CIP7: '3810248',
  CIP13: '3400938102482',
  ucdLib: "REVLIMID 15MG GELU",
  UCD7: '9298136',
  UCD13: '3400892981369',
  ucdQtyMultiplicator: 21,
  cipLib: "REVLIMID 15MG GELU BT 21",
  atcCode: "L04AX04"
}, {
  CIP7: '3810254',
  CIP13: '3400938102543',
  ucdLib: "REVLIMID 25MG GELU",
  UCD7: '9298142',
  UCD13: '3400892981420',
  ucdQtyMultiplicator: 21,
  cipLib: "REVLIMID 25MG GELU BT 21",
  atcCode: "L04AX04"
}, {
  CIP7: '3810225',
  CIP13: '3400938102253',
  ucdLib: "REVLIMID 5MG GELU",
  UCD7: '9298159',
  UCD13: '3400892981598',
  ucdQtyMultiplicator: 21,
  cipLib: "REVLIMID 5MG GELU BT 21",
  atcCode: "L04AX04"
}, {
  CIP7: '2759456',
  CIP13: '3400927594564',
  ucdLib: "REVLIMID 2,5MG GELU",
  UCD7: '9405678',
  UCD13: '3400894056782',
  ucdQtyMultiplicator: 7,
  cipLib: "REVLIMID 2,5MG GELU BT 7",
  atcCode: "L04AX04"
}, {
  CIP7: '2759462',
  CIP13: '3400927594625',
  ucdLib: "REVLIMID 5MG GELU",
  UCD7: '9298159',
  UCD13: '3400892981598',
  ucdQtyMultiplicator: 7,
  cipLib: "REVLIMID 5MG GELU BT 7",
  atcCode: "L04AX04"
}, {
  CIP7: '2756392',
  CIP13: '3400927563928',
  ucdLib: "REVLIMID 2,5MG GELU",
  UCD7: '9405678',
  UCD13: '3400894056782',
  ucdQtyMultiplicator: 21,
  cipLib: "REVLIMID 2,5 mg GꬠPlq/21",
  atcCode: "L04AX04"
}, {
  CIP7: '3001774',
  CIP13: '3400930017746',
  ucdLib: "REVLIMID 20MG GELU",
  UCD7: '9408292',
  UCD13: '3400894082927',
  ucdQtyMultiplicator: 21,
  cipLib: "REVLIMID 20 mg GꬠPlq/21",
  atcCode: "L04AX04"
}, {
  CIP7: '3001772',
  CIP13: '3400930017722',
  ucdLib: "REVLIMID 7,5MG GELU",
  UCD7: '9408300',
  UCD13: '3400894083009',
  ucdQtyMultiplicator: 21,
  cipLib: "REVLIMID 7,5 mg GꬠPlq/21",
  atcCode: "L04AX04"
}, {
  CIP7: '3001634',
  CIP13: '3400930016343',
  ucdLib: "IMETH 10MG/0,4ML INJ SRG",
  UCD7: '9412299',
  UCD13: '3400894122999',
  ucdQtyMultiplicator: 4,
  cipLib: "IMETH 10MG/0,4ML INJ SRG BT 4",
  atcCode: "L04AX03"
}, {
  CIP7: '3001636',
  CIP13: '3400930016367',
  ucdLib: "IMETH 12,5MG/0,5ML INJ SRG",
  UCD7: '9412307',
  UCD13: '3400894123071',
  ucdQtyMultiplicator: 4,
  cipLib: "IMETH 12,5MG/0,5ML INJ SRG BT 4",
  atcCode: "L04AX03"
}, {
  CIP7: '3001638',
  CIP13: '3400930016381',
  ucdLib: "IMETH 15MG/0,6ML INJ SRG",
  UCD7: '9412313',
  UCD13: '3400894123132',
  ucdQtyMultiplicator: 4,
  cipLib: "IMETH 15MG/0,6ML INJ SRG BT 4",
  atcCode: "L04AX03"
}, {
  CIP7: '3001640',
  CIP13: '3400930016404',
  ucdLib: "IMETH 17,5MG/0,7ML INJ SRG",
  UCD7: '9412336',
  UCD13: '3400894123361',
  ucdQtyMultiplicator: 4,
  cipLib: "IMETH 17,5MG/0,7ML INJ SRG BT 4",
  atcCode: "L04AX03"
}, {
  CIP7: '3001642',
  CIP13: '3400930016428',
  ucdLib: "IMETH 20MG/0,8ML INJ SRG",
  UCD7: '9412342',
  UCD13: '3400894123422',
  ucdQtyMultiplicator: 4,
  cipLib: "IMETH 20MG/0,8ML INJ SRG BT 4",
  atcCode: "L04AX03"
}, {
  CIP7: '3001644',
  CIP13: '3400930016442',
  ucdLib: "IMETH 22,5MG/0,9ML INJ SRG",
  UCD7: '9412359',
  UCD13: '3400894123590',
  ucdQtyMultiplicator: 4,
  cipLib: "IMETH 22,5MG/0,9ML INJ SRG BT 4",
  atcCode: "L04AX03"
}, {
  CIP7: '3001646',
  CIP13: '3400930016466',
  ucdLib: "IMETH 25MG/1ML INJ SRG",
  UCD7: '9412365',
  UCD13: '3400894123651',
  ucdQtyMultiplicator: 4,
  cipLib: "IMETH 25MG/1ML INJ SRG BT 4",
  atcCode: "L04AX03"
}, {
  CIP7: '3001631',
  CIP13: '3400930016312',
  ucdLib: "IMETH 7,5MG/0,3ML INJ SRG",
  UCD7: '9412371',
  UCD13: '3400894123712',
  ucdQtyMultiplicator: 4,
  cipLib: "IMETH 7,5MG/0,3ML INJ SRG BT 4",
  atcCode: "L04AX03"
}, {
  CIP7: '3002025',
  CIP13: '3400930020258',
  ucdLib: "METOJECT 10MG/0,2ML STYL.+N",
  UCD7: '9418818',
  UCD13: '3400894188186',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 10MG/0,2ML STYL.+N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002029',
  CIP13: '3400930020296',
  ucdLib: "METOJECT 12,5MG/0,25ML STYL+N",
  UCD7: '9418824',
  UCD13: '3400894188247',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 12,5MG/0,25ML STYL+N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002032',
  CIP13: '3400930020326',
  ucdLib: "METOJECT 15MG/0,3ML STYL.+N",
  UCD7: '9418830',
  UCD13: '3400894188308',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 15MG/0,3ML STYL.+N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002036',
  CIP13: '3400930020364',
  ucdLib: "METOJECT 17,5MG/0,35ML STYL+N",
  UCD7: '9418847',
  UCD13: '3400894188476',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 17,5MG/0,35ML STYL+N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002039',
  CIP13: '3400930020395',
  ucdLib: "METOJECT 20MG/0,40ML STYL.+N",
  UCD7: '9418853',
  UCD13: '3400894188537',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 20MG/0,40ML STYL.+N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002043',
  CIP13: '3400930020432',
  ucdLib: "METOJECT 22,5MG/0,45ML STYL+N",
  UCD7: '9418876',
  UCD13: '3400894188766',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 22,5MG/0,45ML STYL+N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002046',
  CIP13: '3400930020463',
  ucdLib: "METOJECT 25MG/0,50ML STYL +N",
  UCD7: '9418882',
  UCD13: '3400894188827',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 25MG/0,50ML STYL +N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002049',
  CIP13: '3400930020494',
  ucdLib: "METOJECT 27,5MG/0,55ML STYL+N",
  UCD7: '9418899',
  UCD13: '3400894188995',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 27,5MG/0,55ML STYL+N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002052',
  CIP13: '3400930020524',
  ucdLib: "METOJECT 30MG/0,60ML STYL +N",
  UCD7: '9418907',
  UCD13: '3400894189077',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 30MG/0,60ML STYL +N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3002019',
  CIP13: '3400930020197',
  ucdLib: "METOJECT 7,5MG/0,15ML STYL.+N",
  UCD7: '9418913',
  UCD13: '3400894189138',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 7,5MG/0,15ML STYL.+N BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '3349826',
  CIP13: '3400933498269',
  ucdLib: "NOVATREX 2,5MG CPR",
  UCD7: '9175770',
  UCD13: '3400891757705',
  ucdQtyMultiplicator: 12,
  cipLib: "NOVATREX 2,5MG CPR BT 12",
  atcCode: "L04AX03"
}, {
  CIP7: '3897404',
  CIP13: '3400938974041',
  ucdLib: "IMETH 10MG CPR",
  UCD7: '9352628',
  UCD13: '3400893526286',
  ucdQtyMultiplicator: 10,
  cipLib: "IMETH 10MG CPR BT 10",
  atcCode: "L04AX03"
}, {
  CIP7: '3898415',
  CIP13: '3400938984156',
  ucdLib: "IMETH 2,5MG CPR",
  UCD7: '9330443',
  UCD13: '3400893304433',
  ucdQtyMultiplicator: 24,
  cipLib: "IMETH 2,5MG CPR BT 24",
  atcCode: "L04AX03"
}, {
  CIP7: '2688905',
  CIP13: '3400926889050',
  ucdLib: "METOJECT 10MG/0,2ML SRG+A.+T",
  UCD7: '9392148',
  UCD13: '3400893921487',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 10MG/0,2ML SRG+A.+T BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '2677497',
  CIP13: '3400926774974',
  ucdLib: "METOJECT 15MG/0,3ML SRG+A.+T",
  UCD7: '9392154',
  UCD13: '3400893921548',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 15MG/0,3ML SRG+A.+T BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '2688940',
  CIP13: '3400926889401',
  ucdLib: "METOJECT 20MG/0,4ML SRG+A.+T",
  UCD7: '9392160',
  UCD13: '3400893921609',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 20MG/0,4ML SRG+A.+T BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '2688992',
  CIP13: '3400926889920',
  ucdLib: "METOJECT 25MG/0,5ML SRG+A.+T",
  UCD7: '9392177',
  UCD13: '3400893921777',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 25MG/0,5ML SRG+A.+T BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '2688868',
  CIP13: '3400926888688',
  ucdLib: "METOJECT 7,5MG/0,15ML S.+A+T",
  UCD7: '9392183',
  UCD13: '3400893921838',
  ucdQtyMultiplicator: 1,
  cipLib: "METOJECT 7,5MG/0,15ML S.+A+T BT 1",
  atcCode: "L04AX03"
}, {
  CIP7: '5726776',
  CIP13: '3400957267766',
  ucdLib: "THALIDOMIDE CLG 50MG GELU",
  UCD7: '9330963',
  UCD13: '3400893309636',
  ucdQtyMultiplicator: 28,
  cipLib: "THALIDOMIDE CLG 50MG GELU BT 28",
  atcCode: "L04AX02"
}, {
  CIP7: '3854990',
  CIP13: '3400938549904',
  ucdLib: "AZATHIOPRINE EG 50MG CPR",
  UCD7: '9318353',
  UCD13: '3400893183533',
  ucdQtyMultiplicator: 100,
  cipLib: "AZATHIOPRINE EG 50MG CPR BT 100",
  atcCode: "L04AX01"
}, {
  CIP7: '3545131',
  CIP13: '3400935451316',
  ucdLib: "AZATHIOPRINE MYL 50MG CPR",
  UCD7: '9227797',
  UCD13: '3400892277974',
  ucdQtyMultiplicator: 100,
  cipLib: "AZATHIOPRINE MYL 50MG CPR BT 100",
  atcCode: "L04AX01"
}, {
  CIP7: '3792007',
  CIP13: '3400937920070',
  ucdLib: "AZATHIOPRINE TVC 50MG CPR",
  UCD7: '9302659',
  UCD13: '3400893026595',
  ucdQtyMultiplicator: 100,
  cipLib: "AZATHIOPRINE TVC 50MG CPR BT 100",
  atcCode: "L04AX01"
}, {
  CIP7: '3641432',
  CIP13: '3400936414327',
  ucdLib: "IMUREL 25MG CPR PELLIC",
  UCD7: '9270729',
  UCD13: '3400892707297',
  ucdQtyMultiplicator: 50,
  cipLib: "IMUREL 25MG CPR PELLIC BT 50",
  atcCode: "L04AX01"
}, {
  CIP7: '3641490',
  CIP13: '3400936414907',
  ucdLib: "IMUREL 50MG CPR PELLIC",
  UCD7: '9270847',
  UCD13: '3400892708478',
  ucdQtyMultiplicator: 100,
  cipLib: "IMUREL 50MG CPR PELLIC BT 100",
  atcCode: "L04AX01"
}, {
  CIP7: '5619365',
  CIP13: '3400956193653',
  ucdLib: "IMUREL 50MG INJ FL",
  UCD7: '9210271',
  UCD13: '3400892102719',
  ucdQtyMultiplicator: 1,
  cipLib: "IMUREL 50MG INJ FL BT 1",
  atcCode: "L04AX01"
}, {
  CIP7: '3000929',
  CIP13: '3400930009291',
  ucdLib: "ADOPORT 2MG GELU",
  UCD7: '9410685',
  UCD13: '3400894106852',
  ucdQtyMultiplicator: 50,
  cipLib: "ADOPORT 2MG GELU BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '3000119',
  CIP13: '3400930001196',
  ucdLib: "ENVARSUS 0,75MG CPR LP",
  UCD7: '9408168',
  UCD13: '3400894081685',
  ucdQtyMultiplicator: 30,
  cipLib: "ENVARSUS 0,75MG CPR LP BT 30",
  atcCode: "L04AD02"
}, {
  CIP7: '3000122',
  CIP13: '3400930001226',
  ucdLib: "ENVARSUS 1MG CPR LP",
  UCD7: '9408174',
  UCD13: '3400894081746',
  ucdQtyMultiplicator: 30,
  cipLib: "ENVARSUS 1MG CPR LP BT 30",
  atcCode: "L04AD02"
}, {
  CIP7: '3000126',
  CIP13: '3400930001264',
  ucdLib: "ENVARSUS 4MG CPR LP",
  UCD7: '9408180',
  UCD13: '3400894081807',
  ucdQtyMultiplicator: 30,
  cipLib: "ENVARSUS 4MG CPR LP BT 30",
  atcCode: "L04AD02"
}, {
  CIP7: '5588742',
  CIP13: '3400955887423',
  ucdLib: "PROGRAF 5MG/1ML INJ AMP",
  UCD7: '9180044',
  UCD13: '3400891800449',
  ucdQtyMultiplicator: 10,
  cipLib: "PROGRAF 5MG/1ML INJ AMP BT 10",
  atcCode: "L04AD02"
}, {
  CIP7: '3589588',
  CIP13: '3400935895882',
  ucdLib: "PROGRAF 0,5MG GELU",
  UCD7: '9202679',
  UCD13: '3400892026794',
  ucdQtyMultiplicator: 50,
  cipLib: "PROGRAF 0,5MG GELU BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '3589571',
  CIP13: '3400935895714',
  ucdLib: "PROGRAF 1MG GELU",
  UCD7: '9180021',
  UCD13: '3400891800210',
  ucdQtyMultiplicator: 50,
  cipLib: "PROGRAF 1MG GELU BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '3587572',
  CIP13: '3400935875723',
  ucdLib: "PROGRAF 5MG GELU",
  UCD7: '9180038',
  UCD13: '3400891800388',
  ucdQtyMultiplicator: 50,
  cipLib: "PROGRAF 5MG GELU BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '3741547',
  CIP13: '3400937415477',
  ucdLib: "ADOPORT 0,5MG GELU",
  UCD7: '9389838',
  UCD13: '3400893898383',
  ucdQtyMultiplicator: 50,
  cipLib: "ADOPORT 0,5MG GELU BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '3748532',
  CIP13: '3400937485326',
  ucdLib: "ADOPORT 1MG GELU",
  UCD7: '9389844',
  UCD13: '3400893898444',
  ucdQtyMultiplicator: 50,
  cipLib: "ADOPORT 1MG GELU BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '3748561',
  CIP13: '3400937485616',
  ucdLib: "ADOPORT 5MG GELU",
  UCD7: '9389850',
  UCD13: '3400893898505',
  ucdQtyMultiplicator: 50,
  cipLib: "ADOPORT 5MG GELU BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '3806927',
  CIP13: '3400938069273',
  ucdLib: "ADVAGRAF 0,5MG GELU LP",
  UCD7: '9309294',
  UCD13: '3400893092941',
  ucdQtyMultiplicator: 30,
  cipLib: "ADVAGRAF 0,5MG GELU LP BT 30",
  atcCode: "L04AD02"
}, {
  CIP7: '3806962',
  CIP13: '3400938069624',
  ucdLib: "ADVAGRAF 1MG GELU LP",
  UCD7: '9309302',
  UCD13: '3400893093023',
  ucdQtyMultiplicator: 30,
  cipLib: "ADVAGRAF 1MG GELU LP BT 30",
  atcCode: "L04AD02"
}, {
  CIP7: '3806991',
  CIP13: '3400938069914',
  ucdLib: "ADVAGRAF 5MG GELU LP",
  UCD7: '9309319',
  UCD13: '3400893093191',
  ucdQtyMultiplicator: 30,
  cipLib: "ADVAGRAF 5MG GELU LP BT 30",
  atcCode: "L04AD02"
}, {
  CIP7: '3953462',
  CIP13: '3400939534626',
  ucdLib: "ADVAGRAF 3MG GELU LP",
  UCD7: '9333192',
  UCD13: '3400893331927',
  ucdQtyMultiplicator: 30,
  cipLib: "ADVAGRAF 3MG GELU LP BT 30",
  atcCode: "L04AD02"
}, {
  CIP7: '3959482',
  CIP13: '3400939594828',
  ucdLib: "MODIGRAF 0,2MG GLE BUV SACH",
  UCD7: '9348472',
  UCD13: '3400893484722',
  ucdQtyMultiplicator: 50,
  cipLib: "MODIGRAF 0,2MG GLE BUV SACH BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '3959499',
  CIP13: '3400939594996',
  ucdLib: "MODIGRAF 1MG GLE BUV SACH",
  UCD7: '9348489',
  UCD13: '3400893484890',
  ucdQtyMultiplicator: 50,
  cipLib: "MODIGRAF 1MG GLE BUV SACH BT 50",
  atcCode: "L04AD02"
}, {
  CIP7: '5545796',
  CIP13: '3400955457961',
  ucdLib: "SANDIMMUN INJ AMP1ML",
  UCD7: '9082092',
  UCD13: '3400890820929',
  ucdQtyMultiplicator: 10,
  cipLib: "SANDIMMUN INJ AMP1ML BT 10",
  atcCode: "L04AD01"
}, {
  CIP7: '5545804',
  CIP13: '3400955458043',
  ucdLib: "SANDIMMUN INJ AMP5ML",
  UCD7: '9082100',
  UCD13: '3400890821001',
  ucdQtyMultiplicator: 10,
  cipLib: "SANDIMMUN INJ AMP5ML BT 10",
  atcCode: "L04AD01"
}, {
  CIP7: '3463060',
  CIP13: '3400934630606',
  ucdLib: "NEORAL 100MG CAPS",
  UCD7: '9179963',
  UCD13: '3400891799637',
  ucdQtyMultiplicator: 60,
  cipLib: "NEORAL 100MG CAPS BT 60",
  atcCode: "L04AD01"
}, {
  CIP7: '3463315',
  CIP13: '3400934633157',
  ucdLib: "NEORAL 100MG/ML BUV FL50ML",
  UCD7: '9179992',
  UCD13: '3400891799927',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORAL 100MG/ML BUV FL50ML BT 1",
  atcCode: "L04AD01"
}, {
  CIP7: '3463077',
  CIP13: '3400934630774',
  ucdLib: "NEORAL 10MG CAPS",
  UCD7: '9211980',
  UCD13: '3400892119809',
  ucdQtyMultiplicator: 60,
  cipLib: "NEORAL 10MG CAPS BT 60",
  atcCode: "L04AD01"
}, {
  CIP7: '3463048',
  CIP13: '3400934630484',
  ucdLib: "NEORAL 25MG CAPS",
  UCD7: '9180009',
  UCD13: '3400891800098',
  ucdQtyMultiplicator: 60,
  cipLib: "NEORAL 25MG CAPS BT 60",
  atcCode: "L04AD01"
}, {
  CIP7: '3463054',
  CIP13: '3400934630545',
  ucdLib: "NEORAL 50MG CAPS",
  UCD7: '9180015',
  UCD13: '3400891800159',
  ucdQtyMultiplicator: 60,
  cipLib: "NEORAL 50MG CAPS BT 60",
  atcCode: "L04AD01"
}, {
  CIP7: '3006079',
  CIP13: '3400930060797',
  ucdLib: "TALTZ 80MG INJ SRG1ML",
  UCD7: '9418681',
  UCD13: '3400894186816',
  ucdQtyMultiplicator: 1,
  cipLib: "TALTZ 80MG INJ SRG1ML BT 1",
  atcCode: "L04AC13"
}, {
  CIP7: '3006075',
  CIP13: '3400930060759',
  ucdLib: "TALTZ 80MG INJ STYLO1ML",
  UCD7: '9418698',
  UCD13: '3400894186984',
  ucdQtyMultiplicator: 1,
  cipLib: "TALTZ 80MG INJ STYLO1ML BT 1",
  atcCode: "L04AC13"
}, {
  CIP7: '5869168',
  CIP13: '3400958691683',
  ucdLib: "SYLVANT 100MG PERF FL",
  UCD7: '9409908',
  UCD13: '3400894099086',
  ucdQtyMultiplicator: 1,
  cipLib: "SYLVANT 100MG PERF FL BT 1",
  atcCode: "L04AC11"
}, {
  CIP7: '5869174',
  CIP13: '3400958691744',
  ucdLib: "SYLVANT 400MG PERF FL",
  UCD7: '9409914',
  UCD13: '3400894099147',
  ucdQtyMultiplicator: 1,
  cipLib: "SYLVANT 400MG PERF FL BT 1",
  atcCode: "L04AC11"
}, {
  CIP7: '3001060',
  CIP13: '3400930010600',
  ucdLib: "COSENTYX 150MG INJ SRG1ML",
  UCD7: '9410604',
  UCD13: '3400894106043',
  ucdQtyMultiplicator: 1,
  cipLib: "COSENTYX 150MG INJ SRG1ML BT 1",
  atcCode: "L04AC10"
}, {
  CIP7: '3001061',
  CIP13: '3400930010617',
  ucdLib: "COSENTYX 150MG INJ SRG1ML",
  UCD7: '9410604',
  UCD13: '3400894106043',
  ucdQtyMultiplicator: 2,
  cipLib: "COSENTYX 150MG INJ SRG1ML BT 2",
  atcCode: "L04AC10"
}, {
  CIP7: '3001062',
  CIP13: '3400930010624',
  ucdLib: "COSENTYX 150MG INJ STY1ML",
  UCD7: '9410610',
  UCD13: '3400894106104',
  ucdQtyMultiplicator: 1,
  cipLib: "COSENTYX 150MG INJ STY1ML BT 1",
  atcCode: "L04AC10"
}, {
  CIP7: '3001063',
  CIP13: '3400930010631',
  ucdLib: "COSENTYX 150MG INJ STY1ML",
  UCD7: '9410610',
  UCD13: '3400894106104',
  ucdQtyMultiplicator: 2,
  cipLib: "COSENTYX 150MG INJ STY1ML BT 2",
  atcCode: "L04AC10"
}, {
  CIP7: '2178759',
  CIP13: '3400921787597',
  ucdLib: "ILARIS 150MG INJ FL+FL +NEC",
  UCD7: '9378183',
  UCD13: '3400893781838',
  ucdQtyMultiplicator: 1,
  cipLib: "ILARIS 150MG INJ FL+FL +NEC BT 1",
  atcCode: "L04AC08"
}, {
  CIP7: '2782484',
  CIP13: '3400927824845',
  ucdLib: "ROACTEMRA 162MG INJ SRG0,9ML",
  UCD7: '9404377',
  UCD13: '3400894043775',
  ucdQtyMultiplicator: 4,
  cipLib: "ROACTEMRA 162MG INJ SRG0,9ML BT 4",
  atcCode: "L04AC07"
}, {
  CIP7: '5746448',
  CIP13: '3400957464486',
  ucdLib: "ROACTEMRA 20MG/ML INJ FL10ML",
  UCD7: '9331879',
  UCD13: '3400893318799',
  ucdQtyMultiplicator: 1,
  cipLib: "ROACTEMRA 20MG/ML INJ FL10ML BT 1",
  atcCode: "L04AC07"
}, {
  CIP7: '5746454',
  CIP13: '3400957464547',
  ucdLib: "ROACTEMRA 20MG/ML INJ FL20ML",
  UCD7: '9331885',
  UCD13: '3400893318850',
  ucdQtyMultiplicator: 1,
  cipLib: "ROACTEMRA 20MG/ML INJ FL20ML BT 1",
  atcCode: "L04AC07"
}, {
  CIP7: '5746431',
  CIP13: '3400957464318',
  ucdLib: "ROACTEMRA 20MG/ML INJ FL4ML",
  UCD7: '9331891',
  UCD13: '3400893318911',
  ucdQtyMultiplicator: 1,
  cipLib: "ROACTEMRA 20MG/ML INJ FL4ML BT 1",
  atcCode: "L04AC07"
}, {
  CIP7: '3748489',
  CIP13: '3400937484893',
  ucdLib: "STELARA 45MG INJ SRG0,5ML",
  UCD7: '9351787',
  UCD13: '3400893517871',
  ucdQtyMultiplicator: 1,
  cipLib: "STELARA 45MG INJ SRG0,5ML BT 1",
  atcCode: "L04AC05"
}, {
  CIP7: '3748495',
  CIP13: '3400937484954',
  ucdLib: "STELARA 90MG INJ SRG1ML",
  UCD7: '9351793',
  UCD13: '3400893517932',
  ucdQtyMultiplicator: 1,
  cipLib: "STELARA 90MG INJ SRG1ML BT 1",
  atcCode: "L04AC05"
}, {
  CIP7: '3925862',
  CIP13: '3400939258621',
  ucdLib: "STELARA 45MG INJ FL0,5ML",
  UCD7: '9328096',
  UCD13: '3400893280966',
  ucdQtyMultiplicator: 1,
  cipLib: "STELARA 45MG INJ FL0,5ML BT 1",
  atcCode: "L04AC05"
}, {
  CIP7: '2773203',
  CIP13: '3400927732034',
  ucdLib: "KINERET 100MG/0,67ML INJ SRG",
  UCD7: '9406577',
  UCD13: '3400894065777',
  ucdQtyMultiplicator: 7,
  cipLib: "KINERET 100MG/0,67ML INJ SRG BT 7",
  atcCode: "L04AC03"
}, {
  CIP7: '5618928',
  CIP13: '3400956189281',
  ucdLib: "SIMULECT 20MG INJ FL+AMP",
  UCD7: '9208340',
  UCD13: '3400892083407',
  ucdQtyMultiplicator: 1,
  cipLib: "SIMULECT 20MG INJ FL+AMP BT 1",
  atcCode: "L04AC02"
}, {
  CIP7: '5645121',
  CIP13: '3400956451210',
  ucdLib: "SIMULECT 10MG INJ FL+AMP",
  UCD7: '9250796',
  UCD13: '3400892507965',
  ucdQtyMultiplicator: 1,
  cipLib: "SIMULECT 10MG INJ FL+AMP BT 1",
  atcCode: "L04AC02"
}, {
  CIP7: '3973097',
  CIP13: '3400939730974',
  ucdLib: "SIMPONI 50MG INJ SRG0,5ML",
  UCD7: '9377120',
  UCD13: '3400893771204',
  ucdQtyMultiplicator: 1,
  cipLib: "SIMPONI 50MG INJ SRG0,5ML BT 1",
  atcCode: "L04AB06"
}, {
  CIP7: '3973074',
  CIP13: '3400939730745',
  ucdLib: "SIMPONI 50MG INJ STY0,5ML",
  UCD7: '9377137',
  UCD13: '3400893771372',
  ucdQtyMultiplicator: 1,
  cipLib: "SIMPONI 50MG INJ STY0,5ML BT 1",
  atcCode: "L04AB06"
}, {
  CIP7: '2756848',
  CIP13: '3400927568480',
  ucdLib: "SIMPONI 100MG INJ SRG1ML",
  UCD7: '9398748',
  UCD13: '3400893987483',
  ucdQtyMultiplicator: 1,
  cipLib: "SIMPONI 100MG INJ SRG1ML BT 1",
  atcCode: "L04AB06"
}, {
  CIP7: '2756831',
  CIP13: '3400927568312',
  ucdLib: "SIMPONI 100MG INJ STY1ML",
  UCD7: '9398754',
  UCD13: '3400893987544',
  ucdQtyMultiplicator: 1,
  cipLib: "SIMPONI 100MG INJ STY1ML BT 1",
  atcCode: "L04AB06"
}, {
  CIP7: '3973200',
  CIP13: '3400939732008',
  ucdLib: "CIMZIA 200MG INJ SRG1ML",
  UCD7: '9342601',
  UCD13: '3400893426012',
  ucdQtyMultiplicator: 2,
  cipLib: "CIMZIA 200MG INJ SRG1ML BT 2",
  atcCode: "L04AB05"
}, {
  CIP7: '3004248',
  CIP13: '3400930042489',
  ucdLib: "HUMIRA 40MG INJ SRG0,4ML +T.",
  UCD7: '9416618',
  UCD13: '3400894166184',
  ucdQtyMultiplicator: 2,
  cipLib: "HUMIRA 40MG INJ SRG0,4ML +T. BT 2",
  atcCode: "L04AB04"
}, {
  CIP7: '3004268',
  CIP13: '3400930042687',
  ucdLib: "HUMIRA 40MG INJ STY0,4ML +T.",
  UCD7: '9416630',
  UCD13: '3400894166306',
  ucdQtyMultiplicator: 2,
  cipLib: "HUMIRA 40MG INJ STY0,4ML +T. BT 2",
  atcCode: "L04AB04"
}, {
  CIP7: '3622305',
  CIP13: '3400936223059',
  ucdLib: "HUMIRA 40MG INJ SRG0,8ML +T.",
  UCD7: '9251092',
  UCD13: '3400892510927',
  ucdQtyMultiplicator: 2,
  cipLib: "HUMIRA 40MG INJ SRG0,8ML +T. BT 2",
  atcCode: "L04AB04"
}, {
  CIP7: '3780145',
  CIP13: '3400937801454',
  ucdLib: "HUMIRA 40MG INJ STY0,8ML +T.",
  UCD7: '9307562',
  UCD13: '3400893075623',
  ucdQtyMultiplicator: 2,
  cipLib: "HUMIRA 40MG INJ STY0,8ML +T. BT 2",
  atcCode: "L04AB04"
}, {
  CIP7: '4185172',
  CIP13: '3400941851728',
  ucdLib: "HUMIRA 40MG INJ FL0,8ML +NEC",
  UCD7: '9368664',
  UCD13: '3400893686645',
  ucdQtyMultiplicator: 2,
  cipLib: "HUMIRA 40MG INJ FL0,8ML +NEC BT 2",
  atcCode: "L04AB04"
}, {
  CIP7: '5867620',
  CIP13: '3400958676208',
  ucdLib: "REMSIMA 100MG PERF FL",
  UCD7: '9402303',
  UCD13: '3400894023036',
  ucdQtyMultiplicator: 1,
  cipLib: "REMSIMA 100MG PERF FL BT 1",
  atcCode: "L04AB02"
}, {
  CIP7: '5620701',
  CIP13: '3400956207015',
  ucdLib: "REMICADE 100MG PERF FL",
  UCD7: '9213737',
  UCD13: '3400892137377',
  ucdQtyMultiplicator: 1,
  cipLib: "REMICADE 100MG PERF FL BT 1",
  atcCode: "L04AB02"
}, {
  CIP7: '5859804',
  CIP13: '3400958598043',
  ucdLib: "INFLECTRA 100MG PERF FL",
  UCD7: '9398352',
  UCD13: '3400893983522',
  ucdQtyMultiplicator: 1,
  cipLib: "INFLECTRA 100MG PERF FL BT 1",
  atcCode: "L04AB02"
}, {
  CIP7: '3004459',
  CIP13: '3400930044599',
  ucdLib: "BENEPALI 50MG INJ SRG0,98ML",
  UCD7: '9416653',
  UCD13: '3400894166535',
  ucdQtyMultiplicator: 4,
  cipLib: "BENEPALI 50MG INJ SRG0,98ML BT 4",
  atcCode: "L04AB01"
}, {
  CIP7: '3004460',
  CIP13: '3400930044605',
  ucdLib: "BENEPALI 50MG INJ STYLO",
  UCD7: '9416676',
  UCD13: '3400894166764',
  ucdQtyMultiplicator: 4,
  cipLib: "BENEPALI 50MG INJ STYLO BT 4",
  atcCode: "L04AB01"
}, {
  CIP7: '3606499',
  CIP13: '3400936064997',
  ucdLib: "ENBREL 25MG INJ FL+SRG +NEC",
  UCD7: '9242615',
  UCD13: '3400892426150',
  ucdQtyMultiplicator: 4,
  cipLib: "ENBREL 25MG INJ FL+SRG +NEC BT 4",
  atcCode: "L04AB01"
}, {
  CIP7: '3771910',
  CIP13: '3400937719100',
  ucdLib: "ENBREL 25MG INJ SRG0,5ML +NEC",
  UCD7: '9295853',
  UCD13: '3400892958538',
  ucdQtyMultiplicator: 4,
  cipLib: "ENBREL 25MG INJ SRG0,5ML +NEC BT 4",
  atcCode: "L04AB01"
}, {
  CIP7: '3771956',
  CIP13: '3400937719568',
  ucdLib: "ENBREL 50MG INJ SRG1ML +NEC",
  UCD7: '9295882',
  UCD13: '3400892958828',
  ucdQtyMultiplicator: 4,
  cipLib: "ENBREL 50MG INJ SRG1ML +NEC BT 4",
  atcCode: "L04AB01"
}, {
  CIP7: '3960522',
  CIP13: '3400939605227',
  ucdLib: "ENBREL 50MG INJ STY1ML +TAMP",
  UCD7: '9341725',
  UCD13: '3400893417256',
  ucdQtyMultiplicator: 4,
  cipLib: "ENBREL 50MG INJ STY1ML +TAMP BT 4",
  atcCode: "L04AB01"
}, {
  CIP7: '2167632',
  CIP13: '3400921676327',
  ucdLib: "ENBREL 10MG PEDIA FL+SRG +N",
  UCD7: '9391048',
  UCD13: '3400893910481',
  ucdQtyMultiplicator: 4,
  cipLib: "ENBREL 10MG PEDIA FL+SRG +N BT 4",
  atcCode: "L04AB01"
}, {
  CIP7: '5856734',
  CIP13: '3400958567346',
  ucdLib: "LEMTRADA 12MG PERF FL1,2ML",
  UCD7: '9396985',
  UCD13: '3400893969854',
  ucdQtyMultiplicator: 1,
  cipLib: "LEMTRADA 12MG PERF FL1,2ML BT 1",
  atcCode: "L04AA34"
}, {
  CIP7: '5867287',
  CIP13: '3400958672873',
  ucdLib: "ENTYVIO 300MG PERF FL20ML",
  UCD7: '9402059',
  UCD13: '3400894020592',
  ucdQtyMultiplicator: 1,
  cipLib: "ENTYVIO 300MG PERF FL20ML BT 1",
  atcCode: "L04AA33"
}, {
  CIP7: '3000888',
  CIP13: '3400930008881',
  ucdLib: "OTEZLA 10MG/20MG/30MG CPR",
  UCD7: '9408263',
  UCD13: '3400894082637',
  ucdQtyMultiplicator: 27,
  cipLib: "OTEZLA 10MG/20MG/30MG CPR BT 27",
  atcCode: "L04AA32"
}, {
  CIP7: '3000889',
  CIP13: '3400930008898',
  ucdLib: "OTEZLA 30MG CPR",
  UCD7: '9408518',
  UCD13: '3400894085188',
  ucdQtyMultiplicator: 56,
  cipLib: "OTEZLA 30MG CPR BT 56",
  atcCode: "L04AA32"
}, {
  CIP7: '2749989',
  CIP13: '3400927499890',
  ucdLib: "AUBAGIO 14MG CPR PELLIC",
  UCD7: '9395661',
  UCD13: '3400893956618',
  ucdQtyMultiplicator: 28,
  cipLib: "AUBAGIO 14MG CPR PELLIC BT 28",
  atcCode: "L04AA31"
}, {
  CIP7: '5804157',
  CIP13: '3400958041570',
  ucdLib: "NULOJIX 250MG PERF FL+SRG",
  UCD7: '9373607',
  UCD13: '3400893736074',
  ucdQtyMultiplicator: 1,
  cipLib: "NULOJIX 250MG PERF FL+SRG BT 1",
  atcCode: "L04AA28"
}, {
  CIP7: '4177853',
  CIP13: '3400941778537',
  ucdLib: "GILENYA 0,5MG GELU",
  UCD7: '9373576',
  UCD13: '3400893735763',
  ucdQtyMultiplicator: 7,
  cipLib: "GILENYA 0,5MG GELU BT 7",
  atcCode: "L04AA27"
}, {
  CIP7: '4177876',
  CIP13: '3400941778766',
  ucdLib: "GILENYA 0,5MG GELU",
  UCD7: '9373576',
  UCD13: '3400893735763',
  ucdQtyMultiplicator: 28,
  cipLib: "GILENYA 0,5MG GELU BT 28",
  atcCode: "L04AA27"
}, {
  CIP7: '5808758',
  CIP13: '3400958087585',
  ucdLib: "BENLYSTA 120MG PERF FL",
  UCD7: '9386604',
  UCD13: '3400893866047',
  ucdQtyMultiplicator: 1,
  cipLib: "BENLYSTA 120MG PERF FL BT 1",
  atcCode: "L04AA26"
}, {
  CIP7: '5808764',
  CIP13: '3400958087646',
  ucdLib: "BENLYSTA 400MG PERF FL",
  UCD7: '9386610',
  UCD13: '3400893866108',
  ucdQtyMultiplicator: 1,
  cipLib: "BENLYSTA 400MG PERF FL BT 1",
  atcCode: "L04AA26"
}, {
  CIP7: '5711384',
  CIP13: '3400957113841',
  ucdLib: "SOLIRIS 300MG PERF FL30ML",
  UCD7: '9299207',
  UCD13: '3400892992075',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLIRIS 300MG PERF FL30ML BT 1",
  atcCode: "L04AA25"
}, {
  CIP7: '3001920',
  CIP13: '3400930019207',
  ucdLib: "ORENCIA 125MG INJ STYLO1ML",
  UCD7: '9411957',
  UCD13: '3400894119579',
  ucdQtyMultiplicator: 4,
  cipLib: "ORENCIA 125MG INJ STYLO1ML BT 4",
  atcCode: "L04AA24"
}, {
  CIP7: '2688437',
  CIP13: '3400926884376',
  ucdLib: "ORENCIA 125MG INJ SRG1ML +P/A",
  UCD7: '9390267',
  UCD13: '3400893902677',
  ucdQtyMultiplicator: 4,
  cipLib: "ORENCIA 125MG INJ SRG1ML +P/A BT 4",
  atcCode: "L04AA24"
}, {
  CIP7: '5809893',
  CIP13: '3400958098932',
  ucdLib: "ORENCIA 250MG PERF FL+SRG",
  UCD7: '9300181',
  UCD13: '3400893001813',
  ucdQtyMultiplicator: 1,
  cipLib: "ORENCIA 250MG PERF FL+SRG BT 1",
  atcCode: "L04AA24"
}, {
  CIP7: '5699677',
  CIP13: '3400956996773',
  ucdLib: "TYSABRI 300MG PERF FL15ML",
  UCD7: '9293340',
  UCD13: '3400892933405',
  ucdQtyMultiplicator: 1,
  cipLib: "TYSABRI 300MG PERF FL15ML BT 1",
  atcCode: "L04AA23"
}, {
  CIP7: '3641159',
  CIP13: '3400936411593',
  ucdLib: "CERTICAN 0,1MG CPR DISP",
  UCD7: '9263008',
  UCD13: '3400892630083',
  ucdQtyMultiplicator: 60,
  cipLib: "CERTICAN 0,1MG CPR DISP BT 60",
  atcCode: "L04AA18"
}, {
  CIP7: '3641113',
  CIP13: '3400936411135',
  ucdLib: "CERTICAN 0,25MG CPR",
  UCD7: '9263014',
  UCD13: '3400892630144',
  ucdQtyMultiplicator: 60,
  cipLib: "CERTICAN 0,25MG CPR BT 60",
  atcCode: "L04AA18"
}, {
  CIP7: '3641188',
  CIP13: '3400936411883',
  ucdLib: "CERTICAN 0,25MG CPR DISP",
  UCD7: '9277803',
  UCD13: '3400892778037',
  ucdQtyMultiplicator: 60,
  cipLib: "CERTICAN 0,25MG CPR DISP BT 60",
  atcCode: "L04AA18"
}, {
  CIP7: '3641082',
  CIP13: '3400936410824',
  ucdLib: "CERTICAN 0,5MG CPR",
  UCD7: '9263020',
  UCD13: '3400892630205',
  ucdQtyMultiplicator: 60,
  cipLib: "CERTICAN 0,5MG CPR BT 60",
  atcCode: "L04AA18"
}, {
  CIP7: '3641030',
  CIP13: '3400936410305',
  ucdLib: "CERTICAN 0,75MG CPR",
  UCD7: '9263037',
  UCD13: '3400892630373',
  ucdQtyMultiplicator: 60,
  cipLib: "CERTICAN 0,75MG CPR BT 60",
  atcCode: "L04AA18"
}, {
  CIP7: '3541713',
  CIP13: '3400935417138',
  ucdLib: "ARAVA 100MG CPR",
  UCD7: '9221197',
  UCD13: '3400892211978',
  ucdQtyMultiplicator: 3,
  cipLib: "ARAVA 100MG CPR BT 3",
  atcCode: "L04AA13"
}, {
  CIP7: '3541647',
  CIP13: '3400935416476',
  ucdLib: "ARAVA 10MG CPR",
  UCD7: '9221180',
  UCD13: '3400892211800',
  ucdQtyMultiplicator: 30,
  cipLib: "ARAVA 10MG CPR BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '3541699',
  CIP13: '3400935416995',
  ucdLib: "ARAVA 20MG CPR",
  UCD7: '9221205',
  UCD13: '3400892212050',
  ucdQtyMultiplicator: 30,
  cipLib: "ARAVA 20MG CPR BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '4950626',
  CIP13: '3400949506262',
  ucdLib: "ARAVA 10MG CPR ADP BBA",
  UCD7: '9393946',
  UCD13: '3400893939468',
  ucdQtyMultiplicator: 30,
  cipLib: "ARAVA 10MG CPR ADP BBA BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '4950879',
  CIP13: '3400949508792',
  ucdLib: "ARAVA 10MG CPR ADP MWI",
  UCD7: '9396212',
  UCD13: '3400893962121',
  ucdQtyMultiplicator: 30,
  cipLib: "ARAVA 10MG CPR ADP MWI BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '4950603',
  CIP13: '3400949506033',
  ucdLib: "ARAVA 20MG CPR ADP BBA",
  UCD7: '9393952',
  UCD13: '3400893939529',
  ucdQtyMultiplicator: 30,
  cipLib: "ARAVA 20MG CPR ADP BBA BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '4950885',
  CIP13: '3400949508853',
  ucdLib: "ARAVA 20MG CPR ADP MWI",
  UCD7: '9396229',
  UCD13: '3400893962299',
  ucdQtyMultiplicator: 30,
  cipLib: "ARAVA 20MG CPR ADP MWI BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '4951206',
  CIP13: '3400949512065',
  ucdLib: "ARAVA 20MG CPR ADP PLA",
  UCD7: '9409802',
  UCD13: '3400894098027',
  ucdQtyMultiplicator: 30,
  cipLib: "ARAVA 20MG CPR ADP PLA BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '4972680',
  CIP13: '3400949726806',
  ucdLib: "LEFLUNOMIDE WTR 10MG CPR",
  UCD7: '9371560',
  UCD13: '3400893715604',
  ucdQtyMultiplicator: 30,
  cipLib: "LEFLUNOMIDE WTR 10MG CPR BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '4972705',
  CIP13: '3400949727056',
  ucdLib: "LEFLUNOMIDE WTR 20MG CPR",
  UCD7: '9371577',
  UCD13: '3400893715772',
  ucdQtyMultiplicator: 30,
  cipLib: "LEFLUNOMIDE WTR 20MG CPR BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '2208489',
  CIP13: '3400922084893',
  ucdLib: "LEFLUNOMIDE MYL 10MG CPR",
  UCD7: '9395224',
  UCD13: '3400893952245',
  ucdQtyMultiplicator: 30,
  cipLib: "LEFLUNOMIDE MYL 10MG CPR BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '2208526',
  CIP13: '3400922085265',
  ucdLib: "LEFLUNOMIDE MYL 20MG CPR",
  UCD7: '9395230',
  UCD13: '3400893952306',
  ucdQtyMultiplicator: 30,
  cipLib: "LEFLUNOMIDE MYL 20MG CPR BT 30",
  atcCode: "L04AA13"
}, {
  CIP7: '3615682',
  CIP13: '3400936156821',
  ucdLib: "RAPAMUNE 2MG CPR",
  UCD7: '9246085',
  UCD13: '3400892460857',
  ucdQtyMultiplicator: 30,
  cipLib: "RAPAMUNE 2MG CPR BT 30",
  atcCode: "L04AA10"
}, {
  CIP7: '3568847',
  CIP13: '3400935688477',
  ucdLib: "RAPAMUNE 1MG/ML BUV 60ML",
  UCD7: '9228816',
  UCD13: '3400892288161',
  ucdQtyMultiplicator: 1,
  cipLib: "RAPAMUNE 1MG/ML BUV 60ML BT 1",
  atcCode: "L04AA10"
}, {
  CIP7: '3595301',
  CIP13: '3400935953018',
  ucdLib: "RAPAMUNE 1MG CPR",
  UCD7: '9238080',
  UCD13: '3400892380803',
  ucdQtyMultiplicator: 30,
  cipLib: "RAPAMUNE 1MG CPR BT 30",
  atcCode: "L04AA10"
}, {
  CIP7: '4930457',
  CIP13: '3400949304578',
  ucdLib: "RAPAMUNE 0,5MG CPR",
  UCD7: '9353993',
  UCD13: '3400893539934',
  ucdQtyMultiplicator: 30,
  cipLib: "RAPAMUNE 0,5MG CPR BT 30",
  atcCode: "L04AA10"
}, {
  CIP7: '4917959',
  CIP13: '3400949179596',
  ucdLib: "MYCOPHENOL.MOF.BGA 250MG G.",
  UCD7: '9356371',
  UCD13: '3400893563717',
  ucdQtyMultiplicator: 100,
  cipLib: "MYCOPHENOL.MOF.BGA 250MG G. BT 100",
  atcCode: "L04AA06"
}, {
  CIP7: '4914145',
  CIP13: '3400949141456',
  ucdLib: "MYCOPHENOL.MOF.ZYD 500MG CPR",
  UCD7: '9354432',
  UCD13: '3400893544327',
  ucdQtyMultiplicator: 50,
  cipLib: "MYCOPHENOL.MOF.ZYD 500MG CPR BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '3850041',
  CIP13: '3400938500417',
  ucdLib: "MYCOPHENOL.MOF.TVC 250MG G.",
  UCD7: '9342297',
  UCD13: '3400893422977',
  ucdQtyMultiplicator: 100,
  cipLib: "MYCOPHENOL.MOF.TVC 250MG G. BT 100",
  atcCode: "L04AA06"
}, {
  CIP7: '3850064',
  CIP13: '3400938500646',
  ucdLib: "MYCOPHENOL.MOF.TVC 500MG CPR",
  UCD7: '9342305',
  UCD13: '3400893423059',
  ucdQtyMultiplicator: 50,
  cipLib: "MYCOPHENOL.MOF.TVC 500MG CPR BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '3595293',
  CIP13: '3400935952936',
  ucdLib: "CELLCEPT 1G/5ML BUV PDR FL",
  UCD7: '9236566',
  UCD13: '3400892365664',
  ucdQtyMultiplicator: 1,
  cipLib: "CELLCEPT 1G/5ML BUV PDR FL BT 1",
  atcCode: "L04AA06"
}, {
  CIP7: '3595258',
  CIP13: '3400935952585',
  ucdLib: "CELLCEPT 250MG GELU",
  UCD7: '9182132',
  UCD13: '3400891821321',
  ucdQtyMultiplicator: 100,
  cipLib: "CELLCEPT 250MG GELU BT 100",
  atcCode: "L04AA06"
}, {
  CIP7: '3595270',
  CIP13: '3400935952707',
  ucdLib: "CELLCEPT 500MG CPR",
  UCD7: '9182149',
  UCD13: '3400891821499',
  ucdQtyMultiplicator: 50,
  cipLib: "CELLCEPT 500MG CPR BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '4950448',
  CIP13: '3400949504480',
  ucdLib: "CELLCEPT 250MG GELU ADP MWI",
  UCD7: '9389011',
  UCD13: '3400893890110',
  ucdQtyMultiplicator: 100,
  cipLib: "CELLCEPT 250MG GELU ADP MWI BT 100",
  atcCode: "L04AA06"
}, {
  CIP7: '4950454',
  CIP13: '3400949504541',
  ucdLib: "CELLCEPT 500MG CPR ADP MWI",
  UCD7: '9389028',
  UCD13: '3400893890288',
  ucdQtyMultiplicator: 50,
  cipLib: "CELLCEPT 500MG CPR ADP MWI BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '3630871',
  CIP13: '3400936308718',
  ucdLib: "MYFORTIC 180MG CPR",
  UCD7: '9257580',
  UCD13: '3400892575803',
  ucdQtyMultiplicator: 120,
  cipLib: "MYFORTIC 180MG CPR BT 120",
  atcCode: "L04AA06"
}, {
  CIP7: '3630919',
  CIP13: '3400936309197',
  ucdLib: "MYFORTIC 360MG CPR",
  UCD7: '9257597',
  UCD13: '3400892575971',
  ucdQtyMultiplicator: 120,
  cipLib: "MYFORTIC 360MG CPR BT 120",
  atcCode: "L04AA06"
}, {
  CIP7: '5619394',
  CIP13: '3400956193943',
  ucdLib: "CELLCEPT 500MG PERF FL",
  UCD7: '9208802',
  UCD13: '3400892088020',
  ucdQtyMultiplicator: 4,
  cipLib: "CELLCEPT 500MG PERF FL BT 4",
  atcCode: "L04AA06"
}, {
  CIP7: '3921261',
  CIP13: '3400939212616',
  ucdLib: "MYCOPHENOL.MOF.ZYD 250MG G.",
  UCD7: '9332123',
  UCD13: '3400893321232',
  ucdQtyMultiplicator: 100,
  cipLib: "MYCOPHENOL.MOF.ZYD 250MG G. BT 100",
  atcCode: "L04AA06"
}, {
  CIP7: '3961125',
  CIP13: '3400939611259',
  ucdLib: "MYCOPHENOL.MOF.AHL 250MG G.",
  UCD7: '9344913',
  UCD13: '3400893449134',
  ucdQtyMultiplicator: 100,
  cipLib: "MYCOPHENOL.MOF.AHL 250MG G. BT 100",
  atcCode: "L04AA06"
}, {
  CIP7: '4979392',
  CIP13: '3400949793921',
  ucdLib: "MYCOPHENOL.MOF.MYL 500MG C DU",
  UCD7: '9370253',
  UCD13: '3400893702536',
  ucdQtyMultiplicator: 50,
  cipLib: "MYCOPHENOL.MOF.MYL 500MG C DU BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '3941625',
  CIP13: '3400939416250',
  ucdLib: "MYCOPHENOL.MOF.AHL 500MG CPR",
  UCD7: '9339875',
  UCD13: '3400893398753',
  ucdQtyMultiplicator: 50,
  cipLib: "MYCOPHENOL.MOF.AHL 500MG CPR BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '4946599',
  CIP13: '3400949465996',
  ucdLib: "MYCOPHENOL.MOF.EG 250MG G.",
  UCD7: '9362302',
  UCD13: '3400893623022',
  ucdQtyMultiplicator: 100,
  cipLib: "MYCOPHENOL.MOF.EG 250MG G. BT 100",
  atcCode: "L04AA06"
}, {
  CIP7: '4946636',
  CIP13: '3400949466368',
  ucdLib: "MYCOPHENOL.MOF.EG 500MG CPR",
  UCD7: '9362319',
  UCD13: '3400893623190',
  ucdQtyMultiplicator: 50,
  cipLib: "MYCOPHENOL.MOF.EG 500MG CPR BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '4929715',
  CIP13: '3400949297153',
  ucdLib: "MYCOPHENOL.MOF.BGA 500MG CPR",
  UCD7: '9356388',
  UCD13: '3400893563885',
  ucdQtyMultiplicator: 50,
  cipLib: "MYCOPHENOL.MOF.BGA 500MG CPR BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '4921211',
  CIP13: '3400949212118',
  ucdLib: "MYCOPHENOL.MOF.SDZ 250MG G.",
  UCD7: '9356394',
  UCD13: '3400893563946',
  ucdQtyMultiplicator: 100,
  cipLib: "MYCOPHENOL.MOF.SDZ 250MG G. BT 100",
  atcCode: "L04AA06"
}, {
  CIP7: '4924451',
  CIP13: '3400949244515',
  ucdLib: "MYCOPHENOL.MOF.SDZ 500MG CPR",
  UCD7: '9355785',
  UCD13: '3400893557853',
  ucdQtyMultiplicator: 50,
  cipLib: "MYCOPHENOL.MOF.SDZ 500MG CPR BT 50",
  atcCode: "L04AA06"
}, {
  CIP7: '5608870',
  CIP13: '3400956088706',
  ucdLib: "GRAFALON 20MG/ML INJ FL5ML",
  UCD7: '9194885',
  UCD13: '3400891948851',
  ucdQtyMultiplicator: 10,
  cipLib: "GRAFALON 20MG/ML INJ FL5ML BT 10",
  atcCode: "L04AA04"
}, {
  CIP7: '5702818',
  CIP13: '3400957028183',
  ucdLib: "THYMOGLOBULINE 5MG/ML FL",
  UCD7: '9295511',
  UCD13: '3400892955117',
  ucdQtyMultiplicator: 1,
  cipLib: "THYMOGLOBULINE 5MG/ML FL BT 1",
  atcCode: "L04AA04"
}, {
  CIP7: '3971537',
  CIP13: '3400939715377',
  ucdLib: "MOZOBIL 20MG/ML INJ FL1,2ML",
  UCD7: '9338516',
  UCD13: '3400893385166',
  ucdQtyMultiplicator: 1,
  cipLib: "MOZOBIL 20MG/ML INJ FL1,2ML BT 1",
  atcCode: "L03AX16"
}, {
  CIP7: '3638401',
  CIP13: '3400936384019',
  ucdLib: "COPAXONE 20MG INJ SRG1ML",
  UCD7: '9262641',
  UCD13: '3400892626413',
  ucdQtyMultiplicator: 28,
  cipLib: "COPAXONE 20MG INJ SRG1ML BT 28",
  atcCode: "L03AX13"
}, {
  CIP7: '5616579',
  CIP13: '3400956165797',
  ucdLib: "BEROMUN 1MG INJ FL+AMP",
  UCD7: '9233680',
  UCD13: '3400892336800',
  ucdQtyMultiplicator: 4,
  cipLib: "BEROMUN 1MG INJ FL+AMP BT 4",
  atcCode: "L03AX11"
}, {
  CIP7: '3001864',
  CIP13: '3400930018644',
  ucdLib: "BCG-MEDAC FL+POC LUERL A/C",
  UCD7: '9409676',
  UCD13: '3400894096764',
  ucdQtyMultiplicator: 1,
  cipLib: "BCG-MEDAC FL+POC LUERL A/C BT 1",
  atcCode: "L03AX03"
}, {
  CIP7: '4925249',
  CIP13: '3400949252497',
  ucdLib: "IMMUCYST 81MG PDR VESIC FL",
  UCD7: '9353846',
  UCD13: '3400893538463',
  ucdQtyMultiplicator: 1,
  cipLib: "IMMUCYST 81MG PDR VESIC FL BT 1",
  atcCode: "L03AX03"
}, {
  CIP7: '5621586',
  CIP13: '3400956215867',
  ucdLib: "PROLEUKIN 18M UI INJ FL",
  UCD7: '9233214',
  UCD13: '3400892332147',
  ucdQtyMultiplicator: 1,
  cipLib: "PROLEUKIN 18M UI INJ FL BT 1",
  atcCode: "L03AC01"
}, {
  CIP7: '5621557',
  CIP13: '3400956215577',
  ucdLib: "PROLEUKIN 18M UI PERF FL",
  UCD7: '9233220',
  UCD13: '3400892332208',
  ucdQtyMultiplicator: 1,
  cipLib: "PROLEUKIN 18M UI PERF FL BT 1",
  atcCode: "L03AC01"
}, {
  CIP7: '2794932',
  CIP13: '3400927949326',
  ucdLib: "PLEGRIDY 125MCG INJ SRG0,5ML",
  UCD7: '9412738',
  UCD13: '3400894127383',
  ucdQtyMultiplicator: 2,
  cipLib: "PLEGRIDY 125MCG INJ SRG0,5ML BT 2",
  atcCode: "L03AB13"
}, {
  CIP7: '2794955',
  CIP13: '3400927949555',
  ucdLib: "PLEGRIDY 125MCG INJ STY0,5ML",
  UCD7: '9412744',
  UCD13: '3400894127444',
  ucdQtyMultiplicator: 2,
  cipLib: "PLEGRIDY 125MCG INJ STY0,5ML BT 2",
  atcCode: "L03AB13"
}, {
  CIP7: '2794926',
  CIP13: '3400927949265',
  ucdLib: "PLEGRIDY 63+94Y INJ STY0,5ML",
  UCD7: '9412767',
  UCD13: '3400894127673',
  ucdQtyMultiplicator: 2,
  cipLib: "PLEGRIDY 63+94Y INJ STY0,5ML BT 2",
  atcCode: "L03AB13"
}, {
  CIP7: '3599581',
  CIP13: '3400935995810',
  ucdLib: "PEGASYS 135MCG INJ SRG0,5ML",
  UCD7: '9241047',
  UCD13: '3400892410470',
  ucdQtyMultiplicator: 1,
  cipLib: "PEGASYS 135MCG INJ SRG0,5ML BT 1",
  atcCode: "L03AB11"
}, {
  CIP7: '3599598',
  CIP13: '3400935995988',
  ucdLib: "PEGASYS 135MCG INJ SRG0,5ML",
  UCD7: '9241047',
  UCD13: '3400892410470',
  ucdQtyMultiplicator: 4,
  cipLib: "PEGASYS 135MCG INJ SRG0,5ML BT 4",
  atcCode: "L03AB11"
}, {
  CIP7: '3599606',
  CIP13: '3400935996060',
  ucdLib: "PEGASYS 180MCG INJ SRG0,5ML",
  UCD7: '9241076',
  UCD13: '3400892410760',
  ucdQtyMultiplicator: 1,
  cipLib: "PEGASYS 180MCG INJ SRG0,5ML BT 1",
  atcCode: "L03AB11"
}, {
  CIP7: '3599612',
  CIP13: '3400935996121',
  ucdLib: "PEGASYS 180MCG INJ SRG0,5ML",
  UCD7: '9241076',
  UCD13: '3400892410760',
  ucdQtyMultiplicator: 4,
  cipLib: "PEGASYS 180MCG INJ SRG0,5ML BT 4",
  atcCode: "L03AB11"
}, {
  CIP7: '2698051',
  CIP13: '3400926980511',
  ucdLib: "PEGASYS 90MCG INJ SRG0,5ML",
  UCD7: '9395388',
  UCD13: '3400893953884',
  ucdQtyMultiplicator: 1,
  cipLib: "PEGASYS 90MCG INJ SRG0,5ML BT 1",
  atcCode: "L03AB11"
}, {
  CIP7: '2171680',
  CIP13: '3400921716801',
  ucdLib: "PEGASYS 135MCG INJ STY0,5ML",
  UCD7: '9374682',
  UCD13: '3400893746820',
  ucdQtyMultiplicator: 1,
  cipLib: "PEGASYS 135MCG INJ STY0,5ML BT 1",
  atcCode: "L03AB11"
}, {
  CIP7: '2171697',
  CIP13: '3400921716979',
  ucdLib: "PEGASYS 135MCG INJ STY0,5ML",
  UCD7: '9374682',
  UCD13: '3400893746820',
  ucdQtyMultiplicator: 4,
  cipLib: "PEGASYS 135MCG INJ STY0,5ML BT 4",
  atcCode: "L03AB11"
}, {
  CIP7: '2171734',
  CIP13: '3400921717341',
  ucdLib: "PEGASYS 180MCG INJ STY0,5ML",
  UCD7: '9374699',
  UCD13: '3400893746998',
  ucdQtyMultiplicator: 1,
  cipLib: "PEGASYS 180MCG INJ STY0,5ML BT 1",
  atcCode: "L03AB11"
}, {
  CIP7: '2171817',
  CIP13: '3400921718171',
  ucdLib: "PEGASYS 180MCG INJ STY0,5ML",
  UCD7: '9374699',
  UCD13: '3400893746998',
  ucdQtyMultiplicator: 4,
  cipLib: "PEGASYS 180MCG INJ STY0,5ML BT 4",
  atcCode: "L03AB11"
}, {
  CIP7: '3772022',
  CIP13: '3400937720229',
  ucdLib: "BETAFERON 250 INJ FL+SRG+NEC",
  UCD7: '9300643',
  UCD13: '3400893006436',
  ucdQtyMultiplicator: 15,
  cipLib: "BETAFERON 250 INJ FL+SRG+NEC BT 15",
  atcCode: "L03AB08"
}, {
  CIP7: '2699435',
  CIP13: '3400926994358',
  ucdLib: "EXTAVIA 250MCG/ML INJ F+S.LL",
  UCD7: '9395773',
  UCD13: '3400893957738',
  ucdQtyMultiplicator: 15,
  cipLib: "EXTAVIA 250MCG/ML INJ F+S.LL BT 15",
  atcCode: "L03AB08"
}, {
  CIP7: '3432326',
  CIP13: '3400934323263',
  ucdLib: "AVONEX 30MCG/0,5ML INJ SRG",
  UCD7: '9191993',
  UCD13: '3400891919936',
  ucdQtyMultiplicator: 4,
  cipLib: "AVONEX 30MCG/0,5ML INJ SRG BT 4",
  atcCode: "L03AB07"
}, {
  CIP7: '3474170',
  CIP13: '3400934741708',
  ucdLib: "REBIF 22MCG INJ SRG0,5ML",
  UCD7: '9206938',
  UCD13: '3400892069388',
  ucdQtyMultiplicator: 12,
  cipLib: "REBIF 22MCG INJ SRG0,5ML BT 12",
  atcCode: "L03AB07"
}, {
  CIP7: '3759027',
  CIP13: '3400937590273',
  ucdLib: "REBIF 8,8/22MCG INJ SRG",
  UCD7: '9299064',
  UCD13: '3400892990644',
  ucdQtyMultiplicator: 12,
  cipLib: "REBIF 8,8/22MCG INJ SRG BT 12",
  atcCode: "L03AB07"
}, {
  CIP7: '2219079',
  CIP13: '3400922190792',
  ucdLib: "REBIF 22MCG INJ STYLO",
  UCD7: '9392208',
  UCD13: '3400893922088',
  ucdQtyMultiplicator: 12,
  cipLib: "REBIF 22MCG INJ STYLO BT 12",
  atcCode: "L03AB07"
}, {
  CIP7: '3931466',
  CIP13: '3400939314662',
  ucdLib: "REBIF 22Y/0,5ML INJ C.1,5ML",
  UCD7: '9348029',
  UCD13: '3400893480298',
  ucdQtyMultiplicator: 4,
  cipLib: "REBIF 22Y/0,5ML INJ C.1,5ML BT 4",
  atcCode: "L03AB07"
}, {
  CIP7: '3508093',
  CIP13: '3400935080936',
  ucdLib: "REBIF 44MCG INJ SRG0,5ML",
  UCD7: '9213878',
  UCD13: '3400892138787',
  ucdQtyMultiplicator: 12,
  cipLib: "REBIF 44MCG INJ SRG0,5ML BT 12",
  atcCode: "L03AB07"
}, {
  CIP7: '2219091',
  CIP13: '3400922190914',
  ucdLib: "REBIF 44MCG INJ STYLO",
  UCD7: '9392214',
  UCD13: '3400893922149',
  ucdQtyMultiplicator: 12,
  cipLib: "REBIF 44MCG INJ STYLO BT 12",
  atcCode: "L03AB07"
}, {
  CIP7: '3931472',
  CIP13: '3400939314723',
  ucdLib: "REBIF 44Y/0,5ML INJ C.1,5ML",
  UCD7: '9348035',
  UCD13: '3400893480359',
  ucdQtyMultiplicator: 4,
  cipLib: "REBIF 44Y/0,5ML INJ C.1,5ML BT 4",
  atcCode: "L03AB07"
}, {
  CIP7: '2219116',
  CIP13: '3400922191164',
  ucdLib: "REBIF 8,8/22MCG INJ STYLO",
  UCD7: '9392220',
  UCD13: '3400893922200',
  ucdQtyMultiplicator: 12,
  cipLib: "REBIF 8,8/22MCG INJ STYLO BT 12",
  atcCode: "L03AB07"
}, {
  CIP7: '2160908',
  CIP13: '3400921609080',
  ucdLib: "AVONEX 30MCG/0,5ML INJ STYLO",
  UCD7: '9378160',
  UCD13: '3400893781609',
  ucdQtyMultiplicator: 4,
  cipLib: "AVONEX 30MCG/0,5ML INJ STYLO BT 4",
  atcCode: "L03AB07"
}, {
  CIP7: '3596542',
  CIP13: '3400935965424',
  ucdLib: "INTRONA 18MN INJ STYLO+12SET",
  UCD7: '9247110',
  UCD13: '3400892471105',
  ucdQtyMultiplicator: 1,
  cipLib: "INTRONA 18MN INJ STYLO+12SET BT 1",
  atcCode: "L03AB05"
}, {
  CIP7: '3495628',
  CIP13: '3400934956287',
  ucdLib: "INTRONA 10MN INJ FL1ML",
  UCD7: '9206708',
  UCD13: '3400892067087',
  ucdQtyMultiplicator: 1,
  cipLib: "INTRONA 10MN INJ FL1ML BT 1",
  atcCode: "L03AB05"
}, {
  CIP7: '3003820',
  CIP13: '3400930038208',
  ucdLib: "ROFERON-A 3MUI INJ SRG0,5ML",
  UCD7: '9220861',
  UCD13: '3400892208619',
  ucdQtyMultiplicator: 12,
  cipLib: "ROFERON-A 3MUI INJ SRG0,5ML BT 12",
  atcCode: "L03AB04"
}, {
  CIP7: '3525737',
  CIP13: '3400935257376',
  ucdLib: "ROFERON-A 3MUI INJ SRG0,5ML",
  UCD7: '9220861',
  UCD13: '3400892208619',
  ucdQtyMultiplicator: 1,
  cipLib: "ROFERON-A 3MUI INJ SRG0,5ML BT 1",
  atcCode: "L03AB04"
}, {
  CIP7: '3525625',
  CIP13: '3400935256256',
  ucdLib: "ROFERON-A 6MUI INJ SRG0,5ML",
  UCD7: '9220884',
  UCD13: '3400892208848',
  ucdQtyMultiplicator: 1,
  cipLib: "ROFERON-A 6MUI INJ SRG0,5ML BT 1",
  atcCode: "L03AB04"
}, {
  CIP7: '3525677',
  CIP13: '3400935256775',
  ucdLib: "ROFERON-A 9MUI INJ SRG0,5ML",
  UCD7: '9220890',
  UCD13: '3400892208909',
  ucdQtyMultiplicator: 1,
  cipLib: "ROFERON-A 9MUI INJ SRG0,5ML BT 1",
  atcCode: "L03AB04"
}, {
  CIP7: '5577678',
  CIP13: '3400955776789',
  ucdLib: "IMUKIN 2MUI INJ FL0,5ML",
  UCD7: '9162336',
  UCD13: '3400891623369',
  ucdQtyMultiplicator: 1,
  cipLib: "IMUKIN 2MUI INJ FL0,5ML BT 1",
  atcCode: "L03AB03"
}, {
  CIP7: '3953516',
  CIP13: '3400939535166',
  ucdLib: "NEULASTA 6MG INJ SRG.S0,6ML",
  UCD7: '9340826',
  UCD13: '3400893408261',
  ucdQtyMultiplicator: 1,
  cipLib: "NEULASTA 6MG INJ SRG.S0,6ML BT 1",
  atcCode: "L03AA13"
}, {
  CIP7: '3497567',
  CIP13: '3400934975677',
  ucdLib: "GRANOCYTE 13 INJ FL+SRG",
  UCD7: '9190143',
  UCD13: '3400891901436',
  ucdQtyMultiplicator: 1,
  cipLib: "GRANOCYTE 13 INJ FL+SRG BT 1",
  atcCode: "L03AA10"
}, {
  CIP7: '3497573',
  CIP13: '3400934975738',
  ucdLib: "GRANOCYTE 13 INJ FL+SRG",
  UCD7: '9190143',
  UCD13: '3400891901436',
  ucdQtyMultiplicator: 5,
  cipLib: "GRANOCYTE 13 INJ FL+SRG BT 5",
  atcCode: "L03AA10"
}, {
  CIP7: '3497610',
  CIP13: '3400934976100',
  ucdLib: "GRANOCYTE 34 INJ FL+SRG",
  UCD7: '9190166',
  UCD13: '3400891901665',
  ucdQtyMultiplicator: 1,
  cipLib: "GRANOCYTE 34 INJ FL+SRG BT 1",
  atcCode: "L03AA10"
}, {
  CIP7: '3498064',
  CIP13: '3400934980640',
  ucdLib: "GRANOCYTE 34 INJ FL+SRG",
  UCD7: '9190166',
  UCD13: '3400891901665',
  ucdQtyMultiplicator: 5,
  cipLib: "GRANOCYTE 34 INJ FL+SRG BT 5",
  atcCode: "L03AA10"
}, {
  CIP7: '4900047',
  CIP13: '3400949000470',
  ucdLib: "GRANOCYTE 34 FL+SRG AIPBBA UK",
  UCD7: '9416469',
  UCD13: '3400894164692',
  ucdQtyMultiplicator: 1,
  cipLib: "GRANOCYTE 34 FL+SRG AIPBBA UK BT 1",
  atcCode: "L03AA10"
}, {
  CIP7: '4900028',
  CIP13: '3400949000289',
  ucdLib: "GRANOCYTE 34 FL+SRG AIPMWI LT",
  UCD7: '9409860',
  UCD13: '3400894098607',
  ucdQtyMultiplicator: 1,
  cipLib: "GRANOCYTE 34 FL+SRG AIPMWI LT BT 1",
  atcCode: "L03AA10"
}, {
  CIP7: '4901119',
  CIP13: '3400949011193',
  ucdLib: "GRANOCYTE 34 FL+SRG AIPMWI PL",
  UCD7: '9385674',
  UCD13: '3400893856741',
  ucdQtyMultiplicator: 1,
  cipLib: "GRANOCYTE 34 FL+SRG AIPMWI PL BT 1",
  atcCode: "L03AA10"
}, {
  CIP7: '4900597',
  CIP13: '3400949005970',
  ucdLib: "GRANOCYTE 34 FL+SRG AIPPLA PL",
  UCD7: '9353119',
  UCD13: '3400893531198',
  ucdQtyMultiplicator: 1,
  cipLib: "GRANOCYTE 34 FL+SRG AIPPLA PL BT 1",
  atcCode: "L03AA10"
}, {
  CIP7: '3001041',
  CIP13: '3400930010419',
  ucdLib: "ACCOFIL 30MU/0,5ML INJ S. +P",
  UCD7: '9406583',
  UCD13: '3400894065838',
  ucdQtyMultiplicator: 1,
  cipLib: "ACCOFIL 30MU/0,5ML INJ S. +P BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '3001043',
  CIP13: '3400930010433',
  ucdLib: "ACCOFIL 30MU/0,5ML INJ S. +P",
  UCD7: '9406583',
  UCD13: '3400894065838',
  ucdQtyMultiplicator: 5,
  cipLib: "ACCOFIL 30MU/0,5ML INJ S. +P BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '3001045',
  CIP13: '3400930010457',
  ucdLib: "ACCOFIL 48MU/0,5ML INJ S. +P",
  UCD7: '9406608',
  UCD13: '3400894066088',
  ucdQtyMultiplicator: 1,
  cipLib: "ACCOFIL 48MU/0,5ML INJ S. +P BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '3001048',
  CIP13: '3400930010488',
  ucdLib: "ACCOFIL 48MU/0,5ML INJ S. +P",
  UCD7: '9406608',
  UCD13: '3400894066088',
  ucdQtyMultiplicator: 5,
  cipLib: "ACCOFIL 48MU/0,5ML INJ S. +P BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '3539538',
  CIP13: '3400935395382',
  ucdLib: "NEUPOGEN 30 MU INJ SRG0,5ML",
  UCD7: '9259739',
  UCD13: '3400892597393',
  ucdQtyMultiplicator: 1,
  cipLib: "NEUPOGEN 30 MU INJ SRG0,5ML BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '3539515',
  CIP13: '3400935395153',
  ucdLib: "NEUPOGEN 48 MU INJ SRG0,5ML",
  UCD7: '9259745',
  UCD13: '3400892597454',
  ucdQtyMultiplicator: 1,
  cipLib: "NEUPOGEN 48 MU INJ SRG0,5ML BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '3498118',
  CIP13: '3400934981180',
  ucdLib: "NEUPOGEN 30 MU INJ FL1ML",
  UCD7: '9151114',
  UCD13: '3400891511147',
  ucdQtyMultiplicator: 5,
  cipLib: "NEUPOGEN 30 MU INJ FL1ML BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '3864942',
  CIP13: '3400938649420',
  ucdLib: "TEVAGRASTIM 30MUI/0,5ML SRG",
  UCD7: '9333080',
  UCD13: '3400893330807',
  ucdQtyMultiplicator: 1,
  cipLib: "TEVAGRASTIM 30MUI/0,5ML SRG BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '3864965',
  CIP13: '3400938649659',
  ucdLib: "TEVAGRASTIM 48MUI/0,8ML SRG",
  UCD7: '9333097',
  UCD13: '3400893330975',
  ucdQtyMultiplicator: 1,
  cipLib: "TEVAGRASTIM 48MUI/0,8ML SRG BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '3935441',
  CIP13: '3400939354415',
  ucdLib: "ZARZIO 30MU/0,5ML INJ SRG",
  UCD7: '9339384',
  UCD13: '3400893393840',
  ucdQtyMultiplicator: 1,
  cipLib: "ZARZIO 30MU/0,5ML INJ SRG BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '3935464',
  CIP13: '3400939354644',
  ucdLib: "ZARZIO 30MU/0,5ML INJ SRG",
  UCD7: '9339384',
  UCD13: '3400893393840',
  ucdQtyMultiplicator: 5,
  cipLib: "ZARZIO 30MU/0,5ML INJ SRG BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '3935487',
  CIP13: '3400939354873',
  ucdLib: "ZARZIO 48MU/0,5ML INJ SRG",
  UCD7: '9339390',
  UCD13: '3400893393901',
  ucdQtyMultiplicator: 1,
  cipLib: "ZARZIO 48MU/0,5ML INJ SRG BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '3935501',
  CIP13: '3400939355016',
  ucdLib: "ZARZIO 48MU/0,5ML INJ SRG",
  UCD7: '9339390',
  UCD13: '3400893393901',
  ucdQtyMultiplicator: 5,
  cipLib: "ZARZIO 48MU/0,5ML INJ SRG BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '4941337',
  CIP13: '3400949413379',
  ucdLib: "NIVESTIM 12MUI/0,2ML INJ SRG",
  UCD7: '9354248',
  UCD13: '3400893542484',
  ucdQtyMultiplicator: 1,
  cipLib: "NIVESTIM 12MUI/0,2ML INJ SRG BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '4941343',
  CIP13: '3400949413430',
  ucdLib: "NIVESTIM 12MUI/0,2ML INJ SRG",
  UCD7: '9354248',
  UCD13: '3400893542484',
  ucdQtyMultiplicator: 5,
  cipLib: "NIVESTIM 12MUI/0,2ML INJ SRG BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '4941366',
  CIP13: '3400949413669',
  ucdLib: "NIVESTIM 30MUI/0,5ML INJ SRG",
  UCD7: '9354254',
  UCD13: '3400893542545',
  ucdQtyMultiplicator: 1,
  cipLib: "NIVESTIM 30MUI/0,5ML INJ SRG BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '4941372',
  CIP13: '3400949413720',
  ucdLib: "NIVESTIM 30MUI/0,5ML INJ SRG",
  UCD7: '9354254',
  UCD13: '3400893542545',
  ucdQtyMultiplicator: 5,
  cipLib: "NIVESTIM 30MUI/0,5ML INJ SRG BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '4941389',
  CIP13: '3400949413898',
  ucdLib: "NIVESTIM 48MUI/0,5ML INJ SRG",
  UCD7: '9354260',
  UCD13: '3400893542606',
  ucdQtyMultiplicator: 1,
  cipLib: "NIVESTIM 48MUI/0,5ML INJ SRG BT 1",
  atcCode: "L03AA02"
}, {
  CIP7: '4941395',
  CIP13: '3400949413959',
  ucdLib: "NIVESTIM 48MUI/0,5ML INJ SRG",
  UCD7: '9354260',
  UCD13: '3400893542606',
  ucdQtyMultiplicator: 5,
  cipLib: "NIVESTIM 48MUI/0,5ML INJ SRG BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '3998200',
  CIP13: '3400939982007',
  ucdLib: "RATIOGRASTIM 48MUI/0,8ML S. +D",
  UCD7: '9343090',
  UCD13: '3400893430903',
  ucdQtyMultiplicator: 5,
  cipLib: "RATIOGRASTIM 48MUI/0,8ML S. +D BT 5",
  atcCode: "L03AA02"
}, {
  CIP7: '2174974',
  CIP13: '3400921749748',
  ucdLib: "ZYTIGA 250MG CPR",
  UCD7: '9373004',
  UCD13: '3400893730041',
  ucdQtyMultiplicator: 120,
  cipLib: "ZYTIGA 250MG CPR BT 120",
  atcCode: "L02BX03"
}, {
  CIP7: '3943274',
  CIP13: '3400939432748',
  ucdLib: "FIRMAGON 120MG INJ FL+FL 2",
  UCD7: '9345999',
  UCD13: '3400893459997',
  ucdQtyMultiplicator: 2,
  cipLib: "FIRMAGON 120MG INJ FL+FL 2 BT 2",
  atcCode: "L02BX02"
}, {
  CIP7: '3943268',
  CIP13: '3400939432687',
  ucdLib: "FIRMAGON 80MG INJ FL+FL 1",
  UCD7: '9346007',
  UCD13: '3400893460078',
  ucdQtyMultiplicator: 1,
  cipLib: "FIRMAGON 80MG INJ FL+FL 1 BT 1",
  atcCode: "L02BX02"
}, {
  CIP7: '4919013',
  CIP13: '3400949190133',
  ucdLib: "EXEMESTANE SDZ 25MG CPR",
  UCD7: '9361024',
  UCD13: '3400893610244',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE SDZ 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '3527966',
  CIP13: '3400935279668',
  ucdLib: "AROMASINE 25MG CPR",
  UCD7: '9223931',
  UCD13: '3400892239316',
  ucdQtyMultiplicator: 30,
  cipLib: "AROMASINE 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4902018',
  CIP13: '3400949020188',
  ucdLib: "AROMASINE 25MG CPR AIPMWI IT",
  UCD7: '9397737',
  UCD13: '3400893977378',
  ucdQtyMultiplicator: 30,
  cipLib: "AROMASINE 25MG CPR AIPMWI IT BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4900078',
  CIP13: '3400949000784',
  ucdLib: "AROMASINE 25MG CPR AIPMWI LT",
  UCD7: '9418994',
  UCD13: '3400894189947',
  ucdQtyMultiplicator: 30,
  cipLib: "AROMASINE 25MG CPR AIPMWI LT BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4901384',
  CIP13: '3400949013845',
  ucdLib: "AROMASINE 25MG CPR AIPPLA IT",
  UCD7: '9394265',
  UCD13: '3400893942659',
  ucdQtyMultiplicator: 30,
  cipLib: "AROMASINE 25MG CPR AIPPLA IT BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4150937',
  CIP13: '3400941509377',
  ucdLib: "EXEMESTANE ARW 25MG CPR",
  UCD7: '9368807',
  UCD13: '3400893688076',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE ARW 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4998099',
  CIP13: '3400949980994',
  ucdLib: "EXEMESTANE BGA 25MG CPR",
  UCD7: '9368569',
  UCD13: '3400893685693',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE BGA 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4152020',
  CIP13: '3400941520204',
  ucdLib: "EXEMESTANE CRT 25MG CPR",
  UCD7: '9403277',
  UCD13: '3400894032779',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE CRT 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4993185',
  CIP13: '3400949931859',
  ucdLib: "EXEMESTANE MYL 25MG CPR",
  UCD7: '9368575',
  UCD13: '3400893685754',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE MYL 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4195041',
  CIP13: '3400941950414',
  ucdLib: "EXEMESTANE PFZ 25MG CPR",
  UCD7: '9381601',
  UCD13: '3400893816011',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE PFZ 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4929537',
  CIP13: '3400949295371',
  ucdLib: "EXEMESTANE ACC 25MG CPR",
  UCD7: '9360504',
  UCD13: '3400893605042',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE ACC 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '2165478',
  CIP13: '3400921654783',
  ucdLib: "EXEMESTANE RBX 25MG CPR",
  UCD7: '9377870',
  UCD13: '3400893778708',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE RBX 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4920559',
  CIP13: '3400949205592',
  ucdLib: "EXEMESTANE TVC 25MG CPR",
  UCD7: '9359323',
  UCD13: '3400893593233',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE TVC 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '2179210',
  CIP13: '3400921792102',
  ucdLib: "EXEMESTANE ZEN 25MG CPR",
  UCD7: '9397306',
  UCD13: '3400893973066',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE ZEN 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4162768',
  CIP13: '3400941627682',
  ucdLib: "EXEMESTANE ZYF 25MG CPR",
  UCD7: '9371703',
  UCD13: '3400893717035',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE ZYF 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4962635',
  CIP13: '3400949626359',
  ucdLib: "EXEMESTANE EG 25MG CPR",
  UCD7: '9367073',
  UCD13: '3400893670736',
  ucdQtyMultiplicator: 30,
  cipLib: "EXEMESTANE EG 25MG CPR BT 30",
  atcCode: "L02BG06"
}, {
  CIP7: '4918812',
  CIP13: '3400949188123',
  ucdLib: "LETROZOLE BGA 2,5MG CPR",
  UCD7: '9359375',
  UCD13: '3400893593752',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE BGA 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4914085',
  CIP13: '3400949140855',
  ucdLib: "LETROZOLE ZEN 2,5MG CPR",
  UCD7: '9357867',
  UCD13: '3400893578674',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE ZEN 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '3414742',
  CIP13: '3400934147425',
  ucdLib: "FEMARA 2,5MG CPR",
  UCD7: '9186466',
  UCD13: '3400891864663',
  ucdQtyMultiplicator: 30,
  cipLib: "FEMARA 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '3462592',
  CIP13: '3400934625923',
  ucdLib: "LETROZOLE ARW 2,5MG CPR",
  UCD7: '9351267',
  UCD13: '3400893512678',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE ARW 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '3462623',
  CIP13: '3400934626234',
  ucdLib: "LETROZOLE ISD 2,5MG CPR",
  UCD7: '9349448',
  UCD13: '3400893494486',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE ISD 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '3827674',
  CIP13: '3400938276749',
  ucdLib: "LETROZOLE BLF 2,5MG CPR",
  UCD7: '9357850',
  UCD13: '3400893578506',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE BLF 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '3829408',
  CIP13: '3400938294088',
  ucdLib: "LETROZOLE TVC 2,5MG CPR",
  UCD7: '9359381',
  UCD13: '3400893593813',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE TVC 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '2213616',
  CIP13: '3400922136165',
  ucdLib: "LETROZOLE EVO 2,5MG CPR",
  UCD7: '9387727',
  UCD13: '3400893877272',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE EVO 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4900040',
  CIP13: '3400949000401',
  ucdLib: "FEMARA 2,5MG CPR AIP BBA HU",
  UCD7: '9416417',
  UCD13: '3400894164173',
  ucdQtyMultiplicator: 30,
  cipLib: "FEMARA 2,5MG CPR AIP BBA HU BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4901562',
  CIP13: '3400949015627',
  ucdLib: "FEMARA 2,5MG CPR AIP BBA IT",
  UCD7: '9394377',
  UCD13: '3400893943779',
  ucdQtyMultiplicator: 30,
  cipLib: "FEMARA 2,5MG CPR AIP BBA IT BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4902774',
  CIP13: '3400949027743',
  ucdLib: "FEMARA 2,5MG CPR AIP ITT IT",
  UCD7: '9405342',
  UCD13: '3400894053422',
  ucdQtyMultiplicator: 30,
  cipLib: "FEMARA 2,5MG CPR AIP ITT IT BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4900064',
  CIP13: '3400949000647',
  ucdLib: "FEMARA 2,5MG CPR AIP MWI HU",
  UCD7: '9416423',
  UCD13: '3400894164234',
  ucdQtyMultiplicator: 30,
  cipLib: "FEMARA 2,5MG CPR AIP MWI HU BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4900491',
  CIP13: '3400949004911',
  ucdLib: "FEMARA 2,5MG CPR AIP MWI IT",
  UCD7: '9344356',
  UCD13: '3400893443569',
  ucdQtyMultiplicator: 30,
  cipLib: "FEMARA 2,5MG CPR AIP MWI IT BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4901616',
  CIP13: '3400949016167',
  ucdLib: "FEMARA 2,5MG CPR AIP PLA IT",
  UCD7: '9394383',
  UCD13: '3400893943830',
  ucdQtyMultiplicator: 30,
  cipLib: "FEMARA 2,5MG CPR AIP PLA IT BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '3943937',
  CIP13: '3400939439372',
  ucdLib: "LETROZOLE AHL 2,5MG CPR",
  UCD7: '9340068',
  UCD13: '3400893400685',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE AHL 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4945246',
  CIP13: '3400949452460',
  ucdLib: "LETROZOLE EG 2,5MG CPR",
  UCD7: '9366990',
  UCD13: '3400893669907',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE EG 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4991654',
  CIP13: '3400949916542',
  ucdLib: "LETROZOLE MYL 2,5MG CPR",
  UCD7: '9368049',
  UCD13: '3400893680490',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE MYL 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4155449',
  CIP13: '3400941554490',
  ucdLib: "LETROZOLE RBX 2,5MG CPR",
  UCD7: '9371749',
  UCD13: '3400893717493',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE RBX 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '4155389',
  CIP13: '3400941553899',
  ucdLib: "LETROZOLE SDZ 2,5MG CPR",
  UCD7: '9371583',
  UCD13: '3400893715833',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE SDZ 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '3985195',
  CIP13: '3400939851952',
  ucdLib: "LETROZOLE ZYD 2,5MG CPR",
  UCD7: '9346734',
  UCD13: '3400893467343',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE ZYD 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '2163611',
  CIP13: '3400921636116',
  ucdLib: "LETROZOLE CRT 2,5MG CPR",
  UCD7: '9376882',
  UCD13: '3400893768822',
  ucdQtyMultiplicator: 30,
  cipLib: "LETROZOLE CRT 2,5MG CPR BT 30",
  atcCode: "L02BG04"
}, {
  CIP7: '3603762',
  CIP13: '3400936037625',
  ucdLib: "ANASTROZOLE ZEN 1MG CPR",
  UCD7: '9316118',
  UCD13: '3400893161180',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE ZEN 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '3851514',
  CIP13: '3400938515145',
  ucdLib: "ANASTROZOLE TVC 1MG CPR",
  UCD7: '9319944',
  UCD13: '3400893199442',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE TVC 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3851566',
  CIP13: '3400938515664',
  ucdLib: "ANASTROZOLE TVC 1MG CPR",
  UCD7: '9319944',
  UCD13: '3400893199442',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE TVC 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '3590114',
  CIP13: '3400935901149',
  ucdLib: "ANASTROZOLE BGA 1MG CPR",
  UCD7: '9353131',
  UCD13: '3400893531310',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE BGA 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3590189',
  CIP13: '3400935901897',
  ucdLib: "ANASTROZOLE BGA 1MG CPR",
  UCD7: '9353131',
  UCD13: '3400893531310',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE BGA 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '3598535',
  CIP13: '3400935985354',
  ucdLib: "ANASTROZOLE MYL 1MG CPR",
  UCD7: '9314645',
  UCD13: '3400893146453',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE MYL 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '3925980',
  CIP13: '3400939259802',
  ucdLib: "ANASTROZOLE EG 1MG CPR",
  UCD7: '9339409',
  UCD13: '3400893394090',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE EG 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3916136',
  CIP13: '3400939161365',
  ucdLib: "ANASTROZOLE ARW 1MG CPR",
  UCD7: '9336581',
  UCD13: '3400893365816',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE ARW 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3966542',
  CIP13: '3400939665429',
  ucdLib: "ANASTROZOLE CRT 1MG CPR",
  UCD7: '9344178',
  UCD13: '3400893441787',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE CRT 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3843561',
  CIP13: '3400938435610',
  ucdLib: "ANASTROZOLE MYL 1MG CPR",
  UCD7: '9314645',
  UCD13: '3400893146453',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE MYL 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3843443',
  CIP13: '3400938434439',
  ucdLib: "ANASTROZOLE SDZ 1MG CPR",
  UCD7: '9319938',
  UCD13: '3400893199381',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE SDZ 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3843667',
  CIP13: '3400938436679',
  ucdLib: "ANASTROZOLE ZEN 1MG CPR",
  UCD7: '9316118',
  UCD13: '3400893161180',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE ZEN 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3894305',
  CIP13: '3400938943054',
  ucdLib: "ANASTROZOLE ZYD 1MG CPR",
  UCD7: '9326973',
  UCD13: '3400893269732',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE ZYD 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3909521',
  CIP13: '3400939095219',
  ucdLib: "ARIMIDEX 1MG CPR",
  UCD7: '9195028',
  UCD13: '3400891950281',
  ucdQtyMultiplicator: 90,
  cipLib: "ARIMIDEX 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '4949729',
  CIP13: '3400949497294',
  ucdLib: "ANASTROZOLE ACC 1MG CPR",
  UCD7: '9360496',
  UCD13: '3400893604960',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE ACC 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '4949770',
  CIP13: '3400949497706',
  ucdLib: "ANASTROZOLE ACC 1MG CPR",
  UCD7: '9360496',
  UCD13: '3400893604960',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE ACC 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '4941001',
  CIP13: '3400949410019',
  ucdLib: "ANASTROZOLE PHR 1MG CPR",
  UCD7: '9360970',
  UCD13: '3400893609705',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE PHR 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '4941024',
  CIP13: '3400949410248',
  ucdLib: "ANASTROZOLE PHR 1MG CPR",
  UCD7: '9360970',
  UCD13: '3400893609705',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE PHR 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '4155739',
  CIP13: '3400941557392',
  ucdLib: "ANASTROZOLE SDZ 1MG CPR",
  UCD7: '9319938',
  UCD13: '3400893199381',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE SDZ 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '4900048',
  CIP13: '3400949000487',
  ucdLib: "ARIMIDEX 1MG CPR AIP MWI ES",
  UCD7: '9299650',
  UCD13: '3400892996509',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIMIDEX 1MG CPR AIP MWI ES BT 28",
  atcCode: "L02BG03"
}, {
  CIP7: '4900002',
  CIP13: '3400949000029',
  ucdLib: "ARIMIDEX 1MG CPR AIP MWI UK",
  UCD7: '9290910',
  UCD13: '3400892909103',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIMIDEX 1MG CPR AIP MWI UK BT 28",
  atcCode: "L02BG03"
}, {
  CIP7: '4900829',
  CIP13: '3400949008292',
  ucdLib: "ARIMIDEX 1MG CPR AIP PLA BE",
  UCD7: '9374268',
  UCD13: '3400893742686',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIMIDEX 1MG CPR AIP PLA BE BT 28",
  atcCode: "L02BG03"
}, {
  CIP7: '4900315',
  CIP13: '3400949003150',
  ucdLib: "ARIMIDEX 1MG CPR AIP PLA ES",
  UCD7: '9336144',
  UCD13: '3400893361443',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIMIDEX 1MG CPR AIP PLA ES BT 28",
  atcCode: "L02BG03"
}, {
  CIP7: '4900195',
  CIP13: '3400949001958',
  ucdLib: "ARIMIDEX 1MG CPR AIP PLA UK",
  UCD7: '9317750',
  UCD13: '3400893177501',
  ucdQtyMultiplicator: 28,
  cipLib: "ARIMIDEX 1MG CPR AIP PLA UK BT 28",
  atcCode: "L02BG03"
}, {
  CIP7: '4925261',
  CIP13: '3400949252619',
  ucdLib: "ANASTROZOLE ARW 1MG CPR",
  UCD7: '9336581',
  UCD13: '3400893365816',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE ARW 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '4927716',
  CIP13: '3400949277162',
  ucdLib: "ANASTROZOLE BLF 1MG CPR",
  UCD7: '9363537',
  UCD13: '3400893635377',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE BLF 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '4927573',
  CIP13: '3400949275731',
  ucdLib: "ANASTROZOLE EVO 1MG CPR",
  UCD7: '9359168',
  UCD13: '3400893591680',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE EVO 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '4927751',
  CIP13: '3400949277513',
  ucdLib: "ANASTROZOLE ISD 1MG CPR",
  UCD7: '9359145',
  UCD13: '3400893591451',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE ISD 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '4927768',
  CIP13: '3400949277681',
  ucdLib: "ANASTROZOLE ISD 1MG CPR",
  UCD7: '9359145',
  UCD13: '3400893591451',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE ISD 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '3998737',
  CIP13: '3400939987378',
  ucdLib: "ANASTROZOLE RBX 1MG CPR",
  UCD7: '9348756',
  UCD13: '3400893487563',
  ucdQtyMultiplicator: 30,
  cipLib: "ANASTROZOLE RBX 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '3998766',
  CIP13: '3400939987668',
  ucdLib: "ANASTROZOLE RBX 1MG CPR",
  UCD7: '9348756',
  UCD13: '3400893487563',
  ucdQtyMultiplicator: 90,
  cipLib: "ANASTROZOLE RBX 1MG CPR BT 90",
  atcCode: "L02BG03"
}, {
  CIP7: '3423652',
  CIP13: '3400934236525',
  ucdLib: "ARIMIDEX 1MG CPR",
  UCD7: '9195028',
  UCD13: '3400891950281',
  ucdQtyMultiplicator: 30,
  cipLib: "ARIMIDEX 1MG CPR BT 30",
  atcCode: "L02BG03"
}, {
  CIP7: '2743248',
  CIP13: '3400927432484',
  ucdLib: "XTANDI 40MG CAPS MOL",
  UCD7: '9396554',
  UCD13: '3400893965542',
  ucdQtyMultiplicator: 112,
  cipLib: "XTANDI 40MG CAPS MOL BT 112",
  atcCode: "L02BB04"
}, {
  CIP7: '4913358',
  CIP13: '3400949133581',
  ucdLib: "BICALUTAMIDE PHR 50MG CPR",
  UCD7: '9354308',
  UCD13: '3400893543085',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE PHR 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '4989290',
  CIP13: '3400949892907',
  ucdLib: "BICALUTAMIDE ISD 50MG CPR",
  UCD7: '9365358',
  UCD13: '3400893653586',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE ISD 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3858829',
  CIP13: '3400938588293',
  ucdLib: "BICALUTAMIDE ALM 50MG CPR",
  UCD7: '9319950',
  UCD13: '3400893199503',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE ALM 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3852034',
  CIP13: '3400938520347',
  ucdLib: "BICALUTAMIDE SDZ 50MG CPR",
  UCD7: '9315254',
  UCD13: '3400893152546',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE SDZ 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3391633',
  CIP13: '3400933916336',
  ucdLib: "CASODEX 50MG CPR",
  UCD7: '9176462',
  UCD13: '3400891764628',
  ucdQtyMultiplicator: 30,
  cipLib: "CASODEX 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3761165',
  CIP13: '3400937611657',
  ucdLib: "BICALUTAMIDE EG 50MG CPR",
  UCD7: '9291312',
  UCD13: '3400892913124',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE EG 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3772826',
  CIP13: '3400937728263',
  ucdLib: "BICALUTAMIDE ARL 50MG CPR",
  UCD7: '9296410',
  UCD13: '3400892964102',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE ARL 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3785177',
  CIP13: '3400937851770',
  ucdLib: "BICALUTAMIDE BGA 50MG CPR",
  UCD7: '9302719',
  UCD13: '3400893027196',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE BGA 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3785384',
  CIP13: '3400937853842',
  ucdLib: "BICALUTAMIDE RBX 50MG CPR",
  UCD7: '9315231',
  UCD13: '3400893152317',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE RBX 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3793840',
  CIP13: '3400937938402',
  ucdLib: "BICALUTAMIDE ZEN 50MG CPR",
  UCD7: '9315283',
  UCD13: '3400893152836',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE ZEN 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3785332',
  CIP13: '3400937853323',
  ucdLib: "ORMANDYL 50MG CPR",
  UCD7: '9315567',
  UCD13: '3400893155677',
  ucdQtyMultiplicator: 30,
  cipLib: "ORMANDYL 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3843035',
  CIP13: '3400938430356',
  ucdLib: "BICALUTAMIDE ARW 50MG CPR",
  UCD7: '9315188',
  UCD13: '3400893151884',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE ARW 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3843911',
  CIP13: '3400938439113',
  ucdLib: "BICALUTAMIDE CRT 50MG CPR",
  UCD7: '9315225',
  UCD13: '3400893152256',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE CRT 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3931851',
  CIP13: '3400939318516',
  ucdLib: "BICALUTAMIDE EVO 50MG CPR",
  UCD7: '9336635',
  UCD13: '3400893366356',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE EVO 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3843288',
  CIP13: '3400938432886',
  ucdLib: "BICALUTAMIDE MYL 50MG CPR",
  UCD7: '9316905',
  UCD13: '3400893169056',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE MYL 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3840781',
  CIP13: '3400938407815',
  ucdLib: "BICALUTAMIDE TVC 50MG CPR",
  UCD7: '9315277',
  UCD13: '3400893152775',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE TVC 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '4946702',
  CIP13: '3400949467020',
  ucdLib: "BICALUTAMIDE ACC 50MG CPR",
  UCD7: '9359033',
  UCD13: '3400893590331',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE ACC 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '2195775',
  CIP13: '3400921957754',
  ucdLib: "BICALUTAMIDE ZYD 50MG CPR",
  UCD7: '9381682',
  UCD13: '3400893816820',
  ucdQtyMultiplicator: 30,
  cipLib: "BICALUTAMIDE ZYD 50MG CPR BT 30",
  atcCode: "L02BB03"
}, {
  CIP7: '3326452',
  CIP13: '3400933264529',
  ucdLib: "ANANDRON 150MG CPR",
  UCD7: '9170330',
  UCD13: '3400891703306',
  ucdQtyMultiplicator: 30,
  cipLib: "ANANDRON 150MG CPR BT 30",
  atcCode: "L02BB02"
}, {
  CIP7: '3288272',
  CIP13: '3400932882724',
  ucdLib: "ANANDRON 50MG CPR",
  UCD7: '9122199',
  UCD13: '3400891221992',
  ucdQtyMultiplicator: 90,
  cipLib: "ANANDRON 50MG CPR BT 90",
  atcCode: "L02BB02"
}, {
  CIP7: '3611572',
  CIP13: '3400936115729',
  ucdLib: "FLUTAMIDE TVC 250MG CPR",
  UCD7: '9245068',
  UCD13: '3400892450681',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUTAMIDE TVC 250MG CPR BT 30",
  atcCode: "L02BB01"
}, {
  CIP7: '3525401',
  CIP13: '3400935254016',
  ucdLib: "FLUTAMIDE MYL 250MG CPR",
  UCD7: '9226705',
  UCD13: '3400892267050',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUTAMIDE MYL 250MG CPR BT 30",
  atcCode: "L02BB01"
}, {
  CIP7: '3561147',
  CIP13: '3400935611475',
  ucdLib: "FLUTAMIDE CRT 250MG CPR",
  UCD7: '9329457',
  UCD13: '3400893294574',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUTAMIDE CRT 250MG CPR BT 30",
  atcCode: "L02BB01"
}, {
  CIP7: '3534280',
  CIP13: '3400935342805',
  ucdLib: "FLUTAMIDE BGA 250MG CPR",
  UCD7: '9219065',
  UCD13: '3400892190655',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUTAMIDE BGA 250MG CPR BT 30",
  atcCode: "L02BB01"
}, {
  CIP7: '3538763',
  CIP13: '3400935387639',
  ucdLib: "FLUTAMIDE EG 250MG CPR",
  UCD7: '9223227',
  UCD13: '3400892232270',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUTAMIDE EG 250MG CPR BT 30",
  atcCode: "L02BB01"
}, {
  CIP7: '3634900',
  CIP13: '3400936349001',
  ucdLib: "FASLODEX 250MG INJ SRG5ML +A.",
  UCD7: '9261073',
  UCD13: '3400892610733',
  ucdQtyMultiplicator: 1,
  cipLib: "FASLODEX 250MG INJ SRG5ML +A. BT 1",
  atcCode: "L02BA03"
}, {
  CIP7: '3406205',
  CIP13: '3400934062056',
  ucdLib: "FARESTON 60MG CPR",
  UCD7: '9195330',
  UCD13: '3400891953305',
  ucdQtyMultiplicator: 30,
  cipLib: "FARESTON 60MG CPR BT 30",
  atcCode: "L02BA02"
}, {
  CIP7: '3614346',
  CIP13: '3400936143463',
  ucdLib: "TAMOXIFENE TVC 10MG CPR",
  UCD7: '9245453',
  UCD13: '3400892454535',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE TVC 10MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3614352',
  CIP13: '3400936143524',
  ucdLib: "TAMOXIFENE TVC 20MG CPR",
  UCD7: '9245476',
  UCD13: '3400892454764',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE TVC 20MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3286528',
  CIP13: '3400932865284',
  ucdLib: "NOLVADEX 20MG CPR",
  UCD7: '9120220',
  UCD13: '3400891202205',
  ucdQtyMultiplicator: 30,
  cipLib: "NOLVADEX 20MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3205932',
  CIP13: '3400932059324',
  ucdLib: "NOLVADEX 10MG CPR PELLIC",
  UCD7: '9063367',
  UCD13: '3400890633673',
  ucdQtyMultiplicator: 30,
  cipLib: "NOLVADEX 10MG CPR PELLIC BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3679759',
  CIP13: '3400936797598',
  ucdLib: "TAMOXIFENE SDZ 10MG CPR",
  UCD7: '9268750',
  UCD13: '3400892687506',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE SDZ 10MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3679765',
  CIP13: '3400936797659',
  ucdLib: "TAMOXIFENE SDZ 20MG CPR",
  UCD7: '9268767',
  UCD13: '3400892687674',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE SDZ 20MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3395223',
  CIP13: '3400933952235',
  ucdLib: "TAMOXIFENE MYL 10MG CPR",
  UCD7: '9181397',
  UCD13: '3400891813975',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE MYL 10MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3395246',
  CIP13: '3400933952464',
  ucdLib: "TAMOXIFENE MYL 20MG CPR",
  UCD7: '9181405',
  UCD13: '3400891814057',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE MYL 20MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3463930',
  CIP13: '3400934639302',
  ucdLib: "TAMOXIFENE BGA 10MG CPR",
  UCD7: '9204419',
  UCD13: '3400892044194',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE BGA 10MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3463947',
  CIP13: '3400934639470',
  ucdLib: "TAMOXIFENE BGA 20MG CPR",
  UCD7: '9204425',
  UCD13: '3400892044255',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE BGA 20MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3582540',
  CIP13: '3400935825407',
  ucdLib: "TAMOXIFENE EG 10MG CPR",
  UCD7: '9239949',
  UCD13: '3400892399492',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE EG 10MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3583344',
  CIP13: '3400935833440',
  ucdLib: "TAMOXIFENE EG 20MG CPR",
  UCD7: '9239955',
  UCD13: '3400892399553',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE EG 20MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3666403',
  CIP13: '3400936664036',
  ucdLib: "TAMOXIFENE ZYD 20MG CPR",
  UCD7: '9269548',
  UCD13: '3400892695488',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE ZYD 20MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3647624',
  CIP13: '3400936476240',
  ucdLib: "TAMOXIFENE ARW 20MG CPR",
  UCD7: '9264315',
  UCD13: '3400892643151',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMOXIFENE ARW 20MG CPR BT 30",
  atcCode: "L02BA01"
}, {
  CIP7: '3285026',
  CIP13: '3400932850266',
  ucdLib: "DECAPEPTYL 0,1MG INJ FL+AMP",
  UCD7: '9109419',
  UCD13: '3400891094190',
  ucdQtyMultiplicator: 7,
  cipLib: "DECAPEPTYL 0,1MG INJ FL+AMP BT 7",
  atcCode: "L02AE04"
}, {
  CIP7: '3394376',
  CIP13: '3400933943769',
  ucdLib: "DECAPEPTYL LP 3MG FL+AMP +NEC",
  UCD7: '9176901',
  UCD13: '3400891769012',
  ucdQtyMultiplicator: 1,
  cipLib: "DECAPEPTYL LP 3MG FL+AMP +NEC BT 1",
  atcCode: "L02AE04"
}, {
  CIP7: '3412565',
  CIP13: '3400934125652',
  ucdLib: "DECAPEPTYL LP11,25MG F+A +NEC",
  UCD7: '9186408',
  UCD13: '3400891864083',
  ucdQtyMultiplicator: 1,
  cipLib: "DECAPEPTYL LP11,25MG F+A +NEC BT 1",
  atcCode: "L02AE04"
}, {
  CIP7: '3584467',
  CIP13: '3400935844675',
  ucdLib: "GONAPEPTYL 3,75MG INJ SRG+SRG",
  UCD7: '9276502',
  UCD13: '3400892765020',
  ucdQtyMultiplicator: 1,
  cipLib: "GONAPEPTYL 3,75MG INJ SRG+SRG BT 1",
  atcCode: "L02AE04"
}, {
  CIP7: '3808145',
  CIP13: '3400938081459',
  ucdLib: "SALVACYL LP 11,25MG INJ FL+A.",
  UCD7: '9324299',
  UCD13: '3400893242995',
  ucdQtyMultiplicator: 1,
  cipLib: "SALVACYL LP 11,25MG INJ FL+A. BT 1",
  atcCode: "L02AE04"
}, {
  CIP7: '3989017',
  CIP13: '3400939890173',
  ucdLib: "DECAPEPTYL LP22,5MG FL+A +NEC",
  UCD7: '9345717',
  UCD13: '3400893457177',
  ucdQtyMultiplicator: 1,
  cipLib: "DECAPEPTYL LP22,5MG FL+A +NEC BT 1",
  atcCode: "L02AE04"
}, {
  CIP7: '3293267',
  CIP13: '3400932932672',
  ucdLib: "ZOLADEX 3,6MG IMPL INJ SRG",
  UCD7: '9130922',
  UCD13: '3400891309225',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOLADEX 3,6MG IMPL INJ SRG BT 1",
  atcCode: "L02AE03"
}, {
  CIP7: '3396381',
  CIP13: '3400933963811',
  ucdLib: "ZOLADEX 10,8MG IMPL INJ SRG",
  UCD7: '9183060',
  UCD13: '3400891830606',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOLADEX 10,8MG IMPL INJ SRG BT 1",
  atcCode: "L02AE03"
}, {
  CIP7: '3669092',
  CIP13: '3400936690929',
  ucdLib: "ELIGARD 22,5MG INJ SRG+SRG",
  UCD7: '9281561',
  UCD13: '3400892815619',
  ucdQtyMultiplicator: 1,
  cipLib: "ELIGARD 22,5MG INJ SRG+SRG BT 1",
  atcCode: "L02AE02"
}, {
  CIP7: '3669086',
  CIP13: '3400936690868',
  ucdLib: "ELIGARD 7,5MG INJ SRG+SRG",
  UCD7: '9281578',
  UCD13: '3400892815787',
  ucdQtyMultiplicator: 1,
  cipLib: "ELIGARD 7,5MG INJ SRG+SRG BT 1",
  atcCode: "L02AE02"
}, {
  CIP7: '3826338',
  CIP13: '3400938263381',
  ucdLib: "ELIGARD 45MG INJ SRG+SRG PLAT",
  UCD7: '9309087',
  UCD13: '3400893090879',
  ucdQtyMultiplicator: 1,
  cipLib: "ELIGARD 45MG INJ SRG+SRG PLAT BT 1",
  atcCode: "L02AE02"
}, {
  CIP7: '3757531',
  CIP13: '3400937575317',
  ucdLib: "ENANTONE LP 11,25MG INJ F+A +D",
  UCD7: '9292257',
  UCD13: '3400892922577',
  ucdQtyMultiplicator: 1,
  cipLib: "ENANTONE LP 11,25MG INJ F+A +D BT 1",
  atcCode: "L02AE02"
}, {
  CIP7: '3757525',
  CIP13: '3400937575256',
  ucdLib: "ENANTONE LP 3,75MG INJ F+A. +D",
  UCD7: '9292263',
  UCD13: '3400892922638',
  ucdQtyMultiplicator: 1,
  cipLib: "ENANTONE LP 3,75MG INJ F+A. +D BT 1",
  atcCode: "L02AE02"
}, {
  CIP7: '3845838',
  CIP13: '3400938458381',
  ucdLib: "ENANTONE LP 30MG INJ SRG",
  UCD7: '9316779',
  UCD13: '3400893167793',
  ucdQtyMultiplicator: 1,
  cipLib: "ENANTONE LP 30MG INJ SRG BT 1",
  atcCode: "L02AE02"
}, {
  CIP7: '3363878',
  CIP13: '3400933638788',
  ucdLib: "BIGONIST 6,3MG INJ SRG",
  UCD7: '9164281',
  UCD13: '3400891642810',
  ucdQtyMultiplicator: 1,
  cipLib: "BIGONIST 6,3MG INJ SRG BT 1",
  atcCode: "L02AE01"
}, {
  CIP7: '3261439',
  CIP13: '3400932614394',
  ucdLib: "DEPO-PRODASONE 500MG INJ FL",
  UCD7: '9025119',
  UCD13: '3400890251198',
  ucdQtyMultiplicator: 1,
  cipLib: "DEPO-PRODASONE 500MG INJ FL BT 1",
  atcCode: "L02AB02"
}, {
  CIP7: '3166830',
  CIP13: '3400931668305',
  ucdLib: "DEPO-PRODASONE 250MG INJ FL",
  UCD7: '9025102',
  UCD13: '3400890251020',
  ucdQtyMultiplicator: 1,
  cipLib: "DEPO-PRODASONE 250MG INJ FL BT 1",
  atcCode: "L02AB02"
}, {
  CIP7: '3360472',
  CIP13: '3400933604721',
  ucdLib: "MEGACE 160MG CPR",
  UCD7: '9167753',
  UCD13: '3400891677539',
  ucdQtyMultiplicator: 30,
  cipLib: "MEGACE 160MG CPR BT 30",
  atcCode: "L02AB01"
}, {
  CIP7: '5890077',
  CIP13: '3400958900778',
  ucdLib: "VENETOCLAX ABV 100MG CPR",
  UCD7: '9419278',
  UCD13: '3400894192787',
  ucdQtyMultiplicator: 7,
  cipLib: "VENETOCLAX ABV 100MG CPR BT 7",
  atcCode: "L01XX52"
}, {
  CIP7: '5890078',
  CIP13: '3400958900785',
  ucdLib: "VENETOCLAX ABV 100MG CPR",
  UCD7: '9419278',
  UCD13: '3400894192787',
  ucdQtyMultiplicator: 14,
  cipLib: "VENETOCLAX ABV 100MG CPR BT 14",
  atcCode: "L01XX52"
}, {
  CIP7: '5890080',
  CIP13: '3400958900808',
  ucdLib: "VENETOCLAX ABV 100MG CPR",
  UCD7: '9419278',
  UCD13: '3400894192787',
  ucdQtyMultiplicator: 120,
  cipLib: "VENETOCLAX ABV 100MG CPR BT 120",
  atcCode: "L01XX52"
}, {
  CIP7: '5890075',
  CIP13: '3400958900754',
  ucdLib: "VENETOCLAX ABV 10MG CPR",
  UCD7: '9419284',
  UCD13: '3400894192848',
  ucdQtyMultiplicator: 14,
  cipLib: "VENETOCLAX ABV 10MG CPR BT 14",
  atcCode: "L01XX52"
}, {
  CIP7: '5890076',
  CIP13: '3400958900761',
  ucdLib: "VENETOCLAX ABV 50MG CPR",
  UCD7: '9419290',
  UCD13: '3400894192909',
  ucdQtyMultiplicator: 7,
  cipLib: "VENETOCLAX ABV 50MG CPR BT 7",
  atcCode: "L01XX52"
}, {
  CIP7: '3007785',
  CIP13: '3400930077856',
  ucdLib: "VENCLYXTO 10MG CPR",
  UCD7: '9422814',
  UCD13: '3400894228141',
  ucdQtyMultiplicator: 14,
  cipLib: "VENCLYXTO 10 mg Cpr pell Plq/14 (7x2)",
  atcCode: "L01XX52"
}, {
  CIP7: '3007789',
  CIP13: '3400930077894',
  ucdLib: "VENCLYXTO 100MG CPR",
  UCD7: '9422808',
  UCD13: '3400894228080',
  ucdQtyMultiplicator: 7,
  cipLib: "VENCLYXTO 100 mg Cpr pell 7Plq/1",
  atcCode: "L01XX52"
}, {
  CIP7: '3007791',
  CIP13: '3400930077917',
  ucdLib: "VENCLYXTO 100MG CPR",
  UCD7: '9422808',
  UCD13: '3400894228080',
  ucdQtyMultiplicator: 112,
  cipLib: "VENCLYXTO 100 mg Cpr pell Plq/112 (4x28)",
  atcCode: "L01XX52"
}, {
  CIP7: '3007790',
  CIP13: '3400930077900',
  ucdLib: "VENCLYXTO 100MG CPR",
  UCD7: '9422808',
  UCD13: '3400894228080',
  ucdQtyMultiplicator: 14,
  cipLib: "VENCLYXTO 100 mg Cpr pell Plq/14 (7x2)",
  atcCode: "L01XX52"
}, {
  CIP7: '3007788',
  CIP13: '3400930077887',
  ucdLib: "VENCLYXTO 50MG CPR",
  UCD7: '9422820',
  UCD13: '3400894228202',
  ucdQtyMultiplicator: 14,
  cipLib: "VENCLYXTO 50 mg Cpr pell 7Plq/1",
  atcCode: "L01XX52"
}, {
  CIP7: '3007769',
  CIP13: '3400930077696',
  ucdLib: "NINLARO 2,3MG GELU",
  UCD7: '9426278',
  UCD13: '3400894262787',
  ucdQtyMultiplicator: 3,
  cipLib: "NINLARO 2,3 mg Gꬠ3Etuis/1",
  atcCode: "L01XX50"
}, {
  CIP7: '3007771',
  CIP13: '3400930077719',
  ucdLib: "NINLARO 3MG GELU",
  UCD7: '9426284',
  UCD13: '3400894262848',
  ucdQtyMultiplicator: 3,
  cipLib: "NINLARO 3 mg Gꬠ3Etuis/1",
  atcCode: "L01XX50"
}, {
  CIP7: '3007772',
  CIP13: '3400930077726',
  ucdLib: "NINLARO 4MG GELU",
  UCD7: '9426290',
  UCD13: '3400894262909',
  ucdQtyMultiplicator: 3,
  cipLib: "NINLARO 4 mg Gꬠ3Etuis/1",
  atcCode: "L01XX50"
}, {
  CIP7: '2795966',
  CIP13: '3400927959660',
  ucdLib: "ZYDELIG 100MG CPR",
  UCD7: '9403478',
  UCD13: '3400894034780',
  ucdQtyMultiplicator: 60,
  cipLib: "ZYDELIG 100MG CPR BT 60",
  atcCode: "L01XX47"
}, {
  CIP7: '2795972',
  CIP13: '3400927959721',
  ucdLib: "ZYDELIG 150MG CPR",
  UCD7: '9403484',
  UCD13: '3400894034841',
  ucdQtyMultiplicator: 60,
  cipLib: "ZYDELIG 150MG CPR BT 60",
  atcCode: "L01XX47"
}, {
  CIP7: '3000399',
  CIP13: '3400930003992',
  ucdLib: "LYNPARZA 50MG GELU",
  UCD7: '9405684',
  UCD13: '3400894056843',
  ucdQtyMultiplicator: 448,
  cipLib: "LYNPARZA 50MG GELU BT 448",
  atcCode: "L01XX46"
}, {
  CIP7: '5841856',
  CIP13: '3400958418563',
  ucdLib: "ZALTRAP 25MG/ML PERF FL4ML",
  UCD7: '9394992',
  UCD13: '3400893949924',
  ucdQtyMultiplicator: 1,
  cipLib: "ZALTRAP 25MG/ML PERF FL4ML BT 1",
  atcCode: "L01XX44"
}, {
  CIP7: '5841879',
  CIP13: '3400958418792',
  ucdLib: "ZALTRAP 25MG/ML PERF FL8ML",
  UCD7: '9395000',
  UCD13: '3400893950005',
  ucdQtyMultiplicator: 1,
  cipLib: "ZALTRAP 25MG/ML PERF FL8ML BT 1",
  atcCode: "L01XX44"
}, {
  CIP7: '2747677',
  CIP13: '3400927476778',
  ucdLib: "ERIVEDGE 150MG GELU",
  UCD7: '9396494',
  UCD13: '3400893964941',
  ucdQtyMultiplicator: 28,
  cipLib: "ERIVEDGE 150MG GELU BT 28",
  atcCode: "L01XX43"
}, {
  CIP7: '3002466',
  CIP13: '3400930024669',
  ucdLib: "FARYDAK 10MG GELU",
  UCD7: '9413413',
  UCD13: '3400894134138',
  ucdQtyMultiplicator: 6,
  cipLib: "FARYDAK 10MG GELU BT 6",
  atcCode: "L01XX42"
}, {
  CIP7: '3002468',
  CIP13: '3400930024683',
  ucdLib: "FARYDAK 15MG GELU",
  UCD7: '9413436',
  UCD13: '3400894134367',
  ucdQtyMultiplicator: 6,
  cipLib: "FARYDAK 15MG GELU BT 6",
  atcCode: "L01XX42"
}, {
  CIP7: '3002469',
  CIP13: '3400930024690',
  ucdLib: "FARYDAK 20MG GELU",
  UCD7: '9413442',
  UCD13: '3400894134428',
  ucdQtyMultiplicator: 6,
  cipLib: "FARYDAK 20MG GELU BT 6",
  atcCode: "L01XX42"
}, {
  CIP7: '4183523',
  CIP13: '3400941835230',
  ucdLib: "HALAVEN 0,44MG/ML INJ FL2ML",
  UCD7: '9368954',
  UCD13: '3400893689547',
  ucdQtyMultiplicator: 1,
  cipLib: "HALAVEN 0,44MG/ML INJ FL2ML BT 1",
  atcCode: "L01XX41"
}, {
  CIP7: '4183546',
  CIP13: '3400941835469',
  ucdLib: "HALAVEN 0,44MG/ML INJ FL2ML",
  UCD7: '9368954',
  UCD13: '3400893689547',
  ucdQtyMultiplicator: 6,
  cipLib: "HALAVEN 0,44MG/ML INJ FL2ML BT 6",
  atcCode: "L01XX41"
}, {
  CIP7: '3651790',
  CIP13: '3400936517905',
  ucdLib: "XAGRID 0,5MG GELU",
  UCD7: '9239435',
  UCD13: '3400892394350',
  ucdQtyMultiplicator: 100,
  cipLib: "XAGRID 0,5MG GELU BT 100",
  atcCode: "L01XX35"
}, {
  CIP7: '3866579',
  CIP13: '3400938665796',
  ucdLib: "VELCADE 1MG INJ FL",
  UCD7: '9318910',
  UCD13: '3400893189108',
  ucdQtyMultiplicator: 1,
  cipLib: "VELCADE 1MG INJ FL BT 1",
  atcCode: "L01XX32"
}, {
  CIP7: '5649573',
  CIP13: '3400956495733',
  ucdLib: "VELCADE 3,5MG INJ FL",
  UCD7: '9260010',
  UCD13: '3400892600109',
  ucdQtyMultiplicator: 1,
  cipLib: "VELCADE 3,5MG INJ FL BT 1",
  atcCode: "L01XX32"
}, {
  CIP7: '5636205',
  CIP13: '3400956362059',
  ucdLib: "TRISENOX 1MG/ML INJ AMP10ML",
  UCD7: '9242911',
  UCD13: '3400892429113',
  ucdQtyMultiplicator: 10,
  cipLib: "TRISENOX 1MG/ML INJ AMP10ML BT 10",
  atcCode: "L01XX27"
}, {
  CIP7: '3657479',
  CIP13: '3400936574793',
  ucdLib: "TARGRETIN 75MG CAPS MOL",
  UCD7: '9233728',
  UCD13: '3400892337289',
  ucdQtyMultiplicator: 100,
  cipLib: "TARGRETIN 75MG CAPS MOL BT 100",
  atcCode: "L01XX25"
}, {
  CIP7: '5501701',
  CIP13: '3400955017011',
  ucdLib: "ONCASPAR 750U/ML INJ FL5ML",
  UCD7: '9298828',
  UCD13: '3400892988283',
  ucdQtyMultiplicator: 1,
  cipLib: "ONCASPAR 750U/ML INJ FL5ML BT 1",
  atcCode: "L01XX24"
}, {
  CIP7: '5657940',
  CIP13: '3400956579402',
  ucdLib: "LYSODREN 500MG CPR",
  UCD7: '9259509',
  UCD13: '3400892595092',
  ucdQtyMultiplicator: 100,
  cipLib: "LYSODREN 500MG CPR BT 100",
  atcCode: "L01XX23"
}, {
  CIP7: '3580417',
  CIP13: '3400935804174',
  ucdLib: "PANRETIN 0,1% GEL TB60G",
  UCD7: '9239754',
  UCD13: '3400892397542',
  ucdQtyMultiplicator: 1,
  cipLib: "PANRETIN 0,1% GEL TB60G BT 1",
  atcCode: "L01XX22"
}, {
  CIP7: '5726925',
  CIP13: '3400957269258',
  ucdLib: "CAMPTO 20MG/ML PERF FP15ML",
  UCD7: '9317170',
  UCD13: '3400893171707',
  ucdQtyMultiplicator: 1,
  cipLib: "CAMPTO 20MG/ML PERF FP15ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5726902',
  CIP13: '3400957269029',
  ucdLib: "CAMPTO 20MG/ML PERF FP2ML",
  UCD7: '9317187',
  UCD13: '3400893171875',
  ucdQtyMultiplicator: 1,
  cipLib: "CAMPTO 20MG/ML PERF FP2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5726919',
  CIP13: '3400957269197',
  ucdLib: "CAMPTO 20MG/ML PERF FP5ML",
  UCD7: '9317193',
  UCD13: '3400893171936',
  ucdQtyMultiplicator: 1,
  cipLib: "CAMPTO 20MG/ML PERF FP5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5753371',
  CIP13: '3400957533717',
  ucdLib: "IRINOTECAN ARW 20MG/ML FL25ML",
  UCD7: '9333329',
  UCD13: '3400893333297',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN ARW 20MG/ML FL25ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5729332',
  CIP13: '3400957293321',
  ucdLib: "IRINOTECAN ARW 20MG/ML FL2ML",
  UCD7: '9321036',
  UCD13: '3400893210369',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN ARW 20MG/ML FL2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5729349',
  CIP13: '3400957293499',
  ucdLib: "IRINOTECAN ARW 20MG/ML FL5ML",
  UCD7: '9321042',
  UCD13: '3400893210420',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN ARW 20MG/ML FL5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5755648',
  CIP13: '3400957556488',
  ucdLib: "IRINOTECAN EBP 20MG/ML FL25ML",
  UCD7: '9334665',
  UCD13: '3400893346655',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN EBP 20MG/ML FL25ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5748944',
  CIP13: '3400957489441',
  ucdLib: "IRINOTECAN FRF 20MG/ML FL2ML",
  UCD7: '9334814',
  UCD13: '3400893348147',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN FRF 20MG/ML FL2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5748950',
  CIP13: '3400957489502',
  ucdLib: "IRINOTECAN FRF 20MG/ML FL5ML",
  UCD7: '9334820',
  UCD13: '3400893348208',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN FRF 20MG/ML FL5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5747873',
  CIP13: '3400957478735',
  ucdLib: "IRINOTECAN HPI 20MG/ML FL25ML",
  UCD7: '9334582',
  UCD13: '3400893345825',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN HPI 20MG/ML FL25ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5747850',
  CIP13: '3400957478506',
  ucdLib: "IRINOTECAN HPI 20MG/ML FL2ML",
  UCD7: '9333335',
  UCD13: '3400893333358',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN HPI 20MG/ML FL2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5747867',
  CIP13: '3400957478674',
  ucdLib: "IRINOTECAN HPI 20MG/ML FL5ML",
  UCD7: '9333341',
  UCD13: '3400893333419',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN HPI 20MG/ML FL5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5751490',
  CIP13: '3400957514907',
  ucdLib: "IRINOTECAN KBI 20MG/ML FL2ML",
  UCD7: '9332778',
  UCD13: '3400893327784',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN KBI 20MG/ML FL2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5751509',
  CIP13: '3400957515096',
  ucdLib: "IRINOTECAN KBI 20MG/ML FL5ML",
  UCD7: '9332784',
  UCD13: '3400893327845',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN KBI 20MG/ML FL5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5757819',
  CIP13: '3400957578190',
  ucdLib: "IRINOTECAN MYL 20MG/ML FL15ML",
  UCD7: '9338249',
  UCD13: '3400893382493',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN MYL 20MG/ML FL15ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5757854',
  CIP13: '3400957578541',
  ucdLib: "IRINOTECAN MYL 20MG/ML FL25ML",
  UCD7: '9338255',
  UCD13: '3400893382554',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN MYL 20MG/ML FL25ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5744283',
  CIP13: '3400957442835',
  ucdLib: "IRINOTECAN MYL 20MG/ML FL2ML",
  UCD7: '9326246',
  UCD13: '3400893262467',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN MYL 20MG/ML FL2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5744337',
  CIP13: '3400957443375',
  ucdLib: "IRINOTECAN MYL 20MG/ML FL5ML",
  UCD7: '9326252',
  UCD13: '3400893262528',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN MYL 20MG/ML FL5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5746075',
  CIP13: '3400957460754',
  ucdLib: "IRINOTECAN TVC 20MG/ML FL25ML",
  UCD7: '9326393',
  UCD13: '3400893263938',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN TVC 20MG/ML FL25ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5791093',
  CIP13: '3400957910938',
  ucdLib: "IRINOTECAN ARW 20MG/ML FL15ML",
  UCD7: '9364270',
  UCD13: '3400893642702',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN ARW 20MG/ML FL15ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5732179',
  CIP13: '3400957321796',
  ucdLib: "IRINOTECAN EBP 20MG/ML FL2ML",
  UCD7: '9330182',
  UCD13: '3400893301821',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN EBP 20MG/ML FL2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5732185',
  CIP13: '3400957321857',
  ucdLib: "IRINOTECAN EBP 20MG/ML FL5ML",
  UCD7: '9330199',
  UCD13: '3400893301999',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN EBP 20MG/ML FL5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5779436',
  CIP13: '3400957794361',
  ucdLib: "IRINOTECAN EBW 20MG/ML 15ML S",
  UCD7: '9354969',
  UCD13: '3400893549698',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN EBW 20MG/ML 15ML S BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5779442',
  CIP13: '3400957794422',
  ucdLib: "IRINOTECAN EBW 20MG/ML 25ML S",
  UCD7: '9354975',
  UCD13: '3400893549759',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN EBW 20MG/ML 25ML S BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5779459',
  CIP13: '3400957794590',
  ucdLib: "IRINOTECAN EBW 20MG/ML FL2ML",
  UCD7: '9354923',
  UCD13: '3400893549230',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN EBW 20MG/ML FL2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5824651',
  CIP13: '3400958246517',
  ucdLib: "IRINOTECAN FRF 20MG/ML FL15ML",
  UCD7: '9383468',
  UCD13: '3400893834688',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN FRF 20MG/ML FL15ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5738302',
  CIP13: '3400957383022',
  ucdLib: "IRINOTECAN TVC 20MG/ML FL2ML",
  UCD7: '9324253',
  UCD13: '3400893242537',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN TVC 20MG/ML FL2ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5738319',
  CIP13: '3400957383190',
  ucdLib: "IRINOTECAN TVC 20MG/ML FL5ML",
  UCD7: '9324276',
  UCD13: '3400893242766',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN TVC 20MG/ML FL5ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5769403',
  CIP13: '3400957694036',
  ucdLib: "IRINOTECAN FRF 20MG/ML FL25ML",
  UCD7: '9348006',
  UCD13: '3400893480069',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN FRF 20MG/ML FL25ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5767976',
  CIP13: '3400957679767',
  ucdLib: "IRINOTECAN KBI 20MG/ML FL15ML",
  UCD7: '9345930',
  UCD13: '3400893459300',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN KBI 20MG/ML FL15ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5767982',
  CIP13: '3400957679828',
  ucdLib: "IRINOTECAN KBI 20MG/ML FL25ML",
  UCD7: '9345947',
  UCD13: '3400893459478',
  ucdQtyMultiplicator: 1,
  cipLib: "IRINOTECAN KBI 20MG/ML FL25ML BT 1",
  atcCode: "L01XX19"
}, {
  CIP7: '5605452',
  CIP13: '3400956054527',
  ucdLib: "HYCAMTIN 4MG PERF FL5ML",
  UCD7: '9187023',
  UCD13: '3400891870237',
  ucdQtyMultiplicator: 1,
  cipLib: "HYCAMTIN 4MG PERF FL5ML BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '3471421',
  CIP13: '3400934714214',
  ucdLib: "TOPOTECAN TVC 4MG INJ FL4ML",
  UCD7: '9372482',
  UCD13: '3400893724828',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPOTECAN TVC 4MG INJ FL4ML BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '3848765',
  CIP13: '3400938487657',
  ucdLib: "HYCAMTIN 0,25MG GELU",
  UCD7: '9311581',
  UCD13: '3400893115817',
  ucdQtyMultiplicator: 10,
  cipLib: "HYCAMTIN 0,25MG GELU BT 10",
  atcCode: "L01XX17"
}, {
  CIP7: '3848771',
  CIP13: '3400938487718',
  ucdLib: "HYCAMTIN 1MG GELU",
  UCD7: '9311598',
  UCD13: '3400893115985',
  ucdQtyMultiplicator: 10,
  cipLib: "HYCAMTIN 1MG GELU BT 10",
  atcCode: "L01XX17"
}, {
  CIP7: '4941320',
  CIP13: '3400949413201',
  ucdLib: "TOPOTECAN HPI 4MG INJ FL4ML",
  UCD7: '9355029',
  UCD13: '3400893550298',
  ucdQtyMultiplicator: 5,
  cipLib: "TOPOTECAN HPI 4MG INJ FL4ML BT 5",
  atcCode: "L01XX17"
}, {
  CIP7: '2189912',
  CIP13: '3400921899122',
  ucdLib: "POTACTASOL 4MG INJ FL",
  UCD7: '9378504',
  UCD13: '3400893785041',
  ucdQtyMultiplicator: 1,
  cipLib: "POTACTASOL 4MG INJ FL BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '2225737',
  CIP13: '3400922257372',
  ucdLib: "TOPOTECANE ACC 1MG/ML INJ 1ML",
  UCD7: '9397720',
  UCD13: '3400893977200',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPOTECANE ACC 1MG/ML INJ 1ML BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '2225766',
  CIP13: '3400922257662',
  ucdLib: "TOPOTECANE ACC 1MG/ML INJ 4ML",
  UCD7: '9386001',
  UCD13: '3400893860014',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPOTECANE ACC 1MG/ML INJ 4ML BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '5796506',
  CIP13: '3400957965068',
  ucdLib: "TOPOTECAN MDC 1MG/ML INJ 1ML",
  UCD7: '9379917',
  UCD13: '3400893799178',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPOTECAN MDC 1MG/ML INJ 1ML BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '5796541',
  CIP13: '3400957965419',
  ucdLib: "TOPOTECAN MDC 1MG/ML INJ 4ML",
  UCD7: '9379946',
  UCD13: '3400893799468',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPOTECAN MDC 1MG/ML INJ 4ML BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '5791437',
  CIP13: '3400957914370',
  ucdLib: "TOPOTECAN MYL 1MG/ML INJ 4ML",
  UCD7: '9365513',
  UCD13: '3400893655139',
  ucdQtyMultiplicator: 1,
  cipLib: "TOPOTECAN MYL 1MG/ML INJ 4ML BT 1",
  atcCode: "L01XX17"
}, {
  CIP7: '3658697',
  CIP13: '3400936586970',
  ucdLib: "VESANOID 10MG CAPS",
  UCD7: '9182184',
  UCD13: '3400891821840',
  ucdQtyMultiplicator: 100,
  cipLib: "VESANOID 10MG CAPS BT 100",
  atcCode: "L01XX14"
}, {
  CIP7: '3238274',
  CIP13: '3400932382743',
  ucdLib: "ESTRACYT 140MG GELU",
  UCD7: '9032869',
  UCD13: '3400890328692',
  ucdQtyMultiplicator: 40,
  cipLib: "ESTRACYT 140MG GELU BT 40",
  atcCode: "L01XX11"
}, {
  CIP7: '3229795',
  CIP13: '3400932297955',
  ucdLib: "ESTRACYT 140MG GELU",
  UCD7: '9032869',
  UCD13: '3400890328692',
  ucdQtyMultiplicator: 100,
  cipLib: "ESTRACYT 140MG GELU BT 100",
  atcCode: "L01XX11"
}, {
  CIP7: '5580410',
  CIP13: '3400955804109',
  ucdLib: "NIPENT 10MG INJ FL",
  UCD7: '9160509',
  UCD13: '3400891605099',
  ucdQtyMultiplicator: 1,
  cipLib: "NIPENT 10MG INJ FL BT 1",
  atcCode: "L01XX08"
}, {
  CIP7: '3051268',
  CIP13: '3400930512685',
  ucdLib: "HYDREA 500MG GELU",
  UCD7: '9045004',
  UCD13: '3400890450041',
  ucdQtyMultiplicator: 20,
  cipLib: "HYDREA 500MG GELU BT 20",
  atcCode: "L01XX05"
}, {
  CIP7: '3810194',
  CIP13: '3400938101942',
  ucdLib: "SIKLOS 1000MG CPR",
  UCD7: '9311948',
  UCD13: '3400893119488',
  ucdQtyMultiplicator: 30,
  cipLib: "SIKLOS 1000MG CPR BT 30",
  atcCode: "L01XX05"
}, {
  CIP7: '4158057',
  CIP13: '3400941580574',
  ucdLib: "SIKLOS 100MG CPR",
  UCD7: '9356170',
  UCD13: '3400893561706',
  ucdQtyMultiplicator: 60,
  cipLib: "SIKLOS 100MG CPR BT 60",
  atcCode: "L01XX05"
}, {
  CIP7: '3224740',
  CIP13: '3400932247400',
  ucdLib: "HEXASTAT 100MG GELU",
  UCD7: '9043494',
  UCD13: '3400890434942',
  ucdQtyMultiplicator: 25,
  cipLib: "HEXASTAT 100MG GELU BT 25",
  atcCode: "L01XX03"
}, {
  CIP7: '3118104',
  CIP13: '3400931181040',
  ucdLib: "KIDROLASE 10000U INJ FL+AMP",
  UCD7: '9049077',
  UCD13: '3400890490771',
  ucdQtyMultiplicator: 1,
  cipLib: "KIDROLASE 10000U INJ FL+AMP BT 1",
  atcCode: "L01XX02"
}, {
  CIP7: '5500416',
  CIP13: '3400955004165',
  ucdLib: "ERWINASE 10000UI INJ FL",
  UCD7: '9290502',
  UCD13: '3400892905020',
  ucdQtyMultiplicator: 5,
  cipLib: "ERWINASE 10000UI INJ FL BT 5",
  atcCode: "L01XX02"
}, {
  CIP7: '5525204',
  CIP13: '3400955252047',
  ucdLib: "KIDROLASE 10000U INJ FL",
  UCD7: '9262428',
  UCD13: '3400892624280',
  ucdQtyMultiplicator: 10,
  cipLib: "KIDROLASE 10000U INJ FL BT 10",
  atcCode: "L01XX02"
}, {
  CIP7: '5649946',
  CIP13: '3400956499465',
  ucdLib: "AMSALYO 75MG PERF FL",
  UCD7: '9259113',
  UCD13: '3400892591131',
  ucdQtyMultiplicator: 5,
  cipLib: "AMSALYO 75MG PERF FL BT 5",
  atcCode: "L01XX01"
}, {
  CIP7: '5890081',
  CIP13: '3400958900815',
  ucdLib: "MIDOSTAURINE NPH 25MG CAPS",
  UCD7: '9420494',
  UCD13: '3400894204947',
  ucdQtyMultiplicator: 64,
  cipLib: "MIDOSTAURINE NPH 25MG CAPS BT 64",
  atcCode: "L01XE39"
}, {
  CIP7: '3011360',
  CIP13: '3400930113608',
  ucdLib: "RYDAPT 25MG CAPS",
  UCD7: '9433203',
  UCD13: '3400894332039',
  ucdQtyMultiplicator: 112,
  cipLib: "RYDAPT 25 mg Caps molle Plq/112 (4x28)",
  atcCode: "L01XE39"
}, {
  CIP7: '3003755',
  CIP13: '3400930037553',
  ucdLib: "COTELLIC 20MG CPR",
  UCD7: '9412454',
  UCD13: '3400894124542',
  ucdQtyMultiplicator: 63,
  cipLib: "COTELLIC 20MG CPR BT 63",
  atcCode: "L01XE38"
}, {
  CIP7: '5910126',
  CIP13: '3400959101266',
  ucdLib: "ALECTINIB RCH 150MG GELU",
  UCD7: '9410691',
  UCD13: '3400894106913',
  ucdQtyMultiplicator: 1,
  cipLib: "ALECTINIB RCH 150MG GELU BT 1",
  atcCode: "L01XE36"
}, {
  CIP7: '3004764',
  CIP13: '3400930047644',
  ucdLib: "TAGRISSO 40MG CPR",
  UCD7: '9416245',
  UCD13: '3400894162452',
  ucdQtyMultiplicator: 30,
  cipLib: "TAGRISSO 40MG CPR BT 30",
  atcCode: "L01XE35"
}, {
  CIP7: '3004765',
  CIP13: '3400930047651',
  ucdLib: "TAGRISSO 80MG CPR",
  UCD7: '9416251',
  UCD13: '3400894162513',
  ucdQtyMultiplicator: 30,
  cipLib: "TAGRISSO 80MG CPR BT 30",
  atcCode: "L01XE35"
}, {
  CIP7: '5890047',
  CIP13: '3400958900471',
  ucdLib: "PALBOCICLIB PFZ 100MG GELU",
  UCD7: '9407654',
  UCD13: '3400894076544',
  ucdQtyMultiplicator: 21,
  cipLib: "PALBOCICLIB PFZ 100MG GELU BT 21",
  atcCode: "L01XE33"
}, {
  CIP7: '5890049',
  CIP13: '3400958900495',
  ucdLib: "PALBOCICLIB PFZ 125MG GELU",
  UCD7: '9407660',
  UCD13: '3400894076605',
  ucdQtyMultiplicator: 21,
  cipLib: "PALBOCICLIB PFZ 125MG GELU BT 21",
  atcCode: "L01XE33"
}, {
  CIP7: '5890045',
  CIP13: '3400958900457',
  ucdLib: "PALBOCICLIB PFZ 75MG GELU",
  UCD7: '9407677',
  UCD13: '3400894076773',
  ucdQtyMultiplicator: 21,
  cipLib: "PALBOCICLIB PFZ 75MG GELU BT 21",
  atcCode: "L01XE33"
}, {
  CIP7: '3007529',
  CIP13: '3400930075296',
  ucdLib: "IBRANCE 100MG GELU",
  UCD7: '9422843',
  UCD13: '3400894228431',
  ucdQtyMultiplicator: 21,
  cipLib: "IBRANCE 100 mg Gꬠ3Plq/7 (21)",
  atcCode: "L01XE33"
}, {
  CIP7: '3007530',
  CIP13: '3400930075302',
  ucdLib: "IBRANCE 125MG GELU",
  UCD7: '9422866',
  UCD13: '3400894228660',
  ucdQtyMultiplicator: 21,
  cipLib: "IBRANCE 125 mg Gꬠ3Plq/7 (21)",
  atcCode: "L01XE33"
}, {
  CIP7: '3007527',
  CIP13: '3400930075272',
  ucdLib: "IBRANCE 75MG GELU",
  UCD7: '9422872',
  UCD13: '3400894228721',
  ucdQtyMultiplicator: 21,
  cipLib: "IBRANCE 75 mg Gꬠ3Plq/7 (21)",
  atcCode: "L01XE33"
}, {
  CIP7: '3000602',
  CIP13: '3400930006023',
  ucdLib: "OFEV 100MG CAPS",
  UCD7: '9406614',
  UCD13: '3400894066149',
  ucdQtyMultiplicator: 60,
  cipLib: "OFEV 100MG CAPS BT 60",
  atcCode: "L01XE31"
}, {
  CIP7: '3000604',
  CIP13: '3400930006047',
  ucdLib: "OFEV 150MG CAPS",
  UCD7: '9406620',
  UCD13: '3400894066200',
  ucdQtyMultiplicator: 60,
  cipLib: "OFEV 150MG CAPS BT 60",
  atcCode: "L01XE31"
}, {
  CIP7: '3001895',
  CIP13: '3400930018958',
  ucdLib: "LENVIMA 10MG GELU",
  UCD7: '9408866',
  UCD13: '3400894088660',
  ucdQtyMultiplicator: 30,
  cipLib: "LENVIMA 10MG GELU BT 30",
  atcCode: "L01XE29"
}, {
  CIP7: '3001894',
  CIP13: '3400930018941',
  ucdLib: "LENVIMA 4MG GELU",
  UCD7: '9408872',
  UCD13: '3400894088721',
  ucdQtyMultiplicator: 30,
  cipLib: "LENVIMA 4MG GELU BT 30",
  atcCode: "L01XE29"
}, {
  CIP7: '3001569',
  CIP13: '3400930015698',
  ucdLib: "ZYKADIA 150MG GELU",
  UCD7: '9410834',
  UCD13: '3400894108344',
  ucdQtyMultiplicator: 150,
  cipLib: "ZYKADIA 150MG GELU BT 150",
  atcCode: "L01XE28"
}, {
  CIP7: '2794984',
  CIP13: '3400927949845',
  ucdLib: "IMBRUVICA 140MG GELU",
  UCD7: '9403490',
  UCD13: '3400894034902',
  ucdQtyMultiplicator: 90,
  cipLib: "IMBRUVICA 140MG GELU BT 90",
  atcCode: "L01XE27"
}, {
  CIP7: '2794990',
  CIP13: '3400927949906',
  ucdLib: "IMBRUVICA 140MG GELU",
  UCD7: '9403490',
  UCD13: '3400894034902',
  ucdQtyMultiplicator: 120,
  cipLib: "IMBRUVICA 140MG GELU BT 120",
  atcCode: "L01XE27"
}, {
  CIP7: '5890082',
  CIP13: '3400958900822',
  ucdLib: "CABOMETYX 20MG CPR",
  UCD7: '9420005',
  UCD13: '3400894200055',
  ucdQtyMultiplicator: 30,
  cipLib: "CABOMETYX 20MG CPR BT 30",
  atcCode: "L01XE26"
}, {
  CIP7: '5890083',
  CIP13: '3400958900839',
  ucdLib: "CABOMETYX 40MG CPR",
  UCD7: '9420011',
  UCD13: '3400894200116',
  ucdQtyMultiplicator: 30,
  cipLib: "CABOMETYX 40MG CPR BT 30",
  atcCode: "L01XE26"
}, {
  CIP7: '5890084',
  CIP13: '3400958900846',
  ucdLib: "CABOMETYX 60MG CPR",
  UCD7: '9420028',
  UCD13: '3400894200284',
  ucdQtyMultiplicator: 30,
  cipLib: "CABOMETYX 60MG CPR BT 30",
  atcCode: "L01XE26"
}, {
  CIP7: '2794435',
  CIP13: '3400927944352',
  ucdLib: "MEKINIST 0,5MG CPR",
  UCD7: '9421789',
  UCD13: '3400894217893',
  ucdQtyMultiplicator: 30,
  cipLib: "MEKINIST 0,5MG CPR BT 30",
  atcCode: "L01XE25"
}, {
  CIP7: '2794470',
  CIP13: '3400927944703',
  ucdLib: "MEKINIST 2MG CPR",
  UCD7: '9421795',
  UCD13: '3400894217954',
  ucdQtyMultiplicator: 30,
  cipLib: "MEKINIST 2MG CPR BT 30",
  atcCode: "L01XE25"
}, {
  CIP7: '3002002',
  CIP13: '3400930020029',
  ucdLib: "ICLUSIG 15MG CPR",
  UCD7: '9395750',
  UCD13: '3400893957509',
  ucdQtyMultiplicator: 30,
  cipLib: "ICLUSIG 15MG CPR BT 30",
  atcCode: "L01XE24"
}, {
  CIP7: '3004761',
  CIP13: '3400930047613',
  ucdLib: "ICLUSIG 30MG CPR",
  UCD7: '9417701',
  UCD13: '3400894177012',
  ucdQtyMultiplicator: 30,
  cipLib: "ICLUSIG 30MG CPR BT 30",
  atcCode: "L01XE24"
}, {
  CIP7: '2741982',
  CIP13: '3400927419829',
  ucdLib: "ICLUSIG 45MG CPR",
  UCD7: '9395767',
  UCD13: '3400893957677',
  ucdQtyMultiplicator: 30,
  cipLib: "ICLUSIG 45MG CPR BT 30",
  atcCode: "L01XE24"
}, {
  CIP7: '2754967',
  CIP13: '3400927549670',
  ucdLib: "TAFINLAR 50MG GELU",
  UCD7: '9395626',
  UCD13: '3400893956267',
  ucdQtyMultiplicator: 120,
  cipLib: "TAFINLAR 50MG GELU BT 120",
  atcCode: "L01XE23"
}, {
  CIP7: '2754973',
  CIP13: '3400927549731',
  ucdLib: "TAFINLAR 75MG GELU",
  UCD7: '9395632',
  UCD13: '3400893956328',
  ucdQtyMultiplicator: 120,
  cipLib: "TAFINLAR 75MG GELU BT 120",
  atcCode: "L01XE23"
}, {
  CIP7: '2752000',
  CIP13: '3400927520006',
  ucdLib: "STIVARGA 40MG CPR PELL",
  UCD7: '9395603',
  UCD13: '3400893956038',
  ucdQtyMultiplicator: 84,
  cipLib: "STIVARGA 40MG CPR PELL BT 84",
  atcCode: "L01XE21"
}, {
  CIP7: '3000245',
  CIP13: '3400930002452',
  ucdLib: "JAKAVI 10MG CPR",
  UCD7: '9419628',
  UCD13: '3400894196280',
  ucdQtyMultiplicator: 56,
  cipLib: "JAKAVI 10MG CPR BT 56",
  atcCode: "L01XE18"
}, {
  CIP7: '2732606',
  CIP13: '3400927326066',
  ucdLib: "JAKAVI 15MG CPR",
  UCD7: '9388000',
  UCD13: '3400893880005',
  ucdQtyMultiplicator: 56,
  cipLib: "JAKAVI 15MG CPR BT 56",
  atcCode: "L01XE18"
}, {
  CIP7: '2732629',
  CIP13: '3400927326295',
  ucdLib: "JAKAVI 20MG CPR",
  UCD7: '9388017',
  UCD13: '3400893880173',
  ucdQtyMultiplicator: 56,
  cipLib: "JAKAVI 20MG CPR BT 56",
  atcCode: "L01XE18"
}, {
  CIP7: '2732581',
  CIP13: '3400927325816',
  ucdLib: "JAKAVI 5MG CPR",
  UCD7: '9388023',
  UCD13: '3400893880234',
  ucdQtyMultiplicator: 56,
  cipLib: "JAKAVI 5MG CPR BT 56",
  atcCode: "L01XE18"
}, {
  CIP7: '2664804',
  CIP13: '3400926648046',
  ucdLib: "INLYTA 1MG CPR PELLIC",
  UCD7: '9387555',
  UCD13: '3400893875551',
  ucdQtyMultiplicator: 56,
  cipLib: "INLYTA 1MG CPR PELLIC BT 56",
  atcCode: "L01XE17"
}, {
  CIP7: '2754737',
  CIP13: '3400927547379',
  ucdLib: "INLYTA 3MG CPR PELLIC",
  UCD7: '9402929',
  UCD13: '3400894029298',
  ucdQtyMultiplicator: 56,
  cipLib: "INLYTA 3MG CPR PELLIC BT 56",
  atcCode: "L01XE17"
}, {
  CIP7: '2664827',
  CIP13: '3400926648275',
  ucdLib: "INLYTA 5MG CPR PELLIC",
  UCD7: '9387561',
  UCD13: '3400893875612',
  ucdQtyMultiplicator: 56,
  cipLib: "INLYTA 5MG CPR PELLIC BT 56",
  atcCode: "L01XE17"
}, {
  CIP7: '2754766',
  CIP13: '3400927547669',
  ucdLib: "INLYTA 7MG CPR PELLIC",
  UCD7: '9402935',
  UCD13: '3400894029359',
  ucdQtyMultiplicator: 56,
  cipLib: "INLYTA 7MG CPR PELLIC BT 56",
  atcCode: "L01XE17"
}, {
  CIP7: '2676256',
  CIP13: '3400926762568',
  ucdLib: "XALKORI 200MG GELU",
  UCD7: '9389258',
  UCD13: '3400893892589',
  ucdQtyMultiplicator: 60,
  cipLib: "XALKORI 200MG GELU BT 60",
  atcCode: "L01XE16"
}, {
  CIP7: '2676279',
  CIP13: '3400926762797',
  ucdLib: "XALKORI 250MG GELU",
  UCD7: '9389264',
  UCD13: '3400893892640',
  ucdQtyMultiplicator: 60,
  cipLib: "XALKORI 250MG GELU BT 60",
  atcCode: "L01XE16"
}, {
  CIP7: '2208756',
  CIP13: '3400922087566',
  ucdLib: "ZELBORAF 240MG CPR",
  UCD7: '9382279',
  UCD13: '3400893822791',
  ucdQtyMultiplicator: 56,
  cipLib: "ZELBORAF 240MG CPR BT 56",
  atcCode: "L01XE15"
}, {
  CIP7: '2699352',
  CIP13: '3400926993528',
  ucdLib: "BOSULIF 100MG CPR",
  UCD7: '9393509',
  UCD13: '3400893935095',
  ucdQtyMultiplicator: 28,
  cipLib: "BOSULIF 100MG CPR BT 28",
  atcCode: "L01XE14"
}, {
  CIP7: '2699375',
  CIP13: '3400926993757',
  ucdLib: "BOSULIF 500MG CPR",
  UCD7: '9393515',
  UCD13: '3400893935156',
  ucdQtyMultiplicator: 28,
  cipLib: "BOSULIF 500MG CPR BT 28",
  atcCode: "L01XE14"
}, {
  CIP7: '2756564',
  CIP13: '3400927565649',
  ucdLib: "GIOTRIF 20MG CPR",
  UCD7: '9398783',
  UCD13: '3400893987834',
  ucdQtyMultiplicator: 28,
  cipLib: "GIOTRIF 20MG CPR BT 28",
  atcCode: "L01XE13"
}, {
  CIP7: '2756570',
  CIP13: '3400927565700',
  ucdLib: "GIOTRIF 30MG CPR",
  UCD7: '9398808',
  UCD13: '3400893988084',
  ucdQtyMultiplicator: 28,
  cipLib: "GIOTRIF 30MG CPR BT 28",
  atcCode: "L01XE13"
}, {
  CIP7: '2756587',
  CIP13: '3400927565878',
  ucdLib: "GIOTRIF 40MG CPR",
  UCD7: '9398814',
  UCD13: '3400893988145',
  ucdQtyMultiplicator: 28,
  cipLib: "GIOTRIF 40MG CPR BT 28",
  atcCode: "L01XE13"
}, {
  CIP7: '2756593',
  CIP13: '3400927565939',
  ucdLib: "GIOTRIF 50MG CPR",
  UCD7: '9398820',
  UCD13: '3400893988206',
  ucdQtyMultiplicator: 28,
  cipLib: "GIOTRIF 50MG CPR BT 28",
  atcCode: "L01XE13"
}, {
  CIP7: '2206680',
  CIP13: '3400922066806',
  ucdLib: "CAPRELSA 100MG CPR PELLIC",
  UCD7: '9381239',
  UCD13: '3400893812396',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPRELSA 100MG CPR PELLIC BT 30",
  atcCode: "L01XE12"
}, {
  CIP7: '2206697',
  CIP13: '3400922066974',
  ucdLib: "CAPRELSA 300MG CPR PELLIC",
  UCD7: '9381245',
  UCD13: '3400893812457',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPRELSA 300MG CPR PELLIC BT 30",
  atcCode: "L01XE12"
}, {
  CIP7: '4913134',
  CIP13: '3400949131341',
  ucdLib: "VOTRIENT 200MG CPR",
  UCD7: '9355609',
  UCD13: '3400893556092',
  ucdQtyMultiplicator: 30,
  cipLib: "VOTRIENT 200MG CPR BT 30",
  atcCode: "L01XE11"
}, {
  CIP7: '4913157',
  CIP13: '3400949131570',
  ucdLib: "VOTRIENT 400MG CPR",
  UCD7: '9355615',
  UCD13: '3400893556153',
  ucdQtyMultiplicator: 30,
  cipLib: "VOTRIENT 400MG CPR BT 30",
  atcCode: "L01XE11"
}, {
  CIP7: '4913163',
  CIP13: '3400949131631',
  ucdLib: "VOTRIENT 400MG CPR",
  UCD7: '9355615',
  UCD13: '3400893556153',
  ucdQtyMultiplicator: 60,
  cipLib: "VOTRIENT 400MG CPR BT 60",
  atcCode: "L01XE11"
}, {
  CIP7: '2764351',
  CIP13: '3400927643514',
  ucdLib: "VOTUBIA 2MG CPR DISP",
  UCD7: '9405170',
  UCD13: '3400894051701',
  ucdQtyMultiplicator: 30,
  cipLib: "VOTUBIA 2MG CPR DISP BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '2764368',
  CIP13: '3400927643682',
  ucdLib: "VOTUBIA 3MG CPR DISP",
  UCD7: '9405187',
  UCD13: '3400894051879',
  ucdQtyMultiplicator: 30,
  cipLib: "VOTUBIA 3MG CPR DISP BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '2764374',
  CIP13: '3400927643743',
  ucdLib: "VOTUBIA 5MG CPR DISP",
  UCD7: '9405193',
  UCD13: '3400894051930',
  ucdQtyMultiplicator: 30,
  cipLib: "VOTUBIA 5MG CPR DISP BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '3962828',
  CIP13: '3400939628288',
  ucdLib: "AFINITOR 10MG CPR",
  UCD7: '9339326',
  UCD13: '3400893393260',
  ucdQtyMultiplicator: 30,
  cipLib: "AFINITOR 10MG CPR BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '3962811',
  CIP13: '3400939628110',
  ucdLib: "AFINITOR 5MG CPR",
  UCD7: '9339332',
  UCD13: '3400893393321',
  ucdQtyMultiplicator: 30,
  cipLib: "AFINITOR 5MG CPR BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '2194770',
  CIP13: '3400921947700',
  ucdLib: "VOTUBIA 10MG CPR",
  UCD7: '9401002',
  UCD13: '3400894010029',
  ucdQtyMultiplicator: 30,
  cipLib: "VOTUBIA 10MG CPR BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '2194758',
  CIP13: '3400921947588',
  ucdLib: "VOTUBIA 2,5MG CPR",
  UCD7: '9377700',
  UCD13: '3400893777008',
  ucdQtyMultiplicator: 30,
  cipLib: "VOTUBIA 2,5MG CPR BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '2194764',
  CIP13: '3400921947649',
  ucdLib: "VOTUBIA 5MG CPR",
  UCD7: '9377717',
  UCD13: '3400893777176',
  ucdQtyMultiplicator: 30,
  cipLib: "VOTUBIA 5MG CPR BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '2678841',
  CIP13: '3400926788414',
  ucdLib: "AFINITOR 2,5MG CPR",
  UCD7: '9413264',
  UCD13: '3400894132646',
  ucdQtyMultiplicator: 30,
  cipLib: "AFINITOR 2,5MG CPR BT 30",
  atcCode: "L01XE10"
}, {
  CIP7: '5717837',
  CIP13: '3400957178376',
  ucdLib: "TORISEL 30MG PERF FL+FL",
  UCD7: '9304776',
  UCD13: '3400893047767',
  ucdQtyMultiplicator: 1,
  cipLib: "TORISEL 30MG PERF FL+FL BT 1",
  atcCode: "L01XE09"
}, {
  CIP7: '4981584',
  CIP13: '3400949815845',
  ucdLib: "TASIGNA 150MG GELU",
  UCD7: '9381044',
  UCD13: '3400893810446',
  ucdQtyMultiplicator: 28,
  cipLib: "TASIGNA 150MG GELU BT 28",
  atcCode: "L01XE08"
}, {
  CIP7: '4981590',
  CIP13: '3400949815906',
  ucdLib: "TASIGNA 150MG GELU",
  UCD7: '9381044',
  UCD13: '3400893810446',
  ucdQtyMultiplicator: 112,
  cipLib: "TASIGNA 150MG GELU BT 112",
  atcCode: "L01XE08"
}, {
  CIP7: '2168755',
  CIP13: '3400921687552',
  ucdLib: "TASIGNA 200MG GELU S/ET",
  UCD7: '9307527',
  UCD13: '3400893075272',
  ucdQtyMultiplicator: 28,
  cipLib: "TASIGNA 200MG GELU S/ET BT 28",
  atcCode: "L01XE08"
}, {
  CIP7: '2168761',
  CIP13: '3400921687613',
  ucdLib: "TASIGNA 200MG GELU S/ET",
  UCD7: '9307527',
  UCD13: '3400893075272',
  ucdQtyMultiplicator: 112,
  cipLib: "TASIGNA 200MG GELU S/ET BT 112",
  atcCode: "L01XE08"
}, {
  CIP7: '4170176',
  CIP13: '3400941701764',
  ucdLib: "TYVERB 250MG CPR PELLIC",
  UCD7: '9298745',
  UCD13: '3400892987453',
  ucdQtyMultiplicator: 70,
  cipLib: "TYVERB 250MG CPR PELLIC BT 70",
  atcCode: "L01XE07"
}, {
  CIP7: '4170182',
  CIP13: '3400941701825',
  ucdLib: "TYVERB 250MG CPR PELLIC",
  UCD7: '9298745',
  UCD13: '3400892987453',
  ucdQtyMultiplicator: 140,
  cipLib: "TYVERB 250MG CPR PELLIC BT 140",
  atcCode: "L01XE07"
}, {
  CIP7: '4170199',
  CIP13: '3400941701993',
  ucdLib: "TYVERB 250MG CPR PELLIC",
  UCD7: '9298745',
  UCD13: '3400892987453',
  ucdQtyMultiplicator: 84,
  cipLib: "TYVERB 250MG CPR PELLIC BT 84",
  atcCode: "L01XE07"
}, {
  CIP7: '3776379',
  CIP13: '3400937763790',
  ucdLib: "SPRYCEL 20MG CPR",
  UCD7: '9293311',
  UCD13: '3400892933115',
  ucdQtyMultiplicator: 60,
  cipLib: "SPRYCEL 20MG CPR BT 60",
  atcCode: "L01XE06"
}, {
  CIP7: '3776416',
  CIP13: '3400937764162',
  ucdLib: "SPRYCEL 50MG CPR",
  UCD7: '9293328',
  UCD13: '3400892933283',
  ucdQtyMultiplicator: 60,
  cipLib: "SPRYCEL 50MG CPR BT 60",
  atcCode: "L01XE06"
}, {
  CIP7: '3776445',
  CIP13: '3400937764452',
  ucdLib: "SPRYCEL 70MG CPR",
  UCD7: '9293506',
  UCD13: '3400892935065',
  ucdQtyMultiplicator: 60,
  cipLib: "SPRYCEL 70MG CPR BT 60",
  atcCode: "L01XE06"
}, {
  CIP7: '3915958',
  CIP13: '3400939159584',
  ucdLib: "SPRYCEL 100MG CPR",
  UCD7: '9326223',
  UCD13: '3400893262238',
  ucdQtyMultiplicator: 30,
  cipLib: "SPRYCEL 100MG CPR BT 30",
  atcCode: "L01XE06"
}, {
  CIP7: '4946174',
  CIP13: '3400949461745',
  ucdLib: "SPRYCEL 140MG CPR",
  UCD7: '9372714',
  UCD13: '3400893727140',
  ucdQtyMultiplicator: 30,
  cipLib: "SPRYCEL 140MG CPR BT 30",
  atcCode: "L01XE06"
}, {
  CIP7: '3761372',
  CIP13: '3400937613729',
  ucdLib: "NEXAVAR 200MG CPR",
  UCD7: '9285375',
  UCD13: '3400892853758',
  ucdQtyMultiplicator: 112,
  cipLib: "NEXAVAR 200MG CPR BT 112",
  atcCode: "L01XE05"
}, {
  CIP7: '3821022',
  CIP13: '3400938210224',
  ucdLib: "SUTENT 12,5MG GELU",
  UCD7: '9284915',
  UCD13: '3400892849157',
  ucdQtyMultiplicator: 28,
  cipLib: "SUTENT 12,5MG GELU BT 28",
  atcCode: "L01XE04"
}, {
  CIP7: '3821039',
  CIP13: '3400938210392',
  ucdLib: "SUTENT 25MG GELU",
  UCD7: '9284921',
  UCD13: '3400892849218',
  ucdQtyMultiplicator: 28,
  cipLib: "SUTENT 25MG GELU BT 28",
  atcCode: "L01XE04"
}, {
  CIP7: '3821045',
  CIP13: '3400938210453',
  ucdLib: "SUTENT 50MG GELU",
  UCD7: '9284938',
  UCD13: '3400892849386',
  ucdQtyMultiplicator: 28,
  cipLib: "SUTENT 50MG GELU BT 28",
  atcCode: "L01XE04"
}, {
  CIP7: '3692346',
  CIP13: '3400936923461',
  ucdLib: "TARCEVA 100MG CPR PELLIC",
  UCD7: '9271723',
  UCD13: '3400892717234',
  ucdQtyMultiplicator: 30,
  cipLib: "TARCEVA 100MG CPR PELLIC BT 30",
  atcCode: "L01XE03"
}, {
  CIP7: '3692352',
  CIP13: '3400936923522',
  ucdLib: "TARCEVA 150MG CPR PELLIC",
  UCD7: '9271746',
  UCD13: '3400892717463',
  ucdQtyMultiplicator: 30,
  cipLib: "TARCEVA 150MG CPR PELLIC BT 30",
  atcCode: "L01XE03"
}, {
  CIP7: '3692323',
  CIP13: '3400936923232',
  ucdLib: "TARCEVA 25MG CPR PELLIC",
  UCD7: '9271752',
  UCD13: '3400892717524',
  ucdQtyMultiplicator: 30,
  cipLib: "TARCEVA 25MG CPR PELLIC BT 30",
  atcCode: "L01XE03"
}, {
  CIP7: '3959507',
  CIP13: '3400939595078',
  ucdLib: "IRESSA 250MG CPR",
  UCD7: '9241981',
  UCD13: '3400892419817',
  ucdQtyMultiplicator: 30,
  cipLib: "IRESSA 250MG CPR BT 30",
  atcCode: "L01XE02"
}, {
  CIP7: '3006289',
  CIP13: '3400930062890',
  ucdLib: "IMATINIB BGR 100MG CPR",
  UCD7: '9421619',
  UCD13: '3400894216193',
  ucdQtyMultiplicator: 60,
  cipLib: "IMATINIB BGR 100MG CPR BT 60",
  atcCode: "L01XE01"
}, {
  CIP7: '3006296',
  CIP13: '3400930062968',
  ucdLib: "IMATINIB BGR 400MG CPR",
  UCD7: '9421625',
  UCD13: '3400894216254',
  ucdQtyMultiplicator: 30,
  cipLib: "IMATINIB BGR 400MG CPR BT 30",
  atcCode: "L01XE01"
}, {
  CIP7: '3005701',
  CIP13: '3400930057018',
  ucdLib: "IMATINIB HCS 100MG CPR",
  UCD7: '9422079',
  UCD13: '3400894220794',
  ucdQtyMultiplicator: 60,
  cipLib: "IMATINIB HCS 100MG CPR BT 60",
  atcCode: "L01XE01"
}, {
  CIP7: '3005706',
  CIP13: '3400930057063',
  ucdLib: "IMATINIB HCS 400MG CPR",
  UCD7: '9422085',
  UCD13: '3400894220855',
  ucdQtyMultiplicator: 30,
  cipLib: "IMATINIB HCS 400MG CPR BT 30",
  atcCode: "L01XE01"
}, {
  CIP7: '3006796',
  CIP13: '3400930067963',
  ucdLib: "IMATINIB MYL 100MG CPR",
  UCD7: '9420057',
  UCD13: '3400894200574',
  ucdQtyMultiplicator: 60,
  cipLib: "IMATINIB MYL 100MG CPR BT 60",
  atcCode: "L01XE01"
}, {
  CIP7: '3006797',
  CIP13: '3400930067970',
  ucdLib: "IMATINIB MYL 400MG CPR",
  UCD7: '9420063',
  UCD13: '3400894200635',
  ucdQtyMultiplicator: 30,
  cipLib: "IMATINIB MYL 400MG CPR BT 30",
  atcCode: "L01XE01"
}, {
  CIP7: '3004830',
  CIP13: '3400930048306',
  ucdLib: "IMATINIB SDZ 100MG CPR",
  UCD7: '9420471',
  UCD13: '3400894204718',
  ucdQtyMultiplicator: 60,
  cipLib: "IMATINIB SDZ 100MG CPR BT 60",
  atcCode: "L01XE01"
}, {
  CIP7: '3004835',
  CIP13: '3400930048351',
  ucdLib: "IMATINIB SDZ 400MG CPR",
  UCD7: '9420488',
  UCD13: '3400894204886',
  ucdQtyMultiplicator: 30,
  cipLib: "IMATINIB SDZ 400MG CPR BT 30",
  atcCode: "L01XE01"
}, {
  CIP7: '3005711',
  CIP13: '3400930057117',
  ucdLib: "IMATINIB TVC 100MG CPR",
  UCD7: '9420229',
  UCD13: '3400894202295',
  ucdQtyMultiplicator: 60,
  cipLib: "IMATINIB TVC 100MG CPR BT 60",
  atcCode: "L01XE01"
}, {
  CIP7: '3005712',
  CIP13: '3400930057124',
  ucdLib: "IMATINIB TVC 400MG CPR",
  UCD7: '9420235',
  UCD13: '3400894202356',
  ucdQtyMultiplicator: 30,
  cipLib: "IMATINIB TVC 400MG CPR BT 30",
  atcCode: "L01XE01"
}, {
  CIP7: '3622475',
  CIP13: '3400936224759',
  ucdLib: "GLIVEC 100MG CPR",
  UCD7: '9263511',
  UCD13: '3400892635118',
  ucdQtyMultiplicator: 60,
  cipLib: "GLIVEC 100MG CPR BT 60",
  atcCode: "L01XE01"
}, {
  CIP7: '3622498',
  CIP13: '3400936224988',
  ucdLib: "GLIVEC 400MG CPR",
  UCD7: '9263528',
  UCD13: '3400892635286',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIVEC 400MG CPR BT 30",
  atcCode: "L01XE01"
}, {
  CIP7: '5732251',
  CIP13: '3400957322519',
  ucdLib: "GLIOLAN 30MG/ML BUV PDR FL",
  UCD7: '9318028',
  UCD13: '3400893180280',
  ucdQtyMultiplicator: 1,
  cipLib: "GLIOLAN 30MG/ML BUV PDR FL BT 1",
  atcCode: "L01XD04"
}, {
  CIP7: '3771985',
  CIP13: '3400937719858',
  ucdLib: "METVIXIA 168MG/G CR TB2G",
  UCD7: '9296999',
  UCD13: '3400892969992',
  ucdQtyMultiplicator: 1,
  cipLib: "METVIXIA 168MG/G CR TB2G BT 1",
  atcCode: "L01XD03"
}, {
  CIP7: '5594926',
  CIP13: '3400955949268',
  ucdLib: "PHOTOFRIN 75MG INJ FL",
  UCD7: '9194052',
  UCD13: '3400891940527',
  ucdQtyMultiplicator: 1,
  cipLib: "PHOTOFRIN 75MG INJ FL BT 1",
  atcCode: "L01XD01"
}, {
  CIP7: '5502181',
  CIP13: '3400955021810',
  ucdLib: "DARZALEX 20MG/ML PERF FL20ML",
  UCD7: '9417871',
  UCD13: '3400894178712',
  ucdQtyMultiplicator: 1,
  cipLib: "DARZALEX 20MG/ML PERF FL20ML BT 1",
  atcCode: "L01XC24"
}, {
  CIP7: '5502180',
  CIP13: '3400955021803',
  ucdLib: "DARZALEX 20MG/ML PERF FL5ML",
  UCD7: '9417888',
  UCD13: '3400894178880',
  ucdQtyMultiplicator: 1,
  cipLib: "DARZALEX 20MG/ML PERF FL5ML BT 1",
  atcCode: "L01XC24"
}, {
  CIP7: '5500027',
  CIP13: '3400955000273',
  ucdLib: "CYRAMZA 10MG/ML PERF FL10ML",
  UCD7: '9405572',
  UCD13: '3400894055723',
  ucdQtyMultiplicator: 1,
  cipLib: "CYRAMZA 10MG/ML PERF FL10ML BT 1",
  atcCode: "L01XC21"
}, {
  CIP7: '5500029',
  CIP13: '3400955000297',
  ucdLib: "CYRAMZA 10MG/ML PERF FL50ML",
  UCD7: '9405589',
  UCD13: '3400894055891',
  ucdQtyMultiplicator: 1,
  cipLib: "CYRAMZA 10MG/ML PERF FL50ML BT 1",
  atcCode: "L01XC21"
}, {
  CIP7: '5501347',
  CIP13: '3400955013471',
  ucdLib: "BLINCYTO 38,5MCG PERF F+F10ML",
  UCD7: '9412129',
  UCD13: '3400894121299',
  ucdQtyMultiplicator: 1,
  cipLib: "BLINCYTO 38,5MCG PERF F+F10ML BT 1",
  atcCode: "L01XC19"
}, {
  CIP7: '5500655',
  CIP13: '3400955006558',
  ucdLib: "KEYTRUDA 50MG PERF FL15ML",
  UCD7: '9409535',
  UCD13: '3400894095354',
  ucdQtyMultiplicator: 1,
  cipLib: "KEYTRUDA 50MG PERF FL15ML BT 1",
  atcCode: "L01XC18"
}, {
  CIP7: '5500580',
  CIP13: '3400955005803',
  ucdLib: "OPDIVO 10MG/ML PERF FL10ML",
  UCD7: '9409452',
  UCD13: '3400894094524',
  ucdQtyMultiplicator: 1,
  cipLib: "OPDIVO 10MG/ML PERF FL10ML BT 1",
  atcCode: "L01XC17"
}, {
  CIP7: '5500579',
  CIP13: '3400955005797',
  ucdLib: "OPDIVO 10MG/ML PERF FL4ML",
  UCD7: '9409469',
  UCD13: '3400894094692',
  ucdQtyMultiplicator: 1,
  cipLib: "OPDIVO 10MG/ML PERF FL4ML BT 1",
  atcCode: "L01XC17"
}, {
  CIP7: '5870036',
  CIP13: '3400958700361',
  ucdLib: "GAZYVARO 1000MG PERF FL40ML",
  UCD7: '9406761',
  UCD13: '3400894067610',
  ucdQtyMultiplicator: 1,
  cipLib: "GAZYVARO 1000MG PERF FL40ML BT 1",
  atcCode: "L01XC15"
}, {
  CIP7: '5857604',
  CIP13: '3400958576041',
  ucdLib: "KADCYLA 100MG PERF FL",
  UCD7: '9400043',
  UCD13: '3400894000433',
  ucdQtyMultiplicator: 1,
  cipLib: "KADCYLA 100MG PERF FL BT 1",
  atcCode: "L01XC14"
}, {
  CIP7: '5857610',
  CIP13: '3400958576102',
  ucdLib: "KADCYLA 160MG PERF FL",
  UCD7: '9400066',
  UCD13: '3400894000662',
  ucdQtyMultiplicator: 1,
  cipLib: "KADCYLA 160MG PERF FL BT 1",
  atcCode: "L01XC14"
}, {
  CIP7: '5846339',
  CIP13: '3400958463396',
  ucdLib: "PERJETA 420MG PERF FL14ML",
  UCD7: '9395106',
  UCD13: '3400893951064',
  ucdQtyMultiplicator: 1,
  cipLib: "PERJETA 420MG PERF FL14ML BT 1",
  atcCode: "L01XC13"
}, {
  CIP7: '5839718',
  CIP13: '3400958397189',
  ucdLib: "ADCETRIS 50MG PERF FL",
  UCD7: '9391344',
  UCD13: '3400893913444',
  ucdQtyMultiplicator: 1,
  cipLib: "ADCETRIS 50MG PERF FL BT 1",
  atcCode: "L01XC12"
}, {
  CIP7: '5808770',
  CIP13: '3400958087707',
  ucdLib: "YERVOY 5MG/ML PERF FL10ML",
  UCD7: '9374050',
  UCD13: '3400893740507',
  ucdQtyMultiplicator: 1,
  cipLib: "YERVOY 5MG/ML PERF FL10ML BT 1",
  atcCode: "L01XC11"
}, {
  CIP7: '5808787',
  CIP13: '3400958087875',
  ucdLib: "YERVOY 5MG/ML PERF FL40ML",
  UCD7: '9374067',
  UCD13: '3400893740675',
  ucdQtyMultiplicator: 1,
  cipLib: "YERVOY 5MG/ML PERF FL40ML BT 1",
  atcCode: "L01XC11"
}, {
  CIP7: '5870289',
  CIP13: '3400958702891',
  ucdLib: "ARZERRA 1000MG PERF FL50ML",
  UCD7: '9404437',
  UCD13: '3400894044376',
  ucdQtyMultiplicator: 1,
  cipLib: "ARZERRA 1000MG PERF FL50ML BT 1",
  atcCode: "L01XC10"
}, {
  CIP7: '5870272',
  CIP13: '3400958702723',
  ucdLib: "ARZERRA 100MG PERF FL5ML",
  UCD7: '9404443',
  UCD13: '3400894044437',
  ucdQtyMultiplicator: 3,
  cipLib: "ARZERRA 100MG PERF FL5ML BT 3",
  atcCode: "L01XC10"
}, {
  CIP7: '5755358',
  CIP13: '3400957553586',
  ucdLib: "REMOVAB 10MCG PERF SRG0,1ML",
  UCD7: '9348124',
  UCD13: '3400893481240',
  ucdQtyMultiplicator: 1,
  cipLib: "REMOVAB 10MCG PERF SRG0,1ML BT 1",
  atcCode: "L01XC09"
}, {
  CIP7: '5755364',
  CIP13: '3400957553647',
  ucdLib: "REMOVAB 50MCG PERF SRG0,5ML",
  UCD7: '9348130',
  UCD13: '3400893481301',
  ucdQtyMultiplicator: 1,
  cipLib: "REMOVAB 50MCG PERF SRG0,5ML BT 1",
  atcCode: "L01XC09"
}, {
  CIP7: '5718216',
  CIP13: '3400957182168',
  ucdLib: "VECTIBIX 20MG/ML PERF FL20ML",
  UCD7: '9307177',
  UCD13: '3400893071779',
  ucdQtyMultiplicator: 1,
  cipLib: "VECTIBIX 20MG/ML PERF FL20ML BT 1",
  atcCode: "L01XC08"
}, {
  CIP7: '5718185',
  CIP13: '3400957181857',
  ucdLib: "VECTIBIX 20MG/ML PERF FL5ML",
  UCD7: '9307183',
  UCD13: '3400893071830',
  ucdQtyMultiplicator: 1,
  cipLib: "VECTIBIX 20MG/ML PERF FL5ML BT 1",
  atcCode: "L01XC08"
}, {
  CIP7: '5662013',
  CIP13: '3400956620135',
  ucdLib: "AVASTIN 25MG/ML PERF FL16ML",
  UCD7: '9261110',
  UCD13: '3400892611105',
  ucdQtyMultiplicator: 1,
  cipLib: "AVASTIN 25MG/ML PERF FL16ML BT 1",
  atcCode: "L01XC07"
}, {
  CIP7: '5662007',
  CIP13: '3400956620074',
  ucdLib: "AVASTIN 25MG/ML PERF FL4ML",
  UCD7: '9261104',
  UCD13: '3400892611044',
  ucdQtyMultiplicator: 1,
  cipLib: "AVASTIN 25MG/ML PERF FL4ML BT 1",
  atcCode: "L01XC07"
}, {
  CIP7: '5707520',
  CIP13: '3400957075200',
  ucdLib: "ERBITUX 5MG/ML PERF FL100ML",
  UCD7: '9301111',
  UCD13: '3400893011119',
  ucdQtyMultiplicator: 1,
  cipLib: "ERBITUX 5MG/ML PERF FL100ML BT 1",
  atcCode: "L01XC06"
}, {
  CIP7: '5707508',
  CIP13: '3400957075088',
  ucdLib: "ERBITUX 5MG/ML PERF FL20ML",
  UCD7: '9301128',
  UCD13: '3400893011287',
  ucdQtyMultiplicator: 1,
  cipLib: "ERBITUX 5MG/ML PERF FL20ML BT 1",
  atcCode: "L01XC06"
}, {
  CIP7: '5893669',
  CIP13: '3400958936692',
  ucdLib: "MYLOTARG 5MG PERF FL",
  UCD7: '9299176',
  UCD13: '3400892991764',
  ucdQtyMultiplicator: 1,
  cipLib: "MYLOTARG 5MG PERF FL BT 1",
  atcCode: "L01XC05"
}, {
  CIP7: '5621037',
  CIP13: '3400956210374',
  ucdLib: "HERCEPTIN 150MG INJ FL",
  UCD7: '9220097',
  UCD13: '3400892200972',
  ucdQtyMultiplicator: 1,
  cipLib: "HERCEPTIN 150MG INJ FL BT 1",
  atcCode: "L01XC03"
}, {
  CIP7: '5855769',
  CIP13: '3400958557699',
  ucdLib: "HERCEPTIN 600MG INJ FL5ML",
  UCD7: '9400037',
  UCD13: '3400894000372',
  ucdQtyMultiplicator: 1,
  cipLib: "HERCEPTIN 600MG INJ FL5ML BT 1",
  atcCode: "L01XC03"
}, {
  CIP7: '5865992',
  CIP13: '3400958659928',
  ucdLib: "MABTHERA 1400MG INJ SC FL",
  UCD7: '9403691',
  UCD13: '3400894036913',
  ucdQtyMultiplicator: 1,
  cipLib: "MABTHERA 1400MG INJ SC FL BT 1",
  atcCode: "L01XC02"
}, {
  CIP7: '5606003',
  CIP13: '3400956060030',
  ucdLib: "MABTHERA 100MG PERF FL10ML",
  UCD7: '9197702',
  UCD13: '3400891977028',
  ucdQtyMultiplicator: 2,
  cipLib: "MABTHERA 100MG PERF FL10ML BT 2",
  atcCode: "L01XC02"
}, {
  CIP7: '5606026',
  CIP13: '3400956060269',
  ucdLib: "MABTHERA 500MG PERF FL50ML",
  UCD7: '9197719',
  UCD13: '3400891977196',
  ucdQtyMultiplicator: 1,
  cipLib: "MABTHERA 500MG PERF FL50ML BT 1",
  atcCode: "L01XC02"
}, {
  CIP7: '3000877',
  CIP13: '3400930008775',
  ucdLib: "NATULAN 50MG GELU",
  UCD7: '9061173',
  UCD13: '3400890611732',
  ucdQtyMultiplicator: 50,
  cipLib: "NATULAN 50MG GELU BT 50",
  atcCode: "L01XB01"
}, {
  CIP7: '5695604',
  CIP13: '3400956956043',
  ucdLib: "ELOXATINE 5MG/ML PERF FL40ML",
  UCD7: '9290637',
  UCD13: '3400892906379',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOXATINE 5MG/ML PERF FL40ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5759273',
  CIP13: '3400957592738',
  ucdLib: "OXALIPLATIN.KBI 5MG/ML 10ML +P",
  UCD7: '9339272',
  UCD13: '3400893392720',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.KBI 5MG/ML 10ML +P BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5759296',
  CIP13: '3400957592967',
  ucdLib: "OXALIPLATIN.KBI 5MG/ML 20ML +P",
  UCD7: '9339289',
  UCD13: '3400893392898',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.KBI 5MG/ML 20ML +P BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5724808',
  CIP13: '3400957248086',
  ucdLib: "OXALIPLATIN.MAY 5MG/ML 10ML +O",
  UCD7: '9312793',
  UCD13: '3400893127933',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.MAY 5MG/ML 10ML +O BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5724820',
  CIP13: '3400957248208',
  ucdLib: "OXALIPLATIN.MAY 5MG/ML 20ML +O",
  UCD7: '9312801',
  UCD13: '3400893128015',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.MAY 5MG/ML 20ML +O BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5744024',
  CIP13: '3400957440244',
  ucdLib: "OXALIPLATIN.MAY 5MG/ML 40ML +O",
  UCD7: '9323851',
  UCD13: '3400893238516',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.MAY 5MG/ML 40ML +O BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5718713',
  CIP13: '3400957187132',
  ucdLib: "OXALIPLATIN.TVC 5MG/ML 10ML",
  UCD7: '9308863',
  UCD13: '3400893088630',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.TVC 5MG/ML 10ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5718736',
  CIP13: '3400957187361',
  ucdLib: "OXALIPLATIN.TVC 5MG/ML 20ML",
  UCD7: '9308857',
  UCD13: '3400893088579',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.TVC 5MG/ML 20ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5795464',
  CIP13: '3400957954642',
  ucdLib: "OXALIPLATIN.ACC 5MG/ML 40ML",
  UCD7: '9365536',
  UCD13: '3400893655368',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.ACC 5MG/ML 40ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5731056',
  CIP13: '3400957310561',
  ucdLib: "OXALIPLATIN.ARW 5MG/ML 100MG",
  UCD7: '9319720',
  UCD13: '3400893197202',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.ARW 5MG/ML 100MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5803413',
  CIP13: '3400958034138',
  ucdLib: "OXALIPLATIN.ARW 5MG/ML 10ML",
  UCD7: '9376149',
  UCD13: '3400893761496',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.ARW 5MG/ML 10ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5803436',
  CIP13: '3400958034367',
  ucdLib: "OXALIPLATIN.ARW 5MG/ML 20ML",
  UCD7: '9376155',
  UCD13: '3400893761557',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.ARW 5MG/ML 20ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5803442',
  CIP13: '3400958034428',
  ucdLib: "OXALIPLATIN.ARW 5MG/ML 40ML",
  UCD7: '9376161',
  UCD13: '3400893761618',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.ARW 5MG/ML 40ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5731033',
  CIP13: '3400957310332',
  ucdLib: "OXALIPLATIN.ARW 5MG/ML 50MG",
  UCD7: '9319737',
  UCD13: '3400893197370',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.ARW 5MG/ML 50MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5803666',
  CIP13: '3400958036668',
  ucdLib: "OXALIPLATIN.KBI 5MG/ML 40ML +P",
  UCD7: '9378088',
  UCD13: '3400893780886',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.KBI 5MG/ML 40ML +P BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5732392',
  CIP13: '3400957323929',
  ucdLib: "OXALIPLATIN.TVC 5MG/ML 40ML",
  UCD7: '9316992',
  UCD13: '3400893169926',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.TVC 5MG/ML 40ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5735404',
  CIP13: '3400957354046',
  ucdLib: "OXALIPLATINE EG 5MG/ML 100MG",
  UCD7: '9351758',
  UCD13: '3400893517581',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATINE EG 5MG/ML 100MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5735396',
  CIP13: '3400957353964',
  ucdLib: "OXALIPLATINE EG 5MG/ML 50MG",
  UCD7: '9351770',
  UCD13: '3400893517703',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATINE EG 5MG/ML 50MG BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5659838',
  CIP13: '3400956598380',
  ucdLib: "ELOXATINE 5MG/ML PERF FL10ML",
  UCD7: '9266550',
  UCD13: '3400892665504',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOXATINE 5MG/ML PERF FL10ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5659844',
  CIP13: '3400956598441',
  ucdLib: "ELOXATINE 5MG/ML PERF FL20ML",
  UCD7: '9266567',
  UCD13: '3400892665672',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOXATINE 5MG/ML PERF FL20ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5768415',
  CIP13: '3400957684150',
  ucdLib: "OXALIPLATIN.ACC 5MG/ML 10ML",
  UCD7: '9355288',
  UCD13: '3400893552889',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.ACC 5MG/ML 10ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5768421',
  CIP13: '3400957684211',
  ucdLib: "OXALIPLATIN.ACC 5MG/ML 20ML",
  UCD7: '9355294',
  UCD13: '3400893552940',
  ucdQtyMultiplicator: 1,
  cipLib: "OXALIPLATIN.ACC 5MG/ML 20ML BT 1",
  atcCode: "L01XA03"
}, {
  CIP7: '5618041',
  CIP13: '3400956180417',
  ucdLib: "CARBOPLATINE MYL 10MG/ML 15ML",
  UCD7: '9218605',
  UCD13: '3400892186054',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE MYL 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5618058',
  CIP13: '3400956180585',
  ucdLib: "CARBOPLATINE MYL 10MG/ML 45ML",
  UCD7: '9218611',
  UCD13: '3400892186115',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE MYL 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5618035',
  CIP13: '3400956180356',
  ucdLib: "CARBOPLATINE MYL 10MG/ML 5ML",
  UCD7: '9218628',
  UCD13: '3400892186283',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE MYL 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5618437',
  CIP13: '3400956184378',
  ucdLib: "CARBOPLATINE TVC 10MG/ML 15ML",
  UCD7: '9210213',
  UCD13: '3400892102139',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE TVC 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5618472',
  CIP13: '3400956184729',
  ucdLib: "CARBOPLATINE TVC 10MG/ML 45ML",
  UCD7: '9210236',
  UCD13: '3400892102368',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE TVC 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5618408',
  CIP13: '3400956184088',
  ucdLib: "CARBOPLATINE TVC 10MG/ML 5ML",
  UCD7: '9210242',
  UCD13: '3400892102429',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE TVC 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5631840',
  CIP13: '3400956318407',
  ucdLib: "CARBOPLATINE MYL 10MG/ML 60ML",
  UCD7: '9241159',
  UCD13: '3400892411590',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE MYL 10MG/ML 60ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5725570',
  CIP13: '3400957255701',
  ucdLib: "CARBOPLATINE ACC 10MG/ML 15ML",
  UCD7: '9320054',
  UCD13: '3400893200544',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE ACC 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5725587',
  CIP13: '3400957255879',
  ucdLib: "CARBOPLATINE ACC 10MG/ML 45ML",
  UCD7: '9320060',
  UCD13: '3400893200605',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE ACC 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5725564',
  CIP13: '3400957255640',
  ucdLib: "CARBOPLATINE ACC 10MG/ML 5ML",
  UCD7: '9320077',
  UCD13: '3400893200773',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE ACC 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5725535',
  CIP13: '3400957255350',
  ucdLib: "CARBOPLATINE ARW 10MG/ML 15ML",
  UCD7: '9316207',
  UCD13: '3400893162071',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE ARW 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5725541',
  CIP13: '3400957255411',
  ucdLib: "CARBOPLATINE ARW 10MG/ML 45ML",
  UCD7: '9316213',
  UCD13: '3400893162132',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE ARW 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5725529',
  CIP13: '3400957255299',
  ucdLib: "CARBOPLATINE ARW 10MG/ML 5ML",
  UCD7: '9316236',
  UCD13: '3400893162361',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE ARW 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5725558',
  CIP13: '3400957255589',
  ucdLib: "CARBOPLATINE ARW 10MG/ML 60ML",
  UCD7: '9316242',
  UCD13: '3400893162422',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE ARW 10MG/ML 60ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5708040',
  CIP13: '3400957080402',
  ucdLib: "CARBOPLATINE HPI 10MG A/F60ML",
  UCD7: '9302300',
  UCD13: '3400893023006',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE HPI 10MG A/F60ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5708028',
  CIP13: '3400957080280',
  ucdLib: "CARBOPLATINE HPI 10MG/ML 15ML",
  UCD7: '9302323',
  UCD13: '3400893023235',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE HPI 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5708034',
  CIP13: '3400957080341',
  ucdLib: "CARBOPLATINE HPI 10MG/ML 45ML",
  UCD7: '9302286',
  UCD13: '3400893022863',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE HPI 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5708011',
  CIP13: '3400957080112',
  ucdLib: "CARBOPLATINE HPI 10MG/ML 5ML",
  UCD7: '9302292',
  UCD13: '3400893022924',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE HPI 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5787482',
  CIP13: '3400957874827',
  ucdLib: "CARBOPLATINE ACC 10MG/ML 60ML",
  UCD7: '9362271',
  UCD13: '3400893622711',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE ACC 10MG/ML 60ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5838618',
  CIP13: '3400958386183',
  ucdLib: "CARBOPLATINE KBI 10MG/ML 15ML",
  UCD7: '9392510',
  UCD13: '3400893925102',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE KBI 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5838624',
  CIP13: '3400958386244',
  ucdLib: "CARBOPLATINE KBI 10MG/ML 45ML",
  UCD7: '9392527',
  UCD13: '3400893925270',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE KBI 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5838601',
  CIP13: '3400958386015',
  ucdLib: "CARBOPLATINE KBI 10MG/ML 5ML",
  UCD7: '9392533',
  UCD13: '3400893925331',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE KBI 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5838630',
  CIP13: '3400958386305',
  ucdLib: "CARBOPLATINE KBI 10MG/ML 60ML",
  UCD7: '9392556',
  UCD13: '3400893925560',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE KBI 10MG/ML 60ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5769656',
  CIP13: '3400957696566',
  ucdLib: "CARBOPLATINE SUN 10MG/ML 15ML",
  UCD7: '9356069',
  UCD13: '3400893560693',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE SUN 10MG/ML 15ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5769685',
  CIP13: '3400957696856',
  ucdLib: "CARBOPLATINE SUN 10MG/ML 45ML",
  UCD7: '9356075',
  UCD13: '3400893560754',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE SUN 10MG/ML 45ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5769610',
  CIP13: '3400957696108',
  ucdLib: "CARBOPLATINE SUN 10MG/ML 5ML",
  UCD7: '9356081',
  UCD13: '3400893560815',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE SUN 10MG/ML 5ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5769722',
  CIP13: '3400957697228',
  ucdLib: "CARBOPLATINE SUN 10MG/ML 60ML",
  UCD7: '9356098',
  UCD13: '3400893560983',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE SUN 10MG/ML 60ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5653528',
  CIP13: '3400956535286',
  ucdLib: "CARBOPLATINE TVC 10MG/ML 60ML",
  UCD7: '9259691',
  UCD13: '3400892596914',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOPLATINE TVC 10MG/ML 60ML BT 1",
  atcCode: "L01XA02"
}, {
  CIP7: '5622539',
  CIP13: '3400956225392',
  ucdLib: "CISPLATINE MYL 10MG/10ML FL",
  UCD7: '9217592',
  UCD13: '3400892175928',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE MYL 10MG/10ML FL BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5622516',
  CIP13: '3400956225163',
  ucdLib: "CISPLATINE MYL 1MG/ML FL50ML",
  UCD7: '9217617',
  UCD13: '3400892176178',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE MYL 1MG/ML FL50ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5622522',
  CIP13: '3400956225224',
  ucdLib: "CISPLATINE MYL 25MG/25ML FL",
  UCD7: '9217600',
  UCD13: '3400892176000',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE MYL 25MG/25ML FL BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5622999',
  CIP13: '3400956229994',
  ucdLib: "CISPLATINE TVC PERF FL100ML",
  UCD7: '9220275',
  UCD13: '3400892202754',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE TVC PERF FL100ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5610269',
  CIP13: '3400956102693',
  ucdLib: "CISPLATINE TVC PERF FL10ML",
  UCD7: '9208245',
  UCD13: '3400892082455',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE TVC PERF FL10ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5610329',
  CIP13: '3400956103294',
  ucdLib: "CISPLATINE TVC PERF FL50ML",
  UCD7: '9208268',
  UCD13: '3400892082684',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE TVC PERF FL50ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5631857',
  CIP13: '3400956318575',
  ucdLib: "CISPLATINE MYL 1MG/ML FL100ML",
  UCD7: '9240740',
  UCD13: '3400892407401',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE MYL 1MG/ML FL100ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5793778',
  CIP13: '3400957937782',
  ucdLib: "CISPLATINE ACC 1MG/ML FL100ML",
  UCD7: '9364790',
  UCD13: '3400893647905',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE ACC 1MG/ML FL100ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5761554',
  CIP13: '3400957615543',
  ucdLib: "CISPLATINE ACC 1MG/ML FL10ML",
  UCD7: '9343115',
  UCD13: '3400893431153',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE ACC 1MG/ML FL10ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5761560',
  CIP13: '3400957615604',
  ucdLib: "CISPLATINE ACC 1MG/ML FL25ML",
  UCD7: '9343121',
  UCD13: '3400893431214',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE ACC 1MG/ML FL25ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '5761577',
  CIP13: '3400957615772',
  ucdLib: "CISPLATINE ACC 1MG/ML FL50ML",
  UCD7: '9343138',
  UCD13: '3400893431382',
  ucdQtyMultiplicator: 1,
  cipLib: "CISPLATINE ACC 1MG/ML FL50ML BT 1",
  atcCode: "L01XA01"
}, {
  CIP7: '3575480',
  CIP13: '3400935754806',
  ucdLib: "AMETYCINE 40MG IRR FL+SRG",
  UCD7: '9237755',
  UCD13: '3400892377551',
  ucdQtyMultiplicator: 1,
  cipLib: "AMETYCINE 40MG IRR FL+SRG BT 1",
  atcCode: "L01DC03"
}, {
  CIP7: '3604767',
  CIP13: '3400936047679',
  ucdLib: "AMETYCINE 10MG INJ FL",
  UCD7: '9003738',
  UCD13: '3400890037389',
  ucdQtyMultiplicator: 1,
  cipLib: "AMETYCINE 10MG INJ FL BT 1",
  atcCode: "L01DC03"
}, {
  CIP7: '3604773',
  CIP13: '3400936047730',
  ucdLib: "AMETYCINE 20MG INJ FL",
  UCD7: '9143250',
  UCD13: '3400891432503',
  ucdQtyMultiplicator: 1,
  cipLib: "AMETYCINE 20MG INJ FL BT 1",
  atcCode: "L01DC03"
}, {
  CIP7: '3013196',
  CIP13: '3400930131961',
  ucdLib: "BLEOMYCINE BLN 15MG INJ FL",
  UCD7: '9011778',
  UCD13: '3400890117784',
  ucdQtyMultiplicator: 1,
  cipLib: "BLEOMYCINE BLN 15MG INJ FL BT 1",
  atcCode: "L01DC01"
}, {
  CIP7: '5517593',
  CIP13: '3400955175933',
  ucdLib: "BLEOMYCINE BLN 15MG INJ FL",
  UCD7: '9011778',
  UCD13: '3400890117784',
  ucdQtyMultiplicator: 10,
  cipLib: "BLEOMYCINE BLN 15MG INJ FL BT 10",
  atcCode: "L01DC01"
}, {
  CIP7: '5839724',
  CIP13: '3400958397240',
  ucdLib: "PIXUVRI 29MG PERF FL",
  UCD7: '9395721',
  UCD13: '3400893957219',
  ucdQtyMultiplicator: 1,
  cipLib: "PIXUVRI 29MG PERF FL BT 1",
  atcCode: "L01DB11"
}, {
  CIP7: '3002594',
  CIP13: '3400930025949',
  ucdLib: "MITOXANTRONE ACC2MG/ML 15ML",
  UCD7: '9411041',
  UCD13: '3400894110415',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE ACC2MG/ML 15ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '3002593',
  CIP13: '3400930025932',
  ucdLib: "MITOXANTRONE ACC2MG/ML 5ML",
  UCD7: '9411058',
  UCD13: '3400894110583',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE ACC2MG/ML 5ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5615634',
  CIP13: '3400956156344',
  ucdLib: "MITOXANTRONE TVC 10MG/5ML FL",
  UCD7: '9268388',
  UCD13: '3400892683881',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE TVC 10MG/5ML FL BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5615640',
  CIP13: '3400956156405',
  ucdLib: "MITOXANTRONE TVC 20MG/10ML FL",
  UCD7: '9268394',
  UCD13: '3400892683942',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE TVC 20MG/10ML FL BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5615657',
  CIP13: '3400956156573',
  ucdLib: "MITOXANTRONE TVC 25MG/12,5ML",
  UCD7: '9268402',
  UCD13: '3400892684024',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE TVC 25MG/12,5ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5643458',
  CIP13: '3400956434589',
  ucdLib: "ELSEP 2MG/ML INJ FL10ML",
  UCD7: '9256385',
  UCD13: '3400892563855',
  ucdQtyMultiplicator: 1,
  cipLib: "ELSEP 2MG/ML INJ FL10ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5632302',
  CIP13: '3400956323029',
  ucdLib: "NOVANTRONE 10MG/5ML IV FL",
  UCD7: '9122348',
  UCD13: '3400891223484',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVANTRONE 10MG/5ML IV FL BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5632294',
  CIP13: '3400956322947',
  ucdLib: "NOVANTRONE 20MG/10ML IV FL",
  UCD7: '9109827',
  UCD13: '3400891098273',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVANTRONE 20MG/10ML IV FL BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5744159',
  CIP13: '3400957441593',
  ucdLib: "MITOXANTRONE EBW2MG/ML 10ML",
  UCD7: '9327725',
  UCD13: '3400893277256',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE EBW2MG/ML 10ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5744165',
  CIP13: '3400957441654',
  ucdLib: "MITOXANTRONE EBW2MG/ML 12,5ML",
  UCD7: '9327731',
  UCD13: '3400893277317',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE EBW2MG/ML 12,5ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5744142',
  CIP13: '3400957441425',
  ucdLib: "MITOXANTRONE EBW2MG/ML 5ML",
  UCD7: '9327748',
  UCD13: '3400893277485',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOXANTRONE EBW2MG/ML 5ML BT 1",
  atcCode: "L01DB07"
}, {
  CIP7: '5574823',
  CIP13: '3400955748236',
  ucdLib: "ZAVEDOS 10MG PERF FL",
  UCD7: '9153395',
  UCD13: '3400891533958',
  ucdQtyMultiplicator: 1,
  cipLib: "ZAVEDOS 10MG PERF FL BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5574846',
  CIP13: '3400955748465',
  ucdLib: "ZAVEDOS 5MG PERF FL",
  UCD7: '9153403',
  UCD13: '3400891534030',
  ucdQtyMultiplicator: 1,
  cipLib: "ZAVEDOS 5MG PERF FL BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '3657516',
  CIP13: '3400936575165',
  ucdLib: "ZAVEDOS 10MG GELU",
  UCD7: '9208624',
  UCD13: '3400892086248',
  ucdQtyMultiplicator: 1,
  cipLib: "ZAVEDOS 10MG GELU BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '3657485',
  CIP13: '3400936574854',
  ucdLib: "ZAVEDOS 25MG GELU",
  UCD7: '9208630',
  UCD13: '3400892086309',
  ucdQtyMultiplicator: 1,
  cipLib: "ZAVEDOS 25MG GELU BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '3657491',
  CIP13: '3400936574915',
  ucdLib: "ZAVEDOS 5MG GELU",
  UCD7: '9208647',
  UCD13: '3400892086477',
  ucdQtyMultiplicator: 1,
  cipLib: "ZAVEDOS 5MG GELU BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5628660',
  CIP13: '3400956286607',
  ucdLib: "ZAVEDOS 10MG INJ FP10ML",
  UCD7: '9268508',
  UCD13: '3400892685083',
  ucdQtyMultiplicator: 1,
  cipLib: "ZAVEDOS 10MG INJ FP10ML BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5628677',
  CIP13: '3400956286775',
  ucdLib: "ZAVEDOS 20MG INJ FP20ML",
  UCD7: '9268520',
  UCD13: '3400892685205',
  ucdQtyMultiplicator: 1,
  cipLib: "ZAVEDOS 20MG INJ FP20ML BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5628654',
  CIP13: '3400956286546',
  ucdLib: "ZAVEDOS 5MG INJ FP5ML",
  UCD7: '9268543',
  UCD13: '3400892685434',
  ucdQtyMultiplicator: 1,
  cipLib: "ZAVEDOS 5MG INJ FP5ML BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5802566',
  CIP13: '3400958025662',
  ucdLib: "IDARUBICINE MYL 1MG/ML FL10ML",
  UCD7: '9371726',
  UCD13: '3400893717264',
  ucdQtyMultiplicator: 1,
  cipLib: "IDARUBICINE MYL 1MG/ML FL10ML BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '5802537',
  CIP13: '3400958025372',
  ucdLib: "IDARUBICINE MYL 1MG/ML FL5ML",
  UCD7: '9371732',
  UCD13: '3400893717325',
  ucdQtyMultiplicator: 1,
  cipLib: "IDARUBICINE MYL 1MG/ML FL5ML BT 1",
  atcCode: "L01DB06"
}, {
  CIP7: '3358771',
  CIP13: '3400933587710',
  ucdLib: "FARMORUBICINE 10MG PERF FL",
  UCD7: '9145332',
  UCD13: '3400891453324',
  ucdQtyMultiplicator: 1,
  cipLib: "FARMORUBICINE 10MG PERF FL BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '3358788',
  CIP13: '3400933587888',
  ucdLib: "FARMORUBICINE 50MG PERF FL",
  UCD7: '9145361',
  UCD13: '3400891453614',
  ucdQtyMultiplicator: 1,
  cipLib: "FARMORUBICINE 50MG PERF FL BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5615019',
  CIP13: '3400956150199',
  ucdLib: "FARMORUBICINE 10MG SOL FP5ML",
  UCD7: '9202834',
  UCD13: '3400892028347',
  ucdQtyMultiplicator: 1,
  cipLib: "FARMORUBICINE 10MG SOL FP5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5614988',
  CIP13: '3400956149889',
  ucdLib: "FARMORUBICINE 200MG FP100ML",
  UCD7: '9202857',
  UCD13: '3400892028576',
  ucdQtyMultiplicator: 1,
  cipLib: "FARMORUBICINE 200MG FP100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5615025',
  CIP13: '3400956150250',
  ucdLib: "FARMORUBICINE 20MG SOL FP10ML",
  UCD7: '9202840',
  UCD13: '3400892028408',
  ucdQtyMultiplicator: 1,
  cipLib: "FARMORUBICINE 20MG SOL FP10ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5615031',
  CIP13: '3400956150311',
  ucdLib: "FARMORUBICINE 50MG SOL FP25ML",
  UCD7: '9202863',
  UCD13: '3400892028637',
  ucdQtyMultiplicator: 1,
  cipLib: "FARMORUBICINE 50MG SOL FP25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5725222',
  CIP13: '3400957252229',
  ucdLib: "EPIRUBICINE ARW 2MG/ML FL100ML",
  UCD7: '9316058',
  UCD13: '3400893160589',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ARW 2MG/ML FL100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5725179',
  CIP13: '3400957251796',
  ucdLib: "EPIRUBICINE ARW 2MG/ML FL10ML",
  UCD7: '9319708',
  UCD13: '3400893197080',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ARW 2MG/ML FL10ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5725185',
  CIP13: '3400957251857',
  ucdLib: "EPIRUBICINE ARW 2MG/ML FL25ML",
  UCD7: '9316064',
  UCD13: '3400893160640',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ARW 2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5725191',
  CIP13: '3400957251918',
  ucdLib: "EPIRUBICINE ARW 2MG/ML FL50ML",
  UCD7: '9319714',
  UCD13: '3400893197141',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ARW 2MG/ML FL50ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5725162',
  CIP13: '3400957251628',
  ucdLib: "EPIRUBICINE ARW 2MG/ML FL5ML",
  UCD7: '9316070',
  UCD13: '3400893160701',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ARW 2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5711289',
  CIP13: '3400957112899',
  ucdLib: "EPIRUBICINE EG 2MG/ML FL100ML",
  UCD7: '9306605',
  UCD13: '3400893066058',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE EG 2MG/ML FL100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5711272',
  CIP13: '3400957112721',
  ucdLib: "EPIRUBICINE EG 2MG/ML FL25ML",
  UCD7: '9306611',
  UCD13: '3400893066119',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE EG 2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5711243',
  CIP13: '3400957112431',
  ucdLib: "EPIRUBICINE EG 2MG/ML FL5ML",
  UCD7: '9306628',
  UCD13: '3400893066287',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE EG 2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5724694',
  CIP13: '3400957246945',
  ucdLib: "EPIRUBICINE MDC 2MG/ML FL100ML",
  UCD7: '9313137',
  UCD13: '3400893131374',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MDC 2MG/ML FL100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5724702',
  CIP13: '3400957247027',
  ucdLib: "EPIRUBICINE MDC 2MG/ML FL200ML",
  UCD7: '9313143',
  UCD13: '3400893131435',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MDC 2MG/ML FL200ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5724671',
  CIP13: '3400957246716',
  ucdLib: "EPIRUBICINE MDC 2MG/ML FL25ML",
  UCD7: '9313166',
  UCD13: '3400893131664',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MDC 2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5724688',
  CIP13: '3400957246884',
  ucdLib: "EPIRUBICINE MDC 2MG/ML FL50ML",
  UCD7: '9313189',
  UCD13: '3400893131893',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MDC 2MG/ML FL50ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5724659',
  CIP13: '3400957246594',
  ucdLib: "EPIRUBICINE MDC 2MG/ML FL5ML",
  UCD7: '9313172',
  UCD13: '3400893131725',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MDC 2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5711220',
  CIP13: '3400957112202',
  ucdLib: "EPIRUBICINE MYL 2MG/ML F100ML",
  UCD7: '9304463',
  UCD13: '3400893044636',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MYL 2MG/ML F100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5711208',
  CIP13: '3400957112080',
  ucdLib: "EPIRUBICINE MYL 2MG/ML FL10ML",
  UCD7: '9304457',
  UCD13: '3400893044575',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MYL 2MG/ML FL10ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5711214',
  CIP13: '3400957112141',
  ucdLib: "EPIRUBICINE MYL 2MG/ML FL25ML",
  UCD7: '9304486',
  UCD13: '3400893044865',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MYL 2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5747821',
  CIP13: '3400957478216',
  ucdLib: "EPIRUBICINE MYL 2MG/ML FL50ML",
  UCD7: '9328481',
  UCD13: '3400893284810',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MYL 2MG/ML FL50ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5711183',
  CIP13: '3400957111830',
  ucdLib: "EPIRUBICINE MYL 2MG/ML FL5ML",
  UCD7: '9304492',
  UCD13: '3400893044926',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE MYL 2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5752420',
  CIP13: '3400957524203',
  ucdLib: "EPIRUBICINE TVC.2MG/ML FL100ML",
  UCD7: '9337936',
  UCD13: '3400893379363',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE TVC.2MG/ML FL100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5752383',
  CIP13: '3400957523831',
  ucdLib: "EPIRUBICINE TVC.2MG/ML FL10ML",
  UCD7: '9337913',
  UCD13: '3400893379134',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE TVC.2MG/ML FL10ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5752408',
  CIP13: '3400957524081',
  ucdLib: "EPIRUBICINE TVC.2MG/ML FL25ML",
  UCD7: '9337942',
  UCD13: '3400893379424',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE TVC.2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5752377',
  CIP13: '3400957523770',
  ucdLib: "EPIRUBICINE TVC.2MG/ML FL5ML",
  UCD7: '9337959',
  UCD13: '3400893379592',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE TVC.2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5676340',
  CIP13: '3400956763405',
  ucdLib: "EPIRUBICINE HPI 2MG/ML FL100ML",
  UCD7: '9284335',
  UCD13: '3400892843353',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE HPI 2MG/ML FL100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5676328',
  CIP13: '3400956763283',
  ucdLib: "EPIRUBICINE HPI 2MG/ML FL25ML",
  UCD7: '9284306',
  UCD13: '3400892843063',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE HPI 2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5676334',
  CIP13: '3400956763344',
  ucdLib: "EPIRUBICINE HPI 2MG/ML FL50ML",
  UCD7: '9284329',
  UCD13: '3400892843292',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE HPI 2MG/ML FL50ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5676311',
  CIP13: '3400956763115',
  ucdLib: "EPIRUBICINE HPI 2MG/ML FL5ML",
  UCD7: '9284312',
  UCD13: '3400892843124',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE HPI 2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5760253',
  CIP13: '3400957602536',
  ucdLib: "EPIRUBICINE ACC 2MG/ML FL100ML",
  UCD7: '9343730',
  UCD13: '3400893437308',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ACC 2MG/ML FL100ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5760230',
  CIP13: '3400957602307',
  ucdLib: "EPIRUBICINE ACC 2MG/ML FL10ML",
  UCD7: '9343724',
  UCD13: '3400893437247',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ACC 2MG/ML FL10ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5760247',
  CIP13: '3400957602475',
  ucdLib: "EPIRUBICINE ACC 2MG/ML FL25ML",
  UCD7: '9343747',
  UCD13: '3400893437476',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ACC 2MG/ML FL25ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5760224',
  CIP13: '3400957602246',
  ucdLib: "EPIRUBICINE ACC 2MG/ML FL5ML",
  UCD7: '9343753',
  UCD13: '3400893437537',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIRUBICINE ACC 2MG/ML FL5ML BT 1",
  atcCode: "L01DB03"
}, {
  CIP7: '5600360',
  CIP13: '3400956003600',
  ucdLib: "DAUNOXOME 2MG/ML INJ FL50ML",
  UCD7: '9184467',
  UCD13: '3400891844672',
  ucdQtyMultiplicator: 1,
  cipLib: "DAUNOXOME 2MG/ML INJ FL50ML BT 1",
  atcCode: "L01DB02"
}, {
  CIP7: '5504805',
  CIP13: '3400955048053',
  ucdLib: "CERUBIDINE 20MG INJ FL",
  UCD7: '9242650',
  UCD13: '3400892426501',
  ucdQtyMultiplicator: 10,
  cipLib: "CERUBIDINE 20MG INJ FL BT 10",
  atcCode: "L01DB02"
}, {
  CIP7: '3340802',
  CIP13: '3400933408022',
  ucdLib: "ADRIBLASTINE 10MG LYOT FL",
  UCD7: '9157849',
  UCD13: '3400891578492',
  ucdQtyMultiplicator: 1,
  cipLib: "ADRIBLASTINE 10MG LYOT FL BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '3340825',
  CIP13: '3400933408251',
  ucdLib: "ADRIBLASTINE 50MG LYOT FL",
  UCD7: '9157855',
  UCD13: '3400891578553',
  ucdQtyMultiplicator: 1,
  cipLib: "ADRIBLASTINE 50MG LYOT FL BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5594866',
  CIP13: '3400955948667',
  ucdLib: "DOXORUBICINE TVC 10MG INJ FL",
  UCD7: '9222647',
  UCD13: '3400892226477',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE TVC 10MG INJ FL BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5594895',
  CIP13: '3400955948957',
  ucdLib: "DOXORUBICINE TVC 200MG INJ FL",
  UCD7: '9222676',
  UCD13: '3400892226767',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE TVC 200MG INJ FL BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5594889',
  CIP13: '3400955948896',
  ucdLib: "DOXORUBICINE TVC 50MG INJ FL",
  UCD7: '9222682',
  UCD13: '3400892226828',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE TVC 50MG INJ FL BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '3461227',
  CIP13: '3400934612275',
  ucdLib: "ADRIBLASTINE 10MG/5ML FP",
  UCD7: '9202774',
  UCD13: '3400892027746',
  ucdQtyMultiplicator: 1,
  cipLib: "ADRIBLASTINE 10MG/5ML FP BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '3461256',
  CIP13: '3400934612565',
  ucdLib: "ADRIBLASTINE 50MG/25ML FP",
  UCD7: '9202780',
  UCD13: '3400892027807',
  ucdQtyMultiplicator: 1,
  cipLib: "ADRIBLASTINE 50MG/25ML FP BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5603619',
  CIP13: '3400956036196',
  ucdLib: "CAELYX 2MG/ML PERF FL10ML",
  UCD7: '9194460',
  UCD13: '3400891944600',
  ucdQtyMultiplicator: 1,
  cipLib: "CAELYX 2MG/ML PERF FL10ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5614971',
  CIP13: '3400956149711',
  ucdLib: "ADRIBLASTINE 200MG/100ML FP",
  UCD7: '9267911',
  UCD13: '3400892679112',
  ucdQtyMultiplicator: 1,
  cipLib: "ADRIBLASTINE 200MG/100ML FP BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5632615',
  CIP13: '3400956326150',
  ucdLib: "CAELYX 2MG/ML PERF FL25ML",
  UCD7: '9229483',
  UCD13: '3400892294834',
  ucdQtyMultiplicator: 1,
  cipLib: "CAELYX 2MG/ML PERF FL25ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5632609',
  CIP13: '3400956326099',
  ucdLib: "MYOCET 50MG PERF FL+FL+FL",
  UCD7: '9233697',
  UCD13: '3400892336978',
  ucdQtyMultiplicator: 2,
  cipLib: "MYOCET 50MG PERF FL+FL+FL BT 2",
  atcCode: "L01DB01"
}, {
  CIP7: '5722100',
  CIP13: '3400957221003',
  ucdLib: "DOXORUBICINE ARW2MG/ML FL10MG",
  UCD7: '9315892',
  UCD13: '3400893158920',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE ARW2MG/ML FL10MG BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5722117',
  CIP13: '3400957221171',
  ucdLib: "DOXORUBICINE ARW2MG/ML FL50MG",
  UCD7: '9315900',
  UCD13: '3400893159002',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE ARW2MG/ML FL50MG BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5713785',
  CIP13: '3400957137854',
  ucdLib: "DOXORUBICINE EG 2MG/ML FL25ML",
  UCD7: '9308188',
  UCD13: '3400893081884',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE EG 2MG/ML FL25ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5713779',
  CIP13: '3400957137793',
  ucdLib: "DOXORUBICINE EG 2MG/ML FL5ML",
  UCD7: '9327151',
  UCD13: '3400893271513',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE EG 2MG/ML FL5ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5791532',
  CIP13: '3400957915322',
  ucdLib: "DOXORUBICINE ACC2MG/ML F100ML",
  UCD7: '9363247',
  UCD13: '3400893632475',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE ACC2MG/ML F100ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5770547',
  CIP13: '3400957705473',
  ucdLib: "DOXORUBICINE ACC2MG/ML FL25ML",
  UCD7: '9353728',
  UCD13: '3400893537282',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE ACC2MG/ML FL25ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5770530',
  CIP13: '3400957705305',
  ucdLib: "DOXORUBICINE ACC2MG/ML FL5ML",
  UCD7: '9353734',
  UCD13: '3400893537343',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE ACC2MG/ML FL5ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5813216',
  CIP13: '3400958132162',
  ucdLib: "DOXORUBICINE ARW2MG/ML F100ML",
  UCD7: '9380636',
  UCD13: '3400893806364',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE ARW2MG/ML F100ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5813179',
  CIP13: '3400958131790',
  ucdLib: "DOXORUBICINE ARW2MG/ML FL25ML",
  UCD7: '9380613',
  UCD13: '3400893806135',
  ucdQtyMultiplicator: 1,
  cipLib: "DOXORUBICINE ARW2MG/ML FL25ML BT 1",
  atcCode: "L01DB01"
}, {
  CIP7: '5643429',
  CIP13: '3400956434299',
  ucdLib: "COSMEGEN 0,5MG INJ FL",
  UCD7: '9255724',
  UCD13: '3400892557243',
  ucdQtyMultiplicator: 1,
  cipLib: "COSMEGEN 0,5MG INJ FL BT 1",
  atcCode: "L01DA01"
}, {
  CIP7: '5715229',
  CIP13: '3400957152291',
  ucdLib: "YONDELIS 0,25MG PERF FL",
  UCD7: '9290519',
  UCD13: '3400892905198',
  ucdQtyMultiplicator: 1,
  cipLib: "YONDELIS 0,25MG PERF FL BT 1",
  atcCode: "L01CX01"
}, {
  CIP7: '5715241',
  CIP13: '3400957152413',
  ucdLib: "YONDELIS 1MG PERF FL",
  UCD7: '9290525',
  UCD13: '3400892905259',
  ucdQtyMultiplicator: 1,
  cipLib: "YONDELIS 1MG PERF FL BT 1",
  atcCode: "L01CX01"
}, {
  CIP7: '5798497',
  CIP13: '3400957984977',
  ucdLib: "JEVTANA 60MG PERF FL+FL",
  UCD7: '9365950',
  UCD13: '3400893659502',
  ucdQtyMultiplicator: 1,
  cipLib: "JEVTANA 60MG PERF FL+FL BT 1",
  atcCode: "L01CD04"
}, {
  CIP7: '2243304',
  CIP13: '3400922433042',
  ucdLib: "DOCETAXEL ACC 160MG/8ML INJ F",
  UCD7: '9384485',
  UCD13: '3400893844854',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL ACC 160MG/8ML INJ F BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '2243273',
  CIP13: '3400922432731',
  ucdLib: "DOCETAXEL ACC 20MG/1ML INJ FL",
  UCD7: '9384491',
  UCD13: '3400893844915',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL ACC 20MG/1ML INJ FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '2243296',
  CIP13: '3400922432960',
  ucdLib: "DOCETAXEL ACC 80MG/4ML INJ FL",
  UCD7: '9384516',
  UCD13: '3400893845165',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL ACC 80MG/4ML INJ FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '2235925',
  CIP13: '3400922359250',
  ucdLib: "DOCETAXEL KBI 160MG/8ML INJ F",
  UCD7: '9387087',
  UCD13: '3400893870877',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL KBI 160MG/8ML INJ F BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '2678858',
  CIP13: '3400926788582',
  ucdLib: "DOCETAXEL KBI 20MG/1ML INJ FL",
  UCD7: '9388891',
  UCD13: '3400893888919',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL KBI 20MG/1ML INJ FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '2235902',
  CIP13: '3400922359021',
  ucdLib: "DOCETAXEL KBI 80MG/4ML INJ FL",
  UCD7: '9387101',
  UCD13: '3400893871010',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL KBI 80MG/4ML INJ FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5793726',
  CIP13: '3400957937263',
  ucdLib: "DOCETAXEL ARW 20MG/ML FL1ML",
  UCD7: '9366636',
  UCD13: '3400893666364',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL ARW 20MG/ML FL1ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5793732',
  CIP13: '3400957937324',
  ucdLib: "DOCETAXEL ARW 20MG/ML FL4ML",
  UCD7: '9366642',
  UCD13: '3400893666425',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL ARW 20MG/ML FL4ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5793749',
  CIP13: '3400957937492',
  ucdLib: "DOCETAXEL ARW 20MG/ML FL7ML",
  UCD7: '9366659',
  UCD13: '3400893666593',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL ARW 20MG/ML FL7ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5798126',
  CIP13: '3400957981266',
  ucdLib: "DOCETAXEL EBW 10MG/ML FL16ML",
  UCD7: '9367535',
  UCD13: '3400893675359',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL EBW 10MG/ML FL16ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5771222',
  CIP13: '3400957712228',
  ucdLib: "DOCETAXEL HPI 10MG/ML FL16ML",
  UCD7: '9351818',
  UCD13: '3400893518182',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL HPI 10MG/ML FL16ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5771191',
  CIP13: '3400957711917',
  ucdLib: "DOCETAXEL HPI 10MG/ML FL2ML",
  UCD7: '9351824',
  UCD13: '3400893518243',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL HPI 10MG/ML FL2ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5771216',
  CIP13: '3400957712167',
  ucdLib: "DOCETAXEL HPI 10MG/ML FL8ML",
  UCD7: '9351830',
  UCD13: '3400893518304',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL HPI 10MG/ML FL8ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5793643',
  CIP13: '3400957936433',
  ucdLib: "DOCETAXEL TVC 20MG/ML FL1ML",
  UCD7: '9382003',
  UCD13: '3400893820032',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL TVC 20MG/ML FL1ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5793666',
  CIP13: '3400957936662',
  ucdLib: "DOCETAXEL TVC 20MG/ML FL4ML",
  UCD7: '9382026',
  UCD13: '3400893820261',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL TVC 20MG/ML FL4ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5793672',
  CIP13: '3400957936723',
  ucdLib: "DOCETAXEL TVC 20MG/ML FL7ML",
  UCD7: '9382032',
  UCD13: '3400893820322',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL TVC 20MG/ML FL7ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5775674',
  CIP13: '3400957756741',
  ucdLib: "TAXOTERE 160MG/8ML PERF FL",
  UCD7: '9353964',
  UCD13: '3400893539644',
  ucdQtyMultiplicator: 1,
  cipLib: "TAXOTERE 160MG/8ML PERF FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5768183',
  CIP13: '3400957681838',
  ucdLib: "DOCETAXEL EBW 10MG/ML FL2ML",
  UCD7: '9352887',
  UCD13: '3400893528877',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL EBW 10MG/ML FL2ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5768220',
  CIP13: '3400957682200',
  ucdLib: "DOCETAXEL EBW 10MG/ML FL8ML",
  UCD7: '9352893',
  UCD13: '3400893528938',
  ucdQtyMultiplicator: 1,
  cipLib: "DOCETAXEL EBW 10MG/ML FL8ML BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5765687',
  CIP13: '3400957656874',
  ucdLib: "TAXOTERE 20MG/1ML PERF FL",
  UCD7: '9342877',
  UCD13: '3400893428771',
  ucdQtyMultiplicator: 1,
  cipLib: "TAXOTERE 20MG/1ML PERF FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5765776',
  CIP13: '3400957657765',
  ucdLib: "TAXOTERE 80MG/4ML PERF FL",
  UCD7: '9342883',
  UCD13: '3400893428832',
  ucdQtyMultiplicator: 1,
  cipLib: "TAXOTERE 80MG/4ML PERF FL BT 1",
  atcCode: "L01CD02"
}, {
  CIP7: '5867755',
  CIP13: '3400958677557',
  ucdLib: "PACLITAXEL AHCL 6MG/ML F100ML",
  UCD7: '9401350',
  UCD13: '3400894013501',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL AHCL 6MG/ML F100ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5867749',
  CIP13: '3400958677496',
  ucdLib: "PACLITAXEL AHCL 6MG/ML FL25ML",
  UCD7: '9401367',
  UCD13: '3400894013679',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL AHCL 6MG/ML FL25ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5697170',
  CIP13: '3400956971701',
  ucdLib: "PACLITAXEL EG 6MG/ML FL16,7ML",
  UCD7: '9296829',
  UCD13: '3400892968292',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EG 6MG/ML FL16,7ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5697187',
  CIP13: '3400956971879',
  ucdLib: "PACLITAXEL EG 6MG/ML FL25ML",
  UCD7: '9296835',
  UCD13: '3400892968353',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EG 6MG/ML FL25ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5697193',
  CIP13: '3400956971930',
  ucdLib: "PACLITAXEL EG 6MG/ML FL50ML",
  UCD7: '9296858',
  UCD13: '3400892968582',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EG 6MG/ML FL50ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5697164',
  CIP13: '3400956971640',
  ucdLib: "PACLITAXEL EG 6MG/ML FL5ML",
  UCD7: '9296841',
  UCD13: '3400892968414',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EG 6MG/ML FL5ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5699588',
  CIP13: '3400956995882',
  ucdLib: "PACLITAXEL TVC 6MG/ML FL25ML",
  UCD7: '9308254',
  UCD13: '3400893082546',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL TVC 6MG/ML FL25ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '3844187',
  CIP13: '3400938441871',
  ucdLib: "ABRAXANE 5MG/ML INJ FL100MG",
  UCD7: '9348064',
  UCD13: '3400893480649',
  ucdQtyMultiplicator: 1,
  cipLib: "ABRAXANE 5MG/ML INJ FL100MG BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5742410',
  CIP13: '3400957424107',
  ucdLib: "PACLITAXEL ARW 6MG/ML 16,7ML",
  UCD7: '9327903',
  UCD13: '3400893279038',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL ARW 6MG/ML 16,7ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5742427',
  CIP13: '3400957424275',
  ucdLib: "PACLITAXEL ARW 6MG/ML FL25ML",
  UCD7: '9327926',
  UCD13: '3400893279267',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL ARW 6MG/ML FL25ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5742433',
  CIP13: '3400957424336',
  ucdLib: "PACLITAXEL ARW 6MG/ML FL50ML",
  UCD7: '9327949',
  UCD13: '3400893279496',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL ARW 6MG/ML FL50ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5742404',
  CIP13: '3400957424046',
  ucdLib: "PACLITAXEL ARW 6MG/ML FL5ML",
  UCD7: '9327932',
  UCD13: '3400893279328',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL ARW 6MG/ML FL5ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5717381',
  CIP13: '3400957173814',
  ucdLib: "PACLITAXEL HPI 6MG/ML 16,7ML",
  UCD7: '9308923',
  UCD13: '3400893089231',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL HPI 6MG/ML 16,7ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5717398',
  CIP13: '3400957173982',
  ucdLib: "PACLITAXEL HPI 6MG/ML FL25ML",
  UCD7: '9308946',
  UCD13: '3400893089460',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL HPI 6MG/ML FL25ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5717406',
  CIP13: '3400957174064',
  ucdLib: "PACLITAXEL HPI 6MG/ML FL50ML",
  UCD7: '9308969',
  UCD13: '3400893089699',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL HPI 6MG/ML FL50ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5717375',
  CIP13: '3400957173753',
  ucdLib: "PACLITAXEL HPI 6MG/ML FL5ML",
  UCD7: '9308952',
  UCD13: '3400893089521',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL HPI 6MG/ML FL5ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5750438',
  CIP13: '3400957504380',
  ucdLib: "PACLITAXEL KBI 6MG/ML 16,7ML",
  UCD7: '9332809',
  UCD13: '3400893328095',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL KBI 6MG/ML 16,7ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5750450',
  CIP13: '3400957504502',
  ucdLib: "PACLITAXEL KBI 6MG/ML FV50ML",
  UCD7: '9332821',
  UCD13: '3400893328217',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL KBI 6MG/ML FV50ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5750415',
  CIP13: '3400957504151',
  ucdLib: "PACLITAXEL KBI 6MG/ML FV5ML",
  UCD7: '9332815',
  UCD13: '3400893328156',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL KBI 6MG/ML FV5ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5713153',
  CIP13: '3400957131531',
  ucdLib: "PACLITAXEL MYP 6MG/ML 16,7ML",
  UCD7: '9305379',
  UCD13: '3400893053799',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL MYP 6MG/ML 16,7ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5713176',
  CIP13: '3400957131760',
  ucdLib: "PACLITAXEL MYP 6MG/ML FL50ML",
  UCD7: '9305391',
  UCD13: '3400893053911',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL MYP 6MG/ML FL50ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5713147',
  CIP13: '3400957131470',
  ucdLib: "PACLITAXEL MYP 6MG/ML FL5ML",
  UCD7: '9305385',
  UCD13: '3400893053850',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL MYP 6MG/ML FL5ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5788091',
  CIP13: '3400957880910',
  ucdLib: "PACLITAXEL AHCL 6MG/ML 16,7ML",
  UCD7: '9363282',
  UCD13: '3400893632826',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL AHCL 6MG/ML 16,7ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5788116',
  CIP13: '3400957881160',
  ucdLib: "PACLITAXEL AHCL 6MG/ML FL50ML",
  UCD7: '9363307',
  UCD13: '3400893633076',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL AHCL 6MG/ML FL50ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5788085',
  CIP13: '3400957880859',
  ucdLib: "PACLITAXEL AHCL 6MG/ML FL5ML",
  UCD7: '9363299',
  UCD13: '3400893632994',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL AHCL 6MG/ML FL5ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5685161',
  CIP13: '3400956851614',
  ucdLib: "PACLITAXEL EBW 6MG/ML 16,7ML",
  UCD7: '9285381',
  UCD13: '3400892853819',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EBW 6MG/ML 16,7ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5734669',
  CIP13: '3400957346690',
  ucdLib: "PACLITAXEL EBW 6MG/ML FL100ML",
  UCD7: '9319022',
  UCD13: '3400893190227',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EBW 6MG/ML FL100ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5689785',
  CIP13: '3400956897858',
  ucdLib: "PACLITAXEL EBW 6MG/ML FL25ML",
  UCD7: '9285398',
  UCD13: '3400892853987',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EBW 6MG/ML FL25ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5685178',
  CIP13: '3400956851782',
  ucdLib: "PACLITAXEL EBW 6MG/ML FL50ML",
  UCD7: '9285412',
  UCD13: '3400892854120',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EBW 6MG/ML FL50ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5685155',
  CIP13: '3400956851553',
  ucdLib: "PACLITAXEL EBW 6MG/ML FL5ML",
  UCD7: '9285406',
  UCD13: '3400892854069',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL EBW 6MG/ML FL5ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5797262',
  CIP13: '3400957972622',
  ucdLib: "PACLITAXEL KBI 6MG/ML FV100ML",
  UCD7: '9366441',
  UCD13: '3400893664414',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL KBI 6MG/ML FV100ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5797256',
  CIP13: '3400957972561',
  ucdLib: "PACLITAXEL KBI 6MG/ML FV25ML",
  UCD7: '9366458',
  UCD13: '3400893664582',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL KBI 6MG/ML FV25ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5675180',
  CIP13: '3400956751808',
  ucdLib: "PACLITAXEL TVC 6MG/ML 16,7ML",
  UCD7: '9278091',
  UCD13: '3400892780917',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL TVC 6MG/ML 16,7ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5675197',
  CIP13: '3400956751976',
  ucdLib: "PACLITAXEL TVC 6MG/ML FL50ML",
  UCD7: '9278122',
  UCD13: '3400892781228',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL TVC 6MG/ML FL50ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5675174',
  CIP13: '3400956751747',
  ucdLib: "PACLITAXEL TVC 6MG/ML FL5ML",
  UCD7: '9278116',
  UCD13: '3400892781167',
  ucdQtyMultiplicator: 1,
  cipLib: "PACLITAXEL TVC 6MG/ML FL5ML BT 1",
  atcCode: "L01CD01"
}, {
  CIP7: '5596500',
  CIP13: '3400955965008',
  ucdLib: "ETOPOPHOS 100MG INJ FL",
  UCD7: '9184438',
  UCD13: '3400891844382',
  ucdQtyMultiplicator: 1,
  cipLib: "ETOPOPHOS 100MG INJ FL BT 1",
  atcCode: "L01CB01"
}, {
  CIP7: '5596629',
  CIP13: '3400955966296',
  ucdLib: "ETOPOSIDE TVC100MG INJ FL5ML",
  UCD7: '9186437',
  UCD13: '3400891864373',
  ucdQtyMultiplicator: 1,
  cipLib: "ETOPOSIDE TVC100MG INJ FL5ML BT 1",
  atcCode: "L01CB01"
}, {
  CIP7: '5596635',
  CIP13: '3400955966357',
  ucdLib: "ETOPOSIDE TVC200MG INJ FL10ML",
  UCD7: '9186443',
  UCD13: '3400891864434',
  ucdQtyMultiplicator: 1,
  cipLib: "ETOPOSIDE TVC200MG INJ FL10ML BT 1",
  atcCode: "L01CB01"
}, {
  CIP7: '3657597',
  CIP13: '3400936575974',
  ucdLib: "CELLTOP 25MG CAPS",
  UCD7: '9192320',
  UCD13: '3400891923209',
  ucdQtyMultiplicator: 40,
  cipLib: "CELLTOP 25MG CAPS BT 40",
  atcCode: "L01CB01"
}, {
  CIP7: '3657580',
  CIP13: '3400936575806',
  ucdLib: "CELLTOP 50MG CAPS",
  UCD7: '9192337',
  UCD13: '3400891923377',
  ucdQtyMultiplicator: 20,
  cipLib: "CELLTOP 50MG CAPS BT 20",
  atcCode: "L01CB01"
}, {
  CIP7: '5602577',
  CIP13: '3400956025770',
  ucdLib: "ETOPOSIDE MYL20MG INJ FL5ML",
  UCD7: '9195726',
  UCD13: '3400891957266',
  ucdQtyMultiplicator: 10,
  cipLib: "ETOPOSIDE MYL20MG INJ FL5ML BT 10",
  atcCode: "L01CB01"
}, {
  CIP7: '5624538',
  CIP13: '3400956245383',
  ucdLib: "ETOPOSIDE MYL20MG INJ FL10ML",
  UCD7: '9224698',
  UCD13: '3400892246987',
  ucdQtyMultiplicator: 10,
  cipLib: "ETOPOSIDE MYL20MG INJ FL10ML BT 10",
  atcCode: "L01CB01"
}, {
  CIP7: '5618294',
  CIP13: '3400956182947',
  ucdLib: "ETOPOSIDE TVC20MG INJ FL25ML",
  UCD7: '9208280',
  UCD13: '3400892082806',
  ucdQtyMultiplicator: 1,
  cipLib: "ETOPOSIDE TVC20MG INJ FL25ML BT 1",
  atcCode: "L01CB01"
}, {
  CIP7: '5618325',
  CIP13: '3400956183258',
  ucdLib: "ETOPOSIDE TVC20MG INJ FL50ML",
  UCD7: '9208297',
  UCD13: '3400892082974',
  ucdQtyMultiplicator: 1,
  cipLib: "ETOPOSIDE TVC20MG INJ FL50ML BT 1",
  atcCode: "L01CB01"
}, {
  CIP7: '3964307',
  CIP13: '3400939643076',
  ucdLib: "JAVLOR 25MG/ML INJ FL10ML BG",
  UCD7: '9344847',
  UCD13: '3400893448472',
  ucdQtyMultiplicator: 1,
  cipLib: "JAVLOR 25MG/ML INJ FL10ML BG BT 1",
  atcCode: "L01CA05"
}, {
  CIP7: '3964282',
  CIP13: '3400939642826',
  ucdLib: "JAVLOR 25MG/ML INJ FL2ML BG",
  UCD7: '9344853',
  UCD13: '3400893448533',
  ucdQtyMultiplicator: 1,
  cipLib: "JAVLOR 25MG/ML INJ FL2ML BG BT 1",
  atcCode: "L01CA05"
}, {
  CIP7: '3319044',
  CIP13: '3400933190446',
  ucdLib: "NAVELBINE 10MG INJ FV1ML",
  UCD7: '9137172',
  UCD13: '3400891371727',
  ucdQtyMultiplicator: 10,
  cipLib: "NAVELBINE 10MG INJ FV1ML BT 10",
  atcCode: "L01CA04"
}, {
  CIP7: '3318458',
  CIP13: '3400933184582',
  ucdLib: "NAVELBINE 50MG INJ FV5ML",
  UCD7: '9137189',
  UCD13: '3400891371895',
  ucdQtyMultiplicator: 10,
  cipLib: "NAVELBINE 50MG INJ FV5ML BT 10",
  atcCode: "L01CA04"
}, {
  CIP7: '3659484',
  CIP13: '3400936594845',
  ucdLib: "NAVELBINE 20MG CAPS MOL",
  UCD7: '9230380',
  UCD13: '3400892303802',
  ucdQtyMultiplicator: 1,
  cipLib: "NAVELBINE 20MG CAPS MOL BT 1",
  atcCode: "L01CA04"
}, {
  CIP7: '3659490',
  CIP13: '3400936594906',
  ucdLib: "NAVELBINE 30MG CAPS MOL",
  UCD7: '9230397',
  UCD13: '3400892303970',
  ucdQtyMultiplicator: 1,
  cipLib: "NAVELBINE 30MG CAPS MOL BT 1",
  atcCode: "L01CA04"
}, {
  CIP7: '5738199',
  CIP13: '3400957381998',
  ucdLib: "VINORELBINE ARW 10MG/ML FL1ML",
  UCD7: '9323791',
  UCD13: '3400893237915',
  ucdQtyMultiplicator: 1,
  cipLib: "VINORELBINE ARW 10MG/ML FL1ML BT 1",
  atcCode: "L01CA04"
}, {
  CIP7: '5738213',
  CIP13: '3400957382131',
  ucdLib: "VINORELBINE ARW 10MG/ML FL5ML",
  UCD7: '9323816',
  UCD13: '3400893238165',
  ucdQtyMultiplicator: 1,
  cipLib: "VINORELBINE ARW 10MG/ML FL5ML BT 1",
  atcCode: "L01CA04"
}, {
  CIP7: '5735901',
  CIP13: '3400957359010',
  ucdLib: "VINORELBINE SDZ 10MG/ML FL1ML",
  UCD7: '9325956',
  UCD13: '3400893259566',
  ucdQtyMultiplicator: 1,
  cipLib: "VINORELBINE SDZ 10MG/ML FL1ML BT 1",
  atcCode: "L01CA04"
}, {
  CIP7: '5735930',
  CIP13: '3400957359300',
  ucdLib: "VINORELBINE SDZ 10MG/ML FL5ML",
  UCD7: '9325962',
  UCD13: '3400893259627',
  ucdQtyMultiplicator: 1,
  cipLib: "VINORELBINE SDZ 10MG/ML FL5ML BT 1",
  atcCode: "L01CA04"
}, {
  CIP7: '3253931',
  CIP13: '3400932539314',
  ucdLib: "ELDISINE 1MG INJ FL",
  UCD7: '9120651',
  UCD13: '3400891206517',
  ucdQtyMultiplicator: 1,
  cipLib: "ELDISINE 1MG INJ FL BT 1",
  atcCode: "L01CA03"
}, {
  CIP7: '5655007',
  CIP13: '3400956550074',
  ucdLib: "ELDISINE 5MG INJ FL",
  UCD7: '9268158',
  UCD13: '3400892681580',
  ucdQtyMultiplicator: 1,
  cipLib: "ELDISINE 5MG INJ FL BT 1",
  atcCode: "L01CA03"
}, {
  CIP7: '3264998',
  CIP13: '3400932649983',
  ucdLib: "ONCOVIN 1MG INJ SOL FL1ML",
  UCD7: '9065107',
  UCD13: '3400890651073',
  ucdQtyMultiplicator: 1,
  cipLib: "ONCOVIN 1MG INJ SOL FL1ML BT 1",
  atcCode: "L01CA02"
}, {
  CIP7: '3795394',
  CIP13: '3400937953948',
  ucdLib: "VINCRISTINE HPI 2MG INJ 2ML",
  UCD7: '9302346',
  UCD13: '3400893023464',
  ucdQtyMultiplicator: 5,
  cipLib: "VINCRISTINE HPI 2MG INJ 2ML BT 5",
  atcCode: "L01CA02"
}, {
  CIP7: '3881840',
  CIP13: '3400938818406',
  ucdLib: "VINCRISTINE TVC 1MG INJ 1ML",
  UCD7: '9320841',
  UCD13: '3400893208410',
  ucdQtyMultiplicator: 1,
  cipLib: "VINCRISTINE TVC 1MG INJ 1ML BT 1",
  atcCode: "L01CA02"
}, {
  CIP7: '3881857',
  CIP13: '3400938818574',
  ucdLib: "VINCRISTINE TVC 1MG INJ 2ML",
  UCD7: '9320858',
  UCD13: '3400893208588',
  ucdQtyMultiplicator: 1,
  cipLib: "VINCRISTINE TVC 1MG INJ 2ML BT 1",
  atcCode: "L01CA02"
}, {
  CIP7: '3112024',
  CIP13: '3400931120247',
  ucdLib: "VELBE 10MG INJ FL",
  UCD7: '9098087',
  UCD13: '3400890980876',
  ucdQtyMultiplicator: 1,
  cipLib: "VELBE 10MG INJ FL BT 1",
  atcCode: "L01CA01"
}, {
  CIP7: '3005777',
  CIP13: '3400930057773',
  ucdLib: "LONSURF 15MG/6,14MG CPR",
  UCD7: '9420761',
  UCD13: '3400894207610',
  ucdQtyMultiplicator: 20,
  cipLib: "LONSURF 15MG/6,14MG CPR BT 20",
  atcCode: "L01BC59"
}, {
  CIP7: '3005780',
  CIP13: '3400930057803',
  ucdLib: "LONSURF 20MG/8,19MG CPR",
  UCD7: '9420778',
  UCD13: '3400894207788',
  ucdQtyMultiplicator: 20,
  cipLib: "LONSURF 20MG/8,19MG CPR BT 20",
  atcCode: "L01BC59"
}, {
  CIP7: '2670383',
  CIP13: '3400926703837',
  ucdLib: "DACOGEN 50MG PERF FL",
  UCD7: '9300695',
  UCD13: '3400893006955',
  ucdQtyMultiplicator: 1,
  cipLib: "DACOGEN 50MG PERF FL BT 1",
  atcCode: "L01BC08"
}, {
  CIP7: '3912658',
  CIP13: '3400939126586',
  ucdLib: "VIDAZA 25MG/ML INJ FL",
  UCD7: '9274762',
  UCD13: '3400892747620',
  ucdQtyMultiplicator: 1,
  cipLib: "VIDAZA 25MG/ML INJ FL BT 1",
  atcCode: "L01BC07"
}, {
  CIP7: '2762671',
  CIP13: '3400927626715',
  ucdLib: "CAPECITABINE BGA 150MG CPR",
  UCD7: '9399506',
  UCD13: '3400893995068',
  ucdQtyMultiplicator: 60,
  cipLib: "CAPECITABINE BGA 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '2762694',
  CIP13: '3400927626944',
  ucdLib: "CAPECITABINE BGA 500MG CPR",
  UCD7: '9399512',
  UCD13: '3400893995129',
  ucdQtyMultiplicator: 120,
  cipLib: "CAPECITABINE BGA 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '2764262',
  CIP13: '3400927642623',
  ucdLib: "CAPECITABINE SDZ 150MG CPR",
  UCD7: '9397269',
  UCD13: '3400893972694',
  ucdQtyMultiplicator: 60,
  cipLib: "CAPECITABINE SDZ 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '2764279',
  CIP13: '3400927642791',
  ucdLib: "CAPECITABINE SDZ 500MG CPR",
  UCD7: '9397275',
  UCD13: '3400893972755',
  ucdQtyMultiplicator: 120,
  cipLib: "CAPECITABINE SDZ 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '3657456',
  CIP13: '3400936574564',
  ucdLib: "XELODA 150MG CPR",
  UCD7: '9204626',
  UCD13: '3400892046266',
  ucdQtyMultiplicator: 60,
  cipLib: "XELODA 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '3657462',
  CIP13: '3400936574625',
  ucdLib: "XELODA 500MG CPR",
  UCD7: '9204632',
  UCD13: '3400892046327',
  ucdQtyMultiplicator: 120,
  cipLib: "XELODA 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '2757687',
  CIP13: '3400927576874',
  ucdLib: "CAPECITABINE ARW 150MG CPR",
  UCD7: '9396471',
  UCD13: '3400893964712',
  ucdQtyMultiplicator: 60,
  cipLib: "CAPECITABINE ARW 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '2757670',
  CIP13: '3400927576706',
  ucdLib: "CAPECITABINE ARW 500MG CPR",
  UCD7: '9396488',
  UCD13: '3400893964880',
  ucdQtyMultiplicator: 120,
  cipLib: "CAPECITABINE ARW 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '2748004',
  CIP13: '3400927480041',
  ucdLib: "CAPECITABINE EG 150MG CPR",
  UCD7: '9395879',
  UCD13: '3400893958797',
  ucdQtyMultiplicator: 60,
  cipLib: "CAPECITABINE EG 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '2748033',
  CIP13: '3400927480331',
  ucdLib: "CAPECITABINE EG 500MG CPR",
  UCD7: '9395885',
  UCD13: '3400893958858',
  ucdQtyMultiplicator: 120,
  cipLib: "CAPECITABINE EG 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '2744319',
  CIP13: '3400927443190',
  ucdLib: "CAPECITABINE MYL 150MG CPR",
  UCD7: '9398286',
  UCD13: '3400893982860',
  ucdQtyMultiplicator: 60,
  cipLib: "CAPECITABINE MYL 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '2744986',
  CIP13: '3400927449864',
  ucdLib: "CAPECITABINE MYL 500MG CPR",
  UCD7: '9398292',
  UCD13: '3400893982921',
  ucdQtyMultiplicator: 120,
  cipLib: "CAPECITABINE MYL 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '2696744',
  CIP13: '3400926967444',
  ucdLib: "CAPECITABINE TVC 150MG CPR",
  UCD7: '9397281',
  UCD13: '3400893972816',
  ucdQtyMultiplicator: 60,
  cipLib: "CAPECITABINE TVC 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '2696750',
  CIP13: '3400926967505',
  ucdLib: "CAPECITABINE TVC 500MG CPR",
  UCD7: '9397298',
  UCD13: '3400893972984',
  ucdQtyMultiplicator: 120,
  cipLib: "CAPECITABINE TVC 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '2698387',
  CIP13: '3400926983871',
  ucdLib: "CAPECITABINE ZEN 150MG CPR",
  UCD7: '9396040',
  UCD13: '3400893960400',
  ucdQtyMultiplicator: 60,
  cipLib: "CAPECITABINE ZEN 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '2698364',
  CIP13: '3400926983642',
  ucdLib: "CAPECITABINE ZEN 500MG CPR",
  UCD7: '9396057',
  UCD13: '3400893960578',
  ucdQtyMultiplicator: 120,
  cipLib: "CAPECITABINE ZEN 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '2738980',
  CIP13: '3400927389801',
  ucdLib: "CAPECITABINE ACC 150MG CPR",
  UCD7: '9390379',
  UCD13: '3400893903797',
  ucdQtyMultiplicator: 60,
  cipLib: "CAPECITABINE ACC 150MG CPR BT 60",
  atcCode: "L01BC06"
}, {
  CIP7: '2739057',
  CIP13: '3400927390579',
  ucdLib: "CAPECITABINE ACC 500MG CPR",
  UCD7: '9390385',
  UCD13: '3400893903858',
  ucdQtyMultiplicator: 120,
  cipLib: "CAPECITABINE ACC 500MG CPR BT 120",
  atcCode: "L01BC06"
}, {
  CIP7: '5596753',
  CIP13: '3400955967538',
  ucdLib: "GEMZAR 1000MG PERF FL",
  UCD7: '9182190',
  UCD13: '3400891821901',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMZAR 1000MG PERF FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5596747',
  CIP13: '3400955967477',
  ucdLib: "GEMZAR 200MG PERF FL",
  UCD7: '9182209',
  UCD13: '3400891822090',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMZAR 200MG PERF FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5500137',
  CIP13: '3400955001379',
  ucdLib: "GEMCITABINE KBI 38MG/ML 26,3ML",
  UCD7: '9417658',
  UCD13: '3400894176589',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE KBI 38MG/ML 26,3ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5500139',
  CIP13: '3400955001393',
  ucdLib: "GEMCITABINE KBI 38MG/ML 52,6ML",
  UCD7: '9417670',
  UCD13: '3400894176701',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE KBI 38MG/ML 52,6ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5725676',
  CIP13: '3400957256760',
  ucdLib: "GEMCITABINE ACC 1000MG INJ FL",
  UCD7: '9318465',
  UCD13: '3400893184653',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ACC 1000MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '2189935',
  CIP13: '3400921899351',
  ucdLib: "GEMCITABINE ACC 100MG/ML 10ML",
  UCD7: '9379981',
  UCD13: '3400893799819',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ACC 100MG/ML 10ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '2189941',
  CIP13: '3400921899412',
  ucdLib: "GEMCITABINE ACC 100MG/ML 15ML",
  UCD7: '9379998',
  UCD13: '3400893799987',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ACC 100MG/ML 15ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '2189958',
  CIP13: '3400921899580',
  ucdLib: "GEMCITABINE ACC 100MG/ML 20ML",
  UCD7: '9380004',
  UCD13: '3400893800041',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ACC 100MG/ML 20ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '2189929',
  CIP13: '3400921899290',
  ucdLib: "GEMCITABINE ACC 100MG/ML 2ML",
  UCD7: '9379975',
  UCD13: '3400893799758',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ACC 100MG/ML 2ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5725653',
  CIP13: '3400957256531',
  ucdLib: "GEMCITABINE ACC 200MG INJ FL",
  UCD7: '9318471',
  UCD13: '3400893184714',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ACC 200MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5755944',
  CIP13: '3400957559441',
  ucdLib: "GEMCITABINE EG 38MG/ML 26,3ML",
  UCD7: '9343405',
  UCD13: '3400893434055',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE EG 38MG/ML 26,3ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5755938',
  CIP13: '3400957559380',
  ucdLib: "GEMCITABINE EG 38MG/ML 5,26ML",
  UCD7: '9343411',
  UCD13: '3400893434116',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE EG 38MG/ML 5,26ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5737219',
  CIP13: '3400957372194',
  ucdLib: "GEMCITABINE ARW 1000MG INJ FL",
  UCD7: '9325755',
  UCD13: '3400893257555',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ARW 1000MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5737202',
  CIP13: '3400957372026',
  ucdLib: "GEMCITABINE ARW 200MG INJ FL",
  UCD7: '9325761',
  UCD13: '3400893257616',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ARW 200MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770777',
  CIP13: '3400957707774',
  ucdLib: "GEMCITABINE ARW 40MG/ML F25ML",
  UCD7: '9350925',
  UCD13: '3400893509258',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ARW 40MG/ML F25ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770783',
  CIP13: '3400957707835',
  ucdLib: "GEMCITABINE ARW 40MG/ML F50ML",
  UCD7: '9350948',
  UCD13: '3400893509487',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ARW 40MG/ML F50ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770760',
  CIP13: '3400957707606',
  ucdLib: "GEMCITABINE ARW 40MG/ML FL5ML",
  UCD7: '9350931',
  UCD13: '3400893509319',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ARW 40MG/ML FL5ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5792141',
  CIP13: '3400957921415',
  ucdLib: "GEMCITABINE HPI 38MG/ML 26,3ML",
  UCD7: '9368606',
  UCD13: '3400893686065',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE HPI 38MG/ML 26,3ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5792135',
  CIP13: '3400957921354',
  ucdLib: "GEMCITABINE HPI 38MG/ML 5,3ML",
  UCD7: '9368612',
  UCD13: '3400893686126',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE HPI 38MG/ML 5,3ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5792158',
  CIP13: '3400957921583',
  ucdLib: "GEMCITABINE HPI 38MG/ML 52,6ML",
  UCD7: '9368629',
  UCD13: '3400893686294',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE HPI 38MG/ML 52,6ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5779117',
  CIP13: '3400957791179',
  ucdLib: "GEMCITABINE KBI 1000MG INJ FL",
  UCD7: '9354604',
  UCD13: '3400893546048',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE KBI 1000MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5779123',
  CIP13: '3400957791230',
  ucdLib: "GEMCITABINE KBI 2000MG INJ FL",
  UCD7: '9354627',
  UCD13: '3400893546277',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE KBI 2000MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5779100',
  CIP13: '3400957791001',
  ucdLib: "GEMCITABINE KBI 200MG INJ FL",
  UCD7: '9354610',
  UCD13: '3400893546109',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE KBI 200MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770748',
  CIP13: '3400957707484',
  ucdLib: "GEMCITABINE MYL 40MG/ML F25ML",
  UCD7: '9351698',
  UCD13: '3400893516980',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE MYL 40MG/ML F25ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770754',
  CIP13: '3400957707545',
  ucdLib: "GEMCITABINE MYL 40MG/ML F50ML",
  UCD7: '9351712',
  UCD13: '3400893517123',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE MYL 40MG/ML F50ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770731',
  CIP13: '3400957707316',
  ucdLib: "GEMCITABINE MYL 40MG/ML FL5ML",
  UCD7: '9351706',
  UCD13: '3400893517062',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE MYL 40MG/ML FL5ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5787335',
  CIP13: '3400957873356',
  ucdLib: "GEMCITABINE SDZ 40MG/ML F25ML",
  UCD7: '9363017',
  UCD13: '3400893630174',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE SDZ 40MG/ML F25ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5787341',
  CIP13: '3400957873417',
  ucdLib: "GEMCITABINE SDZ 40MG/ML F50ML",
  UCD7: '9363046',
  UCD13: '3400893630464',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE SDZ 40MG/ML F50ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5787306',
  CIP13: '3400957873066',
  ucdLib: "GEMCITABINE SDZ 40MG/ML FL5ML",
  UCD7: '9363023',
  UCD13: '3400893630235',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE SDZ 40MG/ML FL5ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770719',
  CIP13: '3400957707194',
  ucdLib: "GEMCITABINE TVC 40MG/ML F25ML",
  UCD7: '9352686',
  UCD13: '3400893526866',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE TVC 40MG/ML F25ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770725',
  CIP13: '3400957707255',
  ucdLib: "GEMCITABINE TVC 40MG/ML F50ML",
  UCD7: '9352700',
  UCD13: '3400893527009',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE TVC 40MG/ML F50ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5770702',
  CIP13: '3400957707026',
  ucdLib: "GEMCITABINE TVC 40MG/ML FL5ML",
  UCD7: '9352692',
  UCD13: '3400893526927',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE TVC 40MG/ML FL5ML BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5766391',
  CIP13: '3400957663919',
  ucdLib: "GEMCITABINE ACC 2000MG INJ FL",
  UCD7: '9347998',
  UCD13: '3400893479988',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ACC 2000MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '5764274',
  CIP13: '3400957642747',
  ucdLib: "GEMCITABINE ARW 2000MG INJ FL",
  UCD7: '9343316',
  UCD13: '3400893433164',
  ucdQtyMultiplicator: 1,
  cipLib: "GEMCITABINE ARW 2000MG INJ FL BT 1",
  atcCode: "L01BC05"
}, {
  CIP7: '3218432',
  CIP13: '3400932184323',
  ucdLib: "EFUDIX 5% CR TB20G",
  UCD7: '9030534',
  UCD13: '3400890305341',
  ucdQtyMultiplicator: 1,
  cipLib: "EFUDIX 5% CR TB20G BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5604323',
  CIP13: '3400956043231',
  ucdLib: "FLUOROURACILE TVC 1000MG 20ML",
  UCD7: '9196163',
  UCD13: '3400891961638',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE TVC 1000MG 20ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5604346',
  CIP13: '3400956043460',
  ucdLib: "FLUOROURACILE TVC5000MG 100ML",
  UCD7: '9196200',
  UCD13: '3400891962000',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE TVC5000MG 100ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5604317',
  CIP13: '3400956043170',
  ucdLib: "FLUOROURACILE TVC500MG FL10ML",
  UCD7: '9196192',
  UCD13: '3400891961928',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE TVC500MG FL10ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '3768724',
  CIP13: '3400937687249',
  ucdLib: "EFUDIX 5% CR TB40G",
  UCD7: '9303995',
  UCD13: '3400893039953',
  ucdQtyMultiplicator: 1,
  cipLib: "EFUDIX 5% CR TB40G BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5751828',
  CIP13: '3400957518288',
  ucdLib: "FLUOROURACILE ACC 50MG F100ML",
  UCD7: '9334872',
  UCD13: '3400893348727',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE ACC 50MG F100ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5751805',
  CIP13: '3400957518059',
  ucdLib: "FLUOROURACILE ACC 50MG FL10ML",
  UCD7: '9334866',
  UCD13: '3400893348666',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE ACC 50MG FL10ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5751811',
  CIP13: '3400957518110',
  ucdLib: "FLUOROURACILE ACC 50MG FL20ML",
  UCD7: '9334889',
  UCD13: '3400893348895',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE ACC 50MG FL20ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5751797',
  CIP13: '3400957517977',
  ucdLib: "FLUOROURACILE ACC 50MG FL5ML",
  UCD7: '9334895',
  UCD13: '3400893348956',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE ACC 50MG FL5ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5725334',
  CIP13: '3400957253349',
  ucdLib: "FLUOROURACILE PFZ 50MG F100ML",
  UCD7: '9316443',
  UCD13: '3400893164433',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUOROURACILE PFZ 50MG F100ML BT 5",
  atcCode: "L01BC02"
}, {
  CIP7: '5725340',
  CIP13: '3400957253400',
  ucdLib: "FLUOROURACILE PFZ 50MG F200ML",
  UCD7: '9311291',
  UCD13: '3400893112915',
  ucdQtyMultiplicator: 2,
  cipLib: "FLUOROURACILE PFZ 50MG F200ML BT 2",
  atcCode: "L01BC02"
}, {
  CIP7: '5725311',
  CIP13: '3400957253110',
  ucdLib: "FLUOROURACILE PFZ 50MG FL10ML",
  UCD7: '9316437',
  UCD13: '3400893164372',
  ucdQtyMultiplicator: 6,
  cipLib: "FLUOROURACILE PFZ 50MG FL10ML BT 6",
  atcCode: "L01BC02"
}, {
  CIP7: '5725328',
  CIP13: '3400957253288',
  ucdLib: "FLUOROURACILE PFZ 50MG FL20ML",
  UCD7: '9316466',
  UCD13: '3400893164662',
  ucdQtyMultiplicator: 6,
  cipLib: "FLUOROURACILE PFZ 50MG FL20ML BT 6",
  atcCode: "L01BC02"
}, {
  CIP7: '5725305',
  CIP13: '3400957253059',
  ucdLib: "FLUOROURACILE PFZ 50MG FL5ML",
  UCD7: '9311316',
  UCD13: '3400893113165',
  ucdQtyMultiplicator: 12,
  cipLib: "FLUOROURACILE PFZ 50MG FL5ML BT 12",
  atcCode: "L01BC02"
}, {
  CIP7: '5798451',
  CIP13: '3400957984519',
  ucdLib: "FLUOROURACILE ACC 50MG FL50ML",
  UCD7: '9380961',
  UCD13: '3400893809617',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE ACC 50MG FL50ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5761531',
  CIP13: '3400957615314',
  ucdLib: "FLUOROURACILE EBW 50MG OS100ML",
  UCD7: '9340973',
  UCD13: '3400893409732',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE EBW 50MG OS100ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '5761494',
  CIP13: '3400957614942',
  ucdLib: "FLUOROURACILE EBW 50MG OS20ML",
  UCD7: '9340996',
  UCD13: '3400893409961',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOROURACILE EBW 50MG OS20ML BT 1",
  atcCode: "L01BC02"
}, {
  CIP7: '3026721',
  CIP13: '3400930267219',
  ucdLib: "ARACYTINE 100MG INJ FL+AMP",
  UCD7: '9006062',
  UCD13: '3400890060622',
  ucdQtyMultiplicator: 1,
  cipLib: "ARACYTINE 100MG INJ FL+AMP BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5560643',
  CIP13: '3400955606437',
  ucdLib: "CYTARABINE EBW 50MG/ML FL10ML",
  UCD7: '9307556',
  UCD13: '3400893075562',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE EBW 50MG/ML FL10ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5620167',
  CIP13: '3400956201679',
  ucdLib: "ARACYTINE 1G IV FL",
  UCD7: '9124904',
  UCD13: '3400891249040',
  ucdQtyMultiplicator: 1,
  cipLib: "ARACYTINE 1G IV FL BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5626483',
  CIP13: '3400956264834',
  ucdLib: "ARACYTINE 2G IV FL",
  UCD7: '9124910',
  UCD13: '3400891249101',
  ucdQtyMultiplicator: 1,
  cipLib: "ARACYTINE 2G IV FL BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5620150',
  CIP13: '3400956201501',
  ucdLib: "ARACYTINE 500MG INJ FL",
  UCD7: '9123046',
  UCD13: '3400891230468',
  ucdQtyMultiplicator: 1,
  cipLib: "ARACYTINE 500MG INJ FL BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '3804992',
  CIP13: '3400938049923',
  ucdLib: "CYTARABINE EBW 20MG/ML FL5ML",
  UCD7: '9305770',
  UCD13: '3400893057704',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE EBW 20MG/ML FL5ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '3757519',
  CIP13: '3400937575195',
  ucdLib: "CYTARABINE EG 20MG/ML INJ 5ML",
  UCD7: '9305787',
  UCD13: '3400893057872',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE EG 20MG/ML INJ 5ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5649283',
  CIP13: '3400956492831',
  ucdLib: "DEPOCYTE 50MG INJ FL5ML",
  UCD7: '9261050',
  UCD13: '3400892610504',
  ucdQtyMultiplicator: 1,
  cipLib: "DEPOCYTE 50MG INJ FL5ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5700713',
  CIP13: '3400957007133',
  ucdLib: "CYTARABINE EG 50MG/ML INJ 20ML",
  UCD7: '9302843',
  UCD13: '3400893028438',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE EG 50MG/ML INJ 20ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5853173',
  CIP13: '3400958531736',
  ucdLib: "CYTARABINE ACC 100MG/ML F10ML",
  UCD7: '9395023',
  UCD13: '3400893950234',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE ACC 100MG/ML F10ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5853196',
  CIP13: '3400958531965',
  ucdLib: "CYTARABINE ACC 100MG/ML F20ML",
  UCD7: '9395046',
  UCD13: '3400893950463',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE ACC 100MG/ML F20ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5853138',
  CIP13: '3400958531385',
  ucdLib: "CYTARABINE ACC 100MG/ML FL1ML",
  UCD7: '9395017',
  UCD13: '3400893950173',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE ACC 100MG/ML FL1ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5853150',
  CIP13: '3400958531507',
  ucdLib: "CYTARABINE ACC 100MG/ML FL5ML",
  UCD7: '9395052',
  UCD13: '3400893950524',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE ACC 100MG/ML FL5ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5828548',
  CIP13: '3400958285486',
  ucdLib: "CYTARABINE KBI 100MG/ML FL10ML",
  UCD7: '9391893',
  UCD13: '3400893918937',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE KBI 100MG/ML FL10ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5828525',
  CIP13: '3400958285257',
  ucdLib: "CYTARABINE KBI 100MG/ML FL1ML",
  UCD7: '9391887',
  UCD13: '3400893918876',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE KBI 100MG/ML FL1ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5828554',
  CIP13: '3400958285547',
  ucdLib: "CYTARABINE KBI 100MG/ML FL20ML",
  UCD7: '9391901',
  UCD13: '3400893919019',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE KBI 100MG/ML FL20ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5828531',
  CIP13: '3400958285318',
  ucdLib: "CYTARABINE KBI 100MG/ML FL5ML",
  UCD7: '9391918',
  UCD13: '3400893919187',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE KBI 100MG/ML FL5ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5808617',
  CIP13: '3400958086175',
  ucdLib: "CYTARABINE SDZ 100MG/ML FL50ML",
  UCD7: '9385467',
  UCD13: '3400893854679',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTARABINE SDZ 100MG/ML FL50ML BT 1",
  atcCode: "L01BC01"
}, {
  CIP7: '5713489',
  CIP13: '3400957134891',
  ucdLib: "ATRIANCE 5MG/ML PERF FL50ML",
  UCD7: '9304718',
  UCD13: '3400893047187',
  ucdQtyMultiplicator: 6,
  cipLib: "ATRIANCE 5MG/ML PERF FL50ML BT 6",
  atcCode: "L01BB07"
}, {
  CIP7: '5756777',
  CIP13: '3400957567774',
  ucdLib: "EVOLTRA 1MG/ML PERF FL20ML",
  UCD7: '9294954',
  UCD13: '3400892949543',
  ucdQtyMultiplicator: 1,
  cipLib: "EVOLTRA 1MG/ML PERF FL20ML BT 1",
  atcCode: "L01BB06"
}, {
  CIP7: '5585442',
  CIP13: '3400955854425',
  ucdLib: "FLUDARA 50MG INJ FL",
  UCD7: '9171341',
  UCD13: '3400891713411',
  ucdQtyMultiplicator: 5,
  cipLib: "FLUDARA 50MG INJ FL BT 5",
  atcCode: "L01BB05"
}, {
  CIP7: '3585320',
  CIP13: '3400935853202',
  ucdLib: "FLUDARA 10MG CPR",
  UCD7: '9240757',
  UCD13: '3400892407579',
  ucdQtyMultiplicator: 15,
  cipLib: "FLUDARA 10MG CPR BT 15",
  atcCode: "L01BB05"
}, {
  CIP7: '3585337',
  CIP13: '3400935853370',
  ucdLib: "FLUDARA 10MG CPR",
  UCD7: '9240757',
  UCD13: '3400892407579',
  ucdQtyMultiplicator: 20,
  cipLib: "FLUDARA 10MG CPR BT 20",
  atcCode: "L01BB05"
}, {
  CIP7: '3819999',
  CIP13: '3400938199994',
  ucdLib: "FLUDARABINE TVC 25MG/ML FL2ML",
  UCD7: '9307800',
  UCD13: '3400893078006',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUDARABINE TVC 25MG/ML FL2ML BT 1",
  atcCode: "L01BB05"
}, {
  CIP7: '5726693',
  CIP13: '3400957266936',
  ucdLib: "FLUDARABINE ARW 25MG/ML FL",
  UCD7: '9316710',
  UCD13: '3400893167106',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUDARABINE ARW 25MG/ML FL BT 1",
  atcCode: "L01BB05"
}, {
  CIP7: '5742717',
  CIP13: '3400957427177',
  ucdLib: "FLUDARABINE EBW 25MG/ML FL2ML",
  UCD7: '9325979',
  UCD13: '3400893259795',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUDARABINE EBW 25MG/ML FL2ML BT 1",
  atcCode: "L01BB05"
}, {
  CIP7: '3640668',
  CIP13: '3400936406681',
  ucdLib: "LITAK 2MG/ML INJ FL5ML",
  UCD7: '9271456',
  UCD13: '3400892714561',
  ucdQtyMultiplicator: 1,
  cipLib: "LITAK 2MG/ML INJ FL5ML BT 1",
  atcCode: "L01BB04"
}, {
  CIP7: '3640674',
  CIP13: '3400936406742',
  ucdLib: "LITAK 2MG/ML INJ FL5ML",
  UCD7: '9271456',
  UCD13: '3400892714561',
  ucdQtyMultiplicator: 5,
  cipLib: "LITAK 2MG/ML INJ FL5ML BT 5",
  atcCode: "L01BB04"
}, {
  CIP7: '5612423',
  CIP13: '3400956124237',
  ucdLib: "LEUSTATINE 10MG INJ FV10ML",
  UCD7: '9168014',
  UCD13: '3400891680140',
  ucdQtyMultiplicator: 1,
  cipLib: "LEUSTATINE 10MG INJ FV10ML BT 1",
  atcCode: "L01BB04"
}, {
  CIP7: '3692300',
  CIP13: '3400936923003',
  ucdLib: "LANVIS 40MG CPR",
  UCD7: '9184906',
  UCD13: '3400891849066',
  ucdQtyMultiplicator: 25,
  cipLib: "LANVIS 40MG CPR BT 25",
  atcCode: "L01BB03"
}, {
  CIP7: '3643112',
  CIP13: '3400936431126',
  ucdLib: "PURINETHOL 50MG CPR",
  UCD7: '9077352',
  UCD13: '3400890773522',
  ucdQtyMultiplicator: 25,
  cipLib: "PURINETHOL 50MG CPR BT 25",
  atcCode: "L01BB02"
}, {
  CIP7: '2245740',
  CIP13: '3400922457406',
  ucdLib: "XALUPRINE 20MG/ML FL100ML +N",
  UCD7: '9388721',
  UCD13: '3400893887219',
  ucdQtyMultiplicator: 1,
  cipLib: "XALUPRINE 20MG/ML FL100ML +N BT 1",
  atcCode: "L01BB02"
}, {
  CIP7: '3830802',
  CIP13: '3400938308020',
  ucdLib: "ALIMTA 100MG PERF FL",
  UCD7: '9311670',
  UCD13: '3400893116708',
  ucdQtyMultiplicator: 1,
  cipLib: "ALIMTA 100MG PERF FL BT 1",
  atcCode: "L01BA04"
}, {
  CIP7: '5658253',
  CIP13: '3400956582532',
  ucdLib: "ALIMTA 500MG PERF FL",
  UCD7: '9261771',
  UCD13: '3400892617718',
  ucdQtyMultiplicator: 1,
  cipLib: "ALIMTA 500MG PERF FL BT 1",
  atcCode: "L01BA04"
}, {
  CIP7: '5631739',
  CIP13: '3400956317394',
  ucdLib: "TOMUDEX 2MG INJ FL",
  UCD7: '9182066',
  UCD13: '3400891820669',
  ucdQtyMultiplicator: 1,
  cipLib: "TOMUDEX 2MG INJ FL BT 1",
  atcCode: "L01BA03"
}, {
  CIP7: '3067068',
  CIP13: '3400930670682',
  ucdLib: "METHOTREXATE BLN 2,5MG CPR",
  UCD7: '9058544',
  UCD13: '3400890585446',
  ucdQtyMultiplicator: 20,
  cipLib: "METHOTREXATE BLN 2,5MG CPR BT 20",
  atcCode: "L01BA01"
}, {
  CIP7: '3578337',
  CIP13: '3400935783370',
  ucdLib: "METHOTREX.MYL 2,5MG/ML 2ML",
  UCD7: '9233473',
  UCD13: '3400892334738',
  ucdQtyMultiplicator: 10,
  cipLib: "METHOTREX.MYL 2,5MG/ML 2ML BT 10",
  atcCode: "L01BA01"
}, {
  CIP7: '3578314',
  CIP13: '3400935783141',
  ucdLib: "METHOTREX.MYL 50MG/2ML FL",
  UCD7: '9233622',
  UCD13: '3400892336220',
  ucdQtyMultiplicator: 10,
  cipLib: "METHOTREX.MYL 50MG/2ML FL BT 10",
  atcCode: "L01BA01"
}, {
  CIP7: '3150148',
  CIP13: '3400931501480',
  ucdLib: "LEDERTREXATE 50MG INJ AMP2ML",
  UCD7: '9050287',
  UCD13: '3400890502870',
  ucdQtyMultiplicator: 1,
  cipLib: "LEDERTREXATE 50MG INJ AMP2ML BT 1",
  atcCode: "L01BA01"
}, {
  CIP7: '3150125',
  CIP13: '3400931501251',
  ucdLib: "METHOTREX.BDM 5MG INJ AMP2ML",
  UCD7: '9050270',
  UCD13: '3400890502702',
  ucdQtyMultiplicator: 1,
  cipLib: "METHOTREX.BDM 5MG INJ AMP2ML BT 1",
  atcCode: "L01BA01"
}, {
  CIP7: '5601968',
  CIP13: '3400956019687',
  ucdLib: "METHOTREX.TVC 500MG/20ML FL",
  UCD7: '9190634',
  UCD13: '3400891906349',
  ucdQtyMultiplicator: 1,
  cipLib: "METHOTREX.TVC 500MG/20ML FL BT 1",
  atcCode: "L01BA01"
}, {
  CIP7: '5601951',
  CIP13: '3400956019519',
  ucdLib: "METHOTREX.TVC 50MG/2ML FL",
  UCD7: '9190628',
  UCD13: '3400891906288',
  ucdQtyMultiplicator: 1,
  cipLib: "METHOTREX.TVC 50MG/2ML FL BT 1",
  atcCode: "L01BA01"
}, {
  CIP7: '5601974',
  CIP13: '3400956019748',
  ucdLib: "METHOTREX.TVC 5G/50ML FL",
  UCD7: '9190605',
  UCD13: '3400891906059',
  ucdQtyMultiplicator: 1,
  cipLib: "METHOTREX.TVC 5G/50ML FL BT 1",
  atcCode: "L01BA01"
}, {
  CIP7: '3160218',
  CIP13: '3400931602187',
  ucdLib: "METHOTREX.BDM 25MG INJ AMP1ML",
  UCD7: '9050264',
  UCD13: '3400890502641',
  ucdQtyMultiplicator: 1,
  cipLib: "METHOTREX.BDM 25MG INJ AMP1ML BT 1",
  atcCode: "L01BA01"
}, {
  CIP7: '5610097',
  CIP13: '3400956100972',
  ucdLib: "METHOTREX.TVC 1G/10ML FL",
  UCD7: '9205933',
  UCD13: '3400892059334',
  ucdQtyMultiplicator: 1,
  cipLib: "METHOTREX.TVC 1G/10ML FL BT 1",
  atcCode: "L01BA01"
}, {
  CIP7: '5642430',
  CIP13: '3400956424306',
  ucdLib: "METHOTREX.MYL 100MG/ML 50ML",
  UCD7: '9233467',
  UCD13: '3400892334677',
  ucdQtyMultiplicator: 10,
  cipLib: "METHOTREX.MYL 100MG/ML 50ML BT 10",
  atcCode: "L01BA01"
}, {
  CIP7: '5642341',
  CIP13: '3400956423415',
  ucdLib: "METHOTREX.MYL 25MG/ML 20ML",
  UCD7: '9233496',
  UCD13: '3400892334967',
  ucdQtyMultiplicator: 10,
  cipLib: "METHOTREX.MYL 25MG/ML 20ML BT 10",
  atcCode: "L01BA01"
}, {
  CIP7: '5681068',
  CIP13: '3400956810680',
  ucdLib: "METHOTREX.MYL 100MG/ML 10ML",
  UCD7: '9284795',
  UCD13: '3400892847955',
  ucdQtyMultiplicator: 10,
  cipLib: "METHOTREX.MYL 100MG/ML 10ML BT 10",
  atcCode: "L01BA01"
}, {
  CIP7: '5869837',
  CIP13: '3400958698378',
  ucdLib: "DACARBAZINE MDC 100MG INJ FL",
  UCD7: '9403053',
  UCD13: '3400894030539',
  ucdQtyMultiplicator: 10,
  cipLib: "DACARBAZINE MDC 100MG INJ FL BT 10",
  atcCode: "L01AX04"
}, {
  CIP7: '5869866',
  CIP13: '3400958698668',
  ucdLib: "DACARBAZINE MDC 500MG INJ FL",
  UCD7: '9403076',
  UCD13: '3400894030768',
  ucdQtyMultiplicator: 5,
  cipLib: "DACARBAZINE MDC 500MG INJ FL BT 5",
  atcCode: "L01AX04"
}, {
  CIP7: '5620121',
  CIP13: '3400956201211',
  ucdLib: "DETICENE 100MG INJ FL+AMP",
  UCD7: '9025711',
  UCD13: '3400890257114',
  ucdQtyMultiplicator: 10,
  cipLib: "DETICENE 100MG INJ FL+AMP BT 10",
  atcCode: "L01AX04"
}, {
  CIP7: '5769550',
  CIP13: '3400957695507',
  ucdLib: "DACARBAZINE LIP 100MG INJ FL",
  UCD7: '9362710',
  UCD13: '3400893627105',
  ucdQtyMultiplicator: 10,
  cipLib: "DACARBAZINE LIP 100MG INJ FL BT 10",
  atcCode: "L01AX04"
}, {
  CIP7: '5769567',
  CIP13: '3400957695675',
  ucdLib: "DACARBAZINE LIP 200MG INJ FL",
  UCD7: '9362727',
  UCD13: '3400893627273',
  ucdQtyMultiplicator: 10,
  cipLib: "DACARBAZINE LIP 200MG INJ FL BT 10",
  atcCode: "L01AX04"
}, {
  CIP7: '3002400',
  CIP13: '3400930024003',
  ucdLib: "TEMOZOLOMIDE ACC 100MG GELU",
  UCD7: '9351586',
  UCD13: '3400893515860',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE ACC 100MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '3002402',
  CIP13: '3400930024027',
  ucdLib: "TEMOZOLOMIDE ACC 140MG GELU",
  UCD7: '9351592',
  UCD13: '3400893515921',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE ACC 140MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '3002404',
  CIP13: '3400930024041',
  ucdLib: "TEMOZOLOMIDE ACC 180MG GELU",
  UCD7: '9351600',
  UCD13: '3400893516003',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE ACC 180MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '3002397',
  CIP13: '3400930023976',
  ucdLib: "TEMOZOLOMIDE ACC 20MG GELU",
  UCD7: '9351617',
  UCD13: '3400893516171',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE ACC 20MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '3002406',
  CIP13: '3400930024065',
  ucdLib: "TEMOZOLOMIDE ACC 250MG GELU",
  UCD7: '9351623',
  UCD13: '3400893516232',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE ACC 250MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '3002395',
  CIP13: '3400930023952',
  ucdLib: "TEMOZOLOMIDE ACC 5MG GELU",
  UCD7: '9351646',
  UCD13: '3400893516461',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE ACC 5MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '5747471',
  CIP13: '3400957474713',
  ucdLib: "TEMODAL 100MG GELU",
  UCD7: '9203058',
  UCD13: '3400892030586',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMODAL 100MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '5747494',
  CIP13: '3400957474942',
  ucdLib: "TEMODAL 140MG GELU",
  UCD7: '9330265',
  UCD13: '3400893302651',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMODAL 140MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '5747519',
  CIP13: '3400957475192',
  ucdLib: "TEMODAL 180MG GELU",
  UCD7: '9330271',
  UCD13: '3400893302712',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMODAL 180MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '5747554',
  CIP13: '3400957475543',
  ucdLib: "TEMODAL 2,5MG/ML INJ FL100MG",
  UCD7: '9330650',
  UCD13: '3400893306505',
  ucdQtyMultiplicator: 1,
  cipLib: "TEMODAL 2,5MG/ML INJ FL100MG BT 1",
  atcCode: "L01AX03"
}, {
  CIP7: '5747459',
  CIP13: '3400957474591',
  ucdLib: "TEMODAL 20MG GELU",
  UCD7: '9203064',
  UCD13: '3400892030647',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMODAL 20MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '5747531',
  CIP13: '3400957475314',
  ucdLib: "TEMODAL 250MG GELU",
  UCD7: '9203070',
  UCD13: '3400892030708',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMODAL 250MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '5759505',
  CIP13: '3400957595050',
  ucdLib: "TEMODAL 5MG GELU",
  UCD7: '9203087',
  UCD13: '3400892030876',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMODAL 5MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '2678597',
  CIP13: '3400926785970',
  ucdLib: "TEMOZOLOMIDE SUN 100MG GELU",
  UCD7: '9372743',
  UCD13: '3400893727430',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE SUN 100MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '2678611',
  CIP13: '3400926786113',
  ucdLib: "TEMOZOLOMIDE SUN 140MG GELU",
  UCD7: '9372766',
  UCD13: '3400893727669',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE SUN 140MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '2678634',
  CIP13: '3400926786342',
  ucdLib: "TEMOZOLOMIDE SUN 180MG GELU",
  UCD7: '9372772',
  UCD13: '3400893727720',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE SUN 180MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '2678574',
  CIP13: '3400926785741',
  ucdLib: "TEMOZOLOMIDE SUN 20MG GELU",
  UCD7: '9372789',
  UCD13: '3400893727898',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE SUN 20MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '2678657',
  CIP13: '3400926786571',
  ucdLib: "TEMOZOLOMIDE SUN 250MG GELU",
  UCD7: '9372795',
  UCD13: '3400893727959',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE SUN 250MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '2678551',
  CIP13: '3400926785512',
  ucdLib: "TEMOZOLOMIDE SUN 5MG GELU",
  UCD7: '9372803',
  UCD13: '3400893728031',
  ucdQtyMultiplicator: 5,
  cipLib: "TEMOZOLOMIDE SUN 5MG GELU BT 5",
  atcCode: "L01AX03"
}, {
  CIP7: '3487273',
  CIP13: '3400934872730',
  ucdLib: "VERCYTE 25MG CPR",
  UCD7: '9098199',
  UCD13: '3400890981996',
  ucdQtyMultiplicator: 30,
  cipLib: "VERCYTE 25MG CPR BT 30",
  atcCode: "L01AX02"
}, {
  CIP7: '3318702',
  CIP13: '3400933187026',
  ucdLib: "MUPHORAN INJ FL+AMP",
  UCD7: '9137580',
  UCD13: '3400891375800',
  ucdQtyMultiplicator: 1,
  cipLib: "MUPHORAN INJ FL+AMP BT 1",
  atcCode: "L01AD05"
}, {
  CIP7: '5619827',
  CIP13: '3400956198276',
  ucdLib: "ZANOSAR INJ FL",
  UCD7: '9123201',
  UCD13: '3400891232011',
  ucdQtyMultiplicator: 1,
  cipLib: "ZANOSAR INJ FL BT 1",
  atcCode: "L01AD04"
}, {
  CIP7: '3187275',
  CIP13: '3400931872757',
  ucdLib: "BELUSTINE 40MG GELU",
  UCD7: '9009994',
  UCD13: '3400890099943',
  ucdQtyMultiplicator: 5,
  cipLib: "BELUSTINE 40MG GELU BT 5",
  atcCode: "L01AD02"
}, {
  CIP7: '5619916',
  CIP13: '3400956199167',
  ucdLib: "BICNU INJ FL+AMP",
  UCD7: '9010750',
  UCD13: '3400890107501',
  ucdQtyMultiplicator: 1,
  cipLib: "BICNU INJ FL+AMP BT 1",
  atcCode: "L01AD01"
}, {
  CIP7: '5619075',
  CIP13: '3400956190751',
  ucdLib: "GLIADEL 7,7MG IMPL SACH",
  UCD7: '9212264',
  UCD13: '3400892122649',
  ucdQtyMultiplicator: 8,
  cipLib: "GLIADEL 7,7MG IMPL SACH BT 8",
  atcCode: "L01AD01"
}, {
  CIP7: '5789044',
  CIP13: '3400957890445',
  ucdLib: "TEPADINA 100MG PERF FL",
  UCD7: '9380292',
  UCD13: '3400893802922',
  ucdQtyMultiplicator: 1,
  cipLib: "TEPADINA 100MG PERF FL BT 1",
  atcCode: "L01AC01"
}, {
  CIP7: '5789038',
  CIP13: '3400957890384',
  ucdLib: "TEPADINA 15MG PERF FL",
  UCD7: '9380300',
  UCD13: '3400893803004',
  ucdQtyMultiplicator: 1,
  cipLib: "TEPADINA 15MG PERF FL BT 1",
  atcCode: "L01AC01"
}, {
  CIP7: '3692317',
  CIP13: '3400936923171',
  ucdLib: "MYLERAN 2MG CPR",
  UCD7: '9184912',
  UCD13: '3400891849127',
  ucdQtyMultiplicator: 25,
  cipLib: "MYLERAN 2MG CPR BT 25",
  atcCode: "L01AB01"
}, {
  CIP7: '5870734',
  CIP13: '3400958707346',
  ucdLib: "BUSULFAN FRK 6MG/ML PERF FL",
  UCD7: '9403521',
  UCD13: '3400894035213',
  ucdQtyMultiplicator: 8,
  cipLib: "BUSULFAN FRK 6MG/ML PERF FL BT 8",
  atcCode: "L01AB01"
}, {
  CIP7: '5721537',
  CIP13: '3400957215378',
  ucdLib: "BUSILVEX 6MG/ML INJ FL10ML",
  UCD7: '9319358',
  UCD13: '3400893193587',
  ucdQtyMultiplicator: 8,
  cipLib: "BUSILVEX 6MG/ML INJ FL10ML BT 8",
  atcCode: "L01AB01"
}, {
  CIP7: '5501644',
  CIP13: '3400955016441',
  ucdLib: "BENDAMUST.ACC 2,5MG/ML 100MG",
  UCD7: '9415317',
  UCD13: '3400894153177',
  ucdQtyMultiplicator: 5,
  cipLib: "BENDAMUST.ACC 2,5MG/ML 100MG BT 5",
  atcCode: "L01AA09"
}, {
  CIP7: '5501641',
  CIP13: '3400955016410',
  ucdLib: "BENDAMUST.ACC 2,5MG/ML 25MG",
  UCD7: '9415323',
  UCD13: '3400894153238',
  ucdQtyMultiplicator: 5,
  cipLib: "BENDAMUST.ACC 2,5MG/ML 25MG BT 5",
  atcCode: "L01AA09"
}, {
  CIP7: '5778655',
  CIP13: '3400957786557',
  ucdLib: "LEVACT 2,5MG/ML INJ FL100MG",
  UCD7: '9353987',
  UCD13: '3400893539873',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVACT 2,5MG/ML INJ FL100MG BT 5",
  atcCode: "L01AA09"
}, {
  CIP7: '5778632',
  CIP13: '3400957786328',
  ucdLib: "LEVACT 2,5MG/ML INJ FL25MG",
  UCD7: '9353970',
  UCD13: '3400893539705',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVACT 2,5MG/ML INJ FL25MG BT 5",
  atcCode: "L01AA09"
}, {
  CIP7: '5778649',
  CIP13: '3400957786496',
  ucdLib: "LEVACT 2,5MG/ML INJ FL25MG",
  UCD7: '9353970',
  UCD13: '3400893539705',
  ucdQtyMultiplicator: 20,
  cipLib: "LEVACT 2,5MG/ML INJ FL25MG BT 20",
  atcCode: "L01AA09"
}, {
  CIP7: '5584342',
  CIP13: '3400955843429',
  ucdLib: "HOLOXAN 2000MG INJ FL",
  UCD7: '9175304',
  UCD13: '3400891753042',
  ucdQtyMultiplicator: 1,
  cipLib: "HOLOXAN 2000MG INJ FL BT 1",
  atcCode: "L01AA06"
}, {
  CIP7: '3691772',
  CIP13: '3400936917729',
  ucdLib: "HOLOXAN 1000MG INJ FL",
  UCD7: '9149347',
  UCD13: '3400891493474',
  ucdQtyMultiplicator: 1,
  cipLib: "HOLOXAN 1000MG INJ FL BT 1",
  atcCode: "L01AA06"
}, {
  CIP7: '5665371',
  CIP13: '3400956653713',
  ucdLib: "IFOSFAMIDE EG 40MG/ML INJ 25ML",
  UCD7: '9354320',
  UCD13: '3400893543207',
  ucdQtyMultiplicator: 1,
  cipLib: "IFOSFAMIDE EG 40MG/ML INJ 25ML BT 1",
  atcCode: "L01AA06"
}, {
  CIP7: '5665388',
  CIP13: '3400956653881',
  ucdLib: "IFOSFAMIDE EG 40MG/ML INJ 50ML",
  UCD7: '9354337',
  UCD13: '3400893543375',
  ucdQtyMultiplicator: 1,
  cipLib: "IFOSFAMIDE EG 40MG/ML INJ 50ML BT 1",
  atcCode: "L01AA06"
}, {
  CIP7: '3607599',
  CIP13: '3400936075993',
  ucdLib: "ALKERAN 2MG CPR PELLIC",
  UCD7: '9207470',
  UCD13: '3400892074702',
  ucdQtyMultiplicator: 50,
  cipLib: "ALKERAN 2MG CPR PELLIC BT 50",
  atcCode: "L01AA03"
}, {
  CIP7: '5595268',
  CIP13: '3400955952688',
  ucdLib: "ALKERAN 50MG/10ML INJ FL+FL",
  UCD7: '9182356',
  UCD13: '3400891823561',
  ucdQtyMultiplicator: 1,
  cipLib: "ALKERAN 50MG/10ML INJ FL+FL BT 1",
  atcCode: "L01AA03"
}, {
  CIP7: '3369906',
  CIP13: '3400933699062',
  ucdLib: "CHLORAMINOPHENE 2MG GELU",
  UCD7: '9167960',
  UCD13: '3400891679601',
  ucdQtyMultiplicator: 30,
  cipLib: "CHLORAMINOPHENE 2MG GELU BT 30",
  atcCode: "L01AA02"
}, {
  CIP7: '3035890',
  CIP13: '3400930358900',
  ucdLib: "ENDOXAN 50MG CPR",
  UCD7: '9031083',
  UCD13: '3400890310833',
  ucdQtyMultiplicator: 50,
  cipLib: "ENDOXAN 50MG CPR BT 50",
  atcCode: "L01AA01"
}, {
  CIP7: '5583704',
  CIP13: '3400955837046',
  ucdLib: "ENDOXAN 1000MG PDR INJ FL",
  UCD7: '9167977',
  UCD13: '3400891679779',
  ucdQtyMultiplicator: 1,
  cipLib: "ENDOXAN 1000MG PDR INJ FL BT 1",
  atcCode: "L01AA01"
}, {
  CIP7: '3211950',
  CIP13: '3400932119509',
  ucdLib: "ENDOXAN 500MG INJ FL",
  UCD7: '9031108',
  UCD13: '3400890311083',
  ucdQtyMultiplicator: 1,
  cipLib: "ENDOXAN 500MG INJ FL BT 1",
  atcCode: "L01AA01"
}, {
  CIP7: '5500148',
  CIP13: '3400955001485',
  ucdLib: "CYCLOPHOSPHAM.SDZ 1000MG FL",
  UCD7: '9412460',
  UCD13: '3400894124603',
  ucdQtyMultiplicator: 1,
  cipLib: "CYCLOPHOSPHAM.SDZ 1000MG FL BT 1",
  atcCode: "L01AA01"
}, {
  CIP7: '5500145',
  CIP13: '3400955001454',
  ucdLib: "CYCLOPHOSPHAM.SDZ 500MG FL",
  UCD7: '9412477',
  UCD13: '3400894124771',
  ucdQtyMultiplicator: 1,
  cipLib: "CYCLOPHOSPHAM.SDZ 500MG FL BT 1",
  atcCode: "L01AA01"
}, {
  CIP7: '3607783',
  CIP13: '3400936077836',
  ucdLib: "TYAVAX INJ SRG1ML A/AIG",
  UCD7: '9251459',
  UCD13: '3400892514598',
  ucdQtyMultiplicator: 1,
  cipLib: "TYAVAX INJ SRG1ML A/AIG BT 1",
  atcCode: "J07CA10"
}, {
  CIP7: '3549583',
  CIP13: '3400935495839',
  ucdLib: "INFANRIX HEXA INJ FL+SRG+AIG",
  UCD7: '9237005',
  UCD13: '3400892370057',
  ucdQtyMultiplicator: 1,
  cipLib: "INFANRIX HEXA INJ FL+SRG+AIG BT 1",
  atcCode: "J07CA09"
}, {
  CIP7: '2735036',
  CIP13: '3400927350368',
  ucdLib: "HEXYON INJ SRG0,5ML + 2AIG",
  UCD7: '9411118',
  UCD13: '3400894111184',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXYON INJ SRG0,5ML + 2AIG BT 1",
  atcCode: "J07CA09"
}, {
  CIP7: '3687434',
  CIP13: '3400936874343',
  ucdLib: "PENTAVAC INJ FL+SRG A/2AIG",
  UCD7: '9286222',
  UCD13: '3400892862224',
  ucdQtyMultiplicator: 1,
  cipLib: "PENTAVAC INJ FL+SRG A/2AIG BT 1",
  atcCode: "J07CA06"
}, {
  CIP7: '3552473',
  CIP13: '3400935524737',
  ucdLib: "INFANRIXQUINTA INJ FL+SRG",
  UCD7: '9230552',
  UCD13: '3400892305523',
  ucdQtyMultiplicator: 1,
  cipLib: "INFANRIXQUINTA INJ FL+SRG BT 1",
  atcCode: "J07CA06"
}, {
  CIP7: '3687397',
  CIP13: '3400936873971',
  ucdLib: "REPEVAX INJ SRG 1 A/2AIG CHLOR",
  UCD7: '9291105',
  UCD13: '3400892911052',
  ucdQtyMultiplicator: 1,
  cipLib: "REPEVAX INJ SRG 1 A/2AIG CHLOR BT 1",
  atcCode: "J07CA02"
}, {
  CIP7: '3687492',
  CIP13: '3400936874923',
  ucdLib: "TETRAVAC-ACELLULAIRE SRG1 A/2A",
  UCD7: '9289568',
  UCD13: '3400892895680',
  ucdQtyMultiplicator: 1,
  cipLib: "TETRAVAC-ACELLULAIRE SRG1 A/2A BT 1",
  atcCode: "J07CA02"
}, {
  CIP7: '3677387',
  CIP13: '3400936773875',
  ucdLib: "BOOSTRIXTETRA INJ SRG0,5ML+A",
  UCD7: '9275253',
  UCD13: '3400892752532',
  ucdQtyMultiplicator: 1,
  cipLib: "BOOSTRIXTETRA INJ SRG0,5ML+A BT 1",
  atcCode: "J07CA02"
}, {
  CIP7: '3552467',
  CIP13: '3400935524676',
  ucdLib: "INFANRIXTETRA INJ SRG0,5ML",
  UCD7: '9230569',
  UCD13: '3400892305691',
  ucdQtyMultiplicator: 1,
  cipLib: "INFANRIXTETRA INJ SRG0,5ML BT 1",
  atcCode: "J07CA02"
}, {
  CIP7: '3687629',
  CIP13: '3400936876293',
  ucdLib: "REVAXIS INJ SRG0,5ML 1 A/2AIG",
  UCD7: '9289545',
  UCD13: '3400892895451',
  ucdQtyMultiplicator: 1,
  cipLib: "REVAXIS INJ SRG0,5ML 1 A/2AIG BT 1",
  atcCode: "J07CA01"
}, {
  CIP7: '3816423',
  CIP13: '3400938164237',
  ucdLib: "CERVARIX INJ SRG0,5ML +1AIG",
  UCD7: '9311196',
  UCD13: '3400893111963',
  ucdQtyMultiplicator: 1,
  cipLib: "CERVARIX INJ SRG0,5ML +1AIG BT 1",
  atcCode: "J07BM02"
}, {
  CIP7: '3771301',
  CIP13: '3400937713016',
  ucdLib: "GARDASIL INJ SRG A/2AIG",
  UCD7: '9300910',
  UCD13: '3400893009109',
  ucdQtyMultiplicator: 1,
  cipLib: "GARDASIL INJ SRG A/2AIG BT 1",
  atcCode: "J07BM01"
}, {
  CIP7: '3699348',
  CIP13: '3400936993488',
  ucdLib: "STAMARIL INJ FL+SRG A/2AIG",
  UCD7: '9304670',
  UCD13: '3400893046708',
  ucdQtyMultiplicator: 10,
  cipLib: "STAMARIL INJ FL+SRG A/2AIG BT 10",
  atcCode: "J07BL01"
}, {
  CIP7: '3759300',
  CIP13: '3400937593007',
  ucdLib: "ZOSTAVAX INJ FL+SRG +2AIG",
  UCD7: '9409162',
  UCD13: '3400894091622',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOSTAVAX INJ FL+SRG +2AIG BT 1",
  atcCode: "J07BK02"
}, {
  CIP7: '3687641',
  CIP13: '3400936876415',
  ucdLib: "VARIVAX INJ FL+SRG A/2AIG",
  UCD7: '9284298',
  UCD13: '3400892842981',
  ucdQtyMultiplicator: 1,
  cipLib: "VARIVAX INJ FL+SRG A/2AIG BT 1",
  atcCode: "J07BK01"
}, {
  CIP7: '3627722',
  CIP13: '3400936277229',
  ucdLib: "VARILRIX INJ FL+SRG",
  UCD7: '9260777',
  UCD13: '3400892607771',
  ucdQtyMultiplicator: 1,
  cipLib: "VARILRIX INJ FL+SRG BT 1",
  atcCode: "J07BK01"
}, {
  CIP7: '3762236',
  CIP13: '3400937622363',
  ucdLib: "ROTATEQ BUV UNIDOS2ML",
  UCD7: '9293831',
  UCD13: '3400892938318',
  ucdQtyMultiplicator: 1,
  cipLib: "ROTATEQ BUV UNIDOS2ML BT 1",
  atcCode: "J07BH02"
}, {
  CIP7: '3902016',
  CIP13: '3400939020167',
  ucdLib: "ROTARIX BUV APPLCT.1,5ML",
  UCD7: '9384350',
  UCD13: '3400893843505',
  ucdQtyMultiplicator: 1,
  cipLib: "ROTARIX BUV APPLCT.1,5ML BT 1",
  atcCode: "J07BH01"
}, {
  CIP7: '3304887',
  CIP13: '3400933048877',
  ucdLib: "PASTEUR VAC RABIQ.VERO FL+S.",
  UCD7: '9127363',
  UCD13: '3400891273632',
  ucdQtyMultiplicator: 1,
  cipLib: "PASTEUR VAC RABIQ.VERO FL+S. BT 1",
  atcCode: "J07BG01"
}, {
  CIP7: '3627679',
  CIP13: '3400936276796',
  ucdLib: "RABIPUR INJ FL+AMP +SRG",
  UCD7: '9263669',
  UCD13: '3400892636696',
  ucdQtyMultiplicator: 1,
  cipLib: "RABIPUR INJ FL+AMP +SRG BT 1",
  atcCode: "J07BG01"
}, {
  CIP7: '3257550',
  CIP13: '3400932575503',
  ucdLib: "IMOVAX POLIO SRG0,5ML",
  UCD7: '9203176',
  UCD13: '3400892031767',
  ucdQtyMultiplicator: 1,
  cipLib: "IMOVAX POLIO SRG0,5ML BT 1",
  atcCode: "J07BF03"
}, {
  CIP7: '3513734',
  CIP13: '3400935137340',
  ucdLib: "PRIORIX INJ FL+SRG +2AIG",
  UCD7: '9213594',
  UCD13: '3400892135946',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIORIX INJ FL+SRG +2AIG BT 1",
  atcCode: "J07BD52"
}, {
  CIP7: '3732821',
  CIP13: '3400937328210',
  ucdLib: "M-M-RVAXPRO INJ FL+SRG +2AIG",
  UCD7: '9310469',
  UCD13: '3400893104699',
  ucdQtyMultiplicator: 1,
  cipLib: "M-M-RVAXPRO INJ FL+SRG +2AIG BT 1",
  atcCode: "J07BD52"
}, {
  CIP7: '3092675',
  CIP13: '3400930926758',
  ucdLib: "ROUVAX FL+SERING",
  UCD7: '9081218',
  UCD13: '3400890812184',
  ucdQtyMultiplicator: 1,
  cipLib: "ROUVAX FL+SERING BT 1",
  atcCode: "J07BD01"
}, {
  CIP7: '3567693',
  CIP13: '3400935676931',
  ucdLib: "TWINRIX AD. INJ SRG+AIG",
  UCD7: '9234780',
  UCD13: '3400892347806',
  ucdQtyMultiplicator: 1,
  cipLib: "TWINRIX AD. INJ SRG+AIG BT 1",
  atcCode: "J07BC20"
}, {
  CIP7: '3567687',
  CIP13: '3400935676870',
  ucdLib: "TWINRIX ENF INJ SRG+AIG",
  UCD7: '9234797',
  UCD13: '3400892347974',
  ucdQtyMultiplicator: 1,
  cipLib: "TWINRIX ENF INJ SRG+AIG BT 1",
  atcCode: "J07BC20"
}, {
  CIP7: '3830995',
  CIP13: '3400938309959',
  ucdLib: "VAQTA 50U/1ML INJ SRG +2AIG",
  UCD7: '9410828',
  UCD13: '3400894108283',
  ucdQtyMultiplicator: 1,
  cipLib: "VAQTA 50U/1ML INJ SRG +2AIG BT 1",
  atcCode: "J07BC02"
}, {
  CIP7: '3377515',
  CIP13: '3400933775155',
  ucdLib: "HAVRIX 1440 AD. INJ SRG1ML",
  UCD7: '9169031',
  UCD13: '3400891690316',
  ucdQtyMultiplicator: 1,
  cipLib: "HAVRIX 1440 AD. INJ SRG1ML BT 1",
  atcCode: "J07BC02"
}, {
  CIP7: '3708202',
  CIP13: '3400937082020',
  ucdLib: "AVAXIM 160U INJ S0,5ML A/2A",
  UCD7: '9301105',
  UCD13: '3400893011058',
  ucdQtyMultiplicator: 1,
  cipLib: "AVAXIM 160U INJ S0,5ML A/2A BT 1",
  atcCode: "J07BC02"
}, {
  CIP7: '3476045',
  CIP13: '3400934760457',
  ucdLib: "HAVRIX 720 ENF INJ SRG0,5ML",
  UCD7: '9206571',
  UCD13: '3400892065717',
  ucdQtyMultiplicator: 1,
  cipLib: "HAVRIX 720 ENF INJ SRG0,5ML BT 1",
  atcCode: "J07BC02"
}, {
  CIP7: '2245958',
  CIP13: '3400922459585',
  ucdLib: "AVAXIM 80U INJ SRG0,5ML+2AIG",
  UCD7: '9391367',
  UCD13: '3400893913673',
  ucdQtyMultiplicator: 1,
  cipLib: "AVAXIM 80U INJ SRG0,5ML+2AIG BT 1",
  atcCode: "J07BC02"
}, {
  CIP7: '3567658',
  CIP13: '3400935676580',
  ucdLib: "HBVAXPRO 40MCG INJ FL1ML",
  UCD7: '9230894',
  UCD13: '3400892308944',
  ucdQtyMultiplicator: 1,
  cipLib: "HBVAXPRO 40MCG INJ FL1ML BT 1",
  atcCode: "J07BC01"
}, {
  CIP7: '3516709',
  CIP13: '3400935167095',
  ucdLib: "ENGERIX B 10Y SRG.BACK.0,5ML",
  UCD7: '9225806',
  UCD13: '3400892258065',
  ucdQtyMultiplicator: 1,
  cipLib: "ENGERIX B 10Y SRG.BACK.0,5ML BT 1",
  atcCode: "J07BC01"
}, {
  CIP7: '3516690',
  CIP13: '3400935166906',
  ucdLib: "ENGERIX B 20Y SRG.BACK.1ML",
  UCD7: '9225812',
  UCD13: '3400892258126',
  ucdQtyMultiplicator: 1,
  cipLib: "ENGERIX B 20Y SRG.BACK.1ML BT 1",
  atcCode: "J07BC01"
}, {
  CIP7: '3692464',
  CIP13: '3400936924642',
  ucdLib: "HBVAXPRO 10MCG SRG1ML A/2AIG",
  UCD7: '9289290',
  UCD13: '3400892892900',
  ucdQtyMultiplicator: 1,
  cipLib: "HBVAXPRO 10MCG SRG1ML A/2AIG BT 1",
  atcCode: "J07BC01"
}, {
  CIP7: '3692429',
  CIP13: '3400936924291',
  ucdLib: "HBVAXPRO 5MCG SRG0,5ML A/2A",
  UCD7: '9289309',
  UCD13: '3400892893099',
  ucdQtyMultiplicator: 1,
  cipLib: "HBVAXPRO 5MCG SRG0,5ML A/2A BT 1",
  atcCode: "J07BC01"
}, {
  CIP7: '3001117',
  CIP13: '3400930011171',
  ucdLib: "FLUENZ TETRA PULV NAS 3VOLET",
  UCD7: '9417109',
  UCD13: '3400894171096',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUENZ TETRA PULV NAS 3VOLET BT 1",
  atcCode: "J07BB03"
}, {
  CIP7: '3002922',
  CIP13: '3400930029220',
  ucdLib: "FLUARIXTETRA INJ SRG0,5ML +2A",
  UCD7: '9421246',
  UCD13: '3400894212461',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUARIXTETRA INJ SRG0,5ML +2A BT 1",
  atcCode: "J07BB02"
}, {
  CIP7: '3338550',
  CIP13: '3400933385507',
  ucdLib: "IMMUGRIP INJ SRG0,5ML",
  UCD7: '9150244',
  UCD13: '3400891502442',
  ucdQtyMultiplicator: 1,
  cipLib: "IMMUGRIP INJ SRG0,5ML BT 1",
  atcCode: "J07BB02"
}, {
  CIP7: '3365216',
  CIP13: '3400933652166',
  ucdLib: "INFLUVAC INJ SRG0,5ML",
  UCD7: '9173469',
  UCD13: '3400891734690',
  ucdQtyMultiplicator: 1,
  cipLib: "INFLUVAC INJ SRG0,5ML BT 1",
  atcCode: "J07BB02"
}, {
  CIP7: '3212990',
  CIP13: '3400932129904',
  ucdLib: "VAXIGRIP INJ SRG0,5ML A/AIG",
  UCD7: '9097840',
  UCD13: '3400890978408',
  ucdQtyMultiplicator: 1,
  cipLib: "VAXIGRIP INJ SRG0,5ML A/AIG BT 1",
  atcCode: "J07BB02"
}, {
  CIP7: '3594738',
  CIP13: '3400935947383',
  ucdLib: "AGRIPPAL INJ SRG0,5ML A/AIG",
  UCD7: '9241656',
  UCD13: '3400892416564',
  ucdQtyMultiplicator: 1,
  cipLib: "AGRIPPAL INJ SRG0,5ML A/AIG BT 1",
  atcCode: "J07BB02"
}, {
  CIP7: '2751331',
  CIP13: '3400927513312',
  ucdLib: "OPTAFLU INJ SRG0,5ML A/ALUER",
  UCD7: '9398671',
  UCD13: '3400893986714',
  ucdQtyMultiplicator: 1,
  cipLib: "OPTAFLU INJ SRG0,5ML A/ALUER BT 1",
  atcCode: "J07BB02"
}, {
  CIP7: '3939597',
  CIP13: '3400939395975',
  ucdLib: "IXIARO INJ SRG0,5ML S/AIG",
  UCD7: '9331997',
  UCD13: '3400893319970',
  ucdQtyMultiplicator: 1,
  cipLib: "IXIARO INJ SRG0,5ML S/AIG BT 1",
  atcCode: "J07BA02"
}, {
  CIP7: '3677453',
  CIP13: '3400936774537',
  ucdLib: "ENCEPUR 1,5MCG/0,5ML INJ SRG",
  UCD7: '9331833',
  UCD13: '3400893318331',
  ucdQtyMultiplicator: 1,
  cipLib: "ENCEPUR 1,5MCG/0,5ML INJ SRG BT 1",
  atcCode: "J07BA01"
}, {
  CIP7: '3677482',
  CIP13: '3400936774827',
  ucdLib: "TICOVAC 0,25ML ENF S/A SRG",
  UCD7: '9414068',
  UCD13: '3400894140689',
  ucdQtyMultiplicator: 1,
  cipLib: "TICOVAC 0,25ML ENF S/A SRG BT 1",
  atcCode: "J07BA01"
}, {
  CIP7: '2784170',
  CIP13: '3400927841705',
  ucdLib: "TICOVAC 0,5ML AD. S/A SRG",
  UCD7: '9414074',
  UCD13: '3400894140740',
  ucdQtyMultiplicator: 1,
  cipLib: "TICOVAC 0,5ML AD. S/A SRG BT 1",
  atcCode: "J07BA01"
}, {
  CIP7: '3514716',
  CIP13: '3400935147165',
  ucdLib: "SPIROLEPT INJ SRG1ML",
  UCD7: '9214062',
  UCD13: '3400892140629',
  ucdQtyMultiplicator: 1,
  cipLib: "SPIROLEPT INJ SRG1ML BT 1",
  atcCode: "J07AX"
}, {
  CIP7: '3699302',
  CIP13: '3400936993020',
  ucdLib: "TYPHIM VI INJ SRG0,5ML 1 A/2AI",
  UCD7: '9305215',
  UCD13: '3400893052150',
  ucdQtyMultiplicator: 1,
  cipLib: "TYPHIM VI INJ SRG0,5ML 1 A/2AI BT 1",
  atcCode: "J07AP03"
}, {
  CIP7: '3508035',
  CIP13: '3400935080356',
  ucdLib: "TYPHERIX INJ SRG0,5ML",
  UCD7: '9210638',
  UCD13: '3400892106380',
  ucdQtyMultiplicator: 1,
  cipLib: "TYPHERIX INJ SRG0,5ML BT 1",
  atcCode: "J07AP03"
}, {
  CIP7: '3646642',
  CIP13: '3400936466425',
  ucdLib: "SSI VAC BCG INJ FL+FL +N.",
  UCD7: '9261601',
  UCD13: '3400892616018',
  ucdQtyMultiplicator: 1,
  cipLib: "SSI VAC BCG INJ FL+FL +N. BT 1",
  atcCode: "J07AN01"
}, {
  CIP7: '3285724',
  CIP13: '3400932857241',
  ucdLib: "PASTEUR VAC TETAN. SV0,5ML",
  UCD7: '9109862',
  UCD13: '3400891098624',
  ucdQtyMultiplicator: 1,
  cipLib: "PASTEUR VAC TETAN. SV0,5ML BT 1",
  atcCode: "J07AM01"
}, {
  CIP7: '5521301',
  CIP13: '3400955213017',
  ucdLib: "PASTEUR VAC TETAN. SV0,5ML",
  UCD7: '9109862',
  UCD13: '3400891098624',
  ucdQtyMultiplicator: 20,
  cipLib: "PASTEUR VAC TETAN. SV0,5ML BT 20",
  atcCode: "J07AM01"
}, {
  CIP7: '3990115',
  CIP13: '3400939901152',
  ucdLib: "PREVENAR 13 INJ SRG0,5ML A/A",
  UCD7: '9342819',
  UCD13: '3400893428191',
  ucdQtyMultiplicator: 1,
  cipLib: "PREVENAR 13 INJ SRG0,5ML A/A BT 1",
  atcCode: "J07AL02"
}, {
  CIP7: '3243482',
  CIP13: '3400932434824',
  ucdLib: "PNEUMO 23 INJ SRG0,5ML",
  UCD7: '9046021',
  UCD13: '3400890460217',
  ucdQtyMultiplicator: 1,
  cipLib: "PNEUMO 23 INJ SRG0,5ML BT 1",
  atcCode: "J07AL01"
}, {
  CIP7: '3552800',
  CIP13: '3400935528001',
  ucdLib: "PNEUMOVAX INJ FL0,5ML",
  UCD7: '9314154',
  UCD13: '3400893141540',
  ucdQtyMultiplicator: 1,
  cipLib: "PNEUMOVAX INJ FL0,5ML BT 1",
  atcCode: "J07AL01"
}, {
  CIP7: '2686303',
  CIP13: '3400926863036',
  ucdLib: "BEXSERO INJ SRG0,5ML +AIG",
  UCD7: '9397832',
  UCD13: '3400893978320',
  ucdQtyMultiplicator: 1,
  cipLib: "BEXSERO INJ SRG0,5ML +AIG BT 1",
  atcCode: "J07AH09"
}, {
  CIP7: '2170290',
  CIP13: '3400921702903',
  ucdLib: "MENVEO INJ FL+FL",
  UCD7: '9380642',
  UCD13: '3400893806425',
  ucdQtyMultiplicator: 1,
  cipLib: "MENVEO INJ FL+FL BT 1",
  atcCode: "J07AH08"
}, {
  CIP7: '2225393',
  CIP13: '3400922253930',
  ucdLib: "NIMENRIX INJ FL+SRG A/2AIG",
  UCD7: '9387360',
  UCD13: '3400893873601',
  ucdQtyMultiplicator: 1,
  cipLib: "NIMENRIX INJ FL+SRG A/2AIG BT 1",
  atcCode: "J07AH08"
}, {
  CIP7: '3001760',
  CIP13: '3400930017609',
  ucdLib: "MENJUGATE 10MCG INJ SRG0,6ML",
  UCD7: '9410024',
  UCD13: '3400894100249',
  ucdQtyMultiplicator: 1,
  cipLib: "MENJUGATE 10MCG INJ SRG0,6ML BT 1",
  atcCode: "J07AH07"
}, {
  CIP7: '3627739',
  CIP13: '3400936277397',
  ucdLib: "NEISVAC INJ SRG0,5ML +NEC",
  UCD7: '9257108',
  UCD13: '3400892571089',
  ucdQtyMultiplicator: 1,
  cipLib: "NEISVAC INJ SRG0,5ML +NEC BT 1",
  atcCode: "J07AH07"
}, {
  CIP7: '3815010',
  CIP13: '3400938150100',
  ucdLib: "MENINGITEC INJ SRG0,5ML +AIG",
  UCD7: '9307303',
  UCD13: '3400893073032',
  ucdQtyMultiplicator: 1,
  cipLib: "MENINGITEC INJ SRG0,5ML +AIG BT 1",
  atcCode: "J07AH07"
}, {
  CIP7: '3858858',
  CIP13: '3400938588583',
  ucdLib: "MENCEVAX INJ FL+FL",
  UCD7: '9321562',
  UCD13: '3400893215623',
  ucdQtyMultiplicator: 1,
  cipLib: "MENCEVAX INJ FL+FL BT 1",
  atcCode: "J07AH04"
}, {
  CIP7: '3183722',
  CIP13: '3400931837220',
  ucdLib: "MERIEUX VAC MEN. A+C FL+SER.",
  UCD7: '9058260',
  UCD13: '3400890582605',
  ucdQtyMultiplicator: 1,
  cipLib: "MERIEUX VAC MEN. A+C FL+SER. BT 1",
  atcCode: "J07AH03"
}, {
  CIP7: '3347201',
  CIP13: '3400933472016',
  ucdLib: "ACT-HIB INJ FL+SRG",
  UCD7: '9152591',
  UCD13: '3400891525915',
  ucdQtyMultiplicator: 1,
  cipLib: "ACT-HIB INJ FL+SRG BT 1",
  atcCode: "J07AG01"
}, {
  CIP7: '3651258',
  CIP13: '3400936512580',
  ucdLib: "DUKORAL BUV FL+SACH",
  UCD7: '9267029',
  UCD13: '3400892670294',
  ucdQtyMultiplicator: 2,
  cipLib: "DUKORAL BUV FL+SACH BT 2",
  atcCode: "J07AE01"
}, {
  CIP7: '3521550',
  CIP13: '3400935215505',
  ucdLib: "SYNAGIS 100MG INJ FL+AMP",
  UCD7: '9213743',
  UCD13: '3400892137438',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNAGIS 100MG INJ FL+AMP BT 1",
  atcCode: "J06BB16"
}, {
  CIP7: '3523141',
  CIP13: '3400935231413',
  ucdLib: "SYNAGIS 50MG INJ FL+AMP",
  UCD7: '9213766',
  UCD13: '3400892137667',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNAGIS 50MG INJ FL+AMP BT 1",
  atcCode: "J06BB16"
}, {
  CIP7: '3482318',
  CIP13: '3400934823183',
  ucdLib: "IMOGAM RAGE 150UI/ML FL2ML",
  UCD7: '9172872',
  UCD13: '3400891728729',
  ucdQtyMultiplicator: 1,
  cipLib: "IMOGAM RAGE 150UI/ML FL2ML BT 1",
  atcCode: "J06BB05"
}, {
  CIP7: '3464800',
  CIP13: '3400934648007',
  ucdLib: "FAVIRAB INJ FL5ML",
  UCD7: '9204106',
  UCD13: '3400892041063',
  ucdQtyMultiplicator: 1,
  cipLib: "FAVIRAB INJ FL5ML BT 1",
  atcCode: "J06BB05"
}, {
  CIP7: '5621362',
  CIP13: '3400956213627',
  ucdLib: "IVHEBEX 5000UI INJ FV+FV",
  UCD7: '9233208',
  UCD13: '3400892332086',
  ucdQtyMultiplicator: 1,
  cipLib: "IVHEBEX 5000UI INJ FV+FV BT 1",
  atcCode: "J06BB04"
}, {
  CIP7: '5815764',
  CIP13: '3400958157646',
  ucdLib: "IMMUNOGLOB.100 LFB HEP-B 1ML",
  UCD7: '9385094',
  UCD13: '3400893850947',
  ucdQtyMultiplicator: 1,
  cipLib: "IMMUNOGLOB.100 LFB HEP-B 1ML BT 1",
  atcCode: "J06BB04"
}, {
  CIP7: '5815770',
  CIP13: '3400958157707',
  ucdLib: "IMMUNOGLOB.100 LFB HEP-B 5ML",
  UCD7: '9385102',
  UCD13: '3400893851029',
  ucdQtyMultiplicator: 5,
  cipLib: "IMMUNOGLOB.100 LFB HEP-B 5ML BT 5",
  atcCode: "J06BB04"
}, {
  CIP7: '5787571',
  CIP13: '3400957875718',
  ucdLib: "ZUTECTRA 500UI INJ SRG1ML",
  UCD7: '9373671',
  UCD13: '3400893736715',
  ucdQtyMultiplicator: 5,
  cipLib: "ZUTECTRA 500UI INJ SRG1ML BT 5",
  atcCode: "J06BB04"
}, {
  CIP7: '3289219',
  CIP13: '3400932892198',
  ucdLib: "GAMMATETANOS 250UI SRG2ML",
  UCD7: '9120444',
  UCD13: '3400891204445',
  ucdQtyMultiplicator: 1,
  cipLib: "GAMMATETANOS 250UI SRG2ML BT 1",
  atcCode: "J06BB02"
}, {
  CIP7: '3214776',
  CIP13: '3400932147762',
  ucdLib: "IMMUNOGLOB.TET.PAST 1500 SRG",
  UCD7: '9068459',
  UCD13: '3400890684590',
  ucdQtyMultiplicator: 1,
  cipLib: "IMMUNOGLOB.TET.PAST 1500 SRG BT 1",
  atcCode: "J06BB02"
}, {
  CIP7: '3639702',
  CIP13: '3400936397026',
  ucdLib: "RHOPHYLAC 200MCG/2ML INJ SRG",
  UCD7: '9267495',
  UCD13: '3400892674957',
  ucdQtyMultiplicator: 1,
  cipLib: "RHOPHYLAC 200MCG/2ML INJ SRG BT 1",
  atcCode: "J06BB01"
}, {
  CIP7: '3639719',
  CIP13: '3400936397194',
  ucdLib: "RHOPHYLAC 300MCG/2ML INJ SRG",
  UCD7: '9267503',
  UCD13: '3400892675039',
  ucdQtyMultiplicator: 1,
  cipLib: "RHOPHYLAC 300MCG/2ML INJ SRG BT 1",
  atcCode: "J06BB01"
}, {
  CIP7: '5598982',
  CIP13: '3400955989820',
  ucdLib: "TEGELINE 50MG/ML INJ F+F100ML",
  UCD7: '9182853',
  UCD13: '3400891828535',
  ucdQtyMultiplicator: 1,
  cipLib: "TEGELINE 50MG/ML INJ F+F100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5598953',
  CIP13: '3400955989530',
  ucdLib: "TEGELINE 50MG/ML INJ F+F10ML",
  UCD7: '9182824',
  UCD13: '3400891828245',
  ucdQtyMultiplicator: 1,
  cipLib: "TEGELINE 50MG/ML INJ F+F10ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5598999',
  CIP13: '3400955989998',
  ucdLib: "TEGELINE 50MG/ML INJ F+F200ML",
  UCD7: '9182830',
  UCD13: '3400891828306',
  ucdQtyMultiplicator: 1,
  cipLib: "TEGELINE 50MG/ML INJ F+F200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5598976',
  CIP13: '3400955989769',
  ucdLib: "TEGELINE 50MG/ML INJ F+F50ML",
  UCD7: '9182847',
  UCD13: '3400891828474',
  ucdQtyMultiplicator: 1,
  cipLib: "TEGELINE 50MG/ML INJ F+F50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5603140',
  CIP13: '3400956031405',
  ucdLib: "GAMMAGARD 50MG/ML FL+FL100ML",
  UCD7: '9199078',
  UCD13: '3400891990782',
  ucdQtyMultiplicator: 1,
  cipLib: "GAMMAGARD 50MG/ML FL+FL100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5603157',
  CIP13: '3400956031573',
  ucdLib: "GAMMAGARD 50MG/ML FL+FL200ML",
  UCD7: '9199055',
  UCD13: '3400891990553',
  ucdQtyMultiplicator: 1,
  cipLib: "GAMMAGARD 50MG/ML FL+FL200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5620598',
  CIP13: '3400956205981',
  ucdLib: "OCTAGAM 50MG/ML INJ FL100ML",
  UCD7: '9212488',
  UCD13: '3400892124889',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 50MG/ML INJ FL100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5620606',
  CIP13: '3400956206063',
  ucdLib: "OCTAGAM 50MG/ML INJ FL200ML",
  UCD7: '9212494',
  UCD13: '3400892124940',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 50MG/ML INJ FL200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5621149',
  CIP13: '3400956211494',
  ucdLib: "OCTAGAM 50MG/ML INJ FL20ML",
  UCD7: '9231669',
  UCD13: '3400892316697',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 50MG/ML INJ FL20ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5620581',
  CIP13: '3400956205813',
  ucdLib: "OCTAGAM 50MG/ML INJ FL50ML",
  UCD7: '9212502',
  UCD13: '3400892125022',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 50MG/ML INJ FL50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '3732755',
  CIP13: '3400937327558',
  ucdLib: "KIOVIG 100MG/ML INJ FL100ML",
  UCD7: '9282715',
  UCD13: '3400892827155',
  ucdQtyMultiplicator: 1,
  cipLib: "KIOVIG 100MG/ML INJ FL100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '3732726',
  CIP13: '3400937327268',
  ucdLib: "KIOVIG 100MG/ML INJ FL10ML",
  UCD7: '9282709',
  UCD13: '3400892827094',
  ucdQtyMultiplicator: 1,
  cipLib: "KIOVIG 100MG/ML INJ FL10ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '3732844',
  CIP13: '3400937328449',
  ucdLib: "KIOVIG 100MG/ML INJ FL200ML",
  UCD7: '9284890',
  UCD13: '3400892848907',
  ucdQtyMultiplicator: 1,
  cipLib: "KIOVIG 100MG/ML INJ FL200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '3732732',
  CIP13: '3400937327329',
  ucdLib: "KIOVIG 100MG/ML INJ FL25ML",
  UCD7: '9282721',
  UCD13: '3400892827216',
  ucdQtyMultiplicator: 1,
  cipLib: "KIOVIG 100MG/ML INJ FL25ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '3732749',
  CIP13: '3400937327497',
  ucdLib: "KIOVIG 100MG/ML INJ FL50ML",
  UCD7: '9282738',
  UCD13: '3400892827384',
  ucdQtyMultiplicator: 1,
  cipLib: "KIOVIG 100MG/ML INJ FL50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5711237',
  CIP13: '3400957112370',
  ucdLib: "OCTAGAM 50MG/ML INJ FL500ML",
  UCD7: '9372619',
  UCD13: '3400893726198',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 50MG/ML INJ FL500ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5727913',
  CIP13: '3400957279134',
  ucdLib: "PRIVIGEN 100MG/ML PERF FV100ML",
  UCD7: '9312652',
  UCD13: '3400893126523',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIVIGEN 100MG/ML PERF FV100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5727936',
  CIP13: '3400957279363',
  ucdLib: "PRIVIGEN 100MG/ML PERF FV200ML",
  UCD7: '9312669',
  UCD13: '3400893126691',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIVIGEN 100MG/ML PERF FV200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5756234',
  CIP13: '3400957562342',
  ucdLib: "PRIVIGEN 100MG/ML PERF FV25ML",
  UCD7: '9341398',
  UCD13: '3400893413982',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIVIGEN 100MG/ML PERF FV25ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5727907',
  CIP13: '3400957279073',
  ucdLib: "PRIVIGEN 100MG/ML PERF FV50ML",
  UCD7: '9312675',
  UCD13: '3400893126752',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIVIGEN 100MG/ML PERF FV50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5798161',
  CIP13: '3400957981617',
  ucdLib: "FLEBOGAMMA DIF 100MG/ML F100ML",
  UCD7: '9373725',
  UCD13: '3400893737255',
  ucdQtyMultiplicator: 1,
  cipLib: "FLEBOGAMMA DIF 100MG/ML F100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5798178',
  CIP13: '3400957981785',
  ucdLib: "FLEBOGAMMA DIF 100MG/ML F200ML",
  UCD7: '9373731',
  UCD13: '3400893737316',
  ucdQtyMultiplicator: 1,
  cipLib: "FLEBOGAMMA DIF 100MG/ML F200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5798155',
  CIP13: '3400957981556',
  ucdLib: "FLEBOGAMMA DIF 100MG/ML FL50ML",
  UCD7: '9373748',
  UCD13: '3400893737484',
  ucdQtyMultiplicator: 1,
  cipLib: "FLEBOGAMMA DIF 100MG/ML FL50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5770292',
  CIP13: '3400957702922',
  ucdLib: "FLEBOGAMMA DIF 50MG/ML FL100ML",
  UCD7: '9360668',
  UCD13: '3400893606681',
  ucdQtyMultiplicator: 1,
  cipLib: "FLEBOGAMMA DIF 50MG/ML FL100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5770263',
  CIP13: '3400957702632',
  ucdLib: "FLEBOGAMMA DIF 50MG/ML FL10ML",
  UCD7: '9360651',
  UCD13: '3400893606513',
  ucdQtyMultiplicator: 1,
  cipLib: "FLEBOGAMMA DIF 50MG/ML FL10ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5770300',
  CIP13: '3400957703004',
  ucdLib: "FLEBOGAMMA DIF 50MG/ML FL200ML",
  UCD7: '9360674',
  UCD13: '3400893606742',
  ucdQtyMultiplicator: 1,
  cipLib: "FLEBOGAMMA DIF 50MG/ML FL200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5770317',
  CIP13: '3400957703172',
  ucdLib: "FLEBOGAMMA DIF 50MG/ML FL400ML",
  UCD7: '9360680',
  UCD13: '3400893606803',
  ucdQtyMultiplicator: 1,
  cipLib: "FLEBOGAMMA DIF 50MG/ML FL400ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5770286',
  CIP13: '3400957702861',
  ucdLib: "FLEBOGAMMA DIF 50MG/ML FL50ML",
  UCD7: '9360697',
  UCD13: '3400893606971',
  ucdQtyMultiplicator: 1,
  cipLib: "FLEBOGAMMA DIF 50MG/ML FL50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5777845',
  CIP13: '3400957778453',
  ucdLib: "KIOVIG 100MG/ML INJ FL300ML",
  UCD7: '9352516',
  UCD13: '3400893525166',
  ucdQtyMultiplicator: 1,
  cipLib: "KIOVIG 100MG/ML INJ FL300ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5854066',
  CIP13: '3400958540660',
  ucdLib: "PRIVIGEN 100MG/ML PERF FV400ML",
  UCD7: '9395112',
  UCD13: '3400893951125',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIVIGEN 100MG/ML PERF FV400ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761896',
  CIP13: '3400957618964',
  ucdLib: "CLAIRYG 50MG/ML INJ FL100ML",
  UCD7: '9347567',
  UCD13: '3400893475676',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAIRYG 50MG/ML INJ FL100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761904',
  CIP13: '3400957619046',
  ucdLib: "CLAIRYG 50MG/ML INJ FL200ML",
  UCD7: '9347596',
  UCD13: '3400893475966',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAIRYG 50MG/ML INJ FL200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761867',
  CIP13: '3400957618674',
  ucdLib: "CLAIRYG 50MG/ML INJ FL20ML",
  UCD7: '9347573',
  UCD13: '3400893475737',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAIRYG 50MG/ML INJ FL20ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761910',
  CIP13: '3400957619107',
  ucdLib: "CLAIRYG 50MG/ML INJ FL400ML",
  UCD7: '9347604',
  UCD13: '3400893476048',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAIRYG 50MG/ML INJ FL400ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761873',
  CIP13: '3400957618735',
  ucdLib: "CLAIRYG 50MG/ML INJ FL50ML",
  UCD7: '9347610',
  UCD13: '3400893476109',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAIRYG 50MG/ML INJ FL50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761844',
  CIP13: '3400957618445',
  ucdLib: "OCTAGAM 100MG/ML INJ FL100ML",
  UCD7: '9347952',
  UCD13: '3400893479520',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 100MG/ML INJ FL100ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761850',
  CIP13: '3400957618506',
  ucdLib: "OCTAGAM 100MG/ML INJ FL200ML",
  UCD7: '9347975',
  UCD13: '3400893479759',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 100MG/ML INJ FL200ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761821',
  CIP13: '3400957618216',
  ucdLib: "OCTAGAM 100MG/ML INJ FL20ML",
  UCD7: '9347969',
  UCD13: '3400893479698',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 100MG/ML INJ FL20ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5761838',
  CIP13: '3400957618384',
  ucdLib: "OCTAGAM 100MG/ML INJ FL50ML",
  UCD7: '9347981',
  UCD13: '3400893479810',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAGAM 100MG/ML INJ FL50ML BT 1",
  atcCode: "J06BA02"
}, {
  CIP7: '5865294',
  CIP13: '3400958652943',
  ucdLib: "GAMMANORM 165MG/ML INJ FL12ML",
  UCD7: '9404549',
  UCD13: '3400894045496',
  ucdQtyMultiplicator: 1,
  cipLib: "GAMMANORM 165MG/ML INJ FL12ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5865354',
  CIP13: '3400958653544',
  ucdLib: "GAMMANORM 165MG/ML INJ FL24ML",
  UCD7: '9404555',
  UCD13: '3400894045557',
  ucdQtyMultiplicator: 1,
  cipLib: "GAMMANORM 165MG/ML INJ FL24ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5865383',
  CIP13: '3400958653834',
  ucdLib: "GAMMANORM 165MG/ML INJ FL48ML",
  UCD7: '9403679',
  UCD13: '3400894036791',
  ucdQtyMultiplicator: 1,
  cipLib: "GAMMANORM 165MG/ML INJ FL48ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5865265',
  CIP13: '3400958652653',
  ucdLib: "GAMMANORM 165MG/ML INJ FL6ML",
  UCD7: '9403685',
  UCD13: '3400894036852',
  ucdQtyMultiplicator: 1,
  cipLib: "GAMMANORM 165MG/ML INJ FL6ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5500423',
  CIP13: '3400955004233',
  ucdLib: "HYQVIA 100MG/ML PERF F+F100ML",
  UCD7: '9407370',
  UCD13: '3400894073703',
  ucdQtyMultiplicator: 1,
  cipLib: "HYQVIA 100MG/ML PERF F+F100ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5500424',
  CIP13: '3400955004240',
  ucdLib: "HYQVIA 100MG/ML PERF F+F200ML",
  UCD7: '9407387',
  UCD13: '3400894073871',
  ucdQtyMultiplicator: 1,
  cipLib: "HYQVIA 100MG/ML PERF F+F200ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5500421',
  CIP13: '3400955004219',
  ucdLib: "HYQVIA 100MG/ML PERF F+F25ML",
  UCD7: '9407393',
  UCD13: '3400894073932',
  ucdQtyMultiplicator: 1,
  cipLib: "HYQVIA 100MG/ML PERF F+F25ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5500425',
  CIP13: '3400955004257',
  ucdLib: "HYQVIA 100MG/ML PERF F+F300ML",
  UCD7: '9407401',
  UCD13: '3400894074014',
  ucdQtyMultiplicator: 1,
  cipLib: "HYQVIA 100MG/ML PERF F+F300ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5500422',
  CIP13: '3400955004226',
  ucdLib: "HYQVIA 100MG/ML PERF F+F50ML",
  UCD7: '9407418',
  UCD13: '3400894074182',
  ucdQtyMultiplicator: 1,
  cipLib: "HYQVIA 100MG/ML PERF F+F50ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5797813',
  CIP13: '3400957978136',
  ucdLib: "HIZENTRA 200MG/ML INJ FV10ML",
  UCD7: '9368983',
  UCD13: '3400893689837',
  ucdQtyMultiplicator: 1,
  cipLib: "HIZENTRA 200MG/ML INJ FV10ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5797836',
  CIP13: '3400957978365',
  ucdLib: "HIZENTRA 200MG/ML INJ FV20ML",
  UCD7: '9369008',
  UCD13: '3400893690086',
  ucdQtyMultiplicator: 1,
  cipLib: "HIZENTRA 200MG/ML INJ FV20ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5848580',
  CIP13: '3400958485800',
  ucdLib: "HIZENTRA 200MG/ML INJ FV50ML",
  UCD7: '9392326',
  UCD13: '3400893923269',
  ucdQtyMultiplicator: 1,
  cipLib: "HIZENTRA 200MG/ML INJ FV50ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5797807',
  CIP13: '3400957978075',
  ucdLib: "HIZENTRA 200MG/ML INJ FV5ML",
  UCD7: '9369014',
  UCD13: '3400893690147',
  ucdQtyMultiplicator: 1,
  cipLib: "HIZENTRA 200MG/ML INJ FV5ML BT 1",
  atcCode: "J06BA01"
}, {
  CIP7: '5621540',
  CIP13: '3400956215409',
  ucdLib: "VIPERFAV PERF FV4ML",
  UCD7: '9233183',
  UCD13: '3400892331836',
  ucdQtyMultiplicator: 1,
  cipLib: "VIPERFAV PERF FV4ML BT 1",
  atcCode: "J06AA03"
}, {
  CIP7: '2771463',
  CIP13: '3400927714634',
  ucdLib: "TIVICAY 50MG CPR",
  UCD7: '9398866',
  UCD13: '3400893988664',
  ucdQtyMultiplicator: 30,
  cipLib: "TIVICAY 50MG CPR BT 30",
  atcCode: "J05AX12"
}, {
  CIP7: '3823481',
  CIP13: '3400938234817',
  ucdLib: "CELSENTRI 150MG CPR",
  UCD7: '9317276',
  UCD13: '3400893172766',
  ucdQtyMultiplicator: 60,
  cipLib: "CELSENTRI 150MG CPR BT 60",
  atcCode: "J05AX09"
}, {
  CIP7: '3823498',
  CIP13: '3400938234985',
  ucdLib: "CELSENTRI 300MG CPR",
  UCD7: '9317282',
  UCD13: '3400893172827',
  ucdQtyMultiplicator: 60,
  cipLib: "CELSENTRI 300MG CPR BT 60",
  atcCode: "J05AX09"
}, {
  CIP7: '3830848',
  CIP13: '3400938308488',
  ucdLib: "ISENTRESS 400MG CPR",
  UCD7: '9303877',
  UCD13: '3400893038772',
  ucdQtyMultiplicator: 60,
  cipLib: "ISENTRESS 400MG CPR BT 60",
  atcCode: "J05AX08"
}, {
  CIP7: '2699257',
  CIP13: '3400926992576',
  ucdLib: "ISENTRESS 100MG CPR CROQ",
  UCD7: '9391077',
  UCD13: '3400893910771',
  ucdQtyMultiplicator: 60,
  cipLib: "ISENTRESS 100MG CPR CROQ BT 60",
  atcCode: "J05AX08"
}, {
  CIP7: '2699240',
  CIP13: '3400926992408',
  ucdLib: "ISENTRESS 25MG CPR CROQ",
  UCD7: '9391083',
  UCD13: '3400893910832',
  ucdQtyMultiplicator: 60,
  cipLib: "ISENTRESS 25MG CPR CROQ BT 60",
  atcCode: "J05AX08"
}, {
  CIP7: '2794636',
  CIP13: '3400927946363',
  ucdLib: "ISENTRESS 100MG GLE BUV SACH",
  UCD7: '9403107',
  UCD13: '3400894031079',
  ucdQtyMultiplicator: 60,
  cipLib: "ISENTRESS 100MG GLE BUV SACH BT 60",
  atcCode: "J05AX08"
}, {
  CIP7: '3622185',
  CIP13: '3400936221857',
  ucdLib: "FUZEON 90MG/ML INJ FL+FL+NEC",
  UCD7: '9247357',
  UCD13: '3400892473574',
  ucdQtyMultiplicator: 60,
  cipLib: "FUZEON 90MG/ML INJ FL+FL+NEC BT 60",
  atcCode: "J05AX07"
}, {
  CIP7: '3003773',
  CIP13: '3400930037737',
  ucdLib: "GENVOYA 150/150/200/10MG CPR",
  UCD7: '9413347',
  UCD13: '3400894133476',
  ucdQtyMultiplicator: 30,
  cipLib: "GENVOYA 150/150/200/10MG CPR BT 30",
  atcCode: "J05AR18"
}, {
  CIP7: '3005733',
  CIP13: '3400930057339',
  ucdLib: "DESCOVY 200MG/10MG CPR",
  UCD7: '9416819',
  UCD13: '3400894168195',
  ucdQtyMultiplicator: 30,
  cipLib: "DESCOVY 200MG/10MG CPR BT 30",
  atcCode: "J05AR17"
}, {
  CIP7: '3005734',
  CIP13: '3400930057346',
  ucdLib: "DESCOVY 200MG/25MG CPR",
  UCD7: '9416825',
  UCD13: '3400894168256',
  ucdQtyMultiplicator: 30,
  cipLib: "DESCOVY 200MG/25MG CPR BT 30",
  atcCode: "J05AR17"
}, {
  CIP7: '2794895',
  CIP13: '3400927948954',
  ucdLib: "TRIUMEQ 50/600/300MG CPR",
  UCD7: '9407826',
  UCD13: '3400894078265',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIUMEQ 50/600/300MG CPR BT 30",
  atcCode: "J05AR13"
}, {
  CIP7: '3566819',
  CIP13: '3400935668196',
  ucdLib: "KALETRA BUV FL60ML + SRG",
  UCD7: '9229158',
  UCD13: '3400892291581',
  ucdQtyMultiplicator: 5,
  cipLib: "KALETRA BUV FL60ML + SRG BT 5",
  atcCode: "J05AR10"
}, {
  CIP7: '3844201',
  CIP13: '3400938442014',
  ucdLib: "KALETRA 100MG/25MG CPR",
  UCD7: '9312072',
  UCD13: '3400893120729',
  ucdQtyMultiplicator: 60,
  cipLib: "KALETRA 100MG/25MG CPR BT 60",
  atcCode: "J05AR10"
}, {
  CIP7: '4940964',
  CIP13: '3400949409648',
  ucdLib: "KALETRA 200MG/50MG CPR",
  UCD7: '9286995',
  UCD13: '3400892869957',
  ucdQtyMultiplicator: 120,
  cipLib: "KALETRA 200MG/50MG CPR BT 120",
  atcCode: "J05AR10"
}, {
  CIP7: '2742645',
  CIP13: '3400927426452',
  ucdLib: "STRIBILD 150/150/200/245 CPR",
  UCD7: '9393455',
  UCD13: '3400893934555',
  ucdQtyMultiplicator: 30,
  cipLib: "STRIBILD 150/150/200/245 CPR BT 30",
  atcCode: "J05AR09"
}, {
  CIP7: '2194735',
  CIP13: '3400921947359',
  ucdLib: "EVIPLERA 200/25/245MG CPR",
  UCD7: '9378131',
  UCD13: '3400893781319',
  ucdQtyMultiplicator: 30,
  cipLib: "EVIPLERA 200/25/245MG CPR BT 30",
  atcCode: "J05AR08"
}, {
  CIP7: '3830699',
  CIP13: '3400938306996',
  ucdLib: "ATRIPLA 600/200/245MG CPR",
  UCD7: '9308679',
  UCD13: '3400893086797',
  ucdQtyMultiplicator: 30,
  cipLib: "ATRIPLA 600/200/245MG CPR BT 30",
  atcCode: "J05AR06"
}, {
  CIP7: '3610928',
  CIP13: '3400936109285',
  ucdLib: "TRIZIVIR CPR",
  UCD7: '9225901',
  UCD13: '3400892259017',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIZIVIR CPR BT 60",
  atcCode: "J05AR04"
}, {
  CIP7: '3656563',
  CIP13: '3400936565630',
  ucdLib: "TRUVADA CPR",
  UCD7: '9274182',
  UCD13: '3400892741826',
  ucdQtyMultiplicator: 30,
  cipLib: "TRUVADA CPR BT 30",
  atcCode: "J05AR03"
}, {
  CIP7: '3657284',
  CIP13: '3400936572843',
  ucdLib: "KIVEXA CPR PELLIC",
  UCD7: '9273426',
  UCD13: '3400892734262',
  ucdQtyMultiplicator: 30,
  cipLib: "KIVEXA CPR PELLIC BT 30",
  atcCode: "J05AR02"
}, {
  CIP7: '3000900',
  CIP13: '3400930009000',
  ucdLib: "LAMI/ZID.CRT150/300MG CPR",
  UCD7: '9407269',
  UCD13: '3400894072690',
  ucdQtyMultiplicator: 60,
  cipLib: "LAMI/ZID.CRT150/300MG CPR BT 60",
  atcCode: "J05AR01"
}, {
  CIP7: '3466271',
  CIP13: '3400934662713',
  ucdLib: "COMBIVIR 150MG/300MG CPR",
  UCD7: '9200692',
  UCD13: '3400892006925',
  ucdQtyMultiplicator: 60,
  cipLib: "COMBIVIR 150MG/300MG CPR BT 60",
  atcCode: "J05AR01"
}, {
  CIP7: '4194509',
  CIP13: '3400941945090',
  ucdLib: "LAMI/ZID.TVC150/300MG CPR",
  UCD7: '9375440',
  UCD13: '3400893754405',
  ucdQtyMultiplicator: 60,
  cipLib: "LAMI/ZID.TVC150/300MG CPR BT 60",
  atcCode: "J05AR01"
}, {
  CIP7: '2226412',
  CIP13: '3400922264127',
  ucdLib: "LAMI/ZID.MYL150/300MG CPR",
  UCD7: '9387868',
  UCD13: '3400893878682',
  ucdQtyMultiplicator: 60,
  cipLib: "LAMI/ZID.MYL150/300MG CPR BT 60",
  atcCode: "J05AR01"
}, {
  CIP7: '2679059',
  CIP13: '3400926790592',
  ucdLib: "LAMI/ZID.SDZ150/300MG CPR",
  UCD7: '9391108',
  UCD13: '3400893911082',
  ucdQtyMultiplicator: 60,
  cipLib: "LAMI/ZID.SDZ150/300MG CPR BT 60",
  atcCode: "J05AR01"
}, {
  CIP7: '3006170',
  CIP13: '3400930061701',
  ucdLib: "ZEPATIER 50MG/100MG CPR",
  UCD7: '9418008',
  UCD13: '3400894180081',
  ucdQtyMultiplicator: 28,
  cipLib: "ZEPATIER 50 mg/100 mg Cpr pell Plq/28",
  atcCode: "J05AP54"
}, {
  CIP7: '3000780',
  CIP13: '3400930007808',
  ucdLib: "VIEKIRAX 12,5/75/50MG CPR",
  UCD7: '9405750',
  UCD13: '3400894057505',
  ucdQtyMultiplicator: 56,
  cipLib: "VIEKIRAX 12,5/75/50MG CPR BT 56",
  atcCode: "J05AP53"
}, {
  CIP7: '3000088',
  CIP13: '3400930000885',
  ucdLib: "HARVONI 90MG/400MG CPR",
  UCD7: '9405081',
  UCD13: '3400894050810',
  ucdQtyMultiplicator: 28,
  cipLib: "HARVONI 90MG/400MG CPR BT 28",
  atcCode: "J05AP51"
}, {
  CIP7: '3000778',
  CIP13: '3400930007785',
  ucdLib: "EXVIERA 250MG CPR",
  UCD7: '9405744',
  UCD13: '3400894057444',
  ucdQtyMultiplicator: 56,
  cipLib: "EXVIERA 250MG CPR BT 56",
  atcCode: "J05AP09"
}, {
  CIP7: '2770707',
  CIP13: '3400927707070',
  ucdLib: "SOVALDI 400MG CPR PELLIC",
  UCD7: '9398211',
  UCD13: '3400893982112',
  ucdQtyMultiplicator: 28,
  cipLib: "SOVALDI 400MG CPR PELLIC BT 28",
  atcCode: "J05AP08"
}, {
  CIP7: '2794122',
  CIP13: '3400927941221',
  ucdLib: "DAKLINZA 30MG CPR PELLIC",
  UCD7: '9402846',
  UCD13: '3400894028468',
  ucdQtyMultiplicator: 28,
  cipLib: "DAKLINZA 30MG CPR PELLIC BT 28",
  atcCode: "J05AP07"
}, {
  CIP7: '2794145',
  CIP13: '3400927941450',
  ucdLib: "DAKLINZA 60MG CPR PELLIC",
  UCD7: '9402852',
  UCD13: '3400894028529',
  ucdQtyMultiplicator: 28,
  cipLib: "DAKLINZA 60MG CPR PELLIC BT 28",
  atcCode: "J05AP07"
}, {
  CIP7: '2788564',
  CIP13: '3400927885648',
  ucdLib: "OLYSIO 150MG GELU",
  UCD7: '9401108',
  UCD13: '3400894011088',
  ucdQtyMultiplicator: 28,
  cipLib: "OLYSIO 150MG GELU BT 28",
  atcCode: "J05AP05"
}, {
  CIP7: '3615914',
  CIP13: '3400936159143',
  ucdLib: "COPEGUS 200MG CPR",
  UCD7: '9250187',
  UCD13: '3400892501871',
  ucdQtyMultiplicator: 168,
  cipLib: "COPEGUS 200MG CPR BT 168",
  atcCode: "J05AP01"
}, {
  CIP7: '3620045',
  CIP13: '3400936200456',
  ucdLib: "COPEGUS 200MG CPR",
  UCD7: '9250187',
  UCD13: '3400892501871',
  ucdQtyMultiplicator: 112,
  cipLib: "COPEGUS 200MG CPR BT 112",
  atcCode: "J05AP01"
}, {
  CIP7: '3519719',
  CIP13: '3400935197191',
  ucdLib: "REBETOL 200MG GELU",
  UCD7: '9208570',
  UCD13: '3400892085708',
  ucdQtyMultiplicator: 84,
  cipLib: "REBETOL 200MG GELU BT 84",
  atcCode: "J05AP01"
}, {
  CIP7: '3519725',
  CIP13: '3400935197252',
  ucdLib: "REBETOL 200MG GELU",
  UCD7: '9208570',
  UCD13: '3400892085708',
  ucdQtyMultiplicator: 140,
  cipLib: "REBETOL 200MG GELU BT 140",
  atcCode: "J05AP01"
}, {
  CIP7: '3519731',
  CIP13: '3400935197313',
  ucdLib: "REBETOL 200MG GELU",
  UCD7: '9208570',
  UCD13: '3400892085708',
  ucdQtyMultiplicator: 168,
  cipLib: "REBETOL 200MG GELU BT 168",
  atcCode: "J05AP01"
}, {
  CIP7: '3658668',
  CIP13: '3400936586680',
  ucdLib: "REBETOL 40MG/ML BUV FL100ML",
  UCD7: '9274408',
  UCD13: '3400892744087',
  ucdQtyMultiplicator: 1,
  cipLib: "REBETOL 40MG/ML BUV FL100ML BT 1",
  atcCode: "J05AP01"
}, {
  CIP7: '3777976',
  CIP13: '3400937779760',
  ucdLib: "COPEGUS 400MG CPR",
  UCD7: '9298610',
  UCD13: '3400892986104',
  ucdQtyMultiplicator: 56,
  cipLib: "COPEGUS 400MG CPR BT 56",
  atcCode: "J05AP01"
}, {
  CIP7: '3732778',
  CIP13: '3400937327787',
  ucdLib: "REBETOL 200MG GELU",
  UCD7: '9208570',
  UCD13: '3400892085708',
  ucdQtyMultiplicator: 112,
  cipLib: "REBETOL 200MG GELU BT 112",
  atcCode: "J05AP01"
}, {
  CIP7: '4168239',
  CIP13: '3400941682391',
  ucdLib: "RIBAVIRINE BGA 200MG CPR",
  UCD7: '9373346',
  UCD13: '3400893733462',
  ucdQtyMultiplicator: 28,
  cipLib: "RIBAVIRINE BGA 200MG CPR BT 28",
  atcCode: "J05AP01"
}, {
  CIP7: '4168274',
  CIP13: '3400941682742',
  ucdLib: "RIBAVIRINE BGA 200MG CPR",
  UCD7: '9373346',
  UCD13: '3400893733462',
  ucdQtyMultiplicator: 112,
  cipLib: "RIBAVIRINE BGA 200MG CPR BT 112",
  atcCode: "J05AP01"
}, {
  CIP7: '4168280',
  CIP13: '3400941682803',
  ucdLib: "RIBAVIRINE BGA 200MG CPR",
  UCD7: '9373346',
  UCD13: '3400893733462',
  ucdQtyMultiplicator: 168,
  cipLib: "RIBAVIRINE BGA 200MG CPR BT 168",
  atcCode: "J05AP01"
}, {
  CIP7: '4168311',
  CIP13: '3400941683114',
  ucdLib: "RIBAVIRINE BGA 400MG CPR",
  UCD7: '9373352',
  UCD13: '3400893733523',
  ucdQtyMultiplicator: 56,
  cipLib: "RIBAVIRINE BGA 400MG CPR BT 56",
  atcCode: "J05AP01"
}, {
  CIP7: '2169565',
  CIP13: '3400921695656',
  ucdLib: "RIBAVIRINE MYL 200MG CPR",
  UCD7: '9373381',
  UCD13: '3400893733813',
  ucdQtyMultiplicator: 28,
  cipLib: "RIBAVIRINE MYL 200MG CPR BT 28",
  atcCode: "J05AP01"
}, {
  CIP7: '2169571',
  CIP13: '3400921695717',
  ucdLib: "RIBAVIRINE MYL 200MG CPR",
  UCD7: '9373381',
  UCD13: '3400893733813',
  ucdQtyMultiplicator: 42,
  cipLib: "RIBAVIRINE MYL 200MG CPR BT 42",
  atcCode: "J05AP01"
}, {
  CIP7: '4168446',
  CIP13: '3400941684463',
  ucdLib: "RIBAVIRINE MYL 200MG CPR",
  UCD7: '9373381',
  UCD13: '3400893733813',
  ucdQtyMultiplicator: 112,
  cipLib: "RIBAVIRINE MYL 200MG CPR BT 112",
  atcCode: "J05AP01"
}, {
  CIP7: '4168452',
  CIP13: '3400941684524',
  ucdLib: "RIBAVIRINE MYL 200MG CPR",
  UCD7: '9373381',
  UCD13: '3400893733813',
  ucdQtyMultiplicator: 168,
  cipLib: "RIBAVIRINE MYL 200MG CPR BT 168",
  atcCode: "J05AP01"
}, {
  CIP7: '2670928',
  CIP13: '3400926709280',
  ucdLib: "RIBAVIRINE MYL 200MG GELU",
  UCD7: '9367587',
  UCD13: '3400893675878',
  ucdQtyMultiplicator: 84,
  cipLib: "RIBAVIRINE MYL 200MG GELU BT 84",
  atcCode: "J05AP01"
}, {
  CIP7: '2670934',
  CIP13: '3400926709341',
  ucdLib: "RIBAVIRINE MYL 200MG GELU",
  UCD7: '9367587',
  UCD13: '3400893675878',
  ucdQtyMultiplicator: 112,
  cipLib: "RIBAVIRINE MYL 200MG GELU BT 112",
  atcCode: "J05AP01"
}, {
  CIP7: '2670940',
  CIP13: '3400926709402',
  ucdLib: "RIBAVIRINE MYL 200MG GELU",
  UCD7: '9367587',
  UCD13: '3400893675878',
  ucdQtyMultiplicator: 140,
  cipLib: "RIBAVIRINE MYL 200MG GELU BT 140",
  atcCode: "J05AP01"
}, {
  CIP7: '2670957',
  CIP13: '3400926709570',
  ucdLib: "RIBAVIRINE MYL 200MG GELU",
  UCD7: '9367587',
  UCD13: '3400893675878',
  ucdQtyMultiplicator: 168,
  cipLib: "RIBAVIRINE MYL 200MG GELU BT 168",
  atcCode: "J05AP01"
}, {
  CIP7: '4168475',
  CIP13: '3400941684753',
  ucdLib: "RIBAVIRINE MYL 400MG CPR",
  UCD7: '9373398',
  UCD13: '3400893733981',
  ucdQtyMultiplicator: 56,
  cipLib: "RIBAVIRINE MYL 400MG CPR BT 56",
  atcCode: "J05AP01"
}, {
  CIP7: '2732753',
  CIP13: '3400927327537',
  ucdLib: "RIBAVOX 600MG CPR",
  UCD7: '9408949',
  UCD13: '3400894089490',
  ucdQtyMultiplicator: 56,
  cipLib: "RIBAVOX 600MG CPR BT 56",
  atcCode: "J05AP01"
}, {
  CIP7: '2790101',
  CIP13: '3400927901010',
  ucdLib: "RIBAVOX 200MG CPR",
  UCD7: '9406413',
  UCD13: '3400894064138',
  ucdQtyMultiplicator: 168,
  cipLib: "RIBAVOX 200MG CPR BT 168",
  atcCode: "J05AP01"
}, {
  CIP7: '2790124',
  CIP13: '3400927901249',
  ucdLib: "RIBAVOX 400MG CPR",
  UCD7: '9406436',
  UCD13: '3400894064367',
  ucdQtyMultiplicator: 56,
  cipLib: "RIBAVOX 400MG CPR BT 56",
  atcCode: "J05AP01"
}, {
  CIP7: '3599629',
  CIP13: '3400935996299',
  ucdLib: "TAMIFLU 75MG GELU",
  UCD7: '9239665',
  UCD13: '3400892396651',
  ucdQtyMultiplicator: 10,
  cipLib: "TAMIFLU 75MG GELU BT 10",
  atcCode: "J05AH02"
}, {
  CIP7: '3820152',
  CIP13: '3400938201529',
  ucdLib: "TAMIFLU 30MG GELU",
  UCD7: '9311977',
  UCD13: '3400893119778',
  ucdQtyMultiplicator: 10,
  cipLib: "TAMIFLU 30MG GELU BT 10",
  atcCode: "J05AH02"
}, {
  CIP7: '3820169',
  CIP13: '3400938201697',
  ucdLib: "TAMIFLU 45MG GELU",
  UCD7: '9311983',
  UCD13: '3400893119839',
  ucdQtyMultiplicator: 10,
  cipLib: "TAMIFLU 45MG GELU BT 10",
  atcCode: "J05AH02"
}, {
  CIP7: '2206906',
  CIP13: '3400922069067',
  ucdLib: "TAMIFLU 6MG/ML BUV FL13G",
  UCD7: '9387526',
  UCD13: '3400893875261',
  ucdQtyMultiplicator: 1,
  cipLib: "TAMIFLU 6MG/ML BUV FL13G BT 1",
  atcCode: "J05AH02"
}, {
  CIP7: '3519748',
  CIP13: '3400935197481',
  ucdLib: "RELENZA 5MG PDR 4DOS + DISK.",
  UCD7: '9213134',
  UCD13: '3400892131344',
  ucdQtyMultiplicator: 5,
  cipLib: "RELENZA 5MG PDR 4DOS + DISK. BT 5",
  atcCode: "J05AH01"
}, {
  CIP7: '2194729',
  CIP13: '3400921947298',
  ucdLib: "EDURANT 25MG CPR",
  UCD7: '9382730',
  UCD13: '3400893827307',
  ucdQtyMultiplicator: 30,
  cipLib: "EDURANT 25MG CPR BT 30",
  atcCode: "J05AG05"
}, {
  CIP7: '3874260',
  CIP13: '3400938742602',
  ucdLib: "INTELENCE 100MG CPR",
  UCD7: '9316874',
  UCD13: '3400893168745',
  ucdQtyMultiplicator: 120,
  cipLib: "INTELENCE 100MG CPR BT 120",
  atcCode: "J05AG04"
}, {
  CIP7: '2194669',
  CIP13: '3400921946697',
  ucdLib: "INTELENCE 200MG CPR",
  UCD7: '9380470',
  UCD13: '3400893804704',
  ucdQtyMultiplicator: 60,
  cipLib: "INTELENCE 200MG CPR BT 60",
  atcCode: "J05AG04"
}, {
  CIP7: '2688762',
  CIP13: '3400926887629',
  ucdLib: "INTELENCE 25MG CPR",
  UCD7: '9397766',
  UCD13: '3400893977668',
  ucdQtyMultiplicator: 120,
  cipLib: "INTELENCE 25MG CPR BT 120",
  atcCode: "J05AG04"
}, {
  CIP7: '3001516',
  CIP13: '3400930015162',
  ucdLib: "EFAVIRENZ CRT 600MG CPR",
  UCD7: '9410188',
  UCD13: '3400894101888',
  ucdQtyMultiplicator: 30,
  cipLib: "EFAVIRENZ CRT 600MG CPR BT 30",
  atcCode: "J05AG03"
}, {
  CIP7: '3517695',
  CIP13: '3400935176950',
  ucdLib: "SUSTIVA 100MG GELU",
  UCD7: '9212011',
  UCD13: '3400892120119',
  ucdQtyMultiplicator: 30,
  cipLib: "SUSTIVA 100MG GELU BT 30",
  atcCode: "J05AG03"
}, {
  CIP7: '3517703',
  CIP13: '3400935177032',
  ucdLib: "SUSTIVA 200MG GELU",
  UCD7: '9201065',
  UCD13: '3400892010656',
  ucdQtyMultiplicator: 90,
  cipLib: "SUSTIVA 200MG GELU BT 90",
  atcCode: "J05AG03"
}, {
  CIP7: '3517689',
  CIP13: '3400935176899',
  ucdLib: "SUSTIVA 50MG GELU",
  UCD7: '9212028',
  UCD13: '3400892120287',
  ucdQtyMultiplicator: 30,
  cipLib: "SUSTIVA 50MG GELU BT 30",
  atcCode: "J05AG03"
}, {
  CIP7: '3599664',
  CIP13: '3400935996640',
  ucdLib: "SUSTIVA 600MG CPR",
  UCD7: '9240562',
  UCD13: '3400892405629',
  ucdQtyMultiplicator: 30,
  cipLib: "SUSTIVA 600MG CPR BT 30",
  atcCode: "J05AG03"
}, {
  CIP7: '2740965',
  CIP13: '3400927409653',
  ucdLib: "EFAVIRENZ MYL 600MG CPR",
  UCD7: '9396442',
  UCD13: '3400893964422',
  ucdQtyMultiplicator: 30,
  cipLib: "EFAVIRENZ MYL 600MG CPR BT 30",
  atcCode: "J05AG03"
}, {
  CIP7: '2754536',
  CIP13: '3400927545368',
  ucdLib: "EFAVIRENZ SDZ 600MG CPR",
  UCD7: '9404331',
  UCD13: '3400894043317',
  ucdQtyMultiplicator: 30,
  cipLib: "EFAVIRENZ SDZ 600MG CPR BT 30",
  atcCode: "J05AG03"
}, {
  CIP7: '2742639',
  CIP13: '3400927426391',
  ucdLib: "EFAVIRENZ TVC 600MG CPR",
  UCD7: '9416713',
  UCD13: '3400894167136',
  ucdQtyMultiplicator: 30,
  cipLib: "EFAVIRENZ TVC 600MG CPR BT 30",
  atcCode: "J05AG03"
}, {
  CIP7: '2761080',
  CIP13: '3400927610806',
  ucdLib: "NEVIRAPINE SDZ 200MG CPR",
  UCD7: '9397080',
  UCD13: '3400893970805',
  ucdQtyMultiplicator: 60,
  cipLib: "NEVIRAPINE SDZ 200MG CPR BT 60",
  atcCode: "J05AG01"
}, {
  CIP7: '3521024',
  CIP13: '3400935210241',
  ucdLib: "VIRAMUNE 50MG/5ML BUV FL",
  UCD7: '9203383',
  UCD13: '3400892033839',
  ucdQtyMultiplicator: 1,
  cipLib: "VIRAMUNE 50MG/5ML BUV FL BT 1",
  atcCode: "J05AG01"
}, {
  CIP7: '3461144',
  CIP13: '3400934611445',
  ucdLib: "VIRAMUNE 200MG CPR",
  UCD7: '9196476',
  UCD13: '3400891964769',
  ucdQtyMultiplicator: 60,
  cipLib: "VIRAMUNE 200MG CPR BT 60",
  atcCode: "J05AG01"
}, {
  CIP7: '3941298',
  CIP13: '3400939412986',
  ucdLib: "VIRAMUNE 200MG CPR",
  UCD7: '9196476',
  UCD13: '3400891964769',
  ucdQtyMultiplicator: 14,
  cipLib: "VIRAMUNE 200MG CPR BT 14",
  atcCode: "J05AG01"
}, {
  CIP7: '2789227',
  CIP13: '3400927892271',
  ucdLib: "NEVIRAPINE CRT 200MG CPR",
  UCD7: '9404839',
  UCD13: '3400894048398',
  ucdQtyMultiplicator: 60,
  cipLib: "NEVIRAPINE CRT 200MG CPR BT 60",
  atcCode: "J05AG01"
}, {
  CIP7: '2243965',
  CIP13: '3400922439655',
  ucdLib: "NEVIRAPINE MYL 200MG CPR",
  UCD7: '9391410',
  UCD13: '3400893914106',
  ucdQtyMultiplicator: 60,
  cipLib: "NEVIRAPINE MYL 200MG CPR BT 60",
  atcCode: "J05AG01"
}, {
  CIP7: '2189875',
  CIP13: '3400921898750',
  ucdLib: "VIRAMUNE 100MG CPR LP",
  UCD7: '9375635',
  UCD13: '3400893756355',
  ucdQtyMultiplicator: 90,
  cipLib: "VIRAMUNE 100MG CPR LP BT 90",
  atcCode: "J05AG01"
}, {
  CIP7: '2189898',
  CIP13: '3400921898989',
  ucdLib: "VIRAMUNE 400MG CPR LP",
  UCD7: '9375641',
  UCD13: '3400893756416',
  ucdQtyMultiplicator: 30,
  cipLib: "VIRAMUNE 400MG CPR LP BT 30",
  atcCode: "J05AG01"
}, {
  CIP7: '3799357',
  CIP13: '3400937993579',
  ucdLib: "SEBIVO 600MG CPR",
  UCD7: '9300956',
  UCD13: '3400893009567',
  ucdQtyMultiplicator: 28,
  cipLib: "SEBIVO 600MG CPR BT 28",
  atcCode: "J05AF11"
}, {
  CIP7: '3762928',
  CIP13: '3400937629287',
  ucdLib: "BARACLUDE 0,05MG/ML BUV 210ML",
  UCD7: '9288304',
  UCD13: '3400892883045',
  ucdQtyMultiplicator: 1,
  cipLib: "BARACLUDE 0,05MG/ML BUV 210ML BT 1",
  atcCode: "J05AF10"
}, {
  CIP7: '3762897',
  CIP13: '3400937628976',
  ucdLib: "BARACLUDE 0,5MG CPR",
  UCD7: '9288310',
  UCD13: '3400892883106',
  ucdQtyMultiplicator: 30,
  cipLib: "BARACLUDE 0,5MG CPR BT 30",
  atcCode: "J05AF10"
}, {
  CIP7: '3762911',
  CIP13: '3400937629119',
  ucdLib: "BARACLUDE 1MG CPR",
  UCD7: '9288327',
  UCD13: '3400892883274',
  ucdQtyMultiplicator: 30,
  cipLib: "BARACLUDE 1MG CPR BT 30",
  atcCode: "J05AF10"
}, {
  CIP7: '3622564',
  CIP13: '3400936225640',
  ucdLib: "EMTRIVA 200MG GELU",
  UCD7: '9256238',
  UCD13: '3400892562384',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRIVA 200MG GELU BT 30",
  atcCode: "J05AF09"
}, {
  CIP7: '3634484',
  CIP13: '3400936344846',
  ucdLib: "EMTRIVA 10MG/ML BUV FL170ML",
  UCD7: '9256221',
  UCD13: '3400892562216',
  ucdQtyMultiplicator: 1,
  cipLib: "EMTRIVA 10MG/ML BUV FL170ML BT 1",
  atcCode: "J05AF09"
}, {
  CIP7: '3615676',
  CIP13: '3400936156760',
  ucdLib: "HEPSERA 10MG CPR",
  UCD7: '9246642',
  UCD13: '3400892466422',
  ucdQtyMultiplicator: 30,
  cipLib: "HEPSERA 10MG CPR BT 30",
  atcCode: "J05AF08"
}, {
  CIP7: '3585001',
  CIP13: '3400935850010',
  ucdLib: "VIREAD 245MG CPR",
  UCD7: '9236247',
  UCD13: '3400892362472',
  ucdQtyMultiplicator: 30,
  cipLib: "VIREAD 245MG CPR BT 30",
  atcCode: "J05AF07"
}, {
  CIP7: '2678887',
  CIP13: '3400926788872',
  ucdLib: "VIREAD 123MG CPR",
  UCD7: '9393544',
  UCD13: '3400893935446',
  ucdQtyMultiplicator: 30,
  cipLib: "VIREAD 123MG CPR BT 30",
  atcCode: "J05AF07"
}, {
  CIP7: '2678893',
  CIP13: '3400926788933',
  ucdLib: "VIREAD 163MG CPR",
  UCD7: '9393550',
  UCD13: '3400893935507',
  ucdQtyMultiplicator: 30,
  cipLib: "VIREAD 163MG CPR BT 30",
  atcCode: "J05AF07"
}, {
  CIP7: '2678901',
  CIP13: '3400926789015',
  ucdLib: "VIREAD 204MG CPR",
  UCD7: '9393567',
  UCD13: '3400893935675',
  ucdQtyMultiplicator: 30,
  cipLib: "VIREAD 204MG CPR BT 30",
  atcCode: "J05AF07"
}, {
  CIP7: '2678918',
  CIP13: '3400926789183',
  ucdLib: "VIREAD 33MG/G GLE ORAL FL60G",
  UCD7: '9393573',
  UCD13: '3400893935736',
  ucdQtyMultiplicator: 1,
  cipLib: "VIREAD 33MG/G GLE ORAL FL60G BT 1",
  atcCode: "J05AF07"
}, {
  CIP7: '3610905',
  CIP13: '3400936109056',
  ucdLib: "ZIAGEN 20MG/ML BUV FL240ML",
  UCD7: '9212548',
  UCD13: '3400892125480',
  ucdQtyMultiplicator: 1,
  cipLib: "ZIAGEN 20MG/ML BUV FL240ML BT 1",
  atcCode: "J05AF06"
}, {
  CIP7: '3610897',
  CIP13: '3400936108974',
  ucdLib: "ZIAGEN 300MG CPR",
  UCD7: '9211359',
  UCD13: '3400892113593',
  ucdQtyMultiplicator: 60,
  cipLib: "ZIAGEN 300MG CPR BT 60",
  atcCode: "J05AF06"
}, {
  CIP7: '3414512',
  CIP13: '3400934145124',
  ucdLib: "EPIVIR 10MG/ML BUV FL240ML",
  UCD7: '9183195',
  UCD13: '3400891831955',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIVIR 10MG/ML BUV FL240ML BT 1",
  atcCode: "J05AF05"
}, {
  CIP7: '3414529',
  CIP13: '3400934145292',
  ucdLib: "EPIVIR 150MG CPR",
  UCD7: '9183203',
  UCD13: '3400891832037',
  ucdQtyMultiplicator: 60,
  cipLib: "EPIVIR 150MG CPR BT 60",
  atcCode: "J05AF05"
}, {
  CIP7: '3519671',
  CIP13: '3400935196712',
  ucdLib: "ZEFFIX 100MG CPR",
  UCD7: '9212525',
  UCD13: '3400892125251',
  ucdQtyMultiplicator: 28,
  cipLib: "ZEFFIX 100MG CPR BT 28",
  atcCode: "J05AF05"
}, {
  CIP7: '3519694',
  CIP13: '3400935196941',
  ucdLib: "ZEFFIX 5MG/ML BUV FL240ML",
  UCD7: '9212531',
  UCD13: '3400892125312',
  ucdQtyMultiplicator: 1,
  cipLib: "ZEFFIX 5MG/ML BUV FL240ML BT 1",
  atcCode: "J05AF05"
}, {
  CIP7: '3584881',
  CIP13: '3400935848819',
  ucdLib: "EPIVIR 300MG CPR",
  UCD7: '9239228',
  UCD13: '3400892392288',
  ucdQtyMultiplicator: 30,
  cipLib: "EPIVIR 300MG CPR BT 30",
  atcCode: "J05AF05"
}, {
  CIP7: '2237663',
  CIP13: '3400922376639',
  ucdLib: "LAMIVUDINE MYL 150MG CPR",
  UCD7: '9386573',
  UCD13: '3400893865736',
  ucdQtyMultiplicator: 60,
  cipLib: "LAMIVUDINE MYL 150MG CPR BT 60",
  atcCode: "J05AF05"
}, {
  CIP7: '2237700',
  CIP13: '3400922377001',
  ucdLib: "LAMIVUDINE MYL 300MG CPR",
  UCD7: '9386596',
  UCD13: '3400893865965',
  ucdQtyMultiplicator: 30,
  cipLib: "LAMIVUDINE MYL 300MG CPR BT 30",
  atcCode: "J05AF05"
}, {
  CIP7: '3413381',
  CIP13: '3400934133817',
  ucdLib: "ZERIT 200MG BUV FL200ML",
  UCD7: '9185946',
  UCD13: '3400891859461',
  ucdQtyMultiplicator: 1,
  cipLib: "ZERIT 200MG BUV FL200ML BT 1",
  atcCode: "J05AF04"
}, {
  CIP7: '3413323',
  CIP13: '3400934133237',
  ucdLib: "ZERIT 20MG GELU",
  UCD7: '9177585',
  UCD13: '3400891775853',
  ucdQtyMultiplicator: 56,
  cipLib: "ZERIT 20MG GELU BT 56",
  atcCode: "J05AF04"
}, {
  CIP7: '3413352',
  CIP13: '3400934133527',
  ucdLib: "ZERIT 30MG GELU",
  UCD7: '9177591',
  UCD13: '3400891775914',
  ucdQtyMultiplicator: 56,
  cipLib: "ZERIT 30MG GELU BT 56",
  atcCode: "J05AF04"
}, {
  CIP7: '3413375',
  CIP13: '3400934133756',
  ucdLib: "ZERIT 40MG GELU",
  UCD7: '9177616',
  UCD13: '3400891776164',
  ucdQtyMultiplicator: 56,
  cipLib: "ZERIT 40MG GELU BT 56",
  atcCode: "J05AF04"
}, {
  CIP7: '3437358',
  CIP13: '3400934373589',
  ucdLib: "VIDEX 100MG CPR DISP",
  UCD7: '9153691',
  UCD13: '3400891536911',
  ucdQtyMultiplicator: 60,
  cipLib: "VIDEX 100MG CPR DISP BT 60",
  atcCode: "J05AF02"
}, {
  CIP7: '3437364',
  CIP13: '3400934373640',
  ucdLib: "VIDEX 150MG CPR DISP",
  UCD7: '9153716',
  UCD13: '3400891537161',
  ucdQtyMultiplicator: 60,
  cipLib: "VIDEX 150MG CPR DISP BT 60",
  atcCode: "J05AF02"
}, {
  CIP7: '3437080',
  CIP13: '3400934370809',
  ucdLib: "VIDEX 25MG CPR DISP",
  UCD7: '9153722',
  UCD13: '3400891537222',
  ucdQtyMultiplicator: 60,
  cipLib: "VIDEX 25MG CPR DISP BT 60",
  atcCode: "J05AF02"
}, {
  CIP7: '3437097',
  CIP13: '3400934370977',
  ucdLib: "VIDEX 50MG CPR DISP",
  UCD7: '9153739',
  UCD13: '3400891537390',
  ucdQtyMultiplicator: 60,
  cipLib: "VIDEX 50MG CPR DISP BT 60",
  atcCode: "J05AF02"
}, {
  CIP7: '3674153',
  CIP13: '3400936741539',
  ucdLib: "VIDEX 2G PDR BUV FL",
  UCD7: '9157364',
  UCD13: '3400891573640',
  ucdQtyMultiplicator: 1,
  cipLib: "VIDEX 2G PDR BUV FL BT 1",
  atcCode: "J05AF02"
}, {
  CIP7: '3537427',
  CIP13: '3400935374271',
  ucdLib: "VIDEX 125MG GELU",
  UCD7: '9217362',
  UCD13: '3400892173627',
  ucdQtyMultiplicator: 30,
  cipLib: "VIDEX 125MG GELU BT 30",
  atcCode: "J05AF02"
}, {
  CIP7: '3537433',
  CIP13: '3400935374332',
  ucdLib: "VIDEX 200MG GELU",
  UCD7: '9217379',
  UCD13: '3400892173795',
  ucdQtyMultiplicator: 30,
  cipLib: "VIDEX 200MG GELU BT 30",
  atcCode: "J05AF02"
}, {
  CIP7: '3537456',
  CIP13: '3400935374561',
  ucdLib: "VIDEX 250MG GELU",
  UCD7: '9217385',
  UCD13: '3400892173856',
  ucdQtyMultiplicator: 30,
  cipLib: "VIDEX 250MG GELU BT 30",
  atcCode: "J05AF02"
}, {
  CIP7: '3537278',
  CIP13: '3400935372789',
  ucdLib: "VIDEX 400MG GELU",
  UCD7: '9217391',
  UCD13: '3400892173917',
  ucdQtyMultiplicator: 30,
  cipLib: "VIDEX 400MG GELU BT 30",
  atcCode: "J05AF02"
}, {
  CIP7: '5580114',
  CIP13: '3400955801146',
  ucdLib: "RETROVIR 10MG/ML INJ FV20ML",
  UCD7: '9159854',
  UCD13: '3400891598544',
  ucdQtyMultiplicator: 5,
  cipLib: "RETROVIR 10MG/ML INJ FV20ML BT 5",
  atcCode: "J05AF01"
}, {
  CIP7: '3388051',
  CIP13: '3400933880514',
  ucdLib: "RETROVIR 100MG GELU",
  UCD7: '9119659',
  UCD13: '3400891196597',
  ucdQtyMultiplicator: 100,
  cipLib: "RETROVIR 100MG GELU BT 100",
  atcCode: "J05AF01"
}, {
  CIP7: '3388045',
  CIP13: '3400933880453',
  ucdLib: "RETROVIR 250MG GELU",
  UCD7: '9124442',
  UCD13: '3400891244427',
  ucdQtyMultiplicator: 40,
  cipLib: "RETROVIR 250MG GELU BT 40",
  atcCode: "J05AF01"
}, {
  CIP7: '3388424',
  CIP13: '3400933884246',
  ucdLib: "RETROVIR BUV FL200ML+SRG10ML",
  UCD7: '9154182',
  UCD13: '3400891541823',
  ucdQtyMultiplicator: 1,
  cipLib: "RETROVIR BUV FL200ML+SRG10ML BT 1",
  atcCode: "J05AF01"
}, {
  CIP7: '3634159',
  CIP13: '3400936341593',
  ucdLib: "RETROVIR BUV FL200ML+SRG1ML",
  UCD7: '9261908',
  UCD13: '3400892619088',
  ucdQtyMultiplicator: 1,
  cipLib: "RETROVIR BUV FL200ML+SRG1ML BT 1",
  atcCode: "J05AF01"
}, {
  CIP7: '3959536',
  CIP13: '3400939595368',
  ucdLib: "PREZISTA 150MG CPR",
  UCD7: '9339177',
  UCD13: '3400893391778',
  ucdQtyMultiplicator: 240,
  cipLib: "PREZISTA 150MG CPR BT 240",
  atcCode: "J05AE10"
}, {
  CIP7: '3931383',
  CIP13: '3400939313832',
  ucdLib: "PREZISTA 400MG CPR",
  UCD7: '9328050',
  UCD13: '3400893280508',
  ucdQtyMultiplicator: 60,
  cipLib: "PREZISTA 400MG CPR BT 60",
  atcCode: "J05AE10"
}, {
  CIP7: '3931408',
  CIP13: '3400939314082',
  ucdLib: "PREZISTA 600MG CPR",
  UCD7: '9328067',
  UCD13: '3400893280676',
  ucdQtyMultiplicator: 60,
  cipLib: "PREZISTA 600MG CPR BT 60",
  atcCode: "J05AE10"
}, {
  CIP7: '3959513',
  CIP13: '3400939595139',
  ucdLib: "PREZISTA 75MG CPR",
  UCD7: '9339183',
  UCD13: '3400893391839',
  ucdQtyMultiplicator: 480,
  cipLib: "PREZISTA 75MG CPR BT 480",
  atcCode: "J05AE10"
}, {
  CIP7: '2670495',
  CIP13: '3400926704957',
  ucdLib: "PREZISTA 100MG/ML BUV FV200ML",
  UCD7: '9393461',
  UCD13: '3400893934616',
  ucdQtyMultiplicator: 1,
  cipLib: "PREZISTA 100MG/ML BUV FV200ML BT 1",
  atcCode: "J05AE10"
}, {
  CIP7: '2678870',
  CIP13: '3400926788704',
  ucdLib: "PREZISTA 800MG CPR",
  UCD7: '9391025',
  UCD13: '3400893910252',
  ucdQtyMultiplicator: 30,
  cipLib: "PREZISTA 800MG CPR BT 30",
  atcCode: "J05AE10"
}, {
  CIP7: '3692524',
  CIP13: '3400936925243',
  ucdLib: "APTIVUS 250MG CAPS MOL",
  UCD7: '9280596',
  UCD13: '3400892805962',
  ucdQtyMultiplicator: 120,
  cipLib: "APTIVUS 250MG CAPS MOL BT 120",
  atcCode: "J05AE09"
}, {
  CIP7: '3958838',
  CIP13: '3400939588384',
  ucdLib: "APTIVUS 100MG/ML BUV FL95ML",
  UCD7: '9339295',
  UCD13: '3400893392959',
  ucdQtyMultiplicator: 1,
  cipLib: "APTIVUS 100MG/ML BUV FL95ML BT 1",
  atcCode: "J05AE09"
}, {
  CIP7: '3640438',
  CIP13: '3400936404380',
  ucdLib: "REYATAZ 150MG GELU",
  UCD7: '9258697',
  UCD13: '3400892586977',
  ucdQtyMultiplicator: 60,
  cipLib: "REYATAZ 150MG GELU BT 60",
  atcCode: "J05AE08"
}, {
  CIP7: '3640450',
  CIP13: '3400936404502',
  ucdLib: "REYATAZ 200MG GELU",
  UCD7: '9258705',
  UCD13: '3400892587059',
  ucdQtyMultiplicator: 60,
  cipLib: "REYATAZ 200MG GELU BT 60",
  atcCode: "J05AE08"
}, {
  CIP7: '3848788',
  CIP13: '3400938487886',
  ucdLib: "REYATAZ 300MG GELU",
  UCD7: '9312907',
  UCD13: '3400893129074',
  ucdQtyMultiplicator: 30,
  cipLib: "REYATAZ 300MG GELU BT 30",
  atcCode: "J05AE08"
}, {
  CIP7: '3640645',
  CIP13: '3400936406452',
  ucdLib: "TELZIR 50MG/ML BUV FL225ML",
  UCD7: '9264930',
  UCD13: '3400892649306',
  ucdQtyMultiplicator: 1,
  cipLib: "TELZIR 50MG/ML BUV FL225ML BT 1",
  atcCode: "J05AE07"
}, {
  CIP7: '3640639',
  CIP13: '3400936406391',
  ucdLib: "TELZIR 700MG CPR",
  UCD7: '9261966',
  UCD13: '3400892619668',
  ucdQtyMultiplicator: 60,
  cipLib: "TELZIR 700MG CPR BT 60",
  atcCode: "J05AE07"
}, {
  CIP7: '3003326',
  CIP13: '3400930033265',
  ucdLib: "NORVIR 100MG BUV PDR SACH",
  UCD7: '9415292',
  UCD13: '3400894152927',
  ucdQtyMultiplicator: 30,
  cipLib: "NORVIR 100MG BUV PDR SACH BT 30",
  atcCode: "J05AE03"
}, {
  CIP7: '3440751',
  CIP13: '3400934407512',
  ucdLib: "NORVIR 100MG CPR",
  UCD7: '9352410',
  UCD13: '3400893524107',
  ucdQtyMultiplicator: 30,
  cipLib: "NORVIR 100MG CPR BT 30",
  atcCode: "J05AE03"
}, {
  CIP7: '4169670',
  CIP13: '3400941696701',
  ucdLib: "NORVIR 80MG/ML BUV FL90ML +S.",
  UCD7: '9366116',
  UCD13: '3400893661161',
  ucdQtyMultiplicator: 1,
  cipLib: "NORVIR 80MG/ML BUV FL90ML +S. BT 1",
  atcCode: "J05AE03"
}, {
  CIP7: '3420990',
  CIP13: '3400934209901',
  ucdLib: "CRIXIVAN 200MG GELU",
  UCD7: '9180802',
  UCD13: '3400891808025',
  ucdQtyMultiplicator: 360,
  cipLib: "CRIXIVAN 200MG GELU BT 360",
  atcCode: "J05AE02"
}, {
  CIP7: '3421009',
  CIP13: '3400934210099',
  ucdLib: "CRIXIVAN 400MG GELU",
  UCD7: '9180819',
  UCD13: '3400891808193',
  ucdQtyMultiplicator: 90,
  cipLib: "CRIXIVAN 400MG GELU BT 90",
  atcCode: "J05AE02"
}, {
  CIP7: '3421015',
  CIP13: '3400934210150',
  ucdLib: "CRIXIVAN 400MG GELU",
  UCD7: '9180819',
  UCD13: '3400891808193',
  ucdQtyMultiplicator: 180,
  cipLib: "CRIXIVAN 400MG GELU BT 180",
  atcCode: "J05AE02"
}, {
  CIP7: '3659403',
  CIP13: '3400936594036',
  ucdLib: "INVIRASE 500MG CPR",
  UCD7: '9275891',
  UCD13: '3400892758916',
  ucdQtyMultiplicator: 120,
  cipLib: "INVIRASE 500MG CPR BT 120",
  atcCode: "J05AE01"
}, {
  CIP7: '3420843',
  CIP13: '3400934208430',
  ucdLib: "INVIRASE 200MG GELU",
  UCD7: '9181664',
  UCD13: '3400891816648',
  ucdQtyMultiplicator: 270,
  cipLib: "INVIRASE 200MG GELU BT 270",
  atcCode: "J05AE01"
}, {
  CIP7: '3464450',
  CIP13: '3400934644504',
  ucdLib: "FOSCAVIR 6G PERF FV250ML",
  UCD7: '9150155',
  UCD13: '3400891501551',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSCAVIR 6G PERF FV250ML BT 1",
  atcCode: "J05AD01"
}, {
  CIP7: '3000896',
  CIP13: '3400930008966',
  ucdLib: "VALGANCICLOVIR ARW 450MG CPR",
  UCD7: '9420318',
  UCD13: '3400894203186',
  ucdQtyMultiplicator: 60,
  cipLib: "VALGANCICLOVIR ARW 450MG CPR BT 60",
  atcCode: "J05AB14"
}, {
  CIP7: '3000872',
  CIP13: '3400930008720',
  ucdLib: "VALGANCICLOVIR MYL 450MG CPR",
  UCD7: '9411816',
  UCD13: '3400894118169',
  ucdQtyMultiplicator: 60,
  cipLib: "VALGANCICLOVIR MYL 450MG CPR BT 60",
  atcCode: "J05AB14"
}, {
  CIP7: '3000871',
  CIP13: '3400930008713',
  ucdLib: "VALGANCICLOVIR SDZ 450MG CPR",
  UCD7: '9419077',
  UCD13: '3400894190776',
  ucdQtyMultiplicator: 60,
  cipLib: "VALGANCICLOVIR SDZ 450MG CPR BT 60",
  atcCode: "J05AB14"
}, {
  CIP7: '3601361',
  CIP13: '3400936013612',
  ucdLib: "ROVALCYTE 450MG CPR",
  UCD7: '9246398',
  UCD13: '3400892463988',
  ucdQtyMultiplicator: 60,
  cipLib: "ROVALCYTE 450MG CPR BT 60",
  atcCode: "J05AB14"
}, {
  CIP7: '3867337',
  CIP13: '3400938673371',
  ucdLib: "ROVALCYTE 50MG/ML BUV FL100ML",
  UCD7: '9324537',
  UCD13: '3400893245378',
  ucdQtyMultiplicator: 1,
  cipLib: "ROVALCYTE 50MG/ML BUV FL100ML BT 1",
  atcCode: "J05AB14"
}, {
  CIP7: '3522420',
  CIP13: '3400935224200',
  ucdLib: "ZELITREX 500MG CPR",
  UCD7: '9177823',
  UCD13: '3400891778236',
  ucdQtyMultiplicator: 112,
  cipLib: "ZELITREX 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3417083',
  CIP13: '3400934170836',
  ucdLib: "ZELITREX 500MG CPR",
  UCD7: '9177823',
  UCD13: '3400891778236',
  ucdQtyMultiplicator: 10,
  cipLib: "ZELITREX 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3580297',
  CIP13: '3400935802972',
  ucdLib: "VALACICLOVIR CRT 500MG CPR",
  UCD7: '9340708',
  UCD13: '3400893407080',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR CRT 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3384449',
  CIP13: '3400933844493',
  ucdLib: "ZELITREX 500MG CPR",
  UCD7: '9177823',
  UCD13: '3400891778236',
  ucdQtyMultiplicator: 42,
  cipLib: "ZELITREX 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3470338',
  CIP13: '3400934703386',
  ucdLib: "VALACICLOVIR CRT 500MG CPR",
  UCD7: '9340708',
  UCD13: '3400893407080',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR CRT 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3876448',
  CIP13: '3400938764482',
  ucdLib: "VALACICLOVIR BGA 500MG CPR",
  UCD7: '9322886',
  UCD13: '3400893228869',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR BGA 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3876460',
  CIP13: '3400938764604',
  ucdLib: "VALACICLOVIR BGA 500MG CPR",
  UCD7: '9322886',
  UCD13: '3400893228869',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR BGA 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3876514',
  CIP13: '3400938765144',
  ucdLib: "VALACICLOVIR BGA 500MG CPR",
  UCD7: '9322886',
  UCD13: '3400893228869',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR BGA 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3860329',
  CIP13: '3400938603293',
  ucdLib: "VALACICLOVIR TVC 500MG CPR",
  UCD7: '9338025',
  UCD13: '3400893380253',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR TVC 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3860358',
  CIP13: '3400938603583',
  ucdLib: "VALACICLOVIR TVC 500MG CPR",
  UCD7: '9338025',
  UCD13: '3400893380253',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR TVC 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3876537',
  CIP13: '3400938765373',
  ucdLib: "VALACICLOVIR ZEN 500MG CPR",
  UCD7: '9325732',
  UCD13: '3400893257326',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR ZEN 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3876566',
  CIP13: '3400938765663',
  ucdLib: "VALACICLOVIR ZEN 500MG CPR",
  UCD7: '9325732',
  UCD13: '3400893257326',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR ZEN 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3876603',
  CIP13: '3400938766035',
  ucdLib: "VALACICLOVIR ZEN 500MG CPR",
  UCD7: '9325732',
  UCD13: '3400893257326',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR ZEN 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3842277',
  CIP13: '3400938422771',
  ucdLib: "VALACICLOVIR ALT 500MG CPR",
  UCD7: '9314964',
  UCD13: '3400893149645',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR ALT 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3842308',
  CIP13: '3400938423082',
  ucdLib: "VALACICLOVIR ALT 500MG CPR",
  UCD7: '9314964',
  UCD13: '3400893149645',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR ALT 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3974464',
  CIP13: '3400939744643',
  ucdLib: "VALACICLOVIR BLF 500MG CPR",
  UCD7: '9347461',
  UCD13: '3400893474617',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR BLF 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3974493',
  CIP13: '3400939744933',
  ucdLib: "VALACICLOVIR BLF 500MG CPR",
  UCD7: '9347461',
  UCD13: '3400893474617',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR BLF 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3974530',
  CIP13: '3400939745305',
  ucdLib: "VALACICLOVIR BLF 500MG CPR",
  UCD7: '9347461',
  UCD13: '3400893474617',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR BLF 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3958554',
  CIP13: '3400939585543',
  ucdLib: "VALACICLOVIR EVO 500MG CPR",
  UCD7: '9342624',
  UCD13: '3400893426241',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR EVO 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3958577',
  CIP13: '3400939585772',
  ucdLib: "VALACICLOVIR EVO 500MG CPR",
  UCD7: '9342624',
  UCD13: '3400893426241',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR EVO 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3956503',
  CIP13: '3400939565033',
  ucdLib: "VALACICLOVIR RBX 500MG CPR",
  UCD7: '9339094',
  UCD13: '3400893390948',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR RBX 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3956532',
  CIP13: '3400939565323',
  ucdLib: "VALACICLOVIR RBX 500MG CPR",
  UCD7: '9339094',
  UCD13: '3400893390948',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR RBX 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3956561',
  CIP13: '3400939565613',
  ucdLib: "VALACICLOVIR RBX 500MG CPR",
  UCD7: '9339094',
  UCD13: '3400893390948',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR RBX 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3841792',
  CIP13: '3400938417920',
  ucdLib: "VALACICLOVIR SDZ 500MG CPR",
  UCD7: '9315053',
  UCD13: '3400893150535',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR SDZ 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3841817',
  CIP13: '3400938418170',
  ucdLib: "VALACICLOVIR SDZ 500MG CPR",
  UCD7: '9315053',
  UCD13: '3400893150535',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR SDZ 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3841852',
  CIP13: '3400938418521',
  ucdLib: "VALACICLOVIR SDZ 500MG CPR",
  UCD7: '9315053',
  UCD13: '3400893150535',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR SDZ 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3955975',
  CIP13: '3400939559759',
  ucdLib: "VALACICLOVIR TVC 500MG CPR",
  UCD7: '9338025',
  UCD13: '3400893380253',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR TVC 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3988437',
  CIP13: '3400939884370',
  ucdLib: "VALACICLOVIR ALM 500MG CPR",
  UCD7: '9344132',
  UCD13: '3400893441329',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR ALM 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3988466',
  CIP13: '3400939884660',
  ucdLib: "VALACICLOVIR ALM 500MG CPR",
  UCD7: '9344132',
  UCD13: '3400893441329',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR ALM 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '2758066',
  CIP13: '3400927580666',
  ucdLib: "VALACICLOVIR ARW 500MG CPR",
  UCD7: '9407140',
  UCD13: '3400894071402',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR ARW 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '2758095',
  CIP13: '3400927580956',
  ucdLib: "VALACICLOVIR ARW 500MG CPR",
  UCD7: '9407140',
  UCD13: '3400894071402',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR ARW 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '2758132',
  CIP13: '3400927581328',
  ucdLib: "VALACICLOVIR ARW 500MG CPR",
  UCD7: '9407140',
  UCD13: '3400894071402',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR ARW 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3946278',
  CIP13: '3400939462783',
  ucdLib: "VALACICLOVIR CRT 500MG CPR",
  UCD7: '9340708',
  UCD13: '3400893407080',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR CRT 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3949271',
  CIP13: '3400939492711',
  ucdLib: "VALACICLOVIR EG 500MG CPR",
  UCD7: '9338752',
  UCD13: '3400893387528',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR EG 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3949294',
  CIP13: '3400939492940',
  ucdLib: "VALACICLOVIR EG 500MG CPR",
  UCD7: '9338752',
  UCD13: '3400893387528',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR EG 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3949325',
  CIP13: '3400939493251',
  ucdLib: "VALACICLOVIR EG 500MG CPR",
  UCD7: '9338752',
  UCD13: '3400893387528',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR EG 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3980890',
  CIP13: '3400939808901',
  ucdLib: "VALACICLOVIR MYL 500MG CPR",
  UCD7: '9344155',
  UCD13: '3400893441558',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR MYL 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '3980915',
  CIP13: '3400939809151',
  ucdLib: "VALACICLOVIR MYL 500MG CPR",
  UCD7: '9344155',
  UCD13: '3400893441558',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR MYL 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '3980921',
  CIP13: '3400939809212',
  ucdLib: "VALACICLOVIR MYL 500MG CPR",
  UCD7: '9344155',
  UCD13: '3400893441558',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR MYL 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '4946027',
  CIP13: '3400949460274',
  ucdLib: "VALACICLOVIR ZYD 500MG CPR",
  UCD7: '9364726',
  UCD13: '3400893647264',
  ucdQtyMultiplicator: 10,
  cipLib: "VALACICLOVIR ZYD 500MG CPR BT 10",
  atcCode: "J05AB11"
}, {
  CIP7: '4946056',
  CIP13: '3400949460564',
  ucdLib: "VALACICLOVIR ZYD 500MG CPR",
  UCD7: '9364726',
  UCD13: '3400893647264',
  ucdQtyMultiplicator: 42,
  cipLib: "VALACICLOVIR ZYD 500MG CPR BT 42",
  atcCode: "J05AB11"
}, {
  CIP7: '4946085',
  CIP13: '3400949460854',
  ucdLib: "VALACICLOVIR ZYD 500MG CPR",
  UCD7: '9364726',
  UCD13: '3400893647264',
  ucdQtyMultiplicator: 112,
  cipLib: "VALACICLOVIR ZYD 500MG CPR BT 112",
  atcCode: "J05AB11"
}, {
  CIP7: '3523690',
  CIP13: '3400935236906',
  ucdLib: "ORAVIR 125MG CPR",
  UCD7: '9220335',
  UCD13: '3400892203355',
  ucdQtyMultiplicator: 10,
  cipLib: "ORAVIR 125MG CPR BT 10",
  atcCode: "J05AB09"
}, {
  CIP7: '3413820',
  CIP13: '3400934138201',
  ucdLib: "ORAVIR 500MG CPR",
  UCD7: '9191711',
  UCD13: '3400891917116',
  ucdQtyMultiplicator: 21,
  cipLib: "ORAVIR 500MG CPR BT 21",
  atcCode: "J05AB09"
}, {
  CIP7: '3478044',
  CIP13: '3400934780448',
  ucdLib: "CYMEVAN 500MG INJ FL10ML",
  UCD7: '9130945',
  UCD13: '3400891309454',
  ucdQtyMultiplicator: 1,
  cipLib: "CYMEVAN 500MG INJ FL10ML BT 1",
  atcCode: "J05AB06"
}, {
  CIP7: '3611158',
  CIP13: '3400936111585',
  ucdLib: "ACICLOVIR TVC 200MG CPR",
  UCD7: '9244324',
  UCD13: '3400892443249',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR TVC 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3270817',
  CIP13: '3400932708178',
  ucdLib: "ZOVIRAX 200MG CPR",
  UCD7: '9103931',
  UCD13: '3400891039313',
  ucdQtyMultiplicator: 25,
  cipLib: "ZOVIRAX 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3260687',
  CIP13: '3400932606870',
  ucdLib: "ZOVIRAX 250MG IV FL",
  UCD7: '9102110',
  UCD13: '3400891021103',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOVIRAX 250MG IV FL BT 1",
  atcCode: "J05AB01"
}, {
  CIP7: '3341138',
  CIP13: '3400933411381',
  ucdLib: "ZOVIRAX 200MG/5ML BUV FL125ML",
  UCD7: '9170703',
  UCD13: '3400891707038',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOVIRAX 200MG/5ML BUV FL125ML BT 1",
  atcCode: "J05AB01"
}, {
  CIP7: '3341121',
  CIP13: '3400933411213',
  ucdLib: "ZOVIRAX 800MG CPR",
  UCD7: '9170726',
  UCD13: '3400891707267',
  ucdQtyMultiplicator: 35,
  cipLib: "ZOVIRAX 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3359397',
  CIP13: '3400933593971',
  ucdLib: "ZOVIRAX 800MG/10ML BUV FL180ML",
  UCD7: '9170732',
  UCD13: '3400891707328',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOVIRAX 800MG/10ML BUV FL180ML BT 1",
  atcCode: "J05AB01"
}, {
  CIP7: '3556614',
  CIP13: '3400935566140',
  ucdLib: "ACICLOVIR EG 800MG CPR",
  UCD7: '9234389',
  UCD13: '3400892343891',
  ucdQtyMultiplicator: 35,
  cipLib: "ACICLOVIR EG 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3556620',
  CIP13: '3400935566201',
  ucdLib: "ACICLOVIR TVC 800MG CPR",
  UCD7: '9229247',
  UCD13: '3400892292472',
  ucdQtyMultiplicator: 35,
  cipLib: "ACICLOVIR TVC 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3363938',
  CIP13: '3400933639389',
  ucdLib: "ZOVIRAX 500MG IV FL",
  UCD7: '9163672',
  UCD13: '3400891636727',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOVIRAX 500MG IV FL BT 1",
  atcCode: "J05AB01"
}, {
  CIP7: '3593058',
  CIP13: '3400935930583',
  ucdLib: "ACICLOVIR ARW 200MG CPR",
  UCD7: '9241679',
  UCD13: '3400892416793',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR ARW 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3593124',
  CIP13: '3400935931245',
  ucdLib: "ACICLOVIR ARW 800MG CPR",
  UCD7: '9264114',
  UCD13: '3400892641140',
  ucdQtyMultiplicator: 35,
  cipLib: "ACICLOVIR ARW 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3486150',
  CIP13: '3400934861505',
  ucdLib: "ACICLOVIR BGA 200MG CPR",
  UCD7: '9212620',
  UCD13: '3400892126203',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR BGA 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3486167',
  CIP13: '3400934861673',
  ucdLib: "ACICLOVIR BGA 800MG CPR",
  UCD7: '9212637',
  UCD13: '3400892126371',
  ucdQtyMultiplicator: 35,
  cipLib: "ACICLOVIR BGA 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3483128',
  CIP13: '3400934831287',
  ucdLib: "ACICLOVIR EG 200MG CPR",
  UCD7: '9234372',
  UCD13: '3400892343723',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR EG 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3656830',
  CIP13: '3400936568303',
  ucdLib: "ACICLOVIR SDZ 200MG CPR",
  UCD7: '9263706',
  UCD13: '3400892637068',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR SDZ 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3468809',
  CIP13: '3400934688096',
  ucdLib: "ACICLOVIR CRT 200MG CPR",
  UCD7: '9347834',
  UCD13: '3400893478349',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR CRT 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3460570',
  CIP13: '3400934605703',
  ucdLib: "ACICLOVIR MYL 200MG CPR",
  UCD7: '9201444',
  UCD13: '3400892014449',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR MYL 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3466710',
  CIP13: '3400934667107',
  ucdLib: "ACICLOVIR MYL 250MG INJ FL",
  UCD7: '9206631',
  UCD13: '3400892066318',
  ucdQtyMultiplicator: 5,
  cipLib: "ACICLOVIR MYL 250MG INJ FL BT 5",
  atcCode: "J05AB01"
}, {
  CIP7: '3466756',
  CIP13: '3400934667565',
  ucdLib: "ACICLOVIR MYL 500MG INJ FL",
  UCD7: '9206648',
  UCD13: '3400892066486',
  ucdQtyMultiplicator: 5,
  cipLib: "ACICLOVIR MYL 500MG INJ FL BT 5",
  atcCode: "J05AB01"
}, {
  CIP7: '3463887',
  CIP13: '3400934638879',
  ucdLib: "ACICLOVIR MYL 800MG CPR",
  UCD7: '9203207',
  UCD13: '3400892032078',
  ucdQtyMultiplicator: 35,
  cipLib: "ACICLOVIR MYL 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3781475',
  CIP13: '3400937814751',
  ucdLib: "ACICLOVIR ARL 200MG CPR",
  UCD7: '9299986',
  UCD13: '3400892999869',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR ARL 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3794940',
  CIP13: '3400937949408',
  ucdLib: "ACICLOVIR ARL 800MG CPR",
  UCD7: '9301602',
  UCD13: '3400893016022',
  ucdQtyMultiplicator: 35,
  cipLib: "ACICLOVIR ARL 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3794928',
  CIP13: '3400937949286',
  ucdLib: "ACICLOVIR CRT 800MG CPR",
  UCD7: '9302412',
  UCD13: '3400893024126',
  ucdQtyMultiplicator: 35,
  cipLib: "ACICLOVIR CRT 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3782902',
  CIP13: '3400937829021',
  ucdLib: "ACICLOVIR RBX 200MG CPR",
  UCD7: '9300778',
  UCD13: '3400893007785',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR RBX 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3781481',
  CIP13: '3400937814812',
  ucdLib: "ACICLOVIR ZEN 200MG CPR",
  UCD7: '9300790',
  UCD13: '3400893007907',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR ZEN 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3794963',
  CIP13: '3400937949637',
  ucdLib: "ACICLOVIR ZEN 800MG CPR",
  UCD7: '9301619',
  UCD13: '3400893016190',
  ucdQtyMultiplicator: 35,
  cipLib: "ACICLOVIR ZEN 800MG CPR BT 35",
  atcCode: "J05AB01"
}, {
  CIP7: '3781469',
  CIP13: '3400937814690',
  ucdLib: "ACICLOVIR ZYD 200MG CPR",
  UCD7: '9299992',
  UCD13: '3400892999920',
  ucdQtyMultiplicator: 25,
  cipLib: "ACICLOVIR ZYD 200MG CPR BT 25",
  atcCode: "J05AB01"
}, {
  CIP7: '3032561',
  CIP13: '3400930325612',
  ucdLib: "DISULONE CPR",
  UCD7: '9027940',
  UCD13: '3400890279406',
  ucdQtyMultiplicator: 100,
  cipLib: "DISULONE CPR BT 100",
  atcCode: "J04BA02"
}, {
  CIP7: '5602821',
  CIP13: '3400956028214',
  ucdLib: "LAMPRENE 100MG CAPS",
  UCD7: '9166883',
  UCD13: '3400891668834',
  ucdQtyMultiplicator: 100,
  cipLib: "LAMPRENE 100MG CAPS BT 100",
  atcCode: "J04BA01"
}, {
  CIP7: '5602815',
  CIP13: '3400956028153',
  ucdLib: "LAMPRENE 50MG CAPS",
  UCD7: '9166908',
  UCD13: '3400891669084',
  ucdQtyMultiplicator: 100,
  cipLib: "LAMPRENE 50MG CAPS BT 100",
  atcCode: "J04BA01"
}, {
  CIP7: '3299353',
  CIP13: '3400932993536',
  ucdLib: "RIFATER CPR",
  UCD7: '9146544',
  UCD13: '3400891465440',
  ucdQtyMultiplicator: 60,
  cipLib: "RIFATER CPR BT 60",
  atcCode: "J04AM05"
}, {
  CIP7: '3295409',
  CIP13: '3400932954094',
  ucdLib: "RIFINAH CPR",
  UCD7: '9146550',
  UCD13: '3400891465501',
  ucdQtyMultiplicator: 30,
  cipLib: "RIFINAH CPR BT 30",
  atcCode: "J04AM02"
}, {
  CIP7: '3001057',
  CIP13: '3400930010570',
  ucdLib: "DELTYBA 50MG CPR",
  UCD7: '9413212',
  UCD13: '3400894132127',
  ucdQtyMultiplicator: 48,
  cipLib: "DELTYBA 50MG CPR BT 48",
  atcCode: "J04AK06"
}, {
  CIP7: '3001581',
  CIP13: '3400930015810',
  ucdLib: "SIRTURO 100MG CPR",
  UCD7: '9408961',
  UCD13: '3400894089612',
  ucdQtyMultiplicator: 24,
  cipLib: "SIRTURO 100MG CPR BT 24",
  atcCode: "J04AK05"
}, {
  CIP7: '3069311',
  CIP13: '3400930693117',
  ucdLib: "MYAMBUTOL 400MG CPR",
  UCD7: '9060357',
  UCD13: '3400890603577',
  ucdQtyMultiplicator: 50,
  cipLib: "MYAMBUTOL 400MG CPR BT 50",
  atcCode: "J04AK02"
}, {
  CIP7: '3116217',
  CIP13: '3400931162179',
  ucdLib: "DEXAMBUTOL 500MG CPR",
  UCD7: '9025898',
  UCD13: '3400890258982',
  ucdQtyMultiplicator: 50,
  cipLib: "DEXAMBUTOL 500MG CPR BT 50",
  atcCode: "J04AK02"
}, {
  CIP7: '5585577',
  CIP13: '3400955855774',
  ucdLib: "MYAMBUTOL 1000MG INJ A.10ML",
  UCD7: '9171163',
  UCD13: '3400891711639',
  ucdQtyMultiplicator: 50,
  cipLib: "MYAMBUTOL 1000MG INJ A.10ML BT 50",
  atcCode: "J04AK02"
}, {
  CIP7: '3238707',
  CIP13: '3400932387076',
  ucdLib: "PIRILENE 500MG CPR",
  UCD7: '9072277',
  UCD13: '3400890722773',
  ucdQtyMultiplicator: 60,
  cipLib: "PIRILENE 500MG CPR BT 60",
  atcCode: "J04AK01"
}, {
  CIP7: '3477978',
  CIP13: '3400934779787',
  ucdLib: "RIMIFON 150MG CPR",
  UCD7: '9202248',
  UCD13: '3400892022482',
  ucdQtyMultiplicator: 100,
  cipLib: "RIMIFON 150MG CPR BT 100",
  atcCode: "J04AC01"
}, {
  CIP7: '3477984',
  CIP13: '3400934779848',
  ucdLib: "RIMIFON 500MG INJ AMP5ML",
  UCD7: '9202260',
  UCD13: '3400892022604',
  ucdQtyMultiplicator: 6,
  cipLib: "RIMIFON 500MG INJ AMP5ML BT 6",
  atcCode: "J04AC01"
}, {
  CIP7: '3477961',
  CIP13: '3400934779619',
  ucdLib: "RIMIFON 50MG CPR",
  UCD7: '9202254',
  UCD13: '3400892022543',
  ucdQtyMultiplicator: 200,
  cipLib: "RIMIFON 50MG CPR BT 200",
  atcCode: "J04AC01"
}, {
  CIP7: '3360696',
  CIP13: '3400933606961',
  ucdLib: "ANSATIPINE 150MG GELU",
  UCD7: '9159216',
  UCD13: '3400891592160',
  ucdQtyMultiplicator: 30,
  cipLib: "ANSATIPINE 150MG GELU BT 30",
  atcCode: "J04AB04"
}, {
  CIP7: '5536656',
  CIP13: '3400955366560',
  ucdLib: "RIFADINE 300MG GELU",
  UCD7: '9080288',
  UCD13: '3400890802888',
  ucdQtyMultiplicator: 60,
  cipLib: "RIFADINE 300MG GELU BT 60",
  atcCode: "J04AB02"
}, {
  CIP7: '3118676',
  CIP13: '3400931186762',
  ucdLib: "RIFADINE 2% BUV FL120ML",
  UCD7: '9080294',
  UCD13: '3400890802949',
  ucdQtyMultiplicator: 1,
  cipLib: "RIFADINE 2% BUV FL120ML BT 1",
  atcCode: "J04AB02"
}, {
  CIP7: '3091500',
  CIP13: '3400930915004',
  ucdLib: "RIFADINE 300MG GELU",
  UCD7: '9080288',
  UCD13: '3400890802888',
  ucdQtyMultiplicator: 30,
  cipLib: "RIFADINE 300MG GELU BT 30",
  atcCode: "J04AB02"
}, {
  CIP7: '3091517',
  CIP13: '3400930915172',
  ucdLib: "RIFADINE 300MG GELU",
  UCD7: '9080288',
  UCD13: '3400890802888',
  ucdQtyMultiplicator: 8,
  cipLib: "RIFADINE 300MG GELU BT 8",
  atcCode: "J04AB02"
}, {
  CIP7: '3091629',
  CIP13: '3400930916292',
  ucdLib: "RIMACTAN 300MG GELU",
  UCD7: '9080408',
  UCD13: '3400890804080',
  ucdQtyMultiplicator: 30,
  cipLib: "RIMACTAN 300MG GELU BT 30",
  atcCode: "J04AB02"
}, {
  CIP7: '3692369',
  CIP13: '3400936923690',
  ucdLib: "RIFADINE 600MG IV FL+AMP",
  UCD7: '9118163',
  UCD13: '3400891181630',
  ucdQtyMultiplicator: 1,
  cipLib: "RIFADINE 600MG IV FL+AMP BT 1",
  atcCode: "J04AB02"
}, {
  CIP7: '2788015',
  CIP13: '3400927880155',
  ucdLib: "GRANUPAS 4G GLE SACH",
  UCD7: '9404615',
  UCD13: '3400894046158',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANUPAS 4G GLE SACH BT 30",
  atcCode: "J04AA01"
}, {
  CIP7: '3959832',
  CIP13: '3400939598321',
  ucdLib: "ECALTA 100MG PERF FL30ML",
  UCD7: '9341234',
  UCD13: '3400893412343',
  ucdQtyMultiplicator: 1,
  cipLib: "ECALTA 100MG PERF FL30ML BT 1",
  atcCode: "J02AX06"
}, {
  CIP7: '3866289',
  CIP13: '3400938662894',
  ucdLib: "MYCAMINE 100MG INJ FL10ML",
  UCD7: '9314421',
  UCD13: '3400893144213',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCAMINE 100MG INJ FL10ML BT 1",
  atcCode: "J02AX05"
}, {
  CIP7: '3866272',
  CIP13: '3400938662726',
  ucdLib: "MYCAMINE 50MG INJ FL10ML",
  UCD7: '9314438',
  UCD13: '3400893144381',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCAMINE 50MG INJ FL10ML BT 1",
  atcCode: "J02AX05"
}, {
  CIP7: '5643381',
  CIP13: '3400956433810',
  ucdLib: "CANCIDAS 50MG INJ FL",
  UCD7: '9249089',
  UCD13: '3400892490892',
  ucdQtyMultiplicator: 1,
  cipLib: "CANCIDAS 50MG INJ FL BT 1",
  atcCode: "J02AX04"
}, {
  CIP7: '5643406',
  CIP13: '3400956434060',
  ucdLib: "CANCIDAS 70MG INJ FL",
  UCD7: '9249103',
  UCD13: '3400892491035',
  ucdQtyMultiplicator: 1,
  cipLib: "CANCIDAS 70MG INJ FL BT 1",
  atcCode: "J02AX04"
}, {
  CIP7: '3179643',
  CIP13: '3400931796435',
  ucdLib: "ANCOTIL 500MG CPR",
  UCD7: '9004732',
  UCD13: '3400890047326',
  ucdQtyMultiplicator: 100,
  cipLib: "ANCOTIL 500MG CPR BT 100",
  atcCode: "J02AX01"
}, {
  CIP7: '5620339',
  CIP13: '3400956203390',
  ucdLib: "ANCOTIL 1% PERF FL250ML",
  UCD7: '9106993',
  UCD13: '3400891069938',
  ucdQtyMultiplicator: 5,
  cipLib: "ANCOTIL 1% PERF FL250ML BT 5",
  atcCode: "J02AX01"
}, {
  CIP7: '3003990',
  CIP13: '3400930039908',
  ucdLib: "CRESEMBA 100MG GELU",
  UCD7: '9416995',
  UCD13: '3400894169956',
  ucdQtyMultiplicator: 14,
  cipLib: "CRESEMBA 100MG GELU BT 14",
  atcCode: "J02AC05"
}, {
  CIP7: '3003989',
  CIP13: '3400930039892',
  ucdLib: "CRESEMBA 200MG INJ FL",
  UCD7: '9417003',
  UCD13: '3400894170037',
  ucdQtyMultiplicator: 1,
  cipLib: "CRESEMBA 200MG INJ FL BT 1",
  atcCode: "J02AC05"
}, {
  CIP7: '3702398',
  CIP13: '3400937023986',
  ucdLib: "NOXAFIL 40MG/ML BUV FL105ML",
  UCD7: '9279966',
  UCD13: '3400892799667',
  ucdQtyMultiplicator: 1,
  cipLib: "NOXAFIL 40MG/ML BUV FL105ML BT 1",
  atcCode: "J02AC04"
}, {
  CIP7: '2788831',
  CIP13: '3400927888311',
  ucdLib: "NOXAFIL 100MG CPR",
  UCD7: '9400617',
  UCD13: '3400894006176',
  ucdQtyMultiplicator: 24,
  cipLib: "NOXAFIL 100MG CPR BT 24",
  atcCode: "J02AC04"
}, {
  CIP7: '2788848',
  CIP13: '3400927888489',
  ucdLib: "NOXAFIL 100MG CPR",
  UCD7: '9400617',
  UCD13: '3400894006176',
  ucdQtyMultiplicator: 96,
  cipLib: "NOXAFIL 100MG CPR BT 96",
  atcCode: "J02AC04"
}, {
  CIP7: '3004453',
  CIP13: '3400930044537',
  ucdLib: "VORICONAZOLE ACC 200MG CPR",
  UCD7: '9413927',
  UCD13: '3400894139270',
  ucdQtyMultiplicator: 14,
  cipLib: "VORICONAZOLE ACC 200MG CPR BT 14",
  atcCode: "J02AC03"
}, {
  CIP7: '3004454',
  CIP13: '3400930044544',
  ucdLib: "VORICONAZOLE ACC 200MG CPR",
  UCD7: '9413927',
  UCD13: '3400894139270',
  ucdQtyMultiplicator: 28,
  cipLib: "VORICONAZOLE ACC 200MG CPR BT 28",
  atcCode: "J02AC03"
}, {
  CIP7: '3004455',
  CIP13: '3400930044551',
  ucdLib: "VORICONAZOLE ACC 200MG CPR",
  UCD7: '9413927',
  UCD13: '3400894139270',
  ucdQtyMultiplicator: 56,
  cipLib: "VORICONAZOLE ACC 200MG CPR BT 56",
  atcCode: "J02AC03"
}, {
  CIP7: '3000264',
  CIP13: '3400930002643',
  ucdLib: "VORICONAZOLE ACC 200MG INJ FL",
  UCD7: '9414097',
  UCD13: '3400894140979',
  ucdQtyMultiplicator: 1,
  cipLib: "VORICONAZOLE ACC 200MG INJ FL BT 1",
  atcCode: "J02AC03"
}, {
  CIP7: '3004452',
  CIP13: '3400930044520',
  ucdLib: "VORICONAZOLE ACC 50MG CPR",
  UCD7: '9413933',
  UCD13: '3400894139331',
  ucdQtyMultiplicator: 28,
  cipLib: "VORICONAZOLE ACC 50MG CPR BT 28",
  atcCode: "J02AC03"
}, {
  CIP7: '3006301',
  CIP13: '3400930063019',
  ucdLib: "VORICONAZOLE ACC 50MG CPR",
  UCD7: '9413933',
  UCD13: '3400894139331',
  ucdQtyMultiplicator: 56,
  cipLib: "VORICONAZOLE ACC 50MG CPR BT 56",
  atcCode: "J02AC03"
}, {
  CIP7: '3005710',
  CIP13: '3400930057100',
  ucdLib: "VORICONAZOLE ARW 200MG INJ FL",
  UCD7: '9417983',
  UCD13: '3400894179832',
  ucdQtyMultiplicator: 1,
  cipLib: "VORICONAZOLE ARW 200MG INJ FL BT 1",
  atcCode: "J02AC03"
}, {
  CIP7: '3005633',
  CIP13: '3400930056332',
  ucdLib: "VORICONAZOLE FRK 200MG INJ FL",
  UCD7: '9419060',
  UCD13: '3400894190608',
  ucdQtyMultiplicator: 1,
  cipLib: "VORICONAZOLE FRK 200MG INJ FL BT 1",
  atcCode: "J02AC03"
}, {
  CIP7: '3004182',
  CIP13: '3400930041826',
  ucdLib: "VORICONAZOLE OHR 200MG CPR",
  UCD7: '9418310',
  UCD13: '3400894183105',
  ucdQtyMultiplicator: 30,
  cipLib: "VORICONAZOLE OHR 200MG CPR BT 30",
  atcCode: "J02AC03"
}, {
  CIP7: '3004170',
  CIP13: '3400930041703',
  ucdLib: "VORICONAZOLE OHR 50MG CPR",
  UCD7: '9418327',
  UCD13: '3400894183273',
  ucdQtyMultiplicator: 30,
  cipLib: "VORICONAZOLE OHR 50MG CPR BT 30",
  atcCode: "J02AC03"
}, {
  CIP7: '3004102',
  CIP13: '3400930041024',
  ucdLib: "VORICONAZOLE SDZ 200MG INJ FL",
  UCD7: '9418356',
  UCD13: '3400894183563',
  ucdQtyMultiplicator: 1,
  cipLib: "VORICONAZOLE SDZ 200MG INJ FL BT 1",
  atcCode: "J02AC03"
}, {
  CIP7: '3592900',
  CIP13: '3400935929006',
  ucdLib: "VFEND 200MG CPR",
  UCD7: '9240131',
  UCD13: '3400892401317',
  ucdQtyMultiplicator: 14,
  cipLib: "VFEND 200MG CPR BT 14",
  atcCode: "J02AC03"
}, {
  CIP7: '3592917',
  CIP13: '3400935929174',
  ucdLib: "VFEND 200MG CPR",
  UCD7: '9240131',
  UCD13: '3400892401317',
  ucdQtyMultiplicator: 28,
  cipLib: "VFEND 200MG CPR BT 28",
  atcCode: "J02AC03"
}, {
  CIP7: '3592923',
  CIP13: '3400935929235',
  ucdLib: "VFEND 200MG CPR",
  UCD7: '9240131',
  UCD13: '3400892401317',
  ucdQtyMultiplicator: 56,
  cipLib: "VFEND 200MG CPR BT 56",
  atcCode: "J02AC03"
}, {
  CIP7: '3592946',
  CIP13: '3400935929464',
  ucdLib: "VFEND 200MG INJ FL",
  UCD7: '9240125',
  UCD13: '3400892401256',
  ucdQtyMultiplicator: 1,
  cipLib: "VFEND 200MG INJ FL BT 1",
  atcCode: "J02AC03"
}, {
  CIP7: '3592886',
  CIP13: '3400935928863',
  ucdLib: "VFEND 50MG CPR",
  UCD7: '9240148',
  UCD13: '3400892401485',
  ucdQtyMultiplicator: 28,
  cipLib: "VFEND 50MG CPR BT 28",
  atcCode: "J02AC03"
}, {
  CIP7: '3592892',
  CIP13: '3400935928924',
  ucdLib: "VFEND 50MG CPR",
  UCD7: '9240148',
  UCD13: '3400892401485',
  ucdQtyMultiplicator: 56,
  cipLib: "VFEND 50MG CPR BT 56",
  atcCode: "J02AC03"
}, {
  CIP7: '3640616',
  CIP13: '3400936406162',
  ucdLib: "VFEND 40MG/ML BUV PDR FL45G",
  UCD7: '9261788',
  UCD13: '3400892617886',
  ucdQtyMultiplicator: 1,
  cipLib: "VFEND 40MG/ML BUV PDR FL45G BT 1",
  atcCode: "J02AC03"
}, {
  CIP7: '2747973',
  CIP13: '3400927479731',
  ucdLib: "VORICONAZOLE SDZ 200MG CPR",
  UCD7: '9418333',
  UCD13: '3400894183334',
  ucdQtyMultiplicator: 10,
  cipLib: "VORICONAZOLE SDZ 200MG CPR BT 10",
  atcCode: "J02AC03"
}, {
  CIP7: '2747996',
  CIP13: '3400927479960',
  ucdLib: "VORICONAZOLE SDZ 200MG CPR",
  UCD7: '9418333',
  UCD13: '3400894183334',
  ucdQtyMultiplicator: 100,
  cipLib: "VORICONAZOLE SDZ 200MG CPR BT 100",
  atcCode: "J02AC03"
}, {
  CIP7: '2747950',
  CIP13: '3400927479502',
  ucdLib: "VORICONAZOLE SDZ 50MG CPR",
  UCD7: '9418362',
  UCD13: '3400894183624',
  ucdQtyMultiplicator: 60,
  cipLib: "VORICONAZOLE SDZ 50MG CPR BT 60",
  atcCode: "J02AC03"
}, {
  CIP7: '2795564',
  CIP13: '3400927955648',
  ucdLib: "VORICONAZOLE MYL 200MG CPR",
  UCD7: '9419083',
  UCD13: '3400894190837',
  ucdQtyMultiplicator: 14,
  cipLib: "VORICONAZOLE MYL 200MG CPR BT 14",
  atcCode: "J02AC03"
}, {
  CIP7: '2795570',
  CIP13: '3400927955709',
  ucdLib: "VORICONAZOLE MYL 200MG CPR",
  UCD7: '9419083',
  UCD13: '3400894190837',
  ucdQtyMultiplicator: 28,
  cipLib: "VORICONAZOLE MYL 200MG CPR BT 28",
  atcCode: "J02AC03"
}, {
  CIP7: '2795601',
  CIP13: '3400927956010',
  ucdLib: "VORICONAZOLE MYL 200MG CPR",
  UCD7: '9419083',
  UCD13: '3400894190837',
  ucdQtyMultiplicator: 56,
  cipLib: "VORICONAZOLE MYL 200MG CPR BT 56",
  atcCode: "J02AC03"
}, {
  CIP7: '2795417',
  CIP13: '3400927954177',
  ucdLib: "VORICONAZOLE MYL 50MG CPR",
  UCD7: '9419114',
  UCD13: '3400894191148',
  ucdQtyMultiplicator: 28,
  cipLib: "VORICONAZOLE MYL 50MG CPR BT 28",
  atcCode: "J02AC03"
}, {
  CIP7: '2795452',
  CIP13: '3400927954528',
  ucdLib: "VORICONAZOLE MYL 50MG CPR",
  UCD7: '9419114',
  UCD13: '3400894191148',
  ucdQtyMultiplicator: 56,
  cipLib: "VORICONAZOLE MYL 50MG CPR BT 56",
  atcCode: "J02AC03"
}, {
  CIP7: '3450206',
  CIP13: '3400934502064',
  ucdLib: "SPORANOX 10MG/ML BUV FL150ML",
  UCD7: '9199859',
  UCD13: '3400891998597',
  ucdQtyMultiplicator: 1,
  cipLib: "SPORANOX 10MG/ML BUV FL150ML BT 1",
  atcCode: "J02AC02"
}, {
  CIP7: '3346288',
  CIP13: '3400933462888',
  ucdLib: "SPORANOX 100MG GELU",
  UCD7: '9157329',
  UCD13: '3400891573299',
  ucdQtyMultiplicator: 30,
  cipLib: "SPORANOX 100MG GELU BT 30",
  atcCode: "J02AC02"
}, {
  CIP7: '3672941',
  CIP13: '3400936729414',
  ucdLib: "ITRACONAZOLE SDZ 100MG GELU",
  UCD7: '9271605',
  UCD13: '3400892716053',
  ucdQtyMultiplicator: 30,
  cipLib: "ITRACONAZOLE SDZ 100MG GELU BT 30",
  atcCode: "J02AC02"
}, {
  CIP7: '3816802',
  CIP13: '3400938168020',
  ucdLib: "ITRACONAZOLE TVC 100MG GELU",
  UCD7: '9308202',
  UCD13: '3400893082027',
  ucdQtyMultiplicator: 30,
  cipLib: "ITRACONAZOLE TVC 100MG GELU BT 30",
  atcCode: "J02AC02"
}, {
  CIP7: '3773145',
  CIP13: '3400937731454',
  ucdLib: "ITRACONAZOLE MYL 100MG GELU",
  UCD7: '9291192',
  UCD13: '3400892911922',
  ucdQtyMultiplicator: 30,
  cipLib: "ITRACONAZOLE MYL 100MG GELU BT 30",
  atcCode: "J02AC02"
}, {
  CIP7: '3455741',
  CIP13: '3400934557415',
  ucdLib: "TRIFLUCAN 100MG GELU",
  UCD7: '9144315',
  UCD13: '3400891443158',
  ucdQtyMultiplicator: 7,
  cipLib: "TRIFLUCAN 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3455758',
  CIP13: '3400934557583',
  ucdLib: "TRIFLUCAN 200MG GELU",
  UCD7: '9144344',
  UCD13: '3400891443448',
  ucdQtyMultiplicator: 7,
  cipLib: "TRIFLUCAN 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3326593',
  CIP13: '3400933265939',
  ucdLib: "TRIFLUCAN 100MG GELU",
  UCD7: '9144315',
  UCD13: '3400891443158',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIFLUCAN 100MG GELU BT 60",
  atcCode: "J02AC01"
}, {
  CIP7: '3326587',
  CIP13: '3400933265878',
  ucdLib: "TRIFLUCAN 200MG GELU",
  UCD7: '9144344',
  UCD13: '3400891443448',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIFLUCAN 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3326624',
  CIP13: '3400933266240',
  ucdLib: "TRIFLUCAN 2MG/ML INJ FV100ML",
  UCD7: '9144321',
  UCD13: '3400891443219',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIFLUCAN 2MG/ML INJ FV100ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3326630',
  CIP13: '3400933266301',
  ucdLib: "TRIFLUCAN 2MG/ML INJ FV200ML",
  UCD7: '9226941',
  UCD13: '3400892269412',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIFLUCAN 2MG/ML INJ FV200ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3326618',
  CIP13: '3400933266189',
  ucdLib: "TRIFLUCAN 2MG/ML INJ FV50ML",
  UCD7: '9144338',
  UCD13: '3400891443387',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIFLUCAN 2MG/ML INJ FV50ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3305533',
  CIP13: '3400933055332',
  ucdLib: "FLUCONAZOLE PFZ 150MG GELU",
  UCD7: '9222162',
  UCD13: '3400892221625',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE PFZ 150MG GELU BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3305510',
  CIP13: '3400933055103',
  ucdLib: "TRIFLUCAN 50MG GELU",
  UCD7: '9130218',
  UCD13: '3400891302189',
  ucdQtyMultiplicator: 7,
  cipLib: "TRIFLUCAN 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '5561364',
  CIP13: '3400955613640',
  ucdLib: "TRIFLUCAN 50MG GELU",
  UCD7: '9130218',
  UCD13: '3400891302189',
  ucdQtyMultiplicator: 100,
  cipLib: "TRIFLUCAN 50MG GELU BT 100",
  atcCode: "J02AC01"
}, {
  CIP7: '3671686',
  CIP13: '3400936716865',
  ucdLib: "FLUCONAZOLE ARW 100MG GELU",
  UCD7: '9275922',
  UCD13: '3400892759227',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ARW 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3671775',
  CIP13: '3400936717756',
  ucdLib: "FLUCONAZOLE ARW 200MG GELU",
  UCD7: '9275939',
  UCD13: '3400892759395',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ARW 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3671781',
  CIP13: '3400936717817',
  ucdLib: "FLUCONAZOLE ARW 200MG GELU",
  UCD7: '9275939',
  UCD13: '3400892759395',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE ARW 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3671634',
  CIP13: '3400936716346',
  ucdLib: "FLUCONAZOLE ARW 50MG GELU",
  UCD7: '9275945',
  UCD13: '3400892759456',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ARW 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3354715',
  CIP13: '3400933547158',
  ucdLib: "TRIFLUCAN 200MG/5ML BUV FL",
  UCD7: '9243709',
  UCD13: '3400892437095',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIFLUCAN 200MG/5ML BUV FL BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3354709',
  CIP13: '3400933547097',
  ucdLib: "TRIFLUCAN 50MG/5ML BUV FL",
  UCD7: '9199291',
  UCD13: '3400891992915',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIFLUCAN 50MG/5ML BUV FL BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3628101',
  CIP13: '3400936281011',
  ucdLib: "BEAGYNE 150MG GELU",
  UCD7: '9328475',
  UCD13: '3400893284759',
  ucdQtyMultiplicator: 1,
  cipLib: "BEAGYNE 150MG GELU BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3628130',
  CIP13: '3400936281301',
  ucdLib: "FLUCONAZOLE ZEN 100MG GELU",
  UCD7: '9295698',
  UCD13: '3400892956985',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ZEN 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3627188',
  CIP13: '3400936271883',
  ucdLib: "FLUCONAZOLE ZEN 200MG GELU",
  UCD7: '9295706',
  UCD13: '3400892957067',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ZEN 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3628087',
  CIP13: '3400936280878',
  ucdLib: "FLUCONAZOLE ZEN 200MG GELU",
  UCD7: '9295706',
  UCD13: '3400892957067',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE ZEN 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3628176',
  CIP13: '3400936281769',
  ucdLib: "FLUCONAZOLE ZEN 50MG GELU",
  UCD7: '9295712',
  UCD13: '3400892957128',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ZEN 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3703245',
  CIP13: '3400937032452',
  ucdLib: "FLUCONAZOLE MYL 100MG GELU",
  UCD7: '9296172',
  UCD13: '3400892961729',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE MYL 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3703469',
  CIP13: '3400937034692',
  ucdLib: "FLUCONAZOLE MYL 200MG GELU",
  UCD7: '9296226',
  UCD13: '3400892962269',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE MYL 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3703498',
  CIP13: '3400937034982',
  ucdLib: "FLUCONAZOLE MYL 200MG GELU",
  UCD7: '9296226',
  UCD13: '3400892962269',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE MYL 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3703050',
  CIP13: '3400937030502',
  ucdLib: "FLUCONAZOLE MYL 50MG GELU",
  UCD7: '9296232',
  UCD13: '3400892962320',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE MYL 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3465917',
  CIP13: '3400934659171',
  ucdLib: "FLUCONAZOLE PFZ 100MG GELU",
  UCD7: '9328707',
  UCD13: '3400893287071',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE PFZ 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3465900',
  CIP13: '3400934659003',
  ucdLib: "FLUCONAZOLE PFZ 200MG GELU",
  UCD7: '9328713',
  UCD13: '3400893287132',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE PFZ 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3760131',
  CIP13: '3400937601313',
  ucdLib: "FLUCONAZOLE AGT2MG/ML 100ML",
  UCD7: '9286825',
  UCD13: '3400892868257',
  ucdQtyMultiplicator: 50,
  cipLib: "FLUCONAZOLE AGT2MG/ML 100ML BT 50",
  atcCode: "J02AC01"
}, {
  CIP7: '3760154',
  CIP13: '3400937601542',
  ucdLib: "FLUCONAZOLE AGT2MG/ML 200ML",
  UCD7: '9286831',
  UCD13: '3400892868318',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE AGT2MG/ML 200ML BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3760160',
  CIP13: '3400937601603',
  ucdLib: "FLUCONAZOLE AGT2MG/ML 200ML",
  UCD7: '9286831',
  UCD13: '3400892868318',
  ucdQtyMultiplicator: 20,
  cipLib: "FLUCONAZOLE AGT2MG/ML 200ML BT 20",
  atcCode: "J02AC01"
}, {
  CIP7: '3760059',
  CIP13: '3400937600590',
  ucdLib: "FLUCONAZOLE AGT2MG/ML 50ML",
  UCD7: '9286848',
  UCD13: '3400892868486',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE AGT2MG/ML 50ML BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3760088',
  CIP13: '3400937600880',
  ucdLib: "FLUCONAZOLE AGT2MG/ML 50ML",
  UCD7: '9286848',
  UCD13: '3400892868486',
  ucdQtyMultiplicator: 50,
  cipLib: "FLUCONAZOLE AGT2MG/ML 50ML BT 50",
  atcCode: "J02AC01"
}, {
  CIP7: '3669910',
  CIP13: '3400936699106',
  ucdLib: "FLUCONAZOLE BGA 100MG GELU",
  UCD7: '9277950',
  UCD13: '3400892779508',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE BGA 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3669962',
  CIP13: '3400936699625',
  ucdLib: "FLUCONAZOLE BGA 200MG GELU",
  UCD7: '9277967',
  UCD13: '3400892779676',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE BGA 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3669979',
  CIP13: '3400936699793',
  ucdLib: "FLUCONAZOLE BGA 200MG GELU",
  UCD7: '9277967',
  UCD13: '3400892779676',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE BGA 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3669873',
  CIP13: '3400936698734',
  ucdLib: "FLUCONAZOLE BGA 50MG GELU",
  UCD7: '9277973',
  UCD13: '3400892779737',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE BGA 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3386773',
  CIP13: '3400933867737',
  ucdLib: "FLUCONAZOLE PFZ 200MG GELU",
  UCD7: '9328713',
  UCD13: '3400893287132',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE PFZ 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3386796',
  CIP13: '3400933867966',
  ucdLib: "FLUCONAZOLE PFZ 50MG GELU",
  UCD7: '9328736',
  UCD13: '3400893287361',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE PFZ 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3386827',
  CIP13: '3400933868277',
  ucdLib: "FLUCONAZOLE PFZ 50MG/5ML BUV",
  UCD7: '9328742',
  UCD13: '3400893287422',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE PFZ 50MG/5ML BUV BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3665237',
  CIP13: '3400936652378',
  ucdLib: "FLUCONAZOLE TVC 100MG GELU",
  UCD7: '9267785',
  UCD13: '3400892677859',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE TVC 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3665214',
  CIP13: '3400936652149',
  ucdLib: "FLUCONAZOLE TVC 200MG GELU",
  UCD7: '9267791',
  UCD13: '3400892677910',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE TVC 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3665220',
  CIP13: '3400936652200',
  ucdLib: "FLUCONAZOLE TVC 200MG GELU",
  UCD7: '9267791',
  UCD13: '3400892677910',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE TVC 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3665266',
  CIP13: '3400936652668',
  ucdLib: "FLUCONAZOLE TVC 50MG GELU",
  UCD7: '9267816',
  UCD13: '3400892678160',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE TVC 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3819321',
  CIP13: '3400938193213',
  ucdLib: "FLUCONAZOLE TVC 50MG/5ML BUV",
  UCD7: '9307616',
  UCD13: '3400893076163',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE TVC 50MG/5ML BUV BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3817144',
  CIP13: '3400938171440',
  ucdLib: "FLUCONAZOLE TVC2MG/ML FL50ML",
  UCD7: '9309035',
  UCD13: '3400893090350',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE TVC2MG/ML FL50ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3780760',
  CIP13: '3400937807609',
  ucdLib: "FLUCONAZOLE ARW 50MG/5ML BUV",
  UCD7: '9297711',
  UCD13: '3400892977119',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE ARW 50MG/5ML BUV BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3780731',
  CIP13: '3400937807319',
  ucdLib: "FLUCONAZOLE BGA 50MG/5ML BUV",
  UCD7: '9297728',
  UCD13: '3400892977287',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE BGA 50MG/5ML BUV BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3778384',
  CIP13: '3400937783842',
  ucdLib: "FLUCONAZOLE EG 100MG GELU",
  UCD7: '9297734',
  UCD13: '3400892977348',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE EG 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3778409',
  CIP13: '3400937784092',
  ucdLib: "FLUCONAZOLE EG 200MG GELU",
  UCD7: '9297740',
  UCD13: '3400892977409',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE EG 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3778415',
  CIP13: '3400937784153',
  ucdLib: "FLUCONAZOLE EG 200MG GELU",
  UCD7: '9297740',
  UCD13: '3400892977409',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE EG 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3778361',
  CIP13: '3400937783613',
  ucdLib: "FLUCONAZOLE EG 50MG GELU",
  UCD7: '9297757',
  UCD13: '3400892977577',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE EG 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3781446',
  CIP13: '3400937814461',
  ucdLib: "FLUCONAZOLE EG 50MG/5ML BUV",
  UCD7: '9297763',
  UCD13: '3400892977638',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE EG 50MG/5ML BUV BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3780961',
  CIP13: '3400937809610',
  ucdLib: "FLUCONAZOLE MYL 50MG/5ML BUV",
  UCD7: '9296249',
  UCD13: '3400892962498',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE MYL 50MG/5ML BUV BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3780694',
  CIP13: '3400937806947',
  ucdLib: "FLUCONAZOLE SDZ 100MG GELU",
  UCD7: '9298656',
  UCD13: '3400892986562',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE SDZ 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3780702',
  CIP13: '3400937807029',
  ucdLib: "FLUCONAZOLE SDZ 150MG GELU",
  UCD7: '9299779',
  UCD13: '3400892997797',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE SDZ 150MG GELU BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3780719',
  CIP13: '3400937807197',
  ucdLib: "FLUCONAZOLE SDZ 200MG GELU",
  UCD7: '9272912',
  UCD13: '3400892729121',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE SDZ 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3780725',
  CIP13: '3400937807258',
  ucdLib: "FLUCONAZOLE SDZ 200MG GELU",
  UCD7: '9272912',
  UCD13: '3400892729121',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE SDZ 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3780688',
  CIP13: '3400937806886',
  ucdLib: "FLUCONAZOLE SDZ 50MG GELU",
  UCD7: '9298662',
  UCD13: '3400892986623',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE SDZ 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3780978',
  CIP13: '3400937809788',
  ucdLib: "FLUCONAZOLE SDZ 50MG/5ML BUV",
  UCD7: '9297533',
  UCD13: '3400892975337',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE SDZ 50MG/5ML BUV BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3781452',
  CIP13: '3400937814522',
  ucdLib: "FLUCONAZOLE ZEN 50MG/5ML BUV",
  UCD7: '9303417',
  UCD13: '3400893034170',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE ZEN 50MG/5ML BUV BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '3793716',
  CIP13: '3400937937160',
  ucdLib: "FLUCONAZOLE ZYD 100MG GELU",
  UCD7: '9301737',
  UCD13: '3400893017371',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ZYD 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3793745',
  CIP13: '3400937937450',
  ucdLib: "FLUCONAZOLE ZYD 200MG GELU",
  UCD7: '9301743',
  UCD13: '3400893017432',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ZYD 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3793751',
  CIP13: '3400937937511',
  ucdLib: "FLUCONAZOLE ZYD 200MG GELU",
  UCD7: '9301743',
  UCD13: '3400893017432',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE ZYD 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3793685',
  CIP13: '3400937936859',
  ucdLib: "FLUCONAZOLE ZYD 50MG GELU",
  UCD7: '9301766',
  UCD13: '3400893017661',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ZYD 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3871327',
  CIP13: '3400938713275',
  ucdLib: "FLUCONAZOLE KBI2MG/ML F100ML",
  UCD7: '9353059',
  UCD13: '3400893530597',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE KBI2MG/ML F100ML BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3871468',
  CIP13: '3400938714685',
  ucdLib: "FLUCONAZOLE KBI2MG/ML F200ML",
  UCD7: '9353065',
  UCD13: '3400893530658',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE KBI2MG/ML F200ML BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3871178',
  CIP13: '3400938711783',
  ucdLib: "FLUCONAZOLE KBI2MG/ML FL50ML",
  UCD7: '9353071',
  UCD13: '3400893530719',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE KBI2MG/ML FL50ML BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3807453',
  CIP13: '3400938074536',
  ucdLib: "FLUCONAZOLE RBG2MG/ML P.50ML",
  UCD7: '9303400',
  UCD13: '3400893034002',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE RBG2MG/ML P.50ML BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3807482',
  CIP13: '3400938074826',
  ucdLib: "FLUCONAZOLE RBG2MG/ML P100ML",
  UCD7: '9303386',
  UCD13: '3400893033869',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE RBG2MG/ML P100ML BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3895598',
  CIP13: '3400938955989',
  ucdLib: "FLUCONAZOLE ACT 50MG GELU",
  UCD7: '9324394',
  UCD13: '3400893243947',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE ACT 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3843696',
  CIP13: '3400938436969',
  ucdLib: "FLUCONAZOLE AGT2MG/ML 50ML+M",
  UCD7: '9313315',
  UCD13: '3400893133156',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE AGT2MG/ML 50ML+M BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3843756',
  CIP13: '3400938437560',
  ucdLib: "FLUCONAZOLE AGT2MG/ML100ML+M",
  UCD7: '9313290',
  UCD13: '3400893132906',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE AGT2MG/ML100ML+M BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3843816',
  CIP13: '3400938438161',
  ucdLib: "FLUCONAZOLE AGT2MG/ML200ML+M",
  UCD7: '9313309',
  UCD13: '3400893133095',
  ucdQtyMultiplicator: 10,
  cipLib: "FLUCONAZOLE AGT2MG/ML200ML+M BT 10",
  atcCode: "J02AC01"
}, {
  CIP7: '3952669',
  CIP13: '3400939526690',
  ucdLib: "FLUCONAZOLE CRT 100MG GELU",
  UCD7: '9338976',
  UCD13: '3400893389768',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE CRT 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3952681',
  CIP13: '3400939526812',
  ucdLib: "FLUCONAZOLE CRT 200MG GELU",
  UCD7: '9338982',
  UCD13: '3400893389829',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE CRT 200MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3952698',
  CIP13: '3400939526980',
  ucdLib: "FLUCONAZOLE CRT 200MG GELU",
  UCD7: '9338982',
  UCD13: '3400893389829',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE CRT 200MG GELU BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '3952646',
  CIP13: '3400939526461',
  ucdLib: "FLUCONAZOLE CRT 50MG GELU",
  UCD7: '9338999',
  UCD13: '3400893389997',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE CRT 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3895523',
  CIP13: '3400938955231',
  ucdLib: "FLUCONAZOLE EVO 100MG GELU",
  UCD7: '9330124',
  UCD13: '3400893301241',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE EVO 100MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3895492',
  CIP13: '3400938954920',
  ucdLib: "FLUCONAZOLE EVO 50MG GELU",
  UCD7: '9327777',
  UCD13: '3400893277775',
  ucdQtyMultiplicator: 7,
  cipLib: "FLUCONAZOLE EVO 50MG GELU BT 7",
  atcCode: "J02AC01"
}, {
  CIP7: '3951730',
  CIP13: '3400939517308',
  ucdLib: "OROFLUCO 150MG GELU",
  UCD7: '9342038',
  UCD13: '3400893420386',
  ucdQtyMultiplicator: 1,
  cipLib: "OROFLUCO 150MG GELU BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '5724257',
  CIP13: '3400957242572',
  ucdLib: "FLUCONAZOLE MAC2MG/ML 100ML",
  UCD7: '9311500',
  UCD13: '3400893115008',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE MAC2MG/ML 100ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '5724317',
  CIP13: '3400957243173',
  ucdLib: "FLUCONAZOLE MAC2MG/ML 200ML",
  UCD7: '9311517',
  UCD13: '3400893115176',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE MAC2MG/ML 200ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '5724205',
  CIP13: '3400957242053',
  ucdLib: "FLUCONAZOLE MAC2MG/ML 50ML",
  UCD7: '9311523',
  UCD13: '3400893115237',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUCONAZOLE MAC2MG/ML 50ML BT 1",
  atcCode: "J02AC01"
}, {
  CIP7: '5723890',
  CIP13: '3400957238902',
  ucdLib: "FLUCONAZOLE MYL2MG/ML P.50ML",
  UCD7: '9312965',
  UCD13: '3400893129654',
  ucdQtyMultiplicator: 20,
  cipLib: "FLUCONAZOLE MYL2MG/ML P.50ML BT 20",
  atcCode: "J02AC01"
}, {
  CIP7: '5741787',
  CIP13: '3400957417871',
  ucdLib: "FLUCONAZOLE MYL2MG/ML P100ML",
  UCD7: '9312942',
  UCD13: '3400893129425',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUCONAZOLE MYL2MG/ML P100ML BT 30",
  atcCode: "J02AC01"
}, {
  CIP7: '5741793',
  CIP13: '3400957417932',
  ucdLib: "FLUCONAZOLE MYL2MG/ML P200ML",
  UCD7: '9312959',
  UCD13: '3400893129593',
  ucdQtyMultiplicator: 15,
  cipLib: "FLUCONAZOLE MYL2MG/ML P200ML BT 15",
  atcCode: "J02AC01"
}, {
  CIP7: '5605446',
  CIP13: '3400956054466',
  ucdLib: "ABELCET 5MG/ML PERF FL20ML",
  UCD7: '9196246',
  UCD13: '3400891962468',
  ucdQtyMultiplicator: 10,
  cipLib: "ABELCET 5MG/ML PERF FL20ML BT 10",
  atcCode: "J02AA01"
}, {
  CIP7: '5603329',
  CIP13: '3400956033294',
  ucdLib: "FUNGIZONE 50MG INJ FL",
  UCD7: '9036689',
  UCD13: '3400890366892',
  ucdQtyMultiplicator: 1,
  cipLib: "FUNGIZONE 50MG INJ FL BT 1",
  atcCode: "J02AA01"
}, {
  CIP7: '5624082',
  CIP13: '3400956240821',
  ucdLib: "AMBISOME 50MG PERF FL15ML",
  UCD7: '9218261',
  UCD13: '3400892182612',
  ucdQtyMultiplicator: 10,
  cipLib: "AMBISOME 50MG PERF FL15ML BT 10",
  atcCode: "J02AA01"
}, {
  CIP7: '3001114',
  CIP13: '3400930011140',
  ucdLib: "SIVEXTRO 200MG CPR PELL",
  UCD7: '9408197',
  UCD13: '3400894081975',
  ucdQtyMultiplicator: 6,
  cipLib: "SIVEXTRO 200MG CPR PELL BT 6",
  atcCode: "J01XX11"
}, {
  CIP7: '3001116',
  CIP13: '3400930011164',
  ucdLib: "SIVEXTRO 200MG PERF FL",
  UCD7: '9408205',
  UCD13: '3400894082057',
  ucdQtyMultiplicator: 6,
  cipLib: "SIVEXTRO 200MG PERF FL BT 6",
  atcCode: "J01XX11"
}, {
  CIP7: '5672193',
  CIP13: '3400956721931',
  ucdLib: "CUBICIN 350MG PERF FL",
  UCD7: '9285062',
  UCD13: '3400892850627',
  ucdQtyMultiplicator: 1,
  cipLib: "CUBICIN 350MG PERF FL BT 1",
  atcCode: "J01XX09"
}, {
  CIP7: '5672201',
  CIP13: '3400956722013',
  ucdLib: "CUBICIN 500MG PERF FL",
  UCD7: '9285079',
  UCD13: '3400892850795',
  ucdQtyMultiplicator: 1,
  cipLib: "CUBICIN 500MG PERF FL BT 1",
  atcCode: "J01XX09"
}, {
  CIP7: '3006127',
  CIP13: '3400930061275',
  ucdLib: "LINEZOLIDE ARW 600MG CPR",
  UCD7: '9417977',
  UCD13: '3400894179771',
  ucdQtyMultiplicator: 10,
  cipLib: "LINEZOLIDE ARW 600MG CPR BT 10",
  atcCode: "J01XX08"
}, {
  CIP7: '5500487',
  CIP13: '3400955004875',
  ucdLib: "LINEZOLIDE KBI 600MG CPR",
  UCD7: '9411940',
  UCD13: '3400894119401',
  ucdQtyMultiplicator: 10,
  cipLib: "LINEZOLIDE KBI 600MG CPR BT 10",
  atcCode: "J01XX08"
}, {
  CIP7: '5500909',
  CIP13: '3400955009092',
  ucdLib: "LINEZOLIDE KBI2MG/ML FP300ML",
  UCD7: '9412075',
  UCD13: '3400894120759',
  ucdQtyMultiplicator: 10,
  cipLib: "LINEZOLIDE KBI2MG/ML FP300ML BT 10",
  atcCode: "J01XX08"
}, {
  CIP7: '5500271',
  CIP13: '3400955002710',
  ucdLib: "LINEZOLIDE OHR 600MG CPR",
  UCD7: '9416647',
  UCD13: '3400894166474',
  ucdQtyMultiplicator: 10,
  cipLib: "LINEZOLIDE OHR 600MG CPR BT 10",
  atcCode: "J01XX08"
}, {
  CIP7: '5500653',
  CIP13: '3400955006534',
  ucdLib: "LINEZOLIDE PAN 2MG/ML P300ML",
  UCD7: '9413241',
  UCD13: '3400894132417',
  ucdQtyMultiplicator: 10,
  cipLib: "LINEZOLIDE PAN 2MG/ML P300ML BT 10",
  atcCode: "J01XX08"
}, {
  CIP7: '5631395',
  CIP13: '3400956313952',
  ucdLib: "ZYVOXID 600MG CPR",
  UCD7: '9233533',
  UCD13: '3400892335339',
  ucdQtyMultiplicator: 10,
  cipLib: "ZYVOXID 600MG CPR BT 10",
  atcCode: "J01XX08"
}, {
  CIP7: '2794033',
  CIP13: '3400927940330',
  ucdLib: "LINEZOLIDE SDZ 600MG CPR",
  UCD7: '9412388',
  UCD13: '3400894123880',
  ucdQtyMultiplicator: 10,
  cipLib: "LINEZOLIDE SDZ 600MG CPR BT 10",
  atcCode: "J01XX08"
}, {
  CIP7: '5811074',
  CIP13: '3400958110740',
  ucdLib: "ZYVOXID 2MG/ML INJ PFX300ML",
  UCD7: '9386946',
  UCD13: '3400893869468',
  ucdQtyMultiplicator: 10,
  cipLib: "ZYVOXID 2MG/ML INJ PFX300ML BT 10",
  atcCode: "J01XX08"
}, {
  CIP7: '5651268',
  CIP13: '3400956512683',
  ucdLib: "ZYVOXID 100MG/5ML BUV FL",
  UCD7: '9251399',
  UCD13: '3400892513997',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYVOXID 100MG/5ML BUV FL BT 1",
  atcCode: "J01XX08"
}, {
  CIP7: '3320923',
  CIP13: '3400933209230',
  ucdLib: "MONURIL 3G BUV GLE SACH",
  UCD7: '9143505',
  UCD13: '3400891435054',
  ucdQtyMultiplicator: 1,
  cipLib: "MONURIL 3G BUV GLE SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3328238',
  CIP13: '3400933282387',
  ucdLib: "URIDOZ 3G AD. GLE BUV SACH",
  UCD7: '9146567',
  UCD13: '3400891465679',
  ucdQtyMultiplicator: 1,
  cipLib: "URIDOZ 3G AD. GLE BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '4987931',
  CIP13: '3400949879311',
  ucdLib: "FOSFOMYCINE EVO 3G BUV SACH",
  UCD7: '9371353',
  UCD13: '3400893713532',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE EVO 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '4987925',
  CIP13: '3400949879250',
  ucdLib: "FOSFOPHARM 3G AD. BUV SACH",
  UCD7: '9371258',
  UCD13: '3400893712580',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOPHARM 3G AD. BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3941826',
  CIP13: '3400939418261',
  ucdLib: "FOSFOMYCINE ARW 3G BUV SACH",
  UCD7: '9333105',
  UCD13: '3400893331057',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE ARW 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3942352',
  CIP13: '3400939423524',
  ucdLib: "FOSFOMYCINE BGA 3G BUV SACH",
  UCD7: '9335682',
  UCD13: '3400893356821',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE BGA 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3946350',
  CIP13: '3400939463506',
  ucdLib: "FOSFOMYCINE CRT 3G BUV SACH",
  UCD7: '9339711',
  UCD13: '3400893397114',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE CRT 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3942369',
  CIP13: '3400939423692',
  ucdLib: "FOSFOMYCINE EG 3G BUV SACH",
  UCD7: '9335707',
  UCD13: '3400893357071',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE EG 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3942381',
  CIP13: '3400939423814',
  ucdLib: "FOSFOMYCINE MYP 3G BUV SACH",
  UCD7: '9335699',
  UCD13: '3400893356999',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE MYP 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3988911',
  CIP13: '3400939889115',
  ucdLib: "FOSFOMYCINE RBX 3G BUV SACH",
  UCD7: '9346622',
  UCD13: '3400893466223',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE RBX 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3988905',
  CIP13: '3400939889054',
  ucdLib: "FOSFOMYCINE SDZ 3G BUV SACH",
  UCD7: '9343598',
  UCD13: '3400893435984',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE SDZ 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3988940',
  CIP13: '3400939889405',
  ucdLib: "FOSFOMYCINE TVS 3G BUV SACH",
  UCD7: '9345344',
  UCD13: '3400893453445',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE TVS 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '3988934',
  CIP13: '3400939889344',
  ucdLib: "FOSFOMYCINE ZEN 3G BUV SACH",
  UCD7: '9345539',
  UCD13: '3400893455395',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOMYCINE ZEN 3G BUV SACH BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '4900052',
  CIP13: '3400949000524',
  ucdLib: "MONURIL 3G BUV SACH AIPMWI ES",
  UCD7: '9413318',
  UCD13: '3400894133186',
  ucdQtyMultiplicator: 1,
  cipLib: "MONURIL 3G BUV SACH AIPMWI ES BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '4900686',
  CIP13: '3400949006861',
  ucdLib: "MONURIL 3G BUV SACH AIPMWI PT",
  UCD7: '9360272',
  UCD13: '3400893602720',
  ucdQtyMultiplicator: 1,
  cipLib: "MONURIL 3G BUV SACH AIPMWI PT BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '4900350',
  CIP13: '3400949003501',
  ucdLib: "MONURIL 3G BUV SACH AIPPLA PT",
  UCD7: '9352953',
  UCD13: '3400893529539',
  ucdQtyMultiplicator: 1,
  cipLib: "MONURIL 3G BUV SACH AIPPLA PT BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '2179115',
  CIP13: '3400921791150',
  ucdLib: "FOSFOCINE 1G INJ FL",
  UCD7: '9406034',
  UCD13: '3400894060345',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOCINE 1G INJ FL BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '2179121',
  CIP13: '3400921791211',
  ucdLib: "FOSFOCINE 4G INJ FL",
  UCD7: '9406040',
  UCD13: '3400894060406',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSFOCINE 4G INJ FL BT 1",
  atcCode: "J01XX01"
}, {
  CIP7: '5536863',
  CIP13: '3400955368632',
  ucdLib: "FURADANTINE 50MG GELU",
  UCD7: '9036790',
  UCD13: '3400890367905',
  ucdQtyMultiplicator: 100,
  cipLib: "FURADANTINE 50MG GELU BT 100",
  atcCode: "J01XE01"
}, {
  CIP7: '3296449',
  CIP13: '3400932964499',
  ucdLib: "FURADANTINE 50MG GELU",
  UCD7: '9036790',
  UCD13: '3400890367905',
  ucdQtyMultiplicator: 21,
  cipLib: "FURADANTINE 50MG GELU BT 21",
  atcCode: "J01XE01"
}, {
  CIP7: '3277860',
  CIP13: '3400932778607',
  ucdLib: "TIBERAL 500MG CPR",
  UCD7: '9093061',
  UCD13: '3400890930611',
  ucdQtyMultiplicator: 10,
  cipLib: "TIBERAL 500MG CPR BT 10",
  atcCode: "J01XD03"
}, {
  CIP7: '5557115',
  CIP13: '3400955571155',
  ucdLib: "TIBERAL 500MG INJ AMP3ML",
  UCD7: '9093055',
  UCD13: '3400890930550',
  ucdQtyMultiplicator: 12,
  cipLib: "TIBERAL 500MG INJ AMP3ML BT 12",
  atcCode: "J01XD03"
}, {
  CIP7: '5571670',
  CIP13: '3400955716709',
  ucdLib: "TIBERAL 1G INJ AMP6ML",
  UCD7: '9118453',
  UCD13: '3400891184532',
  ucdQtyMultiplicator: 12,
  cipLib: "TIBERAL 1G INJ AMP6ML BT 12",
  atcCode: "J01XD03"
}, {
  CIP7: '3179382',
  CIP13: '3400931793823',
  ucdLib: "FASIGYNE 500MG CPR ENROB",
  UCD7: '9034420',
  UCD13: '3400890344203',
  ucdQtyMultiplicator: 4,
  cipLib: "FASIGYNE 500MG CPR ENROB BT 4",
  atcCode: "J01XD02"
}, {
  CIP7: '3040000',
  CIP13: '3400930400005',
  ucdLib: "FLAGYL 250MG CPR",
  UCD7: '9035098',
  UCD13: '3400890350983',
  ucdQtyMultiplicator: 20,
  cipLib: "FLAGYL 250MG CPR BT 20",
  atcCode: "J01XD01"
}, {
  CIP7: '3311551',
  CIP13: '3400933115517',
  ucdLib: "FLAGYL 500MG CPR",
  UCD7: '9137060',
  UCD13: '3400891370607',
  ucdQtyMultiplicator: 4,
  cipLib: "FLAGYL 500MG CPR BT 4",
  atcCode: "J01XD01"
}, {
  CIP7: '3311568',
  CIP13: '3400933115685',
  ucdLib: "FLAGYL 500MG CPR",
  UCD7: '9137060',
  UCD13: '3400891370607',
  ucdQtyMultiplicator: 14,
  cipLib: "FLAGYL 500MG CPR BT 14",
  atcCode: "J01XD01"
}, {
  CIP7: '5567800',
  CIP13: '3400955678007',
  ucdLib: "FLAGYL 0,5% INJ POC100ML",
  UCD7: '9117413',
  UCD13: '3400891174137',
  ucdQtyMultiplicator: 25,
  cipLib: "FLAGYL 0,5% INJ POC100ML BT 25",
  atcCode: "J01XD01"
}, {
  CIP7: '5586625',
  CIP13: '3400955866251',
  ucdLib: "METRONIDAZOLE BAX0,5% P100ML",
  UCD7: '9174322',
  UCD13: '3400891743227',
  ucdQtyMultiplicator: 50,
  cipLib: "METRONIDAZOLE BAX0,5% P100ML BT 50",
  atcCode: "J01XD01"
}, {
  CIP7: '3131694',
  CIP13: '3400931316947',
  ucdLib: "FLAGYL 4% BUV FL120ML",
  UCD7: '9035129',
  UCD13: '3400890351294',
  ucdQtyMultiplicator: 1,
  cipLib: "FLAGYL 4% BUV FL120ML BT 1",
  atcCode: "J01XD01"
}, {
  CIP7: '3466265',
  CIP13: '3400934662652',
  ucdLib: "METRONIDAZOLE BBM0,5% P100ML",
  UCD7: '9201390',
  UCD13: '3400892013909',
  ucdQtyMultiplicator: 1,
  cipLib: "METRONIDAZOLE BBM0,5% P100ML BT 1",
  atcCode: "J01XD01"
}, {
  CIP7: '5612498',
  CIP13: '3400956124985',
  ucdLib: "METRONIDAZOLE BBM0,5% P200ML",
  UCD7: '9209807',
  UCD13: '3400892098074',
  ucdQtyMultiplicator: 20,
  cipLib: "METRONIDAZOLE BBM0,5% P200ML BT 20",
  atcCode: "J01XD01"
}, {
  CIP7: '5615746',
  CIP13: '3400956157464',
  ucdLib: "METRONIDAZOLE LAV0,5% F100ML",
  UCD7: '9203911',
  UCD13: '3400892039114',
  ucdQtyMultiplicator: 1,
  cipLib: "METRONIDAZOLE LAV0,5% F100ML BT 1",
  atcCode: "J01XD01"
}, {
  CIP7: '3322715',
  CIP13: '3400933227159',
  ucdLib: "FUCIDINE 100MG/2ML BUV FV50ML",
  UCD7: '9144025',
  UCD13: '3400891440256',
  ucdQtyMultiplicator: 1,
  cipLib: "FUCIDINE 100MG/2ML BUV FV50ML BT 1",
  atcCode: "J01XC01"
}, {
  CIP7: '3322721',
  CIP13: '3400933227210',
  ucdLib: "FUCIDINE 250MG/5ML BUV FV90ML",
  UCD7: '9144019',
  UCD13: '3400891440195',
  ucdQtyMultiplicator: 1,
  cipLib: "FUCIDINE 250MG/5ML BUV FV90ML BT 1",
  atcCode: "J01XC01"
}, {
  CIP7: '3676637',
  CIP13: '3400936766372',
  ucdLib: "FUCIDINE 250MG CPR",
  UCD7: '9036502',
  UCD13: '3400890365024',
  ucdQtyMultiplicator: 10,
  cipLib: "FUCIDINE 250MG CPR BT 10",
  atcCode: "J01XC01"
}, {
  CIP7: '5517707',
  CIP13: '3400955177074',
  ucdLib: "COLIMYCINE 1MN INJ FL",
  UCD7: '9020978',
  UCD13: '3400890209786',
  ucdQtyMultiplicator: 50,
  cipLib: "COLIMYCINE 1MN INJ FL BT 50",
  atcCode: "J01XB01"
}, {
  CIP7: '3650589',
  CIP13: '3400936505896',
  ucdLib: "COLIMYCINE 1MN NEB FL+AMP",
  UCD7: '9294285',
  UCD13: '3400892942858',
  ucdQtyMultiplicator: 1,
  cipLib: "COLIMYCINE 1MN NEB FL+AMP BT 1",
  atcCode: "J01XB01"
}, {
  CIP7: '3804696',
  CIP13: '3400938046960',
  ucdLib: "COLIMYCINE 1MN NEB FL+AMP",
  UCD7: '9294285',
  UCD13: '3400892942858',
  ucdQtyMultiplicator: 30,
  cipLib: "COLIMYCINE 1MN NEB FL+AMP BT 30",
  atcCode: "J01XB01"
}, {
  CIP7: '3871132',
  CIP13: '3400938711325',
  ucdLib: "TADIM 1MUI PDR INHAL FV",
  UCD7: '9414921',
  UCD13: '3400894149217',
  ucdQtyMultiplicator: 30,
  cipLib: "TADIM 1MUI PDR INHAL FV BT 30",
  atcCode: "J01XB01"
}, {
  CIP7: '2756943',
  CIP13: '3400927569432',
  ucdLib: "COLOBREATHE 1662500UI GELU",
  UCD7: '9406005',
  UCD13: '3400894060055',
  ucdQtyMultiplicator: 56,
  cipLib: "COLOBREATHE 1662500UI GELU BT 56",
  atcCode: "J01XB01"
}, {
  CIP7: '5560548',
  CIP13: '3400955605485',
  ucdLib: "TARGOCID 100MG INJ FL+AMP",
  UCD7: '9125157',
  UCD13: '3400891251579',
  ucdQtyMultiplicator: 1,
  cipLib: "TARGOCID 100MG INJ FL+AMP BT 1",
  atcCode: "J01XA02"
}, {
  CIP7: '5560554',
  CIP13: '3400955605546',
  ucdLib: "TARGOCID 200MG INJ FL+AMP",
  UCD7: '9125163',
  UCD13: '3400891251630',
  ucdQtyMultiplicator: 1,
  cipLib: "TARGOCID 200MG INJ FL+AMP BT 1",
  atcCode: "J01XA02"
}, {
  CIP7: '5560531',
  CIP13: '3400955605317',
  ucdLib: "TARGOCID 400MG INJ FL+AMP",
  UCD7: '9125186',
  UCD13: '3400891251869',
  ucdQtyMultiplicator: 1,
  cipLib: "TARGOCID 400MG INJ FL+AMP BT 1",
  atcCode: "J01XA02"
}, {
  CIP7: '5625845',
  CIP13: '3400956258451',
  ucdLib: "VANCOMYCINE MYL 125MG INJ FL",
  UCD7: '9226970',
  UCD13: '3400892269702',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE MYL 125MG INJ FL BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5625986',
  CIP13: '3400956259861',
  ucdLib: "VANCOMYCINE MYL 1G INJ FL",
  UCD7: '9195732',
  UCD13: '3400891957327',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE MYL 1G INJ FL BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5625928',
  CIP13: '3400956259281',
  ucdLib: "VANCOMYCINE MYL 250MG INJ FL",
  UCD7: '9226987',
  UCD13: '3400892269870',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE MYL 250MG INJ FL BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5625957',
  CIP13: '3400956259571',
  ucdLib: "VANCOMYCINE MYL 500MG INJ FL",
  UCD7: '9195749',
  UCD13: '3400891957495',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE MYL 500MG INJ FL BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5637831',
  CIP13: '3400956378319',
  ucdLib: "VANCOMYCINE KBI 1G INJ FL",
  UCD7: '9264433',
  UCD13: '3400892644332',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE KBI 1G INJ FL BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5637825',
  CIP13: '3400956378258',
  ucdLib: "VANCOMYCINE KBI 500MG INJ FL",
  UCD7: '9264456',
  UCD13: '3400892644561',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE KBI 500MG INJ FL BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5661315',
  CIP13: '3400956613151',
  ucdLib: "VANCOMYCINE SDZ 125MG IV FV",
  UCD7: '9270617',
  UCD13: '3400892706177',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE SDZ 125MG IV FV BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5661404',
  CIP13: '3400956614042',
  ucdLib: "VANCOMYCINE SDZ 1G IV FV20ML",
  UCD7: '9272680',
  UCD13: '3400892726809',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE SDZ 1G IV FV20ML BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5661321',
  CIP13: '3400956613212',
  ucdLib: "VANCOMYCINE SDZ 250MG IV FV",
  UCD7: '9270623',
  UCD13: '3400892706238',
  ucdQtyMultiplicator: 1,
  cipLib: "VANCOMYCINE SDZ 250MG IV FV BT 1",
  atcCode: "J01XA01"
}, {
  CIP7: '5661338',
  CIP13: '3400956613380',
  ucdLib: "VANCOMYCINE SDZ 500MG IV FV",
  UCD7: '9270646',
  UCD13: '3400892706467',
  ucdQtyMultiplicator: 10,
  cipLib: "VANCOMYCINE SDZ 500MG IV FV BT 10",
  atcCode: "J01XA01"
}, {
  CIP7: '3074772',
  CIP13: '3400930747728',
  ucdLib: "RODOGYL CPR",
  UCD7: '9081069',
  UCD13: '3400890810692',
  ucdQtyMultiplicator: 20,
  cipLib: "RODOGYL CPR BT 20",
  atcCode: "J01RA04"
}, {
  CIP7: '3670528',
  CIP13: '3400936705289',
  ucdLib: "SPIRAMYCINE/MET.BGA 125MG C.",
  UCD7: '9273627',
  UCD13: '3400892736273',
  ucdQtyMultiplicator: 20,
  cipLib: "SPIRAMYCINE/MET.BGA 125MG C. BT 20",
  atcCode: "J01RA04"
}, {
  CIP7: '3671396',
  CIP13: '3400936713963',
  ucdLib: "SPIRAMYCINE/MET.BGA 250MG C.",
  UCD7: '9273610',
  UCD13: '3400892736105',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.BGA 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3671427',
  CIP13: '3400936714274',
  ucdLib: "SPIRAMYCINE/MET.MYL 250MG C.",
  UCD7: '9274561',
  UCD13: '3400892745619',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.MYL 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3671350',
  CIP13: '3400936713505',
  ucdLib: "SPIRAMYCINE/MET.SDZ 250MG C.",
  UCD7: '9273633',
  UCD13: '3400892736334',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.SDZ 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3670534',
  CIP13: '3400936705340',
  ucdLib: "SPIRAMYCINE/MET.TVC 125MG C.",
  UCD7: '9273679',
  UCD13: '3400892736792',
  ucdQtyMultiplicator: 20,
  cipLib: "SPIRAMYCINE/MET.TVC 125MG C. BT 20",
  atcCode: "J01RA04"
}, {
  CIP7: '3671462',
  CIP13: '3400936714625',
  ucdLib: "SPIRAMYCINE/MET.TVC 250MG C.",
  UCD7: '9273662',
  UCD13: '3400892736624',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.TVC 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3554727',
  CIP13: '3400935547279',
  ucdLib: "SPIRAMYCINE/MET.ZEN 250MG C.",
  UCD7: '9273001',
  UCD13: '3400892730011',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.ZEN 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3482815',
  CIP13: '3400934828157',
  ucdLib: "BIRODOGYL CPR",
  UCD7: '9209204',
  UCD13: '3400892092041',
  ucdQtyMultiplicator: 10,
  cipLib: "BIRODOGYL CPR BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3711026',
  CIP13: '3400937110266',
  ucdLib: "BI-MISSILOR 1,5MUI/250MG CPR",
  UCD7: '9283324',
  UCD13: '3400892833248',
  ucdQtyMultiplicator: 10,
  cipLib: "BI-MISSILOR 1,5MUI/250MG CPR BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3710819',
  CIP13: '3400937108195',
  ucdLib: "SPIRAMYCINE/MET.ARW 125MG C.",
  UCD7: '9283258',
  UCD13: '3400892832586',
  ucdQtyMultiplicator: 20,
  cipLib: "SPIRAMYCINE/MET.ARW 125MG C. BT 20",
  atcCode: "J01RA04"
}, {
  CIP7: '3710765',
  CIP13: '3400937107655',
  ucdLib: "SPIRAMYCINE/MET.ARW 250MG C.",
  UCD7: '9282891',
  UCD13: '3400892828916',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.ARW 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3711569',
  CIP13: '3400937115698',
  ucdLib: "SPIRAMYCINE/MET.CRT 125MG C.",
  UCD7: '9283293',
  UCD13: '3400892832937',
  ucdQtyMultiplicator: 20,
  cipLib: "SPIRAMYCINE/MET.CRT 125MG C. BT 20",
  atcCode: "J01RA04"
}, {
  CIP7: '3710647',
  CIP13: '3400937106474',
  ucdLib: "SPIRAMYCINE/MET.EG 125MG CPR",
  UCD7: '9283264',
  UCD13: '3400892832647',
  ucdQtyMultiplicator: 20,
  cipLib: "SPIRAMYCINE/MET.EG 125MG CPR BT 20",
  atcCode: "J01RA04"
}, {
  CIP7: '3710593',
  CIP13: '3400937105934',
  ucdLib: "SPIRAMYCINE/MET.EG 250MG CPR",
  UCD7: '9283318',
  UCD13: '3400892833187',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.EG 250MG CPR BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3710831',
  CIP13: '3400937108317',
  ucdLib: "SPIRAMYCINE/MET.MYL 125MG C.",
  UCD7: '9283867',
  UCD13: '3400892838670',
  ucdQtyMultiplicator: 20,
  cipLib: "SPIRAMYCINE/MET.MYL 125MG C. BT 20",
  atcCode: "J01RA04"
}, {
  CIP7: '3710854',
  CIP13: '3400937108546',
  ucdLib: "SPIRAMYCINE/MET.RBX 250MG C.",
  UCD7: '9283850',
  UCD13: '3400892838502',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.RBX 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3710914',
  CIP13: '3400937109147',
  ucdLib: "SPIRAMYCINE/MET.RTP 250MG C.",
  UCD7: '9282945',
  UCD13: '3400892829456',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.RTP 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3710392',
  CIP13: '3400937103923',
  ucdLib: "SPIRAMYCINE/MET.ZYD 250MG C.",
  UCD7: '9291281',
  UCD13: '3400892912813',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.ZYD 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '4929158',
  CIP13: '3400949291588',
  ucdLib: "SPIRAMYCINE/MET.ALM 250MG C.",
  UCD7: '9359027',
  UCD13: '3400893590270',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.ALM 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '4929201',
  CIP13: '3400949292011',
  ucdLib: "SPIRAMYCINE/MET.CRT 250MG C.",
  UCD7: '9356514',
  UCD13: '3400893565148',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE/MET.CRT 250MG C. BT 10",
  atcCode: "J01RA04"
}, {
  CIP7: '3368723',
  CIP13: '3400933687236',
  ucdLib: "PEDIAZOLE GLE SIR FV200ML",
  UCD7: '9183396',
  UCD13: '3400891833966',
  ucdQtyMultiplicator: 1,
  cipLib: "PEDIAZOLE GLE SIR FV200ML BT 1",
  atcCode: "J01RA02"
}, {
  CIP7: '3200975',
  CIP13: '3400932009756',
  ucdLib: "APURONE 400MG CPR",
  UCD7: '9006027',
  UCD13: '3400890060271',
  ucdQtyMultiplicator: 30,
  cipLib: "APURONE 400MG CPR BT 30",
  atcCode: "J01MB07"
}, {
  CIP7: '5545483',
  CIP13: '3400955454830',
  ucdLib: "PIPRAM FORT 400MG CPR ENROB",
  UCD7: '9072248',
  UCD13: '3400890722483',
  ucdQtyMultiplicator: 50,
  cipLib: "PIPRAM FORT 400MG CPR ENROB BT 50",
  atcCode: "J01MB04"
}, {
  CIP7: '3266069',
  CIP13: '3400932660698',
  ucdLib: "PIPRAM FORT 400MG CPR ENROB",
  UCD7: '9072248',
  UCD13: '3400890722483',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPRAM FORT 400MG CPR ENROB BT 10",
  atcCode: "J01MB04"
}, {
  CIP7: '3575787',
  CIP13: '3400935757876',
  ucdLib: "IZILOX 400MG CPR",
  UCD7: '9232982',
  UCD13: '3400892329826',
  ucdQtyMultiplicator: 5,
  cipLib: "IZILOX 400MG CPR BT 5",
  atcCode: "J01MA14"
}, {
  CIP7: '3575793',
  CIP13: '3400935757937',
  ucdLib: "IZILOX 400MG CPR",
  UCD7: '9232982',
  UCD13: '3400892329826',
  ucdQtyMultiplicator: 7,
  cipLib: "IZILOX 400MG CPR BT 7",
  atcCode: "J01MA14"
}, {
  CIP7: '5635306',
  CIP13: '3400956353064',
  ucdLib: "IZILOX 400MG CPR",
  UCD7: '9232982',
  UCD13: '3400892329826',
  ucdQtyMultiplicator: 50,
  cipLib: "IZILOX 400MG CPR BT 50",
  atcCode: "J01MA14"
}, {
  CIP7: '2735651',
  CIP13: '3400927356513',
  ucdLib: "MOXIFLOXACINE EG 400MG CPR",
  UCD7: '9402639',
  UCD13: '3400894026396',
  ucdQtyMultiplicator: 5,
  cipLib: "MOXIFLOXACINE EG 400MG CPR BT 5",
  atcCode: "J01MA14"
}, {
  CIP7: '2735668',
  CIP13: '3400927356681',
  ucdLib: "MOXIFLOXACINE EG 400MG CPR",
  UCD7: '9402639',
  UCD13: '3400894026396',
  ucdQtyMultiplicator: 7,
  cipLib: "MOXIFLOXACINE EG 400MG CPR BT 7",
  atcCode: "J01MA14"
}, {
  CIP7: '2785525',
  CIP13: '3400927855252',
  ucdLib: "MOXIFLOXACINE MYL 400MG CPR",
  UCD7: '9415062',
  UCD13: '3400894150626',
  ucdQtyMultiplicator: 5,
  cipLib: "MOXIFLOXACINE MYL 400MG CPR BT 5",
  atcCode: "J01MA14"
}, {
  CIP7: '2785531',
  CIP13: '3400927855313',
  ucdLib: "MOXIFLOXACINE MYL 400MG CPR",
  UCD7: '9415062',
  UCD13: '3400894150626',
  ucdQtyMultiplicator: 7,
  cipLib: "MOXIFLOXACINE MYL 400MG CPR BT 7",
  atcCode: "J01MA14"
}, {
  CIP7: '2208354',
  CIP13: '3400922083544',
  ucdLib: "MOXIFLOXACINE SDZ 400MG CPR",
  UCD7: '9391456',
  UCD13: '3400893914564',
  ucdQtyMultiplicator: 5,
  cipLib: "MOXIFLOXACINE SDZ 400MG CPR BT 5",
  atcCode: "J01MA14"
}, {
  CIP7: '2208360',
  CIP13: '3400922083605',
  ucdLib: "MOXIFLOXACINE SDZ 400MG CPR",
  UCD7: '9391456',
  UCD13: '3400893914564',
  ucdQtyMultiplicator: 7,
  cipLib: "MOXIFLOXACINE SDZ 400MG CPR BT 7",
  atcCode: "J01MA14"
}, {
  CIP7: '2792643',
  CIP13: '3400927926433',
  ucdLib: "MOXIFLOXACINE KRK 400MG CPR",
  UCD7: '9406169',
  UCD13: '3400894061694',
  ucdQtyMultiplicator: 5,
  cipLib: "MOXIFLOXACINE KRK 400MG CPR BT 5",
  atcCode: "J01MA14"
}, {
  CIP7: '2792666',
  CIP13: '3400927926662',
  ucdLib: "MOXIFLOXACINE KRK 400MG CPR",
  UCD7: '9406169',
  UCD13: '3400894061694',
  ucdQtyMultiplicator: 7,
  cipLib: "MOXIFLOXACINE KRK 400MG CPR BT 7",
  atcCode: "J01MA14"
}, {
  CIP7: '5769308',
  CIP13: '3400957693084',
  ucdLib: "IZILOX 400MG/250ML INJ FL",
  UCD7: '9351959',
  UCD13: '3400893519592',
  ucdQtyMultiplicator: 5,
  cipLib: "IZILOX 400MG/250ML INJ FL BT 5",
  atcCode: "J01MA14"
}, {
  CIP7: '3002974',
  CIP13: '3400930029749',
  ucdLib: "LEVOFLOXACINE KRK 500MG CPR",
  UCD7: '9415027',
  UCD13: '3400894150275',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE KRK 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3496556',
  CIP13: '3400934965562',
  ucdLib: "TAVANIC 500MG CPR",
  UCD7: '9209463',
  UCD13: '3400892094632',
  ucdQtyMultiplicator: 5,
  cipLib: "TAVANIC 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3752746',
  CIP13: '3400937527460',
  ucdLib: "LEVOFLOXACINE ZYD 500MG CPR",
  UCD7: '9357933',
  UCD13: '3400893579336',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE ZYD 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '5619000',
  CIP13: '3400956190003',
  ucdLib: "TAVANIC 5MG/ML PERF FL100ML",
  UCD7: '9209440',
  UCD13: '3400892094403',
  ucdQtyMultiplicator: 1,
  cipLib: "TAVANIC 5MG/ML PERF FL100ML BT 1",
  atcCode: "J01MA12"
}, {
  CIP7: '5618986',
  CIP13: '3400956189861',
  ucdLib: "TAVANIC 5MG/ML PERF FL50ML",
  UCD7: '9209457',
  UCD13: '3400892094571',
  ucdQtyMultiplicator: 1,
  cipLib: "TAVANIC 5MG/ML PERF FL50ML BT 1",
  atcCode: "J01MA12"
}, {
  CIP7: '3958413',
  CIP13: '3400939584133',
  ucdLib: "LEVOFLOXACINE BGA 500MG CPR",
  UCD7: '9342251',
  UCD13: '3400893422519',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE BGA 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3958229',
  CIP13: '3400939582290',
  ucdLib: "LEVOFLOXACINE EVO 500MG CPR",
  UCD7: '9342239',
  UCD13: '3400893422397',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE EVO 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3958028',
  CIP13: '3400939580289',
  ucdLib: "LEVOFLOXACINE RBX 500MG CPR",
  UCD7: '9342216',
  UCD13: '3400893422168',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE RBX 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3979645',
  CIP13: '3400939796451',
  ucdLib: "LEVOFLOXACINE SDZ 500MG CPR",
  UCD7: '9346763',
  UCD13: '3400893467633',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE SDZ 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3911015',
  CIP13: '3400939110158',
  ucdLib: "LEVOFLOXACINE TVC 500MG CPR",
  UCD7: '9329552',
  UCD13: '3400893295526',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE TVC 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3949667',
  CIP13: '3400939496672',
  ucdLib: "LEVOFLOXACINE ACT 500MG CPR",
  UCD7: '9340074',
  UCD13: '3400893400746',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE ACT 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '4196431',
  CIP13: '3400941964312',
  ucdLib: "LEVOFLOXACINE AHL 500MG CPR",
  UCD7: '9374156',
  UCD13: '3400893741566',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE AHL 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '4949132',
  CIP13: '3400949491322',
  ucdLib: "LEVOFLOXACINE ALM 500MG CPR",
  UCD7: '9364028',
  UCD13: '3400893640289',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE ALM 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3988319',
  CIP13: '3400939883199',
  ucdLib: "LEVOFLOXACINE ARW 500MG CPR",
  UCD7: '9368635',
  UCD13: '3400893686355',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE ARW 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3949791',
  CIP13: '3400939497914',
  ucdLib: "LEVOFLOXACINE CRT 500MG CPR",
  UCD7: '9342274',
  UCD13: '3400893422748',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE CRT 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3949874',
  CIP13: '3400939498744',
  ucdLib: "LEVOFLOXACINE EG 500MG CPR",
  UCD7: '9340080',
  UCD13: '3400893400807',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE EG 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '3988271',
  CIP13: '3400939882710',
  ucdLib: "LEVOFLOXACINE ZEN 500MG CPR",
  UCD7: '9346786',
  UCD13: '3400893467862',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE ZEN 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '4901444',
  CIP13: '3400949014446',
  ucdLib: "TAVANIC 500MG CPR AIP BBA IT",
  UCD7: '9394503',
  UCD13: '3400893945032',
  ucdQtyMultiplicator: 5,
  cipLib: "TAVANIC 500MG CPR AIP BBA IT BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '4900568',
  CIP13: '3400949005680',
  ucdLib: "TAVANIC 500MG CPR AIP MWI DE",
  UCD7: '9351994',
  UCD13: '3400893519943',
  ucdQtyMultiplicator: 5,
  cipLib: "TAVANIC 500MG CPR AIP MWI DE BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '4900396',
  CIP13: '3400949003969',
  ucdLib: "TAVANIC 500MG CPR AIP PLA DE",
  UCD7: '9341984',
  UCD13: '3400893419847',
  ucdQtyMultiplicator: 5,
  cipLib: "TAVANIC 500MG CPR AIP PLA DE BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '5756599',
  CIP13: '3400957565992',
  ucdLib: "LEVOFLOX.MYL 5MG/ML POC100ML",
  UCD7: '9341872',
  UCD13: '3400893418727',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOFLOX.MYL 5MG/ML POC100ML BT 30",
  atcCode: "J01MA12"
}, {
  CIP7: '5756487',
  CIP13: '3400957564872',
  ucdLib: "LEVOFLOX.MYL 5MG/ML POC50ML",
  UCD7: '9341889',
  UCD13: '3400893418895',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVOFLOX.MYL 5MG/ML POC50ML BT 10",
  atcCode: "J01MA12"
}, {
  CIP7: '3991149',
  CIP13: '3400939911496',
  ucdLib: "LEVOFLOXACINE MYL 500MG CPR",
  UCD7: '9349460',
  UCD13: '3400893494608',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE MYL 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '4927722',
  CIP13: '3400949277223',
  ucdLib: "LEVOFLOXACINE PHR 500MG CPR",
  UCD7: '9361521',
  UCD13: '3400893615218',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOFLOXACINE PHR 500MG CPR BT 5",
  atcCode: "J01MA12"
}, {
  CIP7: '5787602',
  CIP13: '3400957876029',
  ucdLib: "LEVOFLOX.ARW 5MG/ML FL100ML",
  UCD7: '9366429',
  UCD13: '3400893664292',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVOFLOX.ARW 5MG/ML FL100ML BT 1",
  atcCode: "J01MA12"
}, {
  CIP7: '5815907',
  CIP13: '3400958159077',
  ucdLib: "LEVOFLOX.ARW 5MG/ML POC100ML",
  UCD7: '9380984',
  UCD13: '3400893809846',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVOFLOX.ARW 5MG/ML POC100ML BT 10",
  atcCode: "J01MA12"
}, {
  CIP7: '5815882',
  CIP13: '3400958158827',
  ucdLib: "LEVOFLOX.ARW 5MG/ML POC50ML",
  UCD7: '9380990',
  UCD13: '3400893809907',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVOFLOX.ARW 5MG/ML POC50ML BT 10",
  atcCode: "J01MA12"
}, {
  CIP7: '5834425',
  CIP13: '3400958344251',
  ucdLib: "LEVOFLOX.EG 5MG/ML POC100ML",
  UCD7: '9390801',
  UCD13: '3400893908013',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVOFLOX.EG 5MG/ML POC100ML BT 1",
  atcCode: "J01MA12"
}, {
  CIP7: '5794039',
  CIP13: '3400957940393',
  ucdLib: "LEVOFLOX.HPI 5MG/ML POC100ML",
  UCD7: '9371614',
  UCD13: '3400893716144',
  ucdQtyMultiplicator: 20,
  cipLib: "LEVOFLOX.HPI 5MG/ML POC100ML BT 20",
  atcCode: "J01MA12"
}, {
  CIP7: '5779301',
  CIP13: '3400957793012',
  ucdLib: "LEVOFLOX.KBI 5MG/ML FL100ML",
  UCD7: '9359398',
  UCD13: '3400893593981',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVOFLOX.KBI 5MG/ML FL100ML BT 1",
  atcCode: "J01MA12"
}, {
  CIP7: '5779287',
  CIP13: '3400957792879',
  ucdLib: "LEVOFLOX.KBI 5MG/ML FL50ML",
  UCD7: '9359406',
  UCD13: '3400893594063',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVOFLOX.KBI 5MG/ML FL50ML BT 1",
  atcCode: "J01MA12"
}, {
  CIP7: '5804447',
  CIP13: '3400958044472',
  ucdLib: "LEVOFLOXACINE AHL 500MG CPR",
  UCD7: '9374156',
  UCD13: '3400893741566',
  ucdQtyMultiplicator: 50,
  cipLib: "LEVOFLOXACINE AHL 500MG CPR BT 50",
  atcCode: "J01MA12"
}, {
  CIP7: '5795725',
  CIP13: '3400957957254',
  ucdLib: "LEVOFLOXACINE MYL 500MG CPR",
  UCD7: '9349460',
  UCD13: '3400893494608',
  ucdQtyMultiplicator: 100,
  cipLib: "LEVOFLOXACINE MYL 500MG CPR BT 100",
  atcCode: "J01MA12"
}, {
  CIP7: '3379649',
  CIP13: '3400933796495',
  ucdLib: "DECALOGIFLOX CPR",
  UCD7: '9171654',
  UCD13: '3400891716542',
  ucdQtyMultiplicator: 10,
  cipLib: "DECALOGIFLOX CPR BT 10",
  atcCode: "J01MA07"
}, {
  CIP7: '3345975',
  CIP13: '3400933459758',
  ucdLib: "LOGIFLOX 400MG CPR",
  UCD7: '9169054',
  UCD13: '3400891690545',
  ucdQtyMultiplicator: 3,
  cipLib: "LOGIFLOX 400MG CPR BT 3",
  atcCode: "J01MA07"
}, {
  CIP7: '3613341',
  CIP13: '3400936133419',
  ucdLib: "NORFLOXACINE BGA 400MG CPR",
  UCD7: '9255836',
  UCD13: '3400892558363',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE BGA 400MG CPR BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '3612548',
  CIP13: '3400936125483',
  ucdLib: "NORFLOXACINE EG 400MG CPR",
  UCD7: '9248285',
  UCD13: '3400892482859',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE EG 400MG CPR BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '3679742',
  CIP13: '3400936797420',
  ucdLib: "NORFLOXACINE SDZ 400MG C.PEL",
  UCD7: '9268678',
  UCD13: '3400892686783',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE SDZ 400MG C.PEL BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '3674710',
  CIP13: '3400936747104',
  ucdLib: "NORFLOXACINE ZEN 400MG CPR",
  UCD7: '9270132',
  UCD13: '3400892701325',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE ZEN 400MG CPR BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '3626711',
  CIP13: '3400936267114',
  ucdLib: "NORFLOXACINE ARW 400MG CPR",
  UCD7: '9255598',
  UCD13: '3400892555980',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE ARW 400MG CPR BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '3626697',
  CIP13: '3400936266971',
  ucdLib: "NORFLOXACINE CRT 400MG CPR",
  UCD7: '9256333',
  UCD13: '3400892563336',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE CRT 400MG CPR BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '3626734',
  CIP13: '3400936267343',
  ucdLib: "NORFLOXACINE MYL 400MG CPR",
  UCD7: '9255606',
  UCD13: '3400892556062',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE MYL 400MG CPR BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '3626705',
  CIP13: '3400936267053',
  ucdLib: "NORFLOXACINE TVC 400MG CPR",
  UCD7: '9257114',
  UCD13: '3400892571140',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE TVC 400MG CPR BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '3746533',
  CIP13: '3400937465335',
  ucdLib: "NORFLOXACINE RBX 400MG CPR",
  UCD7: '9288451',
  UCD13: '3400892884516',
  ucdQtyMultiplicator: 10,
  cipLib: "NORFLOXACINE RBX 400MG CPR BT 10",
  atcCode: "J01MA06"
}, {
  CIP7: '5650292',
  CIP13: '3400956502929',
  ucdLib: "NORFLOXACINE ARW 400MG CPR",
  UCD7: '9255598',
  UCD13: '3400892555980',
  ucdQtyMultiplicator: 50,
  cipLib: "NORFLOXACINE ARW 400MG CPR BT 50",
  atcCode: "J01MA06"
}, {
  CIP7: '5548659',
  CIP13: '3400955486596',
  ucdLib: "PEFLACINE 400MG CPR",
  UCD7: '9106556',
  UCD13: '3400891065565',
  ucdQtyMultiplicator: 50,
  cipLib: "PEFLACINE 400MG CPR BT 50",
  atcCode: "J01MA03"
}, {
  CIP7: '5571718',
  CIP13: '3400955717188',
  ucdLib: "PEFLACINE 400MG IV AMP5ML",
  UCD7: '9106533',
  UCD13: '3400891065336',
  ucdQtyMultiplicator: 5,
  cipLib: "PEFLACINE 400MG IV AMP5ML BT 5",
  atcCode: "J01MA03"
}, {
  CIP7: '3612844',
  CIP13: '3400936128446',
  ucdLib: "CIPROFLOXACINE EG 250MG CPR",
  UCD7: '9255807',
  UCD13: '3400892558073',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE EG 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3612838',
  CIP13: '3400936128385',
  ucdLib: "CIPROFLOXACINE EG 500MG CPR",
  UCD7: '9255813',
  UCD13: '3400892558134',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE EG 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3612703',
  CIP13: '3400936127036',
  ucdLib: "CIPROFLOXACINE MYL 250MG CPR",
  UCD7: '9257746',
  UCD13: '3400892577463',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE MYL 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3612732',
  CIP13: '3400936127326',
  ucdLib: "CIPROFLOXACINE MYL 500MG CPR",
  UCD7: '9257752',
  UCD13: '3400892577524',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE MYL 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3002171',
  CIP13: '3400930021712',
  ucdLib: "CIPROFLOX.KBI200/100ML 100ML",
  UCD7: '9410389',
  UCD13: '3400894103899',
  ucdQtyMultiplicator: 1,
  cipLib: "CIPROFLOX.KBI200/100ML 100ML BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '3002184',
  CIP13: '3400930021842',
  ucdLib: "CIPROFLOX.KBI400/200ML 200ML",
  UCD7: '9410395',
  UCD13: '3400894103950',
  ucdQtyMultiplicator: 1,
  cipLib: "CIPROFLOX.KBI400/200ML 200ML BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '3685286',
  CIP13: '3400936852860',
  ucdLib: "CIPROFLOXACINE ALT 250MG CPR",
  UCD7: '9275767',
  UCD13: '3400892757674',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ALT 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3685292',
  CIP13: '3400936852921',
  ucdLib: "CIPROFLOXACINE ALT 500MG CPR",
  UCD7: '9275773',
  UCD13: '3400892757735',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ALT 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3682112',
  CIP13: '3400936821125',
  ucdLib: "CIPROFLOXACINE ARW 250MG CPR",
  UCD7: '9279251',
  UCD13: '3400892792514',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ARW 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3682230',
  CIP13: '3400936822306',
  ucdLib: "CIPROFLOXACINE ARW 500MG CPR",
  UCD7: '9279268',
  UCD13: '3400892792682',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ARW 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3678286',
  CIP13: '3400936782860',
  ucdLib: "CIPROFLOXACINE SDZ 250MG CPR",
  UCD7: '9269608',
  UCD13: '3400892696089',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE SDZ 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3678317',
  CIP13: '3400936783171',
  ucdLib: "CIPROFLOXACINE SDZ 500MG CPR",
  UCD7: '9269614',
  UCD13: '3400892696140',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE SDZ 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3672467',
  CIP13: '3400936724679',
  ucdLib: "CIPROFLOXACINE TVC 250MG CPR",
  UCD7: '9267271',
  UCD13: '3400892672717',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE TVC 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3672473',
  CIP13: '3400936724730',
  ucdLib: "CIPROFLOXACINE TVC 500MG CPR",
  UCD7: '9267288',
  UCD13: '3400892672885',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE TVC 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3674489',
  CIP13: '3400936744899',
  ucdLib: "CIPROFLOXACINE ZEN 250MG CPR",
  UCD7: '9269927',
  UCD13: '3400892699271',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ZEN 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3674495',
  CIP13: '3400936744950',
  ucdLib: "CIPROFLOXACINE ZEN 500MG CPR",
  UCD7: '9269933',
  UCD13: '3400892699332',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ZEN 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3365239',
  CIP13: '3400933652395',
  ucdLib: "UNIFLOX CPR",
  UCD7: '9167925',
  UCD13: '3400891679250',
  ucdQtyMultiplicator: 1,
  cipLib: "UNIFLOX CPR BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '3762271',
  CIP13: '3400937622714',
  ucdLib: "CIFLOX 200MG/100ML INJ FL",
  UCD7: '9124258',
  UCD13: '3400891242584',
  ucdQtyMultiplicator: 1,
  cipLib: "CIFLOX 200MG/100ML INJ FL BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '3638424',
  CIP13: '3400936384248',
  ucdLib: "CIPROFLOXACINE BGA 250MG CPR",
  UCD7: '9259886',
  UCD13: '3400892598864',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE BGA 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3638430',
  CIP13: '3400936384309',
  ucdLib: "CIPROFLOXACINE BGA 500MG CPR",
  UCD7: '9259892',
  UCD13: '3400892598925',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE BGA 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3642934',
  CIP13: '3400936429345',
  ucdLib: "CIFLOX 250MG CPR",
  UCD7: '9121337',
  UCD13: '3400891213379',
  ucdQtyMultiplicator: 12,
  cipLib: "CIFLOX 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3642963',
  CIP13: '3400936429635',
  ucdLib: "CIFLOX 500MG CPR",
  UCD7: '9121343',
  UCD13: '3400891213430',
  ucdQtyMultiplicator: 12,
  cipLib: "CIFLOX 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3648569',
  CIP13: '3400936485693',
  ucdLib: "CIPROFLOXACINE RTP 250MG CPR",
  UCD7: '9264226',
  UCD13: '3400892642260',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE RTP 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3643098',
  CIP13: '3400936430983',
  ucdLib: "CIPROFLOXACINE ZYD 250MG CPR",
  UCD7: '9261630',
  UCD13: '3400892616308',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ZYD 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3643081',
  CIP13: '3400936430815',
  ucdLib: "CIPROFLOXACINE ZYD 500MG CPR",
  UCD7: '9261647',
  UCD13: '3400892616476',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ZYD 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3441940',
  CIP13: '3400934419409',
  ucdLib: "CIFLOX 500MG/5ML BUV FL100ML",
  UCD7: '9198481',
  UCD13: '3400891984811',
  ucdQtyMultiplicator: 1,
  cipLib: "CIFLOX 500MG/5ML BUV FL100ML BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '3809363',
  CIP13: '3400938093636',
  ucdLib: "CIPROFLOXACINE EVO 500MG CPR",
  UCD7: '9304552',
  UCD13: '3400893045527',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE EVO 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3809334',
  CIP13: '3400938093346',
  ucdLib: "CIPROFLOXACINE RBX 250MG CPR",
  UCD7: '9305043',
  UCD13: '3400893050439',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE RBX 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '3809541',
  CIP13: '3400938095418',
  ucdLib: "CIPROFLOXACINE RBX 500MG CPR",
  UCD7: '9305066',
  UCD13: '3400893050668',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE RBX 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '5639681',
  CIP13: '3400956396818',
  ucdLib: "CIPROFLOX.MYP200MG/100ML POC",
  UCD7: '9259774',
  UCD13: '3400892597744',
  ucdQtyMultiplicator: 10,
  cipLib: "CIPROFLOX.MYP200MG/100ML POC BT 10",
  atcCode: "J01MA02"
}, {
  CIP7: '5642111',
  CIP13: '3400956421114',
  ucdLib: "CIPROFLOX.MYP400MG/200ML POC",
  UCD7: '9259780',
  UCD13: '3400892597805',
  ucdQtyMultiplicator: 10,
  cipLib: "CIPROFLOX.MYP400MG/200ML POC BT 10",
  atcCode: "J01MA02"
}, {
  CIP7: '5646712',
  CIP13: '3400956467129',
  ucdLib: "CIPROFLOXACINE MYL 500MG CPR",
  UCD7: '9257752',
  UCD13: '3400892577524',
  ucdQtyMultiplicator: 100,
  cipLib: "CIPROFLOXACINE MYL 500MG CPR BT 100",
  atcCode: "J01MA02"
}, {
  CIP7: '5640603',
  CIP13: '3400956406036',
  ucdLib: "CIPROFLOXACINE MYL 750MG C.",
  UCD7: '9262115',
  UCD13: '3400892621159',
  ucdQtyMultiplicator: 100,
  cipLib: "CIPROFLOXACINE MYL 750MG C. BT 100",
  atcCode: "J01MA02"
}, {
  CIP7: '5722353',
  CIP13: '3400957223533',
  ucdLib: "CIPROFLOX.MAC200MG/100ML POC",
  UCD7: '9314817',
  UCD13: '3400893148174',
  ucdQtyMultiplicator: 1,
  cipLib: "CIPROFLOX.MAC200MG/100ML POC BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '5722258',
  CIP13: '3400957222581',
  ucdLib: "CIPROFLOX.MAC400MG/200ML POC",
  UCD7: '9314823',
  UCD13: '3400893148235',
  ucdQtyMultiplicator: 1,
  cipLib: "CIPROFLOX.MAC400MG/200ML POC BT 1",
  atcCode: "J01MA02"
}, {
  CIP7: '5741758',
  CIP13: '3400957417581',
  ucdLib: "CIPROFLOX.MYL200MG/100ML POC",
  UCD7: '9314846',
  UCD13: '3400893148464',
  ucdQtyMultiplicator: 30,
  cipLib: "CIPROFLOX.MYL200MG/100ML POC BT 30",
  atcCode: "J01MA02"
}, {
  CIP7: '5741764',
  CIP13: '3400957417642',
  ucdLib: "CIPROFLOX.MYL400MG/200ML POC",
  UCD7: '9314852',
  UCD13: '3400893148525',
  ucdQtyMultiplicator: 15,
  cipLib: "CIPROFLOX.MYL400MG/200ML POC BT 15",
  atcCode: "J01MA02"
}, {
  CIP7: '5727072',
  CIP13: '3400957270728',
  ucdLib: "CIPROFLOX.PAN200MG/100ML POC",
  UCD7: '9316354',
  UCD13: '3400893163542',
  ucdQtyMultiplicator: 10,
  cipLib: "CIPROFLOX.PAN200MG/100ML POC BT 10",
  atcCode: "J01MA02"
}, {
  CIP7: '5727089',
  CIP13: '3400957270896',
  ucdLib: "CIPROFLOX.PAN400MG/200ML POC",
  UCD7: '9316087',
  UCD13: '3400893160879',
  ucdQtyMultiplicator: 10,
  cipLib: "CIPROFLOX.PAN400MG/200ML POC BT 10",
  atcCode: "J01MA02"
}, {
  CIP7: '2232022',
  CIP13: '3400922320229',
  ucdLib: "CIPROFLOXACINE ACC 250MG CPR",
  UCD7: '9388460',
  UCD13: '3400893884607',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ACC 250MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '2232128',
  CIP13: '3400922321288',
  ucdLib: "CIPROFLOXACINE ACC 500MG CPR",
  UCD7: '9388477',
  UCD13: '3400893884775',
  ucdQtyMultiplicator: 12,
  cipLib: "CIPROFLOXACINE ACC 500MG CPR BT 12",
  atcCode: "J01MA02"
}, {
  CIP7: '5672632',
  CIP13: '3400956726325',
  ucdLib: "CIPROFLOXACINE ARW 500MG CPR",
  UCD7: '9279268',
  UCD13: '3400892792682',
  ucdQtyMultiplicator: 100,
  cipLib: "CIPROFLOXACINE ARW 500MG CPR BT 100",
  atcCode: "J01MA02"
}, {
  CIP7: '5672678',
  CIP13: '3400956726783',
  ucdLib: "CIPROFLOXACINE ARW 750MG C.",
  UCD7: '9279274',
  UCD13: '3400892792743',
  ucdQtyMultiplicator: 100,
  cipLib: "CIPROFLOXACINE ARW 750MG C. BT 100",
  atcCode: "J01MA02"
}, {
  CIP7: '5660907',
  CIP13: '3400956609079',
  ucdLib: "CIPROFLOXACINE TVC 750MG C.",
  UCD7: '9319453',
  UCD13: '3400893194539',
  ucdQtyMultiplicator: 100,
  cipLib: "CIPROFLOXACINE TVC 750MG C. BT 100",
  atcCode: "J01MA02"
}, {
  CIP7: '5653830',
  CIP13: '3400956538300',
  ucdLib: "CIFLOX 750MG CPR",
  UCD7: '9121366',
  UCD13: '3400891213669',
  ucdQtyMultiplicator: 100,
  cipLib: "CIFLOX 750MG CPR BT 100",
  atcCode: "J01MA02"
}, {
  CIP7: '3617988',
  CIP13: '3400936179882',
  ucdLib: "OFLOXACINE BGA 200MG CPR",
  UCD7: '9249876',
  UCD13: '3400892498768',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE BGA 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3616670',
  CIP13: '3400936166707',
  ucdLib: "OFLOXACINE TVC 200MG CPR",
  UCD7: '9249379',
  UCD13: '3400892493794',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE TVC 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3290323',
  CIP13: '3400932903238',
  ucdLib: "OFLOCET 200MG CPR PELLIC SECAB",
  UCD7: '9114188',
  UCD13: '3400891141887',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOCET 200MG CPR PELLIC SECAB BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '5554298',
  CIP13: '3400955542988',
  ucdLib: "OFLOCET 200MG CPR PELLIC SECAB",
  UCD7: '9114188',
  UCD13: '3400891141887',
  ucdQtyMultiplicator: 50,
  cipLib: "OFLOCET 200MG CPR PELLIC SECAB BT 50",
  atcCode: "J01MA01"
}, {
  CIP7: '3603087',
  CIP13: '3400936030879',
  ucdLib: "OFLOXACINE MYL 200MG CPR",
  UCD7: '9244146',
  UCD13: '3400892441467',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE MYL 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3671611',
  CIP13: '3400936716117',
  ucdLib: "OFLOXACINE ZEN 200MG CPR",
  UCD7: '9273886',
  UCD13: '3400892738864',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE ZEN 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3391248',
  CIP13: '3400933912482',
  ucdLib: "MONOFLOCET 200MG CPR",
  UCD7: '9191705',
  UCD13: '3400891917055',
  ucdQtyMultiplicator: 2,
  cipLib: "MONOFLOCET 200MG CPR BT 2",
  atcCode: "J01MA01"
}, {
  CIP7: '3623842',
  CIP13: '3400936238428',
  ucdLib: "OFLOXACINE ARW 200MG CPR",
  UCD7: '9255629',
  UCD13: '3400892556291',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE ARW 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3769362',
  CIP13: '3400937693622',
  ucdLib: "OFLOXACINE ALM 200MG CPR",
  UCD7: '9295244',
  UCD13: '3400892952444',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE ALM 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3767340',
  CIP13: '3400937673402',
  ucdLib: "OFLOXACINE CRT 200MG CPR",
  UCD7: '9295215',
  UCD13: '3400892952154',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE CRT 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3635839',
  CIP13: '3400936358393',
  ucdLib: "OFLOXACINE EG 200MG CPR",
  UCD7: '9258970',
  UCD13: '3400892589701',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE EG 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3769356',
  CIP13: '3400937693561',
  ucdLib: "OFLOXACINE EVO 200MG CPR",
  UCD7: '9295221',
  UCD13: '3400892952215',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE EVO 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3767469',
  CIP13: '3400937674690',
  ucdLib: "OFLOXACINE RBX 200MG CPR",
  UCD7: '9295238',
  UCD13: '3400892952383',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE RBX 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '3645298',
  CIP13: '3400936452985',
  ucdLib: "OFLOXACINE SDZ 200MG CPR",
  UCD7: '9262121',
  UCD13: '3400892621210',
  ucdQtyMultiplicator: 10,
  cipLib: "OFLOXACINE SDZ 200MG CPR BT 10",
  atcCode: "J01MA01"
}, {
  CIP7: '5641235',
  CIP13: '3400956412358',
  ucdLib: "OFLOXACINE ARW 200MG CPR",
  UCD7: '9255629',
  UCD13: '3400892556291',
  ucdQtyMultiplicator: 50,
  cipLib: "OFLOXACINE ARW 200MG CPR BT 50",
  atcCode: "J01MA01"
}, {
  CIP7: '5639675',
  CIP13: '3400956396757',
  ucdLib: "OFLOXACINE MYP200MG/40ML POC",
  UCD7: '9243520',
  UCD13: '3400892435206',
  ucdQtyMultiplicator: 20,
  cipLib: "OFLOXACINE MYP200MG/40ML POC BT 20",
  atcCode: "J01MA01"
}, {
  CIP7: '5667743',
  CIP13: '3400956677436',
  ucdLib: "OFLOXACINE MAC200MG/40ML POC",
  UCD7: '9277714',
  UCD13: '3400892777146',
  ucdQtyMultiplicator: 1,
  cipLib: "OFLOXACINE MAC200MG/40ML POC BT 1",
  atcCode: "J01MA01"
}, {
  CIP7: '5737722',
  CIP13: '3400957377229',
  ucdLib: "OFLOXACINE MYL 200MG/40ML P.",
  UCD7: '9280113',
  UCD13: '3400892801131',
  ucdQtyMultiplicator: 50,
  cipLib: "OFLOXACINE MYL 200MG/40ML P. BT 50",
  atcCode: "J01MA01"
}, {
  CIP7: '3003328',
  CIP13: '3400930033289',
  ucdLib: "AMIKACINE MYL 250MG INJ FL",
  UCD7: '9284163',
  UCD13: '3400892841632',
  ucdQtyMultiplicator: 20,
  cipLib: "AMIKACINE MYL 250MG INJ FL BT 20",
  atcCode: "J01GB06"
}, {
  CIP7: '3003330',
  CIP13: '3400930033302',
  ucdLib: "AMIKACINE MYL 500MG INJ FL",
  UCD7: '9284186',
  UCD13: '3400892841861',
  ucdQtyMultiplicator: 20,
  cipLib: "AMIKACINE MYL 500MG INJ FL BT 20",
  atcCode: "J01GB06"
}, {
  CIP7: '3550451',
  CIP13: '3400935504517',
  ucdLib: "AMIKACINE MYL 1G INJ FL",
  UCD7: '9222222',
  UCD13: '3400892222226',
  ucdQtyMultiplicator: 20,
  cipLib: "AMIKACINE MYL 1G INJ FL BT 20",
  atcCode: "J01GB06"
}, {
  CIP7: '5596641',
  CIP13: '3400955966418',
  ucdLib: "AMIKACINE MYL 50MG INJ AMP",
  UCD7: '9208593',
  UCD13: '3400892085937',
  ucdQtyMultiplicator: 20,
  cipLib: "AMIKACINE MYL 50MG INJ AMP BT 20",
  atcCode: "J01GB06"
}, {
  CIP7: '5795352',
  CIP13: '3400957953522',
  ucdLib: "AMIKACINE BBM 10MG/ML INJ FL",
  UCD7: '9397223',
  UCD13: '3400893972236',
  ucdQtyMultiplicator: 10,
  cipLib: "AMIKACINE BBM 10MG/ML INJ FL BT 10",
  atcCode: "J01GB06"
}, {
  CIP7: '5792313',
  CIP13: '3400957923136',
  ucdLib: "AMIKACINE BBM 2,5MG/ML INJ FL",
  UCD7: '9397246',
  UCD13: '3400893972465',
  ucdQtyMultiplicator: 10,
  cipLib: "AMIKACINE BBM 2,5MG/ML INJ FL BT 10",
  atcCode: "J01GB06"
}, {
  CIP7: '5795292',
  CIP13: '3400957952921',
  ucdLib: "AMIKACINE BBM 5MG/ML INJ FL",
  UCD7: '9397252',
  UCD13: '3400893972526',
  ucdQtyMultiplicator: 10,
  cipLib: "AMIKACINE BBM 5MG/ML INJ FL BT 10",
  atcCode: "J01GB06"
}, {
  CIP7: '5681022',
  CIP13: '3400956810222',
  ucdLib: "AMIKACINE MYL 250MG INJ FL",
  UCD7: '9284163',
  UCD13: '3400892841632',
  ucdQtyMultiplicator: 20,
  cipLib: "AMIKACINE MYL 250MG INJ FL BT 20",
  atcCode: "J01GB06"
}, {
  CIP7: '5681039',
  CIP13: '3400956810390',
  ucdLib: "AMIKACINE MYL 500MG INJ FL",
  UCD7: '9284186',
  UCD13: '3400892841861',
  ucdQtyMultiplicator: 20,
  cipLib: "AMIKACINE MYL 500MG INJ FL BT 20",
  atcCode: "J01GB06"
}, {
  CIP7: '3269530',
  CIP13: '3400932695300',
  ucdLib: "GENTAMICINE PAN 10MG INJ AMP",
  UCD7: '9121030',
  UCD13: '3400891210309',
  ucdQtyMultiplicator: 1,
  cipLib: "GENTAMICINE PAN 10MG INJ AMP BT 1",
  atcCode: "J01GB03"
}, {
  CIP7: '3269518',
  CIP13: '3400932695188',
  ucdLib: "GENTAMICINE PAN 160MG INJ A.",
  UCD7: '9121047',
  UCD13: '3400891210477',
  ucdQtyMultiplicator: 1,
  cipLib: "GENTAMICINE PAN 160MG INJ A. BT 1",
  atcCode: "J01GB03"
}, {
  CIP7: '3269524',
  CIP13: '3400932695249',
  ucdLib: "GENTAMICINE PAN 40MG INJ AMP",
  UCD7: '9121053',
  UCD13: '3400891210538',
  ucdQtyMultiplicator: 1,
  cipLib: "GENTAMICINE PAN 40MG INJ AMP BT 1",
  atcCode: "J01GB03"
}, {
  CIP7: '3269501',
  CIP13: '3400932695010',
  ucdLib: "GENTAMICINE PAN 80MG INJ AMP",
  UCD7: '9121076',
  UCD13: '3400891210767',
  ucdQtyMultiplicator: 1,
  cipLib: "GENTAMICINE PAN 80MG INJ AMP BT 1",
  atcCode: "J01GB03"
}, {
  CIP7: '3512025',
  CIP13: '3400935120250',
  ucdLib: "GENTAMICINE PAN 10MG INJ AMP",
  UCD7: '9121030',
  UCD13: '3400891210309',
  ucdQtyMultiplicator: 10,
  cipLib: "GENTAMICINE PAN 10MG INJ AMP BT 10",
  atcCode: "J01GB03"
}, {
  CIP7: '3512054',
  CIP13: '3400935120540',
  ucdLib: "GENTAMICINE PAN 160MG INJ A.",
  UCD7: '9121047',
  UCD13: '3400891210477',
  ucdQtyMultiplicator: 10,
  cipLib: "GENTAMICINE PAN 160MG INJ A. BT 10",
  atcCode: "J01GB03"
}, {
  CIP7: '3512031',
  CIP13: '3400935120311',
  ucdLib: "GENTAMICINE PAN 40MG INJ AMP",
  UCD7: '9121053',
  UCD13: '3400891210538',
  ucdQtyMultiplicator: 10,
  cipLib: "GENTAMICINE PAN 40MG INJ AMP BT 10",
  atcCode: "J01GB03"
}, {
  CIP7: '3512048',
  CIP13: '3400935120489',
  ucdLib: "GENTAMICINE PAN 80MG INJ AMP",
  UCD7: '9121076',
  UCD13: '3400891210767',
  ucdQtyMultiplicator: 10,
  cipLib: "GENTAMICINE PAN 80MG INJ AMP BT 10",
  atcCode: "J01GB03"
}, {
  CIP7: '3657232',
  CIP13: '3400936572324',
  ucdLib: "TOBI 300MG/5ML INHAL AMP",
  UCD7: '9227030',
  UCD13: '3400892270302',
  ucdQtyMultiplicator: 56,
  cipLib: "TOBI 300MG/5ML INHAL AMP BT 56",
  atcCode: "J01GB01"
}, {
  CIP7: '3164877',
  CIP13: '3400931648772',
  ucdLib: "NEBCINE 100MG INJ FL-AMP",
  UCD7: '9267383',
  UCD13: '3400892673837',
  ucdQtyMultiplicator: 1,
  cipLib: "NEBCINE 100MG INJ FL-AMP BT 1",
  atcCode: "J01GB01"
}, {
  CIP7: '3164854',
  CIP13: '3400931648543',
  ucdLib: "NEBCINE 25MG INJ FL-A.2,5ML",
  UCD7: '9061322',
  UCD13: '3400890613224',
  ucdQtyMultiplicator: 1,
  cipLib: "NEBCINE 25MG INJ FL-A.2,5ML BT 1",
  atcCode: "J01GB01"
}, {
  CIP7: '3164860',
  CIP13: '3400931648604',
  ucdLib: "NEBCINE 75MG INJ FL-A.1,5ML",
  UCD7: '9061339',
  UCD13: '3400890613392',
  ucdQtyMultiplicator: 1,
  cipLib: "NEBCINE 75MG INJ FL-A.1,5ML BT 1",
  atcCode: "J01GB01"
}, {
  CIP7: '4991329',
  CIP13: '3400949913299',
  ucdLib: "TOBI PODHALER 28MG PDR GELU",
  UCD7: '9384048',
  UCD13: '3400893840481',
  ucdQtyMultiplicator: 224,
  cipLib: "TOBI PODHALER 28MG PDR GELU BT 224",
  atcCode: "J01GB01"
}, {
  CIP7: '3100334',
  CIP13: '3400931003342',
  ucdLib: "STREPTOMYCINE PAN 1G INJ FL",
  UCD7: '9088284',
  UCD13: '3400890882842',
  ucdQtyMultiplicator: 1,
  cipLib: "STREPTOMYCINE PAN 1G INJ FL BT 1",
  atcCode: "J01GA01"
}, {
  CIP7: '5583325',
  CIP13: '3400955833253',
  ucdLib: "PYOSTACINE 500MG CPR",
  UCD7: '9077493',
  UCD13: '3400890774932',
  ucdQtyMultiplicator: 100,
  cipLib: "PYOSTACINE 500MG CPR BT 100",
  atcCode: "J01FG01"
}, {
  CIP7: '3135858',
  CIP13: '3400931358589',
  ucdLib: "PYOSTACINE 500MG CPR",
  UCD7: '9077493',
  UCD13: '3400890774932',
  ucdQtyMultiplicator: 16,
  cipLib: "PYOSTACINE 500MG CPR BT 16",
  atcCode: "J01FG01"
}, {
  CIP7: '3393721',
  CIP13: '3400933937218',
  ucdLib: "PYOSTACINE 250MG ENF CPR",
  UCD7: '9182497',
  UCD13: '3400891824971',
  ucdQtyMultiplicator: 16,
  cipLib: "PYOSTACINE 250MG ENF CPR BT 16",
  atcCode: "J01FG01"
}, {
  CIP7: '3389990',
  CIP13: '3400933899905',
  ucdLib: "PRISTAM 500MG CPR",
  UCD7: '9173334',
  UCD13: '3400891733341',
  ucdQtyMultiplicator: 16,
  cipLib: "PRISTAM 500MG CPR BT 16",
  atcCode: "J01FG01"
}, {
  CIP7: '3259081',
  CIP13: '3400932590810',
  ucdLib: "LINCOCINE 500MG GELU",
  UCD7: '9054256',
  UCD13: '3400890542562',
  ucdQtyMultiplicator: 12,
  cipLib: "LINCOCINE 500MG GELU BT 12",
  atcCode: "J01FF02"
}, {
  CIP7: '5616510',
  CIP13: '3400956165100',
  ucdLib: "LINCOCINE INJ AMP2ML",
  UCD7: '9054233',
  UCD13: '3400890542333',
  ucdQtyMultiplicator: 1,
  cipLib: "LINCOCINE INJ AMP2ML BT 1",
  atcCode: "J01FF02"
}, {
  CIP7: '3066815',
  CIP13: '3400930668153',
  ucdLib: "DALACINE 150MG GELU",
  UCD7: '9023913',
  UCD13: '3400890239134',
  ucdQtyMultiplicator: 12,
  cipLib: "DALACINE 150MG GELU BT 12",
  atcCode: "J01FF01"
}, {
  CIP7: '3066809',
  CIP13: '3400930668092',
  ucdLib: "DALACINE 75MG GELU",
  UCD7: '9023936',
  UCD13: '3400890239363',
  ucdQtyMultiplicator: 12,
  cipLib: "DALACINE 75MG GELU BT 12",
  atcCode: "J01FF01"
}, {
  CIP7: '3410365',
  CIP13: '3400934103650',
  ucdLib: "DALACINE 300MG GELU",
  UCD7: '9192521',
  UCD13: '3400891925210',
  ucdQtyMultiplicator: 16,
  cipLib: "DALACINE 300MG GELU BT 16",
  atcCode: "J01FF01"
}, {
  CIP7: '5619773',
  CIP13: '3400956197736',
  ucdLib: "DALACINE 600MG INJ AMP4ML",
  UCD7: '9023907',
  UCD13: '3400890239073',
  ucdQtyMultiplicator: 1,
  cipLib: "DALACINE 600MG INJ AMP4ML BT 1",
  atcCode: "J01FF01"
}, {
  CIP7: '5619767',
  CIP13: '3400956197675',
  ucdLib: "DALACINE 900MG INJ AMP6ML",
  UCD7: '9124270',
  UCD13: '3400891242706',
  ucdQtyMultiplicator: 1,
  cipLib: "DALACINE 900MG INJ AMP6ML BT 1",
  atcCode: "J01FF01"
}, {
  CIP7: '5729438',
  CIP13: '3400957294380',
  ucdLib: "CLINDAMYCINE KBI 600MG/4ML A",
  UCD7: '9322113',
  UCD13: '3400893221136',
  ucdQtyMultiplicator: 5,
  cipLib: "CLINDAMYCINE KBI 600MG/4ML A BT 5",
  atcCode: "J01FF01"
}, {
  CIP7: '3575592',
  CIP13: '3400935755926',
  ucdLib: "KETEK 400MG CPR",
  UCD7: '9237235',
  UCD13: '3400892372358',
  ucdQtyMultiplicator: 10,
  cipLib: "KETEK 400MG CPR BT 10",
  atcCode: "J01FA15"
}, {
  CIP7: '4950247',
  CIP13: '3400949502479',
  ucdLib: "KETEK 400MG CPR ADP BBA",
  UCD7: '9360237',
  UCD13: '3400893602379',
  ucdQtyMultiplicator: 10,
  cipLib: "KETEK 400MG CPR ADP BBA BT 10",
  atcCode: "J01FA15"
}, {
  CIP7: '4950017',
  CIP13: '3400949500178',
  ucdLib: "KETEK 400MG CPR ADP MWI",
  UCD7: '9311486',
  UCD13: '3400893114865',
  ucdQtyMultiplicator: 10,
  cipLib: "KETEK 400MG CPR ADP MWI BT 10",
  atcCode: "J01FA15"
}, {
  CIP7: '4950069',
  CIP13: '3400949500697',
  ucdLib: "KETEK 400MG CPR ADP PLA",
  UCD7: '9321705',
  UCD13: '3400893217054',
  ucdQtyMultiplicator: 10,
  cipLib: "KETEK 400MG CPR ADP PLA BT 10",
  atcCode: "J01FA15"
}, {
  CIP7: '3338107',
  CIP13: '3400933381073',
  ucdLib: "MOSIL 400MG CPR",
  UCD7: '9163502',
  UCD13: '3400891635027',
  ucdQtyMultiplicator: 20,
  cipLib: "MOSIL 400MG CPR BT 20",
  atcCode: "J01FA11"
}, {
  CIP7: '3560142',
  CIP13: '3400935601421',
  ucdLib: "MOSIL 800MG BUV PDR SACH",
  UCD7: '9231008',
  UCD13: '3400892310084',
  ucdQtyMultiplicator: 20,
  cipLib: "MOSIL 800MG BUV PDR SACH BT 20",
  atcCode: "J01FA11"
}, {
  CIP7: '2764658',
  CIP13: '3400927646584',
  ucdLib: "AZITHROMYCINE BGA 250MG CPR",
  UCD7: '9301625',
  UCD13: '3400893016251',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE BGA 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3433372',
  CIP13: '3400934333729',
  ucdLib: "AZADOSE 600MG CPR",
  UCD7: '9199285',
  UCD13: '3400891992854',
  ucdQtyMultiplicator: 8,
  cipLib: "AZADOSE 600MG CPR BT 8",
  atcCode: "J01FA10"
}, {
  CIP7: '3565642',
  CIP13: '3400935656421',
  ucdLib: "ZITHROMAX ENF BUV FL30ML+SRG",
  UCD7: '9232597',
  UCD13: '3400892325972',
  ucdQtyMultiplicator: 1,
  cipLib: "ZITHROMAX ENF BUV FL30ML+SRG BT 1",
  atcCode: "J01FA10"
}, {
  CIP7: '3565659',
  CIP13: '3400935656599',
  ucdLib: "ZITHROMAX ENF BUV FL37,5ML+SRG",
  UCD7: '9232605',
  UCD13: '3400892326054',
  ucdQtyMultiplicator: 1,
  cipLib: "ZITHROMAX ENF BUV FL37,5ML+SRG BT 1",
  atcCode: "J01FA10"
}, {
  CIP7: '3517755',
  CIP13: '3400935177551',
  ucdLib: "AZITHROMYCINE PFZ 250MG CPR",
  UCD7: '9328630',
  UCD13: '3400893286302',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE PFZ 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3517732',
  CIP13: '3400935177322',
  ucdLib: "ZITHROMAX 250MG CPR",
  UCD7: '9216842',
  UCD13: '3400892168425',
  ucdQtyMultiplicator: 6,
  cipLib: "ZITHROMAX 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3517778',
  CIP13: '3400935177780',
  ucdLib: "ZITHROMAX MONODOS 250MG CPR",
  UCD7: '9225060',
  UCD13: '3400892250601',
  ucdQtyMultiplicator: 4,
  cipLib: "ZITHROMAX MONODOS 250MG CPR BT 4",
  atcCode: "J01FA10"
}, {
  CIP7: '3745999',
  CIP13: '3400937459990',
  ucdLib: "AZITHROMYCINE EVO 250MG CPR",
  UCD7: '9352634',
  UCD13: '3400893526347',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE EVO 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3821387',
  CIP13: '3400938213874',
  ucdLib: "AZITHROMYCINE ARW 250MG CPR",
  UCD7: '9312741',
  UCD13: '3400893127414',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE ARW 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3794549',
  CIP13: '3400937945493',
  ucdLib: "AZITHROMYCINE EG 250MG CPR",
  UCD7: '9301306',
  UCD13: '3400893013069',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE EG 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3794578',
  CIP13: '3400937945783',
  ucdLib: "AZITHROMYCINE MYL 250MG CPR",
  UCD7: '9301312',
  UCD13: '3400893013120',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE MYL 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3793538',
  CIP13: '3400937935388',
  ucdLib: "AZITHROMYCINE SDZ 250MG CPR",
  UCD7: '9300494',
  UCD13: '3400893004944',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE SDZ 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3824061',
  CIP13: '3400938240610',
  ucdLib: "AZITHROMYCINE ZYD 250MG CPR",
  UCD7: '9309420',
  UCD13: '3400893094204',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE ZYD 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3802556',
  CIP13: '3400938025569',
  ucdLib: "AZITHROMYCINE RBX 250MG CPR",
  UCD7: '9302671',
  UCD13: '3400893026717',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE RBX 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3876282',
  CIP13: '3400938762822',
  ucdLib: "AZITHROMYCINE SDZ MONO250 CPR",
  UCD7: '9321616',
  UCD13: '3400893216163',
  ucdQtyMultiplicator: 4,
  cipLib: "AZITHROMYCINE SDZ MONO250 CPR BT 4",
  atcCode: "J01FA10"
}, {
  CIP7: '3950096',
  CIP13: '3400939500966',
  ucdLib: "AZITHROMYCINE CRT 250MG CPR",
  UCD7: '9337971',
  UCD13: '3400893379714',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE CRT 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3932282',
  CIP13: '3400939322827',
  ucdLib: "AZITHROMYCINE ZEN 250MG CPR",
  UCD7: '9334613',
  UCD13: '3400893346136',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE ZEN 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3953479',
  CIP13: '3400939534794',
  ucdLib: "ORDIPHA 500MG CPR DISP",
  UCD7: '9345663',
  UCD13: '3400893456637',
  ucdQtyMultiplicator: 3,
  cipLib: "ORDIPHA 500MG CPR DISP BT 3",
  atcCode: "J01FA10"
}, {
  CIP7: '2784833',
  CIP13: '3400927848339',
  ucdLib: "AZITHROMYCINE KRK 250MG CPR",
  UCD7: '9403722',
  UCD13: '3400894037224',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE KRK 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '2181170',
  CIP13: '3400921811704',
  ucdLib: "AZITHROMYCINE TVC 250MG CPR",
  UCD7: '9294701',
  UCD13: '3400892947013',
  ucdQtyMultiplicator: 6,
  cipLib: "AZITHROMYCINE TVC 250MG CPR BT 6",
  atcCode: "J01FA10"
}, {
  CIP7: '3456700',
  CIP13: '3400934567001',
  ucdLib: "CLARITHROMY.BIP 25MG/ML 100ML",
  UCD7: '9393691',
  UCD13: '3400893936917',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITHROMY.BIP 25MG/ML 100ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3456551',
  CIP13: '3400934565519',
  ucdLib: "ZECLAR 25MG/ML BUV FP100ML",
  UCD7: '9387130',
  UCD13: '3400893871300',
  ucdQtyMultiplicator: 1,
  cipLib: "ZECLAR 25MG/ML BUV FP100ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3057615',
  CIP13: '3400930576151',
  ucdLib: "CLARITHROMYCINE ARW 500 C.LM",
  UCD7: '9348934',
  UCD13: '3400893489345',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE ARW 500 C.LM BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3000437',
  CIP13: '3400930004371',
  ucdLib: "CLARITHROMYCINE EG 500 C.LM",
  UCD7: '9348928',
  UCD13: '3400893489284',
  ucdQtyMultiplicator: 5,
  cipLib: "CLARITHROMYCINE EG 500 C.LM BT 5",
  atcCode: "J01FA09"
}, {
  CIP7: '3034519',
  CIP13: '3400930345191',
  ucdLib: "CLARITHROMYCINE EG 500 C.LM",
  UCD7: '9348928',
  UCD13: '3400893489284',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE EG 500 C.LM BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3046132',
  CIP13: '3400930461327',
  ucdLib: "CLARITHROMYCINE ARW 500 C.LM",
  UCD7: '9348934',
  UCD13: '3400893489345',
  ucdQtyMultiplicator: 5,
  cipLib: "CLARITHROMYCINE ARW 500 C.LM BT 5",
  atcCode: "J01FA09"
}, {
  CIP7: '3686009',
  CIP13: '3400936860094',
  ucdLib: "CLARITHROMYCINE EG 500MG CPR",
  UCD7: '9276896',
  UCD13: '3400892768960',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE EG 500MG CPR BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3686015',
  CIP13: '3400936860155',
  ucdLib: "CLARITHROMYCINE EG 500MG CPR",
  UCD7: '9276896',
  UCD13: '3400892768960',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE EG 500MG CPR BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3686038',
  CIP13: '3400936860384',
  ucdLib: "CLARITHROMYCINE RBX 500MG CP",
  UCD7: '9276904',
  UCD13: '3400892769042',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE RBX 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3686044',
  CIP13: '3400936860445',
  ucdLib: "CLARITHROMYCINE RBX 500MG CP",
  UCD7: '9276904',
  UCD13: '3400892769042',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE RBX 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3341724',
  CIP13: '3400933417246',
  ucdLib: "CLARITHROMYCINE BIP 250MG CP",
  UCD7: '9159736',
  UCD13: '3400891597363',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE BIP 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3409741',
  CIP13: '3400934097416',
  ucdLib: "CLARITHROMYCINE BIP 500MG CP",
  UCD7: '9180191',
  UCD13: '3400891801910',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE BIP 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3340311',
  CIP13: '3400933403119',
  ucdLib: "ZECLAR 250MG CPR",
  UCD7: '9151367',
  UCD13: '3400891513677',
  ucdQtyMultiplicator: 10,
  cipLib: "ZECLAR 250MG CPR BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3678056',
  CIP13: '3400936780569',
  ucdLib: "CLARITHROMYCINE EG 250MG CPR",
  UCD7: '9271918',
  UCD13: '3400892719184',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE EG 250MG CPR BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3678033',
  CIP13: '3400936780330',
  ucdLib: "CLARITHROMYCINE RBX 250MG CP",
  UCD7: '9271924',
  UCD13: '3400892719245',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE RBX 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3850199',
  CIP13: '3400938501995',
  ucdLib: "CLARITHROMY.ARW 25MG/ML 100ML",
  UCD7: '9314390',
  UCD13: '3400893143902',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITHROMY.ARW 25MG/ML 100ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3850213',
  CIP13: '3400938502138',
  ucdLib: "CLARITHROMY.ARW 50MG/ML 60ML",
  UCD7: '9314409',
  UCD13: '3400893144091',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITHROMY.ARW 50MG/ML 60ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3850259',
  CIP13: '3400938502596',
  ucdLib: "CLARITHROMY.MYL 25MG/ML 100ML",
  UCD7: '9314496',
  UCD13: '3400893144961',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITHROMY.MYL 25MG/ML 100ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3850271',
  CIP13: '3400938502718',
  ucdLib: "CLARITHROMY.MYL 50MG/ML 60ML",
  UCD7: '9314504',
  UCD13: '3400893145043',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITHROMY.MYL 50MG/ML 60ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3850130',
  CIP13: '3400938501308',
  ucdLib: "CLARITHROMY.SDZ 25MG/ML 100ML",
  UCD7: '9314510',
  UCD13: '3400893145104',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITHROMY.SDZ 25MG/ML 100ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3850153',
  CIP13: '3400938501537',
  ucdLib: "CLARITHROMY.SDZ 50MG/ML 60ML",
  UCD7: '9314527',
  UCD13: '3400893145272',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITHROMY.SDZ 50MG/ML 60ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3855363',
  CIP13: '3400938553635',
  ucdLib: "CLARITHROMYCINE TVC 250MG CP",
  UCD7: '9314533',
  UCD13: '3400893145333',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE TVC 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3853654',
  CIP13: '3400938536546',
  ucdLib: "CLARITHROMYCINE ZYD 250MG CP",
  UCD7: '9316756',
  UCD13: '3400893167564',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE ZYD 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3853921',
  CIP13: '3400938539219',
  ucdLib: "CLARITHROMYCINE ZYD 500MG CP",
  UCD7: '9316762',
  UCD13: '3400893167625',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE ZYD 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3853944',
  CIP13: '3400938539448',
  ucdLib: "CLARITHROMYCINE ZYD 500MG CP",
  UCD7: '9316762',
  UCD13: '3400893167625',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE ZYD 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3558435',
  CIP13: '3400935584359',
  ucdLib: "ZECLAR 0,5G INJ FL15ML",
  UCD7: '9229804',
  UCD13: '3400892298047',
  ucdQtyMultiplicator: 1,
  cipLib: "ZECLAR 0,5G INJ FL15ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3487362',
  CIP13: '3400934873621',
  ucdLib: "CLARITHROMYCINE BIP 500MG CP",
  UCD7: '9180191',
  UCD13: '3400891801910',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE BIP 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3655428',
  CIP13: '3400936554283',
  ucdLib: "CLARITHROMYCINE MYP 500 C.LM",
  UCD7: '9274472',
  UCD13: '3400892744728',
  ucdQtyMultiplicator: 5,
  cipLib: "CLARITHROMYCINE MYP 500 C.LM BT 5",
  atcCode: "J01FA09"
}, {
  CIP7: '3655463',
  CIP13: '3400936554634',
  ucdLib: "CLARITHROMYCINE MYP 500 C.LM",
  UCD7: '9274472',
  UCD13: '3400892744728',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE MYP 500 C.LM BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3655339',
  CIP13: '3400936553392',
  ucdLib: "MONOZECLAR 500MG LM CPR",
  UCD7: '9275431',
  UCD13: '3400892754314',
  ucdQtyMultiplicator: 5,
  cipLib: "MONOZECLAR 500MG LM CPR BT 5",
  atcCode: "J01FA09"
}, {
  CIP7: '3655374',
  CIP13: '3400936553743',
  ucdLib: "MONOZECLAR 500MG LM CPR",
  UCD7: '9275431',
  UCD13: '3400892754314',
  ucdQtyMultiplicator: 10,
  cipLib: "MONOZECLAR 500MG LM CPR BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3817925',
  CIP13: '3400938179255',
  ucdLib: "CLARITHROMYCINE TVC 500MG CP",
  UCD7: '9311492',
  UCD13: '3400893114926',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE TVC 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3817931',
  CIP13: '3400938179316',
  ucdLib: "CLARITHROMYCINE TVC 500MG CP",
  UCD7: '9311492',
  UCD13: '3400893114926',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE TVC 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3817948',
  CIP13: '3400938179484',
  ucdLib: "CLARITHROMYCINE TVC 500MG CP",
  UCD7: '9311492',
  UCD13: '3400893114926',
  ucdQtyMultiplicator: 30,
  cipLib: "CLARITHROMYCINE TVC 500MG CP BT 30",
  atcCode: "J01FA09"
}, {
  CIP7: '3380138',
  CIP13: '3400933801380',
  ucdLib: "ZECLAR 500MG CPR",
  UCD7: '9171364',
  UCD13: '3400891713640',
  ucdQtyMultiplicator: 10,
  cipLib: "ZECLAR 500MG CPR BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3382806',
  CIP13: '3400933828066',
  ucdLib: "ZECLAR 500MG CPR",
  UCD7: '9171364',
  UCD13: '3400891713640',
  ucdQtyMultiplicator: 14,
  cipLib: "ZECLAR 500MG CPR BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3478535',
  CIP13: '3400934785351',
  ucdLib: "ZECLAR 50MG/ML BUV FP60ML",
  UCD7: '9398435',
  UCD13: '3400893984352',
  ucdQtyMultiplicator: 1,
  cipLib: "ZECLAR 50MG/ML BUV FP60ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '3808837',
  CIP13: '3400938088373',
  ucdLib: "CLARITHROMYCINE ARW 250MG CP",
  UCD7: '9306539',
  UCD13: '3400893065396',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE ARW 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3809067',
  CIP13: '3400938090673',
  ucdLib: "CLARITHROMYCINE ARW 500MG CP",
  UCD7: '9306545',
  UCD13: '3400893065457',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE ARW 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3809073',
  CIP13: '3400938090734',
  ucdLib: "CLARITHROMYCINE ARW 500MG CP",
  UCD7: '9306545',
  UCD13: '3400893065457',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE ARW 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3808671',
  CIP13: '3400938086713',
  ucdLib: "CLARITHROMYCINE MYL 250MG CP",
  UCD7: '9306516',
  UCD13: '3400893065167',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE MYL 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3808725',
  CIP13: '3400938087253',
  ucdLib: "CLARITHROMYCINE MYL 500MG CP",
  UCD7: '9306522',
  UCD13: '3400893065228',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE MYL 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3808731',
  CIP13: '3400938087314',
  ucdLib: "CLARITHROMYCINE MYL 500MG CP",
  UCD7: '9306522',
  UCD13: '3400893065228',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE MYL 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3808777',
  CIP13: '3400938087772',
  ucdLib: "CLARITHROMYCINE SDZ 250MG CP",
  UCD7: '9306574',
  UCD13: '3400893065747',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE SDZ 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3808955',
  CIP13: '3400938089554',
  ucdLib: "CLARITHROMYCINE SDZ 500MG CP",
  UCD7: '9306580',
  UCD13: '3400893065808',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE SDZ 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3808961',
  CIP13: '3400938089615',
  ucdLib: "CLARITHROMYCINE SDZ 500MG CP",
  UCD7: '9306580',
  UCD13: '3400893065808',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE SDZ 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3849894',
  CIP13: '3400938498943',
  ucdLib: "CLARITHROMYCINE ALM 250MG CP",
  UCD7: '9314094',
  UCD13: '3400893140949',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE ALM 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3849049',
  CIP13: '3400938490497',
  ucdLib: "CLARITHROMYCINE ALM 500MG CP",
  UCD7: '9314102',
  UCD13: '3400893141021',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE ALM 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3849061',
  CIP13: '3400938490619',
  ucdLib: "CLARITHROMYCINE ALM 500MG CP",
  UCD7: '9314102',
  UCD13: '3400893141021',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE ALM 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3849813',
  CIP13: '3400938498134',
  ucdLib: "CLARITHROMYCINE BGA 250MG CP",
  UCD7: '9313516',
  UCD13: '3400893135167',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE BGA 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3849150',
  CIP13: '3400938491500',
  ucdLib: "CLARITHROMYCINE BGA 500MG CP",
  UCD7: '9313522',
  UCD13: '3400893135228',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE BGA 500MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3849173',
  CIP13: '3400938491739',
  ucdLib: "CLARITHROMYCINE BGA 500MG CP",
  UCD7: '9313522',
  UCD13: '3400893135228',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE BGA 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '3849411',
  CIP13: '3400938494112',
  ucdLib: "CLARITHROMYCINE EVO 250MG CP",
  UCD7: '9316377',
  UCD13: '3400893163771',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE EVO 250MG CP BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3849316',
  CIP13: '3400938493160',
  ucdLib: "CLARITHROMYCINE EVO 500MG CP",
  UCD7: '9316383',
  UCD13: '3400893163832',
  ucdQtyMultiplicator: 14,
  cipLib: "CLARITHROMYCINE EVO 500MG CP BT 14",
  atcCode: "J01FA09"
}, {
  CIP7: '2668334',
  CIP13: '3400926683344',
  ucdLib: "CLARITHROMY.BIP 50MG/ML 60ML",
  UCD7: '9393716',
  UCD13: '3400893937167',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARITHROMY.BIP 50MG/ML 60ML BT 1",
  atcCode: "J01FA09"
}, {
  CIP7: '4948629',
  CIP13: '3400949486298',
  ucdLib: "CLARITHROMYCINE EVO 500 C.LM",
  UCD7: '9363000',
  UCD13: '3400893630006',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE EVO 500 C.LM BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '4940740',
  CIP13: '3400949407408',
  ucdLib: "CLARITHROMYCINE MYL 500 C.LM",
  UCD7: '9361099',
  UCD13: '3400893610992',
  ucdQtyMultiplicator: 5,
  cipLib: "CLARITHROMYCINE MYL 500 C.LM BT 5",
  atcCode: "J01FA09"
}, {
  CIP7: '4940792',
  CIP13: '3400949407927',
  ucdLib: "CLARITHROMYCINE MYL 500 C.LM",
  UCD7: '9361099',
  UCD13: '3400893610992',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE MYL 500 C.LM BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '4940852',
  CIP13: '3400949408528',
  ucdLib: "CLARITHROMYCINE TVC 500 C.LM",
  UCD7: '9360177',
  UCD13: '3400893601778',
  ucdQtyMultiplicator: 5,
  cipLib: "CLARITHROMYCINE TVC 500 C.LM BT 5",
  atcCode: "J01FA09"
}, {
  CIP7: '4940898',
  CIP13: '3400949408986',
  ucdLib: "CLARITHROMYCINE TVC 500 C.LM",
  UCD7: '9360177',
  UCD13: '3400893601778',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE TVC 500 C.LM BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3998861',
  CIP13: '3400939988610',
  ucdLib: "CLARITHROMYCINE BGA 500 C.LM",
  UCD7: '9348302',
  UCD13: '3400893483022',
  ucdQtyMultiplicator: 5,
  cipLib: "CLARITHROMYCINE BGA 500 C.LM BT 5",
  atcCode: "J01FA09"
}, {
  CIP7: '3998909',
  CIP13: '3400939989099',
  ucdLib: "CLARITHROMYCINE BGA 500 C.LM",
  UCD7: '9348302',
  UCD13: '3400893483022',
  ucdQtyMultiplicator: 10,
  cipLib: "CLARITHROMYCINE BGA 500 C.LM BT 10",
  atcCode: "J01FA09"
}, {
  CIP7: '3230628',
  CIP13: '3400932306282',
  ucdLib: "JOSACINE 125MG BUV GLE FL60ML",
  UCD7: '9048103',
  UCD13: '3400890481038',
  ucdQtyMultiplicator: 1,
  cipLib: "JOSACINE 125MG BUV GLE FL60ML BT 1",
  atcCode: "J01FA07"
}, {
  CIP7: '3230700',
  CIP13: '3400932307005',
  ucdLib: "JOSACINE 250MG BUV GLE FL60ML",
  UCD7: '9048126',
  UCD13: '3400890481267',
  ucdQtyMultiplicator: 1,
  cipLib: "JOSACINE 250MG BUV GLE FL60ML BT 1",
  atcCode: "J01FA07"
}, {
  CIP7: '3236016',
  CIP13: '3400932360161',
  ucdLib: "JOSACINE 500MG BUV GLE FL60ML",
  UCD7: '9048149',
  UCD13: '3400890481496',
  ucdQtyMultiplicator: 1,
  cipLib: "JOSACINE 500MG BUV GLE FL60ML BT 1",
  atcCode: "J01FA07"
}, {
  CIP7: '3230692',
  CIP13: '3400932306923',
  ucdLib: "JOSACINE 500MG CPR",
  UCD7: '9048132',
  UCD13: '3400890481328',
  ucdQtyMultiplicator: 20,
  cipLib: "JOSACINE 500MG CPR BT 20",
  atcCode: "J01FA07"
}, {
  CIP7: '3394117',
  CIP13: '3400933941178',
  ucdLib: "JOSACINE 1000MG CPR DISP",
  UCD7: '9178194',
  UCD13: '3400891781946',
  ucdQtyMultiplicator: 10,
  cipLib: "JOSACINE 1000MG CPR DISP BT 10",
  atcCode: "J01FA07"
}, {
  CIP7: '3612614',
  CIP13: '3400936126145',
  ucdLib: "ROXITHROMYCINE ARW 150MG CPR",
  UCD7: '9249882',
  UCD13: '3400892498829',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE ARW 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3612620',
  CIP13: '3400936126206',
  ucdLib: "ROXITHROMYCINE ARW 150MG CPR",
  UCD7: '9249882',
  UCD13: '3400892498829',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE ARW 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3612560',
  CIP13: '3400936125605',
  ucdLib: "ROXITHROMYCINE BGA 150MG CPR",
  UCD7: '9248061',
  UCD13: '3400892480619',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE BGA 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3612577',
  CIP13: '3400936125773',
  ucdLib: "ROXITHROMYCINE BGA 150MG CPR",
  UCD7: '9248061',
  UCD13: '3400892480619',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE BGA 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3617072',
  CIP13: '3400936170728',
  ucdLib: "ROXITHROMYCINE EG 150MG CPR",
  UCD7: '9254498',
  UCD13: '3400892544984',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE EG 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3617089',
  CIP13: '3400936170896',
  ucdLib: "ROXITHROMYCINE EG 150MG CPR",
  UCD7: '9254498',
  UCD13: '3400892544984',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE EG 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3612896',
  CIP13: '3400936128965',
  ucdLib: "ROXITHROMYCINE MYL 150MG CPR",
  UCD7: '9248919',
  UCD13: '3400892489193',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE MYL 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3612927',
  CIP13: '3400936129276',
  ucdLib: "ROXITHROMYCINE MYL 150MG CPR",
  UCD7: '9248919',
  UCD13: '3400892489193',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE MYL 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3613157',
  CIP13: '3400936131576',
  ucdLib: "ROXITHROMYCINE TVC 100MG CPR",
  UCD7: '9249391',
  UCD13: '3400892493916',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE TVC 100MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3613163',
  CIP13: '3400936131637',
  ucdLib: "ROXITHROMYCINE TVC 100MG CPR",
  UCD7: '9249391',
  UCD13: '3400892493916',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE TVC 100MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3612637',
  CIP13: '3400936126374',
  ucdLib: "ROXITHROMYCINE TVC 150MG CPR",
  UCD7: '9249416',
  UCD13: '3400892494166',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE TVC 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3612643',
  CIP13: '3400936126435',
  ucdLib: "ROXITHROMYCINE TVC 150MG CPR",
  UCD7: '9249416',
  UCD13: '3400892494166',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE TVC 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3290381',
  CIP13: '3400932903818',
  ucdLib: "RULID 150MG CPR",
  UCD7: '9117100',
  UCD13: '3400891171006',
  ucdQtyMultiplicator: 10,
  cipLib: "RULID 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3609144',
  CIP13: '3400936091443',
  ucdLib: "ROXITHROMYCINE SDZ 150MG C.S",
  UCD7: '9248078',
  UCD13: '3400892480787',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE SDZ 150MG C.S BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3609150',
  CIP13: '3400936091504',
  ucdLib: "ROXITHROMYCINE SDZ 150MG C.S",
  UCD7: '9248078',
  UCD13: '3400892480787',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE SDZ 150MG C.S BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3376131',
  CIP13: '3400933761318',
  ucdLib: "RULID 150MG CPR",
  UCD7: '9117100',
  UCD13: '3400891171006',
  ucdQtyMultiplicator: 16,
  cipLib: "RULID 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3437329',
  CIP13: '3400934373299',
  ucdLib: "RULID 50MG CPR BUV",
  UCD7: '9187572',
  UCD13: '3400891875720',
  ucdQtyMultiplicator: 16,
  cipLib: "RULID 50MG CPR BUV BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3395364',
  CIP13: '3400933953645',
  ucdLib: "RULID 50MG CPR BUV",
  UCD7: '9187572',
  UCD13: '3400891875720',
  ucdQtyMultiplicator: 10,
  cipLib: "RULID 50MG CPR BUV BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3621760',
  CIP13: '3400936217607',
  ucdLib: "ROXITHROMYCINE RTP 150MG CPR",
  UCD7: '9250299',
  UCD13: '3400892502991',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE RTP 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3621777',
  CIP13: '3400936217775',
  ucdLib: "ROXITHROMYCINE RTP 150MG CPR",
  UCD7: '9250299',
  UCD13: '3400892502991',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE RTP 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3621783',
  CIP13: '3400936217836',
  ucdLib: "ROXITHROMYCINE ZYD 150MG CPR",
  UCD7: '9266225',
  UCD13: '3400892662251',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE ZYD 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3621808',
  CIP13: '3400936218086',
  ucdLib: "ROXITHROMYCINE ZYD 150MG CPR",
  UCD7: '9266225',
  UCD13: '3400892662251',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE ZYD 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3781297',
  CIP13: '3400937812979',
  ucdLib: "ROXITHROMYCINE RBX 150MG C.",
  UCD7: '9298314',
  UCD13: '3400892983141',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE RBX 150MG C. BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3781305',
  CIP13: '3400937813051',
  ucdLib: "ROXITHROMYCINE RBX 150MG C.",
  UCD7: '9298314',
  UCD13: '3400892983141',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE RBX 150MG C. BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3781311',
  CIP13: '3400937813112',
  ucdLib: "ROXITHROMYCINE ZEN 150MG CPR",
  UCD7: '9270215',
  UCD13: '3400892702155',
  ucdQtyMultiplicator: 10,
  cipLib: "ROXITHROMYCINE ZEN 150MG CPR BT 10",
  atcCode: "J01FA06"
}, {
  CIP7: '3781328',
  CIP13: '3400937813280',
  ucdLib: "ROXITHROMYCINE ZEN 150MG CPR",
  UCD7: '9270215',
  UCD13: '3400892702155',
  ucdQtyMultiplicator: 16,
  cipLib: "ROXITHROMYCINE ZEN 150MG CPR BT 16",
  atcCode: "J01FA06"
}, {
  CIP7: '3324708',
  CIP13: '3400933247089',
  ucdLib: "ROVAMYCINE 3MN CPR",
  UCD7: '9144545',
  UCD13: '3400891445459',
  ucdQtyMultiplicator: 10,
  cipLib: "ROVAMYCINE 3MN CPR BT 10",
  atcCode: "J01FA02"
}, {
  CIP7: '5559545',
  CIP13: '3400955595458',
  ucdLib: "ROVAMYCINE 1,5MN INJ FL",
  UCD7: '9121426',
  UCD13: '3400891214260',
  ucdQtyMultiplicator: 1,
  cipLib: "ROVAMYCINE 1,5MN INJ FL BT 1",
  atcCode: "J01FA02"
}, {
  CIP7: '3124168',
  CIP13: '3400931241683',
  ucdLib: "ROVAMYCINE 1,5MN CPR",
  UCD7: '9081224',
  UCD13: '3400890812245',
  ucdQtyMultiplicator: 16,
  cipLib: "ROVAMYCINE 1,5MN CPR BT 16",
  atcCode: "J01FA02"
}, {
  CIP7: '3435974',
  CIP13: '3400934359743',
  ucdLib: "ROVAMYCINE 3MN CPR",
  UCD7: '9144545',
  UCD13: '3400891445459',
  ucdQtyMultiplicator: 16,
  cipLib: "ROVAMYCINE 3MN CPR BT 16",
  atcCode: "J01FA02"
}, {
  CIP7: '5583207',
  CIP13: '3400955832072',
  ucdLib: "ROVAMYCINE 3MN CPR",
  UCD7: '9144545',
  UCD13: '3400891445459',
  ucdQtyMultiplicator: 100,
  cipLib: "ROVAMYCINE 3MN CPR BT 100",
  atcCode: "J01FA02"
}, {
  CIP7: '3763454',
  CIP13: '3400937634540',
  ucdLib: "SPIRAMYCINE BGA 3MUI CPR",
  UCD7: '9291631',
  UCD13: '3400892916316',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE BGA 3MUI CPR BT 10",
  atcCode: "J01FA02"
}, {
  CIP7: '3763460',
  CIP13: '3400937634601',
  ucdLib: "SPIRAMYCINE BGA 3MUI CPR",
  UCD7: '9291631',
  UCD13: '3400892916316',
  ucdQtyMultiplicator: 16,
  cipLib: "SPIRAMYCINE BGA 3MUI CPR BT 16",
  atcCode: "J01FA02"
}, {
  CIP7: '3746059',
  CIP13: '3400937460590',
  ucdLib: "SPIRAMYCINE CRT 3MUI CPR",
  UCD7: '9351988',
  UCD13: '3400893519882',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE CRT 3MUI CPR BT 10",
  atcCode: "J01FA02"
}, {
  CIP7: '3746088',
  CIP13: '3400937460880',
  ucdLib: "SPIRAMYCINE CRT 3MUI CPR",
  UCD7: '9351988',
  UCD13: '3400893519882',
  ucdQtyMultiplicator: 16,
  cipLib: "SPIRAMYCINE CRT 3MUI CPR BT 16",
  atcCode: "J01FA02"
}, {
  CIP7: '3763431',
  CIP13: '3400937634311',
  ucdLib: "SPIRAMYCINE EG 3MUI CPR",
  UCD7: '9291625',
  UCD13: '3400892916255',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE EG 3MUI CPR BT 10",
  atcCode: "J01FA02"
}, {
  CIP7: '3763448',
  CIP13: '3400937634489',
  ucdLib: "SPIRAMYCINE EG 3MUI CPR",
  UCD7: '9291625',
  UCD13: '3400892916255',
  ucdQtyMultiplicator: 16,
  cipLib: "SPIRAMYCINE EG 3MUI CPR BT 16",
  atcCode: "J01FA02"
}, {
  CIP7: '3746119',
  CIP13: '3400937461191',
  ucdLib: "SPIRAMYCINE MYL 3MUI CPR",
  UCD7: '9353444',
  UCD13: '3400893534441',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE MYL 3MUI CPR BT 10",
  atcCode: "J01FA02"
}, {
  CIP7: '3746148',
  CIP13: '3400937461481',
  ucdLib: "SPIRAMYCINE MYL 3MUI CPR",
  UCD7: '9353444',
  UCD13: '3400893534441',
  ucdQtyMultiplicator: 16,
  cipLib: "SPIRAMYCINE MYL 3MUI CPR BT 16",
  atcCode: "J01FA02"
}, {
  CIP7: '3763477',
  CIP13: '3400937634779',
  ucdLib: "SPIRAMYCINE SDZ 3MUI CPR",
  UCD7: '9291619',
  UCD13: '3400892916194',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE SDZ 3MUI CPR BT 10",
  atcCode: "J01FA02"
}, {
  CIP7: '3763483',
  CIP13: '3400937634830',
  ucdLib: "SPIRAMYCINE SDZ 3MUI CPR",
  UCD7: '9291619',
  UCD13: '3400892916194',
  ucdQtyMultiplicator: 16,
  cipLib: "SPIRAMYCINE SDZ 3MUI CPR BT 16",
  atcCode: "J01FA02"
}, {
  CIP7: '3763419',
  CIP13: '3400937634199',
  ucdLib: "SPIRAMYCINE TVC 3MUI CPR",
  UCD7: '9291648',
  UCD13: '3400892916484',
  ucdQtyMultiplicator: 10,
  cipLib: "SPIRAMYCINE TVC 3MUI CPR BT 10",
  atcCode: "J01FA02"
}, {
  CIP7: '3763425',
  CIP13: '3400937634250',
  ucdLib: "SPIRAMYCINE TVC 3MUI CPR",
  UCD7: '9291648',
  UCD13: '3400892916484',
  ucdQtyMultiplicator: 16,
  cipLib: "SPIRAMYCINE TVC 3MUI CPR BT 16",
  atcCode: "J01FA02"
}, {
  CIP7: '3242560',
  CIP13: '3400932425600',
  ucdLib: "ERY 125MG GLE SACH",
  UCD7: '9032071',
  UCD13: '3400890320719',
  ucdQtyMultiplicator: 24,
  cipLib: "ERY 125MG GLE SACH BT 24",
  atcCode: "J01FA01"
}, {
  CIP7: '3242554',
  CIP13: '3400932425549',
  ucdLib: "ERY 250MG GLE SACH",
  UCD7: '9032088',
  UCD13: '3400890320887',
  ucdQtyMultiplicator: 24,
  cipLib: "ERY 250MG GLE SACH BT 24",
  atcCode: "J01FA01"
}, {
  CIP7: '3249585',
  CIP13: '3400932495856',
  ucdLib: "ERYTHROCINE 1000 GLE SACH AL",
  UCD7: '9032148',
  UCD13: '3400890321488',
  ucdQtyMultiplicator: 10,
  cipLib: "ERYTHROCINE 1000 GLE SACH AL BT 10",
  atcCode: "J01FA01"
}, {
  CIP7: '3249929',
  CIP13: '3400932499298',
  ucdLib: "ERYTHROCINE 500 CPR PELLIC",
  UCD7: '9032160',
  UCD13: '3400890321600',
  ucdQtyMultiplicator: 20,
  cipLib: "ERYTHROCINE 500 CPR PELLIC BT 20",
  atcCode: "J01FA01"
}, {
  CIP7: '3223887',
  CIP13: '3400932238873',
  ucdLib: "ERY 500MG CPR",
  UCD7: '9032094',
  UCD13: '3400890320948',
  ucdQtyMultiplicator: 20,
  cipLib: "ERY 500MG CPR BT 20",
  atcCode: "J01FA01"
}, {
  CIP7: '5575188',
  CIP13: '3400955751885',
  ucdLib: "ERYTHROCINE 0,5G LYOT IV FL",
  UCD7: '9155661',
  UCD13: '3400891556612',
  ucdQtyMultiplicator: 1,
  cipLib: "ERYTHROCINE 0,5G LYOT IV FL BT 1",
  atcCode: "J01FA01"
}, {
  CIP7: '3357814',
  CIP13: '3400933578145',
  ucdLib: "EGERY 250MG GELU",
  UCD7: '9162684',
  UCD13: '3400891626841',
  ucdQtyMultiplicator: 20,
  cipLib: "EGERY 250MG GELU BT 20",
  atcCode: "J01FA01"
}, {
  CIP7: '3357820',
  CIP13: '3400933578206',
  ucdLib: "EGERY 250MG GELU",
  UCD7: '9162684',
  UCD13: '3400891626841',
  ucdQtyMultiplicator: 40,
  cipLib: "EGERY 250MG GELU BT 40",
  atcCode: "J01FA01"
}, {
  CIP7: '3202158',
  CIP13: '3400932021581',
  ucdLib: "ERYTHROCINE 500 GLE SACH ALU",
  UCD7: '9032177',
  UCD13: '3400890321778',
  ucdQtyMultiplicator: 12,
  cipLib: "ERYTHROCINE 500 GLE SACH ALU BT 12",
  atcCode: "J01FA01"
}, {
  CIP7: '5528059',
  CIP13: '3400955280590',
  ucdLib: "ERYTHROCINE 1G IV FV1,5G",
  UCD7: '9121811',
  UCD13: '3400891218114',
  ucdQtyMultiplicator: 1,
  cipLib: "ERYTHROCINE 1G IV FV1,5G BT 1",
  atcCode: "J01FA01"
}, {
  CIP7: '5544348',
  CIP13: '3400955443483',
  ucdLib: "BACTRIM ADULTE CPR",
  UCD7: '9009008',
  UCD13: '3400890090087',
  ucdQtyMultiplicator: 50,
  cipLib: "BACTRIM ADULTE CPR BT 50",
  atcCode: "J01EE01"
}, {
  CIP7: '5544354',
  CIP13: '3400955443544',
  ucdLib: "BACTRIM FORTE CPR",
  UCD7: '9009043',
  UCD13: '3400890090438',
  ucdQtyMultiplicator: 50,
  cipLib: "BACTRIM FORTE CPR BT 50",
  atcCode: "J01EE01"
}, {
  CIP7: '3001069',
  CIP13: '3400930010693',
  ucdLib: "BACTRIM ADULTE CPR",
  UCD7: '9009008',
  UCD13: '3400890090087',
  ucdQtyMultiplicator: 20,
  cipLib: "BACTRIM ADULTE CPR BT 20",
  atcCode: "J01EE01"
}, {
  CIP7: '5571612',
  CIP13: '3400955716129',
  ucdLib: "BACTRIM PERF AMP5ML",
  UCD7: '9121515',
  UCD13: '3400891215151',
  ucdQtyMultiplicator: 6,
  cipLib: "BACTRIM PERF AMP5ML BT 6",
  atcCode: "J01EE01"
}, {
  CIP7: '3130536',
  CIP13: '3400931305361',
  ucdLib: "BACTRIM PEDIA BUV FL100ML",
  UCD7: '9009014',
  UCD13: '3400890090148',
  ucdQtyMultiplicator: 1,
  cipLib: "BACTRIM PEDIA BUV FL100ML BT 1",
  atcCode: "J01EE01"
}, {
  CIP7: '3219704',
  CIP13: '3400932197040',
  ucdLib: "BACTRIM FORTE CPR",
  UCD7: '9009043',
  UCD13: '3400890090438',
  ucdQtyMultiplicator: 10,
  cipLib: "BACTRIM FORTE CPR BT 10",
  atcCode: "J01EE01"
}, {
  CIP7: '3491754',
  CIP13: '3400934917547',
  ucdLib: "COTRIMOXAZOLE TVC CPR",
  UCD7: '9209090',
  UCD13: '3400892090900',
  ucdQtyMultiplicator: 10,
  cipLib: "COTRIMOXAZOLE TVC CPR BT 10",
  atcCode: "J01EE01"
}, {
  CIP7: '3001230',
  CIP13: '3400930012307',
  ucdLib: "ADIAZINE 500MG CPR",
  UCD7: '9001194',
  UCD13: '3400890011945',
  ucdQtyMultiplicator: 20,
  cipLib: "ADIAZINE 500MG CPR BT 20",
  atcCode: "J01EC02"
}, {
  CIP7: '3093315',
  CIP13: '3400930933152',
  ucdLib: "RUFOL CPR",
  UCD7: '9081359',
  UCD13: '3400890813594',
  ucdQtyMultiplicator: 50,
  cipLib: "RUFOL CPR BT 50",
  atcCode: "J01EB02"
}, {
  CIP7: '3003623',
  CIP13: '3400930036235',
  ucdLib: "ZERBAXA 1G/0,5G PERF FL",
  UCD7: '9413956',
  UCD13: '3400894139560',
  ucdQtyMultiplicator: 10,
  cipLib: "ZERBAXA 1G/0,5G PERF FL BT 10",
  atcCode: "J01DI54"
}, {
  CIP7: '2681843',
  CIP13: '3400926818432',
  ucdLib: "ZINFORO 600MG PERF FL",
  UCD7: '9389904',
  UCD13: '3400893899045',
  ucdQtyMultiplicator: 10,
  cipLib: "ZINFORO 600MG PERF FL BT 10",
  atcCode: "J01DI02"
}, {
  CIP7: '2773166',
  CIP13: '3400927731662',
  ucdLib: "MABELIO 500MG PERF FL20ML",
  UCD7: '9403952',
  UCD13: '3400894039525',
  ucdQtyMultiplicator: 10,
  cipLib: "MABELIO 500MG PERF FL20ML BT 10",
  atcCode: "J01DI01"
}, {
  CIP7: '3833700',
  CIP13: '3400938337006',
  ucdLib: "TIENAM 500/500MG IV FL20ML",
  UCD7: '9313226',
  UCD13: '3400893132265',
  ucdQtyMultiplicator: 1,
  cipLib: "TIENAM 500/500MG IV FL20ML BT 1",
  atcCode: "J01DH51"
}, {
  CIP7: '3006005',
  CIP13: '3400930060056',
  ucdLib: "IMIPEN/CIL.ARW 500/500 20ML",
  UCD7: '9354219',
  UCD13: '3400893542194',
  ucdQtyMultiplicator: 1,
  cipLib: "IMIPEN/CIL.ARW 500/500 20ML BT 1",
  atcCode: "J01DH51"
}, {
  CIP7: '4917273',
  CIP13: '3400949172733',
  ucdLib: "IMIPEN/CIL.MYL 500/500 30ML",
  UCD7: '9352930',
  UCD13: '3400893529300',
  ucdQtyMultiplicator: 1,
  cipLib: "IMIPEN/CIL.MYL 500/500 30ML BT 1",
  atcCode: "J01DH51"
}, {
  CIP7: '4917296',
  CIP13: '3400949172962',
  ucdLib: "IMIPEN/CIL.MYL 500/500 30ML",
  UCD7: '9352930',
  UCD13: '3400893529300',
  ucdQtyMultiplicator: 10,
  cipLib: "IMIPEN/CIL.MYL 500/500 30ML BT 10",
  atcCode: "J01DH51"
}, {
  CIP7: '5759787',
  CIP13: '3400957597870',
  ucdLib: "IMIPEN/CIL.KBI 250/250 20ML",
  UCD7: '9343262',
  UCD13: '3400893432624',
  ucdQtyMultiplicator: 10,
  cipLib: "IMIPEN/CIL.KBI 250/250 20ML BT 10",
  atcCode: "J01DH51"
}, {
  CIP7: '5770085',
  CIP13: '3400957700850',
  ucdLib: "IMIPEN/CIL.HPF 500/500 20ML",
  UCD7: '9359062',
  UCD13: '3400893590621',
  ucdQtyMultiplicator: 5,
  cipLib: "IMIPEN/CIL.HPF 500/500 20ML BT 5",
  atcCode: "J01DH51"
}, {
  CIP7: '5770151',
  CIP13: '3400957701512',
  ucdLib: "IMIPEN/CIL.PAN 500/500 20ML",
  UCD7: '9353088',
  UCD13: '3400893530887',
  ucdQtyMultiplicator: 10,
  cipLib: "IMIPEN/CIL.PAN 500/500 20ML BT 10",
  atcCode: "J01DH51"
}, {
  CIP7: '5778603',
  CIP13: '3400957786038',
  ucdLib: "IMIPEN/CIL.RBX 500/500 30ML",
  UCD7: '9395218',
  UCD13: '3400893952184',
  ucdQtyMultiplicator: 10,
  cipLib: "IMIPEN/CIL.RBX 500/500 30ML BT 10",
  atcCode: "J01DH51"
}, {
  CIP7: '5769751',
  CIP13: '3400957697518',
  ucdLib: "IMIPEN/CIL.ARW 250/250 20ML",
  UCD7: '9357608',
  UCD13: '3400893576083',
  ucdQtyMultiplicator: 1,
  cipLib: "IMIPEN/CIL.ARW 250/250 20ML BT 1",
  atcCode: "J01DH51"
}, {
  CIP7: '5769805',
  CIP13: '3400957698058',
  ucdLib: "IMIPEN/CIL.ARW 500/500 20ML",
  UCD7: '9354219',
  UCD13: '3400893542194',
  ucdQtyMultiplicator: 10,
  cipLib: "IMIPEN/CIL.ARW 500/500 20ML BT 10",
  atcCode: "J01DH51"
}, {
  CIP7: '5764216',
  CIP13: '3400957642167',
  ucdLib: "IMIPEN/CIL.KBI 500/500 20ML",
  UCD7: '9343279',
  UCD13: '3400893432792',
  ucdQtyMultiplicator: 10,
  cipLib: "IMIPEN/CIL.KBI 500/500 20ML BT 10",
  atcCode: "J01DH51"
}, {
  CIP7: '5649165',
  CIP13: '3400956491650',
  ucdLib: "INVANZ 1G INJ FL",
  UCD7: '9250572',
  UCD13: '3400892505725',
  ucdQtyMultiplicator: 1,
  cipLib: "INVANZ 1G INJ FL BT 1",
  atcCode: "J01DH03"
}, {
  CIP7: '3004107',
  CIP13: '3400930041079',
  ucdLib: "MEROPENEM ACT 1G INJ FL",
  UCD7: '9394549',
  UCD13: '3400893945490',
  ucdQtyMultiplicator: 10,
  cipLib: "MEROPENEM ACT 1G INJ FL BT 10",
  atcCode: "J01DH02"
}, {
  CIP7: '4912525',
  CIP13: '3400949125258',
  ucdLib: "MEROPENEM PAN 1G INJ FL",
  UCD7: '9353823',
  UCD13: '3400893538234',
  ucdQtyMultiplicator: 10,
  cipLib: "MEROPENEM PAN 1G INJ FL BT 10",
  atcCode: "J01DH02"
}, {
  CIP7: '3878306',
  CIP13: '3400938783063',
  ucdLib: "MERONEM 1G INJ FL",
  UCD7: '9194738',
  UCD13: '3400891947380',
  ucdQtyMultiplicator: 10,
  cipLib: "MERONEM 1G INJ FL BT 10",
  atcCode: "J01DH02"
}, {
  CIP7: '2169677',
  CIP13: '3400921696776',
  ucdLib: "KIRAVEM 1G INJ FL",
  UCD7: '9390818',
  UCD13: '3400893908181',
  ucdQtyMultiplicator: 10,
  cipLib: "KIRAVEM 1G INJ FL BT 10",
  atcCode: "J01DH02"
}, {
  CIP7: '2169915',
  CIP13: '3400921699159',
  ucdLib: "KIRAVEM 500MG INJ FL",
  UCD7: '9395129',
  UCD13: '3400893951293',
  ucdQtyMultiplicator: 10,
  cipLib: "KIRAVEM 500MG INJ FL BT 10",
  atcCode: "J01DH02"
}, {
  CIP7: '2187899',
  CIP13: '3400921878998',
  ucdLib: "MEROPENEM KBI 1G INJ FL50ML",
  UCD7: '9379691',
  UCD13: '3400893796917',
  ucdQtyMultiplicator: 10,
  cipLib: "MEROPENEM KBI 1G INJ FL50ML BT 10",
  atcCode: "J01DH02"
}, {
  CIP7: '4163756',
  CIP13: '3400941637568',
  ucdLib: "MEROPENEM SDZ 1G INJ FL",
  UCD7: '9372677',
  UCD13: '3400893726778',
  ucdQtyMultiplicator: 10,
  cipLib: "MEROPENEM SDZ 1G INJ FL BT 10",
  atcCode: "J01DH02"
}, {
  CIP7: '5829507',
  CIP13: '3400958295072',
  ucdLib: "MEROPENEM ACT 500MG INJ FL",
  UCD7: '9394578',
  UCD13: '3400893945780',
  ucdQtyMultiplicator: 10,
  cipLib: "MEROPENEM ACT 500MG INJ FL BT 10",
  atcCode: "J01DH02"
}, {
  CIP7: '3692085',
  CIP13: '3400936920859',
  ucdLib: "AZACTAM 1G INJ FL",
  UCD7: '9128813',
  UCD13: '3400891288131',
  ucdQtyMultiplicator: 1,
  cipLib: "AZACTAM 1G INJ FL BT 1",
  atcCode: "J01DF01"
}, {
  CIP7: '3751511',
  CIP13: '3400937515115',
  ucdLib: "CAYSTON 75MG INHAL FL+A.+NEB",
  UCD7: '9350776',
  UCD13: '3400893507766',
  ucdQtyMultiplicator: 84,
  cipLib: "CAYSTON 75MG INHAL FL+A.+NEB BT 84",
  atcCode: "J01DF01"
}, {
  CIP7: '3702292',
  CIP13: '3400937022927',
  ucdLib: "AXEPIM 0,5G INJ FL",
  UCD7: '9161644',
  UCD13: '3400891616446',
  ucdQtyMultiplicator: 1,
  cipLib: "AXEPIM 0,5G INJ FL BT 1",
  atcCode: "J01DE01"
}, {
  CIP7: '3702300',
  CIP13: '3400937023009',
  ucdLib: "AXEPIM 1G INJ FL",
  UCD7: '9161650',
  UCD13: '3400891616507',
  ucdQtyMultiplicator: 1,
  cipLib: "AXEPIM 1G INJ FL BT 1",
  atcCode: "J01DE01"
}, {
  CIP7: '3702346',
  CIP13: '3400937023467',
  ucdLib: "AXEPIM 2G INJ FL",
  UCD7: '9161667',
  UCD13: '3400891616675',
  ucdQtyMultiplicator: 1,
  cipLib: "AXEPIM 2G INJ FL BT 1",
  atcCode: "J01DE01"
}, {
  CIP7: '3906238',
  CIP13: '3400939062389',
  ucdLib: "CEFEPIME MYL 1G INJ FL",
  UCD7: '9323638',
  UCD13: '3400893236383',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFEPIME MYL 1G INJ FL BT 1",
  atcCode: "J01DE01"
}, {
  CIP7: '3906296',
  CIP13: '3400939062969',
  ucdLib: "CEFEPIME MYL 2G INJ FL",
  UCD7: '9323644',
  UCD13: '3400893236444',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFEPIME MYL 2G INJ FL BT 1",
  atcCode: "J01DE01"
}, {
  CIP7: '4947564',
  CIP13: '3400949475643',
  ucdLib: "CEFEPIME PAN 1G INJ FL",
  UCD7: '9363661',
  UCD13: '3400893636619',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFEPIME PAN 1G INJ FL BT 10",
  atcCode: "J01DE01"
}, {
  CIP7: '4947618',
  CIP13: '3400949476183',
  ucdLib: "CEFEPIME PAN 2G INJ FL",
  UCD7: '9363678',
  UCD13: '3400893636787',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFEPIME PAN 2G INJ FL BT 10",
  atcCode: "J01DE01"
}, {
  CIP7: '3331430',
  CIP13: '3400933314309',
  ucdLib: "CEFPODOXIME ZEN 100MG CPR",
  UCD7: '9147874',
  UCD13: '3400891478747',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME ZEN 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3331424',
  CIP13: '3400933314248',
  ucdLib: "ORELOX 100MG CPR",
  UCD7: '9147905',
  UCD13: '3400891479058',
  ucdQtyMultiplicator: 10,
  cipLib: "ORELOX 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3360377',
  CIP13: '3400933603779',
  ucdLib: "CEFPODOXIME ZEN ENF/BB FV100ML",
  UCD7: '9295936',
  UCD13: '3400892959368',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME ZEN ENF/BB FV100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3360360',
  CIP13: '3400933603601',
  ucdLib: "CEFPODOXIME ZEN ENF/BB FV50ML",
  UCD7: '9295942',
  UCD13: '3400892959429',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME ZEN ENF/BB FV50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3360408',
  CIP13: '3400933604080',
  ucdLib: "ORELOX ENF/BB BUV GLE FV100ML",
  UCD7: '9169479',
  UCD13: '3400891694796',
  ucdQtyMultiplicator: 1,
  cipLib: "ORELOX ENF/BB BUV GLE FV100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3360383',
  CIP13: '3400933603830',
  ucdLib: "ORELOX ENF/BB BUV GLE FV50ML",
  UCD7: '9169485',
  UCD13: '3400891694857',
  ucdQtyMultiplicator: 1,
  cipLib: "ORELOX ENF/BB BUV GLE FV50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3462818',
  CIP13: '3400934628184',
  ucdLib: "CEFPODOXIME MYP 100MG CPR",
  UCD7: '9303133',
  UCD13: '3400893031339',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME MYP 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3797708',
  CIP13: '3400937977081',
  ucdLib: "CEFPODOXIME ARW 100MG CPR",
  UCD7: '9301200',
  UCD13: '3400893012000',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME ARW 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3797795',
  CIP13: '3400937977951',
  ucdLib: "CEFPODOXIME EG 100MG CPR",
  UCD7: '9301855',
  UCD13: '3400893018552',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME EG 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3791002',
  CIP13: '3400937910026',
  ucdLib: "CEFPODOXIME ZYD 100MG CPR",
  UCD7: '9302808',
  UCD13: '3400893028087',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME ZYD 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3875012',
  CIP13: '3400938750126',
  ucdLib: "CEFPODOXIME ARW ENF/BB FV100ML",
  UCD7: '9321272',
  UCD13: '3400893212721',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME ARW ENF/BB FV100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3875006',
  CIP13: '3400938750065',
  ucdLib: "CEFPODOXIME ARW ENF/BB FV50ML",
  UCD7: '9321289',
  UCD13: '3400893212899',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME ARW ENF/BB FV50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3801427',
  CIP13: '3400938014273',
  ucdLib: "CEFPODOXIME BGA 100MG CPR",
  UCD7: '9302748',
  UCD13: '3400893027486',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME BGA 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3873295',
  CIP13: '3400938732955',
  ucdLib: "CEFPODOXIME BGA ENF/BB FP100ML",
  UCD7: '9321668',
  UCD13: '3400893216682',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME BGA ENF/BB FP100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3873289',
  CIP13: '3400938732894',
  ucdLib: "CEFPODOXIME BGA ENF/BB FP50ML",
  UCD7: '9321674',
  UCD13: '3400893216743',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME BGA ENF/BB FP50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3873361',
  CIP13: '3400938733617',
  ucdLib: "CEFPODOXIME EG ENF/BB FP100ML",
  UCD7: '9321504',
  UCD13: '3400893215043',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME EG ENF/BB FP100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3873355',
  CIP13: '3400938733556',
  ucdLib: "CEFPODOXIME EG ENF/BB FP50ML",
  UCD7: '9321510',
  UCD13: '3400893215104',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME EG ENF/BB FP50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3801410',
  CIP13: '3400938014105',
  ucdLib: "CEFPODOXIME ISD 100MG CPR",
  UCD7: '9305729',
  UCD13: '3400893057292',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME ISD 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3873384',
  CIP13: '3400938733846',
  ucdLib: "CEFPODOXIME ISD ENF/BB FP100ML",
  UCD7: '9322403',
  UCD13: '3400893224038',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME ISD ENF/BB FP100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3873378',
  CIP13: '3400938733785',
  ucdLib: "CEFPODOXIME ISD ENF/BB FP50ML",
  UCD7: '9322426',
  UCD13: '3400893224267',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME ISD ENF/BB FP50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3873645',
  CIP13: '3400938736458',
  ucdLib: "CEFPODOXIME MYL ENF/BB FV100ML",
  UCD7: '9321527',
  UCD13: '3400893215272',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME MYL ENF/BB FV100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3873639',
  CIP13: '3400938736397',
  ucdLib: "CEFPODOXIME MYL ENF/BB FV50ML",
  UCD7: '9321533',
  UCD13: '3400893215333',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME MYL ENF/BB FV50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3802154',
  CIP13: '3400938021547',
  ucdLib: "CEFPODOXIME RBX 100MG CPR",
  UCD7: '9302777',
  UCD13: '3400893027776',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME RBX 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3927068',
  CIP13: '3400939270685',
  ucdLib: "CEFPODOXIME SDZ 100MG CPR",
  UCD7: '9302168',
  UCD13: '3400893021682',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME SDZ 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3874998',
  CIP13: '3400938749984',
  ucdLib: "CEFPODOXIME SDZ ENF/BB FV100ML",
  UCD7: '9321326',
  UCD13: '3400893213261',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME SDZ ENF/BB FV100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3874981',
  CIP13: '3400938749816',
  ucdLib: "CEFPODOXIME SDZ ENF/BB FV50ML",
  UCD7: '9321332',
  UCD13: '3400893213322',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME SDZ ENF/BB FV50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3802208',
  CIP13: '3400938022087',
  ucdLib: "CEFPODOXIME TVC 100MG CPR",
  UCD7: '9302783',
  UCD13: '3400893027837',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME TVC 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3873349',
  CIP13: '3400938733495',
  ucdLib: "CEFPODOXIME TVC ENF/BB FP100ML",
  UCD7: '9321680',
  UCD13: '3400893216804',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME TVC ENF/BB FP100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3873332',
  CIP13: '3400938733327',
  ucdLib: "CEFPODOXIME TVC ENF/BB FP50ML",
  UCD7: '9321697',
  UCD13: '3400893216972',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME TVC ENF/BB FP50ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '3906505',
  CIP13: '3400939065052',
  ucdLib: "CEFPODOXIME ALM 100MG CPR",
  UCD7: '9326298',
  UCD13: '3400893262986',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME ALM 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3902789',
  CIP13: '3400939027890',
  ucdLib: "CEFPODOXIME CRT 100MG CPR",
  UCD7: '9329925',
  UCD13: '3400893299258',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME CRT 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '2190097',
  CIP13: '3400921900972',
  ucdLib: "CEFPODOXIME ARG ENF/BB FP100ML",
  UCD7: '9408688',
  UCD13: '3400894086888',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFPODOXIME ARG ENF/BB FP100ML BT 1",
  atcCode: "J01DD13"
}, {
  CIP7: '2666996',
  CIP13: '3400926669966',
  ucdLib: "CEFPODOXIME ARL 100MG CPR",
  UCD7: '9407051',
  UCD13: '3400894070511',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFPODOXIME ARL 100MG CPR BT 10",
  atcCode: "J01DD13"
}, {
  CIP7: '3313113',
  CIP13: '3400933131135',
  ucdLib: "OROKEN 200MG CPR",
  UCD7: '9134794',
  UCD13: '3400891347944',
  ucdQtyMultiplicator: 8,
  cipLib: "OROKEN 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '3358995',
  CIP13: '3400933589950',
  ucdLib: "OROKEN BB. 40MG/5ML BUV FL40ML",
  UCD7: '9163152',
  UCD13: '3400891631524',
  ucdQtyMultiplicator: 1,
  cipLib: "OROKEN BB. 40MG/5ML BUV FL40ML BT 1",
  atcCode: "J01DD08"
}, {
  CIP7: '3358989',
  CIP13: '3400933589899',
  ucdLib: "OROKEN ENF 100MG/5ML BUV F40ML",
  UCD7: '9163146',
  UCD13: '3400891631463',
  ucdQtyMultiplicator: 1,
  cipLib: "OROKEN ENF 100MG/5ML BUV F40ML BT 1",
  atcCode: "J01DD08"
}, {
  CIP7: '3804443',
  CIP13: '3400938044430',
  ucdLib: "CEFIXIME ALM 200MG CPR",
  UCD7: '9305422',
  UCD13: '3400893054222',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFIXIME ALM 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '3804578',
  CIP13: '3400938045789',
  ucdLib: "CEFIXIME BGA 200MG CPR",
  UCD7: '9304523',
  UCD13: '3400893045237',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFIXIME BGA 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '3881892',
  CIP13: '3400938818925',
  ucdLib: "CEFIXIME EG 200MG CPR",
  UCD7: '9323153',
  UCD13: '3400893231531',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFIXIME EG 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '3882035',
  CIP13: '3400938820355',
  ucdLib: "CEFIXIME ZEN 200MG CPR",
  UCD7: '9323182',
  UCD13: '3400893231821',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFIXIME ZEN 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '3907025',
  CIP13: '3400939070254',
  ucdLib: "CEFIXIME ARW 200MG CPR",
  UCD7: '9328676',
  UCD13: '3400893286760',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFIXIME ARW 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '3900655',
  CIP13: '3400939006550',
  ucdLib: "CEFIXIME RBX 200MG CPR",
  UCD7: '9326654',
  UCD13: '3400893266540',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFIXIME RBX 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '4995132',
  CIP13: '3400949951321',
  ucdLib: "CEFIXIME EVO 200MG CPR",
  UCD7: '9368552',
  UCD13: '3400893685525',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFIXIME EVO 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '2232803',
  CIP13: '3400922328034',
  ucdLib: "CEFIXIME MYP 200MG CPR",
  UCD7: '9410372',
  UCD13: '3400894103721',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFIXIME MYP 200MG CPR BT 8",
  atcCode: "J01DD08"
}, {
  CIP7: '3618019',
  CIP13: '3400936180192',
  ucdLib: "CEFTRIAXONE PAN 1G/3,5ML F+A.",
  UCD7: '9250075',
  UCD13: '3400892500751',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE PAN 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3615044',
  CIP13: '3400936150447',
  ucdLib: "TRIACEFAN 1G/3,5ML INJ FL+A.",
  UCD7: '9250951',
  UCD13: '3400892509518',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIACEFAN 1G/3,5ML INJ FL+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3574486',
  CIP13: '3400935744869',
  ucdLib: "CEFTRIAXONE ARW 1G/10ML FL+A.",
  UCD7: '9234917',
  UCD13: '3400892349176',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ARW 1G/10ML FL+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3574405',
  CIP13: '3400935744050',
  ucdLib: "CEFTRIAXONE ARW 1G/3,5ML F+A.",
  UCD7: '9234923',
  UCD13: '3400892349237',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ARW 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3574380',
  CIP13: '3400935743800',
  ucdLib: "CEFTRIAXONE ARW 500MG/2ML F+A",
  UCD7: '9234946',
  UCD13: '3400892349466',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ARW 500MG/2ML F+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3574428',
  CIP13: '3400935744289',
  ucdLib: "CEFTRIAXONE ARW 500MG/5ML F+A",
  UCD7: '9234952',
  UCD13: '3400892349527',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ARW 500MG/5ML F+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3576551',
  CIP13: '3400935765512',
  ucdLib: "CEFTRIAXONE KBI 1G INJ FL",
  UCD7: '9308716',
  UCD13: '3400893087169',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTRIAXONE KBI 1G INJ FL BT 10",
  atcCode: "J01DD04"
}, {
  CIP7: '3573481',
  CIP13: '3400935734815',
  ucdLib: "CEFTRIAXONE KBI 2G INJ FL",
  UCD7: '9308722',
  UCD13: '3400893087220',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTRIAXONE KBI 2G INJ FL BT 10",
  atcCode: "J01DD04"
}, {
  CIP7: '3267488',
  CIP13: '3400932674886',
  ucdLib: "ROCEPHINE 1G/10ML IV FL+AMP",
  UCD7: '9080816',
  UCD13: '3400890808163',
  ucdQtyMultiplicator: 1,
  cipLib: "ROCEPHINE 1G/10ML IV FL+AMP BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3267525',
  CIP13: '3400932675258',
  ucdLib: "ROCEPHINE 1G/3,5ML IM FL+AMP",
  UCD7: '9080791',
  UCD13: '3400890807913',
  ucdQtyMultiplicator: 1,
  cipLib: "ROCEPHINE 1G/3,5ML IM FL+AMP BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3267502',
  CIP13: '3400932675029',
  ucdLib: "ROCEPHINE 500MG/2ML IM FL+AMP",
  UCD7: '9080845',
  UCD13: '3400890808453',
  ucdQtyMultiplicator: 1,
  cipLib: "ROCEPHINE 500MG/2ML IM FL+AMP BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3267465',
  CIP13: '3400932674657',
  ucdLib: "ROCEPHINE 500MG/5ML IV FL+AMP",
  UCD7: '9080851',
  UCD13: '3400890808514',
  ucdQtyMultiplicator: 1,
  cipLib: "ROCEPHINE 500MG/5ML IV FL+AMP BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3605703',
  CIP13: '3400936057036',
  ucdLib: "CEFTRIAXONE BGA 1G/10ML FL+A.",
  UCD7: '9244560',
  UCD13: '3400892445601',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE BGA 1G/10ML FL+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3605666',
  CIP13: '3400936056664',
  ucdLib: "CEFTRIAXONE BGA 1G/3,5ML F+A.",
  UCD7: '9244577',
  UCD13: '3400892445779',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE BGA 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3674414',
  CIP13: '3400936744141',
  ucdLib: "CEFTRIAXONE ZEN 1G/10ML FL+A",
  UCD7: '9269844',
  UCD13: '3400892698441',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ZEN 1G/10ML FL+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3674437',
  CIP13: '3400936744370',
  ucdLib: "CEFTRIAXONE ZEN 1G/3,5MLF+A",
  UCD7: '9269850',
  UCD13: '3400892698502',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ZEN 1G/3,5MLF+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3674420',
  CIP13: '3400936744202',
  ucdLib: "CEFTRIAXONE ZEN 500MG/2ML F+A",
  UCD7: '9269867',
  UCD13: '3400892698670',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ZEN 500MG/2ML F+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3674408',
  CIP13: '3400936744080',
  ucdLib: "CEFTRIAXONE ZEN 500MG/5MLF+A",
  UCD7: '9269873',
  UCD13: '3400892698731',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ZEN 500MG/5MLF+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3554791',
  CIP13: '3400935547910',
  ucdLib: "CEFTRIAXONE CRT 1G/10ML FL+A",
  UCD7: '9230842',
  UCD13: '3400892308425',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE CRT 1G/10ML FL+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3554839',
  CIP13: '3400935548399',
  ucdLib: "CEFTRIAXONE EG 1G/10ML FL+A.",
  UCD7: '9229000',
  UCD13: '3400892290003',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE EG 1G/10ML FL+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3559050',
  CIP13: '3400935590503',
  ucdLib: "CEFTRIAXONE EG 1G/3,5ML F+A.",
  UCD7: '9229017',
  UCD13: '3400892290171',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE EG 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3556726',
  CIP13: '3400935567260',
  ucdLib: "CEFTRIAXONE MYL 1G/10ML FL+A.",
  UCD7: '9226504',
  UCD13: '3400892265049',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE MYL 1G/10ML FL+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3556896',
  CIP13: '3400935568960',
  ucdLib: "CEFTRIAXONE MYL 1G/3,5ML F+A.",
  UCD7: '9226510',
  UCD13: '3400892265100',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE MYL 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3561621',
  CIP13: '3400935616210',
  ucdLib: "CEFTRIAXONE MYL 2G INJ FL",
  UCD7: '9227679',
  UCD13: '3400892276793',
  ucdQtyMultiplicator: 5,
  cipLib: "CEFTRIAXONE MYL 2G INJ FL BT 5",
  atcCode: "J01DD04"
}, {
  CIP7: '3556927',
  CIP13: '3400935569271',
  ucdLib: "CEFTRIAXONE MYL 500MG/2ML F+A",
  UCD7: '9226527',
  UCD13: '3400892265278',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE MYL 500MG/2ML F+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3556755',
  CIP13: '3400935567550',
  ucdLib: "CEFTRIAXONE MYL 500MG/5ML F+A",
  UCD7: '9226533',
  UCD13: '3400892265339',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE MYL 500MG/5ML F+A BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3628489',
  CIP13: '3400936284890',
  ucdLib: "CEFTRIAXONE RPG 1G/3,5ML F+A.",
  UCD7: '9257723',
  UCD13: '3400892577234',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE RPG 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3598038',
  CIP13: '3400935980380',
  ucdLib: "CEFTRIAXONE TVS 1G/10ML FL+A.",
  UCD7: '9242101',
  UCD13: '3400892421018',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE TVS 1G/10ML FL+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3598133',
  CIP13: '3400935981332',
  ucdLib: "CEFTRIAXONE TVS 1G/3,5ML F+A.",
  UCD7: '9242118',
  UCD13: '3400892421186',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE TVS 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3462652',
  CIP13: '3400934626524',
  ucdLib: "CEFTRIAXONE CRT 1G/3,5ML F+A.",
  UCD7: '9346378',
  UCD13: '3400893463789',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE CRT 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3462675',
  CIP13: '3400934626753',
  ucdLib: "CEFTRIAXONE EVO 1G/3,5ML F+A.",
  UCD7: '9349201',
  UCD13: '3400893492017',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE EVO 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3581836',
  CIP13: '3400935818362',
  ucdLib: "CEFTRIAXONE PAN 1G INJ FL",
  UCD7: '9239748',
  UCD13: '3400892397481',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFTRIAXONE PAN 1G INJ FL BT 25",
  atcCode: "J01DD04"
}, {
  CIP7: '5629990',
  CIP13: '3400956299904',
  ucdLib: "CEFTRIAXONE MYL 1G INJ FL10ML",
  UCD7: '9227739',
  UCD13: '3400892277394',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTRIAXONE MYL 1G INJ FL10ML BT 10",
  atcCode: "J01DD04"
}, {
  CIP7: '5627838',
  CIP13: '3400956278381',
  ucdLib: "CEFTRIAXONE MYL 250MG FL10ML",
  UCD7: '9227745',
  UCD13: '3400892277455',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTRIAXONE MYL 250MG FL10ML BT 10",
  atcCode: "J01DD04"
}, {
  CIP7: '5629978',
  CIP13: '3400956299782',
  ucdLib: "CEFTRIAXONE MYL 500MG FL10ML",
  UCD7: '9227751',
  UCD13: '3400892277516',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTRIAXONE MYL 500MG FL10ML BT 10",
  atcCode: "J01DD04"
}, {
  CIP7: '3774831',
  CIP13: '3400937748315',
  ucdLib: "CEFTRIAXONE ZYD 1G/3,5ML F+A.",
  UCD7: '9298596',
  UCD13: '3400892985961',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ZYD 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '3861493',
  CIP13: '3400938614930',
  ucdLib: "CEFTRIAXONE ALM 1G/3,5ML F+A.",
  UCD7: '9319074',
  UCD13: '3400893190746',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE ALM 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '2770512',
  CIP13: '3400927705120',
  ucdLib: "CEFTRIAXONE SDZ 1G/10ML FL+A.",
  UCD7: '9399914',
  UCD13: '3400893999141',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE SDZ 1G/10ML FL+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '2770529',
  CIP13: '3400927705298',
  ucdLib: "CEFTRIAXONE SDZ 1G/3,5ML F+A.",
  UCD7: '9399920',
  UCD13: '3400893999202',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTRIAXONE SDZ 1G/3,5ML F+A. BT 1",
  atcCode: "J01DD04"
}, {
  CIP7: '5651392',
  CIP13: '3400956513925',
  ucdLib: "CEFTRIAXONE PAN 2G INJ FL",
  UCD7: '9257189',
  UCD13: '3400892571898',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFTRIAXONE PAN 2G INJ FL BT 25",
  atcCode: "J01DD04"
}, {
  CIP7: '3818304',
  CIP13: '3400938183047',
  ucdLib: "CEFTAZIDIME MYL 1G INJ FL",
  UCD7: '9305244',
  UCD13: '3400893052440',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTAZIDIME MYL 1G INJ FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3818333',
  CIP13: '3400938183337',
  ucdLib: "CEFTAZIDIME MYL 2G INJ FL",
  UCD7: '9305250',
  UCD13: '3400893052501',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTAZIDIME MYL 2G INJ FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3723302',
  CIP13: '3400937233026',
  ucdLib: "FORTUM 1G INJ FL",
  UCD7: '9104497',
  UCD13: '3400891044973',
  ucdQtyMultiplicator: 1,
  cipLib: "FORTUM 1G INJ FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3723265',
  CIP13: '3400937232654',
  ucdLib: "FORTUM 250MG INJ FL",
  UCD7: '9106289',
  UCD13: '3400891062892',
  ucdQtyMultiplicator: 1,
  cipLib: "FORTUM 250MG INJ FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3723325',
  CIP13: '3400937233255',
  ucdLib: "FORTUM 2G INJ FL",
  UCD7: '9154354',
  UCD13: '3400891543544',
  ucdQtyMultiplicator: 1,
  cipLib: "FORTUM 2G INJ FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3723288',
  CIP13: '3400937232883',
  ucdLib: "FORTUM 500MG INJ FL",
  UCD7: '9106295',
  UCD13: '3400891062953',
  ucdQtyMultiplicator: 1,
  cipLib: "FORTUM 500MG INJ FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3723331',
  CIP13: '3400937233316',
  ucdLib: "FORTUMSET 1G PERF FL",
  UCD7: '9205264',
  UCD13: '3400892052649',
  ucdQtyMultiplicator: 1,
  cipLib: "FORTUMSET 1G PERF FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3780375',
  CIP13: '3400937803755',
  ucdLib: "CEFTAZIDIME ARW 1G INJ FL",
  UCD7: '9298567',
  UCD13: '3400892985671',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTAZIDIME ARW 1G INJ FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3780381',
  CIP13: '3400937803816',
  ucdLib: "CEFTAZIDIME ARW 2G INJ FL",
  UCD7: '9298573',
  UCD13: '3400892985732',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFTAZIDIME ARW 2G INJ FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3730667',
  CIP13: '3400937306676',
  ucdLib: "FORTUMSET 2G PERF FL",
  UCD7: '9205270',
  UCD13: '3400892052700',
  ucdQtyMultiplicator: 1,
  cipLib: "FORTUMSET 2G PERF FL BT 1",
  atcCode: "J01DD02"
}, {
  CIP7: '3946137',
  CIP13: '3400939461373',
  ucdLib: "CEFTAZIDIME KBI 2G INJ FL",
  UCD7: '9338404',
  UCD13: '3400893384046',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTAZIDIME KBI 2G INJ FL BT 10",
  atcCode: "J01DD02"
}, {
  CIP7: '5752526',
  CIP13: '3400957525262',
  ucdLib: "CEFTAZIDIME KBI 1G INJ FL",
  UCD7: '9338396',
  UCD13: '3400893383964',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTAZIDIME KBI 1G INJ FL BT 10",
  atcCode: "J01DD02"
}, {
  CIP7: '5752503',
  CIP13: '3400957525033',
  ucdLib: "CEFTAZIDIME KBI 500MG INJ FL",
  UCD7: '9338410',
  UCD13: '3400893384107',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTAZIDIME KBI 500MG INJ FL BT 10",
  atcCode: "J01DD02"
}, {
  CIP7: '5714112',
  CIP13: '3400957141127',
  ucdLib: "CEFTAZIDIME MYL 1G INJ FL",
  UCD7: '9305244',
  UCD13: '3400893052440',
  ucdQtyMultiplicator: 5,
  cipLib: "CEFTAZIDIME MYL 1G INJ FL BT 5",
  atcCode: "J01DD02"
}, {
  CIP7: '5714170',
  CIP13: '3400957141707',
  ucdLib: "CEFTAZIDIME MYL 250MG INJ FL",
  UCD7: '9305238',
  UCD13: '3400893052389',
  ucdQtyMultiplicator: 5,
  cipLib: "CEFTAZIDIME MYL 250MG INJ FL BT 5",
  atcCode: "J01DD02"
}, {
  CIP7: '5714135',
  CIP13: '3400957141356',
  ucdLib: "CEFTAZIDIME MYL 2G INJ FL",
  UCD7: '9305250',
  UCD13: '3400893052501',
  ucdQtyMultiplicator: 5,
  cipLib: "CEFTAZIDIME MYL 2G INJ FL BT 5",
  atcCode: "J01DD02"
}, {
  CIP7: '5714158',
  CIP13: '3400957141585',
  ucdLib: "CEFTAZIDIME MYL 500MG INJ FL",
  UCD7: '9305221',
  UCD13: '3400893052211',
  ucdQtyMultiplicator: 5,
  cipLib: "CEFTAZIDIME MYL 500MG INJ FL BT 5",
  atcCode: "J01DD02"
}, {
  CIP7: '5790923',
  CIP13: '3400957909239',
  ucdLib: "CEFTAZIDIME PAN 1G INJ FL",
  UCD7: '9368115',
  UCD13: '3400893681152',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTAZIDIME PAN 1G INJ FL BT 10",
  atcCode: "J01DD02"
}, {
  CIP7: '5788642',
  CIP13: '3400957886424',
  ucdLib: "CEFTAZIDIME PAN 250MG INJ FL",
  UCD7: '9368090',
  UCD13: '3400893680902',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTAZIDIME PAN 250MG INJ FL BT 10",
  atcCode: "J01DD02"
}, {
  CIP7: '5790975',
  CIP13: '3400957909758',
  ucdLib: "CEFTAZIDIME PAN 2G INJ FL",
  UCD7: '9368121',
  UCD13: '3400893681213',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTAZIDIME PAN 2G INJ FL BT 10",
  atcCode: "J01DD02"
}, {
  CIP7: '5790834',
  CIP13: '3400957908348',
  ucdLib: "CEFTAZIDIME PAN 500MG INJ FL",
  UCD7: '9368109',
  UCD13: '3400893681091',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFTAZIDIME PAN 500MG INJ FL BT 10",
  atcCode: "J01DD02"
}, {
  CIP7: '5610401',
  CIP13: '3400956104017',
  ucdLib: "CEFOTAXIME MYL 1G INJ FL",
  UCD7: '9218203',
  UCD13: '3400892182032',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFOTAXIME MYL 1G INJ FL BT 10",
  atcCode: "J01DD01"
}, {
  CIP7: '5611197',
  CIP13: '3400956111978',
  ucdLib: "CEFOTAXIME MYL 2G INJ FL",
  UCD7: '9218226',
  UCD13: '3400892182261',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFOTAXIME MYL 2G INJ FL BT 10",
  atcCode: "J01DD01"
}, {
  CIP7: '5610364',
  CIP13: '3400956103645',
  ucdLib: "CEFOTAXIME MYL 500MG INJ FL",
  UCD7: '9218232',
  UCD13: '3400892182322',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFOTAXIME MYL 500MG INJ FL BT 10",
  atcCode: "J01DD01"
}, {
  CIP7: '5633371',
  CIP13: '3400956333714',
  ucdLib: "CEFOTAXIME PAN 0,5G INJ 15ML",
  UCD7: '9228704',
  UCD13: '3400892287041',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFOTAXIME PAN 0,5G INJ 15ML BT 25",
  atcCode: "J01DD01"
}, {
  CIP7: '5633394',
  CIP13: '3400956333943',
  ucdLib: "CEFOTAXIME PAN 1G INJ FL15ML",
  UCD7: '9228710',
  UCD13: '3400892287102',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFOTAXIME PAN 1G INJ FL15ML BT 25",
  atcCode: "J01DD01"
}, {
  CIP7: '3356418',
  CIP13: '3400933564186',
  ucdLib: "TEXODIL 200MG CPR",
  UCD7: '9158719',
  UCD13: '3400891587197',
  ucdQtyMultiplicator: 10,
  cipLib: "TEXODIL 200MG CPR BT 10",
  atcCode: "J01DC07"
}, {
  CIP7: '3233242',
  CIP13: '3400932332427',
  ucdLib: "ALFATIL 125MG/5ML BUV FL60ML",
  UCD7: '9002414',
  UCD13: '3400890024143',
  ucdQtyMultiplicator: 1,
  cipLib: "ALFATIL 125MG/5ML BUV FL60ML BT 1",
  atcCode: "J01DC04"
}, {
  CIP7: '3233236',
  CIP13: '3400932332366',
  ucdLib: "ALFATIL 250MG GELU",
  UCD7: '9002383',
  UCD13: '3400890023832',
  ucdQtyMultiplicator: 12,
  cipLib: "ALFATIL 250MG GELU BT 12",
  atcCode: "J01DC04"
}, {
  CIP7: '3245624',
  CIP13: '3400932456246',
  ucdLib: "ALFATIL 250MG/5ML BUV FL60ML",
  UCD7: '9002437',
  UCD13: '3400890024372',
  ucdQtyMultiplicator: 1,
  cipLib: "ALFATIL 250MG/5ML BUV FL60ML BT 1",
  atcCode: "J01DC04"
}, {
  CIP7: '3357576',
  CIP13: '3400933575762',
  ucdLib: "ALFATIL LP 375MG CPR",
  UCD7: '9163413',
  UCD13: '3400891634136',
  ucdQtyMultiplicator: 8,
  cipLib: "ALFATIL LP 375MG CPR BT 8",
  atcCode: "J01DC04"
}, {
  CIP7: '3357599',
  CIP13: '3400933575991',
  ucdLib: "ALFATIL LP 500MG CPR",
  UCD7: '9163436',
  UCD13: '3400891634365',
  ucdQtyMultiplicator: 8,
  cipLib: "ALFATIL LP 500MG CPR BT 8",
  atcCode: "J01DC04"
}, {
  CIP7: '3557111',
  CIP13: '3400935571113',
  ucdLib: "CEFAMANDOLE PAN 750MG INJ FL",
  UCD7: '9192165',
  UCD13: '3400891921656',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFAMANDOLE PAN 750MG INJ FL BT 10",
  atcCode: "J01DC03"
}, {
  CIP7: '3574842',
  CIP13: '3400935748423',
  ucdLib: "CEFUROXIME PAN 750MG INJ FL",
  UCD7: '9202082',
  UCD13: '3400892020822',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFUROXIME PAN 750MG INJ FL BT 10",
  atcCode: "J01DC02"
}, {
  CIP7: '3312177',
  CIP13: '3400933121778',
  ucdLib: "CEFUROXIME BGA 125MG CPR",
  UCD7: '9270391',
  UCD13: '3400892703916',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME BGA 125MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3312160',
  CIP13: '3400933121600',
  ucdLib: "CEFUROXIME BGA 250MG CPR",
  UCD7: '9270445',
  UCD13: '3400892704456',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME BGA 250MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3312208',
  CIP13: '3400933122089',
  ucdLib: "CEFUROXIME ZEN 250MG C.PELL",
  UCD7: '9129735',
  UCD13: '3400891297355',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME ZEN 250MG C.PELL BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3312154',
  CIP13: '3400933121549',
  ucdLib: "ZINNAT 125MG CPR",
  UCD7: '9130253',
  UCD13: '3400891302530',
  ucdQtyMultiplicator: 8,
  cipLib: "ZINNAT 125MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3312148',
  CIP13: '3400933121488',
  ucdLib: "ZINNAT 250MG CPR",
  UCD7: '9130276',
  UCD13: '3400891302769',
  ucdQtyMultiplicator: 8,
  cipLib: "ZINNAT 250MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3436637',
  CIP13: '3400934366376',
  ucdLib: "CEFUROXIME BGA 500MG CPR",
  UCD7: '9270468',
  UCD13: '3400892704685',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME BGA 500MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3340328',
  CIP13: '3400933403287',
  ucdLib: "ZINNAT 125MG/5ML BUV FL40ML",
  UCD7: '9164772',
  UCD13: '3400891647723',
  ucdQtyMultiplicator: 1,
  cipLib: "ZINNAT 125MG/5ML BUV FL40ML BT 1",
  atcCode: "J01DC02"
}, {
  CIP7: '3340357',
  CIP13: '3400933403577',
  ucdLib: "ZINNAT 125MG/5ML BUV FL80ML",
  UCD7: '9164789',
  UCD13: '3400891647891',
  ucdQtyMultiplicator: 1,
  cipLib: "ZINNAT 125MG/5ML BUV FL80ML BT 1",
  atcCode: "J01DC02"
}, {
  CIP7: '3675572',
  CIP13: '3400936755727',
  ucdLib: "CEFUROXIME MYL 250MG CPR",
  UCD7: '9271031',
  UCD13: '3400892710310',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME MYL 250MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3675595',
  CIP13: '3400936755956',
  ucdLib: "CEFUROXIME MYL 500MG CPR",
  UCD7: '9271048',
  UCD13: '3400892710488',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME MYL 500MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3672734',
  CIP13: '3400936727342',
  ucdLib: "CEFUROXIME SDZ 250MG CPR",
  UCD7: '9271060',
  UCD13: '3400892710600',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME SDZ 250MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3672786',
  CIP13: '3400936727861',
  ucdLib: "CEFUROXIME SDZ 500MG CPR",
  UCD7: '9271077',
  UCD13: '3400892710778',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME SDZ 500MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3855038',
  CIP13: '3400938550382',
  ucdLib: "CEFUROXIME ARW 250MG CPR",
  UCD7: '9316934',
  UCD13: '3400893169346',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME ARW 250MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3855009',
  CIP13: '3400938550092',
  ucdLib: "CEFUROXIME ARW 500MG CPR",
  UCD7: '9316940',
  UCD13: '3400893169407',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME ARW 500MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3596915',
  CIP13: '3400935969156',
  ucdLib: "CEFUROXIME TVC 750MG INJ FL",
  UCD7: '9264344',
  UCD13: '3400892643441',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFUROXIME TVC 750MG INJ FL BT 1",
  atcCode: "J01DC02"
}, {
  CIP7: '3763187',
  CIP13: '3400937631877',
  ucdLib: "CEFUROXIME RBX 250MG CPR",
  UCD7: '9292033',
  UCD13: '3400892920337',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME RBX 250MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3636230',
  CIP13: '3400936362307',
  ucdLib: "CEFUROXIME ZEN 125MG CPR",
  UCD7: '9297148',
  UCD13: '3400892971483',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME ZEN 125MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3384219',
  CIP13: '3400933842192',
  ucdLib: "ZINNAT 750MG IM FL+AMP",
  UCD7: '9192455',
  UCD13: '3400891924558',
  ucdQtyMultiplicator: 2,
  cipLib: "ZINNAT 750MG IM FL+AMP BT 2",
  atcCode: "J01DC02"
}, {
  CIP7: '3917093',
  CIP13: '3400939170930',
  ucdLib: "CEFUROXIME KBI 750MG INJ FL",
  UCD7: '9334197',
  UCD13: '3400893341971',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFUROXIME KBI 750MG INJ FL BT 1",
  atcCode: "J01DC02"
}, {
  CIP7: '3917101',
  CIP13: '3400939171012',
  ucdLib: "CEFUROXIME KBI 750MG INJ FL",
  UCD7: '9334197',
  UCD13: '3400893341971',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFUROXIME KBI 750MG INJ FL BT 10",
  atcCode: "J01DC02"
}, {
  CIP7: '5645405',
  CIP13: '3400956454051',
  ucdLib: "CEFUROXIME PAN 1,5G IV FL60ML",
  UCD7: '9202030',
  UCD13: '3400892020303',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFUROXIME PAN 1,5G IV FL60ML BT 10",
  atcCode: "J01DC02"
}, {
  CIP7: '3932046',
  CIP13: '3400939320465',
  ucdLib: "CEFUROXIME TVC 250MG CPR",
  UCD7: '9336724',
  UCD13: '3400893367247',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME TVC 250MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3932098',
  CIP13: '3400939320984',
  ucdLib: "CEFUROXIME TVC 500MG CPR",
  UCD7: '9336730',
  UCD13: '3400893367308',
  ucdQtyMultiplicator: 8,
  cipLib: "CEFUROXIME TVC 500MG CPR BT 8",
  atcCode: "J01DC02"
}, {
  CIP7: '3500890',
  CIP13: '3400935008909',
  ucdLib: "ZINNAT 1,5G IV FL",
  UCD7: '9023215',
  UCD13: '3400890232159',
  ucdQtyMultiplicator: 1,
  cipLib: "ZINNAT 1,5G IV FL BT 1",
  atcCode: "J01DC02"
}, {
  CIP7: '3500878',
  CIP13: '3400935008787',
  ucdLib: "ZINNAT 250MG IM IV FL",
  UCD7: '9117577',
  UCD13: '3400891175776',
  ucdQtyMultiplicator: 1,
  cipLib: "ZINNAT 250MG IM IV FL BT 1",
  atcCode: "J01DC02"
}, {
  CIP7: '3500915',
  CIP13: '3400935009159',
  ucdLib: "ZINNAT 750MG IM IV FL",
  UCD7: '9117583',
  UCD13: '3400891175837',
  ucdQtyMultiplicator: 1,
  cipLib: "ZINNAT 750MG IM IV FL BT 1",
  atcCode: "J01DC02"
}, {
  CIP7: '5663917',
  CIP13: '3400956639175',
  ucdLib: "CEFUROXIME MYL 1,5G PERF FL",
  UCD7: '9209641',
  UCD13: '3400892096414',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFUROXIME MYL 1,5G PERF FL BT 10",
  atcCode: "J01DC02"
}, {
  CIP7: '5663900',
  CIP13: '3400956639007',
  ucdLib: "CEFUROXIME MYL 750MG INJ FL",
  UCD7: '9209664',
  UCD13: '3400892096643',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFUROXIME MYL 750MG INJ FL BT 10",
  atcCode: "J01DC02"
}, {
  CIP7: '5857194',
  CIP13: '3400958571947',
  ucdLib: "CEFUROXIME PAN 1,5G IV FL17ML",
  UCD7: '9398889',
  UCD13: '3400893988893',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFUROXIME PAN 1,5G IV FL17ML BT 10",
  atcCode: "J01DC02"
}, {
  CIP7: '5830114',
  CIP13: '3400958301148',
  ucdLib: "CEFUROXIME PAN 250MG INJ FL",
  UCD7: '9202047',
  UCD13: '3400892020471',
  ucdQtyMultiplicator: 10,
  cipLib: "CEFUROXIME PAN 250MG INJ FL BT 10",
  atcCode: "J01DC02"
}, {
  CIP7: '5612819',
  CIP13: '3400956128198',
  ucdLib: "CEFOXITINE PAN 1G INJ FL",
  UCD7: '9212436',
  UCD13: '3400892124360',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFOXITINE PAN 1G INJ FL BT 25",
  atcCode: "J01DC01"
}, {
  CIP7: '5612825',
  CIP13: '3400956128259',
  ucdLib: "CEFOXITINE PAN 2G INJ FL",
  UCD7: '9212442',
  UCD13: '3400892124421',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFOXITINE PAN 2G INJ FL BT 25",
  atcCode: "J01DC01"
}, {
  CIP7: '5742203',
  CIP13: '3400957422035',
  ucdLib: "CEFOXITINE HPI 2G INJ FL",
  UCD7: '9335506',
  UCD13: '3400893355060',
  ucdQtyMultiplicator: 20,
  cipLib: "CEFOXITINE HPI 2G INJ FL BT 20",
  atcCode: "J01DC01"
}, {
  CIP7: '3485222',
  CIP13: '3400934852220',
  ucdLib: "DEXEF 500MG GELU",
  UCD7: '9212985',
  UCD13: '3400892129853',
  ucdQtyMultiplicator: 12,
  cipLib: "DEXEF 500MG GELU BT 12",
  atcCode: "J01DB09"
}, {
  CIP7: '3450212',
  CIP13: '3400934502125',
  ucdLib: "CEFADROXIL MYL 500MG GELU",
  UCD7: '9202797',
  UCD13: '3400892027975',
  ucdQtyMultiplicator: 12,
  cipLib: "CEFADROXIL MYL 500MG GELU BT 12",
  atcCode: "J01DB05"
}, {
  CIP7: '3290211',
  CIP13: '3400932902118',
  ucdLib: "ORACEFAL 1G CPR DISP",
  UCD7: '9163407',
  UCD13: '3400891634075',
  ucdQtyMultiplicator: 6,
  cipLib: "ORACEFAL 1G CPR DISP BT 6",
  atcCode: "J01DB05"
}, {
  CIP7: '3680886',
  CIP13: '3400936808867',
  ucdLib: "CEFADROXIL SDZ 500MG GELU",
  UCD7: '9268827',
  UCD13: '3400892688275',
  ucdQtyMultiplicator: 12,
  cipLib: "CEFADROXIL SDZ 500MG GELU BT 12",
  atcCode: "J01DB05"
}, {
  CIP7: '3201880',
  CIP13: '3400932018802',
  ucdLib: "ORACEFAL 125MG/5ML BUV FL60ML",
  UCD7: '9065490',
  UCD13: '3400890654906',
  ucdQtyMultiplicator: 1,
  cipLib: "ORACEFAL 125MG/5ML BUV FL60ML BT 1",
  atcCode: "J01DB05"
}, {
  CIP7: '3203123',
  CIP13: '3400932031238',
  ucdLib: "ORACEFAL 250MG/5ML BUV FL60ML",
  UCD7: '9065515',
  UCD13: '3400890655156',
  ucdQtyMultiplicator: 1,
  cipLib: "ORACEFAL 250MG/5ML BUV FL60ML BT 1",
  atcCode: "J01DB05"
}, {
  CIP7: '3201839',
  CIP13: '3400932018390',
  ucdLib: "ORACEFAL 500MG GELU",
  UCD7: '9065521',
  UCD13: '3400890655217',
  ucdQtyMultiplicator: 12,
  cipLib: "ORACEFAL 500MG GELU BT 12",
  atcCode: "J01DB05"
}, {
  CIP7: '3564619',
  CIP13: '3400935646194',
  ucdLib: "CEFADROXIL MYL 1G CPR",
  UCD7: '9231391',
  UCD13: '3400892313917',
  ucdQtyMultiplicator: 6,
  cipLib: "CEFADROXIL MYL 1G CPR BT 6",
  atcCode: "J01DB05"
}, {
  CIP7: '3216054',
  CIP13: '3400932160549',
  ucdLib: "ORACEFAL 500MG/5ML BUV FL60ML",
  UCD7: '9065538',
  UCD13: '3400890655385',
  ucdQtyMultiplicator: 1,
  cipLib: "ORACEFAL 500MG/5ML BUV FL60ML BT 1",
  atcCode: "J01DB05"
}, {
  CIP7: '3486049',
  CIP13: '3400934860492',
  ucdLib: "CEFADROXIL BGA 500MG GELU",
  UCD7: '9208156',
  UCD13: '3400892081564',
  ucdQtyMultiplicator: 12,
  cipLib: "CEFADROXIL BGA 500MG GELU BT 12",
  atcCode: "J01DB05"
}, {
  CIP7: '3490619',
  CIP13: '3400934906190',
  ucdLib: "CEFADROXIL MYL 250MG/5ML 60ML",
  UCD7: '9210466',
  UCD13: '3400892104669',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFADROXIL MYL 250MG/5ML 60ML BT 1",
  atcCode: "J01DB05"
}, {
  CIP7: '3490631',
  CIP13: '3400934906312',
  ucdLib: "CEFADROXIL MYL 500MG/5ML 60ML",
  UCD7: '9210472',
  UCD13: '3400892104720',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFADROXIL MYL 500MG/5ML 60ML BT 1",
  atcCode: "J01DB05"
}, {
  CIP7: '5561401',
  CIP13: '3400955614012',
  ucdLib: "CEFAZOLINE PAN 1G/5ML FL",
  UCD7: '9134647',
  UCD13: '3400891346473',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFAZOLINE PAN 1G/5ML FL BT 25",
  atcCode: "J01DB04"
}, {
  CIP7: '5561393',
  CIP13: '3400955613930',
  ucdLib: "CEFAZOLINE PAN 2G/10ML FL",
  UCD7: '9134653',
  UCD13: '3400891346534',
  ucdQtyMultiplicator: 25,
  cipLib: "CEFAZOLINE PAN 2G/10ML FL BT 25",
  atcCode: "J01DB04"
}, {
  CIP7: '3554118',
  CIP13: '3400935541185',
  ucdLib: "CEFAZOLINE MYL 1G INJ FL",
  UCD7: '9226496',
  UCD13: '3400892264967',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFAZOLINE MYL 1G INJ FL BT 1",
  atcCode: "J01DB04"
}, {
  CIP7: '3594081',
  CIP13: '3400935940810',
  ucdLib: "CEFAZOLINE MYL 2G INJ FL",
  UCD7: '9238281',
  UCD13: '3400892382814',
  ucdQtyMultiplicator: 1,
  cipLib: "CEFAZOLINE MYL 2G INJ FL BT 1",
  atcCode: "J01DB04"
}, {
  CIP7: '3198652',
  CIP13: '3400931986522',
  ucdLib: "KEFORAL 1G CPR",
  UCD7: '9048706',
  UCD13: '3400890487061',
  ucdQtyMultiplicator: 6,
  cipLib: "KEFORAL 1G CPR BT 6",
  atcCode: "J01DB01"
}, {
  CIP7: '3135752',
  CIP13: '3400931357520',
  ucdLib: "KEFORAL 500MG CPR",
  UCD7: '9048741',
  UCD13: '3400890487412',
  ucdQtyMultiplicator: 10,
  cipLib: "KEFORAL 500MG CPR BT 10",
  atcCode: "J01DB01"
}, {
  CIP7: '3212145',
  CIP13: '3400932121458',
  ucdLib: "KEFORAL 250MG BUV PDR FL60ML",
  UCD7: '9048729',
  UCD13: '3400890487290',
  ucdQtyMultiplicator: 1,
  cipLib: "KEFORAL 250MG BUV PDR FL60ML BT 1",
  atcCode: "J01DB01"
}, {
  CIP7: '3812313',
  CIP13: '3400938123135',
  ucdLib: "PIPERACIL/TAZ.MYL 2G/0,25G FL",
  UCD7: '9302257',
  UCD13: '3400893022573',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.MYL 2G/0,25G FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3812939',
  CIP13: '3400938129397',
  ucdLib: "PIPERACIL/TAZ.MYL 4G/0,5G FL",
  UCD7: '9302263',
  UCD13: '3400893022634',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.MYL 4G/0,5G FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3691921',
  CIP13: '3400936919211',
  ucdLib: "TAZOCILLINE 2G/0,25G INJ FL",
  UCD7: '9154957',
  UCD13: '3400891549577',
  ucdQtyMultiplicator: 1,
  cipLib: "TAZOCILLINE 2G/0,25G INJ FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3691944',
  CIP13: '3400936919440',
  ucdLib: "TAZOCILLINE 4G/0,5G INJ FL",
  UCD7: '9154963',
  UCD13: '3400891549638',
  ucdQtyMultiplicator: 1,
  cipLib: "TAZOCILLINE 4G/0,5G INJ FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3884548',
  CIP13: '3400938845488',
  ucdLib: "PIPERACIL/TAZ.HPI 4G/500MG FL",
  UCD7: '9321473',
  UCD13: '3400893214732',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.HPI 4G/500MG FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3921404',
  CIP13: '3400939214047',
  ucdLib: "PIPERACIL/TAZ.KBI2G/250 10ML",
  UCD7: '9342794',
  UCD13: '3400893427941',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.KBI2G/250 10ML BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3921427',
  CIP13: '3400939214276',
  ucdLib: "PIPERACIL/TAZ.KBI2G/250 10ML",
  UCD7: '9342794',
  UCD13: '3400893427941',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACIL/TAZ.KBI2G/250 10ML BT 10",
  atcCode: "J01CR05"
}, {
  CIP7: '3921433',
  CIP13: '3400939214337',
  ucdLib: "PIPERACIL/TAZ.KBI2G/250 50ML",
  UCD7: '9331483',
  UCD13: '3400893314838',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.KBI2G/250 50ML BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3921462',
  CIP13: '3400939214627',
  ucdLib: "PIPERACIL/TAZ.KBI2G/250 50ML",
  UCD7: '9331483',
  UCD13: '3400893314838',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACIL/TAZ.KBI2G/250 50ML BT 10",
  atcCode: "J01CR05"
}, {
  CIP7: '3921479',
  CIP13: '3400939214795',
  ucdLib: "PIPERACIL/TAZ.KBI4G/500 50ML",
  UCD7: '9331508',
  UCD13: '3400893315088',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.KBI4G/500 50ML BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3921491',
  CIP13: '3400939214917',
  ucdLib: "PIPERACIL/TAZ.KBI4G/500 50ML",
  UCD7: '9331508',
  UCD13: '3400893315088',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACIL/TAZ.KBI4G/500 50ML BT 10",
  atcCode: "J01CR05"
}, {
  CIP7: '3936587',
  CIP13: '3400939365879',
  ucdLib: "PIPERACIL/TAZ.PAN 2G/250MG FL",
  UCD7: '9333306',
  UCD13: '3400893333068',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACIL/TAZ.PAN 2G/250MG FL BT 10",
  atcCode: "J01CR05"
}, {
  CIP7: '3936647',
  CIP13: '3400939366470',
  ucdLib: "PIPERACIL/TAZ.PAN 4G/500MG FL",
  UCD7: '9333312',
  UCD13: '3400893333129',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACIL/TAZ.PAN 4G/500MG FL BT 10",
  atcCode: "J01CR05"
}, {
  CIP7: '3895693',
  CIP13: '3400938956931',
  ucdLib: "PIPERACIL/TAZ.SDZ 2G/0,25G FL",
  UCD7: '9333938',
  UCD13: '3400893339381',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.SDZ 2G/0,25G FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3895730',
  CIP13: '3400938957303',
  ucdLib: "PIPERACIL/TAZ.SDZ 4G/0,5G FL",
  UCD7: '9328009',
  UCD13: '3400893280096',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.SDZ 4G/0,5G FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3917182',
  CIP13: '3400939171821',
  ucdLib: "PIPERACIL/TAZ.TVS 2G/250MG FL",
  UCD7: '9329279',
  UCD13: '3400893292792',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.TVS 2G/250MG FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3917153',
  CIP13: '3400939171531',
  ucdLib: "PIPERACIL/TAZ.TVS 4G/500MG FL",
  UCD7: '9329285',
  UCD13: '3400893292853',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACIL/TAZ.TVS 4G/500MG FL BT 1",
  atcCode: "J01CR05"
}, {
  CIP7: '3769907',
  CIP13: '3400937699075',
  ucdLib: "CLAVENTIN 3G/200MG IV FV",
  UCD7: '9131548',
  UCD13: '3400891315486',
  ucdQtyMultiplicator: 10,
  cipLib: "CLAVENTIN 3G/200MG IV FV BT 10",
  atcCode: "J01CR03"
}, {
  CIP7: '3769913',
  CIP13: '3400937699136',
  ucdLib: "CLAVENTIN 5G/200MG IV FV",
  UCD7: '9125625',
  UCD13: '3400891256253',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAVENTIN 5G/200MG IV FV BT 1",
  atcCode: "J01CR03"
}, {
  CIP7: '3610064',
  CIP13: '3400936100640',
  ucdLib: "AMOX/AC.CLAV ZYF 500/62,5 C.",
  UCD7: '9262687',
  UCD13: '3400892626871',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV ZYF 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3610070',
  CIP13: '3400936100701',
  ucdLib: "AMOX/AC.CLAV ZYF 500/62,5 C.",
  UCD7: '9262687',
  UCD13: '3400892626871',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV ZYF 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3329522',
  CIP13: '3400933295226',
  ucdLib: "AMOX/AC.CLAV ZTL 100MG BB.30ML",
  UCD7: '9233444',
  UCD13: '3400892334448',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ZTL 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3331401',
  CIP13: '3400933314019',
  ucdLib: "AUGMENTIN 100MG BB. BUV FV30ML",
  UCD7: '9151479',
  UCD13: '3400891514797',
  ucdQtyMultiplicator: 1,
  cipLib: "AUGMENTIN 100MG BB. BUV FV30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3304031',
  CIP13: '3400933040314',
  ucdLib: "AUGMENTIN 1G/200MG IV FL+AMP",
  UCD7: '9149502',
  UCD13: '3400891495027',
  ucdQtyMultiplicator: 1,
  cipLib: "AUGMENTIN 1G/200MG IV FL+AMP BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3606163',
  CIP13: '3400936061637',
  ucdLib: "AMOX/AC.CLAV ALM 500/62,5 C.",
  UCD7: '9246122',
  UCD13: '3400892461229',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV ALM 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3606186',
  CIP13: '3400936061866',
  ucdLib: "AMOX/AC.CLAV ALM 500/62,5 C.",
  UCD7: '9246122',
  UCD13: '3400892461229',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV ALM 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3688847',
  CIP13: '3400936888470',
  ucdLib: "AMOX/AC.CLAV MYL 1G/100MG FL",
  UCD7: '9276100',
  UCD13: '3400892761008',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV MYL 1G/100MG FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3686239',
  CIP13: '3400936862395',
  ucdLib: "AMOX/AC.CLAV MYL 2G/200MG FL",
  UCD7: '9276123',
  UCD13: '3400892761237',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV MYL 2G/200MG FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3688818',
  CIP13: '3400936888180',
  ucdLib: "AMOX/AC.CLAV MYL 500/50 20ML",
  UCD7: '9280490',
  UCD13: '3400892804903',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV MYL 500/50 20ML BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3608794',
  CIP13: '3400936087941',
  ucdLib: "AMOX/AC.CLAV MYL 500/62,5 C.",
  UCD7: '9246435',
  UCD13: '3400892464350',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV MYL 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3608802',
  CIP13: '3400936088023',
  ucdLib: "AMOX/AC.CLAV MYL 500/62,5 C.",
  UCD7: '9246435',
  UCD13: '3400892464350',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV MYL 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3686110',
  CIP13: '3400936861107',
  ucdLib: "AMOX/AC.CLAV MYL1G/200MG20ML",
  UCD7: '9276117',
  UCD13: '3400892761176',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV MYL1G/200MG20ML BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3680343',
  CIP13: '3400936803435',
  ucdLib: "AMOX/AC.CLAV RBX 100MG ENF60ML",
  UCD7: '9272183',
  UCD13: '3400892721835',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV RBX 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3608908',
  CIP13: '3400936089082',
  ucdLib: "AMOX/AC.CLAV SDZ 500/62,5 C.",
  UCD7: '9267762',
  UCD13: '3400892677620',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV SDZ 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3608914',
  CIP13: '3400936089143',
  ucdLib: "AMOX/AC.CLAV SDZ 500/62,5 C.",
  UCD7: '9267762',
  UCD13: '3400892677620',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV SDZ 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3602739',
  CIP13: '3400936027398',
  ucdLib: "AMOX/AC.CLAV ZYF 100MG BB.30ML",
  UCD7: '9247498',
  UCD13: '3400892474984',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ZYF 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3602722',
  CIP13: '3400936027220',
  ucdLib: "AMOX/AC.CLAV ZYF 100MG ENF60ML",
  UCD7: '9247481',
  UCD13: '3400892474816',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ZYF 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3439251',
  CIP13: '3400934392511',
  ucdLib: "AUGMENTIN 100MG ENF BUV FV60ML",
  UCD7: '9198328',
  UCD13: '3400891983289',
  ucdQtyMultiplicator: 1,
  cipLib: "AUGMENTIN 100MG ENF BUV FV60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3670801',
  CIP13: '3400936708013',
  ucdLib: "AMOX/AC.CLAV EG 1G/125MG SAC",
  UCD7: '9274420',
  UCD13: '3400892744209',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV EG 1G/125MG SAC BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3670818',
  CIP13: '3400936708181',
  ucdLib: "AMOX/AC.CLAV EG 1G/125MG SAC",
  UCD7: '9274420',
  UCD13: '3400892744209',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV EG 1G/125MG SAC BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3673231',
  CIP13: '3400936732315',
  ucdLib: "AMOX/AC.CLAV RBX 500/62,5 C.",
  UCD7: '9269318',
  UCD13: '3400892693187',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV RBX 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3673248',
  CIP13: '3400936732483',
  ucdLib: "AMOX/AC.CLAV RBX 500/62,5 C.",
  UCD7: '9269318',
  UCD13: '3400892693187',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV RBX 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3673202',
  CIP13: '3400936732025',
  ucdLib: "AMOX/AC.CLAV TVC 100MG ENF60ML",
  UCD7: '9269293',
  UCD13: '3400892692937',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV TVC 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3673188',
  CIP13: '3400936731882',
  ucdLib: "AMOX/AC.CLAV TVC 500/62,5 C.",
  UCD7: '9269301',
  UCD13: '3400892693019',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV TVC 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3673194',
  CIP13: '3400936731943',
  ucdLib: "AMOX/AC.CLAV TVC 500/62,5 C.",
  UCD7: '9269301',
  UCD13: '3400892693019',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV TVC 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3594879',
  CIP13: '3400935948793',
  ucdLib: "AMOX/AC.CLAV ALM 100MG BB.30ML",
  UCD7: '9239895',
  UCD13: '3400892398952',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ALM 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3594885',
  CIP13: '3400935948854',
  ucdLib: "AMOX/AC.CLAV ALM 100MG ENF60ML",
  UCD7: '9239889',
  UCD13: '3400892398891',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ALM 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3594827',
  CIP13: '3400935948274',
  ucdLib: "AMOX/AC.CLAV ARW 100MG BB.30ML",
  UCD7: '9242644',
  UCD13: '3400892426440',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ARW 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3594833',
  CIP13: '3400935948335',
  ucdLib: "AMOX/AC.CLAV ARW 100MG ENF60ML",
  UCD7: '9242638',
  UCD13: '3400892426389',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ARW 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3656273',
  CIP13: '3400936562738',
  ucdLib: "AMOX/AC.CLAV ARW 500/62,5 C.",
  UCD7: '9266969',
  UCD13: '3400892669694',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV ARW 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3656296',
  CIP13: '3400936562967',
  ucdLib: "AMOX/AC.CLAV ARW 500/62,5 C.",
  UCD7: '9266969',
  UCD13: '3400892669694',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV ARW 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3535552',
  CIP13: '3400935355522',
  ucdLib: "AMOX/AC.CLAV BGA 100MG BB.30ML",
  UCD7: '9233579',
  UCD13: '3400892335797',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV BGA 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3535569',
  CIP13: '3400935355690',
  ucdLib: "AMOX/AC.CLAV BGA 100MG ENF60ML",
  UCD7: '9233562',
  UCD13: '3400892335629',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV BGA 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3533487',
  CIP13: '3400935334879',
  ucdLib: "AMOX/AC.CLAV BGA 1G/125MG S.",
  UCD7: '9233556',
  UCD13: '3400892335568',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV BGA 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3533501',
  CIP13: '3400935335012',
  ucdLib: "AMOX/AC.CLAV BGA 1G/125MG S.",
  UCD7: '9233556',
  UCD13: '3400892335568',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV BGA 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3533524',
  CIP13: '3400935335241',
  ucdLib: "AMOX/AC.CLAV BGA 500/62,5 C.",
  UCD7: '9233585',
  UCD13: '3400892335858',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV BGA 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3533547',
  CIP13: '3400935335470',
  ucdLib: "AMOX/AC.CLAV BGA 500/62,5 C.",
  UCD7: '9233585',
  UCD13: '3400892335858',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV BGA 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3594856',
  CIP13: '3400935948564',
  ucdLib: "AMOX/AC.CLAV MYL 100MG BB.30ML",
  UCD7: '9240326',
  UCD13: '3400892403267',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV MYL 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3594862',
  CIP13: '3400935948625',
  ucdLib: "AMOX/AC.CLAV MYL 100MG ENF60ML",
  UCD7: '9240303',
  UCD13: '3400892403038',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV MYL 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3656221',
  CIP13: '3400936562219',
  ucdLib: "AMOX/AC.CLAV MYL 1G/125MG S.",
  UCD7: '9266314',
  UCD13: '3400892663142',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV MYL 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3656238',
  CIP13: '3400936562387',
  ucdLib: "AMOX/AC.CLAV MYL 1G/125MG S.",
  UCD7: '9266314',
  UCD13: '3400892663142',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV MYL 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3594891',
  CIP13: '3400935948915',
  ucdLib: "AMOX/AC.CLAV SDZ 100MG BB.30ML",
  UCD7: '9267756',
  UCD13: '3400892677569',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV SDZ 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3594916',
  CIP13: '3400935949165',
  ucdLib: "AMOX/AC.CLAV SDZ 100MG ENF60ML",
  UCD7: '9267733',
  UCD13: '3400892677330',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV SDZ 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3656327',
  CIP13: '3400936563278',
  ucdLib: "AMOX/AC.CLAV SDZ 1G/125MG S.",
  UCD7: '9267472',
  UCD13: '3400892674728',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV SDZ 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3656333',
  CIP13: '3400936563339',
  ucdLib: "AMOX/AC.CLAV SDZ 1G/125MG S.",
  UCD7: '9267472',
  UCD13: '3400892674728',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV SDZ 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3535575',
  CIP13: '3400935355751',
  ucdLib: "AMOX/AC.CLAV ZTL 100MG ENF60ML",
  UCD7: '9233438',
  UCD13: '3400892334387',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ZTL 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3533872',
  CIP13: '3400935338723',
  ucdLib: "AMOX/AC.CLAV ZTL 1G/125MG S.",
  UCD7: '9233421',
  UCD13: '3400892334219',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV ZTL 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3533895',
  CIP13: '3400935338952',
  ucdLib: "AMOX/AC.CLAV ZTL 1G/125MG S.",
  UCD7: '9233421',
  UCD13: '3400892334219',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV ZTL 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3533754',
  CIP13: '3400935337542',
  ucdLib: "AMOX/AC.CLAV ZTL 500/62,5 C.",
  UCD7: '9233450',
  UCD13: '3400892334509',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV ZTL 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3533777',
  CIP13: '3400935337771',
  ucdLib: "AMOX/AC.CLAV ZTL 500/62,5 C.",
  UCD7: '9233450',
  UCD13: '3400892334509',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV ZTL 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3533702',
  CIP13: '3400935337023',
  ucdLib: "AUGMENTIN 500MG/62,5MG CPR",
  UCD7: '9217764',
  UCD13: '3400892177649',
  ucdQtyMultiplicator: 16,
  cipLib: "AUGMENTIN 500MG/62,5MG CPR BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3533725',
  CIP13: '3400935337252',
  ucdLib: "AUGMENTIN 500MG/62,5MG CPR",
  UCD7: '9217764',
  UCD13: '3400892177649',
  ucdQtyMultiplicator: 24,
  cipLib: "AUGMENTIN 500MG/62,5MG CPR BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3638068',
  CIP13: '3400936380684',
  ucdLib: "AMOX/AC.CLAV ARW 1G/125MG S.",
  UCD7: '9265728',
  UCD13: '3400892657288',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV ARW 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3638074',
  CIP13: '3400936380745',
  ucdLib: "AMOX/AC.CLAV ARW 1G/125MG S.",
  UCD7: '9265728',
  UCD13: '3400892657288',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV ARW 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3668307',
  CIP13: '3400936683075',
  ucdLib: "AMOX/AC.CLAV EG 500/62,5 CPR",
  UCD7: '9273745',
  UCD13: '3400892737454',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV EG 500/62,5 CPR BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3668313',
  CIP13: '3400936683136',
  ucdLib: "AMOX/AC.CLAV EG 500/62,5 CPR",
  UCD7: '9273745',
  UCD13: '3400892737454',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV EG 500/62,5 CPR BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3773754',
  CIP13: '3400937737548',
  ucdLib: "AMOX/AC.CLAV ALT 100MG BB.30ML",
  UCD7: '9296344',
  UCD13: '3400892963440',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ALT 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3773748',
  CIP13: '3400937737487',
  ucdLib: "AMOX/AC.CLAV ALT 100MG ENF60ML",
  UCD7: '9296338',
  UCD13: '3400892963389',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV ALT 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3773642',
  CIP13: '3400937736428',
  ucdLib: "AMOX/AC.CLAV ALT 1G/125MG S.",
  UCD7: '9296321',
  UCD13: '3400892963211',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV ALT 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3773659',
  CIP13: '3400937736596',
  ucdLib: "AMOX/AC.CLAV ALT 1G/125MG S.",
  UCD7: '9296321',
  UCD13: '3400892963211',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV ALT 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3773412',
  CIP13: '3400937734127',
  ucdLib: "AMOX/AC.CLAV ALT 500/62,5 C.",
  UCD7: '9296350',
  UCD13: '3400892963501',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV ALT 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3773429',
  CIP13: '3400937734295',
  ucdLib: "AMOX/AC.CLAV ALT 500/62,5 C.",
  UCD7: '9296350',
  UCD13: '3400892963501',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV ALT 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3773487',
  CIP13: '3400937734875',
  ucdLib: "AMOX/AC.CLAV GSK 1G/125MG S.",
  UCD7: '9294865',
  UCD13: '3400892948652',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV GSK 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3773501',
  CIP13: '3400937735018',
  ucdLib: "AMOX/AC.CLAV GSK 1G/125MG S.",
  UCD7: '9294865',
  UCD13: '3400892948652',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV GSK 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3773582',
  CIP13: '3400937735827',
  ucdLib: "AMOX/AC.CLAV GSK 500/62,5 C.",
  UCD7: '9294894',
  UCD13: '3400892948942',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV GSK 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3773607',
  CIP13: '3400937736077',
  ucdLib: "AMOX/AC.CLAV GSK 500/62,5 C.",
  UCD7: '9294894',
  UCD13: '3400892948942',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV GSK 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3821341',
  CIP13: '3400938213416',
  ucdLib: "AMOX/AC.CLAV PAN 1G/200MG FL",
  UCD7: '9305600',
  UCD13: '3400893056004',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV PAN 1G/200MG FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3822085',
  CIP13: '3400938220858',
  ucdLib: "AMOX/AC.CLAV PAN 2G/200MG FL",
  UCD7: '9305617',
  UCD13: '3400893056172',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV PAN 2G/200MG FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3822122',
  CIP13: '3400938221220',
  ucdLib: "AMOX/AC.CLAV PAN 500/50MG FL",
  UCD7: '9305646',
  UCD13: '3400893056462',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV PAN 500/50MG FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3776511',
  CIP13: '3400937765114',
  ucdLib: "AMOX/AC.CLAV SDZ 1G/200MG FL",
  UCD7: '9297504',
  UCD13: '3400892975047',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV SDZ 1G/200MG FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3776468',
  CIP13: '3400937764681',
  ucdLib: "AMOX/AC.CLAV SDZ 2G/200MG FL",
  UCD7: '9297510',
  UCD13: '3400892975108',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV SDZ 2G/200MG FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3786107',
  CIP13: '3400937861076',
  ucdLib: "AMOX/AC.CLAV SDZ 500/50MG FL",
  UCD7: '9297680',
  UCD13: '3400892976808',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOX/AC.CLAV SDZ 500/50MG FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3759524',
  CIP13: '3400937595247',
  ucdLib: "AMOX/AC.CLAV CRT 100MG BB.30ML",
  UCD7: '9291513',
  UCD13: '3400892915135',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV CRT 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3759530',
  CIP13: '3400937595308',
  ucdLib: "AMOX/AC.CLAV CRT 100MG ENF60ML",
  UCD7: '9291507',
  UCD13: '3400892915074',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV CRT 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3750144',
  CIP13: '3400937501446',
  ucdLib: "AMOX/AC.CLAV CRT 500/62,5 C.",
  UCD7: '9289723',
  UCD13: '3400892897233',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV CRT 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3750150',
  CIP13: '3400937501507',
  ucdLib: "AMOX/AC.CLAV CRT 500/62,5 C.",
  UCD7: '9289723',
  UCD13: '3400892897233',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV CRT 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3868259',
  CIP13: '3400938682595',
  ucdLib: "AMOX/AC.CLAV EG 100MG BB. 30ML",
  UCD7: '9321964',
  UCD13: '3400893219645',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV EG 100MG BB. 30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3869804',
  CIP13: '3400938698046',
  ucdLib: "AMOX/AC.CLAV EGG 100MG ENF60ML",
  UCD7: '9320930',
  UCD13: '3400893209301',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV EGG 100MG ENF60ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3754165',
  CIP13: '3400937541657',
  ucdLib: "AMOX/AC.CLAV TVS 100MG BB.30ML",
  UCD7: '9353562',
  UCD13: '3400893535622',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOX/AC.CLAV TVS 100MG BB.30ML BT 1",
  atcCode: "J01CR02"
}, {
  CIP7: '3754113',
  CIP13: '3400937541138',
  ucdLib: "AMOX/AC.CLAV TVS 1G/125MG S.",
  UCD7: '9353533',
  UCD13: '3400893535332',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV TVS 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3754082',
  CIP13: '3400937540827',
  ucdLib: "AMOX/AC.CLAV TVS 500/62,5 C.",
  UCD7: '9353579',
  UCD13: '3400893535790',
  ucdQtyMultiplicator: 16,
  cipLib: "AMOX/AC.CLAV TVS 500/62,5 C. BT 16",
  atcCode: "J01CR02"
}, {
  CIP7: '3754099',
  CIP13: '3400937540995',
  ucdLib: "AMOX/AC.CLAV TVS 500/62,5 C.",
  UCD7: '9353579',
  UCD13: '3400893535790',
  ucdQtyMultiplicator: 24,
  cipLib: "AMOX/AC.CLAV TVS 500/62,5 C. BT 24",
  atcCode: "J01CR02"
}, {
  CIP7: '3445085',
  CIP13: '3400934450853',
  ucdLib: "AUGMENTIN 1G/125MG PDR SACH",
  UCD7: '9198311',
  UCD13: '3400891983111',
  ucdQtyMultiplicator: 8,
  cipLib: "AUGMENTIN 1G/125MG PDR SACH BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '3445116',
  CIP13: '3400934451164',
  ucdLib: "AUGMENTIN 1G/125MG PDR SACH",
  UCD7: '9198311',
  UCD13: '3400891983111',
  ucdQtyMultiplicator: 12,
  cipLib: "AUGMENTIN 1G/125MG PDR SACH BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3507745',
  CIP13: '3400935077455',
  ucdLib: "AUGMENTIN 1G/200MG IV FL",
  UCD7: '9108130',
  UCD13: '3400891081305',
  ucdQtyMultiplicator: 10,
  cipLib: "AUGMENTIN 1G/200MG IV FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3508207',
  CIP13: '3400935082077',
  ucdLib: "AUGMENTIN 2G/200MG IV FL",
  UCD7: '9108147',
  UCD13: '3400891081473',
  ucdQtyMultiplicator: 10,
  cipLib: "AUGMENTIN 2G/200MG IV FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '3508182',
  CIP13: '3400935081827',
  ucdLib: "AUGMENTIN 500MG/50MG IV FL",
  UCD7: '9108153',
  UCD13: '3400891081534',
  ucdQtyMultiplicator: 10,
  cipLib: "AUGMENTIN 500MG/50MG IV FL BT 10",
  atcCode: "J01CR02"
}, {
  CIP7: '2694159',
  CIP13: '3400926941598',
  ucdLib: "AMOX/AC.CLAV ZYD 1G/125MG S.",
  UCD7: '9392504',
  UCD13: '3400893925041',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV ZYD 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '2694171',
  CIP13: '3400926941710',
  ucdLib: "AMOX/AC.CLAV ZYD 1G/125MG S.",
  UCD7: '9392504',
  UCD13: '3400893925041',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV ZYD 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '2774993',
  CIP13: '3400927749933',
  ucdLib: "AMOX/AC.CLAV CRT 1G/125MG S.",
  UCD7: '9401396',
  UCD13: '3400894013969',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV CRT 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '2775001',
  CIP13: '3400927750014',
  ucdLib: "AMOX/AC.CLAV CRT 1G/125MG S.",
  UCD7: '9401396',
  UCD13: '3400894013969',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV CRT 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '2775018',
  CIP13: '3400927750182',
  ucdLib: "AMOX/AC.CLAV RBX 1G/125MG S.",
  UCD7: '9401404',
  UCD13: '3400894014041',
  ucdQtyMultiplicator: 8,
  cipLib: "AMOX/AC.CLAV RBX 1G/125MG S. BT 8",
  atcCode: "J01CR02"
}, {
  CIP7: '2775024',
  CIP13: '3400927750243',
  ucdLib: "AMOX/AC.CLAV RBX 1G/125MG S.",
  UCD7: '9401404',
  UCD13: '3400894014041',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV RBX 1G/125MG S. BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '2775076',
  CIP13: '3400927750762',
  ucdLib: "AMOX/AC.CLAV TVC 1G/125MG SS",
  UCD7: '9417865',
  UCD13: '3400894178651',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOX/AC.CLAV TVC 1G/125MG SS BT 12",
  atcCode: "J01CR02"
}, {
  CIP7: '3295361',
  CIP13: '3400932953615',
  ucdLib: "UNACIM 0,5G/1G INJ FL",
  UCD7: '9127133',
  UCD13: '3400891271331',
  ucdQtyMultiplicator: 1,
  cipLib: "UNACIM 0,5G/1G INJ FL BT 1",
  atcCode: "J01CR01"
}, {
  CIP7: '3337332',
  CIP13: '3400933373320',
  ucdLib: "UNACIM 0,5G/1G INJ FL+AMP",
  UCD7: '9152674',
  UCD13: '3400891526745',
  ucdQtyMultiplicator: 1,
  cipLib: "UNACIM 0,5G/1G INJ FL+AMP BT 1",
  atcCode: "J01CR01"
}, {
  CIP7: '3015226',
  CIP13: '3400930152263',
  ucdLib: "BRISTOPEN 1G/5ML INJ FL+AMP",
  UCD7: '9013240',
  UCD13: '3400890132404',
  ucdQtyMultiplicator: 1,
  cipLib: "BRISTOPEN 1G/5ML INJ FL+AMP BT 1",
  atcCode: "J01CF04"
}, {
  CIP7: '3001519',
  CIP13: '3400930015193',
  ucdLib: "CLOXACILLINE ARW 500MG GELU",
  UCD7: '9409995',
  UCD13: '3400894099956',
  ucdQtyMultiplicator: 16,
  cipLib: "CLOXACILLINE ARW 500MG GELU BT 16",
  atcCode: "J01CF02"
}, {
  CIP7: '3193933',
  CIP13: '3400931939337',
  ucdLib: "ORBENINE 500MG GELU",
  UCD7: '9065685',
  UCD13: '3400890656856',
  ucdQtyMultiplicator: 16,
  cipLib: "ORBENINE 500MG GELU BT 16",
  atcCode: "J01CF02"
}, {
  CIP7: '5564865',
  CIP13: '3400955648659',
  ucdLib: "ORBENINE 1G IV FL",
  UCD7: '9108443',
  UCD13: '3400891084436',
  ucdQtyMultiplicator: 10,
  cipLib: "ORBENINE 1G IV FL BT 10",
  atcCode: "J01CF02"
}, {
  CIP7: '5640796',
  CIP13: '3400956407965',
  ucdLib: "CLOXACILLINE PAN 1G INJ FL",
  UCD7: '9390770',
  UCD13: '3400893907702',
  ucdQtyMultiplicator: 10,
  cipLib: "CLOXACILLINE PAN 1G INJ FL BT 10",
  atcCode: "J01CF02"
}, {
  CIP7: '3282708',
  CIP13: '3400932827084',
  ucdLib: "ORACILLINE 1MN BUV FV180ML",
  UCD7: '9127015',
  UCD13: '3400891270150',
  ucdQtyMultiplicator: 1,
  cipLib: "ORACILLINE 1MN BUV FV180ML BT 1",
  atcCode: "J01CE10"
}, {
  CIP7: '3282660',
  CIP13: '3400932826605',
  ucdLib: "ORACILLINE 500M BUV FV120ML",
  UCD7: '9105841',
  UCD13: '3400891058413',
  ucdQtyMultiplicator: 1,
  cipLib: "ORACILLINE 500M BUV FV120ML BT 1",
  atcCode: "J01CE10"
}, {
  CIP7: '3181031',
  CIP13: '3400931810315',
  ucdLib: "ORACILLINE 250M BUV FV120ML",
  UCD7: '9065596',
  UCD13: '3400890655965',
  ucdQtyMultiplicator: 1,
  cipLib: "ORACILLINE 250M BUV FV120ML BT 1",
  atcCode: "J01CE10"
}, {
  CIP7: '3000284',
  CIP13: '3400930002841',
  ucdLib: "BENZATHINE BENZ.SDZ 1,2 FL+A.",
  UCD7: '9405773',
  UCD13: '3400894057734',
  ucdQtyMultiplicator: 1,
  cipLib: "BENZATHINE BENZ.SDZ 1,2 FL+A. BT 1",
  atcCode: "J01CE08"
}, {
  CIP7: '3000285',
  CIP13: '3400930002858',
  ucdLib: "BENZATHINE BENZ.SDZ 2,4 FL+A.",
  UCD7: '9405796',
  UCD13: '3400894057963',
  ucdQtyMultiplicator: 1,
  cipLib: "BENZATHINE BENZ.SDZ 2,4 FL+A. BT 1",
  atcCode: "J01CE08"
}, {
  CIP7: '3194915',
  CIP13: '3400931949152',
  ucdLib: "ORACILLINE 1MN UI CPR",
  UCD7: '9065544',
  UCD13: '3400890655446',
  ucdQtyMultiplicator: 12,
  cipLib: "ORACILLINE 1MN UI CPR BT 12",
  atcCode: "J01CE02"
}, {
  CIP7: '5597675',
  CIP13: '3400955976752',
  ucdLib: "PENICILLINE G PAN 5MN FL",
  UCD7: '9182221',
  UCD13: '3400891822212',
  ucdQtyMultiplicator: 25,
  cipLib: "PENICILLINE G PAN 5MN FL BT 25",
  atcCode: "J01CE01"
}, {
  CIP7: '3658208',
  CIP13: '3400936582088',
  ucdLib: "PENICILLINE G PAN 1MN FL",
  UCD7: '9182215',
  UCD13: '3400891822151',
  ucdQtyMultiplicator: 25,
  cipLib: "PENICILLINE G PAN 1MN FL BT 25",
  atcCode: "J01CE01"
}, {
  CIP7: '3000452',
  CIP13: '3400930004524',
  ucdLib: "NEGABAN 1G INJ FL",
  UCD7: '9295497',
  UCD13: '3400892954974',
  ucdQtyMultiplicator: 1,
  cipLib: "NEGABAN 1G INJ FL BT 1",
  atcCode: "J01CA17"
}, {
  CIP7: '3000453',
  CIP13: '3400930004531',
  ucdLib: "NEGABAN 2G INJ FL",
  UCD7: '9295505',
  UCD13: '3400892955056',
  ucdQtyMultiplicator: 1,
  cipLib: "NEGABAN 2G INJ FL BT 1",
  atcCode: "J01CA17"
}, {
  CIP7: '3239411',
  CIP13: '3400932394111',
  ucdLib: "TICARPEN 5G INJ FL",
  UCD7: '9093109',
  UCD13: '3400890931090',
  ucdQtyMultiplicator: 1,
  cipLib: "TICARPEN 5G INJ FL BT 1",
  atcCode: "J01CA13"
}, {
  CIP7: '5608309',
  CIP13: '3400956083091',
  ucdLib: "PIPERACILLINE PAN 1G INJ FL",
  UCD7: '9198386',
  UCD13: '3400891983869',
  ucdQtyMultiplicator: 1,
  cipLib: "PIPERACILLINE PAN 1G INJ FL BT 1",
  atcCode: "J01CA12"
}, {
  CIP7: '5645397',
  CIP13: '3400956453979',
  ucdLib: "PIPERACILLINE PAN 4G INJ FL",
  UCD7: '9198400',
  UCD13: '3400891984002',
  ucdQtyMultiplicator: 10,
  cipLib: "PIPERACILLINE PAN 4G INJ FL BT 10",
  atcCode: "J01CA12"
}, {
  CIP7: '3799305',
  CIP13: '3400937993050',
  ucdLib: "SELEXID 200MG CPR",
  UCD7: '9083387',
  UCD13: '3400890833875',
  ucdQtyMultiplicator: 12,
  cipLib: "SELEXID 200MG CPR BT 12",
  atcCode: "J01CA08"
}, {
  CIP7: '3611276',
  CIP13: '3400936112766',
  ucdLib: "AMOXICILLINE TVC 500MG GELU",
  UCD7: '9244494',
  UCD13: '3400892444949',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE TVC 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3576597',
  CIP13: '3400935765970',
  ucdLib: "AMOXICILLINE ARW 125MG BUV60ML",
  UCD7: '9235383',
  UCD13: '3400892353838',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ARW 125MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3576580',
  CIP13: '3400935765802',
  ucdLib: "AMOXICILLINE ARW 250MG BUV60ML",
  UCD7: '9235408',
  UCD13: '3400892354088',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ARW 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3576574',
  CIP13: '3400935765741',
  ucdLib: "AMOXICILLINE ARW 500MG BUV60ML",
  UCD7: '9235420',
  UCD13: '3400892354200',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ARW 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3576568',
  CIP13: '3400935765680',
  ucdLib: "AMOXICILLINE ARW 500MG GELU",
  UCD7: '9235414',
  UCD13: '3400892354149',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE ARW 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3579615',
  CIP13: '3400935796158',
  ucdLib: "AMOXICILLINE BGA 1G CPR DISP",
  UCD7: '9236419',
  UCD13: '3400892364193',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE BGA 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '5557753',
  CIP13: '3400955577539',
  ucdLib: "CLAMOXYL 1G IM IV FL",
  UCD7: '9108348',
  UCD13: '3400891083484',
  ucdQtyMultiplicator: 10,
  cipLib: "CLAMOXYL 1G IM IV FL BT 10",
  atcCode: "J01CA04"
}, {
  CIP7: '3234537',
  CIP13: '3400932345373',
  ucdLib: "AMODEX 250MG BUV PDR FL60ML",
  UCD7: '9003945',
  UCD13: '3400890039451',
  ucdQtyMultiplicator: 1,
  cipLib: "AMODEX 250MG BUV PDR FL60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3234543',
  CIP13: '3400932345434',
  ucdLib: "AMODEX 500MG BUV PDR FL60ML",
  UCD7: '9003974',
  UCD13: '3400890039741',
  ucdQtyMultiplicator: 1,
  cipLib: "AMODEX 500MG BUV PDR FL60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3234520',
  CIP13: '3400932345205',
  ucdLib: "AMODEX 500MG GELU",
  UCD7: '9003951',
  UCD13: '3400890039512',
  ucdQtyMultiplicator: 12,
  cipLib: "AMODEX 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '5869688',
  CIP13: '3400958696886',
  ucdLib: "AMOXICILLINE ARL 500MG GELU",
  UCD7: '9408352',
  UCD13: '3400894083528',
  ucdQtyMultiplicator: 30,
  cipLib: "AMOXICILLINE ARL 500MG GELU BT 30",
  atcCode: "J01CA04"
}, {
  CIP7: '3230002',
  CIP13: '3400932300020',
  ucdLib: "CLAMOXYL 500MG/5ML BUV FL60ML",
  UCD7: '9020180',
  UCD13: '3400890201803',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAMOXYL 500MG/5ML BUV FL60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3305496',
  CIP13: '3400933054960',
  ucdLib: "CLAMOXYL 1G CPR DISP",
  UCD7: '9141274',
  UCD13: '3400891412741',
  ucdQtyMultiplicator: 6,
  cipLib: "CLAMOXYL 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '5564871',
  CIP13: '3400955648710',
  ucdLib: "CLAMOXYL 500MG IM IV FL",
  UCD7: '9108354',
  UCD13: '3400891083545',
  ucdQtyMultiplicator: 10,
  cipLib: "CLAMOXYL 500MG IM IV FL BT 10",
  atcCode: "J01CA04"
}, {
  CIP7: '3688296',
  CIP13: '3400936882966',
  ucdLib: "AMOXICILLINE SDZ 125MG BUV60ML",
  UCD7: '9273107',
  UCD13: '3400892731070',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE SDZ 125MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3603584',
  CIP13: '3400936035843',
  ucdLib: "AMOXICILLINE TVS 125MG BUV60ML",
  UCD7: '9244057',
  UCD13: '3400892440576',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE TVS 125MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3603590',
  CIP13: '3400936035904',
  ucdLib: "AMOXICILLINE TVS 250MG BUV60ML",
  UCD7: '9244063',
  UCD13: '3400892440637',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE TVS 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3603609',
  CIP13: '3400936036093',
  ucdLib: "AMOXICILLINE TVS 500MG BUV60ML",
  UCD7: '9244086',
  UCD13: '3400892440866',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE TVS 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3225260',
  CIP13: '3400932252602',
  ucdLib: "CLAMOXYL 1G IM IV FL",
  UCD7: '9108348',
  UCD13: '3400891083484',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAMOXYL 1G IM IV FL BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3524330',
  CIP13: '3400935243300',
  ucdLib: "AMOXICILLINE BGA 1G CPR DISP",
  UCD7: '9236419',
  UCD13: '3400892364193',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE BGA 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3525200',
  CIP13: '3400935252005',
  ucdLib: "AMOXICILLINE MYP 125MG BUV60ML",
  UCD7: '9236112',
  UCD13: '3400892361123',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE MYP 125MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3525192',
  CIP13: '3400935251923',
  ucdLib: "AMOXICILLINE MYP 250MG BUV60ML",
  UCD7: '9236129',
  UCD13: '3400892361291',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE MYP 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3525186',
  CIP13: '3400935251862',
  ucdLib: "AMOXICILLINE MYP 500MG BUV60ML",
  UCD7: '9236141',
  UCD13: '3400892361413',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE MYP 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3406091',
  CIP13: '3400934060915',
  ucdLib: "AMOXICILLINE RPG 250MG BUV60ML",
  UCD7: '9180357',
  UCD13: '3400891803570',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE RPG 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3406122',
  CIP13: '3400934061226',
  ucdLib: "AMOXICILLINE RPG 500MG BUV60ML",
  UCD7: '9180392',
  UCD13: '3400891803921',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE RPG 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3525246',
  CIP13: '3400935252463',
  ucdLib: "AMOXICILLINE ZYD 125MG BUV60ML",
  UCD7: '9222127',
  UCD13: '3400892221274',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ZYD 125MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3525223',
  CIP13: '3400935252234',
  ucdLib: "AMOXICILLINE ZYD 250MG BUV60ML",
  UCD7: '9222133',
  UCD13: '3400892221335',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ZYD 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3525217',
  CIP13: '3400935252173',
  ucdLib: "AMOXICILLINE ZYD 500MG BUV60ML",
  UCD7: '9222156',
  UCD13: '3400892221564',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ZYD 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3679601',
  CIP13: '3400936796010',
  ucdLib: "AMOXICILLINE SDZ 500MG GELU",
  UCD7: '9268603',
  UCD13: '3400892686035',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE SDZ 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3674265',
  CIP13: '3400936742659',
  ucdLib: "AMOXICILLINE ZEN 1G CPR DISP",
  UCD7: '9269749',
  UCD13: '3400892697499',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE ZEN 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3674271',
  CIP13: '3400936742710',
  ucdLib: "AMOXICILLINE ZEN 1G CPR DISP",
  UCD7: '9269749',
  UCD13: '3400892697499',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE ZEN 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3673610',
  CIP13: '3400936736108',
  ucdLib: "AMOXICILLINE ZEN 250MG BUV60ML",
  UCD7: '9266627',
  UCD13: '3400892666273',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ZEN 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3673627',
  CIP13: '3400936736276',
  ucdLib: "AMOXICILLINE ZEN 500MG BUV60ML",
  UCD7: '9266656',
  UCD13: '3400892666563',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ZEN 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3673633',
  CIP13: '3400936736337',
  ucdLib: "AMOXICILLINE ZEN 500MG GELU",
  UCD7: '9266633',
  UCD13: '3400892666334',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE ZEN 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3568451',
  CIP13: '3400935684516',
  ucdLib: "AMOXICILLINE MYL 1G CPR DISP",
  UCD7: '9232321',
  UCD13: '3400892323213',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE MYL 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3568468',
  CIP13: '3400935684684',
  ucdLib: "AMOXICILLINE MYL 1G CPR DISP",
  UCD7: '9232321',
  UCD13: '3400892323213',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE MYL 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3855185',
  CIP13: '3400938551853',
  ucdLib: "AMOXICILLINE RBX 500MG GELU",
  UCD7: '9319393',
  UCD13: '3400893193938',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE RBX 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3558286',
  CIP13: '3400935582867',
  ucdLib: "AMOXICILLINE TVS 1G CPR DISP",
  UCD7: '9226421',
  UCD13: '3400892264219',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE TVS 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3558292',
  CIP13: '3400935582928',
  ucdLib: "AMOXICILLINE TVS 1G CPR DISP",
  UCD7: '9226421',
  UCD13: '3400892264219',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE TVS 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3211105',
  CIP13: '3400932111053',
  ucdLib: "CLAMOXYL 125MG/5ML BUV FL60ML",
  UCD7: '9020116',
  UCD13: '3400890201162',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAMOXYL 125MG/5ML BUV FL60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3211128',
  CIP13: '3400932111282',
  ucdLib: "CLAMOXYL 250MG/5ML BUV FL60ML",
  UCD7: '9020151',
  UCD13: '3400890201513',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAMOXYL 250MG/5ML BUV FL60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3597978',
  CIP13: '3400935979780',
  ucdLib: "AMOXICILLINE ARW 1G CPR DISP",
  UCD7: '9243477',
  UCD13: '3400892434773',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE ARW 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3597984',
  CIP13: '3400935979841',
  ucdLib: "AMOXICILLINE ARW 1G CPR DISP",
  UCD7: '9243477',
  UCD13: '3400892434773',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE ARW 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3628503',
  CIP13: '3400936285033',
  ucdLib: "AMOXICILLINE CRT 125MG BUV60ML",
  UCD7: '9257640',
  UCD13: '3400892576404',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE CRT 125MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3628526',
  CIP13: '3400936285262',
  ucdLib: "AMOXICILLINE CRT 250MG BUV60ML",
  UCD7: '9257657',
  UCD13: '3400892576572',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE CRT 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3628532',
  CIP13: '3400936285323',
  ucdLib: "AMOXICILLINE CRT 500MG BUV60ML",
  UCD7: '9257686',
  UCD13: '3400892576862',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE CRT 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3628495',
  CIP13: '3400936284951',
  ucdLib: "AMOXICILLINE CRT 500MG GELU",
  UCD7: '9257663',
  UCD13: '3400892576633',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE CRT 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3532559',
  CIP13: '3400935325594',
  ucdLib: "AMOXICILLINE EG 250MG BUV 60ML",
  UCD7: '9219272',
  UCD13: '3400892192727',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE EG 250MG BUV 60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3533464',
  CIP13: '3400935334640',
  ucdLib: "AMOXICILLINE EG 500MG BUV 60ML",
  UCD7: '9219289',
  UCD13: '3400892192895',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE EG 500MG BUV 60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3518683',
  CIP13: '3400935186836',
  ucdLib: "AMOXICILLINE EG 500MG GELU",
  UCD7: '9214984',
  UCD13: '3400892149844',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE EG 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3537798',
  CIP13: '3400935377982',
  ucdLib: "AMOXICILLINE EGL 1G CPR DISP",
  UCD7: '9219705',
  UCD13: '3400892197050',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE EGL 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3537806',
  CIP13: '3400935378064',
  ucdLib: "AMOXICILLINE EGL 1G CPR DISP",
  UCD7: '9219705',
  UCD13: '3400892197050',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE EGL 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3658243',
  CIP13: '3400936582439',
  ucdLib: "AMOXICILLINE SDZ 250MG BUV60ML",
  UCD7: '9263770',
  UCD13: '3400892637709',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE SDZ 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3417172',
  CIP13: '3400934171727',
  ucdLib: "CLAMOXYL 1G CPR DISP",
  UCD7: '9141274',
  UCD13: '3400891412741',
  ucdQtyMultiplicator: 14,
  cipLib: "CLAMOXYL 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3705416',
  CIP13: '3400937054164',
  ucdLib: "AMOXICILLINE ALM 250MG BUV60ML",
  UCD7: '9279446',
  UCD13: '3400892794464',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ALM 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3705391',
  CIP13: '3400937053914',
  ucdLib: "AMOXICILLINE ALM 500MG BUV60ML",
  UCD7: '9279469',
  UCD13: '3400892794693',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ALM 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3705439',
  CIP13: '3400937054393',
  ucdLib: "AMOXICILLINE ALM 500MG GELU",
  UCD7: '9279452',
  UCD13: '3400892794525',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE ALM 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3542813',
  CIP13: '3400935428134',
  ucdLib: "AMOXICILLINE EG 125MG BUV 60ML",
  UCD7: '9221234',
  UCD13: '3400892212340',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE EG 125MG BUV 60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '5603588',
  CIP13: '3400956035885',
  ucdLib: "AMOXICILLINE PAN 1G INJ FL",
  UCD7: '9192047',
  UCD13: '3400891920475',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOXICILLINE PAN 1G INJ FL BT 10",
  atcCode: "J01CA04"
}, {
  CIP7: '5603594',
  CIP13: '3400956035946',
  ucdLib: "AMOXICILLINE PAN 2G INJ FL",
  UCD7: '9192076',
  UCD13: '3400891920765',
  ucdQtyMultiplicator: 10,
  cipLib: "AMOXICILLINE PAN 2G INJ FL BT 10",
  atcCode: "J01CA04"
}, {
  CIP7: '3158753',
  CIP13: '3400931587538',
  ucdLib: "CLAMOXYL 500MG GELU",
  UCD7: '9020174',
  UCD13: '3400890201742',
  ucdQtyMultiplicator: 12,
  cipLib: "CLAMOXYL 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3761461',
  CIP13: '3400937614610',
  ucdLib: "AMOXICILLINE ALM 1G CPR DISP",
  UCD7: '9288818',
  UCD13: '3400892888187',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE ALM 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3761478',
  CIP13: '3400937614788',
  ucdLib: "AMOXICILLINE ALM 1G CPR DISP",
  UCD7: '9288818',
  UCD13: '3400892888187',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE ALM 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3385868',
  CIP13: '3400933858681',
  ucdLib: "AMOXICILLINE BGA 125MG BUV60ML",
  UCD7: '9191088',
  UCD13: '3400891910889',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE BGA 125MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3385880',
  CIP13: '3400933858803',
  ucdLib: "AMOXICILLINE BGA 250MG BUV60ML",
  UCD7: '9191094',
  UCD13: '3400891910940',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE BGA 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3385905',
  CIP13: '3400933859053',
  ucdLib: "AMOXICILLINE BGA 500MG BUV60ML",
  UCD7: '9191102',
  UCD13: '3400891911022',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE BGA 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3385704',
  CIP13: '3400933857042',
  ucdLib: "AMOXICILLINE BGA 500MG GELU",
  UCD7: '9192461',
  UCD13: '3400891924619',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE BGA 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3666573',
  CIP13: '3400936665736',
  ucdLib: "AMOXICILLINE SDZ 500MG BUV60ML",
  UCD7: '9272177',
  UCD13: '3400892721774',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE SDZ 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '3491317',
  CIP13: '3400934913174',
  ucdLib: "AMOXICILLINE MYP 500MG GELU",
  UCD7: '9236135',
  UCD13: '3400892361352',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE MYP 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3443382',
  CIP13: '3400934433825',
  ucdLib: "AMODEX 1G CPR DISP",
  UCD7: '9238105',
  UCD13: '3400892381053',
  ucdQtyMultiplicator: 6,
  cipLib: "AMODEX 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3443399',
  CIP13: '3400934433993',
  ucdLib: "AMODEX 1G CPR DISP",
  UCD7: '9238105',
  UCD13: '3400892381053',
  ucdQtyMultiplicator: 14,
  cipLib: "AMODEX 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3920741',
  CIP13: '3400939207414',
  ucdLib: "AMOXICILLINE SDZ 1G CPR DISP",
  UCD7: '9339208',
  UCD13: '3400893392089',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE SDZ 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3920787',
  CIP13: '3400939207872',
  ucdLib: "AMOXICILLINE SDZ 1G CPR DISP",
  UCD7: '9339208',
  UCD13: '3400893392089',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE SDZ 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3882911',
  CIP13: '3400938829112',
  ucdLib: "AMOXICILLINE ZYF 1G CPR DISP",
  UCD7: '9323147',
  UCD13: '3400893231470',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE ZYF 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3882934',
  CIP13: '3400938829341',
  ucdLib: "AMOXICILLINE ZYF 1G CPR DISP",
  UCD7: '9323147',
  UCD13: '3400893231470',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE ZYF 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '3844336',
  CIP13: '3400938443363',
  ucdLib: "AMOXICILLINE RBX 1G CPR DISP",
  UCD7: '9315142',
  UCD13: '3400893151426',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE RBX 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '3844342',
  CIP13: '3400938443424',
  ucdLib: "AMOXICILLINE RBX 1G CPR DISP",
  UCD7: '9315142',
  UCD13: '3400893151426',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE RBX 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '2759031',
  CIP13: '3400927590313',
  ucdLib: "AMOXICILLINE ZYF 500MG GELU",
  UCD7: '9416305',
  UCD13: '3400894163053',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE ZYF 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '5815735',
  CIP13: '3400958157356',
  ucdLib: "AMOXICILLINE ARW 1G CPR DISP",
  UCD7: '9243477',
  UCD13: '3400892434773',
  ucdQtyMultiplicator: 30,
  cipLib: "AMOXICILLINE ARW 1G CPR DISP BT 30",
  atcCode: "J01CA04"
}, {
  CIP7: '2792873',
  CIP13: '3400927928734',
  ucdLib: "AMOXICILLINE ZTL 125MG BUV60ML",
  UCD7: '9406637',
  UCD13: '3400894066378',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ZTL 125MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '2792896',
  CIP13: '3400927928963',
  ucdLib: "AMOXICILLINE ZTL 1G CPR DISP",
  UCD7: '9406643',
  UCD13: '3400894066439',
  ucdQtyMultiplicator: 6,
  cipLib: "AMOXICILLINE ZTL 1G CPR DISP BT 6",
  atcCode: "J01CA04"
}, {
  CIP7: '2792904',
  CIP13: '3400927929045',
  ucdLib: "AMOXICILLINE ZTL 1G CPR DISP",
  UCD7: '9406643',
  UCD13: '3400894066439',
  ucdQtyMultiplicator: 14,
  cipLib: "AMOXICILLINE ZTL 1G CPR DISP BT 14",
  atcCode: "J01CA04"
}, {
  CIP7: '2792850',
  CIP13: '3400927928505',
  ucdLib: "AMOXICILLINE ZTL 250MG BUV60ML",
  UCD7: '9406666',
  UCD13: '3400894066668',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ZTL 250MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '2792838',
  CIP13: '3400927928383',
  ucdLib: "AMOXICILLINE ZTL 500MG BUV60ML",
  UCD7: '9406689',
  UCD13: '3400894066897',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE ZTL 500MG BUV60ML BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '2792933',
  CIP13: '3400927929335',
  ucdLib: "AMOXICILLINE ZTL 500MG GELU",
  UCD7: '9406672',
  UCD13: '3400894066729',
  ucdQtyMultiplicator: 12,
  cipLib: "AMOXICILLINE ZTL 500MG GELU BT 12",
  atcCode: "J01CA04"
}, {
  CIP7: '3422859',
  CIP13: '3400934228599',
  ucdLib: "AMOXICILLINE PAN 1G FL+AMP",
  UCD7: '9192053',
  UCD13: '3400891920536',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOXICILLINE PAN 1G FL+AMP BT 1",
  atcCode: "J01CA04"
}, {
  CIP7: '5524995',
  CIP13: '3400955249955',
  ucdLib: "CLAMOXYL 2G IV FL",
  UCD7: '9020139',
  UCD13: '3400890201391',
  ucdQtyMultiplicator: 10,
  cipLib: "CLAMOXYL 2G IV FL BT 10",
  atcCode: "J01CA04"
}, {
  CIP7: '5536538',
  CIP13: '3400955365389',
  ucdLib: "THIOPHENICOL 750MG INJ FL+AMP",
  UCD7: '9092736',
  UCD13: '3400890927369',
  ucdQtyMultiplicator: 20,
  cipLib: "THIOPHENICOL 750MG INJ FL+AMP BT 20",
  atcCode: "J01BA02"
}, {
  CIP7: '3105923',
  CIP13: '3400931059233',
  ucdLib: "THIOPHENICOL 250MG CPR",
  UCD7: '9092713',
  UCD13: '3400890927130',
  ucdQtyMultiplicator: 16,
  cipLib: "THIOPHENICOL 250MG CPR BT 16",
  atcCode: "J01BA02"
}, {
  CIP7: '3105946',
  CIP13: '3400931059462',
  ucdLib: "THIOPHENICOL 750MG INJ FL+AMP",
  UCD7: '9092736',
  UCD13: '3400890927369',
  ucdQtyMultiplicator: 1,
  cipLib: "THIOPHENICOL 750MG INJ FL+AMP BT 1",
  atcCode: "J01BA02"
}, {
  CIP7: '5670320',
  CIP13: '3400956703203',
  ucdLib: "TYGACIL 50MG PERF FV5ML",
  UCD7: '9285027',
  UCD13: '3400892850276',
  ucdQtyMultiplicator: 10,
  cipLib: "TYGACIL 50MG PERF FV5ML BT 10",
  atcCode: "J01AA12"
}, {
  CIP7: '3411689',
  CIP13: '3400934116896',
  ucdLib: "MYNOCINE 100MG GELU",
  UCD7: '9060570',
  UCD13: '3400890605700',
  ucdQtyMultiplicator: 15,
  cipLib: "MYNOCINE 100MG GELU BT 15",
  atcCode: "J01AA08"
}, {
  CIP7: '3479701',
  CIP13: '3400934797019',
  ucdLib: "MINOCYCLINE BGA 100MG CPR",
  UCD7: '9196909',
  UCD13: '3400891969092',
  ucdQtyMultiplicator: 14,
  cipLib: "MINOCYCLINE BGA 100MG CPR BT 14",
  atcCode: "J01AA08"
}, {
  CIP7: '3404471',
  CIP13: '3400934044717',
  ucdLib: "PHYSIOMYCINE 300MG GELU",
  UCD7: '9071639',
  UCD13: '3400890716390',
  ucdQtyMultiplicator: 16,
  cipLib: "PHYSIOMYCINE 300MG GELU BT 16",
  atcCode: "J01AA05"
}, {
  CIP7: '3173072',
  CIP13: '3400931730729',
  ucdLib: "LYSOCLINE 300MG GELU",
  UCD7: '9055770',
  UCD13: '3400890557702',
  ucdQtyMultiplicator: 12,
  cipLib: "LYSOCLINE 300MG GELU BT 12",
  atcCode: "J01AA05"
}, {
  CIP7: '3675980',
  CIP13: '3400936759800',
  ucdLib: "TETRALYSAL 300MG GELU",
  UCD7: '9332011',
  UCD13: '3400893320112',
  ucdQtyMultiplicator: 28,
  cipLib: "TETRALYSAL 300MG GELU BT 28",
  atcCode: "J01AA04"
}, {
  CIP7: '4158809',
  CIP13: '3400941588099',
  ucdLib: "TETRALYSAL 150MG GELU",
  UCD7: '9091889',
  UCD13: '3400890918893',
  ucdQtyMultiplicator: 56,
  cipLib: "TETRALYSAL 150MG GELU BT 56",
  atcCode: "J01AA04"
}, {
  CIP7: '2798315',
  CIP13: '3400927983153',
  ucdLib: "LYMECYCLINE ARW 408MG GELU",
  UCD7: '9409446',
  UCD13: '3400894094463',
  ucdQtyMultiplicator: 28,
  cipLib: "LYMECYCLINE ARW 408MG GELU BT 28",
  atcCode: "J01AA04"
}, {
  CIP7: '3454931',
  CIP13: '3400934549311',
  ucdLib: "DOXY 100MG CPR",
  UCD7: '9200203',
  UCD13: '3400892002033',
  ucdQtyMultiplicator: 5,
  cipLib: "DOXY 100MG CPR BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '3454954',
  CIP13: '3400934549540',
  ucdLib: "DOXY 100MG CPR",
  UCD7: '9200203',
  UCD13: '3400892002033',
  ucdQtyMultiplicator: 15,
  cipLib: "DOXY 100MG CPR BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3454977',
  CIP13: '3400934549779',
  ucdLib: "DOXY 50MG CPR",
  UCD7: '9200226',
  UCD13: '3400892002262',
  ucdQtyMultiplicator: 14,
  cipLib: "DOXY 50MG CPR BT 14",
  atcCode: "J01AA02"
}, {
  CIP7: '3454983',
  CIP13: '3400934549830',
  ucdLib: "DOXY 50MG CPR",
  UCD7: '9200226',
  UCD13: '3400892002262',
  ucdQtyMultiplicator: 28,
  cipLib: "DOXY 50MG CPR BT 28",
  atcCode: "J01AA02"
}, {
  CIP7: '3613045',
  CIP13: '3400936130456',
  ucdLib: "DOXYCYCLINE ARW 100MG CPR",
  UCD7: '9250632',
  UCD13: '3400892506326',
  ucdQtyMultiplicator: 5,
  cipLib: "DOXYCYCLINE ARW 100MG CPR BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '3613051',
  CIP13: '3400936130517',
  ucdLib: "DOXYCYCLINE ARW 100MG CPR",
  UCD7: '9250632',
  UCD13: '3400892506326',
  ucdQtyMultiplicator: 15,
  cipLib: "DOXYCYCLINE ARW 100MG CPR BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3613068',
  CIP13: '3400936130685',
  ucdLib: "DOXYCYCLINE ARW 100MG CPR",
  UCD7: '9250632',
  UCD13: '3400892506326',
  ucdQtyMultiplicator: 30,
  cipLib: "DOXYCYCLINE ARW 100MG CPR BT 30",
  atcCode: "J01AA02"
}, {
  CIP7: '3617497',
  CIP13: '3400936174979',
  ucdLib: "DOXYCYCLINE TVC 100MG CPR",
  UCD7: '9250023',
  UCD13: '3400892500232',
  ucdQtyMultiplicator: 5,
  cipLib: "DOXYCYCLINE TVC 100MG CPR BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '3617505',
  CIP13: '3400936175051',
  ucdLib: "DOXYCYCLINE TVC 100MG CPR",
  UCD7: '9250023',
  UCD13: '3400892500232',
  ucdQtyMultiplicator: 15,
  cipLib: "DOXYCYCLINE TVC 100MG CPR BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3617528',
  CIP13: '3400936175280',
  ucdLib: "DOXYCYCLINE TVC 100MG CPR",
  UCD7: '9250023',
  UCD13: '3400892500232',
  ucdQtyMultiplicator: 30,
  cipLib: "DOXYCYCLINE TVC 100MG CPR BT 30",
  atcCode: "J01AA02"
}, {
  CIP7: '3249970',
  CIP13: '3400932499700',
  ucdLib: "VIBRAMYCINE N 100MG CPR",
  UCD7: '9098532',
  UCD13: '3400890985321',
  ucdQtyMultiplicator: 5,
  cipLib: "VIBRAMYCINE N 100MG CPR BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '5565362',
  CIP13: '3400955653622',
  ucdLib: "VIBRAVEINEUSE 100MG IV AMP5ML",
  UCD7: '9098561',
  UCD13: '3400890985611',
  ucdQtyMultiplicator: 1,
  cipLib: "VIBRAVEINEUSE 100MG IV AMP5ML BT 1",
  atcCode: "J01AA02"
}, {
  CIP7: '3561644',
  CIP13: '3400935616449',
  ucdLib: "DOXY 100MG CPR",
  UCD7: '9200203',
  UCD13: '3400892002033',
  ucdQtyMultiplicator: 30,
  cipLib: "DOXY 100MG CPR BT 30",
  atcCode: "J01AA02"
}, {
  CIP7: '3558197',
  CIP13: '3400935581976',
  ucdLib: "DOXYCYCLINE MYL 100MG C.SEC",
  UCD7: '9232427',
  UCD13: '3400892324272',
  ucdQtyMultiplicator: 5,
  cipLib: "DOXYCYCLINE MYL 100MG C.SEC BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '3558211',
  CIP13: '3400935582119',
  ucdLib: "DOXYCYCLINE MYL 100MG C.SEC",
  UCD7: '9232427',
  UCD13: '3400892324272',
  ucdQtyMultiplicator: 15,
  cipLib: "DOXYCYCLINE MYL 100MG C.SEC BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3558234',
  CIP13: '3400935582348',
  ucdLib: "DOXYCYCLINE MYL 100MG C.SEC",
  UCD7: '9232427',
  UCD13: '3400892324272',
  ucdQtyMultiplicator: 30,
  cipLib: "DOXYCYCLINE MYL 100MG C.SEC BT 30",
  atcCode: "J01AA02"
}, {
  CIP7: '3562939',
  CIP13: '3400935629395',
  ucdLib: "DOXYPALU 100MG CPR",
  UCD7: '9238654',
  UCD13: '3400892386546',
  ucdQtyMultiplicator: 28,
  cipLib: "DOXYPALU 100MG CPR BT 28",
  atcCode: "J01AA02"
}, {
  CIP7: '3559920',
  CIP13: '3400935599209',
  ucdLib: "SPANOR 100MG CPR",
  UCD7: '9086612',
  UCD13: '3400890866125',
  ucdQtyMultiplicator: 15,
  cipLib: "SPANOR 100MG CPR BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3559937',
  CIP13: '3400935599377',
  ucdLib: "SPANOR 100MG CPR",
  UCD7: '9086612',
  UCD13: '3400890866125',
  ucdQtyMultiplicator: 30,
  cipLib: "SPANOR 100MG CPR BT 30",
  atcCode: "J01AA02"
}, {
  CIP7: '3396553',
  CIP13: '3400933965532',
  ucdLib: "TOLEXINE 100MG CPR",
  UCD7: '9178573',
  UCD13: '3400891785739',
  ucdQtyMultiplicator: 15,
  cipLib: "TOLEXINE 100MG CPR BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3396524',
  CIP13: '3400933965242',
  ucdLib: "TOLEXINE 50MG CPR",
  UCD7: '9178596',
  UCD13: '3400891785968',
  ucdQtyMultiplicator: 14,
  cipLib: "TOLEXINE 50MG CPR BT 14",
  atcCode: "J01AA02"
}, {
  CIP7: '3396530',
  CIP13: '3400933965303',
  ucdLib: "TOLEXINE 50MG CPR",
  UCD7: '9178596',
  UCD13: '3400891785968',
  ucdQtyMultiplicator: 28,
  cipLib: "TOLEXINE 50MG CPR BT 28",
  atcCode: "J01AA02"
}, {
  CIP7: '3559943',
  CIP13: '3400935599438',
  ucdLib: "VIBRAMYCINE N 100MG CPR",
  UCD7: '9098532',
  UCD13: '3400890985321',
  ucdQtyMultiplicator: 30,
  cipLib: "VIBRAMYCINE N 100MG CPR BT 30",
  atcCode: "J01AA02"
}, {
  CIP7: '3533263',
  CIP13: '3400935332639',
  ucdLib: "DOXYCYCLINE BGA 100MG CPR",
  UCD7: '9218999',
  UCD13: '3400892189994',
  ucdQtyMultiplicator: 5,
  cipLib: "DOXYCYCLINE BGA 100MG CPR BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '3533286',
  CIP13: '3400935332868',
  ucdLib: "DOXYCYCLINE BGA 100MG CPR",
  UCD7: '9218999',
  UCD13: '3400892189994',
  ucdQtyMultiplicator: 15,
  cipLib: "DOXYCYCLINE BGA 100MG CPR BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3533435',
  CIP13: '3400935334350',
  ucdLib: "DOXYPALU 50MG CPR",
  UCD7: '9238660',
  UCD13: '3400892386607',
  ucdQtyMultiplicator: 28,
  cipLib: "DOXYPALU 50MG CPR BT 28",
  atcCode: "J01AA02"
}, {
  CIP7: '3766613',
  CIP13: '3400937666138',
  ucdLib: "DOXYCYCLINE SDZ 100MG C.SEC",
  UCD7: '9291571',
  UCD13: '3400892915715',
  ucdQtyMultiplicator: 5,
  cipLib: "DOXYCYCLINE SDZ 100MG C.SEC BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '3766636',
  CIP13: '3400937666367',
  ucdLib: "DOXYCYCLINE SDZ 100MG C.SEC",
  UCD7: '9291571',
  UCD13: '3400892915715',
  ucdQtyMultiplicator: 15,
  cipLib: "DOXYCYCLINE SDZ 100MG C.SEC BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3642265',
  CIP13: '3400936422650',
  ucdLib: "DOXYLIS 100MG CPR",
  UCD7: '9261825',
  UCD13: '3400892618258',
  ucdQtyMultiplicator: 30,
  cipLib: "DOXYLIS 100MG CPR BT 30",
  atcCode: "J01AA02"
}, {
  CIP7: '3474827',
  CIP13: '3400934748271',
  ucdLib: "TOLEXINE 100MG CPR",
  UCD7: '9178573',
  UCD13: '3400891785739',
  ucdQtyMultiplicator: 28,
  cipLib: "TOLEXINE 100MG CPR BT 28",
  atcCode: "J01AA02"
}, {
  CIP7: '3443330',
  CIP13: '3400934433306',
  ucdLib: "GRANUDOXY 100MG CPR",
  UCD7: '9197116',
  UCD13: '3400891971163',
  ucdQtyMultiplicator: 5,
  cipLib: "GRANUDOXY 100MG CPR BT 5",
  atcCode: "J01AA02"
}, {
  CIP7: '3443347',
  CIP13: '3400934433474',
  ucdLib: "GRANUDOXY 100MG CPR",
  UCD7: '9197116',
  UCD13: '3400891971163',
  ucdQtyMultiplicator: 15,
  cipLib: "GRANUDOXY 100MG CPR BT 15",
  atcCode: "J01AA02"
}, {
  CIP7: '3443353',
  CIP13: '3400934433535',
  ucdLib: "GRANUDOXY 100MG CPR",
  UCD7: '9197116',
  UCD13: '3400891971163',
  ucdQtyMultiplicator: 28,
  cipLib: "GRANUDOXY 100MG CPR BT 28",
  atcCode: "J01AA02"
}, {
  CIP7: '2189757',
  CIP13: '3400921897579',
  ucdLib: "DOXYCYCLINE SDZ 100MG C.SEC",
  UCD7: '9291571',
  UCD13: '3400892915715',
  ucdQtyMultiplicator: 30,
  cipLib: "DOXYCYCLINE SDZ 100MG C.SEC BT 30",
  atcCode: "J01AA02"
}, {
  CIP7: '3651554',
  CIP13: '3400936515543',
  ucdLib: "MIMPARA 30MG CPR",
  UCD7: '9266521',
  UCD13: '3400892665214',
  ucdQtyMultiplicator: 28,
  cipLib: "MIMPARA 30MG CPR BT 28",
  atcCode: "H05BX01"
}, {
  CIP7: '3651608',
  CIP13: '3400936516083',
  ucdLib: "MIMPARA 60MG CPR",
  UCD7: '9266538',
  UCD13: '3400892665382',
  ucdQtyMultiplicator: 28,
  cipLib: "MIMPARA 60MG CPR BT 28",
  atcCode: "H05BX01"
}, {
  CIP7: '3651643',
  CIP13: '3400936516434',
  ucdLib: "MIMPARA 90MG CPR",
  UCD7: '9266544',
  UCD13: '3400892665443',
  ucdQtyMultiplicator: 28,
  cipLib: "MIMPARA 90MG CPR BT 28",
  atcCode: "H05BX01"
}, {
  CIP7: '3302032',
  CIP13: '3400933020323',
  ucdLib: "MIACALCIC 50UI INJ A.1ML",
  UCD7: '9130649',
  UCD13: '3400891306491',
  ucdQtyMultiplicator: 5,
  cipLib: "MIACALCIC 50UI INJ A.1ML BT 5",
  atcCode: "H05BA01"
}, {
  CIP7: '3681779',
  CIP13: '3400936817791',
  ucdLib: "CALCITONINE SDZ 50UI/1ML AMP",
  UCD7: '9268804',
  UCD13: '3400892688046',
  ucdQtyMultiplicator: 5,
  cipLib: "CALCITONINE SDZ 50UI/1ML AMP BT 5",
  atcCode: "H05BA01"
}, {
  CIP7: '3406582',
  CIP13: '3400934065828',
  ucdLib: "CALSYN 100UI INJ AMP1ML",
  UCD7: '9191378',
  UCD13: '3400891913781',
  ucdQtyMultiplicator: 1,
  cipLib: "CALSYN 100UI INJ AMP1ML BT 1",
  atcCode: "H05BA01"
}, {
  CIP7: '3406576',
  CIP13: '3400934065767',
  ucdLib: "CALSYN 50UI INJ AMP0,5ML",
  UCD7: '9191384',
  UCD13: '3400891913842',
  ucdQtyMultiplicator: 1,
  cipLib: "CALSYN 50UI INJ AMP0,5ML BT 1",
  atcCode: "H05BA01"
}, {
  CIP7: '3476447',
  CIP13: '3400934764479',
  ucdLib: "CALCITONINE PMY 100UI/1ML AMP",
  UCD7: '9209606',
  UCD13: '3400892096063',
  ucdQtyMultiplicator: 5,
  cipLib: "CALCITONINE PMY 100UI/1ML AMP BT 5",
  atcCode: "H05BA01"
}, {
  CIP7: '3476430',
  CIP13: '3400934764301',
  ucdLib: "CALCITONINE PMY 50UI/1ML AMP",
  UCD7: '9209612',
  UCD13: '3400892096124',
  ucdQtyMultiplicator: 5,
  cipLib: "CALCITONINE PMY 50UI/1ML AMP BT 5",
  atcCode: "H05BA01"
}, {
  CIP7: '3622162',
  CIP13: '3400936221628',
  ucdLib: "FORSTEO 20MCG/80MCL INJ 3ML",
  UCD7: '9262718',
  UCD13: '3400892627182',
  ucdQtyMultiplicator: 1,
  cipLib: "FORSTEO 20MCG/80MCL INJ 3ML BT 1",
  atcCode: "H05AA02"
}, {
  CIP7: '3359055',
  CIP13: '3400933590550',
  ucdLib: "GLUCAGEN 1MG INJ FL+FL",
  UCD7: '9189631',
  UCD13: '3400891896312',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCAGEN 1MG INJ FL+FL BT 1",
  atcCode: "H04AA01"
}, {
  CIP7: '3359049',
  CIP13: '3400933590499',
  ucdLib: "GLUCAGEN KIT 1MG INJ FL+SRG",
  UCD7: '9189743',
  UCD13: '3400891897432',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCAGEN KIT 1MG INJ FL+SRG BT 1",
  atcCode: "H04AA01"
}, {
  CIP7: '3911191',
  CIP13: '3400939111919',
  ucdLib: "THYROZOL 10MG CPR",
  UCD7: '9339059',
  UCD13: '3400893390597',
  ucdQtyMultiplicator: 30,
  cipLib: "THYROZOL 10MG CPR BT 30",
  atcCode: "H03BB02"
}, {
  CIP7: '3911245',
  CIP13: '3400939112459',
  ucdLib: "THYROZOL 20MG CPR",
  UCD7: '9339065',
  UCD13: '3400893390658',
  ucdQtyMultiplicator: 30,
  cipLib: "THYROZOL 20MG CPR BT 30",
  atcCode: "H03BB02"
}, {
  CIP7: '3911156',
  CIP13: '3400939111568',
  ucdLib: "THYROZOL 5MG CPR",
  UCD7: '9339071',
  UCD13: '3400893390719',
  ucdQtyMultiplicator: 30,
  cipLib: "THYROZOL 5MG CPR BT 30",
  atcCode: "H03BB02"
}, {
  CIP7: '3616227',
  CIP13: '3400936162273',
  ucdLib: "NEO-MERCAZOLE 20MG CPR",
  UCD7: '9146691',
  UCD13: '3400891466911',
  ucdQtyMultiplicator: 30,
  cipLib: "NEO-MERCAZOLE 20MG CPR BT 30",
  atcCode: "H03BB01"
}, {
  CIP7: '3611106',
  CIP13: '3400936111066',
  ucdLib: "NEO-MERCAZOLE 5MG CPR",
  UCD7: '9061546',
  UCD13: '3400890615464',
  ucdQtyMultiplicator: 50,
  cipLib: "NEO-MERCAZOLE 5MG CPR BT 50",
  atcCode: "H03BB01"
}, {
  CIP7: '3009964',
  CIP13: '3400930099643',
  ucdLib: "BASDENE 25MG CPR",
  UCD7: '9009540',
  UCD13: '3400890095402',
  ucdQtyMultiplicator: 50,
  cipLib: "BASDENE 25MG CPR BT 50",
  atcCode: "H03BA03"
}, {
  CIP7: '3813011',
  CIP13: '3400938130119',
  ucdLib: "PROPYLEX 50MG CPR",
  UCD7: '9308886',
  UCD13: '3400893088869',
  ucdQtyMultiplicator: 30,
  cipLib: "PROPYLEX 50MG CPR BT 30",
  atcCode: "H03BA02"
}, {
  CIP7: '3813028',
  CIP13: '3400938130287',
  ucdLib: "PROPYLEX 50MG CPR",
  UCD7: '9308886',
  UCD13: '3400893088869',
  ucdQtyMultiplicator: 90,
  cipLib: "PROPYLEX 50MG CPR BT 90",
  atcCode: "H03BA02"
}, {
  CIP7: '3173735',
  CIP13: '3400931737353',
  ucdLib: "TEATROIS 0,35MG 0,35MG CPR",
  UCD7: '9090619',
  UCD13: '3400890906197',
  ucdQtyMultiplicator: 100,
  cipLib: "TEATROIS 0,35MG 0,35MG CPR BT 100",
  atcCode: "H03AA04"
}, {
  CIP7: '3748377',
  CIP13: '3400937483773',
  ucdLib: "EUTHYRAL CPR",
  UCD7: '9033969',
  UCD13: '3400890339698',
  ucdQtyMultiplicator: 50,
  cipLib: "EUTHYRAL CPR BT 50",
  atcCode: "H03AA03"
}, {
  CIP7: '3027755',
  CIP13: '3400930277553',
  ucdLib: "CYNOMEL 0,025MG CPR",
  UCD7: '9023600',
  UCD13: '3400890236003',
  ucdQtyMultiplicator: 30,
  cipLib: "CYNOMEL 0,025MG CPR BT 30",
  atcCode: "H03AA02"
}, {
  CIP7: '3319216',
  CIP13: '3400933192167',
  ucdLib: "LEVOTHYROX 150MCG CPR",
  UCD7: '9140412',
  UCD13: '3400891404128',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROX 150MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3319185',
  CIP13: '3400933191856',
  ucdLib: "LEVOTHYROX 25MCG CPR",
  UCD7: '9136801',
  UCD13: '3400891368017',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROX 25MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3319191',
  CIP13: '3400933191917',
  ucdLib: "LEVOTHYROX 75MCG CPR",
  UCD7: '9136818',
  UCD13: '3400891368185',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROX 75MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3304284',
  CIP13: '3400933042844',
  ucdLib: "LEVOTHYROX 25MCG CPR",
  UCD7: '9136801',
  UCD13: '3400891368017',
  ucdQtyMultiplicator: 50,
  cipLib: "LEVOTHYROX 25MCG CPR BT 50",
  atcCode: "H03AA01"
}, {
  CIP7: '3462787',
  CIP13: '3400934627873',
  ucdLib: "LEVOTHYROX 25MCG CPR",
  UCD7: '9136801',
  UCD13: '3400891368017',
  ucdQtyMultiplicator: 90,
  cipLib: "LEVOTHYROX 25MCG CPR BT 90",
  atcCode: "H03AA01"
}, {
  CIP7: '3462793',
  CIP13: '3400934627934',
  ucdLib: "LEVOTHYROX 50MCG CPR",
  UCD7: '9053860',
  UCD13: '3400890538602',
  ucdQtyMultiplicator: 90,
  cipLib: "LEVOTHYROX 50MCG CPR BT 90",
  atcCode: "H03AA01"
}, {
  CIP7: '3811265',
  CIP13: '3400938112658',
  ucdLib: "L-THYROXINE SERB BUV GTT 15ML",
  UCD7: '9303653',
  UCD13: '3400893036532',
  ucdQtyMultiplicator: 1,
  cipLib: "L-THYROXINE SERB BUV GTT 15ML BT 1",
  atcCode: "H03AA01"
}, {
  CIP7: '3478340',
  CIP13: '3400934783401',
  ucdLib: "LEVOTHYROX 100MCG CPR",
  UCD7: '9053854',
  UCD13: '3400890538541',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROX 100MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3490861',
  CIP13: '3400934908613',
  ucdLib: "LEVOTHYROX 125MCG CPR",
  UCD7: '9217847',
  UCD13: '3400892178479',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROX 125MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3490878',
  CIP13: '3400934908781',
  ucdLib: "LEVOTHYROX 125MCG CPR",
  UCD7: '9217847',
  UCD13: '3400892178479',
  ucdQtyMultiplicator: 50,
  cipLib: "LEVOTHYROX 125MCG CPR BT 50",
  atcCode: "H03AA01"
}, {
  CIP7: '3490909',
  CIP13: '3400934909092',
  ucdLib: "LEVOTHYROX 175MCG CPR",
  UCD7: '9217907',
  UCD13: '3400892179070',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROX 175MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3490944',
  CIP13: '3400934909443',
  ucdLib: "LEVOTHYROX 200MCG CPR",
  UCD7: '9217913',
  UCD13: '3400892179131',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROX 200MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3478357',
  CIP13: '3400934783579',
  ucdLib: "LEVOTHYROX 50MCG CPR",
  UCD7: '9053860',
  UCD13: '3400890538602',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROX 50MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3804756',
  CIP13: '3400938047561',
  ucdLib: "L-THYROXINE SERB INJ AMP1ML",
  UCD7: '9301269',
  UCD13: '3400893012697',
  ucdQtyMultiplicator: 6,
  cipLib: "L-THYROXINE SERB INJ AMP1ML BT 6",
  atcCode: "H03AA01"
}, {
  CIP7: '3933755',
  CIP13: '3400939337555',
  ucdLib: "LEVOTHYROXINE BGA 100MCG CPR",
  UCD7: '9338634',
  UCD13: '3400893386347',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROXINE BGA 100MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3933778',
  CIP13: '3400939337784',
  ucdLib: "LEVOTHYROXINE BGA 125MCG CPR",
  UCD7: '9338640',
  UCD13: '3400893386408',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROXINE BGA 125MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3933790',
  CIP13: '3400939337906',
  ucdLib: "LEVOTHYROXINE BGA 150MCG CPR",
  UCD7: '9338657',
  UCD13: '3400893386576',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROXINE BGA 150MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3933815',
  CIP13: '3400939338156',
  ucdLib: "LEVOTHYROXINE BGA 175MCG CPR",
  UCD7: '9338663',
  UCD13: '3400893386637',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROXINE BGA 175MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3933838',
  CIP13: '3400939338385',
  ucdLib: "LEVOTHYROXINE BGA 200MCG CPR",
  UCD7: '9338686',
  UCD13: '3400893386866',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROXINE BGA 200MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3933399',
  CIP13: '3400939333991',
  ucdLib: "LEVOTHYROXINE BGA 25MCG CPR",
  UCD7: '9338692',
  UCD13: '3400893386927',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROXINE BGA 25MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3933436',
  CIP13: '3400939334363',
  ucdLib: "LEVOTHYROXINE BGA 25MCG CPR",
  UCD7: '9338692',
  UCD13: '3400893386927',
  ucdQtyMultiplicator: 90,
  cipLib: "LEVOTHYROXINE BGA 25MCG CPR BT 90",
  atcCode: "H03AA01"
}, {
  CIP7: '3933548',
  CIP13: '3400939335483',
  ucdLib: "LEVOTHYROXINE BGA 50MCG CPR",
  UCD7: '9338700',
  UCD13: '3400893387009',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROXINE BGA 50MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3933577',
  CIP13: '3400939335773',
  ucdLib: "LEVOTHYROXINE BGA 50MCG CPR",
  UCD7: '9338700',
  UCD13: '3400893387009',
  ucdQtyMultiplicator: 90,
  cipLib: "LEVOTHYROXINE BGA 50MCG CPR BT 90",
  atcCode: "H03AA01"
}, {
  CIP7: '3933703',
  CIP13: '3400939337036',
  ucdLib: "LEVOTHYROXINE BGA 75MCG CPR",
  UCD7: '9338717',
  UCD13: '3400893387177',
  ucdQtyMultiplicator: 30,
  cipLib: "LEVOTHYROXINE BGA 75MCG CPR BT 30",
  atcCode: "H03AA01"
}, {
  CIP7: '3135798',
  CIP13: '3400931357988',
  ucdLib: "ALTIM 3,75MG INJ SRG1,5ML",
  UCD7: '9003595',
  UCD13: '3400890035958',
  ucdQtyMultiplicator: 1,
  cipLib: "ALTIM 3,75MG INJ SRG1,5ML BT 1",
  atcCode: "H02AB17"
}, {
  CIP7: '3051417',
  CIP13: '3400930514177',
  ucdLib: "HYDROCORTISONE RSL 10MG CPR",
  UCD7: '9045205',
  UCD13: '3400890452052',
  ucdQtyMultiplicator: 25,
  cipLib: "HYDROCORTISONE RSL 10MG CPR BT 25",
  atcCode: "H02AB09"
}, {
  CIP7: '3357234',
  CIP13: '3400933572341',
  ucdLib: "HYDROCORTISONE BDX 100MG F+A.",
  UCD7: '9229448',
  UCD13: '3400892294483',
  ucdQtyMultiplicator: 1,
  cipLib: "HYDROCORTISONE BDX 100MG F+A. BT 1",
  atcCode: "H02AB09"
}, {
  CIP7: '3214115',
  CIP13: '3400932141159',
  ucdLib: "HYDROCORTISONE UPJ 100MG F+A",
  UCD7: '9045263',
  UCD13: '3400890452632',
  ucdQtyMultiplicator: 1,
  cipLib: "HYDROCORTISONE UPJ 100MG F+A BT 1",
  atcCode: "H02AB09"
}, {
  CIP7: '3214109',
  CIP13: '3400932141098',
  ucdLib: "HYDROCORTISONE UPJ 500MG F+A",
  UCD7: '9045286',
  UCD13: '3400890452861',
  ucdQtyMultiplicator: 10,
  cipLib: "HYDROCORTISONE UPJ 500MG F+A BT 10",
  atcCode: "H02AB09"
}, {
  CIP7: '5753046',
  CIP13: '3400957530464',
  ucdLib: "HYDROCORTISONE RSL 10MG CPR",
  UCD7: '9045205',
  UCD13: '3400890452052',
  ucdQtyMultiplicator: 50,
  cipLib: "HYDROCORTISONE RSL 10MG CPR BT 50",
  atcCode: "H02AB09"
}, {
  CIP7: '3055875',
  CIP13: '3400930558751',
  ucdLib: "KENACORT RET.40MG SER.+AMP1ML",
  UCD7: '9048824',
  UCD13: '3400890488242',
  ucdQtyMultiplicator: 1,
  cipLib: "KENACORT RET.40MG SER.+AMP1ML BT 1",
  atcCode: "H02AB08"
}, {
  CIP7: '3184130',
  CIP13: '3400931841302',
  ucdLib: "HEXATRIONE 2% INJ AMP2ML",
  UCD7: '9043502',
  UCD13: '3400890435024',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXATRIONE 2% INJ AMP2ML BT 1",
  atcCode: "H02AB08"
}, {
  CIP7: '3158457',
  CIP13: '3400931584575',
  ucdLib: "KENACORT RET.80MG SER+AMP2ML",
  UCD7: '9048830',
  UCD13: '3400890488303',
  ucdQtyMultiplicator: 1,
  cipLib: "KENACORT RET.80MG SER+AMP2ML BT 1",
  atcCode: "H02AB08"
}, {
  CIP7: '3328385',
  CIP13: '3400933283858',
  ucdLib: "CORTANCYL 20MG CPR",
  UCD7: '9144284',
  UCD13: '3400891442847',
  ucdQtyMultiplicator: 20,
  cipLib: "CORTANCYL 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3005035',
  CIP13: '3400930050354',
  ucdLib: "PREDNISONE BGA 5MG CPR",
  UCD7: '9266254',
  UCD13: '3400892662541',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE BGA 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3025897',
  CIP13: '3400930258972',
  ucdLib: "CORTANCYL 1MG CPR",
  UCD7: '9022316',
  UCD13: '3400890223164',
  ucdQtyMultiplicator: 30,
  cipLib: "CORTANCYL 1MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3025905',
  CIP13: '3400930259054',
  ucdLib: "CORTANCYL 5MG CPR",
  UCD7: '9022322',
  UCD13: '3400890223225',
  ucdQtyMultiplicator: 30,
  cipLib: "CORTANCYL 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3675773',
  CIP13: '3400936757738',
  ucdLib: "PREDNISONE SDZ 5MG CPR",
  UCD7: '9271663',
  UCD13: '3400892716633',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE SDZ 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3855860',
  CIP13: '3400938558609',
  ucdLib: "PREDNISONE CRT 1MG CPR",
  UCD7: '9320522',
  UCD13: '3400893205228',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE CRT 1MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3855883',
  CIP13: '3400938558838',
  ucdLib: "PREDNISONE MYL 1MG CPR",
  UCD7: '9317000',
  UCD13: '3400893170007',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE MYL 1MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3652341',
  CIP13: '3400936523418',
  ucdLib: "PREDNISONE ARW 20MG CPR",
  UCD7: '9265680',
  UCD13: '3400892656809',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISONE ARW 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3651991',
  CIP13: '3400936519916',
  ucdLib: "PREDNISONE ARW 5MG CPR",
  UCD7: '9265697',
  UCD13: '3400892656977',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE ARW 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3652252',
  CIP13: '3400936522527',
  ucdLib: "PREDNISONE BGA 20MG CPR",
  UCD7: '9266248',
  UCD13: '3400892662480',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISONE BGA 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3651927',
  CIP13: '3400936519275',
  ucdLib: "PREDNISONE BGA 5MG CPR",
  UCD7: '9266254',
  UCD13: '3400892662541',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE BGA 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3652111',
  CIP13: '3400936521117',
  ucdLib: "PREDNISONE CRT 20MG CPR",
  UCD7: '9265964',
  UCD13: '3400892659640',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISONE CRT 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3651838',
  CIP13: '3400936518384',
  ucdLib: "PREDNISONE CRT 5MG CPR",
  UCD7: '9265970',
  UCD13: '3400892659701',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE CRT 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3652080',
  CIP13: '3400936520806',
  ucdLib: "PREDNISONE EG 20MG CPR",
  UCD7: '9266260',
  UCD13: '3400892662602',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISONE EG 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3652140',
  CIP13: '3400936521407',
  ucdLib: "PREDNISONE MYL 20MG CPR",
  UCD7: '9265289',
  UCD13: '3400892652894',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISONE MYL 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3651850',
  CIP13: '3400936518506',
  ucdLib: "PREDNISONE MYL 5MG CPR",
  UCD7: '9265295',
  UCD13: '3400892652955',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE MYL 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3652370',
  CIP13: '3400936523708',
  ucdLib: "PREDNISONE SDZ 20MG CPR",
  UCD7: '9265705',
  UCD13: '3400892657059',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISONE SDZ 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3652312',
  CIP13: '3400936523128',
  ucdLib: "PREDNISONE TVC 20MG CPR",
  UCD7: '9265332',
  UCD13: '3400892653327',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISONE TVC 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3651979',
  CIP13: '3400936519794',
  ucdLib: "PREDNISONE TVC 5MG CPR",
  UCD7: '9265349',
  UCD13: '3400892653495',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE TVC 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3464125',
  CIP13: '3400934641251',
  ucdLib: "PREDNISONE ZEN 1MG CPR",
  UCD7: '9272467',
  UCD13: '3400892724676',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE ZEN 1MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3464102',
  CIP13: '3400934641022',
  ucdLib: "PREDNISONE ZEN 20MG CPR",
  UCD7: '9272473',
  UCD13: '3400892724737',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISONE ZEN 20MG CPR BT 20",
  atcCode: "H02AB07"
}, {
  CIP7: '3464119',
  CIP13: '3400934641190',
  ucdLib: "PREDNISONE ZEN 5MG CPR",
  UCD7: '9272496',
  UCD13: '3400892724966',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE ZEN 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '3648730',
  CIP13: '3400936487307',
  ucdLib: "PREDNISONE EG 5MG CPR",
  UCD7: '9266277',
  UCD13: '3400892662770',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISONE EG 5MG CPR BT 30",
  atcCode: "H02AB07"
}, {
  CIP7: '5748996',
  CIP13: '3400957489960',
  ucdLib: "CORTANCYL 20MG CPR",
  UCD7: '9144284',
  UCD13: '3400891442847',
  ucdQtyMultiplicator: 100,
  cipLib: "CORTANCYL 20MG CPR BT 100",
  atcCode: "H02AB07"
}, {
  CIP7: '3051558',
  CIP13: '3400930515587',
  ucdLib: "HYDROCORTANCYL 2,5% INJ FL5ML",
  UCD7: '9045091',
  UCD13: '3400890450911',
  ucdQtyMultiplicator: 1,
  cipLib: "HYDROCORTANCYL 2,5% INJ FL5ML BT 1",
  atcCode: "H02AB06"
}, {
  CIP7: '3613708',
  CIP13: '3400936137080',
  ucdLib: "PREDNISOLONE CRT 20MG C.EFFV",
  UCD7: '9259366',
  UCD13: '3400892593661',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE CRT 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3611738',
  CIP13: '3400936117389',
  ucdLib: "PREDNISOLONE TVC 20MG C.EFFV",
  UCD7: '9245329',
  UCD13: '3400892453293',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE TVC 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3619645',
  CIP13: '3400936196452',
  ucdLib: "PREDNISOLONE ZEN 20MG C.DISP",
  UCD7: '9315952',
  UCD13: '3400893159521',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE ZEN 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3282039',
  CIP13: '3400932820399',
  ucdLib: "SOLUPRED 1MG/ML BUV FL50ML",
  UCD7: '9122087',
  UCD13: '3400891220872',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLUPRED 1MG/ML BUV FL50ML BT 1",
  atcCode: "H02AB06"
}, {
  CIP7: '3574055',
  CIP13: '3400935740557',
  ucdLib: "PREDNISOLONE BGA 20MG C.EFFV",
  UCD7: '9243796',
  UCD13: '3400892437965',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE BGA 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3574032',
  CIP13: '3400935740328',
  ucdLib: "PREDNISOLONE EG 20MG C.EFFV",
  UCD7: '9234633',
  UCD13: '3400892346335',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE EG 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3608788',
  CIP13: '3400936087880',
  ucdLib: "PREDNISOLONE ARW 20MG C.EFFV",
  UCD7: '9246180',
  UCD13: '3400892461809',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE ARW 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3608742',
  CIP13: '3400936087422',
  ucdLib: "PREDNISOLONE MYL 20MG C.EFFV",
  UCD7: '9246777',
  UCD13: '3400892467771',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE MYL 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3608765',
  CIP13: '3400936087651',
  ucdLib: "PREDNISOLONE RTP 20MG C.EFFV",
  UCD7: '9244666',
  UCD13: '3400892446660',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE RTP 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3680679',
  CIP13: '3400936806795',
  ucdLib: "PREDNISOLONE SDZ 20MG C.EFFV",
  UCD7: '9269005',
  UCD13: '3400892690056',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE SDZ 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3097520',
  CIP13: '3400930975206',
  ucdLib: "SOLUPRED 5MG CPR EFFV",
  UCD7: '9085943',
  UCD13: '3400890859431',
  ucdQtyMultiplicator: 30,
  cipLib: "SOLUPRED 5MG CPR EFFV BT 30",
  atcCode: "H02AB06"
}, {
  CIP7: '3674791',
  CIP13: '3400936747913',
  ucdLib: "PREDNISOLONE ZEN 20MG C.EFFV",
  UCD7: '9270184',
  UCD13: '3400892701844',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE ZEN 20MG C.EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3201466',
  CIP13: '3400932014668',
  ucdLib: "SOLUPRED 20MG CPR EFFV",
  UCD7: '9085937',
  UCD13: '3400890859370',
  ucdQtyMultiplicator: 20,
  cipLib: "SOLUPRED 20MG CPR EFFV BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3648173',
  CIP13: '3400936481732',
  ucdLib: "PREDNISOLONE TVC 5MG C.EFFV",
  UCD7: '9263586',
  UCD13: '3400892635866',
  ucdQtyMultiplicator: 30,
  cipLib: "PREDNISOLONE TVC 5MG C.EFFV BT 30",
  atcCode: "H02AB06"
}, {
  CIP7: '3493687',
  CIP13: '3400934936876',
  ucdLib: "SOLUPRED 20MG CPR ORODISP",
  UCD7: '9220364',
  UCD13: '3400892203645',
  ucdQtyMultiplicator: 20,
  cipLib: "SOLUPRED 20MG CPR ORODISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3493670',
  CIP13: '3400934936708',
  ucdLib: "SOLUPRED 5MG CPR ORODISP",
  UCD7: '9220370',
  UCD13: '3400892203706',
  ucdQtyMultiplicator: 30,
  cipLib: "SOLUPRED 5MG CPR ORODISP BT 30",
  atcCode: "H02AB06"
}, {
  CIP7: '3910659',
  CIP13: '3400939106595',
  ucdLib: "PREDNISOLONE ARL 20MG C.DISP",
  UCD7: '9328914',
  UCD13: '3400893289143',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE ARL 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910688',
  CIP13: '3400939106885',
  ucdLib: "PREDNISOLONE ARW 20MG C.DISP",
  UCD7: '9326861',
  UCD13: '3400893268612',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE ARW 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910719',
  CIP13: '3400939107196',
  ucdLib: "PREDNISOLONE BGA 20MG C.DISP",
  UCD7: '9329658',
  UCD13: '3400893296585',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE BGA 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910748',
  CIP13: '3400939107486',
  ucdLib: "PREDNISOLONE CRT 20MG C.DISP",
  UCD7: '9328920',
  UCD13: '3400893289204',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE CRT 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910961',
  CIP13: '3400939109619',
  ucdLib: "PREDNISOLONE EG 20MG C.DISP",
  UCD7: '9326878',
  UCD13: '3400893268780',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE EG 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910346',
  CIP13: '3400939103464',
  ucdLib: "PREDNISOLONE MYL 20MG C.DISP",
  UCD7: '9328937',
  UCD13: '3400893289372',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE MYL 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910932',
  CIP13: '3400939109329',
  ucdLib: "PREDNISOLONE RBX 20MG C.DISP",
  UCD7: '9326884',
  UCD13: '3400893268841',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE RBX 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910866',
  CIP13: '3400939108667',
  ucdLib: "PREDNISOLONE RTP 20MG C.DISP",
  UCD7: '9326890',
  UCD13: '3400893268902',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE RTP 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910820',
  CIP13: '3400939108209',
  ucdLib: "PREDNISOLONE SDZ 20MG C.DISP",
  UCD7: '9328966',
  UCD13: '3400893289662',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE SDZ 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '3910895',
  CIP13: '3400939108957',
  ucdLib: "PREDNISOLONE TVC 20MG C.DISP",
  UCD7: '9329664',
  UCD13: '3400893296646',
  ucdQtyMultiplicator: 20,
  cipLib: "PREDNISOLONE TVC 20MG C.DISP BT 20",
  atcCode: "H02AB06"
}, {
  CIP7: '5749027',
  CIP13: '3400957490270',
  ucdLib: "SOLUPRED 20MG CPR ORODISP",
  UCD7: '9220364',
  UCD13: '3400892203645',
  ucdQtyMultiplicator: 50,
  cipLib: "SOLUPRED 20MG CPR ORODISP BT 50",
  atcCode: "H02AB06"
}, {
  CIP7: '5749010',
  CIP13: '3400957490102',
  ucdLib: "SOLUPRED 5MG CPR ORODISP",
  UCD7: '9220370',
  UCD13: '3400892203706',
  ucdQtyMultiplicator: 50,
  cipLib: "SOLUPRED 5MG CPR ORODISP BT 50",
  atcCode: "H02AB06"
}, {
  CIP7: '3065595',
  CIP13: '3400930655955',
  ucdLib: "MEDROL 4MG CPR",
  UCD7: '9057585',
  UCD13: '3400890575850',
  ucdQtyMultiplicator: 30,
  cipLib: "MEDROL 4MG CPR BT 30",
  atcCode: "H02AB04"
}, {
  CIP7: '5539465',
  CIP13: '3400955394655',
  ucdLib: "MEDROL 4MG CPR",
  UCD7: '9057585',
  UCD13: '3400890575850',
  ucdQtyMultiplicator: 100,
  cipLib: "MEDROL 4MG CPR BT 100",
  atcCode: "H02AB04"
}, {
  CIP7: '3318984',
  CIP13: '3400933189846',
  ucdLib: "MEDROL 16MG CPR",
  UCD7: '9141050',
  UCD13: '3400891410501',
  ucdQtyMultiplicator: 20,
  cipLib: "MEDROL 16MG CPR BT 20",
  atcCode: "H02AB04"
}, {
  CIP7: '5568202',
  CIP13: '3400955682028',
  ucdLib: "MEDROL 16MG CPR",
  UCD7: '9141050',
  UCD13: '3400891410501',
  ucdQtyMultiplicator: 100,
  cipLib: "MEDROL 16MG CPR BT 100",
  atcCode: "H02AB04"
}, {
  CIP7: '3097170',
  CIP13: '3400930971703',
  ucdLib: "SOLUMEDROL 20MG INJ FL+AMP",
  UCD7: '9085653',
  UCD13: '3400890856539',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLUMEDROL 20MG INJ FL+AMP BT 1",
  atcCode: "H02AB04"
}, {
  CIP7: '3097187',
  CIP13: '3400930971871',
  ucdLib: "SOLUMEDROL 40MG INJ FL+AMP",
  UCD7: '9085676',
  UCD13: '3400890856768',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLUMEDROL 40MG INJ FL+AMP BT 1",
  atcCode: "H02AB04"
}, {
  CIP7: '5586536',
  CIP13: '3400955865360',
  ucdLib: "SOLUMEDROL 120MG INJ FL",
  UCD7: '9172429',
  UCD13: '3400891724295',
  ucdQtyMultiplicator: 10,
  cipLib: "SOLUMEDROL 120MG INJ FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '5586482',
  CIP13: '3400955864820',
  ucdLib: "SOLUMEDROL 20MG INJ FL",
  UCD7: '9172435',
  UCD13: '3400891724356',
  ucdQtyMultiplicator: 10,
  cipLib: "SOLUMEDROL 20MG INJ FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '5586507',
  CIP13: '3400955865070',
  ucdLib: "SOLUMEDROL 40MG INJ FL",
  UCD7: '9172441',
  UCD13: '3400891724417',
  ucdQtyMultiplicator: 10,
  cipLib: "SOLUMEDROL 40MG INJ FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '3369786',
  CIP13: '3400933697860',
  ucdLib: "DEPO-MEDROL 40MG INJ FL1ML",
  UCD7: '9025094',
  UCD13: '3400890250948',
  ucdQtyMultiplicator: 1,
  cipLib: "DEPO-MEDROL 40MG INJ FL1ML BT 1",
  atcCode: "H02AB04"
}, {
  CIP7: '3554101',
  CIP13: '3400935541017',
  ucdLib: "METHYLPREDNIS. MYL 120MG FL",
  UCD7: '9226763',
  UCD13: '3400892267630',
  ucdQtyMultiplicator: 20,
  cipLib: "METHYLPREDNIS. MYL 120MG FL BT 20",
  atcCode: "H02AB04"
}, {
  CIP7: '3554064',
  CIP13: '3400935540645',
  ucdLib: "METHYLPREDNIS. MYL 1G FL",
  UCD7: '9223003',
  UCD13: '3400892230030',
  ucdQtyMultiplicator: 10,
  cipLib: "METHYLPREDNIS. MYL 1G FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '3554087',
  CIP13: '3400935540874',
  ucdLib: "METHYLPREDNIS. MYL 20MG FL",
  UCD7: '9226786',
  UCD13: '3400892267869',
  ucdQtyMultiplicator: 20,
  cipLib: "METHYLPREDNIS. MYL 20MG FL BT 20",
  atcCode: "H02AB04"
}, {
  CIP7: '3554093',
  CIP13: '3400935540935',
  ucdLib: "METHYLPREDNIS. MYL 40MG FL",
  UCD7: '9226792',
  UCD13: '3400892267920',
  ucdQtyMultiplicator: 20,
  cipLib: "METHYLPREDNIS. MYL 40MG FL BT 20",
  atcCode: "H02AB04"
}, {
  CIP7: '3554058',
  CIP13: '3400935540584',
  ucdLib: "METHYLPREDNIS. MYL 500MG FL",
  UCD7: '9223026',
  UCD13: '3400892230269',
  ucdQtyMultiplicator: 10,
  cipLib: "METHYLPREDNIS. MYL 500MG FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '3419136',
  CIP13: '3400934191367',
  ucdLib: "METHYLPREDNIS. MYL 120MG FL",
  UCD7: '9226763',
  UCD13: '3400892267630',
  ucdQtyMultiplicator: 10,
  cipLib: "METHYLPREDNIS. MYL 120MG FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '3417953',
  CIP13: '3400934179532',
  ucdLib: "METHYLPREDNIS. MYL 20MG FL",
  UCD7: '9226786',
  UCD13: '3400892267869',
  ucdQtyMultiplicator: 10,
  cipLib: "METHYLPREDNIS. MYL 20MG FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '3419099',
  CIP13: '3400934190995',
  ucdLib: "METHYLPREDNIS. MYL 40MG FL",
  UCD7: '9226792',
  UCD13: '3400892267920',
  ucdQtyMultiplicator: 10,
  cipLib: "METHYLPREDNIS. MYL 40MG FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '3155281',
  CIP13: '3400931552819',
  ucdLib: "SOLUMEDROL 120MG INJ FL+AMP",
  UCD7: '9085630',
  UCD13: '3400890856300',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLUMEDROL 120MG INJ FL+AMP BT 1",
  atcCode: "H02AB04"
}, {
  CIP7: '3723242',
  CIP13: '3400937232425',
  ucdLib: "MEDROL 100MG CPR",
  UCD7: '9196335',
  UCD13: '3400891963359',
  ucdQtyMultiplicator: 30,
  cipLib: "MEDROL 100MG CPR BT 30",
  atcCode: "H02AB04"
}, {
  CIP7: '3867722',
  CIP13: '3400938677225',
  ucdLib: "SOLUMEDROL 1G INJ FL+FL",
  UCD7: '9217741',
  UCD13: '3400892177410',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLUMEDROL 1G INJ FL+FL BT 1",
  atcCode: "H02AB04"
}, {
  CIP7: '3867774',
  CIP13: '3400938677744',
  ucdLib: "SOLUMEDROL 500MG INJ FL",
  UCD7: '9172458',
  UCD13: '3400891724585',
  ucdQtyMultiplicator: 10,
  cipLib: "SOLUMEDROL 500MG INJ FL BT 10",
  atcCode: "H02AB04"
}, {
  CIP7: '3004893',
  CIP13: '3400930048931',
  ucdLib: "NEOFORDEX 40MG CPR",
  UCD7: '9417894',
  UCD13: '3400894178941',
  ucdQtyMultiplicator: 10,
  cipLib: "NEOFORDEX 40MG CPR BT 10",
  atcCode: "H02AB02"
}, {
  CIP7: '3028536',
  CIP13: '3400930285367',
  ucdLib: "DECTANCYL 0,5MG CPR",
  UCD7: '9024309',
  UCD13: '3400890243094',
  ucdQtyMultiplicator: 30,
  cipLib: "DECTANCYL 0,5MG CPR BT 30",
  atcCode: "H02AB02"
}, {
  CIP7: '5630757',
  CIP13: '3400956307579',
  ucdLib: "DEXAMETHASONE MYL 20MG/5ML A.",
  UCD7: '9223078',
  UCD13: '3400892230788',
  ucdQtyMultiplicator: 10,
  cipLib: "DEXAMETHASONE MYL 20MG/5ML A. BT 10",
  atcCode: "H02AB02"
}, {
  CIP7: '5630763',
  CIP13: '3400956307630',
  ucdLib: "DEXAMETHASONE MYL 4MG/1ML A.",
  UCD7: '9223084',
  UCD13: '3400892230849',
  ucdQtyMultiplicator: 20,
  cipLib: "DEXAMETHASONE MYL 4MG/1ML A. BT 20",
  atcCode: "H02AB02"
}, {
  CIP7: '5536774',
  CIP13: '3400955367741',
  ucdLib: "CELESTENE C-DOS AMP1ML",
  UCD7: '9017350',
  UCD13: '3400890173506',
  ucdQtyMultiplicator: 25,
  cipLib: "CELESTENE C-DOS AMP1ML BT 25",
  atcCode: "H02AB01"
}, {
  CIP7: '3010973',
  CIP13: '3400930109731',
  ucdLib: "BETNESOL 0,5MG CPR",
  UCD7: '9010514',
  UCD13: '3400890105149',
  ucdQtyMultiplicator: 30,
  cipLib: "BETNESOL 0,5MG CPR BT 30",
  atcCode: "H02AB01"
}, {
  CIP7: '3010967',
  CIP13: '3400930109670',
  ucdLib: "BETNESOL 4MG INJ AMP1ML",
  UCD7: '9010508',
  UCD13: '3400890105088',
  ucdQtyMultiplicator: 3,
  cipLib: "BETNESOL 4MG INJ AMP1ML BT 3",
  atcCode: "H02AB01"
}, {
  CIP7: '3019508',
  CIP13: '3400930195086',
  ucdLib: "CELESTENE 0,05% GTT FL30ML",
  UCD7: '9017344',
  UCD13: '3400890173445',
  ucdQtyMultiplicator: 1,
  cipLib: "CELESTENE 0,05% GTT FL30ML BT 1",
  atcCode: "H02AB01"
}, {
  CIP7: '3019460',
  CIP13: '3400930194607',
  ucdLib: "CELESTENE 4MG INJ AMP1ML",
  UCD7: '9017321',
  UCD13: '3400890173216',
  ucdQtyMultiplicator: 3,
  cipLib: "CELESTENE 4MG INJ AMP1ML BT 3",
  atcCode: "H02AB01"
}, {
  CIP7: '3205777',
  CIP13: '3400932057771',
  ucdLib: "CELESTENE C-DOS SERING + AMP",
  UCD7: '9017367',
  UCD13: '3400890173674',
  ucdQtyMultiplicator: 1,
  cipLib: "CELESTENE C-DOS SERING + AMP BT 1",
  atcCode: "H02AB01"
}, {
  CIP7: '3200509',
  CIP13: '3400932005093',
  ucdLib: "DIPROSTENE INJ SERING1ML",
  UCD7: '9027785',
  UCD13: '3400890277853',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPROSTENE INJ SERING1ML BT 1",
  atcCode: "H02AB01"
}, {
  CIP7: '3412447',
  CIP13: '3400934124471',
  ucdLib: "CELESTENE 2MG CPR DISP",
  UCD7: '9191409',
  UCD13: '3400891914092',
  ucdQtyMultiplicator: 20,
  cipLib: "CELESTENE 2MG CPR DISP BT 20",
  atcCode: "H02AB01"
}, {
  CIP7: '3887788',
  CIP13: '3400938877885',
  ucdLib: "BETAMETHASONE ARW 2MG C.DISP",
  UCD7: '9322515',
  UCD13: '3400893225158',
  ucdQtyMultiplicator: 20,
  cipLib: "BETAMETHASONE ARW 2MG C.DISP BT 20",
  atcCode: "H02AB01"
}, {
  CIP7: '3887541',
  CIP13: '3400938875416',
  ucdLib: "BETAMETHASONE BGA 2MG C.DISP",
  UCD7: '9324359',
  UCD13: '3400893243596',
  ucdQtyMultiplicator: 20,
  cipLib: "BETAMETHASONE BGA 2MG C.DISP BT 20",
  atcCode: "H02AB01"
}, {
  CIP7: '3887819',
  CIP13: '3400938878196',
  ucdLib: "BETAMETHASONE EG 2MG C.DISP",
  UCD7: '9323561',
  UCD13: '3400893235614',
  ucdQtyMultiplicator: 20,
  cipLib: "BETAMETHASONE EG 2MG C.DISP BT 20",
  atcCode: "H02AB01"
}, {
  CIP7: '3887759',
  CIP13: '3400938877595',
  ucdLib: "BETAMETHASONE ZEN 2MG C.DISP",
  UCD7: '9324081',
  UCD13: '3400893240816',
  ucdQtyMultiplicator: 20,
  cipLib: "BETAMETHASONE ZEN 2MG C.DISP BT 20",
  atcCode: "H02AB01"
}, {
  CIP7: '3894707',
  CIP13: '3400938947076',
  ucdLib: "BETAMETHASONE ARW0,05% BUV30ML",
  UCD7: '9323555',
  UCD13: '3400893235553',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAMETHASONE ARW0,05% BUV30ML BT 1",
  atcCode: "H02AB01"
}, {
  CIP7: '3894699',
  CIP13: '3400938946994',
  ucdLib: "BETAMETHASONE BGA0,05% BUV30ML",
  UCD7: '9324342',
  UCD13: '3400893243428',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAMETHASONE BGA0,05% BUV30ML BT 1",
  atcCode: "H02AB01"
}, {
  CIP7: '3894713',
  CIP13: '3400938947137',
  ucdLib: "BETAMETHASONE EG 0,05% BUV30ML",
  UCD7: '9323880',
  UCD13: '3400893238806',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAMETHASONE EG 0,05% BUV30ML BT 1",
  atcCode: "H02AB01"
}, {
  CIP7: '3894736',
  CIP13: '3400938947366',
  ucdLib: "BETAMETHASONE ZEN0,05% BUV30ML",
  UCD7: '9324075',
  UCD13: '3400893240755',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAMETHASONE ZEN0,05% BUV30ML BT 1",
  atcCode: "H02AB01"
}, {
  CIP7: '3906014',
  CIP13: '3400939060149',
  ucdLib: "ADIXON 50MCG CPR",
  UCD7: '9393679',
  UCD13: '3400893936795',
  ucdQtyMultiplicator: 60,
  cipLib: "ADIXON 50MCG CPR BT 60",
  atcCode: "H02AA02"
}, {
  CIP7: '3906066',
  CIP13: '3400939060668',
  ucdLib: "FLUCORTAC 50MCG CPR",
  UCD7: '9326074',
  UCD13: '3400893260746',
  ucdQtyMultiplicator: 60,
  cipLib: "FLUCORTAC 50MCG CPR BT 60",
  atcCode: "H02AA02"
}, {
  CIP7: '3517790',
  CIP13: '3400935177902',
  ucdLib: "CETROTIDE 0,25MG INJ FL+SRG",
  UCD7: '9218812',
  UCD13: '3400892188126',
  ucdQtyMultiplicator: 1,
  cipLib: "CETROTIDE 0,25MG INJ FL+SRG BT 1",
  atcCode: "H01CC02"
}, {
  CIP7: '3553018',
  CIP13: '3400935530189',
  ucdLib: "ORGALUTRAN 0,25MG INJ SRG",
  UCD7: '9233591',
  UCD13: '3400892335919',
  ucdQtyMultiplicator: 1,
  cipLib: "ORGALUTRAN 0,25MG INJ SRG BT 1",
  atcCode: "H01CC01"
}, {
  CIP7: '3553024',
  CIP13: '3400935530240',
  ucdLib: "ORGALUTRAN 0,25MG INJ SRG",
  UCD7: '9233591',
  UCD13: '3400892335919',
  ucdQtyMultiplicator: 5,
  cipLib: "ORGALUTRAN 0,25MG INJ SRG BT 5",
  atcCode: "H01CC01"
}, {
  CIP7: '3000141',
  CIP13: '3400930001417',
  ucdLib: "SIGNIFOR 20MG INJ FL+SRG",
  UCD7: '9405135',
  UCD13: '3400894051350',
  ucdQtyMultiplicator: 1,
  cipLib: "SIGNIFOR 20MG INJ FL+SRG BT 1",
  atcCode: "H01CB05"
}, {
  CIP7: '3000142',
  CIP13: '3400930001424',
  ucdLib: "SIGNIFOR 40MG INJ FL+SRG",
  UCD7: '9405141',
  UCD13: '3400894051411',
  ucdQtyMultiplicator: 1,
  cipLib: "SIGNIFOR 40MG INJ FL+SRG BT 1",
  atcCode: "H01CB05"
}, {
  CIP7: '3000143',
  CIP13: '3400930001431',
  ucdLib: "SIGNIFOR 60MG INJ FL+SRG",
  UCD7: '9405158',
  UCD13: '3400894051589',
  ucdQtyMultiplicator: 1,
  cipLib: "SIGNIFOR 60MG INJ FL+SRG BT 1",
  atcCode: "H01CB05"
}, {
  CIP7: '2223514',
  CIP13: '3400922235141',
  ucdLib: "SIGNIFOR 0,3MG INJ AMP1ML",
  UCD7: '9385740',
  UCD13: '3400893857403',
  ucdQtyMultiplicator: 60,
  cipLib: "SIGNIFOR 0,3MG INJ AMP1ML BT 60",
  atcCode: "H01CB05"
}, {
  CIP7: '2223520',
  CIP13: '3400922235202',
  ucdLib: "SIGNIFOR 0,6MG INJ AMP1ML",
  UCD7: '9385757',
  UCD13: '3400893857571',
  ucdQtyMultiplicator: 6,
  cipLib: "SIGNIFOR 0,6MG INJ AMP1ML BT 6",
  atcCode: "H01CB05"
}, {
  CIP7: '2223566',
  CIP13: '3400922235660',
  ucdLib: "SIGNIFOR 0,6MG INJ AMP1ML",
  UCD7: '9385757',
  UCD13: '3400893857571',
  ucdQtyMultiplicator: 60,
  cipLib: "SIGNIFOR 0,6MG INJ AMP1ML BT 60",
  atcCode: "H01CB05"
}, {
  CIP7: '2223603',
  CIP13: '3400922236032',
  ucdLib: "SIGNIFOR 0,9MG INJ AMP1ML",
  UCD7: '9385763',
  UCD13: '3400893857632',
  ucdQtyMultiplicator: 60,
  cipLib: "SIGNIFOR 0,9MG INJ AMP1ML BT 60",
  atcCode: "H01CB05"
}, {
  CIP7: '3572895',
  CIP13: '3400935728951',
  ucdLib: "SOMATULINE LP 120MG INJ SRG",
  UCD7: '9235354',
  UCD13: '3400892353548',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMATULINE LP 120MG INJ SRG BT 1",
  atcCode: "H01CB03"
}, {
  CIP7: '3572872',
  CIP13: '3400935728722',
  ucdLib: "SOMATULINE LP 60MG INJ SRG",
  UCD7: '9235360',
  UCD13: '3400892353609',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMATULINE LP 60MG INJ SRG BT 1",
  atcCode: "H01CB03"
}, {
  CIP7: '3572889',
  CIP13: '3400935728890',
  ucdLib: "SOMATULINE LP 90MG INJ SRG",
  UCD7: '9235377',
  UCD13: '3400892353777',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMATULINE LP 90MG INJ SRG BT 1",
  atcCode: "H01CB03"
}, {
  CIP7: '3373523',
  CIP13: '3400933735234',
  ucdLib: "SOMATULINE LP 30MG INJ FL+A.",
  UCD7: '9171312',
  UCD13: '3400891713121',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMATULINE LP 30MG INJ FL+A. BT 1",
  atcCode: "H01CB03"
}, {
  CIP7: '3651063',
  CIP13: '3400936510630',
  ucdLib: "SANDOSTATINE LP 10MG FL+SRG",
  UCD7: '9278381',
  UCD13: '3400892783819',
  ucdQtyMultiplicator: 1,
  cipLib: "SANDOSTATINE LP 10MG FL+SRG BT 1",
  atcCode: "H01CB02"
}, {
  CIP7: '3651086',
  CIP13: '3400936510869',
  ucdLib: "SANDOSTATINE LP 20MG FL+SRG",
  UCD7: '9278398',
  UCD13: '3400892783987',
  ucdQtyMultiplicator: 1,
  cipLib: "SANDOSTATINE LP 20MG FL+SRG BT 1",
  atcCode: "H01CB02"
}, {
  CIP7: '3651092',
  CIP13: '3400936510920',
  ucdLib: "SANDOSTATINE LP 30MG FL+SRG",
  UCD7: '9278406',
  UCD13: '3400892784069',
  ucdQtyMultiplicator: 1,
  cipLib: "SANDOSTATINE LP 30MG FL+SRG BT 1",
  atcCode: "H01CB02"
}, {
  CIP7: '3953545',
  CIP13: '3400939535456',
  ucdLib: "SIROCTID 0,05MG/ML INJ SRG",
  UCD7: '9364991',
  UCD13: '3400893649916',
  ucdQtyMultiplicator: 6,
  cipLib: "SIROCTID 0,05MG/ML INJ SRG BT 6",
  atcCode: "H01CB02"
}, {
  CIP7: '3953858',
  CIP13: '3400939538587',
  ucdLib: "SIROCTID 0,1MG/ML INJ SRG",
  UCD7: '9365016',
  UCD13: '3400893650165',
  ucdQtyMultiplicator: 6,
  cipLib: "SIROCTID 0,1MG/ML INJ SRG BT 6",
  atcCode: "H01CB02"
}, {
  CIP7: '3954237',
  CIP13: '3400939542379',
  ucdLib: "SIROCTID 0,5MG/ML INJ SRG",
  UCD7: '9365022',
  UCD13: '3400893650226',
  ucdQtyMultiplicator: 6,
  cipLib: "SIROCTID 0,5MG/ML INJ SRG BT 6",
  atcCode: "H01CB02"
}, {
  CIP7: '3944813',
  CIP13: '3400939448138',
  ucdLib: "OCTREOTIDE HPI 100Y/1ML INJ",
  UCD7: '9332525',
  UCD13: '3400893325254',
  ucdQtyMultiplicator: 5,
  cipLib: "OCTREOTIDE HPI 100Y/1ML INJ BT 5",
  atcCode: "H01CB02"
}, {
  CIP7: '3944902',
  CIP13: '3400939449029',
  ucdLib: "OCTREOTIDE HPI 500Y/1ML INJ",
  UCD7: '9332548',
  UCD13: '3400893325483',
  ucdQtyMultiplicator: 5,
  cipLib: "OCTREOTIDE HPI 500Y/1ML INJ BT 5",
  atcCode: "H01CB02"
}, {
  CIP7: '3944865',
  CIP13: '3400939448657',
  ucdLib: "OCTREOTIDE HPI 50Y/1ML INJ",
  UCD7: '9332531',
  UCD13: '3400893325315',
  ucdQtyMultiplicator: 5,
  cipLib: "OCTREOTIDE HPI 50Y/1ML INJ BT 5",
  atcCode: "H01CB02"
}, {
  CIP7: '2175063',
  CIP13: '3400921750638',
  ucdLib: "OCTREOTIDE ARW 100Y/1ML INJ",
  UCD7: '9380493',
  UCD13: '3400893804933',
  ucdQtyMultiplicator: 10,
  cipLib: "OCTREOTIDE ARW 100Y/1ML INJ BT 10",
  atcCode: "H01CB02"
}, {
  CIP7: '2175011',
  CIP13: '3400921750119',
  ucdLib: "OCTREOTIDE ARW 500Y/1ML INJ",
  UCD7: '9380487',
  UCD13: '3400893804872',
  ucdQtyMultiplicator: 10,
  cipLib: "OCTREOTIDE ARW 500Y/1ML INJ BT 10",
  atcCode: "H01CB02"
}, {
  CIP7: '2175146',
  CIP13: '3400921751468',
  ucdLib: "OCTREOTIDE ARW 50Y/1ML INJ",
  UCD7: '9380501',
  UCD13: '3400893805015',
  ucdQtyMultiplicator: 10,
  cipLib: "OCTREOTIDE ARW 50Y/1ML INJ BT 10",
  atcCode: "H01CB02"
}, {
  CIP7: '5821138',
  CIP13: '3400958211386',
  ucdLib: "OCTREOTIDE ARW 200Y/ML INJ",
  UCD7: '9384249',
  UCD13: '3400893842492',
  ucdQtyMultiplicator: 10,
  cipLib: "OCTREOTIDE ARW 200Y/ML INJ BT 10",
  atcCode: "H01CB02"
}, {
  CIP7: '2795736',
  CIP13: '3400927957369',
  ucdLib: "OCTREOTIDE KBI 100Y/1ML INJ",
  UCD7: '9397022',
  UCD13: '3400893970225',
  ucdQtyMultiplicator: 5,
  cipLib: "OCTREOTIDE KBI 100Y/1ML INJ BT 5",
  atcCode: "H01CB02"
}, {
  CIP7: '2795765',
  CIP13: '3400927957659',
  ucdLib: "OCTREOTIDE KBI 500Y/1ML INJ",
  UCD7: '9397039',
  UCD13: '3400893970393',
  ucdQtyMultiplicator: 5,
  cipLib: "OCTREOTIDE KBI 500Y/1ML INJ BT 5",
  atcCode: "H01CB02"
}, {
  CIP7: '2795699',
  CIP13: '3400927956997',
  ucdLib: "OCTREOTIDE KBI 50Y/1ML INJ",
  UCD7: '9397045',
  UCD13: '3400893970454',
  ucdQtyMultiplicator: 5,
  cipLib: "OCTREOTIDE KBI 50Y/1ML INJ BT 5",
  atcCode: "H01CB02"
}, {
  CIP7: '3424427',
  CIP13: '3400934244278',
  ucdLib: "SANDOSTATINE 100Y INJ AV1ML",
  UCD7: '9137255',
  UCD13: '3400891372557',
  ucdQtyMultiplicator: 6,
  cipLib: "SANDOSTATINE 100Y INJ AV1ML BT 6",
  atcCode: "H01CB02"
}, {
  CIP7: '3424433',
  CIP13: '3400934244339',
  ucdLib: "SANDOSTATINE 500Y INJ AMP1ML",
  UCD7: '9146403',
  UCD13: '3400891464030',
  ucdQtyMultiplicator: 6,
  cipLib: "SANDOSTATINE 500Y INJ AMP1ML BT 6",
  atcCode: "H01CB02"
}, {
  CIP7: '3424410',
  CIP13: '3400934244100',
  ucdLib: "SANDOSTATINE 50Y INJ AV1ML",
  UCD7: '9137261',
  UCD13: '3400891372618',
  ucdQtyMultiplicator: 6,
  cipLib: "SANDOSTATINE 50Y INJ AV1ML BT 6",
  atcCode: "H01CB02"
}, {
  CIP7: '5578353',
  CIP13: '3400955783534',
  ucdLib: "SOMATOSTA.EUM 0,25MG INJ F+A.",
  UCD7: '9160633',
  UCD13: '3400891606331',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMATOSTA.EUM 0,25MG INJ F+A. BT 1",
  atcCode: "H01CB01"
}, {
  CIP7: '5578376',
  CIP13: '3400955783763',
  ucdLib: "SOMATOSTA.EUM 3MG INJ FL+AMP",
  UCD7: '9160656',
  UCD13: '3400891606560',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMATOSTA.EUM 3MG INJ FL+AMP BT 1",
  atcCode: "H01CB01"
}, {
  CIP7: '5600354',
  CIP13: '3400956003549',
  ucdLib: "SOMATOSTA.EUM 6MG INJ FL+AMP",
  UCD7: '9191846',
  UCD13: '3400891918465',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMATOSTA.EUM 6MG INJ FL+AMP BT 1",
  atcCode: "H01CB01"
}, {
  CIP7: '3535210',
  CIP13: '3400935352101',
  ucdLib: "SYNAREL ENDONAS FL PULV 8ML",
  UCD7: '9219958',
  UCD13: '3400892199580',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNAREL ENDONAS FL PULV 8ML BT 1",
  atcCode: "H01CA02"
}, {
  CIP7: '3284363',
  CIP13: '3400932843633',
  ucdLib: "LUTRELEF 3,2MG INJ FL+FL",
  UCD7: '9117548',
  UCD13: '3400891175486',
  ucdQtyMultiplicator: 1,
  cipLib: "LUTRELEF 3,2MG INJ FL+FL BT 1",
  atcCode: "H01CA01"
}, {
  CIP7: '5501092',
  CIP13: '3400955010920',
  ucdLib: "PABAL 100MCG/ML INJ FL1ML",
  UCD7: '9413206',
  UCD13: '3400894132066',
  ucdQtyMultiplicator: 5,
  cipLib: "PABAL 100MCG/ML INJ FL1ML BT 5",
  atcCode: "H01BB03"
}, {
  CIP7: '5621988',
  CIP13: '3400956219889',
  ucdLib: "SYNTOCINON 5UI INJ AMP1ML",
  UCD7: '9090068',
  UCD13: '3400890900683',
  ucdQtyMultiplicator: 10,
  cipLib: "SYNTOCINON 5UI INJ AMP1ML BT 10",
  atcCode: "H01BB02"
}, {
  CIP7: '5857952',
  CIP13: '3400958579523',
  ucdLib: "OXYTOCINE MDC 5UI/ML AMP1ML",
  UCD7: '9397559',
  UCD13: '3400893975596',
  ucdQtyMultiplicator: 10,
  cipLib: "OXYTOCINE MDC 5UI/ML AMP1ML BT 10",
  atcCode: "H01BB02"
}, {
  CIP7: '5841419',
  CIP13: '3400958414190',
  ucdLib: "OXYTOCINE PAN 5UI/ML AMP1ML",
  UCD7: '9391752',
  UCD13: '3400893917527',
  ucdQtyMultiplicator: 10,
  cipLib: "OXYTOCINE PAN 5UI/ML AMP1ML BT 10",
  atcCode: "H01BB02"
}, {
  CIP7: '5562748',
  CIP13: '3400955627487',
  ucdLib: "GLYPRESSINE 1MG IV FL+AMP",
  UCD7: '9126079',
  UCD13: '3400891260793',
  ucdQtyMultiplicator: 5,
  cipLib: "GLYPRESSINE 1MG IV FL+AMP BT 5",
  atcCode: "H01BA04"
}, {
  CIP7: '5753721',
  CIP13: '3400957537210',
  ucdLib: "HAEMOPRESSIN 1MG INJ FL+AMP",
  UCD7: '9341168',
  UCD13: '3400893411681',
  ucdQtyMultiplicator: 5,
  cipLib: "HAEMOPRESSIN 1MG INJ FL+AMP BT 5",
  atcCode: "H01BA04"
}, {
  CIP7: '5770056',
  CIP13: '3400957700560',
  ucdLib: "GLYPRESSINE 1MG IV AMP8,5ML",
  UCD7: '9355058',
  UCD13: '3400893550588',
  ucdQtyMultiplicator: 5,
  cipLib: "GLYPRESSINE 1MG IV AMP8,5ML BT 5",
  atcCode: "H01BA04"
}, {
  CIP7: '3233199',
  CIP13: '3400932331994',
  ucdLib: "MINIRIN 0,1MG/ML NAS FL2,5ML",
  UCD7: '9059207',
  UCD13: '3400890592079',
  ucdQtyMultiplicator: 1,
  cipLib: "MINIRIN 0,1MG/ML NAS FL2,5ML BT 1",
  atcCode: "H01BA02"
}, {
  CIP7: '3309152',
  CIP13: '3400933091521',
  ucdLib: "MINIRIN 4MCG/ML INJ AMP1ML",
  UCD7: '9137551',
  UCD13: '3400891375510',
  ucdQtyMultiplicator: 10,
  cipLib: "MINIRIN 4MCG/ML INJ AMP1ML BT 10",
  atcCode: "H01BA02"
}, {
  CIP7: '3305504',
  CIP13: '3400933055042',
  ucdLib: "MINIRIN SPRAY 10MCG/DOS 2,5ML",
  UCD7: '9130023',
  UCD13: '3400891300239',
  ucdQtyMultiplicator: 1,
  cipLib: "MINIRIN SPRAY 10MCG/DOS 2,5ML BT 1",
  atcCode: "H01BA02"
}, {
  CIP7: '3547331',
  CIP13: '3400935473318',
  ucdLib: "OCTIM 150MCG/DOS NAS FL2,5ML",
  UCD7: '9189513',
  UCD13: '3400891895131',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTIM 150MCG/DOS NAS FL2,5ML BT 1",
  atcCode: "H01BA02"
}, {
  CIP7: '3693133',
  CIP13: '3400936931336',
  ucdLib: "MINIRINMELT 120MCG LYOT",
  UCD7: '9282796',
  UCD13: '3400892827964',
  ucdQtyMultiplicator: 30,
  cipLib: "MINIRINMELT 120MCG LYOT BT 30",
  atcCode: "H01BA02"
}, {
  CIP7: '3693156',
  CIP13: '3400936931565',
  ucdLib: "MINIRINMELT 120MCG LYOT",
  UCD7: '9282796',
  UCD13: '3400892827964',
  ucdQtyMultiplicator: 100,
  cipLib: "MINIRINMELT 120MCG LYOT BT 100",
  atcCode: "H01BA02"
}, {
  CIP7: '3693179',
  CIP13: '3400936931794',
  ucdLib: "MINIRINMELT 240MCG LYOT",
  UCD7: '9289315',
  UCD13: '3400892893150',
  ucdQtyMultiplicator: 30,
  cipLib: "MINIRINMELT 240MCG LYOT BT 30",
  atcCode: "H01BA02"
}, {
  CIP7: '3693104',
  CIP13: '3400936931046',
  ucdLib: "MINIRINMELT 60MCG LYOT",
  UCD7: '9282804',
  UCD13: '3400892828046',
  ucdQtyMultiplicator: 30,
  cipLib: "MINIRINMELT 60MCG LYOT BT 30",
  atcCode: "H01BA02"
}, {
  CIP7: '3693110',
  CIP13: '3400936931107',
  ucdLib: "MINIRINMELT 60MCG LYOT",
  UCD7: '9282804',
  UCD13: '3400892828046',
  ucdQtyMultiplicator: 100,
  cipLib: "MINIRINMELT 60MCG LYOT BT 100",
  atcCode: "H01BA02"
}, {
  CIP7: '3611810',
  CIP13: '3400936118102',
  ucdLib: "SOMAVERT 20MG INJ FL+FL",
  UCD7: '9257634',
  UCD13: '3400892576343',
  ucdQtyMultiplicator: 30,
  cipLib: "SOMAVERT 20MG INJ FL+FL BT 30",
  atcCode: "H01AX01"
}, {
  CIP7: '3607837',
  CIP13: '3400936078376',
  ucdLib: "SOMAVERT 10MG INJ FL+FL",
  UCD7: '9257611',
  UCD13: '3400892576114',
  ucdQtyMultiplicator: 30,
  cipLib: "SOMAVERT 10MG INJ FL+FL BT 30",
  atcCode: "H01AX01"
}, {
  CIP7: '3607843',
  CIP13: '3400936078437',
  ucdLib: "SOMAVERT 15MG INJ FL+FL",
  UCD7: '9257628',
  UCD13: '3400892576282',
  ucdQtyMultiplicator: 30,
  cipLib: "SOMAVERT 15MG INJ FL+FL BT 30",
  atcCode: "H01AX01"
}, {
  CIP7: '3622506',
  CIP13: '3400936225060',
  ucdLib: "SOMAVERT 20MG INJ FL+FL",
  UCD7: '9257634',
  UCD13: '3400892576343',
  ucdQtyMultiplicator: 1,
  cipLib: "SOMAVERT 20MG INJ FL+FL BT 1",
  atcCode: "H01AX01"
}, {
  CIP7: '3814677',
  CIP13: '3400938146776',
  ucdLib: "INCRELEX 10MG/ML INJ FL4ML",
  UCD7: '9299638',
  UCD13: '3400892996387',
  ucdQtyMultiplicator: 1,
  cipLib: "INCRELEX 10MG/ML INJ FL4ML BT 1",
  atcCode: "H01AC03"
}, {
  CIP7: '3438441',
  CIP13: '3400934384417',
  ucdLib: "GENOTONORM MINIQUICK 0,6MG S.",
  UCD7: '9241780',
  UCD13: '3400892417806',
  ucdQtyMultiplicator: 7,
  cipLib: "GENOTONORM MINIQUICK 0,6MG S. BT 7",
  atcCode: "H01AC01"
}, {
  CIP7: '3438458',
  CIP13: '3400934384585',
  ucdLib: "GENOTONORM MINIQUICK 0,8MG S.",
  UCD7: '9241797',
  UCD13: '3400892417974',
  ucdQtyMultiplicator: 7,
  cipLib: "GENOTONORM MINIQUICK 0,8MG S. BT 7",
  atcCode: "H01AC01"
}, {
  CIP7: '3438470',
  CIP13: '3400934384707',
  ucdLib: "GENOTONORM MINIQUICK 1,2MG S.",
  UCD7: '9241805',
  UCD13: '3400892418056',
  ucdQtyMultiplicator: 7,
  cipLib: "GENOTONORM MINIQUICK 1,2MG S. BT 7",
  atcCode: "H01AC01"
}, {
  CIP7: '3438487',
  CIP13: '3400934384875',
  ucdLib: "GENOTONORM MINIQUICK 1,4MG S.",
  UCD7: '9241811',
  UCD13: '3400892418117',
  ucdQtyMultiplicator: 7,
  cipLib: "GENOTONORM MINIQUICK 1,4MG S. BT 7",
  atcCode: "H01AC01"
}, {
  CIP7: '3438493',
  CIP13: '3400934384936',
  ucdLib: "GENOTONORM MINIQUICK 1,6MG S.",
  UCD7: '9241828',
  UCD13: '3400892418285',
  ucdQtyMultiplicator: 7,
  cipLib: "GENOTONORM MINIQUICK 1,6MG S. BT 7",
  atcCode: "H01AC01"
}, {
  CIP7: '3438501',
  CIP13: '3400934385018',
  ucdLib: "GENOTONORM MINIQUICK 1,8MG S.",
  UCD7: '9241834',
  UCD13: '3400892418346',
  ucdQtyMultiplicator: 7,
  cipLib: "GENOTONORM MINIQUICK 1,8MG S. BT 7",
  atcCode: "H01AC01"
}, {
  CIP7: '3438464',
  CIP13: '3400934384646',
  ucdLib: "GENOTONORM MINIQUICK 1MG SRG",
  UCD7: '9241840',
  UCD13: '3400892418407',
  ucdQtyMultiplicator: 7,
  cipLib: "GENOTONORM MINIQUICK 1MG SRG BT 7",
  atcCode: "H01AC01"
}, {
  CIP7: '3438518',
  CIP13: '3400934385186',
  ucdLib: "GENOTONORM MINIQUICK 2MG SRG",
  UCD7: '9241857',
  UCD13: '3400892418575',
  ucdQtyMultiplicator: 7,
  cipLib: "GENOTONORM MINIQUICK 2MG SRG BT 7",
  atcCode: "H01AC01"
}, {
  CIP7: '3567612',
  CIP13: '3400935676122',
  ucdLib: "SAIZEN CLICKEASY 8MG FL+CART.",
  UCD7: '9234308',
  UCD13: '3400892343082',
  ucdQtyMultiplicator: 1,
  cipLib: "SAIZEN CLICKEASY 8MG FL+CART. BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3419969',
  CIP13: '3400934199691',
  ucdLib: "GENOTONORM 12MG INJ CARTCHE",
  UCD7: '9164074',
  UCD13: '3400891640748',
  ucdQtyMultiplicator: 1,
  cipLib: "GENOTONORM 12MG INJ CARTCHE BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3530891',
  CIP13: '3400935308917',
  ucdLib: "NORDITROPINE SIMPL.10MG CART.",
  UCD7: '9224787',
  UCD13: '3400892247878',
  ucdQtyMultiplicator: 1,
  cipLib: "NORDITROPINE SIMPL.10MG CART. BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3530939',
  CIP13: '3400935309396',
  ucdLib: "NORDITROPINE SIMPL.15MG CART.",
  UCD7: '9224793',
  UCD13: '3400892247939',
  ucdQtyMultiplicator: 1,
  cipLib: "NORDITROPINE SIMPL.15MG CART. BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3530862',
  CIP13: '3400935308627',
  ucdLib: "NORDITROPINE SIMPL.5MG CART.",
  UCD7: '9223894',
  UCD13: '3400892238944',
  ucdQtyMultiplicator: 1,
  cipLib: "NORDITROPINE SIMPL.5MG CART. BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3708403',
  CIP13: '3400937084031',
  ucdLib: "ZOMACTON 10MG/ML INJ FL+SRG",
  UCD7: '9299549',
  UCD13: '3400892995496',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOMACTON 10MG/ML INJ FL+SRG BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3639688',
  CIP13: '3400936396883',
  ucdLib: "NORDITROPINE NORDI.10MG STYLO",
  UCD7: '9389910',
  UCD13: '3400893899106',
  ucdQtyMultiplicator: 1,
  cipLib: "NORDITROPINE NORDI.10MG STYLO BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3639694',
  CIP13: '3400936396944',
  ucdLib: "NORDITROPINE NORDI.15MG STYLO",
  UCD7: '9361633',
  UCD13: '3400893616338',
  ucdQtyMultiplicator: 1,
  cipLib: "NORDITROPINE NORDI.15MG STYLO BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3639671',
  CIP13: '3400936396715',
  ucdLib: "NORDITROPINE NORDI.5MG STYLO",
  UCD7: '9389927',
  UCD13: '3400893899274',
  ucdQtyMultiplicator: 1,
  cipLib: "NORDITROPINE NORDI.5MG STYLO BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3497550',
  CIP13: '3400934975509',
  ucdLib: "GENOTONORM 5,3MG INJ CARTCHE",
  UCD7: '9213312',
  UCD13: '3400892133126',
  ucdQtyMultiplicator: 1,
  cipLib: "GENOTONORM 5,3MG INJ CARTCHE BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3640622',
  CIP13: '3400936406223',
  ucdLib: "NUTROPINAQ 10MG/2ML INJ CART.",
  UCD7: '9266981',
  UCD13: '3400892669816',
  ucdQtyMultiplicator: 1,
  cipLib: "NUTROPINAQ 10MG/2ML INJ CART. BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3805483',
  CIP13: '3400938054835',
  ucdLib: "OMNITROPE 5MG INJ C.1,5ML",
  UCD7: '9307065',
  UCD13: '3400893070659',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNITROPE 5MG INJ C.1,5ML BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3805508',
  CIP13: '3400938055085',
  ucdLib: "OMNITROPE 5MG INJ C.1,5ML",
  UCD7: '9307065',
  UCD13: '3400893070659',
  ucdQtyMultiplicator: 5,
  cipLib: "OMNITROPE 5MG INJ C.1,5ML BT 5",
  atcCode: "H01AC01"
}, {
  CIP7: '4974207',
  CIP13: '3400949742073',
  ucdLib: "GENOTONORM 12MG INJ CART.GO",
  UCD7: '9391930',
  UCD13: '3400893919309',
  ucdQtyMultiplicator: 1,
  cipLib: "GENOTONORM 12MG INJ CART.GO BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '4974213',
  CIP13: '3400949742134',
  ucdLib: "GENOTONORM 12MG INJ CART.GO",
  UCD7: '9391930',
  UCD13: '3400893919309',
  ucdQtyMultiplicator: 5,
  cipLib: "GENOTONORM 12MG INJ CART.GO BT 5",
  atcCode: "H01AC01"
}, {
  CIP7: '4974182',
  CIP13: '3400949741823',
  ucdLib: "GENOTONORM 5,3MG INJ CART.GO",
  UCD7: '9391947',
  UCD13: '3400893919477',
  ucdQtyMultiplicator: 1,
  cipLib: "GENOTONORM 5,3MG INJ CART.GO BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '4974199',
  CIP13: '3400949741991',
  ucdLib: "GENOTONORM 5,3MG INJ CART.GO",
  UCD7: '9391947',
  UCD13: '3400893919477',
  ucdQtyMultiplicator: 5,
  cipLib: "GENOTONORM 5,3MG INJ CART.GO BT 5",
  atcCode: "H01AC01"
}, {
  CIP7: '2741924',
  CIP13: '3400927419249',
  ucdLib: "NUTROPINAQ 10MG/2ML INJ CART.",
  UCD7: '9266981',
  UCD13: '3400892669816',
  ucdQtyMultiplicator: 3,
  cipLib: "NUTROPINAQ 10MG/2ML INJ CART. BT 3",
  atcCode: "H01AC01"
}, {
  CIP7: '2755286',
  CIP13: '3400927552861',
  ucdLib: "OMNITROPE 10MG INJ CS1,5ML",
  UCD7: '9396991',
  UCD13: '3400893969915',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNITROPE 10MG INJ CS1,5ML BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '2755292',
  CIP13: '3400927552922',
  ucdLib: "OMNITROPE 10MG INJ CS1,5ML",
  UCD7: '9396991',
  UCD13: '3400893969915',
  ucdQtyMultiplicator: 5,
  cipLib: "OMNITROPE 10MG INJ CS1,5ML BT 5",
  atcCode: "H01AC01"
}, {
  CIP7: '2755300',
  CIP13: '3400927553004',
  ucdLib: "OMNITROPE 10MG INJ CS1,5ML",
  UCD7: '9396991',
  UCD13: '3400893969915',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNITROPE 10MG INJ CS1,5ML BT 10",
  atcCode: "H01AC01"
}, {
  CIP7: '2755240',
  CIP13: '3400927552403',
  ucdLib: "OMNITROPE 5MG INJ CS1,5ML",
  UCD7: '9397016',
  UCD13: '3400893970164',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNITROPE 5MG INJ CS1,5ML BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '2755257',
  CIP13: '3400927552571',
  ucdLib: "OMNITROPE 5MG INJ CS1,5ML",
  UCD7: '9397016',
  UCD13: '3400893970164',
  ucdQtyMultiplicator: 5,
  cipLib: "OMNITROPE 5MG INJ CS1,5ML BT 5",
  atcCode: "H01AC01"
}, {
  CIP7: '2755263',
  CIP13: '3400927552632',
  ucdLib: "OMNITROPE 5MG INJ CS1,5ML",
  UCD7: '9397016',
  UCD13: '3400893970164',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNITROPE 5MG INJ CS1,5ML BT 10",
  atcCode: "H01AC01"
}, {
  CIP7: '4155745',
  CIP13: '3400941557453',
  ucdLib: "SAIZEN 5,83MG/ML INJ C.1,03ML",
  UCD7: '9391999',
  UCD13: '3400893919996',
  ucdQtyMultiplicator: 1,
  cipLib: "SAIZEN 5,83MG/ML INJ C.1,03ML BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '4155774',
  CIP13: '3400941557743',
  ucdLib: "SAIZEN 8MG/ML INJ CART.2,5ML",
  UCD7: '9392013',
  UCD13: '3400893920138',
  ucdQtyMultiplicator: 1,
  cipLib: "SAIZEN 8MG/ML INJ CART.2,5ML BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '2168778',
  CIP13: '3400921687781',
  ucdLib: "OMNITROPE 15MG INJ C.1,5ML",
  UCD7: '9391982',
  UCD13: '3400893919828',
  ucdQtyMultiplicator: 1,
  cipLib: "OMNITROPE 15MG INJ C.1,5ML BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '2168784',
  CIP13: '3400921687842',
  ucdLib: "OMNITROPE 15MG INJ C.1,5ML",
  UCD7: '9391982',
  UCD13: '3400893919828',
  ucdQtyMultiplicator: 5,
  cipLib: "OMNITROPE 15MG INJ C.1,5ML BT 5",
  atcCode: "H01AC01"
}, {
  CIP7: '2168790',
  CIP13: '3400921687903',
  ucdLib: "OMNITROPE 15MG INJ C.1,5ML",
  UCD7: '9391982',
  UCD13: '3400893919828',
  ucdQtyMultiplicator: 10,
  cipLib: "OMNITROPE 15MG INJ C.1,5ML BT 10",
  atcCode: "H01AC01"
}, {
  CIP7: '3421593',
  CIP13: '3400934215933',
  ucdLib: "UMATROPE 12MG INJ CART+SRG",
  UCD7: '9187112',
  UCD13: '3400891871128',
  ucdQtyMultiplicator: 1,
  cipLib: "UMATROPE 12MG INJ CART+SRG BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3421601',
  CIP13: '3400934216015',
  ucdLib: "UMATROPE 24MG INJ CART+SRG",
  UCD7: '9238246',
  UCD13: '3400892382463',
  ucdQtyMultiplicator: 1,
  cipLib: "UMATROPE 24MG INJ CART+SRG BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3421587',
  CIP13: '3400934215872',
  ucdLib: "UMATROPE 6MG INJ CART+SRG",
  UCD7: '9187106',
  UCD13: '3400891871067',
  ucdQtyMultiplicator: 1,
  cipLib: "UMATROPE 6MG INJ CART+SRG BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3421541',
  CIP13: '3400934215414',
  ucdLib: "ZOMACTON 4MG A/C INJ FL+AMP",
  UCD7: '9167084',
  UCD13: '3400891670844',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOMACTON 4MG A/C INJ FL+AMP BT 1",
  atcCode: "H01AC01"
}, {
  CIP7: '3102586',
  CIP13: '3400931025863',
  ucdLib: "SYNACTHENE RET.1MG INJ AMP",
  UCD7: '9089875',
  UCD13: '3400890898751',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNACTHENE RET.1MG INJ AMP BT 1",
  atcCode: "H01AA02"
}, {
  CIP7: '3182869',
  CIP13: '3400931828693',
  ucdLib: "SYNACTHENE 0,25MG INJ AMP",
  UCD7: '9089852',
  UCD13: '3400890898522',
  ucdQtyMultiplicator: 1,
  cipLib: "SYNACTHENE 0,25MG INJ AMP BT 1",
  atcCode: "H01AA02"
}, {
  CIP7: '3600373',
  CIP13: '3400936003736',
  ucdLib: "PERMIXON 160MG GELU",
  UCD7: '9154265',
  UCD13: '3400891542653',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GELU BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '3344958',
  CIP13: '3400933449582',
  ucdLib: "PERMIXON 160MG GELU",
  UCD7: '9154265',
  UCD13: '3400891542653',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GELU BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '3722432',
  CIP13: '3400937224321',
  ucdLib: "PERMIXON 160MG GELU",
  UCD7: '9154265',
  UCD13: '3400891542653',
  ucdQtyMultiplicator: 180,
  cipLib: "PERMIXON 160MG GELU BT 180",
  atcCode: "G04CX02"
}, {
  CIP7: '3753154',
  CIP13: '3400937531542',
  ucdLib: "PRODINAN 160MG GELU",
  UCD7: '9362911',
  UCD13: '3400893629116',
  ucdQtyMultiplicator: 60,
  cipLib: "PRODINAN 160MG GELU BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '3753183',
  CIP13: '3400937531832',
  ucdLib: "PRODINAN 160MG GELU",
  UCD7: '9362911',
  UCD13: '3400893629116',
  ucdQtyMultiplicator: 180,
  cipLib: "PRODINAN 160MG GELU BT 180",
  atcCode: "G04CX02"
}, {
  CIP7: '4901711',
  CIP13: '3400949017119',
  ucdLib: "PERMIXON 160MG GEL.AIPAMB ES",
  UCD7: '9394495',
  UCD13: '3400893944950',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPAMB ES BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4901728',
  CIP13: '3400949017287',
  ucdLib: "PERMIXON 160MG GEL.AIPAMB ES",
  UCD7: '9394495',
  UCD13: '3400893944950',
  ucdQtyMultiplicator: 180,
  cipLib: "PERMIXON 160MG GEL.AIPAMB ES BT 180",
  atcCode: "G04CX02"
}, {
  CIP7: '4900781',
  CIP13: '3400949007813',
  ucdLib: "PERMIXON 160MG GEL.AIPBBA ES",
  UCD7: '9375546',
  UCD13: '3400893755464',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPBBA ES BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4901326',
  CIP13: '3400949013265',
  ucdLib: "PERMIXON 160MG GEL.AIPBBA ES",
  UCD7: '9375546',
  UCD13: '3400893755464',
  ucdQtyMultiplicator: 180,
  cipLib: "PERMIXON 160MG GEL.AIPBBA ES BT 180",
  atcCode: "G04CX02"
}, {
  CIP7: '4900089',
  CIP13: '3400949000890',
  ucdLib: "PERMIXON 160MG GEL.AIPBBABG",
  UCD7: '9421387',
  UCD13: '3400894213871',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPBBABG BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4902567',
  CIP13: '3400949025671',
  ucdLib: "PERMIXON 160MG GEL.AIPITT ES",
  UCD7: '9403030',
  UCD13: '3400894030300',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPITT ES BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4900057',
  CIP13: '3400949000579',
  ucdLib: "PERMIXON 160MG GEL.AIPMWI BG",
  UCD7: '9415808',
  UCD13: '3400894158080',
  ucdQtyMultiplicator: 180,
  cipLib: "PERMIXON 160MG GEL.AIPMWI BG BT 180",
  atcCode: "G04CX02"
}, {
  CIP7: '4900058',
  CIP13: '3400949000586',
  ucdLib: "PERMIXON 160MG GEL.AIPMWI BG",
  UCD7: '9415808',
  UCD13: '3400894158080',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPMWI BG BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4900516',
  CIP13: '3400949005161',
  ucdLib: "PERMIXON 160MG GEL.AIPMWI ES",
  UCD7: '9344681',
  UCD13: '3400893446812',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPMWI ES BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4900953',
  CIP13: '3400949009534',
  ucdLib: "PERMIXON 160MG GEL.AIPMWI ES",
  UCD7: '9344681',
  UCD13: '3400893446812',
  ucdQtyMultiplicator: 180,
  cipLib: "PERMIXON 160MG GEL.AIPMWI ES BT 180",
  atcCode: "G04CX02"
}, {
  CIP7: '4902320',
  CIP13: '3400949023202',
  ucdLib: "PERMIXON 160MG GEL.AIPMWI LT",
  UCD7: '9400528',
  UCD13: '3400894005285',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPMWI LT BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4900137',
  CIP13: '3400949001378',
  ucdLib: "PERMIXON 160MG GEL.AIPMWI PT",
  UCD7: '9311026',
  UCD13: '3400893110263',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPMWI PT BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4900087',
  CIP13: '3400949000876',
  ucdLib: "PERMIXON 160MG GEL.AIPPLA BG",
  UCD7: '9420407',
  UCD13: '3400894204077',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPPLA BG BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4900088',
  CIP13: '3400949000883',
  ucdLib: "PERMIXON 160MG GEL.AIPPLA BG",
  UCD7: '9420407',
  UCD13: '3400894204077',
  ucdQtyMultiplicator: 180,
  cipLib: "PERMIXON 160MG GEL.AIPPLA BG BT 180",
  atcCode: "G04CX02"
}, {
  CIP7: '4900255',
  CIP13: '3400949002559',
  ucdLib: "PERMIXON 160MG GEL.AIPPLA ES",
  UCD7: '9334458',
  UCD13: '3400893344583',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPPLA ES BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '4900338',
  CIP13: '3400949003389',
  ucdLib: "PERMIXON 160MG GEL.AIPPLA ES",
  UCD7: '9334458',
  UCD13: '3400893344583',
  ucdQtyMultiplicator: 180,
  cipLib: "PERMIXON 160MG GEL.AIPPLA ES BT 180",
  atcCode: "G04CX02"
}, {
  CIP7: '4900019',
  CIP13: '3400949000197',
  ucdLib: "PERMIXON 160MG GEL.AIPPLA PT",
  UCD7: '9298231',
  UCD13: '3400892982311',
  ucdQtyMultiplicator: 60,
  cipLib: "PERMIXON 160MG GEL.AIPPLA PT BT 60",
  atcCode: "G04CX02"
}, {
  CIP7: '3376409',
  CIP13: '3400933764098',
  ucdLib: "TADENAN 50MG CAPS MOL",
  UCD7: '9157708',
  UCD13: '3400891577082',
  ucdQtyMultiplicator: 60,
  cipLib: "TADENAN 50MG CAPS MOL BT 60",
  atcCode: "G04CX01"
}, {
  CIP7: '3924029',
  CIP13: '3400939240299',
  ucdLib: "PRUNIER AFR.ARW 50MG CAPS",
  UCD7: '9341932',
  UCD13: '3400893419328',
  ucdQtyMultiplicator: 30,
  cipLib: "PRUNIER AFR.ARW 50MG CAPS BT 30",
  atcCode: "G04CX01"
}, {
  CIP7: '3924035',
  CIP13: '3400939240350',
  ucdLib: "PRUNIER AFR.ARW 50MG CAPS",
  UCD7: '9341932',
  UCD13: '3400893419328',
  ucdQtyMultiplicator: 60,
  cipLib: "PRUNIER AFR.ARW 50MG CAPS BT 60",
  atcCode: "G04CX01"
}, {
  CIP7: '3165428',
  CIP13: '3400931654285',
  ucdLib: "TADENAN 50MG CAPS MOL",
  UCD7: '9157708',
  UCD13: '3400891577082',
  ucdQtyMultiplicator: 30,
  cipLib: "TADENAN 50MG CAPS MOL BT 30",
  atcCode: "G04CX01"
}, {
  CIP7: '3618255',
  CIP13: '3400936182554',
  ucdLib: "AVODART 0,5MG CAPS MOL",
  UCD7: '9250862',
  UCD13: '3400892508627',
  ucdQtyMultiplicator: 30,
  cipLib: "AVODART 0,5MG CAPS MOL BT 30",
  atcCode: "G04CB02"
}, {
  CIP7: '4901059',
  CIP13: '3400949010592',
  ucdLib: "AVODART 0,5MG CAPS AIPMWI BG",
  UCD7: '9384597',
  UCD13: '3400893845974',
  ucdQtyMultiplicator: 30,
  cipLib: "AVODART 0,5MG CAPS AIPMWI BG BT 30",
  atcCode: "G04CB02"
}, {
  CIP7: '3832600',
  CIP13: '3400938326000',
  ucdLib: "FINASTERIDE RBX 5MG CPR",
  UCD7: '9313628',
  UCD13: '3400893136287',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE RBX 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3352484',
  CIP13: '3400933524845',
  ucdLib: "CHIBRO-PROSCAR 5MG CPR",
  UCD7: '9155810',
  UCD13: '3400891558104',
  ucdQtyMultiplicator: 28,
  cipLib: "CHIBRO-PROSCAR 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3771413',
  CIP13: '3400937714136',
  ucdLib: "FINASTERIDE MYL 5MG CPR",
  UCD7: '9296551',
  UCD13: '3400892965512',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE MYL 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3773263',
  CIP13: '3400937732635',
  ucdLib: "FINASTERIDE TVC 5MG CPR",
  UCD7: '9296574',
  UCD13: '3400892965741',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE TVC 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3920103',
  CIP13: '3400939201030',
  ucdLib: "FINASTERIDE ACC 5MG CPR",
  UCD7: '9333246',
  UCD13: '3400893332467',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ACC 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3873473',
  CIP13: '3400938734737',
  ucdLib: "FINASTERIDE ARL 5MG CPR",
  UCD7: '9322219',
  UCD13: '3400893222195',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ARL 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3873496',
  CIP13: '3400938734966',
  ucdLib: "FINASTERIDE ARL 5MG CPR",
  UCD7: '9322219',
  UCD13: '3400893222195',
  ucdQtyMultiplicator: 30,
  cipLib: "FINASTERIDE ARL 5MG CPR BT 30",
  atcCode: "G04CB01"
}, {
  CIP7: '3756141',
  CIP13: '3400937561419',
  ucdLib: "FINASTERIDE BGA 5MG CPR",
  UCD7: '9296597',
  UCD13: '3400892965970',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE BGA 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3756187',
  CIP13: '3400937561877',
  ucdLib: "FINASTERIDE BGA 5MG CPR",
  UCD7: '9296597',
  UCD13: '3400892965970',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE BGA 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3809452',
  CIP13: '3400938094527',
  ucdLib: "FINASTERIDE EG 5MG CPR",
  UCD7: '9306775',
  UCD13: '3400893067758',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE EG 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3752456',
  CIP13: '3400937524568',
  ucdLib: "FINASTERIDE SDZ 5MG CPR",
  UCD7: '9357028',
  UCD13: '3400893570289',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE SDZ 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3756276',
  CIP13: '3400937562768',
  ucdLib: "FINASTERIDE ZEN 5MG CPR",
  UCD7: '9296580',
  UCD13: '3400892965802',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ZEN 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3902921',
  CIP13: '3400939029214',
  ucdLib: "FINASTERIDE ALM 5MG CPR",
  UCD7: '9329434',
  UCD13: '3400893294345',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ALM 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3906592',
  CIP13: '3400939065922',
  ucdLib: "FINASTERIDE ALT 5MG CPR",
  UCD7: '9329440',
  UCD13: '3400893294406',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ALT 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '4973538',
  CIP13: '3400949735389',
  ucdLib: "FINASTERIDE ISD 5MG CPR",
  UCD7: '9364821',
  UCD13: '3400893648216',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ISD 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '4973604',
  CIP13: '3400949736041',
  ucdLib: "FINASTERIDE PHR 5MG CPR",
  UCD7: '9364838',
  UCD13: '3400893648384',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE PHR 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3939976',
  CIP13: '3400939399768',
  ucdLib: "FINASTERIDE ZYD 5MG CPR",
  UCD7: '9333252',
  UCD13: '3400893332528',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ZYD 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3983954',
  CIP13: '3400939839547',
  ucdLib: "FINASTERIDE CRT 5MG CPR",
  UCD7: '9343894',
  UCD13: '3400893438947',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE CRT 5MG CPR BT 28",
  atcCode: "G04CB01"
}, {
  CIP7: '3893398',
  CIP13: '3400938933987',
  ucdLib: "COMBODART 0,5MG/0,4MG GELU",
  UCD7: '9390787',
  UCD13: '3400893907870',
  ucdQtyMultiplicator: 30,
  cipLib: "COMBODART 0,5MG/0,4MG GELU BT 30",
  atcCode: "G04CA52"
}, {
  CIP7: '3749075',
  CIP13: '3400937490757',
  ucdLib: "SILODYX 4MG GELU",
  UCD7: '9354828',
  UCD13: '3400893548288',
  ucdQtyMultiplicator: 30,
  cipLib: "SILODYX 4MG GELU BT 30",
  atcCode: "G04CA04"
}, {
  CIP7: '3749342',
  CIP13: '3400937493420',
  ucdLib: "SILODYX 8MG GELU",
  UCD7: '9354834',
  UCD13: '3400893548349',
  ucdQtyMultiplicator: 30,
  cipLib: "SILODYX 8MG GELU BT 30",
  atcCode: "G04CA04"
}, {
  CIP7: '3749388',
  CIP13: '3400937493888',
  ucdLib: "UROREC 4MG GELU",
  UCD7: '9354840',
  UCD13: '3400893548400',
  ucdQtyMultiplicator: 30,
  cipLib: "UROREC 4MG GELU BT 30",
  atcCode: "G04CA04"
}, {
  CIP7: '4951123',
  CIP13: '3400949511235',
  ucdLib: "UROREC 4MG GELU ADP BBA",
  UCD7: '9401120',
  UCD13: '3400894011200',
  ucdQtyMultiplicator: 30,
  cipLib: "UROREC 4MG GELU ADP BBA BT 30",
  atcCode: "G04CA04"
}, {
  CIP7: '4950632',
  CIP13: '3400949506323',
  ucdLib: "UROREC 4MG GELU ADP MWI",
  UCD7: '9390480',
  UCD13: '3400893904800',
  ucdQtyMultiplicator: 30,
  cipLib: "UROREC 4MG GELU ADP MWI BT 30",
  atcCode: "G04CA04"
}, {
  CIP7: '3749425',
  CIP13: '3400937494250',
  ucdLib: "UROREC 8MG GELU",
  UCD7: '9354857',
  UCD13: '3400893548578',
  ucdQtyMultiplicator: 30,
  cipLib: "UROREC 8MG GELU BT 30",
  atcCode: "G04CA04"
}, {
  CIP7: '4950649',
  CIP13: '3400949506491',
  ucdLib: "UROREC 8MG GELU ADP MWI",
  UCD7: '9390497',
  UCD13: '3400893904978',
  ucdQtyMultiplicator: 30,
  cipLib: "UROREC 8MG GELU ADP MWI BT 30",
  atcCode: "G04CA04"
}, {
  CIP7: '3611460',
  CIP13: '3400936114609',
  ucdLib: "TERAZOSINE TVC 5MG CPR",
  UCD7: '9245499',
  UCD13: '3400892454993',
  ucdQtyMultiplicator: 28,
  cipLib: "TERAZOSINE TVC 5MG CPR BT 28",
  atcCode: "G04CA03"
}, {
  CIP7: '3574552',
  CIP13: '3400935745521',
  ucdLib: "TERAZOSINE MYL 5MG CPR",
  UCD7: '9234656',
  UCD13: '3400892346564',
  ucdQtyMultiplicator: 28,
  cipLib: "TERAZOSINE MYL 5MG CPR BT 28",
  atcCode: "G04CA03"
}, {
  CIP7: '3404376',
  CIP13: '3400934043765',
  ucdLib: "HYTRINE 1MG CPR",
  UCD7: '9189950',
  UCD13: '3400891899504',
  ucdQtyMultiplicator: 15,
  cipLib: "HYTRINE 1MG CPR BT 15",
  atcCode: "G04CA03"
}, {
  CIP7: '3413027',
  CIP13: '3400934130274',
  ucdLib: "HYTRINE 5MG CPR",
  UCD7: '9189967',
  UCD13: '3400891899672',
  ucdQtyMultiplicator: 28,
  cipLib: "HYTRINE 5MG CPR BT 28",
  atcCode: "G04CA03"
}, {
  CIP7: '3621369',
  CIP13: '3400936213692',
  ucdLib: "TERAZOSINE BGA 5MG CPR",
  UCD7: '9255641',
  UCD13: '3400892556413',
  ucdQtyMultiplicator: 28,
  cipLib: "TERAZOSINE BGA 5MG CPR BT 28",
  atcCode: "G04CA03"
}, {
  CIP7: '3424290',
  CIP13: '3400934242908',
  ucdLib: "DYSALFA 1MG CPR",
  UCD7: '9186868',
  UCD13: '3400891868685',
  ucdQtyMultiplicator: 15,
  cipLib: "DYSALFA 1MG CPR BT 15",
  atcCode: "G04CA03"
}, {
  CIP7: '3424315',
  CIP13: '3400934243158',
  ucdLib: "DYSALFA 5MG CPR",
  UCD7: '9186874',
  UCD13: '3400891868746',
  ucdQtyMultiplicator: 28,
  cipLib: "DYSALFA 5MG CPR BT 28",
  atcCode: "G04CA03"
}, {
  CIP7: '3399824',
  CIP13: '3400933998240',
  ucdLib: "JOSIR LP 0,4MG GELU",
  UCD7: '9183597',
  UCD13: '3400891835977',
  ucdQtyMultiplicator: 30,
  cipLib: "JOSIR LP 0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3399818',
  CIP13: '3400933998189',
  ucdLib: "OMIX LP 0,4MG GELU",
  UCD7: '9183611',
  UCD13: '3400891836110',
  ucdQtyMultiplicator: 30,
  cipLib: "OMIX LP 0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3707763',
  CIP13: '3400937077637',
  ucdLib: "TAMSULOSINE ALM LP0,4MG GELU",
  UCD7: '9283459',
  UCD13: '3400892834597',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE ALM LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3705698',
  CIP13: '3400937056984',
  ucdLib: "TAMSULOSINE BGA LP0,4MG GELU",
  UCD7: '9282626',
  UCD13: '3400892826264',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE BGA LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3707680',
  CIP13: '3400937076807',
  ucdLib: "TAMSULOSINE MYL LP0,4MG GELU",
  UCD7: '9282632',
  UCD13: '3400892826325',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE MYL LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3696255',
  CIP13: '3400936962552',
  ucdLib: "MECIR LP 0,4MG CPR",
  UCD7: '9286423',
  UCD13: '3400892864235',
  ucdQtyMultiplicator: 30,
  cipLib: "MECIR LP 0,4MG CPR BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3696249',
  CIP13: '3400936962491',
  ucdLib: "OMEXEL LP 0,4MG CPR",
  UCD7: '9286328',
  UCD13: '3400892863283',
  ucdQtyMultiplicator: 30,
  cipLib: "OMEXEL LP 0,4MG CPR BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3718577',
  CIP13: '3400937185776',
  ucdLib: "TAMSULOSINE ACT LP0,4MG GELU",
  UCD7: '9286297',
  UCD13: '3400892862972',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE ACT LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3771962',
  CIP13: '3400937719629',
  ucdLib: "TAMSULOSINE ARW LP0,4MG GELU",
  UCD7: '9297384',
  UCD13: '3400892973845',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE ARW LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3711983',
  CIP13: '3400937119832',
  ucdLib: "TAMSULOSINE EG LP0,4MG GELU",
  UCD7: '9282951',
  UCD13: '3400892829517',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE EG LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3718643',
  CIP13: '3400937186438',
  ucdLib: "TAMSULOSINE SDZ LP0,4MG GELU",
  UCD7: '9284134',
  UCD13: '3400892841342',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE SDZ LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3718560',
  CIP13: '3400937185608',
  ucdLib: "TAMSULOSINE TVC LP0,4MG GELU",
  UCD7: '9284140',
  UCD13: '3400892841403',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE TVC LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3718614',
  CIP13: '3400937186148',
  ucdLib: "TAMSULOSINE ZEN LP0,4MG GELU",
  UCD7: '9284157',
  UCD13: '3400892841571',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE ZEN LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3718620',
  CIP13: '3400937186209',
  ucdLib: "TAMSULOSINE ZYF LP0,4MG GELU",
  UCD7: '9286274',
  UCD13: '3400892862743',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE ZYF LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3884181',
  CIP13: '3400938841817',
  ucdLib: "TAMSULOSINE RBX LP0,4MG GELU",
  UCD7: '9321881',
  UCD13: '3400893218815',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE RBX LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '2213220',
  CIP13: '3400922132204',
  ucdLib: "TAMSULOSINE SDZ LP0,4MG CPR",
  UCD7: '9382658',
  UCD13: '3400893826584',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE SDZ LP0,4MG CPR BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '2213295',
  CIP13: '3400922132952',
  ucdLib: "TAMSULOSINE TVC LP0,4MG CPR",
  UCD7: '9388655',
  UCD13: '3400893886557',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE TVC LP0,4MG CPR BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '4925321',
  CIP13: '3400949253210',
  ucdLib: "TAMSULOSINE ISD LP0,4MG GELU",
  UCD7: '9355495',
  UCD13: '3400893554951',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE ISD LP0,4MG GELU BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '4177592',
  CIP13: '3400941775925',
  ucdLib: "TAMSULOSINE BGA LP0,4MG CPR",
  UCD7: '9385533',
  UCD13: '3400893855331',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE BGA LP0,4MG CPR BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '4177103',
  CIP13: '3400941771033',
  ucdLib: "TAMSULOSINE EG LP0,4MG CPR",
  UCD7: '9376899',
  UCD13: '3400893768990',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE EG LP0,4MG CPR BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '4177439',
  CIP13: '3400941774393',
  ucdLib: "TAMSULOSINE MYL LP0,4MG CPR",
  UCD7: '9380211',
  UCD13: '3400893802113',
  ucdQtyMultiplicator: 30,
  cipLib: "TAMSULOSINE MYL LP0,4MG CPR BT 30",
  atcCode: "G04CA02"
}, {
  CIP7: '3331246',
  CIP13: '3400933312466',
  ucdLib: "URION 2,5MG CPR",
  UCD7: '9149726',
  UCD13: '3400891497267',
  ucdQtyMultiplicator: 30,
  cipLib: "URION 2,5MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3301601',
  CIP13: '3400933016012',
  ucdLib: "XATRAL 2,5MG CPR",
  UCD7: '9130247',
  UCD13: '3400891302479',
  ucdQtyMultiplicator: 30,
  cipLib: "XATRAL 2,5MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3511103',
  CIP13: '3400935111036',
  ucdLib: "ALFUZOSINE ZEN LP 10MG CPR",
  UCD7: '9281207',
  UCD13: '3400892812076',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE ZEN LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3511066',
  CIP13: '3400935110664',
  ucdLib: "XATRAL LP 10MG CPR",
  UCD7: '9216581',
  UCD13: '3400892165813',
  ucdQtyMultiplicator: 30,
  cipLib: "XATRAL LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3704546',
  CIP13: '3400937045469',
  ucdLib: "ALFUZOSINE EG LP 10MG CPR",
  UCD7: '9282135',
  UCD13: '3400892821351',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE EG LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3704523',
  CIP13: '3400937045230',
  ucdLib: "ALFUZOSINE MYL LP 10MG CPR",
  UCD7: '9282170',
  UCD13: '3400892821702',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE MYL LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3704552',
  CIP13: '3400937045520',
  ucdLib: "ALFUZOSINE SDZ LP 10MG CPR",
  UCD7: '9282158',
  UCD13: '3400892821580',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE SDZ LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3704486',
  CIP13: '3400937044868',
  ucdLib: "ALFUZOSINE TVS LP 10MG CPR",
  UCD7: '9282230',
  UCD13: '3400892822303',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE TVS LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3813755',
  CIP13: '3400938137552',
  ucdLib: "ALFUZOSINE ZYD LP 10MG CPR",
  UCD7: '9307384',
  UCD13: '3400893073841',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE ZYD LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3732100',
  CIP13: '3400937321006',
  ucdLib: "ALFUZOSINE BGA LP 10MG CPR",
  UCD7: '9285435',
  UCD13: '3400892854359',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE BGA LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3907628',
  CIP13: '3400939076287',
  ucdLib: "ALFUZOSINE RPG LP 10MG CPR",
  UCD7: '9329776',
  UCD13: '3400893297766',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE RPG LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '4900930',
  CIP13: '3400949009305',
  ucdLib: "XATRAL LP 10MG CPR AIPBBA IT",
  UCD7: '9382121',
  UCD13: '3400893821213',
  ucdQtyMultiplicator: 30,
  cipLib: "XATRAL LP 10MG CPR AIPBBA IT BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '4901289',
  CIP13: '3400949012893',
  ucdLib: "XATRAL LP 10MG CPR AIPMWI IT",
  UCD7: '9393627',
  UCD13: '3400893936276',
  ucdQtyMultiplicator: 30,
  cipLib: "XATRAL LP 10MG CPR AIPMWI IT BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '4900189',
  CIP13: '3400949001897',
  ucdLib: "XATRAL LP 10MG CPR AIPMWI UK",
  UCD7: '9324661',
  UCD13: '3400893246610',
  ucdQtyMultiplicator: 30,
  cipLib: "XATRAL LP 10MG CPR AIPMWI UK BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '4900373',
  CIP13: '3400949003730',
  ucdLib: "XATRAL LP 10MG CPR AIPPLA UK",
  UCD7: '9341990',
  UCD13: '3400893419908',
  ucdQtyMultiplicator: 30,
  cipLib: "XATRAL LP 10MG CPR AIPPLA UK BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '2168749',
  CIP13: '3400921687491',
  ucdLib: "ALFUZOSINE CRT LP 10MG CPR",
  UCD7: '9377835',
  UCD13: '3400893778357',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE CRT LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '3863196',
  CIP13: '3400938631968',
  ucdLib: "ALFUZOSINE EVO LP 10MG CPR",
  UCD7: '9371809',
  UCD13: '3400893718094',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFUZOSINE EVO LP 10MG CPR BT 30",
  atcCode: "G04CA01"
}, {
  CIP7: '2226926',
  CIP13: '3400922269269',
  ucdLib: "PRILIGY 30MG CPR",
  UCD7: '9391798',
  UCD13: '3400893917985',
  ucdQtyMultiplicator: 3,
  cipLib: "PRILIGY 30MG CPR BT 3",
  atcCode: "G04BX14"
}, {
  CIP7: '2226932',
  CIP13: '3400922269320',
  ucdLib: "PRILIGY 30MG CPR",
  UCD7: '9391798',
  UCD13: '3400893917985',
  ucdQtyMultiplicator: 6,
  cipLib: "PRILIGY 30MG CPR BT 6",
  atcCode: "G04BX14"
}, {
  CIP7: '2226961',
  CIP13: '3400922269610',
  ucdLib: "PRILIGY 60MG CPR",
  UCD7: '9391806',
  UCD13: '3400893918067',
  ucdQtyMultiplicator: 3,
  cipLib: "PRILIGY 60MG CPR BT 3",
  atcCode: "G04BX14"
}, {
  CIP7: '2226978',
  CIP13: '3400922269788',
  ucdLib: "PRILIGY 60MG CPR",
  UCD7: '9391806',
  UCD13: '3400893918067',
  ucdQtyMultiplicator: 6,
  cipLib: "PRILIGY 60MG CPR BT 6",
  atcCode: "G04BX14"
}, {
  CIP7: '3425438',
  CIP13: '3400934254383',
  ucdLib: "SUCCINIMIDE PRB BUV SACH",
  UCD7: '9191154',
  UCD13: '3400891911541',
  ucdQtyMultiplicator: 30,
  cipLib: "SUCCINIMIDE PRB BUV SACH BT 30",
  atcCode: "G04BX10"
}, {
  CIP7: '2759522',
  CIP13: '3400927595226',
  ucdLib: "SPEDRA 100MG CPR",
  UCD7: '9400190',
  UCD13: '3400894001904',
  ucdQtyMultiplicator: 2,
  cipLib: "SPEDRA 100MG CPR BT 2",
  atcCode: "G04BE10"
}, {
  CIP7: '2759539',
  CIP13: '3400927595394',
  ucdLib: "SPEDRA 100MG CPR",
  UCD7: '9400190',
  UCD13: '3400894001904',
  ucdQtyMultiplicator: 4,
  cipLib: "SPEDRA 100MG CPR BT 4",
  atcCode: "G04BE10"
}, {
  CIP7: '2759545',
  CIP13: '3400927595455',
  ucdLib: "SPEDRA 100MG CPR",
  UCD7: '9400190',
  UCD13: '3400894001904',
  ucdQtyMultiplicator: 8,
  cipLib: "SPEDRA 100MG CPR BT 8",
  atcCode: "G04BE10"
}, {
  CIP7: '2759551',
  CIP13: '3400927595516',
  ucdLib: "SPEDRA 100MG CPR",
  UCD7: '9400190',
  UCD13: '3400894001904',
  ucdQtyMultiplicator: 12,
  cipLib: "SPEDRA 100MG CPR BT 12",
  atcCode: "G04BE10"
}, {
  CIP7: '2759568',
  CIP13: '3400927595684',
  ucdLib: "SPEDRA 200MG CPR",
  UCD7: '9400209',
  UCD13: '3400894002093',
  ucdQtyMultiplicator: 4,
  cipLib: "SPEDRA 200MG CPR BT 4",
  atcCode: "G04BE10"
}, {
  CIP7: '2759574',
  CIP13: '3400927595745',
  ucdLib: "SPEDRA 200MG CPR",
  UCD7: '9400209',
  UCD13: '3400894002093',
  ucdQtyMultiplicator: 8,
  cipLib: "SPEDRA 200MG CPR BT 8",
  atcCode: "G04BE10"
}, {
  CIP7: '2759580',
  CIP13: '3400927595806',
  ucdLib: "SPEDRA 200MG CPR",
  UCD7: '9400209',
  UCD13: '3400894002093',
  ucdQtyMultiplicator: 12,
  cipLib: "SPEDRA 200MG CPR BT 12",
  atcCode: "G04BE10"
}, {
  CIP7: '2759485',
  CIP13: '3400927594854',
  ucdLib: "SPEDRA 50MG CPR",
  UCD7: '9400215',
  UCD13: '3400894002154',
  ucdQtyMultiplicator: 4,
  cipLib: "SPEDRA 50MG CPR BT 4",
  atcCode: "G04BE10"
}, {
  CIP7: '2759491',
  CIP13: '3400927594915',
  ucdLib: "SPEDRA 50MG CPR",
  UCD7: '9400215',
  UCD13: '3400894002154',
  ucdQtyMultiplicator: 8,
  cipLib: "SPEDRA 50MG CPR BT 8",
  atcCode: "G04BE10"
}, {
  CIP7: '3618321',
  CIP13: '3400936183216',
  ucdLib: "LEVITRA 10MG CPR",
  UCD7: '9247251',
  UCD13: '3400892472515',
  ucdQtyMultiplicator: 4,
  cipLib: "LEVITRA 10MG CPR BT 4",
  atcCode: "G04BE09"
}, {
  CIP7: '3618338',
  CIP13: '3400936183384',
  ucdLib: "LEVITRA 10MG CPR",
  UCD7: '9247251',
  UCD13: '3400892472515',
  ucdQtyMultiplicator: 8,
  cipLib: "LEVITRA 10MG CPR BT 8",
  atcCode: "G04BE09"
}, {
  CIP7: '3618367',
  CIP13: '3400936183674',
  ucdLib: "LEVITRA 20MG CPR",
  UCD7: '9247268',
  UCD13: '3400892472683',
  ucdQtyMultiplicator: 4,
  cipLib: "LEVITRA 20MG CPR BT 4",
  atcCode: "G04BE09"
}, {
  CIP7: '3618373',
  CIP13: '3400936183735',
  ucdLib: "LEVITRA 20MG CPR",
  UCD7: '9247268',
  UCD13: '3400892472683',
  ucdQtyMultiplicator: 8,
  cipLib: "LEVITRA 20MG CPR BT 8",
  atcCode: "G04BE09"
}, {
  CIP7: '3618396',
  CIP13: '3400936183964',
  ucdLib: "LEVITRA 20MG CPR",
  UCD7: '9247268',
  UCD13: '3400892472683',
  ucdQtyMultiplicator: 12,
  cipLib: "LEVITRA 20MG CPR BT 12",
  atcCode: "G04BE09"
}, {
  CIP7: '3618284',
  CIP13: '3400936182844',
  ucdLib: "LEVITRA 5MG CPR",
  UCD7: '9247274',
  UCD13: '3400892472744',
  ucdQtyMultiplicator: 4,
  cipLib: "LEVITRA 5MG CPR BT 4",
  atcCode: "G04BE09"
}, {
  CIP7: '4941254',
  CIP13: '3400949412549',
  ucdLib: "LEVITRA 10MG CPR ORODISP",
  UCD7: '9360800',
  UCD13: '3400893608005',
  ucdQtyMultiplicator: 4,
  cipLib: "LEVITRA 10MG CPR ORODISP BT 4",
  atcCode: "G04BE09"
}, {
  CIP7: '4996031',
  CIP13: '3400949960316',
  ucdLib: "LEVITRA 10MG CPR ORODISP",
  UCD7: '9360800',
  UCD13: '3400893608005',
  ucdQtyMultiplicator: 8,
  cipLib: "LEVITRA 10MG CPR ORODISP BT 8",
  atcCode: "G04BE09"
}, {
  CIP7: '2169476',
  CIP13: '3400921694765',
  ucdLib: "LEVITRA 20MG CPR",
  UCD7: '9247268',
  UCD13: '3400892472683',
  ucdQtyMultiplicator: 20,
  cipLib: "LEVITRA 20MG CPR BT 20",
  atcCode: "G04BE09"
}, {
  CIP7: '3607984',
  CIP13: '3400936079847',
  ucdLib: "CIALIS 10MG CPR",
  UCD7: '9246004',
  UCD13: '3400892460048',
  ucdQtyMultiplicator: 4,
  cipLib: "CIALIS 10MG CPR BT 4",
  atcCode: "G04BE08"
}, {
  CIP7: '3608009',
  CIP13: '3400936080096',
  ucdLib: "CIALIS 20MG CPR",
  UCD7: '9246010',
  UCD13: '3400892460109',
  ucdQtyMultiplicator: 4,
  cipLib: "CIALIS 20MG CPR BT 4",
  atcCode: "G04BE08"
}, {
  CIP7: '3608015',
  CIP13: '3400936080157',
  ucdLib: "CIALIS 20MG CPR",
  UCD7: '9246010',
  UCD13: '3400892460109',
  ucdQtyMultiplicator: 8,
  cipLib: "CIALIS 20MG CPR BT 8",
  atcCode: "G04BE08"
}, {
  CIP7: '4951241',
  CIP13: '3400949512416',
  ucdLib: "CIALIS 10MG CPR ADP BBA",
  UCD7: '9407832',
  UCD13: '3400894078326',
  ucdQtyMultiplicator: 4,
  cipLib: "CIALIS 10MG CPR ADP BBA BT 4",
  atcCode: "G04BE08"
}, {
  CIP7: '4950460',
  CIP13: '3400949504602',
  ucdLib: "CIALIS 10MG CPR ADP MWI",
  UCD7: '9385444',
  UCD13: '3400893854440',
  ucdQtyMultiplicator: 4,
  cipLib: "CIALIS 10MG CPR ADP MWI BT 4",
  atcCode: "G04BE08"
}, {
  CIP7: '4950862',
  CIP13: '3400949508624',
  ucdLib: "CIALIS 10MG CPR ADP PLA",
  UCD7: '9404064',
  UCD13: '3400894040644',
  ucdQtyMultiplicator: 4,
  cipLib: "CIALIS 10MG CPR ADP PLA BT 4",
  atcCode: "G04BE08"
}, {
  CIP7: '4951258',
  CIP13: '3400949512584',
  ucdLib: "CIALIS 20MG CPR ADP BBA",
  UCD7: '9407849',
  UCD13: '3400894078494',
  ucdQtyMultiplicator: 4,
  cipLib: "CIALIS 20MG CPR ADP BBA BT 4",
  atcCode: "G04BE08"
}, {
  CIP7: '4950477',
  CIP13: '3400949504770',
  ucdLib: "CIALIS 20MG CPR ADP MWI",
  UCD7: '9385450',
  UCD13: '3400893854501',
  ucdQtyMultiplicator: 4,
  cipLib: "CIALIS 20MG CPR ADP MWI BT 4",
  atcCode: "G04BE08"
}, {
  CIP7: '4951169',
  CIP13: '3400949511693',
  ucdLib: "CIALIS 20MG CPR ADP PLA",
  UCD7: '9419120',
  UCD13: '3400894191209',
  ucdQtyMultiplicator: 4,
  cipLib: "CIALIS 20MG CPR ADP PLA BT 4",
  atcCode: "G04BE08"
}, {
  CIP7: '3805431',
  CIP13: '3400938054316',
  ucdLib: "CIALIS 2,5MG CPR",
  UCD7: '9305534',
  UCD13: '3400893055342',
  ucdQtyMultiplicator: 28,
  cipLib: "CIALIS 2,5MG CPR BT 28",
  atcCode: "G04BE08"
}, {
  CIP7: '3805454',
  CIP13: '3400938054545',
  ucdLib: "CIALIS 5MG CPR",
  UCD7: '9305540',
  UCD13: '3400893055403',
  ucdQtyMultiplicator: 28,
  cipLib: "CIALIS 5MG CPR BT 28",
  atcCode: "G04BE08"
}, {
  CIP7: '2792695',
  CIP13: '3400927926952',
  ucdLib: "CIALIS 5MG CPR",
  UCD7: '9305540',
  UCD13: '3400893055403',
  ucdQtyMultiplicator: 84,
  cipLib: "CIALIS 5MG CPR BT 84",
  atcCode: "G04BE08"
}, {
  CIP7: '3537309',
  CIP13: '3400935373090',
  ucdLib: "YOCORAL 5MG CPR",
  UCD7: '9228377',
  UCD13: '3400892283777',
  ucdQtyMultiplicator: 50,
  cipLib: "YOCORAL 5MG CPR BT 50",
  atcCode: "G04BE04"
}, {
  CIP7: '3537315',
  CIP13: '3400935373151',
  ucdLib: "YOCORAL 5MG CPR",
  UCD7: '9228377',
  UCD13: '3400892283777',
  ucdQtyMultiplicator: 100,
  cipLib: "YOCORAL 5MG CPR BT 100",
  atcCode: "G04BE04"
}, {
  CIP7: '4980403',
  CIP13: '3400949804030',
  ucdLib: "SILDENAFIL MYL 100MG CPR",
  UCD7: '9370827',
  UCD13: '3400893708279',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL MYL 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '4980426',
  CIP13: '3400949804269',
  ucdLib: "SILDENAFIL MYL 100MG CPR",
  UCD7: '9370827',
  UCD13: '3400893708279',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL MYL 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '4980432',
  CIP13: '3400949804320',
  ucdLib: "SILDENAFIL MYL 100MG CPR",
  UCD7: '9370827',
  UCD13: '3400893708279',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL MYL 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '4980283',
  CIP13: '3400949802838',
  ucdLib: "SILDENAFIL MYL 25MG CPR",
  UCD7: '9370833',
  UCD13: '3400893708330',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL MYL 25MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '4980308',
  CIP13: '3400949803088',
  ucdLib: "SILDENAFIL MYL 25MG CPR",
  UCD7: '9370833',
  UCD13: '3400893708330',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL MYL 25MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '4980343',
  CIP13: '3400949803439',
  ucdLib: "SILDENAFIL MYL 50MG CPR",
  UCD7: '9370856',
  UCD13: '3400893708569',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL MYL 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '4980366',
  CIP13: '3400949803668',
  ucdLib: "SILDENAFIL MYL 50MG CPR",
  UCD7: '9370856',
  UCD13: '3400893708569',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL MYL 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '4980372',
  CIP13: '3400949803729',
  ucdLib: "SILDENAFIL MYL 50MG CPR",
  UCD7: '9370856',
  UCD13: '3400893708569',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL MYL 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '3484317',
  CIP13: '3400934843174',
  ucdLib: "VIAGRA 100MG CPR",
  UCD7: '9204767',
  UCD13: '3400892047676',
  ucdQtyMultiplicator: 4,
  cipLib: "VIAGRA 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3484323',
  CIP13: '3400934843235',
  ucdLib: "VIAGRA 100MG CPR",
  UCD7: '9204767',
  UCD13: '3400892047676',
  ucdQtyMultiplicator: 8,
  cipLib: "VIAGRA 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '3484346',
  CIP13: '3400934843464',
  ucdLib: "VIAGRA 100MG CPR",
  UCD7: '9204767',
  UCD13: '3400892047676',
  ucdQtyMultiplicator: 12,
  cipLib: "VIAGRA 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '3484228',
  CIP13: '3400934842283',
  ucdLib: "VIAGRA 25MG CPR",
  UCD7: '9204773',
  UCD13: '3400892047737',
  ucdQtyMultiplicator: 4,
  cipLib: "VIAGRA 25MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3484234',
  CIP13: '3400934842344',
  ucdLib: "VIAGRA 25MG CPR",
  UCD7: '9204773',
  UCD13: '3400892047737',
  ucdQtyMultiplicator: 8,
  cipLib: "VIAGRA 25MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '3484263',
  CIP13: '3400934842634',
  ucdLib: "VIAGRA 50MG CPR",
  UCD7: '9204796',
  UCD13: '3400892047966',
  ucdQtyMultiplicator: 4,
  cipLib: "VIAGRA 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3484286',
  CIP13: '3400934842863',
  ucdLib: "VIAGRA 50MG CPR",
  UCD7: '9204796',
  UCD13: '3400892047966',
  ucdQtyMultiplicator: 8,
  cipLib: "VIAGRA 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '3484292',
  CIP13: '3400934842924',
  ucdLib: "VIAGRA 50MG CPR",
  UCD7: '9204796',
  UCD13: '3400892047966',
  ucdQtyMultiplicator: 12,
  cipLib: "VIAGRA 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '3469513',
  CIP13: '3400934695131',
  ucdLib: "SILDENAFIL TVC 100MG CPR",
  UCD7: '9351540',
  UCD13: '3400893515402',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL TVC 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3469536',
  CIP13: '3400934695360',
  ucdLib: "SILDENAFIL TVC 100MG CPR",
  UCD7: '9351540',
  UCD13: '3400893515402',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL TVC 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '3469476',
  CIP13: '3400934694769',
  ucdLib: "SILDENAFIL TVC 25MG CPR",
  UCD7: '9351557',
  UCD13: '3400893515570',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL TVC 25MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3469482',
  CIP13: '3400934694820',
  ucdLib: "SILDENAFIL TVC 25MG CPR",
  UCD7: '9351557',
  UCD13: '3400893515570',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL TVC 25MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '3469499',
  CIP13: '3400934694998',
  ucdLib: "SILDENAFIL TVC 50MG CPR",
  UCD7: '9351563',
  UCD13: '3400893515631',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL TVC 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3469507',
  CIP13: '3400934695070',
  ucdLib: "SILDENAFIL TVC 50MG CPR",
  UCD7: '9351563',
  UCD13: '3400893515631',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL TVC 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2697005',
  CIP13: '3400926970055',
  ucdLib: "SILDENAFIL ACT 100MG CPR",
  UCD7: '9394213',
  UCD13: '3400893942130',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL ACT 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2697011',
  CIP13: '3400926970116',
  ucdLib: "SILDENAFIL ACT 100MG CPR",
  UCD7: '9394213',
  UCD13: '3400893942130',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL ACT 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2697028',
  CIP13: '3400926970284',
  ucdLib: "SILDENAFIL ACT 100MG CPR",
  UCD7: '9394213',
  UCD13: '3400893942130',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL ACT 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2696951',
  CIP13: '3400926969516',
  ucdLib: "SILDENAFIL ACT 50MG CPR",
  UCD7: '9394236',
  UCD13: '3400893942369',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL ACT 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2696968',
  CIP13: '3400926969684',
  ucdLib: "SILDENAFIL ACT 50MG CPR",
  UCD7: '9394236',
  UCD13: '3400893942369',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL ACT 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2696974',
  CIP13: '3400926969745',
  ucdLib: "SILDENAFIL ACT 50MG CPR",
  UCD7: '9394236',
  UCD13: '3400893942369',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL ACT 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '4190380',
  CIP13: '3400941903809',
  ucdLib: "SILDENAFIL CRT 100MG CPR",
  UCD7: '9376669',
  UCD13: '3400893766699',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL CRT 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '4190339',
  CIP13: '3400941903397',
  ucdLib: "SILDENAFIL CRT 50MG CPR",
  UCD7: '9376681',
  UCD13: '3400893766811',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL CRT 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2696230',
  CIP13: '3400926962302',
  ucdLib: "SILDENAFIL PFZ 100MG CPR",
  UCD7: '9394242',
  UCD13: '3400893942420',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL PFZ 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2696247',
  CIP13: '3400926962470',
  ucdLib: "SILDENAFIL PFZ 100MG CPR",
  UCD7: '9394242',
  UCD13: '3400893942420',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL PFZ 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2696253',
  CIP13: '3400926962531',
  ucdLib: "SILDENAFIL PFZ 100MG CPR",
  UCD7: '9394242',
  UCD13: '3400893942420',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL PFZ 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2696276',
  CIP13: '3400926962760',
  ucdLib: "SILDENAFIL PFZ 100MG CPR",
  UCD7: '9394242',
  UCD13: '3400893942420',
  ucdQtyMultiplicator: 24,
  cipLib: "SILDENAFIL PFZ 100MG CPR BT 24",
  atcCode: "G04BE03"
}, {
  CIP7: '2696187',
  CIP13: '3400926961879',
  ucdLib: "SILDENAFIL PFZ 50MG CPR",
  UCD7: '9394259',
  UCD13: '3400893942598',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL PFZ 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2696193',
  CIP13: '3400926961930',
  ucdLib: "SILDENAFIL PFZ 50MG CPR",
  UCD7: '9394259',
  UCD13: '3400893942598',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL PFZ 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2696201',
  CIP13: '3400926962012',
  ucdLib: "SILDENAFIL PFZ 50MG CPR",
  UCD7: '9394259',
  UCD13: '3400893942598',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL PFZ 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2696218',
  CIP13: '3400926962180',
  ucdLib: "SILDENAFIL PFZ 50MG CPR",
  UCD7: '9394259',
  UCD13: '3400893942598',
  ucdQtyMultiplicator: 24,
  cipLib: "SILDENAFIL PFZ 50MG CPR BT 24",
  atcCode: "G04BE03"
}, {
  CIP7: '2697979',
  CIP13: '3400926979799',
  ucdLib: "SILDENAFIL ZEN 100MG CPR",
  UCD7: '9394176',
  UCD13: '3400893941768',
  ucdQtyMultiplicator: 2,
  cipLib: "SILDENAFIL ZEN 100MG CPR BT 2",
  atcCode: "G04BE03"
}, {
  CIP7: '2697985',
  CIP13: '3400926979850',
  ucdLib: "SILDENAFIL ZEN 100MG CPR",
  UCD7: '9394176',
  UCD13: '3400893941768',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL ZEN 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2697991',
  CIP13: '3400926979911',
  ucdLib: "SILDENAFIL ZEN 100MG CPR",
  UCD7: '9394176',
  UCD13: '3400893941768',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL ZEN 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2698016',
  CIP13: '3400926980160',
  ucdLib: "SILDENAFIL ZEN 100MG CPR",
  UCD7: '9394176',
  UCD13: '3400893941768',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL ZEN 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2697815',
  CIP13: '3400926978150',
  ucdLib: "SILDENAFIL ZEN 25MG CPR",
  UCD7: '9394182',
  UCD13: '3400893941829',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL ZEN 25MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2697821',
  CIP13: '3400926978211',
  ucdLib: "SILDENAFIL ZEN 25MG CPR",
  UCD7: '9394182',
  UCD13: '3400893941829',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL ZEN 25MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2697873',
  CIP13: '3400926978730',
  ucdLib: "SILDENAFIL ZEN 50MG CPR",
  UCD7: '9394199',
  UCD13: '3400893941997',
  ucdQtyMultiplicator: 2,
  cipLib: "SILDENAFIL ZEN 50MG CPR BT 2",
  atcCode: "G04BE03"
}, {
  CIP7: '2697896',
  CIP13: '3400926978969',
  ucdLib: "SILDENAFIL ZEN 50MG CPR",
  UCD7: '9394199',
  UCD13: '3400893941997',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL ZEN 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2697904',
  CIP13: '3400926979041',
  ucdLib: "SILDENAFIL ZEN 50MG CPR",
  UCD7: '9394199',
  UCD13: '3400893941997',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL ZEN 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2697910',
  CIP13: '3400926979102',
  ucdLib: "SILDENAFIL ZEN 50MG CPR",
  UCD7: '9394199',
  UCD13: '3400893941997',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL ZEN 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2664595',
  CIP13: '3400926645953',
  ucdLib: "VIZARSIN 100MG CPR",
  UCD7: '9394029',
  UCD13: '3400893940297',
  ucdQtyMultiplicator: 4,
  cipLib: "VIZARSIN 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2664603',
  CIP13: '3400926646035',
  ucdLib: "VIZARSIN 100MG CPR",
  UCD7: '9394029',
  UCD13: '3400893940297',
  ucdQtyMultiplicator: 8,
  cipLib: "VIZARSIN 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2664626',
  CIP13: '3400926646264',
  ucdLib: "VIZARSIN 100MG CPR",
  UCD7: '9394029',
  UCD13: '3400893940297',
  ucdQtyMultiplicator: 12,
  cipLib: "VIZARSIN 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2664767',
  CIP13: '3400926647674',
  ucdLib: "VIZARSIN 100MG CPR DISP",
  UCD7: '9394012',
  UCD13: '3400893940129',
  ucdQtyMultiplicator: 8,
  cipLib: "VIZARSIN 100MG CPR DISP BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2664508',
  CIP13: '3400926645083',
  ucdLib: "VIZARSIN 25MG CPR",
  UCD7: '9394035',
  UCD13: '3400893940358',
  ucdQtyMultiplicator: 4,
  cipLib: "VIZARSIN 25MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2664514',
  CIP13: '3400926645144',
  ucdLib: "VIZARSIN 25MG CPR",
  UCD7: '9394035',
  UCD13: '3400893940358',
  ucdQtyMultiplicator: 8,
  cipLib: "VIZARSIN 25MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2664543',
  CIP13: '3400926645434',
  ucdLib: "VIZARSIN 50MG CPR",
  UCD7: '9394058',
  UCD13: '3400893940587',
  ucdQtyMultiplicator: 4,
  cipLib: "VIZARSIN 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2664566',
  CIP13: '3400926645663',
  ucdLib: "VIZARSIN 50MG CPR",
  UCD7: '9394058',
  UCD13: '3400893940587',
  ucdQtyMultiplicator: 8,
  cipLib: "VIZARSIN 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2664572',
  CIP13: '3400926645724',
  ucdLib: "VIZARSIN 50MG CPR",
  UCD7: '9394058',
  UCD13: '3400893940587',
  ucdQtyMultiplicator: 12,
  cipLib: "VIZARSIN 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2664715',
  CIP13: '3400926647155',
  ucdLib: "VIZARSIN 50MG CPR DISP",
  UCD7: '9394041',
  UCD13: '3400893940419',
  ucdQtyMultiplicator: 8,
  cipLib: "VIZARSIN 50MG CPR DISP BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2180302',
  CIP13: '3400921803020',
  ucdLib: "SILDENAFIL ACC 100MG CPR",
  UCD7: '9391315',
  UCD13: '3400893913154',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL ACC 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2180319',
  CIP13: '3400921803198',
  ucdLib: "SILDENAFIL ACC 100MG CPR",
  UCD7: '9391315',
  UCD13: '3400893913154',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL ACC 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2180325',
  CIP13: '3400921803259',
  ucdLib: "SILDENAFIL ACC 100MG CPR",
  UCD7: '9391315',
  UCD13: '3400893913154',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL ACC 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2180213',
  CIP13: '3400921802139',
  ucdLib: "SILDENAFIL ACC 25MG CPR",
  UCD7: '9391321',
  UCD13: '3400893913215',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL ACC 25MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2180236',
  CIP13: '3400921802368',
  ucdLib: "SILDENAFIL ACC 25MG CPR",
  UCD7: '9391321',
  UCD13: '3400893913215',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL ACC 25MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2180265',
  CIP13: '3400921802658',
  ucdLib: "SILDENAFIL ACC 50MG CPR",
  UCD7: '9391338',
  UCD13: '3400893913383',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL ACC 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2180271',
  CIP13: '3400921802719',
  ucdLib: "SILDENAFIL ACC 50MG CPR",
  UCD7: '9391338',
  UCD13: '3400893913383',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL ACC 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2180288',
  CIP13: '3400921802887',
  ucdLib: "SILDENAFIL ACC 50MG CPR",
  UCD7: '9391338',
  UCD13: '3400893913383',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL ACC 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2688064',
  CIP13: '3400926880644',
  ucdLib: "SILDENAFIL BGA 100MG CPR",
  UCD7: '9393998',
  UCD13: '3400893939987',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL BGA 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2688070',
  CIP13: '3400926880705',
  ucdLib: "SILDENAFIL BGA 100MG CPR",
  UCD7: '9393998',
  UCD13: '3400893939987',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL BGA 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2688087',
  CIP13: '3400926880873',
  ucdLib: "SILDENAFIL BGA 100MG CPR",
  UCD7: '9393998',
  UCD13: '3400893939987',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL BGA 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2688012',
  CIP13: '3400926880125',
  ucdLib: "SILDENAFIL BGA 50MG CPR",
  UCD7: '9394006',
  UCD13: '3400893940068',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL BGA 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2688029',
  CIP13: '3400926880293',
  ucdLib: "SILDENAFIL BGA 50MG CPR",
  UCD7: '9394006',
  UCD13: '3400893940068',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL BGA 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2688035',
  CIP13: '3400926880354',
  ucdLib: "SILDENAFIL BGA 50MG CPR",
  UCD7: '9394006',
  UCD13: '3400893940068',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL BGA 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2183157',
  CIP13: '3400921831573',
  ucdLib: "SILDENAFIL EG 100MG CPR",
  UCD7: '9394118',
  UCD13: '3400893941188',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL EG 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2183163',
  CIP13: '3400921831634',
  ucdLib: "SILDENAFIL EG 100MG CPR",
  UCD7: '9394118',
  UCD13: '3400893941188',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL EG 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2183097',
  CIP13: '3400921830972',
  ucdLib: "SILDENAFIL EG 50MG CPR",
  UCD7: '9394124',
  UCD13: '3400893941249',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL EG 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2183105',
  CIP13: '3400921831054',
  ucdLib: "SILDENAFIL EG 50MG CPR",
  UCD7: '9394124',
  UCD13: '3400893941249',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL EG 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '2686237',
  CIP13: '3400926862374',
  ucdLib: "SILDENAFIL RBX 100MG CPR",
  UCD7: '9394130',
  UCD13: '3400893941300',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL RBX 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '2686160',
  CIP13: '3400926861605',
  ucdLib: "SILDENAFIL RBX 50MG CPR",
  UCD7: '9394147',
  UCD13: '3400893941478',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL RBX 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3995756',
  CIP13: '3400939957562',
  ucdLib: "SILDENAFIL SDZ 100MG CPR",
  UCD7: '9349135',
  UCD13: '3400893491355',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL SDZ 100MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3995785',
  CIP13: '3400939957852',
  ucdLib: "SILDENAFIL SDZ 100MG CPR",
  UCD7: '9349135',
  UCD13: '3400893491355',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL SDZ 100MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '3995822',
  CIP13: '3400939958224',
  ucdLib: "SILDENAFIL SDZ 100MG CPR",
  UCD7: '9349135',
  UCD13: '3400893491355',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL SDZ 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '3995325',
  CIP13: '3400939953250',
  ucdLib: "SILDENAFIL SDZ 25MG CPR",
  UCD7: '9349141',
  UCD13: '3400893491416',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL SDZ 25MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3995360',
  CIP13: '3400939953601',
  ucdLib: "SILDENAFIL SDZ 25MG CPR",
  UCD7: '9349141',
  UCD13: '3400893491416',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL SDZ 25MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '3995503',
  CIP13: '3400939955032',
  ucdLib: "SILDENAFIL SDZ 50MG CPR",
  UCD7: '9349158',
  UCD13: '3400893491584',
  ucdQtyMultiplicator: 4,
  cipLib: "SILDENAFIL SDZ 50MG CPR BT 4",
  atcCode: "G04BE03"
}, {
  CIP7: '3995549',
  CIP13: '3400939955490',
  ucdLib: "SILDENAFIL SDZ 50MG CPR",
  UCD7: '9349158',
  UCD13: '3400893491584',
  ucdQtyMultiplicator: 8,
  cipLib: "SILDENAFIL SDZ 50MG CPR BT 8",
  atcCode: "G04BE03"
}, {
  CIP7: '3995578',
  CIP13: '3400939955780',
  ucdLib: "SILDENAFIL SDZ 50MG CPR",
  UCD7: '9349158',
  UCD13: '3400893491584',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL SDZ 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2686295',
  CIP13: '3400926862954',
  ucdLib: "SILDENAFIL TVC 100MG CPR",
  UCD7: '9351540',
  UCD13: '3400893515402',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL TVC 100MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '2686289',
  CIP13: '3400926862893',
  ucdLib: "SILDENAFIL TVC 50MG CPR",
  UCD7: '9351563',
  UCD13: '3400893515631',
  ucdQtyMultiplicator: 12,
  cipLib: "SILDENAFIL TVC 50MG CPR BT 12",
  atcCode: "G04BE03"
}, {
  CIP7: '3619757',
  CIP13: '3400936197572',
  ucdLib: "CAVERJECTDUAL 10 INJ C+CPRESS",
  UCD7: '9282483',
  UCD13: '3400892824833',
  ucdQtyMultiplicator: 2,
  cipLib: "CAVERJECTDUAL 10 INJ C+CPRESS BT 2",
  atcCode: "G04BE01"
}, {
  CIP7: '3619786',
  CIP13: '3400936197862',
  ucdLib: "CAVERJECTDUAL 20 INJ C+CPRESS",
  UCD7: '9282508',
  UCD13: '3400892825083',
  ucdQtyMultiplicator: 2,
  cipLib: "CAVERJECTDUAL 20 INJ C+CPRESS BT 2",
  atcCode: "G04BE01"
}, {
  CIP7: '3431580',
  CIP13: '3400934315800',
  ucdLib: "EDEX 10MCG/1ML INJ CART+AIG",
  UCD7: '9195910',
  UCD13: '3400891959109',
  ucdQtyMultiplicator: 2,
  cipLib: "EDEX 10MCG/1ML INJ CART+AIG BT 2",
  atcCode: "G04BE01"
}, {
  CIP7: '3431858',
  CIP13: '3400934318580',
  ucdLib: "EDEX 20MCG/1ML INJ CART+AIG",
  UCD7: '9195927',
  UCD13: '3400891959277',
  ucdQtyMultiplicator: 2,
  cipLib: "EDEX 20MCG/1ML INJ CART+AIG BT 2",
  atcCode: "G04BE01"
}, {
  CIP7: '3396346',
  CIP13: '3400933963460',
  ucdLib: "CAVERJECT 10 INJ FL+SRG",
  UCD7: '9176344',
  UCD13: '3400891763447',
  ucdQtyMultiplicator: 1,
  cipLib: "CAVERJECT 10 INJ FL+SRG BT 1",
  atcCode: "G04BE01"
}, {
  CIP7: '3396352',
  CIP13: '3400933963521',
  ucdLib: "CAVERJECT 20 INJ FL+SRG",
  UCD7: '9176350',
  UCD13: '3400891763508',
  ucdQtyMultiplicator: 1,
  cipLib: "CAVERJECT 20 INJ FL+SRG BT 1",
  atcCode: "G04BE01"
}, {
  CIP7: '3500128',
  CIP13: '3400935001283',
  ucdLib: "MUSE 1000MCG BATON",
  UCD7: '9209138',
  UCD13: '3400892091389',
  ucdQtyMultiplicator: 1,
  cipLib: "MUSE 1000MCG BATON BT 1",
  atcCode: "G04BE01"
}, {
  CIP7: '3500068',
  CIP13: '3400935000682',
  ucdLib: "MUSE 250MCG BATON",
  UCD7: '9209144',
  UCD13: '3400892091440',
  ucdQtyMultiplicator: 1,
  cipLib: "MUSE 250MCG BATON BT 1",
  atcCode: "G04BE01"
}, {
  CIP7: '3500097',
  CIP13: '3400935000972',
  ucdLib: "MUSE 500MCG BATON",
  UCD7: '9209150',
  UCD13: '3400892091501',
  ucdQtyMultiplicator: 1,
  cipLib: "MUSE 500MCG BATON BT 1",
  atcCode: "G04BE01"
}, {
  CIP7: '2754387',
  CIP13: '3400927543876',
  ucdLib: "VITAROS 300MCG CR UNIDOS",
  UCD7: '9409050',
  UCD13: '3400894090502',
  ucdQtyMultiplicator: 4,
  cipLib: "VITAROS 300MCG CR UNIDOS BT 4",
  atcCode: "G04BE01"
}, {
  CIP7: '2731825',
  CIP13: '3400927318252',
  ucdLib: "BETMIGA 25MG CPR LP",
  UCD7: '9409601',
  UCD13: '3400894096016',
  ucdQtyMultiplicator: 30,
  cipLib: "BETMIGA 25MG CPR LP BT 30",
  atcCode: "G04BD12"
}, {
  CIP7: '2731831',
  CIP13: '3400927318313',
  ucdLib: "BETMIGA 50MG CPR LP",
  UCD7: '9409618',
  UCD13: '3400894096184',
  ucdQtyMultiplicator: 30,
  cipLib: "BETMIGA 50MG CPR LP BT 30",
  atcCode: "G04BD12"
}, {
  CIP7: '2670472',
  CIP13: '3400926704728',
  ucdLib: "TOVIAZ LP 4MG CPR",
  UCD7: '9399802',
  UCD13: '3400893998021',
  ucdQtyMultiplicator: 30,
  cipLib: "TOVIAZ LP 4MG CPR BT 30",
  atcCode: "G04BD11"
}, {
  CIP7: '2670489',
  CIP13: '3400926704896',
  ucdLib: "TOVIAZ LP 8MG CPR",
  UCD7: '9399819',
  UCD13: '3400893998199',
  ucdQtyMultiplicator: 30,
  cipLib: "TOVIAZ LP 8MG CPR BT 30",
  atcCode: "G04BD11"
}, {
  CIP7: '3516158',
  CIP13: '3400935161581',
  ucdLib: "CERIS 20MG CPR",
  UCD7: '9220602',
  UCD13: '3400892206028',
  ucdQtyMultiplicator: 30,
  cipLib: "CERIS 20MG CPR BT 30",
  atcCode: "G04BD09"
}, {
  CIP7: '2757003',
  CIP13: '3400927570032',
  ucdLib: "TROSPIPHARM 20MG CPR",
  UCD7: '9403403',
  UCD13: '3400894034032',
  ucdQtyMultiplicator: 30,
  cipLib: "TROSPIPHARM 20MG CPR BT 30",
  atcCode: "G04BD09"
}, {
  CIP7: '3655167',
  CIP13: '3400936551671',
  ucdLib: "VESICARE 10MG CPR",
  UCD7: '9263445',
  UCD13: '3400892634456',
  ucdQtyMultiplicator: 30,
  cipLib: "VESICARE 10MG CPR BT 30",
  atcCode: "G04BD08"
}, {
  CIP7: '3655150',
  CIP13: '3400936551503',
  ucdLib: "VESICARE 5MG CPR",
  UCD7: '9263451',
  UCD13: '3400892634517',
  ucdQtyMultiplicator: 30,
  cipLib: "VESICARE 5MG CPR BT 30",
  atcCode: "G04BD08"
}, {
  CIP7: '3461670',
  CIP13: '3400934616709',
  ucdLib: "DETRUSITOL 2MG CPR",
  UCD7: '9200806',
  UCD13: '3400892008066',
  ucdQtyMultiplicator: 28,
  cipLib: "DETRUSITOL 2MG CPR BT 28",
  atcCode: "G04BD07"
}, {
  CIP7: '3273075',
  CIP13: '3400932730759',
  ucdLib: "DITROPAN 5MG CPR",
  UCD7: '9102630',
  UCD13: '3400891026306',
  ucdQtyMultiplicator: 60,
  cipLib: "DITROPAN 5MG CPR BT 60",
  atcCode: "G04BD04"
}, {
  CIP7: '3433113',
  CIP13: '3400934331138',
  ucdLib: "OXYBUTYNINE EG 5MG CPR",
  UCD7: '9210727',
  UCD13: '3400892107271',
  ucdQtyMultiplicator: 60,
  cipLib: "OXYBUTYNINE EG 5MG CPR BT 60",
  atcCode: "G04BD04"
}, {
  CIP7: '3369562',
  CIP13: '3400933695620',
  ucdLib: "DRIPTANE 5MG CPR",
  UCD7: '9163962',
  UCD13: '3400891639629',
  ucdQtyMultiplicator: 60,
  cipLib: "DRIPTANE 5MG CPR BT 60",
  atcCode: "G04BD04"
}, {
  CIP7: '3595956',
  CIP13: '3400935959560',
  ucdLib: "OXYBUTYNINE BGA 5MG CPR",
  UCD7: '9259343',
  UCD13: '3400892593432',
  ucdQtyMultiplicator: 60,
  cipLib: "OXYBUTYNINE BGA 5MG CPR BT 60",
  atcCode: "G04BD04"
}, {
  CIP7: '3483513',
  CIP13: '3400934835131',
  ucdLib: "OXYBUTYNINE MYL 5MG CPR",
  UCD7: '9209055',
  UCD13: '3400892090559',
  ucdQtyMultiplicator: 60,
  cipLib: "OXYBUTYNINE MYL 5MG CPR BT 60",
  atcCode: "G04BD04"
}, {
  CIP7: '3595979',
  CIP13: '3400935959799',
  ucdLib: "OXYBUTYNINE TVC 5MG CPR",
  UCD7: '9239932',
  UCD13: '3400892399324',
  ucdQtyMultiplicator: 60,
  cipLib: "OXYBUTYNINE TVC 5MG CPR BT 60",
  atcCode: "G04BD04"
}, {
  CIP7: '3766702',
  CIP13: '3400937667029',
  ucdLib: "OXYBUTYNINE SDZ 5MG CPR",
  UCD7: '9291884',
  UCD13: '3400892918846',
  ucdQtyMultiplicator: 60,
  cipLib: "OXYBUTYNINE SDZ 5MG CPR BT 60",
  atcCode: "G04BD04"
}, {
  CIP7: '2671750',
  CIP13: '3400926717506',
  ucdLib: "OXYBUTYNINE ACC 5MG CPR",
  UCD7: '9389689',
  UCD13: '3400893896891',
  ucdQtyMultiplicator: 60,
  cipLib: "OXYBUTYNINE ACC 5MG CPR BT 60",
  atcCode: "G04BD04"
}, {
  CIP7: '3263409',
  CIP13: '3400932634095',
  ucdLib: "URISPAS 200MG CPR",
  UCD7: '9144574',
  UCD13: '3400891445749',
  ucdQtyMultiplicator: 42,
  cipLib: "URISPAS 200MG CPR BT 42",
  atcCode: "G04BD02"
}, {
  CIP7: '3040939',
  CIP13: '3400930409398',
  ucdLib: "FONCITRIL 4000 GLE SACH",
  UCD7: '9035939',
  UCD13: '3400890359399',
  ucdQtyMultiplicator: 30,
  cipLib: "FONCITRIL 4000 GLE SACH BT 30",
  atcCode: "G04BC"
}, {
  CIP7: '3126894',
  CIP13: '3400931268949',
  ucdLib: "ALCAPHOR BUV SOL FL250ML",
  UCD7: '9002006',
  UCD13: '3400890020060',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCAPHOR BUV SOL FL250ML BT 1",
  atcCode: "G04BC"
}, {
  CIP7: '3482726',
  CIP13: '3400934827266',
  ucdLib: "EVISTA 60MG CPR",
  UCD7: '9206387',
  UCD13: '3400892063874',
  ucdQtyMultiplicator: 28,
  cipLib: "EVISTA 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '3482732',
  CIP13: '3400934827327',
  ucdLib: "EVISTA 60MG CPR",
  UCD7: '9206387',
  UCD13: '3400892063874',
  ucdQtyMultiplicator: 84,
  cipLib: "EVISTA 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '3484843',
  CIP13: '3400934848438',
  ucdLib: "OPTRUMA 60MG CPR",
  UCD7: '9232002',
  UCD13: '3400892320021',
  ucdQtyMultiplicator: 28,
  cipLib: "OPTRUMA 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '3484866',
  CIP13: '3400934848667',
  ucdLib: "OPTRUMA 60MG CPR",
  UCD7: '9232002',
  UCD13: '3400892320021',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTRUMA 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4951011',
  CIP13: '3400949510115',
  ucdLib: "EVISTA 60MG CPR ADP ITT",
  UCD7: '9398317',
  UCD13: '3400893983171',
  ucdQtyMultiplicator: 84,
  cipLib: "EVISTA 60MG CPR ADP ITT BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4950365',
  CIP13: '3400949503650',
  ucdLib: "EVISTA 60MG CPR ADP MWI",
  UCD7: '9384663',
  UCD13: '3400893846636',
  ucdQtyMultiplicator: 28,
  cipLib: "EVISTA 60MG CPR ADP MWI BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4950371',
  CIP13: '3400949503711',
  ucdLib: "EVISTA 60MG CPR ADP MWI",
  UCD7: '9384663',
  UCD13: '3400893846636',
  ucdQtyMultiplicator: 84,
  cipLib: "EVISTA 60MG CPR ADP MWI BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4950827',
  CIP13: '3400949508273',
  ucdLib: "EVISTA 60MG CPR ADP PLA",
  UCD7: '9396241',
  UCD13: '3400893962411',
  ucdQtyMultiplicator: 28,
  cipLib: "EVISTA 60MG CPR ADP PLA BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4950833',
  CIP13: '3400949508334',
  ucdLib: "EVISTA 60MG CPR ADP PLA",
  UCD7: '9396241',
  UCD13: '3400893962411',
  ucdQtyMultiplicator: 84,
  cipLib: "EVISTA 60MG CPR ADP PLA BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4950359',
  CIP13: '3400949503599',
  ucdLib: "OPTRUMA 60MG CPR ADP MWI",
  UCD7: '9384746',
  UCD13: '3400893847466',
  ucdQtyMultiplicator: 28,
  cipLib: "OPTRUMA 60MG CPR ADP MWI BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4950388',
  CIP13: '3400949503889',
  ucdLib: "OPTRUMA 60MG CPR ADP MWI",
  UCD7: '9384746',
  UCD13: '3400893847466',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTRUMA 60MG CPR ADP MWI BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4950804',
  CIP13: '3400949508044',
  ucdLib: "OPTRUMA 60MG CPR ADP PLA",
  UCD7: '9396264',
  UCD13: '3400893962640',
  ucdQtyMultiplicator: 28,
  cipLib: "OPTRUMA 60MG CPR ADP PLA BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4950810',
  CIP13: '3400949508105',
  ucdLib: "OPTRUMA 60MG CPR ADP PLA",
  UCD7: '9396264',
  UCD13: '3400893962640',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTRUMA 60MG CPR ADP PLA BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '2218298',
  CIP13: '3400922182988',
  ucdLib: "RALOXIFENE EG 60MG CPR",
  UCD7: '9393225',
  UCD13: '3400893932254',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOXIFENE EG 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '2218312',
  CIP13: '3400922183121',
  ucdLib: "RALOXIFENE EG 60MG CPR",
  UCD7: '9393225',
  UCD13: '3400893932254',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOXIFENE EG 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '2211072',
  CIP13: '3400922110721',
  ucdLib: "RALOXIFENE SDZ 60MG CPR",
  UCD7: '9382724',
  UCD13: '3400893827246',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOXIFENE SDZ 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '2211095',
  CIP13: '3400922110950',
  ucdLib: "RALOXIFENE SDZ 60MG CPR",
  UCD7: '9382724',
  UCD13: '3400893827246',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOXIFENE SDZ 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4199524',
  CIP13: '3400941995248',
  ucdLib: "RALOPHARM 60MG CPR",
  UCD7: '9391551',
  UCD13: '3400893915516',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOPHARM 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4199547',
  CIP13: '3400941995477',
  ucdLib: "RALOPHARM 60MG CPR",
  UCD7: '9391551',
  UCD13: '3400893915516',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOPHARM 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4199470',
  CIP13: '3400941994708',
  ucdLib: "RALOXIFENE BGA 60MG CPR",
  UCD7: '9390089',
  UCD13: '3400893900895',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOXIFENE BGA 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4199493',
  CIP13: '3400941994937',
  ucdLib: "RALOXIFENE BGA 60MG CPR",
  UCD7: '9390089',
  UCD13: '3400893900895',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOXIFENE BGA 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '2749707',
  CIP13: '3400927497070',
  ucdLib: "RALOXIFENE CRT 60MG CPR",
  UCD7: '9399268',
  UCD13: '3400893992685',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOXIFENE CRT 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '2749736',
  CIP13: '3400927497360',
  ucdLib: "RALOXIFENE CRT 60MG CPR",
  UCD7: '9399268',
  UCD13: '3400893992685',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOXIFENE CRT 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4933504',
  CIP13: '3400949335046',
  ucdLib: "RALOXIFENE TVC 60MG CPR",
  UCD7: '9364235',
  UCD13: '3400893642351',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOXIFENE TVC 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4933510',
  CIP13: '3400949335107',
  ucdLib: "RALOXIFENE TVC 60MG CPR",
  UCD7: '9364235',
  UCD13: '3400893642351',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOXIFENE TVC 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4199429',
  CIP13: '3400941994296',
  ucdLib: "RALOXIFENE ZEN 60MG CPR",
  UCD7: '9393231',
  UCD13: '3400893932315',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOXIFENE ZEN 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4199441',
  CIP13: '3400941994418',
  ucdLib: "RALOXIFENE ZEN 60MG CPR",
  UCD7: '9393231',
  UCD13: '3400893932315',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOXIFENE ZEN 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '4161987',
  CIP13: '3400941619878',
  ucdLib: "RALOXIFENE MYP 60MG CPR",
  UCD7: '9372418',
  UCD13: '3400893724187',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOXIFENE MYP 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '4162001',
  CIP13: '3400941620010',
  ucdLib: "RALOXIFENE MYP 60MG CPR",
  UCD7: '9372418',
  UCD13: '3400893724187',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOXIFENE MYP 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '2771078',
  CIP13: '3400927710780',
  ucdLib: "RALOXIFENE ARW 60MG CPR",
  UCD7: '9414482',
  UCD13: '3400894144823',
  ucdQtyMultiplicator: 28,
  cipLib: "RALOXIFENE ARW 60MG CPR BT 28",
  atcCode: "G03XC01"
}, {
  CIP7: '2771109',
  CIP13: '3400927711091',
  ucdLib: "RALOXIFENE ARW 60MG CPR",
  UCD7: '9414482',
  UCD13: '3400894144823',
  ucdQtyMultiplicator: 84,
  cipLib: "RALOXIFENE ARW 60MG CPR BT 84",
  atcCode: "G03XC01"
}, {
  CIP7: '2225789',
  CIP13: '3400922257891',
  ucdLib: "ESMYA 5MG CPR",
  UCD7: '9394911',
  UCD13: '3400893949115',
  ucdQtyMultiplicator: 28,
  cipLib: "ESMYA 5MG CPR BT 28",
  atcCode: "G03XB02"
}, {
  CIP7: '3651347',
  CIP13: '3400936513471',
  ucdLib: "MIFEGYNE 200MG CPR",
  UCD7: '9138734',
  UCD13: '3400891387346',
  ucdQtyMultiplicator: 3,
  cipLib: "MIFEGYNE 200MG CPR BT 3",
  atcCode: "G03XB01"
}, {
  CIP7: '2676782',
  CIP13: '3400926767822',
  ucdLib: "MIFFEE 200MG CPR BT30",
  UCD7: '9398665',
  UCD13: '3400893986653',
  ucdQtyMultiplicator: 1,
  cipLib: "MIFFEE 200MG CPR BT30 BT 1",
  atcCode: "G03XB01"
}, {
  CIP7: '5837748',
  CIP13: '3400958377488',
  ucdLib: "MIFFEE 200MG CPR BT30",
  UCD7: '9398665',
  UCD13: '3400893986653',
  ucdQtyMultiplicator: 30,
  cipLib: "MIFFEE 200MG CPR BT30 BT 30",
  atcCode: "G03XB01"
}, {
  CIP7: '3230108',
  CIP13: '3400932301089',
  ucdLib: "DANATROL GELU",
  UCD7: '9023965',
  UCD13: '3400890239653',
  ucdQtyMultiplicator: 40,
  cipLib: "DANATROL GELU BT 40",
  atcCode: "G03XA01"
}, {
  CIP7: '3230114',
  CIP13: '3400932301140',
  ucdLib: "DANATROL GELU",
  UCD7: '9023965',
  UCD13: '3400890239653',
  ucdQtyMultiplicator: 100,
  cipLib: "DANATROL GELU BT 100",
  atcCode: "G03XA01"
}, {
  CIP7: '3450672',
  CIP13: '3400934506727',
  ucdLib: "MINERVA 35MCG CPR",
  UCD7: '9246984',
  UCD13: '3400892469843',
  ucdQtyMultiplicator: 21,
  cipLib: "MINERVA 35MCG CPR BT 21",
  atcCode: "G03HB01"
}, {
  CIP7: '3450689',
  CIP13: '3400934506895',
  ucdLib: "MINERVA 35MCG CPR",
  UCD7: '9246984',
  UCD13: '3400892469843',
  ucdQtyMultiplicator: 63,
  cipLib: "MINERVA 35MCG CPR BT 63",
  atcCode: "G03HB01"
}, {
  CIP7: '3296975',
  CIP13: '3400932969753',
  ucdLib: "DIANE 35 CPR",
  UCD7: '9121136',
  UCD13: '3400891211368',
  ucdQtyMultiplicator: 21,
  cipLib: "DIANE 35 CPR BT 21",
  atcCode: "G03HB01"
}, {
  CIP7: '3296981',
  CIP13: '3400932969814',
  ucdLib: "DIANE 35 CPR",
  UCD7: '9121136',
  UCD13: '3400891211368',
  ucdQtyMultiplicator: 63,
  cipLib: "DIANE 35 CPR BT 63",
  atcCode: "G03HB01"
}, {
  CIP7: '3436761',
  CIP13: '3400934367618',
  ucdLib: "EVEPAR 2MG/0,035MG CPR",
  UCD7: '9258496',
  UCD13: '3400892584966',
  ucdQtyMultiplicator: 21,
  cipLib: "EVEPAR 2MG/0,035MG CPR BT 21",
  atcCode: "G03HB01"
}, {
  CIP7: '3436778',
  CIP13: '3400934367786',
  ucdLib: "EVEPAR 2MG/0,035MG CPR",
  UCD7: '9258496',
  UCD13: '3400892584966',
  ucdQtyMultiplicator: 63,
  cipLib: "EVEPAR 2MG/0,035MG CPR BT 63",
  atcCode: "G03HB01"
}, {
  CIP7: '3360437',
  CIP13: '3400933604370',
  ucdLib: "CLIMENE CPR",
  UCD7: '9158346',
  UCD13: '3400891583465',
  ucdQtyMultiplicator: 21,
  cipLib: "CLIMENE CPR BT 21",
  atcCode: "G03HB01"
}, {
  CIP7: '3235100',
  CIP13: '3400932351008',
  ucdLib: "ANDROCUR 50MG CPR",
  UCD7: '9004790',
  UCD13: '3400890047906',
  ucdQtyMultiplicator: 20,
  cipLib: "ANDROCUR 50MG CPR BT 20",
  atcCode: "G03HA01"
}, {
  CIP7: '3409014',
  CIP13: '3400934090141',
  ucdLib: "CYPROTERONE MYL 50MG CPR",
  UCD7: '9184473',
  UCD13: '3400891844733',
  ucdQtyMultiplicator: 20,
  cipLib: "CYPROTERONE MYL 50MG CPR BT 20",
  atcCode: "G03HA01"
}, {
  CIP7: '3626970',
  CIP13: '3400936269705',
  ucdLib: "CYPROTERONE EG 50MG CPR",
  UCD7: '9257060',
  UCD13: '3400892570600',
  ucdQtyMultiplicator: 20,
  cipLib: "CYPROTERONE EG 50MG CPR BT 20",
  atcCode: "G03HA01"
}, {
  CIP7: '3694581',
  CIP13: '3400936945814',
  ucdLib: "CYPROTERONE EG 100MG CPR",
  UCD7: '9278441',
  UCD13: '3400892784410',
  ucdQtyMultiplicator: 60,
  cipLib: "CYPROTERONE EG 100MG CPR BT 60",
  atcCode: "G03HA01"
}, {
  CIP7: '3693529',
  CIP13: '3400936935297',
  ucdLib: "CYPROTERONE MYL 100MG CPR",
  UCD7: '9278487',
  UCD13: '3400892784878',
  ucdQtyMultiplicator: 60,
  cipLib: "CYPROTERONE MYL 100MG CPR BT 60",
  atcCode: "G03HA01"
}, {
  CIP7: '3766599',
  CIP13: '3400937665995',
  ucdLib: "CYPROTERONE SDZ 50MG CPR",
  UCD7: '9291542',
  UCD13: '3400892915425',
  ucdQtyMultiplicator: 20,
  cipLib: "CYPROTERONE SDZ 50MG CPR BT 20",
  atcCode: "G03HA01"
}, {
  CIP7: '3746651',
  CIP13: '3400937466516',
  ucdLib: "CYPROTERONE ZEN 50MG CPR",
  UCD7: '9292174',
  UCD13: '3400892921747',
  ucdQtyMultiplicator: 20,
  cipLib: "CYPROTERONE ZEN 50MG CPR BT 20",
  atcCode: "G03HA01"
}, {
  CIP7: '3820620',
  CIP13: '3400938206203',
  ucdLib: "CYPROTERONE TVC 100MG CPR",
  UCD7: '9309443',
  UCD13: '3400893094433',
  ucdQtyMultiplicator: 60,
  cipLib: "CYPROTERONE TVC 100MG CPR BT 60",
  atcCode: "G03HA01"
}, {
  CIP7: '3820525',
  CIP13: '3400938205251',
  ucdLib: "CYPROTERONE TVC 50MG CPR",
  UCD7: '9308797',
  UCD13: '3400893087978',
  ucdQtyMultiplicator: 20,
  cipLib: "CYPROTERONE TVC 50MG CPR BT 20",
  atcCode: "G03HA01"
}, {
  CIP7: '3884459',
  CIP13: '3400938844597',
  ucdLib: "CYPROTERONE ARW 100MG CPR",
  UCD7: '9323822',
  UCD13: '3400893238226',
  ucdQtyMultiplicator: 60,
  cipLib: "CYPROTERONE ARW 100MG CPR BT 60",
  atcCode: "G03HA01"
}, {
  CIP7: '3884436',
  CIP13: '3400938844368',
  ucdLib: "CYPROTERONE ARW 50MG CPR",
  UCD7: '9323839',
  UCD13: '3400893238394',
  ucdQtyMultiplicator: 20,
  cipLib: "CYPROTERONE ARW 50MG CPR BT 20",
  atcCode: "G03HA01"
}, {
  CIP7: '3750612',
  CIP13: '3400937506120',
  ucdLib: "CYPROTERONE SDZ 100MG CPR",
  UCD7: '9287724',
  UCD13: '3400892877242',
  ucdQtyMultiplicator: 60,
  cipLib: "CYPROTERONE SDZ 100MG CPR BT 60",
  atcCode: "G03HA01"
}, {
  CIP7: '4160752',
  CIP13: '3400941607523',
  ucdLib: "CYPROTERONE ZEN 100MG CPR",
  UCD7: '9371554',
  UCD13: '3400893715543',
  ucdQtyMultiplicator: 60,
  cipLib: "CYPROTERONE ZEN 100MG CPR BT 60",
  atcCode: "G03HA01"
}, {
  CIP7: '3420168',
  CIP13: '3400934201684',
  ucdLib: "CYPROTERONE BGA 100MG CPR",
  UCD7: '9290229',
  UCD13: '3400892902296',
  ucdQtyMultiplicator: 60,
  cipLib: "CYPROTERONE BGA 100MG CPR BT 60",
  atcCode: "G03HA01"
}, {
  CIP7: '3423273',
  CIP13: '3400934232732',
  ucdLib: "CYPROTERONE BGA 50MG CPR",
  UCD7: '9257516',
  UCD13: '3400892575162',
  ucdQtyMultiplicator: 20,
  cipLib: "CYPROTERONE BGA 50MG CPR BT 20",
  atcCode: "G03HA01"
}, {
  CIP7: '3262338',
  CIP13: '3400932623389',
  ucdLib: "CLOMID 50MG CPR",
  UCD7: '9020458',
  UCD13: '3400890204583',
  ucdQtyMultiplicator: 5,
  cipLib: "CLOMID 50MG CPR BT 5",
  atcCode: "G03GB02"
}, {
  CIP7: '3812193',
  CIP13: '3400938121933',
  ucdLib: "PERGOVERIS 150/75UI INJ FL+FL",
  UCD7: '9317394',
  UCD13: '3400893173947',
  ucdQtyMultiplicator: 1,
  cipLib: "PERGOVERIS 150/75UI INJ FL+FL BT 1",
  atcCode: "G03GA30"
}, {
  CIP7: '3812218',
  CIP13: '3400938122183',
  ucdLib: "PERGOVERIS 150/75UI INJ FL+FL",
  UCD7: '9317394',
  UCD13: '3400893173947',
  ucdQtyMultiplicator: 10,
  cipLib: "PERGOVERIS 150/75UI INJ FL+FL BT 10",
  atcCode: "G03GA30"
}, {
  CIP7: '3745901',
  CIP13: '3400937459013',
  ucdLib: "ELONVA 100MCG INJ SRG0,5ML",
  UCD7: '9390244',
  UCD13: '3400893902448',
  ucdQtyMultiplicator: 1,
  cipLib: "ELONVA 100MCG INJ SRG0,5ML BT 1",
  atcCode: "G03GA09"
}, {
  CIP7: '3745918',
  CIP13: '3400937459181',
  ucdLib: "ELONVA 150MCG INJ SRG0,5ML",
  UCD7: '9390250',
  UCD13: '3400893902509',
  ucdQtyMultiplicator: 1,
  cipLib: "ELONVA 150MCG INJ SRG0,5ML BT 1",
  atcCode: "G03GA09"
}, {
  CIP7: '2170947',
  CIP13: '3400921709476',
  ucdLib: "OVITRELLE 250MCG INJ STY0,5ML",
  UCD7: '9380151',
  UCD13: '3400893801512',
  ucdQtyMultiplicator: 1,
  cipLib: "OVITRELLE 250MCG INJ STY0,5ML BT 1",
  atcCode: "G03GA08"
}, {
  CIP7: '3549643',
  CIP13: '3400935496430',
  ucdLib: "LUVERIS 75UI INJ FL+FL",
  UCD7: '9234366',
  UCD13: '3400892343662',
  ucdQtyMultiplicator: 1,
  cipLib: "LUVERIS 75UI INJ FL+FL BT 1",
  atcCode: "G03GA07"
}, {
  CIP7: '3549666',
  CIP13: '3400935496669',
  ucdLib: "LUVERIS 75UI INJ FL+FL",
  UCD7: '9234366',
  UCD13: '3400892343662',
  ucdQtyMultiplicator: 3,
  cipLib: "LUVERIS 75UI INJ FL+FL BT 3",
  atcCode: "G03GA07"
}, {
  CIP7: '3530974',
  CIP13: '3400935309747',
  ucdLib: "PUREGON 300UI INJ C.0,36ML",
  UCD7: '9237413',
  UCD13: '3400892374130',
  ucdQtyMultiplicator: 1,
  cipLib: "PUREGON 300UI INJ C.0,36ML BT 1",
  atcCode: "G03GA06"
}, {
  CIP7: '3514001',
  CIP13: '3400935140012',
  ucdLib: "PUREGON 50UI INJ FL0,5ML",
  UCD7: '9213795',
  UCD13: '3400892137957',
  ucdQtyMultiplicator: 5,
  cipLib: "PUREGON 50UI INJ FL0,5ML BT 5",
  atcCode: "G03GA06"
}, {
  CIP7: '3530980',
  CIP13: '3400935309808',
  ucdLib: "PUREGON 600UI INJ C.0,72ML",
  UCD7: '9237838',
  UCD13: '3400892378381',
  ucdQtyMultiplicator: 1,
  cipLib: "PUREGON 600UI INJ C.0,72ML BT 1",
  atcCode: "G03GA06"
}, {
  CIP7: '3514030',
  CIP13: '3400935140302',
  ucdLib: "PUREGON 75UI INJ FL0,5ML",
  UCD7: '9213803',
  UCD13: '3400892138039',
  ucdQtyMultiplicator: 5,
  cipLib: "PUREGON 75UI INJ FL0,5ML BT 5",
  atcCode: "G03GA06"
}, {
  CIP7: '3651413',
  CIP13: '3400936514133',
  ucdLib: "PUREGON 900UI INJ C.1,08ML",
  UCD7: '9263391',
  UCD13: '3400892633916',
  ucdQtyMultiplicator: 1,
  cipLib: "PUREGON 900UI INJ C.1,08ML BT 1",
  atcCode: "G03GA06"
}, {
  CIP7: '3578018',
  CIP13: '3400935780188',
  ucdLib: "GONAL-F 1050UI/1,75ML FL+SRG",
  UCD7: '9247297',
  UCD13: '3400892472973',
  ucdQtyMultiplicator: 1,
  cipLib: "GONAL-F 1050UI/1,75ML FL+SRG BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '3577929',
  CIP13: '3400935779298',
  ucdLib: "GONAL-F 75UI INJ FL+SRG",
  UCD7: '9247328',
  UCD13: '3400892473284',
  ucdQtyMultiplicator: 1,
  cipLib: "GONAL-F 75UI INJ FL+SRG BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '3634797',
  CIP13: '3400936347977',
  ucdLib: "GONAL-F 300UI/0,50ML STYL.",
  UCD7: '9263468',
  UCD13: '3400892634685',
  ucdQtyMultiplicator: 1,
  cipLib: "GONAL-F 300UI/0,50ML STYL. BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '3634805',
  CIP13: '3400936348059',
  ucdLib: "GONAL-F 450UI/0,75ML STYL.",
  UCD7: '9263474',
  UCD13: '3400892634746',
  ucdQtyMultiplicator: 1,
  cipLib: "GONAL-F 450UI/0,75ML STYL. BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '3634811',
  CIP13: '3400936348110',
  ucdLib: "GONAL-F 900UI/1,5ML STYL.",
  UCD7: '9263480',
  UCD13: '3400892634807',
  ucdQtyMultiplicator: 1,
  cipLib: "GONAL-F 900UI/1,5ML STYL. BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '2793915',
  CIP13: '3400927939150',
  ucdLib: "BEMFOLA 150UI/0,25ML INJ STYL",
  UCD7: '9408613',
  UCD13: '3400894086130',
  ucdQtyMultiplicator: 1,
  cipLib: "BEMFOLA 150UI/0,25ML INJ STYL BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '2793921',
  CIP13: '3400927939211',
  ucdLib: "BEMFOLA 225UI/0,375ML INJ STY",
  UCD7: '9408636',
  UCD13: '3400894086369',
  ucdQtyMultiplicator: 1,
  cipLib: "BEMFOLA 225UI/0,375ML INJ STY BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '2793938',
  CIP13: '3400927939389',
  ucdLib: "BEMFOLA 300UI/0,50ML INJ STYL",
  UCD7: '9408642',
  UCD13: '3400894086420',
  ucdQtyMultiplicator: 1,
  cipLib: "BEMFOLA 300UI/0,50ML INJ STYL BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '2793944',
  CIP13: '3400927939440',
  ucdLib: "BEMFOLA 450UI/0,75ML INJ STYL",
  UCD7: '9408659',
  UCD13: '3400894086598',
  ucdQtyMultiplicator: 1,
  cipLib: "BEMFOLA 450UI/0,75ML INJ STYL BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '2793909',
  CIP13: '3400927939099',
  ucdLib: "BEMFOLA 75UI/0,125ML INJ STYL",
  UCD7: '9408665',
  UCD13: '3400894086659',
  ucdQtyMultiplicator: 1,
  cipLib: "BEMFOLA 75UI/0,125ML INJ STYL BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '2790302',
  CIP13: '3400927903021',
  ucdLib: "OVALEAP 300UI/0,5ML INJ CART.",
  UCD7: '9416015',
  UCD13: '3400894160151',
  ucdQtyMultiplicator: 1,
  cipLib: "OVALEAP 300UI/0,5ML INJ CART. BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '2790319',
  CIP13: '3400927903199',
  ucdLib: "OVALEAP 450UI/0,75ML INJ CART",
  UCD7: '9416021',
  UCD13: '3400894160212',
  ucdQtyMultiplicator: 1,
  cipLib: "OVALEAP 450UI/0,75ML INJ CART BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '2790325',
  CIP13: '3400927903250',
  ucdLib: "OVALEAP 900UI/1,5ML INJ CART.",
  UCD7: '9416038',
  UCD13: '3400894160380',
  ucdQtyMultiplicator: 1,
  cipLib: "OVALEAP 900UI/1,5ML INJ CART. BT 1",
  atcCode: "G03GA05"
}, {
  CIP7: '3760964',
  CIP13: '3400937609647',
  ucdLib: "FOSTIMONKIT 150UI INJ FL+SRG",
  UCD7: '9299785',
  UCD13: '3400892997858',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSTIMONKIT 150UI INJ FL+SRG BT 1",
  atcCode: "G03GA04"
}, {
  CIP7: '3760970',
  CIP13: '3400937609708',
  ucdLib: "FOSTIMONKIT 150UI INJ FL+SRG",
  UCD7: '9299785',
  UCD13: '3400892997858',
  ucdQtyMultiplicator: 5,
  cipLib: "FOSTIMONKIT 150UI INJ FL+SRG BT 5",
  atcCode: "G03GA04"
}, {
  CIP7: '3760935',
  CIP13: '3400937609357',
  ucdLib: "FOSTIMONKIT 75UI INJ FL+SRG",
  UCD7: '9299791',
  UCD13: '3400892997919',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSTIMONKIT 75UI INJ FL+SRG BT 1",
  atcCode: "G03GA04"
}, {
  CIP7: '3760941',
  CIP13: '3400937609418',
  ucdLib: "FOSTIMONKIT 75UI INJ FL+SRG",
  UCD7: '9299791',
  UCD13: '3400892997919',
  ucdQtyMultiplicator: 5,
  cipLib: "FOSTIMONKIT 75UI INJ FL+SRG BT 5",
  atcCode: "G03GA04"
}, {
  CIP7: '2743596',
  CIP13: '3400927435966',
  ucdLib: "FOSTIMONKIT 225UI INJ FL+SRG",
  UCD7: '9398613',
  UCD13: '3400893986134',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSTIMONKIT 225UI INJ FL+SRG BT 1",
  atcCode: "G03GA04"
}, {
  CIP7: '2743604',
  CIP13: '3400927436048',
  ucdLib: "FOSTIMONKIT 225UI INJ FL+SRG",
  UCD7: '9398613',
  UCD13: '3400893986134',
  ucdQtyMultiplicator: 5,
  cipLib: "FOSTIMONKIT 225UI INJ FL+SRG BT 5",
  atcCode: "G03GA04"
}, {
  CIP7: '2743610',
  CIP13: '3400927436109',
  ucdLib: "FOSTIMONKIT 300UI INJ FL+SRG",
  UCD7: '9398636',
  UCD13: '3400893986363',
  ucdQtyMultiplicator: 1,
  cipLib: "FOSTIMONKIT 300UI INJ FL+SRG BT 1",
  atcCode: "G03GA04"
}, {
  CIP7: '2743627',
  CIP13: '3400927436277',
  ucdLib: "FOSTIMONKIT 300UI INJ FL+SRG",
  UCD7: '9398636',
  UCD13: '3400893986363',
  ucdQtyMultiplicator: 5,
  cipLib: "FOSTIMONKIT 300UI INJ FL+SRG BT 5",
  atcCode: "G03GA04"
}, {
  CIP7: '3002112',
  CIP13: '3400930021125',
  ucdLib: "FERTISTARTKIT 150UI FL+SRG",
  UCD7: '9417612',
  UCD13: '3400894176121',
  ucdQtyMultiplicator: 5,
  cipLib: "FERTISTARTKIT 150UI FL+SRG BT 5",
  atcCode: "G03GA02"
}, {
  CIP7: '3002113',
  CIP13: '3400930021132',
  ucdLib: "FERTISTARTKIT 150UI FL+SRG",
  UCD7: '9417612',
  UCD13: '3400894176121',
  ucdQtyMultiplicator: 10,
  cipLib: "FERTISTARTKIT 150UI FL+SRG BT 10",
  atcCode: "G03GA02"
}, {
  CIP7: '3002109',
  CIP13: '3400930021095',
  ucdLib: "FERTISTARTKIT 75UI FL+SRG",
  UCD7: '9417629',
  UCD13: '3400894176299',
  ucdQtyMultiplicator: 5,
  cipLib: "FERTISTARTKIT 75UI FL+SRG BT 5",
  atcCode: "G03GA02"
}, {
  CIP7: '3002110',
  CIP13: '3400930021101',
  ucdLib: "FERTISTARTKIT 75UI FL+SRG",
  UCD7: '9417629',
  UCD13: '3400894176299',
  ucdQtyMultiplicator: 10,
  cipLib: "FERTISTARTKIT 75UI FL+SRG BT 10",
  atcCode: "G03GA02"
}, {
  CIP7: '3568161',
  CIP13: '3400935681614',
  ucdLib: "MENOPUR 75UI INJ FL+AMP",
  UCD7: '9235331',
  UCD13: '3400892353319',
  ucdQtyMultiplicator: 5,
  cipLib: "MENOPUR 75UI INJ FL+AMP BT 5",
  atcCode: "G03GA02"
}, {
  CIP7: '2739092',
  CIP13: '3400927390920',
  ucdLib: "MENOPUR 600UI INJ FL+SRG",
  UCD7: '9397335',
  UCD13: '3400893973356',
  ucdQtyMultiplicator: 1,
  cipLib: "MENOPUR 600UI INJ FL+SRG BT 1",
  atcCode: "G03GA02"
}, {
  CIP7: '3045842',
  CIP13: '3400930458426',
  ucdLib: "GONADOTR.CHO.ENDO 1500UI/1ML 1",
  UCD7: '9040627',
  UCD13: '3400890406277',
  ucdQtyMultiplicator: 3,
  cipLib: "GONADOTR.CHO.ENDO 1500UI/1ML 1 BT 3",
  atcCode: "G03GA01"
}, {
  CIP7: '3045807',
  CIP13: '3400930458075',
  ucdLib: "GONADOTR.CHO.ENDO 5000UI/1ML",
  UCD7: '9040656',
  UCD13: '3400890406567',
  ucdQtyMultiplicator: 1,
  cipLib: "GONADOTR.CHO.ENDO 5000UI/1ML BT 1",
  atcCode: "G03GA01"
}, {
  CIP7: '3553113',
  CIP13: '3400935531131',
  ucdLib: "FEMSEPTCOMBI 50Y/10Y/24H DISP",
  UCD7: '9229187',
  UCD13: '3400892291871',
  ucdQtyMultiplicator: 4,
  cipLib: "FEMSEPTCOMBI 50Y/10Y/24H DISP BT 4",
  atcCode: "G03FB09"
}, {
  CIP7: '3526435',
  CIP13: '3400935264350',
  ucdLib: "CLIMASTON 1MG/10MG CPR",
  UCD7: '9221530',
  UCD13: '3400892215303',
  ucdQtyMultiplicator: 28,
  cipLib: "CLIMASTON 1MG/10MG CPR BT 28",
  atcCode: "G03FB08"
}, {
  CIP7: '3438524',
  CIP13: '3400934385247',
  ucdLib: "CLIMASTON 2MG/10MG CPR",
  UCD7: '9200723',
  UCD13: '3400892007236',
  ucdQtyMultiplicator: 28,
  cipLib: "CLIMASTON 2MG/10MG CPR BT 28",
  atcCode: "G03FB08"
}, {
  CIP7: '3566038',
  CIP13: '3400935660381',
  ucdLib: "CLIMASTON 1MG/5MG CPR",
  UCD7: '9233409',
  UCD13: '3400892334097',
  ucdQtyMultiplicator: 28,
  cipLib: "CLIMASTON 1MG/5MG CPR BT 28",
  atcCode: "G03FB08"
}, {
  CIP7: '3344355',
  CIP13: '3400933443559',
  ucdLib: "DIVINA CPR",
  UCD7: '9153142',
  UCD13: '3400891531428',
  ucdQtyMultiplicator: 21,
  cipLib: "DIVINA CPR BT 21",
  atcCode: "G03FB06"
}, {
  CIP7: '3254882',
  CIP13: '3400932548828',
  ucdLib: "TRISEQUENS CPR",
  UCD7: '9095143',
  UCD13: '3400890951432',
  ucdQtyMultiplicator: 28,
  cipLib: "TRISEQUENS CPR BT 28",
  atcCode: "G03FB05"
}, {
  CIP7: '3584792',
  CIP13: '3400935847928',
  ucdLib: "NOVOFEMME CPR",
  UCD7: '9242822',
  UCD13: '3400892428222',
  ucdQtyMultiplicator: 28,
  cipLib: "NOVOFEMME CPR BT 28",
  atcCode: "G03FB05"
}, {
  CIP7: '3635029',
  CIP13: '3400936350298',
  ucdLib: "ANGELIQ 1MG/2MG CPR",
  UCD7: '9270592',
  UCD13: '3400892705927',
  ucdQtyMultiplicator: 28,
  cipLib: "ANGELIQ 1MG/2MG CPR BT 28",
  atcCode: "G03FA17"
}, {
  CIP7: '3576232',
  CIP13: '3400935762320',
  ucdLib: "CLIMODIENE 2MG/2MG CPR",
  UCD7: '9241716',
  UCD13: '3400892417165',
  ucdQtyMultiplicator: 28,
  cipLib: "CLIMODIENE 2MG/2MG CPR BT 28",
  atcCode: "G03FA15"
}, {
  CIP7: '4925640',
  CIP13: '3400949256402',
  ucdLib: "CLIMASTON 0,5MG/2,5MG CPR",
  UCD7: '9407890',
  UCD13: '3400894078906',
  ucdQtyMultiplicator: 28,
  cipLib: "CLIMASTON 0,5MG/2,5MG CPR BT 28",
  atcCode: "G03FA14"
}, {
  CIP7: '3578490',
  CIP13: '3400935784902',
  ucdLib: "DUOVA 1MG/2,5MG CPR",
  UCD7: '9235673',
  UCD13: '3400892356730',
  ucdQtyMultiplicator: 28,
  cipLib: "DUOVA 1MG/2,5MG CPR BT 28",
  atcCode: "G03FA12"
}, {
  CIP7: '3578515',
  CIP13: '3400935785152',
  ucdLib: "DUOVA 1MG/5MG CPR",
  UCD7: '9235696',
  UCD13: '3400892356969',
  ucdQtyMultiplicator: 28,
  cipLib: "DUOVA 1MG/5MG CPR BT 28",
  atcCode: "G03FA12"
}, {
  CIP7: '3578538',
  CIP13: '3400935785381',
  ucdLib: "DUOVA 2MG/5MG CPR",
  UCD7: '9235704',
  UCD13: '3400892357041',
  ucdQtyMultiplicator: 28,
  cipLib: "DUOVA 2MG/5MG CPR BT 28",
  atcCode: "G03FA12"
}, {
  CIP7: '3675945',
  CIP13: '3400936759459',
  ucdLib: "FEMSEPTEVO 50Y/7Y/24H DISP",
  UCD7: '9282655',
  UCD13: '3400892826554',
  ucdQtyMultiplicator: 4,
  cipLib: "FEMSEPTEVO 50Y/7Y/24H DISP BT 4",
  atcCode: "G03FA11"
}, {
  CIP7: '3461049',
  CIP13: '3400934610493',
  ucdLib: "FLORGYNAL GELU VAG",
  UCD7: '9215699',
  UCD13: '3400892156996',
  ucdQtyMultiplicator: 14,
  cipLib: "FLORGYNAL GELU VAG BT 14",
  atcCode: "G03FA04"
}, {
  CIP7: '3154577',
  CIP13: '3400931545774',
  ucdLib: "TROPHIGIL GELU VAG",
  UCD7: '9095410',
  UCD13: '3400890954105',
  ucdQtyMultiplicator: 14,
  cipLib: "TROPHIGIL GELU VAG BT 14",
  atcCode: "G03FA04"
}, {
  CIP7: '3314555',
  CIP13: '3400933145552',
  ucdLib: "KLIOGEST CPR",
  UCD7: '9135782',
  UCD13: '3400891357820',
  ucdQtyMultiplicator: 28,
  cipLib: "KLIOGEST CPR BT 28",
  atcCode: "G03FA01"
}, {
  CIP7: '3487994',
  CIP13: '3400934879944',
  ucdLib: "ACTIVELLE CPR",
  UCD7: '9229253',
  UCD13: '3400892292533',
  ucdQtyMultiplicator: 28,
  cipLib: "ACTIVELLE CPR BT 28",
  atcCode: "G03FA01"
}, {
  CIP7: '3471131',
  CIP13: '3400934711312',
  ucdLib: "VISANNE 2MG CPR",
  UCD7: '9387957',
  UCD13: '3400893879573',
  ucdQtyMultiplicator: 28,
  cipLib: "VISANNE 2MG CPR BT 28",
  atcCode: "G03DB08"
}, {
  CIP7: '3313314',
  CIP13: '3400933133146',
  ucdLib: "SURGESTONE 0,500MG CPR",
  UCD7: '9140978',
  UCD13: '3400891409789',
  ucdQtyMultiplicator: 10,
  cipLib: "SURGESTONE 0,500MG CPR BT 10",
  atcCode: "G03DB07"
}, {
  CIP7: '3249154',
  CIP13: '3400932491544',
  ucdLib: "SURGESTONE 0,125MG CPR",
  UCD7: '9089527',
  UCD13: '3400890895279',
  ucdQtyMultiplicator: 10,
  cipLib: "SURGESTONE 0,125MG CPR BT 10",
  atcCode: "G03DB07"
}, {
  CIP7: '3249183',
  CIP13: '3400932491834',
  ucdLib: "SURGESTONE 0,250MG CPR",
  UCD7: '9089533',
  UCD13: '3400890895330',
  ucdQtyMultiplicator: 10,
  cipLib: "SURGESTONE 0,250MG CPR BT 10",
  atcCode: "G03DB07"
}, {
  CIP7: '3364286',
  CIP13: '3400933642860',
  ucdLib: "SURGESTONE 0,500MG CPR",
  UCD7: '9140978',
  UCD13: '3400891409789',
  ucdQtyMultiplicator: 12,
  cipLib: "SURGESTONE 0,500MG CPR BT 12",
  atcCode: "G03DB07"
}, {
  CIP7: '3063320',
  CIP13: '3400930633205',
  ucdLib: "LUTERAN 5MG CPR",
  UCD7: '9055439',
  UCD13: '3400890554398',
  ucdQtyMultiplicator: 10,
  cipLib: "LUTERAN 5MG CPR BT 10",
  atcCode: "G03DB06"
}, {
  CIP7: '3394330',
  CIP13: '3400933943301',
  ucdLib: "LUTERAN 10MG CPR",
  UCD7: '9191674',
  UCD13: '3400891916744',
  ucdQtyMultiplicator: 12,
  cipLib: "LUTERAN 10MG CPR BT 12",
  atcCode: "G03DB06"
}, {
  CIP7: '3656014',
  CIP13: '3400936560147',
  ucdLib: "CHLORMADINONE SDZ 5MG CPR",
  UCD7: '9265740',
  UCD13: '3400892657400',
  ucdQtyMultiplicator: 10,
  cipLib: "CHLORMADINONE SDZ 5MG CPR BT 10",
  atcCode: "G03DB06"
}, {
  CIP7: '3656184',
  CIP13: '3400936561847',
  ucdLib: "CHLORMADINONE TVC 10MG CPR",
  UCD7: '9265119',
  UCD13: '3400892651194',
  ucdQtyMultiplicator: 12,
  cipLib: "CHLORMADINONE TVC 10MG CPR BT 12",
  atcCode: "G03DB06"
}, {
  CIP7: '3652631',
  CIP13: '3400936526310',
  ucdLib: "CHLORMADINONE TVC 5MG CPR",
  UCD7: '9265131',
  UCD13: '3400892651316',
  ucdQtyMultiplicator: 10,
  cipLib: "CHLORMADINONE TVC 5MG CPR BT 10",
  atcCode: "G03DB06"
}, {
  CIP7: '3664746',
  CIP13: '3400936647466',
  ucdLib: "CHLORMADINONE MYL 10MG CPR",
  UCD7: '9266691',
  UCD13: '3400892666914',
  ucdQtyMultiplicator: 12,
  cipLib: "CHLORMADINONE MYL 10MG CPR BT 12",
  atcCode: "G03DB06"
}, {
  CIP7: '3632798',
  CIP13: '3400936327986',
  ucdLib: "CHLORMADINONE MYL 5MG CPR",
  UCD7: '9258349',
  UCD13: '3400892583495',
  ucdQtyMultiplicator: 10,
  cipLib: "CHLORMADINONE MYL 5MG CPR BT 10",
  atcCode: "G03DB06"
}, {
  CIP7: '3664752',
  CIP13: '3400936647527',
  ucdLib: "CHLORMADINONE SDZ 10MG CPR",
  UCD7: '9267414',
  UCD13: '3400892674148',
  ucdQtyMultiplicator: 12,
  cipLib: "CHLORMADINONE SDZ 10MG CPR BT 12",
  atcCode: "G03DB06"
}, {
  CIP7: '3266112',
  CIP13: '3400932661121',
  ucdLib: "LUTENYL 5MG CPR",
  UCD7: '9103061',
  UCD13: '3400891030617',
  ucdQtyMultiplicator: 10,
  cipLib: "LUTENYL 5MG CPR BT 10",
  atcCode: "G03DB04"
}, {
  CIP7: '3655724',
  CIP13: '3400936557246',
  ucdLib: "LUTENYL 3,75MG CPR",
  UCD7: '9306350',
  UCD13: '3400893063507',
  ucdQtyMultiplicator: 14,
  cipLib: "LUTENYL 3,75MG CPR BT 14",
  atcCode: "G03DB04"
}, {
  CIP7: '3817345',
  CIP13: '3400938173451',
  ucdLib: "NOMEGESTROL BGA 5MG CPR",
  UCD7: '9307958',
  UCD13: '3400893079584',
  ucdQtyMultiplicator: 10,
  cipLib: "NOMEGESTROL BGA 5MG CPR BT 10",
  atcCode: "G03DB04"
}, {
  CIP7: '3817279',
  CIP13: '3400938172799',
  ucdLib: "NOMEGESTROL EG 5MG CPR",
  UCD7: '9306025',
  UCD13: '3400893060254',
  ucdQtyMultiplicator: 10,
  cipLib: "NOMEGESTROL EG 5MG CPR BT 10",
  atcCode: "G03DB04"
}, {
  CIP7: '3645370',
  CIP13: '3400936453708',
  ucdLib: "NOMEGESTROL MYL 5MG CPR",
  UCD7: '9262322',
  UCD13: '3400892623221',
  ucdQtyMultiplicator: 10,
  cipLib: "NOMEGESTROL MYL 5MG CPR BT 10",
  atcCode: "G03DB04"
}, {
  CIP7: '3869187',
  CIP13: '3400938691870',
  ucdLib: "NOMEGESTROL ARW 5MG CPR",
  UCD7: '9321875',
  UCD13: '3400893218754',
  ucdQtyMultiplicator: 10,
  cipLib: "NOMEGESTROL ARW 5MG CPR BT 10",
  atcCode: "G03DB04"
}, {
  CIP7: '3869253',
  CIP13: '3400938692532',
  ucdLib: "NOMEGESTROL ZEN 5MG CPR",
  UCD7: '9332459',
  UCD13: '3400893324592',
  ucdQtyMultiplicator: 10,
  cipLib: "NOMEGESTROL ZEN 5MG CPR BT 10",
  atcCode: "G03DB04"
}, {
  CIP7: '3901620',
  CIP13: '3400939016207',
  ucdLib: "NOMEGESTROL SDZ 5MG CPR",
  UCD7: '9326766',
  UCD13: '3400893267660',
  ucdQtyMultiplicator: 10,
  cipLib: "NOMEGESTROL SDZ 5MG CPR BT 10",
  atcCode: "G03DB04"
}, {
  CIP7: '3130861',
  CIP13: '3400931308614',
  ucdLib: "COLPRONE 5MG CPR",
  UCD7: '9021498',
  UCD13: '3400890214988',
  ucdQtyMultiplicator: 20,
  cipLib: "COLPRONE 5MG CPR BT 20",
  atcCode: "G03DB03"
}, {
  CIP7: '3219294',
  CIP13: '3400932192946',
  ucdLib: "DUPHASTON 10MG CPR",
  UCD7: '9102647',
  UCD13: '3400891026474',
  ucdQtyMultiplicator: 10,
  cipLib: "DUPHASTON 10MG CPR BT 10",
  atcCode: "G03DB01"
}, {
  CIP7: '3617899',
  CIP13: '3400936178991',
  ucdLib: "PROGESTERONE MYL 100MG CAPS",
  UCD7: '9251169',
  UCD13: '3400892511696',
  ucdQtyMultiplicator: 30,
  cipLib: "PROGESTERONE MYL 100MG CAPS BT 30",
  atcCode: "G03DA04"
}, {
  CIP7: '3001252',
  CIP13: '3400930012529',
  ucdLib: "CRINONE 80MG/G GEL VAG APPL",
  UCD7: '9411727',
  UCD13: '3400894117278',
  ucdQtyMultiplicator: 15,
  cipLib: "CRINONE 80MG/G GEL VAG APPL BT 15",
  atcCode: "G03DA04"
}, {
  CIP7: '3002452',
  CIP13: '3400930024522',
  ucdLib: "PROGESTERONE MYL 100MG CAPS",
  UCD7: '9251169',
  UCD13: '3400892511696',
  ucdQtyMultiplicator: 90,
  cipLib: "PROGESTERONE MYL 100MG CAPS BT 90",
  atcCode: "G03DA04"
}, {
  CIP7: '3232751',
  CIP13: '3400932327515',
  ucdLib: "UTROGESTAN 100MG CAPS MOL",
  UCD7: '9096987',
  UCD13: '3400890969871',
  ucdQtyMultiplicator: 30,
  cipLib: "UTROGESTAN 100MG CAPS MOL BT 30",
  atcCode: "G03DA04"
}, {
  CIP7: '2764397',
  CIP13: '3400927643972',
  ucdLib: "PROGIRON 25MG SOL INJ FL",
  UCD7: '9414714',
  UCD13: '3400894147145',
  ucdQtyMultiplicator: 7,
  cipLib: "PROGIRON 25MG SOL INJ FL BT 7",
  atcCode: "G03DA04"
}, {
  CIP7: '3680739',
  CIP13: '3400936807396',
  ucdLib: "PROGESTERONE SDZ 100MG CAPS",
  UCD7: '9269011',
  UCD13: '3400892690117',
  ucdQtyMultiplicator: 30,
  cipLib: "PROGESTERONE SDZ 100MG CAPS BT 30",
  atcCode: "G03DA04"
}, {
  CIP7: '3603733',
  CIP13: '3400936037335',
  ucdLib: "PROGESTERONE TVC 100MG CAPS",
  UCD7: '9247541',
  UCD13: '3400892475417',
  ucdQtyMultiplicator: 30,
  cipLib: "PROGESTERONE TVC 100MG CAPS BT 30",
  atcCode: "G03DA04"
}, {
  CIP7: '3521828',
  CIP13: '3400935218285',
  ucdLib: "ESTIMA 100MG CAPS MOL",
  UCD7: '9217623',
  UCD13: '3400892176239',
  ucdQtyMultiplicator: 30,
  cipLib: "ESTIMA 100MG CAPS MOL BT 30",
  atcCode: "G03DA04"
}, {
  CIP7: '3131412',
  CIP13: '3400931314127',
  ucdLib: "PROGESTOGEL 1% LOC GEL TB80G",
  UCD7: '9076068',
  UCD13: '3400890760683',
  ucdQtyMultiplicator: 1,
  cipLib: "PROGESTOGEL 1% LOC GEL TB80G BT 1",
  atcCode: "G03DA04"
}, {
  CIP7: '3567138',
  CIP13: '3400935671387',
  ucdLib: "ESTIMA 200MG CAPS MOL",
  UCD7: '9231416',
  UCD13: '3400892314167',
  ucdQtyMultiplicator: 15,
  cipLib: "ESTIMA 200MG CAPS MOL BT 15",
  atcCode: "G03DA04"
}, {
  CIP7: '3620884',
  CIP13: '3400936208841',
  ucdLib: "PROGESTAN 100MG CAPS MOL",
  UCD7: '9251117',
  UCD13: '3400892511177',
  ucdQtyMultiplicator: 30,
  cipLib: "PROGESTAN 100MG CAPS MOL BT 30",
  atcCode: "G03DA04"
}, {
  CIP7: '3620849',
  CIP13: '3400936208490',
  ucdLib: "PROGESTAN 200MG CAPS MOL",
  UCD7: '9251123',
  UCD13: '3400892511238',
  ucdQtyMultiplicator: 15,
  cipLib: "PROGESTAN 200MG CAPS MOL BT 15",
  atcCode: "G03DA04"
}, {
  CIP7: '3483996',
  CIP13: '3400934839962',
  ucdLib: "UTROGESTAN 200MG CAPS MOL",
  UCD7: '9221866',
  UCD13: '3400892218663',
  ucdQtyMultiplicator: 15,
  cipLib: "UTROGESTAN 200MG CAPS MOL BT 15",
  atcCode: "G03DA04"
}, {
  CIP7: '3581138',
  CIP13: '3400935811387',
  ucdLib: "PROGESTAN 100MG CAPS MOL",
  UCD7: '9251117',
  UCD13: '3400892511177',
  ucdQtyMultiplicator: 90,
  cipLib: "PROGESTAN 100MG CAPS MOL BT 90",
  atcCode: "G03DA04"
}, {
  CIP7: '3587632',
  CIP13: '3400935876324',
  ucdLib: "PROGESTAN 200MG CAPS MOL",
  UCD7: '9251123',
  UCD13: '3400892511238',
  ucdQtyMultiplicator: 45,
  cipLib: "PROGESTAN 200MG CAPS MOL BT 45",
  atcCode: "G03DA04"
}, {
  CIP7: '3580498',
  CIP13: '3400935804983',
  ucdLib: "PROGESTERONE BGA 100MG CAPS",
  UCD7: '9235288',
  UCD13: '3400892352886',
  ucdQtyMultiplicator: 30,
  cipLib: "PROGESTERONE BGA 100MG CAPS BT 30",
  atcCode: "G03DA04"
}, {
  CIP7: '3582505',
  CIP13: '3400935825056',
  ucdLib: "PROGESTERONE BGA 200MG CAPS",
  UCD7: '9236997',
  UCD13: '3400892369976',
  ucdQtyMultiplicator: 15,
  cipLib: "PROGESTERONE BGA 200MG CAPS BT 15",
  atcCode: "G03DA04"
}, {
  CIP7: '3587678',
  CIP13: '3400935876782',
  ucdLib: "UTROGESTAN 100MG CAPS MOL",
  UCD7: '9096987',
  UCD13: '3400890969871',
  ucdQtyMultiplicator: 90,
  cipLib: "UTROGESTAN 100MG CAPS MOL BT 90",
  atcCode: "G03DA04"
}, {
  CIP7: '3587684',
  CIP13: '3400935876843',
  ucdLib: "UTROGESTAN 200MG CAPS MOL",
  UCD7: '9221866',
  UCD13: '3400892218663',
  ucdQtyMultiplicator: 45,
  cipLib: "UTROGESTAN 200MG CAPS MOL BT 45",
  atcCode: "G03DA04"
}, {
  CIP7: '3741501',
  CIP13: '3400937415019',
  ucdLib: "ESTIMA 100MG CAPS MOL",
  UCD7: '9217623',
  UCD13: '3400892176239',
  ucdQtyMultiplicator: 90,
  cipLib: "ESTIMA 100MG CAPS MOL BT 90",
  atcCode: "G03DA04"
}, {
  CIP7: '3741487',
  CIP13: '3400937414876',
  ucdLib: "ESTIMA 200MG CAPS MOL",
  UCD7: '9231416',
  UCD13: '3400892314167',
  ucdQtyMultiplicator: 45,
  cipLib: "ESTIMA 200MG CAPS MOL BT 45",
  atcCode: "G03DA04"
}, {
  CIP7: '3086597',
  CIP13: '3400930865972',
  ucdLib: "PROGESTERONE RET.PHARL.500MG",
  UCD7: '9076051',
  UCD13: '3400890760515',
  ucdQtyMultiplicator: 3,
  cipLib: "PROGESTERONE RET.PHARL.500MG BT 3",
  atcCode: "G03DA03"
}, {
  CIP7: '3543586',
  CIP13: '3400935435866',
  ucdLib: "LIVIAL 2,5MG CPR",
  UCD7: '9221091',
  UCD13: '3400892210919',
  ucdQtyMultiplicator: 28,
  cipLib: "LIVIAL 2,5MG CPR BT 28",
  atcCode: "G03CX01"
}, {
  CIP7: '4900023',
  CIP13: '3400949000234',
  ucdLib: "LIVIAL 2,5MG CPR AIP BBA UK",
  UCD7: '9413867',
  UCD13: '3400894138679',
  ucdQtyMultiplicator: 28,
  cipLib: "LIVIAL 2,5MG CPR AIP BBA UK BT 28",
  atcCode: "G03CX01"
}, {
  CIP7: '4902030',
  CIP13: '3400949020300',
  ucdLib: "LIVIAL 2,5MG CPR AIP MWI UK",
  UCD7: '9397855',
  UCD13: '3400893978559',
  ucdQtyMultiplicator: 28,
  cipLib: "LIVIAL 2,5MG CPR AIP MWI UK BT 28",
  atcCode: "G03CX01"
}, {
  CIP7: '3000921',
  CIP13: '3400930009215',
  ucdLib: "DUAVIVE 0,45MG/20MG CPR LM",
  UCD7: '9417693',
  UCD13: '3400894176930',
  ucdQtyMultiplicator: 28,
  cipLib: "DUAVIVE 0,45MG/20MG CPR LM BT 28",
  atcCode: "G03CC07"
}, {
  CIP7: '3213682',
  CIP13: '3400932136827',
  ucdLib: "DISTILBENE 1MG GERDA CPR",
  UCD7: '9027928',
  UCD13: '3400890279284',
  ucdQtyMultiplicator: 26,
  cipLib: "DISTILBENE 1MG GERDA CPR BT 26",
  atcCode: "G03CB02"
}, {
  CIP7: '3199410',
  CIP13: '3400931994107',
  ucdLib: "COLPOTROPHINE 1% CR TB30G",
  UCD7: '9021481',
  UCD13: '3400890214810',
  ucdQtyMultiplicator: 1,
  cipLib: "COLPOTROPHINE 1% CR TB30G BT 1",
  atcCode: "G03CA09"
}, {
  CIP7: '3162329',
  CIP13: '3400931623298',
  ucdLib: "COLPOTROPHINE CAPS VAG",
  UCD7: '9021475',
  UCD13: '3400890214759',
  ucdQtyMultiplicator: 20,
  cipLib: "COLPOTROPHINE CAPS VAG BT 20",
  atcCode: "G03CA09"
}, {
  CIP7: '3296917',
  CIP13: '3400932969173',
  ucdLib: "PHYSIOGINE 0,1% CR VAG TB15G",
  UCD7: '9135894',
  UCD13: '3400891358940',
  ucdQtyMultiplicator: 1,
  cipLib: "PHYSIOGINE 0,1% CR VAG TB15G BT 1",
  atcCode: "G03CA04"
}, {
  CIP7: '3296900',
  CIP13: '3400932969005',
  ucdLib: "PHYSIOGINE 0,5MG OV",
  UCD7: '9135902',
  UCD13: '3400891359022',
  ucdQtyMultiplicator: 15,
  cipLib: "PHYSIOGINE 0,5MG OV BT 15",
  atcCode: "G03CA04"
}, {
  CIP7: '3295533',
  CIP13: '3400932955336',
  ucdLib: "TROPHICREME 0,1% CR VAG TB30G",
  UCD7: '9125855',
  UCD13: '3400891258554',
  ucdQtyMultiplicator: 1,
  cipLib: "TROPHICREME 0,1% CR VAG TB30G BT 1",
  atcCode: "G03CA04"
}, {
  CIP7: '3412594',
  CIP13: '3400934125942',
  ucdLib: "GYDRELLE 0,1% CR VAG TB30G",
  UCD7: '9195264',
  UCD13: '3400891952643',
  ucdQtyMultiplicator: 1,
  cipLib: "GYDRELLE 0,1% CR VAG TB30G BT 1",
  atcCode: "G03CA04"
}, {
  CIP7: '3382634',
  CIP13: '3400933826345',
  ucdLib: "PHYSIOGINE 1MG CPR",
  UCD7: '9184958',
  UCD13: '3400891849585',
  ucdQtyMultiplicator: 30,
  cipLib: "PHYSIOGINE 1MG CPR BT 30",
  atcCode: "G03CA04"
}, {
  CIP7: '3254876',
  CIP13: '3400932548767',
  ucdLib: "ESTROFEM 2MG CPR",
  UCD7: '9032875',
  UCD13: '3400890328753',
  ucdQtyMultiplicator: 28,
  cipLib: "ESTROFEM 2MG CPR BT 28",
  atcCode: "G03CA03"
}, {
  CIP7: '3409037',
  CIP13: '3400934090370',
  ucdLib: "DERMESTRIL 100MCG/24H DISP",
  UCD7: '9187738',
  UCD13: '3400891877380',
  ucdQtyMultiplicator: 8,
  cipLib: "DERMESTRIL 100MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3409066',
  CIP13: '3400934090660',
  ucdLib: "DERMESTRIL 25MCG/24H DISP",
  UCD7: '9187744',
  UCD13: '3400891877441',
  ucdQtyMultiplicator: 8,
  cipLib: "DERMESTRIL 25MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3409043',
  CIP13: '3400934090431',
  ucdLib: "DERMESTRIL 50MCG/24H DISP",
  UCD7: '9187750',
  UCD13: '3400891877502',
  ucdQtyMultiplicator: 8,
  cipLib: "DERMESTRIL 50MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3523939',
  CIP13: '3400935239396',
  ucdLib: "DERMESTRIL SEPTEM 25Y/24H DIS",
  UCD7: '9219349',
  UCD13: '3400892193496',
  ucdQtyMultiplicator: 4,
  cipLib: "DERMESTRIL SEPTEM 25Y/24H DIS BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3523916',
  CIP13: '3400935239167',
  ucdLib: "DERMESTRIL SEPTEM 50Y/24H DIS",
  UCD7: '9219355',
  UCD13: '3400892193557',
  ucdQtyMultiplicator: 4,
  cipLib: "DERMESTRIL SEPTEM 50Y/24H DIS BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3523951',
  CIP13: '3400935239518',
  ucdLib: "DERMESTRIL SEPTEM 75Y/24H DIS",
  UCD7: '9219361',
  UCD13: '3400892193618',
  ucdQtyMultiplicator: 4,
  cipLib: "DERMESTRIL SEPTEM 75Y/24H DIS BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3409072',
  CIP13: '3400934090721',
  ucdLib: "THAIS 100MCG/24H DISP",
  UCD7: '9196855',
  UCD13: '3400891968552',
  ucdQtyMultiplicator: 8,
  cipLib: "THAIS 100MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3409095',
  CIP13: '3400934090950',
  ucdLib: "THAIS 25MCG/24H DISP",
  UCD7: '9196861',
  UCD13: '3400891968613',
  ucdQtyMultiplicator: 8,
  cipLib: "THAIS 25MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3409089',
  CIP13: '3400934090899',
  ucdLib: "THAIS 50MCG/24H DISP",
  UCD7: '9196878',
  UCD13: '3400891968781',
  ucdQtyMultiplicator: 8,
  cipLib: "THAIS 50MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3523974',
  CIP13: '3400935239747',
  ucdLib: "THAIS SEPT 25MCG/24H DISP",
  UCD7: '9219473',
  UCD13: '3400892194738',
  ucdQtyMultiplicator: 4,
  cipLib: "THAIS SEPT 25MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3523997',
  CIP13: '3400935239976',
  ucdLib: "THAIS SEPT 50MCG/24H DISP",
  UCD7: '9219496',
  UCD13: '3400892194967',
  ucdQtyMultiplicator: 4,
  cipLib: "THAIS SEPT 50MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3524011',
  CIP13: '3400935240118',
  ucdLib: "THAIS SEPT 75MCG/24H DISP",
  UCD7: '9219504',
  UCD13: '3400892195049',
  ucdQtyMultiplicator: 4,
  cipLib: "THAIS SEPT 75MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3566512',
  CIP13: '3400935665126',
  ucdLib: "ESTRAPATCH 40MCG/24H DISP",
  UCD7: '9234490',
  UCD13: '3400892344904',
  ucdQtyMultiplicator: 4,
  cipLib: "ESTRAPATCH 40MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3566506',
  CIP13: '3400935665065',
  ucdLib: "ESTRAPATCH 60MCG/24H DISP",
  UCD7: '9234509',
  UCD13: '3400892345093',
  ucdQtyMultiplicator: 4,
  cipLib: "ESTRAPATCH 60MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3391308',
  CIP13: '3400933913083',
  ucdLib: "ESTREVA GEL FL-DOS 50G",
  UCD7: '9178834',
  UCD13: '3400891788341',
  ucdQtyMultiplicator: 1,
  cipLib: "ESTREVA GEL FL-DOS 50G BT 1",
  atcCode: "G03CA03"
}, {
  CIP7: '3396317',
  CIP13: '3400933963170',
  ucdLib: "ESTROFEM 1MG CPR",
  UCD7: '9180914',
  UCD13: '3400891809145',
  ucdQtyMultiplicator: 28,
  cipLib: "ESTROFEM 1MG CPR BT 28",
  atcCode: "G03CA03"
}, {
  CIP7: '3595465',
  CIP13: '3400935954657',
  ucdLib: "ESTRAPATCH 80MCG/24H DISP",
  UCD7: '9249445',
  UCD13: '3400892494456',
  ucdQtyMultiplicator: 4,
  cipLib: "ESTRAPATCH 80MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3511675',
  CIP13: '3400935116758',
  ucdLib: "OROMONE 1MG CPR",
  UCD7: '9220341',
  UCD13: '3400892203416',
  ucdQtyMultiplicator: 28,
  cipLib: "OROMONE 1MG CPR BT 28",
  atcCode: "G03CA03"
}, {
  CIP7: '3655747',
  CIP13: '3400936557475',
  ucdLib: "VIVELLEDOT 25MCG/24H DISP",
  UCD7: '9286191',
  UCD13: '3400892861913',
  ucdQtyMultiplicator: 8,
  cipLib: "VIVELLEDOT 25MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3461055',
  CIP13: '3400934610554',
  ucdLib: "FEMSEPT 100MCG/24H DISP",
  UCD7: '9203130',
  UCD13: '3400892031309',
  ucdQtyMultiplicator: 4,
  cipLib: "FEMSEPT 100MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3461078',
  CIP13: '3400934610783',
  ucdLib: "FEMSEPT 50MCG/24H DISP",
  UCD7: '9203147',
  UCD13: '3400892031477',
  ucdQtyMultiplicator: 4,
  cipLib: "FEMSEPT 50MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3461061',
  CIP13: '3400934610615',
  ucdLib: "FEMSEPT 75MCG/24H DISP",
  UCD7: '9203153',
  UCD13: '3400892031538',
  ucdQtyMultiplicator: 4,
  cipLib: "FEMSEPT 75MCG/24H DISP BT 4",
  atcCode: "G03CA03"
}, {
  CIP7: '3189156',
  CIP13: '3400931891567',
  ucdLib: "PROGYNOVA 1MG CPR",
  UCD7: '9168267',
  UCD13: '3400891682670',
  ucdQtyMultiplicator: 20,
  cipLib: "PROGYNOVA 1MG CPR BT 20",
  atcCode: "G03CA03"
}, {
  CIP7: '3189222',
  CIP13: '3400931892229',
  ucdLib: "PROGYNOVA 2MG CPR",
  UCD7: '9076105',
  UCD13: '3400890761055',
  ucdQtyMultiplicator: 20,
  cipLib: "PROGYNOVA 2MG CPR BT 20",
  atcCode: "G03CA03"
}, {
  CIP7: '3189239',
  CIP13: '3400931892397',
  ucdLib: "PROGYNOVA 2MG CPR",
  UCD7: '9076105',
  UCD13: '3400890761055',
  ucdQtyMultiplicator: 60,
  cipLib: "PROGYNOVA 2MG CPR BT 60",
  atcCode: "G03CA03"
}, {
  CIP7: '3466667',
  CIP13: '3400934666674',
  ucdLib: "PROVAMES 1MG CPR",
  UCD7: '9205063',
  UCD13: '3400892050638',
  ucdQtyMultiplicator: 30,
  cipLib: "PROVAMES 1MG CPR BT 30",
  atcCode: "G03CA03"
}, {
  CIP7: '3547934',
  CIP13: '3400935479341',
  ucdLib: "PROVAMES 2MG CPR",
  UCD7: '9169491',
  UCD13: '3400891694918',
  ucdQtyMultiplicator: 28,
  cipLib: "PROVAMES 2MG CPR BT 28",
  atcCode: "G03CA03"
}, {
  CIP7: '3585900',
  CIP13: '3400935859006',
  ucdLib: "VIVELLEDOT 100MCG/24H DISP",
  UCD7: '9262836',
  UCD13: '3400892628363',
  ucdQtyMultiplicator: 8,
  cipLib: "VIVELLEDOT 100MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3585805',
  CIP13: '3400935858054',
  ucdLib: "VIVELLEDOT 37,5MCG/24H DISP",
  UCD7: '9262842',
  UCD13: '3400892628424',
  ucdQtyMultiplicator: 8,
  cipLib: "VIVELLEDOT 37,5MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3585834',
  CIP13: '3400935858344',
  ucdLib: "VIVELLEDOT 50MCG/24H DISP",
  UCD7: '9262859',
  UCD13: '3400892628592',
  ucdQtyMultiplicator: 8,
  cipLib: "VIVELLEDOT 50MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3585863',
  CIP13: '3400935858634',
  ucdLib: "VIVELLEDOT 75MCG/24H DISP",
  UCD7: '9262865',
  UCD13: '3400892628653',
  ucdQtyMultiplicator: 8,
  cipLib: "VIVELLEDOT 75MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3381126',
  CIP13: '3400933811266',
  ucdLib: "OESCLIM 25MCG/24H DISP",
  UCD7: '9170910',
  UCD13: '3400891709100',
  ucdQtyMultiplicator: 8,
  cipLib: "OESCLIM 25MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3381184',
  CIP13: '3400933811846',
  ucdLib: "OESCLIM 50MCG/24H DISP",
  UCD7: '9170927',
  UCD13: '3400891709278',
  ucdQtyMultiplicator: 8,
  cipLib: "OESCLIM 50MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '3382924',
  CIP13: '3400933829247',
  ucdLib: "OESTRODOSE 0,06% GEL LOC FL80G",
  UCD7: '9171714',
  UCD13: '3400891717143',
  ucdQtyMultiplicator: 1,
  cipLib: "OESTRODOSE 0,06% GEL LOC FL80G BT 1",
  atcCode: "G03CA03"
}, {
  CIP7: '3446682',
  CIP13: '3400934466823',
  ucdLib: "OESCLIM 37,5MCG/24H DISP",
  UCD7: '9200611',
  UCD13: '3400892006116',
  ucdQtyMultiplicator: 8,
  cipLib: "OESCLIM 37,5MCG/24H DISP BT 8",
  atcCode: "G03CA03"
}, {
  CIP7: '2756618',
  CIP13: '3400927566189',
  ucdLib: "ESTRING 2MG SYST DIFF VAG",
  UCD7: '9420293',
  UCD13: '3400894202936',
  ucdQtyMultiplicator: 1,
  cipLib: "ESTRING 2MG SYST DIFF VAG BT 1",
  atcCode: "G03CA03"
}, {
  CIP7: '3424019',
  CIP13: '3400934240195',
  ucdLib: "DELIDOSE 0,5MG GEL SACH0,5G",
  UCD7: '9217066',
  UCD13: '3400892170664',
  ucdQtyMultiplicator: 28,
  cipLib: "DELIDOSE 0,5MG GEL SACH0,5G BT 28",
  atcCode: "G03CA03"
}, {
  CIP7: '3423994',
  CIP13: '3400934239946',
  ucdLib: "DELIDOSE 1MG GEL SACH",
  UCD7: '9217072',
  UCD13: '3400892170725',
  ucdQtyMultiplicator: 28,
  cipLib: "DELIDOSE 1MG GEL SACH BT 28",
  atcCode: "G03CA03"
}, {
  CIP7: '3424367',
  CIP13: '3400934243677',
  ucdLib: "OROMONE 2MG CPR",
  UCD7: '9155856',
  UCD13: '3400891558562',
  ucdQtyMultiplicator: 28,
  cipLib: "OROMONE 2MG CPR BT 28",
  atcCode: "G03CA03"
}, {
  CIP7: '3517531',
  CIP13: '3400935175311',
  ucdLib: "ETHINYL-OEST. EFK 50MCG CPR",
  UCD7: '9213306',
  UCD13: '3400892133065',
  ucdQtyMultiplicator: 15,
  cipLib: "ETHINYL-OEST. EFK 50MCG CPR BT 15",
  atcCode: "G03CA01"
}, {
  CIP7: '3242873',
  CIP13: '3400932428731',
  ucdLib: "ANDRACTIM LOC GEL TB80G",
  UCD7: '9004784',
  UCD13: '3400890047845',
  ucdQtyMultiplicator: 1,
  cipLib: "ANDRACTIM LOC GEL TB80G BT 1",
  atcCode: "G03BB02"
}, {
  CIP7: '3004613',
  CIP13: '3400930046135',
  ucdLib: "ANDROTARDYL 250MG IM AMP1ML",
  UCD7: '9004815',
  UCD13: '3400890048156',
  ucdQtyMultiplicator: 1,
  cipLib: "ANDROTARDYL 250MG IM AMP1ML BT 1",
  atcCode: "G03BA03"
}, {
  CIP7: '3575362',
  CIP13: '3400935753625',
  ucdLib: "ANDROGEL 25MG GEL SACH",
  UCD7: '9238111',
  UCD13: '3400892381114',
  ucdQtyMultiplicator: 30,
  cipLib: "ANDROGEL 25MG GEL SACH BT 30",
  atcCode: "G03BA03"
}, {
  CIP7: '3575385',
  CIP13: '3400935753854',
  ucdLib: "ANDROGEL 50MG GEL SACH",
  UCD7: '9238128',
  UCD13: '3400892381282',
  ucdQtyMultiplicator: 30,
  cipLib: "ANDROGEL 50MG GEL SACH BT 30",
  atcCode: "G03BA03"
}, {
  CIP7: '3775724',
  CIP13: '3400937757249',
  ucdLib: "FORTIGEL 2% GEL FL60G",
  UCD7: '9301499',
  UCD13: '3400893014998',
  ucdQtyMultiplicator: 1,
  cipLib: "FORTIGEL 2% GEL FL60G BT 1",
  atcCode: "G03BA03"
}, {
  CIP7: '3776480',
  CIP13: '3400937764803',
  ucdLib: "PANTESTONE 40MG CAPS MOL",
  UCD7: '9122897',
  UCD13: '3400891228977',
  ucdQtyMultiplicator: 60,
  cipLib: "PANTESTONE 40MG CAPS MOL BT 60",
  atcCode: "G03BA03"
}, {
  CIP7: '2771345',
  CIP13: '3400927713453',
  ucdLib: "NEBIDO 1000MG/4ML INJ FL4ML",
  UCD7: '9408346',
  UCD13: '3400894083467',
  ucdQtyMultiplicator: 1,
  cipLib: "NEBIDO 1000MG/4ML INJ FL4ML BT 1",
  atcCode: "G03BA03"
}, {
  CIP7: '3945037',
  CIP13: '3400939450377',
  ucdLib: "ELLAONE 30MG CPR",
  UCD7: '9339220',
  UCD13: '3400893392201',
  ucdQtyMultiplicator: 1,
  cipLib: "ELLAONE 30MG CPR BT 1",
  atcCode: "G03AD02"
}, {
  CIP7: '3000094',
  CIP13: '3400930000946',
  ucdLib: "LEVOSOLO 1500MCG CPR",
  UCD7: '9421499',
  UCD13: '3400894214991',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVOSOLO 1500MCG CPR BT 1",
  atcCode: "G03AD01"
}, {
  CIP7: '2762300',
  CIP13: '3400927623004',
  ucdLib: "LEVONORGESTREL MYL 1,5MG CP",
  UCD7: '9399699',
  UCD13: '3400893996997',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVONORGESTREL MYL 1,5MG CP BT 1",
  atcCode: "G03AD01"
}, {
  CIP7: '3641372',
  CIP13: '3400936413726',
  ucdLib: "NORLEVO 1,5MG CPR",
  UCD7: '9262658',
  UCD13: '3400892626581',
  ucdQtyMultiplicator: 1,
  cipLib: "NORLEVO 1,5MG CPR BT 1",
  atcCode: "G03AD01"
}, {
  CIP7: '3730756',
  CIP13: '3400937307567',
  ucdLib: "LEVONORGESTREL BGA 1500Y CPR",
  UCD7: '9302955',
  UCD13: '3400893029558',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVONORGESTREL BGA 1500Y CPR BT 1",
  atcCode: "G03AD01"
}, {
  CIP7: '2781059',
  CIP13: '3400927810596',
  ucdLib: "LEVONORGESTREL EG 1,5MG CPR",
  UCD7: '9417807',
  UCD13: '3400894178071',
  ucdQtyMultiplicator: 1,
  cipLib: "LEVONORGESTREL EG 1,5MG CPR BT 1",
  atcCode: "G03AD01"
}, {
  CIP7: '3529020',
  CIP13: '3400935290205',
  ucdLib: "CERAZETTE 0,075MG CPR",
  UCD7: '9220507',
  UCD13: '3400892205076',
  ucdQtyMultiplicator: 28,
  cipLib: "CERAZETTE 0,075MG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '3529037',
  CIP13: '3400935290373',
  ucdLib: "CERAZETTE 0,075MG CPR",
  UCD7: '9220507',
  UCD13: '3400892205076',
  ucdQtyMultiplicator: 84,
  cipLib: "CERAZETTE 0,075MG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '4191830',
  CIP13: '3400941918308',
  ucdLib: "CLAREAL 0,075MG CPR",
  UCD7: '9378303',
  UCD13: '3400893783030',
  ucdQtyMultiplicator: 28,
  cipLib: "CLAREAL 0,075MG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '4191847',
  CIP13: '3400941918476',
  ucdLib: "CLAREAL 0,075MG CPR",
  UCD7: '9378303',
  UCD13: '3400893783030',
  ucdQtyMultiplicator: 84,
  cipLib: "CLAREAL 0,075MG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2695466',
  CIP13: '3400926954666',
  ucdLib: "DESOGESTREL EG 0,075MG CPR",
  UCD7: '9394555',
  UCD13: '3400893945551',
  ucdQtyMultiplicator: 28,
  cipLib: "DESOGESTREL EG 0,075MG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '2695472',
  CIP13: '3400926954727',
  ucdLib: "DESOGESTREL EG 0,075MG CPR",
  UCD7: '9394555',
  UCD13: '3400893945551',
  ucdQtyMultiplicator: 84,
  cipLib: "DESOGESTREL EG 0,075MG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '4191244',
  CIP13: '3400941912443',
  ucdLib: "DESOGESTREL ZEN 75MCG CPR",
  UCD7: '9378349',
  UCD13: '3400893783498',
  ucdQtyMultiplicator: 28,
  cipLib: "DESOGESTREL ZEN 75MCG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '4191267',
  CIP13: '3400941912672',
  ucdLib: "DESOGESTREL ZEN 75MCG CPR",
  UCD7: '9378349',
  UCD13: '3400893783498',
  ucdQtyMultiplicator: 84,
  cipLib: "DESOGESTREL ZEN 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2742160',
  CIP13: '3400927421600',
  ucdLib: "LACTINETTE 75MCG CPR",
  UCD7: '9420330',
  UCD13: '3400894203308',
  ucdQtyMultiplicator: 28,
  cipLib: "LACTINETTE 75MCG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '2742177',
  CIP13: '3400927421778',
  ucdLib: "LACTINETTE 75MCG CPR",
  UCD7: '9420330',
  UCD13: '3400894203308',
  ucdQtyMultiplicator: 84,
  cipLib: "LACTINETTE 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2740681',
  CIP13: '3400927406812',
  ucdLib: "OPTIMIZETTE 75MCG CPR",
  UCD7: '9403366',
  UCD13: '3400894033660',
  ucdQtyMultiplicator: 28,
  cipLib: "OPTIMIZETTE 75MCG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '2740698',
  CIP13: '3400927406980',
  ucdLib: "OPTIMIZETTE 75MCG CPR",
  UCD7: '9403366',
  UCD13: '3400894033660',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTIMIZETTE 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2247414',
  CIP13: '3400922474144',
  ucdLib: "ANTIGONE 75MCG CPR",
  UCD7: '9389867',
  UCD13: '3400893898673',
  ucdQtyMultiplicator: 28,
  cipLib: "ANTIGONE 75MCG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '2247420',
  CIP13: '3400922474205',
  ucdLib: "ANTIGONE 75MCG CPR",
  UCD7: '9389867',
  UCD13: '3400893898673',
  ucdQtyMultiplicator: 56,
  cipLib: "ANTIGONE 75MCG CPR BT 56",
  atcCode: "G03AC09"
}, {
  CIP7: '2247437',
  CIP13: '3400922474373',
  ucdLib: "ANTIGONE 75MCG CPR",
  UCD7: '9389867',
  UCD13: '3400893898673',
  ucdQtyMultiplicator: 84,
  cipLib: "ANTIGONE 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2166101',
  CIP13: '3400921661019',
  ucdLib: "DESOGESTREL ARW 75MCG CPR",
  UCD7: '9389896',
  UCD13: '3400893898963',
  ucdQtyMultiplicator: 28,
  cipLib: "DESOGESTREL ARW 75MCG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '2166118',
  CIP13: '3400921661187',
  ucdLib: "DESOGESTREL ARW 75MCG CPR",
  UCD7: '9389896',
  UCD13: '3400893898963',
  ucdQtyMultiplicator: 84,
  cipLib: "DESOGESTREL ARW 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2673648',
  CIP13: '3400926736484',
  ucdLib: "DESOGESTREL BGA 75MCG CPR",
  UCD7: '9389790',
  UCD13: '3400893897904',
  ucdQtyMultiplicator: 28,
  cipLib: "DESOGESTREL BGA 75MCG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '2673654',
  CIP13: '3400926736545',
  ucdLib: "DESOGESTREL BGA 75MCG CPR",
  UCD7: '9389790',
  UCD13: '3400893897904',
  ucdQtyMultiplicator: 84,
  cipLib: "DESOGESTREL BGA 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2166147',
  CIP13: '3400921661477',
  ucdLib: "DESOGESTREL MYL 75MCG CPR",
  UCD7: '9389873',
  UCD13: '3400893898734',
  ucdQtyMultiplicator: 28,
  cipLib: "DESOGESTREL MYL 75MCG CPR BT 28",
  atcCode: "G03AC09"
}, {
  CIP7: '2166153',
  CIP13: '3400921661538',
  ucdLib: "DESOGESTREL MYL 75MCG CPR",
  UCD7: '9389873',
  UCD13: '3400893898734',
  ucdQtyMultiplicator: 84,
  cipLib: "DESOGESTREL MYL 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2166070',
  CIP13: '3400921660708',
  ucdLib: "DESOGESTREL TVC 75MCG CPR",
  UCD7: '9385958',
  UCD13: '3400893859582',
  ucdQtyMultiplicator: 84,
  cipLib: "DESOGESTREL TVC 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '2680826',
  CIP13: '3400926808266',
  ucdLib: "DESOPOP 75MCG CPR",
  UCD7: '9392562',
  UCD13: '3400893925621',
  ucdQtyMultiplicator: 84,
  cipLib: "DESOPOP 75MCG CPR BT 84",
  atcCode: "G03AC09"
}, {
  CIP7: '3515443',
  CIP13: '3400935154439',
  ucdLib: "NEXPLANON 68MG IMPL SC",
  UCD7: '9222848',
  UCD13: '3400892228488',
  ucdQtyMultiplicator: 1,
  cipLib: "NEXPLANON 68MG IMPL SC BT 1",
  atcCode: "G03AC08"
}, {
  CIP7: '3238699',
  CIP13: '3400932386994',
  ucdLib: "DEPO-PROVERA 150MG INJ FL3ML",
  UCD7: '9025125',
  UCD13: '3400890251259',
  ucdQtyMultiplicator: 1,
  cipLib: "DEPO-PROVERA 150MG INJ FL3ML BT 1",
  atcCode: "G03AC06"
}, {
  CIP7: '3220067',
  CIP13: '3400932200672',
  ucdLib: "MICROVAL CPR",
  UCD7: '9058834',
  UCD13: '3400890588348',
  ucdQtyMultiplicator: 28,
  cipLib: "MICROVAL CPR BT 28",
  atcCode: "G03AC03"
}, {
  CIP7: '3220073',
  CIP13: '3400932200733',
  ucdLib: "MICROVAL CPR",
  UCD7: '9058834',
  UCD13: '3400890588348',
  ucdQtyMultiplicator: 84,
  cipLib: "MICROVAL CPR BT 84",
  atcCode: "G03AC03"
}, {
  CIP7: '3909484',
  CIP13: '3400939094847',
  ucdLib: "QLAIRA CPR",
  UCD7: '9333074',
  UCD13: '3400893330746',
  ucdQtyMultiplicator: 28,
  cipLib: "QLAIRA CPR BT 28",
  atcCode: "G03AB08"
}, {
  CIP7: '3909490',
  CIP13: '3400939094908',
  ucdLib: "QLAIRA CPR",
  UCD7: '9333074',
  UCD13: '3400893330746',
  ucdQtyMultiplicator: 84,
  cipLib: "QLAIRA CPR BT 84",
  atcCode: "G03AB08"
}, {
  CIP7: '3004510',
  CIP13: '3400930045107',
  ucdLib: "TRI-MINULET CPR A/D",
  UCD7: '9418942',
  UCD13: '3400894189428',
  ucdQtyMultiplicator: 21,
  cipLib: "TRI-MINULET CPR A/D BT 21",
  atcCode: "G03AB06"
}, {
  CIP7: '3004511',
  CIP13: '3400930045114',
  ucdLib: "TRI-MINULET CPR A/D",
  UCD7: '9418942',
  UCD13: '3400894189428',
  ucdQtyMultiplicator: 63,
  cipLib: "TRI-MINULET CPR A/D BT 63",
  atcCode: "G03AB06"
}, {
  CIP7: '3715811',
  CIP13: '3400937158114',
  ucdLib: "PERLEANE CPR",
  UCD7: '9285524',
  UCD13: '3400892855240',
  ucdQtyMultiplicator: 21,
  cipLib: "PERLEANE CPR BT 21",
  atcCode: "G03AB06"
}, {
  CIP7: '3715828',
  CIP13: '3400937158282',
  ucdLib: "PERLEANE CPR",
  UCD7: '9285524',
  UCD13: '3400892855240',
  ucdQtyMultiplicator: 63,
  cipLib: "PERLEANE CPR BT 63",
  atcCode: "G03AB06"
}, {
  CIP7: '3254913',
  CIP13: '3400932549139',
  ucdLib: "TRIELLA CPR",
  UCD7: '9094787',
  UCD13: '3400890947879',
  ucdQtyMultiplicator: 21,
  cipLib: "TRIELLA CPR BT 21",
  atcCode: "G03AB04"
}, {
  CIP7: '3254936',
  CIP13: '3400932549368',
  ucdLib: "TRIELLA CPR",
  UCD7: '9094787',
  UCD13: '3400890947879',
  ucdQtyMultiplicator: 63,
  cipLib: "TRIELLA CPR BT 63",
  atcCode: "G03AB04"
}, {
  CIP7: '3280709',
  CIP13: '3400932807093',
  ucdLib: "TRINORDIOL CPR",
  UCD7: '9107136',
  UCD13: '3400891071368',
  ucdQtyMultiplicator: 21,
  cipLib: "TRINORDIOL CPR BT 21",
  atcCode: "G03AB03"
}, {
  CIP7: '3280715',
  CIP13: '3400932807154',
  ucdLib: "TRINORDIOL CPR",
  UCD7: '9107136',
  UCD13: '3400891071368',
  ucdQtyMultiplicator: 63,
  cipLib: "TRINORDIOL CPR BT 63",
  atcCode: "G03AB03"
}, {
  CIP7: '3184064',
  CIP13: '3400931840640',
  ucdLib: "ADEPAL CPR",
  UCD7: '9001188',
  UCD13: '3400890011884',
  ucdQtyMultiplicator: 21,
  cipLib: "ADEPAL CPR BT 21",
  atcCode: "G03AB03"
}, {
  CIP7: '3184087',
  CIP13: '3400931840879',
  ucdLib: "ADEPAL CPR",
  UCD7: '9001188',
  UCD13: '3400890011884',
  ucdQtyMultiplicator: 63,
  cipLib: "ADEPAL CPR BT 63",
  atcCode: "G03AB03"
}, {
  CIP7: '3588413',
  CIP13: '3400935884138',
  ucdLib: "DAILY CPR",
  UCD7: '9238737',
  UCD13: '3400892387376',
  ucdQtyMultiplicator: 21,
  cipLib: "DAILY CPR BT 21",
  atcCode: "G03AB03"
}, {
  CIP7: '3588436',
  CIP13: '3400935884367',
  ucdLib: "DAILY CPR",
  UCD7: '9238737',
  UCD13: '3400892387376',
  ucdQtyMultiplicator: 63,
  cipLib: "DAILY CPR BT 63",
  atcCode: "G03AB03"
}, {
  CIP7: '3899975',
  CIP13: '3400938999754',
  ucdLib: "EVANECIA CPR",
  UCD7: '9326677',
  UCD13: '3400893266779',
  ucdQtyMultiplicator: 21,
  cipLib: "EVANECIA CPR BT 21",
  atcCode: "G03AB03"
}, {
  CIP7: '3899981',
  CIP13: '3400938999815',
  ucdLib: "EVANECIA CPR",
  UCD7: '9326677',
  UCD13: '3400893266779',
  ucdQtyMultiplicator: 63,
  cipLib: "EVANECIA CPR BT 63",
  atcCode: "G03AB03"
}, {
  CIP7: '3918106',
  CIP13: '3400939181066',
  ucdLib: "PACILIA CPR",
  UCD7: '9331394',
  UCD13: '3400893313947',
  ucdQtyMultiplicator: 21,
  cipLib: "PACILIA CPR BT 21",
  atcCode: "G03AB03"
}, {
  CIP7: '3918112',
  CIP13: '3400939181127',
  ucdLib: "PACILIA CPR",
  UCD7: '9331394',
  UCD13: '3400893313947',
  ucdQtyMultiplicator: 63,
  cipLib: "PACILIA CPR BT 63",
  atcCode: "G03AB03"
}, {
  CIP7: '3695008',
  CIP13: '3400936950085',
  ucdLib: "BELARA 0,03MG/2MG CPR",
  UCD7: '9277849',
  UCD13: '3400892778495',
  ucdQtyMultiplicator: 21,
  cipLib: "BELARA 0,03MG/2MG CPR BT 21",
  atcCode: "G03AA15"
}, {
  CIP7: '3695014',
  CIP13: '3400936950146',
  ucdLib: "BELARA 0,03MG/2MG CPR",
  UCD7: '9277849',
  UCD13: '3400892778495',
  ucdQtyMultiplicator: 63,
  cipLib: "BELARA 0,03MG/2MG CPR BT 63",
  atcCode: "G03AA15"
}, {
  CIP7: '3993697',
  CIP13: '3400939936970',
  ucdLib: "BELARACONTINU 0,03/2MG CPR",
  UCD7: '9407714',
  UCD13: '3400894077145',
  ucdQtyMultiplicator: 28,
  cipLib: "BELARACONTINU 0,03/2MG CPR BT 28",
  atcCode: "G03AA15"
}, {
  CIP7: '3993705',
  CIP13: '3400939937052',
  ucdLib: "BELARACONTINU 0,03/2MG CPR",
  UCD7: '9407714',
  UCD13: '3400894077145',
  ucdQtyMultiplicator: 84,
  cipLib: "BELARACONTINU 0,03/2MG CPR BT 84",
  atcCode: "G03AA15"
}, {
  CIP7: '4190813',
  CIP13: '3400941908132',
  ucdLib: "ZOELY 2,5MG/1,5MG CPR",
  UCD7: '9377775',
  UCD13: '3400893777756',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOELY 2,5MG/1,5MG CPR BT 28",
  atcCode: "G03AA14"
}, {
  CIP7: '4190836',
  CIP13: '3400941908361',
  ucdLib: "ZOELY 2,5MG/1,5MG CPR",
  UCD7: '9377775',
  UCD13: '3400893777756',
  ucdQtyMultiplicator: 84,
  cipLib: "ZOELY 2,5MG/1,5MG CPR BT 84",
  atcCode: "G03AA14"
}, {
  CIP7: '3605146',
  CIP13: '3400936051461',
  ucdLib: "EVRA DISP TRANS",
  UCD7: '9257172',
  UCD13: '3400892571720',
  ucdQtyMultiplicator: 3,
  cipLib: "EVRA DISP TRANS BT 3",
  atcCode: "G03AA13"
}, {
  CIP7: '3605152',
  CIP13: '3400936051522',
  ucdLib: "EVRA DISP TRANS",
  UCD7: '9257172',
  UCD13: '3400892571720',
  ucdQtyMultiplicator: 9,
  cipLib: "EVRA DISP TRANS BT 9",
  atcCode: "G03AA13"
}, {
  CIP7: '3561696',
  CIP13: '3400935616968',
  ucdLib: "CONVULINE 0,03MG/3MG CPR",
  UCD7: '9365163',
  UCD13: '3400893651636',
  ucdQtyMultiplicator: 21,
  cipLib: "CONVULINE 0,03MG/3MG CPR BT 21",
  atcCode: "G03AA12"
}, {
  CIP7: '3561704',
  CIP13: '3400935617040',
  ucdLib: "CONVULINE 0,03MG/3MG CPR",
  UCD7: '9365163',
  UCD13: '3400893651636',
  ucdQtyMultiplicator: 63,
  cipLib: "CONVULINE 0,03MG/3MG CPR BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '3560550',
  CIP13: '3400935605504',
  ucdLib: "JASMINE 0,03MG/3MG CPR",
  UCD7: '9237376',
  UCD13: '3400892373768',
  ucdQtyMultiplicator: 21,
  cipLib: "JASMINE 0,03MG/3MG CPR BT 21",
  atcCode: "G03AA12"
}, {
  CIP7: '3560567',
  CIP13: '3400935605672',
  ucdLib: "JASMINE 0,03MG/3MG CPR",
  UCD7: '9237376',
  UCD13: '3400892373768',
  ucdQtyMultiplicator: 63,
  cipLib: "JASMINE 0,03MG/3MG CPR BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '3764181',
  CIP13: '3400937641814',
  ucdLib: "BELANETTE 0,02MG/3MG CPR",
  UCD7: '9365140',
  UCD13: '3400893651407',
  ucdQtyMultiplicator: 21,
  cipLib: "BELANETTE 0,02MG/3MG CPR BT 21",
  atcCode: "G03AA12"
}, {
  CIP7: '3764198',
  CIP13: '3400937641982',
  ucdLib: "BELANETTE 0,02MG/3MG CPR",
  UCD7: '9365140',
  UCD13: '3400893651407',
  ucdQtyMultiplicator: 63,
  cipLib: "BELANETTE 0,02MG/3MG CPR BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '3763980',
  CIP13: '3400937639804',
  ucdLib: "JASMINELLE 0,02MG/3MG CPR",
  UCD7: '9290666',
  UCD13: '3400892906669',
  ucdQtyMultiplicator: 21,
  cipLib: "JASMINELLE 0,02MG/3MG CPR BT 21",
  atcCode: "G03AA12"
}, {
  CIP7: '3764005',
  CIP13: '3400937640053',
  ucdLib: "JASMINELLE 0,02MG/3MG CPR",
  UCD7: '9290666',
  UCD13: '3400892906669',
  ucdQtyMultiplicator: 63,
  cipLib: "JASMINELLE 0,02MG/3MG CPR BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '3764442',
  CIP13: '3400937644426',
  ucdLib: "JASMINELLECONTINU 0,02/3MG C",
  UCD7: '9310707',
  UCD13: '3400893107072',
  ucdQtyMultiplicator: 28,
  cipLib: "JASMINELLECONTINU 0,02/3MG C BT 28",
  atcCode: "G03AA12"
}, {
  CIP7: '3764459',
  CIP13: '3400937644594',
  ucdLib: "JASMINELLECONTINU 0,02/3MG C",
  UCD7: '9310707',
  UCD13: '3400893107072',
  ucdQtyMultiplicator: 84,
  cipLib: "JASMINELLECONTINU 0,02/3MG C BT 84",
  atcCode: "G03AA12"
}, {
  CIP7: '3884040',
  CIP13: '3400938840407',
  ucdLib: "YAZ 0,02MG/3MG CPR",
  UCD7: '9323489',
  UCD13: '3400893234891',
  ucdQtyMultiplicator: 28,
  cipLib: "YAZ 0,02MG/3MG CPR BT 28",
  atcCode: "G03AA12"
}, {
  CIP7: '3884057',
  CIP13: '3400938840575',
  ucdLib: "YAZ 0,02MG/3MG CPR",
  UCD7: '9323489',
  UCD13: '3400893234891',
  ucdQtyMultiplicator: 84,
  cipLib: "YAZ 0,02MG/3MG CPR BT 84",
  atcCode: "G03AA12"
}, {
  CIP7: '2190447',
  CIP13: '3400921904475',
  ucdLib: "DROSP/ETHINYL.MYL3/0,02MG CP",
  UCD7: '9394070',
  UCD13: '3400893940709',
  ucdQtyMultiplicator: 21,
  cipLib: "DROSP/ETHINYL.MYL3/0,02MG CP BT 21",
  atcCode: "G03AA12"
}, {
  CIP7: '2190476',
  CIP13: '3400921904765',
  ucdLib: "DROSP/ETHINYL.MYL3/0,02MG CP",
  UCD7: '9394070',
  UCD13: '3400893940709',
  ucdQtyMultiplicator: 63,
  cipLib: "DROSP/ETHINYL.MYL3/0,02MG CP BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '2190482',
  CIP13: '3400921904826',
  ucdLib: "DROSP/ETHINYL.MYL3/0,03MG CP",
  UCD7: '9394087',
  UCD13: '3400893940877',
  ucdQtyMultiplicator: 21,
  cipLib: "DROSP/ETHINYL.MYL3/0,03MG CP BT 21",
  atcCode: "G03AA12"
}, {
  CIP7: '2190507',
  CIP13: '3400921905076',
  ucdLib: "DROSP/ETHINYL.MYL3/0,03MG CP",
  UCD7: '9394087',
  UCD13: '3400893940877',
  ucdQtyMultiplicator: 63,
  cipLib: "DROSP/ETHINYL.MYL3/0,03MG CP BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '2190513',
  CIP13: '3400921905137',
  ucdLib: "DROSP/ETHINYL.MYLCONTINU CPR",
  UCD7: '9394093',
  UCD13: '3400893940938',
  ucdQtyMultiplicator: 28,
  cipLib: "DROSP/ETHINYL.MYLCONTINU CPR BT 28",
  atcCode: "G03AA12"
}, {
  CIP7: '2190559',
  CIP13: '3400921905595',
  ucdLib: "DROSP/ETHINYL.MYLCONTINU CPR",
  UCD7: '9394093',
  UCD13: '3400893940938',
  ucdQtyMultiplicator: 84,
  cipLib: "DROSP/ETHINYL.MYLCONTINU CPR BT 84",
  atcCode: "G03AA12"
}, {
  CIP7: '2692261',
  CIP13: '3400926922610',
  ucdLib: "DROSP/ETHINYL.MYPCONTINU CPR",
  UCD7: '9401019',
  UCD13: '3400894010197',
  ucdQtyMultiplicator: 28,
  cipLib: "DROSP/ETHINYL.MYPCONTINU CPR BT 28",
  atcCode: "G03AA12"
}, {
  CIP7: '2692278',
  CIP13: '3400926922788',
  ucdLib: "DROSP/ETHINYL.MYPCONTINU CPR",
  UCD7: '9401019',
  UCD13: '3400894010197',
  ucdQtyMultiplicator: 84,
  cipLib: "DROSP/ETHINYL.MYPCONTINU CPR BT 84",
  atcCode: "G03AA12"
}, {
  CIP7: '2190341',
  CIP13: '3400921903416',
  ucdLib: "DROSPIBEL 0,02MG/3MG CPR",
  UCD7: '9380866',
  UCD13: '3400893808665',
  ucdQtyMultiplicator: 63,
  cipLib: "DROSPIBEL 0,02MG/3MG CPR BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '2190370',
  CIP13: '3400921903706',
  ucdLib: "DROSPIBEL 0,03MG/3MG CPR",
  UCD7: '9380872',
  UCD13: '3400893808726',
  ucdQtyMultiplicator: 63,
  cipLib: "DROSPIBEL 0,03MG/3MG CPR BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '4997208',
  CIP13: '3400949972081',
  ucdLib: "ETHINYL/DROSP.BGA0,02/3MG C",
  UCD7: '9369735',
  UCD13: '3400893697351',
  ucdQtyMultiplicator: 21,
  cipLib: "ETHINYL/DROSP.BGA0,02/3MG C BT 21",
  atcCode: "G03AA12"
}, {
  CIP7: '4997214',
  CIP13: '3400949972142',
  ucdLib: "ETHINYL/DROSP.BGA0,02/3MG C",
  UCD7: '9369735',
  UCD13: '3400893697351',
  ucdQtyMultiplicator: 63,
  cipLib: "ETHINYL/DROSP.BGA0,02/3MG C BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '4997272',
  CIP13: '3400949972722',
  ucdLib: "ETHINYL/DROSP.BGA0,03/3MG C",
  UCD7: '9369741',
  UCD13: '3400893697412',
  ucdQtyMultiplicator: 21,
  cipLib: "ETHINYL/DROSP.BGA0,03/3MG C BT 21",
  atcCode: "G03AA12"
}, {
  CIP7: '4997289',
  CIP13: '3400949972890',
  ucdLib: "ETHINYL/DROSP.BGA0,03/3MG C",
  UCD7: '9369741',
  UCD13: '3400893697412',
  ucdQtyMultiplicator: 63,
  cipLib: "ETHINYL/DROSP.BGA0,03/3MG C BT 63",
  atcCode: "G03AA12"
}, {
  CIP7: '4997295',
  CIP13: '3400949972951',
  ucdLib: "ETHINYL/DROSP.BGACONTINU CPR",
  UCD7: '9369729',
  UCD13: '3400893697290',
  ucdQtyMultiplicator: 28,
  cipLib: "ETHINYL/DROSP.BGACONTINU CPR BT 28",
  atcCode: "G03AA12"
}, {
  CIP7: '4997303',
  CIP13: '3400949973033',
  ucdLib: "ETHINYL/DROSP.BGACONTINU CPR",
  UCD7: '9369729',
  UCD13: '3400893697290',
  ucdQtyMultiplicator: 84,
  cipLib: "ETHINYL/DROSP.BGACONTINU CPR BT 84",
  atcCode: "G03AA12"
}, {
  CIP7: '2691913',
  CIP13: '3400926919139',
  ucdLib: "IZEANE 0,02MG/3MG CPR",
  UCD7: '9408369',
  UCD13: '3400894083696',
  ucdQtyMultiplicator: 28,
  cipLib: "IZEANE 0,02MG/3MG CPR BT 28",
  atcCode: "G03AA12"
}, {
  CIP7: '2691936',
  CIP13: '3400926919368',
  ucdLib: "IZEANE 0,02MG/3MG CPR",
  UCD7: '9408369',
  UCD13: '3400894083696',
  ucdQtyMultiplicator: 84,
  cipLib: "IZEANE 0,02MG/3MG CPR BT 84",
  atcCode: "G03AA12"
}, {
  CIP7: '3589967',
  CIP13: '3400935899675',
  ucdLib: "TRIAFEMI CPR",
  UCD7: '9247363',
  UCD13: '3400892473635',
  ucdQtyMultiplicator: 63,
  cipLib: "TRIAFEMI CPR BT 63",
  atcCode: "G03AA11"
}, {
  CIP7: '3384024',
  CIP13: '3400933840242',
  ucdLib: "EFFIPREV CPR",
  UCD7: '9171335',
  UCD13: '3400891713350',
  ucdQtyMultiplicator: 63,
  cipLib: "EFFIPREV CPR BT 63",
  atcCode: "G03AA11"
}, {
  CIP7: '4919409',
  CIP13: '3400949194094',
  ucdLib: "GESTODENE/ETH.MYL 60/15Y CPR",
  UCD7: '9357169',
  UCD13: '3400893571699',
  ucdQtyMultiplicator: 28,
  cipLib: "GESTODENE/ETH.MYL 60/15Y CPR BT 28",
  atcCode: "G03AA10"
}, {
  CIP7: '4919415',
  CIP13: '3400949194155',
  ucdLib: "GESTODENE/ETH.MYL 60/15Y CPR",
  UCD7: '9357169',
  UCD13: '3400893571699',
  ucdQtyMultiplicator: 84,
  cipLib: "GESTODENE/ETH.MYL 60/15Y CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '4919438',
  CIP13: '3400949194384',
  ucdLib: "GESTODENE/ETH.TVC 60/15Y CPR",
  UCD7: '9357175',
  UCD13: '3400893571750',
  ucdQtyMultiplicator: 84,
  cipLib: "GESTODENE/ETH.TVC 60/15Y CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '4919154',
  CIP13: '3400949191543',
  ucdLib: "GESTODENE/ETH.ZEN 60/15Y CPR",
  UCD7: '9359317',
  UCD13: '3400893593172',
  ucdQtyMultiplicator: 28,
  cipLib: "GESTODENE/ETH.ZEN 60/15Y CPR BT 28",
  atcCode: "G03AA10"
}, {
  CIP7: '4919160',
  CIP13: '3400949191604',
  ucdLib: "GESTODENE/ETH.ZEN 60/15Y CPR",
  UCD7: '9359317',
  UCD13: '3400893593172',
  ucdQtyMultiplicator: 84,
  cipLib: "GESTODENE/ETH.ZEN 60/15Y CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '3305125',
  CIP13: '3400933051259',
  ucdLib: "MINULET CPR",
  UCD7: '9148649',
  UCD13: '3400891486490',
  ucdQtyMultiplicator: 21,
  cipLib: "MINULET CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3305131',
  CIP13: '3400933051310',
  ucdLib: "MINULET CPR",
  UCD7: '9148649',
  UCD13: '3400891486490',
  ucdQtyMultiplicator: 63,
  cipLib: "MINULET CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3392207',
  CIP13: '3400933922078',
  ucdLib: "HARMONET CPR",
  UCD7: '9173305',
  UCD13: '3400891733051',
  ucdQtyMultiplicator: 21,
  cipLib: "HARMONET CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3392213',
  CIP13: '3400933922139',
  ucdLib: "HARMONET CPR",
  UCD7: '9173305',
  UCD13: '3400891733051',
  ucdQtyMultiplicator: 63,
  cipLib: "HARMONET CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3392182',
  CIP13: '3400933921828',
  ucdLib: "MELIANE CPR",
  UCD7: '9173191',
  UCD13: '3400891731910',
  ucdQtyMultiplicator: 21,
  cipLib: "MELIANE CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3392199',
  CIP13: '3400933921996',
  ucdLib: "MELIANE CPR",
  UCD7: '9173191',
  UCD13: '3400891731910',
  ucdQtyMultiplicator: 63,
  cipLib: "MELIANE CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3515779',
  CIP13: '3400935157799',
  ucdLib: "MELODIA 60MCG/15MCG CPR",
  UCD7: '9212519',
  UCD13: '3400892125190',
  ucdQtyMultiplicator: 28,
  cipLib: "MELODIA 60MCG/15MCG CPR BT 28",
  atcCode: "G03AA10"
}, {
  CIP7: '3515785',
  CIP13: '3400935157850',
  ucdLib: "MELODIA 60MCG/15MCG CPR",
  UCD7: '9212519',
  UCD13: '3400892125190',
  ucdQtyMultiplicator: 84,
  cipLib: "MELODIA 60MCG/15MCG CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '3515756',
  CIP13: '3400935157560',
  ucdLib: "MINESSE 60MCG/15MCG CPR",
  UCD7: '9210839',
  UCD13: '3400892108391',
  ucdQtyMultiplicator: 28,
  cipLib: "MINESSE 60MCG/15MCG CPR BT 28",
  atcCode: "G03AA10"
}, {
  CIP7: '3515762',
  CIP13: '3400935157621',
  ucdLib: "MINESSE 60MCG/15MCG CPR",
  UCD7: '9210839',
  UCD13: '3400892108391',
  ucdQtyMultiplicator: 84,
  cipLib: "MINESSE 60MCG/15MCG CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '3746438',
  CIP13: '3400937464383',
  ucdLib: "GESTODENE/ETH.BGA 75/20Y CPR",
  UCD7: '9288221',
  UCD13: '3400892882215',
  ucdQtyMultiplicator: 21,
  cipLib: "GESTODENE/ETH.BGA 75/20Y CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3746444',
  CIP13: '3400937464444',
  ucdLib: "GESTODENE/ETH.BGA 75/20Y CPR",
  UCD7: '9288221',
  UCD13: '3400892882215',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.BGA 75/20Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3746450',
  CIP13: '3400937464505',
  ucdLib: "GESTODENE/ETH.BGA 75/30Y CPR",
  UCD7: '9288238',
  UCD13: '3400892882383',
  ucdQtyMultiplicator: 21,
  cipLib: "GESTODENE/ETH.BGA 75/30Y CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3746467',
  CIP13: '3400937464673',
  ucdLib: "GESTODENE/ETH.BGA 75/30Y CPR",
  UCD7: '9288238',
  UCD13: '3400892882383',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.BGA 75/30Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3773665',
  CIP13: '3400937736657',
  ucdLib: "GESTODENE/ETH.ZEN 75/20Y CPR",
  UCD7: '9296700',
  UCD13: '3400892967004',
  ucdQtyMultiplicator: 21,
  cipLib: "GESTODENE/ETH.ZEN 75/20Y CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3773671',
  CIP13: '3400937736718',
  ucdLib: "GESTODENE/ETH.ZEN 75/20Y CPR",
  UCD7: '9296700',
  UCD13: '3400892967004',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.ZEN 75/20Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3773725',
  CIP13: '3400937737258',
  ucdLib: "GESTODENE/ETH.ZEN 75/30Y CPR",
  UCD7: '9296717',
  UCD13: '3400892967172',
  ucdQtyMultiplicator: 21,
  cipLib: "GESTODENE/ETH.ZEN 75/30Y CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3773731',
  CIP13: '3400937737319',
  ucdLib: "GESTODENE/ETH.ZEN 75/30Y CPR",
  UCD7: '9296717',
  UCD13: '3400892967172',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.ZEN 75/30Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3759636',
  CIP13: '3400937596367',
  ucdLib: "CARLIN 75MCG/20MCG CPR",
  UCD7: '9287813',
  UCD13: '3400892878133',
  ucdQtyMultiplicator: 63,
  cipLib: "CARLIN 75MCG/20MCG CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3759553',
  CIP13: '3400937595537',
  ucdLib: "CARLIN 75MCG/30MCG CPR",
  UCD7: '9287836',
  UCD13: '3400892878362',
  ucdQtyMultiplicator: 63,
  cipLib: "CARLIN 75MCG/30MCG CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3759607',
  CIP13: '3400937596077',
  ucdLib: "GESTODENE/ETH.EG 75/20Y CPR",
  UCD7: '9292346',
  UCD13: '3400892923468',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.EG 75/20Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3759582',
  CIP13: '3400937595827',
  ucdLib: "GESTODENE/ETH.EG 75/30Y CPR",
  UCD7: '9292352',
  UCD13: '3400892923529',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.EG 75/30Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3759642',
  CIP13: '3400937596428',
  ucdLib: "GESTODENE/ETH.MYL 75/20Y CPR",
  UCD7: '9289976',
  UCD13: '3400892899763',
  ucdQtyMultiplicator: 21,
  cipLib: "GESTODENE/ETH.MYL 75/20Y CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3759659',
  CIP13: '3400937596596',
  ucdLib: "GESTODENE/ETH.MYL 75/20Y CPR",
  UCD7: '9289976',
  UCD13: '3400892899763',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.MYL 75/20Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3759688',
  CIP13: '3400937596886',
  ucdLib: "GESTODENE/ETH.MYL 75/30Y CPR",
  UCD7: '9289982',
  UCD13: '3400892899824',
  ucdQtyMultiplicator: 21,
  cipLib: "GESTODENE/ETH.MYL 75/30Y CPR BT 21",
  atcCode: "G03AA10"
}, {
  CIP7: '3759694',
  CIP13: '3400937596947',
  ucdLib: "GESTODENE/ETH.MYL 75/30Y CPR",
  UCD7: '9289982',
  UCD13: '3400892899824',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.MYL 75/30Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3807252',
  CIP13: '3400938072525',
  ucdLib: "GESTODENE/ETH.TVC 75/20Y CPR",
  UCD7: '9304291',
  UCD13: '3400893042915',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.TVC 75/20Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3807217',
  CIP13: '3400938072174',
  ucdLib: "GESTODENE/ETH.TVC 75/30Y CPR",
  UCD7: '9304227',
  UCD13: '3400893042274',
  ucdQtyMultiplicator: 63,
  cipLib: "GESTODENE/ETH.TVC 75/30Y CPR BT 63",
  atcCode: "G03AA10"
}, {
  CIP7: '3935406',
  CIP13: '3400939354064',
  ucdLib: "GESTODENE/ETH.BGA 60/15Y CPR",
  UCD7: '9337020',
  UCD13: '3400893370209',
  ucdQtyMultiplicator: 28,
  cipLib: "GESTODENE/ETH.BGA 60/15Y CPR BT 28",
  atcCode: "G03AA10"
}, {
  CIP7: '3935412',
  CIP13: '3400939354125',
  ucdLib: "GESTODENE/ETH.BGA 60/15Y CPR",
  UCD7: '9337020',
  UCD13: '3400893370209',
  ucdQtyMultiplicator: 84,
  cipLib: "GESTODENE/ETH.BGA 60/15Y CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '3917242',
  CIP13: '3400939172422',
  ucdLib: "OPTINESSE 60MCG/15MCG CPR",
  UCD7: '9329546',
  UCD13: '3400893295465',
  ucdQtyMultiplicator: 28,
  cipLib: "OPTINESSE 60MCG/15MCG CPR BT 28",
  atcCode: "G03AA10"
}, {
  CIP7: '3917259',
  CIP13: '3400939172590',
  ucdLib: "OPTINESSE 60MCG/15MCG CPR",
  UCD7: '9329546',
  UCD13: '3400893295465',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTINESSE 60MCG/15MCG CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '2201501',
  CIP13: '3400922015019',
  ucdLib: "GESTODENE/ETH.CRT 60/15Y CPR",
  UCD7: '9406560',
  UCD13: '3400894065609',
  ucdQtyMultiplicator: 84,
  cipLib: "GESTODENE/ETH.CRT 60/15Y CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '2201470',
  CIP13: '3400922014708',
  ucdLib: "GESTODENE/ETH.EG 60/15Y CPR",
  UCD7: '9391634',
  UCD13: '3400893916346',
  ucdQtyMultiplicator: 84,
  cipLib: "GESTODENE/ETH.EG 60/15Y CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '2788452',
  CIP13: '3400927884528',
  ucdLib: "LISVY 60MCG+13MCG/24H DISP",
  UCD7: '9416624',
  UCD13: '3400894166245',
  ucdQtyMultiplicator: 3,
  cipLib: "LISVY 60MCG+13MCG/24H DISP BT 3",
  atcCode: "G03AA10"
}, {
  CIP7: '2788469',
  CIP13: '3400927884696',
  ucdLib: "LISVY 60MCG+13MCG/24H DISP",
  UCD7: '9416624',
  UCD13: '3400894166245',
  ucdQtyMultiplicator: 9,
  cipLib: "LISVY 60MCG+13MCG/24H DISP BT 9",
  atcCode: "G03AA10"
}, {
  CIP7: '2794257',
  CIP13: '3400927942570',
  ucdLib: "OPTINESSE 75MCG/20MCG CPR",
  UCD7: '9406850',
  UCD13: '3400894068501',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTINESSE 75MCG/20MCG CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '2794286',
  CIP13: '3400927942860',
  ucdLib: "OPTINESSE 75MCG/30MCG CPR",
  UCD7: '9406867',
  UCD13: '3400894068679',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTINESSE 75MCG/30MCG CPR BT 84",
  atcCode: "G03AA10"
}, {
  CIP7: '3000542',
  CIP13: '3400930005422',
  ucdLib: "DESOGEST.ETHIN.EG 150/20Y",
  UCD7: '9411012',
  UCD13: '3400894110125',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOGEST.ETHIN.EG 150/20Y BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3000565',
  CIP13: '3400930005651',
  ucdLib: "DESOGEST.ETHIN.EG 150/30Y",
  UCD7: '9411029',
  UCD13: '3400894110293',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOGEST.ETHIN.EG 150/30Y BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3000746',
  CIP13: '3400930007464',
  ucdLib: "DESOGEST.ETHIN.MYL 150/20Y",
  UCD7: '9409067',
  UCD13: '3400894090670',
  ucdQtyMultiplicator: 21,
  cipLib: "DESOGEST.ETHIN.MYL 150/20Y BT 21",
  atcCode: "G03AA09"
}, {
  CIP7: '3000747',
  CIP13: '3400930007471',
  ucdLib: "DESOGEST.ETHIN.MYL 150/20Y",
  UCD7: '9409067',
  UCD13: '3400894090670',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOGEST.ETHIN.MYL 150/20Y BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3000744',
  CIP13: '3400930007440',
  ucdLib: "DESOGEST.ETHIN.MYL 150/30Y",
  UCD7: '9409073',
  UCD13: '3400894090731',
  ucdQtyMultiplicator: 21,
  cipLib: "DESOGEST.ETHIN.MYL 150/30Y BT 21",
  atcCode: "G03AA09"
}, {
  CIP7: '3000745',
  CIP13: '3400930007457',
  ucdLib: "DESOGEST.ETHIN.MYL 150/30Y",
  UCD7: '9409073',
  UCD13: '3400894090731',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOGEST.ETHIN.MYL 150/30Y BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3254971',
  CIP13: '3400932549719',
  ucdLib: "VARNOLINE CPR",
  UCD7: '9097455',
  UCD13: '3400890974554',
  ucdQtyMultiplicator: 21,
  cipLib: "VARNOLINE CPR BT 21",
  atcCode: "G03AA09"
}, {
  CIP7: '3254988',
  CIP13: '3400932549887',
  ucdLib: "VARNOLINE CPR",
  UCD7: '9097455',
  UCD13: '3400890974554',
  ucdQtyMultiplicator: 63,
  cipLib: "VARNOLINE CPR BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3305208',
  CIP13: '3400933052089',
  ucdLib: "MERCILON CPR",
  UCD7: '9140091',
  UCD13: '3400891400915',
  ucdQtyMultiplicator: 21,
  cipLib: "MERCILON CPR BT 21",
  atcCode: "G03AA09"
}, {
  CIP7: '3305214',
  CIP13: '3400933052140',
  ucdLib: "MERCILON CPR",
  UCD7: '9140091',
  UCD13: '3400891400915',
  ucdQtyMultiplicator: 63,
  cipLib: "MERCILON CPR BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3586621',
  CIP13: '3400935866219',
  ucdLib: "DESOGEST.ETHIN.BGA 150/20Y",
  UCD7: '9257249',
  UCD13: '3400892572499',
  ucdQtyMultiplicator: 21,
  cipLib: "DESOGEST.ETHIN.BGA 150/20Y BT 21",
  atcCode: "G03AA09"
}, {
  CIP7: '3586638',
  CIP13: '3400935866387',
  ucdLib: "DESOGEST.ETHIN.BGA 150/20Y",
  UCD7: '9257249',
  UCD13: '3400892572499',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOGEST.ETHIN.BGA 150/20Y BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3586644',
  CIP13: '3400935866448',
  ucdLib: "DESOGEST.ETHIN.BGA 150/30Y",
  UCD7: '9257255',
  UCD13: '3400892572550',
  ucdQtyMultiplicator: 21,
  cipLib: "DESOGEST.ETHIN.BGA 150/30Y BT 21",
  atcCode: "G03AA09"
}, {
  CIP7: '3586650',
  CIP13: '3400935866509',
  ucdLib: "DESOGEST.ETHIN.BGA 150/30Y",
  UCD7: '9257255',
  UCD13: '3400892572550',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOGEST.ETHIN.BGA 150/30Y BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3385383',
  CIP13: '3400933853839',
  ucdLib: "VARNOLINE CONTINU CPR",
  UCD7: '9177556',
  UCD13: '3400891775563',
  ucdQtyMultiplicator: 28,
  cipLib: "VARNOLINE CONTINU CPR BT 28",
  atcCode: "G03AA09"
}, {
  CIP7: '3385408',
  CIP13: '3400933854089',
  ucdLib: "VARNOLINE CONTINU CPR",
  UCD7: '9177556',
  UCD13: '3400891775563',
  ucdQtyMultiplicator: 84,
  cipLib: "VARNOLINE CONTINU CPR BT 84",
  atcCode: "G03AA09"
}, {
  CIP7: '3972063',
  CIP13: '3400939720630',
  ucdLib: "DESOBEL 150MCG/20MCG CPR",
  UCD7: '9344238',
  UCD13: '3400893442388',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOBEL 150MCG/20MCG CPR BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '3972146',
  CIP13: '3400939721460',
  ucdLib: "DESOBEL 150MCG/30MCG CPR",
  UCD7: '9344244',
  UCD13: '3400893442449',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOBEL 150MCG/30MCG CPR BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '2690581',
  CIP13: '3400926905811',
  ucdLib: "DESOGEST.ETH.BGACONT 150/30",
  UCD7: '9408719',
  UCD13: '3400894087199',
  ucdQtyMultiplicator: 28,
  cipLib: "DESOGEST.ETH.BGACONT 150/30 BT 28",
  atcCode: "G03AA09"
}, {
  CIP7: '2690598',
  CIP13: '3400926905989',
  ucdLib: "DESOGEST.ETH.BGACONT 150/30",
  UCD7: '9408719',
  UCD13: '3400894087199',
  ucdQtyMultiplicator: 84,
  cipLib: "DESOGEST.ETH.BGACONT 150/30 BT 84",
  atcCode: "G03AA09"
}, {
  CIP7: '4960381',
  CIP13: '3400949603817',
  ucdLib: "DESOGEST.ETHIN.ZEN 150/20Y",
  UCD7: '9363951',
  UCD13: '3400893639511',
  ucdQtyMultiplicator: 21,
  cipLib: "DESOGEST.ETHIN.ZEN 150/20Y BT 21",
  atcCode: "G03AA09"
}, {
  CIP7: '4960398',
  CIP13: '3400949603985',
  ucdLib: "DESOGEST.ETHIN.ZEN 150/20Y",
  UCD7: '9363951',
  UCD13: '3400893639511',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOGEST.ETHIN.ZEN 150/20Y BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '4960688',
  CIP13: '3400949606887',
  ucdLib: "DESOGEST.ETHIN.ZEN 150/30Y",
  UCD7: '9363968',
  UCD13: '3400893639689',
  ucdQtyMultiplicator: 21,
  cipLib: "DESOGEST.ETHIN.ZEN 150/30Y BT 21",
  atcCode: "G03AA09"
}, {
  CIP7: '4960694',
  CIP13: '3400949606948',
  ucdLib: "DESOGEST.ETHIN.ZEN 150/30Y",
  UCD7: '9363968',
  UCD13: '3400893639689',
  ucdQtyMultiplicator: 63,
  cipLib: "DESOGEST.ETHIN.ZEN 150/30Y BT 63",
  atcCode: "G03AA09"
}, {
  CIP7: '2794228',
  CIP13: '3400927942280',
  ucdLib: "OPTIDESO 20/150MCG CPR",
  UCD7: '9407855',
  UCD13: '3400894078555',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTIDESO 20/150MCG CPR BT 84",
  atcCode: "G03AA09"
}, {
  CIP7: '2794168',
  CIP13: '3400927941689',
  ucdLib: "OPTIDESO 30/150MCG CPR",
  UCD7: '9407861',
  UCD13: '3400894078616',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTIDESO 30/150MCG CPR BT 84",
  atcCode: "G03AA09"
}, {
  CIP7: '3001051',
  CIP13: '3400930010518',
  ucdLib: "SEASONIQUE 150/30+10MCG CPR",
  UCD7: '9411785',
  UCD13: '3400894117858',
  ucdQtyMultiplicator: 91,
  cipLib: "SEASONIQUE 150/30+10MCG CPR BT 91",
  atcCode: "G03AA07"
}, {
  CIP7: '4911336',
  CIP13: '3400949113361',
  ucdLib: "LEVON/ETHINYL.MYL150/30Y CPR",
  UCD7: '9356543',
  UCD13: '3400893565438',
  ucdQtyMultiplicator: 21,
  cipLib: "LEVON/ETHINYL.MYL150/30Y CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '4911342',
  CIP13: '3400949113422',
  ucdLib: "LEVON/ETHINYL.MYL150/30Y CPR",
  UCD7: '9356543',
  UCD13: '3400893565438',
  ucdQtyMultiplicator: 63,
  cipLib: "LEVON/ETHINYL.MYL150/30Y CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '3567316',
  CIP13: '3400935673169',
  ucdLib: "LUDEAL 0,15MG/0,03MG CPR",
  UCD7: '9235265',
  UCD13: '3400892352657',
  ucdQtyMultiplicator: 21,
  cipLib: "LUDEAL 0,15MG/0,03MG CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '3567322',
  CIP13: '3400935673220',
  ucdLib: "LUDEAL 0,15MG/0,03MG CPR",
  UCD7: '9235265',
  UCD13: '3400892352657',
  ucdQtyMultiplicator: 63,
  cipLib: "LUDEAL 0,15MG/0,03MG CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '3182390',
  CIP13: '3400931823902',
  ucdLib: "MINIDRIL CPR",
  UCD7: '9059153',
  UCD13: '3400890591539',
  ucdQtyMultiplicator: 21,
  cipLib: "MINIDRIL CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '3182409',
  CIP13: '3400931824091',
  ucdLib: "MINIDRIL CPR",
  UCD7: '9059153',
  UCD13: '3400890591539',
  ucdQtyMultiplicator: 63,
  cipLib: "MINIDRIL CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '3847926',
  CIP13: '3400938479263',
  ucdLib: "LEELOO 0,1MG/0,02MG CPR",
  UCD7: '9315946',
  UCD13: '3400893159460',
  ucdQtyMultiplicator: 21,
  cipLib: "LEELOO 0,1MG/0,02MG CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '3847932',
  CIP13: '3400938479324',
  ucdLib: "LEELOO 0,1MG/0,02MG CPR",
  UCD7: '9315946',
  UCD13: '3400893159460',
  ucdQtyMultiplicator: 63,
  cipLib: "LEELOO 0,1MG/0,02MG CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '3910234',
  CIP13: '3400939102344',
  ucdLib: "LOVAVULO 20/100MCG CPR",
  UCD7: '9354159',
  UCD13: '3400893541593',
  ucdQtyMultiplicator: 21,
  cipLib: "LOVAVULO 20/100MCG CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '3910808',
  CIP13: '3400939108087',
  ucdLib: "LOVAVULO 20/100MCG CPR",
  UCD7: '9354159',
  UCD13: '3400893541593',
  ucdQtyMultiplicator: 63,
  cipLib: "LOVAVULO 20/100MCG CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '2217896',
  CIP13: '3400922178967',
  ucdLib: "OPTILOVA 20/100MCG CPR",
  UCD7: '9383959',
  UCD13: '3400893839591',
  ucdQtyMultiplicator: 28,
  cipLib: "OPTILOVA 20/100MCG CPR BT 28",
  atcCode: "G03AA07"
}, {
  CIP7: '2217904',
  CIP13: '3400922179049',
  ucdLib: "OPTILOVA 20/100MCG CPR",
  UCD7: '9383959',
  UCD13: '3400893839591',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTILOVA 20/100MCG CPR BT 84",
  atcCode: "G03AA07"
}, {
  CIP7: '2802330',
  CIP13: '3400928023308',
  ucdLib: "LEVON/ETHINYL.BGA150/30Y CPR",
  UCD7: '9406152',
  UCD13: '3400894061526',
  ucdQtyMultiplicator: 21,
  cipLib: "LEVON/ETHINYL.BGA150/30Y CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '2802347',
  CIP13: '3400928023476',
  ucdLib: "LEVON/ETHINYL.BGA150/30Y CPR",
  UCD7: '9406152',
  UCD13: '3400894061526',
  ucdQtyMultiplicator: 63,
  cipLib: "LEVON/ETHINYL.BGA150/30Y CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '2783839',
  CIP13: '3400927838392',
  ucdLib: "LEVON/ETHINYL.EG 100/20Y CPR",
  UCD7: '9409736',
  UCD13: '3400894097365',
  ucdQtyMultiplicator: 21,
  cipLib: "LEVON/ETHINYL.EG 100/20Y CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '2783845',
  CIP13: '3400927838453',
  ucdLib: "LEVON/ETHINYL.EG 100/20Y CPR",
  UCD7: '9409736',
  UCD13: '3400894097365',
  ucdQtyMultiplicator: 63,
  cipLib: "LEVON/ETHINYL.EG 100/20Y CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '2783816',
  CIP13: '3400927838163',
  ucdLib: "LEVON/ETHINYL.MYL100/20Y CPR",
  UCD7: '9417813',
  UCD13: '3400894178132',
  ucdQtyMultiplicator: 21,
  cipLib: "LEVON/ETHINYL.MYL100/20Y CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '2783822',
  CIP13: '3400927838224',
  ucdLib: "LEVON/ETHINYL.MYL100/20Y CPR",
  UCD7: '9417813',
  UCD13: '3400894178132',
  ucdQtyMultiplicator: 63,
  cipLib: "LEVON/ETHINYL.MYL100/20Y CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '2203339',
  CIP13: '3400922033396',
  ucdLib: "LOVAPHARM 30/150MCG CPR",
  UCD7: '9388738',
  UCD13: '3400893887387',
  ucdQtyMultiplicator: 21,
  cipLib: "LOVAPHARM 30/150MCG CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '2203345',
  CIP13: '3400922033457',
  ucdLib: "LOVAPHARM 30/150MCG CPR",
  UCD7: '9388738',
  UCD13: '3400893887387',
  ucdQtyMultiplicator: 63,
  cipLib: "LOVAPHARM 30/150MCG CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '2675251',
  CIP13: '3400926752514',
  ucdLib: "OPTIDRIL 30/150MCG CPR",
  UCD7: '9388767',
  UCD13: '3400893887677',
  ucdQtyMultiplicator: 28,
  cipLib: "OPTIDRIL 30/150MCG CPR BT 28",
  atcCode: "G03AA07"
}, {
  CIP7: '2675268',
  CIP13: '3400926752682',
  ucdLib: "OPTIDRIL 30/150MCG CPR",
  UCD7: '9388767',
  UCD13: '3400893887677',
  ucdQtyMultiplicator: 84,
  cipLib: "OPTIDRIL 30/150MCG CPR BT 84",
  atcCode: "G03AA07"
}, {
  CIP7: '2798255',
  CIP13: '3400927982552',
  ucdLib: "LEVON/ETHINYL.EG 150/30Y CPR",
  UCD7: '9405371',
  UCD13: '3400894053712',
  ucdQtyMultiplicator: 21,
  cipLib: "LEVON/ETHINYL.EG 150/30Y CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '2798261',
  CIP13: '3400927982613',
  ucdLib: "LEVON/ETHINYL.EG 150/30Y CPR",
  UCD7: '9405371',
  UCD13: '3400894053712',
  ucdQtyMultiplicator: 63,
  cipLib: "LEVON/ETHINYL.EG 150/30Y CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '2773172',
  CIP13: '3400927731723',
  ucdLib: "LEVON/ETHINYL.ZEN100/20Y CPR",
  UCD7: '9403797',
  UCD13: '3400894037972',
  ucdQtyMultiplicator: 21,
  cipLib: "LEVON/ETHINYL.ZEN100/20Y CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '2773189',
  CIP13: '3400927731891',
  ucdLib: "LEVON/ETHINYL.ZEN100/20Y CPR",
  UCD7: '9403797',
  UCD13: '3400894037972',
  ucdQtyMultiplicator: 63,
  cipLib: "LEVON/ETHINYL.ZEN100/20Y CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '2799929',
  CIP13: '3400927999291',
  ucdLib: "LEVON/ETHINYL.ZEN150/30Y CPR",
  UCD7: '9408760',
  UCD13: '3400894087601',
  ucdQtyMultiplicator: 21,
  cipLib: "LEVON/ETHINYL.ZEN150/30Y CPR BT 21",
  atcCode: "G03AA07"
}, {
  CIP7: '2799935',
  CIP13: '3400927999352',
  ucdLib: "LEVON/ETHINYL.ZEN150/30Y CPR",
  UCD7: '9408760',
  UCD13: '3400894087601',
  ucdQtyMultiplicator: 63,
  cipLib: "LEVON/ETHINYL.ZEN150/30Y CPR BT 63",
  atcCode: "G03AA07"
}, {
  CIP7: '3001206',
  CIP13: '3400930012062',
  ucdLib: "CIMIPAX 6,5MG CPR",
  UCD7: '9411638',
  UCD13: '3400894116387',
  ucdQtyMultiplicator: 30,
  cipLib: "CIMIPAX 6,5MG CPR BT 30",
  atcCode: "G02CX04"
}, {
  CIP7: '5624277',
  CIP13: '3400956242771',
  ucdLib: "TRACTOCILE 37,5MG INJ FL5ML",
  UCD7: '9220826',
  UCD13: '3400892208268',
  ucdQtyMultiplicator: 1,
  cipLib: "TRACTOCILE 37,5MG INJ FL5ML BT 1",
  atcCode: "G02CX01"
}, {
  CIP7: '5624260',
  CIP13: '3400956242603',
  ucdLib: "TRACTOCILE 6,75MG INJ FL0,9ML",
  UCD7: '9220803',
  UCD13: '3400892208039',
  ucdQtyMultiplicator: 1,
  cipLib: "TRACTOCILE 6,75MG INJ FL0,9ML BT 1",
  atcCode: "G02CX01"
}, {
  CIP7: '5501259',
  CIP13: '3400955012597',
  ucdLib: "ATOSIBAN PAN 37,5MG FL5ML",
  UCD7: '9413399',
  UCD13: '3400894133995',
  ucdQtyMultiplicator: 1,
  cipLib: "ATOSIBAN PAN 37,5MG FL5ML BT 1",
  atcCode: "G02CX01"
}, {
  CIP7: '5501258',
  CIP13: '3400955012580',
  ucdLib: "ATOSIBAN PAN 6,75MG AMP0,9ML",
  UCD7: '9413407',
  UCD13: '3400894134077',
  ucdQtyMultiplicator: 1,
  cipLib: "ATOSIBAN PAN 6,75MG AMP0,9ML BT 1",
  atcCode: "G02CX01"
}, {
  CIP7: '5854149',
  CIP13: '3400958541490',
  ucdLib: "ATOSIBAN SUN 37,5MG FL5ML",
  UCD7: '9395448',
  UCD13: '3400893954485',
  ucdQtyMultiplicator: 1,
  cipLib: "ATOSIBAN SUN 37,5MG FL5ML BT 1",
  atcCode: "G02CX01"
}, {
  CIP7: '5854132',
  CIP13: '3400958541322',
  ucdLib: "ATOSIBAN SUN 6,75MG FL0,9ML",
  UCD7: '9395454',
  UCD13: '3400893954546',
  ucdQtyMultiplicator: 1,
  cipLib: "ATOSIBAN SUN 6,75MG FL0,9ML BT 1",
  atcCode: "G02CX01"
}, {
  CIP7: '3284653',
  CIP13: '3400932846535',
  ucdLib: "OPALGYNE SOL VAG FL140ML",
  UCD7: '9108704',
  UCD13: '3400891087048',
  ucdQtyMultiplicator: 6,
  cipLib: "OPALGYNE SOL VAG FL140ML BT 6",
  atcCode: "G02CC03"
}, {
  CIP7: '3296627',
  CIP13: '3400932966271',
  ucdLib: "OPALGYNE SOL VAG FL140ML",
  UCD7: '9108704',
  UCD13: '3400891087048',
  ucdQtyMultiplicator: 2,
  cipLib: "OPALGYNE SOL VAG FL140ML BT 2",
  atcCode: "G02CC03"
}, {
  CIP7: '3386514',
  CIP13: '3400933865146',
  ucdLib: "NORPROLAC 150MCG CPR",
  UCD7: '9177786',
  UCD13: '3400891777864',
  ucdQtyMultiplicator: 30,
  cipLib: "NORPROLAC 150MCG CPR BT 30",
  atcCode: "G02CB04"
}, {
  CIP7: '3386477',
  CIP13: '3400933864774',
  ucdLib: "NORPROLAC 25MCG/50MCG CPR",
  UCD7: '9177792',
  UCD13: '3400891777925',
  ucdQtyMultiplicator: 6,
  cipLib: "NORPROLAC 25MCG/50MCG CPR BT 6",
  atcCode: "G02CB04"
}, {
  CIP7: '3386508',
  CIP13: '3400933865085',
  ucdLib: "NORPROLAC 75MCG CPR",
  UCD7: '9177800',
  UCD13: '3400891778007',
  ucdQtyMultiplicator: 30,
  cipLib: "NORPROLAC 75MCG CPR BT 30",
  atcCode: "G02CB04"
}, {
  CIP7: '3404287',
  CIP13: '3400934042874',
  ucdLib: "DOSTINEX 0,5MG CPR",
  UCD7: '9199026',
  UCD13: '3400891990263',
  ucdQtyMultiplicator: 8,
  cipLib: "DOSTINEX 0,5MG CPR BT 8",
  atcCode: "G02CB03"
}, {
  CIP7: '3850354',
  CIP13: '3400938503548',
  ucdLib: "CABERGOLINE TVC 0,5MG CPR",
  UCD7: '9319051',
  UCD13: '3400893190517',
  ucdQtyMultiplicator: 8,
  cipLib: "CABERGOLINE TVC 0,5MG CPR BT 8",
  atcCode: "G02CB03"
}, {
  CIP7: '2694478',
  CIP13: '3400926944780',
  ucdLib: "CABERGOLINE SDZ 0,5MG CPR",
  UCD7: '9391433',
  UCD13: '3400893914335',
  ucdQtyMultiplicator: 2,
  cipLib: "CABERGOLINE SDZ 0,5MG CPR BT 2",
  atcCode: "G02CB03"
}, {
  CIP7: '2694490',
  CIP13: '3400926944902',
  ucdLib: "CABERGOLINE SDZ 0,5MG CPR",
  UCD7: '9391433',
  UCD13: '3400893914335',
  ucdQtyMultiplicator: 8,
  cipLib: "CABERGOLINE SDZ 0,5MG CPR BT 8",
  atcCode: "G02CB03"
}, {
  CIP7: '3348028',
  CIP13: '3400933480288',
  ucdLib: "AROLAC 0,2MG CPR",
  UCD7: '9168385',
  UCD13: '3400891683851',
  ucdQtyMultiplicator: 20,
  cipLib: "AROLAC 0,2MG CPR BT 20",
  atcCode: "G02CB02"
}, {
  CIP7: '3341575',
  CIP13: '3400933415754',
  ucdLib: "PARLODEL 2,5MG INHIB CPR",
  UCD7: '9292234',
  UCD13: '3400892922348',
  ucdQtyMultiplicator: 20,
  cipLib: "PARLODEL 2,5MG INHIB CPR BT 20",
  atcCode: "G02CB01"
}, {
  CIP7: '3358280',
  CIP13: '3400933582807',
  ucdLib: "BROMOCRIPTINE ZEN 2,5MG LACT",
  UCD7: '9169077',
  UCD13: '3400891690774',
  ucdQtyMultiplicator: 20,
  cipLib: "BROMOCRIPTINE ZEN 2,5MG LACT BT 20",
  atcCode: "G02CB01"
}, {
  CIP7: '3202655',
  CIP13: '3400932026555',
  ucdLib: "PARLODEL 2,5MG CPR",
  UCD7: '9067796',
  UCD13: '3400890677967',
  ucdQtyMultiplicator: 30,
  cipLib: "PARLODEL 2,5MG CPR BT 30",
  atcCode: "G02CB01"
}, {
  CIP7: '3352892',
  CIP13: '3400933528928',
  ucdLib: "ABUFENE 400MG CPR",
  UCD7: '9000332',
  UCD13: '3400890003322',
  ucdQtyMultiplicator: 30,
  cipLib: "ABUFENE 400MG CPR BT 30",
  atcCode: "G02C"
}, {
  CIP7: '2674458',
  CIP13: '3400926744588',
  ucdLib: "ABUFENE 400MG CPR",
  UCD7: '9000332',
  UCD13: '3400890003322',
  ucdQtyMultiplicator: 60,
  cipLib: "ABUFENE 400MG CPR BT 60",
  atcCode: "G02C"
}, {
  CIP7: '3630813',
  CIP13: '3400936308138',
  ucdLib: "NUVARING SYST DIFFUS VAG",
  UCD7: '9258510',
  UCD13: '3400892585109',
  ucdQtyMultiplicator: 1,
  cipLib: "NUVARING SYST DIFFUS VAG BT 1",
  atcCode: "G02BB01"
}, {
  CIP7: '3630836',
  CIP13: '3400936308367',
  ucdLib: "NUVARING SYST DIFFUS VAG",
  UCD7: '9258510',
  UCD13: '3400892585109',
  ucdQtyMultiplicator: 3,
  cipLib: "NUVARING SYST DIFFUS VAG BT 3",
  atcCode: "G02BB01"
}, {
  CIP7: '3392928',
  CIP13: '3400933929282',
  ucdLib: "MIRENA 52MG DIU BLIST",
  UCD7: '9196217',
  UCD13: '3400891962178',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRENA 52MG DIU BLIST BT 1",
  atcCode: "G02BA03"
}, {
  CIP7: '2741947',
  CIP13: '3400927419478',
  ucdLib: "JAYDESS 13,5MG SYST DIFF UTER",
  UCD7: '9399682',
  UCD13: '3400893996829',
  ucdQtyMultiplicator: 1,
  cipLib: "JAYDESS 13,5MG SYST DIFF UTER BT 1",
  atcCode: "G02BA03"
}, {
  CIP7: '3624994',
  CIP13: '3400936249943',
  ucdLib: "GYMISO 200MCG CPR",
  UCD7: '9259030',
  UCD13: '3400892590301',
  ucdQtyMultiplicator: 2,
  cipLib: "GYMISO 200MCG CPR BT 2",
  atcCode: "G02AD06"
}, {
  CIP7: '5849645',
  CIP13: '3400958496455',
  ucdLib: "MISOONE 400MCG CPR",
  UCD7: '9395945',
  UCD13: '3400893959459',
  ucdQtyMultiplicator: 16,
  cipLib: "MISOONE 400MCG CPR BT 16",
  atcCode: "G02AD06"
}, {
  CIP7: '5552520',
  CIP13: '3400955525202',
  ucdLib: "NALADOR 500MCG INJ AMP",
  UCD7: '9105002',
  UCD13: '3400891050028',
  ucdQtyMultiplicator: 1,
  cipLib: "NALADOR 500MCG INJ AMP BT 1",
  atcCode: "G02AD05"
}, {
  CIP7: '3273046',
  CIP13: '3400932730469',
  ucdLib: "CERVAGEME 1MG OV",
  UCD7: '9117844',
  UCD13: '3400891178449',
  ucdQtyMultiplicator: 1,
  cipLib: "CERVAGEME 1MG OV BT 1",
  atcCode: "G02AD03"
}, {
  CIP7: '5548435',
  CIP13: '3400955484356',
  ucdLib: "PROSTINE E2 1MG/ML A.0,75ML",
  UCD7: '9104729',
  UCD13: '3400891047295',
  ucdQtyMultiplicator: 1,
  cipLib: "PROSTINE E2 1MG/ML A.0,75ML BT 1",
  atcCode: "G02AD02"
}, {
  CIP7: '5559120',
  CIP13: '3400955591207',
  ucdLib: "PREPIDIL INTRACERV. SER.+CAT.",
  UCD7: '9129149',
  UCD13: '3400891291490',
  ucdQtyMultiplicator: 1,
  cipLib: "PREPIDIL INTRACERV. SER.+CAT. BT 1",
  atcCode: "G02AD02"
}, {
  CIP7: '5577483',
  CIP13: '3400955774839',
  ucdLib: "PROSTINE E2 1MG GEL VAG SER",
  UCD7: '9158286',
  UCD13: '3400891582864',
  ucdQtyMultiplicator: 1,
  cipLib: "PROSTINE E2 1MG GEL VAG SER BT 1",
  atcCode: "G02AD02"
}, {
  CIP7: '5577508',
  CIP13: '3400955775089',
  ucdLib: "PROSTINE E2 2MG GEL VAG SER",
  UCD7: '9158292',
  UCD13: '3400891582925',
  ucdQtyMultiplicator: 1,
  cipLib: "PROSTINE E2 2MG GEL VAG SER BT 1",
  atcCode: "G02AD02"
}, {
  CIP7: '5619744',
  CIP13: '3400956197446',
  ucdLib: "PROPESS 10MG DISP VAG SACH",
  UCD7: '9208044',
  UCD13: '3400892080444',
  ucdQtyMultiplicator: 5,
  cipLib: "PROPESS 10MG DISP VAG SACH BT 5",
  atcCode: "G02AD02"
}, {
  CIP7: '3066962',
  CIP13: '3400930669624',
  ucdLib: "METHERGIN 0,2MG INJ AMP1ML",
  UCD7: '9058484',
  UCD13: '3400890584845',
  ucdQtyMultiplicator: 3,
  cipLib: "METHERGIN 0,2MG INJ AMP1ML BT 3",
  atcCode: "G02AB01"
}, {
  CIP7: '5621971',
  CIP13: '3400956219711',
  ucdLib: "METHERGIN 0,2MG INJ AMP1ML",
  UCD7: '9058484',
  UCD13: '3400890584845',
  ucdQtyMultiplicator: 10,
  cipLib: "METHERGIN 0,2MG INJ AMP1ML BT 10",
  atcCode: "G02AB01"
}, {
  CIP7: '3010855',
  CIP13: '3400930108550',
  ucdLib: "BETADINE 10% SOL VAG FP125ML",
  UCD7: '9010388',
  UCD13: '3400890103886',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 10% SOL VAG FP125ML BT 1",
  atcCode: "G01AX11"
}, {
  CIP7: '3203100',
  CIP13: '3400932031009',
  ucdLib: "BETADINE 250MG OV",
  UCD7: '9102400',
  UCD13: '3400891024005',
  ucdQtyMultiplicator: 8,
  cipLib: "BETADINE 250MG OV BT 8",
  atcCode: "G01AX11"
}, {
  CIP7: '3492831',
  CIP13: '3400934928314',
  ucdLib: "BETADINE 10% SOL VAG D.10ML",
  UCD7: '9409191',
  UCD13: '3400894091912',
  ucdQtyMultiplicator: 10,
  cipLib: "BETADINE 10% SOL VAG D.10ML BT 10",
  atcCode: "G01AX11"
}, {
  CIP7: '5619336',
  CIP13: '3400956193363',
  ucdLib: "BETADINE 10% SOL VAG D.10ML",
  UCD7: '9409191',
  UCD13: '3400894091912',
  ucdQtyMultiplicator: 50,
  cipLib: "BETADINE 10% SOL VAG D.10ML BT 50",
  atcCode: "G01AX11"
}, {
  CIP7: '5523872',
  CIP13: '3400955238720',
  ucdLib: "BETADINE 10% SOL VAG FP500ML",
  UCD7: '9108259',
  UCD13: '3400891082593',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 10% SOL VAG FP500ML BT 1",
  atcCode: "G01AX11"
}, {
  CIP7: '3419521',
  CIP13: '3400934195211',
  ucdLib: "MONAZOL OV",
  UCD7: '9202981',
  UCD13: '3400892029818',
  ucdQtyMultiplicator: 1,
  cipLib: "MONAZOL OV BT 1",
  atcCode: "G01AF19"
}, {
  CIP7: '3378348',
  CIP13: '3400933783488',
  ucdLib: "LOMEXIN 600MG CAPS VAG",
  UCD7: '9176999',
  UCD13: '3400891769999',
  ucdQtyMultiplicator: 1,
  cipLib: "LOMEXIN 600MG CAPS VAG BT 1",
  atcCode: "G01AF12"
}, {
  CIP7: '3378331',
  CIP13: '3400933783310',
  ucdLib: "TERLOMEXIN 200MG CAPS VAG",
  UCD7: '9177125',
  UCD13: '3400891771251',
  ucdQtyMultiplicator: 3,
  cipLib: "TERLOMEXIN 200MG CAPS VAG BT 3",
  atcCode: "G01AF12"
}, {
  CIP7: '3690933',
  CIP13: '3400936909335',
  ucdLib: "LOMEXIN 600MG CAPS VAG",
  UCD7: '9176999',
  UCD13: '3400891769999',
  ucdQtyMultiplicator: 2,
  cipLib: "LOMEXIN 600MG CAPS VAG BT 2",
  atcCode: "G01AF12"
}, {
  CIP7: '3280721',
  CIP13: '3400932807215',
  ucdLib: "GYNO-TROSYD 300MG OV",
  UCD7: '9109106',
  UCD13: '3400891091069',
  ucdQtyMultiplicator: 1,
  cipLib: "GYNO-TROSYD 300MG OV BT 1",
  atcCode: "G01AF08"
}, {
  CIP7: '3234974',
  CIP13: '3400932349746',
  ucdLib: "FAZOL G 300MG OV",
  UCD7: '9034443',
  UCD13: '3400890344432',
  ucdQtyMultiplicator: 3,
  cipLib: "FAZOL G 300MG OV BT 3",
  atcCode: "G01AF07"
}, {
  CIP7: '3302411',
  CIP13: '3400933024116',
  ucdLib: "GYNO-PEVARYL LP 150MG OV",
  UCD7: '9129936',
  UCD13: '3400891299366',
  ucdQtyMultiplicator: 1,
  cipLib: "GYNO-PEVARYL LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3675750',
  CIP13: '3400936757509',
  ucdLib: "ECONAZOLE ARW LP 150MG OV",
  UCD7: '9271597',
  UCD13: '3400892715971',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE ARW LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3672680',
  CIP13: '3400936726802',
  ucdLib: "ECONAZOLE BGA LP 150MG OV",
  UCD7: '9269436',
  UCD13: '3400892694368',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE BGA LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3672668',
  CIP13: '3400936726680',
  ucdLib: "ECONAZOLE EG LP 150MG OV",
  UCD7: '9269442',
  UCD13: '3400892694429',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE EG LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3672645',
  CIP13: '3400936726451',
  ucdLib: "ECONAZOLE MYL LP 150MG OV",
  UCD7: '9269465',
  UCD13: '3400892694658',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE MYL LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3672697',
  CIP13: '3400936726970',
  ucdLib: "ECONAZOLE SDZ LP 150MG OV",
  UCD7: '9269488',
  UCD13: '3400892694887',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE SDZ LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3671120',
  CIP13: '3400936711204',
  ucdLib: "ECONAZOLE TVC LP 150MG OV",
  UCD7: '9273515',
  UCD13: '3400892735153',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE TVC LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3672674',
  CIP13: '3400936726741',
  ucdLib: "ECONAZOLE ZYD LP 150MG OV",
  UCD7: '9269459',
  UCD13: '3400892694597',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE ZYD LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3202276',
  CIP13: '3400932022762',
  ucdLib: "GYNO-PEVARYL 150MG OV",
  UCD7: '9041265',
  UCD13: '3400890412650',
  ucdQtyMultiplicator: 3,
  cipLib: "GYNO-PEVARYL 150MG OV BT 3",
  atcCode: "G01AF05"
}, {
  CIP7: '3769221',
  CIP13: '3400937692212',
  ucdLib: "ECONAZOLE RBX LP 150MG OV",
  UCD7: '9294374',
  UCD13: '3400892943749',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE RBX LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3746527',
  CIP13: '3400937465274',
  ucdLib: "MYLEUGYNE LP 150MG OV",
  UCD7: '9290287',
  UCD13: '3400892902876',
  ucdQtyMultiplicator: 1,
  cipLib: "MYLEUGYNE LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3775210',
  CIP13: '3400937752107',
  ucdLib: "ECONAZOLE ZEN LP 150MG OV",
  UCD7: '9298627',
  UCD13: '3400892986272',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE ZEN LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3800706',
  CIP13: '3400938007060',
  ucdLib: "GYNOPURA LP 150MG OV",
  UCD7: '9309503',
  UCD13: '3400893095034',
  ucdQtyMultiplicator: 1,
  cipLib: "GYNOPURA LP 150MG OV BT 1",
  atcCode: "G01AF05"
}, {
  CIP7: '3800712',
  CIP13: '3400938007121',
  ucdLib: "GYNOPURA LP 150MG OV",
  UCD7: '9309503',
  UCD13: '3400893095034',
  ucdQtyMultiplicator: 2,
  cipLib: "GYNOPURA LP 150MG OV BT 2",
  atcCode: "G01AF05"
}, {
  CIP7: '3986243',
  CIP13: '3400939862439',
  ucdLib: "MYLEUGYNE LP 150MG OV",
  UCD7: '9290287',
  UCD13: '3400892902876',
  ucdQtyMultiplicator: 2,
  cipLib: "MYLEUGYNE LP 150MG OV BT 2",
  atcCode: "G01AF05"
}, {
  CIP7: '3238713',
  CIP13: '3400932387137',
  ucdLib: "GYNO-DAKTARIN 400MG OV",
  UCD7: '9041213',
  UCD13: '3400890412131',
  ucdQtyMultiplicator: 3,
  cipLib: "GYNO-DAKTARIN 400MG OV BT 3",
  atcCode: "G01AF04"
}, {
  CIP7: '3419478',
  CIP13: '3400934194788',
  ucdLib: "MYCOHYDRALIN CR TB20G",
  UCD7: '9373056',
  UCD13: '3400893730560',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOHYDRALIN CR TB20G BT 1",
  atcCode: "G01AF02"
}, {
  CIP7: '4939866',
  CIP13: '3400949398669',
  ucdLib: "MYCOHYDRALIN 200MG C.VAG +APL",
  UCD7: '9373062',
  UCD13: '3400893730621',
  ucdQtyMultiplicator: 3,
  cipLib: "MYCOHYDRALIN 200MG C.VAG +APL BT 3",
  atcCode: "G01AF02"
}, {
  CIP7: '2796581',
  CIP13: '3400927965814',
  ucdLib: "MYCOHYDRALIN 500MG C.VAG +APL",
  UCD7: '9403923',
  UCD13: '3400894039235',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOHYDRALIN 500MG C.VAG +APL BT 1",
  atcCode: "G01AF02"
}, {
  CIP7: '3040017',
  CIP13: '3400930400173',
  ucdLib: "FLAGYL 500MG OV",
  UCD7: '9035106',
  UCD13: '3400890351065',
  ucdQtyMultiplicator: 10,
  cipLib: "FLAGYL 500MG OV BT 10",
  atcCode: "G01AF01"
}, {
  CIP7: '3415256',
  CIP13: '3400934152566',
  ucdLib: "TERGYNAN CPR VAG",
  UCD7: '9091240',
  UCD13: '3400890912402',
  ucdQtyMultiplicator: 10,
  cipLib: "TERGYNAN CPR VAG BT 10",
  atcCode: "G01AA51"
}, {
  CIP7: '4948351',
  CIP13: '3400949483518',
  ucdLib: "POLYGYNAX CAPS VAG",
  UCD7: '9073851',
  UCD13: '3400890738514',
  ucdQtyMultiplicator: 6,
  cipLib: "POLYGYNAX CAPS VAG BT 6",
  atcCode: "G01AA51"
}, {
  CIP7: '2161055',
  CIP13: '3400921610550',
  ucdLib: "POLYGYNAX VIRGO CAPS VAG",
  UCD7: '9073868',
  UCD13: '3400890738682',
  ucdQtyMultiplicator: 6,
  cipLib: "POLYGYNAX VIRGO CAPS VAG BT 6",
  atcCode: "G01AA51"
}, {
  CIP7: '5784785',
  CIP13: '3400957847852',
  ucdLib: "POLYGYNAX CAPS VAG",
  UCD7: '9073851',
  UCD13: '3400890738514',
  ucdQtyMultiplicator: 60,
  cipLib: "POLYGYNAX CAPS VAG BT 60",
  atcCode: "G01AA51"
}, {
  CIP7: '3002410',
  CIP13: '3400930024102',
  ucdLib: "SOOLANTRA 10MG/G CR TB15G",
  UCD7: '9411791',
  UCD13: '3400894117919',
  ucdQtyMultiplicator: 1,
  cipLib: "SOOLANTRA 10MG/G CR TB15G BT 1",
  atcCode: "D11AX22"
}, {
  CIP7: '2802778',
  CIP13: '3400928027788',
  ucdLib: "MIRVASO 3MG/G GEL TB30G",
  UCD7: '9414536',
  UCD13: '3400894145363',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRVASO 3MG/G GEL TB30G BT 1",
  atcCode: "D11AX21"
}, {
  CIP7: '3490803',
  CIP13: '3400934908033',
  ucdLib: "SOLARAZE 3% GEL TB25G",
  UCD7: '9247647',
  UCD13: '3400892476476',
  ucdQtyMultiplicator: 1,
  cipLib: "SOLARAZE 3% GEL TB25G BT 1",
  atcCode: "D11AX18"
}, {
  CIP7: '3567003',
  CIP13: '3400935670038',
  ucdLib: "VANIQA 11,5% CR TB30G",
  UCD7: '9265361',
  UCD13: '3400892653617',
  ucdQtyMultiplicator: 1,
  cipLib: "VANIQA 11,5% CR TB30G BT 1",
  atcCode: "D11AX16"
}, {
  CIP7: '3005500',
  CIP13: '3400930055007',
  ucdLib: "FINASTERIDE SDZ 1MG CPR",
  UCD7: '9335647',
  UCD13: '3400893356470',
  ucdQtyMultiplicator: 84,
  cipLib: "FINASTERIDE SDZ 1MG CPR BT 84",
  atcCode: "D11AX10"
}, {
  CIP7: '3490660',
  CIP13: '3400934906602',
  ucdLib: "PROPECIA 1MG CPR",
  UCD7: '9207004',
  UCD13: '3400892070049',
  ucdQtyMultiplicator: 28,
  cipLib: "PROPECIA 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '3490683',
  CIP13: '3400934906831',
  ucdLib: "PROPECIA 1MG CPR",
  UCD7: '9207004',
  UCD13: '3400892070049',
  ucdQtyMultiplicator: 84,
  cipLib: "PROPECIA 1MG CPR BT 84",
  atcCode: "D11AX10"
}, {
  CIP7: '3921700',
  CIP13: '3400939217000',
  ucdLib: "FINASTERIDE EG 1MG CPR",
  UCD7: '9335624',
  UCD13: '3400893356241',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE EG 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '3921870',
  CIP13: '3400939218700',
  ucdLib: "FINASTERIDE RTP 1MG CPR",
  UCD7: '9335630',
  UCD13: '3400893356302',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE RTP 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '3921597',
  CIP13: '3400939215976',
  ucdLib: "FINASTERIDE SDZ 1MG CPR",
  UCD7: '9335647',
  UCD13: '3400893356470',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE SDZ 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '3754171',
  CIP13: '3400937541718',
  ucdLib: "FINASTERIDE ZYD 1MG CPR",
  UCD7: '9357034',
  UCD13: '3400893570340',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ZYD 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '3954303',
  CIP13: '3400939543031',
  ucdLib: "FINASTERIDE MYL 1MG CPR",
  UCD7: '9342015',
  UCD13: '3400893420157',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE MYL 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '3954349',
  CIP13: '3400939543499',
  ucdLib: "FINASTERIDE MYL 1MG CPR",
  UCD7: '9342015',
  UCD13: '3400893420157',
  ucdQtyMultiplicator: 84,
  cipLib: "FINASTERIDE MYL 1MG CPR BT 84",
  atcCode: "D11AX10"
}, {
  CIP7: '3981352',
  CIP13: '3400939813523',
  ucdLib: "FINASTERIDE ARG 1MG CPR",
  UCD7: '9346496',
  UCD13: '3400893464960',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE ARG 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '3981168',
  CIP13: '3400939811680',
  ucdLib: "FINASTERIDE BGA 1MG CPR",
  UCD7: '9346504',
  UCD13: '3400893465042',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE BGA 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '3981180',
  CIP13: '3400939811802',
  ucdLib: "FINASTERIDE BGA 1MG CPR",
  UCD7: '9346504',
  UCD13: '3400893465042',
  ucdQtyMultiplicator: 84,
  cipLib: "FINASTERIDE BGA 1MG CPR BT 84",
  atcCode: "D11AX10"
}, {
  CIP7: '4195130',
  CIP13: '3400941951305',
  ucdLib: "FINASTERIDE TVC 1MG CPR",
  UCD7: '9380257',
  UCD13: '3400893802571',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE TVC 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '4195153',
  CIP13: '3400941951534',
  ucdLib: "FINASTERIDE TVC 1MG CPR",
  UCD7: '9380257',
  UCD13: '3400893802571',
  ucdQtyMultiplicator: 84,
  cipLib: "FINASTERIDE TVC 1MG CPR BT 84",
  atcCode: "D11AX10"
}, {
  CIP7: '4151776',
  CIP13: '3400941517761',
  ucdLib: "FINHAIR 1MG CPR",
  UCD7: '9405690',
  UCD13: '3400894056904',
  ucdQtyMultiplicator: 28,
  cipLib: "FINHAIR 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '4151799',
  CIP13: '3400941517990',
  ucdLib: "FINHAIR 1MG CPR",
  UCD7: '9405690',
  UCD13: '3400894056904',
  ucdQtyMultiplicator: 84,
  cipLib: "FINHAIR 1MG CPR BT 84",
  atcCode: "D11AX10"
}, {
  CIP7: '2683871',
  CIP13: '3400926838713',
  ucdLib: "FINASTERIDE BLL 1MG CPR",
  UCD7: '9397200',
  UCD13: '3400893972007',
  ucdQtyMultiplicator: 28,
  cipLib: "FINASTERIDE BLL 1MG CPR BT 28",
  atcCode: "D11AX10"
}, {
  CIP7: '2683894',
  CIP13: '3400926838942',
  ucdLib: "FINASTERIDE BLL 1MG CPR",
  UCD7: '9397200',
  UCD13: '3400893972007',
  ucdQtyMultiplicator: 84,
  cipLib: "FINASTERIDE BLL 1MG CPR BT 84",
  atcCode: "D11AX10"
}, {
  CIP7: '3061344',
  CIP13: '3400930613443',
  ucdLib: "LEUCODININE B 10% POM TB30G",
  UCD7: '9053825',
  UCD13: '3400890538251',
  ucdQtyMultiplicator: 1,
  cipLib: "LEUCODININE B 10% POM TB30G BT 1",
  atcCode: "D11AX06"
}, {
  CIP7: '3369734',
  CIP13: '3400933697341',
  ucdLib: "CLAIRODERMYL 10% CR TB30G",
  UCD7: '9163063',
  UCD13: '3400891630633',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAIRODERMYL 10% CR TB30G BT 1",
  atcCode: "D11AX06"
}, {
  CIP7: '3369728',
  CIP13: '3400933697280',
  ucdLib: "CLAIRODERMYL 5% CR TB30G",
  UCD7: '9163086',
  UCD13: '3400891630862',
  ucdQtyMultiplicator: 1,
  cipLib: "CLAIRODERMYL 5% CR TB30G BT 1",
  atcCode: "D11AX06"
}, {
  CIP7: '3416379',
  CIP13: '3400934163791',
  ucdLib: "ANY 8% POM TB25G",
  UCD7: '9200019',
  UCD13: '3400892000190',
  ucdQtyMultiplicator: 1,
  cipLib: "ANY 8% POM TB25G BT 1",
  atcCode: "D11AX06"
}, {
  CIP7: '3308744',
  CIP13: '3400933087449',
  ucdLib: "ALOSTIL 2% SOL FP60ML",
  UCD7: '9118281',
  UCD13: '3400891182811',
  ucdQtyMultiplicator: 3,
  cipLib: "ALOSTIL 2% SOL FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3689137',
  CIP13: '3400936891371',
  ucdLib: "MINOXIDIL BLL 5% LOC FP60ML",
  UCD7: '9277476',
  UCD13: '3400892774763',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL BLL 5% LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3359500',
  CIP13: '3400933595005',
  ucdLib: "MINOXIDIL CPF 2% LOC FV60ML",
  UCD7: '9221659',
  UCD13: '3400892216591',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL CPF 2% LOC FV60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3675632',
  CIP13: '3400936756328',
  ucdLib: "MINOXIDIL SDC 5% LOC FP60ML",
  UCD7: '9271634',
  UCD13: '3400892716343',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL SDC 5% LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3398730',
  CIP13: '3400933987305',
  ucdLib: "ALOSTIL 5% SOL FP60ML +TAMP",
  UCD7: '9204980',
  UCD13: '3400892049809',
  ucdQtyMultiplicator: 3,
  cipLib: "ALOSTIL 5% SOL FP60ML +TAMP BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3547851',
  CIP13: '3400935478511',
  ucdLib: "UNIPEXIL 2% LOC FV60ML",
  UCD7: '9221665',
  UCD13: '3400892216652',
  ucdQtyMultiplicator: 3,
  cipLib: "UNIPEXIL 2% LOC FV60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3635986',
  CIP13: '3400936359864',
  ucdLib: "MINOXIDIL BLL 2% LOC FP60ML",
  UCD7: '9260613',
  UCD13: '3400892606132',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL BLL 2% LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3814602',
  CIP13: '3400938146028',
  ucdLib: "MINOXIDIL SDC 2% LOC FP60ML",
  UCD7: '9315886',
  UCD13: '3400893158869',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL SDC 2% LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3643075',
  CIP13: '3400936430754',
  ucdLib: "ALOPEXY 2% SOL LOC FP60ML",
  UCD7: '9291045',
  UCD13: '3400892910451',
  ucdQtyMultiplicator: 3,
  cipLib: "ALOPEXY 2% SOL LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3844046',
  CIP13: '3400938440461',
  ucdLib: "ALOPEXY 5% SOL LOC FV60ML +NEC",
  UCD7: '9317997',
  UCD13: '3400893179970',
  ucdQtyMultiplicator: 3,
  cipLib: "ALOPEXY 5% SOL LOC FV60ML +NEC BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '2216098',
  CIP13: '3400922160986',
  ucdLib: "MINOXIDIL TCO 5% LOC FL60ML",
  UCD7: '9403969',
  UCD13: '3400894039693',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL TCO 5% LOC FL60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '2666051',
  CIP13: '3400926660512',
  ucdLib: "ALOSTIL 5% MOUS FL PRESS 60G",
  UCD7: '9397507',
  UCD13: '3400893975077',
  ucdQtyMultiplicator: 3,
  cipLib: "ALOSTIL 5% MOUS FL PRESS 60G BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '4933467',
  CIP13: '3400949334674',
  ucdLib: "MINOXIDIL MYL 5% LOC FP60ML",
  UCD7: '9361550',
  UCD13: '3400893615508',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL MYL 5% LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '2172521',
  CIP13: '3400921725216',
  ucdLib: "MINOXIDIL CPF 5% LOC FP60ML",
  UCD7: '9387124',
  UCD13: '3400893871249',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL CPF 5% LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '2187497',
  CIP13: '3400921874976',
  ucdLib: "MINOXIDIL MYL 2% LOC FP60ML",
  UCD7: '9374647',
  UCD13: '3400893746479',
  ucdQtyMultiplicator: 3,
  cipLib: "MINOXIDIL MYL 2% LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '2685769',
  CIP13: '3400926857691',
  ucdLib: "UNIPEXIL 5% LOC FP60ML",
  UCD7: '9395589',
  UCD13: '3400893955895',
  ucdQtyMultiplicator: 3,
  cipLib: "UNIPEXIL 5% LOC FP60ML BT 3",
  atcCode: "D11AX01"
}, {
  CIP7: '3896008',
  CIP13: '3400938960082',
  ucdLib: "TOCTINO 10MG CAPS MOL",
  UCD7: '9335251',
  UCD13: '3400893352519',
  ucdQtyMultiplicator: 30,
  cipLib: "TOCTINO 10MG CAPS MOL BT 30",
  atcCode: "D11AH04"
}, {
  CIP7: '3896020',
  CIP13: '3400938960204',
  ucdLib: "TOCTINO 30MG CAPS MOL",
  UCD7: '9335268',
  UCD13: '3400893352687',
  ucdQtyMultiplicator: 30,
  cipLib: "TOCTINO 30MG CAPS MOL BT 30",
  atcCode: "D11AH04"
}, {
  CIP7: '3592219',
  CIP13: '3400935922199',
  ucdLib: "PROTOPIC 0,03% POM TB30G",
  UCD7: '9247156',
  UCD13: '3400892471563',
  ucdQtyMultiplicator: 1,
  cipLib: "PROTOPIC 0,03% POM TB30G BT 1",
  atcCode: "D11AH01"
}, {
  CIP7: '3592231',
  CIP13: '3400935922311',
  ucdLib: "PROTOPIC 0,1% POM TB30G",
  UCD7: '9247162',
  UCD13: '3400892471624',
  ucdQtyMultiplicator: 1,
  cipLib: "PROTOPIC 0,1% POM TB30G BT 1",
  atcCode: "D11AH01"
}, {
  CIP7: '3030378',
  CIP13: '3400930303788',
  ucdLib: "DIABLE CORICIDE LOC SOL FL4G",
  UCD7: '9026053',
  UCD13: '3400890260534',
  ucdQtyMultiplicator: 1,
  cipLib: "DIABLE CORICIDE LOC SOL FL4G BT 1",
  atcCode: "D11AF"
}, {
  CIP7: '3039758',
  CIP13: '3400930397589',
  ucdLib: "FEUILLE SAULE GILB. COR EMPL",
  UCD7: '9034851',
  UCD13: '3400890348515',
  ucdQtyMultiplicator: 9,
  cipLib: "FEUILLE SAULE GILB. COR EMPL BT 9",
  atcCode: "D11AF"
}, {
  CIP7: '3039764',
  CIP13: '3400930397640',
  ucdLib: "FEUILLE SAULE GILB. DUR EMPL",
  UCD7: '9034868',
  UCD13: '3400890348683',
  ucdQtyMultiplicator: 5,
  cipLib: "FEUILLE SAULE GILB. DUR EMPL BT 5",
  atcCode: "D11AF"
}, {
  CIP7: '3039770',
  CIP13: '3400930397701',
  ucdLib: "FEUILLE SAULE GILB. EMPL",
  UCD7: '9034839',
  UCD13: '3400890348393',
  ucdQtyMultiplicator: 1,
  cipLib: "FEUILLE SAULE GILB. EMPL BT 1",
  atcCode: "D11AF"
}, {
  CIP7: '3295007',
  CIP13: '3400932950072',
  ucdLib: "VERRUPAN BAUM FL4ML",
  UCD7: '9098325',
  UCD13: '3400890983259',
  ucdQtyMultiplicator: 2,
  cipLib: "VERRUPAN BAUM FL4ML BT 2",
  atcCode: "D11AF"
}, {
  CIP7: '3024001',
  CIP13: '3400930240014',
  ucdLib: "COCHON M.O. 50% POM POT10G",
  UCD7: '9020613',
  UCD13: '3400890206136',
  ucdQtyMultiplicator: 1,
  cipLib: "COCHON M.O. 50% POM POT10G BT 1",
  atcCode: "D11AF"
}, {
  CIP7: '3259520',
  CIP13: '3400932595204',
  ucdLib: "KERAFILM LOC SOL FL10ML+RONDEL",
  UCD7: '9048907',
  UCD13: '3400890489072',
  ucdQtyMultiplicator: 1,
  cipLib: "KERAFILM LOC SOL FL10ML+RONDEL BT 1",
  atcCode: "D11AF"
}, {
  CIP7: '3246374',
  CIP13: '3400932463749',
  ucdLib: "DUOFILM SOL LOC FL15ML",
  UCD7: '9029376',
  UCD13: '3400890293761',
  ucdQtyMultiplicator: 1,
  cipLib: "DUOFILM SOL LOC FL15ML BT 1",
  atcCode: "D11AF"
}, {
  CIP7: '3094214',
  CIP13: '3400930942147',
  ucdLib: "SANITOS LOC SOL FL5ML",
  UCD7: '9082181',
  UCD13: '3400890821810',
  ucdQtyMultiplicator: 1,
  cipLib: "SANITOS LOC SOL FL5ML BT 1",
  atcCode: "D11AF"
}, {
  CIP7: '3392762',
  CIP13: '3400933927622',
  ucdLib: "VERRUFILM LOC SOL FL14ML",
  UCD7: '9176203',
  UCD13: '3400891762037',
  ucdQtyMultiplicator: 1,
  cipLib: "VERRUFILM LOC SOL FL14ML BT 1",
  atcCode: "D11AF"
}, {
  CIP7: '3487333',
  CIP13: '3400934873331',
  ucdLib: "TRANSVERCID 12MM DISP SACH",
  UCD7: '9209405',
  UCD13: '3400892094052',
  ucdQtyMultiplicator: 8,
  cipLib: "TRANSVERCID 12MM DISP SACH BT 8",
  atcCode: "D11AF"
}, {
  CIP7: '3594129',
  CIP13: '3400935941299',
  ucdLib: "TRANSVERCID 6MM DISP SACH",
  UCD7: '9209411',
  UCD13: '3400892094113',
  ucdQtyMultiplicator: 10,
  cipLib: "TRANSVERCID 6MM DISP SACH BT 10",
  atcCode: "D11AF"
}, {
  CIP7: '3181114',
  CIP13: '3400931811145',
  ucdLib: "FEUILLE SAULE GILB. LIQ FL5ML",
  UCD7: '9038381',
  UCD13: '3400890383813',
  ucdQtyMultiplicator: 1,
  cipLib: "FEUILLE SAULE GILB. LIQ FL5ML BT 1",
  atcCode: "D11AF"
}, {
  CIP7: '3352478',
  CIP13: '3400933524784',
  ucdLib: "GRANIONS ZINC BUV AMP2ML",
  UCD7: '9158369',
  UCD13: '3400891583694',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS ZINC BUV AMP2ML BT 30",
  atcCode: "D10BX"
}, {
  CIP7: '3611477',
  CIP13: '3400936114777',
  ucdLib: "ACNETRAIT 10MG CAPS MOL",
  UCD7: '9246607',
  UCD13: '3400892466071',
  ucdQtyMultiplicator: 30,
  cipLib: "ACNETRAIT 10MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3611483',
  CIP13: '3400936114838',
  ucdLib: "ACNETRAIT 20MG CAPS MOL",
  UCD7: '9246613',
  UCD13: '3400892466132',
  ucdQtyMultiplicator: 30,
  cipLib: "ACNETRAIT 20MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3578389',
  CIP13: '3400935783899',
  ucdLib: "PROCUTA 10MG CAPS MOL",
  UCD7: '9237293',
  UCD13: '3400892372938',
  ucdQtyMultiplicator: 30,
  cipLib: "PROCUTA 10MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3578366',
  CIP13: '3400935783660',
  ucdLib: "PROCUTA 20MG CAPS MOL",
  UCD7: '9237301',
  UCD13: '3400892373010',
  ucdQtyMultiplicator: 30,
  cipLib: "PROCUTA 20MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3578403',
  CIP13: '3400935784032',
  ucdLib: "PROCUTA 5MG CAPS MOL",
  UCD7: '9237318',
  UCD13: '3400892373188',
  ucdQtyMultiplicator: 30,
  cipLib: "PROCUTA 5MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3678843',
  CIP13: '3400936788435',
  ucdLib: "CONTRACNE 40MG CAPS MOL",
  UCD7: '9273389',
  UCD13: '3400892733890',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTRACNE 40MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3676034',
  CIP13: '3400936760349',
  ucdLib: "CURACNE 40MG CAPS MOL",
  UCD7: '9273395',
  UCD13: '3400892733951',
  ucdQtyMultiplicator: 30,
  cipLib: "CURACNE 40MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3678808',
  CIP13: '3400936788084',
  ucdLib: "PROCUTA 40MG CAPS MOL",
  UCD7: '9273461',
  UCD13: '3400892734613',
  ucdQtyMultiplicator: 30,
  cipLib: "PROCUTA 40MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3581204',
  CIP13: '3400935812049',
  ucdLib: "CONTRACNE 10MG CAPS MOL",
  UCD7: '9270669',
  UCD13: '3400892706696',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTRACNE 10MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3581167',
  CIP13: '3400935811677',
  ucdLib: "CONTRACNE 20MG CAPS MOL",
  UCD7: '9270675',
  UCD13: '3400892706757',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTRACNE 20MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3581316',
  CIP13: '3400935813169',
  ucdLib: "CURACNE 10MG CAPS MOL",
  UCD7: '9237778',
  UCD13: '3400892377780',
  ucdQtyMultiplicator: 30,
  cipLib: "CURACNE 10MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3581368',
  CIP13: '3400935813688',
  ucdLib: "CURACNE 20MG CAPS MOL",
  UCD7: '9237784',
  UCD13: '3400892377841',
  ucdQtyMultiplicator: 30,
  cipLib: "CURACNE 20MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3581256',
  CIP13: '3400935812568',
  ucdLib: "CURACNE 5MG CAPS MOL",
  UCD7: '9237790',
  UCD13: '3400892377902',
  ucdQtyMultiplicator: 30,
  cipLib: "CURACNE 5MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3826019',
  CIP13: '3400938260199',
  ucdLib: "CONTRACNE 5MG CAPS MOL",
  UCD7: '9309578',
  UCD13: '3400893095782',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTRACNE 5MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3976316',
  CIP13: '3400939763163',
  ucdLib: "ACNETRAIT 40MG CAPS MOL",
  UCD7: '9352491',
  UCD13: '3400893524916',
  ucdQtyMultiplicator: 30,
  cipLib: "ACNETRAIT 40MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3905227',
  CIP13: '3400939052274',
  ucdLib: "ACNETRAIT 5MG CAPS MOL",
  UCD7: '9326720',
  UCD13: '3400893267202',
  ucdQtyMultiplicator: 30,
  cipLib: "ACNETRAIT 5MG CAPS MOL BT 30",
  atcCode: "D10BA01"
}, {
  CIP7: '3324482',
  CIP13: '3400933244828',
  ucdLib: "SKINOREN 20% LOC CR TB30G",
  UCD7: '9140286',
  UCD13: '3400891402865',
  ucdQtyMultiplicator: 1,
  cipLib: "SKINOREN 20% LOC CR TB30G BT 1",
  atcCode: "D10AX03"
}, {
  CIP7: '3624445',
  CIP13: '3400936244450',
  ucdLib: "FINACEA 15% GEL TB30G",
  UCD7: '9259828',
  UCD13: '3400892598284',
  ucdQtyMultiplicator: 1,
  cipLib: "FINACEA 15% GEL TB30G BT 1",
  atcCode: "D10AX03"
}, {
  CIP7: '3424344',
  CIP13: '3400934243448',
  ucdLib: "ERYLIK GEL TB30G",
  UCD7: '9196594',
  UCD13: '3400891965940',
  ucdQtyMultiplicator: 1,
  cipLib: "ERYLIK GEL TB30G BT 1",
  atcCode: "D10AF52"
}, {
  CIP7: '2773812',
  CIP13: '3400927738128',
  ucdLib: "ZANEA 10MG/0,25MG/G GEL TB30G",
  UCD7: '9404609',
  UCD13: '3400894046097',
  ucdQtyMultiplicator: 1,
  cipLib: "ZANEA 10MG/0,25MG/G GEL TB30G BT 1",
  atcCode: "D10AF51"
}, {
  CIP7: '3284021',
  CIP13: '3400932840212',
  ucdLib: "ERYFLUID LOT FV30ML",
  UCD7: '9131212',
  UCD13: '3400891312126',
  ucdQtyMultiplicator: 1,
  cipLib: "ERYFLUID LOT FV30ML BT 1",
  atcCode: "D10AF02"
}, {
  CIP7: '3267100',
  CIP13: '3400932671007',
  ucdLib: "ERYFLUID LOT FV100ML",
  UCD7: '9032102',
  UCD13: '3400890321020',
  ucdQtyMultiplicator: 1,
  cipLib: "ERYFLUID LOT FV100ML BT 1",
  atcCode: "D10AF02"
}, {
  CIP7: '3267092',
  CIP13: '3400932670925',
  ucdLib: "ERYTHROGEL 4% GEL LOC TB30G",
  UCD7: '9032208',
  UCD13: '3400890322089',
  ucdQtyMultiplicator: 1,
  cipLib: "ERYTHROGEL 4% GEL LOC TB30G BT 1",
  atcCode: "D10AF02"
}, {
  CIP7: '3311410',
  CIP13: '3400933114107',
  ucdLib: "ERYTHROMYCINE BLL 4% SOL 100ML",
  UCD7: '9146509',
  UCD13: '3400891465099',
  ucdQtyMultiplicator: 1,
  cipLib: "ERYTHROMYCINE BLL 4% SOL 100ML BT 1",
  atcCode: "D10AF02"
}, {
  CIP7: '3615699',
  CIP13: '3400936156999',
  ucdLib: "ZINDACLINE 1% GEL TB30G",
  UCD7: '9250520',
  UCD13: '3400892505206',
  ucdQtyMultiplicator: 1,
  cipLib: "ZINDACLINE 1% GEL TB30G BT 1",
  atcCode: "D10AF01"
}, {
  CIP7: '3265696',
  CIP13: '3400932656967',
  ucdLib: "DALACINE T TOPIC SOL FL30ML",
  UCD7: '9023942',
  UCD13: '3400890239424',
  ucdQtyMultiplicator: 1,
  cipLib: "DALACINE T TOPIC SOL FL30ML BT 1",
  atcCode: "D10AF01"
}, {
  CIP7: '3000969',
  CIP13: '3400930009697',
  ucdLib: "CURASPOTAQUA 5% GEL TB50G",
  UCD7: '9419887',
  UCD13: '3400894198871',
  ucdQtyMultiplicator: 1,
  cipLib: "CURASPOTAQUA 5% GEL TB50G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '3281258',
  CIP13: '3400932812585',
  ucdLib: "CUTACNYL 10G GEL LOC TB40G",
  UCD7: '9105083',
  UCD13: '3400891050837',
  ucdQtyMultiplicator: 1,
  cipLib: "CUTACNYL 10G GEL LOC TB40G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '3282565',
  CIP13: '3400932825653',
  ucdLib: "CUTACNYL 5% GEL LOC TB40G",
  UCD7: '9105108',
  UCD13: '3400891051087',
  ucdQtyMultiplicator: 1,
  cipLib: "CUTACNYL 5% GEL LOC TB40G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '3273112',
  CIP13: '3400932731121',
  ucdLib: "CUTACNYL 2,5% GEL LOC TB40G",
  UCD7: '9106875',
  UCD13: '3400891068757',
  ucdQtyMultiplicator: 1,
  cipLib: "CUTACNYL 2,5% GEL LOC TB40G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '3433567',
  CIP13: '3400934335679',
  ucdLib: "PANNOGEL 10 GEL LOC TB40G",
  UCD7: '9197777',
  UCD13: '3400891977776',
  ucdQtyMultiplicator: 1,
  cipLib: "PANNOGEL 10 GEL LOC TB40G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '3433550',
  CIP13: '3400934335501',
  ucdLib: "PAPCLAIR 5% GEL TB40G",
  UCD7: '9197783',
  UCD13: '3400891977837',
  ucdQtyMultiplicator: 1,
  cipLib: "PAPCLAIR 5% GEL TB40G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '3545800',
  CIP13: '3400935458001',
  ucdLib: "CURASPOTAQUA 5% GEL TB100G",
  UCD7: '9351801',
  UCD13: '3400893518014',
  ucdQtyMultiplicator: 1,
  cipLib: "CURASPOTAQUA 5% GEL TB100G BT 1",
  atcCode: "D10AE01"
}, {
  CIP7: '2761111',
  CIP13: '3400927611117',
  ucdLib: "EPIDUO GEL M-DOS30G",
  UCD7: '9403099',
  UCD13: '3400894030997',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIDUO GEL M-DOS30G BT 1",
  atcCode: "D10AD53"
}, {
  CIP7: '2761128',
  CIP13: '3400927611285',
  ucdLib: "EPIDUO GEL M-DOS45G",
  UCD7: '9419893',
  UCD13: '3400894198932',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIDUO GEL M-DOS45G BT 1",
  atcCode: "D10AD53"
}, {
  CIP7: '3347170',
  CIP13: '3400933471705',
  ucdLib: "ROACCUTANE 0,05% GEL LOC TB30G",
  UCD7: '9153188',
  UCD13: '3400891531886',
  ucdQtyMultiplicator: 1,
  cipLib: "ROACCUTANE 0,05% GEL LOC TB30G BT 1",
  atcCode: "D10AD04"
}, {
  CIP7: '3378874',
  CIP13: '3400933788742',
  ucdLib: "DIFFERINE 0,1% GEL TB30G",
  UCD7: '9172547',
  UCD13: '3400891725476',
  ucdQtyMultiplicator: 1,
  cipLib: "DIFFERINE 0,1% GEL TB30G BT 1",
  atcCode: "D10AD03"
}, {
  CIP7: '3437631',
  CIP13: '3400934376313',
  ucdLib: "DIFFERINE 0,1% CR TB30G",
  UCD7: '9203302',
  UCD13: '3400892033020',
  ucdQtyMultiplicator: 1,
  cipLib: "DIFFERINE 0,1% CR TB30G BT 1",
  atcCode: "D10AD03"
}, {
  CIP7: '4924327',
  CIP13: '3400949243273',
  ucdLib: "ADAPALENE TVC 0,1% CR TB30G",
  UCD7: '9356224',
  UCD13: '3400893562246',
  ucdQtyMultiplicator: 1,
  cipLib: "ADAPALENE TVC 0,1% CR TB30G BT 1",
  atcCode: "D10AD03"
}, {
  CIP7: '4924296',
  CIP13: '3400949242962',
  ucdLib: "ADAPALENE ZEN 0,1% CR TB30G",
  UCD7: '9356247',
  UCD13: '3400893562475',
  ucdQtyMultiplicator: 1,
  cipLib: "ADAPALENE ZEN 0,1% CR TB30G BT 1",
  atcCode: "D10AD03"
}, {
  CIP7: '4924362',
  CIP13: '3400949243624',
  ucdLib: "ADAPALENE ZEN 0,1% GEL TB30G",
  UCD7: '9356253',
  UCD13: '3400893562536',
  ucdQtyMultiplicator: 1,
  cipLib: "ADAPALENE ZEN 0,1% GEL TB30G BT 1",
  atcCode: "D10AD03"
}, {
  CIP7: '3237292',
  CIP13: '3400932372928',
  ucdLib: "LOCACID 0,05% CR DERM TB30G",
  UCD7: '9054807',
  UCD13: '3400890548076',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCACID 0,05% CR DERM TB30G BT 1",
  atcCode: "D10AD01"
}, {
  CIP7: '3318501',
  CIP13: '3400933185015',
  ucdLib: "RETACNYL 0,05 CR TB30G",
  UCD7: '9140808',
  UCD13: '3400891408089',
  ucdQtyMultiplicator: 1,
  cipLib: "RETACNYL 0,05 CR TB30G BT 1",
  atcCode: "D10AD01"
}, {
  CIP7: '3334434',
  CIP13: '3400933344344',
  ucdLib: "RETACNYL 0,025 CR TB30G",
  UCD7: '9147584',
  UCD13: '3400891475845',
  ucdQtyMultiplicator: 1,
  cipLib: "RETACNYL 0,025 CR TB30G BT 1",
  atcCode: "D10AD01"
}, {
  CIP7: '3227069',
  CIP13: '3400932270699',
  ucdLib: "EFFEDERM LOC SOL FL50ML",
  UCD7: '9030439',
  UCD13: '3400890304399',
  ucdQtyMultiplicator: 1,
  cipLib: "EFFEDERM LOC SOL FL50ML BT 1",
  atcCode: "D10AD01"
}, {
  CIP7: '3408836',
  CIP13: '3400934088360',
  ucdLib: "KETREL 0,050% CR TB30G",
  UCD7: '9188057',
  UCD13: '3400891880571',
  ucdQtyMultiplicator: 1,
  cipLib: "KETREL 0,050% CR TB30G BT 1",
  atcCode: "D10AD01"
}, {
  CIP7: '3176277',
  CIP13: '3400931762775',
  ucdLib: "EFFEDERM 0,05% CR TB30G",
  UCD7: '9030422',
  UCD13: '3400890304221',
  ucdQtyMultiplicator: 1,
  cipLib: "EFFEDERM 0,05% CR TB30G BT 1",
  atcCode: "D10AD01"
}, {
  CIP7: '3203287',
  CIP13: '3400932032877',
  ucdLib: "BETADINE 350MG CPRESS SACH",
  UCD7: '9010336',
  UCD13: '3400890103367',
  ucdQtyMultiplicator: 6,
  cipLib: "BETADINE 350MG CPRESS SACH BT 6",
  atcCode: "D09AA09"
}, {
  CIP7: '3219408',
  CIP13: '3400932194087',
  ucdLib: "BETADINE TUL10% 10X10 PANS PE",
  UCD7: '9010402',
  UCD13: '3400890104029',
  ucdQtyMultiplicator: 10,
  cipLib: "BETADINE TUL10% 10X10 PANS PE BT 10",
  atcCode: "D09AA09"
}, {
  CIP7: '3646292',
  CIP13: '3400936462922',
  ucdLib: "BETADINE TUL10% 10X10 PANS PP",
  UCD7: '9273113',
  UCD13: '3400892731131',
  ucdQtyMultiplicator: 5,
  cipLib: "BETADINE TUL10% 10X10 PANS PP BT 5",
  atcCode: "D09AA09"
}, {
  CIP7: '5523961',
  CIP13: '3400955239611',
  ucdLib: "BETADINE 350MG CPRESS SACH",
  UCD7: '9010336',
  UCD13: '3400890103367',
  ucdQtyMultiplicator: 50,
  cipLib: "BETADINE 350MG CPRESS SACH BT 50",
  atcCode: "D09AA09"
}, {
  CIP7: '3315891',
  CIP13: '3400933158910',
  ucdLib: "ALCOOL MEDICAL GILB FP250ML",
  UCD7: '9134989',
  UCD13: '3400891349894',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MEDICAL GILB FP250ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3432332',
  CIP13: '3400934323324',
  ucdLib: "ALCOOL MEDICAL GILB FP500ML",
  UCD7: '9372832',
  UCD13: '3400893728321',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MEDICAL GILB FP500ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3431640',
  CIP13: '3400934316401',
  ucdLib: "ALCOOL MODIFIE COOPER FP125ML",
  UCD7: '9195413',
  UCD13: '3400891954135',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE COOPER FP125ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3431657',
  CIP13: '3400934316579',
  ucdLib: "ALCOOL MODIFIE COOPER FP250ML",
  UCD7: '9195436',
  UCD13: '3400891954364',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE COOPER FP250ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3431663',
  CIP13: '3400934316630',
  ucdLib: "ALCOOL MODIFIE COOPER FP500ML",
  UCD7: '9215357',
  UCD13: '3400892153575',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE COOPER FP500ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3340647',
  CIP13: '3400933406479',
  ucdLib: "ALCOOL MODIFIE GIFRER FP125ML",
  UCD7: '9187595',
  UCD13: '3400891875959',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE GIFRER FP125ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3340653',
  CIP13: '3400933406530',
  ucdLib: "ALCOOL MODIFIE GIFRER FP250ML",
  UCD7: '9153426',
  UCD13: '3400891534269',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE GIFRER FP250ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3340676',
  CIP13: '3400933406769',
  ucdLib: "ALCOOL MODIFIE GIFRER FP500ML",
  UCD7: '9153432',
  UCD13: '3400891534320',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE GIFRER FP500ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3186525',
  CIP13: '3400931865254',
  ucdLib: "ALCOOL MED GILB 2,5ML CPRESS",
  UCD7: '9070864',
  UCD13: '3400890708647',
  ucdQtyMultiplicator: 12,
  cipLib: "ALCOOL MED GILB 2,5ML CPRESS BT 12",
  atcCode: "D08AX08"
}, {
  CIP7: '5608195',
  CIP13: '3400956081950',
  ucdLib: "ALCOOL MED GILB 2,5ML CPRESS",
  UCD7: '9070864',
  UCD13: '3400890708647',
  ucdQtyMultiplicator: 200,
  cipLib: "ALCOOL MED GILB 2,5ML CPRESS BT 200",
  atcCode: "D08AX08"
}, {
  CIP7: '3767305',
  CIP13: '3400937673051',
  ucdLib: "ALCOOL MODIFIE EVL LOC FP125ML",
  UCD7: '9312008',
  UCD13: '3400893120088',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE EVL LOC FP125ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3767311',
  CIP13: '3400937673112',
  ucdLib: "ALCOOL MODIFIE EVL LOC FP250ML",
  UCD7: '9312014',
  UCD13: '3400893120149',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MODIFIE EVL LOC FP250ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '4184511',
  CIP13: '3400941845116',
  ucdLib: "ALCOOL MEDICAL GILB FP125ML",
  UCD7: '9372826',
  UCD13: '3400893728260',
  ucdQtyMultiplicator: 1,
  cipLib: "ALCOOL MEDICAL GILB FP125ML BT 1",
  atcCode: "D08AX08"
}, {
  CIP7: '3314526',
  CIP13: '3400933145262',
  ucdLib: "DAKIN CPF STABILISE LOC 250ML",
  UCD7: '9141280',
  UCD13: '3400891412802',
  ucdQtyMultiplicator: 1,
  cipLib: "DAKIN CPF STABILISE LOC 250ML BT 1",
  atcCode: "D08AX07"
}, {
  CIP7: '3314532',
  CIP13: '3400933145323',
  ucdLib: "DAKIN CPF STABILISE LOC 500ML",
  UCD7: '9141297',
  UCD13: '3400891412970',
  ucdQtyMultiplicator: 1,
  cipLib: "DAKIN CPF STABILISE LOC 500ML BT 1",
  atcCode: "D08AX07"
}, {
  CIP7: '3677275',
  CIP13: '3400936772755',
  ucdLib: "DAKIN CPF STABILISE LOC 125ML",
  UCD7: '9368138',
  UCD13: '3400893681381',
  ucdQtyMultiplicator: 1,
  cipLib: "DAKIN CPF STABILISE LOC 125ML BT 1",
  atcCode: "D08AX07"
}, {
  CIP7: '3368344',
  CIP13: '3400933683443',
  ucdLib: "AMUKINE 0,06% SOL LOC FP200ML",
  UCD7: '9222937',
  UCD13: '3400892229379',
  ucdQtyMultiplicator: 1,
  cipLib: "AMUKINE 0,06% SOL LOC FP200ML BT 1",
  atcCode: "D08AX07"
}, {
  CIP7: '3551551',
  CIP13: '3400935515513',
  ucdLib: "AMUKINE 0,06% SOL LOC FP60ML",
  UCD7: '9222943',
  UCD13: '3400892229430',
  ucdQtyMultiplicator: 1,
  cipLib: "AMUKINE 0,06% SOL LOC FP60ML BT 1",
  atcCode: "D08AX07"
}, {
  CIP7: '3411784',
  CIP13: '3400934117848',
  ucdLib: "DAKIN CPF STABILISE LOC 60ML",
  UCD7: '9189499',
  UCD13: '3400891894998',
  ucdQtyMultiplicator: 1,
  cipLib: "DAKIN CPF STABILISE LOC 60ML BT 1",
  atcCode: "D08AX07"
}, {
  CIP7: '5567763',
  CIP13: '3400955677635',
  ucdLib: "EOSINE 2% GILB AQ. DOS5ML",
  UCD7: '9135569',
  UCD13: '3400891355697',
  ucdQtyMultiplicator: 120,
  cipLib: "EOSINE 2% GILB AQ. DOS5ML BT 120",
  atcCode: "D08AX02"
}, {
  CIP7: '3376585',
  CIP13: '3400933765859',
  ucdLib: "EOSINE 2% GILB AQ. DOS2ML",
  UCD7: '9171660',
  UCD13: '3400891716603',
  ucdQtyMultiplicator: 10,
  cipLib: "EOSINE 2% GILB AQ. DOS2ML BT 10",
  atcCode: "D08AX02"
}, {
  CIP7: '5583584',
  CIP13: '3400955835844',
  ucdLib: "EOSINE 2% GILB AQ. DOS2ML",
  UCD7: '9171660',
  UCD13: '3400891716603',
  ucdQtyMultiplicator: 120,
  cipLib: "EOSINE 2% GILB AQ. DOS2ML BT 120",
  atcCode: "D08AX02"
}, {
  CIP7: '3396837',
  CIP13: '3400933968373',
  ucdLib: "EOSINE 2% CPF UNIDOS2ML",
  UCD7: '9205778',
  UCD13: '3400892057781',
  ucdQtyMultiplicator: 10,
  cipLib: "EOSINE 2% CPF UNIDOS2ML BT 10",
  atcCode: "D08AX02"
}, {
  CIP7: '3447865',
  CIP13: '3400934478659',
  ucdLib: "EOSINE 2% NTM AQ. DOS2ML",
  UCD7: '9371784',
  UCD13: '3400893717844',
  ucdQtyMultiplicator: 10,
  cipLib: "EOSINE 2% NTM AQ. DOS2ML BT 10",
  atcCode: "D08AX02"
}, {
  CIP7: '5768013',
  CIP13: '3400957680138',
  ucdLib: "EOSINE 2% GILB AQ. DOS2ML",
  UCD7: '9171660',
  UCD13: '3400891716603',
  ucdQtyMultiplicator: 60,
  cipLib: "EOSINE 2% GILB AQ. DOS2ML BT 60",
  atcCode: "D08AX02"
}, {
  CIP7: '5768036',
  CIP13: '3400957680367',
  ucdLib: "EOSINE 2% GILB AQ. DOS5ML",
  UCD7: '9135569',
  UCD13: '3400891355697',
  ucdQtyMultiplicator: 60,
  cipLib: "EOSINE 2% GILB AQ. DOS5ML BT 60",
  atcCode: "D08AX02"
}, {
  CIP7: '3615759',
  CIP13: '3400936157590',
  ucdLib: "EAU OXYGENEE GILB 10V 10ML",
  UCD7: '9250508',
  UCD13: '3400892505084',
  ucdQtyMultiplicator: 10,
  cipLib: "EAU OXYGENEE GILB 10V 10ML BT 10",
  atcCode: "D08AX01"
}, {
  CIP7: '3316005',
  CIP13: '3400933160050',
  ucdLib: "EAU OXYGENEE GILB 10V FV120ML",
  UCD7: '9135523',
  UCD13: '3400891355239',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE GILB 10V FV120ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '3316011',
  CIP13: '3400933160111',
  ucdLib: "EAU OXYGENEE GILB 10V FV250ML",
  UCD7: '9135546',
  UCD13: '3400891355468',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE GILB 10V FV250ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '3316732',
  CIP13: '3400933167325',
  ucdLib: "EAU OXYGENEE GILB 10V PUL120ML",
  UCD7: '9135517',
  UCD13: '3400891355178',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE GILB 10V PUL120ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '3336284',
  CIP13: '3400933362843',
  ucdLib: "EAU OXYGENEE GIFR 10V FP250ML",
  UCD7: '9152817',
  UCD13: '3400891528176',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE GIFR 10V FP250ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '3407707',
  CIP13: '3400934077074',
  ucdLib: "EAU OXYGENEE GIFR 10V FP125ML",
  UCD7: '9171157',
  UCD13: '3400891711578',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE GIFR 10V FP125ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '3559794',
  CIP13: '3400935597946',
  ucdLib: "EAU OXYGENEE CPF 10V FP125ML",
  UCD7: '9228779',
  UCD13: '3400892287799',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE CPF 10V FP125ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '3559802',
  CIP13: '3400935598028',
  ucdLib: "EAU OXYGENEE CPF 10V FP250ML",
  UCD7: '9228785',
  UCD13: '3400892287850',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE CPF 10V FP250ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '3597429',
  CIP13: '3400935974297',
  ucdLib: "DOSOXYGENEE 10V DOS5ML",
  UCD7: '9209486',
  UCD13: '3400892094861',
  ucdQtyMultiplicator: 20,
  cipLib: "DOSOXYGENEE 10V DOS5ML BT 20",
  atcCode: "D08AX01"
}, {
  CIP7: '3778272',
  CIP13: '3400937782722',
  ucdLib: "EAU OXYGENEE EVL 10V FP125ML",
  UCD7: '9312037',
  UCD13: '3400893120378',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE EVL 10V FP125ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '3778289',
  CIP13: '3400937782890',
  ucdLib: "EAU OXYGENEE EVL 10V FP250ML",
  UCD7: '9312043',
  UCD13: '3400893120439',
  ucdQtyMultiplicator: 1,
  cipLib: "EAU OXYGENEE EVL 10V FP250ML BT 1",
  atcCode: "D08AX01"
}, {
  CIP7: '5641057',
  CIP13: '3400956410576',
  ucdLib: "EAU OXYGENEE GILB 10V 10ML",
  UCD7: '9250508',
  UCD13: '3400892505084',
  ucdQtyMultiplicator: 100,
  cipLib: "EAU OXYGENEE GILB 10V 10ML BT 100",
  atcCode: "D08AX01"
}, {
  CIP7: '5768042',
  CIP13: '3400957680428',
  ucdLib: "EAU OXYGENEE GILB 10V 10ML",
  UCD7: '9250508',
  UCD13: '3400892505084',
  ucdQtyMultiplicator: 60,
  cipLib: "EAU OXYGENEE GILB 10V 10ML BT 60",
  atcCode: "D08AX01"
}, {
  CIP7: '3812046',
  CIP13: '3400938120462',
  ucdLib: "CETAVLON CR TB80G",
  UCD7: '9312830',
  UCD13: '3400893128305',
  ucdQtyMultiplicator: 1,
  cipLib: "CETAVLON CR TB80G BT 1",
  atcCode: "D08AJ04"
}, {
  CIP7: '3384780',
  CIP13: '3400933847807',
  ucdLib: "STERILENE 0,5% LOC SOL FP35ML",
  UCD7: '9173050',
  UCD13: '3400891730500',
  ucdQtyMultiplicator: 1,
  cipLib: "STERILENE 0,5% LOC SOL FP35ML BT 1",
  atcCode: "D08AJ04"
}, {
  CIP7: '3029435',
  CIP13: '3400930294352',
  ucdLib: "DERMACIDE SOL MOUSST FP250ML",
  UCD7: '9025243',
  UCD13: '3400890252430',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMACIDE SOL MOUSST FP250ML BT 1",
  atcCode: "D08AH03"
}, {
  CIP7: '3006137',
  CIP13: '3400930061374',
  ucdLib: "BETADINE ALC.5% LOC SOL F125ML",
  UCD7: '9212092',
  UCD13: '3400892120928',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE ALC.5% LOC SOL F125ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '3010861',
  CIP13: '3400930108611',
  ucdLib: "BETADINE SCRUB SOL FP125ML",
  UCD7: '9010394',
  UCD13: '3400890103947',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE SCRUB SOL FP125ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '3198801',
  CIP13: '3400931988014',
  ucdLib: "BETADINE 10% GEL TB30G",
  UCD7: '9010342',
  UCD13: '3400890103428',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 10% GEL TB30G BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '3149978',
  CIP13: '3400931499787',
  ucdLib: "BETADINE 10% SOL LOC FL125ML",
  UCD7: '9010359',
  UCD13: '3400890103596',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 10% SOL LOC FL125ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '3149990',
  CIP13: '3400931499909',
  ucdLib: "BETADINE 10% SOL LOC FL500ML",
  UCD7: '9108242',
  UCD13: '3400891082425',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 10% SOL LOC FL500ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '3598386',
  CIP13: '3400935983862',
  ucdLib: "BETADINE 10% SOL LOC DOS5ML",
  UCD7: '9259024',
  UCD13: '3400892590240',
  ucdQtyMultiplicator: 10,
  cipLib: "BETADINE 10% SOL LOC DOS5ML BT 10",
  atcCode: "D08AG02"
}, {
  CIP7: '3535598',
  CIP13: '3400935355980',
  ucdLib: "BETADINE SCRUB SOL DOS10ML",
  UCD7: '9225114',
  UCD13: '3400892251141',
  ucdQtyMultiplicator: 10,
  cipLib: "BETADINE SCRUB SOL DOS10ML BT 10",
  atcCode: "D08AG02"
}, {
  CIP7: '3640935',
  CIP13: '3400936409354',
  ucdLib: "BETADINE ALC.5% LOC SOL 10ML",
  UCD7: '9264947',
  UCD13: '3400892649474',
  ucdQtyMultiplicator: 10,
  cipLib: "BETADINE ALC.5% LOC SOL 10ML BT 10",
  atcCode: "D08AG02"
}, {
  CIP7: '5624099',
  CIP13: '3400956240999',
  ucdLib: "BETADINE SCRUB SOL DOS10ML",
  UCD7: '9225114',
  UCD13: '3400892251141',
  ucdQtyMultiplicator: 50,
  cipLib: "BETADINE SCRUB SOL DOS10ML BT 50",
  atcCode: "D08AG02"
}, {
  CIP7: '5616444',
  CIP13: '3400956164448',
  ucdLib: "BETADINE ALC.5% LOC SOL F125ML",
  UCD7: '9212092',
  UCD13: '3400892120928',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE ALC.5% LOC SOL F125ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '5612966',
  CIP13: '3400956129669',
  ucdLib: "POVIDONE MYL 10% SOL CUT 500ML",
  UCD7: '9211885',
  UCD13: '3400892118857',
  ucdQtyMultiplicator: 1,
  cipLib: "POVIDONE MYL 10% SOL CUT 500ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '5631171',
  CIP13: '3400956311712',
  ucdLib: "BETADINE ALC.5% LOC SOL 500ML",
  UCD7: '9257545',
  UCD13: '3400892575452',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE ALC.5% LOC SOL 500ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '3506881',
  CIP13: '3400935068811',
  ucdLib: "POVIDONE MYL 10% SOL CUT 125ML",
  UCD7: '9211879',
  UCD13: '3400892118796',
  ucdQtyMultiplicator: 1,
  cipLib: "POVIDONE MYL 10% SOL CUT 125ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '5523949',
  CIP13: '3400955239499',
  ucdLib: "BETADINE 10% GEL TB100G",
  UCD7: '9108213',
  UCD13: '3400891082135',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 10% GEL TB100G BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '3426426',
  CIP13: '3400934264269',
  ucdLib: "BETADINE 10% SOL LOC DOS10ML",
  UCD7: '9246518',
  UCD13: '3400892465180',
  ucdQtyMultiplicator: 50,
  cipLib: "BETADINE 10% SOL LOC DOS10ML BT 50",
  atcCode: "D08AG02"
}, {
  CIP7: '5655208',
  CIP13: '3400956552085',
  ucdLib: "BETADINE ALC.5% LOC SOL 10ML",
  UCD7: '9264947',
  UCD13: '3400892649474',
  ucdQtyMultiplicator: 40,
  cipLib: "BETADINE ALC.5% LOC SOL 10ML BT 40",
  atcCode: "D08AG02"
}, {
  CIP7: '5523895',
  CIP13: '3400955238959',
  ucdLib: "BETADINE SCRUB SOL FP500ML",
  UCD7: '9108288',
  UCD13: '3400891082883',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE SCRUB SOL FP500ML BT 1",
  atcCode: "D08AG02"
}, {
  CIP7: '3291328',
  CIP13: '3400932913282',
  ucdLib: "BISEPTINE SOL LOC FL PULV100ML",
  UCD7: '9129681',
  UCD13: '3400891296815',
  ucdQtyMultiplicator: 1,
  cipLib: "BISEPTINE SOL LOC FL PULV100ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3291334',
  CIP13: '3400932913343',
  ucdLib: "BISEPTINE SOL LOC FP500ML",
  UCD7: '9129698',
  UCD13: '3400891296983',
  ucdQtyMultiplicator: 1,
  cipLib: "BISEPTINE SOL LOC FP500ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3305421',
  CIP13: '3400933054212',
  ucdLib: "BISEPTINE SOL LOC FP250ML",
  UCD7: '9224847',
  UCD13: '3400892248479',
  ucdQtyMultiplicator: 1,
  cipLib: "BISEPTINE SOL LOC FP250ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3357636',
  CIP13: '3400933576363',
  ucdLib: "BISEPTINE SOL LOC FP40ML",
  UCD7: '9158091',
  UCD13: '3400891580914',
  ucdQtyMultiplicator: 1,
  cipLib: "BISEPTINE SOL LOC FP40ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3204654',
  CIP13: '3400932046546',
  ucdLib: "CYTEAL SOL MOUSS FP250ML",
  UCD7: '9023669',
  UCD13: '3400890236690',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTEAL SOL MOUSS FP250ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3202359',
  CIP13: '3400932023592',
  ucdLib: "CYTEAL SOL MOUSS FP500ML",
  UCD7: '9109388',
  UCD13: '3400891093889',
  ucdQtyMultiplicator: 1,
  cipLib: "CYTEAL SOL MOUSS FP500ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3564559',
  CIP13: '3400935645593',
  ucdLib: "BISEPTINESCRUB LOC SOL FP125ML",
  UCD7: '9387466',
  UCD13: '3400893874660',
  ucdQtyMultiplicator: 1,
  cipLib: "BISEPTINESCRUB LOC SOL FP125ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3553171',
  CIP13: '3400935531711',
  ucdLib: "BISEPTINESPRAID LOC FP125ML",
  UCD7: '9236810',
  UCD13: '3400892368108',
  ucdQtyMultiplicator: 1,
  cipLib: "BISEPTINESPRAID LOC FP125ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3484079',
  CIP13: '3400934840791',
  ucdLib: "DERMOBACTER SOL CUTA FL125ML",
  UCD7: '9224899',
  UCD13: '3400892248998',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOBACTER SOL CUTA FL125ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3484085',
  CIP13: '3400934840852',
  ucdLib: "DERMOBACTER SOL CUTA FL300ML",
  UCD7: '9224907',
  UCD13: '3400892249070',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOBACTER SOL CUTA FL300ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3535635',
  CIP13: '3400935356352',
  ucdLib: "MERCRYL SOL MOUSST FP1000ML",
  UCD7: '9218568',
  UCD13: '3400892185682',
  ucdQtyMultiplicator: 1,
  cipLib: "MERCRYL SOL MOUSST FP1000ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3535629',
  CIP13: '3400935356291',
  ucdLib: "MERCRYL SOL MOUSST FP300ML",
  UCD7: '9218580',
  UCD13: '3400892185804',
  ucdQtyMultiplicator: 1,
  cipLib: "MERCRYL SOL MOUSST FP300ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3545680',
  CIP13: '3400935456809',
  ucdLib: "MERCRYL LOC SOL FP125ML",
  UCD7: '9226734',
  UCD13: '3400892267340',
  ucdQtyMultiplicator: 1,
  cipLib: "MERCRYL LOC SOL FP125ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3545674',
  CIP13: '3400935456748',
  ucdLib: "MERCRYLSPRAY LOC SOL FL50ML",
  UCD7: '9226757',
  UCD13: '3400892267579',
  ucdQtyMultiplicator: 1,
  cipLib: "MERCRYLSPRAY LOC SOL FL50ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3664545',
  CIP13: '3400936645455',
  ucdLib: "BISEPTINESPRAID LOC PULV 50ML",
  UCD7: '9269146',
  UCD13: '3400892691466',
  ucdQtyMultiplicator: 1,
  cipLib: "BISEPTINESPRAID LOC PULV 50ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3503351',
  CIP13: '3400935033512',
  ucdLib: "CHLORAPREP COL LOC A.10,5ML",
  UCD7: '9368210',
  UCD13: '3400893682104',
  ucdQtyMultiplicator: 25,
  cipLib: "CHLORAPREP COL LOC A.10,5ML BT 25",
  atcCode: "D08AC52"
}, {
  CIP7: '3503368',
  CIP13: '3400935033680',
  ucdLib: "CHLORAPREP COL LOC AMP26ML",
  UCD7: '9368227',
  UCD13: '3400893682272',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORAPREP COL LOC AMP26ML BT 1",
  atcCode: "D08AC52"
}, {
  CIP7: '3503339',
  CIP13: '3400935033390',
  ucdLib: "CHLORAPREP COL LOC AMP3ML",
  UCD7: '9368233',
  UCD13: '3400893682333',
  ucdQtyMultiplicator: 25,
  cipLib: "CHLORAPREP COL LOC AMP3ML BT 25",
  atcCode: "D08AC52"
}, {
  CIP7: '5846569',
  CIP13: '3400958465697',
  ucdLib: "CHLORAPREP LOC AMP0,67ML",
  UCD7: '9397909',
  UCD13: '3400893979099',
  ucdQtyMultiplicator: 200,
  cipLib: "CHLORAPREP LOC AMP0,67ML BT 200",
  atcCode: "D08AC52"
}, {
  CIP7: '3049538',
  CIP13: '3400930495384',
  ucdLib: "HEXOMEDINE 1%. SOL FP250ML",
  UCD7: '9043583',
  UCD13: '3400890435833',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXOMEDINE 1%. SOL FP250ML BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3049544',
  CIP13: '3400930495445',
  ucdLib: "HEXOMEDINE 1%. SOL FP45ML",
  UCD7: '9112640',
  UCD13: '3400891126402',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXOMEDINE 1%. SOL FP45ML BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3049567',
  CIP13: '3400930495674',
  ucdLib: "HEXOMEDINE TRANSCUT FV45ML",
  UCD7: '9043608',
  UCD13: '3400890436083',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXOMEDINE TRANSCUT FV45ML BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3375752',
  CIP13: '3400933757526',
  ucdLib: "HEXASEPTINE 0,1% LOC SOL 75ML",
  UCD7: '9170353',
  UCD13: '3400891703535',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXASEPTINE 0,1% LOC SOL 75ML BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3356217',
  CIP13: '3400933562175',
  ucdLib: "HEXOMEDINE 1%. GEL TB30G",
  UCD7: '9159156',
  UCD13: '3400891591569',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXOMEDINE 1%. GEL TB30G BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3444370',
  CIP13: '3400934443701',
  ucdLib: "HEXAMIDINE GIL 0,1% SOL FL45ML",
  UCD7: '9216049',
  UCD13: '3400892160498',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXAMIDINE GIL 0,1% SOL FL45ML BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3846217',
  CIP13: '3400938462173',
  ucdLib: "HEXAMIDINE MYL 1/M SOL FP250ML",
  UCD7: '9324402',
  UCD13: '3400893244029',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXAMIDINE MYL 1/M SOL FP250ML BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3846200',
  CIP13: '3400938462005',
  ucdLib: "HEXAMIDINE MYL 1/M SOL FP45ML",
  UCD7: '9324419',
  UCD13: '3400893244197',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXAMIDINE MYL 1/M SOL FP45ML BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3501300',
  CIP13: '3400935013002',
  ucdLib: "HEXOMEDINE 1%. SOL FL PULV75ML",
  UCD7: '9215570',
  UCD13: '3400892155708',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXOMEDINE 1%. SOL FL PULV75ML BT 1",
  atcCode: "D08AC04"
}, {
  CIP7: '3575043',
  CIP13: '3400935750433',
  ucdLib: "CHLORHEXIDINE GIF AV/COL 125ML",
  UCD7: '9244583',
  UCD13: '3400892445830',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIF AV/COL 125ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3292463',
  CIP13: '3400932924639',
  ucdLib: "SEPTEAL SOL LOC FP250ML",
  UCD7: '9123514',
  UCD13: '3400891235142',
  ucdQtyMultiplicator: 1,
  cipLib: "SEPTEAL SOL LOC FP250ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3244464',
  CIP13: '3400932444649',
  ucdLib: "HIBITANE CHAMP 0,5% FP125ML",
  UCD7: '9195117',
  UCD13: '3400891951172',
  ucdQtyMultiplicator: 1,
  cipLib: "HIBITANE CHAMP 0,5% FP125ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3604307',
  CIP13: '3400936043077',
  ucdLib: "BIORGASEPT 0,5% LOC SOL 250ML",
  UCD7: '9249652',
  UCD13: '3400892496528',
  ucdQtyMultiplicator: 1,
  cipLib: "BIORGASEPT 0,5% LOC SOL 250ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3601823',
  CIP13: '3400936018235',
  ucdLib: "CHLORHEXIDINE GIF INCOL 125ML",
  UCD7: '9275023',
  UCD13: '3400892750231',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIF INCOL 125ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3601846',
  CIP13: '3400936018464',
  ucdLib: "CHLORHEXIDINE GIF INCOL 250ML",
  UCD7: '9275046',
  UCD13: '3400892750460',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIF INCOL 250ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '5575538',
  CIP13: '3400955755388',
  ucdLib: "CHLORHEXIDINE GIL COL 20ML",
  UCD7: '9163005',
  UCD13: '3400891630053',
  ucdQtyMultiplicator: 100,
  cipLib: "CHLORHEXIDINE GIL COL 20ML BT 100",
  atcCode: "D08AC02"
}, {
  CIP7: '5588334',
  CIP13: '3400955883340',
  ucdLib: "CHLORHEXIDINE GIL COL 100ML",
  UCD7: '9174405',
  UCD13: '3400891744057',
  ucdQtyMultiplicator: 50,
  cipLib: "CHLORHEXIDINE GIL COL 100ML BT 50",
  atcCode: "D08AC02"
}, {
  CIP7: '5588311',
  CIP13: '3400955883111',
  ucdLib: "CHLORHEXIDINE GIL COL 50ML",
  UCD7: '9174411',
  UCD13: '3400891744118',
  ucdQtyMultiplicator: 100,
  cipLib: "CHLORHEXIDINE GIL COL 50ML BT 100",
  atcCode: "D08AC02"
}, {
  CIP7: '5583294',
  CIP13: '3400955832942',
  ucdLib: "DOSISEPTINE 0,05% DOS100ML",
  UCD7: '9204566',
  UCD13: '3400892045665',
  ucdQtyMultiplicator: 30,
  cipLib: "DOSISEPTINE 0,05% DOS100ML BT 30",
  atcCode: "D08AC02"
}, {
  CIP7: '5583288',
  CIP13: '3400955832881',
  ucdLib: "DOSISEPTINE 0,05% DOS45ML",
  UCD7: '9204589',
  UCD13: '3400892045894',
  ucdQtyMultiplicator: 30,
  cipLib: "DOSISEPTINE 0,05% DOS45ML BT 30",
  atcCode: "D08AC02"
}, {
  CIP7: '3201673',
  CIP13: '3400932016730',
  ucdLib: "HIBISCRUB 4% SOL MOUSS FP125ML",
  UCD7: '9043643',
  UCD13: '3400890436434',
  ucdQtyMultiplicator: 1,
  cipLib: "HIBISCRUB 4% SOL MOUSS FP125ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3209143',
  CIP13: '3400932091430',
  ucdLib: "HIBISCRUB 4% SOL MOUSS FP500ML",
  UCD7: '9112692',
  UCD13: '3400891126921',
  ucdQtyMultiplicator: 1,
  cipLib: "HIBISCRUB 4% SOL MOUSS FP500ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3202939',
  CIP13: '3400932029396',
  ucdLib: "PLUREXID LOC SOL FP250ML",
  UCD7: '9072739',
  UCD13: '3400890727396',
  ucdQtyMultiplicator: 1,
  cipLib: "PLUREXID LOC SOL FP250ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3597458',
  CIP13: '3400935974587',
  ucdLib: "DOSISEPTINE 0,05% DOS5ML",
  UCD7: '9204595',
  UCD13: '3400892045955',
  ucdQtyMultiplicator: 10,
  cipLib: "DOSISEPTINE 0,05% DOS5ML BT 10",
  atcCode: "D08AC02"
}, {
  CIP7: '3597464',
  CIP13: '3400935974648',
  ucdLib: "DOSISEPTINE 0,05% DOS5ML",
  UCD7: '9204595',
  UCD13: '3400892045955',
  ucdQtyMultiplicator: 20,
  cipLib: "DOSISEPTINE 0,05% DOS5ML BT 20",
  atcCode: "D08AC02"
}, {
  CIP7: '3411755',
  CIP13: '3400934117558',
  ucdLib: "HIBIDIL SOL LOC UNIDOS15ML",
  UCD7: '9169083',
  UCD13: '3400891690835',
  ucdQtyMultiplicator: 25,
  cipLib: "HIBIDIL SOL LOC UNIDOS15ML BT 25",
  atcCode: "D08AC02"
}, {
  CIP7: '3815932',
  CIP13: '3400938159325',
  ucdLib: "CETAVLEX AQ.0,5% SOL FP125ML+P",
  UCD7: '9315780',
  UCD13: '3400893157800',
  ucdQtyMultiplicator: 1,
  cipLib: "CETAVLEX AQ.0,5% SOL FP125ML+P BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3691849',
  CIP13: '3400936918498',
  ucdLib: "DIASEPTYL 0,5% SOL PULV 125ML",
  UCD7: '9289284',
  UCD13: '3400892892849',
  ucdQtyMultiplicator: 1,
  cipLib: "DIASEPTYL 0,5% SOL PULV 125ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3472604',
  CIP13: '3400934726040',
  ucdLib: "CHLORHEXIDINE GIL COL 20ML",
  UCD7: '9163005',
  UCD13: '3400891630053',
  ucdQtyMultiplicator: 48,
  cipLib: "CHLORHEXIDINE GIL COL 20ML BT 48",
  atcCode: "D08AC02"
}, {
  CIP7: '3472627',
  CIP13: '3400934726279',
  ucdLib: "CHLORHEXIDINE GIL COL 50ML",
  UCD7: '9174411',
  UCD13: '3400891744118',
  ucdQtyMultiplicator: 32,
  cipLib: "CHLORHEXIDINE GIL COL 50ML BT 32",
  atcCode: "D08AC02"
}, {
  CIP7: '3472656',
  CIP13: '3400934726569',
  ucdLib: "CHLORHEXIDINE GIL0,2% D.20ML",
  UCD7: '9361461',
  UCD13: '3400893614617',
  ucdQtyMultiplicator: 48,
  cipLib: "CHLORHEXIDINE GIL0,2% D.20ML BT 48",
  atcCode: "D08AC02"
}, {
  CIP7: '3472662',
  CIP13: '3400934726620',
  ucdLib: "CHLORHEXIDINE GIL0,2% D.50ML",
  UCD7: '9361478',
  UCD13: '3400893614785',
  ucdQtyMultiplicator: 32,
  cipLib: "CHLORHEXIDINE GIL0,2% D.50ML BT 32",
  atcCode: "D08AC02"
}, {
  CIP7: '3474773',
  CIP13: '3400934747731',
  ucdLib: "DOSISEPTINE 0,05% LOC FL50ML",
  UCD7: '9207145',
  UCD13: '3400892071459',
  ucdQtyMultiplicator: 1,
  cipLib: "DOSISEPTINE 0,05% LOC FL50ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3641662',
  CIP13: '3400936416628',
  ucdLib: "SEPTIVON 1,5% CUTA FL250ML",
  UCD7: '9280610',
  UCD13: '3400892806105',
  ucdQtyMultiplicator: 1,
  cipLib: "SEPTIVON 1,5% CUTA FL250ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3641679',
  CIP13: '3400936416796',
  ucdLib: "SEPTIVON 1,5% CUTA FL500ML",
  UCD7: '9280627',
  UCD13: '3400892806273',
  ucdQtyMultiplicator: 1,
  cipLib: "SEPTIVON 1,5% CUTA FL500ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3444341',
  CIP13: '3400934443411',
  ucdLib: "CHLORHEXIDINE GIH ALC FL125ML",
  UCD7: '9200858',
  UCD13: '3400892008585',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIH ALC FL125ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3444358',
  CIP13: '3400934443589',
  ucdLib: "CHLORHEXIDINE GIH ALC FL250ML",
  UCD7: '9237726',
  UCD13: '3400892377261',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIH ALC FL250ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3444364',
  CIP13: '3400934443640',
  ucdLib: "CHLORHEXIDINE GIH ALC FL500ML",
  UCD7: '9277677',
  UCD13: '3400892776774',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIH ALC FL500ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '5508312',
  CIP13: '3400955083122',
  ucdLib: "HIBITANE CHAMP 0,5% FP500ML",
  UCD7: '9136770',
  UCD13: '3400891367706',
  ucdQtyMultiplicator: 1,
  cipLib: "HIBITANE CHAMP 0,5% FP500ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '5639304',
  CIP13: '3400956393046',
  ucdLib: "CHLORHEXIDINE GIF AV/COL 250ML",
  UCD7: '9241946',
  UCD13: '3400892419466',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEXIDINE GIF AV/COL 250ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3917897',
  CIP13: '3400939178974',
  ucdLib: "CHLORHEXIDINE GIL0,2% D100ML",
  UCD7: '9337273',
  UCD13: '3400893372739',
  ucdQtyMultiplicator: 50,
  cipLib: "CHLORHEXIDINE GIL0,2% D100ML BT 50",
  atcCode: "D08AC02"
}, {
  CIP7: '3917733',
  CIP13: '3400939177335',
  ucdLib: "CHLORHEXIDINE GIL0,2% DOS5ML",
  UCD7: '9337296',
  UCD13: '3400893372968',
  ucdQtyMultiplicator: 10,
  cipLib: "CHLORHEXIDINE GIL0,2% DOS5ML BT 10",
  atcCode: "D08AC02"
}, {
  CIP7: '5639327',
  CIP13: '3400956393275',
  ucdLib: "HIBIDIL SOL LOC UNIDOS15ML",
  UCD7: '9169083',
  UCD13: '3400891690835',
  ucdQtyMultiplicator: 240,
  cipLib: "HIBIDIL SOL LOC UNIDOS15ML BT 240",
  atcCode: "D08AC02"
}, {
  CIP7: '3972169',
  CIP13: '3400939721699',
  ucdLib: "SEPTIDOSE 0,05% LOC DOS15ML",
  UCD7: '9346303',
  UCD13: '3400893463031',
  ucdQtyMultiplicator: 20,
  cipLib: "SEPTIDOSE 0,05% LOC DOS15ML BT 20",
  atcCode: "D08AC02"
}, {
  CIP7: '4940987',
  CIP13: '3400949409877',
  ucdLib: "DIASEPTYL 0,5% LOC SOL FP75ML",
  UCD7: '9371689',
  UCD13: '3400893716892',
  ucdQtyMultiplicator: 1,
  cipLib: "DIASEPTYL 0,5% LOC SOL FP75ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '4966604',
  CIP13: '3400949666041',
  ucdLib: "BIORGASEPT 0,5% SOL PULV 60ML",
  UCD7: '9383818',
  UCD13: '3400893838181',
  ucdQtyMultiplicator: 1,
  cipLib: "BIORGASEPT 0,5% SOL PULV 60ML BT 1",
  atcCode: "D08AC02"
}, {
  CIP7: '3239919',
  CIP13: '3400932399192',
  ucdLib: "DIPROSALIC LOT FP30G",
  UCD7: '9109632',
  UCD13: '3400891096323',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPROSALIC LOT FP30G BT 1",
  atcCode: "D07XC01"
}, {
  CIP7: '3230924',
  CIP13: '3400932309245',
  ucdLib: "DIPROSALIC POM DERM TB30G",
  UCD7: '9109655',
  UCD13: '3400891096552',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPROSALIC POM DERM TB30G BT 1",
  atcCode: "D07XC01"
}, {
  CIP7: '3239894',
  CIP13: '3400932398942',
  ucdLib: "LOCALONE LOT FV125ML",
  UCD7: '9054859',
  UCD13: '3400890548595',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCALONE LOT FV125ML BT 1",
  atcCode: "D07XB02"
}, {
  CIP7: '3221954',
  CIP13: '3400932219544',
  ucdLib: "PEVISONE CR DERM TB10G",
  UCD7: '9070769',
  UCD13: '3400890707695',
  ucdQtyMultiplicator: 1,
  cipLib: "PEVISONE CR DERM TB10G BT 1",
  atcCode: "D07XB02"
}, {
  CIP7: '3445754',
  CIP13: '3400934457548',
  ucdLib: "ONCTOSE H.C CR TB30G",
  UCD7: '9200634',
  UCD13: '3400892006345',
  ucdQtyMultiplicator: 1,
  cipLib: "ONCTOSE H.C CR TB30G BT 1",
  atcCode: "D07XA01"
}, {
  CIP7: '3225283',
  CIP13: '3400932252831',
  ucdLib: "NERISONE C CR TB30G",
  UCD7: '9062178',
  UCD13: '3400890621786',
  ucdQtyMultiplicator: 1,
  cipLib: "NERISONE C CR TB30G BT 1",
  atcCode: "D07BC04"
}, {
  CIP7: '3261304',
  CIP13: '3400932613045',
  ucdLib: "DERMOVAL GEL LOC FL20ML",
  UCD7: '9025504',
  UCD13: '3400890255042',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOVAL GEL LOC FL20ML BT 1",
  atcCode: "D07AD01"
}, {
  CIP7: '3204329',
  CIP13: '3400932043293',
  ucdLib: "DERMOVAL 0,05% CR TB10G",
  UCD7: '9025496',
  UCD13: '3400890254960',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOVAL 0,05% CR TB10G BT 1",
  atcCode: "D07AD01"
}, {
  CIP7: '3795230',
  CIP13: '3400937952309',
  ucdLib: "CLOBEX 500MCG/G SHA FP125ML 1",
  UCD7: '9314243',
  UCD13: '3400893142431',
  ucdQtyMultiplicator: 1,
  cipLib: "CLOBEX 500MCG/G SHA FP125ML 1 BT 1",
  atcCode: "D07AD01"
}, {
  CIP7: '3870954',
  CIP13: '3400938709544',
  ucdLib: "CLARELUX 500MCG/G CR TB10G",
  UCD7: '9355182',
  UCD13: '3400893551820',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARELUX 500MCG/G CR TB10G BT 1",
  atcCode: "D07AD01"
}, {
  CIP7: '2165828',
  CIP13: '3400921658286',
  ucdLib: "CLARELUX 500MCG/G MOUSS FL100G",
  UCD7: '9391864',
  UCD13: '3400893918647',
  ucdQtyMultiplicator: 1,
  cipLib: "CLARELUX 500MCG/G MOUSS FL100G BT 1",
  atcCode: "D07AD01"
}, {
  CIP7: '3210293',
  CIP13: '3400932102938',
  ucdLib: "EPITOPIC 0,05% CR TB15G",
  UCD7: '9031663',
  UCD13: '3400890316637',
  ucdQtyMultiplicator: 1,
  cipLib: "EPITOPIC 0,05% CR TB15G BT 1",
  atcCode: "D07AC19"
}, {
  CIP7: '3368410',
  CIP13: '3400933684105',
  ucdLib: "FLIXOVATE 0,005% POM TB30G",
  UCD7: '9233898',
  UCD13: '3400892338989',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXOVATE 0,005% POM TB30G BT 1",
  atcCode: "D07AC17"
}, {
  CIP7: '3368396',
  CIP13: '3400933683962',
  ucdLib: "FLIXOVATE 0,05% CR TB30G",
  UCD7: '9233906',
  UCD13: '3400892339061',
  ucdQtyMultiplicator: 1,
  cipLib: "FLIXOVATE 0,05% CR TB30G BT 1",
  atcCode: "D07AC17"
}, {
  CIP7: '3306900',
  CIP13: '3400933069001',
  ucdLib: "EFFICORT LIPO 0,127% CR TB30G",
  UCD7: '9149614',
  UCD13: '3400891496147',
  ucdQtyMultiplicator: 1,
  cipLib: "EFFICORT LIPO 0,127% CR TB30G BT 1",
  atcCode: "D07AC16"
}, {
  CIP7: '3423735',
  CIP13: '3400934237355',
  ucdLib: "EFFICORT HYDRO 0,127% CR TB30G",
  UCD7: '9192248',
  UCD13: '3400891922486',
  ucdQtyMultiplicator: 1,
  cipLib: "EFFICORT HYDRO 0,127% CR TB30G BT 1",
  atcCode: "D07AC16"
}, {
  CIP7: '3222379',
  CIP13: '3400932223794',
  ucdLib: "NERISONE CR TB30G",
  UCD7: '9062132',
  UCD13: '3400890621328',
  ucdQtyMultiplicator: 1,
  cipLib: "NERISONE CR TB30G BT 1",
  atcCode: "D07AC06"
}, {
  CIP7: '3222362',
  CIP13: '3400932223626',
  ucdLib: "NERISONE GRAS POM TB30G",
  UCD7: '9062190',
  UCD13: '3400890621908',
  ucdQtyMultiplicator: 1,
  cipLib: "NERISONE GRAS POM TB30G BT 1",
  atcCode: "D07AC06"
}, {
  CIP7: '3222356',
  CIP13: '3400932223565',
  ucdLib: "NERISONE POM TB30G",
  UCD7: '9062155',
  UCD13: '3400890621557',
  ucdQtyMultiplicator: 1,
  cipLib: "NERISONE POM TB30G BT 1",
  atcCode: "D07AC06"
}, {
  CIP7: '3275826',
  CIP13: '3400932758265',
  ucdLib: "DIPROLENE 0,05% POM TB15G",
  UCD7: '9105120',
  UCD13: '3400891051209',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPROLENE 0,05% POM TB15G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '3011010',
  CIP13: '3400930110102',
  ucdLib: "BETNEVAL LOTION 0,1% FL15G",
  UCD7: '9010566',
  UCD13: '3400890105668',
  ucdQtyMultiplicator: 1,
  cipLib: "BETNEVAL LOTION 0,1% FL15G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '3230901',
  CIP13: '3400932309016',
  ucdLib: "DIPROSONE 0,05% CR TB30G",
  UCD7: '9027733',
  UCD13: '3400890277334',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPROSONE 0,05% CR TB30G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '3230829',
  CIP13: '3400932308293',
  ucdLib: "DIPROSONE 0,05% POM TB30G",
  UCD7: '9109750',
  UCD13: '3400891097504',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPROSONE 0,05% POM TB30G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '3198439',
  CIP13: '3400931984399',
  ucdLib: "DIPROSONE 0,05% LOT FL30G",
  UCD7: '9027756',
  UCD13: '3400890277563',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPROSONE 0,05% LOT FL30G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '3247333',
  CIP13: '3400932473335',
  ucdLib: "BETNEVAL 0,1% CR TB30G",
  UCD7: '9108302',
  UCD13: '3400891083026',
  ucdQtyMultiplicator: 1,
  cipLib: "BETNEVAL 0,1% CR TB30G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '3247356',
  CIP13: '3400932473564',
  ucdLib: "BETNEVAL 0,1% POM TB30G",
  UCD7: '9108325',
  UCD13: '3400891083255',
  ucdQtyMultiplicator: 1,
  cipLib: "BETNEVAL 0,1% POM TB30G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '3779774',
  CIP13: '3400937797740',
  ucdLib: "BETESIL 2,25MG EMPL MEDIC",
  UCD7: '9304380',
  UCD13: '3400893043806',
  ucdQtyMultiplicator: 8,
  cipLib: "BETESIL 2,25MG EMPL MEDIC BT 8",
  atcCode: "D07AC01"
}, {
  CIP7: '5527002',
  CIP13: '3400955270027',
  ucdLib: "BETNEVAL 0,1% CR TB100G",
  UCD7: '9108294',
  UCD13: '3400891082944',
  ucdQtyMultiplicator: 1,
  cipLib: "BETNEVAL 0,1% CR TB100G BT 1",
  atcCode: "D07AC01"
}, {
  CIP7: '3192796',
  CIP13: '3400931927969',
  ucdLib: "LOCAPRED 0,1% CR TB15G",
  UCD7: '9054865',
  UCD13: '3400890548656',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCAPRED 0,1% CR TB15G BT 1",
  atcCode: "D07AB08"
}, {
  CIP7: '3158575',
  CIP13: '3400931585756',
  ucdLib: "TRIDESONIT 0,05% CR TB30G",
  UCD7: '9094758',
  UCD13: '3400890947589',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIDESONIT 0,05% CR TB30G BT 1",
  atcCode: "D07AB08"
}, {
  CIP7: '3385124',
  CIP13: '3400933851248',
  ucdLib: "LOCATOP 0,1% CR TB30G",
  UCD7: '9186213',
  UCD13: '3400891862133',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCATOP 0,1% CR TB30G BT 1",
  atcCode: "D07AB08"
}, {
  CIP7: '3278517',
  CIP13: '3400932785179',
  ucdLib: "LOCOID CR EPAIS TB30G",
  UCD7: '9106007',
  UCD13: '3400891060072',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCOID CR EPAIS TB30G BT 1",
  atcCode: "D07AB02"
}, {
  CIP7: '3218969',
  CIP13: '3400932189694',
  ucdLib: "LOCOID 0,1% CR TB30G",
  UCD7: '9054888',
  UCD13: '3400890548885',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCOID 0,1% CR TB30G BT 1",
  atcCode: "D07AB02"
}, {
  CIP7: '3368491',
  CIP13: '3400933684914',
  ucdLib: "LOCOID 0,1% EMUL FL30G",
  UCD7: '9167032',
  UCD13: '3400891670325',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCOID 0,1% EMUL FL30G BT 1",
  atcCode: "D07AB02"
}, {
  CIP7: '3218946',
  CIP13: '3400932189465',
  ucdLib: "LOCOID 0,1% LOT FL30ML",
  UCD7: '9054894',
  UCD13: '3400890548946',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCOID 0,1% LOT FL30ML BT 1",
  atcCode: "D07AB02"
}, {
  CIP7: '3219029',
  CIP13: '3400932190294',
  ucdLib: "LOCOID 0,1% POM TB30G",
  UCD7: '9054902',
  UCD13: '3400890549028',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCOID 0,1% POM TB30G BT 1",
  atcCode: "D07AB02"
}, {
  CIP7: '3575652',
  CIP13: '3400935756527',
  ucdLib: "CORTAPAISYL 0,5% CR TB15G",
  UCD7: '9242851',
  UCD13: '3400892428512',
  ucdQtyMultiplicator: 1,
  cipLib: "CORTAPAISYL 0,5% CR TB15G BT 1",
  atcCode: "D07AA02"
}, {
  CIP7: '3585768',
  CIP13: '3400935857682',
  ucdLib: "DERMOFENAC DEMANG.0,5% CR 15G",
  UCD7: '9244867',
  UCD13: '3400892448671',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOFENAC DEMANG.0,5% CR 15G BT 1",
  atcCode: "D07AA02"
}, {
  CIP7: '3631876',
  CIP13: '3400936318762',
  ucdLib: "CORTISEDERMYL 0,5% CR TB15G",
  UCD7: '9259455',
  UCD13: '3400892594552',
  ucdQtyMultiplicator: 1,
  cipLib: "CORTISEDERMYL 0,5% CR TB15G BT 1",
  atcCode: "D07AA02"
}, {
  CIP7: '3695310',
  CIP13: '3400936953109',
  ucdLib: "HYDROCORTISONE JJC 1% CR TB15G",
  UCD7: '9300608',
  UCD13: '3400893006085',
  ucdQtyMultiplicator: 1,
  cipLib: "HYDROCORTISONE JJC 1% CR TB15G BT 1",
  atcCode: "D07AA02"
}, {
  CIP7: '2790182',
  CIP13: '3400927901829',
  ucdLib: "CORTAPAISYL 0,5% CR TB5G",
  UCD7: '9410509',
  UCD13: '3400894105091',
  ucdQtyMultiplicator: 3,
  cipLib: "CORTAPAISYL 0,5% CR TB5G BT 3",
  atcCode: "D07AA02"
}, {
  CIP7: '2685284',
  CIP13: '3400926852849',
  ucdLib: "PICATO 150MCG/G GEL TB0,47G",
  UCD7: '9399050',
  UCD13: '3400893990506',
  ucdQtyMultiplicator: 3,
  cipLib: "PICATO 150MCG/G GEL TB0,47G BT 3",
  atcCode: "D06BX02"
}, {
  CIP7: '2685290',
  CIP13: '3400926852900',
  ucdLib: "PICATO 500MCG/G GEL TB0,47G",
  UCD7: '9399067',
  UCD13: '3400893990674',
  ucdQtyMultiplicator: 2,
  cipLib: "PICATO 500MCG/G GEL TB0,47G BT 2",
  atcCode: "D06BX02"
}, {
  CIP7: '3336692',
  CIP13: '3400933366926',
  ucdLib: "ROZEX 0,75% GEL TB30G",
  UCD7: '9148566',
  UCD13: '3400891485660',
  ucdQtyMultiplicator: 1,
  cipLib: "ROZEX 0,75% GEL TB30G BT 1",
  atcCode: "D06BX01"
}, {
  CIP7: '3347218',
  CIP13: '3400933472184',
  ucdLib: "ROZAGEL LOC GEL TB30G",
  UCD7: '9159647',
  UCD13: '3400891596472',
  ucdQtyMultiplicator: 1,
  cipLib: "ROZAGEL LOC GEL TB30G BT 1",
  atcCode: "D06BX01"
}, {
  CIP7: '3526501',
  CIP13: '3400935265012',
  ucdLib: "ROZEX 0,75% EMUL TB30G",
  UCD7: '9236230',
  UCD13: '3400892362304',
  ucdQtyMultiplicator: 1,
  cipLib: "ROZEX 0,75% EMUL TB30G BT 1",
  atcCode: "D06BX01"
}, {
  CIP7: '3534593',
  CIP13: '3400935345936',
  ucdLib: "ROZACREME 0,75% CR TB30G",
  UCD7: '9226361',
  UCD13: '3400892263618',
  ucdQtyMultiplicator: 1,
  cipLib: "ROZACREME 0,75% CR TB30G BT 1",
  atcCode: "D06BX01"
}, {
  CIP7: '3482459',
  CIP13: '3400934824593',
  ucdLib: "ROZEX 0,75% CR TB30G",
  UCD7: '9209865',
  UCD13: '3400892098654',
  ucdQtyMultiplicator: 1,
  cipLib: "ROZEX 0,75% CR TB30G BT 1",
  atcCode: "D06BX01"
}, {
  CIP7: '3804153',
  CIP13: '3400938041538',
  ucdLib: "ERAZABAN 10% CR TB2G",
  UCD7: '9355839',
  UCD13: '3400893558393',
  ucdQtyMultiplicator: 1,
  cipLib: "ERAZABAN 10% CR TB2G BT 1",
  atcCode: "D06BB11"
}, {
  CIP7: '4950201',
  CIP13: '3400949502011',
  ucdLib: "ALDARA 5% CR SACH ADP MWI",
  UCD7: '9351899',
  UCD13: '3400893518991',
  ucdQtyMultiplicator: 12,
  cipLib: "ALDARA 5% CR SACH ADP MWI BT 12",
  atcCode: "D06BB10"
}, {
  CIP7: '3492044',
  CIP13: '3400934920448',
  ucdLib: "ALDARA 5% CR SACH",
  UCD7: '9207122',
  UCD13: '3400892071220',
  ucdQtyMultiplicator: 12,
  cipLib: "ALDARA 5% CR SACH BT 12",
  atcCode: "D06BB10"
}, {
  CIP7: '3156843',
  CIP13: '3400931568438',
  ucdLib: "CUTERPES 1% GEL TB5G",
  UCD7: '9023296',
  UCD13: '3400890232968',
  ucdQtyMultiplicator: 1,
  cipLib: "CUTERPES 1% GEL TB5G BT 1",
  atcCode: "D06BB08"
}, {
  CIP7: '3312616',
  CIP13: '3400933126162',
  ucdLib: "CONDYLINE 0,5% LOC SOL FV3,5ML",
  UCD7: '9136379',
  UCD13: '3400891363791',
  ucdQtyMultiplicator: 1,
  cipLib: "CONDYLINE 0,5% LOC SOL FV3,5ML BT 1",
  atcCode: "D06BB04"
}, {
  CIP7: '3457349',
  CIP13: '3400934573491',
  ucdLib: "ACTIVIR 5% CR TB ALU 2G",
  UCD7: '9217327',
  UCD13: '3400892173276',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTIVIR 5% CR TB ALU 2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3612376',
  CIP13: '3400936123762',
  ucdLib: "ACICLOVIR ARW 5% CR TB10G",
  UCD7: '9248291',
  UCD13: '3400892482910',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR ARW 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3612353',
  CIP13: '3400936123533',
  ucdLib: "ACICLOVIR MYL 5% CR TB10G",
  UCD7: '9247848',
  UCD13: '3400892478487',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR MYL 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3617787',
  CIP13: '3400936177871',
  ucdLib: "ACICLOVIR RPG 5% CR TB10G",
  UCD7: '9259248',
  UCD13: '3400892592480',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR RPG 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3612382',
  CIP13: '3400936123823',
  ucdLib: "ACICLOVIR RTP 5% CR TB10G",
  UCD7: '9247340',
  UCD13: '3400892473406',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR RTP 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3617706',
  CIP13: '3400936177062',
  ucdLib: "ACICLOVIR TVC 5% CR TB10G",
  UCD7: '9256681',
  UCD13: '3400892566818',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR TVC 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3284618',
  CIP13: '3400932846184',
  ucdLib: "ZOVIRAX 5% CR TB10G",
  UCD7: '9120935',
  UCD13: '3400891209358',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOVIRAX 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3284601',
  CIP13: '3400932846016',
  ucdLib: "ZOVIRAX 5% CR TB2G",
  UCD7: '9123632',
  UCD13: '3400891236323',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOVIRAX 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3681957',
  CIP13: '3400936819573',
  ucdLib: "ACICLOVIR SDZ 5% CR TB10G",
  UCD7: '9268773',
  UCD13: '3400892687735',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR SDZ 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3405128',
  CIP13: '3400934051289',
  ucdLib: "ACTIVIR 5% CR TB POMP2G",
  UCD7: '9186271',
  UCD13: '3400891862713',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTIVIR 5% CR TB POMP2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3674199',
  CIP13: '3400936741997',
  ucdLib: "ACICLOVIR ZEN 5% CR TB10G",
  UCD7: '9269672',
  UCD13: '3400892696720',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR ZEN 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3855469',
  CIP13: '3400938554694',
  ucdLib: "ACICLOVIR CRT 5% CR TB10G",
  UCD7: '9316101',
  UCD13: '3400893161012',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR CRT 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3628880',
  CIP13: '3400936288805',
  ucdLib: "HERPESEDERMYL 5% CR TB2G",
  UCD7: '9263043',
  UCD13: '3400892630434',
  ucdQtyMultiplicator: 1,
  cipLib: "HERPESEDERMYL 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3540062',
  CIP13: '3400935400628',
  ucdLib: "ACICLOVIR BGC 5% CR TB2G",
  UCD7: '9400089',
  UCD13: '3400894000891',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR BGC 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3540056',
  CIP13: '3400935400567',
  ucdLib: "ACICLOVIR MYP 5% CR TB2G",
  UCD7: '9266076',
  UCD13: '3400892660769',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR MYP 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3548684',
  CIP13: '3400935486844',
  ucdLib: "ACICLOVIR RTC 5% CR TB2G",
  UCD7: '9286400',
  UCD13: '3400892864006',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR RTC 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3668744',
  CIP13: '3400936687448',
  ucdLib: "ACICLOVIR ALM 5% CR TB10G",
  UCD7: '9278240',
  UCD13: '3400892782409',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR ALM 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3639257',
  CIP13: '3400936392571',
  ucdLib: "ACICLOVIR AWC 5% CR TB2G",
  UCD7: '9262664',
  UCD13: '3400892626642',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR AWC 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3635845',
  CIP13: '3400936358454',
  ucdLib: "ACICLOVIR BGA 5% CR TB10G",
  UCD7: '9248463',
  UCD13: '3400892484631',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR BGA 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3639292',
  CIP13: '3400936392922',
  ucdLib: "ACICLOVIR CRC 5% CR TB2G",
  UCD7: '9343606',
  UCD13: '3400893436066',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR CRC 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3768606',
  CIP13: '3400937686068',
  ucdLib: "ACICLOVIR MYP 5% CR FL2G",
  UCD7: '9294262',
  UCD13: '3400892942629',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR MYP 5% CR FL2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3633697',
  CIP13: '3400936336971',
  ucdLib: "REMEX 5% CR TB2G",
  UCD7: '9299845',
  UCD13: '3400892998459',
  ucdQtyMultiplicator: 1,
  cipLib: "REMEX 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3491524',
  CIP13: '3400934915246',
  ucdLib: "ACICLOVIR EG 5% CR TB10G",
  UCD7: '9211721',
  UCD13: '3400892117218',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR EG 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3775397',
  CIP13: '3400937753975',
  ucdLib: "ACICLOVIR SDC 5% CR TB2G",
  UCD7: '9304078',
  UCD13: '3400893040782',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR SDC 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3642466',
  CIP13: '3400936424661',
  ucdLib: "ACICLOVIR ZYD 5% CR TB10G",
  UCD7: '9262262',
  UCD13: '3400892622620',
  ucdQtyMultiplicator: 1,
  cipLib: "ACICLOVIR ZYD 5% CR TB10G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '3494882',
  CIP13: '3400934948824',
  ucdLib: "KENDIX 5% CR TB2G",
  UCD7: '9241662',
  UCD13: '3400892416625',
  ucdQtyMultiplicator: 1,
  cipLib: "KENDIX 5% CR TB2G BT 1",
  atcCode: "D06BB03"
}, {
  CIP7: '5575260',
  CIP13: '3400955752608',
  ucdLib: "FLAMMACERIUM CR STER POT 500G",
  UCD7: '9156301',
  UCD13: '3400891563016',
  ucdQtyMultiplicator: 1,
  cipLib: "FLAMMACERIUM CR STER POT 500G BT 1",
  atcCode: "D06BA51"
}, {
  CIP7: '3207032',
  CIP13: '3400932070329',
  ucdLib: "FLAMMAZINE CR POT500G",
  UCD7: '9110463',
  UCD13: '3400891104639',
  ucdQtyMultiplicator: 1,
  cipLib: "FLAMMAZINE CR POT500G BT 1",
  atcCode: "D06BA01"
}, {
  CIP7: '3207026',
  CIP13: '3400932070268',
  ucdLib: "FLAMMAZINE CR TB50G",
  UCD7: '9035141',
  UCD13: '3400890351416',
  ucdQtyMultiplicator: 1,
  cipLib: "FLAMMAZINE CR TB50G BT 1",
  atcCode: "D06BA01"
}, {
  CIP7: '2761022',
  CIP13: '3400927610226',
  ucdLib: "MUPIROCINE BGA 2% POM TB15G",
  UCD7: '9406407',
  UCD13: '3400894064077',
  ucdQtyMultiplicator: 1,
  cipLib: "MUPIROCINE BGA 2% POM TB15G BT 1",
  atcCode: "D06AX09"
}, {
  CIP7: '3304634',
  CIP13: '3400933046347',
  ucdLib: "MUPIDERM 2% POM TB15G",
  UCD7: '9138183',
  UCD13: '3400891381832',
  ucdQtyMultiplicator: 1,
  cipLib: "MUPIDERM 2% POM TB15G BT 1",
  atcCode: "D06AX09"
}, {
  CIP7: '3293184',
  CIP13: '3400932931842',
  ucdLib: "FUCIDINE 2% CR TB15G",
  UCD7: '9123098',
  UCD13: '3400891230987',
  ucdQtyMultiplicator: 1,
  cipLib: "FUCIDINE 2% CR TB15G BT 1",
  atcCode: "D06AX01"
}, {
  CIP7: '3041703',
  CIP13: '3400930417034',
  ucdLib: "FUCIDINE 2% POM TB15G",
  UCD7: '9036525',
  UCD13: '3400890365253',
  ucdQtyMultiplicator: 1,
  cipLib: "FUCIDINE 2% POM TB15G BT 1",
  atcCode: "D06AX01"
}, {
  CIP7: '3887558',
  CIP13: '3400938875584',
  ucdLib: "ACIDE FUSIDIQ.EG 2% CR TB15G",
  UCD7: '9324201',
  UCD13: '3400893242018',
  ucdQtyMultiplicator: 1,
  cipLib: "ACIDE FUSIDIQ.EG 2% CR TB15G BT 1",
  atcCode: "D06AX01"
}, {
  CIP7: '3887570',
  CIP13: '3400938875706',
  ucdLib: "ACIDE FUSIDIQ.MYL 2% CR TB15G",
  UCD7: '9326938',
  UCD13: '3400893269381',
  ucdQtyMultiplicator: 1,
  cipLib: "ACIDE FUSIDIQ.MYL 2% CR TB15G BT 1",
  atcCode: "D06AX01"
}, {
  CIP7: '3874231',
  CIP13: '3400938742312',
  ucdLib: "FUSIDATE P.F 2% POM TB15G",
  UCD7: '9321800',
  UCD13: '3400893218006',
  ucdQtyMultiplicator: 1,
  cipLib: "FUSIDATE P.F 2% POM TB15G BT 1",
  atcCode: "D06AX01"
}, {
  CIP7: '3847872',
  CIP13: '3400938478723',
  ucdLib: "ACIDE FUSIDIQ.ARW 2% CR TB15G",
  UCD7: '9312735',
  UCD13: '3400893127353',
  ucdQtyMultiplicator: 1,
  cipLib: "ACIDE FUSIDIQ.ARW 2% CR TB15G BT 1",
  atcCode: "D06AX01"
}, {
  CIP7: '3912635',
  CIP13: '3400939126357',
  ucdLib: "ACIDE FUSIDIQ.SDZ 2% CR TB15G",
  UCD7: '9329753',
  UCD13: '3400893297537',
  ucdQtyMultiplicator: 1,
  cipLib: "ACIDE FUSIDIQ.SDZ 2% CR TB15G BT 1",
  atcCode: "D06AX01"
}, {
  CIP7: '4965651',
  CIP13: '3400949656516',
  ucdLib: "ACIDE FUSIDIQ.BGR 2% CR TB15G",
  UCD7: '9369296',
  UCD13: '3400893692967',
  ucdQtyMultiplicator: 1,
  cipLib: "ACIDE FUSIDIQ.BGR 2% CR TB15G BT 1",
  atcCode: "D06AX01"
}, {
  CIP7: '3008580',
  CIP13: '3400930085806',
  ucdLib: "AUREOMYCINE MONOT 3% POM TB15G",
  UCD7: '9008411',
  UCD13: '3400890084116',
  ucdQtyMultiplicator: 1,
  cipLib: "AUREOMYCINE MONOT 3% POM TB15G BT 1",
  atcCode: "D06AA02"
}, {
  CIP7: '3421328',
  CIP13: '3400934213281',
  ucdLib: "AUREOMYCINE EVM 3% POM 15G",
  UCD7: '9200580',
  UCD13: '3400892005805',
  ucdQtyMultiplicator: 1,
  cipLib: "AUREOMYCINE EVM 3% POM 15G BT 1",
  atcCode: "D06AA02"
}, {
  CIP7: '3312639',
  CIP13: '3400933126391',
  ucdLib: "SORIATANE 10MG GELU",
  UCD7: '9137278',
  UCD13: '3400891372786',
  ucdQtyMultiplicator: 30,
  cipLib: "SORIATANE 10MG GELU BT 30",
  atcCode: "D05BB02"
}, {
  CIP7: '3312674',
  CIP13: '3400933126742',
  ucdLib: "SORIATANE 25MG GELU",
  UCD7: '9137284',
  UCD13: '3400891372847',
  ucdQtyMultiplicator: 30,
  cipLib: "SORIATANE 25MG GELU BT 30",
  atcCode: "D05BB02"
}, {
  CIP7: '3065661',
  CIP13: '3400930656617',
  ucdLib: "MELADININE 10MG CPR",
  UCD7: '9057740',
  UCD13: '3400890577403',
  ucdQtyMultiplicator: 30,
  cipLib: "MELADININE 10MG CPR BT 30",
  atcCode: "D05BA02"
}, {
  CIP7: '3608268',
  CIP13: '3400936082687',
  ucdLib: "DAIVOBET POM TB60G",
  UCD7: '9250649',
  UCD13: '3400892506494',
  ucdQtyMultiplicator: 1,
  cipLib: "DAIVOBET POM TB60G BT 1",
  atcCode: "D05AX52"
}, {
  CIP7: '3896936',
  CIP13: '3400938969368',
  ucdLib: "DAIVOBET GEL FL60G",
  UCD7: '9354774',
  UCD13: '3400893547748',
  ucdQtyMultiplicator: 1,
  cipLib: "DAIVOBET GEL FL60G BT 1",
  atcCode: "D05AX52"
}, {
  CIP7: '3896971',
  CIP13: '3400938969719',
  ucdLib: "XAMIOL GEL FL60G",
  UCD7: '9338870',
  UCD13: '3400893388709',
  ucdQtyMultiplicator: 1,
  cipLib: "XAMIOL GEL FL60G BT 1",
  atcCode: "D05AX52"
}, {
  CIP7: '2794607',
  CIP13: '3400927946073',
  ucdLib: "DAIVOBET GEL CARTCHE60G",
  UCD7: '9412069',
  UCD13: '3400894120698',
  ucdQtyMultiplicator: 1,
  cipLib: "DAIVOBET GEL CARTCHE60G BT 1",
  atcCode: "D05AX52"
}, {
  CIP7: '3446506',
  CIP13: '3400934465062',
  ucdLib: "ZORAC 0,05% GEL TB60G",
  UCD7: '9205146',
  UCD13: '3400892051468',
  ucdQtyMultiplicator: 1,
  cipLib: "ZORAC 0,05% GEL TB60G BT 1",
  atcCode: "D05AX05"
}, {
  CIP7: '3446564',
  CIP13: '3400934465642',
  ucdLib: "ZORAC 0,1% GEL TB60G",
  UCD7: '9205169',
  UCD13: '3400892051697',
  ucdQtyMultiplicator: 1,
  cipLib: "ZORAC 0,1% GEL TB60G BT 1",
  atcCode: "D05AX05"
}, {
  CIP7: '3511184',
  CIP13: '3400935111845',
  ucdLib: "APSOR POM TB15G",
  UCD7: '9217557',
  UCD13: '3400892175577',
  ucdQtyMultiplicator: 1,
  cipLib: "APSOR POM TB15G BT 1",
  atcCode: "D05AX04"
}, {
  CIP7: '3511221',
  CIP13: '3400935112217',
  ucdLib: "APSOR POM TB60G",
  UCD7: '9217563',
  UCD13: '3400892175638',
  ucdQtyMultiplicator: 1,
  cipLib: "APSOR POM TB60G BT 1",
  atcCode: "D05AX04"
}, {
  CIP7: '3722024',
  CIP13: '3400937220248',
  ucdLib: "APSOR EMUL CUTA FL50ML",
  UCD7: '9298165',
  UCD13: '3400892981659',
  ucdQtyMultiplicator: 1,
  cipLib: "APSOR EMUL CUTA FL50ML BT 1",
  atcCode: "D05AX04"
}, {
  CIP7: '3511178',
  CIP13: '3400935111784',
  ucdLib: "SILKIS 3MCG/G POM TB100G",
  UCD7: '9249451',
  UCD13: '3400892494517',
  ucdQtyMultiplicator: 1,
  cipLib: "SILKIS 3MCG/G POM TB100G BT 1",
  atcCode: "D05AX03"
}, {
  CIP7: '3563488',
  CIP13: '3400935634887',
  ucdLib: "DAIVONEX 50MCG/G POM TB120G",
  UCD7: '9237353',
  UCD13: '3400892373539',
  ucdQtyMultiplicator: 1,
  cipLib: "DAIVONEX 50MCG/G POM TB120G BT 1",
  atcCode: "D05AX02"
}, {
  CIP7: '3065678',
  CIP13: '3400930656785',
  ucdLib: "MELADININE 0,1% LOC FL24ML",
  UCD7: '9057757',
  UCD13: '3400890577571',
  ucdQtyMultiplicator: 1,
  cipLib: "MELADININE 0,1% LOC FL24ML BT 1",
  atcCode: "D05AD02"
}, {
  CIP7: '3065684',
  CIP13: '3400930656846',
  ucdLib: "MELADININE 0,75% LOC FL24ML",
  UCD7: '9057763',
  UCD13: '3400890577632',
  ucdQtyMultiplicator: 1,
  cipLib: "MELADININE 0,75% LOC FL24ML BT 1",
  atcCode: "D05AD02"
}, {
  CIP7: '3290642',
  CIP13: '3400932906420',
  ucdLib: "EURAX 10% CR TB40G",
  UCD7: '9116922',
  UCD13: '3400891169225',
  ucdQtyMultiplicator: 1,
  cipLib: "EURAX 10% CR TB40G BT 1",
  atcCode: "D04AX"
}, {
  CIP7: '3071615',
  CIP13: '3400930716151',
  ucdLib: "NESTOSYL POM DERM TB30G",
  UCD7: '9062250',
  UCD13: '3400890622509',
  ucdQtyMultiplicator: 1,
  cipLib: "NESTOSYL POM DERM TB30G BT 1",
  atcCode: "D04AX"
}, {
  CIP7: '3527995',
  CIP13: '3400935279958',
  ucdLib: "PO 12 2% CR TB40G",
  UCD7: '9127564',
  UCD13: '3400891275643',
  ucdQtyMultiplicator: 1,
  cipLib: "PO 12 2% CR TB40G BT 1",
  atcCode: "D04AX"
}, {
  CIP7: '3397630',
  CIP13: '3400933976309',
  ucdLib: "CALAMINE GEL TB50ML",
  UCD7: '9178113',
  UCD13: '3400891781137',
  ucdQtyMultiplicator: 1,
  cipLib: "CALAMINE GEL TB50ML BT 1",
  atcCode: "D04AX"
}, {
  CIP7: '3368798',
  CIP13: '3400933687984',
  ucdLib: "IRRISEDERMYL CR TB30G",
  UCD7: '9197406',
  UCD13: '3400891974065',
  ucdQtyMultiplicator: 1,
  cipLib: "IRRISEDERMYL CR TB30G BT 1",
  atcCode: "D04AX"
}, {
  CIP7: '3171914',
  CIP13: '3400931719144',
  ucdLib: "ONCTOSE CR TB48G",
  UCD7: '9113243',
  UCD13: '3400891132434',
  ucdQtyMultiplicator: 1,
  cipLib: "ONCTOSE CR TB48G BT 1",
  atcCode: "D04AX"
}, {
  CIP7: '3089124',
  CIP13: '3400930891247',
  ucdLib: "QUOTANE 0,5% CR TB30G",
  UCD7: '9078110',
  UCD13: '3400890781107',
  ucdQtyMultiplicator: 1,
  cipLib: "QUOTANE 0,5% CR TB30G BT 1",
  atcCode: "D04AB05"
}, {
  CIP7: '3293043',
  CIP13: '3400932930432',
  ucdLib: "BUTIX GEL LOC TB PLAST 30G",
  UCD7: '9149181',
  UCD13: '3400891491814',
  ucdQtyMultiplicator: 1,
  cipLib: "BUTIX GEL LOC TB PLAST 30G BT 1",
  atcCode: "D04AA32"
}, {
  CIP7: '3171788',
  CIP13: '3400931717881',
  ucdLib: "APAISYLGEL 0,75% GEL TB30G",
  UCD7: '9005714',
  UCD13: '3400890057141',
  ucdQtyMultiplicator: 1,
  cipLib: "APAISYLGEL 0,75% GEL TB30G BT 1",
  atcCode: "D04AA22"
}, {
  CIP7: '3189015',
  CIP13: '3400931890157',
  ucdLib: "SEDERMYL 0,75% CR TB35G",
  UCD7: '9083186',
  UCD13: '3400890831864',
  ucdQtyMultiplicator: 1,
  cipLib: "SEDERMYL 0,75% CR TB35G BT 1",
  atcCode: "D04AA22"
}, {
  CIP7: '3082263',
  CIP13: '3400930822630',
  ucdLib: "PHENERGAN 2% CR TB30G",
  UCD7: '9071013',
  UCD13: '3400890710138',
  ucdQtyMultiplicator: 1,
  cipLib: "PHENERGAN 2% CR TB30G BT 1",
  atcCode: "D04AA10"
}, {
  CIP7: '3617095',
  CIP13: '3400936170957',
  ucdLib: "LAMIDERM 0,67% EMUL TB140ML",
  UCD7: '9258125',
  UCD13: '3400892581255',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMIDERM 0,67% EMUL TB140ML BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3285701',
  CIP13: '3400932857012',
  ucdLib: "BIAFINE EMUL CUTA TB186G",
  UCD7: '9010690',
  UCD13: '3400890106900',
  ucdQtyMultiplicator: 1,
  cipLib: "BIAFINE EMUL CUTA TB186G BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3192282',
  CIP13: '3400931922827',
  ucdLib: "BIAFINE EMUL CUTA TB93G",
  UCD7: '9108532',
  UCD13: '3400891085327',
  ucdQtyMultiplicator: 1,
  cipLib: "BIAFINE EMUL CUTA TB93G BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3544060',
  CIP13: '3400935440600',
  ucdLib: "LAMIDERM 0,67% EMUL TB200ML",
  UCD7: '9247400',
  UCD13: '3400892474007',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMIDERM 0,67% EMUL TB200ML BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3745976',
  CIP13: '3400937459761',
  ucdLib: "TROLAMINE NTM 0,67% LOC TB186G",
  UCD7: '9358588',
  UCD13: '3400893585887',
  ucdQtyMultiplicator: 1,
  cipLib: "TROLAMINE NTM 0,67% LOC TB186G BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3783209',
  CIP13: '3400937832090',
  ucdLib: "BIAFINEACT EMUL CUTA TB139,5G",
  UCD7: '9312899',
  UCD13: '3400893128992',
  ucdQtyMultiplicator: 1,
  cipLib: "BIAFINEACT EMUL CUTA TB139,5G BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3893292',
  CIP13: '3400938932928',
  ucdLib: "TROLAMINE BGA 0,67% LOC TB186G",
  UCD7: '9327228',
  UCD13: '3400893272282',
  ucdQtyMultiplicator: 1,
  cipLib: "TROLAMINE BGA 0,67% LOC TB186G BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3893263',
  CIP13: '3400938932638',
  ucdLib: "TROLAMINE BGA 0,67% LOC TB93G",
  UCD7: '9327234',
  UCD13: '3400893272343',
  ucdQtyMultiplicator: 1,
  cipLib: "TROLAMINE BGA 0,67% LOC TB93G BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3943558',
  CIP13: '3400939435589',
  ucdLib: "LAMIDERM 0,67% EMUL TB80ML",
  UCD7: '9339378',
  UCD13: '3400893393789',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMIDERM 0,67% EMUL TB80ML BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3980482',
  CIP13: '3400939804828',
  ucdLib: "TROLAMINE BGC 0,67% LOC 46,5G",
  UCD7: '9369221',
  UCD13: '3400893692219',
  ucdQtyMultiplicator: 1,
  cipLib: "TROLAMINE BGC 0,67% LOC 46,5G BT 1",
  atcCode: "D03AX12"
}, {
  CIP7: '3003682',
  CIP13: '3400930036822',
  ucdLib: "DEXPANTHENOL CRT 5% POM TB100G",
  UCD7: '9420910',
  UCD13: '3400894209102',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL CRT 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '3003680',
  CIP13: '3400930036808',
  ucdLib: "DEXPANTHENOL EGC 5% POM TB100G",
  UCD7: '9415978',
  UCD13: '3400894159780',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL EGC 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '3003679',
  CIP13: '3400930036792',
  ucdLib: "DEXPANTHENOL EGC 5% POM TB30G",
  UCD7: '9415984',
  UCD13: '3400894159841',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL EGC 5% POM TB30G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2764055',
  CIP13: '3400927640551',
  ucdLib: "DEXPANTHENOL ARW 5% POM TB100G",
  UCD7: '9398240',
  UCD13: '3400893982402',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL ARW 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2764049',
  CIP13: '3400927640490',
  ucdLib: "DEXPANTHENOL ARW 5% POM TB30G",
  UCD7: '9398257',
  UCD13: '3400893982570',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL ARW 5% POM TB30G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '3594017',
  CIP13: '3400935940179',
  ucdLib: "BEPANTHEN 5% POM TB100G",
  UCD7: '9240220',
  UCD13: '3400892402208',
  ucdQtyMultiplicator: 1,
  cipLib: "BEPANTHEN 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '3593992',
  CIP13: '3400935939920',
  ucdLib: "BEPANTHEN 5% POM TB30G",
  UCD7: '9240237',
  UCD13: '3400892402376',
  ucdQtyMultiplicator: 1,
  cipLib: "BEPANTHEN 5% POM TB30G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '3588778',
  CIP13: '3400935887788',
  ucdLib: "BEPANTHEN 5% CR TB100G",
  UCD7: '9240208',
  UCD13: '3400892402086',
  ucdQtyMultiplicator: 1,
  cipLib: "BEPANTHEN 5% CR TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '3383007',
  CIP13: '3400933830076',
  ucdLib: "BEPANTHEN 5% POM TB3,5G",
  UCD7: '9275566',
  UCD13: '3400892755663',
  ucdQtyMultiplicator: 1,
  cipLib: "BEPANTHEN 5% POM TB3,5G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '3919991',
  CIP13: '3400939199917',
  ucdLib: "BEPANTHEN 5% POM TB100G",
  UCD7: '9240220',
  UCD13: '3400892402208',
  ucdQtyMultiplicator: 2,
  cipLib: "BEPANTHEN 5% POM TB100G BT 2",
  atcCode: "D03AX03"
}, {
  CIP7: '2794783',
  CIP13: '3400927947834',
  ucdLib: "DEXPANTHENOL BGC 5% POM TB100G",
  UCD7: '9407482',
  UCD13: '3400894074823',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL BGC 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2794777',
  CIP13: '3400927947773',
  ucdLib: "DEXPANTHENOL BGC 5% POM TB30G",
  UCD7: '9407499',
  UCD13: '3400894074991',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL BGC 5% POM TB30G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2794725',
  CIP13: '3400927947254',
  ucdLib: "DEXPANTHENOL BLL 5% POM TB100G",
  UCD7: '9409104',
  UCD13: '3400894091042',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL BLL 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2794719',
  CIP13: '3400927947193',
  ucdLib: "DEXPANTHENOL BLL 5% POM TB30G",
  UCD7: '9409110',
  UCD13: '3400894091103',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL BLL 5% POM TB30G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2794889',
  CIP13: '3400927948893',
  ucdLib: "DEXPANTHENOL MYL 5% POM TB100G",
  UCD7: '9408978',
  UCD13: '3400894089780',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL MYL 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2794872',
  CIP13: '3400927948725',
  ucdLib: "DEXPANTHENOL MYL 5% POM TB30G",
  UCD7: '9408984',
  UCD13: '3400894089841',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL MYL 5% POM TB30G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2794754',
  CIP13: '3400927947544',
  ucdLib: "DEXPANTHENOL SDC 5% POM TB100G",
  UCD7: '9404911',
  UCD13: '3400894049111',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL SDC 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '2794820',
  CIP13: '3400927948206',
  ucdLib: "DEXPANTHENOL ZTC 5% POM TB100G",
  UCD7: '9413181',
  UCD13: '3400894131816',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXPANTHENOL ZTC 5% POM TB100G BT 1",
  atcCode: "D03AX03"
}, {
  CIP7: '3040224',
  CIP13: '3400930402245',
  ucdLib: "FLETAGEX POM TB30G",
  UCD7: '9168356',
  UCD13: '3400891683561',
  ucdQtyMultiplicator: 1,
  cipLib: "FLETAGEX POM TB30G BT 1",
  atcCode: "D03AA"
}, {
  CIP7: '3064093',
  CIP13: '3400930640937',
  ucdLib: "MADECASSOL 1% CR TB10G",
  UCD7: '9055971',
  UCD13: '3400890559713',
  ucdQtyMultiplicator: 1,
  cipLib: "MADECASSOL 1% CR TB10G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3000147',
  CIP13: '3400930001479',
  ucdLib: "A 313 POM TB50G",
  UCD7: '9000065',
  UCD13: '3400890000659',
  ucdQtyMultiplicator: 1,
  cipLib: "A 313 POM TB50G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3324246',
  CIP13: '3400933242466',
  ucdLib: "DERMOPHIL LEV POM BAT TB3,5G",
  UCD7: '9151887',
  UCD13: '3400891518870',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOPHIL LEV POM BAT TB3,5G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3293095',
  CIP13: '3400932930951',
  ucdLib: "CICATRYL POM DERM SACH2G",
  UCD7: '9120763',
  UCD13: '3400891207637',
  ucdQtyMultiplicator: 14,
  cipLib: "CICATRYL POM DERM SACH2G BT 14",
  atcCode: "D02AX"
}, {
  CIP7: '3293132',
  CIP13: '3400932931323',
  ucdLib: "CICATRYL POM DERM SACH2G",
  UCD7: '9120763',
  UCD13: '3400891207637',
  ucdQtyMultiplicator: 28,
  cipLib: "CICATRYL POM DERM SACH2G BT 28",
  atcCode: "D02AX"
}, {
  CIP7: '3290518',
  CIP13: '3400932905188',
  ucdLib: "MADECASSOL 1% CR TB25G",
  UCD7: '9117241',
  UCD13: '3400891172416',
  ucdQtyMultiplicator: 1,
  cipLib: "MADECASSOL 1% CR TB25G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3360207',
  CIP13: '3400933602079',
  ucdLib: "DERMOPHIL MAINS BAT TB30G",
  UCD7: '9160024',
  UCD13: '3400891600247',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOPHIL MAINS BAT TB30G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3636715',
  CIP13: '3400936367159',
  ucdLib: "MITOSYL IRRIT. POM TB150G",
  UCD7: '9217988',
  UCD13: '3400892179889',
  ucdQtyMultiplicator: 2,
  cipLib: "MITOSYL IRRIT. POM TB150G BT 2",
  atcCode: "D02AX"
}, {
  CIP7: '3161034',
  CIP13: '3400931610342',
  ucdLib: "CAMPHRICE CANADA 4% BAT TB30G",
  UCD7: '9015799',
  UCD13: '3400890157995',
  ucdQtyMultiplicator: 1,
  cipLib: "CAMPHRICE CANADA 4% BAT TB30G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3506266',
  CIP13: '3400935062666',
  ucdLib: "MITOSYL IRRIT. POM TB150G",
  UCD7: '9217988',
  UCD13: '3400892179889',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOSYL IRRIT. POM TB150G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '3506237',
  CIP13: '3400935062376',
  ucdLib: "MITOSYL IRRIT. POM TB65G",
  UCD7: '9217994',
  UCD13: '3400892179940',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOSYL IRRIT. POM TB65G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '4993877',
  CIP13: '3400949938773',
  ucdLib: "MITOSYL IRRIT. POM TB20G+300G",
  UCD7: '9373688',
  UCD13: '3400893736883',
  ucdQtyMultiplicator: 1,
  cipLib: "MITOSYL IRRIT. POM TB20G+300G BT 1",
  atcCode: "D02AX"
}, {
  CIP7: '4168802',
  CIP13: '3400941688027',
  ucdLib: "MITOSYL IRRIT. POM TB20G",
  UCD7: '9365677',
  UCD13: '3400893656778',
  ucdQtyMultiplicator: 2,
  cipLib: "MITOSYL IRRIT. POM TB20G BT 2",
  atcCode: "D02AX"
}, {
  CIP7: '3003748',
  CIP13: '3400930037485',
  ucdLib: "DEXERYLCARE CR FL POMP 500G",
  UCD7: '9419686',
  UCD13: '3400894196860',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXERYLCARE CR FL POMP 500G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '3001199',
  CIP13: '3400930011997',
  ucdLib: "GLYCER/VASEL/PARAF.EG CR 250G",
  UCD7: '9415010',
  UCD13: '3400894150107',
  ucdQtyMultiplicator: 1,
  cipLib: "GLYCER/VASEL/PARAF.EG CR 250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '3001200',
  CIP13: '3400930012000',
  ucdLib: "GLYCER/VASEL/PARAF.ZEN CR 250G",
  UCD7: '9416452',
  UCD13: '3400894164524',
  ucdQtyMultiplicator: 1,
  cipLib: "GLYCER/VASEL/PARAF.ZEN CR 250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '3437281',
  CIP13: '3400934372810',
  ucdLib: "COOPER VASELINE OFFIC TB20G",
  UCD7: '9198699',
  UCD13: '3400891986990',
  ucdQtyMultiplicator: 1,
  cipLib: "COOPER VASELINE OFFIC TB20G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '3437298',
  CIP13: '3400934372988',
  ucdLib: "COOPER VASELINE OFFIC TB45G",
  UCD7: '9198707',
  UCD13: '3400891987072',
  ucdQtyMultiplicator: 1,
  cipLib: "COOPER VASELINE OFFIC TB45G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '3437306',
  CIP13: '3400934373060',
  ucdLib: "COOPER VASELINE OFFIC TB80G",
  UCD7: '9198713',
  UCD13: '3400891987133',
  ucdQtyMultiplicator: 1,
  cipLib: "COOPER VASELINE OFFIC TB80G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '3404459',
  CIP13: '3400934044595',
  ucdLib: "DEXERYL CR TB250G",
  UCD7: '9209196',
  UCD13: '3400892091969',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXERYL CR TB250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '3344272',
  CIP13: '3400933442729',
  ucdLib: "DEXERYL CR TB50G",
  UCD7: '9201349',
  UCD13: '3400892013497',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXERYL CR TB50G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '3437275',
  CIP13: '3400934372759',
  ucdLib: "VASELINE CPF STER. TB20G",
  UCD7: '9201177',
  UCD13: '3400892011776',
  ucdQtyMultiplicator: 1,
  cipLib: "VASELINE CPF STER. TB20G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '2667435',
  CIP13: '3400926674359',
  ucdLib: "GLYCER/VASEL/PARAF.PFS CR 250G",
  UCD7: '9410225',
  UCD13: '3400894102250',
  ucdQtyMultiplicator: 1,
  cipLib: "GLYCER/VASEL/PARAF.PFS CR 250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '2783874',
  CIP13: '3400927838743',
  ucdLib: "DEXATOPIA CR TB250G",
  UCD7: '9411354',
  UCD13: '3400894113546',
  ucdQtyMultiplicator: 1,
  cipLib: "DEXATOPIA CR TB250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '2783868',
  CIP13: '3400927838682',
  ucdLib: "GLYCER/VASEL/PARAF.ARW CR 250G",
  UCD7: '9411495',
  UCD13: '3400894114956',
  ucdQtyMultiplicator: 1,
  cipLib: "GLYCER/VASEL/PARAF.ARW CR 250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '2678249',
  CIP13: '3400926782498',
  ucdLib: "GLYCER/VASEL/PARAF.BGA CR 250G",
  UCD7: '9408607',
  UCD13: '3400894086079',
  ucdQtyMultiplicator: 1,
  cipLib: "GLYCER/VASEL/PARAF.BGA CR 250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '2783584',
  CIP13: '3400927835841',
  ucdLib: "GLYCER/VASEL/PARAF.MYL CR 250G",
  UCD7: '9411325',
  UCD13: '3400894113256',
  ucdQtyMultiplicator: 1,
  cipLib: "GLYCER/VASEL/PARAF.MYL CR 250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '2783851',
  CIP13: '3400927838514',
  ucdLib: "GLYCER/VASEL/PARAF.SDZ CR 250G",
  UCD7: '9411503',
  UCD13: '3400894115038',
  ucdQtyMultiplicator: 1,
  cipLib: "GLYCER/VASEL/PARAF.SDZ CR 250G BT 1",
  atcCode: "D02AC"
}, {
  CIP7: '5532687',
  CIP13: '3400955326878',
  ucdLib: "SENOPHILE POM TB50G",
  UCD7: '9083499',
  UCD13: '3400890834995',
  ucdQtyMultiplicator: 50,
  cipLib: "SENOPHILE POM TB50G BT 50",
  atcCode: "D02AB"
}, {
  CIP7: '3053155',
  CIP13: '3400930531556',
  ucdLib: "INOTYOL POM TB50G",
  UCD7: '9046541',
  UCD13: '3400890465410',
  ucdQtyMultiplicator: 1,
  cipLib: "INOTYOL POM TB50G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3002933',
  CIP13: '3400930029336',
  ucdLib: "ALOPLASTINE PATE TB90G",
  UCD7: '9003313',
  UCD13: '3400890033138',
  ucdQtyMultiplicator: 1,
  cipLib: "ALOPLASTINE PATE TB90G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3012185',
  CIP13: '3400930121856',
  ucdLib: "BIOXYOL PATE DERM BT190G",
  UCD7: '9108561',
  UCD13: '3400891085617',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOXYOL PATE DERM BT190G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3028677',
  CIP13: '3400930286777',
  ucdLib: "DEFLAMOL POM TB30G",
  UCD7: '9024373',
  UCD13: '3400890243735',
  ucdQtyMultiplicator: 1,
  cipLib: "DEFLAMOL POM TB30G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3029530',
  CIP13: '3400930295304',
  ucdLib: "DERMOCUIVRE POM TB25G",
  UCD7: '9025390',
  UCD13: '3400890253901',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOCUIVRE POM TB25G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3077144',
  CIP13: '3400930771440',
  ucdLib: "OXYPLASTINE 46% POM TB135G",
  UCD7: '9066638',
  UCD13: '3400890666381',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYPLASTINE 46% POM TB135G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3077173',
  CIP13: '3400930771730',
  ucdLib: "OXYTHYOL PATE DERM POT160G",
  UCD7: '9066667',
  UCD13: '3400890666671',
  ucdQtyMultiplicator: 1,
  cipLib: "OXYTHYOL PATE DERM POT160G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3095797',
  CIP13: '3400930957974',
  ucdLib: "SENOPHILE POM TB50G",
  UCD7: '9083499',
  UCD13: '3400890834995',
  ucdQtyMultiplicator: 1,
  cipLib: "SENOPHILE POM TB50G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3410968',
  CIP13: '3400934109683',
  ucdLib: "AGATHOL BAUME POM TB50G",
  UCD7: '9191289',
  UCD13: '3400891912890',
  ucdQtyMultiplicator: 1,
  cipLib: "AGATHOL BAUME POM TB50G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3411169',
  CIP13: '3400934111693',
  ucdLib: "BRULEX POM TB30G",
  UCD7: '9196559',
  UCD13: '3400891965599',
  ucdQtyMultiplicator: 1,
  cipLib: "BRULEX POM TB30G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3541038',
  CIP13: '3400935410382',
  ucdLib: "ALOPLASTINE PATE TB200G",
  UCD7: '9127446',
  UCD13: '3400891274462',
  ucdQtyMultiplicator: 1,
  cipLib: "ALOPLASTINE PATE TB200G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3420576',
  CIP13: '3400934205767',
  ucdLib: "DERMOCUIVRE POM TB100G",
  UCD7: '9193696',
  UCD13: '3400891936964',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMOCUIVRE POM TB100G BT 1",
  atcCode: "D02AB"
}, {
  CIP7: '3349565',
  CIP13: '3400933495657',
  ucdLib: "LAMISIL 250MG CPR",
  UCD7: '9166630',
  UCD13: '3400891666304',
  ucdQtyMultiplicator: 14,
  cipLib: "LAMISIL 250MG CPR BT 14",
  atcCode: "D01BA02"
}, {
  CIP7: '3349571',
  CIP13: '3400933495718',
  ucdLib: "LAMISIL 250MG CPR",
  UCD7: '9166630',
  UCD13: '3400891666304',
  ucdQtyMultiplicator: 28,
  cipLib: "LAMISIL 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '4989077',
  CIP13: '3400949890774',
  ucdLib: "TERBINAFINE SDZ 250MG CPR",
  UCD7: '9363158',
  UCD13: '3400893631584',
  ucdQtyMultiplicator: 14,
  cipLib: "TERBINAFINE SDZ 250MG CPR BT 14",
  atcCode: "D01BA02"
}, {
  CIP7: '4989083',
  CIP13: '3400949890835',
  ucdLib: "TERBINAFINE SDZ 250MG CPR",
  UCD7: '9363158',
  UCD13: '3400893631584',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE SDZ 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3854843',
  CIP13: '3400938548433',
  ucdLib: "TERBINAFINE BLL 250MG CPR",
  UCD7: '9317678',
  UCD13: '3400893176788',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE BLL 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3659283',
  CIP13: '3400936592834',
  ucdLib: "TERBINAFINE EG 250MG CPR",
  UCD7: '9277306',
  UCD13: '3400892773063',
  ucdQtyMultiplicator: 14,
  cipLib: "TERBINAFINE EG 250MG CPR BT 14",
  atcCode: "D01BA02"
}, {
  CIP7: '3659308',
  CIP13: '3400936593084',
  ucdLib: "TERBINAFINE EG 250MG CPR",
  UCD7: '9277306',
  UCD13: '3400892773063',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE EG 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3705155',
  CIP13: '3400937051552',
  ucdLib: "TERBINAFINE ZEN 250MG CPR",
  UCD7: '9283376',
  UCD13: '3400892833767',
  ucdQtyMultiplicator: 14,
  cipLib: "TERBINAFINE ZEN 250MG CPR BT 14",
  atcCode: "D01BA02"
}, {
  CIP7: '3705161',
  CIP13: '3400937051613',
  ucdLib: "TERBINAFINE ZEN 250MG CPR",
  UCD7: '9283376',
  UCD13: '3400892833767',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE ZEN 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3749891',
  CIP13: '3400937498913',
  ucdLib: "TERBINAFINE BGA 250MG CPR",
  UCD7: '9290382',
  UCD13: '3400892903828',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE BGA 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3638708',
  CIP13: '3400936387089',
  ucdLib: "TERBINAFINE MYL 250MG CPR",
  UCD7: '9261707',
  UCD13: '3400892617077',
  ucdQtyMultiplicator: 14,
  cipLib: "TERBINAFINE MYL 250MG CPR BT 14",
  atcCode: "D01BA02"
}, {
  CIP7: '3638714',
  CIP13: '3400936387140',
  ucdLib: "TERBINAFINE MYL 250MG CPR",
  UCD7: '9261707',
  UCD13: '3400892617077',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE MYL 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3740878',
  CIP13: '3400937408783',
  ucdLib: "TERBINAFINE RTP 250MG CPR",
  UCD7: '9289634',
  UCD13: '3400892896342',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE RTP 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3711859',
  CIP13: '3400937118590',
  ucdLib: "FUNGSTER 250MG CPR",
  UCD7: '9283353',
  UCD13: '3400892833538',
  ucdQtyMultiplicator: 14,
  cipLib: "FUNGSTER 250MG CPR BT 14",
  atcCode: "D01BA02"
}, {
  CIP7: '3711865',
  CIP13: '3400937118651',
  ucdLib: "FUNGSTER 250MG CPR",
  UCD7: '9283353',
  UCD13: '3400892833538',
  ucdQtyMultiplicator: 28,
  cipLib: "FUNGSTER 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3786171',
  CIP13: '3400937861717',
  ucdLib: "TERBINAFINE ALM 250MG CPR",
  UCD7: '9302091',
  UCD13: '3400893020913',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE ALM 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3807105',
  CIP13: '3400938071054',
  ucdLib: "TERBINAFINE ARL 250MG CPR",
  UCD7: '9311109',
  UCD13: '3400893111093',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE ARL 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3804733',
  CIP13: '3400938047332',
  ucdLib: "TERBINAFINE ARW 250MG CPR",
  UCD7: '9303073',
  UCD13: '3400893030738',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE ARW 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3807080',
  CIP13: '3400938070804',
  ucdLib: "TERBINAFINE EVO 250MG CPR",
  UCD7: '9306433',
  UCD13: '3400893064337',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE EVO 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3802390',
  CIP13: '3400938023909',
  ucdLib: "TERBINAFINE TVC 250MG CPR",
  UCD7: '9303096',
  UCD13: '3400893030967',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE TVC 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3802912',
  CIP13: '3400938029123',
  ucdLib: "TERBINAFINE ZYD 250MG CPR",
  UCD7: '9303104',
  UCD13: '3400893031049',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE ZYD 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3973619',
  CIP13: '3400939736198',
  ucdLib: "TERBINAFINE CRT 250MG CPR",
  UCD7: '9341599',
  UCD13: '3400893415993',
  ucdQtyMultiplicator: 14,
  cipLib: "TERBINAFINE CRT 250MG CPR BT 14",
  atcCode: "D01BA02"
}, {
  CIP7: '3973625',
  CIP13: '3400939736259',
  ucdLib: "TERBINAFINE CRT 250MG CPR",
  UCD7: '9341599',
  UCD13: '3400893415993',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE CRT 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3939686',
  CIP13: '3400939396866',
  ucdLib: "TERBINAFINE RPG 250MG CPR",
  UCD7: '9355503',
  UCD13: '3400893555033',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE RPG 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3997979',
  CIP13: '3400939979793',
  ucdLib: "TERBINAFINE ISD 250MG CPR",
  UCD7: '9345686',
  UCD13: '3400893456866',
  ucdQtyMultiplicator: 28,
  cipLib: "TERBINAFINE ISD 250MG CPR BT 28",
  atcCode: "D01BA02"
}, {
  CIP7: '3046445',
  CIP13: '3400930464458',
  ucdLib: "GRISEFULINE 250MG CPR",
  UCD7: '9041012',
  UCD13: '3400890410120',
  ucdQtyMultiplicator: 30,
  cipLib: "GRISEFULINE 250MG CPR BT 30",
  atcCode: "D01BA01"
}, {
  CIP7: '3828892',
  CIP13: '3400938288926',
  ucdLib: "GRISEFULINE 500MG CPR",
  UCD7: '9321929',
  UCD13: '3400893219294',
  ucdQtyMultiplicator: 30,
  cipLib: "GRISEFULINE 500MG CPR BT 30",
  atcCode: "D01BA01"
}, {
  CIP7: '3099200',
  CIP13: '3400930992005',
  ucdLib: "SPORILINE 1% LOT FL25ML",
  UCD7: '9087250',
  UCD13: '3400890872508',
  ucdQtyMultiplicator: 1,
  cipLib: "SPORILINE 1% LOT FL25ML BT 1",
  atcCode: "D01AE18"
}, {
  CIP7: '3000721',
  CIP13: '3400930007211',
  ucdLib: "AMOROLFINE BGC 5% V3.2,5ML+30S",
  UCD7: '9409512',
  UCD13: '3400894095125',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE BGC 5% V3.2,5ML+30S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3000730',
  CIP13: '3400930007303',
  ucdLib: "AMOROLFINE EG 5% V3.2,5ML+10S",
  UCD7: '9421973',
  UCD13: '3400894219736',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE EG 5% V3.2,5ML+10S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3001021',
  CIP13: '3400930010211',
  ucdLib: "AMOROLFINE MYC 5% V3.2,5ML+30S",
  UCD7: '9414884',
  UCD13: '3400894148845',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE MYC 5% V3.2,5ML+30S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3004537',
  CIP13: '3400930045374',
  ucdLib: "AMOROLFINE P.F 5% V3.2,5ML+20S",
  UCD7: '9419657',
  UCD13: '3400894196570',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE P.F 5% V3.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3001358',
  CIP13: '3400930013588',
  ucdLib: "AMOROLFINE SDC 5% V3.2,5ML+30S",
  UCD7: '9407795',
  UCD13: '3400894077954',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE SDC 5% V3.2,5ML+30S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3001363',
  CIP13: '3400930013632',
  ucdLib: "AMOROLFINE SDZ 5% V3.2,5ML+20S",
  UCD7: '9407878',
  UCD13: '3400894078784',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE SDZ 5% V3.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3000973',
  CIP13: '3400930009734',
  ucdLib: "AMOROLFINE TVC 5% V3.2,5ML+20S",
  UCD7: '9409682',
  UCD13: '3400894096825',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE TVC 5% V3.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3000886',
  CIP13: '3400930008867',
  ucdLib: "AMOROLFINE ZEN 5% V3.2,5ML+20S",
  UCD7: '9417316',
  UCD13: '3400894173168',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE ZEN 5% V3.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3348873',
  CIP13: '3400933488734',
  ucdLib: "LOCERYL 5% VERN FL2,5ML+10SPAT",
  UCD7: '9164424',
  UCD13: '3400891644241',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCERYL 5% VERN FL2,5ML+10SPAT BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '4981495',
  CIP13: '3400949814954',
  ucdLib: "AMOROLFINE MYL 5% V.2,5ML+20SP",
  UCD7: '9365329',
  UCD13: '3400893653296',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE MYL 5% V.2,5ML+20SP BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '4981466',
  CIP13: '3400949814664',
  ucdLib: "AMOROLFINE TVC 5% V1.2,5ML+20S",
  UCD7: '9365341',
  UCD13: '3400893653418',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE TVC 5% V1.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3971767',
  CIP13: '3400939717678',
  ucdLib: "LOCERYLPRO 5% VERN ONGL F2,5ML",
  UCD7: '9344221',
  UCD13: '3400893442210',
  ucdQtyMultiplicator: 1,
  cipLib: "LOCERYLPRO 5% VERN ONGL F2,5ML BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '4197560',
  CIP13: '3400941975608',
  ucdLib: "AMOROLFINE ARW 5% V1.2,5ML+30S",
  UCD7: '9379685',
  UCD13: '3400893796856',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE ARW 5% V1.2,5ML+30S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '4996025',
  CIP13: '3400949960255',
  ucdLib: "AMOROLFINE ZEN 5% V1.2,5ML+20S",
  UCD7: '9368032',
  UCD13: '3400893680322',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE ZEN 5% V1.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '2166302',
  CIP13: '3400921663020',
  ucdLib: "AMOROLFINE CRT 5% V1.2,5ML+20S",
  UCD7: '9393685',
  UCD13: '3400893936856',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE CRT 5% V1.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '2166207',
  CIP13: '3400921662078',
  ucdLib: "AMOROLFINE RBX 5% V1.2,5ML+20S",
  UCD7: '9377232',
  UCD13: '3400893772324',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE RBX 5% V1.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '2166213',
  CIP13: '3400921662139',
  ucdLib: "AMOROLFINE RBX 5% V1.2,5ML+30S",
  UCD7: '9379751',
  UCD13: '3400893797518',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE RBX 5% V1.2,5ML+30S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '2189763',
  CIP13: '3400921897630',
  ucdLib: "AMOROLFINE UGO 5% V1.2,5ML+NEC",
  UCD7: '9383882',
  UCD13: '3400893838822',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE UGO 5% V1.2,5ML+NEC BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '4166602',
  CIP13: '3400941666025',
  ucdLib: "AMOROLFINE ZYD 5% V.2,5ML+20SP",
  UCD7: '9401195',
  UCD13: '3400894011958',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE ZYD 5% V.2,5ML+20SP BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '2794004',
  CIP13: '3400927940040',
  ucdLib: "AMOROLFINE ARW 5% V3.2,5ML+20S",
  UCD7: '9419462',
  UCD13: '3400894194620',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE ARW 5% V3.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '2793973',
  CIP13: '3400927939730',
  ucdLib: "AMOROLFINE BGR 5% V3.2,5ML+20S",
  UCD7: '9408599',
  UCD13: '3400894085997',
  ucdQtyMultiplicator: 1,
  cipLib: "AMOROLFINE BGR 5% V3.2,5ML+20S BT 1",
  atcCode: "D01AE16"
}, {
  CIP7: '3349594',
  CIP13: '3400933495947',
  ucdLib: "LAMISIL 1% CR TB15G",
  UCD7: '9172665',
  UCD13: '3400891726657',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMISIL 1% CR TB15G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3349625',
  CIP13: '3400933496258',
  ucdLib: "LAMISILATE 1% CR TB10G",
  UCD7: '9286216',
  UCD13: '3400892862163',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMISILATE 1% CR TB10G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3558553',
  CIP13: '3400935585530',
  ucdLib: "LAMISIL 1% LOC SOL FL PULV15ML",
  UCD7: '9236767',
  UCD13: '3400892367675',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMISIL 1% LOC SOL FL PULV15ML BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3554578',
  CIP13: '3400935545787',
  ucdLib: "TERBINAFINE EG 1% CR TB15G",
  UCD7: '9351652',
  UCD13: '3400893516522',
  ucdQtyMultiplicator: 1,
  cipLib: "TERBINAFINE EG 1% CR TB15G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3770684',
  CIP13: '3400937706841',
  ucdLib: "LAMISILATE MONODOS 1% SOL TB4G",
  UCD7: '9295669',
  UCD13: '3400892956695',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMISILATE MONODOS 1% SOL TB4G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3870983',
  CIP13: '3400938709834',
  ucdLib: "TERBINAFINE MYL 1% CR TB15G",
  UCD7: '9356520',
  UCD13: '3400893565209',
  ucdQtyMultiplicator: 1,
  cipLib: "TERBINAFINE MYL 1% CR TB15G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3500186',
  CIP13: '3400935001863',
  ucdLib: "LAMISILDERMGEL 1% GEL TB15G",
  UCD7: '9236773',
  UCD13: '3400892367736',
  ucdQtyMultiplicator: 1,
  cipLib: "LAMISILDERMGEL 1% GEL TB15G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3979208',
  CIP13: '3400939792088',
  ucdLib: "TERBINAFINE ARW 1% CR TB15G",
  UCD7: '9343368',
  UCD13: '3400893433683',
  ucdQtyMultiplicator: 1,
  cipLib: "TERBINAFINE ARW 1% CR TB15G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3898763',
  CIP13: '3400938987638',
  ucdLib: "TERBINAFINE BGA 1% CR TB15G",
  UCD7: '9327211',
  UCD13: '3400893272114',
  ucdQtyMultiplicator: 1,
  cipLib: "TERBINAFINE BGA 1% CR TB15G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3936707',
  CIP13: '3400939367071',
  ucdLib: "TERBINAFINE P.F 1% CR TB15G",
  UCD7: '9337712',
  UCD13: '3400893377123',
  ucdQtyMultiplicator: 1,
  cipLib: "TERBINAFINE P.F 1% CR TB15G BT 1",
  atcCode: "D01AE15"
}, {
  CIP7: '3255746',
  CIP13: '3400932557462',
  ucdLib: "MYCOSTER 1% CR TB30G",
  UCD7: '9116827',
  UCD13: '3400891168273',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOSTER 1% CR TB30G BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3304114',
  CIP13: '3400933041144',
  ucdLib: "MYCOSTER 1% SOL CUTA FP30ML",
  UCD7: '9126984',
  UCD13: '3400891269840',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOSTER 1% SOL CUTA FP30ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3686400',
  CIP13: '3400936864009',
  ucdLib: "MYCOSTER 10MG/G SHP FL60ML",
  UCD7: '9403219',
  UCD13: '3400894032199',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOSTER 10MG/G SHP FL60ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3341894',
  CIP13: '3400933418946',
  ucdLib: "MYCOSTER 8% SOL LOC FL3ML+PINC",
  UCD7: '9150824',
  UCD13: '3400891508246',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOSTER 8% SOL LOC FL3ML+PINC BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3523307',
  CIP13: '3400935233073',
  ucdLib: "SEBIPROX 1,5% SHAMP FL100ML",
  UCD7: '9249681',
  UCD13: '3400892496818',
  ucdQtyMultiplicator: 1,
  cipLib: "SEBIPROX 1,5% SHAMP FL100ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3412482',
  CIP13: '3400934124822',
  ucdLib: "MYCOSTER 1% PDR CUTA FL30G",
  UCD7: '9209813',
  UCD13: '3400892098135',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOSTER 1% PDR CUTA FL30G BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3882383',
  CIP13: '3400938823837',
  ucdLib: "CICLOPIROX BGA 8% VERN ONGL3ML",
  UCD7: '9324365',
  UCD13: '3400893243657',
  ucdQtyMultiplicator: 1,
  cipLib: "CICLOPIROX BGA 8% VERN ONGL3ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3882288',
  CIP13: '3400938822885',
  ucdLib: "CICLOPIROX MYL 8% VERN ONGL3ML",
  UCD7: '9323897',
  UCD13: '3400893238974',
  ucdQtyMultiplicator: 1,
  cipLib: "CICLOPIROX MYL 8% VERN ONGL3ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3882265',
  CIP13: '3400938822656',
  ucdLib: "CICLOPIROX TVC 8% VERN ONGL3ML",
  UCD7: '9323650',
  UCD13: '3400893236505',
  ucdQtyMultiplicator: 1,
  cipLib: "CICLOPIROX TVC 8% VERN ONGL3ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3950110',
  CIP13: '3400939501109',
  ucdLib: "ONYTEC 80MG/G VERN ONGL 6,6ML",
  UCD7: '9350919',
  UCD13: '3400893509197',
  ucdQtyMultiplicator: 1,
  cipLib: "ONYTEC 80MG/G VERN ONGL 6,6ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '2661504',
  CIP13: '3400926615048',
  ucdLib: "CICLOPIROX OLAM.BGA 1% CR T30G",
  UCD7: '9388974',
  UCD13: '3400893889749',
  ucdQtyMultiplicator: 1,
  cipLib: "CICLOPIROX OLAM.BGA 1% CR T30G BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '2661510',
  CIP13: '3400926615109',
  ucdLib: "CICLOPIROX OLAM.TVC 1% CR T30G",
  UCD7: '9388980',
  UCD13: '3400893889800',
  ucdQtyMultiplicator: 1,
  cipLib: "CICLOPIROX OLAM.TVC 1% CR T30G BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '2661527',
  CIP13: '3400926615277',
  ucdLib: "MYCOSKIN 1% CR TB30G",
  UCD7: '9388997',
  UCD13: '3400893889978',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOSKIN 1% CR TB30G BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '4900059',
  CIP13: '3400949000593',
  ucdLib: "SEBIPROX 1,5% SH.AIPMWIAT100ML",
  UCD7: '9415814',
  UCD13: '3400894158141',
  ucdQtyMultiplicator: 1,
  cipLib: "SEBIPROX 1,5% SH.AIPMWIAT100ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '2678717',
  CIP13: '3400926787172',
  ucdLib: "CICLOPIROX OLAM.SDZ 1% CR T30G",
  UCD7: '9414370',
  UCD13: '3400894143703',
  ucdQtyMultiplicator: 1,
  cipLib: "CICLOPIROX OLAM.SDZ 1% CR T30G BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '2228569',
  CIP13: '3400922285696',
  ucdLib: "MYCONAIL 80MG/G VERN ONGL3,3ML",
  UCD7: '9392817',
  UCD13: '3400893928172',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCONAIL 80MG/G VERN ONGL3,3ML BT 1",
  atcCode: "D01AE14"
}, {
  CIP7: '3346176',
  CIP13: '3400933461768',
  ucdLib: "SELSUN 2,5% SUSP EXT FP120ML",
  UCD7: '9158412',
  UCD13: '3400891584127',
  ucdQtyMultiplicator: 1,
  cipLib: "SELSUN 2,5% SUSP EXT FP120ML BT 1",
  atcCode: "D01AE13"
}, {
  CIP7: '3069386',
  CIP13: '3400930693865',
  ucdLib: "MYCODECYL CR TB30G",
  UCD7: '9060452',
  UCD13: '3400890604529',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCODECYL CR TB30G BT 1",
  atcCode: "D01AE04"
}, {
  CIP7: '3069363',
  CIP13: '3400930693636',
  ucdLib: "MYCODECYL PDR LOC FL50G",
  UCD7: '9060446',
  UCD13: '3400890604468',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCODECYL PDR LOC FL50G BT 1",
  atcCode: "D01AE04"
}, {
  CIP7: '3380888',
  CIP13: '3400933808884',
  ucdLib: "AMYCOR ONYCHOSET POM TB10G",
  UCD7: '9172530',
  UCD13: '3400891725308',
  ucdQtyMultiplicator: 1,
  cipLib: "AMYCOR ONYCHOSET POM TB10G BT 1",
  atcCode: "D01AC60"
}, {
  CIP7: '3491240',
  CIP13: '3400934912405',
  ucdLib: "MONAZOL 2% CR TB15G",
  UCD7: '9208676',
  UCD13: '3400892086767',
  ucdQtyMultiplicator: 1,
  cipLib: "MONAZOL 2% CR TB15G BT 1",
  atcCode: "D01AC14"
}, {
  CIP7: '3327055',
  CIP13: '3400933270551',
  ucdLib: "FONGAMIL 1% CR TB15G",
  UCD7: '9147963',
  UCD13: '3400891479638',
  ucdQtyMultiplicator: 1,
  cipLib: "FONGAMIL 1% CR TB15G BT 1",
  atcCode: "D01AC13"
}, {
  CIP7: '3298997',
  CIP13: '3400932989973',
  ucdLib: "FONGAMIL 1% PDR FL20G",
  UCD7: '9147986',
  UCD13: '3400891479867',
  ucdQtyMultiplicator: 1,
  cipLib: "FONGAMIL 1% PDR FL20G BT 1",
  atcCode: "D01AC13"
}, {
  CIP7: '3309488',
  CIP13: '3400933094881',
  ucdLib: "FONGAMIL 1% SOL FL PRESS 30G",
  UCD7: '9147992',
  UCD13: '3400891479928',
  ucdQtyMultiplicator: 1,
  cipLib: "FONGAMIL 1% SOL FL PRESS 30G BT 1",
  atcCode: "D01AC13"
}, {
  CIP7: '3338308',
  CIP13: '3400933383084',
  ucdLib: "LOMEXIN 2% CR TB15G",
  UCD7: '9176982',
  UCD13: '3400891769821',
  ucdQtyMultiplicator: 1,
  cipLib: "LOMEXIN 2% CR TB15G BT 1",
  atcCode: "D01AC12"
}, {
  CIP7: '3867633',
  CIP13: '3400938676334',
  ucdLib: "LOMEXIN 2% CR TB30G",
  UCD7: '9324282',
  UCD13: '3400893242827',
  ucdQtyMultiplicator: 1,
  cipLib: "LOMEXIN 2% CR TB30G BT 1",
  atcCode: "D01AC12"
}, {
  CIP7: '3338685',
  CIP13: '3400933386856',
  ucdLib: "FONX 1% CR TB15G",
  UCD7: '9157559',
  UCD13: '3400891575590',
  ucdQtyMultiplicator: 1,
  cipLib: "FONX 1% CR TB15G BT 1",
  atcCode: "D01AC11"
}, {
  CIP7: '3341322',
  CIP13: '3400933413224',
  ucdLib: "FONX 1% PDR LOC FL15G",
  UCD7: '9157565',
  UCD13: '3400891575651',
  ucdQtyMultiplicator: 1,
  cipLib: "FONX 1% PDR LOC FL15G BT 1",
  atcCode: "D01AC11"
}, {
  CIP7: '3358707',
  CIP13: '3400933587079',
  ucdLib: "FONX 1% SOL LOC FL PULV 15ML",
  UCD7: '9157571',
  UCD13: '3400891575712',
  ucdQtyMultiplicator: 1,
  cipLib: "FONX 1% SOL LOC FL PULV 15ML BT 1",
  atcCode: "D01AC11"
}, {
  CIP7: '3322856',
  CIP13: '3400933228569',
  ucdLib: "AMYCOR 1% SOL LOC FV15ML",
  UCD7: '9143899',
  UCD13: '3400891438994',
  ucdQtyMultiplicator: 1,
  cipLib: "AMYCOR 1% SOL LOC FV15ML BT 1",
  atcCode: "D01AC10"
}, {
  CIP7: '3274850',
  CIP13: '3400932748501',
  ucdLib: "AMYCOR 1% CR DERM TB15G",
  UCD7: '9119978',
  UCD13: '3400891199789',
  ucdQtyMultiplicator: 1,
  cipLib: "AMYCOR 1% CR DERM TB15G BT 1",
  atcCode: "D01AC10"
}, {
  CIP7: '3349418',
  CIP13: '3400933494186',
  ucdLib: "AMYCOR 1% PDR LOC FL15G",
  UCD7: '9157097',
  UCD13: '3400891570977',
  ucdQtyMultiplicator: 1,
  cipLib: "AMYCOR 1% PDR LOC FL15G BT 1",
  atcCode: "D01AC10"
}, {
  CIP7: '3838117',
  CIP13: '3400938381177',
  ucdLib: "KETOCONAZOLE ARW 2% GEL 20G",
  UCD7: '9313717',
  UCD13: '3400893137178',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOCONAZOLE ARW 2% GEL 20G BT 1",
  atcCode: "D01AC08"
}, {
  CIP7: '3836590',
  CIP13: '3400938365900',
  ucdLib: "KETOCONAZOLE ARW 2% GEL SACH",
  UCD7: '9313700',
  UCD13: '3400893137000',
  ucdQtyMultiplicator: 8,
  cipLib: "KETOCONAZOLE ARW 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3838258',
  CIP13: '3400938382587',
  ucdLib: "KETOCONAZOLE EG 2% GEL 20G",
  UCD7: '9313083',
  UCD13: '3400893130834',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOCONAZOLE EG 2% GEL 20G BT 1",
  atcCode: "D01AC08"
}, {
  CIP7: '3838270',
  CIP13: '3400938382709',
  ucdLib: "KETOCONAZOLE EG 2% GEL SACH",
  UCD7: '9313077',
  UCD13: '3400893130773',
  ucdQtyMultiplicator: 8,
  cipLib: "KETOCONAZOLE EG 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3292492',
  CIP13: '3400932924929',
  ucdLib: "KETODERM 2% CR DERM TB15G",
  UCD7: '9120036',
  UCD13: '3400891200362',
  ucdQtyMultiplicator: 1,
  cipLib: "KETODERM 2% CR DERM TB15G BT 1",
  atcCode: "D01AC08"
}, {
  CIP7: '3330695',
  CIP13: '3400933306953',
  ucdLib: "KETODERM 2% GEL SACH",
  UCD7: '9151628',
  UCD13: '3400891516289',
  ucdQtyMultiplicator: 8,
  cipLib: "KETODERM 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3886079',
  CIP13: '3400938860795',
  ucdLib: "KETOCONAZOLE CRT 2% GEL 20G",
  UCD7: '9327493',
  UCD13: '3400893274934',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOCONAZOLE CRT 2% GEL 20G BT 1",
  atcCode: "D01AC08"
}, {
  CIP7: '3886151',
  CIP13: '3400938861518',
  ucdLib: "KETOCONAZOLE CRT 2% GEL SACH",
  UCD7: '9327487',
  UCD13: '3400893274873',
  ucdQtyMultiplicator: 8,
  cipLib: "KETOCONAZOLE CRT 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3886010',
  CIP13: '3400938860108',
  ucdLib: "KETOCONAZOLE MYL 2% GEL 20G",
  UCD7: '9321852',
  UCD13: '3400893218525',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOCONAZOLE MYL 2% GEL 20G BT 1",
  atcCode: "D01AC08"
}, {
  CIP7: '3886033',
  CIP13: '3400938860337',
  ucdLib: "KETOCONAZOLE MYL 2% GEL SACH",
  UCD7: '9321846',
  UCD13: '3400893218464',
  ucdQtyMultiplicator: 8,
  cipLib: "KETOCONAZOLE MYL 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3886085',
  CIP13: '3400938860856',
  ucdLib: "KETOCONAZOLE SDZ 2% GEL 20G",
  UCD7: '9324448',
  UCD13: '3400893244487',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOCONAZOLE SDZ 2% GEL 20G BT 1",
  atcCode: "D01AC08"
}, {
  CIP7: '3886174',
  CIP13: '3400938861747',
  ucdLib: "KETOCONAZOLE SDZ 2% GEL SACH",
  UCD7: '9324431',
  UCD13: '3400893244319',
  ucdQtyMultiplicator: 8,
  cipLib: "KETOCONAZOLE SDZ 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3886139',
  CIP13: '3400938861396',
  ucdLib: "KETOCONAZOLE ZYD 2% GEL SACH",
  UCD7: '9327441',
  UCD13: '3400893274415',
  ucdQtyMultiplicator: 8,
  cipLib: "KETOCONAZOLE ZYD 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3841444',
  CIP13: '3400938414448',
  ucdLib: "KETOCONAZOLE BGA 2% GEL 20G",
  UCD7: '9314125',
  UCD13: '3400893141250',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOCONAZOLE BGA 2% GEL 20G BT 1",
  atcCode: "D01AC08"
}, {
  CIP7: '3841579',
  CIP13: '3400938415797',
  ucdLib: "KETOCONAZOLE BGA 2% GEL SACH",
  UCD7: '9314119',
  UCD13: '3400893141199',
  ucdQtyMultiplicator: 8,
  cipLib: "KETOCONAZOLE BGA 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3894222',
  CIP13: '3400938942224',
  ucdLib: "KETOCONAZOLE ZEN 2% GEL 20G",
  UCD7: '9326358',
  UCD13: '3400893263587',
  ucdQtyMultiplicator: 1,
  cipLib: "KETOCONAZOLE ZEN 2% GEL 20G BT 1",
  atcCode: "D01AC08"
}, {
  CIP7: '3894245',
  CIP13: '3400938942453',
  ucdLib: "KETOCONAZOLE ZEN 2% GEL SACH",
  UCD7: '9326341',
  UCD13: '3400893263419',
  ucdQtyMultiplicator: 8,
  cipLib: "KETOCONAZOLE ZEN 2% GEL SACH BT 8",
  atcCode: "D01AC08"
}, {
  CIP7: '3267040',
  CIP13: '3400932670406',
  ucdLib: "TROSYD 1% CR DERM TB30G",
  UCD7: '9109201',
  UCD13: '3400891092011',
  ucdQtyMultiplicator: 1,
  cipLib: "TROSYD 1% CR DERM TB30G BT 1",
  atcCode: "D01AC07"
}, {
  CIP7: '3318754',
  CIP13: '3400933187545',
  ucdLib: "FAZOL 2% EMUL LOC FP30G",
  UCD7: '9164335',
  UCD13: '3400891643350',
  ucdQtyMultiplicator: 1,
  cipLib: "FAZOL 2% EMUL LOC FP30G BT 1",
  atcCode: "D01AC05"
}, {
  CIP7: '3307288',
  CIP13: '3400933072889',
  ucdLib: "FAZOL 2% PDR LOC FP30G",
  UCD7: '9131040',
  UCD13: '3400891310405',
  ucdQtyMultiplicator: 1,
  cipLib: "FAZOL 2% PDR LOC FP30G BT 1",
  atcCode: "D01AC05"
}, {
  CIP7: '3222304',
  CIP13: '3400932223046',
  ucdLib: "FAZOL 2% CR TB30G",
  UCD7: '9034437',
  UCD13: '3400890344371',
  ucdQtyMultiplicator: 1,
  cipLib: "FAZOL 2% CR TB30G BT 1",
  atcCode: "D01AC05"
}, {
  CIP7: '3831109',
  CIP13: '3400938311099',
  ucdLib: "ECONAZOLE ARW 1% CR TB30G",
  UCD7: '9309466',
  UCD13: '3400893094662',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE ARW 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3831090',
  CIP13: '3400938310900',
  ucdLib: "ECONAZOLE ARW 1% EMUL FL30G",
  UCD7: '9309472',
  UCD13: '3400893094723',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE ARW 1% EMUL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3831084',
  CIP13: '3400938310849',
  ucdLib: "ECONAZOLE ARW 1% PDR FL30G",
  UCD7: '9309489',
  UCD13: '3400893094891',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE ARW 1% PDR FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3831078',
  CIP13: '3400938310788',
  ucdLib: "ECONAZOLE ARW 1% SOL FL30G",
  UCD7: '9309495',
  UCD13: '3400893094952',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE ARW 1% SOL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3614116',
  CIP13: '3400936141162',
  ucdLib: "ECONAZOLE TVC 1% SOL FL30G",
  UCD7: '9244979',
  UCD13: '3400892449791',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE TVC 1% SOL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3688244',
  CIP13: '3400936882447',
  ucdLib: "ECONAZOLE SDZ 1% PDR FL30G",
  UCD7: '9272102',
  UCD13: '3400892721026',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE SDZ 1% PDR FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3680857',
  CIP13: '3400936808577',
  ucdLib: "ECONAZOLE SDZ 1% SOL FL30G",
  UCD7: '9268891',
  UCD13: '3400892688916',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE SDZ 1% SOL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3400800',
  CIP13: '3400934008009',
  ucdLib: "ECONAZOLE RPG 1% CR TB30G",
  UCD7: '9184384',
  UCD13: '3400891843842',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE RPG 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3524347',
  CIP13: '3400935243478',
  ucdLib: "ECONAZOLE RPG 1% PDR FL30G",
  UCD7: '9217497',
  UCD13: '3400892174976',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE RPG 1% PDR FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3524413',
  CIP13: '3400935244130',
  ucdLib: "ECONAZOLE TVS 1% PDR FL30G",
  UCD7: '9219013',
  UCD13: '3400892190136',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE TVS 1% PDR FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3342362',
  CIP13: '3400933423629',
  ucdLib: "PEVARYL 1% PDR LOC FL30G",
  UCD7: '9179704',
  UCD13: '3400891797046',
  ucdQtyMultiplicator: 1,
  cipLib: "PEVARYL 1% PDR LOC FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3202253',
  CIP13: '3400932022533',
  ucdLib: "PEVARYL 1% EMUL FLUID FL30ML",
  UCD7: '9070717',
  UCD13: '3400890707176',
  ucdQtyMultiplicator: 1,
  cipLib: "PEVARYL 1% EMUL FLUID FL30ML BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3357694',
  CIP13: '3400933576943',
  ucdLib: "PEVARYL 1% SOL LOC FL PULV 30G",
  UCD7: '9165033',
  UCD13: '3400891650334',
  ucdQtyMultiplicator: 1,
  cipLib: "PEVARYL 1% SOL LOC FL PULV 30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3362376',
  CIP13: '3400933623760',
  ucdLib: "DERMAZOL 1% CR TB30G",
  UCD7: '9171217',
  UCD13: '3400891712179',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMAZOL 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3362407',
  CIP13: '3400933624071',
  ucdLib: "DERMAZOL 1% EMUL FL30G",
  UCD7: '9171223',
  UCD13: '3400891712230',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMAZOL 1% EMUL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3484731',
  CIP13: '3400934847318',
  ucdLib: "DERMAZOL 1% PDR FL30G",
  UCD7: '9213890',
  UCD13: '3400892138909',
  ucdQtyMultiplicator: 1,
  cipLib: "DERMAZOL 1% PDR FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3513409',
  CIP13: '3400935134097',
  ucdLib: "ECONAZOLE EG 1% CR TB30G",
  UCD7: '9215096',
  UCD13: '3400892150963',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE EG 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3513415',
  CIP13: '3400935134158',
  ucdLib: "ECONAZOLE EG 1% EMUL FL30G",
  UCD7: '9215104',
  UCD13: '3400892151045',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE EG 1% EMUL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3513378',
  CIP13: '3400935133786',
  ucdLib: "ECONAZOLE EG 1% PDR FL30G",
  UCD7: '9215682',
  UCD13: '3400892156828',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE EG 1% PDR FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3513421',
  CIP13: '3400935134219',
  ucdLib: "ECONAZOLE EG 1% SOL FL30G",
  UCD7: '9215110',
  UCD13: '3400892151106',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE EG 1% SOL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3656824',
  CIP13: '3400936568242',
  ucdLib: "ECONAZOLE SDZ 1% CR TB30G",
  UCD7: '9263623',
  UCD13: '3400892636238',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE SDZ 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3659604',
  CIP13: '3400936596047',
  ucdLib: "ECONAZOLE SDZ 1% EMUL FL30G",
  UCD7: '9263899',
  UCD13: '3400892638997',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE SDZ 1% EMUL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3517614',
  CIP13: '3400935176141',
  ucdLib: "MYCOAPAISYL 1% CR TB30G",
  UCD7: '9217853',
  UCD13: '3400892178530',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOAPAISYL 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3517620',
  CIP13: '3400935176202',
  ucdLib: "MYCOAPAISYL 1% LOC EMUL FL30G",
  UCD7: '9217876',
  UCD13: '3400892178769',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOAPAISYL 1% LOC EMUL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3517637',
  CIP13: '3400935176370',
  ucdLib: "MYCOAPAISYL 1% LOC PDR FL20G",
  UCD7: '9217882',
  UCD13: '3400892178820',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOAPAISYL 1% LOC PDR FL20G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3185224',
  CIP13: '3400931852247',
  ucdLib: "PEVARYL 1% CR TB30G",
  UCD7: '9070700',
  UCD13: '3400890707008',
  ucdQtyMultiplicator: 1,
  cipLib: "PEVARYL 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3386359',
  CIP13: '3400933863593',
  ucdLib: "ECONAZOLE TVS 1% CR TB30G",
  UCD7: '9178308',
  UCD13: '3400891783087',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE TVS 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3386342',
  CIP13: '3400933863425',
  ucdLib: "ECONAZOLE TVS 1% EMUL FL30G",
  UCD7: '9178314',
  UCD13: '3400891783148',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE TVS 1% EMUL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3386371',
  CIP13: '3400933863715',
  ucdLib: "ECONAZOLE TVS 1% SOL FL30G",
  UCD7: '9178337',
  UCD13: '3400891783377',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE TVS 1% SOL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3741228',
  CIP13: '3400937412285',
  ucdLib: "FONGILEINE 1% PDR FL30G",
  UCD7: '9286340',
  UCD13: '3400892863405',
  ucdQtyMultiplicator: 1,
  cipLib: "FONGILEINE 1% PDR FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3773228',
  CIP13: '3400937732284',
  ucdLib: "ECONAZOLE MYL 1% CR TB30G",
  UCD7: '9296491',
  UCD13: '3400892964911',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE MYL 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3773234',
  CIP13: '3400937732345',
  ucdLib: "ECONAZOLE MYL 1% EMUL FL30G",
  UCD7: '9296516',
  UCD13: '3400892965161',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE MYL 1% EMUL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3793739',
  CIP13: '3400937937399',
  ucdLib: "ECONAZOLE MYL 1% PDR FL30G",
  UCD7: '9301878',
  UCD13: '3400893018781',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE MYL 1% PDR FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3773240',
  CIP13: '3400937732406',
  ucdLib: "ECONAZOLE MYL 1% SOL FL30G",
  UCD7: '9297177',
  UCD13: '3400892971773',
  ucdQtyMultiplicator: 1,
  cipLib: "ECONAZOLE MYL 1% SOL FL30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '2215101',
  CIP13: '3400922151014',
  ucdLib: "MYCOSEDERMYL 1% CR TB30G",
  UCD7: '9384137',
  UCD13: '3400893841372',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOSEDERMYL 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3984190',
  CIP13: '3400939841908',
  ucdLib: "GYNOPURA 1% CR TB30G",
  UCD7: '9346438',
  UCD13: '3400893464380',
  ucdQtyMultiplicator: 1,
  cipLib: "GYNOPURA 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '2227417',
  CIP13: '3400922274171',
  ucdLib: "MYLEUGYNE 1% CR TB30G",
  UCD7: '9388537',
  UCD13: '3400893885376',
  ucdQtyMultiplicator: 1,
  cipLib: "MYLEUGYNE 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3429235',
  CIP13: '3400934292354',
  ucdLib: "FONGILEINE 1% CR TB30G",
  UCD7: '9267561',
  UCD13: '3400892675619',
  ucdQtyMultiplicator: 1,
  cipLib: "FONGILEINE 1% CR TB30G BT 1",
  atcCode: "D01AC03"
}, {
  CIP7: '3194105',
  CIP13: '3400931941057',
  ucdLib: "DAKTARIN 2% LOC PDR FL30G",
  UCD7: '9023899',
  UCD13: '3400890238991',
  ucdQtyMultiplicator: 1,
  cipLib: "DAKTARIN 2% LOC PDR FL30G BT 1",
  atcCode: "D01AC02"
}, {
  CIP7: '3692984',
  CIP13: '3400936929845',
  ucdLib: "CADUET 10MG/10MG CPR",
  UCD7: '9290778',
  UCD13: '3400892907789',
  ucdQtyMultiplicator: 30,
  cipLib: "CADUET 10MG/10MG CPR BT 30",
  atcCode: "C10BX03"
}, {
  CIP7: '3693050',
  CIP13: '3400936930506',
  ucdLib: "CADUET 5MG/10MG CPR",
  UCD7: '9290784',
  UCD13: '3400892907840',
  ucdQtyMultiplicator: 30,
  cipLib: "CADUET 5MG/10MG CPR BT 30",
  atcCode: "C10BX03"
}, {
  CIP7: '3757554',
  CIP13: '3400937575546',
  ucdLib: "CADUET 10MG/10MG CPR",
  UCD7: '9290778',
  UCD13: '3400892907789',
  ucdQtyMultiplicator: 90,
  cipLib: "CADUET 10MG/10MG CPR BT 90",
  atcCode: "C10BX03"
}, {
  CIP7: '3757548',
  CIP13: '3400937575485',
  ucdLib: "CADUET 5MG/10MG CPR",
  UCD7: '9290784',
  UCD13: '3400892907840',
  ucdQtyMultiplicator: 90,
  cipLib: "CADUET 5MG/10MG CPR BT 90",
  atcCode: "C10BX03"
}, {
  CIP7: '4900070',
  CIP13: '3400949000708',
  ucdLib: "CADUET 10/10MG CPR AIPBBA HR",
  UCD7: '9417598',
  UCD13: '3400894175988',
  ucdQtyMultiplicator: 30,
  cipLib: "CADUET 10/10MG CPR AIPBBA HR BT 30",
  atcCode: "C10BX03"
}, {
  CIP7: '4900071',
  CIP13: '3400949000715',
  ucdLib: "CADUET 10/10MG CPR AIPBBA HR",
  UCD7: '9417598',
  UCD13: '3400894175988',
  ucdQtyMultiplicator: 90,
  cipLib: "CADUET 10/10MG CPR AIPBBA HR BT 90",
  atcCode: "C10BX03"
}, {
  CIP7: '4900072',
  CIP13: '3400949000722',
  ucdLib: "CADUET 5/10MG CPR AIPBBA HR",
  UCD7: '9417606',
  UCD13: '3400894176060',
  ucdQtyMultiplicator: 90,
  cipLib: "CADUET 5/10MG CPR AIPBBA HR BT 90",
  atcCode: "C10BX03"
}, {
  CIP7: '4900073',
  CIP13: '3400949000739',
  ucdLib: "CADUET 5/10MG CPR AIPBBA HR",
  UCD7: '9417606',
  UCD13: '3400894176060',
  ucdQtyMultiplicator: 30,
  cipLib: "CADUET 5/10MG CPR AIPBBA HR BT 30",
  atcCode: "C10BX03"
}, {
  CIP7: '4900021',
  CIP13: '3400949000210',
  ucdLib: "CADUET 5/10MG CPR AIPPLA CZ",
  UCD7: '9411822',
  UCD13: '3400894118220',
  ucdQtyMultiplicator: 30,
  cipLib: "CADUET 5/10MG CPR AIPPLA CZ BT 30",
  atcCode: "C10BX03"
}, {
  CIP7: '2800489',
  CIP13: '3400928004895',
  ucdLib: "LIPTRUZET 10MG/10MG CPR",
  UCD7: '9406821',
  UCD13: '3400894068211',
  ucdQtyMultiplicator: 30,
  cipLib: "LIPTRUZET 10MG/10MG CPR BT 30",
  atcCode: "C10BA05"
}, {
  CIP7: '2800532',
  CIP13: '3400928005328',
  ucdLib: "LIPTRUZET 10MG/20MG CPR",
  UCD7: '9406838',
  UCD13: '3400894068389',
  ucdQtyMultiplicator: 30,
  cipLib: "LIPTRUZET 10MG/20MG CPR BT 30",
  atcCode: "C10BA05"
}, {
  CIP7: '2800555',
  CIP13: '3400928005557',
  ucdLib: "LIPTRUZET 10MG/40MG CPR",
  UCD7: '9406844',
  UCD13: '3400894068440',
  ucdQtyMultiplicator: 30,
  cipLib: "LIPTRUZET 10MG/40MG CPR BT 30",
  atcCode: "C10BA05"
}, {
  CIP7: '2800578',
  CIP13: '3400928005786',
  ucdLib: "LIPTRUZET 10MG/80MG CPR",
  UCD7: '9406927',
  UCD13: '3400894069270',
  ucdQtyMultiplicator: 30,
  cipLib: "LIPTRUZET 10MG/80MG CPR BT 30",
  atcCode: "C10BA05"
}, {
  CIP7: '3696137',
  CIP13: '3400936961371',
  ucdLib: "INEGY 10MG/20MG CPR",
  UCD7: '9277861',
  UCD13: '3400892778617',
  ucdQtyMultiplicator: 30,
  cipLib: "INEGY 10MG/20MG CPR BT 30",
  atcCode: "C10BA02"
}, {
  CIP7: '3696166',
  CIP13: '3400936961661',
  ucdLib: "INEGY 10MG/40MG CPR",
  UCD7: '9277878',
  UCD13: '3400892778785',
  ucdQtyMultiplicator: 30,
  cipLib: "INEGY 10MG/40MG CPR BT 30",
  atcCode: "C10BA02"
}, {
  CIP7: '3696203',
  CIP13: '3400936962033',
  ucdLib: "VYTORIN 10MG/20MG CPR",
  UCD7: '9379739',
  UCD13: '3400893797396',
  ucdQtyMultiplicator: 30,
  cipLib: "VYTORIN 10MG/20MG CPR BT 30",
  atcCode: "C10BA02"
}, {
  CIP7: '3696232',
  CIP13: '3400936962323',
  ucdLib: "VYTORIN 10MG/40MG CPR",
  UCD7: '9379745',
  UCD13: '3400893797457',
  ucdQtyMultiplicator: 30,
  cipLib: "VYTORIN 10MG/40MG CPR BT 30",
  atcCode: "C10BA02"
}, {
  CIP7: '3909567',
  CIP13: '3400939095677',
  ucdLib: "INEGY 10MG/20MG CPR",
  UCD7: '9277861',
  UCD13: '3400892778617',
  ucdQtyMultiplicator: 90,
  cipLib: "INEGY 10MG/20MG CPR BT 90",
  atcCode: "C10BA02"
}, {
  CIP7: '3909573',
  CIP13: '3400939095738',
  ucdLib: "INEGY 10MG/40MG CPR",
  UCD7: '9277878',
  UCD13: '3400892778785',
  ucdQtyMultiplicator: 90,
  cipLib: "INEGY 10MG/40MG CPR BT 90",
  atcCode: "C10BA02"
}, {
  CIP7: '5671383',
  CIP13: '3400956713837',
  ucdLib: "INEGY 10MG/20MG CPR",
  UCD7: '9277861',
  UCD13: '3400892778617',
  ucdQtyMultiplicator: 50,
  cipLib: "INEGY 10MG/20MG CPR BT 50",
  atcCode: "C10BA02"
}, {
  CIP7: '5671408',
  CIP13: '3400956714087',
  ucdLib: "INEGY 10MG/40MG CPR",
  UCD7: '9277878',
  UCD13: '3400892778785',
  ucdQtyMultiplicator: 50,
  cipLib: "INEGY 10MG/40MG CPR BT 50",
  atcCode: "C10BA02"
}, {
  CIP7: '3622759',
  CIP13: '3400936227590',
  ucdLib: "EZETIMIBE MSD 10MG CPR",
  UCD7: '9379722',
  UCD13: '3400893797228',
  ucdQtyMultiplicator: 28,
  cipLib: "EZETIMIBE MSD 10MG CPR BT 28",
  atcCode: "C10AX09"
}, {
  CIP7: '3622707',
  CIP13: '3400936227071',
  ucdLib: "EZETROL 10MG CPR",
  UCD7: '9250000',
  UCD13: '3400892500003',
  ucdQtyMultiplicator: 28,
  cipLib: "EZETROL 10MG CPR BT 28",
  atcCode: "C10AX09"
}, {
  CIP7: '3917006',
  CIP13: '3400939170060',
  ucdLib: "EZETROL 10MG CPR",
  UCD7: '9250000',
  UCD13: '3400892500003',
  ucdQtyMultiplicator: 90,
  cipLib: "EZETROL 10MG CPR BT 90",
  atcCode: "C10AX09"
}, {
  CIP7: '4900580',
  CIP13: '3400949005802',
  ucdLib: "EZETROL 10MG CPR AIP MWI UK",
  UCD7: '9355845',
  UCD13: '3400893558454',
  ucdQtyMultiplicator: 28,
  cipLib: "EZETROL 10MG CPR AIP MWI UK BT 28",
  atcCode: "C10AX09"
}, {
  CIP7: '5681097',
  CIP13: '3400956810970',
  ucdLib: "EZETROL 10MG CPR",
  UCD7: '9250000',
  UCD13: '3400892500003',
  ucdQtyMultiplicator: 50,
  cipLib: "EZETROL 10MG CPR BT 50",
  atcCode: "C10AX09"
}, {
  CIP7: '3570258',
  CIP13: '3400935702586',
  ucdLib: "OMACOR 1000MG CAPS",
  UCD7: '9238513',
  UCD13: '3400892385136',
  ucdQtyMultiplicator: 28,
  cipLib: "OMACOR 1000MG CAPS BT 28",
  atcCode: "C10AX06"
}, {
  CIP7: '3684602',
  CIP13: '3400936846029',
  ucdLib: "YSOMEGA 1G CAPS MOL",
  UCD7: '9284447',
  UCD13: '3400892844473',
  ucdQtyMultiplicator: 30,
  cipLib: "YSOMEGA 1G CAPS MOL BT 30",
  atcCode: "C10AX06"
}, {
  CIP7: '3684619',
  CIP13: '3400936846197',
  ucdLib: "YSOMEGA 1G CAPS MOL",
  UCD7: '9284447',
  UCD13: '3400892844473',
  ucdQtyMultiplicator: 60,
  cipLib: "YSOMEGA 1G CAPS MOL BT 60",
  atcCode: "C10AX06"
}, {
  CIP7: '4900485',
  CIP13: '3400949004850',
  ucdLib: "OMACOR CAPS AIP MWI UK",
  UCD7: '9345657',
  UCD13: '3400893456576',
  ucdQtyMultiplicator: 28,
  cipLib: "OMACOR CAPS AIP MWI UK BT 28",
  atcCode: "C10AX06"
}, {
  CIP7: '4900574',
  CIP13: '3400949005741',
  ucdLib: "OMACOR CAPS AIP PLA UK",
  UCD7: '9352999',
  UCD13: '3400893529997',
  ucdQtyMultiplicator: 28,
  cipLib: "OMACOR CAPS AIP PLA UK BT 28",
  atcCode: "C10AX06"
}, {
  CIP7: '4902260',
  CIP13: '3400949022601',
  ucdLib: "OMACOR CAPS AIPMWI ES",
  UCD7: '9406956',
  UCD13: '3400894069560',
  ucdQtyMultiplicator: 28,
  cipLib: "OMACOR CAPS AIPMWI ES BT 28",
  atcCode: "C10AX06"
}, {
  CIP7: '3150272',
  CIP13: '3400931502722',
  ucdLib: "QUESTRAN 4G PDR ORAL SACH",
  UCD7: '9077665',
  UCD13: '3400890776653',
  ucdQtyMultiplicator: 50,
  cipLib: "QUESTRAN 4G PDR ORAL SACH BT 50",
  atcCode: "C10AC01"
}, {
  CIP7: '3833568',
  CIP13: '3400938335682',
  ucdLib: "CIPROFIBRATE ARW 100MG GELU",
  UCD7: '9309437',
  UCD13: '3400893094372',
  ucdQtyMultiplicator: 30,
  cipLib: "CIPROFIBRATE ARW 100MG GELU BT 30",
  atcCode: "C10AB08"
}, {
  CIP7: '3269688',
  CIP13: '3400932696888',
  ucdLib: "LIPANOR 100MG GELU",
  UCD7: '9054339',
  UCD13: '3400890543392',
  ucdQtyMultiplicator: 30,
  cipLib: "LIPANOR 100MG GELU BT 30",
  atcCode: "C10AB08"
}, {
  CIP7: '3605583',
  CIP13: '3400936055834',
  ucdLib: "CIPROFIBRATE BGA 100MG GELU",
  UCD7: '9247736',
  UCD13: '3400892477367',
  ucdQtyMultiplicator: 30,
  cipLib: "CIPROFIBRATE BGA 100MG GELU BT 30",
  atcCode: "C10AB08"
}, {
  CIP7: '3674472',
  CIP13: '3400936744721',
  ucdLib: "CIPROFIBRATE ZEN 100MG GELU",
  UCD7: '9269910',
  UCD13: '3400892699103',
  ucdQtyMultiplicator: 30,
  cipLib: "CIPROFIBRATE ZEN 100MG GELU BT 30",
  atcCode: "C10AB08"
}, {
  CIP7: '3624020',
  CIP13: '3400936240209',
  ucdLib: "CIPROFIBRATE MYL 100MG GELU",
  UCD7: '9256735',
  UCD13: '3400892567358',
  ucdQtyMultiplicator: 30,
  cipLib: "CIPROFIBRATE MYL 100MG GELU BT 30",
  atcCode: "C10AB08"
}, {
  CIP7: '3784290',
  CIP13: '3400937842907',
  ucdLib: "CIPROFIBRATE BGA 100MG GELU",
  UCD7: '9247736',
  UCD13: '3400892477367',
  ucdQtyMultiplicator: 90,
  cipLib: "CIPROFIBRATE BGA 100MG GELU BT 90",
  atcCode: "C10AB08"
}, {
  CIP7: '3647794',
  CIP13: '3400936477940',
  ucdLib: "CIPROFIBRATE SDZ 100MG GELU",
  UCD7: '9262888',
  UCD13: '3400892628882',
  ucdQtyMultiplicator: 30,
  cipLib: "CIPROFIBRATE SDZ 100MG GELU BT 30",
  atcCode: "C10AB08"
}, {
  CIP7: '3614582',
  CIP13: '3400936145825',
  ucdLib: "FENOFIBRATE TVC 100MG GELU",
  UCD7: '9245016',
  UCD13: '3400892450162',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE TVC 100MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3614599',
  CIP13: '3400936145993',
  ucdLib: "FENOFIBRATE TVC 300MG GELU",
  UCD7: '9245039',
  UCD13: '3400892450391',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE TVC 300MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3839571',
  CIP13: '3400938395716',
  ucdLib: "FENOFIBRATE TVS 160MG CPR",
  UCD7: '9315308',
  UCD13: '3400893153086',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE TVS 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3839602',
  CIP13: '3400938396027',
  ucdLib: "FENOFIBRATE TVS 160MG CPR",
  UCD7: '9315308',
  UCD13: '3400893153086',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE TVS 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3326357',
  CIP13: '3400933263577',
  ucdLib: "LIPANTHYL 200 MICRO GELU",
  UCD7: '9146679',
  UCD13: '3400891466799',
  ucdQtyMultiplicator: 30,
  cipLib: "LIPANTHYL 200 MICRO GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3576019',
  CIP13: '3400935760197',
  ucdLib: "FEGENOR 140MG GELU",
  UCD7: '9248434',
  UCD13: '3400892484341',
  ucdQtyMultiplicator: 30,
  cipLib: "FEGENOR 140MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3237642',
  CIP13: '3400932376421',
  ucdLib: "SECALIP 100MG GELU",
  UCD7: '9129965',
  UCD13: '3400891299656',
  ucdQtyMultiplicator: 48,
  cipLib: "SECALIP 100MG GELU BT 48",
  atcCode: "C10AB05"
}, {
  CIP7: '3608920',
  CIP13: '3400936089204',
  ucdLib: "FENOFIBRATE BGA 300MG GELU",
  UCD7: '9249735',
  UCD13: '3400892497358',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE BGA 300MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3681897',
  CIP13: '3400936818972',
  ucdLib: "FENOFIBRATE SDZ 200MG GELU",
  UCD7: '9268922',
  UCD13: '3400892689227',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE SDZ 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3349950',
  CIP13: '3400933499501',
  ucdLib: "FENOFIBRATE MYL 100MG GELU",
  UCD7: '9201556',
  UCD13: '3400892015569',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE MYL 100MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3349973',
  CIP13: '3400933499730',
  ucdLib: "FENOFIBRATE MYL 300MG GELU",
  UCD7: '9201562',
  UCD13: '3400892015620',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE MYL 300MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3679570',
  CIP13: '3400936795709',
  ucdLib: "FENOFIBRATE SDZ 300MG GELU",
  UCD7: '9268655',
  UCD13: '3400892686554',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE SDZ 300MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3674555',
  CIP13: '3400936745551',
  ucdLib: "FENOFIBRATE ZEN 200MG GELU",
  UCD7: '9269991',
  UCD13: '3400892699912',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ZEN 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3674549',
  CIP13: '3400936745490',
  ucdLib: "FENOFIBRATE ZEN 67MG GELU",
  UCD7: '9270008',
  UCD13: '3400892700083',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE ZEN 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3352716',
  CIP13: '3400933527167',
  ucdLib: "LIPANTHYL 67 MICRO GELU",
  UCD7: '9158168',
  UCD13: '3400891581683',
  ucdQtyMultiplicator: 60,
  cipLib: "LIPANTHYL 67 MICRO GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3352722',
  CIP13: '3400933527228',
  ucdLib: "LIPANTHYL 67 MICRO GELU",
  UCD7: '9158168',
  UCD13: '3400891581683',
  ucdQtyMultiplicator: 90,
  cipLib: "LIPANTHYL 67 MICRO GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3550787',
  CIP13: '3400935507877',
  ucdLib: "FENOFIBRATE ARW 200MG GELU",
  UCD7: '9236721',
  UCD13: '3400892367217',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ARW 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3550758',
  CIP13: '3400935507587',
  ucdLib: "FENOFIBRATE ARW 67MG GELU",
  UCD7: '9236738',
  UCD13: '3400892367385',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE ARW 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3565263',
  CIP13: '3400935652638',
  ucdLib: "FENOFIBRATE BGA 100MG GELU",
  UCD7: '9231505',
  UCD13: '3400892315058',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE BGA 100MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3550876',
  CIP13: '3400935508768',
  ucdLib: "FENOFIBRATE CRT 200MG GELU",
  UCD7: '9328682',
  UCD13: '3400893286821',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE CRT 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3550830',
  CIP13: '3400935508300',
  ucdLib: "FENOFIBRATE CRT 67MG GELU",
  UCD7: '9328699',
  UCD13: '3400893286999',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE CRT 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3553745',
  CIP13: '3400935537454',
  ucdLib: "FENOFIBRATE FOR 160MG CPR",
  UCD7: '9282431',
  UCD13: '3400892824314',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE FOR 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3553739',
  CIP13: '3400935537393',
  ucdLib: "LIPANTHYL 160MG CPR",
  UCD7: '9228348',
  UCD13: '3400892283487',
  ucdQtyMultiplicator: 30,
  cipLib: "LIPANTHYL 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3534920',
  CIP13: '3400935349200',
  ucdLib: "FEGENOR 200MG GELU",
  UCD7: '9223948',
  UCD13: '3400892239484',
  ucdQtyMultiplicator: 30,
  cipLib: "FEGENOR 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3518329',
  CIP13: '3400935183293',
  ucdLib: "FENOFIBRATE MYL 67MG GELU",
  UCD7: '9215446',
  UCD13: '3400892154466',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE MYL 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3659610',
  CIP13: '3400936596108',
  ucdLib: "FENOFIBRATE SDZ 100MG GELU",
  UCD7: '9263907',
  UCD13: '3400892639079',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE SDZ 100MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3659739',
  CIP13: '3400936597396',
  ucdLib: "FENOFIBRATE SDZ 67MG GELU",
  UCD7: '9263913',
  UCD13: '3400892639130',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE SDZ 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3547733',
  CIP13: '3400935477330',
  ucdLib: "FENOFIBRATE BGA 200MG GELU",
  UCD7: '9223960',
  UCD13: '3400892239606',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE BGA 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3547727',
  CIP13: '3400935477279',
  ucdLib: "FENOFIBRATE BGA 67MG GELU",
  UCD7: '9223977',
  UCD13: '3400892239774',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE BGA 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3548626',
  CIP13: '3400935486264',
  ucdLib: "FENOFIBRATE EG 200MG GELU",
  UCD7: '9223500',
  UCD13: '3400892235004',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE EG 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3548595',
  CIP13: '3400935485953',
  ucdLib: "FENOFIBRATE EG 67MG GELU",
  UCD7: '9223517',
  UCD13: '3400892235172',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE EG 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3544048',
  CIP13: '3400935440488',
  ucdLib: "FENOFIBRATE ZYD 300MG GELU",
  UCD7: '9223210',
  UCD13: '3400892232102',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ZYD 300MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3728357',
  CIP13: '3400937283571',
  ucdLib: "FENOFIBRATE ARW 160MG CPR",
  UCD7: '9285547',
  UCD13: '3400892855479',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ARW 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3728392',
  CIP13: '3400937283922',
  ucdLib: "FENOFIBRATE ARW 160MG CPR",
  UCD7: '9285547',
  UCD13: '3400892855479',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE ARW 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3728044',
  CIP13: '3400937280440',
  ucdLib: "FENOFIBRATE BGA 160MG CPR",
  UCD7: '9285719',
  UCD13: '3400892857190',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE BGA 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3728073',
  CIP13: '3400937280730',
  ucdLib: "FENOFIBRATE BGA 160MG CPR",
  UCD7: '9285719',
  UCD13: '3400892857190',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE BGA 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3696433',
  CIP13: '3400936964334',
  ucdLib: "FENOFIBRATE FOR 145MG CPR",
  UCD7: '9342009',
  UCD13: '3400893420096',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE FOR 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3696456',
  CIP13: '3400936964563',
  ucdLib: "FENOFIBRATE FOR 145MG CPR",
  UCD7: '9342009',
  UCD13: '3400893420096',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE FOR 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3728311',
  CIP13: '3400937283113',
  ucdLib: "FENOFIBRATE RTP 160MG CPR",
  UCD7: '9285441',
  UCD13: '3400892854410',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE RTP 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3728127',
  CIP13: '3400937281270',
  ucdLib: "FENOFIBRATE SDZ 160MG CPR",
  UCD7: '9284944',
  UCD13: '3400892849447',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE SDZ 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3728162',
  CIP13: '3400937281621',
  ucdLib: "FENOFIBRATE SDZ 160MG CPR",
  UCD7: '9284944',
  UCD13: '3400892849447',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE SDZ 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3729405',
  CIP13: '3400937294058',
  ucdLib: "FENOFIBRATE SDZ 200MG GELU",
  UCD7: '9268922',
  UCD13: '3400892689227',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE SDZ 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3729411',
  CIP13: '3400937294119',
  ucdLib: "FENOFIBRATE SDZ 300MG GELU",
  UCD7: '9268655',
  UCD13: '3400892686554',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE SDZ 300MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3631994',
  CIP13: '3400936319943',
  ucdLib: "FENOFIBRATE ZYD 200MG GELU",
  UCD7: '9261156',
  UCD13: '3400892611563',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ZYD 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3631988',
  CIP13: '3400936319882',
  ucdLib: "FENOFIBRATE ZYD 67MG GELU",
  UCD7: '9261162',
  UCD13: '3400892611624',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE ZYD 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3696410',
  CIP13: '3400936964105',
  ucdLib: "LIPANTHYL 145MG CPR",
  UCD7: '9282448',
  UCD13: '3400892824482',
  ucdQtyMultiplicator: 30,
  cipLib: "LIPANTHYL 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3696427',
  CIP13: '3400936964273',
  ucdLib: "LIPANTHYL 145MG CPR",
  UCD7: '9282448',
  UCD13: '3400892824482',
  ucdQtyMultiplicator: 90,
  cipLib: "LIPANTHYL 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3717885',
  CIP13: '3400937178853',
  ucdLib: "FENOFIBRATE BGA 200MG GELU",
  UCD7: '9223960',
  UCD13: '3400892239606',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE BGA 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3471444',
  CIP13: '3400934714443',
  ucdLib: "FENOFIBRATE CRT 200MG GELU",
  UCD7: '9328682',
  UCD13: '3400893286821',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE CRT 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3717810',
  CIP13: '3400937178105',
  ucdLib: "FENOFIBRATE FOR 160MG CPR",
  UCD7: '9282431',
  UCD13: '3400892824314',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE FOR 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3643767',
  CIP13: '3400936437678',
  ucdLib: "FENOFIBRATE FOR 200MG GELU",
  UCD7: '9260895',
  UCD13: '3400892608952',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE FOR 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3714898',
  CIP13: '3400937148986',
  ucdLib: "FENOFIBRATE FOR 200MG GELU",
  UCD7: '9260895',
  UCD13: '3400892608952',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE FOR 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3643750',
  CIP13: '3400936437500',
  ucdLib: "FENOFIBRATE FOR 67MG GELU",
  UCD7: '9260903',
  UCD13: '3400892609034',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE FOR 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3714881',
  CIP13: '3400937148818',
  ucdLib: "FENOFIBRATE FOR 67MG GELU",
  UCD7: '9260903',
  UCD13: '3400892609034',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE FOR 67MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3773323',
  CIP13: '3400937733236',
  ucdLib: "FENOFIBRATE MYL 160MG CPR",
  UCD7: '9285180',
  UCD13: '3400892851808',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE MYL 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3477719',
  CIP13: '3400934777196',
  ucdLib: "FENOFIBRATE MYL 200MG GELU",
  UCD7: '9213246',
  UCD13: '3400892132464',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE MYL 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3791628',
  CIP13: '3400937916288',
  ucdLib: "FENOFIBRATE RBX 300MG GELU",
  UCD7: '9317537',
  UCD13: '3400893175378',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE RBX 300MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3791634',
  CIP13: '3400937916349',
  ucdLib: "FENOFIBRATE RBX 300MG GELU",
  UCD7: '9317537',
  UCD13: '3400893175378',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE RBX 300MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3775233',
  CIP13: '3400937752336',
  ucdLib: "FENOFIBRATE RPG 160MG CPR",
  UCD7: '9298633',
  UCD13: '3400892986333',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE RPG 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3775256',
  CIP13: '3400937752565',
  ucdLib: "FENOFIBRATE RPG 160MG CPR",
  UCD7: '9298633',
  UCD13: '3400892986333',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE RPG 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3475123',
  CIP13: '3400934751233',
  ucdLib: "FENOFIBRATE RTP 300MG GELU",
  UCD7: '9206097',
  UCD13: '3400892060972',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE RTP 300MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3780004',
  CIP13: '3400937800044',
  ucdLib: "FENOFIBRATE TVS 200MG GELU",
  UCD7: '9303357',
  UCD13: '3400893033579',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE TVS 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3780027',
  CIP13: '3400937800273',
  ucdLib: "FENOFIBRATE TVS 200MG GELU",
  UCD7: '9303357',
  UCD13: '3400893033579',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE TVS 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3779946',
  CIP13: '3400937799461',
  ucdLib: "FENOFIBRATE TVS 67MG GELU",
  UCD7: '9303363',
  UCD13: '3400893033630',
  ucdQtyMultiplicator: 60,
  cipLib: "FENOFIBRATE TVS 67MG GELU BT 60",
  atcCode: "C10AB05"
}, {
  CIP7: '3779952',
  CIP13: '3400937799522',
  ucdLib: "FENOFIBRATE TVS 67MG GELU",
  UCD7: '9303363',
  UCD13: '3400893033630',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE TVS 67MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3719720',
  CIP13: '3400937197205',
  ucdLib: "FENOFIBRATE ZYD 200MG GELU",
  UCD7: '9261156',
  UCD13: '3400892611563',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE ZYD 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3719743',
  CIP13: '3400937197434',
  ucdLib: "FENOFIBRATE ZYD 300MG GELU",
  UCD7: '9223210',
  UCD13: '3400892232102',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE ZYD 300MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3717804',
  CIP13: '3400937178044',
  ucdLib: "LIPANTHYL 160MG CPR",
  UCD7: '9228348',
  UCD13: '3400892283487',
  ucdQtyMultiplicator: 90,
  cipLib: "LIPANTHYL 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3717856',
  CIP13: '3400937178563',
  ucdLib: "LIPANTHYL 200 MICRO GELU",
  UCD7: '9146679',
  UCD13: '3400891466799',
  ucdQtyMultiplicator: 90,
  cipLib: "LIPANTHYL 200 MICRO GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3730271',
  CIP13: '3400937302715',
  ucdLib: "FEGENOR 140MG GELU",
  UCD7: '9248434',
  UCD13: '3400892484341',
  ucdQtyMultiplicator: 90,
  cipLib: "FEGENOR 140MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3734895',
  CIP13: '3400937348959',
  ucdLib: "FENOFIBRATE ALM 160MG CPR",
  UCD7: '9286736',
  UCD13: '3400892867366',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ALM 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3739740',
  CIP13: '3400937397407',
  ucdLib: "FENOFIBRATE ARW 200MG GELU",
  UCD7: '9236721',
  UCD13: '3400892367217',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE ARW 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3926749',
  CIP13: '3400939267494',
  ucdLib: "FENOFIBRATE BGA 145MG CPR",
  UCD7: '9335788',
  UCD13: '3400893357880',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE BGA 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3926778',
  CIP13: '3400939267784',
  ucdLib: "FENOFIBRATE BGA 145MG CPR",
  UCD7: '9335788',
  UCD13: '3400893357880',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE BGA 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3732577',
  CIP13: '3400937325776',
  ucdLib: "FENOFIBRATE CRT 160MG CPR",
  UCD7: '9286713',
  UCD13: '3400892867137',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE CRT 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3734748',
  CIP13: '3400937347488',
  ucdLib: "FENOFIBRATE CRT 160MG CPR",
  UCD7: '9286713',
  UCD13: '3400892867137',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE CRT 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3926815',
  CIP13: '3400939268156',
  ucdLib: "FENOFIBRATE EG 145MG CPR",
  UCD7: '9335771',
  UCD13: '3400893357712',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE EG 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3926844',
  CIP13: '3400939268446',
  ucdLib: "FENOFIBRATE EG 145MG CPR",
  UCD7: '9335771',
  UCD13: '3400893357712',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE EG 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3735682',
  CIP13: '3400937356824',
  ucdLib: "FENOFIBRATE EG 160MG CPR",
  UCD7: '9285725',
  UCD13: '3400892857251',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE EG 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3868992',
  CIP13: '3400938689921',
  ucdLib: "FENOFIBRATE EG 160MG CPR",
  UCD7: '9285725',
  UCD13: '3400892857251',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE EG 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3739071',
  CIP13: '3400937390712',
  ucdLib: "FENOFIBRATE EG 200MG GELU",
  UCD7: '9223500',
  UCD13: '3400892235004',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE EG 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3926904',
  CIP13: '3400939269047',
  ucdLib: "FENOFIBRATE MYL 145MG CPR",
  UCD7: '9335794',
  UCD13: '3400893357941',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE MYL 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3926933',
  CIP13: '3400939269337',
  ucdLib: "FENOFIBRATE MYL 145MG CPR",
  UCD7: '9335794',
  UCD13: '3400893357941',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE MYL 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3735653',
  CIP13: '3400937356534',
  ucdLib: "FENOFIBRATE MYL 160MG CPR",
  UCD7: '9285180',
  UCD13: '3400892851808',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE MYL 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3738396',
  CIP13: '3400937383967',
  ucdLib: "FENOFIBRATE MYL 200MG GELU",
  UCD7: '9213246',
  UCD13: '3400892132464',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE MYL 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3738278',
  CIP13: '3400937382786',
  ucdLib: "FENOFIBRATE MYL 300MG GELU",
  UCD7: '9201562',
  UCD13: '3400892015620',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE MYL 300MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3926301',
  CIP13: '3400939263014',
  ucdLib: "FENOFIBRATE RTP 145MG CPR",
  UCD7: '9335593',
  UCD13: '3400893355930',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE RTP 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3926330',
  CIP13: '3400939263304',
  ucdLib: "FENOFIBRATE RTP 145MG CPR",
  UCD7: '9335593',
  UCD13: '3400893355930',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE RTP 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3926666',
  CIP13: '3400939266664',
  ucdLib: "FENOFIBRATE SDZ 145MG CPR",
  UCD7: '9335601',
  UCD13: '3400893356012',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE SDZ 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3926695',
  CIP13: '3400939266954',
  ucdLib: "FENOFIBRATE SDZ 145MG CPR",
  UCD7: '9335601',
  UCD13: '3400893356012',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE SDZ 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3926399',
  CIP13: '3400939263991',
  ucdLib: "FENOFIBRATE ZEN 145MG CPR",
  UCD7: '9335570',
  UCD13: '3400893355701',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ZEN 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3926436',
  CIP13: '3400939264363',
  ucdLib: "FENOFIBRATE ZEN 145MG CPR",
  UCD7: '9335570',
  UCD13: '3400893355701',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE ZEN 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3734599',
  CIP13: '3400937345996',
  ucdLib: "FENOFIBRATE ZEN 160MG CPR",
  UCD7: '9286765',
  UCD13: '3400892867656',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ZEN 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3734636',
  CIP13: '3400937346368',
  ucdLib: "FENOFIBRATE ZEN 160MG CPR",
  UCD7: '9286765',
  UCD13: '3400892867656',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE ZEN 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3734814',
  CIP13: '3400937348140',
  ucdLib: "FENOFIBRATE ZYD 160MG CPR",
  UCD7: '9286771',
  UCD13: '3400892867717',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ZYD 160MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3734843',
  CIP13: '3400937348430',
  ucdLib: "FENOFIBRATE ZYD 160MG CPR",
  UCD7: '9286771',
  UCD13: '3400892867717',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE ZYD 160MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3907338',
  CIP13: '3400939073385',
  ucdLib: "FENOFIBRATE RBX 200MG GELU",
  UCD7: '9326683',
  UCD13: '3400893266830',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE RBX 200MG GELU BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '3907344',
  CIP13: '3400939073446',
  ucdLib: "FENOFIBRATE RBX 200MG GELU",
  UCD7: '9326683',
  UCD13: '3400893266830',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE RBX 200MG GELU BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '4182340',
  CIP13: '3400941823404',
  ucdLib: "FENOFIBRATE ZYD 145MG CPR",
  UCD7: '9378852',
  UCD13: '3400893788523',
  ucdQtyMultiplicator: 30,
  cipLib: "FENOFIBRATE ZYD 145MG CPR BT 30",
  atcCode: "C10AB05"
}, {
  CIP7: '4182386',
  CIP13: '3400941823862',
  ucdLib: "FENOFIBRATE ZYD 145MG CPR",
  UCD7: '9378852',
  UCD13: '3400893788523',
  ucdQtyMultiplicator: 90,
  cipLib: "FENOFIBRATE ZYD 145MG CPR BT 90",
  atcCode: "C10AB05"
}, {
  CIP7: '3260635',
  CIP13: '3400932606351',
  ucdLib: "LIPUR 450MG CPR",
  UCD7: '9054457',
  UCD13: '3400890544573',
  ucdQtyMultiplicator: 60,
  cipLib: "LIPUR 450MG CPR BT 60",
  atcCode: "C10AB04"
}, {
  CIP7: '3293149',
  CIP13: '3400932931491',
  ucdLib: "BEFIZAL LP 400MG CPR",
  UCD7: '9119984',
  UCD13: '3400891199840',
  ucdQtyMultiplicator: 30,
  cipLib: "BEFIZAL LP 400MG CPR BT 30",
  atcCode: "C10AB02"
}, {
  CIP7: '3262172',
  CIP13: '3400932621729',
  ucdLib: "BEFIZAL 200MG CPR",
  UCD7: '9009899',
  UCD13: '3400890098991',
  ucdQtyMultiplicator: 84,
  cipLib: "BEFIZAL 200MG CPR BT 84",
  atcCode: "C10AB02"
}, {
  CIP7: '3717738',
  CIP13: '3400937177382',
  ucdLib: "BEFIZAL LP 400MG CPR",
  UCD7: '9119984',
  UCD13: '3400891199840',
  ucdQtyMultiplicator: 90,
  cipLib: "BEFIZAL LP 400MG CPR BT 90",
  atcCode: "C10AB02"
}, {
  CIP7: '2761051',
  CIP13: '3400927610516',
  ucdLib: "CRESTOR 10MG CPR",
  UCD7: '9249592',
  UCD13: '3400892495927',
  ucdQtyMultiplicator: 60,
  cipLib: "CRESTOR 10MG CPR BT 60",
  atcCode: "C10AA07"
}, {
  CIP7: '2761068',
  CIP13: '3400927610684',
  ucdLib: "CRESTOR 20MG CPR",
  UCD7: '9249600',
  UCD13: '3400892496009',
  ucdQtyMultiplicator: 60,
  cipLib: "CRESTOR 20MG CPR BT 60",
  atcCode: "C10AA07"
}, {
  CIP7: '2761045',
  CIP13: '3400927610455',
  ucdLib: "CRESTOR 5MG CPR",
  UCD7: '9280461',
  UCD13: '3400892804613',
  ucdQtyMultiplicator: 60,
  cipLib: "CRESTOR 5MG CPR BT 60",
  atcCode: "C10AA07"
}, {
  CIP7: '3698538',
  CIP13: '3400936985384',
  ucdLib: "CRESTOR 5MG CPR",
  UCD7: '9280461',
  UCD13: '3400892804613',
  ucdQtyMultiplicator: 30,
  cipLib: "CRESTOR 5MG CPR BT 30",
  atcCode: "C10AA07"
}, {
  CIP7: '3916946',
  CIP13: '3400939169460',
  ucdLib: "CRESTOR 10MG CPR",
  UCD7: '9249592',
  UCD13: '3400892495927',
  ucdQtyMultiplicator: 30,
  cipLib: "CRESTOR 10MG CPR BT 30",
  atcCode: "C10AA07"
}, {
  CIP7: '3916969',
  CIP13: '3400939169699',
  ucdLib: "CRESTOR 10MG CPR",
  UCD7: '9249592',
  UCD13: '3400892495927',
  ucdQtyMultiplicator: 90,
  cipLib: "CRESTOR 10MG CPR BT 90",
  atcCode: "C10AA07"
}, {
  CIP7: '3916975',
  CIP13: '3400939169750',
  ucdLib: "CRESTOR 20MG CPR",
  UCD7: '9249600',
  UCD13: '3400892496009',
  ucdQtyMultiplicator: 30,
  cipLib: "CRESTOR 20MG CPR BT 30",
  atcCode: "C10AA07"
}, {
  CIP7: '3916998',
  CIP13: '3400939169989',
  ucdLib: "CRESTOR 20MG CPR",
  UCD7: '9249600',
  UCD13: '3400892496009',
  ucdQtyMultiplicator: 90,
  cipLib: "CRESTOR 20MG CPR BT 90",
  atcCode: "C10AA07"
}, {
  CIP7: '3916900',
  CIP13: '3400939169002',
  ucdLib: "CRESTOR 5MG CPR",
  UCD7: '9280461',
  UCD13: '3400892804613',
  ucdQtyMultiplicator: 90,
  cipLib: "CRESTOR 5MG CPR BT 90",
  atcCode: "C10AA07"
}, {
  CIP7: '3003526',
  CIP13: '3400930035269',
  ucdLib: "ATORVASTATINE ARG 10MG CPR",
  UCD7: '9414105',
  UCD13: '3400894141051',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ARG 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '3003529',
  CIP13: '3400930035290',
  ucdLib: "ATORVASTATINE ARG 10MG CPR",
  UCD7: '9414105',
  UCD13: '3400894141051',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARG 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3003540',
  CIP13: '3400930035405',
  ucdLib: "ATORVASTATINE ARG 20MG CPR",
  UCD7: '9414111',
  UCD13: '3400894141112',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARG 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3003547',
  CIP13: '3400930035474',
  ucdLib: "ATORVASTATINE ARG 40MG CPR",
  UCD7: '9414128',
  UCD13: '3400894141280',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ARG 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '3003550',
  CIP13: '3400930035504',
  ucdLib: "ATORVASTATINE ARG 40MG CPR",
  UCD7: '9414128',
  UCD13: '3400894141280',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARG 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3003555',
  CIP13: '3400930035559',
  ucdLib: "ATORVASTATINE ARG 80MG CPR",
  UCD7: '9414134',
  UCD13: '3400894141341',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ARG 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '3003558',
  CIP13: '3400930035580',
  ucdLib: "ATORVASTATINE ARG 80MG CPR",
  UCD7: '9414134',
  UCD13: '3400894141341',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARG 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3001982',
  CIP13: '3400930019825',
  ucdLib: "ATORVASTATINE BGR 10MG CPR",
  UCD7: '9381699',
  UCD13: '3400893816998',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE BGR 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3001983',
  CIP13: '3400930019832',
  ucdLib: "ATORVASTATINE BGR 20MG CPR",
  UCD7: '9381707',
  UCD13: '3400893817070',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE BGR 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3001984',
  CIP13: '3400930019849',
  ucdLib: "ATORVASTATINE BGR 40MG CPR",
  UCD7: '9381713',
  UCD13: '3400893817131',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE BGR 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3004271',
  CIP13: '3400930042717',
  ucdLib: "ATORVASTATINE PFZ 10MG CPR",
  UCD7: '9417339',
  UCD13: '3400894173397',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE PFZ 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3004272',
  CIP13: '3400930042724',
  ucdLib: "ATORVASTATINE PFZ 20MG CPR",
  UCD7: '9417345',
  UCD13: '3400894173458',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE PFZ 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3004273',
  CIP13: '3400930042731',
  ucdLib: "ATORVASTATINE PFZ 40MG CPR",
  UCD7: '9417351',
  UCD13: '3400894173519',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE PFZ 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3004274',
  CIP13: '3400930042748',
  ucdLib: "ATORVASTATINE PFZ 80MG CPR",
  UCD7: '9417368',
  UCD13: '3400894173687',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE PFZ 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3430675',
  CIP13: '3400934306754',
  ucdLib: "TAHOR 10MG CPR",
  UCD7: '9189973',
  UCD13: '3400891899733',
  ucdQtyMultiplicator: 28,
  cipLib: "TAHOR 10MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '3430681',
  CIP13: '3400934306815',
  ucdLib: "TAHOR 20MG CPR",
  UCD7: '9226237',
  UCD13: '3400892262376',
  ucdQtyMultiplicator: 28,
  cipLib: "TAHOR 20MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '3430698',
  CIP13: '3400934306983',
  ucdLib: "TAHOR 40MG CPR",
  UCD7: '9189996',
  UCD13: '3400891899962',
  ucdQtyMultiplicator: 28,
  cipLib: "TAHOR 40MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '3555750',
  CIP13: '3400935557506',
  ucdLib: "TAHOR 80MG CPR",
  UCD7: '9233160',
  UCD13: '3400892331607',
  ucdQtyMultiplicator: 28,
  cipLib: "TAHOR 80MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '3555767',
  CIP13: '3400935557674',
  ucdLib: "TAHOR 80MG CPR",
  UCD7: '9233160',
  UCD13: '3400892331607',
  ucdQtyMultiplicator: 50,
  cipLib: "TAHOR 80MG CPR BT 50",
  atcCode: "C10AA05"
}, {
  CIP7: '5603022',
  CIP13: '3400956030224',
  ucdLib: "TAHOR 10MG CPR",
  UCD7: '9189973',
  UCD13: '3400891899733',
  ucdQtyMultiplicator: 50,
  cipLib: "TAHOR 10MG CPR BT 50",
  atcCode: "C10AA05"
}, {
  CIP7: '5603045',
  CIP13: '3400956030453',
  ucdLib: "TAHOR 20MG CPR",
  UCD7: '9226237',
  UCD13: '3400892262376',
  ucdQtyMultiplicator: 50,
  cipLib: "TAHOR 20MG CPR BT 50",
  atcCode: "C10AA05"
}, {
  CIP7: '5603068',
  CIP13: '3400956030682',
  ucdLib: "TAHOR 40MG CPR",
  UCD7: '9189996',
  UCD13: '3400891899962',
  ucdQtyMultiplicator: 50,
  cipLib: "TAHOR 40MG CPR BT 50",
  atcCode: "C10AA05"
}, {
  CIP7: '3719921',
  CIP13: '3400937199216',
  ucdLib: "TAHOR 10MG CPR",
  UCD7: '9189973',
  UCD13: '3400891899733',
  ucdQtyMultiplicator: 90,
  cipLib: "TAHOR 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3719938',
  CIP13: '3400937199384',
  ucdLib: "TAHOR 20MG CPR",
  UCD7: '9226237',
  UCD13: '3400892262376',
  ucdQtyMultiplicator: 90,
  cipLib: "TAHOR 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3719944',
  CIP13: '3400937199445',
  ucdLib: "TAHOR 40MG CPR",
  UCD7: '9189996',
  UCD13: '3400891899962',
  ucdQtyMultiplicator: 90,
  cipLib: "TAHOR 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3719950',
  CIP13: '3400937199506',
  ucdLib: "TAHOR 80MG CPR",
  UCD7: '9233160',
  UCD13: '3400892331607',
  ucdQtyMultiplicator: 90,
  cipLib: "TAHOR 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2218358',
  CIP13: '3400922183589',
  ucdLib: "ATORVASTATINE ALM 10MG CPR",
  UCD7: '9373837',
  UCD13: '3400893738375',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ALM 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2218364',
  CIP13: '3400922183640',
  ucdLib: "ATORVASTATINE ALM 20MG CPR",
  UCD7: '9373843',
  UCD13: '3400893738436',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ALM 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2218370',
  CIP13: '3400922183701',
  ucdLib: "ATORVASTATINE ALM 40MG CPR",
  UCD7: '9373866',
  UCD13: '3400893738665',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ALM 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2218387',
  CIP13: '3400922183879',
  ucdLib: "ATORVASTATINE ALM 80MG CPR",
  UCD7: '9373872',
  UCD13: '3400893738726',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ALM 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2211971',
  CIP13: '3400922119717',
  ucdLib: "ATORVASTATINE ARL 10MG CPR",
  UCD7: '9374759',
  UCD13: '3400893747599',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARL 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2211988',
  CIP13: '3400922119885',
  ucdLib: "ATORVASTATINE ARL 20MG CPR",
  UCD7: '9374765',
  UCD13: '3400893747650',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARL 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2211994',
  CIP13: '3400922119946',
  ucdLib: "ATORVASTATINE ARL 40MG CPR",
  UCD7: '9374771',
  UCD13: '3400893747711',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARL 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2213533',
  CIP13: '3400922135335',
  ucdLib: "ATORVASTATINE ARW 20MG CPR",
  UCD7: '9382440',
  UCD13: '3400893824405',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ARW 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2213579',
  CIP13: '3400922135793',
  ucdLib: "ATORVASTATINE ARW 20MG CPR",
  UCD7: '9382440',
  UCD13: '3400893824405',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARW 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2213705',
  CIP13: '3400922137056',
  ucdLib: "ATORVASTATINE ARW 40MG CPR",
  UCD7: '9382463',
  UCD13: '3400893824634',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARW 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2214567',
  CIP13: '3400922145679',
  ucdLib: "ATORVASTATINE ARW 80MG CPR",
  UCD7: '9382457',
  UCD13: '3400893824573',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARW 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2219056',
  CIP13: '3400922190563',
  ucdLib: "ATORVASTATINE ZYF 10MG CPR",
  UCD7: '9373932',
  UCD13: '3400893739327',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ZYF 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2219062',
  CIP13: '3400922190624',
  ucdLib: "ATORVASTATINE ZYF 20MG CPR",
  UCD7: '9373949',
  UCD13: '3400893739495',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ZYF 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2219085',
  CIP13: '3400922190853',
  ucdLib: "ATORVASTATINE ZYF 40MG CPR",
  UCD7: '9373955',
  UCD13: '3400893739556',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ZYF 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2219122',
  CIP13: '3400922191225',
  ucdLib: "ATORVASTATINE ZYF 80MG CPR",
  UCD7: '9373961',
  UCD13: '3400893739617',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ZYF 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4939719',
  CIP13: '3400949397198',
  ucdLib: "ATORVASTATINE ALM 10MG CPR",
  UCD7: '9373837',
  UCD13: '3400893738375',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ALM 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4939748',
  CIP13: '3400949397488',
  ucdLib: "ATORVASTATINE ALM 20MG CPR",
  UCD7: '9373843',
  UCD13: '3400893738436',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ALM 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4939777',
  CIP13: '3400949397778',
  ucdLib: "ATORVASTATINE ALM 40MG CPR",
  UCD7: '9373866',
  UCD13: '3400893738665',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ALM 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4939814',
  CIP13: '3400949398140',
  ucdLib: "ATORVASTATINE ALM 80MG CPR",
  UCD7: '9373872',
  UCD13: '3400893738726',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ALM 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4173890',
  CIP13: '3400941738906',
  ucdLib: "ATORVASTATINE ALT 10MG CPR",
  UCD7: '9374788',
  UCD13: '3400893747889',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE ALT 10MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4173944',
  CIP13: '3400941739446',
  ucdLib: "ATORVASTATINE ALT 10MG CPR",
  UCD7: '9374788',
  UCD13: '3400893747889',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ALT 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4174412',
  CIP13: '3400941744129',
  ucdLib: "ATORVASTATINE ALT 20MG CPR",
  UCD7: '9374794',
  UCD13: '3400893747940',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE ALT 20MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4174464',
  CIP13: '3400941744648',
  ucdLib: "ATORVASTATINE ALT 20MG CPR",
  UCD7: '9374794',
  UCD13: '3400893747940',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ALT 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4173016',
  CIP13: '3400941730160',
  ucdLib: "ATORVASTATINE ALT 40MG CPR",
  UCD7: '9374802',
  UCD13: '3400893748022',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE ALT 40MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4173660',
  CIP13: '3400941736605',
  ucdLib: "ATORVASTATINE ARL 10MG CPR",
  UCD7: '9374759',
  UCD13: '3400893747599',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ARL 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4173714',
  CIP13: '3400941737145',
  ucdLib: "ATORVASTATINE ARL 10MG CPR",
  UCD7: '9374759',
  UCD13: '3400893747599',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARL 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4174205',
  CIP13: '3400941742057',
  ucdLib: "ATORVASTATINE ARL 20MG CPR",
  UCD7: '9374765',
  UCD13: '3400893747650',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ARL 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4174240',
  CIP13: '3400941742408',
  ucdLib: "ATORVASTATINE ARL 20MG CPR",
  UCD7: '9374765',
  UCD13: '3400893747650',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARL 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4172815',
  CIP13: '3400941728150',
  ucdLib: "ATORVASTATINE ARL 40MG CPR",
  UCD7: '9374771',
  UCD13: '3400893747711',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ARL 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4172850',
  CIP13: '3400941728501',
  ucdLib: "ATORVASTATINE ARL 40MG CPR",
  UCD7: '9374771',
  UCD13: '3400893747711',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ARL 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2699814',
  CIP13: '3400926998141',
  ucdLib: "ATORVASTATINE CRT 80MG CPR",
  UCD7: '9393030',
  UCD13: '3400893930304',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE CRT 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2699866',
  CIP13: '3400926998660',
  ucdLib: "ATORVASTATINE CRT 80MG CPR",
  UCD7: '9393030',
  UCD13: '3400893930304',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE CRT 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4198795',
  CIP13: '3400941987953',
  ucdLib: "ATORVASTATINE EG 10MG CPR",
  UCD7: '9381624',
  UCD13: '3400893816240',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE EG 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4198803',
  CIP13: '3400941988035',
  ucdLib: "ATORVASTATINE EG 10MG CPR",
  UCD7: '9381624',
  UCD13: '3400893816240',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE EG 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4198826',
  CIP13: '3400941988264',
  ucdLib: "ATORVASTATINE EG 20MG CPR",
  UCD7: '9381630',
  UCD13: '3400893816301',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE EG 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4198832',
  CIP13: '3400941988325',
  ucdLib: "ATORVASTATINE EG 20MG CPR",
  UCD7: '9381630',
  UCD13: '3400893816301',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE EG 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4198849',
  CIP13: '3400941988493',
  ucdLib: "ATORVASTATINE EG 40MG CPR",
  UCD7: '9381647',
  UCD13: '3400893816479',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE EG 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4198855',
  CIP13: '3400941988554',
  ucdLib: "ATORVASTATINE EG 40MG CPR",
  UCD7: '9381647',
  UCD13: '3400893816479',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE EG 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4198861',
  CIP13: '3400941988615',
  ucdLib: "ATORVASTATINE EG 80MG CPR",
  UCD7: '9381653',
  UCD13: '3400893816530',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE EG 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4198878',
  CIP13: '3400941988783',
  ucdLib: "ATORVASTATINE EG 80MG CPR",
  UCD7: '9381653',
  UCD13: '3400893816530',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE EG 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4173217',
  CIP13: '3400941732171',
  ucdLib: "ATORVASTATINE EVO 10MG CPR",
  UCD7: '9374848',
  UCD13: '3400893748480',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE EVO 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4173269',
  CIP13: '3400941732690',
  ucdLib: "ATORVASTATINE EVO 10MG CPR",
  UCD7: '9374848',
  UCD13: '3400893748480',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE EVO 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4174636',
  CIP13: '3400941746369',
  ucdLib: "ATORVASTATINE EVO 20MG CPR",
  UCD7: '9374854',
  UCD13: '3400893748541',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE EVO 20MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4174688',
  CIP13: '3400941746888',
  ucdLib: "ATORVASTATINE EVO 20MG CPR",
  UCD7: '9374854',
  UCD13: '3400893748541',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE EVO 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4172407',
  CIP13: '3400941724077',
  ucdLib: "ATORVASTATINE EVO 40MG CPR",
  UCD7: '9374860',
  UCD13: '3400893748602',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE EVO 40MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4172465',
  CIP13: '3400941724657',
  ucdLib: "ATORVASTATINE EVO 40MG CPR",
  UCD7: '9374860',
  UCD13: '3400893748602',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE EVO 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2663325',
  CIP13: '3400926633257',
  ucdLib: "ATORVASTATINE KRK 10MG CPR",
  UCD7: '9388804',
  UCD13: '3400893888049',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE KRK 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2663360',
  CIP13: '3400926633608',
  ucdLib: "ATORVASTATINE KRK 10MG CPR",
  UCD7: '9388804',
  UCD13: '3400893888049',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE KRK 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2663437',
  CIP13: '3400926634377',
  ucdLib: "ATORVASTATINE KRK 20MG CPR",
  UCD7: '9388810',
  UCD13: '3400893888100',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE KRK 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2663489',
  CIP13: '3400926634896',
  ucdLib: "ATORVASTATINE KRK 20MG CPR",
  UCD7: '9388810',
  UCD13: '3400893888100',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE KRK 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2663555',
  CIP13: '3400926635558',
  ucdLib: "ATORVASTATINE KRK 40MG CPR",
  UCD7: '9388827',
  UCD13: '3400893888278',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE KRK 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2663590',
  CIP13: '3400926635909',
  ucdLib: "ATORVASTATINE KRK 40MG CPR",
  UCD7: '9388827',
  UCD13: '3400893888278',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE KRK 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4194840',
  CIP13: '3400941948404',
  ucdLib: "ATORVASTATINE KRK 80MG CPR",
  UCD7: '9386751',
  UCD13: '3400893867518',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE KRK 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4194900',
  CIP13: '3400941949005',
  ucdLib: "ATORVASTATINE KRK 80MG CPR",
  UCD7: '9386751',
  UCD13: '3400893867518',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE KRK 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2758445',
  CIP13: '3400927584459',
  ucdLib: "ATORVASTATINE MYL 10MG CPR",
  UCD7: '9374877',
  UCD13: '3400893748770',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE MYL 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2758451',
  CIP13: '3400927584510',
  ucdLib: "ATORVASTATINE MYL 10MG CPR",
  UCD7: '9374877',
  UCD13: '3400893748770',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE MYL 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2758474',
  CIP13: '3400927584749',
  ucdLib: "ATORVASTATINE MYL 20MG CPR",
  UCD7: '9374883',
  UCD13: '3400893748831',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE MYL 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2758480',
  CIP13: '3400927584800',
  ucdLib: "ATORVASTATINE MYL 20MG CPR",
  UCD7: '9374883',
  UCD13: '3400893748831',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE MYL 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2758505',
  CIP13: '3400927585050',
  ucdLib: "ATORVASTATINE MYL 40MG CPR",
  UCD7: '9374908',
  UCD13: '3400893749081',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE MYL 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2758511',
  CIP13: '3400927585111',
  ucdLib: "ATORVASTATINE MYL 40MG CPR",
  UCD7: '9374908',
  UCD13: '3400893749081',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE MYL 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2758534',
  CIP13: '3400927585340',
  ucdLib: "ATORVASTATINE MYL 80MG CPR",
  UCD7: '9374914',
  UCD13: '3400893749142',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE MYL 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2758540',
  CIP13: '3400927585401',
  ucdLib: "ATORVASTATINE MYL 80MG CPR",
  UCD7: '9374914',
  UCD13: '3400893749142',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE MYL 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4995741',
  CIP13: '3400949957415',
  ucdLib: "ATORVASTATINE PHR 10MG CPR",
  UCD7: '9369497',
  UCD13: '3400893694978',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE PHR 10MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4995787',
  CIP13: '3400949957873',
  ucdLib: "ATORVASTATINE PHR 10MG CPR",
  UCD7: '9369497',
  UCD13: '3400893694978',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE PHR 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4995793',
  CIP13: '3400949957934',
  ucdLib: "ATORVASTATINE PHR 20MG CPR",
  UCD7: '9369505',
  UCD13: '3400893695050',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE PHR 20MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4995830',
  CIP13: '3400949958306',
  ucdLib: "ATORVASTATINE PHR 20MG CPR",
  UCD7: '9369505',
  UCD13: '3400893695050',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE PHR 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4995847',
  CIP13: '3400949958474',
  ucdLib: "ATORVASTATINE PHR 40MG CPR",
  UCD7: '9369511',
  UCD13: '3400893695111',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE PHR 40MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4995907',
  CIP13: '3400949959075',
  ucdLib: "ATORVASTATINE PHR 80MG CPR",
  UCD7: '9369528',
  UCD13: '3400893695289',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE PHR 80MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '2697235',
  CIP13: '3400926972356',
  ucdLib: "ATORVASTATINE RBX 10MG CPR",
  UCD7: '9405253',
  UCD13: '3400894052531',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE RBX 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2697287',
  CIP13: '3400926972875',
  ucdLib: "ATORVASTATINE RBX 10MG CPR",
  UCD7: '9405253',
  UCD13: '3400894052531',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE RBX 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2697347',
  CIP13: '3400926973476',
  ucdLib: "ATORVASTATINE RBX 20MG CPR",
  UCD7: '9405276',
  UCD13: '3400894052760',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE RBX 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2697407',
  CIP13: '3400926974077',
  ucdLib: "ATORVASTATINE RBX 20MG CPR",
  UCD7: '9405276',
  UCD13: '3400894052760',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE RBX 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2697465',
  CIP13: '3400926974657',
  ucdLib: "ATORVASTATINE RBX 40MG CPR",
  UCD7: '9405282',
  UCD13: '3400894052821',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE RBX 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2697519',
  CIP13: '3400926975197',
  ucdLib: "ATORVASTATINE RBX 40MG CPR",
  UCD7: '9405282',
  UCD13: '3400894052821',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE RBX 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2697560',
  CIP13: '3400926975609',
  ucdLib: "ATORVASTATINE RBX 80MG CPR",
  UCD7: '9405299',
  UCD13: '3400894052999',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE RBX 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4153054',
  CIP13: '3400941530548',
  ucdLib: "ATORVASTATINE SDZ 10MG CPR",
  UCD7: '9369385',
  UCD13: '3400893693858',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE SDZ 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4153077',
  CIP13: '3400941530777',
  ucdLib: "ATORVASTATINE SDZ 10MG CPR",
  UCD7: '9369385',
  UCD13: '3400893693858',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE SDZ 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4153166',
  CIP13: '3400941531668',
  ucdLib: "ATORVASTATINE SDZ 20MG CPR",
  UCD7: '9369391',
  UCD13: '3400893693919',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE SDZ 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4153189',
  CIP13: '3400941531897',
  ucdLib: "ATORVASTATINE SDZ 20MG CPR",
  UCD7: '9369391',
  UCD13: '3400893693919',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE SDZ 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4153261',
  CIP13: '3400941532610',
  ucdLib: "ATORVASTATINE SDZ 40MG CPR",
  UCD7: '9369416',
  UCD13: '3400893694169',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE SDZ 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4153284',
  CIP13: '3400941532849',
  ucdLib: "ATORVASTATINE SDZ 40MG CPR",
  UCD7: '9369416',
  UCD13: '3400893694169',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE SDZ 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4938973',
  CIP13: '3400949389735',
  ucdLib: "ATORVASTATINE SDZ 80MG CPR",
  UCD7: '9369563',
  UCD13: '3400893695630',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE SDZ 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4939091',
  CIP13: '3400949390915',
  ucdLib: "ATORVASTATINE SDZ 80MG CPR",
  UCD7: '9369563',
  UCD13: '3400893695630',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE SDZ 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4944092',
  CIP13: '3400949440924',
  ucdLib: "ATORVASTATINE TVS 10MG CPR",
  UCD7: '9366257',
  UCD13: '3400893662571',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE TVS 10MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4944169',
  CIP13: '3400949441693',
  ucdLib: "ATORVASTATINE TVS 10MG CPR",
  UCD7: '9366257',
  UCD13: '3400893662571',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE TVS 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4944258',
  CIP13: '3400949442584',
  ucdLib: "ATORVASTATINE TVS 20MG CPR",
  UCD7: '9366263',
  UCD13: '3400893662632',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE TVS 20MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4944324',
  CIP13: '3400949443246',
  ucdLib: "ATORVASTATINE TVS 20MG CPR",
  UCD7: '9366263',
  UCD13: '3400893662632',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE TVS 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4944413',
  CIP13: '3400949444137',
  ucdLib: "ATORVASTATINE TVS 40MG CPR",
  UCD7: '9366286',
  UCD13: '3400893662861',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE TVS 40MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4944494',
  CIP13: '3400949444946',
  ucdLib: "ATORVASTATINE TVS 40MG CPR",
  UCD7: '9366286',
  UCD13: '3400893662861',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE TVS 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4944560',
  CIP13: '3400949445608',
  ucdLib: "ATORVASTATINE TVS 80MG CPR",
  UCD7: '9366292',
  UCD13: '3400893662922',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE TVS 80MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4944643',
  CIP13: '3400949446438',
  ucdLib: "ATORVASTATINE TVS 80MG CPR",
  UCD7: '9366292',
  UCD13: '3400893662922',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE TVS 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4179763',
  CIP13: '3400941797637',
  ucdLib: "ATORVASTATINE ZTL 10MG CPR",
  UCD7: '9374972',
  UCD13: '3400893749722',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ZTL 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4179792',
  CIP13: '3400941797927',
  ucdLib: "ATORVASTATINE ZTL 10MG CPR",
  UCD7: '9374972',
  UCD13: '3400893749722',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ZTL 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4179881',
  CIP13: '3400941798818',
  ucdLib: "ATORVASTATINE ZTL 20MG CPR",
  UCD7: '9374989',
  UCD13: '3400893749890',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ZTL 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4179906',
  CIP13: '3400941799068',
  ucdLib: "ATORVASTATINE ZTL 20MG CPR",
  UCD7: '9374989',
  UCD13: '3400893749890',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ZTL 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4179987',
  CIP13: '3400941799877',
  ucdLib: "ATORVASTATINE ZTL 40MG CPR",
  UCD7: '9374995',
  UCD13: '3400893749951',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ZTL 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4939470',
  CIP13: '3400949394708',
  ucdLib: "ATORVASTATINE ZYF 10MG CPR",
  UCD7: '9373932',
  UCD13: '3400893739327',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ZYF 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4939501',
  CIP13: '3400949395019',
  ucdLib: "ATORVASTATINE ZYF 20MG CPR",
  UCD7: '9373949',
  UCD13: '3400893739495',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ZYF 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4939530',
  CIP13: '3400949395309',
  ucdLib: "ATORVASTATINE ZYF 40MG CPR",
  UCD7: '9373955',
  UCD13: '3400893739556',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ZYF 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4939576',
  CIP13: '3400949395767',
  ucdLib: "ATORVASTATINE ZYF 80MG CPR",
  UCD7: '9373961',
  UCD13: '3400893739617',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ZYF 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4900036',
  CIP13: '3400949000364',
  ucdLib: "TAHOR 10MG CPR AIP BBA ES",
  UCD7: '9416587',
  UCD13: '3400894165873',
  ucdQtyMultiplicator: 28,
  cipLib: "TAHOR 10MG CPR AIP BBA ES BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4902113',
  CIP13: '3400949021130',
  ucdLib: "TAHOR 10MG CPR AIP MWI ES",
  UCD7: '9399162',
  UCD13: '3400893991626',
  ucdQtyMultiplicator: 28,
  cipLib: "TAHOR 10MG CPR AIP MWI ES BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4900076',
  CIP13: '3400949000760',
  ucdLib: "TAHOR 10MG CPR AIP MWI IT",
  UCD7: '9419031',
  UCD13: '3400894190318',
  ucdQtyMultiplicator: 90,
  cipLib: "TAHOR 10MG CPR AIP MWI IT BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4945878',
  CIP13: '3400949458783',
  ucdLib: "TAHOR 10MG CPR CROQ",
  UCD7: '9380010',
  UCD13: '3400893800102',
  ucdQtyMultiplicator: 30,
  cipLib: "TAHOR 10MG CPR CROQ BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4945884',
  CIP13: '3400949458844',
  ucdLib: "TAHOR 20MG CPR CROQ",
  UCD7: '9380027',
  UCD13: '3400893800270',
  ucdQtyMultiplicator: 30,
  cipLib: "TAHOR 20MG CPR CROQ BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2185825',
  CIP13: '3400921858259',
  ucdLib: "ATORVASTATINE ACC 10MG CPR",
  UCD7: '9409564',
  UCD13: '3400894095644',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ACC 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2185877',
  CIP13: '3400921858778',
  ucdLib: "ATORVASTATINE ACC 20MG CPR",
  UCD7: '9409570',
  UCD13: '3400894095705',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ACC 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2185937',
  CIP13: '3400921859379',
  ucdLib: "ATORVASTATINE ACC 40MG CPR",
  UCD7: '9409587',
  UCD13: '3400894095873',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ACC 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2186055',
  CIP13: '3400921860559',
  ucdLib: "ATORVASTATINE ACC 80MG CPR",
  UCD7: '9409593',
  UCD13: '3400894095934',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ACC 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2174023',
  CIP13: '3400921740233',
  ucdLib: "ATORVASTATINE BGR 10MG CPR",
  UCD7: '9381699',
  UCD13: '3400893816998',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE BGR 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2174081',
  CIP13: '3400921740813',
  ucdLib: "ATORVASTATINE BGR 10MG CPR",
  UCD7: '9381699',
  UCD13: '3400893816998',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE BGR 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2174129',
  CIP13: '3400921741292',
  ucdLib: "ATORVASTATINE BGR 20MG CPR",
  UCD7: '9381707',
  UCD13: '3400893817070',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE BGR 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2174170',
  CIP13: '3400921741704',
  ucdLib: "ATORVASTATINE BGR 20MG CPR",
  UCD7: '9381707',
  UCD13: '3400893817070',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE BGR 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2174218',
  CIP13: '3400921742183',
  ucdLib: "ATORVASTATINE BGR 40MG CPR",
  UCD7: '9381713',
  UCD13: '3400893817131',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE BGR 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2174276',
  CIP13: '3400921742763',
  ucdLib: "ATORVASTATINE BGR 40MG CPR",
  UCD7: '9381713',
  UCD13: '3400893817131',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE BGR 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2174336',
  CIP13: '3400921743364',
  ucdLib: "ATORVASTATINE BGR 80MG CPR",
  UCD7: '9381736',
  UCD13: '3400893817360',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE BGR 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2174388',
  CIP13: '3400921743883',
  ucdLib: "ATORVASTATINE BGR 80MG CPR",
  UCD7: '9381736',
  UCD13: '3400893817360',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE BGR 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4167263',
  CIP13: '3400941672637',
  ucdLib: "ATORVASTATINE CRT 10MG CPR",
  UCD7: '9374819',
  UCD13: '3400893748190',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE CRT 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4167317',
  CIP13: '3400941673177',
  ucdLib: "ATORVASTATINE CRT 10MG CPR",
  UCD7: '9374819',
  UCD13: '3400893748190',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE CRT 10MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4167056',
  CIP13: '3400941670565',
  ucdLib: "ATORVASTATINE CRT 20MG CPR",
  UCD7: '9374825',
  UCD13: '3400893748251',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE CRT 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4167091',
  CIP13: '3400941670916',
  ucdLib: "ATORVASTATINE CRT 20MG CPR",
  UCD7: '9374825',
  UCD13: '3400893748251',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE CRT 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4166832',
  CIP13: '3400941668326',
  ucdLib: "ATORVASTATINE CRT 40MG CPR",
  UCD7: '9374831',
  UCD13: '3400893748312',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE CRT 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4166878',
  CIP13: '3400941668784',
  ucdLib: "ATORVASTATINE CRT 40MG CPR",
  UCD7: '9374831',
  UCD13: '3400893748312',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE CRT 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2166383',
  CIP13: '3400921663839',
  ucdLib: "ATORVASTATINE ISD 10MG CPR",
  UCD7: '9382859',
  UCD13: '3400893828595',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE ISD 10MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '2166443',
  CIP13: '3400921664430',
  ucdLib: "ATORVASTATINE ISD 20MG CPR",
  UCD7: '9382865',
  UCD13: '3400893828656',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE ISD 20MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '2166495',
  CIP13: '3400921664959',
  ucdLib: "ATORVASTATINE ISD 20MG CPR",
  UCD7: '9382865',
  UCD13: '3400893828656',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ISD 20MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2166555',
  CIP13: '3400921665550',
  ucdLib: "ATORVASTATINE ISD 40MG CPR",
  UCD7: '9382871',
  UCD13: '3400893828717',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE ISD 40MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '2166590',
  CIP13: '3400921665901',
  ucdLib: "ATORVASTATINE ISD 40MG CPR",
  UCD7: '9382871',
  UCD13: '3400893828717',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ISD 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '2166609',
  CIP13: '3400921666090',
  ucdLib: "ATORVASTATINE ISD 80MG CPR",
  UCD7: '9382888',
  UCD13: '3400893828885',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE ISD 80MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '2228428',
  CIP13: '3400922284286',
  ucdLib: "ATORVASTATINE MYL 10MG CPR",
  UCD7: '9374877',
  UCD13: '3400893748770',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE MYL 10MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2228457',
  CIP13: '3400922284576',
  ucdLib: "ATORVASTATINE MYL 20MG CPR",
  UCD7: '9374883',
  UCD13: '3400893748831',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE MYL 20MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2228492',
  CIP13: '3400922284927',
  ucdLib: "ATORVASTATINE MYL 40MG CPR",
  UCD7: '9374908',
  UCD13: '3400893749081',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE MYL 40MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2228523',
  CIP13: '3400922285238',
  ucdLib: "ATORVASTATINE MYL 80MG CPR",
  UCD7: '9374914',
  UCD13: '3400893749142',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE MYL 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '2237108',
  CIP13: '3400922371085',
  ucdLib: "ATORVASTATINE PFZ 10MG CPR",
  UCD7: '9417339',
  UCD13: '3400894173397',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE PFZ 10MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '2237143',
  CIP13: '3400922371436',
  ucdLib: "ATORVASTATINE PFZ 20MG CPR",
  UCD7: '9417345',
  UCD13: '3400894173458',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE PFZ 20MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '2237195',
  CIP13: '3400922371955',
  ucdLib: "ATORVASTATINE PFZ 40MG CPR",
  UCD7: '9417351',
  UCD13: '3400894173519',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE PFZ 40MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '2237255',
  CIP13: '3400922372556',
  ucdLib: "ATORVASTATINE PFZ 80MG CPR",
  UCD7: '9417368',
  UCD13: '3400894173687',
  ucdQtyMultiplicator: 28,
  cipLib: "ATORVASTATINE PFZ 80MG CPR BT 28",
  atcCode: "C10AA05"
}, {
  CIP7: '4180016',
  CIP13: '3400941800160',
  ucdLib: "ATORVASTATINE ZTL 40MG CPR",
  UCD7: '9374995',
  UCD13: '3400893749951',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ZTL 40MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '4180080',
  CIP13: '3400941800801',
  ucdLib: "ATORVASTATINE ZTL 80MG CPR",
  UCD7: '9375003',
  UCD13: '3400893750032',
  ucdQtyMultiplicator: 30,
  cipLib: "ATORVASTATINE ZTL 80MG CPR BT 30",
  atcCode: "C10AA05"
}, {
  CIP7: '4180105',
  CIP13: '3400941801051',
  ucdLib: "ATORVASTATINE ZTL 80MG CPR",
  UCD7: '9375003',
  UCD13: '3400893750032',
  ucdQtyMultiplicator: 90,
  cipLib: "ATORVASTATINE ZTL 80MG CPR BT 90",
  atcCode: "C10AA05"
}, {
  CIP7: '3834935',
  CIP13: '3400938349351',
  ucdLib: "FLUVASTATINE SDZ 20MG GELU",
  UCD7: '9313663',
  UCD13: '3400893136638',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE SDZ 20MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3834970',
  CIP13: '3400938349702',
  ucdLib: "FLUVASTATINE SDZ 20MG GELU",
  UCD7: '9313663',
  UCD13: '3400893136638',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE SDZ 20MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3835171',
  CIP13: '3400938351712',
  ucdLib: "FLUVASTATINE SDZ 40MG GELU",
  UCD7: '9313686',
  UCD13: '3400893136867',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE SDZ 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3835219',
  CIP13: '3400938352191',
  ucdLib: "FLUVASTATINE SDZ 40MG GELU",
  UCD7: '9313686',
  UCD13: '3400893136867',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE SDZ 40MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3198876',
  CIP13: '3400931988762',
  ucdLib: "FLUVASTATINE ISD 40MG GELU",
  UCD7: '9345746',
  UCD13: '3400893457467',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE ISD 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3199367',
  CIP13: '3400931993674',
  ucdLib: "FLUVASTATINE ISD 40MG GELU",
  UCD7: '9345746',
  UCD13: '3400893457467',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE ISD 40MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3720812',
  CIP13: '3400937208123',
  ucdLib: "LESCOL 20MG GELU",
  UCD7: '9180943',
  UCD13: '3400891809435',
  ucdQtyMultiplicator: 30,
  cipLib: "LESCOL 20MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3720829',
  CIP13: '3400937208291',
  ucdLib: "LESCOL 20MG GELU",
  UCD7: '9180943',
  UCD13: '3400891809435',
  ucdQtyMultiplicator: 90,
  cipLib: "LESCOL 20MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3720775',
  CIP13: '3400937207751',
  ucdLib: "LESCOL 40MG GELU",
  UCD7: '9180966',
  UCD13: '3400891809664',
  ucdQtyMultiplicator: 30,
  cipLib: "LESCOL 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3720781',
  CIP13: '3400937207812',
  ucdLib: "LESCOL 40MG GELU",
  UCD7: '9180966',
  UCD13: '3400891809664',
  ucdQtyMultiplicator: 90,
  cipLib: "LESCOL 40MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3720798',
  CIP13: '3400937207980',
  ucdLib: "LESCOL LP 80MG CPR",
  UCD7: '9231971',
  UCD13: '3400892319711',
  ucdQtyMultiplicator: 30,
  cipLib: "LESCOL LP 80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3720806',
  CIP13: '3400937208062',
  ucdLib: "LESCOL LP 80MG CPR",
  UCD7: '9231971',
  UCD13: '3400892319711',
  ucdQtyMultiplicator: 90,
  cipLib: "LESCOL LP 80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3923231',
  CIP13: '3400939232317',
  ucdLib: "FLUVASTATINE EG 20MG GELU",
  UCD7: '9332672',
  UCD13: '3400893326725',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE EG 20MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3923260',
  CIP13: '3400939232607',
  ucdLib: "FLUVASTATINE EG 20MG GELU",
  UCD7: '9332672',
  UCD13: '3400893326725',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE EG 20MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3923343',
  CIP13: '3400939233437',
  ucdLib: "FLUVASTATINE EG 40MG GELU",
  UCD7: '9332689',
  UCD13: '3400893326893',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE EG 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3923389',
  CIP13: '3400939233895',
  ucdLib: "FLUVASTATINE EG 40MG GELU",
  UCD7: '9332689',
  UCD13: '3400893326893',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE EG 40MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3879168',
  CIP13: '3400938791686',
  ucdLib: "FLUVASTATINE MYL LP80MG CPR",
  UCD7: '9324738',
  UCD13: '3400893247389',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE MYL LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3879205',
  CIP13: '3400938792058',
  ucdLib: "FLUVASTATINE MYL LP80MG CPR",
  UCD7: '9324738',
  UCD13: '3400893247389',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE MYL LP80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3867202',
  CIP13: '3400938672022',
  ucdLib: "FLUVASTATINE SDZ LP80MG CPR",
  UCD7: '9324744',
  UCD13: '3400893247440',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE SDZ LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3879754',
  CIP13: '3400938797541',
  ucdLib: "FLUVASTATINE SDZ LP80MG CPR",
  UCD7: '9324744',
  UCD13: '3400893247440',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE SDZ LP80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3874389',
  CIP13: '3400938743890',
  ucdLib: "FLUVASTATINE TVC 20MG GELU",
  UCD7: '9321355',
  UCD13: '3400893213551',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE TVC 20MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3874455',
  CIP13: '3400938744552',
  ucdLib: "FLUVASTATINE TVC 20MG GELU",
  UCD7: '9321355',
  UCD13: '3400893213551',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE TVC 20MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3874550',
  CIP13: '3400938745504',
  ucdLib: "FLUVASTATINE TVC 40MG GELU",
  UCD7: '9321361',
  UCD13: '3400893213612',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE TVC 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3874610',
  CIP13: '3400938746105',
  ucdLib: "FLUVASTATINE TVC 40MG GELU",
  UCD7: '9321361',
  UCD13: '3400893213612',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE TVC 40MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3959921',
  CIP13: '3400939599212',
  ucdLib: "FLUVASTATINE ARW 20MG GELU",
  UCD7: '9341518',
  UCD13: '3400893415184',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE ARW 20MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3959944',
  CIP13: '3400939599441',
  ucdLib: "FLUVASTATINE ARW 20MG GELU",
  UCD7: '9341518',
  UCD13: '3400893415184',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE ARW 20MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3959973',
  CIP13: '3400939599731',
  ucdLib: "FLUVASTATINE ARW 40MG GELU",
  UCD7: '9341524',
  UCD13: '3400893415245',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE ARW 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3960002',
  CIP13: '3400939600024',
  ucdLib: "FLUVASTATINE ARW 40MG GELU",
  UCD7: '9341524',
  UCD13: '3400893415245',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE ARW 40MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3961852',
  CIP13: '3400939618524',
  ucdLib: "FLUVASTATINE BGA 20MG GELU",
  UCD7: '9342771',
  UCD13: '3400893427712',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE BGA 20MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3961875',
  CIP13: '3400939618753',
  ucdLib: "FLUVASTATINE BGA 20MG GELU",
  UCD7: '9342771',
  UCD13: '3400893427712',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE BGA 20MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3972815',
  CIP13: '3400939728155',
  ucdLib: "FLUVASTATINE BGA 40MG GELU",
  UCD7: '9342788',
  UCD13: '3400893427880',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE BGA 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3972838',
  CIP13: '3400939728384',
  ucdLib: "FLUVASTATINE BGA 40MG GELU",
  UCD7: '9342788',
  UCD13: '3400893427880',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE BGA 40MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3937813',
  CIP13: '3400939378138',
  ucdLib: "FLUVASTATINE BGA LP80MG CPR",
  UCD7: '9335676',
  UCD13: '3400893356760',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE BGA LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3937842',
  CIP13: '3400939378428',
  ucdLib: "FLUVASTATINE BGA LP80MG CPR",
  UCD7: '9335676',
  UCD13: '3400893356760',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE BGA LP80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3950015',
  CIP13: '3400939500157',
  ucdLib: "FLUVASTATINE MYL 40MG GELU",
  UCD7: '9338580',
  UCD13: '3400893385807',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE MYL 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3950038',
  CIP13: '3400939500386',
  ucdLib: "FLUVASTATINE MYL 40MG GELU",
  UCD7: '9338580',
  UCD13: '3400893385807',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE MYL 40MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '2751880',
  CIP13: '3400927518805',
  ucdLib: "FLUVASTATINE ACC LP80MG CPR",
  UCD7: '9395514',
  UCD13: '3400893955147',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE ACC LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '2751928',
  CIP13: '3400927519284',
  ucdLib: "FLUVASTATINE ACC LP80MG CPR",
  UCD7: '9395514',
  UCD13: '3400893955147',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE ACC LP80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3941967',
  CIP13: '3400939419671',
  ucdLib: "FLUVASTATINE ARW LP80MG CPR",
  UCD7: '9340016',
  UCD13: '3400893400166',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE ARW LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3941996',
  CIP13: '3400939419961',
  ucdLib: "FLUVASTATINE ARW LP80MG CPR",
  UCD7: '9340016',
  UCD13: '3400893400166',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE ARW LP80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3986444',
  CIP13: '3400939864440',
  ucdLib: "FLUVASTATINE CRT LP80MG CPR",
  UCD7: '9346527',
  UCD13: '3400893465271',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE CRT LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3986473',
  CIP13: '3400939864730',
  ucdLib: "FLUVASTATINE CRT LP80MG CPR",
  UCD7: '9346527',
  UCD13: '3400893465271',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE CRT LP80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3943009',
  CIP13: '3400939430096',
  ucdLib: "FLUVASTATINE EG LP 80MG CPR",
  UCD7: '9339651',
  UCD13: '3400893396513',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE EG LP 80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3943021',
  CIP13: '3400939430218',
  ucdLib: "FLUVASTATINE EG LP 80MG CPR",
  UCD7: '9339651',
  UCD13: '3400893396513',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE EG LP 80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3947036',
  CIP13: '3400939470368',
  ucdLib: "FLUVASTATINE EVO LP 80MG CPR",
  UCD7: '9339680',
  UCD13: '3400893396803',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE EVO LP 80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3986562',
  CIP13: '3400939865621',
  ucdLib: "FLUVASTATINE ISD LP80MG CPR",
  UCD7: '9346616',
  UCD13: '3400893466162',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE ISD LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3949928',
  CIP13: '3400939499284',
  ucdLib: "FLUVASTATINE MYL 20MG GELU",
  UCD7: '9338574',
  UCD13: '3400893385746',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE MYL 20MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3949940',
  CIP13: '3400939499406',
  ucdLib: "FLUVASTATINE MYL 20MG GELU",
  UCD7: '9338574',
  UCD13: '3400893385746',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE MYL 20MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3986510',
  CIP13: '3400939865102',
  ucdLib: "FLUVASTATINE RTP LP80MG CPR",
  UCD7: '9349313',
  UCD13: '3400893493137',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE RTP LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3943133',
  CIP13: '3400939431338',
  ucdLib: "FLUVASTATINE TVC LP80MG CPR",
  UCD7: '9338628',
  UCD13: '3400893386286',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE TVC LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3943162',
  CIP13: '3400939431628',
  ucdLib: "FLUVASTATINE TVC LP80MG CPR",
  UCD7: '9338628',
  UCD13: '3400893386286',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE TVC LP80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '3942576',
  CIP13: '3400939425764',
  ucdLib: "FLUVASTATINE ZEN LP80MG CPR",
  UCD7: '9339674',
  UCD13: '3400893396742',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE ZEN LP80MG CPR BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3942599',
  CIP13: '3400939425993',
  ucdLib: "FLUVASTATINE ZEN LP80MG CPR",
  UCD7: '9339674',
  UCD13: '3400893396742',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE ZEN LP80MG CPR BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '2739287',
  CIP13: '3400927392870',
  ucdLib: "FLUVASTATINE EVO 40MG GELU",
  UCD7: '9395916',
  UCD13: '3400893959169',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE EVO 40MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3998074',
  CIP13: '3400939980744',
  ucdLib: "FLUVASTATINE ISD 20MG GELU",
  UCD7: '9345723',
  UCD13: '3400893457238',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUVASTATINE ISD 20MG GELU BT 30",
  atcCode: "C10AA04"
}, {
  CIP7: '3998097',
  CIP13: '3400939980973',
  ucdLib: "FLUVASTATINE ISD 20MG GELU",
  UCD7: '9345723',
  UCD13: '3400893457238',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUVASTATINE ISD 20MG GELU BT 90",
  atcCode: "C10AA04"
}, {
  CIP7: '5670171',
  CIP13: '3400956701711',
  ucdLib: "LESCOL LP 80MG CPR",
  UCD7: '9231971',
  UCD13: '3400892319711',
  ucdQtyMultiplicator: 28,
  cipLib: "LESCOL LP 80MG CPR BT 28",
  atcCode: "C10AA04"
}, {
  CIP7: '3322112',
  CIP13: '3400933221126',
  ucdLib: "ELISOR 10MG CPR",
  UCD7: '9275916',
  UCD13: '3400892759166',
  ucdQtyMultiplicator: 28,
  cipLib: "ELISOR 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3322129',
  CIP13: '3400933221294',
  ucdLib: "ELISOR 20MG CPR",
  UCD7: '9146656',
  UCD13: '3400891466560',
  ucdQtyMultiplicator: 28,
  cipLib: "ELISOR 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3322135',
  CIP13: '3400933221355',
  ucdLib: "VASTEN 10MG CPR",
  UCD7: '9279392',
  UCD13: '3400892793924',
  ucdQtyMultiplicator: 28,
  cipLib: "VASTEN 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3322141',
  CIP13: '3400933221416',
  ucdLib: "VASTEN 20MG CPR",
  UCD7: '9145734',
  UCD13: '3400891457346',
  ucdQtyMultiplicator: 28,
  cipLib: "VASTEN 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3686311',
  CIP13: '3400936863118',
  ucdLib: "PRAVASTATINE TVC 10MG CPR",
  UCD7: '9278547',
  UCD13: '3400892785479',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE TVC 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3686334',
  CIP13: '3400936863347',
  ucdLib: "PRAVASTATINE TVC 20MG CPR",
  UCD7: '9278553',
  UCD13: '3400892785530',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE TVC 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3686357',
  CIP13: '3400936863576',
  ucdLib: "PRAVASTATINE TVC 40MG CPR",
  UCD7: '9278576',
  UCD13: '3400892785769',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE TVC 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3511416',
  CIP13: '3400935114167',
  ucdLib: "ELISOR 40MG CPR",
  UCD7: '9220909',
  UCD13: '3400892209098',
  ucdQtyMultiplicator: 28,
  cipLib: "ELISOR 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3511422',
  CIP13: '3400935114228',
  ucdLib: "VASTEN 40MG CPR",
  UCD7: '9221004',
  UCD13: '3400892210049',
  ucdQtyMultiplicator: 28,
  cipLib: "VASTEN 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '5608166',
  CIP13: '3400956081660',
  ucdLib: "ELISOR 20MG CPR",
  UCD7: '9146656',
  UCD13: '3400891466560',
  ucdQtyMultiplicator: 50,
  cipLib: "ELISOR 20MG CPR BT 50",
  atcCode: "C10AA03"
}, {
  CIP7: '3704730',
  CIP13: '3400937047302',
  ucdLib: "PRAVASTATINE ARG 20MG CPR",
  UCD7: '9282000',
  UCD13: '3400892820002',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ARG 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3704061',
  CIP13: '3400937040617',
  ucdLib: "PRAVASTATINE CRT 20MG CPR",
  UCD7: '9282023',
  UCD13: '3400892820231',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE CRT 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3704150',
  CIP13: '3400937041508',
  ucdLib: "PRAVASTATINE CRT 40MG CPR",
  UCD7: '9282299',
  UCD13: '3400892822990',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE CRT 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3762986',
  CIP13: '3400937629867',
  ucdLib: "PRAVASTATINE ALT 20MG CPR",
  UCD7: '9292932',
  UCD13: '3400892929323',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ALT 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3763000',
  CIP13: '3400937630009',
  ucdLib: "PRAVASTATINE ALT 40MG CPR",
  UCD7: '9292949',
  UCD13: '3400892929491',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ALT 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3745522',
  CIP13: '3400937455220',
  ucdLib: "PRAVASTATINE ZEN 10MG CPR",
  UCD7: '9289806',
  UCD13: '3400892898063',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ZEN 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3745568',
  CIP13: '3400937455688',
  ucdLib: "PRAVASTATINE ZYD 20MG CPR",
  UCD7: '9289456',
  UCD13: '3400892894560',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ZYD 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3745574',
  CIP13: '3400937455749',
  ucdLib: "PRAVASTATINE ZYD 20MG CPR",
  UCD7: '9289456',
  UCD13: '3400892894560',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ZYD 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3745545',
  CIP13: '3400937455459',
  ucdLib: "PRAVASTATINE ZYD 40MG CPR",
  UCD7: '9289462',
  UCD13: '3400892894621',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ZYD 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3745551',
  CIP13: '3400937455510',
  ucdLib: "PRAVASTATINE ZYD 40MG CPR",
  UCD7: '9289462',
  UCD13: '3400892894621',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ZYD 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3690873',
  CIP13: '3400936908734',
  ucdLib: "VASTEN 20MG CPR",
  UCD7: '9145734',
  UCD13: '3400891457346',
  ucdQtyMultiplicator: 84,
  cipLib: "VASTEN 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3690896',
  CIP13: '3400936908963',
  ucdLib: "VASTEN 40MG CPR",
  UCD7: '9221004',
  UCD13: '3400892210049',
  ucdQtyMultiplicator: 84,
  cipLib: "VASTEN 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3713999',
  CIP13: '3400937139991',
  ucdLib: "ELISOR 20MG CPR",
  UCD7: '9146656',
  UCD13: '3400891466560',
  ucdQtyMultiplicator: 84,
  cipLib: "ELISOR 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3714007',
  CIP13: '3400937140072',
  ucdLib: "ELISOR 40MG CPR",
  UCD7: '9220909',
  UCD13: '3400892209098',
  ucdQtyMultiplicator: 84,
  cipLib: "ELISOR 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '5616415',
  CIP13: '3400956164158',
  ucdLib: "ELISOR 40MG CPR",
  UCD7: '9220909',
  UCD13: '3400892209098',
  ucdQtyMultiplicator: 50,
  cipLib: "ELISOR 40MG CPR BT 50",
  atcCode: "C10AA03"
}, {
  CIP7: '3441644',
  CIP13: '3400934416446',
  ucdLib: "PRAVASTATINE ACC 40MG CPR",
  UCD7: '9349738',
  UCD13: '3400893497388',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ACC 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3804101',
  CIP13: '3400938041019',
  ucdLib: "PRAVASTATINE ALT 20MG CPR",
  UCD7: '9292932',
  UCD13: '3400892929323',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ALT 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3756359',
  CIP13: '3400937563598',
  ucdLib: "PRAVASTATINE CRT 10MG CPR",
  UCD7: '9310268',
  UCD13: '3400893102688',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE CRT 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3927648',
  CIP13: '3400939276489',
  ucdLib: "PRAVASTATINE CRT 20MG CPR",
  UCD7: '9282023',
  UCD13: '3400892820231',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE CRT 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3927677',
  CIP13: '3400939276779',
  ucdLib: "PRAVASTATINE CRT 40MG CPR",
  UCD7: '9282299',
  UCD13: '3400892822990',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE CRT 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3755704',
  CIP13: '3400937557047',
  ucdLib: "PRAVASTATINE ISD 20MG CPR",
  UCD7: '9291223',
  UCD13: '3400892912233',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ISD 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3755756',
  CIP13: '3400937557566',
  ucdLib: "PRAVASTATINE ISD 20MG CPR",
  UCD7: '9291223',
  UCD13: '3400892912233',
  ucdQtyMultiplicator: 90,
  cipLib: "PRAVASTATINE ISD 20MG CPR BT 90",
  atcCode: "C10AA03"
}, {
  CIP7: '3755578',
  CIP13: '3400937555784',
  ucdLib: "PRAVASTATINE ISD 40MG CPR",
  UCD7: '9291246',
  UCD13: '3400892912462',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ISD 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3755609',
  CIP13: '3400937556095',
  ucdLib: "PRAVASTATINE ISD 40MG CPR",
  UCD7: '9291246',
  UCD13: '3400892912462',
  ucdQtyMultiplicator: 90,
  cipLib: "PRAVASTATINE ISD 40MG CPR BT 90",
  atcCode: "C10AA03"
}, {
  CIP7: '3861820',
  CIP13: '3400938618204',
  ucdLib: "PRAVASTATINE LBR 20MG CPR",
  UCD7: '9320462',
  UCD13: '3400893204627',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE LBR 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3861843',
  CIP13: '3400938618433',
  ucdLib: "PRAVASTATINE LBR 20MG CPR",
  UCD7: '9320462',
  UCD13: '3400893204627',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE LBR 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3861725',
  CIP13: '3400938617252',
  ucdLib: "PRAVASTATINE LBR 40MG CPR",
  UCD7: '9320479',
  UCD13: '3400893204795',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE LBR 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3861748',
  CIP13: '3400938617481',
  ucdLib: "PRAVASTATINE LBR 40MG CPR",
  UCD7: '9320479',
  UCD13: '3400893204795',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE LBR 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3861783',
  CIP13: '3400938617832',
  ucdLib: "PRAVASTATINE RPG 20MG CPR",
  UCD7: '9320491',
  UCD13: '3400893204917',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE RPG 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3861814',
  CIP13: '3400938618143',
  ucdLib: "PRAVASTATINE RPG 20MG CPR",
  UCD7: '9320491',
  UCD13: '3400893204917',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE RPG 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3861754',
  CIP13: '3400938617542',
  ucdLib: "PRAVASTATINE RPG 40MG CPR",
  UCD7: '9320516',
  UCD13: '3400893205167',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE RPG 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '3861777',
  CIP13: '3400938617771',
  ucdLib: "PRAVASTATINE RPG 40MG CPR",
  UCD7: '9320516',
  UCD13: '3400893205167',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE RPG 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3736598',
  CIP13: '3400937365987',
  ucdLib: "PRAVASTATINE TVC 20MG CPR",
  UCD7: '9278553',
  UCD13: '3400892785530',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE TVC 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3736606',
  CIP13: '3400937366069',
  ucdLib: "PRAVASTATINE TVC 40MG CPR",
  UCD7: '9278576',
  UCD13: '3400892785769',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE TVC 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '3901270',
  CIP13: '3400939012704',
  ucdLib: "PRAVASTATINE SDZ 10MG CPR",
  UCD7: '9330584',
  UCD13: '3400893305843',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAVASTATINE SDZ 10MG CPR BT 30",
  atcCode: "C10AA03"
}, {
  CIP7: '3901382',
  CIP13: '3400939013824',
  ucdLib: "PRAVASTATINE SDZ 20MG CPR",
  UCD7: '9330590',
  UCD13: '3400893305904',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAVASTATINE SDZ 20MG CPR BT 30",
  atcCode: "C10AA03"
}, {
  CIP7: '3901494',
  CIP13: '3400939014944',
  ucdLib: "PRAVASTATINE SDZ 40MG CPR",
  UCD7: '9330609',
  UCD13: '3400893306093',
  ucdQtyMultiplicator: 30,
  cipLib: "PRAVASTATINE SDZ 40MG CPR BT 30",
  atcCode: "C10AA03"
}, {
  CIP7: '4190003',
  CIP13: '3400941900037',
  ucdLib: "PRAVASTATINE ACC 20MG CPR",
  UCD7: '9359085',
  UCD13: '3400893590850',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ACC 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '4190026',
  CIP13: '3400941900266',
  ucdLib: "PRAVASTATINE ACC 40MG CPR",
  UCD7: '9349738',
  UCD13: '3400893497388',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ACC 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '4159849',
  CIP13: '3400941598494',
  ucdLib: "PRAVASTATINE ALS 20MG CPR",
  UCD7: '9369066',
  UCD13: '3400893690666',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ALS 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '4159855',
  CIP13: '3400941598555',
  ucdLib: "PRAVASTATINE ALS 20MG CPR",
  UCD7: '9369066',
  UCD13: '3400893690666',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ALS 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '4176569',
  CIP13: '3400941765698',
  ucdLib: "PRAVASTATINE ALS 40MG CPR",
  UCD7: '9369072',
  UCD13: '3400893690727',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ALS 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2665643',
  CIP13: '3400926656430',
  ucdLib: "PRAVASTATINE ARW 10MG CP",
  UCD7: '9406991',
  UCD13: '3400894069911',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ARW 10MG CP BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2665790',
  CIP13: '3400926657901',
  ucdLib: "PRAVASTATINE ARW 20MG CP",
  UCD7: '9407016',
  UCD13: '3400894070160',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ARW 20MG CP BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2665815',
  CIP13: '3400926658151',
  ucdLib: "PRAVASTATINE ARW 20MG CP",
  UCD7: '9407016',
  UCD13: '3400894070160',
  ucdQtyMultiplicator: 50,
  cipLib: "PRAVASTATINE ARW 20MG CP BT 50",
  atcCode: "C10AA03"
}, {
  CIP7: '2665844',
  CIP13: '3400926658441',
  ucdLib: "PRAVASTATINE ARW 20MG CP",
  UCD7: '9407016',
  UCD13: '3400894070160',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ARW 20MG CP BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2665933',
  CIP13: '3400926659332',
  ucdLib: "PRAVASTATINE ARW 40MG CP",
  UCD7: '9407022',
  UCD13: '3400894070221',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ARW 40MG CP BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2665962',
  CIP13: '3400926659622',
  ucdLib: "PRAVASTATINE ARW 40MG CP",
  UCD7: '9407022',
  UCD13: '3400894070221',
  ucdQtyMultiplicator: 50,
  cipLib: "PRAVASTATINE ARW 40MG CP BT 50",
  atcCode: "C10AA03"
}, {
  CIP7: '2665991',
  CIP13: '3400926659912',
  ucdLib: "PRAVASTATINE ARW 40MG CP",
  UCD7: '9407022',
  UCD13: '3400894070221',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ARW 40MG CP BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2191978',
  CIP13: '3400921919783',
  ucdLib: "PRAVASTATINE BGA 10MG CPR",
  UCD7: '9285866',
  UCD13: '3400892858661',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE BGA 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2192015',
  CIP13: '3400921920154',
  ucdLib: "PRAVASTATINE BGA 20MG CPR",
  UCD7: '9285872',
  UCD13: '3400892858722',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE BGA 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2192038',
  CIP13: '3400921920383',
  ucdLib: "PRAVASTATINE BGA 20MG CPR",
  UCD7: '9285872',
  UCD13: '3400892858722',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE BGA 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2192050',
  CIP13: '3400921920505',
  ucdLib: "PRAVASTATINE BGA 40MG CPR",
  UCD7: '9285889',
  UCD13: '3400892858890',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE BGA 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2192073',
  CIP13: '3400921920734',
  ucdLib: "PRAVASTATINE BGA 40MG CPR",
  UCD7: '9285889',
  UCD13: '3400892858890',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE BGA 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2196125',
  CIP13: '3400921961256',
  ucdLib: "PRAVASTATINE EG 10MG CPR",
  UCD7: '9275974',
  UCD13: '3400892759746',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE EG 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2190720',
  CIP13: '3400921907209',
  ucdLib: "PRAVASTATINE EG 20MG CPR",
  UCD7: '9275980',
  UCD13: '3400892759807',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE EG 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2190737',
  CIP13: '3400921907377',
  ucdLib: "PRAVASTATINE EG 20MG CPR",
  UCD7: '9275980',
  UCD13: '3400892759807',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE EG 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2190766',
  CIP13: '3400921907667',
  ucdLib: "PRAVASTATINE EG 40MG CPR",
  UCD7: '9275997',
  UCD13: '3400892759975',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE EG 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2190772',
  CIP13: '3400921907728',
  ucdLib: "PRAVASTATINE EG 40MG CPR",
  UCD7: '9275997',
  UCD13: '3400892759975',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE EG 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2192104',
  CIP13: '3400921921045',
  ucdLib: "PRAVASTATINE EVO 10MG CPR",
  UCD7: '9282052',
  UCD13: '3400892820521',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE EVO 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2192156',
  CIP13: '3400921921564',
  ucdLib: "PRAVASTATINE EVO 20MG CPR",
  UCD7: '9282069',
  UCD13: '3400892820699',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE EVO 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2192179',
  CIP13: '3400921921793',
  ucdLib: "PRAVASTATINE EVO 20MG CPR",
  UCD7: '9282069',
  UCD13: '3400892820699',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE EVO 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2192191',
  CIP13: '3400921921915',
  ucdLib: "PRAVASTATINE EVO 40MG CPR",
  UCD7: '9282313',
  UCD13: '3400892823133',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE EVO 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2192222',
  CIP13: '3400921922226',
  ucdLib: "PRAVASTATINE EVO 40MG CPR",
  UCD7: '9282313',
  UCD13: '3400892823133',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE EVO 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '4158896',
  CIP13: '3400941588969',
  ucdLib: "PRAVASTATINE PHR 10MG CPR",
  UCD7: '9369089',
  UCD13: '3400893690895',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE PHR 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '4159878',
  CIP13: '3400941598784',
  ucdLib: "PRAVASTATINE PHR 20MG CPR",
  UCD7: '9369095',
  UCD13: '3400893690956',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE PHR 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '4159884',
  CIP13: '3400941598845',
  ucdLib: "PRAVASTATINE PHR 20MG CPR",
  UCD7: '9369095',
  UCD13: '3400893690956',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE PHR 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '4159909',
  CIP13: '3400941599095',
  ucdLib: "PRAVASTATINE PHR 40MG CPR",
  UCD7: '9369103',
  UCD13: '3400893691038',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE PHR 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '4176233',
  CIP13: '3400941762338',
  ucdLib: "PRAVASTATINE PHR 40MG CPR",
  UCD7: '9369103',
  UCD13: '3400893691038',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE PHR 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '4996545',
  CIP13: '3400949965458',
  ucdLib: "PRAVASTATINE RATIO10MG CPR",
  UCD7: '9372358',
  UCD13: '3400893723586',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE RATIO10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '4996634',
  CIP13: '3400949966349',
  ucdLib: "PRAVASTATINE RATIO20MG CPR",
  UCD7: '9372364',
  UCD13: '3400893723647',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE RATIO20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '4996686',
  CIP13: '3400949966868',
  ucdLib: "PRAVASTATINE RATIO20MG CPR",
  UCD7: '9372364',
  UCD13: '3400893723647',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE RATIO20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '4996746',
  CIP13: '3400949967469',
  ucdLib: "PRAVASTATINE RATIO40MG CPR",
  UCD7: '9372370',
  UCD13: '3400893723708',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE RATIO40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2751727',
  CIP13: '3400927517273',
  ucdLib: "PRAVASTATINE ZEN 20MG CPR",
  UCD7: '9288474',
  UCD13: '3400892884745',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ZEN 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2751733',
  CIP13: '3400927517334',
  ucdLib: "PRAVASTATINE ZEN 20MG CPR",
  UCD7: '9288474',
  UCD13: '3400892884745',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ZEN 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2751756',
  CIP13: '3400927517563',
  ucdLib: "PRAVASTATINE ZEN 20MG CPR",
  UCD7: '9288474',
  UCD13: '3400892884745',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ZEN 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2751762',
  CIP13: '3400927517624',
  ucdLib: "PRAVASTATINE ZEN 20MG CPR",
  UCD7: '9288474',
  UCD13: '3400892884745',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ZEN 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2751779',
  CIP13: '3400927517792',
  ucdLib: "PRAVASTATINE ZEN 40MG CPR",
  UCD7: '9288480',
  UCD13: '3400892884806',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ZEN 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2751785',
  CIP13: '3400927517853',
  ucdLib: "PRAVASTATINE ZEN 40MG CPR",
  UCD7: '9288480',
  UCD13: '3400892884806',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ZEN 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2751791',
  CIP13: '3400927517914',
  ucdLib: "PRAVASTATINE ZEN 40MG CPR",
  UCD7: '9288480',
  UCD13: '3400892884806',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ZEN 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2751816',
  CIP13: '3400927518164',
  ucdLib: "PRAVASTATINE ZEN 40MG CPR",
  UCD7: '9288480',
  UCD13: '3400892884806',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE ZEN 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2740646',
  CIP13: '3400927406461',
  ucdLib: "VASTEN 20MG CPR",
  UCD7: '9145734',
  UCD13: '3400891457346',
  ucdQtyMultiplicator: 28,
  cipLib: "VASTEN 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2740652',
  CIP13: '3400927406522',
  ucdLib: "VASTEN 20MG CPR",
  UCD7: '9145734',
  UCD13: '3400891457346',
  ucdQtyMultiplicator: 84,
  cipLib: "VASTEN 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2740669',
  CIP13: '3400927406690',
  ucdLib: "VASTEN 40MG CPR",
  UCD7: '9221004',
  UCD13: '3400892210049',
  ucdQtyMultiplicator: 28,
  cipLib: "VASTEN 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2740675',
  CIP13: '3400927406751',
  ucdLib: "VASTEN 40MG CPR",
  UCD7: '9221004',
  UCD13: '3400892210049',
  ucdQtyMultiplicator: 84,
  cipLib: "VASTEN 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '4929767',
  CIP13: '3400949297672',
  ucdLib: "PRAVASTATINE ACC 10MG CPR",
  UCD7: '9359079',
  UCD13: '3400893590799',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ACC 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '4929856',
  CIP13: '3400949298563',
  ucdLib: "PRAVASTATINE ACC 20MG CPR",
  UCD7: '9359085',
  UCD13: '3400893590850',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ACC 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '4160309',
  CIP13: '3400941603099',
  ucdLib: "PRAVASTATINE ALS 40MG CPR",
  UCD7: '9369072',
  UCD13: '3400893690727',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE ALS 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2184576',
  CIP13: '3400921845761',
  ucdLib: "PRAVASTATINE MYL 10MG CPR",
  UCD7: '9285903',
  UCD13: '3400892859033',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE MYL 10MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2184613',
  CIP13: '3400921846133',
  ucdLib: "PRAVASTATINE MYL 20MG CPR",
  UCD7: '9285926',
  UCD13: '3400892859262',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE MYL 20MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2184642',
  CIP13: '3400921846423',
  ucdLib: "PRAVASTATINE MYL 20MG CPR",
  UCD7: '9285926',
  UCD13: '3400892859262',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE MYL 20MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2184665',
  CIP13: '3400921846652',
  ucdLib: "PRAVASTATINE MYL 40MG CPR",
  UCD7: '9285932',
  UCD13: '3400892859323',
  ucdQtyMultiplicator: 28,
  cipLib: "PRAVASTATINE MYL 40MG CPR BT 28",
  atcCode: "C10AA03"
}, {
  CIP7: '2184688',
  CIP13: '3400921846881',
  ucdLib: "PRAVASTATINE MYL 40MG CPR",
  UCD7: '9285932',
  UCD13: '3400892859323',
  ucdQtyMultiplicator: 84,
  cipLib: "PRAVASTATINE MYL 40MG CPR BT 84",
  atcCode: "C10AA03"
}, {
  CIP7: '2182413',
  CIP13: '3400921824131',
  ucdLib: "PRAVASTATINE SDZ 20MG CPR",
  UCD7: '9330590',
  UCD13: '3400893305904',
  ucdQtyMultiplicator: 90,
  cipLib: "PRAVASTATINE SDZ 20MG CPR BT 90",
  atcCode: "C10AA03"
}, {
  CIP7: '2182436',
  CIP13: '3400921824360',
  ucdLib: "PRAVASTATINE SDZ 40MG CPR",
  UCD7: '9330609',
  UCD13: '3400893306093',
  ucdQtyMultiplicator: 90,
  cipLib: "PRAVASTATINE SDZ 40MG CPR BT 90",
  atcCode: "C10AA03"
}, {
  CIP7: '5675808',
  CIP13: '3400956758081',
  ucdLib: "PRAVASTATINE ARG 20MG CPR",
  UCD7: '9282000',
  UCD13: '3400892820002',
  ucdQtyMultiplicator: 50,
  cipLib: "PRAVASTATINE ARG 20MG CPR BT 50",
  atcCode: "C10AA03"
}, {
  CIP7: '3839281',
  CIP13: '3400938392814',
  ucdLib: "SIMVASTATINE SDZ 20MG CPR",
  UCD7: '9272088',
  UCD13: '3400892720883',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE SDZ 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3839329',
  CIP13: '3400938393293',
  ucdLib: "SIMVASTATINE SDZ 40MG CPR",
  UCD7: '9272094',
  UCD13: '3400892720944',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE SDZ 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3611069',
  CIP13: '3400936110694',
  ucdLib: "ZOCOR 40MG CPR",
  UCD7: '9235029',
  UCD13: '3400892350295',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOCOR 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3004187',
  CIP13: '3400930041871',
  ucdLib: "SIMVASTATINE BGA 20MG CPR",
  UCD7: '9336090',
  UCD13: '3400893360903',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE BGA 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3688557',
  CIP13: '3400936885578',
  ucdLib: "SIMVASTATINE ALT 20MG CPR",
  UCD7: '9314160',
  UCD13: '3400893141601',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ALT 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3680024',
  CIP13: '3400936800243',
  ucdLib: "SIMVASTATINE MYL 40MG CPR",
  UCD7: '9272059',
  UCD13: '3400892720593',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE MYL 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3678464',
  CIP13: '3400936784642',
  ucdLib: "SIMVASTATINE BCR 20MG CPR",
  UCD7: '9271232',
  UCD13: '3400892712321',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE BCR 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3670959',
  CIP13: '3400936709591',
  ucdLib: "SIMVASTATINE CRT 20MG CPR",
  UCD7: '9283809',
  UCD13: '3400892838090',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE CRT 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3670971',
  CIP13: '3400936709713',
  ucdLib: "SIMVASTATINE CRT 40MG CPR",
  UCD7: '9283815',
  UCD13: '3400892838151',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE CRT 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3678659',
  CIP13: '3400936786592',
  ucdLib: "SIMVASTATINE MYL 20MG CPR",
  UCD7: '9272042',
  UCD13: '3400892720425',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE MYL 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3670215',
  CIP13: '3400936702158',
  ucdLib: "SIMVASTATINE TVC 10MG CPR",
  UCD7: '9274147',
  UCD13: '3400892741475',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE TVC 10MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3670250',
  CIP13: '3400936702509',
  ucdLib: "SIMVASTATINE TVC 20MG CPR",
  UCD7: '9272504',
  UCD13: '3400892725048',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE TVC 20MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3670304',
  CIP13: '3400936703049',
  ucdLib: "SIMVASTATINE TVC 40MG CPR",
  UCD7: '9272510',
  UCD13: '3400892725109',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE TVC 40MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3678607',
  CIP13: '3400936786073',
  ucdLib: "SIMVASTATINE ZEN 10MG CPR",
  UCD7: '9279802',
  UCD13: '3400892798028',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ZEN 10MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3678553',
  CIP13: '3400936785533',
  ucdLib: "SIMVASTATINE ZEN 20MG CPR",
  UCD7: '9271947',
  UCD13: '3400892719474',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ZEN 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3678636',
  CIP13: '3400936786363',
  ucdLib: "SIMVASTATINE ZEN 40MG CPR",
  UCD7: '9271953',
  UCD13: '3400892719535',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ZEN 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3676689',
  CIP13: '3400936766891',
  ucdLib: "ZOCOR 20MG CPR",
  UCD7: '9136675',
  UCD13: '3400891366754',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOCOR 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3855498',
  CIP13: '3400938554984',
  ucdLib: "SIMVASTATINE ALM 20MG CPR",
  UCD7: '9284766',
  UCD13: '3400892847665',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE ALM 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3855506',
  CIP13: '3400938555066',
  ucdLib: "SIMVASTATINE ALM 40MG CPR",
  UCD7: '9284772',
  UCD13: '3400892847726',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE ALM 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3855854',
  CIP13: '3400938558548',
  ucdLib: "SIMVASTATINE ISD 20MG CPR",
  UCD7: '9310357',
  UCD13: '3400893103579',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE ISD 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3855908',
  CIP13: '3400938559088',
  ucdLib: "SIMVASTATINE ISD 40MG CPR",
  UCD7: '9297071',
  UCD13: '3400892970714',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE ISD 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3729026',
  CIP13: '3400937290265',
  ucdLib: "SIMVASTATINE TVC 20MG CPR",
  UCD7: '9272504',
  UCD13: '3400892725048',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE TVC 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3729049',
  CIP13: '3400937290494',
  ucdLib: "SIMVASTATINE TVC 40MG CPR",
  UCD7: '9272510',
  UCD13: '3400892725109',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE TVC 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3712965',
  CIP13: '3400937129657',
  ucdLib: "SIMVASTATINE ALM 20MG CPR",
  UCD7: '9284766',
  UCD13: '3400892847665',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ALM 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3713120',
  CIP13: '3400937131209',
  ucdLib: "SIMVASTATINE ALM 40MG CPR",
  UCD7: '9284772',
  UCD13: '3400892847726',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ALM 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3771726',
  CIP13: '3400937717267',
  ucdLib: "SIMVASTATINE BCR 20MG CPR",
  UCD7: '9271232',
  UCD13: '3400892712321',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE BCR 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3771732',
  CIP13: '3400937717328',
  ucdLib: "SIMVASTATINE BCR 40MG CPR",
  UCD7: '9271249',
  UCD13: '3400892712499',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE BCR 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3777002',
  CIP13: '3400937770026',
  ucdLib: "SIMVASTATINE BGA 10MG CPR",
  UCD7: '9360533',
  UCD13: '3400893605332',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE BGA 10MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3774216',
  CIP13: '3400937742160',
  ucdLib: "SIMVASTATINE EG 40MG CPR",
  UCD7: '9289700',
  UCD13: '3400892897004',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE EG 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3647972',
  CIP13: '3400936479722',
  ucdLib: "SIMVASTATINE ISD 20MG CPR",
  UCD7: '9310357',
  UCD13: '3400893103579',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ISD 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3773197',
  CIP13: '3400937731973',
  ucdLib: "SIMVASTATINE ISD 40MG CPR",
  UCD7: '9297071',
  UCD13: '3400892970714',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ISD 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3719849',
  CIP13: '3400937198493',
  ucdLib: "SIMVASTATINE MYL 20MG CPR",
  UCD7: '9272042',
  UCD13: '3400892720425',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE MYL 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3719795',
  CIP13: '3400937197953',
  ucdLib: "SIMVASTATINE MYL 40MG CPR",
  UCD7: '9272059',
  UCD13: '3400892720593',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE MYL 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3645996',
  CIP13: '3400936459960',
  ucdLib: "SIMVASTATINE RTP 20MG CPR",
  UCD7: '9266828',
  UCD13: '3400892668284',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE RTP 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3715490',
  CIP13: '3400937154901',
  ucdLib: "SIMVASTATINE RTP 20MG CPR",
  UCD7: '9266828',
  UCD13: '3400892668284',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE RTP 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3647363',
  CIP13: '3400936473638',
  ucdLib: "SIMVASTATINE RTP 40MG CPR",
  UCD7: '9266834',
  UCD13: '3400892668345',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE RTP 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3715515',
  CIP13: '3400937155151',
  ucdLib: "SIMVASTATINE RTP 40MG CPR",
  UCD7: '9266834',
  UCD13: '3400892668345',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE RTP 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3788431',
  CIP13: '3400937884310',
  ucdLib: "SIMVASTATINE SDZ 10MG CPR",
  UCD7: '9301542',
  UCD13: '3400893015421',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE SDZ 10MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3788945',
  CIP13: '3400937889452',
  ucdLib: "SIMVASTATINE SDZ 20MG CPR",
  UCD7: '9272088',
  UCD13: '3400892720883',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE SDZ 20MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3789005',
  CIP13: '3400937890052',
  ucdLib: "SIMVASTATINE SDZ 40MG CPR",
  UCD7: '9272094',
  UCD13: '3400892720944',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE SDZ 40MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3715432',
  CIP13: '3400937154321',
  ucdLib: "SIMVASTATINE ZEN 20MG CPR",
  UCD7: '9271947',
  UCD13: '3400892719474',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE ZEN 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3719915',
  CIP13: '3400937199155',
  ucdLib: "SIMVASTATINE ZEN 40MG CPR",
  UCD7: '9271953',
  UCD13: '3400892719535',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE ZEN 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3776238',
  CIP13: '3400937762380',
  ucdLib: "ZOCOR 20MG CPR",
  UCD7: '9136675',
  UCD13: '3400891366754',
  ucdQtyMultiplicator: 84,
  cipLib: "ZOCOR 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3776250',
  CIP13: '3400937762502',
  ucdLib: "ZOCOR 40MG CPR",
  UCD7: '9235029',
  UCD13: '3400892350295',
  ucdQtyMultiplicator: 84,
  cipLib: "ZOCOR 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3886464',
  CIP13: '3400938864649',
  ucdLib: "SIMVASTATINE AHL 10MG CPR",
  UCD7: '9325560',
  UCD13: '3400893255605',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE AHL 10MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3886553',
  CIP13: '3400938865530',
  ucdLib: "SIMVASTATINE AHL 20MG CPR",
  UCD7: '9325577',
  UCD13: '3400893255773',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE AHL 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3886607',
  CIP13: '3400938866070',
  ucdLib: "SIMVASTATINE AHL 20MG CPR",
  UCD7: '9325577',
  UCD13: '3400893255773',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE AHL 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3886665',
  CIP13: '3400938866650',
  ucdLib: "SIMVASTATINE AHL 40MG CPR",
  UCD7: '9325583',
  UCD13: '3400893255834',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE AHL 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3886702',
  CIP13: '3400938867022',
  ucdLib: "SIMVASTATINE AHL 40MG CPR",
  UCD7: '9325583',
  UCD13: '3400893255834',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE AHL 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3883342',
  CIP13: '3400938833423',
  ucdLib: "SIMVASTATINE ARL 10MG CPR",
  UCD7: '9325608',
  UCD13: '3400893256084',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE ARL 10MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3883425',
  CIP13: '3400938834253',
  ucdLib: "SIMVASTATINE ARL 20MG CPR",
  UCD7: '9325614',
  UCD13: '3400893256145',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ARL 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3883448',
  CIP13: '3400938834482',
  ucdLib: "SIMVASTATINE ARL 20MG CPR",
  UCD7: '9325614',
  UCD13: '3400893256145',
  ucdQtyMultiplicator: 50,
  cipLib: "SIMVASTATINE ARL 20MG CPR BT 50",
  atcCode: "C10AA01"
}, {
  CIP7: '3883460',
  CIP13: '3400938834604',
  ucdLib: "SIMVASTATINE ARL 20MG CPR",
  UCD7: '9325614',
  UCD13: '3400893256145',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE ARL 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3883520',
  CIP13: '3400938835205',
  ucdLib: "SIMVASTATINE ARL 40MG CPR",
  UCD7: '9325620',
  UCD13: '3400893256206',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE ARL 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3883543',
  CIP13: '3400938835434',
  ucdLib: "SIMVASTATINE ARL 40MG CPR",
  UCD7: '9325620',
  UCD13: '3400893256206',
  ucdQtyMultiplicator: 50,
  cipLib: "SIMVASTATINE ARL 40MG CPR BT 50",
  atcCode: "C10AA01"
}, {
  CIP7: '3883572',
  CIP13: '3400938835724',
  ucdLib: "SIMVASTATINE ARL 40MG CPR",
  UCD7: '9325620',
  UCD13: '3400893256206',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE ARL 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3739941',
  CIP13: '3400937399418',
  ucdLib: "SIMVASTATINE BCR 10MG CPR",
  UCD7: '9284996',
  UCD13: '3400892849966',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE BCR 10MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3805537',
  CIP13: '3400938055375',
  ucdLib: "SIMVASTATINE BGA 40MG CPR",
  UCD7: '9308610',
  UCD13: '3400893086100',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE BGA 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3805566',
  CIP13: '3400938055665',
  ucdLib: "SIMVASTATINE BGA 40MG CPR",
  UCD7: '9308610',
  UCD13: '3400893086100',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE BGA 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3736693',
  CIP13: '3400937366939',
  ucdLib: "SIMVASTATINE CRT 20MG CPR",
  UCD7: '9283809',
  UCD13: '3400892838090',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE CRT 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3736670',
  CIP13: '3400937366700',
  ucdLib: "SIMVASTATINE CRT 40MG CPR",
  UCD7: '9283815',
  UCD13: '3400892838151',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE CRT 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '3739154',
  CIP13: '3400937391542',
  ucdLib: "SIMVASTATINE EG 20MG CPR",
  UCD7: '9271930',
  UCD13: '3400892719306',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE EG 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3887825',
  CIP13: '3400938878257',
  ucdLib: "SIMVASTATINE GRD 20MG CPR",
  UCD7: '9362265',
  UCD13: '3400893622650',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE GRD 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3887995',
  CIP13: '3400938879957',
  ucdLib: "SIMVASTATINE GRD 40MG CPR",
  UCD7: '9328156',
  UCD13: '3400893281567',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE GRD 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3800238',
  CIP13: '3400938002386',
  ucdLib: "SIMVASTATINE MYL 10MG CPR",
  UCD7: '9306309',
  UCD13: '3400893063095',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE MYL 10MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3905492',
  CIP13: '3400939054926',
  ucdLib: "SIMVASTATINE EG 10MG CPR",
  UCD7: '9294233',
  UCD13: '3400892942339',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE EG 10MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3844164',
  CIP13: '3400938441642',
  ucdLib: "SIMVASTATINE EG 20MG CPR",
  UCD7: '9271930',
  UCD13: '3400892719306',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE EG 20MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3844158',
  CIP13: '3400938441581',
  ucdLib: "SIMVASTATINE EG 40MG CPR",
  UCD7: '9289700',
  UCD13: '3400892897004',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE EG 40MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3845376',
  CIP13: '3400938453768',
  ucdLib: "SIMVASTATINE RPG 10MG CPR",
  UCD7: '9321220',
  UCD13: '3400893212202',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE RPG 10MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3845465',
  CIP13: '3400938454659',
  ucdLib: "SIMVASTATINE RPG 20MG CPR",
  UCD7: '9321237',
  UCD13: '3400893212370',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE RPG 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3845548',
  CIP13: '3400938455489',
  ucdLib: "SIMVASTATINE RPG 40MG CPR",
  UCD7: '9321243',
  UCD13: '3400893212431',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE RPG 40MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '5630378',
  CIP13: '3400956303786',
  ucdLib: "ZOCOR 40MG CPR",
  UCD7: '9235029',
  UCD13: '3400892350295',
  ucdQtyMultiplicator: 50,
  cipLib: "ZOCOR 40MG CPR BT 50",
  atcCode: "C10AA01"
}, {
  CIP7: '3940407',
  CIP13: '3400939404073',
  ucdLib: "SIMVASTATINE BGA 20MG CPR",
  UCD7: '9336090',
  UCD13: '3400893360903',
  ucdQtyMultiplicator: 28,
  cipLib: "SIMVASTATINE BGA 20MG CPR BT 28",
  atcCode: "C10AA01"
}, {
  CIP7: '3947390',
  CIP13: '3400939473901',
  ucdLib: "SIMVASTATINE BGA 20MG CPR",
  UCD7: '9336090',
  UCD13: '3400893360903',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE BGA 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '4191675',
  CIP13: '3400941916755',
  ucdLib: "SIMVASTATINE EVO 20MG CPR",
  UCD7: '9267897',
  UCD13: '3400892678979',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE EVO 20MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '4191681',
  CIP13: '3400941916816',
  ucdLib: "SIMVASTATINE EVO 40MG CPR",
  UCD7: '9286009',
  UCD13: '3400892860091',
  ucdQtyMultiplicator: 84,
  cipLib: "SIMVASTATINE EVO 40MG CPR BT 84",
  atcCode: "C10AA01"
}, {
  CIP7: '4940036',
  CIP13: '3400949400362',
  ucdLib: "SIMVASTATINE PHR 10MG CPR",
  UCD7: '9360303',
  UCD13: '3400893603031',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE PHR 10MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '4940102',
  CIP13: '3400949401024',
  ucdLib: "SIMVASTATINE PHR 20MG CPR",
  UCD7: '9360326',
  UCD13: '3400893603260',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE PHR 20MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '4940214',
  CIP13: '3400949402144',
  ucdLib: "SIMVASTATINE PHR 40MG CPR",
  UCD7: '9360332',
  UCD13: '3400893603321',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE PHR 40MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '4940266',
  CIP13: '3400949402663',
  ucdLib: "SIMVASTATINE PHR 40MG CPR",
  UCD7: '9360332',
  UCD13: '3400893603321',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE PHR 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '4177907',
  CIP13: '3400941779077',
  ucdLib: "SIMVASTATINE RPG 20MG CPR",
  UCD7: '9321237',
  UCD13: '3400893212370',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE RPG 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '4177913',
  CIP13: '3400941779138',
  ucdLib: "SIMVASTATINE RPG 40MG CPR",
  UCD7: '9321243',
  UCD13: '3400893212431',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE RPG 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3946775',
  CIP13: '3400939467757',
  ucdLib: "SIMVASTATINE ZYF 10MG CPR",
  UCD7: '9340625',
  UCD13: '3400893406250',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE ZYF 10MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3941683',
  CIP13: '3400939416830',
  ucdLib: "SIMVASTATINE ZYF 20MG CPR",
  UCD7: '9340631',
  UCD13: '3400893406311',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE ZYF 20MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3946829',
  CIP13: '3400939468297',
  ucdLib: "SIMVASTATINE ZYF 20MG CPR",
  UCD7: '9340631',
  UCD13: '3400893406311',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE ZYF 20MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '3944084',
  CIP13: '3400939440842',
  ucdLib: "SIMVASTATINE ZYF 40MG CPR",
  UCD7: '9340648',
  UCD13: '3400893406489',
  ucdQtyMultiplicator: 90,
  cipLib: "SIMVASTATINE ZYF 40MG CPR BT 90",
  atcCode: "C10AA01"
}, {
  CIP7: '3946812',
  CIP13: '3400939468129',
  ucdLib: "SIMVASTATINE ZYF 40MG CPR",
  UCD7: '9340648',
  UCD13: '3400893406489',
  ucdQtyMultiplicator: 30,
  cipLib: "SIMVASTATINE ZYF 40MG CPR BT 30",
  atcCode: "C10AA01"
}, {
  CIP7: '5663923',
  CIP13: '3400956639236',
  ucdLib: "ZOCOR 20MG CPR",
  UCD7: '9136675',
  UCD13: '3400891366754',
  ucdQtyMultiplicator: 50,
  cipLib: "ZOCOR 20MG CPR BT 50",
  atcCode: "C10AA01"
}, {
  CIP7: '3921516',
  CIP13: '3400939215167',
  ucdLib: "RASILEZ HCT 150/12,5MG CPR",
  UCD7: '9339007',
  UCD13: '3400893390078',
  ucdQtyMultiplicator: 30,
  cipLib: "RASILEZ HCT 150/12,5MG CPR BT 30",
  atcCode: "C09XA52"
}, {
  CIP7: '3921539',
  CIP13: '3400939215396',
  ucdLib: "RASILEZ HCT 300/12,5MG CPR",
  UCD7: '9339036',
  UCD13: '3400893390368',
  ucdQtyMultiplicator: 30,
  cipLib: "RASILEZ HCT 300/12,5MG CPR BT 30",
  atcCode: "C09XA52"
}, {
  CIP7: '3921545',
  CIP13: '3400939215457',
  ucdLib: "RASILEZ HCT 300/25MG CPR",
  UCD7: '9339042',
  UCD13: '3400893390429',
  ucdQtyMultiplicator: 30,
  cipLib: "RASILEZ HCT 300/25MG CPR BT 30",
  atcCode: "C09XA52"
}, {
  CIP7: '5745377',
  CIP13: '3400957453770',
  ucdLib: "RASILEZ HCT 150/12,5MG CPR",
  UCD7: '9339007',
  UCD13: '3400893390078',
  ucdQtyMultiplicator: 56,
  cipLib: "RASILEZ HCT 150/12,5MG CPR BT 56",
  atcCode: "C09XA52"
}, {
  CIP7: '5745420',
  CIP13: '3400957454203',
  ucdLib: "RASILEZ HCT 300/12,5MG CPR",
  UCD7: '9339036',
  UCD13: '3400893390368',
  ucdQtyMultiplicator: 56,
  cipLib: "RASILEZ HCT 300/12,5MG CPR BT 56",
  atcCode: "C09XA52"
}, {
  CIP7: '5745443',
  CIP13: '3400957454432',
  ucdLib: "RASILEZ HCT 300/25MG CPR",
  UCD7: '9339042',
  UCD13: '3400893390429',
  ucdQtyMultiplicator: 56,
  cipLib: "RASILEZ HCT 300/25MG CPR BT 56",
  atcCode: "C09XA52"
}, {
  CIP7: '3990084',
  CIP13: '3400939900841',
  ucdLib: "RASILEZ 150MG CPR",
  UCD7: '9314355',
  UCD13: '3400893143551',
  ucdQtyMultiplicator: 30,
  cipLib: "RASILEZ 150MG CPR BT 30",
  atcCode: "C09XA02"
}, {
  CIP7: '3990090',
  CIP13: '3400939900902',
  ucdLib: "RASILEZ 300MG CPR",
  UCD7: '9314361',
  UCD13: '3400893143612',
  ucdQtyMultiplicator: 30,
  cipLib: "RASILEZ 300MG CPR BT 30",
  atcCode: "C09XA02"
}, {
  CIP7: '5764400',
  CIP13: '3400957644000',
  ucdLib: "RASILEZ 150MG CPR",
  UCD7: '9314355',
  UCD13: '3400893143551',
  ucdQtyMultiplicator: 56,
  cipLib: "RASILEZ 150MG CPR BT 56",
  atcCode: "C09XA02"
}, {
  CIP7: '5764417',
  CIP13: '3400957644178',
  ucdLib: "RASILEZ 300MG CPR",
  UCD7: '9314361',
  UCD13: '3400893143612',
  ucdQtyMultiplicator: 56,
  cipLib: "RASILEZ 300MG CPR BT 56",
  atcCode: "C09XA02"
}, {
  CIP7: '3003790',
  CIP13: '3400930037904',
  ucdLib: "ENTRESTO 24MG/26MG CPR",
  UCD7: '9412773',
  UCD13: '3400894127734',
  ucdQtyMultiplicator: 28,
  cipLib: "ENTRESTO 24MG/26MG CPR BT 28",
  atcCode: "C09DX04"
}, {
  CIP7: '3003791',
  CIP13: '3400930037911',
  ucdLib: "ENTRESTO 49MG/51MG CPR",
  UCD7: '9412796',
  UCD13: '3400894127963',
  ucdQtyMultiplicator: 56,
  cipLib: "ENTRESTO 49MG/51MG CPR BT 56",
  atcCode: "C09DX04"
}, {
  CIP7: '3003792',
  CIP13: '3400930037928',
  ucdLib: "ENTRESTO 97MG/103MG CPR",
  UCD7: '9412804',
  UCD13: '3400894128045',
  ucdQtyMultiplicator: 56,
  cipLib: "ENTRESTO 97MG/103MG CPR BT 56",
  atcCode: "C09DX04"
}, {
  CIP7: '3973306',
  CIP13: '3400939733067',
  ucdLib: "EXFORGE HCT 10/160/12,5MG C.",
  UCD7: '9350782',
  UCD13: '3400893507827',
  ucdQtyMultiplicator: 30,
  cipLib: "EXFORGE HCT 10/160/12,5MG C. BT 30",
  atcCode: "C09DX01"
}, {
  CIP7: '3973364',
  CIP13: '3400939733647',
  ucdLib: "EXFORGE HCT 10/160/25MG CPR",
  UCD7: '9350799',
  UCD13: '3400893507995',
  ucdQtyMultiplicator: 30,
  cipLib: "EXFORGE HCT 10/160/25MG CPR BT 30",
  atcCode: "C09DX01"
}, {
  CIP7: '3973275',
  CIP13: '3400939732756',
  ucdLib: "EXFORGE HCT 5/160/12,5MG CPR",
  UCD7: '9350807',
  UCD13: '3400893508077',
  ucdQtyMultiplicator: 30,
  cipLib: "EXFORGE HCT 5/160/12,5MG CPR BT 30",
  atcCode: "C09DX01"
}, {
  CIP7: '3973335',
  CIP13: '3400939733357',
  ucdLib: "EXFORGE HCT 5/160/25MG CPR",
  UCD7: '9350813',
  UCD13: '3400893508138',
  ucdQtyMultiplicator: 30,
  cipLib: "EXFORGE HCT 5/160/25MG CPR BT 30",
  atcCode: "C09DX01"
}, {
  CIP7: '4946524',
  CIP13: '3400949465248',
  ucdLib: "TWYNSTA 40MG/10MG CPR",
  UCD7: '9365565',
  UCD13: '3400893655658',
  ucdQtyMultiplicator: 30,
  cipLib: "TWYNSTA 40MG/10MG CPR BT 30",
  atcCode: "C09DB04"
}, {
  CIP7: '4946530',
  CIP13: '3400949465309',
  ucdLib: "TWYNSTA 40MG/10MG CPR",
  UCD7: '9365565',
  UCD13: '3400893655658',
  ucdQtyMultiplicator: 90,
  cipLib: "TWYNSTA 40MG/10MG CPR BT 90",
  atcCode: "C09DB04"
}, {
  CIP7: '4946470',
  CIP13: '3400949464708',
  ucdLib: "TWYNSTA 40MG/5MG CPR D.U",
  UCD7: '9365571',
  UCD13: '3400893655719',
  ucdQtyMultiplicator: 30,
  cipLib: "TWYNSTA 40MG/5MG CPR D.U BT 30",
  atcCode: "C09DB04"
}, {
  CIP7: '4946493',
  CIP13: '3400949464937',
  ucdLib: "TWYNSTA 40MG/5MG CPR D.U",
  UCD7: '9365571',
  UCD13: '3400893655719',
  ucdQtyMultiplicator: 90,
  cipLib: "TWYNSTA 40MG/5MG CPR D.U BT 90",
  atcCode: "C09DB04"
}, {
  CIP7: '4946576',
  CIP13: '3400949465767',
  ucdLib: "TWYNSTA 80MG/10MG CPR",
  UCD7: '9365588',
  UCD13: '3400893655887',
  ucdQtyMultiplicator: 30,
  cipLib: "TWYNSTA 80MG/10MG CPR BT 30",
  atcCode: "C09DB04"
}, {
  CIP7: '4946582',
  CIP13: '3400949465828',
  ucdLib: "TWYNSTA 80MG/10MG CPR",
  UCD7: '9365588',
  UCD13: '3400893655887',
  ucdQtyMultiplicator: 90,
  cipLib: "TWYNSTA 80MG/10MG CPR BT 90",
  atcCode: "C09DB04"
}, {
  CIP7: '4946547',
  CIP13: '3400949465477',
  ucdLib: "TWYNSTA 80MG/5MG CPR",
  UCD7: '9365594',
  UCD13: '3400893655948',
  ucdQtyMultiplicator: 30,
  cipLib: "TWYNSTA 80MG/5MG CPR BT 30",
  atcCode: "C09DB04"
}, {
  CIP7: '4946553',
  CIP13: '3400949465538',
  ucdLib: "TWYNSTA 80MG/5MG CPR",
  UCD7: '9365594',
  UCD13: '3400893655948',
  ucdQtyMultiplicator: 90,
  cipLib: "TWYNSTA 80MG/5MG CPR BT 90",
  atcCode: "C09DB04"
}, {
  CIP7: '3885387',
  CIP13: '3400938853872',
  ucdLib: "AXELER 20MG/5MG CPR",
  UCD7: '9327240',
  UCD13: '3400893272404',
  ucdQtyMultiplicator: 30,
  cipLib: "AXELER 20MG/5MG CPR BT 30",
  atcCode: "C09DB02"
}, {
  CIP7: '3885401',
  CIP13: '3400938854015',
  ucdLib: "AXELER 20MG/5MG CPR",
  UCD7: '9327240',
  UCD13: '3400893272404',
  ucdQtyMultiplicator: 90,
  cipLib: "AXELER 20MG/5MG CPR BT 90",
  atcCode: "C09DB02"
}, {
  CIP7: '3885418',
  CIP13: '3400938854183',
  ucdLib: "AXELER 40MG/10MG CPR",
  UCD7: '9327257',
  UCD13: '3400893272572',
  ucdQtyMultiplicator: 30,
  cipLib: "AXELER 40MG/10MG CPR BT 30",
  atcCode: "C09DB02"
}, {
  CIP7: '3885430',
  CIP13: '3400938854305',
  ucdLib: "AXELER 40MG/10MG CPR",
  UCD7: '9327257',
  UCD13: '3400893272572',
  ucdQtyMultiplicator: 90,
  cipLib: "AXELER 40MG/10MG CPR BT 90",
  atcCode: "C09DB02"
}, {
  CIP7: '3885447',
  CIP13: '3400938854473',
  ucdLib: "AXELER 40MG/5MG CPR",
  UCD7: '9327263',
  UCD13: '3400893272633',
  ucdQtyMultiplicator: 30,
  cipLib: "AXELER 40MG/5MG CPR BT 30",
  atcCode: "C09DB02"
}, {
  CIP7: '3885476',
  CIP13: '3400938854763',
  ucdLib: "AXELER 40MG/5MG CPR",
  UCD7: '9327263',
  UCD13: '3400893272633',
  ucdQtyMultiplicator: 90,
  cipLib: "AXELER 40MG/5MG CPR BT 90",
  atcCode: "C09DB02"
}, {
  CIP7: '3885826',
  CIP13: '3400938858266',
  ucdLib: "SEVIKAR 20MG/5MG CPR",
  UCD7: '9328328',
  UCD13: '3400893283288',
  ucdQtyMultiplicator: 30,
  cipLib: "SEVIKAR 20MG/5MG CPR BT 30",
  atcCode: "C09DB02"
}, {
  CIP7: '3885849',
  CIP13: '3400938858495',
  ucdLib: "SEVIKAR 20MG/5MG CPR",
  UCD7: '9328328',
  UCD13: '3400893283288',
  ucdQtyMultiplicator: 90,
  cipLib: "SEVIKAR 20MG/5MG CPR BT 90",
  atcCode: "C09DB02"
}, {
  CIP7: '3885743',
  CIP13: '3400938857436',
  ucdLib: "SEVIKAR 40MG/10MG CPR",
  UCD7: '9328334',
  UCD13: '3400893283349',
  ucdQtyMultiplicator: 30,
  cipLib: "SEVIKAR 40MG/10MG CPR BT 30",
  atcCode: "C09DB02"
}, {
  CIP7: '3885772',
  CIP13: '3400938857726',
  ucdLib: "SEVIKAR 40MG/10MG CPR",
  UCD7: '9328334',
  UCD13: '3400893283349',
  ucdQtyMultiplicator: 90,
  cipLib: "SEVIKAR 40MG/10MG CPR BT 90",
  atcCode: "C09DB02"
}, {
  CIP7: '3885789',
  CIP13: '3400938857894',
  ucdLib: "SEVIKAR 40MG/5MG CPR",
  UCD7: '9328340',
  UCD13: '3400893283400',
  ucdQtyMultiplicator: 30,
  cipLib: "SEVIKAR 40MG/5MG CPR BT 30",
  atcCode: "C09DB02"
}, {
  CIP7: '3885803',
  CIP13: '3400938858037',
  ucdLib: "SEVIKAR 40MG/5MG CPR",
  UCD7: '9328340',
  UCD13: '3400893283400',
  ucdQtyMultiplicator: 90,
  cipLib: "SEVIKAR 40MG/5MG CPR BT 90",
  atcCode: "C09DB02"
}, {
  CIP7: '3781819',
  CIP13: '3400937818193',
  ucdLib: "EXFORGE 10MG/160MG CPR",
  UCD7: '9295818',
  UCD13: '3400892958187',
  ucdQtyMultiplicator: 30,
  cipLib: "EXFORGE 10MG/160MG CPR BT 30",
  atcCode: "C09DB01"
}, {
  CIP7: '3781831',
  CIP13: '3400937818315',
  ucdLib: "EXFORGE 10MG/160MG CPR",
  UCD7: '9295818',
  UCD13: '3400892958187',
  ucdQtyMultiplicator: 90,
  cipLib: "EXFORGE 10MG/160MG CPR BT 90",
  atcCode: "C09DB01"
}, {
  CIP7: '3820442',
  CIP13: '3400938204421',
  ucdLib: "EXFORGE 10MG/160MG CPR",
  UCD7: '9295818',
  UCD13: '3400892958187',
  ucdQtyMultiplicator: 56,
  cipLib: "EXFORGE 10MG/160MG CPR BT 56",
  atcCode: "C09DB01"
}, {
  CIP7: '3781788',
  CIP13: '3400937817882',
  ucdLib: "EXFORGE 5MG/160MG CPR",
  UCD7: '9295824',
  UCD13: '3400892958248',
  ucdQtyMultiplicator: 30,
  cipLib: "EXFORGE 5MG/160MG CPR BT 30",
  atcCode: "C09DB01"
}, {
  CIP7: '3781802',
  CIP13: '3400937818025',
  ucdLib: "EXFORGE 5MG/160MG CPR",
  UCD7: '9295824',
  UCD13: '3400892958248',
  ucdQtyMultiplicator: 90,
  cipLib: "EXFORGE 5MG/160MG CPR BT 90",
  atcCode: "C09DB01"
}, {
  CIP7: '3820436',
  CIP13: '3400938204360',
  ucdLib: "EXFORGE 5MG/160MG CPR",
  UCD7: '9295824',
  UCD13: '3400892958248',
  ucdQtyMultiplicator: 56,
  cipLib: "EXFORGE 5MG/160MG CPR BT 56",
  atcCode: "C09DB01"
}, {
  CIP7: '3781759',
  CIP13: '3400937817592',
  ucdLib: "EXFORGE 5MG/80MG CPR",
  UCD7: '9295830',
  UCD13: '3400892958309',
  ucdQtyMultiplicator: 30,
  cipLib: "EXFORGE 5MG/80MG CPR BT 30",
  atcCode: "C09DB01"
}, {
  CIP7: '3781771',
  CIP13: '3400937817714',
  ucdLib: "EXFORGE 5MG/80MG CPR",
  UCD7: '9295830',
  UCD13: '3400892958309',
  ucdQtyMultiplicator: 90,
  cipLib: "EXFORGE 5MG/80MG CPR BT 90",
  atcCode: "C09DB01"
}, {
  CIP7: '3820413',
  CIP13: '3400938204131',
  ucdLib: "EXFORGE 5MG/80MG CPR",
  UCD7: '9295830',
  UCD13: '3400892958309',
  ucdQtyMultiplicator: 56,
  cipLib: "EXFORGE 5MG/80MG CPR BT 56",
  atcCode: "C09DB01"
}, {
  CIP7: '3722194',
  CIP13: '3400937221948',
  ucdLib: "ALTEISDUO 20MG/12,5MG CPR",
  UCD7: '9286587',
  UCD13: '3400892865874',
  ucdQtyMultiplicator: 30,
  cipLib: "ALTEISDUO 20MG/12,5MG CPR BT 30",
  atcCode: "C09DA08"
}, {
  CIP7: '3722202',
  CIP13: '3400937222020',
  ucdLib: "ALTEISDUO 20MG/12,5MG CPR",
  UCD7: '9286587',
  UCD13: '3400892865874',
  ucdQtyMultiplicator: 90,
  cipLib: "ALTEISDUO 20MG/12,5MG CPR BT 90",
  atcCode: "C09DA08"
}, {
  CIP7: '3722219',
  CIP13: '3400937222198',
  ucdLib: "ALTEISDUO 20MG/25MG CPR",
  UCD7: '9286593',
  UCD13: '3400892865935',
  ucdQtyMultiplicator: 30,
  cipLib: "ALTEISDUO 20MG/25MG CPR BT 30",
  atcCode: "C09DA08"
}, {
  CIP7: '3722225',
  CIP13: '3400937222259',
  ucdLib: "ALTEISDUO 20MG/25MG CPR",
  UCD7: '9286593',
  UCD13: '3400892865935',
  ucdQtyMultiplicator: 90,
  cipLib: "ALTEISDUO 20MG/25MG CPR BT 90",
  atcCode: "C09DA08"
}, {
  CIP7: '3722107',
  CIP13: '3400937221078',
  ucdLib: "COOLMETEC 20MG/12,5MG CPR",
  UCD7: '9285033',
  UCD13: '3400892850337',
  ucdQtyMultiplicator: 30,
  cipLib: "COOLMETEC 20MG/12,5MG CPR BT 30",
  atcCode: "C09DA08"
}, {
  CIP7: '3722113',
  CIP13: '3400937221139',
  ucdLib: "COOLMETEC 20MG/12,5MG CPR",
  UCD7: '9285033',
  UCD13: '3400892850337',
  ucdQtyMultiplicator: 90,
  cipLib: "COOLMETEC 20MG/12,5MG CPR BT 90",
  atcCode: "C09DA08"
}, {
  CIP7: '3722136',
  CIP13: '3400937221368',
  ucdLib: "COOLMETEC 20MG/25MG CPR",
  UCD7: '9285056',
  UCD13: '3400892850566',
  ucdQtyMultiplicator: 30,
  cipLib: "COOLMETEC 20MG/25MG CPR BT 30",
  atcCode: "C09DA08"
}, {
  CIP7: '3722142',
  CIP13: '3400937221429',
  ucdLib: "COOLMETEC 20MG/25MG CPR",
  UCD7: '9285056',
  UCD13: '3400892850566',
  ucdQtyMultiplicator: 90,
  cipLib: "COOLMETEC 20MG/25MG CPR BT 90",
  atcCode: "C09DA08"
}, {
  CIP7: '3502386',
  CIP13: '3400935023865',
  ucdLib: "ALTEISDUO 40MG/12,5MG CPR",
  UCD7: '9350463',
  UCD13: '3400893504635',
  ucdQtyMultiplicator: 30,
  cipLib: "ALTEISDUO 40MG/12,5MG CPR BT 30",
  atcCode: "C09DA08"
}, {
  CIP7: '3502392',
  CIP13: '3400935023926',
  ucdLib: "ALTEISDUO 40MG/12,5MG CPR",
  UCD7: '9350463',
  UCD13: '3400893504635',
  ucdQtyMultiplicator: 90,
  cipLib: "ALTEISDUO 40MG/12,5MG CPR BT 90",
  atcCode: "C09DA08"
}, {
  CIP7: '3502423',
  CIP13: '3400935024237',
  ucdLib: "ALTEISDUO 40MG/25MG CPR",
  UCD7: '9350486',
  UCD13: '3400893504864',
  ucdQtyMultiplicator: 30,
  cipLib: "ALTEISDUO 40MG/25MG CPR BT 30",
  atcCode: "C09DA08"
}, {
  CIP7: '3502446',
  CIP13: '3400935024466',
  ucdLib: "ALTEISDUO 40MG/25MG CPR",
  UCD7: '9350486',
  UCD13: '3400893504864',
  ucdQtyMultiplicator: 90,
  cipLib: "ALTEISDUO 40MG/25MG CPR BT 90",
  atcCode: "C09DA08"
}, {
  CIP7: '3502452',
  CIP13: '3400935024527',
  ucdLib: "COOLMETEC 40MG/12,5MG CPR",
  UCD7: '9350440',
  UCD13: '3400893504406',
  ucdQtyMultiplicator: 30,
  cipLib: "COOLMETEC 40MG/12,5MG CPR BT 30",
  atcCode: "C09DA08"
}, {
  CIP7: '3502469',
  CIP13: '3400935024695',
  ucdLib: "COOLMETEC 40MG/12,5MG CPR",
  UCD7: '9350440',
  UCD13: '3400893504406',
  ucdQtyMultiplicator: 90,
  cipLib: "COOLMETEC 40MG/12,5MG CPR BT 90",
  atcCode: "C09DA08"
}, {
  CIP7: '3502475',
  CIP13: '3400935024756',
  ucdLib: "COOLMETEC 40MG/25MG CPR",
  UCD7: '9350428',
  UCD13: '3400893504284',
  ucdQtyMultiplicator: 30,
  cipLib: "COOLMETEC 40MG/25MG CPR BT 30",
  atcCode: "C09DA08"
}, {
  CIP7: '3502481',
  CIP13: '3400935024817',
  ucdLib: "COOLMETEC 40MG/25MG CPR",
  UCD7: '9350428',
  UCD13: '3400893504284',
  ucdQtyMultiplicator: 90,
  cipLib: "COOLMETEC 40MG/25MG CPR BT 90",
  atcCode: "C09DA08"
}, {
  CIP7: '3852703',
  CIP13: '3400938527032',
  ucdLib: "MICARDISPLUS 80/25MG CPR",
  UCD7: '9319588',
  UCD13: '3400893195888',
  ucdQtyMultiplicator: 30,
  cipLib: "MICARDISPLUS 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '3852732',
  CIP13: '3400938527322',
  ucdLib: "MICARDISPLUS 80/25MG CPR",
  UCD7: '9319588',
  UCD13: '3400893195888',
  ucdQtyMultiplicator: 90,
  cipLib: "MICARDISPLUS 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '3777657',
  CIP13: '3400937776578',
  ucdLib: "MICARDISPLUS 40/12,5MG CPR",
  UCD7: '9240645',
  UCD13: '3400892406459',
  ucdQtyMultiplicator: 30,
  cipLib: "MICARDISPLUS 40/12,5MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '3777663',
  CIP13: '3400937776639',
  ucdLib: "MICARDISPLUS 40/12,5MG CPR",
  UCD7: '9240645',
  UCD13: '3400892406459',
  ucdQtyMultiplicator: 90,
  cipLib: "MICARDISPLUS 40/12,5MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '3777686',
  CIP13: '3400937776868',
  ucdLib: "MICARDISPLUS 80/12,5MG CPR",
  UCD7: '9240651',
  UCD13: '3400892406510',
  ucdQtyMultiplicator: 30,
  cipLib: "MICARDISPLUS 80/12,5MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '3777692',
  CIP13: '3400937776929',
  ucdLib: "MICARDISPLUS 80/12,5MG CPR",
  UCD7: '9240651',
  UCD13: '3400892406510',
  ucdQtyMultiplicator: 90,
  cipLib: "MICARDISPLUS 80/12,5MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '3716673',
  CIP13: '3400937166737',
  ucdLib: "PRITORPLUS 40/12,5MG CPR",
  UCD7: '9239760',
  UCD13: '3400892397603',
  ucdQtyMultiplicator: 90,
  cipLib: "PRITORPLUS 40/12,5MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '3777746',
  CIP13: '3400937777469',
  ucdLib: "PRITORPLUS 40/12,5MG CPR",
  UCD7: '9239760',
  UCD13: '3400892397603',
  ucdQtyMultiplicator: 30,
  cipLib: "PRITORPLUS 40/12,5MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '3716696',
  CIP13: '3400937166966',
  ucdLib: "PRITORPLUS 80/12,5MG CPR",
  UCD7: '9239777',
  UCD13: '3400892397771',
  ucdQtyMultiplicator: 90,
  cipLib: "PRITORPLUS 80/12,5MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '3777752',
  CIP13: '3400937777520',
  ucdLib: "PRITORPLUS 80/12,5MG CPR",
  UCD7: '9239777',
  UCD13: '3400892397771',
  ucdQtyMultiplicator: 30,
  cipLib: "PRITORPLUS 80/12,5MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '3865516',
  CIP13: '3400938655162',
  ucdLib: "PRITORPLUS 80/25MG CPR",
  UCD7: '9321941',
  UCD13: '3400893219416',
  ucdQtyMultiplicator: 30,
  cipLib: "PRITORPLUS 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '3865522',
  CIP13: '3400938655223',
  ucdLib: "PRITORPLUS 80/25MG CPR",
  UCD7: '9321941',
  UCD13: '3400893219416',
  ucdQtyMultiplicator: 90,
  cipLib: "PRITORPLUS 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2753436',
  CIP13: '3400927534362',
  ucdLib: "TELMISAR/HYD.ARW 40/12,5 CPR",
  UCD7: '9396502',
  UCD13: '3400893965023',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ARW 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2753471',
  CIP13: '3400927534713',
  ucdLib: "TELMISAR/HYD.ARW 40/12,5 CPR",
  UCD7: '9396502',
  UCD13: '3400893965023',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ARW 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2753695',
  CIP13: '3400927536953',
  ucdLib: "TELMISAR/HYD.ARW 80/12,5 CPR",
  UCD7: '9396519',
  UCD13: '3400893965191',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ARW 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2753749',
  CIP13: '3400927537493',
  ucdLib: "TELMISAR/HYD.ARW 80/12,5 CPR",
  UCD7: '9396519',
  UCD13: '3400893965191',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ARW 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2753962',
  CIP13: '3400927539626',
  ucdLib: "TELMISAR/HYD.ARW 80/25MG CPR",
  UCD7: '9396525',
  UCD13: '3400893965252',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ARW 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2754016',
  CIP13: '3400927540165',
  ucdLib: "TELMISAR/HYD.ARW 80/25MG CPR",
  UCD7: '9396525',
  UCD13: '3400893965252',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ARW 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2746057',
  CIP13: '3400927460579',
  ucdLib: "TELMISAR/HYD.BGA 40/12,5 CPR",
  UCD7: '9398062',
  UCD13: '3400893980620',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.BGA 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2746100',
  CIP13: '3400927461002',
  ucdLib: "TELMISAR/HYD.BGA 40/12,5 CPR",
  UCD7: '9398062',
  UCD13: '3400893980620',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.BGA 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2746318',
  CIP13: '3400927463181',
  ucdLib: "TELMISAR/HYD.BGA 80/12,5 CPR",
  UCD7: '9398079',
  UCD13: '3400893980798',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.BGA 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2746353',
  CIP13: '3400927463532',
  ucdLib: "TELMISAR/HYD.BGA 80/12,5 CPR",
  UCD7: '9398079',
  UCD13: '3400893980798',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.BGA 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2746577',
  CIP13: '3400927465772',
  ucdLib: "TELMISAR/HYD.BGA 80/25MG CPR",
  UCD7: '9398085',
  UCD13: '3400893980859',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.BGA 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2746620',
  CIP13: '3400927466205',
  ucdLib: "TELMISAR/HYD.BGA 80/25MG CPR",
  UCD7: '9398085',
  UCD13: '3400893980859',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.BGA 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2746867',
  CIP13: '3400927468674',
  ucdLib: "TELMISAR/HYD.MYP 40/12,5 CPR",
  UCD7: '9396353',
  UCD13: '3400893963531',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.MYP 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2746910',
  CIP13: '3400927469107',
  ucdLib: "TELMISAR/HYD.MYP 40/12,5 CPR",
  UCD7: '9396353',
  UCD13: '3400893963531',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.MYP 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2747134',
  CIP13: '3400927471346',
  ucdLib: "TELMISAR/HYD.MYP 80/12,5 CPR",
  UCD7: '9396376',
  UCD13: '3400893963760',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.MYP 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2747186',
  CIP13: '3400927471865',
  ucdLib: "TELMISAR/HYD.MYP 80/12,5 CPR",
  UCD7: '9396376',
  UCD13: '3400893963760',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.MYP 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2747393',
  CIP13: '3400927473937',
  ucdLib: "TELMISAR/HYD.MYP 80/25MG CPR",
  UCD7: '9396382',
  UCD13: '3400893963821',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.MYP 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2747430',
  CIP13: '3400927474309',
  ucdLib: "TELMISAR/HYD.MYP 80/25MG CPR",
  UCD7: '9396382',
  UCD13: '3400893963821',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.MYP 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2751093',
  CIP13: '3400927510939',
  ucdLib: "TELMISAR/HYD.SDZ 40/12,5 CPR",
  UCD7: '9396324',
  UCD13: '3400893963241',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.SDZ 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2751130',
  CIP13: '3400927511301',
  ucdLib: "TELMISAR/HYD.SDZ 40/12,5 CPR",
  UCD7: '9396324',
  UCD13: '3400893963241',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.SDZ 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2752112',
  CIP13: '3400927521126',
  ucdLib: "TELMISAR/HYD.SDZ 80/12,5 CPR",
  UCD7: '9396330',
  UCD13: '3400893963302',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.SDZ 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2752158',
  CIP13: '3400927521584',
  ucdLib: "TELMISAR/HYD.SDZ 80/12,5 CPR",
  UCD7: '9396330',
  UCD13: '3400893963302',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.SDZ 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2752371',
  CIP13: '3400927523717',
  ucdLib: "TELMISAR/HYD.SDZ 80/25MG CPR",
  UCD7: '9396347',
  UCD13: '3400893963470',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.SDZ 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2752419',
  CIP13: '3400927524196',
  ucdLib: "TELMISAR/HYD.SDZ 80/25MG CPR",
  UCD7: '9396347',
  UCD13: '3400893963470',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.SDZ 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2755949',
  CIP13: '3400927559495',
  ucdLib: "TELMISAR/HYD.ZEN 40/12,5 CPR",
  UCD7: '9403811',
  UCD13: '3400894038115',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ZEN 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2755955',
  CIP13: '3400927559556',
  ucdLib: "TELMISAR/HYD.ZEN 40/12,5 CPR",
  UCD7: '9403811',
  UCD13: '3400894038115',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ZEN 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2755961',
  CIP13: '3400927559617',
  ucdLib: "TELMISAR/HYD.ZEN 80/12,5 CPR",
  UCD7: '9403828',
  UCD13: '3400894038283',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ZEN 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2755978',
  CIP13: '3400927559785',
  ucdLib: "TELMISAR/HYD.ZEN 80/12,5 CPR",
  UCD7: '9403828',
  UCD13: '3400894038283',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ZEN 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2755984',
  CIP13: '3400927559846',
  ucdLib: "TELMISAR/HYD.ZEN 80/25MG CPR",
  UCD7: '9403834',
  UCD13: '3400894038344',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ZEN 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2755990',
  CIP13: '3400927559907',
  ucdLib: "TELMISAR/HYD.ZEN 80/25MG CPR",
  UCD7: '9403834',
  UCD13: '3400894038344',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ZEN 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2747683',
  CIP13: '3400927476839',
  ucdLib: "TOLUCOMBI 40MG/12,5MG CPR",
  UCD7: '9398168',
  UCD13: '3400893981689',
  ucdQtyMultiplicator: 30,
  cipLib: "TOLUCOMBI 40MG/12,5MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2747708',
  CIP13: '3400927477089',
  ucdLib: "TOLUCOMBI 40MG/12,5MG CPR",
  UCD7: '9398168',
  UCD13: '3400893981689',
  ucdQtyMultiplicator: 90,
  cipLib: "TOLUCOMBI 40MG/12,5MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2747714',
  CIP13: '3400927477140',
  ucdLib: "TOLUCOMBI 80MG/12,5MG CPR",
  UCD7: '9398174',
  UCD13: '3400893981740',
  ucdQtyMultiplicator: 30,
  cipLib: "TOLUCOMBI 80MG/12,5MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2747737',
  CIP13: '3400927477379',
  ucdLib: "TOLUCOMBI 80MG/12,5MG CPR",
  UCD7: '9398174',
  UCD13: '3400893981740',
  ucdQtyMultiplicator: 90,
  cipLib: "TOLUCOMBI 80MG/12,5MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2747743',
  CIP13: '3400927477430',
  ucdLib: "TOLUCOMBI 80MG/25MG CPR",
  UCD7: '9398180',
  UCD13: '3400893981801',
  ucdQtyMultiplicator: 30,
  cipLib: "TOLUCOMBI 80MG/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2747766',
  CIP13: '3400927477669',
  ucdLib: "TOLUCOMBI 80MG/25MG CPR",
  UCD7: '9398180',
  UCD13: '3400893981801',
  ucdQtyMultiplicator: 90,
  cipLib: "TOLUCOMBI 80MG/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2732902',
  CIP13: '3400927329029',
  ucdLib: "TELMISAR/HYD.CRT 40/12,5 CPR",
  UCD7: '9397364',
  UCD13: '3400893973646',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.CRT 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2732948',
  CIP13: '3400927329487',
  ucdLib: "TELMISAR/HYD.CRT 40/12,5 CPR",
  UCD7: '9397364',
  UCD13: '3400893973646',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.CRT 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2733327',
  CIP13: '3400927333279',
  ucdLib: "TELMISAR/HYD.CRT 80/12,5 CPR",
  UCD7: '9397370',
  UCD13: '3400893973707',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.CRT 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2733439',
  CIP13: '3400927334399',
  ucdLib: "TELMISAR/HYD.CRT 80/12,5 CPR",
  UCD7: '9397370',
  UCD13: '3400893973707',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.CRT 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2733557',
  CIP13: '3400927335570',
  ucdLib: "TELMISAR/HYD.CRT 80/25MG CPR",
  UCD7: '9397387',
  UCD13: '3400893973875',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.CRT 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2733600',
  CIP13: '3400927336003',
  ucdLib: "TELMISAR/HYD.CRT 80/25MG CPR",
  UCD7: '9397387',
  UCD13: '3400893973875',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.CRT 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2737288',
  CIP13: '3400927372889',
  ucdLib: "TELMISAR/HYD.EG 40/12,5 CPR",
  UCD7: '9396175',
  UCD13: '3400893961759',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.EG 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2737325',
  CIP13: '3400927373251',
  ucdLib: "TELMISAR/HYD.EG 40/12,5 CPR",
  UCD7: '9396175',
  UCD13: '3400893961759',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.EG 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2737495',
  CIP13: '3400927374951',
  ucdLib: "TELMISAR/HYD.EG 80/12,5 CPR",
  UCD7: '9396181',
  UCD13: '3400893961810',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.EG 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2737549',
  CIP13: '3400927375491',
  ucdLib: "TELMISAR/HYD.EG 80/12,5 CPR",
  UCD7: '9396181',
  UCD13: '3400893961810',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.EG 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2737704',
  CIP13: '3400927377044',
  ucdLib: "TELMISAR/HYD.EG 80/25MG CPR",
  UCD7: '9396198',
  UCD13: '3400893961988',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.EG 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2737756',
  CIP13: '3400927377563',
  ucdLib: "TELMISAR/HYD.EG 80/25MG CPR",
  UCD7: '9396198',
  UCD13: '3400893961988',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.EG 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2734137',
  CIP13: '3400927341373',
  ucdLib: "TELMISAR/HYD.TVS 40/12,5 CPR",
  UCD7: '9398091',
  UCD13: '3400893980910',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.TVS 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2734189',
  CIP13: '3400927341892',
  ucdLib: "TELMISAR/HYD.TVS 40/12,5 CPR",
  UCD7: '9398091',
  UCD13: '3400893980910',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.TVS 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2734404',
  CIP13: '3400927344046',
  ucdLib: "TELMISAR/HYD.TVS 80/12,5 CPR",
  UCD7: '9398116',
  UCD13: '3400893981160',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.TVS 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2734456',
  CIP13: '3400927344565',
  ucdLib: "TELMISAR/HYD.TVS 80/12,5 CPR",
  UCD7: '9398116',
  UCD13: '3400893981160',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.TVS 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2734686',
  CIP13: '3400927346866',
  ucdLib: "TELMISAR/HYD.TVS 80/25MG CPR",
  UCD7: '9398122',
  UCD13: '3400893981221',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.TVS 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2734723',
  CIP13: '3400927347238',
  ucdLib: "TELMISAR/HYD.TVS 80/25MG CPR",
  UCD7: '9398122',
  UCD13: '3400893981221',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.TVS 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2738230',
  CIP13: '3400927382307',
  ucdLib: "TELMISAR/HYD.ZYD 40/12,5 CPR",
  UCD7: '9398139',
  UCD13: '3400893981399',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ZYD 40/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2738247',
  CIP13: '3400927382475',
  ucdLib: "TELMISAR/HYD.ZYD 40/12,5 CPR",
  UCD7: '9398139',
  UCD13: '3400893981399',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ZYD 40/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2738276',
  CIP13: '3400927382765',
  ucdLib: "TELMISAR/HYD.ZYD 80/12,5 CPR",
  UCD7: '9398145',
  UCD13: '3400893981450',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ZYD 80/12,5 CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2738282',
  CIP13: '3400927382826',
  ucdLib: "TELMISAR/HYD.ZYD 80/12,5 CPR",
  UCD7: '9398145',
  UCD13: '3400893981450',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ZYD 80/12,5 CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '2738307',
  CIP13: '3400927383076',
  ucdLib: "TELMISAR/HYD.ZYD 80/25MG CPR",
  UCD7: '9398151',
  UCD13: '3400893981511',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISAR/HYD.ZYD 80/25MG CPR BT 30",
  atcCode: "C09DA07"
}, {
  CIP7: '2738313',
  CIP13: '3400927383137',
  ucdLib: "TELMISAR/HYD.ZYD 80/25MG CPR",
  UCD7: '9398151',
  UCD13: '3400893981511',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISAR/HYD.ZYD 80/25MG CPR BT 90",
  atcCode: "C09DA07"
}, {
  CIP7: '3555684',
  CIP13: '3400935556844',
  ucdLib: "HYTACAND 16MG/12,5MG CPR",
  UCD7: '9229595',
  UCD13: '3400892295954',
  ucdQtyMultiplicator: 30,
  cipLib: "HYTACAND 16MG/12,5MG CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '3720278',
  CIP13: '3400937202787',
  ucdLib: "HYTACAND 16MG/12,5MG CPR",
  UCD7: '9229595',
  UCD13: '3400892295954',
  ucdQtyMultiplicator: 90,
  cipLib: "HYTACAND 16MG/12,5MG CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '3720172',
  CIP13: '3400937201728',
  ucdLib: "HYTACAND 8MG/12,5MG CPR",
  UCD7: '9221837',
  UCD13: '3400892218373',
  ucdQtyMultiplicator: 30,
  cipLib: "HYTACAND 8MG/12,5MG CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '3720195',
  CIP13: '3400937201957',
  ucdLib: "HYTACAND 8MG/12,5MG CPR",
  UCD7: '9221837',
  UCD13: '3400892218373',
  ucdQtyMultiplicator: 90,
  cipLib: "HYTACAND 8MG/12,5MG CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '3714177',
  CIP13: '3400937141772',
  ucdLib: "COKENZEN 16MG/12,5MG CPR",
  UCD7: '9228408',
  UCD13: '3400892284088',
  ucdQtyMultiplicator: 30,
  cipLib: "COKENZEN 16MG/12,5MG CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '3714208',
  CIP13: '3400937142083',
  ucdLib: "COKENZEN 16MG/12,5MG CPR",
  UCD7: '9228408',
  UCD13: '3400892284088',
  ucdQtyMultiplicator: 90,
  cipLib: "COKENZEN 16MG/12,5MG CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '3714094',
  CIP13: '3400937140942',
  ucdLib: "COKENZEN 8MG/12,5MG CPR",
  UCD7: '9221754',
  UCD13: '3400892217543',
  ucdQtyMultiplicator: 30,
  cipLib: "COKENZEN 8MG/12,5MG CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '3714119',
  CIP13: '3400937141192',
  ucdLib: "COKENZEN 8MG/12,5MG CPR",
  UCD7: '9221754',
  UCD13: '3400892217543',
  ucdQtyMultiplicator: 90,
  cipLib: "COKENZEN 8MG/12,5MG CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2210523',
  CIP13: '3400922105239',
  ucdLib: "CANDESAR/HYD.EGL 16/12,5 CPR",
  UCD7: '9383043',
  UCD13: '3400893830437',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.EGL 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2210552',
  CIP13: '3400922105529',
  ucdLib: "CANDESAR/HYD.EGL 16/12,5 CPR",
  UCD7: '9383043',
  UCD13: '3400893830437',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.EGL 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2210463',
  CIP13: '3400922104638',
  ucdLib: "CANDESAR/HYD.EGL 8/12,5 CPR",
  UCD7: '9383066',
  UCD13: '3400893830666',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.EGL 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2210492',
  CIP13: '3400922104928',
  ucdLib: "CANDESAR/HYD.EGL 8/12,5 CPR",
  UCD7: '9383066',
  UCD13: '3400893830666',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.EGL 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4158577',
  CIP13: '3400941585777',
  ucdLib: "CANDESAR/HYD.BGA 16/12,5 CPR",
  UCD7: '9381400',
  UCD13: '3400893814000',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.BGA 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '4158637',
  CIP13: '3400941586378',
  ucdLib: "CANDESAR/HYD.BGA 16/12,5 CPR",
  UCD7: '9381400',
  UCD13: '3400893814000',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.BGA 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4158985',
  CIP13: '3400941589850',
  ucdLib: "CANDESAR/HYD.MYP 16/12,5 CPR",
  UCD7: '9383072',
  UCD13: '3400893830727',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.MYP 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '4159045',
  CIP13: '3400941590450',
  ucdLib: "CANDESAR/HYD.MYP 16/12,5 CPR",
  UCD7: '9383072',
  UCD13: '3400893830727',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.MYP 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4159967',
  CIP13: '3400941599675',
  ucdLib: "CANDESAR/HYD.MYP 8/12,5 CPR",
  UCD7: '9383089',
  UCD13: '3400893830895',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.MYP 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2740215',
  CIP13: '3400927402159',
  ucdLib: "CANDESAR/HYD.TVS 16/12,5 CPR",
  UCD7: '9395856',
  UCD13: '3400893958568',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.TVS 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2740221',
  CIP13: '3400927402210',
  ucdLib: "CANDESAR/HYD.TVS 16/12,5 CPR",
  UCD7: '9395856',
  UCD13: '3400893958568',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.TVS 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2740149',
  CIP13: '3400927401497',
  ucdLib: "CANDESAR/HYD.TVS 8/12,5 CPR",
  UCD7: '9395862',
  UCD13: '3400893958629',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.TVS 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2740161',
  CIP13: '3400927401619',
  ucdLib: "CANDESAR/HYD.TVS 8/12,5 CPR",
  UCD7: '9395862',
  UCD13: '3400893958629',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.TVS 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2699174',
  CIP13: '3400926991746',
  ucdLib: "CANDESAR/HYD.ZYD 16/12,5 CPR",
  UCD7: '9392852',
  UCD13: '3400893928523',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.ZYD 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2699197',
  CIP13: '3400926991975',
  ucdLib: "CANDESAR/HYD.ZYD 16/12,5 CPR",
  UCD7: '9392852',
  UCD13: '3400893928523',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.ZYD 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2699062',
  CIP13: '3400926990626',
  ucdLib: "CANDESAR/HYD.ZYD 8/12,5 CPR",
  UCD7: '9392869',
  UCD13: '3400893928691',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.ZYD 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2699091',
  CIP13: '3400926990916',
  ucdLib: "CANDESAR/HYD.ZYD 8/12,5 CPR",
  UCD7: '9392869',
  UCD13: '3400893928691',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.ZYD 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2800118',
  CIP13: '3400928001184',
  ucdLib: "CANDESAR/HYD.EVO 16/12,5 CPR",
  UCD7: '9414358',
  UCD13: '3400894143581',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.EVO 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2800124',
  CIP13: '3400928001245',
  ucdLib: "CANDESAR/HYD.EVO 16/12,5 CPR",
  UCD7: '9414358',
  UCD13: '3400894143581',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.EVO 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2800093',
  CIP13: '3400928000934',
  ucdLib: "CANDESAR/HYD.EVO 8/12,5 CPR",
  UCD7: '9414364',
  UCD13: '3400894143642',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.EVO 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2800101',
  CIP13: '3400928001016',
  ucdLib: "CANDESAR/HYD.EVO 8/12,5 CPR",
  UCD7: '9414364',
  UCD13: '3400894143642',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.EVO 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2172478',
  CIP13: '3400921724783',
  ucdLib: "CANDESAR/HYD.ARW 16/12,5 CPR",
  UCD7: '9381392',
  UCD13: '3400893813928',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.ARW 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2172509',
  CIP13: '3400921725094',
  ucdLib: "CANDESAR/HYD.ARW 16/12,5 CPR",
  UCD7: '9381392',
  UCD13: '3400893813928',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.ARW 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2172395',
  CIP13: '3400921723953',
  ucdLib: "CANDESAR/HYD.ARW 8/12,5 CPR",
  UCD7: '9381386',
  UCD13: '3400893813867',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.ARW 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2172432',
  CIP13: '3400921724325',
  ucdLib: "CANDESAR/HYD.ARW 8/12,5 CPR",
  UCD7: '9381386',
  UCD13: '3400893813867',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.ARW 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4160083',
  CIP13: '3400941600838',
  ucdLib: "CANDESAR/HYD.BGA 8/12,5 CPR",
  UCD7: '9381417',
  UCD13: '3400893814178',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.BGA 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '4160143',
  CIP13: '3400941601439',
  ucdLib: "CANDESAR/HYD.BGA 8/12,5 CPR",
  UCD7: '9381417',
  UCD13: '3400893814178',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.BGA 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2235144',
  CIP13: '3400922351445',
  ucdLib: "CANDESAR/HYD.CRT 16/12,5 CPR",
  UCD7: '9389979',
  UCD13: '3400893899793',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.CRT 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2235204',
  CIP13: '3400922352046',
  ucdLib: "CANDESAR/HYD.CRT 16/12,5 CPR",
  UCD7: '9389979',
  UCD13: '3400893899793',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.CRT 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2233978',
  CIP13: '3400922339788',
  ucdLib: "CANDESAR/HYD.CRT 8/12,5 CPR",
  UCD7: '9389985',
  UCD13: '3400893899854',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.CRT 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2234021',
  CIP13: '3400922340210',
  ucdLib: "CANDESAR/HYD.CRT 8/12,5 CPR",
  UCD7: '9389985',
  UCD13: '3400893899854',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.CRT 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4169144',
  CIP13: '3400941691447',
  ucdLib: "CANDESAR/HYD.KRK 16/12,5 CPR",
  UCD7: '9372921',
  UCD13: '3400893729212',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.KRK 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '4169196',
  CIP13: '3400941691966',
  ucdLib: "CANDESAR/HYD.KRK 16/12,5 CPR",
  UCD7: '9372921',
  UCD13: '3400893729212',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.KRK 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4168972',
  CIP13: '3400941689727',
  ucdLib: "CANDESAR/HYD.KRK 8/12,5 CPR",
  UCD7: '9372938',
  UCD13: '3400893729380',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.KRK 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '4169026',
  CIP13: '3400941690266',
  ucdLib: "CANDESAR/HYD.KRK 8/12,5 CPR",
  UCD7: '9372938',
  UCD13: '3400893729380',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.KRK 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4160025',
  CIP13: '3400941600258',
  ucdLib: "CANDESAR/HYD.MYP 8/12,5 CPR",
  UCD7: '9383089',
  UCD13: '3400893830895',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.MYP 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4920849',
  CIP13: '3400949208494',
  ucdLib: "CANDESAR/HYD.SDZ 16/12,5 CPR",
  UCD7: '9355704',
  UCD13: '3400893557044',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.SDZ 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '4920909',
  CIP13: '3400949209095',
  ucdLib: "CANDESAR/HYD.SDZ 16/12,5 CPR",
  UCD7: '9355704',
  UCD13: '3400893557044',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.SDZ 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '4920625',
  CIP13: '3400949206254',
  ucdLib: "CANDESAR/HYD.SDZ 8/12,5 CPR",
  UCD7: '9355710',
  UCD13: '3400893557105',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.SDZ 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '4920677',
  CIP13: '3400949206773',
  ucdLib: "CANDESAR/HYD.SDZ 8/12,5 CPR",
  UCD7: '9355710',
  UCD13: '3400893557105',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.SDZ 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2209081',
  CIP13: '3400922090818',
  ucdLib: "CANDESAR/HYD.ZEN 16/12,5 CPR",
  UCD7: '9383617',
  UCD13: '3400893836170',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.ZEN 16/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2209112',
  CIP13: '3400922091129',
  ucdLib: "CANDESAR/HYD.ZEN 16/12,5 CPR",
  UCD7: '9383617',
  UCD13: '3400893836170',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.ZEN 16/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '2209000',
  CIP13: '3400922090009',
  ucdLib: "CANDESAR/HYD.ZEN 8/12,5 CPR",
  UCD7: '9383623',
  UCD13: '3400893836231',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESAR/HYD.ZEN 8/12,5 CPR BT 30",
  atcCode: "C09DA06"
}, {
  CIP7: '2209046',
  CIP13: '3400922090467',
  ucdLib: "CANDESAR/HYD.ZEN 8/12,5 CPR",
  UCD7: '9383623',
  UCD13: '3400893836231',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESAR/HYD.ZEN 8/12,5 CPR BT 90",
  atcCode: "C09DA06"
}, {
  CIP7: '3469861',
  CIP13: '3400934698613',
  ucdLib: "IRBESART/HYD.SDZ 150/12,5 CP",
  UCD7: '9365648',
  UCD13: '3400893656488',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.SDZ 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '3469909',
  CIP13: '3400934699092',
  ucdLib: "IRBESART/HYD.SDZ 150/12,5 CP",
  UCD7: '9365648',
  UCD13: '3400893656488',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.SDZ 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '3469683',
  CIP13: '3400934696831',
  ucdLib: "IRBESART/HYD.SDZ 300/25MG CP",
  UCD7: '9365714',
  UCD13: '3400893657140',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.SDZ 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '3469737',
  CIP13: '3400934697371',
  ucdLib: "IRBESART/HYD.SDZ 300/25MG CP",
  UCD7: '9365714',
  UCD13: '3400893657140',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.SDZ 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '3771100',
  CIP13: '3400937711005',
  ucdLib: "COAPROVEL 300/25MG CP PEL DU",
  UCD7: '9291051',
  UCD13: '3400892910512',
  ucdQtyMultiplicator: 56,
  cipLib: "COAPROVEL 300/25MG CP PEL DU BT 56",
  atcCode: "C09DA04"
}, {
  CIP7: '3801522',
  CIP13: '3400938015225',
  ucdLib: "COAPROVEL 150/12,5 CP PEL",
  UCD7: '9261363',
  UCD13: '3400892613635',
  ucdQtyMultiplicator: 30,
  cipLib: "COAPROVEL 150/12,5 CP PEL BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '3801539',
  CIP13: '3400938015393',
  ucdLib: "COAPROVEL 150/12,5 CP PEL",
  UCD7: '9261363',
  UCD13: '3400892613635',
  ucdQtyMultiplicator: 90,
  cipLib: "COAPROVEL 150/12,5 CP PEL BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '3801545',
  CIP13: '3400938015454',
  ucdLib: "COAPROVEL 300/12,5 CP PEL",
  UCD7: '9261386',
  UCD13: '3400892613864',
  ucdQtyMultiplicator: 30,
  cipLib: "COAPROVEL 300/12,5 CP PEL BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '3801551',
  CIP13: '3400938015515',
  ucdLib: "COAPROVEL 300/12,5 CP PEL",
  UCD7: '9261386',
  UCD13: '3400892613864',
  ucdQtyMultiplicator: 90,
  cipLib: "COAPROVEL 300/12,5 CP PEL BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '3801568',
  CIP13: '3400938015683',
  ucdLib: "COAPROVEL 300/25MG CP PEL",
  UCD7: '9296976',
  UCD13: '3400892969763',
  ucdQtyMultiplicator: 30,
  cipLib: "COAPROVEL 300/25MG CP PEL BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '3801574',
  CIP13: '3400938015744',
  ucdLib: "COAPROVEL 300/25MG CP PEL",
  UCD7: '9296976',
  UCD13: '3400892969763',
  ucdQtyMultiplicator: 90,
  cipLib: "COAPROVEL 300/25MG CP PEL BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '5649521',
  CIP13: '3400956495214',
  ucdLib: "COAPROVEL 150/12,5 CP PEL DU",
  UCD7: '9259165',
  UCD13: '3400892591650',
  ucdQtyMultiplicator: 56,
  cipLib: "COAPROVEL 150/12,5 CP PEL DU BT 56",
  atcCode: "C09DA04"
}, {
  CIP7: '5649550',
  CIP13: '3400956495504',
  ucdLib: "COAPROVEL 300/12,5 CP PEL DU",
  UCD7: '9259171',
  UCD13: '3400892591711',
  ucdQtyMultiplicator: 56,
  cipLib: "COAPROVEL 300/12,5 CP PEL DU BT 56",
  atcCode: "C09DA04"
}, {
  CIP7: '2216738',
  CIP13: '3400922167381',
  ucdLib: "IRBESART/HYD.TVC 150/12,5 CP",
  UCD7: '9386260',
  UCD13: '3400893862605',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.TVC 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2216804',
  CIP13: '3400922168043',
  ucdLib: "IRBESART/HYD.TVC 150/12,5 CP",
  UCD7: '9386260',
  UCD13: '3400893862605',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.TVC 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2216856',
  CIP13: '3400922168562',
  ucdLib: "IRBESART/HYD.TVC 300/12,5 CP",
  UCD7: '9386277',
  UCD13: '3400893862773',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.TVC 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2216885',
  CIP13: '3400922168852',
  ucdLib: "IRBESART/HYD.TVC 300/12,5 CP",
  UCD7: '9386277',
  UCD13: '3400893862773',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.TVC 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2216916',
  CIP13: '3400922169163',
  ucdLib: "IRBESART/HYD.TVC 300/25MG CP",
  UCD7: '9386283',
  UCD13: '3400893862834',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.TVC 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2216945',
  CIP13: '3400922169453',
  ucdLib: "IRBESART/HYD.TVC 300/25MG CP",
  UCD7: '9386283',
  UCD13: '3400893862834',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.TVC 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2219139',
  CIP13: '3400922191393',
  ucdLib: "IRBESART/HYD.ZEN 150/12,5 CP",
  UCD7: '9386857',
  UCD13: '3400893868577',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ZEN 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2219145',
  CIP13: '3400922191454',
  ucdLib: "IRBESART/HYD.ZEN 150/12,5 CP",
  UCD7: '9386857',
  UCD13: '3400893868577',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ZEN 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2219151',
  CIP13: '3400922191515',
  ucdLib: "IRBESART/HYD.ZEN 300/12,5 CP",
  UCD7: '9386863',
  UCD13: '3400893868638',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ZEN 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2219168',
  CIP13: '3400922191683',
  ucdLib: "IRBESART/HYD.ZEN 300/12,5 CP",
  UCD7: '9386863',
  UCD13: '3400893868638',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ZEN 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2219174',
  CIP13: '3400922191744',
  ucdLib: "IRBESART/HYD.ZEN 300/25MG CP",
  UCD7: '9386886',
  UCD13: '3400893868867',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ZEN 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2219180',
  CIP13: '3400922191805',
  ucdLib: "IRBESART/HYD.ZEN 300/25MG CP",
  UCD7: '9386886',
  UCD13: '3400893868867',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ZEN 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '4196738',
  CIP13: '3400941967382',
  ucdLib: "IRBESART/HYD.EG 150/12,5 CPR",
  UCD7: '9393372',
  UCD13: '3400893933725',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.EG 150/12,5 CPR BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '4196773',
  CIP13: '3400941967733',
  ucdLib: "IRBESART/HYD.EG 150/12,5 CPR",
  UCD7: '9393372',
  UCD13: '3400893933725',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.EG 150/12,5 CPR BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '4197198',
  CIP13: '3400941971983',
  ucdLib: "IRBESART/HYD.EG 300/12,5 CPR",
  UCD7: '9393389',
  UCD13: '3400893933893',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.EG 300/12,5 CPR BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '4197229',
  CIP13: '3400941972294',
  ucdLib: "IRBESART/HYD.EG 300/12,5 CPR",
  UCD7: '9393389',
  UCD13: '3400893933893',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.EG 300/12,5 CPR BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '4197100',
  CIP13: '3400941971006',
  ucdLib: "IRBESART/HYD.EG 300/25MG CPR",
  UCD7: '9393395',
  UCD13: '3400893933954',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.EG 300/25MG CPR BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '4197146',
  CIP13: '3400941971464',
  ucdLib: "IRBESART/HYD.EG 300/25MG CPR",
  UCD7: '9393395',
  UCD13: '3400893933954',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.EG 300/25MG CPR BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2245912',
  CIP13: '3400922459127',
  ucdLib: "IFIRMACOMBI 150/12,5MG CPR",
  UCD7: '9394785',
  UCD13: '3400893947852',
  ucdQtyMultiplicator: 30,
  cipLib: "IFIRMACOMBI 150/12,5MG CPR BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2245935',
  CIP13: '3400922459356',
  ucdLib: "IFIRMACOMBI 150/12,5MG CPR",
  UCD7: '9394785',
  UCD13: '3400893947852',
  ucdQtyMultiplicator: 90,
  cipLib: "IFIRMACOMBI 150/12,5MG CPR BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2246076',
  CIP13: '3400922460765',
  ucdLib: "IFIRMACOMBI 300/12,5MG CPR",
  UCD7: '9394791',
  UCD13: '3400893947913',
  ucdQtyMultiplicator: 30,
  cipLib: "IFIRMACOMBI 300/12,5MG CPR BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2246099',
  CIP13: '3400922460994',
  ucdLib: "IFIRMACOMBI 300/12,5MG CPR",
  UCD7: '9394791',
  UCD13: '3400893947913',
  ucdQtyMultiplicator: 90,
  cipLib: "IFIRMACOMBI 300/12,5MG CPR BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2246107',
  CIP13: '3400922461076',
  ucdLib: "IFIRMACOMBI 300/25MG CPR",
  UCD7: '9394816',
  UCD13: '3400893948163',
  ucdQtyMultiplicator: 30,
  cipLib: "IFIRMACOMBI 300/25MG CPR BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2246136',
  CIP13: '3400922461366',
  ucdLib: "IFIRMACOMBI 300/25MG CPR",
  UCD7: '9394816',
  UCD13: '3400893948163',
  ucdQtyMultiplicator: 90,
  cipLib: "IFIRMACOMBI 300/25MG CPR BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2243333',
  CIP13: '3400922433332',
  ucdLib: "IRBESART/HYD.ARG 150/12,5 CP",
  UCD7: '9385680',
  UCD13: '3400893856802',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ARG 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2243379',
  CIP13: '3400922433790',
  ucdLib: "IRBESART/HYD.ARG 150/12,5 CP",
  UCD7: '9385680',
  UCD13: '3400893856802',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ARG 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2243422',
  CIP13: '3400922434223',
  ucdLib: "IRBESART/HYD.ARG 300/12,5 CP",
  UCD7: '9385697',
  UCD13: '3400893856970',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ARG 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2243480',
  CIP13: '3400922434803',
  ucdLib: "IRBESART/HYD.ARG 300/12,5 CP",
  UCD7: '9385697',
  UCD13: '3400893856970',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ARG 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2243652',
  CIP13: '3400922436524',
  ucdLib: "IRBESART/HYD.ARG 300/25MG CP",
  UCD7: '9385705',
  UCD13: '3400893857052',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ARG 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2243681',
  CIP13: '3400922436814',
  ucdLib: "IRBESART/HYD.ARG 300/25MG CP",
  UCD7: '9385705',
  UCD13: '3400893857052',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ARG 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2683061',
  CIP13: '3400926830618',
  ucdLib: "IRBESART/HYD.BGA 150/12,5 CP",
  UCD7: '9393142',
  UCD13: '3400893931424',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.BGA 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2683109',
  CIP13: '3400926831097',
  ucdLib: "IRBESART/HYD.BGA 150/12,5 CP",
  UCD7: '9393142',
  UCD13: '3400893931424',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.BGA 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2683138',
  CIP13: '3400926831387',
  ucdLib: "IRBESART/HYD.BGA 300/12,5 CP",
  UCD7: '9393159',
  UCD13: '3400893931592',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.BGA 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2683173',
  CIP13: '3400926831738',
  ucdLib: "IRBESART/HYD.BGA 300/12,5 CP",
  UCD7: '9393159',
  UCD13: '3400893931592',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.BGA 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2683227',
  CIP13: '3400926832278',
  ucdLib: "IRBESART/HYD.BGA 300/25MG CP",
  UCD7: '9393165',
  UCD13: '3400893931653',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.BGA 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2683279',
  CIP13: '3400926832797',
  ucdLib: "IRBESART/HYD.BGA 300/25MG CP",
  UCD7: '9393165',
  UCD13: '3400893931653',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.BGA 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2178392',
  CIP13: '3400921783926',
  ucdLib: "IRBESART/HYD.CRT 150/12,5 CP",
  UCD7: '9394822',
  UCD13: '3400893948224',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.CRT 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2178423',
  CIP13: '3400921784237',
  ucdLib: "IRBESART/HYD.CRT 150/12,5 CP",
  UCD7: '9394822',
  UCD13: '3400893948224',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.CRT 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2178469',
  CIP13: '3400921784695',
  ucdLib: "IRBESART/HYD.CRT 300/12,5 CP",
  UCD7: '9394839',
  UCD13: '3400893948392',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.CRT 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2178498',
  CIP13: '3400921784985',
  ucdLib: "IRBESART/HYD.CRT 300/12,5 CP",
  UCD7: '9394839',
  UCD13: '3400893948392',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.CRT 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2178529',
  CIP13: '3400921785296',
  ucdLib: "IRBESART/HYD.CRT 300/25MG CP",
  UCD7: '9394845',
  UCD13: '3400893948453',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.CRT 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2178558',
  CIP13: '3400921785586',
  ucdLib: "IRBESART/HYD.CRT 300/25MG CP",
  UCD7: '9394845',
  UCD13: '3400893948453',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.CRT 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2684161',
  CIP13: '3400926841614',
  ucdLib: "IRBESART/HYD.EVO 150/12,5 CP",
  UCD7: '9407223',
  UCD13: '3400894072232',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.EVO 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2684209',
  CIP13: '3400926842093',
  ucdLib: "IRBESART/HYD.EVO 150/12,5 CP",
  UCD7: '9407223',
  UCD13: '3400894072232',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.EVO 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2684238',
  CIP13: '3400926842383',
  ucdLib: "IRBESART/HYD.EVO 300/12,5 CP",
  UCD7: '9407246',
  UCD13: '3400894072461',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.EVO 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2684273',
  CIP13: '3400926842734',
  ucdLib: "IRBESART/HYD.EVO 300/12,5 CP",
  UCD7: '9407246',
  UCD13: '3400894072461',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.EVO 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2684310',
  CIP13: '3400926843106',
  ucdLib: "IRBESART/HYD.EVO 300/25MG CP",
  UCD7: '9407252',
  UCD13: '3400894072522',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.EVO 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2684362',
  CIP13: '3400926843625',
  ucdLib: "IRBESART/HYD.EVO 300/25MG CP",
  UCD7: '9407252',
  UCD13: '3400894072522',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.EVO 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2178216',
  CIP13: '3400921782165',
  ucdLib: "IRBESART/HYD.MYP 150/12,5 CP",
  UCD7: '9387578',
  UCD13: '3400893875780',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.MYP 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2178245',
  CIP13: '3400921782455',
  ucdLib: "IRBESART/HYD.MYP 150/12,5 CP",
  UCD7: '9387578',
  UCD13: '3400893875780',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.MYP 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2178274',
  CIP13: '3400921782745',
  ucdLib: "IRBESART/HYD.MYP 300/12,5 CP",
  UCD7: '9387584',
  UCD13: '3400893875841',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.MYP 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2178305',
  CIP13: '3400921783056',
  ucdLib: "IRBESART/HYD.MYP 300/12,5 CP",
  UCD7: '9387584',
  UCD13: '3400893875841',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.MYP 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2178328',
  CIP13: '3400921783285',
  ucdLib: "IRBESART/HYD.MYP 300/25MG CP",
  UCD7: '9387590',
  UCD13: '3400893875902',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.MYP 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2178357',
  CIP13: '3400921783575',
  ucdLib: "IRBESART/HYD.MYP 300/25MG CP",
  UCD7: '9387590',
  UCD13: '3400893875902',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.MYP 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2181804',
  CIP13: '3400921818048',
  ucdLib: "IRBESART/HYD.SDZ 300/12,5 CP",
  UCD7: '9382776',
  UCD13: '3400893827765',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.SDZ 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2181879',
  CIP13: '3400921818796',
  ucdLib: "IRBESART/HYD.SDZ 300/12,5 CP",
  UCD7: '9382776',
  UCD13: '3400893827765',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.SDZ 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '2248744',
  CIP13: '3400922487441',
  ucdLib: "IRBESART/HYD.ZYD 300/25MG CP",
  UCD7: '9393805',
  UCD13: '3400893938058',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ZYD 300/25MG CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '2248767',
  CIP13: '3400922487670',
  ucdLib: "IRBESART/HYD.ZYD 300/25MG CP",
  UCD7: '9393805',
  UCD13: '3400893938058',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ZYD 300/25MG CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '4965711',
  CIP13: '3400949657117',
  ucdLib: "IRBESART/HYD.ZYD 150/12,5 CP",
  UCD7: '9365654',
  UCD13: '3400893656549',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ZYD 150/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '4965740',
  CIP13: '3400949657407',
  ucdLib: "IRBESART/HYD.ZYD 150/12,5 CP",
  UCD7: '9365654',
  UCD13: '3400893656549',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ZYD 150/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '4966691',
  CIP13: '3400949666911',
  ucdLib: "IRBESART/HYD.ZYD 300/12,5 CP",
  UCD7: '9365660',
  UCD13: '3400893656600',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESART/HYD.ZYD 300/12,5 CP BT 30",
  atcCode: "C09DA04"
}, {
  CIP7: '4966739',
  CIP13: '3400949667390',
  ucdLib: "IRBESART/HYD.ZYD 300/12,5 CP",
  UCD7: '9365660',
  UCD13: '3400893656600',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESART/HYD.ZYD 300/12,5 CP BT 90",
  atcCode: "C09DA04"
}, {
  CIP7: '4915736',
  CIP13: '3400949157365',
  ucdLib: "VALSARTAN/HYD.SDZ 160/12,5 C",
  UCD7: '9355727',
  UCD13: '3400893557273',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.SDZ 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4915802',
  CIP13: '3400949158027',
  ucdLib: "VALSARTAN/HYD.SDZ 160/12,5 C",
  UCD7: '9355727',
  UCD13: '3400893557273',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.SDZ 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4916256',
  CIP13: '3400949162567',
  ucdLib: "VALSARTAN/HYD.SDZ 160/25MG C",
  UCD7: '9355733',
  UCD13: '3400893557334',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.SDZ 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4916345',
  CIP13: '3400949163458',
  ucdLib: "VALSARTAN/HYD.SDZ 160/25MG C",
  UCD7: '9355733',
  UCD13: '3400893557334',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.SDZ 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4915216',
  CIP13: '3400949152162',
  ucdLib: "VALSARTAN/HYD.SDZ 80/12,5 C.",
  UCD7: '9355756',
  UCD13: '3400893557563',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.SDZ 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4915280',
  CIP13: '3400949152803',
  ucdLib: "VALSARTAN/HYD.SDZ 80/12,5 C.",
  UCD7: '9355756',
  UCD13: '3400893557563',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.SDZ 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4982052',
  CIP13: '3400949820528',
  ucdLib: "VALSARTAN/HYD.EG 160/12,5 C.",
  UCD7: '9369132',
  UCD13: '3400893691328',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.EG 160/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4982081',
  CIP13: '3400949820818',
  ucdLib: "VALSARTAN/HYD.EG 160/12,5 C.",
  UCD7: '9369132',
  UCD13: '3400893691328',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.EG 160/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4982098',
  CIP13: '3400949820986',
  ucdLib: "VALSARTAN/HYD.EG 160/25MG C.",
  UCD7: '9369149',
  UCD13: '3400893691496',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.EG 160/25MG C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4982129',
  CIP13: '3400949821297',
  ucdLib: "VALSARTAN/HYD.EG 160/25MG C.",
  UCD7: '9369149',
  UCD13: '3400893691496',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.EG 160/25MG C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4981934',
  CIP13: '3400949819348',
  ucdLib: "VALSARTAN/HYD.EG 80/12,5 C.",
  UCD7: '9369155',
  UCD13: '3400893691557',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.EG 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4981963',
  CIP13: '3400949819638',
  ucdLib: "VALSARTAN/HYD.EG 80/12,5 C.",
  UCD7: '9369155',
  UCD13: '3400893691557',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.EG 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3850029',
  CIP13: '3400938500295',
  ucdLib: "VALSARTAN/HYD.RBX 160/25MG C",
  UCD7: '9358677',
  UCD13: '3400893586778',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.RBX 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3468376',
  CIP13: '3400934683763',
  ucdLib: "VALSARTAN/HYD.RTP 160/12,5 C",
  UCD7: '9351669',
  UCD13: '3400893516690',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.RTP 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3468407',
  CIP13: '3400934684074',
  ucdLib: "VALSARTAN/HYD.RTP 160/12,5 C",
  UCD7: '9351669',
  UCD13: '3400893516690',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.RTP 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3468459',
  CIP13: '3400934684593',
  ucdLib: "VALSARTAN/HYD.RTP 160/25MG C",
  UCD7: '9351675',
  UCD13: '3400893516751',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.RTP 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3468488',
  CIP13: '3400934684883',
  ucdLib: "VALSARTAN/HYD.RTP 160/25MG C",
  UCD7: '9351675',
  UCD13: '3400893516751',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.RTP 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3468287',
  CIP13: '3400934682872',
  ucdLib: "VALSARTAN/HYD.RTP 80/12,5 C.",
  UCD7: '9351681',
  UCD13: '3400893516812',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.RTP 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3468318',
  CIP13: '3400934683183',
  ucdLib: "VALSARTAN/HYD.RTP 80/12,5 C.",
  UCD7: '9351681',
  UCD13: '3400893516812',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.RTP 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3815665',
  CIP13: '3400938156652',
  ucdLib: "COTAREG 160MG/12,5MG CPR",
  UCD7: '9259219',
  UCD13: '3400892592190',
  ucdQtyMultiplicator: 30,
  cipLib: "COTAREG 160MG/12,5MG CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3815688',
  CIP13: '3400938156881',
  ucdLib: "COTAREG 160MG/12,5MG CPR",
  UCD7: '9259219',
  UCD13: '3400892592190',
  ucdQtyMultiplicator: 56,
  cipLib: "COTAREG 160MG/12,5MG CPR BT 56",
  atcCode: "C09DA03"
}, {
  CIP7: '3815702',
  CIP13: '3400938157024',
  ucdLib: "COTAREG 160MG/12,5MG CPR",
  UCD7: '9259219',
  UCD13: '3400892592190',
  ucdQtyMultiplicator: 90,
  cipLib: "COTAREG 160MG/12,5MG CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3815731',
  CIP13: '3400938157314',
  ucdLib: "COTAREG 160MG/25MG CPR",
  UCD7: '9243922',
  UCD13: '3400892439228',
  ucdQtyMultiplicator: 30,
  cipLib: "COTAREG 160MG/25MG CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3815754',
  CIP13: '3400938157543',
  ucdLib: "COTAREG 160MG/25MG CPR",
  UCD7: '9243922',
  UCD13: '3400892439228',
  ucdQtyMultiplicator: 56,
  cipLib: "COTAREG 160MG/25MG CPR BT 56",
  atcCode: "C09DA03"
}, {
  CIP7: '3815777',
  CIP13: '3400938157772',
  ucdLib: "COTAREG 160MG/25MG CPR",
  UCD7: '9243922',
  UCD13: '3400892439228',
  ucdQtyMultiplicator: 90,
  cipLib: "COTAREG 160MG/25MG CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3815582',
  CIP13: '3400938155822',
  ucdLib: "COTAREG 80MG/12,5MG CPR",
  UCD7: '9198541',
  UCD13: '3400891985412',
  ucdQtyMultiplicator: 30,
  cipLib: "COTAREG 80MG/12,5MG CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3815607',
  CIP13: '3400938156072',
  ucdLib: "COTAREG 80MG/12,5MG CPR",
  UCD7: '9198541',
  UCD13: '3400891985412',
  ucdQtyMultiplicator: 56,
  cipLib: "COTAREG 80MG/12,5MG CPR BT 56",
  atcCode: "C09DA03"
}, {
  CIP7: '3815636',
  CIP13: '3400938156362',
  ucdLib: "COTAREG 80MG/12,5MG CPR",
  UCD7: '9198541',
  UCD13: '3400891985412',
  ucdQtyMultiplicator: 90,
  cipLib: "COTAREG 80MG/12,5MG CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3790416',
  CIP13: '3400937904162',
  ucdLib: "NISISCO 160MG/12,5MG CPR",
  UCD7: '9259834',
  UCD13: '3400892598345',
  ucdQtyMultiplicator: 30,
  cipLib: "NISISCO 160MG/12,5MG CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3790451',
  CIP13: '3400937904513',
  ucdLib: "NISISCO 160MG/12,5MG CPR",
  UCD7: '9259834',
  UCD13: '3400892598345',
  ucdQtyMultiplicator: 90,
  cipLib: "NISISCO 160MG/12,5MG CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3790480',
  CIP13: '3400937904803',
  ucdLib: "NISISCO 160MG/25MG CPR",
  UCD7: '9242992',
  UCD13: '3400892429922',
  ucdQtyMultiplicator: 30,
  cipLib: "NISISCO 160MG/25MG CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3790528',
  CIP13: '3400937905282',
  ucdLib: "NISISCO 160MG/25MG CPR",
  UCD7: '9242992',
  UCD13: '3400892429922',
  ucdQtyMultiplicator: 90,
  cipLib: "NISISCO 160MG/25MG CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3790327',
  CIP13: '3400937903271',
  ucdLib: "NISISCO 80MG/12,5MG CPR",
  UCD7: '9198593',
  UCD13: '3400891985931',
  ucdQtyMultiplicator: 30,
  cipLib: "NISISCO 80MG/12,5MG CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3790379',
  CIP13: '3400937903790',
  ucdLib: "NISISCO 80MG/12,5MG CPR",
  UCD7: '9198593',
  UCD13: '3400891985931',
  ucdQtyMultiplicator: 90,
  cipLib: "NISISCO 80MG/12,5MG CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3973803',
  CIP13: '3400939738031',
  ucdLib: "VALSARTAN/HYD.BGA 160/25MG CPR",
  UCD7: '9347509',
  UCD13: '3400893475096',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.BGA 160/25MG CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3973855',
  CIP13: '3400939738550',
  ucdLib: "VALSARTAN/HYD.BGA 160/25MG CPR",
  UCD7: '9347509',
  UCD13: '3400893475096',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.BGA 160/25MG CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3973660',
  CIP13: '3400939736600',
  ucdLib: "VALSARTAN/HYD.BGA 80/12,5 CPR",
  UCD7: '9347515',
  UCD13: '3400893475157',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.BGA 80/12,5 CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3973714',
  CIP13: '3400939737140',
  ucdLib: "VALSARTAN/HYD.BGA 80/12,5 CPR",
  UCD7: '9347515',
  UCD13: '3400893475157',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.BGA 80/12,5 CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2214142',
  CIP13: '3400922141428',
  ucdLib: "VALSARTAN/HYD.EVO 160/25 CPR",
  UCD7: '9385415',
  UCD13: '3400893854150',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.EVO 160/25 CPR BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2214188',
  CIP13: '3400922141886',
  ucdLib: "VALSARTAN/HYD.EVO 160/25 CPR",
  UCD7: '9385415',
  UCD13: '3400893854150',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.EVO 160/25 CPR BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2213987',
  CIP13: '3400922139876',
  ucdLib: "VALSARTAN/HYD.EVO 80/12,5 CP",
  UCD7: '9385421',
  UCD13: '3400893854211',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.EVO 80/12,5 CP BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2214024',
  CIP13: '3400922140247',
  ucdLib: "VALSARTAN/HYD.EVO 80/12,5 CP",
  UCD7: '9385421',
  UCD13: '3400893854211',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.EVO 80/12,5 CP BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3845790',
  CIP13: '3400938457902',
  ucdLib: "VALSARTAN/HYD.RBX 160/12,5 C",
  UCD7: '9358660',
  UCD13: '3400893586600',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.RBX 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3846080',
  CIP13: '3400938460803',
  ucdLib: "VALSARTAN/HYD.RBX 160/12,5 C",
  UCD7: '9358660',
  UCD13: '3400893586600',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.RBX 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3848989',
  CIP13: '3400938489897',
  ucdLib: "VALSARTAN/HYD.RBX 160/25MG C",
  UCD7: '9358677',
  UCD13: '3400893586778',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.RBX 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3842662',
  CIP13: '3400938426625',
  ucdLib: "VALSARTAN/HYD.RBX 80/12,5 C.",
  UCD7: '9358683',
  UCD13: '3400893586839',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.RBX 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3842751',
  CIP13: '3400938427516',
  ucdLib: "VALSARTAN/HYD.RBX 80/12,5 C.",
  UCD7: '9358683',
  UCD13: '3400893586839',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.RBX 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3960290',
  CIP13: '3400939602905',
  ucdLib: "VALSARTAN/HYD.TVC 160/12,5 C",
  UCD7: '9344758',
  UCD13: '3400893447581',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.TVC 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3960338',
  CIP13: '3400939603384',
  ucdLib: "VALSARTAN/HYD.TVC 160/12,5 C",
  UCD7: '9344758',
  UCD13: '3400893447581',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.TVC 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3960054',
  CIP13: '3400939600543',
  ucdLib: "VALSARTAN/HYD.TVC 160/25MG C",
  UCD7: '9344764',
  UCD13: '3400893447642',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.TVC 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3960108',
  CIP13: '3400939601083',
  ucdLib: "VALSARTAN/HYD.TVC 160/25MG C",
  UCD7: '9344764',
  UCD13: '3400893447642',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.TVC 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3960189',
  CIP13: '3400939601892',
  ucdLib: "VALSARTAN/HYD.TVC 80/12,5 C.",
  UCD7: '9344770',
  UCD13: '3400893447703',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.TVC 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3960232',
  CIP13: '3400939602325',
  ucdLib: "VALSARTAN/HYD.TVC 80/12,5 C.",
  UCD7: '9344770',
  UCD13: '3400893447703',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.TVC 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4156294',
  CIP13: '3400941562945',
  ucdLib: "VALSARTAN/HYD.ARL 160/12,5 C",
  UCD7: '9372499',
  UCD13: '3400893724996',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ARL 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4156331',
  CIP13: '3400941563317',
  ucdLib: "VALSARTAN/HYD.ARL 160/12,5 C",
  UCD7: '9372499',
  UCD13: '3400893724996',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ARL 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4156408',
  CIP13: '3400941564086',
  ucdLib: "VALSARTAN/HYD.ARL 160/12,5 C",
  UCD7: '9372499',
  UCD13: '3400893724996',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ARL 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4156012',
  CIP13: '3400941560125',
  ucdLib: "VALSARTAN/HYD.BGA 160/12,5 C",
  UCD7: '9372507',
  UCD13: '3400893725078',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.BGA 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4156058',
  CIP13: '3400941560583',
  ucdLib: "VALSARTAN/HYD.BGA 160/12,5 C",
  UCD7: '9372507',
  UCD13: '3400893725078',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.BGA 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2757517',
  CIP13: '3400927575174',
  ucdLib: "VALSARTAN/HYD.EVO 160/12,5 C",
  UCD7: '9397878',
  UCD13: '3400893978788',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.EVO 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2757569',
  CIP13: '3400927575693',
  ucdLib: "VALSARTAN/HYD.EVO 160/12,5 C",
  UCD7: '9397878',
  UCD13: '3400893978788',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.EVO 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2660410',
  CIP13: '3400926604103',
  ucdLib: "VALSARTAN/HYD.MYP 160/12,5 C",
  UCD7: '9392970',
  UCD13: '3400893929704',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.MYP 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2660462',
  CIP13: '3400926604622',
  ucdLib: "VALSARTAN/HYD.MYP 160/12,5 C",
  UCD7: '9392970',
  UCD13: '3400893929704',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.MYP 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2660545',
  CIP13: '3400926605452',
  ucdLib: "VALSARTAN/HYD.MYP 160/25MG C",
  UCD7: '9392987',
  UCD13: '3400893929872',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.MYP 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2660580',
  CIP13: '3400926605803',
  ucdLib: "VALSARTAN/HYD.MYP 160/25MG C",
  UCD7: '9392987',
  UCD13: '3400893929872',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.MYP 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2660290',
  CIP13: '3400926602901',
  ucdLib: "VALSARTAN/HYD.MYP 80/12,5 C.",
  UCD7: '9392993',
  UCD13: '3400893929933',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.MYP 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2660338',
  CIP13: '3400926603380',
  ucdLib: "VALSARTAN/HYD.MYP 80/12,5 C.",
  UCD7: '9392993',
  UCD13: '3400893929933',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.MYP 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4178953',
  CIP13: '3400941789533',
  ucdLib: "VALSARTAN/HYD.PHR 160/12,5 C",
  UCD7: '9376764',
  UCD13: '3400893767641',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.PHR 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4179013',
  CIP13: '3400941790133',
  ucdLib: "VALSARTAN/HYD.PHR 160/12,5 C",
  UCD7: '9376764',
  UCD13: '3400893767641',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.PHR 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4179160',
  CIP13: '3400941791604',
  ucdLib: "VALSARTAN/HYD.PHR 160/25MG C",
  UCD7: '9376770',
  UCD13: '3400893767702',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.PHR 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4179214',
  CIP13: '3400941792144',
  ucdLib: "VALSARTAN/HYD.PHR 160/25MG C",
  UCD7: '9376770',
  UCD13: '3400893767702',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.PHR 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4156147',
  CIP13: '3400941561474',
  ucdLib: "VALSARTAN/HYD.ZTL 160/12,5 C",
  UCD7: '9372513',
  UCD13: '3400893725139',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ZTL 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4156199',
  CIP13: '3400941561993',
  ucdLib: "VALSARTAN/HYD.ZTL 160/12,5 C",
  UCD7: '9372513',
  UCD13: '3400893725139',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ZTL 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4155863',
  CIP13: '3400941558634',
  ucdLib: "VALSARTAN/HYD.ZYD 160/12,5 C",
  UCD7: '9372536',
  UCD13: '3400893725368',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ZYD 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4155917',
  CIP13: '3400941559174',
  ucdLib: "VALSARTAN/HYD.ZYD 160/12,5 C",
  UCD7: '9372536',
  UCD13: '3400893725368',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ZYD 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3990747',
  CIP13: '3400939907475',
  ucdLib: "VALSARTAN/HYD.ARL 160/25MG C",
  UCD7: '9350055',
  UCD13: '3400893500552',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ARL 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3990799',
  CIP13: '3400939907994',
  ucdLib: "VALSARTAN/HYD.ARL 160/25MG C",
  UCD7: '9350055',
  UCD13: '3400893500552',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ARL 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3990865',
  CIP13: '3400939908656',
  ucdLib: "VALSARTAN/HYD.ARL 160/25MG C",
  UCD7: '9350055',
  UCD13: '3400893500552',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ARL 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3990629',
  CIP13: '3400939906294',
  ucdLib: "VALSARTAN/HYD.ARL 80/12,5 C.",
  UCD7: '9350061',
  UCD13: '3400893500613',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ARL 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3990664',
  CIP13: '3400939906645',
  ucdLib: "VALSARTAN/HYD.ARL 80/12,5 C.",
  UCD7: '9350061',
  UCD13: '3400893500613',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ARL 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3990724',
  CIP13: '3400939907246',
  ucdLib: "VALSARTAN/HYD.ARL 80/12,5 C.",
  UCD7: '9350061',
  UCD13: '3400893500613',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ARL 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2161919',
  CIP13: '3400921619195',
  ucdLib: "VALSARTAN/HYD.CRT 160/12,5 C",
  UCD7: '9377516',
  UCD13: '3400893775165',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.CRT 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2161954',
  CIP13: '3400921619546',
  ucdLib: "VALSARTAN/HYD.CRT 160/12,5 C",
  UCD7: '9377516',
  UCD13: '3400893775165',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.CRT 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2162072',
  CIP13: '3400921620726',
  ucdLib: "VALSARTAN/HYD.CRT 160/25MG C",
  UCD7: '9377522',
  UCD13: '3400893775226',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.CRT 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2162126',
  CIP13: '3400921621266',
  ucdLib: "VALSARTAN/HYD.CRT 160/25MG C",
  UCD7: '9377522',
  UCD13: '3400893775226',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.CRT 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '2161753',
  CIP13: '3400921617535',
  ucdLib: "VALSARTAN/HYD.CRT 80/12,5 C.",
  UCD7: '9377539',
  UCD13: '3400893775394',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.CRT 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '2161807',
  CIP13: '3400921618075',
  ucdLib: "VALSARTAN/HYD.CRT 80/12,5 C.",
  UCD7: '9377539',
  UCD13: '3400893775394',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.CRT 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4162538',
  CIP13: '3400941625381',
  ucdLib: "VALSARTAN/HYD.KRK 160/12,5 C",
  UCD7: '9379544',
  UCD13: '3400893795446',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.KRK 160/12,5 C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4162567',
  CIP13: '3400941625671',
  ucdLib: "VALSARTAN/HYD.KRK 160/12,5 C",
  UCD7: '9379544',
  UCD13: '3400893795446',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.KRK 160/12,5 C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4180619',
  CIP13: '3400941806193',
  ucdLib: "VALSARTAN/HYD.KRK 160/25MG C",
  UCD7: '9379550',
  UCD13: '3400893795507',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.KRK 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4180648',
  CIP13: '3400941806483',
  ucdLib: "VALSARTAN/HYD.KRK 160/25MG C",
  UCD7: '9379550',
  UCD13: '3400893795507',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.KRK 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4180507',
  CIP13: '3400941805073',
  ucdLib: "VALSARTAN/HYD.KRK 80/12,5 C.",
  UCD7: '9379567',
  UCD13: '3400893795675',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.KRK 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '4180565',
  CIP13: '3400941805653',
  ucdLib: "VALSARTAN/HYD.KRK 80/12,5 C.",
  UCD7: '9379567',
  UCD13: '3400893795675',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.KRK 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3992249',
  CIP13: '3400939922492',
  ucdLib: "VALSARTAN/HYD.ZTL 160/25MG C",
  UCD7: '9349218',
  UCD13: '3400893492185',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ZTL 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3992284',
  CIP13: '3400939922843',
  ucdLib: "VALSARTAN/HYD.ZTL 160/25MG C",
  UCD7: '9349218',
  UCD13: '3400893492185',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ZTL 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3992108',
  CIP13: '3400939921082',
  ucdLib: "VALSARTAN/HYD.ZTL 80/12,5 C.",
  UCD7: '9349224',
  UCD13: '3400893492246',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ZTL 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3992143',
  CIP13: '3400939921433',
  ucdLib: "VALSARTAN/HYD.ZTL 80/12,5 C.",
  UCD7: '9349224',
  UCD13: '3400893492246',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ZTL 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3991853',
  CIP13: '3400939918532',
  ucdLib: "VALSARTAN/HYD.ZYD 160/25MG C",
  UCD7: '9349230',
  UCD13: '3400893492307',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ZYD 160/25MG C BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3991907',
  CIP13: '3400939919072',
  ucdLib: "VALSARTAN/HYD.ZYD 160/25MG C",
  UCD7: '9349230',
  UCD13: '3400893492307',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ZYD 160/25MG C BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '3991735',
  CIP13: '3400939917351',
  ucdLib: "VALSARTAN/HYD.ZYD 80/12,5 C.",
  UCD7: '9349247',
  UCD13: '3400893492475',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN/HYD.ZYD 80/12,5 C. BT 30",
  atcCode: "C09DA03"
}, {
  CIP7: '3991770',
  CIP13: '3400939917702',
  ucdLib: "VALSARTAN/HYD.ZYD 80/12,5 C.",
  UCD7: '9349247',
  UCD13: '3400893492475',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN/HYD.ZYD 80/12,5 C. BT 90",
  atcCode: "C09DA03"
}, {
  CIP7: '4989485',
  CIP13: '3400949894857',
  ucdLib: "LOSARTAN/HYD.ISD 100/12,5 C.",
  UCD7: '9365430',
  UCD13: '3400893654309',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ISD 100/12,5 C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '4989522',
  CIP13: '3400949895229',
  ucdLib: "LOSARTAN/HYD.ISD 100/12,5 C.",
  UCD7: '9365430',
  UCD13: '3400893654309',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ISD 100/12,5 C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3854205',
  CIP13: '3400938542059',
  ucdLib: "LOSARTAN/HYD.ARW 50/12,5 CPR",
  UCD7: '9320309',
  UCD13: '3400893203095',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ARW 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3854487',
  CIP13: '3400938544879',
  ucdLib: "LOSARTAN/HYD.CRT 100/25MG C.",
  UCD7: '9333714',
  UCD13: '3400893337141',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.CRT 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3854518',
  CIP13: '3400938545180',
  ucdLib: "LOSARTAN/HYD.CRT 100/25MG C.",
  UCD7: '9333714',
  UCD13: '3400893337141',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.CRT 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3854346',
  CIP13: '3400938543469',
  ucdLib: "LOSARTAN/HYD.CRT 50/12,5 CPR",
  UCD7: '9320321',
  UCD13: '3400893203217',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.CRT 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3854530',
  CIP13: '3400938545302',
  ucdLib: "LOSARTAN/HYD.CRT 50/12,5 CPR",
  UCD7: '9320321',
  UCD13: '3400893203217',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.CRT 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3518625',
  CIP13: '3400935186256',
  ucdLib: "FORTZAAR 100MG/25MG CPR",
  UCD7: '9217698',
  UCD13: '3400892176987',
  ucdQtyMultiplicator: 28,
  cipLib: "FORTZAAR 100MG/25MG CPR BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3385207',
  CIP13: '3400933852078',
  ucdLib: "HYZAAR 50MG/12,5MG CPR",
  UCD7: '9171200',
  UCD13: '3400891712001',
  ucdQtyMultiplicator: 28,
  cipLib: "HYZAAR 50MG/12,5MG CPR BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3774848',
  CIP13: '3400937748483',
  ucdLib: "FORTZAAR 100MG/12,5MG CPR",
  UCD7: '9300548',
  UCD13: '3400893005484',
  ucdQtyMultiplicator: 28,
  cipLib: "FORTZAAR 100MG/12,5MG CPR BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3774883',
  CIP13: '3400937748834',
  ucdLib: "FORTZAAR 100MG/12,5MG CPR",
  UCD7: '9300548',
  UCD13: '3400893005484',
  ucdQtyMultiplicator: 90,
  cipLib: "FORTZAAR 100MG/12,5MG CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3714088',
  CIP13: '3400937140881',
  ucdLib: "FORTZAAR 100MG/25MG CPR",
  UCD7: '9217698',
  UCD13: '3400892176987',
  ucdQtyMultiplicator: 90,
  cipLib: "FORTZAAR 100MG/25MG CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3714467',
  CIP13: '3400937144674',
  ucdLib: "HYZAAR 50MG/12,5MG CPR",
  UCD7: '9171200',
  UCD13: '3400891712001',
  ucdQtyMultiplicator: 90,
  cipLib: "HYZAAR 50MG/12,5MG CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3825913',
  CIP13: '3400938259131',
  ucdLib: "LOSARTAN/HYD.TVC 100/25MG C.",
  UCD7: '9333631',
  UCD13: '3400893336311',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.TVC 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3825965',
  CIP13: '3400938259650',
  ucdLib: "LOSARTAN/HYD.TVC 100/25MG C.",
  UCD7: '9333631',
  UCD13: '3400893336311',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.TVC 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3825505',
  CIP13: '3400938255058',
  ucdLib: "LOSARTAN/HYD.TVC 50/12,5 CPR",
  UCD7: '9333648',
  UCD13: '3400893336489',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.TVC 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3825540',
  CIP13: '3400938255409',
  ucdLib: "LOSARTAN/HYD.TVC 50/12,5 CPR",
  UCD7: '9333648',
  UCD13: '3400893336489',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.TVC 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3863380',
  CIP13: '3400938633801',
  ucdLib: "LOSARTAN/HYD.RBX 100/25MG C.",
  UCD7: '9333602',
  UCD13: '3400893336021',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.RBX 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3863411',
  CIP13: '3400938634112',
  ucdLib: "LOSARTAN/HYD.RBX 100/25MG C.",
  UCD7: '9333602',
  UCD13: '3400893336021',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.RBX 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3863262',
  CIP13: '3400938632620',
  ucdLib: "LOSARTAN/HYD.RBX 50/12,5 CPR",
  UCD7: '9320290',
  UCD13: '3400893202906',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.RBX 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3863285',
  CIP13: '3400938632859',
  ucdLib: "LOSARTAN/HYD.RBX 50/12,5 CPR",
  UCD7: '9320290',
  UCD13: '3400893202906',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.RBX 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3927312',
  CIP13: '3400939273129',
  ucdLib: "LOSARTAN/HYD.SDZ 100/25MG C.",
  UCD7: '9334760',
  UCD13: '3400893347607',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.SDZ 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3927364',
  CIP13: '3400939273648',
  ucdLib: "LOSARTAN/HYD.SDZ 100/25MG C.",
  UCD7: '9334760',
  UCD13: '3400893347607',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.SDZ 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3927424',
  CIP13: '3400939274249',
  ucdLib: "LOSARTAN/HYD.SDZ 50/12,5 CPR",
  UCD7: '9334777',
  UCD13: '3400893347775',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.SDZ 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3927482',
  CIP13: '3400939274829',
  ucdLib: "LOSARTAN/HYD.SDZ 50/12,5 CPR",
  UCD7: '9334777',
  UCD13: '3400893347775',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.SDZ 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3899685',
  CIP13: '3400938996852',
  ucdLib: "LOSARTAN/HYD.BCR 100/25MG C.",
  UCD7: '9333559',
  UCD13: '3400893335598',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.BCR 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3899751',
  CIP13: '3400938997514',
  ucdLib: "LOSARTAN/HYD.BCR 50/12,5 CPR",
  UCD7: '9327636',
  UCD13: '3400893276365',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.BCR 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3891962',
  CIP13: '3400938919622',
  ucdLib: "LOSARTAN/HYD.EG 100/25MG CPR",
  UCD7: '9333565',
  UCD13: '3400893335659',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.EG 100/25MG CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3892022',
  CIP13: '3400938920222',
  ucdLib: "LOSARTAN/HYD.EG 100/25MG CPR",
  UCD7: '9333565',
  UCD13: '3400893335659',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.EG 100/25MG CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3892393',
  CIP13: '3400938923933',
  ucdLib: "LOSARTAN/HYD.EG 50/12,5 CPR",
  UCD7: '9327642',
  UCD13: '3400893276426',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.EG 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3892424',
  CIP13: '3400938924244',
  ucdLib: "LOSARTAN/HYD.EG 50/12,5 CPR",
  UCD7: '9327642',
  UCD13: '3400893276426',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.EG 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3899248',
  CIP13: '3400938992489',
  ucdLib: "LOSARTAN/HYD.ISD 100/25MG C.",
  UCD7: '9333588',
  UCD13: '3400893335888',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ISD 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3899260',
  CIP13: '3400938992601',
  ucdLib: "LOSARTAN/HYD.ISD 50/12,5 CPR",
  UCD7: '9327659',
  UCD13: '3400893276594',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ISD 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3952250',
  CIP13: '3400939522500',
  ucdLib: "LOSARTAN/HYD.MYL 100/25MG C.",
  UCD7: '9339823',
  UCD13: '3400893398234',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN/HYD.MYL 100/25MG C. BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3955952',
  CIP13: '3400939559520',
  ucdLib: "LOSARTAN/HYD.MYL 100/25MG C.",
  UCD7: '9339823',
  UCD13: '3400893398234',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.MYL 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3952178',
  CIP13: '3400939521787',
  ucdLib: "LOSARTAN/HYD.MYL 50/12,5 CPR",
  UCD7: '9339846',
  UCD13: '3400893398463',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN/HYD.MYL 50/12,5 CPR BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3955923',
  CIP13: '3400939559230',
  ucdLib: "LOSARTAN/HYD.MYL 50/12,5 CPR",
  UCD7: '9339846',
  UCD13: '3400893398463',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.MYL 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3964862',
  CIP13: '3400939648620',
  ucdLib: "LOSARTAN/HYD.ZEN 100/12,5 C.",
  UCD7: '9344646',
  UCD13: '3400893446461',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN/HYD.ZEN 100/12,5 C. BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3964922',
  CIP13: '3400939649221',
  ucdLib: "LOSARTAN/HYD.ZEN 100/12,5 C.",
  UCD7: '9344646',
  UCD13: '3400893446461',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ZEN 100/12,5 C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3964968',
  CIP13: '3400939649689',
  ucdLib: "LOSARTAN/HYD.ZEN 100/25MG C.",
  UCD7: '9344824',
  UCD13: '3400893448243',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN/HYD.ZEN 100/25MG C. BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3965011',
  CIP13: '3400939650111',
  ucdLib: "LOSARTAN/HYD.ZEN 100/25MG C.",
  UCD7: '9344824',
  UCD13: '3400893448243',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ZEN 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3964767',
  CIP13: '3400939647678',
  ucdLib: "LOSARTAN/HYD.ZEN 50/12,5 CPR",
  UCD7: '9344830',
  UCD13: '3400893448304',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN/HYD.ZEN 50/12,5 CPR BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '4900918',
  CIP13: '3400949009183',
  ucdLib: "FORTZAAR 100/25 CP AIPMWI IT",
  UCD7: '9377002',
  UCD13: '3400893770023',
  ucdQtyMultiplicator: 28,
  cipLib: "FORTZAAR 100/25 CP AIPMWI IT BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '4900232',
  CIP13: '3400949002320',
  ucdLib: "FORTZAAR 100/25 CP AIPPLA IT",
  UCD7: '9328593',
  UCD13: '3400893285930',
  ucdQtyMultiplicator: 28,
  cipLib: "FORTZAAR 100/25 CP AIPPLA IT BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '3943618',
  CIP13: '3400939436180',
  ucdLib: "LOSARTAN/HYD.BCR 100/25MG C.",
  UCD7: '9333559',
  UCD13: '3400893335598',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.BCR 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3943570',
  CIP13: '3400939435701',
  ucdLib: "LOSARTAN/HYD.BCR 50/12,5 CPR",
  UCD7: '9327636',
  UCD13: '3400893276365',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.BCR 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2197751',
  CIP13: '3400921977516',
  ucdLib: "LOSARTAN/HYD.BGA 100/12,5 C.",
  UCD7: '9384717',
  UCD13: '3400893847176',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.BGA 100/12,5 C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2197780',
  CIP13: '3400921977806',
  ucdLib: "LOSARTAN/HYD.BGA 100/12,5 C.",
  UCD7: '9384717',
  UCD13: '3400893847176',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.BGA 100/12,5 C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3985350',
  CIP13: '3400939853505',
  ucdLib: "LOSARTAN/HYD.BGR 100/25MG C.",
  UCD7: '9343925',
  UCD13: '3400893439258',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.BGR 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3985278',
  CIP13: '3400939852782',
  ucdLib: "LOSARTAN/HYD.BGR 50/12,5 CPR",
  UCD7: '9343931',
  UCD13: '3400893439319',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.BGR 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3985315',
  CIP13: '3400939853154',
  ucdLib: "LOSARTAN/HYD.BGR 50/12,5 CPR",
  UCD7: '9343931',
  UCD13: '3400893439319',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.BGR 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2194385',
  CIP13: '3400921943856',
  ucdLib: "LOSARTAN/HYD.EG 100/12,5 CPR",
  UCD7: '9380458',
  UCD13: '3400893804582',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.EG 100/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2194416',
  CIP13: '3400921944167',
  ucdLib: "LOSARTAN/HYD.EG 100/12,5 CPR",
  UCD7: '9380458',
  UCD13: '3400893804582',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.EG 100/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2198093',
  CIP13: '3400921980936',
  ucdLib: "LOSARTAN/HYD.EVO 100/12,5 C.",
  UCD7: '9390600',
  UCD13: '3400893906002',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.EVO 100/12,5 C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2198124',
  CIP13: '3400921981247',
  ucdLib: "LOSARTAN/HYD.EVO 100/12,5 C.",
  UCD7: '9390600',
  UCD13: '3400893906002',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.EVO 100/12,5 C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '4151374',
  CIP13: '3400941513749',
  ucdLib: "LOSARTAN/HYD.EVO 100/25MG C.",
  UCD7: '9333720',
  UCD13: '3400893337202',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.EVO 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '4151380',
  CIP13: '3400941513800',
  ucdLib: "LOSARTAN/HYD.EVO 100/25MG C.",
  UCD7: '9333720',
  UCD13: '3400893337202',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.EVO 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '4151351',
  CIP13: '3400941513510',
  ucdLib: "LOSARTAN/HYD.EVO 50/12,5 CPR",
  UCD7: '9327754',
  UCD13: '3400893277546',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.EVO 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '4151368',
  CIP13: '3400941513688',
  ucdLib: "LOSARTAN/HYD.EVO 50/12,5 CPR",
  UCD7: '9327754',
  UCD13: '3400893277546',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.EVO 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '4934490',
  CIP13: '3400949344901',
  ucdLib: "LOSARTAN/HYD.PHR 100/25MG C.",
  UCD7: '9358921',
  UCD13: '3400893589212',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.PHR 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '4934538',
  CIP13: '3400949345380',
  ucdLib: "LOSARTAN/HYD.PHR 100/25MG C.",
  UCD7: '9358921',
  UCD13: '3400893589212',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.PHR 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '4934283',
  CIP13: '3400949342839',
  ucdLib: "LOSARTAN/HYD.PHR 50/12,5 CPR",
  UCD7: '9358938',
  UCD13: '3400893589380',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.PHR 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '4934337',
  CIP13: '3400949343379',
  ucdLib: "LOSARTAN/HYD.PHR 50/12,5 CPR",
  UCD7: '9358938',
  UCD13: '3400893589380',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.PHR 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '4196170',
  CIP13: '3400941961700',
  ucdLib: "LOSARTAN/HYD.TVC 100/12,5 C.",
  UCD7: '9377947',
  UCD13: '3400893779477',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.TVC 100/12,5 C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '4196201',
  CIP13: '3400941962011',
  ucdLib: "LOSARTAN/HYD.TVC 100/12,5 C.",
  UCD7: '9377947',
  UCD13: '3400893779477',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.TVC 100/12,5 C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2193807',
  CIP13: '3400921938074',
  ucdLib: "LOSARTAN/HYD.ZYD 100/25MG C.",
  UCD7: '9392266',
  UCD13: '3400893922668',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ZYD 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2193836',
  CIP13: '3400921938364',
  ucdLib: "LOSARTAN/HYD.ZYD 100/25MG C.",
  UCD7: '9392266',
  UCD13: '3400893922668',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ZYD 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2193859',
  CIP13: '3400921938593',
  ucdLib: "LOSARTAN/HYD.ZYD 50/12,5 CPR",
  UCD7: '9392272',
  UCD13: '3400893922729',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ZYD 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2193871',
  CIP13: '3400921938715',
  ucdLib: "LOSARTAN/HYD.ZYD 50/12,5 CPR",
  UCD7: '9392272',
  UCD13: '3400893922729',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ZYD 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2187296',
  CIP13: '3400921872965',
  ucdLib: "LOSARTAN/HYD.ARL 100/12,5 C.",
  UCD7: '9408435',
  UCD13: '3400894084358',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ARL 100/12,5 C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2187333',
  CIP13: '3400921873337',
  ucdLib: "LOSARTAN/HYD.ARL 100/12,5 C.",
  UCD7: '9408435',
  UCD13: '3400894084358',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ARL 100/12,5 C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2187385',
  CIP13: '3400921873856',
  ucdLib: "LOSARTAN/HYD.ARL 100/25MG C.",
  UCD7: '9408441',
  UCD13: '3400894084419',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ARL 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2187439',
  CIP13: '3400921874396',
  ucdLib: "LOSARTAN/HYD.ARL 100/25MG C.",
  UCD7: '9408441',
  UCD13: '3400894084419',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ARL 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2187184',
  CIP13: '3400921871845',
  ucdLib: "LOSARTAN/HYD.ARL 50/12,5 CPR",
  UCD7: '9408458',
  UCD13: '3400894084587',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ARL 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2187221',
  CIP13: '3400921872217',
  ucdLib: "LOSARTAN/HYD.ARL 50/12,5 CPR",
  UCD7: '9408458',
  UCD13: '3400894084587',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ARL 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3993243',
  CIP13: '3400939932439',
  ucdLib: "LOSARTAN/HYD.BGR 100/25MG C.",
  UCD7: '9343925',
  UCD13: '3400893439258',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.BGR 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3993728',
  CIP13: '3400939937281',
  ucdLib: "LOSARTAN/HYD.ISD 100/25MG C.",
  UCD7: '9333588',
  UCD13: '3400893335888',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ISD 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '3993734',
  CIP13: '3400939937342',
  ucdLib: "LOSARTAN/HYD.ISD 50/12,5 CPR",
  UCD7: '9327659',
  UCD13: '3400893276594',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.ISD 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2181081',
  CIP13: '3400921810813',
  ucdLib: "LOSARTAN/HYD.KRK 100/12,5 C.",
  UCD7: '9385639',
  UCD13: '3400893856390',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.KRK 100/12,5 C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2181135',
  CIP13: '3400921811353',
  ucdLib: "LOSARTAN/HYD.KRK 100/12,5 C.",
  UCD7: '9385639',
  UCD13: '3400893856390',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.KRK 100/12,5 C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2688816',
  CIP13: '3400926888169',
  ucdLib: "LOSARTAN/HYD.KRK 100/25MG C.",
  UCD7: '9367015',
  UCD13: '3400893670156',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.KRK 100/25MG C. BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2688839',
  CIP13: '3400926888398',
  ucdLib: "LOSARTAN/HYD.KRK 100/25MG C.",
  UCD7: '9367015',
  UCD13: '3400893670156',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.KRK 100/25MG C. BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2688779',
  CIP13: '3400926887797',
  ucdLib: "LOSARTAN/HYD.KRK 50/12,5 CPR",
  UCD7: '9367021',
  UCD13: '3400893670217',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN/HYD.KRK 50/12,5 CPR BT 30",
  atcCode: "C09DA01"
}, {
  CIP7: '2688791',
  CIP13: '3400926887919',
  ucdLib: "LOSARTAN/HYD.KRK 50/12,5 CPR",
  UCD7: '9367021',
  UCD13: '3400893670217',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.KRK 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '2164349',
  CIP13: '3400921643497',
  ucdLib: "LOSARTAN/HYD.MYP 100/12,5 CP",
  UCD7: '9379099',
  UCD13: '3400893790991',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN/HYD.MYP 100/12,5 CP BT 28",
  atcCode: "C09DA01"
}, {
  CIP7: '2164409',
  CIP13: '3400921644098',
  ucdLib: "LOSARTAN/HYD.MYP 100/12,5 CP",
  UCD7: '9379099',
  UCD13: '3400893790991',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.MYP 100/12,5 CP BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3993579',
  CIP13: '3400939935799',
  ucdLib: "LOSARTAN/HYD.ZEN 50/12,5 CPR",
  UCD7: '9344830',
  UCD13: '3400893448304',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN/HYD.ZEN 50/12,5 CPR BT 90",
  atcCode: "C09DA01"
}, {
  CIP7: '3720663',
  CIP13: '3400937206631',
  ucdLib: "ALTEIS 10MG CPR",
  UCD7: '9256971',
  UCD13: '3400892569710',
  ucdQtyMultiplicator: 30,
  cipLib: "ALTEIS 10MG CPR BT 30",
  atcCode: "C09CA08"
}, {
  CIP7: '3720692',
  CIP13: '3400937206921',
  ucdLib: "ALTEIS 10MG CPR",
  UCD7: '9256971',
  UCD13: '3400892569710',
  ucdQtyMultiplicator: 90,
  cipLib: "ALTEIS 10MG CPR BT 90",
  atcCode: "C09CA08"
}, {
  CIP7: '3720700',
  CIP13: '3400937207003',
  ucdLib: "ALTEIS 20MG CPR",
  UCD7: '9256988',
  UCD13: '3400892569888',
  ucdQtyMultiplicator: 30,
  cipLib: "ALTEIS 20MG CPR BT 30",
  atcCode: "C09CA08"
}, {
  CIP7: '3720723',
  CIP13: '3400937207232',
  ucdLib: "ALTEIS 20MG CPR",
  UCD7: '9256988',
  UCD13: '3400892569888',
  ucdQtyMultiplicator: 90,
  cipLib: "ALTEIS 20MG CPR BT 90",
  atcCode: "C09CA08"
}, {
  CIP7: '3720746',
  CIP13: '3400937207461',
  ucdLib: "ALTEIS 40MG CPR",
  UCD7: '9256994',
  UCD13: '3400892569949',
  ucdQtyMultiplicator: 30,
  cipLib: "ALTEIS 40MG CPR BT 30",
  atcCode: "C09CA08"
}, {
  CIP7: '3720769',
  CIP13: '3400937207690',
  ucdLib: "ALTEIS 40MG CPR",
  UCD7: '9256994',
  UCD13: '3400892569949',
  ucdQtyMultiplicator: 90,
  cipLib: "ALTEIS 40MG CPR BT 90",
  atcCode: "C09CA08"
}, {
  CIP7: '3740140',
  CIP13: '3400937401401',
  ucdLib: "OLMETEC 10MG CPR",
  UCD7: '9261009',
  UCD13: '3400892610092',
  ucdQtyMultiplicator: 30,
  cipLib: "OLMETEC 10MG CPR BT 30",
  atcCode: "C09CA08"
}, {
  CIP7: '3740163',
  CIP13: '3400937401630',
  ucdLib: "OLMETEC 10MG CPR",
  UCD7: '9261009',
  UCD13: '3400892610092',
  ucdQtyMultiplicator: 90,
  cipLib: "OLMETEC 10MG CPR BT 90",
  atcCode: "C09CA08"
}, {
  CIP7: '3740186',
  CIP13: '3400937401869',
  ucdLib: "OLMETEC 20MG CPR",
  UCD7: '9261015',
  UCD13: '3400892610153',
  ucdQtyMultiplicator: 30,
  cipLib: "OLMETEC 20MG CPR BT 30",
  atcCode: "C09CA08"
}, {
  CIP7: '3740200',
  CIP13: '3400937402002',
  ucdLib: "OLMETEC 20MG CPR",
  UCD7: '9261015',
  UCD13: '3400892610153',
  ucdQtyMultiplicator: 90,
  cipLib: "OLMETEC 20MG CPR BT 90",
  atcCode: "C09CA08"
}, {
  CIP7: '3740217',
  CIP13: '3400937402170',
  ucdLib: "OLMETEC 40MG CPR",
  UCD7: '9262523',
  UCD13: '3400892625232',
  ucdQtyMultiplicator: 30,
  cipLib: "OLMETEC 40MG CPR BT 30",
  atcCode: "C09CA08"
}, {
  CIP7: '3740246',
  CIP13: '3400937402460',
  ucdLib: "OLMETEC 40MG CPR",
  UCD7: '9262523',
  UCD13: '3400892625232',
  ucdQtyMultiplicator: 90,
  cipLib: "OLMETEC 40MG CPR BT 90",
  atcCode: "C09CA08"
}, {
  CIP7: '2762903',
  CIP13: '3400927629037',
  ucdLib: "TELMISARTAN ZYD 40MG CPR",
  UCD7: '9398582',
  UCD13: '3400893985823',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN ZYD 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2762932',
  CIP13: '3400927629327',
  ucdLib: "TELMISARTAN ZYD 40MG CPR",
  UCD7: '9398582',
  UCD13: '3400893985823',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN ZYD 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2762961',
  CIP13: '3400927629617',
  ucdLib: "TELMISARTAN ZYD 80MG CPR",
  UCD7: '9398599',
  UCD13: '3400893985991',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN ZYD 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2762984',
  CIP13: '3400927629846',
  ucdLib: "TELMISARTAN ZYD 80MG CPR",
  UCD7: '9398599',
  UCD13: '3400893985991',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN ZYD 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '3526369',
  CIP13: '3400935263698',
  ucdLib: "MICARDIS 20MG CPR",
  UCD7: '9241018',
  UCD13: '3400892410180',
  ucdQtyMultiplicator: 28,
  cipLib: "MICARDIS 20MG CPR BT 28",
  atcCode: "C09CA07"
}, {
  CIP7: '3777611',
  CIP13: '3400937776110',
  ucdLib: "MICARDIS 40MG CPR",
  UCD7: '9207688',
  UCD13: '3400892076881',
  ucdQtyMultiplicator: 30,
  cipLib: "MICARDIS 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '3777628',
  CIP13: '3400937776288',
  ucdLib: "MICARDIS 40MG CPR",
  UCD7: '9207688',
  UCD13: '3400892076881',
  ucdQtyMultiplicator: 90,
  cipLib: "MICARDIS 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '3777634',
  CIP13: '3400937776349',
  ucdLib: "MICARDIS 80MG CPR",
  UCD7: '9207694',
  UCD13: '3400892076942',
  ucdQtyMultiplicator: 30,
  cipLib: "MICARDIS 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '3777640',
  CIP13: '3400937776400',
  ucdLib: "MICARDIS 80MG CPR",
  UCD7: '9207694',
  UCD13: '3400892076942',
  ucdQtyMultiplicator: 90,
  cipLib: "MICARDIS 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '3777700',
  CIP13: '3400937777001',
  ucdLib: "PRITOR 20MG CPR",
  UCD7: '9244672',
  UCD13: '3400892446721',
  ucdQtyMultiplicator: 30,
  cipLib: "PRITOR 20MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '3716710',
  CIP13: '3400937167109',
  ucdLib: "PRITOR 40MG CPR",
  UCD7: '9211997',
  UCD13: '3400892119977',
  ucdQtyMultiplicator: 90,
  cipLib: "PRITOR 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '3777717',
  CIP13: '3400937777179',
  ucdLib: "PRITOR 40MG CPR",
  UCD7: '9211997',
  UCD13: '3400892119977',
  ucdQtyMultiplicator: 30,
  cipLib: "PRITOR 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '3716727',
  CIP13: '3400937167277',
  ucdLib: "PRITOR 80MG CPR",
  UCD7: '9212005',
  UCD13: '3400892120058',
  ucdQtyMultiplicator: 90,
  cipLib: "PRITOR 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '3777723',
  CIP13: '3400937777230',
  ucdLib: "PRITOR 80MG CPR",
  UCD7: '9212005',
  UCD13: '3400892120058',
  ucdQtyMultiplicator: 30,
  cipLib: "PRITOR 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4197608',
  CIP13: '3400941976087',
  ucdLib: "TELMISARTAN BGA 40MG CPR",
  UCD7: '9398033',
  UCD13: '3400893980330',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN BGA 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4197620',
  CIP13: '3400941976209',
  ucdLib: "TELMISARTAN BGA 40MG CPR",
  UCD7: '9398033',
  UCD13: '3400893980330',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN BGA 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '4197703',
  CIP13: '3400941977039',
  ucdLib: "TELMISARTAN BGA 80MG CPR",
  UCD7: '9398056',
  UCD13: '3400893980569',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN BGA 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4197732',
  CIP13: '3400941977329',
  ucdLib: "TELMISARTAN BGA 80MG CPR",
  UCD7: '9398056',
  UCD13: '3400893980569',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN BGA 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '4197873',
  CIP13: '3400941978739',
  ucdLib: "TELMISARTAN CRT 40MG CPR",
  UCD7: '9395365',
  UCD13: '3400893953655',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN CRT 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4197904',
  CIP13: '3400941979040',
  ucdLib: "TELMISARTAN CRT 40MG CPR",
  UCD7: '9395365',
  UCD13: '3400893953655',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN CRT 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '4197979',
  CIP13: '3400941979798',
  ucdLib: "TELMISARTAN CRT 80MG CPR",
  UCD7: '9395371',
  UCD13: '3400893953716',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN CRT 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4197991',
  CIP13: '3400941979910',
  ucdLib: "TELMISARTAN CRT 80MG CPR",
  UCD7: '9395371',
  UCD13: '3400893953716',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN CRT 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2192452',
  CIP13: '3400921924527',
  ucdLib: "TELMISARTAN EG 40MG CPR",
  UCD7: '9395276',
  UCD13: '3400893952764',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN EG 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2192469',
  CIP13: '3400921924695',
  ucdLib: "TELMISARTAN EG 40MG CPR",
  UCD7: '9395276',
  UCD13: '3400893952764',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN EG 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2192475',
  CIP13: '3400921924756',
  ucdLib: "TELMISARTAN EG 80MG CPR",
  UCD7: '9395282',
  UCD13: '3400893952825',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN EG 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2192481',
  CIP13: '3400921924817',
  ucdLib: "TELMISARTAN EG 80MG CPR",
  UCD7: '9395282',
  UCD13: '3400893952825',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN EG 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2191197',
  CIP13: '3400921911978',
  ucdLib: "TELMISARTAN MYL 40MG CPR",
  UCD7: '9395974',
  UCD13: '3400893959749',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN MYL 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2191228',
  CIP13: '3400921912289',
  ucdLib: "TELMISARTAN MYL 40MG CPR",
  UCD7: '9395974',
  UCD13: '3400893959749',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN MYL 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2191352',
  CIP13: '3400921913521',
  ucdLib: "TELMISARTAN MYL 80MG CPR",
  UCD7: '9395980',
  UCD13: '3400893959800',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN MYL 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2191398',
  CIP13: '3400921913989',
  ucdLib: "TELMISARTAN MYL 80MG CPR",
  UCD7: '9395980',
  UCD13: '3400893959800',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN MYL 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2694610',
  CIP13: '3400926946104',
  ucdLib: "TELMISARTAN RBX 40MG CPR",
  UCD7: '9395997',
  UCD13: '3400893959978',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN RBX 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2694685',
  CIP13: '3400926946852',
  ucdLib: "TELMISARTAN RBX 40MG CPR",
  UCD7: '9395997',
  UCD13: '3400893959978',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN RBX 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2694811',
  CIP13: '3400926948115',
  ucdLib: "TELMISARTAN RBX 80MG CPR",
  UCD7: '9396005',
  UCD13: '3400893960059',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN RBX 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2694840',
  CIP13: '3400926948405',
  ucdLib: "TELMISARTAN RBX 80MG CPR",
  UCD7: '9396005',
  UCD13: '3400893960059',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN RBX 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '4191161',
  CIP13: '3400941911613',
  ucdLib: "TELMISARTAN SDZ 20MG CPR",
  UCD7: '9379461',
  UCD13: '3400893794616',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN SDZ 20MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4191416',
  CIP13: '3400941914164',
  ucdLib: "TELMISARTAN SDZ 40MG CPR",
  UCD7: '9379478',
  UCD13: '3400893794784',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN SDZ 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4191468',
  CIP13: '3400941914683',
  ucdLib: "TELMISARTAN SDZ 40MG CPR",
  UCD7: '9379478',
  UCD13: '3400893794784',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN SDZ 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '4191540',
  CIP13: '3400941915406',
  ucdLib: "TELMISARTAN SDZ 80MG CPR",
  UCD7: '9379484',
  UCD13: '3400893794845',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN SDZ 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4191600',
  CIP13: '3400941916007',
  ucdLib: "TELMISARTAN SDZ 80MG CPR",
  UCD7: '9379484',
  UCD13: '3400893794845',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN SDZ 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '4937554',
  CIP13: '3400949375547',
  ucdLib: "TELMISARTAN TVS 40MG CPR",
  UCD7: '9362354',
  UCD13: '3400893623541',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN TVS 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4937614',
  CIP13: '3400949376148',
  ucdLib: "TELMISARTAN TVS 40MG CPR",
  UCD7: '9362354',
  UCD13: '3400893623541',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN TVS 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '4937809',
  CIP13: '3400949378098',
  ucdLib: "TELMISARTAN TVS 80MG CPR",
  UCD7: '9362360',
  UCD13: '3400893623602',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN TVS 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '4937844',
  CIP13: '3400949378449',
  ucdLib: "TELMISARTAN TVS 80MG CPR",
  UCD7: '9362360',
  UCD13: '3400893623602',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN TVS 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2695897',
  CIP13: '3400926958978',
  ucdLib: "TELMISARTAN ZEN 40MG CPR",
  UCD7: '9397341',
  UCD13: '3400893973417',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN ZEN 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2695934',
  CIP13: '3400926959340',
  ucdLib: "TELMISARTAN ZEN 40MG CPR",
  UCD7: '9397341',
  UCD13: '3400893973417',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN ZEN 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2699292',
  CIP13: '3400926992927',
  ucdLib: "TELMISARTAN ZEN 80MG CPR",
  UCD7: '9397358',
  UCD13: '3400893973585',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN ZEN 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2699346',
  CIP13: '3400926993467',
  ucdLib: "TELMISARTAN ZEN 80MG CPR",
  UCD7: '9397358',
  UCD13: '3400893973585',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN ZEN 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2665040',
  CIP13: '3400926650407',
  ucdLib: "TOLURA 40MG CPR",
  UCD7: '9397393',
  UCD13: '3400893973936',
  ucdQtyMultiplicator: 30,
  cipLib: "TOLURA 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2665057',
  CIP13: '3400926650575',
  ucdLib: "TOLURA 40MG CPR",
  UCD7: '9397393',
  UCD13: '3400893973936',
  ucdQtyMultiplicator: 90,
  cipLib: "TOLURA 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2665063',
  CIP13: '3400926650636',
  ucdLib: "TOLURA 80MG CPR",
  UCD7: '9397401',
  UCD13: '3400893974018',
  ucdQtyMultiplicator: 30,
  cipLib: "TOLURA 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2665086',
  CIP13: '3400926650865',
  ucdLib: "TOLURA 80MG CPR",
  UCD7: '9397401',
  UCD13: '3400893974018',
  ucdQtyMultiplicator: 90,
  cipLib: "TOLURA 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2738632',
  CIP13: '3400927386329',
  ucdLib: "TELMISARTAN ACT 40MG CPR",
  UCD7: '9395738',
  UCD13: '3400893957387',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN ACT 40MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2738661',
  CIP13: '3400927386619',
  ucdLib: "TELMISARTAN ACT 40MG CPR",
  UCD7: '9395738',
  UCD13: '3400893957387',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN ACT 40MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '2738715',
  CIP13: '3400927387159',
  ucdLib: "TELMISARTAN ACT 80MG CPR",
  UCD7: '9395744',
  UCD13: '3400893957448',
  ucdQtyMultiplicator: 30,
  cipLib: "TELMISARTAN ACT 80MG CPR BT 30",
  atcCode: "C09CA07"
}, {
  CIP7: '2738744',
  CIP13: '3400927387449',
  ucdLib: "TELMISARTAN ACT 80MG CPR",
  UCD7: '9395744',
  UCD13: '3400893957448',
  ucdQtyMultiplicator: 90,
  cipLib: "TELMISARTAN ACT 80MG CPR BT 90",
  atcCode: "C09CA07"
}, {
  CIP7: '3457220',
  CIP13: '3400934572203',
  ucdLib: "ATACAND 4MG CPR",
  UCD7: '9200893',
  UCD13: '3400892008936',
  ucdQtyMultiplicator: 98,
  cipLib: "ATACAND 4MG CPR BT 98",
  atcCode: "C09CA06"
}, {
  CIP7: '3457289',
  CIP13: '3400934572890',
  ucdLib: "ATACAND 8MG CPR",
  UCD7: '9200901',
  UCD13: '3400892009018',
  ucdQtyMultiplicator: 98,
  cipLib: "ATACAND 8MG CPR BT 98",
  atcCode: "C09CA06"
}, {
  CIP7: '3720568',
  CIP13: '3400937205689',
  ucdLib: "ATACAND 32MG CPR",
  UCD7: '9287144',
  UCD13: '3400892871448',
  ucdQtyMultiplicator: 30,
  cipLib: "ATACAND 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3720290',
  CIP13: '3400937202909',
  ucdLib: "ATACAND 4MG CPR",
  UCD7: '9200893',
  UCD13: '3400892008936',
  ucdQtyMultiplicator: 30,
  cipLib: "ATACAND 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3720315',
  CIP13: '3400937203159',
  ucdLib: "ATACAND 4MG CPR",
  UCD7: '9200893',
  UCD13: '3400892008936',
  ucdQtyMultiplicator: 90,
  cipLib: "ATACAND 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '3720427',
  CIP13: '3400937204279',
  ucdLib: "KENZEN 16MG CPR",
  UCD7: '9215707',
  UCD13: '3400892157078',
  ucdQtyMultiplicator: 30,
  cipLib: "KENZEN 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3720456',
  CIP13: '3400937204569',
  ucdLib: "KENZEN 16MG CPR",
  UCD7: '9215707',
  UCD13: '3400892157078',
  ucdQtyMultiplicator: 90,
  cipLib: "KENZEN 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '3695103',
  CIP13: '3400936951037',
  ucdLib: "KENZEN 32MG CPR",
  UCD7: '9286357',
  UCD13: '3400892863573',
  ucdQtyMultiplicator: 30,
  cipLib: "KENZEN 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3720338',
  CIP13: '3400937203388',
  ucdLib: "KENZEN 4MG CPR",
  UCD7: '9203414',
  UCD13: '3400892034140',
  ucdQtyMultiplicator: 30,
  cipLib: "KENZEN 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3720373',
  CIP13: '3400937203739',
  ucdLib: "KENZEN 8MG CPR",
  UCD7: '9203420',
  UCD13: '3400892034201',
  ucdQtyMultiplicator: 30,
  cipLib: "KENZEN 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3720404',
  CIP13: '3400937204040',
  ucdLib: "KENZEN 8MG CPR",
  UCD7: '9203420',
  UCD13: '3400892034201',
  ucdQtyMultiplicator: 90,
  cipLib: "KENZEN 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '3715277',
  CIP13: '3400937152778',
  ucdLib: "ATACAND 16MG CPR",
  UCD7: '9210851',
  UCD13: '3400892108513',
  ucdQtyMultiplicator: 30,
  cipLib: "ATACAND 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3715308',
  CIP13: '3400937153089',
  ucdLib: "ATACAND 16MG CPR",
  UCD7: '9210851',
  UCD13: '3400892108513',
  ucdQtyMultiplicator: 90,
  cipLib: "ATACAND 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '3715320',
  CIP13: '3400937153201',
  ucdLib: "ATACAND 8MG CPR",
  UCD7: '9200901',
  UCD13: '3400892009018',
  ucdQtyMultiplicator: 30,
  cipLib: "ATACAND 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3715343',
  CIP13: '3400937153430',
  ucdLib: "ATACAND 8MG CPR",
  UCD7: '9200901',
  UCD13: '3400892009018',
  ucdQtyMultiplicator: 90,
  cipLib: "ATACAND 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '5616361',
  CIP13: '3400956163618',
  ucdLib: "ATACAND 16MG CPR",
  UCD7: '9210851',
  UCD13: '3400892108513',
  ucdQtyMultiplicator: 98,
  cipLib: "ATACAND 16MG CPR BT 98",
  atcCode: "C09CA06"
}, {
  CIP7: '3969500',
  CIP13: '3400939695006',
  ucdLib: "CANDESARTAN SDZ 16MG CPR",
  UCD7: '9346131',
  UCD13: '3400893461310',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN SDZ 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3969569',
  CIP13: '3400939695693',
  ucdLib: "CANDESARTAN SDZ 16MG CPR",
  UCD7: '9346131',
  UCD13: '3400893461310',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN SDZ 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '3969983',
  CIP13: '3400939699837',
  ucdLib: "CANDESARTAN SDZ 32MG CPR",
  UCD7: '9346148',
  UCD13: '3400893461488',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN SDZ 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3968682',
  CIP13: '3400939686820',
  ucdLib: "CANDESARTAN SDZ 4MG CPR",
  UCD7: '9346154',
  UCD13: '3400893461549',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN SDZ 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3968742',
  CIP13: '3400939687421',
  ucdLib: "CANDESARTAN SDZ 4MG CPR",
  UCD7: '9346154',
  UCD13: '3400893461549',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN SDZ 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '3969138',
  CIP13: '3400939691381',
  ucdLib: "CANDESARTAN SDZ 8MG CPR",
  UCD7: '9346160',
  UCD13: '3400893461600',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN SDZ 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '3969196',
  CIP13: '3400939691961',
  ucdLib: "CANDESARTAN SDZ 8MG CPR",
  UCD7: '9346160',
  UCD13: '3400893461600',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN SDZ 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4156489',
  CIP13: '3400941564895',
  ucdLib: "CANDESARTAN BGA 16MG CPR",
  UCD7: '9381535',
  UCD13: '3400893815359',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN BGA 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4156532',
  CIP13: '3400941565328',
  ucdLib: "CANDESARTAN BGA 16MG CPR",
  UCD7: '9381535',
  UCD13: '3400893815359',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN BGA 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4156590',
  CIP13: '3400941565908',
  ucdLib: "CANDESARTAN BGA 4MG CPR",
  UCD7: '9381541',
  UCD13: '3400893815410',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN BGA 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4156644',
  CIP13: '3400941566448',
  ucdLib: "CANDESARTAN BGA 4MG CPR",
  UCD7: '9381541',
  UCD13: '3400893815410',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN BGA 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4156733',
  CIP13: '3400941567339',
  ucdLib: "CANDESARTAN BGA 8MG CPR",
  UCD7: '9381558',
  UCD13: '3400893815588',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN BGA 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4156791',
  CIP13: '3400941567919',
  ucdLib: "CANDESARTAN BGA 8MG CPR",
  UCD7: '9381558',
  UCD13: '3400893815588',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN BGA 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2669055',
  CIP13: '3400926690557',
  ucdLib: "CANDESARTAN EVO 16MG CPR",
  UCD7: '9391580',
  UCD13: '3400893915806',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN EVO 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2669061',
  CIP13: '3400926690618',
  ucdLib: "CANDESARTAN EVO 16MG CPR",
  UCD7: '9391580',
  UCD13: '3400893915806',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN EVO 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2669115',
  CIP13: '3400926691158',
  ucdLib: "CANDESARTAN EVO 32MG CPR",
  UCD7: '9391597',
  UCD13: '3400893915974',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN EVO 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2669003',
  CIP13: '3400926690038',
  ucdLib: "CANDESARTAN EVO 4MG CPR",
  UCD7: '9391605',
  UCD13: '3400893916056',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN EVO 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2669026',
  CIP13: '3400926690267',
  ucdLib: "CANDESARTAN EVO 4MG CPR",
  UCD7: '9391605',
  UCD13: '3400893916056',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN EVO 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2669032',
  CIP13: '3400926690328',
  ucdLib: "CANDESARTAN EVO 8MG CPR",
  UCD7: '9391611',
  UCD13: '3400893916117',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN EVO 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2669049',
  CIP13: '3400926690496',
  ucdLib: "CANDESARTAN EVO 8MG CPR",
  UCD7: '9391611',
  UCD13: '3400893916117',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN EVO 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4159387',
  CIP13: '3400941593871',
  ucdLib: "CANDESARTAN MYP 16MG CPR",
  UCD7: '9383008',
  UCD13: '3400893830086',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN MYP 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4159430',
  CIP13: '3400941594304',
  ucdLib: "CANDESARTAN MYP 16MG CPR",
  UCD7: '9383008',
  UCD13: '3400893830086',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN MYP 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4159536',
  CIP13: '3400941595363',
  ucdLib: "CANDESARTAN MYP 32MG CPR",
  UCD7: '9383014',
  UCD13: '3400893830147',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN MYP 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4159105',
  CIP13: '3400941591051',
  ucdLib: "CANDESARTAN MYP 4MG CPR",
  UCD7: '9383020',
  UCD13: '3400893830208',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN MYP 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4159157',
  CIP13: '3400941591570',
  ucdLib: "CANDESARTAN MYP 4MG CPR",
  UCD7: '9383020',
  UCD13: '3400893830208',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN MYP 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4159252',
  CIP13: '3400941592522',
  ucdLib: "CANDESARTAN MYP 8MG CPR",
  UCD7: '9383037',
  UCD13: '3400893830376',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN MYP 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4159306',
  CIP13: '3400941593062',
  ucdLib: "CANDESARTAN MYP 8MG CPR",
  UCD7: '9383037',
  UCD13: '3400893830376',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN MYP 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4994500',
  CIP13: '3400949945009',
  ucdLib: "CANDESARTAN RBX 16MG CPR",
  UCD7: '9369592',
  UCD13: '3400893695920',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN RBX 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4994552',
  CIP13: '3400949945528',
  ucdLib: "CANDESARTAN RBX 16MG CPR",
  UCD7: '9369592',
  UCD13: '3400893695920',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN RBX 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4994380',
  CIP13: '3400949943807',
  ucdLib: "CANDESARTAN RBX 8MG CPR",
  UCD7: '9369617',
  UCD13: '3400893696170',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN RBX 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4994411',
  CIP13: '3400949944118',
  ucdLib: "CANDESARTAN RBX 8MG CPR",
  UCD7: '9369617',
  UCD13: '3400893696170',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN RBX 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2663035',
  CIP13: '3400926630355',
  ucdLib: "CANDESARTAN TVC 16MG CPR",
  UCD7: '9393320',
  UCD13: '3400893933206',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN TVC 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2663041',
  CIP13: '3400926630416',
  ucdLib: "CANDESARTAN TVC 16MG CPR",
  UCD7: '9393320',
  UCD13: '3400893933206',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN TVC 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2663058',
  CIP13: '3400926630584',
  ucdLib: "CANDESARTAN TVC 32MG CPR",
  UCD7: '9393337',
  UCD13: '3400893933374',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN TVC 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2662998',
  CIP13: '3400926629984',
  ucdLib: "CANDESARTAN TVC 4MG CPR",
  UCD7: '9393343',
  UCD13: '3400893933435',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN TVC 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2663006',
  CIP13: '3400926630065',
  ucdLib: "CANDESARTAN TVC 4MG CPR",
  UCD7: '9393343',
  UCD13: '3400893933435',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN TVC 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2663012',
  CIP13: '3400926630126',
  ucdLib: "CANDESARTAN TVC 8MG CPR",
  UCD7: '9393366',
  UCD13: '3400893933664',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN TVC 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2663029',
  CIP13: '3400926630294',
  ucdLib: "CANDESARTAN TVC 8MG CPR",
  UCD7: '9393366',
  UCD13: '3400893933664',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN TVC 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2172047',
  CIP13: '3400921720471',
  ucdLib: "CANDESARTAN ARW 16MG CPR",
  UCD7: '9381506',
  UCD13: '3400893815069',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ARW 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2172082',
  CIP13: '3400921720822',
  ucdLib: "CANDESARTAN ARW 16MG CPR",
  UCD7: '9381506',
  UCD13: '3400893815069',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN ARW 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2172136',
  CIP13: '3400921721362',
  ucdLib: "CANDESARTAN ARW 32MG CPR",
  UCD7: '9381512',
  UCD13: '3400893815120',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ARW 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2171881',
  CIP13: '3400921718812',
  ucdLib: "CANDESARTAN ARW 4MG CPR",
  UCD7: '9381481',
  UCD13: '3400893814819',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ARW 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2171912',
  CIP13: '3400921719123',
  ucdLib: "CANDESARTAN ARW 4MG CPR",
  UCD7: '9381481',
  UCD13: '3400893814819',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN ARW 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2171964',
  CIP13: '3400921719642',
  ucdLib: "CANDESARTAN ARW 8MG CPR",
  UCD7: '9381498',
  UCD13: '3400893814987',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ARW 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2171993',
  CIP13: '3400921719932',
  ucdLib: "CANDESARTAN ARW 8MG CPR",
  UCD7: '9381498',
  UCD13: '3400893814987',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN ARW 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2173868',
  CIP13: '3400921738681',
  ucdLib: "CANDESARTAN BGA 32MG CPR",
  UCD7: '9381529',
  UCD13: '3400893815298',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN BGA 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2231531',
  CIP13: '3400922315317',
  ucdLib: "CANDESARTAN CRT 16MG CPR",
  UCD7: '9385556',
  UCD13: '3400893855560',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN CRT 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2231583',
  CIP13: '3400922315836',
  ucdLib: "CANDESARTAN CRT 16MG CPR",
  UCD7: '9385556',
  UCD13: '3400893855560',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN CRT 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2231258',
  CIP13: '3400922312583',
  ucdLib: "CANDESARTAN CRT 4MG CPR",
  UCD7: '9385562',
  UCD13: '3400893855621',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN CRT 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2231301',
  CIP13: '3400922313016',
  ucdLib: "CANDESARTAN CRT 4MG CPR",
  UCD7: '9385562',
  UCD13: '3400893855621',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN CRT 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2231399',
  CIP13: '3400922313993',
  ucdLib: "CANDESARTAN CRT 8MG CPR",
  UCD7: '9385579',
  UCD13: '3400893855799',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN CRT 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2231459',
  CIP13: '3400922314594',
  ucdLib: "CANDESARTAN CRT 8MG CPR",
  UCD7: '9385579',
  UCD13: '3400893855799',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN CRT 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2201872',
  CIP13: '3400922018720',
  ucdLib: "CANDESARTAN EG 16MG CPR",
  UCD7: '9381831',
  UCD13: '3400893818312',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN EG 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2201903',
  CIP13: '3400922019031',
  ucdLib: "CANDESARTAN EG 16MG CPR",
  UCD7: '9381831',
  UCD13: '3400893818312',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN EG 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2202038',
  CIP13: '3400922020389',
  ucdLib: "CANDESARTAN EG 32MG CPR",
  UCD7: '9381848',
  UCD13: '3400893818480',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN EG 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2201576',
  CIP13: '3400922015767',
  ucdLib: "CANDESARTAN EG 4MG CPR",
  UCD7: '9381819',
  UCD13: '3400893818190',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN EG 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2201607',
  CIP13: '3400922016078',
  ucdLib: "CANDESARTAN EG 4MG CPR",
  UCD7: '9381819',
  UCD13: '3400893818190',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN EG 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2201688',
  CIP13: '3400922016887',
  ucdLib: "CANDESARTAN EG 8MG CPR",
  UCD7: '9381825',
  UCD13: '3400893818251',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN EG 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2201719',
  CIP13: '3400922017198',
  ucdLib: "CANDESARTAN EG 8MG CPR",
  UCD7: '9381825',
  UCD13: '3400893818251',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN EG 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2220622',
  CIP13: '3400922206226',
  ucdLib: "CANDESARTAN KRK 16MG CPR",
  UCD7: '9386113',
  UCD13: '3400893861134',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN KRK 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2220674',
  CIP13: '3400922206745',
  ucdLib: "CANDESARTAN KRK 16MG CPR",
  UCD7: '9386113',
  UCD13: '3400893861134',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN KRK 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2220869',
  CIP13: '3400922208695',
  ucdLib: "CANDESARTAN KRK 32MG CPR",
  UCD7: '9386136',
  UCD13: '3400893861363',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN KRK 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2220071',
  CIP13: '3400922200712',
  ucdLib: "CANDESARTAN KRK 4MG CPR",
  UCD7: '9386142',
  UCD13: '3400893861424',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN KRK 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2220125',
  CIP13: '3400922201252',
  ucdLib: "CANDESARTAN KRK 4MG CPR",
  UCD7: '9386142',
  UCD13: '3400893861424',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN KRK 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2220349',
  CIP13: '3400922203492',
  ucdLib: "CANDESARTAN KRK 8MG CPR",
  UCD7: '9386159',
  UCD13: '3400893861592',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN KRK 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2220390',
  CIP13: '3400922203904',
  ucdLib: "CANDESARTAN KRK 8MG CPR",
  UCD7: '9386159',
  UCD13: '3400893861592',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN KRK 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4164520',
  CIP13: '3400941645204',
  ucdLib: "CANDESARTAN MYL 16MG CPR",
  UCD7: '9375227',
  UCD13: '3400893752272',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN MYL 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4164218',
  CIP13: '3400941642180',
  ucdLib: "CANDESARTAN MYL 4MG CPR",
  UCD7: '9375256',
  UCD13: '3400893752562',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN MYL 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4164371',
  CIP13: '3400941643712',
  ucdLib: "CANDESARTAN MYL 8MG CPR",
  UCD7: '9375262',
  UCD13: '3400893752623',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN MYL 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2679473',
  CIP13: '3400926794736',
  ucdLib: "CANDESARTAN RBX 32MG CPR",
  UCD7: '9391628',
  UCD13: '3400893916285',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN RBX 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2183996',
  CIP13: '3400921839968',
  ucdLib: "CANDESARTAN ZYD 16MG CPR",
  UCD7: '9383126',
  UCD13: '3400893831267',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ZYD 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2184004',
  CIP13: '3400921840049',
  ucdLib: "CANDESARTAN ZYD 16MG CPR",
  UCD7: '9383126',
  UCD13: '3400893831267',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN ZYD 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '2173940',
  CIP13: '3400921739404',
  ucdLib: "CANDESARTAN ZYD 32MG CPR",
  UCD7: '9383132',
  UCD13: '3400893831328',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ZYD 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2232849',
  CIP13: '3400922328492',
  ucdLib: "CANDESARTAN ZYD 8MG CPR",
  UCD7: '9386780',
  UCD13: '3400893867808',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ZYD 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '2232855',
  CIP13: '3400922328553',
  ucdLib: "CANDESARTAN ZYD 8MG CPR",
  UCD7: '9386780',
  UCD13: '3400893867808',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN ZYD 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4962173',
  CIP13: '3400949621736',
  ucdLib: "CANDESARTAN ZEN 16MG CPR",
  UCD7: '9369793',
  UCD13: '3400893697931',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ZEN 16MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4962210',
  CIP13: '3400949622108',
  ucdLib: "CANDESARTAN ZEN 16MG CPR",
  UCD7: '9369793',
  UCD13: '3400893697931',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN ZEN 16MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4962279',
  CIP13: '3400949622795',
  ucdLib: "CANDESARTAN ZEN 32MG CPR",
  UCD7: '9369801',
  UCD13: '3400893698013',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ZEN 32MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4961713',
  CIP13: '3400949617135',
  ucdLib: "CANDESARTAN ZEN 4MG CPR",
  UCD7: '9369818',
  UCD13: '3400893698181',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ZEN 4MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4961759',
  CIP13: '3400949617593',
  ucdLib: "CANDESARTAN ZEN 4MG CPR",
  UCD7: '9369818',
  UCD13: '3400893698181',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN ZEN 4MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4962090',
  CIP13: '3400949620906',
  ucdLib: "CANDESARTAN ZEN 8MG CPR",
  UCD7: '9369824',
  UCD13: '3400893698242',
  ucdQtyMultiplicator: 30,
  cipLib: "CANDESARTAN ZEN 8MG CPR BT 30",
  atcCode: "C09CA06"
}, {
  CIP7: '4962121',
  CIP13: '3400949621217',
  ucdLib: "CANDESARTAN ZEN 8MG CPR",
  UCD7: '9369824',
  UCD13: '3400893698242',
  ucdQtyMultiplicator: 90,
  cipLib: "CANDESARTAN ZEN 8MG CPR BT 90",
  atcCode: "C09CA06"
}, {
  CIP7: '4910816',
  CIP13: '3400949108169',
  ucdLib: "IRBESARTAN ISD 150MG CPR",
  UCD7: '9357784',
  UCD13: '3400893577844',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ISD 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4910845',
  CIP13: '3400949108459',
  ucdLib: "IRBESARTAN ISD 150MG CPR",
  UCD7: '9357784',
  UCD13: '3400893577844',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ISD 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '4910733',
  CIP13: '3400949107339',
  ucdLib: "IRBESARTAN ISD 300MG CPR",
  UCD7: '9357790',
  UCD13: '3400893577905',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ISD 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4910779',
  CIP13: '3400949107797',
  ucdLib: "IRBESARTAN ISD 300MG CPR",
  UCD7: '9357790',
  UCD13: '3400893577905',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ISD 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '4910880',
  CIP13: '3400949108800',
  ucdLib: "IRBESARTAN ISD 75MG CPR",
  UCD7: '9357809',
  UCD13: '3400893578094',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ISD 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4910911',
  CIP13: '3400949109111',
  ucdLib: "IRBESARTAN ISD 75MG CPR",
  UCD7: '9357809',
  UCD13: '3400893578094',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ISD 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3411873',
  CIP13: '3400934118739',
  ucdLib: "IRBESARTAN ARL 300MG CPR",
  UCD7: '9357732',
  UCD13: '3400893577325',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ARL 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3801479',
  CIP13: '3400938014792',
  ucdLib: "APROVEL 150MG CPR PELL",
  UCD7: '9261334',
  UCD13: '3400892613345',
  ucdQtyMultiplicator: 30,
  cipLib: "APROVEL 150MG CPR PELL BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3801485',
  CIP13: '3400938014853',
  ucdLib: "APROVEL 150MG CPR PELL",
  UCD7: '9261334',
  UCD13: '3400892613345',
  ucdQtyMultiplicator: 90,
  cipLib: "APROVEL 150MG CPR PELL BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3801491',
  CIP13: '3400938014914',
  ucdLib: "APROVEL 300MG CPR PELL",
  UCD7: '9261340',
  UCD13: '3400892613406',
  ucdQtyMultiplicator: 30,
  cipLib: "APROVEL 300MG CPR PELL BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3801516',
  CIP13: '3400938015164',
  ucdLib: "APROVEL 300MG CPR PELL",
  UCD7: '9261340',
  UCD13: '3400892613406',
  ucdQtyMultiplicator: 90,
  cipLib: "APROVEL 300MG CPR PELL BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3801456',
  CIP13: '3400938014563',
  ucdLib: "APROVEL 75MG CPR PELL",
  UCD7: '9261357',
  UCD13: '3400892613574',
  ucdQtyMultiplicator: 30,
  cipLib: "APROVEL 75MG CPR PELL BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3801462',
  CIP13: '3400938014624',
  ucdLib: "APROVEL 75MG CPR PELL",
  UCD7: '9261357',
  UCD13: '3400892613574',
  ucdQtyMultiplicator: 90,
  cipLib: "APROVEL 75MG CPR PELL BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3862191',
  CIP13: '3400938621914',
  ucdLib: "IRBESARTAN EG 150MG CPR",
  UCD7: '9357643',
  UCD13: '3400893576434',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN EG 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3863204',
  CIP13: '3400938632040',
  ucdLib: "IRBESARTAN EG 150MG CPR",
  UCD7: '9357643',
  UCD13: '3400893576434',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN EG 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3867900',
  CIP13: '3400938679007',
  ucdLib: "IRBESARTAN EG 300MG CPR",
  UCD7: '9357666',
  UCD13: '3400893576663',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN EG 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3868118',
  CIP13: '3400938681185',
  ucdLib: "IRBESARTAN EG 300MG CPR",
  UCD7: '9357666',
  UCD13: '3400893576663',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN EG 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3860281',
  CIP13: '3400938602814',
  ucdLib: "IRBESARTAN EG 75MG CPR",
  UCD7: '9357672',
  UCD13: '3400893576724',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN EG 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3861760',
  CIP13: '3400938617603',
  ucdLib: "IRBESARTAN EG 75MG CPR",
  UCD7: '9357672',
  UCD13: '3400893576724',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN EG 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3927855',
  CIP13: '3400939278551',
  ucdLib: "IRBESARTAN RBX 150MG CPR",
  UCD7: '9339757',
  UCD13: '3400893397572',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN RBX 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3927890',
  CIP13: '3400939278902',
  ucdLib: "IRBESARTAN RBX 150MG CPR",
  UCD7: '9339757',
  UCD13: '3400893397572',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN RBX 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3927944',
  CIP13: '3400939279442',
  ucdLib: "IRBESARTAN RBX 300MG CPR",
  UCD7: '9339763',
  UCD13: '3400893397633',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN RBX 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3927996',
  CIP13: '3400939279961',
  ucdLib: "IRBESARTAN RBX 300MG CPR",
  UCD7: '9339763',
  UCD13: '3400893397633',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN RBX 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3927743',
  CIP13: '3400939277431',
  ucdLib: "IRBESARTAN RBX 75MG CPR",
  UCD7: '9339786',
  UCD13: '3400893397862',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN RBX 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3927795',
  CIP13: '3400939277950',
  ucdLib: "IRBESARTAN RBX 75MG CPR",
  UCD7: '9339786',
  UCD13: '3400893397862',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN RBX 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '5649461',
  CIP13: '3400956494613',
  ucdLib: "APROVEL 150MG CPR PELL D.U",
  UCD7: '9259136',
  UCD13: '3400892591360',
  ucdQtyMultiplicator: 56,
  cipLib: "APROVEL 150MG CPR PELL D.U BT 56",
  atcCode: "C09CA04"
}, {
  CIP7: '5649490',
  CIP13: '3400956494903',
  ucdLib: "APROVEL 300MG CPR PELL D.U",
  UCD7: '9259142',
  UCD13: '3400892591421',
  ucdQtyMultiplicator: 56,
  cipLib: "APROVEL 300MG CPR PELL D.U BT 56",
  atcCode: "C09CA04"
}, {
  CIP7: '5649432',
  CIP13: '3400956494323',
  ucdLib: "APROVEL 75MG CPR PELL D.U",
  UCD7: '9259159',
  UCD13: '3400892591599',
  ucdQtyMultiplicator: 56,
  cipLib: "APROVEL 75MG CPR PELL D.U BT 56",
  atcCode: "C09CA04"
}, {
  CIP7: '2216566',
  CIP13: '3400922165660',
  ucdLib: "IRBESARTAN BGA 150MG CPR",
  UCD7: '9384976',
  UCD13: '3400893849767',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN BGA 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216626',
  CIP13: '3400922166261',
  ucdLib: "IRBESARTAN BGA 150MG CPR",
  UCD7: '9384976',
  UCD13: '3400893849767',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN BGA 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2216715',
  CIP13: '3400922167152',
  ucdLib: "IRBESARTAN BGA 300MG CPR",
  UCD7: '9384982',
  UCD13: '3400893849828',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN BGA 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216796',
  CIP13: '3400922167961',
  ucdLib: "IRBESARTAN BGA 300MG CPR",
  UCD7: '9384982',
  UCD13: '3400893849828',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN BGA 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2216307',
  CIP13: '3400922163079',
  ucdLib: "IRBESARTAN BGA 75MG CPR",
  UCD7: '9384999',
  UCD13: '3400893849996',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN BGA 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216394',
  CIP13: '3400922163949',
  ucdLib: "IRBESARTAN BGA 75MG CPR",
  UCD7: '9384999',
  UCD13: '3400893849996',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN BGA 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3958904',
  CIP13: '3400939589046',
  ucdLib: "IRBESARTAN RTP 75MG CPR",
  UCD7: '9346243',
  UCD13: '3400893462430',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN RTP 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3950736',
  CIP13: '3400939507361',
  ucdLib: "IRBESARTAN SDZ 150MG CPR",
  UCD7: '9342127',
  UCD13: '3400893421277',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN SDZ 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3950794',
  CIP13: '3400939507941',
  ucdLib: "IRBESARTAN SDZ 150MG CPR",
  UCD7: '9342127',
  UCD13: '3400893421277',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN SDZ 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3951049',
  CIP13: '3400939510491',
  ucdLib: "IRBESARTAN SDZ 300MG CPR",
  UCD7: '9342133',
  UCD13: '3400893421338',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN SDZ 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3951109',
  CIP13: '3400939511092',
  ucdLib: "IRBESARTAN SDZ 300MG CPR",
  UCD7: '9342133',
  UCD13: '3400893421338',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN SDZ 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3950386',
  CIP13: '3400939503868',
  ucdLib: "IRBESARTAN SDZ 75MG CPR",
  UCD7: '9342156',
  UCD13: '3400893421567',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN SDZ 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3950452',
  CIP13: '3400939504520',
  ucdLib: "IRBESARTAN SDZ 75MG CPR",
  UCD7: '9342156',
  UCD13: '3400893421567',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN SDZ 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2216299',
  CIP13: '3400922162997',
  ucdLib: "IRBESARTAN TVC 150MG CPR",
  UCD7: '9383675',
  UCD13: '3400893836750',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN TVC 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216419',
  CIP13: '3400922164199',
  ucdLib: "IRBESARTAN TVC 150MG CPR",
  UCD7: '9383675',
  UCD13: '3400893836750',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN TVC 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2216448',
  CIP13: '3400922164489',
  ucdLib: "IRBESARTAN TVC 300MG CPR",
  UCD7: '9383681',
  UCD13: '3400893836811',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN TVC 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216514',
  CIP13: '3400922165141',
  ucdLib: "IRBESARTAN TVC 300MG CPR",
  UCD7: '9383681',
  UCD13: '3400893836811',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN TVC 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2216193',
  CIP13: '3400922161938',
  ucdLib: "IRBESARTAN TVC 75MG CPR",
  UCD7: '9383698',
  UCD13: '3400893836989',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN TVC 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216230',
  CIP13: '3400922162300',
  ucdLib: "IRBESARTAN TVC 75MG CPR",
  UCD7: '9383698',
  UCD13: '3400893836989',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN TVC 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2216141',
  CIP13: '3400922161419',
  ucdLib: "IRBESARTAN ZEN 150MG CPR",
  UCD7: '9385585',
  UCD13: '3400893855850',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ZEN 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216158',
  CIP13: '3400922161587',
  ucdLib: "IRBESARTAN ZEN 150MG CPR",
  UCD7: '9385585',
  UCD13: '3400893855850',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ZEN 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2216164',
  CIP13: '3400922161648',
  ucdLib: "IRBESARTAN ZEN 300MG CPR",
  UCD7: '9385591',
  UCD13: '3400893855911',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ZEN 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216170',
  CIP13: '3400922161709',
  ucdLib: "IRBESARTAN ZEN 300MG CPR",
  UCD7: '9385591',
  UCD13: '3400893855911',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ZEN 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2216129',
  CIP13: '3400922161297',
  ucdLib: "IRBESARTAN ZEN 75MG CPR",
  UCD7: '9385616',
  UCD13: '3400893856161',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ZEN 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2216135',
  CIP13: '3400922161358',
  ucdLib: "IRBESARTAN ZEN 75MG CPR",
  UCD7: '9385616',
  UCD13: '3400893856161',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ZEN 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2744058',
  CIP13: '3400927440588',
  ucdLib: "IRBESARTAN ARW 150MG CPR",
  UCD7: '9411667',
  UCD13: '3400894116677',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ARW 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2744064',
  CIP13: '3400927440649',
  ucdLib: "IRBESARTAN ARW 150MG CPR",
  UCD7: '9411667',
  UCD13: '3400894116677',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ARW 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2744087',
  CIP13: '3400927440878',
  ucdLib: "IRBESARTAN ARW 300MG CPR",
  UCD7: '9411673',
  UCD13: '3400894116738',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ARW 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2744093',
  CIP13: '3400927440939',
  ucdLib: "IRBESARTAN ARW 300MG CPR",
  UCD7: '9411673',
  UCD13: '3400894116738',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ARW 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2744029',
  CIP13: '3400927440298',
  ucdLib: "IRBESARTAN ARW 75MG CPR",
  UCD7: '9411696',
  UCD13: '3400894116967',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ARW 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2744035',
  CIP13: '3400927440359',
  ucdLib: "IRBESARTAN ARW 75MG CPR",
  UCD7: '9411696',
  UCD13: '3400894116967',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ARW 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2677557',
  CIP13: '3400926775575',
  ucdLib: "IFIRMASTA 150MG CPR",
  UCD7: '9389991',
  UCD13: '3400893899915',
  ucdQtyMultiplicator: 30,
  cipLib: "IFIRMASTA 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2677563',
  CIP13: '3400926775636',
  ucdLib: "IFIRMASTA 150MG CPR",
  UCD7: '9389991',
  UCD13: '3400893899915',
  ucdQtyMultiplicator: 90,
  cipLib: "IFIRMASTA 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2677586',
  CIP13: '3400926775865',
  ucdLib: "IFIRMASTA 300MG CPR",
  UCD7: '9390008',
  UCD13: '3400893900086',
  ucdQtyMultiplicator: 30,
  cipLib: "IFIRMASTA 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2677592',
  CIP13: '3400926775926',
  ucdLib: "IFIRMASTA 300MG CPR",
  UCD7: '9390008',
  UCD13: '3400893900086',
  ucdQtyMultiplicator: 90,
  cipLib: "IFIRMASTA 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2677534',
  CIP13: '3400926775346',
  ucdLib: "IFIRMASTA 75MG CPR",
  UCD7: '9390014',
  UCD13: '3400893900147',
  ucdQtyMultiplicator: 30,
  cipLib: "IFIRMASTA 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2677540',
  CIP13: '3400926775407',
  ucdLib: "IFIRMASTA 75MG CPR",
  UCD7: '9390014',
  UCD13: '3400893900147',
  ucdQtyMultiplicator: 90,
  cipLib: "IFIRMASTA 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2738419',
  CIP13: '3400927384196',
  ucdLib: "IRBESARTAN ACC 150MG CPR",
  UCD7: '9392680',
  UCD13: '3400893926802',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ACC 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2738425',
  CIP13: '3400927384257',
  ucdLib: "IRBESARTAN ACC 150MG CPR",
  UCD7: '9392680',
  UCD13: '3400893926802',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ACC 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2738431',
  CIP13: '3400927384318',
  ucdLib: "IRBESARTAN ACC 300MG CPR",
  UCD7: '9392697',
  UCD13: '3400893926970',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ACC 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2738448',
  CIP13: '3400927384486',
  ucdLib: "IRBESARTAN ACC 300MG CPR",
  UCD7: '9392697',
  UCD13: '3400893926970',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ACC 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2738394',
  CIP13: '3400927383946',
  ucdLib: "IRBESARTAN ACC 75MG CPR",
  UCD7: '9392705',
  UCD13: '3400893927052',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ACC 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2738402',
  CIP13: '3400927384028',
  ucdLib: "IRBESARTAN ACC 75MG CPR",
  UCD7: '9392705',
  UCD13: '3400893927052',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ACC 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2186664',
  CIP13: '3400921866643',
  ucdLib: "IRBESARTAN MYL 150MG CPR",
  UCD7: '9383250',
  UCD13: '3400893832509',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN MYL 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2186724',
  CIP13: '3400921867244',
  ucdLib: "IRBESARTAN MYL 150MG CPR",
  UCD7: '9383250',
  UCD13: '3400893832509',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN MYL 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2186799',
  CIP13: '3400921867992',
  ucdLib: "IRBESARTAN MYL 300MG CPR",
  UCD7: '9383267',
  UCD13: '3400893832677',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN MYL 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2186865',
  CIP13: '3400921868654',
  ucdLib: "IRBESARTAN MYL 300MG CPR",
  UCD7: '9383267',
  UCD13: '3400893832677',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN MYL 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2186546',
  CIP13: '3400921865462',
  ucdLib: "IRBESARTAN MYL 75MG CPR",
  UCD7: '9383273',
  UCD13: '3400893832738',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN MYL 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2186606',
  CIP13: '3400921866063',
  ucdLib: "IRBESARTAN MYL 75MG CPR",
  UCD7: '9383273',
  UCD13: '3400893832738',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN MYL 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '4180306',
  CIP13: '3400941803062',
  ucdLib: "IRBESARTAN PHR 150MG CPR",
  UCD7: '9375948',
  UCD13: '3400893759486',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN PHR 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4180358',
  CIP13: '3400941803581',
  ucdLib: "IRBESARTAN PHR 150MG CPR",
  UCD7: '9375948',
  UCD13: '3400893759486',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN PHR 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '4180418',
  CIP13: '3400941804182',
  ucdLib: "IRBESARTAN PHR 300MG CPR",
  UCD7: '9375954',
  UCD13: '3400893759547',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN PHR 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4180476',
  CIP13: '3400941804762',
  ucdLib: "IRBESARTAN PHR 300MG CPR",
  UCD7: '9375954',
  UCD13: '3400893759547',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN PHR 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '4180186',
  CIP13: '3400941801860',
  ucdLib: "IRBESARTAN PHR 75MG CPR",
  UCD7: '9375960',
  UCD13: '3400893759608',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN PHR 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4180246',
  CIP13: '3400941802461',
  ucdLib: "IRBESARTAN PHR 75MG CPR",
  UCD7: '9375960',
  UCD13: '3400893759608',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN PHR 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3990960',
  CIP13: '3400939909608',
  ucdLib: "IRBESARTAN ZYD 150MG CPR",
  UCD7: '9349402',
  UCD13: '3400893494028',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ZYD 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3991474',
  CIP13: '3400939914749',
  ucdLib: "IRBESARTAN ZYD 150MG CPR",
  UCD7: '9349402',
  UCD13: '3400893494028',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ZYD 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3991416',
  CIP13: '3400939914169',
  ucdLib: "IRBESARTAN ZYD 300MG CPR",
  UCD7: '9349419',
  UCD13: '3400893494196',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ZYD 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3991445',
  CIP13: '3400939914459',
  ucdLib: "IRBESARTAN ZYD 300MG CPR",
  UCD7: '9349419',
  UCD13: '3400893494196',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ZYD 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3990434',
  CIP13: '3400939904344',
  ucdLib: "IRBESARTAN ZYD 75MG CPR",
  UCD7: '9349425',
  UCD13: '3400893494257',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN ZYD 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '3990463',
  CIP13: '3400939904634',
  ucdLib: "IRBESARTAN ZYD 75MG CPR",
  UCD7: '9349425',
  UCD13: '3400893494257',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN ZYD 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '4962517',
  CIP13: '3400949625178',
  ucdLib: "IRBESARTAN CRT 150MG CPR",
  UCD7: '9366932',
  UCD13: '3400893669327',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN CRT 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4962552',
  CIP13: '3400949625529',
  ucdLib: "IRBESARTAN CRT 150MG CPR",
  UCD7: '9366932',
  UCD13: '3400893669327',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN CRT 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '4962598',
  CIP13: '3400949625987',
  ucdLib: "IRBESARTAN CRT 300MG CPR",
  UCD7: '9366949',
  UCD13: '3400893669495',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN CRT 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4962629',
  CIP13: '3400949626298',
  ucdLib: "IRBESARTAN CRT 300MG CPR",
  UCD7: '9366949',
  UCD13: '3400893669495',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN CRT 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '4962434',
  CIP13: '3400949624348',
  ucdLib: "IRBESARTAN CRT 75MG CPR",
  UCD7: '9366955',
  UCD13: '3400893669556',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN CRT 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '4962463',
  CIP13: '3400949624638',
  ucdLib: "IRBESARTAN CRT 75MG CPR",
  UCD7: '9366955',
  UCD13: '3400893669556',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN CRT 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2771227',
  CIP13: '3400927712272',
  ucdLib: "IRBESARTAN EVO 150MG CPR",
  UCD7: '9417776',
  UCD13: '3400894177760',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN EVO 150MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2771262',
  CIP13: '3400927712623',
  ucdLib: "IRBESARTAN EVO 150MG CPR",
  UCD7: '9417776',
  UCD13: '3400894177760',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN EVO 150MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2771291',
  CIP13: '3400927712913',
  ucdLib: "IRBESARTAN EVO 300MG CPR",
  UCD7: '9417782',
  UCD13: '3400894177821',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN EVO 300MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2771339',
  CIP13: '3400927713392',
  ucdLib: "IRBESARTAN EVO 300MG CPR",
  UCD7: '9417782',
  UCD13: '3400894177821',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN EVO 300MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '2771150',
  CIP13: '3400927711503',
  ucdLib: "IRBESARTAN EVO 75MG CPR",
  UCD7: '9417799',
  UCD13: '3400894177999',
  ucdQtyMultiplicator: 30,
  cipLib: "IRBESARTAN EVO 75MG CPR BT 30",
  atcCode: "C09CA04"
}, {
  CIP7: '2771196',
  CIP13: '3400927711961',
  ucdLib: "IRBESARTAN EVO 75MG CPR",
  UCD7: '9417799',
  UCD13: '3400894177999',
  ucdQtyMultiplicator: 90,
  cipLib: "IRBESARTAN EVO 75MG CPR BT 90",
  atcCode: "C09CA04"
}, {
  CIP7: '3000773',
  CIP13: '3400930007730',
  ucdLib: "VALSARTAN ARL 160MG CPR",
  UCD7: '9408116',
  UCD13: '3400894081166',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ARL 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3000771',
  CIP13: '3400930007716',
  ucdLib: "VALSARTAN ARL 40MG CPR",
  UCD7: '9408122',
  UCD13: '3400894081227',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ARL 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3000772',
  CIP13: '3400930007723',
  ucdLib: "VALSARTAN ARL 80MG CPR",
  UCD7: '9408139',
  UCD13: '3400894081395',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ARL 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4914748',
  CIP13: '3400949147489',
  ucdLib: "TAREG 3MG/ML BUV FL160ML",
  UCD7: '9373702',
  UCD13: '3400893737026',
  ucdQtyMultiplicator: 1,
  cipLib: "TAREG 3MG/ML BUV FL160ML BT 1",
  atcCode: "C09CA03"
}, {
  CIP7: '4910667',
  CIP13: '3400949106677',
  ucdLib: "VALSARTAN EG 160MG CPR",
  UCD7: '9358631',
  UCD13: '3400893586310',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN EG 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4910704',
  CIP13: '3400949107049',
  ucdLib: "VALSARTAN EG 160MG CPR",
  UCD7: '9358631',
  UCD13: '3400893586310',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN EG 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4910549',
  CIP13: '3400949105496',
  ucdLib: "VALSARTAN EG 40MG CPR",
  UCD7: '9358648',
  UCD13: '3400893586488',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN EG 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4910578',
  CIP13: '3400949105786',
  ucdLib: "VALSARTAN EG 40MG CPR",
  UCD7: '9358648',
  UCD13: '3400893586488',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN EG 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4910609',
  CIP13: '3400949106097',
  ucdLib: "VALSARTAN EG 80MG CPR",
  UCD7: '9358654',
  UCD13: '3400893586549',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN EG 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4910638',
  CIP13: '3400949106387',
  ucdLib: "VALSARTAN EG 80MG CPR",
  UCD7: '9358654',
  UCD13: '3400893586549',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN EG 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3815524',
  CIP13: '3400938155242',
  ucdLib: "TAREG 160MG CPR",
  UCD7: '9236069',
  UCD13: '3400892360690',
  ucdQtyMultiplicator: 30,
  cipLib: "TAREG 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3815530',
  CIP13: '3400938155303',
  ucdLib: "TAREG 160MG CPR",
  UCD7: '9236069',
  UCD13: '3400892360690',
  ucdQtyMultiplicator: 56,
  cipLib: "TAREG 160MG CPR BT 56",
  atcCode: "C09CA03"
}, {
  CIP7: '3815553',
  CIP13: '3400938155532',
  ucdLib: "TAREG 160MG CPR",
  UCD7: '9236069',
  UCD13: '3400892360690',
  ucdQtyMultiplicator: 90,
  cipLib: "TAREG 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3815406',
  CIP13: '3400938154061',
  ucdLib: "TAREG 40MG CPR SECAB",
  UCD7: '9284708',
  UCD13: '3400892847085',
  ucdQtyMultiplicator: 30,
  cipLib: "TAREG 40MG CPR SECAB BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3815412',
  CIP13: '3400938154122',
  ucdLib: "TAREG 40MG CPR SECAB",
  UCD7: '9284708',
  UCD13: '3400892847085',
  ucdQtyMultiplicator: 56,
  cipLib: "TAREG 40MG CPR SECAB BT 56",
  atcCode: "C09CA03"
}, {
  CIP7: '3815435',
  CIP13: '3400938154351',
  ucdLib: "TAREG 40MG CPR SECAB",
  UCD7: '9284708',
  UCD13: '3400892847085',
  ucdQtyMultiplicator: 90,
  cipLib: "TAREG 40MG CPR SECAB BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3815464',
  CIP13: '3400938154641',
  ucdLib: "TAREG 80MG CPR",
  UCD7: '9236081',
  UCD13: '3400892360812',
  ucdQtyMultiplicator: 30,
  cipLib: "TAREG 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3815470',
  CIP13: '3400938154702',
  ucdLib: "TAREG 80MG CPR",
  UCD7: '9236081',
  UCD13: '3400892360812',
  ucdQtyMultiplicator: 56,
  cipLib: "TAREG 80MG CPR BT 56",
  atcCode: "C09CA03"
}, {
  CIP7: '3815493',
  CIP13: '3400938154931',
  ucdLib: "TAREG 80MG CPR",
  UCD7: '9236081',
  UCD13: '3400892360812',
  ucdQtyMultiplicator: 90,
  cipLib: "TAREG 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3790706',
  CIP13: '3400937907064',
  ucdLib: "NISIS 160MG CPR",
  UCD7: '9236023',
  UCD13: '3400892360232',
  ucdQtyMultiplicator: 30,
  cipLib: "NISIS 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3790735',
  CIP13: '3400937907354',
  ucdLib: "NISIS 160MG CPR",
  UCD7: '9236023',
  UCD13: '3400892360232',
  ucdQtyMultiplicator: 90,
  cipLib: "NISIS 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3790563',
  CIP13: '3400937905633',
  ucdLib: "NISIS 40MG CPR SECAB",
  UCD7: '9285091',
  UCD13: '3400892850917',
  ucdQtyMultiplicator: 30,
  cipLib: "NISIS 40MG CPR SECAB BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3790600',
  CIP13: '3400937906005',
  ucdLib: "NISIS 40MG CPR SECAB",
  UCD7: '9285091',
  UCD13: '3400892850917',
  ucdQtyMultiplicator: 90,
  cipLib: "NISIS 40MG CPR SECAB BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3790646',
  CIP13: '3400937906463',
  ucdLib: "NISIS 80MG CPR",
  UCD7: '9236052',
  UCD13: '3400892360522',
  ucdQtyMultiplicator: 30,
  cipLib: "NISIS 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3790675',
  CIP13: '3400937906753',
  ucdLib: "NISIS 80MG CPR",
  UCD7: '9236052',
  UCD13: '3400892360522',
  ucdQtyMultiplicator: 90,
  cipLib: "NISIS 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4971491',
  CIP13: '3400949714919',
  ucdLib: "VALSARTAN PHR 160MG CPR",
  UCD7: '9367819',
  UCD13: '3400893678190',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN PHR 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4971723',
  CIP13: '3400949717231',
  ucdLib: "VALSARTAN PHR 160MG CPR",
  UCD7: '9367819',
  UCD13: '3400893678190',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN PHR 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4971108',
  CIP13: '3400949711086',
  ucdLib: "VALSARTAN PHR 40MG CPR",
  UCD7: '9367825',
  UCD13: '3400893678251',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN PHR 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4971315',
  CIP13: '3400949713158',
  ucdLib: "VALSARTAN PHR 80MG CPR",
  UCD7: '9367831',
  UCD13: '3400893678312',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN PHR 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4971350',
  CIP13: '3400949713509',
  ucdLib: "VALSARTAN PHR 80MG CPR",
  UCD7: '9367831',
  UCD13: '3400893678312',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN PHR 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3963897',
  CIP13: '3400939638973',
  ucdLib: "VALSARTAN TVC 160MG CPR",
  UCD7: '9344729',
  UCD13: '3400893447291',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN TVC 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3963986',
  CIP13: '3400939639864',
  ucdLib: "VALSARTAN TVC 160MG CPR",
  UCD7: '9344729',
  UCD13: '3400893447291',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN TVC 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3963093',
  CIP13: '3400939630939',
  ucdLib: "VALSARTAN TVC 40MG CPR",
  UCD7: '9344735',
  UCD13: '3400893447352',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN TVC 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3963130',
  CIP13: '3400939631301',
  ucdLib: "VALSARTAN TVC 40MG CPR",
  UCD7: '9344735',
  UCD13: '3400893447352',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN TVC 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3963615',
  CIP13: '3400939636153',
  ucdLib: "VALSARTAN TVC 80MG CPR",
  UCD7: '9344741',
  UCD13: '3400893447413',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN TVC 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3963704',
  CIP13: '3400939637044',
  ucdLib: "VALSARTAN TVC 80MG CPR",
  UCD7: '9344741',
  UCD13: '3400893447413',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN TVC 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4191959',
  CIP13: '3400941919596',
  ucdLib: "VALSARTAN ARG 160MG CPR",
  UCD7: '9349980',
  UCD13: '3400893499801',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ARG 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4191729',
  CIP13: '3400941917295',
  ucdLib: "VALSARTAN ARG 40MG CPR",
  UCD7: '9349997',
  UCD13: '3400893499979',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ARG 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4191907',
  CIP13: '3400941919077',
  ucdLib: "VALSARTAN ARG 80MG CPR",
  UCD7: '9350003',
  UCD13: '3400893500033',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ARG 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2668883',
  CIP13: '3400926688837',
  ucdLib: "VALSARTAN ARL 160MG CPR",
  UCD7: '9408116',
  UCD13: '3400894081166',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ARL 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2668647',
  CIP13: '3400926686475',
  ucdLib: "VALSARTAN ARL 40MG CPR",
  UCD7: '9408122',
  UCD13: '3400894081227',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ARL 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2668771',
  CIP13: '3400926687717',
  ucdLib: "VALSARTAN ARL 80MG CPR",
  UCD7: '9408139',
  UCD13: '3400894081395',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ARL 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4171595',
  CIP13: '3400941715952',
  ucdLib: "VALSARTAN EVO 160MG CPR",
  UCD7: '9349744',
  UCD13: '3400893497449',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN EVO 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4171603',
  CIP13: '3400941716034',
  ucdLib: "VALSARTAN EVO 160MG CPR",
  UCD7: '9349744',
  UCD13: '3400893497449',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN EVO 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4171543',
  CIP13: '3400941715433',
  ucdLib: "VALSARTAN EVO 40MG CPR",
  UCD7: '9349750',
  UCD13: '3400893497500',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN EVO 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4171566',
  CIP13: '3400941715662',
  ucdLib: "VALSARTAN EVO 40MG CPR",
  UCD7: '9349750',
  UCD13: '3400893497500',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN EVO 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4171572',
  CIP13: '3400941715723',
  ucdLib: "VALSARTAN EVO 80MG CPR",
  UCD7: '9349767',
  UCD13: '3400893497678',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN EVO 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4171589',
  CIP13: '3400941715891',
  ucdLib: "VALSARTAN EVO 80MG CPR",
  UCD7: '9349767',
  UCD13: '3400893497678',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN EVO 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4933237',
  CIP13: '3400949332373',
  ucdLib: "VALSARTAN SDZ 160MG CPR",
  UCD7: '9360763',
  UCD13: '3400893607633',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN SDZ 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4933303',
  CIP13: '3400949333035',
  ucdLib: "VALSARTAN SDZ 160MG CPR",
  UCD7: '9360763',
  UCD13: '3400893607633',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN SDZ 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4932203',
  CIP13: '3400949322039',
  ucdLib: "VALSARTAN SDZ 40MG CPR",
  UCD7: '9360786',
  UCD13: '3400893607862',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN SDZ 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4932278',
  CIP13: '3400949322787',
  ucdLib: "VALSARTAN SDZ 40MG CPR",
  UCD7: '9360786',
  UCD13: '3400893607862',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN SDZ 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4932746',
  CIP13: '3400949327461',
  ucdLib: "VALSARTAN SDZ 80MG CPR",
  UCD7: '9360792',
  UCD13: '3400893607923',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN SDZ 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4932806',
  CIP13: '3400949328062',
  ucdLib: "VALSARTAN SDZ 80MG CPR",
  UCD7: '9360792',
  UCD13: '3400893607923',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN SDZ 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4931221',
  CIP13: '3400949312214',
  ucdLib: "VALSARTAN ZEN 160MG CPR",
  UCD7: '9362526',
  UCD13: '3400893625262',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ZEN 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4931244',
  CIP13: '3400949312443',
  ucdLib: "VALSARTAN ZEN 160MG CPR",
  UCD7: '9362526',
  UCD13: '3400893625262',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ZEN 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4931126',
  CIP13: '3400949311262',
  ucdLib: "VALSARTAN ZEN 40MG CPR",
  UCD7: '9362532',
  UCD13: '3400893625323',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ZEN 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4931149',
  CIP13: '3400949311491',
  ucdLib: "VALSARTAN ZEN 40MG CPR",
  UCD7: '9362532',
  UCD13: '3400893625323',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ZEN 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4931178',
  CIP13: '3400949311781',
  ucdLib: "VALSARTAN ZEN 80MG CPR",
  UCD7: '9362549',
  UCD13: '3400893625491',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ZEN 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4931190',
  CIP13: '3400949311903',
  ucdLib: "VALSARTAN ZEN 80MG CPR",
  UCD7: '9362549',
  UCD13: '3400893625491',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ZEN 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4928957',
  CIP13: '3400949289578',
  ucdLib: "VALSARTAN BGA 160MG CPR",
  UCD7: '9349170',
  UCD13: '3400893491706',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN BGA 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4928963',
  CIP13: '3400949289639',
  ucdLib: "VALSARTAN BGA 160MG CPR",
  UCD7: '9349170',
  UCD13: '3400893491706',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN BGA 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4928816',
  CIP13: '3400949288168',
  ucdLib: "VALSARTAN BGA 40MG CPR",
  UCD7: '9349187',
  UCD13: '3400893491874',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN BGA 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4928822',
  CIP13: '3400949288229',
  ucdLib: "VALSARTAN BGA 40MG CPR",
  UCD7: '9349187',
  UCD13: '3400893491874',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN BGA 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4928845',
  CIP13: '3400949288458',
  ucdLib: "VALSARTAN BGA 40MG CPR",
  UCD7: '9349187',
  UCD13: '3400893491874',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN BGA 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4928880',
  CIP13: '3400949288809',
  ucdLib: "VALSARTAN BGA 80MG CPR",
  UCD7: '9349193',
  UCD13: '3400893491935',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN BGA 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4928897',
  CIP13: '3400949288977',
  ucdLib: "VALSARTAN BGA 80MG CPR",
  UCD7: '9349193',
  UCD13: '3400893491935',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN BGA 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4928911',
  CIP13: '3400949289110',
  ucdLib: "VALSARTAN BGA 80MG CPR",
  UCD7: '9349193',
  UCD13: '3400893491935',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN BGA 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2240748',
  CIP13: '3400922407487',
  ucdLib: "VALSARTAN CRT 160MG CPR",
  UCD7: '9350109',
  UCD13: '3400893501092',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN CRT 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2240754',
  CIP13: '3400922407548',
  ucdLib: "VALSARTAN CRT 160MG CPR",
  UCD7: '9350109',
  UCD13: '3400893501092',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN CRT 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2240694',
  CIP13: '3400922406947',
  ucdLib: "VALSARTAN CRT 40MG CPR",
  UCD7: '9350115',
  UCD13: '3400893501153',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN CRT 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2240702',
  CIP13: '3400922407029',
  ucdLib: "VALSARTAN CRT 40MG CPR",
  UCD7: '9350115',
  UCD13: '3400893501153',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN CRT 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2240719',
  CIP13: '3400922407197',
  ucdLib: "VALSARTAN CRT 80MG CPR",
  UCD7: '9350121',
  UCD13: '3400893501214',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN CRT 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2240725',
  CIP13: '3400922407258',
  ucdLib: "VALSARTAN CRT 80MG CPR",
  UCD7: '9350121',
  UCD13: '3400893501214',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN CRT 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4925999',
  CIP13: '3400949259991',
  ucdLib: "VALSARTAN ISD 160MG CPR",
  UCD7: '9359984',
  UCD13: '3400893599846',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ISD 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4925700',
  CIP13: '3400949257003',
  ucdLib: "VALSARTAN ISD 40MG CPR",
  UCD7: '9359990',
  UCD13: '3400893599907',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ISD 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4925746',
  CIP13: '3400949257461',
  ucdLib: "VALSARTAN ISD 40MG CPR",
  UCD7: '9359990',
  UCD13: '3400893599907',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ISD 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4925835',
  CIP13: '3400949258352',
  ucdLib: "VALSARTAN ISD 80MG CPR",
  UCD7: '9360007',
  UCD13: '3400893600078',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ISD 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4925864',
  CIP13: '3400949258642',
  ucdLib: "VALSARTAN ISD 80MG CPR",
  UCD7: '9360007',
  UCD13: '3400893600078',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ISD 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2244918',
  CIP13: '3400922449180',
  ucdLib: "VALSARTAN KRK 160MG CPR",
  UCD7: '9352462',
  UCD13: '3400893524626',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN KRK 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2244924',
  CIP13: '3400922449241',
  ucdLib: "VALSARTAN KRK 160MG CPR",
  UCD7: '9352462',
  UCD13: '3400893524626',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN KRK 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2244870',
  CIP13: '3400922448701',
  ucdLib: "VALSARTAN KRK 40MG CPR",
  UCD7: '9352479',
  UCD13: '3400893524794',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN KRK 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2244887',
  CIP13: '3400922448879',
  ucdLib: "VALSARTAN KRK 40MG CPR",
  UCD7: '9352479',
  UCD13: '3400893524794',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN KRK 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2244893',
  CIP13: '3400922448930',
  ucdLib: "VALSARTAN KRK 80MG CPR",
  UCD7: '9352485',
  UCD13: '3400893524855',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN KRK 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2244901',
  CIP13: '3400922449012',
  ucdLib: "VALSARTAN KRK 80MG CPR",
  UCD7: '9352485',
  UCD13: '3400893524855',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN KRK 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2236729',
  CIP13: '3400922367293',
  ucdLib: "VALSARTAN MYP 160MG CPR",
  UCD7: '9392941',
  UCD13: '3400893929414',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN MYP 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2236741',
  CIP13: '3400922367415',
  ucdLib: "VALSARTAN MYP 160MG CPR",
  UCD7: '9392941',
  UCD13: '3400893929414',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN MYP 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2236451',
  CIP13: '3400922364513',
  ucdLib: "VALSARTAN MYP 40MG CPR",
  UCD7: '9392958',
  UCD13: '3400893929582',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN MYP 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2236474',
  CIP13: '3400922364742',
  ucdLib: "VALSARTAN MYP 40MG CPR",
  UCD7: '9392958',
  UCD13: '3400893929582',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN MYP 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2236540',
  CIP13: '3400922365404',
  ucdLib: "VALSARTAN MYP 80MG CPR",
  UCD7: '9392964',
  UCD13: '3400893929643',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN MYP 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2236652',
  CIP13: '3400922366524',
  ucdLib: "VALSARTAN MYP 80MG CPR",
  UCD7: '9392964',
  UCD13: '3400893929643',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN MYP 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3994314',
  CIP13: '3400939943145',
  ucdLib: "VALSARTAN RBX 160MG CPR",
  UCD7: '9350026',
  UCD13: '3400893500262',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN RBX 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3994343',
  CIP13: '3400939943435',
  ucdLib: "VALSARTAN RBX 160MG CPR",
  UCD7: '9350026',
  UCD13: '3400893500262',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN RBX 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3994981',
  CIP13: '3400939949819',
  ucdLib: "VALSARTAN RBX 40MG CPR",
  UCD7: '9350032',
  UCD13: '3400893500323',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN RBX 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3995012',
  CIP13: '3400939950129',
  ucdLib: "VALSARTAN RBX 40MG CPR",
  UCD7: '9350032',
  UCD13: '3400893500323',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN RBX 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3994917',
  CIP13: '3400939949178',
  ucdLib: "VALSARTAN RBX 80MG CPR",
  UCD7: '9350049',
  UCD13: '3400893500491',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN RBX 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '3994952',
  CIP13: '3400939949529',
  ucdLib: "VALSARTAN RBX 80MG CPR",
  UCD7: '9350049',
  UCD13: '3400893500491',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN RBX 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4926378',
  CIP13: '3400949263783',
  ucdLib: "VALSARTAN RTP 160MG CPR",
  UCD7: '9360013',
  UCD13: '3400893600139',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN RTP 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4926409',
  CIP13: '3400949264094',
  ucdLib: "VALSARTAN RTP 160MG CPR",
  UCD7: '9360013',
  UCD13: '3400893600139',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN RTP 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4926094',
  CIP13: '3400949260942',
  ucdLib: "VALSARTAN RTP 40MG CPR",
  UCD7: '9360036',
  UCD13: '3400893600368',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN RTP 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4926125',
  CIP13: '3400949261253',
  ucdLib: "VALSARTAN RTP 40MG CPR",
  UCD7: '9360036',
  UCD13: '3400893600368',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN RTP 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '4926220',
  CIP13: '3400949262205',
  ucdLib: "VALSARTAN RTP 80MG CPR",
  UCD7: '9360042',
  UCD13: '3400893600429',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN RTP 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '4926266',
  CIP13: '3400949262663',
  ucdLib: "VALSARTAN RTP 80MG CPR",
  UCD7: '9360042',
  UCD13: '3400893600429',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN RTP 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2209520',
  CIP13: '3400922095202',
  ucdLib: "VALSARTAN ZYD 160MG CPR",
  UCD7: '9405460',
  UCD13: '3400894054603',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ZYD 160MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2209537',
  CIP13: '3400922095370',
  ucdLib: "VALSARTAN ZYD 160MG CPR",
  UCD7: '9405460',
  UCD13: '3400894054603',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ZYD 160MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2209477',
  CIP13: '3400922094779',
  ucdLib: "VALSARTAN ZYD 40MG CPR",
  UCD7: '9405477',
  UCD13: '3400894054771',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ZYD 40MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2209483',
  CIP13: '3400922094830',
  ucdLib: "VALSARTAN ZYD 40MG CPR",
  UCD7: '9405477',
  UCD13: '3400894054771',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ZYD 40MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '2209508',
  CIP13: '3400922095080',
  ucdLib: "VALSARTAN ZYD 80MG CPR",
  UCD7: '9405483',
  UCD13: '3400894054832',
  ucdQtyMultiplicator: 30,
  cipLib: "VALSARTAN ZYD 80MG CPR BT 30",
  atcCode: "C09CA03"
}, {
  CIP7: '2209514',
  CIP13: '3400922095141',
  ucdLib: "VALSARTAN ZYD 80MG CPR",
  UCD7: '9405483',
  UCD13: '3400894054832',
  ucdQtyMultiplicator: 90,
  cipLib: "VALSARTAN ZYD 80MG CPR BT 90",
  atcCode: "C09CA03"
}, {
  CIP7: '3563548',
  CIP13: '3400935635488',
  ucdLib: "TEVETEN 300MG CPR",
  UCD7: '9207665',
  UCD13: '3400892076652',
  ucdQtyMultiplicator: 56,
  cipLib: "TEVETEN 300MG CPR BT 56",
  atcCode: "C09CA02"
}, {
  CIP7: '3720605',
  CIP13: '3400937206051',
  ucdLib: "TEVETEN 300MG CPR",
  UCD7: '9207665',
  UCD13: '3400892076652',
  ucdQtyMultiplicator: 168,
  cipLib: "TEVETEN 300MG CPR BT 168",
  atcCode: "C09CA02"
}, {
  CIP7: '3835656',
  CIP13: '3400938356564',
  ucdLib: "LOSARTAN MYL 100MG CPR",
  UCD7: '9315426',
  UCD13: '3400893154267',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN MYL 100MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3835691',
  CIP13: '3400938356915',
  ucdLib: "LOSARTAN MYL 100MG CPR",
  UCD7: '9315426',
  UCD13: '3400893154267',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN MYL 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3835550',
  CIP13: '3400938355505',
  ucdLib: "LOSARTAN MYL 50MG CPR",
  UCD7: '9318488',
  UCD13: '3400893184882',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN MYL 50MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3835604',
  CIP13: '3400938356045',
  ucdLib: "LOSARTAN MYL 50MG CPR",
  UCD7: '9318488',
  UCD13: '3400893184882',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN MYL 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3830162',
  CIP13: '3400938301625',
  ucdLib: "LOSARTAN TVC 100MG CPR",
  UCD7: '9313858',
  UCD13: '3400893138588',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN TVC 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3830268',
  CIP13: '3400938302684',
  ucdLib: "LOSARTAN TVC 100MG CPR",
  UCD7: '9313858',
  UCD13: '3400893138588',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN TVC 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3000429',
  CIP13: '3400930004296',
  ucdLib: "LOSARTAN BGA 50MG CPR",
  UCD7: '9330348',
  UCD13: '3400893303481',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN BGA 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3857511',
  CIP13: '3400938575118',
  ucdLib: "LOSARTAN ACT 100MG CPR",
  UCD7: '9320278',
  UCD13: '3400893202784',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN ACT 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3857534',
  CIP13: '3400938575347',
  ucdLib: "LOSARTAN EVO 100MG CPR",
  UCD7: '9320261',
  UCD13: '3400893202616',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN EVO 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3857557',
  CIP13: '3400938575576',
  ucdLib: "LOSARTAN TOR 100MG CPR",
  UCD7: '9320284',
  UCD13: '3400893202845',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN TOR 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3852927',
  CIP13: '3400938529272',
  ucdLib: "LOSARTAN ZYD 100MG CPR",
  UCD7: '9318525',
  UCD13: '3400893185254',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN ZYD 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3852956',
  CIP13: '3400938529562',
  ucdLib: "LOSARTAN ZYD 100MG CPR",
  UCD7: '9318525',
  UCD13: '3400893185254',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ZYD 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3852784',
  CIP13: '3400938527841',
  ucdLib: "LOSARTAN ZYD 50MG CPR",
  UCD7: '9318548',
  UCD13: '3400893185483',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN ZYD 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3852815',
  CIP13: '3400938528152',
  ucdLib: "LOSARTAN ZYD 50MG CPR",
  UCD7: '9318548',
  UCD13: '3400893185483',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ZYD 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3584958',
  CIP13: '3400935849588',
  ucdLib: "COZAAR 100MG CPR",
  UCD7: '9248931',
  UCD13: '3400892489315',
  ucdQtyMultiplicator: 28,
  cipLib: "COZAAR 100MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3385242',
  CIP13: '3400933852429',
  ucdLib: "COZAAR 50MG CPR",
  UCD7: '9171192',
  UCD13: '3400891711929',
  ucdQtyMultiplicator: 28,
  cipLib: "COZAAR 50MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3714504',
  CIP13: '3400937145046',
  ucdLib: "COZAAR 100MG CPR",
  UCD7: '9248931',
  UCD13: '3400892489315',
  ucdQtyMultiplicator: 90,
  cipLib: "COZAAR 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3714616',
  CIP13: '3400937146166',
  ucdLib: "COZAAR 50MG CPR",
  UCD7: '9171192',
  UCD13: '3400891711929',
  ucdQtyMultiplicator: 90,
  cipLib: "COZAAR 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3829851',
  CIP13: '3400938298512',
  ucdLib: "LOSARTAN TVC 50MG CPR",
  UCD7: '9313864',
  UCD13: '3400893138649',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN TVC 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3829940',
  CIP13: '3400938299403',
  ucdLib: "LOSARTAN TVC 50MG CPR",
  UCD7: '9313864',
  UCD13: '3400893138649',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN TVC 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3751557',
  CIP13: '3400937515573',
  ucdLib: "LOSARTAN ACC 100MG CPR",
  UCD7: '9353757',
  UCD13: '3400893537572',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN ACC 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3751592',
  CIP13: '3400937515924',
  ucdLib: "LOSARTAN ACC 100MG CPR",
  UCD7: '9353757',
  UCD13: '3400893537572',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ACC 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3751669',
  CIP13: '3400937516693',
  ucdLib: "LOSARTAN ACC 50MG CPR",
  UCD7: '9353786',
  UCD13: '3400893537862',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN ACC 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3751698',
  CIP13: '3400937516983',
  ucdLib: "LOSARTAN ACC 50MG CPR",
  UCD7: '9353786',
  UCD13: '3400893537862',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ACC 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3870291',
  CIP13: '3400938702910',
  ucdLib: "LOSARTAN ARW 100MG CPR",
  UCD7: '9321094',
  UCD13: '3400893210949',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN ARW 100MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3870322',
  CIP13: '3400938703221',
  ucdLib: "LOSARTAN ARW 100MG CPR",
  UCD7: '9321094',
  UCD13: '3400893210949',
  ucdQtyMultiplicator: 84,
  cipLib: "LOSARTAN ARW 100MG CPR BT 84",
  atcCode: "C09CA01"
}, {
  CIP7: '3870210',
  CIP13: '3400938702101',
  ucdLib: "LOSARTAN ARW 50MG CPR",
  UCD7: '9321102',
  UCD13: '3400893211021',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN ARW 50MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3870233',
  CIP13: '3400938702330',
  ucdLib: "LOSARTAN ARW 50MG CPR",
  UCD7: '9321102',
  UCD13: '3400893211021',
  ucdQtyMultiplicator: 84,
  cipLib: "LOSARTAN ARW 50MG CPR BT 84",
  atcCode: "C09CA01"
}, {
  CIP7: '3926100',
  CIP13: '3400939261003',
  ucdLib: "LOSARTAN RBX 100MG CPR",
  UCD7: '9337149',
  UCD13: '3400893371497',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN RBX 100MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3926146',
  CIP13: '3400939261461',
  ucdLib: "LOSARTAN RBX 100MG CPR",
  UCD7: '9337149',
  UCD13: '3400893371497',
  ucdQtyMultiplicator: 84,
  cipLib: "LOSARTAN RBX 100MG CPR BT 84",
  atcCode: "C09CA01"
}, {
  CIP7: '3926034',
  CIP13: '3400939260341',
  ucdLib: "LOSARTAN RBX 50MG CPR",
  UCD7: '9337161',
  UCD13: '3400893371619',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN RBX 50MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3926063',
  CIP13: '3400939260631',
  ucdLib: "LOSARTAN RBX 50MG CPR",
  UCD7: '9337161',
  UCD13: '3400893371619',
  ucdQtyMultiplicator: 84,
  cipLib: "LOSARTAN RBX 50MG CPR BT 84",
  atcCode: "C09CA01"
}, {
  CIP7: '3877100',
  CIP13: '3400938771008',
  ucdLib: "LOSARTAN SDZ 100MG CPR",
  UCD7: '9325324',
  UCD13: '3400893253243',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN SDZ 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3877169',
  CIP13: '3400938771695',
  ucdLib: "LOSARTAN SDZ 100MG CPR",
  UCD7: '9325324',
  UCD13: '3400893253243',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN SDZ 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3887647',
  CIP13: '3400938876475',
  ucdLib: "LOSARTAN SDZ 50MG CPR",
  UCD7: '9325330',
  UCD13: '3400893253304',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN SDZ 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3931348',
  CIP13: '3400939313481',
  ucdLib: "COZAAR 2,5MG/ML BUV SACH+FL",
  UCD7: '9340743',
  UCD13: '3400893407431',
  ucdQtyMultiplicator: 1,
  cipLib: "COZAAR 2,5MG/ML BUV SACH+FL BT 1",
  atcCode: "C09CA01"
}, {
  CIP7: '3979941',
  CIP13: '3400939799414',
  ucdLib: "LOSARTAN ACT 100MG CPR",
  UCD7: '9320278',
  UCD13: '3400893202784',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ACT 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3896801',
  CIP13: '3400938968019',
  ucdLib: "LOSARTAN BGA 100MG CPR",
  UCD7: '9327576',
  UCD13: '3400893275764',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN BGA 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3896847',
  CIP13: '3400938968477',
  ucdLib: "LOSARTAN BGA 100MG CPR",
  UCD7: '9327576',
  UCD13: '3400893275764',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN BGA 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3896652',
  CIP13: '3400938966527',
  ucdLib: "LOSARTAN BGA 50MG CPR",
  UCD7: '9330348',
  UCD13: '3400893303481',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN BGA 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3896698',
  CIP13: '3400938966985',
  ucdLib: "LOSARTAN BGA 50MG CPR",
  UCD7: '9330348',
  UCD13: '3400893303481',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN BGA 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3967984',
  CIP13: '3400939679846',
  ucdLib: "LOSARTAN CRT 100MG CPR",
  UCD7: '9343552',
  UCD13: '3400893435526',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN CRT 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3968015',
  CIP13: '3400939680156',
  ucdLib: "LOSARTAN CRT 100MG CPR",
  UCD7: '9343552',
  UCD13: '3400893435526',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN CRT 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3968050',
  CIP13: '3400939680507',
  ucdLib: "LOSARTAN CRT 50MG CPR",
  UCD7: '9343569',
  UCD13: '3400893435694',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN CRT 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3968096',
  CIP13: '3400939680965',
  ucdLib: "LOSARTAN CRT 50MG CPR",
  UCD7: '9343569',
  UCD13: '3400893435694',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN CRT 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3933270',
  CIP13: '3400939332703',
  ucdLib: "LOSARTAN EG 100MG CPR",
  UCD7: '9337126',
  UCD13: '3400893371268',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN EG 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3933301',
  CIP13: '3400939333014',
  ucdLib: "LOSARTAN EG 100MG CPR",
  UCD7: '9337126',
  UCD13: '3400893371268',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN EG 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3932684',
  CIP13: '3400939326849',
  ucdLib: "LOSARTAN EG 50MG CPR",
  UCD7: '9337132',
  UCD13: '3400893371329',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN EG 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3932715',
  CIP13: '3400939327150',
  ucdLib: "LOSARTAN EG 50MG CPR",
  UCD7: '9337132',
  UCD13: '3400893371329',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN EG 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3962142',
  CIP13: '3400939621425',
  ucdLib: "LOSARTAN KRK 100MG CPR",
  UCD7: '9344787',
  UCD13: '3400893447871',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN KRK 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3965293',
  CIP13: '3400939652931',
  ucdLib: "LOSARTAN SDZ 50MG CPR",
  UCD7: '9325330',
  UCD13: '3400893253304',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN SDZ 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3934022',
  CIP13: '3400939340227',
  ucdLib: "LOSARTAN TOR 100MG CPR",
  UCD7: '9320284',
  UCD13: '3400893202845',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN TOR 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3964649',
  CIP13: '3400939646497',
  ucdLib: "LOSARTAN ZEN 100MG CPR",
  UCD7: '9344801',
  UCD13: '3400893448014',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN ZEN 100MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3964690',
  CIP13: '3400939646909',
  ucdLib: "LOSARTAN ZEN 100MG CPR",
  UCD7: '9344801',
  UCD13: '3400893448014',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ZEN 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3964508',
  CIP13: '3400939645087',
  ucdLib: "LOSARTAN ZEN 50MG CPR",
  UCD7: '9344818',
  UCD13: '3400893448182',
  ucdQtyMultiplicator: 28,
  cipLib: "LOSARTAN ZEN 50MG CPR BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3964566',
  CIP13: '3400939645667',
  ucdLib: "LOSARTAN ZEN 50MG CPR",
  UCD7: '9344818',
  UCD13: '3400893448182',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ZEN 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '4901929',
  CIP13: '3400949019298',
  ucdLib: "COZAAR 100MG CPR AIP MWI AT",
  UCD7: '9398607',
  UCD13: '3400893986073',
  ucdQtyMultiplicator: 28,
  cipLib: "COZAAR 100MG CPR AIP MWI AT BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '4902248',
  CIP13: '3400949022489',
  ucdLib: "COZAAR 50MG CPR AIP MWI PL",
  UCD7: '9401048',
  UCD13: '3400894010487',
  ucdQtyMultiplicator: 28,
  cipLib: "COZAAR 50MG CPR AIP MWI PL BT 28",
  atcCode: "C09CA01"
}, {
  CIP7: '3946640',
  CIP13: '3400939466408',
  ucdLib: "LOSARTAN ACT 50MG CPR",
  UCD7: '9338781',
  UCD13: '3400893387818',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN ACT 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3946692',
  CIP13: '3400939466927',
  ucdLib: "LOSARTAN EVO 50MG CPR",
  UCD7: '9339817',
  UCD13: '3400893398173',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN EVO 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3946700',
  CIP13: '3400939467009',
  ucdLib: "LOSARTAN EVO 50MG CPR",
  UCD7: '9339817',
  UCD13: '3400893398173',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN EVO 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '4990293',
  CIP13: '3400949902934',
  ucdLib: "LOSARTAN ISD 100MG CPR",
  UCD7: '9365424',
  UCD13: '3400893654248',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN ISD 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '4990330',
  CIP13: '3400949903306',
  ucdLib: "LOSARTAN ISD 100MG CPR",
  UCD7: '9365424',
  UCD13: '3400893654248',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ISD 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '4990011',
  CIP13: '3400949900114',
  ucdLib: "LOSARTAN ISD 50MG CPR",
  UCD7: '9366085',
  UCD13: '3400893660850',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN ISD 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '4990040',
  CIP13: '3400949900404',
  ucdLib: "LOSARTAN ISD 50MG CPR",
  UCD7: '9366085',
  UCD13: '3400893660850',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN ISD 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '2663271',
  CIP13: '3400926632717',
  ucdLib: "LOSARTAN KRK 100MG CPR",
  UCD7: '9344787',
  UCD13: '3400893447871',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN KRK 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '2663207',
  CIP13: '3400926632076',
  ucdLib: "LOSARTAN KRK 50MG CPR",
  UCD7: '9344793',
  UCD13: '3400893447932',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN KRK 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '2663236',
  CIP13: '3400926632366',
  ucdLib: "LOSARTAN KRK 50MG CPR",
  UCD7: '9344793',
  UCD13: '3400893447932',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN KRK 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '4933349',
  CIP13: '3400949333493',
  ucdLib: "LOSARTAN PHR 100MG CPR",
  UCD7: '9358909',
  UCD13: '3400893589090',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN PHR 100MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '4933378',
  CIP13: '3400949333783',
  ucdLib: "LOSARTAN PHR 100MG CPR",
  UCD7: '9358909',
  UCD13: '3400893589090',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN PHR 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '4931729',
  CIP13: '3400949317295',
  ucdLib: "LOSARTAN PHR 50MG CPR",
  UCD7: '9358915',
  UCD13: '3400893589151',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN PHR 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '4931758',
  CIP13: '3400949317585',
  ucdLib: "LOSARTAN PHR 50MG CPR",
  UCD7: '9358915',
  UCD13: '3400893589151',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN PHR 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '3946746',
  CIP13: '3400939467467',
  ucdLib: "LOSARTAN TOR 50MG CPR",
  UCD7: '9338723',
  UCD13: '3400893387238',
  ucdQtyMultiplicator: 30,
  cipLib: "LOSARTAN TOR 50MG CPR BT 30",
  atcCode: "C09CA01"
}, {
  CIP7: '3946752',
  CIP13: '3400939467528',
  ucdLib: "LOSARTAN TOR 50MG CPR",
  UCD7: '9338723',
  UCD13: '3400893387238',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN TOR 50MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '4964077',
  CIP13: '3400949640775',
  ucdLib: "LOSARTAN EVO 100MG CPR",
  UCD7: '9320261',
  UCD13: '3400893202616',
  ucdQtyMultiplicator: 90,
  cipLib: "LOSARTAN EVO 100MG CPR BT 90",
  atcCode: "C09CA01"
}, {
  CIP7: '2781639',
  CIP13: '3400927816390',
  ucdLib: "TRIPLIXAM 10/2,5/10MG CPR",
  UCD7: '9419166',
  UCD13: '3400894191667',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIPLIXAM 10/2,5/10MG CPR BT 30",
  atcCode: "C09BX01"
}, {
  CIP7: '2781616',
  CIP13: '3400927816161',
  ucdLib: "TRIPLIXAM 10/2,5/5MG CPR",
  UCD7: '9418801',
  UCD13: '3400894188018',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIPLIXAM 10/2,5/5MG CPR BT 30",
  atcCode: "C09BX01"
}, {
  CIP7: '2781585',
  CIP13: '3400927815850',
  ucdLib: "TRIPLIXAM 5/1,25/10MG CPR",
  UCD7: '9419172',
  UCD13: '3400894191728',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIPLIXAM 5/1,25/10MG CPR BT 30",
  atcCode: "C09BX01"
}, {
  CIP7: '2781562',
  CIP13: '3400927815621',
  ucdLib: "TRIPLIXAM 5/1,25/5MG CPR",
  UCD7: '9419189',
  UCD13: '3400894191896',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIPLIXAM 5/1,25/5MG CPR BT 30",
  atcCode: "C09BX01"
}, {
  CIP7: '3712557',
  CIP13: '3400937125574',
  ucdLib: "TARKA LP 180MG/2MG CPR",
  UCD7: '9246493',
  UCD13: '3400892464930',
  ucdQtyMultiplicator: 30,
  cipLib: "TARKA LP 180MG/2MG CPR BT 30",
  atcCode: "C09BB10"
}, {
  CIP7: '3713686',
  CIP13: '3400937136860',
  ucdLib: "TARKA LP 180MG/2MG CPR",
  UCD7: '9246493',
  UCD13: '3400892464930',
  ucdQtyMultiplicator: 90,
  cipLib: "TARKA LP 180MG/2MG CPR BT 90",
  atcCode: "C09BB10"
}, {
  CIP7: '3931420',
  CIP13: '3400939314204',
  ucdLib: "TARKA LP 240MG/2MG CPR",
  UCD7: '9406063',
  UCD13: '3400894060635',
  ucdQtyMultiplicator: 30,
  cipLib: "TARKA LP 240MG/2MG CPR BT 30",
  atcCode: "C09BB10"
}, {
  CIP7: '3931443',
  CIP13: '3400939314433',
  ucdLib: "TARKA LP 240MG/2MG CPR",
  UCD7: '9406063',
  UCD13: '3400894060635',
  ucdQtyMultiplicator: 90,
  cipLib: "TARKA LP 240MG/2MG CPR BT 90",
  atcCode: "C09BB10"
}, {
  CIP7: '3931696',
  CIP13: '3400939316963',
  ucdLib: "TARKA LP 240MG/4MG CPR",
  UCD7: '9406086',
  UCD13: '3400894060864',
  ucdQtyMultiplicator: 30,
  cipLib: "TARKA LP 240MG/4MG CPR BT 30",
  atcCode: "C09BB10"
}, {
  CIP7: '3931710',
  CIP13: '3400939317106',
  ucdLib: "TARKA LP 240MG/4MG CPR",
  UCD7: '9406086',
  UCD13: '3400894060864',
  ucdQtyMultiplicator: 90,
  cipLib: "TARKA LP 240MG/4MG CPR BT 90",
  atcCode: "C09BB10"
}, {
  CIP7: '3858396',
  CIP13: '3400938583960',
  ucdLib: "COVERAM 10MG/10MG CPR",
  UCD7: '9334323',
  UCD13: '3400893343234',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 10MG/10MG CPR BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '3858433',
  CIP13: '3400938584332',
  ucdLib: "COVERAM 10MG/10MG CPR",
  UCD7: '9334323',
  UCD13: '3400893343234',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 10MG/10MG CPR BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '3858278',
  CIP13: '3400938582789',
  ucdLib: "COVERAM 10MG/5MG CPR",
  UCD7: '9334346',
  UCD13: '3400893343463',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 10MG/5MG CPR BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '3858315',
  CIP13: '3400938583151',
  ucdLib: "COVERAM 10MG/5MG CPR",
  UCD7: '9334346',
  UCD13: '3400893343463',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 10MG/5MG CPR BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '3858143',
  CIP13: '3400938581430',
  ucdLib: "COVERAM 5MG/10MG CPR",
  UCD7: '9334352',
  UCD13: '3400893343524',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 5MG/10MG CPR BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '3858195',
  CIP13: '3400938581959',
  ucdLib: "COVERAM 5MG/10MG CPR",
  UCD7: '9334352',
  UCD13: '3400893343524',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 5MG/10MG CPR BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '3858025',
  CIP13: '3400938580259',
  ucdLib: "COVERAM 5MG/5MG CPR",
  UCD7: '9334369',
  UCD13: '3400893343692',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 5MG/5MG CPR BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '3858060',
  CIP13: '3400938580600',
  ucdLib: "COVERAM 5MG/5MG CPR",
  UCD7: '9334369',
  UCD13: '3400893343692',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 5MG/5MG CPR BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '3859088',
  CIP13: '3400938590883',
  ucdLib: "PERIND.ARG-AMLO.BGA 5/5MG CP",
  UCD7: '9374239',
  UCD13: '3400893742396',
  ucdQtyMultiplicator: 30,
  cipLib: "PERIND.ARG-AMLO.BGA 5/5MG CP BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '3858522',
  CIP13: '3400938585223',
  ucdLib: "PERIND.ARG-AMLO.SRV 5/5MG CP",
  UCD7: '9374245',
  UCD13: '3400893742457',
  ucdQtyMultiplicator: 30,
  cipLib: "PERIND.ARG-AMLO.SRV 5/5MG CP BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4902403',
  CIP13: '3400949024032',
  ucdLib: "COVERAM 10/10MG CPR AIPBBACZ",
  UCD7: '9402875',
  UCD13: '3400894028758',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 10/10MG CPR AIPBBACZ BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4902426',
  CIP13: '3400949024261',
  ucdLib: "COVERAM 10/10MG CPR AIPBBACZ",
  UCD7: '9402875',
  UCD13: '3400894028758',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 10/10MG CPR AIPBBACZ BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4900012',
  CIP13: '3400949000128',
  ucdLib: "COVERAM 10/10MG CPR AIPMWIPL",
  UCD7: '9410739',
  UCD13: '3400894107392',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 10/10MG CPR AIPMWIPL BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4900013',
  CIP13: '3400949000135',
  ucdLib: "COVERAM 10/10MG CPR AIPMWIPL",
  UCD7: '9410739',
  UCD13: '3400894107392',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 10/10MG CPR AIPMWIPL BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4900081',
  CIP13: '3400949000814',
  ucdLib: "COVERAM 10/10MG CPR AIPPLAPL",
  UCD7: '9394319',
  UCD13: '3400893943199',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 10/10MG CPR AIPPLAPL BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4901556',
  CIP13: '3400949015566',
  ucdLib: "COVERAM 10/10MG CPR AIPPLAPL",
  UCD7: '9394319',
  UCD13: '3400893943199',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 10/10MG CPR AIPPLAPL BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4902389',
  CIP13: '3400949023899',
  ucdLib: "COVERAM 10/5MG CPR AIPBBA CZ",
  UCD7: '9402881',
  UCD13: '3400894028819',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 10/5MG CPR AIPBBA CZ BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4902395',
  CIP13: '3400949023950',
  ucdLib: "COVERAM 10/5MG CPR AIPBBA CZ",
  UCD7: '9402881',
  UCD13: '3400894028819',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 10/5MG CPR AIPBBA CZ BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4900006',
  CIP13: '3400949000067',
  ucdLib: "COVERAM 10/5MG CPR AIPMWI PL",
  UCD7: '9410745',
  UCD13: '3400894107453',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 10/5MG CPR AIPMWI PL BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4900007',
  CIP13: '3400949000074',
  ucdLib: "COVERAM 10/5MG CPR AIPMWI PL",
  UCD7: '9410745',
  UCD13: '3400894107453',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 10/5MG CPR AIPMWI PL BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4900080',
  CIP13: '3400949000807',
  ucdLib: "COVERAM 10/5MG CPR AIPPLA PL",
  UCD7: '9384628',
  UCD13: '3400893846285',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 10/5MG CPR AIPPLA PL BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4901013',
  CIP13: '3400949010134',
  ucdLib: "COVERAM 10/5MG CPR AIPPLA PL",
  UCD7: '9384628',
  UCD13: '3400893846285',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 10/5MG CPR AIPPLA PL BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4902366',
  CIP13: '3400949023660',
  ucdLib: "COVERAM 5/10MG CPR AIPBBA CZ",
  UCD7: '9402898',
  UCD13: '3400894028987',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 5/10MG CPR AIPBBA CZ BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4902372',
  CIP13: '3400949023721',
  ucdLib: "COVERAM 5/10MG CPR AIPBBA CZ",
  UCD7: '9402898',
  UCD13: '3400894028987',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 5/10MG CPR AIPBBA CZ BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4900015',
  CIP13: '3400949000159',
  ucdLib: "COVERAM 5/10MG CPR AIPMWI PL",
  UCD7: '9410751',
  UCD13: '3400894107514',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 5/10MG CPR AIPMWI PL BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4900016',
  CIP13: '3400949000166',
  ucdLib: "COVERAM 5/10MG CPR AIPMWI PL",
  UCD7: '9410751',
  UCD13: '3400894107514',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 5/10MG CPR AIPMWI PL BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4902337',
  CIP13: '3400949023370',
  ucdLib: "COVERAM 5/5MG CPR AIPBBA CZ",
  UCD7: '9402906',
  UCD13: '3400894029069',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 5/5MG CPR AIPBBA CZ BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4902343',
  CIP13: '3400949023431',
  ucdLib: "COVERAM 5/5MG CPR AIPBBA CZ",
  UCD7: '9402906',
  UCD13: '3400894029069',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 5/5MG CPR AIPBBA CZ BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4900008',
  CIP13: '3400949000081',
  ucdLib: "COVERAM 5/5MG CPR AIPMWI PL",
  UCD7: '9410768',
  UCD13: '3400894107682',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 5/5MG CPR AIPMWI PL BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '4900009',
  CIP13: '3400949000098',
  ucdLib: "COVERAM 5/5MG CPR AIPMWI PL",
  UCD7: '9410768',
  UCD13: '3400894107682',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 5/5MG CPR AIPMWI PL BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4900079',
  CIP13: '3400949000791',
  ucdLib: "COVERAM 5/5MG CPR AIPPLA PL",
  UCD7: '9394325',
  UCD13: '3400893943250',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERAM 5/5MG CPR AIPPLA PL BT 90",
  atcCode: "C09BB04"
}, {
  CIP7: '4901533',
  CIP13: '3400949015337',
  ucdLib: "COVERAM 5/5MG CPR AIPPLA PL",
  UCD7: '9394325',
  UCD13: '3400893943250',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERAM 5/5MG CPR AIPPLA PL BT 30",
  atcCode: "C09BB04"
}, {
  CIP7: '3000557',
  CIP13: '3400930005576',
  ucdLib: "LERCAPRESS 20MG/20MG CPR",
  UCD7: '9411242',
  UCD13: '3400894112426',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCAPRESS 20MG/20MG CPR BT 30",
  atcCode: "C09BB02"
}, {
  CIP7: '3000563',
  CIP13: '3400930005637',
  ucdLib: "LERCAPRESS 20MG/20MG CPR",
  UCD7: '9411242',
  UCD13: '3400894112426',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCAPRESS 20MG/20MG CPR BT 90",
  atcCode: "C09BB02"
}, {
  CIP7: '3000546',
  CIP13: '3400930005460',
  ucdLib: "ZANEXTRA 20MG/20MG CPR",
  UCD7: '9411259',
  UCD13: '3400894112594',
  ucdQtyMultiplicator: 30,
  cipLib: "ZANEXTRA 20MG/20MG CPR BT 30",
  atcCode: "C09BB02"
}, {
  CIP7: '3000552',
  CIP13: '3400930005521',
  ucdLib: "ZANEXTRA 20MG/20MG CPR",
  UCD7: '9411259',
  UCD13: '3400894112594',
  ucdQtyMultiplicator: 90,
  cipLib: "ZANEXTRA 20MG/20MG CPR BT 90",
  atcCode: "C09BB02"
}, {
  CIP7: '3859639',
  CIP13: '3400938596397',
  ucdLib: "LERCAPRESS 20MG/10MG CPR",
  UCD7: '9331218',
  UCD13: '3400893312186',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCAPRESS 20MG/10MG CPR BT 30",
  atcCode: "C09BB02"
}, {
  CIP7: '3859674',
  CIP13: '3400938596748',
  ucdLib: "ZANEXTRA 20MG/10MG CPR",
  UCD7: '9331313',
  UCD13: '3400893313138',
  ucdQtyMultiplicator: 30,
  cipLib: "ZANEXTRA 20MG/10MG CPR BT 30",
  atcCode: "C09BB02"
}, {
  CIP7: '3873757',
  CIP13: '3400938737578',
  ucdLib: "LERCAPRESS 20MG/10MG CPR",
  UCD7: '9331218',
  UCD13: '3400893312186',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCAPRESS 20MG/10MG CPR BT 90",
  atcCode: "C09BB02"
}, {
  CIP7: '3873929',
  CIP13: '3400938739299',
  ucdLib: "ZANEXTRA 20MG/10MG CPR",
  UCD7: '9331313',
  UCD13: '3400893313138',
  ucdQtyMultiplicator: 90,
  cipLib: "ZANEXTRA 20MG/10MG CPR BT 90",
  atcCode: "C09BB02"
}, {
  CIP7: '3669028',
  CIP13: '3400936690288',
  ucdLib: "ZOFENILDUO 30MG/12,5MG CPR",
  UCD7: '9281532',
  UCD13: '3400892815329',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOFENILDUO 30MG/12,5MG CPR BT 30",
  atcCode: "C09BA15"
}, {
  CIP7: '3742127',
  CIP13: '3400937421270',
  ucdLib: "ZOFENILDUO 30MG/12,5MG CPR",
  UCD7: '9281532',
  UCD13: '3400892815329',
  ucdQtyMultiplicator: 90,
  cipLib: "ZOFENILDUO 30MG/12,5MG CPR BT 90",
  atcCode: "C09BA15"
}, {
  CIP7: '3857095',
  CIP13: '3400938570953',
  ucdLib: "FOSINOPRIL HYD.ARW 20/12,5 C",
  UCD7: '9320189',
  UCD13: '3400893201893',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL HYD.ARW 20/12,5 C BT 30",
  atcCode: "C09BA09"
}, {
  CIP7: '3857310',
  CIP13: '3400938573107',
  ucdLib: "FOSINOPRIL HYD.BGA 20/12,5 C",
  UCD7: '9319571',
  UCD13: '3400893195710',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL HYD.BGA 20/12,5 C BT 30",
  atcCode: "C09BA09"
}, {
  CIP7: '3857362',
  CIP13: '3400938573626',
  ucdLib: "FOSINOPRIL HYD.MYL 20/12,5 C",
  UCD7: '9320114',
  UCD13: '3400893201145',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL HYD.MYL 20/12,5 C BT 30",
  atcCode: "C09BA09"
}, {
  CIP7: '3463195',
  CIP13: '3400934631955',
  ucdLib: "FOSINOPRIL HYD.CRT 20/12,5 C",
  UCD7: '9347857',
  UCD13: '3400893478578',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL HYD.CRT 20/12,5 C BT 30",
  atcCode: "C09BA09"
}, {
  CIP7: '3463226',
  CIP13: '3400934632266',
  ucdLib: "FOSINOPRIL HYD.CRT 20/12,5 C",
  UCD7: '9347857',
  UCD13: '3400893478578',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL HYD.CRT 20/12,5 C BT 90",
  atcCode: "C09BA09"
}, {
  CIP7: '3798151',
  CIP13: '3400937981514',
  ucdLib: "FOSINOPRIL HYD.TVC 20/12,5 CPR",
  UCD7: '9305439',
  UCD13: '3400893054390',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL HYD.TVC 20/12,5 CPR BT 30",
  atcCode: "C09BA09"
}, {
  CIP7: '3860909',
  CIP13: '3400938609097',
  ucdLib: "FOSINOPRIL HYD.BGA 20/12,5 C",
  UCD7: '9319571',
  UCD13: '3400893195710',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL HYD.BGA 20/12,5 C BT 90",
  atcCode: "C09BA09"
}, {
  CIP7: '3884494',
  CIP13: '3400938844948',
  ucdLib: "FOSINOPRIL HYD.EG 20/12,5 C.",
  UCD7: '9327429',
  UCD13: '3400893274293',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL HYD.EG 20/12,5 C. BT 30",
  atcCode: "C09BA09"
}, {
  CIP7: '3884519',
  CIP13: '3400938845198',
  ucdLib: "FOSINOPRIL HYD.EG 20/12,5 C.",
  UCD7: '9327429',
  UCD13: '3400893274293',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL HYD.EG 20/12,5 C. BT 90",
  atcCode: "C09BA09"
}, {
  CIP7: '3878594',
  CIP13: '3400938785944',
  ucdLib: "FOSINOPRIL HYD.TVC 20/12,5 CPR",
  UCD7: '9305439',
  UCD13: '3400893054390',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL HYD.TVC 20/12,5 CPR BT 90",
  atcCode: "C09BA09"
}, {
  CIP7: '3869939',
  CIP13: '3400938699395',
  ucdLib: "FOSINOPRIL HYD.ZEN 20/12,5 C",
  UCD7: '9322225',
  UCD13: '3400893222256',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL HYD.ZEN 20/12,5 C BT 30",
  atcCode: "C09BA09"
}, {
  CIP7: '3892358',
  CIP13: '3400938923582',
  ucdLib: "FOSINOPRIL HYD.ARW 20/12,5 C",
  UCD7: '9320189',
  UCD13: '3400893201893',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL HYD.ARW 20/12,5 C BT 90",
  atcCode: "C09BA09"
}, {
  CIP7: '3896149',
  CIP13: '3400938961492',
  ucdLib: "FOSINOPRIL HYD.MYL 20/12,5 C",
  UCD7: '9320114',
  UCD13: '3400893201145',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL HYD.MYL 20/12,5 C BT 90",
  atcCode: "C09BA09"
}, {
  CIP7: '3723880',
  CIP13: '3400937238809',
  ucdLib: "BRIAZIDE 10MG/12,5MG CPR",
  UCD7: '9157424',
  UCD13: '3400891574241',
  ucdQtyMultiplicator: 30,
  cipLib: "BRIAZIDE 10MG/12,5MG CPR BT 30",
  atcCode: "C09BA07"
}, {
  CIP7: '3723905',
  CIP13: '3400937239059',
  ucdLib: "BRIAZIDE 10MG/12,5MG CPR",
  UCD7: '9157424',
  UCD13: '3400891574241',
  ucdQtyMultiplicator: 90,
  cipLib: "BRIAZIDE 10MG/12,5MG CPR BT 90",
  atcCode: "C09BA07"
}, {
  CIP7: '3715596',
  CIP13: '3400937155960',
  ucdLib: "CIBADREX CPR",
  UCD7: '9157476',
  UCD13: '3400891574760',
  ucdQtyMultiplicator: 30,
  cipLib: "CIBADREX CPR BT 30",
  atcCode: "C09BA07"
}, {
  CIP7: '3715610',
  CIP13: '3400937156103',
  ucdLib: "CIBADREX CPR",
  UCD7: '9157476',
  UCD13: '3400891574760',
  ucdQtyMultiplicator: 90,
  cipLib: "CIBADREX CPR BT 90",
  atcCode: "C09BA07"
}, {
  CIP7: '3874308',
  CIP13: '3400938743081',
  ucdLib: "BENAZEPRIL/HYD.TVS 10/12,5 C",
  UCD7: '9321645',
  UCD13: '3400893216453',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL/HYD.TVS 10/12,5 C BT 30",
  atcCode: "C09BA07"
}, {
  CIP7: '3874320',
  CIP13: '3400938743203',
  ucdLib: "BENAZEPRIL/HYD.TVS 10/12,5 C",
  UCD7: '9321645',
  UCD13: '3400893216453',
  ucdQtyMultiplicator: 90,
  cipLib: "BENAZEPRIL/HYD.TVS 10/12,5 C BT 90",
  atcCode: "C09BA07"
}, {
  CIP7: '3902803',
  CIP13: '3400939028033',
  ucdLib: "BENAZEPRIL/HYD.EG 10/12,5 C.",
  UCD7: '9324218',
  UCD13: '3400893242186',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL/HYD.EG 10/12,5 C. BT 30",
  atcCode: "C09BA07"
}, {
  CIP7: '3902826',
  CIP13: '3400939028262',
  ucdLib: "BENAZEPRIL/HYD.EG 10/12,5 C.",
  UCD7: '9324218',
  UCD13: '3400893242186',
  ucdQtyMultiplicator: 90,
  cipLib: "BENAZEPRIL/HYD.EG 10/12,5 C. BT 90",
  atcCode: "C09BA07"
}, {
  CIP7: '2176967',
  CIP13: '3400921769678',
  ucdLib: "BENAZEPRIL/HYD.ARW 10/12,5 C",
  UCD7: '9381452',
  UCD13: '3400893814529',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL/HYD.ARW 10/12,5 C BT 30",
  atcCode: "C09BA07"
}, {
  CIP7: '2177027',
  CIP13: '3400921770278',
  ucdLib: "BENAZEPRIL/HYD.ARW 10/12,5 C",
  UCD7: '9381452',
  UCD13: '3400893814529',
  ucdQtyMultiplicator: 90,
  cipLib: "BENAZEPRIL/HYD.ARW 10/12,5 C BT 90",
  atcCode: "C09BA07"
}, {
  CIP7: '3364079',
  CIP13: '3400933640798',
  ucdLib: "ACUILIX 20MG/12,5MG CPR",
  UCD7: '9165004',
  UCD13: '3400891650044',
  ucdQtyMultiplicator: 28,
  cipLib: "ACUILIX 20MG/12,5MG CPR BT 28",
  atcCode: "C09BA06"
}, {
  CIP7: '3724394',
  CIP13: '3400937243940',
  ucdLib: "ACUILIX 20MG/12,5MG CPR",
  UCD7: '9165004',
  UCD13: '3400891650044',
  ucdQtyMultiplicator: 90,
  cipLib: "ACUILIX 20MG/12,5MG CPR BT 90",
  atcCode: "C09BA06"
}, {
  CIP7: '3768747',
  CIP13: '3400937687478',
  ucdLib: "QUINAPRIL/HYD.TVS 20/12,5 C.",
  UCD7: '9295296',
  UCD13: '3400892952963',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL/HYD.TVS 20/12,5 C. BT 28",
  atcCode: "C09BA06"
}, {
  CIP7: '3768782',
  CIP13: '3400937687829',
  ucdLib: "QUINAPRIL/HYD.TVS 20/12,5 C.",
  UCD7: '9295296',
  UCD13: '3400892952963',
  ucdQtyMultiplicator: 90,
  cipLib: "QUINAPRIL/HYD.TVS 20/12,5 C. BT 90",
  atcCode: "C09BA06"
}, {
  CIP7: '3802763',
  CIP13: '3400938027631',
  ucdLib: "QUINAPRIL/HYD.ARW 20/12,5 C.",
  UCD7: '9322716',
  UCD13: '3400893227169',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL/HYD.ARW 20/12,5 C. BT 28",
  atcCode: "C09BA06"
}, {
  CIP7: '3880289',
  CIP13: '3400938802894',
  ucdLib: "QUINAPRIL/HYD.ARW 20/12,5 C.",
  UCD7: '9322716',
  UCD13: '3400893227169',
  ucdQtyMultiplicator: 90,
  cipLib: "QUINAPRIL/HYD.ARW 20/12,5 C. BT 90",
  atcCode: "C09BA06"
}, {
  CIP7: '3869891',
  CIP13: '3400938698916',
  ucdLib: "QUINAPRIL/HYD.MYL 20/12,5 C.",
  UCD7: '9321556',
  UCD13: '3400893215562',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL/HYD.MYL 20/12,5 C. BT 28",
  atcCode: "C09BA06"
}, {
  CIP7: '3880378',
  CIP13: '3400938803785',
  ucdLib: "QUINAPRIL/HYD.MYL 20/12,5 C.",
  UCD7: '9321556',
  UCD13: '3400893215562',
  ucdQtyMultiplicator: 90,
  cipLib: "QUINAPRIL/HYD.MYL 20/12,5 C. BT 90",
  atcCode: "C09BA06"
}, {
  CIP7: '3804911',
  CIP13: '3400938049114',
  ucdLib: "QUINAPRIL/HYD.ZEN 20/12,5 C.",
  UCD7: '9321214',
  UCD13: '3400893212141',
  ucdQtyMultiplicator: 30,
  cipLib: "QUINAPRIL/HYD.ZEN 20/12,5 C. BT 30",
  atcCode: "C09BA06"
}, {
  CIP7: '3909461',
  CIP13: '3400939094618',
  ucdLib: "QUINAPRIL/HYD.EG 20/12,5 C.",
  UCD7: '9323673',
  UCD13: '3400893236734',
  ucdQtyMultiplicator: 30,
  cipLib: "QUINAPRIL/HYD.EG 20/12,5 C. BT 30",
  atcCode: "C09BA06"
}, {
  CIP7: '3909478',
  CIP13: '3400939094786',
  ucdLib: "QUINAPRIL/HYD.EG 20/12,5 C.",
  UCD7: '9323673',
  UCD13: '3400893236734',
  ucdQtyMultiplicator: 90,
  cipLib: "QUINAPRIL/HYD.EG 20/12,5 C. BT 90",
  atcCode: "C09BA06"
}, {
  CIP7: '3696290',
  CIP13: '3400936962903',
  ucdLib: "COTRIATEC 5MG/12,5MG CPR",
  UCD7: '9280314',
  UCD13: '3400892803142',
  ucdQtyMultiplicator: 30,
  cipLib: "COTRIATEC 5MG/12,5MG CPR BT 30",
  atcCode: "C09BA05"
}, {
  CIP7: '2215928',
  CIP13: '3400922159287',
  ucdLib: "RAMIPRIL/HYD.ARW 5/12,5 CPR",
  UCD7: '9388856',
  UCD13: '3400893888568',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL/HYD.ARW 5/12,5 CPR BT 30",
  atcCode: "C09BA05"
}, {
  CIP7: '2215957',
  CIP13: '3400922159577',
  ucdLib: "RAMIPRIL/HYD.ARW 5/12,5 CPR",
  UCD7: '9388856',
  UCD13: '3400893888568',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL/HYD.ARW 5/12,5 CPR BT 90",
  atcCode: "C09BA05"
}, {
  CIP7: '2216000',
  CIP13: '3400922160009',
  ucdLib: "RAMIPRIL/HYD.EG 5/12,5 CPR",
  UCD7: '9386461',
  UCD13: '3400893864616',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL/HYD.EG 5/12,5 CPR BT 30",
  atcCode: "C09BA05"
}, {
  CIP7: '2694716',
  CIP13: '3400926947163',
  ucdLib: "RAMIPRIL/HYD.BGA 5/12,5 CPR",
  UCD7: '9396927',
  UCD13: '3400893969274',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL/HYD.BGA 5/12,5 CPR BT 30",
  atcCode: "C09BA05"
}, {
  CIP7: '2694900',
  CIP13: '3400926949006',
  ucdLib: "RAMIPRIL/HYD.MYP 5/12,5 CPR",
  UCD7: '9393248',
  UCD13: '3400893932483',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL/HYD.MYP 5/12,5 CPR BT 30",
  atcCode: "C09BA05"
}, {
  CIP7: '2695058',
  CIP13: '3400926950583',
  ucdLib: "RAMIPRIL/HYD.SDZ 5/12,5 CPR",
  UCD7: '9404420',
  UCD13: '3400894044208',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL/HYD.SDZ 5/12,5 CPR BT 30",
  atcCode: "C09BA05"
}, {
  CIP7: '2695118',
  CIP13: '3400926951184',
  ucdLib: "RAMIPRIL/HYD.SDZ 5/12,5 CPR",
  UCD7: '9404420',
  UCD13: '3400894044208',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL/HYD.SDZ 5/12,5 CPR BT 90",
  atcCode: "C09BA05"
}, {
  CIP7: '2695236',
  CIP13: '3400926952365',
  ucdLib: "RAMIPRIL/HYD.TVC 5/12,5 CPR",
  UCD7: '9395342',
  UCD13: '3400893953426',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL/HYD.TVC 5/12,5 CPR BT 30",
  atcCode: "C09BA05"
}, {
  CIP7: '2244640',
  CIP13: '3400922446400',
  ucdLib: "RAMIPRIL/HYD.ZEN 5/12,5 CPR",
  UCD7: '9388916',
  UCD13: '3400893889169',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL/HYD.ZEN 5/12,5 CPR BT 30",
  atcCode: "C09BA05"
}, {
  CIP7: '3450867',
  CIP13: '3400934508677',
  ucdLib: "PERINDOPRIL/INDAP.BGA2MG CPR",
  UCD7: '9341412',
  UCD13: '3400893414125',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.BGA2MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3450896',
  CIP13: '3400934508967',
  ucdLib: "PERINDOPRIL/INDAP.BGA2MG CPR",
  UCD7: '9341412',
  UCD13: '3400893414125',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.BGA2MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3450910',
  CIP13: '3400934509100',
  ucdLib: "PERINDOPRIL/INDAP.BGA4MG CPR",
  UCD7: '9341406',
  UCD13: '3400893414064',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.BGA4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3450933',
  CIP13: '3400934509339',
  ucdLib: "PERINDOPRIL/INDAP.BGA4MG CPR",
  UCD7: '9341406',
  UCD13: '3400893414064',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.BGA4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3450703',
  CIP13: '3400934507038',
  ucdLib: "PRETERIAN 2MG/0,625MG CPR",
  UCD7: '9205809',
  UCD13: '3400892058092',
  ucdQtyMultiplicator: 30,
  cipLib: "PRETERIAN 2MG/0,625MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3004109',
  CIP13: '3400930041093',
  ucdLib: "PERINDOPRIL/INDAP.ZYF2MG CPR",
  UCD7: '9417440',
  UCD13: '3400894174400',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.ZYF2MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3004462',
  CIP13: '3400930044629',
  ucdLib: "PERINDOPRIL/INDAP.ZYF2MG CPR",
  UCD7: '9417440',
  UCD13: '3400894174400',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.ZYF2MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3004112',
  CIP13: '3400930041123',
  ucdLib: "PERINDOPRIL/INDAP.ZYF4MG CPR",
  UCD7: '9417457',
  UCD13: '3400894174578',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.ZYF4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3004465',
  CIP13: '3400930044650',
  ucdLib: "PERINDOPRIL/INDAP.ZYF4MG CPR",
  UCD7: '9417457',
  UCD13: '3400894174578',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.ZYF4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3004113',
  CIP13: '3400930041130',
  ucdLib: "PERINDOPRIL/INDAP.ZYF8MG CPR",
  UCD7: '9417463',
  UCD13: '3400894174639',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.ZYF8MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3004467',
  CIP13: '3400930044674',
  ucdLib: "PERINDOPRIL/INDAP.ZYF8MG CPR",
  UCD7: '9417463',
  UCD13: '3400894174639',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.ZYF8MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '4910064',
  CIP13: '3400949100644',
  ucdLib: "PERINDOPRIL/INDAP.KRK2MG CPR",
  UCD7: '9359292',
  UCD13: '3400893592922',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.KRK2MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '4910101',
  CIP13: '3400949101016',
  ucdLib: "PERINDOPRIL/INDAP.KRK2MG CPR",
  UCD7: '9359292',
  UCD13: '3400893592922',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.KRK2MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '4910242',
  CIP13: '3400949102426',
  ucdLib: "PERINDOPRIL/INDAP.KRK4MG CPR",
  UCD7: '9359300',
  UCD13: '3400893593004',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.KRK4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '4910288',
  CIP13: '3400949102884',
  ucdLib: "PERINDOPRIL/INDAP.KRK4MG CPR",
  UCD7: '9359300',
  UCD13: '3400893593004',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.KRK4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3562885',
  CIP13: '3400935628855',
  ucdLib: "PRETERIAN 2MG/0,625MG CPR",
  UCD7: '9205809',
  UCD13: '3400892058092',
  ucdQtyMultiplicator: 90,
  cipLib: "PRETERIAN 2MG/0,625MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3782405',
  CIP13: '3400937824057',
  ucdLib: "BIPRETERAX 5MG/1,25MG CPR",
  UCD7: '9334470',
  UCD13: '3400893344705',
  ucdQtyMultiplicator: 30,
  cipLib: "BIPRETERAX 5MG/1,25MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3782428',
  CIP13: '3400937824286',
  ucdLib: "BIPRETERAX 5MG/1,25MG CPR",
  UCD7: '9334470',
  UCD13: '3400893344705',
  ucdQtyMultiplicator: 90,
  cipLib: "BIPRETERAX 5MG/1,25MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3782322',
  CIP13: '3400937823227',
  ucdLib: "PRETERAX 2,5MG/0,625MG CPR",
  UCD7: '9334464',
  UCD13: '3400893344644',
  ucdQtyMultiplicator: 30,
  cipLib: "PRETERAX 2,5MG/0,625MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3782345',
  CIP13: '3400937823456',
  ucdLib: "PRETERAX 2,5MG/0,625MG CPR",
  UCD7: '9334464',
  UCD13: '3400893344644',
  ucdQtyMultiplicator: 90,
  cipLib: "PRETERAX 2,5MG/0,625MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3782492',
  CIP13: '3400937824927',
  ucdLib: "PRETERVAL 2,5MG/0,625MG CPR",
  UCD7: '9369250',
  UCD13: '3400893692509',
  ucdQtyMultiplicator: 30,
  cipLib: "PRETERVAL 2,5MG/0,625MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3920155',
  CIP13: '3400939201559',
  ucdLib: "PARATERAX 8MG/2,5MG CPR",
  UCD7: '9380317',
  UCD13: '3400893803172',
  ucdQtyMultiplicator: 30,
  cipLib: "PARATERAX 8MG/2,5MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3928990',
  CIP13: '3400939289908',
  ucdLib: "PERINDOPRIL/INDAP.MYL2MG CPR",
  UCD7: '9339496',
  UCD13: '3400893394960',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.MYL2MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3929044',
  CIP13: '3400939290447',
  ucdLib: "PERINDOPRIL/INDAP.MYL2MG CPR",
  UCD7: '9339496',
  UCD13: '3400893394960',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.MYL2MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3929535',
  CIP13: '3400939295350',
  ucdLib: "PERINDOPRIL/INDAP.MYL4MG CPR",
  UCD7: '9339504',
  UCD13: '3400893395042',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.MYL4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3929570',
  CIP13: '3400939295701',
  ucdLib: "PERINDOPRIL/INDAP.MYL4MG CPR",
  UCD7: '9339504',
  UCD13: '3400893395042',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.MYL4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3929185',
  CIP13: '3400939291857',
  ucdLib: "PERINDOPRIL/INDAP.TVC2MG CPR",
  UCD7: '9339467',
  UCD13: '3400893394670',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.TVC2MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3929239',
  CIP13: '3400939292397',
  ucdLib: "PERINDOPRIL/INDAP.TVC2MG CPR",
  UCD7: '9339467',
  UCD13: '3400893394670',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.TVC2MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3929707',
  CIP13: '3400939297071',
  ucdLib: "PERINDOPRIL/INDAP.TVC4MG CPR",
  UCD7: '9339473',
  UCD13: '3400893394731',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.TVC4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3929759',
  CIP13: '3400939297590',
  ucdLib: "PERINDOPRIL/INDAP.TVC4MG CPR",
  UCD7: '9339473',
  UCD13: '3400893394731',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.TVC4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3931549',
  CIP13: '3400939315492',
  ucdLib: "BIPRETERAX 10MG/2,5MG CPR",
  UCD7: '9334406',
  UCD13: '3400893344064',
  ucdQtyMultiplicator: 30,
  cipLib: "BIPRETERAX 10MG/2,5MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3931584',
  CIP13: '3400939315843',
  ucdLib: "BIPRETERAX 10MG/2,5MG CPR",
  UCD7: '9334406',
  UCD13: '3400893344064',
  ucdQtyMultiplicator: 90,
  cipLib: "BIPRETERAX 10MG/2,5MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3931621',
  CIP13: '3400939316215',
  ucdLib: "PERIND.ARG/INDAP.SRV 10MG CP",
  UCD7: '9380323',
  UCD13: '3400893803233',
  ucdQtyMultiplicator: 30,
  cipLib: "PERIND.ARG/INDAP.SRV 10MG CP BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3919666',
  CIP13: '3400939196664',
  ucdLib: "PERINDOPRIL/INDAP.ARW4MG CPR",
  UCD7: '9334429',
  UCD13: '3400893344293',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.ARW4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3919703',
  CIP13: '3400939197036',
  ucdLib: "PERINDOPRIL/INDAP.ARW4MG CPR",
  UCD7: '9334429',
  UCD13: '3400893344293',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.ARW4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '4973171',
  CIP13: '3400949731718',
  ucdLib: "PERINDOPRIL/INDAP.EG2MG CPR",
  UCD7: '9364956',
  UCD13: '3400893649565',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.EG2MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '4973194',
  CIP13: '3400949731947',
  ucdLib: "PERINDOPRIL/INDAP.EG2MG CPR",
  UCD7: '9364956',
  UCD13: '3400893649565',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.EG2MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '4973082',
  CIP13: '3400949730827',
  ucdLib: "PERINDOPRIL/INDAP.EG4MG CPR",
  UCD7: '9364962',
  UCD13: '3400893649626',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.EG4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '4973107',
  CIP13: '3400949731077',
  ucdLib: "PERINDOPRIL/INDAP.EG4MG CPR",
  UCD7: '9364962',
  UCD13: '3400893649626',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.EG4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3919755',
  CIP13: '3400939197555',
  ucdLib: "PERINDOPRIL/INDAP.ZTL4MG CPR",
  UCD7: '9334441',
  UCD13: '3400893344415',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.ZTL4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '3919790',
  CIP13: '3400939197906',
  ucdLib: "PERINDOPRIL/INDAP.ZTL4MG CPR",
  UCD7: '9334441',
  UCD13: '3400893344415',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.ZTL4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '4900099',
  CIP13: '3400949000999',
  ucdLib: "BIPRETERAX 10/2,5 C.AIPMWICZ",
  UCD7: '9421298',
  UCD13: '3400894212980',
  ucdQtyMultiplicator: 30,
  cipLib: "BIPRETERAX 10/2,5 C.AIPMWICZ BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '4900100',
  CIP13: '3400949001002',
  ucdLib: "BIPRETERAX 10/2,5 C.AIPMWICZ",
  UCD7: '9421298',
  UCD13: '3400894212980',
  ucdQtyMultiplicator: 90,
  cipLib: "BIPRETERAX 10/2,5 C.AIPMWICZ BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '2690486',
  CIP13: '3400926904869',
  ucdLib: "PERIND.TOS/INDAP.TVC2,5MG CP",
  UCD7: '9405974',
  UCD13: '3400894059745',
  ucdQtyMultiplicator: 30,
  cipLib: "PERIND.TOS/INDAP.TVC2,5MG CP BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '2690517',
  CIP13: '3400926905170',
  ucdLib: "PERIND.TOS/INDAP.TVC2,5MG CP",
  UCD7: '9405974',
  UCD13: '3400894059745',
  ucdQtyMultiplicator: 90,
  cipLib: "PERIND.TOS/INDAP.TVC2,5MG CP BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '2690434',
  CIP13: '3400926904340',
  ucdLib: "PERIND.TOS/INDAP.TVC5MG CPR",
  UCD7: '9405980',
  UCD13: '3400894059806',
  ucdQtyMultiplicator: 30,
  cipLib: "PERIND.TOS/INDAP.TVC5MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '2690463',
  CIP13: '3400926904630',
  ucdLib: "PERIND.TOS/INDAP.TVC5MG CPR",
  UCD7: '9405980',
  UCD13: '3400894059806',
  ucdQtyMultiplicator: 90,
  cipLib: "PERIND.TOS/INDAP.TVC5MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '4935087',
  CIP13: '3400949350872',
  ucdLib: "PERINDOPRIL/INDAP.SDZ2MG CPR",
  UCD7: '9354981',
  UCD13: '3400893549810',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.SDZ2MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '4935118',
  CIP13: '3400949351183',
  ucdLib: "PERINDOPRIL/INDAP.SDZ2MG CPR",
  UCD7: '9354981',
  UCD13: '3400893549810',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.SDZ2MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '4935288',
  CIP13: '3400949352883',
  ucdLib: "PERINDOPRIL/INDAP.SDZ4MG CPR",
  UCD7: '9354998',
  UCD13: '3400893549988',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL/INDAP.SDZ4MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '4935319',
  CIP13: '3400949353194',
  ucdLib: "PERINDOPRIL/INDAP.SDZ4MG CPR",
  UCD7: '9354998',
  UCD13: '3400893549988',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL/INDAP.SDZ4MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '2680890',
  CIP13: '3400926808907',
  ucdLib: "PERIND.ARG/INDAP.BGA2,5MG CP",
  UCD7: '9399624',
  UCD13: '3400893996249',
  ucdQtyMultiplicator: 30,
  cipLib: "PERIND.ARG/INDAP.BGA2,5MG CP BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '2680915',
  CIP13: '3400926809157',
  ucdLib: "PERIND.ARG/INDAP.BGA2,5MG CP",
  UCD7: '9399624',
  UCD13: '3400893996249',
  ucdQtyMultiplicator: 90,
  cipLib: "PERIND.ARG/INDAP.BGA2,5MG CP BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '2680973',
  CIP13: '3400926809737',
  ucdLib: "PERIND.ARG/INDAP.BGA5MG CPR",
  UCD7: '9399630',
  UCD13: '3400893996300',
  ucdQtyMultiplicator: 30,
  cipLib: "PERIND.ARG/INDAP.BGA5MG CPR BT 30",
  atcCode: "C09BA04"
}, {
  CIP7: '2681004',
  CIP13: '3400926810047',
  ucdLib: "PERIND.ARG/INDAP.BGA5MG CPR",
  UCD7: '9399630',
  UCD13: '3400893996300',
  ucdQtyMultiplicator: 90,
  cipLib: "PERIND.ARG/INDAP.BGA5MG CPR BT 90",
  atcCode: "C09BA04"
}, {
  CIP7: '3689025',
  CIP13: '3400936890251',
  ucdLib: "LISINOPRIL/HYD.EG 20/12,5 C.",
  UCD7: '9277447',
  UCD13: '3400892774473',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL/HYD.EG 20/12,5 C. BT 28",
  atcCode: "C09BA03"
}, {
  CIP7: '3745232',
  CIP13: '3400937452328',
  ucdLib: "LISINOPRIL/HYD.ARL 20/12,5 C",
  UCD7: '9289195',
  UCD13: '3400892891958',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL/HYD.ARL 20/12,5 C BT 28",
  atcCode: "C09BA03"
}, {
  CIP7: '3668218',
  CIP13: '3400936682184',
  ucdLib: "LISINOPRIL/HYD.BGA 20/12,5 C",
  UCD7: '9273840',
  UCD13: '3400892738406',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL/HYD.BGA 20/12,5 C BT 28",
  atcCode: "C09BA03"
}, {
  CIP7: '3768279',
  CIP13: '3400937682794',
  ucdLib: "LISINOPRIL/HYD.EG 20/12,5 C.",
  UCD7: '9277447',
  UCD13: '3400892774473',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL/HYD.EG 20/12,5 C. BT 84",
  atcCode: "C09BA03"
}, {
  CIP7: '3729428',
  CIP13: '3400937294287',
  ucdLib: "LISINOPRIL/HYD.SDZ 20/12,5 C",
  UCD7: '9279021',
  UCD13: '3400892790213',
  ucdQtyMultiplicator: 30,
  cipLib: "LISINOPRIL/HYD.SDZ 20/12,5 C BT 30",
  atcCode: "C09BA03"
}, {
  CIP7: '3729440',
  CIP13: '3400937294409',
  ucdLib: "LISINOPRIL/HYD.SDZ 20/12,5 C",
  UCD7: '9279021',
  UCD13: '3400892790213',
  ucdQtyMultiplicator: 90,
  cipLib: "LISINOPRIL/HYD.SDZ 20/12,5 C BT 90",
  atcCode: "C09BA03"
}, {
  CIP7: '3668164',
  CIP13: '3400936681644',
  ucdLib: "LISINOPRIL/HYD.TVC 20/12,5 C",
  UCD7: '9274041',
  UCD13: '3400892740416',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL/HYD.TVC 20/12,5 C BT 28",
  atcCode: "C09BA03"
}, {
  CIP7: '3780748',
  CIP13: '3400937807487',
  ucdLib: "LISINOPRIL/HYD.BGA 20/12,5 C",
  UCD7: '9273840',
  UCD13: '3400892738406',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL/HYD.BGA 20/12,5 C BT 84",
  atcCode: "C09BA03"
}, {
  CIP7: '3715372',
  CIP13: '3400937153720',
  ucdLib: "ZESTORETIC 20MG/12,5MG CPR",
  UCD7: '9143445',
  UCD13: '3400891434453',
  ucdQtyMultiplicator: 30,
  cipLib: "ZESTORETIC 20MG/12,5MG CPR BT 30",
  atcCode: "C09BA03"
}, {
  CIP7: '3715395',
  CIP13: '3400937153959',
  ucdLib: "ZESTORETIC 20MG/12,5MG CPR",
  UCD7: '9143445',
  UCD13: '3400891434453',
  ucdQtyMultiplicator: 90,
  cipLib: "ZESTORETIC 20MG/12,5MG CPR BT 90",
  atcCode: "C09BA03"
}, {
  CIP7: '3873125',
  CIP13: '3400938731255',
  ucdLib: "LISINOPRIL/HYD.ARL 20/12,5 C",
  UCD7: '9289195',
  UCD13: '3400892891958',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL/HYD.ARL 20/12,5 C BT 84",
  atcCode: "C09BA03"
}, {
  CIP7: '3738456',
  CIP13: '3400937384568',
  ucdLib: "LISINOPRIL/HYD.MYL 20/12,5 C",
  UCD7: '9273857',
  UCD13: '3400892738574',
  ucdQtyMultiplicator: 30,
  cipLib: "LISINOPRIL/HYD.MYL 20/12,5 C BT 30",
  atcCode: "C09BA03"
}, {
  CIP7: '3738479',
  CIP13: '3400937384797',
  ucdLib: "LISINOPRIL/HYD.MYL 20/12,5 C",
  UCD7: '9273857',
  UCD13: '3400892738574',
  ucdQtyMultiplicator: 90,
  cipLib: "LISINOPRIL/HYD.MYL 20/12,5 C BT 90",
  atcCode: "C09BA03"
}, {
  CIP7: '3876276',
  CIP13: '3400938762761',
  ucdLib: "LISINOPRIL/HYD.TVC 20/12,5 C",
  UCD7: '9274041',
  UCD13: '3400892740416',
  ucdQtyMultiplicator: 90,
  cipLib: "LISINOPRIL/HYD.TVC 20/12,5 C BT 90",
  atcCode: "C09BA03"
}, {
  CIP7: '3735162',
  CIP13: '3400937351621',
  ucdLib: "LISINOPRIL/HYD.ZEN 20/12,5 C",
  UCD7: '9285501',
  UCD13: '3400892855011',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL/HYD.ZEN 20/12,5 C BT 28",
  atcCode: "C09BA03"
}, {
  CIP7: '2172219',
  CIP13: '3400921722192',
  ucdLib: "LISINOPRIL/HYD.ZYD 20/12,5 C",
  UCD7: '9377930',
  UCD13: '3400893779309',
  ucdQtyMultiplicator: 30,
  cipLib: "LISINOPRIL/HYD.ZYD 20/12,5 C BT 30",
  atcCode: "C09BA03"
}, {
  CIP7: '2172225',
  CIP13: '3400921722253',
  ucdLib: "LISINOPRIL/HYD.ZYD 20/12,5 C",
  UCD7: '9377930',
  UCD13: '3400893779309',
  ucdQtyMultiplicator: 90,
  cipLib: "LISINOPRIL/HYD.ZYD 20/12,5 C BT 90",
  atcCode: "C09BA03"
}, {
  CIP7: '3302405',
  CIP13: '3400933024055',
  ucdLib: "CO-RENITEC 20MG/12,5MG CPR",
  UCD7: '9129758',
  UCD13: '3400891297584',
  ucdQtyMultiplicator: 28,
  cipLib: "CO-RENITEC 20MG/12,5MG CPR BT 28",
  atcCode: "C09BA02"
}, {
  CIP7: '3529155',
  CIP13: '3400935291554',
  ucdLib: "ENALAPRIL/HYD.CRT 20/12,5 C.",
  UCD7: '9338953',
  UCD13: '3400893389539',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL/HYD.CRT 20/12,5 C. BT 30",
  atcCode: "C09BA02"
}, {
  CIP7: '3529161',
  CIP13: '3400935291615',
  ucdLib: "ENALAPRIL/HYD.CRT 20/12,5 C.",
  UCD7: '9338953',
  UCD13: '3400893389539',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL/HYD.CRT 20/12,5 C. BT 90",
  atcCode: "C09BA02"
}, {
  CIP7: '3703937',
  CIP13: '3400937039376',
  ucdLib: "ENALAPRIL/HYD.PHR 20/12,5 C.",
  UCD7: '9281905',
  UCD13: '3400892819051',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL/HYD.PHR 20/12,5 C. BT 28",
  atcCode: "C09BA02"
}, {
  CIP7: '3703908',
  CIP13: '3400937039086',
  ucdLib: "ENALAPRIL/HYD.TVC 20/12,5 C.",
  UCD7: '9281911',
  UCD13: '3400892819112',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL/HYD.TVC 20/12,5 C. BT 28",
  atcCode: "C09BA02"
}, {
  CIP7: '3703989',
  CIP13: '3400937039895',
  ucdLib: "ENALAPRIL/HYD.ZEN 20/12,5 C.",
  UCD7: '9281590',
  UCD13: '3400892815909',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL/HYD.ZEN 20/12,5 C. BT 28",
  atcCode: "C09BA02"
}, {
  CIP7: '3664887',
  CIP13: '3400936648876',
  ucdLib: "ENALAPRIL/HYD.BGA 20/12,5 C.",
  UCD7: '9267437',
  UCD13: '3400892674377',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL/HYD.BGA 20/12,5 C. BT 28",
  atcCode: "C09BA02"
}, {
  CIP7: '3765536',
  CIP13: '3400937655361',
  ucdLib: "ENALAPRIL/HYD.BGA 20/12,5 C.",
  UCD7: '9267437',
  UCD13: '3400892674377',
  ucdQtyMultiplicator: 84,
  cipLib: "ENALAPRIL/HYD.BGA 20/12,5 C. BT 84",
  atcCode: "C09BA02"
}, {
  CIP7: '3768262',
  CIP13: '3400937682626',
  ucdLib: "ENALAPRIL/HYD.EG 20/12,5 C.",
  UCD7: '9281213',
  UCD13: '3400892812137',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL/HYD.EG 20/12,5 C. BT 90",
  atcCode: "C09BA02"
}, {
  CIP7: '3664918',
  CIP13: '3400936649187',
  ucdLib: "ENALAPRIL/HYD.MYL 20/12,5 C.",
  UCD7: '9267443',
  UCD13: '3400892674438',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL/HYD.MYL 20/12,5 C. BT 30",
  atcCode: "C09BA02"
}, {
  CIP7: '3636299',
  CIP13: '3400936362994',
  ucdLib: "ENALAPRIL/HYD.RPG 20/12,5 C.",
  UCD7: '9271338',
  UCD13: '3400892713380',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL/HYD.RPG 20/12,5 C. BT 28",
  atcCode: "C09BA02"
}, {
  CIP7: '3713781',
  CIP13: '3400937137812',
  ucdLib: "CO-RENITEC 20MG/12,5MG CPR",
  UCD7: '9129758',
  UCD13: '3400891297584',
  ucdQtyMultiplicator: 90,
  cipLib: "CO-RENITEC 20MG/12,5MG CPR BT 90",
  atcCode: "C09BA02"
}, {
  CIP7: '3739473',
  CIP13: '3400937394734',
  ucdLib: "ENALAPRIL/HYD.ARW 20/12,5 C.",
  UCD7: '9267348',
  UCD13: '3400892673486',
  ucdQtyMultiplicator: 84,
  cipLib: "ENALAPRIL/HYD.ARW 20/12,5 C. BT 84",
  atcCode: "C09BA02"
}, {
  CIP7: '3878967',
  CIP13: '3400938789676',
  ucdLib: "ENALAPRIL/HYD.EG 20/12,5 C.",
  UCD7: '9281213',
  UCD13: '3400892812137',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL/HYD.EG 20/12,5 C. BT 30",
  atcCode: "C09BA02"
}, {
  CIP7: '3730012',
  CIP13: '3400937300124',
  ucdLib: "ENALAPRIL/HYD.MYL 20/12,5 C.",
  UCD7: '9267443',
  UCD13: '3400892674438',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL/HYD.MYL 20/12,5 C. BT 90",
  atcCode: "C09BA02"
}, {
  CIP7: '3864327',
  CIP13: '3400938643275',
  ucdLib: "ENALAPRIL/HYD.SDZ 20/12,5 C.",
  UCD7: '9325092',
  UCD13: '3400893250921',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL/HYD.SDZ 20/12,5 C. BT 30",
  atcCode: "C09BA02"
}, {
  CIP7: '3864385',
  CIP13: '3400938643855',
  ucdLib: "ENALAPRIL/HYD.SDZ 20/12,5 C.",
  UCD7: '9325092',
  UCD13: '3400893250921',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL/HYD.SDZ 20/12,5 C. BT 90",
  atcCode: "C09BA02"
}, {
  CIP7: '3882851',
  CIP13: '3400938828511',
  ucdLib: "ENALAPRIL/HYD.TVC 20/12,5 C.",
  UCD7: '9281911',
  UCD13: '3400892819112',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL/HYD.TVC 20/12,5 C. BT 90",
  atcCode: "C09BA02"
}, {
  CIP7: '3847990',
  CIP13: '3400938479904',
  ucdLib: "ENALAPRIL/HYD.ARL 20/12,5 C.",
  UCD7: '9316408',
  UCD13: '3400893164082',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL/HYD.ARL 20/12,5 C. BT 28",
  atcCode: "C09BA02"
}, {
  CIP7: '3836992',
  CIP13: '3400938369922',
  ucdLib: "CAPTOPRIL/HYD.ZEN 50/25MG C.",
  UCD7: '9313031',
  UCD13: '3400893130315',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL/HYD.ZEN 50/25MG C. BT 30",
  atcCode: "C09BA01"
}, {
  CIP7: '3603816',
  CIP13: '3400936038165',
  ucdLib: "ECAZIDE CPR",
  UCD7: '9123603',
  UCD13: '3400891236033',
  ucdQtyMultiplicator: 90,
  cipLib: "ECAZIDE CPR BT 90",
  atcCode: "C09BA01"
}, {
  CIP7: '3631899',
  CIP13: '3400936318991',
  ucdLib: "CAPTOPRIL/HYD.ARW 50/25MG C.",
  UCD7: '9259863',
  UCD13: '3400892598635',
  ucdQtyMultiplicator: 28,
  cipLib: "CAPTOPRIL/HYD.ARW 50/25MG C. BT 28",
  atcCode: "C09BA01"
}, {
  CIP7: '3631379',
  CIP13: '3400936313798',
  ucdLib: "CAPTOPRIL/HYD.BGA 50/25MG C.",
  UCD7: '9257717',
  UCD13: '3400892577173',
  ucdQtyMultiplicator: 28,
  cipLib: "CAPTOPRIL/HYD.BGA 50/25MG C. BT 28",
  atcCode: "C09BA01"
}, {
  CIP7: '3664686',
  CIP13: '3400936646865',
  ucdLib: "CAPTOPRIL/HYD.MYL 50/25MG C.",
  UCD7: '9266679',
  UCD13: '3400892666792',
  ucdQtyMultiplicator: 28,
  cipLib: "CAPTOPRIL/HYD.MYL 50/25MG C. BT 28",
  atcCode: "C09BA01"
}, {
  CIP7: '3724359',
  CIP13: '3400937243599',
  ucdLib: "CAPTOPRIL/HYD.MYL 50/25MG C.",
  UCD7: '9266679',
  UCD13: '3400892666792',
  ucdQtyMultiplicator: 84,
  cipLib: "CAPTOPRIL/HYD.MYL 50/25MG C. BT 84",
  atcCode: "C09BA01"
}, {
  CIP7: '3742400',
  CIP13: '3400937424004',
  ucdLib: "CAPTOPRIL/HYD.TVC 50/25MG C.",
  UCD7: '9287173',
  UCD13: '3400892871738',
  ucdQtyMultiplicator: 28,
  cipLib: "CAPTOPRIL/HYD.TVC 50/25MG C. BT 28",
  atcCode: "C09BA01"
}, {
  CIP7: '3780783',
  CIP13: '3400937807838',
  ucdLib: "CAPTOPRIL/HYD.BGA 50/25MG C.",
  UCD7: '9257717',
  UCD13: '3400892577173',
  ucdQtyMultiplicator: 84,
  cipLib: "CAPTOPRIL/HYD.BGA 50/25MG C. BT 84",
  atcCode: "C09BA01"
}, {
  CIP7: '3799630',
  CIP13: '3400937996303',
  ucdLib: "CAPTOPRIL/HYD.EG 50/25MG C.",
  UCD7: '9290821',
  UCD13: '3400892908212',
  ucdQtyMultiplicator: 90,
  cipLib: "CAPTOPRIL/HYD.EG 50/25MG C. BT 90",
  atcCode: "C09BA01"
}, {
  CIP7: '3790882',
  CIP13: '3400937908825',
  ucdLib: "CAPTOPRIL/HYD.SDZ 50/25MG C.",
  UCD7: '9277329',
  UCD13: '3400892773292',
  ucdQtyMultiplicator: 28,
  cipLib: "CAPTOPRIL/HYD.SDZ 50/25MG C. BT 28",
  atcCode: "C09BA01"
}, {
  CIP7: '3733186',
  CIP13: '3400937331869',
  ucdLib: "CAPTOPRIL/HYD.CRT 50/25MG C.",
  UCD7: '9351907',
  UCD13: '3400893519073',
  ucdQtyMultiplicator: 28,
  cipLib: "CAPTOPRIL/HYD.CRT 50/25MG C. BT 28",
  atcCode: "C09BA01"
}, {
  CIP7: '3733217',
  CIP13: '3400937332170',
  ucdLib: "CAPTOPRIL/HYD.CRT 50/25MG C.",
  UCD7: '9351907',
  UCD13: '3400893519073',
  ucdQtyMultiplicator: 84,
  cipLib: "CAPTOPRIL/HYD.CRT 50/25MG C. BT 84",
  atcCode: "C09BA01"
}, {
  CIP7: '3875667',
  CIP13: '3400938756678',
  ucdLib: "CAPTOPRIL/HYD.EG 50/25MG C.",
  UCD7: '9290821',
  UCD13: '3400892908212',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL/HYD.EG 50/25MG C. BT 30",
  atcCode: "C09BA01"
}, {
  CIP7: '3876098',
  CIP13: '3400938760989',
  ucdLib: "CAPTOPRIL/HYD.TVC 50/25MG C.",
  UCD7: '9287173',
  UCD13: '3400892871738',
  ucdQtyMultiplicator: 84,
  cipLib: "CAPTOPRIL/HYD.TVC 50/25MG C. BT 84",
  atcCode: "C09BA01"
}, {
  CIP7: '3845962',
  CIP13: '3400938459623',
  ucdLib: "CAPTOPRIL/HYD.ACT 50/25MG C.",
  UCD7: '9316147',
  UCD13: '3400893161470',
  ucdQtyMultiplicator: 28,
  cipLib: "CAPTOPRIL/HYD.ACT 50/25MG C. BT 28",
  atcCode: "C09BA01"
}, {
  CIP7: '3974895',
  CIP13: '3400939748955',
  ucdLib: "ECAZIDE CPR",
  UCD7: '9123603',
  UCD13: '3400891236033',
  ucdQtyMultiplicator: 30,
  cipLib: "ECAZIDE CPR BT 30",
  atcCode: "C09BA01"
}, {
  CIP7: '3983546',
  CIP13: '3400939835464',
  ucdLib: "CAPTEA CPR",
  UCD7: '9123595',
  UCD13: '3400891235951',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTEA CPR BT 30",
  atcCode: "C09BA01"
}, {
  CIP7: '3989052',
  CIP13: '3400939890524',
  ucdLib: "CAPTEA CPR",
  UCD7: '9123595',
  UCD13: '3400891235951',
  ucdQtyMultiplicator: 90,
  cipLib: "CAPTEA CPR BT 90",
  atcCode: "C09BA01"
}, {
  CIP7: '3741889',
  CIP13: '3400937418898',
  ucdLib: "TEOULA 15MG CPR",
  UCD7: '9238950',
  UCD13: '3400892389509',
  ucdQtyMultiplicator: 30,
  cipLib: "TEOULA 15MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '3741903',
  CIP13: '3400937419031',
  ucdLib: "TEOULA 30MG CPR",
  UCD7: '9238967',
  UCD13: '3400892389677',
  ucdQtyMultiplicator: 30,
  cipLib: "TEOULA 30MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '3741932',
  CIP13: '3400937419321',
  ucdLib: "TEOULA 60MG CPR",
  UCD7: '9238973',
  UCD13: '3400892389738',
  ucdQtyMultiplicator: 30,
  cipLib: "TEOULA 60MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '3741866',
  CIP13: '3400937418669',
  ucdLib: "TEOULA 7,5MG CPR",
  UCD7: '9238996',
  UCD13: '3400892389967',
  ucdQtyMultiplicator: 30,
  cipLib: "TEOULA 7,5MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '3741978',
  CIP13: '3400937419789',
  ucdLib: "ZOFENIL 15MG CPR",
  UCD7: '9238536',
  UCD13: '3400892385365',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOFENIL 15MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '3741984',
  CIP13: '3400937419840',
  ucdLib: "ZOFENIL 15MG CPR",
  UCD7: '9238536',
  UCD13: '3400892385365',
  ucdQtyMultiplicator: 90,
  cipLib: "ZOFENIL 15MG CPR BT 90",
  atcCode: "C09AA15"
}, {
  CIP7: '3741990',
  CIP13: '3400937419901',
  ucdLib: "ZOFENIL 30MG CPR",
  UCD7: '9238542',
  UCD13: '3400892385426',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOFENIL 30MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '3742009',
  CIP13: '3400937420099',
  ucdLib: "ZOFENIL 30MG CPR",
  UCD7: '9238542',
  UCD13: '3400892385426',
  ucdQtyMultiplicator: 90,
  cipLib: "ZOFENIL 30MG CPR BT 90",
  atcCode: "C09AA15"
}, {
  CIP7: '3742015',
  CIP13: '3400937420150',
  ucdLib: "ZOFENIL 60MG CPR",
  UCD7: '9238559',
  UCD13: '3400892385594',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOFENIL 60MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '3741955',
  CIP13: '3400937419550',
  ucdLib: "ZOFENIL 7,5MG CPR",
  UCD7: '9238565',
  UCD13: '3400892385655',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOFENIL 7,5MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '4195093',
  CIP13: '3400941950933',
  ucdLib: "ZOFENOPRIL MYL 30MG CPR",
  UCD7: '9380429',
  UCD13: '3400893804292',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOFENOPRIL MYL 30MG CPR BT 30",
  atcCode: "C09AA15"
}, {
  CIP7: '4195118',
  CIP13: '3400941951183',
  ucdLib: "ZOFENOPRIL MYL 30MG CPR",
  UCD7: '9380429',
  UCD13: '3400893804292',
  ucdQtyMultiplicator: 90,
  cipLib: "ZOFENOPRIL MYL 30MG CPR BT 90",
  atcCode: "C09AA15"
}, {
  CIP7: '3193904',
  CIP13: '3400931939047',
  ucdLib: "TRANDOLAPRIL EG 2MG GELU",
  UCD7: '9345427',
  UCD13: '3400893454275',
  ucdQtyMultiplicator: 90,
  cipLib: "TRANDOLAPRIL EG 2MG GELU BT 90",
  atcCode: "C09AA10"
}, {
  CIP7: '3197227',
  CIP13: '3400931972273',
  ucdLib: "TRANDOLAPRIL EG 4MG GELU",
  UCD7: '9345433',
  UCD13: '3400893454336',
  ucdQtyMultiplicator: 90,
  cipLib: "TRANDOLAPRIL EG 4MG GELU BT 90",
  atcCode: "C09AA10"
}, {
  CIP7: '3347313',
  CIP13: '3400933473136',
  ucdLib: "ODRIK 0,5MG GELU",
  UCD7: '9156991',
  UCD13: '3400891569919',
  ucdQtyMultiplicator: 28,
  cipLib: "ODRIK 0,5MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3347336',
  CIP13: '3400933473365',
  ucdLib: "ODRIK 2MG GELU",
  UCD7: '9157016',
  UCD13: '3400891570168',
  ucdQtyMultiplicator: 28,
  cipLib: "ODRIK 2MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3714622',
  CIP13: '3400937146227',
  ucdLib: "ODRIK 0,5MG GELU",
  UCD7: '9156991',
  UCD13: '3400891569919',
  ucdQtyMultiplicator: 84,
  cipLib: "ODRIK 0,5MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3715254',
  CIP13: '3400937152549',
  ucdLib: "ODRIK 2MG GELU",
  UCD7: '9157016',
  UCD13: '3400891570168',
  ucdQtyMultiplicator: 84,
  cipLib: "ODRIK 2MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3644123',
  CIP13: '3400936441231',
  ucdLib: "ODRIK 4MG GELU",
  UCD7: '9274779',
  UCD13: '3400892747798',
  ucdQtyMultiplicator: 28,
  cipLib: "ODRIK 4MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3713746',
  CIP13: '3400937137461',
  ucdLib: "ODRIK 4MG GELU",
  UCD7: '9274779',
  UCD13: '3400892747798',
  ucdQtyMultiplicator: 84,
  cipLib: "ODRIK 4MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3881455',
  CIP13: '3400938814552',
  ucdLib: "TRANDOLAPRIL BGA 0,5MG GELU",
  UCD7: '9325689',
  UCD13: '3400893256893',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL BGA 0,5MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3881478',
  CIP13: '3400938814781',
  ucdLib: "TRANDOLAPRIL BGA 0,5MG GELU",
  UCD7: '9325689',
  UCD13: '3400893256893',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL BGA 0,5MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3881490',
  CIP13: '3400938814903',
  ucdLib: "TRANDOLAPRIL BGA 2MG GELU",
  UCD7: '9325695',
  UCD13: '3400893256954',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL BGA 2MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3881515',
  CIP13: '3400938815153',
  ucdLib: "TRANDOLAPRIL BGA 2MG GELU",
  UCD7: '9325695',
  UCD13: '3400893256954',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL BGA 2MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3881596',
  CIP13: '3400938815962',
  ucdLib: "TRANDOLAPRIL BGA 4MG GELU",
  UCD7: '9325703',
  UCD13: '3400893257036',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL BGA 4MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3881610',
  CIP13: '3400938816105',
  ucdLib: "TRANDOLAPRIL BGA 4MG GELU",
  UCD7: '9325703',
  UCD13: '3400893257036',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL BGA 4MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3960367',
  CIP13: '3400939603674',
  ucdLib: "TRANDOLAPRIL ARW 0,5MG GELU",
  UCD7: '9344072',
  UCD13: '3400893440728',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL ARW 0,5MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3960686',
  CIP13: '3400939606866',
  ucdLib: "TRANDOLAPRIL ARW 2MG GELU",
  UCD7: '9344089',
  UCD13: '3400893440896',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL ARW 2MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3961065',
  CIP13: '3400939610658',
  ucdLib: "TRANDOLAPRIL ARW 4MG GELU",
  UCD7: '9344095',
  UCD13: '3400893440957',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL ARW 4MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3976517',
  CIP13: '3400939765174',
  ucdLib: "TRANDOLAPRIL EG 0,5MG GELU",
  UCD7: '9345410',
  UCD13: '3400893454107',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANDOLAPRIL EG 0,5MG GELU BT 30",
  atcCode: "C09AA10"
}, {
  CIP7: '3976546',
  CIP13: '3400939765464',
  ucdLib: "TRANDOLAPRIL EG 0,5MG GELU",
  UCD7: '9345410',
  UCD13: '3400893454107',
  ucdQtyMultiplicator: 90,
  cipLib: "TRANDOLAPRIL EG 0,5MG GELU BT 90",
  atcCode: "C09AA10"
}, {
  CIP7: '3976569',
  CIP13: '3400939765693',
  ucdLib: "TRANDOLAPRIL EG 2MG GELU",
  UCD7: '9345427',
  UCD13: '3400893454275',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANDOLAPRIL EG 2MG GELU BT 30",
  atcCode: "C09AA10"
}, {
  CIP7: '3976581',
  CIP13: '3400939765815',
  ucdLib: "TRANDOLAPRIL EG 4MG GELU",
  UCD7: '9345433',
  UCD13: '3400893454336',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANDOLAPRIL EG 4MG GELU BT 30",
  atcCode: "C09AA10"
}, {
  CIP7: '3847197',
  CIP13: '3400938471977',
  ucdLib: "TRANDOLAPRIL MYL 0,5MG GELU",
  UCD7: '9315975',
  UCD13: '3400893159750',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL MYL 0,5MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3847286',
  CIP13: '3400938472868',
  ucdLib: "TRANDOLAPRIL MYL 2MG GELU",
  UCD7: '9315981',
  UCD13: '3400893159811',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL MYL 2MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3847323',
  CIP13: '3400938473230',
  ucdLib: "TRANDOLAPRIL MYL 2MG GELU",
  UCD7: '9315981',
  UCD13: '3400893159811',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL MYL 2MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3847375',
  CIP13: '3400938473759',
  ucdLib: "TRANDOLAPRIL MYL 4MG GELU",
  UCD7: '9315998',
  UCD13: '3400893159989',
  ucdQtyMultiplicator: 28,
  cipLib: "TRANDOLAPRIL MYL 4MG GELU BT 28",
  atcCode: "C09AA10"
}, {
  CIP7: '3847412',
  CIP13: '3400938474121',
  ucdLib: "TRANDOLAPRIL MYL 4MG GELU",
  UCD7: '9315998',
  UCD13: '3400893159989',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL MYL 4MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3999168',
  CIP13: '3400939991689',
  ucdLib: "TRANDOLAPRIL ARW 0,5MG GELU",
  UCD7: '9344072',
  UCD13: '3400893440728',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL ARW 0,5MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3999174',
  CIP13: '3400939991740',
  ucdLib: "TRANDOLAPRIL ARW 2MG GELU",
  UCD7: '9344089',
  UCD13: '3400893440896',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL ARW 2MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '3992568',
  CIP13: '3400939925684',
  ucdLib: "TRANDOLAPRIL ARW 4MG GELU",
  UCD7: '9344095',
  UCD13: '3400893440957',
  ucdQtyMultiplicator: 84,
  cipLib: "TRANDOLAPRIL ARW 4MG GELU BT 84",
  atcCode: "C09AA10"
}, {
  CIP7: '5591916',
  CIP13: '3400955919162',
  ucdLib: "FOZITEC 10MG CPR",
  UCD7: '9172636',
  UCD13: '3400891726367',
  ucdQtyMultiplicator: 50,
  cipLib: "FOZITEC 10MG CPR BT 50",
  atcCode: "C09AA09"
}, {
  CIP7: '5591891',
  CIP13: '3400955918912',
  ucdLib: "FOZITEC 20MG CPR",
  UCD7: '9172642',
  UCD13: '3400891726428',
  ucdQtyMultiplicator: 50,
  cipLib: "FOZITEC 20MG CPR BT 50",
  atcCode: "C09AA09"
}, {
  CIP7: '3720019',
  CIP13: '3400937200196',
  ucdLib: "FOZITEC 10MG CPR",
  UCD7: '9172636',
  UCD13: '3400891726367',
  ucdQtyMultiplicator: 30,
  cipLib: "FOZITEC 10MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3720025',
  CIP13: '3400937200257',
  ucdLib: "FOZITEC 10MG CPR",
  UCD7: '9172636',
  UCD13: '3400891726367',
  ucdQtyMultiplicator: 90,
  cipLib: "FOZITEC 10MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3720031',
  CIP13: '3400937200318',
  ucdLib: "FOZITEC 20MG CPR",
  UCD7: '9172642',
  UCD13: '3400891726428',
  ucdQtyMultiplicator: 30,
  cipLib: "FOZITEC 20MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3720048',
  CIP13: '3400937200486',
  ucdLib: "FOZITEC 20MG CPR",
  UCD7: '9172642',
  UCD13: '3400891726428',
  ucdQtyMultiplicator: 90,
  cipLib: "FOZITEC 20MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3718330',
  CIP13: '3400937183307',
  ucdLib: "FOSINOPRIL TVC 10MG CPR",
  UCD7: '9323957',
  UCD13: '3400893239575',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL TVC 10MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3718376',
  CIP13: '3400937183765',
  ucdLib: "FOSINOPRIL TVC 20MG CPR",
  UCD7: '9285607',
  UCD13: '3400892856070',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL TVC 20MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3882762',
  CIP13: '3400938827620',
  ucdLib: "FOSINOPRIL EG 10MG CPR",
  UCD7: '9325175',
  UCD13: '3400893251751',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL EG 10MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3882785',
  CIP13: '3400938827859',
  ucdLib: "FOSINOPRIL EG 10MG CPR",
  UCD7: '9325175',
  UCD13: '3400893251751',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL EG 10MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3882791',
  CIP13: '3400938827910',
  ucdLib: "FOSINOPRIL EG 20MG CPR",
  UCD7: '9325181',
  UCD13: '3400893251812',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL EG 20MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3882822',
  CIP13: '3400938828221',
  ucdLib: "FOSINOPRIL EG 20MG CPR",
  UCD7: '9325181',
  UCD13: '3400893251812',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL EG 20MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3867403',
  CIP13: '3400938674033',
  ucdLib: "FOSINOPRIL ZEN 10MG CPR",
  UCD7: '9323963',
  UCD13: '3400893239636',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL ZEN 10MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3867366',
  CIP13: '3400938673661',
  ucdLib: "FOSINOPRIL ZEN 20MG CPR",
  UCD7: '9323986',
  UCD13: '3400893239865',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL ZEN 20MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3972850',
  CIP13: '3400939728506',
  ucdLib: "FOSINOPRIL ARG 10MG CPR",
  UCD7: '9342854',
  UCD13: '3400893428542',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL ARG 10MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3972896',
  CIP13: '3400939728964',
  ucdLib: "FOSINOPRIL ARG 10MG CPR",
  UCD7: '9342854',
  UCD13: '3400893428542',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL ARG 10MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3972979',
  CIP13: '3400939729794',
  ucdLib: "FOSINOPRIL ARG 20MG CPR",
  UCD7: '9342860',
  UCD13: '3400893428603',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL ARG 20MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3973016',
  CIP13: '3400939730165',
  ucdLib: "FOSINOPRIL ARG 20MG CPR",
  UCD7: '9342860',
  UCD13: '3400893428603',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL ARG 20MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3957448',
  CIP13: '3400939574486',
  ucdLib: "FOSINOPRIL BGA 10MG CPR",
  UCD7: '9342050',
  UCD13: '3400893420508',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL BGA 10MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3958637',
  CIP13: '3400939586373',
  ucdLib: "FOSINOPRIL BGA 10MG CPR",
  UCD7: '9342050',
  UCD13: '3400893420508',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL BGA 10MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3957477',
  CIP13: '3400939574776',
  ucdLib: "FOSINOPRIL BGA 20MG CPR",
  UCD7: '9342067',
  UCD13: '3400893420676',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL BGA 20MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3957833',
  CIP13: '3400939578330',
  ucdLib: "FOSINOPRIL BGA 20MG CPR",
  UCD7: '9342067',
  UCD13: '3400893420676',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL BGA 20MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3971922',
  CIP13: '3400939719221',
  ucdLib: "FOSINOPRIL CRT 10MG CPR",
  UCD7: '9341642',
  UCD13: '3400893416426',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL CRT 10MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3972229',
  CIP13: '3400939722290',
  ucdLib: "FOSINOPRIL CRT 20MG CPR",
  UCD7: '9341659',
  UCD13: '3400893416594',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL CRT 20MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3900508',
  CIP13: '3400939005089',
  ucdLib: "FOSINOPRIL MYL 10MG CPR",
  UCD7: '9288652',
  UCD13: '3400892886527',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL MYL 10MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3900514',
  CIP13: '3400939005140',
  ucdLib: "FOSINOPRIL MYL 10MG CPR",
  UCD7: '9288652',
  UCD13: '3400892886527',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL MYL 10MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3900520',
  CIP13: '3400939005201',
  ucdLib: "FOSINOPRIL MYL 20MG CPR",
  UCD7: '9288913',
  UCD13: '3400892889139',
  ucdQtyMultiplicator: 30,
  cipLib: "FOSINOPRIL MYL 20MG CPR BT 30",
  atcCode: "C09AA09"
}, {
  CIP7: '3900537',
  CIP13: '3400939005379',
  ucdLib: "FOSINOPRIL MYL 20MG CPR",
  UCD7: '9288913',
  UCD13: '3400892889139',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL MYL 20MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3895233',
  CIP13: '3400938952339',
  ucdLib: "FOSINOPRIL TVC 10MG CPR",
  UCD7: '9323957',
  UCD13: '3400893239575',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL TVC 10MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3895285',
  CIP13: '3400938952858',
  ucdLib: "FOSINOPRIL TVC 20MG CPR",
  UCD7: '9285607',
  UCD13: '3400892856070',
  ucdQtyMultiplicator: 90,
  cipLib: "FOSINOPRIL TVC 20MG CPR BT 90",
  atcCode: "C09AA09"
}, {
  CIP7: '3722395',
  CIP13: '3400937223959',
  ucdLib: "BRIEM 10MG CPR",
  UCD7: '9148454',
  UCD13: '3400891484540',
  ucdQtyMultiplicator: 30,
  cipLib: "BRIEM 10MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '3722426',
  CIP13: '3400937224260',
  ucdLib: "BRIEM 10MG CPR",
  UCD7: '9148454',
  UCD13: '3400891484540',
  ucdQtyMultiplicator: 90,
  cipLib: "BRIEM 10MG CPR BT 90",
  atcCode: "C09AA07"
}, {
  CIP7: '3784261',
  CIP13: '3400937842617',
  ucdLib: "BENAZEPRIL EG 10MG CPR",
  UCD7: '9296373',
  UCD13: '3400892963730',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL EG 10MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '3784249',
  CIP13: '3400937842495',
  ucdLib: "BENAZEPRIL EG 5MG CPR",
  UCD7: '9296396',
  UCD13: '3400892963969',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL EG 5MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '3870807',
  CIP13: '3400938708073',
  ucdLib: "BENAZEPRIL TVS 10MG CPR",
  UCD7: '9321622',
  UCD13: '3400893216224',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL TVS 10MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '3870859',
  CIP13: '3400938708592',
  ucdLib: "BENAZEPRIL TVS 5MG CPR",
  UCD7: '9321639',
  UCD13: '3400893216392',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL TVS 5MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '3870888',
  CIP13: '3400938708882',
  ucdLib: "BENAZEPRIL TVS 5MG CPR",
  UCD7: '9321639',
  UCD13: '3400893216392',
  ucdQtyMultiplicator: 90,
  cipLib: "BENAZEPRIL TVS 5MG CPR BT 90",
  atcCode: "C09AA07"
}, {
  CIP7: '3731247',
  CIP13: '3400937312479',
  ucdLib: "CIBACENE 10MG CPR",
  UCD7: '9148477',
  UCD13: '3400891484779',
  ucdQtyMultiplicator: 30,
  cipLib: "CIBACENE 10MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '3731276',
  CIP13: '3400937312769',
  ucdLib: "CIBACENE 10MG CPR",
  UCD7: '9148477',
  UCD13: '3400891484779',
  ucdQtyMultiplicator: 90,
  cipLib: "CIBACENE 10MG CPR BT 90",
  atcCode: "C09AA07"
}, {
  CIP7: '3731218',
  CIP13: '3400937312189',
  ucdLib: "CIBACENE 5MG CPR",
  UCD7: '9148483',
  UCD13: '3400891484830',
  ucdQtyMultiplicator: 30,
  cipLib: "CIBACENE 5MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '3731230',
  CIP13: '3400937312301',
  ucdLib: "CIBACENE 5MG CPR",
  UCD7: '9148483',
  UCD13: '3400891484830',
  ucdQtyMultiplicator: 90,
  cipLib: "CIBACENE 5MG CPR BT 90",
  atcCode: "C09AA07"
}, {
  CIP7: '2176772',
  CIP13: '3400921767728',
  ucdLib: "BENAZEPRIL ARW 10MG CPR",
  UCD7: '9381802',
  UCD13: '3400893818022',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL ARW 10MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '2176826',
  CIP13: '3400921768268',
  ucdLib: "BENAZEPRIL ARW 10MG CPR",
  UCD7: '9381802',
  UCD13: '3400893818022',
  ucdQtyMultiplicator: 90,
  cipLib: "BENAZEPRIL ARW 10MG CPR BT 90",
  atcCode: "C09AA07"
}, {
  CIP7: '2176571',
  CIP13: '3400921765717',
  ucdLib: "BENAZEPRIL ARW 5MG CPR",
  UCD7: '9381475',
  UCD13: '3400893814758',
  ucdQtyMultiplicator: 30,
  cipLib: "BENAZEPRIL ARW 5MG CPR BT 30",
  atcCode: "C09AA07"
}, {
  CIP7: '2176619',
  CIP13: '3400921766196',
  ucdLib: "BENAZEPRIL ARW 5MG CPR",
  UCD7: '9381475',
  UCD13: '3400893814758',
  ucdQtyMultiplicator: 90,
  cipLib: "BENAZEPRIL ARW 5MG CPR BT 90",
  atcCode: "C09AA07"
}, {
  CIP7: '3317223',
  CIP13: '3400933172237',
  ucdLib: "ACUITEL 20MG CPR",
  UCD7: '9140932',
  UCD13: '3400891409321',
  ucdQtyMultiplicator: 28,
  cipLib: "ACUITEL 20MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3317252',
  CIP13: '3400933172527',
  ucdLib: "ACUITEL 5MG CPR",
  UCD7: '9140949',
  UCD13: '3400891409499',
  ucdQtyMultiplicator: 28,
  cipLib: "ACUITEL 5MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3729641',
  CIP13: '3400937296410',
  ucdLib: "ACUITEL 20MG CPR",
  UCD7: '9140932',
  UCD13: '3400891409321',
  ucdQtyMultiplicator: 90,
  cipLib: "ACUITEL 20MG CPR BT 90",
  atcCode: "C09AA06"
}, {
  CIP7: '3729635',
  CIP13: '3400937296359',
  ucdLib: "ACUITEL 5MG CPR",
  UCD7: '9140949',
  UCD13: '3400891409499',
  ucdQtyMultiplicator: 90,
  cipLib: "ACUITEL 5MG CPR BT 90",
  atcCode: "C09AA06"
}, {
  CIP7: '3763359',
  CIP13: '3400937633598',
  ucdLib: "QUINAPRIL ARW 20MG CPR",
  UCD7: '9290991',
  UCD13: '3400892909912',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL ARW 20MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3763342',
  CIP13: '3400937633420',
  ucdLib: "QUINAPRIL ARW 5MG CPR",
  UCD7: '9291016',
  UCD13: '3400892910161',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL ARW 5MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3639168',
  CIP13: '3400936391680',
  ucdLib: "QUINAPRIL TVC 20MG CPR",
  UCD7: '9263505',
  UCD13: '3400892635057',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL TVC 20MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3639145',
  CIP13: '3400936391451',
  ucdLib: "QUINAPRIL TVC 5MG CPR",
  UCD7: '9283778',
  UCD13: '3400892837789',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL TVC 5MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3780033',
  CIP13: '3400937800334',
  ucdLib: "QUINAPRIL BGA 20MG CPR",
  UCD7: '9298863',
  UCD13: '3400892988634',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL BGA 20MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3647222',
  CIP13: '3400936472228',
  ucdLib: "QUINAPRIL MYL 20MG CPR",
  UCD7: '9263497',
  UCD13: '3400892634975',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL MYL 20MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3781699',
  CIP13: '3400937816991',
  ucdLib: "QUINAPRIL ZEN 20MG CPR",
  UCD7: '9298892',
  UCD13: '3400892988924',
  ucdQtyMultiplicator: 30,
  cipLib: "QUINAPRIL ZEN 20MG CPR BT 30",
  atcCode: "C09AA06"
}, {
  CIP7: '3738367',
  CIP13: '3400937383677',
  ucdLib: "QUINAPRIL MYL 20MG CPR",
  UCD7: '9263497',
  UCD13: '3400892634975',
  ucdQtyMultiplicator: 84,
  cipLib: "QUINAPRIL MYL 20MG CPR BT 84",
  atcCode: "C09AA06"
}, {
  CIP7: '3875348',
  CIP13: '3400938753486',
  ucdLib: "QUINAPRIL TVC 20MG CPR",
  UCD7: '9263505',
  UCD13: '3400892635057',
  ucdQtyMultiplicator: 90,
  cipLib: "QUINAPRIL TVC 20MG CPR BT 90",
  atcCode: "C09AA06"
}, {
  CIP7: '4971048',
  CIP13: '3400949710485',
  ucdLib: "QUINAPRIL EG 20MG CPR",
  UCD7: '9359665',
  UCD13: '3400893596654',
  ucdQtyMultiplicator: 28,
  cipLib: "QUINAPRIL EG 20MG CPR BT 28",
  atcCode: "C09AA06"
}, {
  CIP7: '3615386',
  CIP13: '3400936153868',
  ucdLib: "TRIATEC 10MG CPR",
  UCD7: '9248457',
  UCD13: '3400892484570',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIATEC 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2765126',
  CIP13: '3400927651267',
  ucdLib: "RAMIPRIL RPG 1,25MG CPR",
  UCD7: '9404851',
  UCD13: '3400894048510',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL RPG 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2765132',
  CIP13: '3400927651328',
  ucdLib: "RAMIPRIL RPG 1,25MG CPR",
  UCD7: '9404851',
  UCD13: '3400894048510',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL RPG 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '2765439',
  CIP13: '3400927654398',
  ucdLib: "RAMIPRIL RPG 10MG CPR",
  UCD7: '9404868',
  UCD13: '3400894048688',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL RPG 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2765445',
  CIP13: '3400927654459',
  ucdLib: "RAMIPRIL RPG 10MG CPR",
  UCD7: '9404868',
  UCD13: '3400894048688',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL RPG 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '2765267',
  CIP13: '3400927652677',
  ucdLib: "RAMIPRIL RPG 2,5MG CPR",
  UCD7: '9404874',
  UCD13: '3400894048749',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL RPG 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2765273',
  CIP13: '3400927652738',
  ucdLib: "RAMIPRIL RPG 2,5MG CPR",
  UCD7: '9404874',
  UCD13: '3400894048749',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL RPG 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '2765356',
  CIP13: '3400927653568',
  ucdLib: "RAMIPRIL RPG 5MG CPR",
  UCD7: '9404880',
  UCD13: '3400894048800',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL RPG 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2765362',
  CIP13: '3400927653629',
  ucdLib: "RAMIPRIL RPG 5MG CPR",
  UCD7: '9404880',
  UCD13: '3400894048800',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL RPG 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3683206',
  CIP13: '3400936832060',
  ucdLib: "RAMIPRIL SDZ 1,25MG CPR",
  UCD7: '9280260',
  UCD13: '3400892802602',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL SDZ 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3683465',
  CIP13: '3400936834651',
  ucdLib: "RAMIPRIL SDZ 10MG CPR",
  UCD7: '9280277',
  UCD13: '3400892802770',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL SDZ 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3683287',
  CIP13: '3400936832879',
  ucdLib: "RAMIPRIL SDZ 2,5MG CPR",
  UCD7: '9280283',
  UCD13: '3400892802831',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL SDZ 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3683376',
  CIP13: '3400936833760',
  ucdLib: "RAMIPRIL SDZ 5MG CPR",
  UCD7: '9280308',
  UCD13: '3400892803081',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL SDZ 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3670391',
  CIP13: '3400936703919',
  ucdLib: "RAMIPRIL ZEN 1,25MG CPR",
  UCD7: '9274532',
  UCD13: '3400892745329',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ZEN 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3670445',
  CIP13: '3400936704459',
  ucdLib: "RAMIPRIL ZEN 2,5MG CPR",
  UCD7: '9274549',
  UCD13: '3400892745497',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ZEN 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3670480',
  CIP13: '3400936704800',
  ucdLib: "RAMIPRIL ZEN 5MG CPR",
  UCD7: '9274555',
  UCD13: '3400892745558',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ZEN 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3852287',
  CIP13: '3400938522877',
  ucdLib: "RAMIPRIL ALT 5MG CPR",
  UCD7: '9289539',
  UCD13: '3400892895390',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ALT 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3700531',
  CIP13: '3400937005319',
  ucdLib: "RAMIPRIL MYL 1,25MG CPR",
  UCD7: '9279682',
  UCD13: '3400892796826',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL MYL 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3700809',
  CIP13: '3400937008099',
  ucdLib: "RAMIPRIL MYL 10MG CPR",
  UCD7: '9279699',
  UCD13: '3400892796994',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL MYL 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3700844',
  CIP13: '3400937008440',
  ucdLib: "RAMIPRIL MYL 10MG CPR",
  UCD7: '9279699',
  UCD13: '3400892796994',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL MYL 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3700620',
  CIP13: '3400937006200',
  ucdLib: "RAMIPRIL MYL 2,5MG CPR",
  UCD7: '9279707',
  UCD13: '3400892797076',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL MYL 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3700672',
  CIP13: '3400937006729',
  ucdLib: "RAMIPRIL MYL 2,5MG CPR",
  UCD7: '9279707',
  UCD13: '3400892797076',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL MYL 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3700726',
  CIP13: '3400937007269',
  ucdLib: "RAMIPRIL MYL 5MG CPR",
  UCD7: '9279713',
  UCD13: '3400892797137',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL MYL 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3700761',
  CIP13: '3400937007610',
  ucdLib: "RAMIPRIL MYL 5MG CPR",
  UCD7: '9279713',
  UCD13: '3400892797137',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL MYL 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3727688',
  CIP13: '3400937276887',
  ucdLib: "RAMIPRIL ALT 10MG CPR",
  UCD7: '9289516',
  UCD13: '3400892895161',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ALT 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3727464',
  CIP13: '3400937274647',
  ucdLib: "RAMIPRIL ALT 2,5MG CPR",
  UCD7: '9289522',
  UCD13: '3400892895222',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ALT 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3727576',
  CIP13: '3400937275767',
  ucdLib: "RAMIPRIL ALT 5MG CPR",
  UCD7: '9289539',
  UCD13: '3400892895390',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ALT 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3726364',
  CIP13: '3400937263641',
  ucdLib: "RAMIPRIL BCR 10MG CPR",
  UCD7: '9284660',
  UCD13: '3400892846606',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL BCR 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3740134',
  CIP13: '3400937401340',
  ucdLib: "RAMIPRIL BCR 10MG CPR",
  UCD7: '9284660',
  UCD13: '3400892846606',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL BCR 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3726140',
  CIP13: '3400937261401',
  ucdLib: "RAMIPRIL BCR 2,5MG CPR",
  UCD7: '9284677',
  UCD13: '3400892846774',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL BCR 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3740111',
  CIP13: '3400937401111',
  ucdLib: "RAMIPRIL BCR 2,5MG CPR",
  UCD7: '9284677',
  UCD13: '3400892846774',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL BCR 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3726269',
  CIP13: '3400937262699',
  ucdLib: "RAMIPRIL BCR 5MG CPR",
  UCD7: '9284683',
  UCD13: '3400892846835',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL BCR 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3740128',
  CIP13: '3400937401289',
  ucdLib: "RAMIPRIL BCR 5MG CPR",
  UCD7: '9284683',
  UCD13: '3400892846835',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL BCR 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3725488',
  CIP13: '3400937254885',
  ucdLib: "RAMIPRIL BGA 10MG CPR",
  UCD7: '9284068',
  UCD13: '3400892840680',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL BGA 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3725376',
  CIP13: '3400937253765',
  ucdLib: "RAMIPRIL BGA 5MG CPR",
  UCD7: '9284080',
  UCD13: '3400892840802',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL BGA 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3726915',
  CIP13: '3400937269155',
  ucdLib: "RAMIPRIL EG 1,25MG CPR",
  UCD7: '9286133',
  UCD13: '3400892861333',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL EG 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3768322',
  CIP13: '3400937683227',
  ucdLib: "RAMIPRIL EG 1,25MG CPR",
  UCD7: '9286133',
  UCD13: '3400892861333',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL EG 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3727240',
  CIP13: '3400937272407',
  ucdLib: "RAMIPRIL EG 10MG CPR",
  UCD7: '9286156',
  UCD13: '3400892861562',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL EG 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3768405',
  CIP13: '3400937684057',
  ucdLib: "RAMIPRIL EG 10MG CPR",
  UCD7: '9286156',
  UCD13: '3400892861562',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL EG 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3727027',
  CIP13: '3400937270274',
  ucdLib: "RAMIPRIL EG 2,5MG CPR",
  UCD7: '9286162',
  UCD13: '3400892861623',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL EG 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3768339',
  CIP13: '3400937683395',
  ucdLib: "RAMIPRIL EG 2,5MG CPR",
  UCD7: '9286162',
  UCD13: '3400892861623',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL EG 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3727145',
  CIP13: '3400937271455',
  ucdLib: "RAMIPRIL EG 5MG CPR",
  UCD7: '9286179',
  UCD13: '3400892861791',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL EG 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3768345',
  CIP13: '3400937683456',
  ucdLib: "RAMIPRIL EG 5MG CPR",
  UCD7: '9286179',
  UCD13: '3400892861791',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL EG 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3740453',
  CIP13: '3400937404532',
  ucdLib: "RAMIPRIL TVS 10MG CPR",
  UCD7: '9285955',
  UCD13: '3400892859552',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVS 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3740298',
  CIP13: '3400937402989',
  ucdLib: "RAMIPRIL TVS 2,5MG CPR",
  UCD7: '9285961',
  UCD13: '3400892859613',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVS 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3740370',
  CIP13: '3400937403702',
  ucdLib: "RAMIPRIL TVS 5MG CPR",
  UCD7: '9285978',
  UCD13: '3400892859781',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVS 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3632953',
  CIP13: '3400936329539',
  ucdLib: "RAMIPRIL ZEN 10MG CPR",
  UCD7: '9276784',
  UCD13: '3400892767840',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ZEN 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3690838',
  CIP13: '3400936908383',
  ucdLib: "TRIATEC 1,25MG CPR",
  UCD7: '9261305',
  UCD13: '3400892613055',
  ucdQtyMultiplicator: 90,
  cipLib: "TRIATEC 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3690867',
  CIP13: '3400936908673',
  ucdLib: "TRIATEC 10MG CPR",
  UCD7: '9248457',
  UCD13: '3400892484570',
  ucdQtyMultiplicator: 90,
  cipLib: "TRIATEC 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3690844',
  CIP13: '3400936908444',
  ucdLib: "TRIATEC 2,5MG CPR",
  UCD7: '9261311',
  UCD13: '3400892613116',
  ucdQtyMultiplicator: 90,
  cipLib: "TRIATEC 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3690850',
  CIP13: '3400936908505',
  ucdLib: "TRIATEC 5MG CPR",
  UCD7: '9261328',
  UCD13: '3400892613284',
  ucdQtyMultiplicator: 90,
  cipLib: "TRIATEC 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3716348',
  CIP13: '3400937163484',
  ucdLib: "RAMIPRIL BGA 1,25MG CPR",
  UCD7: '9284051',
  UCD13: '3400892840512',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL BGA 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3780777',
  CIP13: '3400937807777',
  ucdLib: "RAMIPRIL BGA 10MG CPR",
  UCD7: '9284068',
  UCD13: '3400892840680',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL BGA 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3716466',
  CIP13: '3400937164665',
  ucdLib: "RAMIPRIL BGA 2,5MG CPR",
  UCD7: '9284074',
  UCD13: '3400892840741',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL BGA 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3716207',
  CIP13: '3400937162074',
  ucdLib: "RAMIPRIL TVC 1,25MG CPR",
  UCD7: '9283962',
  UCD13: '3400892839622',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVC 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3716035',
  CIP13: '3400937160353',
  ucdLib: "RAMIPRIL TVC 10MG CPR",
  UCD7: '9283979',
  UCD13: '3400892839790',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVC 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3787414',
  CIP13: '3400937874144',
  ucdLib: "RAMIPRIL TVC 10MG CPR",
  UCD7: '9283979',
  UCD13: '3400892839790',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL TVC 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3716093',
  CIP13: '3400937160933',
  ucdLib: "RAMIPRIL TVC 2,5MG CPR",
  UCD7: '9283985',
  UCD13: '3400892839851',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVC 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3716029',
  CIP13: '3400937160292',
  ucdLib: "RAMIPRIL TVC 5MG CPR",
  UCD7: '9283991',
  UCD13: '3400892839912',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVC 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3787408',
  CIP13: '3400937874083',
  ucdLib: "RAMIPRIL TVC 5MG CPR",
  UCD7: '9283991',
  UCD13: '3400892839912',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL TVC 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3785591',
  CIP13: '3400937855914',
  ucdLib: "RAMIPRIL TVS 1,25MG CPR",
  UCD7: '9285949',
  UCD13: '3400892859491',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL TVS 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3785639',
  CIP13: '3400937856393',
  ucdLib: "RAMIPRIL TVS 10MG CPR",
  UCD7: '9285955',
  UCD13: '3400892859552',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL TVS 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3785616',
  CIP13: '3400937856164',
  ucdLib: "RAMIPRIL TVS 2,5MG CPR",
  UCD7: '9285961',
  UCD13: '3400892859613',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL TVS 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3785622',
  CIP13: '3400937856225',
  ucdLib: "RAMIPRIL TVS 5MG CPR",
  UCD7: '9285978',
  UCD13: '3400892859781',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL TVS 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3712385',
  CIP13: '3400937123853',
  ucdLib: "RAMIPRIL ZEN 10MG CPR",
  UCD7: '9276784',
  UCD13: '3400892767840',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ZEN 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3712362',
  CIP13: '3400937123624',
  ucdLib: "RAMIPRIL ZEN 2,5MG CPR",
  UCD7: '9274549',
  UCD13: '3400892745497',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ZEN 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3712379',
  CIP13: '3400937123792',
  ucdLib: "RAMIPRIL ZEN 5MG CPR",
  UCD7: '9274555',
  UCD13: '3400892745558',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ZEN 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3643974',
  CIP13: '3400936439740',
  ucdLib: "TRIATEC 1,25MG CPR",
  UCD7: '9261305',
  UCD13: '3400892613055',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIATEC 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3644011',
  CIP13: '3400936440111',
  ucdLib: "TRIATEC 2,5MG CPR",
  UCD7: '9261311',
  UCD13: '3400892613116',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIATEC 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3644057',
  CIP13: '3400936440579',
  ucdLib: "TRIATEC 5MG CPR",
  UCD7: '9261328',
  UCD13: '3400892613284',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIATEC 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3733298',
  CIP13: '3400937332989',
  ucdLib: "RAMIPRIL ALM 1,25MG CPR",
  UCD7: '9286914',
  UCD13: '3400892869148',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ALM 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3733565',
  CIP13: '3400937335652',
  ucdLib: "RAMIPRIL ALM 10MG CPR",
  UCD7: '9287003',
  UCD13: '3400892870038',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ALM 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3925833',
  CIP13: '3400939258331',
  ucdLib: "RAMIPRIL ALM 10MG CPR",
  UCD7: '9287003',
  UCD13: '3400892870038',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ALM 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3733660',
  CIP13: '3400937336604',
  ucdLib: "RAMIPRIL ALM 2,5MG CPR",
  UCD7: '9286920',
  UCD13: '3400892869209',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ALM 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3867596',
  CIP13: '3400938675962',
  ucdLib: "RAMIPRIL ALM 2,5MG CPR",
  UCD7: '9286920',
  UCD13: '3400892869209',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ALM 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3733447',
  CIP13: '3400937334471',
  ucdLib: "RAMIPRIL ALM 5MG CPR",
  UCD7: '9287026',
  UCD13: '3400892870267',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ALM 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3867610',
  CIP13: '3400938676105',
  ucdLib: "RAMIPRIL ALM 5MG CPR",
  UCD7: '9287026',
  UCD13: '3400892870267',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ALM 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3733720',
  CIP13: '3400937337205',
  ucdLib: "RAMIPRIL ARL 1,25MG CPR",
  UCD7: '9286802',
  UCD13: '3400892868028',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ARL 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3862788',
  CIP13: '3400938627886',
  ucdLib: "RAMIPRIL ARL 1,25MG CPR",
  UCD7: '9286802',
  UCD13: '3400892868028',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ARL 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3734062',
  CIP13: '3400937340625',
  ucdLib: "RAMIPRIL ARL 10MG CPR",
  UCD7: '9286966',
  UCD13: '3400892869667',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ARL 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3734079',
  CIP13: '3400937340793',
  ucdLib: "RAMIPRIL ARL 10MG CPR",
  UCD7: '9286966',
  UCD13: '3400892869667',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ARL 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3863032',
  CIP13: '3400938630329',
  ucdLib: "RAMIPRIL ARL 10MG CPR",
  UCD7: '9286966',
  UCD13: '3400892869667',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ARL 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3733849',
  CIP13: '3400937338493',
  ucdLib: "RAMIPRIL ARL 2,5MG CPR",
  UCD7: '9286819',
  UCD13: '3400892868196',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ARL 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3733855',
  CIP13: '3400937338554',
  ucdLib: "RAMIPRIL ARL 2,5MG CPR",
  UCD7: '9286819',
  UCD13: '3400892868196',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ARL 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3862794',
  CIP13: '3400938627947',
  ucdLib: "RAMIPRIL ARL 2,5MG CPR",
  UCD7: '9286819',
  UCD13: '3400892868196',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ARL 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3733944',
  CIP13: '3400937339445',
  ucdLib: "RAMIPRIL ARL 5MG CPR",
  UCD7: '9286972',
  UCD13: '3400892869728',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ARL 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3733950',
  CIP13: '3400937339506',
  ucdLib: "RAMIPRIL ARL 5MG CPR",
  UCD7: '9286972',
  UCD13: '3400892869728',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ARL 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3863026',
  CIP13: '3400938630268',
  ucdLib: "RAMIPRIL ARL 5MG CPR",
  UCD7: '9286972',
  UCD13: '3400892869728',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ARL 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3739958',
  CIP13: '3400937399586',
  ucdLib: "RAMIPRIL BGA 2,5MG CPR",
  UCD7: '9284074',
  UCD13: '3400892840741',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL BGA 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3739970',
  CIP13: '3400937399708',
  ucdLib: "RAMIPRIL BGA 5MG CPR",
  UCD7: '9284080',
  UCD13: '3400892840802',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL BGA 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3888397',
  CIP13: '3400938883978',
  ucdLib: "RAMIPRIL EVO 1,25MG CPR",
  UCD7: '9330667',
  UCD13: '3400893306673',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL EVO 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3888227',
  CIP13: '3400938882278',
  ucdLib: "RAMIPRIL EVO 10MG CPR",
  UCD7: '9327889',
  UCD13: '3400893278895',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL EVO 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3888256',
  CIP13: '3400938882568',
  ucdLib: "RAMIPRIL EVO 10MG CPR",
  UCD7: '9327889',
  UCD13: '3400893278895',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL EVO 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3888575',
  CIP13: '3400938885750',
  ucdLib: "RAMIPRIL EVO 2,5MG CPR",
  UCD7: '9330673',
  UCD13: '3400893306734',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL EVO 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3888598',
  CIP13: '3400938885989',
  ucdLib: "RAMIPRIL EVO 2,5MG CPR",
  UCD7: '9330673',
  UCD13: '3400893306734',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL EVO 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3888730',
  CIP13: '3400938887303',
  ucdLib: "RAMIPRIL EVO 5MG CPR",
  UCD7: '9327895',
  UCD13: '3400893278956',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL EVO 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3888753',
  CIP13: '3400938887532',
  ucdLib: "RAMIPRIL EVO 5MG CPR",
  UCD7: '9327895',
  UCD13: '3400893278956',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL EVO 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3922220',
  CIP13: '3400939222202',
  ucdLib: "RAMIPRIL ISD 1,25MG CPR",
  UCD7: '9331750',
  UCD13: '3400893317501',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ISD 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3730058',
  CIP13: '3400937300582',
  ucdLib: "RAMIPRIL MYL 1,25MG CPR",
  UCD7: '9279682',
  UCD13: '3400892796826',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL MYL 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3730064',
  CIP13: '3400937300643',
  ucdLib: "RAMIPRIL MYL 10MG CPR",
  UCD7: '9279699',
  UCD13: '3400892796994',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL MYL 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3730070',
  CIP13: '3400937300704',
  ucdLib: "RAMIPRIL MYL 2,5MG CPR",
  UCD7: '9279707',
  UCD13: '3400892797076',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL MYL 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3730087',
  CIP13: '3400937300872',
  ucdLib: "RAMIPRIL MYL 5MG CPR",
  UCD7: '9279713',
  UCD13: '3400892797137',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL MYL 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3731069',
  CIP13: '3400937310697',
  ucdLib: "RAMIPRIL SDZ 1,25MG CPR",
  UCD7: '9280260',
  UCD13: '3400892802602',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL SDZ 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3731098',
  CIP13: '3400937310987',
  ucdLib: "RAMIPRIL SDZ 10MG CPR",
  UCD7: '9280277',
  UCD13: '3400892802770',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL SDZ 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3731075',
  CIP13: '3400937310758',
  ucdLib: "RAMIPRIL SDZ 2,5MG CPR",
  UCD7: '9280283',
  UCD13: '3400892802831',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL SDZ 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3731081',
  CIP13: '3400937310819',
  ucdLib: "RAMIPRIL SDZ 5MG CPR",
  UCD7: '9280308',
  UCD13: '3400892803081',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL SDZ 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3735802',
  CIP13: '3400937358026',
  ucdLib: "RAMIPRIL TVS 1,25MG CPR",
  UCD7: '9285949',
  UCD13: '3400892859491',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL TVS 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3873160',
  CIP13: '3400938731606',
  ucdLib: "RAMIPRIL ZYF 10MG CPR",
  UCD7: '9325531',
  UCD13: '3400893255315',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ZYF 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3873177',
  CIP13: '3400938731774',
  ucdLib: "RAMIPRIL ZYF 10MG CPR",
  UCD7: '9325531',
  UCD13: '3400893255315',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ZYF 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3957537',
  CIP13: '3400939575377',
  ucdLib: "RAMIPRIL CRT 1,25MG CPR",
  UCD7: '9339243',
  UCD13: '3400893392430',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL CRT 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3957566',
  CIP13: '3400939575667',
  ucdLib: "RAMIPRIL CRT 1,25MG CPR",
  UCD7: '9339243',
  UCD13: '3400893392430',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL CRT 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3957804',
  CIP13: '3400939578040',
  ucdLib: "RAMIPRIL CRT 10MG CPR",
  UCD7: '9340921',
  UCD13: '3400893409213',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL CRT 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3958502',
  CIP13: '3400939585024',
  ucdLib: "RAMIPRIL CRT 10MG CPR",
  UCD7: '9340921',
  UCD13: '3400893409213',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL CRT 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3957632',
  CIP13: '3400939576329',
  ucdLib: "RAMIPRIL CRT 2,5MG CPR",
  UCD7: '9340938',
  UCD13: '3400893409381',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL CRT 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3957655',
  CIP13: '3400939576558',
  ucdLib: "RAMIPRIL CRT 2,5MG CPR",
  UCD7: '9340938',
  UCD13: '3400893409381',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL CRT 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3957715',
  CIP13: '3400939577159',
  ucdLib: "RAMIPRIL CRT 5MG CPR",
  UCD7: '9339266',
  UCD13: '3400893392669',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL CRT 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3958525',
  CIP13: '3400939585253',
  ucdLib: "RAMIPRIL CRT 5MG CPR",
  UCD7: '9339266',
  UCD13: '3400893392669',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL CRT 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3904535',
  CIP13: '3400939045351',
  ucdLib: "RAMIPRIL ISD 10MG CPR",
  UCD7: '9328972',
  UCD13: '3400893289723',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ISD 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3903381',
  CIP13: '3400939033815',
  ucdLib: "RAMIPRIL ISD 2,5MG CPR",
  UCD7: '9328989',
  UCD13: '3400893289891',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ISD 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3904334',
  CIP13: '3400939043340',
  ucdLib: "RAMIPRIL ISD 5MG CPR",
  UCD7: '9328995',
  UCD13: '3400893289952',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ISD 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3904357',
  CIP13: '3400939043579',
  ucdLib: "RAMIPRIL ISD 5MG CPR",
  UCD7: '9328995',
  UCD13: '3400893289952',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ISD 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3905664',
  CIP13: '3400939056647',
  ucdLib: "RAMIPRIL ZYF 1,25MG CPR",
  UCD7: '9330696',
  UCD13: '3400893306963',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ZYF 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3905836',
  CIP13: '3400939058368',
  ucdLib: "RAMIPRIL ZYF 2,5MG CPR",
  UCD7: '9329670',
  UCD13: '3400893296707',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ZYF 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3905859',
  CIP13: '3400939058597',
  ucdLib: "RAMIPRIL ZYF 2,5MG CPR",
  UCD7: '9329670',
  UCD13: '3400893296707',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ZYF 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '3902884',
  CIP13: '3400939028842',
  ucdLib: "RAMIPRIL ZYF 5MG CPR",
  UCD7: '9329687',
  UCD13: '3400893296875',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL ZYF 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '3903004',
  CIP13: '3400939030043',
  ucdLib: "RAMIPRIL ZYF 5MG CPR",
  UCD7: '9329687',
  UCD13: '3400893296875',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL ZYF 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '2740327',
  CIP13: '3400927403279',
  ucdLib: "RAMIPRIL KRK 1,25MG CPR",
  UCD7: '9396123',
  UCD13: '3400893961230',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL KRK 1,25MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2740362',
  CIP13: '3400927403620',
  ucdLib: "RAMIPRIL KRK 1,25MG CPR",
  UCD7: '9396123',
  UCD13: '3400893961230',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL KRK 1,25MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '2740592',
  CIP13: '3400927405921',
  ucdLib: "RAMIPRIL KRK 10MG CPR",
  UCD7: '9396146',
  UCD13: '3400893961469',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL KRK 10MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2740623',
  CIP13: '3400927406232',
  ucdLib: "RAMIPRIL KRK 10MG CPR",
  UCD7: '9396146',
  UCD13: '3400893961469',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL KRK 10MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '2740422',
  CIP13: '3400927404221',
  ucdLib: "RAMIPRIL KRK 2,5MG CPR",
  UCD7: '9396152',
  UCD13: '3400893961520',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL KRK 2,5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2740451',
  CIP13: '3400927404511',
  ucdLib: "RAMIPRIL KRK 2,5MG CPR",
  UCD7: '9396152',
  UCD13: '3400893961520',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL KRK 2,5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '2740505',
  CIP13: '3400927405051',
  ucdLib: "RAMIPRIL KRK 5MG CPR",
  UCD7: '9396169',
  UCD13: '3400893961698',
  ucdQtyMultiplicator: 30,
  cipLib: "RAMIPRIL KRK 5MG CPR BT 30",
  atcCode: "C09AA05"
}, {
  CIP7: '2740534',
  CIP13: '3400927405341',
  ucdLib: "RAMIPRIL KRK 5MG CPR",
  UCD7: '9396169',
  UCD13: '3400893961698',
  ucdQtyMultiplicator: 90,
  cipLib: "RAMIPRIL KRK 5MG CPR BT 90",
  atcCode: "C09AA05"
}, {
  CIP7: '5656892',
  CIP13: '3400956568925',
  ucdLib: "TRIATEC 1,25MG CPR",
  UCD7: '9261305',
  UCD13: '3400892613055',
  ucdQtyMultiplicator: 100,
  cipLib: "TRIATEC 1,25MG CPR BT 100",
  atcCode: "C09AA05"
}, {
  CIP7: '5656900',
  CIP13: '3400956569007',
  ucdLib: "TRIATEC 2,5MG CPR",
  UCD7: '9261311',
  UCD13: '3400892613116',
  ucdQtyMultiplicator: 100,
  cipLib: "TRIATEC 2,5MG CPR BT 100",
  atcCode: "C09AA05"
}, {
  CIP7: '5656917',
  CIP13: '3400956569175',
  ucdLib: "TRIATEC 5MG CPR",
  UCD7: '9261328',
  UCD13: '3400892613284',
  ucdQtyMultiplicator: 100,
  cipLib: "TRIATEC 5MG CPR BT 100",
  atcCode: "C09AA05"
}, {
  CIP7: '3110918',
  CIP13: '3400931109181',
  ucdLib: "PERINDOPRIL ZEN 2MG CPR",
  UCD7: '9348354',
  UCD13: '3400893483541',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ZEN 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3110976',
  CIP13: '3400931109761',
  ucdLib: "PERINDOPRIL ZEN 4MG CPR",
  UCD7: '9348360',
  UCD13: '3400893483602',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ZEN 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3111013',
  CIP13: '3400931110132',
  ucdLib: "PERINDOPRIL ZEN 8MG CPR",
  UCD7: '9348377',
  UCD13: '3400893483770',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ZEN 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3310557',
  CIP13: '3400933105570',
  ucdLib: "PERINDOPRIL BGA 2MG CPR",
  UCD7: '9132803',
  UCD13: '3400891328035',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL BGA 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3310586',
  CIP13: '3400933105860',
  ucdLib: "PERINDOPRIL BGA 2MG CPR",
  UCD7: '9132803',
  UCD13: '3400891328035',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL BGA 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3310646',
  CIP13: '3400933106461',
  ucdLib: "PERINDOPRIL BGA 4MG CPR",
  UCD7: '9132826',
  UCD13: '3400891328264',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL BGA 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3310669',
  CIP13: '3400933106690',
  ucdLib: "PERINDOPRIL BGA 4MG CPR",
  UCD7: '9132826',
  UCD13: '3400891328264',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL BGA 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3310480',
  CIP13: '3400933104801',
  ucdLib: "PERINDOPRIL MYL 2MG CPR",
  UCD7: '9132298',
  UCD13: '3400891322989',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL MYL 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3310505',
  CIP13: '3400933105051',
  ucdLib: "PERINDOPRIL MYL 2MG CPR",
  UCD7: '9132298',
  UCD13: '3400891322989',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL MYL 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3310416',
  CIP13: '3400933104160',
  ucdLib: "PERINDOPRIL MYL 4MG CPR",
  UCD7: '9132306',
  UCD13: '3400891323061',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL MYL 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3310439',
  CIP13: '3400933104399',
  ucdLib: "PERINDOPRIL MYL 4MG CPR",
  UCD7: '9132306',
  UCD13: '3400891323061',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL MYL 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4989143',
  CIP13: '3400949891436',
  ucdLib: "PERINDOPRIL PHR 8MG CPR",
  UCD7: '9365559',
  UCD13: '3400893655597',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL PHR 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3629313',
  CIP13: '3400936293137',
  ucdLib: "PERINDOPRIL BGA 8MG CPR",
  UCD7: '9309673',
  UCD13: '3400893096734',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL BGA 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3629342',
  CIP13: '3400936293427',
  ucdLib: "PERINDOPRIL BGA 8MG CPR",
  UCD7: '9309673',
  UCD13: '3400893096734',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL BGA 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3629224',
  CIP13: '3400936292246',
  ucdLib: "PERINDOPRIL MYL 8MG CPR",
  UCD7: '9345373',
  UCD13: '3400893453735',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL MYL 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3629247',
  CIP13: '3400936292475',
  ucdLib: "PERINDOPRIL MYL 8MG CPR",
  UCD7: '9345373',
  UCD13: '3400893453735',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL MYL 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3468991',
  CIP13: '3400934689918',
  ucdLib: "PERINDOPRIL ZEN 2MG CPR",
  UCD7: '9348354',
  UCD13: '3400893483541',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ZEN 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3469068',
  CIP13: '3400934690686',
  ucdLib: "PERINDOPRIL ZEN 4MG CPR",
  UCD7: '9348360',
  UCD13: '3400893483602',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ZEN 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3468904',
  CIP13: '3400934689048',
  ucdLib: "PERINDOPRIL ZEN 8MG CPR",
  UCD7: '9348377',
  UCD13: '3400893483770',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ZEN 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3666030',
  CIP13: '3400936660304',
  ucdLib: "COVERSYL 10MG CPR",
  UCD7: '9314214',
  UCD13: '3400893142141',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 10MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3666076',
  CIP13: '3400936660762',
  ucdLib: "COVERSYL 10MG CPR",
  UCD7: '9314214',
  UCD13: '3400893142141',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERSYL 10MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3665875',
  CIP13: '3400936658752',
  ucdLib: "COVERSYL 2,5MG CPR",
  UCD7: '9314220',
  UCD13: '3400893142202',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 2,5MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3665906',
  CIP13: '3400936659063',
  ucdLib: "COVERSYL 2,5MG CPR",
  UCD7: '9314220',
  UCD13: '3400893142202',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERSYL 2,5MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3665958',
  CIP13: '3400936659582',
  ucdLib: "COVERSYL 5MG CPR",
  UCD7: '9314237',
  UCD13: '3400893142370',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 5MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3665987',
  CIP13: '3400936659872',
  ucdLib: "COVERSYL 5MG CPR",
  UCD7: '9314237',
  UCD13: '3400893142370',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERSYL 5MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3666136',
  CIP13: '3400936661363',
  ucdLib: "PERINDOPRIL ARGI.SRV 2,5MG C",
  UCD7: '9369238',
  UCD13: '3400893692387',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARGI.SRV 2,5MG C BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3666219',
  CIP13: '3400936662193',
  ucdLib: "PERINDOPRIL ARGI.SRV 5MG CPR",
  UCD7: '9369244',
  UCD13: '3400893692448',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARGI.SRV 5MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3765275',
  CIP13: '3400937652759',
  ucdLib: "PERINDOPRIL RTP 2MG CPR",
  UCD7: '9296901',
  UCD13: '3400892969015',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL RTP 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3765358',
  CIP13: '3400937653589',
  ucdLib: "PERINDOPRIL RTP 4MG CPR",
  UCD7: '9296918',
  UCD13: '3400892969183',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL RTP 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3764519',
  CIP13: '3400937645195',
  ucdLib: "PERINDOPRIL TVS 2MG CPR",
  UCD7: '9296947',
  UCD13: '3400892969473',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL TVS 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3764548',
  CIP13: '3400937645485',
  ucdLib: "PERINDOPRIL TVS 2MG CPR",
  UCD7: '9296947',
  UCD13: '3400892969473',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL TVS 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3764608',
  CIP13: '3400937646086',
  ucdLib: "PERINDOPRIL TVS 4MG CPR",
  UCD7: '9296953',
  UCD13: '3400892969534',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL TVS 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3764637',
  CIP13: '3400937646376',
  ucdLib: "PERINDOPRIL TVS 4MG CPR",
  UCD7: '9296953',
  UCD13: '3400892969534',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL TVS 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3861949',
  CIP13: '3400938619492',
  ucdLib: "PERINDOPRIL ARW 2MG CPR",
  UCD7: '9319186',
  UCD13: '3400893191866',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARW 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3861984',
  CIP13: '3400938619843',
  ucdLib: "PERINDOPRIL ARW 2MG CPR",
  UCD7: '9319186',
  UCD13: '3400893191866',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ARW 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3862280',
  CIP13: '3400938622805',
  ucdLib: "PERINDOPRIL ARW 4MG CPR",
  UCD7: '9320427',
  UCD13: '3400893204276',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARW 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3862328',
  CIP13: '3400938623284',
  ucdLib: "PERINDOPRIL ARW 4MG CPR",
  UCD7: '9320427',
  UCD13: '3400893204276',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ARW 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3862601',
  CIP13: '3400938626018',
  ucdLib: "PERINDOPRIL ARW 8MG CPR",
  UCD7: '9320433',
  UCD13: '3400893204337',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARW 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3862647',
  CIP13: '3400938626476',
  ucdLib: "PERINDOPRIL ARW 8MG CPR",
  UCD7: '9320433',
  UCD13: '3400893204337',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ARW 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3886955',
  CIP13: '3400938869552',
  ucdLib: "PERINDOPRIL RTP 8MG CPR",
  UCD7: '9325519',
  UCD13: '3400893255193',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL RTP 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3886984',
  CIP13: '3400938869842',
  ucdLib: "PERINDOPRIL RTP 8MG CPR",
  UCD7: '9325519',
  UCD13: '3400893255193',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL RTP 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3886872',
  CIP13: '3400938868722',
  ucdLib: "PERINDOPRIL TVS 8MG CPR",
  UCD7: '9325525',
  UCD13: '3400893255254',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL TVS 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3886903',
  CIP13: '3400938869033',
  ucdLib: "PERINDOPRIL TVS 8MG CPR",
  UCD7: '9325525',
  UCD13: '3400893255254',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL TVS 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3953350',
  CIP13: '3400939533506',
  ucdLib: "PERINDOPRIL ACT 4MG CPR",
  UCD7: '9326803',
  UCD13: '3400893268032',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ACT 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3894618',
  CIP13: '3400938946185',
  ucdLib: "PERINDOPRIL ACT 8MG CPR",
  UCD7: '9326826',
  UCD13: '3400893268261',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ACT 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3890891',
  CIP13: '3400938908916',
  ucdLib: "PERINDOPRIL EG 2MG CPR",
  UCD7: '9296887',
  UCD13: '3400892968872',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL EG 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3890951',
  CIP13: '3400938909517',
  ucdLib: "PERINDOPRIL EG 2MG CPR",
  UCD7: '9296887',
  UCD13: '3400892968872',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL EG 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3891057',
  CIP13: '3400938910575',
  ucdLib: "PERINDOPRIL EG 4MG CPR",
  UCD7: '9296893',
  UCD13: '3400892968933',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL EG 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3891117',
  CIP13: '3400938911176',
  ucdLib: "PERINDOPRIL EG 4MG CPR",
  UCD7: '9296893',
  UCD13: '3400892968933',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL EG 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4977849',
  CIP13: '3400949778492',
  ucdLib: "PERINDOPRIL ISD 2MG CPR",
  UCD7: '9364910',
  UCD13: '3400893649107',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ISD 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4977878',
  CIP13: '3400949778782',
  ucdLib: "PERINDOPRIL ISD 2MG CPR",
  UCD7: '9364910',
  UCD13: '3400893649107',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ISD 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4977921',
  CIP13: '3400949779215',
  ucdLib: "PERINDOPRIL ISD 4MG CPR",
  UCD7: '9364927',
  UCD13: '3400893649275',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ISD 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4977950',
  CIP13: '3400949779505',
  ucdLib: "PERINDOPRIL ISD 4MG CPR",
  UCD7: '9364927',
  UCD13: '3400893649275',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ISD 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4978010',
  CIP13: '3400949780105',
  ucdLib: "PERINDOPRIL ISD 8MG CPR",
  UCD7: '9364933',
  UCD13: '3400893649336',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ISD 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4978056',
  CIP13: '3400949780563',
  ucdLib: "PERINDOPRIL ISD 8MG CPR",
  UCD7: '9364933',
  UCD13: '3400893649336',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ISD 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3503859',
  CIP13: '3400935038593',
  ucdLib: "PERINDOPRIL KRK 2MG CPR",
  UCD7: '9359636',
  UCD13: '3400893596364',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL KRK 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3503894',
  CIP13: '3400935038944',
  ucdLib: "PERINDOPRIL KRK 2MG CPR",
  UCD7: '9359636',
  UCD13: '3400893596364',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL KRK 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3504178',
  CIP13: '3400935041784',
  ucdLib: "PERINDOPRIL KRK 4MG CPR",
  UCD7: '9359642',
  UCD13: '3400893596425',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL KRK 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3504221',
  CIP13: '3400935042217',
  ucdLib: "PERINDOPRIL KRK 4MG CPR",
  UCD7: '9359642',
  UCD13: '3400893596425',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL KRK 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3504511',
  CIP13: '3400935045119',
  ucdLib: "PERINDOPRIL KRK 8MG CPR",
  UCD7: '9359659',
  UCD13: '3400893596593',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL KRK 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3504563',
  CIP13: '3400935045638',
  ucdLib: "PERINDOPRIL KRK 8MG CPR",
  UCD7: '9359659',
  UCD13: '3400893596593',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL KRK 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3939918',
  CIP13: '3400939399188',
  ucdLib: "PERINDOPRIL RBX 2MG CPR",
  UCD7: '9334671',
  UCD13: '3400893346716',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL RBX 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3939930',
  CIP13: '3400939399300',
  ucdLib: "PERINDOPRIL RBX 2MG CPR",
  UCD7: '9334671',
  UCD13: '3400893346716',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL RBX 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3939462',
  CIP13: '3400939394626',
  ucdLib: "PERINDOPRIL RBX 4MG CPR",
  UCD7: '9334688',
  UCD13: '3400893346884',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL RBX 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3939485',
  CIP13: '3400939394855',
  ucdLib: "PERINDOPRIL RBX 4MG CPR",
  UCD7: '9334688',
  UCD13: '3400893346884',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL RBX 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3848185',
  CIP13: '3400938481853',
  ucdLib: "PERINDOPRIL SDZ 2MG CPR",
  UCD7: '9316816',
  UCD13: '3400893168165',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL SDZ 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3848239',
  CIP13: '3400938482393',
  ucdLib: "PERINDOPRIL SDZ 2MG CPR",
  UCD7: '9316816',
  UCD13: '3400893168165',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL SDZ 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3848506',
  CIP13: '3400938485066',
  ucdLib: "PERINDOPRIL SDZ 4MG CPR",
  UCD7: '9316822',
  UCD13: '3400893168226',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL SDZ 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3848541',
  CIP13: '3400938485417',
  ucdLib: "PERINDOPRIL SDZ 4MG CPR",
  UCD7: '9316822',
  UCD13: '3400893168226',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL SDZ 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3895049',
  CIP13: '3400938950496',
  ucdLib: "PERINDOPRIL ZYD 2MG CPR",
  UCD7: '9326832',
  UCD13: '3400893268322',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ZYD 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3895115',
  CIP13: '3400938951158',
  ucdLib: "PERINDOPRIL ZYD 4MG CPR",
  UCD7: '9326849',
  UCD13: '3400893268490',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ZYD 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3895173',
  CIP13: '3400938951738',
  ucdLib: "PERINDOPRIL ZYD 8MG CPR",
  UCD7: '9326855',
  UCD13: '3400893268551',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ZYD 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4900870',
  CIP13: '3400949008704',
  ucdLib: "COVERSYL 10MG CPR AIP MWI IT",
  UCD7: '9378177',
  UCD13: '3400893781777',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 10MG CPR AIP MWI IT BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4900887',
  CIP13: '3400949008872',
  ucdLib: "COVERSYL 10MG CPR AIP MWI IT",
  UCD7: '9378177',
  UCD13: '3400893781777',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERSYL 10MG CPR AIP MWI IT BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4900456',
  CIP13: '3400949004560',
  ucdLib: "COVERSYL 10MG CPR AIP PLA UK",
  UCD7: '9341820',
  UCD13: '3400893418208',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 10MG CPR AIP PLA UK BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4900746',
  CIP13: '3400949007462',
  ucdLib: "COVERSYL 10MG CPR AIP PLA UK",
  UCD7: '9341820',
  UCD13: '3400893418208',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERSYL 10MG CPR AIP PLA UK BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4901674',
  CIP13: '3400949016747',
  ucdLib: "COVERSYL 5MG CPR AIP BBA CZ",
  UCD7: '9394348',
  UCD13: '3400893943489',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 5MG CPR AIP BBA CZ BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4901680',
  CIP13: '3400949016808',
  ucdLib: "COVERSYL 5MG CPR AIP BBA CZ",
  UCD7: '9394348',
  UCD13: '3400893943489',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERSYL 5MG CPR AIP BBA CZ BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4900001',
  CIP13: '3400949000012',
  ucdLib: "COVERSYL 5MG CPR AIP MWI CZ",
  UCD7: '9409825',
  UCD13: '3400894098256',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 5MG CPR AIP MWI CZ BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4900003',
  CIP13: '3400949000036',
  ucdLib: "COVERSYL 5MG CPR AIP MWI CZ",
  UCD7: '9409825',
  UCD13: '3400894098256',
  ucdQtyMultiplicator: 90,
  cipLib: "COVERSYL 5MG CPR AIP MWI CZ BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4901941',
  CIP13: '3400949019410',
  ucdLib: "COVERSYL 5MG CPR AIP MWI PL",
  UCD7: '9397648',
  UCD13: '3400893976487',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 5MG CPR AIP MWI PL BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4900522',
  CIP13: '3400949005222',
  ucdLib: "COVERSYL 5MG CPR AIP PLA PL",
  UCD7: '9352924',
  UCD13: '3400893529249',
  ucdQtyMultiplicator: 30,
  cipLib: "COVERSYL 5MG CPR AIP PLA PL BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4940355',
  CIP13: '3400949403554',
  ucdLib: "PERINDOPRIL PHR 2MG CPR",
  UCD7: '9361981',
  UCD13: '3400893619810',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL PHR 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4940415',
  CIP13: '3400949404155',
  ucdLib: "PERINDOPRIL PHR 4MG CPR",
  UCD7: '9361998',
  UCD13: '3400893619988',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL PHR 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4940438',
  CIP13: '3400949404384',
  ucdLib: "PERINDOPRIL PHR 4MG CPR",
  UCD7: '9361998',
  UCD13: '3400893619988',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL PHR 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3940169',
  CIP13: '3400939401690',
  ucdLib: "PERINDOPRIL RBX 8MG CPR",
  UCD7: '9334694',
  UCD13: '3400893346945',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL RBX 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3940181',
  CIP13: '3400939401812',
  ucdLib: "PERINDOPRIL RBX 8MG CPR",
  UCD7: '9334694',
  UCD13: '3400893346945',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL RBX 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3946456',
  CIP13: '3400939464565',
  ucdLib: "PERINDOPRIL SDZ 8MG CPR",
  UCD7: '9334808',
  UCD13: '3400893348086',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL SDZ 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '3946491',
  CIP13: '3400939464916',
  ucdLib: "PERINDOPRIL SDZ 8MG CPR",
  UCD7: '9334808',
  UCD13: '3400893348086',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL SDZ 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4991192',
  CIP13: '3400949911929',
  ucdLib: "PERINDOPRIL ZYD 2MG CPR",
  UCD7: '9326832',
  UCD13: '3400893268322',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ZYD 2MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4991200',
  CIP13: '3400949912001',
  ucdLib: "PERINDOPRIL ZYD 4MG CPR",
  UCD7: '9326849',
  UCD13: '3400893268490',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ZYD 4MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '4991217',
  CIP13: '3400949912179',
  ucdLib: "PERINDOPRIL ZYD 8MG CPR",
  UCD7: '9326855',
  UCD13: '3400893268551',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ZYD 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '2784129',
  CIP13: '3400927841293',
  ucdLib: "PERINDOPRIL ARGI.BGA 10MG CP",
  UCD7: '9401953',
  UCD13: '3400894019534',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARGI.BGA 10MG CP BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2784158',
  CIP13: '3400927841583',
  ucdLib: "PERINDOPRIL ARGI.BGA 10MG CP",
  UCD7: '9401953',
  UCD13: '3400894019534',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ARGI.BGA 10MG CP BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '2783940',
  CIP13: '3400927839405',
  ucdLib: "PERINDOPRIL ARGI.BGA 2,5MG C",
  UCD7: '9401976',
  UCD13: '3400894019763',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARGI.BGA 2,5MG C BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2783986',
  CIP13: '3400927839863',
  ucdLib: "PERINDOPRIL ARGI.BGA 2,5MG C",
  UCD7: '9401976',
  UCD13: '3400894019763',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ARGI.BGA 2,5MG C BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '2784046',
  CIP13: '3400927840463',
  ucdLib: "PERINDOPRIL ARGI.BGA 5MG CPR",
  UCD7: '9401982',
  UCD13: '3400894019824',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARGI.BGA 5MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2784075',
  CIP13: '3400927840753',
  ucdLib: "PERINDOPRIL ARGI.BGA 5MG CPR",
  UCD7: '9401982',
  UCD13: '3400894019824',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL ARGI.BGA 5MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '2671247',
  CIP13: '3400926712471',
  ucdLib: "PERINDOPRIL ARL 2MG CPR SS",
  UCD7: '9417836',
  UCD13: '3400894178361',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARL 2MG CPR SS BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2671342',
  CIP13: '3400926713423',
  ucdLib: "PERINDOPRIL ARL 4MG CPR SS",
  UCD7: '9417842',
  UCD13: '3400894178422',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARL 4MG CPR SS BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2671425',
  CIP13: '3400926714253',
  ucdLib: "PERINDOPRIL ARL 8MG CPR SS",
  UCD7: '9417859',
  UCD13: '3400894178590',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL ARL 8MG CPR SS BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4922185',
  CIP13: '3400949221851',
  ucdLib: "PERINDOPRIL EG 8MG CPR",
  UCD7: '9356431',
  UCD13: '3400893564318',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL EG 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '4922216',
  CIP13: '3400949222162',
  ucdLib: "PERINDOPRIL EG 8MG CPR",
  UCD7: '9356431',
  UCD13: '3400893564318',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL EG 8MG CPR BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '2168927',
  CIP13: '3400921689273',
  ucdLib: "PERINDOPRIL EVO 2MG CPR",
  UCD7: '9385349',
  UCD13: '3400893853498',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL EVO 2MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2169068',
  CIP13: '3400921690682',
  ucdLib: "PERINDOPRIL EVO 4MG CPR",
  UCD7: '9385355',
  UCD13: '3400893853559',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL EVO 4MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2169401',
  CIP13: '3400921694017',
  ucdLib: "PERINDOPRIL EVO 8MG CPR",
  UCD7: '9385361',
  UCD13: '3400893853610',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL EVO 8MG CPR BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2794381',
  CIP13: '3400927943812',
  ucdLib: "PERINDOPRIL TOSI.TVC 10MG CP",
  UCD7: '9404294',
  UCD13: '3400894042945',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL TOSI.TVC 10MG CP BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2794412',
  CIP13: '3400927944123',
  ucdLib: "PERINDOPRIL TOSI.TVC 10MG CP",
  UCD7: '9404294',
  UCD13: '3400894042945',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL TOSI.TVC 10MG CP BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '2794292',
  CIP13: '3400927942921',
  ucdLib: "PERINDOPRIL TOSI.TVC 2,5MG C",
  UCD7: '9404302',
  UCD13: '3400894043027',
  ucdQtyMultiplicator: 30,
  cipLib: "PERINDOPRIL TOSI.TVC 2,5MG C BT 30",
  atcCode: "C09AA04"
}, {
  CIP7: '2794323',
  CIP13: '3400927943232',
  ucdLib: "PERINDOPRIL TOSI.TVC 2,5MG C",
  UCD7: '9404302',
  UCD13: '3400894043027',
  ucdQtyMultiplicator: 90,
  cipLib: "PERINDOPRIL TOSI.TVC 2,5MG C BT 90",
  atcCode: "C09AA04"
}, {
  CIP7: '3299904',
  CIP13: '3400932999040',
  ucdLib: "ZESTRIL 20MG CPR",
  UCD7: '9128061',
  UCD13: '3400891280616',
  ucdQtyMultiplicator: 28,
  cipLib: "ZESTRIL 20MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3299910',
  CIP13: '3400932999101',
  ucdLib: "ZESTRIL 5MG CPR",
  UCD7: '9128078',
  UCD13: '3400891280784',
  ucdQtyMultiplicator: 28,
  cipLib: "ZESTRIL 5MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3602521',
  CIP13: '3400936025219',
  ucdLib: "LISINOPRIL EG 20MG CPR",
  UCD7: '9256310',
  UCD13: '3400892563107',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL EG 20MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3602515',
  CIP13: '3400936025158',
  ucdLib: "LISINOPRIL EG 5MG CPR",
  UCD7: '9256327',
  UCD13: '3400892563275',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL EG 5MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3671137',
  CIP13: '3400936711372',
  ucdLib: "LISINOPRIL ARW 20MG CPR",
  UCD7: '9272763',
  UCD13: '3400892727639',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL ARW 20MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3673099',
  CIP13: '3400936730991',
  ucdLib: "LISINOPRIL BGA 20MG CPR",
  UCD7: '9270853',
  UCD13: '3400892708539',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL BGA 20MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3673076',
  CIP13: '3400936730762',
  ucdLib: "LISINOPRIL BGA 5MG CPR",
  UCD7: '9270876',
  UCD13: '3400892708768',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL BGA 5MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3693972',
  CIP13: '3400936939721',
  ucdLib: "LISINOPRIL CRT 20MG CPR",
  UCD7: '9277921',
  UCD13: '3400892779218',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL CRT 20MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3724230',
  CIP13: '3400937242301',
  ucdLib: "LISINOPRIL MYL 20MG CPR",
  UCD7: '9264137',
  UCD13: '3400892641379',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL MYL 20MG CPR BT 84",
  atcCode: "C09AA03"
}, {
  CIP7: '3744540',
  CIP13: '3400937445405',
  ucdLib: "LISINOPRIL MYL 5MG CPR",
  UCD7: '9288439',
  UCD13: '3400892884394',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL MYL 5MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3744586',
  CIP13: '3400937445863',
  ucdLib: "LISINOPRIL MYL 5MG CPR",
  UCD7: '9288439',
  UCD13: '3400892884394',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL MYL 5MG CPR BT 84",
  atcCode: "C09AA03"
}, {
  CIP7: '3729871',
  CIP13: '3400937298711',
  ucdLib: "LISINOPRIL SDZ 20MG CPR",
  UCD7: '9261185',
  UCD13: '3400892611853',
  ucdQtyMultiplicator: 90,
  cipLib: "LISINOPRIL SDZ 20MG CPR BT 90",
  atcCode: "C09AA03"
}, {
  CIP7: '3729859',
  CIP13: '3400937298599',
  ucdLib: "LISINOPRIL SDZ 5MG CPR",
  UCD7: '9261191',
  UCD13: '3400892611914',
  ucdQtyMultiplicator: 90,
  cipLib: "LISINOPRIL SDZ 5MG CPR BT 90",
  atcCode: "C09AA03"
}, {
  CIP7: '3665071',
  CIP13: '3400936650718',
  ucdLib: "LISINOPRIL TVC 20MG CPR",
  UCD7: '9266739',
  UCD13: '3400892667393',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL TVC 20MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3728914',
  CIP13: '3400937289146',
  ucdLib: "LISINOPRIL TVC 20MG CPR",
  UCD7: '9266739',
  UCD13: '3400892667393',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL TVC 20MG CPR BT 84",
  atcCode: "C09AA03"
}, {
  CIP7: '3665065',
  CIP13: '3400936650657',
  ucdLib: "LISINOPRIL TVC 5MG CPR",
  UCD7: '9266745',
  UCD13: '3400892667454',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL TVC 5MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3720522',
  CIP13: '3400937205221',
  ucdLib: "LISINOPRIL ZEN 20MG CPR",
  UCD7: '9276577',
  UCD13: '3400892765778',
  ucdQtyMultiplicator: 30,
  cipLib: "LISINOPRIL ZEN 20MG CPR BT 30",
  atcCode: "C09AA03"
}, {
  CIP7: '3742498',
  CIP13: '3400937424981',
  ucdLib: "LISINOPRIL ZYD 20MG CPR",
  UCD7: '9289249',
  UCD13: '3400892892498',
  ucdQtyMultiplicator: 30,
  cipLib: "LISINOPRIL ZYD 20MG CPR BT 30",
  atcCode: "C09AA03"
}, {
  CIP7: '3742506',
  CIP13: '3400937425063',
  ucdLib: "LISINOPRIL ZYD 20MG CPR",
  UCD7: '9289249',
  UCD13: '3400892892498',
  ucdQtyMultiplicator: 90,
  cipLib: "LISINOPRIL ZYD 20MG CPR BT 90",
  atcCode: "C09AA03"
}, {
  CIP7: '3791427',
  CIP13: '3400937914277',
  ucdLib: "LISINOPRIL BGA 20MG CPR",
  UCD7: '9270853',
  UCD13: '3400892708539',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL BGA 20MG CPR BT 84",
  atcCode: "C09AA03"
}, {
  CIP7: '3791373',
  CIP13: '3400937913737',
  ucdLib: "LISINOPRIL BGA 5MG CPR",
  UCD7: '9270876',
  UCD13: '3400892708768',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL BGA 5MG CPR BT 84",
  atcCode: "C09AA03"
}, {
  CIP7: '3647854',
  CIP13: '3400936478541',
  ucdLib: "LISINOPRIL MYL 20MG CPR",
  UCD7: '9264137',
  UCD13: '3400892641379',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL MYL 20MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3641573',
  CIP13: '3400936415737',
  ucdLib: "LISINOPRIL SDZ 20MG CPR",
  UCD7: '9261185',
  UCD13: '3400892611853',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL SDZ 20MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3641550',
  CIP13: '3400936415508',
  ucdLib: "LISINOPRIL SDZ 5MG CPR",
  UCD7: '9261191',
  UCD13: '3400892611914',
  ucdQtyMultiplicator: 28,
  cipLib: "LISINOPRIL SDZ 5MG CPR BT 28",
  atcCode: "C09AA03"
}, {
  CIP7: '3739639',
  CIP13: '3400937396394',
  ucdLib: "LISINOPRIL ARW 20MG CPR",
  UCD7: '9272763',
  UCD13: '3400892727639',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL ARW 20MG CPR BT 84",
  atcCode: "C09AA03"
}, {
  CIP7: '3739220',
  CIP13: '3400937392204',
  ucdLib: "LISINOPRIL EG 20MG CPR",
  UCD7: '9256310',
  UCD13: '3400892563107',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL EG 20MG CPR BT 84",
  atcCode: "C09AA03"
}, {
  CIP7: '3739208',
  CIP13: '3400937392082',
  ucdLib: "LISINOPRIL EG 5MG CPR",
  UCD7: '9256327',
  UCD13: '3400892563275',
  ucdQtyMultiplicator: 84,
  cipLib: "LISINOPRIL EG 5MG CPR BT 84",
  atcCode: "C09AA03"
}, {
  CIP7: '3570991',
  CIP13: '3400935709912',
  ucdLib: "ENALAPRIL ZYD 20MG CPR",
  UCD7: '9234478',
  UCD13: '3400892344782',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL ZYD 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3270906',
  CIP13: '3400932709069',
  ucdLib: "RENITEC 20MG CPR",
  UCD7: '9078937',
  UCD13: '3400890789370',
  ucdQtyMultiplicator: 28,
  cipLib: "RENITEC 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3270898',
  CIP13: '3400932708987',
  ucdLib: "RENITEC 5MG CPR",
  UCD7: '9078943',
  UCD13: '3400890789431',
  ucdQtyMultiplicator: 28,
  cipLib: "RENITEC 5MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3608989',
  CIP13: '3400936089891',
  ucdLib: "ENALAPRIL ARW 5MG CPR",
  UCD7: '9246760',
  UCD13: '3400892467603',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL ARW 5MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3602001',
  CIP13: '3400936020016',
  ucdLib: "ENALAPRIL TVS 20MG CPR",
  UCD7: '9242383',
  UCD13: '3400892423838',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL TVS 20MG CPR BT 30",
  atcCode: "C09AA02"
}, {
  CIP7: '3601941',
  CIP13: '3400936019416',
  ucdLib: "ENALAPRIL TVS 5MG CPR",
  UCD7: '9242408',
  UCD13: '3400892424088',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL TVS 5MG CPR BT 30",
  atcCode: "C09AA02"
}, {
  CIP7: '3674532',
  CIP13: '3400936745322',
  ucdLib: "ENALAPRIL ZEN 20MG CPR",
  UCD7: '9269979',
  UCD13: '3400892699790',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL ZEN 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3674526',
  CIP13: '3400936745261',
  ucdLib: "ENALAPRIL ZEN 5MG CPR",
  UCD7: '9269985',
  UCD13: '3400892699851',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL ZEN 5MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3550014',
  CIP13: '3400935500144',
  ucdLib: "ENALAPRIL BGA 5MG CPR",
  UCD7: '9224959',
  UCD13: '3400892249599',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL BGA 5MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3550497',
  CIP13: '3400935504975',
  ucdLib: "ENALAPRIL MYL 20MG CPR",
  UCD7: '9229626',
  UCD13: '3400892296265',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL MYL 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3626415',
  CIP13: '3400936264151',
  ucdLib: "ENALAPRIL CRT 20MG CPR",
  UCD7: '9255569',
  UCD13: '3400892555690',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL CRT 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3626409',
  CIP13: '3400936264090',
  ucdLib: "ENALAPRIL CRT 5MG CPR",
  UCD7: '9255575',
  UCD13: '3400892555751',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL CRT 5MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3592567',
  CIP13: '3400935925671',
  ucdLib: "ENALAPRIL EVO 20MG CPR",
  UCD7: '9316957',
  UCD13: '3400893169575',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL EVO 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3592610',
  CIP13: '3400935926104',
  ucdLib: "ENALAPRIL EVO 5MG CPR",
  UCD7: '9316963',
  UCD13: '3400893169636',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL EVO 5MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3549962',
  CIP13: '3400935499622',
  ucdLib: "ENALAPRIL BGA 20MG CPR",
  UCD7: '9224942',
  UCD13: '3400892249421',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL BGA 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3540398',
  CIP13: '3400935403988',
  ucdLib: "ENALAPRIL MYL 5MG CPR",
  UCD7: '9229632',
  UCD13: '3400892296326',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL MYL 5MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3724253',
  CIP13: '3400937242530',
  ucdLib: "ENALAPRIL MYL 20MG CPR",
  UCD7: '9229626',
  UCD13: '3400892296265',
  ucdQtyMultiplicator: 84,
  cipLib: "ENALAPRIL MYL 20MG CPR BT 84",
  atcCode: "C09AA02"
}, {
  CIP7: '3739349',
  CIP13: '3400937393492',
  ucdLib: "ENALAPRIL EG 20MG CPR",
  UCD7: '9232640',
  UCD13: '3400892326405',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL EG 20MG CPR BT 90",
  atcCode: "C09AA02"
}, {
  CIP7: '3879010',
  CIP13: '3400938790108',
  ucdLib: "ENALAPRIL EG 20MG CPR",
  UCD7: '9232640',
  UCD13: '3400892326405',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL EG 20MG CPR BT 30",
  atcCode: "C09AA02"
}, {
  CIP7: '3739332',
  CIP13: '3400937393324',
  ucdLib: "ENALAPRIL EG 5MG CPR",
  UCD7: '9232657',
  UCD13: '3400892326573',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL EG 5MG CPR BT 90",
  atcCode: "C09AA02"
}, {
  CIP7: '3879004',
  CIP13: '3400938790047',
  ucdLib: "ENALAPRIL EG 5MG CPR",
  UCD7: '9232657',
  UCD13: '3400892326573',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL EG 5MG CPR BT 30",
  atcCode: "C09AA02"
}, {
  CIP7: '3731448',
  CIP13: '3400937314480',
  ucdLib: "ENALAPRIL SDZ 20MG CPR",
  UCD7: '9231480',
  UCD13: '3400892314808',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL SDZ 20MG CPR BT 30",
  atcCode: "C09AA02"
}, {
  CIP7: '3731460',
  CIP13: '3400937314602',
  ucdLib: "ENALAPRIL SDZ 20MG CPR",
  UCD7: '9231480',
  UCD13: '3400892314808',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL SDZ 20MG CPR BT 90",
  atcCode: "C09AA02"
}, {
  CIP7: '3731402',
  CIP13: '3400937314022',
  ucdLib: "ENALAPRIL SDZ 5MG CPR",
  UCD7: '9231497',
  UCD13: '3400892314976',
  ucdQtyMultiplicator: 30,
  cipLib: "ENALAPRIL SDZ 5MG CPR BT 30",
  atcCode: "C09AA02"
}, {
  CIP7: '3731425',
  CIP13: '3400937314251',
  ucdLib: "ENALAPRIL SDZ 5MG CPR",
  UCD7: '9231497',
  UCD13: '3400892314976',
  ucdQtyMultiplicator: 90,
  cipLib: "ENALAPRIL SDZ 5MG CPR BT 90",
  atcCode: "C09AA02"
}, {
  CIP7: '2674659',
  CIP13: '3400926746599',
  ucdLib: "ENALAPRIL RBX 20MG CPR",
  UCD7: '9396637',
  UCD13: '3400893966372',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL RBX 20MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '2674582',
  CIP13: '3400926745820',
  ucdLib: "ENALAPRIL RBX 5MG CPR",
  UCD7: '9396643',
  UCD13: '3400893966433',
  ucdQtyMultiplicator: 28,
  cipLib: "ENALAPRIL RBX 5MG CPR BT 28",
  atcCode: "C09AA02"
}, {
  CIP7: '3616109',
  CIP13: '3400936161092',
  ucdLib: "CAPTOPRIL TVC 25MG CPR",
  UCD7: '9247386',
  UCD13: '3400892473864',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL TVC 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3616115',
  CIP13: '3400936161153',
  ucdLib: "CAPTOPRIL TVC 50MG CPR",
  UCD7: '9247392',
  UCD13: '3400892473925',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL TVC 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3576373',
  CIP13: '3400935763730',
  ucdLib: "CAPTOPRIL ARW 25MG CPR",
  UCD7: '9235489',
  UCD13: '3400892354897',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL ARW 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3576410',
  CIP13: '3400935764102',
  ucdLib: "CAPTOPRIL ARW 50MG CPR",
  UCD7: '9235495',
  UCD13: '3400892354958',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL ARW 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3268364',
  CIP13: '3400932683642',
  ucdLib: "LOPRIL 25MG CPR",
  UCD7: '9055132',
  UCD13: '3400890551328',
  ucdQtyMultiplicator: 30,
  cipLib: "LOPRIL 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3268358',
  CIP13: '3400932683581',
  ucdLib: "LOPRIL 50MG CPR",
  UCD7: '9055149',
  UCD13: '3400890551496',
  ucdQtyMultiplicator: 30,
  cipLib: "LOPRIL 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3673923',
  CIP13: '3400936739239',
  ucdLib: "CAPTOPRIL ZEN 25MG CPR",
  UCD7: '9271261',
  UCD13: '3400892712611',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL ZEN 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3673946',
  CIP13: '3400936739468',
  ucdLib: "CAPTOPRIL ZEN 50MG CPR",
  UCD7: '9271278',
  UCD13: '3400892712789',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL ZEN 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3485771',
  CIP13: '3400934857713',
  ucdLib: "CAPTOPRIL BGA 25MG CPR",
  UCD7: '9208073',
  UCD13: '3400892080734',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL BGA 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3485788',
  CIP13: '3400934857881',
  ucdLib: "CAPTOPRIL BGA 50MG CPR",
  UCD7: '9208096',
  UCD13: '3400892080963',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL BGA 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3481402',
  CIP13: '3400934814020',
  ucdLib: "CAPTOPRIL EG 25MG CPR",
  UCD7: '9208104',
  UCD13: '3400892081045',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL EG 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3481454',
  CIP13: '3400934814549',
  ucdLib: "CAPTOPRIL EG 25MG CPR",
  UCD7: '9208104',
  UCD13: '3400892081045',
  ucdQtyMultiplicator: 90,
  cipLib: "CAPTOPRIL EG 25MG CPR BT 90",
  atcCode: "C09AA01"
}, {
  CIP7: '3480383',
  CIP13: '3400934803833',
  ucdLib: "CAPTOPRIL EG 50MG CPR",
  UCD7: '9208110',
  UCD13: '3400892081106',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL EG 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3480443',
  CIP13: '3400934804434',
  ucdLib: "CAPTOPRIL EG 50MG CPR",
  UCD7: '9208110',
  UCD13: '3400892081106',
  ucdQtyMultiplicator: 90,
  cipLib: "CAPTOPRIL EG 50MG CPR BT 90",
  atcCode: "C09AA01"
}, {
  CIP7: '3514917',
  CIP13: '3400935149176',
  ucdLib: "CAPTOPRIL SDZ 25MG CPR",
  UCD7: '9215653',
  UCD13: '3400892156538',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL SDZ 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3514923',
  CIP13: '3400935149237',
  ucdLib: "CAPTOPRIL SDZ 50MG CPR",
  UCD7: '9215676',
  UCD13: '3400892156767',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL SDZ 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3466992',
  CIP13: '3400934669927',
  ucdLib: "CAPTOPRIL ZYD 25MG CPR",
  UCD7: '9205844',
  UCD13: '3400892058443',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL ZYD 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3467000',
  CIP13: '3400934670008',
  ucdLib: "CAPTOPRIL ZYD 50MG CPR",
  UCD7: '9205850',
  UCD13: '3400892058504',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL ZYD 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3722840',
  CIP13: '3400937228404',
  ucdLib: "LOPRIL 25MG CPR",
  UCD7: '9055132',
  UCD13: '3400890551328',
  ucdQtyMultiplicator: 90,
  cipLib: "LOPRIL 25MG CPR BT 90",
  atcCode: "C09AA01"
}, {
  CIP7: '3722857',
  CIP13: '3400937228572',
  ucdLib: "LOPRIL 50MG CPR",
  UCD7: '9055149',
  UCD13: '3400890551496',
  ucdQtyMultiplicator: 90,
  cipLib: "LOPRIL 50MG CPR BT 90",
  atcCode: "C09AA01"
}, {
  CIP7: '3475287',
  CIP13: '3400934752872',
  ucdLib: "CAPTOPRIL MYL 25MG CPR",
  UCD7: '9206358',
  UCD13: '3400892063584',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL MYL 25MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3475318',
  CIP13: '3400934753183',
  ucdLib: "CAPTOPRIL MYL 25MG CPR",
  UCD7: '9206358',
  UCD13: '3400892063584',
  ucdQtyMultiplicator: 90,
  cipLib: "CAPTOPRIL MYL 25MG CPR BT 90",
  atcCode: "C09AA01"
}, {
  CIP7: '3475169',
  CIP13: '3400934751691',
  ucdLib: "CAPTOPRIL MYL 50MG CPR",
  UCD7: '9206364',
  UCD13: '3400892063645',
  ucdQtyMultiplicator: 30,
  cipLib: "CAPTOPRIL MYL 50MG CPR BT 30",
  atcCode: "C09AA01"
}, {
  CIP7: '3475198',
  CIP13: '3400934751981',
  ucdLib: "CAPTOPRIL MYL 50MG CPR",
  UCD7: '9206364',
  UCD13: '3400892063645',
  ucdQtyMultiplicator: 90,
  cipLib: "CAPTOPRIL MYL 50MG CPR BT 90",
  atcCode: "C09AA01"
}, {
  CIP7: '5890059',
  CIP13: '3400958900594',
  ucdLib: "NOYADA 25MG/5ML BUV FL100ML",
  UCD7: '9407648',
  UCD13: '3400894076483',
  ucdQtyMultiplicator: 1,
  cipLib: "NOYADA 25MG/5ML BUV FL100ML BT 1",
  atcCode: "C09AA01"
}, {
  CIP7: '5890058',
  CIP13: '3400958900587',
  ucdLib: "NOYADA 5MG/5ML BUV FL100ML",
  UCD7: '9415346',
  UCD13: '3400894153467',
  ucdQtyMultiplicator: 1,
  cipLib: "NOYADA 5MG/5ML BUV FL100ML BT 1",
  atcCode: "C09AA01"
}, {
  CIP7: '2759835',
  CIP13: '3400927598357',
  ucdLib: "NATRIXAM 1,5MG/10MG CPR LM",
  UCD7: '9400221',
  UCD13: '3400894002215',
  ucdQtyMultiplicator: 30,
  cipLib: "NATRIXAM 1,5MG/10MG CPR LM BT 30",
  atcCode: "C08GA02"
}, {
  CIP7: '2759858',
  CIP13: '3400927598586',
  ucdLib: "NATRIXAM 1,5MG/10MG CPR LM",
  UCD7: '9400221',
  UCD13: '3400894002215',
  ucdQtyMultiplicator: 90,
  cipLib: "NATRIXAM 1,5MG/10MG CPR LM BT 90",
  atcCode: "C08GA02"
}, {
  CIP7: '2759752',
  CIP13: '3400927597527',
  ucdLib: "NATRIXAM 1,5MG/5MG CPR LM",
  UCD7: '9400238',
  UCD13: '3400894002383',
  ucdQtyMultiplicator: 30,
  cipLib: "NATRIXAM 1,5MG/5MG CPR LM BT 30",
  atcCode: "C08GA02"
}, {
  CIP7: '2759775',
  CIP13: '3400927597756',
  ucdLib: "NATRIXAM 1,5MG/5MG CPR LM",
  UCD7: '9400238',
  UCD13: '3400894002383',
  ucdQtyMultiplicator: 90,
  cipLib: "NATRIXAM 1,5MG/5MG CPR LM BT 90",
  atcCode: "C08GA02"
}, {
  CIP7: '3459549',
  CIP13: '3400934595493',
  ucdLib: "DILTIAZEM MYL LP 120MG GELU",
  UCD7: '9183456',
  UCD13: '3400891834567',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM MYL LP 120MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '3459532',
  CIP13: '3400934595325',
  ucdLib: "DILTIAZEM MYL LP 90MG GELU",
  UCD7: '9183462',
  UCD13: '3400891834628',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM MYL LP 90MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '3615995',
  CIP13: '3400936159952',
  ucdLib: "DILTIAZEM TVC 60MG CPR",
  UCD7: '9246688',
  UCD13: '3400892466880',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM TVC 60MG CPR BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '3614665',
  CIP13: '3400936146655',
  ucdLib: "DILTIAZEM TVC LP 120MG GELU",
  UCD7: '9244896',
  UCD13: '3400892448961',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM TVC LP 120MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3616003',
  CIP13: '3400936160033',
  ucdLib: "DILTIAZEM TVC LP 300MG GELU",
  UCD7: '9246671',
  UCD13: '3400892466712',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM TVC LP 300MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3614659',
  CIP13: '3400936146594',
  ucdLib: "DILTIAZEM TVC LP 90MG GELU",
  UCD7: '9244904',
  UCD13: '3400892449043',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM TVC LP 90MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '5549067',
  CIP13: '3400955490678',
  ucdLib: "TILDIEM 25MG INJ FL",
  UCD7: '9136617',
  UCD13: '3400891366174',
  ucdQtyMultiplicator: 20,
  cipLib: "TILDIEM 25MG INJ FL BT 20",
  atcCode: "C08DB01"
}, {
  CIP7: '3238179',
  CIP13: '3400932381791',
  ucdLib: "TILDIEM 60MG CPR",
  UCD7: '9093291',
  UCD13: '3400890932912',
  ucdQtyMultiplicator: 30,
  cipLib: "TILDIEM 60MG CPR BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '5563498',
  CIP13: '3400955634980',
  ucdLib: "TILDIEM 100MG INJ FL",
  UCD7: '9131465',
  UCD13: '3400891314656',
  ucdQtyMultiplicator: 20,
  cipLib: "TILDIEM 100MG INJ FL BT 20",
  atcCode: "C08DB01"
}, {
  CIP7: '3604075',
  CIP13: '3400936040755',
  ucdLib: "DILTIAZEM CRT LP 120MG GELU",
  UCD7: '9240059',
  UCD13: '3400892400594',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM CRT LP 120MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3604081',
  CIP13: '3400936040816',
  ucdLib: "DILTIAZEM CRT LP 90MG GELU",
  UCD7: '9240071',
  UCD13: '3400892400716',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM CRT LP 90MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3689284',
  CIP13: '3400936892842',
  ucdLib: "DILTIAZEM SDZ LP 120MG GELU",
  UCD7: '9273194',
  UCD13: '3400892731940',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM SDZ LP 120MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3689433',
  CIP13: '3400936894334',
  ucdLib: "DILTIAZEM SDZ LP 300MG GELU",
  UCD7: '9273260',
  UCD13: '3400892732602',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM SDZ LP 300MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '3689321',
  CIP13: '3400936893214',
  ucdLib: "DILTIAZEM SDZ LP 90MG GELU",
  UCD7: '9273202',
  UCD13: '3400892732022',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM SDZ LP 90MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '5578608',
  CIP13: '3400955786085',
  ucdLib: "MONO-TILDIEM LP 200MG GELU",
  UCD7: '9158398',
  UCD13: '3400891583984',
  ucdQtyMultiplicator: 50,
  cipLib: "MONO-TILDIEM LP 200MG GELU BT 50",
  atcCode: "C08DB01"
}, {
  CIP7: '5578548',
  CIP13: '3400955785484',
  ucdLib: "MONO-TILDIEM LP 300MG GELU",
  UCD7: '9158406',
  UCD13: '3400891584066',
  ucdQtyMultiplicator: 50,
  cipLib: "MONO-TILDIEM LP 300MG GELU BT 50",
  atcCode: "C08DB01"
}, {
  CIP7: '3404554',
  CIP13: '3400934045547',
  ucdLib: "DILTIAZEM MYL 60MG CPR",
  UCD7: '9183479',
  UCD13: '3400891834796',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM MYL 60MG CPR BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '3357228',
  CIP13: '3400933572280',
  ucdLib: "MONO-TILDIEM LP 200MG GELU",
  UCD7: '9158398',
  UCD13: '3400891583984',
  ucdQtyMultiplicator: 28,
  cipLib: "MONO-TILDIEM LP 200MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3357211',
  CIP13: '3400933572112',
  ucdLib: "MONO-TILDIEM LP 300MG GELU",
  UCD7: '9158406',
  UCD13: '3400891584066',
  ucdQtyMultiplicator: 28,
  cipLib: "MONO-TILDIEM LP 300MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3489214',
  CIP13: '3400934892141',
  ucdLib: "DILTIAZEM BGA 60MG CPR",
  UCD7: '9209279',
  UCD13: '3400892092799',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM BGA 60MG CPR BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '3597501',
  CIP13: '3400935975010',
  ucdLib: "DILTIAZEM CRT 60MG CPR",
  UCD7: '9240088',
  UCD13: '3400892400884',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM CRT 60MG CPR BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '3659722',
  CIP13: '3400936597228',
  ucdLib: "DILTIAZEM SDZ 60MG CPR",
  UCD7: '9263882',
  UCD13: '3400892638829',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM SDZ 60MG CPR BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '3634426',
  CIP13: '3400936344266',
  ucdLib: "BI-TILDIEM LP 120MG CPR",
  UCD7: '9146610',
  UCD13: '3400891466102',
  ucdQtyMultiplicator: 28,
  cipLib: "BI-TILDIEM LP 120MG CPR BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3634449',
  CIP13: '3400936344495',
  ucdLib: "BI-TILDIEM LP 90MG CPR",
  UCD7: '9146627',
  UCD13: '3400891466270',
  ucdQtyMultiplicator: 28,
  cipLib: "BI-TILDIEM LP 90MG CPR BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3722981',
  CIP13: '3400937229814',
  ucdLib: "MONO-TILDIEM LP 200MG GELU",
  UCD7: '9158398',
  UCD13: '3400891583984',
  ucdQtyMultiplicator: 84,
  cipLib: "MONO-TILDIEM LP 200MG GELU BT 84",
  atcCode: "C08DB01"
}, {
  CIP7: '3722998',
  CIP13: '3400937229982',
  ucdLib: "MONO-TILDIEM LP 300MG GELU",
  UCD7: '9158406',
  UCD13: '3400891584066',
  ucdQtyMultiplicator: 84,
  cipLib: "MONO-TILDIEM LP 300MG GELU BT 84",
  atcCode: "C08DB01"
}, {
  CIP7: '3475784',
  CIP13: '3400934757846',
  ucdLib: "DILTIAZEM BGA LP 120MG GELU",
  UCD7: '9204359',
  UCD13: '3400892043593',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM BGA LP 120MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '3475778',
  CIP13: '3400934757785',
  ucdLib: "DILTIAZEM BGA LP 90MG GELU",
  UCD7: '9204365',
  UCD13: '3400892043654',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM BGA LP 90MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '5501647',
  CIP13: '3400955016472',
  ucdLib: "MONO-TILDIEM LP 200MG GELU",
  UCD7: '9158398',
  UCD13: '3400891583984',
  ucdQtyMultiplicator: 24,
  cipLib: "MONO-TILDIEM LP 200MG GELU BT 24",
  atcCode: "C08DB01"
}, {
  CIP7: '5631314',
  CIP13: '3400956313143',
  ucdLib: "TILDIEM 60MG CPR",
  UCD7: '9093291',
  UCD13: '3400890932912',
  ucdQtyMultiplicator: 100,
  cipLib: "TILDIEM 60MG CPR BT 100",
  atcCode: "C08DB01"
}, {
  CIP7: '2692947',
  CIP13: '3400926929473',
  ucdLib: "DILTIAZEM TVS LP 200MG GELU",
  UCD7: '9401901',
  UCD13: '3400894019015',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM TVS LP 200MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '2692999',
  CIP13: '3400926929992',
  ucdLib: "DILTIAZEM TVS LP 200MG GELU",
  UCD7: '9401901',
  UCD13: '3400894019015',
  ucdQtyMultiplicator: 84,
  cipLib: "DILTIAZEM TVS LP 200MG GELU BT 84",
  atcCode: "C08DB01"
}, {
  CIP7: '2693119',
  CIP13: '3400926931193',
  ucdLib: "DILTIAZEM TVS LP 300MG GELU",
  UCD7: '9401918',
  UCD13: '3400894019183',
  ucdQtyMultiplicator: 84,
  cipLib: "DILTIAZEM TVS LP 300MG GELU BT 84",
  atcCode: "C08DB01"
}, {
  CIP7: '2748079',
  CIP13: '3400927480799',
  ucdLib: "DILTIAZEM TVS LP 300MG GELU",
  UCD7: '9401918',
  UCD13: '3400894019183',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM TVS LP 300MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '2694366',
  CIP13: '3400926943660',
  ucdLib: "DILTIAZEM ZTL LP 200MG GELU",
  UCD7: '9402697',
  UCD13: '3400894026976',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM ZTL LP 200MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '2694395',
  CIP13: '3400926943950',
  ucdLib: "DILTIAZEM ZTL LP 200MG GELU",
  UCD7: '9402697',
  UCD13: '3400894026976',
  ucdQtyMultiplicator: 84,
  cipLib: "DILTIAZEM ZTL LP 200MG GELU BT 84",
  atcCode: "C08DB01"
}, {
  CIP7: '2694426',
  CIP13: '3400926944261',
  ucdLib: "DILTIAZEM ZTL LP 300MG GELU",
  UCD7: '9402705',
  UCD13: '3400894027058',
  ucdQtyMultiplicator: 28,
  cipLib: "DILTIAZEM ZTL LP 300MG GELU BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '2694455',
  CIP13: '3400926944551',
  ucdLib: "DILTIAZEM ZTL LP 300MG GELU",
  UCD7: '9402705',
  UCD13: '3400894027058',
  ucdQtyMultiplicator: 84,
  cipLib: "DILTIAZEM ZTL LP 300MG GELU BT 84",
  atcCode: "C08DB01"
}, {
  CIP7: '4900172',
  CIP13: '3400949001729',
  ucdLib: "MONO-TILDIEM LP200 AIPMWI UK",
  UCD7: '9317939',
  UCD13: '3400893179390',
  ucdQtyMultiplicator: 28,
  cipLib: "MONO-TILDIEM LP200 AIPMWI UK BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '4901088',
  CIP13: '3400949010882',
  ucdLib: "MONO-TILDIEM LP200 AIPMWI UK",
  UCD7: '9317939',
  UCD13: '3400893179390',
  ucdQtyMultiplicator: 84,
  cipLib: "MONO-TILDIEM LP200 AIPMWI UK BT 84",
  atcCode: "C08DB01"
}, {
  CIP7: '4900278',
  CIP13: '3400949002788',
  ucdLib: "MONO-TILDIEM LP200 AIPPLA UK",
  UCD7: '9334398',
  UCD13: '3400893343982',
  ucdQtyMultiplicator: 28,
  cipLib: "MONO-TILDIEM LP200 AIPPLA UK BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '4900700',
  CIP13: '3400949007004',
  ucdLib: "MONO-TILDIEM LP300 AIPMWI UK",
  UCD7: '9364896',
  UCD13: '3400893648964',
  ucdQtyMultiplicator: 28,
  cipLib: "MONO-TILDIEM LP300 AIPMWI UK BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '4901036',
  CIP13: '3400949010363',
  ucdLib: "MONO-TILDIEM LP300 AIPMWI UK",
  UCD7: '9364896',
  UCD13: '3400893648964',
  ucdQtyMultiplicator: 84,
  cipLib: "MONO-TILDIEM LP300 AIPMWI UK BT 84",
  atcCode: "C08DB01"
}, {
  CIP7: '4900545',
  CIP13: '3400949005451',
  ucdLib: "MONO-TILDIEM LP300 AIPPLA UK",
  UCD7: '9353622',
  UCD13: '3400893536223',
  ucdQtyMultiplicator: 28,
  cipLib: "MONO-TILDIEM LP300 AIPPLA UK BT 28",
  atcCode: "C08DB01"
}, {
  CIP7: '2684416',
  CIP13: '3400926844165',
  ucdLib: "DILTIAZEM BGR LP 200MG GELU",
  UCD7: '9403774',
  UCD13: '3400894037743',
  ucdQtyMultiplicator: 90,
  cipLib: "DILTIAZEM BGR LP 200MG GELU BT 90",
  atcCode: "C08DB01"
}, {
  CIP7: '2689106',
  CIP13: '3400926891060',
  ucdLib: "DILTIAZEM BGR LP 200MG GELU",
  UCD7: '9403774',
  UCD13: '3400894037743',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM BGR LP 200MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '2684451',
  CIP13: '3400926844516',
  ucdLib: "DILTIAZEM BGR LP 300MG GELU",
  UCD7: '9403780',
  UCD13: '3400894037804',
  ucdQtyMultiplicator: 90,
  cipLib: "DILTIAZEM BGR LP 300MG GELU BT 90",
  atcCode: "C08DB01"
}, {
  CIP7: '2689098',
  CIP13: '3400926890988',
  ucdLib: "DILTIAZEM BGR LP 300MG GELU",
  UCD7: '9403780',
  UCD13: '3400894037804',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM BGR LP 300MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '5702072',
  CIP13: '3400957020729',
  ucdLib: "DILTIAZEM WTR LP 90MG CPR",
  UCD7: '9296485',
  UCD13: '3400892964850',
  ucdQtyMultiplicator: 50,
  cipLib: "DILTIAZEM WTR LP 90MG CPR BT 50",
  atcCode: "C08DB01"
}, {
  CIP7: '5702089',
  CIP13: '3400957020897',
  ucdLib: "DILTIAZEM WTR LP120MG CPR",
  UCD7: '9296479',
  UCD13: '3400892964799',
  ucdQtyMultiplicator: 50,
  cipLib: "DILTIAZEM WTR LP120MG CPR BT 50",
  atcCode: "C08DB01"
}, {
  CIP7: '2773568',
  CIP13: '3400927735684',
  ucdLib: "DILTIAZEM GNR LP 200MG GELU",
  UCD7: '9408903',
  UCD13: '3400894089032',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM GNR LP 200MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '2773628',
  CIP13: '3400927736285',
  ucdLib: "DILTIAZEM GNR LP 200MG GELU",
  UCD7: '9408903',
  UCD13: '3400894089032',
  ucdQtyMultiplicator: 90,
  cipLib: "DILTIAZEM GNR LP 200MG GELU BT 90",
  atcCode: "C08DB01"
}, {
  CIP7: '2773700',
  CIP13: '3400927737008',
  ucdLib: "DILTIAZEM GNR LP 300MG GELU",
  UCD7: '9222819',
  UCD13: '3400892228198',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM GNR LP 300MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '2773775',
  CIP13: '3400927737756',
  ucdLib: "DILTIAZEM GNR LP 300MG GELU",
  UCD7: '9222819',
  UCD13: '3400892228198',
  ucdQtyMultiplicator: 90,
  cipLib: "DILTIAZEM GNR LP 300MG GELU BT 90",
  atcCode: "C08DB01"
}, {
  CIP7: '2779766',
  CIP13: '3400927797668',
  ucdLib: "DILTIAZEM MYL LP 200MG GELU",
  UCD7: '9401203',
  UCD13: '3400894012030',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM MYL LP 200MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '2779795',
  CIP13: '3400927797958',
  ucdLib: "DILTIAZEM MYL LP 200MG GELU",
  UCD7: '9401203',
  UCD13: '3400894012030',
  ucdQtyMultiplicator: 90,
  cipLib: "DILTIAZEM MYL LP 200MG GELU BT 90",
  atcCode: "C08DB01"
}, {
  CIP7: '2779826',
  CIP13: '3400927798269',
  ucdLib: "DILTIAZEM MYL LP 300MG GELU",
  UCD7: '9401226',
  UCD13: '3400894012269',
  ucdQtyMultiplicator: 30,
  cipLib: "DILTIAZEM MYL LP 300MG GELU BT 30",
  atcCode: "C08DB01"
}, {
  CIP7: '2779855',
  CIP13: '3400927798559',
  ucdLib: "DILTIAZEM MYL LP 300MG GELU",
  UCD7: '9401226',
  UCD13: '3400894012269',
  ucdQtyMultiplicator: 90,
  cipLib: "DILTIAZEM MYL LP 300MG GELU BT 90",
  atcCode: "C08DB01"
}, {
  CIP7: '5653155',
  CIP13: '3400956531554',
  ucdLib: "BI-TILDIEM LP 120MG CPR",
  UCD7: '9146610',
  UCD13: '3400891466102',
  ucdQtyMultiplicator: 50,
  cipLib: "BI-TILDIEM LP 120MG CPR BT 50",
  atcCode: "C08DB01"
}, {
  CIP7: '5653190',
  CIP13: '3400956531905',
  ucdLib: "BI-TILDIEM LP 90MG CPR",
  UCD7: '9146627',
  UCD13: '3400891466270',
  ucdQtyMultiplicator: 50,
  cipLib: "BI-TILDIEM LP 90MG CPR BT 50",
  atcCode: "C08DB01"
}, {
  CIP7: '3054580',
  CIP13: '3400930545805',
  ucdLib: "ISOPTINE 40MG CPR ENROB",
  UCD7: '9047701',
  UCD13: '3400890477017',
  ucdQtyMultiplicator: 75,
  cipLib: "ISOPTINE 40MG CPR ENROB BT 75",
  atcCode: "C08DA01"
}, {
  CIP7: '3614435',
  CIP13: '3400936144354',
  ucdLib: "VERAPAMIL TVC LP 120MG GELU",
  UCD7: '9245789',
  UCD13: '3400892457895',
  ucdQtyMultiplicator: 60,
  cipLib: "VERAPAMIL TVC LP 120MG GELU BT 60",
  atcCode: "C08DA01"
}, {
  CIP7: '3614441',
  CIP13: '3400936144415',
  ucdLib: "VERAPAMIL TVC LP 240MG GELU",
  UCD7: '9245795',
  UCD13: '3400892457956',
  ucdQtyMultiplicator: 30,
  cipLib: "VERAPAMIL TVC LP 240MG GELU BT 30",
  atcCode: "C08DA01"
}, {
  CIP7: '3286741',
  CIP13: '3400932867417',
  ucdLib: "ISOPTINE LP 240MG CPR",
  UCD7: '9125039',
  UCD13: '3400891250398',
  ucdQtyMultiplicator: 30,
  cipLib: "ISOPTINE LP 240MG CPR BT 30",
  atcCode: "C08DA01"
}, {
  CIP7: '3309146',
  CIP13: '3400933091460',
  ucdLib: "ISOPTINE 5MG/2ML INJ AMP",
  UCD7: '9047687',
  UCD13: '3400890476874',
  ucdQtyMultiplicator: 5,
  cipLib: "ISOPTINE 5MG/2ML INJ AMP BT 5",
  atcCode: "C08DA01"
}, {
  CIP7: '3688333',
  CIP13: '3400936883338',
  ucdLib: "VERAPAMIL SDZ LP 240MG CPR",
  UCD7: '9273248',
  UCD13: '3400892732480',
  ucdQtyMultiplicator: 30,
  cipLib: "VERAPAMIL SDZ LP 240MG CPR BT 30",
  atcCode: "C08DA01"
}, {
  CIP7: '3356039',
  CIP13: '3400933560393',
  ucdLib: "VERAPAMIL MYL LP 120MG CPR",
  UCD7: '9171045',
  UCD13: '3400891710458',
  ucdQtyMultiplicator: 60,
  cipLib: "VERAPAMIL MYL LP 120MG CPR BT 60",
  atcCode: "C08DA01"
}, {
  CIP7: '3355979',
  CIP13: '3400933559793',
  ucdLib: "VERAPAMIL MYL LP 240MG CPR",
  UCD7: '9171051',
  UCD13: '3400891710519',
  ucdQtyMultiplicator: 30,
  cipLib: "VERAPAMIL MYL LP 240MG CPR BT 30",
  atcCode: "C08DA01"
}, {
  CIP7: '3565286',
  CIP13: '3400935652867',
  ucdLib: "VERAPAMIL EG LP 240MG CPR",
  UCD7: '9231072',
  UCD13: '3400892310725',
  ucdQtyMultiplicator: 30,
  cipLib: "VERAPAMIL EG LP 240MG CPR BT 30",
  atcCode: "C08DA01"
}, {
  CIP7: '3547791',
  CIP13: '3400935477910',
  ucdLib: "ISOPTINE 120MG GELU",
  UCD7: '9047693',
  UCD13: '3400890476935',
  ucdQtyMultiplicator: 30,
  cipLib: "ISOPTINE 120MG GELU BT 30",
  atcCode: "C08DA01"
}, {
  CIP7: '3464869',
  CIP13: '3400934648694',
  ucdLib: "VERAPAMIL TVC 120MG CPR",
  UCD7: '9200551',
  UCD13: '3400892005515',
  ucdQtyMultiplicator: 30,
  cipLib: "VERAPAMIL TVC 120MG CPR BT 30",
  atcCode: "C08DA01"
}, {
  CIP7: '3464881',
  CIP13: '3400934648816',
  ucdLib: "VERAPAMIL TVC 120MG CPR",
  UCD7: '9200551',
  UCD13: '3400892005515',
  ucdQtyMultiplicator: 90,
  cipLib: "VERAPAMIL TVC 120MG CPR BT 90",
  atcCode: "C08DA01"
}, {
  CIP7: '3766808',
  CIP13: '3400937668088',
  ucdLib: "VERAPAMIL SDZ 120MG CPR",
  UCD7: '9291967',
  UCD13: '3400892919676',
  ucdQtyMultiplicator: 28,
  cipLib: "VERAPAMIL SDZ 120MG CPR BT 28",
  atcCode: "C08DA01"
}, {
  CIP7: '3723532',
  CIP13: '3400937235327',
  ucdLib: "VERAPAMIL SDZ LP 240MG CPR",
  UCD7: '9273248',
  UCD13: '3400892732480',
  ucdQtyMultiplicator: 90,
  cipLib: "VERAPAMIL SDZ LP 240MG CPR BT 90",
  atcCode: "C08DA01"
}, {
  CIP7: '3714042',
  CIP13: '3400937140423',
  ucdLib: "ISOPTINE 120MG GELU",
  UCD7: '9047693',
  UCD13: '3400890476935',
  ucdQtyMultiplicator: 90,
  cipLib: "ISOPTINE 120MG GELU BT 90",
  atcCode: "C08DA01"
}, {
  CIP7: '3715248',
  CIP13: '3400937152488',
  ucdLib: "ISOPTINE LP 240MG CPR",
  UCD7: '9125039',
  UCD13: '3400891250398',
  ucdQtyMultiplicator: 90,
  cipLib: "ISOPTINE LP 240MG CPR BT 90",
  atcCode: "C08DA01"
}, {
  CIP7: '3773317',
  CIP13: '3400937733175',
  ucdLib: "VERAPAMIL MYL LP 240MG CPR",
  UCD7: '9171051',
  UCD13: '3400891710519',
  ucdQtyMultiplicator: 90,
  cipLib: "VERAPAMIL MYL LP 240MG CPR BT 90",
  atcCode: "C08DA01"
}, {
  CIP7: '3739289',
  CIP13: '3400937392891',
  ucdLib: "VERAPAMIL EG LP 240MG CPR",
  UCD7: '9231072',
  UCD13: '3400892310725',
  ucdQtyMultiplicator: 90,
  cipLib: "VERAPAMIL EG LP 240MG CPR BT 90",
  atcCode: "C08DA01"
}, {
  CIP7: '3731201',
  CIP13: '3400937312011',
  ucdLib: "VERAPAMIL TVC LP 240MG GELU",
  UCD7: '9245795',
  UCD13: '3400892457956',
  ucdQtyMultiplicator: 90,
  cipLib: "VERAPAMIL TVC LP 240MG GELU BT 90",
  atcCode: "C08DA01"
}, {
  CIP7: '3426372',
  CIP13: '3400934263729',
  ucdLib: "VERAPAMIL BGA LP 240MG GELU",
  UCD7: '9195821',
  UCD13: '3400891958218',
  ucdQtyMultiplicator: 30,
  cipLib: "VERAPAMIL BGA LP 240MG GELU BT 30",
  atcCode: "C08DA01"
}, {
  CIP7: '2199767',
  CIP13: '3400921997675',
  ucdLib: "CLEVIPREX 0,5MG/ML INJ 50ML",
  UCD7: '9396407',
  UCD13: '3400893964071',
  ucdQtyMultiplicator: 10,
  cipLib: "CLEVIPREX 0,5MG/ML INJ 50ML BT 10",
  atcCode: "C08CA16"
}, {
  CIP7: '3005053',
  CIP13: '3400930050538',
  ucdLib: "LERCANIDIPINE BGA 10MG CPR",
  UCD7: '9333861',
  UCD13: '3400893338612',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE BGA 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3005054',
  CIP13: '3400930050545',
  ucdLib: "LERCANIDIPINE BGA 20MG CPR",
  UCD7: '9333878',
  UCD13: '3400893338780',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE BGA 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3327517',
  CIP13: '3400933275174',
  ucdLib: "LERCANIDIPINE MYL 20MG CPR",
  UCD7: '9345775',
  UCD13: '3400893457757',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE MYL 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3282654',
  CIP13: '3400932826544',
  ucdLib: "LERCANIDIPINE RTP 20MG CPR",
  UCD7: '9345835',
  UCD13: '3400893458358',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE RTP 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3294516',
  CIP13: '3400932945160',
  ucdLib: "LERCANIDIPINE MYL 10MG CPR",
  UCD7: '9345769',
  UCD13: '3400893457696',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE MYL 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3294545',
  CIP13: '3400932945450',
  ucdLib: "LERCANIDIPINE MYL 10MG CPR",
  UCD7: '9345769',
  UCD13: '3400893457696',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE MYL 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3319357',
  CIP13: '3400933193577',
  ucdLib: "LERCANIDIPINE MYL 20MG CPR",
  UCD7: '9345775',
  UCD13: '3400893457757',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE MYL 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3191472',
  CIP13: '3400931914723',
  ucdLib: "LERCANIDIPINE ZYD 10MG CPR",
  UCD7: '9345864',
  UCD13: '3400893458648',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE ZYD 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '4918373',
  CIP13: '3400949183739',
  ucdLib: "LERCANIDIPINE CRT 10MG CPR",
  UCD7: '9355213',
  UCD13: '3400893552131',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE CRT 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '4918539',
  CIP13: '3400949185399',
  ucdLib: "LERCANIDIPINE CRT 20MG CPR",
  UCD7: '9355236',
  UCD13: '3400893552360',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE CRT 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3370878',
  CIP13: '3400933708788',
  ucdLib: "LERCANIDIPINE RBX 10MG CPR",
  UCD7: '9345806',
  UCD13: '3400893458068',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE RBX 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3353236',
  CIP13: '3400933532369',
  ucdLib: "LERCANIDIPINE RBX 20MG CPR",
  UCD7: '9345812',
  UCD13: '3400893458129',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE RBX 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3354974',
  CIP13: '3400933549749',
  ucdLib: "LERCANIDIPINE RBX 20MG CPR",
  UCD7: '9345812',
  UCD13: '3400893458129',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE RBX 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3147583',
  CIP13: '3400931475835',
  ucdLib: "LERCANIDIPINE SDZ 10MG CPR",
  UCD7: '9345841',
  UCD13: '3400893458419',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE SDZ 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3367764',
  CIP13: '3400933677640',
  ucdLib: "LERCANIDIPINE RBX 10MG CPR",
  UCD7: '9345806',
  UCD13: '3400893458068',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE RBX 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3156257',
  CIP13: '3400931562573',
  ucdLib: "LERCANIDIPINE ARW 10MG CPR",
  UCD7: '9345491',
  UCD13: '3400893454916',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE ARW 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3467572',
  CIP13: '3400934675720',
  ucdLib: "LERCANIDIPINE EG 10MG CPR",
  UCD7: '9348319',
  UCD13: '3400893483190',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE EG 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3467603',
  CIP13: '3400934676031',
  ucdLib: "LERCANIDIPINE EG 10MG CPR",
  UCD7: '9348319',
  UCD13: '3400893483190',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE EG 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3467721',
  CIP13: '3400934677212',
  ucdLib: "LERCANIDIPINE EG 20MG CPR",
  UCD7: '9348325',
  UCD13: '3400893483251',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE EG 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3467767',
  CIP13: '3400934677670',
  ucdLib: "LERCANIDIPINE EG 20MG CPR",
  UCD7: '9348325',
  UCD13: '3400893483251',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE EG 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3151716',
  CIP13: '3400931517160',
  ucdLib: "LERCANIDIPINE SDZ 10MG CPR",
  UCD7: '9345841',
  UCD13: '3400893458419',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE SDZ 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3153187',
  CIP13: '3400931531876',
  ucdLib: "LERCANIDIPINE SDZ 20MG CPR",
  UCD7: '9345858',
  UCD13: '3400893458587',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE SDZ 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3153299',
  CIP13: '3400931532996',
  ucdLib: "LERCANIDIPINE SDZ 20MG CPR",
  UCD7: '9345858',
  UCD13: '3400893458587',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE SDZ 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3185098',
  CIP13: '3400931850984',
  ucdLib: "LERCANIDIPINE ZYD 10MG CPR",
  UCD7: '9345864',
  UCD13: '3400893458648',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE ZYD 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3175473',
  CIP13: '3400931754732',
  ucdLib: "LERCANIDIPINE ZYD 20MG CPR",
  UCD7: '9345870',
  UCD13: '3400893458709',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE ZYD 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3178856',
  CIP13: '3400931788560',
  ucdLib: "LERCANIDIPINE ZYD 20MG CPR",
  UCD7: '9345870',
  UCD13: '3400893458709',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE ZYD 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3722596',
  CIP13: '3400937225960',
  ucdLib: "ZANIDIP 10MG CPR",
  UCD7: '9217818',
  UCD13: '3400892178189',
  ucdQtyMultiplicator: 30,
  cipLib: "ZANIDIP 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3722604',
  CIP13: '3400937226042',
  ucdLib: "ZANIDIP 10MG CPR",
  UCD7: '9217818',
  UCD13: '3400892178189',
  ucdQtyMultiplicator: 90,
  cipLib: "ZANIDIP 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3722863',
  CIP13: '3400937228633',
  ucdLib: "ZANIDIP 20MG CPR",
  UCD7: '9250514',
  UCD13: '3400892505145',
  ucdQtyMultiplicator: 30,
  cipLib: "ZANIDIP 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3722886',
  CIP13: '3400937228862',
  ucdLib: "ZANIDIP 20MG CPR",
  UCD7: '9250514',
  UCD13: '3400892505145',
  ucdQtyMultiplicator: 90,
  cipLib: "ZANIDIP 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3712416',
  CIP13: '3400937124164',
  ucdLib: "LERCAN 10MG CPR",
  UCD7: '9217793',
  UCD13: '3400892177939',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCAN 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3712422',
  CIP13: '3400937124225',
  ucdLib: "LERCAN 10MG CPR",
  UCD7: '9217793',
  UCD13: '3400892177939',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCAN 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3712439',
  CIP13: '3400937124393',
  ucdLib: "LERCAN 20MG CPR",
  UCD7: '9250543',
  UCD13: '3400892505435',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCAN 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3712445',
  CIP13: '3400937124454',
  ucdLib: "LERCAN 20MG CPR",
  UCD7: '9250543',
  UCD13: '3400892505435',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCAN 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3778042',
  CIP13: '3400937780421',
  ucdLib: "LERCANIDIPINE EVO 10MG CPR",
  UCD7: '9356359',
  UCD13: '3400893563595',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE EVO 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3779550',
  CIP13: '3400937795500',
  ucdLib: "LERCANIDIPINE EVO 10MG CPR",
  UCD7: '9356359',
  UCD13: '3400893563595',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE EVO 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3783385',
  CIP13: '3400937833851',
  ucdLib: "LERCANIDIPINE EVO 20MG CPR",
  UCD7: '9356365',
  UCD13: '3400893563656',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE EVO 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3783617',
  CIP13: '3400937836173',
  ucdLib: "LERCANIDIPINE EVO 20MG CPR",
  UCD7: '9356365',
  UCD13: '3400893563656',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE EVO 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3161198',
  CIP13: '3400931611981',
  ucdLib: "LERCANIDIPINE ARW 10MG CPR",
  UCD7: '9345491',
  UCD13: '3400893454916',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE ARW 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3163116',
  CIP13: '3400931631163',
  ucdLib: "LERCANIDIPINE ARW 20MG CPR",
  UCD7: '9345516',
  UCD13: '3400893455166',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE ARW 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3165486',
  CIP13: '3400931654865',
  ucdLib: "LERCANIDIPINE ARW 20MG CPR",
  UCD7: '9345516',
  UCD13: '3400893455166',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE ARW 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3924087',
  CIP13: '3400939240879',
  ucdLib: "LERCANIDIPINE BCR 20MG CPR",
  UCD7: '9333855',
  UCD13: '3400893338551',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE BCR 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3924118',
  CIP13: '3400939241180',
  ucdLib: "LERCANIDIPINE BGA 20MG CPR",
  UCD7: '9333878',
  UCD13: '3400893338780',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE BGA 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3924147',
  CIP13: '3400939241470',
  ucdLib: "LERCANIDIPINE ZEN 20MG CPR",
  UCD7: '9333890',
  UCD13: '3400893338902',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE ZEN 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3915728',
  CIP13: '3400939157283',
  ucdLib: "LERCANIDIPINE BCR 10MG CPR",
  UCD7: '9333849',
  UCD13: '3400893338490',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE BCR 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3915757',
  CIP13: '3400939157573',
  ucdLib: "LERCANIDIPINE BCR 10MG CPR",
  UCD7: '9333849',
  UCD13: '3400893338490',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE BCR 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3917041',
  CIP13: '3400939170411',
  ucdLib: "LERCANIDIPINE BCR 20MG CPR",
  UCD7: '9333855',
  UCD13: '3400893338551',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE BCR 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3915800',
  CIP13: '3400939158006',
  ucdLib: "LERCANIDIPINE BGA 10MG CPR",
  UCD7: '9333861',
  UCD13: '3400893338612',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE BGA 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3915846',
  CIP13: '3400939158464',
  ucdLib: "LERCANIDIPINE BGA 10MG CPR",
  UCD7: '9333861',
  UCD13: '3400893338612',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE BGA 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3917070',
  CIP13: '3400939170701',
  ucdLib: "LERCANIDIPINE BGA 20MG CPR",
  UCD7: '9333878',
  UCD13: '3400893338780',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE BGA 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '2210090',
  CIP13: '3400922100906',
  ucdLib: "LERCANIDIPINE TVS 10MG CPR",
  UCD7: '9384686',
  UCD13: '3400893846865',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE TVS 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '2210138',
  CIP13: '3400922101385',
  ucdLib: "LERCANIDIPINE TVS 10MG CPR",
  UCD7: '9384686',
  UCD13: '3400893846865',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE TVS 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '2210285',
  CIP13: '3400922102856',
  ucdLib: "LERCANIDIPINE TVS 20MG CPR",
  UCD7: '9384692',
  UCD13: '3400893846926',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE TVS 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '2210339',
  CIP13: '3400922103396',
  ucdLib: "LERCANIDIPINE TVS 20MG CPR",
  UCD7: '9384692',
  UCD13: '3400893846926',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE TVS 20MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3915881',
  CIP13: '3400939158815',
  ucdLib: "LERCANIDIPINE ZEN 10MG CPR",
  UCD7: '9333884',
  UCD13: '3400893338841',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE ZEN 10MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3915912',
  CIP13: '3400939159126',
  ucdLib: "LERCANIDIPINE ZEN 10MG CPR",
  UCD7: '9333884',
  UCD13: '3400893338841',
  ucdQtyMultiplicator: 90,
  cipLib: "LERCANIDIPINE ZEN 10MG CPR BT 90",
  atcCode: "C08CA13"
}, {
  CIP7: '3916053',
  CIP13: '3400939160535',
  ucdLib: "LERCANIDIPINE ZEN 20MG CPR",
  UCD7: '9333890',
  UCD13: '3400893338902',
  ucdQtyMultiplicator: 30,
  cipLib: "LERCANIDIPINE ZEN 20MG CPR BT 30",
  atcCode: "C08CA13"
}, {
  CIP7: '3748242',
  CIP13: '3400937482424',
  ucdLib: "IPERTEN 10MG CPR",
  UCD7: '9250537',
  UCD13: '3400892505374',
  ucdQtyMultiplicator: 30,
  cipLib: "IPERTEN 10MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '3748265',
  CIP13: '3400937482653',
  ucdLib: "IPERTEN 10MG CPR",
  UCD7: '9250537',
  UCD13: '3400892505374',
  ucdQtyMultiplicator: 90,
  cipLib: "IPERTEN 10MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '3748271',
  CIP13: '3400937482714',
  ucdLib: "IPERTEN 20MG CPR",
  UCD7: '9258585',
  UCD13: '3400892585857',
  ucdQtyMultiplicator: 30,
  cipLib: "IPERTEN 20MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '3748294',
  CIP13: '3400937482943',
  ucdLib: "IPERTEN 20MG CPR",
  UCD7: '9258585',
  UCD13: '3400892585857',
  ucdQtyMultiplicator: 90,
  cipLib: "IPERTEN 20MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '3790385',
  CIP13: '3400937903851',
  ucdLib: "MANIDIPINE MYL 10MG CPR",
  UCD7: '9354366',
  UCD13: '3400893543665',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE MYL 10MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '3790741',
  CIP13: '3400937907415',
  ucdLib: "MANIDIPINE MYL 10MG CPR",
  UCD7: '9354366',
  UCD13: '3400893543665',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE MYL 10MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '3788891',
  CIP13: '3400937888912',
  ucdLib: "MANIDIPINE MYL 20MG CPR",
  UCD7: '9354372',
  UCD13: '3400893543726',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE MYL 20MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '3789229',
  CIP13: '3400937892292',
  ucdLib: "MANIDIPINE MYL 20MG CPR",
  UCD7: '9354372',
  UCD13: '3400893543726',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE MYL 20MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '3783847',
  CIP13: '3400937838474',
  ucdLib: "MANIDIPINE TVC 10MG CPR",
  UCD7: '9355259',
  UCD13: '3400893552599',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE TVC 10MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '3804845',
  CIP13: '3400938048452',
  ucdLib: "MANIDIPINE SDZ 10MG CPR",
  UCD7: '9352812',
  UCD13: '3400893528129',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE SDZ 10MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '3804851',
  CIP13: '3400938048513',
  ucdLib: "MANIDIPINE SDZ 10MG CPR",
  UCD7: '9352812',
  UCD13: '3400893528129',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE SDZ 10MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '3804905',
  CIP13: '3400938049053',
  ucdLib: "MANIDIPINE SDZ 20MG CPR",
  UCD7: '9352829',
  UCD13: '3400893528297',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE SDZ 20MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '3804928',
  CIP13: '3400938049282',
  ucdLib: "MANIDIPINE SDZ 20MG CPR",
  UCD7: '9352829',
  UCD13: '3400893528297',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE SDZ 20MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '4198915',
  CIP13: '3400941989155',
  ucdLib: "MANIDIPINE EG 10MG CPR",
  UCD7: '9357293',
  UCD13: '3400893572931',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE EG 10MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '4198921',
  CIP13: '3400941989216',
  ucdLib: "MANIDIPINE EG 10MG CPR",
  UCD7: '9357293',
  UCD13: '3400893572931',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE EG 10MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '4198938',
  CIP13: '3400941989384',
  ucdLib: "MANIDIPINE EG 20MG CPR",
  UCD7: '9357301',
  UCD13: '3400893573013',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE EG 20MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '4198944',
  CIP13: '3400941989445',
  ucdLib: "MANIDIPINE EG 20MG CPR",
  UCD7: '9357301',
  UCD13: '3400893573013',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE EG 20MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '4175848',
  CIP13: '3400941758485',
  ucdLib: "MANIDIPINE ZEN 10MG CPR",
  UCD7: '9357212',
  UCD13: '3400893572122',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE ZEN 10MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '4175860',
  CIP13: '3400941758607',
  ucdLib: "MANIDIPINE ZEN 10MG CPR",
  UCD7: '9357212',
  UCD13: '3400893572122',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE ZEN 10MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '4175877',
  CIP13: '3400941758775',
  ucdLib: "MANIDIPINE ZEN 20MG CPR",
  UCD7: '9357229',
  UCD13: '3400893572290',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE ZEN 20MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '4175908',
  CIP13: '3400941759086',
  ucdLib: "MANIDIPINE ZEN 20MG CPR",
  UCD7: '9357229',
  UCD13: '3400893572290',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE ZEN 20MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '4181613',
  CIP13: '3400941816130',
  ucdLib: "MANIDIPINE BGA 10MG CPR",
  UCD7: '9357270',
  UCD13: '3400893572702',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE BGA 10MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '4181636',
  CIP13: '3400941816369',
  ucdLib: "MANIDIPINE BGA 10MG CPR",
  UCD7: '9357270',
  UCD13: '3400893572702',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE BGA 10MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '4181642',
  CIP13: '3400941816420',
  ucdLib: "MANIDIPINE BGA 20MG CPR",
  UCD7: '9357287',
  UCD13: '3400893572870',
  ucdQtyMultiplicator: 30,
  cipLib: "MANIDIPINE BGA 20MG CPR BT 30",
  atcCode: "C08CA11"
}, {
  CIP7: '4181659',
  CIP13: '3400941816598',
  ucdLib: "MANIDIPINE BGA 20MG CPR",
  UCD7: '9357287',
  UCD13: '3400893572870',
  ucdQtyMultiplicator: 90,
  cipLib: "MANIDIPINE BGA 20MG CPR BT 90",
  atcCode: "C08CA11"
}, {
  CIP7: '3334701',
  CIP13: '3400933347017',
  ucdLib: "CALDINE 2MG CPR",
  UCD7: '9158464',
  UCD13: '3400891584646',
  ucdQtyMultiplicator: 30,
  cipLib: "CALDINE 2MG CPR BT 30",
  atcCode: "C08CA09"
}, {
  CIP7: '3334747',
  CIP13: '3400933347475',
  ucdLib: "CALDINE 4MG CPR",
  UCD7: '9158470',
  UCD13: '3400891584707',
  ucdQtyMultiplicator: 30,
  cipLib: "CALDINE 4MG CPR BT 30",
  atcCode: "C08CA09"
}, {
  CIP7: '3731313',
  CIP13: '3400937313131',
  ucdLib: "CALDINE 2MG CPR",
  UCD7: '9158464',
  UCD13: '3400891584646',
  ucdQtyMultiplicator: 90,
  cipLib: "CALDINE 2MG CPR BT 90",
  atcCode: "C08CA09"
}, {
  CIP7: '3731299',
  CIP13: '3400937312998',
  ucdLib: "CALDINE 4MG CPR",
  UCD7: '9158470',
  UCD13: '3400891584707',
  ucdQtyMultiplicator: 90,
  cipLib: "CALDINE 4MG CPR BT 90",
  atcCode: "C08CA09"
}, {
  CIP7: '3300369',
  CIP13: '3400933003692',
  ucdLib: "NIDREL 10MG CPR",
  UCD7: '9133659',
  UCD13: '3400891336597',
  ucdQtyMultiplicator: 28,
  cipLib: "NIDREL 10MG CPR BT 28",
  atcCode: "C08CA08"
}, {
  CIP7: '3300375',
  CIP13: '3400933003753',
  ucdLib: "NIDREL 20MG CPR",
  UCD7: '9133665',
  UCD13: '3400891336658',
  ucdQtyMultiplicator: 28,
  cipLib: "NIDREL 20MG CPR BT 28",
  atcCode: "C08CA08"
}, {
  CIP7: '3486664',
  CIP13: '3400934866647',
  ucdLib: "BAYPRESS 10MG CPR",
  UCD7: '9123572',
  UCD13: '3400891235722',
  ucdQtyMultiplicator: 30,
  cipLib: "BAYPRESS 10MG CPR BT 30",
  atcCode: "C08CA08"
}, {
  CIP7: '3484820',
  CIP13: '3400934848209',
  ucdLib: "BAYPRESS 20MG CPR",
  UCD7: '9123589',
  UCD13: '3400891235890',
  ucdQtyMultiplicator: 30,
  cipLib: "BAYPRESS 20MG CPR BT 30",
  atcCode: "C08CA08"
}, {
  CIP7: '3724282',
  CIP13: '3400937242820',
  ucdLib: "NITRENDIPINE MYL 20MG CPR",
  UCD7: '9210035',
  UCD13: '3400892100357',
  ucdQtyMultiplicator: 30,
  cipLib: "NITRENDIPINE MYL 20MG CPR BT 30",
  atcCode: "C08CA08"
}, {
  CIP7: '3724307',
  CIP13: '3400937243070',
  ucdLib: "NITRENDIPINE MYL 20MG CPR",
  UCD7: '9210035',
  UCD13: '3400892100357',
  ucdQtyMultiplicator: 90,
  cipLib: "NITRENDIPINE MYL 20MG CPR BT 90",
  atcCode: "C08CA08"
}, {
  CIP7: '3719677',
  CIP13: '3400937196772',
  ucdLib: "BAYPRESS 20MG CPR",
  UCD7: '9123589',
  UCD13: '3400891235890',
  ucdQtyMultiplicator: 90,
  cipLib: "BAYPRESS 20MG CPR BT 90",
  atcCode: "C08CA08"
}, {
  CIP7: '3714786',
  CIP13: '3400937147866',
  ucdLib: "NIDREL 10MG CPR",
  UCD7: '9133659',
  UCD13: '3400891336597',
  ucdQtyMultiplicator: 90,
  cipLib: "NIDREL 10MG CPR BT 90",
  atcCode: "C08CA08"
}, {
  CIP7: '3714792',
  CIP13: '3400937147927',
  ucdLib: "NIDREL 20MG CPR",
  UCD7: '9133665',
  UCD13: '3400891336658',
  ucdQtyMultiplicator: 90,
  cipLib: "NIDREL 20MG CPR BT 90",
  atcCode: "C08CA08"
}, {
  CIP7: '5618851',
  CIP13: '3400956188512',
  ucdLib: "BAYPRESS 10MG CPR",
  UCD7: '9123572',
  UCD13: '3400891235722',
  ucdQtyMultiplicator: 50,
  cipLib: "BAYPRESS 10MG CPR BT 50",
  atcCode: "C08CA08"
}, {
  CIP7: '5618874',
  CIP13: '3400956188741',
  ucdLib: "BAYPRESS 20MG CPR",
  UCD7: '9123589',
  UCD13: '3400891235890',
  ucdQtyMultiplicator: 50,
  cipLib: "BAYPRESS 20MG CPR BT 50",
  atcCode: "C08CA08"
}, {
  CIP7: '3730093',
  CIP13: '3400937300933',
  ucdLib: "NITRENDIPINE MYL 10MG CPR",
  UCD7: '9210029',
  UCD13: '3400892100296',
  ucdQtyMultiplicator: 30,
  cipLib: "NITRENDIPINE MYL 10MG CPR BT 30",
  atcCode: "C08CA08"
}, {
  CIP7: '3657261',
  CIP13: '3400936572614',
  ucdLib: "NIMOTOP 30MG CPR PELLIC",
  UCD7: '9120786',
  UCD13: '3400891207866',
  ucdQtyMultiplicator: 90,
  cipLib: "NIMOTOP 30MG CPR PELLIC BT 90",
  atcCode: "C08CA06"
}, {
  CIP7: '5632006',
  CIP13: '3400956320066',
  ucdLib: "NIMOTOP 10MG INJ FV50ML",
  UCD7: '9129089',
  UCD13: '3400891290899',
  ucdQtyMultiplicator: 1,
  cipLib: "NIMOTOP 10MG INJ FV50ML BT 1",
  atcCode: "C08CA06"
}, {
  CIP7: '3456870',
  CIP13: '3400934568701',
  ucdLib: "NIFEDIPINE MYL LP 20MG CPR",
  UCD7: '9201585',
  UCD13: '3400892015859',
  ucdQtyMultiplicator: 30,
  cipLib: "NIFEDIPINE MYL LP 20MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3274011',
  CIP13: '3400932740116',
  ucdLib: "ADALATE LP 20MG CPR",
  UCD7: '9102239',
  UCD13: '3400891022391',
  ucdQtyMultiplicator: 30,
  cipLib: "ADALATE LP 20MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3578047',
  CIP13: '3400935780478',
  ucdLib: "CHRONADALATE LP 30MG CPR",
  UCD7: '9159311',
  UCD13: '3400891593112',
  ucdQtyMultiplicator: 30,
  cipLib: "CHRONADALATE LP 30MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3578076',
  CIP13: '3400935780768',
  ucdLib: "CHRONADALATE LP 30MG CPR",
  UCD7: '9159311',
  UCD13: '3400891593112',
  ucdQtyMultiplicator: 100,
  cipLib: "CHRONADALATE LP 30MG CPR BT 100",
  atcCode: "C08CA05"
}, {
  CIP7: '3223479',
  CIP13: '3400932234790',
  ucdLib: "ADALATE 10MG CAPS",
  UCD7: '9001076',
  UCD13: '3400890010764',
  ucdQtyMultiplicator: 30,
  cipLib: "ADALATE 10MG CAPS BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3689166',
  CIP13: '3400936891661',
  ucdLib: "NIFEDIPINE ARW LP 30MG CPR",
  UCD7: '9276614',
  UCD13: '3400892766140',
  ucdQtyMultiplicator: 30,
  cipLib: "NIFEDIPINE ARW LP 30MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3689203',
  CIP13: '3400936892033',
  ucdLib: "NIFEDIPINE MYL LP 30MG CPR",
  UCD7: '9277944',
  UCD13: '3400892779447',
  ucdQtyMultiplicator: 30,
  cipLib: "NIFEDIPINE MYL LP 30MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3399528',
  CIP13: '3400933995287',
  ucdLib: "NIFEDIPINE RPG LP 20MG CPR",
  UCD7: '9179549',
  UCD13: '3400891795493',
  ucdQtyMultiplicator: 30,
  cipLib: "NIFEDIPINE RPG LP 20MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3723874',
  CIP13: '3400937238748',
  ucdLib: "ADALATE LP 20MG CPR",
  UCD7: '9102239',
  UCD13: '3400891022391',
  ucdQtyMultiplicator: 180,
  cipLib: "ADALATE LP 20MG CPR BT 180",
  atcCode: "C08CA05"
}, {
  CIP7: '3761082',
  CIP13: '3400937610827',
  ucdLib: "NIFEDIPINE EG LP 30MG CPR",
  UCD7: '9292889',
  UCD13: '3400892928890',
  ucdQtyMultiplicator: 30,
  cipLib: "NIFEDIPINE EG LP 30MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3761136',
  CIP13: '3400937611367',
  ucdLib: "NIFEDIPINE EG LP 30MG CPR",
  UCD7: '9292889',
  UCD13: '3400892928890',
  ucdQtyMultiplicator: 90,
  cipLib: "NIFEDIPINE EG LP 30MG CPR BT 90",
  atcCode: "C08CA05"
}, {
  CIP7: '3746562',
  CIP13: '3400937465625',
  ucdLib: "NIFEDIPINE SDZ LP 30MG CPR",
  UCD7: '9287799',
  UCD13: '3400892877990',
  ucdQtyMultiplicator: 30,
  cipLib: "NIFEDIPINE SDZ LP 30MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3719683',
  CIP13: '3400937196833',
  ucdLib: "CHRONADALATE LP 30MG CPR",
  UCD7: '9159311',
  UCD13: '3400891593112',
  ucdQtyMultiplicator: 90,
  cipLib: "CHRONADALATE LP 30MG CPR BT 90",
  atcCode: "C08CA05"
}, {
  CIP7: '3770193',
  CIP13: '3400937701938',
  ucdLib: "NIFEDIPINE RBX LP 30MG CPR",
  UCD7: '9294718',
  UCD13: '3400892947181',
  ucdQtyMultiplicator: 30,
  cipLib: "NIFEDIPINE RBX LP 30MG CPR BT 30",
  atcCode: "C08CA05"
}, {
  CIP7: '3738290',
  CIP13: '3400937382908',
  ucdLib: "NIFEDIPINE MYL LP 30MG CPR",
  UCD7: '9277944',
  UCD13: '3400892779447',
  ucdQtyMultiplicator: 90,
  cipLib: "NIFEDIPINE MYL LP 30MG CPR BT 90",
  atcCode: "C08CA05"
}, {
  CIP7: '3278173',
  CIP13: '3400932781737',
  ucdLib: "LOXEN 20MG CPR",
  UCD7: '9105775',
  UCD13: '3400891057751',
  ucdQtyMultiplicator: 30,
  cipLib: "LOXEN 20MG CPR BT 30",
  atcCode: "C08CA04"
}, {
  CIP7: '3278204',
  CIP13: '3400932782048',
  ucdLib: "LOXEN 20MG CPR",
  UCD7: '9105775',
  UCD13: '3400891057751',
  ucdQtyMultiplicator: 90,
  cipLib: "LOXEN 20MG CPR BT 90",
  atcCode: "C08CA04"
}, {
  CIP7: '3295510',
  CIP13: '3400932955107',
  ucdLib: "LOXEN LP 50MG GELU",
  UCD7: '9126932',
  UCD13: '3400891269321',
  ucdQtyMultiplicator: 60,
  cipLib: "LOXEN LP 50MG GELU BT 60",
  atcCode: "C08CA04"
}, {
  CIP7: '3311077',
  CIP13: '3400933110772',
  ucdLib: "LOXEN 10MG INJ AMP10ML",
  UCD7: '9132140',
  UCD13: '3400891321401',
  ucdQtyMultiplicator: 5,
  cipLib: "LOXEN 10MG INJ AMP10ML BT 5",
  atcCode: "C08CA04"
}, {
  CIP7: '3719648',
  CIP13: '3400937196482',
  ucdLib: "LOXEN LP 50MG GELU",
  UCD7: '9126932',
  UCD13: '3400891269321',
  ucdQtyMultiplicator: 180,
  cipLib: "LOXEN LP 50MG GELU BT 180",
  atcCode: "C08CA04"
}, {
  CIP7: '5700908',
  CIP13: '3400957009083',
  ucdLib: "NICARDIPINE AGT10MG INJ 10ML",
  UCD7: '9290703',
  UCD13: '3400892907031',
  ucdQtyMultiplicator: 10,
  cipLib: "NICARDIPINE AGT10MG INJ 10ML BT 10",
  atcCode: "C08CA04"
}, {
  CIP7: '4168647',
  CIP13: '3400941686474',
  ucdLib: "NICARDIPINE ARW10MG INJ 10ML",
  UCD7: '9372341',
  UCD13: '3400893723418',
  ucdQtyMultiplicator: 10,
  cipLib: "NICARDIPINE ARW10MG INJ 10ML BT 10",
  atcCode: "C08CA04"
}, {
  CIP7: '3334078',
  CIP13: '3400933340780',
  ucdLib: "ICAZ LP 2,5MG GELU",
  UCD7: '9152266',
  UCD13: '3400891522662',
  ucdQtyMultiplicator: 30,
  cipLib: "ICAZ LP 2,5MG GELU BT 30",
  atcCode: "C08CA03"
}, {
  CIP7: '3334109',
  CIP13: '3400933341091',
  ucdLib: "ICAZ LP 2,5MG GELU",
  UCD7: '9152266',
  UCD13: '3400891522662',
  ucdQtyMultiplicator: 30,
  cipLib: "ICAZ LP 2,5MG GELU BT 30",
  atcCode: "C08CA03"
}, {
  CIP7: '3333357',
  CIP13: '3400933333577',
  ucdLib: "ICAZ LP 5MG GELU",
  UCD7: '9152272',
  UCD13: '3400891522723',
  ucdQtyMultiplicator: 30,
  cipLib: "ICAZ LP 5MG GELU BT 30",
  atcCode: "C08CA03"
}, {
  CIP7: '3333392',
  CIP13: '3400933333928',
  ucdLib: "ICAZ LP 5MG GELU",
  UCD7: '9152272',
  UCD13: '3400891522723',
  ucdQtyMultiplicator: 30,
  cipLib: "ICAZ LP 5MG GELU BT 30",
  atcCode: "C08CA03"
}, {
  CIP7: '3739378',
  CIP13: '3400937393782',
  ucdLib: "ICAZ LP 2,5MG GELU",
  UCD7: '9152266',
  UCD13: '3400891522662',
  ucdQtyMultiplicator: 90,
  cipLib: "ICAZ LP 2,5MG GELU BT 90",
  atcCode: "C08CA03"
}, {
  CIP7: '3739390',
  CIP13: '3400937393904',
  ucdLib: "ICAZ LP 5MG GELU",
  UCD7: '9152272',
  UCD13: '3400891522723',
  ucdQtyMultiplicator: 90,
  cipLib: "ICAZ LP 5MG GELU BT 90",
  atcCode: "C08CA03"
}, {
  CIP7: '3785970',
  CIP13: '3400937859707',
  ucdLib: "FELODIPINE SDZ LP 5MG CPR",
  UCD7: '9297527',
  UCD13: '3400892975276',
  ucdQtyMultiplicator: 30,
  cipLib: "FELODIPINE SDZ LP 5MG CPR BT 30",
  atcCode: "C08CA02"
}, {
  CIP7: '3785987',
  CIP13: '3400937859875',
  ucdLib: "FELODIPINE SDZ LP 5MG CPR",
  UCD7: '9297527',
  UCD13: '3400892975276',
  ucdQtyMultiplicator: 90,
  cipLib: "FELODIPINE SDZ LP 5MG CPR BT 90",
  atcCode: "C08CA02"
}, {
  CIP7: '3799529',
  CIP13: '3400937995290',
  ucdLib: "FELODIPINE ZEN LP 5MG CPR",
  UCD7: '9302085',
  UCD13: '3400893020852',
  ucdQtyMultiplicator: 30,
  cipLib: "FELODIPINE ZEN LP 5MG CPR BT 30",
  atcCode: "C08CA02"
}, {
  CIP7: '3799541',
  CIP13: '3400937995412',
  ucdLib: "FELODIPINE ZEN LP 5MG CPR",
  UCD7: '9302085',
  UCD13: '3400893020852',
  ucdQtyMultiplicator: 90,
  cipLib: "FELODIPINE ZEN LP 5MG CPR BT 90",
  atcCode: "C08CA02"
}, {
  CIP7: '3714361',
  CIP13: '3400937143615',
  ucdLib: "FLODIL LP 5MG CPR",
  UCD7: '9154259',
  UCD13: '3400891542592',
  ucdQtyMultiplicator: 30,
  cipLib: "FLODIL LP 5MG CPR BT 30",
  atcCode: "C08CA02"
}, {
  CIP7: '3714384',
  CIP13: '3400937143844',
  ucdLib: "FLODIL LP 5MG CPR",
  UCD7: '9154259',
  UCD13: '3400891542592',
  ucdQtyMultiplicator: 90,
  cipLib: "FLODIL LP 5MG CPR BT 90",
  atcCode: "C08CA02"
}, {
  CIP7: '3005051',
  CIP13: '3400930050514',
  ucdLib: "AMLODIPINE BGA 10MG GELU",
  UCD7: '9301996',
  UCD13: '3400893019962',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE BGA 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3334196',
  CIP13: '3400933341961',
  ucdLib: "AMLODIPINE PFZ 10MG GELU",
  UCD7: '9329322',
  UCD13: '3400893293225',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE PFZ 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3334167',
  CIP13: '3400933341671',
  ucdLib: "AMLODIPINE PFZ 5MG GELU",
  UCD7: '9329339',
  UCD13: '3400893293393',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE PFZ 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3331335',
  CIP13: '3400933313357',
  ucdLib: "AMLOR 10MG GELU",
  UCD7: '9152533',
  UCD13: '3400891525335',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLOR 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3331358',
  CIP13: '3400933313586',
  ucdLib: "AMLOR 5MG GELU",
  UCD7: '9152556',
  UCD13: '3400891525564',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLOR 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3746409',
  CIP13: '3400937464093',
  ucdLib: "AMLODIPINE BCR 10MG GELU",
  UCD7: '9289999',
  UCD13: '3400892899992',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE BCR 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3746384',
  CIP13: '3400937463843',
  ucdLib: "AMLODIPINE BCR 5MG GELU",
  UCD7: '9290005',
  UCD13: '3400892900056',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE BCR 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3815079',
  CIP13: '3400938150797',
  ucdLib: "AMLODIPINE EG 10MG GELU",
  UCD7: '9302010',
  UCD13: '3400893020104',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE EG 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3815062',
  CIP13: '3400938150629',
  ucdLib: "AMLODIPINE EG 5MG GELU",
  UCD7: '9302027',
  UCD13: '3400893020272',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE EG 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3744066',
  CIP13: '3400937440660',
  ucdLib: "AMLODIPINE MYL 10MG GELU",
  UCD7: '9288675',
  UCD13: '3400892886756',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE MYL 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3744072',
  CIP13: '3400937440721',
  ucdLib: "AMLODIPINE MYL 10MG GELU",
  UCD7: '9288675',
  UCD13: '3400892886756',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE MYL 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3744095',
  CIP13: '3400937440950',
  ucdLib: "AMLODIPINE MYL 10MG GELU",
  UCD7: '9288675',
  UCD13: '3400892886756',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE MYL 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3743960',
  CIP13: '3400937439602',
  ucdLib: "AMLODIPINE MYL 5MG GELU",
  UCD7: '9288681',
  UCD13: '3400892886817',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE MYL 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3743983',
  CIP13: '3400937439831',
  ucdLib: "AMLODIPINE MYL 5MG GELU",
  UCD7: '9288681',
  UCD13: '3400892886817',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE MYL 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3744014',
  CIP13: '3400937440141',
  ucdLib: "AMLODIPINE MYL 5MG GELU",
  UCD7: '9288681',
  UCD13: '3400892886817',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE MYL 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3769451',
  CIP13: '3400937694513',
  ucdLib: "AMLODIPINE ZEN 10MG GELU",
  UCD7: '9294799',
  UCD13: '3400892947990',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ZEN 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3769468',
  CIP13: '3400937694681',
  ucdLib: "AMLODIPINE ZEN 5MG GELU",
  UCD7: '9294807',
  UCD13: '3400892948072',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ZEN 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3724388',
  CIP13: '3400937243889',
  ucdLib: "AMLOR 10MG GELU",
  UCD7: '9152533',
  UCD13: '3400891525335',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLOR 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3724371',
  CIP13: '3400937243711',
  ucdLib: "AMLOR 5MG GELU",
  UCD7: '9152556',
  UCD13: '3400891525564',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLOR 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3797714',
  CIP13: '3400937977142',
  ucdLib: "AMLODIPINE ALM 10MG GELU",
  UCD7: '9301944',
  UCD13: '3400893019443',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ALM 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3797720',
  CIP13: '3400937977203',
  ucdLib: "AMLODIPINE ALM 10MG GELU",
  UCD7: '9301944',
  UCD13: '3400893019443',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ALM 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3797660',
  CIP13: '3400937976602',
  ucdLib: "AMLODIPINE ALM 5MG GELU",
  UCD7: '9301950',
  UCD13: '3400893019504',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ALM 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3797677',
  CIP13: '3400937976770',
  ucdLib: "AMLODIPINE ALM 5MG GELU",
  UCD7: '9301950',
  UCD13: '3400893019504',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ALM 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3783126',
  CIP13: '3400937831260',
  ucdLib: "AMLODIPINE ARW 10MG GELU",
  UCD7: '9301967',
  UCD13: '3400893019672',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ARW 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3783103',
  CIP13: '3400937831031',
  ucdLib: "AMLODIPINE ARW 5MG GELU",
  UCD7: '9301973',
  UCD13: '3400893019733',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ARW 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3797453',
  CIP13: '3400937974530',
  ucdLib: "AMLODIPINE BCR 10MG GELU",
  UCD7: '9289999',
  UCD13: '3400892899992',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE BCR 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3797447',
  CIP13: '3400937974479',
  ucdLib: "AMLODIPINE BCR 5MG GELU",
  UCD7: '9290005',
  UCD13: '3400892900056',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE BCR 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3797737',
  CIP13: '3400937977371',
  ucdLib: "AMLODIPINE BGA 10MG GELU",
  UCD7: '9301996',
  UCD13: '3400893019962',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE BGA 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3797743',
  CIP13: '3400937977432',
  ucdLib: "AMLODIPINE BGA 10MG GELU",
  UCD7: '9301996',
  UCD13: '3400893019962',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE BGA 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3797766',
  CIP13: '3400937977661',
  ucdLib: "AMLODIPINE BGA 5MG GELU",
  UCD7: '9302004',
  UCD13: '3400893020043',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE BGA 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3797772',
  CIP13: '3400937977722',
  ucdLib: "AMLODIPINE BGA 5MG GELU",
  UCD7: '9302004',
  UCD13: '3400893020043',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE BGA 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3794495',
  CIP13: '3400937944953',
  ucdLib: "AMLODIPINE EG 10MG GELU",
  UCD7: '9302010',
  UCD13: '3400893020104',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE EG 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3794489',
  CIP13: '3400937944892',
  ucdLib: "AMLODIPINE EG 5MG GELU",
  UCD7: '9302027',
  UCD13: '3400893020272',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE EG 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3823512',
  CIP13: '3400938235128',
  ucdLib: "AMLODIPINE PFZ 10MG GELU",
  UCD7: '9329322',
  UCD13: '3400893293225',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE PFZ 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3823529',
  CIP13: '3400938235296',
  ucdLib: "AMLODIPINE PFZ 5MG GELU",
  UCD7: '9329339',
  UCD13: '3400893293393',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE PFZ 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3791605',
  CIP13: '3400937916059',
  ucdLib: "AMLODIPINE RBX 10MG GELU",
  UCD7: '9302033',
  UCD13: '3400893020333',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE RBX 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3791611',
  CIP13: '3400937916110',
  ucdLib: "AMLODIPINE RBX 10MG GELU",
  UCD7: '9302033',
  UCD13: '3400893020333',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE RBX 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3791580',
  CIP13: '3400937915809',
  ucdLib: "AMLODIPINE RBX 5MG GELU",
  UCD7: '9302056',
  UCD13: '3400893020562',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE RBX 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3791597',
  CIP13: '3400937915977',
  ucdLib: "AMLODIPINE RBX 5MG GELU",
  UCD7: '9302056',
  UCD13: '3400893020562',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE RBX 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3784545',
  CIP13: '3400937845458',
  ucdLib: "AMLODIPINE SDZ 10MG GELU",
  UCD7: '9297987',
  UCD13: '3400892979878',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE SDZ 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3784551',
  CIP13: '3400937845519',
  ucdLib: "AMLODIPINE SDZ 10MG GELU",
  UCD7: '9297987',
  UCD13: '3400892979878',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE SDZ 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3784404',
  CIP13: '3400937844048',
  ucdLib: "AMLODIPINE SDZ 5MG GELU",
  UCD7: '9297993',
  UCD13: '3400892979939',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE SDZ 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3784410',
  CIP13: '3400937844109',
  ucdLib: "AMLODIPINE SDZ 5MG GELU",
  UCD7: '9297993',
  UCD13: '3400892979939',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE SDZ 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3774363',
  CIP13: '3400937743631',
  ucdLib: "AMLODIPINE TVC 10MG GELU",
  UCD7: '9286601',
  UCD13: '3400892866017',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE TVC 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3774357',
  CIP13: '3400937743570',
  ucdLib: "AMLODIPINE TVC 5MG GELU",
  UCD7: '9286618',
  UCD13: '3400892866185',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE TVC 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3771235',
  CIP13: '3400937712354',
  ucdLib: "AMLODIPINE ZEN 10MG GELU",
  UCD7: '9294799',
  UCD13: '3400892947990',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ZEN 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3771264',
  CIP13: '3400937712644',
  ucdLib: "AMLODIPINE ZEN 5MG GELU",
  UCD7: '9294807',
  UCD13: '3400892948072',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ZEN 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3792800',
  CIP13: '3400937928007',
  ucdLib: "AMLODIPINE ZYD 10MG GELU",
  UCD7: '9302062',
  UCD13: '3400893020623',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ZYD 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3792817',
  CIP13: '3400937928175',
  ucdLib: "AMLODIPINE ZYD 10MG GELU",
  UCD7: '9302062',
  UCD13: '3400893020623',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ZYD 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3791568',
  CIP13: '3400937915687',
  ucdLib: "AMLODIPINE ZYD 5MG GELU",
  UCD7: '9302079',
  UCD13: '3400893020791',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ZYD 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3791574',
  CIP13: '3400937915748',
  ucdLib: "AMLODIPINE ZYD 5MG GELU",
  UCD7: '9302079',
  UCD13: '3400893020791',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ZYD 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3755940',
  CIP13: '3400937559409',
  ucdLib: "AMLODIPINE ARG 10MG GELU",
  UCD7: '9291588',
  UCD13: '3400892915883',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ARG 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3755963',
  CIP13: '3400937559638',
  ucdLib: "AMLODIPINE ARG 10MG GELU",
  UCD7: '9291588',
  UCD13: '3400892915883',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ARG 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3873237',
  CIP13: '3400938732375',
  ucdLib: "AMLODIPINE ARG 10MG GELU",
  UCD7: '9291588',
  UCD13: '3400892915883',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ARG 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3755992',
  CIP13: '3400937559928',
  ucdLib: "AMLODIPINE ARG 5MG GELU",
  UCD7: '9291594',
  UCD13: '3400892915944',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ARG 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3873214',
  CIP13: '3400938732146',
  ucdLib: "AMLODIPINE ARG 5MG GELU",
  UCD7: '9291594',
  UCD13: '3400892915944',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ARG 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3807364',
  CIP13: '3400938073645',
  ucdLib: "AMLODIPINE ARW 10MG GELU",
  UCD7: '9301967',
  UCD13: '3400893019672',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ARW 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3807358',
  CIP13: '3400938073584',
  ucdLib: "AMLODIPINE ARW 5MG GELU",
  UCD7: '9301973',
  UCD13: '3400893019733',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ARW 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3750109',
  CIP13: '3400937501095',
  ucdLib: "AMLODIPINE EVO 10MG GELU",
  UCD7: '9290034',
  UCD13: '3400892900346',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE EVO 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3750115',
  CIP13: '3400937501156',
  ucdLib: "AMLODIPINE EVO 10MG GELU",
  UCD7: '9290034',
  UCD13: '3400892900346',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE EVO 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3750121',
  CIP13: '3400937501217',
  ucdLib: "AMLODIPINE EVO 5MG GELU",
  UCD7: '9290040',
  UCD13: '3400892900407',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE EVO 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3750138',
  CIP13: '3400937501385',
  ucdLib: "AMLODIPINE EVO 5MG GELU",
  UCD7: '9290040',
  UCD13: '3400892900407',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE EVO 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3734990',
  CIP13: '3400937349901',
  ucdLib: "AMLODIPINE TVC 10MG GELU",
  UCD7: '9286601',
  UCD13: '3400892866017',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE TVC 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3734955',
  CIP13: '3400937349550',
  ucdLib: "AMLODIPINE TVC 5MG GELU",
  UCD7: '9286618',
  UCD13: '3400892866185',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE TVC 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3967518',
  CIP13: '3400939675183',
  ucdLib: "AMLODIPINE CRT 10MG GELU",
  UCD7: '9341458',
  UCD13: '3400893414583',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE CRT 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3967524',
  CIP13: '3400939675244',
  ucdLib: "AMLODIPINE CRT 10MG GELU",
  UCD7: '9341458',
  UCD13: '3400893414583',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE CRT 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3967464',
  CIP13: '3400939674643',
  ucdLib: "AMLODIPINE CRT 5MG GELU",
  UCD7: '9341464',
  UCD13: '3400893414644',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE CRT 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '3967470',
  CIP13: '3400939674704',
  ucdLib: "AMLODIPINE CRT 5MG GELU",
  UCD7: '9341464',
  UCD13: '3400893414644',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE CRT 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '4972450',
  CIP13: '3400949724505',
  ucdLib: "AMLODIPINE ISD 10MG GELU",
  UCD7: '9362963',
  UCD13: '3400893629635',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ISD 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '4972473',
  CIP13: '3400949724734',
  ucdLib: "AMLODIPINE ISD 10MG GELU",
  UCD7: '9362963',
  UCD13: '3400893629635',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ISD 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '4972390',
  CIP13: '3400949723904',
  ucdLib: "AMLODIPINE ISD 5MG GELU",
  UCD7: '9362986',
  UCD13: '3400893629864',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE ISD 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '4972421',
  CIP13: '3400949724215',
  ucdLib: "AMLODIPINE ISD 5MG GELU",
  UCD7: '9362986',
  UCD13: '3400893629864',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE ISD 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '4942271',
  CIP13: '3400949422715',
  ucdLib: "AMLODIPINE PHR 10MG GELU",
  UCD7: '9362609',
  UCD13: '3400893626092',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE PHR 10MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '4942207',
  CIP13: '3400949422074',
  ucdLib: "AMLODIPINE PHR 5MG GELU",
  UCD7: '9362615',
  UCD13: '3400893626153',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLODIPINE PHR 5MG GELU BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '4942242',
  CIP13: '3400949422425',
  ucdLib: "AMLODIPINE PHR 5MG GELU",
  UCD7: '9362615',
  UCD13: '3400893626153',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE PHR 5MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '2661852',
  CIP13: '3400926618520',
  ucdLib: "AMLODIPINE RATIO 10MG GELU",
  UCD7: '9389956',
  UCD13: '3400893899564',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLODIPINE RATIO 10MG GELU BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '4902722',
  CIP13: '3400949027224',
  ucdLib: "AMLOR 5MG GELU AIP BBA LT",
  UCD7: '9404325',
  UCD13: '3400894043256',
  ucdQtyMultiplicator: 30,
  cipLib: "AMLOR 5MG GELU AIP BBA LT BT 30",
  atcCode: "C08CA01"
}, {
  CIP7: '4902739',
  CIP13: '3400949027392',
  ucdLib: "AMLOR 5MG GELU AIP BBA LT",
  UCD7: '9404325',
  UCD13: '3400894043256',
  ucdQtyMultiplicator: 90,
  cipLib: "AMLOR 5MG GELU AIP BBA LT BT 90",
  atcCode: "C08CA01"
}, {
  CIP7: '3714993',
  CIP13: '3400937149938',
  ucdLib: "TENORDATE GELU",
  UCD7: '9131169',
  UCD13: '3400891311693',
  ucdQtyMultiplicator: 30,
  cipLib: "TENORDATE GELU BT 30",
  atcCode: "C07FB03"
}, {
  CIP7: '3715018',
  CIP13: '3400937150187',
  ucdLib: "TENORDATE GELU",
  UCD7: '9131169',
  UCD13: '3400891311693',
  ucdQtyMultiplicator: 90,
  cipLib: "TENORDATE GELU BT 90",
  atcCode: "C07FB03"
}, {
  CIP7: '3714409',
  CIP13: '3400937144094',
  ucdLib: "LOGIMAX 5MG/47,5MG CPR",
  UCD7: '9173765',
  UCD13: '3400891737653',
  ucdQtyMultiplicator: 30,
  cipLib: "LOGIMAX 5MG/47,5MG CPR BT 30",
  atcCode: "C07FB02"
}, {
  CIP7: '3714421',
  CIP13: '3400937144216',
  ucdLib: "LOGIMAX 5MG/47,5MG CPR",
  UCD7: '9173765',
  UCD13: '3400891737653',
  ucdQtyMultiplicator: 90,
  cipLib: "LOGIMAX 5MG/47,5MG CPR BT 90",
  atcCode: "C07FB02"
}, {
  CIP7: '3220937',
  CIP13: '3400932209378',
  ucdLib: "MODUCREN CPR",
  UCD7: '9059466',
  UCD13: '3400890594660',
  ucdQtyMultiplicator: 30,
  cipLib: "MODUCREN CPR BT 30",
  atcCode: "C07DA06"
}, {
  CIP7: '3720083',
  CIP13: '3400937200837',
  ucdLib: "TENORETIC 50MG/12,5MG CPR",
  UCD7: '9126174',
  UCD13: '3400891261745',
  ucdQtyMultiplicator: 30,
  cipLib: "TENORETIC 50MG/12,5MG CPR BT 30",
  atcCode: "C07CB03"
}, {
  CIP7: '3720114',
  CIP13: '3400937201148',
  ucdLib: "TENORETIC 50MG/12,5MG CPR",
  UCD7: '9126174',
  UCD13: '3400891261745',
  ucdQtyMultiplicator: 90,
  cipLib: "TENORETIC 50MG/12,5MG CPR BT 90",
  atcCode: "C07CB03"
}, {
  CIP7: '3939634',
  CIP13: '3400939396347',
  ucdLib: "CONEBILOX 5MG/12,5MG CPR",
  UCD7: '9347521',
  UCD13: '3400893475218',
  ucdQtyMultiplicator: 30,
  cipLib: "CONEBILOX 5MG/12,5MG CPR BT 30",
  atcCode: "C07BB12"
}, {
  CIP7: '3939663',
  CIP13: '3400939396637',
  ucdLib: "CONEBILOX 5MG/12,5MG CPR",
  UCD7: '9347521',
  UCD13: '3400893475218',
  ucdQtyMultiplicator: 90,
  cipLib: "CONEBILOX 5MG/12,5MG CPR BT 90",
  atcCode: "C07BB12"
}, {
  CIP7: '3939717',
  CIP13: '3400939397177',
  ucdLib: "CONEBILOX 5MG/25MG CPR",
  UCD7: '9347538',
  UCD13: '3400893475386',
  ucdQtyMultiplicator: 30,
  cipLib: "CONEBILOX 5MG/25MG CPR BT 30",
  atcCode: "C07BB12"
}, {
  CIP7: '3939752',
  CIP13: '3400939397528',
  ucdLib: "CONEBILOX 5MG/25MG CPR",
  UCD7: '9347538',
  UCD13: '3400893475386',
  ucdQtyMultiplicator: 90,
  cipLib: "CONEBILOX 5MG/25MG CPR BT 90",
  atcCode: "C07BB12"
}, {
  CIP7: '3939769',
  CIP13: '3400939397696',
  ucdLib: "TEMERITDUO 5MG/12,5MG CPR",
  UCD7: '9347892',
  UCD13: '3400893478929',
  ucdQtyMultiplicator: 30,
  cipLib: "TEMERITDUO 5MG/12,5MG CPR BT 30",
  atcCode: "C07BB12"
}, {
  CIP7: '3939775',
  CIP13: '3400939397757',
  ucdLib: "TEMERITDUO 5MG/12,5MG CPR",
  UCD7: '9347892',
  UCD13: '3400893478929',
  ucdQtyMultiplicator: 90,
  cipLib: "TEMERITDUO 5MG/12,5MG CPR BT 90",
  atcCode: "C07BB12"
}, {
  CIP7: '3939781',
  CIP13: '3400939397818',
  ucdLib: "TEMERITDUO 5MG/25MG CPR",
  UCD7: '9347900',
  UCD13: '3400893479001',
  ucdQtyMultiplicator: 30,
  cipLib: "TEMERITDUO 5MG/25MG CPR BT 30",
  atcCode: "C07BB12"
}, {
  CIP7: '3939798',
  CIP13: '3400939397986',
  ucdLib: "TEMERITDUO 5MG/25MG CPR",
  UCD7: '9347900',
  UCD13: '3400893479001',
  ucdQtyMultiplicator: 90,
  cipLib: "TEMERITDUO 5MG/25MG CPR BT 90",
  atcCode: "C07BB12"
}, {
  CIP7: '3617391',
  CIP13: '3400936173910',
  ucdLib: "BISOPROL/HYD.SDZ 10/6,25 CPR",
  UCD7: '9353148',
  UCD13: '3400893531488',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.SDZ 10/6,25 CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3617445',
  CIP13: '3400936174450',
  ucdLib: "BISOPROL/HYD.SDZ 10/6,25 CPR",
  UCD7: '9353148',
  UCD13: '3400893531488',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.SDZ 10/6,25 CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3615305',
  CIP13: '3400936153059',
  ucdLib: "BISOPROL/HYD.SDZ 5/6,25MG C.",
  UCD7: '9353160',
  UCD13: '3400893531600',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.SDZ 5/6,25MG C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3616842',
  CIP13: '3400936168428',
  ucdLib: "BISOPROL/HYD.SDZ 5/6,25MG C.",
  UCD7: '9353160',
  UCD13: '3400893531600',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.SDZ 5/6,25MG C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3607872',
  CIP13: '3400936078727',
  ucdLib: "BISOPROL/HYD.ARW 10/6,25 CPR",
  UCD7: '9350598',
  UCD13: '3400893505984',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.ARW 10/6,25 CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3609397',
  CIP13: '3400936093973',
  ucdLib: "BISOPROL/HYD.ARW 10/6,25 CPR",
  UCD7: '9350598',
  UCD13: '3400893505984',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.ARW 10/6,25 CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3603897',
  CIP13: '3400936038974',
  ucdLib: "BISOPROL/HYD.ARW 2,5/6,25 C.",
  UCD7: '9350606',
  UCD13: '3400893506066',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.ARW 2,5/6,25 C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3605347',
  CIP13: '3400936053472',
  ucdLib: "BISOPROL/HYD.ARW 2,5/6,25 C.",
  UCD7: '9350606',
  UCD13: '3400893506066',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.ARW 2,5/6,25 C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3605436',
  CIP13: '3400936054363',
  ucdLib: "BISOPROL/HYD.ARW 5/6,25MG C.",
  UCD7: '9350612',
  UCD13: '3400893506127',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.ARW 5/6,25MG C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3607547',
  CIP13: '3400936075474',
  ucdLib: "BISOPROL/HYD.ARW 5/6,25MG C.",
  UCD7: '9350612',
  UCD13: '3400893506127',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.ARW 5/6,25MG C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3609776',
  CIP13: '3400936097766',
  ucdLib: "BISOPROL/HYD.SDZ 2,5/6,25 C.",
  UCD7: '9353154',
  UCD13: '3400893531549',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.SDZ 2,5/6,25 C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3609813',
  CIP13: '3400936098138',
  ucdLib: "BISOPROL/HYD.SDZ 2,5/6,25 C.",
  UCD7: '9353154',
  UCD13: '3400893531549',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.SDZ 2,5/6,25 C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3620826',
  CIP13: '3400936208261',
  ucdLib: "BISOPROL/HYD.EG 2,5/6,25 CPR",
  UCD7: '9352657',
  UCD13: '3400893526576',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.EG 2,5/6,25 CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3627461',
  CIP13: '3400936274617',
  ucdLib: "BISOPROL/HYD.EG 2,5/6,25 CPR",
  UCD7: '9352657',
  UCD13: '3400893526576',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.EG 2,5/6,25 CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3627998',
  CIP13: '3400936279988',
  ucdLib: "BISOPROL/HYD.EG 5/6,25MG CPR",
  UCD7: '9352663',
  UCD13: '3400893526637',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.EG 5/6,25MG CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3628035',
  CIP13: '3400936280359',
  ucdLib: "BISOPROL/HYD.EG 5/6,25MG CPR",
  UCD7: '9352663',
  UCD13: '3400893526637',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.EG 5/6,25MG CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3630931',
  CIP13: '3400936309319',
  ucdLib: "BISOPROL/HYD.EG 10/6,25 CPR",
  UCD7: '9352640',
  UCD13: '3400893526408',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.EG 10/6,25 CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3636336',
  CIP13: '3400936363366',
  ucdLib: "BISOPROL/HYD.EG 10/6,25 CPR",
  UCD7: '9352640',
  UCD13: '3400893526408',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.EG 10/6,25 CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3822464',
  CIP13: '3400938224641',
  ucdLib: "BISOPROL/HYD.TVC 10/6,25 CPR",
  UCD7: '9308768',
  UCD13: '3400893087688',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.TVC 10/6,25 CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3822168',
  CIP13: '3400938221688',
  ucdLib: "BISOPROL/HYD.TVC 2,5/6,25 C.",
  UCD7: '9308774',
  UCD13: '3400893087749',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.TVC 2,5/6,25 C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3822369',
  CIP13: '3400938223699',
  ucdLib: "BISOPROL/HYD.TVC 5/6,25MG C.",
  UCD7: '9308780',
  UCD13: '3400893087800',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.TVC 5/6,25MG C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3922421',
  CIP13: '3400939224213',
  ucdLib: "BISOPROL/HYD.BGA 10/6,25 CPR",
  UCD7: '9334151',
  UCD13: '3400893341513',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.BGA 10/6,25 CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3922450',
  CIP13: '3400939224503',
  ucdLib: "BISOPROL/HYD.BGA 10/6,25 CPR",
  UCD7: '9334151',
  UCD13: '3400893341513',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.BGA 10/6,25 CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3922295',
  CIP13: '3400939222950',
  ucdLib: "BISOPROL/HYD.BGA 2,5/6,25 C.",
  UCD7: '9334168',
  UCD13: '3400893341681',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.BGA 2,5/6,25 C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3922332',
  CIP13: '3400939223322',
  ucdLib: "BISOPROL/HYD.BGA 2,5/6,25 C.",
  UCD7: '9334168',
  UCD13: '3400893341681',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.BGA 2,5/6,25 C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3922361',
  CIP13: '3400939223612',
  ucdLib: "BISOPROL/HYD.BGA 5/6,25MG C.",
  UCD7: '9334174',
  UCD13: '3400893341742',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.BGA 5/6,25MG C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3922390',
  CIP13: '3400939223902',
  ucdLib: "BISOPROL/HYD.BGA 5/6,25MG C.",
  UCD7: '9334174',
  UCD13: '3400893341742',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.BGA 5/6,25MG C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3881662',
  CIP13: '3400938816624',
  ucdLib: "BISOPROL/HYD.TVC 10/6,25 CPR",
  UCD7: '9308768',
  UCD13: '3400893087688',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.TVC 10/6,25 CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3881633',
  CIP13: '3400938816334',
  ucdLib: "BISOPROL/HYD.TVC 2,5/6,25 C.",
  UCD7: '9308774',
  UCD13: '3400893087749',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.TVC 2,5/6,25 C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3881656',
  CIP13: '3400938816563',
  ucdLib: "BISOPROL/HYD.TVC 5/6,25MG C.",
  UCD7: '9308780',
  UCD13: '3400893087800',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.TVC 5/6,25MG C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3869738',
  CIP13: '3400938697384',
  ucdLib: "LODOZ 10MG/6,25MG CPR",
  UCD7: '9214777',
  UCD13: '3400892147772',
  ucdQtyMultiplicator: 30,
  cipLib: "LODOZ 10MG/6,25MG CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3869767',
  CIP13: '3400938697674',
  ucdLib: "LODOZ 10MG/6,25MG CPR",
  UCD7: '9214777',
  UCD13: '3400892147772',
  ucdQtyMultiplicator: 90,
  cipLib: "LODOZ 10MG/6,25MG CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3869632',
  CIP13: '3400938696325',
  ucdLib: "LODOZ 2,5MG/6,25MG CPR",
  UCD7: '9214530',
  UCD13: '3400892145303',
  ucdQtyMultiplicator: 30,
  cipLib: "LODOZ 2,5MG/6,25MG CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3869661',
  CIP13: '3400938696615',
  ucdLib: "LODOZ 2,5MG/6,25MG CPR",
  UCD7: '9214530',
  UCD13: '3400892145303',
  ucdQtyMultiplicator: 90,
  cipLib: "LODOZ 2,5MG/6,25MG CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3869684',
  CIP13: '3400938696844',
  ucdLib: "LODOZ 5MG/6,25MG CPR",
  UCD7: '9214783',
  UCD13: '3400892147833',
  ucdQtyMultiplicator: 30,
  cipLib: "LODOZ 5MG/6,25MG CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3869715',
  CIP13: '3400938697155',
  ucdLib: "LODOZ 5MG/6,25MG CPR",
  UCD7: '9214783',
  UCD13: '3400892147833',
  ucdQtyMultiplicator: 90,
  cipLib: "LODOZ 5MG/6,25MG CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3887305',
  CIP13: '3400938873054',
  ucdLib: "WYTENS 10MG/6,25MG CPR",
  UCD7: '9203555',
  UCD13: '3400892035550',
  ucdQtyMultiplicator: 30,
  cipLib: "WYTENS 10MG/6,25MG CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3887191',
  CIP13: '3400938871913',
  ucdLib: "WYTENS 2,5MG/6,25MG CPR",
  UCD7: '9203561',
  UCD13: '3400892035611',
  ucdQtyMultiplicator: 30,
  cipLib: "WYTENS 2,5MG/6,25MG CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3887251',
  CIP13: '3400938872514',
  ucdLib: "WYTENS 5MG/6,25MG CPR",
  UCD7: '9203578',
  UCD13: '3400892035789',
  ucdQtyMultiplicator: 30,
  cipLib: "WYTENS 5MG/6,25MG CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '2196817',
  CIP13: '3400921968170',
  ucdLib: "BISOPROL/HYD.CRT 10/6,25 CPR",
  UCD7: '9407186',
  UCD13: '3400894071860',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.CRT 10/6,25 CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '2196852',
  CIP13: '3400921968521',
  ucdLib: "BISOPROL/HYD.CRT 10/6,25 CPR",
  UCD7: '9407186',
  UCD13: '3400894071860',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.CRT 10/6,25 CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '2196912',
  CIP13: '3400921969122',
  ucdLib: "BISOPROL/HYD.CRT 2,5/6,25 C.",
  UCD7: '9407192',
  UCD13: '3400894071921',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.CRT 2,5/6,25 C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '2196941',
  CIP13: '3400921969412',
  ucdLib: "BISOPROL/HYD.CRT 2,5/6,25 C.",
  UCD7: '9407192',
  UCD13: '3400894071921',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.CRT 2,5/6,25 C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '2196869',
  CIP13: '3400921968699',
  ucdLib: "BISOPROL/HYD.CRT 5/6,25MG C.",
  UCD7: '9407200',
  UCD13: '3400894072003',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.CRT 5/6,25MG C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '2196898',
  CIP13: '3400921968989',
  ucdLib: "BISOPROL/HYD.CRT 5/6,25MG C.",
  UCD7: '9407200',
  UCD13: '3400894072003',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.CRT 5/6,25MG C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3989112',
  CIP13: '3400939891125',
  ucdLib: "BISOPROL/HYD.ZEN 10/6,25 CPR",
  UCD7: '9345309',
  UCD13: '3400893453094',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.ZEN 10/6,25 CPR BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3989141',
  CIP13: '3400939891415',
  ucdLib: "BISOPROL/HYD.ZEN 10/6,25 CPR",
  UCD7: '9345309',
  UCD13: '3400893453094',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.ZEN 10/6,25 CPR BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3989299',
  CIP13: '3400939892993',
  ucdLib: "BISOPROL/HYD.ZEN 2,5/6,25 C.",
  UCD7: '9345315',
  UCD13: '3400893453155',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.ZEN 2,5/6,25 C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3989336',
  CIP13: '3400939893365',
  ucdLib: "BISOPROL/HYD.ZEN 2,5/6,25 C.",
  UCD7: '9345315',
  UCD13: '3400893453155',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.ZEN 2,5/6,25 C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3989201',
  CIP13: '3400939892016',
  ucdLib: "BISOPROL/HYD.ZEN 5/6,25MG C.",
  UCD7: '9345321',
  UCD13: '3400893453216',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.ZEN 5/6,25MG C. BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '3989230',
  CIP13: '3400939892306',
  ucdLib: "BISOPROL/HYD.ZEN 5/6,25MG C.",
  UCD7: '9345321',
  UCD13: '3400893453216',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.ZEN 5/6,25MG C. BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '2234713',
  CIP13: '3400922347134',
  ucdLib: "BISOPROL/HYD.MYP 10/6,25",
  UCD7: '9388862',
  UCD13: '3400893888629',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.MYP 10/6,25 BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '2234736',
  CIP13: '3400922347363',
  ucdLib: "BISOPROL/HYD.MYP 10/6,25",
  UCD7: '9388862',
  UCD13: '3400893888629',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.MYP 10/6,25 BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '2234469',
  CIP13: '3400922344690',
  ucdLib: "BISOPROL/HYD.MYP 2,5/6,25",
  UCD7: '9388879',
  UCD13: '3400893888797',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.MYP 2,5/6,25 BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '2234475',
  CIP13: '3400922344751',
  ucdLib: "BISOPROL/HYD.MYP 2,5/6,25",
  UCD7: '9388879',
  UCD13: '3400893888797',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.MYP 2,5/6,25 BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '2234587',
  CIP13: '3400922345871',
  ucdLib: "BISOPROL/HYD.MYP 5/6,25MG",
  UCD7: '9388885',
  UCD13: '3400893888858',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROL/HYD.MYP 5/6,25MG BT 30",
  atcCode: "C07BB07"
}, {
  CIP7: '2234593',
  CIP13: '3400922345932',
  ucdLib: "BISOPROL/HYD.MYP 5/6,25MG",
  UCD7: '9388885',
  UCD13: '3400893888858',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROL/HYD.MYP 5/6,25MG BT 90",
  atcCode: "C07BB07"
}, {
  CIP7: '3264544',
  CIP13: '3400932645442',
  ucdLib: "LOGROTON CPR PELLIC",
  UCD7: '9054954',
  UCD13: '3400890549547',
  ucdQtyMultiplicator: 30,
  cipLib: "LOGROTON CPR PELLIC BT 30",
  atcCode: "C07BB02"
}, {
  CIP7: '3748213',
  CIP13: '3400937482134',
  ucdLib: "LOGROTON CPR PELLIC",
  UCD7: '9054954',
  UCD13: '3400890549547',
  ucdQtyMultiplicator: 90,
  cipLib: "LOGROTON CPR PELLIC BT 90",
  atcCode: "C07BB02"
}, {
  CIP7: '3683117',
  CIP13: '3400936831179',
  ucdLib: "CARVEDILOL MYL 6,25MG CPR",
  UCD7: '9285702',
  UCD13: '3400892857022',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL MYL 6,25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3705209',
  CIP13: '3400937052092',
  ucdLib: "CARVEDILOL BGA 12,5MG CPR",
  UCD7: '9282974',
  UCD13: '3400892829746',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL BGA 12,5MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3705215',
  CIP13: '3400937052153',
  ucdLib: "CARVEDILOL BGA 25MG CPR",
  UCD7: '9282980',
  UCD13: '3400892829807',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL BGA 25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3705190',
  CIP13: '3400937051903',
  ucdLib: "CARVEDILOL BGA 6,25MG CPR",
  UCD7: '9283005',
  UCD13: '3400892830056',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL BGA 6,25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3740536',
  CIP13: '3400937405362',
  ucdLib: "CARVEDILOL MYL 12,5MG CPR",
  UCD7: '9285688',
  UCD13: '3400892856889',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL MYL 12,5MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3740594',
  CIP13: '3400937405942',
  ucdLib: "CARVEDILOL MYL 25MG CPR",
  UCD7: '9285694',
  UCD13: '3400892856940',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL MYL 25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3767630',
  CIP13: '3400937676304',
  ucdLib: "CARVEDILOL ZEN 12,5MG CPR",
  UCD7: '9293854',
  UCD13: '3400892938547',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL ZEN 12,5MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3767707',
  CIP13: '3400937677073',
  ucdLib: "CARVEDILOL ZEN 25MG CPR",
  UCD7: '9293860',
  UCD13: '3400892938608',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL ZEN 25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3767587',
  CIP13: '3400937675871',
  ucdLib: "CARVEDILOL ZEN 6,25MG CPR",
  UCD7: '9293883',
  UCD13: '3400892938837',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL ZEN 6,25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3772341',
  CIP13: '3400937723411',
  ucdLib: "CARVEDILOL TVC 25MG CPR",
  UCD7: '9296456',
  UCD13: '3400892964560',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL TVC 25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3880059',
  CIP13: '3400938800593',
  ucdLib: "CARVEDILOL EG 12,5MG CPR",
  UCD7: '9323609',
  UCD13: '3400893236093',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL EG 12,5MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3880131',
  CIP13: '3400938801316',
  ucdLib: "CARVEDILOL EG 25MG CPR",
  UCD7: '9323615',
  UCD13: '3400893236154',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL EG 25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3879961',
  CIP13: '3400938799613',
  ucdLib: "CARVEDILOL EG 6,25MG CPR",
  UCD7: '9323621',
  UCD13: '3400893236215',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL EG 6,25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '4152959',
  CIP13: '3400941529597',
  ucdLib: "CARVEDILOL TVC 12,5MG CPR",
  UCD7: '9369646',
  UCD13: '3400893696460',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL TVC 12,5MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '4152936',
  CIP13: '3400941529368',
  ucdLib: "CARVEDILOL TVC 6,25MG CPR",
  UCD7: '9369669',
  UCD13: '3400893696699',
  ucdQtyMultiplicator: 28,
  cipLib: "CARVEDILOL TVC 6,25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3423474',
  CIP13: '3400934234743',
  ucdLib: "KREDEX 12,5MG CPR",
  UCD7: '9194537',
  UCD13: '3400891945379',
  ucdQtyMultiplicator: 28,
  cipLib: "KREDEX 12,5MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3426395',
  CIP13: '3400934263958',
  ucdLib: "KREDEX 25MG CPR",
  UCD7: '9194543',
  UCD13: '3400891945430',
  ucdQtyMultiplicator: 28,
  cipLib: "KREDEX 25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3423445',
  CIP13: '3400934234453',
  ucdLib: "KREDEX 6,25MG CPR",
  UCD7: '9194566',
  UCD13: '3400891945669',
  ucdQtyMultiplicator: 28,
  cipLib: "KREDEX 6,25MG CPR BT 28",
  atcCode: "C07AG02"
}, {
  CIP7: '3226526',
  CIP13: '3400932265268',
  ucdLib: "TRANDATE 200MG CPR",
  UCD7: '9094221',
  UCD13: '3400890942218',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANDATE 200MG CPR BT 30",
  atcCode: "C07AG01"
}, {
  CIP7: '3748236',
  CIP13: '3400937482363',
  ucdLib: "TRANDATE 200MG CPR",
  UCD7: '9094221',
  UCD13: '3400890942218',
  ucdQtyMultiplicator: 180,
  cipLib: "TRANDATE 200MG CPR BT 180",
  atcCode: "C07AG01"
}, {
  CIP7: '5524943',
  CIP13: '3400955249436',
  ucdLib: "TRANDATE 5MG/ML INJ AMP20ML",
  UCD7: '9094209',
  UCD13: '3400890942096',
  ucdQtyMultiplicator: 5,
  cipLib: "TRANDATE 5MG/ML INJ AMP20ML BT 5",
  atcCode: "C07AG01"
}, {
  CIP7: '3836650',
  CIP13: '3400938366501',
  ucdLib: "NEBIVOLOL SDZ 5MG CPR",
  UCD7: '9313930',
  UCD13: '3400893139301',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL SDZ 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3836710',
  CIP13: '3400938367102',
  ucdLib: "NEBIVOLOL SDZ 5MG CPR",
  UCD7: '9313930',
  UCD13: '3400893139301',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL SDZ 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '4989976',
  CIP13: '3400949899760',
  ucdLib: "NEBIVOLOL ISD 5MG CPR",
  UCD7: '9368061',
  UCD13: '3400893680612',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL ISD 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3742073',
  CIP13: '3400937420730',
  ucdLib: "NEBILOX 5MG CPR",
  UCD7: '9262799',
  UCD13: '3400892627991',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBILOX 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3742096',
  CIP13: '3400937420969',
  ucdLib: "NEBILOX 5MG CPR",
  UCD7: '9262799',
  UCD13: '3400892627991',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBILOX 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3742038',
  CIP13: '3400937420389',
  ucdLib: "TEMERIT 5MG CPR",
  UCD7: '9259981',
  UCD13: '3400892599816',
  ucdQtyMultiplicator: 30,
  cipLib: "TEMERIT 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3742044',
  CIP13: '3400937420440',
  ucdLib: "TEMERIT 5MG CPR",
  UCD7: '9259981',
  UCD13: '3400892599816',
  ucdQtyMultiplicator: 90,
  cipLib: "TEMERIT 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3751451',
  CIP13: '3400937514514',
  ucdLib: "NEBIVOLOL ARW 5MG CPR",
  UCD7: '9351149',
  UCD13: '3400893511497',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL ARW 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3751497',
  CIP13: '3400937514972',
  ucdLib: "NEBIVOLOL ARW 5MG CPR",
  UCD7: '9351149',
  UCD13: '3400893511497',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL ARW 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3807306',
  CIP13: '3400938073065',
  ucdLib: "NEBIVOLOL EG 5MG CPR",
  UCD7: '9308047',
  UCD13: '3400893080474',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL EG 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3807335',
  CIP13: '3400938073355',
  ucdLib: "NEBIVOLOL EG 5MG CPR",
  UCD7: '9308047',
  UCD13: '3400893080474',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL EG 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3876980',
  CIP13: '3400938769807',
  ucdLib: "NEBIVOLOL ZEN 5MG CPR",
  UCD7: '9322550',
  UCD13: '3400893225509',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL ZEN 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3877175',
  CIP13: '3400938771756',
  ucdLib: "NEBIVOLOL ZEN 5MG CPR",
  UCD7: '9322550',
  UCD13: '3400893225509',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL ZEN 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3974091',
  CIP13: '3400939740911',
  ucdLib: "NEBIVOLOL BGA 5MG CPR",
  UCD7: '9346881',
  UCD13: '3400893468814',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL BGA 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3974145',
  CIP13: '3400939741451',
  ucdLib: "NEBIVOLOL BGA 5MG CPR",
  UCD7: '9346881',
  UCD13: '3400893468814',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL BGA 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3932916',
  CIP13: '3400939329161',
  ucdLib: "NEBIVOLOL MYL 5MG CPR",
  UCD7: '9340157',
  UCD13: '3400893401576',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL MYL 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3932968',
  CIP13: '3400939329680',
  ucdLib: "NEBIVOLOL MYL 5MG CPR",
  UCD7: '9340157',
  UCD13: '3400893401576',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL MYL 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3937492',
  CIP13: '3400939374925',
  ucdLib: "NEBIVOLOL RBX 5MG CPR",
  UCD7: '9346906',
  UCD13: '3400893469064',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL RBX 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3937523',
  CIP13: '3400939375236',
  ucdLib: "NEBIVOLOL RBX 5MG CPR",
  UCD7: '9346906',
  UCD13: '3400893469064',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL RBX 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3968311',
  CIP13: '3400939683119',
  ucdLib: "NEBIVOLOL TVS 5MG CPR",
  UCD7: '9345367',
  UCD13: '3400893453674',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL TVS 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3968363',
  CIP13: '3400939683638',
  ucdLib: "NEBIVOLOL TVS 5MG CPR",
  UCD7: '9345367',
  UCD13: '3400893453674',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL TVS 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3982802',
  CIP13: '3400939828022',
  ucdLib: "NEBIVOLOL ACT 5MG CPR",
  UCD7: '9346869',
  UCD13: '3400893468692',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL ACT 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3982831',
  CIP13: '3400939828312',
  ucdLib: "NEBIVOLOL ACT 5MG CPR",
  UCD7: '9346869',
  UCD13: '3400893468692',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL ACT 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3982920',
  CIP13: '3400939829203',
  ucdLib: "NEBIVOLOL ACT 5MG CPR",
  UCD7: '9346869',
  UCD13: '3400893468692',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL ACT 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3982989',
  CIP13: '3400939829890',
  ucdLib: "NEBIVOLOL CRT 5MG CPR",
  UCD7: '9346912',
  UCD13: '3400893469125',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL CRT 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3983026',
  CIP13: '3400939830261',
  ucdLib: "NEBIVOLOL CRT 5MG CPR",
  UCD7: '9346912',
  UCD13: '3400893469125',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL CRT 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3983351',
  CIP13: '3400939833514',
  ucdLib: "NEBIVOLOL EVO 5MG CPR",
  UCD7: '9346875',
  UCD13: '3400893468753',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL EVO 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3983380',
  CIP13: '3400939833804',
  ucdLib: "NEBIVOLOL EVO 5MG CPR",
  UCD7: '9346875',
  UCD13: '3400893468753',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL EVO 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '3983150',
  CIP13: '3400939831503',
  ucdLib: "NEBIVOLOL ZYD 5MG CPR",
  UCD7: '9346852',
  UCD13: '3400893468524',
  ucdQtyMultiplicator: 30,
  cipLib: "NEBIVOLOL ZYD 5MG CPR BT 30",
  atcCode: "C07AB12"
}, {
  CIP7: '3983196',
  CIP13: '3400939831961',
  ucdLib: "NEBIVOLOL ZYD 5MG CPR",
  UCD7: '9346852',
  UCD13: '3400893468524',
  ucdQtyMultiplicator: 90,
  cipLib: "NEBIVOLOL ZYD 5MG CPR BT 90",
  atcCode: "C07AB12"
}, {
  CIP7: '5566114',
  CIP13: '3400955661146',
  ucdLib: "BREVIBLOC 100MG INJ FV10ML",
  UCD7: '9138875',
  UCD13: '3400891388756',
  ucdQtyMultiplicator: 5,
  cipLib: "BREVIBLOC 100MG INJ FV10ML BT 5",
  atcCode: "C07AB09"
}, {
  CIP7: '5635447',
  CIP13: '3400956354474',
  ucdLib: "BREVIBLOC 10MG/ML INJ P.250ML",
  UCD7: '9240792',
  UCD13: '3400892407920',
  ucdQtyMultiplicator: 1,
  cipLib: "BREVIBLOC 10MG/ML INJ P.250ML BT 1",
  atcCode: "C07AB09"
}, {
  CIP7: '5709571',
  CIP13: '3400957095710',
  ucdLib: "ESMOCARD 100MG INJ FL10ML",
  UCD7: '9306692',
  UCD13: '3400893066928',
  ucdQtyMultiplicator: 5,
  cipLib: "ESMOCARD 100MG INJ FL10ML BT 5",
  atcCode: "C07AB09"
}, {
  CIP7: '3614145',
  CIP13: '3400936141452',
  ucdLib: "CELIPROLOL TVC 200MG CPR",
  UCD7: '9244844',
  UCD13: '3400892448442',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL TVC 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3293505',
  CIP13: '3400932935055',
  ucdLib: "CELECTOL 200MG CPR",
  UCD7: '9126300',
  UCD13: '3400891263008',
  ucdQtyMultiplicator: 28,
  cipLib: "CELECTOL 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3577289',
  CIP13: '3400935772893',
  ucdLib: "CELIPROLOL ARW 200MG CPR",
  UCD7: '9235503',
  UCD13: '3400892355030',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL ARW 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3577295',
  CIP13: '3400935772954',
  ucdLib: "CELIPROLOL MYL 200MG CPR",
  UCD7: '9234455',
  UCD13: '3400892344553',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL MYL 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3685346',
  CIP13: '3400936853461',
  ucdLib: "CELIPROLOL RBX 200MG CPR",
  UCD7: '9277370',
  UCD13: '3400892773704',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL RBX 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3652447',
  CIP13: '3400936524477',
  ucdLib: "CELIPROLOL ACT 200MG CPR",
  UCD7: '9267006',
  UCD13: '3400892670065',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL ACT 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3583597',
  CIP13: '3400935835970',
  ucdLib: "CELIPROLOL BGA 200MG CPR",
  UCD7: '9235242',
  UCD13: '3400892352428',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL BGA 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3583657',
  CIP13: '3400935836571',
  ucdLib: "CELIPROLOL CRT 200MG CPR",
  UCD7: '9247989',
  UCD13: '3400892479897',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL CRT 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3583611',
  CIP13: '3400935836113',
  ucdLib: "CELIPROLOL EG 200MG CPR",
  UCD7: '9235259',
  UCD13: '3400892352596',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL EG 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3583700',
  CIP13: '3400935837004',
  ucdLib: "CELIPROLOL ZYD 200MG CPR",
  UCD7: '9237502',
  UCD13: '3400892375021',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL ZYD 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3723934',
  CIP13: '3400937239349',
  ucdLib: "CELECTOL 200MG CPR",
  UCD7: '9126300',
  UCD13: '3400891263008',
  ucdQtyMultiplicator: 84,
  cipLib: "CELECTOL 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3762549',
  CIP13: '3400937625494',
  ucdLib: "CELIPROLOL EG 200MG CPR",
  UCD7: '9235259',
  UCD13: '3400892352596',
  ucdQtyMultiplicator: 84,
  cipLib: "CELIPROLOL EG 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3728742',
  CIP13: '3400937287425',
  ucdLib: "CELIPROLOL TVC 200MG CPR",
  UCD7: '9244844',
  UCD13: '3400892448442',
  ucdQtyMultiplicator: 84,
  cipLib: "CELIPROLOL TVC 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3784752',
  CIP13: '3400937847520',
  ucdLib: "CELIPROLOL BGA 200MG CPR",
  UCD7: '9235242',
  UCD13: '3400892352428',
  ucdQtyMultiplicator: 84,
  cipLib: "CELIPROLOL BGA 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3781239',
  CIP13: '3400937812399',
  ucdLib: "CELIPROLOL SDZ 200MG CPR",
  UCD7: '9263847',
  UCD13: '3400892638478',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL SDZ 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3712474',
  CIP13: '3400937124744',
  ucdLib: "CELIPROLOL ZYD 200MG CPR",
  UCD7: '9237502',
  UCD13: '3400892375021',
  ucdQtyMultiplicator: 90,
  cipLib: "CELIPROLOL ZYD 200MG CPR BT 90",
  atcCode: "C07AB08"
}, {
  CIP7: '3757666',
  CIP13: '3400937576666',
  ucdLib: "CELIPROLOL ALM 200MG CPR",
  UCD7: '9292122',
  UCD13: '3400892921228',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL ALM 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3739711',
  CIP13: '3400937397117',
  ucdLib: "CELIPROLOL ARW 200MG CPR",
  UCD7: '9235503',
  UCD13: '3400892355030',
  ucdQtyMultiplicator: 84,
  cipLib: "CELIPROLOL ARW 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3736641',
  CIP13: '3400937366410',
  ucdLib: "CELIPROLOL CRT 200MG CPR",
  UCD7: '9247989',
  UCD13: '3400892479897',
  ucdQtyMultiplicator: 84,
  cipLib: "CELIPROLOL CRT 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3757347',
  CIP13: '3400937573474',
  ucdLib: "CELIPROLOL EVO 200MG CPR",
  UCD7: '9292139',
  UCD13: '3400892921396',
  ucdQtyMultiplicator: 28,
  cipLib: "CELIPROLOL EVO 200MG CPR BT 28",
  atcCode: "C07AB08"
}, {
  CIP7: '3738491',
  CIP13: '3400937384919',
  ucdLib: "CELIPROLOL MYL 200MG CPR",
  UCD7: '9234455',
  UCD13: '3400892344553',
  ucdQtyMultiplicator: 84,
  cipLib: "CELIPROLOL MYL 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3737764',
  CIP13: '3400937377645',
  ucdLib: "CELIPROLOL RBX 200MG CPR",
  UCD7: '9277370',
  UCD13: '3400892773704',
  ucdQtyMultiplicator: 84,
  cipLib: "CELIPROLOL RBX 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3731508',
  CIP13: '3400937315081',
  ucdLib: "CELIPROLOL SDZ 200MG CPR",
  UCD7: '9263847',
  UCD13: '3400892638478',
  ucdQtyMultiplicator: 84,
  cipLib: "CELIPROLOL SDZ 200MG CPR BT 84",
  atcCode: "C07AB08"
}, {
  CIP7: '3897255',
  CIP13: '3400938972559',
  ucdLib: "CELIPROLOL ZEN 200MG CPR",
  UCD7: '9332152',
  UCD13: '3400893321522',
  ucdQtyMultiplicator: 90,
  cipLib: "CELIPROLOL ZEN 200MG CPR BT 90",
  atcCode: "C07AB08"
}, {
  CIP7: '3908266',
  CIP13: '3400939082660',
  ucdLib: "CELIPROLOL ZEN 200MG CPR",
  UCD7: '9332152',
  UCD13: '3400893321522',
  ucdQtyMultiplicator: 30,
  cipLib: "CELIPROLOL ZEN 200MG CPR BT 30",
  atcCode: "C07AB08"
}, {
  CIP7: '3612436',
  CIP13: '3400936124363',
  ucdLib: "BISOPROLOL ARW 10MG CPR",
  UCD7: '9248523',
  UCD13: '3400892485232',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ARW 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3612471',
  CIP13: '3400936124714',
  ucdLib: "BISOPROLOL BGA 10MG C.PELL",
  UCD7: '9329799',
  UCD13: '3400893297995',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL BGA 10MG C.PELL BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3615156',
  CIP13: '3400936151567',
  ucdLib: "BISOPROLOL EG 10MG CPR",
  UCD7: '9248546',
  UCD13: '3400892485461',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL EG 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3612459',
  CIP13: '3400936124592',
  ucdLib: "BISOPROLOL MYL 10MG CPR",
  UCD7: '9248813',
  UCD13: '3400892488134',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL MYL 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3612531',
  CIP13: '3400936125315',
  ucdLib: "BISOPROLOL ZEN 10MG CPR",
  UCD7: '9246889',
  UCD13: '3400892468891',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ZEN 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3615096',
  CIP13: '3400936150966',
  ucdLib: "BISOPROLOL ZYD 10MG CPR",
  UCD7: '9265734',
  UCD13: '3400892657349',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ZYD 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3004572',
  CIP13: '3400930045725',
  ucdLib: "BISOPROLOL CRT 1,25MG CPR",
  UCD7: '9418391',
  UCD13: '3400894183914',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL CRT 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3004625',
  CIP13: '3400930046258',
  ucdLib: "BISOPROLOL CRT 10MG CPR",
  UCD7: '9418416',
  UCD13: '3400894184164',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL CRT 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3004584',
  CIP13: '3400930045848',
  ucdLib: "BISOPROLOL CRT 2,5MG CPR",
  UCD7: '9418422',
  UCD13: '3400894184225',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL CRT 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3004594',
  CIP13: '3400930045947',
  ucdLib: "BISOPROLOL CRT 3,75MG CPR",
  UCD7: '9418439',
  UCD13: '3400894184393',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL CRT 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3004605',
  CIP13: '3400930046050',
  ucdLib: "BISOPROLOL CRT 5MG CPR",
  UCD7: '9418445',
  UCD13: '3400894184454',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL CRT 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3004617',
  CIP13: '3400930046173',
  ucdLib: "BISOPROLOL CRT 7,5MG CPR",
  UCD7: '9418451',
  UCD13: '3400894184515',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL CRT 7,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3571571',
  CIP13: '3400935715715',
  ucdLib: "BISOPROLOL ALM 10MG CPR",
  UCD7: '9307591',
  UCD13: '3400893075913',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ALM 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2769012',
  CIP13: '3400927690129',
  ucdLib: "BISOPROLOL KRK 10MG CPR",
  UCD7: '9404667',
  UCD13: '3400894046677',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL KRK 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2769064',
  CIP13: '3400927690648',
  ucdLib: "BISOPROLOL KRK 10MG CPR",
  UCD7: '9404667',
  UCD13: '3400894046677',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL KRK 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '2768797',
  CIP13: '3400927687976',
  ucdLib: "BISOPROLOL KRK 2,5MG CPR",
  UCD7: '9404673',
  UCD13: '3400894046738',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL KRK 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2768900',
  CIP13: '3400927689000',
  ucdLib: "BISOPROLOL KRK 5MG CPR",
  UCD7: '9404696',
  UCD13: '3400894046967',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL KRK 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4918723',
  CIP13: '3400949187232',
  ucdLib: "BISOPROLOL EG 1,25MG CPR",
  UCD7: '9356276',
  UCD13: '3400893562765',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL EG 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4918870',
  CIP13: '3400949188703',
  ucdLib: "BISOPROLOL EG 2,5MG CPR",
  UCD7: '9356282',
  UCD13: '3400893562826',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL EG 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4918628',
  CIP13: '3400949186280',
  ucdLib: "BISOPROLOL EG 3,75MG CPR",
  UCD7: '9356299',
  UCD13: '3400893562994',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL EG 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529540',
  CIP13: '3400935295408',
  ucdLib: "BISOPROLOL BGR 1,25MG CPR",
  UCD7: '9321987',
  UCD13: '3400893219874',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL BGR 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529669',
  CIP13: '3400935296696',
  ucdLib: "BISOPROLOL BGR 10MG CPR",
  UCD7: '9321993',
  UCD13: '3400893219935',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL BGR 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529563',
  CIP13: '3400935295637',
  ucdLib: "BISOPROLOL BGR 2,5MG CPR",
  UCD7: '9322001',
  UCD13: '3400893220016',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL BGR 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529592',
  CIP13: '3400935295927',
  ucdLib: "BISOPROLOL BGR 3,75MG CPR",
  UCD7: '9322018',
  UCD13: '3400893220184',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL BGR 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529617',
  CIP13: '3400935296177',
  ucdLib: "BISOPROLOL BGR 5MG CPR",
  UCD7: '9322024',
  UCD13: '3400893220245',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL BGR 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529646',
  CIP13: '3400935296467',
  ucdLib: "BISOPROLOL BGR 7,5MG CPR",
  UCD7: '9322030',
  UCD13: '3400893220306',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL BGR 7,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529681',
  CIP13: '3400935296818',
  ucdLib: "CARDENSIEL 1,25MG CPR",
  UCD7: '9220720',
  UCD13: '3400892207209',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDENSIEL 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529698',
  CIP13: '3400935296986',
  ucdLib: "CARDENSIEL 1,25MG CPR",
  UCD7: '9220720',
  UCD13: '3400892207209',
  ucdQtyMultiplicator: 90,
  cipLib: "CARDENSIEL 1,25MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3529706',
  CIP13: '3400935297068',
  ucdLib: "CARDENSIEL 2,5MG CPR",
  UCD7: '9220743',
  UCD13: '3400892207438',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDENSIEL 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529712',
  CIP13: '3400935297129',
  ucdLib: "CARDENSIEL 2,5MG CPR",
  UCD7: '9220743',
  UCD13: '3400892207438',
  ucdQtyMultiplicator: 90,
  cipLib: "CARDENSIEL 2,5MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3529729',
  CIP13: '3400935297297',
  ucdLib: "CARDENSIEL 3,75MG CPR",
  UCD7: '9220766',
  UCD13: '3400892207667',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDENSIEL 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3529741',
  CIP13: '3400935297419',
  ucdLib: "CARDENSIEL 5MG CPR",
  UCD7: '9220772',
  UCD13: '3400892207728',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDENSIEL 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4989887',
  CIP13: '3400949898879',
  ucdLib: "BISOPROLOL ZYF 1,25MG CPR",
  UCD7: '9365364',
  UCD13: '3400893653647',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ZYF 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4989663',
  CIP13: '3400949896639',
  ucdLib: "BISOPROLOL ZYF 2,5MG CPR",
  UCD7: '9365370',
  UCD13: '3400893653708',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ZYF 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4989611',
  CIP13: '3400949896110',
  ucdLib: "BISOPROLOL ZYF 5MG CPR",
  UCD7: '9365387',
  UCD13: '3400893653876',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ZYF 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3560981',
  CIP13: '3400935609816',
  ucdLib: "BISOPROLOL TVC 10MG CPR",
  UCD7: '9249250',
  UCD13: '3400892492506',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL TVC 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3560805',
  CIP13: '3400935608055',
  ucdLib: "BISOPROLOL TVC 5MG CPR",
  UCD7: '9249267',
  UCD13: '3400892492674',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL TVC 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531399',
  CIP13: '3400935313997',
  ucdLib: "BISOCE 1,25MG CPR",
  UCD7: '9283614',
  UCD13: '3400892836140',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOCE 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531407',
  CIP13: '3400935314079',
  ucdLib: "BISOCE 1,25MG CPR",
  UCD7: '9283614',
  UCD13: '3400892836140',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOCE 1,25MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3531502',
  CIP13: '3400935315021',
  ucdLib: "BISOCE 10MG CPR",
  UCD7: '9283620',
  UCD13: '3400892836201',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOCE 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531519',
  CIP13: '3400935315199',
  ucdLib: "BISOCE 10MG CPR",
  UCD7: '9283620',
  UCD13: '3400892836201',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOCE 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3531413',
  CIP13: '3400935314130',
  ucdLib: "BISOCE 2,5MG CPR",
  UCD7: '9283637',
  UCD13: '3400892836379',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOCE 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531436',
  CIP13: '3400935314369',
  ucdLib: "BISOCE 2,5MG CPR",
  UCD7: '9283637',
  UCD13: '3400892836379',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOCE 2,5MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3531442',
  CIP13: '3400935314420',
  ucdLib: "BISOCE 3,75MG CPR",
  UCD7: '9283643',
  UCD13: '3400892836430',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOCE 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531465',
  CIP13: '3400935314659',
  ucdLib: "BISOCE 5MG CPR",
  UCD7: '9283666',
  UCD13: '3400892836669',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOCE 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531471',
  CIP13: '3400935314710',
  ucdLib: "BISOCE 5MG CPR",
  UCD7: '9283666',
  UCD13: '3400892836669',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOCE 5MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3531488',
  CIP13: '3400935314888',
  ucdLib: "BISOCE 7,5MG CPR",
  UCD7: '9283672',
  UCD13: '3400892836720',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOCE 7,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3623925',
  CIP13: '3400936239258',
  ucdLib: "BISOPROLOL RPG 10MG CPR",
  UCD7: '9256698',
  UCD13: '3400892566986',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL RPG 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3623902',
  CIP13: '3400936239029',
  ucdLib: "BISOPROLOL RPG 5MG CPR",
  UCD7: '9256706',
  UCD13: '3400892567068',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL RPG 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531318',
  CIP13: '3400935313188',
  ucdLib: "CARDENSIEL 10MG CPR",
  UCD7: '9220737',
  UCD13: '3400892207377',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDENSIEL 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531293',
  CIP13: '3400935312938',
  ucdLib: "CARDENSIEL 7,5MG CPR",
  UCD7: '9220789',
  UCD13: '3400892207896',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDENSIEL 7,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531525',
  CIP13: '3400935315250',
  ucdLib: "CARDIOCOR 1,25MG CPR",
  UCD7: '9220140',
  UCD13: '3400892201405',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDIOCOR 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531548',
  CIP13: '3400935315489',
  ucdLib: "CARDIOCOR 2,5MG CPR",
  UCD7: '9220163',
  UCD13: '3400892201634',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDIOCOR 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3531583',
  CIP13: '3400935315830',
  ucdLib: "CARDIOCOR 5MG CPR",
  UCD7: '9220192',
  UCD13: '3400892201924',
  ucdQtyMultiplicator: 30,
  cipLib: "CARDIOCOR 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3588175',
  CIP13: '3400935881755',
  ucdLib: "DETENSIEL 10MG CPR",
  UCD7: '9119317',
  UCD13: '3400891193176',
  ucdQtyMultiplicator: 30,
  cipLib: "DETENSIEL 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3768546',
  CIP13: '3400937685467',
  ucdLib: "BISOPROLOL EG 10MG CPR",
  UCD7: '9248546',
  UCD13: '3400892485461',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL EG 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3724224',
  CIP13: '3400937242240',
  ucdLib: "BISOPROLOL MYL 10MG CPR",
  UCD7: '9248813',
  UCD13: '3400892488134',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL MYL 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3722455',
  CIP13: '3400937224550',
  ucdLib: "DETENSIEL 10MG CPR",
  UCD7: '9119317',
  UCD13: '3400891193176',
  ucdQtyMultiplicator: 90,
  cipLib: "DETENSIEL 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3712451',
  CIP13: '3400937124515',
  ucdLib: "BISOPROLOL ZYD 10MG CPR",
  UCD7: '9265734',
  UCD13: '3400892657349',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL ZYD 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3739800',
  CIP13: '3400937398008',
  ucdLib: "BISOPROLOL ARW 10MG CPR",
  UCD7: '9248523',
  UCD13: '3400892485232',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL ARW 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3730437',
  CIP13: '3400937304375',
  ucdLib: "BISOPROLOL RPG 10MG CPR",
  UCD7: '9256698',
  UCD13: '3400892566986',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL RPG 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3738781',
  CIP13: '3400937387811',
  ucdLib: "BISOPROLOL TVC 10MG CPR",
  UCD7: '9249250',
  UCD13: '3400892492506',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL TVC 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3956957',
  CIP13: '3400939569574',
  ucdLib: "BISOPROLOL BGA 10MG C.PELL",
  UCD7: '9329799',
  UCD13: '3400893297995',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL BGA 10MG C.PELL BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '3909857',
  CIP13: '3400939098579',
  ucdLib: "BISOPROLOL SDZ 1,25MG CPR",
  UCD7: '9332057',
  UCD13: '3400893320570',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL SDZ 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3911989',
  CIP13: '3400939119892',
  ucdLib: "BISOPROLOL SDZ 10MG CPR",
  UCD7: '9332034',
  UCD13: '3400893320341',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL SDZ 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3909998',
  CIP13: '3400939099989',
  ucdLib: "BISOPROLOL SDZ 2,5MG CPR",
  UCD7: '9332063',
  UCD13: '3400893320631',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL SDZ 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3910091',
  CIP13: '3400939100913',
  ucdLib: "BISOPROLOL SDZ 3,75MG CPR",
  UCD7: '9332086',
  UCD13: '3400893320860',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL SDZ 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3911831',
  CIP13: '3400939118314',
  ucdLib: "BISOPROLOL SDZ 5MG CPR",
  UCD7: '9332040',
  UCD13: '3400893320402',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL SDZ 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3910180',
  CIP13: '3400939101804',
  ucdLib: "BISOPROLOL SDZ 7,5MG CPR",
  UCD7: '9332092',
  UCD13: '3400893320921',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL SDZ 7,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4193987',
  CIP13: '3400941939877',
  ucdLib: "BISOPROLOL RBX 7,5MG CPR",
  UCD7: '9377249',
  UCD13: '3400893772492',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL RBX 7,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4153315',
  CIP13: '3400941533150',
  ucdLib: "BISOPROLOL SDZ 1,25MG CPR",
  UCD7: '9332057',
  UCD13: '3400893320570',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL SDZ 1,25MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '4153373',
  CIP13: '3400941533730',
  ucdLib: "BISOPROLOL SDZ 10MG CPR",
  UCD7: '9332034',
  UCD13: '3400893320341',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL SDZ 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '4153321',
  CIP13: '3400941533211',
  ucdLib: "BISOPROLOL SDZ 2,5MG CPR",
  UCD7: '9332063',
  UCD13: '3400893320631',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL SDZ 2,5MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '4175156',
  CIP13: '3400941751561',
  ucdLib: "BISOPROLOL TVS 1,25MG CPR",
  UCD7: '9375144',
  UCD13: '3400893751442',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL TVS 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4175162',
  CIP13: '3400941751622',
  ucdLib: "BISOPROLOL TVS 1,25MG CPR",
  UCD7: '9375144',
  UCD13: '3400893751442',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL TVS 1,25MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '4175268',
  CIP13: '3400941752681',
  ucdLib: "BISOPROLOL TVS 10MG CPR",
  UCD7: '9375150',
  UCD13: '3400893751503',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL TVS 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4175179',
  CIP13: '3400941751790',
  ucdLib: "BISOPROLOL TVS 2,5MG CPR",
  UCD7: '9375167',
  UCD13: '3400893751671',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL TVS 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4175185',
  CIP13: '3400941751851',
  ucdLib: "BISOPROLOL TVS 2,5MG CPR",
  UCD7: '9375167',
  UCD13: '3400893751671',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL TVS 2,5MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '4175191',
  CIP13: '3400941751912',
  ucdLib: "BISOPROLOL TVS 3,75MG CPR",
  UCD7: '9375173',
  UCD13: '3400893751732',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL TVS 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4175222',
  CIP13: '3400941752223',
  ucdLib: "BISOPROLOL TVS 5MG CPR",
  UCD7: '9375196',
  UCD13: '3400893751961',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL TVS 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4175245',
  CIP13: '3400941752452',
  ucdLib: "BISOPROLOL TVS 7,5MG CPR",
  UCD7: '9375204',
  UCD13: '3400893752043',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL TVS 7,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2230017',
  CIP13: '3400922300177',
  ucdLib: "BISOPROLOL AHL 10MG CPR",
  UCD7: '9384290',
  UCD13: '3400893842904',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL AHL 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2230069',
  CIP13: '3400922300696',
  ucdLib: "BISOPROLOL AHL 10MG CPR",
  UCD7: '9384290',
  UCD13: '3400893842904',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL AHL 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '2229675',
  CIP13: '3400922296753',
  ucdLib: "BISOPROLOL AHL 2,5MG CPR",
  UCD7: '9384232',
  UCD13: '3400893842324',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL AHL 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2229712',
  CIP13: '3400922297125',
  ucdLib: "BISOPROLOL AHL 2,5MG CPR",
  UCD7: '9384232',
  UCD13: '3400893842324',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL AHL 2,5MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '2229830',
  CIP13: '3400922298306',
  ucdLib: "BISOPROLOL AHL 5MG CPR",
  UCD7: '9384309',
  UCD13: '3400893843093',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL AHL 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2229882',
  CIP13: '3400922298825',
  ucdLib: "BISOPROLOL AHL 5MG CPR",
  UCD7: '9384309',
  UCD13: '3400893843093',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL AHL 5MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '4921889',
  CIP13: '3400949218899',
  ucdLib: "BISOPROLOL RBX 1,25MG CPR",
  UCD7: '9356307',
  UCD13: '3400893563076',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL RBX 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4921978',
  CIP13: '3400949219780',
  ucdLib: "BISOPROLOL RBX 2,5MG CPR",
  UCD7: '9356313',
  UCD13: '3400893563137',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL RBX 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '4922050',
  CIP13: '3400949220502',
  ucdLib: "BISOPROLOL RBX 3,75MG CPR",
  UCD7: '9356336',
  UCD13: '3400893563366',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL RBX 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2226263',
  CIP13: '3400922262635',
  ucdLib: "BISOPROLOL ZTL 10MG CPR",
  UCD7: '9386047',
  UCD13: '3400893860472',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ZTL 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2226286',
  CIP13: '3400922262864',
  ucdLib: "BISOPROLOL ZTL 10MG CPR",
  UCD7: '9386047',
  UCD13: '3400893860472',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL ZTL 10MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '2225803',
  CIP13: '3400922258034',
  ucdLib: "BISOPROLOL ZTL 2,5MG CPR",
  UCD7: '9386053',
  UCD13: '3400893860533',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ZTL 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2226234',
  CIP13: '3400922262345',
  ucdLib: "BISOPROLOL ZTL 5MG CPR",
  UCD7: '9386076',
  UCD13: '3400893860762',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL ZTL 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2772362',
  CIP13: '3400927723629',
  ucdLib: "BISOPROLOL QVR 1,25MG CPR",
  UCD7: '9402154',
  UCD13: '3400894021544',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL QVR 1,25MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2772882',
  CIP13: '3400927728822',
  ucdLib: "BISOPROLOL QVR 10MG CPR",
  UCD7: '9402160',
  UCD13: '3400894021605',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL QVR 10MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2772474',
  CIP13: '3400927724749',
  ucdLib: "BISOPROLOL QVR 2,5MG CPR",
  UCD7: '9402177',
  UCD13: '3400894021773',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL QVR 2,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2772586',
  CIP13: '3400927725869',
  ucdLib: "BISOPROLOL QVR 3,75MG CPR",
  UCD7: '9402183',
  UCD13: '3400894021834',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL QVR 3,75MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2772698',
  CIP13: '3400927726989',
  ucdLib: "BISOPROLOL QVR 5MG CPR",
  UCD7: '9402208',
  UCD13: '3400894022084',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL QVR 5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '2772712',
  CIP13: '3400927727122',
  ucdLib: "BISOPROLOL QVR 5MG CPR",
  UCD7: '9402208',
  UCD13: '3400894022084',
  ucdQtyMultiplicator: 90,
  cipLib: "BISOPROLOL QVR 5MG CPR BT 90",
  atcCode: "C07AB07"
}, {
  CIP7: '2772793',
  CIP13: '3400927727931',
  ucdLib: "BISOPROLOL QVR 7,5MG CPR",
  UCD7: '9402214',
  UCD13: '3400894022145',
  ucdQtyMultiplicator: 30,
  cipLib: "BISOPROLOL QVR 7,5MG CPR BT 30",
  atcCode: "C07AB07"
}, {
  CIP7: '3254942',
  CIP13: '3400932549429',
  ucdLib: "KERLONE 20MG CPR",
  UCD7: '9048971',
  UCD13: '3400890489713',
  ucdQtyMultiplicator: 28,
  cipLib: "KERLONE 20MG CPR BT 28",
  atcCode: "C07AB05"
}, {
  CIP7: '3714645',
  CIP13: '3400937146456',
  ucdLib: "KERLONE 20MG CPR",
  UCD7: '9048971',
  UCD13: '3400890489713',
  ucdQtyMultiplicator: 84,
  cipLib: "KERLONE 20MG CPR BT 84",
  atcCode: "C07AB05"
}, {
  CIP7: '2697643',
  CIP13: '3400926976439',
  ucdLib: "BETAXOLOL TVS 20MG CPR",
  UCD7: '9396028',
  UCD13: '3400893960288',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAXOLOL TVS 20MG CPR BT 30",
  atcCode: "C07AB05"
}, {
  CIP7: '2697672',
  CIP13: '3400926976729',
  ucdLib: "BETAXOLOL TVS 20MG CPR",
  UCD7: '9396028',
  UCD13: '3400893960288',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAXOLOL TVS 20MG CPR BT 90",
  atcCode: "C07AB05"
}, {
  CIP7: '2737957',
  CIP13: '3400927379574',
  ucdLib: "BETAXOLOL BGA 20MG CPR",
  UCD7: '9394638',
  UCD13: '3400893946381',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAXOLOL BGA 20MG CPR BT 30",
  atcCode: "C07AB05"
}, {
  CIP7: '2737986',
  CIP13: '3400927379864',
  ucdLib: "BETAXOLOL BGA 20MG CPR",
  UCD7: '9394638',
  UCD13: '3400893946381',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAXOLOL BGA 20MG CPR BT 90",
  atcCode: "C07AB05"
}, {
  CIP7: '2732842',
  CIP13: '3400927328428',
  ucdLib: "BETAXOLOL EG 20MG CPR",
  UCD7: '9393768',
  UCD13: '3400893937686',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAXOLOL EG 20MG CPR BT 30",
  atcCode: "C07AB05"
}, {
  CIP7: '2732859',
  CIP13: '3400927328596',
  ucdLib: "BETAXOLOL EG 20MG CPR",
  UCD7: '9393768',
  UCD13: '3400893937686',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAXOLOL EG 20MG CPR BT 90",
  atcCode: "C07AB05"
}, {
  CIP7: '2737897',
  CIP13: '3400927378973',
  ucdLib: "BETAXOLOL MYL 20MG CPR",
  UCD7: '9400600',
  UCD13: '3400894006008',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAXOLOL MYL 20MG CPR BT 30",
  atcCode: "C07AB05"
}, {
  CIP7: '2737911',
  CIP13: '3400927379116',
  ucdLib: "BETAXOLOL MYL 20MG CPR",
  UCD7: '9400600',
  UCD13: '3400894006008',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAXOLOL MYL 20MG CPR BT 90",
  atcCode: "C07AB05"
}, {
  CIP7: '2738052',
  CIP13: '3400927380525',
  ucdLib: "BETAXOLOL SDZ 20MG CPR",
  UCD7: '9392800',
  UCD13: '3400893928004',
  ucdQtyMultiplicator: 30,
  cipLib: "BETAXOLOL SDZ 20MG CPR BT 30",
  atcCode: "C07AB05"
}, {
  CIP7: '2738075',
  CIP13: '3400927380754',
  ucdLib: "BETAXOLOL SDZ 20MG CPR",
  UCD7: '9392800',
  UCD13: '3400893928004',
  ucdQtyMultiplicator: 90,
  cipLib: "BETAXOLOL SDZ 20MG CPR BT 90",
  atcCode: "C07AB05"
}, {
  CIP7: '3614636',
  CIP13: '3400936146365',
  ucdLib: "ACEBUTOLOL TVC 200MG CPR",
  UCD7: '9244293',
  UCD13: '3400892442938',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL TVC 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3614642',
  CIP13: '3400936146426',
  ucdLib: "ACEBUTOLOL TVC 400MG CPR",
  UCD7: '9244301',
  UCD13: '3400892443010',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL TVC 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3003872',
  CIP13: '3400930038727',
  ucdLib: "ACEBUTOLOL BGA 200MG CPR",
  UCD7: '9218060',
  UCD13: '3400892180601',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL BGA 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3317312',
  CIP13: '3400933173128',
  ucdLib: "SECTRAL LP 500MG CPR",
  UCD7: '9141311',
  UCD13: '3400891413113',
  ucdQtyMultiplicator: 28,
  cipLib: "SECTRAL LP 500MG CPR BT 28",
  atcCode: "C07AB04"
}, {
  CIP7: '3304605',
  CIP13: '3400933046057',
  ucdLib: "SECTRAL 40MG/ML BUV FL125ML",
  UCD7: '9134305',
  UCD13: '3400891343052',
  ucdQtyMultiplicator: 1,
  cipLib: "SECTRAL 40MG/ML BUV FL125ML BT 1",
  atcCode: "C07AB04"
}, {
  CIP7: '3220771',
  CIP13: '3400932207718',
  ucdLib: "SECTRAL 400MG CPR",
  UCD7: '9082979',
  UCD13: '3400890829793',
  ucdQtyMultiplicator: 30,
  cipLib: "SECTRAL 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3528411',
  CIP13: '3400935284112',
  ucdLib: "ACEBUTOLOL BGA 400MG CPR",
  UCD7: '9218077',
  UCD13: '3400892180779',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL BGA 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3404703',
  CIP13: '3400934047039',
  ucdLib: "SECTRAL 200MG CPR",
  UCD7: '9082985',
  UCD13: '3400890829854',
  ucdQtyMultiplicator: 30,
  cipLib: "SECTRAL 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '5589919',
  CIP13: '3400955899198',
  ucdLib: "SECTRAL 200MG CPR",
  UCD7: '9082985',
  UCD13: '3400890829854',
  ucdQtyMultiplicator: 100,
  cipLib: "SECTRAL 200MG CPR BT 100",
  atcCode: "C07AB04"
}, {
  CIP7: '3852347',
  CIP13: '3400938523478',
  ucdLib: "ACEBUTOLOL RBX 200MG CPR",
  UCD7: '9317514',
  UCD13: '3400893175149',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL RBX 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3852353',
  CIP13: '3400938523539',
  ucdLib: "ACEBUTOLOL RBX 400MG CPR",
  UCD7: '9317520',
  UCD13: '3400893175200',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL RBX 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3594968',
  CIP13: '3400935949684',
  ucdLib: "ACEBUTOLOL ARW 200MG CPR",
  UCD7: '9240272',
  UCD13: '3400892402727',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL ARW 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3594974',
  CIP13: '3400935949745',
  ucdLib: "ACEBUTOLOL ARW 400MG CPR",
  UCD7: '9240289',
  UCD13: '3400892402895',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL ARW 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3530744',
  CIP13: '3400935307446',
  ucdLib: "ACEBUTOLOL BGA 200MG CPR",
  UCD7: '9218060',
  UCD13: '3400892180601',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL BGA 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3594997',
  CIP13: '3400935949974',
  ucdLib: "ACEBUTOLOL CRT 200MG CPR",
  UCD7: '9247914',
  UCD13: '3400892479149',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL CRT 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3595005',
  CIP13: '3400935950055',
  ucdLib: "ACEBUTOLOL CRT 400MG CPR",
  UCD7: '9247920',
  UCD13: '3400892479200',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL CRT 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3481715',
  CIP13: '3400934817151',
  ucdLib: "ACEBUTOLOL RTP 400MG CPR",
  UCD7: '9208222',
  UCD13: '3400892082226',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL RTP 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3658390',
  CIP13: '3400936583900',
  ucdLib: "ACEBUTOLOL SDZ 200MG CPR",
  UCD7: '9263681',
  UCD13: '3400892636818',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL SDZ 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3658409',
  CIP13: '3400936584099',
  ucdLib: "ACEBUTOLOL SDZ 400MG CPR",
  UCD7: '9263698',
  UCD13: '3400892636986',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL SDZ 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3538622',
  CIP13: '3400935386229',
  ucdLib: "ACEBUTOLOL ZYD 400MG CPR",
  UCD7: '9222736',
  UCD13: '3400892227368',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL ZYD 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3546662',
  CIP13: '3400935466624',
  ucdLib: "ACEBUTOLOL EG 200MG CPR",
  UCD7: '9223115',
  UCD13: '3400892231150',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL EG 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3546656',
  CIP13: '3400935466563',
  ucdLib: "ACEBUTOLOL EG 400MG CPR",
  UCD7: '9223121',
  UCD13: '3400892231211',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL EG 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3540961',
  CIP13: '3400935409614',
  ucdLib: "ACEBUTOLOL ZYD 200MG CPR",
  UCD7: '9222713',
  UCD13: '3400892227139',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL ZYD 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3768084',
  CIP13: '3400937680844',
  ucdLib: "ACEBUTOLOL EG 200MG CPR",
  UCD7: '9223115',
  UCD13: '3400892231150',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL EG 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3768090',
  CIP13: '3400937680905',
  ucdLib: "ACEBUTOLOL EG 400MG CPR",
  UCD7: '9223121',
  UCD13: '3400892231211',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL EG 400MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3722656',
  CIP13: '3400937226561',
  ucdLib: "ACEBUTOLOL RTP 200MG CPR",
  UCD7: '9198096',
  UCD13: '3400891980967',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL RTP 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3729262',
  CIP13: '3400937292627',
  ucdLib: "ACEBUTOLOL SDZ 200MG CPR",
  UCD7: '9263681',
  UCD13: '3400892636818',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL SDZ 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3729285',
  CIP13: '3400937292856',
  ucdLib: "ACEBUTOLOL SDZ 400MG CPR",
  UCD7: '9263698',
  UCD13: '3400892636986',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL SDZ 400MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3720858',
  CIP13: '3400937208581',
  ucdLib: "SECTRAL 200MG CPR",
  UCD7: '9082985',
  UCD13: '3400890829854',
  ucdQtyMultiplicator: 90,
  cipLib: "SECTRAL 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3722254',
  CIP13: '3400937222549',
  ucdLib: "SECTRAL 400MG CPR",
  UCD7: '9082979',
  UCD13: '3400890829793',
  ucdQtyMultiplicator: 90,
  cipLib: "SECTRAL 400MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3781334',
  CIP13: '3400937813341',
  ucdLib: "ACEBUTOLOL BGA 200MG CPR",
  UCD7: '9218060',
  UCD13: '3400892180601',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL BGA 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3785071',
  CIP13: '3400937850711',
  ucdLib: "ACEBUTOLOL ZEN 200MG CPR",
  UCD7: '9269643',
  UCD13: '3400892696430',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL ZEN 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3785088',
  CIP13: '3400937850889',
  ucdLib: "ACEBUTOLOL ZEN 200MG CPR",
  UCD7: '9269643',
  UCD13: '3400892696430',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL ZEN 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3786194',
  CIP13: '3400937861946',
  ucdLib: "ACEBUTOLOL ZEN 400MG CPR",
  UCD7: '9305528',
  UCD13: '3400893055281',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL ZEN 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3712528',
  CIP13: '3400937125284',
  ucdLib: "ACEBUTOLOL ZYD 200MG CPR",
  UCD7: '9222713',
  UCD13: '3400892227139',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL ZYD 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3864913',
  CIP13: '3400938649130',
  ucdLib: "ACEBUTOLOL ALM 200MG CPR",
  UCD7: '9319039',
  UCD13: '3400893190395',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL ALM 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3736575',
  CIP13: '3400937365758',
  ucdLib: "ACEBUTOLOL ARW 200MG CPR",
  UCD7: '9240272',
  UCD13: '3400892402727',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL ARW 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3736664',
  CIP13: '3400937366649',
  ucdLib: "ACEBUTOLOL CRT 200MG CPR",
  UCD7: '9247914',
  UCD13: '3400892479149',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL CRT 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3730124',
  CIP13: '3400937301244',
  ucdLib: "ACEBUTOLOL MYL 200MG CPR",
  UCD7: '9213157',
  UCD13: '3400892131573',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL MYL 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3738433',
  CIP13: '3400937384339',
  ucdLib: "ACEBUTOLOL MYL 400MG CPR",
  UCD7: '9213163',
  UCD13: '3400892131634',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL MYL 400MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3738031',
  CIP13: '3400937380317',
  ucdLib: "ACEBUTOLOL RBX 200MG CPR",
  UCD7: '9317514',
  UCD13: '3400893175149',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL RBX 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3737818',
  CIP13: '3400937378185',
  ucdLib: "ACEBUTOLOL RBX 400MG CPR",
  UCD7: '9317520',
  UCD13: '3400893175200',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL RBX 400MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3731106',
  CIP13: '3400937311069',
  ucdLib: "ACEBUTOLOL TVC 200MG CPR",
  UCD7: '9244293',
  UCD13: '3400892442938',
  ucdQtyMultiplicator: 90,
  cipLib: "ACEBUTOLOL TVC 200MG CPR BT 90",
  atcCode: "C07AB04"
}, {
  CIP7: '3502073',
  CIP13: '3400935020734',
  ucdLib: "ACEBUTOLOL MYL 200MG CPR",
  UCD7: '9213157',
  UCD13: '3400892131573',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL MYL 200MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3502096',
  CIP13: '3400935020963',
  ucdLib: "ACEBUTOLOL MYL 400MG CPR",
  UCD7: '9213163',
  UCD13: '3400892131634',
  ucdQtyMultiplicator: 30,
  cipLib: "ACEBUTOLOL MYL 400MG CPR BT 30",
  atcCode: "C07AB04"
}, {
  CIP7: '3839559',
  CIP13: '3400938395594',
  ucdLib: "ATENOLOL ZYD 100MG CPR",
  UCD7: '9235437',
  UCD13: '3400892354378',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL ZYD 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3839476',
  CIP13: '3400938394764',
  ucdLib: "ATENOLOL ZYD 50MG CPR",
  UCD7: '9235443',
  UCD13: '3400892354439',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL ZYD 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3003871',
  CIP13: '3400930038710',
  ucdLib: "ATENOLOL BGA 50MG CPR",
  UCD7: '9230813',
  UCD13: '3400892308135',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL BGA 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3574210',
  CIP13: '3400935742100',
  ucdLib: "ATENOLOL ARW 100MG CPR",
  UCD7: '9234403',
  UCD13: '3400892344034',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL ARW 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3574173',
  CIP13: '3400935741738',
  ucdLib: "ATENOLOL ARW 50MG CPR",
  UCD7: '9234426',
  UCD13: '3400892344263',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL ARW 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3274838',
  CIP13: '3400932748389',
  ucdLib: "TENORMINE 5MG IV AMP10ML",
  UCD7: '9122561',
  UCD13: '3400891225617',
  ucdQtyMultiplicator: 5,
  cipLib: "TENORMINE 5MG IV AMP10ML BT 5",
  atcCode: "C07AB03"
}, {
  CIP7: '3306188',
  CIP13: '3400933061883',
  ucdLib: "BETATOP 100MG CPR",
  UCD7: '9138208',
  UCD13: '3400891382082',
  ucdQtyMultiplicator: 28,
  cipLib: "BETATOP 100MG CPR BT 28",
  atcCode: "C07AB03"
}, {
  CIP7: '3306159',
  CIP13: '3400933061593',
  ucdLib: "BETATOP 50MG CPR",
  UCD7: '9138214',
  UCD13: '3400891382143',
  ucdQtyMultiplicator: 28,
  cipLib: "BETATOP 50MG CPR BT 28",
  atcCode: "C07AB03"
}, {
  CIP7: '3355330',
  CIP13: '3400933553302',
  ucdLib: "ATENOLOL RPG 100MG CPR",
  UCD7: '9158961',
  UCD13: '3400891589610',
  ucdQtyMultiplicator: 28,
  cipLib: "ATENOLOL RPG 100MG CPR BT 28",
  atcCode: "C07AB03"
}, {
  CIP7: '3564424',
  CIP13: '3400935644244',
  ucdLib: "ATENOLOL BGA 50MG CPR",
  UCD7: '9230813',
  UCD13: '3400892308135',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL BGA 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3557565',
  CIP13: '3400935575654',
  ucdLib: "ATENOLOL MYL 100MG CPR",
  UCD7: '9190002',
  UCD13: '3400891900026',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL MYL 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3557513',
  CIP13: '3400935575135',
  ucdLib: "ATENOLOL MYL 50MG CPR",
  UCD7: '9190019',
  UCD13: '3400891900194',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL MYL 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3513639',
  CIP13: '3400935136398',
  ucdLib: "ATENOLOL RPG 50MG CPR",
  UCD7: '9215050',
  UCD13: '3400892150505',
  ucdQtyMultiplicator: 28,
  cipLib: "ATENOLOL RPG 50MG CPR BT 28",
  atcCode: "C07AB03"
}, {
  CIP7: '3722722',
  CIP13: '3400937227223',
  ucdLib: "ATENOLOL EVO 50MG CPR",
  UCD7: '9178225',
  UCD13: '3400891782257',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL EVO 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3722745',
  CIP13: '3400937227452',
  ucdLib: "ATENOLOL EVO 50MG CPR",
  UCD7: '9178225',
  UCD13: '3400891782257',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL EVO 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3729954',
  CIP13: '3400937299541',
  ucdLib: "ATENOLOL MYL 100MG CPR",
  UCD7: '9190002',
  UCD13: '3400891900026',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL MYL 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3729919',
  CIP13: '3400937299190',
  ucdLib: "ATENOLOL MYL 50MG CPR",
  UCD7: '9190019',
  UCD13: '3400891900194',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL MYL 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3728713',
  CIP13: '3400937287135',
  ucdLib: "ATENOLOL TVC 100MG CPR",
  UCD7: '9244519',
  UCD13: '3400892445199',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL TVC 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3728736',
  CIP13: '3400937287364',
  ucdLib: "ATENOLOL TVC 100MG CPR",
  UCD7: '9244519',
  UCD13: '3400892445199',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL TVC 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3728682',
  CIP13: '3400937286824',
  ucdLib: "ATENOLOL TVC 50MG CPR",
  UCD7: '9244525',
  UCD13: '3400892445250',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL TVC 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3728699',
  CIP13: '3400937286992',
  ucdLib: "ATENOLOL TVC 50MG CPR",
  UCD7: '9244525',
  UCD13: '3400892445250',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL TVC 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3780820',
  CIP13: '3400937808200',
  ucdLib: "ATENOLOL BGA 100MG CPR",
  UCD7: '9162388',
  UCD13: '3400891623888',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL BGA 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3791516',
  CIP13: '3400937915168',
  ucdLib: "ATENOLOL BGA 100MG CPR",
  UCD7: '9162388',
  UCD13: '3400891623888',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL BGA 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3780843',
  CIP13: '3400937808439',
  ucdLib: "ATENOLOL BGA 50MG CPR",
  UCD7: '9230813',
  UCD13: '3400892308135',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL BGA 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3712505',
  CIP13: '3400937125055',
  ucdLib: "ATENOLOL ZYD 100MG CPR",
  UCD7: '9235437',
  UCD13: '3400892354378',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL ZYD 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3712497',
  CIP13: '3400937124973',
  ucdLib: "ATENOLOL ZYD 50MG CPR",
  UCD7: '9235443',
  UCD13: '3400892354439',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL ZYD 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3714220',
  CIP13: '3400937142205',
  ucdLib: "TENORMINE 100MG CPR",
  UCD7: '9090909',
  UCD13: '3400890909099',
  ucdQtyMultiplicator: 30,
  cipLib: "TENORMINE 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3714243',
  CIP13: '3400937142434',
  ucdLib: "TENORMINE 100MG CPR",
  UCD7: '9090909',
  UCD13: '3400890909099',
  ucdQtyMultiplicator: 90,
  cipLib: "TENORMINE 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3714272',
  CIP13: '3400937142724',
  ucdLib: "TENORMINE 50MG CPR",
  UCD7: '9192395',
  UCD13: '3400891923957',
  ucdQtyMultiplicator: 30,
  cipLib: "TENORMINE 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3714295',
  CIP13: '3400937142953',
  ucdLib: "TENORMINE 50MG CPR",
  UCD7: '9192395',
  UCD13: '3400891923957',
  ucdQtyMultiplicator: 90,
  cipLib: "TENORMINE 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3739591',
  CIP13: '3400937395915',
  ucdLib: "ATENOLOL ARW 100MG CPR",
  UCD7: '9234403',
  UCD13: '3400892344034',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL ARW 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3739579',
  CIP13: '3400937395793',
  ucdLib: "ATENOLOL ARW 50MG CPR",
  UCD7: '9234426',
  UCD13: '3400892344263',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL ARW 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3739119',
  CIP13: '3400937391191',
  ucdLib: "ATENOLOL EG 100MG CPR",
  UCD7: '9224818',
  UCD13: '3400892248189',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL EG 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3739094',
  CIP13: '3400937390941',
  ucdLib: "ATENOLOL EG 50MG CPR",
  UCD7: '9224824',
  UCD13: '3400892248240',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL EG 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3731773',
  CIP13: '3400937317733',
  ucdLib: "ATENOLOL SDZ 100MG CPR",
  UCD7: '9263787',
  UCD13: '3400892637877',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL SDZ 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3731804',
  CIP13: '3400937318044',
  ucdLib: "ATENOLOL SDZ 100MG CPR",
  UCD7: '9263787',
  UCD13: '3400892637877',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL SDZ 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3731678',
  CIP13: '3400937316781',
  ucdLib: "ATENOLOL SDZ 50MG CPR",
  UCD7: '9263793',
  UCD13: '3400892637938',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL SDZ 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3731690',
  CIP13: '3400937316903',
  ucdLib: "ATENOLOL SDZ 50MG CPR",
  UCD7: '9263793',
  UCD13: '3400892637938',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL SDZ 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3844141',
  CIP13: '3400938441413',
  ucdLib: "ATENOLOL EG 100MG CPR",
  UCD7: '9224818',
  UCD13: '3400892248189',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL EG 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '3844135',
  CIP13: '3400938441352',
  ucdLib: "ATENOLOL EG 50MG CPR",
  UCD7: '9224824',
  UCD13: '3400892248240',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL EG 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '4948552',
  CIP13: '3400949485529',
  ucdLib: "ATENOLOL AHL 100MG CPR",
  UCD7: '9363193',
  UCD13: '3400893631935',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL AHL 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '4948569',
  CIP13: '3400949485697',
  ucdLib: "ATENOLOL AHL 100MG CPR",
  UCD7: '9363193',
  UCD13: '3400893631935',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL AHL 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '4948492',
  CIP13: '3400949484928',
  ucdLib: "ATENOLOL AHL 50MG CPR",
  UCD7: '9363201',
  UCD13: '3400893632017',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL AHL 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '4948500',
  CIP13: '3400949485000',
  ucdLib: "ATENOLOL AHL 50MG CPR",
  UCD7: '9363201',
  UCD13: '3400893632017',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL AHL 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '2169499',
  CIP13: '3400921694994',
  ucdLib: "ATENOLOL ZEN 100MG CPR",
  UCD7: '9382836',
  UCD13: '3400893828366',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL ZEN 100MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '2169513',
  CIP13: '3400921695137',
  ucdLib: "ATENOLOL ZEN 100MG CPR",
  UCD7: '9382836',
  UCD13: '3400893828366',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL ZEN 100MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '2168695',
  CIP13: '3400921686951',
  ucdLib: "ATENOLOL ZEN 50MG CPR",
  UCD7: '9382842',
  UCD13: '3400893828427',
  ucdQtyMultiplicator: 30,
  cipLib: "ATENOLOL ZEN 50MG CPR BT 30",
  atcCode: "C07AB03"
}, {
  CIP7: '2168726',
  CIP13: '3400921687262',
  ucdLib: "ATENOLOL ZEN 50MG CPR",
  UCD7: '9382842',
  UCD13: '3400893828427',
  ucdQtyMultiplicator: 90,
  cipLib: "ATENOLOL ZEN 50MG CPR BT 90",
  atcCode: "C07AB03"
}, {
  CIP7: '3230373',
  CIP13: '3400932303731',
  ucdLib: "LOPRESSOR LP 200MG CPR",
  UCD7: '9055103',
  UCD13: '3400890551038',
  ucdQtyMultiplicator: 30,
  cipLib: "LOPRESSOR LP 200MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '3310899',
  CIP13: '3400933108991',
  ucdLib: "SELOZOK LP 190MG CPR",
  UCD7: '9238588',
  UCD13: '3400892385884',
  ucdQtyMultiplicator: 28,
  cipLib: "SELOZOK LP 190MG CPR BT 28",
  atcCode: "C07AB02"
}, {
  CIP7: '3310847',
  CIP13: '3400933108472',
  ucdLib: "SELOZOK LP 95MG CPR",
  UCD7: '9238602',
  UCD13: '3400892386027',
  ucdQtyMultiplicator: 28,
  cipLib: "SELOZOK LP 95MG CPR BT 28",
  atcCode: "C07AB02"
}, {
  CIP7: '3225047',
  CIP13: '3400932250479',
  ucdLib: "LOPRESSOR 100MG CPR PELLIC",
  UCD7: '9055095',
  UCD13: '3400890550956',
  ucdQtyMultiplicator: 30,
  cipLib: "LOPRESSOR 100MG CPR PELLIC BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '3852494',
  CIP13: '3400938524949',
  ucdLib: "METOPROLOL RBX 100MG CPR",
  UCD7: '9317655',
  UCD13: '3400893176559',
  ucdQtyMultiplicator: 30,
  cipLib: "METOPROLOL RBX 100MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '3584674',
  CIP13: '3400935846747',
  ucdLib: "SELOZOK LP 23,75MG CPR",
  UCD7: '9238594',
  UCD13: '3400892385945',
  ucdQtyMultiplicator: 28,
  cipLib: "SELOZOK LP 23,75MG CPR BT 28",
  atcCode: "C07AB02"
}, {
  CIP7: '3766694',
  CIP13: '3400937666947',
  ucdLib: "METOPROLOL SDZ 100MG CPR",
  UCD7: '9291861',
  UCD13: '3400892918617',
  ucdQtyMultiplicator: 30,
  cipLib: "METOPROLOL SDZ 100MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '3766688',
  CIP13: '3400937666886',
  ucdLib: "METOPROLOL SDZ 50MG CPR",
  UCD7: '9291878',
  UCD13: '3400892918785',
  ucdQtyMultiplicator: 30,
  cipLib: "METOPROLOL SDZ 50MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '3722521',
  CIP13: '3400937225212',
  ucdLib: "SELOKEN LP 200MG CPR",
  UCD7: '9120384',
  UCD13: '3400891203844',
  ucdQtyMultiplicator: 30,
  cipLib: "SELOKEN LP 200MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '3722544',
  CIP13: '3400937225441',
  ucdLib: "SELOKEN LP 200MG CPR",
  UCD7: '9120384',
  UCD13: '3400891203844',
  ucdQtyMultiplicator: 90,
  cipLib: "SELOKEN LP 200MG CPR BT 90",
  atcCode: "C07AB02"
}, {
  CIP7: '3715030',
  CIP13: '3400937150309',
  ucdLib: "SELOKEN 100MG CPR",
  UCD7: '9152208',
  UCD13: '3400891522082',
  ucdQtyMultiplicator: 30,
  cipLib: "SELOKEN 100MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '3739355',
  CIP13: '3400937393553',
  ucdLib: "LOPRESSOR 100MG CPR PELLIC",
  UCD7: '9055095',
  UCD13: '3400890550956',
  ucdQtyMultiplicator: 90,
  cipLib: "LOPRESSOR 100MG CPR PELLIC BT 90",
  atcCode: "C07AB02"
}, {
  CIP7: '3739361',
  CIP13: '3400937393614',
  ucdLib: "LOPRESSOR LP 200MG CPR",
  UCD7: '9055103',
  UCD13: '3400890551038',
  ucdQtyMultiplicator: 90,
  cipLib: "LOPRESSOR LP 200MG CPR BT 90",
  atcCode: "C07AB02"
}, {
  CIP7: '3736291',
  CIP13: '3400937362917',
  ucdLib: "METOPROLOL RBX 100MG CPR",
  UCD7: '9317655',
  UCD13: '3400893176559',
  ucdQtyMultiplicator: 90,
  cipLib: "METOPROLOL RBX 100MG CPR BT 90",
  atcCode: "C07AB02"
}, {
  CIP7: '2232424',
  CIP13: '3400922324241',
  ucdLib: "METOPROLOL ACC 100MG CPR",
  UCD7: '9389666',
  UCD13: '3400893896662',
  ucdQtyMultiplicator: 30,
  cipLib: "METOPROLOL ACC 100MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '2232482',
  CIP13: '3400922324821',
  ucdLib: "METOPROLOL ACC 100MG CPR",
  UCD7: '9389666',
  UCD13: '3400893896662',
  ucdQtyMultiplicator: 90,
  cipLib: "METOPROLOL ACC 100MG CPR BT 90",
  atcCode: "C07AB02"
}, {
  CIP7: '2232335',
  CIP13: '3400922323350',
  ucdLib: "METOPROLOL ACC 50MG CPR",
  UCD7: '9389672',
  UCD13: '3400893896723',
  ucdQtyMultiplicator: 30,
  cipLib: "METOPROLOL ACC 50MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '4165554',
  CIP13: '3400941655548',
  ucdLib: "METOPROLOL ARW 100MG CPR",
  UCD7: '9376089',
  UCD13: '3400893760895',
  ucdQtyMultiplicator: 30,
  cipLib: "METOPROLOL ARW 100MG CPR BT 30",
  atcCode: "C07AB02"
}, {
  CIP7: '4165583',
  CIP13: '3400941655838',
  ucdLib: "METOPROLOL ARW 100MG CPR",
  UCD7: '9376089',
  UCD13: '3400893760895',
  ucdQtyMultiplicator: 90,
  cipLib: "METOPROLOL ARW 100MG CPR BT 90",
  atcCode: "C07AB02"
}, {
  CIP7: '3285121',
  CIP13: '3400932851218',
  ucdLib: "ARTEX 5MG CPR",
  UCD7: '9119576',
  UCD13: '3400891195767',
  ucdQtyMultiplicator: 30,
  cipLib: "ARTEX 5MG CPR BT 30",
  atcCode: "C07AA16"
}, {
  CIP7: '3478328',
  CIP13: '3400934783289',
  ucdLib: "CORGARD 80MG CPR",
  UCD7: '9022115',
  UCD13: '3400890221153',
  ucdQtyMultiplicator: 28,
  cipLib: "CORGARD 80MG CPR BT 28",
  atcCode: "C07AA12"
}, {
  CIP7: '3836561',
  CIP13: '3400938365610',
  ucdLib: "SOTALOL RBX 80MG CPR",
  UCD7: '9311960',
  UCD13: '3400893119600',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL RBX 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3616167',
  CIP13: '3400936161672',
  ucdLib: "SOTALOL TVC 160MG CPR",
  UCD7: '9247446',
  UCD13: '3400892474465',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL TVC 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3616150',
  CIP13: '3400936161504',
  ucdLib: "SOTALOL TVC 80MG CPR",
  UCD7: '9247452',
  UCD13: '3400892474526',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL TVC 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3579437',
  CIP13: '3400935794376',
  ucdLib: "SOTALOL BGA 160MG CPR",
  UCD7: '9235294',
  UCD13: '3400892352947',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL BGA 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3579414',
  CIP13: '3400935794147',
  ucdLib: "SOTALOL BGA 80MG CPR",
  UCD7: '9235302',
  UCD13: '3400892353029',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL BGA 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3579420',
  CIP13: '3400935794208',
  ucdLib: "SOTALOL BGA 80MG CPR",
  UCD7: '9235302',
  UCD13: '3400892353029',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL BGA 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3222563',
  CIP13: '3400932225637',
  ucdLib: "SOTALEX 160MG CPR",
  UCD7: '9086463',
  UCD13: '3400890864633',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALEX 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3601496',
  CIP13: '3400936014961',
  ucdLib: "SOTALOL ARW 160MG CPR",
  UCD7: '9242489',
  UCD13: '3400892424897',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL ARW 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3601510',
  CIP13: '3400936015104',
  ucdLib: "SOTALOL ARW 80MG CPR",
  UCD7: '9242495',
  UCD13: '3400892424958',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL ARW 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3602202',
  CIP13: '3400936022027',
  ucdLib: "SOTALOL ARW 80MG CPR",
  UCD7: '9242495',
  UCD13: '3400892424958',
  ucdQtyMultiplicator: 60,
  cipLib: "SOTALOL ARW 80MG CPR BT 60",
  atcCode: "C07AA07"
}, {
  CIP7: '3601616',
  CIP13: '3400936016163',
  ucdLib: "SOTALOL RTP 160MG CPR",
  UCD7: '9242207',
  UCD13: '3400892422077',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL RTP 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3601585',
  CIP13: '3400936015852',
  ucdLib: "SOTALOL RTP 80MG CPR",
  UCD7: '9242213',
  UCD13: '3400892422138',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL RTP 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3680745',
  CIP13: '3400936807457',
  ucdLib: "SOTALOL SDZ 160MG CPR",
  UCD7: '9269040',
  UCD13: '3400892690407',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL SDZ 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3680751',
  CIP13: '3400936807518',
  ucdLib: "SOTALOL SDZ 80MG CPR",
  UCD7: '9269057',
  UCD13: '3400892690575',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL SDZ 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3674868',
  CIP13: '3400936748682',
  ucdLib: "SOTALOL ZEN 160MG CPR",
  UCD7: '9270221',
  UCD13: '3400892702216',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL ZEN 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3674851',
  CIP13: '3400936748514',
  ucdLib: "SOTALOL ZEN 80MG CPR",
  UCD7: '9270238',
  UCD13: '3400892702384',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL ZEN 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3487008',
  CIP13: '3400934870088',
  ucdLib: "SOTALOL MYL 160MG CPR",
  UCD7: '9210532',
  UCD13: '3400892105321',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL MYL 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3486977',
  CIP13: '3400934869778',
  ucdLib: "SOTALOL MYL 80MG CPR",
  UCD7: '9210549',
  UCD13: '3400892105499',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL MYL 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3181580',
  CIP13: '3400931815808',
  ucdLib: "SOTALEX 80MG CPR",
  UCD7: '9086486',
  UCD13: '3400890864862',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALEX 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3549318',
  CIP13: '3400935493187',
  ucdLib: "SOTALOL CRT 160MG CPR",
  UCD7: '9232189',
  UCD13: '3400892321899',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL CRT 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3548997',
  CIP13: '3400935489975',
  ucdLib: "SOTALOL CRT 80MG CPR",
  UCD7: '9232195',
  UCD13: '3400892321950',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL CRT 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3549086',
  CIP13: '3400935490865',
  ucdLib: "SOTALOL EG 160MG CPR",
  UCD7: '9226906',
  UCD13: '3400892269061',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL EG 160MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3549057',
  CIP13: '3400935490575',
  ucdLib: "SOTALOL EG 80MG CPR",
  UCD7: '9226912',
  UCD13: '3400892269122',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL EG 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3897195',
  CIP13: '3400938971958',
  ucdLib: "SOTALOL ALM 80MG CPR",
  UCD7: '9324566',
  UCD13: '3400893245668',
  ucdQtyMultiplicator: 30,
  cipLib: "SOTALOL ALM 80MG CPR BT 30",
  atcCode: "C07AA07"
}, {
  CIP7: '3182036',
  CIP13: '3400931820369',
  ucdLib: "TIMACOR 10MG CPR",
  UCD7: '9093316',
  UCD13: '3400890933162',
  ucdQtyMultiplicator: 30,
  cipLib: "TIMACOR 10MG CPR BT 30",
  atcCode: "C07AA06"
}, {
  CIP7: '3003853',
  CIP13: '3400930038536',
  ucdLib: "PROPRANOLOL BGA 40MG CPR",
  UCD7: '9415228',
  UCD13: '3400894152286',
  ucdQtyMultiplicator: 50,
  cipLib: "PROPRANOLOL BGA 40MG CPR BT 50",
  atcCode: "C07AA05"
}, {
  CIP7: '3356996',
  CIP13: '3400933569969',
  ucdLib: "PROPRANOLOL TVC 40MG CPR",
  UCD7: '9157826',
  UCD13: '3400891578263',
  ucdQtyMultiplicator: 50,
  cipLib: "PROPRANOLOL TVC 40MG CPR BT 50",
  atcCode: "C07AA05"
}, {
  CIP7: '3656764',
  CIP13: '3400936567641',
  ucdLib: "PROPRANOLOL EG 40MG CPR",
  UCD7: '9264284',
  UCD13: '3400892642840',
  ucdQtyMultiplicator: 50,
  cipLib: "PROPRANOLOL EG 40MG CPR BT 50",
  atcCode: "C07AA05"
}, {
  CIP7: '3723414',
  CIP13: '3400937234146',
  ucdLib: "PROPRANOLOL TVC LP 80MG GELU",
  UCD7: '9144120',
  UCD13: '3400891441208',
  ucdQtyMultiplicator: 30,
  cipLib: "PROPRANOLOL TVC LP 80MG GELU BT 30",
  atcCode: "C07AA05"
}, {
  CIP7: '3723437',
  CIP13: '3400937234375',
  ucdLib: "PROPRANOLOL TVC LP 80MG GELU",
  UCD7: '9144120',
  UCD13: '3400891441208',
  ucdQtyMultiplicator: 90,
  cipLib: "PROPRANOLOL TVC LP 80MG GELU BT 90",
  atcCode: "C07AA05"
}, {
  CIP7: '3723093',
  CIP13: '3400937230933',
  ucdLib: "PROPRANOLOL TVC LP160MG GELU",
  UCD7: '9157803',
  UCD13: '3400891578034',
  ucdQtyMultiplicator: 30,
  cipLib: "PROPRANOLOL TVC LP160MG GELU BT 30",
  atcCode: "C07AA05"
}, {
  CIP7: '3723118',
  CIP13: '3400937231183',
  ucdLib: "PROPRANOLOL TVC LP160MG GELU",
  UCD7: '9157803',
  UCD13: '3400891578034',
  ucdQtyMultiplicator: 90,
  cipLib: "PROPRANOLOL TVC LP160MG GELU BT 90",
  atcCode: "C07AA05"
}, {
  CIP7: '2788363',
  CIP13: '3400927883637',
  ucdLib: "HEMANGIOL 3,75MG/ML BUV 120ML",
  UCD7: '9402243',
  UCD13: '3400894022435',
  ucdQtyMultiplicator: 1,
  cipLib: "HEMANGIOL 3,75MG/ML BUV 120ML BT 1",
  atcCode: "C07AA05"
}, {
  CIP7: '3224266',
  CIP13: '3400932242665',
  ucdLib: "VISKEN QUINZE CPR",
  UCD7: '9099141',
  UCD13: '3400890991414',
  ucdQtyMultiplicator: 30,
  cipLib: "VISKEN QUINZE CPR BT 30",
  atcCode: "C07AA03"
}, {
  CIP7: '3714674',
  CIP13: '3400937146746',
  ucdLib: "VISKEN 5MG CPR",
  UCD7: '9099135',
  UCD13: '3400890991353',
  ucdQtyMultiplicator: 90,
  cipLib: "VISKEN 5MG CPR BT 90",
  atcCode: "C07AA03"
}, {
  CIP7: '3714705',
  CIP13: '3400937147057',
  ucdLib: "VISKEN QUINZE CPR",
  UCD7: '9099141',
  UCD13: '3400890991414',
  ucdQtyMultiplicator: 90,
  cipLib: "VISKEN QUINZE CPR BT 90",
  atcCode: "C07AA03"
}, {
  CIP7: '3420174',
  CIP13: '3400934201745',
  ucdLib: "ETIOVEN 30MG CPR",
  UCD7: '9195100',
  UCD13: '3400891951004',
  ucdQtyMultiplicator: 30,
  cipLib: "ETIOVEN 30MG CPR BT 30",
  atcCode: "C05CX02"
}, {
  CIP7: '3304321',
  CIP13: '3400933043216',
  ucdLib: "GINKOR FORT GELU",
  UCD7: '9136155',
  UCD13: '3400891361551',
  ucdQtyMultiplicator: 30,
  cipLib: "GINKOR FORT GELU BT 30",
  atcCode: "C05CA54"
}, {
  CIP7: '3304344',
  CIP13: '3400933043445',
  ucdLib: "GINKOR FORT GELU",
  UCD7: '9136155',
  UCD13: '3400891361551',
  ucdQtyMultiplicator: 60,
  cipLib: "GINKOR FORT GELU BT 60",
  atcCode: "C05CA54"
}, {
  CIP7: '3834183',
  CIP13: '3400938341836',
  ucdLib: "DAFLON 500MG CPR",
  UCD7: '9119582',
  UCD13: '3400891195828',
  ucdQtyMultiplicator: 60,
  cipLib: "DAFLON 500MG CPR BT 60",
  atcCode: "C05CA53"
}, {
  CIP7: '3286600',
  CIP13: '3400932866007',
  ucdLib: "DAFLON 500MG CPR",
  UCD7: '9119582',
  UCD13: '3400891195828',
  ucdQtyMultiplicator: 30,
  cipLib: "DAFLON 500MG CPR BT 30",
  atcCode: "C05CA53"
}, {
  CIP7: '5583354',
  CIP13: '3400955833543',
  ucdLib: "DAFLON 500MG CPR",
  UCD7: '9119582',
  UCD13: '3400891195828',
  ucdQtyMultiplicator: 100,
  cipLib: "DAFLON 500MG CPR BT 100",
  atcCode: "C05CA53"
}, {
  CIP7: '4900055',
  CIP13: '3400949000555',
  ucdLib: "DAFLON 500MG CPR AIP MWI RO",
  UCD7: '9413821',
  UCD13: '3400894138211',
  ucdQtyMultiplicator: 60,
  cipLib: "DAFLON 500MG CPR AIP MWI RO BT 60",
  atcCode: "C05CA53"
}, {
  CIP7: '2225861',
  CIP13: '3400922258614',
  ucdLib: "FRACTION FLAV.MYP 500MG CPR",
  UCD7: '9393596',
  UCD13: '3400893935965',
  ucdQtyMultiplicator: 60,
  cipLib: "FRACTION FLAV.MYP 500MG CPR BT 60",
  atcCode: "C05CA53"
}, {
  CIP7: '3224792',
  CIP13: '3400932247929',
  ucdLib: "CIRKAN PREDNACINOLONE SUP",
  UCD7: '9019805',
  UCD13: '3400890198059',
  ucdQtyMultiplicator: 12,
  cipLib: "CIRKAN PREDNACINOLONE SUP BT 12",
  atcCode: "C05CA51"
}, {
  CIP7: '3348034',
  CIP13: '3400933480349',
  ucdLib: "ESBERIVEN FORT BUV AMP4ML",
  UCD7: '9156057',
  UCD13: '3400891560572',
  ucdQtyMultiplicator: 20,
  cipLib: "ESBERIVEN FORT BUV AMP4ML BT 20",
  atcCode: "C05CA51"
}, {
  CIP7: '3163346',
  CIP13: '3400931633464',
  ucdLib: "VELITEN CPR",
  UCD7: '9098093',
  UCD13: '3400890980937',
  ucdQtyMultiplicator: 30,
  cipLib: "VELITEN CPR BT 30",
  atcCode: "C05CA51"
}, {
  CIP7: '3840338',
  CIP13: '3400938403381',
  ucdLib: "VELITEN CPR",
  UCD7: '9098093',
  UCD13: '3400890980937',
  ucdQtyMultiplicator: 90,
  cipLib: "VELITEN CPR BT 90",
  atcCode: "C05CA51"
}, {
  CIP7: '3330494',
  CIP13: '3400933304942',
  ucdLib: "VEINAMITOL 3500MG BUV A.7ML",
  UCD7: '9149749',
  UCD13: '3400891497496',
  ucdQtyMultiplicator: 10,
  cipLib: "VEINAMITOL 3500MG BUV A.7ML BT 10",
  atcCode: "C05CA04"
}, {
  CIP7: '3362778',
  CIP13: '3400933627782',
  ucdLib: "RHEOFLUX 3500MG BUV AMP7ML",
  UCD7: '9167871',
  UCD13: '3400891678710',
  ucdQtyMultiplicator: 10,
  cipLib: "RHEOFLUX 3500MG BUV AMP7ML BT 10",
  atcCode: "C05CA04"
}, {
  CIP7: '3362784',
  CIP13: '3400933627843',
  ucdLib: "RHEOFLUX 3500MG PDR SACH",
  UCD7: '9167865',
  UCD13: '3400891678659',
  ucdQtyMultiplicator: 10,
  cipLib: "RHEOFLUX 3500MG PDR SACH BT 10",
  atcCode: "C05CA04"
}, {
  CIP7: '3364599',
  CIP13: '3400933645991',
  ucdLib: "VEINAMITOL 3500MG PDR SACH",
  UCD7: '9163028',
  UCD13: '3400891630282',
  ucdQtyMultiplicator: 10,
  cipLib: "VEINAMITOL 3500MG PDR SACH BT 10",
  atcCode: "C05CA04"
}, {
  CIP7: '3489473',
  CIP13: '3400934894732',
  ucdLib: "TROXERUTINE MYL 3,5G SACH",
  UCD7: '9213281',
  UCD13: '3400892132815',
  ucdQtyMultiplicator: 10,
  cipLib: "TROXERUTINE MYL 3,5G SACH BT 10",
  atcCode: "C05CA04"
}, {
  CIP7: '3783037',
  CIP13: '3400937830379',
  ucdLib: "TROXERUTINE BGC 3,5G SACH",
  UCD7: '9303771',
  UCD13: '3400893037713',
  ucdQtyMultiplicator: 10,
  cipLib: "TROXERUTINE BGC 3,5G SACH BT 10",
  atcCode: "C05CA04"
}, {
  CIP7: '3616055',
  CIP13: '3400936160552',
  ucdLib: "DIOSMINE TCO 300MG CPR",
  UCD7: '9246694',
  UCD13: '3400892466941',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE TCO 300MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3616061',
  CIP13: '3400936160613',
  ucdLib: "DIOSMINE TCO 300MG CPR",
  UCD7: '9246694',
  UCD13: '3400892466941',
  ucdQtyMultiplicator: 60,
  cipLib: "DIOSMINE TCO 300MG CPR BT 60",
  atcCode: "C05CA03"
}, {
  CIP7: '3616078',
  CIP13: '3400936160781',
  ucdLib: "DIOSMINE TCO 600MG CPR",
  UCD7: '9246702',
  UCD13: '3400892467023',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE TCO 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3576976',
  CIP13: '3400935769763',
  ucdLib: "DIOSMINE ARW 600MG CPR",
  UCD7: '9236715',
  UCD13: '3400892367156',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE ARW 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3335818',
  CIP13: '3400933358181',
  ucdLib: "DIO 300MG CPR",
  UCD7: '9151574',
  UCD13: '3400891515749',
  ucdQtyMultiplicator: 30,
  cipLib: "DIO 300MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3603466',
  CIP13: '3400936034662',
  ucdLib: "DIOSMINE RTC 600MG CPR",
  UCD7: '9246151',
  UCD13: '3400892461519',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE RTC 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3681940',
  CIP13: '3400936819405',
  ucdLib: "DIOSMINE SDC 600MG CPR",
  UCD7: '9268879',
  UCD13: '3400892688794',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE SDC 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3372699',
  CIP13: '3400933726997',
  ucdLib: "DIOVENOR 600MG CPR",
  UCD7: '9171594',
  UCD13: '3400891715941',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOVENOR 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3347951',
  CIP13: '3400933479510',
  ucdLib: "MEDIVEINE 300MG CPR",
  UCD7: '9169060',
  UCD13: '3400891690606',
  ucdQtyMultiplicator: 30,
  cipLib: "MEDIVEINE 300MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3347968',
  CIP13: '3400933479688',
  ucdLib: "MEDIVEINE 300MG CPR",
  UCD7: '9169060',
  UCD13: '3400891690606',
  ucdQtyMultiplicator: 60,
  cipLib: "MEDIVEINE 300MG CPR BT 60",
  atcCode: "C05CA03"
}, {
  CIP7: '3562537',
  CIP13: '3400935625373',
  ucdLib: "DIO 600MG CPR DISP",
  UCD7: '9228911',
  UCD13: '3400892289113',
  ucdQtyMultiplicator: 30,
  cipLib: "DIO 600MG CPR DISP BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3561785',
  CIP13: '3400935617859',
  ucdLib: "DIOSMINE BGC 300MG CPR",
  UCD7: '9230440',
  UCD13: '3400892304403',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE BGC 300MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3561816',
  CIP13: '3400935618160',
  ucdLib: "DIOSMINE BGC 600MG CPR",
  UCD7: '9230457',
  UCD13: '3400892304571',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE BGC 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3559239',
  CIP13: '3400935592392',
  ucdLib: "DIOSMINE EG 600MG CPR",
  UCD7: '9229388',
  UCD13: '3400892293882',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE EG 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3563778',
  CIP13: '3400935637789',
  ucdLib: "DIOSMINE RPG 600MG CPR",
  UCD7: '9229709',
  UCD13: '3400892297095',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE RPG 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3561779',
  CIP13: '3400935617798',
  ucdLib: "DIOSMINE ZYD 600MG CPR",
  UCD7: '9230434',
  UCD13: '3400892304342',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE ZYD 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3562721',
  CIP13: '3400935627216',
  ucdLib: "VENACLAR 600MG CPR",
  UCD7: '9230517',
  UCD13: '3400892305172',
  ucdQtyMultiplicator: 30,
  cipLib: "VENACLAR 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3656356',
  CIP13: '3400936563568',
  ucdLib: "DIOSMINE MYL 300MG CPR",
  UCD7: '9267555',
  UCD13: '3400892675558',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE MYL 300MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3480650',
  CIP13: '3400934806506',
  ucdLib: "DIOVENOR 600MG BUV PDR SACH",
  UCD7: '9212749',
  UCD13: '3400892127491',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOVENOR 600MG BUV PDR SACH BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3511132',
  CIP13: '3400935111326',
  ucdLib: "MEDIVEINE 600MG CPR",
  UCD7: '9212761',
  UCD13: '3400892127613',
  ucdQtyMultiplicator: 30,
  cipLib: "MEDIVEINE 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3631095',
  CIP13: '3400936310957',
  ucdLib: "DIOSMINE CRT 600MG CPR",
  UCD7: '9267064',
  UCD13: '3400892670645',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE CRT 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3491151',
  CIP13: '3400934911514',
  ucdLib: "DIOSMINE MYL 600MG CPR",
  UCD7: '9210012',
  UCD13: '3400892100128',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE MYL 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3500157',
  CIP13: '3400935001573',
  ucdLib: "DIOSMINE ZTC 600MG CPR",
  UCD7: '9211454',
  UCD13: '3400892114545',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMINE ZTC 600MG CPR BT 30",
  atcCode: "C05CA03"
}, {
  CIP7: '3361951',
  CIP13: '3400933619510',
  ucdLib: "ESBERIVEN FORT CPR",
  UCD7: '9171677',
  UCD13: '3400891716771',
  ucdQtyMultiplicator: 30,
  cipLib: "ESBERIVEN FORT CPR BT 30",
  atcCode: "C05CA01"
}, {
  CIP7: '3949897',
  CIP13: '3400939498973',
  ucdLib: "ESBERIVEN FORT CPR",
  UCD7: '9171677',
  UCD13: '3400891716771',
  ucdQtyMultiplicator: 60,
  cipLib: "ESBERIVEN FORT CPR BT 60",
  atcCode: "C05CA01"
}, {
  CIP7: '3117286',
  CIP13: '3400931172864',
  ucdLib: "DOXIUM 250MG CPR",
  UCD7: '9028827',
  UCD13: '3400890288279',
  ucdQtyMultiplicator: 30,
  cipLib: "DOXIUM 250MG CPR BT 30",
  atcCode: "C05BX01"
}, {
  CIP7: '4911980',
  CIP13: '3400949119806',
  ucdLib: "TROMBOVAR 1% IV AMP2ML",
  UCD7: '9095338',
  UCD13: '3400890953382',
  ucdQtyMultiplicator: 5,
  cipLib: "TROMBOVAR 1% IV AMP2ML BT 5",
  atcCode: "C05BB04"
}, {
  CIP7: '4911997',
  CIP13: '3400949119974',
  ucdLib: "TROMBOVAR 3% IV AMP2ML",
  UCD7: '9095344',
  UCD13: '3400890953443',
  ucdQtyMultiplicator: 5,
  cipLib: "TROMBOVAR 3% IV AMP2ML BT 5",
  atcCode: "C05BB04"
}, {
  CIP7: '2688242',
  CIP13: '3400926882426',
  ucdLib: "FIBROVEIN 0,2% INJ FL5ML",
  UCD7: '9404124',
  UCD13: '3400894041245',
  ucdQtyMultiplicator: 5,
  cipLib: "FIBROVEIN 0,2% INJ FL5ML BT 5",
  atcCode: "C05BB04"
}, {
  CIP7: '2688265',
  CIP13: '3400926882655',
  ucdLib: "FIBROVEIN 0,5% INJ AMP2ML",
  UCD7: '9404130',
  UCD13: '3400894041306',
  ucdQtyMultiplicator: 5,
  cipLib: "FIBROVEIN 0,5% INJ AMP2ML BT 5",
  atcCode: "C05BB04"
}, {
  CIP7: '2688325',
  CIP13: '3400926883256',
  ucdLib: "FIBROVEIN 1% INJ AMP2ML",
  UCD7: '9404147',
  UCD13: '3400894041474',
  ucdQtyMultiplicator: 5,
  cipLib: "FIBROVEIN 1% INJ AMP2ML BT 5",
  atcCode: "C05BB04"
}, {
  CIP7: '2688360',
  CIP13: '3400926883607',
  ucdLib: "FIBROVEIN 3% INJ AMP2ML",
  UCD7: '9404153',
  UCD13: '3400894041535',
  ucdQtyMultiplicator: 5,
  cipLib: "FIBROVEIN 3% INJ AMP2ML BT 5",
  atcCode: "C05BB04"
}, {
  CIP7: '2688348',
  CIP13: '3400926883485',
  ucdLib: "FIBROVEIN 3% INJ FL5ML",
  UCD7: '9404176',
  UCD13: '3400894041764',
  ucdQtyMultiplicator: 5,
  cipLib: "FIBROVEIN 3% INJ FL5ML BT 5",
  atcCode: "C05BB04"
}, {
  CIP7: '3477553',
  CIP13: '3400934775536',
  ucdLib: "AETOXISCLEROL TAM.0,25% A2ML",
  UCD7: '9204052',
  UCD13: '3400892040523',
  ucdQtyMultiplicator: 5,
  cipLib: "AETOXISCLEROL TAM.0,25% A2ML BT 5",
  atcCode: "C05BB02"
}, {
  CIP7: '3477524',
  CIP13: '3400934775246',
  ucdLib: "AETOXISCLEROL TAM.0,50% A2ML",
  UCD7: '9204069',
  UCD13: '3400892040691',
  ucdQtyMultiplicator: 5,
  cipLib: "AETOXISCLEROL TAM.0,50% A2ML BT 5",
  atcCode: "C05BB02"
}, {
  CIP7: '3477547',
  CIP13: '3400934775475',
  ucdLib: "AETOXISCLEROL TAM.2% A2ML",
  UCD7: '9204075',
  UCD13: '3400892040752',
  ucdQtyMultiplicator: 5,
  cipLib: "AETOXISCLEROL TAM.2% A2ML BT 5",
  atcCode: "C05BB02"
}, {
  CIP7: '3477530',
  CIP13: '3400934775307',
  ucdLib: "AETOXISCLEROL TAM.3% A2ML",
  UCD7: '9204081',
  UCD13: '3400892040813',
  ucdQtyMultiplicator: 5,
  cipLib: "AETOXISCLEROL TAM.3% A2ML BT 5",
  atcCode: "C05BB02"
}, {
  CIP7: '3335250',
  CIP13: '3400933352509',
  ucdLib: "ESBERIVEN CR DERM TB100G",
  UCD7: '9193791',
  UCD13: '3400891937916',
  ucdQtyMultiplicator: 1,
  cipLib: "ESBERIVEN CR DERM TB100G BT 1",
  atcCode: "C05BA53"
}, {
  CIP7: '3047930',
  CIP13: '3400930479308',
  ucdLib: "HEMOCLAR 0,5% CR TB30G",
  UCD7: '9042299',
  UCD13: '3400890422994',
  ucdQtyMultiplicator: 1,
  cipLib: "HEMOCLAR 0,5% CR TB30G BT 1",
  atcCode: "C05BA04"
}, {
  CIP7: '3230077',
  CIP13: '3400932300778',
  ucdLib: "TITANOREINE SUP",
  UCD7: '9093405',
  UCD13: '3400890934053',
  ucdQtyMultiplicator: 12,
  cipLib: "TITANOREINE SUP BT 12",
  atcCode: "C05AX04"
}, {
  CIP7: '3476849',
  CIP13: '3400934768491',
  ucdLib: "TITANOREINE CR TB40G",
  UCD7: '9231066',
  UCD13: '3400892310664',
  ucdQtyMultiplicator: 1,
  cipLib: "TITANOREINE CR TB40G BT 1",
  atcCode: "C05AX04"
}, {
  CIP7: '3110143',
  CIP13: '3400931101437',
  ucdLib: "ULTRAPROCT SUP",
  UCD7: '9096355',
  UCD13: '3400890963558',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRAPROCT SUP BT 10",
  atcCode: "C05AX03"
}, {
  CIP7: '3140724',
  CIP13: '3400931407249',
  ucdLib: "PROCTOLOG CR RECT TB20G",
  UCD7: '9075904',
  UCD13: '3400890759045',
  ucdQtyMultiplicator: 1,
  cipLib: "PROCTOLOG CR RECT TB20G BT 1",
  atcCode: "C05AX03"
}, {
  CIP7: '3140730',
  CIP13: '3400931407300',
  ucdLib: "PROCTOLOG SUP",
  UCD7: '9075910',
  UCD13: '3400890759106',
  ucdQtyMultiplicator: 10,
  cipLib: "PROCTOLOG SUP BT 10",
  atcCode: "C05AX03"
}, {
  CIP7: '3139170',
  CIP13: '3400931391708',
  ucdLib: "ULTRAPROCT POM RECT TB30G",
  UCD7: '9403596',
  UCD13: '3400894035961',
  ucdQtyMultiplicator: 1,
  cipLib: "ULTRAPROCT POM RECT TB30G BT 1",
  atcCode: "C05AX03"
}, {
  CIP7: '3765370',
  CIP13: '3400937653701',
  ucdLib: "RECTOGESIC 4MG/G POM RECT 30G",
  UCD7: '9301358',
  UCD13: '3400893013588',
  ucdQtyMultiplicator: 1,
  cipLib: "RECTOGESIC 4MG/G POM RECT 30G BT 1",
  atcCode: "C05AE01"
}, {
  CIP7: '3108726',
  CIP13: '3400931087267',
  ucdLib: "TRONOTHANE 1% GEL LOC TB30G",
  UCD7: '9095367',
  UCD13: '3400890953672',
  ucdQtyMultiplicator: 1,
  cipLib: "TRONOTHANE 1% GEL LOC TB30G BT 1",
  atcCode: "C05AD07"
}, {
  CIP7: '3131493',
  CIP13: '3400931314936',
  ucdLib: "PHLEBOCREME CR RECT TB30G",
  UCD7: '9195382',
  UCD13: '3400891953824',
  ucdQtyMultiplicator: 1,
  cipLib: "PHLEBOCREME CR RECT TB30G BT 1",
  atcCode: "C05AD03"
}, {
  CIP7: '3205843',
  CIP13: '3400932058433',
  ucdLib: "PHLEBOSUP SUP",
  UCD7: '9200640',
  UCD13: '3400892006406',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLEBOSUP SUP BT 10",
  atcCode: "C05AD03"
}, {
  CIP7: '3762584',
  CIP13: '3400937625845',
  ucdLib: "SEDORRHOIDE CRISE HEMOR. CR30G",
  UCD7: '9297361',
  UCD13: '3400892973616',
  ucdQtyMultiplicator: 1,
  cipLib: "SEDORRHOIDE CRISE HEMOR. CR30G BT 1",
  atcCode: "C05AD03"
}, {
  CIP7: '3762609',
  CIP13: '3400937626095',
  ucdLib: "SEDORRHOIDE CRISE HEMOR. SUP",
  UCD7: '9297378',
  UCD13: '3400892973784',
  ucdQtyMultiplicator: 8,
  cipLib: "SEDORRHOIDE CRISE HEMOR. SUP BT 8",
  atcCode: "C05AD03"
}, {
  CIP7: '3237240',
  CIP13: '3400932372409',
  ucdLib: "TITANOREINE 2% CR RECT TB20G",
  UCD7: '9093397',
  UCD13: '3400890933971',
  ucdQtyMultiplicator: 1,
  cipLib: "TITANOREINE 2% CR RECT TB20G BT 1",
  atcCode: "C05AD01"
}, {
  CIP7: '3028884',
  CIP13: '3400930288849',
  ucdLib: "DELIPROCT SUP",
  UCD7: '9024551',
  UCD13: '3400890245517',
  ucdQtyMultiplicator: 6,
  cipLib: "DELIPROCT SUP BT 6",
  atcCode: "C05AA04"
}, {
  CIP7: '3139543',
  CIP13: '3400931395430',
  ucdLib: "DELIPROCT POM RECT TB30G",
  UCD7: '9403550',
  UCD13: '3400894035503',
  ucdQtyMultiplicator: 1,
  cipLib: "DELIPROCT POM RECT TB30G BT 1",
  atcCode: "C05AA04"
}, {
  CIP7: '3328793',
  CIP13: '3400933287931',
  ucdLib: "PRAXILENE 100MG GELU",
  UCD7: '9074804',
  UCD13: '3400890748049',
  ucdQtyMultiplicator: 20,
  cipLib: "PRAXILENE 100MG GELU BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3257656',
  CIP13: '3400932576562',
  ucdLib: "NAFTILUX 200MG GELU",
  UCD7: '9060825',
  UCD13: '3400890608251',
  ucdQtyMultiplicator: 20,
  cipLib: "NAFTILUX 200MG GELU BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3242643',
  CIP13: '3400932426430',
  ucdLib: "PRAXILENE 200MG CPR",
  UCD7: '9074827',
  UCD13: '3400890748278',
  ucdQtyMultiplicator: 20,
  cipLib: "PRAXILENE 200MG CPR BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '5592376',
  CIP13: '3400955923763',
  ucdLib: "PRAXILENE 200MG CPR",
  UCD7: '9074827',
  UCD13: '3400890748278',
  ucdQtyMultiplicator: 50,
  cipLib: "PRAXILENE 200MG CPR BT 50",
  atcCode: "C04AX21"
}, {
  CIP7: '3464421',
  CIP13: '3400934644214',
  ucdLib: "NAFTIDROFURYL MYL 100MG GELU",
  UCD7: '9181351',
  UCD13: '3400891813517',
  ucdQtyMultiplicator: 20,
  cipLib: "NAFTIDROFURYL MYL 100MG GELU BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3464438',
  CIP13: '3400934644382',
  ucdLib: "NAFTIDROFURYL MYL 200MG CPR",
  UCD7: '9181368',
  UCD13: '3400891813685',
  ucdQtyMultiplicator: 20,
  cipLib: "NAFTIDROFURYL MYL 200MG CPR BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3666461',
  CIP13: '3400936664616',
  ucdLib: "NAFTIDROFURYL EG 200MG CPR",
  UCD7: '9269407',
  UCD13: '3400892694078',
  ucdQtyMultiplicator: 20,
  cipLib: "NAFTIDROFURYL EG 200MG CPR BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3666484',
  CIP13: '3400936664845',
  ucdLib: "NAFTIDROFURYL EG 200MG CPR",
  UCD7: '9269407',
  UCD13: '3400892694078',
  ucdQtyMultiplicator: 90,
  cipLib: "NAFTIDROFURYL EG 200MG CPR BT 90",
  atcCode: "C04AX21"
}, {
  CIP7: '3711670',
  CIP13: '3400937116701',
  ucdLib: "DIACTANE 200MG CPR",
  UCD7: '9283761',
  UCD13: '3400892837611',
  ucdQtyMultiplicator: 20,
  cipLib: "DIACTANE 200MG CPR BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3711753',
  CIP13: '3400937117531',
  ucdLib: "NAFTIDROFURYL BGA 200MG CPR",
  UCD7: '9283577',
  UCD13: '3400892835778',
  ucdQtyMultiplicator: 20,
  cipLib: "NAFTIDROFURYL BGA 200MG CPR BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3711799',
  CIP13: '3400937117999',
  ucdLib: "NAFTIDROFURYL BGA 200MG CPR",
  UCD7: '9283577',
  UCD13: '3400892835778',
  ucdQtyMultiplicator: 90,
  cipLib: "NAFTIDROFURYL BGA 200MG CPR BT 90",
  atcCode: "C04AX21"
}, {
  CIP7: '3474916',
  CIP13: '3400934749162',
  ucdLib: "NAFTIDROFURYL MYL 200MG CPR",
  UCD7: '9181368',
  UCD13: '3400891813685',
  ucdQtyMultiplicator: 90,
  cipLib: "NAFTIDROFURYL MYL 200MG CPR BT 90",
  atcCode: "C04AX21"
}, {
  CIP7: '3711517',
  CIP13: '3400937115179',
  ucdLib: "NAFTIDROFURYL RBX 200MG CPR",
  UCD7: '9283755',
  UCD13: '3400892837550',
  ucdQtyMultiplicator: 20,
  cipLib: "NAFTIDROFURYL RBX 200MG CPR BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3711552',
  CIP13: '3400937115520',
  ucdLib: "NAFTIDROFURYL RBX 200MG CPR",
  UCD7: '9283755',
  UCD13: '3400892837550',
  ucdQtyMultiplicator: 90,
  cipLib: "NAFTIDROFURYL RBX 200MG CPR BT 90",
  atcCode: "C04AX21"
}, {
  CIP7: '3647765',
  CIP13: '3400936477650',
  ucdLib: "NAFTIDROFURYL TVC 200MG CPR",
  UCD7: '9265237',
  UCD13: '3400892652375',
  ucdQtyMultiplicator: 20,
  cipLib: "NAFTIDROFURYL TVC 200MG CPR BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3647788',
  CIP13: '3400936477889',
  ucdLib: "NAFTIDROFURYL TVC 200MG CPR",
  UCD7: '9265237',
  UCD13: '3400892652375',
  ucdQtyMultiplicator: 90,
  cipLib: "NAFTIDROFURYL TVC 200MG CPR BT 90",
  atcCode: "C04AX21"
}, {
  CIP7: '3711718',
  CIP13: '3400937117180',
  ucdLib: "NAFTIDROFURYL ZEN 200MG CPR",
  UCD7: '9283873',
  UCD13: '3400892838731',
  ucdQtyMultiplicator: 20,
  cipLib: "NAFTIDROFURYL ZEN 200MG CPR BT 20",
  atcCode: "C04AX21"
}, {
  CIP7: '3711747',
  CIP13: '3400937117470',
  ucdLib: "NAFTIDROFURYL ZEN 200MG CPR",
  UCD7: '9283873',
  UCD13: '3400892838731',
  ucdQtyMultiplicator: 90,
  cipLib: "NAFTIDROFURYL ZEN 200MG CPR BT 90",
  atcCode: "C04AX21"
}, {
  CIP7: '3420553',
  CIP13: '3400934205538',
  ucdLib: "PRAXILENE 200MG CPR",
  UCD7: '9074827',
  UCD13: '3400890748278',
  ucdQtyMultiplicator: 90,
  cipLib: "PRAXILENE 200MG CPR BT 90",
  atcCode: "C04AX21"
}, {
  CIP7: '3018992',
  CIP13: '3400930189924',
  ucdLib: "CARLYTENE 30MG CPR",
  UCD7: '9016557',
  UCD13: '3400890165570',
  ucdQtyMultiplicator: 32,
  cipLib: "CARLYTENE 30MG CPR BT 32",
  atcCode: "C04AX10"
}, {
  CIP7: '3348732',
  CIP13: '3400933487324',
  ucdLib: "PENTOFLUX LP 400MG CPR",
  UCD7: '9154489',
  UCD13: '3400891544893',
  ucdQtyMultiplicator: 30,
  cipLib: "PENTOFLUX LP 400MG CPR BT 30",
  atcCode: "C04AD03"
}, {
  CIP7: '3679618',
  CIP13: '3400936796188',
  ucdLib: "PENTOXIF.SDZ LP 400MG CPR",
  UCD7: '9268684',
  UCD13: '3400892686844',
  ucdQtyMultiplicator: 30,
  cipLib: "PENTOXIF.SDZ LP 400MG CPR BT 30",
  atcCode: "C04AD03"
}, {
  CIP7: '3512841',
  CIP13: '3400935128416',
  ucdLib: "PENTOXIF.BGA LP 400MG CPR",
  UCD7: '9215831',
  UCD13: '3400892158310',
  ucdQtyMultiplicator: 30,
  cipLib: "PENTOXIF.BGA LP 400MG CPR BT 30",
  atcCode: "C04AD03"
}, {
  CIP7: '3587922',
  CIP13: '3400935879226',
  ucdLib: "PENTOXIF.EG LP 400MG CPR",
  UCD7: '9237206',
  UCD13: '3400892372068',
  ucdQtyMultiplicator: 30,
  cipLib: "PENTOXIF.EG LP 400MG CPR BT 30",
  atcCode: "C04AD03"
}, {
  CIP7: '3497679',
  CIP13: '3400934976797',
  ucdLib: "PENTOXIF.MYL LP 400MG CPR",
  UCD7: '9208185',
  UCD13: '3400892081854',
  ucdQtyMultiplicator: 30,
  cipLib: "PENTOXIF.MYL LP 400MG CPR BT 30",
  atcCode: "C04AD03"
}, {
  CIP7: '3001343',
  CIP13: '3400930013434',
  ucdLib: "JINARC 15MG CPR",
  UCD7: '9412483',
  UCD13: '3400894124832',
  ucdQtyMultiplicator: 7,
  cipLib: "JINARC 15MG CPR BT 7",
  atcCode: "C03XA01"
}, {
  CIP7: '3001606',
  CIP13: '3400930016060',
  ucdLib: "JINARC 15MG/45MG CPR",
  UCD7: '9412508',
  UCD13: '3400894125082',
  ucdQtyMultiplicator: 56,
  cipLib: "JINARC 15MG/45MG CPR BT 56",
  atcCode: "C03XA01"
}, {
  CIP7: '3001345',
  CIP13: '3400930013458',
  ucdLib: "JINARC 30MG CPR",
  UCD7: '9412514',
  UCD13: '3400894125143',
  ucdQtyMultiplicator: 7,
  cipLib: "JINARC 30MG CPR BT 7",
  atcCode: "C03XA01"
}, {
  CIP7: '3001609',
  CIP13: '3400930016091',
  ucdLib: "JINARC 30MG/60MG CPR",
  UCD7: '9412520',
  UCD13: '3400894125204',
  ucdQtyMultiplicator: 56,
  cipLib: "JINARC 30MG/60MG CPR BT 56",
  atcCode: "C03XA01"
}, {
  CIP7: '3001611',
  CIP13: '3400930016114',
  ucdLib: "JINARC 30MG/90MG CPR",
  UCD7: '9412537',
  UCD13: '3400894125372',
  ucdQtyMultiplicator: 56,
  cipLib: "JINARC 30MG/90MG CPR BT 56",
  atcCode: "C03XA01"
}, {
  CIP7: '5910095',
  CIP13: '3400959100955',
  ucdLib: "SAMSCA 15MG CPR",
  UCD7: '9343776',
  UCD13: '3400893437766',
  ucdQtyMultiplicator: 10,
  cipLib: "SAMSCA 15MG CPR BT 10",
  atcCode: "C03XA01"
}, {
  CIP7: '3297578',
  CIP13: '3400932975785',
  ucdLib: "LOGIRENE CPR",
  UCD7: '9126754',
  UCD13: '3400891267549',
  ucdQtyMultiplicator: 30,
  cipLib: "LOGIRENE CPR BT 30",
  atcCode: "C03EB01"
}, {
  CIP7: '5534568',
  CIP13: '3400955345688',
  ucdLib: "ALDACTAZINE CPR",
  UCD7: '9002093',
  UCD13: '3400890020930',
  ucdQtyMultiplicator: 100,
  cipLib: "ALDACTAZINE CPR BT 100",
  atcCode: "C03EA04"
}, {
  CIP7: '3611649',
  CIP13: '3400936116498',
  ucdLib: "SPIRONOLACTONE ALTI.TVC CPR",
  UCD7: '9245401',
  UCD13: '3400892454016',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ALTI.TVC CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3522377',
  CIP13: '3400935223777',
  ucdLib: "SPIROCTAZINE CPR",
  UCD7: '9087178',
  UCD13: '3400890871785',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIROCTAZINE CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3409764',
  CIP13: '3400934097645',
  ucdLib: "SPIRONOLACTONE ALTI.MYL CPR",
  UCD7: '9181546',
  UCD13: '3400891815467',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ALTI.MYL CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3673780',
  CIP13: '3400936737808',
  ucdLib: "SPIRONOLACTONE ALTI.ZEN CPR",
  UCD7: '9266840',
  UCD13: '3400892668406',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ALTI.ZEN CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3512551',
  CIP13: '3400935125514',
  ucdLib: "ALDACTAZINE CPR",
  UCD7: '9002093',
  UCD13: '3400890020930',
  ucdQtyMultiplicator: 30,
  cipLib: "ALDACTAZINE CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3597872',
  CIP13: '3400935978721',
  ucdLib: "SPIRONOLACTONE ALTI.ARW CPR",
  UCD7: '9242242',
  UCD13: '3400892422428',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ALTI.ARW CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3514768',
  CIP13: '3400935147684',
  ucdLib: "SPIRONOLACTONE ALTI.EG CPR",
  UCD7: '9202490',
  UCD13: '3400892024905',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ALTI.EG CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3723348',
  CIP13: '3400937233484',
  ucdLib: "ALDACTAZINE CPR",
  UCD7: '9002093',
  UCD13: '3400890020930',
  ucdQtyMultiplicator: 90,
  cipLib: "ALDACTAZINE CPR BT 90",
  atcCode: "C03EA04"
}, {
  CIP7: '3729693',
  CIP13: '3400937296939',
  ucdLib: "SPIRONOLACTONE ALTI.PFZ CPR",
  UCD7: '9219941',
  UCD13: '3400892199412',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE ALTI.PFZ CPR BT 90",
  atcCode: "C03EA04"
}, {
  CIP7: '3666627',
  CIP13: '3400936666276',
  ucdLib: "SPIRONOLACTONE ALTI.SDZ CPR",
  UCD7: '9272125',
  UCD13: '3400892721255',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ALTI.SDZ CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3729055',
  CIP13: '3400937290555',
  ucdLib: "SPIRONOLACTONE ALTI.TVC CPR",
  UCD7: '9245401',
  UCD13: '3400892454016',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE ALTI.TVC CPR BT 90",
  atcCode: "C03EA04"
}, {
  CIP7: '3496616',
  CIP13: '3400934966163',
  ucdLib: "SPIRONOLACTONE ALTI.BGA CPR",
  UCD7: '9209569',
  UCD13: '3400892095691',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ALTI.BGA CPR BT 30",
  atcCode: "C03EA04"
}, {
  CIP7: '3784812',
  CIP13: '3400937848121',
  ucdLib: "SPIRONOLACTONE ALTI.BGA CPR",
  UCD7: '9209569',
  UCD13: '3400892095691',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE ALTI.BGA CPR BT 90",
  atcCode: "C03EA04"
}, {
  CIP7: '3739272',
  CIP13: '3400937392723',
  ucdLib: "SPIRONOLACTONE ALTI.EG CPR",
  UCD7: '9202490',
  UCD13: '3400892024905',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE ALTI.EG CPR BT 90",
  atcCode: "C03EA04"
}, {
  CIP7: '3738315',
  CIP13: '3400937383158',
  ucdLib: "SPIRONOLACTONE ALTI.MYL CPR",
  UCD7: '9181546',
  UCD13: '3400891815467',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE ALTI.MYL CPR BT 90",
  atcCode: "C03EA04"
}, {
  CIP7: '3149240',
  CIP13: '3400931492405',
  ucdLib: "MODURETIC CPR",
  UCD7: '9059489',
  UCD13: '3400890594899',
  ucdQtyMultiplicator: 30,
  cipLib: "MODURETIC CPR BT 30",
  atcCode: "C03EA01"
}, {
  CIP7: '3417798',
  CIP13: '3400934177989',
  ucdLib: "AMILORIDE-HYDROCHLOR.RPG CPR",
  UCD7: '9194170',
  UCD13: '3400891941708',
  ucdQtyMultiplicator: 30,
  cipLib: "AMILORIDE-HYDROCHLOR.RPG CPR BT 30",
  atcCode: "C03EA01"
}, {
  CIP7: '3519205',
  CIP13: '3400935192059',
  ucdLib: "AMILORIDE-HYDROCHLOR.TVC CPR",
  UCD7: '9218284',
  UCD13: '3400892182841',
  ucdQtyMultiplicator: 30,
  cipLib: "AMILORIDE-HYDROCHLOR.TVC CPR BT 30",
  atcCode: "C03EA01"
}, {
  CIP7: '3185135',
  CIP13: '3400931851356',
  ucdLib: "PRESTOLE GELU",
  UCD7: '9075086',
  UCD13: '3400890750868',
  ucdQtyMultiplicator: 30,
  cipLib: "PRESTOLE GELU BT 30",
  atcCode: "C03EA01"
}, {
  CIP7: '3768351',
  CIP13: '3400937683517',
  ucdLib: "AMILORIDE-HYDROCHLOR.RPG CPR",
  UCD7: '9194170',
  UCD13: '3400891941708',
  ucdQtyMultiplicator: 90,
  cipLib: "AMILORIDE-HYDROCHLOR.RPG CPR BT 90",
  atcCode: "C03EA01"
}, {
  CIP7: '3728653',
  CIP13: '3400937286534',
  ucdLib: "AMILORIDE-HYDROCHLOR.TVC CPR",
  UCD7: '9218284',
  UCD13: '3400892182841',
  ucdQtyMultiplicator: 90,
  cipLib: "AMILORIDE-HYDROCHLOR.TVC CPR BT 90",
  atcCode: "C03EA01"
}, {
  CIP7: '3150208',
  CIP13: '3400931502081',
  ucdLib: "MODAMIDE 5MG CPR",
  UCD7: '9059294',
  UCD13: '3400890592949',
  ucdQtyMultiplicator: 30,
  cipLib: "MODAMIDE 5MG CPR BT 30",
  atcCode: "C03DB01"
}, {
  CIP7: '3000977',
  CIP13: '3400930009772',
  ucdLib: "EPLERENONE ARW 25MG CPR",
  UCD7: '9410314',
  UCD13: '3400894103141',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE ARW 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3000994',
  CIP13: '3400930009949',
  ucdLib: "EPLERENONE ARW 25MG CPR",
  UCD7: '9410314',
  UCD13: '3400894103141',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE ARW 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3001012',
  CIP13: '3400930010129',
  ucdLib: "EPLERENONE ARW 50MG CPR",
  UCD7: '9410320',
  UCD13: '3400894103202',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE ARW 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3003337',
  CIP13: '3400930033371',
  ucdLib: "EPLERENONE BGA 25MG CPR",
  UCD7: '9414996',
  UCD13: '3400894149965',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE BGA 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3003339',
  CIP13: '3400930033395',
  ucdLib: "EPLERENONE BGA 25MG CPR",
  UCD7: '9414996',
  UCD13: '3400894149965',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE BGA 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3003363',
  CIP13: '3400930033630',
  ucdLib: "EPLERENONE BGA 50MG CPR",
  UCD7: '9415004',
  UCD13: '3400894150046',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE BGA 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3003366',
  CIP13: '3400930033661',
  ucdLib: "EPLERENONE BGA 50MG CPR",
  UCD7: '9415004',
  UCD13: '3400894150046',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE BGA 50MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3002415',
  CIP13: '3400930024157',
  ucdLib: "EPLERENONE CRT 25MG CPR BT30",
  UCD7: '9414401',
  UCD13: '3400894144014',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE CRT 25MG CPR BT30 BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3002431',
  CIP13: '3400930024317',
  ucdLib: "EPLERENONE CRT 50MG CPR BT30",
  UCD7: '9414418',
  UCD13: '3400894144182',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE CRT 50MG CPR BT30 BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3000568',
  CIP13: '3400930005682',
  ucdLib: "EPLERENONE EG 25MG CPR",
  UCD7: '9412968',
  UCD13: '3400894129684',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE EG 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3000598',
  CIP13: '3400930005989',
  ucdLib: "EPLERENONE EG 25MG CPR",
  UCD7: '9412968',
  UCD13: '3400894129684',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE EG 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3000571',
  CIP13: '3400930005712',
  ucdLib: "EPLERENONE EG 50MG CPR",
  UCD7: '9412974',
  UCD13: '3400894129745',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE EG 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3000600',
  CIP13: '3400930006009',
  ucdLib: "EPLERENONE EG 50MG CPR",
  UCD7: '9412974',
  UCD13: '3400894129745',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE EG 50MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3001243',
  CIP13: '3400930012437',
  ucdLib: "EPLERENONE MYL 25MG CPR",
  UCD7: '9411360',
  UCD13: '3400894113607',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE MYL 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3001871',
  CIP13: '3400930018712',
  ucdLib: "EPLERENONE MYL 25MG CPR",
  UCD7: '9411360',
  UCD13: '3400894113607',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE MYL 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3001248',
  CIP13: '3400930012482',
  ucdLib: "EPLERENONE MYL 50MG CPR",
  UCD7: '9411377',
  UCD13: '3400894113775',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE MYL 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3001880',
  CIP13: '3400930018804',
  ucdLib: "EPLERENONE MYL 50MG CPR",
  UCD7: '9411377',
  UCD13: '3400894113775',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE MYL 50MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3000587',
  CIP13: '3400930005873',
  ucdLib: "EPLERENONE PFZ 25MG CPR",
  UCD7: '9412158',
  UCD13: '3400894121589',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE PFZ 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3000589',
  CIP13: '3400930005897',
  ucdLib: "EPLERENONE PFZ 25MG CPR",
  UCD7: '9412158',
  UCD13: '3400894121589',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE PFZ 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3000594',
  CIP13: '3400930005941',
  ucdLib: "EPLERENONE PFZ 50MG CPR",
  UCD7: '9412164',
  UCD13: '3400894121640',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE PFZ 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3000596',
  CIP13: '3400930005965',
  ucdLib: "EPLERENONE PFZ 50MG CPR",
  UCD7: '9412164',
  UCD13: '3400894121640',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE PFZ 50MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3001934',
  CIP13: '3400930019344',
  ucdLib: "EPLERENONE ZEN 25MG CPR",
  UCD7: '9412276',
  UCD13: '3400894122760',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE ZEN 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3002188',
  CIP13: '3400930021880',
  ucdLib: "EPLERENONE ZEN 25MG CPR",
  UCD7: '9412276',
  UCD13: '3400894122760',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE ZEN 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3001946',
  CIP13: '3400930019467',
  ucdLib: "EPLERENONE ZEN 50MG CPR",
  UCD7: '9412282',
  UCD13: '3400894122821',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE ZEN 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3002191',
  CIP13: '3400930021910',
  ucdLib: "EPLERENONE ZEN 50MG CPR",
  UCD7: '9412282',
  UCD13: '3400894122821',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE ZEN 50MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3002551',
  CIP13: '3400930025512',
  ucdLib: "EPLERENONE ZYD 25MG CPR",
  UCD7: '9412980',
  UCD13: '3400894129806',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE ZYD 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3002553',
  CIP13: '3400930025536',
  ucdLib: "EPLERENONE ZYD 25MG CPR",
  UCD7: '9412980',
  UCD13: '3400894129806',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE ZYD 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3002566',
  CIP13: '3400930025666',
  ucdLib: "EPLERENONE ZYD 50MG CPR",
  UCD7: '9412997',
  UCD13: '3400894129974',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE ZYD 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3002568',
  CIP13: '3400930025680',
  ucdLib: "EPLERENONE ZYD 50MG CPR",
  UCD7: '9412997',
  UCD13: '3400894129974',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE ZYD 50MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3665705',
  CIP13: '3400936657052',
  ucdLib: "INSPRA 25MG CPR",
  UCD7: '9271692',
  UCD13: '3400892716923',
  ucdQtyMultiplicator: 30,
  cipLib: "INSPRA 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3665740',
  CIP13: '3400936657403',
  ucdLib: "INSPRA 50MG CPR",
  UCD7: '9271700',
  UCD13: '3400892717005',
  ucdQtyMultiplicator: 30,
  cipLib: "INSPRA 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '3909811',
  CIP13: '3400939098111',
  ucdLib: "INSPRA 25MG CPR",
  UCD7: '9271692',
  UCD13: '3400892716923',
  ucdQtyMultiplicator: 90,
  cipLib: "INSPRA 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '3909946',
  CIP13: '3400939099460',
  ucdLib: "INSPRA 50MG CPR",
  UCD7: '9271700',
  UCD13: '3400892717005',
  ucdQtyMultiplicator: 90,
  cipLib: "INSPRA 50MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '2796931',
  CIP13: '3400927969317',
  ucdLib: "EPLERENONE TVC 25MG CPR",
  UCD7: '9414507',
  UCD13: '3400894145073',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE TVC 25MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '2796977',
  CIP13: '3400927969775',
  ucdLib: "EPLERENONE TVC 25MG CPR",
  UCD7: '9414507',
  UCD13: '3400894145073',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE TVC 25MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '2797310',
  CIP13: '3400927973109',
  ucdLib: "EPLERENONE TVC 50MG CPR",
  UCD7: '9414513',
  UCD13: '3400894145134',
  ucdQtyMultiplicator: 30,
  cipLib: "EPLERENONE TVC 50MG CPR BT 30",
  atcCode: "C03DA04"
}, {
  CIP7: '2797362',
  CIP13: '3400927973628',
  ucdLib: "EPLERENONE TVC 50MG CPR",
  UCD7: '9414513',
  UCD13: '3400894145134',
  ucdQtyMultiplicator: 90,
  cipLib: "EPLERENONE TVC 50MG CPR BT 90",
  atcCode: "C03DA04"
}, {
  CIP7: '5661574',
  CIP13: '3400956615742',
  ucdLib: "INSPRA 25MG CPR",
  UCD7: '9271692',
  UCD13: '3400892716923',
  ucdQtyMultiplicator: 50,
  cipLib: "INSPRA 25MG CPR BT 50",
  atcCode: "C03DA04"
}, {
  CIP7: '5661605',
  CIP13: '3400956616053',
  ucdLib: "INSPRA 50MG CPR",
  UCD7: '9271700',
  UCD13: '3400892717005',
  ucdQtyMultiplicator: 50,
  cipLib: "INSPRA 50MG CPR BT 50",
  atcCode: "C03DA04"
}, {
  CIP7: '3252245',
  CIP13: '3400932522453',
  ucdLib: "SOLUDACTONE 100MG INJ FL+A.",
  UCD7: '9085831',
  UCD13: '3400890858311',
  ucdQtyMultiplicator: 5,
  cipLib: "SOLUDACTONE 100MG INJ FL+A. BT 5",
  atcCode: "C03DA02"
}, {
  CIP7: '3252251',
  CIP13: '3400932522514',
  ucdLib: "SOLUDACTONE 200MG INJ FL+A.",
  UCD7: '9085848',
  UCD13: '3400890858489',
  ucdQtyMultiplicator: 5,
  cipLib: "SOLUDACTONE 200MG INJ FL+A. BT 5",
  atcCode: "C03DA02"
}, {
  CIP7: '3830765',
  CIP13: '3400938307658',
  ucdLib: "SPIRONOLACTONE ARW 50MG CPR",
  UCD7: '9309957',
  UCD13: '3400893099575',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ARW 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3611626',
  CIP13: '3400936116269',
  ucdLib: "SPIRONOLACTONE TVC 50MG CPR",
  UCD7: '9245418',
  UCD13: '3400892454184',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE TVC 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3611632',
  CIP13: '3400936116320',
  ucdLib: "SPIRONOLACTONE TVC 75MG CPR",
  UCD7: '9245424',
  UCD13: '3400892454245',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE TVC 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3260807',
  CIP13: '3400932608072',
  ucdLib: "ALDACTONE 75MG CPR",
  UCD7: '9002130',
  UCD13: '3400890021302',
  ucdQtyMultiplicator: 100,
  cipLib: "ALDACTONE 75MG CPR BT 100",
  atcCode: "C03DA01"
}, {
  CIP7: '3601438',
  CIP13: '3400936014381',
  ucdLib: "SPIRONOLACTONE ARL 75MG CPR",
  UCD7: '9353881',
  UCD13: '3400893538814',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ARL 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3605784',
  CIP13: '3400936057845',
  ucdLib: "SPIRONOLACTONE ARW 75MG CPR",
  UCD7: '9246783',
  UCD13: '3400892467832',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ARW 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3603383',
  CIP13: '3400936033832',
  ucdLib: "SPIRONOLACTONE CRT 50MG CPR",
  UCD7: '9352723',
  UCD13: '3400893527238',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE CRT 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3680834',
  CIP13: '3400936808348',
  ucdLib: "SPIRONOLACTONE SDZ 75MG CPR",
  UCD7: '9269063',
  UCD13: '3400892690636',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE SDZ 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3522383',
  CIP13: '3400935223838',
  ucdLib: "SPIROCTAN 50MG GELU",
  UCD7: '9223411',
  UCD13: '3400892234113',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIROCTAN 50MG GELU BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3522408',
  CIP13: '3400935224088',
  ucdLib: "SPIROCTAN 75MG GELU",
  UCD7: '9223428',
  UCD13: '3400892234281',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIROCTAN 75MG GELU BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3526843',
  CIP13: '3400935268433',
  ucdLib: "SPIRONOLACTONE EG 75MG CPR",
  UCD7: '9218781',
  UCD13: '3400892187815',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE EG 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3431806',
  CIP13: '3400934318061',
  ucdLib: "SPIRONOLACTONE PFZ 75MG CPR",
  UCD7: '9192627',
  UCD13: '3400891926279',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE PFZ 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3673805',
  CIP13: '3400936738058',
  ucdLib: "SPIRONOLACTONE ZEN 50MG CPR",
  UCD7: '9266857',
  UCD13: '3400892668574',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ZEN 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3673828',
  CIP13: '3400936738287',
  ucdLib: "SPIRONOLACTONE ZEN 75MG CPR",
  UCD7: '9266863',
  UCD13: '3400892668635',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ZEN 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3512539',
  CIP13: '3400935125392',
  ucdLib: "ALDACTONE 50MG CPR",
  UCD7: '9002118',
  UCD13: '3400890021180',
  ucdQtyMultiplicator: 30,
  cipLib: "ALDACTONE 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3512545',
  CIP13: '3400935125453',
  ucdLib: "ALDACTONE 75MG CPR",
  UCD7: '9002130',
  UCD13: '3400890021302',
  ucdQtyMultiplicator: 30,
  cipLib: "ALDACTONE 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3485073',
  CIP13: '3400934850738',
  ucdLib: "SPIRONOLACTONE BGA 25MG CPR",
  UCD7: '9341955',
  UCD13: '3400893419557',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE BGA 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3484748',
  CIP13: '3400934847486',
  ucdLib: "SPIRONOLACTONE BGA 75MG CPR",
  UCD7: '9206915',
  UCD13: '3400892069159',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE BGA 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3485050',
  CIP13: '3400934850509',
  ucdLib: "SPIRONOLACTONE PFZ 25MG CPR",
  UCD7: '9341671',
  UCD13: '3400893416716',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE PFZ 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '5609763',
  CIP13: '3400956097630',
  ucdLib: "ALDACTONE 25MG CPR",
  UCD7: '9202389',
  UCD13: '3400892023892',
  ucdQtyMultiplicator: 100,
  cipLib: "ALDACTONE 25MG CPR BT 100",
  atcCode: "C03DA01"
}, {
  CIP7: '3709182',
  CIP13: '3400937091824',
  ucdLib: "SPIRONOLACTONE CRT 75MG CPR",
  UCD7: '9352746',
  UCD13: '3400893527467',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE CRT 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3467052',
  CIP13: '3400934670527',
  ucdLib: "SPIRONOLACTONE PFZ 50MG CPR",
  UCD7: '9074715',
  UCD13: '3400890747158',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE PFZ 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3708596',
  CIP13: '3400937085960',
  ucdLib: "SPIRONOLACTONE ZYD 50MG CPR",
  UCD7: '9352769',
  UCD13: '3400893527696',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ZYD 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3709124',
  CIP13: '3400937091244',
  ucdLib: "SPIRONOLACTONE ZYD 75MG CPR",
  UCD7: '9352775',
  UCD13: '3400893527757',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ZYD 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3729598',
  CIP13: '3400937295987',
  ucdLib: "ALDACTONE 25MG CPR",
  UCD7: '9202389',
  UCD13: '3400892023892',
  ucdQtyMultiplicator: 90,
  cipLib: "ALDACTONE 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3723354',
  CIP13: '3400937233545',
  ucdLib: "ALDACTONE 50MG CPR",
  UCD7: '9002118',
  UCD13: '3400890021180',
  ucdQtyMultiplicator: 90,
  cipLib: "ALDACTONE 50MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3729606',
  CIP13: '3400937296069',
  ucdLib: "ALDACTONE 75MG CPR",
  UCD7: '9002130',
  UCD13: '3400890021302',
  ucdQtyMultiplicator: 90,
  cipLib: "ALDACTONE 75MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3696485',
  CIP13: '3400936964853',
  ucdLib: "SPIRONOLACTONE ARL 50MG CPR",
  UCD7: '9353875',
  UCD13: '3400893538753',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ARL 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3690229',
  CIP13: '3400936902299',
  ucdLib: "SPIRONOLACTONE MYL 50MG CPR",
  UCD7: '9352752',
  UCD13: '3400893527528',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE MYL 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3690258',
  CIP13: '3400936902589',
  ucdLib: "SPIRONOLACTONE MYL 50MG CPR",
  UCD7: '9352752',
  UCD13: '3400893527528',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE MYL 50MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3729670',
  CIP13: '3400937296700',
  ucdLib: "SPIRONOLACTONE PFZ 50MG CPR",
  UCD7: '9074715',
  UCD13: '3400890747158',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE PFZ 50MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3729687',
  CIP13: '3400937296878',
  ucdLib: "SPIRONOLACTONE PFZ 75MG CPR",
  UCD7: '9192627',
  UCD13: '3400891926279',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE PFZ 75MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3691074',
  CIP13: '3400936910744',
  ucdLib: "SPIRONOLACTONE SDZ 50MG CPR",
  UCD7: '9350718',
  UCD13: '3400893507186',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE SDZ 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3691134',
  CIP13: '3400936911345',
  ucdLib: "SPIRONOLACTONE SDZ 50MG CPR",
  UCD7: '9350718',
  UCD13: '3400893507186',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE SDZ 50MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3729204',
  CIP13: '3400937292047',
  ucdLib: "SPIRONOLACTONE SDZ 75MG CPR",
  UCD7: '9269063',
  UCD13: '3400892690636',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE SDZ 75MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3729061',
  CIP13: '3400937290616',
  ucdLib: "SPIRONOLACTONE TVC 50MG CPR",
  UCD7: '9245418',
  UCD13: '3400892454184',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE TVC 50MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3729078',
  CIP13: '3400937290784',
  ucdLib: "SPIRONOLACTONE TVC 75MG CPR",
  UCD7: '9245424',
  UCD13: '3400892454245',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE TVC 75MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3496591',
  CIP13: '3400934965913',
  ucdLib: "SPIRONOLACTONE BGA 50MG CPR",
  UCD7: '9206909',
  UCD13: '3400892069098',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE BGA 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3784746',
  CIP13: '3400937847469',
  ucdLib: "SPIRONOLACTONE BGA 50MG CPR",
  UCD7: '9206909',
  UCD13: '3400892069098',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE BGA 50MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3784723',
  CIP13: '3400937847230',
  ucdLib: "SPIRONOLACTONE BGA 75MG CPR",
  UCD7: '9206915',
  UCD13: '3400892069159',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE BGA 75MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3496817',
  CIP13: '3400934968174',
  ucdLib: "SPIRONOLACTONE MYL 75MG CPR",
  UCD7: '9188436',
  UCD13: '3400891884364',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE MYL 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3496958',
  CIP13: '3400934969584',
  ucdLib: "SPIRONOLACTONE RPG 75MG CPR",
  UCD7: '9182706',
  UCD13: '3400891827064',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE RPG 75MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3446630',
  CIP13: '3400934466304',
  ucdLib: "ALDACTONE 25MG CPR",
  UCD7: '9202389',
  UCD13: '3400892023892',
  ucdQtyMultiplicator: 30,
  cipLib: "ALDACTONE 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3736457',
  CIP13: '3400937364577',
  ucdLib: "SPIRONOLACTONE ARW 50MG CPR",
  UCD7: '9309957',
  UCD13: '3400893099575',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE ARW 50MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3739705',
  CIP13: '3400937397056',
  ucdLib: "SPIRONOLACTONE ARW 75MG CPR",
  UCD7: '9246783',
  UCD13: '3400892467832',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE ARW 75MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3739125',
  CIP13: '3400937391252',
  ucdLib: "SPIRONOLACTONE EG 50MG CPR",
  UCD7: '9214671',
  UCD13: '3400892146713',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE EG 50MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3739131',
  CIP13: '3400937391313',
  ucdLib: "SPIRONOLACTONE EG 75MG CPR",
  UCD7: '9218781',
  UCD13: '3400892187815',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE EG 75MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3738338',
  CIP13: '3400937383387',
  ucdLib: "SPIRONOLACTONE MYL 75MG CPR",
  UCD7: '9188436',
  UCD13: '3400891884364',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE MYL 75MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3968191',
  CIP13: '3400939681917',
  ucdLib: "SPIRONOLACTONE ARW 25MG CPR",
  UCD7: '9342676',
  UCD13: '3400893426760',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ARW 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3968216',
  CIP13: '3400939682167',
  ucdLib: "SPIRONOLACTONE ARW 25MG CPR",
  UCD7: '9342676',
  UCD13: '3400893426760',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE ARW 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3962774',
  CIP13: '3400939627748',
  ucdLib: "SPIRONOLACTONE BGA 25MG CPR",
  UCD7: '9341955',
  UCD13: '3400893419557',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE BGA 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3961473',
  CIP13: '3400939614731',
  ucdLib: "SPIRONOLACTONE CRT 25MG CPR",
  UCD7: '9341665',
  UCD13: '3400893416655',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE CRT 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3961510',
  CIP13: '3400939615103',
  ucdLib: "SPIRONOLACTONE EG 25MG CPR",
  UCD7: '9341961',
  UCD13: '3400893419618',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE EG 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3961527',
  CIP13: '3400939615271',
  ucdLib: "SPIRONOLACTONE EG 25MG CPR",
  UCD7: '9341961',
  UCD13: '3400893419618',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE EG 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3506059',
  CIP13: '3400935060594',
  ucdLib: "SPIRONOLACTONE EG 50MG CPR",
  UCD7: '9214671',
  UCD13: '3400892146713',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE EG 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3974240',
  CIP13: '3400939742403',
  ucdLib: "SPIRONOLACTONE MYL 25MG CPR",
  UCD7: '9343575',
  UCD13: '3400893435755',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE MYL 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3974257',
  CIP13: '3400939742571',
  ucdLib: "SPIRONOLACTONE MYL 25MG CPR",
  UCD7: '9343575',
  UCD13: '3400893435755',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE MYL 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3962797',
  CIP13: '3400939627977',
  ucdLib: "SPIRONOLACTONE PFZ 25MG CPR",
  UCD7: '9341671',
  UCD13: '3400893416716',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE PFZ 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3506013',
  CIP13: '3400935060136',
  ucdLib: "SPIRONOLACTONE RPG 50MG CPR",
  UCD7: '9182698',
  UCD13: '3400891826982',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE RPG 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3967783',
  CIP13: '3400939677835',
  ucdLib: "SPIRONOLACTONE RTP 25MG CPR",
  UCD7: '9345203',
  UCD13: '3400893452035',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE RTP 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3967808',
  CIP13: '3400939678085',
  ucdLib: "SPIRONOLACTONE RTP 25MG CPR",
  UCD7: '9345203',
  UCD13: '3400893452035',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE RTP 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3506065',
  CIP13: '3400935060655',
  ucdLib: "SPIRONOLACTONE RTP 50MG CPR",
  UCD7: '9152792',
  UCD13: '3400891527926',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE RTP 50MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3961674',
  CIP13: '3400939616742',
  ucdLib: "SPIRONOLACTONE SDZ 25MG CPR",
  UCD7: '9339131',
  UCD13: '3400893391310',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE SDZ 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3961680',
  CIP13: '3400939616803',
  ucdLib: "SPIRONOLACTONE SDZ 25MG CPR",
  UCD7: '9339131',
  UCD13: '3400893391310',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE SDZ 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3959884',
  CIP13: '3400939598840',
  ucdLib: "SPIRONOLACTONE TVC 25MG CPR",
  UCD7: '9341688',
  UCD13: '3400893416884',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE TVC 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3959890',
  CIP13: '3400939598901',
  ucdLib: "SPIRONOLACTONE TVC 25MG CPR",
  UCD7: '9341688',
  UCD13: '3400893416884',
  ucdQtyMultiplicator: 90,
  cipLib: "SPIRONOLACTONE TVC 25MG CPR BT 90",
  atcCode: "C03DA01"
}, {
  CIP7: '3967949',
  CIP13: '3400939679495',
  ucdLib: "SPIRONOLACTONE ZEN 25MG CPR",
  UCD7: '9343693',
  UCD13: '3400893436936',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ZEN 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '3967820',
  CIP13: '3400939678207',
  ucdLib: "SPIRONOLACTONE ZYD 25MG CPR",
  UCD7: '9345108',
  UCD13: '3400893451083',
  ucdQtyMultiplicator: 30,
  cipLib: "SPIRONOLACTONE ZYD 25MG CPR BT 30",
  atcCode: "C03DA01"
}, {
  CIP7: '5524570',
  CIP13: '3400955245704',
  ucdLib: "ALDACTONE 50MG CPR",
  UCD7: '9002118',
  UCD13: '3400890021180',
  ucdQtyMultiplicator: 100,
  cipLib: "ALDACTONE 50MG CPR BT 100",
  atcCode: "C03DA01"
}, {
  CIP7: '3322247',
  CIP13: '3400933222475',
  ucdLib: "EURELIX 6MG GELU",
  UCD7: '9152237',
  UCD13: '3400891522372',
  ucdQtyMultiplicator: 30,
  cipLib: "EURELIX 6MG GELU BT 30",
  atcCode: "C03CA03"
}, {
  CIP7: '3452139',
  CIP13: '3400934521393',
  ucdLib: "BURINEX 5MG CPR",
  UCD7: '9126234',
  UCD13: '3400891262346',
  ucdQtyMultiplicator: 30,
  cipLib: "BURINEX 5MG CPR BT 30",
  atcCode: "C03CA02"
}, {
  CIP7: '3285842',
  CIP13: '3400932858422',
  ucdLib: "BURINEX 2MG/4ML IV AMP4ML",
  UCD7: '9121745',
  UCD13: '3400891217452',
  ucdQtyMultiplicator: 5,
  cipLib: "BURINEX 2MG/4ML IV AMP4ML BT 5",
  atcCode: "C03CA02"
}, {
  CIP7: '3293965',
  CIP13: '3400932939657',
  ucdLib: "BURINEX 1MG CPR",
  UCD7: '9121739',
  UCD13: '3400891217391',
  ucdQtyMultiplicator: 30,
  cipLib: "BURINEX 1MG CPR BT 30",
  atcCode: "C03CA02"
}, {
  CIP7: '5531937',
  CIP13: '3400955319375',
  ucdLib: "LASILIX 40MG CPR",
  UCD7: '9049901',
  UCD13: '3400890499019',
  ucdQtyMultiplicator: 100,
  cipLib: "LASILIX 40MG CPR BT 100",
  atcCode: "C03CA01"
}, {
  CIP7: '3616931',
  CIP13: '3400936169319',
  ucdLib: "FUROSEMIDE EG 20MG CPR",
  UCD7: '9248233',
  UCD13: '3400892482330',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE EG 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3616954',
  CIP13: '3400936169548',
  ucdLib: "FUROSEMIDE EG 40MG CPR",
  UCD7: '9248256',
  UCD13: '3400892482569',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE EG 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3614524',
  CIP13: '3400936145245',
  ucdLib: "FUROSEMIDE TVC 40MG CPR",
  UCD7: '9245370',
  UCD13: '3400892453705',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE TVC 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3057331',
  CIP13: '3400930573310',
  ucdLib: "LASILIX 20MG INJ AMP2ML",
  UCD7: '9049893',
  UCD13: '3400890498937',
  ucdQtyMultiplicator: 1,
  cipLib: "LASILIX 20MG INJ AMP2ML BT 1",
  atcCode: "C03CA01"
}, {
  CIP7: '3003799',
  CIP13: '3400930037997',
  ucdLib: "FUROSEMIDE BGA 20MG CPR",
  UCD7: '9143379',
  UCD13: '3400891433791',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE BGA 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3003801',
  CIP13: '3400930038017',
  ucdLib: "FUROSEMIDE BGA 40MG CPR",
  UCD7: '9143391',
  UCD13: '3400891433913',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE BGA 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3006112',
  CIP13: '3400930061121',
  ucdLib: "FUROSEMIDE MYL 20MG CPR",
  UCD7: '9270824',
  UCD13: '3400892708249',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE MYL 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3006113',
  CIP13: '3400930061138',
  ucdLib: "FUROSEMIDE MYL 40MG CPR",
  UCD7: '9265214',
  UCD13: '3400892652146',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE MYL 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3000220',
  CIP13: '3400930002209',
  ucdLib: "FUROSEMIDE ZEN 500MG CPR",
  UCD7: '9407565',
  UCD13: '3400894075653',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE ZEN 500MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3001263',
  CIP13: '3400930012635',
  ucdLib: "FUROSEMIDE ZYD 20MG CPR",
  UCD7: '9409699',
  UCD13: '3400894096993',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE ZYD 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3001265',
  CIP13: '3400930012659',
  ucdLib: "FUROSEMIDE ZYD 40MG CPR",
  UCD7: '9409707',
  UCD13: '3400894097075',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE ZYD 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '5868803',
  CIP13: '3400958688034',
  ucdLib: "LASILIX 20MG INJ AMP2ML",
  UCD7: '9049893',
  UCD13: '3400890498937',
  ucdQtyMultiplicator: 60,
  cipLib: "LASILIX 20MG INJ AMP2ML BT 60",
  atcCode: "C03CA01"
}, {
  CIP7: '3256013',
  CIP13: '3400932560134',
  ucdLib: "FUROSEMIDE BGA 20MG CPR",
  UCD7: '9143379',
  UCD13: '3400891433791',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE BGA 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3300091',
  CIP13: '3400933000912',
  ucdLib: "LASILIX 10MG/ML BUV FL60ML",
  UCD7: '9133286',
  UCD13: '3400891332865',
  ucdQtyMultiplicator: 1,
  cipLib: "LASILIX 10MG/ML BUV FL60ML BT 1",
  atcCode: "C03CA01"
}, {
  CIP7: '5566539',
  CIP13: '3400955665397',
  ucdLib: "LASILIX FAIBLE 20MG CPR",
  UCD7: '9049918',
  UCD13: '3400890499187',
  ucdQtyMultiplicator: 100,
  cipLib: "LASILIX FAIBLE 20MG CPR BT 100",
  atcCode: "C03CA01"
}, {
  CIP7: '3249237',
  CIP13: '3400932492374',
  ucdLib: "LASILIX RETARD 60MG GELU",
  UCD7: '9049924',
  UCD13: '3400890499248',
  ucdQtyMultiplicator: 30,
  cipLib: "LASILIX RETARD 60MG GELU BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '5566522',
  CIP13: '3400955665229',
  ucdLib: "LASILIX RETARD 60MG GELU",
  UCD7: '9049924',
  UCD13: '3400890499248',
  ucdQtyMultiplicator: 100,
  cipLib: "LASILIX RETARD 60MG GELU BT 100",
  atcCode: "C03CA01"
}, {
  CIP7: '3681905',
  CIP13: '3400936819054',
  ucdLib: "FUROSEMIDE SDZ 20MG CPR",
  UCD7: '9268939',
  UCD13: '3400892689395',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE SDZ 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3681963',
  CIP13: '3400936819634',
  ucdLib: "FUROSEMIDE SDZ 40MG CPR",
  UCD7: '9268945',
  UCD13: '3400892689456',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE SDZ 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3528138',
  CIP13: '3400935281388',
  ucdLib: "LASILIX 40MG CPR",
  UCD7: '9049901',
  UCD13: '3400890499019',
  ucdQtyMultiplicator: 30,
  cipLib: "LASILIX 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3673691',
  CIP13: '3400936736917',
  ucdLib: "FUROSEMIDE ZEN 20MG CPR",
  UCD7: '9266716',
  UCD13: '3400892667164',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE ZEN 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3673716',
  CIP13: '3400936737167',
  ucdLib: "FUROSEMIDE ZEN 40MG CPR",
  UCD7: '9266722',
  UCD13: '3400892667225',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE ZEN 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3215356',
  CIP13: '3400932153565',
  ucdLib: "LASILIX FAIBLE 20MG CPR",
  UCD7: '9049918',
  UCD13: '3400890499187',
  ucdQtyMultiplicator: 30,
  cipLib: "LASILIX FAIBLE 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3665473',
  CIP13: '3400936654730',
  ucdLib: "FUROSEMIDE ARW 20MG CPR",
  UCD7: '9267377',
  UCD13: '3400892673776',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE ARW 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3665504',
  CIP13: '3400936655041',
  ucdLib: "FUROSEMIDE MYL 20MG CPR",
  UCD7: '9270824',
  UCD13: '3400892708249',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE MYL 20MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3384538',
  CIP13: '3400933845384',
  ucdLib: "LASILIX SPECIAL 500MG CPR",
  UCD7: '9049947',
  UCD13: '3400890499477',
  ucdQtyMultiplicator: 30,
  cipLib: "LASILIX SPECIAL 500MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3647676',
  CIP13: '3400936476769',
  ucdLib: "FUROSEMIDE ARW 40MG CPR",
  UCD7: '9265208',
  UCD13: '3400892652085',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE ARW 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3478386',
  CIP13: '3400934783869',
  ucdLib: "FUROSEMIDE BGA 40MG CPR",
  UCD7: '9143391',
  UCD13: '3400891433913',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE BGA 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '3647699',
  CIP13: '3400936476998',
  ucdLib: "FUROSEMIDE MYL 40MG CPR",
  UCD7: '9265214',
  UCD13: '3400892652146',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE MYL 40MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '5618561',
  CIP13: '3400956185610',
  ucdLib: "FUROSEMIDE LAV 20MG INJ 2ML",
  UCD7: '9205471',
  UCD13: '3400892054711',
  ucdQtyMultiplicator: 100,
  cipLib: "FUROSEMIDE LAV 20MG INJ 2ML BT 100",
  atcCode: "C03CA01"
}, {
  CIP7: '5618911',
  CIP13: '3400956189113',
  ucdLib: "FUROSEMIDE REN 20MG INJ 2ML",
  UCD7: '9208831',
  UCD13: '3400892088310',
  ucdQtyMultiplicator: 100,
  cipLib: "FUROSEMIDE REN 20MG INJ 2ML BT 100",
  atcCode: "C03CA01"
}, {
  CIP7: '5640106',
  CIP13: '3400956401062',
  ucdLib: "FUROSEMIDE REN 250MG A.25ML",
  UCD7: '9242621',
  UCD13: '3400892426211',
  ucdQtyMultiplicator: 10,
  cipLib: "FUROSEMIDE REN 250MG A.25ML BT 10",
  atcCode: "C03CA01"
}, {
  CIP7: '5870220',
  CIP13: '3400958702204',
  ucdLib: "FUROSEMIDE REN 20MG INJ 2ML",
  UCD7: '9208831',
  UCD13: '3400892088310',
  ucdQtyMultiplicator: 10,
  cipLib: "FUROSEMIDE REN 20MG INJ 2ML BT 10",
  atcCode: "C03CA01"
}, {
  CIP7: '4162662',
  CIP13: '3400941626623',
  ucdLib: "FUROSEMIDE TVC 500MG CPR",
  UCD7: '9375397',
  UCD13: '3400893753972',
  ucdQtyMultiplicator: 30,
  cipLib: "FUROSEMIDE TVC 500MG CPR BT 30",
  atcCode: "C03CA01"
}, {
  CIP7: '2781935',
  CIP13: '3400927819353',
  ucdLib: "LASILIX SPECIAL 250MG INJ A.",
  UCD7: '9049930',
  UCD13: '3400890499309',
  ucdQtyMultiplicator: 6,
  cipLib: "LASILIX SPECIAL 250MG INJ A. BT 6",
  atcCode: "C03CA01"
}, {
  CIP7: '5753744',
  CIP13: '3400957537449',
  ucdLib: "LASILIX SPECIAL 500MG CPR",
  UCD7: '9049947',
  UCD13: '3400890499477',
  ucdQtyMultiplicator: 100,
  cipLib: "LASILIX SPECIAL 500MG CPR BT 100",
  atcCode: "C03CA01"
}, {
  CIP7: '5812501',
  CIP13: '3400958125010',
  ucdLib: "LASILIX 20MG INJ AMP2ML",
  UCD7: '9049893',
  UCD13: '3400890498937',
  ucdQtyMultiplicator: 12,
  cipLib: "LASILIX 20MG INJ AMP2ML BT 12",
  atcCode: "C03CA01"
}, {
  CIP7: '3287479',
  CIP13: '3400932874798',
  ucdLib: "TENSTATEN 50MG GELU",
  UCD7: '9123626',
  UCD13: '3400891236262',
  ucdQtyMultiplicator: 30,
  cipLib: "TENSTATEN 50MG GELU BT 30",
  atcCode: "C03BX03"
}, {
  CIP7: '3715231',
  CIP13: '3400937152310',
  ucdLib: "TENSTATEN 50MG GELU",
  UCD7: '9123626',
  UCD13: '3400891236262',
  ucdQtyMultiplicator: 90,
  cipLib: "TENSTATEN 50MG GELU BT 90",
  atcCode: "C03BX03"
}, {
  CIP7: '4972562',
  CIP13: '3400949725625',
  ucdLib: "CICLETANINE BGA 50MG GELU",
  UCD7: '9363230',
  UCD13: '3400893632307',
  ucdQtyMultiplicator: 30,
  cipLib: "CICLETANINE BGA 50MG GELU BT 30",
  atcCode: "C03BX03"
}, {
  CIP7: '4972585',
  CIP13: '3400949725854',
  ucdLib: "CICLETANINE BGA 50MG GELU",
  UCD7: '9363230',
  UCD13: '3400893632307',
  ucdQtyMultiplicator: 90,
  cipLib: "CICLETANINE BGA 50MG GELU BT 90",
  atcCode: "C03BX03"
}, {
  CIP7: '4972639',
  CIP13: '3400949726394',
  ucdLib: "CICLETANINE TVC 50MG GELU",
  UCD7: '9364815',
  UCD13: '3400893648155',
  ucdQtyMultiplicator: 30,
  cipLib: "CICLETANINE TVC 50MG GELU BT 30",
  atcCode: "C03BX03"
}, {
  CIP7: '4972651',
  CIP13: '3400949726516',
  ucdLib: "CICLETANINE TVC 50MG GELU",
  UCD7: '9364815',
  UCD13: '3400893648155',
  ucdQtyMultiplicator: 90,
  cipLib: "CICLETANINE TVC 50MG GELU BT 90",
  atcCode: "C03BX03"
}, {
  CIP7: '4949089',
  CIP13: '3400949490899',
  ucdLib: "CICLETANINE MYL 50MG GELU",
  UCD7: '9363224',
  UCD13: '3400893632246',
  ucdQtyMultiplicator: 30,
  cipLib: "CICLETANINE MYL 50MG GELU BT 30",
  atcCode: "C03BX03"
}, {
  CIP7: '4949103',
  CIP13: '3400949491032',
  ucdLib: "CICLETANINE MYL 50MG GELU",
  UCD7: '9363224',
  UCD13: '3400893632246',
  ucdQtyMultiplicator: 90,
  cipLib: "CICLETANINE MYL 50MG GELU BT 90",
  atcCode: "C03BX03"
}, {
  CIP7: '3578142',
  CIP13: '3400935781420',
  ucdLib: "FLUDEX LP 1,5MG CPR",
  UCD7: '9174486',
  UCD13: '3400891744866',
  ucdQtyMultiplicator: 90,
  cipLib: "FLUDEX LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3578165',
  CIP13: '3400935781659',
  ucdLib: "INDAPAMIDE ARW LP 1,5MG CPR",
  UCD7: '9337066',
  UCD13: '3400893370667',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE ARW LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3298046',
  CIP13: '3400932980468',
  ucdLib: "INDAPAMIDE BGA 2,5MG CPR",
  UCD7: '9191125',
  UCD13: '3400891911251',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE BGA 2,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3578188',
  CIP13: '3400935781888',
  ucdLib: "INDAPAMIDE BGA LP 1,5MG CPR",
  UCD7: '9319499',
  UCD13: '3400893194997',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE BGA LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3144372',
  CIP13: '3400931443728',
  ucdLib: "FLUDEX 2,5MG CPR",
  UCD7: '9035448',
  UCD13: '3400890354486',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUDEX 2,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3854777',
  CIP13: '3400938547771',
  ucdLib: "INDAPAMIDE EG LP 1,5MG CPR",
  UCD7: '9320203',
  UCD13: '3400893202036',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE EG LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3854814',
  CIP13: '3400938548143',
  ucdLib: "INDAPAMIDE EG LP 1,5MG CPR",
  UCD7: '9320203',
  UCD13: '3400893202036',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE EG LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3397699',
  CIP13: '3400933976996',
  ucdLib: "INDAPAMIDE MYL 2,5MG CPR",
  UCD7: '9181291',
  UCD13: '3400891812916',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE MYL 2,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3859817',
  CIP13: '3400938598179',
  ucdLib: "INDAPAMIDE RBX LP 1,5MG CPR",
  UCD7: '9319163',
  UCD13: '3400893191637',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE RBX LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3859852',
  CIP13: '3400938598520',
  ucdLib: "INDAPAMIDE RBX LP 1,5MG CPR",
  UCD7: '9319163',
  UCD13: '3400893191637',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE RBX LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3382746',
  CIP13: '3400933827465',
  ucdLib: "FLUDEX LP 1,5MG CPR",
  UCD7: '9174486',
  UCD13: '3400891744866',
  ucdQtyMultiplicator: 30,
  cipLib: "FLUDEX LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3382769',
  CIP13: '3400933827694',
  ucdLib: "FLUDEX LP 1,5MG CPR",
  UCD7: '9174486',
  UCD13: '3400891744866',
  ucdQtyMultiplicator: 100,
  cipLib: "FLUDEX LP 1,5MG CPR BT 100",
  atcCode: "C03BA11"
}, {
  CIP7: '3383237',
  CIP13: '3400933832377',
  ucdLib: "INDAPAMIDE BGA LP 1,5MG CPR",
  UCD7: '9319499',
  UCD13: '3400893194997',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE BGA LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3497722',
  CIP13: '3400934977220',
  ucdLib: "INDAPAMIDE ARW LP 1,5MG CPR",
  UCD7: '9337066',
  UCD13: '3400893370667',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE ARW LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3774587',
  CIP13: '3400937745871',
  ucdLib: "INDAPAMIDE TVS LP 1,5MG CPR",
  UCD7: '9357620',
  UCD13: '3400893576205',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE TVS LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3774624',
  CIP13: '3400937746243',
  ucdLib: "INDAPAMIDE TVS LP 1,5MG CPR",
  UCD7: '9357620',
  UCD13: '3400893576205',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE TVS LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3471384',
  CIP13: '3400934713842',
  ucdLib: "INDAPAMIDE ZYD LP 1,5MG CPR",
  UCD7: '9347886',
  UCD13: '3400893478868',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE ZYD LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3861547',
  CIP13: '3400938615470',
  ucdLib: "INDAPAMIDE KRK LP 1,5MG CPR",
  UCD7: '9325293',
  UCD13: '3400893252932',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE KRK LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3861582',
  CIP13: '3400938615821',
  ucdLib: "INDAPAMIDE KRK LP 1,5MG CPR",
  UCD7: '9325293',
  UCD13: '3400893252932',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE KRK LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3883916',
  CIP13: '3400938839166',
  ucdLib: "INDAPAMIDE ZEN LP 1,5MG CPR",
  UCD7: '9326335',
  UCD13: '3400893263358',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE ZEN LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3883945',
  CIP13: '3400938839456',
  ucdLib: "INDAPAMIDE ZEN LP 1,5MG CPR",
  UCD7: '9326335',
  UCD13: '3400893263358',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE ZEN LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3934677',
  CIP13: '3400939346779',
  ucdLib: "INDAPAMIDE ISD LP 1,5MG CPR",
  UCD7: '9339740',
  UCD13: '3400893397404',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE ISD LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3934714',
  CIP13: '3400939347141',
  ucdLib: "INDAPAMIDE ISD LP 1,5MG CPR",
  UCD7: '9339740',
  UCD13: '3400893397404',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE ISD LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3842691',
  CIP13: '3400938426915',
  ucdLib: "INDAPAMIDE MYL LP 1,5MG CPR",
  UCD7: '9317632',
  UCD13: '3400893176320',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE MYL LP 1,5MG CPR BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3842716',
  CIP13: '3400938427165',
  ucdLib: "INDAPAMIDE MYL LP 1,5MG CPR",
  UCD7: '9317632',
  UCD13: '3400893176320',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE MYL LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3899478',
  CIP13: '3400938994780',
  ucdLib: "INDAPAMIDE ZYD LP 1,5MG CPR",
  UCD7: '9347886',
  UCD13: '3400893478868',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE ZYD LP 1,5MG CPR BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3992522',
  CIP13: '3400939925226',
  ucdLib: "INDAPAMIDE SDZ LP 1,5MG CPR 30",
  UCD7: '9345953',
  UCD13: '3400893459539',
  ucdQtyMultiplicator: 30,
  cipLib: "INDAPAMIDE SDZ LP 1,5MG CPR 30 BT 30",
  atcCode: "C03BA11"
}, {
  CIP7: '3992551',
  CIP13: '3400939925516',
  ucdLib: "INDAPAMIDE SDZ LP 1,5MG CPR 30",
  UCD7: '9345953',
  UCD13: '3400893459539',
  ucdQtyMultiplicator: 90,
  cipLib: "INDAPAMIDE SDZ LP 1,5MG CPR 30 BT 90",
  atcCode: "C03BA11"
}, {
  CIP7: '3719654',
  CIP13: '3400937196543',
  ucdLib: "ESIDREX 25MG CPR",
  UCD7: '9032438',
  UCD13: '3400890324380',
  ucdQtyMultiplicator: 30,
  cipLib: "ESIDREX 25MG CPR BT 30",
  atcCode: "C03AA03"
}, {
  CIP7: '3719660',
  CIP13: '3400937196604',
  ucdLib: "ESIDREX 25MG CPR",
  UCD7: '9032438',
  UCD13: '3400890324380',
  ucdQtyMultiplicator: 90,
  cipLib: "ESIDREX 25MG CPR BT 90",
  atcCode: "C03AA03"
}, {
  CIP7: '3103746',
  CIP13: '3400931037460',
  ucdLib: "TENSIONORME CPR",
  UCD7: '9090950',
  UCD13: '3400890909501',
  ucdQtyMultiplicator: 24,
  cipLib: "TENSIONORME CPR BT 24",
  atcCode: "C02LA01"
}, {
  CIP7: '2784891',
  CIP13: '3400927848919',
  ucdLib: "ADEMPAS 0,5MG CPR",
  UCD7: '9400540',
  UCD13: '3400894005407',
  ucdQtyMultiplicator: 42,
  cipLib: "ADEMPAS 0,5MG CPR BT 42",
  atcCode: "C02KX05"
}, {
  CIP7: '2784968',
  CIP13: '3400927849688',
  ucdLib: "ADEMPAS 1,5MG CPR",
  UCD7: '9400557',
  UCD13: '3400894005575',
  ucdQtyMultiplicator: 42,
  cipLib: "ADEMPAS 1,5MG CPR BT 42",
  atcCode: "C02KX05"
}, {
  CIP7: '2784980',
  CIP13: '3400927849800',
  ucdLib: "ADEMPAS 1,5MG CPR",
  UCD7: '9400557',
  UCD13: '3400894005575',
  ucdQtyMultiplicator: 90,
  cipLib: "ADEMPAS 1,5MG CPR BT 90",
  atcCode: "C02KX05"
}, {
  CIP7: '2784939',
  CIP13: '3400927849398',
  ucdLib: "ADEMPAS 1MG CPR",
  UCD7: '9400563',
  UCD13: '3400894005636',
  ucdQtyMultiplicator: 42,
  cipLib: "ADEMPAS 1MG CPR BT 42",
  atcCode: "C02KX05"
}, {
  CIP7: '2784951',
  CIP13: '3400927849510',
  ucdLib: "ADEMPAS 1MG CPR",
  UCD7: '9400563',
  UCD13: '3400894005636',
  ucdQtyMultiplicator: 90,
  cipLib: "ADEMPAS 1MG CPR BT 90",
  atcCode: "C02KX05"
}, {
  CIP7: '2785028',
  CIP13: '3400927850288',
  ucdLib: "ADEMPAS 2,5MG CPR",
  UCD7: '9400586',
  UCD13: '3400894005865',
  ucdQtyMultiplicator: 42,
  cipLib: "ADEMPAS 2,5MG CPR BT 42",
  atcCode: "C02KX05"
}, {
  CIP7: '2785040',
  CIP13: '3400927850400',
  ucdLib: "ADEMPAS 2,5MG CPR",
  UCD7: '9400586',
  UCD13: '3400894005865',
  ucdQtyMultiplicator: 90,
  cipLib: "ADEMPAS 2,5MG CPR BT 90",
  atcCode: "C02KX05"
}, {
  CIP7: '2784997',
  CIP13: '3400927849978',
  ucdLib: "ADEMPAS 2MG CPR",
  UCD7: '9400592',
  UCD13: '3400894005926',
  ucdQtyMultiplicator: 42,
  cipLib: "ADEMPAS 2MG CPR BT 42",
  atcCode: "C02KX05"
}, {
  CIP7: '2785011',
  CIP13: '3400927850110',
  ucdLib: "ADEMPAS 2MG CPR",
  UCD7: '9400592',
  UCD13: '3400894005926',
  ucdQtyMultiplicator: 90,
  cipLib: "ADEMPAS 2MG CPR BT 90",
  atcCode: "C02KX05"
}, {
  CIP7: '3865806',
  CIP13: '3400938658064',
  ucdLib: "VOLIBRIS 10MG CPR PELLIC",
  UCD7: '9316035',
  UCD13: '3400893160350',
  ucdQtyMultiplicator: 30,
  cipLib: "VOLIBRIS 10MG CPR PELLIC BT 30",
  atcCode: "C02KX02"
}, {
  CIP7: '3865781',
  CIP13: '3400938657814',
  ucdLib: "VOLIBRIS 5MG CPR PELLIC",
  UCD7: '9316041',
  UCD13: '3400893160411',
  ucdQtyMultiplicator: 30,
  cipLib: "VOLIBRIS 5MG CPR PELLIC BT 30",
  atcCode: "C02KX02"
}, {
  CIP7: '5636228',
  CIP13: '3400956362288',
  ucdLib: "TRACLEER 125MG CPR",
  UCD7: '9240013',
  UCD13: '3400892400136',
  ucdQtyMultiplicator: 56,
  cipLib: "TRACLEER 125MG CPR BT 56",
  atcCode: "C02KX01"
}, {
  CIP7: '5636211',
  CIP13: '3400956362110',
  ucdLib: "TRACLEER 62,5MG CPR",
  UCD7: '9240036',
  UCD13: '3400892400365',
  ucdQtyMultiplicator: 56,
  cipLib: "TRACLEER 62,5MG CPR BT 56",
  atcCode: "C02KX01"
}, {
  CIP7: '3993510',
  CIP13: '3400939935102',
  ucdLib: "TRACLEER 32MG CPR DISP",
  UCD7: '9342759',
  UCD13: '3400893427590',
  ucdQtyMultiplicator: 56,
  cipLib: "TRACLEER 32MG CPR DISP BT 56",
  atcCode: "C02KX01"
}, {
  CIP7: '3268281',
  CIP13: '3400932682812',
  ucdLib: "LONOTEN 10MG CPR",
  UCD7: '9055066',
  UCD13: '3400890550666',
  ucdQtyMultiplicator: 40,
  cipLib: "LONOTEN 10MG CPR BT 40",
  atcCode: "C02DC01"
}, {
  CIP7: '3268306',
  CIP13: '3400932683062',
  ucdLib: "LONOTEN 5MG CPR",
  UCD7: '9055072',
  UCD13: '3400890550727',
  ucdQtyMultiplicator: 40,
  cipLib: "LONOTEN 5MG CPR BT 40",
  atcCode: "C02DC01"
}, {
  CIP7: '5624113',
  CIP13: '3400956241132',
  ucdLib: "NEPRESSOL 25MG INJ AMP+AMP",
  UCD7: '9223836',
  UCD13: '3400892238364',
  ucdQtyMultiplicator: 5,
  cipLib: "NEPRESSOL 25MG INJ AMP+AMP BT 5",
  atcCode: "C02DB01"
}, {
  CIP7: '3305450',
  CIP13: '3400933054502',
  ucdLib: "EUPRESSYL 25MG IV AMP5ML",
  UCD7: '9128888',
  UCD13: '3400891288889',
  ucdQtyMultiplicator: 5,
  cipLib: "EUPRESSYL 25MG IV AMP5ML BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '3304798',
  CIP13: '3400933047986',
  ucdLib: "EUPRESSYL 50MG IV AMP10ML",
  UCD7: '9128894',
  UCD13: '3400891288940',
  ucdQtyMultiplicator: 5,
  cipLib: "EUPRESSYL 50MG IV AMP10ML BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '3609316',
  CIP13: '3400936093164',
  ucdLib: "EUPRESSYL 30MG GELU",
  UCD7: '9129853',
  UCD13: '3400891298536',
  ucdQtyMultiplicator: 30,
  cipLib: "EUPRESSYL 30MG GELU BT 30",
  atcCode: "C02CA06"
}, {
  CIP7: '3609322',
  CIP13: '3400936093225',
  ucdLib: "EUPRESSYL 60MG GELU",
  UCD7: '9129876',
  UCD13: '3400891298765',
  ucdQtyMultiplicator: 30,
  cipLib: "EUPRESSYL 60MG GELU BT 30",
  atcCode: "C02CA06"
}, {
  CIP7: '3609339',
  CIP13: '3400936093393',
  ucdLib: "MEDIATENSYL 30MG GELU",
  UCD7: '9129988',
  UCD13: '3400891299885',
  ucdQtyMultiplicator: 30,
  cipLib: "MEDIATENSYL 30MG GELU BT 30",
  atcCode: "C02CA06"
}, {
  CIP7: '3609351',
  CIP13: '3400936093515',
  ucdLib: "MEDIATENSYL 60MG GELU",
  UCD7: '9129994',
  UCD13: '3400891299946',
  ucdQtyMultiplicator: 30,
  cipLib: "MEDIATENSYL 60MG GELU BT 30",
  atcCode: "C02CA06"
}, {
  CIP7: '3788655',
  CIP13: '3400937886550',
  ucdLib: "URAPIDIL NDP 25MG IV A.5ML",
  UCD7: '9298478',
  UCD13: '3400892984780',
  ucdQtyMultiplicator: 5,
  cipLib: "URAPIDIL NDP 25MG IV A.5ML BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '3788678',
  CIP13: '3400937886789',
  ucdLib: "URAPIDIL NDP 50MG IV A.10ML",
  UCD7: '9298484',
  UCD13: '3400892984841',
  ucdQtyMultiplicator: 5,
  cipLib: "URAPIDIL NDP 50MG IV A.10ML BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '3802697',
  CIP13: '3400938026979',
  ucdLib: "EUPRESSYL 100MG/20ML IV AMP",
  UCD7: '9318198',
  UCD13: '3400893181980',
  ucdQtyMultiplicator: 5,
  cipLib: "EUPRESSYL 100MG/20ML IV AMP BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '4153692',
  CIP13: '3400941536922',
  ucdLib: "URAPIDIL MYL 100MG IV A.20ML",
  UCD7: '9367943',
  UCD13: '3400893679432',
  ucdQtyMultiplicator: 5,
  cipLib: "URAPIDIL MYL 100MG IV A.20ML BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '4153663',
  CIP13: '3400941536632',
  ucdLib: "URAPIDIL MYL 25MG IV A.5ML",
  UCD7: '9367966',
  UCD13: '3400893679661',
  ucdQtyMultiplicator: 5,
  cipLib: "URAPIDIL MYL 25MG IV A.5ML BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '4153686',
  CIP13: '3400941536861',
  ucdLib: "URAPIDIL MYL 50MG IV A.10ML",
  UCD7: '9367972',
  UCD13: '3400893679722',
  ucdQtyMultiplicator: 5,
  cipLib: "URAPIDIL MYL 50MG IV A.10ML BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '2233263',
  CIP13: '3400922332635',
  ucdLib: "URAPIDIL NDP 100MG IV A.20ML",
  UCD7: '9387064',
  UCD13: '3400893870648',
  ucdQtyMultiplicator: 5,
  cipLib: "URAPIDIL NDP 100MG IV A.20ML BT 5",
  atcCode: "C02CA06"
}, {
  CIP7: '3944641',
  CIP13: '3400939446417',
  ucdLib: "DOXAZOSINE TVC 4MG CPR LP",
  UCD7: '9338947',
  UCD13: '3400893389478',
  ucdQtyMultiplicator: 28,
  cipLib: "DOXAZOSINE TVC 4MG CPR LP BT 28",
  atcCode: "C02CA04"
}, {
  CIP7: '2165567',
  CIP13: '3400921655674',
  ucdLib: "DOXAZOSINE ARW LP 8MG CPR",
  UCD7: '9387851',
  UCD13: '3400893878514',
  ucdQtyMultiplicator: 28,
  cipLib: "DOXAZOSINE ARW LP 8MG CPR BT 28",
  atcCode: "C02CA04"
}, {
  CIP7: '2165679',
  CIP13: '3400921656794',
  ucdLib: "DOXAZOSINE MYL LP 8MG CP",
  UCD7: '9393774',
  UCD13: '3400893937747',
  ucdQtyMultiplicator: 28,
  cipLib: "DOXAZOSINE MYL LP 8MG CP BT 28",
  atcCode: "C02CA04"
}, {
  CIP7: '3311775',
  CIP13: '3400933117757',
  ucdLib: "ALPRESS LP 2,5MG CPR",
  UCD7: '9134593',
  UCD13: '3400891345933',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRESS LP 2,5MG CPR BT 30",
  atcCode: "C02CA01"
}, {
  CIP7: '3311723',
  CIP13: '3400933117238',
  ucdLib: "ALPRESS LP 5MG CPR",
  UCD7: '9134601',
  UCD13: '3400891346015',
  ucdQtyMultiplicator: 30,
  cipLib: "ALPRESS LP 5MG CPR BT 30",
  atcCode: "C02CA01"
}, {
  CIP7: '3224705',
  CIP13: '3400932247059',
  ucdLib: "MINIPRESS 1MG CPR",
  UCD7: '9059182',
  UCD13: '3400890591829',
  ucdQtyMultiplicator: 30,
  cipLib: "MINIPRESS 1MG CPR BT 30",
  atcCode: "C02CA01"
}, {
  CIP7: '3224711',
  CIP13: '3400932247110',
  ucdLib: "MINIPRESS 5MG CPR",
  UCD7: '9059199',
  UCD13: '3400890591997',
  ucdQtyMultiplicator: 30,
  cipLib: "MINIPRESS 5MG CPR BT 30",
  atcCode: "C02CA01"
}, {
  CIP7: '3729658',
  CIP13: '3400937296588',
  ucdLib: "ALPRESS LP 2,5MG CPR",
  UCD7: '9134593',
  UCD13: '3400891345933',
  ucdQtyMultiplicator: 90,
  cipLib: "ALPRESS LP 2,5MG CPR BT 90",
  atcCode: "C02CA01"
}, {
  CIP7: '3729664',
  CIP13: '3400937296649',
  ucdLib: "ALPRESS LP 5MG CPR",
  UCD7: '9134601',
  UCD13: '3400891346015',
  ucdQtyMultiplicator: 90,
  cipLib: "ALPRESS LP 5MG CPR BT 90",
  atcCode: "C02CA01"
}, {
  CIP7: '3294692',
  CIP13: '3400932946921',
  ucdLib: "HYPERIUM 1MG CPR",
  UCD7: '9125387',
  UCD13: '3400891253870',
  ucdQtyMultiplicator: 30,
  cipLib: "HYPERIUM 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3294746',
  CIP13: '3400932947461',
  ucdLib: "RILMENIDINE BGA 1MG CPR",
  UCD7: '9242199',
  UCD13: '3400892421995',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE BGA 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3608937',
  CIP13: '3400936089372',
  ucdLib: "RILMENIDINE MYL 1MG CPR",
  UCD7: '9248055',
  UCD13: '3400892480558',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE MYL 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '5583383',
  CIP13: '3400955833833',
  ucdLib: "HYPERIUM 1MG CPR",
  UCD7: '9125387',
  UCD13: '3400891253870',
  ucdQtyMultiplicator: 100,
  cipLib: "HYPERIUM 1MG CPR BT 100",
  atcCode: "C02AC06"
}, {
  CIP7: '3722573',
  CIP13: '3400937225731',
  ucdLib: "HYPERIUM 1MG CPR",
  UCD7: '9125387',
  UCD13: '3400891253870',
  ucdQtyMultiplicator: 90,
  cipLib: "HYPERIUM 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3749980',
  CIP13: '3400937499804',
  ucdLib: "RILMENIDINE RBX 1MG CPR",
  UCD7: '9289692',
  UCD13: '3400892896922',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE RBX 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3815837',
  CIP13: '3400938158373',
  ucdLib: "RILMENIDINE SDZ 1MG CPR",
  UCD7: '9305209',
  UCD13: '3400893052099',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE SDZ 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3815843',
  CIP13: '3400938158434',
  ucdLib: "RILMENIDINE SDZ 1MG CPR",
  UCD7: '9305209',
  UCD13: '3400893052099',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE SDZ 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3815889',
  CIP13: '3400938158892',
  ucdLib: "RILMENIDINE TVC 1MG CPR",
  UCD7: '9307071',
  UCD13: '3400893070710',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE TVC 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3815903',
  CIP13: '3400938159035',
  ucdLib: "RILMENIDINE TVC 1MG CPR",
  UCD7: '9307071',
  UCD13: '3400893070710',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE TVC 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3749945',
  CIP13: '3400937499453',
  ucdLib: "RILMENIDINE ZEN 1MG CPR",
  UCD7: '9290347',
  UCD13: '3400892903477',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE ZEN 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3749968',
  CIP13: '3400937499682',
  ucdLib: "RILMENIDINE ZEN 1MG CPR",
  UCD7: '9290347',
  UCD13: '3400892903477',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE ZEN 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3780808',
  CIP13: '3400937808088',
  ucdLib: "RILMENIDINE BGA 1MG CPR",
  UCD7: '9242199',
  UCD13: '3400892421995',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE BGA 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3750078',
  CIP13: '3400937500784',
  ucdLib: "RILMENIDINE ARW 1MG CPR",
  UCD7: '9289261',
  UCD13: '3400892892610',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE ARW 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3750090',
  CIP13: '3400937500906',
  ucdLib: "RILMENIDINE ARW 1MG CPR",
  UCD7: '9289261',
  UCD13: '3400892892610',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE ARW 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3750032',
  CIP13: '3400937500326',
  ucdLib: "RILMENIDINE EG 1MG CPR",
  UCD7: '9289686',
  UCD13: '3400892896861',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE EG 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3750055',
  CIP13: '3400937500555',
  ucdLib: "RILMENIDINE EG 1MG CPR",
  UCD7: '9289686',
  UCD13: '3400892896861',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE EG 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3730041',
  CIP13: '3400937300414',
  ucdLib: "RILMENIDINE MYL 1MG CPR",
  UCD7: '9248055',
  UCD13: '3400892480558',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE MYL 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3750003',
  CIP13: '3400937500036',
  ucdLib: "RILMENIDINE RBX 1MG CPR",
  UCD7: '9289692',
  UCD13: '3400892896922',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE RBX 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3755851',
  CIP13: '3400937558518',
  ucdLib: "RILMENIDINE ZYD 1MG CPR",
  UCD7: '9289901',
  UCD13: '3400892899015',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE ZYD 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3755874',
  CIP13: '3400937558747',
  ucdLib: "RILMENIDINE ZYD 1MG CPR",
  UCD7: '9289901',
  UCD13: '3400892899015',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE ZYD 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3896089',
  CIP13: '3400938960891',
  ucdLib: "RILMENIDINE ALT 1MG CPR",
  UCD7: '9328073',
  UCD13: '3400893280737',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE ALT 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3974027',
  CIP13: '3400939740270',
  ucdLib: "RILMENIDINE CRT 1MG CPR",
  UCD7: '9341582',
  UCD13: '3400893415825',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE CRT 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '3974056',
  CIP13: '3400939740560',
  ucdLib: "RILMENIDINE CRT 1MG CPR",
  UCD7: '9341582',
  UCD13: '3400893415825',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE CRT 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '4993067',
  CIP13: '3400949930678',
  ucdLib: "RILMENIDINE ACT 1MG CPR",
  UCD7: '9365447',
  UCD13: '3400893654477',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE ACT 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '4993363',
  CIP13: '3400949933631',
  ucdLib: "RILMENIDINE EVO 1MG CPR",
  UCD7: '9365453',
  UCD13: '3400893654538',
  ucdQtyMultiplicator: 30,
  cipLib: "RILMENIDINE EVO 1MG CPR BT 30",
  atcCode: "C02AC06"
}, {
  CIP7: '4993392',
  CIP13: '3400949933921',
  ucdLib: "RILMENIDINE EVO 1MG CPR",
  UCD7: '9365453',
  UCD13: '3400893654538',
  ucdQtyMultiplicator: 90,
  cipLib: "RILMENIDINE EVO 1MG CPR BT 90",
  atcCode: "C02AC06"
}, {
  CIP7: '3377828',
  CIP13: '3400933778286',
  ucdLib: "PHYSIOTENS 0,2MG CPR",
  UCD7: '9184817',
  UCD13: '3400891848175',
  ucdQtyMultiplicator: 30,
  cipLib: "PHYSIOTENS 0,2MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3377892',
  CIP13: '3400933778927',
  ucdLib: "PHYSIOTENS 0,4MG CPR",
  UCD7: '9184823',
  UCD13: '3400891848236',
  ucdQtyMultiplicator: 30,
  cipLib: "PHYSIOTENS 0,4MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3768374',
  CIP13: '3400937683746',
  ucdLib: "MOXONIDINE EG 0,2MG CPR",
  UCD7: '9289858',
  UCD13: '3400892898582',
  ucdQtyMultiplicator: 90,
  cipLib: "MOXONIDINE EG 0,2MG CPR BT 90",
  atcCode: "C02AC05"
}, {
  CIP7: '3768397',
  CIP13: '3400937683975',
  ucdLib: "MOXONIDINE EG 0,4MG CPR",
  UCD7: '9289864',
  UCD13: '3400892898643',
  ucdQtyMultiplicator: 90,
  cipLib: "MOXONIDINE EG 0,4MG CPR BT 90",
  atcCode: "C02AC05"
}, {
  CIP7: '3745060',
  CIP13: '3400937450607',
  ucdLib: "MOXONIDINE TVS 0,2MG CPR",
  UCD7: '9288741',
  UCD13: '3400892887418',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXONIDINE TVS 0,2MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3745083',
  CIP13: '3400937450836',
  ucdLib: "MOXONIDINE TVS 0,2MG CPR",
  UCD7: '9288741',
  UCD13: '3400892887418',
  ucdQtyMultiplicator: 90,
  cipLib: "MOXONIDINE TVS 0,2MG CPR BT 90",
  atcCode: "C02AC05"
}, {
  CIP7: '3745114',
  CIP13: '3400937451147',
  ucdLib: "MOXONIDINE TVS 0,4MG CPR",
  UCD7: '9288758',
  UCD13: '3400892887586',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXONIDINE TVS 0,4MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3745137',
  CIP13: '3400937451376',
  ucdLib: "MOXONIDINE TVS 0,4MG CPR",
  UCD7: '9288758',
  UCD13: '3400892887586',
  ucdQtyMultiplicator: 90,
  cipLib: "MOXONIDINE TVS 0,4MG CPR BT 90",
  atcCode: "C02AC05"
}, {
  CIP7: '3793596',
  CIP13: '3400937935968',
  ucdLib: "MOXONIDINE BGA 0,2MG CPR",
  UCD7: '9301915',
  UCD13: '3400893019153',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXONIDINE BGA 0,2MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3793662',
  CIP13: '3400937936620',
  ucdLib: "MOXONIDINE BGA 0,4MG CPR",
  UCD7: '9301921',
  UCD13: '3400893019214',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXONIDINE BGA 0,4MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3795388',
  CIP13: '3400937953887',
  ucdLib: "MOXONIDINE EG 0,2MG CPR",
  UCD7: '9289858',
  UCD13: '3400892898582',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXONIDINE EG 0,2MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3795402',
  CIP13: '3400937954020',
  ucdLib: "MOXONIDINE EG 0,4MG CPR",
  UCD7: '9289864',
  UCD13: '3400892898643',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXONIDINE EG 0,4MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3714852',
  CIP13: '3400937148528',
  ucdLib: "PHYSIOTENS 0,2MG CPR",
  UCD7: '9184817',
  UCD13: '3400891848175',
  ucdQtyMultiplicator: 90,
  cipLib: "PHYSIOTENS 0,2MG CPR BT 90",
  atcCode: "C02AC05"
}, {
  CIP7: '3714869',
  CIP13: '3400937148696',
  ucdLib: "PHYSIOTENS 0,4MG CPR",
  UCD7: '9184823',
  UCD13: '3400891848236',
  ucdQtyMultiplicator: 90,
  cipLib: "PHYSIOTENS 0,4MG CPR BT 90",
  atcCode: "C02AC05"
}, {
  CIP7: '3735311',
  CIP13: '3400937353113',
  ucdLib: "MOXONIDINE MYL 0,2MG CPR",
  UCD7: '9288729',
  UCD13: '3400892887296',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXONIDINE MYL 0,2MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3735340',
  CIP13: '3400937353403',
  ucdLib: "MOXONIDINE MYL 0,2MG CPR",
  UCD7: '9288729',
  UCD13: '3400892887296',
  ucdQtyMultiplicator: 90,
  cipLib: "MOXONIDINE MYL 0,2MG CPR BT 90",
  atcCode: "C02AC05"
}, {
  CIP7: '3735386',
  CIP13: '3400937353861',
  ucdLib: "MOXONIDINE MYL 0,4MG CPR",
  UCD7: '9288735',
  UCD13: '3400892887357',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXONIDINE MYL 0,4MG CPR BT 30",
  atcCode: "C02AC05"
}, {
  CIP7: '3735417',
  CIP13: '3400937354172',
  ucdLib: "MOXONIDINE MYL 0,4MG CPR",
  UCD7: '9288735',
  UCD13: '3400892887357',
  ucdQtyMultiplicator: 90,
  cipLib: "MOXONIDINE MYL 0,4MG CPR BT 90",
  atcCode: "C02AC05"
}, {
  CIP7: '3551321',
  CIP13: '3400935513212',
  ucdLib: "CATAPRESSAN 0,15MG INJ AMP1ML",
  UCD7: '9016824',
  UCD13: '3400890168243',
  ucdQtyMultiplicator: 10,
  cipLib: "CATAPRESSAN 0,15MG INJ AMP1ML BT 10",
  atcCode: "C02AC01"
}, {
  CIP7: '3594069',
  CIP13: '3400935940698',
  ucdLib: "CATAPRESSAN 0,15MG CPR",
  UCD7: '9016830',
  UCD13: '3400890168304',
  ucdQtyMultiplicator: 30,
  cipLib: "CATAPRESSAN 0,15MG CPR BT 30",
  atcCode: "C02AC01"
}, {
  CIP7: '3002198',
  CIP13: '3400930021989',
  ucdLib: "ALDOMET 250MG CPR",
  UCD7: '9002182',
  UCD13: '3400890021821',
  ucdQtyMultiplicator: 30,
  cipLib: "ALDOMET 250MG CPR BT 30",
  atcCode: "C02AB02"
}, {
  CIP7: '3173801',
  CIP13: '3400931738015',
  ucdLib: "ALDOMET 500MG CPR",
  UCD7: '9002199',
  UCD13: '3400890021999',
  ucdQtyMultiplicator: 30,
  cipLib: "ALDOMET 500MG CPR BT 30",
  atcCode: "C02AB02"
}, {
  CIP7: '5849639',
  CIP13: '3400958496394',
  ucdLib: "RAPISCAN 400MCG INJ FL5ML",
  UCD7: '9393283',
  UCD13: '3400893932834',
  ucdQtyMultiplicator: 1,
  cipLib: "RAPISCAN 400MCG INJ FL5ML BT 1",
  atcCode: "C01EB21"
}, {
  CIP7: '3716762',
  CIP13: '3400937167628',
  ucdLib: "PROCORALAN 5MG CPR",
  UCD7: '9295787',
  UCD13: '3400892957876',
  ucdQtyMultiplicator: 56,
  cipLib: "PROCORALAN 5MG CPR BT 56",
  atcCode: "C01EB17"
}, {
  CIP7: '3716791',
  CIP13: '3400937167918',
  ucdLib: "PROCORALAN 7,5MG CPR",
  UCD7: '9295793',
  UCD13: '3400892957937',
  ucdQtyMultiplicator: 56,
  cipLib: "PROCORALAN 7,5MG CPR BT 56",
  atcCode: "C01EB17"
}, {
  CIP7: '5672081',
  CIP13: '3400956720811',
  ucdLib: "PROCORALAN 5MG CPR",
  UCD7: '9295787',
  UCD13: '3400892957876',
  ucdQtyMultiplicator: 100,
  cipLib: "PROCORALAN 5MG CPR BT 100",
  atcCode: "C01EB17"
}, {
  CIP7: '5672098',
  CIP13: '3400956720989',
  ucdLib: "PROCORALAN 7,5MG CPR",
  UCD7: '9295793',
  UCD13: '3400892957937',
  ucdQtyMultiplicator: 100,
  cipLib: "PROCORALAN 7,5MG CPR BT 100",
  atcCode: "C01EB17"
}, {
  CIP7: '5658135',
  CIP13: '3400956581351',
  ucdLib: "PEDEA 5MG/ML INJ AMP2ML",
  UCD7: '9264700',
  UCD13: '3400892647005',
  ucdQtyMultiplicator: 4,
  cipLib: "PEDEA 5MG/ML INJ AMP2ML BT 4",
  atcCode: "C01EB16"
}, {
  CIP7: '3572458',
  CIP13: '3400935724588',
  ucdLib: "VASTAREL 35MG CPR LM",
  UCD7: '9242609',
  UCD13: '3400892426099',
  ucdQtyMultiplicator: 60,
  cipLib: "VASTAREL 35MG CPR LM BT 60",
  atcCode: "C01EB15"
}, {
  CIP7: '3572470',
  CIP13: '3400935724700',
  ucdLib: "VASTAREL 35MG CPR LM",
  UCD7: '9242609',
  UCD13: '3400892426099',
  ucdQtyMultiplicator: 100,
  cipLib: "VASTAREL 35MG CPR LM BT 100",
  atcCode: "C01EB15"
}, {
  CIP7: '3220506',
  CIP13: '3400932205066',
  ucdLib: "VASTAREL 20MG CPR PELLIC",
  UCD7: '9097797',
  UCD13: '3400890977975',
  ucdQtyMultiplicator: 60,
  cipLib: "VASTAREL 20MG CPR PELLIC BT 60",
  atcCode: "C01EB15"
}, {
  CIP7: '3227520',
  CIP13: '3400932275205',
  ucdLib: "VASTAREL 20MG/ML BUV FL60ML",
  UCD7: '9097805',
  UCD13: '3400890978057',
  ucdQtyMultiplicator: 1,
  cipLib: "VASTAREL 20MG/ML BUV FL60ML BT 1",
  atcCode: "C01EB15"
}, {
  CIP7: '3411181',
  CIP13: '3400934111815',
  ucdLib: "TRIMETAZIDINE BGA 20MG CPR",
  UCD7: '9191177',
  UCD13: '3400891911770',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIMETAZIDINE BGA 20MG CPR BT 60",
  atcCode: "C01EB15"
}, {
  CIP7: '3510374',
  CIP13: '3400935103741',
  ucdLib: "TRIMETAZIDINE MYL20MG/ML 60ML",
  UCD7: '9216983',
  UCD13: '3400892169835',
  ucdQtyMultiplicator: 1,
  cipLib: "TRIMETAZIDINE MYL20MG/ML 60ML BT 1",
  atcCode: "C01EB15"
}, {
  CIP7: '3799920',
  CIP13: '3400937999205',
  ucdLib: "TRIMETAZIDINE BGA 35MG CLM",
  UCD7: '9305468',
  UCD13: '3400893054680',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIMETAZIDINE BGA 35MG CLM BT 60",
  atcCode: "C01EB15"
}, {
  CIP7: '3799707',
  CIP13: '3400937997072',
  ucdLib: "TRIMETAZIDINE EG 35MG CLM",
  UCD7: '9305480',
  UCD13: '3400893054802',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIMETAZIDINE EG 35MG CLM BT 60",
  atcCode: "C01EB15"
}, {
  CIP7: '3774529',
  CIP13: '3400937745291',
  ucdLib: "TRIMETAZIDINE ZYD 20MG CPR",
  UCD7: '9295385',
  UCD13: '3400892953854',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIMETAZIDINE ZYD 20MG CPR BT 60",
  atcCode: "C01EB15"
}, {
  CIP7: '3871971',
  CIP13: '3400938719710',
  ucdLib: "TRIMETAZIDINE MYL 35MG CLM",
  UCD7: '9354171',
  UCD13: '3400893541715',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIMETAZIDINE MYL 35MG CLM BT 60",
  atcCode: "C01EB15"
}, {
  CIP7: '3509187',
  CIP13: '3400935091871',
  ucdLib: "TRIMETAZIDINE MYL 20MG CPR",
  UCD7: '9213424',
  UCD13: '3400892134246',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIMETAZIDINE MYL 20MG CPR BT 60",
  atcCode: "C01EB15"
}, {
  CIP7: '3347626',
  CIP13: '3400933476267',
  ucdLib: "ADENYL 60MG CPR",
  UCD7: '9163614',
  UCD13: '3400891636147',
  ucdQtyMultiplicator: 30,
  cipLib: "ADENYL 60MG CPR BT 30",
  atcCode: "C01EB10"
}, {
  CIP7: '5599817',
  CIP13: '3400955998174',
  ucdLib: "ADENOSCAN 30MG/10ML IV FL",
  UCD7: '9201987',
  UCD13: '3400892019871',
  ucdQtyMultiplicator: 6,
  cipLib: "ADENOSCAN 30MG/10ML IV FL BT 6",
  atcCode: "C01EB10"
}, {
  CIP7: '5500858',
  CIP13: '3400955008583',
  ucdLib: "ADENOSINE MDC 6MG/2ML INJ FL",
  UCD7: '9412448',
  UCD13: '3400894124481',
  ucdQtyMultiplicator: 6,
  cipLib: "ADENOSINE MDC 6MG/2ML INJ FL BT 6",
  atcCode: "C01EB10"
}, {
  CIP7: '5611688',
  CIP13: '3400956116881',
  ucdLib: "KRENOSIN 6MG/2ML INJ FL",
  UCD7: '9164080',
  UCD13: '3400891640809',
  ucdQtyMultiplicator: 6,
  cipLib: "KRENOSIN 6MG/2ML INJ FL BT 6",
  atcCode: "C01EB10"
}, {
  CIP7: '5631113',
  CIP13: '3400956311132',
  ucdLib: "STRIADYNE 20MG INJ AMP2ML",
  UCD7: '9088309',
  UCD13: '3400890883092',
  ucdQtyMultiplicator: 10,
  cipLib: "STRIADYNE 20MG INJ AMP2ML BT 10",
  atcCode: "C01EB10"
}, {
  CIP7: '5541551',
  CIP13: '3400955415510',
  ucdLib: "PROSTINE VR 0,5MG/ML INJ A1ML",
  UCD7: '9119435',
  UCD13: '3400891194357',
  ucdQtyMultiplicator: 1,
  cipLib: "PROSTINE VR 0,5MG/ML INJ A1ML BT 1",
  atcCode: "C01EA01"
}, {
  CIP7: '5738584',
  CIP13: '3400957385842',
  ucdLib: "ALPROSTADIL INT0,5MG/ML A.1ML",
  UCD7: '9326950',
  UCD13: '3400893269503',
  ucdQtyMultiplicator: 1,
  cipLib: "ALPROSTADIL INT0,5MG/ML A.1ML BT 1",
  atcCode: "C01EA01"
}, {
  CIP7: '5739052',
  CIP13: '3400957390525',
  ucdLib: "ALPROSTADIL PAN0,5MG/ML A.1ML",
  UCD7: '9326967',
  UCD13: '3400893269671',
  ucdQtyMultiplicator: 1,
  cipLib: "ALPROSTADIL PAN0,5MG/ML A.1ML BT 1",
  atcCode: "C01EA01"
}, {
  CIP7: '3000821',
  CIP13: '3400930008218',
  ucdLib: "NICORANDIL EG 10MG CPR",
  UCD7: '9389123',
  UCD13: '3400893891230',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL EG 10MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '3000823',
  CIP13: '3400930008232',
  ucdLib: "NICORANDIL EG 20MG CPR",
  UCD7: '9389146',
  UCD13: '3400893891469',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL EG 20MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '3354833',
  CIP13: '3400933548339',
  ucdLib: "ADANCOR 10MG CPR",
  UCD7: '9167262',
  UCD13: '3400891672626',
  ucdQtyMultiplicator: 30,
  cipLib: "ADANCOR 10MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '3354856',
  CIP13: '3400933548568',
  ucdLib: "ADANCOR 20MG CPR",
  UCD7: '9167279',
  UCD13: '3400891672794',
  ucdQtyMultiplicator: 30,
  cipLib: "ADANCOR 20MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '3354810',
  CIP13: '3400933548100',
  ucdLib: "IKOREL 10MG CPR",
  UCD7: '9159162',
  UCD13: '3400891591620',
  ucdQtyMultiplicator: 30,
  cipLib: "IKOREL 10MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '3354827',
  CIP13: '3400933548278',
  ucdLib: "IKOREL 20MG CPR",
  UCD7: '9159179',
  UCD13: '3400891591798',
  ucdQtyMultiplicator: 30,
  cipLib: "IKOREL 20MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '3780352',
  CIP13: '3400937803526',
  ucdLib: "NICORANDIL ZEN 10MG CPR",
  UCD7: '9300821',
  UCD13: '3400893008218',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL ZEN 10MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '3780369',
  CIP13: '3400937803694',
  ucdLib: "NICORANDIL ZEN 20MG CPR",
  UCD7: '9300838',
  UCD13: '3400893008386',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL ZEN 20MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '4170354',
  CIP13: '3400941703546',
  ucdLib: "NICORANDIL ALM 20MG CPR",
  UCD7: '9371761',
  UCD13: '3400893717615',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL ALM 20MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '4171514',
  CIP13: '3400941715143',
  ucdLib: "NICORANDIL BGA 10MG CPR",
  UCD7: '9372105',
  UCD13: '3400893721056',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL BGA 10MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '4171537',
  CIP13: '3400941715372',
  ucdLib: "NICORANDIL BGA 20MG CPR",
  UCD7: '9372111',
  UCD13: '3400893721117',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL BGA 20MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '4168819',
  CIP13: '3400941688195',
  ucdLib: "NICORANDIL ALM 10MG CPR",
  UCD7: '9371755',
  UCD13: '3400893717554',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL ALM 10MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '2161173',
  CIP13: '3400921611731',
  ucdLib: "NICORANDIL SDZ 10MG CPR",
  UCD7: '9379248',
  UCD13: '3400893792483',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL SDZ 10MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '2161084',
  CIP13: '3400921610840',
  ucdLib: "NICORANDIL SDZ 20MG CPR",
  UCD7: '9379254',
  UCD13: '3400893792544',
  ucdQtyMultiplicator: 30,
  cipLib: "NICORANDIL SDZ 20MG CPR BT 30",
  atcCode: "C01DX16"
}, {
  CIP7: '3573096',
  CIP13: '3400935730961',
  ucdLib: "MOLSIDOMINE ARW 2MG CPR",
  UCD7: '9234573',
  UCD13: '3400892345734',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE ARW 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3573104',
  CIP13: '3400935731043',
  ucdLib: "MOLSIDOMINE ARW 2MG CPR",
  UCD7: '9234573',
  UCD13: '3400892345734',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE ARW 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3573110',
  CIP13: '3400935731104',
  ucdLib: "MOLSIDOMINE ARW 4MG CPR",
  UCD7: '9235271',
  UCD13: '3400892352718',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE ARW 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3574546',
  CIP13: '3400935745460',
  ucdLib: "MOLSIDOMINE ARW 4MG CPR",
  UCD7: '9235271',
  UCD13: '3400892352718',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE ARW 4MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3570577',
  CIP13: '3400935705778',
  ucdLib: "MOLSIDOMINE MYL 4MG CPR",
  UCD7: '9227018',
  UCD13: '3400892270180',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE MYL 4MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3241081',
  CIP13: '3400932410811',
  ucdLib: "CORVASAL 2MG CPR",
  UCD7: '9022546',
  UCD13: '3400890225465',
  ucdQtyMultiplicator: 30,
  cipLib: "CORVASAL 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3241106',
  CIP13: '3400932411061',
  ucdLib: "CORVASAL 2MG CPR",
  UCD7: '9022546',
  UCD13: '3400890225465',
  ucdQtyMultiplicator: 90,
  cipLib: "CORVASAL 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '5566516',
  CIP13: '3400955665168',
  ucdLib: "CORVASAL 2MG CPR",
  UCD7: '9022546',
  UCD13: '3400890225465',
  ucdQtyMultiplicator: 100,
  cipLib: "CORVASAL 2MG CPR BT 100",
  atcCode: "C01DX12"
}, {
  CIP7: '3303592',
  CIP13: '3400933035921',
  ucdLib: "CORVASAL 4MG CPR",
  UCD7: '9123655',
  UCD13: '3400891236552',
  ucdQtyMultiplicator: 30,
  cipLib: "CORVASAL 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '5562607',
  CIP13: '3400955626077',
  ucdLib: "CORVASAL 4MG CPR",
  UCD7: '9123655',
  UCD13: '3400891236552',
  ucdQtyMultiplicator: 100,
  cipLib: "CORVASAL 4MG CPR BT 100",
  atcCode: "C01DX12"
}, {
  CIP7: '3680768',
  CIP13: '3400936807686',
  ucdLib: "MOLSIDOMINE SDZ 4MG CPR",
  UCD7: '9268980',
  UCD13: '3400892689807',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE SDZ 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3674650',
  CIP13: '3400936746503',
  ucdLib: "MOLSIDOMINE ZEN 2MG CPR",
  UCD7: '9270095',
  UCD13: '3400892700953',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE ZEN 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3674667',
  CIP13: '3400936746671',
  ucdLib: "MOLSIDOMINE ZEN 2MG CPR",
  UCD7: '9270095',
  UCD13: '3400892700953',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE ZEN 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3674673',
  CIP13: '3400936746732',
  ucdLib: "MOLSIDOMINE ZEN 4MG CPR",
  UCD7: '9270103',
  UCD13: '3400892701035',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE ZEN 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555572',
  CIP13: '3400935555724',
  ucdLib: "MOLSIDOMINE ACT 4MG CPR",
  UCD7: '9227892',
  UCD13: '3400892278926',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE ACT 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555419',
  CIP13: '3400935554192',
  ucdLib: "MOLSIDOMINE BGA 2MG CPR",
  UCD7: '9224066',
  UCD13: '3400892240664',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE BGA 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555425',
  CIP13: '3400935554253',
  ucdLib: "MOLSIDOMINE BGA 2MG CPR",
  UCD7: '9224066',
  UCD13: '3400892240664',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE BGA 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3555431',
  CIP13: '3400935554314',
  ucdLib: "MOLSIDOMINE BGA 4MG CPR",
  UCD7: '9224072',
  UCD13: '3400892240725',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE BGA 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555477',
  CIP13: '3400935554772',
  ucdLib: "MOLSIDOMINE CRT 2MG CPR",
  UCD7: '9335328',
  UCD13: '3400893353288',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE CRT 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555483',
  CIP13: '3400935554833',
  ucdLib: "MOLSIDOMINE CRT 2MG CPR",
  UCD7: '9335328',
  UCD13: '3400893353288',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE CRT 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3555508',
  CIP13: '3400935555083',
  ucdLib: "MOLSIDOMINE CRT 4MG CPR",
  UCD7: '9335334',
  UCD13: '3400893353349',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE CRT 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555589',
  CIP13: '3400935555892',
  ucdLib: "MOLSIDOMINE EG 2MG CPR",
  UCD7: '9226823',
  UCD13: '3400892268231',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE EG 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555595',
  CIP13: '3400935555953',
  ucdLib: "MOLSIDOMINE EG 2MG CPR",
  UCD7: '9226823',
  UCD13: '3400892268231',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE EG 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3555603',
  CIP13: '3400935556035',
  ucdLib: "MOLSIDOMINE EG 4MG CPR",
  UCD7: '9226846',
  UCD13: '3400892268460',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE EG 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555514',
  CIP13: '3400935555144',
  ucdLib: "MOLSIDOMINE MYL 2MG CPR",
  UCD7: '9226266',
  UCD13: '3400892262666',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE MYL 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3555520',
  CIP13: '3400935555205',
  ucdLib: "MOLSIDOMINE MYL 2MG CPR",
  UCD7: '9226266',
  UCD13: '3400892262666',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE MYL 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3555537',
  CIP13: '3400935555373',
  ucdLib: "MOLSIDOMINE MYL 4MG CPR",
  UCD7: '9227018',
  UCD13: '3400892270180',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE MYL 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3584059',
  CIP13: '3400935840592',
  ucdLib: "MOLSIDOMINE ZYD 2MG CPR",
  UCD7: '9257976',
  UCD13: '3400892579764',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE ZYD 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3584071',
  CIP13: '3400935840714',
  ucdLib: "MOLSIDOMINE ZYD 2MG CPR",
  UCD7: '9257976',
  UCD13: '3400892579764',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE ZYD 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3584088',
  CIP13: '3400935840882',
  ucdLib: "MOLSIDOMINE ZYD 4MG CPR",
  UCD7: '9257982',
  UCD13: '3400892579825',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE ZYD 4MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3666656',
  CIP13: '3400936666566',
  ucdLib: "MOLSIDOMINE SDZ 2MG CPR",
  UCD7: '9272361',
  UCD13: '3400892723617',
  ucdQtyMultiplicator: 30,
  cipLib: "MOLSIDOMINE SDZ 2MG CPR BT 30",
  atcCode: "C01DX12"
}, {
  CIP7: '3666662',
  CIP13: '3400936666627',
  ucdLib: "MOLSIDOMINE SDZ 2MG CPR",
  UCD7: '9272361',
  UCD13: '3400892723617',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE SDZ 2MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3962805',
  CIP13: '3400939628059',
  ucdLib: "MOLSIDOMINE CRT 4MG CPR",
  UCD7: '9335334',
  UCD13: '3400893353349',
  ucdQtyMultiplicator: 90,
  cipLib: "MOLSIDOMINE CRT 4MG CPR BT 90",
  atcCode: "C01DX12"
}, {
  CIP7: '3049159',
  CIP13: '3400930491591',
  ucdLib: "HEPTAMYL 187,8MG CPR",
  UCD7: '9043123',
  UCD13: '3400890431231',
  ucdQtyMultiplicator: 20,
  cipLib: "HEPTAMYL 187,8MG CPR BT 20",
  atcCode: "C01DX08"
}, {
  CIP7: '5579401',
  CIP13: '3400955794011',
  ucdLib: "HEPTAMYL 187,8MG CPR",
  UCD7: '9043123',
  UCD13: '3400890431231',
  ucdQtyMultiplicator: 150,
  cipLib: "HEPTAMYL 187,8MG CPR BT 150",
  atcCode: "C01DX08"
}, {
  CIP7: '5593772',
  CIP13: '3400955937722',
  ucdLib: "HEPTAMINOL RCA 187,8MG CPR",
  UCD7: '9176545',
  UCD13: '3400891765458',
  ucdQtyMultiplicator: 500,
  cipLib: "HEPTAMINOL RCA 187,8MG CPR BT 500",
  atcCode: "C01DX08"
}, {
  CIP7: '3187186',
  CIP13: '3400931871866',
  ucdLib: "AMPECYCLAL 300MG GELU",
  UCD7: '9004086',
  UCD13: '3400890040860',
  ucdQtyMultiplicator: 30,
  cipLib: "AMPECYCLAL 300MG GELU BT 30",
  atcCode: "C01DX08"
}, {
  CIP7: '5604889',
  CIP13: '3400956048892',
  ucdLib: "HEPTAMINOL RCA 30,5% BUV 100ML",
  UCD7: '9195353',
  UCD13: '3400891953534',
  ucdQtyMultiplicator: 1,
  cipLib: "HEPTAMINOL RCA 30,5% BUV 100ML BT 1",
  atcCode: "C01DX08"
}, {
  CIP7: '3286480',
  CIP13: '3400932864805',
  ucdLib: "MONICOR LP 40MG GELU",
  UCD7: '9124382',
  UCD13: '3400891243826',
  ucdQtyMultiplicator: 30,
  cipLib: "MONICOR LP 40MG GELU BT 30",
  atcCode: "C01DA14"
}, {
  CIP7: '3286505',
  CIP13: '3400932865055',
  ucdLib: "MONICOR LP 60MG GELU",
  UCD7: '9125401',
  UCD13: '3400891254013',
  ucdQtyMultiplicator: 30,
  cipLib: "MONICOR LP 60MG GELU BT 30",
  atcCode: "C01DA14"
}, {
  CIP7: '3279296',
  CIP13: '3400932792962',
  ucdLib: "MONICOR LP 20MG GELU",
  UCD7: '9107751',
  UCD13: '3400891077513',
  ucdQtyMultiplicator: 30,
  cipLib: "MONICOR LP 20MG GELU BT 30",
  atcCode: "C01DA14"
}, {
  CIP7: '3279304',
  CIP13: '3400932793044',
  ucdLib: "MONICOR LP 20MG GELU",
  UCD7: '9107751',
  UCD13: '3400891077513',
  ucdQtyMultiplicator: 60,
  cipLib: "MONICOR LP 20MG GELU BT 60",
  atcCode: "C01DA14"
}, {
  CIP7: '3291274',
  CIP13: '3400932912742',
  ucdLib: "ISOCARD SPRAY SOL PULV FL20ML",
  UCD7: '9134759',
  UCD13: '3400891347593',
  ucdQtyMultiplicator: 1,
  cipLib: "ISOCARD SPRAY SOL PULV FL20ML BT 1",
  atcCode: "C01DA08"
}, {
  CIP7: '5557925',
  CIP13: '3400955579250',
  ucdLib: "RISORDAN 10MG INJ AMP10ML",
  UCD7: '9080644',
  UCD13: '3400890806442',
  ucdQtyMultiplicator: 50,
  cipLib: "RISORDAN 10MG INJ AMP10ML BT 50",
  atcCode: "C01DA08"
}, {
  CIP7: '3240443',
  CIP13: '3400932404438',
  ucdLib: "RISORDAN 20MG CPR",
  UCD7: '9080673',
  UCD13: '3400890806732',
  ucdQtyMultiplicator: 60,
  cipLib: "RISORDAN 20MG CPR BT 60",
  atcCode: "C01DA08"
}, {
  CIP7: '3324884',
  CIP13: '3400933248840',
  ucdLib: "DISCOTRINE 10MG/24H DISP",
  UCD7: '9144999',
  UCD13: '3400891449990',
  ucdQtyMultiplicator: 30,
  cipLib: "DISCOTRINE 10MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3324861',
  CIP13: '3400933248611',
  ucdLib: "DISCOTRINE 5MG/24H DISP",
  UCD7: '9144841',
  UCD13: '3400891448412',
  ucdQtyMultiplicator: 30,
  cipLib: "DISCOTRINE 5MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3283056',
  CIP13: '3400932830565',
  ucdLib: "NITRIDERM TTS 10MG/24H DISP",
  UCD7: '9104304',
  UCD13: '3400891043044',
  ucdQtyMultiplicator: 30,
  cipLib: "NITRIDERM TTS 10MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3283033',
  CIP13: '3400932830336',
  ucdLib: "NITRIDERM TTS 5MG/24H DISP",
  UCD7: '9103204',
  UCD13: '3400891032048',
  ucdQtyMultiplicator: 30,
  cipLib: "NITRIDERM TTS 5MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3293698',
  CIP13: '3400932936984',
  ucdLib: "NATISPRAY 0,15MG BUC FL200DOS",
  UCD7: '9130342',
  UCD13: '3400891303421',
  ucdQtyMultiplicator: 1,
  cipLib: "NATISPRAY 0,15MG BUC FL200DOS BT 1",
  atcCode: "C01DA02"
}, {
  CIP7: '3374267',
  CIP13: '3400933742676',
  ucdLib: "DIAFUSOR 10MG/24H DISP TRANS",
  UCD7: '9126317',
  UCD13: '3400891263176',
  ucdQtyMultiplicator: 30,
  cipLib: "DIAFUSOR 10MG/24H DISP TRANS BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3374304',
  CIP13: '3400933743048',
  ucdLib: "DIAFUSOR 15MG/24H DISP TRANS",
  UCD7: '9170784',
  UCD13: '3400891707847',
  ucdQtyMultiplicator: 30,
  cipLib: "DIAFUSOR 15MG/24H DISP TRANS BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3374238',
  CIP13: '3400933742386',
  ucdLib: "DIAFUSOR 5MG/24H DISP TRANS",
  UCD7: '9126323',
  UCD13: '3400891263237',
  ucdQtyMultiplicator: 30,
  cipLib: "DIAFUSOR 5MG/24H DISP TRANS BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3430706',
  CIP13: '3400934307065',
  ucdLib: "NATISPRAY 0,30MG BUC FL300DOS",
  UCD7: '9194394',
  UCD13: '3400891943948',
  ucdQtyMultiplicator: 1,
  cipLib: "NATISPRAY 0,30MG BUC FL300DOS BT 1",
  atcCode: "C01DA02"
}, {
  CIP7: '3407512',
  CIP13: '3400934075124',
  ucdLib: "NITRIDERM TTS 15MG/24H DISP",
  UCD7: '9186555',
  UCD13: '3400891865554',
  ucdQtyMultiplicator: 30,
  cipLib: "NITRIDERM TTS 15MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3395654',
  CIP13: '3400933956547',
  ucdLib: "DISCOTRINE 15MG/24H DISP",
  UCD7: '9182971',
  UCD13: '3400891829716',
  ucdQtyMultiplicator: 30,
  cipLib: "DISCOTRINE 15MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3569775',
  CIP13: '3400935697752',
  ucdLib: "TRINITRINE MYL 10MG/24H DISP",
  UCD7: '9251301',
  UCD13: '3400892513010',
  ucdQtyMultiplicator: 30,
  cipLib: "TRINITRINE MYL 10MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3569769',
  CIP13: '3400935697691',
  ucdLib: "TRINITRINE MYL 5MG/24H DISP",
  UCD7: '9251318',
  UCD13: '3400892513188',
  ucdQtyMultiplicator: 30,
  cipLib: "TRINITRINE MYL 5MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3589909',
  CIP13: '3400935899095',
  ucdLib: "EPINITRIL 10MG/24H DISP",
  UCD7: '9243626',
  UCD13: '3400892436265',
  ucdQtyMultiplicator: 30,
  cipLib: "EPINITRIL 10MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3589921',
  CIP13: '3400935899217',
  ucdLib: "EPINITRIL 15MG/24H DISP",
  UCD7: '9243632',
  UCD13: '3400892436326',
  ucdQtyMultiplicator: 30,
  cipLib: "EPINITRIL 15MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3589884',
  CIP13: '3400935898845',
  ucdLib: "EPINITRIL 5MG/24H DISP",
  UCD7: '9243649',
  UCD13: '3400892436494',
  ucdQtyMultiplicator: 30,
  cipLib: "EPINITRIL 5MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3380730',
  CIP13: '3400933807306',
  ucdLib: "TRINIPATCH 10MG/24H DISP",
  UCD7: '9171275',
  UCD13: '3400891712759',
  ucdQtyMultiplicator: 30,
  cipLib: "TRINIPATCH 10MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3380724',
  CIP13: '3400933807245',
  ucdLib: "TRINIPATCH 5MG/24H DISP",
  UCD7: '9171281',
  UCD13: '3400891712810',
  ucdQtyMultiplicator: 30,
  cipLib: "TRINIPATCH 5MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '3476708',
  CIP13: '3400934767081',
  ucdLib: "TRINIPATCH 15MG/24H DISP",
  UCD7: '9210207',
  UCD13: '3400892102078',
  ucdQtyMultiplicator: 30,
  cipLib: "TRINIPATCH 15MG/24H DISP BT 30",
  atcCode: "C01DA02"
}, {
  CIP7: '5671495',
  CIP13: '3400956714957',
  ucdLib: "NITRONAL 1MG/ML INJ AMP10ML",
  UCD7: '9310920',
  UCD13: '3400893109205',
  ucdQtyMultiplicator: 10,
  cipLib: "NITRONAL 1MG/ML INJ AMP10ML BT 10",
  atcCode: "C01DA02"
}, {
  CIP7: '5671489',
  CIP13: '3400956714896',
  ucdLib: "NITRONAL 1MG/ML INJ AMP5ML",
  UCD7: '9310937',
  UCD13: '3400893109373',
  ucdQtyMultiplicator: 10,
  cipLib: "NITRONAL 1MG/ML INJ AMP5ML BT 10",
  atcCode: "C01DA02"
}, {
  CIP7: '3002104',
  CIP13: '3400930021040',
  ucdLib: "ZIMINO 2,5MG/ML INJ FL5ML",
  UCD7: '9418178',
  UCD13: '3400894181781',
  ucdQtyMultiplicator: 1,
  cipLib: "ZIMINO 2,5MG/ML INJ FL5ML BT 1",
  atcCode: "C01CX08"
}, {
  CIP7: '5560264',
  CIP13: '3400955602644',
  ucdLib: "PERFANE 100MG IV AMP20ML",
  UCD7: '9131063',
  UCD13: '3400891310634',
  ucdQtyMultiplicator: 10,
  cipLib: "PERFANE 100MG IV AMP20ML BT 10",
  atcCode: "C01CE03"
}, {
  CIP7: '5560229',
  CIP13: '3400955602293',
  ucdLib: "COROTROPE 10MG IV AMP10ML",
  UCD7: '9124933',
  UCD13: '3400891249330',
  ucdQtyMultiplicator: 10,
  cipLib: "COROTROPE 10MG IV AMP10ML BT 10",
  atcCode: "C01CE02"
}, {
  CIP7: '5500123',
  CIP13: '3400955001232',
  ucdLib: "MILRINONE PAN 1MG/ML AMP10ML",
  UCD7: '9408889',
  UCD13: '3400894088899',
  ucdQtyMultiplicator: 10,
  cipLib: "MILRINONE PAN 1MG/ML AMP10ML BT 10",
  atcCode: "C01CE02"
}, {
  CIP7: '5826986',
  CIP13: '3400958269868',
  ucdLib: "MILRINONE MDC 10MG INJ A10ML",
  UCD7: '9390712',
  UCD13: '3400893907122',
  ucdQtyMultiplicator: 10,
  cipLib: "MILRINONE MDC 10MG INJ A10ML BT 10",
  atcCode: "C01CE02"
}, {
  CIP7: '5639020',
  CIP13: '3400956390205',
  ucdLib: "EPHEDRINE AGT 30MG/ML AB1ML",
  UCD7: '9242845',
  UCD13: '3400892428451',
  ucdQtyMultiplicator: 10,
  cipLib: "EPHEDRINE AGT 30MG/ML AB1ML BT 10",
  atcCode: "C01CA26"
}, {
  CIP7: '5632779',
  CIP13: '3400956327799',
  ucdLib: "EPHEDRINE REN 30MG INJ A1ML",
  UCD7: '9230718',
  UCD13: '3400892307183',
  ucdQtyMultiplicator: 10,
  cipLib: "EPHEDRINE REN 30MG INJ A1ML BT 10",
  atcCode: "C01CA26"
}, {
  CIP7: '5632816',
  CIP13: '3400956328161',
  ucdLib: "EPHEDRINE REN 30MG INJ A1ML",
  UCD7: '9230718',
  UCD13: '3400892307183',
  ucdQtyMultiplicator: 100,
  cipLib: "EPHEDRINE REN 30MG INJ A1ML BT 100",
  atcCode: "C01CA26"
}, {
  CIP7: '5758434',
  CIP13: '3400957584344',
  ucdLib: "EPHEDRINE AGT 3MG/ML SP10ML",
  UCD7: '9338456',
  UCD13: '3400893384565',
  ucdQtyMultiplicator: 12,
  cipLib: "EPHEDRINE AGT 3MG/ML SP10ML BT 12",
  atcCode: "C01CA26"
}, {
  CIP7: '5710137',
  CIP13: '3400957101374',
  ucdLib: "EPHEDRINE REN 30MG INJ 10ML",
  UCD7: '9304960',
  UCD13: '3400893049600',
  ucdQtyMultiplicator: 10,
  cipLib: "EPHEDRINE REN 30MG INJ 10ML BT 10",
  atcCode: "C01CA26"
}, {
  CIP7: '5843507',
  CIP13: '3400958435072',
  ucdLib: "EPHEDRINE AGT 30MG/10ML AP",
  UCD7: '9391568',
  UCD13: '3400893915684',
  ucdQtyMultiplicator: 10,
  cipLib: "EPHEDRINE AGT 30MG/10ML AP BT 10",
  atcCode: "C01CA26"
}, {
  CIP7: '5805808',
  CIP13: '3400958058080',
  ucdLib: "EPHEDRINE ARW 30MG/ML A.1ML",
  UCD7: '9374340',
  UCD13: '3400893743409',
  ucdQtyMultiplicator: 10,
  cipLib: "EPHEDRINE ARW 30MG/ML A.1ML BT 10",
  atcCode: "C01CA26"
}, {
  CIP7: '3615736',
  CIP13: '3400936157361',
  ucdLib: "ANAPEN 150MCG INJ SRG0,3ML",
  UCD7: '9222239',
  UCD13: '3400892222394',
  ucdQtyMultiplicator: 2,
  cipLib: "ANAPEN 150MCG INJ SRG0,3ML BT 2",
  atcCode: "C01CA24"
}, {
  CIP7: '3615742',
  CIP13: '3400936157422',
  ucdLib: "ANAPEN 300MCG INJ SRG0,3ML",
  UCD7: '9222245',
  UCD13: '3400892222455',
  ucdQtyMultiplicator: 2,
  cipLib: "ANAPEN 300MCG INJ SRG0,3ML BT 2",
  atcCode: "C01CA24"
}, {
  CIP7: '3005497',
  CIP13: '3400930054970',
  ucdLib: "ADRENALIN0,1MG/ML AGT SS10ML",
  UCD7: '9415777',
  UCD13: '3400894157779',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALIN0,1MG/ML AGT SS10ML BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '3003829',
  CIP13: '3400930038291',
  ucdLib: "JEXT 150MCG INJ STYLO0,15ML",
  UCD7: '9389181',
  UCD13: '3400893891810',
  ucdQtyMultiplicator: 2,
  cipLib: "JEXT 150MCG INJ STYLO0,15ML BT 2",
  atcCode: "C01CA24"
}, {
  CIP7: '3003830',
  CIP13: '3400930038307',
  ucdLib: "JEXT 300MCG INJ STYLO0,30ML",
  UCD7: '9389198',
  UCD13: '3400893891988',
  ucdQtyMultiplicator: 2,
  cipLib: "JEXT 300MCG INJ STYLO0,30ML BT 2",
  atcCode: "C01CA24"
}, {
  CIP7: '3195317',
  CIP13: '3400931953173',
  ucdLib: "ADRENALINE 1MG/ML AGT A.1ML",
  UCD7: '9001320',
  UCD13: '3400890013208',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALINE 1MG/ML AGT A.1ML BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '4985493',
  CIP13: '3400949854936',
  ucdLib: "JEXT 150MCG INJ STYLO0,15ML",
  UCD7: '9389181',
  UCD13: '3400893891810',
  ucdQtyMultiplicator: 1,
  cipLib: "JEXT 150MCG INJ STYLO0,15ML BT 1",
  atcCode: "C01CA24"
}, {
  CIP7: '4985501',
  CIP13: '3400949855018',
  ucdLib: "JEXT 300MCG INJ STYLO0,30ML",
  UCD7: '9389198',
  UCD13: '3400893891988',
  ucdQtyMultiplicator: 1,
  cipLib: "JEXT 300MCG INJ STYLO0,30ML BT 1",
  atcCode: "C01CA24"
}, {
  CIP7: '3643394',
  CIP13: '3400936433946',
  ucdLib: "ADRENALINE 0,25MG/ML REN AB",
  UCD7: '9262090',
  UCD13: '3400892620909',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALINE 0,25MG/ML REN AB BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '3643365',
  CIP13: '3400936433656',
  ucdLib: "ADRENALINE 0,50MG/ML REN AB",
  UCD7: '9261995',
  UCD13: '3400892619958',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALINE 0,50MG/ML REN AB BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '3643336',
  CIP13: '3400936433366',
  ucdLib: "ADRENALINE 1MG/ML REN AB20ML",
  UCD7: '9310736',
  UCD13: '3400893107362',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALINE 1MG/ML REN AB20ML BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '3643299',
  CIP13: '3400936432994',
  ucdLib: "ADRENALINE 1MG/ML REN AB5ML",
  UCD7: '9262026',
  UCD13: '3400892620268',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALINE 1MG/ML REN AB5ML BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '2756469',
  CIP13: '3400927564697',
  ucdLib: "EPIPEN 0,15MG/0,3ML INJ STYLO",
  UCD7: '9402289',
  UCD13: '3400894022893',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIPEN 0,15MG/0,3ML INJ STYLO BT 1",
  atcCode: "C01CA24"
}, {
  CIP7: '2756475',
  CIP13: '3400927564758',
  ucdLib: "EPIPEN 0,15MG/0,3ML INJ STYLO",
  UCD7: '9402289',
  UCD13: '3400894022893',
  ucdQtyMultiplicator: 2,
  cipLib: "EPIPEN 0,15MG/0,3ML INJ STYLO BT 2",
  atcCode: "C01CA24"
}, {
  CIP7: '2756481',
  CIP13: '3400927564819',
  ucdLib: "EPIPEN 0,30MG/0,3ML INJ STYLO",
  UCD7: '9402295',
  UCD13: '3400894022954',
  ucdQtyMultiplicator: 1,
  cipLib: "EPIPEN 0,30MG/0,3ML INJ STYLO BT 1",
  atcCode: "C01CA24"
}, {
  CIP7: '2756498',
  CIP13: '3400927564987',
  ucdLib: "EPIPEN 0,30MG/0,3ML INJ STYLO",
  UCD7: '9402295',
  UCD13: '3400894022954',
  ucdQtyMultiplicator: 2,
  cipLib: "EPIPEN 0,30MG/0,3ML INJ STYLO BT 2",
  atcCode: "C01CA24"
}, {
  CIP7: '5727801',
  CIP13: '3400957278014',
  ucdLib: "ADRENALINE 1MG/ML AGT SS 1ML",
  UCD7: '9374707',
  UCD13: '3400893747070',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALINE 1MG/ML AGT SS 1ML BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '5714224',
  CIP13: '3400957142247',
  ucdLib: "ADRENALINE 1MG/ML AGT SS 5ML",
  UCD7: '9306462',
  UCD13: '3400893064627',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALINE 1MG/ML AGT SS 5ML BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '5654611',
  CIP13: '3400956546114',
  ucdLib: "ADRENALINE 0,25MG/ML REN AB",
  UCD7: '9262090',
  UCD13: '3400892620909',
  ucdQtyMultiplicator: 100,
  cipLib: "ADRENALINE 0,25MG/ML REN AB BT 100",
  atcCode: "C01CA24"
}, {
  CIP7: '5654597',
  CIP13: '3400956545971',
  ucdLib: "ADRENALINE 0,50MG/ML REN AB",
  UCD7: '9261995',
  UCD13: '3400892619958',
  ucdQtyMultiplicator: 100,
  cipLib: "ADRENALINE 0,50MG/ML REN AB BT 100",
  atcCode: "C01CA24"
}, {
  CIP7: '5654545',
  CIP13: '3400956545452',
  ucdLib: "ADRENALINE 1MG/ML REN AB1ML",
  UCD7: '9262003',
  UCD13: '3400892620039',
  ucdQtyMultiplicator: 10,
  cipLib: "ADRENALINE 1MG/ML REN AB1ML BT 10",
  atcCode: "C01CA24"
}, {
  CIP7: '5654574',
  CIP13: '3400956545742',
  ucdLib: "ADRENALINE 1MG/ML REN AB1ML",
  UCD7: '9262003',
  UCD13: '3400892620039',
  ucdQtyMultiplicator: 100,
  cipLib: "ADRENALINE 1MG/ML REN AB1ML BT 100",
  atcCode: "C01CA24"
}, {
  CIP7: '3482548',
  CIP13: '3400934825484',
  ucdLib: "GUTRON 2,5MG CPR",
  UCD7: '9160403',
  UCD13: '3400891604030',
  ucdQtyMultiplicator: 30,
  cipLib: "GUTRON 2,5MG CPR BT 30",
  atcCode: "C01CA17"
}, {
  CIP7: '3482554',
  CIP13: '3400934825545',
  ucdLib: "GUTRON 2,5MG CPR",
  UCD7: '9160403',
  UCD13: '3400891604030',
  ucdQtyMultiplicator: 90,
  cipLib: "GUTRON 2,5MG CPR BT 90",
  atcCode: "C01CA17"
}, {
  CIP7: '5624432',
  CIP13: '3400956244324',
  ucdLib: "DOBUTAMINE MYL 250MG INJ AMP",
  UCD7: '9220298',
  UCD13: '3400892202983',
  ucdQtyMultiplicator: 10,
  cipLib: "DOBUTAMINE MYL 250MG INJ AMP BT 10",
  atcCode: "C01CA07"
}, {
  CIP7: '5633477',
  CIP13: '3400956334773',
  ucdLib: "DOBUTAMINE PAN 250MG INJ FL",
  UCD7: '9233639',
  UCD13: '3400892336398',
  ucdQtyMultiplicator: 10,
  cipLib: "DOBUTAMINE PAN 250MG INJ FL BT 10",
  atcCode: "C01CA07"
}, {
  CIP7: '5701598',
  CIP13: '3400957015985',
  ucdLib: "DOBUTAMINE AGT 250MG IV 20ML",
  UCD7: '9291022',
  UCD13: '3400892910222',
  ucdQtyMultiplicator: 10,
  cipLib: "DOBUTAMINE AGT 250MG IV 20ML BT 10",
  atcCode: "C01CA07"
}, {
  CIP7: '3000104',
  CIP13: '3400930001042',
  ucdLib: "PHENYLEPH.AGT 50MCG SRG10ML",
  UCD7: '9404578',
  UCD13: '3400894045786',
  ucdQtyMultiplicator: 10,
  cipLib: "PHENYLEPH.AGT 50MCG SRG10ML BT 10",
  atcCode: "C01CA06"
}, {
  CIP7: '5805694',
  CIP13: '3400958056949',
  ucdLib: "PHENYLEPH.REN 100MCG AMP5ML",
  UCD7: '9380286',
  UCD13: '3400893802861',
  ucdQtyMultiplicator: 10,
  cipLib: "PHENYLEPH.REN 100MCG AMP5ML BT 10",
  atcCode: "C01CA06"
}, {
  CIP7: '5805642',
  CIP13: '3400958056420',
  ucdLib: "PHENYLEPH.REN 50MCG AMP10ML",
  UCD7: '9380263',
  UCD13: '3400893802632',
  ucdQtyMultiplicator: 10,
  cipLib: "PHENYLEPH.REN 50MCG AMP10ML BT 10",
  atcCode: "C01CA06"
}, {
  CIP7: '5623645',
  CIP13: '3400956236459',
  ucdLib: "DOPAMINE AGT 10MG/ML AMP5ML",
  UCD7: '9216598',
  UCD13: '3400892165981',
  ucdQtyMultiplicator: 50,
  cipLib: "DOPAMINE AGT 10MG/ML AMP5ML BT 50",
  atcCode: "C01CA04"
}, {
  CIP7: '5618093',
  CIP13: '3400956180936',
  ucdLib: "DOPAMINE AGT 40MG/ML AMP5ML",
  UCD7: '9216606',
  UCD13: '3400892166063',
  ucdQtyMultiplicator: 50,
  cipLib: "DOPAMINE AGT 40MG/ML AMP5ML BT 50",
  atcCode: "C01CA04"
}, {
  CIP7: '5646959',
  CIP13: '3400956469598',
  ucdLib: "DOPAMINE MYL 40MG/ML AMP5ML",
  UCD7: '9248345',
  UCD13: '3400892483450',
  ucdQtyMultiplicator: 50,
  cipLib: "DOPAMINE MYL 40MG/ML AMP5ML BT 50",
  atcCode: "C01CA04"
}, {
  CIP7: '5645546',
  CIP13: '3400956455461',
  ucdLib: "DOPAMINE MYL 5MG/ML AMP10ML",
  UCD7: '9248351',
  UCD13: '3400892483511',
  ucdQtyMultiplicator: 50,
  cipLib: "DOPAMINE MYL 5MG/ML AMP10ML BT 50",
  atcCode: "C01CA04"
}, {
  CIP7: '5644995',
  CIP13: '3400956449958',
  ucdLib: "DOPAMINE REN 10MG/ML AMP5ML",
  UCD7: '9246263',
  UCD13: '3400892462639',
  ucdQtyMultiplicator: 10,
  cipLib: "DOPAMINE REN 10MG/ML AMP5ML BT 10",
  atcCode: "C01CA04"
}, {
  CIP7: '5634502',
  CIP13: '3400956345021',
  ucdLib: "DOPAMINE REN 40MG/ML AMP5ML",
  UCD7: '9242271',
  UCD13: '3400892422718',
  ucdQtyMultiplicator: 100,
  cipLib: "DOPAMINE REN 40MG/ML AMP5ML BT 100",
  atcCode: "C01CA04"
}, {
  CIP7: '5645463',
  CIP13: '3400956454631',
  ucdLib: "DOPAMINE REN 5MG/ML AMP10ML",
  UCD7: '9246286',
  UCD13: '3400892462868',
  ucdQtyMultiplicator: 10,
  cipLib: "DOPAMINE REN 5MG/ML AMP10ML BT 10",
  atcCode: "C01CA04"
}, {
  CIP7: '5609355',
  CIP13: '3400956093557',
  ucdLib: "NORADRENALINE AGT 2MG/ML 4ML",
  UCD7: '9195761',
  UCD13: '3400891957617',
  ucdQtyMultiplicator: 10,
  cipLib: "NORADRENALINE AGT 2MG/ML 4ML BT 10",
  atcCode: "C01CA03"
}, {
  CIP7: '5646103',
  CIP13: '3400956461035',
  ucdLib: "NORADRENALINE AGT 2MG/ML 8ML",
  UCD7: '9243460',
  UCD13: '3400892434605',
  ucdQtyMultiplicator: 10,
  cipLib: "NORADRENALINE AGT 2MG/ML 8ML BT 10",
  atcCode: "C01CA03"
}, {
  CIP7: '5643547',
  CIP13: '3400956435470',
  ucdLib: "NORADRENALINE MYL 2MG/ML 4ML",
  UCD7: '9250856',
  UCD13: '3400892508566',
  ucdQtyMultiplicator: 50,
  cipLib: "NORADRENALINE MYL 2MG/ML 4ML BT 50",
  atcCode: "C01CA03"
}, {
  CIP7: '2172998',
  CIP13: '3400921729986',
  ucdLib: "NORADRENALINE HPI 2MG/ML 4ML",
  UCD7: '9377114',
  UCD13: '3400893771143',
  ucdQtyMultiplicator: 5,
  cipLib: "NORADRENALINE HPI 2MG/ML 4ML BT 5",
  atcCode: "C01CA03"
}, {
  CIP7: '5845937',
  CIP13: '3400958459375',
  ucdLib: "NORADRENAL.REN0,5MG/ML F50ML",
  UCD7: '9399297',
  UCD13: '3400893992975',
  ucdQtyMultiplicator: 12,
  cipLib: "NORADRENAL.REN0,5MG/ML F50ML BT 12",
  atcCode: "C01CA03"
}, {
  CIP7: '5845989',
  CIP13: '3400958459894',
  ucdLib: "NORADRENAL.REN1MG/ML FL50ML",
  UCD7: '9399305',
  UCD13: '3400893993057',
  ucdQtyMultiplicator: 12,
  cipLib: "NORADRENAL.REN1MG/ML FL50ML BT 12",
  atcCode: "C01CA03"
}, {
  CIP7: '5680979',
  CIP13: '3400956809790',
  ucdLib: "NORADRENAL.REN2MG/ML SC 8ML",
  UCD7: '9310191',
  UCD13: '3400893101919',
  ucdQtyMultiplicator: 10,
  cipLib: "NORADRENAL.REN2MG/ML SC 8ML BT 10",
  atcCode: "C01CA03"
}, {
  CIP7: '5657354',
  CIP13: '3400956573547',
  ucdLib: "NORADRENAL.REN2MG/ML SC 4ML",
  UCD7: '9270511',
  UCD13: '3400892705118',
  ucdQtyMultiplicator: 10,
  cipLib: "NORADRENAL.REN2MG/ML SC 4ML BT 10",
  atcCode: "C01CA03"
}, {
  CIP7: '5529739',
  CIP13: '3400955297390',
  ucdLib: "ISUPREL 0,2MG INJ AMP1ML",
  UCD7: '9047888',
  UCD13: '3400890478885',
  ucdQtyMultiplicator: 50,
  cipLib: "ISUPREL 0,2MG INJ AMP1ML BT 50",
  atcCode: "C01CA02"
}, {
  CIP7: '3035016',
  CIP13: '3400930350164',
  ucdLib: "EFFORTIL 5MG CPR",
  UCD7: '9030505',
  UCD13: '3400890305051',
  ucdQtyMultiplicator: 30,
  cipLib: "EFFORTIL 5MG CPR BT 30",
  atcCode: "C01CA01"
}, {
  CIP7: '3035022',
  CIP13: '3400930350225',
  ucdLib: "EFFORTIL BUV GTT FL30ML",
  UCD7: '9030511',
  UCD13: '3400890305112',
  ucdQtyMultiplicator: 1,
  cipLib: "EFFORTIL BUV GTT FL30ML BT 1",
  atcCode: "C01CA01"
}, {
  CIP7: '3594075',
  CIP13: '3400935940759',
  ucdLib: "ETILEFRINE SRB 10MG/ML INJ A.",
  UCD7: '9238097',
  UCD13: '3400892380971',
  ucdQtyMultiplicator: 6,
  cipLib: "ETILEFRINE SRB 10MG/ML INJ A. BT 6",
  atcCode: "C01CA01"
}, {
  CIP7: '3294829',
  CIP13: '3400932948291',
  ucdLib: "CIPRALAN 130MG CPR SECAB",
  UCD7: '9121107',
  UCD13: '3400891211078',
  ucdQtyMultiplicator: 30,
  cipLib: "CIPRALAN 130MG CPR SECAB BT 30",
  atcCode: "C01BG07"
}, {
  CIP7: '3345024',
  CIP13: '3400933450243',
  ucdLib: "EXACOR 130MG CPR",
  UCD7: '9155394',
  UCD13: '3400891553949',
  ucdQtyMultiplicator: 30,
  cipLib: "EXACOR 130MG CPR BT 30",
  atcCode: "C01BG07"
}, {
  CIP7: '3990167',
  CIP13: '3400939901671',
  ucdLib: "MULTAQ 400MG CPR",
  UCD7: '9342848',
  UCD13: '3400893428481',
  ucdQtyMultiplicator: 60,
  cipLib: "MULTAQ 400MG CPR BT 60",
  atcCode: "C01BD07"
}, {
  CIP7: '3454440',
  CIP13: '3400934544408',
  ucdLib: "AMIODARONE MYL 200MG CPR",
  UCD7: '9201473',
  UCD13: '3400892014739',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE MYL 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3454457',
  CIP13: '3400934544576',
  ucdLib: "AMIODARONE MYL 200MG CPR",
  UCD7: '9201473',
  UCD13: '3400892014739',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE MYL 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3611425',
  CIP13: '3400936114258',
  ucdLib: "AMIODARONE TVC 200MG CPR",
  UCD7: '9244442',
  UCD13: '3400892444420',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE TVC 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3000838',
  CIP13: '3400930008386',
  ucdLib: "AMIODARONE BGA 200MG CPR",
  UCD7: '9218870',
  UCD13: '3400892188706',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE BGA 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3025650',
  CIP13: '3400930256503',
  ucdLib: "CORDARONE 200MG CPR",
  UCD7: '9022055',
  UCD13: '3400890220552',
  ucdQtyMultiplicator: 30,
  cipLib: "CORDARONE 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3199976',
  CIP13: '3400931999768',
  ucdLib: "CORDARONE 150MG IV AMP3ML",
  UCD7: '9022049',
  UCD13: '3400890220491',
  ucdQtyMultiplicator: 6,
  cipLib: "CORDARONE 150MG IV AMP3ML BT 6",
  atcCode: "C01BD01"
}, {
  CIP7: '4985636',
  CIP13: '3400949856367',
  ucdLib: "AMIODARONE ISD 200MG CPR",
  UCD7: '9366211',
  UCD13: '3400893662113',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE ISD 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3673604',
  CIP13: '3400936736047',
  ucdLib: "AMIODARONE ZEN 200MG CPR",
  UCD7: '9266604',
  UCD13: '3400892666044',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE ZEN 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3556809',
  CIP13: '3400935568090',
  ucdLib: "AMIODARONE ACT 200MG CPR",
  UCD7: '9343428',
  UCD13: '3400893434284',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE ACT 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3558808',
  CIP13: '3400935588081',
  ucdLib: "AMIODARONE ALM 200MG CPR",
  UCD7: '9295675',
  UCD13: '3400892956756',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE ALM 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3567345',
  CIP13: '3400935673459',
  ucdLib: "AMIODARONE ARW 200MG CPR",
  UCD7: '9235213',
  UCD13: '3400892352138',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE ARW 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3558820',
  CIP13: '3400935588203',
  ucdLib: "AMIODARONE ZYD 200MG CPR",
  UCD7: '9299006',
  UCD13: '3400892990064',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE ZYD 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '5590012',
  CIP13: '3400955900122',
  ucdLib: "CORDARONE 200MG CPR",
  UCD7: '9022055',
  UCD13: '3400890220552',
  ucdQtyMultiplicator: 50,
  cipLib: "CORDARONE 200MG CPR BT 50",
  atcCode: "C01BD01"
}, {
  CIP7: '3537769',
  CIP13: '3400935377692',
  ucdLib: "AMIODARONE BGA 200MG CPR",
  UCD7: '9218870',
  UCD13: '3400892188706',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE BGA 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3537752',
  CIP13: '3400935377524',
  ucdLib: "AMIODARONE CRT 200MG CPR",
  UCD7: '9220016',
  UCD13: '3400892200163',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE CRT 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3658272',
  CIP13: '3400936582729',
  ucdLib: "AMIODARONE SDZ 200MG CPR",
  UCD7: '9263764',
  UCD13: '3400892637648',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE SDZ 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3540719',
  CIP13: '3400935407191',
  ucdLib: "AMIODARONE EG 200MG CPR",
  UCD7: '9220938',
  UCD13: '3400892209388',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE EG 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '3794383',
  CIP13: '3400937943833',
  ucdLib: "AMIODARONE RBX 200MG CPR",
  UCD7: '9317744',
  UCD13: '3400893177440',
  ucdQtyMultiplicator: 30,
  cipLib: "AMIODARONE RBX 200MG CPR BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '4900082',
  CIP13: '3400949000821',
  ucdLib: "CORDARONE 200MG C.AIPMWI RO",
  UCD7: '9419019',
  UCD13: '3400894190196',
  ucdQtyMultiplicator: 30,
  cipLib: "CORDARONE 200MG C.AIPMWI RO BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '4901438',
  CIP13: '3400949014385',
  ucdLib: "CORDARONE 200MG C.AIPPLA PT",
  UCD7: '9394302',
  UCD13: '3400893943021',
  ucdQtyMultiplicator: 30,
  cipLib: "CORDARONE 200MG C.AIPPLA PT BT 30",
  atcCode: "C01BD01"
}, {
  CIP7: '5711740',
  CIP13: '3400957117405',
  ucdLib: "AMIODARONE AGT 50MG/ML A.3ML",
  UCD7: '9296031',
  UCD13: '3400892960319',
  ucdQtyMultiplicator: 10,
  cipLib: "AMIODARONE AGT 50MG/ML A.3ML BT 10",
  atcCode: "C01BD01"
}, {
  CIP7: '5766646',
  CIP13: '3400957666460',
  ucdLib: "AMIODARONE ARW 200MG CPR",
  UCD7: '9235213',
  UCD13: '3400892352138',
  ucdQtyMultiplicator: 50,
  cipLib: "AMIODARONE ARW 200MG CPR BT 50",
  atcCode: "C01BD01"
}, {
  CIP7: '3263622',
  CIP13: '3400932636228',
  ucdLib: "FLECAINE 100MG CPR",
  UCD7: '9035224',
  UCD13: '3400890352246',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINE 100MG CPR BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3599977',
  CIP13: '3400935999771',
  ucdLib: "FLECAINIDE RPG 100MG CPR",
  UCD7: '9249847',
  UCD13: '3400892498478',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE RPG 100MG CPR BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3580564',
  CIP13: '3400935805645',
  ucdLib: "FLECAINE LP 100MG GELU",
  UCD7: '9246814',
  UCD13: '3400892468143',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINE LP 100MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3580541',
  CIP13: '3400935805416',
  ucdLib: "FLECAINE LP 150MG GELU",
  UCD7: '9246820',
  UCD13: '3400892468204',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINE LP 150MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3580587',
  CIP13: '3400935805874',
  ucdLib: "FLECAINE LP 200MG GELU",
  UCD7: '9246837',
  UCD13: '3400892468372',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINE LP 200MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3580529',
  CIP13: '3400935805294',
  ucdLib: "FLECAINE LP 50MG GELU",
  UCD7: '9246843',
  UCD13: '3400892468433',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINE LP 50MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3824434',
  CIP13: '3400938244342',
  ucdLib: "FLECAINIDE ARW 100MG CPR",
  UCD7: '9312356',
  UCD13: '3400893123560',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE ARW 100MG CPR BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3824150',
  CIP13: '3400938241501',
  ucdLib: "FLECAINIDE BGA 100MG CPR",
  UCD7: '9310417',
  UCD13: '3400893104170',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE BGA 100MG CPR BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3824581',
  CIP13: '3400938245813',
  ucdLib: "FLECAINIDE EG 100MG CPR",
  UCD7: '9309609',
  UCD13: '3400893096093',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE EG 100MG CPR BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3642526',
  CIP13: '3400936425262',
  ucdLib: "FLECAINIDE MYL 100MG CPR",
  UCD7: '9263540',
  UCD13: '3400892635408',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE MYL 100MG CPR BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3824859',
  CIP13: '3400938248593',
  ucdLib: "FLECAINIDE SDZ 100MG CPR",
  UCD7: '9308981',
  UCD13: '3400893089811',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE SDZ 100MG CPR BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '5637452',
  CIP13: '3400956374526',
  ucdLib: "FLECAINE 10MG/ML INJ AMP15ML",
  UCD7: '9243508',
  UCD13: '3400892435084',
  ucdQtyMultiplicator: 5,
  cipLib: "FLECAINE 10MG/ML INJ AMP15ML BT 5",
  atcCode: "C01BC04"
}, {
  CIP7: '2758735',
  CIP13: '3400927587351',
  ucdLib: "FLECAINIDE BGA LP 100MG GELU",
  UCD7: '9402473',
  UCD13: '3400894024736',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE BGA LP 100MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2758741',
  CIP13: '3400927587412',
  ucdLib: "FLECAINIDE BGA LP 150MG GELU",
  UCD7: '9402496',
  UCD13: '3400894024965',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE BGA LP 150MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2758758',
  CIP13: '3400927587580',
  ucdLib: "FLECAINIDE BGA LP 200MG GELU",
  UCD7: '9402504',
  UCD13: '3400894025047',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE BGA LP 200MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2758729',
  CIP13: '3400927587290',
  ucdLib: "FLECAINIDE BGA LP 50MG GELU",
  UCD7: '9402510',
  UCD13: '3400894025108',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE BGA LP 50MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2757109',
  CIP13: '3400927571091',
  ucdLib: "FLECAINIDE TVC LP 100MG GELU",
  UCD7: '9402527',
  UCD13: '3400894025276',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE TVC LP 100MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2757115',
  CIP13: '3400927571152',
  ucdLib: "FLECAINIDE TVC LP 150MG GELU",
  UCD7: '9402533',
  UCD13: '3400894025337',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE TVC LP 150MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2757121',
  CIP13: '3400927571213',
  ucdLib: "FLECAINIDE TVC LP 200MG GELU",
  UCD7: '9402556',
  UCD13: '3400894025566',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE TVC LP 200MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2757090',
  CIP13: '3400927570902',
  ucdLib: "FLECAINIDE TVC LP 50MG GELU",
  UCD7: '9402562',
  UCD13: '3400894025627',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE TVC LP 50MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2758770',
  CIP13: '3400927587702',
  ucdLib: "FLECAINIDE ZEN LP 100MG GELU",
  UCD7: '9402332',
  UCD13: '3400894023326',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE ZEN LP 100MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2758787',
  CIP13: '3400927587870',
  ucdLib: "FLECAINIDE ZEN LP 150MG GELU",
  UCD7: '9402349',
  UCD13: '3400894023494',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE ZEN LP 150MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2758793',
  CIP13: '3400927587931',
  ucdLib: "FLECAINIDE ZEN LP 200MG GELU",
  UCD7: '9402355',
  UCD13: '3400894023555',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE ZEN LP 200MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '2758764',
  CIP13: '3400927587641',
  ucdLib: "FLECAINIDE ZEN LP 50MG GELU",
  UCD7: '9402361',
  UCD13: '3400894023616',
  ucdQtyMultiplicator: 30,
  cipLib: "FLECAINIDE ZEN LP 50MG GELU BT 30",
  atcCode: "C01BC04"
}, {
  CIP7: '3265710',
  CIP13: '3400932657100',
  ucdLib: "RYTHMOL 300MG CPR",
  UCD7: '9081566',
  UCD13: '3400890815666',
  ucdQtyMultiplicator: 30,
  cipLib: "RYTHMOL 300MG CPR BT 30",
  atcCode: "C01BC03"
}, {
  CIP7: '3749709',
  CIP13: '3400937497091',
  ucdLib: "XYLOCARD 20MG/ML IV AMP5ML",
  UCD7: '9294635',
  UCD13: '3400892946351',
  ucdQtyMultiplicator: 10,
  cipLib: "XYLOCARD 20MG/ML IV AMP5ML BT 10",
  atcCode: "C01BB01"
}, {
  CIP7: '5509412',
  CIP13: '3400955094128',
  ucdLib: "XYLOCARD 50MG/ML PERF FV20ML",
  UCD7: '9101808',
  UCD13: '3400891018080',
  ucdQtyMultiplicator: 10,
  cipLib: "XYLOCARD 50MG/ML PERF FV20ML BT 10",
  atcCode: "C01BB01"
}, {
  CIP7: '3240087',
  CIP13: '3400932400874',
  ucdLib: "SERECOR 300MG GELU",
  UCD7: '9083708',
  UCD13: '3400890837088',
  ucdQtyMultiplicator: 60,
  cipLib: "SERECOR 300MG GELU BT 60",
  atcCode: "C01BA13"
}, {
  CIP7: '3298939',
  CIP13: '3400932989393',
  ucdLib: "ISORYTHM LP 125MG GELU",
  UCD7: '9138958',
  UCD13: '3400891389586',
  ucdQtyMultiplicator: 20,
  cipLib: "ISORYTHM LP 125MG GELU BT 20",
  atcCode: "C01BA03"
}, {
  CIP7: '3298945',
  CIP13: '3400932989454',
  ucdLib: "ISORYTHM LP 250MG GELU",
  UCD7: '9138964',
  UCD13: '3400891389647',
  ucdQtyMultiplicator: 20,
  cipLib: "ISORYTHM LP 250MG GELU BT 20",
  atcCode: "C01BA03"
}, {
  CIP7: '3246026',
  CIP13: '3400932460267',
  ucdLib: "RYTHMODAN LP 250MG CPR",
  UCD7: '9081543',
  UCD13: '3400890815437',
  ucdQtyMultiplicator: 20,
  cipLib: "RYTHMODAN LP 250MG CPR BT 20",
  atcCode: "C01BA03"
}, {
  CIP7: '3093545',
  CIP13: '3400930935453',
  ucdLib: "RYTHMODAN 100MG GELU",
  UCD7: '9081537',
  UCD13: '3400890815376',
  ucdQtyMultiplicator: 40,
  cipLib: "RYTHMODAN 100MG GELU BT 40",
  atcCode: "C01BA03"
}, {
  CIP7: '3031389',
  CIP13: '3400930313893',
  ucdLib: "DIGOXINE NAT 0,5MG INJ AMP",
  UCD7: '9027041',
  UCD13: '3400890270410',
  ucdQtyMultiplicator: 6,
  cipLib: "DIGOXINE NAT 0,5MG INJ AMP BT 6",
  atcCode: "C01AA05"
}, {
  CIP7: '3116341',
  CIP13: '3400931163411',
  ucdLib: "DIGOXINE NAT BUV GTT FV60ML",
  UCD7: '9027064',
  UCD13: '3400890270649',
  ucdQtyMultiplicator: 1,
  cipLib: "DIGOXINE NAT BUV GTT FV60ML BT 1",
  atcCode: "C01AA05"
}, {
  CIP7: '3346609',
  CIP13: '3400933466091',
  ucdLib: "DIGOXINE NAT 0,25MG CPR",
  UCD7: '9027058',
  UCD13: '3400890270588',
  ucdQtyMultiplicator: 30,
  cipLib: "DIGOXINE NAT 0,25MG CPR BT 30",
  atcCode: "C01AA05"
}, {
  CIP7: '3348904',
  CIP13: '3400933489045',
  ucdLib: "HEMIGOXINE NAT 0,125MG CPR",
  UCD7: '9194342',
  UCD13: '3400891943429',
  ucdQtyMultiplicator: 30,
  cipLib: "HEMIGOXINE NAT 0,125MG CPR BT 30",
  atcCode: "C01AA05"
}, {
  CIP7: '4989410',
  CIP13: '3400949894109',
  ucdLib: "RUCONEST 2100U INJ FL",
  UCD7: '9362696',
  UCD13: '3400893626962',
  ucdQtyMultiplicator: 1,
  cipLib: "RUCONEST 2100U INJ FL BT 1",
  atcCode: "B06AC04"
}, {
  CIP7: '3873680',
  CIP13: '3400938736809',
  ucdLib: "FIRAZYR 30MG INJ SRG3ML",
  UCD7: '9320166',
  UCD13: '3400893201664',
  ucdQtyMultiplicator: 1,
  cipLib: "FIRAZYR 30MG INJ SRG3ML BT 1",
  atcCode: "B06AC02"
}, {
  CIP7: '5745963',
  CIP13: '3400957459635',
  ucdLib: "BERINERT 500UI INJ F+F",
  UCD7: '9268081',
  UCD13: '3400892680811',
  ucdQtyMultiplicator: 1,
  cipLib: "BERINERT 500UI INJ F+F BT 1",
  atcCode: "B06AC01"
}, {
  CIP7: '2185630',
  CIP13: '3400921856309',
  ucdLib: "CINRYZE 500UI INJ FL+FL",
  UCD7: '9382351',
  UCD13: '3400893823514',
  ucdQtyMultiplicator: 2,
  cipLib: "CINRYZE 500UI INJ FL+FL BT 2",
  atcCode: "B06AC01"
}, {
  CIP7: '5586111',
  CIP13: '3400955861119',
  ucdLib: "NORMOSANG 25MG/ML INJ AMP10ML",
  UCD7: '9173475',
  UCD13: '3400891734751',
  ucdQtyMultiplicator: 4,
  cipLib: "NORMOSANG 25MG/ML INJ AMP10ML BT 4",
  atcCode: "B06AB01"
}, {
  CIP7: '3838293',
  CIP13: '3400938382938',
  ucdLib: "HEMOSOL BO P.POLY5000ML",
  UCD7: '9310104',
  UCD13: '3400893101049',
  ucdQtyMultiplicator: 2,
  cipLib: "HEMOSOL BO P.POLY5000ML BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3608736',
  CIP13: '3400936087361',
  ucdLib: "HOSPASOL 167MMOL/L INJ POC3L",
  UCD7: '9247819',
  UCD13: '3400892478197',
  ucdQtyMultiplicator: 3,
  cipLib: "HOSPASOL 167MMOL/L INJ POC3L BT 3",
  atcCode: "B05ZB"
}, {
  CIP7: '3469447',
  CIP13: '3400934694479',
  ucdLib: "MULTIBIC 2/POT HEMO POC5L",
  UCD7: '9346823',
  UCD13: '3400893468234',
  ucdQtyMultiplicator: 2,
  cipLib: "MULTIBIC 2/POT HEMO POC5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3469542',
  CIP13: '3400934695421',
  ucdLib: "MULTIBIC 4/POT HEMO POC5L",
  UCD7: '9346846',
  UCD13: '3400893468463',
  ucdQtyMultiplicator: 2,
  cipLib: "MULTIBIC 4/POT HEMO POC5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3469424',
  CIP13: '3400934694240',
  ucdLib: "MULTIBIC S/POT HEMO POC5L",
  UCD7: '9346817',
  UCD13: '3400893468173',
  ucdQtyMultiplicator: 2,
  cipLib: "MULTIBIC S/POT HEMO POC5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3747716',
  CIP13: '3400937477161',
  ucdLib: "ACCUSOL 35 INJ CFX5L",
  UCD7: '9287606',
  UCD13: '3400892876061',
  ucdQtyMultiplicator: 2,
  cipLib: "ACCUSOL 35 INJ CFX5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3747722',
  CIP13: '3400937477222',
  ucdLib: "ACCUSOL 35 POTAS.2MMOL CFX5L",
  UCD7: '9287581',
  UCD13: '3400892875811',
  ucdQtyMultiplicator: 2,
  cipLib: "ACCUSOL 35 POTAS.2MMOL CFX5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3747739',
  CIP13: '3400937477390',
  ucdLib: "ACCUSOL 35 POTAS.4MMOL CFX5L",
  UCD7: '9287598',
  UCD13: '3400892875989',
  ucdQtyMultiplicator: 2,
  cipLib: "ACCUSOL 35 POTAS.4MMOL CFX5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3812862',
  CIP13: '3400938128628',
  ucdLib: "PRISMASOL 2MMOL/L POTAS.POL5L",
  UCD7: '9313350',
  UCD13: '3400893133507',
  ucdQtyMultiplicator: 2,
  cipLib: "PRISMASOL 2MMOL/L POTAS.POL5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3840143',
  CIP13: '3400938401431',
  ucdLib: "PRISMASOL 4MMOL/L POTAS.POL5L",
  UCD7: '9313367',
  UCD13: '3400893133675',
  ucdQtyMultiplicator: 2,
  cipLib: "PRISMASOL 4MMOL/L POTAS.POL5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3944977',
  CIP13: '3400939449777',
  ucdLib: "PHOXILIUM 1,2MMOL/L PHO.POL5L",
  UCD7: '9338290',
  UCD13: '3400893382905',
  ucdQtyMultiplicator: 2,
  cipLib: "PHOXILIUM 1,2MMOL/L PHO.POL5L BT 2",
  atcCode: "B05ZB"
}, {
  CIP7: '3676695',
  CIP13: '3400936766952',
  ucdLib: "SOLUVIT INJ FL",
  UCD7: '9141239',
  UCD13: '3400891412390',
  ucdQtyMultiplicator: 10,
  cipLib: "SOLUVIT INJ FL BT 10",
  atcCode: "B05XC"
}, {
  CIP7: '3565719',
  CIP13: '3400935657190',
  ucdLib: "CERNEVIT INJ FL",
  UCD7: '9134328',
  UCD13: '3400891343281',
  ucdQtyMultiplicator: 10,
  cipLib: "CERNEVIT INJ FL BT 10",
  atcCode: "B05XC"
}, {
  CIP7: '3658496',
  CIP13: '3400936584969',
  ucdLib: "VITALIPIDE AD. INJ AMP10ML",
  UCD7: '9141245',
  UCD13: '3400891412451',
  ucdQtyMultiplicator: 10,
  cipLib: "VITALIPIDE AD. INJ AMP10ML BT 10",
  atcCode: "B05XC"
}, {
  CIP7: '3692375',
  CIP13: '3400936923751',
  ucdLib: "VITALIPIDE ENF INJ AMP10ML",
  UCD7: '9141251',
  UCD13: '3400891412512',
  ucdQtyMultiplicator: 10,
  cipLib: "VITALIPIDE ENF INJ AMP10ML BT 10",
  atcCode: "B05XC"
}, {
  CIP7: '3442514',
  CIP13: '3400934425141',
  ucdLib: "DIPEPTIVEN PERF FL100ML",
  UCD7: '9198357',
  UCD13: '3400891983579',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPEPTIVEN PERF FL100ML BT 1",
  atcCode: "B05XB02"
}, {
  CIP7: '3442508',
  CIP13: '3400934425080',
  ucdLib: "DIPEPTIVEN PERF FL50ML",
  UCD7: '9198363',
  UCD13: '3400891983630',
  ucdQtyMultiplicator: 1,
  cipLib: "DIPEPTIVEN PERF FL50ML BT 1",
  atcCode: "B05XB02"
}, {
  CIP7: '3003522',
  CIP13: '3400930035221',
  ucdLib: "NUTRYELT PERF AMP10ML",
  UCD7: '9406117',
  UCD13: '3400894061175',
  ucdQtyMultiplicator: 10,
  cipLib: "NUTRYELT PERF AMP10ML BT 10",
  atcCode: "B05XA31"
}, {
  CIP7: '3001374',
  CIP13: '3400930013748',
  ucdLib: "SUPPLIVEN PERF AMP10ML",
  UCD7: '9409794',
  UCD13: '3400894097945',
  ucdQtyMultiplicator: 20,
  cipLib: "SUPPLIVEN PERF AMP10ML BT 20",
  atcCode: "B05XA31"
}, {
  CIP7: '3642880',
  CIP13: '3400936428805',
  ucdLib: "PHOCYTAN 0,33MMOL/ML A.B20ML",
  UCD7: '9259478',
  UCD13: '3400892594781',
  ucdQtyMultiplicator: 50,
  cipLib: "PHOCYTAN 0,33MMOL/ML A.B20ML BT 50",
  atcCode: "B05XA31"
}, {
  CIP7: '2202848',
  CIP13: '3400922028484',
  ucdLib: "PHOCYTAN 0,66MMOL/ML AMP10ML",
  UCD7: '9382670',
  UCD13: '3400893826706',
  ucdQtyMultiplicator: 10,
  cipLib: "PHOCYTAN 0,66MMOL/ML AMP10ML BT 10",
  atcCode: "B05XA31"
}, {
  CIP7: '2202860',
  CIP13: '3400922028606',
  ucdLib: "PHOCYTAN 0,66MMOL/ML AMP10ML",
  UCD7: '9382670',
  UCD13: '3400893826706',
  ucdQtyMultiplicator: 50,
  cipLib: "PHOCYTAN 0,66MMOL/ML AMP10ML BT 50",
  atcCode: "B05XA31"
}, {
  CIP7: '5564701',
  CIP13: '3400955647010',
  ucdLib: "OLIGO-ELEMENTS AGT BB. FV40ML",
  UCD7: '9137605',
  UCD13: '3400891376050',
  ucdQtyMultiplicator: 1,
  cipLib: "OLIGO-ELEMENTS AGT BB. FV40ML BT 1",
  atcCode: "B05XA30"
}, {
  CIP7: '3523796',
  CIP13: '3400935237965',
  ucdLib: "DECAN PERF FL40ML",
  UCD7: '9218025',
  UCD13: '3400892180250',
  ucdQtyMultiplicator: 25,
  cipLib: "DECAN PERF FL40ML BT 25",
  atcCode: "B05XA30"
}, {
  CIP7: '3556525',
  CIP13: '3400935565259',
  ucdLib: "TRACUTIL PERF AMP10ML",
  UCD7: '9231830',
  UCD13: '3400892318301',
  ucdQtyMultiplicator: 5,
  cipLib: "TRACUTIL PERF AMP10ML BT 5",
  atcCode: "B05XA30"
}, {
  CIP7: '5559769',
  CIP13: '3400955597698',
  ucdLib: "PLEGISOL SOL CARDIOPL. POC 1L",
  UCD7: '9209368',
  UCD13: '3400892093680',
  ucdQtyMultiplicator: 1,
  cipLib: "PLEGISOL SOL CARDIOPL. POC 1L BT 1",
  atcCode: "B05XA16"
}, {
  CIP7: '5890019',
  CIP13: '3400958900198',
  ucdLib: "CUSTODIOL SOL CARDIO FL500ML",
  UCD7: '9409624',
  UCD13: '3400894096245',
  ucdQtyMultiplicator: 10,
  cipLib: "CUSTODIOL SOL CARDIO FL500ML BT 10",
  atcCode: "B05XA16"
}, {
  CIP7: '5890020',
  CIP13: '3400958900204',
  ucdLib: "CUSTODIOL SOL CARDIO P1000ML",
  UCD7: '9409630',
  UCD13: '3400894096306',
  ucdQtyMultiplicator: 6,
  cipLib: "CUSTODIOL SOL CARDIO P1000ML BT 6",
  atcCode: "B05XA16"
}, {
  CIP7: '5890021',
  CIP13: '3400958900211',
  ucdLib: "CUSTODIOL SOL CARDIO P2000ML",
  UCD7: '9409647',
  UCD13: '3400894096474',
  ucdQtyMultiplicator: 4,
  cipLib: "CUSTODIOL SOL CARDIO P2000ML BT 4",
  atcCode: "B05XA16"
}, {
  CIP7: '5890022',
  CIP13: '3400958900228',
  ucdLib: "CUSTODIOL SOL CARDIO P5000ML",
  UCD7: '9409653',
  UCD13: '3400894096535',
  ucdQtyMultiplicator: 2,
  cipLib: "CUSTODIOL SOL CARDIO P5000ML BT 2",
  atcCode: "B05XA16"
}, {
  CIP7: '3629833',
  CIP13: '3400936298330',
  ucdLib: "MAGNESIUM C.10% LAV AB10ML",
  UCD7: '9261423',
  UCD13: '3400892614236',
  ucdQtyMultiplicator: 10,
  cipLib: "MAGNESIUM C.10% LAV AB10ML BT 10",
  atcCode: "B05XA11"
}, {
  CIP7: '3664344',
  CIP13: '3400936643444',
  ucdLib: "MAGNESIUM CHL 10% REN A.B",
  UCD7: '9276761',
  UCD13: '3400892767611',
  ucdQtyMultiplicator: 100,
  cipLib: "MAGNESIUM CHL 10% REN A.B BT 100",
  atcCode: "B05XA11"
}, {
  CIP7: '5647806',
  CIP13: '3400956478064',
  ucdLib: "MAGNESIUM C.10% LAV AB10ML",
  UCD7: '9261423',
  UCD13: '3400892614236',
  ucdQtyMultiplicator: 100,
  cipLib: "MAGNESIUM C.10% LAV AB10ML BT 100",
  atcCode: "B05XA11"
}, {
  CIP7: '3649706',
  CIP13: '3400936497061',
  ucdLib: "CALCIUM CH.10% REN A.B10ML",
  UCD7: '9276749',
  UCD13: '3400892767499',
  ucdQtyMultiplicator: 10,
  cipLib: "CALCIUM CH.10% REN A.B10ML BT 10",
  atcCode: "B05XA07"
}, {
  CIP7: '3649735',
  CIP13: '3400936497351',
  ucdLib: "CALCIUM CH.10% REN A.B10ML",
  UCD7: '9276749',
  UCD13: '3400892767499',
  ucdQtyMultiplicator: 100,
  cipLib: "CALCIUM CH.10% REN A.B10ML BT 100",
  atcCode: "B05XA07"
}, {
  CIP7: '3605086',
  CIP13: '3400936050860',
  ucdLib: "PHOSPHATE DIPOT.REN AMP10ML",
  UCD7: '9246317',
  UCD13: '3400892463179',
  ucdQtyMultiplicator: 10,
  cipLib: "PHOSPHATE DIPOT.REN AMP10ML BT 10",
  atcCode: "B05XA06"
}, {
  CIP7: '3605034',
  CIP13: '3400936050341',
  ucdLib: "PHOSPHATE MONOPOT.REN A.10ML",
  UCD7: '9246323',
  UCD13: '3400892463230',
  ucdQtyMultiplicator: 10,
  cipLib: "PHOSPHATE MONOPOT.REN A.10ML BT 10",
  atcCode: "B05XA06"
}, {
  CIP7: '3619220',
  CIP13: '3400936192201',
  ucdLib: "MAGNESIUM SUL 10% REN 10ML",
  UCD7: '9297390',
  UCD13: '3400892973906',
  ucdQtyMultiplicator: 10,
  cipLib: "MAGNESIUM SUL 10% REN 10ML BT 10",
  atcCode: "B05XA05"
}, {
  CIP7: '3287611',
  CIP13: '3400932876112',
  ucdLib: "SPASMAG INJ AMP10ML",
  UCD7: '9121627',
  UCD13: '3400891216271',
  ucdQtyMultiplicator: 5,
  cipLib: "SPASMAG INJ AMP10ML BT 5",
  atcCode: "B05XA05"
}, {
  CIP7: '3629980',
  CIP13: '3400936299801',
  ucdLib: "MAGNESIUM S.15% LAV AB10ML",
  UCD7: '9261446',
  UCD13: '3400892614465',
  ucdQtyMultiplicator: 10,
  cipLib: "MAGNESIUM S.15% LAV AB10ML BT 10",
  atcCode: "B05XA05"
}, {
  CIP7: '3629997',
  CIP13: '3400936299979',
  ucdLib: "MAGNESIUM S.15% LAV AB20ML",
  UCD7: '9261452',
  UCD13: '3400892614526',
  ucdQtyMultiplicator: 10,
  cipLib: "MAGNESIUM S.15% LAV AB20ML BT 10",
  atcCode: "B05XA05"
}, {
  CIP7: '3664290',
  CIP13: '3400936642904',
  ucdLib: "MAGNESIUM SUL 15% REN A.B",
  UCD7: '9277163',
  UCD13: '3400892771632',
  ucdQtyMultiplicator: 100,
  cipLib: "MAGNESIUM SUL 15% REN A.B BT 100",
  atcCode: "B05XA05"
}, {
  CIP7: '3717307',
  CIP13: '3400937173070',
  ucdLib: "MAGNESIUM SUL 15% PROA.10ML",
  UCD7: '9281443',
  UCD13: '3400892814438',
  ucdQtyMultiplicator: 50,
  cipLib: "MAGNESIUM SUL 15% PROA.10ML BT 50",
  atcCode: "B05XA05"
}, {
  CIP7: '5647812',
  CIP13: '3400956478125',
  ucdLib: "MAGNESIUM S.15% LAV AB10ML",
  UCD7: '9261446',
  UCD13: '3400892614465',
  ucdQtyMultiplicator: 100,
  cipLib: "MAGNESIUM S.15% LAV AB10ML BT 100",
  atcCode: "B05XA05"
}, {
  CIP7: '5648266',
  CIP13: '3400956482665',
  ucdLib: "MAGNESIUM SUL 10% REN 10ML",
  UCD7: '9297390',
  UCD13: '3400892973906',
  ucdQtyMultiplicator: 100,
  cipLib: "MAGNESIUM SUL 10% REN 10ML BT 100",
  atcCode: "B05XA05"
}, {
  CIP7: '5538052',
  CIP13: '3400955380528',
  ucdLib: "SODIUM 0,9% AGT INJ L.S500ML",
  UCD7: '9176002',
  UCD13: '3400891760026',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% AGT INJ L.S500ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5535102',
  CIP13: '3400955351023',
  ucdLib: "SODIUM 0,9% LAV INJ FV1000ML",
  UCD7: '9084470',
  UCD13: '3400890844703',
  ucdQtyMultiplicator: 6,
  cipLib: "SODIUM 0,9% LAV INJ FV1000ML BT 6",
  atcCode: "B05XA03"
}, {
  CIP7: '5535131',
  CIP13: '3400955351313',
  ucdLib: "SODIUM 0,9% LAV INJ FV125ML",
  UCD7: '9115288',
  UCD13: '3400891152883',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM 0,9% LAV INJ FV125ML BT 24",
  atcCode: "B05XA03"
}, {
  CIP7: '5535125',
  CIP13: '3400955351252',
  ucdLib: "SODIUM 0,9% LAV INJ FV250ML",
  UCD7: '9115294',
  UCD13: '3400891152944',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% LAV INJ FV250ML BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '5535119',
  CIP13: '3400955351191',
  ucdLib: "SODIUM 0,9% LAV INJ FV500ML",
  UCD7: '9115302',
  UCD13: '3400891153026',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% LAV INJ FV500ML BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '5547281',
  CIP13: '3400955472810',
  ucdLib: "SODIUM 0,9% AGT INJ L.S2000ML",
  UCD7: '9084760',
  UCD13: '3400890847605',
  ucdQtyMultiplicator: 5,
  cipLib: "SODIUM 0,9% AGT INJ L.S2000ML BT 5",
  atcCode: "B05XA03"
}, {
  CIP7: '3618657',
  CIP13: '3400936186576',
  ucdLib: "SODIUM 0,9% BIOPERF P.1000ML",
  UCD7: '9255687',
  UCD13: '3400892556871',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% BIOPERF P.1000ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3618611',
  CIP13: '3400936186118',
  ucdLib: "SODIUM 0,9% BIOPERF POC100ML",
  UCD7: '9250804',
  UCD13: '3400892508047',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 0,9% BIOPERF POC100ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3618634',
  CIP13: '3400936186347',
  ucdLib: "SODIUM 0,9% BIOPERF POC250ML",
  UCD7: '9250810',
  UCD13: '3400892508108',
  ucdQtyMultiplicator: 30,
  cipLib: "SODIUM 0,9% BIOPERF POC250ML BT 30",
  atcCode: "B05XA03"
}, {
  CIP7: '3618640',
  CIP13: '3400936186408',
  ucdLib: "SODIUM 0,9% BIOPERF POC500ML",
  UCD7: '9255701',
  UCD13: '3400892557014',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% BIOPERF POC500ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3618605',
  CIP13: '3400936186057',
  ucdLib: "SODIUM 0,9% BIOPERF POC50ML",
  UCD7: '9250827',
  UCD13: '3400892508276',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 0,9% BIOPERF POC50ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3831138',
  CIP13: '3400938311389',
  ucdLib: "SODIUM 0,9% FRF INJ FP100ML",
  UCD7: '9307846',
  UCD13: '3400893078464',
  ucdQtyMultiplicator: 40,
  cipLib: "SODIUM 0,9% FRF INJ FP100ML BT 40",
  atcCode: "B05XA03"
}, {
  CIP7: '3831227',
  CIP13: '3400938312270',
  ucdLib: "SODIUM 0,9% FRF INJ FP1L",
  UCD7: '9307852',
  UCD13: '3400893078525',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ FP1L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3831233',
  CIP13: '3400938312331',
  ucdLib: "SODIUM 0,9% FRF INJ FP1L",
  UCD7: '9307852',
  UCD13: '3400893078525',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% FRF INJ FP1L BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3831167',
  CIP13: '3400938311679',
  ucdLib: "SODIUM 0,9% FRF INJ FP250ML",
  UCD7: '9307869',
  UCD13: '3400893078693',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% FRF INJ FP250ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3831204',
  CIP13: '3400938312041',
  ucdLib: "SODIUM 0,9% FRF INJ FP500ML",
  UCD7: '9307875',
  UCD13: '3400893078754',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% FRF INJ FP500ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3057839',
  CIP13: '3400930578391',
  ucdLib: "SODIUM 0,9% LAV INJ FV1000ML",
  UCD7: '9084470',
  UCD13: '3400890844703',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ FV1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3057845',
  CIP13: '3400930578452',
  ucdLib: "SODIUM 0,9% LAV INJ FV125ML",
  UCD7: '9115288',
  UCD13: '3400891152883',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ FV125ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3057897',
  CIP13: '3400930578971',
  ucdLib: "SODIUM 0,9% LAV INJ FV250ML",
  UCD7: '9115294',
  UCD13: '3400891152944',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ FV250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3057940',
  CIP13: '3400930579404',
  ucdLib: "SODIUM 0,9% LAV INJ FV500ML",
  UCD7: '9115302',
  UCD13: '3400891153026',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ FV500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3000438',
  CIP13: '3400930004388',
  ucdLib: "SODIUM 0,9% BAX CFX2L+VB.CL",
  UCD7: '9368316',
  UCD13: '3400893683163',
  ucdQtyMultiplicator: 6,
  cipLib: "SODIUM 0,9% BAX CFX2L+VB.CL BT 6",
  atcCode: "B05XA03"
}, {
  CIP7: '3000436',
  CIP13: '3400930004364',
  ucdLib: "SODIUM 0,9% BAX CFX2L+VBL",
  UCD7: '9239820',
  UCD13: '3400892398204',
  ucdQtyMultiplicator: 6,
  cipLib: "SODIUM 0,9% BAX CFX2L+VBL BT 6",
  atcCode: "B05XA03"
}, {
  CIP7: '3000434',
  CIP13: '3400930004340',
  ucdLib: "SODIUM 0,9% BAX CFX500ML+VBL",
  UCD7: '9248701',
  UCD13: '3400892487014',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% BAX CFX500ML+VBL BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3000425',
  CIP13: '3400930004258',
  ucdLib: "SODIUM 0,9% LAV INJ P.P100ML",
  UCD7: '9409222',
  UCD13: '3400894092223',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ P.P100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3000426',
  CIP13: '3400930004265',
  ucdLib: "SODIUM 0,9% LAV INJ P.P250ML",
  UCD7: '9409245',
  UCD13: '3400894092452',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ P.P250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3000427',
  CIP13: '3400930004272',
  ucdLib: "SODIUM 0,9% LAV INJ P.P500ML",
  UCD7: '9409268',
  UCD13: '3400894092681',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ P.P500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3000424',
  CIP13: '3400930004241',
  ucdLib: "SODIUM 0,9% LAV INJ P.P50ML",
  UCD7: '9409251',
  UCD13: '3400894092513',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ P.P50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3000428',
  CIP13: '3400930004289',
  ucdLib: "SODIUM 0,9% LAV INJ PP1000ML",
  UCD7: '9409239',
  UCD13: '3400894092391',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ PP1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5550969',
  CIP13: '3400955509691',
  ucdLib: "SODIUM 0,9% AGT INJ DAT2000ML",
  UCD7: '9175959',
  UCD13: '3400891759594',
  ucdQtyMultiplicator: 5,
  cipLib: "SODIUM 0,9% AGT INJ DAT2000ML BT 5",
  atcCode: "B05XA03"
}, {
  CIP7: '5558563',
  CIP13: '3400955585633',
  ucdLib: "SODIUM 0,9% FRF INJ FPP1L",
  UCD7: '9131347',
  UCD13: '3400891313475',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ FPP1L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5558557',
  CIP13: '3400955585572',
  ucdLib: "SODIUM 0,9% FRF INJ FPP500ML",
  UCD7: '9131376',
  UCD13: '3400891313765',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ FPP500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5557983',
  CIP13: '3400955579830',
  ucdLib: "SODIUM 0,9% LAV F125ML/100ML",
  UCD7: '9144373',
  UCD13: '3400891443738',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM 0,9% LAV F125ML/100ML BT 24",
  atcCode: "B05XA03"
}, {
  CIP7: '5557977',
  CIP13: '3400955579779',
  ucdLib: "SODIUM 0,9% LAV F125ML/50ML",
  UCD7: '9144396',
  UCD13: '3400891443967',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM 0,9% LAV F125ML/50ML BT 24",
  atcCode: "B05XA03"
}, {
  CIP7: '3268743',
  CIP13: '3400932687435',
  ucdLib: "SODIUM 0,9% BLZ INJ P.1000ML",
  UCD7: '9129209',
  UCD13: '3400891292091',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BLZ INJ P.1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3268737',
  CIP13: '3400932687374',
  ucdLib: "SODIUM 0,9% BLZ INJ P.500ML",
  UCD7: '9129250',
  UCD13: '3400891292503',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BLZ INJ P.500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3330873',
  CIP13: '3400933308735',
  ucdLib: "SODIUM 0,9% BLZ INJ P.100ML",
  UCD7: '9129190',
  UCD13: '3400891291902',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BLZ INJ P.100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3330867',
  CIP13: '3400933308674',
  ucdLib: "SODIUM 0,9% BLZ INJ P.250ML",
  UCD7: '9129221',
  UCD13: '3400891292213',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BLZ INJ P.250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3330896',
  CIP13: '3400933308964',
  ucdLib: "SODIUM 0,9% BLZ INJ P.50ML",
  UCD7: '9129244',
  UCD13: '3400891292442',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BLZ INJ P.50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5560040',
  CIP13: '3400955600404',
  ucdLib: "SODIUM 0,9% FRF INJ FPP250ML",
  UCD7: '9131353',
  UCD13: '3400891313536',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF INJ FPP250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5570475',
  CIP13: '3400955704751',
  ucdLib: "SODIUM 0,9% AGT INJ FV250ML",
  UCD7: '9115093',
  UCD13: '3400891150933',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% AGT INJ FV250ML BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '5570481',
  CIP13: '3400955704812',
  ucdLib: "SODIUM 0,9% AGT INJ FV500ML",
  UCD7: '9084748',
  UCD13: '3400890847483',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% AGT INJ FV500ML BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '3604922',
  CIP13: '3400936049222',
  ucdLib: "SODIUM 0,9% BBM INJ P.E1000ML",
  UCD7: '9178024',
  UCD13: '3400891780246',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM INJ P.E1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604885',
  CIP13: '3400936048850',
  ucdLib: "SODIUM 0,9% BBM INJ P.E100ML",
  UCD7: '9189430',
  UCD13: '3400891894301',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM INJ P.E100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604891',
  CIP13: '3400936048911',
  ucdLib: "SODIUM 0,9% BBM INJ P.E250ML",
  UCD7: '9178030',
  UCD13: '3400891780307',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM INJ P.E250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604916',
  CIP13: '3400936049161',
  ucdLib: "SODIUM 0,9% BBM INJ P.E500ML",
  UCD7: '9178047',
  UCD13: '3400891780475',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM INJ P.E500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604879',
  CIP13: '3400936048799',
  ucdLib: "SODIUM 0,9% BBM INJ P.E50ML",
  UCD7: '9189447',
  UCD13: '3400891894479',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM INJ P.E50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604974',
  CIP13: '3400936049741',
  ucdLib: "SODIUM 0,9% BBM P.ES1000ML",
  UCD7: '9225226',
  UCD13: '3400892252261',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM P.ES1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604945',
  CIP13: '3400936049451',
  ucdLib: "SODIUM 0,9% BBM P.ES100ML",
  UCD7: '9225203',
  UCD13: '3400892252032',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM P.ES100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604951',
  CIP13: '3400936049512',
  ucdLib: "SODIUM 0,9% BBM P.ES250ML",
  UCD7: '9225232',
  UCD13: '3400892252322',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM P.ES250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604968',
  CIP13: '3400936049680',
  ucdLib: "SODIUM 0,9% BBM P.ES500ML",
  UCD7: '9225255',
  UCD13: '3400892252551',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM P.ES500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3604939',
  CIP13: '3400936049390',
  ucdLib: "SODIUM 0,9% BBM P.ES50ML",
  UCD7: '9225249',
  UCD13: '3400892252490',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BBM P.ES50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5587151',
  CIP13: '3400955871514',
  ucdLib: "SODIUM 0,9% BSD FPP250/125ML",
  UCD7: '9171128',
  UCD13: '3400891711288',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% BSD FPP250/125ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3522928',
  CIP13: '3400935229281',
  ucdLib: "SODIUM 0,9% MAC INJ PP100ML",
  UCD7: '9139840',
  UCD13: '3400891398403',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PP100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3522911',
  CIP13: '3400935229113',
  ucdLib: "SODIUM 0,9% MAC INJ PP50ML",
  UCD7: '9139900',
  UCD13: '3400891399004',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PP50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3675129',
  CIP13: '3400936751293',
  ucdLib: "SODIUM 0,9% FRF SIS-SEBS100ML",
  UCD7: '9279883',
  UCD13: '3400892798837',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF SIS-SEBS100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3675158',
  CIP13: '3400936751583',
  ucdLib: "SODIUM 0,9% FRF SIS-SEBS1L",
  UCD7: '9276376',
  UCD13: '3400892763767',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF SIS-SEBS1L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3675135',
  CIP13: '3400936751354',
  ucdLib: "SODIUM 0,9% FRF SIS-SEBS250ML",
  UCD7: '9279908',
  UCD13: '3400892799087',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF SIS-SEBS250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3675141',
  CIP13: '3400936751415',
  ucdLib: "SODIUM 0,9% FRF SIS-SEBS500ML",
  UCD7: '9276382',
  UCD13: '3400892763828',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF SIS-SEBS500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3675112',
  CIP13: '3400936751125',
  ucdLib: "SODIUM 0,9% FRF SIS-SEBS50ML",
  UCD7: '9279914',
  UCD13: '3400892799148',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% FRF SIS-SEBS50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3670586',
  CIP13: '3400936705869',
  ucdLib: "SODIUM 20% PROAMP INJ 10ML",
  UCD7: '9276229',
  UCD13: '3400892762296',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 20% PROAMP INJ 10ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3670617',
  CIP13: '3400936706170',
  ucdLib: "SODIUM 20% PROAMP INJ 20ML",
  UCD7: '9276235',
  UCD13: '3400892762357',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 20% PROAMP INJ 20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3563330',
  CIP13: '3400935633309',
  ucdLib: "SODIUM 0,9% MAC INJ PBL1000ML",
  UCD7: '9230233',
  UCD13: '3400892302331',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PBL1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563347',
  CIP13: '3400935633477',
  ucdLib: "SODIUM 0,9% MAC INJ PBL2000ML",
  UCD7: '9230262',
  UCD13: '3400892302621',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PBL2000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563318',
  CIP13: '3400935633187',
  ucdLib: "SODIUM 0,9% MAC INJ PBL250ML",
  UCD7: '9230279',
  UCD13: '3400892302799',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PBL250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563324',
  CIP13: '3400935633248',
  ucdLib: "SODIUM 0,9% MAC INJ PBL500ML",
  UCD7: '9230291',
  UCD13: '3400892302911',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PBL500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563264',
  CIP13: '3400935632647',
  ucdLib: "SODIUM 0,9% MAC INJ PML1000ML",
  UCD7: '9230322',
  UCD13: '3400892303222',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PML1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563229',
  CIP13: '3400935632296',
  ucdLib: "SODIUM 0,9% MAC INJ PML100ML",
  UCD7: '9230316',
  UCD13: '3400892303161',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PML100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563241',
  CIP13: '3400935632418',
  ucdLib: "SODIUM 0,9% MAC INJ PML250ML",
  UCD7: '9230351',
  UCD13: '3400892303512',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PML250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563258',
  CIP13: '3400935632586',
  ucdLib: "SODIUM 0,9% MAC INJ PML500ML",
  UCD7: '9230374',
  UCD13: '3400892303741',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PML500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563198',
  CIP13: '3400935631985',
  ucdLib: "SODIUM 0,9% MAC INJ POC1000ML",
  UCD7: '9230150',
  UCD13: '3400892301501',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ POC1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563152',
  CIP13: '3400935631527',
  ucdLib: "SODIUM 0,9% MAC INJ POC100ML",
  UCD7: '9230144',
  UCD13: '3400892301440',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ POC100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563175',
  CIP13: '3400935631756',
  ucdLib: "SODIUM 0,9% MAC INJ POC250ML",
  UCD7: '9230196',
  UCD13: '3400892301969',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ POC250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563181',
  CIP13: '3400935631817',
  ucdLib: "SODIUM 0,9% MAC INJ POC500ML",
  UCD7: '9230210',
  UCD13: '3400892302102',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ POC500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3563146',
  CIP13: '3400935631466',
  ucdLib: "SODIUM 0,9% MAC INJ POC50ML",
  UCD7: '9230204',
  UCD13: '3400892302041',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ POC50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3518849',
  CIP13: '3400935188496',
  ucdLib: "SODIUM 0,9% BAX CFX1L+VEL",
  UCD7: '9155750',
  UCD13: '3400891557503',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% BAX CFX1L+VEL BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '3518861',
  CIP13: '3400935188618',
  ucdLib: "SODIUM 0,9% BAX CFX2L+VEL",
  UCD7: '9156732',
  UCD13: '3400891567328',
  ucdQtyMultiplicator: 6,
  cipLib: "SODIUM 0,9% BAX CFX2L+VEL BT 6",
  atcCode: "B05XA03"
}, {
  CIP7: '3518826',
  CIP13: '3400935188267',
  ucdLib: "SODIUM 0,9% BAX CFX500ML+VEL",
  UCD7: '9155773',
  UCD13: '3400891557732',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% BAX CFX500ML+VEL BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3653286',
  CIP13: '3400936532861',
  ucdLib: "SODIUM 0,9% CPF INJ AB10ML",
  UCD7: '9281822',
  UCD13: '3400892818221',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% CPF INJ AB10ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3653292',
  CIP13: '3400936532922',
  ucdLib: "SODIUM 0,9% CPF INJ AB20ML",
  UCD7: '9281845',
  UCD13: '3400892818450',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% CPF INJ AB20ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3653263',
  CIP13: '3400936532632',
  ucdLib: "SODIUM 0,9% CPF INJ AB5ML",
  UCD7: '9281851',
  UCD13: '3400892818511',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% CPF INJ AB5ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3510954',
  CIP13: '3400935109545',
  ucdLib: "SODIUM 0,9% CPF INJ FV1000ML",
  UCD7: '9218491',
  UCD13: '3400892184913',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% CPF INJ FV1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3510948',
  CIP13: '3400935109484',
  ucdLib: "SODIUM 0,9% CPF INJ FV250ML",
  UCD7: '9218516',
  UCD13: '3400892185163',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% CPF INJ FV250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3510977',
  CIP13: '3400935109774',
  ucdLib: "SODIUM 0,9% CPF INJ FV500ML",
  UCD7: '9218522',
  UCD13: '3400892185224',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% CPF INJ FV500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3535931',
  CIP13: '3400935359315',
  ucdLib: "SODIUM 0,9% MAC INJ PP1L",
  UCD7: '9139857',
  UCD13: '3400891398571',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PP1L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3535919',
  CIP13: '3400935359193',
  ucdLib: "SODIUM 0,9% MAC INJ PP250ML",
  UCD7: '9139892',
  UCD13: '3400891398922',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PP250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3535948',
  CIP13: '3400935359483',
  ucdLib: "SODIUM 0,9% MAC INJ PP2L",
  UCD7: '9139886',
  UCD13: '3400891398861',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PP2L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3535925',
  CIP13: '3400935359254',
  ucdLib: "SODIUM 0,9% MAC INJ PP500ML",
  UCD7: '9139917',
  UCD13: '3400891399172',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC INJ PP500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3598587',
  CIP13: '3400935985873',
  ucdLib: "SODIUM 0,9% VIAFLO POC1000ML",
  UCD7: '9260518',
  UCD13: '3400892605180',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% VIAFLO POC1000ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3595821',
  CIP13: '3400935958211',
  ucdLib: "SODIUM 0,9% VIAFLO POC100ML",
  UCD7: '9260501',
  UCD13: '3400892605012',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 0,9% VIAFLO POC100ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3595844',
  CIP13: '3400935958440',
  ucdLib: "SODIUM 0,9% VIAFLO POC250ML",
  UCD7: '9260530',
  UCD13: '3400892605302',
  ucdQtyMultiplicator: 30,
  cipLib: "SODIUM 0,9% VIAFLO POC250ML BT 30",
  atcCode: "B05XA03"
}, {
  CIP7: '3595850',
  CIP13: '3400935958501',
  ucdLib: "SODIUM 0,9% VIAFLO POC500ML",
  UCD7: '9260553',
  UCD13: '3400892605531',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% VIAFLO POC500ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3595815',
  CIP13: '3400935958150',
  ucdLib: "SODIUM 0,9% VIAFLO POC50ML",
  UCD7: '9260547',
  UCD13: '3400892605470',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 0,9% VIAFLO POC50ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3653398',
  CIP13: '3400936533981',
  ucdLib: "SODIUM 10% CPF INJ AB10ML",
  UCD7: '9283494',
  UCD13: '3400892834948',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 10% CPF INJ AB10ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3547265',
  CIP13: '3400935472656',
  ucdLib: "SODIUM 0,9% BAX CFX2L+V2",
  UCD7: '9224540',
  UCD13: '3400892245409',
  ucdQtyMultiplicator: 6,
  cipLib: "SODIUM 0,9% BAX CFX2L+V2 BT 6",
  atcCode: "B05XA03"
}, {
  CIP7: '5602318',
  CIP13: '3400956023189',
  ucdLib: "SODIUM 0,9% BBM INJ APE10ML",
  UCD7: '9189246',
  UCD13: '3400891892468',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% BBM INJ APE10ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5602324',
  CIP13: '3400956023240',
  ucdLib: "SODIUM 0,9% BBM INJ APE20ML",
  UCD7: '9189252',
  UCD13: '3400891892529',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% BBM INJ APE20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3701269',
  CIP13: '3400937012690',
  ucdLib: "SODIUM 0,9% FRF INJ AP10ML",
  UCD7: '9282112',
  UCD13: '3400892821122',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% FRF INJ AP10ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3701281',
  CIP13: '3400937012812',
  ucdLib: "SODIUM 0,9% FRF INJ AP20ML",
  UCD7: '9282129',
  UCD13: '3400892821290',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% FRF INJ AP20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3701217',
  CIP13: '3400937012171',
  ucdLib: "SODIUM 10% FRF INJ AP10ML",
  UCD7: '9282075',
  UCD13: '3400892820750',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 10% FRF INJ AP10ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3701246',
  CIP13: '3400937012461',
  ucdLib: "SODIUM 10% FRF INJ AP20ML",
  UCD7: '9282081',
  UCD13: '3400892820811',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 10% FRF INJ AP20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5602347',
  CIP13: '3400956023479',
  ucdLib: "SODIUM 20% BBM PERF AP10ML",
  UCD7: '9189453',
  UCD13: '3400891894530',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 20% BBM PERF AP10ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5602353',
  CIP13: '3400956023530',
  ucdLib: "SODIUM 20% BBM PERF AP20ML",
  UCD7: '9189476',
  UCD13: '3400891894769',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 20% BBM PERF AP20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3634076',
  CIP13: '3400936340763',
  ucdLib: "SODIUM 0,9% LAV INJ AB10ML",
  UCD7: '9261512',
  UCD13: '3400892615127',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ AB10ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3634082',
  CIP13: '3400936340824',
  ucdLib: "SODIUM 0,9% LAV INJ AB20ML",
  UCD7: '9261535',
  UCD13: '3400892615356',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ AB20ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3634047',
  CIP13: '3400936340473',
  ucdLib: "SODIUM 0,9% LAV INJ AB2ML",
  UCD7: '9261529',
  UCD13: '3400892615295',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ AB2ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3634053',
  CIP13: '3400936340534',
  ucdLib: "SODIUM 0,9% LAV INJ AB5ML",
  UCD7: '9261541',
  UCD13: '3400892615417',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ AB5ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3669353',
  CIP13: '3400936693531',
  ucdLib: "SODIUM 0,9% PROAMP INJ 10ML",
  UCD7: '9276152',
  UCD13: '3400892761527',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% PROAMP INJ 10ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3669413',
  CIP13: '3400936694132',
  ucdLib: "SODIUM 0,9% PROAMP INJ 20ML",
  UCD7: '9276169',
  UCD13: '3400892761695',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% PROAMP INJ 20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3669330',
  CIP13: '3400936693302',
  ucdLib: "SODIUM 0,9% PROAMP INJ 5ML",
  UCD7: '9276175',
  UCD13: '3400892761756',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 0,9% PROAMP INJ 5ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3634107',
  CIP13: '3400936341074',
  ucdLib: "SODIUM 10% LAV INJ AB10ML",
  UCD7: '9261558',
  UCD13: '3400892615585',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 10% LAV INJ AB10ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3634113',
  CIP13: '3400936341135',
  ucdLib: "SODIUM 10% LAV INJ AB20ML",
  UCD7: '9261564',
  UCD13: '3400892615646',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 10% LAV INJ AB20ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3669519',
  CIP13: '3400936695191',
  ucdLib: "SODIUM 10% PROAMP INJ 10ML",
  UCD7: '9276181',
  UCD13: '3400892761817',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 10% PROAMP INJ 10ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3669548',
  CIP13: '3400936695481',
  ucdLib: "SODIUM 10% PROAMP INJ 20ML",
  UCD7: '9276198',
  UCD13: '3400892761985',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 10% PROAMP INJ 20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3695959',
  CIP13: '3400936959590',
  ucdLib: "SODIUM 20% FRF INJ APP10ML",
  UCD7: '9282098',
  UCD13: '3400892820989',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 20% FRF INJ APP10ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3695971',
  CIP13: '3400936959712',
  ucdLib: "SODIUM 20% FRF INJ APP20ML",
  UCD7: '9282106',
  UCD13: '3400892821061',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 20% FRF INJ APP20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '3634136',
  CIP13: '3400936341364',
  ucdLib: "SODIUM 20% LAV INJ AB10ML",
  UCD7: '9261570',
  UCD13: '3400892615707',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 20% LAV INJ AB10ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3634142',
  CIP13: '3400936341425',
  ucdLib: "SODIUM 20% LAV INJ AB20ML",
  UCD7: '9261587',
  UCD13: '3400892615875',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 20% LAV INJ AB20ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3669465',
  CIP13: '3400936694651',
  ucdLib: "SODIUM 5,85% PROAMP INJ 20ML",
  UCD7: '9276241',
  UCD13: '3400892762418',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 5,85% PROAMP INJ 20ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5620730',
  CIP13: '3400956207305',
  ucdLib: "SODIUM 0,9% AGT INJ DAT3000ML",
  UCD7: '9175971',
  UCD13: '3400891759716',
  ucdQtyMultiplicator: 4,
  cipLib: "SODIUM 0,9% AGT INJ DAT3000ML BT 4",
  atcCode: "B05XA03"
}, {
  CIP7: '5612535',
  CIP13: '3400956125357',
  ucdLib: "SODIUM 0,9% CPF INJ FV1000ML",
  UCD7: '9218491',
  UCD13: '3400892184913',
  ucdQtyMultiplicator: 6,
  cipLib: "SODIUM 0,9% CPF INJ FV1000ML BT 6",
  atcCode: "B05XA03"
}, {
  CIP7: '5612512',
  CIP13: '3400956125128',
  ucdLib: "SODIUM 0,9% CPF INJ FV250ML",
  UCD7: '9218516',
  UCD13: '3400892185163',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% CPF INJ FV250ML BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '5612529',
  CIP13: '3400956125296',
  ucdLib: "SODIUM 0,9% CPF INJ FV500ML",
  UCD7: '9218522',
  UCD13: '3400892185224',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% CPF INJ FV500ML BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '3802800',
  CIP13: '3400938028003',
  ucdLib: "SODIUM 0,9% MAC P.EA/F100ML",
  UCD7: '9309710',
  UCD13: '3400893097106',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3802846',
  CIP13: '3400938028461',
  ucdLib: "SODIUM 0,9% MAC P.EA/F1L",
  UCD7: '9309727',
  UCD13: '3400893097274',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F1L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3802817',
  CIP13: '3400938028171',
  ucdLib: "SODIUM 0,9% MAC P.EA/F250ML",
  UCD7: '9309733',
  UCD13: '3400893097335',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3802823',
  CIP13: '3400938028232',
  ucdLib: "SODIUM 0,9% MAC P.EA/F500ML",
  UCD7: '9309762',
  UCD13: '3400893097625',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3802792',
  CIP13: '3400938027921',
  ucdLib: "SODIUM 0,9% MAC P.EA/F50ML",
  UCD7: '9309756',
  UCD13: '3400893097564',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5644819',
  CIP13: '3400956448197',
  ucdLib: "SODIUM 0,9% AGT INJ LS1000ML",
  UCD7: '9176539',
  UCD13: '3400891765397',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% AGT INJ LS1000ML BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '3952333',
  CIP13: '3400939523330',
  ucdLib: "SODIUM 0,9% LAV INJ AP10ML",
  UCD7: '9333447',
  UCD13: '3400893334478',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ AP10ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3952356',
  CIP13: '3400939523569',
  ucdLib: "SODIUM 0,9% LAV INJ AP20ML",
  UCD7: '9333453',
  UCD13: '3400893334539',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ AP20ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3952362',
  CIP13: '3400939523620',
  ucdLib: "SODIUM 0,9% LAV INJ AP20ML",
  UCD7: '9333453',
  UCD13: '3400893334539',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 0,9% LAV INJ AP20ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '3907775',
  CIP13: '3400939077758',
  ucdLib: "SODIUM 0,9% LAV INJ FP1000ML",
  UCD7: '9323526',
  UCD13: '3400893235263',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ FP1000ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3907781',
  CIP13: '3400939077819',
  ucdLib: "SODIUM 0,9% LAV INJ FP1000ML",
  UCD7: '9323526',
  UCD13: '3400893235263',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ FP1000ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3907717',
  CIP13: '3400939077178',
  ucdLib: "SODIUM 0,9% LAV INJ FP100ML",
  UCD7: '9323503',
  UCD13: '3400893235034',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ FP100ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3907723',
  CIP13: '3400939077239',
  ucdLib: "SODIUM 0,9% LAV INJ FP250ML",
  UCD7: '9323532',
  UCD13: '3400893235324',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ FP250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3907746',
  CIP13: '3400939077468',
  ucdLib: "SODIUM 0,9% LAV INJ FP250ML",
  UCD7: '9323532',
  UCD13: '3400893235324',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ FP250ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '3907752',
  CIP13: '3400939077529',
  ucdLib: "SODIUM 0,9% LAV INJ FP500ML",
  UCD7: '9323549',
  UCD13: '3400893235492',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% LAV INJ FP500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '3907769',
  CIP13: '3400939077697',
  ucdLib: "SODIUM 0,9% LAV INJ FP500ML",
  UCD7: '9323549',
  UCD13: '3400893235492',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% LAV INJ FP500ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '4974957',
  CIP13: '3400949749577',
  ucdLib: "SODIUM 0,9% MAC P.EA/F+100ML",
  UCD7: '9368351',
  UCD13: '3400893683514',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F+100ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4974992',
  CIP13: '3400949749928',
  ucdLib: "SODIUM 0,9% MAC P.EA/F+1L",
  UCD7: '9368368',
  UCD13: '3400893683682',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F+1L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4974963',
  CIP13: '3400949749638',
  ucdLib: "SODIUM 0,9% MAC P.EA/F+250ML",
  UCD7: '9368374',
  UCD13: '3400893683743',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F+250ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4974986',
  CIP13: '3400949749867',
  ucdLib: "SODIUM 0,9% MAC P.EA/F+500ML",
  UCD7: '9368397',
  UCD13: '3400893683972',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F+500ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4974940',
  CIP13: '3400949749409',
  ucdLib: "SODIUM 0,9% MAC P.EA/F+50ML",
  UCD7: '9368380',
  UCD13: '3400893683804',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9% MAC P.EA/F+50ML BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4191304',
  CIP13: '3400941913044',
  ucdLib: "SODIUM 0,9% FRF INJ FP50ML",
  UCD7: '9371962',
  UCD13: '3400893719626',
  ucdQtyMultiplicator: 40,
  cipLib: "SODIUM 0,9% FRF INJ FP50ML BT 40",
  atcCode: "B05XA03"
}, {
  CIP7: '4157425',
  CIP13: '3400941574252',
  ucdLib: "SODIUM 0,9%FRF SIS-SEBS 1L +L",
  UCD7: '9371985',
  UCD13: '3400893719855',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9%FRF SIS-SEBS 1L +L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4157394',
  CIP13: '3400941573941',
  ucdLib: "SODIUM 0,9%FRF SIS-SEBS100ML+L",
  UCD7: '9371979',
  UCD13: '3400893719794',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9%FRF SIS-SEBS100ML+L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4157402',
  CIP13: '3400941574023',
  ucdLib: "SODIUM 0,9%FRF SIS-SEBS250ML+L",
  UCD7: '9371991',
  UCD13: '3400893719916',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9%FRF SIS-SEBS250ML+L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4157419',
  CIP13: '3400941574191',
  ucdLib: "SODIUM 0,9%FRF SIS-SEBS500ML+L",
  UCD7: '9372022',
  UCD13: '3400893720226',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9%FRF SIS-SEBS500ML+L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '4157388',
  CIP13: '3400941573880',
  ucdLib: "SODIUM 0,9%FRF SIS-SEBS50ML +L",
  UCD7: '9372016',
  UCD13: '3400893720165',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM 0,9%FRF SIS-SEBS50ML +L BT 1",
  atcCode: "B05XA03"
}, {
  CIP7: '5758368',
  CIP13: '3400957583682',
  ucdLib: "SODIUM 0,9% BBM INJ P.E1000ML",
  UCD7: '9178024',
  UCD13: '3400891780246',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% BBM INJ P.E1000ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '5758374',
  CIP13: '3400957583743',
  ucdLib: "SODIUM 0,9% BBM INJ P.E100ML",
  UCD7: '9189430',
  UCD13: '3400891894301',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% BBM INJ P.E100ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5758380',
  CIP13: '3400957583804',
  ucdLib: "SODIUM 0,9% BBM INJ P.E250ML",
  UCD7: '9178030',
  UCD13: '3400891780307',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM 0,9% BBM INJ P.E250ML BT 20",
  atcCode: "B05XA03"
}, {
  CIP7: '5758351',
  CIP13: '3400957583514',
  ucdLib: "SODIUM 0,9% BBM INJ P.E500ML",
  UCD7: '9178047',
  UCD13: '3400891780475',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM 0,9% BBM INJ P.E500ML BT 10",
  atcCode: "B05XA03"
}, {
  CIP7: '5754206',
  CIP13: '3400957542061',
  ucdLib: "SODIUM 0,9% LAV INJ AP10ML",
  UCD7: '9333447',
  UCD13: '3400893334478',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% LAV INJ AP10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5754560',
  CIP13: '3400957545604',
  ucdLib: "SODIUM 0,9% LAV INJ AP5ML",
  UCD7: '9333476',
  UCD13: '3400893334768',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% LAV INJ AP5ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5807285',
  CIP13: '3400958072857',
  ucdLib: "SODIUM 0,9% BBM INJ APP10ML",
  UCD7: '9377640',
  UCD13: '3400893776407',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% BBM INJ APP10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5807291',
  CIP13: '3400958072918',
  ucdLib: "SODIUM 0,9% BBM INJ APP20ML",
  UCD7: '9377657',
  UCD13: '3400893776575',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% BBM INJ APP20ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5669819',
  CIP13: '3400956698196',
  ucdLib: "SODIUM 10% REN INJ A.B10ML",
  UCD7: '9277269',
  UCD13: '3400892772691',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 10% REN INJ A.B10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5654752',
  CIP13: '3400956547524',
  ucdLib: "SODIUM 0,9% CPF INJ AB10ML",
  UCD7: '9281822',
  UCD13: '3400892818221',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% CPF INJ AB10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5764268',
  CIP13: '3400957642686',
  ucdLib: "SODIUM 0,9% LAV F250ML/125ML",
  UCD7: '9348041',
  UCD13: '3400893480410',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM 0,9% LAV F250ML/125ML BT 12",
  atcCode: "B05XA03"
}, {
  CIP7: '5653451',
  CIP13: '3400956534517',
  ucdLib: "SODIUM 0,9% LAV INJ AB10ML",
  UCD7: '9261512',
  UCD13: '3400892615127',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 0,9% LAV INJ AB10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5653468',
  CIP13: '3400956534685',
  ucdLib: "SODIUM 0,9% LAV INJ AB20ML",
  UCD7: '9261535',
  UCD13: '3400892615356',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 0,9% LAV INJ AB20ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '5653480',
  CIP13: '3400956534807',
  ucdLib: "SODIUM 10% LAV INJ AB10ML",
  UCD7: '9261558',
  UCD13: '3400892615585',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 10% LAV INJ AB10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5653505',
  CIP13: '3400956535057',
  ucdLib: "SODIUM 20% LAV INJ AB10ML",
  UCD7: '9261570',
  UCD13: '3400892615707',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM 20% LAV INJ AB10ML BT 100",
  atcCode: "B05XA03"
}, {
  CIP7: '5653511',
  CIP13: '3400956535118',
  ucdLib: "SODIUM 20% LAV INJ AB20ML",
  UCD7: '9261587',
  UCD13: '3400892615875',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM 20% LAV INJ AB20ML BT 50",
  atcCode: "B05XA03"
}, {
  CIP7: '5535065',
  CIP13: '3400955350651',
  ucdLib: "SODIUM BIC 1,4% LAV FV250ML",
  UCD7: '9108851',
  UCD13: '3400891088519',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM BIC 1,4% LAV FV250ML BT 12",
  atcCode: "B05XA02"
}, {
  CIP7: '5535071',
  CIP13: '3400955350712',
  ucdLib: "SODIUM BIC 1,4% LAV FV500ML",
  UCD7: '9016250',
  UCD13: '3400890162500',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM BIC 1,4% LAV FV500ML BT 12",
  atcCode: "B05XA02"
}, {
  CIP7: '3057503',
  CIP13: '3400930575031',
  ucdLib: "SODIUM BIC 1,4% LAV FV250ML",
  UCD7: '9108851',
  UCD13: '3400891088519',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% LAV FV250ML BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '3057526',
  CIP13: '3400930575260',
  ucdLib: "SODIUM BIC 1,4% LAV FV500ML",
  UCD7: '9016250',
  UCD13: '3400890162500',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% LAV FV500ML BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '3521343',
  CIP13: '3400935213433',
  ucdLib: "SODIUM BIC 1,4% BAX P.2L+V1",
  UCD7: '9185171',
  UCD13: '3400891851717',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% BAX P.2L+V1 BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '3521366',
  CIP13: '3400935213662',
  ucdLib: "SODIUM BIC 1,4% BAX P.3L+V2",
  UCD7: '9162342',
  UCD13: '3400891623420',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% BAX P.3L+V2 BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '3126144',
  CIP13: '3400931261445',
  ucdLib: "SODIUM BIC 1,4% BSD FV250ML",
  UCD7: '9016310',
  UCD13: '3400890163101',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% BSD FV250ML BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '3126150',
  CIP13: '3400931261506',
  ucdLib: "SODIUM BIC 1,4% BSD FV500ML",
  UCD7: '9108868',
  UCD13: '3400891088687',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% BSD FV500ML BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '3676399',
  CIP13: '3400936763999',
  ucdLib: "SODIUM BIC 1,4% BBM FV250ML",
  UCD7: '9350173',
  UCD13: '3400893501733',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 1,4% BBM FV250ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '3676407',
  CIP13: '3400936764071',
  ucdLib: "SODIUM BIC 1,4% BBM FV500ML",
  UCD7: '9350196',
  UCD13: '3400893501962',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 1,4% BBM FV500ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '3562922',
  CIP13: '3400935629227',
  ucdLib: "SODIUM BIC 1,4% BAX 500ML+V1",
  UCD7: '9232373',
  UCD13: '3400892323732',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% BAX 500ML+V1 BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '3511882',
  CIP13: '3400935118820',
  ucdLib: "SODIUM BIC 4,2% CPF A.10ML",
  UCD7: '9216434',
  UCD13: '3400892164342',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 4,2% CPF A.10ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '3664491',
  CIP13: '3400936644915',
  ucdLib: "SODIUM BIC 1,4% CPF AB10ML",
  UCD7: '9281816',
  UCD13: '3400892818160',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 1,4% CPF AB10ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '3637956',
  CIP13: '3400936379565',
  ucdLib: "SODIUM BIC 1,4% LAV AB10ML",
  UCD7: '9275477',
  UCD13: '3400892754772',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM BIC 1,4% LAV AB10ML BT 100",
  atcCode: "B05XA02"
}, {
  CIP7: '3667590',
  CIP13: '3400936675902',
  ucdLib: "SODIUM BIC 1,4% LAV AB10ML",
  UCD7: '9275477',
  UCD13: '3400892754772',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 1,4% LAV AB10ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '5616740',
  CIP13: '3400956167401',
  ucdLib: "SODIUM BIC 4,2% CPF A.10ML",
  UCD7: '9216434',
  UCD13: '3400892164342',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM BIC 4,2% CPF A.10ML BT 100",
  atcCode: "B05XA02"
}, {
  CIP7: '3507343',
  CIP13: '3400935073433',
  ucdLib: "SODIUM BIC 1,4% CPF FV250ML",
  UCD7: '9220217',
  UCD13: '3400892202174',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% CPF FV250ML BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '3507372',
  CIP13: '3400935073723',
  ucdLib: "SODIUM BIC 1,4% CPF FV500ML",
  UCD7: '9225628',
  UCD13: '3400892256283',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM BIC 1,4% CPF FV500ML BT 1",
  atcCode: "B05XA02"
}, {
  CIP7: '5706785',
  CIP13: '3400957067854',
  ucdLib: "SODIUM BIC 1,4% VIAFLO 500ML",
  UCD7: '9300867',
  UCD13: '3400893008676',
  ucdQtyMultiplicator: 20,
  cipLib: "SODIUM BIC 1,4% VIAFLO 500ML BT 20",
  atcCode: "B05XA02"
}, {
  CIP7: '5753632',
  CIP13: '3400957536329',
  ucdLib: "SODIUM BIC 4,2% BBM FV250ML",
  UCD7: '9107946',
  UCD13: '3400891079463',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 4,2% BBM FV250ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '5753649',
  CIP13: '3400957536497',
  ucdLib: "SODIUM BIC 4,2% BBM FV500ML",
  UCD7: '9192030',
  UCD13: '3400891920307',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 4,2% BBM FV500ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '5680614',
  CIP13: '3400956806140',
  ucdLib: "SODIUM BIC 1,4% REN A.B10ML",
  UCD7: '9280892',
  UCD13: '3400892808925',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM BIC 1,4% REN A.B10ML BT 100",
  atcCode: "B05XA02"
}, {
  CIP7: '5680666',
  CIP13: '3400956806669',
  ucdLib: "SODIUM BIC 1,4% REN A.B20ML",
  UCD7: '9280900',
  UCD13: '3400892809007',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM BIC 1,4% REN A.B20ML BT 50",
  atcCode: "B05XA02"
}, {
  CIP7: '5680821',
  CIP13: '3400956808212',
  ucdLib: "SODIUM BIC 4,2% REN A.B10ML",
  UCD7: '9280917',
  UCD13: '3400892809175',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM BIC 4,2% REN A.B10ML BT 100",
  atcCode: "B05XA02"
}, {
  CIP7: '5680838',
  CIP13: '3400956808380',
  ucdLib: "SODIUM BIC 4,2% REN A.B20ML",
  UCD7: '9280923',
  UCD13: '3400892809236',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM BIC 4,2% REN A.B20ML BT 50",
  atcCode: "B05XA02"
}, {
  CIP7: '5680689',
  CIP13: '3400956806898',
  ucdLib: "SODIUM BIC 8,4% REN A.B10ML",
  UCD7: '9280969',
  UCD13: '3400892809694',
  ucdQtyMultiplicator: 100,
  cipLib: "SODIUM BIC 8,4% REN A.B10ML BT 100",
  atcCode: "B05XA02"
}, {
  CIP7: '5680732',
  CIP13: '3400956807321',
  ucdLib: "SODIUM BIC 8,4% REN A.B20ML",
  UCD7: '9280975',
  UCD13: '3400892809755',
  ucdQtyMultiplicator: 50,
  cipLib: "SODIUM BIC 8,4% REN A.B20ML BT 50",
  atcCode: "B05XA02"
}, {
  CIP7: '5658589',
  CIP13: '3400956585892',
  ucdLib: "SODIUM BIC 8,4% BBM FV250ML",
  UCD7: '9294256',
  UCD13: '3400892942568',
  ucdQtyMultiplicator: 10,
  cipLib: "SODIUM BIC 8,4% BBM FV250ML BT 10",
  atcCode: "B05XA02"
}, {
  CIP7: '3681325',
  CIP13: '3400936813250',
  ucdLib: "POTASSIUM 10% PROAMP A.20ML",
  UCD7: '9269169',
  UCD13: '3400892691695',
  ucdQtyMultiplicator: 20,
  cipLib: "POTASSIUM 10% PROAMP A.20ML BT 20",
  atcCode: "B05XA01"
}, {
  CIP7: '3653317',
  CIP13: '3400936533172',
  ucdLib: "POTASSIUM 10% CPF AB10ML",
  UCD7: '9283471',
  UCD13: '3400892834719',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM 10% CPF AB10ML BT 10",
  atcCode: "B05XA01"
}, {
  CIP7: '5602413',
  CIP13: '3400956024131',
  ucdLib: "POTASSIUM 10% BBM AP10ML",
  UCD7: '9189341',
  UCD13: '3400891893410',
  ucdQtyMultiplicator: 20,
  cipLib: "POTASSIUM 10% BBM AP10ML BT 20",
  atcCode: "B05XA01"
}, {
  CIP7: '5602436',
  CIP13: '3400956024360',
  ucdLib: "POTASSIUM 10% BBM AP20ML",
  UCD7: '9189358',
  UCD13: '3400891893588',
  ucdQtyMultiplicator: 20,
  cipLib: "POTASSIUM 10% BBM AP20ML BT 20",
  atcCode: "B05XA01"
}, {
  CIP7: '3706539',
  CIP13: '3400937065399',
  ucdLib: "POTASSIUM 20% PROAMP A.5ML",
  UCD7: '9280716',
  UCD13: '3400892807164',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 20% PROAMP A.5ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '3695907',
  CIP13: '3400936959071',
  ucdLib: "POTASSIUM 10% FRF AP10ML",
  UCD7: '9281957',
  UCD13: '3400892819570',
  ucdQtyMultiplicator: 20,
  cipLib: "POTASSIUM 10% FRF AP10ML BT 20",
  atcCode: "B05XA01"
}, {
  CIP7: '3695936',
  CIP13: '3400936959361',
  ucdLib: "POTASSIUM 10% FRF AP20ML",
  UCD7: '9281963',
  UCD13: '3400892819631',
  ucdQtyMultiplicator: 20,
  cipLib: "POTASSIUM 10% FRF AP20ML BT 20",
  atcCode: "B05XA01"
}, {
  CIP7: '3630032',
  CIP13: '3400936300323',
  ucdLib: "POTASSIUM 10% LAV AB10ML",
  UCD7: '9261475',
  UCD13: '3400892614755',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM 10% LAV AB10ML BT 10",
  atcCode: "B05XA01"
}, {
  CIP7: '3630049',
  CIP13: '3400936300491',
  ucdLib: "POTASSIUM 10% LAV AB20ML",
  UCD7: '9261481',
  UCD13: '3400892614816',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM 10% LAV AB20ML BT 10",
  atcCode: "B05XA01"
}, {
  CIP7: '3630055',
  CIP13: '3400936300552',
  ucdLib: "POTASSIUM 15% LAV AB10ML",
  UCD7: '9275514',
  UCD13: '3400892755144',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM 15% LAV AB10ML BT 10",
  atcCode: "B05XA01"
}, {
  CIP7: '3634024',
  CIP13: '3400936340244',
  ucdLib: "POTASSIUM 20% LAV AB10ML",
  UCD7: '9261498',
  UCD13: '3400892614984',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM 20% LAV AB10ML BT 10",
  atcCode: "B05XA01"
}, {
  CIP7: '3634030',
  CIP13: '3400936340305',
  ucdLib: "POTASSIUM 20% LAV AB20ML",
  UCD7: '9261506',
  UCD13: '3400892615066',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM 20% LAV AB20ML BT 10",
  atcCode: "B05XA01"
}, {
  CIP7: '3630003',
  CIP13: '3400936300033',
  ucdLib: "POTASSIUM 7,46% LAV AB10ML",
  UCD7: '9275454',
  UCD13: '3400892754543',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM 7,46% LAV AB10ML BT 10",
  atcCode: "B05XA01"
}, {
  CIP7: '3953373',
  CIP13: '3400939533735',
  ucdLib: "POTASSIUM 10% LAV AP10ML",
  UCD7: '9333163',
  UCD13: '3400893331637',
  ucdQtyMultiplicator: 10,
  cipLib: "POTASSIUM 10% LAV AP10ML BT 10",
  atcCode: "B05XA01"
}, {
  CIP7: '5754548',
  CIP13: '3400957545482',
  ucdLib: "POTASSIUM 10% LAV AP10ML",
  UCD7: '9333163',
  UCD13: '3400893331637',
  ucdQtyMultiplicator: 100,
  cipLib: "POTASSIUM 10% LAV AP10ML BT 100",
  atcCode: "B05XA01"
}, {
  CIP7: '5754554',
  CIP13: '3400957545543',
  ucdLib: "POTASSIUM 10% LAV AP20ML",
  UCD7: '9333186',
  UCD13: '3400893331866',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 10% LAV AP20ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '5665419',
  CIP13: '3400956654192',
  ucdLib: "POTASSIUM 10% PROAMP A.10ML",
  UCD7: '9269152',
  UCD13: '3400892691527',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 10% PROAMP A.10ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '5680761',
  CIP13: '3400956807611',
  ucdLib: "POTASSIUM 10% REN AB10ML",
  UCD7: '9280946',
  UCD13: '3400892809465',
  ucdQtyMultiplicator: 100,
  cipLib: "POTASSIUM 10% REN AB10ML BT 100",
  atcCode: "B05XA01"
}, {
  CIP7: '5665394',
  CIP13: '3400956653942',
  ucdLib: "POTASSIUM 15% PROAMP A.10ML",
  UCD7: '9269175',
  UCD13: '3400892691756',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 15% PROAMP A.10ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '5680790',
  CIP13: '3400956807901',
  ucdLib: "POTASSIUM 20% REN AB10ML",
  UCD7: '9280981',
  UCD13: '3400892809816',
  ucdQtyMultiplicator: 100,
  cipLib: "POTASSIUM 20% REN AB10ML BT 100",
  atcCode: "B05XA01"
}, {
  CIP7: '5680809',
  CIP13: '3400956808090',
  ucdLib: "POTASSIUM 20% REN AB20ML",
  UCD7: '9280998',
  UCD13: '3400892809984',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 20% REN AB20ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '5665454',
  CIP13: '3400956654543',
  ucdLib: "POTASSIUM 7,46% PROAMP 10ML",
  UCD7: '9269181',
  UCD13: '3400892691817',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 7,46% PROAMP 10ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '5653362',
  CIP13: '3400956533626',
  ucdLib: "POTASSIUM 10% LAV AB10ML",
  UCD7: '9261475',
  UCD13: '3400892614755',
  ucdQtyMultiplicator: 100,
  cipLib: "POTASSIUM 10% LAV AB10ML BT 100",
  atcCode: "B05XA01"
}, {
  CIP7: '5653385',
  CIP13: '3400956533855',
  ucdLib: "POTASSIUM 15% LAV AB10ML",
  UCD7: '9275514',
  UCD13: '3400892755144',
  ucdQtyMultiplicator: 100,
  cipLib: "POTASSIUM 15% LAV AB10ML BT 100",
  atcCode: "B05XA01"
}, {
  CIP7: '5653416',
  CIP13: '3400956534166',
  ucdLib: "POTASSIUM 20% LAV AB10ML",
  UCD7: '9261498',
  UCD13: '3400892614984',
  ucdQtyMultiplicator: 100,
  cipLib: "POTASSIUM 20% LAV AB10ML BT 100",
  atcCode: "B05XA01"
}, {
  CIP7: '5653422',
  CIP13: '3400956534227',
  ucdLib: "POTASSIUM 20% LAV AB20ML",
  UCD7: '9261506',
  UCD13: '3400892615066',
  ucdQtyMultiplicator: 50,
  cipLib: "POTASSIUM 20% LAV AB20ML BT 50",
  atcCode: "B05XA01"
}, {
  CIP7: '5653333',
  CIP13: '3400956533336',
  ucdLib: "POTASSIUM 7,46% LAV AB10ML",
  UCD7: '9275454',
  UCD13: '3400892754543',
  ucdQtyMultiplicator: 100,
  cipLib: "POTASSIUM 7,46% LAV AB10ML BT 100",
  atcCode: "B05XA01"
}, {
  CIP7: '3600835',
  CIP13: '3400936008359',
  ucdLib: "DPCA3 DIA.PER. SLS3000ML",
  UCD7: '9243017',
  UCD13: '3400892430171',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA3 DIA.PER. SLS3000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600806',
  CIP13: '3400936008069',
  ucdLib: "DPCA3 DIA.PER. STS2000ML",
  UCD7: '9243023',
  UCD13: '3400892430232',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA3 DIA.PER. STS2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600887',
  CIP13: '3400936008878',
  ucdLib: "DPCA4 DIA.PER. SLS3000ML",
  UCD7: '9243052',
  UCD13: '3400892430522',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA4 DIA.PER. SLS3000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600858',
  CIP13: '3400936008588',
  ucdLib: "DPCA4 DIA.PER. STS2000ML",
  UCD7: '9243069',
  UCD13: '3400892430690',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA4 DIA.PER. STS2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600640',
  CIP13: '3400936006409',
  ucdLib: "NEUTRAVERA G1,5% D/P SLS3L",
  UCD7: '9312971',
  UCD13: '3400893129715',
  ucdQtyMultiplicator: 4,
  cipLib: "NEUTRAVERA G1,5% D/P SLS3L BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600628',
  CIP13: '3400936006287',
  ucdLib: "NEUTRAVERA G1,5% D/P STS2,5L",
  UCD7: '9331112',
  UCD13: '3400893311127',
  ucdQtyMultiplicator: 4,
  cipLib: "NEUTRAVERA G1,5% D/P STS2,5L BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600611',
  CIP13: '3400936006119',
  ucdLib: "NEUTRAVERA G1,5% D/P STS2L",
  UCD7: '9312988',
  UCD13: '3400893129883',
  ucdQtyMultiplicator: 4,
  cipLib: "NEUTRAVERA G1,5% D/P STS2L BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600781',
  CIP13: '3400936007819',
  ucdLib: "NEUTRAVERA G2,3% D/P SLS3L",
  UCD7: '9312994',
  UCD13: '3400893129944',
  ucdQtyMultiplicator: 4,
  cipLib: "NEUTRAVERA G2,3% D/P SLS3L BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600752',
  CIP13: '3400936007529',
  ucdLib: "NEUTRAVERA G2,3% D/P STS2L",
  UCD7: '9313002',
  UCD13: '3400893130025',
  ucdQtyMultiplicator: 4,
  cipLib: "NEUTRAVERA G2,3% D/P STS2L BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600723',
  CIP13: '3400936007239',
  ucdLib: "NEUTRAVERA G4,25% D/P SLS3L",
  UCD7: '9313019',
  UCD13: '3400893130193',
  ucdQtyMultiplicator: 4,
  cipLib: "NEUTRAVERA G4,25% D/P SLS3L BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3600692',
  CIP13: '3400936006928',
  ucdLib: "NEUTRAVERA G4,25% D/P STS2L",
  UCD7: '9313025',
  UCD13: '3400893130254',
  ucdQtyMultiplicator: 4,
  cipLib: "NEUTRAVERA G4,25% D/P STS2L BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3526576',
  CIP13: '3400935265760',
  ucdLib: "PHYSIONEAL40 1,36% PD1,5L +V",
  UCD7: '9227142',
  UCD13: '3400892271422',
  ucdQtyMultiplicator: 6,
  cipLib: "PHYSIONEAL40 1,36% PD1,5L +V BT 6",
  atcCode: "B05DB"
}, {
  CIP7: '3526665',
  CIP13: '3400935266651',
  ucdLib: "PHYSIONEAL40 1,36% PD2,5L +V",
  UCD7: '9227165',
  UCD13: '3400892271651',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL40 1,36% PD2,5L +V BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3526613',
  CIP13: '3400935266132',
  ucdLib: "PHYSIONEAL40 1,36% PD2L +V.",
  UCD7: '9227159',
  UCD13: '3400892271590',
  ucdQtyMultiplicator: 5,
  cipLib: "PHYSIONEAL40 1,36% PD2L +V. BT 5",
  atcCode: "B05DB"
}, {
  CIP7: '3526642',
  CIP13: '3400935266422',
  ucdLib: "PHYSIONEAL40 1,36% PS2,5L +V",
  UCD7: '9227171',
  UCD13: '3400892271712',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL40 1,36% PS2,5L +V BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3527558',
  CIP13: '3400935275585',
  ucdLib: "PHYSIONEAL40 2,27% PD1,5L +V",
  UCD7: '9379662',
  UCD13: '3400893796627',
  ucdQtyMultiplicator: 6,
  cipLib: "PHYSIONEAL40 2,27% PD1,5L +V BT 6",
  atcCode: "B05DB"
}, {
  CIP7: '3527630',
  CIP13: '3400935276308',
  ucdLib: "PHYSIONEAL40 2,27% PD2,5L +V",
  UCD7: '9379679',
  UCD13: '3400893796795',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL40 2,27% PD2,5L +V BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3527593',
  CIP13: '3400935275936',
  ucdLib: "PHYSIONEAL40 2,27% PD2L +V.",
  UCD7: '9227194',
  UCD13: '3400892271941',
  ucdQtyMultiplicator: 5,
  cipLib: "PHYSIONEAL40 2,27% PD2L +V. BT 5",
  atcCode: "B05DB"
}, {
  CIP7: '3527618',
  CIP13: '3400935276186',
  ucdLib: "PHYSIONEAL40 2,27% PS2,5L +V",
  UCD7: '9227202',
  UCD13: '3400892272023',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL40 2,27% PS2,5L +V BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3527647',
  CIP13: '3400935276476',
  ucdLib: "PHYSIONEAL40 3,86% PD1,5L +V",
  UCD7: '9227225',
  UCD13: '3400892272252',
  ucdQtyMultiplicator: 6,
  cipLib: "PHYSIONEAL40 3,86% PD1,5L +V BT 6",
  atcCode: "B05DB"
}, {
  CIP7: '3527742',
  CIP13: '3400935277428',
  ucdLib: "PHYSIONEAL40 3,86% PD2,5L +V",
  UCD7: '9227248',
  UCD13: '3400892272481',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL40 3,86% PD2,5L +V BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3527699',
  CIP13: '3400935276995',
  ucdLib: "PHYSIONEAL40 3,86% PD2L +V.",
  UCD7: '9227231',
  UCD13: '3400892272313',
  ucdQtyMultiplicator: 5,
  cipLib: "PHYSIONEAL40 3,86% PD2L +V. BT 5",
  atcCode: "B05DB"
}, {
  CIP7: '3527713',
  CIP13: '3400935277138',
  ucdLib: "PHYSIONEAL40 3,86% PS2,5L +V",
  UCD7: '9227254',
  UCD13: '3400892272542',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL40 3,86% PS2,5L +V BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3857273',
  CIP13: '3400938572735',
  ucdLib: "DPCA2 DIA.PER. SLS5000ML",
  UCD7: '9331075',
  UCD13: '3400893310755',
  ucdQtyMultiplicator: 2,
  cipLib: "DPCA2 DIA.PER. SLS5000ML BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3857422',
  CIP13: '3400938574227',
  ucdLib: "DPCA3 DIA.PER. SLS5000ML",
  UCD7: '9331081',
  UCD13: '3400893310816',
  ucdQtyMultiplicator: 2,
  cipLib: "DPCA3 DIA.PER. SLS5000ML BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3857468',
  CIP13: '3400938574685',
  ucdLib: "DPCA4 DIA.PER. SLS5000ML",
  UCD7: '9331098',
  UCD13: '3400893310984',
  ucdQtyMultiplicator: 2,
  cipLib: "DPCA4 DIA.PER. SLS5000ML BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3857600',
  CIP13: '3400938576009',
  ucdLib: "NEUTRAVERA G1,5% D/P SLS5L",
  UCD7: '9331106',
  UCD13: '3400893311066',
  ucdQtyMultiplicator: 2,
  cipLib: "NEUTRAVERA G1,5% D/P SLS5L BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3857698',
  CIP13: '3400938576986',
  ucdLib: "NEUTRAVERA G2,3% D/P SLS5L",
  UCD7: '9331129',
  UCD13: '3400893311295',
  ucdQtyMultiplicator: 2,
  cipLib: "NEUTRAVERA G2,3% D/P SLS5L BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3857652',
  CIP13: '3400938576528',
  ucdLib: "NEUTRAVERA G4,25% D/P SLS5L",
  UCD7: '9331135',
  UCD13: '3400893311356',
  ucdQtyMultiplicator: 2,
  cipLib: "NEUTRAVERA G4,25% D/P SLS5L BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3629721',
  CIP13: '3400936297210',
  ucdLib: "BICAVERA G1,5% D/P SLS3000ML",
  UCD7: '9259188',
  UCD13: '3400892591889',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G1,5% D/P SLS3000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3629767',
  CIP13: '3400936297678',
  ucdLib: "BICAVERA G2,3% D/P SLS3000ML",
  UCD7: '9259194',
  UCD13: '3400892591940',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G2,3% D/P SLS3000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3629810',
  CIP13: '3400936298101',
  ucdLib: "BICAVERA G4,25% D/P SLS3000ML",
  UCD7: '9259202',
  UCD13: '3400892592022',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G4,25% D/P SLS3000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3537580',
  CIP13: '3400935375803',
  ucdLib: "DPCA17 DIA.PER. P.2000ML",
  UCD7: '9224422',
  UCD13: '3400892244228',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA17 DIA.PER. P.2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3537597',
  CIP13: '3400935375971',
  ucdLib: "DPCA18 DIA.PER. P.2000ML",
  UCD7: '9224439',
  UCD13: '3400892244396',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA18 DIA.PER. P.2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3537605',
  CIP13: '3400935376053',
  ucdLib: "DPCA19 DIA.PER. P.2000ML",
  UCD7: '9224445',
  UCD13: '3400892244457',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA19 DIA.PER. P.2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3599813',
  CIP13: '3400935998132',
  ucdLib: "DPCA2 DIA.PER. SLS3000ML",
  UCD7: '9242957',
  UCD13: '3400892429571',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA2 DIA.PER. SLS3000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3599782',
  CIP13: '3400935997821',
  ucdLib: "DPCA2 DIA.PER. STS2000ML",
  UCD7: '9242963',
  UCD13: '3400892429632',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA2 DIA.PER. STS2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3599799',
  CIP13: '3400935997999',
  ucdLib: "DPCA2 DIA.PER. STS2500ML",
  UCD7: '9242986',
  UCD13: '3400892429861',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA2 DIA.PER. STS2500ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3659892',
  CIP13: '3400936598928',
  ucdLib: "PHYSION.35 1,36% CFX PS5L +R",
  UCD7: '9319281',
  UCD13: '3400893192818',
  ucdQtyMultiplicator: 2,
  cipLib: "PHYSION.35 1,36% CFX PS5L +R BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3585202',
  CIP13: '3400935852021',
  ucdLib: "BICAVERA G1,5% D/P STS2000ML",
  UCD7: '9237850',
  UCD13: '3400892378503',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G1,5% D/P STS2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3585219',
  CIP13: '3400935852199',
  ucdLib: "BICAVERA G1,5% D/P STS2500ML",
  UCD7: '9237867',
  UCD13: '3400892378671',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G1,5% D/P STS2500ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3585248',
  CIP13: '3400935852489',
  ucdLib: "BICAVERA G2,3% D/P STS2000ML",
  UCD7: '9237904',
  UCD13: '3400892379043',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G2,3% D/P STS2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3585254',
  CIP13: '3400935852540',
  ucdLib: "BICAVERA G2,3% D/P STS2500ML",
  UCD7: '9237910',
  UCD13: '3400892379104',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G2,3% D/P STS2500ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3585283',
  CIP13: '3400935852830',
  ucdLib: "BICAVERA G4,25% D/P STS2000ML",
  UCD7: '9237956',
  UCD13: '3400892379562',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G4,25% D/P STS2000ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3585308',
  CIP13: '3400935853080',
  ucdLib: "BICAVERA G4,25% D/P STS2500ML",
  UCD7: '9237962',
  UCD13: '3400892379623',
  ucdQtyMultiplicator: 4,
  cipLib: "BICAVERA G4,25% D/P STS2500ML BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3663037',
  CIP13: '3400936630376',
  ucdLib: "DIANEAL PD4 G.1,36% 3L/2,5L+LU",
  UCD7: '9379863',
  UCD13: '3400893798638',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% 3L/2,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663149',
  CIP13: '3400936631496',
  ucdLib: "DIANEAL PD4 G.1,36% PD1,5L+LU",
  UCD7: '9379610',
  UCD13: '3400893796108',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% PD1,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663209',
  CIP13: '3400936632097',
  ucdLib: "DIANEAL PD4 G.1,36% PD2,5L+LU",
  UCD7: '9287859',
  UCD13: '3400892878591',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% PD2,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663178',
  CIP13: '3400936631786',
  ucdLib: "DIANEAL PD4 G.1,36% PD2L+LU",
  UCD7: '9287842',
  UCD13: '3400892878423',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% PD2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663238',
  CIP13: '3400936632387',
  ucdLib: "DIANEAL PD4 G.1,36% PD3L+LU",
  UCD7: '9288178',
  UCD13: '3400892881782',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% PD3L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663008',
  CIP13: '3400936630086',
  ucdLib: "DIANEAL PD4 G.1,36% PS2L+LU",
  UCD7: '9287902',
  UCD13: '3400892879024',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% PS2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3662983',
  CIP13: '3400936629837',
  ucdLib: "DIANEAL PD4 G.1,36% PS2L+P.",
  UCD7: '9287931',
  UCD13: '3400892879314',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% PS2L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663072',
  CIP13: '3400936630727',
  ucdLib: "DIANEAL PD4 G.1,36% PS5L+LU",
  UCD7: '9287919',
  UCD13: '3400892879192',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.1,36% PS5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663333',
  CIP13: '3400936633339',
  ucdLib: "DIANEAL PD4 G.2,27% 3L/2,5L+LU",
  UCD7: '9379886',
  UCD13: '3400893798867',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% 3L/2,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663474',
  CIP13: '3400936634749',
  ucdLib: "DIANEAL PD4 G.2,27% PD2L+LU",
  UCD7: '9287865',
  UCD13: '3400892878652',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% PD2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663468',
  CIP13: '3400936634688',
  ucdLib: "DIANEAL PD4 G.2,27% PD2L+P.",
  UCD7: '9287977',
  UCD13: '3400892879772',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% PD2L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663534',
  CIP13: '3400936635340',
  ucdLib: "DIANEAL PD4 G.2,27% PD3L+LU",
  UCD7: '9300933',
  UCD13: '3400893009338',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% PD3L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663296',
  CIP13: '3400936632967',
  ucdLib: "DIANEAL PD4 G.2,27% PS2L+P.",
  UCD7: '9366406',
  UCD13: '3400893664063',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% PS2L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663379',
  CIP13: '3400936633797',
  ucdLib: "DIANEAL PD4 G.2,27% PS5L+LU",
  UCD7: '9287960',
  UCD13: '3400892879604',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.2,27% PS5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663646',
  CIP13: '3400936636460',
  ucdLib: "DIANEAL PD4 G.3,86% 3L/2,5L+LU",
  UCD7: '9379656',
  UCD13: '3400893796566',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.3,86% 3L/2,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663793',
  CIP13: '3400936637931',
  ucdLib: "DIANEAL PD4 G.3,86% PD2,5L+LU",
  UCD7: '9287894',
  UCD13: '3400892878942',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.3,86% PD2,5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663764',
  CIP13: '3400936637641',
  ucdLib: "DIANEAL PD4 G.3,86% PD2L+LU",
  UCD7: '9287888',
  UCD13: '3400892878881',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.3,86% PD2L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663592',
  CIP13: '3400936635920',
  ucdLib: "DIANEAL PD4 G.3,86% PS2L+P.",
  UCD7: '9288037',
  UCD13: '3400892880372',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.3,86% PS2L+P. BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3663675',
  CIP13: '3400936636750',
  ucdLib: "DIANEAL PD4 G.3,86% PS5L+LU",
  UCD7: '9288014',
  UCD13: '3400892880143',
  ucdQtyMultiplicator: 1,
  cipLib: "DIANEAL PD4 G.3,86% PS5L+LU BT 1",
  atcCode: "B05DB"
}, {
  CIP7: '3660174',
  CIP13: '3400936601741',
  ucdLib: "PHYSION.35 2,27% CFX PS5L +R",
  UCD7: '9319298',
  UCD13: '3400893192986',
  ucdQtyMultiplicator: 2,
  cipLib: "PHYSION.35 2,27% CFX PS5L +R BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3660441',
  CIP13: '3400936604414',
  ucdLib: "PHYSION.35 3,86% CFX PS5L +R",
  UCD7: '9319306',
  UCD13: '3400893193068',
  ucdQtyMultiplicator: 2,
  cipLib: "PHYSION.35 3,86% CFX PS5L +R BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3661274',
  CIP13: '3400936612747',
  ucdLib: "PHYSION.40 1,36% CFX PS5L +R",
  UCD7: '9319312',
  UCD13: '3400893193129',
  ucdQtyMultiplicator: 2,
  cipLib: "PHYSION.40 1,36% CFX PS5L +R BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3660719',
  CIP13: '3400936607194',
  ucdLib: "PHYSION.40 2,27% CFX PS5L +R",
  UCD7: '9319329',
  UCD13: '3400893193297',
  ucdQtyMultiplicator: 2,
  cipLib: "PHYSION.40 2,27% CFX PS5L +R BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3660990',
  CIP13: '3400936609907',
  ucdLib: "PHYSION.40 3,86% CFX PS5L +R",
  UCD7: '9319335',
  UCD13: '3400893193358',
  ucdQtyMultiplicator: 2,
  cipLib: "PHYSION.40 3,86% CFX PS5L +R BT 2",
  atcCode: "B05DB"
}, {
  CIP7: '3630196',
  CIP13: '3400936301962',
  ucdLib: "PHYSIONEAL35 1,36% PD2L +R.",
  UCD7: '9260079',
  UCD13: '3400892600796',
  ucdQtyMultiplicator: 5,
  cipLib: "PHYSIONEAL35 1,36% PD2L +R. BT 5",
  atcCode: "B05DB"
}, {
  CIP7: '3630227',
  CIP13: '3400936302273',
  ucdLib: "PHYSIONEAL35 1,36% PS2,5L +R",
  UCD7: '9260085',
  UCD13: '3400892600857',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL35 1,36% PS2,5L +R BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3630457',
  CIP13: '3400936304574',
  ucdLib: "PHYSIONEAL35 2,27% PD2L +R.",
  UCD7: '9260091',
  UCD13: '3400892600918',
  ucdQtyMultiplicator: 5,
  cipLib: "PHYSIONEAL35 2,27% PD2L +R. BT 5",
  atcCode: "B05DB"
}, {
  CIP7: '3630492',
  CIP13: '3400936304925',
  ucdLib: "PHYSIONEAL35 2,27% PS2,5L +R",
  UCD7: '9260116',
  UCD13: '3400892601168',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL35 2,27% PS2,5L +R BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3630718',
  CIP13: '3400936307186',
  ucdLib: "PHYSIONEAL35 3,86% PD2L +R.",
  UCD7: '9260122',
  UCD13: '3400892601229',
  ucdQtyMultiplicator: 5,
  cipLib: "PHYSIONEAL35 3,86% PD2L +R. BT 5",
  atcCode: "B05DB"
}, {
  CIP7: '3630747',
  CIP13: '3400936307476',
  ucdLib: "PHYSIONEAL35 3,86% PS2,5L +R",
  UCD7: '9260139',
  UCD13: '3400892601397',
  ucdQtyMultiplicator: 4,
  cipLib: "PHYSIONEAL35 3,86% PS2,5L +R BT 4",
  atcCode: "B05DB"
}, {
  CIP7: '3520527',
  CIP13: '3400935205278',
  ucdLib: "DPCA2 DIA.PER. P.SLEEP5L",
  UCD7: '9213849',
  UCD13: '3400892138497',
  ucdQtyMultiplicator: 2,
  cipLib: "DPCA2 DIA.PER. P.SLEEP5L BT 2",
  atcCode: "B05DA"
}, {
  CIP7: '3520697',
  CIP13: '3400935206978',
  ucdLib: "DPCA3 DIA.PER. P.SLEEP5L",
  UCD7: '9213855',
  UCD13: '3400892138558',
  ucdQtyMultiplicator: 2,
  cipLib: "DPCA3 DIA.PER. P.SLEEP5L BT 2",
  atcCode: "B05DA"
}, {
  CIP7: '3520817',
  CIP13: '3400935208170',
  ucdLib: "DPCA4 DIA.PER. P.SLEEP5L",
  UCD7: '9213861',
  UCD13: '3400892138619',
  ucdQtyMultiplicator: 2,
  cipLib: "DPCA4 DIA.PER. P.SLEEP5L BT 2",
  atcCode: "B05DA"
}, {
  CIP7: '3677128',
  CIP13: '3400936771284',
  ucdLib: "EXTRANEAL D/P PD1,5L 6 +LU",
  UCD7: '9331649',
  UCD13: '3400893316498',
  ucdQtyMultiplicator: 6,
  cipLib: "EXTRANEAL D/P PD1,5L 6 +LU BT 6",
  atcCode: "B05DA"
}, {
  CIP7: '3677217',
  CIP13: '3400936772175',
  ucdLib: "EXTRANEAL D/P PD2,5L +LU",
  UCD7: '9288066',
  UCD13: '3400892880662',
  ucdQtyMultiplicator: 4,
  cipLib: "EXTRANEAL D/P PD2,5L +LU BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3677163',
  CIP13: '3400936771635',
  ucdLib: "EXTRANEAL D/P PD2L +LU",
  UCD7: '9288043',
  UCD13: '3400892880433',
  ucdQtyMultiplicator: 5,
  cipLib: "EXTRANEAL D/P PD2L +LU BT 5",
  atcCode: "B05DA"
}, {
  CIP7: '3677200',
  CIP13: '3400936772007',
  ucdLib: "EXTRANEAL D/P PS2,5L +LU",
  UCD7: '9288089',
  UCD13: '3400892880891',
  ucdQtyMultiplicator: 4,
  cipLib: "EXTRANEAL D/P PS2,5L +LU BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3677157',
  CIP13: '3400936771574',
  ucdLib: "EXTRANEAL D/P PS2L +LU",
  UCD7: '9288072',
  UCD13: '3400892880723',
  ucdQtyMultiplicator: 5,
  cipLib: "EXTRANEAL D/P PS2L +LU BT 5",
  atcCode: "B05DA"
}, {
  CIP7: '3677140',
  CIP13: '3400936771406',
  ucdLib: "EXTRANEAL D/P PS2L +P.",
  UCD7: '9288095',
  UCD13: '3400892880952',
  ucdQtyMultiplicator: 5,
  cipLib: "EXTRANEAL D/P PS2L +P. BT 5",
  atcCode: "B05DA"
}, {
  CIP7: '3539662',
  CIP13: '3400935396624',
  ucdLib: "SELUTRIO 10 D/P PD2,5L+C",
  UCD7: '9221783',
  UCD13: '3400892217833',
  ucdQtyMultiplicator: 4,
  cipLib: "SELUTRIO 10 D/P PD2,5L+C BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3539656',
  CIP13: '3400935396563',
  ucdLib: "SELUTRIO 10 D/P PD2L+C",
  UCD7: '9221872',
  UCD13: '3400892218724',
  ucdQtyMultiplicator: 4,
  cipLib: "SELUTRIO 10 D/P PD2L+C BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3539366',
  CIP13: '3400935393661',
  ucdLib: "SELUTRIO 10 D/P PS2,5L+C",
  UCD7: '9228489',
  UCD13: '3400892284897',
  ucdQtyMultiplicator: 4,
  cipLib: "SELUTRIO 10 D/P PS2,5L+C BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3539389',
  CIP13: '3400935393890',
  ucdLib: "SELUTRIO 10 D/P PS5L+C",
  UCD7: '9228495',
  UCD13: '3400892284958',
  ucdQtyMultiplicator: 2,
  cipLib: "SELUTRIO 10 D/P PS5L+C BT 2",
  atcCode: "B05DA"
}, {
  CIP7: '3540257',
  CIP13: '3400935402578',
  ucdLib: "SELUTRIO 40 D/P PD2,5L+C",
  UCD7: '9221820',
  UCD13: '3400892218205',
  ucdQtyMultiplicator: 4,
  cipLib: "SELUTRIO 40 D/P PD2,5L+C BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3540240',
  CIP13: '3400935402400',
  ucdLib: "SELUTRIO 40 D/P PD2L+C",
  UCD7: '9221814',
  UCD13: '3400892218144',
  ucdQtyMultiplicator: 4,
  cipLib: "SELUTRIO 40 D/P PD2L+C BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3540180',
  CIP13: '3400935401809',
  ucdLib: "SELUTRIO 40 D/P PS2,5L+C",
  UCD7: '9228526',
  UCD13: '3400892285269',
  ucdQtyMultiplicator: 4,
  cipLib: "SELUTRIO 40 D/P PS2,5L+C BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3540205',
  CIP13: '3400935402059',
  ucdLib: "SELUTRIO 40 D/P PS5L+C",
  UCD7: '9228532',
  UCD13: '3400892285320',
  ucdQtyMultiplicator: 2,
  cipLib: "SELUTRIO 40 D/P PS5L+C BT 2",
  atcCode: "B05DA"
}, {
  CIP7: '3664166',
  CIP13: '3400936641662',
  ucdLib: "NUTRINEAL PD4 D/P PD2L+LU",
  UCD7: '9288126',
  UCD13: '3400892881263',
  ucdQtyMultiplicator: 1,
  cipLib: "NUTRINEAL PD4 D/P PD2L+LU BT 1",
  atcCode: "B05DA"
}, {
  CIP7: '3663994',
  CIP13: '3400936639942',
  ucdLib: "NUTRINEAL PD4 D/P PS2,5L+LU",
  UCD7: '9288155',
  UCD13: '3400892881553',
  ucdQtyMultiplicator: 1,
  cipLib: "NUTRINEAL PD4 D/P PS2,5L+LU BT 1",
  atcCode: "B05DA"
}, {
  CIP7: '3663959',
  CIP13: '3400936639591',
  ucdLib: "NUTRINEAL PD4 D/P PS2L+P.",
  UCD7: '9288161',
  UCD13: '3400892881614',
  ucdQtyMultiplicator: 1,
  cipLib: "NUTRINEAL PD4 D/P PS2L+P. BT 1",
  atcCode: "B05DA"
}, {
  CIP7: '3473905',
  CIP13: '3400934739057',
  ucdLib: "DPCA2 DIA.PER. P.STAY.2,5L",
  UCD7: '9203673',
  UCD13: '3400892036731',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA2 DIA.PER. P.STAY.2,5L BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3473897',
  CIP13: '3400934738975',
  ucdLib: "DPCA2 DIA.PER. P.STAY.2L",
  UCD7: '9203667',
  UCD13: '3400892036670',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA2 DIA.PER. P.STAY.2L BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3473928',
  CIP13: '3400934739286',
  ucdLib: "DPCA3 DIA.PER. P.STAY.2L",
  UCD7: '9203704',
  UCD13: '3400892037042',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA3 DIA.PER. P.STAY.2L BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3473963',
  CIP13: '3400934739637',
  ucdLib: "DPCA4 DIA.PER. P.STAY.2,5L 4",
  UCD7: '9203756',
  UCD13: '3400892037561',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA4 DIA.PER. P.STAY.2,5L 4 BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3473957',
  CIP13: '3400934739576',
  ucdLib: "DPCA4 DIA.PER. P.STAY.2L 4",
  UCD7: '9203733',
  UCD13: '3400892037332',
  ucdQtyMultiplicator: 4,
  cipLib: "DPCA4 DIA.PER. P.STAY.2L 4 BT 4",
  atcCode: "B05DA"
}, {
  CIP7: '3676376',
  CIP13: '3400936763760',
  ucdLib: "MANNITOL 20% BBM INJ FV250ML",
  UCD7: '9132772',
  UCD13: '3400891327724',
  ucdQtyMultiplicator: 10,
  cipLib: "MANNITOL 20% BBM INJ FV250ML BT 10",
  atcCode: "B05BC01"
}, {
  CIP7: '3676382',
  CIP13: '3400936763821',
  ucdLib: "MANNITOL 20% BBM INJ FV500ML",
  UCD7: '9132789',
  UCD13: '3400891327892',
  ucdQtyMultiplicator: 10,
  cipLib: "MANNITOL 20% BBM INJ FV500ML BT 10",
  atcCode: "B05BC01"
}, {
  CIP7: '3551605',
  CIP13: '3400935516053',
  ucdLib: "MANNITOL 10% MAC INJ POC250ML",
  UCD7: '9169404',
  UCD13: '3400891694048',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 10% MAC INJ POC250ML BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3551611',
  CIP13: '3400935516114',
  ucdLib: "MANNITOL 10% MAC INJ POC500ML",
  UCD7: '9169410',
  UCD13: '3400891694109',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 10% MAC INJ POC500ML BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3551634',
  CIP13: '3400935516343',
  ucdLib: "MANNITOL 20% MAC INJ POC250ML",
  UCD7: '9169433',
  UCD13: '3400891694338',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 20% MAC INJ POC250ML BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3551640',
  CIP13: '3400935516404',
  ucdLib: "MANNITOL 20% MAC INJ POC500ML",
  UCD7: '9169456',
  UCD13: '3400891694567',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 20% MAC INJ POC500ML BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3637063',
  CIP13: '3400936370630',
  ucdLib: "MANNITOL 10% BBM INJ P.E250ML",
  UCD7: '9262500',
  UCD13: '3400892625003',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 10% BBM INJ P.E250ML BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3637086',
  CIP13: '3400936370869',
  ucdLib: "MANNITOL 10% BBM INJ P.E500ML",
  UCD7: '9262517',
  UCD13: '3400892625171',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 10% BBM INJ P.E500ML BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3816191',
  CIP13: '3400938161915',
  ucdLib: "MANNITOL 10% MAC P.FNS250ML 1",
  UCD7: '9304842',
  UCD13: '3400893048429',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 10% MAC P.FNS250ML 1 BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3816216',
  CIP13: '3400938162165',
  ucdLib: "MANNITOL 10% MAC P.FNS500ML 1",
  UCD7: '9304859',
  UCD13: '3400893048597',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 10% MAC P.FNS500ML 1 BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3816239',
  CIP13: '3400938162394',
  ucdLib: "MANNITOL 20% MAC P.FNS250ML 1",
  UCD7: '9304871',
  UCD13: '3400893048719',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 20% MAC P.FNS250ML 1 BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3816245',
  CIP13: '3400938162455',
  ucdLib: "MANNITOL 20% MAC P.FNS500ML 1",
  UCD7: '9304888',
  UCD13: '3400893048887',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 20% MAC P.FNS500ML 1 BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3448741',
  CIP13: '3400934487415',
  ucdLib: "MANNITOL 20% LAV INJ FV500ML",
  UCD7: '9203897',
  UCD13: '3400892038971',
  ucdQtyMultiplicator: 1,
  cipLib: "MANNITOL 20% LAV INJ FV500ML BT 1",
  atcCode: "B05BC01"
}, {
  CIP7: '3837796',
  CIP13: '3400938377965',
  ucdLib: "BIONOLYTE G10 INJ FPE1000ML",
  UCD7: '9309325',
  UCD13: '3400893093252',
  ucdQtyMultiplicator: 10,
  cipLib: "BIONOLYTE G10 INJ FPE1000ML BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '3837750',
  CIP13: '3400938377507',
  ucdLib: "BIONOLYTE G10 INJ FPE500ML",
  UCD7: '9309331',
  UCD13: '3400893093313',
  ucdQtyMultiplicator: 10,
  cipLib: "BIONOLYTE G10 INJ FPE500ML BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '3837738',
  CIP13: '3400938377385',
  ucdLib: "BIONOLYTE G5 INJ FPE1000ML",
  UCD7: '9309348',
  UCD13: '3400893093481',
  ucdQtyMultiplicator: 10,
  cipLib: "BIONOLYTE G5 INJ FPE1000ML BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '3837709',
  CIP13: '3400938377095',
  ucdLib: "BIONOLYTE G5 INJ FPE500ML",
  UCD7: '9309354',
  UCD13: '3400893093542',
  ucdQtyMultiplicator: 10,
  cipLib: "BIONOLYTE G5 INJ FPE500ML BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '3610822',
  CIP13: '3400936108226',
  ucdLib: "GLUCIDION G10 INJ P.E1000ML",
  UCD7: '9189795',
  UCD13: '3400891897951',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCIDION G10 INJ P.E1000ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3610816',
  CIP13: '3400936108165',
  ucdLib: "GLUCIDION G10 INJ P.E500ML",
  UCD7: '9189826',
  UCD13: '3400891898262',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCIDION G10 INJ P.E500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3286913',
  CIP13: '3400932869138',
  ucdLib: "COMPENSAL 15G10 INJ FV250ML",
  UCD7: '9116253',
  UCD13: '3400891162530',
  ucdQtyMultiplicator: 1,
  cipLib: "COMPENSAL 15G10 INJ FV250ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3286936',
  CIP13: '3400932869367',
  ucdLib: "COMPENSAL 15G10 INJ FV500ML",
  UCD7: '9116276',
  UCD13: '3400891162769',
  ucdQtyMultiplicator: 1,
  cipLib: "COMPENSAL 15G10 INJ FV500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3607352',
  CIP13: '3400936073524',
  ucdLib: "GLUCIDION G 5 INJ P.E1000ML",
  UCD7: '9189766',
  UCD13: '3400891897661',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCIDION G 5 INJ P.E1000ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3607346',
  CIP13: '3400936073463',
  ucdLib: "GLUCIDION G 5 INJ P.E500ML",
  UCD7: '9189789',
  UCD13: '3400891897890',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCIDION G 5 INJ P.E500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3604862',
  CIP13: '3400936048621',
  ucdLib: "GLUCOSE 2,5%NACL BBM PE1000ML",
  UCD7: '9179087',
  UCD13: '3400891790870',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5%NACL BBM PE1000ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3604856',
  CIP13: '3400936048560',
  ucdLib: "GLUCOSE 2,5%NACL BBM PE500ML",
  UCD7: '9179093',
  UCD13: '3400891790931',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5%NACL BBM PE500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3604365',
  CIP13: '3400936043657',
  ucdLib: "POLYIONIQUE G5 MAC P.FN1000ML",
  UCD7: '9241372',
  UCD13: '3400892413723',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQUE G5 MAC P.FN1000ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3604342',
  CIP13: '3400936043428',
  ucdLib: "POLYIONIQUE G5 MAC P.FN250ML",
  UCD7: '9241389',
  UCD13: '3400892413891',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQUE G5 MAC P.FN250ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3604359',
  CIP13: '3400936043596',
  ucdLib: "POLYIONIQUE G5 MAC P.FN500ML",
  UCD7: '9241395',
  UCD13: '3400892413952',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQUE G5 MAC P.FN500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3675046',
  CIP13: '3400936750463',
  ucdLib: "BIONOLYTE G5 SIS-SEB1000ML",
  UCD7: '9277654',
  UCD13: '3400892776545',
  ucdQtyMultiplicator: 1,
  cipLib: "BIONOLYTE G5 SIS-SEB1000ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3675023',
  CIP13: '3400936750234',
  ucdLib: "BIONOLYTE G5 SIS-SEB500ML",
  UCD7: '9277660',
  UCD13: '3400892776606',
  ucdQtyMultiplicator: 1,
  cipLib: "BIONOLYTE G5 SIS-SEB500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3855475',
  CIP13: '3400938554755',
  ucdLib: "BIONOLYTE G5 SIS-SEB1000ML",
  UCD7: '9277654',
  UCD13: '3400892776545',
  ucdQtyMultiplicator: 10,
  cipLib: "BIONOLYTE G5 SIS-SEB1000ML BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '3855179',
  CIP13: '3400938551792',
  ucdLib: "BIONOLYTE G5 SIS-SEB500ML",
  UCD7: '9277660',
  UCD13: '3400892776606',
  ucdQtyMultiplicator: 20,
  cipLib: "BIONOLYTE G5 SIS-SEB500ML BT 20",
  atcCode: "B05BB02"
}, {
  CIP7: '3551775',
  CIP13: '3400935517753',
  ucdLib: "POLYIONIQ.1A BAX VFO.S1L",
  UCD7: '9225522',
  UCD13: '3400892255224',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQ.1A BAX VFO.S1L BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3551769',
  CIP13: '3400935517692',
  ucdLib: "POLYIONIQ.1A BAX VFO.S500ML",
  UCD7: '9225545',
  UCD13: '3400892255453',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQ.1A BAX VFO.S500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3551835',
  CIP13: '3400935518354',
  ucdLib: "POLYIONIQ.2A BAX VFO.S1L",
  UCD7: '9225551',
  UCD13: '3400892255514',
  ucdQtyMultiplicator: 10,
  cipLib: "POLYIONIQ.2A BAX VFO.S1L BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '3551829',
  CIP13: '3400935518293',
  ucdLib: "POLYIONIQ.2A BAX VFO.S500ML",
  UCD7: '9225574',
  UCD13: '3400892255743',
  ucdQtyMultiplicator: 20,
  cipLib: "POLYIONIQ.2A BAX VFO.S500ML BT 20",
  atcCode: "B05BB02"
}, {
  CIP7: '3566452',
  CIP13: '3400935664525',
  ucdLib: "POLYIONIQUE B46 AP-HP 250ML",
  UCD7: '9229827',
  UCD13: '3400892298276',
  ucdQtyMultiplicator: 12,
  cipLib: "POLYIONIQUE B46 AP-HP 250ML BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '3566469',
  CIP13: '3400935664693',
  ucdLib: "POLYIONIQUE B46 AP-HP 500ML",
  UCD7: '9229833',
  UCD13: '3400892298337',
  ucdQtyMultiplicator: 12,
  cipLib: "POLYIONIQUE B46 AP-HP 500ML BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '3561986',
  CIP13: '3400935619860',
  ucdLib: "POLYIONIQUE B66 AP-HP 250ML",
  UCD7: '9229810',
  UCD13: '3400892298108',
  ucdQtyMultiplicator: 12,
  cipLib: "POLYIONIQUE B66 AP-HP 250ML BT 12",
  atcCode: "B05BB02"
}, {
  CIP7: '3562750',
  CIP13: '3400935627506',
  ucdLib: "POLYIONIQUE G5 MAC P.1000ML",
  UCD7: '9140530',
  UCD13: '3400891405309',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQUE G5 MAC P.1000ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3562744',
  CIP13: '3400935627445',
  ucdLib: "POLYIONIQUE G5 MAC P.500ML",
  UCD7: '9140553',
  UCD13: '3400891405538',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQUE G5 MAC P.500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3794325',
  CIP13: '3400937943253',
  ucdLib: "POLYIONIQUE G10 MAC PFNS1000ML",
  UCD7: '9305273',
  UCD13: '3400893052730',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQUE G10 MAC PFNS1000ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3794319',
  CIP13: '3400937943192',
  ucdLib: "POLYIONIQUE G10 MAC PFNS500ML1",
  UCD7: '9305184',
  UCD13: '3400893051849',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQUE G10 MAC PFNS500ML1 BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '3864250',
  CIP13: '3400938642506',
  ucdLib: "BIONOLYTE G10 SIS-SEB1000ML",
  UCD7: '9277631',
  UCD13: '3400892776316',
  ucdQtyMultiplicator: 10,
  cipLib: "BIONOLYTE G10 SIS-SEB1000ML BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '3863606',
  CIP13: '3400938636062',
  ucdLib: "BIONOLYTE G10 SIS-SEB500ML",
  UCD7: '9277648',
  UCD13: '3400892776484',
  ucdQtyMultiplicator: 20,
  cipLib: "BIONOLYTE G10 SIS-SEB500ML BT 20",
  atcCode: "B05BB02"
}, {
  CIP7: '2228397',
  CIP13: '3400922283975',
  ucdLib: "POLYIONIQUE B27 FRF PS500ML",
  UCD7: '9383830',
  UCD13: '3400893838303',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYIONIQUE B27 FRF PS500ML BT 1",
  atcCode: "B05BB02"
}, {
  CIP7: '5658773',
  CIP13: '3400956587735',
  ucdLib: "OSMOTAN G10% INJ TOF1000ML",
  UCD7: '9319648',
  UCD13: '3400893196489',
  ucdQtyMultiplicator: 10,
  cipLib: "OSMOTAN G10% INJ TOF1000ML BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '5658750',
  CIP13: '3400956587506',
  ucdLib: "OSMOTAN G5% INJ TOF1000ML",
  UCD7: '9319594',
  UCD13: '3400893195949',
  ucdQtyMultiplicator: 10,
  cipLib: "OSMOTAN G5% INJ TOF1000ML BT 10",
  atcCode: "B05BB02"
}, {
  CIP7: '5535562',
  CIP13: '3400955355625',
  ucdLib: "RINGER LAC LAV FV500ML",
  UCD7: '9114610',
  UCD13: '3400891146103',
  ucdQtyMultiplicator: 12,
  cipLib: "RINGER LAC LAV FV500ML BT 12",
  atcCode: "B05BB01"
}, {
  CIP7: '3619740',
  CIP13: '3400936197404',
  ucdLib: "RINGER LAC BBM P.E250ML",
  UCD7: '9246033',
  UCD13: '3400892460338',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC BBM P.E250ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3831865',
  CIP13: '3400938318654',
  ucdLib: "RINGER LAC FKF FPE1000ML",
  UCD7: '9307817',
  UCD13: '3400893078174',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC FKF FPE1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3831871',
  CIP13: '3400938318715',
  ucdLib: "RINGER LAC FKF FPE1000ML",
  UCD7: '9307817',
  UCD13: '3400893078174',
  ucdQtyMultiplicator: 10,
  cipLib: "RINGER LAC FKF FPE1000ML BT 10",
  atcCode: "B05BB01"
}, {
  CIP7: '3831836',
  CIP13: '3400938318364',
  ucdLib: "RINGER LAC FKF FPE500ML",
  UCD7: '9307823',
  UCD13: '3400893078235',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC FKF FPE500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3831842',
  CIP13: '3400938318425',
  ucdLib: "RINGER LAC FKF FPE500ML",
  UCD7: '9307823',
  UCD13: '3400893078235',
  ucdQtyMultiplicator: 10,
  cipLib: "RINGER LAC FKF FPE500ML BT 10",
  atcCode: "B05BB01"
}, {
  CIP7: '3615601',
  CIP13: '3400936156012',
  ucdLib: "RINGER LAC VIAFLO POC1000ML",
  UCD7: '9260458',
  UCD13: '3400892604589',
  ucdQtyMultiplicator: 10,
  cipLib: "RINGER LAC VIAFLO POC1000ML BT 10",
  atcCode: "B05BB01"
}, {
  CIP7: '3615593',
  CIP13: '3400936155930',
  ucdLib: "RINGER LAC VIAFLO POC500ML",
  UCD7: '9260470',
  UCD13: '3400892604701',
  ucdQtyMultiplicator: 20,
  cipLib: "RINGER LAC VIAFLO POC500ML BT 20",
  atcCode: "B05BB01"
}, {
  CIP7: '3832209',
  CIP13: '3400938322095',
  ucdLib: "RINGER MAC P.FNS1000ML",
  UCD7: '9316584',
  UCD13: '3400893165843',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER MAC P.FNS1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3832190',
  CIP13: '3400938321906',
  ucdLib: "RINGER MAC P.FNS500ML",
  UCD7: '9316609',
  UCD13: '3400893166093',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER MAC P.FNS500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3263160',
  CIP13: '3400932631605',
  ucdLib: "RINGER LAC BSD P.1000ML",
  UCD7: '9132832',
  UCD13: '3400891328325',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC BSD P.1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3607458',
  CIP13: '3400936074583',
  ucdLib: "RINGER LAC BBM P.E1000ML",
  UCD7: '9189401',
  UCD13: '3400891894011',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC BBM P.E1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3607441',
  CIP13: '3400936074415',
  ucdLib: "RINGER LAC BBM P.E500ML",
  UCD7: '9189418',
  UCD13: '3400891894189',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC BBM P.E500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3673455',
  CIP13: '3400936734555',
  ucdLib: "RINGER FRF INJ SIS-SEBS500ML",
  UCD7: '9275247',
  UCD13: '3400892752471',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER FRF INJ SIS-SEBS500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3673403',
  CIP13: '3400936734036',
  ucdLib: "RINGER LAC FRF SIS-SEBS1000ML",
  UCD7: '9275632',
  UCD13: '3400892756325',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC FRF SIS-SEBS1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3205866',
  CIP13: '3400932058662',
  ucdLib: "RINGER LAC LAV FV500ML",
  UCD7: '9114610',
  UCD13: '3400891146103',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC LAV FV500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3551278',
  CIP13: '3400935512789',
  ucdLib: "RINGER LAC FRF P.S1000ML",
  UCD7: '9232350',
  UCD13: '3400892323503',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC FRF P.S1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3216232',
  CIP13: '3400932162321',
  ucdLib: "RINGER LAC LAV FV1000ML",
  UCD7: '9114604',
  UCD13: '3400891146042',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC LAV FV1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3591579',
  CIP13: '3400935915795',
  ucdLib: "RINGER LAC PCA DAT3000ML",
  UCD7: '9312267',
  UCD13: '3400893122679',
  ucdQtyMultiplicator: 3,
  cipLib: "RINGER LAC PCA DAT3000ML BT 3",
  atcCode: "B05BB01"
}, {
  CIP7: '3706597',
  CIP13: '3400937065979',
  ucdLib: "PLASMALYTE VIAFLO POC500ML",
  UCD7: '9368523',
  UCD13: '3400893685235',
  ucdQtyMultiplicator: 20,
  cipLib: "PLASMALYTE VIAFLO POC500ML BT 20",
  atcCode: "B05BB01"
}, {
  CIP7: '3692636',
  CIP13: '3400936926363',
  ucdLib: "ISOFUNDINE PERF ECB500ML",
  UCD7: '9306396',
  UCD13: '3400893063965',
  ucdQtyMultiplicator: 20,
  cipLib: "ISOFUNDINE PERF ECB500ML BT 20",
  atcCode: "B05BB01"
}, {
  CIP7: '3692582',
  CIP13: '3400936925823',
  ucdLib: "ISOFUNDINE PERF ECF1000ML",
  UCD7: '9301134',
  UCD13: '3400893011348',
  ucdQtyMultiplicator: 10,
  cipLib: "ISOFUNDINE PERF ECF1000ML BT 10",
  atcCode: "B05BB01"
}, {
  CIP7: '3692530',
  CIP13: '3400936925304',
  ucdLib: "ISOFUNDINE PERF ECF250ML",
  UCD7: '9304500',
  UCD13: '3400893045008',
  ucdQtyMultiplicator: 10,
  cipLib: "ISOFUNDINE PERF ECF250ML BT 10",
  atcCode: "B05BB01"
}, {
  CIP7: '3692553',
  CIP13: '3400936925533',
  ucdLib: "ISOFUNDINE PERF ECF500ML",
  UCD7: '9301140',
  UCD13: '3400893011409',
  ucdQtyMultiplicator: 10,
  cipLib: "ISOFUNDINE PERF ECF500ML BT 10",
  atcCode: "B05BB01"
}, {
  CIP7: '3638140',
  CIP13: '3400936381407',
  ucdLib: "RINGER BBM P.E1000ML",
  UCD7: '9265444',
  UCD13: '3400892654447',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER BBM P.E1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3638128',
  CIP13: '3400936381285',
  ucdLib: "RINGER BBM P.E250ML",
  UCD7: '9265450',
  UCD13: '3400892654508',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER BBM P.E250ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3638134',
  CIP13: '3400936381346',
  ucdLib: "RINGER BBM P.E500ML",
  UCD7: '9265467',
  UCD13: '3400892654676',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER BBM P.E500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3664597',
  CIP13: '3400936645974',
  ucdLib: "RINGER LAC FRF SIS-SEBS500ML",
  UCD7: '9275649',
  UCD13: '3400892756493',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC FRF SIS-SEBS500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3698314',
  CIP13: '3400936983144',
  ucdLib: "RINGER LAC MAC P.FNS1000ML",
  UCD7: '9311865',
  UCD13: '3400893118658',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.FNS1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3698283',
  CIP13: '3400936982833',
  ucdLib: "RINGER LAC MAC P.FNS250ML",
  UCD7: '9311871',
  UCD13: '3400893118719',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.FNS250ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3698308',
  CIP13: '3400936983083',
  ucdLib: "RINGER LAC MAC P.FNS500ML",
  UCD7: '9311888',
  UCD13: '3400893118887',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.FNS500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3698277',
  CIP13: '3400936982772',
  ucdLib: "RINGER LAC MAC P.FS1000ML",
  UCD7: '9311836',
  UCD13: '3400893118368',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.FS1000ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3698254',
  CIP13: '3400936982543',
  ucdLib: "RINGER LAC MAC P.FS250ML",
  UCD7: '9311842',
  UCD13: '3400893118429',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.FS250ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3698260',
  CIP13: '3400936982604',
  ucdLib: "RINGER LAC MAC P.FS500ML",
  UCD7: '9311859',
  UCD13: '3400893118597',
  ucdQtyMultiplicator: 1,
  cipLib: "RINGER LAC MAC P.FS500ML BT 1",
  atcCode: "B05BB01"
}, {
  CIP7: '3988963',
  CIP13: '3400939889634',
  ucdLib: "IONOVEN SOL PERF POC1000ML",
  UCD7: '9354662',
  UCD13: '3400893546628',
  ucdQtyMultiplicator: 10,
  cipLib: "IONOVEN SOL PERF POC1000ML BT 10",
  atcCode: "B05BB01"
}, {
  CIP7: '3988957',
  CIP13: '3400939889573',
  ucdLib: "IONOVEN SOL PERF POC500ML",
  UCD7: '9354679',
  UCD13: '3400893546796',
  ucdQtyMultiplicator: 20,
  cipLib: "IONOVEN SOL PERF POC500ML BT 20",
  atcCode: "B05BB01"
}, {
  CIP7: '3006086',
  CIP13: '3400930060865',
  ucdLib: "NUMETAH G13%E PREMA P.T300ML",
  UCD7: '9418505',
  UCD13: '3400894185055',
  ucdQtyMultiplicator: 10,
  cipLib: "NUMETAH G13%E PREMA P.T300ML BT 10",
  atcCode: "B05BA10"
}, {
  CIP7: '3000971',
  CIP13: '3400930009710',
  ucdLib: "PEDIAVEN AP-HP NN S/OE250ML",
  UCD7: '9408932',
  UCD13: '3400894089322',
  ucdQtyMultiplicator: 10,
  cipLib: "PEDIAVEN AP-HP NN S/OE250ML BT 10",
  atcCode: "B05BA10"
}, {
  CIP7: '3526091',
  CIP13: '3400935260918',
  ucdLib: "MEDNUTRIF.LI G120N5,4 1875ML",
  UCD7: '9323733',
  UCD13: '3400893237335',
  ucdQtyMultiplicator: 5,
  cipLib: "MEDNUTRIF.LI G120N5,4 1875ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3526122',
  CIP13: '3400935261229',
  ucdLib: "REANUTRIFLEX L.G144N8 1250ML",
  UCD7: '9319341',
  UCD13: '3400893193419',
  ucdQtyMultiplicator: 5,
  cipLib: "REANUTRIFLEX L.G144N8 1250ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '4982342',
  CIP13: '3400949823420',
  ucdLib: "MEDNUTRIF.OM G120N5,4E 1250ML",
  UCD7: '9368144',
  UCD13: '3400893681442',
  ucdQtyMultiplicator: 5,
  cipLib: "MEDNUTRIF.OM G120N5,4E 1250ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '4982359',
  CIP13: '3400949823598',
  ucdLib: "MEDNUTRIF.OM G120N5,4E 1875ML",
  UCD7: '9368150',
  UCD13: '3400893681503',
  ucdQtyMultiplicator: 5,
  cipLib: "MEDNUTRIF.OM G120N5,4E 1875ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '4982365',
  CIP13: '3400949823659',
  ucdLib: "MEDNUTRIF.OM G120N5,4E 2500ML",
  UCD7: '9368167',
  UCD13: '3400893681671',
  ucdQtyMultiplicator: 5,
  cipLib: "MEDNUTRIF.OM G120N5,4E 2500ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '4982201',
  CIP13: '3400949822010',
  ucdLib: "REANUTRIFLEX O.G144N8E 1250ML",
  UCD7: '9368173',
  UCD13: '3400893681732',
  ucdQtyMultiplicator: 5,
  cipLib: "REANUTRIFLEX O.G144N8E 1250ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '4982218',
  CIP13: '3400949822188',
  ucdLib: "REANUTRIFLEX O.G144N8E 1875ML",
  UCD7: '9368196',
  UCD13: '3400893681961',
  ucdQtyMultiplicator: 5,
  cipLib: "REANUTRIFLEX O.G144N8E 1875ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '4982193',
  CIP13: '3400949821938',
  ucdLib: "REANUTRIFLEX O.G144N8E 625ML",
  UCD7: '9368204',
  UCD13: '3400893682043',
  ucdQtyMultiplicator: 5,
  cipLib: "REANUTRIFLEX O.G144N8E 625ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3563608',
  CIP13: '3400935636089',
  ucdLib: "CLINIMIX N12G20E INJ PD1,5L",
  UCD7: '9235779',
  UCD13: '3400892357799',
  ucdQtyMultiplicator: 1,
  cipLib: "CLINIMIX N12G20E INJ PD1,5L BT 1",
  atcCode: "B05BA10"
}, {
  CIP7: '3563583',
  CIP13: '3400935635839',
  ucdLib: "CLINIMIX N12G20E INJ PD1L",
  UCD7: '9235845',
  UCD13: '3400892358451',
  ucdQtyMultiplicator: 1,
  cipLib: "CLINIMIX N12G20E INJ PD1L BT 1",
  atcCode: "B05BA10"
}, {
  CIP7: '3563695',
  CIP13: '3400935636959',
  ucdLib: "CLINIMIX N14G30 INJ PD1,5L",
  UCD7: '9235785',
  UCD13: '3400892357850',
  ucdQtyMultiplicator: 6,
  cipLib: "CLINIMIX N14G30 INJ PD1,5L BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3563577',
  CIP13: '3400935635778',
  ucdLib: "CLINIMIX N9G15E INJ PD1,5L",
  UCD7: '9235839',
  UCD13: '3400892358390',
  ucdQtyMultiplicator: 6,
  cipLib: "CLINIMIX N9G15E INJ PD1,5L BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3563560',
  CIP13: '3400935635600',
  ucdLib: "CLINIMIX N9G15E INJ PD1L",
  UCD7: '9235868',
  UCD13: '3400892358680',
  ucdQtyMultiplicator: 8,
  cipLib: "CLINIMIX N9G15E INJ PD1L BT 8",
  atcCode: "B05BA10"
}, {
  CIP7: '3542902',
  CIP13: '3400935429025',
  ucdLib: "CLINIMIX N12G20 INJ PD2L",
  UCD7: '9182758',
  UCD13: '3400891827583',
  ucdQtyMultiplicator: 4,
  cipLib: "CLINIMIX N12G20 INJ PD2L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3542871',
  CIP13: '3400935428714',
  ucdLib: "CLINIMIX N12G20E INJ PD2L",
  UCD7: '9182764',
  UCD13: '3400891827644',
  ucdQtyMultiplicator: 1,
  cipLib: "CLINIMIX N12G20E INJ PD2L BT 1",
  atcCode: "B05BA10"
}, {
  CIP7: '3542919',
  CIP13: '3400935429193',
  ucdLib: "CLINIMIX N14G30 INJ PD2L",
  UCD7: '9182770',
  UCD13: '3400891827705',
  ucdQtyMultiplicator: 4,
  cipLib: "CLINIMIX N14G30 INJ PD2L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3698745',
  CIP13: '3400936987456',
  ucdLib: "AMINOMIX 500 PERF POC1000ML",
  UCD7: '9292607',
  UCD13: '3400892926070',
  ucdQtyMultiplicator: 6,
  cipLib: "AMINOMIX 500 PERF POC1000ML BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3698751',
  CIP13: '3400936987517',
  ucdLib: "AMINOMIX 500 PERF POC1500ML",
  UCD7: '9292613',
  UCD13: '3400892926131',
  ucdQtyMultiplicator: 4,
  cipLib: "AMINOMIX 500 PERF POC1500ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3698774',
  CIP13: '3400936987746',
  ucdLib: "AMINOMIX 500E PERF POC1000ML",
  UCD7: '9292642',
  UCD13: '3400892926421',
  ucdQtyMultiplicator: 6,
  cipLib: "AMINOMIX 500E PERF POC1000ML BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3698780',
  CIP13: '3400936987807',
  ucdLib: "AMINOMIX 500E PERF POC1500ML",
  UCD7: '9292659',
  UCD13: '3400892926599',
  ucdQtyMultiplicator: 4,
  cipLib: "AMINOMIX 500E PERF POC1500ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3698805',
  CIP13: '3400936988057',
  ucdLib: "AMINOMIX 800E PERF POC1000ML",
  UCD7: '9292671',
  UCD13: '3400892926711',
  ucdQtyMultiplicator: 6,
  cipLib: "AMINOMIX 800E PERF POC1000ML BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3698811',
  CIP13: '3400936988118',
  ucdLib: "AMINOMIX 800E PERF POC1500ML",
  UCD7: '9292688',
  UCD13: '3400892926889',
  ucdQtyMultiplicator: 4,
  cipLib: "AMINOMIX 800E PERF POC1500ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3698828',
  CIP13: '3400936988286',
  ucdLib: "AMINOMIX 800E PERF POC2000ML",
  UCD7: '9292694',
  UCD13: '3400892926940',
  ucdQtyMultiplicator: 4,
  cipLib: "AMINOMIX 800E PERF POC2000ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3777522',
  CIP13: '3400937775229',
  ucdLib: "KABIVEN INJ P3C1026ML",
  UCD7: '9317075',
  UCD13: '3400893170755',
  ucdQtyMultiplicator: 4,
  cipLib: "KABIVEN INJ P3C1026ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3777551',
  CIP13: '3400937775519',
  ucdLib: "KABIVEN INJ P3C1540ML",
  UCD7: '9317081',
  UCD13: '3400893170816',
  ucdQtyMultiplicator: 4,
  cipLib: "KABIVEN INJ P3C1540ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3777574',
  CIP13: '3400937775748',
  ucdLib: "KABIVEN INJ P3C2053ML",
  UCD7: '9317098',
  UCD13: '3400893170984',
  ucdQtyMultiplicator: 4,
  cipLib: "KABIVEN INJ P3C2053ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3777597',
  CIP13: '3400937775977',
  ucdLib: "KABIVEN INJ P3C2566ML",
  UCD7: '9317106',
  UCD13: '3400893171066',
  ucdQtyMultiplicator: 3,
  cipLib: "KABIVEN INJ P3C2566ML BT 3",
  atcCode: "B05BA10"
}, {
  CIP7: '3828768',
  CIP13: '3400938287684',
  ucdLib: "MEDNUTRIF.LI G120N5,4E 1250ML",
  UCD7: '9309816',
  UCD13: '3400893098165',
  ucdQtyMultiplicator: 5,
  cipLib: "MEDNUTRIF.LI G120N5,4E 1250ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3828780',
  CIP13: '3400938287806',
  ucdLib: "MEDNUTRIF.LI G120N5,4E 1875ML",
  UCD7: '9309822',
  UCD13: '3400893098226',
  ucdQtyMultiplicator: 5,
  cipLib: "MEDNUTRIF.LI G120N5,4E 1875ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3828797',
  CIP13: '3400938287974',
  ucdLib: "MEDNUTRIF.LI G120N5,4E 2500ML",
  UCD7: '9309839',
  UCD13: '3400893098394',
  ucdQtyMultiplicator: 5,
  cipLib: "MEDNUTRIF.LI G120N5,4E 2500ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3777456',
  CIP13: '3400937774567',
  ucdLib: "PERIKABIVEN INJ P3C1440ML",
  UCD7: '9317112',
  UCD13: '3400893171127',
  ucdQtyMultiplicator: 4,
  cipLib: "PERIKABIVEN INJ P3C1440ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3777479',
  CIP13: '3400937774796',
  ucdLib: "PERIKABIVEN INJ P3C1920ML",
  UCD7: '9317129',
  UCD13: '3400893171295',
  ucdQtyMultiplicator: 4,
  cipLib: "PERIKABIVEN INJ P3C1920ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3777491',
  CIP13: '3400937774918',
  ucdLib: "PERIKABIVEN INJ P3C2400ML",
  UCD7: '9317135',
  UCD13: '3400893171356',
  ucdQtyMultiplicator: 3,
  cipLib: "PERIKABIVEN INJ P3C2400ML BT 3",
  atcCode: "B05BA10"
}, {
  CIP7: '3828739',
  CIP13: '3400938287394',
  ucdLib: "PERINUTRIFLEX G64N4,6E 1250ML",
  UCD7: '9309845',
  UCD13: '3400893098455',
  ucdQtyMultiplicator: 5,
  cipLib: "PERINUTRIFLEX G64N4,6E 1250ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3828745',
  CIP13: '3400938287455',
  ucdLib: "PERINUTRIFLEX G64N4,6E 1875ML",
  UCD7: '9309851',
  UCD13: '3400893098516',
  ucdQtyMultiplicator: 5,
  cipLib: "PERINUTRIFLEX G64N4,6E 1875ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3829414',
  CIP13: '3400938294149',
  ucdLib: "REANUTRIFLEX L.G144N8 1875ML",
  UCD7: '9309868',
  UCD13: '3400893098684',
  ucdQtyMultiplicator: 5,
  cipLib: "REANUTRIFLEX L.G144N8 1875ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3828828',
  CIP13: '3400938288285',
  ucdLib: "REANUTRIFLEX L.G144N8E 1250ML",
  UCD7: '9309874',
  UCD13: '3400893098745',
  ucdQtyMultiplicator: 5,
  cipLib: "REANUTRIFLEX L.G144N8E 1250ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3828834',
  CIP13: '3400938288346',
  ucdLib: "REANUTRIFLEX L.G144N8E 1875ML",
  UCD7: '9309880',
  UCD13: '3400893098806',
  ucdQtyMultiplicator: 5,
  cipLib: "REANUTRIFLEX L.G144N8E 1875ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '3866013',
  CIP13: '3400938660135',
  ucdLib: "OLIMEL N7 PERF P.T1,5L",
  UCD7: '9326097',
  UCD13: '3400893260975',
  ucdQtyMultiplicator: 4,
  cipLib: "OLIMEL N7 PERF P.T1,5L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3866036',
  CIP13: '3400938660364',
  ucdLib: "OLIMEL N7 PERF P.T2L",
  UCD7: '9326105',
  UCD13: '3400893261057',
  ucdQtyMultiplicator: 4,
  cipLib: "OLIMEL N7 PERF P.T2L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3866065',
  CIP13: '3400938660654',
  ucdLib: "OLIMEL N7E PERF P.T1,5L",
  UCD7: '9318063',
  UCD13: '3400893180631',
  ucdQtyMultiplicator: 4,
  cipLib: "OLIMEL N7E PERF P.T1,5L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3866059',
  CIP13: '3400938660593',
  ucdLib: "OLIMEL N7E PERF P.T1L",
  UCD7: '9318057',
  UCD13: '3400893180570',
  ucdQtyMultiplicator: 6,
  cipLib: "OLIMEL N7E PERF P.T1L BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3866071',
  CIP13: '3400938660715',
  ucdLib: "OLIMEL N7E PERF P.T2L",
  UCD7: '9318086',
  UCD13: '3400893180860',
  ucdQtyMultiplicator: 4,
  cipLib: "OLIMEL N7E PERF P.T2L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3866102',
  CIP13: '3400938661026',
  ucdLib: "OLIMEL N9 PERF P.T1,5L",
  UCD7: '9318100',
  UCD13: '3400893181003',
  ucdQtyMultiplicator: 4,
  cipLib: "OLIMEL N9 PERF P.T1,5L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3866094',
  CIP13: '3400938660944',
  ucdLib: "OLIMEL N9 PERF P.T1L",
  UCD7: '9318092',
  UCD13: '3400893180921',
  ucdQtyMultiplicator: 6,
  cipLib: "OLIMEL N9 PERF P.T1L BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3866119',
  CIP13: '3400938661194',
  ucdLib: "OLIMEL N9 PERF P.T2L",
  UCD7: '9318117',
  UCD13: '3400893181171',
  ucdQtyMultiplicator: 4,
  cipLib: "OLIMEL N9 PERF P.T2L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3866148',
  CIP13: '3400938661484',
  ucdLib: "OLIMEL N9E PERF P.T1,5L",
  UCD7: '9318146',
  UCD13: '3400893181461',
  ucdQtyMultiplicator: 4,
  cipLib: "OLIMEL N9E PERF P.T1,5L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3866131',
  CIP13: '3400938661316',
  ucdLib: "OLIMEL N9E PERF P.T1L",
  UCD7: '9318123',
  UCD13: '3400893181232',
  ucdQtyMultiplicator: 6,
  cipLib: "OLIMEL N9E PERF P.T1L BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3866154',
  CIP13: '3400938661545',
  ucdLib: "OLIMEL N9E PERF P.T2L",
  UCD7: '9318152',
  UCD13: '3400893181522',
  ucdQtyMultiplicator: 4,
  cipLib: "OLIMEL N9E PERF P.T2L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3865918',
  CIP13: '3400938659184',
  ucdLib: "PERIOLIMEL N4E PERF P.T1,5L",
  UCD7: '9318175',
  UCD13: '3400893181751',
  ucdQtyMultiplicator: 4,
  cipLib: "PERIOLIMEL N4E PERF P.T1,5L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3865901',
  CIP13: '3400938659016',
  ucdLib: "PERIOLIMEL N4E PERF P.T1L",
  UCD7: '9318169',
  UCD13: '3400893181690',
  ucdQtyMultiplicator: 6,
  cipLib: "PERIOLIMEL N4E PERF P.T1L BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '3865924',
  CIP13: '3400938659245',
  ucdLib: "PERIOLIMEL N4E PERF P.T2L",
  UCD7: '9318181',
  UCD13: '3400893181812',
  ucdQtyMultiplicator: 4,
  cipLib: "PERIOLIMEL N4E PERF P.T2L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3928091',
  CIP13: '3400939280912',
  ucdLib: "SMOFKABIVEN E PERF PTB1477ML",
  UCD7: '9331276',
  UCD13: '3400893312766',
  ucdQtyMultiplicator: 4,
  cipLib: "SMOFKABIVEN E PERF PTB1477ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3928122',
  CIP13: '3400939281223',
  ucdLib: "SMOFKABIVEN E PERF PTB1970ML",
  UCD7: '9331282',
  UCD13: '3400893312827',
  ucdQtyMultiplicator: 4,
  cipLib: "SMOFKABIVEN E PERF PTB1970ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3928079',
  CIP13: '3400939280790',
  ucdLib: "SMOFKABIVEN E PERF PTB986ML",
  UCD7: '9331307',
  UCD13: '3400893313077',
  ucdQtyMultiplicator: 4,
  cipLib: "SMOFKABIVEN E PERF PTB986ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3928406',
  CIP13: '3400939284064',
  ucdLib: "SMOFKABIVEN PERF PTB1477ML",
  UCD7: '9331224',
  UCD13: '3400893312247',
  ucdQtyMultiplicator: 4,
  cipLib: "SMOFKABIVEN PERF PTB1477ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3928429',
  CIP13: '3400939284293',
  ucdLib: "SMOFKABIVEN PERF PTB1970ML",
  UCD7: '9331230',
  UCD13: '3400893312308',
  ucdQtyMultiplicator: 4,
  cipLib: "SMOFKABIVEN PERF PTB1970ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3928441',
  CIP13: '3400939284415',
  ucdLib: "SMOFKABIVEN PERF PTB2463ML",
  UCD7: '9331247',
  UCD13: '3400893312476',
  ucdQtyMultiplicator: 3,
  cipLib: "SMOFKABIVEN PERF PTB2463ML BT 3",
  atcCode: "B05BA10"
}, {
  CIP7: '3928381',
  CIP13: '3400939283814',
  ucdLib: "SMOFKABIVEN PERF PTB986ML",
  UCD7: '9331253',
  UCD13: '3400893312537',
  ucdQtyMultiplicator: 4,
  cipLib: "SMOFKABIVEN PERF PTB986ML BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '3911067',
  CIP13: '3400939110677',
  ucdLib: "REANUTRIFLEX L.G144N8E 625ML",
  UCD7: '9332175',
  UCD13: '3400893321751',
  ucdQtyMultiplicator: 5,
  cipLib: "REANUTRIFLEX L.G144N8E 625ML BT 5",
  atcCode: "B05BA10"
}, {
  CIP7: '4199990',
  CIP13: '3400941999901',
  ucdLib: "PEDIAVEN AP-HP G15 BIO1L",
  UCD7: '9374564',
  UCD13: '3400893745649',
  ucdQtyMultiplicator: 4,
  cipLib: "PEDIAVEN AP-HP G15 BIO1L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '4199576',
  CIP13: '3400941995767',
  ucdLib: "PEDIAVEN AP-HP G20 BIO1L",
  UCD7: '9374570',
  UCD13: '3400893745700',
  ucdQtyMultiplicator: 4,
  cipLib: "PEDIAVEN AP-HP G20 BIO1L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '4178060',
  CIP13: '3400941780608',
  ucdLib: "PEDIAVEN AP-HP NN1 BIO250ML",
  UCD7: '9360409',
  UCD13: '3400893604090',
  ucdQtyMultiplicator: 10,
  cipLib: "PEDIAVEN AP-HP NN1 BIO250ML BT 10",
  atcCode: "B05BA10"
}, {
  CIP7: '4178077',
  CIP13: '3400941780776',
  ucdLib: "PEDIAVEN AP-HP NN2 BIO250ML",
  UCD7: '9360415',
  UCD13: '3400893604151',
  ucdQtyMultiplicator: 10,
  cipLib: "PEDIAVEN AP-HP NN2 BIO250ML BT 10",
  atcCode: "B05BA10"
}, {
  CIP7: '5704303',
  CIP13: '3400957043032',
  ucdLib: "NP100 PREMAT.AP-HP INJ 500ML",
  UCD7: '9277708',
  UCD13: '3400892777085',
  ucdQtyMultiplicator: 10,
  cipLib: "NP100 PREMAT.AP-HP INJ 500ML BT 10",
  atcCode: "B05BA10"
}, {
  CIP7: '5708672',
  CIP13: '3400957086725',
  ucdLib: "NP2 ENFANT AP-HP INJ 500ML",
  UCD7: '9285530',
  UCD13: '3400892855301',
  ucdQtyMultiplicator: 10,
  cipLib: "NP2 ENFANT AP-HP INJ 500ML BT 10",
  atcCode: "B05BA10"
}, {
  CIP7: '4166246',
  CIP13: '3400941662461',
  ucdLib: "NUMETAH G16%E PERF P.T500ML",
  UCD7: '9369273',
  UCD13: '3400893692738',
  ucdQtyMultiplicator: 6,
  cipLib: "NUMETAH G16%E PERF P.T500ML BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '4166252',
  CIP13: '3400941662522',
  ucdLib: "NUMETAH G19%E PERF P.T1000ML",
  UCD7: '9378243',
  UCD13: '3400893782439',
  ucdQtyMultiplicator: 6,
  cipLib: "NUMETAH G19%E PERF P.T1000ML BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '2160363',
  CIP13: '3400921603637',
  ucdLib: "PEDIAVEN AP-HP G25 BIO1L",
  UCD7: '9374587',
  UCD13: '3400893745878',
  ucdQtyMultiplicator: 4,
  cipLib: "PEDIAVEN AP-HP G25 BIO1L BT 4",
  atcCode: "B05BA10"
}, {
  CIP7: '2178771',
  CIP13: '3400921787719',
  ucdLib: "SMOFKABIVEN E PERF PTB493ML",
  UCD7: '9384189',
  UCD13: '3400893841891',
  ucdQtyMultiplicator: 6,
  cipLib: "SMOFKABIVEN E PERF PTB493ML BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '2683575',
  CIP13: '3400926835750',
  ucdLib: "SMOFKABIVEN PERF PTB493ML",
  UCD7: '9391781',
  UCD13: '3400893917817',
  ucdQtyMultiplicator: 6,
  cipLib: "SMOFKABIVEN PERF PTB493ML BT 6",
  atcCode: "B05BA10"
}, {
  CIP7: '5535438',
  CIP13: '3400955354383',
  ucdLib: "GLUCOSE 10% LAV INJ FV250ML",
  UCD7: '9039357',
  UCD13: '3400890393577',
  ucdQtyMultiplicator: 12,
  cipLib: "GLUCOSE 10% LAV INJ FV250ML BT 12",
  atcCode: "B05BA03"
}, {
  CIP7: '5535036',
  CIP13: '3400955350361',
  ucdLib: "GLUCOSE 30% LAV INJ FV1000ML",
  UCD7: '9116477',
  UCD13: '3400891164770',
  ucdQtyMultiplicator: 6,
  cipLib: "GLUCOSE 30% LAV INJ FV1000ML BT 6",
  atcCode: "B05BA03"
}, {
  CIP7: '5534887',
  CIP13: '3400955348870',
  ucdLib: "GLUCOSE 5% LAV INJ FV1000ML",
  UCD7: '9116690',
  UCD13: '3400891166903',
  ucdQtyMultiplicator: 6,
  cipLib: "GLUCOSE 5% LAV INJ FV1000ML BT 6",
  atcCode: "B05BA03"
}, {
  CIP7: '5534901',
  CIP13: '3400955349013',
  ucdLib: "GLUCOSE 5% LAV INJ FV250ML",
  UCD7: '9116715',
  UCD13: '3400891167153',
  ucdQtyMultiplicator: 12,
  cipLib: "GLUCOSE 5% LAV INJ FV250ML BT 12",
  atcCode: "B05BA03"
}, {
  CIP7: '5534893',
  CIP13: '3400955348931',
  ucdLib: "GLUCOSE 5% LAV INJ FV500ML",
  UCD7: '9039794',
  UCD13: '3400890397940',
  ucdQtyMultiplicator: 12,
  cipLib: "GLUCOSE 5% LAV INJ FV500ML BT 12",
  atcCode: "B05BA03"
}, {
  CIP7: '3458053',
  CIP13: '3400934580536',
  ucdLib: "GLUCOSE 50% BBM INJ FV500ML",
  UCD7: '9107656',
  UCD13: '3400891076561',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 50% BBM INJ FV500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3832178',
  CIP13: '3400938321784',
  ucdLib: "GLUCOSE 10% FKF INJ FP1000ML",
  UCD7: '9308283',
  UCD13: '3400893082836',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 10% FKF INJ FP1000ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3832103',
  CIP13: '3400938321036',
  ucdLib: "GLUCOSE 10% FKF INJ FP250ML",
  UCD7: '9308308',
  UCD13: '3400893083086',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 10% FKF INJ FP250ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3832149',
  CIP13: '3400938321494',
  ucdLib: "GLUCOSE 10% FKF INJ FP500ML",
  UCD7: '9308314',
  UCD13: '3400893083147',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 10% FKF INJ FP500ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3058419',
  CIP13: '3400930584194',
  ucdLib: "GLUCOSE 10% LAV INJ FV500ML",
  UCD7: '9114136',
  UCD13: '3400891141368',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% LAV INJ FV500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3058514',
  CIP13: '3400930585146',
  ucdLib: "GLUCOSE 30% LAV INJ FV250ML",
  UCD7: '9039535',
  UCD13: '3400890395359',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 30% LAV INJ FV250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3058543',
  CIP13: '3400930585436',
  ucdLib: "GLUCOSE 30% LAV INJ FV500ML",
  UCD7: '9116483',
  UCD13: '3400891164831',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 30% LAV INJ FV500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3618597',
  CIP13: '3400936185975',
  ucdLib: "GLUCOSE 5% BIOPERF POC1000ML",
  UCD7: '9255658',
  UCD13: '3400892556581',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% BIOPERF POC1000ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3618551',
  CIP13: '3400936185517',
  ucdLib: "GLUCOSE 5% BIOPERF POC100ML",
  UCD7: '9250738',
  UCD13: '3400892507385',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 5% BIOPERF POC100ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '3618574',
  CIP13: '3400936185746',
  ucdLib: "GLUCOSE 5% BIOPERF POC250ML",
  UCD7: '9250744',
  UCD13: '3400892507446',
  ucdQtyMultiplicator: 30,
  cipLib: "GLUCOSE 5% BIOPERF POC250ML BT 30",
  atcCode: "B05BA03"
}, {
  CIP7: '3618580',
  CIP13: '3400936185807',
  ucdLib: "GLUCOSE 5% BIOPERF POC500ML",
  UCD7: '9255670',
  UCD13: '3400892556703',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 5% BIOPERF POC500ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3832014',
  CIP13: '3400938320145',
  ucdLib: "GLUCOSE 5% FKF INJ FP1000ML",
  UCD7: '9307993',
  UCD13: '3400893079935',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% FKF INJ FP1000ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3831919',
  CIP13: '3400938319194',
  ucdLib: "GLUCOSE 5% FKF INJ FP100ML",
  UCD7: '9307987',
  UCD13: '3400893079874',
  ucdQtyMultiplicator: 40,
  cipLib: "GLUCOSE 5% FKF INJ FP100ML BT 40",
  atcCode: "B05BA03"
}, {
  CIP7: '3831948',
  CIP13: '3400938319484',
  ucdLib: "GLUCOSE 5% FKF INJ FP250ML",
  UCD7: '9308001',
  UCD13: '3400893080016',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 5% FKF INJ FP250ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3831977',
  CIP13: '3400938319774',
  ucdLib: "GLUCOSE 5% FKF INJ FP500ML",
  UCD7: '9308018',
  UCD13: '3400893080184',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% FKF INJ FP500ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3058589',
  CIP13: '3400930585894',
  ucdLib: "GLUCOSE 5% LAV INJ FV1000ML",
  UCD7: '9116690',
  UCD13: '3400891166903',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ FV1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3058595',
  CIP13: '3400930585955',
  ucdLib: "GLUCOSE 5% LAV INJ FV125ML",
  UCD7: '9116709',
  UCD13: '3400891167092',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ FV125ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3058632',
  CIP13: '3400930586327',
  ucdLib: "GLUCOSE 5% LAV INJ FV250ML",
  UCD7: '9116715',
  UCD13: '3400891167153',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ FV250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3058655',
  CIP13: '3400930586556',
  ucdLib: "GLUCOSE 5% LAV INJ FV500ML",
  UCD7: '9039794',
  UCD13: '3400890397940',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ FV500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3236387',
  CIP13: '3400932363872',
  ucdLib: "GLUCOSE 15% BSD INJ FV1000ML",
  UCD7: '9114142',
  UCD13: '3400891141429',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 15% BSD INJ FV1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3330850',
  CIP13: '3400933308506',
  ucdLib: "GLUCOSE 10% BLZ INJ P.1000ML",
  UCD7: '9128902',
  UCD13: '3400891289022',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% BLZ INJ P.1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3330838',
  CIP13: '3400933308384',
  ucdLib: "GLUCOSE 10% BLZ INJ P.250ML",
  UCD7: '9128919',
  UCD13: '3400891289190',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% BLZ INJ P.250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3330844',
  CIP13: '3400933308445',
  ucdLib: "GLUCOSE 10% BLZ INJ P.500ML",
  UCD7: '9128925',
  UCD13: '3400891289251',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% BLZ INJ P.500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3330790',
  CIP13: '3400933307905',
  ucdLib: "GLUCOSE 5% BLZ INJ P.1000ML",
  UCD7: '9128948',
  UCD13: '3400891289480',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BLZ INJ P.1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3330821',
  CIP13: '3400933308216',
  ucdLib: "GLUCOSE 5% BLZ INJ P.100ML",
  UCD7: '9128931',
  UCD13: '3400891289312',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BLZ INJ P.100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3330809',
  CIP13: '3400933308094',
  ucdLib: "GLUCOSE 5% BLZ INJ P.250ML",
  UCD7: '9128954',
  UCD13: '3400891289541',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BLZ INJ P.250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3330784',
  CIP13: '3400933307844',
  ucdLib: "GLUCOSE 5% BLZ INJ P.500ML",
  UCD7: '9128977',
  UCD13: '3400891289770',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BLZ INJ P.500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3330815',
  CIP13: '3400933308155',
  ucdLib: "GLUCOSE 5% BLZ INJ P.50ML",
  UCD7: '9128960',
  UCD13: '3400891289602',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BLZ INJ P.50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604750',
  CIP13: '3400936047501',
  ucdLib: "GLUCOSE 10% BAX INJ VFO1L",
  UCD7: '9248374',
  UCD13: '3400892483740',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 10% BAX INJ VFO1L BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3604744',
  CIP13: '3400936047440',
  ucdLib: "GLUCOSE 10% BAX INJ VFO500ML",
  UCD7: '9248405',
  UCD13: '3400892484051',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 10% BAX INJ VFO500ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3606720',
  CIP13: '3400936067202',
  ucdLib: "GLUCOSE 10% BBM INJ P.E1000ML",
  UCD7: '9179035',
  UCD13: '3400891790351',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% BBM INJ P.E1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606708',
  CIP13: '3400936067080',
  ucdLib: "GLUCOSE 10% BBM INJ P.E250ML 1",
  UCD7: '9202656',
  UCD13: '3400892026565',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% BBM INJ P.E250ML 1 BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606714',
  CIP13: '3400936067141',
  ucdLib: "GLUCOSE 10% BBM INJ P.E500ML",
  UCD7: '9179041',
  UCD13: '3400891790412',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% BBM INJ P.E500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604649',
  CIP13: '3400936046498',
  ucdLib: "GLUCOSE 10% MAC INJ P.1000ML",
  UCD7: '9131761',
  UCD13: '3400891317619',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P.1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604595',
  CIP13: '3400936045958',
  ucdLib: "GLUCOSE 10% MAC INJ P.100ML",
  UCD7: '9131755',
  UCD13: '3400891317558',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P.100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604626',
  CIP13: '3400936046269',
  ucdLib: "GLUCOSE 10% MAC INJ P.250ML",
  UCD7: '9131784',
  UCD13: '3400891317848',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P.250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604632',
  CIP13: '3400936046320',
  ucdLib: "GLUCOSE 10% MAC INJ P.500ML",
  UCD7: '9131809',
  UCD13: '3400891318098',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P.500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3604589',
  CIP13: '3400936045897',
  ucdLib: "GLUCOSE 10% MAC INJ P.50ML",
  UCD7: '9131790',
  UCD13: '3400891317909',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC INJ P.50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606950',
  CIP13: '3400936069503',
  ucdLib: "GLUCOSE 15% BBM INJ P.E1000ML",
  UCD7: '9179064',
  UCD13: '3400891790641',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 15% BBM INJ P.E1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606944',
  CIP13: '3400936069442',
  ucdLib: "GLUCOSE 15% BBM INJ P.E500ML",
  UCD7: '9179070',
  UCD13: '3400891790702',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 15% BBM INJ P.E500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606855',
  CIP13: '3400936068551',
  ucdLib: "GLUCOSE 2,5% BBM P.E1000ML",
  UCD7: '9189298',
  UCD13: '3400891892987',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5% BBM P.E1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606849',
  CIP13: '3400936068490',
  ucdLib: "GLUCOSE 2,5% BBM P.E500ML",
  UCD7: '9189306',
  UCD13: '3400891893069',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5% BBM P.E500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3607079',
  CIP13: '3400936070790',
  ucdLib: "GLUCOSE 30% BBM INJ P.E1000ML",
  UCD7: '9179101',
  UCD13: '3400891791013',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 30% BBM INJ P.E1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3607062',
  CIP13: '3400936070622',
  ucdLib: "GLUCOSE 30% BBM INJ P.E500ML",
  UCD7: '9179118',
  UCD13: '3400891791181',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 30% BBM INJ P.E500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606594',
  CIP13: '3400936065949',
  ucdLib: "GLUCOSE 5% BBM INJ P.E1000ML",
  UCD7: '9177987',
  UCD13: '3400891779875',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BBM INJ P.E1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606565',
  CIP13: '3400936065659',
  ucdLib: "GLUCOSE 5% BBM INJ P.E100ML",
  UCD7: '9189329',
  UCD13: '3400891893298',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BBM INJ P.E100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606571',
  CIP13: '3400936065710',
  ucdLib: "GLUCOSE 5% BBM INJ P.E250ML",
  UCD7: '9177993',
  UCD13: '3400891779936',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BBM INJ P.E250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606588',
  CIP13: '3400936065888',
  ucdLib: "GLUCOSE 5% BBM INJ P.E500ML",
  UCD7: '9178001',
  UCD13: '3400891780017',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BBM INJ P.E500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606559',
  CIP13: '3400936065598',
  ucdLib: "GLUCOSE 5% BBM INJ P.E50ML",
  UCD7: '9189335',
  UCD13: '3400891893359',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BBM INJ P.E50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606619',
  CIP13: '3400936066199',
  ucdLib: "GLUCOSE 5% BBM P.ES100ML",
  UCD7: '9225137',
  UCD13: '3400892251370',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BBM P.ES100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606625',
  CIP13: '3400936066250',
  ucdLib: "GLUCOSE 5% BBM P.ES250ML",
  UCD7: '9225166',
  UCD13: '3400892251660',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BBM P.ES250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3606631',
  CIP13: '3400936066311',
  ucdLib: "GLUCOSE 5% BBM P.ES500ML",
  UCD7: '9225189',
  UCD13: '3400892251899',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% BBM P.ES500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3522845',
  CIP13: '3400935228451',
  ucdLib: "GLUCOSE 5% MAC INJ P.1000ML",
  UCD7: '9132602',
  UCD13: '3400891326024',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ P.1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3522791',
  CIP13: '3400935227911',
  ucdLib: "GLUCOSE 5% MAC INJ P.100ML",
  UCD7: '9132594',
  UCD13: '3400891325942',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ P.100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3522822',
  CIP13: '3400935228222',
  ucdLib: "GLUCOSE 5% MAC INJ P.250ML",
  UCD7: '9132625',
  UCD13: '3400891326253',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ P.250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3522839',
  CIP13: '3400935228390',
  ucdLib: "GLUCOSE 5% MAC INJ P.500ML",
  UCD7: '9132648',
  UCD13: '3400891326482',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ P.500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3522785',
  CIP13: '3400935227850',
  ucdLib: "GLUCOSE 5% MAC INJ P.50ML",
  UCD7: '9132631',
  UCD13: '3400891326314',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ P.50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3676353',
  CIP13: '3400936763531',
  ucdLib: "GLUCOSE 10% FRF SIS-SEBS1L",
  UCD7: '9275069',
  UCD13: '3400892750699',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% FRF SIS-SEBS1L BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3676347',
  CIP13: '3400936763470',
  ucdLib: "GLUCOSE 10% FRF SIS-SEBS500ML",
  UCD7: '9275081',
  UCD13: '3400892750811',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% FRF SIS-SEBS500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3139827',
  CIP13: '3400931398271',
  ucdLib: "GLUCOSE 10% LAV INJ FV250ML",
  UCD7: '9039357',
  UCD13: '3400890393577',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% LAV INJ FV250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3676270',
  CIP13: '3400936762701',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS100ML",
  UCD7: '9279854',
  UCD13: '3400892798547',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3676301',
  CIP13: '3400936763012',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS1L",
  UCD7: '9275098',
  UCD13: '3400892750989',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS1L BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3676287',
  CIP13: '3400936762879',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS250ML",
  UCD7: '9279860',
  UCD13: '3400892798608',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3676293',
  CIP13: '3400936762930',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS500ML",
  UCD7: '9275106',
  UCD13: '3400892751061',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3676264',
  CIP13: '3400936762640',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS50ML",
  UCD7: '9279877',
  UCD13: '3400892798776',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3558381',
  CIP13: '3400935583819',
  ucdLib: "GLUCOSE 2,5% MAC INJ P.1000ML",
  UCD7: '9177958',
  UCD13: '3400891779585',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5% MAC INJ P.1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3558375',
  CIP13: '3400935583758',
  ucdLib: "GLUCOSE 2,5% MAC INJ P.500ML",
  UCD7: '9177970',
  UCD13: '3400891779707',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5% MAC INJ P.500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3551723',
  CIP13: '3400935517234',
  ucdLib: "GLUCOSE 5% BAX CFX500ML +V.",
  UCD7: '9210265',
  UCD13: '3400892102658',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 5% BAX CFX500ML +V. BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3563123',
  CIP13: '3400935631237',
  ucdLib: "GLUCOSE 5% MAC INJ PBL1000ML",
  UCD7: '9230032',
  UCD13: '3400892300320',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ PBL1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3563117',
  CIP13: '3400935631176',
  ucdLib: "GLUCOSE 5% MAC INJ PBL500ML",
  UCD7: '9230078',
  UCD13: '3400892300788',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ PBL500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561420',
  CIP13: '3400935614209',
  ucdLib: "GLUCOSE 5% MAC INJ PML1000ML",
  UCD7: '9230090',
  UCD13: '3400892300900',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ PML1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561377',
  CIP13: '3400935613776',
  ucdLib: "GLUCOSE 5% MAC INJ PML100ML",
  UCD7: '9230084',
  UCD13: '3400892300849',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ PML100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561408',
  CIP13: '3400935614087',
  ucdLib: "GLUCOSE 5% MAC INJ PML250ML",
  UCD7: '9230115',
  UCD13: '3400892301150',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ PML250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561414',
  CIP13: '3400935614148',
  ucdLib: "GLUCOSE 5% MAC INJ PML500ML",
  UCD7: '9230138',
  UCD13: '3400892301389',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ PML500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561354',
  CIP13: '3400935613547',
  ucdLib: "GLUCOSE 5% MAC INJ POC1000ML",
  UCD7: '9229968',
  UCD13: '3400892299686',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ POC1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561319',
  CIP13: '3400935613196',
  ucdLib: "GLUCOSE 5% MAC INJ POC100ML",
  UCD7: '9229951',
  UCD13: '3400892299518',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ POC100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561331',
  CIP13: '3400935613318',
  ucdLib: "GLUCOSE 5% MAC INJ POC250ML",
  UCD7: '9229980',
  UCD13: '3400892299808',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ POC250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561348',
  CIP13: '3400935613486',
  ucdLib: "GLUCOSE 5% MAC INJ POC500ML",
  UCD7: '9230003',
  UCD13: '3400892300030',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ POC500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3561302',
  CIP13: '3400935613028',
  ucdLib: "GLUCOSE 5% MAC INJ POC50ML",
  UCD7: '9229997',
  UCD13: '3400892299976',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC INJ POC50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3629945',
  CIP13: '3400936299450',
  ucdLib: "GLUCOSE 10% LAV INJ AB10ML",
  UCD7: '9261400',
  UCD13: '3400892614007',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 10% LAV INJ AB10ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3625746',
  CIP13: '3400936257467',
  ucdLib: "GLUCOSE 10% MAC P.FN1000ML",
  UCD7: '9258823',
  UCD13: '3400892588230',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC P.FN1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3625692',
  CIP13: '3400936256927',
  ucdLib: "GLUCOSE 10% MAC P.FN100ML",
  UCD7: '9258817',
  UCD13: '3400892588179',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC P.FN100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3625717',
  CIP13: '3400936257177',
  ucdLib: "GLUCOSE 10% MAC P.FN250ML",
  UCD7: '9258852',
  UCD13: '3400892588520',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC P.FN250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3625723',
  CIP13: '3400936257238',
  ucdLib: "GLUCOSE 10% MAC P.FN500ML",
  UCD7: '9258875',
  UCD13: '3400892588759',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC P.FN500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3625686',
  CIP13: '3400936256866',
  ucdLib: "GLUCOSE 10% MAC P.FN50ML",
  UCD7: '9258869',
  UCD13: '3400892588698',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% MAC P.FN50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3593532',
  CIP13: '3400935935328',
  ucdLib: "GLUCOSE 20% BBM INJ P.E500ML",
  UCD7: '9238921',
  UCD13: '3400892389219',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 20% BBM INJ P.E500ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3629968',
  CIP13: '3400936299689',
  ucdLib: "GLUCOSE 30% LAV INJ AB10ML",
  UCD7: '9272295',
  UCD13: '3400892722955',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 30% LAV INJ AB10ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3629974',
  CIP13: '3400936299740',
  ucdLib: "GLUCOSE 30% LAV INJ AB20ML",
  UCD7: '9272303',
  UCD13: '3400892723037',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 30% LAV INJ AB20ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3512479',
  CIP13: '3400935124791',
  ucdLib: "GLUCOSE 5% CPF INJ FV1000ML",
  UCD7: '9218367',
  UCD13: '3400892183671',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% CPF INJ FV1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3512456',
  CIP13: '3400935124562',
  ucdLib: "GLUCOSE 5% CPF INJ FV250ML",
  UCD7: '9218373',
  UCD13: '3400892183732',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% CPF INJ FV250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3512462',
  CIP13: '3400935124623',
  ucdLib: "GLUCOSE 5% CPF INJ FV500ML",
  UCD7: '9218396',
  UCD13: '3400892183961',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% CPF INJ FV500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3480673',
  CIP13: '3400934806735',
  ucdLib: "GLUCOSE 5% FMC INJ P.BX500ML",
  UCD7: '9207323',
  UCD13: '3400892073231',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FMC INJ P.BX500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3629922',
  CIP13: '3400936299221',
  ucdLib: "GLUCOSE 5% LAV INJ AB10ML",
  UCD7: '9272326',
  UCD13: '3400892723266',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% LAV INJ AB10ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3629939',
  CIP13: '3400936299399',
  ucdLib: "GLUCOSE 5% LAV INJ AB20ML",
  UCD7: '9272332',
  UCD13: '3400892723327',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% LAV INJ AB20ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3595778',
  CIP13: '3400935957788',
  ucdLib: "GLUCOSE 5% VIAFLO POC1000ML",
  UCD7: '9260375',
  UCD13: '3400892603759',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% VIAFLO POC1000ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3595732',
  CIP13: '3400935957320',
  ucdLib: "GLUCOSE 5% VIAFLO POC100ML",
  UCD7: '9260369',
  UCD13: '3400892603698',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 5% VIAFLO POC100ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '3595755',
  CIP13: '3400935957559',
  ucdLib: "GLUCOSE 5% VIAFLO POC250ML",
  UCD7: '9260398',
  UCD13: '3400892603988',
  ucdQtyMultiplicator: 30,
  cipLib: "GLUCOSE 5% VIAFLO POC250ML BT 30",
  atcCode: "B05BA03"
}, {
  CIP7: '3595761',
  CIP13: '3400935957610',
  ucdLib: "GLUCOSE 5% VIAFLO POC500ML",
  UCD7: '9260412',
  UCD13: '3400892604121',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 5% VIAFLO POC500ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3595726',
  CIP13: '3400935957269',
  ucdLib: "GLUCOSE 5% VIAFLO POC50ML",
  UCD7: '9260406',
  UCD13: '3400892604060',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 5% VIAFLO POC50ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '3625309',
  CIP13: '3400936253094',
  ucdLib: "GLUCOSE 50% MAC P.DEHP1000ML",
  UCD7: '9260978',
  UCD13: '3400892609782',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 50% MAC P.DEHP1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3542664',
  CIP13: '3400935426642',
  ucdLib: "GLUCOSE 5% LAV INJ POC1000ML",
  UCD7: '9226102',
  UCD13: '3400892261027',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ POC1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3542552',
  CIP13: '3400935425522',
  ucdLib: "GLUCOSE 5% LAV INJ POC100ML",
  UCD7: '9226094',
  UCD13: '3400892260945',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ POC100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3542581',
  CIP13: '3400935425812',
  ucdLib: "GLUCOSE 5% LAV INJ POC250ML",
  UCD7: '9226119',
  UCD13: '3400892261195',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ POC250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3542629',
  CIP13: '3400935426291',
  ucdLib: "GLUCOSE 5% LAV INJ POC500ML",
  UCD7: '9226131',
  UCD13: '3400892261317',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ POC500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3542517',
  CIP13: '3400935425171',
  ucdLib: "GLUCOSE 5% LAV INJ POC50ML",
  UCD7: '9226125',
  UCD13: '3400892261256',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ POC50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3717431',
  CIP13: '3400937174312',
  ucdLib: "GLUCOSE 10% PROAMP AMP10ML",
  UCD7: '9281271',
  UCD13: '3400892812717',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 10% PROAMP AMP10ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '3794199',
  CIP13: '3400937941990',
  ucdLib: "GLUCOSE 15% MAC P.FNS1000ML",
  UCD7: '9306226',
  UCD13: '3400893062265',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 15% MAC P.FNS1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3794182',
  CIP13: '3400937941822',
  ucdLib: "GLUCOSE 15% MAC P.FNS500ML",
  UCD7: '9306249',
  UCD13: '3400893062494',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 15% MAC P.FNS500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3794288',
  CIP13: '3400937942881',
  ucdLib: "GLUCOSE 20% MAC P.FNS1000ML",
  UCD7: '9382612',
  UCD13: '3400893826126',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 20% MAC P.FNS1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3794271',
  CIP13: '3400937942713',
  ucdLib: "GLUCOSE 20% MAC P.FNS500ML",
  UCD7: '9304782',
  UCD13: '3400893047828',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 20% MAC P.FNS500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3794242',
  CIP13: '3400937942423',
  ucdLib: "GLUCOSE 30% MAC P.FNS1000ML",
  UCD7: '9382078',
  UCD13: '3400893820780',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 30% MAC P.FNS1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3794207',
  CIP13: '3400937942072',
  ucdLib: "GLUCOSE 30% MAC P.FNS100ML",
  UCD7: '9382061',
  UCD13: '3400893820612',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 30% MAC P.FNS100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3794213',
  CIP13: '3400937942133',
  ucdLib: "GLUCOSE 30% MAC P.FNS250ML",
  UCD7: '9304799',
  UCD13: '3400893047996',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 30% MAC P.FNS250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3794236',
  CIP13: '3400937942362',
  ucdLib: "GLUCOSE 30% MAC P.FNS500ML",
  UCD7: '9304807',
  UCD13: '3400893048078',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 30% MAC P.FNS500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3717477',
  CIP13: '3400937174770',
  ucdLib: "GLUCOSE 30% PROAMP AMP10ML",
  UCD7: '9281288',
  UCD13: '3400892812885',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 30% PROAMP AMP10ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '3717359',
  CIP13: '3400937173599',
  ucdLib: "GLUCOSE 5% PROAMP AMP10ML",
  UCD7: '9281294',
  UCD13: '3400892812946',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 5% PROAMP AMP10ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '3717388',
  CIP13: '3400937173889',
  ucdLib: "GLUCOSE 5% PROAMP AMP20ML",
  UCD7: '9281302',
  UCD13: '3400892813028',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 5% PROAMP AMP20ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '3794360',
  CIP13: '3400937943604',
  ucdLib: "GLUCOSE 50% MAC P.FNS1000ML",
  UCD7: '9382635',
  UCD13: '3400893826355',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 50% MAC P.FNS1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3794354',
  CIP13: '3400937943543',
  ucdLib: "GLUCOSE 50% MAC P.FNS500ML",
  UCD7: '9304813',
  UCD13: '3400893048139',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 50% MAC P.FNS500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3758097',
  CIP13: '3400937580977',
  ucdLib: "GLUCOSE 2,5% MAC P.FS1000ML",
  UCD7: '9298047',
  UCD13: '3400892980478',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5% MAC P.FS1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3758080',
  CIP13: '3400937580809',
  ucdLib: "GLUCOSE 2,5% MAC P.FS500ML",
  UCD7: '9298076',
  UCD13: '3400892980768',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 2,5% MAC P.FS500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3802869',
  CIP13: '3400938028690',
  ucdLib: "GLUCOSE 5% MAC P.EASY100ML",
  UCD7: '9307409',
  UCD13: '3400893074091',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3802898',
  CIP13: '3400938028980',
  ucdLib: "GLUCOSE 5% MAC P.EASY1L",
  UCD7: '9307415',
  UCD13: '3400893074152',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY1L BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3802875',
  CIP13: '3400938028751',
  ucdLib: "GLUCOSE 5% MAC P.EASY250ML",
  UCD7: '9307421',
  UCD13: '3400893074213',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3802881',
  CIP13: '3400938028812',
  ucdLib: "GLUCOSE 5% MAC P.EASY500ML",
  UCD7: '9307444',
  UCD13: '3400893074442',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3802852',
  CIP13: '3400938028522',
  ucdLib: "GLUCOSE 5% MAC P.EASY50ML",
  UCD7: '9307438',
  UCD13: '3400893074381',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5647769',
  CIP13: '3400956477692',
  ucdLib: "GLUCOSE 10% LAV INJ AB10ML",
  UCD7: '9261400',
  UCD13: '3400892614007',
  ucdQtyMultiplicator: 100,
  cipLib: "GLUCOSE 10% LAV INJ AB10ML BT 100",
  atcCode: "B05BA03"
}, {
  CIP7: '5639043',
  CIP13: '3400956390434',
  ucdLib: "GLUCOSE 2,5% VIAFLO POC500ML",
  UCD7: '9248411',
  UCD13: '3400892484112',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 2,5% VIAFLO POC500ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '5647781',
  CIP13: '3400956477814',
  ucdLib: "GLUCOSE 30% LAV INJ AB10ML",
  UCD7: '9272295',
  UCD13: '3400892722955',
  ucdQtyMultiplicator: 100,
  cipLib: "GLUCOSE 30% LAV INJ AB10ML BT 100",
  atcCode: "B05BA03"
}, {
  CIP7: '5647798',
  CIP13: '3400956477982',
  ucdLib: "GLUCOSE 30% LAV INJ AB20ML",
  UCD7: '9272303',
  UCD13: '3400892723037',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 30% LAV INJ AB20ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '5647746',
  CIP13: '3400956477463',
  ucdLib: "GLUCOSE 5% LAV INJ AB10ML",
  UCD7: '9272326',
  UCD13: '3400892723266',
  ucdQtyMultiplicator: 100,
  cipLib: "GLUCOSE 5% LAV INJ AB10ML BT 100",
  atcCode: "B05BA03"
}, {
  CIP7: '5647752',
  CIP13: '3400956477524',
  ucdLib: "GLUCOSE 5% LAV INJ AB20ML",
  UCD7: '9272332',
  UCD13: '3400892723327',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 5% LAV INJ AB20ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '3909797',
  CIP13: '3400939097978',
  ucdLib: "GLUCOSE 5% LAV INJ FP1000ML",
  UCD7: '9326588',
  UCD13: '3400893265888',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ FP1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3909805',
  CIP13: '3400939098050',
  ucdLib: "GLUCOSE 5% LAV INJ FP1000ML",
  UCD7: '9326588',
  UCD13: '3400893265888',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% LAV INJ FP1000ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3909745',
  CIP13: '3400939097459',
  ucdLib: "GLUCOSE 5% LAV INJ FP100ML",
  UCD7: '9326571',
  UCD13: '3400893265710',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% LAV INJ FP100ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3909751',
  CIP13: '3400939097510',
  ucdLib: "GLUCOSE 5% LAV INJ FP250ML",
  UCD7: '9326594',
  UCD13: '3400893265949',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ FP250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3909768',
  CIP13: '3400939097688',
  ucdLib: "GLUCOSE 5% LAV INJ FP250ML",
  UCD7: '9326594',
  UCD13: '3400893265949',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% LAV INJ FP250ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '3909774',
  CIP13: '3400939097749',
  ucdLib: "GLUCOSE 5% LAV INJ FP500ML",
  UCD7: '9326602',
  UCD13: '3400893266021',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% LAV INJ FP500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3909780',
  CIP13: '3400939097800',
  ucdLib: "GLUCOSE 5% LAV INJ FP500ML",
  UCD7: '9326602',
  UCD13: '3400893266021',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% LAV INJ FP500ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '4975158',
  CIP13: '3400949751587',
  ucdLib: "GLUCOSE 5% MAC P.EASY+1000ML",
  UCD7: '9368262',
  UCD13: '3400893682623',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY+1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4975129',
  CIP13: '3400949751297',
  ucdLib: "GLUCOSE 5% MAC P.EASY+100ML",
  UCD7: '9368256',
  UCD13: '3400893682562',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY+100ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4975135',
  CIP13: '3400949751358',
  ucdLib: "GLUCOSE 5% MAC P.EASY+250ML",
  UCD7: '9368279',
  UCD13: '3400893682791',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY+250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4975141',
  CIP13: '3400949751419',
  ucdLib: "GLUCOSE 5% MAC P.EASY+500ML",
  UCD7: '9368291',
  UCD13: '3400893682913',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY+500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4975112',
  CIP13: '3400949751129',
  ucdLib: "GLUCOSE 5% MAC P.EASY+50ML",
  UCD7: '9368285',
  UCD13: '3400893682852',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% MAC P.EASY+50ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3980370',
  CIP13: '3400939803708',
  ucdLib: "GLUCOSE 10% LAV INJ PP1000ML",
  UCD7: '9343227',
  UCD13: '3400893432273',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% LAV INJ PP1000ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3980329',
  CIP13: '3400939803296',
  ucdLib: "GLUCOSE 10% LAV INJ PP250ML",
  UCD7: '9343233',
  UCD13: '3400893432334',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% LAV INJ PP250ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '3980341',
  CIP13: '3400939803418',
  ucdLib: "GLUCOSE 10% LAV INJ PP500ML",
  UCD7: '9343256',
  UCD13: '3400893432563',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 10% LAV INJ PP500ML BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4157276',
  CIP13: '3400941572760',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS 1L +L",
  UCD7: '9371910',
  UCD13: '3400893719107',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS 1L +L BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4157230',
  CIP13: '3400941572302',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS100ML+L",
  UCD7: '9371904',
  UCD13: '3400893719046',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS100ML+L BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4157247',
  CIP13: '3400941572470',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS250ML+L",
  UCD7: '9371927',
  UCD13: '3400893719275',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS250ML+L BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4157253',
  CIP13: '3400941572531',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS500ML+L",
  UCD7: '9371956',
  UCD13: '3400893719565',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS500ML+L BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '4157224',
  CIP13: '3400941572241',
  ucdLib: "GLUCOSE 5% FRF SIS-SEBS50ML +L",
  UCD7: '9371933',
  UCD13: '3400893719336',
  ucdQtyMultiplicator: 1,
  cipLib: "GLUCOSE 5% FRF SIS-SEBS50ML +L BT 1",
  atcCode: "B05BA03"
}, {
  CIP7: '5749872',
  CIP13: '3400957498726',
  ucdLib: "GLUCOSE 2,5% VIAFLO P.1000ML",
  UCD7: '9331684',
  UCD13: '3400893316849',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 2,5% VIAFLO P.1000ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '5758322',
  CIP13: '3400957583224',
  ucdLib: "GLUCOSE 5% BBM INJ P.E1000ML",
  UCD7: '9177987',
  UCD13: '3400891779875',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% BBM INJ P.E1000ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '5758339',
  CIP13: '3400957583392',
  ucdLib: "GLUCOSE 5% BBM INJ P.E100ML",
  UCD7: '9189329',
  UCD13: '3400891893298',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 5% BBM INJ P.E100ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '5758345',
  CIP13: '3400957583453',
  ucdLib: "GLUCOSE 5% BBM INJ P.E250ML",
  UCD7: '9177993',
  UCD13: '3400891779936',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 5% BBM INJ P.E250ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '5758316',
  CIP13: '3400957583163',
  ucdLib: "GLUCOSE 5% BBM INJ P.E500ML",
  UCD7: '9178001',
  UCD13: '3400891780017',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 5% BBM INJ P.E500ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '2189680',
  CIP13: '3400921896800',
  ucdLib: "GLUCOSE 5% FKF FP100/50ML 40",
  UCD7: '9374736',
  UCD13: '3400893747360',
  ucdQtyMultiplicator: 40,
  cipLib: "GLUCOSE 5% FKF FP100/50ML 40 BT 40",
  atcCode: "B05BA03"
}, {
  CIP7: '5672023',
  CIP13: '3400956720231',
  ucdLib: "GLUCOSE 30% REN INJ A.B10ML",
  UCD7: '9280857',
  UCD13: '3400892808574',
  ucdQtyMultiplicator: 100,
  cipLib: "GLUCOSE 30% REN INJ A.B10ML BT 100",
  atcCode: "B05BA03"
}, {
  CIP7: '5680399',
  CIP13: '3400956803996',
  ucdLib: "GLUCOSE 30% REN INJ A.B20ML",
  UCD7: '9280863',
  UCD13: '3400892808635',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 30% REN INJ A.B20ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '5671897',
  CIP13: '3400956718979',
  ucdLib: "GLUCOSE 5% REN INJ A.B10ML",
  UCD7: '9280745',
  UCD13: '3400892807454',
  ucdQtyMultiplicator: 100,
  cipLib: "GLUCOSE 5% REN INJ A.B10ML BT 100",
  atcCode: "B05BA03"
}, {
  CIP7: '5680465',
  CIP13: '3400956804658',
  ucdLib: "GLUCOSE 50% REN INJ A.B20ML",
  UCD7: '9310765',
  UCD13: '3400893107652',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOSE 50% REN INJ A.B20ML BT 50",
  atcCode: "B05BA03"
}, {
  CIP7: '5762045',
  CIP13: '3400957620455',
  ucdLib: "GLUCOSE 10% LAV INJ PP1000ML",
  UCD7: '9343227',
  UCD13: '3400893432273',
  ucdQtyMultiplicator: 10,
  cipLib: "GLUCOSE 10% LAV INJ PP1000ML BT 10",
  atcCode: "B05BA03"
}, {
  CIP7: '5761985',
  CIP13: '3400957619855',
  ucdLib: "GLUCOSE 10% LAV INJ PP250ML",
  UCD7: '9343233',
  UCD13: '3400893432334',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 10% LAV INJ PP250ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '5762022',
  CIP13: '3400957620226',
  ucdLib: "GLUCOSE 10% LAV INJ PP500ML",
  UCD7: '9343256',
  UCD13: '3400893432563',
  ucdQtyMultiplicator: 20,
  cipLib: "GLUCOSE 10% LAV INJ PP500ML BT 20",
  atcCode: "B05BA03"
}, {
  CIP7: '5764618',
  CIP13: '3400957646189',
  ucdLib: "GLUCOSE 5% LAV FV250ML/125ML",
  UCD7: '9348012',
  UCD13: '3400893480120',
  ucdQtyMultiplicator: 12,
  cipLib: "GLUCOSE 5% LAV FV250ML/125ML BT 12",
  atcCode: "B05BA03"
}, {
  CIP7: '5565391',
  CIP13: '3400955653912',
  ucdLib: "MEDIALIPIDE 20% INJ FV100ML",
  UCD7: '9137120',
  UCD13: '3400891371208',
  ucdQtyMultiplicator: 1,
  cipLib: "MEDIALIPIDE 20% INJ FV100ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '5565416',
  CIP13: '3400955654162',
  ucdLib: "MEDIALIPIDE 20% INJ FV250ML",
  UCD7: '9137143',
  UCD13: '3400891371437',
  ucdQtyMultiplicator: 1,
  cipLib: "MEDIALIPIDE 20% INJ FV250ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '5565422',
  CIP13: '3400955654223',
  ucdLib: "MEDIALIPIDE 20% INJ FV500ML",
  UCD7: '9137166',
  UCD13: '3400891371666',
  ucdQtyMultiplicator: 1,
  cipLib: "MEDIALIPIDE 20% INJ FV500ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3550965',
  CIP13: '3400935509659',
  ucdLib: "INTRALIPIDE 20% INJ POC100ML",
  UCD7: '9222274',
  UCD13: '3400892222745',
  ucdQtyMultiplicator: 1,
  cipLib: "INTRALIPIDE 20% INJ POC100ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3550971',
  CIP13: '3400935509710',
  ucdLib: "INTRALIPIDE 20% INJ POC250ML",
  UCD7: '9222280',
  UCD13: '3400892222806',
  ucdQtyMultiplicator: 1,
  cipLib: "INTRALIPIDE 20% INJ POC250ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3482301',
  CIP13: '3400934823015',
  ucdLib: "INTRALIPIDE 30% INJ POC333ML",
  UCD7: '9222311',
  UCD13: '3400892223117',
  ucdQtyMultiplicator: 1,
  cipLib: "INTRALIPIDE 30% INJ POC333ML BT 1",
  atcCode: "B05BA02"
}, {
  CIP7: '3486457',
  CIP13: '3400934864575',
  ucdLib: "OMEGAVEN PERF FL100ML",
  UCD7: '9211336',
  UCD13: '3400892113364',
  ucdQtyMultiplicator: 10,
  cipLib: "OMEGAVEN PERF FL100ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '3486440',
  CIP13: '3400934864407',
  ucdLib: "OMEGAVEN PERF FL50ML",
  UCD7: '9211342',
  UCD13: '3400892113425',
  ucdQtyMultiplicator: 10,
  cipLib: "OMEGAVEN PERF FL50ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '3585923',
  CIP13: '3400935859235',
  ucdLib: "CLINOLEIC 20% PERF P.100ML",
  UCD7: '9239033',
  UCD13: '3400892390338',
  ucdQtyMultiplicator: 24,
  cipLib: "CLINOLEIC 20% PERF P.100ML BT 24",
  atcCode: "B05BA02"
}, {
  CIP7: '3585946',
  CIP13: '3400935859464',
  ucdLib: "CLINOLEIC 20% PERF P.250ML",
  UCD7: '9239062',
  UCD13: '3400892390628',
  ucdQtyMultiplicator: 20,
  cipLib: "CLINOLEIC 20% PERF P.250ML BT 20",
  atcCode: "B05BA02"
}, {
  CIP7: '3585969',
  CIP13: '3400935859693',
  ucdLib: "CLINOLEIC 20% PERF P.500ML",
  UCD7: '9239085',
  UCD13: '3400892390857',
  ucdQtyMultiplicator: 10,
  cipLib: "CLINOLEIC 20% PERF P.500ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '3669206',
  CIP13: '3400936692060',
  ucdLib: "LIPIDEM 200MG/ML INJ FL250ML",
  UCD7: '9293073',
  UCD13: '3400892930732',
  ucdQtyMultiplicator: 10,
  cipLib: "LIPIDEM 200MG/ML INJ FL250ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '3669229',
  CIP13: '3400936692299',
  ucdLib: "LIPIDEM 200MG/ML INJ FL500ML",
  UCD7: '9293096',
  UCD13: '3400892930961',
  ucdQtyMultiplicator: 10,
  cipLib: "LIPIDEM 200MG/ML INJ FL500ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '3760007',
  CIP13: '3400937600071',
  ucdLib: "SMOFLIPID 200MG/ML IV F250ML",
  UCD7: '9308975',
  UCD13: '3400893089750',
  ucdQtyMultiplicator: 10,
  cipLib: "SMOFLIPID 200MG/ML IV F250ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '3760013',
  CIP13: '3400937600132',
  ucdLib: "SMOFLIPID 200MG/ML IV F500ML",
  UCD7: '9312729',
  UCD13: '3400893127292',
  ucdQtyMultiplicator: 10,
  cipLib: "SMOFLIPID 200MG/ML IV F500ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '3759990',
  CIP13: '3400937599900',
  ucdLib: "SMOFLIPID 200MG/ML IV F100ML",
  UCD7: '9312712',
  UCD13: '3400893127124',
  ucdQtyMultiplicator: 10,
  cipLib: "SMOFLIPID 200MG/ML IV F100ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '5838475',
  CIP13: '3400958384752',
  ucdLib: "INTRALIPIDE 10% INJ PBC500ML",
  UCD7: '9391700',
  UCD13: '3400893917008',
  ucdQtyMultiplicator: 12,
  cipLib: "INTRALIPIDE 10% INJ PBC500ML BT 12",
  atcCode: "B05BA02"
}, {
  CIP7: '5838481',
  CIP13: '3400958384813',
  ucdLib: "INTRALIPIDE 20% INJ PBC100ML",
  UCD7: '9391717',
  UCD13: '3400893917176',
  ucdQtyMultiplicator: 10,
  cipLib: "INTRALIPIDE 20% INJ PBC100ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '5838498',
  CIP13: '3400958384981',
  ucdLib: "INTRALIPIDE 20% INJ PBC250ML",
  UCD7: '9391723',
  UCD13: '3400893917237',
  ucdQtyMultiplicator: 10,
  cipLib: "INTRALIPIDE 20% INJ PBC250ML BT 10",
  atcCode: "B05BA02"
}, {
  CIP7: '5838506',
  CIP13: '3400958385063',
  ucdLib: "INTRALIPIDE 20% INJ PBC500ML",
  UCD7: '9391746',
  UCD13: '3400893917466',
  ucdQtyMultiplicator: 12,
  cipLib: "INTRALIPIDE 20% INJ PBC500ML BT 12",
  atcCode: "B05BA02"
}, {
  CIP7: '3299809',
  CIP13: '3400932998098',
  ucdLib: "VAMINOLACT PERF FV1000ML",
  UCD7: '9123715',
  UCD13: '3400891237153',
  ucdQtyMultiplicator: 1,
  cipLib: "VAMINOLACT PERF FV1000ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '3299761',
  CIP13: '3400932997619',
  ucdLib: "VAMINOLACT PERF FV100ML",
  UCD7: '9123709',
  UCD13: '3400891237092',
  ucdQtyMultiplicator: 1,
  cipLib: "VAMINOLACT PERF FV100ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '3299784',
  CIP13: '3400932997848',
  ucdLib: "VAMINOLACT PERF FV500ML",
  UCD7: '9123738',
  UCD13: '3400891237382',
  ucdQtyMultiplicator: 1,
  cipLib: "VAMINOLACT PERF FV500ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '3272532',
  CIP13: '3400932725328',
  ucdLib: "VINTENE INJ FV250ML",
  UCD7: '9098897',
  UCD13: '3400890988971',
  ucdQtyMultiplicator: 1,
  cipLib: "VINTENE INJ FV250ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '3237151',
  CIP13: '3400932371518',
  ucdLib: "VINTENE INJ FV1000ML",
  UCD7: '9116052',
  UCD13: '3400891160529',
  ucdQtyMultiplicator: 1,
  cipLib: "VINTENE INJ FV1000ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '3231970',
  CIP13: '3400932319701',
  ucdLib: "VINTENE INJ FV500ML",
  UCD7: '9116075',
  UCD13: '3400891160758',
  ucdQtyMultiplicator: 1,
  cipLib: "VINTENE INJ FV500ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '5571322',
  CIP13: '3400955713227',
  ucdLib: "HYPERAMINE 20 PERF FL250ML",
  UCD7: '9149376',
  UCD13: '3400891493764',
  ucdQtyMultiplicator: 1,
  cipLib: "HYPERAMINE 20 PERF FL250ML BT 1",
  atcCode: "B05BA01"
}, {
  CIP7: '3698426',
  CIP13: '3400936984264',
  ucdLib: "AMINOPLASMAL 12 INJ FL500ML",
  UCD7: '9365068',
  UCD13: '3400893650684',
  ucdQtyMultiplicator: 10,
  cipLib: "AMINOPLASMAL 12 INJ FL500ML BT 10",
  atcCode: "B05BA01"
}, {
  CIP7: '3698389',
  CIP13: '3400936983892',
  ucdLib: "AMINOPLASMAL 8 INJ FL500ML",
  UCD7: '9365074',
  UCD13: '3400893650745',
  ucdQtyMultiplicator: 10,
  cipLib: "AMINOPLASMAL 8 INJ FL500ML BT 10",
  atcCode: "B05BA01"
}, {
  CIP7: '5733523',
  CIP13: '3400957335236',
  ucdLib: "PRIMENE 10% INJ FV100ML",
  UCD7: '9107099',
  UCD13: '3400891070996',
  ucdQtyMultiplicator: 20,
  cipLib: "PRIMENE 10% INJ FV100ML BT 20",
  atcCode: "B05BA01"
}, {
  CIP7: '5733546',
  CIP13: '3400957335465',
  ucdLib: "PRIMENE 10% INJ FV250ML",
  UCD7: '9112002',
  UCD13: '3400891120028',
  ucdQtyMultiplicator: 10,
  cipLib: "PRIMENE 10% INJ FV250ML BT 10",
  atcCode: "B05BA01"
}, {
  CIP7: '3838442',
  CIP13: '3400938384420',
  ucdLib: "RESTORVOL 6% PERF ECB500ML",
  UCD7: '9310713',
  UCD13: '3400893107133',
  ucdQtyMultiplicator: 20,
  cipLib: "RESTORVOL 6% PERF ECB500ML BT 20",
  atcCode: "B05AA07"
}, {
  CIP7: '3605175',
  CIP13: '3400936051751',
  ucdLib: "HYPERHES PERF POC250ML",
  UCD7: '9249480',
  UCD13: '3400892494807',
  ucdQtyMultiplicator: 1,
  cipLib: "HYPERHES PERF POC250ML BT 1",
  atcCode: "B05AA07"
}, {
  CIP7: '3674041',
  CIP13: '3400936740419',
  ucdLib: "VOLUVEN PERF SIS-SEBS500ML",
  UCD7: '9309288',
  UCD13: '3400893092880',
  ucdQtyMultiplicator: 1,
  cipLib: "VOLUVEN PERF SIS-SEBS500ML BT 1",
  atcCode: "B05AA07"
}, {
  CIP7: '3907798',
  CIP13: '3400939077987',
  ucdLib: "HYPERHES PERF POC250ML",
  UCD7: '9249480',
  UCD13: '3400892494807',
  ucdQtyMultiplicator: 30,
  cipLib: "HYPERHES PERF POC250ML BT 30",
  atcCode: "B05AA07"
}, {
  CIP7: '2184292',
  CIP13: '3400921842920',
  ucdLib: "ISOVOL 6% SOL PERF POC500ML",
  UCD7: '9384433',
  UCD13: '3400893844335',
  ucdQtyMultiplicator: 20,
  cipLib: "ISOVOL 6% SOL PERF POC500ML BT 20",
  atcCode: "B05AA07"
}, {
  CIP7: '5630912',
  CIP13: '3400956309122',
  ucdLib: "GELOFUSINE 40MG/ML P.ES500ML",
  UCD7: '9224652',
  UCD13: '3400892246529',
  ucdQtyMultiplicator: 20,
  cipLib: "GELOFUSINE 40MG/ML P.ES500ML BT 20",
  atcCode: "B05AA06"
}, {
  CIP7: '4199978',
  CIP13: '3400941999789',
  ucdLib: "GELASPAN SOL PERF POC500ML",
  UCD7: '9384545',
  UCD13: '3400893845455',
  ucdQtyMultiplicator: 20,
  cipLib: "GELASPAN SOL PERF POC500ML BT 20",
  atcCode: "B05AA06"
}, {
  CIP7: '5793873',
  CIP13: '3400957938734',
  ucdLib: "PLASMION INJ POC FFX500ML",
  UCD7: '9369037',
  UCD13: '3400893690376',
  ucdQtyMultiplicator: 20,
  cipLib: "PLASMION INJ POC FFX500ML BT 20",
  atcCode: "B05AA06"
}, {
  CIP7: '5645084',
  CIP13: '3400956450848',
  ucdLib: "VIALEBEX 200MG/ML BB. FV10ML",
  UCD7: '9246116',
  UCD13: '3400892461168',
  ucdQtyMultiplicator: 1,
  cipLib: "VIALEBEX 200MG/ML BB. FV10ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5644699',
  CIP13: '3400956446995',
  ucdLib: "VIALEBEX 200MG/ML INJ FV100ML",
  UCD7: '9243419',
  UCD13: '3400892434193',
  ucdQtyMultiplicator: 1,
  cipLib: "VIALEBEX 200MG/ML INJ FV100ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5645078',
  CIP13: '3400956450787',
  ucdLib: "VIALEBEX 200MG/ML INJ FV50ML",
  UCD7: '9243425',
  UCD13: '3400892434254',
  ucdQtyMultiplicator: 1,
  cipLib: "VIALEBEX 200MG/ML INJ FV50ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5644653',
  CIP13: '3400956446537',
  ucdLib: "VIALEBEX 40MG/ML INJ FV100ML",
  UCD7: '9243431',
  UCD13: '3400892434315',
  ucdQtyMultiplicator: 1,
  cipLib: "VIALEBEX 40MG/ML INJ FV100ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5644676',
  CIP13: '3400956446766',
  ucdLib: "VIALEBEX 40MG/ML INJ FV250ML",
  UCD7: '9243448',
  UCD13: '3400892434483',
  ucdQtyMultiplicator: 1,
  cipLib: "VIALEBEX 40MG/ML INJ FV250ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5644682',
  CIP13: '3400956446827',
  ucdLib: "VIALEBEX 40MG/ML INJ FV500ML",
  UCD7: '9243454',
  UCD13: '3400892434544',
  ucdQtyMultiplicator: 1,
  cipLib: "VIALEBEX 40MG/ML INJ FV500ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5704711',
  CIP13: '3400957047115',
  ucdLib: "ALBUMINE H. BSC 200G/L 100ML",
  UCD7: '9297303',
  UCD13: '3400892973036',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUMINE H. BSC 200G/L 100ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5704697',
  CIP13: '3400957046972',
  ucdLib: "ALBUMINE H. BSC 200G/L 50ML",
  UCD7: '9297326',
  UCD13: '3400892973265',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUMINE H. BSC 200G/L 50ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5750875',
  CIP13: '3400957508753',
  ucdLib: "ALBUNORM 20% PERF FL100ML",
  UCD7: '9338195',
  UCD13: '3400893381953',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUNORM 20% PERF FL100ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5750852',
  CIP13: '3400957508524',
  ucdLib: "ALBUNORM 20% PERF FL50ML",
  UCD7: '9338203',
  UCD13: '3400893382035',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUNORM 20% PERF FL50ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5750792',
  CIP13: '3400957507923',
  ucdLib: "ALBUNORM 5% PERF FL100ML",
  UCD7: '9338858',
  UCD13: '3400893388587',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUNORM 5% PERF FL100ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5750817',
  CIP13: '3400957508173',
  ucdLib: "ALBUNORM 5% PERF FL250ML",
  UCD7: '9338226',
  UCD13: '3400893382264',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUNORM 5% PERF FL250ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5750846',
  CIP13: '3400957508463',
  ucdLib: "ALBUNORM 5% PERF FL500ML",
  UCD7: '9338232',
  UCD13: '3400893382325',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUNORM 5% PERF FL500ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5701061',
  CIP13: '3400957010614',
  ucdLib: "VIALEBEX 50MG/ML INJ FV250ML",
  UCD7: '9293618',
  UCD13: '3400892936185',
  ucdQtyMultiplicator: 1,
  cipLib: "VIALEBEX 50MG/ML INJ FV250ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5701078',
  CIP13: '3400957010782',
  ucdLib: "VIALEBEX 50MG/ML INJ FV500ML",
  UCD7: '9293624',
  UCD13: '3400892936246',
  ucdQtyMultiplicator: 1,
  cipLib: "VIALEBEX 50MG/ML INJ FV500ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5756228',
  CIP13: '3400957562281',
  ucdLib: "YDRALBUM 200G/L PERF FL100ML",
  UCD7: '9380903',
  UCD13: '3400893809037',
  ucdQtyMultiplicator: 1,
  cipLib: "YDRALBUM 200G/L PERF FL100ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5756211',
  CIP13: '3400957562113',
  ucdLib: "YDRALBUM 200G/L PERF FL50ML",
  UCD7: '9380895',
  UCD13: '3400893808955',
  ucdQtyMultiplicator: 1,
  cipLib: "YDRALBUM 200G/L PERF FL50ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5785632',
  CIP13: '3400957856328',
  ucdLib: "ALBUNORM 4% PERF FL100ML",
  UCD7: '9360622',
  UCD13: '3400893606223',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUNORM 4% PERF FL100ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5785649',
  CIP13: '3400957856496',
  ucdLib: "ALBUNORM 4% PERF FL250ML",
  UCD7: '9360639',
  UCD13: '3400893606391',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUNORM 4% PERF FL250ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '5785655',
  CIP13: '3400957856557',
  ucdLib: "ALBUNORM 4% PERF FL500ML",
  UCD7: '9360645',
  UCD13: '3400893606452',
  ucdQtyMultiplicator: 1,
  cipLib: "ALBUNORM 4% PERF FL500ML BT 1",
  atcCode: "B05AA01"
}, {
  CIP7: '3815174',
  CIP13: '3400938151749',
  ucdLib: "MIRCERA 100MCG INJ SRG0,3ML",
  UCD7: '9313870',
  UCD13: '3400893138700',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 100MCG INJ SRG0,3ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3815180',
  CIP13: '3400938151800',
  ucdLib: "MIRCERA 150MCG INJ SRG0,3ML",
  UCD7: '9313887',
  UCD13: '3400893138878',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 150MCG INJ SRG0,3ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3815205',
  CIP13: '3400938152050',
  ucdLib: "MIRCERA 200MCG INJ SRG0,3ML",
  UCD7: '9313893',
  UCD13: '3400893138939',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 200MCG INJ SRG0,3ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3815211',
  CIP13: '3400938152111',
  ucdLib: "MIRCERA 250MCG INJ SRG0,3ML",
  UCD7: '9313901',
  UCD13: '3400893139011',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 250MCG INJ SRG0,3ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3815145',
  CIP13: '3400938151459',
  ucdLib: "MIRCERA 50MCG INJ SRG0,3ML",
  UCD7: '9313918',
  UCD13: '3400893139189',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 50MCG INJ SRG0,3ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3815151',
  CIP13: '3400938151510',
  ucdLib: "MIRCERA 75MCG INJ SRG0,3ML",
  UCD7: '9313924',
  UCD13: '3400893139240',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 75MCG INJ SRG0,3ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3903808',
  CIP13: '3400939038087',
  ucdLib: "MIRCERA 120MCG INJ SRG0,3ML",
  UCD7: '9324632',
  UCD13: '3400893246320',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 120MCG INJ SRG0,3ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3903725',
  CIP13: '3400939037257',
  ucdLib: "MIRCERA 30MCG INJ SRG0,3ML",
  UCD7: '9324649',
  UCD13: '3400893246498',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 30MCG INJ SRG0,3ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3903814',
  CIP13: '3400939038148',
  ucdLib: "MIRCERA 360MCG INJ SRG0,6ML",
  UCD7: '9324655',
  UCD13: '3400893246559',
  ucdQtyMultiplicator: 1,
  cipLib: "MIRCERA 360MCG INJ SRG0,6ML BT 1",
  atcCode: "B03XA03"
}, {
  CIP7: '3567813',
  CIP13: '3400935678133',
  ucdLib: "ARANESP 10MCG INJ SRG0,4ML",
  UCD7: '9233237',
  UCD13: '3400892332376',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 10MCG INJ SRG0,4ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3659320',
  CIP13: '3400936593206',
  ucdLib: "ARANESP 100MCG INJ STYLO0,5ML",
  UCD7: '9274609',
  UCD13: '3400892746098',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 100MCG INJ STYLO0,5ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3659337',
  CIP13: '3400936593374',
  ucdLib: "ARANESP 150MCG INJ STYLO0,3ML",
  UCD7: '9274621',
  UCD13: '3400892746210',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 150MCG INJ STYLO0,3ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3659343',
  CIP13: '3400936593435',
  ucdLib: "ARANESP 300MCG INJ STYLO0,6ML",
  UCD7: '9274650',
  UCD13: '3400892746500',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 300MCG INJ STYLO0,6ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3658852',
  CIP13: '3400936588523',
  ucdLib: "ARANESP 40MCG INJ STYLO0,4ML",
  UCD7: '9274667',
  UCD13: '3400892746678',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 40MCG INJ STYLO0,4ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3659366',
  CIP13: '3400936593664',
  ucdLib: "ARANESP 500MCG INJ STYLO1ML",
  UCD7: '9274696',
  UCD13: '3400892746968',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 500MCG INJ STYLO1ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3658875',
  CIP13: '3400936588752',
  ucdLib: "ARANESP 60MCG INJ STYLO0,3ML",
  UCD7: '9274704',
  UCD13: '3400892747040',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 60MCG INJ STYLO0,3ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3659314',
  CIP13: '3400936593145',
  ucdLib: "ARANESP 80MCG INJ STYLO0,4ML",
  UCD7: '9274710',
  UCD13: '3400892747101',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 80MCG INJ STYLO0,4ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959298',
  CIP13: '3400939592985',
  ucdLib: "ARANESP 100MCG INJ SEC0,5ML",
  UCD7: '9334961',
  UCD13: '3400893349618',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 100MCG INJ SEC0,5ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959312',
  CIP13: '3400939593128',
  ucdLib: "ARANESP 130MCG INJ SEC0,65ML",
  UCD7: '9334978',
  UCD13: '3400893349786',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 130MCG INJ SEC0,65ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959335',
  CIP13: '3400939593357',
  ucdLib: "ARANESP 150MCG INJ SEC0,3ML",
  UCD7: '9334990',
  UCD13: '3400893349908',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 150MCG INJ SEC0,3ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959157',
  CIP13: '3400939591575',
  ucdLib: "ARANESP 20MCG INJ SEC0,5ML",
  UCD7: '9335009',
  UCD13: '3400893350096',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 20MCG INJ SEC0,5ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959358',
  CIP13: '3400939593586',
  ucdLib: "ARANESP 300MCG INJ SEC0,6ML",
  UCD7: '9335021',
  UCD13: '3400893350218',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 300MCG INJ SEC0,6ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959186',
  CIP13: '3400939591865',
  ucdLib: "ARANESP 30MCG INJ SEC0,3ML",
  UCD7: '9335015',
  UCD13: '3400893350157',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 30MCG INJ SEC0,3ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959200',
  CIP13: '3400939592008',
  ucdLib: "ARANESP 40MCG INJ SEC0,4ML",
  UCD7: '9335038',
  UCD13: '3400893350386',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 40MCG INJ SEC0,4ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959370',
  CIP13: '3400939593708',
  ucdLib: "ARANESP 500MCG INJ SEC1ML",
  UCD7: '9335050',
  UCD13: '3400893350508',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 500MCG INJ SEC1ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959223',
  CIP13: '3400939592237',
  ucdLib: "ARANESP 50MCG INJ SEC0,5ML",
  UCD7: '9335044',
  UCD13: '3400893350447',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 50MCG INJ SEC0,5ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959252',
  CIP13: '3400939592527',
  ucdLib: "ARANESP 60MCG INJ SEC0,3ML",
  UCD7: '9335067',
  UCD13: '3400893350676',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 60MCG INJ SEC0,3ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3959275',
  CIP13: '3400939592756',
  ucdLib: "ARANESP 80MCG INJ SEC0,4ML",
  UCD7: '9335073',
  UCD13: '3400893350737',
  ucdQtyMultiplicator: 1,
  cipLib: "ARANESP 80MCG INJ SEC0,4ML BT 1",
  atcCode: "B03XA02"
}, {
  CIP7: '3832764',
  CIP13: '3400938327649',
  ucdLib: "EPREX 40000U/ML INJ SRG0,75ML",
  UCD7: '9311687',
  UCD13: '3400893116876',
  ucdQtyMultiplicator: 1,
  cipLib: "EPREX 40000U/ML INJ SRG0,75ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3001972',
  CIP13: '3400930019726',
  ucdLib: "EPORATIO 20000UI/1ML SRG +A",
  UCD7: '9411064',
  UCD13: '3400894110644',
  ucdQtyMultiplicator: 1,
  cipLib: "EPORATIO 20000UI/1ML SRG +A BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3001976',
  CIP13: '3400930019764',
  ucdLib: "EPORATIO 30000UI/1ML SRG +A",
  UCD7: '9411070',
  UCD13: '3400894110705',
  ucdQtyMultiplicator: 1,
  cipLib: "EPORATIO 30000UI/1ML SRG +A BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3001217',
  CIP13: '3400930012178',
  ucdLib: "RETACRIT 10000U/1ML INJ S. +D",
  UCD7: '9407944',
  UCD13: '3400894079446',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 10000U/1ML INJ S. +D BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3001209',
  CIP13: '3400930012093',
  ucdLib: "RETACRIT 1000U/0,3ML INJ S. +D",
  UCD7: '9407950',
  UCD13: '3400894079507',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 1000U/0,3ML INJ S. +D BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3001219',
  CIP13: '3400930012192',
  ucdLib: "RETACRIT 20000U/0,5ML INJ S +D",
  UCD7: '9407967',
  UCD13: '3400894079675',
  ucdQtyMultiplicator: 1,
  cipLib: "RETACRIT 20000U/0,5ML INJ S +D BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3001210',
  CIP13: '3400930012109',
  ucdLib: "RETACRIT 2000U/0,6ML INJ S. +D",
  UCD7: '9407973',
  UCD13: '3400894079736',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 2000U/0,6ML INJ S. +D BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3001220',
  CIP13: '3400930012208',
  ucdLib: "RETACRIT 30000U/0,75ML S1+D",
  UCD7: '9407996',
  UCD13: '3400894079965',
  ucdQtyMultiplicator: 1,
  cipLib: "RETACRIT 30000U/0,75ML S1+D BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3001211',
  CIP13: '3400930012116',
  ucdLib: "RETACRIT 3000U/0,9ML INJ S. +D",
  UCD7: '9408004',
  UCD13: '3400894080046',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 3000U/0,9ML INJ S. +D BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3001221',
  CIP13: '3400930012215',
  ucdLib: "RETACRIT 40000U/1ML INJ S. +D",
  UCD7: '9408010',
  UCD13: '3400894080107',
  ucdQtyMultiplicator: 1,
  cipLib: "RETACRIT 40000U/1ML INJ S. +D BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3001212',
  CIP13: '3400930012123',
  ucdLib: "RETACRIT 4000U/0,4ML INJ S. +D",
  UCD7: '9408027',
  UCD13: '3400894080275',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 4000U/0,4ML INJ S. +D BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3001213',
  CIP13: '3400930012130',
  ucdLib: "RETACRIT 5000U/0,5ML INJ S. +D",
  UCD7: '9408033',
  UCD13: '3400894080336',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 5000U/0,5ML INJ S. +D BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3001215',
  CIP13: '3400930012154',
  ucdLib: "RETACRIT 8000U/0,8ML INJ S. +D",
  UCD7: '9408062',
  UCD13: '3400894080626',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 8000U/0,8ML INJ S. +D BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '4981839',
  CIP13: '3400949818396',
  ucdLib: "BINOCRIT 20000UI INJ S0,5ML +A",
  UCD7: '9363431',
  UCD13: '3400893634318',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 20000UI INJ S0,5ML +A BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '4981851',
  CIP13: '3400949818518',
  ucdLib: "BINOCRIT 30000UI INJ 0,75ML +A",
  UCD7: '9363454',
  UCD13: '3400893634547',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 30000UI INJ 0,75ML +A BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '4981874',
  CIP13: '3400949818747',
  ucdLib: "BINOCRIT 40000UI INJ S1ML +A",
  UCD7: '9363477',
  UCD13: '3400893634776',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 40000UI INJ S1ML +A BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3531063',
  CIP13: '3400935310637',
  ucdLib: "NEORECORMON 4000 INJ SRG",
  UCD7: '9227900',
  UCD13: '3400892279008',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 4000 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3531086',
  CIP13: '3400935310866',
  ucdLib: "NEORECORMON 4000 INJ SRG",
  UCD7: '9227900',
  UCD13: '3400892279008',
  ucdQtyMultiplicator: 6,
  cipLib: "NEORECORMON 4000 INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3531092',
  CIP13: '3400935310927',
  ucdLib: "NEORECORMON 6000 INJ SRG",
  UCD7: '9227917',
  UCD13: '3400892279176',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 6000 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3531100',
  CIP13: '3400935311009',
  ucdLib: "NEORECORMON 6000 INJ SRG",
  UCD7: '9227917',
  UCD13: '3400892279176',
  ucdQtyMultiplicator: 6,
  cipLib: "NEORECORMON 6000 INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3549703',
  CIP13: '3400935497031',
  ucdLib: "EPREX 10000U/ML INJ SRG0,5ML",
  UCD7: '9226303',
  UCD13: '3400892263038',
  ucdQtyMultiplicator: 6,
  cipLib: "EPREX 10000U/ML INJ SRG0,5ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3549726',
  CIP13: '3400935497260',
  ucdLib: "EPREX 10000U/ML INJ SRG0,6ML",
  UCD7: '9226326',
  UCD13: '3400892263267',
  ucdQtyMultiplicator: 6,
  cipLib: "EPREX 10000U/ML INJ SRG0,6ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3549749',
  CIP13: '3400935497499',
  ucdLib: "EPREX 10000U/ML INJ SRG0,8ML",
  UCD7: '9226349',
  UCD13: '3400892263496',
  ucdQtyMultiplicator: 6,
  cipLib: "EPREX 10000U/ML INJ SRG0,8ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3699199',
  CIP13: '3400936991996',
  ucdLib: "EPREX 40000U/ML INJ SRG0,5ML",
  UCD7: '9284476',
  UCD13: '3400892844763',
  ucdQtyMultiplicator: 1,
  cipLib: "EPREX 40000U/ML INJ SRG0,5ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3699236',
  CIP13: '3400936992368',
  ucdLib: "EPREX 40000U/ML INJ SRG1ML",
  UCD7: '9284482',
  UCD13: '3400892844824',
  ucdQtyMultiplicator: 1,
  cipLib: "EPREX 40000U/ML INJ SRG1ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3634656',
  CIP13: '3400936346567',
  ucdLib: "NEORECORMON 30000 INJ SRG",
  UCD7: '9255718',
  UCD13: '3400892557182',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 30000 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3634662',
  CIP13: '3400936346628',
  ucdLib: "NEORECORMON 30000 INJ SRG",
  UCD7: '9255718',
  UCD13: '3400892557182',
  ucdQtyMultiplicator: 4,
  cipLib: "NEORECORMON 30000 INJ SRG BT 4",
  atcCode: "B03XA01"
}, {
  CIP7: '3821677',
  CIP13: '3400938216776',
  ucdLib: "BINOCRIT 10000UI INJ SRG1ML",
  UCD7: '9311210',
  UCD13: '3400893112106',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 10000UI INJ SRG1ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3821683',
  CIP13: '3400938216837',
  ucdLib: "BINOCRIT 10000UI INJ SRG1ML",
  UCD7: '9311210',
  UCD13: '3400893112106',
  ucdQtyMultiplicator: 6,
  cipLib: "BINOCRIT 10000UI INJ SRG1ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3821476',
  CIP13: '3400938214765',
  ucdLib: "BINOCRIT 1000UI INJ SRG0,5ML",
  UCD7: '9311204',
  UCD13: '3400893112045',
  ucdQtyMultiplicator: 6,
  cipLib: "BINOCRIT 1000UI INJ SRG0,5ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3821499',
  CIP13: '3400938214994',
  ucdLib: "BINOCRIT 2000UI INJ SRG1ML",
  UCD7: '9311227',
  UCD13: '3400893112274',
  ucdQtyMultiplicator: 6,
  cipLib: "BINOCRIT 2000UI INJ SRG1ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3821513',
  CIP13: '3400938215137',
  ucdLib: "BINOCRIT 3000UI INJ SRG0,3ML",
  UCD7: '9311233',
  UCD13: '3400893112335',
  ucdQtyMultiplicator: 6,
  cipLib: "BINOCRIT 3000UI INJ SRG0,3ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3821542',
  CIP13: '3400938215427',
  ucdLib: "BINOCRIT 4000UI INJ SRG0,4ML",
  UCD7: '9311256',
  UCD13: '3400893112564',
  ucdQtyMultiplicator: 6,
  cipLib: "BINOCRIT 4000UI INJ SRG0,4ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3821565',
  CIP13: '3400938215656',
  ucdLib: "BINOCRIT 5000UI INJ SRG0,5ML",
  UCD7: '9311262',
  UCD13: '3400893112625',
  ucdQtyMultiplicator: 6,
  cipLib: "BINOCRIT 5000UI INJ SRG0,5ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3821588',
  CIP13: '3400938215885',
  ucdLib: "BINOCRIT 6000UI INJ SRG0,6ML",
  UCD7: '9311279',
  UCD13: '3400893112793',
  ucdQtyMultiplicator: 6,
  cipLib: "BINOCRIT 6000UI INJ SRG0,6ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3821602',
  CIP13: '3400938216028',
  ucdLib: "BINOCRIT 8000UI INJ SRG0,8ML",
  UCD7: '9311285',
  UCD13: '3400893112854',
  ucdQtyMultiplicator: 1,
  cipLib: "BINOCRIT 8000UI INJ SRG0,8ML BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3821631',
  CIP13: '3400938216318',
  ucdLib: "BINOCRIT 8000UI INJ SRG0,8ML",
  UCD7: '9311285',
  UCD13: '3400893112854',
  ucdQtyMultiplicator: 6,
  cipLib: "BINOCRIT 8000UI INJ SRG0,8ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3646688',
  CIP13: '3400936466883',
  ucdLib: "EPREX 10000U/ML INJ SRG0,3ML",
  UCD7: '9272645',
  UCD13: '3400892726458',
  ucdQtyMultiplicator: 6,
  cipLib: "EPREX 10000U/ML INJ SRG0,3ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3646694',
  CIP13: '3400936466944',
  ucdLib: "EPREX 10000U/ML INJ SRG0,4ML",
  UCD7: '9272651',
  UCD13: '3400892726519',
  ucdQtyMultiplicator: 6,
  cipLib: "EPREX 10000U/ML INJ SRG0,4ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3493121',
  CIP13: '3400934931215',
  ucdLib: "EPREX 10000U/ML INJ SRG1ML",
  UCD7: '9167440',
  UCD13: '3400891674408',
  ucdQtyMultiplicator: 6,
  cipLib: "EPREX 10000U/ML INJ SRG1ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3646665',
  CIP13: '3400936466654',
  ucdLib: "EPREX 2000U/ML INJ SRG0,5ML",
  UCD7: '9273403',
  UCD13: '3400892734033',
  ucdQtyMultiplicator: 6,
  cipLib: "EPREX 2000U/ML INJ SRG0,5ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3646671',
  CIP13: '3400936466715',
  ucdLib: "EPREX 4000U/ML INJ SRG0,5ML",
  UCD7: '9272674',
  UCD13: '3400892726748',
  ucdQtyMultiplicator: 6,
  cipLib: "EPREX 4000U/ML INJ SRG0,5ML BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3498466',
  CIP13: '3400934984662',
  ucdLib: "NEORECORMON 500 INJ SRG",
  UCD7: '9201148',
  UCD13: '3400892011486',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 500 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3498472',
  CIP13: '3400934984723',
  ucdLib: "NEORECORMON 500 INJ SRG",
  UCD7: '9201148',
  UCD13: '3400892011486',
  ucdQtyMultiplicator: 6,
  cipLib: "NEORECORMON 500 INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3862972',
  CIP13: '3400938629729',
  ucdLib: "RETACRIT 10000U/1ML INJ SRG",
  UCD7: '9315610',
  UCD13: '3400893156100',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 10000U/1ML INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3862819',
  CIP13: '3400938628197',
  ucdLib: "RETACRIT 1000U/0,3ML INJ SRG",
  UCD7: '9315604',
  UCD13: '3400893156049',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 1000U/0,3ML INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3862989',
  CIP13: '3400938629897',
  ucdLib: "RETACRIT 20000U/0,5ML INJ SRG",
  UCD7: '9315633',
  UCD13: '3400893156339',
  ucdQtyMultiplicator: 1,
  cipLib: "RETACRIT 20000U/0,5ML INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3862831',
  CIP13: '3400938628319',
  ucdLib: "RETACRIT 2000U/0,6ML INJ SRG",
  UCD7: '9315627',
  UCD13: '3400893156278',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 2000U/0,6ML INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3862995',
  CIP13: '3400938629958',
  ucdLib: "RETACRIT 30000U/0,75ML INJ S.",
  UCD7: '9315662',
  UCD13: '3400893156629',
  ucdQtyMultiplicator: 1,
  cipLib: "RETACRIT 30000U/0,75ML INJ S. BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3862854',
  CIP13: '3400938628548',
  ucdLib: "RETACRIT 3000U/0,9ML INJ SRG",
  UCD7: '9315656',
  UCD13: '3400893156568',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 3000U/0,9ML INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3863003',
  CIP13: '3400938630039',
  ucdLib: "RETACRIT 40000U/1ML INJ SRG",
  UCD7: '9315685',
  UCD13: '3400893156858',
  ucdQtyMultiplicator: 1,
  cipLib: "RETACRIT 40000U/1ML INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3862877',
  CIP13: '3400938628777',
  ucdLib: "RETACRIT 4000U/0,4ML INJ SRG",
  UCD7: '9315679',
  UCD13: '3400893156797',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 4000U/0,4ML INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3862908',
  CIP13: '3400938629088',
  ucdLib: "RETACRIT 5000U/0,5ML INJ SRG",
  UCD7: '9315691',
  UCD13: '3400893156919',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 5000U/0,5ML INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3862920',
  CIP13: '3400938629200',
  ucdLib: "RETACRIT 6000U/0,6ML INJ SRG",
  UCD7: '9315716',
  UCD13: '3400893157169',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 6000U/0,6ML INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3862943',
  CIP13: '3400938629439',
  ucdLib: "RETACRIT 8000U/0,8ML INJ SRG",
  UCD7: '9315722',
  UCD13: '3400893157220',
  ucdQtyMultiplicator: 6,
  cipLib: "RETACRIT 8000U/0,8ML INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3500335',
  CIP13: '3400935003355',
  ucdLib: "NEORECORMON 10000 INJ SRG",
  UCD7: '9201102',
  UCD13: '3400892011028',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 10000 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3500341',
  CIP13: '3400935003416',
  ucdLib: "NEORECORMON 10000 INJ SRG",
  UCD7: '9201102',
  UCD13: '3400892011028',
  ucdQtyMultiplicator: 6,
  cipLib: "NEORECORMON 10000 INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3500275',
  CIP13: '3400935002754',
  ucdLib: "NEORECORMON 2000 INJ SRG",
  UCD7: '9201119',
  UCD13: '3400892011196',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 2000 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3500281',
  CIP13: '3400935002815',
  ucdLib: "NEORECORMON 2000 INJ SRG",
  UCD7: '9201119',
  UCD13: '3400892011196',
  ucdQtyMultiplicator: 6,
  cipLib: "NEORECORMON 2000 INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3500358',
  CIP13: '3400935003584',
  ucdLib: "NEORECORMON 20000 INJ SRG",
  UCD7: '9201125',
  UCD13: '3400892011257',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 20000 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3500364',
  CIP13: '3400935003645',
  ucdLib: "NEORECORMON 20000 INJ SRG",
  UCD7: '9201125',
  UCD13: '3400892011257',
  ucdQtyMultiplicator: 6,
  cipLib: "NEORECORMON 20000 INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3500298',
  CIP13: '3400935002983',
  ucdLib: "NEORECORMON 3000 INJ SRG",
  UCD7: '9201131',
  UCD13: '3400892011318',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 3000 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3500306',
  CIP13: '3400935003065',
  ucdLib: "NEORECORMON 3000 INJ SRG",
  UCD7: '9201131',
  UCD13: '3400892011318',
  ucdQtyMultiplicator: 6,
  cipLib: "NEORECORMON 3000 INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3500312',
  CIP13: '3400935003126',
  ucdLib: "NEORECORMON 5000 INJ SRG",
  UCD7: '9201154',
  UCD13: '3400892011547',
  ucdQtyMultiplicator: 1,
  cipLib: "NEORECORMON 5000 INJ SRG BT 1",
  atcCode: "B03XA01"
}, {
  CIP7: '3500329',
  CIP13: '3400935003294',
  ucdLib: "NEORECORMON 5000 INJ SRG",
  UCD7: '9201154',
  UCD13: '3400892011547',
  ucdQtyMultiplicator: 6,
  cipLib: "NEORECORMON 5000 INJ SRG BT 6",
  atcCode: "B03XA01"
}, {
  CIP7: '3835917',
  CIP13: '3400938359176',
  ucdLib: "CALCIUM FOL.ZEN 25MG/10ML A.",
  UCD7: '9314734',
  UCD13: '3400893147344',
  ucdQtyMultiplicator: 10,
  cipLib: "CALCIUM FOL.ZEN 25MG/10ML A. BT 10",
  atcCode: "B03BB01"
}, {
  CIP7: '3835923',
  CIP13: '3400938359237',
  ucdLib: "CALCIUM FOL.ZEN 50MG INJ FL",
  UCD7: '9310073',
  UCD13: '3400893100738',
  ucdQtyMultiplicator: 10,
  cipLib: "CALCIUM FOL.ZEN 50MG INJ FL BT 10",
  atcCode: "B03BB01"
}, {
  CIP7: '3835900',
  CIP13: '3400938359008',
  ucdLib: "CALCIUM FOL.ZEN 5MG/2ML AMP",
  UCD7: '9310067',
  UCD13: '3400893100677',
  ucdQtyMultiplicator: 25,
  cipLib: "CALCIUM FOL.ZEN 5MG/2ML AMP BT 25",
  atcCode: "B03BB01"
}, {
  CIP7: '3615570',
  CIP13: '3400936155701',
  ucdLib: "SPECIAFOLDINE 0,4MG CPR",
  UCD7: '9247707',
  UCD13: '3400892477077',
  ucdQtyMultiplicator: 28,
  cipLib: "SPECIAFOLDINE 0,4MG CPR BT 28",
  atcCode: "B03BB01"
}, {
  CIP7: '3576605',
  CIP13: '3400935766052',
  ucdLib: "ACIDE FOLIQUE CCD 5MG CPR",
  UCD7: '9235207',
  UCD13: '3400892352077',
  ucdQtyMultiplicator: 20,
  cipLib: "ACIDE FOLIQUE CCD 5MG CPR BT 20",
  atcCode: "B03BB01"
}, {
  CIP7: '3040891',
  CIP13: '3400930408919',
  ucdLib: "SPECIAFOLDINE 5MG CPR",
  UCD7: '9087066',
  UCD13: '3400890870665',
  ucdQtyMultiplicator: 20,
  cipLib: "SPECIAFOLDINE 5MG CPR BT 20",
  atcCode: "B03BB01"
}, {
  CIP7: '3584585',
  CIP13: '3400935845856',
  ucdLib: "ACIDE FOLIQUE CCD 0,4MG CPR",
  UCD7: '9235756',
  UCD13: '3400892357560',
  ucdQtyMultiplicator: 30,
  cipLib: "ACIDE FOLIQUE CCD 0,4MG CPR BT 30",
  atcCode: "B03BB01"
}, {
  CIP7: '4160284',
  CIP13: '3400941602849',
  ucdLib: "ACIDE FOLIQUE ARW 5MG CPR",
  UCD7: '9372051',
  UCD13: '3400893720516',
  ucdQtyMultiplicator: 20,
  cipLib: "ACIDE FOLIQUE ARW 5MG CPR BT 20",
  atcCode: "B03BB01"
}, {
  CIP7: '5763872',
  CIP13: '3400957638726',
  ucdLib: "ACIDE FOLIQUE CCD 5MG CPR",
  UCD7: '9235207',
  UCD13: '3400892352077',
  ucdQtyMultiplicator: 200,
  cipLib: "ACIDE FOLIQUE CCD 5MG CPR BT 200",
  atcCode: "B03BB01"
}, {
  CIP7: '3169828',
  CIP13: '3400931698289',
  ucdLib: "DODECAVIT 0,5MG/ML AMP2ML",
  UCD7: '9028129',
  UCD13: '3400890281294',
  ucdQtyMultiplicator: 6,
  cipLib: "DODECAVIT 0,5MG/ML AMP2ML BT 6",
  atcCode: "B03BA03"
}, {
  CIP7: '3113638',
  CIP13: '3400931136385',
  ucdLib: "VIT B12 GERDA 1000Y AMP4ML",
  UCD7: '9100335',
  UCD13: '3400891003352',
  ucdQtyMultiplicator: 6,
  cipLib: "VIT B12 GERDA 1000Y AMP4ML BT 6",
  atcCode: "B03BA01"
}, {
  CIP7: '3113644',
  CIP13: '3400931136446',
  ucdLib: "VIT B12 GERDA 250Y CPR",
  UCD7: '9100341',
  UCD13: '3400891003413',
  ucdQtyMultiplicator: 24,
  cipLib: "VIT B12 GERDA 250Y CPR BT 24",
  atcCode: "B03BA01"
}, {
  CIP7: '3551539',
  CIP13: '3400935515391',
  ucdLib: "VIT B12 LAV 1000Y INJ A.1ML",
  UCD7: '9223865',
  UCD13: '3400892238654',
  ucdQtyMultiplicator: 10,
  cipLib: "VIT B12 LAV 1000Y INJ A.1ML BT 10",
  atcCode: "B03BA01"
}, {
  CIP7: '3548879',
  CIP13: '3400935488794',
  ucdLib: "CYANOCOBALAMINE REN INJ 2ML",
  UCD7: '9236572',
  UCD13: '3400892365725',
  ucdQtyMultiplicator: 100,
  cipLib: "CYANOCOBALAMINE REN INJ 2ML BT 100",
  atcCode: "B03BA01"
}, {
  CIP7: '3171050',
  CIP13: '3400931710509',
  ucdLib: "VIT B12 DEL.1000Y INJ A.2ML",
  UCD7: '9100298',
  UCD13: '3400891002980',
  ucdQtyMultiplicator: 6,
  cipLib: "VIT B12 DEL.1000Y INJ A.2ML BT 6",
  atcCode: "B03BA01"
}, {
  CIP7: '5628565',
  CIP13: '3400956285655',
  ucdLib: "VIT B12 LAV 1000Y INJ A.1ML",
  UCD7: '9223865',
  UCD13: '3400892238654',
  ucdQtyMultiplicator: 100,
  cipLib: "VIT B12 LAV 1000Y INJ A.1ML BT 100",
  atcCode: "B03BA01"
}, {
  CIP7: '3291819',
  CIP13: '3400932918195',
  ucdLib: "TARDYFERON B9 CPR",
  UCD7: '9122360',
  UCD13: '3400891223606',
  ucdQtyMultiplicator: 30,
  cipLib: "TARDYFERON B9 CPR BT 30",
  atcCode: "B03AD03"
}, {
  CIP7: '3869247',
  CIP13: '3400938692471',
  ucdLib: "FERINJECT 50MG/ML INJ FL10ML",
  UCD7: '9352781',
  UCD13: '3400893527818',
  ucdQtyMultiplicator: 1,
  cipLib: "FERINJECT 50MG/ML INJ FL10ML BT 1",
  atcCode: "B03AC"
}, {
  CIP7: '3868124',
  CIP13: '3400938681246',
  ucdLib: "FERINJECT 50MG/ML INJ FL2ML",
  UCD7: '9352798',
  UCD13: '3400893527986',
  ucdQtyMultiplicator: 1,
  cipLib: "FERINJECT 50MG/ML INJ FL2ML BT 1",
  atcCode: "B03AC"
}, {
  CIP7: '2193948',
  CIP13: '3400921939484',
  ucdLib: "FERINJECT 50MG/ML INJ FL10ML",
  UCD7: '9352781',
  UCD13: '3400893527818',
  ucdQtyMultiplicator: 2,
  cipLib: "FERINJECT 50MG/ML INJ FL10ML BT 2",
  atcCode: "B03AC"
}, {
  CIP7: '5740374',
  CIP13: '3400957403744',
  ucdLib: "FER MYL 100MG/5ML PERF AMP",
  UCD7: '9321740',
  UCD13: '3400893217405',
  ucdQtyMultiplicator: 5,
  cipLib: "FER MYL 100MG/5ML PERF AMP BT 5",
  atcCode: "B03AC"
}, {
  CIP7: '5729220',
  CIP13: '3400957292201',
  ucdLib: "FERRISAT 50MG/ML INJ AMP10ML",
  UCD7: '9312936',
  UCD13: '3400893129364',
  ucdQtyMultiplicator: 2,
  cipLib: "FERRISAT 50MG/ML INJ AMP10ML BT 2",
  atcCode: "B03AC"
}, {
  CIP7: '5714796',
  CIP13: '3400957147969',
  ucdLib: "FERRISAT 50MG/ML INJ AMP2ML",
  UCD7: '9305304',
  UCD13: '3400893053041',
  ucdQtyMultiplicator: 5,
  cipLib: "FERRISAT 50MG/ML INJ AMP2ML BT 5",
  atcCode: "B03AC"
}, {
  CIP7: '5712834',
  CIP13: '3400957128340',
  ucdLib: "VENOFER 20MG/ML INJ FL5ML",
  UCD7: '9352806',
  UCD13: '3400893528068',
  ucdQtyMultiplicator: 5,
  cipLib: "VENOFER 20MG/ML INJ FL5ML BT 5",
  atcCode: "B03AC"
}, {
  CIP7: '5774580',
  CIP13: '3400957745806',
  ucdLib: "FER ARW 100MG/5ML INJ AMP",
  UCD7: '9355012',
  UCD13: '3400893550120',
  ucdQtyMultiplicator: 5,
  cipLib: "FER ARW 100MG/5ML INJ AMP BT 5",
  atcCode: "B03AC"
}, {
  CIP7: '5800478',
  CIP13: '3400958004780',
  ucdLib: "FER PAN 100MG/5ML PERF AMP",
  UCD7: '9399713',
  UCD13: '3400893997130',
  ucdQtyMultiplicator: 5,
  cipLib: "FER PAN 100MG/5ML PERF AMP BT 5",
  atcCode: "B03AC"
}, {
  CIP7: '5734735',
  CIP13: '3400957347352',
  ucdLib: "FER SDZ 100MG/5ML PERF AMP",
  UCD7: '9322892',
  UCD13: '3400893228920',
  ucdQtyMultiplicator: 5,
  cipLib: "FER SDZ 100MG/5ML PERF AMP BT 5",
  atcCode: "B03AC"
}, {
  CIP7: '5859885',
  CIP13: '3400958598852',
  ucdLib: "FERINJECT 50MG/ML INJ FL20ML",
  UCD7: '9399736',
  UCD13: '3400893997369',
  ucdQtyMultiplicator: 1,
  cipLib: "FERINJECT 50MG/ML INJ FL20ML BT 1",
  atcCode: "B03AC"
}, {
  CIP7: '3039698',
  CIP13: '3400930396988',
  ucdLib: "FERROSTRANE 0,68% SIR FL125ML",
  UCD7: '9034762',
  UCD13: '3400890347624',
  ucdQtyMultiplicator: 1,
  cipLib: "FERROSTRANE 0,68% SIR FL125ML BT 1",
  atcCode: "B03AB03"
}, {
  CIP7: '3006960',
  CIP13: '3400930069608',
  ucdLib: "ASCOFER 33MG GELU",
  UCD7: '9007110',
  UCD13: '3400890071109',
  ucdQtyMultiplicator: 30,
  cipLib: "ASCOFER 33MG GELU BT 30",
  atcCode: "B03AA10"
}, {
  CIP7: '3570614',
  CIP13: '3400935706140',
  ucdLib: "TIMOFEROL GELU",
  UCD7: '9262813',
  UCD13: '3400892628134',
  ucdQtyMultiplicator: 30,
  cipLib: "TIMOFEROL GELU BT 30",
  atcCode: "B03AA07"
}, {
  CIP7: '3118794',
  CIP13: '3400931187943',
  ucdLib: "FEROGRAD VIT C 500 CPR",
  UCD7: '9034727',
  UCD13: '3400890347273',
  ucdQtyMultiplicator: 30,
  cipLib: "FEROGRAD VIT C 500 CPR BT 30",
  atcCode: "B03AA07"
}, {
  CIP7: '3351800',
  CIP13: '3400933518004',
  ucdLib: "TARDYFERON 80MG CPR",
  UCD7: '9155508',
  UCD13: '3400891555080',
  ucdQtyMultiplicator: 30,
  cipLib: "TARDYFERON 80MG CPR BT 30",
  atcCode: "B03AA07"
}, {
  CIP7: '3692665',
  CIP13: '3400936926653',
  ucdLib: "FER AP-HP 0,5MG NN GELU",
  UCD7: '9289657',
  UCD13: '3400892896571',
  ucdQtyMultiplicator: 100,
  cipLib: "FER AP-HP 0,5MG NN GELU BT 100",
  atcCode: "B03AA07"
}, {
  CIP7: '3870687',
  CIP13: '3400938706871',
  ucdLib: "TIMOFEROL GELU",
  UCD7: '9262813',
  UCD13: '3400892628134',
  ucdQtyMultiplicator: 90,
  cipLib: "TIMOFEROL GELU BT 90",
  atcCode: "B03AA07"
}, {
  CIP7: '5791704',
  CIP13: '3400957917043',
  ucdLib: "TARDYFERON 80MG CPR",
  UCD7: '9155508',
  UCD13: '3400891555080',
  ucdQtyMultiplicator: 100,
  cipLib: "TARDYFERON 80MG CPR BT 100",
  atcCode: "B03AA07"
}, {
  CIP7: '3352969',
  CIP13: '3400933529697',
  ucdLib: "INOFER CPR",
  UCD7: '9154549',
  UCD13: '3400891545494',
  ucdQtyMultiplicator: 100,
  cipLib: "INOFER CPR BT 100",
  atcCode: "B03AA06"
}, {
  CIP7: '3107313',
  CIP13: '3400931073130',
  ucdLib: "TOTHEMA BUV AMP10ML",
  UCD7: '9094095',
  UCD13: '3400890940955',
  ucdQtyMultiplicator: 20,
  cipLib: "TOTHEMA BUV AMP10ML BT 20",
  atcCode: "B03AA03"
}, {
  CIP7: '3041815',
  CIP13: '3400930418154',
  ucdLib: "FUMAFER 33MG/1G PDR BT50G",
  UCD7: '9036577',
  UCD13: '3400890365772',
  ucdQtyMultiplicator: 1,
  cipLib: "FUMAFER 33MG/1G PDR BT50G BT 1",
  atcCode: "B03AA02"
}, {
  CIP7: '3041809',
  CIP13: '3400930418093',
  ucdLib: "FUMAFER 66MG CPR",
  UCD7: '9036560',
  UCD13: '3400890365604',
  ucdQtyMultiplicator: 100,
  cipLib: "FUMAFER 66MG CPR BT 100",
  atcCode: "B03AA02"
}, {
  CIP7: '5591744',
  CIP13: '3400955917441',
  ucdLib: "FUMAFER 66MG CPR",
  UCD7: '9036560',
  UCD13: '3400890365604',
  ucdQtyMultiplicator: 50,
  cipLib: "FUMAFER 66MG CPR BT 50",
  atcCode: "B03AA02"
}, {
  CIP7: '3745858',
  CIP13: '3400937458580',
  ucdLib: "REVOLADE 25MG CPR",
  UCD7: '9351965',
  UCD13: '3400893519653',
  ucdQtyMultiplicator: 14,
  cipLib: "REVOLADE 25MG CPR BT 14",
  atcCode: "B02BX05"
}, {
  CIP7: '3745864',
  CIP13: '3400937458641',
  ucdLib: "REVOLADE 25MG CPR",
  UCD7: '9351965',
  UCD13: '3400893519653',
  ucdQtyMultiplicator: 28,
  cipLib: "REVOLADE 25MG CPR BT 28",
  atcCode: "B02BX05"
}, {
  CIP7: '3745887',
  CIP13: '3400937458870',
  ucdLib: "REVOLADE 50MG CPR",
  UCD7: '9351971',
  UCD13: '3400893519714',
  ucdQtyMultiplicator: 14,
  cipLib: "REVOLADE 50MG CPR BT 14",
  atcCode: "B02BX05"
}, {
  CIP7: '3745893',
  CIP13: '3400937458931',
  ucdLib: "REVOLADE 50MG CPR",
  UCD7: '9351971',
  UCD13: '3400893519714',
  ucdQtyMultiplicator: 28,
  cipLib: "REVOLADE 50MG CPR BT 28",
  atcCode: "B02BX05"
}, {
  CIP7: '3598558',
  CIP13: '3400935985583',
  ucdLib: "NPLATE 250MCG INJ FL+SRG +KIT",
  UCD7: '9354449',
  UCD13: '3400893544495',
  ucdQtyMultiplicator: 1,
  cipLib: "NPLATE 250MCG INJ FL+SRG +KIT BT 1",
  atcCode: "B02BX04"
}, {
  CIP7: '3599641',
  CIP13: '3400935996411',
  ucdLib: "NPLATE 500MCG INJ FL+SRG +KIT",
  UCD7: '9354455',
  UCD13: '3400893544556',
  ucdQtyMultiplicator: 1,
  cipLib: "NPLATE 500MCG INJ FL+SRG +KIT BT 1",
  atcCode: "B02BX04"
}, {
  CIP7: '3030881',
  CIP13: '3400930308813',
  ucdLib: "DICYNONE 250MG INJ AMP2ML",
  UCD7: '9026662',
  UCD13: '3400890266628',
  ucdQtyMultiplicator: 6,
  cipLib: "DICYNONE 250MG INJ AMP2ML BT 6",
  atcCode: "B02BX01"
}, {
  CIP7: '3030906',
  CIP13: '3400930309063',
  ucdLib: "DICYNONE 500MG CPR",
  UCD7: '9026685',
  UCD13: '3400890266857',
  ucdQtyMultiplicator: 20,
  cipLib: "DICYNONE 500MG CPR BT 20",
  atcCode: "B02BX01"
}, {
  CIP7: '5645138',
  CIP13: '3400956451388',
  ucdLib: "WILFACTIN 100UI/ML FL+FL10ML",
  UCD7: '9255463',
  UCD13: '3400892554631',
  ucdQtyMultiplicator: 1,
  cipLib: "WILFACTIN 100UI/ML FL+FL10ML BT 1",
  atcCode: "B02BD10"
}, {
  CIP7: '5851027',
  CIP13: '3400958510274',
  ucdLib: "WILFACTIN 100UI/ML FL+FL20ML",
  UCD7: '9394615',
  UCD13: '3400893946152',
  ucdQtyMultiplicator: 1,
  cipLib: "WILFACTIN 100UI/ML FL+FL20ML BT 1",
  atcCode: "B02BD10"
}, {
  CIP7: '5851010',
  CIP13: '3400958510106',
  ucdLib: "WILFACTIN 100UI/ML FL+FL5ML",
  UCD7: '9394621',
  UCD13: '3400893946213',
  ucdQtyMultiplicator: 1,
  cipLib: "WILFACTIN 100UI/ML FL+FL5ML BT 1",
  atcCode: "B02BD10"
}, {
  CIP7: '5730921',
  CIP13: '3400957309213',
  ucdLib: "NOVOSEVEN 1MG INJ FL+FL",
  UCD7: '9318873',
  UCD13: '3400893188736',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOSEVEN 1MG INJ FL+FL BT 1",
  atcCode: "B02BD08"
}, {
  CIP7: '5838417',
  CIP13: '3400958384172',
  ucdLib: "NOVOSEVEN 1MG INJ FL+SRG",
  UCD7: '9389732',
  UCD13: '3400893897324',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOSEVEN 1MG INJ FL+SRG BT 1",
  atcCode: "B02BD08"
}, {
  CIP7: '5730938',
  CIP13: '3400957309381',
  ucdLib: "NOVOSEVEN 2MG INJ FL+FL",
  UCD7: '9318896',
  UCD13: '3400893188965',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOSEVEN 2MG INJ FL+FL BT 1",
  atcCode: "B02BD08"
}, {
  CIP7: '5838423',
  CIP13: '3400958384233',
  ucdLib: "NOVOSEVEN 2MG INJ FL+SRG",
  UCD7: '9389749',
  UCD13: '3400893897492',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOSEVEN 2MG INJ FL+SRG BT 1",
  atcCode: "B02BD08"
}, {
  CIP7: '5730944',
  CIP13: '3400957309442',
  ucdLib: "NOVOSEVEN 5MG INJ FL+FL",
  UCD7: '9318904',
  UCD13: '3400893189047',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOSEVEN 5MG INJ FL+FL BT 1",
  atcCode: "B02BD08"
}, {
  CIP7: '5838446',
  CIP13: '3400958384462',
  ucdLib: "NOVOSEVEN 5MG INJ FL+SRG",
  UCD7: '9389755',
  UCD13: '3400893897553',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOSEVEN 5MG INJ FL+SRG BT 1",
  atcCode: "B02BD08"
}, {
  CIP7: '5823953',
  CIP13: '3400958239533',
  ucdLib: "NOVOSEVEN 8MG INJ FL+FL",
  UCD7: '9384077',
  UCD13: '3400893840771',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOSEVEN 8MG INJ FL+FL BT 1",
  atcCode: "B02BD08"
}, {
  CIP7: '5838452',
  CIP13: '3400958384523',
  ucdLib: "NOVOSEVEN 8MG INJ FL+SRG",
  UCD7: '9389761',
  UCD13: '3400893897614',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOSEVEN 8MG INJ FL+SRG BT 1",
  atcCode: "B02BD08"
}, {
  CIP7: '5754169',
  CIP13: '3400957541699',
  ucdLib: "FIBROGAMMIN 62,5UI/ML F+A4ML",
  UCD7: '9341369',
  UCD13: '3400893413692',
  ucdQtyMultiplicator: 1,
  cipLib: "FIBROGAMMIN 62,5UI/ML F+A4ML BT 1",
  atcCode: "B02BD07"
}, {
  CIP7: '5754175',
  CIP13: '3400957541750',
  ucdLib: "FIBROGAMMIN 62,5UI/ML F+F20ML",
  UCD7: '9341375',
  UCD13: '3400893413753',
  ucdQtyMultiplicator: 1,
  cipLib: "FIBROGAMMIN 62,5UI/ML F+F20ML BT 1",
  atcCode: "B02BD07"
}, {
  CIP7: '5645167',
  CIP13: '3400956451678',
  ucdLib: "WILSTART 100UI/ML INJ FL+FL",
  UCD7: '9255486',
  UCD13: '3400892554860',
  ucdQtyMultiplicator: 1,
  cipLib: "WILSTART 100UI/ML INJ FL+FL BT 1",
  atcCode: "B02BD06"
}, {
  CIP7: '5856390',
  CIP13: '3400958563904',
  ucdLib: "VONCENTO 1000/2400UI INJ FL+F",
  UCD7: '9395678',
  UCD13: '3400893956786',
  ucdQtyMultiplicator: 1,
  cipLib: "VONCENTO 1000/2400UI INJ FL+F BT 1",
  atcCode: "B02BD06"
}, {
  CIP7: '5856384',
  CIP13: '3400958563843',
  ucdLib: "VONCENTO 500/1200UI INJ FL+FL",
  UCD7: '9395690',
  UCD13: '3400893956908',
  ucdQtyMultiplicator: 1,
  cipLib: "VONCENTO 500/1200UI INJ FL+FL BT 1",
  atcCode: "B02BD06"
}, {
  CIP7: '5597729',
  CIP13: '3400955977292',
  ucdLib: "MONONINE 1000UI INJ FL+FL+NEC",
  UCD7: '9181670',
  UCD13: '3400891816709',
  ucdQtyMultiplicator: 1,
  cipLib: "MONONINE 1000UI INJ FL+FL+NEC BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5623065',
  CIP13: '3400956230655',
  ucdLib: "BETAFACT 50UI/ML INJ FV+FV10ML",
  UCD7: '9232120',
  UCD13: '3400892321202',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAFACT 50UI/ML INJ FV+FV10ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5623088',
  CIP13: '3400956230884',
  ucdLib: "BETAFACT 50UI/ML INJ FV+FV20ML",
  UCD7: '9232137',
  UCD13: '3400892321370',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAFACT 50UI/ML INJ FV+FV20ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5623071',
  CIP13: '3400956230716',
  ucdLib: "BETAFACT 50UI/ML INJ FV+FV5ML",
  UCD7: '9232143',
  UCD13: '3400892321431',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAFACT 50UI/ML INJ FV+FV5ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5500399',
  CIP13: '3400955003991',
  ucdLib: "RIXUBIS 1000UI INJ FL+FL5ML",
  UCD7: '9407424',
  UCD13: '3400894074243',
  ucdQtyMultiplicator: 1,
  cipLib: "RIXUBIS 1000UI INJ FL+FL5ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5500400',
  CIP13: '3400955004004',
  ucdLib: "RIXUBIS 2000UI INJ FL+FL5ML",
  UCD7: '9407430',
  UCD13: '3400894074304',
  ucdQtyMultiplicator: 1,
  cipLib: "RIXUBIS 2000UI INJ FL+FL5ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5500396',
  CIP13: '3400955003960',
  ucdLib: "RIXUBIS 250UI INJ FL+FL5ML",
  UCD7: '9407447',
  UCD13: '3400894074472',
  ucdQtyMultiplicator: 1,
  cipLib: "RIXUBIS 250UI INJ FL+FL5ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5500401',
  CIP13: '3400955004011',
  ucdLib: "RIXUBIS 3000UI INJ FL+FL5ML",
  UCD7: '9407619',
  UCD13: '3400894076193',
  ucdQtyMultiplicator: 1,
  cipLib: "RIXUBIS 3000UI INJ FL+FL5ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5500398',
  CIP13: '3400955003984',
  ucdLib: "RIXUBIS 500UI INJ FL+FL5ML",
  UCD7: '9407453',
  UCD13: '3400894074533',
  ucdQtyMultiplicator: 1,
  cipLib: "RIXUBIS 500UI INJ FL+FL5ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5634152',
  CIP13: '3400956341528',
  ucdLib: "OCTAFIX 100UI/ML INJ F+F10ML",
  UCD7: '9248144',
  UCD13: '3400892481449',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAFIX 100UI/ML INJ F+F10ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5634146',
  CIP13: '3400956341467',
  ucdLib: "OCTAFIX 100UI/ML INJ F+F5ML",
  UCD7: '9248150',
  UCD13: '3400892481500',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAFIX 100UI/ML INJ F+F5ML BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5711585',
  CIP13: '3400957115852',
  ucdLib: "BENEFIX 1000UI INJ FL+SRG",
  UCD7: '9304256',
  UCD13: '3400893042564',
  ucdQtyMultiplicator: 1,
  cipLib: "BENEFIX 1000UI INJ FL+SRG BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5711591',
  CIP13: '3400957115913',
  ucdLib: "BENEFIX 2000UI INJ FL+SRG",
  UCD7: '9304262',
  UCD13: '3400893042625',
  ucdQtyMultiplicator: 1,
  cipLib: "BENEFIX 2000UI INJ FL+SRG BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5711562',
  CIP13: '3400957115623',
  ucdLib: "BENEFIX 250UI INJ FL+SRG",
  UCD7: '9304279',
  UCD13: '3400893042793',
  ucdQtyMultiplicator: 1,
  cipLib: "BENEFIX 250UI INJ FL+SRG BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5711579',
  CIP13: '3400957115791',
  ucdLib: "BENEFIX 500UI INJ FL+SRG",
  UCD7: '9304285',
  UCD13: '3400893042854',
  ucdQtyMultiplicator: 1,
  cipLib: "BENEFIX 500UI INJ FL+SRG BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5744194',
  CIP13: '3400957441944',
  ucdLib: "BETAFACT 100UI/ML FV+FV10ML+S.",
  UCD7: '9331336',
  UCD13: '3400893313367',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAFACT 100UI/ML FV+FV10ML+S. BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5744188',
  CIP13: '3400957441883',
  ucdLib: "BETAFACT 100UI/ML FV+FV5ML +S.",
  UCD7: '9331342',
  UCD13: '3400893313428',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAFACT 100UI/ML FV+FV5ML +S. BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5834394',
  CIP13: '3400958343940',
  ucdLib: "BENEFIX 3000UI INJ FL+SRG",
  UCD7: '9390184',
  UCD13: '3400893901847',
  ucdQtyMultiplicator: 1,
  cipLib: "BENEFIX 3000UI INJ FL+SRG BT 1",
  atcCode: "B02BD04"
}, {
  CIP7: '5645150',
  CIP13: '3400956451500',
  ucdLib: "FEIBA 1000U INJ FL+FL+BJ",
  UCD7: '9259082',
  UCD13: '3400892590820',
  ucdQtyMultiplicator: 1,
  cipLib: "FEIBA 1000U INJ FL+FL+BJ BT 1",
  atcCode: "B02BD03"
}, {
  CIP7: '5645144',
  CIP13: '3400956451449',
  ucdLib: "FEIBA 500U INJ FL+FL+BJ",
  UCD7: '9259099',
  UCD13: '3400892590998',
  ucdQtyMultiplicator: 1,
  cipLib: "FEIBA 500U INJ FL+FL+BJ BT 1",
  atcCode: "B02BD03"
}, {
  CIP7: '5621178',
  CIP13: '3400956211784',
  ucdLib: "FACTANE 100UI/ML FV+FV10ML",
  UCD7: '9225918',
  UCD13: '3400892259185',
  ucdQtyMultiplicator: 1,
  cipLib: "FACTANE 100UI/ML FV+FV10ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5621155',
  CIP13: '3400956211555',
  ucdLib: "FACTANE 100UI/ML FV+FV2,5ML",
  UCD7: '9225924',
  UCD13: '3400892259246',
  ucdQtyMultiplicator: 1,
  cipLib: "FACTANE 100UI/ML FV+FV2,5ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5621161',
  CIP13: '3400956211616',
  ucdLib: "FACTANE 100UI/ML FV+FV5ML",
  UCD7: '9225930',
  UCD13: '3400892259307',
  ucdQtyMultiplicator: 1,
  cipLib: "FACTANE 100UI/ML FV+FV5ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5620960',
  CIP13: '3400956209606',
  ucdLib: "HELIXATE NEXGEN 250UI F+F+NEC",
  UCD7: '9224988',
  UCD13: '3400892249889',
  ucdQtyMultiplicator: 1,
  cipLib: "HELIXATE NEXGEN 250UI F+F+NEC BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5620977',
  CIP13: '3400956209774',
  ucdLib: "HELIXATE NEXGEN 500UI F+F+NEC",
  UCD7: '9224994',
  UCD13: '3400892249940',
  ucdQtyMultiplicator: 1,
  cipLib: "HELIXATE NEXGEN 500UI F+F+NEC BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5620983',
  CIP13: '3400956209835',
  ucdLib: "HELIXATE NEXGEN1000UI F+F+NEC",
  UCD7: '9224971',
  UCD13: '3400892249711',
  ucdQtyMultiplicator: 1,
  cipLib: "HELIXATE NEXGEN1000UI F+F+NEC BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5501583',
  CIP13: '3400955015833',
  ucdLib: "ELOCTA 1000UI INJ FL+SRG",
  UCD7: '9415381',
  UCD13: '3400894153818',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOCTA 1000UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5501584',
  CIP13: '3400955015840',
  ucdLib: "ELOCTA 1500UI INJ FL+SRG",
  UCD7: '9415398',
  UCD13: '3400894153986',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOCTA 1500UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5501585',
  CIP13: '3400955015857',
  ucdLib: "ELOCTA 2000UI INJ FL+SRG",
  UCD7: '9415406',
  UCD13: '3400894154068',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOCTA 2000UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5501580',
  CIP13: '3400955015802',
  ucdLib: "ELOCTA 250UI INJ FL+SRG",
  UCD7: '9415412',
  UCD13: '3400894154129',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOCTA 250UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5501587',
  CIP13: '3400955015871',
  ucdLib: "ELOCTA 3000UI INJ FL+SRG",
  UCD7: '9415429',
  UCD13: '3400894154297',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOCTA 3000UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5501581',
  CIP13: '3400955015819',
  ucdLib: "ELOCTA 500UI INJ FL+SRG",
  UCD7: '9415435',
  UCD13: '3400894154358',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOCTA 500UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5501582',
  CIP13: '3400955015826',
  ucdLib: "ELOCTA 750UI INJ FL+SRG",
  UCD7: '9415441',
  UCD13: '3400894154419',
  ucdQtyMultiplicator: 1,
  cipLib: "ELOCTA 750UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5500404',
  CIP13: '3400955004042',
  ucdLib: "NUWIQ 1000UI INJ FL+SRG +N",
  UCD7: '9410432',
  UCD13: '3400894104322',
  ucdQtyMultiplicator: 1,
  cipLib: "NUWIQ 1000UI INJ FL+SRG +N BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5500406',
  CIP13: '3400955004066',
  ucdLib: "NUWIQ 2000UI INJ FL+SRG +N",
  UCD7: '9410449',
  UCD13: '3400894104490',
  ucdQtyMultiplicator: 1,
  cipLib: "NUWIQ 2000UI INJ FL+SRG +N BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5500402',
  CIP13: '3400955004028',
  ucdLib: "NUWIQ 250UI INJ FL+SRG +N",
  UCD7: '9410455',
  UCD13: '3400894104551',
  ucdQtyMultiplicator: 1,
  cipLib: "NUWIQ 250UI INJ FL+SRG +N BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5500403',
  CIP13: '3400955004035',
  ucdLib: "NUWIQ 500UI INJ FL+SRG +N",
  UCD7: '9410461',
  UCD13: '3400894104612',
  ucdQtyMultiplicator: 1,
  cipLib: "NUWIQ 500UI INJ FL+SRG +N BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5500639',
  CIP13: '3400955006398',
  ucdLib: "OCTANATE LV 100UI/ML FL+FL5ML",
  UCD7: '9413962',
  UCD13: '3400894139621',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTANATE LV 100UI/ML FL+FL5ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5500651',
  CIP13: '3400955006510',
  ucdLib: "OCTANATE LV 200UI/ML FL+FL5ML",
  UCD7: '9413979',
  UCD13: '3400894139799',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTANATE LV 200UI/ML FL+FL5ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5872064',
  CIP13: '3400958720642',
  ucdLib: "ADVATE 1000UI INJ FL+FL2ML +D",
  UCD7: '9406229',
  UCD13: '3400894062295',
  ucdQtyMultiplicator: 1,
  cipLib: "ADVATE 1000UI INJ FL+FL2ML +D BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5872087',
  CIP13: '3400958720871',
  ucdLib: "ADVATE 1500UI INJ FL+FL2ML +D",
  UCD7: '9406235',
  UCD13: '3400894062356',
  ucdQtyMultiplicator: 1,
  cipLib: "ADVATE 1500UI INJ FL+FL2ML +D BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5872093',
  CIP13: '3400958720932',
  ucdLib: "ADVATE 2000UI INJ FL+FL5ML +D",
  UCD7: '9406241',
  UCD13: '3400894062417',
  ucdQtyMultiplicator: 1,
  cipLib: "ADVATE 2000UI INJ FL+FL5ML +D BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5872029',
  CIP13: '3400958720291',
  ucdLib: "ADVATE 250UI INJ FL+FL2ML +D",
  UCD7: '9406258',
  UCD13: '3400894062585',
  ucdQtyMultiplicator: 1,
  cipLib: "ADVATE 250UI INJ FL+FL2ML +D BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5872101',
  CIP13: '3400958721014',
  ucdLib: "ADVATE 3000UI INJ FL+FL5ML +D",
  UCD7: '9406264',
  UCD13: '3400894062646',
  ucdQtyMultiplicator: 1,
  cipLib: "ADVATE 3000UI INJ FL+FL5ML +D BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5872041',
  CIP13: '3400958720413',
  ucdLib: "ADVATE 500UI INJ FL+FL2ML +D",
  UCD7: '9406270',
  UCD13: '3400894062707',
  ucdQtyMultiplicator: 1,
  cipLib: "ADVATE 500UI INJ FL+FL2ML +D BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5723536',
  CIP13: '3400957235369',
  ucdLib: "HELIXATE NEXGEN2000UI F+F +NEC",
  UCD7: '9310512',
  UCD13: '3400893105122',
  ucdQtyMultiplicator: 1,
  cipLib: "HELIXATE NEXGEN2000UI F+F +NEC BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5717843',
  CIP13: '3400957178437',
  ucdLib: "KOGENATE BAY 2000UI FL+S.BIO",
  UCD7: '9309549',
  UCD13: '3400893095492',
  ucdQtyMultiplicator: 1,
  cipLib: "KOGENATE BAY 2000UI FL+S.BIO BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5852009',
  CIP13: '3400958520099',
  ucdLib: "FACTANE 200UI/ML FV+FV10ML",
  UCD7: '9394940',
  UCD13: '3400893949405',
  ucdQtyMultiplicator: 1,
  cipLib: "FACTANE 200UI/ML FV+FV10ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5852015',
  CIP13: '3400958520150',
  ucdLib: "FACTANE 200UI/ML FV+FV5ML",
  UCD7: '9394957',
  UCD13: '3400893949573',
  ucdQtyMultiplicator: 1,
  cipLib: "FACTANE 200UI/ML FV+FV5ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5787476',
  CIP13: '3400957874766',
  ucdLib: "HELIXATE NEXGEN3000UI F+F+NEC",
  UCD7: '9359346',
  UCD13: '3400893593462',
  ucdQtyMultiplicator: 1,
  cipLib: "HELIXATE NEXGEN3000UI F+F+NEC BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5661924',
  CIP13: '3400956619245',
  ucdLib: "KOGENATE BAY 1000UI FL+S.BIO",
  UCD7: '9264663',
  UCD13: '3400892646633',
  ucdQtyMultiplicator: 1,
  cipLib: "KOGENATE BAY 1000UI FL+S.BIO BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5661901',
  CIP13: '3400956619016',
  ucdLib: "KOGENATE BAY 250UI FL+S.BIO",
  UCD7: '9264686',
  UCD13: '3400892646862',
  ucdQtyMultiplicator: 1,
  cipLib: "KOGENATE BAY 250UI FL+S.BIO BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5782266',
  CIP13: '3400957822668',
  ucdLib: "KOGENATE BAY 3000UI FL+S.BIO",
  UCD7: '9362733',
  UCD13: '3400893627334',
  ucdQtyMultiplicator: 1,
  cipLib: "KOGENATE BAY 3000UI FL+S.BIO BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5661918',
  CIP13: '3400956619184',
  ucdLib: "KOGENATE BAY 500UI FL+S.BIO",
  UCD7: '9264692',
  UCD13: '3400892646923',
  ucdQtyMultiplicator: 1,
  cipLib: "KOGENATE BAY 500UI FL+S.BIO BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5857426',
  CIP13: '3400958574269',
  ucdLib: "NOVOEIGHT 1000UI INJ FL+SRG",
  UCD7: '9397134',
  UCD13: '3400893971345',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOEIGHT 1000UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5857432',
  CIP13: '3400958574320',
  ucdLib: "NOVOEIGHT 1500UI INJ FL+SRG",
  UCD7: '9397140',
  UCD13: '3400893971406',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOEIGHT 1500UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5857449',
  CIP13: '3400958574498',
  ucdLib: "NOVOEIGHT 2000UI INJ FL+SRG",
  UCD7: '9397157',
  UCD13: '3400893971574',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOEIGHT 2000UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5857395',
  CIP13: '3400958573958',
  ucdLib: "NOVOEIGHT 250UI INJ FL+SRG",
  UCD7: '9397163',
  UCD13: '3400893971635',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOEIGHT 250UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5857455',
  CIP13: '3400958574559',
  ucdLib: "NOVOEIGHT 3000UI INJ FL+SRG",
  UCD7: '9397186',
  UCD13: '3400893971864',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOEIGHT 3000UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5857403',
  CIP13: '3400958574030',
  ucdLib: "NOVOEIGHT 500UI INJ FL+SRG",
  UCD7: '9397192',
  UCD13: '3400893971925',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVOEIGHT 500UI INJ FL+SRG BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5798787',
  CIP13: '3400957987879',
  ucdLib: "REFACTO AF 1000UI INJ SRG+MAT",
  UCD7: '9373636',
  UCD13: '3400893736364',
  ucdQtyMultiplicator: 1,
  cipLib: "REFACTO AF 1000UI INJ SRG+MAT BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5798793',
  CIP13: '3400957987930',
  ucdLib: "REFACTO AF 2000UI INJ SRG+MAT",
  UCD7: '9373642',
  UCD13: '3400893736425',
  ucdQtyMultiplicator: 1,
  cipLib: "REFACTO AF 2000UI INJ SRG+MAT BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5838363',
  CIP13: '3400958383632',
  ucdLib: "REFACTO AF 250UI INJ SRG +MAT",
  UCD7: '9390209',
  UCD13: '3400893902097',
  ucdQtyMultiplicator: 1,
  cipLib: "REFACTO AF 250UI INJ SRG +MAT BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5798801',
  CIP13: '3400957988012',
  ucdLib: "REFACTO AF 3000UI INJ SRG +MAT",
  UCD7: '9373599',
  UCD13: '3400893735992',
  ucdQtyMultiplicator: 1,
  cipLib: "REFACTO AF 3000UI INJ SRG +MAT BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5798770',
  CIP13: '3400957987701',
  ucdLib: "REFACTO AF 500UI INJ SRG+MAT",
  UCD7: '9373659',
  UCD13: '3400893736593',
  ucdQtyMultiplicator: 1,
  cipLib: "REFACTO AF 500UI INJ SRG+MAT BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5657874',
  CIP13: '3400956578740',
  ucdLib: "OCTANATE 100UI/ML INJ F+F10ML",
  UCD7: '9290413',
  UCD13: '3400892904139',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTANATE 100UI/ML INJ F+F10ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5657868',
  CIP13: '3400956578689',
  ucdLib: "OCTANATE 50UI/ML INJ F+F10ML",
  UCD7: '9290436',
  UCD13: '3400892904368',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTANATE 50UI/ML INJ F+F10ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5657851',
  CIP13: '3400956578511',
  ucdLib: "OCTANATE 50UI/ML INJ F+F5ML",
  UCD7: '9290442',
  UCD13: '3400892904429',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTANATE 50UI/ML INJ F+F5ML BT 1",
  atcCode: "B02BD02"
}, {
  CIP7: '5501663',
  CIP13: '3400955016632',
  ucdLib: "KOVALTRY 1000UI FL+SRG2,5ML",
  UCD7: '9416920',
  UCD13: '3400894169208',
  ucdQtyMultiplicator: 1,
  cipLib: "KOVALTRY 1000 UI Pdre/solv p sol inj adaptateur pour flacon Fl+Ser pr겯2,5ml",
  atcCode: "B02BD02"
}, {
  CIP7: '5501665',
  CIP13: '3400955016656',
  ucdLib: "KOVALTRY 2000UI FL+SRG5ML",
  UCD7: '9416937',
  UCD13: '3400894169376',
  ucdQtyMultiplicator: 1,
  cipLib: "KOVALTRY 2000 UI Pdre/solv p sol inj adaptateur pour flacon Fl+Ser pr겯5ml",
  atcCode: "B02BD02"
}, {
  CIP7: '5501659',
  CIP13: '3400955016595',
  ucdLib: "KOVALTRY 250UI FL+SRG2,5ML",
  UCD7: '9416943',
  UCD13: '3400894169437',
  ucdQtyMultiplicator: 1,
  cipLib: "KOVALTRY 250 UI Pdre/solv p sol inj adaptateur pour flacon Fl+Ser pr겯2,5ml",
  atcCode: "B02BD02"
}, {
  CIP7: '5501667',
  CIP13: '3400955016670',
  ucdLib: "KOVALTRY 3000UI FL+SRG5ML",
  UCD7: '9416966',
  UCD13: '3400894169666',
  ucdQtyMultiplicator: 1,
  cipLib: "KOVALTRY 3000 UI Pdre/solv p sol inj adaptateur pour flacon Fl+Ser pr겯5ml",
  atcCode: "B02BD02"
}, {
  CIP7: '5501661',
  CIP13: '3400955016618',
  ucdLib: "KOVALTRY 500UI FL+SRG2,5ML",
  UCD7: '9416972',
  UCD13: '3400894169727',
  ucdQtyMultiplicator: 1,
  cipLib: "KOVALTRY 500 UI Pdre/solv p sol inj adaptateur pour flacon Fl+Ser pr겯2,5ml",
  atcCode: "B02BD02"
}, {
  CIP7: '5740345',
  CIP13: '3400957403454',
  ucdLib: "CONFIDEX 250UI INJ FL+FL",
  UCD7: '9324046',
  UCD13: '3400893240465',
  ucdQtyMultiplicator: 1,
  cipLib: "CONFIDEX 250UI INJ FL+FL BT 1",
  atcCode: "B02BD01"
}, {
  CIP7: '5740291',
  CIP13: '3400957402914',
  ucdLib: "CONFIDEX 500UI INJ FL+FL",
  UCD7: '9324052',
  UCD13: '3400893240526',
  ucdQtyMultiplicator: 1,
  cipLib: "CONFIDEX 500UI INJ FL+FL BT 1",
  atcCode: "B02BD01"
}, {
  CIP7: '5851613',
  CIP13: '3400958516139',
  ucdLib: "CONFIDEX 1000UI INJ FL+FL",
  UCD7: '9394905',
  UCD13: '3400893949054',
  ucdQtyMultiplicator: 1,
  cipLib: "CONFIDEX 1000UI INJ FL+FL BT 1",
  atcCode: "B02BD01"
}, {
  CIP7: '5738638',
  CIP13: '3400957386382',
  ucdLib: "KANOKAD 250UI INJ FL+FL",
  UCD7: '9328788',
  UCD13: '3400893287880',
  ucdQtyMultiplicator: 1,
  cipLib: "KANOKAD 250UI INJ FL+FL BT 1",
  atcCode: "B02BD01"
}, {
  CIP7: '5738644',
  CIP13: '3400957386443',
  ucdLib: "KANOKAD 500UI INJ FL+FL",
  UCD7: '9328794',
  UCD13: '3400893287941',
  ucdQtyMultiplicator: 1,
  cipLib: "KANOKAD 500UI INJ FL+FL BT 1",
  atcCode: "B02BD01"
}, {
  CIP7: '5661060',
  CIP13: '3400956610600',
  ucdLib: "OCTAPLEX 500UI PERF FL+FL +N",
  UCD7: '9271798',
  UCD13: '3400892717982',
  ucdQtyMultiplicator: 1,
  cipLib: "OCTAPLEX 500UI PERF FL+FL +N BT 1",
  atcCode: "B02BD01"
}, {
  CIP7: '5620925',
  CIP13: '3400956209255',
  ucdLib: "TISSUCOL KIT 1ML FL+FL+NEC",
  UCD7: '9178656',
  UCD13: '3400891786569',
  ucdQtyMultiplicator: 1,
  cipLib: "TISSUCOL KIT 1ML FL+FL+NEC BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5620894',
  CIP13: '3400956208944',
  ucdLib: "TISSUCOL KIT 2ML FL+FL+NEC",
  UCD7: '9178662',
  UCD13: '3400891786620',
  ucdQtyMultiplicator: 1,
  cipLib: "TISSUCOL KIT 2ML FL+FL+NEC BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5620902',
  CIP13: '3400956209026',
  ucdLib: "TISSUCOL KIT 5ML FL+FL+NEC",
  UCD7: '9178679',
  UCD13: '3400891786798',
  ucdQtyMultiplicator: 1,
  cipLib: "TISSUCOL KIT 5ML FL+FL+NEC BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5500335',
  CIP13: '3400955003359',
  ucdLib: "EVARREST 5,1*10,2CM COLLE S.",
  UCD7: '9413991',
  UCD13: '3400894139911',
  ucdQtyMultiplicator: 2,
  cipLib: "EVARREST 5,1*10,2CM COLLE S. BT 2",
  atcCode: "B02BC30"
}, {
  CIP7: '5500125',
  CIP13: '3400955001256',
  ucdLib: "TACHOSIL MATRICE 4,8X4,8CM PR",
  UCD7: '9411348',
  UCD13: '3400894113485',
  ucdQtyMultiplicator: 1,
  cipLib: "TACHOSIL MATRICE 4,8X4,8CM PR BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5500092',
  CIP13: '3400955000921',
  ucdLib: "TISSEEL SOL PR COLLE SYST10ML",
  UCD7: '9407111',
  UCD13: '3400894071112',
  ucdQtyMultiplicator: 1,
  cipLib: "TISSEEL SOL PR COLLE SYST10ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5500089',
  CIP13: '3400955000891',
  ucdLib: "TISSEEL SOL PR COLLE SYST2ML",
  UCD7: '9407128',
  UCD13: '3400894071280',
  ucdQtyMultiplicator: 1,
  cipLib: "TISSEEL SOL PR COLLE SYST2ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5500091',
  CIP13: '3400955000914',
  ucdLib: "TISSEEL SOL PR COLLE SYST4ML",
  UCD7: '9407134',
  UCD13: '3400894071341',
  ucdQtyMultiplicator: 1,
  cipLib: "TISSEEL SOL PR COLLE SYST4ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5755766',
  CIP13: '3400957557669',
  ucdLib: "ARTISS COLLE CONG SRG1ML",
  UCD7: '9340849',
  UCD13: '3400893408490',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTISS COLLE CONG SRG1ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5755772',
  CIP13: '3400957557720',
  ucdLib: "ARTISS COLLE CONG SRG2ML",
  UCD7: '9340855',
  UCD13: '3400893408551',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTISS COLLE CONG SRG2ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5755789',
  CIP13: '3400957557898',
  ucdLib: "ARTISS COLLE CONG SRG5ML",
  UCD7: '9340861',
  UCD13: '3400893408612',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTISS COLLE CONG SRG5ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5754637',
  CIP13: '3400957546373',
  ucdLib: "EVICEL SOL PR COLLE FL+FL1ML",
  UCD7: '9348213',
  UCD13: '3400893482131',
  ucdQtyMultiplicator: 1,
  cipLib: "EVICEL SOL PR COLLE FL+FL1ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5754643',
  CIP13: '3400957546434',
  ucdLib: "EVICEL SOL PR COLLE FL+FL2ML",
  UCD7: '9348236',
  UCD13: '3400893482360',
  ucdQtyMultiplicator: 1,
  cipLib: "EVICEL SOL PR COLLE FL+FL2ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5754666',
  CIP13: '3400957546663',
  ucdLib: "EVICEL SOL PR COLLE FL+FL5ML",
  UCD7: '9348242',
  UCD13: '3400893482421',
  ucdQtyMultiplicator: 1,
  cipLib: "EVICEL SOL PR COLLE FL+FL5ML BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '5658081',
  CIP13: '3400956580811',
  ucdLib: "TACHOSIL MATRICE 4,8X4,8CM",
  UCD7: '9269092',
  UCD13: '3400892690926',
  ucdQtyMultiplicator: 2,
  cipLib: "TACHOSIL MATRICE 4,8X4,8CM BT 2",
  atcCode: "B02BC30"
}, {
  CIP7: '5658075',
  CIP13: '3400956580750',
  ucdLib: "TACHOSIL MATRICE 9,5X4,8CM",
  UCD7: '9266308',
  UCD13: '3400892663081',
  ucdQtyMultiplicator: 1,
  cipLib: "TACHOSIL MATRICE 9,5X4,8CM BT 1",
  atcCode: "B02BC30"
}, {
  CIP7: '4948842',
  CIP13: '3400949488421',
  ucdLib: "RIASTAP 1G INJ FL",
  UCD7: '9360527',
  UCD13: '3400893605271',
  ucdQtyMultiplicator: 1,
  cipLib: "RIASTAP 1G INJ FL BT 1",
  atcCode: "B02BB01"
}, {
  CIP7: '5749719',
  CIP13: '3400957497194',
  ucdLib: "CLOTTAFACT 1,5G/100ML FL+FL",
  UCD7: '9332620',
  UCD13: '3400893326206',
  ucdQtyMultiplicator: 1,
  cipLib: "CLOTTAFACT 1,5G/100ML FL+FL BT 1",
  atcCode: "B02BB01"
}, {
  CIP7: '3483022',
  CIP13: '3400934830228',
  ucdLib: "VIT K1 ROCHE 10MG B/I A.1ML+P",
  UCD7: '9209948',
  UCD13: '3400892099484',
  ucdQtyMultiplicator: 3,
  cipLib: "VIT K1 ROCHE 10MG B/I A.1ML+P BT 3",
  atcCode: "B02BA01"
}, {
  CIP7: '3486463',
  CIP13: '3400934864636',
  ucdLib: "VIT K1 ROCHE 2MG B/I A.0,2ML",
  UCD7: '9223440',
  UCD13: '3400892234403',
  ucdQtyMultiplicator: 5,
  cipLib: "VIT K1 ROCHE 2MG B/I A.0,2ML BT 5",
  atcCode: "B02BA01"
}, {
  CIP7: '5793761',
  CIP13: '3400957937614',
  ucdLib: "ALFALASTIN 33,33MG F+F120ML +N",
  UCD7: '9382084',
  UCD13: '3400893820841',
  ucdQtyMultiplicator: 1,
  cipLib: "ALFALASTIN 33,33MG F+F120ML +N BT 1",
  atcCode: "B02AB02"
}, {
  CIP7: '5661189',
  CIP13: '3400956611898',
  ucdLib: "ALFALASTIN 33,33MG F+F30ML +N",
  UCD7: '9275715',
  UCD13: '3400892757155',
  ucdQtyMultiplicator: 1,
  cipLib: "ALFALASTIN 33,33MG F+F30ML +N BT 1",
  atcCode: "B02AB02"
}, {
  CIP7: '5572221',
  CIP13: '3400955722212',
  ucdLib: "TRASYLOL 500000U INJ FL50ML",
  UCD7: '9150190',
  UCD13: '3400891501902',
  ucdQtyMultiplicator: 1,
  cipLib: "TRASYLOL 500000U INJ FL50ML BT 1",
  atcCode: "B02AB01"
}, {
  CIP7: '3285552',
  CIP13: '3400932855520',
  ucdLib: "EXACYL 500MG CPR PELLIC",
  UCD7: '9120852',
  UCD13: '3400891208528',
  ucdQtyMultiplicator: 20,
  cipLib: "EXACYL 500MG CPR PELLIC BT 20",
  atcCode: "B02AA02"
}, {
  CIP7: '3115761',
  CIP13: '3400931157618',
  ucdLib: "EXACYL 0,5G IV AMP5ML",
  UCD7: '9034064',
  UCD13: '3400890340649',
  ucdQtyMultiplicator: 5,
  cipLib: "EXACYL 0,5G IV AMP5ML BT 5",
  atcCode: "B02AA02"
}, {
  CIP7: '3115755',
  CIP13: '3400931157557',
  ucdLib: "EXACYL 1G/10ML BUV AMP",
  UCD7: '9034058',
  UCD13: '3400890340588',
  ucdQtyMultiplicator: 5,
  cipLib: "EXACYL 1G/10ML BUV AMP BT 5",
  atcCode: "B02AA02"
}, {
  CIP7: '3389961',
  CIP13: '3400933899615',
  ucdLib: "SPOTOF 1G/10ML BUV AMP",
  UCD7: '9185449',
  UCD13: '3400891854497',
  ucdQtyMultiplicator: 5,
  cipLib: "SPOTOF 1G/10ML BUV AMP BT 5",
  atcCode: "B02AA02"
}, {
  CIP7: '3389955',
  CIP13: '3400933899554',
  ucdLib: "SPOTOF 500MG CPR",
  UCD7: '9185455',
  UCD13: '3400891854558',
  ucdQtyMultiplicator: 20,
  cipLib: "SPOTOF 500MG CPR BT 20",
  atcCode: "B02AA02"
}, {
  CIP7: '3656534',
  CIP13: '3400936565340',
  ucdLib: "ARIXTRA 10MG/0,8ML INJ SRG",
  UCD7: '9280768',
  UCD13: '3400892807683',
  ucdQtyMultiplicator: 2,
  cipLib: "ARIXTRA 10MG/0,8ML INJ SRG BT 2",
  atcCode: "B01AX05"
}, {
  CIP7: '3656557',
  CIP13: '3400936565579',
  ucdLib: "ARIXTRA 10MG/0,8ML INJ SRG",
  UCD7: '9280768',
  UCD13: '3400892807683',
  ucdQtyMultiplicator: 10,
  cipLib: "ARIXTRA 10MG/0,8ML INJ SRG BT 10",
  atcCode: "B01AX05"
}, {
  CIP7: '3592254',
  CIP13: '3400935922540',
  ucdLib: "ARIXTRA 2,5MG/0,5ML INJ SRG",
  UCD7: '9238275',
  UCD13: '3400892382753',
  ucdQtyMultiplicator: 2,
  cipLib: "ARIXTRA 2,5MG/0,5ML INJ SRG BT 2",
  atcCode: "B01AX05"
}, {
  CIP7: '3592260',
  CIP13: '3400935922601',
  ucdLib: "ARIXTRA 2,5MG/0,5ML INJ SRG",
  UCD7: '9238275',
  UCD13: '3400892382753',
  ucdQtyMultiplicator: 7,
  cipLib: "ARIXTRA 2,5MG/0,5ML INJ SRG BT 7",
  atcCode: "B01AX05"
}, {
  CIP7: '3656474',
  CIP13: '3400936564749',
  ucdLib: "ARIXTRA 5MG/0,4ML INJ SRG",
  UCD7: '9280774',
  UCD13: '3400892807744',
  ucdQtyMultiplicator: 2,
  cipLib: "ARIXTRA 5MG/0,4ML INJ SRG BT 2",
  atcCode: "B01AX05"
}, {
  CIP7: '3656497',
  CIP13: '3400936564978',
  ucdLib: "ARIXTRA 5MG/0,4ML INJ SRG",
  UCD7: '9280774',
  UCD13: '3400892807744',
  ucdQtyMultiplicator: 10,
  cipLib: "ARIXTRA 5MG/0,4ML INJ SRG BT 10",
  atcCode: "B01AX05"
}, {
  CIP7: '3656505',
  CIP13: '3400936565050',
  ucdLib: "ARIXTRA 7,5MG/0,6ML INJ SRG",
  UCD7: '9280780',
  UCD13: '3400892807805',
  ucdQtyMultiplicator: 2,
  cipLib: "ARIXTRA 7,5MG/0,6ML INJ SRG BT 2",
  atcCode: "B01AX05"
}, {
  CIP7: '3656528',
  CIP13: '3400936565289',
  ucdLib: "ARIXTRA 7,5MG/0,6ML INJ SRG",
  UCD7: '9280780',
  UCD13: '3400892807805',
  ucdQtyMultiplicator: 10,
  cipLib: "ARIXTRA 7,5MG/0,6ML INJ SRG BT 10",
  atcCode: "B01AX05"
}, {
  CIP7: '5636197',
  CIP13: '3400956361977',
  ucdLib: "ARIXTRA 2,5MG/0,5ML INJ SRG",
  UCD7: '9238275',
  UCD13: '3400892382753',
  ucdQtyMultiplicator: 10,
  cipLib: "ARIXTRA 2,5MG/0,5ML INJ SRG BT 10",
  atcCode: "B01AX05"
}, {
  CIP7: '5857946',
  CIP13: '3400958579462',
  ucdLib: "DEFITELIO 80MG/ML INJ FL2,5ML",
  UCD7: '9401172',
  UCD13: '3400894011729',
  ucdQtyMultiplicator: 10,
  cipLib: "DEFITELIO 80MG/ML INJ FL2,5ML BT 10",
  atcCode: "B01AX01"
}, {
  CIP7: '4194544',
  CIP13: '3400941945441',
  ucdLib: "ELIQUIS 2,5MG CPR",
  UCD7: '9372571',
  UCD13: '3400893725719',
  ucdQtyMultiplicator: 10,
  cipLib: "ELIQUIS 2,5MG CPR BT 10",
  atcCode: "B01AF02"
}, {
  CIP7: '4194550',
  CIP13: '3400941945502',
  ucdLib: "ELIQUIS 2,5MG CPR",
  UCD7: '9372571',
  UCD13: '3400893725719',
  ucdQtyMultiplicator: 20,
  cipLib: "ELIQUIS 2,5MG CPR BT 20",
  atcCode: "B01AF02"
}, {
  CIP7: '4194567',
  CIP13: '3400941945670',
  ucdLib: "ELIQUIS 2,5MG CPR",
  UCD7: '9372571',
  UCD13: '3400893725719',
  ucdQtyMultiplicator: 60,
  cipLib: "ELIQUIS 2,5MG CPR BT 60",
  atcCode: "B01AF02"
}, {
  CIP7: '4194573',
  CIP13: '3400941945731',
  ucdLib: "ELIQUIS 2,5MG CPR",
  UCD7: '9372571',
  UCD13: '3400893725719',
  ucdQtyMultiplicator: 60,
  cipLib: "ELIQUIS 2,5MG CPR BT 60",
  atcCode: "B01AF02"
}, {
  CIP7: '2678410',
  CIP13: '3400926784102',
  ucdLib: "ELIQUIS 5MG CPR",
  UCD7: '9388773',
  UCD13: '3400893887738',
  ucdQtyMultiplicator: 60,
  cipLib: "ELIQUIS 5MG CPR BT 60",
  atcCode: "B01AF02"
}, {
  CIP7: '5838073',
  CIP13: '3400958380730',
  ucdLib: "ELIQUIS 5MG CPR",
  UCD7: '9388773',
  UCD13: '3400893887738',
  ucdQtyMultiplicator: 100,
  cipLib: "ELIQUIS 5MG CPR BT 100",
  atcCode: "B01AF02"
}, {
  CIP7: '4950678',
  CIP13: '3400949506781',
  ucdLib: "XARELTO 10MG CPR ADP MWI",
  UCD7: '9394986',
  UCD13: '3400893949863',
  ucdQtyMultiplicator: 30,
  cipLib: "XARELTO 10MG CPR ADP MWI BT 30",
  atcCode: "B01AF01"
}, {
  CIP7: '3883810',
  CIP13: '3400938838107',
  ucdLib: "XARELTO 10MG CPR PELLIC",
  UCD7: '9323443',
  UCD13: '3400893234433',
  ucdQtyMultiplicator: 5,
  cipLib: "XARELTO 10MG CPR PELLIC BT 5",
  atcCode: "B01AF01"
}, {
  CIP7: '3883827',
  CIP13: '3400938838275',
  ucdLib: "XARELTO 10MG CPR PELLIC",
  UCD7: '9323443',
  UCD13: '3400893234433',
  ucdQtyMultiplicator: 10,
  cipLib: "XARELTO 10MG CPR PELLIC BT 10",
  atcCode: "B01AF01"
}, {
  CIP7: '3883833',
  CIP13: '3400938838336',
  ucdLib: "XARELTO 10MG CPR PELLIC",
  UCD7: '9323443',
  UCD13: '3400893234433',
  ucdQtyMultiplicator: 30,
  cipLib: "XARELTO 10MG CPR PELLIC BT 30",
  atcCode: "B01AF01"
}, {
  CIP7: '2192251',
  CIP13: '3400921922516',
  ucdLib: "XARELTO 15MG CPR PELLIC",
  UCD7: '9384166',
  UCD13: '3400893841662',
  ucdQtyMultiplicator: 14,
  cipLib: "XARELTO 15MG CPR PELLIC BT 14",
  atcCode: "B01AF01"
}, {
  CIP7: '2192268',
  CIP13: '3400921922684',
  ucdLib: "XARELTO 15MG CPR PELLIC",
  UCD7: '9384166',
  UCD13: '3400893841662',
  ucdQtyMultiplicator: 28,
  cipLib: "XARELTO 15MG CPR PELLIC BT 28",
  atcCode: "B01AF01"
}, {
  CIP7: '2192274',
  CIP13: '3400921922745',
  ucdLib: "XARELTO 15MG CPR PELLIC",
  UCD7: '9384166',
  UCD13: '3400893841662',
  ucdQtyMultiplicator: 42,
  cipLib: "XARELTO 15MG CPR PELLIC BT 42",
  atcCode: "B01AF01"
}, {
  CIP7: '2192305',
  CIP13: '3400921923056',
  ucdLib: "XARELTO 20MG CPR PELLIC",
  UCD7: '9384172',
  UCD13: '3400893841723',
  ucdQtyMultiplicator: 28,
  cipLib: "XARELTO 20MG CPR PELLIC BT 28",
  atcCode: "B01AF01"
}, {
  CIP7: '5736289',
  CIP13: '3400957362898',
  ucdLib: "XARELTO 10MG CPR PELLIC",
  UCD7: '9323443',
  UCD13: '3400893234433',
  ucdQtyMultiplicator: 100,
  cipLib: "XARELTO 10MG CPR PELLIC BT 100",
  atcCode: "B01AF01"
}, {
  CIP7: '5814167',
  CIP13: '3400958141676',
  ucdLib: "XARELTO 15MG CPR PELLIC",
  UCD7: '9384166',
  UCD13: '3400893841662',
  ucdQtyMultiplicator: 100,
  cipLib: "XARELTO 15MG CPR PELLIC BT 100",
  atcCode: "B01AF01"
}, {
  CIP7: '5814196',
  CIP13: '3400958141966',
  ucdLib: "XARELTO 20MG CPR PELLIC",
  UCD7: '9384172',
  UCD13: '3400893841723',
  ucdQtyMultiplicator: 100,
  cipLib: "XARELTO 20MG CPR PELLIC BT 100",
  atcCode: "B01AF01"
}, {
  CIP7: '3852608',
  CIP13: '3400938526080',
  ucdLib: "PRADAXA 110MG GELU",
  UCD7: '9320829',
  UCD13: '3400893208298',
  ucdQtyMultiplicator: 10,
  cipLib: "PRADAXA 110MG GELU BT 10",
  atcCode: "B01AE07"
}, {
  CIP7: '3852614',
  CIP13: '3400938526141',
  ucdLib: "PRADAXA 110MG GELU",
  UCD7: '9320829',
  UCD13: '3400893208298',
  ucdQtyMultiplicator: 30,
  cipLib: "PRADAXA 110MG GELU BT 30",
  atcCode: "B01AE07"
}, {
  CIP7: '3852620',
  CIP13: '3400938526202',
  ucdLib: "PRADAXA 110MG GELU",
  UCD7: '9320829',
  UCD13: '3400893208298',
  ucdQtyMultiplicator: 60,
  cipLib: "PRADAXA 110MG GELU BT 60",
  atcCode: "B01AE07"
}, {
  CIP7: '3852554',
  CIP13: '3400938525540',
  ucdLib: "PRADAXA 75MG GELU",
  UCD7: '9320835',
  UCD13: '3400893208359',
  ucdQtyMultiplicator: 10,
  cipLib: "PRADAXA 75MG GELU BT 10",
  atcCode: "B01AE07"
}, {
  CIP7: '3852560',
  CIP13: '3400938525601',
  ucdLib: "PRADAXA 75MG GELU",
  UCD7: '9320835',
  UCD13: '3400893208359',
  ucdQtyMultiplicator: 30,
  cipLib: "PRADAXA 75MG GELU BT 30",
  atcCode: "B01AE07"
}, {
  CIP7: '3852577',
  CIP13: '3400938525779',
  ucdLib: "PRADAXA 75MG GELU",
  UCD7: '9320835',
  UCD13: '3400893208359',
  ucdQtyMultiplicator: 60,
  cipLib: "PRADAXA 75MG GELU BT 60",
  atcCode: "B01AE07"
}, {
  CIP7: '4194538',
  CIP13: '3400941945380',
  ucdLib: "PRADAXA 150MG GELU",
  UCD7: '9374446',
  UCD13: '3400893744468',
  ucdQtyMultiplicator: 60,
  cipLib: "PRADAXA 150MG GELU BT 60",
  atcCode: "B01AE07"
}, {
  CIP7: '5661930',
  CIP13: '3400956619306',
  ucdLib: "ANGIOX 250MG PERF FL",
  UCD7: '9269583',
  UCD13: '3400892695839',
  ucdQtyMultiplicator: 10,
  cipLib: "ANGIOX 250MG PERF FL BT 10",
  atcCode: "B01AE06"
}, {
  CIP7: '4169687',
  CIP13: '3400941696879',
  ucdLib: "ARGANOVA 100MG/ML INJ FL2,5ML",
  UCD7: '9372039',
  UCD13: '3400893720394',
  ucdQtyMultiplicator: 1,
  cipLib: "ARGANOVA 100MG/ML INJ FL2,5ML BT 1",
  atcCode: "B01AE03"
}, {
  CIP7: '5633885',
  CIP13: '3400956338856',
  ucdLib: "PROTEXEL 50UI/ML INJ FV+FV",
  UCD7: '9234047',
  UCD13: '3400892340470',
  ucdQtyMultiplicator: 1,
  cipLib: "PROTEXEL 50UI/ML INJ FV+FV BT 1",
  atcCode: "B01AD12"
}, {
  CIP7: '5649260',
  CIP13: '3400956492602',
  ucdLib: "METALYSE 10000U INJ FL+SRG",
  UCD7: '9227774',
  UCD13: '3400892277745',
  ucdQtyMultiplicator: 1,
  cipLib: "METALYSE 10000U INJ FL+SRG BT 1",
  atcCode: "B01AD11"
}, {
  CIP7: '5600466',
  CIP13: '3400956004669',
  ucdLib: "RAPILYSIN 10U INJ FL+SRG",
  UCD7: '9184214',
  UCD13: '3400891842142',
  ucdQtyMultiplicator: 2,
  cipLib: "RAPILYSIN 10U INJ FL+SRG BT 2",
  atcCode: "B01AD07"
}, {
  CIP7: '5595400',
  CIP13: '3400955954002',
  ucdLib: "UKIDAN 1000000UI INJ FL+AMP",
  UCD7: '9191065',
  UCD13: '3400891910650',
  ucdQtyMultiplicator: 1,
  cipLib: "UKIDAN 1000000UI INJ FL+AMP BT 1",
  atcCode: "B01AD04"
}, {
  CIP7: '5651067',
  CIP13: '3400956510672',
  ucdLib: "ACTOSOLV UROK.100M INJ FL",
  UCD7: '9262285',
  UCD13: '3400892622859',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTOSOLV UROK.100M INJ FL BT 1",
  atcCode: "B01AD04"
}, {
  CIP7: '5651073',
  CIP13: '3400956510733',
  ucdLib: "ACTOSOLV UROK.600M INJ FL",
  UCD7: '9262291',
  UCD13: '3400892622910',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTOSOLV UROK.600M INJ FL BT 1",
  atcCode: "B01AD04"
}, {
  CIP7: '5571842',
  CIP13: '3400955718420',
  ucdLib: "ACTILYSE INJ FL+FL10ML",
  UCD7: '9156873',
  UCD13: '3400891568738',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTILYSE INJ FL+FL10ML BT 1",
  atcCode: "B01AD02"
}, {
  CIP7: '5585293',
  CIP13: '3400955852933',
  ucdLib: "ACTILYSE INJ FL+FL20ML +CAN",
  UCD7: '9122584',
  UCD13: '3400891225846',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTILYSE INJ FL+FL20ML +CAN BT 1",
  atcCode: "B01AD02"
}, {
  CIP7: '5585301',
  CIP13: '3400955853015',
  ucdLib: "ACTILYSE INJ FL+FL50ML +CAN",
  UCD7: '9122590',
  UCD13: '3400891225907',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTILYSE INJ FL+FL50ML +CAN BT 1",
  atcCode: "B01AD02"
}, {
  CIP7: '5741942',
  CIP13: '3400957419424',
  ucdLib: "ACTILYSE 2MG INJ FL",
  UCD7: '9343339',
  UCD13: '3400893433393',
  ucdQtyMultiplicator: 5,
  cipLib: "ACTILYSE 2MG INJ FL BT 5",
  atcCode: "B01AD02"
}, {
  CIP7: '3432349',
  CIP13: '3400934323492',
  ucdLib: "ASASANTINE LP GELU",
  UCD7: '9200137',
  UCD13: '3400892001371',
  ucdQtyMultiplicator: 60,
  cipLib: "ASASANTINE LP GELU BT 60",
  atcCode: "B01AC30"
}, {
  CIP7: '3590226',
  CIP13: '3400935902269',
  ucdLib: "DUOPLAVIN 75/75MG CPR D.U",
  UCD7: '9347840',
  UCD13: '3400893478400',
  ucdQtyMultiplicator: 30,
  cipLib: "DUOPLAVIN 75/75MG CPR D.U BT 30",
  atcCode: "B01AC30"
}, {
  CIP7: '3820637',
  CIP13: '3400938206371',
  ucdLib: "DUOPLAVIN 75/75MG CPR D.U",
  UCD7: '9347840',
  UCD13: '3400893478400',
  ucdQtyMultiplicator: 30,
  cipLib: "DUOPLAVIN 75/75MG CPR D.U BT 30",
  atcCode: "B01AC30"
}, {
  CIP7: '3006122',
  CIP13: '3400930061220',
  ucdLib: "UPTRAVI 1000MCG CPR PELL",
  UCD7: '9416073',
  UCD13: '3400894160731',
  ucdQtyMultiplicator: 60,
  cipLib: "UPTRAVI 1000MCG CPR PELL BT 60",
  atcCode: "B01AC27"
}, {
  CIP7: '3006123',
  CIP13: '3400930061237',
  ucdLib: "UPTRAVI 1200MCG CPR PELL",
  UCD7: '9416096',
  UCD13: '3400894160960',
  ucdQtyMultiplicator: 60,
  cipLib: "UPTRAVI 1200MCG CPR PELL BT 60",
  atcCode: "B01AC27"
}, {
  CIP7: '3006124',
  CIP13: '3400930061244',
  ucdLib: "UPTRAVI 1400MCG CPR PELL",
  UCD7: '9416104',
  UCD13: '3400894161042',
  ucdQtyMultiplicator: 60,
  cipLib: "UPTRAVI 1400MCG CPR PELL BT 60",
  atcCode: "B01AC27"
}, {
  CIP7: '3006125',
  CIP13: '3400930061251',
  ucdLib: "UPTRAVI 1600MCG CPR PELL",
  UCD7: '9416110',
  UCD13: '3400894161103',
  ucdQtyMultiplicator: 60,
  cipLib: "UPTRAVI 1600MCG CPR PELL BT 60",
  atcCode: "B01AC27"
}, {
  CIP7: '3006116',
  CIP13: '3400930061169',
  ucdLib: "UPTRAVI 200MCG CPR PELL",
  UCD7: '9416127',
  UCD13: '3400894161271',
  ucdQtyMultiplicator: 60,
  cipLib: "UPTRAVI 200MCG CPR PELL BT 60",
  atcCode: "B01AC27"
}, {
  CIP7: '3006117',
  CIP13: '3400930061176',
  ucdLib: "UPTRAVI 200MCG CPR PELL +CO",
  UCD7: '9416133',
  UCD13: '3400894161332',
  ucdQtyMultiplicator: 140,
  cipLib: "UPTRAVI 200MCG CPR PELL +CO BT 140",
  atcCode: "B01AC27"
}, {
  CIP7: '3006118',
  CIP13: '3400930061183',
  ucdLib: "UPTRAVI 400MCG CPR PELL",
  UCD7: '9416156',
  UCD13: '3400894161561',
  ucdQtyMultiplicator: 60,
  cipLib: "UPTRAVI 400MCG CPR PELL BT 60",
  atcCode: "B01AC27"
}, {
  CIP7: '3006119',
  CIP13: '3400930061190',
  ucdLib: "UPTRAVI 600MCG CPR PELL",
  UCD7: '9416162',
  UCD13: '3400894161622',
  ucdQtyMultiplicator: 60,
  cipLib: "UPTRAVI 600MCG CPR PELL BT 60",
  atcCode: "B01AC27"
}, {
  CIP7: '3006120',
  CIP13: '3400930061206',
  ucdLib: "UPTRAVI 800MCG CPR PELL",
  UCD7: '9416179',
  UCD13: '3400894161790',
  ucdQtyMultiplicator: 60,
  cipLib: "UPTRAVI 800MCG CPR PELL BT 60",
  atcCode: "B01AC27"
}, {
  CIP7: '4988741',
  CIP13: '3400949887415',
  ucdLib: "BRILIQUE 90MG CPR",
  UCD7: '9380441',
  UCD13: '3400893804414',
  ucdQtyMultiplicator: 60,
  cipLib: "BRILIQUE 90MG CPR BT 60",
  atcCode: "B01AC24"
}, {
  CIP7: '5789400',
  CIP13: '3400957894009',
  ucdLib: "BRILIQUE 90MG CPR",
  UCD7: '9380441',
  UCD13: '3400893804414',
  ucdQtyMultiplicator: 100,
  cipLib: "BRILIQUE 90MG CPR BT 100",
  atcCode: "B01AC24"
}, {
  CIP7: '3987969',
  CIP13: '3400939879697',
  ucdLib: "EFIENT 10MG CPR",
  UCD7: '9328417',
  UCD13: '3400893284179',
  ucdQtyMultiplicator: 30,
  cipLib: "EFIENT 10MG CPR BT 30",
  atcCode: "B01AC22"
}, {
  CIP7: '5745302',
  CIP13: '3400957453022',
  ucdLib: "EFIENT 10MG CPR",
  UCD7: '9328417',
  UCD13: '3400893284179',
  ucdQtyMultiplicator: 90,
  cipLib: "EFIENT 10MG CPR BT 90",
  atcCode: "B01AC22"
}, {
  CIP7: '3681644',
  CIP13: '3400936816442',
  ucdLib: "REMODULIN 10MG/ML PERF FV20ML",
  UCD7: '9271545',
  UCD13: '3400892715452',
  ucdQtyMultiplicator: 1,
  cipLib: "REMODULIN 10MG/ML PERF FV20ML BT 1",
  atcCode: "B01AC21"
}, {
  CIP7: '3681615',
  CIP13: '3400936816152',
  ucdLib: "REMODULIN 1MG/ML PERF FV20ML",
  UCD7: '9271539',
  UCD13: '3400892715391',
  ucdQtyMultiplicator: 1,
  cipLib: "REMODULIN 1MG/ML PERF FV20ML BT 1",
  atcCode: "B01AC21"
}, {
  CIP7: '3681621',
  CIP13: '3400936816213',
  ucdLib: "REMODULIN 2,5MG/ML PERF FV20ML",
  UCD7: '9271551',
  UCD13: '3400892715513',
  ucdQtyMultiplicator: 1,
  cipLib: "REMODULIN 2,5MG/ML PERF FV20ML BT 1",
  atcCode: "B01AC21"
}, {
  CIP7: '3681638',
  CIP13: '3400936816381',
  ucdLib: "REMODULIN 5MG/ML PERF FV20ML",
  UCD7: '9271568',
  UCD13: '3400892715681',
  ucdQtyMultiplicator: 1,
  cipLib: "REMODULIN 5MG/ML PERF FV20ML BT 1",
  atcCode: "B01AC21"
}, {
  CIP7: '5621675',
  CIP13: '3400956216758',
  ucdLib: "AGRASTAT 250MCG/ML INJ FL50ML",
  UCD7: '9213430',
  UCD13: '3400892134307',
  ucdQtyMultiplicator: 1,
  cipLib: "AGRASTAT 250MCG/ML INJ FL50ML BT 1",
  atcCode: "B01AC17"
}, {
  CIP7: '5632325',
  CIP13: '3400956323258',
  ucdLib: "AGRASTAT 50MCG/ML INJ P.250ML",
  UCD7: '9231646',
  UCD13: '3400892316468',
  ucdQtyMultiplicator: 1,
  cipLib: "AGRASTAT 50MCG/ML INJ P.250ML BT 1",
  atcCode: "B01AC17"
}, {
  CIP7: '5859891',
  CIP13: '3400958598913',
  ucdLib: "TIROFIBAN MDC 50MCG/ML P250ML",
  UCD7: '9398205',
  UCD13: '3400893982051',
  ucdQtyMultiplicator: 1,
  cipLib: "TIROFIBAN MDC 50MCG/ML P250ML BT 1",
  atcCode: "B01AC17"
}, {
  CIP7: '5621770',
  CIP13: '3400956217700',
  ucdLib: "INTEGRILIN 0,75MG/ML PERF100ML",
  UCD7: '9214205',
  UCD13: '3400892142050',
  ucdQtyMultiplicator: 1,
  cipLib: "INTEGRILIN 0,75MG/ML PERF100ML BT 1",
  atcCode: "B01AC16"
}, {
  CIP7: '5621787',
  CIP13: '3400956217878',
  ucdLib: "INTEGRILIN 2MG/ML INJ FL10ML",
  UCD7: '9214211',
  UCD13: '3400892142111',
  ucdQtyMultiplicator: 1,
  cipLib: "INTEGRILIN 2MG/ML INJ FL10ML BT 1",
  atcCode: "B01AC16"
}, {
  CIP7: '5588110',
  CIP13: '3400955881100',
  ucdLib: "REOPRO 2MG/ML INJ FL5ML",
  UCD7: '9173877',
  UCD13: '3400891738773',
  ucdQtyMultiplicator: 1,
  cipLib: "REOPRO 2MG/ML INJ FL5ML BT 1",
  atcCode: "B01AC13"
}, {
  CIP7: '5578896',
  CIP13: '3400955788966',
  ucdLib: "ILOMEDINE 0,05MG INJ A.0,5ML",
  UCD7: '9160461',
  UCD13: '3400891604610',
  ucdQtyMultiplicator: 5,
  cipLib: "ILOMEDINE 0,05MG INJ A.0,5ML BT 5",
  atcCode: "B01AC11"
}, {
  CIP7: '3754805',
  CIP13: '3400937548052',
  ucdLib: "VENTAVIS 10MCG/ML NEB A.1ML",
  UCD7: '9297467',
  UCD13: '3400892974675',
  ucdQtyMultiplicator: 30,
  cipLib: "VENTAVIS 10MCG/ML NEB A.1ML BT 30",
  atcCode: "B01AC11"
}, {
  CIP7: '5649202',
  CIP13: '3400956492022',
  ucdLib: "VENTAVIS 10MCG/ML NEB A.2ML",
  UCD7: '9256965',
  UCD13: '3400892569659',
  ucdQtyMultiplicator: 30,
  cipLib: "VENTAVIS 10MCG/ML NEB A.2ML BT 30",
  atcCode: "B01AC11"
}, {
  CIP7: '5614008',
  CIP13: '3400956140084',
  ucdLib: "FLOLAN 0,5MG INJ FV+FV",
  UCD7: '9184881',
  UCD13: '3400891848816',
  ucdQtyMultiplicator: 1,
  cipLib: "FLOLAN 0,5MG INJ FV+FV BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5613983',
  CIP13: '3400956139835',
  ucdLib: "FLOLAN 1,5MG INJ FV+FV",
  UCD7: '9202886',
  UCD13: '3400892028866',
  ucdQtyMultiplicator: 1,
  cipLib: "FLOLAN 1,5MG INJ FV+FV BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5776774',
  CIP13: '3400957767747',
  ucdLib: "EPOPROSTENOL PAN 0,5MG FL+FL",
  UCD7: '9354225',
  UCD13: '3400893542255',
  ucdQtyMultiplicator: 1,
  cipLib: "EPOPROSTENOL PAN 0,5MG FL+FL BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5776797',
  CIP13: '3400957767976',
  ucdLib: "EPOPROSTENOL PAN 1,5MG FL+FL",
  UCD7: '9354231',
  UCD13: '3400893542316',
  ucdQtyMultiplicator: 1,
  cipLib: "EPOPROSTENOL PAN 1,5MG FL+FL BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5857633',
  CIP13: '3400958576331',
  ucdLib: "VELETRI 0,5MG INJ FL+FL",
  UCD7: '9399877',
  UCD13: '3400893998779',
  ucdQtyMultiplicator: 1,
  cipLib: "VELETRI 0,5MG INJ FL+FL BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '5857656',
  CIP13: '3400958576560',
  ucdLib: "VELETRI 1,5MG INJ FL+FL",
  UCD7: '9399883',
  UCD13: '3400893998830',
  ucdQtyMultiplicator: 1,
  cipLib: "VELETRI 1,5MG INJ FL+FL BT 1",
  atcCode: "B01AC09"
}, {
  CIP7: '3082033',
  CIP13: '3400930820339',
  ucdLib: "PERSANTINE 75MG CPR ENROB",
  UCD7: '9070485',
  UCD13: '3400890704854',
  ucdQtyMultiplicator: 30,
  cipLib: "PERSANTINE 75MG CPR ENROB BT 30",
  atcCode: "B01AC07"
}, {
  CIP7: '3225917',
  CIP13: '3400932259175',
  ucdLib: "CLERIDIUM 150MG CPR",
  UCD7: '9020375',
  UCD13: '3400890203753',
  ucdQtyMultiplicator: 60,
  cipLib: "CLERIDIUM 150MG CPR BT 60",
  atcCode: "B01AC07"
}, {
  CIP7: '5623409',
  CIP13: '3400956234097',
  ucdLib: "PERSANTINE 10MG/2ML INJ AMP",
  UCD7: '9070462',
  UCD13: '3400890704625',
  ucdQtyMultiplicator: 10,
  cipLib: "PERSANTINE 10MG/2ML INJ AMP BT 10",
  atcCode: "B01AC07"
}, {
  CIP7: '3324737',
  CIP13: '3400933247379',
  ucdLib: "KARDEGIC 160MG PDR SACH",
  UCD7: '9157602',
  UCD13: '3400891576023',
  ucdQtyMultiplicator: 30,
  cipLib: "KARDEGIC 160MG PDR SACH BT 30",
  atcCode: "B01AC06"
}, {
  CIP7: '3322655',
  CIP13: '3400933226558',
  ucdLib: "KARDEGIC 300MG PDR SACH",
  UCD7: '9157619',
  UCD13: '3400891576191',
  ucdQtyMultiplicator: 30,
  cipLib: "KARDEGIC 300MG PDR SACH BT 30",
  atcCode: "B01AC06"
}, {
  CIP7: '3001403',
  CIP13: '3400930014035',
  ucdLib: "RESITUNE 100MG CPR",
  UCD7: '9421393',
  UCD13: '3400894213932',
  ucdQtyMultiplicator: 30,
  cipLib: "RESITUNE 100MG CPR BT 30",
  atcCode: "B01AC06"
}, {
  CIP7: '3001406',
  CIP13: '3400930014066',
  ucdLib: "RESITUNE 100MG CPR",
  UCD7: '9421393',
  UCD13: '3400894213932',
  ucdQtyMultiplicator: 90,
  cipLib: "RESITUNE 100MG CPR BT 90",
  atcCode: "B01AC06"
}, {
  CIP7: '3001395',
  CIP13: '3400930013953',
  ucdLib: "RESITUNE 75MG CPR",
  UCD7: '9421401',
  UCD13: '3400894214014',
  ucdQtyMultiplicator: 30,
  cipLib: "RESITUNE 75MG CPR BT 30",
  atcCode: "B01AC06"
}, {
  CIP7: '3001398',
  CIP13: '3400930013984',
  ucdLib: "RESITUNE 75MG CPR",
  UCD7: '9421401',
  UCD13: '3400894214014',
  ucdQtyMultiplicator: 90,
  cipLib: "RESITUNE 75MG CPR BT 90",
  atcCode: "B01AC06"
}, {
  CIP7: '3430014',
  CIP13: '3400934300141',
  ucdLib: "ASPIRINE PROTECT 300MG CPR",
  UCD7: '9200456',
  UCD13: '3400892004563',
  ucdQtyMultiplicator: 30,
  cipLib: "ASPIRINE PROTECT 300MG CPR BT 30",
  atcCode: "B01AC06"
}, {
  CIP7: '3537485',
  CIP13: '3400935374851',
  ucdLib: "KARDEGIC 500MG/5ML INJ FL",
  UCD7: '9224528',
  UCD13: '3400892245287',
  ucdQtyMultiplicator: 20,
  cipLib: "KARDEGIC 500MG/5ML INJ FL BT 20",
  atcCode: "B01AC06"
}, {
  CIP7: '3474419',
  CIP13: '3400934744198',
  ucdLib: "KARDEGIC 75MG PDR SACH",
  UCD7: '9206536',
  UCD13: '3400892065366',
  ucdQtyMultiplicator: 30,
  cipLib: "KARDEGIC 75MG PDR SACH BT 30",
  atcCode: "B01AC06"
}, {
  CIP7: '2693993',
  CIP13: '3400926939939',
  ucdLib: "ASPIRINE PROTECT 100MG CPR",
  UCD7: '9399860',
  UCD13: '3400893998601',
  ucdQtyMultiplicator: 30,
  cipLib: "ASPIRINE PROTECT 100MG CPR BT 30",
  atcCode: "B01AC06"
}, {
  CIP7: '2694001',
  CIP13: '3400926940010',
  ucdLib: "ASPIRINE PROTECT 100MG CPR",
  UCD7: '9399860',
  UCD13: '3400893998601',
  ucdQtyMultiplicator: 50,
  cipLib: "ASPIRINE PROTECT 100MG CPR BT 50",
  atcCode: "B01AC06"
}, {
  CIP7: '5827046',
  CIP13: '3400958270468',
  ucdLib: "MODIXIS 75MG BUV SACH",
  UCD7: '9384539',
  UCD13: '3400893845394',
  ucdQtyMultiplicator: 100,
  cipLib: "MODIXIS 75MG BUV SACH BT 100",
  atcCode: "B01AC06"
}, {
  CIP7: '3571200',
  CIP13: '3400935712004',
  ucdLib: "TICLOPIDINE ARW 250MG CPR",
  UCD7: '9238223',
  UCD13: '3400892382234',
  ucdQtyMultiplicator: 30,
  cipLib: "TICLOPIDINE ARW 250MG CPR BT 30",
  atcCode: "B01AC05"
}, {
  CIP7: '3220802',
  CIP13: '3400932208029',
  ucdLib: "TICLID 250MG CPR",
  UCD7: '9093115',
  UCD13: '3400890931151',
  ucdQtyMultiplicator: 30,
  cipLib: "TICLID 250MG CPR BT 30",
  atcCode: "B01AC05"
}, {
  CIP7: '3525476',
  CIP13: '3400935254764',
  ucdLib: "TICLOPIDINE MYL 250MG CPR",
  UCD7: '9231037',
  UCD13: '3400892310374',
  ucdQtyMultiplicator: 30,
  cipLib: "TICLOPIDINE MYL 250MG CPR BT 30",
  atcCode: "B01AC05"
}, {
  CIP7: '3549258',
  CIP13: '3400935492586',
  ucdLib: "TICLOPIDINE EG 250MG CPR",
  UCD7: '9227946',
  UCD13: '3400892279466',
  ucdQtyMultiplicator: 30,
  cipLib: "TICLOPIDINE EG 250MG CPR BT 30",
  atcCode: "B01AC05"
}, {
  CIP7: '3766754',
  CIP13: '3400937667548',
  ucdLib: "TICLOPIDINE SDZ 250MG CPR",
  UCD7: '9291074',
  UCD13: '3400892910741',
  ucdQtyMultiplicator: 30,
  cipLib: "TICLOPIDINE SDZ 250MG CPR BT 30",
  atcCode: "B01AC05"
}, {
  CIP7: '3782204',
  CIP13: '3400937822046',
  ucdLib: "TICLOPIDINE TVC 250MG CPR",
  UCD7: '9300850',
  UCD13: '3400893008508',
  ucdQtyMultiplicator: 30,
  cipLib: "TICLOPIDINE TVC 250MG CPR BT 30",
  atcCode: "B01AC05"
}, {
  CIP7: '3959772',
  CIP13: '3400939597720',
  ucdLib: "TICLID 250MG CPR",
  UCD7: '9093115',
  UCD13: '3400890931151',
  ucdQtyMultiplicator: 30,
  cipLib: "TICLID 250MG CPR BT 30",
  atcCode: "B01AC05"
}, {
  CIP7: '3006506',
  CIP13: '3400930065068',
  ucdLib: "CLOPIDOGREL BGR 75MG CPR",
  UCD7: '9392645',
  UCD13: '3400893926451',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL BGR 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3467916',
  CIP13: '3400934679162',
  ucdLib: "CLOPIDOGREL ISD 75MG CPR",
  UCD7: '9347627',
  UCD13: '3400893476277',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ISD 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '4950018',
  CIP13: '3400949500185',
  ucdLib: "CLOPIDOGREL MYL 75MG C ADPBBA",
  UCD7: '9421306',
  UCD13: '3400894213062',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL MYL 75MG C ADPBBA BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3690063',
  CIP13: '3400936900639',
  ucdLib: "CLOPIDOGREL PHR 75MG CPR",
  UCD7: '9352918',
  UCD13: '3400893529188',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL PHR 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '4950299',
  CIP13: '3400949502998',
  ucdLib: "PLAVIX 75MG CPR ADP BBA",
  UCD7: '9368581',
  UCD13: '3400893685815',
  ucdQtyMultiplicator: 30,
  cipLib: "PLAVIX 75MG CPR ADP BBA BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '4951264',
  CIP13: '3400949512645',
  ucdLib: "PLAVIX 75MG CPR ADP ITT",
  UCD7: '9409096',
  UCD13: '3400894090960',
  ucdQtyMultiplicator: 30,
  cipLib: "PLAVIX 75MG CPR ADP ITT BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '4950684',
  CIP13: '3400949506842',
  ucdLib: "PLAVIX 75MG CPR ADP MWI",
  UCD7: '9393202',
  UCD13: '3400893932025',
  ucdQtyMultiplicator: 30,
  cipLib: "PLAVIX 75MG CPR ADP MWI BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '4950230',
  CIP13: '3400949502301',
  ucdLib: "PLAVIX 75MG CPR ADP PLA",
  UCD7: '9369215',
  UCD13: '3400893692158',
  ucdQtyMultiplicator: 30,
  cipLib: "PLAVIX 75MG CPR ADP PLA BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3479463',
  CIP13: '3400934794636',
  ucdLib: "PLAVIX 75MG CPR",
  UCD7: '9205258',
  UCD13: '3400892052588',
  ucdQtyMultiplicator: 50,
  cipLib: "PLAVIX 75MG CPR BT 50",
  atcCode: "B01AC04"
}, {
  CIP7: '3880622',
  CIP13: '3400938806229',
  ucdLib: "CLOPIDOGREL ZEN 75MG CPR",
  UCD7: '9318991',
  UCD13: '3400893189917',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ZEN 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3880639',
  CIP13: '3400938806397',
  ucdLib: "CLOPIDOGREL ZEN 75MG CPR",
  UCD7: '9318991',
  UCD13: '3400893189917',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ZEN 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3802220',
  CIP13: '3400938022209',
  ucdLib: "PLAVIX 75MG CPR",
  UCD7: '9205258',
  UCD13: '3400892052588',
  ucdQtyMultiplicator: 30,
  cipLib: "PLAVIX 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3802237',
  CIP13: '3400938022377',
  ucdLib: "PLAVIX 75MG CPR",
  UCD7: '9205258',
  UCD13: '3400892052588',
  ucdQtyMultiplicator: 30,
  cipLib: "PLAVIX 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3974180',
  CIP13: '3400939741802',
  ucdLib: "CLOPIDOGREL ALM 75MG CPR",
  UCD7: '9341056',
  UCD13: '3400893410561',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ALM 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3971589',
  CIP13: '3400939715896',
  ucdLib: "CLOPIDOGREL ALT 75MG CPR",
  UCD7: '9341062',
  UCD13: '3400893410622',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ALT 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3968995',
  CIP13: '3400939689951',
  ucdLib: "CLOPIDOGREL ARG 75MG CPR",
  UCD7: '9340832',
  UCD13: '3400893408322',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ARG 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3969842',
  CIP13: '3400939698427',
  ucdLib: "CLOPIDOGREL ARL 75MG CPR",
  UCD7: '9341180',
  UCD13: '3400893411803',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ARL 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3969859',
  CIP13: '3400939698595',
  ucdLib: "CLOPIDOGREL ARL 75MG CPR",
  UCD7: '9341180',
  UCD13: '3400893411803',
  ucdQtyMultiplicator: 50,
  cipLib: "CLOPIDOGREL ARL 75MG CPR BT 50",
  atcCode: "B01AC04"
}, {
  CIP7: '3969894',
  CIP13: '3400939698946',
  ucdLib: "CLOPIDOGREL ARL 75MG CPR",
  UCD7: '9341180',
  UCD13: '3400893411803',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ARL 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3970963',
  CIP13: '3400939709635',
  ucdLib: "CLOPIDOGREL ARL 75MG CPR",
  UCD7: '9341180',
  UCD13: '3400893411803',
  ucdQtyMultiplicator: 100,
  cipLib: "CLOPIDOGREL ARL 75MG CPR BT 100",
  atcCode: "B01AC04"
}, {
  CIP7: '3970874',
  CIP13: '3400939708744',
  ucdLib: "CLOPIDOGREL BCR 75MG CPR",
  UCD7: '9341197',
  UCD13: '3400893411971',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL BCR 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3971247',
  CIP13: '3400939712475',
  ucdLib: "CLOPIDOGREL CRT 75MG CPR",
  UCD7: '9341085',
  UCD13: '3400893410851',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL CRT 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3967872',
  CIP13: '3400939678726',
  ucdLib: "CLOPIDOGREL EG 75MG CPR",
  UCD7: '9341091',
  UCD13: '3400893410912',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL EG 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3971052',
  CIP13: '3400939710525',
  ucdLib: "CLOPIDOGREL EVO 75MG CPR",
  UCD7: '9341145',
  UCD13: '3400893411452',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL EVO 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '2664388',
  CIP13: '3400926643881',
  ucdLib: "CLOPIDOGREL BGR 75MG CPR",
  UCD7: '9392645',
  UCD13: '3400893926451',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL BGR 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '2241570',
  CIP13: '3400922415703',
  ucdLib: "CLOPIDOGREL KRK 75MG CPR",
  UCD7: '9386165',
  UCD13: '3400893861653',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL KRK 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3998393',
  CIP13: '3400939983936',
  ucdLib: "CLOPIDOGREL MYL 75MG CPR",
  UCD7: '9341211',
  UCD13: '3400893412114',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL MYL 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '2175873',
  CIP13: '3400921758733',
  ucdLib: "CLOPIDOGREL RPG. 75MG CPR",
  UCD7: '9378668',
  UCD13: '3400893786680',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL RPG. 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3998424',
  CIP13: '3400939984247',
  ucdLib: "CLOPIDOGREL SDZ 75MG CPR",
  UCD7: '9353177',
  UCD13: '3400893531778',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL SDZ 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '2245711',
  CIP13: '3400922457116',
  ucdLib: "CLOPIDOGREL ZF 75MG CPR",
  UCD7: '9395307',
  UCD13: '3400893953075',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL ZF 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '5794306',
  CIP13: '3400957943066',
  ucdLib: "CLOPIDOGREL MYP 75MG CPR",
  UCD7: '9375718',
  UCD13: '3400893757185',
  ucdQtyMultiplicator: 50,
  cipLib: "CLOPIDOGREL MYP 75MG CPR BT 50",
  atcCode: "B01AC04"
}, {
  CIP7: '2773930',
  CIP13: '3400927739309',
  ucdLib: "CLOPIDOGREL TVC 75MG CPR",
  UCD7: '9402421',
  UCD13: '3400894024217',
  ucdQtyMultiplicator: 30,
  cipLib: "CLOPIDOGREL TVC 75MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '5730192',
  CIP13: '3400957301927',
  ucdLib: "PLAVIX 300MG CPR",
  UCD7: '9314993',
  UCD13: '3400893149935',
  ucdQtyMultiplicator: 30,
  cipLib: "PLAVIX 300MG CPR BT 30",
  atcCode: "B01AC04"
}, {
  CIP7: '3343309',
  CIP13: '3400933433093',
  ucdLib: "INNOHEP 2500 INJ SRG0,25ML",
  UCD7: '9150853',
  UCD13: '3400891508536',
  ucdQtyMultiplicator: 2,
  cipLib: "INNOHEP 2500 INJ SRG0,25ML BT 2",
  atcCode: "B01AB10"
}, {
  CIP7: '3343321',
  CIP13: '3400933433215',
  ucdLib: "INNOHEP 3500 INJ SRG0,35ML",
  UCD7: '9150882',
  UCD13: '3400891508826',
  ucdQtyMultiplicator: 2,
  cipLib: "INNOHEP 3500 INJ SRG0,35ML BT 2",
  atcCode: "B01AB10"
}, {
  CIP7: '3358245',
  CIP13: '3400933582456',
  ucdLib: "INNOHEP 2500 INJ SRG0,25ML",
  UCD7: '9150853',
  UCD13: '3400891508536',
  ucdQtyMultiplicator: 6,
  cipLib: "INNOHEP 2500 INJ SRG0,25ML BT 6",
  atcCode: "B01AB10"
}, {
  CIP7: '3358216',
  CIP13: '3400933582166',
  ucdLib: "INNOHEP 3500 INJ SRG0,35ML",
  UCD7: '9150882',
  UCD13: '3400891508826',
  ucdQtyMultiplicator: 6,
  cipLib: "INNOHEP 3500 INJ SRG0,35ML BT 6",
  atcCode: "B01AB10"
}, {
  CIP7: '3397239',
  CIP13: '3400933972394',
  ucdLib: "INNOHEP 10000 INJ SRG0,5ML",
  UCD7: '9184645',
  UCD13: '3400891846454',
  ucdQtyMultiplicator: 2,
  cipLib: "INNOHEP 10000 INJ SRG0,5ML BT 2",
  atcCode: "B01AB10"
}, {
  CIP7: '3397251',
  CIP13: '3400933972516',
  ucdLib: "INNOHEP 10000 INJ SRG0,5ML",
  UCD7: '9184645',
  UCD13: '3400891846454',
  ucdQtyMultiplicator: 10,
  cipLib: "INNOHEP 10000 INJ SRG0,5ML BT 10",
  atcCode: "B01AB10"
}, {
  CIP7: '3397280',
  CIP13: '3400933972806',
  ucdLib: "INNOHEP 14000 INJ SRG0,7ML",
  UCD7: '9184651',
  UCD13: '3400891846515',
  ucdQtyMultiplicator: 10,
  cipLib: "INNOHEP 14000 INJ SRG0,7ML BT 10",
  atcCode: "B01AB10"
}, {
  CIP7: '3397311',
  CIP13: '3400933973117',
  ucdLib: "INNOHEP 18000 INJ SRG0,9ML",
  UCD7: '9184668',
  UCD13: '3400891846683',
  ucdQtyMultiplicator: 10,
  cipLib: "INNOHEP 18000 INJ SRG0,9ML BT 10",
  atcCode: "B01AB10"
}, {
  CIP7: '3421699',
  CIP13: '3400934216992',
  ucdLib: "INNOHEP 4500 INJ SRG0,45ML",
  UCD7: '9191622',
  UCD13: '3400891916225',
  ucdQtyMultiplicator: 2,
  cipLib: "INNOHEP 4500 INJ SRG0,45ML BT 2",
  atcCode: "B01AB10"
}, {
  CIP7: '3421707',
  CIP13: '3400934217074',
  ucdLib: "INNOHEP 4500 INJ SRG0,45ML",
  UCD7: '9191622',
  UCD13: '3400891916225',
  ucdQtyMultiplicator: 6,
  cipLib: "INNOHEP 4500 INJ SRG0,45ML BT 6",
  atcCode: "B01AB10"
}, {
  CIP7: '5598568',
  CIP13: '3400955985686',
  ucdLib: "ORGARAN 750U AXA/0,6ML AMP",
  UCD7: '9183947',
  UCD13: '3400891839470',
  ucdQtyMultiplicator: 10,
  cipLib: "ORGARAN 750U AXA/0,6ML AMP BT 10",
  atcCode: "B01AB09"
}, {
  CIP7: '3324654',
  CIP13: '3400933246549',
  ucdLib: "FRAXIPARINE 7600UI SERING",
  UCD7: '9140903',
  UCD13: '3400891409031',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAXIPARINE 7600UI SERING BT 2",
  atcCode: "B01AB06"
}, {
  CIP7: '3278256',
  CIP13: '3400932782567',
  ucdLib: "FRAXIPARINE 2850UI SERING",
  UCD7: '9104296',
  UCD13: '3400891042962',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAXIPARINE 2850UI SERING BT 2",
  atcCode: "B01AB06"
}, {
  CIP7: '3278279',
  CIP13: '3400932782796',
  ucdLib: "FRAXIPARINE 2850UI SERING",
  UCD7: '9104296',
  UCD13: '3400891042962',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXIPARINE 2850UI SERING BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '3278285',
  CIP13: '3400932782857',
  ucdLib: "FRAXIPARINE 5700UI SERING",
  UCD7: '9137522',
  UCD13: '3400891375220',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAXIPARINE 5700UI SERING BT 2",
  atcCode: "B01AB06"
}, {
  CIP7: '3278316',
  CIP13: '3400932783168',
  ucdLib: "FRAXIPARINE 5700UI SERING",
  UCD7: '9137522',
  UCD13: '3400891375220',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXIPARINE 5700UI SERING BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '3278322',
  CIP13: '3400932783229',
  ucdLib: "FRAXIPARINE 9500UI SERING",
  UCD7: '9137539',
  UCD13: '3400891375398',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAXIPARINE 9500UI SERING BT 2",
  atcCode: "B01AB06"
}, {
  CIP7: '3278345',
  CIP13: '3400932783458',
  ucdLib: "FRAXIPARINE 9500UI SERING",
  UCD7: '9137539',
  UCD13: '3400891375398',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXIPARINE 9500UI SERING BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '5567941',
  CIP13: '3400955679417',
  ucdLib: "FRAXIPARINE 1900UI SERING",
  UCD7: '9141162',
  UCD13: '3400891411621',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXIPARINE 1900UI SERING BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '3338917',
  CIP13: '3400933389178',
  ucdLib: "FRAXIPARINE 2850UI SERING",
  UCD7: '9104296',
  UCD13: '3400891042962',
  ucdQtyMultiplicator: 6,
  cipLib: "FRAXIPARINE 2850UI SERING BT 6",
  atcCode: "B01AB06"
}, {
  CIP7: '5567958',
  CIP13: '3400955679585',
  ucdLib: "FRAXIPARINE 3800UI SERING",
  UCD7: '9141156',
  UCD13: '3400891411560',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXIPARINE 3800UI SERING BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '3348761',
  CIP13: '3400933487614',
  ucdLib: "FRAXIPARINE 5700UI SERING",
  UCD7: '9137522',
  UCD13: '3400891375220',
  ucdQtyMultiplicator: 6,
  cipLib: "FRAXIPARINE 5700UI SERING BT 6",
  atcCode: "B01AB06"
}, {
  CIP7: '3348896',
  CIP13: '3400933488963',
  ucdLib: "FRAXIPARINE 7600UI SERING",
  UCD7: '9140903',
  UCD13: '3400891409031',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXIPARINE 7600UI SERING BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '3473288',
  CIP13: '3400934732881',
  ucdLib: "FRAXODI 11400UI INJ SRG0,6ML",
  UCD7: '9202432',
  UCD13: '3400892024325',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAXODI 11400UI INJ SRG0,6ML BT 2",
  atcCode: "B01AB06"
}, {
  CIP7: '3473302',
  CIP13: '3400934733024',
  ucdLib: "FRAXODI 11400UI INJ SRG0,6ML",
  UCD7: '9202432',
  UCD13: '3400892024325',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXODI 11400UI INJ SRG0,6ML BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '3473319',
  CIP13: '3400934733192',
  ucdLib: "FRAXODI 15200UI INJ SRG0,8ML",
  UCD7: '9202449',
  UCD13: '3400892024493',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAXODI 15200UI INJ SRG0,8ML BT 2",
  atcCode: "B01AB06"
}, {
  CIP7: '3473331',
  CIP13: '3400934733314',
  ucdLib: "FRAXODI 15200UI INJ SRG0,8ML",
  UCD7: '9202449',
  UCD13: '3400892024493',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXODI 15200UI INJ SRG0,8ML BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '3473348',
  CIP13: '3400934733482',
  ucdLib: "FRAXODI 19000UI INJ SRG1ML",
  UCD7: '9202455',
  UCD13: '3400892024554',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAXODI 19000UI INJ SRG1ML BT 2",
  atcCode: "B01AB06"
}, {
  CIP7: '3473360',
  CIP13: '3400934733604',
  ucdLib: "FRAXODI 19000UI INJ SRG1ML",
  UCD7: '9202455',
  UCD13: '3400892024554',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAXODI 19000UI INJ SRG1ML BT 10",
  atcCode: "B01AB06"
}, {
  CIP7: '3646895',
  CIP13: '3400936468955',
  ucdLib: "LOVENOX 10000UI SRG1ML +ERIS",
  UCD7: '9266900',
  UCD13: '3400892669007',
  ucdQtyMultiplicator: 10,
  cipLib: "LOVENOX 10000UI SRG1ML +ERIS BT 10",
  atcCode: "B01AB05"
}, {
  CIP7: '3646837',
  CIP13: '3400936468375',
  ucdLib: "LOVENOX 2000UI SRG0,2ML +ERIS",
  UCD7: '9266917',
  UCD13: '3400892669175',
  ucdQtyMultiplicator: 2,
  cipLib: "LOVENOX 2000UI SRG0,2ML +ERIS BT 2",
  atcCode: "B01AB05"
}, {
  CIP7: '3646843',
  CIP13: '3400936468436',
  ucdLib: "LOVENOX 2000UI SRG0,2ML +ERIS",
  UCD7: '9266917',
  UCD13: '3400892669175',
  ucdQtyMultiplicator: 6,
  cipLib: "LOVENOX 2000UI SRG0,2ML +ERIS BT 6",
  atcCode: "B01AB05"
}, {
  CIP7: '3646866',
  CIP13: '3400936468665',
  ucdLib: "LOVENOX 4000UI SRG0,4ML +ERIS",
  UCD7: '9266923',
  UCD13: '3400892669236',
  ucdQtyMultiplicator: 2,
  cipLib: "LOVENOX 4000UI SRG0,4ML +ERIS BT 2",
  atcCode: "B01AB05"
}, {
  CIP7: '3646872',
  CIP13: '3400936468726',
  ucdLib: "LOVENOX 4000UI SRG0,4ML +ERIS",
  UCD7: '9266923',
  UCD13: '3400892669236',
  ucdQtyMultiplicator: 6,
  cipLib: "LOVENOX 4000UI SRG0,4ML +ERIS BT 6",
  atcCode: "B01AB05"
}, {
  CIP7: '3646903',
  CIP13: '3400936469037',
  ucdLib: "LOVENOX 6000UI SRG0,6ML +ERIS",
  UCD7: '9266946',
  UCD13: '3400892669465',
  ucdQtyMultiplicator: 2,
  cipLib: "LOVENOX 6000UI SRG0,6ML +ERIS BT 2",
  atcCode: "B01AB05"
}, {
  CIP7: '3646926',
  CIP13: '3400936469266',
  ucdLib: "LOVENOX 6000UI SRG0,6ML +ERIS",
  UCD7: '9266946',
  UCD13: '3400892669465',
  ucdQtyMultiplicator: 10,
  cipLib: "LOVENOX 6000UI SRG0,6ML +ERIS BT 10",
  atcCode: "B01AB05"
}, {
  CIP7: '3646932',
  CIP13: '3400936469327',
  ucdLib: "LOVENOX 8000UI SRG0,8ML +ERIS",
  UCD7: '9266952',
  UCD13: '3400892669526',
  ucdQtyMultiplicator: 2,
  cipLib: "LOVENOX 8000UI SRG0,8ML +ERIS BT 2",
  atcCode: "B01AB05"
}, {
  CIP7: '3646949',
  CIP13: '3400936469495',
  ucdLib: "LOVENOX 8000UI SRG0,8ML +ERIS",
  UCD7: '9266952',
  UCD13: '3400892669526',
  ucdQtyMultiplicator: 10,
  cipLib: "LOVENOX 8000UI SRG0,8ML +ERIS BT 10",
  atcCode: "B01AB05"
}, {
  CIP7: '5610708',
  CIP13: '3400956107087',
  ucdLib: "LOVENOX 30000UI INJ FL3ML",
  UCD7: '9209339',
  UCD13: '3400892093390',
  ucdQtyMultiplicator: 1,
  cipLib: "LOVENOX 30000UI INJ FL3ML BT 1",
  atcCode: "B01AB05"
}, {
  CIP7: '3301096',
  CIP13: '3400933010966',
  ucdLib: "FRAGMINE 2500UI INJ SRG0,2ML",
  UCD7: '9126731',
  UCD13: '3400891267310',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAGMINE 2500UI INJ SRG0,2ML BT 2",
  atcCode: "B01AB04"
}, {
  CIP7: '5560844',
  CIP13: '3400955608448',
  ucdLib: "FRAGMINE 2500UI INJ SRG0,2ML",
  UCD7: '9126731',
  UCD13: '3400891267310',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAGMINE 2500UI INJ SRG0,2ML BT 10",
  atcCode: "B01AB04"
}, {
  CIP7: '3301073',
  CIP13: '3400933010737',
  ucdLib: "FRAGMINE 5000UI INJ SRG0,2ML",
  UCD7: '9126748',
  UCD13: '3400891267488',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAGMINE 5000UI INJ SRG0,2ML BT 2",
  atcCode: "B01AB04"
}, {
  CIP7: '5560850',
  CIP13: '3400955608509',
  ucdLib: "FRAGMINE 5000UI INJ SRG0,2ML",
  UCD7: '9126748',
  UCD13: '3400891267488',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAGMINE 5000UI INJ SRG0,2ML BT 10",
  atcCode: "B01AB04"
}, {
  CIP7: '3373084',
  CIP13: '3400933730840',
  ucdLib: "FRAGMINE 10000UI INJ SRG1ML",
  UCD7: '9182416',
  UCD13: '3400891824162',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAGMINE 10000UI INJ SRG1ML BT 2",
  atcCode: "B01AB04"
}, {
  CIP7: '3373061',
  CIP13: '3400933730611',
  ucdLib: "FRAGMINE 7500UI INJ SRG0,75ML",
  UCD7: '9182422',
  UCD13: '3400891824223',
  ucdQtyMultiplicator: 2,
  cipLib: "FRAGMINE 7500UI INJ SRG0,75ML BT 2",
  atcCode: "B01AB04"
}, {
  CIP7: '3353012',
  CIP13: '3400933530129',
  ucdLib: "FRAGMINE 2500UI INJ SRG0,2ML",
  UCD7: '9126731',
  UCD13: '3400891267310',
  ucdQtyMultiplicator: 6,
  cipLib: "FRAGMINE 2500UI INJ SRG0,2ML BT 6",
  atcCode: "B01AB04"
}, {
  CIP7: '3352981',
  CIP13: '3400933529819',
  ucdLib: "FRAGMINE 5000UI INJ SRG0,2ML",
  UCD7: '9126748',
  UCD13: '3400891267488',
  ucdQtyMultiplicator: 6,
  cipLib: "FRAGMINE 5000UI INJ SRG0,2ML BT 6",
  atcCode: "B01AB04"
}, {
  CIP7: '3974323',
  CIP13: '3400939743233',
  ucdLib: "FRAGMINE 12500UI INJ SRG0,5ML",
  UCD7: '9352019',
  UCD13: '3400893520192',
  ucdQtyMultiplicator: 5,
  cipLib: "FRAGMINE 12500UI INJ SRG0,5ML BT 5",
  atcCode: "B01AB04"
}, {
  CIP7: '3974346',
  CIP13: '3400939743462',
  ucdLib: "FRAGMINE 15000UI INJ SRG0,6ML",
  UCD7: '9352025',
  UCD13: '3400893520253',
  ucdQtyMultiplicator: 5,
  cipLib: "FRAGMINE 15000UI INJ SRG0,6ML BT 5",
  atcCode: "B01AB04"
}, {
  CIP7: '3974352',
  CIP13: '3400939743523',
  ucdLib: "FRAGMINE 18000UI INJ S.0,72ML",
  UCD7: '9352031',
  UCD13: '3400893520314',
  ucdQtyMultiplicator: 5,
  cipLib: "FRAGMINE 18000UI INJ S.0,72ML BT 5",
  atcCode: "B01AB04"
}, {
  CIP7: '3974300',
  CIP13: '3400939743004',
  ucdLib: "FRAGMINE 7500UI INJ SRG0,3ML",
  UCD7: '9354797',
  UCD13: '3400893547977',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAGMINE 7500UI INJ SRG0,3ML BT 10",
  atcCode: "B01AB04"
}, {
  CIP7: '4925019',
  CIP13: '3400949250196',
  ucdLib: "FRAGMINE 10000UI INJ S.0,4ML",
  UCD7: '9354722',
  UCD13: '3400893547229',
  ucdQtyMultiplicator: 5,
  cipLib: "FRAGMINE 10000UI INJ S.0,4ML BT 5",
  atcCode: "B01AB04"
}, {
  CIP7: '3421305',
  CIP13: '3400934213052',
  ucdLib: "FRAGMINE 10000UI INJ SRG1ML",
  UCD7: '9182416',
  UCD13: '3400891824162',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAGMINE 10000UI INJ SRG1ML BT 10",
  atcCode: "B01AB04"
}, {
  CIP7: '3421297',
  CIP13: '3400934212970',
  ucdLib: "FRAGMINE 7500UI INJ SRG0,75ML",
  UCD7: '9182422',
  UCD13: '3400891824223',
  ucdQtyMultiplicator: 10,
  cipLib: "FRAGMINE 7500UI INJ SRG0,75ML BT 10",
  atcCode: "B01AB04"
}, {
  CIP7: '5619388',
  CIP13: '3400956193882',
  ucdLib: "ACLOTINE 100UI INJ FV+FV10ML",
  UCD7: '9211371',
  UCD13: '3400892113715',
  ucdQtyMultiplicator: 1,
  cipLib: "ACLOTINE 100UI INJ FV+FV10ML BT 1",
  atcCode: "B01AB02"
}, {
  CIP7: '5619371',
  CIP13: '3400956193714',
  ucdLib: "ACLOTINE 100UI INJ FV+FV5ML",
  UCD7: '9211388',
  UCD13: '3400892113883',
  ucdQtyMultiplicator: 1,
  cipLib: "ACLOTINE 100UI INJ FV+FV5ML BT 1",
  atcCode: "B01AB02"
}, {
  CIP7: '3016763',
  CIP13: '3400930167632',
  ucdLib: "CALCIPARINE SC SERING+AMP0,8ML",
  UCD7: '9014587',
  UCD13: '3400890145879',
  ucdQtyMultiplicator: 2,
  cipLib: "CALCIPARINE SC SERING+AMP0,8ML BT 2",
  atcCode: "B01AB01"
}, {
  CIP7: '3048450',
  CIP13: '3400930484500',
  ucdLib: "HEPARINE CHOAY 25000 INJ FL5ML",
  UCD7: '9042661',
  UCD13: '3400890426619',
  ucdQtyMultiplicator: 1,
  cipLib: "HEPARINE CHOAY 25000 INJ FL5ML BT 1",
  atcCode: "B01AB01"
}, {
  CIP7: '5567036',
  CIP13: '3400955670360',
  ucdLib: "CALCIPARINE SC AMP0,5ML",
  UCD7: '9141340',
  UCD13: '3400891413403',
  ucdQtyMultiplicator: 50,
  cipLib: "CALCIPARINE SC AMP0,5ML BT 50",
  atcCode: "B01AB01"
}, {
  CIP7: '5567065',
  CIP13: '3400955670650',
  ucdLib: "CALCIPARINE SC AMP0,8ML",
  UCD7: '9141357',
  UCD13: '3400891413571',
  ucdQtyMultiplicator: 50,
  cipLib: "CALCIPARINE SC AMP0,8ML BT 50",
  atcCode: "B01AB01"
}, {
  CIP7: '5567094',
  CIP13: '3400955670940',
  ucdLib: "CALCIPARINE SC AMP1ML",
  UCD7: '9143066',
  UCD13: '3400891430660',
  ucdQtyMultiplicator: 50,
  cipLib: "CALCIPARINE SC AMP1ML BT 50",
  atcCode: "B01AB01"
}, {
  CIP7: '3133109',
  CIP13: '3400931331094',
  ucdLib: "CALCIPARINE SC SERING+AMP0,5ML",
  UCD7: '9014570',
  UCD13: '3400890145701',
  ucdQtyMultiplicator: 2,
  cipLib: "CALCIPARINE SC SERING+AMP0,5ML BT 2",
  atcCode: "B01AB01"
}, {
  CIP7: '3187861',
  CIP13: '3400931878612',
  ucdLib: "CALCIPARINE 5000UI/0,2ML SRG",
  UCD7: '9014558',
  UCD13: '3400890145589',
  ucdQtyMultiplicator: 2,
  cipLib: "CALCIPARINE 5000UI/0,2ML SRG BT 2",
  atcCode: "B01AB01"
}, {
  CIP7: '3187855',
  CIP13: '3400931878551',
  ucdLib: "CALCIPARINE 7500UI/0,3ML SRG",
  UCD7: '9014564',
  UCD13: '3400890145640',
  ucdQtyMultiplicator: 2,
  cipLib: "CALCIPARINE 7500UI/0,3ML SRG BT 2",
  atcCode: "B01AB01"
}, {
  CIP7: '5524311',
  CIP13: '3400955243113',
  ucdLib: "CALCIPARINE 5000UI/0,2ML SRG",
  UCD7: '9014558',
  UCD13: '3400890145589',
  ucdQtyMultiplicator: 10,
  cipLib: "CALCIPARINE 5000UI/0,2ML SRG BT 10",
  atcCode: "B01AB01"
}, {
  CIP7: '5524328',
  CIP13: '3400955243281',
  ucdLib: "CALCIPARINE 7500UI/0,3ML SRG",
  UCD7: '9014564',
  UCD13: '3400890145640',
  ucdQtyMultiplicator: 10,
  cipLib: "CALCIPARINE 7500UI/0,3ML SRG BT 10",
  atcCode: "B01AB01"
}, {
  CIP7: '5524363',
  CIP13: '3400955243632',
  ucdLib: "HEPARINE CHOAY 25000 INJ FL5ML",
  UCD7: '9042661',
  UCD13: '3400890426619',
  ucdQtyMultiplicator: 10,
  cipLib: "HEPARINE CHOAY 25000 INJ FL5ML BT 10",
  atcCode: "B01AB01"
}, {
  CIP7: '5524386',
  CIP13: '3400955243861',
  ucdLib: "HEPARINE CHOAY 5000 AMP1ML",
  UCD7: '9134386',
  UCD13: '3400891343861',
  ucdQtyMultiplicator: 20,
  cipLib: "HEPARINE CHOAY 5000 AMP1ML BT 20",
  atcCode: "B01AB01"
}, {
  CIP7: '5520508',
  CIP13: '3400955205081',
  ucdLib: "HEPARINE PAN 5000 FL5ML",
  UCD7: '9128730',
  UCD13: '3400891287301',
  ucdQtyMultiplicator: 10,
  cipLib: "HEPARINE PAN 5000 FL5ML BT 10",
  atcCode: "B01AB01"
}, {
  CIP7: '3348413',
  CIP13: '3400933484132',
  ucdLib: "PREVISCAN 20MG CPR",
  UCD7: '9075123',
  UCD13: '3400890751230',
  ucdQtyMultiplicator: 30,
  cipLib: "PREVISCAN 20MG CPR BT 30",
  atcCode: "B01AA12"
}, {
  CIP7: '3356430',
  CIP13: '3400933564308',
  ucdLib: "SINTROM 4MG CPR",
  UCD7: '9084079',
  UCD13: '3400890840798',
  ucdQtyMultiplicator: 30,
  cipLib: "SINTROM 4MG CPR BT 30",
  atcCode: "B01AA07"
}, {
  CIP7: '3366291',
  CIP13: '3400933662912',
  ucdLib: "MINI-SINTROM 1MG CPR",
  UCD7: '9166972',
  UCD13: '3400891669725',
  ucdQtyMultiplicator: 20,
  cipLib: "MINI-SINTROM 1MG CPR BT 20",
  atcCode: "B01AA07"
}, {
  CIP7: '3026454',
  CIP13: '3400930264546',
  ucdLib: "COUMADINE 2MG CPR",
  UCD7: '9022629',
  UCD13: '3400890226295',
  ucdQtyMultiplicator: 20,
  cipLib: "COUMADINE 2MG CPR BT 20",
  atcCode: "B01AA03"
}, {
  CIP7: '3569309',
  CIP13: '3400935693099',
  ucdLib: "COUMADINE 5MG CPR",
  UCD7: '9231586',
  UCD13: '3400892315867',
  ucdQtyMultiplicator: 30,
  cipLib: "COUMADINE 5MG CPR BT 30",
  atcCode: "B01AA03"
}, {
  CIP7: '3006082',
  CIP13: '3400930060827',
  ucdLib: "GALAFOLD 123MG GELU",
  UCD7: '9415949',
  UCD13: '3400894159490',
  ucdQtyMultiplicator: 14,
  cipLib: "GALAFOLD 123MG GELU BT 14",
  atcCode: "A16AX14"
}, {
  CIP7: '3000878',
  CIP13: '3400930008782',
  ucdLib: "CERDELGA 84MG GELU",
  UCD7: '9405566',
  UCD13: '3400894055662',
  ucdQtyMultiplicator: 56,
  cipLib: "CERDELGA 84MG GELU BT 56",
  atcCode: "A16AX10"
}, {
  CIP7: '2772209',
  CIP13: '3400927722097',
  ucdLib: "REVESTIVE 5MG INJ FL+SRG",
  UCD7: '9405023',
  UCD13: '3400894050230',
  ucdQtyMultiplicator: 28,
  cipLib: "REVESTIVE 5MG INJ FL+SRG BT 28",
  atcCode: "A16AX08"
}, {
  CIP7: '3904624',
  CIP13: '3400939046242',
  ucdLib: "KUVAN 100MG CPR BUV",
  UCD7: '9327783',
  UCD13: '3400893277836',
  ucdQtyMultiplicator: 30,
  cipLib: "KUVAN 100MG CPR BUV BT 30",
  atcCode: "A16AX07"
}, {
  CIP7: '3904630',
  CIP13: '3400939046303',
  ucdLib: "KUVAN 100MG CPR BUV",
  UCD7: '9327783',
  UCD13: '3400893277836',
  ucdQtyMultiplicator: 120,
  cipLib: "KUVAN 100MG CPR BUV BT 120",
  atcCode: "A16AX07"
}, {
  CIP7: '5501318',
  CIP13: '3400955013181',
  ucdLib: "MIGLUSTAT BLF 100MG GELU",
  UCD7: '9415263',
  UCD13: '3400894152637',
  ucdQtyMultiplicator: 84,
  cipLib: "MIGLUSTAT BLF 100MG GELU BT 84",
  atcCode: "A16AX06"
}, {
  CIP7: '5641169',
  CIP13: '3400956411696',
  ucdLib: "ZAVESCA 100MG GELU",
  UCD7: '9246725',
  UCD13: '3400892467252',
  ucdQtyMultiplicator: 84,
  cipLib: "ZAVESCA 100MG GELU BT 84",
  atcCode: "A16AX06"
}, {
  CIP7: '3651755',
  CIP13: '3400936517554',
  ucdLib: "WILZIN 25MG GELU",
  UCD7: '9268069',
  UCD13: '3400892680699',
  ucdQtyMultiplicator: 250,
  cipLib: "WILZIN 25MG GELU BT 250",
  atcCode: "A16AX05"
}, {
  CIP7: '3651761',
  CIP13: '3400936517615',
  ucdLib: "WILZIN 50MG GELU",
  UCD7: '9268075',
  UCD13: '3400892680750',
  ucdQtyMultiplicator: 250,
  cipLib: "WILZIN 50MG GELU BT 250",
  atcCode: "A16AX05"
}, {
  CIP7: '3659395',
  CIP13: '3400936593954',
  ucdLib: "ORFADIN 10MG GELU",
  UCD7: '9274727',
  UCD13: '3400892747279',
  ucdQtyMultiplicator: 60,
  cipLib: "ORFADIN 10MG GELU BT 60",
  atcCode: "A16AX04"
}, {
  CIP7: '3659372',
  CIP13: '3400936593725',
  ucdLib: "ORFADIN 2MG GELU",
  UCD7: '9274733',
  UCD13: '3400892747330',
  ucdQtyMultiplicator: 60,
  cipLib: "ORFADIN 2MG GELU BT 60",
  atcCode: "A16AX04"
}, {
  CIP7: '3659389',
  CIP13: '3400936593893',
  ucdLib: "ORFADIN 5MG GELU",
  UCD7: '9274756',
  UCD13: '3400892747569',
  ucdQtyMultiplicator: 60,
  cipLib: "ORFADIN 5MG GELU BT 60",
  atcCode: "A16AX04"
}, {
  CIP7: '5628306',
  CIP13: '3400956283064',
  ucdLib: "AMMONAPS 500MG CPR",
  UCD7: '9232309',
  UCD13: '3400892323091',
  ucdQtyMultiplicator: 250,
  cipLib: "AMMONAPS 500MG CPR BT 250",
  atcCode: "A16AX03"
}, {
  CIP7: '5628329',
  CIP13: '3400956283293',
  ucdLib: "AMMONAPS 940MG/G BUV FL266G",
  UCD7: '9232315',
  UCD13: '3400892323152',
  ucdQtyMultiplicator: 1,
  cipLib: "AMMONAPS 940MG/G BUV FL266G BT 1",
  atcCode: "A16AX03"
}, {
  CIP7: '2741918',
  CIP13: '3400927419188',
  ucdLib: "PHEBURANE 483MG/G GRLS FL174G",
  UCD7: '9387609',
  UCD13: '3400893876091',
  ucdQtyMultiplicator: 1,
  cipLib: "PHEBURANE 483MG/G GRLS FL174G BT 1",
  atcCode: "A16AX03"
}, {
  CIP7: '3117820',
  CIP13: '3400931178200',
  ucdLib: "SULFARLEM S 25MG CPR",
  UCD7: '9088864',
  UCD13: '3400890888646',
  ucdQtyMultiplicator: 60,
  cipLib: "SULFARLEM S 25MG CPR BT 60",
  atcCode: "A16AX02"
}, {
  CIP7: '3101109',
  CIP13: '3400931011095',
  ucdLib: "SULFARLEM 12,5MG CPR",
  UCD7: '9088841',
  UCD13: '3400890888417',
  ucdQtyMultiplicator: 60,
  cipLib: "SULFARLEM 12,5MG CPR BT 60",
  atcCode: "A16AX02"
}, {
  CIP7: '5501098',
  CIP13: '3400955010982',
  ucdLib: "KANUMA 2MG/ML PERF FL10ML",
  UCD7: '9410001',
  UCD13: '3400894100010',
  ucdQtyMultiplicator: 1,
  cipLib: "KANUMA 2MG/ML PERF FL10ML BT 1",
  atcCode: "A16AB14"
}, {
  CIP7: '5867270',
  CIP13: '3400958672705',
  ucdLib: "VIMIZIM 1MG/ML PERF FL5ML",
  UCD7: '9396011',
  UCD13: '3400893960110',
  ucdQtyMultiplicator: 1,
  cipLib: "VIMIZIM 1MG/ML PERF FL5ML BT 1",
  atcCode: "A16AB12"
}, {
  CIP7: '5781887',
  CIP13: '3400957818876',
  ucdLib: "VPRIV 400U PERF FL",
  UCD7: '9355035',
  UCD13: '3400893550359',
  ucdQtyMultiplicator: 1,
  cipLib: "VPRIV 400U PERF FL BT 1",
  atcCode: "A16AB10"
}, {
  CIP7: '5705633',
  CIP13: '3400957056339',
  ucdLib: "ELAPRASE 2MG/ML PERF FL3ML",
  UCD7: '9293593',
  UCD13: '3400892935935',
  ucdQtyMultiplicator: 1,
  cipLib: "ELAPRASE 2MG/ML PERF FL3ML BT 1",
  atcCode: "A16AB09"
}, {
  CIP7: '5672187',
  CIP13: '3400956721870',
  ucdLib: "NAGLAZYME 1MG/ML PERF FL5ML",
  UCD7: '9287196',
  UCD13: '3400892871967',
  ucdQtyMultiplicator: 1,
  cipLib: "NAGLAZYME 1MG/ML PERF FL5ML BT 1",
  atcCode: "A16AB08"
}, {
  CIP7: '5695751',
  CIP13: '3400956957514',
  ucdLib: "MYOZYME 50MG PERF FL",
  UCD7: '9293216',
  UCD13: '3400892932163',
  ucdQtyMultiplicator: 1,
  cipLib: "MYOZYME 50MG PERF FL BT 1",
  atcCode: "A16AB07"
}, {
  CIP7: '5695768',
  CIP13: '3400956957682',
  ucdLib: "MYOZYME 50MG PERF FL",
  UCD7: '9293216',
  UCD13: '3400892932163',
  ucdQtyMultiplicator: 10,
  cipLib: "MYOZYME 50MG PERF FL BT 10",
  atcCode: "A16AB07"
}, {
  CIP7: '5649171',
  CIP13: '3400956491711',
  ucdLib: "ALDURAZYME 100U/ML INJ FL5ML",
  UCD7: '9249907',
  UCD13: '3400892499079',
  ucdQtyMultiplicator: 1,
  cipLib: "ALDURAZYME 100U/ML INJ FL5ML BT 1",
  atcCode: "A16AB05"
}, {
  CIP7: '5633974',
  CIP13: '3400956339747',
  ucdLib: "FABRAZYME 35MG PERF FL",
  UCD7: '9235058',
  UCD13: '3400892350585',
  ucdQtyMultiplicator: 1,
  cipLib: "FABRAZYME 35MG PERF FL BT 1",
  atcCode: "A16AB04"
}, {
  CIP7: '5634005',
  CIP13: '3400956340057',
  ucdLib: "REPLAGAL 1MG/ML PERF FL3,5ML",
  UCD7: '9238861',
  UCD13: '3400892388618',
  ucdQtyMultiplicator: 1,
  cipLib: "REPLAGAL 1MG/ML PERF FL3,5ML BT 1",
  atcCode: "A16AB03"
}, {
  CIP7: '5620807',
  CIP13: '3400956208074',
  ucdLib: "CEREZYME 400U INJ FL",
  UCD7: '9219740',
  UCD13: '3400892197401',
  ucdQtyMultiplicator: 1,
  cipLib: "CEREZYME 400U INJ FL BT 1",
  atcCode: "A16AB02"
}, {
  CIP7: '3830127',
  CIP13: '3400938301274',
  ucdLib: "BETAINE CITR CRT 10% GLE 250G",
  UCD7: '9312876',
  UCD13: '3400893128763',
  ucdQtyMultiplicator: 1,
  cipLib: "BETAINE CITR CRT 10% GLE 250G BT 1",
  atcCode: "A16AA06"
}, {
  CIP7: '3830311',
  CIP13: '3400938303117',
  ucdLib: "BETAINE CITR CRT 2G/5ML AMP",
  UCD7: '9318382',
  UCD13: '3400893183823',
  ucdQtyMultiplicator: 20,
  cipLib: "BETAINE CITR CRT 2G/5ML AMP BT 20",
  atcCode: "A16AA06"
}, {
  CIP7: '3746243',
  CIP13: '3400937462433',
  ucdLib: "BETAINE CITR MYL CPR EFFV",
  UCD7: '9329351',
  UCD13: '3400893293515',
  ucdQtyMultiplicator: 20,
  cipLib: "BETAINE CITR MYL CPR EFFV BT 20",
  atcCode: "A16AA06"
}, {
  CIP7: '3496585',
  CIP13: '3400934965852',
  ucdLib: "BETAINE CITR UPSA 2G CITR C.",
  UCD7: '9010448',
  UCD13: '3400890104487',
  ucdQtyMultiplicator: 20,
  cipLib: "BETAINE CITR UPSA 2G CITR C. BT 20",
  atcCode: "A16AA06"
}, {
  CIP7: '3793780',
  CIP13: '3400937937801',
  ucdLib: "CYSTADANE 1G PDR ORAL FL180G",
  UCD7: '9239501',
  UCD13: '3400892395012',
  ucdQtyMultiplicator: 1,
  cipLib: "CYSTADANE 1G PDR ORAL FL180G BT 1",
  atcCode: "A16AA06"
}, {
  CIP7: '4997409',
  CIP13: '3400949974092',
  ucdLib: "BETAINE CITR UPSA 2G MENT C.",
  UCD7: '9374653',
  UCD13: '3400893746530',
  ucdQtyMultiplicator: 20,
  cipLib: "BETAINE CITR UPSA 2G MENT C. BT 20",
  atcCode: "A16AA06"
}, {
  CIP7: '3656592',
  CIP13: '3400936565920',
  ucdLib: "CARBAGLU 200MG CPR DISP",
  UCD7: '9234053',
  UCD13: '3400892340531',
  ucdQtyMultiplicator: 5,
  cipLib: "CARBAGLU 200MG CPR DISP BT 5",
  atcCode: "A16AA05"
}, {
  CIP7: '5641034',
  CIP13: '3400956410347',
  ucdLib: "CARBAGLU 200MG CPR DISP",
  UCD7: '9234053',
  UCD13: '3400892340531',
  ucdQtyMultiplicator: 60,
  cipLib: "CARBAGLU 200MG CPR DISP BT 60",
  atcCode: "A16AA05"
}, {
  CIP7: '5609734',
  CIP13: '3400956097340',
  ucdLib: "CYSTAGON 150MG GELU",
  UCD7: '9200031',
  UCD13: '3400892000312',
  ucdQtyMultiplicator: 100,
  cipLib: "CYSTAGON 150MG GELU BT 100",
  atcCode: "A16AA04"
}, {
  CIP7: '5609711',
  CIP13: '3400956097111',
  ucdLib: "CYSTAGON 50MG GELU",
  UCD7: '9200048',
  UCD13: '3400892000480',
  ucdQtyMultiplicator: 100,
  cipLib: "CYSTAGON 50MG GELU BT 100",
  atcCode: "A16AA04"
}, {
  CIP7: '3657114',
  CIP13: '3400936571143',
  ucdLib: "LEVOCARNIL 100MG/ML BUV FL10ML",
  UCD7: '9128049',
  UCD13: '3400891280494',
  ucdQtyMultiplicator: 10,
  cipLib: "LEVOCARNIL 100MG/ML BUV FL10ML BT 10",
  atcCode: "A16AA01"
}, {
  CIP7: '3657120',
  CIP13: '3400936571204',
  ucdLib: "LEVOCARNIL 1G/5ML INJ AMP",
  UCD7: '9126085',
  UCD13: '3400891260854',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVOCARNIL 1G/5ML INJ AMP BT 5",
  atcCode: "A16AA01"
}, {
  CIP7: '3271662',
  CIP13: '3400932716623',
  ucdLib: "PARGINE 5G BUV AMP10ML",
  UCD7: '9110747',
  UCD13: '3400891107470',
  ucdQtyMultiplicator: 20,
  cipLib: "PARGINE 5G BUV AMP10ML BT 20",
  atcCode: "A14B"
}, {
  CIP7: '3072885',
  CIP13: '3400930728857',
  ucdLib: "NILEVAR 10MG CPR",
  UCD7: '9063054',
  UCD13: '3400890630542',
  ucdQtyMultiplicator: 30,
  cipLib: "NILEVAR 10MG CPR BT 30",
  atcCode: "A14AA09"
}, {
  CIP7: '3833479',
  CIP13: '3400938334791',
  ucdLib: "STIMOL 1G BUV PDR EFFV SACH",
  UCD7: '9373530',
  UCD13: '3400893735305',
  ucdQtyMultiplicator: 18,
  cipLib: "STIMOL 1G BUV PDR EFFV SACH BT 18",
  atcCode: "A13A"
}, {
  CIP7: '3289283',
  CIP13: '3400932892839',
  ucdLib: "SARGENOR 1G BUV AMP5ML",
  UCD7: '9123164',
  UCD13: '3400891231649',
  ucdQtyMultiplicator: 20,
  cipLib: "SARGENOR 1G BUV AMP5ML BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3329812',
  CIP13: '3400933298128',
  ucdLib: "SARGENOR 1G BUV AMP5ML",
  UCD7: '9123164',
  UCD13: '3400891231649',
  ucdQtyMultiplicator: 40,
  cipLib: "SARGENOR 1G BUV AMP5ML BT 40",
  atcCode: "A13A"
}, {
  CIP7: '3575304',
  CIP13: '3400935753045',
  ucdLib: "REVITALOSE BUV SACH+SACH",
  UCD7: '9263221',
  UCD13: '3400892632216',
  ucdQtyMultiplicator: 14,
  cipLib: "REVITALOSE BUV SACH+SACH BT 14",
  atcCode: "A13A"
}, {
  CIP7: '3046563',
  CIP13: '3400930465639',
  ucdLib: "GURONSAN CPR EFFV",
  UCD7: '9041101',
  UCD13: '3400890411011',
  ucdQtyMultiplicator: 30,
  cipLib: "GURONSAN CPR EFFV BT 30",
  atcCode: "A13A"
}, {
  CIP7: '3317430',
  CIP13: '3400933174309',
  ucdLib: "ARKOGELULES GINSENG 390MG",
  UCD7: '9138935',
  UCD13: '3400891389357',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES GINSENG 390MG BT 45",
  atcCode: "A13A"
}, {
  CIP7: '3317447',
  CIP13: '3400933174477',
  ucdLib: "ARKOGELULES GINSENG 390MG",
  UCD7: '9138935',
  UCD13: '3400891389357',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES GINSENG 390MG BT 150",
  atcCode: "A13A"
}, {
  CIP7: '3336321',
  CIP13: '3400933363215',
  ucdLib: "PHYTEMAG GELU",
  UCD7: '9154130',
  UCD13: '3400891541304',
  ucdQtyMultiplicator: 20,
  cipLib: "PHYTEMAG GELU BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3343597',
  CIP13: '3400933435974',
  ucdLib: "ACTI 5 BUV AMP5ML",
  UCD7: '9000674',
  UCD13: '3400890006743',
  ucdQtyMultiplicator: 30,
  cipLib: "ACTI 5 BUV AMP5ML BT 30",
  atcCode: "A13A"
}, {
  CIP7: '3345202',
  CIP13: '3400933452025',
  ucdLib: "STIMOL BUV SACH10ML",
  UCD7: '9153194',
  UCD13: '3400891531947',
  ucdQtyMultiplicator: 36,
  cipLib: "STIMOL BUV SACH10ML BT 36",
  atcCode: "A13A"
}, {
  CIP7: '3130157',
  CIP13: '3400931301578',
  ucdLib: "DEBRUMYL BUV AMP5ML",
  UCD7: '9024195',
  UCD13: '3400890241953',
  ucdQtyMultiplicator: 20,
  cipLib: "DEBRUMYL BUV AMP5ML BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3350203',
  CIP13: '3400933502034',
  ucdLib: "DYNAMISAN 3G/10ML BUV AMP",
  UCD7: '9164915',
  UCD13: '3400891649154',
  ucdQtyMultiplicator: 20,
  cipLib: "DYNAMISAN 3G/10ML BUV AMP BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3357300',
  CIP13: '3400933573003',
  ucdLib: "REVITALOSE S/S BUV A.JUM5ML",
  UCD7: '9159044',
  UCD13: '3400891590449',
  ucdQtyMultiplicator: 14,
  cipLib: "REVITALOSE S/S BUV A.JUM5ML BT 14",
  atcCode: "A13A"
}, {
  CIP7: '3545622',
  CIP13: '3400935456229',
  ucdLib: "SARGENOR VIT C BUV AMP5ML",
  UCD7: '9255517',
  UCD13: '3400892555171',
  ucdQtyMultiplicator: 20,
  cipLib: "SARGENOR VIT C BUV AMP5ML BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3545556',
  CIP13: '3400935455567',
  ucdLib: "SARGENOR VIT C CPR EFFV",
  UCD7: '9223606',
  UCD13: '3400892236063',
  ucdQtyMultiplicator: 20,
  cipLib: "SARGENOR VIT C CPR EFFV BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3177555',
  CIP13: '3400931775553',
  ucdLib: "STIMOL 1G BUV AMP10ML",
  UCD7: '9087936',
  UCD13: '3400890879361',
  ucdQtyMultiplicator: 18,
  cipLib: "STIMOL 1G BUV AMP10ML BT 18",
  atcCode: "A13A"
}, {
  CIP7: '3769244',
  CIP13: '3400937692441',
  ucdLib: "GCFORM CPR EFFV",
  UCD7: '9392042',
  UCD13: '3400893920428',
  ucdQtyMultiplicator: 30,
  cipLib: "GCFORM CPR EFFV BT 30",
  atcCode: "A13A"
}, {
  CIP7: '3490542',
  CIP13: '3400934905421',
  ucdLib: "FASTENYL BUV AMP5ML",
  UCD7: '9228928',
  UCD13: '3400892289281',
  ucdQtyMultiplicator: 20,
  cipLib: "FASTENYL BUV AMP5ML BT 20",
  atcCode: "A13A"
}, {
  CIP7: '3478601',
  CIP13: '3400934786013',
  ucdLib: "SARGENOR 0,5G BUV AMP5ML",
  UCD7: '9237703',
  UCD13: '3400892377032',
  ucdQtyMultiplicator: 40,
  cipLib: "SARGENOR 0,5G BUV AMP5ML BT 40",
  atcCode: "A13A"
}, {
  CIP7: '3441213',
  CIP13: '3400934412134',
  ucdLib: "SARGENOR S/SUC 1G CPR CROQ",
  UCD7: '9197257',
  UCD13: '3400891972573',
  ucdQtyMultiplicator: 40,
  cipLib: "SARGENOR S/SUC 1G CPR CROQ BT 40",
  atcCode: "A13A"
}, {
  CIP7: '3425154',
  CIP13: '3400934251542',
  ucdLib: "SARGENOR S/SUC 1G CPR EFFV",
  UCD7: '9194997',
  UCD13: '3400891949971',
  ucdQtyMultiplicator: 40,
  cipLib: "SARGENOR S/SUC 1G CPR EFFV BT 40",
  atcCode: "A13A"
}, {
  CIP7: '3032437',
  CIP13: '3400930324370',
  ucdLib: "DISSOLVUROL BUV GTT FL45ML",
  UCD7: '9027905',
  UCD13: '3400890279055',
  ucdQtyMultiplicator: 1,
  cipLib: "DISSOLVUROL BUV GTT FL45ML BT 1",
  atcCode: "A12CX"
}, {
  CIP7: '3046221',
  CIP13: '3400930462218',
  ucdLib: "GRANIONS BISMUTH BUV AMP2ML",
  UCD7: '9040780',
  UCD13: '3400890407809',
  ucdQtyMultiplicator: 10,
  cipLib: "GRANIONS BISMUTH BUV AMP2ML BT 10",
  atcCode: "A12CX"
}, {
  CIP7: '3075062',
  CIP13: '3400930750629',
  ucdLib: "OLIGOSOL BISMUTH BUV A.1ML",
  UCD7: '9064792',
  UCD13: '3400890647922',
  ucdQtyMultiplicator: 10,
  cipLib: "OLIGOSOL BISMUTH BUV A.1ML BT 10",
  atcCode: "A12CX"
}, {
  CIP7: '3075139',
  CIP13: '3400930751398',
  ucdLib: "OLIGOSOL COBALT BUV A.2ML",
  UCD7: '9064817',
  UCD13: '3400890648172',
  ucdQtyMultiplicator: 14,
  cipLib: "OLIGOSOL COBALT BUV A.2ML BT 14",
  atcCode: "A12CX"
}, {
  CIP7: '3075079',
  CIP13: '3400930750797',
  ucdLib: "OLIGOSOL CU-AU-AG BUV FL60ML",
  UCD7: '9064846',
  UCD13: '3400890648462',
  ucdQtyMultiplicator: 1,
  cipLib: "OLIGOSOL CU-AU-AG BUV FL60ML BT 1",
  atcCode: "A12CX"
}, {
  CIP7: '3075174',
  CIP13: '3400930751749',
  ucdLib: "OLIGOSOL MANGANESE BUV A.2ML",
  UCD7: '9064898',
  UCD13: '3400890648981',
  ucdQtyMultiplicator: 14,
  cipLib: "OLIGOSOL MANGANESE BUV A.2ML BT 14",
  atcCode: "A12CX"
}, {
  CIP7: '3075180',
  CIP13: '3400930751800',
  ucdLib: "OLIGOSOL MN-CU-CO BUV A.2ML",
  UCD7: '9064929',
  UCD13: '3400890649292',
  ucdQtyMultiplicator: 14,
  cipLib: "OLIGOSOL MN-CU-CO BUV A.2ML BT 14",
  atcCode: "A12CX"
}, {
  CIP7: '3075205',
  CIP13: '3400930752050',
  ucdLib: "OLIGOSOL PHOSPHORE BUV A.2ML",
  UCD7: '9064941',
  UCD13: '3400890649414',
  ucdQtyMultiplicator: 14,
  cipLib: "OLIGOSOL PHOSPHORE BUV A.2ML BT 14",
  atcCode: "A12CX"
}, {
  CIP7: '3355175',
  CIP13: '3400933551759',
  ucdLib: "PHOSPHONEUROS BUV GTT FL120ML",
  UCD7: '9154532',
  UCD13: '3400891545326',
  ucdQtyMultiplicator: 1,
  cipLib: "PHOSPHONEUROS BUV GTT FL120ML BT 1",
  atcCode: "A12CX"
}, {
  CIP7: '3666722',
  CIP13: '3400936667228',
  ucdLib: "GRANIONS LITHIUM BUV AMP2ML",
  UCD7: '9153159',
  UCD13: '3400891531596',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS LITHIUM BUV AMP2ML BT 30",
  atcCode: "A12CX"
}, {
  CIP7: '3754604',
  CIP13: '3400937546041',
  ucdLib: "GRANIONS CUIVRE BUV AMP2ML",
  UCD7: '9040797',
  UCD13: '3400890407977',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS CUIVRE BUV AMP2ML BT 30",
  atcCode: "A12CX"
}, {
  CIP7: '3754596',
  CIP13: '3400937545969',
  ucdLib: "GRANIONS MANGANESE BUV 2ML",
  UCD7: '9188235',
  UCD13: '3400891882353',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS MANGANESE BUV 2ML BT 30",
  atcCode: "A12CX"
}, {
  CIP7: '3754679',
  CIP13: '3400937546799',
  ucdLib: "OLIGOSOL CUIVRE BUV A.2ML",
  UCD7: '9064823',
  UCD13: '3400890648233',
  ucdQtyMultiplicator: 28,
  cipLib: "OLIGOSOL CUIVRE BUV A.2ML BT 28",
  atcCode: "A12CX"
}, {
  CIP7: '3754745',
  CIP13: '3400937547451',
  ucdLib: "OLIGOSOL MN-CU BUV A.2ML",
  UCD7: '9182296',
  UCD13: '3400891822960',
  ucdQtyMultiplicator: 28,
  cipLib: "OLIGOSOL MN-CU BUV A.2ML BT 28",
  atcCode: "A12CX"
}, {
  CIP7: '3754768',
  CIP13: '3400937547680',
  ucdLib: "OLIGOSOL SOUFRE BUV A.2ML",
  UCD7: '9064970',
  UCD13: '3400890649704',
  ucdQtyMultiplicator: 28,
  cipLib: "OLIGOSOL SOUFRE BUV A.2ML BT 28",
  atcCode: "A12CX"
}, {
  CIP7: '3943883',
  CIP13: '3400939438832',
  ucdLib: "GRANIONS ARGENT BUV AMP2ML",
  UCD7: '9040768',
  UCD13: '3400890407687',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS ARGENT BUV AMP2ML BT 30",
  atcCode: "A12CX"
}, {
  CIP7: '4940970',
  CIP13: '3400949409709',
  ucdLib: "OLIGOCURE BUV FP60ML",
  UCD7: '9368977',
  UCD13: '3400893689776',
  ucdQtyMultiplicator: 1,
  cipLib: "OLIGOCURE BUV FP60ML BT 1",
  atcCode: "A12CX"
}, {
  CIP7: '3334150',
  CIP13: '3400933341503',
  ucdLib: "SELENIUM AGT 10MCG/ML 10ML",
  UCD7: '9130655',
  UCD13: '3400891306552',
  ucdQtyMultiplicator: 10,
  cipLib: "SELENIUM AGT 10MCG/ML 10ML BT 10",
  atcCode: "A12CE02"
}, {
  CIP7: '3754751',
  CIP13: '3400937547512',
  ucdLib: "OLIGOSOL SELENIUM BUV A.2ML",
  UCD7: '9204715',
  UCD13: '3400892047157',
  ucdQtyMultiplicator: 28,
  cipLib: "OLIGOSOL SELENIUM BUV A.2ML BT 28",
  atcCode: "A12CE02"
}, {
  CIP7: '3571849',
  CIP13: '3400935718495',
  ucdLib: "FLUOSTEROL BUV FL22,5ML",
  UCD7: '9250218',
  UCD13: '3400892502182',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOSTEROL BUV FL22,5ML BT 1",
  atcCode: "A12CD51"
}, {
  CIP7: '3481069',
  CIP13: '3400934810695',
  ucdLib: "ZYMADUO 300UI BUV GTT FL12ML",
  UCD7: '9218545',
  UCD13: '3400892185453',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYMADUO 300UI BUV GTT FL12ML BT 1",
  atcCode: "A12CD51"
}, {
  CIP7: '3478050',
  CIP13: '3400934780509',
  ucdLib: "ZYMADUO 150UI BUV GTT FL12ML",
  UCD7: '9218539',
  UCD13: '3400892185392',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYMADUO 150UI BUV GTT FL12ML BT 1",
  atcCode: "A12CD51"
}, {
  CIP7: '3690790',
  CIP13: '3400936907904',
  ucdLib: "SARGEMAG GLE EFFV SACH",
  UCD7: '9278889',
  UCD13: '3400892788890',
  ucdQtyMultiplicator: 30,
  cipLib: "SARGEMAG GLE EFFV SACH BT 30",
  atcCode: "A12CC30"
}, {
  CIP7: '3341351',
  CIP13: '3400933413514',
  ucdLib: "MAGNESIUM ARW 150MG CPR",
  UCD7: '9251407',
  UCD13: '3400892514079',
  ucdQtyMultiplicator: 20,
  cipLib: "MAGNESIUM ARW 150MG CPR BT 20",
  atcCode: "A12CC10"
}, {
  CIP7: '3325820',
  CIP13: '3400933258207',
  ucdLib: "MAG 2 BUV PDR SACH6G",
  UCD7: '9155402',
  UCD13: '3400891554021',
  ucdQtyMultiplicator: 30,
  cipLib: "MAG 2 BUV PDR SACH6G BT 30",
  atcCode: "A12CC08"
}, {
  CIP7: '3638223',
  CIP13: '3400936382237',
  ucdLib: "MAG 2 S/SUC BUV AMP10ML",
  UCD7: '9353792',
  UCD13: '3400893537923',
  ucdQtyMultiplicator: 30,
  cipLib: "MAG 2 S/SUC BUV AMP10ML BT 30",
  atcCode: "A12CC08"
}, {
  CIP7: '3064383',
  CIP13: '3400930643839',
  ucdLib: "MAGNESPASMYL 1,9% GLE BT100G",
  UCD7: '9056373',
  UCD13: '3400890563734',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNESPASMYL 1,9% GLE BT100G BT 1",
  atcCode: "A12CC06"
}, {
  CIP7: '3064408',
  CIP13: '3400930644089',
  ucdLib: "MAGNESPASMYL 47,4MG CPR",
  UCD7: '9056396',
  UCD13: '3400890563963',
  ucdQtyMultiplicator: 50,
  cipLib: "MAGNESPASMYL 47,4MG CPR BT 50",
  atcCode: "A12CC06"
}, {
  CIP7: '3494497',
  CIP13: '3400934944970',
  ucdLib: "MAGNESIUM GLYC. LAFARGE CPR",
  UCD7: '9056249',
  UCD13: '3400890562492',
  ucdQtyMultiplicator: 40,
  cipLib: "MAGNESIUM GLYC. LAFARGE CPR BT 40",
  atcCode: "A12CC06"
}, {
  CIP7: '3494505',
  CIP13: '3400934945052',
  ucdLib: "MAGNESIUM GLYC. LAFARGE CPR",
  UCD7: '9056249',
  UCD13: '3400890562492',
  ucdQtyMultiplicator: 80,
  cipLib: "MAGNESIUM GLYC. LAFARGE CPR BT 80",
  atcCode: "A12CC06"
}, {
  CIP7: '4917267',
  CIP13: '3400949172672',
  ucdLib: "MEGAMAG 45MG GELU",
  UCD7: '9363276',
  UCD13: '3400893632765',
  ucdQtyMultiplicator: 60,
  cipLib: "MEGAMAG 45MG GELU BT 60",
  atcCode: "A12CC05"
}, {
  CIP7: '4964350',
  CIP13: '3400949643509',
  ucdLib: "MEGAMAG 45MG GELU",
  UCD7: '9363276',
  UCD13: '3400893632765',
  ucdQtyMultiplicator: 120,
  cipLib: "MEGAMAG 45MG GELU BT 120",
  atcCode: "A12CC05"
}, {
  CIP7: '3292635',
  CIP13: '3400932926350',
  ucdLib: "SPASMAG BUV AMP5ML",
  UCD7: '9119843',
  UCD13: '3400891198430',
  ucdQtyMultiplicator: 30,
  cipLib: "SPASMAG BUV AMP5ML BT 30",
  atcCode: "A12CC02"
}, {
  CIP7: '3236909',
  CIP13: '3400932369096',
  ucdLib: "SPASMAG GELU",
  UCD7: '9086859',
  UCD13: '3400890868594',
  ucdQtyMultiplicator: 60,
  cipLib: "SPASMAG GELU BT 60",
  atcCode: "A12CC02"
}, {
  CIP7: '3666745',
  CIP13: '3400936667457',
  ucdLib: "GRANIONS MAGNESIUM BUV AMP2ML",
  UCD7: '9040828',
  UCD13: '3400890408288',
  ucdQtyMultiplicator: 30,
  cipLib: "GRANIONS MAGNESIUM BUV AMP2ML BT 30",
  atcCode: "A12CC01"
}, {
  CIP7: '3306857',
  CIP13: '3400933068578',
  ucdLib: "RUBOZINC 15MG GELU",
  UCD7: '9127995',
  UCD13: '3400891279955',
  ucdQtyMultiplicator: 30,
  cipLib: "RUBOZINC 15MG GELU BT 30",
  atcCode: "A12CB02"
}, {
  CIP7: '3334144',
  CIP13: '3400933341442',
  ucdLib: "ZINC AGT 1MG/ML INJ FV10ML",
  UCD7: '9129385',
  UCD13: '3400891293852',
  ucdQtyMultiplicator: 10,
  cipLib: "ZINC AGT 1MG/ML INJ FV10ML BT 10",
  atcCode: "A12CB02"
}, {
  CIP7: '3678955',
  CIP13: '3400936789555',
  ucdLib: "EFFIZINC 15MG GELU",
  UCD7: '9276459',
  UCD13: '3400892764597',
  ucdQtyMultiplicator: 30,
  cipLib: "EFFIZINC 15MG GELU BT 30",
  atcCode: "A12CB02"
}, {
  CIP7: '3678978',
  CIP13: '3400936789784',
  ucdLib: "EFFIZINC 15MG GELU",
  UCD7: '9276459',
  UCD13: '3400892764597',
  ucdQtyMultiplicator: 60,
  cipLib: "EFFIZINC 15MG GELU BT 60",
  atcCode: "A12CB02"
}, {
  CIP7: '3705445',
  CIP13: '3400937054454',
  ucdLib: "RUBOZINC 15MG GELU",
  UCD7: '9127995',
  UCD13: '3400891279955',
  ucdQtyMultiplicator: 60,
  cipLib: "RUBOZINC 15MG GELU BT 60",
  atcCode: "A12CB02"
}, {
  CIP7: '3293669',
  CIP13: '3400932936694',
  ucdLib: "POTASSIUM RICHARD SIR SACH15ML",
  UCD7: '9130885',
  UCD13: '3400891308853',
  ucdQtyMultiplicator: 20,
  cipLib: "POTASSIUM RICHARD SIR SACH15ML BT 20",
  atcCode: "A12BA51"
}, {
  CIP7: '3130418',
  CIP13: '3400931304180',
  ucdLib: "POTASSIUM RICHARD SIR FL250ML",
  UCD7: '9074595',
  UCD13: '3400890745956',
  ucdQtyMultiplicator: 1,
  cipLib: "POTASSIUM RICHARD SIR FL250ML BT 1",
  atcCode: "A12BA51"
}, {
  CIP7: '3006305',
  CIP13: '3400930063057',
  ucdLib: "POTASSIUM H2P 25MG/ML SIR200ML",
  UCD7: '9421648',
  UCD13: '3400894216483',
  ucdQtyMultiplicator: 1,
  cipLib: "POTASSIUM H2P 25MG/ML SIR200ML BT 1",
  atcCode: "A12BA05"
}, {
  CIP7: '3075211',
  CIP13: '3400930752111',
  ucdLib: "OLIGOSOL POTASSIUM BUV A.2ML",
  UCD7: '9064958',
  UCD13: '3400890649582',
  ucdQtyMultiplicator: 14,
  cipLib: "OLIGOSOL POTASSIUM BUV A.2ML BT 14",
  atcCode: "A12BA05"
}, {
  CIP7: '3430439',
  CIP13: '3400934304392',
  ucdLib: "POTASSIUM H2P 25MG/ML SIR250ML",
  UCD7: '9257278',
  UCD13: '3400892572789',
  ucdQtyMultiplicator: 1,
  cipLib: "POTASSIUM H2P 25MG/ML SIR250ML BT 1",
  atcCode: "A12BA05"
}, {
  CIP7: '3070136',
  CIP13: '3400930701362',
  ucdLib: "NATI-K 500MG CPR",
  UCD7: '9061078',
  UCD13: '3400890610780',
  ucdQtyMultiplicator: 40,
  cipLib: "NATI-K 500MG CPR BT 40",
  atcCode: "A12BA03"
}, {
  CIP7: '3327782',
  CIP13: '3400933277826',
  ucdLib: "KALEORID LP 1000MG CPR",
  UCD7: '9148394',
  UCD13: '3400891483949',
  ucdQtyMultiplicator: 30,
  cipLib: "KALEORID LP 1000MG CPR BT 30",
  atcCode: "A12BA01"
}, {
  CIP7: '3321733',
  CIP13: '3400933217334',
  ucdLib: "KALEORID LP 600MG CPR",
  UCD7: '9048333',
  UCD13: '3400890483339',
  ucdQtyMultiplicator: 30,
  cipLib: "KALEORID LP 600MG CPR BT 30",
  atcCode: "A12BA01"
}, {
  CIP7: '3290599',
  CIP13: '3400932905997',
  ucdLib: "DIFFU-K GELU",
  UCD7: '9122503',
  UCD13: '3400891225037',
  ucdQtyMultiplicator: 40,
  cipLib: "DIFFU-K GELU BT 40",
  atcCode: "A12BA01"
}, {
  CIP7: '3615653',
  CIP13: '3400936156531',
  ucdLib: "EPTAVIT 1000MG/880UI C.EFFV",
  UCD7: '9262575',
  UCD13: '3400892625751',
  ucdQtyMultiplicator: 30,
  cipLib: "EPTAVIT 1000MG/880UI C.EFFV BT 30",
  atcCode: "A12AX"
}, {
  CIP7: '3239523',
  CIP13: '3400932395231',
  ucdLib: "OSSOPAN 600MG CPR PELLIC",
  UCD7: '9066093',
  UCD13: '3400890660938',
  ucdQtyMultiplicator: 30,
  cipLib: "OSSOPAN 600MG CPR PELLIC BT 30",
  atcCode: "A12AX"
}, {
  CIP7: '3601243',
  CIP13: '3400936012431',
  ucdLib: "CALCIPRAT D3 1000MG/800UI C.",
  UCD7: '9250879',
  UCD13: '3400892508795',
  ucdQtyMultiplicator: 30,
  cipLib: "CALCIPRAT D3 1000MG/800UI C. BT 30",
  atcCode: "A12AX"
}, {
  CIP7: '3566825',
  CIP13: '3400935668257',
  ucdLib: "CALCIFORTE VIT D3 CPR",
  UCD7: '9237123',
  UCD13: '3400892371238',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIFORTE VIT D3 CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3564602',
  CIP13: '3400935646026',
  ucdLib: "CALCIUM D3 BGA 500MG CPR",
  UCD7: '9260240',
  UCD13: '3400892602400',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIUM D3 BGA 500MG CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3564588',
  CIP13: '3400935645883',
  ucdLib: "CALCIUM D3 EG 500MG CPR",
  UCD7: '9265591',
  UCD13: '3400892655918',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIUM D3 EG 500MG CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3396955',
  CIP13: '3400933969554',
  ucdLib: "CALTRATE VIT D3 600 CPR",
  UCD7: '9182451',
  UCD13: '3400891824513',
  ucdQtyMultiplicator: 60,
  cipLib: "CALTRATE VIT D3 600 CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3556318',
  CIP13: '3400935563187',
  ucdLib: "METOCALCIUM 600MG/400UI CPR",
  UCD7: '9235348',
  UCD13: '3400892353487',
  ucdQtyMultiplicator: 60,
  cipLib: "METOCALCIUM 600MG/400UI CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3411560',
  CIP13: '3400934115608',
  ucdLib: "CALCIPRAT D3 500MG/400UI C.",
  UCD7: '9185627',
  UCD13: '3400891856279',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIPRAT D3 500MG/400UI C. BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3511445',
  CIP13: '3400935114457',
  ucdLib: "CALCIUM D3 SDZ 500MG CPR",
  UCD7: '9217511',
  UCD13: '3400892175119',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIUM D3 SDZ 500MG CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3411577',
  CIP13: '3400934115776',
  ucdLib: "CALPEROS D3 CPR SUCER",
  UCD7: '9186383',
  UCD13: '3400891863833',
  ucdQtyMultiplicator: 60,
  cipLib: "CALPEROS D3 CPR SUCER BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3515615',
  CIP13: '3400935156150',
  ucdLib: "OSSEANS VIT D3 CPR",
  UCD7: '9215067',
  UCD13: '3400892150673',
  ucdQtyMultiplicator: 60,
  cipLib: "OSSEANS VIT D3 CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3547650',
  CIP13: '3400935476500',
  ucdLib: "CALCIUM D3 TVC 500MG CPR",
  UCD7: '9250885',
  UCD13: '3400892508856',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIUM D3 TVC 500MG CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3387873',
  CIP13: '3400933878733',
  ucdLib: "CACIT VIT D3 1000 GLE EFFV S",
  UCD7: '9175586',
  UCD13: '3400891755862',
  ucdQtyMultiplicator: 30,
  cipLib: "CACIT VIT D3 1000 GLE EFFV S BT 30",
  atcCode: "A12AX"
}, {
  CIP7: '3724106',
  CIP13: '3400937241069',
  ucdLib: "CACIT VIT D3 1000 GLE EFFV S",
  UCD7: '9175586',
  UCD13: '3400891755862',
  ucdQtyMultiplicator: 90,
  cipLib: "CACIT VIT D3 1000 GLE EFFV S BT 90",
  atcCode: "A12AX"
}, {
  CIP7: '3383088',
  CIP13: '3400933830885',
  ucdLib: "CALCIDOSE VIT D3 PDR SACH",
  UCD7: '9176640',
  UCD13: '3400891766400',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIDOSE VIT D3 PDR SACH BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3762874',
  CIP13: '3400937628747',
  ucdLib: "FIXICAL D3 1000MG/800UI CPR",
  UCD7: '9265639',
  UCD13: '3400892656397',
  ucdQtyMultiplicator: 90,
  cipLib: "FIXICAL D3 1000MG/800UI CPR BT 90",
  atcCode: "A12AX"
}, {
  CIP7: '3765482',
  CIP13: '3400937654821',
  ucdLib: "FIXICAL D3 500MG/400UI CPR",
  UCD7: '9210868',
  UCD13: '3400892108681',
  ucdQtyMultiplicator: 180,
  cipLib: "FIXICAL D3 500MG/400UI CPR BT 180",
  atcCode: "A12AX"
}, {
  CIP7: '3380977',
  CIP13: '3400933809775',
  ucdLib: "IDEOS 500MG/400UI CPR SUCER",
  UCD7: '9171602',
  UCD13: '3400891716023',
  ucdQtyMultiplicator: 60,
  cipLib: "IDEOS 500MG/400UI CPR SUCER BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3696060',
  CIP13: '3400936960602',
  ucdLib: "OROCAL D3 500MG/200UI CPR",
  UCD7: '9290583',
  UCD13: '3400892905839',
  ucdQtyMultiplicator: 60,
  cipLib: "OROCAL D3 500MG/200UI CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3720580',
  CIP13: '3400937205801',
  ucdLib: "OROCAL D3 500MG/400UI CPR",
  UCD7: '9205117',
  UCD13: '3400892051178',
  ucdQtyMultiplicator: 180,
  cipLib: "OROCAL D3 500MG/400UI CPR BT 180",
  atcCode: "A12AX"
}, {
  CIP7: '3644092',
  CIP13: '3400936440920',
  ucdLib: "CACIT VIT D3 500 CPR",
  UCD7: '9262931',
  UCD13: '3400892629315',
  ucdQtyMultiplicator: 60,
  cipLib: "CACIT VIT D3 500 CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3473377',
  CIP13: '3400934733772',
  ucdLib: "CALCIUM D3 MYL 500MG CPR",
  UCD7: '9206341',
  UCD13: '3400892063416',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIUM D3 MYL 500MG CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3474514',
  CIP13: '3400934745140',
  ucdLib: "DENSICAL VIT D3 CPR",
  UCD7: '9207530',
  UCD13: '3400892075303',
  ucdQtyMultiplicator: 60,
  cipLib: "DENSICAL VIT D3 CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3642472',
  CIP13: '3400936424722',
  ucdLib: "FIXICAL D3 1000MG/800UI CPR",
  UCD7: '9265639',
  UCD13: '3400892656397',
  ucdQtyMultiplicator: 30,
  cipLib: "FIXICAL D3 1000MG/800UI CPR BT 30",
  atcCode: "A12AX"
}, {
  CIP7: '3737741',
  CIP13: '3400937377416',
  ucdLib: "CALCIFORTE VIT D3 CPR",
  UCD7: '9237123',
  UCD13: '3400892371238',
  ucdQtyMultiplicator: 180,
  cipLib: "CALCIFORTE VIT D3 CPR BT 180",
  atcCode: "A12AX"
}, {
  CIP7: '3738953',
  CIP13: '3400937389532',
  ucdLib: "CALCIPRAT D3 1000MG/800UI C.",
  UCD7: '9250879',
  UCD13: '3400892508795',
  ucdQtyMultiplicator: 90,
  cipLib: "CALCIPRAT D3 1000MG/800UI C. BT 90",
  atcCode: "A12AX"
}, {
  CIP7: '3738829',
  CIP13: '3400937388290',
  ucdLib: "CALTRATE VIT D3 600 CPR",
  UCD7: '9182451',
  UCD13: '3400891824513',
  ucdQtyMultiplicator: 180,
  cipLib: "CALTRATE VIT D3 600 CPR BT 180",
  atcCode: "A12AX"
}, {
  CIP7: '3730288',
  CIP13: '3400937302883',
  ucdLib: "EPTAVIT 1000MG/880UI C.EFFV",
  UCD7: '9262575',
  UCD13: '3400892625751',
  ucdQtyMultiplicator: 90,
  cipLib: "EPTAVIT 1000MG/880UI C.EFFV BT 90",
  atcCode: "A12AX"
}, {
  CIP7: '3738841',
  CIP13: '3400937388412',
  ucdLib: "OROCAL D3 500MG/200UI CPR",
  UCD7: '9290583',
  UCD13: '3400892905839',
  ucdQtyMultiplicator: 180,
  cipLib: "OROCAL D3 500MG/200UI CPR BT 180",
  atcCode: "A12AX"
}, {
  CIP7: '3442804',
  CIP13: '3400934428043',
  ucdLib: "OROCAL D3 500MG/400UI CPR",
  UCD7: '9205117',
  UCD13: '3400892051178',
  ucdQtyMultiplicator: 60,
  cipLib: "OROCAL D3 500MG/400UI CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3875153',
  CIP13: '3400938751536',
  ucdLib: "OSSEANS VIT D3 CPR",
  UCD7: '9215067',
  UCD13: '3400892150673',
  ucdQtyMultiplicator: 180,
  cipLib: "OSSEANS VIT D3 CPR BT 180",
  atcCode: "A12AX"
}, {
  CIP7: '3500507',
  CIP13: '3400935005076',
  ucdLib: "FIXICAL D3 500MG/400UI CPR",
  UCD7: '9210868',
  UCD13: '3400892108681',
  ucdQtyMultiplicator: 60,
  cipLib: "FIXICAL D3 500MG/400UI CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '3979183',
  CIP13: '3400939791838',
  ucdLib: "NATECAL D3 600MG/400UI C.D",
  UCD7: '9348609',
  UCD13: '3400893486092',
  ucdQtyMultiplicator: 60,
  cipLib: "NATECAL D3 600MG/400UI C.D BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '4160344',
  CIP13: '3400941603440',
  ucdLib: "CALCIUM D3 ZYD 500MG CPR",
  UCD7: '9373978',
  UCD13: '3400893739785',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIUM D3 ZYD 500MG CPR BT 60",
  atcCode: "A12AX"
}, {
  CIP7: '2202802',
  CIP13: '3400922028026',
  ucdLib: "STRUCTOCAL D3 1000MG/880UI C",
  UCD7: '9417687',
  UCD13: '3400894176879',
  ucdQtyMultiplicator: 30,
  cipLib: "STRUCTOCAL D3 1000MG/880UI C BT 30",
  atcCode: "A12AX"
}, {
  CIP7: '3329829',
  CIP13: '3400933298296',
  ucdLib: "CALCIFORTE 500MG BUV A.10ML",
  UCD7: '9014446',
  UCD13: '3400890144469',
  ucdQtyMultiplicator: 30,
  cipLib: "CALCIFORTE 500MG BUV A.10ML BT 30",
  atcCode: "A12AA20"
}, {
  CIP7: '3003523',
  CIP13: '3400930035238',
  ucdLib: "CALCIUM GL.10% LAV AP10ML",
  UCD7: '9413330',
  UCD13: '3400894133308',
  ucdQtyMultiplicator: 10,
  cipLib: "CALCIUM GL.10% LAV AP10ML BT 10",
  atcCode: "A12AA20"
}, {
  CIP7: '3016993',
  CIP13: '3400930169933',
  ucdLib: "CALCIUM SDZ 500MG CPR EFFV",
  UCD7: '9015049',
  UCD13: '3400890150491',
  ucdQtyMultiplicator: 20,
  cipLib: "CALCIUM SDZ 500MG CPR EFFV BT 20",
  atcCode: "A12AA20"
}, {
  CIP7: '3557080',
  CIP13: '3400935570802',
  ucdLib: "CALCIUM SDZ 500MG BUV SACH",
  UCD7: '9231379',
  UCD13: '3400892313795',
  ucdQtyMultiplicator: 30,
  cipLib: "CALCIUM SDZ 500MG BUV SACH BT 30",
  atcCode: "A12AA20"
}, {
  CIP7: '5501247',
  CIP13: '3400955012474',
  ucdLib: "CALCIUM GL.10% LAV AP10ML",
  UCD7: '9413330',
  UCD13: '3400894133308',
  ucdQtyMultiplicator: 100,
  cipLib: "CALCIUM GL.10% LAV AP10ML BT 100",
  atcCode: "A12AA20"
}, {
  CIP7: '5705716',
  CIP13: '3400957057169',
  ucdLib: "CALCIUM GL.10% PROAMP A10ML",
  UCD7: '9299934',
  UCD13: '3400892999340',
  ucdQtyMultiplicator: 50,
  cipLib: "CALCIUM GL.10% PROAMP A10ML BT 50",
  atcCode: "A12AA20"
}, {
  CIP7: '3459348',
  CIP13: '3400934593482',
  ucdLib: "CALPRIMUM 500MG CPR CROQ",
  UCD7: '9201496',
  UCD13: '3400892014968',
  ucdQtyMultiplicator: 60,
  cipLib: "CALPRIMUM 500MG CPR CROQ BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3611678',
  CIP13: '3400936116788',
  ucdLib: "CALCIUM TVC 500MG CPR",
  UCD7: '9244703',
  UCD13: '3400892447032',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIUM TVC 500MG CPR BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3322916',
  CIP13: '3400933229160',
  ucdLib: "OROCAL 500MG CPR",
  UCD7: '9144539',
  UCD13: '3400891445398',
  ucdQtyMultiplicator: 60,
  cipLib: "OROCAL 500MG CPR BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3299985',
  CIP13: '3400932999859',
  ucdLib: "CACIT 500MG CPR EFFV",
  UCD7: '9129712',
  UCD13: '3400891297126',
  ucdQtyMultiplicator: 60,
  cipLib: "CACIT 500MG CPR EFFV BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3295450',
  CIP13: '3400932954506',
  ucdLib: "CALCIDIA 1,54G GLE SACH",
  UCD7: '9123649',
  UCD13: '3400891236491',
  ucdQtyMultiplicator: 20,
  cipLib: "CALCIDIA 1,54G GLE SACH BT 20",
  atcCode: "A12AA04"
}, {
  CIP7: '3312734',
  CIP13: '3400933127343',
  ucdLib: "CALTRATE 600MG CPR PELL",
  UCD7: '9149548',
  UCD13: '3400891495485',
  ucdQtyMultiplicator: 60,
  cipLib: "CALTRATE 600MG CPR PELL BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3300004',
  CIP13: '3400933000042',
  ucdLib: "CACIT 1000MG CPR EFFV",
  UCD7: '9129706',
  UCD13: '3400891297065',
  ucdQtyMultiplicator: 30,
  cipLib: "CACIT 1000MG CPR EFFV BT 30",
  atcCode: "A12AA04"
}, {
  CIP7: '3392236',
  CIP13: '3400933922368',
  ucdLib: "CALCIDOSE 500 BUV PDR SACH",
  UCD7: '9181517',
  UCD13: '3400891815177',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIDOSE 500 BUV PDR SACH BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3394146',
  CIP13: '3400933941468',
  ucdLib: "CALCIPRAT 1000MG CPR",
  UCD7: '9201220',
  UCD13: '3400892012209',
  ucdQtyMultiplicator: 30,
  cipLib: "CALCIPRAT 1000MG CPR BT 30",
  atcCode: "A12AA04"
}, {
  CIP7: '3362057',
  CIP13: '3400933620578',
  ucdLib: "CALCIPRAT 750MG CPR",
  UCD7: '9176427',
  UCD13: '3400891764277',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIPRAT 750MG CPR BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3394011',
  CIP13: '3400933940119',
  ucdLib: "CALCIUM MYL 500MG CPR",
  UCD7: '9192662',
  UCD13: '3400891926620',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIUM MYL 500MG CPR BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3360549',
  CIP13: '3400933605490',
  ucdLib: "CALPEROS 500MG CPR",
  UCD7: '9163169',
  UCD13: '3400891631692',
  ucdQtyMultiplicator: 60,
  cipLib: "CALPEROS 500MG CPR BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3387726',
  CIP13: '3400933877262',
  ucdLib: "CALCIPRAT 500MG CPR",
  UCD7: '9176410',
  UCD13: '3400891764109',
  ucdQtyMultiplicator: 60,
  cipLib: "CALCIPRAT 500MG CPR BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3500252',
  CIP13: '3400935002525',
  ucdLib: "FIXICAL 500MG CPR CROQ",
  UCD7: '9210874',
  UCD13: '3400892108742',
  ucdQtyMultiplicator: 60,
  cipLib: "FIXICAL 500MG CPR CROQ BT 60",
  atcCode: "A12AA04"
}, {
  CIP7: '3698366',
  CIP13: '3400936983663',
  ucdLib: "CALCIUM GL.10% BBM INJ 10ML",
  UCD7: '9293050',
  UCD13: '3400892930503',
  ucdQtyMultiplicator: 20,
  cipLib: "CALCIUM GL.10% BBM INJ 10ML BT 20",
  atcCode: "A12AA03"
}, {
  CIP7: '3695221',
  CIP13: '3400936952218',
  ucdLib: "CYSTINE B6 BAILLEUL CPR",
  UCD7: '9023646',
  UCD13: '3400890236461',
  ucdQtyMultiplicator: 60,
  cipLib: "CYSTINE B6 BAILLEUL CPR BT 60",
  atcCode: "A11JC"
}, {
  CIP7: '3801893',
  CIP13: '3400938018936',
  ucdLib: "CYSTINE B6 BAILLEUL CPR",
  UCD7: '9023646',
  UCD13: '3400890236461',
  ucdQtyMultiplicator: 120,
  cipLib: "CYSTINE B6 BAILLEUL CPR BT 120",
  atcCode: "A11JC"
}, {
  CIP7: '2167460',
  CIP13: '3400921674606',
  ucdLib: "CYSTINE B6 BGC 500/50MG CPR",
  UCD7: '9380582',
  UCD13: '3400893805824',
  ucdQtyMultiplicator: 60,
  cipLib: "CYSTINE B6 BGC 500/50MG CPR BT 60",
  atcCode: "A11JC"
}, {
  CIP7: '2167483',
  CIP13: '3400921674835',
  ucdLib: "CYSTINE B6 BGC 500/50MG CPR",
  UCD7: '9380582',
  UCD13: '3400893805824',
  ucdQtyMultiplicator: 120,
  cipLib: "CYSTINE B6 BGC 500/50MG CPR BT 120",
  atcCode: "A11JC"
}, {
  CIP7: '3405134',
  CIP13: '3400934051340',
  ucdLib: "BETASELEN GELU",
  UCD7: '9182391',
  UCD13: '3400891823912',
  ucdQtyMultiplicator: 50,
  cipLib: "BETASELEN GELU BT 50",
  atcCode: "A11JB"
}, {
  CIP7: '3405140',
  CIP13: '3400934051401',
  ucdLib: "BETASELEN GELU",
  UCD7: '9182391',
  UCD13: '3400891823912',
  ucdQtyMultiplicator: 200,
  cipLib: "BETASELEN GELU BT 200",
  atcCode: "A11JB"
}, {
  CIP7: '2791595',
  CIP13: '3400927915956',
  ucdLib: "UVESTEROL A.D.E.C. BUV FL10ML",
  UCD7: '9404905',
  UCD13: '3400894049050',
  ucdQtyMultiplicator: 1,
  cipLib: "UVESTEROL A.D.E.C. BUV FL10ML BT 1",
  atcCode: "A11JA"
}, {
  CIP7: '3294924',
  CIP13: '3400932949243',
  ucdLib: "BEPANTHENE 100MG CPR",
  UCD7: '9010230',
  UCD13: '3400890102308',
  ucdQtyMultiplicator: 60,
  cipLib: "BEPANTHENE 100MG CPR BT 60",
  atcCode: "A11HA30"
}, {
  CIP7: '3010708',
  CIP13: '3400930107089',
  ucdLib: "BEPANTHENE 500MG INJ AMP2ML",
  UCD7: '9010224',
  UCD13: '3400890102247',
  ucdQtyMultiplicator: 6,
  cipLib: "BEPANTHENE 500MG INJ AMP2ML BT 6",
  atcCode: "A11HA30"
}, {
  CIP7: '3989690',
  CIP13: '3400939896908',
  ucdLib: "VEDROP 50MG/ML BUV FL20ML +SRG",
  UCD7: '9311658',
  UCD13: '3400893116586',
  ucdQtyMultiplicator: 1,
  cipLib: "VEDROP 50MG/ML BUV FL20ML +SRG BT 1",
  atcCode: "A11HA08"
}, {
  CIP7: '3989709',
  CIP13: '3400939897097',
  ucdLib: "VEDROP 50MG/ML BUV FL60ML +SRG",
  UCD7: '9311664',
  UCD13: '3400893116647',
  ucdQtyMultiplicator: 1,
  cipLib: "VEDROP 50MG/ML BUV FL60ML +SRG BT 1",
  atcCode: "A11HA08"
}, {
  CIP7: '3690904',
  CIP13: '3400936909045',
  ucdLib: "BIOTINE BAYER 0,5% INJ A.1ML",
  UCD7: '9279506',
  UCD13: '3400892795065',
  ucdQtyMultiplicator: 6,
  cipLib: "BIOTINE BAYER 0,5% INJ A.1ML BT 6",
  atcCode: "A11HA05"
}, {
  CIP7: '3690927',
  CIP13: '3400936909274',
  ucdLib: "BIOTINE BAYER 5MG CPR",
  UCD7: '9279044',
  UCD13: '3400892790442',
  ucdQtyMultiplicator: 60,
  cipLib: "BIOTINE BAYER 5MG CPR BT 60",
  atcCode: "A11HA05"
}, {
  CIP7: '3010281',
  CIP13: '3400930102817',
  ucdLib: "BEFLAVINE 10MG CPR",
  UCD7: '9009913',
  UCD13: '3400890099134',
  ucdQtyMultiplicator: 20,
  cipLib: "BEFLAVINE 10MG CPR BT 20",
  atcCode: "A11HA04"
}, {
  CIP7: '3614576',
  CIP13: '3400936145764',
  ucdLib: "TOCOPHEROL TVC 500MG CAPS",
  UCD7: '9245714',
  UCD13: '3400892457147',
  ucdQtyMultiplicator: 30,
  cipLib: "TOCOPHEROL TVC 500MG CAPS BT 30",
  atcCode: "A11HA03"
}, {
  CIP7: '3264550',
  CIP13: '3400932645503',
  ucdLib: "TOCO 500MG CAPS MOL",
  UCD7: '9093411',
  UCD13: '3400890934114',
  ucdQtyMultiplicator: 30,
  cipLib: "TOCO 500MG CAPS MOL BT 30",
  atcCode: "A11HA03"
}, {
  CIP7: '3688267',
  CIP13: '3400936882676',
  ucdLib: "VIT E SDZ 500MG CAPS",
  UCD7: '9273254',
  UCD13: '3400892732541',
  ucdQtyMultiplicator: 30,
  cipLib: "VIT E SDZ 500MG CAPS BT 30",
  atcCode: "A11HA03"
}, {
  CIP7: '3405714',
  CIP13: '3400934057144',
  ucdLib: "TOCOLION CAPS",
  UCD7: '9187661',
  UCD13: '3400891876611',
  ucdQtyMultiplicator: 30,
  cipLib: "TOCOLION CAPS BT 30",
  atcCode: "A11HA03"
}, {
  CIP7: '3565346',
  CIP13: '3400935653468',
  ucdLib: "VIT E NPA 100MG/2ML INJ AMP",
  UCD7: '9232278',
  UCD13: '3400892322780',
  ucdQtyMultiplicator: 6,
  cipLib: "VIT E NPA 100MG/2ML INJ AMP BT 6",
  atcCode: "A11HA03"
}, {
  CIP7: '3765513',
  CIP13: '3400937655132',
  ucdLib: "DERMORELLE 200MG CAPS MOL",
  UCD7: '9235182',
  UCD13: '3400892351827',
  ucdQtyMultiplicator: 90,
  cipLib: "DERMORELLE 200MG CAPS MOL BT 90",
  atcCode: "A11HA03"
}, {
  CIP7: '5731151',
  CIP13: '3400957311513',
  ucdLib: "VIT E NPA 100MG/2ML INJ AMP",
  UCD7: '9232278',
  UCD13: '3400892322780',
  ucdQtyMultiplicator: 12,
  cipLib: "VIT E NPA 100MG/2ML INJ AMP BT 12",
  atcCode: "A11HA03"
}, {
  CIP7: '3272549',
  CIP13: '3400932725496',
  ucdLib: "BECILAN 250MG INJ AMP5ML",
  UCD7: '9009793',
  UCD13: '3400890097932',
  ucdQtyMultiplicator: 5,
  cipLib: "BECILAN 250MG INJ AMP5ML BT 5",
  atcCode: "A11HA02"
}, {
  CIP7: '3010246',
  CIP13: '3400930102466',
  ucdLib: "BECILAN 250MG CPR",
  UCD7: '9009801',
  UCD13: '3400890098014',
  ucdQtyMultiplicator: 40,
  cipLib: "BECILAN 250MG CPR BT 40",
  atcCode: "A11HA02"
}, {
  CIP7: '3193821',
  CIP13: '3400931938217',
  ucdLib: "VIT B6 RICHARD 250MG CPR",
  UCD7: '9100387',
  UCD13: '3400891003871',
  ucdQtyMultiplicator: 20,
  cipLib: "VIT B6 RICHARD 250MG CPR BT 20",
  atcCode: "A11HA02"
}, {
  CIP7: '5518279',
  CIP13: '3400955182795',
  ucdLib: "VIT B6 RICHARD 250MG CPR",
  UCD7: '9100387',
  UCD13: '3400891003871',
  ucdQtyMultiplicator: 1000,
  cipLib: "VIT B6 RICHARD 250MG CPR BT 1000",
  atcCode: "A11HA02"
}, {
  CIP7: '3643052',
  CIP13: '3400936430525',
  ucdLib: "PYRIDOXINE REN 250MG A.B5ML",
  UCD7: '9262078',
  UCD13: '3400892620787',
  ucdQtyMultiplicator: 10,
  cipLib: "PYRIDOXINE REN 250MG A.B5ML BT 10",
  atcCode: "A11HA02"
}, {
  CIP7: '3004210',
  CIP13: '3400930042106',
  ucdLib: "VIT PP AGT 500MG INJ AMP5ML",
  UCD7: '9415843',
  UCD13: '3400894158431',
  ucdQtyMultiplicator: 10,
  cipLib: "VIT PP AGT 500MG INJ AMP5ML BT 10",
  atcCode: "A11HA01"
}, {
  CIP7: '3855156',
  CIP13: '3400938551563',
  ucdLib: "VIT PP AGT 100MG INJ AMP2ML",
  UCD7: '9312818',
  UCD13: '3400893128183',
  ucdQtyMultiplicator: 10,
  cipLib: "VIT PP AGT 100MG INJ AMP2ML BT 10",
  atcCode: "A11HA01"
}, {
  CIP7: '2744851',
  CIP13: '3400927448515',
  ucdLib: "NICOTINAMIDE REN 100MG AV2ML",
  UCD7: '9398837',
  UCD13: '3400893988374',
  ucdQtyMultiplicator: 10,
  cipLib: "NICOTINAMIDE REN 100MG AV2ML BT 10",
  atcCode: "A11HA01"
}, {
  CIP7: '2744905',
  CIP13: '3400927449055',
  ucdLib: "NICOTINAMIDE REN 500MG AV5ML",
  UCD7: '9398843',
  UCD13: '3400893988435',
  ucdQtyMultiplicator: 10,
  cipLib: "NICOTINAMIDE REN 500MG AV5ML BT 10",
  atcCode: "A11HA01"
}, {
  CIP7: '2238220',
  CIP13: '3400922382203',
  ucdLib: "NICOBION 500MG CPR",
  UCD7: '9062942',
  UCD13: '3400890629423',
  ucdQtyMultiplicator: 30,
  cipLib: "NICOBION 500MG CPR BT 30",
  atcCode: "A11HA01"
}, {
  CIP7: '3007037',
  CIP13: '3400930070376',
  ucdLib: "CALCIUM ASCORB RCA ENF SACH",
  UCD7: '9014682',
  UCD13: '3400890146821',
  ucdQtyMultiplicator: 20,
  cipLib: "CALCIUM ASCORB RCA ENF SACH BT 20",
  atcCode: "A11GB01"
}, {
  CIP7: '3007020',
  CIP13: '3400930070208',
  ucdLib: "CALCIUM ASCORB RICHARD GLE125G",
  UCD7: '9014676',
  UCD13: '3400890146760',
  ucdQtyMultiplicator: 1,
  cipLib: "CALCIUM ASCORB RICHARD GLE125G BT 1",
  atcCode: "A11GB01"
}, {
  CIP7: '3324370',
  CIP13: '3400933243708',
  ucdLib: "VITASCORBOL 1G CPR EFFV",
  UCD7: '9145160',
  UCD13: '3400891451603',
  ucdQtyMultiplicator: 20,
  cipLib: "VITASCORBOL 1G CPR EFFV BT 20",
  atcCode: "A11GA01"
}, {
  CIP7: '3292718',
  CIP13: '3400932927180',
  ucdLib: "VIT C UPSA 500MG CROQ CPR",
  UCD7: '9183114',
  UCD13: '3400891831146',
  ucdQtyMultiplicator: 30,
  cipLib: "VIT C UPSA 500MG CROQ CPR BT 30",
  atcCode: "A11GA01"
}, {
  CIP7: '3242956',
  CIP13: '3400932429561',
  ucdLib: "VIT C PHR 1000MG CPR EFFV",
  UCD7: '9100482',
  UCD13: '3400891004823',
  ucdQtyMultiplicator: 20,
  cipLib: "VIT C PHR 1000MG CPR EFFV BT 20",
  atcCode: "A11GA01"
}, {
  CIP7: '3242910',
  CIP13: '3400932429103',
  ucdLib: "VIT C UPSA 1G EFFV CPR",
  UCD7: '9154845',
  UCD13: '3400891548457',
  ucdQtyMultiplicator: 20,
  cipLib: "VIT C UPSA 1G EFFV CPR BT 20",
  atcCode: "A11GA01"
}, {
  CIP7: '3354158',
  CIP13: '3400933541583',
  ucdLib: "VITASCORBOL 500 S/SUC CPR",
  UCD7: '9155359',
  UCD13: '3400891553598',
  ucdQtyMultiplicator: 12,
  cipLib: "VITASCORBOL 500 S/SUC CPR BT 12",
  atcCode: "A11GA01"
}, {
  CIP7: '3354164',
  CIP13: '3400933541644',
  ucdLib: "VITASCORBOL 500 S/SUC CPR",
  UCD7: '9155359',
  UCD13: '3400891553598',
  ucdQtyMultiplicator: 24,
  cipLib: "VITASCORBOL 500 S/SUC CPR BT 24",
  atcCode: "A11GA01"
}, {
  CIP7: '3566848',
  CIP13: '3400935668486',
  ucdLib: "VIT C UPSA FR.EXO CROQ CPR",
  UCD7: '9233148',
  UCD13: '3400892331485',
  ucdQtyMultiplicator: 30,
  cipLib: "VIT C UPSA FR.EXO CROQ CPR BT 30",
  atcCode: "A11GA01"
}, {
  CIP7: '3544580',
  CIP13: '3400935445803',
  ucdLib: "LAROSCORBINE 1G CPR EFFV",
  UCD7: '9049841',
  UCD13: '3400890498418',
  ucdQtyMultiplicator: 30,
  cipLib: "LAROSCORBINE 1G CPR EFFV BT 30",
  atcCode: "A11GA01"
}, {
  CIP7: '3544611',
  CIP13: '3400935446114',
  ucdLib: "LAROSCORBINE S.SUC 1G CPR",
  UCD7: '9145898',
  UCD13: '3400891458985',
  ucdQtyMultiplicator: 15,
  cipLib: "LAROSCORBINE S.SUC 1G CPR BT 15",
  atcCode: "A11GA01"
}, {
  CIP7: '3544634',
  CIP13: '3400935446343',
  ucdLib: "LAROSCORBINE S.SUC 1G CPR",
  UCD7: '9145898',
  UCD13: '3400891458985',
  ucdQtyMultiplicator: 30,
  cipLib: "LAROSCORBINE S.SUC 1G CPR BT 30",
  atcCode: "A11GA01"
}, {
  CIP7: '3584846',
  CIP13: '3400935848468',
  ucdLib: "LAROSCORBINE S.SUC 500MG CPR",
  UCD7: '9145912',
  UCD13: '3400891459128',
  ucdQtyMultiplicator: 30,
  cipLib: "LAROSCORBINE S.SUC 500MG CPR BT 30",
  atcCode: "A11GA01"
}, {
  CIP7: '3494764',
  CIP13: '3400934947643',
  ucdLib: "VIT C ARW 1G CPR EFFV",
  UCD7: '9251436',
  UCD13: '3400892514369',
  ucdQtyMultiplicator: 20,
  cipLib: "VIT C ARW 1G CPR EFFV BT 20",
  atcCode: "A11GA01"
}, {
  CIP7: '2734918',
  CIP13: '3400927349188',
  ucdLib: "VIT C ARW 500MG CROQ CPR",
  UCD7: '9397536',
  UCD13: '3400893975367',
  ucdQtyMultiplicator: 15,
  cipLib: "VIT C ARW 500MG CROQ CPR BT 15",
  atcCode: "A11GA01"
}, {
  CIP7: '2734924',
  CIP13: '3400927349249',
  ucdLib: "VIT C ARW 500MG CROQ CPR",
  UCD7: '9397536',
  UCD13: '3400893975367',
  ucdQtyMultiplicator: 30,
  cipLib: "VIT C ARW 500MG CROQ CPR BT 30",
  atcCode: "A11GA01"
}, {
  CIP7: '3421357',
  CIP13: '3400934213571',
  ucdLib: "LAROSCORBINE 1G INJ A.5ML",
  UCD7: '9049812',
  UCD13: '3400890498128',
  ucdQtyMultiplicator: 6,
  cipLib: "LAROSCORBINE 1G INJ A.5ML BT 6",
  atcCode: "A11GA01"
}, {
  CIP7: '3006345',
  CIP13: '3400930063453',
  ucdLib: "ARGINOTRI-B CPR",
  UCD7: '9006300',
  UCD13: '3400890063005',
  ucdQtyMultiplicator: 24,
  cipLib: "ARGINOTRI-B CPR BT 24",
  atcCode: "A11EX"
}, {
  CIP7: '3000903',
  CIP13: '3400930009031',
  ucdLib: "BEROCCA CPR PELL",
  UCD7: '9237287',
  UCD13: '3400892372877',
  ucdQtyMultiplicator: 60,
  cipLib: "BEROCCA CPR PELL BT 60",
  atcCode: "A11EX"
}, {
  CIP7: '3570904',
  CIP13: '3400935709042',
  ucdLib: "BEROCCA S/SUC CPR EFFV",
  UCD7: '9238298',
  UCD13: '3400892382982',
  ucdQtyMultiplicator: 30,
  cipLib: "BEROCCA S/SUC CPR EFFV BT 30",
  atcCode: "A11EX"
}, {
  CIP7: '3527794',
  CIP13: '3400935277947',
  ucdLib: "BEROCCA CPR PELL",
  UCD7: '9237287',
  UCD13: '3400892372877',
  ucdQtyMultiplicator: 30,
  cipLib: "BEROCCA CPR PELL BT 30",
  atcCode: "A11EX"
}, {
  CIP7: '2777000',
  CIP13: '3400927770005',
  ucdLib: "BEROCCA S/SUC CPR EFFV",
  UCD7: '9238298',
  UCD13: '3400892382982',
  ucdQtyMultiplicator: 60,
  cipLib: "BEROCCA S/SUC CPR EFFV BT 60",
  atcCode: "A11EX"
}, {
  CIP7: '2793594',
  CIP13: '3400927935947',
  ucdLib: "BEROCCA S/SUC CPR EFFV",
  UCD7: '9238298',
  UCD13: '3400892382982',
  ucdQtyMultiplicator: 60,
  cipLib: "BEROCCA S/SUC CPR EFFV BT 60",
  atcCode: "A11EX"
}, {
  CIP7: '3010275',
  CIP13: '3400930102756',
  ucdLib: "BECOZYME CPR",
  UCD7: '9009847',
  UCD13: '3400890098472',
  ucdQtyMultiplicator: 20,
  cipLib: "BECOZYME CPR BT 20",
  atcCode: "A11EA"
}, {
  CIP7: '3010269',
  CIP13: '3400930102695',
  ucdLib: "BECOZYME INJ AMP2ML",
  UCD7: '9009830',
  UCD13: '3400890098304',
  ucdQtyMultiplicator: 12,
  cipLib: "BECOZYME INJ AMP2ML BT 12",
  atcCode: "A11EA"
}, {
  CIP7: '5579387',
  CIP13: '3400955793878',
  ucdLib: "BECOZYME INJ AMP2ML",
  UCD7: '9009830',
  UCD13: '3400890098304',
  ucdQtyMultiplicator: 6,
  cipLib: "BECOZYME INJ AMP2ML BT 6",
  atcCode: "A11EA"
}, {
  CIP7: '3418869',
  CIP13: '3400934188695',
  ucdLib: "PRINCI-B CPR",
  UCD7: '9199500',
  UCD13: '3400891995008',
  ucdQtyMultiplicator: 30,
  cipLib: "PRINCI-B CPR BT 30",
  atcCode: "A11DB"
}, {
  CIP7: '3690985',
  CIP13: '3400936909854',
  ucdLib: "VIT B1-B6 BAYER CPR",
  UCD7: '9278659',
  UCD13: '3400892786599',
  ucdQtyMultiplicator: 20,
  cipLib: "VIT B1-B6 BAYER CPR BT 20",
  atcCode: "A11DB"
}, {
  CIP7: '3690991',
  CIP13: '3400936909915',
  ucdLib: "VIT B1-B6 BAYER CPR",
  UCD7: '9278659',
  UCD13: '3400892786599',
  ucdQtyMultiplicator: 40,
  cipLib: "VIT B1-B6 BAYER CPR BT 40",
  atcCode: "A11DB"
}, {
  CIP7: '2751667',
  CIP13: '3400927516672',
  ucdLib: "PRINCI-B CPR",
  UCD7: '9199500',
  UCD13: '3400891995008',
  ucdQtyMultiplicator: 30,
  cipLib: "PRINCI-B CPR BT 30",
  atcCode: "A11DB"
}, {
  CIP7: '4192114',
  CIP13: '3400941921148',
  ucdLib: "PRINCI-B CPR",
  UCD7: '9199500',
  UCD13: '3400891995008',
  ucdQtyMultiplicator: 50,
  cipLib: "PRINCI-B CPR BT 50",
  atcCode: "A11DB"
}, {
  CIP7: '5663952',
  CIP13: '3400956639526',
  ucdLib: "VIT B1-B6 BAYER CPR",
  UCD7: '9278659',
  UCD13: '3400892786599',
  ucdQtyMultiplicator: 100,
  cipLib: "VIT B1-B6 BAYER CPR BT 100",
  atcCode: "A11DB"
}, {
  CIP7: '3140888',
  CIP13: '3400931408888',
  ucdLib: "ARCALION 200MG CPR",
  UCD7: '9006091',
  UCD13: '3400890060912',
  ucdQtyMultiplicator: 30,
  cipLib: "ARCALION 200MG CPR BT 30",
  atcCode: "A11DA02"
}, {
  CIP7: '3140894',
  CIP13: '3400931408949',
  ucdLib: "ARCALION 200MG CPR",
  UCD7: '9006091',
  UCD13: '3400890060912',
  ucdQtyMultiplicator: 60,
  cipLib: "ARCALION 200MG CPR BT 60",
  atcCode: "A11DA02"
}, {
  CIP7: '3988561',
  CIP13: '3400939885612',
  ucdLib: "ARCALION 200MG CPR",
  UCD7: '9006091',
  UCD13: '3400890060912',
  ucdQtyMultiplicator: 30,
  cipLib: "ARCALION 200MG CPR BT 30",
  atcCode: "A11DA02"
}, {
  CIP7: '4900290',
  CIP13: '3400949002900',
  ucdLib: "ARCALION 200MG CPR AIP MWI ES",
  UCD7: '9334783',
  UCD13: '3400893347836',
  ucdQtyMultiplicator: 30,
  cipLib: "ARCALION 200MG CPR AIP MWI ES BT 30",
  atcCode: "A11DA02"
}, {
  CIP7: '5557575',
  CIP13: '3400955575757',
  ucdLib: "BENERVA 500MG IM AMP5ML",
  UCD7: '9010075',
  UCD13: '3400890100755',
  ucdQtyMultiplicator: 10,
  cipLib: "BENERVA 500MG IM AMP5ML BT 10",
  atcCode: "A11DA01"
}, {
  CIP7: '3010507',
  CIP13: '3400930105078',
  ucdLib: "BENERVA 250MG CPR",
  UCD7: '9010069',
  UCD13: '3400890100694',
  ucdQtyMultiplicator: 40,
  cipLib: "BENERVA 250MG CPR BT 40",
  atcCode: "A11DA01"
}, {
  CIP7: '3011116',
  CIP13: '3400930111161',
  ucdLib: "BEVITINE 100MG INJ AMP2ML",
  UCD7: '9010649',
  UCD13: '3400890106498',
  ucdQtyMultiplicator: 5,
  cipLib: "BEVITINE 100MG INJ AMP2ML BT 5",
  atcCode: "A11DA01"
}, {
  CIP7: '3011139',
  CIP13: '3400930111390',
  ucdLib: "BEVITINE 250MG CPR",
  UCD7: '9010655',
  UCD13: '3400890106559',
  ucdQtyMultiplicator: 20,
  cipLib: "BEVITINE 250MG CPR BT 20",
  atcCode: "A11DA01"
}, {
  CIP7: '3193867',
  CIP13: '3400931938675',
  ucdLib: "VIT B1 RICHARD 250MG CPR",
  UCD7: '9127854',
  UCD13: '3400891278545',
  ucdQtyMultiplicator: 100,
  cipLib: "VIT B1 RICHARD 250MG CPR BT 100",
  atcCode: "A11DA01"
}, {
  CIP7: '3178632',
  CIP13: '3400931786320',
  ucdLib: "DEDROGYL BUV GTT FL10ML",
  UCD7: '9024344',
  UCD13: '3400890243445',
  ucdQtyMultiplicator: 1,
  cipLib: "DEDROGYL BUV GTT FL10ML BT 1",
  atcCode: "A11CC06"
}, {
  CIP7: '3000454',
  CIP13: '3400930004548',
  ucdLib: "CHOLECALCIFEROL ARW BUV A.2ML",
  UCD7: '9420100',
  UCD13: '3400894201007',
  ucdQtyMultiplicator: 1,
  cipLib: "CHOLECALCIFEROL ARW BUV A.2ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3000456',
  CIP13: '3400930004562',
  ucdLib: "CHOLECALCIFEROL BGA BUV A.2ML",
  UCD7: '9407915',
  UCD13: '3400894079156',
  ucdQtyMultiplicator: 1,
  cipLib: "CHOLECALCIFEROL BGA BUV A.2ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3000457',
  CIP13: '3400930004579',
  ucdLib: "CHOLECALCIFEROL MYL BUV A.2ML",
  UCD7: '9410030',
  UCD13: '3400894100300',
  ucdQtyMultiplicator: 1,
  cipLib: "CHOLECALCIFEROL MYL BUV A.2ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3000455',
  CIP13: '3400930004555',
  ucdLib: "CHOLECALCIFEROL SDZ BUV A.2ML",
  UCD7: '9407720',
  UCD13: '3400894077206',
  ucdQtyMultiplicator: 1,
  cipLib: "CHOLECALCIFEROL SDZ BUV A.2ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3322218',
  CIP13: '3400933222185',
  ucdLib: "UVEDOSE 100000UI BUV AMP2ML",
  UCD7: '9140889',
  UCD13: '3400891408898',
  ucdQtyMultiplicator: 1,
  cipLib: "UVEDOSE 100000UI BUV AMP2ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3113213',
  CIP13: '3400931132134',
  ucdLib: "VIT D3 BON 200000U INJ A.1ML",
  UCD7: '9100648',
  UCD13: '3400891006483',
  ucdQtyMultiplicator: 1,
  cipLib: "VIT D3 BON 200000U INJ A.1ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3535836',
  CIP13: '3400935358363',
  ucdLib: "ZYMAD 10000UI/ML BUV GTT 10ML",
  UCD7: '9242839',
  UCD13: '3400892428390',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYMAD 10000UI/ML BUV GTT 10ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3535813',
  CIP13: '3400935358134',
  ucdLib: "ZYMAD 80000UI BUV AMP2ML",
  UCD7: '9243721',
  UCD13: '3400892437217',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYMAD 80000UI BUV AMP2ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3584964',
  CIP13: '3400935849649',
  ucdLib: "ZYMAD 200000UI BUV AMP2ML",
  UCD7: '9243715',
  UCD13: '3400892437156',
  ucdQtyMultiplicator: 1,
  cipLib: "ZYMAD 200000UI BUV AMP2ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3442307',
  CIP13: '3400934423079',
  ucdLib: "ADRIGYL 10000UI/ML GTT FL10ML",
  UCD7: '9360119',
  UCD13: '3400893601198',
  ucdQtyMultiplicator: 1,
  cipLib: "ADRIGYL 10000UI/ML GTT FL10ML BT 1",
  atcCode: "A11CC05"
}, {
  CIP7: '3264432',
  CIP13: '3400932644322',
  ucdLib: "ROCALTROL 0,25MCG CAPS MOL",
  UCD7: '9103635',
  UCD13: '3400891036350',
  ucdQtyMultiplicator: 30,
  cipLib: "ROCALTROL 0,25MCG CAPS MOL BT 30",
  atcCode: "A11CC04"
}, {
  CIP7: '3260842',
  CIP13: '3400932608423',
  ucdLib: "UN-ALFA 0,10MCG BUV FL10ML",
  UCD7: '9096438',
  UCD13: '3400890964388',
  ucdQtyMultiplicator: 1,
  cipLib: "UN-ALFA 0,10MCG BUV FL10ML BT 1",
  atcCode: "A11CC03"
}, {
  CIP7: '3336663',
  CIP13: '3400933366636',
  ucdLib: "ALFACALCIDOL TVC 0,25Y CAPS",
  UCD7: '9199977',
  UCD13: '3400891999778',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFACALCIDOL TVC 0,25Y CAPS BT 30",
  atcCode: "A11CC03"
}, {
  CIP7: '3336686',
  CIP13: '3400933366865',
  ucdLib: "ALFACALCIDOL TVC 1MCG CAPS",
  UCD7: '9199983',
  UCD13: '3400891999839',
  ucdQtyMultiplicator: 30,
  cipLib: "ALFACALCIDOL TVC 1MCG CAPS BT 30",
  atcCode: "A11CC03"
}, {
  CIP7: '5572994',
  CIP13: '3400955729945',
  ucdLib: "UN-ALFA 1MCG IV AMP0,5ML",
  UCD7: '9149821',
  UCD13: '3400891498219',
  ucdQtyMultiplicator: 10,
  cipLib: "UN-ALFA 1MCG IV AMP0,5ML BT 10",
  atcCode: "A11CC03"
}, {
  CIP7: '5572988',
  CIP13: '3400955729884',
  ucdLib: "UN-ALFA 2MCG IV AMP1ML",
  UCD7: '9149838',
  UCD13: '3400891498387',
  ucdQtyMultiplicator: 10,
  cipLib: "UN-ALFA 2MCG IV AMP1ML BT 10",
  atcCode: "A11CC03"
}, {
  CIP7: '3484145',
  CIP13: '3400934841453',
  ucdLib: "UN-ALFA 0,25MCG CAPS",
  UCD7: '9096415',
  UCD13: '3400890964159',
  ucdQtyMultiplicator: 30,
  cipLib: "UN-ALFA 0,25MCG CAPS BT 30",
  atcCode: "A11CC03"
}, {
  CIP7: '3484151',
  CIP13: '3400934841514',
  ucdLib: "UN-ALFA 1MCG CAPS",
  UCD7: '9096421',
  UCD13: '3400890964210',
  ucdQtyMultiplicator: 30,
  cipLib: "UN-ALFA 1MCG CAPS BT 30",
  atcCode: "A11CC03"
}, {
  CIP7: '3476163',
  CIP13: '3400934761638',
  ucdLib: "UN-ALFA 0,5MCG CAPS",
  UCD7: '9229112',
  UCD13: '3400892291123',
  ucdQtyMultiplicator: 30,
  cipLib: "UN-ALFA 0,5MCG CAPS BT 30",
  atcCode: "A11CC03"
}, {
  CIP7: '3099832',
  CIP13: '3400930998328',
  ucdLib: "STEROGYL 15 A BUV AMP1,5ML",
  UCD7: '9087847',
  UCD13: '3400890878470',
  ucdQtyMultiplicator: 1,
  cipLib: "STEROGYL 15 A BUV AMP1,5ML BT 1",
  atcCode: "A11CC01"
}, {
  CIP7: '3099855',
  CIP13: '3400930998557',
  ucdLib: "STEROGYL 15 H INJ AMP1,5ML",
  UCD7: '9087853',
  UCD13: '3400890878531',
  ucdQtyMultiplicator: 1,
  cipLib: "STEROGYL 15 H INJ AMP1,5ML BT 1",
  atcCode: "A11CC01"
}, {
  CIP7: '3099826',
  CIP13: '3400930998267',
  ucdLib: "STEROGYL BUV GTT FL20ML",
  UCD7: '9087830',
  UCD13: '3400890878302',
  ucdQtyMultiplicator: 1,
  cipLib: "STEROGYL BUV GTT FL20ML BT 1",
  atcCode: "A11CC01"
}, {
  CIP7: '2791572',
  CIP13: '3400927915727',
  ucdLib: "UVESTEROL D 5000UI/ML BUV 10ML",
  UCD7: '9404897',
  UCD13: '3400894048978',
  ucdQtyMultiplicator: 1,
  cipLib: "UVESTEROL D 5000UI/ML BUV 10ML BT 1",
  atcCode: "A11CC01"
}, {
  CIP7: '3000064',
  CIP13: '3400930000649',
  ucdLib: "A 313 50000UI CAPS",
  UCD7: '9000059',
  UCD13: '3400890000598',
  ucdQtyMultiplicator: 30,
  cipLib: "A 313 50000UI CAPS BT 30",
  atcCode: "A11CA01"
}, {
  CIP7: '3565317',
  CIP13: '3400935653178',
  ucdLib: "VIT A NPA 100000UI/2ML INJ A.",
  UCD7: '9232261',
  UCD13: '3400892322612',
  ucdQtyMultiplicator: 6,
  cipLib: "VIT A NPA 100000UI/2ML INJ A. BT 6",
  atcCode: "A11CA01"
}, {
  CIP7: '3771488',
  CIP13: '3400937714884',
  ucdLib: "HYDROSOL VIT PDV BUV GTT 20ML",
  UCD7: '9295623',
  UCD13: '3400892956237',
  ucdQtyMultiplicator: 1,
  cipLib: "HYDROSOL VIT PDV BUV GTT 20ML BT 1",
  atcCode: "A11BA"
}, {
  CIP7: '3571855',
  CIP13: '3400935718556',
  ucdLib: "ELEVIT VIT B9 CPR",
  UCD7: '9170347',
  UCD13: '3400891703474',
  ucdQtyMultiplicator: 30,
  cipLib: "ELEVIT VIT B9 CPR BT 30",
  atcCode: "A11AA04"
}, {
  CIP7: '3571861',
  CIP13: '3400935718617',
  ucdLib: "ELEVIT VIT B9 CPR",
  UCD7: '9170347',
  UCD13: '3400891703474',
  ucdQtyMultiplicator: 100,
  cipLib: "ELEVIT VIT B9 CPR BT 100",
  atcCode: "A11AA04"
}, {
  CIP7: '3003694',
  CIP13: '3400930036945',
  ucdLib: "REPAGLINIDE ARL 0,5MG CPR",
  UCD7: '9412394',
  UCD13: '3400894123941',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ARL 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3003695',
  CIP13: '3400930036952',
  ucdLib: "REPAGLINIDE ARL 1MG CPR",
  UCD7: '9412402',
  UCD13: '3400894124023',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ARL 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3003696',
  CIP13: '3400930036969',
  ucdLib: "REPAGLINIDE ARL 2MG CPR",
  UCD7: '9412419',
  UCD13: '3400894124191',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ARL 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3005036',
  CIP13: '3400930050361',
  ucdLib: "REPAGLINIDE BGA 0,5MG C+FSE",
  UCD7: '9419918',
  UCD13: '3400894199182',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE BGA 0,5MG C+FSE BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3005048',
  CIP13: '3400930050484',
  ucdLib: "REPAGLINIDE BGA 1MG CPR+FSE",
  UCD7: '9419924',
  UCD13: '3400894199243',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE BGA 1MG CPR+FSE BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3005049',
  CIP13: '3400930050491',
  ucdLib: "REPAGLINIDE BGA 2MG CPR+FSE",
  UCD7: '9419930',
  UCD13: '3400894199304',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE BGA 2MG CPR+FSE BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4987144',
  CIP13: '3400949871445',
  ucdLib: "REPAGLINIDE CRT 0,5MG CPR",
  UCD7: '9370537',
  UCD13: '3400893705377',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE CRT 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4987440',
  CIP13: '3400949874408',
  ucdLib: "REPAGLINIDE CRT 1MG CPR",
  UCD7: '9370543',
  UCD13: '3400893705438',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE CRT 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4987598',
  CIP13: '3400949875986',
  ucdLib: "REPAGLINIDE CRT 2MG CPR",
  UCD7: '9370566',
  UCD13: '3400893705667',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE CRT 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4987256',
  CIP13: '3400949872565',
  ucdLib: "REPAGLINIDE RBX 0,5MG CPR",
  UCD7: '9369764',
  UCD13: '3400893697641',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE RBX 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4987351',
  CIP13: '3400949873517',
  ucdLib: "REPAGLINIDE RBX 1MG CPR",
  UCD7: '9369770',
  UCD13: '3400893697702',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE RBX 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4987687',
  CIP13: '3400949876877',
  ucdLib: "REPAGLINIDE RBX 2MG CPR",
  UCD7: '9369787',
  UCD13: '3400893697870',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE RBX 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3484027',
  CIP13: '3400934840272',
  ucdLib: "NOVONORM 0,5MG CPR",
  UCD7: '9217959',
  UCD13: '3400892179599',
  ucdQtyMultiplicator: 90,
  cipLib: "NOVONORM 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3484033',
  CIP13: '3400934840333',
  ucdLib: "NOVONORM 1MG CPR",
  UCD7: '9217965',
  UCD13: '3400892179650',
  ucdQtyMultiplicator: 90,
  cipLib: "NOVONORM 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3484056',
  CIP13: '3400934840562',
  ucdLib: "NOVONORM 2MG CPR",
  UCD7: '9217971',
  UCD13: '3400892179711',
  ucdQtyMultiplicator: 90,
  cipLib: "NOVONORM 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3462824',
  CIP13: '3400934628245',
  ucdLib: "REPAGLINIDE TVC 0,5MG CPR",
  UCD7: '9351385',
  UCD13: '3400893513859',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE TVC 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3462847',
  CIP13: '3400934628474',
  ucdLib: "REPAGLINIDE TVC 0,5MG CPR",
  UCD7: '9351385',
  UCD13: '3400893513859',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE TVC 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3462853',
  CIP13: '3400934628535',
  ucdLib: "REPAGLINIDE TVC 1MG CPR",
  UCD7: '9351391',
  UCD13: '3400893513910',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE TVC 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3463143',
  CIP13: '3400934631436',
  ucdLib: "REPAGLINIDE TVC 1MG CPR",
  UCD7: '9351391',
  UCD13: '3400893513910',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE TVC 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3463166',
  CIP13: '3400934631665',
  ucdLib: "REPAGLINIDE TVC 2MG CPR",
  UCD7: '9351416',
  UCD13: '3400893514160',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE TVC 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3463172',
  CIP13: '3400934631726',
  ucdLib: "REPAGLINIDE TVC 2MG CPR",
  UCD7: '9351416',
  UCD13: '3400893514160',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE TVC 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4950750',
  CIP13: '3400949507504',
  ucdLib: "NOVONORM 0,5MG CPR ADP MWI",
  UCD7: '9390468',
  UCD13: '3400893904688',
  ucdQtyMultiplicator: 90,
  cipLib: "NOVONORM 0,5MG CPR ADP MWI BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4950767',
  CIP13: '3400949507672',
  ucdLib: "NOVONORM 1MG CPR ADP MWI",
  UCD7: '9390474',
  UCD13: '3400893904749',
  ucdQtyMultiplicator: 90,
  cipLib: "NOVONORM 1MG CPR ADP MWI BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3716644',
  CIP13: '3400937166447',
  ucdLib: "NOVONORM 0,5MG CPR",
  UCD7: '9217959',
  UCD13: '3400892179599',
  ucdQtyMultiplicator: 270,
  cipLib: "NOVONORM 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3716650',
  CIP13: '3400937166508',
  ucdLib: "NOVONORM 1MG CPR",
  UCD7: '9217965',
  UCD13: '3400892179650',
  ucdQtyMultiplicator: 270,
  cipLib: "NOVONORM 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3716667',
  CIP13: '3400937166676',
  ucdLib: "NOVONORM 2MG CPR",
  UCD7: '9217971',
  UCD13: '3400892179711',
  ucdQtyMultiplicator: 270,
  cipLib: "NOVONORM 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '2693326',
  CIP13: '3400926933265',
  ucdLib: "REPAGLINIDE ARL 0,5MG CPR",
  UCD7: '9412394',
  UCD13: '3400894123941',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ARL 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2693390',
  CIP13: '3400926933906',
  ucdLib: "REPAGLINIDE ARL 1MG CPR",
  UCD7: '9412402',
  UCD13: '3400894124023',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ARL 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2693444',
  CIP13: '3400926934446',
  ucdLib: "REPAGLINIDE ARL 2MG CPR",
  UCD7: '9412419',
  UCD13: '3400894124191',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ARL 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4995497',
  CIP13: '3400949954971',
  ucdLib: "REPAGLINIDE BGA 0,5MG CPR",
  UCD7: '9366122',
  UCD13: '3400893661222',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE BGA 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4995511',
  CIP13: '3400949955114',
  ucdLib: "REPAGLINIDE BGA 0,5MG CPR",
  UCD7: '9366122',
  UCD13: '3400893661222',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE BGA 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4995439',
  CIP13: '3400949954391',
  ucdLib: "REPAGLINIDE BGA 1MG CPR",
  UCD7: '9366139',
  UCD13: '3400893661390',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE BGA 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4995451',
  CIP13: '3400949954513',
  ucdLib: "REPAGLINIDE BGA 1MG CPR",
  UCD7: '9366139',
  UCD13: '3400893661390',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE BGA 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4995362',
  CIP13: '3400949953622',
  ucdLib: "REPAGLINIDE BGA 2MG CPR",
  UCD7: '9366145',
  UCD13: '3400893661451',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE BGA 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4995385',
  CIP13: '3400949953851',
  ucdLib: "REPAGLINIDE BGA 2MG CPR",
  UCD7: '9366145',
  UCD13: '3400893661451',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE BGA 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3983799',
  CIP13: '3400939837994',
  ucdLib: "REPAGLINIDE EG 0,5MG CPR",
  UCD7: '9352350',
  UCD13: '3400893523506',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE EG 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3983859',
  CIP13: '3400939838595',
  ucdLib: "REPAGLINIDE EG 1MG CPR",
  UCD7: '9352367',
  UCD13: '3400893523674',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE EG 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3983902',
  CIP13: '3400939839028',
  ucdLib: "REPAGLINIDE EG 2MG CPR",
  UCD7: '9352373',
  UCD13: '3400893523735',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE EG 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2664402',
  CIP13: '3400926644024',
  ucdLib: "REPAGLINIDE KRK 0,5MG CPR",
  UCD7: '9388922',
  UCD13: '3400893889220',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE KRK 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2664419',
  CIP13: '3400926644192',
  ucdLib: "REPAGLINIDE KRK 0,5MG CPR",
  UCD7: '9388922',
  UCD13: '3400893889220',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE KRK 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '2664425',
  CIP13: '3400926644253',
  ucdLib: "REPAGLINIDE KRK 1MG CPR",
  UCD7: '9388939',
  UCD13: '3400893889398',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE KRK 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2664431',
  CIP13: '3400926644314',
  ucdLib: "REPAGLINIDE KRK 1MG CPR",
  UCD7: '9388939',
  UCD13: '3400893889398',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE KRK 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '2664448',
  CIP13: '3400926644482',
  ucdLib: "REPAGLINIDE KRK 2MG CPR",
  UCD7: '9388945',
  UCD13: '3400893889459',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE KRK 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2664454',
  CIP13: '3400926644543',
  ucdLib: "REPAGLINIDE KRK 2MG CPR",
  UCD7: '9388945',
  UCD13: '3400893889459',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE KRK 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4995557',
  CIP13: '3400949955572',
  ucdLib: "REPAGLINIDE ZYD 0,5MG CPR",
  UCD7: '9366151',
  UCD13: '3400893661512',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ZYD 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4995586',
  CIP13: '3400949955862',
  ucdLib: "REPAGLINIDE ZYD 0,5MG CPR",
  UCD7: '9366151',
  UCD13: '3400893661512',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ZYD 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4995623',
  CIP13: '3400949956234',
  ucdLib: "REPAGLINIDE ZYD 1MG CPR",
  UCD7: '9366168',
  UCD13: '3400893661680',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ZYD 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4995652',
  CIP13: '3400949956524',
  ucdLib: "REPAGLINIDE ZYD 1MG CPR",
  UCD7: '9366168',
  UCD13: '3400893661680',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ZYD 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4995698',
  CIP13: '3400949956982',
  ucdLib: "REPAGLINIDE ZYD 2MG CPR",
  UCD7: '9366174',
  UCD13: '3400893661741',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ZYD 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2222733',
  CIP13: '3400922227337',
  ucdLib: "REPAGLINIDE ACC 0,5MG CPR",
  UCD7: '9382368',
  UCD13: '3400893823682',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ACC 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2222762',
  CIP13: '3400922227627',
  ucdLib: "REPAGLINIDE ACC 0,5MG CPR",
  UCD7: '9382368',
  UCD13: '3400893823682',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ACC 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '2222791',
  CIP13: '3400922227917',
  ucdLib: "REPAGLINIDE ACC 1MG CPR",
  UCD7: '9382374',
  UCD13: '3400893823743',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ACC 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2222822',
  CIP13: '3400922228228',
  ucdLib: "REPAGLINIDE ACC 1MG CPR",
  UCD7: '9382374',
  UCD13: '3400893823743',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ACC 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '2222851',
  CIP13: '3400922228518',
  ucdLib: "REPAGLINIDE ACC 2MG CPR",
  UCD7: '9382380',
  UCD13: '3400893823804',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ACC 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '2222874',
  CIP13: '3400922228747',
  ucdLib: "REPAGLINIDE ACC 2MG CPR",
  UCD7: '9382380',
  UCD13: '3400893823804',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ACC 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3997548',
  CIP13: '3400939975481',
  ucdLib: "REPAGLINIDE MYP 0,5MG CPR",
  UCD7: '9351178',
  UCD13: '3400893511787',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE MYP 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3997560',
  CIP13: '3400939975603',
  ucdLib: "REPAGLINIDE MYP 0,5MG CPR",
  UCD7: '9351178',
  UCD13: '3400893511787',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE MYP 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3997672',
  CIP13: '3400939976723',
  ucdLib: "REPAGLINIDE MYP 1MG CPR",
  UCD7: '9351184',
  UCD13: '3400893511848',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE MYP 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3997695',
  CIP13: '3400939976952',
  ucdLib: "REPAGLINIDE MYP 1MG CPR",
  UCD7: '9351184',
  UCD13: '3400893511848',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE MYP 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3997790',
  CIP13: '3400939977904',
  ucdLib: "REPAGLINIDE MYP 2MG CPR",
  UCD7: '9351190',
  UCD13: '3400893511909',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE MYP 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3997815',
  CIP13: '3400939978154',
  ucdLib: "REPAGLINIDE MYP 2MG CPR",
  UCD7: '9351190',
  UCD13: '3400893511909',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE MYP 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3996371',
  CIP13: '3400939963716',
  ucdLib: "REPAGLINIDE RTP 0,5MG CPR",
  UCD7: '9349106',
  UCD13: '3400893491065',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE RTP 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3996402',
  CIP13: '3400939964027',
  ucdLib: "REPAGLINIDE RTP 0,5MG CPR",
  UCD7: '9349106',
  UCD13: '3400893491065',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE RTP 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3996537',
  CIP13: '3400939965376',
  ucdLib: "REPAGLINIDE RTP 1MG CPR",
  UCD7: '9349112',
  UCD13: '3400893491126',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE RTP 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3996572',
  CIP13: '3400939965727',
  ucdLib: "REPAGLINIDE RTP 1MG CPR",
  UCD7: '9349112',
  UCD13: '3400893491126',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE RTP 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3996709',
  CIP13: '3400939967097',
  ucdLib: "REPAGLINIDE RTP 2MG CPR",
  UCD7: '9349129',
  UCD13: '3400893491294',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE RTP 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3996738',
  CIP13: '3400939967387',
  ucdLib: "REPAGLINIDE RTP 2MG CPR",
  UCD7: '9349129',
  UCD13: '3400893491294',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE RTP 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4927840',
  CIP13: '3400949278404',
  ucdLib: "REPAGLINIDE SDZ 0,5MG CPR",
  UCD7: '9358996',
  UCD13: '3400893589960',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE SDZ 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4927917',
  CIP13: '3400949279173',
  ucdLib: "REPAGLINIDE SDZ 0,5MG CPR",
  UCD7: '9358996',
  UCD13: '3400893589960',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE SDZ 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4927952',
  CIP13: '3400949279524',
  ucdLib: "REPAGLINIDE SDZ 1MG CPR",
  UCD7: '9359004',
  UCD13: '3400893590041',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE SDZ 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4928012',
  CIP13: '3400949280124',
  ucdLib: "REPAGLINIDE SDZ 1MG CPR",
  UCD7: '9359004',
  UCD13: '3400893590041',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE SDZ 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '4928041',
  CIP13: '3400949280414',
  ucdLib: "REPAGLINIDE SDZ 2MG CPR",
  UCD7: '9359010',
  UCD13: '3400893590102',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE SDZ 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '4928101',
  CIP13: '3400949281015',
  ucdLib: "REPAGLINIDE SDZ 2MG CPR",
  UCD7: '9359010',
  UCD13: '3400893590102',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE SDZ 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3996856',
  CIP13: '3400939968568',
  ucdLib: "REPAGLINIDE ZEN 0,5MG CPR",
  UCD7: '9351215',
  UCD13: '3400893512159',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ZEN 0,5MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3996879',
  CIP13: '3400939968797',
  ucdLib: "REPAGLINIDE ZEN 0,5MG CPR",
  UCD7: '9351215',
  UCD13: '3400893512159',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ZEN 0,5MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3996974',
  CIP13: '3400939969749',
  ucdLib: "REPAGLINIDE ZEN 1MG CPR",
  UCD7: '9351221',
  UCD13: '3400893512210',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ZEN 1MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3996997',
  CIP13: '3400939969978',
  ucdLib: "REPAGLINIDE ZEN 1MG CPR",
  UCD7: '9351221',
  UCD13: '3400893512210',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ZEN 1MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3997092',
  CIP13: '3400939970929',
  ucdLib: "REPAGLINIDE ZEN 2MG CPR",
  UCD7: '9351238',
  UCD13: '3400893512388',
  ucdQtyMultiplicator: 90,
  cipLib: "REPAGLINIDE ZEN 2MG CPR BT 90",
  atcCode: "A10BX02"
}, {
  CIP7: '3997117',
  CIP13: '3400939971179',
  ucdLib: "REPAGLINIDE ZEN 2MG CPR",
  UCD7: '9351238',
  UCD13: '3400893512388',
  ucdQtyMultiplicator: 270,
  cipLib: "REPAGLINIDE ZEN 2MG CPR BT 270",
  atcCode: "A10BX02"
}, {
  CIP7: '3000373',
  CIP13: '3400930003732',
  ucdLib: "TRULICITY 0,75MG INJ STY0,5ML",
  UCD7: '9412098',
  UCD13: '3400894120988',
  ucdQtyMultiplicator: 4,
  cipLib: "TRULICITY 0,75MG INJ STY0,5ML BT 4",
  atcCode: "A10BJ05"
}, {
  CIP7: '3000376',
  CIP13: '3400930003763',
  ucdLib: "TRULICITY 1,5MG INJ STY0,5ML",
  UCD7: '9412106',
  UCD13: '3400894121060',
  ucdQtyMultiplicator: 4,
  cipLib: "TRULICITY 1,5MG INJ STY0,5ML BT 4",
  atcCode: "A10BJ05"
}, {
  CIP7: '3963236',
  CIP13: '3400939632360',
  ucdLib: "VICTOZA 6MG/ML INJ STYLO3ML",
  UCD7: '9345290',
  UCD13: '3400893452905',
  ucdQtyMultiplicator: 2,
  cipLib: "VICTOZA 6MG/ML INJ STYLO3ML BT 2",
  atcCode: "A10BJ02"
}, {
  CIP7: '3780949',
  CIP13: '3400937809498',
  ucdLib: "BYETTA 10MCG INJ STYLO2,4ML",
  UCD7: '9300666',
  UCD13: '3400893006665',
  ucdQtyMultiplicator: 1,
  cipLib: "BYETTA 10MCG INJ STYLO2,4ML BT 1",
  atcCode: "A10BJ01"
}, {
  CIP7: '3780926',
  CIP13: '3400937809269',
  ucdLib: "BYETTA 5MCG INJ STYLO1,2ML",
  UCD7: '9300672',
  UCD13: '3400893006726',
  ucdQtyMultiplicator: 1,
  cipLib: "BYETTA 5MCG INJ STYLO1,2ML BT 1",
  atcCode: "A10BJ01"
}, {
  CIP7: '2801201',
  CIP13: '3400928012012',
  ucdLib: "BYDUREON 2MG LP INJ STYLO",
  UCD7: '9408671',
  UCD13: '3400894086710',
  ucdQtyMultiplicator: 4,
  cipLib: "BYDUREON 2MG LP INJ STYLO BT 4",
  atcCode: "A10BJ01"
}, {
  CIP7: '3973588',
  CIP13: '3400939735887',
  ucdLib: "ONGLYZA 5MG CPR",
  UCD7: '9348259',
  UCD13: '3400893482599',
  ucdQtyMultiplicator: 30,
  cipLib: "ONGLYZA 5MG CPR BT 30",
  atcCode: "A10BH03"
}, {
  CIP7: '5759563',
  CIP13: '3400957595630',
  ucdLib: "ONGLYZA 5MG CPR",
  UCD7: '9348259',
  UCD13: '3400893482599',
  ucdQtyMultiplicator: 90,
  cipLib: "ONGLYZA 5MG CPR BT 90",
  atcCode: "A10BH03"
}, {
  CIP7: '3832215',
  CIP13: '3400938322156',
  ucdLib: "GALVUS 50MG CPR",
  UCD7: '9329262',
  UCD13: '3400893292624',
  ucdQtyMultiplicator: 60,
  cipLib: "GALVUS 50MG CPR BT 60",
  atcCode: "A10BH02"
}, {
  CIP7: '3819516',
  CIP13: '3400938195163',
  ucdLib: "GALVUS 50MG CPR",
  UCD7: '9329262',
  UCD13: '3400893292624',
  ucdQtyMultiplicator: 30,
  cipLib: "GALVUS 50MG CPR BT 30",
  atcCode: "A10BH02"
}, {
  CIP7: '5714655',
  CIP13: '3400957146559',
  ucdLib: "GALVUS 50MG CPR",
  UCD7: '9329262',
  UCD13: '3400893292624',
  ucdQtyMultiplicator: 90,
  cipLib: "GALVUS 50MG CPR BT 90",
  atcCode: "A10BH02"
}, {
  CIP7: '3792504',
  CIP13: '3400937925044',
  ucdLib: "JANUVIA 100MG CPR",
  UCD7: '9304032',
  UCD13: '3400893040324',
  ucdQtyMultiplicator: 28,
  cipLib: "JANUVIA 100MG CPR BT 28",
  atcCode: "A10BH01"
}, {
  CIP7: '3792496',
  CIP13: '3400937924962',
  ucdLib: "JANUVIA 50MG CPR BT28",
  UCD7: '9393478',
  UCD13: '3400893934784',
  ucdQtyMultiplicator: 28,
  cipLib: "JANUVIA 50MG CPR BT28 BT 28",
  atcCode: "A10BH01"
}, {
  CIP7: '3793308',
  CIP13: '3400937933087',
  ucdLib: "XELEVIA 100MG CPR",
  UCD7: '9307579',
  UCD13: '3400893075791',
  ucdQtyMultiplicator: 28,
  cipLib: "XELEVIA 100MG CPR BT 28",
  atcCode: "A10BH01"
}, {
  CIP7: '3793283',
  CIP13: '3400937932837',
  ucdLib: "XELEVIA 50MG CPR",
  UCD7: '9393662',
  UCD13: '3400893936627',
  ucdQtyMultiplicator: 28,
  cipLib: "XELEVIA 50MG CPR BT 28",
  atcCode: "A10BH01"
}, {
  CIP7: '5707454',
  CIP13: '3400957074548',
  ucdLib: "JANUVIA 100MG CPR",
  UCD7: '9304032',
  UCD13: '3400893040324',
  ucdQtyMultiplicator: 50,
  cipLib: "JANUVIA 100MG CPR BT 50",
  atcCode: "A10BH01"
}, {
  CIP7: '5707106',
  CIP13: '3400957071066',
  ucdLib: "JANUVIA 50MG CPR BT28",
  UCD7: '9393478',
  UCD13: '3400893934784',
  ucdQtyMultiplicator: 50,
  cipLib: "JANUVIA 50MG CPR BT28 BT 50",
  atcCode: "A10BH01"
}, {
  CIP7: '3458685',
  CIP13: '3400934586859',
  ucdLib: "DIASTABOL 100MG CPR",
  UCD7: '9204483',
  UCD13: '3400892044835',
  ucdQtyMultiplicator: 90,
  cipLib: "DIASTABOL 100MG CPR BT 90",
  atcCode: "A10BF02"
}, {
  CIP7: '3487534',
  CIP13: '3400934875342',
  ucdLib: "DIASTABOL 100MG CPR",
  UCD7: '9204483',
  UCD13: '3400892044835',
  ucdQtyMultiplicator: 90,
  cipLib: "DIASTABOL 100MG CPR BT 90",
  atcCode: "A10BF02"
}, {
  CIP7: '3487600',
  CIP13: '3400934876004',
  ucdLib: "DIASTABOL 50MG CPR",
  UCD7: '9204508',
  UCD13: '3400892045085',
  ucdQtyMultiplicator: 90,
  cipLib: "DIASTABOL 50MG CPR BT 90",
  atcCode: "A10BF02"
}, {
  CIP7: '3058193',
  CIP13: '3400930581933',
  ucdLib: "ACARBOSE ZEN 100MG CPR",
  UCD7: '9350977',
  UCD13: '3400893509777',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE ZEN 100MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '3058371',
  CIP13: '3400930583715',
  ucdLib: "ACARBOSE ZEN 50MG CPR",
  UCD7: '9350983',
  UCD13: '3400893509838',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE ZEN 50MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2761192',
  CIP13: '3400927611926',
  ucdLib: "ACARBOSE MYL 100MG CPR",
  UCD7: '9397789',
  UCD13: '3400893977897',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE MYL 100MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2761157',
  CIP13: '3400927611575',
  ucdLib: "ACARBOSE MYL 50MG CPR",
  UCD7: '9397795',
  UCD13: '3400893977958',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE MYL 50MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '3375315',
  CIP13: '3400933753153',
  ucdLib: "GLUCOR 100MG CPR",
  UCD7: '9168273',
  UCD13: '3400891682731',
  ucdQtyMultiplicator: 90,
  cipLib: "GLUCOR 100MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '3375290',
  CIP13: '3400933752903',
  ucdLib: "GLUCOR 50MG CPR",
  UCD7: '9168296',
  UCD13: '3400891682960',
  ucdQtyMultiplicator: 90,
  cipLib: "GLUCOR 50MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '3720634',
  CIP13: '3400937206341',
  ucdLib: "GLUCOR 50MG CPR",
  UCD7: '9168296',
  UCD13: '3400891682960',
  ucdQtyMultiplicator: 270,
  cipLib: "GLUCOR 50MG CPR BT 270",
  atcCode: "A10BF01"
}, {
  CIP7: '3719602',
  CIP13: '3400937196024',
  ucdLib: "GLUCOR 100MG CPR",
  UCD7: '9168273',
  UCD13: '3400891682731',
  ucdQtyMultiplicator: 270,
  cipLib: "GLUCOR 100MG CPR BT 270",
  atcCode: "A10BF01"
}, {
  CIP7: '3987254',
  CIP13: '3400939872544',
  ucdLib: "ACARBOSE BGA 100MG CPR",
  UCD7: '9350575',
  UCD13: '3400893505755',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE BGA 100MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '3987225',
  CIP13: '3400939872254',
  ucdLib: "ACARBOSE BGA 50MG CPR",
  UCD7: '9350581',
  UCD13: '3400893505816',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE BGA 50MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2697146',
  CIP13: '3400926971465',
  ucdLib: "ACARBOSE EG 100MG CPR",
  UCD7: '9393018',
  UCD13: '3400893930182',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE EG 100MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2697117',
  CIP13: '3400926971175',
  ucdLib: "ACARBOSE EG 50MG CPR",
  UCD7: '9393024',
  UCD13: '3400893930243',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE EG 50MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2698306',
  CIP13: '3400926983062',
  ucdLib: "ACARBOSE SDZ 100MG CPR",
  UCD7: '9408576',
  UCD13: '3400894085768',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE SDZ 100MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2698275',
  CIP13: '3400926982751',
  ucdLib: "ACARBOSE SDZ 50MG CPR",
  UCD7: '9408582',
  UCD13: '3400894085829',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE SDZ 50MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2223388',
  CIP13: '3400922233888',
  ucdLib: "ACARBOSE ARL 100MG CPR",
  UCD7: '9388069',
  UCD13: '3400893880692',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE ARL 100MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2223218',
  CIP13: '3400922232188',
  ucdLib: "ACARBOSE ARL 50MG CPR",
  UCD7: '9388075',
  UCD13: '3400893880753',
  ucdQtyMultiplicator: 90,
  cipLib: "ACARBOSE ARL 50MG CPR BT 90",
  atcCode: "A10BF01"
}, {
  CIP7: '2200789',
  CIP13: '3400922007892',
  ucdLib: "KOMBOGLYZE 2,5MG/1000MG CP",
  UCD7: '9385711',
  UCD13: '3400893857113',
  ucdQtyMultiplicator: 60,
  cipLib: "KOMBOGLYZE 2,5MG/1000MG CP BT 60",
  atcCode: "A10BD10"
}, {
  CIP7: '2200795',
  CIP13: '3400922007953',
  ucdLib: "KOMBOGLYZE 2,5MG/1000MG CP",
  UCD7: '9385711',
  UCD13: '3400893857113',
  ucdQtyMultiplicator: 60,
  cipLib: "KOMBOGLYZE 2,5MG/1000MG CP BT 60",
  atcCode: "A10BD10"
}, {
  CIP7: '2734901',
  CIP13: '3400927349010',
  ucdLib: "EUCREAS 50MG/1000MG CPR",
  UCD7: '9337876',
  UCD13: '3400893378762',
  ucdQtyMultiplicator: 60,
  cipLib: "EUCREAS 50MG/1000MG CPR BT 60",
  atcCode: "A10BD08"
}, {
  CIP7: '5848491',
  CIP13: '3400958484919',
  ucdLib: "EUCREAS 50MG/1000MG CPR",
  UCD7: '9337876',
  UCD13: '3400893378762',
  ucdQtyMultiplicator: 180,
  cipLib: "EUCREAS 50MG/1000MG CPR BT 180",
  atcCode: "A10BD08"
}, {
  CIP7: '3867811',
  CIP13: '3400938678116',
  ucdLib: "JANUMET 50MG/1000MG CPR",
  UCD7: '9319743',
  UCD13: '3400893197431',
  ucdQtyMultiplicator: 56,
  cipLib: "JANUMET 50MG/1000MG CPR BT 56",
  atcCode: "A10BD07"
}, {
  CIP7: '3867797',
  CIP13: '3400938677973',
  ucdLib: "VELMETIA 50MG/1000MG CPR",
  UCD7: '9338918',
  UCD13: '3400893389188',
  ucdQtyMultiplicator: 56,
  cipLib: "VELMETIA 50MG/1000MG CPR BT 56",
  atcCode: "A10BD07"
}, {
  CIP7: '5731211',
  CIP13: '3400957312114',
  ucdLib: "JANUMET 50MG/1000MG CPR",
  UCD7: '9319743',
  UCD13: '3400893197431',
  ucdQtyMultiplicator: 50,
  cipLib: "JANUMET 50MG/1000MG CPR BT 50",
  atcCode: "A10BD07"
}, {
  CIP7: '3580162',
  CIP13: '3400935801623',
  ucdLib: "GLUCOVANCE 500MG/2,5MG CPR",
  UCD7: '9267354',
  UCD13: '3400892673547',
  ucdQtyMultiplicator: 30,
  cipLib: "GLUCOVANCE 500MG/2,5MG CPR BT 30",
  atcCode: "A10BD02"
}, {
  CIP7: '3580280',
  CIP13: '3400935802804',
  ucdLib: "GLUCOVANCE 500MG/5MG CPR",
  UCD7: '9267360',
  UCD13: '3400892673608',
  ucdQtyMultiplicator: 30,
  cipLib: "GLUCOVANCE 500MG/5MG CPR BT 30",
  atcCode: "A10BD02"
}, {
  CIP7: '3709242',
  CIP13: '3400937092425',
  ucdLib: "GLIMEPIRIDE BGR 2MG CPR",
  UCD7: '9285464',
  UCD13: '3400892854649',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE BGR 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3705273',
  CIP13: '3400937052733',
  ucdLib: "GLIMEPIRIDE ZEN 1MG CPR",
  UCD7: '9281236',
  UCD13: '3400892812366',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ZEN 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3706195',
  CIP13: '3400937061957',
  ucdLib: "GLIMEPIRIDE ZEN 1MG CPR",
  UCD7: '9281236',
  UCD13: '3400892812366',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ZEN 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3706232',
  CIP13: '3400937062329',
  ucdLib: "GLIMEPIRIDE ZEN 2MG CPR",
  UCD7: '9281242',
  UCD13: '3400892812427',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ZEN 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3706309',
  CIP13: '3400937063098',
  ucdLib: "GLIMEPIRIDE ZEN 2MG CPR",
  UCD7: '9281242',
  UCD13: '3400892812427',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ZEN 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3706278',
  CIP13: '3400937062787',
  ucdLib: "GLIMEPIRIDE ZEN 3MG CPR",
  UCD7: '9281259',
  UCD13: '3400892812595',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ZEN 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3706321',
  CIP13: '3400937063210',
  ucdLib: "GLIMEPIRIDE ZEN 4MG CPR",
  UCD7: '9281265',
  UCD13: '3400892812656',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ZEN 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3668514',
  CIP13: '3400936685147',
  ucdLib: "AMAREL 1MG CPR",
  UCD7: '9191958',
  UCD13: '3400891919585',
  ucdQtyMultiplicator: 90,
  cipLib: "AMAREL 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3668566',
  CIP13: '3400936685666',
  ucdLib: "AMAREL 2MG CPR",
  UCD7: '9191964',
  UCD13: '3400891919646',
  ucdQtyMultiplicator: 90,
  cipLib: "AMAREL 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3668603',
  CIP13: '3400936686038',
  ucdLib: "AMAREL 3MG CPR",
  UCD7: '9191970',
  UCD13: '3400891919707',
  ucdQtyMultiplicator: 90,
  cipLib: "AMAREL 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3668655',
  CIP13: '3400936686557',
  ucdLib: "AMAREL 4MG CPR",
  UCD7: '9191987',
  UCD13: '3400891919875',
  ucdQtyMultiplicator: 90,
  cipLib: "AMAREL 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3747165',
  CIP13: '3400937471657',
  ucdLib: "GLIMEPIRIDE EG 1MG CPR",
  UCD7: '9288333',
  UCD13: '3400892883335',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE EG 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3747194',
  CIP13: '3400937471947',
  ucdLib: "GLIMEPIRIDE EG 1MG CPR",
  UCD7: '9288333',
  UCD13: '3400892883335',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE EG 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3747225',
  CIP13: '3400937472258',
  ucdLib: "GLIMEPIRIDE EG 2MG CPR",
  UCD7: '9288356',
  UCD13: '3400892883564',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE EG 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3747254',
  CIP13: '3400937472548',
  ucdLib: "GLIMEPIRIDE EG 2MG CPR",
  UCD7: '9288356',
  UCD13: '3400892883564',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE EG 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3747283',
  CIP13: '3400937472838',
  ucdLib: "GLIMEPIRIDE EG 3MG CPR",
  UCD7: '9288362',
  UCD13: '3400892883625',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE EG 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3747998',
  CIP13: '3400937479981',
  ucdLib: "GLIMEPIRIDE EG 3MG CPR",
  UCD7: '9288362',
  UCD13: '3400892883625',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE EG 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3748029',
  CIP13: '3400937480291',
  ucdLib: "GLIMEPIRIDE EG 4MG CPR",
  UCD7: '9288379',
  UCD13: '3400892883793',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE EG 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3748058',
  CIP13: '3400937480581',
  ucdLib: "GLIMEPIRIDE EG 4MG CPR",
  UCD7: '9288379',
  UCD13: '3400892883793',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE EG 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3765938',
  CIP13: '3400937659383',
  ucdLib: "GLIMEPIRIDE MYP 1MG CPR",
  UCD7: '9292464',
  UCD13: '3400892924649',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE MYP 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3765967',
  CIP13: '3400937659673',
  ucdLib: "GLIMEPIRIDE MYP 1MG CPR",
  UCD7: '9292464',
  UCD13: '3400892924649',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE MYP 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3765890',
  CIP13: '3400937658904',
  ucdLib: "GLIMEPIRIDE MYP 2MG CPR",
  UCD7: '9292470',
  UCD13: '3400892924700',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE MYP 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3765921',
  CIP13: '3400937659215',
  ucdLib: "GLIMEPIRIDE MYP 2MG CPR",
  UCD7: '9292470',
  UCD13: '3400892924700',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE MYP 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3765855',
  CIP13: '3400937658553',
  ucdLib: "GLIMEPIRIDE MYP 3MG CPR",
  UCD7: '9292487',
  UCD13: '3400892924878',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE MYP 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3765884',
  CIP13: '3400937658843',
  ucdLib: "GLIMEPIRIDE MYP 3MG CPR",
  UCD7: '9292487',
  UCD13: '3400892924878',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE MYP 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3765743',
  CIP13: '3400937657433',
  ucdLib: "GLIMEPIRIDE MYP 4MG CPR",
  UCD7: '9292493',
  UCD13: '3400892924939',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE MYP 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3765789',
  CIP13: '3400937657891',
  ucdLib: "GLIMEPIRIDE MYP 4MG CPR",
  UCD7: '9292493',
  UCD13: '3400892924939',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE MYP 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3746935',
  CIP13: '3400937469357',
  ucdLib: "GLIMEPIRIDE RBX 1MG CPR",
  UCD7: '9288385',
  UCD13: '3400892883854',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE RBX 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3746964',
  CIP13: '3400937469647',
  ucdLib: "GLIMEPIRIDE RBX 2MG CPR",
  UCD7: '9288391',
  UCD13: '3400892883915',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE RBX 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3746993',
  CIP13: '3400937469937',
  ucdLib: "GLIMEPIRIDE RBX 2MG CPR",
  UCD7: '9288391',
  UCD13: '3400892883915',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE RBX 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3747024',
  CIP13: '3400937470247',
  ucdLib: "GLIMEPIRIDE RBX 3MG CPR",
  UCD7: '9288416',
  UCD13: '3400892884165',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE RBX 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3747053',
  CIP13: '3400937470537',
  ucdLib: "GLIMEPIRIDE RBX 3MG CPR",
  UCD7: '9288416',
  UCD13: '3400892884165',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE RBX 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3747099',
  CIP13: '3400937470995',
  ucdLib: "GLIMEPIRIDE RBX 4MG CPR",
  UCD7: '9288422',
  UCD13: '3400892884226',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE RBX 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3747136',
  CIP13: '3400937471367',
  ucdLib: "GLIMEPIRIDE RBX 4MG CPR",
  UCD7: '9288422',
  UCD13: '3400892884226',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE RBX 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3748064',
  CIP13: '3400937480642',
  ucdLib: "GLIMEPIRIDE SDZ 1MG CPR",
  UCD7: '9287747',
  UCD13: '3400892877471',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE SDZ 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3749299',
  CIP13: '3400937492997',
  ucdLib: "GLIMEPIRIDE SDZ 1MG CPR",
  UCD7: '9287747',
  UCD13: '3400892877471',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE SDZ 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3748087',
  CIP13: '3400937480871',
  ucdLib: "GLIMEPIRIDE SDZ 2MG CPR",
  UCD7: '9287753',
  UCD13: '3400892877532',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE SDZ 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3749282',
  CIP13: '3400937492829',
  ucdLib: "GLIMEPIRIDE SDZ 2MG CPR",
  UCD7: '9287753',
  UCD13: '3400892877532',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE SDZ 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3748101',
  CIP13: '3400937481014',
  ucdLib: "GLIMEPIRIDE SDZ 3MG CPR",
  UCD7: '9287776',
  UCD13: '3400892877761',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE SDZ 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3749276',
  CIP13: '3400937492768',
  ucdLib: "GLIMEPIRIDE SDZ 3MG CPR",
  UCD7: '9287776',
  UCD13: '3400892877761',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE SDZ 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3748124',
  CIP13: '3400937481243',
  ucdLib: "GLIMEPIRIDE SDZ 4MG CPR",
  UCD7: '9287782',
  UCD13: '3400892877822',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE SDZ 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3749253',
  CIP13: '3400937492539',
  ucdLib: "GLIMEPIRIDE SDZ 4MG CPR",
  UCD7: '9287782',
  UCD13: '3400892877822',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE SDZ 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3718689',
  CIP13: '3400937186896',
  ucdLib: "GLIMEPIRIDE BGR 1MG CPR",
  UCD7: '9285458',
  UCD13: '3400892854588',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE BGR 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3718726',
  CIP13: '3400937187268',
  ucdLib: "GLIMEPIRIDE BGR 1MG CPR",
  UCD7: '9285458',
  UCD13: '3400892854588',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE BGR 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3718962',
  CIP13: '3400937189620',
  ucdLib: "GLIMEPIRIDE BGR 2MG CPR",
  UCD7: '9285464',
  UCD13: '3400892854649',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE BGR 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3718991',
  CIP13: '3400937189910',
  ucdLib: "GLIMEPIRIDE BGR 3MG CPR",
  UCD7: '9285470',
  UCD13: '3400892854700',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE BGR 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3719039',
  CIP13: '3400937190398',
  ucdLib: "GLIMEPIRIDE BGR 3MG CPR",
  UCD7: '9285470',
  UCD13: '3400892854700',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE BGR 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3719068',
  CIP13: '3400937190688',
  ucdLib: "GLIMEPIRIDE BGR 4MG CPR",
  UCD7: '9285487',
  UCD13: '3400892854878',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE BGR 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3719097',
  CIP13: '3400937190978',
  ucdLib: "GLIMEPIRIDE BGR 4MG CPR",
  UCD7: '9285487',
  UCD13: '3400892854878',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE BGR 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3711871',
  CIP13: '3400937118712',
  ucdLib: "GLIMEPIRIDE ZEN 3MG CPR",
  UCD7: '9281259',
  UCD13: '3400892812595',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ZEN 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3711888',
  CIP13: '3400937118880',
  ucdLib: "GLIMEPIRIDE ZEN 4MG CPR",
  UCD7: '9281265',
  UCD13: '3400892812656',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ZEN 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3826031',
  CIP13: '3400938260311',
  ucdLib: "GLIMEPIRIDE ZYD 1MG CPR",
  UCD7: '9308805',
  UCD13: '3400893088050',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ZYD 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3826048',
  CIP13: '3400938260489',
  ucdLib: "GLIMEPIRIDE ZYD 1MG CPR",
  UCD7: '9308805',
  UCD13: '3400893088050',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ZYD 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3826054',
  CIP13: '3400938260540',
  ucdLib: "GLIMEPIRIDE ZYD 2MG CPR",
  UCD7: '9308811',
  UCD13: '3400893088111',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ZYD 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3826060',
  CIP13: '3400938260601',
  ucdLib: "GLIMEPIRIDE ZYD 2MG CPR",
  UCD7: '9308811',
  UCD13: '3400893088111',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ZYD 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3826108',
  CIP13: '3400938261080',
  ucdLib: "GLIMEPIRIDE ZYD 3MG CPR",
  UCD7: '9308828',
  UCD13: '3400893088289',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ZYD 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3826114',
  CIP13: '3400938261141',
  ucdLib: "GLIMEPIRIDE ZYD 3MG CPR",
  UCD7: '9308828',
  UCD13: '3400893088289',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ZYD 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3826120',
  CIP13: '3400938261202',
  ucdLib: "GLIMEPIRIDE ZYD 4MG CPR",
  UCD7: '9308834',
  UCD13: '3400893088340',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ZYD 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3826137',
  CIP13: '3400938261370',
  ucdLib: "GLIMEPIRIDE ZYD 4MG CPR",
  UCD7: '9308834',
  UCD13: '3400893088340',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ZYD 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3884577',
  CIP13: '3400938845778',
  ucdLib: "GLIMEPIRIDE AHL 1MG CPR",
  UCD7: '9325258',
  UCD13: '3400893252581',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE AHL 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3884620',
  CIP13: '3400938846201',
  ucdLib: "GLIMEPIRIDE AHL 2MG CPR",
  UCD7: '9325264',
  UCD13: '3400893252642',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE AHL 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3884672',
  CIP13: '3400938846720',
  ucdLib: "GLIMEPIRIDE AHL 3MG CPR",
  UCD7: '9325270',
  UCD13: '3400893252703',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE AHL 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3884732',
  CIP13: '3400938847321',
  ucdLib: "GLIMEPIRIDE AHL 4MG CPR",
  UCD7: '9325287',
  UCD13: '3400893252871',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE AHL 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3758453',
  CIP13: '3400937584531',
  ucdLib: "GLIMEPIRIDE ARW 1MG CPR",
  UCD7: '9289060',
  UCD13: '3400892890609',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ARW 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3758499',
  CIP13: '3400937584999',
  ucdLib: "GLIMEPIRIDE ARW 1MG CPR",
  UCD7: '9289060',
  UCD13: '3400892890609',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ARW 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3758252',
  CIP13: '3400937582520',
  ucdLib: "GLIMEPIRIDE ARW 2MG CPR",
  UCD7: '9289077',
  UCD13: '3400892890777',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ARW 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3758281',
  CIP13: '3400937582810',
  ucdLib: "GLIMEPIRIDE ARW 2MG CPR",
  UCD7: '9289077',
  UCD13: '3400892890777',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ARW 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3758401',
  CIP13: '3400937584012',
  ucdLib: "GLIMEPIRIDE ARW 3MG CPR",
  UCD7: '9289083',
  UCD13: '3400892890838',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ARW 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3758430',
  CIP13: '3400937584302',
  ucdLib: "GLIMEPIRIDE ARW 3MG CPR",
  UCD7: '9289083',
  UCD13: '3400892890838',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ARW 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3758306',
  CIP13: '3400937583060',
  ucdLib: "GLIMEPIRIDE ARW 4MG CPR",
  UCD7: '9289108',
  UCD13: '3400892891088',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ARW 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3758335',
  CIP13: '3400937583350',
  ucdLib: "GLIMEPIRIDE ARW 4MG CPR",
  UCD7: '9289108',
  UCD13: '3400892891088',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ARW 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3801628',
  CIP13: '3400938016284',
  ucdLib: "GLIMEPIRIDE TVS 1MG CPR",
  UCD7: '9306781',
  UCD13: '3400893067819',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE TVS 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3801657',
  CIP13: '3400938016574',
  ucdLib: "GLIMEPIRIDE TVS 1MG CPR",
  UCD7: '9306781',
  UCD13: '3400893067819',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE TVS 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3801692',
  CIP13: '3400938016925',
  ucdLib: "GLIMEPIRIDE TVS 2MG CPR",
  UCD7: '9306798',
  UCD13: '3400893067987',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE TVS 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3801723',
  CIP13: '3400938017236',
  ucdLib: "GLIMEPIRIDE TVS 2MG CPR",
  UCD7: '9306798',
  UCD13: '3400893067987',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE TVS 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3801769',
  CIP13: '3400938017694',
  ucdLib: "GLIMEPIRIDE TVS 3MG CPR",
  UCD7: '9306806',
  UCD13: '3400893068069',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE TVS 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3801798',
  CIP13: '3400938017984',
  ucdLib: "GLIMEPIRIDE TVS 3MG CPR",
  UCD7: '9306806',
  UCD13: '3400893068069',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE TVS 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3801829',
  CIP13: '3400938018295',
  ucdLib: "GLIMEPIRIDE TVS 4MG CPR",
  UCD7: '9306812',
  UCD13: '3400893068120',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE TVS 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3801858',
  CIP13: '3400938018585',
  ucdLib: "GLIMEPIRIDE TVS 4MG CPR",
  UCD7: '9306812',
  UCD13: '3400893068120',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE TVS 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3938244',
  CIP13: '3400939382449',
  ucdLib: "GLIMEPIRIDE ACT 1MG CPR",
  UCD7: '9335280',
  UCD13: '3400893352809',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ACT 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3938273',
  CIP13: '3400939382739',
  ucdLib: "GLIMEPIRIDE ACT 1MG CPR",
  UCD7: '9335280',
  UCD13: '3400893352809',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ACT 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3938310',
  CIP13: '3400939383101',
  ucdLib: "GLIMEPIRIDE ACT 2MG CPR",
  UCD7: '9335297',
  UCD13: '3400893352977',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ACT 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3938356',
  CIP13: '3400939383569',
  ucdLib: "GLIMEPIRIDE ACT 2MG CPR",
  UCD7: '9335297',
  UCD13: '3400893352977',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ACT 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3938385',
  CIP13: '3400939383859',
  ucdLib: "GLIMEPIRIDE ACT 3MG CPR",
  UCD7: '9335305',
  UCD13: '3400893353059',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ACT 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3938422',
  CIP13: '3400939384221',
  ucdLib: "GLIMEPIRIDE ACT 3MG CPR",
  UCD7: '9335305',
  UCD13: '3400893353059',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ACT 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3938445',
  CIP13: '3400939384450',
  ucdLib: "GLIMEPIRIDE ACT 4MG CPR",
  UCD7: '9335311',
  UCD13: '3400893353110',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE ACT 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3938474',
  CIP13: '3400939384740',
  ucdLib: "GLIMEPIRIDE ACT 4MG CPR",
  UCD7: '9335311',
  UCD13: '3400893353110',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE ACT 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3965258',
  CIP13: '3400939652580',
  ucdLib: "GLIMEPIRIDE CRT 1MG CPR",
  UCD7: '9341530',
  UCD13: '3400893415306',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE CRT 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3965264',
  CIP13: '3400939652641',
  ucdLib: "GLIMEPIRIDE CRT 1MG CPR",
  UCD7: '9341530',
  UCD13: '3400893415306',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE CRT 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3965229',
  CIP13: '3400939652290',
  ucdLib: "GLIMEPIRIDE CRT 2MG CPR",
  UCD7: '9341547',
  UCD13: '3400893415474',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE CRT 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3965235',
  CIP13: '3400939652351',
  ucdLib: "GLIMEPIRIDE CRT 2MG CPR",
  UCD7: '9341547',
  UCD13: '3400893415474',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE CRT 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3965399',
  CIP13: '3400939653990',
  ucdLib: "GLIMEPIRIDE CRT 3MG CPR",
  UCD7: '9341553',
  UCD13: '3400893415535',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE CRT 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3965407',
  CIP13: '3400939654072',
  ucdLib: "GLIMEPIRIDE CRT 3MG CPR",
  UCD7: '9341553',
  UCD13: '3400893415535',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE CRT 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3965324',
  CIP13: '3400939653242',
  ucdLib: "GLIMEPIRIDE CRT 4MG CPR",
  UCD7: '9341576',
  UCD13: '3400893415764',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE CRT 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3965330',
  CIP13: '3400939653303',
  ucdLib: "GLIMEPIRIDE CRT 4MG CPR",
  UCD7: '9341576',
  UCD13: '3400893415764',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE CRT 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '2167253',
  CIP13: '3400921672534',
  ucdLib: "GLIMEPIRIDE AHL 1MG CPR",
  UCD7: '9325258',
  UCD13: '3400893252581',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE AHL 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '2167276',
  CIP13: '3400921672763',
  ucdLib: "GLIMEPIRIDE AHL 2MG CPR",
  UCD7: '9325264',
  UCD13: '3400893252642',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE AHL 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '2167282',
  CIP13: '3400921672824',
  ucdLib: "GLIMEPIRIDE AHL 3MG CPR",
  UCD7: '9325270',
  UCD13: '3400893252703',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE AHL 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '2167299',
  CIP13: '3400921672992',
  ucdLib: "GLIMEPIRIDE AHL 4MG CPR",
  UCD7: '9325287',
  UCD13: '3400893252871',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE AHL 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '2206272',
  CIP13: '3400922062723',
  ucdLib: "GLIMEPIRIDE EVO 1MG CPR",
  UCD7: '9385289',
  UCD13: '3400893852897',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE EVO 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '2206303',
  CIP13: '3400922063034',
  ucdLib: "GLIMEPIRIDE EVO 1MG CPR",
  UCD7: '9385289',
  UCD13: '3400893852897',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE EVO 1MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '2206349',
  CIP13: '3400922063492',
  ucdLib: "GLIMEPIRIDE EVO 2MG CPR",
  UCD7: '9385295',
  UCD13: '3400893852958',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE EVO 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '2206378',
  CIP13: '3400922063782',
  ucdLib: "GLIMEPIRIDE EVO 2MG CPR",
  UCD7: '9385295',
  UCD13: '3400893852958',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE EVO 2MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '2206409',
  CIP13: '3400922064093',
  ucdLib: "GLIMEPIRIDE EVO 3MG CPR",
  UCD7: '9385303',
  UCD13: '3400893853030',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE EVO 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '2206444',
  CIP13: '3400922064444',
  ucdLib: "GLIMEPIRIDE EVO 3MG CPR",
  UCD7: '9385303',
  UCD13: '3400893853030',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE EVO 3MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '2206527',
  CIP13: '3400922065274',
  ucdLib: "GLIMEPIRIDE EVO 4MG CPR",
  UCD7: '9385326',
  UCD13: '3400893853269',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIMEPIRIDE EVO 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '2206562',
  CIP13: '3400922065625',
  ucdLib: "GLIMEPIRIDE EVO 4MG CPR",
  UCD7: '9385326',
  UCD13: '3400893853269',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIMEPIRIDE EVO 4MG CPR BT 90",
  atcCode: "A10BB12"
}, {
  CIP7: '3421021',
  CIP13: '3400934210211',
  ucdLib: "AMAREL 1MG CPR",
  UCD7: '9191958',
  UCD13: '3400891919585',
  ucdQtyMultiplicator: 30,
  cipLib: "AMAREL 1MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3421038',
  CIP13: '3400934210389',
  ucdLib: "AMAREL 2MG CPR",
  UCD7: '9191964',
  UCD13: '3400891919646',
  ucdQtyMultiplicator: 30,
  cipLib: "AMAREL 2MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3421044',
  CIP13: '3400934210440',
  ucdLib: "AMAREL 3MG CPR",
  UCD7: '9191970',
  UCD13: '3400891919707',
  ucdQtyMultiplicator: 30,
  cipLib: "AMAREL 3MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3421050',
  CIP13: '3400934210501',
  ucdLib: "AMAREL 4MG CPR",
  UCD7: '9191987',
  UCD13: '3400891919875',
  ucdQtyMultiplicator: 30,
  cipLib: "AMAREL 4MG CPR BT 30",
  atcCode: "A10BB12"
}, {
  CIP7: '3614530',
  CIP13: '3400936145306',
  ucdLib: "GLICLAZIDE TVC 80MG CPR",
  UCD7: '9245074',
  UCD13: '3400892450742',
  ucdQtyMultiplicator: 20,
  cipLib: "GLICLAZIDE TVC 80MG CPR BT 20",
  atcCode: "A10BB09"
}, {
  CIP7: '3614547',
  CIP13: '3400936145474',
  ucdLib: "GLICLAZIDE TVC 80MG CPR",
  UCD7: '9245074',
  UCD13: '3400892450742',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE TVC 80MG CPR BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3001082',
  CIP13: '3400930010822',
  ucdLib: "GLICLAZIDE EG 60MG CPR LM",
  UCD7: '9410202',
  UCD13: '3400894102021',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE EG 60MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '3001085',
  CIP13: '3400930010853',
  ucdLib: "GLICLAZIDE EG 60MG CPR LM",
  UCD7: '9410202',
  UCD13: '3400894102021',
  ucdQtyMultiplicator: 90,
  cipLib: "GLICLAZIDE EG 60MG CPR LM BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '3004676',
  CIP13: '3400930046760',
  ucdLib: "GLICLAZIDE MYP 60MG CPR LM",
  UCD7: '9404561',
  UCD13: '3400894045618',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE MYP 60MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '4914458',
  CIP13: '3400949144587',
  ucdLib: "GLICLAZIDE ARW 30MG CPR LM",
  UCD7: '9354136',
  UCD13: '3400893541364',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE ARW 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '4914470',
  CIP13: '3400949144709',
  ucdLib: "GLICLAZIDE ARW 30MG CPR LM",
  UCD7: '9354136',
  UCD13: '3400893541364',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE ARW 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '4914530',
  CIP13: '3400949145300',
  ucdLib: "GLICLAZIDE ARW 30MG CPR LM",
  UCD7: '9354136',
  UCD13: '3400893541364',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE ARW 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3681845',
  CIP13: '3400936818453',
  ucdLib: "GLICLAZIDE SDZ 80MG CPR",
  UCD7: '9268951',
  UCD13: '3400892689517',
  ucdQtyMultiplicator: 20,
  cipLib: "GLICLAZIDE SDZ 80MG CPR BT 20",
  atcCode: "A10BB09"
}, {
  CIP7: '3681851',
  CIP13: '3400936818514',
  ucdLib: "GLICLAZIDE SDZ 80MG CPR",
  UCD7: '9268951',
  UCD13: '3400892689517',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE SDZ 80MG CPR BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3525329',
  CIP13: '3400935253293',
  ucdLib: "GLICLAZIDE EG 80MG CPR",
  UCD7: '9219071',
  UCD13: '3400892190716',
  ucdQtyMultiplicator: 20,
  cipLib: "GLICLAZIDE EG 80MG CPR BT 20",
  atcCode: "A10BB09"
}, {
  CIP7: '3525335',
  CIP13: '3400935253354',
  ucdLib: "GLICLAZIDE EG 80MG CPR",
  UCD7: '9219071',
  UCD13: '3400892190716',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE EG 80MG CPR BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3563732',
  CIP13: '3400935637321',
  ucdLib: "GLICLAZIDE ARW 80MG CPR",
  UCD7: '9234515',
  UCD13: '3400892345154',
  ucdQtyMultiplicator: 20,
  cipLib: "GLICLAZIDE ARW 80MG CPR BT 20",
  atcCode: "A10BB09"
}, {
  CIP7: '3856799',
  CIP13: '3400938567991',
  ucdLib: "GLICLAZIDE MYL 30MG CPR LM",
  UCD7: '9319134',
  UCD13: '3400893191347',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE MYL 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '3856813',
  CIP13: '3400938568134',
  ucdLib: "GLICLAZIDE MYL 30MG CPR LM",
  UCD7: '9319134',
  UCD13: '3400893191347',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE MYL 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3856871',
  CIP13: '3400938568714',
  ucdLib: "GLICLAZIDE MYL 30MG CPR LM",
  UCD7: '9319134',
  UCD13: '3400893191347',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE MYL 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3856635',
  CIP13: '3400938566352',
  ucdLib: "GLICLAZIDE RTP 30MG CPR LM",
  UCD7: '9320999',
  UCD13: '3400893209998',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE RTP 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '3856701',
  CIP13: '3400938567014',
  ucdLib: "GLICLAZIDE RTP 30MG CPR LM",
  UCD7: '9320999',
  UCD13: '3400893209998',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE RTP 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3856316',
  CIP13: '3400938563160',
  ucdLib: "GLICLAZIDE SDZ 30MG CPR LM",
  UCD7: '9320976',
  UCD13: '3400893209769',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE SDZ 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '3856339',
  CIP13: '3400938563399',
  ucdLib: "GLICLAZIDE SDZ 30MG CPR LM",
  UCD7: '9320976',
  UCD13: '3400893209769',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE SDZ 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3856380',
  CIP13: '3400938563801',
  ucdLib: "GLICLAZIDE SDZ 30MG CPR LM",
  UCD7: '9320976',
  UCD13: '3400893209769',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE SDZ 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3856463',
  CIP13: '3400938564631',
  ucdLib: "GLICLAZIDE TVC 30MG CPR LM",
  UCD7: '9319157',
  UCD13: '3400893191576',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE TVC 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '3856492',
  CIP13: '3400938564921',
  ucdLib: "GLICLAZIDE TVC 30MG CPR LM",
  UCD7: '9319157',
  UCD13: '3400893191576',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE TVC 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3856552',
  CIP13: '3400938565522',
  ucdLib: "GLICLAZIDE TVC 30MG CPR LM",
  UCD7: '9319157',
  UCD13: '3400893191576',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE TVC 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3510575',
  CIP13: '3400935105752',
  ucdLib: "GLICLAZIDE MYL 80MG CPR",
  UCD7: '9217706',
  UCD13: '3400892177069',
  ucdQtyMultiplicator: 20,
  cipLib: "GLICLAZIDE MYL 80MG CPR BT 20",
  atcCode: "A10BB09"
}, {
  CIP7: '3510581',
  CIP13: '3400935105813',
  ucdLib: "GLICLAZIDE MYL 80MG CPR",
  UCD7: '9217706',
  UCD13: '3400892177069',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE MYL 80MG CPR BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3532536',
  CIP13: '3400935325365',
  ucdLib: "GLICLAZIDE ZYD 80MG CPR",
  UCD7: '9223233',
  UCD13: '3400892232331',
  ucdQtyMultiplicator: 20,
  cipLib: "GLICLAZIDE ZYD 80MG CPR BT 20",
  atcCode: "A10BB09"
}, {
  CIP7: '3532542',
  CIP13: '3400935325426',
  ucdLib: "GLICLAZIDE ZYD 80MG CPR",
  UCD7: '9223233',
  UCD13: '3400892232331',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE ZYD 80MG CPR BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3582310',
  CIP13: '3400935823106',
  ucdLib: "GLICLAZIDE ARW 80MG CPR",
  UCD7: '9234515',
  UCD13: '3400892345154',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE ARW 80MG CPR BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3381468',
  CIP13: '3400933814687',
  ucdLib: "DIAMICRON 60MG CPR LM",
  UCD7: '9346585',
  UCD13: '3400893465851',
  ucdQtyMultiplicator: 30,
  cipLib: "DIAMICRON 60MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '3382338',
  CIP13: '3400933823382',
  ucdLib: "DIAMICRON 60MG CPR LM",
  UCD7: '9346585',
  UCD13: '3400893465851',
  ucdQtyMultiplicator: 90,
  cipLib: "DIAMICRON 60MG CPR LM BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '3382344',
  CIP13: '3400933823443',
  ucdLib: "DIAMICRON 60MG CPR LM",
  UCD7: '9346585',
  UCD13: '3400893465851',
  ucdQtyMultiplicator: 100,
  cipLib: "DIAMICRON 60MG CPR LM BT 100",
  atcCode: "A10BB09"
}, {
  CIP7: '3728860',
  CIP13: '3400937288606',
  ucdLib: "GLICLAZIDE TVC 80MG CPR",
  UCD7: '9245074',
  UCD13: '3400892450742',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE TVC 80MG CPR BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3490281',
  CIP13: '3400934902819',
  ucdLib: "GLICLAZIDE BGA 80MG CPR",
  UCD7: '9218663',
  UCD13: '3400892186634',
  ucdQtyMultiplicator: 20,
  cipLib: "GLICLAZIDE BGA 80MG CPR BT 20",
  atcCode: "A10BB09"
}, {
  CIP7: '3490298',
  CIP13: '3400934902987',
  ucdLib: "GLICLAZIDE BGA 80MG CPR",
  UCD7: '9218663',
  UCD13: '3400892186634',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE BGA 80MG CPR BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3784284',
  CIP13: '3400937842846',
  ucdLib: "GLICLAZIDE BGA 80MG CPR",
  UCD7: '9218663',
  UCD13: '3400892186634',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE BGA 80MG CPR BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3773375',
  CIP13: '3400937733755',
  ucdLib: "GLICLAZIDE MYL 80MG CPR",
  UCD7: '9217706',
  UCD13: '3400892177069',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE MYL 80MG CPR BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3752901',
  CIP13: '3400937529013',
  ucdLib: "GLICLAZIDE ISD 30MG CPR LM",
  UCD7: '9353214',
  UCD13: '3400893532140',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE ISD 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '3752924',
  CIP13: '3400937529242',
  ucdLib: "GLICLAZIDE ISD 30MG CPR LM",
  UCD7: '9353214',
  UCD13: '3400893532140',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE ISD 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '3752999',
  CIP13: '3400937529990',
  ucdLib: "GLICLAZIDE ISD 30MG CPR LM",
  UCD7: '9353214',
  UCD13: '3400893532140',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE ISD 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3904989',
  CIP13: '3400939049892',
  ucdLib: "GLICLAZIDE BGR 30MG CPR LM",
  UCD7: '9330087',
  UCD13: '3400893300879',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE BGR 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '3905003',
  CIP13: '3400939050034',
  ucdLib: "GLICLAZIDE BGR 30MG CPR LM",
  UCD7: '9330087',
  UCD13: '3400893300879',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE BGR 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '4972289',
  CIP13: '3400949722891',
  ucdLib: "GLICLAZIDE ZEN 30MG CPR LM",
  UCD7: '9363253',
  UCD13: '3400893632536',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE ZEN 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '4972303',
  CIP13: '3400949723034',
  ucdLib: "GLICLAZIDE ZEN 30MG CPR LM",
  UCD7: '9363253',
  UCD13: '3400893632536',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE ZEN 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '4972378',
  CIP13: '3400949723782',
  ucdLib: "GLICLAZIDE ZEN 30MG CPR LM",
  UCD7: '9363253',
  UCD13: '3400893632536',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE ZEN 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '4973716',
  CIP13: '3400949737161',
  ucdLib: "GLICLAZIDE ZYD 30MG CPR LM",
  UCD7: '9365418',
  UCD13: '3400893654187',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE ZYD 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '4973739',
  CIP13: '3400949737390',
  ucdLib: "GLICLAZIDE ZYD 30MG CPR LM",
  UCD7: '9365418',
  UCD13: '3400893654187',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE ZYD 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '4973797',
  CIP13: '3400949737970',
  ucdLib: "GLICLAZIDE ZYD 30MG CPR LM",
  UCD7: '9365418',
  UCD13: '3400893654187',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE ZYD 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3905121',
  CIP13: '3400939051215',
  ucdLib: "GLYDIUM 30MG CPR LM",
  UCD7: '9330093',
  UCD13: '3400893300930',
  ucdQtyMultiplicator: 30,
  cipLib: "GLYDIUM 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '4900261',
  CIP13: '3400949002610',
  ucdLib: "DIAMICRON 30MG CLM AIPMWI IT",
  UCD7: '9336150',
  UCD13: '3400893361504',
  ucdQtyMultiplicator: 60,
  cipLib: "DIAMICRON 30MG CLM AIPMWI IT BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '4901622',
  CIP13: '3400949016228',
  ucdLib: "DIAMICRON 60MG CLM AIPBBABE",
  UCD7: '9394354',
  UCD13: '3400893943540',
  ucdQtyMultiplicator: 30,
  cipLib: "DIAMICRON 60MG CLM AIPBBABE BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '4901639',
  CIP13: '3400949016396',
  ucdLib: "DIAMICRON 60MG CLM AIPBBABE",
  UCD7: '9394354',
  UCD13: '3400893943540',
  ucdQtyMultiplicator: 90,
  cipLib: "DIAMICRON 60MG CLM AIPBBABE BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '4900024',
  CIP13: '3400949000241',
  ucdLib: "DIAMICRON 60MG CLM AIPMWIHU",
  UCD7: '9397654',
  UCD13: '3400893976548',
  ucdQtyMultiplicator: 90,
  cipLib: "DIAMICRON 60MG CLM AIPMWIHU BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '4902001',
  CIP13: '3400949020010',
  ucdLib: "DIAMICRON 60MG CLM AIPMWIHU",
  UCD7: '9397654',
  UCD13: '3400893976548',
  ucdQtyMultiplicator: 30,
  cipLib: "DIAMICRON 60MG CLM AIPMWIHU BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '4900041',
  CIP13: '3400949000418',
  ucdLib: "DIAMICRON 60MG CLM AIPPLAHU",
  UCD7: '9401060',
  UCD13: '3400894010609',
  ucdQtyMultiplicator: 90,
  cipLib: "DIAMICRON 60MG CLM AIPPLAHU BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '4902277',
  CIP13: '3400949022779',
  ucdLib: "DIAMICRON 60MG CLM AIPPLAHU",
  UCD7: '9401060',
  UCD13: '3400894010609',
  ucdQtyMultiplicator: 30,
  cipLib: "DIAMICRON 60MG CLM AIPPLAHU BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '2691304',
  CIP13: '3400926913045',
  ucdLib: "GLICLAZIDE ARW 60MG CPR LM",
  UCD7: '9417055',
  UCD13: '3400894170556',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE ARW 60MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '2691356',
  CIP13: '3400926913564',
  ucdLib: "GLICLAZIDE ARW 60MG CPR LM",
  UCD7: '9417055',
  UCD13: '3400894170556',
  ucdQtyMultiplicator: 90,
  cipLib: "GLICLAZIDE ARW 60MG CPR LM BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '2758623',
  CIP13: '3400927586231',
  ucdLib: "GLICLAZIDE BGA 60MG CPR LM",
  UCD7: '9399009',
  UCD13: '3400893990094',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE BGA 60MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '2758675',
  CIP13: '3400927586750',
  ucdLib: "GLICLAZIDE BGA 60MG CPR LM",
  UCD7: '9399009',
  UCD13: '3400893990094',
  ucdQtyMultiplicator: 90,
  cipLib: "GLICLAZIDE BGA 60MG CPR LM BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '2751696',
  CIP13: '3400927516962',
  ucdLib: "GLICLAZIDE KRK 30MG CPR LM",
  UCD7: '9395313',
  UCD13: '3400893953136',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE KRK 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '2691528',
  CIP13: '3400926915285',
  ucdLib: "GLICLAZIDE MYP 60MG CPR LM",
  UCD7: '9404561',
  UCD13: '3400894045618',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE MYP 60MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '2691563',
  CIP13: '3400926915636',
  ucdLib: "GLICLAZIDE MYP 60MG CPR LM",
  UCD7: '9404561',
  UCD13: '3400894045618',
  ucdQtyMultiplicator: 90,
  cipLib: "GLICLAZIDE MYP 60MG CPR LM BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '2691089',
  CIP13: '3400926910891',
  ucdLib: "GLICLAZIDE TVC 60MG CPR LM",
  UCD7: '9411934',
  UCD13: '3400894119340',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE TVC 60MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '2691132',
  CIP13: '3400926911324',
  ucdLib: "GLICLAZIDE TVC 60MG CPR LM",
  UCD7: '9411934',
  UCD13: '3400894119340',
  ucdQtyMultiplicator: 90,
  cipLib: "GLICLAZIDE TVC 60MG CPR LM BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '4189997',
  CIP13: '3400941899973',
  ucdLib: "GLICLAZIDE BGR 30MG CPR LM",
  UCD7: '9330087',
  UCD13: '3400893300879',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE BGR 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '2736886',
  CIP13: '3400927368868',
  ucdLib: "GLICLAZIDE KRK 30MG CPR LM",
  UCD7: '9395313',
  UCD13: '3400893953136',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE KRK 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '2736892',
  CIP13: '3400927368929',
  ucdLib: "GLICLAZIDE KRK 30MG CPR LM",
  UCD7: '9395313',
  UCD13: '3400893953136',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE KRK 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '2737064',
  CIP13: '3400927370649',
  ucdLib: "GLICLAZIDE KRK 60MG CPR LM",
  UCD7: '9395336',
  UCD13: '3400893953365',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE KRK 60MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '2737087',
  CIP13: '3400927370878',
  ucdLib: "GLICLAZIDE KRK 60MG CPR LM",
  UCD7: '9395336',
  UCD13: '3400893953365',
  ucdQtyMultiplicator: 90,
  cipLib: "GLICLAZIDE KRK 60MG CPR LM BT 90",
  atcCode: "A10BB09"
}, {
  CIP7: '2772965',
  CIP13: '3400927729652',
  ucdLib: "GLICLAZIDE EGG 30MG CPR LM",
  UCD7: '9409297',
  UCD13: '3400894092971',
  ucdQtyMultiplicator: 30,
  cipLib: "GLICLAZIDE EGG 30MG CPR LM BT 30",
  atcCode: "A10BB09"
}, {
  CIP7: '2772988',
  CIP13: '3400927729881',
  ucdLib: "GLICLAZIDE EGG 30MG CPR LM",
  UCD7: '9409297',
  UCD13: '3400894092971',
  ucdQtyMultiplicator: 60,
  cipLib: "GLICLAZIDE EGG 30MG CPR LM BT 60",
  atcCode: "A10BB09"
}, {
  CIP7: '2773002',
  CIP13: '3400927730023',
  ucdLib: "GLICLAZIDE EGG 30MG CPR LM",
  UCD7: '9409297',
  UCD13: '3400894092971',
  ucdQtyMultiplicator: 180,
  cipLib: "GLICLAZIDE EGG 30MG CPR LM BT 180",
  atcCode: "A10BB09"
}, {
  CIP7: '3395418',
  CIP13: '3400933954185',
  ucdLib: "OZIDIA 10MG CPR",
  UCD7: '9182161',
  UCD13: '3400891821611',
  ucdQtyMultiplicator: 30,
  cipLib: "OZIDIA 10MG CPR BT 30",
  atcCode: "A10BB07"
}, {
  CIP7: '3395393',
  CIP13: '3400933953935',
  ucdLib: "OZIDIA 5MG CPR",
  UCD7: '9182178',
  UCD13: '3400891821789',
  ucdQtyMultiplicator: 30,
  cipLib: "OZIDIA 5MG CPR BT 30",
  atcCode: "A10BB07"
}, {
  CIP7: '3489705',
  CIP13: '3400934897054',
  ucdLib: "GLIPIZIDE MYL 5MG CPR",
  UCD7: '9210986',
  UCD13: '3400892109862',
  ucdQtyMultiplicator: 30,
  cipLib: "GLIPIZIDE MYL 5MG CPR BT 30",
  atcCode: "A10BB07"
}, {
  CIP7: '3154465',
  CIP13: '3400931544654',
  ucdLib: "GLIBENESE 5MG CPR",
  UCD7: '9038524',
  UCD13: '3400890385244',
  ucdQtyMultiplicator: 20,
  cipLib: "GLIBENESE 5MG CPR BT 20",
  atcCode: "A10BB07"
}, {
  CIP7: '3154488',
  CIP13: '3400931544883',
  ucdLib: "GLIBENESE 5MG CPR",
  UCD7: '9038524',
  UCD13: '3400890385244',
  ucdQtyMultiplicator: 100,
  cipLib: "GLIBENESE 5MG CPR BT 100",
  atcCode: "A10BB07"
}, {
  CIP7: '3152704',
  CIP13: '3400931527046',
  ucdLib: "MINIDIAB 5MG CPR",
  UCD7: '9059147',
  UCD13: '3400890591478',
  ucdQtyMultiplicator: 20,
  cipLib: "MINIDIAB 5MG CPR BT 20",
  atcCode: "A10BB07"
}, {
  CIP7: '3152727',
  CIP13: '3400931527275',
  ucdLib: "MINIDIAB 5MG CPR",
  UCD7: '9059147',
  UCD13: '3400890591478',
  ucdQtyMultiplicator: 100,
  cipLib: "MINIDIAB 5MG CPR BT 100",
  atcCode: "A10BB07"
}, {
  CIP7: '3028097',
  CIP13: '3400930280973',
  ucdLib: "DAONIL 5MG",
  UCD7: '9023994',
  UCD13: '3400890239943',
  ucdQtyMultiplicator: 100,
  cipLib: "DAONIL 5MG BT 100",
  atcCode: "A10BB01"
}, {
  CIP7: '3028105',
  CIP13: '3400930281055',
  ucdLib: "DAONIL 5MG",
  UCD7: '9023994',
  UCD13: '3400890239943',
  ucdQtyMultiplicator: 20,
  cipLib: "DAONIL 5MG BT 20",
  atcCode: "A10BB01"
}, {
  CIP7: '3682081',
  CIP13: '3400936820814',
  ucdLib: "GLIBENCLAMIDE TVC 2,5MG CPR",
  UCD7: '9279297',
  UCD13: '3400892792972',
  ucdQtyMultiplicator: 60,
  cipLib: "GLIBENCLAMIDE TVC 2,5MG CPR BT 60",
  atcCode: "A10BB01"
}, {
  CIP7: '3682098',
  CIP13: '3400936820982',
  ucdLib: "GLIBENCLAMIDE TVC 5MG CPR",
  UCD7: '9279305',
  UCD13: '3400892793054',
  ucdQtyMultiplicator: 20,
  cipLib: "GLIBENCLAMIDE TVC 5MG CPR BT 20",
  atcCode: "A10BB01"
}, {
  CIP7: '3857764',
  CIP13: '3400938577648',
  ucdLib: "GLIBENCLAMIDE EG 5MG CPR",
  UCD7: '9317572',
  UCD13: '3400893175729',
  ucdQtyMultiplicator: 20,
  cipLib: "GLIBENCLAMIDE EG 5MG CPR BT 20",
  atcCode: "A10BB01"
}, {
  CIP7: '3857770',
  CIP13: '3400938577709',
  ucdLib: "GLIBENCLAMIDE EG 5MG CPR",
  UCD7: '9317572',
  UCD13: '3400893175729',
  ucdQtyMultiplicator: 100,
  cipLib: "GLIBENCLAMIDE EG 5MG CPR BT 100",
  atcCode: "A10BB01"
}, {
  CIP7: '3701625',
  CIP13: '3400937016254',
  ucdLib: "GLIBENCLAMIDE TVC 5MG CPR",
  UCD7: '9279305',
  UCD13: '3400892793054',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIBENCLAMIDE TVC 5MG CPR BT 90",
  atcCode: "A10BB01"
}, {
  CIP7: '3720060',
  CIP13: '3400937200608',
  ucdLib: "DAONIL 5MG",
  UCD7: '9023994',
  UCD13: '3400890239943',
  ucdQtyMultiplicator: 180,
  cipLib: "DAONIL 5MG BT 180",
  atcCode: "A10BB01"
}, {
  CIP7: '3740708',
  CIP13: '3400937407083',
  ucdLib: "GLIBENCLAMIDE BGA 5MG CPR",
  UCD7: '9286110',
  UCD13: '3400892861104',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIBENCLAMIDE BGA 5MG CPR BT 90",
  atcCode: "A10BB01"
}, {
  CIP7: '3776534',
  CIP13: '3400937765343',
  ucdLib: "GLIBENCLAMIDE MYL 2,5MG CPR",
  UCD7: '9297935',
  UCD13: '3400892979359',
  ucdQtyMultiplicator: 60,
  cipLib: "GLIBENCLAMIDE MYL 2,5MG CPR BT 60",
  atcCode: "A10BB01"
}, {
  CIP7: '3776557',
  CIP13: '3400937765572',
  ucdLib: "GLIBENCLAMIDE MYL 5MG CPR",
  UCD7: '9297941',
  UCD13: '3400892979410',
  ucdQtyMultiplicator: 20,
  cipLib: "GLIBENCLAMIDE MYL 5MG CPR BT 20",
  atcCode: "A10BB01"
}, {
  CIP7: '3776563',
  CIP13: '3400937765633',
  ucdLib: "GLIBENCLAMIDE MYL 5MG CPR",
  UCD7: '9297941',
  UCD13: '3400892979410',
  ucdQtyMultiplicator: 90,
  cipLib: "GLIBENCLAMIDE MYL 5MG CPR BT 90",
  atcCode: "A10BB01"
}, {
  CIP7: '3782687',
  CIP13: '3400937826877',
  ucdLib: "GLIBENCLAMIDE MYL 5MG CPR",
  UCD7: '9297941',
  UCD13: '3400892979410',
  ucdQtyMultiplicator: 180,
  cipLib: "GLIBENCLAMIDE MYL 5MG CPR BT 180",
  atcCode: "A10BB01"
}, {
  CIP7: '3732117',
  CIP13: '3400937321174',
  ucdLib: "GLIBENCLAMIDE BGA 2,5MG CPR",
  UCD7: '9286104',
  UCD13: '3400892861043',
  ucdQtyMultiplicator: 60,
  cipLib: "GLIBENCLAMIDE BGA 2,5MG CPR BT 60",
  atcCode: "A10BB01"
}, {
  CIP7: '3732146',
  CIP13: '3400937321464',
  ucdLib: "GLIBENCLAMIDE BGA 5MG CPR",
  UCD7: '9286110',
  UCD13: '3400892861104',
  ucdQtyMultiplicator: 20,
  cipLib: "GLIBENCLAMIDE BGA 5MG CPR BT 20",
  atcCode: "A10BB01"
}, {
  CIP7: '3802510',
  CIP13: '3400938025101',
  ucdLib: "GLIBENCLAMIDE RBX 2,5MG CPR",
  UCD7: '9302895',
  UCD13: '3400893028957',
  ucdQtyMultiplicator: 60,
  cipLib: "GLIBENCLAMIDE RBX 2,5MG CPR BT 60",
  atcCode: "A10BB01"
}, {
  CIP7: '3802421',
  CIP13: '3400938024210',
  ucdLib: "GLIBENCLAMIDE RBX 5MG CPR",
  UCD7: '9303883',
  UCD13: '3400893038833',
  ucdQtyMultiplicator: 20,
  cipLib: "GLIBENCLAMIDE RBX 5MG CPR BT 20",
  atcCode: "A10BB01"
}, {
  CIP7: '3802467',
  CIP13: '3400938024678',
  ucdLib: "GLIBENCLAMIDE RBX 5MG CPR",
  UCD7: '9303883',
  UCD13: '3400893038833',
  ucdQtyMultiplicator: 100,
  cipLib: "GLIBENCLAMIDE RBX 5MG CPR BT 100",
  atcCode: "A10BB01"
}, {
  CIP7: '3802303',
  CIP13: '3400938023039',
  ucdLib: "GLIBENCLAMIDE SDZ 2,5MG CPR",
  UCD7: '9302197',
  UCD13: '3400893021972',
  ucdQtyMultiplicator: 60,
  cipLib: "GLIBENCLAMIDE SDZ 2,5MG CPR BT 60",
  atcCode: "A10BB01"
}, {
  CIP7: '3802332',
  CIP13: '3400938023329',
  ucdLib: "GLIBENCLAMIDE SDZ 5MG CPR",
  UCD7: '9302205',
  UCD13: '3400893022054',
  ucdQtyMultiplicator: 20,
  cipLib: "GLIBENCLAMIDE SDZ 5MG CPR BT 20",
  atcCode: "A10BB01"
}, {
  CIP7: '3802378',
  CIP13: '3400938023787',
  ucdLib: "GLIBENCLAMIDE SDZ 5MG CPR",
  UCD7: '9302205',
  UCD13: '3400893022054',
  ucdQtyMultiplicator: 100,
  cipLib: "GLIBENCLAMIDE SDZ 5MG CPR BT 100",
  atcCode: "A10BB01"
}, {
  CIP7: '3875294',
  CIP13: '3400938752946',
  ucdLib: "GLIBENCLAMIDE TVC 2,5MG CPR",
  UCD7: '9279297',
  UCD13: '3400892792972',
  ucdQtyMultiplicator: 180,
  cipLib: "GLIBENCLAMIDE TVC 2,5MG CPR BT 180",
  atcCode: "A10BB01"
}, {
  CIP7: '3875331',
  CIP13: '3400938753318',
  ucdLib: "GLIBENCLAMIDE TVC 5MG CPR",
  UCD7: '9279305',
  UCD13: '3400892793054',
  ucdQtyMultiplicator: 180,
  cipLib: "GLIBENCLAMIDE TVC 5MG CPR BT 180",
  atcCode: "A10BB01"
}, {
  CIP7: '3165026',
  CIP13: '3400931650263',
  ucdLib: "HEMI-DAONIL 2,5MG CPR",
  UCD7: '9042218',
  UCD13: '3400890422185',
  ucdQtyMultiplicator: 60,
  cipLib: "HEMI-DAONIL 2,5MG CPR BT 60",
  atcCode: "A10BB01"
}, {
  CIP7: '3898094',
  CIP13: '3400938980943',
  ucdLib: "GLIBENCLAMIDE ARW 2,5MG CPR",
  UCD7: '9326140',
  UCD13: '3400893261408',
  ucdQtyMultiplicator: 60,
  cipLib: "GLIBENCLAMIDE ARW 2,5MG CPR BT 60",
  atcCode: "A10BB01"
}, {
  CIP7: '3898266',
  CIP13: '3400938982664',
  ucdLib: "GLIBENCLAMIDE ARW 5MG CPR",
  UCD7: '9326157',
  UCD13: '3400893261576',
  ucdQtyMultiplicator: 20,
  cipLib: "GLIBENCLAMIDE ARW 5MG CPR BT 20",
  atcCode: "A10BB01"
}, {
  CIP7: '3908272',
  CIP13: '3400939082721',
  ucdLib: "GLIBENCLAMIDE ARW 5MG CPR",
  UCD7: '9326157',
  UCD13: '3400893261576',
  ucdQtyMultiplicator: 100,
  cipLib: "GLIBENCLAMIDE ARW 5MG CPR BT 100",
  atcCode: "A10BB01"
}, {
  CIP7: '3612258',
  CIP13: '3400936122581',
  ucdLib: "METFORMINE CRT 500MG CPR",
  UCD7: '9247742',
  UCD13: '3400892477428',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE CRT 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3612287',
  CIP13: '3400936122871',
  ucdLib: "METFORMINE CRT 500MG CPR",
  UCD7: '9247742',
  UCD13: '3400892477428',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE CRT 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3612293',
  CIP13: '3400936122932',
  ucdLib: "METFORMINE CRT 850MG CPR",
  UCD7: '9247759',
  UCD13: '3400892477596',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE CRT 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3612324',
  CIP13: '3400936123243',
  ucdLib: "METFORMINE CRT 850MG CPR",
  UCD7: '9247759',
  UCD13: '3400892477596',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE CRT 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3616121',
  CIP13: '3400936161214',
  ucdLib: "METFORMINE TVC 500MG CPR",
  UCD7: '9247417',
  UCD13: '3400892474175',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE TVC 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3616138',
  CIP13: '3400936161382',
  ucdLib: "METFORMINE TVC 850MG CPR",
  UCD7: '9247423',
  UCD13: '3400892474236',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE TVC 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3044788',
  CIP13: '3400930447888',
  ucdLib: "GLUCOPHAGE 500MG CPR",
  UCD7: '9038760',
  UCD13: '3400890387606',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOPHAGE 500MG CPR BT 50",
  atcCode: "A10BA02"
}, {
  CIP7: '3044802',
  CIP13: '3400930448021',
  ucdLib: "GLUCOPHAGE 850MG CPR",
  UCD7: '9038777',
  UCD13: '3400890387774',
  ucdQtyMultiplicator: 30,
  cipLib: "GLUCOPHAGE 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3192750',
  CIP13: '3400931927501',
  ucdLib: "STAGID 700MG CPR",
  UCD7: '9087379',
  UCD13: '3400890873796',
  ucdQtyMultiplicator: 30,
  cipLib: "STAGID 700MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3192767',
  CIP13: '3400931927679',
  ucdLib: "STAGID 700MG CPR",
  UCD7: '9087379',
  UCD13: '3400890873796',
  ucdQtyMultiplicator: 100,
  cipLib: "STAGID 700MG CPR BT 100",
  atcCode: "A10BA02"
}, {
  CIP7: '4912577',
  CIP13: '3400949125777',
  ucdLib: "METFORMINE MYP 1000MG CPR",
  UCD7: '9362621',
  UCD13: '3400893626214',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE MYP 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '4912643',
  CIP13: '3400949126439',
  ucdLib: "METFORMINE MYP 1000MG CPR",
  UCD7: '9362621',
  UCD13: '3400893626214',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE MYP 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '4912040',
  CIP13: '3400949120406',
  ucdLib: "METFORMINE MYP 500MG CPR",
  UCD7: '9362638',
  UCD13: '3400893626382',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE MYP 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '4912117',
  CIP13: '3400949121175',
  ucdLib: "METFORMINE MYP 500MG CPR",
  UCD7: '9362638',
  UCD13: '3400893626382',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE MYP 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '4912301',
  CIP13: '3400949123018',
  ucdLib: "METFORMINE MYP 850MG CPR",
  UCD7: '9362644',
  UCD13: '3400893626443',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE MYP 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '4912376',
  CIP13: '3400949123766',
  ucdLib: "METFORMINE MYP 850MG CPR",
  UCD7: '9362644',
  UCD13: '3400893626443',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE MYP 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3689462',
  CIP13: '3400936894624',
  ucdLib: "METFORMINE RBX 500MG CPR",
  UCD7: '9278257',
  UCD13: '3400892782577',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE RBX 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3689031',
  CIP13: '3400936890312',
  ucdLib: "METFORMINE ZEN 1000MG CPR",
  UCD7: '9277453',
  UCD13: '3400892774534',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ZEN 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3528167',
  CIP13: '3400935281678',
  ucdLib: "GLUCOPHAGE 500MG CPR",
  UCD7: '9038760',
  UCD13: '3400890387606',
  ucdQtyMultiplicator: 30,
  cipLib: "GLUCOPHAGE 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '4980030',
  CIP13: '3400949800308',
  ucdLib: "METFORMINE EG 500MG CPR",
  UCD7: '9370112',
  UCD13: '3400893701126',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE EG 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3670847',
  CIP13: '3400936708471',
  ucdLib: "METFORMINE PHR 1000MG CPR",
  UCD7: '9333683',
  UCD13: '3400893336830',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE PHR 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3670853',
  CIP13: '3400936708532',
  ucdLib: "METFORMINE PHR 1000MG CPR",
  UCD7: '9333683',
  UCD13: '3400893336830',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE PHR 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3675336',
  CIP13: '3400936753365',
  ucdLib: "METFORMINE RBX 850MG CPR",
  UCD7: '9269206',
  UCD13: '3400892692067',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE RBX 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3670899',
  CIP13: '3400936708990',
  ucdLib: "METFORMINE TVC 1000MG CPR",
  UCD7: '9273596',
  UCD13: '3400892735962',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE TVC 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3670907',
  CIP13: '3400936709072',
  ucdLib: "METFORMINE TVC 1000MG CPR",
  UCD7: '9273596',
  UCD13: '3400892735962',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE TVC 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3673722',
  CIP13: '3400936737228',
  ucdLib: "METFORMINE ZEN 850MG CPR",
  UCD7: '9266751',
  UCD13: '3400892667515',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ZEN 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3560171',
  CIP13: '3400935601711',
  ucdLib: "GLUCOPHAGE 1000MG CPR",
  UCD7: '9229862',
  UCD13: '3400892298627',
  ucdQtyMultiplicator: 30,
  cipLib: "GLUCOPHAGE 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3560231',
  CIP13: '3400935602312',
  ucdLib: "GLUCOPHAGE 1000MG CPR",
  UCD7: '9229862',
  UCD13: '3400892298627',
  ucdQtyMultiplicator: 90,
  cipLib: "GLUCOPHAGE 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '5592330',
  CIP13: '3400955923305',
  ucdLib: "GLUCOPHAGE 850MG CPR",
  UCD7: '9038777',
  UCD13: '3400890387774',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOPHAGE 850MG CPR BT 50",
  atcCode: "A10BA02"
}, {
  CIP7: '3852318',
  CIP13: '3400938523188',
  ucdLib: "METFORMINE EG 1000MG C.",
  UCD7: '9266395',
  UCD13: '3400892663951',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE EG 1000MG C. BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3855848',
  CIP13: '3400938558487',
  ucdLib: "METFORMINE ISD 1000MG CPR",
  UCD7: '9292754',
  UCD13: '3400892927541',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ISD 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3855825',
  CIP13: '3400938558258',
  ucdLib: "METFORMINE ISD 500MG CPR",
  UCD7: '9292760',
  UCD13: '3400892927602',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ISD 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3855831',
  CIP13: '3400938558319',
  ucdLib: "METFORMINE ISD 850MG CPR",
  UCD7: '9292777',
  UCD13: '3400892927770',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ISD 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3650193',
  CIP13: '3400936501935',
  ucdLib: "METFORMINE EG 1000MG C.",
  UCD7: '9266395',
  UCD13: '3400892663951',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE EG 1000MG C. BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3650112',
  CIP13: '3400936501126',
  ucdLib: "METFORMINE ZYD 1000MG CPR",
  UCD7: '9272349',
  UCD13: '3400892723495',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ZYD 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3704003',
  CIP13: '3400937040037',
  ucdLib: "METFORMINE ALT 1000MG CPR",
  UCD7: '9281940',
  UCD13: '3400892819402',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ALT 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3704049',
  CIP13: '3400937040495',
  ucdLib: "METFORMINE ALT 1000MG CPR",
  UCD7: '9281940',
  UCD13: '3400892819402',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ALT 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3720485',
  CIP13: '3400937204859',
  ucdLib: "GLUCOPHAGE 500MG CPR",
  UCD7: '9038760',
  UCD13: '3400890387606',
  ucdQtyMultiplicator: 90,
  cipLib: "GLUCOPHAGE 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3722461',
  CIP13: '3400937224611',
  ucdLib: "GLUCOPHAGE 850MG CPR",
  UCD7: '9038777',
  UCD13: '3400890387774',
  ucdQtyMultiplicator: 90,
  cipLib: "GLUCOPHAGE 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3812974',
  CIP13: '3400938129748',
  ucdLib: "METFORMINE CRT 1000MG CPR",
  UCD7: '9306864',
  UCD13: '3400893068649',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE CRT 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3813005',
  CIP13: '3400938130058',
  ucdLib: "METFORMINE CRT 1000MG CPR",
  UCD7: '9306864',
  UCD13: '3400893068649',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE CRT 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3763247',
  CIP13: '3400937632478',
  ucdLib: "METFORMINE ISD 1000MG CPR",
  UCD7: '9292754',
  UCD13: '3400892927541',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ISD 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3763299',
  CIP13: '3400937632997',
  ucdLib: "METFORMINE ISD 500MG CPR",
  UCD7: '9292760',
  UCD13: '3400892927602',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ISD 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3763313',
  CIP13: '3400937633130',
  ucdLib: "METFORMINE ISD 850MG CPR",
  UCD7: '9292777',
  UCD13: '3400892927770',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ISD 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3667087',
  CIP13: '3400936670877',
  ucdLib: "METFORMINE SDZ 1000MG CPR",
  UCD7: '9269620',
  UCD13: '3400892696201',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE SDZ 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3667101',
  CIP13: '3400936671010',
  ucdLib: "METFORMINE SDZ 1000MG CPR",
  UCD7: '9269620',
  UCD13: '3400892696201',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE SDZ 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3728943',
  CIP13: '3400937289436',
  ucdLib: "METFORMINE TVC 500MG CPR",
  UCD7: '9247417',
  UCD13: '3400892474175',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE TVC 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3728966',
  CIP13: '3400937289665',
  ucdLib: "METFORMINE TVC 850MG CPR",
  UCD7: '9247423',
  UCD13: '3400892474236',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE TVC 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3722768',
  CIP13: '3400937227681',
  ucdLib: "METFORMINE ZYD 1000MG CPR",
  UCD7: '9272349',
  UCD13: '3400892723495',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ZYD 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3491234',
  CIP13: '3400934912344',
  ucdLib: "METFORMINE ALT 850MG CPR",
  UCD7: '9283749',
  UCD13: '3400892837499',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ALT 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3794609',
  CIP13: '3400937946094',
  ucdLib: "METFORMINE MYL 1000MG C.DIS",
  UCD7: '9304641',
  UCD13: '3400893046418',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE MYL 1000MG C.DIS BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3784120',
  CIP13: '3400937841207',
  ucdLib: "METFORMINE ZEN 850MG CPR",
  UCD7: '9266751',
  UCD13: '3400892667515',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ZEN 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3869626',
  CIP13: '3400938696264',
  ucdLib: "METFORMINE ALT 850MG CPR",
  UCD7: '9283749',
  UCD13: '3400892837499',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ALT 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3925112',
  CIP13: '3400939251127',
  ucdLib: "METFORMINE BLF 500MG CPR",
  UCD7: '9335860',
  UCD13: '3400893358603',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE BLF 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3925201',
  CIP13: '3400939252018',
  ucdLib: "METFORMINE BLF 500MG CPR",
  UCD7: '9335860',
  UCD13: '3400893358603',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE BLF 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3925299',
  CIP13: '3400939252995',
  ucdLib: "METFORMINE BLF 850MG CPR",
  UCD7: '9335877',
  UCD13: '3400893358771',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE BLF 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3925394',
  CIP13: '3400939253947',
  ucdLib: "METFORMINE BLF 850MG CPR",
  UCD7: '9335877',
  UCD13: '3400893358771',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE BLF 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3800758',
  CIP13: '3400938007589',
  ucdLib: "METFORMINE MYL 500MG C.DISP",
  UCD7: '9304658',
  UCD13: '3400893046586',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE MYL 500MG C.DISP BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3801025',
  CIP13: '3400938010251',
  ucdLib: "METFORMINE MYL 850MG C.DISP",
  UCD7: '9304664',
  UCD13: '3400893046647',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE MYL 850MG C.DISP BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3925448',
  CIP13: '3400939254487',
  ucdLib: "METFORMINE RBX 1000MG CPR",
  UCD7: '9335854',
  UCD13: '3400893358542',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE RBX 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3925514',
  CIP13: '3400939255149',
  ucdLib: "METFORMINE RBX 1000MG CPR",
  UCD7: '9335854',
  UCD13: '3400893358542',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE RBX 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3730874',
  CIP13: '3400937308748',
  ucdLib: "METFORMINE RBX 500MG CPR",
  UCD7: '9278257',
  UCD13: '3400892782577',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE RBX 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3730845',
  CIP13: '3400937308458',
  ucdLib: "METFORMINE RBX 850MG CPR",
  UCD7: '9269206',
  UCD13: '3400892692067',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE RBX 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3730348',
  CIP13: '3400937303484',
  ucdLib: "METFORMINE RPG 1000MG CPR",
  UCD7: '9266426',
  UCD13: '3400892664262',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE RPG 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3737735',
  CIP13: '3400937377355',
  ucdLib: "METFORMINE ZEN 1000MG CPR",
  UCD7: '9277453',
  UCD13: '3400892774534',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ZEN 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3865321',
  CIP13: '3400938653212',
  ucdLib: "METFORMINE ZYD 500MG CPR",
  UCD7: '9257947',
  UCD13: '3400892579474',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ZYD 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3865344',
  CIP13: '3400938653441',
  ucdLib: "METFORMINE ZYD 500MG CPR",
  UCD7: '9257947',
  UCD13: '3400892579474',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ZYD 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3883129',
  CIP13: '3400938831290',
  ucdLib: "METFORMINE ZYF 850MG CPR",
  UCD7: '9322308',
  UCD13: '3400893223086',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ZYF 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3883158',
  CIP13: '3400938831580',
  ucdLib: "METFORMINE ZYF 850MG CPR",
  UCD7: '9322308',
  UCD13: '3400893223086',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ZYF 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '5632590',
  CIP13: '3400956325900',
  ucdLib: "GLUCOPHAGE 1000MG CPR",
  UCD7: '9229862',
  UCD13: '3400892298627',
  ucdQtyMultiplicator: 50,
  cipLib: "GLUCOPHAGE 1000MG CPR BT 50",
  atcCode: "A10BA02"
}, {
  CIP7: '4979038',
  CIP13: '3400949790388',
  ucdLib: "METFORMINE ARG 500MG C.PEL",
  UCD7: '9370141',
  UCD13: '3400893701416',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ARG 500MG C.PEL BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '4979127',
  CIP13: '3400949791279',
  ucdLib: "METFORMINE ARG 500MG C.PEL",
  UCD7: '9370141',
  UCD13: '3400893701416',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ARG 500MG C.PEL BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '4979498',
  CIP13: '3400949794980',
  ucdLib: "METFORMINE ARG 500MG C.PEL",
  UCD7: '9370141',
  UCD13: '3400893701416',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ARG 500MG C.PEL BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '4979162',
  CIP13: '3400949791620',
  ucdLib: "METFORMINE ARG 850MG C.PEL",
  UCD7: '9370158',
  UCD13: '3400893701584',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ARG 850MG C.PEL BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '4979251',
  CIP13: '3400949792511',
  ucdLib: "METFORMINE ARG 850MG C.PEL",
  UCD7: '9370158',
  UCD13: '3400893701584',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ARG 850MG C.PEL BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '4979618',
  CIP13: '3400949796182',
  ucdLib: "METFORMINE ARG 850MG C.PEL",
  UCD7: '9370158',
  UCD13: '3400893701584',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ARG 850MG C.PEL BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3971833',
  CIP13: '3400939718330',
  ucdLib: "METFORMINE BGA 1000MG CPR",
  UCD7: '9344907',
  UCD13: '3400893449073',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE BGA 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3971862',
  CIP13: '3400939718620',
  ucdLib: "METFORMINE BGA 1000MG CPR",
  UCD7: '9344907',
  UCD13: '3400893449073',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE BGA 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3971721',
  CIP13: '3400939717210',
  ucdLib: "METFORMINE BGR 500MG CPR",
  UCD7: '9346800',
  UCD13: '3400893468005',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE BGR 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3971744',
  CIP13: '3400939717449',
  ucdLib: "METFORMINE BGR 500MG CPR",
  UCD7: '9346800',
  UCD13: '3400893468005',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE BGR 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3971796',
  CIP13: '3400939717968',
  ucdLib: "METFORMINE BGR 850MG CPR",
  UCD7: '9390037',
  UCD13: '3400893900376',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE BGR 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3971810',
  CIP13: '3400939718101',
  ucdLib: "METFORMINE BGR 850MG CPR",
  UCD7: '9390037',
  UCD13: '3400893900376',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE BGR 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '2215213',
  CIP13: '3400922152134',
  ucdLib: "METFORMINE EG 500MG CPR",
  UCD7: '9370112',
  UCD13: '3400893701126',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE EG 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '2215236',
  CIP13: '3400922152363',
  ucdLib: "METFORMINE EG 850MG CPR",
  UCD7: '9383327',
  UCD13: '3400893833278',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE EG 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3893470',
  CIP13: '3400938934700',
  ucdLib: "METFORMINE PHR 500MG CPR",
  UCD7: '9325376',
  UCD13: '3400893253762',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE PHR 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3893487',
  CIP13: '3400938934878',
  ucdLib: "METFORMINE PHR 500MG CPR",
  UCD7: '9325376',
  UCD13: '3400893253762',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE PHR 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3893458',
  CIP13: '3400938934588',
  ucdLib: "METFORMINE PHR 850MG CPR",
  UCD7: '9325382',
  UCD13: '3400893253823',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE PHR 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3893464',
  CIP13: '3400938934649',
  ucdLib: "METFORMINE PHR 850MG CPR",
  UCD7: '9325382',
  UCD13: '3400893253823',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE PHR 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3970288',
  CIP13: '3400939702889',
  ucdLib: "METFORMINE SDZ 500MG CPR",
  UCD7: '9343948',
  UCD13: '3400893439487',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE SDZ 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3970348',
  CIP13: '3400939703480',
  ucdLib: "METFORMINE SDZ 500MG CPR",
  UCD7: '9343948',
  UCD13: '3400893439487',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE SDZ 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '3970590',
  CIP13: '3400939705903',
  ucdLib: "METFORMINE SDZ 850MG CPR",
  UCD7: '9343954',
  UCD13: '3400893439548',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE SDZ 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '3970650',
  CIP13: '3400939706504',
  ucdLib: "METFORMINE SDZ 850MG CPR",
  UCD7: '9343954',
  UCD13: '3400893439548',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE SDZ 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '4158235',
  CIP13: '3400941582356',
  ucdLib: "METFORMINE EVO 500MG CPR",
  UCD7: '9373205',
  UCD13: '3400893732052',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE EVO 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '4158442',
  CIP13: '3400941584428',
  ucdLib: "METFORMINE EVO 850MG CPR",
  UCD7: '9373211',
  UCD13: '3400893732113',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE EVO 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '2756423',
  CIP13: '3400927564239',
  ucdLib: "METFORMINE ZEN 500MG CPR",
  UCD7: '9399015',
  UCD13: '3400893990155',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ZEN 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '2756452',
  CIP13: '3400927564529',
  ucdLib: "METFORMINE ZEN 500MG CPR",
  UCD7: '9399015',
  UCD13: '3400893990155',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ZEN 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '2208696',
  CIP13: '3400922086965',
  ucdLib: "METFORMINE EG 850MG CPR",
  UCD7: '9383327',
  UCD13: '3400893833278',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE EG 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '2797439',
  CIP13: '3400927974397',
  ucdLib: "METFORMINE ARL 1000MG CPR",
  UCD7: '9337209',
  UCD13: '3400893372098',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ARL 1000MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '2797451',
  CIP13: '3400927974519',
  ucdLib: "METFORMINE ARL 1000MG CPR",
  UCD7: '9337209',
  UCD13: '3400893372098',
  ucdQtyMultiplicator: 50,
  cipLib: "METFORMINE ARL 1000MG CPR BT 50",
  atcCode: "A10BA02"
}, {
  CIP7: '2797497',
  CIP13: '3400927974977',
  ucdLib: "METFORMINE ARL 1000MG CPR",
  UCD7: '9337209',
  UCD13: '3400893372098',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ARL 1000MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '2796718',
  CIP13: '3400927967184',
  ucdLib: "METFORMINE ARL 500MG CPR",
  UCD7: '9337215',
  UCD13: '3400893372159',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ARL 500MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '2796813',
  CIP13: '3400927968136',
  ucdLib: "METFORMINE ARL 500MG CPR",
  UCD7: '9337215',
  UCD13: '3400893372159',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ARL 500MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '2796842',
  CIP13: '3400927968426',
  ucdLib: "METFORMINE ARL 500MG CPR",
  UCD7: '9337215',
  UCD13: '3400893372159',
  ucdQtyMultiplicator: 100,
  cipLib: "METFORMINE ARL 500MG CPR BT 100",
  atcCode: "A10BA02"
}, {
  CIP7: '2797020',
  CIP13: '3400927970207',
  ucdLib: "METFORMINE ARL 850MG CPR",
  UCD7: '9337221',
  UCD13: '3400893372210',
  ucdQtyMultiplicator: 30,
  cipLib: "METFORMINE ARL 850MG CPR BT 30",
  atcCode: "A10BA02"
}, {
  CIP7: '2797178',
  CIP13: '3400927971785',
  ucdLib: "METFORMINE ARL 850MG CPR",
  UCD7: '9337221',
  UCD13: '3400893372210',
  ucdQtyMultiplicator: 90,
  cipLib: "METFORMINE ARL 850MG CPR BT 90",
  atcCode: "A10BA02"
}, {
  CIP7: '2797209',
  CIP13: '3400927972096',
  ucdLib: "METFORMINE ARL 850MG CPR",
  UCD7: '9337221',
  UCD13: '3400893372210',
  ucdQtyMultiplicator: 100,
  cipLib: "METFORMINE ARL 850MG CPR BT 100",
  atcCode: "A10BA02"
}, {
  CIP7: '3001851',
  CIP13: '3400930018514',
  ucdLib: "XULTOPHY INJ CART.3ML STYLO",
  UCD7: '9417925',
  UCD13: '3400894179252',
  ucdQtyMultiplicator: 5,
  cipLib: "XULTOPHY INJ CART.3ML STYLO BT 5",
  atcCode: "A10AE56"
}, {
  CIP7: '3651198',
  CIP13: '3400936511989',
  ucdLib: "LEVEMIR FLEXPEN STYLO3ML",
  UCD7: '9271203',
  UCD13: '3400892712031',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVEMIR FLEXPEN STYLO3ML BT 5",
  atcCode: "A10AE05"
}, {
  CIP7: '3651206',
  CIP13: '3400936512061',
  ucdLib: "LEVEMIR INNOLET STYLO3ML",
  UCD7: '9301329',
  UCD13: '3400893013298',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVEMIR INNOLET STYLO3ML BT 5",
  atcCode: "A10AE05"
}, {
  CIP7: '3651181',
  CIP13: '3400936511811',
  ucdLib: "LEVEMIR PENFILL CART.3ML",
  UCD7: '9271226',
  UCD13: '3400892712260',
  ucdQtyMultiplicator: 5,
  cipLib: "LEVEMIR PENFILL CART.3ML BT 5",
  atcCode: "A10AE05"
}, {
  CIP7: '3001616',
  CIP13: '3400930016169',
  ucdLib: "ABASAGLAR 100U INJ CART.3ML",
  UCD7: '9412046',
  UCD13: '3400894120469',
  ucdQtyMultiplicator: 5,
  cipLib: "ABASAGLAR 100U INJ CART.3ML BT 5",
  atcCode: "A10AE04"
}, {
  CIP7: '3001621',
  CIP13: '3400930016213',
  ucdLib: "ABASAGLAR 100U INJ STYLO3ML",
  UCD7: '9412052',
  UCD13: '3400894120520',
  ucdQtyMultiplicator: 5,
  cipLib: "ABASAGLAR 100U INJ STYLO3ML BT 5",
  atcCode: "A10AE04"
}, {
  CIP7: '3001667',
  CIP13: '3400930016671',
  ucdLib: "TOUJEO 300U/ML INJ STYLO1,5ML",
  UCD7: '9413175',
  UCD13: '3400894131755',
  ucdQtyMultiplicator: 3,
  cipLib: "TOUJEO 300U/ML INJ STYLO1,5ML BT 3",
  atcCode: "A10AE04"
}, {
  CIP7: '3594649',
  CIP13: '3400935946492',
  ucdLib: "LANTUS 100U/ML INJ FL10ML",
  UCD7: '9238938',
  UCD13: '3400892389387',
  ucdQtyMultiplicator: 1,
  cipLib: "LANTUS 100U/ML INJ FL10ML BT 1",
  atcCode: "A10AE04"
}, {
  CIP7: '3546320',
  CIP13: '3400935463203',
  ucdLib: "LANTUS 100U/ML INJ C.3ML",
  UCD7: '9227596',
  UCD13: '3400892275963',
  ucdQtyMultiplicator: 5,
  cipLib: "LANTUS 100U/ML INJ C.3ML BT 5",
  atcCode: "A10AE04"
}, {
  CIP7: '3772298',
  CIP13: '3400937722988',
  ucdLib: "LANTUS 100U/ML INJ SOLO3ML",
  UCD7: '9292599',
  UCD13: '3400892925998',
  ucdQtyMultiplicator: 5,
  cipLib: "LANTUS 100U/ML INJ SOLO3ML BT 5",
  atcCode: "A10AE04"
}, {
  CIP7: '3567664',
  CIP13: '3400935676641',
  ucdLib: "NOVOMIX 30 FLEXPEN STYLO3ML",
  UCD7: '9236655',
  UCD13: '3400892366555',
  ucdQtyMultiplicator: 5,
  cipLib: "NOVOMIX 30 FLEXPEN STYLO3ML BT 5",
  atcCode: "A10AD05"
}, {
  CIP7: '3549525',
  CIP13: '3400935495259',
  ucdLib: "NOVOMIX 30 PENFILL CART.3ML",
  UCD7: '9236678',
  UCD13: '3400892366784',
  ucdQtyMultiplicator: 5,
  cipLib: "NOVOMIX 30 PENFILL CART.3ML BT 5",
  atcCode: "A10AD05"
}, {
  CIP7: '3702429',
  CIP13: '3400937024297',
  ucdLib: "NOVOMIX 50 FLEXPEN STYLO3ML",
  UCD7: '9296137',
  UCD13: '3400892961378',
  ucdQtyMultiplicator: 5,
  cipLib: "NOVOMIX 50 FLEXPEN STYLO3ML BT 5",
  atcCode: "A10AD05"
}, {
  CIP7: '3716532',
  CIP13: '3400937165327',
  ucdLib: "NOVOMIX 70 FLEXPEN STYLO3ML",
  UCD7: '9297289',
  UCD13: '3400892972893',
  ucdQtyMultiplicator: 5,
  cipLib: "NOVOMIX 70 FLEXPEN STYLO3ML BT 5",
  atcCode: "A10AD05"
}, {
  CIP7: '3851106',
  CIP13: '3400938511062',
  ucdLib: "HUMALOG MIX25 100KWIKPEN 3ML",
  UCD7: '9317595',
  UCD13: '3400893175958',
  ucdQtyMultiplicator: 5,
  cipLib: "HUMALOG MIX25 100KWIKPEN 3ML BT 5",
  atcCode: "A10AD04"
}, {
  CIP7: '3851112',
  CIP13: '3400938511123',
  ucdLib: "HUMALOG MIX50 100KWIKPEN 3ML",
  UCD7: '9317603',
  UCD13: '3400893176030',
  ucdQtyMultiplicator: 5,
  cipLib: "HUMALOG MIX50 100KWIKPEN 3ML BT 5",
  atcCode: "A10AD04"
}, {
  CIP7: '3494451',
  CIP13: '3400934944512',
  ucdLib: "HUMALOG MIX25 100UI C.3ML",
  UCD7: '9214091',
  UCD13: '3400892140919',
  ucdQtyMultiplicator: 5,
  cipLib: "HUMALOG MIX25 100UI C.3ML BT 5",
  atcCode: "A10AD04"
}, {
  CIP7: '3494468',
  CIP13: '3400934944680',
  ucdLib: "HUMALOG MIX50 100UI C.3ML",
  UCD7: '9214122',
  UCD13: '3400892141220',
  ucdQtyMultiplicator: 5,
  cipLib: "HUMALOG MIX50 100UI C.3ML BT 5",
  atcCode: "A10AD04"
}, {
  CIP7: '3612034',
  CIP13: '3400936120341',
  ucdLib: "MIXTARD 30 INJ FL10ML",
  UCD7: '9256072',
  UCD13: '3400892560724',
  ucdQtyMultiplicator: 1,
  cipLib: "MIXTARD 30 INJ FL10ML BT 1",
  atcCode: "A10AD01"
}, {
  CIP7: '3403945',
  CIP13: '3400934039454',
  ucdLib: "UMULINE PROFIL30 100UI C.3ML",
  UCD7: '9187247',
  UCD13: '3400891872477',
  ucdQtyMultiplicator: 5,
  cipLib: "UMULINE PROFIL30 100UI C.3ML BT 5",
  atcCode: "A10AD01"
}, {
  CIP7: '3352308',
  CIP13: '3400933523084',
  ucdLib: "UMULINE PROFIL30 100U/ML 10ML",
  UCD7: '9215274',
  UCD13: '3400892152745',
  ucdQtyMultiplicator: 1,
  cipLib: "UMULINE PROFIL30 100U/ML 10ML BT 1",
  atcCode: "A10AD01"
}, {
  CIP7: '3487824',
  CIP13: '3400934878244',
  ucdLib: "UMULINE PROFIL30 KWIKPEN 3ML",
  UCD7: '9214174',
  UCD13: '3400892141749',
  ucdQtyMultiplicator: 5,
  cipLib: "UMULINE PROFIL30 KWIKPEN 3ML BT 5",
  atcCode: "A10AD01"
}, {
  CIP7: '3612028',
  CIP13: '3400936120280',
  ucdLib: "INSULATARD 100UI/ML FL10ML",
  UCD7: '9255977',
  UCD13: '3400892559773',
  ucdQtyMultiplicator: 1,
  cipLib: "INSULATARD 100UI/ML FL10ML BT 1",
  atcCode: "A10AC01"
}, {
  CIP7: '3612092',
  CIP13: '3400936120921',
  ucdLib: "INSULATARD FLEXPEN STYLO3ML",
  UCD7: '9246352',
  UCD13: '3400892463520',
  ucdQtyMultiplicator: 5,
  cipLib: "INSULATARD FLEXPEN STYLO3ML BT 5",
  atcCode: "A10AC01"
}, {
  CIP7: '3611997',
  CIP13: '3400936119970',
  ucdLib: "INSULATARD INNOLET STY3ML",
  UCD7: '9255954',
  UCD13: '3400892559544',
  ucdQtyMultiplicator: 5,
  cipLib: "INSULATARD INNOLET STY3ML BT 5",
  atcCode: "A10AC01"
}, {
  CIP7: '3611833',
  CIP13: '3400936118331',
  ucdLib: "INSULATARD PENFILL CA3ML",
  UCD7: '9255960',
  UCD13: '3400892559605',
  ucdQtyMultiplicator: 5,
  cipLib: "INSULATARD PENFILL CA3ML BT 5",
  atcCode: "A10AC01"
}, {
  CIP7: '3403879',
  CIP13: '3400934038792',
  ucdLib: "UMULINE NPH 100UI CART.3ML",
  UCD7: '9187282',
  UCD13: '3400891872828',
  ucdQtyMultiplicator: 5,
  cipLib: "UMULINE NPH 100UI CART.3ML BT 5",
  atcCode: "A10AC01"
}, {
  CIP7: '3352343',
  CIP13: '3400933523435',
  ucdLib: "UMULINE NPH 100UI/ML FL10ML",
  UCD7: '9215297',
  UCD13: '3400892152974',
  ucdQtyMultiplicator: 1,
  cipLib: "UMULINE NPH 100UI/ML FL10ML BT 1",
  atcCode: "A10AC01"
}, {
  CIP7: '3487882',
  CIP13: '3400934878824',
  ucdLib: "UMULINE NPH 100UI KWIKPEN 3ML",
  UCD7: '9214151',
  UCD13: '3400892141510',
  ucdQtyMultiplicator: 5,
  cipLib: "UMULINE NPH 100UI KWIKPEN 3ML BT 5",
  atcCode: "A10AC01"
}, {
  CIP7: '3656942',
  CIP13: '3400936569423',
  ucdLib: "APIDRA 100U/ML INJ CART3ML",
  UCD7: '9339119',
  UCD13: '3400893391198',
  ucdQtyMultiplicator: 5,
  cipLib: "APIDRA 100U/ML INJ CART3ML BT 5",
  atcCode: "A10AB06"
}, {
  CIP7: '3651809',
  CIP13: '3400936518094',
  ucdLib: "APIDRA 100U/ML INJ FL10ML",
  UCD7: '9279831',
  UCD13: '3400892798318',
  ucdQtyMultiplicator: 1,
  cipLib: "APIDRA 100U/ML INJ FL10ML BT 1",
  atcCode: "A10AB06"
}, {
  CIP7: '3772200',
  CIP13: '3400937722001',
  ucdLib: "APIDRA 100U/ML INJ SOLO3ML",
  UCD7: '9292240',
  UCD13: '3400892922409',
  ucdQtyMultiplicator: 5,
  cipLib: "APIDRA 100U/ML INJ SOLO3ML BT 5",
  atcCode: "A10AB06"
}, {
  CIP7: '3525909',
  CIP13: '3400935259097',
  ucdLib: "NOVORAPID 100U/ML INJ FL10ML",
  UCD7: '9222995',
  UCD13: '3400892229959',
  ucdQtyMultiplicator: 1,
  cipLib: "NOVORAPID 100U/ML INJ FL10ML BT 1",
  atcCode: "A10AB05"
}, {
  CIP7: '3525921',
  CIP13: '3400935259219',
  ucdLib: "NOVORAPID PENFILL CART.3ML",
  UCD7: '9222989',
  UCD13: '3400892229898',
  ucdQtyMultiplicator: 5,
  cipLib: "NOVORAPID PENFILL CART.3ML BT 5",
  atcCode: "A10AB05"
}, {
  CIP7: '3552740',
  CIP13: '3400935527400',
  ucdLib: "NOVORAPID FLEXPEN STYLO3ML",
  UCD7: '9240243',
  UCD13: '3400892402437',
  ucdQtyMultiplicator: 5,
  cipLib: "NOVORAPID FLEXPEN STYLO3ML BT 5",
  atcCode: "A10AB05"
}, {
  CIP7: '2771457',
  CIP13: '3400927714573',
  ucdLib: "NOVORAPID PUMPCART CART1,6ML",
  UCD7: '9405543',
  UCD13: '3400894055433',
  ucdQtyMultiplicator: 5,
  cipLib: "NOVORAPID PUMPCART CART1,6ML BT 5",
  atcCode: "A10AB05"
}, {
  CIP7: '3000085',
  CIP13: '3400930000854',
  ucdLib: "HUMALOG 200UI/ML KWIKPEN 3ML",
  UCD7: '9406459',
  UCD13: '3400894064596',
  ucdQtyMultiplicator: 5,
  cipLib: "HUMALOG 200UI/ML KWIKPEN 3ML BT 5",
  atcCode: "A10AB04"
}, {
  CIP7: '3437393',
  CIP13: '3400934373930',
  ucdLib: "HUMALOG 100UI/ML INJ C.3ML",
  UCD7: '9203325',
  UCD13: '3400892033259',
  ucdQtyMultiplicator: 5,
  cipLib: "HUMALOG 100UI/ML INJ C.3ML BT 5",
  atcCode: "A10AB04"
}, {
  CIP7: '3851098',
  CIP13: '3400938510980',
  ucdLib: "HUMALOG 100UI/ML KWIKPEN 3ML",
  UCD7: '9317626',
  UCD13: '3400893176269',
  ucdQtyMultiplicator: 5,
  cipLib: "HUMALOG 100UI/ML KWIKPEN 3ML BT 5",
  atcCode: "A10AB04"
}, {
  CIP7: '3414268',
  CIP13: '3400934142680',
  ucdLib: "HUMALOG 100UI/ML INJ FL10ML",
  UCD7: '9215191',
  UCD13: '3400892151915',
  ucdQtyMultiplicator: 1,
  cipLib: "HUMALOG 100UI/ML INJ FL10ML BT 1",
  atcCode: "A10AB04"
}, {
  CIP7: '3612011',
  CIP13: '3400936120112',
  ucdLib: "ACTRAPID INJ FL10ML",
  UCD7: '9255925',
  UCD13: '3400892559254',
  ucdQtyMultiplicator: 1,
  cipLib: "ACTRAPID INJ FL10ML BT 1",
  atcCode: "A10AB01"
}, {
  CIP7: '3611827',
  CIP13: '3400936118270',
  ucdLib: "ACTRAPID PENFILL CART.3ML",
  UCD7: '9255919',
  UCD13: '3400892559193',
  ucdQtyMultiplicator: 5,
  cipLib: "ACTRAPID PENFILL CART.3ML BT 5",
  atcCode: "A10AB01"
}, {
  CIP7: '3403856',
  CIP13: '3400934038563',
  ucdLib: "UMULINE RAPIDE 100UI C.3ML",
  UCD7: '9187299',
  UCD13: '3400891872996',
  ucdQtyMultiplicator: 5,
  cipLib: "UMULINE RAPIDE 100UI C.3ML BT 5",
  atcCode: "A10AB01"
}, {
  CIP7: '3352366',
  CIP13: '3400933523664',
  ucdLib: "UMULINE RAPIDE 100U/ML FL10ML",
  UCD7: '9215305',
  UCD13: '3400892153056',
  ucdQtyMultiplicator: 1,
  cipLib: "UMULINE RAPIDE 100U/ML FL10ML BT 1",
  atcCode: "A10AB01"
}, {
  CIP7: '3493552',
  CIP13: '3400934935527',
  ucdLib: "INSUMAN 100UI INFU 3,15ML",
  UCD7: '9212755',
  UCD13: '3400892127552',
  ucdQtyMultiplicator: 5,
  cipLib: "INSUMAN 100UI INFU 3,15ML BT 5",
  atcCode: "A10AB01"
}, {
  CIP7: '5857484',
  CIP13: '3400958574849',
  ucdLib: "INSUMAN 400UI IMPLAN. FL10ML",
  UCD7: '9404940',
  UCD13: '3400894049401',
  ucdQtyMultiplicator: 1,
  cipLib: "INSUMAN 400UI IMPLAN. FL10ML BT 1",
  atcCode: "A10AB01"
}, {
  CIP7: '3321466',
  CIP13: '3400933214661',
  ucdLib: "ENTECET CPR",
  UCD7: '9143511',
  UCD13: '3400891435115',
  ucdQtyMultiplicator: 60,
  cipLib: "ENTECET CPR BT 60",
  atcCode: "A09AA02"
}, {
  CIP7: '3001226',
  CIP13: '3400930012260',
  ucdLib: "EUROBIOL 12500U GELU",
  UCD7: '9411207',
  UCD13: '3400894112075',
  ucdQtyMultiplicator: 100,
  cipLib: "EUROBIOL 12500U GELU BT 100",
  atcCode: "A09AA02"
}, {
  CIP7: '3001222',
  CIP13: '3400930012222',
  ucdLib: "EUROBIOL 2500U/DOS GLE FL10G",
  UCD7: '9411213',
  UCD13: '3400894112136',
  ucdQtyMultiplicator: 1,
  cipLib: "EUROBIOL 2500U/DOS GLE FL10G BT 1",
  atcCode: "A09AA02"
}, {
  CIP7: '3001228',
  CIP13: '3400930012284',
  ucdLib: "EUROBIOL 40000U GELU",
  UCD7: '9411236',
  UCD13: '3400894112365',
  ucdQtyMultiplicator: 50,
  cipLib: "EUROBIOL 40000U GELU BT 50",
  atcCode: "A09AA02"
}, {
  CIP7: '3302693',
  CIP13: '3400933026936',
  ucdLib: "CREON 12000U GELU",
  UCD7: '9123069',
  UCD13: '3400891230697',
  ucdQtyMultiplicator: 100,
  cipLib: "CREON 12000U GELU BT 100",
  atcCode: "A09AA02"
}, {
  CIP7: '3677447',
  CIP13: '3400936774476',
  ucdLib: "EUROBIOL 12500U/DOS GLE FL20G",
  UCD7: '9281503',
  UCD13: '3400892815039',
  ucdQtyMultiplicator: 1,
  cipLib: "EUROBIOL 12500U/DOS GLE FL20G BT 1",
  atcCode: "A09AA02"
}, {
  CIP7: '5598893',
  CIP13: '3400955988939',
  ucdLib: "EUROBIOL 25000U GELU",
  UCD7: '9134222',
  UCD13: '3400891342222',
  ucdQtyMultiplicator: 100,
  cipLib: "EUROBIOL 25000U GELU BT 100",
  atcCode: "A09AA02"
}, {
  CIP7: '3369970',
  CIP13: '3400933699703',
  ucdLib: "PANCRELASE CPR",
  UCD7: '9067158',
  UCD13: '3400890671583',
  ucdQtyMultiplicator: 30,
  cipLib: "PANCRELASE CPR BT 30",
  atcCode: "A09AA02"
}, {
  CIP7: '3639642',
  CIP13: '3400936396425',
  ucdLib: "CREON 12000U GELU",
  UCD7: '9123069',
  UCD13: '3400891230697',
  ucdQtyMultiplicator: 60,
  cipLib: "CREON 12000U GELU BT 60",
  atcCode: "A09AA02"
}, {
  CIP7: '3639665',
  CIP13: '3400936396654',
  ucdLib: "CREON 12000U GELU",
  UCD7: '9123069',
  UCD13: '3400891230697',
  ucdQtyMultiplicator: 120,
  cipLib: "CREON 12000U GELU BT 120",
  atcCode: "A09AA02"
}, {
  CIP7: '3639553',
  CIP13: '3400936395534',
  ucdLib: "CREON 25000U GELU",
  UCD7: '9164967',
  UCD13: '3400891649673',
  ucdQtyMultiplicator: 60,
  cipLib: "CREON 25000U GELU BT 60",
  atcCode: "A09AA02"
}, {
  CIP7: '3953338',
  CIP13: '3400939533384',
  ucdLib: "EUROBIOL 25000U GELU",
  UCD7: '9134222',
  UCD13: '3400891342222',
  ucdQtyMultiplicator: 100,
  cipLib: "EUROBIOL 25000U GELU BT 100",
  atcCode: "A09AA02"
}, {
  CIP7: '2791365',
  CIP13: '3400927913655',
  ucdLib: "CREON 5000U GLE FL20G",
  UCD7: '9402823',
  UCD13: '3400894028239',
  ucdQtyMultiplicator: 1,
  cipLib: "CREON 5000U GLE FL20G BT 1",
  atcCode: "A09AA02"
}, {
  CIP7: '4950431',
  CIP13: '3400949504312',
  ucdLib: "XENICAL 120MG GELU ADP BBA",
  UCD7: '9394584',
  UCD13: '3400893945841',
  ucdQtyMultiplicator: 84,
  cipLib: "XENICAL 120MG GELU ADP BBA BT 84",
  atcCode: "A08AB01"
}, {
  CIP7: '4950170',
  CIP13: '3400949501700',
  ucdLib: "XENICAL 120MG GELU ADP MWI",
  UCD7: '9342831',
  UCD13: '3400893428313',
  ucdQtyMultiplicator: 84,
  cipLib: "XENICAL 120MG GELU ADP MWI BT 84",
  atcCode: "A08AB01"
}, {
  CIP7: '4950106',
  CIP13: '3400949501069',
  ucdLib: "XENICAL 120MG GELU ADP PLA",
  UCD7: '9337907',
  UCD13: '3400893379073',
  ucdQtyMultiplicator: 84,
  cipLib: "XENICAL 120MG GELU ADP PLA BT 84",
  atcCode: "A08AB01"
}, {
  CIP7: '3478096',
  CIP13: '3400934780967',
  ucdLib: "XENICAL 120MG GELU",
  UCD7: '9203621',
  UCD13: '3400892036212',
  ucdQtyMultiplicator: 84,
  cipLib: "XENICAL 120MG GELU BT 84",
  atcCode: "A08AB01"
}, {
  CIP7: '2193463',
  CIP13: '3400921934632',
  ucdLib: "ORLISTAT EG 120MG GELU",
  UCD7: '9387489',
  UCD13: '3400893874899',
  ucdQtyMultiplicator: 84,
  cipLib: "ORLISTAT EG 120MG GELU BT 84",
  atcCode: "A08AB01"
}, {
  CIP7: '3001652',
  CIP13: '3400930016527',
  ucdLib: "RACECADOTRIL BGC 100MG GELU",
  UCD7: '9412081',
  UCD13: '3400894120810',
  ucdQtyMultiplicator: 10,
  cipLib: "RACECADOTRIL BGC 100MG GELU BT 10",
  atcCode: "A07XA04"
}, {
  CIP7: '3001693',
  CIP13: '3400930016930',
  ucdLib: "RACECADOTRIL BGR 100MG GELU",
  UCD7: '9410260',
  UCD13: '3400894102601',
  ucdQtyMultiplicator: 20,
  cipLib: "RACECADOTRIL BGR 100MG GELU BT 20",
  atcCode: "A07XA04"
}, {
  CIP7: '3349677',
  CIP13: '3400933496777',
  ucdLib: "TIORFAN 100MG GELU",
  UCD7: '9157915',
  UCD13: '3400891579154',
  ucdQtyMultiplicator: 20,
  cipLib: "TIORFAN 100MG GELU BT 20",
  atcCode: "A07XA04"
}, {
  CIP7: '3521113',
  CIP13: '3400935211132',
  ucdLib: "TIORFAN 10MG BB. PDR SACH",
  UCD7: '9213714',
  UCD13: '3400892137148',
  ucdQtyMultiplicator: 16,
  cipLib: "TIORFAN 10MG BB. PDR SACH BT 16",
  atcCode: "A07XA04"
}, {
  CIP7: '3521142',
  CIP13: '3400935211422',
  ucdLib: "TIORFAN 30MG ENF PDR SACH",
  UCD7: '9213720',
  UCD13: '3400892137209',
  ucdQtyMultiplicator: 30,
  cipLib: "TIORFAN 30MG ENF PDR SACH BT 30",
  atcCode: "A07XA04"
}, {
  CIP7: '3820034',
  CIP13: '3400938200348',
  ucdLib: "TIORFANOR 175MG CPR",
  UCD7: '9314378',
  UCD13: '3400893143780',
  ucdQtyMultiplicator: 12,
  cipLib: "TIORFANOR 175MG CPR BT 12",
  atcCode: "A07XA04"
}, {
  CIP7: '3896161',
  CIP13: '3400938961614',
  ucdLib: "TIORFAST 100MG GELU",
  UCD7: '9323874',
  UCD13: '3400893238745',
  ucdQtyMultiplicator: 10,
  cipLib: "TIORFAST 100MG GELU BT 10",
  atcCode: "A07XA04"
}, {
  CIP7: '4921599',
  CIP13: '3400949215997',
  ucdLib: "DIARFIX 100MG GELU",
  UCD7: '9360875',
  UCD13: '3400893608753',
  ucdQtyMultiplicator: 10,
  cipLib: "DIARFIX 100MG GELU BT 10",
  atcCode: "A07XA04"
}, {
  CIP7: '3110019',
  CIP13: '3400931100195',
  ucdLib: "ULTRA-LEVURE 50MG GELU",
  UCD7: '9096332',
  UCD13: '3400890963329',
  ucdQtyMultiplicator: 20,
  cipLib: "ULTRA-LEVURE 50MG GELU BT 20",
  atcCode: "A07FA02"
}, {
  CIP7: '3259885',
  CIP13: '3400932598854',
  ucdLib: "ULTRA-LEVURE 50MG GELU",
  UCD7: '9096332',
  UCD13: '3400890963329',
  ucdQtyMultiplicator: 50,
  cipLib: "ULTRA-LEVURE 50MG GELU BT 50",
  atcCode: "A07FA02"
}, {
  CIP7: '3437944',
  CIP13: '3400934379444',
  ucdLib: "ULTRA-LEVURE 100MG PDR SACH",
  UCD7: '9280722',
  UCD13: '3400892807225',
  ucdQtyMultiplicator: 20,
  cipLib: "ULTRA-LEVURE 100MG PDR SACH BT 20",
  atcCode: "A07FA02"
}, {
  CIP7: '3760740',
  CIP13: '3400937607407',
  ucdLib: "ULTRA-LEVURE 200MG GELU",
  UCD7: '9280739',
  UCD13: '3400892807393',
  ucdQtyMultiplicator: 30,
  cipLib: "ULTRA-LEVURE 200MG GELU BT 30",
  atcCode: "A07FA02"
}, {
  CIP7: '2209661',
  CIP13: '3400922096612',
  ucdLib: "ULTRA-LEVURE 200MG GELU",
  UCD7: '9280739',
  UCD13: '3400892807393',
  ucdQtyMultiplicator: 10,
  cipLib: "ULTRA-LEVURE 200MG GELU BT 10",
  atcCode: "A07FA02"
}, {
  CIP7: '5524541',
  CIP13: '3400955245414',
  ucdLib: "ULTRA-LEVURE 50MG GELU",
  UCD7: '9096332',
  UCD13: '3400890963329',
  ucdQtyMultiplicator: 200,
  cipLib: "ULTRA-LEVURE 50MG GELU BT 200",
  atcCode: "A07FA02"
}, {
  CIP7: '3307360',
  CIP13: '3400933073602',
  ucdLib: "LACTEOL 340MG BUV SACH",
  UCD7: '9135799',
  UCD13: '3400891357998',
  ucdQtyMultiplicator: 10,
  cipLib: "LACTEOL 340MG BUV SACH BT 10",
  atcCode: "A07FA01"
}, {
  CIP7: '3484783',
  CIP13: '3400934847837',
  ucdLib: "LACTEOL 340MG GELU",
  UCD7: '9283933',
  UCD13: '3400892839332',
  ucdQtyMultiplicator: 10,
  cipLib: "LACTEOL 340MG GELU BT 10",
  atcCode: "A07FA01"
}, {
  CIP7: '3465515',
  CIP13: '3400934655159',
  ucdLib: "BACILOR BUV PDR SACH",
  UCD7: '9211365',
  UCD13: '3400892113654',
  ucdQtyMultiplicator: 10,
  cipLib: "BACILOR BUV PDR SACH BT 10",
  atcCode: "A07FA01"
}, {
  CIP7: '3153313',
  CIP13: '3400931533139',
  ucdLib: "LYO-BIFIDUS PDR SACH",
  UCD7: '9055528',
  UCD13: '3400890555289',
  ucdQtyMultiplicator: 6,
  cipLib: "LYO-BIFIDUS PDR SACH BT 6",
  atcCode: "A07FA01"
}, {
  CIP7: '3479612',
  CIP13: '3400934796128',
  ucdLib: "BACILOR GELU",
  UCD7: '9204158',
  UCD13: '3400892041582',
  ucdQtyMultiplicator: 20,
  cipLib: "BACILOR GELU BT 20",
  atcCode: "A07FA01"
}, {
  CIP7: '3807022',
  CIP13: '3400938070224',
  ucdLib: "LACTEOL 340MG GELU",
  UCD7: '9283933',
  UCD13: '3400892839332',
  ucdQtyMultiplicator: 30,
  cipLib: "LACTEOL 340MG GELU BT 30",
  atcCode: "A07FA01"
}, {
  CIP7: '3330407',
  CIP13: '3400933304072',
  ucdLib: "DIPENTUM 250MG GELU",
  UCD7: '9152148',
  UCD13: '3400891521481',
  ucdQtyMultiplicator: 100,
  cipLib: "DIPENTUM 250MG GELU BT 100",
  atcCode: "A07EC03"
}, {
  CIP7: '3394028',
  CIP13: '3400933940287',
  ucdLib: "DIPENTUM 500MG CPR",
  UCD7: '9208274',
  UCD13: '3400892082745',
  ucdQtyMultiplicator: 60,
  cipLib: "DIPENTUM 500MG CPR BT 60",
  atcCode: "A07EC03"
}, {
  CIP7: '3327888',
  CIP13: '3400933278885',
  ucdLib: "PENTASA 500MG CPR",
  UCD7: '9146716',
  UCD13: '3400891467161',
  ucdQtyMultiplicator: 100,
  cipLib: "PENTASA 500MG CPR BT 100",
  atcCode: "A07EC02"
}, {
  CIP7: '3293474',
  CIP13: '3400932934744',
  ucdLib: "PENTASA 1G RECT SUSP FP100ML",
  UCD7: '9128055',
  UCD13: '3400891280555',
  ucdQtyMultiplicator: 5,
  cipLib: "PENTASA 1G RECT SUSP FP100ML BT 5",
  atcCode: "A07EC02"
}, {
  CIP7: '3338254',
  CIP13: '3400933382544',
  ucdLib: "ROWASA 250MG CPR",
  UCD7: '9158665',
  UCD13: '3400891586657',
  ucdQtyMultiplicator: 90,
  cipLib: "ROWASA 250MG CPR BT 90",
  atcCode: "A07EC02"
}, {
  CIP7: '3338231',
  CIP13: '3400933382315',
  ucdLib: "ROWASA 500MG CPR",
  UCD7: '9158671',
  UCD13: '3400891586718',
  ucdQtyMultiplicator: 90,
  cipLib: "ROWASA 500MG CPR BT 90",
  atcCode: "A07EC02"
}, {
  CIP7: '4985843',
  CIP13: '3400949858439',
  ucdLib: "PENTASA 1G CPR",
  UCD7: '9371666',
  UCD13: '3400893716663',
  ucdQtyMultiplicator: 60,
  cipLib: "PENTASA 1G CPR BT 60",
  atcCode: "A07EC02"
}, {
  CIP7: '3350284',
  CIP13: '3400933502843',
  ucdLib: "PENTASA 1G SUP",
  UCD7: '9158197',
  UCD13: '3400891581973',
  ucdQtyMultiplicator: 15,
  cipLib: "PENTASA 1G SUP BT 15",
  atcCode: "A07EC02"
}, {
  CIP7: '3675879',
  CIP13: '3400936758797',
  ucdLib: "PENTASA 2G GLE SACH",
  UCD7: '9269637',
  UCD13: '3400892696379',
  ucdQtyMultiplicator: 60,
  cipLib: "PENTASA 2G GLE SACH BT 60",
  atcCode: "A07EC02"
}, {
  CIP7: '3350367',
  CIP13: '3400933503673',
  ucdLib: "ROWASA 500MG SUP",
  UCD7: '9159653',
  UCD13: '3400891596533',
  ucdQtyMultiplicator: 15,
  cipLib: "ROWASA 500MG SUP BT 15",
  atcCode: "A07EC02"
}, {
  CIP7: '3350373',
  CIP13: '3400933503734',
  ucdLib: "ROWASA 500MG SUP",
  UCD7: '9159653',
  UCD13: '3400891596533',
  ucdQtyMultiplicator: 30,
  cipLib: "ROWASA 500MG SUP BT 30",
  atcCode: "A07EC02"
}, {
  CIP7: '3588117',
  CIP13: '3400935881175',
  ucdLib: "FIVASA 500MG SUP",
  UCD7: '9237169',
  UCD13: '3400892371696',
  ucdQtyMultiplicator: 30,
  cipLib: "FIVASA 500MG SUP BT 30",
  atcCode: "A07EC02"
}, {
  CIP7: '3585685',
  CIP13: '3400935856852',
  ucdLib: "FIVASA 800MG CPR",
  UCD7: '9238499',
  UCD13: '3400892384993',
  ucdQtyMultiplicator: 90,
  cipLib: "FIVASA 800MG CPR BT 90",
  atcCode: "A07EC02"
}, {
  CIP7: '3478618',
  CIP13: '3400934786181',
  ucdLib: "FIVASA 400MG CPR",
  UCD7: '9219036',
  UCD13: '3400892190365',
  ucdQtyMultiplicator: 100,
  cipLib: "FIVASA 400MG CPR BT 100",
  atcCode: "A07EC02"
}, {
  CIP7: '3442477',
  CIP13: '3400934424779',
  ucdLib: "PENTASA 1G GLE SACH",
  UCD7: '9199316',
  UCD13: '3400891993165',
  ucdQtyMultiplicator: 120,
  cipLib: "PENTASA 1G GLE SACH BT 120",
  atcCode: "A07EC02"
}, {
  CIP7: '3226880',
  CIP13: '3400932268801',
  ucdLib: "SALAZOPYRINE 500MG CPR",
  UCD7: '9081885',
  UCD13: '3400890818858',
  ucdQtyMultiplicator: 100,
  cipLib: "SALAZOPYRINE 500MG CPR BT 100",
  atcCode: "A07EC01"
}, {
  CIP7: '3275708',
  CIP13: '3400932757084',
  ucdLib: "INTERCRON BUV AMP5ML",
  UCD7: '9171683',
  UCD13: '3400891716832',
  ucdQtyMultiplicator: 30,
  cipLib: "INTERCRON BUV AMP5ML BT 30",
  atcCode: "A07EB01"
}, {
  CIP7: '3569261',
  CIP13: '3400935692610',
  ucdLib: "MIKICORT 3MG GELU",
  UCD7: '9293937',
  UCD13: '3400892939377',
  ucdQtyMultiplicator: 50,
  cipLib: "MIKICORT 3MG GELU BT 50",
  atcCode: "A07EA06"
}, {
  CIP7: '3569278',
  CIP13: '3400935692788',
  ucdLib: "MIKICORT 3MG GELU",
  UCD7: '9293937',
  UCD13: '3400892939377',
  ucdQtyMultiplicator: 90,
  cipLib: "MIKICORT 3MG GELU BT 90",
  atcCode: "A07EA06"
}, {
  CIP7: '3414771',
  CIP13: '3400934147715',
  ucdLib: "ENTOCORT 3MG GELU",
  UCD7: '9188212',
  UCD13: '3400891882124',
  ucdQtyMultiplicator: 45,
  cipLib: "ENTOCORT 3MG GELU BT 45",
  atcCode: "A07EA06"
}, {
  CIP7: '3414788',
  CIP13: '3400934147883',
  ucdLib: "ENTOCORT 3MG GELU",
  UCD7: '9188212',
  UCD13: '3400891882124',
  ucdQtyMultiplicator: 90,
  cipLib: "ENTOCORT 3MG GELU BT 90",
  atcCode: "A07EA06"
}, {
  CIP7: '3010996',
  CIP13: '3400930109960',
  ucdLib: "BETNESOL 5MG RECT POC 100ML",
  UCD7: '9010520',
  UCD13: '3400890105200',
  ucdQtyMultiplicator: 1,
  cipLib: "BETNESOL 5MG RECT POC 100ML BT 1",
  atcCode: "A07EA04"
}, {
  CIP7: '3260612',
  CIP13: '3400932606122',
  ucdLib: "COLOFOAM MOUSS RECT PRESS 20G",
  UCD7: '9021386',
  UCD13: '3400890213868',
  ucdQtyMultiplicator: 1,
  cipLib: "COLOFOAM MOUSS RECT PRESS 20G BT 1",
  atcCode: "A07EA02"
}, {
  CIP7: '3788201',
  CIP13: '3400937882019',
  ucdLib: "IMODIUMDUO CPR",
  UCD7: '9304931',
  UCD13: '3400893049310',
  ucdQtyMultiplicator: 8,
  cipLib: "IMODIUMDUO CPR BT 8",
  atcCode: "A07DA53"
}, {
  CIP7: '3398173',
  CIP13: '3400933981730',
  ucdLib: "ARESTAL 1MG CPR",
  UCD7: '9184450',
  UCD13: '3400891844504',
  ucdQtyMultiplicator: 20,
  cipLib: "ARESTAL 1MG CPR BT 20",
  atcCode: "A07DA05"
}, {
  CIP7: '3456835',
  CIP13: '3400934568350',
  ucdLib: "LOPERAMIDE EGL 2MG GELU",
  UCD7: '9202426',
  UCD13: '3400892024264',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE EGL 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3830682',
  CIP13: '3400938306828',
  ucdLib: "LOPERAMIDE CRT 2MG GELU",
  UCD7: '9334607',
  UCD13: '3400893346075',
  ucdQtyMultiplicator: 12,
  cipLib: "LOPERAMIDE CRT 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3377573',
  CIP13: '3400933775735',
  ucdLib: "LOPERAMIDE RPG 2MG GELU",
  UCD7: '9180699',
  UCD13: '3400891806991',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE RPG 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3430988',
  CIP13: '3400934309885',
  ucdLib: "LOPERAMIDE SDZ 2MG GELU",
  UCD7: '9195933',
  UCD13: '3400891959338',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE SDZ 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3436169',
  CIP13: '3400934361692',
  ucdLib: "LOPERAMIDE TVC 2MG CPR",
  UCD7: '9195583',
  UCD13: '3400891955835',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE TVC 2MG CPR BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3356677',
  CIP13: '3400933566777',
  ucdLib: "LOPERAMIDE ZEN 2MG GELU",
  UCD7: '9167368',
  UCD13: '3400891673685',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE ZEN 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3857190',
  CIP13: '3400938571905',
  ucdLib: "IMODIUMCAPS 2MG GELU",
  UCD7: '9318206',
  UCD13: '3400893182062',
  ucdQtyMultiplicator: 12,
  cipLib: "IMODIUMCAPS 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3556672',
  CIP13: '3400935566720',
  ucdLib: "LOPERAMIDE ZYD 2MG GELU",
  UCD7: '9228934',
  UCD13: '3400892289342',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE ZYD 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3595471',
  CIP13: '3400935954718',
  ucdLib: "LOPERAMIDE ARW 2MG GELU",
  UCD7: '9241573',
  UCD13: '3400892415734',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE ARW 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3514739',
  CIP13: '3400935147394',
  ucdLib: "LOPERAMIDE LYOC 2MG LYOT",
  UCD7: '9223256',
  UCD13: '3400892232560',
  ucdQtyMultiplicator: 10,
  cipLib: "LOPERAMIDE LYOC 2MG LYOT BT 10",
  atcCode: "A07DA03"
}, {
  CIP7: '3482896',
  CIP13: '3400934828966',
  ucdLib: "LOPERAMIDE MYL 2MG GELU",
  UCD7: '9209931',
  UCD13: '3400892099316',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE MYL 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3584214',
  CIP13: '3400935842145',
  ucdLib: "DIARETYL 2MG GELU",
  UCD7: '9197412',
  UCD13: '3400891974126',
  ucdQtyMultiplicator: 12,
  cipLib: "DIARETYL 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3188659',
  CIP13: '3400931886594',
  ucdLib: "IMODIUM 0,2MG/ML BUV FL90ML",
  UCD7: '9045978',
  UCD13: '3400890459785',
  ucdQtyMultiplicator: 1,
  cipLib: "IMODIUM 0,2MG/ML BUV FL90ML BT 1",
  atcCode: "A07DA03"
}, {
  CIP7: '3188607',
  CIP13: '3400931886075',
  ucdLib: "IMODIUM 2MG GELU",
  UCD7: '9045961',
  UCD13: '3400890459617',
  ucdQtyMultiplicator: 20,
  cipLib: "IMODIUM 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3740832',
  CIP13: '3400937408325',
  ucdLib: "DIASTROLIB 2MG LYOT ORAL",
  UCD7: '9377864',
  UCD13: '3400893778647',
  ucdQtyMultiplicator: 10,
  cipLib: "DIASTROLIB 2MG LYOT ORAL BT 10",
  atcCode: "A07DA03"
}, {
  CIP7: '3666679',
  CIP13: '3400936666795',
  ucdLib: "IMODIUMLINGUAL 2MG LYOT",
  UCD7: '9277832',
  UCD13: '3400892778327',
  ucdQtyMultiplicator: 12,
  cipLib: "IMODIUMLINGUAL 2MG LYOT BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3695250',
  CIP13: '3400936952508',
  ucdLib: "LOPERAMIDE AWC 2MG GELU",
  UCD7: '9286127',
  UCD13: '3400892861272',
  ucdQtyMultiplicator: 12,
  cipLib: "LOPERAMIDE AWC 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3496622',
  CIP13: '3400934966224',
  ucdLib: "ERCESTOP 2MG GELU",
  UCD7: '9222593',
  UCD13: '3400892225937',
  ucdQtyMultiplicator: 12,
  cipLib: "ERCESTOP 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3496705',
  CIP13: '3400934967054',
  ucdLib: "INDIARAL 2MG GELU",
  UCD7: '9182362',
  UCD13: '3400891823622',
  ucdQtyMultiplicator: 12,
  cipLib: "INDIARAL 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3797370',
  CIP13: '3400937973700',
  ucdLib: "LOPERAMIDE SDC 2MG GELU",
  UCD7: '9307941',
  UCD13: '3400893079416',
  ucdQtyMultiplicator: 12,
  cipLib: "LOPERAMIDE SDC 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3823506',
  CIP13: '3400938235067',
  ucdLib: "LOPERAMIDE TCO 2MG GELU",
  UCD7: '9312706',
  UCD13: '3400893127063',
  ucdQtyMultiplicator: 12,
  cipLib: "LOPERAMIDE TCO 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3496639',
  CIP13: '3400934966392',
  ucdLib: "PERACEL 2MG GELU",
  UCD7: '9178478',
  UCD13: '3400891784787',
  ucdQtyMultiplicator: 12,
  cipLib: "PERACEL 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '3870782',
  CIP13: '3400938707823',
  ucdLib: "GASTROWELL LOPERA.2MG GELU",
  UCD7: '9211224',
  UCD13: '3400892112244',
  ucdQtyMultiplicator: 12,
  cipLib: "GASTROWELL LOPERA.2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '4971002',
  CIP13: '3400949710027',
  ucdLib: "LOPERAMIDE ALM 2MG GELU",
  UCD7: '9364873',
  UCD13: '3400893648735',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE ALM 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3935524',
  CIP13: '3400939355245',
  ucdLib: "LOPERAMIDE ZYF 2MG GELU",
  UCD7: '9368405',
  UCD13: '3400893684054',
  ucdQtyMultiplicator: 12,
  cipLib: "LOPERAMIDE ZYF 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '2661585',
  CIP13: '3400926615857',
  ucdLib: "LOPERAMIDE MYP 2MG GELU",
  UCD7: '9236218',
  UCD13: '3400892362182',
  ucdQtyMultiplicator: 12,
  cipLib: "LOPERAMIDE MYP 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '2180101',
  CIP13: '3400921801019',
  ucdLib: "IMODIUMLIQUICAPS 2MG CAPS",
  UCD7: '9387992',
  UCD13: '3400893879924',
  ucdQtyMultiplicator: 12,
  cipLib: "IMODIUMLIQUICAPS 2MG CAPS BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '5755453',
  CIP13: '3400957554538',
  ucdLib: "LOPERAMIDE ARW 2MG GELU",
  UCD7: '9241573',
  UCD13: '3400892415734',
  ucdQtyMultiplicator: 30,
  cipLib: "LOPERAMIDE ARW 2MG GELU BT 30",
  atcCode: "A07DA03"
}, {
  CIP7: '4168127',
  CIP13: '3400941681271',
  ucdLib: "LOPERAMIDE BGA 2MG GELU",
  UCD7: '9374038',
  UCD13: '3400893740385',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE BGA 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '2244717',
  CIP13: '3400922447179',
  ucdLib: "LOPERAMIDE BGC 2MG GELU",
  UCD7: '9388371',
  UCD13: '3400893883716',
  ucdQtyMultiplicator: 12,
  cipLib: "LOPERAMIDE BGC 2MG GELU BT 12",
  atcCode: "A07DA03"
}, {
  CIP7: '2226671',
  CIP13: '3400922266718',
  ucdLib: "LOPERAMIDE EVO 2MG GELU",
  UCD7: '9386343',
  UCD13: '3400893863435',
  ucdQtyMultiplicator: 20,
  cipLib: "LOPERAMIDE EVO 2MG GELU BT 20",
  atcCode: "A07DA03"
}, {
  CIP7: '3042855',
  CIP13: '3400930428559',
  ucdLib: "GASTROPULGITE BUV PDR SACH",
  UCD7: '9037619',
  UCD13: '3400890376198',
  ucdQtyMultiplicator: 30,
  cipLib: "GASTROPULGITE BUV PDR SACH BT 30",
  atcCode: "A07BC54"
}, {
  CIP7: '3043228',
  CIP13: '3400930432280',
  ucdLib: "GELOPECTOSE PDR BT120G",
  UCD7: '9037789',
  UCD13: '3400890377898',
  ucdQtyMultiplicator: 1,
  cipLib: "GELOPECTOSE PDR BT120G BT 1",
  atcCode: "A07BC30"
}, {
  CIP7: '3000790',
  CIP13: '3400930007907',
  ucdLib: "SMECTA 3G FRAISE BUV SACH",
  UCD7: '9411621',
  UCD13: '3400894116219',
  ucdQtyMultiplicator: 12,
  cipLib: "SMECTA 3G FRAISE BUV SACH BT 12",
  atcCode: "A07BC05"
}, {
  CIP7: '3000787',
  CIP13: '3400930007877',
  ucdLib: "SMECTALIA 3G BUV SACH10G",
  UCD7: '9412655',
  UCD13: '3400894126553',
  ucdQtyMultiplicator: 12,
  cipLib: "SMECTALIA 3G BUV SACH10G BT 12",
  atcCode: "A07BC05"
}, {
  CIP7: '3192307',
  CIP13: '3400931923077',
  ucdLib: "SMECTA 3G ORAN-VANI BUV SACH",
  UCD7: '9084228',
  UCD13: '3400890842280',
  ucdQtyMultiplicator: 30,
  cipLib: "SMECTA 3G ORAN-VANI BUV SACH BT 30",
  atcCode: "A07BC05"
}, {
  CIP7: '3192313',
  CIP13: '3400931923138',
  ucdLib: "SMECTA 3G ORAN-VANI BUV SACH",
  UCD7: '9084228',
  UCD13: '3400890842280',
  ucdQtyMultiplicator: 60,
  cipLib: "SMECTA 3G ORAN-VANI BUV SACH BT 60",
  atcCode: "A07BC05"
}, {
  CIP7: '2754714',
  CIP13: '3400927547140',
  ucdLib: "DIOSMECTITE MYL 3G BUV SACH",
  UCD7: '9353183',
  UCD13: '3400893531839',
  ucdQtyMultiplicator: 18,
  cipLib: "DIOSMECTITE MYL 3G BUV SACH BT 18",
  atcCode: "A07BC05"
}, {
  CIP7: '3948225',
  CIP13: '3400939482255',
  ucdLib: "DIOSMECTITE MYL 3G BUV SACH",
  UCD7: '9353183',
  UCD13: '3400893531839',
  ucdQtyMultiplicator: 30,
  cipLib: "DIOSMECTITE MYL 3G BUV SACH BT 30",
  atcCode: "A07BC05"
}, {
  CIP7: '4931379',
  CIP13: '3400949313792',
  ucdLib: "SMECTALIA 3G BUV SACH3,76G",
  UCD7: '9353438',
  UCD13: '3400893534380',
  ucdQtyMultiplicator: 18,
  cipLib: "SMECTALIA 3G BUV SACH3,76G BT 18",
  atcCode: "A07BC05"
}, {
  CIP7: '2791589',
  CIP13: '3400927915895',
  ucdLib: "SMECTA 3G ORAN-VANI BUV SACH",
  UCD7: '9084228',
  UCD13: '3400890842280',
  ucdQtyMultiplicator: 18,
  cipLib: "SMECTA 3G ORAN-VANI BUV SACH BT 18",
  atcCode: "A07BC05"
}, {
  CIP7: '3000549',
  CIP13: '3400930005491',
  ucdLib: "ACTAPULGITE 3G PDR SACH",
  UCD7: '9000639',
  UCD13: '3400890006392',
  ucdQtyMultiplicator: 30,
  cipLib: "ACTAPULGITE 3G PDR SACH BT 30",
  atcCode: "A07BC04"
}, {
  CIP7: '3075292',
  CIP13: '3400930752920',
  ucdLib: "BOLINAN 2G CPR",
  UCD7: '9012016',
  UCD13: '3400890120166',
  ucdQtyMultiplicator: 15,
  cipLib: "BOLINAN 2G CPR BT 15",
  atcCode: "A07BC03"
}, {
  CIP7: '3144490',
  CIP13: '3400931444909',
  ucdLib: "BOLINAN 2G CPR",
  UCD7: '9012016',
  UCD13: '3400890120166',
  ucdQtyMultiplicator: 40,
  cipLib: "BOLINAN 2G CPR BT 40",
  atcCode: "A07BC03"
}, {
  CIP7: '3006061',
  CIP13: '3400930060612',
  ucdLib: "CARBOLEVURE ENF GELU",
  UCD7: '9016190',
  UCD13: '3400890161909',
  ucdQtyMultiplicator: 20,
  cipLib: "CARBOLEVURE ENF GELU BT 20",
  atcCode: "A07BA51"
}, {
  CIP7: '3295438',
  CIP13: '3400932954384',
  ucdLib: "CARBOSYLANE ENF GELU DOS",
  UCD7: '9176479',
  UCD13: '3400891764796',
  ucdQtyMultiplicator: 48,
  cipLib: "CARBOSYLANE ENF GELU DOS BT 48",
  atcCode: "A07BA51"
}, {
  CIP7: '3299548',
  CIP13: '3400932995486',
  ucdLib: "CARBOSYLANE ENF GELU DOS",
  UCD7: '9176479',
  UCD13: '3400891764796',
  ucdQtyMultiplicator: 24,
  cipLib: "CARBOSYLANE ENF GELU DOS BT 24",
  atcCode: "A07BA51"
}, {
  CIP7: '3272443',
  CIP13: '3400932724437',
  ucdLib: "CARBOSYLANE GELU + GELU",
  UCD7: '9016416',
  UCD13: '3400890164160',
  ucdQtyMultiplicator: 48,
  cipLib: "CARBOSYLANE GELU + GELU BT 48",
  atcCode: "A07BA51"
}, {
  CIP7: '3273129',
  CIP13: '3400932731299',
  ucdLib: "CARBOSYLANE GELU + GELU",
  UCD7: '9016416',
  UCD13: '3400890164160',
  ucdQtyMultiplicator: 24,
  cipLib: "CARBOSYLANE GELU + GELU BT 24",
  atcCode: "A07BA51"
}, {
  CIP7: '3309293',
  CIP13: '3400933092931',
  ucdLib: "CARBOLEVURE AD. GELU",
  UCD7: '9016184',
  UCD13: '3400890161848',
  ucdQtyMultiplicator: 30,
  cipLib: "CARBOLEVURE AD. GELU BT 30",
  atcCode: "A07BA51"
}, {
  CIP7: '3431278',
  CIP13: '3400934312786',
  ucdLib: "ACTICARBINE CPR",
  UCD7: '9000705',
  UCD13: '3400890007054',
  ucdQtyMultiplicator: 42,
  cipLib: "ACTICARBINE CPR BT 42",
  atcCode: "A07BA51"
}, {
  CIP7: '3431290',
  CIP13: '3400934312908',
  ucdLib: "ACTICARBINE CPR",
  UCD7: '9000705',
  UCD13: '3400890007054',
  ucdQtyMultiplicator: 84,
  cipLib: "ACTICARBINE CPR BT 84",
  atcCode: "A07BA51"
}, {
  CIP7: '3490370',
  CIP13: '3400934903700',
  ucdLib: "CARBOSYMAG GELU+GELU",
  UCD7: '9223150',
  UCD13: '3400892231501',
  ucdQtyMultiplicator: 24,
  cipLib: "CARBOSYMAG GELU+GELU BT 24",
  atcCode: "A07BA51"
}, {
  CIP7: '3490387',
  CIP13: '3400934903878',
  ucdLib: "CARBOSYMAG GELU+GELU",
  UCD7: '9223150',
  UCD13: '3400892231501',
  ucdQtyMultiplicator: 48,
  cipLib: "CARBOSYMAG GELU+GELU BT 48",
  atcCode: "A07BA51"
}, {
  CIP7: '3298514',
  CIP13: '3400932985142',
  ucdLib: "CARBOMIX 50G BUV GLE FP500ML",
  UCD7: '9124726',
  UCD13: '3400891247268',
  ucdQtyMultiplicator: 1,
  cipLib: "CARBOMIX 50G BUV GLE FP500ML BT 1",
  atcCode: "A07BA01"
}, {
  CIP7: '3041092',
  CIP13: '3400930410929',
  ucdLib: "FORMOCARBINE 15% GLE SACH100G",
  UCD7: '9036100',
  UCD13: '3400890361002',
  ucdQtyMultiplicator: 1,
  cipLib: "FORMOCARBINE 15% GLE SACH100G BT 1",
  atcCode: "A07BA01"
}, {
  CIP7: '3099157',
  CIP13: '3400930991572',
  ucdLib: "SPLENOCARBINE 17% GLE BT100G",
  UCD7: '9087209',
  UCD13: '3400890872096',
  ucdQtyMultiplicator: 1,
  cipLib: "SPLENOCARBINE 17% GLE BT100G BT 1",
  atcCode: "A07BA01"
}, {
  CIP7: '3350249',
  CIP13: '3400933502492',
  ucdLib: "ARKOGELULES CHARBON VEG",
  UCD7: '9155106',
  UCD13: '3400891551068',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES CHARBON VEG BT 45",
  atcCode: "A07BA01"
}, {
  CIP7: '3350255',
  CIP13: '3400933502553',
  ucdLib: "ARKOGELULES CHARBON VEG",
  UCD7: '9155106',
  UCD13: '3400891551068',
  ucdQtyMultiplicator: 150,
  cipLib: "ARKOGELULES CHARBON VEG BT 150",
  atcCode: "A07BA01"
}, {
  CIP7: '3358601',
  CIP13: '3400933586010',
  ucdLib: "CARBACTIVE 120MG GELU",
  UCD7: '9172412',
  UCD13: '3400891724127',
  ucdQtyMultiplicator: 30,
  cipLib: "CARBACTIVE 120MG GELU BT 30",
  atcCode: "A07BA01"
}, {
  CIP7: '3544893',
  CIP13: '3400935448934',
  ucdLib: "TOXICARB BUV FL250ML",
  UCD7: '9241449',
  UCD13: '3400892414492',
  ucdQtyMultiplicator: 1,
  cipLib: "TOXICARB BUV FL250ML BT 1",
  atcCode: "A07BA01"
}, {
  CIP7: '3544887',
  CIP13: '3400935448873',
  ucdLib: "TOXICARB BUV FL60ML",
  UCD7: '9241455',
  UCD13: '3400892414553',
  ucdQtyMultiplicator: 1,
  cipLib: "TOXICARB BUV FL60ML BT 1",
  atcCode: "A07BA01"
}, {
  CIP7: '3508638',
  CIP13: '3400935086389',
  ucdLib: "CHARBON BELLOC 125MG CAPS",
  UCD7: '9213536',
  UCD13: '3400892135366',
  ucdQtyMultiplicator: 36,
  cipLib: "CHARBON BELLOC 125MG CAPS BT 36",
  atcCode: "A07BA01"
}, {
  CIP7: '3611744',
  CIP13: '3400936117440',
  ucdLib: "NIFUROXAZIDE TVC 200MG GELU",
  UCD7: '9245252',
  UCD13: '3400892452524',
  ucdQtyMultiplicator: 28,
  cipLib: "NIFUROXAZIDE TVC 200MG GELU BT 28",
  atcCode: "A07AX03"
}, {
  CIP7: '3275588',
  CIP13: '3400932755882',
  ucdLib: "PANFUREX 200MG GELU",
  UCD7: '9124057',
  UCD13: '3400891240573',
  ucdQtyMultiplicator: 28,
  cipLib: "PANFUREX 200MG GELU BT 28",
  atcCode: "A07AX03"
}, {
  CIP7: '3275594',
  CIP13: '3400932755943',
  ucdLib: "PANFUREX 4% BUV FL90ML",
  UCD7: '9129623',
  UCD13: '3400891296235',
  ucdQtyMultiplicator: 1,
  cipLib: "PANFUREX 4% BUV FL90ML BT 1",
  atcCode: "A07AX03"
}, {
  CIP7: '3674696',
  CIP13: '3400936746961',
  ucdLib: "NIFUROXAZIDE ZEN 200MG GELU",
  UCD7: '9270126',
  UCD13: '3400892701264',
  ucdQtyMultiplicator: 28,
  cipLib: "NIFUROXAZIDE ZEN 200MG GELU BT 28",
  atcCode: "A07AX03"
}, {
  CIP7: '3857178',
  CIP13: '3400938571783',
  ucdLib: "IMOSEPTYL 200MG GELU",
  UCD7: '9321378',
  UCD13: '3400893213780',
  ucdQtyMultiplicator: 12,
  cipLib: "IMOSEPTYL 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3851193',
  CIP13: '3400938511932',
  ucdLib: "NIFUROXAZIDE AWC 200MG GELU",
  UCD7: '9298283',
  UCD13: '3400892982830',
  ucdQtyMultiplicator: 12,
  cipLib: "NIFUROXAZIDE AWC 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3595873',
  CIP13: '3400935958730',
  ucdLib: "BACTERIX 200MG GELU",
  UCD7: '9248196',
  UCD13: '3400892481968',
  ucdQtyMultiplicator: 12,
  cipLib: "BACTERIX 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3659679',
  CIP13: '3400936596795',
  ucdLib: "NIFUROXAZIDE SDZ 200MG GELU",
  UCD7: '9264048',
  UCD13: '3400892640488',
  ucdQtyMultiplicator: 28,
  cipLib: "NIFUROXAZIDE SDZ 200MG GELU BT 28",
  atcCode: "A07AX03"
}, {
  CIP7: '3548891',
  CIP13: '3400935488916',
  ucdLib: "DIAFURYL 200MG GELU",
  UCD7: '9271686',
  UCD13: '3400892716862',
  ucdQtyMultiplicator: 12,
  cipLib: "DIAFURYL 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3540518',
  CIP13: '3400935405180',
  ucdLib: "NIFUROXAZIDE BGA 200MG GELU",
  UCD7: '9220631',
  UCD13: '3400892206318',
  ucdQtyMultiplicator: 28,
  cipLib: "NIFUROXAZIDE BGA 200MG GELU BT 28",
  atcCode: "A07AX03"
}, {
  CIP7: '3811259',
  CIP13: '3400938112597',
  ucdLib: "ERCEFURYL 200MG GELU",
  UCD7: '9031976',
  UCD13: '3400890319768',
  ucdQtyMultiplicator: 12,
  cipLib: "ERCEFURYL 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3748408',
  CIP13: '3400937484084',
  ucdLib: "NIFUROXAZIDE SDC 200MG GELU",
  UCD7: '9292895',
  UCD13: '3400892928951',
  ucdQtyMultiplicator: 12,
  cipLib: "NIFUROXAZIDE SDC 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3823156',
  CIP13: '3400938231564',
  ucdLib: "NIFUROXAZIDE MYL 200MG GELU",
  UCD7: '9213252',
  UCD13: '3400892132525',
  ucdQtyMultiplicator: 12,
  cipLib: "NIFUROXAZIDE MYL 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3477458',
  CIP13: '3400934774584',
  ucdLib: "PANFURYL 200MG GELU",
  UCD7: '9341151',
  UCD13: '3400893411513',
  ucdQtyMultiplicator: 12,
  cipLib: "PANFURYL 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3923202',
  CIP13: '3400939232027',
  ucdLib: "NIFUROXAZIDE CRT 200MG GELU",
  UCD7: '9336983',
  UCD13: '3400893369838',
  ucdQtyMultiplicator: 12,
  cipLib: "NIFUROXAZIDE CRT 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3927246',
  CIP13: '3400939272467',
  ucdLib: "NIFUROXAZIDE EGC 200MG GELU",
  UCD7: '9223262',
  UCD13: '3400892232621',
  ucdQtyMultiplicator: 12,
  cipLib: "NIFUROXAZIDE EGC 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3873272',
  CIP13: '3400938732726',
  ucdLib: "NIFUROXAZIDE ZYD 200MG GELU",
  UCD7: '9210905',
  UCD13: '3400892109053',
  ucdQtyMultiplicator: 12,
  cipLib: "NIFUROXAZIDE ZYD 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '3847636',
  CIP13: '3400938476361',
  ucdLib: "NIFUROXAZIDE BGC 200MG GELU",
  UCD7: '9316785',
  UCD13: '3400893167854',
  ucdQtyMultiplicator: 12,
  cipLib: "NIFUROXAZIDE BGC 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '4153982',
  CIP13: '3400941539824',
  ucdLib: "NIFUROXAZIDE TCO 200MG GELU",
  UCD7: '9258964',
  UCD13: '3400892589640',
  ucdQtyMultiplicator: 12,
  cipLib: "NIFUROXAZIDE TCO 200MG GELU BT 12",
  atcCode: "A07AX03"
}, {
  CIP7: '2223767',
  CIP13: '3400922237671',
  ucdLib: "DIFICLIR 200MG CPR",
  UCD7: '9384373',
  UCD13: '3400893843734',
  ucdQtyMultiplicator: 20,
  cipLib: "DIFICLIR 200MG CPR BT 20",
  atcCode: "A07AA12"
}, {
  CIP7: '3000966',
  CIP13: '3400930009666',
  ucdLib: "TIXTAR 550MG CPR",
  UCD7: '9407803',
  UCD13: '3400894078036',
  ucdQtyMultiplicator: 56,
  cipLib: "TIXTAR 550MG CPR BT 56",
  atcCode: "A07AA11"
}, {
  CIP7: '3041867',
  CIP13: '3400930418673',
  ucdLib: "FUNGIZONE 10% BUV FL40ML",
  UCD7: '9036703',
  UCD13: '3400890367035',
  ucdQtyMultiplicator: 1,
  cipLib: "FUNGIZONE 10% BUV FL40ML BT 1",
  atcCode: "A07AA07"
}, {
  CIP7: '3462422',
  CIP13: '3400934624223',
  ucdLib: "FUNGIZONE 10% BB./ENF BUV 40ML",
  UCD7: '9213387',
  UCD13: '3400892133874',
  ucdQtyMultiplicator: 1,
  cipLib: "FUNGIZONE 10% BB./ENF BUV 40ML BT 1",
  atcCode: "A07AA07"
}, {
  CIP7: '5900352',
  CIP13: '3400959003522',
  ucdLib: "HUMATIN 250MG GELU",
  UCD7: '9044677',
  UCD13: '3400890446778',
  ucdQtyMultiplicator: 16,
  cipLib: "HUMATIN 250MG GELU BT 16",
  atcCode: "A07AA06"
}, {
  CIP7: '3517904',
  CIP13: '3400935179043',
  ucdLib: "MYCOSTATINE BUV SUSP FL24ML",
  UCD7: '9060541',
  UCD13: '3400890605410',
  ucdQtyMultiplicator: 1,
  cipLib: "MYCOSTATINE BUV SUSP FL24ML BT 1",
  atcCode: "A07AA02"
}, {
  CIP7: '4941627',
  CIP13: '3400949416271',
  ucdLib: "RESOLOR 1MG CPR",
  UCD7: '9379952',
  UCD13: '3400893799529',
  ucdQtyMultiplicator: 28,
  cipLib: "RESOLOR 1MG CPR BT 28",
  atcCode: "A06AX05"
}, {
  CIP7: '4941656',
  CIP13: '3400949416561',
  ucdLib: "RESOLOR 2MG CPR",
  UCD7: '9379969',
  UCD13: '3400893799697',
  ucdQtyMultiplicator: 28,
  cipLib: "RESOLOR 2MG CPR BT 28",
  atcCode: "A06AX05"
}, {
  CIP7: '4185002',
  CIP13: '3400941850028',
  ucdLib: "RESOLOR 2MG CPR",
  UCD7: '9379969',
  UCD13: '3400893799697',
  ucdQtyMultiplicator: 14,
  cipLib: "RESOLOR 2MG CPR BT 14",
  atcCode: "A06AX05"
}, {
  CIP7: '3034844',
  CIP13: '3400930348444',
  ucdLib: "EDUCTYL AD. SUP EFFV",
  UCD7: '9030273',
  UCD13: '3400890302739',
  ucdQtyMultiplicator: 12,
  cipLib: "EDUCTYL AD. SUP EFFV BT 12",
  atcCode: "A06AX02"
}, {
  CIP7: '3034867',
  CIP13: '3400930348673',
  ucdLib: "EDUCTYL ENF SUP EFFV",
  UCD7: '9030296',
  UCD13: '3400890302968',
  ucdQtyMultiplicator: 12,
  cipLib: "EDUCTYL ENF SUP EFFV BT 12",
  atcCode: "A06AX02"
}, {
  CIP7: '3236542',
  CIP13: '3400932365425',
  ucdLib: "GLYCERINE GIFRER SUP ENF",
  UCD7: '9187069',
  UCD13: '3400891870695',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE GIFRER SUP ENF BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3236275',
  CIP13: '3400932362752',
  ucdLib: "GLYCERINE MONOT SUP AD.",
  UCD7: '9040082',
  UCD13: '3400890400824',
  ucdQtyMultiplicator: 25,
  cipLib: "GLYCERINE MONOT SUP AD. BT 25",
  atcCode: "A06AX01"
}, {
  CIP7: '3236281',
  CIP13: '3400932362813',
  ucdLib: "GLYCERINE MONOT SUP AD.",
  UCD7: '9040082',
  UCD13: '3400890400824',
  ucdQtyMultiplicator: 50,
  cipLib: "GLYCERINE MONOT SUP AD. BT 50",
  atcCode: "A06AX01"
}, {
  CIP7: '3236298',
  CIP13: '3400932362981',
  ucdLib: "GLYCERINE MONOT SUP AD.",
  UCD7: '9040082',
  UCD13: '3400890400824',
  ucdQtyMultiplicator: 100,
  cipLib: "GLYCERINE MONOT SUP AD. BT 100",
  atcCode: "A06AX01"
}, {
  CIP7: '3026916',
  CIP13: '3400930269169',
  ucdLib: "GLYCERINE MYS SUP AD.",
  UCD7: '9022813',
  UCD13: '3400890228138',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE MYS SUP AD. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3026922',
  CIP13: '3400930269220',
  ucdLib: "GLYCERINE MYS SUP BB.",
  UCD7: '9022836',
  UCD13: '3400890228367',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE MYS SUP BB. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3026939',
  CIP13: '3400930269398',
  ucdLib: "GLYCERINE MYS SUP ENF",
  UCD7: '9022842',
  UCD13: '3400890228428',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE MYS SUP ENF BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3319541',
  CIP13: '3400933195410',
  ucdLib: "CRISTAL AD. SUP",
  UCD7: '9214317',
  UCD13: '3400892143170',
  ucdQtyMultiplicator: 10,
  cipLib: "CRISTAL AD. SUP BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3319624',
  CIP13: '3400933196240',
  ucdLib: "CRISTAL BB. SUP",
  UCD7: '9214346',
  UCD13: '3400892143460',
  ucdQtyMultiplicator: 10,
  cipLib: "CRISTAL BB. SUP BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3319587',
  CIP13: '3400933195878',
  ucdLib: "CRISTAL ENF SUP",
  UCD7: '9214323',
  UCD13: '3400892143231',
  ucdQtyMultiplicator: 10,
  cipLib: "CRISTAL ENF SUP BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3347804',
  CIP13: '3400933478049',
  ucdLib: "GLYCERINE CENTR SUP AD.",
  UCD7: '9154070',
  UCD13: '3400891540703',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE CENTR SUP AD. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3347810',
  CIP13: '3400933478100',
  ucdLib: "GLYCERINE CENTR SUP AD.",
  UCD7: '9154070',
  UCD13: '3400891540703',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE CENTR SUP AD. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3347827',
  CIP13: '3400933478278',
  ucdLib: "GLYCERINE CENTR SUP AD.",
  UCD7: '9154070',
  UCD13: '3400891540703',
  ucdQtyMultiplicator: 25,
  cipLib: "GLYCERINE CENTR SUP AD. BT 25",
  atcCode: "A06AX01"
}, {
  CIP7: '3347833',
  CIP13: '3400933478339',
  ucdLib: "GLYCERINE CENTR SUP AD.",
  UCD7: '9154070',
  UCD13: '3400891540703',
  ucdQtyMultiplicator: 50,
  cipLib: "GLYCERINE CENTR SUP AD. BT 50",
  atcCode: "A06AX01"
}, {
  CIP7: '3347856',
  CIP13: '3400933478568',
  ucdLib: "GLYCERINE CENTR SUP AD.",
  UCD7: '9154070',
  UCD13: '3400891540703',
  ucdQtyMultiplicator: 100,
  cipLib: "GLYCERINE CENTR SUP AD. BT 100",
  atcCode: "A06AX01"
}, {
  CIP7: '3347721',
  CIP13: '3400933477219',
  ucdLib: "GLYCERINE CENTR SUP BB.",
  UCD7: '9154118',
  UCD13: '3400891541182',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE CENTR SUP BB. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3347750',
  CIP13: '3400933477509',
  ucdLib: "GLYCERINE CENTR SUP ENF",
  UCD7: '9154093',
  UCD13: '3400891540932',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE CENTR SUP ENF BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3347767',
  CIP13: '3400933477677',
  ucdLib: "GLYCERINE CENTR SUP ENF",
  UCD7: '9154093',
  UCD13: '3400891540932',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE CENTR SUP ENF BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3347773',
  CIP13: '3400933477738',
  ucdLib: "GLYCERINE CENTR SUP ENF",
  UCD7: '9154093',
  UCD13: '3400891540932',
  ucdQtyMultiplicator: 25,
  cipLib: "GLYCERINE CENTR SUP ENF BT 25",
  atcCode: "A06AX01"
}, {
  CIP7: '3129645',
  CIP13: '3400931296454',
  ucdLib: "GLYCERINE MONOT SUP AD.",
  UCD7: '9040082',
  UCD13: '3400890400824',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE MONOT SUP AD. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3129680',
  CIP13: '3400931296805',
  ucdLib: "GLYCERINE MONOT SUP BB.",
  UCD7: '9040099',
  UCD13: '3400890400992',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE MONOT SUP BB. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3129668',
  CIP13: '3400931296683',
  ucdLib: "GLYCERINE MONOT SUP ENF",
  UCD7: '9040107',
  UCD13: '3400890401074',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE MONOT SUP ENF BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3392704',
  CIP13: '3400933927042',
  ucdLib: "GLYCERINE GIFRER SUP AD.",
  UCD7: '9187046',
  UCD13: '3400891870466',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE GIFRER SUP AD. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3391567',
  CIP13: '3400933915674',
  ucdLib: "GLYCERINE GIFRER SUP AD.SAC",
  UCD7: '9187052',
  UCD13: '3400891870527',
  ucdQtyMultiplicator: 25,
  cipLib: "GLYCERINE GIFRER SUP AD.SAC BT 25",
  atcCode: "A06AX01"
}, {
  CIP7: '3391573',
  CIP13: '3400933915735',
  ucdLib: "GLYCERINE GIFRER SUP AD.SAC",
  UCD7: '9187052',
  UCD13: '3400891870527',
  ucdQtyMultiplicator: 50,
  cipLib: "GLYCERINE GIFRER SUP AD.SAC BT 50",
  atcCode: "A06AX01"
}, {
  CIP7: '3392696',
  CIP13: '3400933926960',
  ucdLib: "GLYCERINE GIFRER SUP AD.SAC",
  UCD7: '9187052',
  UCD13: '3400891870527',
  ucdQtyMultiplicator: 100,
  cipLib: "GLYCERINE GIFRER SUP AD.SAC BT 100",
  atcCode: "A06AX01"
}, {
  CIP7: '3391544',
  CIP13: '3400933915445',
  ucdLib: "GLYCERINE GIFRER SUP BB.",
  UCD7: '9187075',
  UCD13: '3400891870756',
  ucdQtyMultiplicator: 10,
  cipLib: "GLYCERINE GIFRER SUP BB. BT 10",
  atcCode: "A06AX01"
}, {
  CIP7: '3701789',
  CIP13: '3400937017893',
  ucdLib: "GLYCERINE EVL SUP AD. DOS",
  UCD7: '9312066',
  UCD13: '3400893120668',
  ucdQtyMultiplicator: 25,
  cipLib: "GLYCERINE EVL SUP AD. DOS BT 25",
  atcCode: "A06AX01"
}, {
  CIP7: '3741412',
  CIP13: '3400937414128',
  ucdLib: "GLYCERINE EVL SUP AD. DOS",
  UCD7: '9312066',
  UCD13: '3400893120668',
  ucdQtyMultiplicator: 50,
  cipLib: "GLYCERINE EVL SUP AD. DOS BT 50",
  atcCode: "A06AX01"
}, {
  CIP7: '3741429',
  CIP13: '3400937414296',
  ucdLib: "GLYCERINE EVL SUP AD. DOS",
  UCD7: '9312066',
  UCD13: '3400893120668',
  ucdQtyMultiplicator: 100,
  cipLib: "GLYCERINE EVL SUP AD. DOS BT 100",
  atcCode: "A06AX01"
}, {
  CIP7: '3166712',
  CIP13: '3400931667124',
  ucdLib: "BEBEGEL GEL RECT UNIDOS",
  UCD7: '9009741',
  UCD13: '3400890097413',
  ucdQtyMultiplicator: 6,
  cipLib: "BEBEGEL GEL RECT UNIDOS BT 6",
  atcCode: "A06AX01"
}, {
  CIP7: '4182475',
  CIP13: '3400941824753',
  ucdLib: "GLYCERINE CPF SUP AD.",
  UCD7: '9402013',
  UCD13: '3400894020134',
  ucdQtyMultiplicator: 25,
  cipLib: "GLYCERINE CPF SUP AD. BT 25",
  atcCode: "A06AX01"
}, {
  CIP7: '4182481',
  CIP13: '3400941824814',
  ucdLib: "GLYCERINE CPF SUP AD.",
  UCD7: '9402013',
  UCD13: '3400894020134',
  ucdQtyMultiplicator: 50,
  cipLib: "GLYCERINE CPF SUP AD. BT 50",
  atcCode: "A06AX01"
}, {
  CIP7: '4182498',
  CIP13: '3400941824982',
  ucdLib: "GLYCERINE CPF SUP AD.",
  UCD7: '9402013',
  UCD13: '3400894020134',
  ucdQtyMultiplicator: 100,
  cipLib: "GLYCERINE CPF SUP AD. BT 100",
  atcCode: "A06AX01"
}, {
  CIP7: '3873674',
  CIP13: '3400938736748',
  ucdLib: "RELISTOR 12MG/0,6ML INJ FL+N.",
  UCD7: '9324224',
  UCD13: '3400893242247',
  ucdQtyMultiplicator: 7,
  cipLib: "RELISTOR 12MG/0,6ML INJ FL+N. BT 7",
  atcCode: "A06AH01"
}, {
  CIP7: '3130737',
  CIP13: '3400931307372',
  ucdLib: "NORMACOL LAVEMENT AD. D.130ML",
  UCD7: '9063580',
  UCD13: '3400890635806',
  ucdQtyMultiplicator: 1,
  cipLib: "NORMACOL LAVEMENT AD. D.130ML BT 1",
  atcCode: "A06AG20"
}, {
  CIP7: '3130743',
  CIP13: '3400931307433',
  ucdLib: "NORMACOL LAVEMENT ENF DOS60ML",
  UCD7: '9063597',
  UCD13: '3400890635974',
  ucdQtyMultiplicator: 1,
  cipLib: "NORMACOL LAVEMENT ENF DOS60ML BT 1",
  atcCode: "A06AG20"
}, {
  CIP7: '3544545',
  CIP13: '3400935445452',
  ucdLib: "MICROLAX BB SOL UNIDOS",
  UCD7: '9058780',
  UCD13: '3400890587808',
  ucdQtyMultiplicator: 4,
  cipLib: "MICROLAX BB SOL UNIDOS BT 4",
  atcCode: "A06AG11"
}, {
  CIP7: '3496875',
  CIP13: '3400934968754',
  ucdLib: "MICROLAX SOL UNIDOS",
  UCD7: '9058774',
  UCD13: '3400890587747',
  ucdQtyMultiplicator: 4,
  cipLib: "MICROLAX SOL UNIDOS BT 4",
  atcCode: "A06AG11"
}, {
  CIP7: '3496881',
  CIP13: '3400934968815',
  ucdLib: "MICROLAX SOL UNIDOS",
  UCD7: '9058774',
  UCD13: '3400890587747',
  ucdQtyMultiplicator: 12,
  cipLib: "MICROLAX SOL UNIDOS BT 12",
  atcCode: "A06AG11"
}, {
  CIP7: '5620724',
  CIP13: '3400956207244',
  ucdLib: "MICROLAX SOL UNIDOS",
  UCD7: '9058774',
  UCD13: '3400890587747',
  ucdQtyMultiplicator: 50,
  cipLib: "MICROLAX SOL UNIDOS BT 50",
  atcCode: "A06AG11"
}, {
  CIP7: '3269116',
  CIP13: '3400932691166',
  ucdLib: "NORGALAX GEL RECT TB10G",
  UCD7: '9063545',
  UCD13: '3400890635455',
  ucdQtyMultiplicator: 6,
  cipLib: "NORGALAX GEL RECT TB10G BT 6",
  atcCode: "A06AG10"
}, {
  CIP7: '3288622',
  CIP13: '3400932886227',
  ucdLib: "FORTRANS BUV PDR SACH 74G",
  UCD7: '9125708',
  UCD13: '3400891257083',
  ucdQtyMultiplicator: 4,
  cipLib: "FORTRANS BUV PDR SACH 74G BT 4",
  atcCode: "A06AD65"
}, {
  CIP7: '3400102',
  CIP13: '3400934001024',
  ucdLib: "MOVICOL BUV PDR SACH",
  UCD7: '9177763',
  UCD13: '3400891777635',
  ucdQtyMultiplicator: 20,
  cipLib: "MOVICOL BUV PDR SACH BT 20",
  atcCode: "A06AD65"
}, {
  CIP7: '3390591',
  CIP13: '3400933905910',
  ucdLib: "COLOPEG BUV PDR SACH",
  UCD7: '9117287',
  UCD13: '3400891172874',
  ucdQtyMultiplicator: 4,
  cipLib: "COLOPEG BUV PDR SACH BT 4",
  atcCode: "A06AD65"
}, {
  CIP7: '3360213',
  CIP13: '3400933602130',
  ucdLib: "KLEAN-PREP BUV PDR SACH1+2",
  UCD7: '9164737',
  UCD13: '3400891647372',
  ucdQtyMultiplicator: 2,
  cipLib: "KLEAN-PREP BUV PDR SACH1+2 BT 2",
  atcCode: "A06AD65"
}, {
  CIP7: '3366635',
  CIP13: '3400933666354',
  ucdLib: "KLEAN-PREP BUV PDR SACH1+2",
  UCD7: '9164737',
  UCD13: '3400891647372',
  ucdQtyMultiplicator: 4,
  cipLib: "KLEAN-PREP BUV PDR SACH1+2 BT 4",
  atcCode: "A06AD65"
}, {
  CIP7: '3640970',
  CIP13: '3400936409705',
  ucdLib: "MOVICOL ENF BUV PDR SACH",
  UCD7: '9283100',
  UCD13: '3400892831008',
  ucdQtyMultiplicator: 20,
  cipLib: "MOVICOL ENF BUV PDR SACH BT 20",
  atcCode: "A06AD65"
}, {
  CIP7: '3788164',
  CIP13: '3400937881647',
  ucdLib: "MOVIPREP BUV PDR SACH DBLE",
  UCD7: '9301157',
  UCD13: '3400893011577',
  ucdQtyMultiplicator: 2,
  cipLib: "MOVIPREP BUV PDR SACH DBLE BT 2",
  atcCode: "A06AD65"
}, {
  CIP7: '4947682',
  CIP13: '3400949476824',
  ucdLib: "MOVICOL CHOC BUV PDR SACH",
  UCD7: '9356158',
  UCD13: '3400893561584',
  ucdQtyMultiplicator: 20,
  cipLib: "MOVICOL CHOC BUV PDR SACH BT 20",
  atcCode: "A06AD65"
}, {
  CIP7: '4947653',
  CIP13: '3400949476534',
  ucdLib: "MOVICOL S/AROM BUV PDR SACH",
  UCD7: '9356164',
  UCD13: '3400893561645',
  ucdQtyMultiplicator: 20,
  cipLib: "MOVICOL S/AROM BUV PDR SACH BT 20",
  atcCode: "A06AD65"
}, {
  CIP7: '5768409',
  CIP13: '3400957684099',
  ucdLib: "COLOPEG BUV PDR SACH",
  UCD7: '9117287',
  UCD13: '3400891172874',
  ucdQtyMultiplicator: 100,
  cipLib: "COLOPEG BUV PDR SACH BT 100",
  atcCode: "A06AD65"
}, {
  CIP7: '3391679',
  CIP13: '3400933916794',
  ucdLib: "TRANSULOSE GELE ORAL POT P150G",
  UCD7: '9183433',
  UCD13: '3400891834338',
  ucdQtyMultiplicator: 1,
  cipLib: "TRANSULOSE GELE ORAL POT P150G BT 1",
  atcCode: "A06AD61"
}, {
  CIP7: '2669210',
  CIP13: '3400926692100',
  ucdLib: "MELAXOSE PATE ORAL POT P150G+C",
  UCD7: '9393975',
  UCD13: '3400893939758',
  ucdQtyMultiplicator: 1,
  cipLib: "MELAXOSE PATE ORAL POT P150G+C BT 1",
  atcCode: "A06AD61"
}, {
  CIP7: '2669227',
  CIP13: '3400926692278',
  ucdLib: "MELAXOSE PATE ORAL POT P200G+C",
  UCD7: '9408464',
  UCD13: '3400894084648',
  ucdQtyMultiplicator: 1,
  cipLib: "MELAXOSE PATE ORAL POT P200G+C BT 1",
  atcCode: "A06AD61"
}, {
  CIP7: '2224554',
  CIP13: '3400922245546',
  ucdLib: "MELAXOSE 3,50G PATE SACH",
  UCD7: '9387472',
  UCD13: '3400893874721',
  ucdQtyMultiplicator: 6,
  cipLib: "MELAXOSE 3,50G PATE SACH BT 6",
  atcCode: "A06AD61"
}, {
  CIP7: '2225223',
  CIP13: '3400922252230',
  ucdLib: "TRANSULOSE PATE ORAL SACH10G",
  UCD7: '9387006',
  UCD13: '3400893870068',
  ucdQtyMultiplicator: 6,
  cipLib: "TRANSULOSE PATE ORAL SACH10G BT 6",
  atcCode: "A06AD61"
}, {
  CIP7: '2225163',
  CIP13: '3400922251639',
  ucdLib: "TRANSULOSE PATE ORAL SACH5G",
  UCD7: '9386998',
  UCD13: '3400893869987',
  ucdQtyMultiplicator: 10,
  cipLib: "TRANSULOSE PATE ORAL SACH5G BT 10",
  atcCode: "A06AD61"
}, {
  CIP7: '3098169',
  CIP13: '3400930981696',
  ucdLib: "SORBITOL DELAL.5G SACH",
  UCD7: '9086285',
  UCD13: '3400890862851',
  ucdQtyMultiplicator: 20,
  cipLib: "SORBITOL DELAL.5G SACH BT 20",
  atcCode: "A06AD18"
}, {
  CIP7: '5584460',
  CIP13: '3400955844600',
  ucdLib: "SORBITOL RCA 5G PDR SACH",
  UCD7: '9176551',
  UCD13: '3400891765519',
  ucdQtyMultiplicator: 100,
  cipLib: "SORBITOL RCA 5G PDR SACH BT 100",
  atcCode: "A06AD18"
}, {
  CIP7: '3448439',
  CIP13: '3400934484391',
  ucdLib: "SORBITOL RCA 5G PDR SACH",
  UCD7: '9176551',
  UCD13: '3400891765519',
  ucdQtyMultiplicator: 20,
  cipLib: "SORBITOL RCA 5G PDR SACH BT 20",
  atcCode: "A06AD18"
}, {
  CIP7: '3324306',
  CIP13: '3400933243067',
  ucdLib: "BIOPEG BUV SOL FP1000ML",
  UCD7: '9145929',
  UCD13: '3400891459296',
  ucdQtyMultiplicator: 1,
  cipLib: "BIOPEG BUV SOL FP1000ML BT 1",
  atcCode: "A06AD15"
}, {
  CIP7: '3005581',
  CIP13: '3400930055816',
  ucdLib: "CASENLAX 10G BUV SACH20ML",
  UCD7: '9418014',
  UCD13: '3400894180142',
  ucdQtyMultiplicator: 20,
  cipLib: "CASENLAX 10G BUV SACH20ML BT 20",
  atcCode: "A06AD15"
}, {
  CIP7: '3605212',
  CIP13: '3400936052123',
  ucdLib: "FORLAX 4G BUV PDR SACH",
  UCD7: '9248612',
  UCD13: '3400892486123',
  ucdQtyMultiplicator: 20,
  cipLib: "FORLAX 4G BUV PDR SACH BT 20",
  atcCode: "A06AD15"
}, {
  CIP7: '5582610',
  CIP13: '3400955826101',
  ucdLib: "TRANSIPEG 2,95G BUV SACH",
  UCD7: '9165719',
  UCD13: '3400891657197',
  ucdQtyMultiplicator: 200,
  cipLib: "TRANSIPEG 2,95G BUV SACH BT 200",
  atcCode: "A06AD15"
}, {
  CIP7: '3368663',
  CIP13: '3400933686635',
  ucdLib: "TRANSIPEG 2,95G BUV SACH",
  UCD7: '9165719',
  UCD13: '3400891657197',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANSIPEG 2,95G BUV SACH BT 30",
  atcCode: "A06AD15"
}, {
  CIP7: '5606411',
  CIP13: '3400956064113',
  ucdLib: "TRANSIPEG 5,9G BUV SACH",
  UCD7: '9202610',
  UCD13: '3400892026107',
  ucdQtyMultiplicator: 200,
  cipLib: "TRANSIPEG 5,9G BUV SACH BT 200",
  atcCode: "A06AD15"
}, {
  CIP7: '3389978',
  CIP13: '3400933899783',
  ucdLib: "FORLAX 10G BUV PDR SACH",
  UCD7: '9178544',
  UCD13: '3400891785449',
  ucdQtyMultiplicator: 20,
  cipLib: "FORLAX 10G BUV PDR SACH BT 20",
  atcCode: "A06AD15"
}, {
  CIP7: '3795052',
  CIP13: '3400937950527',
  ucdLib: "MACROGOL BGA 10G BUV SACH",
  UCD7: '9324477',
  UCD13: '3400893244777',
  ucdQtyMultiplicator: 20,
  cipLib: "MACROGOL BGA 10G BUV SACH BT 20",
  atcCode: "A06AD15"
}, {
  CIP7: '3442402',
  CIP13: '3400934424021',
  ucdLib: "TRANSIPEG 5,9G BUV SACH",
  UCD7: '9202610',
  UCD13: '3400892026107',
  ucdQtyMultiplicator: 20,
  cipLib: "TRANSIPEG 5,9G BUV SACH BT 20",
  atcCode: "A06AD15"
}, {
  CIP7: '3894995',
  CIP13: '3400938949957',
  ucdLib: "MACROGOL 4000 MYL 10G BUV S.",
  UCD7: '9324483',
  UCD13: '3400893244838',
  ucdQtyMultiplicator: 20,
  cipLib: "MACROGOL 4000 MYL 10G BUV S. BT 20",
  atcCode: "A06AD15"
}, {
  CIP7: '3913468',
  CIP13: '3400939134680',
  ucdLib: "MACROGOL 4000 SDZ 10G BUV S.",
  UCD7: '9357962',
  UCD13: '3400893579626',
  ucdQtyMultiplicator: 20,
  cipLib: "MACROGOL 4000 SDZ 10G BUV S. BT 20",
  atcCode: "A06AD15"
}, {
  CIP7: '4153775',
  CIP13: '3400941537752',
  ucdLib: "TRANSIPEGLIB 5,9G BUV SACH",
  UCD7: '9357206',
  UCD13: '3400893572061',
  ucdQtyMultiplicator: 14,
  cipLib: "TRANSIPEGLIB 5,9G BUV SACH BT 14",
  atcCode: "A06AD15"
}, {
  CIP7: '2678947',
  CIP13: '3400926789473',
  ucdLib: "MICROLAX MACROG.5,9G BUV SAC",
  UCD7: '9394704',
  UCD13: '3400893947043',
  ucdQtyMultiplicator: 10,
  cipLib: "MICROLAX MACROG.5,9G BUV SAC BT 10",
  atcCode: "A06AD15"
}, {
  CIP7: '3288384',
  CIP13: '3400932883844',
  ucdLib: "AUXITRANS 5G PDR BUV SACH",
  UCD7: '9119820',
  UCD13: '3400891198201',
  ucdQtyMultiplicator: 20,
  cipLib: "AUXITRANS 5G PDR BUV SACH BT 20",
  atcCode: "A06AD14"
}, {
  CIP7: '3306998',
  CIP13: '3400933069988',
  ucdLib: "IMPORTAL 10G BUV PDR SACH",
  UCD7: '9140263',
  UCD13: '3400891402636',
  ucdQtyMultiplicator: 20,
  cipLib: "IMPORTAL 10G BUV PDR SACH BT 20",
  atcCode: "A06AD12"
}, {
  CIP7: '3358653',
  CIP13: '3400933586539',
  ucdLib: "IMPORTAL 2,5G BUV PDR SACH",
  UCD7: '9164252',
  UCD13: '3400891642520',
  ucdQtyMultiplicator: 10,
  cipLib: "IMPORTAL 2,5G BUV PDR SACH BT 10",
  atcCode: "A06AD12"
}, {
  CIP7: '3358647',
  CIP13: '3400933586478',
  ucdLib: "IMPORTAL 5G BUV PDR SACH",
  UCD7: '9164246',
  UCD13: '3400891642469',
  ucdQtyMultiplicator: 10,
  cipLib: "IMPORTAL 5G BUV PDR SACH BT 10",
  atcCode: "A06AD12"
}, {
  CIP7: '3283808',
  CIP13: '3400932838080',
  ucdLib: "LACTULOSE BGA 66,5% BUV F200ML",
  UCD7: '9191131',
  UCD13: '3400891911312',
  ucdQtyMultiplicator: 1,
  cipLib: "LACTULOSE BGA 66,5% BUV F200ML BT 1",
  atcCode: "A06AD11"
}, {
  CIP7: '5556682',
  CIP13: '3400955566823',
  ucdLib: "DUPHALAC 10G/15ML BUV SACH",
  UCD7: '9129793',
  UCD13: '3400891297935',
  ucdQtyMultiplicator: 400,
  cipLib: "DUPHALAC 10G/15ML BUV SACH BT 400",
  atcCode: "A06AD11"
}, {
  CIP7: '2769319',
  CIP13: '3400927693199',
  ucdLib: "DUPHALAC 10G/15ML BUV S.GF",
  UCD7: '9399446',
  UCD13: '3400893994467',
  ucdQtyMultiplicator: 20,
  cipLib: "DUPHALAC 10G/15ML BUV S.GF BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '3263705',
  CIP13: '3400932637058',
  ucdLib: "LACTULOSE BIP 10G/15ML SACH",
  UCD7: '9049539',
  UCD13: '3400890495394',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTULOSE BIP 10G/15ML SACH BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '3523514',
  CIP13: '3400935235145',
  ucdLib: "DUPHALAC 66,5% BUV FP200ML",
  UCD7: '9218249',
  UCD13: '3400892182490',
  ucdQtyMultiplicator: 1,
  cipLib: "DUPHALAC 66,5% BUV FP200ML BT 1",
  atcCode: "A06AD11"
}, {
  CIP7: '3679771',
  CIP13: '3400936797710',
  ucdLib: "LACTULOSE SDZ 10G SACH15ML",
  UCD7: '9268661',
  UCD13: '3400892686615',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTULOSE SDZ 10G SACH15ML BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '3674609',
  CIP13: '3400936746091',
  ucdLib: "LACTULOSE ZEN 10G SACH15ML",
  UCD7: '9270043',
  UCD13: '3400892700434',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTULOSE ZEN 10G SACH15ML BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '3398405',
  CIP13: '3400933984052',
  ucdLib: "LACTULOSE MYL 10G/15ML SACH",
  UCD7: '9181322',
  UCD13: '3400891813227',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTULOSE MYL 10G/15ML SACH BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '3583829',
  CIP13: '3400935838292',
  ucdLib: "LACTULOSE MYP 10G SACH15ML",
  UCD7: '9249362',
  UCD13: '3400892493626',
  ucdQtyMultiplicator: 12,
  cipLib: "LACTULOSE MYP 10G SACH15ML BT 12",
  atcCode: "A06AD11"
}, {
  CIP7: '3583858',
  CIP13: '3400935838582',
  ucdLib: "LACTULOSE MYP 10G SACH15ML",
  UCD7: '9249362',
  UCD13: '3400892493626',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTULOSE MYP 10G SACH15ML BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '3583901',
  CIP13: '3400935839015',
  ucdLib: "LACTULOSE RTP 10G SACH15ML",
  UCD7: '9236477',
  UCD13: '3400892364773',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTULOSE RTP 10G SACH15ML BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '3473006',
  CIP13: '3400934730061',
  ucdLib: "LACTULOSE BGA 10G/15ML SACH",
  UCD7: '9206393',
  UCD13: '3400892063935',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTULOSE BGA 10G/15ML SACH BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '3475790',
  CIP13: '3400934757907',
  ucdLib: "LAXARON 10G BUV SACH15ML",
  UCD7: '9205206',
  UCD13: '3400892052069',
  ucdQtyMultiplicator: 12,
  cipLib: "LAXARON 10G BUV SACH15ML BT 12",
  atcCode: "A06AD11"
}, {
  CIP7: '3809305',
  CIP13: '3400938093056',
  ucdLib: "LACTULOSE ARW 10G/15ML SACH",
  UCD7: '9349431',
  UCD13: '3400893494318',
  ucdQtyMultiplicator: 20,
  cipLib: "LACTULOSE ARW 10G/15ML SACH BT 20",
  atcCode: "A06AD11"
}, {
  CIP7: '4969436',
  CIP13: '3400949694365',
  ucdLib: "LACTULOSE FRF670MG/ML P200ML",
  UCD7: '9419410',
  UCD13: '3400894194101',
  ucdQtyMultiplicator: 10,
  cipLib: "LACTULOSE FRF670MG/ML P200ML BT 10",
  atcCode: "A06AD11"
}, {
  CIP7: '3459905',
  CIP13: '3400934599057',
  ucdLib: "RECHOLAN 24,4G/10,8G BUV 45ML",
  UCD7: '9207056',
  UCD13: '3400892070568',
  ucdQtyMultiplicator: 2,
  cipLib: "RECHOLAN 24,4G/10,8G BUV 45ML BT 2",
  atcCode: "A06AD10"
}, {
  CIP7: '3471881',
  CIP13: '3400934718816',
  ucdLib: "COLOKIT CPR",
  UCD7: '9354567',
  UCD13: '3400893545676',
  ucdQtyMultiplicator: 32,
  cipLib: "COLOKIT CPR BT 32",
  atcCode: "A06AD10"
}, {
  CIP7: '2699524',
  CIP13: '3400926995249',
  ucdLib: "IZINOVA BUV FL176ML",
  UCD7: '9406494',
  UCD13: '3400894064947',
  ucdQtyMultiplicator: 2,
  cipLib: "IZINOVA BUV FL176ML BT 2",
  atcCode: "A06AD10"
}, {
  CIP7: '3022315',
  CIP13: '3400930223154',
  ucdLib: "CHLORUMAGENE PDR ORAL BT100G",
  UCD7: '9019231',
  UCD13: '3400890192316',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORUMAGENE PDR ORAL BT100G BT 1",
  atcCode: "A06AD02"
}, {
  CIP7: '3139193',
  CIP13: '3400931391937',
  ucdLib: "MAGNESIE PELL NORM 90G",
  UCD7: '9056203',
  UCD13: '3400890562034',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNESIE PELL NORM 90G BT 1",
  atcCode: "A06AD02"
}, {
  CIP7: '3135812',
  CIP13: '3400931358121',
  ucdLib: "MAGNESIE PELL NORM ANIS 90G",
  UCD7: '9056195',
  UCD13: '3400890561952',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNESIE PELL NORM ANIS 90G BT 1",
  atcCode: "A06AD02"
}, {
  CIP7: '3445820',
  CIP13: '3400934458200',
  ucdLib: "MAGNESIE PELL EFFV ANIS 125G",
  UCD7: '9203466',
  UCD13: '3400892034669',
  ucdQtyMultiplicator: 1,
  cipLib: "MAGNESIE PELL EFFV ANIS 125G BT 1",
  atcCode: "A06AD02"
}, {
  CIP7: '3224734',
  CIP13: '3400932247349',
  ucdLib: "KARAYAL GLE BT1000G",
  UCD7: '9111215',
  UCD13: '3400891112153',
  ucdQtyMultiplicator: 1,
  cipLib: "KARAYAL GLE BT1000G BT 1",
  atcCode: "A06AC53"
}, {
  CIP7: '3365564',
  CIP13: '3400933655648',
  ucdLib: "AGIOLAX GLE BT100G",
  UCD7: '9163933',
  UCD13: '3400891639339',
  ucdQtyMultiplicator: 1,
  cipLib: "AGIOLAX GLE BT100G BT 1",
  atcCode: "A06AC51"
}, {
  CIP7: '3626094',
  CIP13: '3400936260948',
  ucdLib: "NORMACOL 62G/100G GLE BT1KG",
  UCD7: '9270936',
  UCD13: '3400892709369',
  ucdQtyMultiplicator: 1,
  cipLib: "NORMACOL 62G/100G GLE BT1KG BT 1",
  atcCode: "A06AC03"
}, {
  CIP7: '3626102',
  CIP13: '3400936261020',
  ucdLib: "NORMACOL 62G/100G GLE SACH",
  UCD7: '9270942',
  UCD13: '3400892709420',
  ucdQtyMultiplicator: 30,
  cipLib: "NORMACOL 62G/100G GLE SACH BT 30",
  atcCode: "A06AC03"
}, {
  CIP7: '3087467',
  CIP13: '3400930874677',
  ucdLib: "PSYLLIUM LANGLEBERT GRAINE250G",
  UCD7: '9076677',
  UCD13: '3400890766777',
  ucdQtyMultiplicator: 1,
  cipLib: "PSYLLIUM LANGLEBERT GRAINE250G BT 1",
  atcCode: "A06AC01"
}, {
  CIP7: '3323979',
  CIP13: '3400933239794',
  ucdLib: "TRANSILANE PDR ORAL SACH",
  UCD7: '9147561',
  UCD13: '3400891475616',
  ucdQtyMultiplicator: 20,
  cipLib: "TRANSILANE PDR ORAL SACH BT 20",
  atcCode: "A06AC01"
}, {
  CIP7: '3276719',
  CIP13: '3400932767199',
  ucdLib: "TRANSILANE BUV PDR BT140G",
  UCD7: '9094296',
  UCD13: '3400890942966',
  ucdQtyMultiplicator: 1,
  cipLib: "TRANSILANE BUV PDR BT140G BT 1",
  atcCode: "A06AC01"
}, {
  CIP7: '3302210',
  CIP13: '3400933022105',
  ucdLib: "PSYLIA PDR BUV SACH6,9G",
  UCD7: '9144870',
  UCD13: '3400891448702',
  ucdQtyMultiplicator: 20,
  cipLib: "PSYLIA PDR BUV SACH6,9G BT 20",
  atcCode: "A06AC01"
}, {
  CIP7: '3098471',
  CIP13: '3400930984710',
  ucdLib: "SPAGULAX MUCILAGE PUR GLE 700G",
  UCD7: '9086598',
  UCD13: '3400890865982',
  ucdQtyMultiplicator: 1,
  cipLib: "SPAGULAX MUCILAGE PUR GLE 700G BT 1",
  atcCode: "A06AC01"
}, {
  CIP7: '3600516',
  CIP13: '3400936005167',
  ucdLib: "SPAGULAX S/SUC PDR EFFV SACH",
  UCD7: '9304055',
  UCD13: '3400893040553',
  ucdQtyMultiplicator: 20,
  cipLib: "SPAGULAX S/SUC PDR EFFV SACH BT 20",
  atcCode: "A06AC01"
}, {
  CIP7: '3406435',
  CIP13: '3400934064357',
  ucdLib: "SPAGULAX MUCILAGE PUR GLE S.",
  UCD7: '9184088',
  UCD13: '3400891840889',
  ucdQtyMultiplicator: 20,
  cipLib: "SPAGULAX MUCILAGE PUR GLE S. BT 20",
  atcCode: "A06AC01"
}, {
  CIP7: '3406955',
  CIP13: '3400934069550',
  ucdLib: "SPAGULAX PDR EFFV SACH",
  UCD7: '9189915',
  UCD13: '3400891899153',
  ucdQtyMultiplicator: 20,
  cipLib: "SPAGULAX PDR EFFV SACH BT 20",
  atcCode: "A06AC01"
}, {
  CIP7: '3508650',
  CIP13: '3400935086501',
  ucdLib: "TRANSILANE S/SUC BUV SACH",
  UCD7: '9227969',
  UCD13: '3400892279695',
  ucdQtyMultiplicator: 20,
  cipLib: "TRANSILANE S/SUC BUV SACH BT 20",
  atcCode: "A06AC01"
}, {
  CIP7: '4917221',
  CIP13: '3400949172214',
  ucdLib: "PICOPREP BUV PDR SACH",
  UCD7: '9365542',
  UCD13: '3400893655429',
  ucdQtyMultiplicator: 2,
  cipLib: "PICOPREP BUV PDR SACH BT 2",
  atcCode: "A06AB58"
}, {
  CIP7: '3841645',
  CIP13: '3400938416459',
  ucdLib: "CITRAFLEET BUV PDR SACH DOS",
  UCD7: '9354047',
  UCD13: '3400893540473',
  ucdQtyMultiplicator: 2,
  cipLib: "CITRAFLEET BUV PDR SACH DOS BT 2",
  atcCode: "A06AB58"
}, {
  CIP7: '4902515',
  CIP13: '3400949025152',
  ucdLib: "CITRAFLEET BUV AIP MWI UK SCH",
  UCD7: '9402869',
  UCD13: '3400894028697',
  ucdQtyMultiplicator: 2,
  cipLib: "CITRAFLEET BUV AIP MWI UK SCH BT 2",
  atcCode: "A06AB58"
}, {
  CIP7: '3333624',
  CIP13: '3400933336240',
  ucdLib: "FUCA DRG",
  UCD7: '9036494',
  UCD13: '3400890364942',
  ucdQtyMultiplicator: 45,
  cipLib: "FUCA DRG BT 45",
  atcCode: "A06AB57"
}, {
  CIP7: '3068033',
  CIP13: '3400930680339',
  ucdLib: "MODANE CPR",
  UCD7: '9059302',
  UCD13: '3400890593021',
  ucdQtyMultiplicator: 20,
  cipLib: "MODANE CPR BT 20",
  atcCode: "A06AB56"
}, {
  CIP7: '3000968',
  CIP13: '3400930009680',
  ucdLib: "PROVENCALE TISANE N1 SACH",
  UCD7: '9199121',
  UCD13: '3400891991215',
  ucdQtyMultiplicator: 24,
  cipLib: "PROVENCALE TISANE N1 SACH BT 24",
  atcCode: "A06AB56"
}, {
  CIP7: '3399333',
  CIP13: '3400933993337',
  ucdLib: "MEDIFLOR N7 TIS SACH DOS NP",
  UCD7: '9178998',
  UCD13: '3400891789980',
  ucdQtyMultiplicator: 24,
  cipLib: "MEDIFLOR N7 TIS SACH DOS NP BT 24",
  atcCode: "A06AB56"
}, {
  CIP7: '3419053',
  CIP13: '3400934190537',
  ucdLib: "YERBALAXA TIS SACH DOS",
  UCD7: '9208216',
  UCD13: '3400892082165',
  ucdQtyMultiplicator: 10,
  cipLib: "YERBALAXA TIS SACH DOS BT 10",
  atcCode: "A06AB56"
}, {
  CIP7: '4159795',
  CIP13: '3400941597954',
  ucdLib: "VALS GRAINS 12,5MG CPR",
  UCD7: '9380168',
  UCD13: '3400893801680',
  ucdQtyMultiplicator: 20,
  cipLib: "VALS GRAINS 12,5MG CPR BT 20",
  atcCode: "A06AB56"
}, {
  CIP7: '3199309',
  CIP13: '3400931993094',
  ucdLib: "BOLDOFLORINE CPR PELLIC",
  UCD7: '9011962',
  UCD13: '3400890119627',
  ucdQtyMultiplicator: 40,
  cipLib: "BOLDOFLORINE CPR PELLIC BT 40",
  atcCode: "A06AB20"
}, {
  CIP7: '3409385',
  CIP13: '3400934093852',
  ucdLib: "IDEOLAXYL CPR",
  UCD7: '9045731',
  UCD13: '3400890457316',
  ucdQtyMultiplicator: 20,
  cipLib: "IDEOLAXYL CPR BT 20",
  atcCode: "A06AB20"
}, {
  CIP7: '3159333',
  CIP13: '3400931593331',
  ucdLib: "FRUCTINES VICHY 5MG CPR",
  UCD7: '9036465',
  UCD13: '3400890364652',
  ucdQtyMultiplicator: 40,
  cipLib: "FRUCTINES VICHY 5MG CPR BT 40",
  atcCode: "A06AB08"
}, {
  CIP7: '3239776',
  CIP13: '3400932397761',
  ucdLib: "X-PREP PDR ORAL SACH5G",
  UCD7: '9101412',
  UCD13: '3400891014129',
  ucdQtyMultiplicator: 1,
  cipLib: "X-PREP PDR ORAL SACH5G BT 1",
  atcCode: "A06AB06"
}, {
  CIP7: '3317341',
  CIP13: '3400933173418',
  ucdLib: "ARKOGELULES SENE",
  UCD7: '9138384',
  UCD13: '3400891383843',
  ucdQtyMultiplicator: 45,
  cipLib: "ARKOGELULES SENE BT 45",
  atcCode: "A06AB06"
}, {
  CIP7: '3365788',
  CIP13: '3400933657888',
  ucdLib: "PURSENNIDE 20MG CPR",
  UCD7: '9077369',
  UCD13: '3400890773690',
  ucdQtyMultiplicator: 20,
  cipLib: "PURSENNIDE 20MG CPR BT 20",
  atcCode: "A06AB06"
}, {
  CIP7: '3025153',
  CIP13: '3400930251539',
  ucdLib: "CONTALAX CPR",
  UCD7: '9021736',
  UCD13: '3400890217361',
  ucdQtyMultiplicator: 30,
  cipLib: "CONTALAX CPR BT 30",
  atcCode: "A06AB02"
}, {
  CIP7: '3396636',
  CIP13: '3400933966362',
  ucdLib: "DULCOLAX 10MG SUP",
  UCD7: '9029347',
  UCD13: '3400890293471',
  ucdQtyMultiplicator: 6,
  cipLib: "DULCOLAX 10MG SUP BT 6",
  atcCode: "A06AB02"
}, {
  CIP7: '3906942',
  CIP13: '3400939069425',
  ucdLib: "DULCOLAX 5MG CPR",
  UCD7: '9029330',
  UCD13: '3400890293303',
  ucdQtyMultiplicator: 30,
  cipLib: "DULCOLAX 5MG CPR BT 30",
  atcCode: "A06AB02"
}, {
  CIP7: '4900063',
  CIP13: '3400949000630',
  ucdLib: "DULCOLAX 5MG CPR AIP MWI UK",
  UCD7: '9415493',
  UCD13: '3400894154938',
  ucdQtyMultiplicator: 30,
  cipLib: "DULCOLAX 5MG CPR AIP MWI UK BT 30",
  atcCode: "A06AB02"
}, {
  CIP7: '3062929',
  CIP13: '3400930629291',
  ucdLib: "LUBENTYL MAGNESIE GELE POT260G",
  UCD7: '9055209',
  UCD13: '3400890552097',
  ucdQtyMultiplicator: 1,
  cipLib: "LUBENTYL MAGNESIE GELE POT260G BT 1",
  atcCode: "A06AA51"
}, {
  CIP7: '3309502',
  CIP13: '3400933095024',
  ucdLib: "PARAPSYLLIUM BUV PDR FP100G",
  UCD7: '9137657',
  UCD13: '3400891376579',
  ucdQtyMultiplicator: 1,
  cipLib: "PARAPSYLLIUM BUV PDR FP100G BT 1",
  atcCode: "A06AA51"
}, {
  CIP7: '3405594',
  CIP13: '3400934055942',
  ucdLib: "PARAPSYLLIUM BUV PDR SACH",
  UCD7: '9188092',
  UCD13: '3400891880922',
  ucdQtyMultiplicator: 10,
  cipLib: "PARAPSYLLIUM BUV PDR SACH BT 10",
  atcCode: "A06AA51"
}, {
  CIP7: '3491688',
  CIP13: '3400934916885',
  ucdLib: "PARAPSYLLIUM BUV PDR SACH",
  UCD7: '9188092',
  UCD13: '3400891880922',
  ucdQtyMultiplicator: 30,
  cipLib: "PARAPSYLLIUM BUV PDR SACH BT 30",
  atcCode: "A06AA51"
}, {
  CIP7: '3054835',
  CIP13: '3400930548356',
  ucdLib: "JAMYLENE 50MG CPR",
  UCD7: '9047954',
  UCD13: '3400890479547',
  ucdQtyMultiplicator: 40,
  cipLib: "JAMYLENE 50MG CPR BT 40",
  atcCode: "A06AA02"
}, {
  CIP7: '3062935',
  CIP13: '3400930629352',
  ucdLib: "LUBENTYL GELE POT 250G",
  UCD7: '9055190',
  UCD13: '3400890551908',
  ucdQtyMultiplicator: 1,
  cipLib: "LUBENTYL GELE POT 250G BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3057035',
  CIP13: '3400930570357',
  ucdLib: "LANSOYL GELE POT 225G",
  UCD7: '9049663',
  UCD13: '3400890496636',
  ucdQtyMultiplicator: 1,
  cipLib: "LANSOYL GELE POT 225G BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3324499',
  CIP13: '3400933244996',
  ucdLib: "HUILE PARAFFINE GIL FV500ML",
  UCD7: '9141222',
  UCD13: '3400891412222',
  ucdQtyMultiplicator: 1,
  cipLib: "HUILE PARAFFINE GIL FV500ML BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3323407',
  CIP13: '3400933234072',
  ucdLib: "LANSOYL SS SUC GELE FV215G",
  UCD7: '9163985',
  UCD13: '3400891639858',
  ucdQtyMultiplicator: 1,
  cipLib: "LANSOYL SS SUC GELE FV215G BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3338969',
  CIP13: '3400933389697',
  ucdLib: "HUILE PARAFFINE GIL 250ML",
  UCD7: '9156212',
  UCD13: '3400891562125',
  ucdQtyMultiplicator: 1,
  cipLib: "HUILE PARAFFINE GIL 250ML BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3437217',
  CIP13: '3400934372179',
  ucdLib: "HUILE PARAFFINE CPF FL250ML",
  UCD7: '9201071',
  UCD13: '3400892010717',
  ucdQtyMultiplicator: 1,
  cipLib: "HUILE PARAFFINE CPF FL250ML BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3437223',
  CIP13: '3400934372230',
  ucdLib: "HUILE PARAFFINE CPF FL500ML",
  UCD7: '9199090',
  UCD13: '3400891990904',
  ucdQtyMultiplicator: 1,
  cipLib: "HUILE PARAFFINE CPF FL500ML BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3129510',
  CIP13: '3400931295105',
  ucdLib: "HUILE PARAFFINE GIFRER 250ML",
  UCD7: '9044559',
  UCD13: '3400890445597',
  ucdQtyMultiplicator: 1,
  cipLib: "HUILE PARAFFINE GIFRER 250ML BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3129527',
  CIP13: '3400931295273',
  ucdLib: "HUILE PARAFFINE GIFRER 500ML",
  UCD7: '9112858',
  UCD13: '3400891128581',
  ucdQtyMultiplicator: 1,
  cipLib: "HUILE PARAFFINE GIFRER 500ML BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3131441',
  CIP13: '3400931314417',
  ucdLib: "RESTRICAL ESTRAGON BUV FL500ML",
  UCD7: '9079227',
  UCD13: '3400890792271',
  ucdQtyMultiplicator: 1,
  cipLib: "RESTRICAL ESTRAGON BUV FL500ML BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3369711',
  CIP13: '3400933697112',
  ucdLib: "TRANSITOL GELE ORAL POT200G",
  UCD7: '9162299',
  UCD13: '3400891622997',
  ucdQtyMultiplicator: 1,
  cipLib: "TRANSITOL GELE ORAL POT200G BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3544462',
  CIP13: '3400935444622',
  ucdLib: "LANSOYL FRAMB. GEL UNIDOS",
  UCD7: '9224379',
  UCD13: '3400892243795',
  ucdQtyMultiplicator: 9,
  cipLib: "LANSOYL FRAMB. GEL UNIDOS BT 9",
  atcCode: "A06AA01"
}, {
  CIP7: '3544479',
  CIP13: '3400935444790',
  ucdLib: "LANSOYL FRAMB. GEL UNIDOS",
  UCD7: '9224379',
  UCD13: '3400892243795',
  ucdQtyMultiplicator: 220,
  cipLib: "LANSOYL FRAMB. GEL UNIDOS BT 220",
  atcCode: "A06AA01"
}, {
  CIP7: '3175929',
  CIP13: '3400931759294',
  ucdLib: "RESTRICAL NOISETTE BUV FL500ML",
  UCD7: '9079233',
  UCD13: '3400890792332',
  ucdQtyMultiplicator: 1,
  cipLib: "RESTRICAL NOISETTE BUV FL500ML BT 1",
  atcCode: "A06AA01"
}, {
  CIP7: '3617103',
  CIP13: '3400936171039',
  ucdLib: "OXYBOLDINE CPR EFFV",
  UCD7: '9066532',
  UCD13: '3400890665322',
  ucdQtyMultiplicator: 24,
  cipLib: "OXYBOLDINE CPR EFFV BT 24",
  atcCode: "A05C"
}, {
  CIP7: '3158428',
  CIP13: '3400931584285',
  ucdLib: "TIADILON 100MG GELU",
  UCD7: '9105947',
  UCD13: '3400891059472',
  ucdQtyMultiplicator: 20,
  cipLib: "TIADILON 100MG GELU BT 20",
  atcCode: "A05BA07"
}, {
  CIP7: '3164110',
  CIP13: '3400931641100',
  ucdLib: "LEGALON 70MG CPR",
  UCD7: '9050293',
  UCD13: '3400890502931',
  ucdQtyMultiplicator: 40,
  cipLib: "LEGALON 70MG CPR BT 40",
  atcCode: "A05BA03"
}, {
  CIP7: '3219213',
  CIP13: '3400932192137',
  ucdLib: "CANTABILINE 400MG CPR",
  UCD7: '9015983',
  UCD13: '3400890159838',
  ucdQtyMultiplicator: 30,
  cipLib: "CANTABILINE 400MG CPR BT 30",
  atcCode: "A05AX02"
}, {
  CIP7: '5890088',
  CIP13: '3400958900884',
  ucdLib: "OCALIVA 5MG CPR PELLIC",
  UCD7: '9421944',
  UCD13: '3400894219446',
  ucdQtyMultiplicator: 100,
  cipLib: "OCALIVA 5MG CPR PELLIC BT 100",
  atcCode: "A05AA04"
}, {
  CIP7: '2787926',
  CIP13: '3400927879265',
  ucdLib: "KOLBAM 250MG GELU",
  UCD7: '9404621',
  UCD13: '3400894046219',
  ucdQtyMultiplicator: 90,
  cipLib: "KOLBAM 250MG GELU BT 90",
  atcCode: "A05AA03"
}, {
  CIP7: '2787903',
  CIP13: '3400927879036',
  ucdLib: "KOLBAM 50MG GELU",
  UCD7: '9404638',
  UCD13: '3400894046387',
  ucdQtyMultiplicator: 90,
  cipLib: "KOLBAM 50MG GELU BT 90",
  atcCode: "A05AA03"
}, {
  CIP7: '4168908',
  CIP13: '3400941689086',
  ucdLib: "ORPHACOL 250MG GELU",
  UCD7: '9323064',
  UCD13: '3400893230640',
  ucdQtyMultiplicator: 30,
  cipLib: "ORPHACOL 250MG GELU BT 30",
  atcCode: "A05AA03"
}, {
  CIP7: '4168860',
  CIP13: '3400941688607',
  ucdLib: "ORPHACOL 50MG GELU",
  UCD7: '9323070',
  UCD13: '3400893230701',
  ucdQtyMultiplicator: 30,
  cipLib: "ORPHACOL 50MG GELU BT 30",
  atcCode: "A05AA03"
}, {
  CIP7: '3234164',
  CIP13: '3400932341641',
  ucdLib: "DELURSAN 250MG CPR",
  UCD7: '9024812',
  UCD13: '3400890248129',
  ucdQtyMultiplicator: 20,
  cipLib: "DELURSAN 250MG CPR BT 20",
  atcCode: "A05AA02"
}, {
  CIP7: '3234075',
  CIP13: '3400932340750',
  ucdLib: "URSOLVAN 200MG GELU",
  UCD7: '9096929',
  UCD13: '3400890969291',
  ucdQtyMultiplicator: 30,
  cipLib: "URSOLVAN 200MG GELU BT 30",
  atcCode: "A05AA02"
}, {
  CIP7: '2190619',
  CIP13: '3400921906196',
  ucdLib: "CHOLURSO 250MG CPR",
  UCD7: '9385875',
  UCD13: '3400893858752',
  ucdQtyMultiplicator: 50,
  cipLib: "CHOLURSO 250MG CPR BT 50",
  atcCode: "A05AA02"
}, {
  CIP7: '2190625',
  CIP13: '3400921906257',
  ucdLib: "CHOLURSO 250MG CPR",
  UCD7: '9385875',
  UCD13: '3400893858752',
  ucdQtyMultiplicator: 60,
  cipLib: "CHOLURSO 250MG CPR BT 60",
  atcCode: "A05AA02"
}, {
  CIP7: '2190654',
  CIP13: '3400921906547',
  ucdLib: "CHOLURSO 500MG CPR",
  UCD7: '9385881',
  UCD13: '3400893858813',
  ucdQtyMultiplicator: 50,
  cipLib: "CHOLURSO 500MG CPR BT 50",
  atcCode: "A05AA02"
}, {
  CIP7: '2190660',
  CIP13: '3400921906608',
  ucdLib: "CHOLURSO 500MG CPR",
  UCD7: '9385881',
  UCD13: '3400893858813',
  ucdQtyMultiplicator: 60,
  cipLib: "CHOLURSO 500MG CPR BT 60",
  atcCode: "A05AA02"
}, {
  CIP7: '2193121',
  CIP13: '3400921931211',
  ucdLib: "DELURSAN 500MG CPR",
  UCD7: '9384657',
  UCD13: '3400893846575',
  ucdQtyMultiplicator: 60,
  cipLib: "DELURSAN 500MG CPR BT 60",
  atcCode: "A05AA02"
}, {
  CIP7: '2233458',
  CIP13: '3400922334585',
  ucdLib: "ACID.URSODESOX.BGA 250MG CPR",
  UCD7: '9388448',
  UCD13: '3400893884485',
  ucdQtyMultiplicator: 20,
  cipLib: "ACID.URSODESOX.BGA 250MG CPR BT 20",
  atcCode: "A05AA02"
}, {
  CIP7: '2233398',
  CIP13: '3400922333984',
  ucdLib: "ACID.URSODESOX.MYL 250MG CPR",
  UCD7: '9391054',
  UCD13: '3400893910542',
  ucdQtyMultiplicator: 20,
  cipLib: "ACID.URSODESOX.MYL 250MG CPR BT 20",
  atcCode: "A05AA02"
}, {
  CIP7: '2233429',
  CIP13: '3400922334295',
  ucdLib: "ACID.URSODESOX.TVC 250MG CPR",
  UCD7: '9388454',
  UCD13: '3400893884546',
  ucdQtyMultiplicator: 20,
  cipLib: "ACID.URSODESOX.TVC 250MG CPR BT 20",
  atcCode: "A05AA02"
}, {
  CIP7: '3635118',
  CIP13: '3400936351189',
  ucdLib: "EMEND 125MG(1)+80MG(2) GELU",
  UCD7: '9258065',
  UCD13: '3400892580654',
  ucdQtyMultiplicator: 3,
  cipLib: "EMEND 125MG(1)+80MG(2) GELU BT 3",
  atcCode: "A04AD12"
}, {
  CIP7: '3635070',
  CIP13: '3400936350700',
  ucdLib: "EMEND 80MG GELU",
  UCD7: '9258071',
  UCD13: '3400892580715',
  ucdQtyMultiplicator: 2,
  cipLib: "EMEND 80MG GELU BT 2",
  atcCode: "A04AD12"
}, {
  CIP7: '5649314',
  CIP13: '3400956493142',
  ucdLib: "EMEND 125MG GELU",
  UCD7: '9258059',
  UCD13: '3400892580593',
  ucdQtyMultiplicator: 5,
  cipLib: "EMEND 125MG GELU BT 5",
  atcCode: "A04AD12"
}, {
  CIP7: '5649308',
  CIP13: '3400956493081',
  ucdLib: "EMEND 80MG GELU",
  UCD7: '9258071',
  UCD13: '3400892580715',
  ucdQtyMultiplicator: 5,
  cipLib: "EMEND 80MG GELU BT 5",
  atcCode: "A04AD12"
}, {
  CIP7: '3114945',
  CIP13: '3400931149453',
  ucdLib: "VOGALENE 10MG INJ AMP1ML",
  UCD7: '9101056',
  UCD13: '3400891010565',
  ucdQtyMultiplicator: 10,
  cipLib: "VOGALENE 10MG INJ AMP1ML BT 10",
  atcCode: "A04AD05"
}, {
  CIP7: '3331625',
  CIP13: '3400933316259',
  ucdLib: "VOGALENE LYOC 7,5MG LYOT",
  UCD7: '9152131',
  UCD13: '3400891521313',
  ucdQtyMultiplicator: 16,
  cipLib: "VOGALENE LYOC 7,5MG LYOT BT 16",
  atcCode: "A04AD05"
}, {
  CIP7: '3205441',
  CIP13: '3400932054411',
  ucdLib: "VOGALENE 15MG GELU",
  UCD7: '9122489',
  UCD13: '3400891224894',
  ucdQtyMultiplicator: 20,
  cipLib: "VOGALENE 15MG GELU BT 20",
  atcCode: "A04AD05"
}, {
  CIP7: '3171481',
  CIP13: '3400931714811',
  ucdLib: "VOGALENE 0,1% BUV FL150ML",
  UCD7: '9101091',
  UCD13: '3400891010916',
  ucdQtyMultiplicator: 1,
  cipLib: "VOGALENE 0,1% BUV FL150ML BT 1",
  atcCode: "A04AD05"
}, {
  CIP7: '3634828',
  CIP13: '3400936348288',
  ucdLib: "VOGALIB 7,5MG S/SUC LYOT",
  UCD7: '9257019',
  UCD13: '3400892570198',
  ucdQtyMultiplicator: 8,
  cipLib: "VOGALIB 7,5MG S/SUC LYOT BT 8",
  atcCode: "A04AD05"
}, {
  CIP7: '3649793',
  CIP13: '3400936497931',
  ucdLib: "VOGALENE 5MG SUP SECAB",
  UCD7: '9267526',
  UCD13: '3400892675268',
  ucdQtyMultiplicator: 10,
  cipLib: "VOGALENE 5MG SUP SECAB BT 10",
  atcCode: "A04AD05"
}, {
  CIP7: '3284943',
  CIP13: '3400932849437',
  ucdLib: "SCOPODERM TTS 1MG/72H DISP",
  UCD7: '9106823',
  UCD13: '3400891068238',
  ucdQtyMultiplicator: 5,
  cipLib: "SCOPODERM TTS 1MG/72H DISP BT 5",
  atcCode: "A04AD01"
}, {
  CIP7: '3476329',
  CIP13: '3400934763298',
  ucdLib: "SCOPOLAMINE CPF 0,5MG A.2ML",
  UCD7: '9207406',
  UCD13: '3400892074061',
  ucdQtyMultiplicator: 10,
  cipLib: "SCOPOLAMINE CPF 0,5MG A.2ML BT 10",
  atcCode: "A04AD01"
}, {
  CIP7: '3476335',
  CIP13: '3400934763359',
  ucdLib: "SCOPOLAMINE CPF 0,5MG A.2ML",
  UCD7: '9207406',
  UCD13: '3400892074061',
  ucdQtyMultiplicator: 50,
  cipLib: "SCOPOLAMINE CPF 0,5MG A.2ML BT 50",
  atcCode: "A04AD01"
}, {
  CIP7: '5758486',
  CIP13: '3400957584863',
  ucdLib: "SCOPODERM TTS 1MG/72H DISP",
  UCD7: '9106823',
  UCD13: '3400891068238',
  ucdQtyMultiplicator: 30,
  cipLib: "SCOPODERM TTS 1MG/72H DISP BT 30",
  atcCode: "A04AD01"
}, {
  CIP7: '5659821',
  CIP13: '3400956598212',
  ucdLib: "SCOPOLAMINE REN 0,025% A2ML",
  UCD7: '9284619',
  UCD13: '3400892846194',
  ucdQtyMultiplicator: 100,
  cipLib: "SCOPOLAMINE REN 0,025% A2ML BT 100",
  atcCode: "A04AD01"
}, {
  CIP7: '3754828',
  CIP13: '3400937548281',
  ucdLib: "ALOXI 250MCG INJ FL5ML",
  UCD7: '9301097',
  UCD13: '3400893010976',
  ucdQtyMultiplicator: 1,
  cipLib: "ALOXI 250MCG INJ FL5ML BT 1",
  atcCode: "A04AA05"
}, {
  CIP7: '3371576',
  CIP13: '3400933715762',
  ucdLib: "KYTRIL 1MG CPR",
  UCD7: '9167747',
  UCD13: '3400891677478',
  ucdQtyMultiplicator: 2,
  cipLib: "KYTRIL 1MG CPR BT 2",
  atcCode: "A04AA02"
}, {
  CIP7: '3371582',
  CIP13: '3400933715823',
  ucdLib: "KYTRIL 1MG CPR",
  UCD7: '9167747',
  UCD13: '3400891677478',
  ucdQtyMultiplicator: 10,
  cipLib: "KYTRIL 1MG CPR BT 10",
  atcCode: "A04AA02"
}, {
  CIP7: '3430155',
  CIP13: '3400934301551',
  ucdLib: "KYTRIL 2MG CPR",
  UCD7: '9197300',
  UCD13: '3400891973006',
  ucdQtyMultiplicator: 1,
  cipLib: "KYTRIL 2MG CPR BT 1",
  atcCode: "A04AA02"
}, {
  CIP7: '3430161',
  CIP13: '3400934301612',
  ucdLib: "KYTRIL 2MG CPR",
  UCD7: '9197300',
  UCD13: '3400891973006',
  ucdQtyMultiplicator: 5,
  cipLib: "KYTRIL 2MG CPR BT 5",
  atcCode: "A04AA02"
}, {
  CIP7: '3393543',
  CIP13: '3400933935436',
  ucdLib: "KYTRIL 3MG INJ AMP3ML",
  UCD7: '9149436',
  UCD13: '3400891494365',
  ucdQtyMultiplicator: 1,
  cipLib: "KYTRIL 3MG INJ AMP3ML BT 1",
  atcCode: "A04AA02"
}, {
  CIP7: '3393566',
  CIP13: '3400933935665',
  ucdLib: "KYTRIL 3MG INJ AMP3ML",
  UCD7: '9149436',
  UCD13: '3400891494365',
  ucdQtyMultiplicator: 5,
  cipLib: "KYTRIL 3MG INJ AMP3ML BT 5",
  atcCode: "A04AA02"
}, {
  CIP7: '3920089',
  CIP13: '3400939200897',
  ucdLib: "GRANISETRON BBM 3MG IV A.3ML",
  UCD7: '9337043',
  UCD13: '3400893370438',
  ucdQtyMultiplicator: 5,
  cipLib: "GRANISETRON BBM 3MG IV A.3ML BT 5",
  atcCode: "A04AA02"
}, {
  CIP7: '3867685',
  CIP13: '3400938676853',
  ucdLib: "GRANISETRON TVC 3MG IV FL3ML",
  UCD7: '9320864',
  UCD13: '3400893208649',
  ucdQtyMultiplicator: 1,
  cipLib: "GRANISETRON TVC 3MG IV FL3ML BT 1",
  atcCode: "A04AA02"
}, {
  CIP7: '3616368',
  CIP13: '3400936163683',
  ucdLib: "ZOPHREN 4MG CPR",
  UCD7: '9142517',
  UCD13: '3400891425178',
  ucdQtyMultiplicator: 2,
  cipLib: "ZOPHREN 4MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3616380',
  CIP13: '3400936163805',
  ucdLib: "ZOPHREN 4MG CPR",
  UCD7: '9142517',
  UCD13: '3400891425178',
  ucdQtyMultiplicator: 4,
  cipLib: "ZOPHREN 4MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3616405',
  CIP13: '3400936164055',
  ucdLib: "ZOPHREN 4MG CPR",
  UCD7: '9142517',
  UCD13: '3400891425178',
  ucdQtyMultiplicator: 10,
  cipLib: "ZOPHREN 4MG CPR BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '3616204',
  CIP13: '3400936162044',
  ucdLib: "ZOPHREN 8MG CPR",
  UCD7: '9142523',
  UCD13: '3400891425239',
  ucdQtyMultiplicator: 4,
  cipLib: "ZOPHREN 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3616411',
  CIP13: '3400936164116',
  ucdLib: "ZOPHREN 8MG CPR",
  UCD7: '9142523',
  UCD13: '3400891425239',
  ucdQtyMultiplicator: 2,
  cipLib: "ZOPHREN 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3619734',
  CIP13: '3400936197343',
  ucdLib: "ZOPHREN 8MG CPR",
  UCD7: '9142523',
  UCD13: '3400891425239',
  ucdQtyMultiplicator: 10,
  cipLib: "ZOPHREN 8MG CPR BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5568314',
  CIP13: '3400955683148',
  ucdLib: "ZOPHREN 2MG/ML INJ AMP2ML",
  UCD7: '9142492',
  UCD13: '3400891424928',
  ucdQtyMultiplicator: 5,
  cipLib: "ZOPHREN 2MG/ML INJ AMP2ML BT 5",
  atcCode: "A04AA01"
}, {
  CIP7: '5568320',
  CIP13: '3400955683209',
  ucdLib: "ZOPHREN 2MG/ML INJ AMP4ML",
  UCD7: '9142500',
  UCD13: '3400891425000',
  ucdQtyMultiplicator: 5,
  cipLib: "ZOPHREN 2MG/ML INJ AMP4ML BT 5",
  atcCode: "A04AA01"
}, {
  CIP7: '3438808',
  CIP13: '3400934388088',
  ucdLib: "ZOPHREN 16MG SUP",
  UCD7: '9212040',
  UCD13: '3400892120409',
  ucdQtyMultiplicator: 2,
  cipLib: "ZOPHREN 16MG SUP BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3438814',
  CIP13: '3400934388149',
  ucdLib: "ZOPHREN 16MG SUP",
  UCD7: '9212040',
  UCD13: '3400892120409',
  ucdQtyMultiplicator: 5,
  cipLib: "ZOPHREN 16MG SUP BT 5",
  atcCode: "A04AA01"
}, {
  CIP7: '3439446',
  CIP13: '3400934394461',
  ucdLib: "ZOPHREN 4MG LYOT ORAL",
  UCD7: '9203868',
  UCD13: '3400892038681',
  ucdQtyMultiplicator: 2,
  cipLib: "ZOPHREN 4MG LYOT ORAL BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3439452',
  CIP13: '3400934394522',
  ucdLib: "ZOPHREN 4MG LYOT ORAL",
  UCD7: '9203868',
  UCD13: '3400892038681',
  ucdQtyMultiplicator: 4,
  cipLib: "ZOPHREN 4MG LYOT ORAL BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3439475',
  CIP13: '3400934394751',
  ucdLib: "ZOPHREN 4MG LYOT ORAL",
  UCD7: '9203868',
  UCD13: '3400892038681',
  ucdQtyMultiplicator: 10,
  cipLib: "ZOPHREN 4MG LYOT ORAL BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '3439481',
  CIP13: '3400934394812',
  ucdLib: "ZOPHREN 8MG LYOT ORAL",
  UCD7: '9203874',
  UCD13: '3400892038742',
  ucdQtyMultiplicator: 2,
  cipLib: "ZOPHREN 8MG LYOT ORAL BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3439498',
  CIP13: '3400934394980',
  ucdLib: "ZOPHREN 8MG LYOT ORAL",
  UCD7: '9203874',
  UCD13: '3400892038742',
  ucdQtyMultiplicator: 4,
  cipLib: "ZOPHREN 8MG LYOT ORAL BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3439512',
  CIP13: '3400934395123',
  ucdLib: "ZOPHREN 8MG LYOT ORAL",
  UCD7: '9203874',
  UCD13: '3400892038742',
  ucdQtyMultiplicator: 10,
  cipLib: "ZOPHREN 8MG LYOT ORAL BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '3353928',
  CIP13: '3400933539283',
  ucdLib: "ZOPHREN 2MG/ML INJ AMP2ML",
  UCD7: '9142492',
  UCD13: '3400891424928',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOPHREN 2MG/ML INJ AMP2ML BT 1",
  atcCode: "A04AA01"
}, {
  CIP7: '3353934',
  CIP13: '3400933539344',
  ucdLib: "ZOPHREN 2MG/ML INJ AMP4ML",
  UCD7: '9142500',
  UCD13: '3400891425000',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOPHREN 2MG/ML INJ AMP4ML BT 1",
  atcCode: "A04AA01"
}, {
  CIP7: '3416563',
  CIP13: '3400934165634',
  ucdLib: "ZOPHREN 4MG/5ML SIR FL50ML",
  UCD7: '9198073',
  UCD13: '3400891980738',
  ucdQtyMultiplicator: 1,
  cipLib: "ZOPHREN 4MG/5ML SIR FL50ML BT 1",
  atcCode: "A04AA01"
}, {
  CIP7: '3763520',
  CIP13: '3400937635202',
  ucdLib: "ONDANSETRON BGA 8MG CPR",
  UCD7: '9294138',
  UCD13: '3400892941387',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON BGA 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3763543',
  CIP13: '3400937635431',
  ucdLib: "ONDANSETRON BGA 8MG CPR",
  UCD7: '9294138',
  UCD13: '3400892941387',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON BGA 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3768687',
  CIP13: '3400937686877',
  ucdLib: "ONDANSETRON EG 8MG CPR",
  UCD7: '9294167',
  UCD13: '3400892941677',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON EG 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3768693',
  CIP13: '3400937686938',
  ucdLib: "ONDANSETRON EG 8MG CPR",
  UCD7: '9294167',
  UCD13: '3400892941677',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON EG 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3766926',
  CIP13: '3400937669269',
  ucdLib: "ONDANSETRON MYL2MG/ML INJ 2ML",
  UCD7: '9296261',
  UCD13: '3400892962610',
  ucdQtyMultiplicator: 1,
  cipLib: "ONDANSETRON MYL2MG/ML INJ 2ML BT 1",
  atcCode: "A04AA01"
}, {
  CIP7: '3766932',
  CIP13: '3400937669320',
  ucdLib: "ONDANSETRON MYL2MG/ML INJ 4ML",
  UCD7: '9296278',
  UCD13: '3400892962788',
  ucdQtyMultiplicator: 1,
  cipLib: "ONDANSETRON MYL2MG/ML INJ 4ML BT 1",
  atcCode: "A04AA01"
}, {
  CIP7: '3761567',
  CIP13: '3400937615679',
  ucdLib: "ONDANSETRON SDZ 8MG CPR",
  UCD7: '9294173',
  UCD13: '3400892941738',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON SDZ 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3761596',
  CIP13: '3400937615969',
  ucdLib: "ONDANSETRON SDZ 8MG CPR",
  UCD7: '9294173',
  UCD13: '3400892941738',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON SDZ 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3813465',
  CIP13: '3400938134650',
  ucdLib: "ONDANSETRON TVC 8MG CPR",
  UCD7: '9307496',
  UCD13: '3400893074961',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON TVC 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3763626',
  CIP13: '3400937636261',
  ucdLib: "ONDANSETRON ZEN 8MG CPR",
  UCD7: '9294196',
  UCD13: '3400892941967',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON ZEN 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3763632',
  CIP13: '3400937636322',
  ucdLib: "ONDANSETRON ZEN 8MG CPR",
  UCD7: '9294196',
  UCD13: '3400892941967',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON ZEN 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3777870',
  CIP13: '3400937778701',
  ucdLib: "ONDANSETRON ARW 8MG CPR",
  UCD7: '9307326',
  UCD13: '3400893073261',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON ARW 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3777887',
  CIP13: '3400937778879',
  ucdLib: "ONDANSETRON ARW 8MG CPR",
  UCD7: '9307326',
  UCD13: '3400893073261',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON ARW 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3781512',
  CIP13: '3400937815123',
  ucdLib: "ONDANSETRON ARW 8MG CPR DISP",
  UCD7: '9297639',
  UCD13: '3400892976396',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON ARW 8MG CPR DISP BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3781529',
  CIP13: '3400937815291',
  ucdLib: "ONDANSETRON ARW 8MG CPR DISP",
  UCD7: '9297639',
  UCD13: '3400892976396',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON ARW 8MG CPR DISP BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3781883',
  CIP13: '3400937818834',
  ucdLib: "ONDANSETRON BGA 8MG CPR DISP",
  UCD7: '9297645',
  UCD13: '3400892976457',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON BGA 8MG CPR DISP BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3781908',
  CIP13: '3400937819084',
  ucdLib: "ONDANSETRON BGA 8MG CPR DISP",
  UCD7: '9297645',
  UCD13: '3400892976457',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON BGA 8MG CPR DISP BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3781989',
  CIP13: '3400937819893',
  ucdLib: "ONDANSETRON EG 8MG CPR DISP",
  UCD7: '9297651',
  UCD13: '3400892976518',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON EG 8MG CPR DISP BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3781995',
  CIP13: '3400937819954',
  ucdLib: "ONDANSETRON EG 8MG CPR DISP",
  UCD7: '9297651',
  UCD13: '3400892976518',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON EG 8MG CPR DISP BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3776310',
  CIP13: '3400937763103',
  ucdLib: "ONDANSETRON MYL 8MG CPR",
  UCD7: '9297668',
  UCD13: '3400892976686',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON MYL 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3776327',
  CIP13: '3400937763271',
  ucdLib: "ONDANSETRON MYL 8MG CPR",
  UCD7: '9297668',
  UCD13: '3400892976686',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON MYL 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '5698577',
  CIP13: '3400956985777',
  ucdLib: "ONDANSETRON MYL2MG/ML INJ 2ML",
  UCD7: '9296261',
  UCD13: '3400892962610',
  ucdQtyMultiplicator: 5,
  cipLib: "ONDANSETRON MYL2MG/ML INJ 2ML BT 5",
  atcCode: "A04AA01"
}, {
  CIP7: '5698614',
  CIP13: '3400956986149',
  ucdLib: "ONDANSETRON MYL2MG/ML INJ 4ML",
  UCD7: '9296278',
  UCD13: '3400892962788',
  ucdQtyMultiplicator: 5,
  cipLib: "ONDANSETRON MYL2MG/ML INJ 4ML BT 5",
  atcCode: "A04AA01"
}, {
  CIP7: '3828403',
  CIP13: '3400938284034',
  ucdLib: "ONDANSETRON ZEN 8MG CPR DISP",
  UCD7: '9312422',
  UCD13: '3400893124222',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON ZEN 8MG CPR DISP BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3828426',
  CIP13: '3400938284263',
  ucdLib: "ONDANSETRON ZEN 8MG CPR DISP",
  UCD7: '9312422',
  UCD13: '3400893124222',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON ZEN 8MG CPR DISP BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3823989',
  CIP13: '3400938239898',
  ucdLib: "ONDANSETRON ZYD 8MG CPR",
  UCD7: '9308604',
  UCD13: '3400893086049',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON ZYD 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3824003',
  CIP13: '3400938240030',
  ucdLib: "ONDANSETRON ZYD 8MG CPR",
  UCD7: '9308604',
  UCD13: '3400893086049',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON ZYD 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3823854',
  CIP13: '3400938238549',
  ucdLib: "ONDANSETRON ZYD 8MG CPR DISP",
  UCD7: '9308596',
  UCD13: '3400893085967',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON ZYD 8MG CPR DISP BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3823860',
  CIP13: '3400938238600',
  ucdLib: "ONDANSETRON ZYD 8MG CPR DISP",
  UCD7: '9308596',
  UCD13: '3400893085967',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON ZYD 8MG CPR DISP BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '5500321',
  CIP13: '3400955003212',
  ucdLib: "ONDANSETRON ACC2MG/ML AVB2ML",
  UCD7: '9409541',
  UCD13: '3400894095415',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON ACC2MG/ML AVB2ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5500324',
  CIP13: '3400955003243',
  ucdLib: "ONDANSETRON ACC2MG/ML AVB4ML",
  UCD7: '9409558',
  UCD13: '3400894095583',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON ACC2MG/ML AVB4ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '3949130',
  CIP13: '3400939491301',
  ucdLib: "ONDANSETRON CRT 8MG CPR",
  UCD7: '9338284',
  UCD13: '3400893382844',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON CRT 8MG CPR BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3949153',
  CIP13: '3400939491530',
  ucdLib: "ONDANSETRON CRT 8MG CPR",
  UCD7: '9338284',
  UCD13: '3400893382844',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON CRT 8MG CPR BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '3949087',
  CIP13: '3400939490878',
  ucdLib: "ONDANSETRON CRT 8MG CPR DISP",
  UCD7: '9338278',
  UCD13: '3400893382783',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON CRT 8MG CPR DISP BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '3949093',
  CIP13: '3400939490939',
  ucdLib: "ONDANSETRON CRT 8MG CPR DISP",
  UCD7: '9338278',
  UCD13: '3400893382783',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON CRT 8MG CPR DISP BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '4991499',
  CIP13: '3400949914999',
  ucdLib: "ONDANSETRON MYL 8MG CPR DISP",
  UCD7: '9299868',
  UCD13: '3400892998688',
  ucdQtyMultiplicator: 2,
  cipLib: "ONDANSETRON MYL 8MG CPR DISP BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '4991507',
  CIP13: '3400949915071',
  ucdLib: "ONDANSETRON MYL 8MG CPR DISP",
  UCD7: '9299868',
  UCD13: '3400892998688',
  ucdQtyMultiplicator: 4,
  cipLib: "ONDANSETRON MYL 8MG CPR DISP BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '5751768',
  CIP13: '3400957517687',
  ucdLib: "ONDANSETRON ACC2MG/ML AVI2ML",
  UCD7: '9334932',
  UCD13: '3400893349328',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON ACC2MG/ML AVI2ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5751774',
  CIP13: '3400957517748',
  ucdLib: "ONDANSETRON ACC2MG/ML AVI4ML",
  UCD7: '9334949',
  UCD13: '3400893349496',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON ACC2MG/ML AVI4ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5708985',
  CIP13: '3400957089856',
  ucdLib: "ONDANSETRON AGT2MG/ML INJ2ML",
  UCD7: '9300376',
  UCD13: '3400893003763',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON AGT2MG/ML INJ2ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5708991',
  CIP13: '3400957089917',
  ucdLib: "ONDANSETRON AGT2MG/ML INJ4ML",
  UCD7: '9300382',
  UCD13: '3400893003824',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON AGT2MG/ML INJ4ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5706897',
  CIP13: '3400957068974',
  ucdLib: "ONDANSETRON REN2MG/ML IV 2ML",
  UCD7: '9301275',
  UCD13: '3400893012758',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON REN2MG/ML IV 2ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5706940',
  CIP13: '3400957069407',
  ucdLib: "ONDANSETRON REN2MG/ML IV 4ML",
  UCD7: '9301281',
  UCD13: '3400893012819',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON REN2MG/ML IV 4ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '2736900',
  CIP13: '3400927369001',
  ucdLib: "SETOFILM 4MG FILM DISP SACH",
  UCD7: '9362242',
  UCD13: '3400893622421',
  ucdQtyMultiplicator: 2,
  cipLib: "SETOFILM 4MG FILM DISP SACH BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '2736917',
  CIP13: '3400927369179',
  ucdLib: "SETOFILM 4MG FILM DISP SACH",
  UCD7: '9362242',
  UCD13: '3400893622421',
  ucdQtyMultiplicator: 4,
  cipLib: "SETOFILM 4MG FILM DISP SACH BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '2736923',
  CIP13: '3400927369230',
  ucdLib: "SETOFILM 8MG FILM DISP SACH",
  UCD7: '9362259',
  UCD13: '3400893622599',
  ucdQtyMultiplicator: 2,
  cipLib: "SETOFILM 8MG FILM DISP SACH BT 2",
  atcCode: "A04AA01"
}, {
  CIP7: '2736946',
  CIP13: '3400927369469',
  ucdLib: "SETOFILM 8MG FILM DISP SACH",
  UCD7: '9362259',
  UCD13: '3400893622599',
  ucdQtyMultiplicator: 4,
  cipLib: "SETOFILM 8MG FILM DISP SACH BT 4",
  atcCode: "A04AA01"
}, {
  CIP7: '5779577',
  CIP13: '3400957795771',
  ucdLib: "ONDANSETRON KBI2MG/ML INJ 2ML",
  UCD7: '9364318',
  UCD13: '3400893643181',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON KBI2MG/ML INJ 2ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5779614',
  CIP13: '3400957796143',
  ucdLib: "ONDANSETRON KBI2MG/ML INJ 4ML",
  UCD7: '9364324',
  UCD13: '3400893643242',
  ucdQtyMultiplicator: 10,
  cipLib: "ONDANSETRON KBI2MG/ML INJ 4ML BT 10",
  atcCode: "A04AA01"
}, {
  CIP7: '5842927',
  CIP13: '3400958429279',
  ucdLib: "SETOFILM 4MG FILM DISP SACH",
  UCD7: '9362242',
  UCD13: '3400893622421',
  ucdQtyMultiplicator: 30,
  cipLib: "SETOFILM 4MG FILM DISP SACH BT 30",
  atcCode: "A04AA01"
}, {
  CIP7: '5842933',
  CIP13: '3400958429330',
  ucdLib: "SETOFILM 8MG FILM DISP SACH",
  UCD7: '9362259',
  UCD13: '3400893622599',
  ucdQtyMultiplicator: 30,
  cipLib: "SETOFILM 8MG FILM DISP SACH BT 30",
  atcCode: "A04AA01"
}, {
  CIP7: '3248640',
  CIP13: '3400932486403',
  ucdLib: "PLITICAN CPR",
  UCD7: '9072716',
  UCD13: '3400890727167',
  ucdQtyMultiplicator: 12,
  cipLib: "PLITICAN CPR BT 12",
  atcCode: "A03FA05"
}, {
  CIP7: '3224148',
  CIP13: '3400932241484',
  ucdLib: "PLITICAN 50MG INJ AMP2ML",
  UCD7: '9072691',
  UCD13: '3400890726917',
  ucdQtyMultiplicator: 6,
  cipLib: "PLITICAN 50MG INJ AMP2ML BT 6",
  atcCode: "A03FA05"
}, {
  CIP7: '3001786',
  CIP13: '3400930017869',
  ucdLib: "DOMPERIDONE BGA 10MG CPR",
  UCD7: '9250135',
  UCD13: '3400892501352',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE BGA 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3006008',
  CIP13: '3400930060087',
  ucdLib: "DOMPERIDONE BGA 10MG CPR",
  UCD7: '9250135',
  UCD13: '3400892501352',
  ucdQtyMultiplicator: 20,
  cipLib: "DOMPERIDONE BGA 10MG CPR BT 20",
  atcCode: "A03FA03"
}, {
  CIP7: '3005951',
  CIP13: '3400930059517',
  ucdLib: "DOMPERIDONE MYL 10MG CPR",
  UCD7: '9254386',
  UCD13: '3400892543864',
  ucdQtyMultiplicator: 20,
  cipLib: "DOMPERIDONE MYL 10MG CPR BT 20",
  atcCode: "A03FA03"
}, {
  CIP7: '3234112',
  CIP13: '3400932341122',
  ucdLib: "MOTILIUM 10MG CPR",
  UCD7: '9059868',
  UCD13: '3400890598682',
  ucdQtyMultiplicator: 40,
  cipLib: "MOTILIUM 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3234098',
  CIP13: '3400932340989',
  ucdLib: "MOTILIUM 1MG/ML BUV FL200ML",
  UCD7: '9059874',
  UCD13: '3400890598743',
  ucdQtyMultiplicator: 1,
  cipLib: "MOTILIUM 1MG/ML BUV FL200ML BT 1",
  atcCode: "A03FA03"
}, {
  CIP7: '3681911',
  CIP13: '3400936819115',
  ucdLib: "DOMPERIDONE SDZ 10MG CPR",
  UCD7: '9268885',
  UCD13: '3400892688855',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE SDZ 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3674503',
  CIP13: '3400936745032',
  ucdLib: "DOMPERIDONE ZEN 10MG CPR",
  UCD7: '9269962',
  UCD13: '3400892699622',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE ZEN 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3621725',
  CIP13: '3400936217256',
  ucdLib: "DOMPERIDONE EG 10MG CPR",
  UCD7: '9254334',
  UCD13: '3400892543345',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE EG 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3623670',
  CIP13: '3400936236707',
  ucdLib: "DOMPERIDONE TVC 10MG CPR",
  UCD7: '9254400',
  UCD13: '3400892544007',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE TVC 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3468577',
  CIP13: '3400934685774',
  ucdLib: "DOMPERIDONE ZEN 10MG C.DISP",
  UCD7: '9351132',
  UCD13: '3400893511329',
  ucdQtyMultiplicator: 30,
  cipLib: "DOMPERIDONE ZEN 10MG C.DISP BT 30",
  atcCode: "A03FA03"
}, {
  CIP7: '3666455',
  CIP13: '3400936664555',
  ucdLib: "DOMPERIDONE ALM 10MG CPR",
  UCD7: '9269330',
  UCD13: '3400892693309',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE ALM 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3632143',
  CIP13: '3400936321434',
  ucdLib: "DOMPERIDONE ARW 10MG CPR",
  UCD7: '9258941',
  UCD13: '3400892589411',
  ucdQtyMultiplicator: 30,
  cipLib: "DOMPERIDONE ARW 10MG CPR BT 30",
  atcCode: "A03FA03"
}, {
  CIP7: '3632166',
  CIP13: '3400936321663',
  ucdLib: "DOMPERIDONE ARW 10MG CPR",
  UCD7: '9258941',
  UCD13: '3400892589411',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE ARW 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3639501',
  CIP13: '3400936395015',
  ucdLib: "DOMPERIDONE ZYD 10MG CPR",
  UCD7: '9266389',
  UCD13: '3400892663890',
  ucdQtyMultiplicator: 40,
  cipLib: "DOMPERIDONE ZYD 10MG CPR BT 40",
  atcCode: "A03FA03"
}, {
  CIP7: '3823239',
  CIP13: '3400938232394',
  ucdLib: "DOMPERIDONE BGA 10MG C.DISP",
  UCD7: '9310825',
  UCD13: '3400893108253',
  ucdQtyMultiplicator: 30,
  cipLib: "DOMPERIDONE BGA 10MG C.DISP BT 30",
  atcCode: "A03FA03"
}, {
  CIP7: '3823280',
  CIP13: '3400938232806',
  ucdLib: "DOMPERIDONE EG 10MG C.DISP",
  UCD7: '9310831',
  UCD13: '3400893108314',
  ucdQtyMultiplicator: 30,
  cipLib: "DOMPERIDONE EG 10MG C.DISP BT 30",
  atcCode: "A03FA03"
}, {
  CIP7: '3823446',
  CIP13: '3400938234466',
  ucdLib: "DOMPERIDONE MYL 10MG C.DISP",
  UCD7: '9310860',
  UCD13: '3400893108604',
  ucdQtyMultiplicator: 20,
  cipLib: "DOMPERIDONE MYL 10MG C.DISP BT 20",
  atcCode: "A03FA03"
}, {
  CIP7: '3823392',
  CIP13: '3400938233926',
  ucdLib: "DOMPERIDONE SDZ 10MG C.DISP",
  UCD7: '9310854',
  UCD13: '3400893108543',
  ucdQtyMultiplicator: 30,
  cipLib: "DOMPERIDONE SDZ 10MG C.DISP BT 30",
  atcCode: "A03FA03"
}, {
  CIP7: '3890715',
  CIP13: '3400938907155',
  ucdLib: "DOMPERIDONE ARW 10MG C.DISP",
  UCD7: '9327205',
  UCD13: '3400893272053',
  ucdQtyMultiplicator: 30,
  cipLib: "DOMPERIDONE ARW 10MG C.DISP BT 30",
  atcCode: "A03FA03"
}, {
  CIP7: '3890767',
  CIP13: '3400938907674',
  ucdLib: "DOMPERIDONE CRT 10MG C.DISP",
  UCD7: '9326660',
  UCD13: '3400893266601',
  ucdQtyMultiplicator: 30,
  cipLib: "DOMPERIDONE CRT 10MG C.DISP BT 30",
  atcCode: "A03FA03"
}, {
  CIP7: '3086143',
  CIP13: '3400930861431',
  ucdLib: "PRIMPERAN 0,1% BUV FL200ML",
  UCD7: '9075287',
  UCD13: '3400890752879',
  ucdQtyMultiplicator: 1,
  cipLib: "PRIMPERAN 0,1% BUV FL200ML BT 1",
  atcCode: "A03FA01"
}, {
  CIP7: '3086120',
  CIP13: '3400930861202',
  ucdLib: "PRIMPERAN 10MG CPR",
  UCD7: '9075264',
  UCD13: '3400890752640',
  ucdQtyMultiplicator: 40,
  cipLib: "PRIMPERAN 10MG CPR BT 40",
  atcCode: "A03FA01"
}, {
  CIP7: '3086166',
  CIP13: '3400930861660',
  ucdLib: "PRIMPERAN 10MG INJ AMP2ML",
  UCD7: '9075258',
  UCD13: '3400890752589',
  ucdQtyMultiplicator: 12,
  cipLib: "PRIMPERAN 10MG INJ AMP2ML BT 12",
  atcCode: "A03FA01"
}, {
  CIP7: '3297348',
  CIP13: '3400932973484',
  ucdLib: "ANAUSIN 15MG CPR",
  UCD7: '9126205',
  UCD13: '3400891262056',
  ucdQtyMultiplicator: 30,
  cipLib: "ANAUSIN 15MG CPR BT 30",
  atcCode: "A03FA01"
}, {
  CIP7: '3297584',
  CIP13: '3400932975846',
  ucdLib: "PROKINYL LP 15MG GELU",
  UCD7: '9126990',
  UCD13: '3400891269901',
  ucdQtyMultiplicator: 30,
  cipLib: "PROKINYL LP 15MG GELU BT 30",
  atcCode: "A03FA01"
}, {
  CIP7: '3231792',
  CIP13: '3400932317929',
  ucdLib: "PRIMPERAN 10MG SUP",
  UCD7: '9075293',
  UCD13: '3400890752930',
  ucdQtyMultiplicator: 10,
  cipLib: "PRIMPERAN 10MG SUP BT 10",
  atcCode: "A03FA01"
}, {
  CIP7: '5566574',
  CIP13: '3400955665748',
  ucdLib: "PRIMPERAN 10MG CPR",
  UCD7: '9075264',
  UCD13: '3400890752640',
  ucdQtyMultiplicator: 150,
  cipLib: "PRIMPERAN 10MG CPR BT 150",
  atcCode: "A03FA01"
}, {
  CIP7: '3670497',
  CIP13: '3400936704978',
  ucdLib: "METOCLOPRAMIDE RCA BUV FL200ML",
  UCD7: '9274058',
  UCD13: '3400892740584',
  ucdQtyMultiplicator: 1,
  cipLib: "METOCLOPRAMIDE RCA BUV FL200ML BT 1",
  atcCode: "A03FA01"
}, {
  CIP7: '3532921',
  CIP13: '3400935329219',
  ucdLib: "METOCLOPRAMIDE MYL 10MG CPR",
  UCD7: '9219450',
  UCD13: '3400892194509',
  ucdQtyMultiplicator: 40,
  cipLib: "METOCLOPRAMIDE MYL 10MG CPR BT 40",
  atcCode: "A03FA01"
}, {
  CIP7: '3661819',
  CIP13: '3400936618190',
  ucdLib: "METOCLOPRAMIDE SDZ 10MG CPR",
  UCD7: '9265817',
  UCD13: '3400892658179',
  ucdQtyMultiplicator: 40,
  cipLib: "METOCLOPRAMIDE SDZ 10MG CPR BT 40",
  atcCode: "A03FA01"
}, {
  CIP7: '5633359',
  CIP13: '3400956333592',
  ucdLib: "METOCLOPRAMIDE REN 10MG/2ML A",
  UCD7: '9236000',
  UCD13: '3400892360003',
  ucdQtyMultiplicator: 100,
  cipLib: "METOCLOPRAMIDE REN 10MG/2ML A BT 100",
  atcCode: "A03FA01"
}, {
  CIP7: '2794688',
  CIP13: '3400927946882',
  ucdLib: "METOCLOPRAMIDE REN 10MG/2ML A",
  UCD7: '9236000',
  UCD13: '3400892360003',
  ucdQtyMultiplicator: 10,
  cipLib: "METOCLOPRAMIDE REN 10MG/2ML A BT 10",
  atcCode: "A03FA01"
}, {
  CIP7: '3553952',
  CIP13: '3400935539526',
  ucdLib: "LIBRAX CPR",
  UCD7: '9228383',
  UCD13: '3400892283838',
  ucdQtyMultiplicator: 30,
  cipLib: "LIBRAX CPR BT 30",
  atcCode: "A03CA02"
}, {
  CIP7: '3515928',
  CIP13: '3400935159281',
  ucdLib: "SCOBUREN 20MG INJ AMP1ML",
  UCD7: '9224089',
  UCD13: '3400892240893',
  ucdQtyMultiplicator: 10,
  cipLib: "SCOBUREN 20MG INJ AMP1ML BT 10",
  atcCode: "A03BB01"
}, {
  CIP7: '2766580',
  CIP13: '3400927665806',
  ucdLib: "ATROPINE 0,1MG/ML AGT SRG5ML",
  UCD7: '9398760',
  UCD13: '3400893987605',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE 0,1MG/ML AGT SRG5ML BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3653174',
  CIP13: '3400936531741',
  ucdLib: "ATROPINE 0,25MG LAV A.B1ML",
  UCD7: '9275359',
  UCD13: '3400892753591',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE 0,25MG LAV A.B1ML BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3653180',
  CIP13: '3400936531802',
  ucdLib: "ATROPINE 0,25MG LAV A.B1ML",
  UCD7: '9275359',
  UCD13: '3400892753591',
  ucdQtyMultiplicator: 100,
  cipLib: "ATROPINE 0,25MG LAV A.B1ML BT 100",
  atcCode: "A03BA01"
}, {
  CIP7: '3653197',
  CIP13: '3400936531970',
  ucdLib: "ATROPINE 0,50MG LAV A.B1ML",
  UCD7: '9275365',
  UCD13: '3400892753652',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE 0,50MG LAV A.B1ML BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3653205',
  CIP13: '3400936532052',
  ucdLib: "ATROPINE 0,50MG LAV A.B1ML",
  UCD7: '9275365',
  UCD13: '3400892753652',
  ucdQtyMultiplicator: 100,
  cipLib: "ATROPINE 0,50MG LAV A.B1ML BT 100",
  atcCode: "A03BA01"
}, {
  CIP7: '3653211',
  CIP13: '3400936532113',
  ucdLib: "ATROPINE 1MG LAV A.B1ML",
  UCD7: '9275371',
  UCD13: '3400892753713',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE 1MG LAV A.B1ML BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3701341',
  CIP13: '3400937013413',
  ucdLib: "ATROPINE 0,25MG AGT A.B1ML",
  UCD7: '9281006',
  UCD13: '3400892810065',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE 0,25MG AGT A.B1ML BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3701364',
  CIP13: '3400937013642',
  ucdLib: "ATROPINE 0,5MG AGT A.B1ML",
  UCD7: '9281012',
  UCD13: '3400892810126',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE 0,5MG AGT A.B1ML BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3701387',
  CIP13: '3400937013871',
  ucdLib: "ATROPINE 1MG AGT A.B1ML",
  UCD7: '9281029',
  UCD13: '3400892810294',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE 1MG AGT A.B1ML BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3643158',
  CIP13: '3400936431584',
  ucdLib: "ATROPINE REN 0,5MG/ML A.B",
  UCD7: '9262055',
  UCD13: '3400892620558',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE REN 0,5MG/ML A.B BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3643193',
  CIP13: '3400936431935',
  ucdLib: "ATROPINE REN 1MG/ML INJ A.B",
  UCD7: '9262061',
  UCD13: '3400892620619',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE REN 1MG/ML INJ A.B BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '3643224',
  CIP13: '3400936432246',
  ucdLib: "ATROPINE REN 1MG/ML INJ A.B",
  UCD7: '9262061',
  UCD13: '3400892620619',
  ucdQtyMultiplicator: 100,
  cipLib: "ATROPINE REN 1MG/ML INJ A.B BT 100",
  atcCode: "A03BA01"
}, {
  CIP7: '2697057',
  CIP13: '3400926970574',
  ucdLib: "ATROPINE 0,2MG/ML AGT SRG5ML",
  UCD7: '9393484',
  UCD13: '3400893934845',
  ucdQtyMultiplicator: 10,
  cipLib: "ATROPINE 0,2MG/ML AGT SRG5ML BT 10",
  atcCode: "A03BA01"
}, {
  CIP7: '5654485',
  CIP13: '3400956544851',
  ucdLib: "ATROPINE REN 0,25MG/ML A.B",
  UCD7: '9262049',
  UCD13: '3400892620497',
  ucdQtyMultiplicator: 100,
  cipLib: "ATROPINE REN 0,25MG/ML A.B BT 100",
  atcCode: "A03BA01"
}, {
  CIP7: '5654479',
  CIP13: '3400956544790',
  ucdLib: "ATROPINE REN 0,5MG/ML A.B",
  UCD7: '9262055',
  UCD13: '3400892620558',
  ucdQtyMultiplicator: 100,
  cipLib: "ATROPINE REN 0,5MG/ML A.B BT 100",
  atcCode: "A03BA01"
}, {
  CIP7: '3325406',
  CIP13: '3400933254063',
  ucdLib: "METEOSPASMYL CAPS",
  UCD7: '9146685',
  UCD13: '3400891466850',
  ucdQtyMultiplicator: 20,
  cipLib: "METEOSPASMYL CAPS BT 20",
  atcCode: "A03AX58"
}, {
  CIP7: '3432591',
  CIP13: '3400934325915',
  ucdLib: "METEOSPASMYL CAPS",
  UCD7: '9146685',
  UCD13: '3400891466850',
  ucdQtyMultiplicator: 30,
  cipLib: "METEOSPASMYL CAPS BT 30",
  atcCode: "A03AX58"
}, {
  CIP7: '3003118',
  CIP13: '3400930031186',
  ucdLib: "PEPSANE CAPS",
  UCD7: '9194419',
  UCD13: '3400891944198',
  ucdQtyMultiplicator: 30,
  cipLib: "PEPSANE CAPS BT 30",
  atcCode: "A03AX13"
}, {
  CIP7: '3320515',
  CIP13: '3400933205157',
  ucdLib: "PEPSANE GEL BUV SACH DOS",
  UCD7: '9138651',
  UCD13: '3400891386516',
  ucdQtyMultiplicator: 12,
  cipLib: "PEPSANE GEL BUV SACH DOS BT 12",
  atcCode: "A03AX13"
}, {
  CIP7: '3320521',
  CIP13: '3400933205218',
  ucdLib: "PEPSANE GEL BUV SACH DOS",
  UCD7: '9138651',
  UCD13: '3400891386516',
  ucdQtyMultiplicator: 30,
  cipLib: "PEPSANE GEL BUV SACH DOS BT 30",
  atcCode: "A03AX13"
}, {
  CIP7: '3207434',
  CIP13: '3400932074341',
  ucdLib: "SILIGAZ CAPS",
  UCD7: '9083909',
  UCD13: '3400890839099',
  ucdQtyMultiplicator: 32,
  cipLib: "SILIGAZ CAPS BT 32",
  atcCode: "A03AX13"
}, {
  CIP7: '3365759',
  CIP13: '3400933657598',
  ucdLib: "POLYSILANE UPSA GEL SACH15G",
  UCD7: '9227627',
  UCD13: '3400892276274',
  ucdQtyMultiplicator: 12,
  cipLib: "POLYSILANE UPSA GEL SACH15G BT 12",
  atcCode: "A03AX13"
}, {
  CIP7: '3483016',
  CIP13: '3400934830167',
  ucdLib: "POLYSILANE UPSA GEL TB170G",
  UCD7: '9224681',
  UCD13: '3400892246819',
  ucdQtyMultiplicator: 1,
  cipLib: "POLYSILANE UPSA GEL TB170G BT 1",
  atcCode: "A03AX13"
}, {
  CIP7: '3098608',
  CIP13: '3400930986080',
  ucdLib: "SPASFON CPR",
  UCD7: '9086799',
  UCD13: '3400890867993',
  ucdQtyMultiplicator: 30,
  cipLib: "SPASFON CPR BT 30",
  atcCode: "A03AX12"
}, {
  CIP7: '3098583',
  CIP13: '3400930985830',
  ucdLib: "SPASFON INJ AMP4ML",
  UCD7: '9086782',
  UCD13: '3400890867825',
  ucdQtyMultiplicator: 6,
  cipLib: "SPASFON INJ AMP4ML BT 6",
  atcCode: "A03AX12"
}, {
  CIP7: '3098614',
  CIP13: '3400930986141',
  ucdLib: "SPASFON SUP",
  UCD7: '9086807',
  UCD13: '3400890868075',
  ucdQtyMultiplicator: 10,
  cipLib: "SPASFON SUP BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3186301',
  CIP13: '3400931863014',
  ucdLib: "SPASFON LYOC 80MG LYOT ORAL",
  UCD7: '9086813',
  UCD13: '3400890868136',
  ucdQtyMultiplicator: 10,
  cipLib: "SPASFON LYOC 80MG LYOT ORAL BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3697295',
  CIP13: '3400936972957',
  ucdLib: "PHLOROGLUCINOL EG 80MG C.D",
  UCD7: '9278783',
  UCD13: '3400892787831',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL EG 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3697088',
  CIP13: '3400936970885',
  ucdLib: "PHLOROGLUCINOL MYL 80MG C.D",
  UCD7: '9278820',
  UCD13: '3400892788203',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL MYL 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3697094',
  CIP13: '3400936970946',
  ucdLib: "PHLOROGLUCINOL MYL 80MG C.D",
  UCD7: '9278820',
  UCD13: '3400892788203',
  ucdQtyMultiplicator: 20,
  cipLib: "PHLOROGLUCINOL MYL 80MG C.D BT 20",
  atcCode: "A03AX12"
}, {
  CIP7: '3697421',
  CIP13: '3400936974210',
  ucdLib: "PHLOROGLUCINOL SDZ 80MG C.D",
  UCD7: '9278180',
  UCD13: '3400892781808',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL SDZ 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3697148',
  CIP13: '3400936971486',
  ucdLib: "PHLOROGLUCINOL TVC 80MG C.D",
  UCD7: '9278872',
  UCD13: '3400892788722',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL TVC 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3786018',
  CIP13: '3400937860185',
  ucdLib: "PHLOROGLUCINOL ARW 80MG C.D",
  UCD7: '9299101',
  UCD13: '3400892991016',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL ARW 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3786047',
  CIP13: '3400937860475',
  ucdLib: "PHLOROGLUCINOL ARW 80MG C.D",
  UCD7: '9299101',
  UCD13: '3400892991016',
  ucdQtyMultiplicator: 20,
  cipLib: "PHLOROGLUCINOL ARW 80MG C.D BT 20",
  atcCode: "A03AX12"
}, {
  CIP7: '3786053',
  CIP13: '3400937860536',
  ucdLib: "PHLOROGLUCINOL ARW 80MG C.D",
  UCD7: '9299101',
  UCD13: '3400892991016',
  ucdQtyMultiplicator: 30,
  cipLib: "PHLOROGLUCINOL ARW 80MG C.D BT 30",
  atcCode: "A03AX12"
}, {
  CIP7: '3825037',
  CIP13: '3400938250374',
  ucdLib: "PHLOROGLUCINOL BGA 80MG C.D",
  UCD7: '9309704',
  UCD13: '3400893097045',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL BGA 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3711138',
  CIP13: '3400937111386',
  ucdLib: "PHLOROGLUCINOL SDC 80MG C.D",
  UCD7: '9283175',
  UCD13: '3400892831756',
  ucdQtyMultiplicator: 20,
  cipLib: "PHLOROGLUCINOL SDC 80MG C.D BT 20",
  atcCode: "A03AX12"
}, {
  CIP7: '3885890',
  CIP13: '3400938858907',
  ucdLib: "PHLOROGLUCINOL ZEN 80MG C.D",
  UCD7: '9332488',
  UCD13: '3400893324882',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL ZEN 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3751126',
  CIP13: '3400937511261',
  ucdLib: "SPASMOCALM 80MG CPR ORODISP",
  UCD7: '9290293',
  UCD13: '3400892902937',
  ucdQtyMultiplicator: 20,
  cipLib: "SPASMOCALM 80MG CPR ORODISP BT 20",
  atcCode: "A03AX12"
}, {
  CIP7: '3919896',
  CIP13: '3400939198965',
  ucdLib: "PHLOROGLUCINOL ISD 80MG C.D",
  UCD7: '9328860',
  UCD13: '3400893288603',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL ISD 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3946172',
  CIP13: '3400939461724',
  ucdLib: "PHLOROGLUCINOL CRT 80MG C.D",
  UCD7: '9334702',
  UCD13: '3400893347027',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUCINOL CRT 80MG C.D BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '3946203',
  CIP13: '3400939462035',
  ucdLib: "PHLOROGLUCINOL CRT 80MG C.D",
  UCD7: '9334702',
  UCD13: '3400893347027',
  ucdQtyMultiplicator: 20,
  cipLib: "PHLOROGLUCINOL CRT 80MG C.D BT 20",
  atcCode: "A03AX12"
}, {
  CIP7: '4184534',
  CIP13: '3400941845345',
  ucdLib: "PHLOROGLUC/TRIMET.ARW INJ A.",
  UCD7: '9373613',
  UCD13: '3400893736135',
  ucdQtyMultiplicator: 10,
  cipLib: "PHLOROGLUC/TRIMET.ARW INJ A. BT 10",
  atcCode: "A03AX12"
}, {
  CIP7: '4168624',
  CIP13: '3400941686245',
  ucdLib: "SPASFON LYOC 160MG LYOT ORAL",
  UCD7: '9378289',
  UCD13: '3400893782897',
  ucdQtyMultiplicator: 5,
  cipLib: "SPASFON LYOC 160MG LYOT ORAL BT 5",
  atcCode: "A03AX12"
}, {
  CIP7: '3272383',
  CIP13: '3400932723836',
  ucdLib: "DICETEL 50MG CPR",
  UCD7: '9026610',
  UCD13: '3400890266109',
  ucdQtyMultiplicator: 20,
  cipLib: "DICETEL 50MG CPR BT 20",
  atcCode: "A03AX04"
}, {
  CIP7: '3705037',
  CIP13: '3400937050371',
  ucdLib: "PINAVERIUM ARW 100MG CPR",
  UCD7: '9280478',
  UCD13: '3400892804781',
  ucdQtyMultiplicator: 30,
  cipLib: "PINAVERIUM ARW 100MG CPR BT 30",
  atcCode: "A03AX04"
}, {
  CIP7: '3705600',
  CIP13: '3400937056007',
  ucdLib: "PINAVERIUM MYL 100MG CPR",
  UCD7: '9282520',
  UCD13: '3400892825205',
  ucdQtyMultiplicator: 30,
  cipLib: "PINAVERIUM MYL 100MG CPR BT 30",
  atcCode: "A03AX04"
}, {
  CIP7: '3705617',
  CIP13: '3400937056175',
  ucdLib: "PINAVERIUM TVS 100MG CPR",
  UCD7: '9282543',
  UCD13: '3400892825434',
  ucdQtyMultiplicator: 30,
  cipLib: "PINAVERIUM TVS 100MG CPR BT 30",
  atcCode: "A03AX04"
}, {
  CIP7: '3387620',
  CIP13: '3400933876203',
  ucdLib: "DICETEL 100MG CPR",
  UCD7: '9182103',
  UCD13: '3400891821031',
  ucdQtyMultiplicator: 30,
  cipLib: "DICETEL 100MG CPR BT 30",
  atcCode: "A03AX04"
}, {
  CIP7: '3760421',
  CIP13: '3400937604215',
  ucdLib: "PINAVERIUM BGA 100MG CPR",
  UCD7: '9282514',
  UCD13: '3400892825144',
  ucdQtyMultiplicator: 30,
  cipLib: "PINAVERIUM BGA 100MG CPR BT 30",
  atcCode: "A03AX04"
}, {
  CIP7: '3387666',
  CIP13: '3400933876661',
  ucdLib: "PINAVERIUM BIP 100MG CPR",
  UCD7: '9271982',
  UCD13: '3400892719825',
  ucdQtyMultiplicator: 30,
  cipLib: "PINAVERIUM BIP 100MG CPR BT 30",
  atcCode: "A03AX04"
}, {
  CIP7: '3745255',
  CIP13: '3400937452557',
  ucdLib: "PINAVERIUM EG 100MG CPR",
  UCD7: '9288468',
  UCD13: '3400892884684',
  ucdQtyMultiplicator: 30,
  cipLib: "PINAVERIUM EG 100MG CPR BT 30",
  atcCode: "A03AX04"
}, {
  CIP7: '3710363',
  CIP13: '3400937103633',
  ucdLib: "PINAVERIUM SDZ 100MG CPR",
  UCD7: '9283198',
  UCD13: '3400892831985',
  ucdQtyMultiplicator: 30,
  cipLib: "PINAVERIUM SDZ 100MG CPR BT 30",
  atcCode: "A03AX04"
}, {
  CIP7: '3487385',
  CIP13: '3400934873850',
  ucdLib: "PAPAVERINE REN 40MG INJ 1ML",
  UCD7: '9208860',
  UCD13: '3400892088600',
  ucdQtyMultiplicator: 10,
  cipLib: "PAPAVERINE REN 40MG INJ 1ML BT 10",
  atcCode: "A03AD01"
}, {
  CIP7: '3701401',
  CIP13: '3400937014014',
  ucdLib: "PAPAVERINE SRB 40MG INJ A.B",
  UCD7: '9354515',
  UCD13: '3400893545157',
  ucdQtyMultiplicator: 10,
  cipLib: "PAPAVERINE SRB 40MG INJ A.B BT 10",
  atcCode: "A03AD01"
}, {
  CIP7: '3098821',
  CIP13: '3400930988213',
  ucdLib: "SPASMODEX 10MG CPR",
  UCD7: '9086977',
  UCD13: '3400890869775',
  ucdQtyMultiplicator: 30,
  cipLib: "SPASMODEX 10MG CPR BT 30",
  atcCode: "A03AA08"
}, {
  CIP7: '3098838',
  CIP13: '3400930988381',
  ucdLib: "SPASMODEX 50MG SUP",
  UCD7: '9086983',
  UCD13: '3400890869836',
  ucdQtyMultiplicator: 6,
  cipLib: "SPASMODEX 50MG SUP BT 6",
  atcCode: "A03AA08"
}, {
  CIP7: '5533936',
  CIP13: '3400955339366',
  ucdLib: "DEBRIDAT 50MG INJ AMP5ML",
  UCD7: '9024114',
  UCD13: '3400890241144',
  ucdQtyMultiplicator: 25,
  cipLib: "DEBRIDAT 50MG INJ AMP5ML BT 25",
  atcCode: "A03AA05"
}, {
  CIP7: '3614553',
  CIP13: '3400936145535',
  ucdLib: "TRIMEBUTINE TVC 100MG CPR",
  UCD7: '9245743',
  UCD13: '3400892457437',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE TVC 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3006107',
  CIP13: '3400930061077',
  ucdLib: "TRIMEBUTINE BGA 200MG CPR",
  UCD7: '9285636',
  UCD13: '3400892856360',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE BGA 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3576479',
  CIP13: '3400935764799',
  ucdLib: "TRIMEBUTINE ARG 100MG CPR",
  UCD7: '9256617',
  UCD13: '3400892566177',
  ucdQtyMultiplicator: 60,
  cipLib: "TRIMEBUTINE ARG 100MG CPR BT 60",
  atcCode: "A03AA05"
}, {
  CIP7: '3028252',
  CIP13: '3400930282526',
  ucdLib: "DEBRIDAT BUV GLE FL250ML",
  UCD7: '9024143',
  UCD13: '3400890241434',
  ucdQtyMultiplicator: 1,
  cipLib: "DEBRIDAT BUV GLE FL250ML BT 1",
  atcCode: "A03AA05"
}, {
  CIP7: '3315626',
  CIP13: '3400933156268',
  ucdLib: "DEBRICALM 100MG CPR",
  UCD7: '9138243',
  UCD13: '3400891382433',
  ucdQtyMultiplicator: 20,
  cipLib: "DEBRICALM 100MG CPR BT 20",
  atcCode: "A03AA05"
}, {
  CIP7: '4912910',
  CIP13: '3400949129102',
  ucdLib: "TRIMEBUTINE ZYD 200MG CPR",
  UCD7: '9355526',
  UCD13: '3400893555262',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ZYD 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3689427',
  CIP13: '3400936894273',
  ucdLib: "TRIMEBUTINE SDZ 100MG CPR",
  UCD7: '9273283',
  UCD13: '3400892732831',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE SDZ 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3525097',
  CIP13: '3400935250971',
  ucdLib: "TRIMEBUTINE ZYD 100MG CPR",
  UCD7: '9222908',
  UCD13: '3400892229089',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ZYD 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3359569',
  CIP13: '3400933595692',
  ucdLib: "DEBRIDAT BUV GLE SACH",
  UCD7: '9163494',
  UCD13: '3400891634945',
  ucdQtyMultiplicator: 30,
  cipLib: "DEBRIDAT BUV GLE SACH BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3674897',
  CIP13: '3400936748972',
  ucdLib: "TRIMEBUTINE ZEN 100MG CPR",
  UCD7: '9270267',
  UCD13: '3400892702674',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ZEN 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3390467',
  CIP13: '3400933904678',
  ucdLib: "DEBRIDAT 100MG CPR",
  UCD7: '9024120',
  UCD13: '3400890241205',
  ucdQtyMultiplicator: 30,
  cipLib: "DEBRIDAT 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3591941',
  CIP13: '3400935919410',
  ucdLib: "DEBRIDAT 200MG CPR",
  UCD7: '9243572',
  UCD13: '3400892435725',
  ucdQtyMultiplicator: 30,
  cipLib: "DEBRIDAT 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3410483',
  CIP13: '3400934104831',
  ucdLib: "DEBRIDAT ENF BUV GLE FL125ML",
  UCD7: '9189878',
  UCD13: '3400891898781',
  ucdQtyMultiplicator: 1,
  cipLib: "DEBRIDAT ENF BUV GLE FL125ML BT 1",
  atcCode: "A03AA05"
}, {
  CIP7: '3594141',
  CIP13: '3400935941411',
  ucdLib: "TRANSACALM 100MG CPR",
  UCD7: '9158180',
  UCD13: '3400891581805',
  ucdQtyMultiplicator: 30,
  cipLib: "TRANSACALM 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3530738',
  CIP13: '3400935307385',
  ucdLib: "TRIMEBUTINE ACT 100MG CPR",
  UCD7: '9296019',
  UCD13: '3400892960197',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ACT 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3489177',
  CIP13: '3400934891779',
  ucdLib: "TRIMEBUTINE EG 100MG CPR",
  UCD7: '9218798',
  UCD13: '3400892187983',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE EG 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3591958',
  CIP13: '3400935919588',
  ucdLib: "TRIMEBUTINE MYL 200MG CPR",
  UCD7: '9293268',
  UCD13: '3400892932682',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE MYL 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3583077',
  CIP13: '3400935830777',
  ucdLib: "TRIMEBUTINE ARW 100MG CPR",
  UCD7: '9246808',
  UCD13: '3400892468082',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ARW 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3540814',
  CIP13: '3400935408143',
  ucdLib: "TRIMEBUTINE ISD 100MG CPR",
  UCD7: '9221599',
  UCD13: '3400892215990',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ISD 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3587738',
  CIP13: '3400935877383',
  ucdLib: "TRIMEBUTINE MYC 100MG CPR",
  UCD7: '9238855',
  UCD13: '3400892388557',
  ucdQtyMultiplicator: 20,
  cipLib: "TRIMEBUTINE MYC 100MG CPR BT 20",
  atcCode: "A03AA05"
}, {
  CIP7: '3763224',
  CIP13: '3400937632249',
  ucdLib: "TRIMEBUTINE ALM 100MG CPR",
  UCD7: '9293274',
  UCD13: '3400892932743',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ALM 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3728593',
  CIP13: '3400937285933',
  ucdLib: "TRIMEBUTINE ALM 200MG CPR",
  UCD7: '9287121',
  UCD13: '3400892871219',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ALM 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3727978',
  CIP13: '3400937279789',
  ucdLib: "TRIMEBUTINE BGA 100MG CPR",
  UCD7: '9206424',
  UCD13: '3400892064246',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE BGA 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3727955',
  CIP13: '3400937279550',
  ucdLib: "TRIMEBUTINE BGA 200MG CPR",
  UCD7: '9285636',
  UCD13: '3400892856360',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE BGA 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3728558',
  CIP13: '3400937285582',
  ucdLib: "TRIMEBUTINE EG 200MG CPR",
  UCD7: '9287138',
  UCD13: '3400892871387',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE EG 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3473118',
  CIP13: '3400934731181',
  ucdLib: "TRIMEBUTINE MYL 100MG CPR",
  UCD7: '9205637',
  UCD13: '3400892056371',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE MYL 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3823185',
  CIP13: '3400938231854',
  ucdLib: "TRIMEBUTINE RATIO 100MG CPR",
  UCD7: '9307964',
  UCD13: '3400893079645',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE RATIO 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3823191',
  CIP13: '3400938231915',
  ucdLib: "TRIMEBUTINE TVS 200MG CPR",
  UCD7: '9307970',
  UCD13: '3400893079706',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE TVS 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3732407',
  CIP13: '3400937324076',
  ucdLib: "TRIMEBUTINE ARW 200MG CPR",
  UCD7: '9287109',
  UCD13: '3400892871097',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ARW 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3962969',
  CIP13: '3400939629698',
  ucdLib: "TRIMEBUTINE ACT 200MG CPR",
  UCD7: '9341033',
  UCD13: '3400893410332',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ACT 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3972413',
  CIP13: '3400939724133',
  ucdLib: "TRIMEBUTINE CRT 200MG CPR",
  UCD7: '9345255',
  UCD13: '3400893452554',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE CRT 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3962981',
  CIP13: '3400939629810',
  ucdLib: "TRIMEBUTINE EVO 200MG CPR",
  UCD7: '9344103',
  UCD13: '3400893441039',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE EVO 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3963029',
  CIP13: '3400939630298',
  ucdLib: "TRIMEBUTINE ISD 200MG CPR",
  UCD7: '9345261',
  UCD13: '3400893452615',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ISD 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3963213',
  CIP13: '3400939632131',
  ucdLib: "TRIMEBUTINE PFZ 100MG CPR",
  UCD7: '9341607',
  UCD13: '3400893416075',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE PFZ 100MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3963176',
  CIP13: '3400939631769',
  ucdLib: "TRIMEBUTINE PFZ 200MG CPR",
  UCD7: '9341613',
  UCD13: '3400893416136',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE PFZ 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3963006',
  CIP13: '3400939630069',
  ucdLib: "TRIMEBUTINE RBX 200MG CPR",
  UCD7: '9341694',
  UCD13: '3400893416945',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE RBX 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3918460',
  CIP13: '3400939184609',
  ucdLib: "TRIMEBUTINE SDZ 200MG CPR",
  UCD7: '9331804',
  UCD13: '3400893318041',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE SDZ 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '3962840',
  CIP13: '3400939628400',
  ucdLib: "TRIMEBUTINE ZEN 200MG CPR",
  UCD7: '9344126',
  UCD13: '3400893441268',
  ucdQtyMultiplicator: 30,
  cipLib: "TRIMEBUTINE ZEN 200MG CPR BT 30",
  atcCode: "A03AA05"
}, {
  CIP7: '4161935',
  CIP13: '3400941619359',
  ucdLib: "TRIMEBUTINE BGC 100MG CPR",
  UCD7: '9371034',
  UCD13: '3400893710340',
  ucdQtyMultiplicator: 20,
  cipLib: "TRIMEBUTINE BGC 100MG CPR BT 20",
  atcCode: "A03AA05"
}, {
  CIP7: '3570867',
  CIP13: '3400935708670',
  ucdLib: "MEBEVERINE ZEN 100MG GELU",
  UCD7: '9087020',
  UCD13: '3400890870207',
  ucdQtyMultiplicator: 30,
  cipLib: "MEBEVERINE ZEN 100MG GELU BT 30",
  atcCode: "A03AA04"
}, {
  CIP7: '3562448',
  CIP13: '3400935624482',
  ucdLib: "MEBEVERINE ZYD 200MG CPR",
  UCD7: '9230575',
  UCD13: '3400892305752',
  ucdQtyMultiplicator: 30,
  cipLib: "MEBEVERINE ZYD 200MG CPR BT 30",
  atcCode: "A03AA04"
}, {
  CIP7: '3494273',
  CIP13: '3400934942730',
  ucdLib: "DUSPATALIN 200MG GELU",
  UCD7: '9159624',
  UCD13: '3400891596243',
  ucdQtyMultiplicator: 30,
  cipLib: "DUSPATALIN 200MG GELU BT 30",
  atcCode: "A03AA04"
}, {
  CIP7: '3507219',
  CIP13: '3400935072191',
  ucdLib: "MEBEVERINE ZEN 200MG CPR",
  UCD7: '9213625',
  UCD13: '3400892136257',
  ucdQtyMultiplicator: 30,
  cipLib: "MEBEVERINE ZEN 200MG CPR BT 30",
  atcCode: "A03AA04"
}, {
  CIP7: '3229708',
  CIP13: '3400932297085',
  ucdLib: "BEDELIX BUV PDR SACH",
  UCD7: '9009853',
  UCD13: '3400890098533',
  ucdQtyMultiplicator: 30,
  cipLib: "BEDELIX BUV PDR SACH BT 30",
  atcCode: "A02X"
}, {
  CIP7: '3229714',
  CIP13: '3400932297146',
  ucdLib: "BEDELIX BUV PDR SACH",
  UCD7: '9009853',
  UCD13: '3400890098533',
  ucdQtyMultiplicator: 60,
  cipLib: "BEDELIX BUV PDR SACH BT 60",
  atcCode: "A02X"
}, {
  CIP7: '3219472',
  CIP13: '3400932194728',
  ucdLib: "TOPAAL CPR CROQ",
  UCD7: '9093687',
  UCD13: '3400890936873',
  ucdQtyMultiplicator: 42,
  cipLib: "TOPAAL CPR CROQ BT 42",
  atcCode: "A02X"
}, {
  CIP7: '3288450',
  CIP13: '3400932884506',
  ucdLib: "KEAL 1G CPR",
  UCD7: '9111244',
  UCD13: '3400891112443',
  ucdQtyMultiplicator: 30,
  cipLib: "KEAL 1G CPR BT 30",
  atcCode: "A02BX02"
}, {
  CIP7: '3328391',
  CIP13: '3400933283919',
  ucdLib: "ULCAR 1G BUV SUSP SACH",
  UCD7: '9148141',
  UCD13: '3400891481419',
  ucdQtyMultiplicator: 30,
  cipLib: "ULCAR 1G BUV SUSP SACH BT 30",
  atcCode: "A02BX02"
}, {
  CIP7: '3339756',
  CIP13: '3400933397562',
  ucdLib: "KEAL 1G SUSP BUV SACH5ML",
  UCD7: '9152295',
  UCD13: '3400891522952',
  ucdQtyMultiplicator: 30,
  cipLib: "KEAL 1G SUSP BUV SACH5ML BT 30",
  atcCode: "A02BX02"
}, {
  CIP7: '3339762',
  CIP13: '3400933397623',
  ucdLib: "KEAL 2G SUSP BUV SACH10ML",
  UCD7: '9152303',
  UCD13: '3400891523034',
  ucdQtyMultiplicator: 15,
  cipLib: "KEAL 2G SUSP BUV SACH10ML BT 15",
  atcCode: "A02BX02"
}, {
  CIP7: '2180420',
  CIP13: '3400921804201',
  ucdLib: "PYLERA 140/125/125MG GELU",
  UCD7: '9360510',
  UCD13: '3400893605103',
  ucdQtyMultiplicator: 120,
  cipLib: "PYLERA 140/125/125MG GELU BT 120",
  atcCode: "A02BD08"
}, {
  CIP7: '2764983',
  CIP13: '3400927649837',
  ucdLib: "NEXIUM CONTROL 20MG CPR",
  UCD7: '9402817',
  UCD13: '3400894028178',
  ucdQtyMultiplicator: 7,
  cipLib: "NEXIUM CONTROL 20MG CPR BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '2765008',
  CIP13: '3400927650086',
  ucdLib: "NEXIUM CONTROL 20MG CPR",
  UCD7: '9402817',
  UCD13: '3400894028178',
  ucdQtyMultiplicator: 14,
  cipLib: "NEXIUM CONTROL 20MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '3553320',
  CIP13: '3400935533203',
  ucdLib: "INEXIUM 20MG CPR",
  UCD7: '9230799',
  UCD13: '3400892307992',
  ucdQtyMultiplicator: 7,
  cipLib: "INEXIUM 20MG CPR BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '3553337',
  CIP13: '3400935533371',
  ucdLib: "INEXIUM 20MG CPR",
  UCD7: '9230799',
  UCD13: '3400892307992',
  ucdQtyMultiplicator: 14,
  cipLib: "INEXIUM 20MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '3553343',
  CIP13: '3400935533432',
  ucdLib: "INEXIUM 20MG CPR",
  UCD7: '9230799',
  UCD13: '3400892307992',
  ucdQtyMultiplicator: 28,
  cipLib: "INEXIUM 20MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '3553389',
  CIP13: '3400935533890',
  ucdLib: "INEXIUM 40MG CPR",
  UCD7: '9230807',
  UCD13: '3400892308074',
  ucdQtyMultiplicator: 14,
  cipLib: "INEXIUM 40MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '3553395',
  CIP13: '3400935533951',
  ucdLib: "INEXIUM 40MG CPR",
  UCD7: '9230807',
  UCD13: '3400892308074',
  ucdQtyMultiplicator: 28,
  cipLib: "INEXIUM 40MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '5628281',
  CIP13: '3400956282814',
  ucdLib: "INEXIUM 20MG CPR",
  UCD7: '9230799',
  UCD13: '3400892307992',
  ucdQtyMultiplicator: 50,
  cipLib: "INEXIUM 20MG CPR BT 50",
  atcCode: "A02BC05"
}, {
  CIP7: '5628298',
  CIP13: '3400956282982',
  ucdLib: "INEXIUM 40MG CPR",
  UCD7: '9230807',
  UCD13: '3400892308074',
  ucdQtyMultiplicator: 50,
  cipLib: "INEXIUM 40MG CPR BT 50",
  atcCode: "A02BC05"
}, {
  CIP7: '3644407',
  CIP13: '3400936444072',
  ucdLib: "INEXIUM 40MG INJ FL",
  UCD7: '9262925',
  UCD13: '3400892629254',
  ucdQtyMultiplicator: 10,
  cipLib: "INEXIUM 40MG INJ FL BT 10",
  atcCode: "A02BC05"
}, {
  CIP7: '3867308',
  CIP13: '3400938673081',
  ucdLib: "INEXIUM 10MG BUV GLE SACH",
  UCD7: '9346533',
  UCD13: '3400893465332',
  ucdQtyMultiplicator: 28,
  cipLib: "INEXIUM 10MG BUV GLE SACH BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2741752',
  CIP13: '3400927417528',
  ucdLib: "ESOMEPRAZOLE SUN 40MG FL5ML",
  UCD7: '9396979',
  UCD13: '3400893969793',
  ucdQtyMultiplicator: 1,
  cipLib: "ESOMEPRAZOLE SUN 40MG FL5ML BT 1",
  atcCode: "A02BC05"
}, {
  CIP7: '4900051',
  CIP13: '3400949000517',
  ucdLib: "INEXIUM 20MG CPR AIP MWI BE",
  UCD7: '9413301',
  UCD13: '3400894133018',
  ucdQtyMultiplicator: 28,
  cipLib: "INEXIUM 20MG CPR AIP MWI BE BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4901579',
  CIP13: '3400949015795',
  ucdLib: "INEXIUM 20MG CPR AIP MWI IT",
  UCD7: '9394408',
  UCD13: '3400893944080',
  ucdQtyMultiplicator: 7,
  cipLib: "INEXIUM 20MG CPR AIP MWI IT BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '4901585',
  CIP13: '3400949015856',
  ucdLib: "INEXIUM 20MG CPR AIP MWI IT",
  UCD7: '9394408',
  UCD13: '3400893944080',
  ucdQtyMultiplicator: 14,
  cipLib: "INEXIUM 20MG CPR AIP MWI IT BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4901591',
  CIP13: '3400949015917',
  ucdLib: "INEXIUM 20MG CPR AIP MWI IT",
  UCD7: '9394408',
  UCD13: '3400893944080',
  ucdQtyMultiplicator: 28,
  cipLib: "INEXIUM 20MG CPR AIP MWI IT BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2735734',
  CIP13: '3400927357343',
  ucdLib: "ESOMEPRAZOLE ARL 20MG CPR",
  UCD7: '9402220',
  UCD13: '3400894022206',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE ARL 20MG CPR BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '2735740',
  CIP13: '3400927357404',
  ucdLib: "ESOMEPRAZOLE ARL 20MG CPR",
  UCD7: '9402220',
  UCD13: '3400894022206',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE ARL 20MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2735757',
  CIP13: '3400927357572',
  ucdLib: "ESOMEPRAZOLE ARL 20MG CPR",
  UCD7: '9402220',
  UCD13: '3400894022206',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE ARL 20MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2735941',
  CIP13: '3400927359415',
  ucdLib: "ESOMEPRAZOLE ARL 40MG CPR",
  UCD7: '9402237',
  UCD13: '3400894022374',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE ARL 40MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2735958',
  CIP13: '3400927359583',
  ucdLib: "ESOMEPRAZOLE ARL 40MG CPR",
  UCD7: '9402237',
  UCD13: '3400894022374',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE ARL 40MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2782159',
  CIP13: '3400927821592',
  ucdLib: "ESOMEPRAZOLE EGL 20MG CPR",
  UCD7: '9401551',
  UCD13: '3400894015512',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE EGL 20MG CPR BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '2782165',
  CIP13: '3400927821653',
  ucdLib: "ESOMEPRAZOLE EGL 20MG CPR",
  UCD7: '9401551',
  UCD13: '3400894015512',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE EGL 20MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2782171',
  CIP13: '3400927821714',
  ucdLib: "ESOMEPRAZOLE EGL 20MG CPR",
  UCD7: '9401551',
  UCD13: '3400894015512',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE EGL 20MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2782248',
  CIP13: '3400927822483',
  ucdLib: "ESOMEPRAZOLE EGL 40MG CPR",
  UCD7: '9401568',
  UCD13: '3400894015680',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE EGL 40MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2782254',
  CIP13: '3400927822544',
  ucdLib: "ESOMEPRAZOLE EGL 40MG CPR",
  UCD7: '9401568',
  UCD13: '3400894015680',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE EGL 40MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2782320',
  CIP13: '3400927823206',
  ucdLib: "ESOMEPRAZOLE EVO 20MG CPR",
  UCD7: '9403231',
  UCD13: '3400894032311',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE EVO 20MG CPR BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '2782337',
  CIP13: '3400927823374',
  ucdLib: "ESOMEPRAZOLE EVO 20MG CPR",
  UCD7: '9403231',
  UCD13: '3400894032311',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE EVO 20MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2782343',
  CIP13: '3400927823435',
  ucdLib: "ESOMEPRAZOLE EVO 20MG CPR",
  UCD7: '9403231',
  UCD13: '3400894032311',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE EVO 20MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2782432',
  CIP13: '3400927824326',
  ucdLib: "ESOMEPRAZOLE EVO 40MG CPR",
  UCD7: '9403248',
  UCD13: '3400894032489',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE EVO 40MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2782449',
  CIP13: '3400927824494',
  ucdLib: "ESOMEPRAZOLE EVO 40MG CPR",
  UCD7: '9403248',
  UCD13: '3400894032489',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE EVO 40MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4188816',
  CIP13: '3400941888168',
  ucdLib: "ESOMEPRAZOLE RBX 20MG CPR",
  UCD7: '9374417',
  UCD13: '3400893744178',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE RBX 20MG CPR BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '4188822',
  CIP13: '3400941888229',
  ucdLib: "ESOMEPRAZOLE RBX 20MG CPR",
  UCD7: '9374417',
  UCD13: '3400893744178',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE RBX 20MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4188845',
  CIP13: '3400941888458',
  ucdLib: "ESOMEPRAZOLE RBX 20MG CPR",
  UCD7: '9374417',
  UCD13: '3400893744178',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE RBX 20MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4188934',
  CIP13: '3400941889349',
  ucdLib: "ESOMEPRAZOLE RBX 40MG CPR",
  UCD7: '9374423',
  UCD13: '3400893744239',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE RBX 40MG CPR BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4188957',
  CIP13: '3400941889578',
  ucdLib: "ESOMEPRAZOLE RBX 40MG CPR",
  UCD7: '9374423',
  UCD13: '3400893744239',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE RBX 40MG CPR BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '3002728',
  CIP13: '3400930027288',
  ucdLib: "ESOMEPRAZOLE BGA 20MG GELU",
  UCD7: '9366702',
  UCD13: '3400893667026',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE BGA 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '3002730',
  CIP13: '3400930027301',
  ucdLib: "ESOMEPRAZOLE BGA 40MG GELU",
  UCD7: '9366719',
  UCD13: '3400893667194',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE BGA 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4972131',
  CIP13: '3400949721313',
  ucdLib: "ESOMEPRAZOLE ARW 20MG GELU",
  UCD7: '9368782',
  UCD13: '3400893687826',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE ARW 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '4972148',
  CIP13: '3400949721481',
  ucdLib: "ESOMEPRAZOLE ARW 20MG GELU",
  UCD7: '9368782',
  UCD13: '3400893687826',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE ARW 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4972154',
  CIP13: '3400949721542',
  ucdLib: "ESOMEPRAZOLE ARW 20MG GELU",
  UCD7: '9368782',
  UCD13: '3400893687826',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE ARW 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4972177',
  CIP13: '3400949721771',
  ucdLib: "ESOMEPRAZOLE ARW 40MG GELU",
  UCD7: '9368799',
  UCD13: '3400893687994',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE ARW 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4972183',
  CIP13: '3400949721832',
  ucdLib: "ESOMEPRAZOLE ARW 40MG GELU",
  UCD7: '9368799',
  UCD13: '3400893687994',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE ARW 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4971835',
  CIP13: '3400949718351',
  ucdLib: "ESOMEPRAZOLE BGA 20MG GELU",
  UCD7: '9366702',
  UCD13: '3400893667026',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE BGA 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '4971841',
  CIP13: '3400949718412',
  ucdLib: "ESOMEPRAZOLE BGA 20MG GELU",
  UCD7: '9366702',
  UCD13: '3400893667026',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE BGA 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4971858',
  CIP13: '3400949718580',
  ucdLib: "ESOMEPRAZOLE BGA 20MG GELU",
  UCD7: '9366702',
  UCD13: '3400893667026',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE BGA 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4971870',
  CIP13: '3400949718702',
  ucdLib: "ESOMEPRAZOLE BGA 40MG GELU",
  UCD7: '9366719',
  UCD13: '3400893667194',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE BGA 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4971887',
  CIP13: '3400949718870',
  ucdLib: "ESOMEPRAZOLE BGA 40MG GELU",
  UCD7: '9366719',
  UCD13: '3400893667194',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE BGA 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4972065',
  CIP13: '3400949720651',
  ucdLib: "ESOMEPRAZOLE EG 20MG GELU",
  UCD7: '9366725',
  UCD13: '3400893667255',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE EG 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '4972071',
  CIP13: '3400949720712',
  ucdLib: "ESOMEPRAZOLE EG 20MG GELU",
  UCD7: '9366725',
  UCD13: '3400893667255',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE EG 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4972088',
  CIP13: '3400949720880',
  ucdLib: "ESOMEPRAZOLE EG 20MG GELU",
  UCD7: '9366725',
  UCD13: '3400893667255',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE EG 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4972102',
  CIP13: '3400949721023',
  ucdLib: "ESOMEPRAZOLE EG 40MG GELU",
  UCD7: '9366731',
  UCD13: '3400893667316',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE EG 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4972119',
  CIP13: '3400949721191',
  ucdLib: "ESOMEPRAZOLE EG 40MG GELU",
  UCD7: '9366731',
  UCD13: '3400893667316',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE EG 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2219731',
  CIP13: '3400922197319',
  ucdLib: "ESOMEPRAZOLE KRK 20MG GELU",
  UCD7: '9371821',
  UCD13: '3400893718216',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE KRK 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '2219748',
  CIP13: '3400922197487',
  ucdLib: "ESOMEPRAZOLE KRK 20MG GELU",
  UCD7: '9371821',
  UCD13: '3400893718216',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE KRK 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2219754',
  CIP13: '3400922197548',
  ucdLib: "ESOMEPRAZOLE KRK 20MG GELU",
  UCD7: '9371821',
  UCD13: '3400893718216',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE KRK 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2219760',
  CIP13: '3400922197609',
  ucdLib: "ESOMEPRAZOLE KRK 40MG GELU",
  UCD7: '9371838',
  UCD13: '3400893718384',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE KRK 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2219777',
  CIP13: '3400922197777',
  ucdLib: "ESOMEPRAZOLE KRK 40MG GELU",
  UCD7: '9371838',
  UCD13: '3400893718384',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE KRK 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4971901',
  CIP13: '3400949719013',
  ucdLib: "ESOMEPRAZOLE MYL 20MG GELU",
  UCD7: '9366748',
  UCD13: '3400893667484',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE MYL 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '4971918',
  CIP13: '3400949719181',
  ucdLib: "ESOMEPRAZOLE MYL 20MG GELU",
  UCD7: '9366748',
  UCD13: '3400893667484',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE MYL 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4971924',
  CIP13: '3400949719242',
  ucdLib: "ESOMEPRAZOLE MYL 20MG GELU",
  UCD7: '9366748',
  UCD13: '3400893667484',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE MYL 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4971947',
  CIP13: '3400949719471',
  ucdLib: "ESOMEPRAZOLE MYL 40MG GELU",
  UCD7: '9366754',
  UCD13: '3400893667545',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE MYL 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4971953',
  CIP13: '3400949719532',
  ucdLib: "ESOMEPRAZOLE MYL 40MG GELU",
  UCD7: '9366754',
  UCD13: '3400893667545',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE MYL 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4971769',
  CIP13: '3400949717699',
  ucdLib: "ESOMEPRAZOLE ZEN 20MG GELU",
  UCD7: '9366814',
  UCD13: '3400893668146',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE ZEN 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '4971775',
  CIP13: '3400949717750',
  ucdLib: "ESOMEPRAZOLE ZEN 20MG GELU",
  UCD7: '9366814',
  UCD13: '3400893668146',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE ZEN 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4971781',
  CIP13: '3400949717811',
  ucdLib: "ESOMEPRAZOLE ZEN 20MG GELU",
  UCD7: '9366814',
  UCD13: '3400893668146',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE ZEN 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4971806',
  CIP13: '3400949718061',
  ucdLib: "ESOMEPRAZOLE ZEN 40MG GELU",
  UCD7: '9366820',
  UCD13: '3400893668207',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE ZEN 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '4971812',
  CIP13: '3400949718122',
  ucdLib: "ESOMEPRAZOLE ZEN 40MG GELU",
  UCD7: '9366820',
  UCD13: '3400893668207',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE ZEN 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4190486',
  CIP13: '3400941904868',
  ucdLib: "ESOMEPRAZOLE MYP 20MG GELU",
  UCD7: '9403254',
  UCD13: '3400894032540',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE MYP 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '4190629',
  CIP13: '3400941906299',
  ucdLib: "ESOMEPRAZOLE MYP 40MG GELU",
  UCD7: '9403260',
  UCD13: '3400894032601',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE MYP 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2192794',
  CIP13: '3400921927948',
  ucdLib: "ESOMEPRAZOLE PHR 40MG GELU",
  UCD7: '9381937',
  UCD13: '3400893819371',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE PHR 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2741775',
  CIP13: '3400927417757',
  ucdLib: "ESOMEPRAZOLE SDZ 20MG GELU",
  UCD7: '9369706',
  UCD13: '3400893697061',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE SDZ 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '2741781',
  CIP13: '3400927417818',
  ucdLib: "ESOMEPRAZOLE SDZ 20MG GELU",
  UCD7: '9369706',
  UCD13: '3400893697061',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE SDZ 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2741798',
  CIP13: '3400927417986',
  ucdLib: "ESOMEPRAZOLE SDZ 20MG GELU",
  UCD7: '9369706',
  UCD13: '3400893697061',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE SDZ 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2741806',
  CIP13: '3400927418068',
  ucdLib: "ESOMEPRAZOLE SDZ 40MG GELU",
  UCD7: '9369712',
  UCD13: '3400893697122',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE SDZ 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2741812',
  CIP13: '3400927418129',
  ucdLib: "ESOMEPRAZOLE SDZ 40MG GELU",
  UCD7: '9369712',
  UCD13: '3400893697122',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE SDZ 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2748139',
  CIP13: '3400927481390',
  ucdLib: "ESOMEPRAZOLE TVC 20MG GELU",
  UCD7: '9366783',
  UCD13: '3400893667835',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE TVC 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '2748145',
  CIP13: '3400927481451',
  ucdLib: "ESOMEPRAZOLE TVC 20MG GELU",
  UCD7: '9366783',
  UCD13: '3400893667835',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE TVC 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2748151',
  CIP13: '3400927481512',
  ucdLib: "ESOMEPRAZOLE TVC 20MG GELU",
  UCD7: '9366783',
  UCD13: '3400893667835',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE TVC 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2748168',
  CIP13: '3400927481680',
  ucdLib: "ESOMEPRAZOLE TVC 40MG GELU",
  UCD7: '9366808',
  UCD13: '3400893668085',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE TVC 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2748174',
  CIP13: '3400927481741',
  ucdLib: "ESOMEPRAZOLE TVC 40MG GELU",
  UCD7: '9366808',
  UCD13: '3400893668085',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE TVC 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2203598',
  CIP13: '3400922035987',
  ucdLib: "ESOMEPRAZOLE CRT 20MG GELU",
  UCD7: '9381908',
  UCD13: '3400893819081',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE CRT 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2203606',
  CIP13: '3400922036069',
  ucdLib: "ESOMEPRAZOLE CRT 20MG GELU",
  UCD7: '9381908',
  UCD13: '3400893819081',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE CRT 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2203629',
  CIP13: '3400922036298',
  ucdLib: "ESOMEPRAZOLE CRT 40MG GELU",
  UCD7: '9381914',
  UCD13: '3400893819142',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE CRT 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2203635',
  CIP13: '3400922036359',
  ucdLib: "ESOMEPRAZOLE CRT 40MG GELU",
  UCD7: '9381914',
  UCD13: '3400893819142',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE CRT 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2736633',
  CIP13: '3400927366338',
  ucdLib: "ESOMEPRAZOLE MYL 20MG GELU",
  UCD7: '9366748',
  UCD13: '3400893667484',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE MYL 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2736679',
  CIP13: '3400927366796',
  ucdLib: "ESOMEPRAZOLE MYL 40MG GELU",
  UCD7: '9366754',
  UCD13: '3400893667545',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE MYL 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2203374',
  CIP13: '3400922033747',
  ucdLib: "ESOMEPRAZOLE ZYD 20MG GELU",
  UCD7: '9383161',
  UCD13: '3400893831618',
  ucdQtyMultiplicator: 7,
  cipLib: "ESOMEPRAZOLE ZYD 20MG GELU BT 7",
  atcCode: "A02BC05"
}, {
  CIP7: '2203380',
  CIP13: '3400922033808',
  ucdLib: "ESOMEPRAZOLE ZYD 20MG GELU",
  UCD7: '9383161',
  UCD13: '3400893831618',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE ZYD 20MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2203397',
  CIP13: '3400922033976',
  ucdLib: "ESOMEPRAZOLE ZYD 20MG GELU",
  UCD7: '9383161',
  UCD13: '3400893831618',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE ZYD 20MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '2203428',
  CIP13: '3400922034287',
  ucdLib: "ESOMEPRAZOLE ZYD 40MG GELU",
  UCD7: '9383178',
  UCD13: '3400893831786',
  ucdQtyMultiplicator: 14,
  cipLib: "ESOMEPRAZOLE ZYD 40MG GELU BT 14",
  atcCode: "A02BC05"
}, {
  CIP7: '2203434',
  CIP13: '3400922034348',
  ucdLib: "ESOMEPRAZOLE ZYD 40MG GELU",
  UCD7: '9383178',
  UCD13: '3400893831786',
  ucdQtyMultiplicator: 28,
  cipLib: "ESOMEPRAZOLE ZYD 40MG GELU BT 28",
  atcCode: "A02BC05"
}, {
  CIP7: '3000292',
  CIP13: '3400930002926',
  ucdLib: "RABEPRAZOLE ALT 10MG CPR",
  UCD7: '9410248',
  UCD13: '3400894102489',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ALT 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '3000306',
  CIP13: '3400930003060',
  ucdLib: "RABEPRAZOLE ALT 20MG CPR",
  UCD7: '9410254',
  UCD13: '3400894102540',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ALT 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '3579727',
  CIP13: '3400935797278',
  ucdLib: "PARIET 10MG CPR",
  UCD7: '9217089',
  UCD13: '3400892170893',
  ucdQtyMultiplicator: 50,
  cipLib: "PARIET 10MG CPR BT 50",
  atcCode: "A02BC04"
}, {
  CIP7: '3579779',
  CIP13: '3400935797797',
  ucdLib: "PARIET 20MG CPR",
  UCD7: '9213275',
  UCD13: '3400892132754',
  ucdQtyMultiplicator: 50,
  cipLib: "PARIET 20MG CPR BT 50",
  atcCode: "A02BC04"
}, {
  CIP7: '3567428',
  CIP13: '3400935674289',
  ucdLib: "PARIET 10MG CPR",
  UCD7: '9217089',
  UCD13: '3400892170893',
  ucdQtyMultiplicator: 14,
  cipLib: "PARIET 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '3567440',
  CIP13: '3400935674401',
  ucdLib: "PARIET 10MG CPR",
  UCD7: '9217089',
  UCD13: '3400892170893',
  ucdQtyMultiplicator: 28,
  cipLib: "PARIET 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '3551456',
  CIP13: '3400935514561',
  ucdLib: "PARIET 20MG CPR",
  UCD7: '9213275',
  UCD13: '3400892132754',
  ucdQtyMultiplicator: 14,
  cipLib: "PARIET 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '3551479',
  CIP13: '3400935514790',
  ucdLib: "PARIET 20MG CPR",
  UCD7: '9213275',
  UCD13: '3400892132754',
  ucdQtyMultiplicator: 28,
  cipLib: "PARIET 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4970020',
  CIP13: '3400949700202',
  ucdLib: "RABEPRAZOLE TVC 10MG CPR",
  UCD7: '9365737',
  UCD13: '3400893657379',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE TVC 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4970161',
  CIP13: '3400949701612',
  ucdLib: "RABEPRAZOLE TVC 20MG CPR",
  UCD7: '9365743',
  UCD13: '3400893657430',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE TVC 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '4970209',
  CIP13: '3400949702091',
  ucdLib: "RABEPRAZOLE TVC 20MG CPR",
  UCD7: '9365743',
  UCD13: '3400893657430',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE TVC 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4900864',
  CIP13: '3400949008643',
  ucdLib: "PARIET 10MG CPR AIP MWI DE",
  UCD7: '9377806',
  UCD13: '3400893778067',
  ucdQtyMultiplicator: 28,
  cipLib: "PARIET 10MG CPR AIP MWI DE BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4900812',
  CIP13: '3400949008124',
  ucdLib: "PARIET 10MG CPR AIP PLA DE",
  UCD7: '9374328',
  UCD13: '3400893743287',
  ucdQtyMultiplicator: 28,
  cipLib: "PARIET 10MG CPR AIP PLA DE BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4900309',
  CIP13: '3400949003099',
  ucdLib: "PARIET 20MG CPR AIP MWI DE",
  UCD7: '9336463',
  UCD13: '3400893364635',
  ucdQtyMultiplicator: 28,
  cipLib: "PARIET 20MG CPR AIP MWI DE BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4900344',
  CIP13: '3400949003440',
  ucdLib: "PARIET 20MG CPR AIP PLA DE",
  UCD7: '9341895',
  UCD13: '3400893418956',
  ucdQtyMultiplicator: 28,
  cipLib: "PARIET 20MG CPR AIP PLA DE BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4993989',
  CIP13: '3400949939893',
  ucdLib: "RABEPRAZOLE BGA 10MG CPR",
  UCD7: '9370655',
  UCD13: '3400893706558',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE BGA 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '4994026',
  CIP13: '3400949940264',
  ucdLib: "RABEPRAZOLE BGA 10MG CPR",
  UCD7: '9370655',
  UCD13: '3400893706558',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE BGA 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4994115',
  CIP13: '3400949941155',
  ucdLib: "RABEPRAZOLE BGA 20MG CPR",
  UCD7: '9370661',
  UCD13: '3400893706619',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE BGA 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '4994144',
  CIP13: '3400949941445',
  ucdLib: "RABEPRAZOLE BGA 20MG CPR",
  UCD7: '9370661',
  UCD13: '3400893706619',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE BGA 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2666565',
  CIP13: '3400926665654',
  ucdLib: "RABEPRAZOLE EVO 10MG CPR",
  UCD7: '9389531',
  UCD13: '3400893895313',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE EVO 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2666602',
  CIP13: '3400926666026',
  ucdLib: "RABEPRAZOLE EVO 10MG CPR",
  UCD7: '9389531',
  UCD13: '3400893895313',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE EVO 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2666789',
  CIP13: '3400926667894',
  ucdLib: "RABEPRAZOLE EVO 20MG CPR",
  UCD7: '9389548',
  UCD13: '3400893895481',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE EVO 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2666832',
  CIP13: '3400926668327',
  ucdLib: "RABEPRAZOLE EVO 20MG CPR",
  UCD7: '9389548',
  UCD13: '3400893895481',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE EVO 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2199230',
  CIP13: '3400921992304',
  ucdLib: "RABEPRAZOLE ISD 10MG CPR",
  UCD7: '9386449',
  UCD13: '3400893864494',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE ISD 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2199282',
  CIP13: '3400921992823',
  ucdLib: "RABEPRAZOLE ISD 10MG CPR",
  UCD7: '9386449',
  UCD13: '3400893864494',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ISD 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2199365',
  CIP13: '3400921993653',
  ucdLib: "RABEPRAZOLE ISD 20MG CPR",
  UCD7: '9386455',
  UCD13: '3400893864555',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE ISD 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '4949557',
  CIP13: '3400949495573',
  ucdLib: "RABEPRAZOLE KRK 10MG CPR",
  UCD7: '9365683',
  UCD13: '3400893656839',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE KRK 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '4949586',
  CIP13: '3400949495863',
  ucdLib: "RABEPRAZOLE KRK 10MG CPR",
  UCD7: '9365683',
  UCD13: '3400893656839',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE KRK 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4949451',
  CIP13: '3400949494514',
  ucdLib: "RABEPRAZOLE KRK 20MG CPR",
  UCD7: '9365708',
  UCD13: '3400893657089',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE KRK 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '4949474',
  CIP13: '3400949494743',
  ucdLib: "RABEPRAZOLE KRK 20MG CPR",
  UCD7: '9365708',
  UCD13: '3400893657089',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE KRK 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2666128',
  CIP13: '3400926661281',
  ucdLib: "RABEPRAZOLE MYG 10MG CPR",
  UCD7: '9400439',
  UCD13: '3400894004394',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE MYG 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2666163',
  CIP13: '3400926661632',
  ucdLib: "RABEPRAZOLE MYG 10MG CPR",
  UCD7: '9400439',
  UCD13: '3400894004394',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE MYG 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2666341',
  CIP13: '3400926663414',
  ucdLib: "RABEPRAZOLE MYG 20MG CPR",
  UCD7: '9400445',
  UCD13: '3400894004455',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE MYG 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2666387',
  CIP13: '3400926663872',
  ucdLib: "RABEPRAZOLE MYG 20MG CPR",
  UCD7: '9400445',
  UCD13: '3400894004455',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE MYG 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2199477',
  CIP13: '3400921994773',
  ucdLib: "RABEPRAZOLE PHR 10MG CPR",
  UCD7: '9388566',
  UCD13: '3400893885666',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE PHR 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4996841',
  CIP13: '3400949968411',
  ucdLib: "RABEPRAZOLE SDZ 10MG CPR",
  UCD7: '9370678',
  UCD13: '3400893706787',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE SDZ 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '4996887',
  CIP13: '3400949968879',
  ucdLib: "RABEPRAZOLE SDZ 10MG CPR",
  UCD7: '9370678',
  UCD13: '3400893706787',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE SDZ 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4997042',
  CIP13: '3400949970421',
  ucdLib: "RABEPRAZOLE SDZ 20MG CPR",
  UCD7: '9370684',
  UCD13: '3400893706848',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE SDZ 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '4997088',
  CIP13: '3400949970889',
  ucdLib: "RABEPRAZOLE SDZ 20MG CPR",
  UCD7: '9370684',
  UCD13: '3400893706848',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE SDZ 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2681470',
  CIP13: '3400926814700',
  ucdLib: "RABEPRAZOLE ALM 20MG CPR",
  UCD7: '9390758',
  UCD13: '3400893907580',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ALM 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2184754',
  CIP13: '3400921847543',
  ucdLib: "RABEPRAZOLE ARG 10MG CPR",
  UCD7: '9385378',
  UCD13: '3400893853788',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE ARG 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2184808',
  CIP13: '3400921848083',
  ucdLib: "RABEPRAZOLE ARG 10MG CPR",
  UCD7: '9385378',
  UCD13: '3400893853788',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ARG 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2184984',
  CIP13: '3400921849844',
  ucdLib: "RABEPRAZOLE ARG 20MG CPR",
  UCD7: '9385384',
  UCD13: '3400893853849',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE ARG 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2185021',
  CIP13: '3400921850215',
  ucdLib: "RABEPRAZOLE ARG 20MG CPR",
  UCD7: '9385384',
  UCD13: '3400893853849',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ARG 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2246277',
  CIP13: '3400922462776',
  ucdLib: "RABEPRAZOLE CRT 10MG CPR",
  UCD7: '9390066',
  UCD13: '3400893900666',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE CRT 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2246343',
  CIP13: '3400922463438',
  ucdLib: "RABEPRAZOLE CRT 10MG CPR",
  UCD7: '9390066',
  UCD13: '3400893900666',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE CRT 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2246521',
  CIP13: '3400922465210',
  ucdLib: "RABEPRAZOLE CRT 20MG CPR",
  UCD7: '9390072',
  UCD13: '3400893900727',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE CRT 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2246567',
  CIP13: '3400922465678',
  ucdLib: "RABEPRAZOLE CRT 20MG CPR",
  UCD7: '9390072',
  UCD13: '3400893900727',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE CRT 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2682216',
  CIP13: '3400926822163',
  ucdLib: "RABEPRAZOLE EGL 10MG CPR",
  UCD7: '9391195',
  UCD13: '3400893911952',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE EGL 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2682245',
  CIP13: '3400926822453',
  ucdLib: "RABEPRAZOLE EGL 10MG CPR",
  UCD7: '9391195',
  UCD13: '3400893911952',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE EGL 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2682328',
  CIP13: '3400926823283',
  ucdLib: "RABEPRAZOLE EGL 20MG CPR",
  UCD7: '9391203',
  UCD13: '3400893912034',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE EGL 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2682340',
  CIP13: '3400926823405',
  ucdLib: "RABEPRAZOLE EGL 20MG CPR",
  UCD7: '9391203',
  UCD13: '3400893912034',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE EGL 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2249123',
  CIP13: '3400922491233',
  ucdLib: "RABEPRAZOLE RBX 10MG CPR",
  UCD7: '9391769',
  UCD13: '3400893917695',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE RBX 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2249146',
  CIP13: '3400922491462',
  ucdLib: "RABEPRAZOLE RBX 10MG CPR",
  UCD7: '9391769',
  UCD13: '3400893917695',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE RBX 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2249169',
  CIP13: '3400922491691',
  ucdLib: "RABEPRAZOLE RBX 20MG CPR",
  UCD7: '9391775',
  UCD13: '3400893917756',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE RBX 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2249175',
  CIP13: '3400922491752',
  ucdLib: "RABEPRAZOLE RBX 20MG CPR",
  UCD7: '9391775',
  UCD13: '3400893917756',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE RBX 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2183654',
  CIP13: '3400921836547',
  ucdLib: "RABEPRAZOLE ZEN 10MG CPR",
  UCD7: '9388595',
  UCD13: '3400893885956',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE ZEN 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2183677',
  CIP13: '3400921836776',
  ucdLib: "RABEPRAZOLE ZEN 10MG CPR",
  UCD7: '9388595',
  UCD13: '3400893885956',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ZEN 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2183789',
  CIP13: '3400921837896',
  ucdLib: "RABEPRAZOLE ZEN 20MG CPR",
  UCD7: '9388603',
  UCD13: '3400893886038',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE ZEN 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2183832',
  CIP13: '3400921838329',
  ucdLib: "RABEPRAZOLE ZEN 20MG CPR",
  UCD7: '9388603',
  UCD13: '3400893886038',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ZEN 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2185216',
  CIP13: '3400921852165',
  ucdLib: "RABEPRAZOLE ZYD 10MG CPR",
  UCD7: '9388336',
  UCD13: '3400893883365',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE ZYD 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2185251',
  CIP13: '3400921852516',
  ucdLib: "RABEPRAZOLE ZYD 10MG CPR",
  UCD7: '9388336',
  UCD13: '3400893883365',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ZYD 10MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '2185446',
  CIP13: '3400921854466',
  ucdLib: "RABEPRAZOLE ZYD 20MG CPR",
  UCD7: '9388342',
  UCD13: '3400893883426',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE ZYD 20MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '2185481',
  CIP13: '3400921854817',
  ucdLib: "RABEPRAZOLE ZYD 20MG CPR",
  UCD7: '9388342',
  UCD13: '3400893883426',
  ucdQtyMultiplicator: 28,
  cipLib: "RABEPRAZOLE ZYD 20MG CPR BT 28",
  atcCode: "A02BC04"
}, {
  CIP7: '4969985',
  CIP13: '3400949699858',
  ucdLib: "RABEPRAZOLE TVC 10MG CPR",
  UCD7: '9365737',
  UCD13: '3400893657379',
  ucdQtyMultiplicator: 14,
  cipLib: "RABEPRAZOLE TVC 10MG CPR BT 14",
  atcCode: "A02BC04"
}, {
  CIP7: '3454902',
  CIP13: '3400934549021',
  ucdLib: "LANZOR 15MG GELU",
  UCD7: '9190189',
  UCD13: '3400891901894',
  ucdQtyMultiplicator: 30,
  cipLib: "LANZOR 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3454842',
  CIP13: '3400934548420',
  ucdLib: "OGAST 15MG GELU",
  UCD7: '9194402',
  UCD13: '3400891944020',
  ucdQtyMultiplicator: 30,
  cipLib: "OGAST 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3430333',
  CIP13: '3400934303333',
  ucdLib: "LANZOR 30MG GELU",
  UCD7: '9151195',
  UCD13: '3400891511956',
  ucdQtyMultiplicator: 14,
  cipLib: "LANZOR 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3430356',
  CIP13: '3400934303562',
  ucdLib: "LANZOR 30MG GELU",
  UCD7: '9151195',
  UCD13: '3400891511956',
  ucdQtyMultiplicator: 14,
  cipLib: "LANZOR 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3430416',
  CIP13: '3400934304163',
  ucdLib: "OGAST 30MG GELU",
  UCD7: '9151203',
  UCD13: '3400891512038',
  ucdQtyMultiplicator: 14,
  cipLib: "OGAST 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3588169',
  CIP13: '3400935881694',
  ucdLib: "LANZOR 15MG GELU",
  UCD7: '9190189',
  UCD13: '3400891901894',
  ucdQtyMultiplicator: 15,
  cipLib: "LANZOR 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3818652',
  CIP13: '3400938186529',
  ucdLib: "LANSOPRAZOLE ALM 15MG GELU",
  UCD7: '9306901',
  UCD13: '3400893069011',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE ALM 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3818675',
  CIP13: '3400938186758',
  ucdLib: "LANSOPRAZOLE ALM 15MG GELU",
  UCD7: '9306901',
  UCD13: '3400893069011',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE ALM 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3811207',
  CIP13: '3400938112078',
  ucdLib: "LANSOPRAZOLE ALM 30MG GELU",
  UCD7: '9306918',
  UCD13: '3400893069189',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE ALM 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3811213',
  CIP13: '3400938112139',
  ucdLib: "LANSOPRAZOLE ALM 30MG GELU",
  UCD7: '9306918',
  UCD13: '3400893069189',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE ALM 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3810320',
  CIP13: '3400938103205',
  ucdLib: "LANSOPRAZOLE BGA 15MG GELU",
  UCD7: '9306924',
  UCD13: '3400893069240',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE BGA 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3810395',
  CIP13: '3400938103953',
  ucdLib: "LANSOPRAZOLE BGA 15MG GELU",
  UCD7: '9306924',
  UCD13: '3400893069240',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE BGA 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3810403',
  CIP13: '3400938104035',
  ucdLib: "LANSOPRAZOLE BGA 15MG GELU",
  UCD7: '9306924',
  UCD13: '3400893069240',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE BGA 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3810544',
  CIP13: '3400938105445',
  ucdLib: "LANSOPRAZOLE BGA 30MG GELU",
  UCD7: '9306930',
  UCD13: '3400893069301',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE BGA 30MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3810610',
  CIP13: '3400938106107',
  ucdLib: "LANSOPRAZOLE BGA 30MG GELU",
  UCD7: '9306930',
  UCD13: '3400893069301',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE BGA 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '3810633',
  CIP13: '3400938106336',
  ucdLib: "LANSOPRAZOLE BGA 30MG GELU",
  UCD7: '9306930',
  UCD13: '3400893069301',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE BGA 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3814430',
  CIP13: '3400938144307',
  ucdLib: "LANSOPRAZOLE BGA 30MG GELU",
  UCD7: '9306930',
  UCD13: '3400893069301',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE BGA 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3811650',
  CIP13: '3400938116502',
  ucdLib: "LANSOPRAZOLE EG 15MG GELU",
  UCD7: '9306947',
  UCD13: '3400893069479',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE EG 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3811673',
  CIP13: '3400938116731',
  ucdLib: "LANSOPRAZOLE EG 15MG GELU",
  UCD7: '9306947',
  UCD13: '3400893069479',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE EG 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3811704',
  CIP13: '3400938117042',
  ucdLib: "LANSOPRAZOLE EG 30MG GELU",
  UCD7: '9306953',
  UCD13: '3400893069530',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE EG 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '3811710',
  CIP13: '3400938117103',
  ucdLib: "LANSOPRAZOLE EG 30MG GELU",
  UCD7: '9306953',
  UCD13: '3400893069530',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE EG 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3811727',
  CIP13: '3400938117271',
  ucdLib: "LANSOPRAZOLE EG 30MG GELU",
  UCD7: '9306953',
  UCD13: '3400893069530',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE EG 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3813985',
  CIP13: '3400938139853',
  ucdLib: "LANSOPRAZOLE MYL 15MG GELU",
  UCD7: '9306976',
  UCD13: '3400893069769',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE MYL 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3814016',
  CIP13: '3400938140163',
  ucdLib: "LANSOPRAZOLE MYL 15MG GELU",
  UCD7: '9306976',
  UCD13: '3400893069769',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE MYL 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3810484',
  CIP13: '3400938104844',
  ucdLib: "LANSOPRAZOLE MYL 30MG GELU",
  UCD7: '9306982',
  UCD13: '3400893069820',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE MYL 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '3810490',
  CIP13: '3400938104905',
  ucdLib: "LANSOPRAZOLE MYL 30MG GELU",
  UCD7: '9306982',
  UCD13: '3400893069820',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE MYL 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3810509',
  CIP13: '3400938105094',
  ucdLib: "LANSOPRAZOLE MYL 30MG GELU",
  UCD7: '9306982',
  UCD13: '3400893069820',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE MYL 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3811302',
  CIP13: '3400938113020',
  ucdLib: "LANSOPRAZOLE PHR 15MG GELU",
  UCD7: '9308219',
  UCD13: '3400893082195',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE PHR 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3811325',
  CIP13: '3400938113259',
  ucdLib: "LANSOPRAZOLE PHR 15MG GELU",
  UCD7: '9308219',
  UCD13: '3400893082195',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE PHR 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3811354',
  CIP13: '3400938113549',
  ucdLib: "LANSOPRAZOLE PHR 30MG GELU",
  UCD7: '9308225',
  UCD13: '3400893082256',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE PHR 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3819350',
  CIP13: '3400938193503',
  ucdLib: "LANSOPRAZOLE RBX 15MG GELU",
  UCD7: '9307450',
  UCD13: '3400893074503',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE RBX 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3819373',
  CIP13: '3400938193732',
  ucdLib: "LANSOPRAZOLE RBX 15MG GELU",
  UCD7: '9307450',
  UCD13: '3400893074503',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE RBX 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3819410',
  CIP13: '3400938194104',
  ucdLib: "LANSOPRAZOLE RBX 30MG GELU",
  UCD7: '9307467',
  UCD13: '3400893074671',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE RBX 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3819433',
  CIP13: '3400938194333',
  ucdLib: "LANSOPRAZOLE RBX 30MG GELU",
  UCD7: '9307467',
  UCD13: '3400893074671',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE RBX 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3811288',
  CIP13: '3400938112887',
  ucdLib: "LANSOPRAZOLE SDZ 15MG GELU",
  UCD7: '9305155',
  UCD13: '3400893051559',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE SDZ 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3811294',
  CIP13: '3400938112948',
  ucdLib: "LANSOPRAZOLE SDZ 15MG GELU",
  UCD7: '9305155',
  UCD13: '3400893051559',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE SDZ 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3811845',
  CIP13: '3400938118452',
  ucdLib: "LANSOPRAZOLE SDZ 30MG GELU",
  UCD7: '9305161',
  UCD13: '3400893051610',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE SDZ 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '3811851',
  CIP13: '3400938118513',
  ucdLib: "LANSOPRAZOLE SDZ 30MG GELU",
  UCD7: '9305161',
  UCD13: '3400893051610',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE SDZ 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3811868',
  CIP13: '3400938118681',
  ucdLib: "LANSOPRAZOLE SDZ 30MG GELU",
  UCD7: '9305161',
  UCD13: '3400893051610',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE SDZ 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3811756',
  CIP13: '3400938117561',
  ucdLib: "LANSOPRAZOLE TVS 15MG GELU",
  UCD7: '9307266',
  UCD13: '3400893072660',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE TVS 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3811779',
  CIP13: '3400938117790',
  ucdLib: "LANSOPRAZOLE TVS 15MG GELU",
  UCD7: '9307266',
  UCD13: '3400893072660',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE TVS 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3811791',
  CIP13: '3400938117912',
  ucdLib: "LANSOPRAZOLE TVS 30MG GELU",
  UCD7: '9307272',
  UCD13: '3400893072721',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE TVS 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '3811816',
  CIP13: '3400938118162',
  ucdLib: "LANSOPRAZOLE TVS 30MG GELU",
  UCD7: '9307272',
  UCD13: '3400893072721',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE TVS 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3811822',
  CIP13: '3400938118223',
  ucdLib: "LANSOPRAZOLE TVS 30MG GELU",
  UCD7: '9307272',
  UCD13: '3400893072721',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE TVS 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3810857',
  CIP13: '3400938108576',
  ucdLib: "LANSOPRAZOLE ZEN 15MG GELU",
  UCD7: '9305327',
  UCD13: '3400893053270',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE ZEN 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3810886',
  CIP13: '3400938108866',
  ucdLib: "LANSOPRAZOLE ZEN 15MG GELU",
  UCD7: '9305327',
  UCD13: '3400893053270',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE ZEN 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3810969',
  CIP13: '3400938109696',
  ucdLib: "LANSOPRAZOLE ZEN 30MG GELU",
  UCD7: '9305333',
  UCD13: '3400893053331',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE ZEN 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '3810975',
  CIP13: '3400938109757',
  ucdLib: "LANSOPRAZOLE ZEN 30MG GELU",
  UCD7: '9305333',
  UCD13: '3400893053331',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE ZEN 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3810998',
  CIP13: '3400938109986',
  ucdLib: "LANSOPRAZOLE ZEN 30MG GELU",
  UCD7: '9305333',
  UCD13: '3400893053331',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE ZEN 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3782836',
  CIP13: '3400937828369',
  ucdLib: "LANSOPRAZOLE ARW 15MG GELU",
  UCD7: '9305072',
  UCD13: '3400893050729',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE ARW 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3782859',
  CIP13: '3400937828598',
  ucdLib: "LANSOPRAZOLE ARW 15MG GELU",
  UCD7: '9305072',
  UCD13: '3400893050729',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE ARW 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3782799',
  CIP13: '3400937827997',
  ucdLib: "LANSOPRAZOLE ARW 30MG GELU",
  UCD7: '9305089',
  UCD13: '3400893050897',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE ARW 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '3782807',
  CIP13: '3400937828079',
  ucdLib: "LANSOPRAZOLE ARW 30MG GELU",
  UCD7: '9305089',
  UCD13: '3400893050897',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE ARW 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3782813',
  CIP13: '3400937828130',
  ucdLib: "LANSOPRAZOLE ARW 30MG GELU",
  UCD7: '9305089',
  UCD13: '3400893050897',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE ARW 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3441549',
  CIP13: '3400934415494',
  ucdLib: "LANSOPRAZOLE BGR 30MG GELU",
  UCD7: '9347805',
  UCD13: '3400893478059',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE BGR 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '3447569',
  CIP13: '3400934475696',
  ucdLib: "LANZOR 30MG GELU",
  UCD7: '9151195',
  UCD13: '3400891511956',
  ucdQtyMultiplicator: 28,
  cipLib: "LANZOR 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3445518',
  CIP13: '3400934455186',
  ucdLib: "OGAST 30MG GELU",
  UCD7: '9151203',
  UCD13: '3400891512038',
  ucdQtyMultiplicator: 28,
  cipLib: "OGAST 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3923952',
  CIP13: '3400939239521',
  ucdLib: "OGASTORO 15MG CPR ORODISP",
  UCD7: '9280633',
  UCD13: '3400892806334',
  ucdQtyMultiplicator: 14,
  cipLib: "OGASTORO 15MG CPR ORODISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3923969',
  CIP13: '3400939239699',
  ucdLib: "OGASTORO 15MG CPR ORODISP",
  UCD7: '9280633',
  UCD13: '3400892806334',
  ucdQtyMultiplicator: 28,
  cipLib: "OGASTORO 15MG CPR ORODISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3923981',
  CIP13: '3400939239811',
  ucdLib: "OGASTORO 30MG CPR ORODISP",
  UCD7: '9280656',
  UCD13: '3400892806563',
  ucdQtyMultiplicator: 14,
  cipLib: "OGASTORO 30MG CPR ORODISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3923998',
  CIP13: '3400939239989',
  ucdLib: "OGASTORO 30MG CPR ORODISP",
  UCD7: '9280656',
  UCD13: '3400892806563',
  ucdQtyMultiplicator: 28,
  cipLib: "OGASTORO 30MG CPR ORODISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3899366',
  CIP13: '3400938993660',
  ucdLib: "LANSOPRAZOLE KRK 15MG GELU",
  UCD7: '9327501',
  UCD13: '3400893275016',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE KRK 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '3899389',
  CIP13: '3400938993899',
  ucdLib: "LANSOPRAZOLE KRK 15MG GELU",
  UCD7: '9327501',
  UCD13: '3400893275016',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE KRK 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '3899159',
  CIP13: '3400938991598',
  ucdLib: "LANSOPRAZOLE KRK 30MG GELU",
  UCD7: '9327518',
  UCD13: '3400893275184',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE KRK 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '3899171',
  CIP13: '3400938991710',
  ucdLib: "LANSOPRAZOLE KRK 30MG GELU",
  UCD7: '9327518',
  UCD13: '3400893275184',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE KRK 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '4190210',
  CIP13: '3400941902109',
  ucdLib: "LANSOPRAZOLE BGR 15MG GELU",
  UCD7: '9347797',
  UCD13: '3400893477977',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE BGR 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '4178338',
  CIP13: '3400941783388',
  ucdLib: "LANSOPRAZOLE CRT 15MG GELU",
  UCD7: '9389063',
  UCD13: '3400893890639',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE CRT 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '4178427',
  CIP13: '3400941784279',
  ucdLib: "LANSOPRAZOLE CRT 15MG GELU",
  UCD7: '9389063',
  UCD13: '3400893890639',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE CRT 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '4178456',
  CIP13: '3400941784569',
  ucdLib: "LANSOPRAZOLE CRT 15MG GELU",
  UCD7: '9389063',
  UCD13: '3400893890639',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE CRT 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '4178746',
  CIP13: '3400941787461',
  ucdLib: "LANSOPRAZOLE CRT 30MG GELU",
  UCD7: '9379030',
  UCD13: '3400893790304',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE CRT 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '4178752',
  CIP13: '3400941787522',
  ucdLib: "LANSOPRAZOLE CRT 30MG GELU",
  UCD7: '9379030',
  UCD13: '3400893790304',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE CRT 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '4178864',
  CIP13: '3400941788642',
  ucdLib: "LANSOPRAZOLE CRT 30MG GELU",
  UCD7: '9379030',
  UCD13: '3400893790304',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE CRT 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '4949801',
  CIP13: '3400949498017',
  ucdLib: "LANSOPRAZOLE EVO 15MG GELU",
  UCD7: '9362822',
  UCD13: '3400893628225',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE EVO 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '4949824',
  CIP13: '3400949498246',
  ucdLib: "LANSOPRAZOLE EVO 15MG GELU",
  UCD7: '9362822',
  UCD13: '3400893628225',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE EVO 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '4949853',
  CIP13: '3400949498536',
  ucdLib: "LANSOPRAZOLE EVO 30MG GELU",
  UCD7: '9362839',
  UCD13: '3400893628393',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE EVO 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '4949876',
  CIP13: '3400949498765',
  ucdLib: "LANSOPRAZOLE EVO 30MG GELU",
  UCD7: '9362839',
  UCD13: '3400893628393',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE EVO 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '4949899',
  CIP13: '3400949498994',
  ucdLib: "LANSOPRAZOLE EVO 30MG GELU",
  UCD7: '9362839',
  UCD13: '3400893628393',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE EVO 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2741835',
  CIP13: '3400927418358',
  ucdLib: "LANSOPRAZOLE MYL 30MG C.DISP",
  UCD7: '9395477',
  UCD13: '3400893954775',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE MYL 30MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2741841',
  CIP13: '3400927418419',
  ucdLib: "LANSOPRAZOLE MYL 30MG C.DISP",
  UCD7: '9395477',
  UCD13: '3400893954775',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE MYL 30MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2695727',
  CIP13: '3400926957278',
  ucdLib: "LANSOPRAZOLE ZYF 15MG GELU",
  UCD7: '9393722',
  UCD13: '3400893937228',
  ucdQtyMultiplicator: 15,
  cipLib: "LANSOPRAZOLE ZYF 15MG GELU BT 15",
  atcCode: "A02BC03"
}, {
  CIP7: '2695756',
  CIP13: '3400926957568',
  ucdLib: "LANSOPRAZOLE ZYF 15MG GELU",
  UCD7: '9393722',
  UCD13: '3400893937228',
  ucdQtyMultiplicator: 30,
  cipLib: "LANSOPRAZOLE ZYF 15MG GELU BT 30",
  atcCode: "A02BC03"
}, {
  CIP7: '2695578',
  CIP13: '3400926955786',
  ucdLib: "LANSOPRAZOLE ZYF 30MG GELU",
  UCD7: '9393739',
  UCD13: '3400893937396',
  ucdQtyMultiplicator: 7,
  cipLib: "LANSOPRAZOLE ZYF 30MG GELU BT 7",
  atcCode: "A02BC03"
}, {
  CIP7: '2695584',
  CIP13: '3400926955847',
  ucdLib: "LANSOPRAZOLE ZYF 30MG GELU",
  UCD7: '9393739',
  UCD13: '3400893937396',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE ZYF 30MG GELU BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2695590',
  CIP13: '3400926955908',
  ucdLib: "LANSOPRAZOLE ZYF 30MG GELU",
  UCD7: '9393739',
  UCD13: '3400893937396',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE ZYF 30MG GELU BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '4902627',
  CIP13: '3400949026272',
  ucdLib: "OGASTORO 15MG C.D AIP BBA UK",
  UCD7: '9405402',
  UCD13: '3400894054023',
  ucdQtyMultiplicator: 28,
  cipLib: "OGASTORO 15MG C.D AIP BBA UK BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '4900752',
  CIP13: '3400949007523',
  ucdLib: "OGASTORO 15MG C.D AIP MWI UK",
  UCD7: '9371790',
  UCD13: '3400893717905',
  ucdQtyMultiplicator: 28,
  cipLib: "OGASTORO 15MG C.D AIP MWI UK BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '4900462',
  CIP13: '3400949004621',
  ucdLib: "OGASTORO 15MG C.D AIP PLA UK",
  UCD7: '9352976',
  UCD13: '3400893529768',
  ucdQtyMultiplicator: 28,
  cipLib: "OGASTORO 15MG C.D AIP PLA UK BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '4900769',
  CIP13: '3400949007691',
  ucdLib: "OGASTORO 30MG C.D AIP MWI UK",
  UCD7: '9374297',
  UCD13: '3400893742976',
  ucdQtyMultiplicator: 28,
  cipLib: "OGASTORO 30MG C.D AIP MWI UK BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '4900479',
  CIP13: '3400949004799',
  ucdLib: "OGASTORO 30MG C.D AIP PLA UK",
  UCD7: '9352982',
  UCD13: '3400893529829',
  ucdQtyMultiplicator: 28,
  cipLib: "OGASTORO 30MG C.D AIP PLA UK BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2787085',
  CIP13: '3400927870859',
  ucdLib: "LANSOPRAZOLE BGA 15MG C.DISP",
  UCD7: '9402591',
  UCD13: '3400894025917',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE BGA 15MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2787091',
  CIP13: '3400927870910',
  ucdLib: "LANSOPRAZOLE BGA 15MG C.DISP",
  UCD7: '9402591',
  UCD13: '3400894025917',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE BGA 15MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2787122',
  CIP13: '3400927871221',
  ucdLib: "LANSOPRAZOLE BGA 30MG C.DISP",
  UCD7: '9402616',
  UCD13: '3400894026167',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE BGA 30MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2787139',
  CIP13: '3400927871399',
  ucdLib: "LANSOPRAZOLE BGA 30MG C.DISP",
  UCD7: '9402616',
  UCD13: '3400894026167',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE BGA 30MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2735289',
  CIP13: '3400927352898',
  ucdLib: "LANSOPRAZOLE MYL 15MG C.DISP",
  UCD7: '9395460',
  UCD13: '3400893954607',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE MYL 15MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2735295',
  CIP13: '3400927352959',
  ucdLib: "LANSOPRAZOLE MYL 15MG C.DISP",
  UCD7: '9395460',
  UCD13: '3400893954607',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE MYL 15MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2793252',
  CIP13: '3400927932526',
  ucdLib: "LANSOPRAZOLE EG 15MG C.DISP",
  UCD7: '9406382',
  UCD13: '3400894063827',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE EG 15MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2793269',
  CIP13: '3400927932694',
  ucdLib: "LANSOPRAZOLE EG 15MG C.DISP",
  UCD7: '9406382',
  UCD13: '3400894063827',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE EG 15MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2793312',
  CIP13: '3400927933127',
  ucdLib: "LANSOPRAZOLE EG 30MG C.DISP",
  UCD7: '9406399',
  UCD13: '3400894063995',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE EG 30MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2793329',
  CIP13: '3400927933295',
  ucdLib: "LANSOPRAZOLE EG 30MG C.DISP",
  UCD7: '9406399',
  UCD13: '3400894063995',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE EG 30MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2792985',
  CIP13: '3400927929854',
  ucdLib: "LANSOPRAZOLE SDZ 15MG C.DISP",
  UCD7: '9404791',
  UCD13: '3400894047919',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE SDZ 15MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2792991',
  CIP13: '3400927929915',
  ucdLib: "LANSOPRAZOLE SDZ 15MG C.DISP",
  UCD7: '9404791',
  UCD13: '3400894047919',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE SDZ 15MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2793068',
  CIP13: '3400927930683',
  ucdLib: "LANSOPRAZOLE SDZ 30MG C.DISP",
  UCD7: '9404816',
  UCD13: '3400894048169',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE SDZ 30MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2793111',
  CIP13: '3400927931116',
  ucdLib: "LANSOPRAZOLE ZEN 15MG C.DISP",
  UCD7: '9406353',
  UCD13: '3400894063537',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE ZEN 15MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2793128',
  CIP13: '3400927931284',
  ucdLib: "LANSOPRAZOLE ZEN 15MG C.DISP",
  UCD7: '9406353',
  UCD13: '3400894063537',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE ZEN 15MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '2793186',
  CIP13: '3400927931864',
  ucdLib: "LANSOPRAZOLE ZEN 30MG C.DISP",
  UCD7: '9406376',
  UCD13: '3400894063766',
  ucdQtyMultiplicator: 14,
  cipLib: "LANSOPRAZOLE ZEN 30MG C.DISP BT 14",
  atcCode: "A02BC03"
}, {
  CIP7: '2793192',
  CIP13: '3400927931925',
  ucdLib: "LANSOPRAZOLE ZEN 30MG C.DISP",
  UCD7: '9406376',
  UCD13: '3400894063766',
  ucdQtyMultiplicator: 28,
  cipLib: "LANSOPRAZOLE ZEN 30MG C.DISP BT 28",
  atcCode: "A02BC03"
}, {
  CIP7: '3579064',
  CIP13: '3400935790644',
  ucdLib: "PANTOLOC CONTROL 20MG CPR",
  UCD7: '9352002',
  UCD13: '3400893520024',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOLOC CONTROL 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '4911626',
  CIP13: '3400949116263',
  ucdLib: "PANTOPRAZOLE PHR 20MG CPR",
  UCD7: '9354490',
  UCD13: '3400893544907',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE PHR 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '4911632',
  CIP13: '3400949116324',
  ucdLib: "PANTOPRAZOLE PHR 20MG CPR",
  UCD7: '9354490',
  UCD13: '3400893544907',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE PHR 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4911709',
  CIP13: '3400949117093',
  ucdLib: "PANTOPRAZOLE PHR 40MG CPR",
  UCD7: '9354509',
  UCD13: '3400893545096',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE PHR 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '4911715',
  CIP13: '3400949117154',
  ucdLib: "PANTOPRAZOLE PHR 40MG CPR",
  UCD7: '9354509',
  UCD13: '3400893545096',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE PHR 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3558530',
  CIP13: '3400935585301',
  ucdLib: "EUPANTOL 20MG CPR",
  UCD7: '9207197',
  UCD13: '3400892071978',
  ucdQtyMultiplicator: 28,
  cipLib: "EUPANTOL 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '5590348',
  CIP13: '3400955903482',
  ucdLib: "EUPANTOL 40MG CPR",
  UCD7: '9171795',
  UCD13: '3400891717952',
  ucdQtyMultiplicator: 50,
  cipLib: "EUPANTOL 40MG CPR BT 50",
  atcCode: "A02BC02"
}, {
  CIP7: '3558441',
  CIP13: '3400935584410',
  ucdLib: "INIPOMP 20MG CPR",
  UCD7: '9211678',
  UCD13: '3400892116785',
  ucdQtyMultiplicator: 28,
  cipLib: "INIPOMP 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3558470',
  CIP13: '3400935584700',
  ucdLib: "INIPOMP 40MG CPR",
  UCD7: '9173570',
  UCD13: '3400891735703',
  ucdQtyMultiplicator: 14,
  cipLib: "INIPOMP 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3558487',
  CIP13: '3400935584878',
  ucdLib: "INIPOMP 40MG CPR",
  UCD7: '9173570',
  UCD13: '3400891735703',
  ucdQtyMultiplicator: 28,
  cipLib: "INIPOMP 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '5591402',
  CIP13: '3400955914020',
  ucdLib: "INIPOMP 40MG CPR",
  UCD7: '9173570',
  UCD13: '3400891735703',
  ucdQtyMultiplicator: 50,
  cipLib: "INIPOMP 40MG CPR BT 50",
  atcCode: "A02BC02"
}, {
  CIP7: '3597441',
  CIP13: '3400935974419',
  ucdLib: "INIPOMP 20MG CPR",
  UCD7: '9211678',
  UCD13: '3400892116785',
  ucdQtyMultiplicator: 14,
  cipLib: "INIPOMP 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3460653',
  CIP13: '3400934606533',
  ucdLib: "EUPANTOL 40MG INJ FL",
  UCD7: '9201036',
  UCD13: '3400892010366',
  ucdQtyMultiplicator: 1,
  cipLib: "EUPANTOL 40MG INJ FL BT 1",
  atcCode: "A02BC02"
}, {
  CIP7: '3460618',
  CIP13: '3400934606182',
  ucdLib: "INIPOMP 40MG INJ FL",
  UCD7: '9202946',
  UCD13: '3400892029467',
  ucdQtyMultiplicator: 1,
  cipLib: "INIPOMP 40MG INJ FL BT 1",
  atcCode: "A02BC02"
}, {
  CIP7: '3580179',
  CIP13: '3400935801791',
  ucdLib: "PANTOLOC CONTROL 20MG CPR",
  UCD7: '9352002',
  UCD13: '3400893520024',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOLOC CONTROL 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '5624633',
  CIP13: '3400956246335',
  ucdLib: "EUPANTOL 20MG CPR",
  UCD7: '9207197',
  UCD13: '3400892071978',
  ucdQtyMultiplicator: 50,
  cipLib: "EUPANTOL 20MG CPR BT 50",
  atcCode: "A02BC02"
}, {
  CIP7: '3797499',
  CIP13: '3400937974998',
  ucdLib: "EUPANTOL 40MG CPR",
  UCD7: '9171795',
  UCD13: '3400891717952',
  ucdQtyMultiplicator: 28,
  cipLib: "EUPANTOL 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3826870',
  CIP13: '3400938268706',
  ucdLib: "PANTOPRAZOLE ALT 40MG CPR",
  UCD7: '9310989',
  UCD13: '3400893109892',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ALT 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3470522',
  CIP13: '3400934705229',
  ucdLib: "PANTOPRAZOLE ISD 20MG CPR",
  UCD7: '9348331',
  UCD13: '3400893483312',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ISD 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3470551',
  CIP13: '3400934705519',
  ucdLib: "PANTOPRAZOLE ISD 20MG CPR",
  UCD7: '9348331',
  UCD13: '3400893483312',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ISD 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3470663',
  CIP13: '3400934706639',
  ucdLib: "PANTOPRAZOLE ISD 40MG CPR",
  UCD7: '9348348',
  UCD13: '3400893483480',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE ISD 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3470686',
  CIP13: '3400934706868',
  ucdLib: "PANTOPRAZOLE ISD 40MG CPR",
  UCD7: '9348348',
  UCD13: '3400893483480',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ISD 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3470723',
  CIP13: '3400934707230',
  ucdLib: "PANTOPRAZOLE ISD 40MG CPR",
  UCD7: '9348348',
  UCD13: '3400893483480',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ISD 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3870374',
  CIP13: '3400938703740',
  ucdLib: "PANTOPRAZOLE ALT 20MG CPR",
  UCD7: '9322395',
  UCD13: '3400893223956',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ALT 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3870397',
  CIP13: '3400938703979',
  ucdLib: "PANTOPRAZOLE ALT 20MG CPR",
  UCD7: '9322395',
  UCD13: '3400893223956',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ALT 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3921309',
  CIP13: '3400939213095',
  ucdLib: "PANTOPRAZOLE BGA 40MG CPR",
  UCD7: '9331709',
  UCD13: '3400893317099',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE BGA 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3921315',
  CIP13: '3400939213156',
  ucdLib: "PANTOPRAZOLE BGA 40MG CPR",
  UCD7: '9331709',
  UCD13: '3400893317099',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE BGA 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3921321',
  CIP13: '3400939213217',
  ucdLib: "PANTOPRAZOLE BGA 40MG CPR",
  UCD7: '9331709',
  UCD13: '3400893317099',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE BGA 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3921338',
  CIP13: '3400939213385',
  ucdLib: "PANTOPRAZOLE BGA 40MG CPR",
  UCD7: '9331709',
  UCD13: '3400893317099',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE BGA 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3925543',
  CIP13: '3400939255439',
  ucdLib: "PANTOPRAZOLE KRK 20MG CPR",
  UCD7: '9340513',
  UCD13: '3400893405130',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE KRK 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3925572',
  CIP13: '3400939255729',
  ucdLib: "PANTOPRAZOLE KRK 20MG CPR",
  UCD7: '9340513',
  UCD13: '3400893405130',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE KRK 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3925744',
  CIP13: '3400939257440',
  ucdLib: "PANTOPRAZOLE KRK 40MG CPR",
  UCD7: '9352054',
  UCD13: '3400893520543',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE KRK 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3925767',
  CIP13: '3400939257679',
  ucdLib: "PANTOPRAZOLE KRK 40MG CPR",
  UCD7: '9352054',
  UCD13: '3400893520543',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE KRK 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3927128',
  CIP13: '3400939271286',
  ucdLib: "PANTOPRAZOLE MYP 40MG CPR",
  UCD7: '9331721',
  UCD13: '3400893317211',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE MYP 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3753088',
  CIP13: '3400937530880',
  ucdLib: "PANTOPRAZOLE RBX 40MG CPR",
  UCD7: '9358192',
  UCD13: '3400893581926',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE RBX 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3753094',
  CIP13: '3400937530941',
  ucdLib: "PANTOPRAZOLE RBX 40MG CPR",
  UCD7: '9358192',
  UCD13: '3400893581926',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE RBX 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3753119',
  CIP13: '3400937531191',
  ucdLib: "PANTOPRAZOLE RBX 40MG CPR",
  UCD7: '9358192',
  UCD13: '3400893581926',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE RBX 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3752798',
  CIP13: '3400937527989',
  ucdLib: "PANTOPRAZOLE RMO 20MG CPR",
  UCD7: '9358186',
  UCD13: '3400893581865',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE RMO 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3752806',
  CIP13: '3400937528061',
  ucdLib: "PANTOPRAZOLE RMO 20MG CPR",
  UCD7: '9358186',
  UCD13: '3400893581865',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE RMO 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3877614',
  CIP13: '3400938776140',
  ucdLib: "PANTOPRAZOLE RTP 20MG CPR",
  UCD7: '9325494',
  UCD13: '3400893254943',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE RTP 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3877637',
  CIP13: '3400938776379',
  ucdLib: "PANTOPRAZOLE RTP 20MG CPR",
  UCD7: '9325494',
  UCD13: '3400893254943',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE RTP 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3877815',
  CIP13: '3400938778151',
  ucdLib: "PANTOPRAZOLE RTP 40MG CPR",
  UCD7: '9325502',
  UCD13: '3400893255025',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE RTP 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3877838',
  CIP13: '3400938778380',
  ucdLib: "PANTOPRAZOLE RTP 40MG CPR",
  UCD7: '9325502',
  UCD13: '3400893255025',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE RTP 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3877850',
  CIP13: '3400938778502',
  ucdLib: "PANTOPRAZOLE RTP 40MG CPR",
  UCD7: '9325502',
  UCD13: '3400893255025',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE RTP 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3878401',
  CIP13: '3400938784015',
  ucdLib: "PANTOPRAZOLE SDZ 20MG CPR",
  UCD7: '9327955',
  UCD13: '3400893279557',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE SDZ 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3878430',
  CIP13: '3400938784305',
  ucdLib: "PANTOPRAZOLE SDZ 20MG CPR",
  UCD7: '9327955',
  UCD13: '3400893279557',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE SDZ 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3878507',
  CIP13: '3400938785074',
  ucdLib: "PANTOPRAZOLE SDZ 40MG CPR",
  UCD7: '9327961',
  UCD13: '3400893279618',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE SDZ 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3878536',
  CIP13: '3400938785364',
  ucdLib: "PANTOPRAZOLE SDZ 40MG CPR",
  UCD7: '9327961',
  UCD13: '3400893279618',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE SDZ 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3878565',
  CIP13: '3400938785654',
  ucdLib: "PANTOPRAZOLE SDZ 40MG CPR",
  UCD7: '9327961',
  UCD13: '3400893279618',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE SDZ 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3878080',
  CIP13: '3400938780802',
  ucdLib: "PANTOPRAZOLE ZEN 20MG CPR",
  UCD7: '9324112',
  UCD13: '3400893241127',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ZEN 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3878105',
  CIP13: '3400938781052',
  ucdLib: "PANTOPRAZOLE ZEN 20MG CPR",
  UCD7: '9324112',
  UCD13: '3400893241127',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ZEN 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3878200',
  CIP13: '3400938782004',
  ucdLib: "PANTOPRAZOLE ZEN 40MG CPR",
  UCD7: '9324129',
  UCD13: '3400893241295',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE ZEN 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3878217',
  CIP13: '3400938782172',
  ucdLib: "PANTOPRAZOLE ZEN 40MG CPR",
  UCD7: '9324129',
  UCD13: '3400893241295',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ZEN 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3878246',
  CIP13: '3400938782462',
  ucdLib: "PANTOPRAZOLE ZEN 40MG CPR",
  UCD7: '9324129',
  UCD13: '3400893241295',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ZEN 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '5637506',
  CIP13: '3400956375066',
  ucdLib: "INIPOMP 20MG CPR",
  UCD7: '9211678',
  UCD13: '3400892116785',
  ucdQtyMultiplicator: 50,
  cipLib: "INIPOMP 20MG CPR BT 50",
  atcCode: "A02BC02"
}, {
  CIP7: '3938824',
  CIP13: '3400939388243',
  ucdLib: "PANTOPRAZOLE ALM 20MG CPR",
  UCD7: '9332270',
  UCD13: '3400893322703',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ALM 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3938847',
  CIP13: '3400939388472',
  ucdLib: "PANTOPRAZOLE ALM 20MG CPR",
  UCD7: '9332270',
  UCD13: '3400893322703',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ALM 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3938965',
  CIP13: '3400939389653',
  ucdLib: "PANTOPRAZOLE ALM 40MG CPR",
  UCD7: '9332287',
  UCD13: '3400893322871',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ALM 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3938988',
  CIP13: '3400939389882',
  ucdLib: "PANTOPRAZOLE ALM 40MG CPR",
  UCD7: '9332287',
  UCD13: '3400893322871',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ALM 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3907232',
  CIP13: '3400939072326',
  ucdLib: "PANTOPRAZOLE BCR 20MG CPR",
  UCD7: '9330561',
  UCD13: '3400893305614',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE BCR 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3907255',
  CIP13: '3400939072555',
  ucdLib: "PANTOPRAZOLE BCR 20MG CPR",
  UCD7: '9330561',
  UCD13: '3400893305614',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE BCR 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3907278',
  CIP13: '3400939072784',
  ucdLib: "PANTOPRAZOLE BCR 40MG CPR",
  UCD7: '9330578',
  UCD13: '3400893305782',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE BCR 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3907284',
  CIP13: '3400939072845',
  ucdLib: "PANTOPRAZOLE BCR 40MG CPR",
  UCD7: '9330578',
  UCD13: '3400893305782',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE BCR 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3907309',
  CIP13: '3400939073095',
  ucdLib: "PANTOPRAZOLE BCR 40MG CPR",
  UCD7: '9330578',
  UCD13: '3400893305782',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE BCR 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3932193',
  CIP13: '3400939321936',
  ucdLib: "PANTOPRAZOLE BGA 20MG CPR",
  UCD7: '9331690',
  UCD13: '3400893316900',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE BGA 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3932201',
  CIP13: '3400939322018',
  ucdLib: "PANTOPRAZOLE BGA 20MG CPR",
  UCD7: '9331690',
  UCD13: '3400893316900',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE BGA 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3932218',
  CIP13: '3400939322186',
  ucdLib: "PANTOPRAZOLE BGA 20MG CPR",
  UCD7: '9331690',
  UCD13: '3400893316900',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE BGA 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3907516',
  CIP13: '3400939075167',
  ucdLib: "PANTOPRAZOLE CRT 20MG CPR",
  UCD7: '9328802',
  UCD13: '3400893288023',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE CRT 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3908071',
  CIP13: '3400939080710',
  ucdLib: "PANTOPRAZOLE CRT 40MG CPR",
  UCD7: '9328819',
  UCD13: '3400893288191',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE CRT 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3903010',
  CIP13: '3400939030104',
  ucdLib: "PANTOPRAZOLE EG 20MG CPR",
  UCD7: '9326772',
  UCD13: '3400893267721',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE EG 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3903027',
  CIP13: '3400939030272',
  ucdLib: "PANTOPRAZOLE EG 20MG CPR",
  UCD7: '9326772',
  UCD13: '3400893267721',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE EG 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3903033',
  CIP13: '3400939030333',
  ucdLib: "PANTOPRAZOLE EG 40MG CPR",
  UCD7: '9326789',
  UCD13: '3400893267899',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE EG 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3903056',
  CIP13: '3400939030562',
  ucdLib: "PANTOPRAZOLE EG 40MG CPR",
  UCD7: '9326789',
  UCD13: '3400893267899',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE EG 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3903062',
  CIP13: '3400939030623',
  ucdLib: "PANTOPRAZOLE EG 40MG CPR",
  UCD7: '9326789',
  UCD13: '3400893267899',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE EG 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3932164',
  CIP13: '3400939321646',
  ucdLib: "PANTOPRAZOLE MYC 20MG CPR",
  UCD7: '9331738',
  UCD13: '3400893317389',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE MYC 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3932069',
  CIP13: '3400939320694',
  ucdLib: "PANTOPRAZOLE MYP 20MG CPR",
  UCD7: '9331715',
  UCD13: '3400893317150',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE MYP 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3932075',
  CIP13: '3400939320755',
  ucdLib: "PANTOPRAZOLE MYP 20MG CPR",
  UCD7: '9331715',
  UCD13: '3400893317150',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE MYP 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3932081',
  CIP13: '3400939320816',
  ucdLib: "PANTOPRAZOLE MYP 20MG CPR",
  UCD7: '9331715',
  UCD13: '3400893317150',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE MYP 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3930751',
  CIP13: '3400939307510',
  ucdLib: "PANTOPRAZOLE MYP 40MG CPR",
  UCD7: '9331721',
  UCD13: '3400893317211',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE MYP 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '3930768',
  CIP13: '3400939307688',
  ucdLib: "PANTOPRAZOLE MYP 40MG CPR",
  UCD7: '9331721',
  UCD13: '3400893317211',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE MYP 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3930774',
  CIP13: '3400939307749',
  ucdLib: "PANTOPRAZOLE MYP 40MG CPR",
  UCD7: '9331721',
  UCD13: '3400893317211',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE MYP 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '3952445',
  CIP13: '3400939524450',
  ucdLib: "PANTOPRAZOLE RBX 20MG CPR",
  UCD7: '9342475',
  UCD13: '3400893424759',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE RBX 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '3952468',
  CIP13: '3400939524689',
  ucdLib: "PANTOPRAZOLE RBX 20MG CPR",
  UCD7: '9342475',
  UCD13: '3400893424759',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE RBX 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4900049',
  CIP13: '3400949000494',
  ucdLib: "EUPANTOL 20MG CPR AIP MWI NO",
  UCD7: '9413287',
  UCD13: '3400894132875',
  ucdQtyMultiplicator: 28,
  cipLib: "EUPANTOL 20MG CPR AIP MWI NO BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4901415',
  CIP13: '3400949014156',
  ucdLib: "EUPANTOL 20MG CPR AIP PLA PL",
  UCD7: '9394928',
  UCD13: '3400893949283',
  ucdQtyMultiplicator: 28,
  cipLib: "EUPANTOL 20MG CPR AIP PLA PL BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4900050',
  CIP13: '3400949000500',
  ucdLib: "EUPANTOL 40MG CPR AIP MWI NO",
  UCD7: '9413293',
  UCD13: '3400894132936',
  ucdQtyMultiplicator: 28,
  cipLib: "EUPANTOL 40MG CPR AIP MWI NO BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4901421',
  CIP13: '3400949014217',
  ucdLib: "EUPANTOL 40MG CPR AIP PLA PL",
  UCD7: '9394934',
  UCD13: '3400893949344',
  ucdQtyMultiplicator: 28,
  cipLib: "EUPANTOL 40MG CPR AIP PLA PL BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4948718',
  CIP13: '3400949487189',
  ucdLib: "PANTOPRAZOLE ARW 40MG INJ FL",
  UCD7: '9364330',
  UCD13: '3400893643303',
  ucdQtyMultiplicator: 1,
  cipLib: "PANTOPRAZOLE ARW 40MG INJ FL BT 1",
  atcCode: "A02BC02"
}, {
  CIP7: '4948724',
  CIP13: '3400949487240',
  ucdLib: "PANTOPRAZOLE ARW 40MG INJ FL",
  UCD7: '9364330',
  UCD13: '3400893643303',
  ucdQtyMultiplicator: 5,
  cipLib: "PANTOPRAZOLE ARW 40MG INJ FL BT 5",
  atcCode: "A02BC02"
}, {
  CIP7: '4171968',
  CIP13: '3400941719684',
  ucdLib: "PANTOPRAZOLE RTC 20MG CPR",
  UCD7: '9376221',
  UCD13: '3400893762219',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE RTC 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '4171974',
  CIP13: '3400941719745',
  ucdLib: "PANTOPRAZOLE RTC 20MG CPR",
  UCD7: '9376221',
  UCD13: '3400893762219',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE RTC 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '4934455',
  CIP13: '3400949344550',
  ucdLib: "PANTOPRAZOLE SUN 40MG INJ FL",
  UCD7: '9361780',
  UCD13: '3400893617809',
  ucdQtyMultiplicator: 1,
  cipLib: "PANTOPRAZOLE SUN 40MG INJ FL BT 1",
  atcCode: "A02BC02"
}, {
  CIP7: '4933645',
  CIP13: '3400949336456',
  ucdLib: "PANTOPRAZOLE TVS 20MG CPR",
  UCD7: '9361969',
  UCD13: '3400893619698',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE TVS 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '4933651',
  CIP13: '3400949336517',
  ucdLib: "PANTOPRAZOLE TVS 20MG CPR",
  UCD7: '9361969',
  UCD13: '3400893619698',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE TVS 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4933711',
  CIP13: '3400949337118',
  ucdLib: "PANTOPRAZOLE TVS 40MG CPR",
  UCD7: '9361975',
  UCD13: '3400893619759',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE TVS 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '4933728',
  CIP13: '3400949337286',
  ucdLib: "PANTOPRAZOLE TVS 40MG CPR",
  UCD7: '9361975',
  UCD13: '3400893619759',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE TVS 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '4933734',
  CIP13: '3400949337347',
  ucdLib: "PANTOPRAZOLE TVS 40MG CPR",
  UCD7: '9361975',
  UCD13: '3400893619759',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE TVS 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '2239403',
  CIP13: '3400922394039',
  ucdLib: "INIPEPSIA 20MG CPR",
  UCD7: '9395520',
  UCD13: '3400893955208',
  ucdQtyMultiplicator: 7,
  cipLib: "INIPEPSIA 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '2239426',
  CIP13: '3400922394268',
  ucdLib: "INIPEPSIA 20MG CPR",
  UCD7: '9395520',
  UCD13: '3400893955208',
  ucdQtyMultiplicator: 14,
  cipLib: "INIPEPSIA 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '2179807',
  CIP13: '3400921798074',
  ucdLib: "IPRAALOX 20MG CPR",
  UCD7: '9382256',
  UCD13: '3400893822562',
  ucdQtyMultiplicator: 7,
  cipLib: "IPRAALOX 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '2179813',
  CIP13: '3400921798135',
  ucdLib: "IPRAALOX 20MG CPR",
  UCD7: '9382256',
  UCD13: '3400893822562',
  ucdQtyMultiplicator: 14,
  cipLib: "IPRAALOX 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '4160798',
  CIP13: '3400941607981',
  ucdLib: "PANTOPRAZOLE ARL 20MG CPR",
  UCD7: '9372128',
  UCD13: '3400893721285',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ARL 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '4160829',
  CIP13: '3400941608292',
  ucdLib: "PANTOPRAZOLE ARL 20MG CPR",
  UCD7: '9372128',
  UCD13: '3400893721285',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ARL 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4160841',
  CIP13: '3400941608414',
  ucdLib: "PANTOPRAZOLE ARL 20MG CPR",
  UCD7: '9372128',
  UCD13: '3400893721285',
  ucdQtyMultiplicator: 50,
  cipLib: "PANTOPRAZOLE ARL 20MG CPR BT 50",
  atcCode: "A02BC02"
}, {
  CIP7: '4160924',
  CIP13: '3400941609244',
  ucdLib: "PANTOPRAZOLE ARL 20MG CPR",
  UCD7: '9372128',
  UCD13: '3400893721285',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ARL 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4160982',
  CIP13: '3400941609824',
  ucdLib: "PANTOPRAZOLE ARL 40MG CPR",
  UCD7: '9372134',
  UCD13: '3400893721346',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE ARL 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '4161007',
  CIP13: '3400941610073',
  ucdLib: "PANTOPRAZOLE ARL 40MG CPR",
  UCD7: '9372134',
  UCD13: '3400893721346',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ARL 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '4161042',
  CIP13: '3400941610424',
  ucdLib: "PANTOPRAZOLE ARL 40MG CPR",
  UCD7: '9372134',
  UCD13: '3400893721346',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ARL 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4161065',
  CIP13: '3400941610653',
  ucdLib: "PANTOPRAZOLE ARL 40MG CPR",
  UCD7: '9372134',
  UCD13: '3400893721346',
  ucdQtyMultiplicator: 50,
  cipLib: "PANTOPRAZOLE ARL 40MG CPR BT 50",
  atcCode: "A02BC02"
}, {
  CIP7: '4161183',
  CIP13: '3400941611834',
  ucdLib: "PANTOPRAZOLE ARL 40MG CPR",
  UCD7: '9372134',
  UCD13: '3400893721346',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ARL 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '2240091',
  CIP13: '3400922400914',
  ucdLib: "PANTOPRAZOLE AWC 20MG CPR",
  UCD7: '9390221',
  UCD13: '3400893902219',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE AWC 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '2240116',
  CIP13: '3400922401164',
  ucdLib: "PANTOPRAZOLE AWC 20MG CPR",
  UCD7: '9390221',
  UCD13: '3400893902219',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE AWC 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '2179753',
  CIP13: '3400921797534',
  ucdLib: "PANTOPRAZOLE EGC 20MG CPR",
  UCD7: '9382664',
  UCD13: '3400893826645',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE EGC 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '2179776',
  CIP13: '3400921797763',
  ucdLib: "PANTOPRAZOLE EGC 20MG CPR",
  UCD7: '9382664',
  UCD13: '3400893826645',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE EGC 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '2240240',
  CIP13: '3400922402406',
  ucdLib: "PANTOPRAZOLE EVO 20MG CPR",
  UCD7: '9391166',
  UCD13: '3400893911662',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE EVO 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '2240352',
  CIP13: '3400922403526',
  ucdLib: "PANTOPRAZOLE EVO 40MG CPR",
  UCD7: '9388313',
  UCD13: '3400893883136',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE EVO 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '2240381',
  CIP13: '3400922403816',
  ucdLib: "PANTOPRAZOLE EVO 40MG CPR",
  UCD7: '9388313',
  UCD13: '3400893883136',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE EVO 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '4188331',
  CIP13: '3400941883316',
  ucdLib: "PANTOPRAZOLE SDC 20MG CPR",
  UCD7: '9375523',
  UCD13: '3400893755235',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE SDC 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '4188348',
  CIP13: '3400941883484',
  ucdLib: "PANTOPRAZOLE SDC 20MG CPR",
  UCD7: '9375523',
  UCD13: '3400893755235',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE SDC 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '2209543',
  CIP13: '3400922095431',
  ucdLib: "PANTOPRAZOLE TVS 40MG INJ FL",
  UCD7: '9404590',
  UCD13: '3400894045908',
  ucdQtyMultiplicator: 1,
  cipLib: "PANTOPRAZOLE TVS 40MG INJ FL BT 1",
  atcCode: "A02BC02"
}, {
  CIP7: '2676500',
  CIP13: '3400926765002',
  ucdLib: "PANTOPRAZOLE ZF 20MG CPR",
  UCD7: '9391574',
  UCD13: '3400893915745',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE ZF 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '2676517',
  CIP13: '3400926765170',
  ucdLib: "PANTOPRAZOLE ZF 20MG CPR",
  UCD7: '9391574',
  UCD13: '3400893915745',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ZF 20MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '2676575',
  CIP13: '3400926765750',
  ucdLib: "PANTOPRAZOLE ZYF 20MG CPR",
  UCD7: '9391172',
  UCD13: '3400893911723',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ZYF 20MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '2676635',
  CIP13: '3400926766351',
  ucdLib: "PANTOPRAZOLE ZYF 40MG CPR",
  UCD7: '9391189',
  UCD13: '3400893911891',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE ZYF 40MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '2676658',
  CIP13: '3400926766580',
  ucdLib: "PANTOPRAZOLE ZYF 40MG CPR",
  UCD7: '9391189',
  UCD13: '3400893911891',
  ucdQtyMultiplicator: 14,
  cipLib: "PANTOPRAZOLE ZYF 40MG CPR BT 14",
  atcCode: "A02BC02"
}, {
  CIP7: '2676687',
  CIP13: '3400926766870',
  ucdLib: "PANTOPRAZOLE ZYF 40MG CPR",
  UCD7: '9391189',
  UCD13: '3400893911891',
  ucdQtyMultiplicator: 28,
  cipLib: "PANTOPRAZOLE ZYF 40MG CPR BT 28",
  atcCode: "A02BC02"
}, {
  CIP7: '2795794',
  CIP13: '3400927957949',
  ucdLib: "PANTOPRAZOLE MYC 20MG CPR",
  UCD7: '9331738',
  UCD13: '3400893317389',
  ucdQtyMultiplicator: 7,
  cipLib: "PANTOPRAZOLE MYC 20MG CPR BT 7",
  atcCode: "A02BC02"
}, {
  CIP7: '2760726',
  CIP13: '3400927607264',
  ucdLib: "OMEPRAZOLE ZYF 10MG GELU",
  UCD7: '9401864',
  UCD13: '3400894018643',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ZYF 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2760732',
  CIP13: '3400927607325',
  ucdLib: "OMEPRAZOLE ZYF 10MG GELU",
  UCD7: '9401864',
  UCD13: '3400894018643',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ZYF 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '2760749',
  CIP13: '3400927607493',
  ucdLib: "OMEPRAZOLE ZYF 20MG GELU",
  UCD7: '9401870',
  UCD13: '3400894018704',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE ZYF 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '2760755',
  CIP13: '3400927607554',
  ucdLib: "OMEPRAZOLE ZYF 20MG GELU",
  UCD7: '9401870',
  UCD13: '3400894018704',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ZYF 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2760761',
  CIP13: '3400927607615',
  ucdLib: "OMEPRAZOLE ZYF 20MG GELU",
  UCD7: '9401870',
  UCD13: '3400894018704',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ZYF 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3688379',
  CIP13: '3400936883796',
  ucdLib: "OMEPRAZOLE ALT 10MG GELU",
  UCD7: '9278754',
  UCD13: '3400892787541',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ALT 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3688385',
  CIP13: '3400936883857',
  ucdLib: "OMEPRAZOLE ALT 10MG GELU",
  UCD7: '9278754',
  UCD13: '3400892787541',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ALT 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3680544',
  CIP13: '3400936805446',
  ucdLib: "OMEPRAZOLE ALT 20MG GELU",
  UCD7: '9278760',
  UCD13: '3400892787602',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ALT 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3688439',
  CIP13: '3400936884397',
  ucdLib: "OMEPRAZOLE CRT 10MG GELU",
  UCD7: '9276643',
  UCD13: '3400892766430',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE CRT 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3680478',
  CIP13: '3400936804784',
  ucdLib: "OMEPRAZOLE CRT 20MG GELU",
  UCD7: '9276666',
  UCD13: '3400892766669',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE CRT 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3680484',
  CIP13: '3400936804845',
  ucdLib: "OMEPRAZOLE CRT 20MG GELU",
  UCD7: '9276666',
  UCD13: '3400892766669',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE CRT 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3688675',
  CIP13: '3400936886759',
  ucdLib: "OMEPRAZOLE ISD 10MG GELU",
  UCD7: '9276703',
  UCD13: '3400892767031',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ISD 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3688681',
  CIP13: '3400936886810',
  ucdLib: "OMEPRAZOLE ISD 10MG GELU",
  UCD7: '9276703',
  UCD13: '3400892767031',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ISD 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3688741',
  CIP13: '3400936887411',
  ucdLib: "OMEPRAZOLE ISD 20MG GELU",
  UCD7: '9276726',
  UCD13: '3400892767260',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ISD 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3686268',
  CIP13: '3400936862685',
  ucdLib: "OMEPRAZOLE MYP 10MG GELU",
  UCD7: '9276637',
  UCD13: '3400892766379',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE MYP 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3686274',
  CIP13: '3400936862746',
  ucdLib: "OMEPRAZOLE MYP 10MG GELU",
  UCD7: '9276637',
  UCD13: '3400892766379',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE MYP 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3405246',
  CIP13: '3400934052460',
  ucdLib: "MOPRAL 10MG GELU",
  UCD7: '9188241',
  UCD13: '3400891882414',
  ucdQtyMultiplicator: 30,
  cipLib: "MOPRAL 10MG GELU BT 30",
  atcCode: "A02BC01"
}, {
  CIP7: '3408109',
  CIP13: '3400934081095',
  ucdLib: "MOPRAL 20MG GELU",
  UCD7: '9139337',
  UCD13: '3400891393378',
  ucdQtyMultiplicator: 7,
  cipLib: "MOPRAL 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3408121',
  CIP13: '3400934081217',
  ucdLib: "MOPRAL 20MG GELU",
  UCD7: '9139337',
  UCD13: '3400891393378',
  ucdQtyMultiplicator: 14,
  cipLib: "MOPRAL 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3409801',
  CIP13: '3400934098017',
  ucdLib: "ZOLTUM 10MG GELU",
  UCD7: '9195005',
  UCD13: '3400891950052',
  ucdQtyMultiplicator: 28,
  cipLib: "ZOLTUM 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3413004',
  CIP13: '3400934130045',
  ucdLib: "MOPRAL 10MG GELU",
  UCD7: '9188241',
  UCD13: '3400891882414',
  ucdQtyMultiplicator: 14,
  cipLib: "MOPRAL 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3628443',
  CIP13: '3400936284432',
  ucdLib: "OMEPRAZOLE BGA 20MG GELU",
  UCD7: '9257999',
  UCD13: '3400892579993',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE BGA 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3628466',
  CIP13: '3400936284661',
  ucdLib: "OMEPRAZOLE BGA 20MG GELU",
  UCD7: '9257999',
  UCD13: '3400892579993',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE BGA 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3628621',
  CIP13: '3400936286214',
  ucdLib: "OMEPRAZOLE BGA 20MG GELU",
  UCD7: '9257999',
  UCD13: '3400892579993',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE BGA 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3629075',
  CIP13: '3400936290754',
  ucdLib: "OMEPRAZOLE BGC 20MG GELU",
  UCD7: '9259952',
  UCD13: '3400892599526',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE BGC 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3629081',
  CIP13: '3400936290815',
  ucdLib: "OMEPRAZOLE BGC 20MG GELU",
  UCD7: '9259952',
  UCD13: '3400892599526',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE BGC 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3628242',
  CIP13: '3400936282421',
  ucdLib: "OMEPRAZOLE MYP 20MG GELU",
  UCD7: '9368888',
  UCD13: '3400893688885',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE MYP 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3628288',
  CIP13: '3400936282889',
  ucdLib: "OMEPRAZOLE MYP 20MG GELU",
  UCD7: '9368888',
  UCD13: '3400893688885',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE MYP 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3628294',
  CIP13: '3400936282940',
  ucdLib: "OMEPRAZOLE MYP 20MG GELU",
  UCD7: '9368888',
  UCD13: '3400893688885',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE MYP 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3628779',
  CIP13: '3400936287792',
  ucdLib: "OMEPRAZOLE RATIO 20MG GELU",
  UCD7: '9258013',
  UCD13: '3400892580135',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE RATIO 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3628785',
  CIP13: '3400936287853',
  ucdLib: "OMEPRAZOLE RATIO 20MG GELU",
  UCD7: '9258013',
  UCD13: '3400892580135',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE RATIO 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3628791',
  CIP13: '3400936287914',
  ucdLib: "OMEPRAZOLE RATIO 20MG GELU",
  UCD7: '9258013',
  UCD13: '3400892580135',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE RATIO 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3667437',
  CIP13: '3400936674370',
  ucdLib: "OMEPRAZOLE BCR 10MG GELU",
  UCD7: '9273432',
  UCD13: '3400892734323',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE BCR 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3667443',
  CIP13: '3400936674431',
  ucdLib: "OMEPRAZOLE BCR 10MG GELU",
  UCD7: '9273432',
  UCD13: '3400892734323',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE BCR 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3666811',
  CIP13: '3400936668119',
  ucdLib: "OMEPRAZOLE BGA 10MG GELU",
  UCD7: '9272390',
  UCD13: '3400892723907',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE BGA 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3666828',
  CIP13: '3400936668287',
  ucdLib: "OMEPRAZOLE BGA 10MG GELU",
  UCD7: '9272390',
  UCD13: '3400892723907',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE BGA 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3764755',
  CIP13: '3400937647557',
  ucdLib: "OMEPRAZOLE MYL 40MG PERF FL",
  UCD7: '9291401',
  UCD13: '3400892914015',
  ucdQtyMultiplicator: 5,
  cipLib: "OMEPRAZOLE MYL 40MG PERF FL BT 5",
  atcCode: "A02BC01"
}, {
  CIP7: '3667360',
  CIP13: '3400936673601',
  ucdLib: "OMEPRAZOLE RTP 10MG GELU",
  UCD7: '9272415',
  UCD13: '3400892724157',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE RTP 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3667377',
  CIP13: '3400936673779',
  ucdLib: "OMEPRAZOLE RTP 10MG GELU",
  UCD7: '9272415',
  UCD13: '3400892724157',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE RTP 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3785007',
  CIP13: '3400937850070',
  ucdLib: "OMEPRAZOLE ARW 40MG PERF FL",
  UCD7: '9303676',
  UCD13: '3400893036761',
  ucdQtyMultiplicator: 1,
  cipLib: "OMEPRAZOLE ARW 40MG PERF FL BT 1",
  atcCode: "A02BC01"
}, {
  CIP7: '3648351',
  CIP13: '3400936483514',
  ucdLib: "OMEPRAZOLE BCR 20MG GELU",
  UCD7: '9264255',
  UCD13: '3400892642550',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE BCR 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3648368',
  CIP13: '3400936483682',
  ucdLib: "OMEPRAZOLE BCR 20MG GELU",
  UCD7: '9264255',
  UCD13: '3400892642550',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE BCR 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3648374',
  CIP13: '3400936483743',
  ucdLib: "OMEPRAZOLE BCR 20MG GELU",
  UCD7: '9264255',
  UCD13: '3400892642550',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE BCR 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3753243',
  CIP13: '3400937532433',
  ucdLib: "MOPRALPRO 20MG CPR",
  UCD7: '9352901',
  UCD13: '3400893529010',
  ucdQtyMultiplicator: 7,
  cipLib: "MOPRALPRO 20MG CPR BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3753266',
  CIP13: '3400937532662',
  ucdLib: "MOPRALPRO 20MG CPR",
  UCD7: '9352901',
  UCD13: '3400893529010',
  ucdQtyMultiplicator: 14,
  cipLib: "MOPRALPRO 20MG CPR BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976241',
  CIP13: '3400949762415',
  ucdLib: "OMEPRAZOLE ALM 10MG GELU",
  UCD7: '9367251',
  UCD13: '3400893672518',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ALM 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976264',
  CIP13: '3400949762644',
  ucdLib: "OMEPRAZOLE ALM 10MG GELU",
  UCD7: '9367251',
  UCD13: '3400893672518',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ALM 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4976353',
  CIP13: '3400949763535',
  ucdLib: "OMEPRAZOLE ALM 20MG GELU",
  UCD7: '9367268',
  UCD13: '3400893672686',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE ALM 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '4976376',
  CIP13: '3400949763764',
  ucdLib: "OMEPRAZOLE ALM 20MG GELU",
  UCD7: '9367268',
  UCD13: '3400893672686',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ALM 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976399',
  CIP13: '3400949763993',
  ucdLib: "OMEPRAZOLE ALM 20MG GELU",
  UCD7: '9367268',
  UCD13: '3400893672686',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ALM 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4975715',
  CIP13: '3400949757152',
  ucdLib: "OMEPRAZOLE ARL 10MG GELU",
  UCD7: '9370394',
  UCD13: '3400893703946',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ARL 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4975738',
  CIP13: '3400949757381',
  ucdLib: "OMEPRAZOLE ARL 10MG GELU",
  UCD7: '9370394',
  UCD13: '3400893703946',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ARL 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4975833',
  CIP13: '3400949758333',
  ucdLib: "OMEPRAZOLE ARL 20MG GELU",
  UCD7: '9370402',
  UCD13: '3400893704028',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE ARL 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '4975856',
  CIP13: '3400949758562',
  ucdLib: "OMEPRAZOLE ARL 20MG GELU",
  UCD7: '9370402',
  UCD13: '3400893704028',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ARL 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4975879',
  CIP13: '3400949758791',
  ucdLib: "OMEPRAZOLE ARL 20MG GELU",
  UCD7: '9370402',
  UCD13: '3400893704028',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ARL 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4976502',
  CIP13: '3400949765027',
  ucdLib: "OMEPRAZOLE EG 10MG GELU",
  UCD7: '9370431',
  UCD13: '3400893704318',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE EG 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976525',
  CIP13: '3400949765256',
  ucdLib: "OMEPRAZOLE EG 10MG GELU",
  UCD7: '9370431',
  UCD13: '3400893704318',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE EG 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4976620',
  CIP13: '3400949766208',
  ucdLib: "OMEPRAZOLE EG 20MG GELU",
  UCD7: '9370448',
  UCD13: '3400893704486',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE EG 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '4976637',
  CIP13: '3400949766376',
  ucdLib: "OMEPRAZOLE EG 20MG GELU",
  UCD7: '9370448',
  UCD13: '3400893704486',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE EG 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976666',
  CIP13: '3400949766666',
  ucdLib: "OMEPRAZOLE EG 20MG GELU",
  UCD7: '9370448',
  UCD13: '3400893704486',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE EG 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3840752',
  CIP13: '3400938407525',
  ucdLib: "OMEPRAZOLE EVO 10MG GELU",
  UCD7: '9354461',
  UCD13: '3400893544617',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE EVO 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3840841',
  CIP13: '3400938408416',
  ucdLib: "OMEPRAZOLE EVO 10MG GELU",
  UCD7: '9354461',
  UCD13: '3400893544617',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE EVO 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4976778',
  CIP13: '3400949767786',
  ucdLib: "OMEPRAZOLE KRK 10MG GELU",
  UCD7: '9370419',
  UCD13: '3400893704196',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE KRK 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976790',
  CIP13: '3400949767908',
  ucdLib: "OMEPRAZOLE KRK 10MG GELU",
  UCD7: '9370419',
  UCD13: '3400893704196',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE KRK 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4976896',
  CIP13: '3400949768967',
  ucdLib: "OMEPRAZOLE KRK 20MG GELU",
  UCD7: '9370425',
  UCD13: '3400893704257',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE KRK 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '4976904',
  CIP13: '3400949769049',
  ucdLib: "OMEPRAZOLE KRK 20MG GELU",
  UCD7: '9370425',
  UCD13: '3400893704257',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE KRK 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976927',
  CIP13: '3400949769278',
  ucdLib: "OMEPRAZOLE KRK 20MG GELU",
  UCD7: '9370425',
  UCD13: '3400893704257',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE KRK 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3965672',
  CIP13: '3400939656724',
  ucdLib: "OMEPRAZOLE NEP 20MG GELU",
  UCD7: '9344994',
  UCD13: '3400893449943',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE NEP 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3965689',
  CIP13: '3400939656892',
  ucdLib: "OMEPRAZOLE NEP 20MG GELU",
  UCD7: '9344994',
  UCD13: '3400893449943',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE NEP 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3965695',
  CIP13: '3400939656953',
  ucdLib: "OMEPRAZOLE NEP 20MG GELU",
  UCD7: '9344994',
  UCD13: '3400893449943',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE NEP 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3954094',
  CIP13: '3400939540948',
  ucdLib: "OMEPRAZOLE SDZ 10MG GELU",
  UCD7: '9310251',
  UCD13: '3400893102510',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE SDZ 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3954119',
  CIP13: '3400939541198',
  ucdLib: "OMEPRAZOLE SDZ 10MG GELU",
  UCD7: '9310251',
  UCD13: '3400893102510',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE SDZ 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3954148',
  CIP13: '3400939541488',
  ucdLib: "OMEPRAZOLE SDZ 20MG GELU",
  UCD7: '9258415',
  UCD13: '3400892584157',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE SDZ 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3954154',
  CIP13: '3400939541549',
  ucdLib: "OMEPRAZOLE SDZ 20MG GELU",
  UCD7: '9258415',
  UCD13: '3400892584157',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE SDZ 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3954177',
  CIP13: '3400939541778',
  ucdLib: "OMEPRAZOLE SDZ 20MG GELU",
  UCD7: '9258415',
  UCD13: '3400892584157',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE SDZ 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4975980',
  CIP13: '3400949759804',
  ucdLib: "OMEPRAZOLE TVS 10MG GELU",
  UCD7: '9370454',
  UCD13: '3400893704547',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE TVS 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976005',
  CIP13: '3400949760053',
  ucdLib: "OMEPRAZOLE TVS 10MG GELU",
  UCD7: '9370454',
  UCD13: '3400893704547',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE TVS 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4976100',
  CIP13: '3400949761005',
  ucdLib: "OMEPRAZOLE TVS 20MG GELU",
  UCD7: '9370460',
  UCD13: '3400893704608',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE TVS 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '4976117',
  CIP13: '3400949761173',
  ucdLib: "OMEPRAZOLE TVS 20MG GELU",
  UCD7: '9370460',
  UCD13: '3400893704608',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE TVS 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '4976146',
  CIP13: '3400949761463',
  ucdLib: "OMEPRAZOLE TVS 20MG GELU",
  UCD7: '9370460',
  UCD13: '3400893704608',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE TVS 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '3981576',
  CIP13: '3400939815763',
  ucdLib: "OMEPRAZOLE EVO 20MG GELU",
  UCD7: '9347136',
  UCD13: '3400893471364',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE EVO 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '3981582',
  CIP13: '3400939815824',
  ucdLib: "OMEPRAZOLE EVO 20MG GELU",
  UCD7: '9347136',
  UCD13: '3400893471364',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE EVO 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '3981607',
  CIP13: '3400939816074',
  ucdLib: "OMEPRAZOLE EVO 20MG GELU",
  UCD7: '9347136',
  UCD13: '3400893471364',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE EVO 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '2695130',
  CIP13: '3400926951306',
  ucdLib: "OMEPRAZOLE RBX 10MG GELU",
  UCD7: '9396904',
  UCD13: '3400893969045',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE RBX 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2695153',
  CIP13: '3400926951535',
  ucdLib: "OMEPRAZOLE RBX 10MG GELU",
  UCD7: '9396904',
  UCD13: '3400893969045',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE RBX 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '2695377',
  CIP13: '3400926953775',
  ucdLib: "OMEPRAZOLE RBX 20MG GELU",
  UCD7: '9396910',
  UCD13: '3400893969106',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE RBX 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '2695408',
  CIP13: '3400926954086',
  ucdLib: "OMEPRAZOLE RBX 20MG GELU",
  UCD7: '9396910',
  UCD13: '3400893969106',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE RBX 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2695437',
  CIP13: '3400926954376',
  ucdLib: "OMEPRAZOLE RBX 20MG GELU",
  UCD7: '9396910',
  UCD13: '3400893969106',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE RBX 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '2756765',
  CIP13: '3400927567650',
  ucdLib: "OMEPRAZOLE ZTL 10MG GELU",
  UCD7: '9402734',
  UCD13: '3400894027348',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ZTL 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2756771',
  CIP13: '3400927567711',
  ucdLib: "OMEPRAZOLE ZTL 10MG GELU",
  UCD7: '9402734',
  UCD13: '3400894027348',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ZTL 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '2756802',
  CIP13: '3400927568022',
  ucdLib: "OMEPRAZOLE ZTL 20MG GELU",
  UCD7: '9402740',
  UCD13: '3400894027409',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE ZTL 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '2756819',
  CIP13: '3400927568190',
  ucdLib: "OMEPRAZOLE ZTL 20MG GELU",
  UCD7: '9402740',
  UCD13: '3400894027409',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ZTL 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2756825',
  CIP13: '3400927568251',
  ucdLib: "OMEPRAZOLE ZTL 20MG GELU",
  UCD7: '9402740',
  UCD13: '3400894027409',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ZTL 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '4185901',
  CIP13: '3400941859014',
  ucdLib: "MOPRAL 20MG GELU",
  UCD7: '9139337',
  UCD13: '3400891393378',
  ucdQtyMultiplicator: 30,
  cipLib: "MOPRAL 20MG GELU BT 30",
  atcCode: "A02BC01"
}, {
  CIP7: '2731788',
  CIP13: '3400927317880',
  ucdLib: "OMEPRAZOLE MYC 20MG GELU",
  UCD7: '9265438',
  UCD13: '3400892654386',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE MYC 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '2731794',
  CIP13: '3400927317941',
  ucdLib: "OMEPRAZOLE MYC 20MG GELU",
  UCD7: '9265438',
  UCD13: '3400892654386',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE MYC 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2242150',
  CIP13: '3400922421506',
  ucdLib: "OMEPRAZOLE SDC 20MG GELU",
  UCD7: '9386567',
  UCD13: '3400893865675',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE SDC 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '2242167',
  CIP13: '3400922421674',
  ucdLib: "OMEPRAZOLE SDC 20MG GELU",
  UCD7: '9386567',
  UCD13: '3400893865675',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE SDC 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2675274',
  CIP13: '3400926752743',
  ucdLib: "OMEPRAZOLE TCO 20MG GELU",
  UCD7: '9395649',
  UCD13: '3400893956496',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE TCO 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '2675280',
  CIP13: '3400926752804',
  ucdLib: "OMEPRAZOLE TCO 20MG GELU",
  UCD7: '9395649',
  UCD13: '3400893956496',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE TCO 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2781786',
  CIP13: '3400927817861',
  ucdLib: "OMEPRAZOLE ZTL 10MG GELU",
  UCD7: '9402734',
  UCD13: '3400894027348',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ZTL 10MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2781792',
  CIP13: '3400927817922',
  ucdLib: "OMEPRAZOLE ZTL 10MG GELU",
  UCD7: '9402734',
  UCD13: '3400894027348',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ZTL 10MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '2781800',
  CIP13: '3400927818004',
  ucdLib: "OMEPRAZOLE ZTL 20MG GELU",
  UCD7: '9402740',
  UCD13: '3400894027409',
  ucdQtyMultiplicator: 14,
  cipLib: "OMEPRAZOLE ZTL 20MG GELU BT 14",
  atcCode: "A02BC01"
}, {
  CIP7: '2781817',
  CIP13: '3400927818172',
  ucdLib: "OMEPRAZOLE ZTL 20MG GELU",
  UCD7: '9402740',
  UCD13: '3400894027409',
  ucdQtyMultiplicator: 28,
  cipLib: "OMEPRAZOLE ZTL 20MG GELU BT 28",
  atcCode: "A02BC01"
}, {
  CIP7: '2784684',
  CIP13: '3400927846847',
  ucdLib: "OMEPRAZOLE ZTL 20MG GELU",
  UCD7: '9402740',
  UCD13: '3400894027409',
  ucdQtyMultiplicator: 7,
  cipLib: "OMEPRAZOLE ZTL 20MG GELU BT 7",
  atcCode: "A02BC01"
}, {
  CIP7: '4185953',
  CIP13: '3400941859533',
  ucdLib: "ZOLTUM 20MG GELU",
  UCD7: '9150178',
  UCD13: '3400891501780',
  ucdQtyMultiplicator: 30,
  cipLib: "ZOLTUM 20MG GELU BT 30",
  atcCode: "A02BC01"
}, {
  CIP7: '3287864',
  CIP13: '3400932878642',
  ucdLib: "CYTOTEC 200MCG CPR",
  UCD7: '9118909',
  UCD13: '3400891189094',
  ucdQtyMultiplicator: 60,
  cipLib: "CYTOTEC 200MCG CPR BT 60",
  atcCode: "A02BB01"
}, {
  CIP7: '3533599',
  CIP13: '3400935335999',
  ucdLib: "PEPCIDDUO CPR CROQ",
  UCD7: '9220973',
  UCD13: '3400892209739',
  ucdQtyMultiplicator: 12,
  cipLib: "PEPCIDDUO CPR CROQ BT 12",
  atcCode: "A02BA53"
}, {
  CIP7: '3309264',
  CIP13: '3400933092641',
  ucdLib: "NIZAXID 150MG GELU",
  UCD7: '9125737',
  UCD13: '3400891257373',
  ucdQtyMultiplicator: 30,
  cipLib: "NIZAXID 150MG GELU BT 30",
  atcCode: "A02BA04"
}, {
  CIP7: '3551025',
  CIP13: '3400935510259',
  ucdLib: "FAMOTIDINE EG 20MG CPR",
  UCD7: '9251063',
  UCD13: '3400892510637',
  ucdQtyMultiplicator: 30,
  cipLib: "FAMOTIDINE EG 20MG CPR BT 30",
  atcCode: "A02BA03"
}, {
  CIP7: '3597866',
  CIP13: '3400935978660',
  ucdLib: "FAMOTIDINE EG 40MG CPR",
  UCD7: '9251086',
  UCD13: '3400892510866',
  ucdQtyMultiplicator: 15,
  cipLib: "FAMOTIDINE EG 40MG CPR BT 15",
  atcCode: "A02BA03"
}, {
  CIP7: '3627030',
  CIP13: '3400936270305',
  ucdLib: "FAMOTIDINE MYL 20MG CPR",
  UCD7: '9260151',
  UCD13: '3400892601519',
  ucdQtyMultiplicator: 30,
  cipLib: "FAMOTIDINE MYL 20MG CPR BT 30",
  atcCode: "A02BA03"
}, {
  CIP7: '3627053',
  CIP13: '3400936270534',
  ucdLib: "FAMOTIDINE MYL 40MG CPR",
  UCD7: '9260168',
  UCD13: '3400892601687',
  ucdQtyMultiplicator: 15,
  cipLib: "FAMOTIDINE MYL 40MG CPR BT 15",
  atcCode: "A02BA03"
}, {
  CIP7: '3611595',
  CIP13: '3400936115958',
  ucdLib: "RANITIDINE TVC 150MG CPR",
  UCD7: '9245335',
  UCD13: '3400892453354',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE TVC 150MG CPR BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3611603',
  CIP13: '3400936116030',
  ucdLib: "RANITIDINE TVC 300MG CPR",
  UCD7: '9245341',
  UCD13: '3400892453415',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE TVC 300MG CPR BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3320857',
  CIP13: '3400933208578',
  ucdLib: "AZANTAC 150MG CPR EFFV",
  UCD7: '9143824',
  UCD13: '3400891438246',
  ucdQtyMultiplicator: 30,
  cipLib: "AZANTAC 150MG CPR EFFV BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3287752',
  CIP13: '3400932877522',
  ucdLib: "AZANTAC 300MG CPR",
  UCD7: '9123891',
  UCD13: '3400891238914',
  ucdQtyMultiplicator: 14,
  cipLib: "AZANTAC 300MG CPR BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3320863',
  CIP13: '3400933208639',
  ucdLib: "RANITIDINE BGA 150MG C.EFFV",
  UCD7: '9256557',
  UCD13: '3400892565576',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE BGA 150MG C.EFFV BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3251435',
  CIP13: '3400932514359',
  ucdLib: "AZANTAC 150MG CPR",
  UCD7: '9008776',
  UCD13: '3400890087766',
  ucdQtyMultiplicator: 30,
  cipLib: "AZANTAC 150MG CPR BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3268275',
  CIP13: '3400932682751',
  ucdLib: "AZANTAC 50MG INJ AMP2ML",
  UCD7: '9102305',
  UCD13: '3400891023053',
  ucdQtyMultiplicator: 5,
  cipLib: "AZANTAC 50MG INJ AMP2ML BT 5",
  atcCode: "A02BA02"
}, {
  CIP7: '3609032',
  CIP13: '3400936090323',
  ucdLib: "RANITIDINE MYL 150MG C.EFFV",
  UCD7: '9244198',
  UCD13: '3400892441986',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE MYL 150MG C.EFFV BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3603029',
  CIP13: '3400936030299',
  ucdLib: "RANITIDINE MYL 300MG C.EFFV",
  UCD7: '9244206',
  UCD13: '3400892442068',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE MYL 300MG C.EFFV BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3609078',
  CIP13: '3400936090781',
  ucdLib: "RANITIDINE RTP 150MG C.EFFV",
  UCD7: '9255842',
  UCD13: '3400892558424',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE RTP 150MG C.EFFV BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3439297',
  CIP13: '3400934392979',
  ucdLib: "RANITIDINE EG 150MG CPR",
  UCD7: '9215133',
  UCD13: '3400892151335',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE EG 150MG CPR BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3520007',
  CIP13: '3400935200075',
  ucdLib: "RANITIDINE EG 300MG CPR",
  UCD7: '9215156',
  UCD13: '3400892151564',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE EG 300MG CPR BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3623492',
  CIP13: '3400936234925',
  ucdLib: "RANITIDINE ARW 150MG C.EFFV",
  UCD7: '9255635',
  UCD13: '3400892556352',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE ARW 150MG C.EFFV BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3621412',
  CIP13: '3400936214125',
  ucdLib: "RANITIDINE ZEN 150MG C.EFFV",
  UCD7: '9355472',
  UCD13: '3400893554722',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE ZEN 150MG C.EFFV BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3621435',
  CIP13: '3400936214354',
  ucdLib: "RANITIDINE ZEN 300MG C.EFFV",
  UCD7: '9355489',
  UCD13: '3400893554890',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE ZEN 300MG C.EFFV BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3466006',
  CIP13: '3400934660061',
  ucdLib: "RANITIDINE MYL 150MG CPR",
  UCD7: '9200315',
  UCD13: '3400892003153',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE MYL 150MG CPR BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3540932',
  CIP13: '3400935409324',
  ucdLib: "RANITIDINE MYL 75MG C.EFFV",
  UCD7: '9244212',
  UCD13: '3400892442129',
  ucdQtyMultiplicator: 28,
  cipLib: "RANITIDINE MYL 75MG C.EFFV BT 28",
  atcCode: "A02BA02"
}, {
  CIP7: '3693268',
  CIP13: '3400936932685',
  ucdLib: "RANITIDINE ARW 300MG C.EFFV",
  UCD7: '9277542',
  UCD13: '3400892775425',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE ARW 300MG C.EFFV BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3641314',
  CIP13: '3400936413146',
  ucdLib: "RANITIDINE ARW 75MG C.EFFV",
  UCD7: '9264290',
  UCD13: '3400892642901',
  ucdQtyMultiplicator: 28,
  cipLib: "RANITIDINE ARW 75MG C.EFFV BT 28",
  atcCode: "A02BA02"
}, {
  CIP7: '3496993',
  CIP13: '3400934969935',
  ucdLib: "RANITIDINE BGA 150MG CPR",
  UCD7: '9206878',
  UCD13: '3400892068787',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE BGA 150MG CPR BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3498584',
  CIP13: '3400934985843',
  ucdLib: "RANITIDINE BGA 300MG CPR",
  UCD7: '9206884',
  UCD13: '3400892068848',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE BGA 300MG CPR BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3474796',
  CIP13: '3400934747960',
  ucdLib: "RANITIDINE MYL 300MG CPR",
  UCD7: '9204000',
  UCD13: '3400892040004',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE MYL 300MG CPR BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3913540',
  CIP13: '3400939135403',
  ucdLib: "RANITIDINE EG 150MG C.EFFV",
  UCD7: '9335185',
  UCD13: '3400893351857',
  ucdQtyMultiplicator: 30,
  cipLib: "RANITIDINE EG 150MG C.EFFV BT 30",
  atcCode: "A02BA02"
}, {
  CIP7: '3913652',
  CIP13: '3400939136523',
  ucdLib: "RANITIDINE EG 300MG C.EFFV",
  UCD7: '9335191',
  UCD13: '3400893351918',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE EG 300MG C.EFFV BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3424982',
  CIP13: '3400934249822',
  ucdLib: "AZANTAC 300MG CPR EFFV",
  UCD7: '9154236',
  UCD13: '3400891542363',
  ucdQtyMultiplicator: 14,
  cipLib: "AZANTAC 300MG CPR EFFV BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3424901',
  CIP13: '3400934249013',
  ucdLib: "RANITIDINE BGA 300MG C.EFFV",
  UCD7: '9256563',
  UCD13: '3400892565637',
  ucdQtyMultiplicator: 14,
  cipLib: "RANITIDINE BGA 300MG C.EFFV BT 14",
  atcCode: "A02BA02"
}, {
  CIP7: '3397067',
  CIP13: '3400933970673',
  ucdLib: "CIMETIDINE MYL 200MG CPR",
  UCD7: '9181256',
  UCD13: '3400891812565',
  ucdQtyMultiplicator: 30,
  cipLib: "CIMETIDINE MYL 200MG CPR BT 30",
  atcCode: "A02BA01"
}, {
  CIP7: '3397133',
  CIP13: '3400933971335',
  ucdLib: "CIMETIDINE MYL 400MG CPR",
  UCD7: '9181262',
  UCD13: '3400891812626',
  ucdQtyMultiplicator: 30,
  cipLib: "CIMETIDINE MYL 400MG CPR BT 30",
  atcCode: "A02BA01"
}, {
  CIP7: '3488255',
  CIP13: '3400934882555',
  ucdLib: "CIMETIDINE ARW 200MG C.EFFV",
  UCD7: '9257901',
  UCD13: '3400892579016',
  ucdQtyMultiplicator: 60,
  cipLib: "CIMETIDINE ARW 200MG C.EFFV BT 60",
  atcCode: "A02BA01"
}, {
  CIP7: '3485860',
  CIP13: '3400934858604',
  ucdLib: "CIMETIDINE MYL 200MG C.EFFV",
  UCD7: '9210006',
  UCD13: '3400892100067',
  ucdQtyMultiplicator: 60,
  cipLib: "CIMETIDINE MYL 200MG C.EFFV BT 60",
  atcCode: "A02BA01"
}, {
  CIP7: '3416474',
  CIP13: '3400934164743',
  ucdLib: "CIMETIDINE MYL 800MG CPR",
  UCD7: '9187448',
  UCD13: '3400891874488',
  ucdQtyMultiplicator: 15,
  cipLib: "CIMETIDINE MYL 800MG CPR BT 15",
  atcCode: "A02BA01"
}, {
  CIP7: '3244027',
  CIP13: '3400932440276',
  ucdLib: "GELOX BUV SUSP SACH",
  UCD7: '9037855',
  UCD13: '3400890378550',
  ucdQtyMultiplicator: 30,
  cipLib: "GELOX BUV SUSP SACH BT 30",
  atcCode: "A02AX"
}, {
  CIP7: '3613370',
  CIP13: '3400936133709',
  ucdLib: "SODIUM ALGI/BICAR BGA BUV S.",
  UCD7: '9255865',
  UCD13: '3400892558653',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM ALGI/BICAR BGA BUV S. BT 24",
  atcCode: "A02AH"
}, {
  CIP7: '3309525',
  CIP13: '3400933095253',
  ucdLib: "GAVISCON BUV SUSP SACH10ML",
  UCD7: '9136681',
  UCD13: '3400891366815',
  ucdQtyMultiplicator: 24,
  cipLib: "GAVISCON BUV SUSP SACH10ML BT 24",
  atcCode: "A02AH"
}, {
  CIP7: '3375367',
  CIP13: '3400933753672',
  ucdLib: "GAVISCON BB BUV SUSP FL150ML",
  UCD7: '9175681',
  UCD13: '3400891756814',
  ucdQtyMultiplicator: 1,
  cipLib: "GAVISCON BB BUV SUSP FL150ML BT 1",
  atcCode: "A02AH"
}, {
  CIP7: '3228502',
  CIP13: '3400932285020',
  ucdLib: "GAVISCON BUV SUSP FV250ML",
  UCD7: '9037683',
  UCD13: '3400890376839',
  ucdQtyMultiplicator: 1,
  cipLib: "GAVISCON BUV SUSP FV250ML BT 1",
  atcCode: "A02AH"
}, {
  CIP7: '3605896',
  CIP13: '3400936058965',
  ucdLib: "SODIUM ALGI/BICAR BGA BUV250ML",
  UCD7: '9256592',
  UCD13: '3400892565927',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM ALGI/BICAR BGA BUV250ML BT 1",
  atcCode: "A02AH"
}, {
  CIP7: '3679096',
  CIP13: '3400936790964',
  ucdLib: "GAVISCON MENT CPR CROQ",
  UCD7: '9276494',
  UCD13: '3400892764948',
  ucdQtyMultiplicator: 20,
  cipLib: "GAVISCON MENT CPR CROQ BT 20",
  atcCode: "A02AH"
}, {
  CIP7: '3385176',
  CIP13: '3400933851767',
  ucdLib: "GAVISCONELL MENT S/S BUV SAC",
  UCD7: '9319660',
  UCD13: '3400893196601',
  ucdQtyMultiplicator: 24,
  cipLib: "GAVISCONELL MENT S/S BUV SAC BT 24",
  atcCode: "A02AH"
}, {
  CIP7: '3762176',
  CIP13: '3400937621762',
  ucdLib: "GAVISCONPRO MENT BUV S.10ML",
  UCD7: '9416067',
  UCD13: '3400894160670',
  ucdQtyMultiplicator: 10,
  cipLib: "GAVISCONPRO MENT BUV S.10ML BT 10",
  atcCode: "A02AH"
}, {
  CIP7: '3745611',
  CIP13: '3400937456111',
  ucdLib: "SODIUM ALGI/BICAR SDZ BUV250ML",
  UCD7: '9287807',
  UCD13: '3400892878072',
  ucdQtyMultiplicator: 1,
  cipLib: "SODIUM ALGI/BICAR SDZ BUV250ML BT 1",
  atcCode: "A02AH"
}, {
  CIP7: '3825451',
  CIP13: '3400938254518',
  ucdLib: "GAVISCONELL MENT S/S BUV SAC",
  UCD7: '9319660',
  UCD13: '3400893196601',
  ucdQtyMultiplicator: 12,
  cipLib: "GAVISCONELL MENT S/S BUV SAC BT 12",
  atcCode: "A02AH"
}, {
  CIP7: '3829377',
  CIP13: '3400938293777',
  ucdLib: "GAVISCONELL S/S FRAI C.CROQ",
  UCD7: '9319677',
  UCD13: '3400893196779',
  ucdQtyMultiplicator: 32,
  cipLib: "GAVISCONELL S/S FRAI C.CROQ BT 32",
  atcCode: "A02AH"
}, {
  CIP7: '3829070',
  CIP13: '3400938290707',
  ucdLib: "GAVISCONELL S/S MENT C.CROQ",
  UCD7: '9319683',
  UCD13: '3400893196830',
  ucdQtyMultiplicator: 32,
  cipLib: "GAVISCONELL S/S MENT C.CROQ BT 32",
  atcCode: "A02AH"
}, {
  CIP7: '2802229',
  CIP13: '3400928022295',
  ucdLib: "MAALOX REFLUX MENT S/S SACH",
  UCD7: '9404414',
  UCD13: '3400894044147',
  ucdQtyMultiplicator: 12,
  cipLib: "MAALOX REFLUX MENT S/S SACH BT 12",
  atcCode: "A02AH"
}, {
  CIP7: '2687716',
  CIP13: '3400926877163',
  ucdLib: "GAVISCONELL FR.PASS S/S S/PL",
  UCD7: '9394207',
  UCD13: '3400893942079',
  ucdQtyMultiplicator: 12,
  cipLib: "GAVISCONELL FR.PASS S/S S/PL BT 12",
  atcCode: "A02AH"
}, {
  CIP7: '2795802',
  CIP13: '3400927958021',
  ucdLib: "SODIUM ALGI/BICAR MYC BUV S.",
  UCD7: '9408955',
  UCD13: '3400894089551',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM ALGI/BICAR MYC BUV S. BT 12",
  atcCode: "A02AH"
}, {
  CIP7: '2790992',
  CIP13: '3400927909924',
  ucdLib: "SODIUM ALGI/BICAR MYL BUV S.",
  UCD7: '9408990',
  UCD13: '3400894089902',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM ALGI/BICAR MYL BUV S. BT 24",
  atcCode: "A02AH"
}, {
  CIP7: '2793424',
  CIP13: '3400927934247',
  ucdLib: "SODIUM ALGI/BICAR SDC BUV S.",
  UCD7: '9403805',
  UCD13: '3400894038054',
  ucdQtyMultiplicator: 12,
  cipLib: "SODIUM ALGI/BICAR SDC BUV S. BT 12",
  atcCode: "A02AH"
}, {
  CIP7: '2793430',
  CIP13: '3400927934308',
  ucdLib: "SODIUM ALGI/BICAR SDC BUV S.",
  UCD7: '9403805',
  UCD13: '3400894038054',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM ALGI/BICAR SDC BUV S. BT 24",
  atcCode: "A02AH"
}, {
  CIP7: '2792703',
  CIP13: '3400927927034',
  ucdLib: "SODIUM ALGI/BICAR SDZ BUV S.",
  UCD7: '9403461',
  UCD13: '3400894034612',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM ALGI/BICAR SDZ BUV S. BT 24",
  atcCode: "A02AH"
}, {
  CIP7: '2792749',
  CIP13: '3400927927492',
  ucdLib: "SODIUM ALGI/BICAR ZEN BUV S.",
  UCD7: '9412187',
  UCD13: '3400894121879',
  ucdQtyMultiplicator: 24,
  cipLib: "SODIUM ALGI/BICAR ZEN BUV S. BT 24",
  atcCode: "A02AH"
}, {
  CIP7: '3431686',
  CIP13: '3400934316869',
  ucdLib: "POLYSILANE DELALANDE CPR",
  UCD7: '9198245',
  UCD13: '3400891982459',
  ucdQtyMultiplicator: 32,
  cipLib: "POLYSILANE DELALANDE CPR BT 32",
  atcCode: "A02AF02"
}, {
  CIP7: '3438010',
  CIP13: '3400934380105',
  ucdLib: "RENNIELIQUO S/SUC BUV S.10ML",
  UCD7: '9322722',
  UCD13: '3400893227220',
  ucdQtyMultiplicator: 20,
  cipLib: "RENNIELIQUO S/SUC BUV S.10ML BT 20",
  atcCode: "A02AD04"
}, {
  CIP7: '3000764',
  CIP13: '3400930007648',
  ucdLib: "MAALOX M.ESTOMAC BUV FP250ML",
  UCD7: '9422501',
  UCD13: '3400894225010',
  ucdQtyMultiplicator: 1,
  cipLib: "MAALOX M.ESTOMAC BUV FP250ML BT 1",
  atcCode: "A02AD01"
}, {
  CIP7: '3325688',
  CIP13: '3400933256883',
  ucdLib: "NEUTROSES CPR CROQ",
  UCD7: '9062712',
  UCD13: '3400890627122',
  ucdQtyMultiplicator: 42,
  cipLib: "NEUTROSES CPR CROQ BT 42",
  atcCode: "A02AD01"
}, {
  CIP7: '3326009',
  CIP13: '3400933260095',
  ucdLib: "RENNIE DEFLATINE S/SUC CPR",
  UCD7: '9144692',
  UCD13: '3400891446920',
  ucdQtyMultiplicator: 18,
  cipLib: "RENNIE DEFLATINE S/SUC CPR BT 18",
  atcCode: "A02AD01"
}, {
  CIP7: '3311143',
  CIP13: '3400933111434',
  ucdLib: "MOXYDAR BUV CPR",
  UCD7: '9137574',
  UCD13: '3400891375749',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXYDAR BUV CPR BT 30",
  atcCode: "A02AD01"
}, {
  CIP7: '3247770',
  CIP13: '3400932477708',
  ucdLib: "RENNIE CPR",
  UCD7: '9078966',
  UCD13: '3400890789660',
  ucdQtyMultiplicator: 48,
  cipLib: "RENNIE CPR BT 48",
  atcCode: "A02AD01"
}, {
  CIP7: '3302888',
  CIP13: '3400933028886',
  ucdLib: "RENNIE SANS SUCRE CPR CROQ",
  UCD7: '9184740',
  UCD13: '3400891847406',
  ucdQtyMultiplicator: 36,
  cipLib: "RENNIE SANS SUCRE CPR CROQ BT 36",
  atcCode: "A02AD01"
}, {
  CIP7: '3302902',
  CIP13: '3400933029029',
  ucdLib: "RENNIE SANS SUCRE CPR CROQ",
  UCD7: '9184740',
  UCD13: '3400891847406',
  ucdQtyMultiplicator: 60,
  cipLib: "RENNIE SANS SUCRE CPR CROQ BT 60",
  atcCode: "A02AD01"
}, {
  CIP7: '3302919',
  CIP13: '3400933029197',
  ucdLib: "RENNIE SANS SUCRE CPR CROQ",
  UCD7: '9184740',
  UCD13: '3400891847406',
  ucdQtyMultiplicator: 96,
  cipLib: "RENNIE SANS SUCRE CPR CROQ BT 96",
  atcCode: "A02AD01"
}, {
  CIP7: '4985168',
  CIP13: '3400949851683',
  ucdLib: "MAALOX M.ESTOMAC S/S F.ROU C",
  UCD7: '9374179',
  UCD13: '3400893741795',
  ucdQtyMultiplicator: 40,
  cipLib: "MAALOX M.ESTOMAC S/S F.ROU C BT 40",
  atcCode: "A02AD01"
}, {
  CIP7: '3538220',
  CIP13: '3400935382207',
  ucdLib: "MAALOX M.ESTOMAC CPR CROQ",
  UCD7: '9229750',
  UCD13: '3400892297507',
  ucdQtyMultiplicator: 40,
  cipLib: "MAALOX M.ESTOMAC CPR CROQ BT 40",
  atcCode: "A02AD01"
}, {
  CIP7: '3538237',
  CIP13: '3400935382375',
  ucdLib: "MAALOX M.ESTOMAC S/SUC CPR",
  UCD7: '9229744',
  UCD13: '3400892297446',
  ucdQtyMultiplicator: 40,
  cipLib: "MAALOX M.ESTOMAC S/SUC CPR BT 40",
  atcCode: "A02AD01"
}, {
  CIP7: '3413613',
  CIP13: '3400934136139',
  ucdLib: "XOLAAM CPR CROQ",
  UCD7: '9187129',
  UCD13: '3400891871296',
  ucdQtyMultiplicator: 40,
  cipLib: "XOLAAM CPR CROQ BT 40",
  atcCode: "A02AD01"
}, {
  CIP7: '3545504',
  CIP13: '3400935455048',
  ucdLib: "MAALOX M.ESTOMAC BUV SACH",
  UCD7: '9229661',
  UCD13: '3400892296616',
  ucdQtyMultiplicator: 20,
  cipLib: "MAALOX M.ESTOMAC BUV SACH BT 20",
  atcCode: "A02AD01"
}, {
  CIP7: '3762590',
  CIP13: '3400937625906',
  ucdLib: "MARGA CPR SUCER",
  UCD7: '9296166',
  UCD13: '3400892961668',
  ucdQtyMultiplicator: 48,
  cipLib: "MARGA CPR SUCER BT 48",
  atcCode: "A02AD01"
}, {
  CIP7: '3694807',
  CIP13: '3400936948075',
  ucdLib: "RENNIE ORANGE CPR CROQ",
  UCD7: '9279009',
  UCD13: '3400892790091',
  ucdQtyMultiplicator: 36,
  cipLib: "RENNIE ORANGE CPR CROQ BT 36",
  atcCode: "A02AD01"
}, {
  CIP7: '3490418',
  CIP13: '3400934904189',
  ucdLib: "MOXYDAR BUV SACH20ML",
  UCD7: '9214010',
  UCD13: '3400892140100',
  ucdQtyMultiplicator: 30,
  cipLib: "MOXYDAR BUV SACH20ML BT 30",
  atcCode: "A02AD01"
}, {
  CIP7: '2189705',
  CIP13: '3400921897050',
  ucdLib: "MAALOX M.ESTOMAC CPR CROQ",
  UCD7: '9229750',
  UCD13: '3400892297507',
  ucdQtyMultiplicator: 60,
  cipLib: "MAALOX M.ESTOMAC CPR CROQ BT 60",
  atcCode: "A02AD01"
}, {
  CIP7: '2173727',
  CIP13: '3400921737271',
  ucdLib: "MAALOX M.ESTOMAC F.ROU SACH",
  UCD7: '9389287',
  UCD13: '3400893892879',
  ucdQtyMultiplicator: 20,
  cipLib: "MAALOX M.ESTOMAC F.ROU SACH BT 20",
  atcCode: "A02AD01"
}, {
  CIP7: '2179150',
  CIP13: '3400921791501',
  ucdLib: "MAALOX M.ESTOMAC S/SUC CPR",
  UCD7: '9229744',
  UCD13: '3400892297446',
  ucdQtyMultiplicator: 60,
  cipLib: "MAALOX M.ESTOMAC S/SUC CPR BT 60",
  atcCode: "A02AD01"
}, {
  CIP7: '3421819',
  CIP13: '3400934218194',
  ucdLib: "XOLAAM BUV FV250ML",
  UCD7: '9194158',
  UCD13: '3400891941586',
  ucdQtyMultiplicator: 1,
  cipLib: "XOLAAM BUV FV250ML BT 1",
  atcCode: "A02AD01"
}, {
  CIP7: '3246262',
  CIP13: '3400932462629',
  ucdLib: "PHOSPHALUGEL SUSP BUV FL250G",
  UCD7: '9071496',
  UCD13: '3400890714969',
  ucdQtyMultiplicator: 1,
  cipLib: "PHOSPHALUGEL SUSP BUV FL250G BT 1",
  atcCode: "A02AB03"
}, {
  CIP7: '3219756',
  CIP13: '3400932197569',
  ucdLib: "PHOSPHALUGEL SUSP BUV SACH",
  UCD7: '9071504',
  UCD13: '3400890715041',
  ucdQtyMultiplicator: 26,
  cipLib: "PHOSPHALUGEL SUSP BUV SACH BT 26",
  atcCode: "A02AB03"
}, {
  CIP7: '3216723',
  CIP13: '3400932167234',
  ucdLib: "ROCGEL 1,2G BUV SACH",
  UCD7: '9080868',
  UCD13: '3400890808682',
  ucdQtyMultiplicator: 24,
  cipLib: "ROCGEL 1,2G BUV SACH BT 24",
  atcCode: "A02AB01"
}, {
  CIP7: '3006782',
  CIP13: '3400930067826',
  ucdLib: "ARTHRODONT 1% PATE GGVL TB40G",
  UCD7: '9006820',
  UCD13: '3400890068208',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTHRODONT 1% PATE GGVL TB40G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3118044',
  CIP13: '3400931180449',
  ucdLib: "DENTOBAUME LIQ FL4ML",
  UCD7: '9024953',
  UCD13: '3400890249539',
  ucdQtyMultiplicator: 1,
  cipLib: "DENTOBAUME LIQ FL4ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3045411',
  CIP13: '3400930454114',
  ucdLib: "GLYCO-THYMOLINE 55 BUC FL250ML",
  UCD7: '9040283',
  UCD13: '3400890402835',
  ucdQtyMultiplicator: 1,
  cipLib: "GLYCO-THYMOLINE 55 BUC FL250ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3259299',
  CIP13: '3400932592999',
  ucdLib: "ARTHRODONT 1% PATE GGVL TB80G",
  UCD7: '9108101',
  UCD13: '3400891081015',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTHRODONT 1% PATE GGVL TB80G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3253428',
  CIP13: '3400932534289',
  ucdLib: "FLOGENCYL GEL GGVL TB20G",
  UCD7: '9035299',
  UCD13: '3400890352994',
  ucdQtyMultiplicator: 1,
  cipLib: "FLOGENCYL GEL GGVL TB20G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3197813',
  CIP13: '3400931978138',
  ucdLib: "PYRALVEX GEL GGVL TB15G",
  UCD7: '9077518',
  UCD13: '3400890775182',
  ucdQtyMultiplicator: 1,
  cipLib: "PYRALVEX GEL GGVL TB15G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3245400',
  CIP13: '3400932454006',
  ucdLib: "ARTISIAL SOL ENDOBUC PULV100ML",
  UCD7: '9006889',
  UCD13: '3400890068895',
  ucdQtyMultiplicator: 1,
  cipLib: "ARTISIAL SOL ENDOBUC PULV100ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3607576',
  CIP13: '3400936075764',
  ucdLib: "PANSORAL GEL BUC TB15G",
  UCD7: '9360355',
  UCD13: '3400893603550',
  ucdQtyMultiplicator: 1,
  cipLib: "PANSORAL GEL BUC TB15G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3139052',
  CIP13: '3400931390527',
  ucdLib: "SELGINE PATE DENT TB100G",
  UCD7: '9083393',
  UCD13: '3400890833936',
  ucdQtyMultiplicator: 1,
  cipLib: "SELGINE PATE DENT TB100G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3369852',
  CIP13: '3400933698522',
  ucdLib: "PYRALVEX SOL GGVL FL10ML",
  UCD7: '9167078',
  UCD13: '3400891670783',
  ucdQtyMultiplicator: 1,
  cipLib: "PYRALVEX SOL GGVL FL10ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3637755',
  CIP13: '3400936377554',
  ucdLib: "AFTAGEL GEL BUC TB15ML",
  UCD7: '9259484',
  UCD13: '3400892594842',
  ucdQtyMultiplicator: 1,
  cipLib: "AFTAGEL GEL BUC TB15ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '2192920',
  CIP13: '3400921929201',
  ucdLib: "DOLODENT SOL GGVL FL27G",
  UCD7: '9384396',
  UCD13: '3400893843963',
  ucdQtyMultiplicator: 1,
  cipLib: "DOLODENT SOL GGVL FL27G BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '5002498',
  CIP13: '3400950024984',
  ucdLib: "PULPARTHROL SOL DENT FV14ML",
  UCD7: '9419597',
  UCD13: '3400894195979',
  ucdQtyMultiplicator: 1,
  cipLib: "PULPARTHROL SOL DENT FV14ML BT 1",
  atcCode: "A01AD11"
}, {
  CIP7: '3609405',
  CIP13: '3400936094055',
  ucdLib: "PAROCLINE 2% GEL DENT SRG",
  UCD7: '9401189',
  UCD13: '3400894011897',
  ucdQtyMultiplicator: 3,
  cipLib: "PAROCLINE 2% GEL DENT SRG BT 3",
  atcCode: "A01AB23"
}, {
  CIP7: '5580611',
  CIP13: '3400955806110',
  ucdLib: "METROCOL 4,5MG EPONG DENT",
  UCD7: '9393277',
  UCD13: '3400893932773',
  ucdQtyMultiplicator: 10,
  cipLib: "METROCOL 4,5MG EPONG DENT BT 10",
  atcCode: "A01AB17"
}, {
  CIP7: '3497774',
  CIP13: '3400934977749',
  ucdLib: "IMIZINE 10% PATE DENT TB4,5G",
  UCD7: '9393001',
  UCD13: '3400893930014',
  ucdQtyMultiplicator: 1,
  cipLib: "IMIZINE 10% PATE DENT TB4,5G BT 1",
  atcCode: "A01AB17"
}, {
  CIP7: '3024834',
  CIP13: '3400930248348',
  ucdLib: "COLLU-HEXTRIL 0,2% COLLU 40ML",
  UCD7: '9021280',
  UCD13: '3400890212809',
  ucdQtyMultiplicator: 1,
  cipLib: "COLLU-HEXTRIL 0,2% COLLU 40ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '3049604',
  CIP13: '3400930496046',
  ucdLib: "HEXTRIL 0,1% BAIN BCHE FV200ML",
  UCD7: '9043614',
  UCD13: '3400890436144',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXTRIL 0,1% BAIN BCHE FV200ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '3303959',
  CIP13: '3400933039592',
  ucdLib: "HEXTRIL 0,1% BAIN BCHE FV30ML",
  UCD7: '9157252',
  UCD13: '3400891572520',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXTRIL 0,1% BAIN BCHE FV30ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '3392615',
  CIP13: '3400933926151',
  ucdLib: "HEXTRIL 0,1% PATE DENT TB100G",
  UCD7: '9177705',
  UCD13: '3400891777055',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXTRIL 0,1% PATE DENT TB100G BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '3597056',
  CIP13: '3400935970565',
  ucdLib: "HEXTRIL MENT 0,1% B.BCHE 200ML",
  UCD7: '9263089',
  UCD13: '3400892630892',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXTRIL MENT 0,1% B.BCHE 200ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '3597062',
  CIP13: '3400935970626',
  ucdLib: "HEXTRIL MENT 0,1% B.BCHE 400ML",
  UCD7: '9263095',
  UCD13: '3400892630953',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXTRIL MENT 0,1% B.BCHE 400ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '3547325',
  CIP13: '3400935473257',
  ucdLib: "HEXTRIL 0,1% BAIN BCHE FP400ML",
  UCD7: '9226711',
  UCD13: '3400892267111',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXTRIL 0,1% BAIN BCHE FP400ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '4199369',
  CIP13: '3400941993695',
  ucdLib: "HEXETIDINE SDC 0,1% BCHE 200ML",
  UCD7: '9377746',
  UCD13: '3400893777466',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXETIDINE SDC 0,1% BCHE 200ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '4199375',
  CIP13: '3400941993756',
  ucdLib: "HEXETIDINE SDC 0,1% BCHE 400ML",
  UCD7: '9377752',
  UCD13: '3400893777527',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXETIDINE SDC 0,1% BCHE 400ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '2233116',
  CIP13: '3400922331164',
  ucdLib: "HEXETIDINE BGC 0,1% BCHE 200ML",
  UCD7: '9387897',
  UCD13: '3400893878972',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXETIDINE BGC 0,1% BCHE 200ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '2233122',
  CIP13: '3400922331225',
  ucdLib: "HEXETIDINE BGC 0,1% BCHE 400ML",
  UCD7: '9387905',
  UCD13: '3400893879054',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXETIDINE BGC 0,1% BCHE 400ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '2225298',
  CIP13: '3400922252988',
  ucdLib: "HEXETIDINE EGC 0,1% BCHE 200ML",
  UCD7: '9393797',
  UCD13: '3400893937976',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXETIDINE EGC 0,1% BCHE 200ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '2233079',
  CIP13: '3400922330792',
  ucdLib: "HEXETIDINE TCO 0,1% BCHE 200ML",
  UCD7: '9387911',
  UCD13: '3400893879115',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXETIDINE TCO 0,1% BCHE 200ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '2233085',
  CIP13: '3400922330853',
  ucdLib: "HEXETIDINE TCO 0,1% BCHE 400ML",
  UCD7: '9387928',
  UCD13: '3400893879283',
  ucdQtyMultiplicator: 1,
  cipLib: "HEXETIDINE TCO 0,1% BCHE 400ML BT 1",
  atcCode: "A01AB12"
}, {
  CIP7: '3458538',
  CIP13: '3400934585388',
  ucdLib: "ALODONT BAIN BCHE FP500ML +GOD",
  UCD7: '9196269',
  UCD13: '3400891962697',
  ucdQtyMultiplicator: 1,
  cipLib: "ALODONT BAIN BCHE FP500ML +GOD BT 1",
  atcCode: "A01AB11"
}, {
  CIP7: '3001999',
  CIP13: '3400930019993',
  ucdLib: "ALODONT BAIN BCHE FP200ML +GOD",
  UCD7: '9414708',
  UCD13: '3400894147084',
  ucdQtyMultiplicator: 1,
  cipLib: "ALODONT BAIN BCHE FP200ML +GOD BT 1",
  atcCode: "A01AB11"
}, {
  CIP7: '3853559',
  CIP13: '3400938535594',
  ucdLib: "HUMEX MAL GORGE COLLU FL35ML",
  UCD7: '9044714',
  UCD13: '3400890447140',
  ucdQtyMultiplicator: 35,
  cipLib: "HUMEX MAL GORGE COLLU FL35ML BT 35",
  atcCode: "A01AB11"
}, {
  CIP7: '3517666',
  CIP13: '3400935176660',
  ucdLib: "BETADINE 10% BAIN BCHE 10ML",
  UCD7: '9221346',
  UCD13: '3400892213460',
  ucdQtyMultiplicator: 10,
  cipLib: "BETADINE 10% BAIN BCHE 10ML BT 10",
  atcCode: "A01AB11"
}, {
  CIP7: '3152874',
  CIP13: '3400931528746',
  ucdLib: "BETADINE 10% BAIN BCHE FP125ML",
  UCD7: '9010313',
  UCD13: '3400890103138',
  ucdQtyMultiplicator: 1,
  cipLib: "BETADINE 10% BAIN BCHE FP125ML BT 1",
  atcCode: "A01AB11"
}, {
  CIP7: '5609295',
  CIP13: '3400956092956',
  ucdLib: "GIVALEX BAIN BCHE FL125ML",
  UCD7: '9208386',
  UCD13: '3400892083865',
  ucdQtyMultiplicator: 1,
  cipLib: "GIVALEX BAIN BCHE FL125ML BT 1",
  atcCode: "A01AB11"
}, {
  CIP7: '3163903',
  CIP13: '3400931639039',
  ucdLib: "ALODONT BAIN BCHE FV200ML +GOD",
  UCD7: '9003224',
  UCD13: '3400890032247',
  ucdQtyMultiplicator: 1,
  cipLib: "ALODONT BAIN BCHE FV200ML +GOD BT 1",
  atcCode: "A01AB11"
}, {
  CIP7: '3160514',
  CIP13: '3400931605140',
  ucdLib: "PYOREX PATE DENT TB90G",
  UCD7: '9077487',
  UCD13: '3400890774871',
  ucdQtyMultiplicator: 1,
  cipLib: "PYOREX PATE DENT TB90G BT 1",
  atcCode: "A01AB11"
}, {
  CIP7: '4153574',
  CIP13: '3400941535741',
  ucdLib: "PREDYL 10% BAIN BCHE FP200ML",
  UCD7: '9372157',
  UCD13: '3400893721575',
  ucdQtyMultiplicator: 1,
  cipLib: "PREDYL 10% BAIN BCHE FP200ML BT 1",
  atcCode: "A01AB11"
}, {
  CIP7: '3268068',
  CIP13: '3400932680689',
  ucdLib: "DAKTARIN 2% GEL BUC TB40G",
  UCD7: '9102570',
  UCD13: '3400891025705',
  ucdQtyMultiplicator: 1,
  cipLib: "DAKTARIN 2% GEL BUC TB40G BT 1",
  atcCode: "A01AB09"
}, {
  CIP7: '3483080',
  CIP13: '3400934830808',
  ucdLib: "DAKTARIN 2% GEL BUC TB80G",
  UCD7: '9324589',
  UCD13: '3400893245897',
  ucdQtyMultiplicator: 1,
  cipLib: "DAKTARIN 2% GEL BUC TB80G BT 1",
  atcCode: "A01AB09"
}, {
  CIP7: '3772364',
  CIP13: '3400937723640',
  ucdLib: "LORAMYC 50MG CPR GGVL",
  UCD7: '9300732',
  UCD13: '3400893007327',
  ucdQtyMultiplicator: 14,
  cipLib: "LORAMYC 50MG CPR GGVL BT 14",
  atcCode: "A01AB09"
}, {
  CIP7: '3223172',
  CIP13: '3400932231720',
  ucdLib: "ELGYDIUM PATE DENT TB150G",
  UCD7: '9110150',
  UCD13: '3400891101508',
  ucdQtyMultiplicator: 1,
  cipLib: "ELGYDIUM PATE DENT TB150G BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3689574',
  CIP13: '3400936895744',
  ucdLib: "ELUDRIL BAIN BCHE FP90ML",
  UCD7: '9352717',
  UCD13: '3400893527177',
  ucdQtyMultiplicator: 1,
  cipLib: "ELUDRIL BAIN BCHE FP90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3372848',
  CIP13: '3400933728489',
  ucdLib: "PREXIDINE BAIN BCHE FL200ML",
  UCD7: '9168563',
  UCD13: '3400891685633',
  ucdQtyMultiplicator: 1,
  cipLib: "PREXIDINE BAIN BCHE FL200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3213535',
  CIP13: '3400932135356',
  ucdLib: "ELGYDIUM PATE DENT TB100G",
  UCD7: '9030698',
  UCD13: '3400890306980',
  ucdQtyMultiplicator: 1,
  cipLib: "ELGYDIUM PATE DENT TB100G BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3213529',
  CIP13: '3400932135295',
  ucdLib: "ELGYDIUM PATE DENT TB50G",
  UCD7: '9217333',
  UCD13: '3400892173337',
  ucdQtyMultiplicator: 1,
  cipLib: "ELGYDIUM PATE DENT TB50G BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3563554',
  CIP13: '3400935635549',
  ucdLib: "PAROEX 0,12% BAIN BCHE 5000ML",
  UCD7: '9233935',
  UCD13: '3400892339351',
  ucdQtyMultiplicator: 1,
  cipLib: "PAROEX 0,12% BAIN BCHE 5000ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3482382',
  CIP13: '3400934823824',
  ucdLib: "ELUDRILPRO BAIN BCHE FP200ML",
  UCD7: '9207180',
  UCD13: '3400892071800',
  ucdQtyMultiplicator: 1,
  cipLib: "ELUDRILPRO BAIN BCHE FP200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3512143',
  CIP13: '3400935121431',
  ucdLib: "ELUDRILPRO BAIN BCHE FP500ML",
  UCD7: '9226042',
  UCD13: '3400892260426',
  ucdQtyMultiplicator: 1,
  cipLib: "ELUDRILPRO BAIN BCHE FP500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3512137',
  CIP13: '3400935121370',
  ucdLib: "PREXIDINE BAIN BCHE FL500ML",
  UCD7: '9212927',
  UCD13: '3400892129273',
  ucdQtyMultiplicator: 1,
  cipLib: "PREXIDINE BAIN BCHE FL500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468034',
  CIP13: '3400934680342',
  ucdLib: "BUCCOSOIN BAIN BCHE FL200ML",
  UCD7: '9348868',
  UCD13: '3400893488683',
  ucdQtyMultiplicator: 1,
  cipLib: "BUCCOSOIN BAIN BCHE FL200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468198',
  CIP13: '3400934681981',
  ucdLib: "CHLORHEX/CHLOROBUT.ARW 200ML",
  UCD7: '9348650',
  UCD13: '3400893486504',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.ARW 200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468181',
  CIP13: '3400934681813',
  ucdLib: "CHLORHEX/CHLOROBUT.ARW 90ML",
  UCD7: '9350138',
  UCD13: '3400893501382',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.ARW 90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468092',
  CIP13: '3400934680922',
  ucdLib: "CHLORHEX/CHLOROBUT.MYL 200ML",
  UCD7: '9348839',
  UCD13: '3400893488393',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.MYL 200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468117',
  CIP13: '3400934681172',
  ucdLib: "CHLORHEX/CHLOROBUT.MYL 500ML",
  UCD7: '9348845',
  UCD13: '3400893488454',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.MYL 500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468086',
  CIP13: '3400934680861',
  ucdLib: "CHLORHEX/CHLOROBUT.MYL 90ML",
  UCD7: '9348851',
  UCD13: '3400893488515',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.MYL 90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468229',
  CIP13: '3400934682292',
  ucdLib: "CHLORHEX/CHLOROBUT.PHR 200ML",
  UCD7: '9350380',
  UCD13: '3400893503805',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.PHR 200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468212',
  CIP13: '3400934682124',
  ucdLib: "CHLORHEX/CHLOROBUT.PHR 90ML",
  UCD7: '9350144',
  UCD13: '3400893501443',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.PHR 90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468169',
  CIP13: '3400934681691',
  ucdLib: "CHLORHEX/CHLOROBUT.ZEN 200ML",
  UCD7: '9348897',
  UCD13: '3400893488973',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.ZEN 200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468152',
  CIP13: '3400934681523',
  ucdLib: "CHLORHEX/CHLOROBUT.ZEN 500ML",
  UCD7: '9348905',
  UCD13: '3400893489055',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.ZEN 500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3468146',
  CIP13: '3400934681462',
  ucdLib: "CHLORHEX/CHLOROBUT.ZEN 90ML",
  UCD7: '9348911',
  UCD13: '3400893489116',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.ZEN 90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3643431',
  CIP13: '3400936434318',
  ucdLib: "PAROEX 0,12% BAIN BCHE F100ML",
  UCD7: '9263215',
  UCD13: '3400892632155',
  ucdQtyMultiplicator: 1,
  cipLib: "PAROEX 0,12% BAIN BCHE F100ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3446417',
  CIP13: '3400934464171',
  ucdLib: "PAROEX 0,12% BAIN BCHE F300ML",
  UCD7: '9207079',
  UCD13: '3400892070797',
  ucdQtyMultiplicator: 1,
  cipLib: "PAROEX 0,12% BAIN BCHE F300ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3446423',
  CIP13: '3400934464232',
  ucdLib: "PAROEX 0,12% BAIN BCHE F500ML",
  UCD7: '9207085',
  UCD13: '3400892070858',
  ucdQtyMultiplicator: 1,
  cipLib: "PAROEX 0,12% BAIN BCHE F500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3940962',
  CIP13: '3400939409627',
  ucdLib: "CHLORHEX/CHLOROBUT.BGA 90ML",
  UCD7: '9335512',
  UCD13: '3400893355121',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.BGA 90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '2693266',
  CIP13: '3400926932664',
  ucdLib: "CHLORHEX/CHLOROBUT.BGC 200ML",
  UCD7: '9398702',
  UCD13: '3400893987025',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.BGC 200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '2693272',
  CIP13: '3400926932725',
  ucdLib: "CHLORHEX/CHLOROBUT.BGC 500ML",
  UCD7: '9398777',
  UCD13: '3400893987773',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.BGC 500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3941080',
  CIP13: '3400939410807',
  ucdLib: "CHLORHEX/CHLOROBUT.EG FL90ML",
  UCD7: '9334636',
  UCD13: '3400893346365',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.EG FL90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3941252',
  CIP13: '3400939412528',
  ucdLib: "CHLORHEX/CHLOROBUT.SDZ 200ML",
  UCD7: '9340482',
  UCD13: '3400893404829',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.SDZ 200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3941269',
  CIP13: '3400939412696',
  ucdLib: "CHLORHEX/CHLOROBUT.SDZ 500ML",
  UCD7: '9340499',
  UCD13: '3400893404997',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.SDZ 500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3941246',
  CIP13: '3400939412467',
  ucdLib: "CHLORHEX/CHLOROBUT.SDZ 90ML",
  UCD7: '9339303',
  UCD13: '3400893393031',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.SDZ 90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3941016',
  CIP13: '3400939410166',
  ucdLib: "CHLORHEX/CHLOROBUT.TVC 200ML",
  UCD7: '9339361',
  UCD13: '3400893393611',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.TVC 200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3941022',
  CIP13: '3400939410227',
  ucdLib: "CHLORHEX/CHLOROBUT.TVC 500ML",
  UCD7: '9343109',
  UCD13: '3400893431092',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.TVC 500ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3940991',
  CIP13: '3400939409917',
  ucdLib: "CHLORHEX/CHLOROBUT.TVC 90ML",
  UCD7: '9334659',
  UCD13: '3400893346594',
  ucdQtyMultiplicator: 1,
  cipLib: "CHLORHEX/CHLOROBUT.TVC 90ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '2225720',
  CIP13: '3400922257204',
  ucdLib: "ELUDRILPERIO BAIN BCHE 200ML",
  UCD7: '9390161',
  UCD13: '3400893901618',
  ucdQtyMultiplicator: 1,
  cipLib: "ELUDRILPERIO BAIN BCHE 200ML BT 1",
  atcCode: "A01AB03"
}, {
  CIP7: '3540079',
  CIP13: '3400935400796',
  ucdLib: "DENTEX BAIN BCHE FL300ML",
  UCD7: '9232410',
  UCD13: '3400892324104',
  ucdQtyMultiplicator: 1,
  cipLib: "DENTEX BAIN BCHE FL300ML BT 1",
  atcCode: "A01AB02"
}, {
  CIP7: '3240986',
  CIP13: '3400932409860',
  ucdLib: "FLUOCARIL BI2000 GEL FL250ML",
  UCD7: '9035595',
  UCD13: '3400890355957',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOCARIL BI2000 GEL FL250ML BT 1",
  atcCode: "A01AA51"
}, {
  CIP7: '3219963',
  CIP13: '3400932199631',
  ucdLib: "FLUOSELGINE PATE DENT TB100G",
  UCD7: '9035810',
  UCD13: '3400890358101',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOSELGINE PATE DENT TB100G BT 1",
  atcCode: "A01AA51"
}, {
  CIP7: '3625640',
  CIP13: '3400936256408',
  ucdLib: "FLUOCARIL BI250 ANIS PATE 75ML",
  UCD7: '9259107',
  UCD13: '3400892591070',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOCARIL BI250 ANIS PATE 75ML BT 1",
  atcCode: "A01AA51"
}, {
  CIP7: '3625628',
  CIP13: '3400936256286',
  ucdLib: "FLUOCARIL BI250 MENT GEL 125ML",
  UCD7: '9258131',
  UCD13: '3400892581316',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOCARIL BI250 MENT GEL 125ML BT 1",
  atcCode: "A01AA51"
}, {
  CIP7: '3625611',
  CIP13: '3400936256118',
  ucdLib: "FLUOCARIL BI250 MENT GEL 75ML",
  UCD7: '9258378',
  UCD13: '3400892583785',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOCARIL BI250 MENT GEL 75ML BT 1",
  atcCode: "A01AA51"
}, {
  CIP7: '3627395',
  CIP13: '3400936273955',
  ucdLib: "FLUOCARIL BI250 MENT PATE 75ML",
  UCD7: '9221777',
  UCD13: '3400892217772',
  ucdQtyMultiplicator: 2,
  cipLib: "FLUOCARIL BI250 MENT PATE 75ML BT 2",
  atcCode: "A01AA51"
}, {
  CIP7: '3627389',
  CIP13: '3400936273894',
  ucdLib: "FLUOCARIL BI250 MENT PATE125ML",
  UCD7: '9221748',
  UCD13: '3400892217482',
  ucdQtyMultiplicator: 2,
  cipLib: "FLUOCARIL BI250 MENT PATE125ML BT 2",
  atcCode: "A01AA51"
}, {
  CIP7: '3500832',
  CIP13: '3400935008329',
  ucdLib: "FLUOCARIL BI250 MENT PATE 50ML",
  UCD7: '9221642',
  UCD13: '3400892216423',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOCARIL BI250 MENT PATE 50ML BT 1",
  atcCode: "A01AA51"
}, {
  CIP7: '3500849',
  CIP13: '3400935008497',
  ucdLib: "FLUOCARIL BI250 MENT PATE 75ML",
  UCD7: '9221777',
  UCD13: '3400892217772',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOCARIL BI250 MENT PATE 75ML BT 1",
  atcCode: "A01AA51"
}, {
  CIP7: '3500861',
  CIP13: '3400935008619',
  ucdLib: "FLUOCARIL BI250 MENT PATE125ML",
  UCD7: '9221748',
  UCD13: '3400892217482',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOCARIL BI250 MENT PATE125ML BT 1",
  atcCode: "A01AA51"
}, {
  CIP7: '3291392',
  CIP13: '3400932913923',
  ucdLib: "FLUODONTYL 1350 PATE DENT 75ML",
  UCD7: '9117301',
  UCD13: '3400891173017',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUODONTYL 1350 PATE DENT 75ML BT 1",
  atcCode: "A01AA01"
}, {
  CIP7: '3274241',
  CIP13: '3400932742417',
  ucdLib: "ZYMAFLUOR 1MG CPR",
  UCD7: '9103954',
  UCD13: '3400891039542',
  ucdQtyMultiplicator: 100,
  cipLib: "ZYMAFLUOR 1MG CPR BT 100",
  atcCode: "A01AA01"
}, {
  CIP7: '3040626',
  CIP13: '3400930406267',
  ucdLib: "CALCIUM FLUOR. CRINEX CPR",
  UCD7: '9014819',
  UCD13: '3400890148191',
  ucdQtyMultiplicator: 200,
  cipLib: "CALCIUM FLUOR. CRINEX CPR BT 200",
  atcCode: "A01AA01"
}, {
  CIP7: '3191199',
  CIP13: '3400931911999',
  ucdLib: "ZYMAFLUOR 0,25MG CPR",
  UCD7: '9102162',
  UCD13: '3400891021622',
  ucdQtyMultiplicator: 200,
  cipLib: "ZYMAFLUOR 0,25MG CPR BT 200",
  atcCode: "A01AA01"
}, {
  CIP7: '3408948',
  CIP13: '3400934089480',
  ucdLib: "ZYMAFLUOR 0,50MG CPR",
  UCD7: '9189921',
  UCD13: '3400891899214',
  ucdQtyMultiplicator: 100,
  cipLib: "ZYMAFLUOR 0,50MG CPR BT 100",
  atcCode: "A01AA01"
}, {
  CIP7: '3408954',
  CIP13: '3400934089541',
  ucdLib: "ZYMAFLUOR 0,75MG CPR",
  UCD7: '9189938',
  UCD13: '3400891899382',
  ucdQtyMultiplicator: 100,
  cipLib: "ZYMAFLUOR 0,75MG CPR BT 100",
  atcCode: "A01AA01"
}, {
  CIP7: '3361678',
  CIP13: '3400933616786',
  ucdLib: "FLUOREX 1MG/1ML BUV FL30ML",
  UCD7: '9163092',
  UCD13: '3400891630923',
  ucdQtyMultiplicator: 1,
  cipLib: "FLUOREX 1MG/1ML BUV FL30ML BT 1",
  atcCode: "A01AA01"
}, {
  CIP7: '3584993',
  CIP13: '3400935849939',
  ucdLib: "DURAPHAT 500MG/100G DENT 51G",
  UCD7: '9366694',
  UCD13: '3400893666944',
  ucdQtyMultiplicator: 1,
  cipLib: "DURAPHAT 500MG/100G DENT 51G BT 1",
  atcCode: "A01AA01"
}, {
  CIP7: '3541759',
  CIP13: '3400935417596',
  ucdLib: "DURAPHAT 50MG/ML SUSP TB10ML",
  UCD7: '9284625',
  UCD13: '3400892846255',
  ucdQtyMultiplicator: 1,
  cipLib: "DURAPHAT 50MG/ML SUSP TB10ML BT 1",
  atcCode: "A01AA01"
}, {
  CIP7: '3643922',
  CIP13: '3400936439221',
  ucdLib: "SANOGYL BLANC FLUOR PATE 105G",
  UCD7: '9374216',
  UCD13: '3400893742167',
  ucdQtyMultiplicator: 1,
  cipLib: "SANOGYL BLANC FLUOR PATE 105G BT 1",
  atcCode: "A01AA01"
}, {
  CIP7: '3646139',
  CIP13: '3400936461390',
  ucdLib: "SANOGYL BLANC FLUOR PATE 140G",
  UCD7: '9374251',
  UCD13: '3400893742518',
  ucdQtyMultiplicator: 1,
  cipLib: "SANOGYL BLANC FLUOR PATE 140G BT 1",
  atcCode: "A01AA01"
}, {
  CIP7: '3016273',
  CIP13: '3400930162736',
  ucdLib: "ALUNBRIG 180MG CPR",
  UCD7: '9444081',
  UCD13: '3400894440819',
  ucdQtyMultiplicator: 28,
  cipLib: "ALUNBRIG 180 mg Cpr pell Plq/28",
  atcCode: "L01XE43"
}, {
  CIP7: '3016269',
  CIP13: '3400930162699',
  ucdLib: "ALUNBRIG 30MG CPR",
  UCD7: '9444098',
  UCD13: '3400894440987',
  ucdQtyMultiplicator: 56,
  cipLib: "ALUNBRIG 30 mg Cpr pell Plq/56",
  atcCode: "L01XE43"
}, {
  CIP7: '3016271',
  CIP13: '3400930162712',
  ucdLib: "ALUNBRIG 90MG CPR",
  UCD7: '9444106',
  UCD13: '3400894441069',
  ucdQtyMultiplicator: 28,
  cipLib: "ALUNBRIG 90 mg Cpr pell Plq/28",
  atcCode: "L01XE43"
}, {
  CIP7: '3016270',
  CIP13: '3400930162705',
  ucdLib: "ALUNBRIG 90MG CPR",
  UCD7: '9444106',
  UCD13: '3400894441069',
  ucdQtyMultiplicator: 7,
  cipLib: "ALUNBRIG 90 mg Cpr pell Plq/7",
  atcCode: "L01XE43"
}, {
  CIP7: '5500346',
  CIP13: '3400955003465',
  ucdLib: "BOSENTAN ACC 125MG CPR",
  UCD7: '9421909',
  UCD13: '3400894219095',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN ACCORD 125 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5500341',
  CIP13: '3400955003410',
  ucdLib: "BOSENTAN ACC 62,5MG CPR",
  UCD7: '9421915',
  UCD13: '3400894219156',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN ACCORD 62,5 mg Cpr pell Plq alu/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5500343',
  CIP13: '3400955003434',
  ucdLib: "BOSENTAN ACC 62,5MG CPR",
  UCD7: '9421915',
  UCD13: '3400894219156',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN ACCORD 62,5 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '3007320',
  CIP13: '3400930073209',
  ucdLib: "BOSENTAN ARW 125MG CPR",
  UCD7: '9422211',
  UCD13: '3400894222118',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN ARROW 125 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '3007124',
  CIP13: '3400930071243',
  ucdLib: "BOSENTAN ARW 62,5MG CPR",
  UCD7: '9422228',
  UCD13: '3400894222286',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN ARROW 62,5 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5502442',
  CIP13: '3400955024422',
  ucdLib: "BOSENTAN BGA 125MG CPR",
  UCD7: '9426717',
  UCD13: '3400894267171',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN BIOGARAN 125 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5502439',
  CIP13: '3400955024392',
  ucdLib: "BOSENTAN BGA 62,5MG CPR",
  UCD7: '9426723',
  UCD13: '3400894267232',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN BIOGARAN 62,5 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5500944',
  CIP13: '3400955009443',
  ucdLib: "BOSENTAN EG 125MG CPR",
  UCD7: '9425190',
  UCD13: '3400894251903',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN EG 125 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5500942',
  CIP13: '3400955009429',
  ucdLib: "BOSENTAN EG 62,5MG CPR",
  UCD7: '9425209',
  UCD13: '3400894252092',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN EG 62,5 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '3006907',
  CIP13: '3400930069073',
  ucdLib: "BOSENTAN MYL 125MG CPR",
  UCD7: '9421536',
  UCD13: '3400894215363',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN MYLAN 125 mg Cpr pell Plq/56x1",
  atcCode: "C02KX01"
}, {
  CIP7: '3006908',
  CIP13: '3400930069080',
  ucdLib: "BOSENTAN MYL 62,5MG CPR",
  UCD7: '9421542',
  UCD13: '3400894215424',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN MYLAN 62,5 mg Cpr pell Plq/56x1",
  atcCode: "C02KX01"
}, {
  CIP7: '3013554',
  CIP13: '3400930135549',
  ucdLib: "BOSENTAN OHR 125MG CPR",
  UCD7: '9437276',
  UCD13: '3400894372769',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN OHRE PHARMA 125 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '3013551',
  CIP13: '3400930135518',
  ucdLib: "BOSENTAN OHR 62,5MG CPR",
  UCD7: '9437282',
  UCD13: '3400894372820',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN OHRE PHARMA 62,5 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5502311',
  CIP13: '3400955023111',
  ucdLib: "BOSENTAN SDZ 125MG CPR",
  UCD7: '9426539',
  UCD13: '3400894265399',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN SANDOZ 125 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5502307',
  CIP13: '3400955023074',
  ucdLib: "BOSENTAN SDZ 62,5MG CPR",
  UCD7: '9426545',
  UCD13: '3400894265450',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN SANDOZ 62,5 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5856102',
  CIP13: '3400958561023',
  ucdLib: "BOSENTAN ZEN 125MG CPR",
  UCD7: '9433634',
  UCD13: '3400894336341',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN ZENTIVA 125 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '5856042',
  CIP13: '3400958560422',
  ucdLib: "BOSENTAN ZEN 62,5MG CPR",
  UCD7: '9433640',
  UCD13: '3400894336402',
  ucdQtyMultiplicator: 56,
  cipLib: "BOSENTAN ZENTIVA 62,5 mg Cpr pell Plq/56",
  atcCode: "C02KX01"
}, {
  CIP7: '3016590',
  CIP13: '3400930165904',
  ucdLib: "CABLIVI 10MG INJ FL+SRG +NEC",
  UCD7: '9438057',
  UCD13: '3400894380573',
  ucdQtyMultiplicator: 7,
  cipLib: "CABLIVI 10 mg Pdre/solv p sol inj 7Fl+7Ser+7Aig+14Tamp",
  atcCode: "B01AX07"
}, {
  CIP7: '3015511',
  CIP13: '3400930155110',
  ucdLib: "CABLIVI 10MG INJ FL+SRG +NEC",
  UCD7: '9438057',
  UCD13: '3400894380573',
  ucdQtyMultiplicator: 1,
  cipLib: "CABLIVI 10 mg Pdre/solv p sol inj Fl+Ser+Aig+2Tamp",
  atcCode: "B01AX07"
}, {
  CIP7: '3011664',
  CIP13: '3400930116647',
  ucdLib: "DUPIXENT 300MG INJ SRG2ML +D.",
  UCD7: '9428722',
  UCD13: '3400894287223',
  ucdQtyMultiplicator: 2,
  cipLib: "DUPIXENT 300 mg S inj en seringue preremplie 2Ser+dispo",
  atcCode: "D11AH05"
}, {
  CIP7: '3009863',
  CIP13: '3400930098639',
  ucdLib: "ELMIRON 100MG GELU",
  UCD7: '9293529',
  UCD13: '3400892935294',
  ucdQtyMultiplicator: 90,
  cipLib: "ELMIRON 100 mg Gel Fl/90",
  atcCode: "G04BX15"
}, {
  CIP7: '3006941',
  CIP13: '3400930069417',
  ucdLib: "EMTRICIT/TENOF.BGA200/245 CP",
  UCD7: '9425267',
  UCD13: '3400894252672',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRICITABINE/TENOFOVIR DISOPROXIL BIOGARAN 200 mg/245 mg Cpr pell Fl/30",
  atcCode: "J05AR03"
}, {
  CIP7: '3006942',
  CIP13: '3400930069424',
  ucdLib: "EMTRICIT/TENOF.EG 200/245 CP",
  UCD7: '9425741',
  UCD13: '3400894257417',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRICITABINE/TENOFOVIR DISOPROXIL EG 200 mg/245 mg Cpr pell Fl/30",
  atcCode: "J05AR03"
}, {
  CIP7: '3010089',
  CIP13: '3400930100899',
  ucdLib: "EMTRICIT/TENOF.KDD200/245 CP",
  UCD7: '9429957',
  UCD13: '3400894299578',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRICITABINE/TENOFOVIR DISOPROXIL KRKA D.D. 200 mg/245 mg Cpr pell en flacon Fl/30",
  atcCode: "J05AR03"
}, {
  CIP7: '3007903',
  CIP13: '3400930079034',
  ucdLib: "EMTRICIT/TENOF.MYL200/245 CP",
  UCD7: '9424724',
  UCD13: '3400894247241',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRICITABINE/TENOFOVIR DISOPROXIL MYLAN 200 mg/245 mg  Cpr pell Plq/30",
  atcCode: "J05AR03"
}, {
  CIP7: '3011199',
  CIP13: '3400930111994',
  ucdLib: "EMTRICIT/TENOF.SDZ200/245 CP",
  UCD7: '9433657',
  UCD13: '3400894336570',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRICITABINE/TENOFOVIR DISOPROXIL SANDOZ 200 mg/245 mg Cpr pell Fl/30",
  atcCode: "J05AR03"
}, {
  CIP7: '3011198',
  CIP13: '3400930111987',
  ucdLib: "EMTRICIT/TENOF.SDZ200/245 CP",
  UCD7: '9433657',
  UCD13: '3400894336570',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRICITABINE/TENOFOVIR DISOPROXIL SANDOZ 200 mg/245 mg Cpr pell Plq/30",
  atcCode: "J05AR03"
}, {
  CIP7: '3009386',
  CIP13: '3400930093863',
  ucdLib: "EMTRICIT/TENOF.TVC200/245 CP",
  UCD7: '9426692',
  UCD13: '3400894266921',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRICITABINE/TENOFOVIR DISOPROXIL TEVA 200 mg/245 mg Cpr pell  Plq/30",
  atcCode: "J05AR03"
}, {
  CIP7: '3007688',
  CIP13: '3400930076880',
  ucdLib: "EMTRICIT/TENOF.ZEN200/245 CP",
  UCD7: '9429532',
  UCD13: '3400894295327',
  ucdQtyMultiplicator: 30,
  cipLib: "EMTRICITABINE/TENOFOVIR DISOPROXIL ZENTIVA 200 mg/245 mg Cpr pell Fl/30",
  atcCode: "J05AR03"
}, {
  CIP7: '3006731',
  CIP13: '3400930067314',
  ucdLib: "EPCLUSA 400MG/100MG CPR",
  UCD7: '9419806',
  UCD13: '3400894198062',
  ucdQtyMultiplicator: 28,
  cipLib: "EPCLUSA 400 mg/100 mg Cpr pell Fl/28",
  atcCode: "J05AP55"
}, {
  CIP7: '3010400',
  CIP13: '3400930104002',
  ucdLib: "ISENTRESS 600MG CPR",
  UCD7: '9428107',
  UCD13: '3400894281078',
  ucdQtyMultiplicator: 60,
  cipLib: "ISENTRESS 600 mg Cpr pell Fl/60",
  atcCode: "J05AX08"
}, {
  CIP7: '5890156',
  CIP13: '3400958901560',
  ucdLib: "LORVIQUA 100MG CPR",
  UCD7: '9445991',
  UCD13: '3400894459910',
  ucdQtyMultiplicator: 30,
  cipLib: "LORVIQUA 100 mg Cpr pell Plq/30",
  atcCode: "L01XE44"
}, {
  CIP7: '5890155',
  CIP13: '3400958901553',
  ucdLib: "LORVIQUA 25MG CPR",
  UCD7: '9446016',
  UCD13: '3400894460169',
  ucdQtyMultiplicator: 120,
  cipLib: "LORVIQUA 25 mg Cpr pell Plq/120",
  atcCode: "L01XE44"
}, {
  CIP7: '3010876',
  CIP13: '3400930108765',
  ucdLib: "MAVIRET 100MG/40MG CPR",
  UCD7: '9428739',
  UCD13: '3400894287391',
  ucdQtyMultiplicator: 84,
  cipLib: "MAVIRET 100 mg/40 mg Cpr pell 28Plq/3",
  atcCode: "J05AP57"
}, {
  CIP7: '3007906',
  CIP13: '3400930079065',
  ucdLib: "OCALIVA 10MG CPR",
  UCD7: '9422889',
  UCD13: '3400894228899',
  ucdQtyMultiplicator: 30,
  cipLib: "OCALIVA 10 mg Cpr pell Fl/30",
  atcCode: "A05AA04"
}, {
  CIP7: '3007905',
  CIP13: '3400930079058',
  ucdLib: "OCALIVA 5MG CPR",
  UCD7: '9421944',
  UCD13: '3400894219446',
  ucdQtyMultiplicator: 30,
  cipLib: "OCALIVA 5 mg Cpr pell Fl/30",
  atcCode: "A05AA04"
}, {
  CIP7: '3006155',
  CIP13: '3400930061558',
  ucdLib: "ODEFSEY 200/25/25MG CPR",
  UCD7: '9418072',
  UCD13: '3400894180722',
  ucdQtyMultiplicator: 30,
  cipLib: "ODEFSEY 200 mg/25 mg/25 mg Cpr pell Fl/30",
  atcCode: "J05AR19"
}, {
  CIP7: '3003391',
  CIP13: '3400930033913',
  ucdLib: "ORFADIN 4MG/ML BUV FL90ML",
  UCD7: '9419522',
  UCD13: '3400894195221',
  ucdQtyMultiplicator: 1,
  cipLib: "ORFADIN 4 mg/ml Susp buv Fl/90ml",
  atcCode: "A16AX04"
}, {
  CIP7: '5901340',
  CIP13: '3400959013408',
  ucdLib: "STRATTERA 10MG GELU",
  UCD7: '9262434',
  UCD13: '3400892624341',
  ucdQtyMultiplicator: 28,
  cipLib: "STRATTERA 10 mg Gel Plq/28 ATUn",
  atcCode: "N06BA09"
}, {
  CIP7: '5901133',
  CIP13: '3400959011336',
  ucdLib: "STRATTERA 10MG GELU",
  UCD7: '9262434',
  UCD13: '3400892624341',
  ucdQtyMultiplicator: 30,
  cipLib: "STRATTERA 10 mg Gel Plq/30 ATUn",
  atcCode: "N06BA09"
}, {
  CIP7: '5901357',
  CIP13: '3400959013576',
  ucdLib: "STRATTERA 18MG GELU",
  UCD7: '9262440',
  UCD13: '3400892624402',
  ucdQtyMultiplicator: 28,
  cipLib: "STRATTERA 18 mg Gel Plq/28 ATUn",
  atcCode: "N06BA09"
}, {
  CIP7: '5901156',
  CIP13: '3400959011565',
  ucdLib: "STRATTERA 18MG GELU",
  UCD7: '9262440',
  UCD13: '3400892624402',
  ucdQtyMultiplicator: 30,
  cipLib: "STRATTERA 18 mg Gel Plq/30 ATUn",
  atcCode: "N06BA09"
}, {
  CIP7: '5901162',
  CIP13: '3400959011626',
  ucdLib: "STRATTERA 25MG GELU",
  UCD7: '9262457',
  UCD13: '3400892624570',
  ucdQtyMultiplicator: 30,
  cipLib: "STRATTERA 25 mg Gel B/30 ATUn",
  atcCode: "N06BA09"
}, {
  CIP7: '5901179',
  CIP13: '3400959011794',
  ucdLib: "STRATTERA 40MG GELU",
  UCD7: '9262463',
  UCD13: '3400892624631',
  ucdQtyMultiplicator: 30,
  cipLib: "STRATTERA 40 mg Gel B/30 ATUn",
  atcCode: "N06BA09"
}, {
  CIP7: '5901185',
  CIP13: '3400959011855',
  ucdLib: "STRATTERA 60MG GELU",
  UCD7: '9262486',
  UCD13: '3400892624860',
  ucdQtyMultiplicator: 30,
  cipLib: "STRATTERA 60 mg Gel B/30 ATUn",
  atcCode: "N06BA09"
}, {
  CIP7: '3008098',
  CIP13: '3400930080986',
  ucdLib: "TALMANCO 20MG CPR",
  UCD7: '9425480',
  UCD13: '3400894254805',
  ucdQtyMultiplicator: 56,
  cipLib: "TALMANCO 20 mg Cpr pell Plq/56",
  atcCode: "G04BE08"
}, {
  CIP7: '5784549',
  CIP13: '3400957845490',
  ucdLib: "TEICOPLANINE MYL 100MG INJ FL",
  UCD7: '9360728',
  UCD13: '3400893607282',
  ucdQtyMultiplicator: 5,
  cipLib: "TEICOPLANINE MYLAN 100 mg Pdr p sol inj perf ou sol buv 5Fl",
  atcCode: "J01XA02"
}, {
  CIP7: '5784578',
  CIP13: '3400957845780',
  ucdLib: "TEICOPLANINE MYL 200MG INJ FL",
  UCD7: '9360734',
  UCD13: '3400893607343',
  ucdQtyMultiplicator: 5,
  cipLib: "TEICOPLANINE MYLAN 200 mg Pdr p sol inj perf ou sol buv 5Fl",
  atcCode: "J01XA02"
}, {
  CIP7: '5784609',
  CIP13: '3400957846091',
  ucdLib: "TEICOPLANINE MYL 400MG INJ FL",
  UCD7: '9360740',
  UCD13: '3400893607404',
  ucdQtyMultiplicator: 5,
  cipLib: "TEICOPLANINE MYLAN 400 mg Pdr p sol inj perf ou sol buv 5Fl",
  atcCode: "J01XA02"
}, {
  CIP7: '5784610',
  CIP13: '3400959109422',
  ucdLib: "VENTOLIN 2MG/5ML SIR",
  UCD7: '9422984',
  UCD13: '3400894229841',
  ucdQtyMultiplicator: 1,
  cipLib: "VENTOLIN 2 mg/5 ml Sirop 1Fl/150ml ATUn",
  atcCode: "R03CC02"
}, {
  CIP7: '3011028',
  CIP13: '3400930110287',
  ucdLib: "VOSEVI 400MG/100MG/100MG CP",
  UCD7: '9430653',
  UCD13: '3400894306535',
  ucdQtyMultiplicator: 28,
  cipLib: "VOSEVI 400 mg/100 mg/100 mg Cpr pell Fl/28",
  atcCode: "J05AP56"
}];